let LuxonError$3 = class LuxonError2 extends Error {
};
let InvalidDateTimeError$1 = class InvalidDateTimeError2 extends LuxonError$3 {
  constructor(reason) {
    super(`Invalid DateTime: ${reason.toMessage()}`);
  }
};
let InvalidIntervalError$1 = class InvalidIntervalError2 extends LuxonError$3 {
  constructor(reason) {
    super(`Invalid Interval: ${reason.toMessage()}`);
  }
};
let InvalidDurationError$1 = class InvalidDurationError2 extends LuxonError$3 {
  constructor(reason) {
    super(`Invalid Duration: ${reason.toMessage()}`);
  }
};
let ConflictingSpecificationError$1 = class ConflictingSpecificationError2 extends LuxonError$3 {
};
let InvalidUnitError$1 = class InvalidUnitError2 extends LuxonError$3 {
  constructor(unit) {
    super(`Invalid unit ${unit}`);
  }
};
let InvalidArgumentError$1 = class InvalidArgumentError2 extends LuxonError$3 {
};
let ZoneIsAbstractError$3 = class ZoneIsAbstractError2 extends LuxonError$3 {
  constructor() {
    super("Zone is an abstract class");
  }
};
const n$1 = "numeric", s$1 = "short", l$1 = "long";
const DATE_SHORT$1 = {
  year: n$1,
  month: n$1,
  day: n$1
};
const DATE_MED$1 = {
  year: n$1,
  month: s$1,
  day: n$1
};
const DATE_MED_WITH_WEEKDAY$1 = {
  year: n$1,
  month: s$1,
  day: n$1,
  weekday: s$1
};
const DATE_FULL$1 = {
  year: n$1,
  month: l$1,
  day: n$1
};
const DATE_HUGE$1 = {
  year: n$1,
  month: l$1,
  day: n$1,
  weekday: l$1
};
const TIME_SIMPLE$1 = {
  hour: n$1,
  minute: n$1
};
const TIME_WITH_SECONDS$1 = {
  hour: n$1,
  minute: n$1,
  second: n$1
};
const TIME_WITH_SHORT_OFFSET$1 = {
  hour: n$1,
  minute: n$1,
  second: n$1,
  timeZoneName: s$1
};
const TIME_WITH_LONG_OFFSET$1 = {
  hour: n$1,
  minute: n$1,
  second: n$1,
  timeZoneName: l$1
};
const TIME_24_SIMPLE$1 = {
  hour: n$1,
  minute: n$1,
  hourCycle: "h23"
};
const TIME_24_WITH_SECONDS$1 = {
  hour: n$1,
  minute: n$1,
  second: n$1,
  hourCycle: "h23"
};
const TIME_24_WITH_SHORT_OFFSET$1 = {
  hour: n$1,
  minute: n$1,
  second: n$1,
  hourCycle: "h23",
  timeZoneName: s$1
};
const TIME_24_WITH_LONG_OFFSET$1 = {
  hour: n$1,
  minute: n$1,
  second: n$1,
  hourCycle: "h23",
  timeZoneName: l$1
};
const DATETIME_SHORT$1 = {
  year: n$1,
  month: n$1,
  day: n$1,
  hour: n$1,
  minute: n$1
};
const DATETIME_SHORT_WITH_SECONDS$1 = {
  year: n$1,
  month: n$1,
  day: n$1,
  hour: n$1,
  minute: n$1,
  second: n$1
};
const DATETIME_MED$1 = {
  year: n$1,
  month: s$1,
  day: n$1,
  hour: n$1,
  minute: n$1
};
const DATETIME_MED_WITH_SECONDS$1 = {
  year: n$1,
  month: s$1,
  day: n$1,
  hour: n$1,
  minute: n$1,
  second: n$1
};
const DATETIME_MED_WITH_WEEKDAY$1 = {
  year: n$1,
  month: s$1,
  day: n$1,
  weekday: s$1,
  hour: n$1,
  minute: n$1
};
const DATETIME_FULL$1 = {
  year: n$1,
  month: l$1,
  day: n$1,
  hour: n$1,
  minute: n$1,
  timeZoneName: s$1
};
const DATETIME_FULL_WITH_SECONDS$1 = {
  year: n$1,
  month: l$1,
  day: n$1,
  hour: n$1,
  minute: n$1,
  second: n$1,
  timeZoneName: s$1
};
const DATETIME_HUGE$1 = {
  year: n$1,
  month: l$1,
  day: n$1,
  weekday: l$1,
  hour: n$1,
  minute: n$1,
  timeZoneName: l$1
};
const DATETIME_HUGE_WITH_SECONDS$1 = {
  year: n$1,
  month: l$1,
  day: n$1,
  weekday: l$1,
  hour: n$1,
  minute: n$1,
  second: n$1,
  timeZoneName: l$1
};
let Zone$3 = class Zone2 {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new ZoneIsAbstractError$3();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new ZoneIsAbstractError$3();
  }
  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new ZoneIsAbstractError$3();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(ts, opts) {
    throw new ZoneIsAbstractError$3();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    throw new ZoneIsAbstractError$3();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(ts) {
    throw new ZoneIsAbstractError$3();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    throw new ZoneIsAbstractError$3();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new ZoneIsAbstractError$3();
  }
};
let singleton$1$1 = null;
let SystemZone$1 = class SystemZone2 extends Zone$3 {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    if (singleton$1$1 === null) {
      singleton$1$1 = new SystemZone2();
    }
    return singleton$1$1;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName(ts, { format, locale }) {
    return parseZoneInfo$3(ts, format, locale);
  }
  /** @override **/
  formatOffset(ts, format) {
    return formatOffset$3(this.offset(ts), format);
  }
  /** @override **/
  offset(ts) {
    return -new Date(ts).getTimezoneOffset();
  }
  /** @override **/
  equals(otherZone) {
    return otherZone.type === "system";
  }
  /** @override **/
  get isValid() {
    return true;
  }
};
const dtfCache$3 = /* @__PURE__ */ new Map();
function makeDTF$3(zoneName) {
  let dtf = dtfCache$3.get(zoneName);
  if (dtf === void 0) {
    dtf = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: zoneName,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      era: "short"
    });
    dtfCache$3.set(zoneName, dtf);
  }
  return dtf;
}
const typeToPos$3 = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function hackyOffset$3(dtf, date) {
  const formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = parsed;
  return [fYear, fMonth, fDay, fadOrBc, fHour, fMinute, fSecond];
}
function partsOffset$3(dtf, date) {
  const formatted = dtf.formatToParts(date);
  const filled = [];
  for (let i2 = 0; i2 < formatted.length; i2++) {
    const { type, value } = formatted[i2];
    const pos = typeToPos$3[type];
    if (type === "era") {
      filled[pos] = value;
    } else if (!isUndefined$3(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }
  return filled;
}
const ianaZoneCache$3 = /* @__PURE__ */ new Map();
let IANAZone$3 = class IANAZone2 extends Zone$3 {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(name2) {
    let zone = ianaZoneCache$3.get(name2);
    if (zone === void 0) {
      ianaZoneCache$3.set(name2, zone = new IANAZone2(name2));
    }
    return zone;
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    ianaZoneCache$3.clear();
    dtfCache$3.clear();
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(s2) {
    return this.isValidZone(s2);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(zone) {
    if (!zone) {
      return false;
    }
    try {
      new Intl.DateTimeFormat("en-US", { timeZone: zone }).format();
      return true;
    } catch (e2) {
      return false;
    }
  }
  constructor(name2) {
    super();
    this.zoneName = name2;
    this.valid = IANAZone2.isValidZone(name2);
  }
  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }
  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return false;
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(ts, { format, locale }) {
    return parseZoneInfo$3(ts, format, locale, this.name);
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    return formatOffset$3(this.offset(ts), format);
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(ts) {
    if (!this.valid) return NaN;
    const date = new Date(ts);
    if (isNaN(date)) return NaN;
    const dtf = makeDTF$3(this.name);
    let [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts ? partsOffset$3(dtf, date) : hackyOffset$3(dtf, date);
    if (adOrBc === "BC") {
      year = -Math.abs(year) + 1;
    }
    const adjustedHour = hour === 24 ? 0 : hour;
    const asUTC = objToLocalTS$3({
      year,
      month,
      day,
      hour: adjustedHour,
      minute,
      second,
      millisecond: 0
    });
    let asTS = +date;
    const over = asTS % 1e3;
    asTS -= over >= 0 ? over : 1e3 + over;
    return (asUTC - asTS) / (60 * 1e3);
  }
  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    return otherZone.type === "iana" && otherZone.name === this.name;
  }
  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
};
let intlLFCache$1 = {};
function getCachedLF$1(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlLFCache$1[key];
  if (!dtf) {
    dtf = new Intl.ListFormat(locString, opts);
    intlLFCache$1[key] = dtf;
  }
  return dtf;
}
const intlDTCache$1 = /* @__PURE__ */ new Map();
function getCachedDTF$1(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlDTCache$1.get(key);
  if (dtf === void 0) {
    dtf = new Intl.DateTimeFormat(locString, opts);
    intlDTCache$1.set(key, dtf);
  }
  return dtf;
}
const intlNumCache$1 = /* @__PURE__ */ new Map();
function getCachedINF$1(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let inf = intlNumCache$1.get(key);
  if (inf === void 0) {
    inf = new Intl.NumberFormat(locString, opts);
    intlNumCache$1.set(key, inf);
  }
  return inf;
}
const intlRelCache$1 = /* @__PURE__ */ new Map();
function getCachedRTF$1(locString, opts = {}) {
  const { base, ...cacheKeyOpts } = opts;
  const key = JSON.stringify([locString, cacheKeyOpts]);
  let inf = intlRelCache$1.get(key);
  if (inf === void 0) {
    inf = new Intl.RelativeTimeFormat(locString, opts);
    intlRelCache$1.set(key, inf);
  }
  return inf;
}
let sysLocaleCache$1 = null;
function systemLocale$1() {
  if (sysLocaleCache$1) {
    return sysLocaleCache$1;
  } else {
    sysLocaleCache$1 = new Intl.DateTimeFormat().resolvedOptions().locale;
    return sysLocaleCache$1;
  }
}
const intlResolvedOptionsCache$1 = /* @__PURE__ */ new Map();
function getCachedIntResolvedOptions$1(locString) {
  let opts = intlResolvedOptionsCache$1.get(locString);
  if (opts === void 0) {
    opts = new Intl.DateTimeFormat(locString).resolvedOptions();
    intlResolvedOptionsCache$1.set(locString, opts);
  }
  return opts;
}
const weekInfoCache$1 = /* @__PURE__ */ new Map();
function getCachedWeekInfo$1(locString) {
  let data = weekInfoCache$1.get(locString);
  if (!data) {
    const locale = new Intl.Locale(locString);
    data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
    if (!("minimalDays" in data)) {
      data = { ...fallbackWeekSettings$1, ...data };
    }
    weekInfoCache$1.set(locString, data);
  }
  return data;
}
function parseLocaleString$1(localeStr) {
  const xIndex = localeStr.indexOf("-x-");
  if (xIndex !== -1) {
    localeStr = localeStr.substring(0, xIndex);
  }
  const uIndex = localeStr.indexOf("-u-");
  if (uIndex === -1) {
    return [localeStr];
  } else {
    let options;
    let selectedStr;
    try {
      options = getCachedDTF$1(localeStr).resolvedOptions();
      selectedStr = localeStr;
    } catch (e2) {
      const smaller = localeStr.substring(0, uIndex);
      options = getCachedDTF$1(smaller).resolvedOptions();
      selectedStr = smaller;
    }
    const { numberingSystem, calendar } = options;
    return [selectedStr, numberingSystem, calendar];
  }
}
function intlConfigString$1(localeStr, numberingSystem, outputCalendar) {
  if (outputCalendar || numberingSystem) {
    if (!localeStr.includes("-u-")) {
      localeStr += "-u";
    }
    if (outputCalendar) {
      localeStr += `-ca-${outputCalendar}`;
    }
    if (numberingSystem) {
      localeStr += `-nu-${numberingSystem}`;
    }
    return localeStr;
  } else {
    return localeStr;
  }
}
function mapMonths$1(f2) {
  const ms = [];
  for (let i2 = 1; i2 <= 12; i2++) {
    const dt = DateTime$1.utc(2009, i2, 1);
    ms.push(f2(dt));
  }
  return ms;
}
function mapWeekdays$1(f2) {
  const ms = [];
  for (let i2 = 1; i2 <= 7; i2++) {
    const dt = DateTime$1.utc(2016, 11, 13 + i2);
    ms.push(f2(dt));
  }
  return ms;
}
function listStuff$1(loc, length, englishFn, intlFn) {
  const mode = loc.listingMode();
  if (mode === "error") {
    return null;
  } else if (mode === "en") {
    return englishFn(length);
  } else {
    return intlFn(length);
  }
}
function supportsFastNumbers$1(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
    return false;
  } else {
    return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || getCachedIntResolvedOptions$1(loc.locale).numberingSystem === "latn";
  }
}
let PolyNumberFormatter$1 = class PolyNumberFormatter2 {
  constructor(intl, forceSimple, opts) {
    this.padTo = opts.padTo || 0;
    this.floor = opts.floor || false;
    const { padTo, floor, ...otherOpts } = opts;
    if (!forceSimple || Object.keys(otherOpts).length > 0) {
      const intlOpts = { useGrouping: false, ...opts };
      if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
      this.inf = getCachedINF$1(intl, intlOpts);
    }
  }
  format(i2) {
    if (this.inf) {
      const fixed = this.floor ? Math.floor(i2) : i2;
      return this.inf.format(fixed);
    } else {
      const fixed = this.floor ? Math.floor(i2) : roundTo$1(i2, 3);
      return padStart$3(fixed, this.padTo);
    }
  }
};
let PolyDateFormatter$1 = class PolyDateFormatter2 {
  constructor(dt, intl, opts) {
    this.opts = opts;
    this.originalZone = void 0;
    let z2 = void 0;
    if (this.opts.timeZone) {
      this.dt = dt;
    } else if (dt.zone.type === "fixed") {
      const gmtOffset = -1 * (dt.offset / 60);
      const offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
      if (dt.offset !== 0 && IANAZone$3.create(offsetZ).valid) {
        z2 = offsetZ;
        this.dt = dt;
      } else {
        z2 = "UTC";
        this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({ minutes: dt.offset });
        this.originalZone = dt.zone;
      }
    } else if (dt.zone.type === "system") {
      this.dt = dt;
    } else if (dt.zone.type === "iana") {
      this.dt = dt;
      z2 = dt.zone.name;
    } else {
      z2 = "UTC";
      this.dt = dt.setZone("UTC").plus({ minutes: dt.offset });
      this.originalZone = dt.zone;
    }
    const intlOpts = { ...this.opts };
    intlOpts.timeZone = intlOpts.timeZone || z2;
    this.dtf = getCachedDTF$1(intl, intlOpts);
  }
  format() {
    if (this.originalZone) {
      return this.formatToParts().map(({ value }) => value).join("");
    }
    return this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const parts = this.dtf.formatToParts(this.dt.toJSDate());
    if (this.originalZone) {
      return parts.map((part) => {
        if (part.type === "timeZoneName") {
          const offsetName = this.originalZone.offsetName(this.dt.ts, {
            locale: this.dt.locale,
            format: this.opts.timeZoneName
          });
          return {
            ...part,
            value: offsetName
          };
        } else {
          return part;
        }
      });
    }
    return parts;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
};
let PolyRelFormatter$1 = class PolyRelFormatter2 {
  constructor(intl, isEnglish, opts) {
    this.opts = { style: "long", ...opts };
    if (!isEnglish && hasRelative$1()) {
      this.rtf = getCachedRTF$1(intl, opts);
    }
  }
  format(count, unit) {
    if (this.rtf) {
      return this.rtf.format(count, unit);
    } else {
      return formatRelativeTime$1(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
  }
  formatToParts(count, unit) {
    if (this.rtf) {
      return this.rtf.formatToParts(count, unit);
    } else {
      return [];
    }
  }
};
const fallbackWeekSettings$1 = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
let Locale$1 = class Locale2 {
  static fromOpts(opts) {
    return Locale2.create(
      opts.locale,
      opts.numberingSystem,
      opts.outputCalendar,
      opts.weekSettings,
      opts.defaultToEN
    );
  }
  static create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN = false) {
    const specifiedLocale = locale || Settings$1.defaultLocale;
    const localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale$1());
    const numberingSystemR = numberingSystem || Settings$1.defaultNumberingSystem;
    const outputCalendarR = outputCalendar || Settings$1.defaultOutputCalendar;
    const weekSettingsR = validateWeekSettings$1(weekSettings) || Settings$1.defaultWeekSettings;
    return new Locale2(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
  }
  static resetCache() {
    sysLocaleCache$1 = null;
    intlDTCache$1.clear();
    intlNumCache$1.clear();
    intlRelCache$1.clear();
    intlResolvedOptionsCache$1.clear();
    weekInfoCache$1.clear();
  }
  static fromObject({ locale, numberingSystem, outputCalendar, weekSettings } = {}) {
    return Locale2.create(locale, numberingSystem, outputCalendar, weekSettings);
  }
  constructor(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
    const [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = parseLocaleString$1(locale);
    this.locale = parsedLocale;
    this.numberingSystem = numbering || parsedNumberingSystem || null;
    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
    this.weekSettings = weekSettings;
    this.intl = intlConfigString$1(this.locale, this.numberingSystem, this.outputCalendar);
    this.weekdaysCache = { format: {}, standalone: {} };
    this.monthsCache = { format: {}, standalone: {} };
    this.meridiemCache = null;
    this.eraCache = {};
    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }
  get fastNumbers() {
    if (this.fastNumbersCached == null) {
      this.fastNumbersCached = supportsFastNumbers$1(this);
    }
    return this.fastNumbersCached;
  }
  listingMode() {
    const isActuallyEn = this.isEnglish();
    const hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return isActuallyEn && hasNoWeirdness ? "en" : "intl";
  }
  clone(alts) {
    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
      return this;
    } else {
      return Locale2.create(
        alts.locale || this.specifiedLocale,
        alts.numberingSystem || this.numberingSystem,
        alts.outputCalendar || this.outputCalendar,
        validateWeekSettings$1(alts.weekSettings) || this.weekSettings,
        alts.defaultToEN || false
      );
    }
  }
  redefaultToEN(alts = {}) {
    return this.clone({ ...alts, defaultToEN: true });
  }
  redefaultToSystem(alts = {}) {
    return this.clone({ ...alts, defaultToEN: false });
  }
  months(length, format = false) {
    return listStuff$1(this, length, months$1, () => {
      const monthSpecialCase = this.intl === "ja" || this.intl.startsWith("ja-");
      format &= !monthSpecialCase;
      const intl = format ? { month: length, day: "numeric" } : { month: length }, formatStr = format ? "format" : "standalone";
      if (!this.monthsCache[formatStr][length]) {
        const mapper = !monthSpecialCase ? (dt) => this.extract(dt, intl, "month") : (dt) => this.dtFormatter(dt, intl).format();
        this.monthsCache[formatStr][length] = mapMonths$1(mapper);
      }
      return this.monthsCache[formatStr][length];
    });
  }
  weekdays(length, format = false) {
    return listStuff$1(this, length, weekdays$1, () => {
      const intl = format ? { weekday: length, year: "numeric", month: "long", day: "numeric" } : { weekday: length }, formatStr = format ? "format" : "standalone";
      if (!this.weekdaysCache[formatStr][length]) {
        this.weekdaysCache[formatStr][length] = mapWeekdays$1(
          (dt) => this.extract(dt, intl, "weekday")
        );
      }
      return this.weekdaysCache[formatStr][length];
    });
  }
  meridiems() {
    return listStuff$1(
      this,
      void 0,
      () => meridiems$1,
      () => {
        if (!this.meridiemCache) {
          const intl = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [DateTime$1.utc(2016, 11, 13, 9), DateTime$1.utc(2016, 11, 13, 19)].map(
            (dt) => this.extract(dt, intl, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(length) {
    return listStuff$1(this, length, eras$1, () => {
      const intl = { era: length };
      if (!this.eraCache[length]) {
        this.eraCache[length] = [DateTime$1.utc(-40, 1, 1), DateTime$1.utc(2017, 1, 1)].map(
          (dt) => this.extract(dt, intl, "era")
        );
      }
      return this.eraCache[length];
    });
  }
  extract(dt, intlOpts, field) {
    const df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find((m) => m.type.toLowerCase() === field);
    return matching ? matching.value : null;
  }
  numberFormatter(opts = {}) {
    return new PolyNumberFormatter$1(this.intl, opts.forceSimple || this.fastNumbers, opts);
  }
  dtFormatter(dt, intlOpts = {}) {
    return new PolyDateFormatter$1(dt, this.intl, intlOpts);
  }
  relFormatter(opts = {}) {
    return new PolyRelFormatter$1(this.intl, this.isEnglish(), opts);
  }
  listFormatter(opts = {}) {
    return getCachedLF$1(this.intl, opts);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || getCachedIntResolvedOptions$1(this.intl).locale.startsWith("en-us");
  }
  getWeekSettings() {
    if (this.weekSettings) {
      return this.weekSettings;
    } else if (!hasLocaleWeekInfo$1()) {
      return fallbackWeekSettings$1;
    } else {
      return getCachedWeekInfo$1(this.locale);
    }
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(other) {
    return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
};
let singleton$4 = null;
let FixedOffsetZone$3 = class FixedOffsetZone2 extends Zone$3 {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    if (singleton$4 === null) {
      singleton$4 = new FixedOffsetZone2(0);
    }
    return singleton$4;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(offset2) {
    return offset2 === 0 ? FixedOffsetZone2.utcInstance : new FixedOffsetZone2(offset2);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(s2) {
    if (s2) {
      const r = s2.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r) {
        return new FixedOffsetZone2(signedOffset$3(r[1], r[2]));
      }
    }
    return null;
  }
  constructor(offset2) {
    super();
    this.fixed = offset2;
  }
  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }
  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${formatOffset$3(this.fixed, "narrow")}`;
  }
  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    if (this.fixed === 0) {
      return "Etc/UTC";
    } else {
      return `Etc/GMT${formatOffset$3(-this.fixed, "narrow")}`;
    }
  }
  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    return formatOffset$3(this.fixed, format);
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return true;
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }
  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
  }
  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return true;
  }
};
let InvalidZone$1 = class InvalidZone2 extends Zone$3 {
  constructor(zoneName) {
    super();
    this.zoneName = zoneName;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return false;
  }
  /** @override **/
  get isValid() {
    return false;
  }
};
function normalizeZone$1(input, defaultZone2) {
  if (isUndefined$3(input) || input === null) {
    return defaultZone2;
  } else if (input instanceof Zone$3) {
    return input;
  } else if (isString$1(input)) {
    const lowered = input.toLowerCase();
    if (lowered === "default") return defaultZone2;
    else if (lowered === "local" || lowered === "system") return SystemZone$1.instance;
    else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone$3.utcInstance;
    else return FixedOffsetZone$3.parseSpecifier(lowered) || IANAZone$3.create(input);
  } else if (isNumber$2(input)) {
    return FixedOffsetZone$3.instance(input);
  } else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") {
    return input;
  } else {
    return new InvalidZone$1(input);
  }
}
const numberingSystems$2 = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
};
const numberingSystemsUTF16$1 = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
};
const hanidecChars$1 = numberingSystems$2.hanidec.replace(/[\[|\]]/g, "").split("");
function parseDigits$1(str) {
  let value = parseInt(str, 10);
  if (isNaN(value)) {
    value = "";
    for (let i2 = 0; i2 < str.length; i2++) {
      const code2 = str.charCodeAt(i2);
      if (str[i2].search(numberingSystems$2.hanidec) !== -1) {
        value += hanidecChars$1.indexOf(str[i2]);
      } else {
        for (const key in numberingSystemsUTF16$1) {
          const [min, max] = numberingSystemsUTF16$1[key];
          if (code2 >= min && code2 <= max) {
            value += code2 - min;
          }
        }
      }
    }
    return parseInt(value, 10);
  } else {
    return value;
  }
}
const digitRegexCache$1 = /* @__PURE__ */ new Map();
function resetDigitRegexCache$1() {
  digitRegexCache$1.clear();
}
function digitRegex$1({ numberingSystem }, append = "") {
  const ns = numberingSystem || "latn";
  let appendCache = digitRegexCache$1.get(ns);
  if (appendCache === void 0) {
    appendCache = /* @__PURE__ */ new Map();
    digitRegexCache$1.set(ns, appendCache);
  }
  let regex = appendCache.get(append);
  if (regex === void 0) {
    regex = new RegExp(`${numberingSystems$2[ns]}${append}`);
    appendCache.set(append, regex);
  }
  return regex;
}
let now$1 = () => Date.now(), defaultZone$1 = "system", defaultLocale$1 = null, defaultNumberingSystem$1 = null, defaultOutputCalendar$1 = null, twoDigitCutoffYear$1 = 60, throwOnInvalid$1, defaultWeekSettings$1 = null;
let Settings$1 = class Settings2 {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return now$1;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(n2) {
    now$1 = n2;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(zone) {
    defaultZone$1 = zone;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return normalizeZone$1(defaultZone$1, SystemZone$1.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return defaultLocale$1;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(locale) {
    defaultLocale$1 = locale;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return defaultNumberingSystem$1;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(numberingSystem) {
    defaultNumberingSystem$1 = numberingSystem;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return defaultOutputCalendar$1;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(outputCalendar) {
    defaultOutputCalendar$1 = outputCalendar;
  }
  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */
  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return defaultWeekSettings$1;
  }
  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(weekSettings) {
    defaultWeekSettings$1 = validateWeekSettings$1(weekSettings);
  }
  /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return twoDigitCutoffYear$1;
  }
  /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(cutoffYear) {
    twoDigitCutoffYear$1 = cutoffYear % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return throwOnInvalid$1;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(t) {
    throwOnInvalid$1 = t;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    Locale$1.resetCache();
    IANAZone$3.resetCache();
    DateTime$1.resetCache();
    resetDigitRegexCache$1();
  }
};
let Invalid$1 = class Invalid2 {
  constructor(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
  }
  toMessage() {
    if (this.explanation) {
      return `${this.reason}: ${this.explanation}`;
    } else {
      return this.reason;
    }
  }
};
const nonLeapLadder$1 = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], leapLadder$1 = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function unitOutOfRange$1(unit, value) {
  return new Invalid$1(
    "unit out of range",
    `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`
  );
}
function dayOfWeek$1(year, month, day) {
  const d2 = new Date(Date.UTC(year, month - 1, day));
  if (year < 100 && year >= 0) {
    d2.setUTCFullYear(d2.getUTCFullYear() - 1900);
  }
  const js = d2.getUTCDay();
  return js === 0 ? 7 : js;
}
function computeOrdinal$1(year, month, day) {
  return day + (isLeapYear$1(year) ? leapLadder$1 : nonLeapLadder$1)[month - 1];
}
function uncomputeOrdinal$1(year, ordinal) {
  const table = isLeapYear$1(year) ? leapLadder$1 : nonLeapLadder$1, month0 = table.findIndex((i2) => i2 < ordinal), day = ordinal - table[month0];
  return { month: month0 + 1, day };
}
function isoWeekdayToLocal$1(isoWeekday, startOfWeek) {
  return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
function gregorianToWeek$1(gregObj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { year, month, day } = gregObj, ordinal = computeOrdinal$1(year, month, day), weekday = isoWeekdayToLocal$1(dayOfWeek$1(year, month, day), startOfWeek);
  let weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = weeksInWeekYear$1(weekYear, minDaysInFirstWeek, startOfWeek);
  } else if (weekNumber > weeksInWeekYear$1(year, minDaysInFirstWeek, startOfWeek)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }
  return { weekYear, weekNumber, weekday, ...timeObject$1(gregObj) };
}
function weekToGregorian$1(weekData, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { weekYear, weekNumber, weekday } = weekData, weekdayOfJan4 = isoWeekdayToLocal$1(dayOfWeek$1(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = daysInYear$1(weekYear);
  let ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
  if (ordinal < 1) {
    year = weekYear - 1;
    ordinal += daysInYear$1(year);
  } else if (ordinal > yearInDays) {
    year = weekYear + 1;
    ordinal -= daysInYear$1(weekYear);
  } else {
    year = weekYear;
  }
  const { month, day } = uncomputeOrdinal$1(year, ordinal);
  return { year, month, day, ...timeObject$1(weekData) };
}
function gregorianToOrdinal$1(gregData) {
  const { year, month, day } = gregData;
  const ordinal = computeOrdinal$1(year, month, day);
  return { year, ordinal, ...timeObject$1(gregData) };
}
function ordinalToGregorian$1(ordinalData) {
  const { year, ordinal } = ordinalData;
  const { month, day } = uncomputeOrdinal$1(year, ordinal);
  return { year, month, day, ...timeObject$1(ordinalData) };
}
function usesLocalWeekValues$1(obj, loc) {
  const hasLocaleWeekData = !isUndefined$3(obj.localWeekday) || !isUndefined$3(obj.localWeekNumber) || !isUndefined$3(obj.localWeekYear);
  if (hasLocaleWeekData) {
    const hasIsoWeekData = !isUndefined$3(obj.weekday) || !isUndefined$3(obj.weekNumber) || !isUndefined$3(obj.weekYear);
    if (hasIsoWeekData) {
      throw new ConflictingSpecificationError$1(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    }
    if (!isUndefined$3(obj.localWeekday)) obj.weekday = obj.localWeekday;
    if (!isUndefined$3(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
    if (!isUndefined$3(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
    delete obj.localWeekday;
    delete obj.localWeekNumber;
    delete obj.localWeekYear;
    return {
      minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
      startOfWeek: loc.getStartOfWeek()
    };
  } else {
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
  }
}
function hasInvalidWeekData$1(obj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const validYear = isInteger$1(obj.weekYear), validWeek = integerBetween$1(
    obj.weekNumber,
    1,
    weeksInWeekYear$1(obj.weekYear, minDaysInFirstWeek, startOfWeek)
  ), validWeekday = integerBetween$1(obj.weekday, 1, 7);
  if (!validYear) {
    return unitOutOfRange$1("weekYear", obj.weekYear);
  } else if (!validWeek) {
    return unitOutOfRange$1("week", obj.weekNumber);
  } else if (!validWeekday) {
    return unitOutOfRange$1("weekday", obj.weekday);
  } else return false;
}
function hasInvalidOrdinalData$1(obj) {
  const validYear = isInteger$1(obj.year), validOrdinal = integerBetween$1(obj.ordinal, 1, daysInYear$1(obj.year));
  if (!validYear) {
    return unitOutOfRange$1("year", obj.year);
  } else if (!validOrdinal) {
    return unitOutOfRange$1("ordinal", obj.ordinal);
  } else return false;
}
function hasInvalidGregorianData$1(obj) {
  const validYear = isInteger$1(obj.year), validMonth = integerBetween$1(obj.month, 1, 12), validDay = integerBetween$1(obj.day, 1, daysInMonth$1(obj.year, obj.month));
  if (!validYear) {
    return unitOutOfRange$1("year", obj.year);
  } else if (!validMonth) {
    return unitOutOfRange$1("month", obj.month);
  } else if (!validDay) {
    return unitOutOfRange$1("day", obj.day);
  } else return false;
}
function hasInvalidTimeData$1(obj) {
  const { hour, minute, second, millisecond } = obj;
  const validHour = integerBetween$1(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = integerBetween$1(minute, 0, 59), validSecond = integerBetween$1(second, 0, 59), validMillisecond = integerBetween$1(millisecond, 0, 999);
  if (!validHour) {
    return unitOutOfRange$1("hour", hour);
  } else if (!validMinute) {
    return unitOutOfRange$1("minute", minute);
  } else if (!validSecond) {
    return unitOutOfRange$1("second", second);
  } else if (!validMillisecond) {
    return unitOutOfRange$1("millisecond", millisecond);
  } else return false;
}
function isUndefined$3(o) {
  return typeof o === "undefined";
}
function isNumber$2(o) {
  return typeof o === "number";
}
function isInteger$1(o) {
  return typeof o === "number" && o % 1 === 0;
}
function isString$1(o) {
  return typeof o === "string";
}
function isDate$1(o) {
  return Object.prototype.toString.call(o) === "[object Date]";
}
function hasRelative$1() {
  try {
    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
  } catch (e2) {
    return false;
  }
}
function hasLocaleWeekInfo$1() {
  try {
    return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch (e2) {
    return false;
  }
}
function maybeArray$1(thing) {
  return Array.isArray(thing) ? thing : [thing];
}
function bestBy$1(arr, by, compare) {
  if (arr.length === 0) {
    return void 0;
  }
  return arr.reduce((best, next) => {
    const pair = [by(next), next];
    if (!best) {
      return pair;
    } else if (compare(best[0], pair[0]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}
function pick$1(obj, keys) {
  return keys.reduce((a2, k) => {
    a2[k] = obj[k];
    return a2;
  }, {});
}
function hasOwnProperty$1(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
function validateWeekSettings$1(settings) {
  if (settings == null) {
    return null;
  } else if (typeof settings !== "object") {
    throw new InvalidArgumentError$1("Week settings must be an object");
  } else {
    if (!integerBetween$1(settings.firstDay, 1, 7) || !integerBetween$1(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some((v) => !integerBetween$1(v, 1, 7))) {
      throw new InvalidArgumentError$1("Invalid week settings");
    }
    return {
      firstDay: settings.firstDay,
      minimalDays: settings.minimalDays,
      weekend: Array.from(settings.weekend)
    };
  }
}
function integerBetween$1(thing, bottom, top) {
  return isInteger$1(thing) && thing >= bottom && thing <= top;
}
function floorMod$1(x2, n2) {
  return x2 - n2 * Math.floor(x2 / n2);
}
function padStart$3(input, n2 = 2) {
  const isNeg = input < 0;
  let padded;
  if (isNeg) {
    padded = "-" + ("" + -input).padStart(n2, "0");
  } else {
    padded = ("" + input).padStart(n2, "0");
  }
  return padded;
}
function parseInteger$3(string) {
  if (isUndefined$3(string) || string === null || string === "") {
    return void 0;
  } else {
    return parseInt(string, 10);
  }
}
function parseFloating$1(string) {
  if (isUndefined$3(string) || string === null || string === "") {
    return void 0;
  } else {
    return parseFloat(string);
  }
}
function parseMillis$3(fraction) {
  if (isUndefined$3(fraction) || fraction === null || fraction === "") {
    return void 0;
  } else {
    const f2 = parseFloat("0." + fraction) * 1e3;
    return Math.floor(f2);
  }
}
function roundTo$1(number, digits, rounding = "round") {
  const factor = 10 ** digits;
  switch (rounding) {
    case "expand":
      return number > 0 ? Math.ceil(number * factor) / factor : Math.floor(number * factor) / factor;
    case "trunc":
      return Math.trunc(number * factor) / factor;
    case "round":
      return Math.round(number * factor) / factor;
    case "floor":
      return Math.floor(number * factor) / factor;
    case "ceil":
      return Math.ceil(number * factor) / factor;
    default:
      throw new RangeError(`Value rounding ${rounding} is out of range`);
  }
}
function isLeapYear$1(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function daysInYear$1(year) {
  return isLeapYear$1(year) ? 366 : 365;
}
function daysInMonth$1(year, month) {
  const modMonth = floorMod$1(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
  if (modMonth === 2) {
    return isLeapYear$1(modYear) ? 29 : 28;
  } else {
    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
  }
}
function objToLocalTS$3(obj) {
  let d2 = Date.UTC(
    obj.year,
    obj.month - 1,
    obj.day,
    obj.hour,
    obj.minute,
    obj.second,
    obj.millisecond
  );
  if (obj.year < 100 && obj.year >= 0) {
    d2 = new Date(d2);
    d2.setUTCFullYear(obj.year, obj.month - 1, obj.day);
  }
  return +d2;
}
function firstWeekOffset$1(year, minDaysInFirstWeek, startOfWeek) {
  const fwdlw = isoWeekdayToLocal$1(dayOfWeek$1(year, 1, minDaysInFirstWeek), startOfWeek);
  return -fwdlw + minDaysInFirstWeek - 1;
}
function weeksInWeekYear$1(weekYear, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const weekOffset = firstWeekOffset$1(weekYear, minDaysInFirstWeek, startOfWeek);
  const weekOffsetNext = firstWeekOffset$1(weekYear + 1, minDaysInFirstWeek, startOfWeek);
  return (daysInYear$1(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function untruncateYear$1(year) {
  if (year > 99) {
    return year;
  } else return year > Settings$1.twoDigitCutoffYear ? 1900 + year : 2e3 + year;
}
function parseZoneInfo$3(ts, offsetFormat, locale, timeZone = null) {
  const date = new Date(ts), intlOpts = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }
  const modified = { timeZoneName: offsetFormat, ...intlOpts };
  const parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find((m) => m.type.toLowerCase() === "timezonename");
  return parsed ? parsed.value : null;
}
function signedOffset$3(offHourStr, offMinuteStr) {
  let offHour = parseInt(offHourStr, 10);
  if (Number.isNaN(offHour)) {
    offHour = 0;
  }
  const offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
}
function asNumber$1(value) {
  const numericValue = Number(value);
  if (typeof value === "boolean" || value === "" || !Number.isFinite(numericValue))
    throw new InvalidArgumentError$1(`Invalid unit value ${value}`);
  return numericValue;
}
function normalizeObject$1(obj, normalizer) {
  const normalized = {};
  for (const u in obj) {
    if (hasOwnProperty$1(obj, u)) {
      const v = obj[u];
      if (v === void 0 || v === null) continue;
      normalized[normalizer(u)] = asNumber$1(v);
    }
  }
  return normalized;
}
function formatOffset$3(offset2, format) {
  const hours = Math.trunc(Math.abs(offset2 / 60)), minutes = Math.trunc(Math.abs(offset2 % 60)), sign = offset2 >= 0 ? "+" : "-";
  switch (format) {
    case "short":
      return `${sign}${padStart$3(hours, 2)}:${padStart$3(minutes, 2)}`;
    case "narrow":
      return `${sign}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
    case "techie":
      return `${sign}${padStart$3(hours, 2)}${padStart$3(minutes, 2)}`;
    default:
      throw new RangeError(`Value format ${format} is out of range for property format`);
  }
}
function timeObject$1(obj) {
  return pick$1(obj, ["hour", "minute", "second", "millisecond"]);
}
const monthsLong$1 = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
const monthsShort$1 = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
const monthsNarrow$1 = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function months$1(length) {
  switch (length) {
    case "narrow":
      return [...monthsNarrow$1];
    case "short":
      return [...monthsShort$1];
    case "long":
      return [...monthsLong$1];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const weekdaysLong$1 = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
];
const weekdaysShort$1 = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const weekdaysNarrow$1 = ["M", "T", "W", "T", "F", "S", "S"];
function weekdays$1(length) {
  switch (length) {
    case "narrow":
      return [...weekdaysNarrow$1];
    case "short":
      return [...weekdaysShort$1];
    case "long":
      return [...weekdaysLong$1];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const meridiems$1 = ["AM", "PM"];
const erasLong$1 = ["Before Christ", "Anno Domini"];
const erasShort$1 = ["BC", "AD"];
const erasNarrow$1 = ["B", "A"];
function eras$1(length) {
  switch (length) {
    case "narrow":
      return [...erasNarrow$1];
    case "short":
      return [...erasShort$1];
    case "long":
      return [...erasLong$1];
    default:
      return null;
  }
}
function meridiemForDateTime$1(dt) {
  return meridiems$1[dt.hour < 12 ? 0 : 1];
}
function weekdayForDateTime$1(dt, length) {
  return weekdays$1(length)[dt.weekday - 1];
}
function monthForDateTime$1(dt, length) {
  return months$1(length)[dt.month - 1];
}
function eraForDateTime$1(dt, length) {
  return eras$1(length)[dt.year < 0 ? 0 : 1];
}
function formatRelativeTime$1(unit, count, numeric = "always", narrow = false) {
  const units = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  };
  const lastable = ["hours", "minutes", "seconds"].indexOf(unit) === -1;
  if (numeric === "auto" && lastable) {
    const isDay = unit === "days";
    switch (count) {
      case 1:
        return isDay ? "tomorrow" : `next ${units[unit][0]}`;
      case -1:
        return isDay ? "yesterday" : `last ${units[unit][0]}`;
      case 0:
        return isDay ? "today" : `this ${units[unit][0]}`;
    }
  }
  const isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
  return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}
function stringifyTokens$1(splits, tokenToString) {
  let s2 = "";
  for (const token of splits) {
    if (token.literal) {
      s2 += token.val;
    } else {
      s2 += tokenToString(token.val);
    }
  }
  return s2;
}
const macroTokenToFormatOpts$1 = {
  D: DATE_SHORT$1,
  DD: DATE_MED$1,
  DDD: DATE_FULL$1,
  DDDD: DATE_HUGE$1,
  t: TIME_SIMPLE$1,
  tt: TIME_WITH_SECONDS$1,
  ttt: TIME_WITH_SHORT_OFFSET$1,
  tttt: TIME_WITH_LONG_OFFSET$1,
  T: TIME_24_SIMPLE$1,
  TT: TIME_24_WITH_SECONDS$1,
  TTT: TIME_24_WITH_SHORT_OFFSET$1,
  TTTT: TIME_24_WITH_LONG_OFFSET$1,
  f: DATETIME_SHORT$1,
  ff: DATETIME_MED$1,
  fff: DATETIME_FULL$1,
  ffff: DATETIME_HUGE$1,
  F: DATETIME_SHORT_WITH_SECONDS$1,
  FF: DATETIME_MED_WITH_SECONDS$1,
  FFF: DATETIME_FULL_WITH_SECONDS$1,
  FFFF: DATETIME_HUGE_WITH_SECONDS$1
};
let Formatter$1 = class Formatter2 {
  static create(locale, opts = {}) {
    return new Formatter2(locale, opts);
  }
  static parseFormat(fmt) {
    let current = null, currentFull = "", bracketed = false;
    const splits = [];
    for (let i2 = 0; i2 < fmt.length; i2++) {
      const c2 = fmt.charAt(i2);
      if (c2 === "'") {
        if (currentFull.length > 0 || bracketed) {
          splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull === "" ? "'" : currentFull
          });
        }
        current = null;
        currentFull = "";
        bracketed = !bracketed;
      } else if (bracketed) {
        currentFull += c2;
      } else if (c2 === current) {
        currentFull += c2;
      } else {
        if (currentFull.length > 0) {
          splits.push({ literal: /^\s+$/.test(currentFull), val: currentFull });
        }
        currentFull = c2;
        current = c2;
      }
    }
    if (currentFull.length > 0) {
      splits.push({ literal: bracketed || /^\s+$/.test(currentFull), val: currentFull });
    }
    return splits;
  }
  static macroTokenToFormatOpts(token) {
    return macroTokenToFormatOpts$1[token];
  }
  constructor(locale, formatOpts) {
    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }
  formatWithSystemDefault(dt, opts) {
    if (this.systemLoc === null) {
      this.systemLoc = this.loc.redefaultToSystem();
    }
    const df = this.systemLoc.dtFormatter(dt, { ...this.opts, ...opts });
    return df.format();
  }
  dtFormatter(dt, opts = {}) {
    return this.loc.dtFormatter(dt, { ...this.opts, ...opts });
  }
  formatDateTime(dt, opts) {
    return this.dtFormatter(dt, opts).format();
  }
  formatDateTimeParts(dt, opts) {
    return this.dtFormatter(dt, opts).formatToParts();
  }
  formatInterval(interval, opts) {
    const df = this.dtFormatter(interval.start, opts);
    return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
  }
  resolvedOptions(dt, opts) {
    return this.dtFormatter(dt, opts).resolvedOptions();
  }
  num(n2, p = 0, signDisplay = void 0) {
    if (this.opts.forceSimple) {
      return padStart$3(n2, p);
    }
    const opts = { ...this.opts };
    if (p > 0) {
      opts.padTo = p;
    }
    if (signDisplay) {
      opts.signDisplay = signDisplay;
    }
    return this.loc.numberFormatter(opts).format(n2);
  }
  formatDateTimeFromString(dt, fmt) {
    const knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = (opts, extract) => this.loc.extract(dt, opts, extract), formatOffset2 = (opts) => {
      if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
        return "Z";
      }
      return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
    }, meridiem = () => knownEnglish ? meridiemForDateTime$1(dt) : string({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), month = (length, standalone) => knownEnglish ? monthForDateTime$1(dt, length) : string(standalone ? { month: length } : { month: length, day: "numeric" }, "month"), weekday = (length, standalone) => knownEnglish ? weekdayForDateTime$1(dt, length) : string(
      standalone ? { weekday: length } : { weekday: length, month: "long", day: "numeric" },
      "weekday"
    ), maybeMacro = (token) => {
      const formatOpts = Formatter2.macroTokenToFormatOpts(token);
      if (formatOpts) {
        return this.formatWithSystemDefault(dt, formatOpts);
      } else {
        return token;
      }
    }, era = (length) => knownEnglish ? eraForDateTime$1(dt, length) : string({ era: length }, "era"), tokenToString = (token) => {
      switch (token) {
        // ms
        case "S":
          return this.num(dt.millisecond);
        case "u":
        // falls through
        case "SSS":
          return this.num(dt.millisecond, 3);
        // seconds
        case "s":
          return this.num(dt.second);
        case "ss":
          return this.num(dt.second, 2);
        // fractional seconds
        case "uu":
          return this.num(Math.floor(dt.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(dt.millisecond / 100));
        // minutes
        case "m":
          return this.num(dt.minute);
        case "mm":
          return this.num(dt.minute, 2);
        // hours
        case "h":
          return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
        case "hh":
          return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
        case "H":
          return this.num(dt.hour);
        case "HH":
          return this.num(dt.hour, 2);
        // offset
        case "Z":
          return formatOffset2({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return formatOffset2({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return formatOffset2({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return dt.zone.offsetName(dt.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return dt.zone.offsetName(dt.ts, { format: "long", locale: this.loc.locale });
        // zone
        case "z":
          return dt.zoneName;
        // meridiems
        case "a":
          return meridiem();
        // dates
        case "d":
          return useDateTimeFormatter ? string({ day: "numeric" }, "day") : this.num(dt.day);
        case "dd":
          return useDateTimeFormatter ? string({ day: "2-digit" }, "day") : this.num(dt.day, 2);
        // weekdays - standalone
        case "c":
          return this.num(dt.weekday);
        case "ccc":
          return weekday("short", true);
        case "cccc":
          return weekday("long", true);
        case "ccccc":
          return weekday("narrow", true);
        // weekdays - format
        case "E":
          return this.num(dt.weekday);
        case "EEE":
          return weekday("short", false);
        case "EEEE":
          return weekday("long", false);
        case "EEEEE":
          return weekday("narrow", false);
        // months - standalone
        case "L":
          return useDateTimeFormatter ? string({ month: "numeric", day: "numeric" }, "month") : this.num(dt.month);
        case "LL":
          return useDateTimeFormatter ? string({ month: "2-digit", day: "numeric" }, "month") : this.num(dt.month, 2);
        case "LLL":
          return month("short", true);
        case "LLLL":
          return month("long", true);
        case "LLLLL":
          return month("narrow", true);
        // months - format
        case "M":
          return useDateTimeFormatter ? string({ month: "numeric" }, "month") : this.num(dt.month);
        case "MM":
          return useDateTimeFormatter ? string({ month: "2-digit" }, "month") : this.num(dt.month, 2);
        case "MMM":
          return month("short", false);
        case "MMMM":
          return month("long", false);
        case "MMMMM":
          return month("narrow", false);
        // years
        case "y":
          return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year);
        case "yy":
          return useDateTimeFormatter ? string({ year: "2-digit" }, "year") : this.num(dt.year.toString().slice(-2), 2);
        case "yyyy":
          return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year, 4);
        case "yyyyyy":
          return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year, 6);
        // eras
        case "G":
          return era("short");
        case "GG":
          return era("long");
        case "GGGGG":
          return era("narrow");
        case "kk":
          return this.num(dt.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(dt.weekYear, 4);
        case "W":
          return this.num(dt.weekNumber);
        case "WW":
          return this.num(dt.weekNumber, 2);
        case "n":
          return this.num(dt.localWeekNumber);
        case "nn":
          return this.num(dt.localWeekNumber, 2);
        case "ii":
          return this.num(dt.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(dt.localWeekYear, 4);
        case "o":
          return this.num(dt.ordinal);
        case "ooo":
          return this.num(dt.ordinal, 3);
        case "q":
          return this.num(dt.quarter);
        case "qq":
          return this.num(dt.quarter, 2);
        case "X":
          return this.num(Math.floor(dt.ts / 1e3));
        case "x":
          return this.num(dt.ts);
        default:
          return maybeMacro(token);
      }
    };
    return stringifyTokens$1(Formatter2.parseFormat(fmt), tokenToString);
  }
  formatDurationFromString(dur, fmt) {
    const invertLargest = this.opts.signMode === "negativeLargestOnly" ? -1 : 1;
    const tokenToField = (token) => {
      switch (token[0]) {
        case "S":
          return "milliseconds";
        case "s":
          return "seconds";
        case "m":
          return "minutes";
        case "h":
          return "hours";
        case "d":
          return "days";
        case "w":
          return "weeks";
        case "M":
          return "months";
        case "y":
          return "years";
        default:
          return null;
      }
    }, tokenToString = (lildur, info) => (token) => {
      const mapped = tokenToField(token);
      if (mapped) {
        const inversionFactor = info.isNegativeDuration && mapped !== info.largestUnit ? invertLargest : 1;
        let signDisplay;
        if (this.opts.signMode === "negativeLargestOnly" && mapped !== info.largestUnit) {
          signDisplay = "never";
        } else if (this.opts.signMode === "all") {
          signDisplay = "always";
        } else {
          signDisplay = "auto";
        }
        return this.num(lildur.get(mapped) * inversionFactor, token.length, signDisplay);
      } else {
        return token;
      }
    }, tokens = Formatter2.parseFormat(fmt), realTokens = tokens.reduce(
      (found, { literal, val }) => literal ? found : found.concat(val),
      []
    ), collapsed = dur.shiftTo(...realTokens.map(tokenToField).filter((t) => t)), durationInfo = {
      isNegativeDuration: collapsed < 0,
      // this relies on "collapsed" being based on "shiftTo", which builds up the object
      // in order
      largestUnit: Object.keys(collapsed.values)[0]
    };
    return stringifyTokens$1(tokens, tokenToString(collapsed, durationInfo));
  }
};
const ianaRegex$3 = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function combineRegexes$3(...regexes) {
  const full = regexes.reduce((f2, r) => f2 + r.source, "");
  return RegExp(`^${full}$`);
}
function combineExtractors$3(...extractors) {
  return (m) => extractors.reduce(
    ([mergedVals, mergedZone, cursor], ex) => {
      const [val, zone, next] = ex(m, cursor);
      return [{ ...mergedVals, ...val }, zone || mergedZone, next];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function parse(s2, ...patterns) {
  if (s2 == null) {
    return [null, null];
  }
  for (const [regex, extractor] of patterns) {
    const m = regex.exec(s2);
    if (m) {
      return extractor(m);
    }
  }
  return [null, null];
}
function simpleParse$3(...keys) {
  return (match2, cursor) => {
    const ret = {};
    let i2;
    for (i2 = 0; i2 < keys.length; i2++) {
      ret[keys[i2]] = parseInteger$3(match2[cursor + i2]);
    }
    return [ret, null, cursor + i2];
  };
}
const offsetRegex$3 = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/;
const isoExtendedZone$3 = `(?:${offsetRegex$3.source}?(?:\\[(${ianaRegex$3.source})\\])?)?`;
const isoTimeBaseRegex$3 = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
const isoTimeRegex$3 = RegExp(`${isoTimeBaseRegex$3.source}${isoExtendedZone$3}`);
const isoTimeExtensionRegex$3 = RegExp(`(?:[Tt]${isoTimeRegex$3.source})?`);
const isoYmdRegex$3 = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
const isoWeekRegex$3 = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
const isoOrdinalRegex$3 = /(\d{4})-?(\d{3})/;
const extractISOWeekData$3 = simpleParse$3("weekYear", "weekNumber", "weekDay");
const extractISOOrdinalData$3 = simpleParse$3("year", "ordinal");
const sqlYmdRegex$3 = /(\d{4})-(\d\d)-(\d\d)/;
const sqlTimeRegex$3 = RegExp(
  `${isoTimeBaseRegex$3.source} ?(?:${offsetRegex$3.source}|(${ianaRegex$3.source}))?`
);
const sqlTimeExtensionRegex$3 = RegExp(`(?: ${sqlTimeRegex$3.source})?`);
function int$3(match2, pos, fallback) {
  const m = match2[pos];
  return isUndefined$3(m) ? fallback : parseInteger$3(m);
}
function extractISOYmd$3(match2, cursor) {
  const item = {
    year: int$3(match2, cursor),
    month: int$3(match2, cursor + 1, 1),
    day: int$3(match2, cursor + 2, 1)
  };
  return [item, null, cursor + 3];
}
function extractISOTime$3(match2, cursor) {
  const item = {
    hours: int$3(match2, cursor, 0),
    minutes: int$3(match2, cursor + 1, 0),
    seconds: int$3(match2, cursor + 2, 0),
    milliseconds: parseMillis$3(match2[cursor + 3])
  };
  return [item, null, cursor + 4];
}
function extractISOOffset$3(match2, cursor) {
  const local = !match2[cursor] && !match2[cursor + 1], fullOffset = signedOffset$3(match2[cursor + 1], match2[cursor + 2]), zone = local ? null : FixedOffsetZone$3.instance(fullOffset);
  return [{}, zone, cursor + 3];
}
function extractIANAZone$3(match2, cursor) {
  const zone = match2[cursor] ? IANAZone$3.create(match2[cursor]) : null;
  return [{}, zone, cursor + 1];
}
const isoTimeOnly$1 = RegExp(`^T?${isoTimeBaseRegex$3.source}$`);
const isoDuration$1 = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function extractISODuration$1(match2) {
  const [s2, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] = match2;
  const hasNegativePrefix = s2[0] === "-";
  const negativeSeconds = secondStr && secondStr[0] === "-";
  const maybeNegate = (num, force = false) => num !== void 0 && (force || num && hasNegativePrefix) ? -num : num;
  return [
    {
      years: maybeNegate(parseFloating$1(yearStr)),
      months: maybeNegate(parseFloating$1(monthStr)),
      weeks: maybeNegate(parseFloating$1(weekStr)),
      days: maybeNegate(parseFloating$1(dayStr)),
      hours: maybeNegate(parseFloating$1(hourStr)),
      minutes: maybeNegate(parseFloating$1(minuteStr)),
      seconds: maybeNegate(parseFloating$1(secondStr), secondStr === "-0"),
      milliseconds: maybeNegate(parseMillis$3(millisecondsStr), negativeSeconds)
    }
  ];
}
const obsOffsets$1 = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function fromStrings$1(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  const result = {
    year: yearStr.length === 2 ? untruncateYear$1(parseInteger$3(yearStr)) : parseInteger$3(yearStr),
    month: monthsShort$1.indexOf(monthStr) + 1,
    day: parseInteger$3(dayStr),
    hour: parseInteger$3(hourStr),
    minute: parseInteger$3(minuteStr)
  };
  if (secondStr) result.second = parseInteger$3(secondStr);
  if (weekdayStr) {
    result.weekday = weekdayStr.length > 3 ? weekdaysLong$1.indexOf(weekdayStr) + 1 : weekdaysShort$1.indexOf(weekdayStr) + 1;
  }
  return result;
}
const rfc2822$1 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function extractRFC2822$1(match2) {
  const [
    ,
    weekdayStr,
    dayStr,
    monthStr,
    yearStr,
    hourStr,
    minuteStr,
    secondStr,
    obsOffset,
    milOffset,
    offHourStr,
    offMinuteStr
  ] = match2, result = fromStrings$1(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  let offset2;
  if (obsOffset) {
    offset2 = obsOffsets$1[obsOffset];
  } else if (milOffset) {
    offset2 = 0;
  } else {
    offset2 = signedOffset$3(offHourStr, offMinuteStr);
  }
  return [result, new FixedOffsetZone$3(offset2)];
}
function preprocessRFC2822$1(s2) {
  return s2.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const rfc1123$1 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, rfc850$1 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, ascii$1 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function extractRFC1123Or850$1(match2) {
  const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match2, result = fromStrings$1(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone$3.utcInstance];
}
function extractASCII$1(match2) {
  const [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match2, result = fromStrings$1(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone$3.utcInstance];
}
const isoYmdWithTimeExtensionRegex$1 = combineRegexes$3(isoYmdRegex$3, isoTimeExtensionRegex$3);
const isoWeekWithTimeExtensionRegex$1 = combineRegexes$3(isoWeekRegex$3, isoTimeExtensionRegex$3);
const isoOrdinalWithTimeExtensionRegex$1 = combineRegexes$3(isoOrdinalRegex$3, isoTimeExtensionRegex$3);
const isoTimeCombinedRegex$1 = combineRegexes$3(isoTimeRegex$3);
const extractISOYmdTimeAndOffset$1 = combineExtractors$3(
  extractISOYmd$3,
  extractISOTime$3,
  extractISOOffset$3,
  extractIANAZone$3
);
const extractISOWeekTimeAndOffset$1 = combineExtractors$3(
  extractISOWeekData$3,
  extractISOTime$3,
  extractISOOffset$3,
  extractIANAZone$3
);
const extractISOOrdinalDateAndTime$1 = combineExtractors$3(
  extractISOOrdinalData$3,
  extractISOTime$3,
  extractISOOffset$3,
  extractIANAZone$3
);
const extractISOTimeAndOffset$1 = combineExtractors$3(
  extractISOTime$3,
  extractISOOffset$3,
  extractIANAZone$3
);
function parseISODate$1(s2) {
  return parse(
    s2,
    [isoYmdWithTimeExtensionRegex$1, extractISOYmdTimeAndOffset$1],
    [isoWeekWithTimeExtensionRegex$1, extractISOWeekTimeAndOffset$1],
    [isoOrdinalWithTimeExtensionRegex$1, extractISOOrdinalDateAndTime$1],
    [isoTimeCombinedRegex$1, extractISOTimeAndOffset$1]
  );
}
function parseRFC2822Date$1(s2) {
  return parse(preprocessRFC2822$1(s2), [rfc2822$1, extractRFC2822$1]);
}
function parseHTTPDate$1(s2) {
  return parse(
    s2,
    [rfc1123$1, extractRFC1123Or850$1],
    [rfc850$1, extractRFC1123Or850$1],
    [ascii$1, extractASCII$1]
  );
}
function parseISODuration$1(s2) {
  return parse(s2, [isoDuration$1, extractISODuration$1]);
}
const extractISOTimeOnly$1 = combineExtractors$3(extractISOTime$3);
function parseISOTimeOnly$1(s2) {
  return parse(s2, [isoTimeOnly$1, extractISOTimeOnly$1]);
}
const sqlYmdWithTimeExtensionRegex$1 = combineRegexes$3(sqlYmdRegex$3, sqlTimeExtensionRegex$3);
const sqlTimeCombinedRegex$1 = combineRegexes$3(sqlTimeRegex$3);
const extractISOTimeOffsetAndIANAZone$1 = combineExtractors$3(
  extractISOTime$3,
  extractISOOffset$3,
  extractIANAZone$3
);
function parseSQL$1(s2) {
  return parse(
    s2,
    [sqlYmdWithTimeExtensionRegex$1, extractISOYmdTimeAndOffset$1],
    [sqlTimeCombinedRegex$1, extractISOTimeOffsetAndIANAZone$1]
  );
}
const INVALID$2$1 = "Invalid Duration";
const lowOrderMatrix$2 = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, casualMatrix$1 = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...lowOrderMatrix$2
}, daysInYearAccurate$1 = 146097 / 400, daysInMonthAccurate$1 = 146097 / 4800, accurateMatrix$1 = {
  years: {
    quarters: 4,
    months: 12,
    weeks: daysInYearAccurate$1 / 7,
    days: daysInYearAccurate$1,
    hours: daysInYearAccurate$1 * 24,
    minutes: daysInYearAccurate$1 * 24 * 60,
    seconds: daysInYearAccurate$1 * 24 * 60 * 60,
    milliseconds: daysInYearAccurate$1 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: daysInYearAccurate$1 / 28,
    days: daysInYearAccurate$1 / 4,
    hours: daysInYearAccurate$1 * 24 / 4,
    minutes: daysInYearAccurate$1 * 24 * 60 / 4,
    seconds: daysInYearAccurate$1 * 24 * 60 * 60 / 4,
    milliseconds: daysInYearAccurate$1 * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: daysInMonthAccurate$1 / 7,
    days: daysInMonthAccurate$1,
    hours: daysInMonthAccurate$1 * 24,
    minutes: daysInMonthAccurate$1 * 24 * 60,
    seconds: daysInMonthAccurate$1 * 24 * 60 * 60,
    milliseconds: daysInMonthAccurate$1 * 24 * 60 * 60 * 1e3
  },
  ...lowOrderMatrix$2
};
const orderedUnits$1$2 = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
];
const reverseUnits$1 = orderedUnits$1$2.slice(0).reverse();
function clone$1$1(dur, alts, clear = false) {
  const conf = {
    values: clear ? alts.values : { ...dur.values, ...alts.values || {} },
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
    matrix: alts.matrix || dur.matrix
  };
  return new Duration$1(conf);
}
function durationToMillis$1(matrix, vals) {
  let sum = vals.milliseconds ?? 0;
  for (const unit of reverseUnits$1.slice(1)) {
    if (vals[unit]) {
      sum += vals[unit] * matrix[unit]["milliseconds"];
    }
  }
  return sum;
}
function normalizeValues$1(matrix, vals) {
  const factor = durationToMillis$1(matrix, vals) < 0 ? -1 : 1;
  orderedUnits$1$2.reduceRight((previous, current) => {
    if (!isUndefined$3(vals[current])) {
      if (previous) {
        const previousVal = vals[previous] * factor;
        const conv = matrix[current][previous];
        const rollUp = Math.floor(previousVal / conv);
        vals[current] += rollUp * factor;
        vals[previous] -= rollUp * conv * factor;
      }
      return current;
    } else {
      return previous;
    }
  }, null);
  orderedUnits$1$2.reduce((previous, current) => {
    if (!isUndefined$3(vals[current])) {
      if (previous) {
        const fraction = vals[previous] % 1;
        vals[previous] -= fraction;
        vals[current] += fraction * matrix[previous][current];
      }
      return current;
    } else {
      return previous;
    }
  }, null);
}
function removeZeroes$1(vals) {
  const newVals = {};
  for (const [key, value] of Object.entries(vals)) {
    if (value !== 0) {
      newVals[key] = value;
    }
  }
  return newVals;
}
let Duration$1 = class Duration2 {
  /**
   * @private
   */
  constructor(config) {
    const accurate = config.conversionAccuracy === "longterm" || false;
    let matrix = accurate ? accurateMatrix$1 : casualMatrix$1;
    if (config.matrix) {
      matrix = config.matrix;
    }
    this.values = config.values;
    this.loc = config.loc || Locale$1.create();
    this.conversionAccuracy = accurate ? "longterm" : "casual";
    this.invalid = config.invalid || null;
    this.matrix = matrix;
    this.isLuxonDuration = true;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(count, opts) {
    return Duration2.fromObject({ milliseconds: count }, opts);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(obj, opts = {}) {
    if (obj == null || typeof obj !== "object") {
      throw new InvalidArgumentError$1(
        `Duration.fromObject: argument expected to be an object, got ${obj === null ? "null" : typeof obj}`
      );
    }
    return new Duration2({
      values: normalizeObject$1(obj, Duration2.normalizeUnit),
      loc: Locale$1.fromObject(opts),
      conversionAccuracy: opts.conversionAccuracy,
      matrix: opts.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(durationLike) {
    if (isNumber$2(durationLike)) {
      return Duration2.fromMillis(durationLike);
    } else if (Duration2.isDuration(durationLike)) {
      return durationLike;
    } else if (typeof durationLike === "object") {
      return Duration2.fromObject(durationLike);
    } else {
      throw new InvalidArgumentError$1(
        `Unknown duration argument ${durationLike} of type ${typeof durationLike}`
      );
    }
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(text, opts) {
    const [parsed] = parseISODuration$1(text);
    if (parsed) {
      return Duration2.fromObject(parsed, opts);
    } else {
      return Duration2.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(text, opts) {
    const [parsed] = parseISOTimeOnly$1(text);
    if (parsed) {
      return Duration2.fromObject(parsed, opts);
    } else {
      return Duration2.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError$1("need to specify a reason the Duration is invalid");
    }
    const invalid2 = reason instanceof Invalid$1 ? reason : new Invalid$1(reason, explanation);
    if (Settings$1.throwOnInvalid) {
      throw new InvalidDurationError$1(invalid2);
    } else {
      return new Duration2({ invalid: invalid2 });
    }
  }
  /**
   * @private
   */
  static normalizeUnit(unit) {
    const normalized = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[unit ? unit.toLowerCase() : unit];
    if (!normalized) throw new InvalidUnitError$1(unit);
    return normalized;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(o) {
    return o && o.isLuxonDuration || false;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @param {'negative'|'all'|'negativeLargestOnly'} [opts.signMode=negative] - How to handle signs
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @example Duration.fromObject({ days: 6, seconds: 2 }).toFormat("d s", { signMode: "all" }) //=> "+6 +2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "all" }) //=> "-6 -2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "negativeLargestOnly" }) //=> "-6 2"
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    const fmtOpts = {
      ...opts,
      floor: opts.round !== false && opts.floor !== false
    };
    return this.isValid ? Formatter$1.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID$2$1;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @param {boolean} [opts.showZeros=true] - Show all units previously used by the duration even if they are zero
   * @example
   * ```js
   * var dur = Duration.fromObject({ months: 1, weeks: 0, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 month, 0 weeks, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 month, 0 weeks, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 mth, 0 wks, 5 hr, 6 min'
   * dur.toHuman({ showZeros: false }) //=> '1 month, 5 hours, 6 minutes'
   * ```
   */
  toHuman(opts = {}) {
    if (!this.isValid) return INVALID$2$1;
    const showZeros = opts.showZeros !== false;
    const l2 = orderedUnits$1$2.map((unit) => {
      const val = this.values[unit];
      if (isUndefined$3(val) || val === 0 && !showZeros) {
        return null;
      }
      return this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...opts, unit: unit.slice(0, -1) }).format(val);
    }).filter((n2) => n2);
    return this.loc.listFormatter({ type: "conjunction", style: opts.listStyle || "narrow", ...opts }).format(l2);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    if (!this.isValid) return {};
    return { ...this.values };
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let s2 = "P";
    if (this.years !== 0) s2 += this.years + "Y";
    if (this.months !== 0 || this.quarters !== 0) s2 += this.months + this.quarters * 3 + "M";
    if (this.weeks !== 0) s2 += this.weeks + "W";
    if (this.days !== 0) s2 += this.days + "D";
    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0)
      s2 += "T";
    if (this.hours !== 0) s2 += this.hours + "H";
    if (this.minutes !== 0) s2 += this.minutes + "M";
    if (this.seconds !== 0 || this.milliseconds !== 0)
      s2 += roundTo$1(this.seconds + this.milliseconds / 1e3, 3) + "S";
    if (s2 === "P") s2 += "T0S";
    return s2;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(opts = {}) {
    if (!this.isValid) return null;
    const millis = this.toMillis();
    if (millis < 0 || millis >= 864e5) return null;
    opts = {
      suppressMilliseconds: false,
      suppressSeconds: false,
      includePrefix: false,
      format: "extended",
      ...opts,
      includeOffset: false
    };
    const dateTime = DateTime$1.fromMillis(millis, { zone: "UTC" });
    return dateTime.toISOTime(opts);
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Duration { values: ${JSON.stringify(this.values)} }`;
    } else {
      return `Duration { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    if (!this.isValid) return NaN;
    return durationToMillis$1(this.matrix, this.values);
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(duration) {
    if (!this.isValid) return this;
    const dur = Duration2.fromDurationLike(duration), result = {};
    for (const k of orderedUnits$1$2) {
      if (hasOwnProperty$1(dur.values, k) || hasOwnProperty$1(this.values, k)) {
        result[k] = dur.get(k) + this.get(k);
      }
    }
    return clone$1$1(this, { values: result }, true);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(duration) {
    if (!this.isValid) return this;
    const dur = Duration2.fromDurationLike(duration);
    return this.plus(dur.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(fn) {
    if (!this.isValid) return this;
    const result = {};
    for (const k of Object.keys(this.values)) {
      result[k] = asNumber$1(fn(this.values[k], k));
    }
    return clone$1$1(this, { values: result }, true);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(unit) {
    return this[Duration2.normalizeUnit(unit)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(values) {
    if (!this.isValid) return this;
    const mixed = { ...this.values, ...normalizeObject$1(values, Duration2.normalizeUnit) };
    return clone$1$1(this, { values: mixed });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale, numberingSystem, conversionAccuracy, matrix } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem });
    const opts = { loc, matrix, conversionAccuracy };
    return clone$1$1(this, opts);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const vals = this.toObject();
    normalizeValues$1(this.matrix, vals);
    return clone$1$1(this, { values: vals }, true);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const vals = removeZeroes$1(this.normalize().shiftToAll().toObject());
    return clone$1$1(this, { values: vals }, true);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...units) {
    if (!this.isValid) return this;
    if (units.length === 0) {
      return this;
    }
    units = units.map((u) => Duration2.normalizeUnit(u));
    const built = {}, accumulated = {}, vals = this.toObject();
    let lastUnit;
    for (const k of orderedUnits$1$2) {
      if (units.indexOf(k) >= 0) {
        lastUnit = k;
        let own = 0;
        for (const ak in accumulated) {
          own += this.matrix[ak][k] * accumulated[ak];
          accumulated[ak] = 0;
        }
        if (isNumber$2(vals[k])) {
          own += vals[k];
        }
        const i2 = Math.trunc(own);
        built[k] = i2;
        accumulated[k] = (own * 1e3 - i2 * 1e3) / 1e3;
      } else if (isNumber$2(vals[k])) {
        accumulated[k] = vals[k];
      }
    }
    for (const key in accumulated) {
      if (accumulated[key] !== 0) {
        built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
      }
    }
    normalizeValues$1(this.matrix, built);
    return clone$1$1(this, { values: built }, true);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    if (!this.isValid) return this;
    return this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    );
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const negated = {};
    for (const k of Object.keys(this.values)) {
      negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
    }
    return clone$1$1(this, { values: negated }, true);
  }
  /**
   * Removes all units with values equal to 0 from this Duration.
   * @example Duration.fromObject({ years: 2, days: 0, hours: 0, minutes: 0 }).removeZeros().toObject() //=> { years: 2 }
   * @return {Duration}
   */
  removeZeros() {
    if (!this.isValid) return this;
    const vals = removeZeroes$1(this.values);
    return clone$1$1(this, { values: vals }, true);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    if (!this.loc.equals(other.loc)) {
      return false;
    }
    function eq(v1, v2) {
      if (v1 === void 0 || v1 === 0) return v2 === void 0 || v2 === 0;
      return v1 === v2;
    }
    for (const u of orderedUnits$1$2) {
      if (!eq(this.values[u], other.values[u])) {
        return false;
      }
    }
    return true;
  }
};
const INVALID$1$1 = "Invalid Interval";
function validateStartEnd$1(start, end) {
  if (!start || !start.isValid) {
    return Interval$1.invalid("missing or invalid start");
  } else if (!end || !end.isValid) {
    return Interval$1.invalid("missing or invalid end");
  } else if (end < start) {
    return Interval$1.invalid(
      "end before start",
      `The end of an interval must be after its start, but you had start=${start.toISO()} and end=${end.toISO()}`
    );
  } else {
    return null;
  }
}
let Interval$1 = class Interval2 {
  /**
   * @private
   */
  constructor(config) {
    this.s = config.start;
    this.e = config.end;
    this.invalid = config.invalid || null;
    this.isLuxonInterval = true;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError$1("need to specify a reason the Interval is invalid");
    }
    const invalid2 = reason instanceof Invalid$1 ? reason : new Invalid$1(reason, explanation);
    if (Settings$1.throwOnInvalid) {
      throw new InvalidIntervalError$1(invalid2);
    } else {
      return new Interval2({ invalid: invalid2 });
    }
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(start, end) {
    const builtStart = friendlyDateTime$1(start), builtEnd = friendlyDateTime$1(end);
    const validateError = validateStartEnd$1(builtStart, builtEnd);
    if (validateError == null) {
      return new Interval2({
        start: builtStart,
        end: builtEnd
      });
    } else {
      return validateError;
    }
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(start, duration) {
    const dur = Duration$1.fromDurationLike(duration), dt = friendlyDateTime$1(start);
    return Interval2.fromDateTimes(dt, dt.plus(dur));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(end, duration) {
    const dur = Duration$1.fromDurationLike(duration), dt = friendlyDateTime$1(end);
    return Interval2.fromDateTimes(dt.minus(dur), dt);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(text, opts) {
    const [s2, e2] = (text || "").split("/", 2);
    if (s2 && e2) {
      let start, startIsValid;
      try {
        start = DateTime$1.fromISO(s2, opts);
        startIsValid = start.isValid;
      } catch (e3) {
        startIsValid = false;
      }
      let end, endIsValid;
      try {
        end = DateTime$1.fromISO(e2, opts);
        endIsValid = end.isValid;
      } catch (e3) {
        endIsValid = false;
      }
      if (startIsValid && endIsValid) {
        return Interval2.fromDateTimes(start, end);
      }
      if (startIsValid) {
        const dur = Duration$1.fromISO(e2, opts);
        if (dur.isValid) {
          return Interval2.after(start, dur);
        }
      } else if (endIsValid) {
        const dur = Duration$1.fromISO(s2, opts);
        if (dur.isValid) {
          return Interval2.before(end, dur);
        }
      }
    }
    return Interval2.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(o) {
    return o && o.isLuxonInterval || false;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval. This is the first instant which is not part of the interval
   * (Interval is half-open).
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns the last DateTime included in the interval (since end is not part of the interval)
   * @type {DateTime}
   */
  get lastDateTime() {
    return this.isValid ? this.e ? this.e.minus(1) : null : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(unit = "milliseconds") {
    return this.isValid ? this.toDuration(...[unit]).get(unit) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(unit = "milliseconds", opts) {
    if (!this.isValid) return NaN;
    const start = this.start.startOf(unit, opts);
    let end;
    if (opts?.useLocaleWeeks) {
      end = this.end.reconfigure({ locale: start.locale });
    } else {
      end = this.end;
    }
    end = end.startOf(unit, opts);
    return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(unit) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(dateTime) {
    if (!this.isValid) return false;
    return this.s > dateTime;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(dateTime) {
    if (!this.isValid) return false;
    return this.e <= dateTime;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(dateTime) {
    if (!this.isValid) return false;
    return this.s <= dateTime && this.e > dateTime;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start, end } = {}) {
    if (!this.isValid) return this;
    return Interval2.fromDateTimes(start || this.s, end || this.e);
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...dateTimes) {
    if (!this.isValid) return [];
    const sorted = dateTimes.map(friendlyDateTime$1).filter((d2) => this.contains(d2)).sort((a2, b2) => a2.toMillis() - b2.toMillis()), results = [];
    let { s: s2 } = this, i2 = 0;
    while (s2 < this.e) {
      const added = sorted[i2] || this.e, next = +added > +this.e ? this.e : added;
      results.push(Interval2.fromDateTimes(s2, next));
      s2 = next;
      i2 += 1;
    }
    return results;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(duration) {
    const dur = Duration$1.fromDurationLike(duration);
    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
      return [];
    }
    let { s: s2 } = this, idx = 1, next;
    const results = [];
    while (s2 < this.e) {
      const added = this.start.plus(dur.mapUnits((x2) => x2 * idx));
      next = +added > +this.e ? this.e : added;
      results.push(Interval2.fromDateTimes(s2, next));
      s2 = next;
      idx += 1;
    }
    return results;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(numberOfParts) {
    if (!this.isValid) return [];
    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(other) {
    return this.e > other.s && this.s < other.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(other) {
    if (!this.isValid) return false;
    return +this.e === +other.s;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(other) {
    if (!this.isValid) return false;
    return +other.e === +this.s;
  }
  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(other) {
    if (!this.isValid) return false;
    return this.s <= other.s && this.e >= other.e;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    return this.s.equals(other.s) && this.e.equals(other.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(other) {
    if (!this.isValid) return this;
    const s2 = this.s > other.s ? this.s : other.s, e2 = this.e < other.e ? this.e : other.e;
    if (s2 >= e2) {
      return null;
    } else {
      return Interval2.fromDateTimes(s2, e2);
    }
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(other) {
    if (!this.isValid) return this;
    const s2 = this.s < other.s ? this.s : other.s, e2 = this.e > other.e ? this.e : other.e;
    return Interval2.fromDateTimes(s2, e2);
  }
  /**
   * Merge an array of Intervals into an equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * The resulting array will contain the Intervals in ascending order, that is, starting with the earliest Interval
   * and ending with the latest.
   *
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(intervals) {
    const [found, final] = intervals.sort((a2, b2) => a2.s - b2.s).reduce(
      ([sofar, current], item) => {
        if (!current) {
          return [sofar, item];
        } else if (current.overlaps(item) || current.abutsStart(item)) {
          return [sofar, current.union(item)];
        } else {
          return [sofar.concat([current]), item];
        }
      },
      [[], null]
    );
    if (final) {
      found.push(final);
    }
    return found;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(intervals) {
    let start = null, currentCount = 0;
    const results = [], ends = intervals.map((i2) => [
      { time: i2.s, type: "s" },
      { time: i2.e, type: "e" }
    ]), flattened = Array.prototype.concat(...ends), arr = flattened.sort((a2, b2) => a2.time - b2.time);
    for (const i2 of arr) {
      currentCount += i2.type === "s" ? 1 : -1;
      if (currentCount === 1) {
        start = i2.time;
      } else {
        if (start && +start !== +i2.time) {
          results.push(Interval2.fromDateTimes(start, i2.time));
        }
        start = null;
      }
    }
    return Interval2.merge(results);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...intervals) {
    return Interval2.xor([this].concat(intervals)).map((i2) => this.intersection(i2)).filter((i2) => i2 && !i2.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    if (!this.isValid) return INVALID$1$1;
    return `[${this.s.toISO()} – ${this.e.toISO()})`;
  }
  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }`;
    } else {
      return `Interval { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(formatOpts = DATE_SHORT$1, opts = {}) {
    return this.isValid ? Formatter$1.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : INVALID$1$1;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(opts) {
    if (!this.isValid) return INVALID$1$1;
    return `${this.s.toISO(opts)}/${this.e.toISO(opts)}`;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    if (!this.isValid) return INVALID$1$1;
    return `${this.s.toISODate()}/${this.e.toISODate()}`;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(opts) {
    if (!this.isValid) return INVALID$1$1;
    return `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}`;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(dateFormat, { separator = " – " } = {}) {
    if (!this.isValid) return INVALID$1$1;
    return `${this.s.toFormat(dateFormat)}${separator}${this.e.toFormat(dateFormat)}`;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(unit, opts) {
    if (!this.isValid) {
      return Duration$1.invalid(this.invalidReason);
    }
    return this.e.diff(this.s, unit, opts);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(mapFn) {
    return Interval2.fromDateTimes(mapFn(this.s), mapFn(this.e));
  }
};
let Info$1 = class Info2 {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(zone = Settings$1.defaultZone) {
    const proto = DateTime$1.now().setZone(zone).set({ month: 12 });
    return !zone.isUniversal && proto.offset !== proto.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(zone) {
    return IANAZone$3.isValidZone(zone);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(input) {
    return normalizeZone$1(input, Settings$1.defaultZone);
  }
  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale$1.create(locale)).getStartOfWeek();
  }
  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale$1.create(locale)).getMinDaysInFirstWeek();
  }
  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale = null, locObj = null } = {}) {
    return (locObj || Locale$1.create(locale)).getWeekendDays().slice();
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(length = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
    return (locObj || Locale$1.create(locale, numberingSystem, outputCalendar)).months(length);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(length = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
    return (locObj || Locale$1.create(locale, numberingSystem, outputCalendar)).months(length, true);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale$1.create(locale, numberingSystem, null)).weekdays(length);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale$1.create(locale, numberingSystem, null)).weekdays(length, true);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale = null } = {}) {
    return Locale$1.create(locale).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(length = "short", { locale = null } = {}) {
    return Locale$1.create(locale, null, "gregory").eras(length);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: hasRelative$1(), localeWeek: hasLocaleWeekInfo$1() };
  }
};
function dayDiff$1(earlier, later) {
  const utcDayStart = (dt) => dt.toUTC(0, { keepLocalTime: true }).startOf("day").valueOf(), ms = utcDayStart(later) - utcDayStart(earlier);
  return Math.floor(Duration$1.fromMillis(ms).as("days"));
}
function highOrderDiffs$1(cursor, later, units) {
  const differs = [
    ["years", (a2, b2) => b2.year - a2.year],
    ["quarters", (a2, b2) => b2.quarter - a2.quarter + (b2.year - a2.year) * 4],
    ["months", (a2, b2) => b2.month - a2.month + (b2.year - a2.year) * 12],
    [
      "weeks",
      (a2, b2) => {
        const days = dayDiff$1(a2, b2);
        return (days - days % 7) / 7;
      }
    ],
    ["days", dayDiff$1]
  ];
  const results = {};
  const earlier = cursor;
  let lowestOrder, highWater;
  for (const [unit, differ] of differs) {
    if (units.indexOf(unit) >= 0) {
      lowestOrder = unit;
      results[unit] = differ(cursor, later);
      highWater = earlier.plus(results);
      if (highWater > later) {
        results[unit]--;
        cursor = earlier.plus(results);
        if (cursor > later) {
          highWater = cursor;
          results[unit]--;
          cursor = earlier.plus(results);
        }
      } else {
        cursor = highWater;
      }
    }
  }
  return [cursor, results, highWater, lowestOrder];
}
function diff(earlier, later, units, opts) {
  let [cursor, results, highWater, lowestOrder] = highOrderDiffs$1(earlier, later, units);
  const remainingMillis = later - cursor;
  const lowerOrderUnits = units.filter(
    (u) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0
  );
  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      highWater = cursor.plus({ [lowestOrder]: 1 });
    }
    if (highWater !== cursor) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
  }
  const duration = Duration$1.fromObject(results, opts);
  if (lowerOrderUnits.length > 0) {
    return Duration$1.fromMillis(remainingMillis, opts).shiftTo(...lowerOrderUnits).plus(duration);
  } else {
    return duration;
  }
}
const MISSING_FTP$1 = "missing Intl.DateTimeFormat.formatToParts support";
function intUnit$1(regex, post = (i2) => i2) {
  return { regex, deser: ([s2]) => post(parseDigits$1(s2)) };
}
const NBSP$1 = String.fromCharCode(160);
const spaceOrNBSP$1 = `[ ${NBSP$1}]`;
const spaceOrNBSPRegExp$1 = new RegExp(spaceOrNBSP$1, "g");
function fixListRegex$1(s2) {
  return s2.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp$1, spaceOrNBSP$1);
}
function stripInsensitivities$1(s2) {
  return s2.replace(/\./g, "").replace(spaceOrNBSPRegExp$1, " ").toLowerCase();
}
function oneOf$1(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex$1).join("|")),
      deser: ([s2]) => strings.findIndex((i2) => stripInsensitivities$1(s2) === stripInsensitivities$1(i2)) + startIndex
    };
  }
}
function offset$1(regex, groups) {
  return { regex, deser: ([, h, m]) => signedOffset$3(h, m), groups };
}
function simple$1(regex) {
  return { regex, deser: ([s2]) => s2 };
}
function escapeToken$1(value) {
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function unitForToken$1(token, loc) {
  const one = digitRegex$1(loc), two = digitRegex$1(loc, "{2}"), three = digitRegex$1(loc, "{3}"), four = digitRegex$1(loc, "{4}"), six = digitRegex$1(loc, "{6}"), oneOrTwo = digitRegex$1(loc, "{1,2}"), oneToThree = digitRegex$1(loc, "{1,3}"), oneToSix = digitRegex$1(loc, "{1,6}"), oneToNine = digitRegex$1(loc, "{1,9}"), twoToFour = digitRegex$1(loc, "{2,4}"), fourToSix = digitRegex$1(loc, "{4,6}"), literal = (t) => ({ regex: RegExp(escapeToken$1(t.val)), deser: ([s2]) => s2, literal: true }), unitate = (t) => {
    if (token.literal) {
      return literal(t);
    }
    switch (t.val) {
      // era
      case "G":
        return oneOf$1(loc.eras("short"), 0);
      case "GG":
        return oneOf$1(loc.eras("long"), 0);
      // years
      case "y":
        return intUnit$1(oneToSix);
      case "yy":
        return intUnit$1(twoToFour, untruncateYear$1);
      case "yyyy":
        return intUnit$1(four);
      case "yyyyy":
        return intUnit$1(fourToSix);
      case "yyyyyy":
        return intUnit$1(six);
      // months
      case "M":
        return intUnit$1(oneOrTwo);
      case "MM":
        return intUnit$1(two);
      case "MMM":
        return oneOf$1(loc.months("short", true), 1);
      case "MMMM":
        return oneOf$1(loc.months("long", true), 1);
      case "L":
        return intUnit$1(oneOrTwo);
      case "LL":
        return intUnit$1(two);
      case "LLL":
        return oneOf$1(loc.months("short", false), 1);
      case "LLLL":
        return oneOf$1(loc.months("long", false), 1);
      // dates
      case "d":
        return intUnit$1(oneOrTwo);
      case "dd":
        return intUnit$1(two);
      // ordinals
      case "o":
        return intUnit$1(oneToThree);
      case "ooo":
        return intUnit$1(three);
      // time
      case "HH":
        return intUnit$1(two);
      case "H":
        return intUnit$1(oneOrTwo);
      case "hh":
        return intUnit$1(two);
      case "h":
        return intUnit$1(oneOrTwo);
      case "mm":
        return intUnit$1(two);
      case "m":
        return intUnit$1(oneOrTwo);
      case "q":
        return intUnit$1(oneOrTwo);
      case "qq":
        return intUnit$1(two);
      case "s":
        return intUnit$1(oneOrTwo);
      case "ss":
        return intUnit$1(two);
      case "S":
        return intUnit$1(oneToThree);
      case "SSS":
        return intUnit$1(three);
      case "u":
        return simple$1(oneToNine);
      case "uu":
        return simple$1(oneOrTwo);
      case "uuu":
        return intUnit$1(one);
      // meridiem
      case "a":
        return oneOf$1(loc.meridiems(), 0);
      // weekYear (k)
      case "kkkk":
        return intUnit$1(four);
      case "kk":
        return intUnit$1(twoToFour, untruncateYear$1);
      // weekNumber (W)
      case "W":
        return intUnit$1(oneOrTwo);
      case "WW":
        return intUnit$1(two);
      // weekdays
      case "E":
      case "c":
        return intUnit$1(one);
      case "EEE":
        return oneOf$1(loc.weekdays("short", false), 1);
      case "EEEE":
        return oneOf$1(loc.weekdays("long", false), 1);
      case "ccc":
        return oneOf$1(loc.weekdays("short", true), 1);
      case "cccc":
        return oneOf$1(loc.weekdays("long", true), 1);
      // offset/zone
      case "Z":
      case "ZZ":
        return offset$1(new RegExp(`([+-]${oneOrTwo.source})(?::(${two.source}))?`), 2);
      case "ZZZ":
        return offset$1(new RegExp(`([+-]${oneOrTwo.source})(${two.source})?`), 2);
      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
      // because we don't have any way to figure out what they are
      case "z":
        return simple$1(/[a-z_+-/]{1,256}?/i);
      // this special-case "token" represents a place where a macro-token expanded into a white-space literal
      // in this case we accept any non-newline white-space
      case " ":
        return simple$1(/[^\S\n\r]/);
      default:
        return literal(t);
    }
  };
  const unit = unitate(token) || {
    invalidReason: MISSING_FTP$1
  };
  unit.token = token;
  return unit;
}
const partTypeStyleToTokenVal$1 = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function tokenForPart$1(part, formatOpts, resolvedOpts) {
  const { type, value } = part;
  if (type === "literal") {
    const isSpace = /^\s+$/.test(value);
    return {
      literal: !isSpace,
      val: isSpace ? " " : value
    };
  }
  const style = formatOpts[type];
  let actualType = type;
  if (type === "hour") {
    if (formatOpts.hour12 != null) {
      actualType = formatOpts.hour12 ? "hour12" : "hour24";
    } else if (formatOpts.hourCycle != null) {
      if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") {
        actualType = "hour12";
      } else {
        actualType = "hour24";
      }
    } else {
      actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
  }
  let val = partTypeStyleToTokenVal$1[actualType];
  if (typeof val === "object") {
    val = val[style];
  }
  if (val) {
    return {
      literal: false,
      val
    };
  }
  return void 0;
}
function buildRegex$1(units) {
  const re = units.map((u) => u.regex).reduce((f2, r) => `${f2}(${r.source})`, "");
  return [`^${re}$`, units];
}
function match$1(input, regex, handlers) {
  const matches = input.match(regex);
  if (matches) {
    const all = {};
    let matchIndex = 1;
    for (const i2 in handlers) {
      if (hasOwnProperty$1(handlers, i2)) {
        const h = handlers[i2], groups = h.groups ? h.groups + 1 : 1;
        if (!h.literal && h.token) {
          all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
        }
        matchIndex += groups;
      }
    }
    return [matches, all];
  } else {
    return [matches, {}];
  }
}
function dateTimeFromMatches$1(matches) {
  const toField = (token) => {
    switch (token) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let zone = null;
  let specificOffset;
  if (!isUndefined$3(matches.z)) {
    zone = IANAZone$3.create(matches.z);
  }
  if (!isUndefined$3(matches.Z)) {
    if (!zone) {
      zone = new FixedOffsetZone$3(matches.Z);
    }
    specificOffset = matches.Z;
  }
  if (!isUndefined$3(matches.q)) {
    matches.M = (matches.q - 1) * 3 + 1;
  }
  if (!isUndefined$3(matches.h)) {
    if (matches.h < 12 && matches.a === 1) {
      matches.h += 12;
    } else if (matches.h === 12 && matches.a === 0) {
      matches.h = 0;
    }
  }
  if (matches.G === 0 && matches.y) {
    matches.y = -matches.y;
  }
  if (!isUndefined$3(matches.u)) {
    matches.S = parseMillis$3(matches.u);
  }
  const vals = Object.keys(matches).reduce((r, k) => {
    const f2 = toField(k);
    if (f2) {
      r[f2] = matches[k];
    }
    return r;
  }, {});
  return [vals, zone, specificOffset];
}
let dummyDateTimeCache$1 = null;
function getDummyDateTime$1() {
  if (!dummyDateTimeCache$1) {
    dummyDateTimeCache$1 = DateTime$1.fromMillis(1555555555555);
  }
  return dummyDateTimeCache$1;
}
function maybeExpandMacroToken$1(token, locale) {
  if (token.literal) {
    return token;
  }
  const formatOpts = Formatter$1.macroTokenToFormatOpts(token.val);
  const tokens = formatOptsToTokens$1(formatOpts, locale);
  if (tokens == null || tokens.includes(void 0)) {
    return token;
  }
  return tokens;
}
function expandMacroTokens$1(tokens, locale) {
  return Array.prototype.concat(...tokens.map((t) => maybeExpandMacroToken$1(t, locale)));
}
let TokenParser$1 = class TokenParser2 {
  constructor(locale, format) {
    this.locale = locale;
    this.format = format;
    this.tokens = expandMacroTokens$1(Formatter$1.parseFormat(format), locale);
    this.units = this.tokens.map((t) => unitForToken$1(t, locale));
    this.disqualifyingUnit = this.units.find((t) => t.invalidReason);
    if (!this.disqualifyingUnit) {
      const [regexString, handlers] = buildRegex$1(this.units);
      this.regex = RegExp(regexString, "i");
      this.handlers = handlers;
    }
  }
  explainFromTokens(input) {
    if (!this.isValid) {
      return { input, tokens: this.tokens, invalidReason: this.invalidReason };
    } else {
      const [rawMatches, matches] = match$1(input, this.regex, this.handlers), [result, zone, specificOffset] = matches ? dateTimeFromMatches$1(matches) : [null, null, void 0];
      if (hasOwnProperty$1(matches, "a") && hasOwnProperty$1(matches, "H")) {
        throw new ConflictingSpecificationError$1(
          "Can't include meridiem when specifying 24-hour format"
        );
      }
      return {
        input,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches,
        matches,
        result,
        zone,
        specificOffset
      };
    }
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
};
function explainFromTokens$1(locale, input, format) {
  const parser = new TokenParser$1(locale, format);
  return parser.explainFromTokens(input);
}
function parseFromTokens$1(locale, input, format) {
  const { result, zone, specificOffset, invalidReason } = explainFromTokens$1(locale, input, format);
  return [result, zone, specificOffset, invalidReason];
}
function formatOptsToTokens$1(formatOpts, locale) {
  if (!formatOpts) {
    return null;
  }
  const formatter = Formatter$1.create(locale, formatOpts);
  const df = formatter.dtFormatter(getDummyDateTime$1());
  const parts = df.formatToParts();
  const resolvedOpts = df.resolvedOptions();
  return parts.map((p) => tokenForPart$1(p, formatOpts, resolvedOpts));
}
const INVALID$4 = "Invalid DateTime";
const MAX_DATE$1 = 864e13;
function unsupportedZone$1(zone) {
  return new Invalid$1("unsupported zone", `the zone "${zone.name}" is not supported`);
}
function possiblyCachedWeekData$1(dt) {
  if (dt.weekData === null) {
    dt.weekData = gregorianToWeek$1(dt.c);
  }
  return dt.weekData;
}
function possiblyCachedLocalWeekData$1(dt) {
  if (dt.localWeekData === null) {
    dt.localWeekData = gregorianToWeek$1(
      dt.c,
      dt.loc.getMinDaysInFirstWeek(),
      dt.loc.getStartOfWeek()
    );
  }
  return dt.localWeekData;
}
function clone$2(inst, alts) {
  const current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalid: inst.invalid
  };
  return new DateTime$1({ ...current, ...alts, old: current });
}
function fixOffset$1(localTS, o, tz) {
  let utcGuess = localTS - o * 60 * 1e3;
  const o2 = tz.offset(utcGuess);
  if (o === o2) {
    return [utcGuess, o];
  }
  utcGuess -= (o2 - o) * 60 * 1e3;
  const o3 = tz.offset(utcGuess);
  if (o2 === o3) {
    return [utcGuess, o2];
  }
  return [localTS - Math.min(o2, o3) * 60 * 1e3, Math.max(o2, o3)];
}
function tsToObj$1(ts, offset2) {
  ts += offset2 * 60 * 1e3;
  const d2 = new Date(ts);
  return {
    year: d2.getUTCFullYear(),
    month: d2.getUTCMonth() + 1,
    day: d2.getUTCDate(),
    hour: d2.getUTCHours(),
    minute: d2.getUTCMinutes(),
    second: d2.getUTCSeconds(),
    millisecond: d2.getUTCMilliseconds()
  };
}
function objToTS$1(obj, offset2, zone) {
  return fixOffset$1(objToLocalTS$3(obj), offset2, zone);
}
function adjustTime$1(inst, dur) {
  const oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c2 = {
    ...inst.c,
    year,
    month,
    day: Math.min(inst.c.day, daysInMonth$1(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
  }, millisToAdd = Duration$1.fromObject({
    years: dur.years - Math.trunc(dur.years),
    quarters: dur.quarters - Math.trunc(dur.quarters),
    months: dur.months - Math.trunc(dur.months),
    weeks: dur.weeks - Math.trunc(dur.weeks),
    days: dur.days - Math.trunc(dur.days),
    hours: dur.hours,
    minutes: dur.minutes,
    seconds: dur.seconds,
    milliseconds: dur.milliseconds
  }).as("milliseconds"), localTS = objToLocalTS$3(c2);
  let [ts, o] = fixOffset$1(localTS, oPre, inst.zone);
  if (millisToAdd !== 0) {
    ts += millisToAdd;
    o = inst.zone.offset(ts);
  }
  return { ts, o };
}
function parseDataToDateTime$1(parsed, parsedZone, opts, format, text, specificOffset) {
  const { setZone, zone } = opts;
  if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
    const interpretationZone = parsedZone || zone, inst = DateTime$1.fromObject(parsed, {
      ...opts,
      zone: interpretationZone,
      specificOffset
    });
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime$1.invalid(
      new Invalid$1("unparsable", `the input "${text}" can't be parsed as ${format}`)
    );
  }
}
function toTechFormat$1(dt, format, allowZ = true) {
  return dt.isValid ? Formatter$1.create(Locale$1.create("en-US"), {
    allowZ,
    forceSimple: true
  }).formatDateTimeFromString(dt, format) : null;
}
function toISODate$1(o, extended, precision) {
  const longFormat = o.c.year > 9999 || o.c.year < 0;
  let c2 = "";
  if (longFormat && o.c.year >= 0) c2 += "+";
  c2 += padStart$3(o.c.year, longFormat ? 6 : 4);
  if (precision === "year") return c2;
  if (extended) {
    c2 += "-";
    c2 += padStart$3(o.c.month);
    if (precision === "month") return c2;
    c2 += "-";
  } else {
    c2 += padStart$3(o.c.month);
    if (precision === "month") return c2;
  }
  c2 += padStart$3(o.c.day);
  return c2;
}
function toISOTime$1(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision) {
  let showSeconds = !suppressSeconds || o.c.millisecond !== 0 || o.c.second !== 0, c2 = "";
  switch (precision) {
    case "day":
    case "month":
    case "year":
      break;
    default:
      c2 += padStart$3(o.c.hour);
      if (precision === "hour") break;
      if (extended) {
        c2 += ":";
        c2 += padStart$3(o.c.minute);
        if (precision === "minute") break;
        if (showSeconds) {
          c2 += ":";
          c2 += padStart$3(o.c.second);
        }
      } else {
        c2 += padStart$3(o.c.minute);
        if (precision === "minute") break;
        if (showSeconds) {
          c2 += padStart$3(o.c.second);
        }
      }
      if (precision === "second") break;
      if (showSeconds && (!suppressMilliseconds || o.c.millisecond !== 0)) {
        c2 += ".";
        c2 += padStart$3(o.c.millisecond, 3);
      }
  }
  if (includeOffset) {
    if (o.isOffsetFixed && o.offset === 0 && !extendedZone) {
      c2 += "Z";
    } else if (o.o < 0) {
      c2 += "-";
      c2 += padStart$3(Math.trunc(-o.o / 60));
      c2 += ":";
      c2 += padStart$3(Math.trunc(-o.o % 60));
    } else {
      c2 += "+";
      c2 += padStart$3(Math.trunc(o.o / 60));
      c2 += ":";
      c2 += padStart$3(Math.trunc(o.o % 60));
    }
  }
  if (extendedZone) {
    c2 += "[" + o.zone.ianaName + "]";
  }
  return c2;
}
const defaultUnitValues$1 = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, defaultWeekUnitValues$1 = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, defaultOrdinalUnitValues$1 = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};
const orderedUnits$2 = ["year", "month", "day", "hour", "minute", "second", "millisecond"], orderedWeekUnits$1 = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], orderedOrdinalUnits$1 = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function normalizeUnit$1(unit) {
  const normalized = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[unit.toLowerCase()];
  if (!normalized) throw new InvalidUnitError$1(unit);
  return normalized;
}
function normalizeUnitWithLocalWeeks$1(unit) {
  switch (unit.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return normalizeUnit$1(unit);
  }
}
function guessOffsetForZone$1(zone) {
  if (zoneOffsetTs$1 === void 0) {
    zoneOffsetTs$1 = Settings$1.now();
  }
  if (zone.type !== "iana") {
    return zone.offset(zoneOffsetTs$1);
  }
  const zoneName = zone.name;
  let offsetGuess = zoneOffsetGuessCache$1.get(zoneName);
  if (offsetGuess === void 0) {
    offsetGuess = zone.offset(zoneOffsetTs$1);
    zoneOffsetGuessCache$1.set(zoneName, offsetGuess);
  }
  return offsetGuess;
}
function quickDT$1(obj, opts) {
  const zone = normalizeZone$1(opts.zone, Settings$1.defaultZone);
  if (!zone.isValid) {
    return DateTime$1.invalid(unsupportedZone$1(zone));
  }
  const loc = Locale$1.fromObject(opts);
  let ts, o;
  if (!isUndefined$3(obj.year)) {
    for (const u of orderedUnits$2) {
      if (isUndefined$3(obj[u])) {
        obj[u] = defaultUnitValues$1[u];
      }
    }
    const invalid2 = hasInvalidGregorianData$1(obj) || hasInvalidTimeData$1(obj);
    if (invalid2) {
      return DateTime$1.invalid(invalid2);
    }
    const offsetProvis = guessOffsetForZone$1(zone);
    [ts, o] = objToTS$1(obj, offsetProvis, zone);
  } else {
    ts = Settings$1.now();
  }
  return new DateTime$1({ ts, zone, loc, o });
}
function diffRelative$1(start, end, opts) {
  const round2 = isUndefined$3(opts.round) ? true : opts.round, rounding = isUndefined$3(opts.rounding) ? "trunc" : opts.rounding, format = (c2, unit) => {
    c2 = roundTo$1(c2, round2 || opts.calendary ? 0 : 2, opts.calendary ? "round" : rounding);
    const formatter = end.loc.clone(opts).relFormatter(opts);
    return formatter.format(c2, unit);
  }, differ = (unit) => {
    if (opts.calendary) {
      if (!end.hasSame(start, unit)) {
        return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
      } else return 0;
    } else {
      return end.diff(start, unit).get(unit);
    }
  };
  if (opts.unit) {
    return format(differ(opts.unit), opts.unit);
  }
  for (const unit of opts.units) {
    const count = differ(unit);
    if (Math.abs(count) >= 1) {
      return format(count, unit);
    }
  }
  return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function lastOpts$1(argList) {
  let opts = {}, args2;
  if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
    opts = argList[argList.length - 1];
    args2 = Array.from(argList).slice(0, argList.length - 1);
  } else {
    args2 = Array.from(argList);
  }
  return [opts, args2];
}
let zoneOffsetTs$1;
const zoneOffsetGuessCache$1 = /* @__PURE__ */ new Map();
let DateTime$1 = class DateTime2 {
  /**
   * @access private
   */
  constructor(config) {
    const zone = config.zone || Settings$1.defaultZone;
    let invalid2 = config.invalid || (Number.isNaN(config.ts) ? new Invalid$1("invalid input") : null) || (!zone.isValid ? unsupportedZone$1(zone) : null);
    this.ts = isUndefined$3(config.ts) ? Settings$1.now() : config.ts;
    let c2 = null, o = null;
    if (!invalid2) {
      const unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
      if (unchanged) {
        [c2, o] = [config.old.c, config.old.o];
      } else {
        const ot = isNumber$2(config.o) && !config.old ? config.o : zone.offset(this.ts);
        c2 = tsToObj$1(this.ts, ot);
        invalid2 = Number.isNaN(c2.year) ? new Invalid$1("invalid input") : null;
        c2 = invalid2 ? null : c2;
        o = invalid2 ? null : ot;
      }
    }
    this._zone = zone;
    this.loc = config.loc || Locale$1.create();
    this.invalid = invalid2;
    this.weekData = null;
    this.localWeekData = null;
    this.c = c2;
    this.o = o;
    this.isLuxonDateTime = true;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new DateTime2({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [opts, args2] = lastOpts$1(arguments), [year, month, day, hour, minute, second, millisecond] = args2;
    return quickDT$1({ year, month, day, hour, minute, second, millisecond }, opts);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [opts, args2] = lastOpts$1(arguments), [year, month, day, hour, minute, second, millisecond] = args2;
    opts.zone = FixedOffsetZone$3.utcInstance;
    return quickDT$1({ year, month, day, hour, minute, second, millisecond }, opts);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(date, options = {}) {
    const ts = isDate$1(date) ? date.valueOf() : NaN;
    if (Number.isNaN(ts)) {
      return DateTime2.invalid("invalid input");
    }
    const zoneToUse = normalizeZone$1(options.zone, Settings$1.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime2.invalid(unsupportedZone$1(zoneToUse));
    }
    return new DateTime2({
      ts,
      zone: zoneToUse,
      loc: Locale$1.fromObject(options)
    });
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(milliseconds, options = {}) {
    if (!isNumber$2(milliseconds)) {
      throw new InvalidArgumentError$1(
        `fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`
      );
    } else if (milliseconds < -MAX_DATE$1 || milliseconds > MAX_DATE$1) {
      return DateTime2.invalid("Timestamp out of range");
    } else {
      return new DateTime2({
        ts: milliseconds,
        zone: normalizeZone$1(options.zone, Settings$1.defaultZone),
        loc: Locale$1.fromObject(options)
      });
    }
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(seconds, options = {}) {
    if (!isNumber$2(seconds)) {
      throw new InvalidArgumentError$1("fromSeconds requires a numerical input");
    } else {
      return new DateTime2({
        ts: seconds * 1e3,
        zone: normalizeZone$1(options.zone, Settings$1.defaultZone),
        loc: Locale$1.fromObject(options)
      });
    }
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(obj, opts = {}) {
    obj = obj || {};
    const zoneToUse = normalizeZone$1(opts.zone, Settings$1.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime2.invalid(unsupportedZone$1(zoneToUse));
    }
    const loc = Locale$1.fromObject(opts);
    const normalized = normalizeObject$1(obj, normalizeUnitWithLocalWeeks$1);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues$1(normalized, loc);
    const tsNow = Settings$1.now(), offsetProvis = !isUndefined$3(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !isUndefined$3(normalized.ordinal), containsGregorYear = !isUndefined$3(normalized.year), containsGregorMD = !isUndefined$3(normalized.month) || !isUndefined$3(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError$1(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError$1("Can't mix ordinal dates with month/day");
    }
    const useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
    let units, defaultValues, objNow = tsToObj$1(tsNow, offsetProvis);
    if (useWeekData) {
      units = orderedWeekUnits$1;
      defaultValues = defaultWeekUnitValues$1;
      objNow = gregorianToWeek$1(objNow, minDaysInFirstWeek, startOfWeek);
    } else if (containsOrdinal) {
      units = orderedOrdinalUnits$1;
      defaultValues = defaultOrdinalUnitValues$1;
      objNow = gregorianToOrdinal$1(objNow);
    } else {
      units = orderedUnits$2;
      defaultValues = defaultUnitValues$1;
    }
    let foundFirst = false;
    for (const u of units) {
      const v = normalized[u];
      if (!isUndefined$3(v)) {
        foundFirst = true;
      } else if (foundFirst) {
        normalized[u] = defaultValues[u];
      } else {
        normalized[u] = objNow[u];
      }
    }
    const higherOrderInvalid = useWeekData ? hasInvalidWeekData$1(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? hasInvalidOrdinalData$1(normalized) : hasInvalidGregorianData$1(normalized), invalid2 = higherOrderInvalid || hasInvalidTimeData$1(normalized);
    if (invalid2) {
      return DateTime2.invalid(invalid2);
    }
    const gregorian = useWeekData ? weekToGregorian$1(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? ordinalToGregorian$1(normalized) : normalized, [tsFinal, offsetFinal] = objToTS$1(gregorian, offsetProvis, zoneToUse), inst = new DateTime2({
      ts: tsFinal,
      zone: zoneToUse,
      o: offsetFinal,
      loc
    });
    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
      return DateTime2.invalid(
        "mismatched weekday",
        `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`
      );
    }
    if (!inst.isValid) {
      return DateTime2.invalid(inst.invalid);
    }
    return inst;
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(text, opts = {}) {
    const [vals, parsedZone] = parseISODate$1(text);
    return parseDataToDateTime$1(vals, parsedZone, opts, "ISO 8601", text);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(text, opts = {}) {
    const [vals, parsedZone] = parseRFC2822Date$1(text);
    return parseDataToDateTime$1(vals, parsedZone, opts, "RFC 2822", text);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(text, opts = {}) {
    const [vals, parsedZone] = parseHTTPDate$1(text);
    return parseDataToDateTime$1(vals, parsedZone, opts, "HTTP", opts);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(text, fmt, opts = {}) {
    if (isUndefined$3(text) || isUndefined$3(fmt)) {
      throw new InvalidArgumentError$1("fromFormat requires an input string and a format");
    }
    const { locale = null, numberingSystem = null } = opts, localeToUse = Locale$1.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    }), [vals, parsedZone, specificOffset, invalid2] = parseFromTokens$1(localeToUse, text, fmt);
    if (invalid2) {
      return DateTime2.invalid(invalid2);
    } else {
      return parseDataToDateTime$1(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
    }
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(text, fmt, opts = {}) {
    return DateTime2.fromFormat(text, fmt, opts);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(text, opts = {}) {
    const [vals, parsedZone] = parseSQL$1(text);
    return parseDataToDateTime$1(vals, parsedZone, opts, "SQL", text);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError$1("need to specify a reason the DateTime is invalid");
    }
    const invalid2 = reason instanceof Invalid$1 ? reason : new Invalid$1(reason, explanation);
    if (Settings$1.throwOnInvalid) {
      throw new InvalidDateTimeError$1(invalid2);
    } else {
      return new DateTime2({ invalid: invalid2 });
    }
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(o) {
    return o && o.isLuxonDateTime || false;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(formatOpts, localeOpts = {}) {
    const tokenList = formatOptsToTokens$1(formatOpts, Locale$1.fromObject(localeOpts));
    return !tokenList ? null : tokenList.map((t) => t ? t.val : null).join("");
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(fmt, localeOpts = {}) {
    const expanded = expandMacroTokens$1(Formatter$1.parseFormat(fmt), Locale$1.fromObject(localeOpts));
    return expanded.map((t) => t.val).join("");
  }
  static resetCache() {
    zoneOffsetTs$1 = void 0;
    zoneOffsetGuessCache$1.clear();
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(unit) {
    return this[unit];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? possiblyCachedWeekData$1(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? possiblyCachedWeekData$1(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? possiblyCachedWeekData$1(this).weekday : NaN;
  }
  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? possiblyCachedLocalWeekData$1(this).weekday : NaN;
  }
  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? possiblyCachedLocalWeekData$1(this).weekNumber : NaN;
  }
  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? possiblyCachedLocalWeekData$1(this).weekYear : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? gregorianToOrdinal$1(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? Info$1.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? Info$1.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? Info$1.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? Info$1.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "short",
        locale: this.locale
      });
    } else {
      return null;
    }
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "long",
        locale: this.locale
      });
    } else {
      return null;
    }
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    if (this.isOffsetFixed) {
      return false;
    } else {
      return this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
    }
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed) {
      return [this];
    }
    const dayMs = 864e5;
    const minuteMs = 6e4;
    const localTS = objToLocalTS$3(this.c);
    const oEarlier = this.zone.offset(localTS - dayMs);
    const oLater = this.zone.offset(localTS + dayMs);
    const o1 = this.zone.offset(localTS - oEarlier * minuteMs);
    const o2 = this.zone.offset(localTS - oLater * minuteMs);
    if (o1 === o2) {
      return [this];
    }
    const ts1 = localTS - o1 * minuteMs;
    const ts2 = localTS - o2 * minuteMs;
    const c1 = tsToObj$1(ts1, o1);
    const c2 = tsToObj$1(ts2, o2);
    if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) {
      return [clone$2(this, { ts: ts1 }), clone$2(this, { ts: ts2 })];
    }
    return [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return isLeapYear$1(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return daysInMonth$1(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? daysInYear$1(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? weeksInWeekYear$1(this.weekYear) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? weeksInWeekYear$1(
      this.localWeekYear,
      this.loc.getMinDaysInFirstWeek(),
      this.loc.getStartOfWeek()
    ) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(opts = {}) {
    const { locale, numberingSystem, calendar } = Formatter$1.create(
      this.loc.clone(opts),
      opts
    ).resolvedOptions(this);
    return { locale, numberingSystem, outputCalendar: calendar };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(offset2 = 0, opts = {}) {
    return this.setZone(FixedOffsetZone$3.instance(offset2), opts);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(Settings$1.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(zone, { keepLocalTime = false, keepCalendarTime = false } = {}) {
    zone = normalizeZone$1(zone, Settings$1.defaultZone);
    if (zone.equals(this.zone)) {
      return this;
    } else if (!zone.isValid) {
      return DateTime2.invalid(unsupportedZone$1(zone));
    } else {
      let newTS = this.ts;
      if (keepLocalTime || keepCalendarTime) {
        const offsetGuess = zone.offset(this.ts);
        const asObj = this.toObject();
        [newTS] = objToTS$1(asObj, offsetGuess, zone);
      }
      return clone$2(this, { ts: newTS, zone });
    }
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale, numberingSystem, outputCalendar } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem, outputCalendar });
    return clone$2(this, { loc });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(locale) {
    return this.reconfigure({ locale });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(values) {
    if (!this.isValid) return this;
    const normalized = normalizeObject$1(values, normalizeUnitWithLocalWeeks$1);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues$1(normalized, this.loc);
    const settingWeekStuff = !isUndefined$3(normalized.weekYear) || !isUndefined$3(normalized.weekNumber) || !isUndefined$3(normalized.weekday), containsOrdinal = !isUndefined$3(normalized.ordinal), containsGregorYear = !isUndefined$3(normalized.year), containsGregorMD = !isUndefined$3(normalized.month) || !isUndefined$3(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError$1(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError$1("Can't mix ordinal dates with month/day");
    }
    let mixed;
    if (settingWeekStuff) {
      mixed = weekToGregorian$1(
        { ...gregorianToWeek$1(this.c, minDaysInFirstWeek, startOfWeek), ...normalized },
        minDaysInFirstWeek,
        startOfWeek
      );
    } else if (!isUndefined$3(normalized.ordinal)) {
      mixed = ordinalToGregorian$1({ ...gregorianToOrdinal$1(this.c), ...normalized });
    } else {
      mixed = { ...this.toObject(), ...normalized };
      if (isUndefined$3(normalized.day)) {
        mixed.day = Math.min(daysInMonth$1(mixed.year, mixed.month), mixed.day);
      }
    }
    const [ts, o] = objToTS$1(mixed, this.o, this.zone);
    return clone$2(this, { ts, o });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(duration) {
    if (!this.isValid) return this;
    const dur = Duration$1.fromDurationLike(duration);
    return clone$2(this, adjustTime$1(this, dur));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(duration) {
    if (!this.isValid) return this;
    const dur = Duration$1.fromDurationLike(duration).negate();
    return clone$2(this, adjustTime$1(this, dur));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(unit, { useLocaleWeeks = false } = {}) {
    if (!this.isValid) return this;
    const o = {}, normalizedUnit = Duration$1.normalizeUnit(unit);
    switch (normalizedUnit) {
      case "years":
        o.month = 1;
      // falls through
      case "quarters":
      case "months":
        o.day = 1;
      // falls through
      case "weeks":
      case "days":
        o.hour = 0;
      // falls through
      case "hours":
        o.minute = 0;
      // falls through
      case "minutes":
        o.second = 0;
      // falls through
      case "seconds":
        o.millisecond = 0;
        break;
    }
    if (normalizedUnit === "weeks") {
      if (useLocaleWeeks) {
        const startOfWeek = this.loc.getStartOfWeek();
        const { weekday } = this;
        if (weekday < startOfWeek) {
          o.weekNumber = this.weekNumber - 1;
        }
        o.weekday = startOfWeek;
      } else {
        o.weekday = 1;
      }
    }
    if (normalizedUnit === "quarters") {
      const q = Math.ceil(this.month / 3);
      o.month = (q - 1) * 3 + 1;
    }
    return this.set(o);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(unit, opts) {
    return this.isValid ? this.plus({ [unit]: 1 }).startOf(unit, opts).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    return this.isValid ? Formatter$1.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID$4;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(formatOpts = DATE_SHORT$1, opts = {}) {
    return this.isValid ? Formatter$1.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : INVALID$4;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(opts = {}) {
    return this.isValid ? Formatter$1.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'years', 'months', 'days', 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @example DateTime.now().toISO({ precision: 'day' }) //=> '2017-04-22Z'
   * @example DateTime.now().toISO({ precision: 'minute' }) //=> '2017-04-22T20:47Z'
   * @return {string|null}
   */
  toISO({
    format = "extended",
    suppressSeconds = false,
    suppressMilliseconds = false,
    includeOffset = true,
    extendedZone = false,
    precision = "milliseconds"
  } = {}) {
    if (!this.isValid) {
      return null;
    }
    precision = normalizeUnit$1(precision);
    const ext = format === "extended";
    let c2 = toISODate$1(this, ext, precision);
    if (orderedUnits$2.indexOf(precision) >= 3) c2 += "T";
    c2 += toISOTime$1(
      this,
      ext,
      suppressSeconds,
      suppressMilliseconds,
      includeOffset,
      extendedZone,
      precision
    );
    return c2;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='day'] - truncate output to desired precision: 'years', 'months', or 'days'.
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @example DateTime.utc(1982, 5, 25).toISODate({ precision: 'month' }) //=> '1982-05'
   * @return {string|null}
   */
  toISODate({ format = "extended", precision = "day" } = {}) {
    if (!this.isValid) {
      return null;
    }
    return toISODate$1(this, format === "extended", normalizeUnit$1(precision));
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return toTechFormat$1(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, second: 56 }).toISOTime({ precision: 'minute' }) //=> '07:34Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds = false,
    suppressSeconds = false,
    includeOffset = true,
    includePrefix = false,
    extendedZone = false,
    format = "extended",
    precision = "milliseconds"
  } = {}) {
    if (!this.isValid) {
      return null;
    }
    precision = normalizeUnit$1(precision);
    let c2 = includePrefix && orderedUnits$2.indexOf(precision) >= 3 ? "T" : "";
    return c2 + toISOTime$1(
      this,
      format === "extended",
      suppressSeconds,
      suppressMilliseconds,
      includeOffset,
      extendedZone,
      precision
    );
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return toTechFormat$1(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return toTechFormat$1(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string|null}
   */
  toSQLDate() {
    if (!this.isValid) {
      return null;
    }
    return toISODate$1(this, true);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset = true, includeZone = false, includeOffsetSpace = true } = {}) {
    let fmt = "HH:mm:ss.SSS";
    if (includeZone || includeOffset) {
      if (includeOffsetSpace) {
        fmt += " ";
      }
      if (includeZone) {
        fmt += "z";
      } else if (includeOffset) {
        fmt += "ZZ";
      }
    }
    return toTechFormat$1(this, fmt, true);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(opts = {}) {
    if (!this.isValid) {
      return null;
    }
    return `${this.toSQLDate()} ${this.toSQLTime(opts)}`;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : INVALID$4;
  }
  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }`;
    } else {
      return `DateTime { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds (including milliseconds in the fractional part) of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(opts = {}) {
    if (!this.isValid) return {};
    const base = { ...this.c };
    if (opts.includeConfig) {
      base.outputCalendar = this.outputCalendar;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }
    return base;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(otherDateTime, unit = "milliseconds", opts = {}) {
    if (!this.isValid || !otherDateTime.isValid) {
      return Duration$1.invalid("created by diffing an invalid DateTime");
    }
    const durOpts = { locale: this.locale, numberingSystem: this.numberingSystem, ...opts };
    const units = maybeArray$1(unit).map(Duration$1.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = diff(earlier, later, units, durOpts);
    return otherIsLater ? diffed.negate() : diffed;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(unit = "milliseconds", opts = {}) {
    return this.diff(DateTime2.now(), unit, opts);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval|DateTime}
   */
  until(otherDateTime) {
    return this.isValid ? Interval$1.fromDateTimes(this, otherDateTime) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(otherDateTime, unit, opts) {
    if (!this.isValid) return false;
    const inputMs = otherDateTime.valueOf();
    const adjustedToZone = this.setZone(otherDateTime.zone, { keepLocalTime: true });
    return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(other) {
    return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds towards zero by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {string} [options.rounding="trunc"] - rounding method to use when rounding the numbers in the output. Can be "trunc" (toward zero), "expand" (away from zero), "round", "floor", or "ceil".
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(options = {}) {
    if (!this.isValid) return null;
    const base = options.base || DateTime2.fromObject({}, { zone: this.zone }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
    let units = ["years", "months", "days", "hours", "minutes", "seconds"];
    let unit = options.unit;
    if (Array.isArray(options.unit)) {
      units = options.unit;
      unit = void 0;
    }
    return diffRelative$1(base, this.plus(padding), {
      ...options,
      numeric: "always",
      units,
      unit
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(options = {}) {
    if (!this.isValid) return null;
    return diffRelative$1(options.base || DateTime2.fromObject({}, { zone: this.zone }), this, {
      ...options,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: true
    });
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...dateTimes) {
    if (!dateTimes.every(DateTime2.isDateTime)) {
      throw new InvalidArgumentError$1("min requires all arguments be DateTimes");
    }
    return bestBy$1(dateTimes, (i2) => i2.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...dateTimes) {
    if (!dateTimes.every(DateTime2.isDateTime)) {
      throw new InvalidArgumentError$1("max requires all arguments be DateTimes");
    }
    return bestBy$1(dateTimes, (i2) => i2.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(text, fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options, localeToUse = Locale$1.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    return explainFromTokens$1(localeToUse, text, fmt);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(text, fmt, options = {}) {
    return DateTime2.fromFormatExplain(text, fmt, options);
  }
  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */
  static buildFormatParser(fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options, localeToUse = Locale$1.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    return new TokenParser$1(localeToUse, fmt);
  }
  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */
  static fromFormatParser(text, formatParser, opts = {}) {
    if (isUndefined$3(text) || isUndefined$3(formatParser)) {
      throw new InvalidArgumentError$1(
        "fromFormatParser requires an input string and a format parser"
      );
    }
    const { locale = null, numberingSystem = null } = opts, localeToUse = Locale$1.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    if (!localeToUse.equals(formatParser.locale)) {
      throw new InvalidArgumentError$1(
        `fromFormatParser called with a locale of ${localeToUse}, but the format parser was created for ${formatParser.locale}`
      );
    }
    const { result, zone, specificOffset, invalidReason } = formatParser.explainFromTokens(text);
    if (invalidReason) {
      return DateTime2.invalid(invalidReason);
    } else {
      return parseDataToDateTime$1(
        result,
        zone,
        opts,
        `format ${formatParser.format}`,
        text,
        specificOffset
      );
    }
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return DATE_SHORT$1;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return DATE_MED$1;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return DATE_MED_WITH_WEEKDAY$1;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return DATE_FULL$1;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return DATE_HUGE$1;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return TIME_SIMPLE$1;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return TIME_WITH_SECONDS$1;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return TIME_WITH_SHORT_OFFSET$1;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return TIME_WITH_LONG_OFFSET$1;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return TIME_24_SIMPLE$1;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return TIME_24_WITH_SECONDS$1;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return TIME_24_WITH_SHORT_OFFSET$1;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return TIME_24_WITH_LONG_OFFSET$1;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return DATETIME_SHORT$1;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return DATETIME_SHORT_WITH_SECONDS$1;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return DATETIME_MED$1;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return DATETIME_MED_WITH_SECONDS$1;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return DATETIME_MED_WITH_WEEKDAY$1;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return DATETIME_FULL$1;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return DATETIME_FULL_WITH_SECONDS$1;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return DATETIME_HUGE$1;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return DATETIME_HUGE_WITH_SECONDS$1;
  }
};
function friendlyDateTime$1(dateTimeish) {
  if (DateTime$1.isDateTime(dateTimeish)) {
    return dateTimeish;
  } else if (dateTimeish && dateTimeish.valueOf && isNumber$2(dateTimeish.valueOf())) {
    return DateTime$1.fromJSDate(dateTimeish);
  } else if (dateTimeish && typeof dateTimeish === "object") {
    return DateTime$1.fromObject(dateTimeish);
  } else {
    throw new InvalidArgumentError$1(
      `Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`
    );
  }
}
const ENCODE_METHOD = Symbol.for("@nhtio/encoder:toEncoded");
const DECODE_METHOD = Symbol.for("@nhtio/encoder:fromEncoded");
var __create = Object.create, __defProp = Object.defineProperty, __getOwnPropDesc = Object.getOwnPropertyDescriptor, __getOwnPropNames = Object.getOwnPropertyNames, __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty, __esmMin = (fn$1, res) => () => (fn$1 && (res = fn$1(fn$1 = 0)), res), __commonJSMin$1 = (cb, mod) => () => (mod || cb((mod = { exports: {} }).exports, mod), mod.exports), __export = (target, all$1) => {
  for (var name$2 in all$1) __defProp(target, name$2, { get: all$1[name$2], enumerable: true });
}, __copyProps = (to, from$2, except, desc$1) => {
  if (from$2 && typeof from$2 == `object` || typeof from$2 == `function`) for (var keys$10 = __getOwnPropNames(from$2), i$4 = 0, n$4 = keys$10.length, key; i$4 < n$4; i$4++) key = keys$10[i$4], !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: ((k) => from$2[k]).bind(null, key), enumerable: !(desc$1 = __getOwnPropDesc(from$2, key)) || desc$1.enumerable });
  return to;
}, __toESM = (mod, isNodeMode, target) => (target = mod == null ? {} : __create(__getProtoOf(mod)), __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, `default`, { value: mod, enumerable: true }) : target, mod)), __toCommonJS = (mod) => __copyProps(__defProp({}, `__esModule`, { value: true }), mod), __require$1 = ((x$1) => typeof require < `u` ? require : typeof Proxy < `u` ? new Proxy(x$1, { get: (a$22, b2) => (typeof require < `u` ? require : a$22)[b2] }) : x$1)(function(x$1) {
  if (typeof require < `u`) return require.apply(this, arguments);
  throw Error('Calling `require` for "' + x$1 + "\" in an environment that doesn't expose the `require` function.");
}), require_assertError = __commonJSMin$1((exports$12, module2) => {
  module2.exports = class extends Error {
    name = `AssertError`;
    constructor(message, ctor) {
      super(message || `Unknown error`), typeof Error.captureStackTrace == `function` && Error.captureStackTrace(this, ctor);
    }
  };
}), require_stringify = __commonJSMin$1((exports$12, module2) => {
  module2.exports = function(...args$1) {
    try {
      return JSON.stringify(...args$1);
    } catch (err$1) {
      return `[Cannot display object: ` + err$1.message + `]`;
    }
  };
}), require_assert$1 = __commonJSMin$1((exports$12, module2) => {
  let AssertError$2 = require_assertError(), Stringify = require_stringify(), assert$53 = module2.exports = function(condition, ...args$1) {
    if (condition) return;
    if (args$1.length === 1 && args$1[0] instanceof Error) throw args$1[0];
    let msgs = args$1.filter((arg) => arg !== ``).map((arg) => typeof arg == `string` ? arg : arg instanceof Error ? arg.message : Stringify(arg));
    throw new AssertError$2(msgs.join(` `), assert$53);
  };
}), dist_exports = {};
__export(dist_exports, { Blob: () => Blob$1, BlobOptions: () => BlobOptions, Buffer: () => Buffer$1$1, File: () => File, FileOptions: () => FileOptions, INSPECT_MAX_BYTES: () => INSPECT_MAX_BYTES, SlowBuffer: () => SlowBuffer, TranscodeEncoding: () => TranscodeEncoding, atob: () => atob$1, btoa: () => btoa$1, constants: () => constants$3, default: () => Buffer$1, isAscii: () => isAscii, isUtf8: () => isUtf8, kMaxLength: () => kMaxLength, kStringMaxLength: () => kStringMaxLength, resolveObjectURL: () => resolveObjectURL, transcode: () => transcode });
function getLens$1(b64) {
  var len$2 = b64.length;
  if (len$2 % 4 > 0) throw Error(`Invalid string. Length must be a multiple of 4`);
  var validLen = b64.indexOf(`=`);
  validLen === -1 && (validLen = len$2);
  var placeHoldersLen = validLen === len$2 ? 0 : 4 - validLen % 4;
  return [validLen, placeHoldersLen];
}
function byteLength$1(b64) {
  var lens = getLens$1(b64), validLen = lens[0], placeHoldersLen = lens[1];
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength$1(b64, validLen, placeHoldersLen) {
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray$1(b64) {
  var tmp, lens = getLens$1(b64), validLen = lens[0], placeHoldersLen = lens[1], arr = new Arr$1(_byteLength$1(b64, validLen, placeHoldersLen)), curByte = 0, len$2 = placeHoldersLen > 0 ? validLen - 4 : validLen, i$4;
  for (i$4 = 0; i$4 < len$2; i$4 += 4) tmp = revLookup$1[b64.charCodeAt(i$4)] << 18 | revLookup$1[b64.charCodeAt(i$4 + 1)] << 12 | revLookup$1[b64.charCodeAt(i$4 + 2)] << 6 | revLookup$1[b64.charCodeAt(i$4 + 3)], arr[curByte++] = tmp >> 16 & 255, arr[curByte++] = tmp >> 8 & 255, arr[curByte++] = tmp & 255;
  return placeHoldersLen === 2 && (tmp = revLookup$1[b64.charCodeAt(i$4)] << 2 | revLookup$1[b64.charCodeAt(i$4 + 1)] >> 4, arr[curByte++] = tmp & 255), placeHoldersLen === 1 && (tmp = revLookup$1[b64.charCodeAt(i$4)] << 10 | revLookup$1[b64.charCodeAt(i$4 + 1)] << 4 | revLookup$1[b64.charCodeAt(i$4 + 2)] >> 2, arr[curByte++] = tmp >> 8 & 255, arr[curByte++] = tmp & 255), arr;
}
function tripletToBase64$1(num) {
  return lookup$1[num >> 18 & 63] + lookup$1[num >> 12 & 63] + lookup$1[num >> 6 & 63] + lookup$1[num & 63];
}
function encodeChunk$1(uint8, start, end) {
  for (var tmp, output = [], i$4 = start; i$4 < end; i$4 += 3) tmp = (uint8[i$4] << 16 & 16711680) + (uint8[i$4 + 1] << 8 & 65280) + (uint8[i$4 + 2] & 255), output.push(tripletToBase64$1(tmp));
  return output.join(``);
}
function fromByteArray$1(uint8) {
  for (var tmp, len$2 = uint8.length, extraBytes = len$2 % 3, parts = [], maxChunkLength = 16383, i$4 = 0, len2 = len$2 - extraBytes; i$4 < len2; i$4 += maxChunkLength) parts.push(encodeChunk$1(uint8, i$4, i$4 + maxChunkLength > len2 ? len2 : i$4 + maxChunkLength));
  return extraBytes === 1 ? (tmp = uint8[len$2 - 1], parts.push(lookup$1[tmp >> 2] + lookup$1[tmp << 4 & 63] + `==`)) : extraBytes === 2 && (tmp = (uint8[len$2 - 2] << 8) + uint8[len$2 - 1], parts.push(lookup$1[tmp >> 10] + lookup$1[tmp >> 4 & 63] + lookup$1[tmp << 2 & 63] + `=`)), parts.join(``);
}
var buffer$2, base64Js$1, lookup$1, revLookup$1, Arr$1, code$1, ieee754$1, Buffer$1, Blob$1, BlobOptions, Buffer$1$1, File, FileOptions, INSPECT_MAX_BYTES, SlowBuffer, TranscodeEncoding, atob$1, btoa$1, constants$3, isAscii, isUtf8, kMaxLength, kStringMaxLength, resolveObjectURL, transcode, init_dist$1 = __esmMin(() => {
  buffer$2 = {}, base64Js$1 = {}, base64Js$1.byteLength = byteLength$1, base64Js$1.toByteArray = toByteArray$1, base64Js$1.fromByteArray = fromByteArray$1, lookup$1 = [], revLookup$1 = [], Arr$1 = typeof Uint8Array < `u` ? Uint8Array : Array, code$1 = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/`;
  for (var i$3 = 0, len$1 = code$1.length; i$3 < len$1; ++i$3) lookup$1[i$3] = code$1[i$3], revLookup$1[code$1.charCodeAt(i$3)] = i$3;
  revLookup$1[45] = 62, revLookup$1[95] = 63, ieee754$1 = {}, ieee754$1.read = function(buffer$3, offset$2, isLE, mLen, nBytes) {
    var e$22, m$3, eLen = nBytes * 8 - mLen - 1, eMax = (1 << eLen) - 1, eBias = eMax >> 1, nBits = -7, i$4 = isLE ? nBytes - 1 : 0, d$12 = isLE ? -1 : 1, s$6 = buffer$3[offset$2 + i$4];
    for (i$4 += d$12, e$22 = s$6 & (1 << -nBits) - 1, s$6 >>= -nBits, nBits += eLen; nBits > 0; e$22 = e$22 * 256 + buffer$3[offset$2 + i$4], i$4 += d$12, nBits -= 8) ;
    for (m$3 = e$22 & (1 << -nBits) - 1, e$22 >>= -nBits, nBits += mLen; nBits > 0; m$3 = m$3 * 256 + buffer$3[offset$2 + i$4], i$4 += d$12, nBits -= 8) ;
    if (e$22 === 0) e$22 = 1 - eBias;
    else if (e$22 === eMax) return m$3 ? NaN : (s$6 ? -1 : 1) * (1 / 0);
    else m$3 += 2 ** mLen, e$22 -= eBias;
    return (s$6 ? -1 : 1) * m$3 * 2 ** (e$22 - mLen);
  }, ieee754$1.write = function(buffer$3, value, offset$2, isLE, mLen, nBytes) {
    var e$22, m$3, c$12, eLen = nBytes * 8 - mLen - 1, eMax = (1 << eLen) - 1, eBias = eMax >> 1, rt = mLen === 23 ? 2 ** -24 - 2 ** -77 : 0, i$4 = isLE ? 0 : nBytes - 1, d$12 = isLE ? 1 : -1, s$6 = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    for (value = Math.abs(value), isNaN(value) || value === 1 / 0 ? (m$3 = isNaN(value) ? 1 : 0, e$22 = eMax) : (e$22 = Math.floor(Math.log(value) / Math.LN2), value * (c$12 = 2 ** -e$22) < 1 && (e$22--, c$12 *= 2), e$22 + eBias >= 1 ? value += rt / c$12 : value += rt * 2 ** (1 - eBias), value * c$12 >= 2 && (e$22++, c$12 /= 2), e$22 + eBias >= eMax ? (m$3 = 0, e$22 = eMax) : e$22 + eBias >= 1 ? (m$3 = (value * c$12 - 1) * 2 ** mLen, e$22 += eBias) : (m$3 = value * 2 ** (eBias - 1) * 2 ** mLen, e$22 = 0)); mLen >= 8; buffer$3[offset$2 + i$4] = m$3 & 255, i$4 += d$12, m$3 /= 256, mLen -= 8) ;
    for (e$22 = e$22 << mLen | m$3, eLen += mLen; eLen > 0; buffer$3[offset$2 + i$4] = e$22 & 255, i$4 += d$12, e$22 /= 256, eLen -= 8) ;
    buffer$3[offset$2 + i$4 - d$12] |= s$6 * 128;
  }, (function(exports$12) {
    let base64 = base64Js$1, ieee754$1$1 = ieee754$1, customInspectSymbol = typeof Symbol == `function` && typeof Symbol.for == `function` ? Symbol.for(`nodejs.util.inspect.custom`) : null;
    exports$12.Buffer = Buffer$27, exports$12.SlowBuffer = SlowBuffer$1, exports$12.INSPECT_MAX_BYTES = 50;
    let K_MAX_LENGTH = 2147483647;
    exports$12.kMaxLength = K_MAX_LENGTH;
    let { Uint8Array: GlobalUint8Array, ArrayBuffer: GlobalArrayBuffer, SharedArrayBuffer: GlobalSharedArrayBuffer } = globalThis;
    Buffer$27.TYPED_ARRAY_SUPPORT = typedArraySupport(), !Buffer$27.TYPED_ARRAY_SUPPORT && typeof console < `u` && typeof console.error == `function` && console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
    function typedArraySupport() {
      try {
        let arr = new GlobalUint8Array(1), proto = { foo: function() {
          return 42;
        } };
        return Object.setPrototypeOf(proto, GlobalUint8Array.prototype), Object.setPrototypeOf(arr, proto), arr.foo() === 42;
      } catch {
        return false;
      }
    }
    Object.defineProperty(Buffer$27.prototype, `parent`, { enumerable: true, get: function() {
      if (Buffer$27.isBuffer(this)) return this.buffer;
    } }), Object.defineProperty(Buffer$27.prototype, `offset`, { enumerable: true, get: function() {
      if (Buffer$27.isBuffer(this)) return this.byteOffset;
    } });
    function createBuffer(length) {
      if (length > K_MAX_LENGTH) throw RangeError(`The value "` + length + `" is invalid for option "size"`);
      let buf = new GlobalUint8Array(length);
      return Object.setPrototypeOf(buf, Buffer$27.prototype), buf;
    }
    function Buffer$27(arg, encodingOrOffset, length) {
      if (typeof arg == `number`) {
        if (typeof encodingOrOffset == `string`) throw TypeError(`The "string" argument must be of type string. Received type number`);
        return allocUnsafe$1(arg);
      }
      return from$2(arg, encodingOrOffset, length);
    }
    Buffer$27.poolSize = 8192;
    function from$2(value, encodingOrOffset, length) {
      if (typeof value == `string`) return fromString(value, encodingOrOffset);
      if (GlobalArrayBuffer.isView(value)) return fromArrayView(value);
      if (value == null) throw TypeError(`The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ` + typeof value);
      if (isInstance(value, GlobalArrayBuffer) || value && isInstance(value.buffer, GlobalArrayBuffer) || GlobalSharedArrayBuffer !== void 0 && (isInstance(value, GlobalSharedArrayBuffer) || value && isInstance(value.buffer, GlobalSharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
      if (typeof value == `number`) throw TypeError(`The "value" argument must not be of type number. Received type number`);
      let valueOf = value.valueOf && value.valueOf();
      if (valueOf != null && valueOf !== value) return Buffer$27.from(valueOf, encodingOrOffset, length);
      let b2 = fromObject(value);
      if (b2) return b2;
      if (typeof Symbol < `u` && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] == `function`) return Buffer$27.from(value[Symbol.toPrimitive](`string`), encodingOrOffset, length);
      throw TypeError(`The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ` + typeof value);
    }
    Buffer$27.from = function(value, encodingOrOffset, length) {
      return from$2(value, encodingOrOffset, length);
    }, Object.setPrototypeOf(Buffer$27.prototype, GlobalUint8Array.prototype), Object.setPrototypeOf(Buffer$27, GlobalUint8Array);
    function assertSize$1(size) {
      if (typeof size != `number`) throw TypeError(`"size" argument must be of type number`);
      if (size < 0) throw RangeError(`The value "` + size + `" is invalid for option "size"`);
    }
    function alloc(size, fill, encoding) {
      return assertSize$1(size), size <= 0 || fill === void 0 ? createBuffer(size) : typeof encoding == `string` ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    }
    Buffer$27.alloc = function(size, fill, encoding) {
      return alloc(size, fill, encoding);
    };
    function allocUnsafe$1(size) {
      return assertSize$1(size), createBuffer(size < 0 ? 0 : checked(size) | 0);
    }
    Buffer$27.allocUnsafe = function(size) {
      return allocUnsafe$1(size);
    }, Buffer$27.allocUnsafeSlow = function(size) {
      return allocUnsafe$1(size);
    };
    function fromString(string, encoding) {
      if ((typeof encoding != `string` || encoding === ``) && (encoding = `utf8`), !Buffer$27.isEncoding(encoding)) throw TypeError(`Unknown encoding: ` + encoding);
      let length = byteLength$2(string, encoding) | 0, buf = createBuffer(length), actual = buf.write(string, encoding);
      return actual !== length && (buf = buf.slice(0, actual)), buf;
    }
    function fromArrayLike(array) {
      let length = array.length < 0 ? 0 : checked(array.length) | 0, buf = createBuffer(length);
      for (let i$4 = 0; i$4 < length; i$4 += 1) buf[i$4] = array[i$4] & 255;
      return buf;
    }
    function fromArrayView(arrayView) {
      if (isInstance(arrayView, GlobalUint8Array)) {
        let copy = new GlobalUint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
      }
      return fromArrayLike(arrayView);
    }
    function fromArrayBuffer(array, byteOffset, length) {
      if (byteOffset < 0 || array.byteLength < byteOffset) throw RangeError(`"offset" is outside of buffer bounds`);
      if (array.byteLength < byteOffset + (length || 0)) throw RangeError(`"length" is outside of buffer bounds`);
      let buf;
      return buf = byteOffset === void 0 && length === void 0 ? new GlobalUint8Array(array) : length === void 0 ? new GlobalUint8Array(array, byteOffset) : new GlobalUint8Array(array, byteOffset, length), Object.setPrototypeOf(buf, Buffer$27.prototype), buf;
    }
    function fromObject(obj) {
      if (Buffer$27.isBuffer(obj)) {
        let len$2 = checked(obj.length) | 0, buf = createBuffer(len$2);
        return buf.length === 0 || obj.copy(buf, 0, 0, len$2), buf;
      }
      if (obj.length !== void 0) return typeof obj.length != `number` || numberIsNaN$2(obj.length) ? createBuffer(0) : fromArrayLike(obj);
      if (obj.type === `Buffer` && Array.isArray(obj.data)) return fromArrayLike(obj.data);
    }
    function checked(length) {
      if (length >= K_MAX_LENGTH) throw RangeError(`Attempt to allocate Buffer larger than maximum size: 0x` + K_MAX_LENGTH.toString(16) + ` bytes`);
      return length | 0;
    }
    function SlowBuffer$1(length) {
      return +length != length && (length = 0), Buffer$27.alloc(+length);
    }
    Buffer$27.isBuffer = function(b2) {
      return b2 != null && b2._isBuffer === true && b2 !== Buffer$27.prototype;
    }, Buffer$27.compare = function(a$22, b2) {
      if (isInstance(a$22, GlobalUint8Array) && (a$22 = Buffer$27.from(a$22, a$22.offset, a$22.byteLength)), isInstance(b2, GlobalUint8Array) && (b2 = Buffer$27.from(b2, b2.offset, b2.byteLength)), !Buffer$27.isBuffer(a$22) || !Buffer$27.isBuffer(b2)) throw TypeError(`The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array`);
      if (a$22 === b2) return 0;
      let x$1 = a$22.length, y$1 = b2.length;
      for (let i$4 = 0, len$2 = Math.min(x$1, y$1); i$4 < len$2; ++i$4) if (a$22[i$4] !== b2[i$4]) {
        x$1 = a$22[i$4], y$1 = b2[i$4];
        break;
      }
      return x$1 < y$1 ? -1 : y$1 < x$1 ? 1 : 0;
    }, Buffer$27.isEncoding = function(encoding) {
      switch (String(encoding).toLowerCase()) {
        case `hex`:
        case `utf8`:
        case `utf-8`:
        case `ascii`:
        case `latin1`:
        case `binary`:
        case `base64`:
        case `ucs2`:
        case `ucs-2`:
        case `utf16le`:
        case `utf-16le`:
          return true;
        default:
          return false;
      }
    }, Buffer$27.concat = function(list, length) {
      if (!Array.isArray(list)) throw TypeError(`"list" argument must be an Array of Buffers`);
      if (list.length === 0) return Buffer$27.alloc(0);
      let i$4;
      if (length === void 0) for (length = 0, i$4 = 0; i$4 < list.length; ++i$4) length += list[i$4].length;
      let buffer$3 = Buffer$27.allocUnsafe(length), pos = 0;
      for (i$4 = 0; i$4 < list.length; ++i$4) {
        let buf = list[i$4];
        if (isInstance(buf, GlobalUint8Array)) pos + buf.length > buffer$3.length ? (Buffer$27.isBuffer(buf) || (buf = Buffer$27.from(buf)), buf.copy(buffer$3, pos)) : GlobalUint8Array.prototype.set.call(buffer$3, buf, pos);
        else if (Buffer$27.isBuffer(buf)) buf.copy(buffer$3, pos);
        else throw TypeError(`"list" argument must be an Array of Buffers`);
        pos += buf.length;
      }
      return buffer$3;
    };
    function byteLength$2(string, encoding) {
      if (Buffer$27.isBuffer(string)) return string.length;
      if (GlobalArrayBuffer.isView(string) || isInstance(string, GlobalArrayBuffer)) return string.byteLength;
      if (typeof string != `string`) throw TypeError(`The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ` + typeof string);
      let len$2 = string.length, mustMatch = arguments.length > 2 && arguments[2] === true;
      if (!mustMatch && len$2 === 0) return 0;
      let loweredCase = false;
      for (; ; ) switch (encoding) {
        case `ascii`:
        case `latin1`:
        case `binary`:
          return len$2;
        case `utf8`:
        case `utf-8`:
          return utf8ToBytes(string).length;
        case `ucs2`:
        case `ucs-2`:
        case `utf16le`:
        case `utf-16le`:
          return len$2 * 2;
        case `hex`:
          return len$2 >>> 1;
        case `base64`:
          return base64ToBytes(string).length;
        default:
          if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length;
          encoding = (`` + encoding).toLowerCase(), loweredCase = true;
      }
    }
    Buffer$27.byteLength = byteLength$2;
    function slowToString(encoding, start, end) {
      let loweredCase = false;
      if ((start === void 0 || start < 0) && (start = 0), start > this.length || ((end === void 0 || end > this.length) && (end = this.length), end <= 0) || (end >>>= 0, start >>>= 0, end <= start)) return ``;
      for (encoding ||= `utf8`; ; ) switch (encoding) {
        case `hex`:
          return hexSlice(this, start, end);
        case `utf8`:
        case `utf-8`:
          return utf8Slice(this, start, end);
        case `ascii`:
          return asciiSlice(this, start, end);
        case `latin1`:
        case `binary`:
          return latin1Slice(this, start, end);
        case `base64`:
          return base64Slice(this, start, end);
        case `ucs2`:
        case `ucs-2`:
        case `utf16le`:
        case `utf-16le`:
          return utf16leSlice(this, start, end);
        default:
          if (loweredCase) throw TypeError(`Unknown encoding: ` + encoding);
          encoding = (encoding + ``).toLowerCase(), loweredCase = true;
      }
    }
    Buffer$27.prototype._isBuffer = true;
    function swap(b2, n$4, m$3) {
      let i$4 = b2[n$4];
      b2[n$4] = b2[m$3], b2[m$3] = i$4;
    }
    Buffer$27.prototype.swap16 = function() {
      let len$2 = this.length;
      if (len$2 % 2 != 0) throw RangeError(`Buffer size must be a multiple of 16-bits`);
      for (let i$4 = 0; i$4 < len$2; i$4 += 2) swap(this, i$4, i$4 + 1);
      return this;
    }, Buffer$27.prototype.swap32 = function() {
      let len$2 = this.length;
      if (len$2 % 4 != 0) throw RangeError(`Buffer size must be a multiple of 32-bits`);
      for (let i$4 = 0; i$4 < len$2; i$4 += 4) swap(this, i$4, i$4 + 3), swap(this, i$4 + 1, i$4 + 2);
      return this;
    }, Buffer$27.prototype.swap64 = function() {
      let len$2 = this.length;
      if (len$2 % 8 != 0) throw RangeError(`Buffer size must be a multiple of 64-bits`);
      for (let i$4 = 0; i$4 < len$2; i$4 += 8) swap(this, i$4, i$4 + 7), swap(this, i$4 + 1, i$4 + 6), swap(this, i$4 + 2, i$4 + 5), swap(this, i$4 + 3, i$4 + 4);
      return this;
    }, Buffer$27.prototype.toString = function() {
      let length = this.length;
      return length === 0 ? `` : arguments.length === 0 ? utf8Slice(this, 0, length) : slowToString.apply(this, arguments);
    }, Buffer$27.prototype.toLocaleString = Buffer$27.prototype.toString, Buffer$27.prototype.equals = function(b2) {
      if (!Buffer$27.isBuffer(b2)) throw TypeError(`Argument must be a Buffer`);
      return this === b2 ? true : Buffer$27.compare(this, b2) === 0;
    }, Buffer$27.prototype.inspect = function() {
      let str = ``, max$3 = exports$12.INSPECT_MAX_BYTES;
      return str = this.toString(`hex`, 0, max$3).replace(/(.{2})/g, `$1 `).trim(), this.length > max$3 && (str += ` ... `), `<Buffer ` + str + `>`;
    }, customInspectSymbol && (Buffer$27.prototype[customInspectSymbol] = Buffer$27.prototype.inspect), Buffer$27.prototype.compare = function(target, start, end, thisStart, thisEnd) {
      if (isInstance(target, GlobalUint8Array) && (target = Buffer$27.from(target, target.offset, target.byteLength)), !Buffer$27.isBuffer(target)) throw TypeError(`The "target" argument must be one of type Buffer or Uint8Array. Received type ` + typeof target);
      if (start === void 0 && (start = 0), end === void 0 && (end = target ? target.length : 0), thisStart === void 0 && (thisStart = 0), thisEnd === void 0 && (thisEnd = this.length), start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw RangeError(`out of range index`);
      if (thisStart >= thisEnd && start >= end) return 0;
      if (thisStart >= thisEnd) return -1;
      if (start >= end) return 1;
      if (start >>>= 0, end >>>= 0, thisStart >>>= 0, thisEnd >>>= 0, this === target) return 0;
      let x$1 = thisEnd - thisStart, y$1 = end - start, len$2 = Math.min(x$1, y$1), thisCopy = this.slice(thisStart, thisEnd), targetCopy = target.slice(start, end);
      for (let i$4 = 0; i$4 < len$2; ++i$4) if (thisCopy[i$4] !== targetCopy[i$4]) {
        x$1 = thisCopy[i$4], y$1 = targetCopy[i$4];
        break;
      }
      return x$1 < y$1 ? -1 : y$1 < x$1 ? 1 : 0;
    };
    function bidirectionalIndexOf(buffer$3, val, byteOffset, encoding, dir) {
      if (buffer$3.length === 0) return -1;
      if (typeof byteOffset == `string` ? (encoding = byteOffset, byteOffset = 0) : byteOffset > 2147483647 ? byteOffset = 2147483647 : byteOffset < -2147483648 && (byteOffset = -2147483648), byteOffset = +byteOffset, numberIsNaN$2(byteOffset) && (byteOffset = dir ? 0 : buffer$3.length - 1), byteOffset < 0 && (byteOffset = buffer$3.length + byteOffset), byteOffset >= buffer$3.length) {
        if (dir) return -1;
        byteOffset = buffer$3.length - 1;
      } else if (byteOffset < 0) if (dir) byteOffset = 0;
      else return -1;
      if (typeof val == `string` && (val = Buffer$27.from(val, encoding)), Buffer$27.isBuffer(val)) return val.length === 0 ? -1 : arrayIndexOf(buffer$3, val, byteOffset, encoding, dir);
      if (typeof val == `number`) return val &= 255, typeof GlobalUint8Array.prototype.indexOf == `function` ? dir ? GlobalUint8Array.prototype.indexOf.call(buffer$3, val, byteOffset) : GlobalUint8Array.prototype.lastIndexOf.call(buffer$3, val, byteOffset) : arrayIndexOf(buffer$3, [val], byteOffset, encoding, dir);
      throw TypeError(`val must be string, number or Buffer`);
    }
    function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
      let indexSize = 1, arrLength = arr.length, valLength = val.length;
      if (encoding !== void 0 && (encoding = String(encoding).toLowerCase(), encoding === `ucs2` || encoding === `ucs-2` || encoding === `utf16le` || encoding === `utf-16le`)) {
        if (arr.length < 2 || val.length < 2) return -1;
        indexSize = 2, arrLength /= 2, valLength /= 2, byteOffset /= 2;
      }
      function read(buf, i$5) {
        return indexSize === 1 ? buf[i$5] : buf.readUInt16BE(i$5 * indexSize);
      }
      let i$4;
      if (dir) {
        let foundIndex = -1;
        for (i$4 = byteOffset; i$4 < arrLength; i$4++) if (read(arr, i$4) === read(val, foundIndex === -1 ? 0 : i$4 - foundIndex)) {
          if (foundIndex === -1 && (foundIndex = i$4), i$4 - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else foundIndex !== -1 && (i$4 -= i$4 - foundIndex), foundIndex = -1;
      } else for (byteOffset + valLength > arrLength && (byteOffset = arrLength - valLength), i$4 = byteOffset; i$4 >= 0; i$4--) {
        let found = true;
        for (let j$1 = 0; j$1 < valLength; j$1++) if (read(arr, i$4 + j$1) !== read(val, j$1)) {
          found = false;
          break;
        }
        if (found) return i$4;
      }
      return -1;
    }
    Buffer$27.prototype.includes = function(val, byteOffset, encoding) {
      return this.indexOf(val, byteOffset, encoding) !== -1;
    }, Buffer$27.prototype.indexOf = function(val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
    }, Buffer$27.prototype.lastIndexOf = function(val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
    };
    function hexWrite(buf, string, offset$2, length) {
      offset$2 = Number(offset$2) || 0;
      let remaining = buf.length - offset$2;
      length ? (length = Number(length), length > remaining && (length = remaining)) : length = remaining;
      let strLen = string.length;
      length > strLen / 2 && (length = strLen / 2);
      let i$4;
      for (i$4 = 0; i$4 < length; ++i$4) {
        let parsed = parseInt(string.substr(i$4 * 2, 2), 16);
        if (numberIsNaN$2(parsed)) return i$4;
        buf[offset$2 + i$4] = parsed;
      }
      return i$4;
    }
    function utf8Write(buf, string, offset$2, length) {
      return blitBuffer(utf8ToBytes(string, buf.length - offset$2), buf, offset$2, length);
    }
    function asciiWrite(buf, string, offset$2, length) {
      return blitBuffer(asciiToBytes(string), buf, offset$2, length);
    }
    function base64Write(buf, string, offset$2, length) {
      return blitBuffer(base64ToBytes(string), buf, offset$2, length);
    }
    function ucs2Write(buf, string, offset$2, length) {
      return blitBuffer(utf16leToBytes(string, buf.length - offset$2), buf, offset$2, length);
    }
    Buffer$27.prototype.write = function(string, offset$2, length, encoding) {
      if (offset$2 === void 0) encoding = `utf8`, length = this.length, offset$2 = 0;
      else if (length === void 0 && typeof offset$2 == `string`) encoding = offset$2, length = this.length, offset$2 = 0;
      else if (isFinite(offset$2)) offset$2 >>>= 0, isFinite(length) ? (length >>>= 0, encoding === void 0 && (encoding = `utf8`)) : (encoding = length, length = void 0);
      else throw Error(`Buffer.write(string, encoding, offset[, length]) is no longer supported`);
      let remaining = this.length - offset$2;
      if ((length === void 0 || length > remaining) && (length = remaining), string.length > 0 && (length < 0 || offset$2 < 0) || offset$2 > this.length) throw RangeError(`Attempt to write outside buffer bounds`);
      encoding ||= `utf8`;
      let loweredCase = false;
      for (; ; ) switch (encoding) {
        case `hex`:
          return hexWrite(this, string, offset$2, length);
        case `utf8`:
        case `utf-8`:
          return utf8Write(this, string, offset$2, length);
        case `ascii`:
        case `latin1`:
        case `binary`:
          return asciiWrite(this, string, offset$2, length);
        case `base64`:
          return base64Write(this, string, offset$2, length);
        case `ucs2`:
        case `ucs-2`:
        case `utf16le`:
        case `utf-16le`:
          return ucs2Write(this, string, offset$2, length);
        default:
          if (loweredCase) throw TypeError(`Unknown encoding: ` + encoding);
          encoding = (`` + encoding).toLowerCase(), loweredCase = true;
      }
    }, Buffer$27.prototype.toJSON = function() {
      return { type: `Buffer`, data: Array.prototype.slice.call(this._arr || this, 0) };
    };
    function base64Slice(buf, start, end) {
      return start === 0 && end === buf.length ? base64.fromByteArray(buf) : base64.fromByteArray(buf.slice(start, end));
    }
    function utf8Slice(buf, start, end) {
      end = Math.min(buf.length, end);
      let res = [], i$4 = start;
      for (; i$4 < end; ) {
        let firstByte = buf[i$4], codePoint = null, bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
        if (i$4 + bytesPerSequence <= end) {
          let secondByte, thirdByte, fourthByte, tempCodePoint;
          switch (bytesPerSequence) {
            case 1:
              firstByte < 128 && (codePoint = firstByte);
              break;
            case 2:
              secondByte = buf[i$4 + 1], (secondByte & 192) == 128 && (tempCodePoint = (firstByte & 31) << 6 | secondByte & 63, tempCodePoint > 127 && (codePoint = tempCodePoint));
              break;
            case 3:
              secondByte = buf[i$4 + 1], thirdByte = buf[i$4 + 2], (secondByte & 192) == 128 && (thirdByte & 192) == 128 && (tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63, tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343) && (codePoint = tempCodePoint));
              break;
            case 4:
              secondByte = buf[i$4 + 1], thirdByte = buf[i$4 + 2], fourthByte = buf[i$4 + 3], (secondByte & 192) == 128 && (thirdByte & 192) == 128 && (fourthByte & 192) == 128 && (tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63, tempCodePoint > 65535 && tempCodePoint < 1114112 && (codePoint = tempCodePoint));
          }
        }
        codePoint === null ? (codePoint = 65533, bytesPerSequence = 1) : codePoint > 65535 && (codePoint -= 65536, res.push(codePoint >>> 10 & 1023 | 55296), codePoint = 56320 | codePoint & 1023), res.push(codePoint), i$4 += bytesPerSequence;
      }
      return decodeCodePointsArray(res);
    }
    let MAX_ARGUMENTS_LENGTH = 4096;
    function decodeCodePointsArray(codePoints) {
      let len$2 = codePoints.length;
      if (len$2 <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints);
      let res = ``, i$4 = 0;
      for (; i$4 < len$2; ) res += String.fromCharCode.apply(String, codePoints.slice(i$4, i$4 += MAX_ARGUMENTS_LENGTH));
      return res;
    }
    function asciiSlice(buf, start, end) {
      let ret = ``;
      end = Math.min(buf.length, end);
      for (let i$4 = start; i$4 < end; ++i$4) ret += String.fromCharCode(buf[i$4] & 127);
      return ret;
    }
    function latin1Slice(buf, start, end) {
      let ret = ``;
      end = Math.min(buf.length, end);
      for (let i$4 = start; i$4 < end; ++i$4) ret += String.fromCharCode(buf[i$4]);
      return ret;
    }
    function hexSlice(buf, start, end) {
      let len$2 = buf.length;
      (!start || start < 0) && (start = 0), (!end || end < 0 || end > len$2) && (end = len$2);
      let out = ``;
      for (let i$4 = start; i$4 < end; ++i$4) out += hexSliceLookupTable[buf[i$4]];
      return out;
    }
    function utf16leSlice(buf, start, end) {
      let bytes = buf.slice(start, end), res = ``;
      for (let i$4 = 0; i$4 < bytes.length - 1; i$4 += 2) res += String.fromCharCode(bytes[i$4] + bytes[i$4 + 1] * 256);
      return res;
    }
    Buffer$27.prototype.slice = function(start, end) {
      let len$2 = this.length;
      start = ~~start, end = end === void 0 ? len$2 : ~~end, start < 0 ? (start += len$2, start < 0 && (start = 0)) : start > len$2 && (start = len$2), end < 0 ? (end += len$2, end < 0 && (end = 0)) : end > len$2 && (end = len$2), end < start && (end = start);
      let newBuf = this.subarray(start, end);
      return Object.setPrototypeOf(newBuf, Buffer$27.prototype), newBuf;
    };
    function checkOffset(offset$2, ext, length) {
      if (offset$2 % 1 != 0 || offset$2 < 0) throw RangeError(`offset is not uint`);
      if (offset$2 + ext > length) throw RangeError(`Trying to access beyond buffer length`);
    }
    Buffer$27.prototype.readUintLE = Buffer$27.prototype.readUIntLE = function(offset$2, byteLength$3, noAssert) {
      offset$2 >>>= 0, byteLength$3 >>>= 0, noAssert || checkOffset(offset$2, byteLength$3, this.length);
      let val = this[offset$2], mul = 1, i$4 = 0;
      for (; ++i$4 < byteLength$3 && (mul *= 256); ) val += this[offset$2 + i$4] * mul;
      return val;
    }, Buffer$27.prototype.readUintBE = Buffer$27.prototype.readUIntBE = function(offset$2, byteLength$3, noAssert) {
      offset$2 >>>= 0, byteLength$3 >>>= 0, noAssert || checkOffset(offset$2, byteLength$3, this.length);
      let val = this[offset$2 + --byteLength$3], mul = 1;
      for (; byteLength$3 > 0 && (mul *= 256); ) val += this[offset$2 + --byteLength$3] * mul;
      return val;
    }, Buffer$27.prototype.readUint8 = Buffer$27.prototype.readUInt8 = function(offset$2, noAssert) {
      return offset$2 >>>= 0, noAssert || checkOffset(offset$2, 1, this.length), this[offset$2];
    }, Buffer$27.prototype.readUint16LE = Buffer$27.prototype.readUInt16LE = function(offset$2, noAssert) {
      return offset$2 >>>= 0, noAssert || checkOffset(offset$2, 2, this.length), this[offset$2] | this[offset$2 + 1] << 8;
    }, Buffer$27.prototype.readUint16BE = Buffer$27.prototype.readUInt16BE = function(offset$2, noAssert) {
      return offset$2 >>>= 0, noAssert || checkOffset(offset$2, 2, this.length), this[offset$2] << 8 | this[offset$2 + 1];
    }, Buffer$27.prototype.readUint32LE = Buffer$27.prototype.readUInt32LE = function(offset$2, noAssert) {
      return offset$2 >>>= 0, noAssert || checkOffset(offset$2, 4, this.length), (this[offset$2] | this[offset$2 + 1] << 8 | this[offset$2 + 2] << 16) + this[offset$2 + 3] * 16777216;
    }, Buffer$27.prototype.readUint32BE = Buffer$27.prototype.readUInt32BE = function(offset$2, noAssert) {
      return offset$2 >>>= 0, noAssert || checkOffset(offset$2, 4, this.length), this[offset$2] * 16777216 + (this[offset$2 + 1] << 16 | this[offset$2 + 2] << 8 | this[offset$2 + 3]);
    }, Buffer$27.prototype.readBigUInt64LE = defineBigIntMethod(function(offset$2) {
      offset$2 >>>= 0, validateNumber(offset$2, `offset`);
      let first$1 = this[offset$2], last$2 = this[offset$2 + 7];
      (first$1 === void 0 || last$2 === void 0) && boundsError(offset$2, this.length - 8);
      let lo = first$1 + this[++offset$2] * 2 ** 8 + this[++offset$2] * 2 ** 16 + this[++offset$2] * 2 ** 24, hi = this[++offset$2] + this[++offset$2] * 2 ** 8 + this[++offset$2] * 2 ** 16 + last$2 * 2 ** 24;
      return BigInt(lo) + (BigInt(hi) << BigInt(32));
    }), Buffer$27.prototype.readBigUInt64BE = defineBigIntMethod(function(offset$2) {
      offset$2 >>>= 0, validateNumber(offset$2, `offset`);
      let first$1 = this[offset$2], last$2 = this[offset$2 + 7];
      (first$1 === void 0 || last$2 === void 0) && boundsError(offset$2, this.length - 8);
      let hi = first$1 * 2 ** 24 + this[++offset$2] * 2 ** 16 + this[++offset$2] * 2 ** 8 + this[++offset$2], lo = this[++offset$2] * 2 ** 24 + this[++offset$2] * 2 ** 16 + this[++offset$2] * 2 ** 8 + last$2;
      return (BigInt(hi) << BigInt(32)) + BigInt(lo);
    }), Buffer$27.prototype.readIntLE = function(offset$2, byteLength$3, noAssert) {
      offset$2 >>>= 0, byteLength$3 >>>= 0, noAssert || checkOffset(offset$2, byteLength$3, this.length);
      let val = this[offset$2], mul = 1, i$4 = 0;
      for (; ++i$4 < byteLength$3 && (mul *= 256); ) val += this[offset$2 + i$4] * mul;
      return mul *= 128, val >= mul && (val -= 2 ** (8 * byteLength$3)), val;
    }, Buffer$27.prototype.readIntBE = function(offset$2, byteLength$3, noAssert) {
      offset$2 >>>= 0, byteLength$3 >>>= 0, noAssert || checkOffset(offset$2, byteLength$3, this.length);
      let i$4 = byteLength$3, mul = 1, val = this[offset$2 + --i$4];
      for (; i$4 > 0 && (mul *= 256); ) val += this[offset$2 + --i$4] * mul;
      return mul *= 128, val >= mul && (val -= 2 ** (8 * byteLength$3)), val;
    }, Buffer$27.prototype.readInt8 = function(offset$2, noAssert) {
      return offset$2 >>>= 0, noAssert || checkOffset(offset$2, 1, this.length), this[offset$2] & 128 ? (255 - this[offset$2] + 1) * -1 : this[offset$2];
    }, Buffer$27.prototype.readInt16LE = function(offset$2, noAssert) {
      offset$2 >>>= 0, noAssert || checkOffset(offset$2, 2, this.length);
      let val = this[offset$2] | this[offset$2 + 1] << 8;
      return val & 32768 ? val | 4294901760 : val;
    }, Buffer$27.prototype.readInt16BE = function(offset$2, noAssert) {
      offset$2 >>>= 0, noAssert || checkOffset(offset$2, 2, this.length);
      let val = this[offset$2 + 1] | this[offset$2] << 8;
      return val & 32768 ? val | 4294901760 : val;
    }, Buffer$27.prototype.readInt32LE = function(offset$2, noAssert) {
      return offset$2 >>>= 0, noAssert || checkOffset(offset$2, 4, this.length), this[offset$2] | this[offset$2 + 1] << 8 | this[offset$2 + 2] << 16 | this[offset$2 + 3] << 24;
    }, Buffer$27.prototype.readInt32BE = function(offset$2, noAssert) {
      return offset$2 >>>= 0, noAssert || checkOffset(offset$2, 4, this.length), this[offset$2] << 24 | this[offset$2 + 1] << 16 | this[offset$2 + 2] << 8 | this[offset$2 + 3];
    }, Buffer$27.prototype.readBigInt64LE = defineBigIntMethod(function(offset$2) {
      offset$2 >>>= 0, validateNumber(offset$2, `offset`);
      let first$1 = this[offset$2], last$2 = this[offset$2 + 7];
      (first$1 === void 0 || last$2 === void 0) && boundsError(offset$2, this.length - 8);
      let val = this[offset$2 + 4] + this[offset$2 + 5] * 2 ** 8 + this[offset$2 + 6] * 2 ** 16 + (last$2 << 24);
      return (BigInt(val) << BigInt(32)) + BigInt(first$1 + this[++offset$2] * 2 ** 8 + this[++offset$2] * 2 ** 16 + this[++offset$2] * 2 ** 24);
    }), Buffer$27.prototype.readBigInt64BE = defineBigIntMethod(function(offset$2) {
      offset$2 >>>= 0, validateNumber(offset$2, `offset`);
      let first$1 = this[offset$2], last$2 = this[offset$2 + 7];
      (first$1 === void 0 || last$2 === void 0) && boundsError(offset$2, this.length - 8);
      let val = (first$1 << 24) + this[++offset$2] * 2 ** 16 + this[++offset$2] * 2 ** 8 + this[++offset$2];
      return (BigInt(val) << BigInt(32)) + BigInt(this[++offset$2] * 2 ** 24 + this[++offset$2] * 2 ** 16 + this[++offset$2] * 2 ** 8 + last$2);
    }), Buffer$27.prototype.readFloatLE = function(offset$2, noAssert) {
      return offset$2 >>>= 0, noAssert || checkOffset(offset$2, 4, this.length), ieee754$1$1.read(this, offset$2, true, 23, 4);
    }, Buffer$27.prototype.readFloatBE = function(offset$2, noAssert) {
      return offset$2 >>>= 0, noAssert || checkOffset(offset$2, 4, this.length), ieee754$1$1.read(this, offset$2, false, 23, 4);
    }, Buffer$27.prototype.readDoubleLE = function(offset$2, noAssert) {
      return offset$2 >>>= 0, noAssert || checkOffset(offset$2, 8, this.length), ieee754$1$1.read(this, offset$2, true, 52, 8);
    }, Buffer$27.prototype.readDoubleBE = function(offset$2, noAssert) {
      return offset$2 >>>= 0, noAssert || checkOffset(offset$2, 8, this.length), ieee754$1$1.read(this, offset$2, false, 52, 8);
    };
    function checkInt(buf, value, offset$2, ext, max$3, min$1) {
      if (!Buffer$27.isBuffer(buf)) throw TypeError(`"buffer" argument must be a Buffer instance`);
      if (value > max$3 || value < min$1) throw RangeError(`"value" argument is out of bounds`);
      if (offset$2 + ext > buf.length) throw RangeError(`Index out of range`);
    }
    Buffer$27.prototype.writeUintLE = Buffer$27.prototype.writeUIntLE = function(value, offset$2, byteLength$3, noAssert) {
      if (value = +value, offset$2 >>>= 0, byteLength$3 >>>= 0, !noAssert) {
        let maxBytes = 2 ** (8 * byteLength$3) - 1;
        checkInt(this, value, offset$2, byteLength$3, maxBytes, 0);
      }
      let mul = 1, i$4 = 0;
      for (this[offset$2] = value & 255; ++i$4 < byteLength$3 && (mul *= 256); ) this[offset$2 + i$4] = value / mul & 255;
      return offset$2 + byteLength$3;
    }, Buffer$27.prototype.writeUintBE = Buffer$27.prototype.writeUIntBE = function(value, offset$2, byteLength$3, noAssert) {
      if (value = +value, offset$2 >>>= 0, byteLength$3 >>>= 0, !noAssert) {
        let maxBytes = 2 ** (8 * byteLength$3) - 1;
        checkInt(this, value, offset$2, byteLength$3, maxBytes, 0);
      }
      let i$4 = byteLength$3 - 1, mul = 1;
      for (this[offset$2 + i$4] = value & 255; --i$4 >= 0 && (mul *= 256); ) this[offset$2 + i$4] = value / mul & 255;
      return offset$2 + byteLength$3;
    }, Buffer$27.prototype.writeUint8 = Buffer$27.prototype.writeUInt8 = function(value, offset$2, noAssert) {
      return value = +value, offset$2 >>>= 0, noAssert || checkInt(this, value, offset$2, 1, 255, 0), this[offset$2] = value & 255, offset$2 + 1;
    }, Buffer$27.prototype.writeUint16LE = Buffer$27.prototype.writeUInt16LE = function(value, offset$2, noAssert) {
      return value = +value, offset$2 >>>= 0, noAssert || checkInt(this, value, offset$2, 2, 65535, 0), this[offset$2] = value & 255, this[offset$2 + 1] = value >>> 8, offset$2 + 2;
    }, Buffer$27.prototype.writeUint16BE = Buffer$27.prototype.writeUInt16BE = function(value, offset$2, noAssert) {
      return value = +value, offset$2 >>>= 0, noAssert || checkInt(this, value, offset$2, 2, 65535, 0), this[offset$2] = value >>> 8, this[offset$2 + 1] = value & 255, offset$2 + 2;
    }, Buffer$27.prototype.writeUint32LE = Buffer$27.prototype.writeUInt32LE = function(value, offset$2, noAssert) {
      return value = +value, offset$2 >>>= 0, noAssert || checkInt(this, value, offset$2, 4, 4294967295, 0), this[offset$2 + 3] = value >>> 24, this[offset$2 + 2] = value >>> 16, this[offset$2 + 1] = value >>> 8, this[offset$2] = value & 255, offset$2 + 4;
    }, Buffer$27.prototype.writeUint32BE = Buffer$27.prototype.writeUInt32BE = function(value, offset$2, noAssert) {
      return value = +value, offset$2 >>>= 0, noAssert || checkInt(this, value, offset$2, 4, 4294967295, 0), this[offset$2] = value >>> 24, this[offset$2 + 1] = value >>> 16, this[offset$2 + 2] = value >>> 8, this[offset$2 + 3] = value & 255, offset$2 + 4;
    };
    function wrtBigUInt64LE(buf, value, offset$2, min$1, max$3) {
      checkIntBI(value, min$1, max$3, buf, offset$2, 7);
      let lo = Number(value & BigInt(4294967295));
      buf[offset$2++] = lo, lo >>= 8, buf[offset$2++] = lo, lo >>= 8, buf[offset$2++] = lo, lo >>= 8, buf[offset$2++] = lo;
      let hi = Number(value >> BigInt(32) & BigInt(4294967295));
      return buf[offset$2++] = hi, hi >>= 8, buf[offset$2++] = hi, hi >>= 8, buf[offset$2++] = hi, hi >>= 8, buf[offset$2++] = hi, offset$2;
    }
    function wrtBigUInt64BE(buf, value, offset$2, min$1, max$3) {
      checkIntBI(value, min$1, max$3, buf, offset$2, 7);
      let lo = Number(value & BigInt(4294967295));
      buf[offset$2 + 7] = lo, lo >>= 8, buf[offset$2 + 6] = lo, lo >>= 8, buf[offset$2 + 5] = lo, lo >>= 8, buf[offset$2 + 4] = lo;
      let hi = Number(value >> BigInt(32) & BigInt(4294967295));
      return buf[offset$2 + 3] = hi, hi >>= 8, buf[offset$2 + 2] = hi, hi >>= 8, buf[offset$2 + 1] = hi, hi >>= 8, buf[offset$2] = hi, offset$2 + 8;
    }
    Buffer$27.prototype.writeBigUInt64LE = defineBigIntMethod(function(value, offset$2 = 0) {
      return wrtBigUInt64LE(this, value, offset$2, BigInt(0), BigInt(`0xffffffffffffffff`));
    }), Buffer$27.prototype.writeBigUInt64BE = defineBigIntMethod(function(value, offset$2 = 0) {
      return wrtBigUInt64BE(this, value, offset$2, BigInt(0), BigInt(`0xffffffffffffffff`));
    }), Buffer$27.prototype.writeIntLE = function(value, offset$2, byteLength$3, noAssert) {
      if (value = +value, offset$2 >>>= 0, !noAssert) {
        let limit = 2 ** (8 * byteLength$3 - 1);
        checkInt(this, value, offset$2, byteLength$3, limit - 1, -limit);
      }
      let i$4 = 0, mul = 1, sub = 0;
      for (this[offset$2] = value & 255; ++i$4 < byteLength$3 && (mul *= 256); ) value < 0 && sub === 0 && this[offset$2 + i$4 - 1] !== 0 && (sub = 1), this[offset$2 + i$4] = (value / mul >> 0) - sub & 255;
      return offset$2 + byteLength$3;
    }, Buffer$27.prototype.writeIntBE = function(value, offset$2, byteLength$3, noAssert) {
      if (value = +value, offset$2 >>>= 0, !noAssert) {
        let limit = 2 ** (8 * byteLength$3 - 1);
        checkInt(this, value, offset$2, byteLength$3, limit - 1, -limit);
      }
      let i$4 = byteLength$3 - 1, mul = 1, sub = 0;
      for (this[offset$2 + i$4] = value & 255; --i$4 >= 0 && (mul *= 256); ) value < 0 && sub === 0 && this[offset$2 + i$4 + 1] !== 0 && (sub = 1), this[offset$2 + i$4] = (value / mul >> 0) - sub & 255;
      return offset$2 + byteLength$3;
    }, Buffer$27.prototype.writeInt8 = function(value, offset$2, noAssert) {
      return value = +value, offset$2 >>>= 0, noAssert || checkInt(this, value, offset$2, 1, 127, -128), value < 0 && (value = 255 + value + 1), this[offset$2] = value & 255, offset$2 + 1;
    }, Buffer$27.prototype.writeInt16LE = function(value, offset$2, noAssert) {
      return value = +value, offset$2 >>>= 0, noAssert || checkInt(this, value, offset$2, 2, 32767, -32768), this[offset$2] = value & 255, this[offset$2 + 1] = value >>> 8, offset$2 + 2;
    }, Buffer$27.prototype.writeInt16BE = function(value, offset$2, noAssert) {
      return value = +value, offset$2 >>>= 0, noAssert || checkInt(this, value, offset$2, 2, 32767, -32768), this[offset$2] = value >>> 8, this[offset$2 + 1] = value & 255, offset$2 + 2;
    }, Buffer$27.prototype.writeInt32LE = function(value, offset$2, noAssert) {
      return value = +value, offset$2 >>>= 0, noAssert || checkInt(this, value, offset$2, 4, 2147483647, -2147483648), this[offset$2] = value & 255, this[offset$2 + 1] = value >>> 8, this[offset$2 + 2] = value >>> 16, this[offset$2 + 3] = value >>> 24, offset$2 + 4;
    }, Buffer$27.prototype.writeInt32BE = function(value, offset$2, noAssert) {
      return value = +value, offset$2 >>>= 0, noAssert || checkInt(this, value, offset$2, 4, 2147483647, -2147483648), value < 0 && (value = 4294967295 + value + 1), this[offset$2] = value >>> 24, this[offset$2 + 1] = value >>> 16, this[offset$2 + 2] = value >>> 8, this[offset$2 + 3] = value & 255, offset$2 + 4;
    }, Buffer$27.prototype.writeBigInt64LE = defineBigIntMethod(function(value, offset$2 = 0) {
      return wrtBigUInt64LE(this, value, offset$2, -BigInt(`0x8000000000000000`), BigInt(`0x7fffffffffffffff`));
    }), Buffer$27.prototype.writeBigInt64BE = defineBigIntMethod(function(value, offset$2 = 0) {
      return wrtBigUInt64BE(this, value, offset$2, -BigInt(`0x8000000000000000`), BigInt(`0x7fffffffffffffff`));
    });
    function checkIEEE754(buf, value, offset$2, ext, max$3, min$1) {
      if (offset$2 + ext > buf.length || offset$2 < 0) throw RangeError(`Index out of range`);
    }
    function writeFloat(buf, value, offset$2, littleEndian, noAssert) {
      return value = +value, offset$2 >>>= 0, noAssert || checkIEEE754(buf, value, offset$2, 4), ieee754$1$1.write(buf, value, offset$2, littleEndian, 23, 4), offset$2 + 4;
    }
    Buffer$27.prototype.writeFloatLE = function(value, offset$2, noAssert) {
      return writeFloat(this, value, offset$2, true, noAssert);
    }, Buffer$27.prototype.writeFloatBE = function(value, offset$2, noAssert) {
      return writeFloat(this, value, offset$2, false, noAssert);
    };
    function writeDouble(buf, value, offset$2, littleEndian, noAssert) {
      return value = +value, offset$2 >>>= 0, noAssert || checkIEEE754(buf, value, offset$2, 8), ieee754$1$1.write(buf, value, offset$2, littleEndian, 52, 8), offset$2 + 8;
    }
    Buffer$27.prototype.writeDoubleLE = function(value, offset$2, noAssert) {
      return writeDouble(this, value, offset$2, true, noAssert);
    }, Buffer$27.prototype.writeDoubleBE = function(value, offset$2, noAssert) {
      return writeDouble(this, value, offset$2, false, noAssert);
    }, Buffer$27.prototype.copy = function(target, targetStart, start, end) {
      if (!Buffer$27.isBuffer(target)) throw TypeError(`argument should be a Buffer`);
      if (start ||= 0, !end && end !== 0 && (end = this.length), targetStart >= target.length && (targetStart = target.length), targetStart ||= 0, end > 0 && end < start && (end = start), end === start || target.length === 0 || this.length === 0) return 0;
      if (targetStart < 0) throw RangeError(`targetStart out of bounds`);
      if (start < 0 || start >= this.length) throw RangeError(`Index out of range`);
      if (end < 0) throw RangeError(`sourceEnd out of bounds`);
      end > this.length && (end = this.length), target.length - targetStart < end - start && (end = target.length - targetStart + start);
      let len$2 = end - start;
      return this === target && typeof GlobalUint8Array.prototype.copyWithin == `function` ? this.copyWithin(targetStart, start, end) : GlobalUint8Array.prototype.set.call(target, this.subarray(start, end), targetStart), len$2;
    }, Buffer$27.prototype.fill = function(val, start, end, encoding) {
      if (typeof val == `string`) {
        if (typeof start == `string` ? (encoding = start, start = 0, end = this.length) : typeof end == `string` && (encoding = end, end = this.length), encoding !== void 0 && typeof encoding != `string`) throw TypeError(`encoding must be a string`);
        if (typeof encoding == `string` && !Buffer$27.isEncoding(encoding)) throw TypeError(`Unknown encoding: ` + encoding);
        if (val.length === 1) {
          let code$2 = val.charCodeAt(0);
          (encoding === `utf8` && code$2 < 128 || encoding === `latin1`) && (val = code$2);
        }
      } else typeof val == `number` ? val &= 255 : typeof val == `boolean` && (val = Number(val));
      if (start < 0 || this.length < start || this.length < end) throw RangeError(`Out of range index`);
      if (end <= start) return this;
      start >>>= 0, end = end === void 0 ? this.length : end >>> 0, val ||= 0;
      let i$4;
      if (typeof val == `number`) for (i$4 = start; i$4 < end; ++i$4) this[i$4] = val;
      else {
        let bytes = Buffer$27.isBuffer(val) ? val : Buffer$27.from(val, encoding), len$2 = bytes.length;
        if (len$2 === 0) throw TypeError(`The value "` + val + `" is invalid for argument "value"`);
        for (i$4 = 0; i$4 < end - start; ++i$4) this[i$4 + start] = bytes[i$4 % len$2];
      }
      return this;
    };
    let errors = {};
    function E(sym, getMessage, Base$4) {
      errors[sym] = class extends Base$4 {
        constructor() {
          super(), Object.defineProperty(this, `message`, { value: getMessage.apply(this, arguments), writable: true, configurable: true }), this.name = `${this.name} [${sym}]`, this.stack, delete this.name;
        }
        get code() {
          return sym;
        }
        set code(value) {
          Object.defineProperty(this, `code`, { configurable: true, enumerable: true, value, writable: true });
        }
        toString() {
          return `${this.name} [${sym}]: ${this.message}`;
        }
      };
    }
    E(`ERR_BUFFER_OUT_OF_BOUNDS`, function(name$2) {
      return name$2 ? `${name$2} is outside of buffer bounds` : `Attempt to access memory outside buffer bounds`;
    }, RangeError), E(`ERR_INVALID_ARG_TYPE`, function(name$2, actual) {
      return `The "${name$2}" argument must be of type number. Received type ${typeof actual}`;
    }, TypeError), E(`ERR_OUT_OF_RANGE`, function(str, range, input) {
      let msg = `The value of "${str}" is out of range.`, received = input;
      return Number.isInteger(input) && Math.abs(input) > 2 ** 32 ? received = addNumericalSeparator(String(input)) : typeof input == `bigint` && (received = String(input), (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) && (received = addNumericalSeparator(received)), received += `n`), msg += ` It must be ${range}. Received ${received}`, msg;
    }, RangeError);
    function addNumericalSeparator(val) {
      let res = ``, i$4 = val.length, start = val[0] === `-` ? 1 : 0;
      for (; i$4 >= start + 4; i$4 -= 3) res = `_${val.slice(i$4 - 3, i$4)}${res}`;
      return `${val.slice(0, i$4)}${res}`;
    }
    function checkBounds(buf, offset$2, byteLength$3) {
      validateNumber(offset$2, `offset`), (buf[offset$2] === void 0 || buf[offset$2 + byteLength$3] === void 0) && boundsError(offset$2, buf.length - (byteLength$3 + 1));
    }
    function checkIntBI(value, min$1, max$3, buf, offset$2, byteLength$3) {
      if (value > max$3 || value < min$1) {
        let n$4 = typeof min$1 == `bigint` ? `n` : ``, range;
        throw range = min$1 === 0 || min$1 === BigInt(0) ? `>= 0${n$4} and < 2${n$4} ** ${(byteLength$3 + 1) * 8}${n$4}` : `>= -(2${n$4} ** ${(byteLength$3 + 1) * 8 - 1}${n$4}) and < 2 ** ${(byteLength$3 + 1) * 8 - 1}${n$4}`, new errors.ERR_OUT_OF_RANGE(`value`, range, value);
      }
      checkBounds(buf, offset$2, byteLength$3);
    }
    function validateNumber(value, name$2) {
      if (typeof value != `number`) throw new errors.ERR_INVALID_ARG_TYPE(name$2, `number`, value);
    }
    function boundsError(value, length, type) {
      throw Math.floor(value) === value ? length < 0 ? new errors.ERR_BUFFER_OUT_OF_BOUNDS() : new errors.ERR_OUT_OF_RANGE(`offset`, `>= ${0} and <= ${length}`, value) : (validateNumber(value, type), new errors.ERR_OUT_OF_RANGE(`offset`, `an integer`, value));
    }
    let INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
    function base64clean(str) {
      if (str = str.split(`=`)[0], str = str.trim().replace(INVALID_BASE64_RE, ``), str.length < 2) return ``;
      for (; str.length % 4 != 0; ) str += `=`;
      return str;
    }
    function utf8ToBytes(string, units) {
      units ||= 1 / 0;
      let codePoint, length = string.length, leadSurrogate = null, bytes = [];
      for (let i$4 = 0; i$4 < length; ++i$4) {
        if (codePoint = string.charCodeAt(i$4), codePoint > 55295 && codePoint < 57344) {
          if (!leadSurrogate) {
            if (codePoint > 56319) {
              (units -= 3) > -1 && bytes.push(239, 191, 189);
              continue;
            } else if (i$4 + 1 === length) {
              (units -= 3) > -1 && bytes.push(239, 191, 189);
              continue;
            }
            leadSurrogate = codePoint;
            continue;
          }
          if (codePoint < 56320) {
            (units -= 3) > -1 && bytes.push(239, 191, 189), leadSurrogate = codePoint;
            continue;
          }
          codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
        } else leadSurrogate && (units -= 3) > -1 && bytes.push(239, 191, 189);
        if (leadSurrogate = null, codePoint < 128) {
          if (--units < 0) break;
          bytes.push(codePoint);
        } else if (codePoint < 2048) {
          if ((units -= 2) < 0) break;
          bytes.push(codePoint >> 6 | 192, codePoint & 63 | 128);
        } else if (codePoint < 65536) {
          if ((units -= 3) < 0) break;
          bytes.push(codePoint >> 12 | 224, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
        } else if (codePoint < 1114112) {
          if ((units -= 4) < 0) break;
          bytes.push(codePoint >> 18 | 240, codePoint >> 12 & 63 | 128, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
        } else throw Error(`Invalid code point`);
      }
      return bytes;
    }
    function asciiToBytes(str) {
      let byteArray = [];
      for (let i$4 = 0; i$4 < str.length; ++i$4) byteArray.push(str.charCodeAt(i$4) & 255);
      return byteArray;
    }
    function utf16leToBytes(str, units) {
      let c$12, hi, lo, byteArray = [];
      for (let i$4 = 0; i$4 < str.length && !((units -= 2) < 0); ++i$4) c$12 = str.charCodeAt(i$4), hi = c$12 >> 8, lo = c$12 % 256, byteArray.push(lo), byteArray.push(hi);
      return byteArray;
    }
    function base64ToBytes(str) {
      return base64.toByteArray(base64clean(str));
    }
    function blitBuffer(src$1, dst, offset$2, length) {
      let i$4;
      for (i$4 = 0; i$4 < length && !(i$4 + offset$2 >= dst.length || i$4 >= src$1.length); ++i$4) dst[i$4 + offset$2] = src$1[i$4];
      return i$4;
    }
    function isInstance(obj, type) {
      return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
    }
    function numberIsNaN$2(obj) {
      return obj !== obj;
    }
    let hexSliceLookupTable = (function() {
      let alphabet = `0123456789abcdef`, table$2 = Array(256);
      for (let i$4 = 0; i$4 < 16; ++i$4) {
        let i16 = i$4 * 16;
        for (let j$1 = 0; j$1 < 16; ++j$1) table$2[i16 + j$1] = alphabet[i$4] + alphabet[j$1];
      }
      return table$2;
    })();
    function defineBigIntMethod(fn$1) {
      return typeof BigInt > `u` ? BufferBigIntNotDefined : fn$1;
    }
    function BufferBigIntNotDefined() {
      throw Error(`BigInt not supported`);
    }
  })(buffer$2), Buffer$1 = buffer$2.Buffer, Blob$1 = buffer$2.Blob, BlobOptions = buffer$2.BlobOptions, Buffer$1$1 = buffer$2.Buffer, File = buffer$2.File, FileOptions = buffer$2.FileOptions, INSPECT_MAX_BYTES = buffer$2.INSPECT_MAX_BYTES, SlowBuffer = buffer$2.SlowBuffer, TranscodeEncoding = buffer$2.TranscodeEncoding, atob$1 = buffer$2.atob, btoa$1 = buffer$2.btoa, constants$3 = buffer$2.constants, isAscii = buffer$2.isAscii, isUtf8 = buffer$2.isUtf8, kMaxLength = buffer$2.kMaxLength, kStringMaxLength = buffer$2.kStringMaxLength, resolveObjectURL = buffer$2.resolveObjectURL, transcode = buffer$2.transcode;
}), require_reach = __commonJSMin$1((exports$12, module2) => {
  let Assert$5 = require_assert$1(), internals$40 = {};
  module2.exports = function(obj, chain, options) {
    if (chain === false || chain == null) return obj;
    options ||= {}, typeof options == `string` && (options = { separator: options });
    let isChainArray = Array.isArray(chain);
    Assert$5(!isChainArray || !options.separator, `Separator option is not valid for array-based chain`);
    let path = isChainArray ? chain : chain.split(options.separator || `.`), ref = obj;
    for (let i$4 = 0; i$4 < path.length; ++i$4) {
      let key = path[i$4], type = options.iterables && internals$40.iterables(ref);
      if (Array.isArray(ref) || type === `set`) {
        let number = Number(key);
        Number.isInteger(number) && (key = number < 0 ? ref.length + number : number);
      }
      if (!ref || typeof ref == `function` && options.functions === false || !type && ref[key] === void 0) {
        Assert$5(!options.strict || i$4 + 1 === path.length, `Missing segment`, key, `in reach path `, chain), Assert$5(typeof ref == `object` || options.functions === true || typeof ref != `function`, `Invalid segment`, key, `in reach path `, chain), ref = options.default;
        break;
      }
      ref = type ? type === `set` ? [...ref][key] : ref.get(key) : ref[key];
    }
    return ref;
  }, internals$40.iterables = function(ref) {
    if (ref instanceof Set) return `set`;
    if (ref instanceof Map) return `map`;
  };
}), require_types$1 = __commonJSMin$1((exports$12, module2) => {
  init_dist$1();
  let internals$39 = {};
  exports$12 = module2.exports = { array: Array.prototype, buffer: Buffer$1 && Buffer$1.prototype, date: Date.prototype, error: Error.prototype, generic: Object.prototype, map: Map.prototype, promise: Promise.prototype, regex: RegExp.prototype, set: Set.prototype, url: URL.prototype, weakMap: WeakMap.prototype, weakSet: WeakSet.prototype }, internals$39.typeMap = /* @__PURE__ */ new Map([[`[object Error]`, exports$12.error], [`[object Map]`, exports$12.map], [`[object Promise]`, exports$12.promise], [`[object Set]`, exports$12.set], [`[object URL]`, exports$12.url], [`[object WeakMap]`, exports$12.weakMap], [`[object WeakSet]`, exports$12.weakSet]]), exports$12.getInternalProto = function(obj) {
    if (Array.isArray(obj)) return exports$12.array;
    if (Buffer$1 && obj instanceof Buffer$1) return exports$12.buffer;
    if (obj instanceof Date) return exports$12.date;
    if (obj instanceof RegExp) return exports$12.regex;
    if (obj instanceof Error) return exports$12.error;
    let objName = Object.prototype.toString.call(obj);
    return internals$39.typeMap.get(objName) || exports$12.generic;
  };
}), require_utils$7 = __commonJSMin$1((exports$12) => {
  exports$12.keys = function(obj, options = {}) {
    return options.symbols === false ? Object.getOwnPropertyNames(obj) : Reflect.ownKeys(obj);
  };
}), require_clone$1 = __commonJSMin$1((exports$12, module2) => {
  init_dist$1();
  let Reach$2 = require_reach(), Types$1 = require_types$1(), Utils$3 = require_utils$7(), internals$38 = { needsProtoHack: /* @__PURE__ */ new Set([Types$1.set, Types$1.map, Types$1.weakSet, Types$1.weakMap]), structuredCloneExists: typeof structuredClone == `function` };
  module2.exports = internals$38.clone = function(obj, options = {}, _seen = null) {
    if (typeof obj != `object` || !obj) return obj;
    let clone$20 = internals$38.clone, seen = _seen;
    if (options.shallow) {
      if (options.shallow !== true) return internals$38.cloneWithShallow(obj, options);
      clone$20 = (value) => value;
    } else if (seen) {
      let lookup$2 = seen.get(obj);
      if (lookup$2) return lookup$2;
    } else seen = /* @__PURE__ */ new Map();
    let baseProto = Types$1.getInternalProto(obj);
    switch (baseProto) {
      case Types$1.buffer:
        return Buffer$1?.from(obj);
      case Types$1.date:
        return new Date(obj.getTime());
      case Types$1.regex:
      case Types$1.url:
        return new baseProto.constructor(obj);
    }
    let newObj = internals$38.base(obj, baseProto, options);
    if (newObj === obj) return obj;
    if (seen && seen.set(obj, newObj), baseProto === Types$1.set) for (let value of obj) newObj.add(clone$20(value, options, seen));
    else if (baseProto === Types$1.map) for (let [key, value] of obj) newObj.set(key, clone$20(value, options, seen));
    let keys$10 = Utils$3.keys(obj, options);
    for (let key of keys$10) {
      if (key === `__proto__`) continue;
      if (baseProto === Types$1.array && key === `length`) {
        newObj.length = obj.length;
        continue;
      }
      if (internals$38.structuredCloneExists && baseProto === Types$1.error && key === `stack`) continue;
      let descriptor = Object.getOwnPropertyDescriptor(obj, key);
      descriptor ? descriptor.get || descriptor.set ? Object.defineProperty(newObj, key, descriptor) : descriptor.enumerable ? newObj[key] = clone$20(obj[key], options, seen) : Object.defineProperty(newObj, key, { enumerable: false, writable: true, configurable: true, value: clone$20(obj[key], options, seen) }) : Object.defineProperty(newObj, key, { enumerable: true, writable: true, configurable: true, value: clone$20(obj[key], options, seen) });
    }
    return newObj;
  }, internals$38.cloneWithShallow = function(source, options) {
    let keys$10 = options.shallow;
    options = Object.assign({}, options), options.shallow = false;
    let seen = /* @__PURE__ */ new Map();
    for (let key of keys$10) {
      let ref = Reach$2(source, key);
      (typeof ref == `object` || typeof ref == `function`) && seen.set(ref, ref);
    }
    return internals$38.clone(source, options, seen);
  }, internals$38.base = function(obj, baseProto, options) {
    if (options.prototype === false) return internals$38.needsProtoHack.has(baseProto) ? new baseProto.constructor() : baseProto === Types$1.array ? [] : {};
    let proto = Object.getPrototypeOf(obj);
    if (proto && proto.isImmutable) return obj;
    if (baseProto === Types$1.array) {
      let newObj = [];
      return proto !== baseProto && Object.setPrototypeOf(newObj, proto), newObj;
    } else if (baseProto === Types$1.error && internals$38.structuredCloneExists && (proto === baseProto || Error.isPrototypeOf(proto.constructor))) {
      let err$1 = structuredClone(obj);
      return Object.getPrototypeOf(err$1) !== proto && Object.setPrototypeOf(err$1, proto), err$1;
    }
    if (internals$38.needsProtoHack.has(baseProto)) {
      let newObj = new proto.constructor();
      return proto !== baseProto && Object.setPrototypeOf(newObj, proto), newObj;
    }
    return Object.create(proto);
  };
}), require_merge = __commonJSMin$1((exports$12, module2) => {
  init_dist$1();
  let Assert$4 = require_assert$1(), Clone$2 = require_clone$1(), Utils$2 = require_utils$7(), internals$37 = {};
  module2.exports = internals$37.merge = function(target, source, options) {
    if (Assert$4(target && typeof target == `object`, `Invalid target value: must be an object`), Assert$4(source == null || typeof source == `object`, `Invalid source value: must be null, undefined, or an object`), !source) return target;
    if (options = Object.assign({ nullOverride: true, mergeArrays: true }, options), Array.isArray(source)) {
      Assert$4(Array.isArray(target), `Cannot merge array onto an object`), options.mergeArrays || (target.length = 0);
      for (let i$4 = 0; i$4 < source.length; ++i$4) target.push(Clone$2(source[i$4], { symbols: options.symbols }));
      return target;
    }
    let keys$10 = Utils$2.keys(source, options);
    for (let i$4 = 0; i$4 < keys$10.length; ++i$4) {
      let key = keys$10[i$4];
      if (key === `__proto__` || !Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      let value = source[key];
      if (value && typeof value == `object`) {
        if (target[key] === value) continue;
        !target[key] || typeof target[key] != `object` || Array.isArray(target[key]) !== Array.isArray(value) || value instanceof Date || Buffer$1 && Buffer$1.isBuffer(value) || value instanceof RegExp ? target[key] = Clone$2(value, { symbols: options.symbols }) : internals$37.merge(target[key], value, options);
      } else value == null ? options.nullOverride && (target[key] = value) : target[key] = value;
    }
    return target;
  };
}), require_applyToDefaults = __commonJSMin$1((exports$12, module2) => {
  let Assert$3 = require_assert$1(), Clone$1 = require_clone$1(), Merge = require_merge(), Reach$1 = require_reach(), internals$36 = {};
  module2.exports = function(defaults$3, source, options = {}) {
    if (Assert$3(defaults$3 && typeof defaults$3 == `object`, `Invalid defaults value: must be an object`), Assert$3(!source || source === true || typeof source == `object`, `Invalid source value: must be true, falsy or an object`), Assert$3(typeof options == `object`, `Invalid options: must be an object`), !source) return null;
    if (options.shallow) return internals$36.applyToDefaultsWithShallow(defaults$3, source, options);
    let copy = Clone$1(defaults$3);
    if (source === true) return copy;
    let nullOverride = options.nullOverride === void 0 ? false : options.nullOverride;
    return Merge(copy, source, { nullOverride, mergeArrays: false });
  }, internals$36.applyToDefaultsWithShallow = function(defaults$3, source, options) {
    let keys$10 = options.shallow;
    Assert$3(Array.isArray(keys$10), `Invalid keys`);
    let seen = /* @__PURE__ */ new Map(), merge$4 = source === true ? null : /* @__PURE__ */ new Set();
    for (let key of keys$10) {
      key = Array.isArray(key) ? key : key.split(`.`);
      let ref = Reach$1(defaults$3, key);
      ref && typeof ref == `object` ? seen.set(ref, merge$4 && Reach$1(source, key) || ref) : merge$4 && merge$4.add(key);
    }
    let copy = Clone$1(defaults$3, {}, seen);
    if (!merge$4) return copy;
    for (let key of merge$4) internals$36.reachCopy(copy, source, key);
    let nullOverride = options.nullOverride === void 0 ? false : options.nullOverride;
    return Merge(copy, source, { nullOverride, mergeArrays: false });
  }, internals$36.reachCopy = function(dst, src$1, path) {
    for (let segment of path) {
      if (!(segment in src$1)) return;
      let val = src$1[segment];
      if (typeof val != `object` || !val) return;
      src$1 = val;
    }
    let value = src$1, ref = dst;
    for (let i$4 = 0; i$4 < path.length - 1; ++i$4) {
      let segment = path[i$4];
      typeof ref[segment] != `object` && (ref[segment] = {}), ref = ref[segment];
    }
    ref[path[path.length - 1]] = value;
  };
});
function getDefaultExportFromCjs(x$1) {
  return x$1 && x$1.__esModule && Object.prototype.hasOwnProperty.call(x$1, `default`) ? x$1.default : x$1;
}
function defaultSetTimout() {
  throw Error(`setTimeout has not been defined`);
}
function defaultClearTimeout() {
  throw Error(`clearTimeout has not been defined`);
}
function runTimeout(fun) {
  if (cachedSetTimeout === setTimeout) return setTimeout(fun, 0);
  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) return cachedSetTimeout = setTimeout, setTimeout(fun, 0);
  try {
    return cachedSetTimeout(fun, 0);
  } catch {
    try {
      return cachedSetTimeout.call(null, fun, 0);
    } catch {
      return cachedSetTimeout.call(this, fun, 0);
    }
  }
}
function runClearTimeout(marker) {
  if (cachedClearTimeout === clearTimeout) return clearTimeout(marker);
  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) return cachedClearTimeout = clearTimeout, clearTimeout(marker);
  try {
    return cachedClearTimeout(marker);
  } catch {
    try {
      return cachedClearTimeout.call(null, marker);
    } catch {
      return cachedClearTimeout.call(this, marker);
    }
  }
}
function cleanUpNextTick() {
  !draining || !currentQueue || (draining = false, currentQueue.length ? queue = currentQueue.concat(queue) : queueIndex = -1, queue.length && drainQueue());
}
function drainQueue() {
  if (!draining) {
    var timeout$5 = runTimeout(cleanUpNextTick);
    draining = true;
    for (var len$2 = queue.length; len$2; ) {
      for (currentQueue = queue, queue = []; ++queueIndex < len$2; ) currentQueue && currentQueue[queueIndex].run();
      queueIndex = -1, len$2 = queue.length;
    }
    currentQueue = null, draining = false, runClearTimeout(timeout$5);
  }
}
function Item(fun, array) {
  this.fun = fun, this.array = array;
}
function noop$6() {
}
var browser$1, process, cachedSetTimeout, cachedClearTimeout, queue, draining, currentQueue, queueIndex, browserExports, process$1, init_dist = __esmMin(() => {
  browser$1 = { exports: {} }, process = browser$1.exports = {}, (function() {
    try {
      cachedSetTimeout = typeof setTimeout == `function` ? setTimeout : defaultSetTimout;
    } catch {
      cachedSetTimeout = defaultSetTimout;
    }
    try {
      cachedClearTimeout = typeof clearTimeout == `function` ? clearTimeout : defaultClearTimeout;
    } catch {
      cachedClearTimeout = defaultClearTimeout;
    }
  })(), queue = [], draining = false, queueIndex = -1, process.nextTick = function(fun) {
    var args$1 = Array(arguments.length - 1);
    if (arguments.length > 1) for (var i$4 = 1; i$4 < arguments.length; i$4++) args$1[i$4 - 1] = arguments[i$4];
    queue.push(new Item(fun, args$1)), queue.length === 1 && !draining && runTimeout(drainQueue);
  }, Item.prototype.run = function() {
    this.fun.apply(null, this.array);
  }, process.title = `browser`, process.browser = true, process.env = {}, process.argv = [], process.version = ``, process.versions = {}, process.on = noop$6, process.addListener = noop$6, process.once = noop$6, process.off = noop$6, process.removeListener = noop$6, process.removeAllListeners = noop$6, process.emit = noop$6, process.prependListener = noop$6, process.prependOnceListener = noop$6, process.listeners = function(name$2) {
    return [];
  }, process.binding = function(name$2) {
    throw Error(`process.binding is not supported`);
  }, process.cwd = function() {
    return `/`;
  }, process.chdir = function(dir) {
    throw Error(`process.chdir is not supported`);
  }, process.umask = function() {
    return 0;
  }, browserExports = browser$1.exports, process$1 = getDefaultExportFromCjs(browserExports);
}), require_bench = __commonJSMin$1((exports$12, module2) => {
  init_dist();
  let internals$35 = {};
  module2.exports = internals$35.Bench = class {
    constructor() {
      this.ts = 0, this.reset();
    }
    reset() {
      this.ts = internals$35.Bench.now();
    }
    elapsed() {
      return internals$35.Bench.now() - this.ts;
    }
    static now() {
      let ts = process$1.hrtime();
      return ts[0] * 1e3 + ts[1] / 1e6;
    }
  };
}), require_ignore = __commonJSMin$1((exports$12, module2) => {
  module2.exports = function() {
  };
}), require_block = __commonJSMin$1((exports$12, module2) => {
  let Ignore = require_ignore();
  module2.exports = function() {
    return new Promise(Ignore);
  };
}), require_deepEqual = __commonJSMin$1((exports$12, module2) => {
  init_dist$1();
  let Types = require_types$1(), internals$34 = { mismatched: null };
  module2.exports = function(obj, ref, options) {
    return options = Object.assign({ prototype: true }, options), !!internals$34.isDeepEqual(obj, ref, options, []);
  }, internals$34.isDeepEqual = function(obj, ref, options, seen) {
    if (obj === ref) return obj !== 0 || 1 / obj == 1 / ref;
    let type = typeof obj;
    if (type !== typeof ref || obj === null || ref === null) return false;
    if (type === `function`) {
      if (!options.deepFunction || obj.toString() !== ref.toString()) return false;
    } else if (type !== `object`) return obj !== obj && ref !== ref;
    let instanceType = internals$34.getSharedType(obj, ref, !!options.prototype);
    switch (instanceType) {
      case Types.buffer:
        return Buffer$1 && Buffer$1.prototype.equals.call(obj, ref);
      case Types.promise:
        return obj === ref;
      case Types.regex:
      case Types.url:
        return obj.toString() === ref.toString();
      case internals$34.mismatched:
        return false;
    }
    for (let i$4 = seen.length - 1; i$4 >= 0; --i$4) if (seen[i$4].isSame(obj, ref)) return true;
    seen.push(new internals$34.SeenEntry(obj, ref));
    try {
      return !!internals$34.isDeepEqualObj(instanceType, obj, ref, options, seen);
    } finally {
      seen.pop();
    }
  }, internals$34.getSharedType = function(obj, ref, checkPrototype) {
    if (checkPrototype) return Object.getPrototypeOf(obj) === Object.getPrototypeOf(ref) ? Types.getInternalProto(obj) : internals$34.mismatched;
    let type = Types.getInternalProto(obj);
    return type === Types.getInternalProto(ref) ? type : internals$34.mismatched;
  }, internals$34.valueOf = function(obj) {
    let objValueOf = obj.valueOf;
    if (objValueOf === void 0) return obj;
    try {
      return objValueOf.call(obj);
    } catch (err$1) {
      return err$1;
    }
  }, internals$34.hasOwnEnumerableProperty = function(obj, key) {
    return Object.prototype.propertyIsEnumerable.call(obj, key);
  }, internals$34.isSetSimpleEqual = function(obj, ref) {
    for (let entry of Set.prototype.values.call(obj)) if (!Set.prototype.has.call(ref, entry)) return false;
    return true;
  }, internals$34.isDeepEqualObj = function(instanceType, obj, ref, options, seen) {
    let { isDeepEqual: isDeepEqual$2, valueOf, hasOwnEnumerableProperty } = internals$34, { keys: keys$10, getOwnPropertySymbols } = Object;
    if (instanceType === Types.array) if (options.part) {
      for (let objValue of obj) for (let refValue of ref) if (isDeepEqual$2(objValue, refValue, options, seen)) return true;
    } else {
      if (obj.length !== ref.length) return false;
      for (let i$4 = 0; i$4 < obj.length; ++i$4) if (!isDeepEqual$2(obj[i$4], ref[i$4], options, seen)) return false;
      return true;
    }
    else if (instanceType === Types.set) {
      if (obj.size !== ref.size) return false;
      if (!internals$34.isSetSimpleEqual(obj, ref)) {
        let ref2 = new Set(Set.prototype.values.call(ref));
        for (let objEntry of Set.prototype.values.call(obj)) {
          if (ref2.delete(objEntry)) continue;
          let found = false;
          for (let refEntry of ref2) if (isDeepEqual$2(objEntry, refEntry, options, seen)) {
            ref2.delete(refEntry), found = true;
            break;
          }
          if (!found) return false;
        }
      }
    } else if (instanceType === Types.map) {
      if (obj.size !== ref.size) return false;
      for (let [key, value] of Map.prototype.entries.call(obj)) if (value === void 0 && !Map.prototype.has.call(ref, key) || !isDeepEqual$2(value, Map.prototype.get.call(ref, key), options, seen)) return false;
    } else if (instanceType === Types.error && (obj.name !== ref.name || obj.message !== ref.message)) return false;
    let valueOfObj = valueOf(obj), valueOfRef = valueOf(ref);
    if ((obj !== valueOfObj || ref !== valueOfRef) && !isDeepEqual$2(valueOfObj, valueOfRef, options, seen)) return false;
    let objKeys = keys$10(obj);
    if (!options.part && objKeys.length !== keys$10(ref).length && !options.skip) return false;
    let skipped = 0;
    for (let key of objKeys) {
      if (options.skip && options.skip.includes(key)) {
        ref[key] === void 0 && ++skipped;
        continue;
      }
      if (!hasOwnEnumerableProperty(ref, key) || !isDeepEqual$2(obj[key], ref[key], options, seen)) return false;
    }
    if (!options.part && objKeys.length - skipped !== keys$10(ref).length) return false;
    if (options.symbols !== false) {
      let objSymbols = getOwnPropertySymbols(obj), refSymbols = new Set(getOwnPropertySymbols(ref));
      for (let key of objSymbols) {
        if (!options.skip?.includes(key)) {
          if (hasOwnEnumerableProperty(obj, key)) {
            if (!hasOwnEnumerableProperty(ref, key) || !isDeepEqual$2(obj[key], ref[key], options, seen)) return false;
          } else if (hasOwnEnumerableProperty(ref, key)) return false;
        }
        refSymbols.delete(key);
      }
      for (let key of refSymbols) if (hasOwnEnumerableProperty(ref, key)) return false;
    }
    return true;
  }, internals$34.SeenEntry = class {
    constructor(obj, ref) {
      this.obj = obj, this.ref = ref;
    }
    isSame(obj, ref) {
      return this.obj === obj && this.ref === ref;
    }
  };
}), require_escapeRegex = __commonJSMin$1((exports$12, module2) => {
  module2.exports = function(string) {
    return string.replace(/[\^\$\.\*\+\-\?\=\!\:\|\\\/\(\)\[\]\{\}\,]/g, `\\$&`);
  };
}), require_contain = __commonJSMin$1((exports$12, module2) => {
  let Assert$2 = require_assert$1(), DeepEqual = require_deepEqual(), EscapeRegex = require_escapeRegex(), Utils$1 = require_utils$7(), internals$33 = {};
  module2.exports = function(ref, values$3, options = {}) {
    return typeof values$3 != `object` && (values$3 = [values$3]), Assert$2(!Array.isArray(values$3) || values$3.length, `Values array cannot be empty`), typeof ref == `string` ? internals$33.string(ref, values$3, options) : Array.isArray(ref) ? internals$33.array(ref, values$3, options) : (Assert$2(typeof ref == `object`, `Reference must be string or an object`), internals$33.object(ref, values$3, options));
  }, internals$33.array = function(ref, values$3, options) {
    if (Array.isArray(values$3) || (values$3 = [values$3]), !ref.length || options.only && options.once && ref.length !== values$3.length) return false;
    let compare$16, map$8 = /* @__PURE__ */ new Map();
    for (let value of values$3) if (!options.deep || !value || typeof value != `object`) {
      let existing = map$8.get(value);
      existing ? ++existing.allowed : map$8.set(value, { allowed: 1, hits: 0 });
    } else {
      compare$16 ??= internals$33.compare(options);
      let found = false;
      for (let [key, existing] of map$8.entries()) if (compare$16(key, value)) {
        ++existing.allowed, found = true;
        break;
      }
      found || map$8.set(value, { allowed: 1, hits: 0 });
    }
    let hits = 0;
    for (let item of ref) {
      let match$2;
      if (!options.deep || !item || typeof item != `object`) match$2 = map$8.get(item);
      else {
        compare$16 ??= internals$33.compare(options);
        for (let [key, existing] of map$8.entries()) if (compare$16(key, item)) {
          match$2 = existing;
          break;
        }
      }
      if (match$2 && (++match$2.hits, ++hits, options.once && match$2.hits > match$2.allowed)) return false;
    }
    if (options.only && hits !== ref.length) return false;
    for (let match$2 of map$8.values()) {
      if (match$2.hits === match$2.allowed) continue;
      if (match$2.hits < match$2.allowed && !options.part) return false;
    }
    return !!hits;
  }, internals$33.object = function(ref, values$3, options) {
    Assert$2(options.once === void 0, `Cannot use option once with object`);
    let keys$10 = Utils$1.keys(ref, options);
    if (!keys$10.length) return false;
    if (Array.isArray(values$3)) return internals$33.array(keys$10, values$3, options);
    let symbols = Object.getOwnPropertySymbols(values$3).filter((sym) => values$3.propertyIsEnumerable(sym)), targets = [...Object.keys(values$3), ...symbols], compare$16 = internals$33.compare(options), set = new Set(targets);
    for (let key of keys$10) {
      if (!set.has(key)) {
        if (options.only) return false;
        continue;
      }
      if (!compare$16(values$3[key], ref[key])) return false;
      set.delete(key);
    }
    return set.size ? options.part ? set.size < targets.length : false : true;
  }, internals$33.string = function(ref, values$3, options) {
    if (ref === ``) return values$3.length === 1 && values$3[0] === `` || !options.once && !values$3.some((v$1) => v$1 !== ``);
    let map$8 = /* @__PURE__ */ new Map(), patterns = [];
    for (let value of values$3) if (Assert$2(typeof value == `string`, `Cannot compare string reference to non-string value`), value) {
      let existing = map$8.get(value);
      existing ? ++existing.allowed : (map$8.set(value, { allowed: 1, hits: 0 }), patterns.push(EscapeRegex(value)));
    } else if (options.once || options.only) return false;
    if (!patterns.length) return true;
    let regex = RegExp(`(${patterns.join(`|`)})`, `g`), leftovers = ref.replace(regex, ($0, $1) => (++map$8.get($1).hits, ``));
    if (options.only && leftovers) return false;
    let any = false;
    for (let match$2 of map$8.values()) {
      if (match$2.hits && (any = true), match$2.hits === match$2.allowed) continue;
      if (match$2.hits < match$2.allowed && !options.part || options.once) return false;
    }
    return !!any;
  }, internals$33.compare = function(options) {
    if (!options.deep) return internals$33.shallow;
    let hasOnly = options.only !== void 0, hasPart = options.part !== void 0, flags = { prototype: hasOnly ? options.only : hasPart ? !options.part : false, part: hasOnly ? !options.only : hasPart ? options.part : false };
    return (a$22, b2) => DeepEqual(a$22, b2, flags);
  }, internals$33.shallow = function(a$22, b2) {
    return a$22 === b2;
  };
}), require_escapeHeaderAttribute = __commonJSMin$1((exports$12, module2) => {
  let Assert$1 = require_assert$1();
  module2.exports = function(attribute) {
    return Assert$1(/^[ \w\!#\$%&'\(\)\*\+,\-\.\/\:;<\=>\?@\[\]\^`\{\|\}~\"\\]*$/.test(attribute), `Bad attribute value (` + attribute + `)`), attribute.replace(/\\/g, `\\\\`).replace(/\"/g, `\\"`);
  };
}), require_escapeHtml = __commonJSMin$1((exports$12, module2) => {
  let internals$32 = {};
  module2.exports = function(input) {
    if (!input) return ``;
    let escaped = ``;
    for (let i$4 = 0; i$4 < input.length; ++i$4) {
      let charCode = input.charCodeAt(i$4);
      internals$32.isSafe(charCode) ? escaped += input[i$4] : escaped += internals$32.escapeHtmlChar(charCode);
    }
    return escaped;
  }, internals$32.escapeHtmlChar = function(charCode) {
    let namedEscape = internals$32.namedHtml.get(charCode);
    if (namedEscape) return namedEscape;
    if (charCode >= 256) return `&#` + charCode + `;`;
    let hexValue = charCode.toString(16).padStart(2, `0`);
    return `&#x${hexValue};`;
  }, internals$32.isSafe = function(charCode) {
    return internals$32.safeCharCodes.has(charCode);
  }, internals$32.namedHtml = /* @__PURE__ */ new Map([[38, `&amp;`], [60, `&lt;`], [62, `&gt;`], [34, `&quot;`], [160, `&nbsp;`], [162, `&cent;`], [163, `&pound;`], [164, `&curren;`], [169, `&copy;`], [174, `&reg;`]]), internals$32.safeCharCodes = (function() {
    let safe = /* @__PURE__ */ new Set();
    for (let i$4 = 32; i$4 < 123; ++i$4) (i$4 >= 97 || i$4 >= 65 && i$4 <= 90 || i$4 >= 48 && i$4 <= 57 || i$4 === 32 || i$4 === 46 || i$4 === 44 || i$4 === 45 || i$4 === 58 || i$4 === 95) && safe.add(i$4);
    return safe;
  })();
}), require_escapeJson = __commonJSMin$1((exports$12, module2) => {
  let internals$31 = {};
  module2.exports = function(input) {
    return input ? input.replace(/[<>&\u2028\u2029]/g, internals$31.escape) : ``;
  }, internals$31.escape = function(char) {
    return internals$31.replacements.get(char);
  }, internals$31.replacements = /* @__PURE__ */ new Map([[`<`, `\\u003c`], [`>`, `\\u003e`], [`&`, `\\u0026`], [`\u2028`, `\\u2028`], [`\u2029`, `\\u2029`]]);
}), require_flatten$1 = __commonJSMin$1((exports$12, module2) => {
  let internals$30 = {};
  module2.exports = internals$30.flatten = function(array, target) {
    let result = target || [];
    for (let entry of array) Array.isArray(entry) ? internals$30.flatten(entry, result) : result.push(entry);
    return result;
  };
}), require_intersect = __commonJSMin$1((exports$12, module2) => {
  let internals$29 = {};
  module2.exports = function(array1, array2, options = {}) {
    if (!array1 || !array2) return options.first ? null : [];
    let common$4 = [], hash$4 = Array.isArray(array1) ? new Set(array1) : array1, found = /* @__PURE__ */ new Set();
    for (let value of array2) if (internals$29.has(hash$4, value) && !found.has(value)) {
      if (options.first) return value;
      common$4.push(value), found.add(value);
    }
    return options.first ? null : common$4;
  }, internals$29.has = function(ref, key) {
    return typeof ref.has == `function` ? ref.has(key) : ref[key] !== void 0;
  };
}), require_isPromise = __commonJSMin$1((exports$12, module2) => {
  module2.exports = function(promise) {
    return typeof promise?.then == `function`;
  };
}), require_once = __commonJSMin$1((exports$12, module2) => {
  let internals$28 = { wrapped: Symbol(`wrapped`) };
  module2.exports = function(method$1) {
    if (method$1[internals$28.wrapped]) return method$1;
    let once$4 = false, wrappedFn = function(...args$1) {
      once$4 || (once$4 = true, method$1(...args$1));
    };
    return wrappedFn[internals$28.wrapped] = true, wrappedFn;
  };
}), require_reachTemplate = __commonJSMin$1((exports$12, module2) => {
  let Reach = require_reach();
  module2.exports = function(obj, template, options) {
    return template.replace(/{([^{}]+)}/g, ($0, chain) => {
      let value = Reach(obj, chain, options);
      return value ?? ``;
    });
  };
}), require_wait = __commonJSMin$1((exports$12, module2) => {
  let internals$27 = { maxTimer: 2 ** 31 - 1 };
  module2.exports = function(timeout$5, returnValue, options) {
    if (typeof timeout$5 == `bigint` && (timeout$5 = Number(timeout$5)), timeout$5 >= 2 ** 53 - 1 && (timeout$5 = 1 / 0), typeof timeout$5 != `number` && timeout$5 !== void 0) throw TypeError(`Timeout must be a number or bigint`);
    return new Promise((resolve) => {
      let _setTimeout = options ? options.setTimeout : setTimeout, activate = () => {
        let time = Math.min(timeout$5, internals$27.maxTimer);
        timeout$5 -= time, _setTimeout(() => timeout$5 > 0 ? activate() : resolve(returnValue), time);
      };
      timeout$5 !== 1 / 0 && activate();
    });
  };
}), require_lib$4 = __commonJSMin$1((exports$12) => {
  exports$12.applyToDefaults = require_applyToDefaults(), exports$12.assert = require_assert$1(), exports$12.AssertError = require_assertError(), exports$12.Bench = require_bench(), exports$12.block = require_block(), exports$12.clone = require_clone$1(), exports$12.contain = require_contain(), exports$12.deepEqual = require_deepEqual(), exports$12.escapeHeaderAttribute = require_escapeHeaderAttribute(), exports$12.escapeHtml = require_escapeHtml(), exports$12.escapeJson = require_escapeJson(), exports$12.escapeRegex = require_escapeRegex(), exports$12.flatten = require_flatten$1(), exports$12.ignore = require_ignore(), exports$12.intersect = require_intersect(), exports$12.isPromise = require_isPromise(), exports$12.merge = require_merge(), exports$12.once = require_once(), exports$12.reach = require_reach(), exports$12.reachTemplate = require_reachTemplate(), exports$12.stringify = require_stringify(), exports$12.wait = require_wait();
}), package_exports$1 = {};
__export(package_exports$1, { browser: () => browser, default: () => package_default$1, dependencies: () => dependencies$1, description: () => description$1, devDependencies: () => devDependencies$1, engines: () => engines, files: () => files$1, keywords: () => keywords$1, license: () => license$1, main: () => main$1, name: () => name$1, repository: () => repository$1, scripts: () => scripts$1, types: () => types, version: () => version$3 });
var name$1, description$1, version$3, repository$1, engines, main$1, types, browser, files$1, keywords$1, dependencies$1, devDependencies$1, scripts$1, license$1, package_default$1, init_package$1 = __esmMin(() => {
  name$1 = `joi`, description$1 = `Object schema validation`, version$3 = `18.0.1`, repository$1 = { url: `git://github.com/hapijs/joi`, type: `git` }, engines = { node: `>= 20` }, main$1 = `lib/index.js`, types = `lib/index.d.ts`, browser = `dist/joi-browser.min.js`, files$1 = [`lib/**/*`, `dist/*`], keywords$1 = [`schema`, `validation`], dependencies$1 = { "@hapi/address": `^5.1.1`, "@hapi/formula": `^3.0.2`, "@hapi/hoek": `^11.0.7`, "@hapi/pinpoint": `^2.0.1`, "@hapi/tlds": `^1.1.1`, "@hapi/topo": `^6.0.2`, "@standard-schema/spec": `^1.0.0` }, devDependencies$1 = { "@hapi/bourne": `^3.0.0`, "@hapi/code": `^9.0.3`, "@hapi/eslint-plugin": `^7.0.0`, "@hapi/joi-legacy-test": `npm:@hapi/joi@15.x.x`, "@hapi/lab": `^26.0.0`, "@types/node": `^20.17.47`, typescript: `^5.8.3` }, scripts$1 = { prepublishOnly: `cd browser && npm install && npm run build`, test: `lab -t 100 -a @hapi/code -L -Y`, "test-cov-html": `lab -r html -o coverage.html -a @hapi/code` }, license$1 = `BSD-3-Clause`, package_default$1 = { name: name$1, description: description$1, version: version$3, repository: repository$1, engines, main: main$1, types, browser, files: files$1, keywords: keywords$1, dependencies: dependencies$1, devDependencies: devDependencies$1, scripts: scripts$1, license: license$1 };
}), require_cache = __commonJSMin$1((exports$12) => {
  let { assert: assert$52, clone: clone$19 } = require_lib$4(), Common$24 = require_common$3(), internals$26 = { max: 1e3, supported: /* @__PURE__ */ new Set([`undefined`, `boolean`, `number`, `string`]) };
  exports$12.provider = { provision(options) {
    return new internals$26.Cache(options);
  } }, internals$26.Cache = class {
    constructor(options = {}) {
      Common$24.assertOptions(options, [`max`]), assert$52(options.max === void 0 || options.max && options.max > 0 && isFinite(options.max), `Invalid max cache size`), this._max = options.max || internals$26.max, this._map = /* @__PURE__ */ new Map(), this._list = new internals$26.List();
    }
    get length() {
      return this._map.size;
    }
    set(key, value) {
      if (key !== null && !internals$26.supported.has(typeof key)) return;
      let node = this._map.get(key);
      if (node) {
        node.value = value, this._list.first(node);
        return;
      }
      node = this._list.unshift({ key, value }), this._map.set(key, node), this._compact();
    }
    get(key) {
      let node = this._map.get(key);
      if (node) return this._list.first(node), clone$19(node.value);
    }
    _compact() {
      if (this._map.size > this._max) {
        let node = this._list.pop();
        this._map.delete(node.key);
      }
    }
  }, internals$26.List = class {
    constructor() {
      this.tail = null, this.head = null;
    }
    unshift(node) {
      return node.next = null, node.prev = this.head, this.head && (this.head.next = node), this.head = node, this.tail ||= node, node;
    }
    first(node) {
      node !== this.head && (this._remove(node), this.unshift(node));
    }
    pop() {
      return this._remove(this.tail);
    }
    _remove(node) {
      let { next, prev } = node;
      return next.prev = prev, prev && (prev.next = next), node === this.tail && (this.tail = next), node.prev = null, node.next = null, node;
    }
  };
}), require_lib$3 = __commonJSMin$1((exports$12) => {
  let internals$25 = { operators: [`!`, `^`, `*`, `/`, `%`, `+`, `-`, `<`, `<=`, `>`, `>=`, `==`, `!=`, `&&`, `||`, `??`], operatorCharacters: [`!`, `^`, `*`, `/`, `%`, `+`, `-`, `<`, `=`, `>`, `&`, `|`, `?`], operatorsOrder: [[`^`], [`*`, `/`, `%`], [`+`, `-`], [`<`, `<=`, `>`, `>=`], [`==`, `!=`], [`&&`], [`||`, `??`]], operatorsPrefix: [`!`, `n`], literals: { '"': `"`, "`": "`", "'": `'`, "[": `]` }, numberRx: /^(?:[0-9]*(\.[0-9]*)?){1}$/, tokenRx: /^[\w\$\#\.\@\:\{\}]+$/, symbol: Symbol(`formula`), settings: Symbol(`settings`) };
  exports$12.Parser = class {
    constructor(string, options = {}) {
      if (!options[internals$25.settings] && options.constants) for (let constant$3 in options.constants) {
        let value = options.constants[constant$3];
        if (value !== null && ![`boolean`, `number`, `string`].includes(typeof value)) throw Error(`Formula constant ${constant$3} contains invalid ${typeof value} value type`);
      }
      this.settings = options[internals$25.settings] ? options : Object.assign({ [internals$25.settings]: true, constants: {}, functions: {} }, options), this.single = null, this._parts = null, this._parse(string);
    }
    _parse(string) {
      let parts = [], current = ``, parenthesis = 0, literal = false, flush = (inner) => {
        if (parenthesis) throw Error(`Formula missing closing parenthesis`);
        let last$2 = parts.length ? parts[parts.length - 1] : null;
        if (!(!literal && !current && !inner)) {
          if (last$2 && last$2.type === `reference` && inner === `)`) {
            last$2.type = `function`, last$2.value = this._subFormula(current, last$2.value), current = ``;
            return;
          }
          if (inner === `)`) {
            let sub = new exports$12.Parser(current, this.settings);
            parts.push({ type: `segment`, value: sub });
          } else if (literal) {
            if (literal === `]`) {
              parts.push({ type: `reference`, value: current }), current = ``;
              return;
            }
            parts.push({ type: `literal`, value: current });
          } else if (internals$25.operatorCharacters.includes(current)) last$2 && last$2.type === `operator` && internals$25.operators.includes(last$2.value + current) ? last$2.value += current : parts.push({ type: `operator`, value: current });
          else if (current.match(internals$25.numberRx)) parts.push({ type: `constant`, value: parseFloat(current) });
          else if (this.settings.constants[current] !== void 0) parts.push({ type: `constant`, value: this.settings.constants[current] });
          else {
            if (!current.match(internals$25.tokenRx)) throw Error(`Formula contains invalid token: ${current}`);
            parts.push({ type: `reference`, value: current });
          }
          current = ``;
        }
      };
      for (let c$12 of string) literal ? c$12 === literal ? (flush(), literal = false) : current += c$12 : parenthesis ? c$12 === `(` ? (current += c$12, ++parenthesis) : c$12 === `)` ? (--parenthesis, parenthesis ? current += c$12 : flush(c$12)) : current += c$12 : c$12 in internals$25.literals ? literal = internals$25.literals[c$12] : c$12 === `(` ? (flush(), ++parenthesis) : internals$25.operatorCharacters.includes(c$12) ? (flush(), current = c$12, flush()) : c$12 === ` ` ? flush() : current += c$12;
      flush(), parts = parts.map((part, i$4) => part.type !== `operator` || part.value !== `-` || i$4 && parts[i$4 - 1].type !== `operator` ? part : { type: `operator`, value: `n` });
      let operator$1 = false;
      for (let part of parts) {
        if (part.type === `operator`) {
          if (internals$25.operatorsPrefix.includes(part.value)) continue;
          if (!operator$1) throw Error(`Formula contains an operator in invalid position`);
          if (!internals$25.operators.includes(part.value)) throw Error(`Formula contains an unknown operator ${part.value}`);
        } else if (operator$1) throw Error(`Formula missing expected operator`);
        operator$1 = !operator$1;
      }
      if (!operator$1) throw Error(`Formula contains invalid trailing operator`);
      parts.length === 1 && [`reference`, `literal`, `constant`].includes(parts[0].type) && (this.single = { type: parts[0].type === `reference` ? `reference` : `value`, value: parts[0].value }), this._parts = parts.map((part) => {
        if (part.type === `operator`) return internals$25.operatorsPrefix.includes(part.value) ? part : part.value;
        if (part.type !== `reference`) return part.value;
        if (this.settings.tokenRx && !this.settings.tokenRx.test(part.value)) throw Error(`Formula contains invalid reference ${part.value}`);
        return this.settings.reference ? this.settings.reference(part.value) : internals$25.reference(part.value);
      });
    }
    _subFormula(string, name$2) {
      let method$1 = this.settings.functions[name$2];
      if (typeof method$1 != `function`) throw Error(`Formula contains unknown function ${name$2}`);
      let args$1 = [];
      if (string) {
        let current = ``, parenthesis = 0, literal = false, flush = () => {
          if (!current) throw Error(`Formula contains function ${name$2} with invalid arguments ${string}`);
          args$1.push(current), current = ``;
        };
        for (let i$4 = 0; i$4 < string.length; ++i$4) {
          let c$12 = string[i$4];
          literal ? (current += c$12, c$12 === literal && (literal = false)) : c$12 in internals$25.literals && !parenthesis ? (current += c$12, literal = internals$25.literals[c$12]) : c$12 === `,` && !parenthesis ? flush() : (current += c$12, c$12 === `(` ? ++parenthesis : c$12 === `)` && --parenthesis);
        }
        flush();
      }
      return args$1 = args$1.map((arg) => new exports$12.Parser(arg, this.settings)), function(context) {
        let innerValues = [];
        for (let arg of args$1) innerValues.push(arg.evaluate(context));
        return method$1.call(context, ...innerValues);
      };
    }
    evaluate(context) {
      let parts = this._parts.slice();
      for (let i$4 = parts.length - 2; i$4 >= 0; --i$4) {
        let part = parts[i$4];
        if (part && part.type === `operator`) {
          let current = parts[i$4 + 1];
          parts.splice(i$4 + 1, 1);
          let value = internals$25.evaluate(current, context);
          parts[i$4] = internals$25.single(part.value, value);
        }
      }
      return internals$25.operatorsOrder.forEach((set) => {
        for (let i$4 = 1; i$4 < parts.length - 1; ) if (set.includes(parts[i$4])) {
          let operator$1 = parts[i$4], left = internals$25.evaluate(parts[i$4 - 1], context), right = internals$25.evaluate(parts[i$4 + 1], context);
          parts.splice(i$4, 2);
          let result = internals$25.calculate(operator$1, left, right);
          parts[i$4 - 1] = result === 0 ? 0 : result;
        } else i$4 += 2;
      }), internals$25.evaluate(parts[0], context);
    }
  }, exports$12.Parser.prototype[internals$25.symbol] = true, internals$25.reference = function(name$2) {
    return function(context) {
      return context && context[name$2] !== void 0 ? context[name$2] : null;
    };
  }, internals$25.evaluate = function(part, context) {
    return part === null ? null : typeof part == `function` ? part(context) : part[internals$25.symbol] ? part.evaluate(context) : part;
  }, internals$25.single = function(operator$1, value) {
    if (operator$1 === `!`) return !value;
    let negative = -value;
    return negative === 0 ? 0 : negative;
  }, internals$25.calculate = function(operator$1, left, right) {
    if (operator$1 === `??`) return internals$25.exists(left) ? left : right;
    if (typeof left == `string` || typeof right == `string`) {
      if (operator$1 === `+`) return left = internals$25.exists(left) ? left : ``, right = internals$25.exists(right) ? right : ``, left + right;
    } else switch (operator$1) {
      case `^`:
        return left ** +right;
      case `*`:
        return left * right;
      case `/`:
        return left / right;
      case `%`:
        return left % right;
      case `+`:
        return left + right;
      case `-`:
        return left - right;
    }
    switch (operator$1) {
      case `<`:
        return left < right;
      case `<=`:
        return left <= right;
      case `>`:
        return left > right;
      case `>=`:
        return left >= right;
      case `==`:
        return left === right;
      case `!=`:
        return left !== right;
      case `&&`:
        return left && right;
      case `||`:
        return left || right;
    }
    return null;
  }, internals$25.exists = function(value) {
    return value != null;
  };
}), require_template = __commonJSMin$1((exports$12, module2) => {
  let { assert: assert$51, clone: clone$18, escapeHtml: escapeHtml$1 } = require_lib$4(), Formula = require_lib$3(), Common$23 = require_common$3(), Errors$8 = require_errors$2(), Ref$11 = require_ref$2(), internals$24 = { symbol: Symbol(`template`), opens: Array(1e3).join(`\0`), closes: Array(1e3).join(``), dateFormat: { date: Date.prototype.toDateString, iso: Date.prototype.toISOString, string: Date.prototype.toString, time: Date.prototype.toTimeString, utc: Date.prototype.toUTCString } };
  module2.exports = internals$24.Template = class {
    constructor(source, options) {
      if (assert$51(typeof source == `string`, `Template source must be a string`), assert$51(!source.includes(`\0`) && !source.includes(``), `Template source cannot contain reserved control characters`), this.source = source, this.rendered = source, this._template = null, options) {
        let { functions, ...opts } = options;
        this._settings = Object.keys(opts).length ? clone$18(opts) : void 0, this._functions = functions, this._functions && (assert$51(Object.keys(this._functions).every((key) => typeof key == `string`), `Functions keys must be strings`), assert$51(Object.values(this._functions).every((key) => typeof key == `function`), `Functions values must be functions`));
      } else this._settings = void 0, this._functions = void 0;
      this._parse();
    }
    _parse() {
      if (!this.source.includes(`{`)) return;
      let encoded = internals$24.encode(this.source), parts = internals$24.split(encoded), refs = false, processed = [], head$1 = parts.shift();
      head$1 && processed.push(head$1);
      for (let part of parts) {
        let raw = part[0] !== `{`, ender = raw ? `}` : `}}`, end = part.indexOf(ender);
        if (end === -1 || part[1] === `{`) {
          processed.push(`{${internals$24.decode(part)}`);
          continue;
        }
        let variable = part.slice(raw ? 0 : 1, end), wrapped = variable[0] === `:`;
        wrapped && (variable = variable.slice(1));
        let dynamic = this._ref(internals$24.decode(variable), { raw, wrapped });
        processed.push(dynamic), typeof dynamic != `string` && (refs = true);
        let rest = part.slice(end + ender.length);
        rest && processed.push(internals$24.decode(rest));
      }
      if (!refs) {
        this.rendered = processed.join(``);
        return;
      }
      this._template = processed;
    }
    static date(date, prefs) {
      return internals$24.dateFormat[prefs.dateFormat].call(date);
    }
    describe(options = {}) {
      if (!this._settings && options.compact) return this.source;
      let desc$1 = { template: this.source };
      return this._settings && (desc$1.options = this._settings), this._functions && (desc$1.functions = this._functions), desc$1;
    }
    static build(desc$1) {
      return new internals$24.Template(desc$1.template, desc$1.options || desc$1.functions ? { ...desc$1.options, functions: desc$1.functions } : void 0);
    }
    isDynamic() {
      return !!this._template;
    }
    static isTemplate(template) {
      return template ? !!template[Common$23.symbols.template] : false;
    }
    refs() {
      if (!this._template) return;
      let refs = [];
      for (let part of this._template) typeof part != `string` && refs.push(...part.refs);
      return refs;
    }
    resolve(value, state, prefs, local) {
      return this._template && this._template.length === 1 ? this._part(this._template[0], value, state, prefs, local, {}) : this.render(value, state, prefs, local);
    }
    _part(part, ...args$1) {
      return part.ref ? part.ref.resolve(...args$1) : part.formula.evaluate(args$1);
    }
    render(value, state, prefs, local, options = {}) {
      if (!this.isDynamic()) return this.rendered;
      let parts = [];
      for (let part of this._template) if (typeof part == `string`) parts.push(part);
      else {
        let rendered = this._part(part, value, state, prefs, local, options), string = internals$24.stringify(rendered, value, state, prefs, local, options);
        if (string !== void 0) {
          let result = part.raw || (options.errors && options.errors.escapeHtml) === false ? string : escapeHtml$1(string);
          parts.push(internals$24.wrap(result, part.wrapped && prefs.errors.wrap.label));
        }
      }
      return parts.join(``);
    }
    _ref(content, { raw, wrapped }) {
      let refs = [], reference = (variable) => {
        let ref = Ref$11.create(variable, this._settings);
        return refs.push(ref), (context) => {
          let resolved = ref.resolve(...context);
          return resolved === void 0 ? null : resolved;
        };
      };
      try {
        let functions = this._functions ? { ...internals$24.functions, ...this._functions } : internals$24.functions;
        var formula = new Formula.Parser(content, { reference, functions, constants: internals$24.constants });
      } catch (err$1) {
        throw err$1.message = `Invalid template variable "${content}" fails due to: ${err$1.message}`, err$1;
      }
      if (formula.single) {
        if (formula.single.type === `reference`) {
          let ref = refs[0];
          return { ref, raw, refs, wrapped: wrapped || ref.type === `local` && ref.key === `label` };
        }
        return internals$24.stringify(formula.single.value);
      }
      return { formula, raw, refs };
    }
    toString() {
      return this.source;
    }
  }, internals$24.Template.prototype[Common$23.symbols.template] = true, internals$24.Template.prototype.isImmutable = true, internals$24.encode = function(string) {
    return string.replace(/\\(\{+)/g, ($0, $1) => internals$24.opens.slice(0, $1.length)).replace(/\\(\}+)/g, ($0, $1) => internals$24.closes.slice(0, $1.length));
  }, internals$24.decode = function(string) {
    return string.replace(/\u0000/g, `{`).replace(/\u0001/g, `}`);
  }, internals$24.split = function(string) {
    let parts = [], current = ``;
    for (let i$4 = 0; i$4 < string.length; ++i$4) {
      let char = string[i$4];
      if (char === `{`) {
        let next = ``;
        for (; i$4 + 1 < string.length && string[i$4 + 1] === `{`; ) next += `{`, ++i$4;
        parts.push(current), current = next;
      } else current += char;
    }
    return parts.push(current), parts;
  }, internals$24.wrap = function(value, ends) {
    return ends ? ends.length === 1 ? `${ends}${value}${ends}` : `${ends[0]}${value}${ends[1]}` : value;
  }, internals$24.stringify = function(value, original, state, prefs, local, options = {}) {
    let type = typeof value, wrap$2 = prefs && prefs.errors && prefs.errors.wrap || {}, skipWrap = false;
    if (Ref$11.isRef(value) && value.render && (skipWrap = value.in, value = value.resolve(original, state, prefs, local, { in: value.in, ...options })), value === null) return `null`;
    if (type === `string`) return internals$24.wrap(value, options.arrayItems && wrap$2.string);
    if (type === `number` || type === `function` || type === `symbol`) return value.toString();
    if (type !== `object`) return JSON.stringify(value);
    if (value instanceof Date) return internals$24.Template.date(value, prefs);
    if (value instanceof Map) {
      let pairs = [];
      for (let [key, sym] of value.entries()) pairs.push(`${key.toString()} -> ${sym.toString()}`);
      value = pairs;
    }
    if (!Array.isArray(value)) return value.toString();
    let values$3 = [];
    for (let item of value) values$3.push(internals$24.stringify(item, original, state, prefs, local, { arrayItems: true, ...options }));
    return internals$24.wrap(values$3.join(`, `), !skipWrap && wrap$2.array);
  }, internals$24.constants = { true: true, false: false, null: null, second: 1e3, minute: 60 * 1e3, hour: 60 * 60 * 1e3, day: 24 * 60 * 60 * 1e3 }, internals$24.functions = { if(condition, then, otherwise) {
    return condition ? then : otherwise;
  }, length(item) {
    return typeof item == `string` ? item.length : !item || typeof item != `object` ? null : Array.isArray(item) ? item.length : Object.keys(item).length;
  }, msg(code$2) {
    let [value, state, prefs, local, options] = this, messages$3 = options.messages;
    if (!messages$3) return ``;
    let template = Errors$8.template(value, messages$3[0], code$2, state, prefs) || Errors$8.template(value, messages$3[1], code$2, state, prefs);
    return template ? template.render(value, state, prefs, local, options) : ``;
  }, number(value) {
    return typeof value == `number` ? value : typeof value == `string` ? parseFloat(value) : typeof value == `boolean` ? value ? 1 : 0 : value instanceof Date ? value.getTime() : null;
  } };
}), require_ref$2 = __commonJSMin$1((exports$12) => {
  let { assert: assert$50, clone: clone$17, reach: reach$4 } = require_lib$4(), Common$22 = require_common$3(), Template$7, internals$23 = { symbol: Symbol(`ref`), defaults: { adjust: null, in: false, iterables: null, map: null, separator: `.`, type: `value` } };
  exports$12.create = function(key, options = {}) {
    assert$50(typeof key == `string`, `Invalid reference key:`, key), Common$22.assertOptions(options, [`adjust`, `ancestor`, `in`, `iterables`, `map`, `prefix`, `render`, `separator`]), assert$50(!options.prefix || typeof options.prefix == `object`, `options.prefix must be of type object`);
    let ref = Object.assign({}, internals$23.defaults, options);
    delete ref.prefix;
    let separator = ref.separator, context = internals$23.context(key, separator, options.prefix);
    if (ref.type = context.type, key = context.key, ref.type === `value`) if (context.root && (assert$50(!separator || key[0] !== separator, `Cannot specify relative path with root prefix`), ref.ancestor = `root`, key ||= null), separator && separator === key) key = null, ref.ancestor = 0;
    else if (ref.ancestor !== void 0) assert$50(!separator || !key || key[0] !== separator, `Cannot combine prefix with ancestor option`);
    else {
      let [ancestor, slice$1] = internals$23.ancestor(key, separator);
      slice$1 && (key = key.slice(slice$1), key === `` && (key = null)), ref.ancestor = ancestor;
    }
    return ref.path = separator ? key === null ? [] : key.split(separator) : [key], new internals$23.Ref(ref);
  }, exports$12.in = function(key, options = {}) {
    return exports$12.create(key, { ...options, in: true });
  }, exports$12.isRef = function(ref) {
    return ref ? !!ref[Common$22.symbols.ref] : false;
  }, internals$23.Ref = class {
    constructor(options) {
      assert$50(typeof options == `object`, `Invalid reference construction`), Common$22.assertOptions(options, [`adjust`, `ancestor`, `in`, `iterables`, `map`, `path`, `render`, `separator`, `type`, `depth`, `key`, `root`, `display`]), assert$50([false, void 0].includes(options.separator) || typeof options.separator == `string` && options.separator.length === 1, `Invalid separator`), assert$50(!options.adjust || typeof options.adjust == `function`, `options.adjust must be a function`), assert$50(!options.map || Array.isArray(options.map), `options.map must be an array`), assert$50(!options.map || !options.adjust, `Cannot set both map and adjust options`), Object.assign(this, internals$23.defaults, options), assert$50(this.type === `value` || this.ancestor === void 0, `Non-value references cannot reference ancestors`), Array.isArray(this.map) && (this.map = new Map(this.map)), this.depth = this.path.length, this.key = this.path.length ? this.path.join(this.separator) : null, this.root = this.path[0], this.updateDisplay();
    }
    resolve(value, state, prefs, local, options = {}) {
      return assert$50(!this.in || options.in, `Invalid in() reference usage`), this.type === `global` ? this._resolve(prefs.context, state, options) : this.type === `local` ? this._resolve(local, state, options) : this.ancestor ? this.ancestor === `root` ? this._resolve(state.ancestors[state.ancestors.length - 1], state, options) : (assert$50(this.ancestor <= state.ancestors.length, `Invalid reference exceeds the schema root:`, this.display), this._resolve(state.ancestors[this.ancestor - 1], state, options)) : this._resolve(value, state, options);
    }
    _resolve(target, state, options) {
      let resolved;
      if (this.type === `value` && state.mainstay.shadow && options.shadow !== false && (resolved = state.mainstay.shadow.get(this.absolute(state))), resolved === void 0 && (resolved = reach$4(target, this.path, { iterables: this.iterables, functions: true })), this.adjust && (resolved = this.adjust(resolved)), this.map) {
        let mapped = this.map.get(resolved);
        mapped !== void 0 && (resolved = mapped);
      }
      return state.mainstay && state.mainstay.tracer.resolve(state, this, resolved), resolved;
    }
    toString() {
      return this.display;
    }
    absolute(state) {
      return [...state.path.slice(0, -this.ancestor), ...this.path];
    }
    clone() {
      return new internals$23.Ref(this);
    }
    describe() {
      let ref = { path: this.path };
      this.type !== `value` && (ref.type = this.type), this.separator !== `.` && (ref.separator = this.separator), this.type === `value` && this.ancestor !== 1 && (ref.ancestor = this.ancestor), this.map && (ref.map = [...this.map]);
      for (let key of [`adjust`, `iterables`, `render`]) this[key] !== null && this[key] !== void 0 && (ref[key] = this[key]);
      return this.in !== false && (ref.in = true), { ref };
    }
    updateDisplay() {
      let key = this.key === null ? `` : this.key;
      if (this.type !== `value`) {
        this.display = `ref:${this.type}:${key}`;
        return;
      }
      if (!this.separator) {
        this.display = `ref:${key}`;
        return;
      }
      if (!this.ancestor) {
        this.display = `ref:${this.separator}${key}`;
        return;
      }
      if (this.ancestor === `root`) {
        this.display = `ref:root:${key}`;
        return;
      }
      if (this.ancestor === 1) {
        this.display = `ref:${key || `..`}`;
        return;
      }
      let lead = Array(this.ancestor + 1).fill(this.separator).join(``);
      this.display = `ref:${lead}${key || ``}`;
    }
  }, internals$23.Ref.prototype[Common$22.symbols.ref] = true, exports$12.build = function(desc$1) {
    return desc$1 = Object.assign({}, internals$23.defaults, desc$1), desc$1.type === `value` && desc$1.ancestor === void 0 && (desc$1.ancestor = 1), new internals$23.Ref(desc$1);
  }, internals$23.context = function(key, separator, prefix = {}) {
    if (key = key.trim(), prefix) {
      let globalp = prefix.global === void 0 ? `$` : prefix.global;
      if (globalp !== separator && key.startsWith(globalp)) return { key: key.slice(globalp.length), type: `global` };
      let local = prefix.local === void 0 ? `#` : prefix.local;
      if (local !== separator && key.startsWith(local)) return { key: key.slice(local.length), type: `local` };
      let root$11 = prefix.root === void 0 ? `/` : prefix.root;
      if (root$11 !== separator && key.startsWith(root$11)) return { key: key.slice(root$11.length), type: `value`, root: true };
    }
    return { key, type: `value` };
  }, internals$23.ancestor = function(key, separator) {
    if (!separator || key[0] !== separator) return [1, 0];
    if (key[1] !== separator) return [0, 1];
    let i$4 = 2;
    for (; key[i$4] === separator; ) ++i$4;
    return [i$4 - 1, i$4];
  }, exports$12.toSibling = 0, exports$12.toParent = 1, exports$12.Manager = class {
    constructor() {
      this.refs = [];
    }
    register(source, target) {
      if (source) {
        if (target = target === void 0 ? exports$12.toParent : target, Array.isArray(source)) {
          for (let ref of source) this.register(ref, target);
          return;
        }
        if (Common$22.isSchema(source)) {
          for (let item of source._refs.refs) item.ancestor - target >= 0 && this.refs.push({ ancestor: item.ancestor - target, root: item.root });
          return;
        }
        exports$12.isRef(source) && source.type === `value` && source.ancestor - target >= 0 && this.refs.push({ ancestor: source.ancestor - target, root: source.root }), Template$7 ||= require_template(), Template$7.isTemplate(source) && this.register(source.refs(), target);
      }
    }
    get length() {
      return this.refs.length;
    }
    clone() {
      let copy = new exports$12.Manager();
      return copy.refs = clone$17(this.refs), copy;
    }
    reset() {
      this.refs = [];
    }
    roots() {
      return this.refs.filter((ref) => !ref.ancestor).map((ref) => ref.root);
    }
  };
}), require_compile = __commonJSMin$1((exports$12) => {
  let { assert: assert$49 } = require_lib$4(), Common$21 = require_common$3(), Ref$10 = require_ref$2(), internals$22 = {};
  exports$12.schema = function(Joi$2, config, options = {}) {
    Common$21.assertOptions(options, [`appendPath`, `override`]);
    try {
      return internals$22.schema(Joi$2, config, options);
    } catch (err$1) {
      throw options.appendPath && err$1.path !== void 0 && (err$1.message = `${err$1.message} (${err$1.path})`), err$1;
    }
  }, internals$22.schema = function(Joi$2, config, options) {
    assert$49(config !== void 0, `Invalid undefined schema`), Array.isArray(config) && (assert$49(config.length, `Invalid empty array schema`), config.length === 1 && (config = config[0]));
    let valid$2 = (base$3, ...values$3) => options.override === false ? base$3.valid(...values$3) : base$3.valid(Joi$2.override, ...values$3);
    if (internals$22.simple(config)) return valid$2(Joi$2, config);
    if (typeof config == `function`) return Joi$2.custom(config);
    if (assert$49(typeof config == `object`, `Invalid schema content:`, typeof config), Common$21.isResolvable(config)) return valid$2(Joi$2, config);
    if (Common$21.isSchema(config)) return config;
    if (Array.isArray(config)) {
      for (let item of config) if (!internals$22.simple(item)) return Joi$2.alternatives().try(...config);
      return valid$2(Joi$2, ...config);
    }
    return config instanceof RegExp ? Joi$2.string().regex(config) : config instanceof Date ? valid$2(Joi$2.date(), config) : (assert$49(Object.getPrototypeOf(config) === Object.getPrototypeOf({}), `Schema can only contain plain objects`), Joi$2.object().keys(config));
  }, exports$12.ref = function(id, options) {
    return Ref$10.isRef(id) ? id : Ref$10.create(id, options);
  }, exports$12.compile = function(root$11, schema$2, options = {}) {
    Common$21.assertOptions(options, [`legacy`]);
    let any = schema$2 && schema$2[Common$21.symbols.any];
    if (any) return assert$49(options.legacy || any.version === Common$21.version, `Cannot mix different versions of joi schemas:`, any.version, Common$21.version), schema$2;
    if (typeof schema$2 != `object` || !options.legacy) return exports$12.schema(root$11, schema$2, { appendPath: true });
    let compiler = internals$22.walk(schema$2);
    return compiler ? compiler.compile(compiler.root, schema$2) : exports$12.schema(root$11, schema$2, { appendPath: true });
  }, internals$22.walk = function(schema$2) {
    if (typeof schema$2 != `object`) return null;
    if (Array.isArray(schema$2)) {
      for (let item of schema$2) {
        let compiler = internals$22.walk(item);
        if (compiler) return compiler;
      }
      return null;
    }
    let any = schema$2[Common$21.symbols.any];
    if (any) return { root: schema$2[any.root], compile: any.compile };
    for (let key in assert$49(Object.getPrototypeOf(schema$2) === Object.getPrototypeOf({}), `Schema can only contain plain objects`), schema$2) {
      let compiler = internals$22.walk(schema$2[key]);
      if (compiler) return compiler;
    }
    return null;
  }, internals$22.simple = function(value) {
    return value === null || [`boolean`, `string`, `number`].includes(typeof value);
  }, exports$12.when = function(schema$2, condition, options) {
    if (options === void 0 && (assert$49(condition && typeof condition == `object`, `Missing options`), options = condition, condition = Ref$10.create(`.`)), Array.isArray(options) && (options = { switch: options }), Common$21.assertOptions(options, [`is`, `not`, `then`, `otherwise`, `switch`, `break`]), Common$21.isSchema(condition)) return assert$49(options.is === void 0, `"is" can not be used with a schema condition`), assert$49(options.not === void 0, `"not" can not be used with a schema condition`), assert$49(options.switch === void 0, `"switch" can not be used with a schema condition`), internals$22.condition(schema$2, { is: condition, then: options.then, otherwise: options.otherwise, break: options.break });
    if (assert$49(Ref$10.isRef(condition) || typeof condition == `string`, `Invalid condition:`, condition), assert$49(options.not === void 0 || options.is === void 0, `Cannot combine "is" with "not"`), options.switch === void 0) {
      let rule$1 = options;
      options.not !== void 0 && (rule$1 = { is: options.not, then: options.otherwise, otherwise: options.then, break: options.break });
      let is = rule$1.is === void 0 ? schema$2.$_root.invalid(null, false, 0, ``).required() : schema$2.$_compile(rule$1.is);
      return assert$49(rule$1.then !== void 0 || rule$1.otherwise !== void 0, `options must have at least one of "then", "otherwise", or "switch"`), assert$49(rule$1.break === void 0 || rule$1.then === void 0 || rule$1.otherwise === void 0, `Cannot specify then, otherwise, and break all together`), options.is !== void 0 && !Ref$10.isRef(options.is) && !Common$21.isSchema(options.is) && (is = is.required()), internals$22.condition(schema$2, { ref: exports$12.ref(condition), is, then: rule$1.then, otherwise: rule$1.otherwise, break: rule$1.break });
    }
    assert$49(Array.isArray(options.switch), `"switch" must be an array`), assert$49(options.is === void 0, `Cannot combine "switch" with "is"`), assert$49(options.not === void 0, `Cannot combine "switch" with "not"`), assert$49(options.then === void 0, `Cannot combine "switch" with "then"`);
    let rule = { ref: exports$12.ref(condition), switch: [], break: options.break };
    for (let i$4 = 0; i$4 < options.switch.length; ++i$4) {
      let test = options.switch[i$4], last$2 = i$4 === options.switch.length - 1;
      Common$21.assertOptions(test, last$2 ? [`is`, `then`, `otherwise`] : [`is`, `then`]), assert$49(test.is !== void 0, `Switch statement missing "is"`), assert$49(test.then !== void 0, `Switch statement missing "then"`);
      let item = { is: schema$2.$_compile(test.is), then: schema$2.$_compile(test.then) };
      if (!Ref$10.isRef(test.is) && !Common$21.isSchema(test.is) && (item.is = item.is.required()), last$2) {
        assert$49(options.otherwise === void 0 || test.otherwise === void 0, `Cannot specify "otherwise" inside and outside a "switch"`);
        let otherwise = options.otherwise === void 0 ? test.otherwise : options.otherwise;
        otherwise !== void 0 && (assert$49(rule.break === void 0, `Cannot specify both otherwise and break`), item.otherwise = schema$2.$_compile(otherwise));
      }
      rule.switch.push(item);
    }
    return rule;
  }, internals$22.condition = function(schema$2, condition) {
    for (let key of [`then`, `otherwise`]) condition[key] === void 0 ? delete condition[key] : condition[key] = schema$2.$_compile(condition[key]);
    return condition;
  };
}), require_messages = __commonJSMin$1((exports$12) => {
  let { assert: assert$48, clone: clone$16 } = require_lib$4(), Template$6 = require_template();
  exports$12.compile = function(messages$3, target) {
    if (typeof messages$3 == `string`) return assert$48(!target, `Cannot set single message string`), new Template$6(messages$3);
    if (Template$6.isTemplate(messages$3)) return assert$48(!target, `Cannot set single message template`), messages$3;
    for (let code$2 in assert$48(typeof messages$3 == `object` && !Array.isArray(messages$3), `Invalid message options`), target = target ? clone$16(target) : {}, messages$3) {
      let message = messages$3[code$2];
      if (code$2 === `root` || Template$6.isTemplate(message)) {
        target[code$2] = message;
        continue;
      }
      if (typeof message == `string`) {
        target[code$2] = new Template$6(message);
        continue;
      }
      assert$48(typeof message == `object` && !Array.isArray(message), `Invalid message for`, code$2);
      let language = code$2;
      for (code$2 in target[language] = target[language] || {}, message) {
        let localized = message[code$2];
        if (code$2 === `root` || Template$6.isTemplate(localized)) {
          target[language][code$2] = localized;
          continue;
        }
        assert$48(typeof localized == `string`, `Invalid message for`, code$2, `in`, language), target[language][code$2] = new Template$6(localized);
      }
    }
    return target;
  }, exports$12.decompile = function(messages$3) {
    let target = {};
    for (let code$2 in messages$3) {
      let message = messages$3[code$2];
      if (code$2 === `root`) {
        target.root = message;
        continue;
      }
      if (Template$6.isTemplate(message)) {
        target[code$2] = message.describe({ compact: true });
        continue;
      }
      let language = code$2;
      for (code$2 in target[language] = {}, message) {
        let localized = message[code$2];
        if (code$2 === `root`) {
          target[language].root = localized;
          continue;
        }
        target[language][code$2] = localized.describe({ compact: true });
      }
    }
    return target;
  }, exports$12.merge = function(base$3, extended) {
    if (!base$3) return exports$12.compile(extended);
    if (!extended) return base$3;
    if (typeof extended == `string`) return new Template$6(extended);
    if (Template$6.isTemplate(extended)) return extended;
    let target = clone$16(base$3);
    for (let code$2 in extended) {
      let message = extended[code$2];
      if (code$2 === `root` || Template$6.isTemplate(message)) {
        target[code$2] = message;
        continue;
      }
      if (typeof message == `string`) {
        target[code$2] = new Template$6(message);
        continue;
      }
      assert$48(typeof message == `object` && !Array.isArray(message), `Invalid message for`, code$2);
      let language = code$2;
      for (code$2 in target[language] = target[language] || {}, message) {
        let localized = message[code$2];
        if (code$2 === `root` || Template$6.isTemplate(localized)) {
          target[language][code$2] = localized;
          continue;
        }
        assert$48(typeof localized == `string`, `Invalid message for`, code$2, `in`, language), target[language][code$2] = new Template$6(localized);
      }
    }
    return target;
  };
}), require_extend$1 = __commonJSMin$1((exports$12) => {
  let { assert: assert$47, clone: clone$15 } = require_lib$4(), Common$20 = require_common$3(), Messages$6 = require_messages(), internals$21 = {};
  exports$12.type = function(from$2, options) {
    let base$3 = Object.getPrototypeOf(from$2), prototype = clone$15(base$3), schema$2 = from$2._assign(Object.create(prototype)), def = Object.assign({}, options);
    delete def.base, prototype._definition = def;
    let parent = base$3._definition || {};
    def.messages = Messages$6.merge(parent.messages, def.messages), def.properties = Object.assign({}, parent.properties, def.properties), schema$2.type = def.type, def.flags = Object.assign({}, parent.flags, def.flags);
    let terms = Object.assign({}, parent.terms);
    if (def.terms) for (let name$2 in def.terms) {
      let term = def.terms[name$2];
      assert$47(schema$2.$_terms[name$2] === void 0, `Invalid term override for`, def.type, name$2), schema$2.$_terms[name$2] = term.init, terms[name$2] = term;
    }
    def.terms = terms, def.args ||= parent.args, def.prepare = internals$21.prepare(def.prepare, parent.prepare), def.coerce && (typeof def.coerce == `function` && (def.coerce = { method: def.coerce }), def.coerce.from && !Array.isArray(def.coerce.from) && (def.coerce = { method: def.coerce.method, from: [].concat(def.coerce.from) })), def.coerce = internals$21.coerce(def.coerce, parent.coerce), def.validate = internals$21.validate(def.validate, parent.validate);
    let rules = Object.assign({}, parent.rules);
    if (def.rules) for (let name$2 in def.rules) {
      let rule = def.rules[name$2];
      assert$47(typeof rule == `object`, `Invalid rule definition for`, def.type, name$2);
      let method$1 = rule.method;
      if (method$1 === void 0 && (method$1 = function() {
        return this.$_addRule(name$2);
      }), method$1 && (assert$47(!prototype[name$2], `Rule conflict in`, def.type, name$2), prototype[name$2] = method$1), assert$47(!rules[name$2], `Rule conflict in`, def.type, name$2), rules[name$2] = rule, rule.alias) {
        let aliases$1 = [].concat(rule.alias);
        for (let alias of aliases$1) prototype[alias] = rule.method;
      }
      rule.args && (rule.argsByName = /* @__PURE__ */ new Map(), rule.args = rule.args.map((arg) => (typeof arg == `string` && (arg = { name: arg }), assert$47(!rule.argsByName.has(arg.name), `Duplicated argument name`, arg.name), Common$20.isSchema(arg.assert) && (arg.assert = arg.assert.strict().label(arg.name)), rule.argsByName.set(arg.name, arg), arg)));
    }
    def.rules = rules;
    let modifiers$1 = Object.assign({}, parent.modifiers);
    if (def.modifiers) for (let name$2 in def.modifiers) {
      assert$47(!prototype[name$2], `Rule conflict in`, def.type, name$2);
      let modifier = def.modifiers[name$2];
      assert$47(typeof modifier == `function`, `Invalid modifier definition for`, def.type, name$2);
      let method$1 = function(arg) {
        return this.rule({ [name$2]: arg });
      };
      prototype[name$2] = method$1, modifiers$1[name$2] = modifier;
    }
    if (def.modifiers = modifiers$1, def.overrides) {
      for (let override in prototype._super = base$3, schema$2.$_super = {}, def.overrides) assert$47(base$3[override], `Cannot override missing`, override), def.overrides[override][Common$20.symbols.parent] = base$3[override], schema$2.$_super[override] = base$3[override].bind(schema$2);
      Object.assign(prototype, def.overrides);
    }
    def.cast = Object.assign({}, parent.cast, def.cast);
    let manifest = Object.assign({}, parent.manifest, def.manifest);
    return manifest.build = internals$21.build(def.manifest && def.manifest.build, parent.manifest && parent.manifest.build), def.manifest = manifest, def.rebuild = internals$21.rebuild(def.rebuild, parent.rebuild), schema$2;
  }, internals$21.build = function(child, parent) {
    return !child || !parent ? child || parent : function(obj, desc$1) {
      return parent(child(obj, desc$1), desc$1);
    };
  }, internals$21.coerce = function(child, parent) {
    return !child || !parent ? child || parent : { from: child.from && parent.from ? [.../* @__PURE__ */ new Set([...child.from, ...parent.from])] : null, method(value, helpers$8) {
      let coerced;
      if ((!parent.from || parent.from.includes(typeof value)) && (coerced = parent.method(value, helpers$8), coerced)) {
        if (coerced.errors || coerced.value === void 0) return coerced;
        value = coerced.value;
      }
      if (!child.from || child.from.includes(typeof value)) {
        let own = child.method(value, helpers$8);
        if (own) return own;
      }
      return coerced;
    } };
  }, internals$21.prepare = function(child, parent) {
    return !child || !parent ? child || parent : function(value, helpers$8) {
      let prepared = child(value, helpers$8);
      if (prepared) {
        if (prepared.errors || prepared.value === void 0) return prepared;
        value = prepared.value;
      }
      return parent(value, helpers$8) || prepared;
    };
  }, internals$21.rebuild = function(child, parent) {
    return !child || !parent ? child || parent : function(schema$2) {
      parent(schema$2), child(schema$2);
    };
  }, internals$21.validate = function(child, parent) {
    return !child || !parent ? child || parent : function(value, helpers$8) {
      let result = parent(value, helpers$8);
      if (result) {
        if (result.errors && (!Array.isArray(result.errors) || result.errors.length)) return result;
        value = result.value;
      }
      return child(value, helpers$8) || result;
    };
  };
}), import_assert, import_clone, import_escapeRegex, init_lib = __esmMin(() => {
  __toESM(require_applyToDefaults(), 1), import_assert = __toESM(require_assert$1(), 1), __toESM(require_bench(), 1), __toESM(require_block(), 1), import_clone = __toESM(require_clone$1(), 1), __toESM(require_contain(), 1), __toESM(require_deepEqual(), 1), __toESM(require_assertError(), 1), __toESM(require_escapeHeaderAttribute(), 1), __toESM(require_escapeHtml(), 1), __toESM(require_escapeJson(), 1), import_escapeRegex = __toESM(require_escapeRegex(), 1), __toESM(require_flatten$1(), 1), __toESM(require_ignore(), 1), __toESM(require_intersect(), 1), __toESM(require_isPromise(), 1), __toESM(require_merge(), 1), __toESM(require_once(), 1), __toESM(require_reach(), 1), __toESM(require_reachTemplate(), 1), __toESM(require_stringify(), 1), __toESM(require_wait(), 1);
}), require_manifest = __commonJSMin$1((exports$12) => {
  init_dist$1();
  var import_schemas$1 = __toESM(require_schemas()), import_template$2 = __toESM(require_template()), import_ref$2 = __toESM(require_ref$2()), import_messages$2 = __toESM(require_messages()), import_common$2 = __toESM(require_common$3());
  init_lib();
  let Common$19 = import_common$2.default, Messages$5 = import_messages$2.default, Ref$9 = import_ref$2.default, Template$5 = import_template$2.default, ManifestDescriptionCache = /* @__PURE__ */ new Map();
  var ManifestItemCacheClass = class {
    #items = /* @__PURE__ */ new Map();
    get(item, options = {}) {
      let cached = this.#items.get(item);
      if (cached) return cached.get(options);
    }
    set(item, options = {}, value) {
      this.#items.has(item) || this.#items.set(item, /* @__PURE__ */ new Map()), this.#items.get(item).set(options, value);
    }
    setAndReturn(item, options = {}, value) {
      return this.set(item, options, value), value;
    }
  };
  let ManifestItemCache = new ManifestItemCacheClass(), Schemas$3, internals$20 = {};
  exports$12.describe = function(schema$2) {
    let cached = ManifestDescriptionCache.get(schema$2);
    if (cached) return cached;
    let def = schema$2._definition, desc$1 = { type: schema$2.type, flags: {}, rules: [] };
    for (let flag in schema$2._flags) flag[0] !== `_` && (desc$1.flags[flag] = internals$20.describe(schema$2._flags[flag]));
    Object.keys(desc$1.flags).length || delete desc$1.flags, schema$2._preferences && (desc$1.preferences = (0, import_clone.default)(schema$2._preferences, { shallow: [`messages`] }), delete desc$1.preferences[Common$19.symbols.prefs], desc$1.preferences.messages && (desc$1.preferences.messages = Messages$5.decompile(desc$1.preferences.messages))), schema$2._valids && (desc$1.allow = schema$2._valids.describe()), schema$2._invalids && (desc$1.invalid = schema$2._invalids.describe());
    for (let rule of schema$2._rules) {
      let ruleDef = def.rules[rule.name];
      if (ruleDef.manifest === false) continue;
      let item = { name: rule.name };
      for (let custom$1 in def.modifiers) rule[custom$1] !== void 0 && (item[custom$1] = internals$20.describe(rule[custom$1]));
      if (rule.args) {
        for (let key in item.args = {}, rule.args) {
          let arg = rule.args[key];
          if (key === `options` && !Object.keys(arg).length) continue;
          item.args[key] = internals$20.describe(arg, { assign: key });
        }
        Object.keys(item.args).length || delete item.args;
      }
      desc$1.rules.push(item);
    }
    for (let term in desc$1.rules.length || delete desc$1.rules, schema$2.$_terms) {
      if (term[0] === `_`) continue;
      (0, import_assert.default)(!desc$1[term], `Cannot describe schema due to internal name conflict with`, term);
      let items = schema$2.$_terms[term];
      if (!items) continue;
      if (items instanceof Map) {
        items.size && (desc$1[term] = [...items.entries()]);
        continue;
      }
      if (Common$19.isValues(items)) {
        desc$1[term] = items.describe();
        continue;
      }
      (0, import_assert.default)(def.terms[term], `Term`, term, `missing configuration`);
      let manifest = def.terms[term].manifest, mapped = typeof manifest == `object`;
      if (!items.length && !mapped) continue;
      let normalized = [];
      for (let item of items) normalized.push(internals$20.describe(item));
      if (mapped) {
        let { from: from$2, to } = manifest.mapped;
        desc$1[term] = {};
        for (let item of normalized) desc$1[term][item[to]] = item[from$2];
        continue;
      }
      if (manifest === `single`) {
        (0, import_assert.default)(normalized.length === 1, `Term`, term, `contains more than one item`), desc$1[term] = normalized[0];
        continue;
      }
      desc$1[term] = normalized;
    }
    return internals$20.validate(schema$2.$_root, desc$1), ManifestDescriptionCache.set(schema$2, desc$1), desc$1;
  }, internals$20.describe = function(item, options = {}) {
    let cached = ManifestItemCache.get(item, options);
    if (cached) return cached;
    if (Array.isArray(item)) return ManifestItemCache.setAndReturn(item, options, item.map(internals$20.describe));
    if (item === Common$19.symbols.deepDefault) return ManifestItemCache.setAndReturn(item, options, { special: `deep` });
    if (typeof item != `object` || !item) return ManifestItemCache.setAndReturn(item, options, item);
    if (options.assign === `options`) return ManifestItemCache.setAndReturn(item, options, (0, import_clone.default)(item));
    if (Buffer$1 && Buffer$1.isBuffer(item)) return ManifestItemCache.setAndReturn(item, options, { buffer: item.toString(`binary`) });
    if (item instanceof Date) return ManifestItemCache.setAndReturn(item, options, item.toISOString());
    if (item instanceof Error) return ManifestItemCache.setAndReturn(item, options, item);
    if (item instanceof RegExp) return options.assign === `regex` ? ManifestItemCache.setAndReturn(item, options, item.toString()) : ManifestItemCache.setAndReturn(item, options, { regex: item.toString() });
    if (item[Common$19.symbols.literal]) return ManifestItemCache.setAndReturn(item, options, { function: item.literal });
    if (typeof item.describe == `function`) return options.assign === `ref` ? ManifestItemCache.setAndReturn(item, options, item.describe().ref) : ManifestItemCache.setAndReturn(item, options, item.describe());
    let normalized = {};
    for (let key in item) {
      let value = item[key];
      if (value === void 0) continue;
      normalized[key] = internals$20.describe(value, { assign: key });
    }
    return ManifestItemCache.setAndReturn(item, options, normalized);
  }, exports$12.build = function(joi, desc$1) {
    let builder = new internals$20.Builder(joi);
    return builder.parse(desc$1);
  }, internals$20.Builder = class {
    constructor(joi) {
      this.joi = joi;
    }
    parse(desc$1) {
      internals$20.validate(this.joi, desc$1);
      let schema$2 = this.joi[desc$1.type]()._bare(), def = schema$2._definition;
      if (desc$1.flags) for (let flag in desc$1.flags) {
        let setter = def.flags[flag] && def.flags[flag].setter || flag;
        (0, import_assert.default)(typeof schema$2[setter] == `function`, `Invalid flag`, flag, `for type`, desc$1.type), schema$2 = schema$2[setter](this.build(desc$1.flags[flag]));
      }
      if (desc$1.preferences && (schema$2 = schema$2.preferences(this.build(desc$1.preferences))), desc$1.allow && (schema$2 = schema$2.allow(...this.build(desc$1.allow))), desc$1.invalid && (schema$2 = schema$2.invalid(...this.build(desc$1.invalid))), desc$1.rules) for (let rule of desc$1.rules) {
        (0, import_assert.default)(typeof schema$2[rule.name] == `function`, `Invalid rule`, rule.name, `for type`, desc$1.type);
        let args$1 = [];
        if (rule.args) {
          let built = {};
          for (let key in rule.args) built[key] = this.build(rule.args[key], { assign: key });
          let keys$10 = Object.keys(built), definition = def.rules[rule.name].args;
          if (definition) {
            (0, import_assert.default)(keys$10.length <= definition.length, `Invalid number of arguments for`, desc$1.type, rule.name, `(expected up to`, definition.length, `, found`, keys$10.length, `)`);
            for (let { name: name$2 } of definition) args$1.push(built[name$2]);
          } else (0, import_assert.default)(keys$10.length === 1, `Invalid number of arguments for`, desc$1.type, rule.name, `(expected up to 1, found`, keys$10.length, `)`), args$1.push(built[keys$10[0]]);
        }
        schema$2 = schema$2[rule.name](...args$1);
        let options = {};
        for (let custom$1 in def.modifiers) rule[custom$1] !== void 0 && (options[custom$1] = this.build(rule[custom$1]));
        Object.keys(options).length && (schema$2 = schema$2.rule(options));
      }
      let terms = {};
      for (let key in desc$1) {
        if ([`allow`, `flags`, `invalid`, `whens`, `preferences`, `rules`, `type`].includes(key)) continue;
        (0, import_assert.default)(def.terms[key], `Term`, key, `missing configuration`);
        let manifest = def.terms[key].manifest;
        if (manifest === `schema`) {
          terms[key] = desc$1[key].map((item) => this.parse(item));
          continue;
        }
        if (manifest === `values`) {
          terms[key] = desc$1[key].map((item) => this.build(item));
          continue;
        }
        if (manifest === `single`) {
          terms[key] = this.build(desc$1[key]);
          continue;
        }
        if (typeof manifest == `object`) {
          for (let name$2 in terms[key] = {}, desc$1[key]) {
            let value = desc$1[key][name$2];
            terms[key][name$2] = this.parse(value);
          }
          continue;
        }
        terms[key] = this.build(desc$1[key]);
      }
      return desc$1.whens && (terms.whens = desc$1.whens.map((when) => this.build(when))), schema$2 = def.manifest.build(schema$2, terms), schema$2.$_temp.ruleset = false, schema$2;
    }
    build(desc$1, options = {}) {
      if (desc$1 === null) return null;
      if (Array.isArray(desc$1)) return desc$1.map((item) => this.build(item));
      if (desc$1 instanceof Error) return desc$1;
      if (options.assign === `options`) return (0, import_clone.default)(desc$1);
      if (options.assign === `regex`) return internals$20.regex(desc$1);
      if (options.assign === `ref`) return Ref$9.build(desc$1);
      if (typeof desc$1 != `object`) return desc$1;
      if (Object.keys(desc$1).length === 1) {
        if (desc$1.buffer) return (0, import_assert.default)(Buffer$1, `Buffers are not supported`), Buffer$1 && Buffer$1.from(desc$1.buffer, `binary`);
        if (desc$1.function) return { [Common$19.symbols.literal]: true, literal: desc$1.function };
        if (desc$1.override) return Common$19.symbols.override;
        if (desc$1.ref) return Ref$9.build(desc$1.ref);
        if (desc$1.regex) return internals$20.regex(desc$1.regex);
        if (desc$1.special) return (0, import_assert.default)([`deep`].includes(desc$1.special), `Unknown special value`, desc$1.special), Common$19.symbols.deepDefault;
        if (desc$1.value) return (0, import_clone.default)(desc$1.value);
      }
      if (desc$1.type) return this.parse(desc$1);
      if (desc$1.template) return Template$5.build(desc$1);
      let normalized = {};
      for (let key in desc$1) normalized[key] = this.build(desc$1[key], { assign: key });
      return normalized;
    }
  }, internals$20.regex = function(string) {
    let end = string.lastIndexOf(`/`), exp = string.slice(1, end), flags = string.slice(end + 1);
    return new RegExp(exp, flags);
  }, internals$20.validate = function(joi, desc$1) {
    Schemas$3 ||= import_schemas$1.default, joi.assert(desc$1, Schemas$3.description);
  };
}), require_lib$2 = __commonJSMin$1((exports$12) => {
  exports$12.location = function(depth = 0) {
    let orig = Error.prepareStackTrace;
    Error.prepareStackTrace = (ignore$2, stack) => stack;
    let capture = {};
    Error.captureStackTrace(capture, this);
    let line = capture.stack[depth + 1];
    return Error.prepareStackTrace = orig, { filename: line.getFileName(), line: line.getLineNumber() };
  };
}), require_trace = __commonJSMin$1((exports$12) => {
  let { deepEqual: deepEqual$3 } = require_lib$4(), Pinpoint = require_lib$2(), Errors$7 = require_errors$2(), internals$19 = { codes: { error: 1, pass: 2, full: 3 }, labels: { 0: `never used`, 1: `always error`, 2: `always pass` } };
  exports$12.setup = function(root$11) {
    let trace = function() {
      return root$11._tracer = root$11._tracer || new internals$19.Tracer(), root$11._tracer;
    };
    root$11.trace = trace, root$11[Symbol.for(`@hapi/lab/coverage/initialize`)] = trace, root$11.untrace = () => {
      root$11._tracer = null;
    };
  }, exports$12.location = function(schema$2) {
    return schema$2.$_setFlag(`_tracerLocation`, Pinpoint.location(2));
  }, internals$19.Tracer = class {
    constructor() {
      this.name = `Joi`, this._schemas = /* @__PURE__ */ new Map();
    }
    _register(schema$2) {
      let existing = this._schemas.get(schema$2);
      if (existing) return existing.store;
      let store = new internals$19.Store(schema$2), { filename, line } = schema$2._flags._tracerLocation || Pinpoint.location(5);
      return this._schemas.set(schema$2, { filename, line, store }), store;
    }
    _combine(merged, sources) {
      for (let { store } of this._schemas.values()) store._combine(merged, sources);
    }
    report(file) {
      let coverage = [];
      for (let { filename, line, store } of this._schemas.values()) {
        if (file && file !== filename) continue;
        let missing = [], skipped = [];
        for (let [schema$2, log$1] of store._sources.entries()) {
          if (internals$19.sub(log$1.paths, skipped)) continue;
          if (!log$1.entry) {
            missing.push({ status: `never reached`, paths: [...log$1.paths] }), skipped.push(...log$1.paths);
            continue;
          }
          for (let type of [`valid`, `invalid`]) {
            let set = schema$2[`_${type}s`];
            if (!set) continue;
            let values$3 = new Set(set._values), refs = new Set(set._refs);
            for (let { value, ref } of log$1[type]) values$3.delete(value), refs.delete(ref);
            (values$3.size || refs.size) && missing.push({ status: [...values$3, ...[...refs].map((ref) => ref.display)], rule: `${type}s` });
          }
          let rules = schema$2._rules.map((rule) => rule.name);
          for (let type of [`default`, `failover`]) schema$2._flags[type] !== void 0 && rules.push(type);
          for (let name$2 of rules) {
            let status = internals$19.labels[log$1.rule[name$2] || 0];
            if (status) {
              let report = { rule: name$2, status };
              log$1.paths.size && (report.paths = [...log$1.paths]), missing.push(report);
            }
          }
        }
        missing.length && coverage.push({ filename, line, missing, severity: `error`, message: `Schema missing tests for ${missing.map(internals$19.message).join(`, `)}` });
      }
      return coverage.length ? coverage : null;
    }
  }, internals$19.Store = class {
    constructor(schema$2) {
      this.active = true, this._sources = /* @__PURE__ */ new Map(), this._combos = /* @__PURE__ */ new Map(), this._scan(schema$2);
    }
    debug(state, source, name$2, result) {
      state.mainstay.debug && state.mainstay.debug.push({ type: source, name: name$2, result, path: state.path });
    }
    entry(schema$2, state) {
      internals$19.debug(state, { type: `entry` }), this._record(schema$2, (log$1) => {
        log$1.entry = true;
      });
    }
    filter(schema$2, state, source, value) {
      internals$19.debug(state, { type: source, ...value }), this._record(schema$2, (log$1) => {
        log$1[source].add(value);
      });
    }
    log(schema$2, state, source, name$2, result) {
      internals$19.debug(state, { type: source, name: name$2, result: result === `full` ? `pass` : result }), this._record(schema$2, (log$1) => {
        log$1[source][name$2] = log$1[source][name$2] || 0, log$1[source][name$2] |= internals$19.codes[result];
      });
    }
    resolve(state, ref, to) {
      if (!state.mainstay.debug) return;
      let log$1 = { type: `resolve`, ref: ref.display, to, path: state.path };
      state.mainstay.debug.push(log$1);
    }
    value(state, by, from$2, to, name$2) {
      if (!state.mainstay.debug || deepEqual$3(from$2, to)) return;
      let log$1 = { type: `value`, by, from: from$2, to, path: state.path };
      name$2 && (log$1.name = name$2), state.mainstay.debug.push(log$1);
    }
    _record(schema$2, each$5) {
      let log$1 = this._sources.get(schema$2);
      if (log$1) {
        each$5(log$1);
        return;
      }
      let sources = this._combos.get(schema$2);
      for (let source of sources) this._record(source, each$5);
    }
    _scan(schema$2, _path) {
      let path = _path || [], log$1 = this._sources.get(schema$2);
      log$1 || (log$1 = { paths: /* @__PURE__ */ new Set(), entry: false, rule: {}, valid: /* @__PURE__ */ new Set(), invalid: /* @__PURE__ */ new Set() }, this._sources.set(schema$2, log$1)), path.length && log$1.paths.add(path);
      let each$5 = (sub, source) => {
        let subId = internals$19.id(sub, source);
        this._scan(sub, path.concat(subId));
      };
      schema$2.$_modify({ each: each$5, ref: false });
    }
    _combine(merged, sources) {
      this._combos.set(merged, sources);
    }
  }, internals$19.message = function(item) {
    let path = item.paths ? Errors$7.path(item.paths[0]) + (item.rule ? `:` : ``) : ``;
    return `${path}${item.rule || ``} (${item.status})`;
  }, internals$19.id = function(schema$2, { source, name: name$2, path, key }) {
    return schema$2._flags.id ? schema$2._flags.id : key || (name$2 = `@${name$2}`, source === `terms` ? [name$2, path[Math.min(path.length - 1, 1)]] : name$2);
  }, internals$19.sub = function(paths, skipped) {
    for (let path of paths) for (let skip of skipped) if (deepEqual$3(path.slice(0, skip.length), skip)) return true;
    return false;
  }, internals$19.debug = function(state, event) {
    state.mainstay.debug && (event.path = state.debug ? [...state.path, state.debug] : state.path, state.mainstay.debug.push(event));
  };
}), require_modify = __commonJSMin$1((exports$12) => {
  let { assert: assert$44 } = require_lib$4(), Common$18 = require_common$3(), Ref$8 = require_ref$2(), internals$18 = {};
  exports$12.Ids = internals$18.Ids = class {
    constructor() {
      this._byId = /* @__PURE__ */ new Map(), this._byKey = /* @__PURE__ */ new Map(), this._schemaChain = false;
    }
    clone() {
      let clone$20 = new internals$18.Ids();
      return clone$20._byId = new Map(this._byId), clone$20._byKey = new Map(this._byKey), clone$20._schemaChain = this._schemaChain, clone$20;
    }
    concat(source) {
      source._schemaChain && (this._schemaChain = true);
      for (let [id, value] of source._byId.entries()) assert$44(!this._byKey.has(id), `Schema id conflicts with existing key:`, id), this._byId.set(id, value);
      for (let [key, value] of source._byKey.entries()) assert$44(!this._byId.has(key), `Schema key conflicts with existing id:`, key), this._byKey.set(key, value);
    }
    fork(path, adjuster, root$11) {
      let chain = this._collect(path);
      chain.push({ schema: root$11 });
      let tail$5 = chain.shift(), adjusted = { id: tail$5.id, schema: adjuster(tail$5.schema) };
      assert$44(Common$18.isSchema(adjusted.schema), `adjuster function failed to return a joi schema type`);
      for (let node of chain) adjusted = { id: node.id, schema: internals$18.fork(node.schema, adjusted.id, adjusted.schema) };
      return adjusted.schema;
    }
    labels(path, behind = []) {
      let current = path[0], node = this._get(current);
      if (!node) return [...behind, ...path].join(`.`);
      let forward = path.slice(1);
      return behind = [...behind, node.schema._flags.label || current], forward.length ? node.schema._ids.labels(forward, behind) : behind.join(`.`);
    }
    reach(path, behind = []) {
      let current = path[0], node = this._get(current);
      assert$44(node, `Schema does not contain path`, [...behind, ...path].join(`.`));
      let forward = path.slice(1);
      return forward.length ? node.schema._ids.reach(forward, [...behind, current]) : node.schema;
    }
    register(schema$2, { key } = {}) {
      if (!schema$2 || !Common$18.isSchema(schema$2)) return;
      (schema$2.$_property(`schemaChain`) || schema$2._ids._schemaChain) && (this._schemaChain = true);
      let id = schema$2._flags.id;
      if (id) {
        let existing = this._byId.get(id);
        assert$44(!existing || existing.schema === schema$2, `Cannot add different schemas with the same id:`, id), assert$44(!this._byKey.has(id), `Schema id conflicts with existing key:`, id), this._byId.set(id, { schema: schema$2, id });
      }
      key && (assert$44(!this._byKey.has(key), `Schema already contains key:`, key), assert$44(!this._byId.has(key), `Schema key conflicts with existing id:`, key), this._byKey.set(key, { schema: schema$2, id: key }));
    }
    reset() {
      this._byId = /* @__PURE__ */ new Map(), this._byKey = /* @__PURE__ */ new Map(), this._schemaChain = false;
    }
    _collect(path, behind = [], nodes = []) {
      let current = path[0], node = this._get(current);
      assert$44(node, `Schema does not contain path`, [...behind, ...path].join(`.`)), nodes = [node, ...nodes];
      let forward = path.slice(1);
      return forward.length ? node.schema._ids._collect(forward, [...behind, current], nodes) : nodes;
    }
    _get(id) {
      return this._byId.get(id) || this._byKey.get(id);
    }
  }, internals$18.fork = function(schema$2, id, replacement) {
    let each$5 = (item, { key }) => {
      if (id === (item._flags.id || key)) return replacement;
    }, obj = exports$12.schema(schema$2, { each: each$5, ref: false });
    return obj ? obj.$_mutateRebuild() : schema$2;
  }, exports$12.schema = function(schema$2, options) {
    let obj;
    for (let name$2 in schema$2._flags) {
      if (name$2[0] === `_`) continue;
      let result = internals$18.scan(schema$2._flags[name$2], { source: `flags`, name: name$2 }, options);
      result !== void 0 && (obj ||= schema$2.clone(), obj._flags[name$2] = result);
    }
    for (let i$4 = 0; i$4 < schema$2._rules.length; ++i$4) {
      let rule = schema$2._rules[i$4], result = internals$18.scan(rule.args, { source: `rules`, name: rule.name }, options);
      if (result !== void 0) {
        obj ||= schema$2.clone();
        let clone$20 = Object.assign({}, rule);
        clone$20.args = result, obj._rules[i$4] = clone$20;
        let existingUnique = obj._singleRules.get(rule.name);
        existingUnique === rule && obj._singleRules.set(rule.name, clone$20);
      }
    }
    for (let name$2 in schema$2.$_terms) {
      if (name$2[0] === `_`) continue;
      let result = internals$18.scan(schema$2.$_terms[name$2], { source: `terms`, name: name$2 }, options);
      result !== void 0 && (obj ||= schema$2.clone(), obj.$_terms[name$2] = result);
    }
    return obj;
  }, internals$18.scan = function(item, source, options, _path, _key) {
    let path = _path || [];
    if (typeof item != `object` || !item) return;
    let clone$20;
    if (Array.isArray(item)) {
      for (let i$4 = 0; i$4 < item.length; ++i$4) {
        let key = source.source === `terms` && source.name === `keys` && item[i$4].key, result = internals$18.scan(item[i$4], source, options, [i$4, ...path], key);
        result !== void 0 && (clone$20 ||= item.slice(), clone$20[i$4] = result);
      }
      return clone$20;
    }
    if (options.schema !== false && Common$18.isSchema(item) || options.ref !== false && Ref$8.isRef(item)) {
      let result = options.each(item, { ...source, path, key: _key });
      return result === item ? void 0 : result;
    }
    for (let key in item) {
      if (key[0] === `_`) continue;
      let result = internals$18.scan(item[key], source, options, [key, ...path], _key);
      result !== void 0 && (clone$20 ||= Object.assign({}, item), clone$20[key] = result);
    }
    return clone$20;
  };
}), require_state$1 = __commonJSMin$1((exports$12, module2) => {
  let { clone: clone$12, reach: reach$2 } = require_lib$4(), Common$17 = require_common$3(), internals$17 = { value: Symbol(`value`) };
  module2.exports = internals$17.State = class {
    constructor(path, ancestors, state) {
      this.path = path, this.ancestors = ancestors, this.mainstay = state.mainstay, this.schemas = state.schemas, this.debug = null;
    }
    localize(path, ancestors = null, schema$2 = null) {
      let state = new internals$17.State(path, ancestors, this);
      return schema$2 && state.schemas && (state.schemas = [internals$17.schemas(schema$2), ...state.schemas]), state;
    }
    nest(schema$2, debug$13) {
      let state = new internals$17.State(this.path, this.ancestors, this);
      return state.schemas = state.schemas && [internals$17.schemas(schema$2), ...state.schemas], state.debug = debug$13, state;
    }
    shadow(value, reason) {
      this.mainstay.shadow = this.mainstay.shadow || new internals$17.Shadow(), this.mainstay.shadow.set(this.path, value, reason);
    }
    snapshot() {
      this.mainstay.shadow && (this._snapshot = clone$12(this.mainstay.shadow.node(this.path))), this.mainstay.snapshot();
    }
    restore() {
      this.mainstay.shadow && (this.mainstay.shadow.override(this.path, this._snapshot), this._snapshot = void 0), this.mainstay.restore();
    }
    commit() {
      this.mainstay.shadow && (this.mainstay.shadow.override(this.path, this._snapshot), this._snapshot = void 0), this.mainstay.commit();
    }
  }, internals$17.schemas = function(schema$2) {
    return Common$17.isSchema(schema$2) ? { schema: schema$2 } : schema$2;
  }, internals$17.Shadow = class {
    constructor() {
      this._values = null;
    }
    set(path, value, reason) {
      if (!path.length || reason === `strip` && typeof path[path.length - 1] == `number`) return;
      this._values = this._values || /* @__PURE__ */ new Map();
      let node = this._values;
      for (let i$4 = 0; i$4 < path.length; ++i$4) {
        let segment = path[i$4], next = node.get(segment);
        next || (next = /* @__PURE__ */ new Map(), node.set(segment, next)), node = next;
      }
      node[internals$17.value] = value;
    }
    get(path) {
      let node = this.node(path);
      if (node) return node[internals$17.value];
    }
    node(path) {
      if (this._values) return reach$2(this._values, path, { iterables: true });
    }
    override(path, node) {
      if (!this._values) return;
      let parents = path.slice(0, -1), own = path[path.length - 1], parent = reach$2(this._values, parents, { iterables: true });
      if (node) {
        parent.set(own, node);
        return;
      }
      parent && parent.delete(own);
    }
  };
}), require_validator = __commonJSMin$1((exports$12) => {
  let { assert: assert$43, clone: clone$11, ignore, reach: reach$1 } = require_lib$4(), Common$16 = require_common$3(), Errors$6 = require_errors$2(), State = require_state$1(), internals$16 = { result: Symbol(`result`) };
  exports$12.entry = function(value, schema$2, prefs) {
    let settings = Common$16.defaults;
    prefs && (assert$43(prefs.warnings === void 0, `Cannot override warnings preference in synchronous validation`), assert$43(prefs.artifacts === void 0, `Cannot override artifacts preference in synchronous validation`), settings = Common$16.preferences(Common$16.defaults, prefs));
    let result = internals$16.entry(value, schema$2, settings);
    assert$43(!result.mainstay.externals.length, `Schema with external rules must use validateAsync()`);
    let outcome = { value: result.value };
    return result.error && (outcome.error = result.error), result.mainstay.warnings.length && (outcome.warning = Errors$6.details(result.mainstay.warnings)), result.mainstay.debug && (outcome.debug = result.mainstay.debug), result.mainstay.artifacts && (outcome.artifacts = result.mainstay.artifacts), outcome;
  }, exports$12.entryAsync = async function(value, schema$2, prefs) {
    let settings = Common$16.defaults;
    prefs && (settings = Common$16.preferences(Common$16.defaults, prefs));
    let result = internals$16.entry(value, schema$2, settings), mainstay = result.mainstay;
    if (result.error) throw mainstay.debug && (result.error.debug = mainstay.debug), result.error;
    if (mainstay.externals.length) {
      let root$11 = result.value, errors = [];
      for (let external of mainstay.externals) {
        let path = external.state.path, linked = external.schema.type === `link` ? mainstay.links.get(external.schema) : null, node = root$11, key, parent, ancestors = path.length ? [root$11] : [], original = path.length ? reach$1(value, path) : value;
        if (path.length) {
          key = path[path.length - 1];
          let current = root$11;
          for (let segment of path.slice(0, -1)) current = current[segment], ancestors.unshift(current);
          parent = ancestors[0], node = parent[key];
        }
        try {
          let createError = (code$2, local) => (linked || external.schema).$_createError(code$2, node, local, external.state, settings), output = await external.method(node, { schema: external.schema, linked, state: external.state, prefs, original, error: createError, errorsArray: internals$16.errorsArray, warn: (code$2, local) => mainstay.warnings.push((linked || external.schema).$_createError(code$2, node, local, external.state, settings)), message: (messages$3, local) => (linked || external.schema).$_createError(`external`, node, local, external.state, settings, { messages: messages$3 }) });
          if (output === void 0 || output === node) continue;
          if (output instanceof Errors$6.Report) {
            if (mainstay.tracer.log(external.schema, external.state, `rule`, `external`, `error`), errors.push(output), settings.abortEarly) break;
            continue;
          }
          if (Array.isArray(output) && output[Common$16.symbols.errors]) {
            if (mainstay.tracer.log(external.schema, external.state, `rule`, `external`, `error`), errors.push(...output), settings.abortEarly) break;
            continue;
          }
          parent ? (mainstay.tracer.value(external.state, `rule`, node, output, `external`), parent[key] = output) : (mainstay.tracer.value(external.state, `rule`, root$11, output, `external`), root$11 = output);
        } catch (err$1) {
          throw settings.errors.label && (err$1.message += ` (${external.label})`), err$1;
        }
      }
      if (result.value = root$11, errors.length) throw result.error = Errors$6.process(errors, value, settings), mainstay.debug && (result.error.debug = mainstay.debug), result.error;
    }
    if (!settings.warnings && !settings.debug && !settings.artifacts) return result.value;
    let outcome = { value: result.value };
    return mainstay.warnings.length && (outcome.warning = Errors$6.details(mainstay.warnings)), mainstay.debug && (outcome.debug = mainstay.debug), mainstay.artifacts && (outcome.artifacts = mainstay.artifacts), outcome;
  }, exports$12.standard = function(value, schema$2) {
    return schema$2.isAsync() ? exports$12.entryAsync(value, schema$2) : exports$12.entry(value, schema$2);
  }, internals$16.Mainstay = class {
    constructor(tracer, debug$13, links) {
      this.externals = [], this.warnings = [], this.tracer = tracer, this.debug = debug$13, this.links = links, this.shadow = null, this.artifacts = null, this._snapshots = [];
    }
    snapshot() {
      this._snapshots.push({ externals: this.externals.slice(), warnings: this.warnings.slice() });
    }
    restore() {
      let snapshot = this._snapshots.pop();
      this.externals = snapshot.externals, this.warnings = snapshot.warnings;
    }
    commit() {
      this._snapshots.pop();
    }
  }, internals$16.entry = function(value, schema$2, prefs) {
    let { tracer, cleanup } = internals$16.tracer(schema$2, prefs), debug$13 = prefs.debug ? [] : null, links = schema$2._ids._schemaChain ? /* @__PURE__ */ new Map() : null, mainstay = new internals$16.Mainstay(tracer, debug$13, links), schemas = schema$2._ids._schemaChain ? [{ schema: schema$2 }] : null, state = new State([], [], { mainstay, schemas }), result = exports$12.validate(value, schema$2, state, prefs);
    cleanup && schema$2.$_root.untrace();
    let error = Errors$6.process(result.errors, value, prefs);
    return { value: result.value, error, mainstay };
  }, internals$16.tracer = function(schema$2, prefs) {
    return schema$2.$_root._tracer ? { tracer: schema$2.$_root._tracer._register(schema$2) } : prefs.debug ? (assert$43(schema$2.$_root.trace, `Debug mode not supported`), { tracer: schema$2.$_root.trace()._register(schema$2), cleanup: true }) : { tracer: internals$16.ignore };
  }, exports$12.validate = function(value, schema$2, state, prefs, overrides = {}) {
    if (schema$2.$_terms.whens && (schema$2 = schema$2._generate(value, state, prefs).schema), schema$2._preferences && (prefs = internals$16.prefs(schema$2, prefs)), schema$2._cache && prefs.cache) {
      let result = schema$2._cache.get(value);
      if (state.mainstay.tracer.debug(state, `validate`, `cached`, !!result), result) return result;
    }
    let createError = (code$2, local, localState) => schema$2.$_createError(code$2, value, local, localState || state, prefs), helpers$8 = { original: value, prefs, schema: schema$2, state, error: createError, errorsArray: internals$16.errorsArray, warn: (code$2, local, localState) => state.mainstay.warnings.push(createError(code$2, local, localState)), message: (messages$3, local) => schema$2.$_createError(`custom`, value, local, state, prefs, { messages: messages$3 }) };
    state.mainstay.tracer.entry(schema$2, state);
    let def = schema$2._definition;
    if (def.prepare && value !== void 0 && prefs.convert) {
      let prepared = def.prepare(value, helpers$8);
      if (prepared) {
        if (state.mainstay.tracer.value(state, `prepare`, value, prepared.value), prepared.errors) return internals$16.finalize(prepared.value, [].concat(prepared.errors), helpers$8);
        value = prepared.value;
      }
    }
    if (def.coerce && value !== void 0 && prefs.convert && (!def.coerce.from || def.coerce.from.includes(typeof value))) {
      let coerced = def.coerce.method(value, helpers$8);
      if (coerced) {
        if (state.mainstay.tracer.value(state, `coerced`, value, coerced.value), coerced.errors) return internals$16.finalize(coerced.value, [].concat(coerced.errors), helpers$8);
        value = coerced.value;
      }
    }
    let empty = schema$2._flags.empty;
    empty && empty.$_match(internals$16.trim(value, schema$2), state.nest(empty), Common$16.defaults) && (state.mainstay.tracer.value(state, `empty`, value, void 0), value = void 0);
    let presence = overrides.presence || schema$2._flags.presence || (schema$2._flags._endedSwitch ? null : prefs.presence);
    if (value === void 0) {
      if (presence === `forbidden`) return internals$16.finalize(value, null, helpers$8);
      if (presence === `required`) return internals$16.finalize(value, [schema$2.$_createError(`any.required`, value, null, state, prefs)], helpers$8);
      if (presence === `optional`) {
        if (schema$2._flags.default !== Common$16.symbols.deepDefault) return internals$16.finalize(value, null, helpers$8);
        state.mainstay.tracer.value(state, `default`, value, {}), value = {};
      }
    } else if (presence === `forbidden`) return internals$16.finalize(value, [schema$2.$_createError(`any.unknown`, value, null, state, prefs)], helpers$8);
    let errors = [];
    if (schema$2._valids) {
      let match$2 = schema$2._valids.get(value, state, prefs, schema$2._flags.insensitive);
      if (match$2) return prefs.convert && (state.mainstay.tracer.value(state, `valids`, value, match$2.value), value = match$2.value), state.mainstay.tracer.filter(schema$2, state, `valid`, match$2), internals$16.finalize(value, null, helpers$8);
      if (schema$2._flags.only) {
        let report = schema$2.$_createError(`any.only`, value, { valids: schema$2._valids.values({ display: true }) }, state, prefs);
        if (prefs.abortEarly) return internals$16.finalize(value, [report], helpers$8);
        errors.push(report);
      }
    }
    if (schema$2._invalids) {
      let match$2 = schema$2._invalids.get(value, state, prefs, schema$2._flags.insensitive);
      if (match$2) {
        state.mainstay.tracer.filter(schema$2, state, `invalid`, match$2);
        let report = schema$2.$_createError(`any.invalid`, value, { invalids: schema$2._invalids.values({ display: true }) }, state, prefs);
        if (prefs.abortEarly) return internals$16.finalize(value, [report], helpers$8);
        errors.push(report);
      }
    }
    if (def.validate) {
      let base$3 = def.validate(value, helpers$8);
      if (base$3 && (state.mainstay.tracer.value(state, `base`, value, base$3.value), value = base$3.value, base$3.errors)) {
        if (!Array.isArray(base$3.errors)) return errors.push(base$3.errors), internals$16.finalize(value, errors, helpers$8);
        if (base$3.errors.length) return errors.push(...base$3.errors), internals$16.finalize(value, errors, helpers$8);
      }
    }
    return schema$2._rules.length ? internals$16.rules(value, errors, helpers$8) : internals$16.finalize(value, errors, helpers$8);
  }, internals$16.rules = function(value, errors, helpers$8) {
    let { schema: schema$2, state, prefs } = helpers$8;
    for (let rule of schema$2._rules) {
      let definition = schema$2._definition.rules[rule.method];
      if (definition.convert && prefs.convert) {
        state.mainstay.tracer.log(schema$2, state, `rule`, rule.name, `full`);
        continue;
      }
      let ret, args$1 = rule.args;
      if (rule._resolve.length) {
        args$1 = Object.assign({}, args$1);
        for (let key of rule._resolve) {
          let resolver = definition.argsByName.get(key), resolved = args$1[key].resolve(value, state, prefs), normalized = resolver.normalize ? resolver.normalize(resolved) : resolved, invalid$1 = Common$16.validateArg(normalized, null, resolver);
          if (invalid$1) {
            ret = schema$2.$_createError(`any.ref`, resolved, { arg: key, ref: args$1[key], reason: invalid$1 }, state, prefs);
            break;
          }
          args$1[key] = normalized;
        }
      }
      ret ||= definition.validate(value, helpers$8, args$1, rule);
      let result = internals$16.rule(ret, rule);
      if (result.errors) {
        if (state.mainstay.tracer.log(schema$2, state, `rule`, rule.name, `error`), rule.warn) {
          state.mainstay.warnings.push(...result.errors);
          continue;
        }
        if (prefs.abortEarly) return internals$16.finalize(value, result.errors, helpers$8);
        errors.push(...result.errors);
      } else state.mainstay.tracer.log(schema$2, state, `rule`, rule.name, `pass`), state.mainstay.tracer.value(state, `rule`, value, result.value, rule.name), value = result.value;
    }
    return internals$16.finalize(value, errors, helpers$8);
  }, internals$16.rule = function(ret, rule) {
    return ret instanceof Errors$6.Report ? (internals$16.error(ret, rule), { errors: [ret], value: null }) : Array.isArray(ret) && ret[Common$16.symbols.errors] ? (ret.forEach((report) => internals$16.error(report, rule)), { errors: ret, value: null }) : { errors: null, value: ret };
  }, internals$16.error = function(report, rule) {
    return rule.message && report._setTemplate(rule.message), report;
  }, internals$16.finalize = function(value, errors, helpers$8) {
    errors ||= [];
    let { schema: schema$2, state, prefs } = helpers$8;
    if (errors.length) {
      let failover = internals$16.default(`failover`, void 0, errors, helpers$8);
      failover !== void 0 && (state.mainstay.tracer.value(state, `failover`, value, failover), value = failover, errors = []);
    }
    if (errors.length && schema$2._flags.error) if (typeof schema$2._flags.error == `function`) {
      errors = schema$2._flags.error(errors), Array.isArray(errors) || (errors = [errors]);
      for (let error of errors) assert$43(error instanceof Error || error instanceof Errors$6.Report, `error() must return an Error object`);
    } else errors = [schema$2._flags.error];
    if (value === void 0) {
      let defaulted = internals$16.default(`default`, value, errors, helpers$8);
      state.mainstay.tracer.value(state, `default`, value, defaulted), value = defaulted;
    }
    if (schema$2._flags.cast && value !== void 0) {
      let caster = schema$2._definition.cast[schema$2._flags.cast];
      if (caster.from(value)) {
        let casted = caster.to(value, helpers$8);
        state.mainstay.tracer.value(state, `cast`, value, casted, schema$2._flags.cast), value = casted;
      }
    }
    if (schema$2.$_terms.externals && prefs.externals && prefs._externals !== false) for (let { method: method$1 } of schema$2.$_terms.externals) state.mainstay.externals.push({ method: method$1, schema: schema$2, state, label: Errors$6.label(schema$2._flags, state, prefs) });
    let result = { value, errors: errors.length ? errors : null };
    return schema$2._flags.result && (result.value = schema$2._flags.result === `strip` ? void 0 : helpers$8.original, state.mainstay.tracer.value(state, schema$2._flags.result, value, result.value), state.shadow(value, schema$2._flags.result)), schema$2._cache && prefs.cache !== false && !schema$2._refs.length && schema$2._cache.set(helpers$8.original, result), value !== void 0 && !result.errors && schema$2._flags.artifact !== void 0 && (state.mainstay.artifacts = state.mainstay.artifacts || /* @__PURE__ */ new Map(), state.mainstay.artifacts.has(schema$2._flags.artifact) || state.mainstay.artifacts.set(schema$2._flags.artifact, []), state.mainstay.artifacts.get(schema$2._flags.artifact).push(state.path)), result;
  }, internals$16.prefs = function(schema$2, prefs) {
    let isDefaultOptions = prefs === Common$16.defaults;
    return isDefaultOptions && schema$2._preferences[Common$16.symbols.prefs] ? schema$2._preferences[Common$16.symbols.prefs] : (prefs = Common$16.preferences(prefs, schema$2._preferences), isDefaultOptions && (schema$2._preferences[Common$16.symbols.prefs] = prefs), prefs);
  }, internals$16.default = function(flag, value, errors, helpers$8) {
    let { schema: schema$2, state, prefs } = helpers$8, source = schema$2._flags[flag];
    if (prefs.noDefaults || source === void 0) return value;
    if (state.mainstay.tracer.log(schema$2, state, `rule`, flag, `full`), !source) return source;
    if (typeof source == `function`) {
      let args$1 = source.length ? [clone$11(state.ancestors[0]), helpers$8] : [];
      try {
        return source(...args$1);
      } catch (err$1) {
        errors.push(schema$2.$_createError(`any.${flag}`, null, { error: err$1 }, state, prefs));
        return;
      }
    }
    return typeof source == `object` ? source[Common$16.symbols.literal] ? source.literal : Common$16.isResolvable(source) ? source.resolve(value, state, prefs) : clone$11(source) : source;
  }, internals$16.trim = function(value, schema$2) {
    if (typeof value != `string`) return value;
    let trim = schema$2.$_getRule(`trim`);
    return !trim || !trim.args.enabled ? value : value.trim();
  }, internals$16.ignore = { active: false, debug: ignore, entry: ignore, filter: ignore, log: ignore, resolve: ignore, value: ignore }, internals$16.errorsArray = function() {
    let errors = [];
    return errors[Common$16.symbols.errors] = true, errors;
  };
}), require_values$1 = __commonJSMin$1((exports$12, module2) => {
  let { assert: assert$42, deepEqual: deepEqual$2 } = require_lib$4(), Common$15 = require_common$3(), internals$15 = {};
  module2.exports = internals$15.Values = class {
    constructor(values$3, refs) {
      this._values = new Set(values$3), this._refs = new Set(refs), this._lowercase = internals$15.lowercases(values$3), this._override = false;
    }
    get length() {
      return this._values.size + this._refs.size;
    }
    add(value, refs) {
      if (Common$15.isResolvable(value)) {
        this._refs.has(value) || (this._refs.add(value), refs && refs.register(value));
        return;
      }
      this.has(value, null, null, false) || (this._values.add(value), typeof value == `string` && this._lowercase.set(value.toLowerCase(), value));
    }
    static merge(target, source, remove$1) {
      if (target ||= new internals$15.Values(), source) {
        if (source._override) return source.clone();
        for (let item of [...source._values, ...source._refs]) target.add(item);
      }
      if (remove$1) for (let item of [...remove$1._values, ...remove$1._refs]) target.remove(item);
      return target.length ? target : null;
    }
    remove(value) {
      if (Common$15.isResolvable(value)) {
        this._refs.delete(value);
        return;
      }
      this._values.delete(value), typeof value == `string` && this._lowercase.delete(value.toLowerCase());
    }
    has(value, state, prefs, insensitive) {
      return !!this.get(value, state, prefs, insensitive);
    }
    get(value, state, prefs, insensitive) {
      if (!this.length) return false;
      if (this._values.has(value)) return { value };
      if (typeof value == `string` && value && insensitive) {
        let found = this._lowercase.get(value.toLowerCase());
        if (found) return { value: found };
      }
      if (!this._refs.size && typeof value != `object`) return false;
      if (typeof value == `object`) {
        for (let item of this._values) if (deepEqual$2(item, value)) return { value: item };
      }
      if (state) for (let ref of this._refs) {
        let resolved = ref.resolve(value, state, prefs, null, { in: true });
        if (resolved === void 0) continue;
        let items = !ref.in || typeof resolved != `object` ? [resolved] : Array.isArray(resolved) ? resolved : Object.keys(resolved);
        for (let item of items) {
          if (typeof item != typeof value) continue;
          if (insensitive && value && typeof value == `string`) {
            if (item.toLowerCase() === value.toLowerCase()) return { value: item, ref };
          } else if (deepEqual$2(item, value)) return { value: item, ref };
        }
      }
      return false;
    }
    override() {
      this._override = true;
    }
    values(options) {
      if (options && options.display) {
        let values$3 = [];
        for (let item of [...this._values, ...this._refs]) item !== void 0 && values$3.push(item);
        return values$3;
      }
      return Array.from([...this._values, ...this._refs]);
    }
    clone() {
      let set = new internals$15.Values(this._values, this._refs);
      return set._override = this._override, set;
    }
    concat(source) {
      assert$42(!source._override, `Cannot concat override set of values`);
      let set = new internals$15.Values([...this._values, ...source._values], [...this._refs, ...source._refs]);
      return set._override = this._override, set;
    }
    describe() {
      let normalized = [];
      this._override && normalized.push({ override: true });
      for (let value of this._values.values()) normalized.push(value && typeof value == `object` ? { value } : value);
      for (let value of this._refs.values()) normalized.push(value.describe());
      return normalized;
    }
  }, internals$15.Values.prototype[Common$15.symbols.values] = true, internals$15.Values.prototype.slice = internals$15.Values.prototype.clone, internals$15.lowercases = function(from$2) {
    let map$8 = /* @__PURE__ */ new Map();
    if (from$2) for (let value of from$2) typeof value == `string` && map$8.set(value.toLowerCase(), value);
    return map$8;
  };
}), require_base$2 = __commonJSMin$1((exports$12, module2) => {
  let { assert: assert$41, clone: clone$10, deepEqual: deepEqual$1, merge: merge$2 } = require_lib$4(), Cache$2 = require_cache(), Common$14 = require_common$3(), Compile$6 = require_compile(), Errors$5 = require_errors$2(), Extend$2 = require_extend$1(), Manifest$2 = require_manifest(), Messages$4 = require_messages(), Modify = require_modify(), Ref$7 = require_ref$2(), Trace$2 = require_trace(), Validator = require_validator(), Values$1 = require_values$1(), internals$14 = {};
  internals$14.Base = class {
    constructor(type) {
      this.type = type, this.$_root = null, this._definition = {}, this._reset();
    }
    _reset() {
      this._ids = new Modify.Ids(), this._preferences = null, this._refs = new Ref$7.Manager(), this._cache = null, this._valids = null, this._invalids = null, this._flags = {}, this._rules = [], this._singleRules = /* @__PURE__ */ new Map(), this.$_terms = {}, this.$_temp = { ruleset: null, whens: {} };
    }
    describe() {
      return assert$41(typeof Manifest$2.describe == `function`, `Manifest functionality disabled`), Manifest$2.describe(this);
    }
    allow(...values$3) {
      return Common$14.verifyFlat(values$3, `allow`), this._values(values$3, `_valids`);
    }
    alter(targets) {
      assert$41(targets && typeof targets == `object` && !Array.isArray(targets), `Invalid targets argument`), assert$41(!this._inRuleset(), `Cannot set alterations inside a ruleset`);
      let obj = this.clone();
      for (let target in obj.$_terms.alterations = obj.$_terms.alterations || [], targets) {
        let adjuster = targets[target];
        assert$41(typeof adjuster == `function`, `Alteration adjuster for`, target, `must be a function`), obj.$_terms.alterations.push({ target, adjuster });
      }
      return obj.$_temp.ruleset = false, obj;
    }
    artifact(id) {
      return assert$41(id !== void 0, `Artifact cannot be undefined`), assert$41(!this._cache, `Cannot set an artifact with a rule cache`), this.$_setFlag(`artifact`, id);
    }
    cast(to) {
      return assert$41(to === false || typeof to == `string`, `Invalid to value`), assert$41(to === false || this._definition.cast[to], `Type`, this.type, `does not support casting to`, to), this.$_setFlag(`cast`, to === false ? void 0 : to);
    }
    default(value, options) {
      return this._default(`default`, value, options);
    }
    description(desc$1) {
      return assert$41(desc$1 && typeof desc$1 == `string`, `Description must be a non-empty string`), this.$_setFlag(`description`, desc$1);
    }
    empty(schema$2) {
      let obj = this.clone();
      return schema$2 !== void 0 && (schema$2 = obj.$_compile(schema$2, { override: false })), obj.$_setFlag(`empty`, schema$2, { clone: false });
    }
    error(err$1) {
      return assert$41(err$1, `Missing error`), assert$41(err$1 instanceof Error || typeof err$1 == `function`, `Must provide a valid Error object or a function`), this.$_setFlag(`error`, err$1);
    }
    example(example, options = {}) {
      return assert$41(example !== void 0, `Missing example`), Common$14.assertOptions(options, [`override`]), this._inner(`examples`, example, { single: true, override: options.override });
    }
    external(method$1, description$2) {
      return typeof method$1 == `object` && (assert$41(!description$2, `Cannot combine options with description`), description$2 = method$1.description, method$1 = method$1.method), assert$41(typeof method$1 == `function`, `Method must be a function`), assert$41(description$2 === void 0 || description$2 && typeof description$2 == `string`, `Description must be a non-empty string`), this._inner(`externals`, { method: method$1, description: description$2 }, { single: true });
    }
    failover(value, options) {
      return this._default(`failover`, value, options);
    }
    forbidden() {
      return this.presence(`forbidden`);
    }
    id(id) {
      return id ? (assert$41(typeof id == `string`, `id must be a non-empty string`), assert$41(/^[^\.]+$/.test(id), `id cannot contain period character`), this.$_setFlag(`id`, id)) : this.$_setFlag(`id`, void 0);
    }
    invalid(...values$3) {
      return this._values(values$3, `_invalids`);
    }
    label(name$2) {
      return assert$41(name$2 && typeof name$2 == `string`, `Label name must be a non-empty string`), this.$_setFlag(`label`, name$2);
    }
    meta(meta) {
      return assert$41(meta !== void 0, `Meta cannot be undefined`), this._inner(`metas`, meta, { single: true });
    }
    note(...notes) {
      assert$41(notes.length, `Missing notes`);
      for (let note of notes) assert$41(note && typeof note == `string`, `Notes must be non-empty strings`);
      return this._inner(`notes`, notes);
    }
    only(mode = true) {
      return assert$41(typeof mode == `boolean`, `Invalid mode:`, mode), this.$_setFlag(`only`, mode);
    }
    optional() {
      return this.presence(`optional`);
    }
    prefs(prefs) {
      assert$41(prefs, `Missing preferences`), assert$41(prefs.context === void 0, `Cannot override context`), assert$41(prefs.externals === void 0, `Cannot override externals`), assert$41(prefs.warnings === void 0, `Cannot override warnings`), assert$41(prefs.debug === void 0, `Cannot override debug`), Common$14.checkPreferences(prefs);
      let obj = this.clone();
      return obj._preferences = Common$14.preferences(obj._preferences, prefs), obj;
    }
    presence(mode) {
      return assert$41([`optional`, `required`, `forbidden`].includes(mode), `Unknown presence mode`, mode), this.$_setFlag(`presence`, mode);
    }
    raw(enabled = true) {
      return this.$_setFlag(`result`, enabled ? `raw` : void 0);
    }
    result(mode) {
      return assert$41([`raw`, `strip`].includes(mode), `Unknown result mode`, mode), this.$_setFlag(`result`, mode);
    }
    required() {
      return this.presence(`required`);
    }
    strict(enabled) {
      let obj = this.clone(), convert = enabled === void 0 ? false : !enabled;
      return obj._preferences = Common$14.preferences(obj._preferences, { convert }), obj;
    }
    strip(enabled = true) {
      return this.$_setFlag(`result`, enabled ? `strip` : void 0);
    }
    tag(...tags$1) {
      assert$41(tags$1.length, `Missing tags`);
      for (let tag of tags$1) assert$41(tag && typeof tag == `string`, `Tags must be non-empty strings`);
      return this._inner(`tags`, tags$1);
    }
    unit(name$2) {
      return assert$41(name$2 && typeof name$2 == `string`, `Unit name must be a non-empty string`), this.$_setFlag(`unit`, name$2);
    }
    valid(...values$3) {
      Common$14.verifyFlat(values$3, `valid`);
      let obj = this.allow(...values$3);
      return obj.$_setFlag(`only`, !!obj._valids, { clone: false }), obj;
    }
    when(condition, options) {
      let obj = this.clone();
      obj.$_terms.whens || (obj.$_terms.whens = []);
      let when = Compile$6.when(obj, condition, options);
      if (![`any`, `link`].includes(obj.type)) {
        let conditions = when.is ? [when] : when.switch;
        for (let item of conditions) assert$41(!item.then || item.then.type === `any` || item.then.type === obj.type, `Cannot combine`, obj.type, `with`, item.then && item.then.type), assert$41(!item.otherwise || item.otherwise.type === `any` || item.otherwise.type === obj.type, `Cannot combine`, obj.type, `with`, item.otherwise && item.otherwise.type);
      }
      return obj.$_terms.whens.push(when), obj.$_mutateRebuild();
    }
    cache(cache$2) {
      assert$41(!this._inRuleset(), `Cannot set caching inside a ruleset`), assert$41(!this._cache, `Cannot override schema cache`), assert$41(this._flags.artifact === void 0, `Cannot cache a rule with an artifact`);
      let obj = this.clone();
      return obj._cache = cache$2 || Cache$2.provider.provision(), obj.$_temp.ruleset = false, obj;
    }
    clone() {
      let obj = Object.create(Object.getPrototypeOf(this));
      return this._assign(obj);
    }
    concat(source) {
      assert$41(Common$14.isSchema(source), `Invalid schema object`), assert$41(this.type === `any` || source.type === `any` || source.type === this.type, `Cannot merge type`, this.type, `with another type:`, source.type), assert$41(!this._inRuleset(), `Cannot concatenate onto a schema with open ruleset`), assert$41(!source._inRuleset(), `Cannot concatenate a schema with open ruleset`);
      let obj = this.clone();
      if (this.type === `any` && source.type !== `any`) {
        let tmpObj = source.clone();
        for (let key of Object.keys(obj)) key !== `type` && (tmpObj[key] = obj[key]);
        obj = tmpObj;
      }
      obj._ids.concat(source._ids), obj._refs.register(source, Ref$7.toSibling), obj._preferences = obj._preferences ? Common$14.preferences(obj._preferences, source._preferences) : source._preferences, obj._valids = Values$1.merge(obj._valids, source._valids, source._invalids), obj._invalids = Values$1.merge(obj._invalids, source._invalids, source._valids);
      for (let name$2 of source._singleRules.keys()) obj._singleRules.has(name$2) && (obj._rules = obj._rules.filter((target) => target.keep || target.name !== name$2), obj._singleRules.delete(name$2));
      for (let test of source._rules) source._definition.rules[test.method].multi || obj._singleRules.set(test.name, test), obj._rules.push(test);
      if (obj._flags.empty && source._flags.empty) {
        obj._flags.empty = obj._flags.empty.concat(source._flags.empty);
        let flags = Object.assign({}, source._flags);
        delete flags.empty, merge$2(obj._flags, flags);
      } else if (source._flags.empty) {
        obj._flags.empty = source._flags.empty;
        let flags = Object.assign({}, source._flags);
        delete flags.empty, merge$2(obj._flags, flags);
      } else merge$2(obj._flags, source._flags);
      for (let key in source.$_terms) {
        let terms = source.$_terms[key];
        if (!terms) {
          obj.$_terms[key] || (obj.$_terms[key] = terms);
          continue;
        }
        if (!obj.$_terms[key]) {
          obj.$_terms[key] = terms.slice();
          continue;
        }
        obj.$_terms[key] = obj.$_terms[key].concat(terms);
      }
      return this.$_root._tracer && this.$_root._tracer._combine(obj, [this, source]), obj.$_mutateRebuild();
    }
    extend(options) {
      return assert$41(!options.base, `Cannot extend type with another base`), Extend$2.type(this, options);
    }
    extract(path) {
      return path = Array.isArray(path) ? path : path.split(`.`), this._ids.reach(path);
    }
    fork(paths, adjuster) {
      assert$41(!this._inRuleset(), `Cannot fork inside a ruleset`);
      let obj = this;
      for (let path of [].concat(paths)) path = Array.isArray(path) ? path : path.split(`.`), obj = obj._ids.fork(path, adjuster, obj);
      return obj.$_temp.ruleset = false, obj;
    }
    isAsync() {
      if (this.$_terms.externals?.length) return true;
      if (this.$_terms.whens) for (let when of this.$_terms.whens) {
        if (when.then?.isAsync() || when.otherwise?.isAsync()) return true;
        if (when.switch) {
          for (let item of when.switch) if (item.then?.isAsync() || item.otherwise?.isAsync()) return true;
        }
      }
      return false;
    }
    rule(options) {
      let def = this._definition;
      Common$14.assertOptions(options, Object.keys(def.modifiers)), assert$41(this.$_temp.ruleset !== false, `Cannot apply rules to empty ruleset or the last rule added does not support rule properties`);
      let start = this.$_temp.ruleset === null ? this._rules.length - 1 : this.$_temp.ruleset;
      assert$41(start >= 0 && start < this._rules.length, `Cannot apply rules to empty ruleset`);
      let obj = this.clone();
      for (let i$4 = start; i$4 < obj._rules.length; ++i$4) {
        let original = obj._rules[i$4], rule = clone$10(original);
        for (let name$2 in options) def.modifiers[name$2](rule, options[name$2]), assert$41(rule.name === original.name, `Cannot change rule name`);
        obj._rules[i$4] = rule, obj._singleRules.get(rule.name) === original && obj._singleRules.set(rule.name, rule);
      }
      return obj.$_temp.ruleset = false, obj.$_mutateRebuild();
    }
    get ruleset() {
      assert$41(!this._inRuleset(), `Cannot start a new ruleset without closing the previous one`);
      let obj = this.clone();
      return obj.$_temp.ruleset = obj._rules.length, obj;
    }
    get $() {
      return this.ruleset;
    }
    tailor(targets) {
      targets = [].concat(targets), assert$41(!this._inRuleset(), `Cannot tailor inside a ruleset`);
      let obj = this;
      if (this.$_terms.alterations) for (let { target, adjuster } of this.$_terms.alterations) targets.includes(target) && (obj = adjuster(obj), assert$41(Common$14.isSchema(obj), `Alteration adjuster for`, target, `failed to return a schema object`));
      return obj = obj.$_modify({ each: (item) => item.tailor(targets), ref: false }), obj.$_temp.ruleset = false, obj.$_mutateRebuild();
    }
    tracer() {
      return Trace$2.location ? Trace$2.location(this) : this;
    }
    validate(value, options) {
      return Validator.entry(value, this, options);
    }
    validateAsync(value, options) {
      return Validator.entryAsync(value, this, options);
    }
    $_addRule(options) {
      for (let key in typeof options == `string` && (options = { name: options }), assert$41(options && typeof options == `object`, `Invalid options`), assert$41(options.name && typeof options.name == `string`, `Invalid rule name`), options) assert$41(key[0] !== `_`, `Cannot set private rule properties`);
      let rule = Object.assign({}, options);
      rule._resolve = [], rule.method = rule.method || rule.name;
      let definition = this._definition.rules[rule.method], args$1 = rule.args;
      assert$41(definition, `Unknown rule`, rule.method);
      let obj = this.clone();
      if (args$1) for (let key in assert$41(Object.keys(args$1).length === 1 || Object.keys(args$1).length === this._definition.rules[rule.name].args.length, `Invalid rule definition for`, this.type, rule.name), args$1) {
        let arg = args$1[key];
        if (definition.argsByName) {
          let resolver = definition.argsByName.get(key);
          if (resolver.ref && Common$14.isResolvable(arg)) rule._resolve.push(key), obj.$_mutateRegister(arg);
          else if (resolver.normalize && (arg = resolver.normalize(arg), args$1[key] = arg), resolver.assert) {
            let error = Common$14.validateArg(arg, key, resolver);
            assert$41(!error, error, `or reference`);
          }
        }
        if (arg === void 0) {
          delete args$1[key];
          continue;
        }
        args$1[key] = arg;
      }
      return definition.multi || (obj._ruleRemove(rule.name, { clone: false }), obj._singleRules.set(rule.name, rule)), obj.$_temp.ruleset === false && (obj.$_temp.ruleset = null), definition.priority ? obj._rules.unshift(rule) : obj._rules.push(rule), obj;
    }
    $_compile(schema$2, options) {
      return Compile$6.schema(this.$_root, schema$2, options);
    }
    $_createError(code$2, value, local, state, prefs, options = {}) {
      let flags = options.flags === false ? {} : this._flags, messages$3 = options.messages ? Messages$4.merge(this._definition.messages, options.messages) : this._definition.messages;
      return new Errors$5.Report(code$2, value, local, flags, messages$3, state, prefs);
    }
    $_getFlag(name$2) {
      return this._flags[name$2];
    }
    $_getRule(name$2) {
      return this._singleRules.get(name$2);
    }
    $_mapLabels(path) {
      return path = Array.isArray(path) ? path : path.split(`.`), this._ids.labels(path);
    }
    $_match(value, state, prefs, overrides) {
      prefs = Object.assign({}, prefs), prefs.abortEarly = true, prefs._externals = false, state.snapshot();
      let result = !Validator.validate(value, this, state, prefs, overrides).errors;
      return state.restore(), result;
    }
    $_modify(options) {
      return Common$14.assertOptions(options, [`each`, `once`, `ref`, `schema`]), Modify.schema(this, options) || this;
    }
    $_mutateRebuild() {
      assert$41(!this._inRuleset(), `Cannot add this rule inside a ruleset`), this._refs.reset(), this._ids.reset();
      let each$5 = (item, { source, name: name$2, path, key }) => {
        let family = this._definition[source][name$2] && this._definition[source][name$2].register;
        family !== false && this.$_mutateRegister(item, { family, key });
      };
      return this.$_modify({ each: each$5 }), this._definition.rebuild && this._definition.rebuild(this), this.$_temp.ruleset = false, this;
    }
    $_mutateRegister(schema$2, { family, key } = {}) {
      this._refs.register(schema$2, family), this._ids.register(schema$2, { key });
    }
    $_property(name$2) {
      return this._definition.properties[name$2];
    }
    $_reach(path) {
      return this._ids.reach(path);
    }
    $_rootReferences() {
      return this._refs.roots();
    }
    $_setFlag(name$2, value, options = {}) {
      assert$41(name$2[0] === `_` || !this._inRuleset(), `Cannot set flag inside a ruleset`);
      let flag = this._definition.flags[name$2] || {};
      if (deepEqual$1(value, flag.default) && (value = void 0), deepEqual$1(value, this._flags[name$2])) return this;
      let obj = options.clone === false ? this : this.clone();
      return value === void 0 ? delete obj._flags[name$2] : (obj._flags[name$2] = value, obj.$_mutateRegister(value)), name$2[0] !== `_` && (obj.$_temp.ruleset = false), obj;
    }
    $_parent(method$1, ...args$1) {
      return this[method$1][Common$14.symbols.parent].call(this, ...args$1);
    }
    $_validate(value, state, prefs) {
      return Validator.validate(value, this, state, prefs);
    }
    _assign(target) {
      for (let key in target.type = this.type, target.$_root = this.$_root, target.$_temp = Object.assign({}, this.$_temp), target.$_temp.whens = {}, target._ids = this._ids.clone(), target._preferences = this._preferences, target._valids = this._valids && this._valids.clone(), target._invalids = this._invalids && this._invalids.clone(), target._rules = this._rules.slice(), target._singleRules = clone$10(this._singleRules, { shallow: true }), target._refs = this._refs.clone(), target._flags = Object.assign({}, this._flags), target._cache = null, target.$_terms = {}, this.$_terms) target.$_terms[key] = this.$_terms[key] ? this.$_terms[key].slice() : null;
      for (let override in target.$_super = {}, this.$_super) target.$_super[override] = this._super[override].bind(target);
      return target;
    }
    _bare() {
      let obj = this.clone();
      obj._reset();
      let terms = obj._definition.terms;
      for (let name$2 in terms) {
        let term = terms[name$2];
        obj.$_terms[name$2] = term.init;
      }
      return obj.$_mutateRebuild();
    }
    _default(flag, value, options = {}) {
      Common$14.assertOptions(options, `literal`), assert$41(value !== void 0, `Missing`, flag, `value`), assert$41(typeof value == `function` || !options.literal, `Only function value supports literal option`), typeof value == `function` && options.literal && (value = { [Common$14.symbols.literal]: true, literal: value });
      let obj = this.$_setFlag(flag, value);
      return obj;
    }
    _generate(value, state, prefs) {
      if (!this.$_terms.whens) return { schema: this };
      let whens = [], ids = [];
      for (let i$4 = 0; i$4 < this.$_terms.whens.length; ++i$4) {
        let when = this.$_terms.whens[i$4];
        if (when.concat) {
          whens.push(when.concat), ids.push(`${i$4}.concat`);
          continue;
        }
        let input = when.ref ? when.ref.resolve(value, state, prefs) : value, tests = when.is ? [when] : when.switch, before = ids.length;
        for (let j$1 = 0; j$1 < tests.length; ++j$1) {
          let { is, then, otherwise } = tests[j$1], baseId = `${i$4}${when.switch ? `.` + j$1 : ``}`;
          if (is.$_match(input, state.nest(is, `${baseId}.is`), prefs)) {
            if (then) {
              let localState = state.localize([...state.path, `${baseId}.then`], state.ancestors, state.schemas), { schema: generated, id: id$1 } = then._generate(value, localState, prefs);
              whens.push(generated), ids.push(`${baseId}.then${id$1 ? `(${id$1})` : ``}`);
              break;
            }
          } else if (otherwise) {
            let localState = state.localize([...state.path, `${baseId}.otherwise`], state.ancestors, state.schemas), { schema: generated, id: id$1 } = otherwise._generate(value, localState, prefs);
            whens.push(generated), ids.push(`${baseId}.otherwise${id$1 ? `(${id$1})` : ``}`);
            break;
          }
        }
        if (when.break && ids.length > before) break;
      }
      let id = ids.join(`, `);
      if (state.mainstay.tracer.debug(state, `rule`, `when`, id), !id) return { schema: this };
      if (!state.mainstay.tracer.active && this.$_temp.whens[id]) return { schema: this.$_temp.whens[id], id };
      let obj = this;
      this._definition.generate && (obj = this._definition.generate(this, value, state, prefs));
      for (let when of whens) obj = obj.concat(when);
      return this.$_root._tracer && this.$_root._tracer._combine(obj, [this, ...whens]), this.$_temp.whens[id] = obj, { schema: obj, id };
    }
    _inner(type, values$3, options = {}) {
      assert$41(!this._inRuleset(), `Cannot set ${type} inside a ruleset`);
      let obj = this.clone();
      return (!obj.$_terms[type] || options.override) && (obj.$_terms[type] = []), options.single ? obj.$_terms[type].push(values$3) : obj.$_terms[type].push(...values$3), obj.$_temp.ruleset = false, obj;
    }
    _inRuleset() {
      return this.$_temp.ruleset !== null && this.$_temp.ruleset !== false;
    }
    _ruleRemove(name$2, options = {}) {
      if (!this._singleRules.has(name$2)) return this;
      let obj = options.clone === false ? this : this.clone();
      obj._singleRules.delete(name$2);
      let filtered = [];
      for (let i$4 = 0; i$4 < obj._rules.length; ++i$4) {
        let test = obj._rules[i$4];
        if (test.name === name$2 && !test.keep) {
          obj._inRuleset() && i$4 < obj.$_temp.ruleset && --obj.$_temp.ruleset;
          continue;
        }
        filtered.push(test);
      }
      return obj._rules = filtered, obj;
    }
    _values(values$3, key) {
      Common$14.verifyFlat(values$3, key.slice(1, -1));
      let obj = this.clone(), override = values$3[0] === Common$14.symbols.override;
      if (override && (values$3 = values$3.slice(1)), !obj[key] && values$3.length ? obj[key] = new Values$1() : override && (obj[key] = values$3.length ? new Values$1() : null, obj.$_mutateRebuild()), !obj[key]) return obj;
      override && obj[key].override();
      for (let value of values$3) {
        assert$41(value !== void 0, `Cannot call allow/valid/invalid with undefined`), assert$41(value !== Common$14.symbols.override, `Override must be the first value`);
        let other = key === `_invalids` ? `_valids` : `_invalids`;
        obj[other] && (obj[other].remove(value), obj[other].length || (assert$41(key === `_valids` || !obj._flags.only, `Setting invalid value`, value, `leaves schema rejecting all values due to previous valid rule`), obj[other] = null)), obj[key].add(value, obj._refs);
      }
      return obj;
    }
    get "~standard"() {
      let mapToStandardError = (error) => {
        let issues;
        return issues = Errors$5.ValidationError.isError(error) ? error.details.map(({ message, path }) => ({ message, path })) : [{ message: error.message }], { issues };
      }, mapToStandardValue = (value) => ({ value });
      return { version: 1, vendor: `joi`, validate: (value) => {
        let result = Validator.standard(value, this);
        return result instanceof Promise ? result.then(mapToStandardValue, mapToStandardError) : result.error ? mapToStandardError(result.error) : mapToStandardValue(result.value);
      } };
    }
  }, internals$14.Base.prototype[Common$14.symbols.any] = { version: Common$14.version, compile: Compile$6.compile, root: `$_root` }, internals$14.Base.prototype.isImmutable = true, internals$14.Base.prototype.deny = internals$14.Base.prototype.invalid, internals$14.Base.prototype.disallow = internals$14.Base.prototype.invalid, internals$14.Base.prototype.equal = internals$14.Base.prototype.valid, internals$14.Base.prototype.exist = internals$14.Base.prototype.required, internals$14.Base.prototype.not = internals$14.Base.prototype.invalid, internals$14.Base.prototype.options = internals$14.Base.prototype.prefs, internals$14.Base.prototype.preferences = internals$14.Base.prototype.prefs, module2.exports = new internals$14.Base();
}), require_any = __commonJSMin$1((exports$12, module2) => {
  let { assert: assert$40 } = require_lib$4(), Base$3 = require_base$2(), Common$13 = require_common$3(), Messages$3 = require_messages();
  module2.exports = Base$3.extend({ type: `any`, flags: { only: { default: false } }, terms: { alterations: { init: null }, examples: { init: null }, externals: { init: null }, metas: { init: [] }, notes: { init: [] }, shared: { init: null }, tags: { init: [] }, whens: { init: null } }, rules: { custom: { method(method$1, description$2) {
    return assert$40(typeof method$1 == `function`, `Method must be a function`), assert$40(description$2 === void 0 || description$2 && typeof description$2 == `string`, `Description must be a non-empty string`), this.$_addRule({ name: `custom`, args: { method: method$1, description: description$2 } });
  }, validate(value, helpers$8, { method: method$1 }) {
    try {
      return method$1(value, helpers$8);
    } catch (err$1) {
      return helpers$8.error(`any.custom`, { error: err$1 });
    }
  }, args: [`method`, `description`], multi: true }, messages: { method(messages$3) {
    return this.prefs({ messages: messages$3 });
  } }, shared: { method(schema$2) {
    assert$40(Common$13.isSchema(schema$2) && schema$2._flags.id, `Schema must be a schema with an id`);
    let obj = this.clone();
    return obj.$_terms.shared = obj.$_terms.shared || [], obj.$_terms.shared.push(schema$2), obj.$_mutateRegister(schema$2), obj;
  } }, warning: { method(code$2, local) {
    return assert$40(code$2 && typeof code$2 == `string`, `Invalid warning code`), this.$_addRule({ name: `warning`, args: { code: code$2, local }, warn: true });
  }, validate(value, helpers$8, { code: code$2, local }) {
    return helpers$8.error(code$2, local);
  }, args: [`code`, `local`], multi: true } }, modifiers: { keep(rule, enabled = true) {
    rule.keep = enabled;
  }, message(rule, message) {
    rule.message = Messages$3.compile(message);
  }, warn(rule, enabled = true) {
    rule.warn = enabled;
  } }, manifest: { build(obj, desc$1) {
    for (let key in desc$1) {
      let values$3 = desc$1[key];
      if ([`examples`, `externals`, `metas`, `notes`, `tags`].includes(key)) {
        for (let value of values$3) obj = obj[key.slice(0, -1)](value);
        continue;
      }
      if (key === `alterations`) {
        let alter = {};
        for (let { target, adjuster } of values$3) alter[target] = adjuster;
        obj = obj.alter(alter);
        continue;
      }
      if (key === `whens`) {
        for (let value of values$3) {
          let { ref, is, not, then, otherwise, concat: concat$1 } = value;
          obj = concat$1 ? obj.concat(concat$1) : ref ? obj.when(ref, { is, not, then, otherwise, switch: value.switch, break: value.break }) : obj.when(is, { then, otherwise, break: value.break });
        }
        continue;
      }
      if (key === `shared`) for (let value of values$3) obj = obj.shared(value);
    }
    return obj;
  } }, messages: { "any.custom": `{{#label}} failed custom validation because {{#error.message}}`, "any.default": `{{#label}} threw an error when running default method`, "any.failover": `{{#label}} threw an error when running failover method`, "any.invalid": `{{#label}} contains an invalid value`, "any.only": `{{#label}} must be {if(#valids.length == 1, "", "one of ")}{{#valids}}`, "any.ref": `{{#label}} {{#arg}} references {{:#ref}} which {{#reason}}`, "any.required": `{{#label}} is required`, "any.unknown": `{{#label}} is not allowed` } });
}), require_alternatives = __commonJSMin$1((exports$12, module2) => {
  let { assert: assert$39, merge: merge$1 } = require_lib$4(), Any$9 = require_any(), Common$12 = require_common$3(), Compile$5 = require_compile(), Errors$4 = require_errors$2(), Ref$6 = require_ref$2(), internals$13 = {};
  module2.exports = Any$9.extend({ type: `alternatives`, flags: { match: { default: `any` } }, terms: { matches: { init: [], register: Ref$6.toSibling } }, args(schema$2, ...schemas) {
    return schemas.length === 1 && Array.isArray(schemas[0]) ? schema$2.try(...schemas[0]) : schema$2.try(...schemas);
  }, validate(value, helpers$8) {
    let { schema: schema$2, error, state, prefs } = helpers$8;
    if (schema$2._flags.match) {
      let matched = [], failed = [];
      for (let i$4 = 0; i$4 < schema$2.$_terms.matches.length; ++i$4) {
        let item = schema$2.$_terms.matches[i$4], localState = state.nest(item.schema, `match.${i$4}`);
        localState.snapshot();
        let result = item.schema.$_validate(value, localState, prefs);
        result.errors ? (failed.push(result.errors), localState.restore()) : (matched.push(result.value), localState.commit());
      }
      if (matched.length === 0) {
        let context = { details: failed.map((f$32) => Errors$4.details(f$32, { override: false })) };
        return { errors: error(`alternatives.any`, context) };
      }
      if (schema$2._flags.match === `one`) return matched.length === 1 ? { value: matched[0] } : { errors: error(`alternatives.one`) };
      if (matched.length !== schema$2.$_terms.matches.length) {
        let context = { details: failed.map((f$32) => Errors$4.details(f$32, { override: false })) };
        return { errors: error(`alternatives.all`, context) };
      }
      let isAnyObj = (alternative) => alternative.$_terms.matches.some((v$1) => v$1.schema.type === `object` || v$1.schema.type === `alternatives` && isAnyObj(v$1.schema));
      return isAnyObj(schema$2) ? { value: matched.reduce((acc, v$1) => merge$1(acc, v$1, { mergeArrays: false })) } : { value: matched[matched.length - 1] };
    }
    let errors = [];
    for (let i$4 = 0; i$4 < schema$2.$_terms.matches.length; ++i$4) {
      let item = schema$2.$_terms.matches[i$4];
      if (item.schema) {
        let localState = state.nest(item.schema, `match.${i$4}`);
        localState.snapshot();
        let result = item.schema.$_validate(value, localState, prefs);
        if (!result.errors) return localState.commit(), result;
        localState.restore(), errors.push({ schema: item.schema, reports: result.errors });
        continue;
      }
      let input = item.ref ? item.ref.resolve(value, state, prefs) : value, tests = item.is ? [item] : item.switch;
      for (let j$1 = 0; j$1 < tests.length; ++j$1) {
        let test = tests[j$1], { is, then, otherwise } = test, id = `match.${i$4}${item.switch ? `.` + j$1 : ``}`;
        if (is.$_match(input, state.nest(is, `${id}.is`), prefs)) {
          if (then) return then.$_validate(value, state.nest(then, `${id}.then`), prefs);
        } else if (otherwise) return otherwise.$_validate(value, state.nest(otherwise, `${id}.otherwise`), prefs);
      }
    }
    return internals$13.errors(errors, helpers$8);
  }, rules: { conditional: { method(condition, options) {
    assert$39(!this._flags._endedSwitch, `Unreachable condition`), assert$39(!this._flags.match, `Cannot combine match mode`, this._flags.match, `with conditional rule`), assert$39(options.break === void 0, `Cannot use break option with alternatives conditional`);
    let obj = this.clone(), match$2 = Compile$5.when(obj, condition, options), conditions = match$2.is ? [match$2] : match$2.switch;
    for (let item of conditions) if (item.then && item.otherwise) {
      obj.$_setFlag(`_endedSwitch`, true, { clone: false });
      break;
    }
    return obj.$_terms.matches.push(match$2), obj.$_mutateRebuild();
  } }, match: { method(mode) {
    if (assert$39([`any`, `one`, `all`].includes(mode), `Invalid alternatives match mode`, mode), mode !== `any`) for (let match$2 of this.$_terms.matches) assert$39(match$2.schema, `Cannot combine match mode`, mode, `with conditional rules`);
    return this.$_setFlag(`match`, mode);
  } }, try: { method(...schemas) {
    assert$39(schemas.length, `Missing alternative schemas`), Common$12.verifyFlat(schemas, `try`), assert$39(!this._flags._endedSwitch, `Unreachable condition`);
    let obj = this.clone();
    for (let schema$2 of schemas) obj.$_terms.matches.push({ schema: obj.$_compile(schema$2) });
    return obj.$_mutateRebuild();
  } } }, overrides: { label(name$2) {
    let obj = this.$_parent(`label`, name$2), each$5 = (item, source) => source.path[0] !== `is` && typeof item._flags.label != `string` ? item.label(name$2) : void 0;
    return obj.$_modify({ each: each$5, ref: false });
  }, isAsync() {
    if (this.$_terms.externals?.length) return true;
    for (let match$2 of this.$_terms.matches) if (match$2.schema?.isAsync() || match$2.then?.isAsync() || match$2.otherwise?.isAsync()) return true;
    return false;
  } }, rebuild(schema$2) {
    let each$5 = (item) => {
      Common$12.isSchema(item) && item.type === `array` && schema$2.$_setFlag(`_arrayItems`, true, { clone: false });
    };
    schema$2.$_modify({ each: each$5 });
  }, manifest: { build(obj, desc$1) {
    if (desc$1.matches) for (let match$2 of desc$1.matches) {
      let { schema: schema$2, ref, is, not, then, otherwise } = match$2;
      obj = schema$2 ? obj.try(schema$2) : ref ? obj.conditional(ref, { is, then, not, otherwise, switch: match$2.switch }) : obj.conditional(is, { then, otherwise });
    }
    return obj;
  } }, messages: { "alternatives.all": `{{#label}} does not match all of the required types`, "alternatives.any": `{{#label}} does not match any of the allowed types`, "alternatives.match": `{{#label}} does not match any of the allowed types`, "alternatives.one": `{{#label}} matches more than one allowed type`, "alternatives.types": `{{#label}} must be one of {{#types}}` } }), internals$13.errors = function(failures, { error, state }) {
    if (!failures.length) return { errors: error(`alternatives.any`) };
    if (failures.length === 1) return { errors: failures[0].reports };
    let valids = /* @__PURE__ */ new Set(), complex = [];
    for (let { reports, schema: schema$2 } of failures) {
      if (reports.length > 1) return internals$13.unmatched(failures, error);
      let report = reports[0];
      if (!(report instanceof Errors$4.Report)) return internals$13.unmatched(failures, error);
      if (report.state.path.length !== state.path.length) {
        complex.push({ type: schema$2.type, report });
        continue;
      }
      if (report.code === `any.only`) {
        for (let valid$2 of report.local.valids) valids.add(valid$2);
        continue;
      }
      let [type, code$2] = report.code.split(`.`);
      code$2 === `base` ? report.code === `object.base` ? valids.add(report.local.type) : valids.add(type) : complex.push({ type: schema$2.type, report });
    }
    return complex.length ? complex.length === 1 ? { errors: complex[0].report } : internals$13.unmatched(failures, error) : { errors: error(`alternatives.types`, { types: [...valids] }) };
  }, internals$13.unmatched = function(failures, error) {
    let errors = [];
    for (let failure of failures) errors.push(...failure.reports);
    return { errors: error(`alternatives.match`, Errors$4.details(errors, { override: false })) };
  };
}), require_array = __commonJSMin$1((exports$12, module2) => {
  let { assert: assert$38, deepEqual, reach } = require_lib$4(), Any$8 = require_any(), Common$11 = require_common$3(), Compile$4 = require_compile(), internals$12 = {};
  module2.exports = Any$8.extend({ type: `array`, flags: { single: { default: false }, sparse: { default: false } }, terms: { items: { init: [], manifest: `schema` }, ordered: { init: [], manifest: `schema` }, _exclusions: { init: [] }, _inclusions: { init: [] }, _requireds: { init: [] } }, coerce: { from: `object`, method(value, { schema: schema$2, state, prefs }) {
    if (!Array.isArray(value)) return;
    let sort$2 = schema$2.$_getRule(`sort`);
    if (sort$2) return internals$12.sort(schema$2, value, sort$2.args.options, state, prefs);
  } }, validate(value, { schema: schema$2, error }) {
    if (!Array.isArray(value)) {
      if (schema$2._flags.single) {
        let single = [value];
        return single[Common$11.symbols.arraySingle] = true, { value: single };
      }
      return { errors: error(`array.base`) };
    }
    if (!(!schema$2.$_getRule(`items`) && !schema$2.$_terms.externals)) return { value: value.slice() };
  }, rules: { has: { method(schema$2) {
    schema$2 = this.$_compile(schema$2, { appendPath: true });
    let obj = this.$_addRule({ name: `has`, args: { schema: schema$2 } });
    return obj.$_mutateRegister(schema$2), obj;
  }, validate(value, { state, prefs, error }, { schema: has$6 }) {
    let ancestors = [value, ...state.ancestors];
    for (let i$4 = 0; i$4 < value.length; ++i$4) {
      let localState = state.localize([...state.path, i$4], ancestors, has$6);
      if (has$6.$_match(value[i$4], localState, prefs)) return value;
    }
    let patternLabel = has$6._flags.label;
    return patternLabel ? error(`array.hasKnown`, { patternLabel }) : error(`array.hasUnknown`, null);
  }, multi: true }, items: { method(...schemas) {
    Common$11.verifyFlat(schemas, `items`);
    let obj = this.$_addRule(`items`);
    for (let i$4 = 0; i$4 < schemas.length; ++i$4) {
      let type = Common$11.tryWithPath(() => this.$_compile(schemas[i$4]), i$4, { append: true });
      obj.$_terms.items.push(type);
    }
    return obj.$_mutateRebuild();
  }, validate(value, { schema: schema$2, error, state, prefs, errorsArray }) {
    let requireds = schema$2.$_terms._requireds.slice(), ordereds = schema$2.$_terms.ordered.slice(), inclusions = [...schema$2.$_terms._inclusions, ...requireds], wasArray = !value[Common$11.symbols.arraySingle];
    delete value[Common$11.symbols.arraySingle];
    let errors = errorsArray(), il = value.length;
    for (let i$4 = 0; i$4 < il; ++i$4) {
      let item = value[i$4], errored = false, isValid = false, key = wasArray ? i$4 : new Number(i$4), path = [...state.path, key];
      if (!schema$2._flags.sparse && item === void 0) {
        if (errors.push(error(`array.sparse`, { key, path, pos: i$4, value: void 0 }, state.localize(path))), prefs.abortEarly) return errors;
        ordereds.shift();
        continue;
      }
      let ancestors = [value, ...state.ancestors];
      for (let exclusion of schema$2.$_terms._exclusions) {
        if (!exclusion.$_match(item, state.localize(path, ancestors, exclusion), prefs, { presence: `ignore` })) continue;
        if (errors.push(error(`array.excludes`, { pos: i$4, value: item }, state.localize(path))), prefs.abortEarly) return errors;
        errored = true, ordereds.shift();
        break;
      }
      if (errored) continue;
      if (schema$2.$_terms.ordered.length) {
        if (ordereds.length) {
          let ordered = ordereds.shift(), res = ordered.$_validate(item, state.localize(path, ancestors, ordered), prefs);
          if (res.errors) {
            if (errors.push(...res.errors), prefs.abortEarly) return errors;
          } else if (ordered._flags.result === `strip`) internals$12.fastSplice(value, i$4), --i$4, --il;
          else if (!schema$2._flags.sparse && res.value === void 0) {
            if (errors.push(error(`array.sparse`, { key, path, pos: i$4, value: void 0 }, state.localize(path))), prefs.abortEarly) return errors;
            continue;
          } else value[i$4] = res.value;
          continue;
        } else if (!schema$2.$_terms.items.length) {
          if (errors.push(error(`array.orderedLength`, { pos: i$4, limit: schema$2.$_terms.ordered.length })), prefs.abortEarly) return errors;
          break;
        }
      }
      let requiredChecks = [], jl = requireds.length;
      for (let j$1 = 0; j$1 < jl; ++j$1) {
        let localState = state.localize(path, ancestors, requireds[j$1]);
        localState.snapshot();
        let res = requireds[j$1].$_validate(item, localState, prefs);
        if (requiredChecks[j$1] = res, !res.errors) {
          if (localState.commit(), value[i$4] = res.value, isValid = true, internals$12.fastSplice(requireds, j$1), --j$1, --jl, !schema$2._flags.sparse && res.value === void 0 && (errors.push(error(`array.sparse`, { key, path, pos: i$4, value: void 0 }, state.localize(path))), prefs.abortEarly)) return errors;
          break;
        }
        localState.restore();
      }
      if (isValid) continue;
      let stripUnknown = prefs.stripUnknown && !!prefs.stripUnknown.arrays || false;
      jl = inclusions.length;
      for (let inclusion of inclusions) {
        let res, previousCheck = requireds.indexOf(inclusion);
        if (previousCheck !== -1) res = requiredChecks[previousCheck];
        else {
          let localState = state.localize(path, ancestors, inclusion);
          if (localState.snapshot(), res = inclusion.$_validate(item, localState, prefs), !res.errors) {
            localState.commit(), inclusion._flags.result === `strip` ? (internals$12.fastSplice(value, i$4), --i$4, --il) : !schema$2._flags.sparse && res.value === void 0 ? (errors.push(error(`array.sparse`, { key, path, pos: i$4, value: void 0 }, state.localize(path))), errored = true) : value[i$4] = res.value, isValid = true;
            break;
          }
          localState.restore();
        }
        if (jl === 1) {
          if (stripUnknown) {
            internals$12.fastSplice(value, i$4), --i$4, --il, isValid = true;
            break;
          }
          if (errors.push(...res.errors), prefs.abortEarly) return errors;
          errored = true;
          break;
        }
      }
      if (!errored && (schema$2.$_terms._inclusions.length || schema$2.$_terms._requireds.length) && !isValid) {
        if (stripUnknown) {
          internals$12.fastSplice(value, i$4), --i$4, --il;
          continue;
        }
        if (errors.push(error(`array.includes`, { pos: i$4, value: item }, state.localize(path))), prefs.abortEarly) return errors;
      }
    }
    return requireds.length && internals$12.fillMissedErrors(schema$2, errors, requireds, value, state, prefs), ordereds.length && (internals$12.fillOrderedErrors(schema$2, errors, ordereds, value, state, prefs), errors.length || internals$12.fillDefault(ordereds, value, state, prefs)), errors.length ? errors : value;
  }, priority: true, manifest: false }, length: { method(limit) {
    return this.$_addRule({ name: `length`, args: { limit }, operator: `=` });
  }, validate(value, helpers$8, { limit }, { name: name$2, operator: operator$1, args: args$1 }) {
    return Common$11.compare(value.length, limit, operator$1) ? value : helpers$8.error(`array.` + name$2, { limit: args$1.limit, value });
  }, args: [{ name: `limit`, ref: true, assert: Common$11.limit, message: `must be a positive integer` }] }, max: { method(limit) {
    return this.$_addRule({ name: `max`, method: `length`, args: { limit }, operator: `<=` });
  } }, min: { method(limit) {
    return this.$_addRule({ name: `min`, method: `length`, args: { limit }, operator: `>=` });
  } }, ordered: { method(...schemas) {
    Common$11.verifyFlat(schemas, `ordered`);
    let obj = this.$_addRule(`items`);
    for (let i$4 = 0; i$4 < schemas.length; ++i$4) {
      let type = Common$11.tryWithPath(() => this.$_compile(schemas[i$4]), i$4, { append: true });
      internals$12.validateSingle(type, obj), obj.$_mutateRegister(type), obj.$_terms.ordered.push(type);
    }
    return obj.$_mutateRebuild();
  } }, single: { method(enabled) {
    let value = enabled === void 0 ? true : !!enabled;
    return assert$38(!value || !this._flags._arrayItems, `Cannot specify single rule when array has array items`), this.$_setFlag(`single`, value);
  } }, sort: { method(options = {}) {
    Common$11.assertOptions(options, [`by`, `order`]);
    let settings = { order: options.order || `ascending` };
    return options.by && (settings.by = Compile$4.ref(options.by, { ancestor: 0 }), assert$38(!settings.by.ancestor, `Cannot sort by ancestor`)), this.$_addRule({ name: `sort`, args: { options: settings } });
  }, validate(value, { error, state, prefs, schema: schema$2 }, { options }) {
    let { value: sorted, errors } = internals$12.sort(schema$2, value, options, state, prefs);
    if (errors) return errors;
    for (let i$4 = 0; i$4 < value.length; ++i$4) if (value[i$4] !== sorted[i$4]) return error(`array.sort`, { order: options.order, by: options.by ? options.by.key : `value` });
    return value;
  }, convert: true }, sparse: { method(enabled) {
    let value = enabled === void 0 ? true : !!enabled;
    if (this._flags.sparse === value) return this;
    let obj = value ? this.clone() : this.$_addRule(`items`);
    return obj.$_setFlag(`sparse`, value, { clone: false });
  } }, unique: { method(comparator, options = {}) {
    assert$38(!comparator || typeof comparator == `function` || typeof comparator == `string`, `comparator must be a function or a string`), Common$11.assertOptions(options, [`ignoreUndefined`, `separator`]);
    let rule = { name: `unique`, args: { options, comparator } };
    if (comparator) if (typeof comparator == `string`) {
      let separator = Common$11.default(options.separator, `.`);
      rule.path = separator ? comparator.split(separator) : [comparator];
    } else rule.comparator = comparator;
    return this.$_addRule(rule);
  }, validate(value, { state, error, schema: schema$2 }, { comparator: raw, options }, { comparator, path }) {
    let found = { string: /* @__PURE__ */ Object.create(null), number: /* @__PURE__ */ Object.create(null), undefined: /* @__PURE__ */ Object.create(null), boolean: /* @__PURE__ */ Object.create(null), bigint: /* @__PURE__ */ Object.create(null), object: /* @__PURE__ */ new Map(), function: /* @__PURE__ */ new Map(), custom: /* @__PURE__ */ new Map() }, compare$16 = comparator || deepEqual, ignoreUndefined = options.ignoreUndefined;
    for (let i$4 = 0; i$4 < value.length; ++i$4) {
      let item = path ? reach(value[i$4], path) : value[i$4], records = comparator ? found.custom : found[typeof item];
      if (assert$38(records, `Failed to find unique map container for type`, typeof item), records instanceof Map) {
        let entries = records.entries(), current;
        for (; !(current = entries.next()).done; ) if (compare$16(current.value[0], item)) {
          let localState = state.localize([...state.path, i$4], [value, ...state.ancestors]), context = { pos: i$4, value: value[i$4], dupePos: current.value[1], dupeValue: value[current.value[1]] };
          return path && (context.path = raw), error(`array.unique`, context, localState);
        }
        records.set(item, i$4);
      } else {
        if ((!ignoreUndefined || item !== void 0) && records[item] !== void 0) {
          let context = { pos: i$4, value: value[i$4], dupePos: records[item], dupeValue: value[records[item]] };
          path && (context.path = raw);
          let localState = state.localize([...state.path, i$4], [value, ...state.ancestors]);
          return error(`array.unique`, context, localState);
        }
        records[item] = i$4;
      }
    }
    return value;
  }, args: [`comparator`, `options`], multi: true } }, overrides: { isAsync() {
    if (this.$_terms.externals?.length) return true;
    for (let item of this.$_terms.items) if (item.isAsync()) return true;
    for (let item of this.$_terms.ordered) if (item.isAsync()) return true;
    return false;
  } }, cast: { set: { from: Array.isArray, to(value, helpers$8) {
    return new Set(value);
  } } }, rebuild(schema$2) {
    schema$2.$_terms._inclusions = [], schema$2.$_terms._exclusions = [], schema$2.$_terms._requireds = [];
    for (let type of schema$2.$_terms.items) internals$12.validateSingle(type, schema$2), type._flags.presence === `required` ? schema$2.$_terms._requireds.push(type) : type._flags.presence === `forbidden` ? schema$2.$_terms._exclusions.push(type) : schema$2.$_terms._inclusions.push(type);
    for (let type of schema$2.$_terms.ordered) internals$12.validateSingle(type, schema$2);
  }, manifest: { build(obj, desc$1) {
    return desc$1.items && (obj = obj.items(...desc$1.items)), desc$1.ordered && (obj = obj.ordered(...desc$1.ordered)), obj;
  } }, messages: { "array.base": `{{#label}} must be an array`, "array.excludes": `{{#label}} contains an excluded value`, "array.hasKnown": `{{#label}} does not contain at least one required match for type {:#patternLabel}`, "array.hasUnknown": `{{#label}} does not contain at least one required match`, "array.includes": `{{#label}} does not match any of the allowed types`, "array.includesRequiredBoth": `{{#label}} does not contain {{#knownMisses}} and {{#unknownMisses}} other required value(s)`, "array.includesRequiredKnowns": `{{#label}} does not contain {{#knownMisses}}`, "array.includesRequiredUnknowns": `{{#label}} does not contain {{#unknownMisses}} required value(s)`, "array.length": `{{#label}} must contain {{#limit}} items`, "array.max": `{{#label}} must contain less than or equal to {{#limit}} items`, "array.min": `{{#label}} must contain at least {{#limit}} items`, "array.orderedLength": `{{#label}} must contain at most {{#limit}} items`, "array.sort": `{{#label}} must be sorted in {#order} order by {{#by}}`, "array.sort.mismatching": `{{#label}} cannot be sorted due to mismatching types`, "array.sort.unsupported": `{{#label}} cannot be sorted due to unsupported type {#type}`, "array.sparse": `{{#label}} must not be a sparse array item`, "array.unique": `{{#label}} contains a duplicate value` } }), internals$12.fillMissedErrors = function(schema$2, errors, requireds, value, state, prefs) {
    let knownMisses = [], unknownMisses = 0;
    for (let required of requireds) {
      let label = required._flags.label;
      label ? knownMisses.push(label) : ++unknownMisses;
    }
    knownMisses.length ? unknownMisses ? errors.push(schema$2.$_createError(`array.includesRequiredBoth`, value, { knownMisses, unknownMisses }, state, prefs)) : errors.push(schema$2.$_createError(`array.includesRequiredKnowns`, value, { knownMisses }, state, prefs)) : errors.push(schema$2.$_createError(`array.includesRequiredUnknowns`, value, { unknownMisses }, state, prefs));
  }, internals$12.fillOrderedErrors = function(schema$2, errors, ordereds, value, state, prefs) {
    let requiredOrdereds = [];
    for (let ordered of ordereds) ordered._flags.presence === `required` && requiredOrdereds.push(ordered);
    requiredOrdereds.length && internals$12.fillMissedErrors(schema$2, errors, requiredOrdereds, value, state, prefs);
  }, internals$12.fillDefault = function(ordereds, value, state, prefs) {
    let overrides = [], trailingUndefined = true;
    for (let i$4 = ordereds.length - 1; i$4 >= 0; --i$4) {
      let ordered = ordereds[i$4], ancestors = [value, ...state.ancestors], override = ordered.$_validate(void 0, state.localize(state.path, ancestors, ordered), prefs).value;
      if (trailingUndefined) {
        if (override === void 0) continue;
        trailingUndefined = false;
      }
      overrides.unshift(override);
    }
    overrides.length && value.push(...overrides);
  }, internals$12.fastSplice = function(arr, i$4) {
    let pos = i$4;
    for (; pos < arr.length; ) arr[pos++] = arr[pos];
    --arr.length;
  }, internals$12.validateSingle = function(type, obj) {
    (type.type === `array` || type._flags._arrayItems) && (assert$38(!obj._flags.single, `Cannot specify array item with single rule enabled`), obj.$_setFlag(`_arrayItems`, true, { clone: false }));
  }, internals$12.sort = function(schema$2, value, settings, state, prefs) {
    let order$2 = settings.order === `ascending` ? 1 : -1, aFirst = -1 * order$2, bFirst = order$2, sort$2 = (a$22, b2) => {
      let compare$16 = internals$12.compare(a$22, b2, aFirst, bFirst);
      if (compare$16 !== null || (settings.by && (a$22 = settings.by.resolve(a$22, state, prefs), b2 = settings.by.resolve(b2, state, prefs)), compare$16 = internals$12.compare(a$22, b2, aFirst, bFirst), compare$16 !== null)) return compare$16;
      let type = typeof a$22;
      if (type !== typeof b2) throw schema$2.$_createError(`array.sort.mismatching`, value, null, state, prefs);
      if (type !== `number` && type !== `string`) throw schema$2.$_createError(`array.sort.unsupported`, value, { type }, state, prefs);
      return type === `number` ? (a$22 - b2) * order$2 : a$22 < b2 ? aFirst : bFirst;
    };
    try {
      return { value: value.slice().sort(sort$2) };
    } catch (err$1) {
      return { errors: err$1 };
    }
  }, internals$12.compare = function(a$22, b2, aFirst, bFirst) {
    return a$22 === b2 ? 0 : a$22 === void 0 ? 1 : b2 === void 0 ? -1 : a$22 === null ? bFirst : b2 === null ? aFirst : null;
  };
}), require_boolean = __commonJSMin$1((exports$12, module2) => {
  let { assert: assert$37 } = require_lib$4(), Any$7 = require_any(), Common$10 = require_common$3(), Values = require_values$1(), internals$11 = {};
  internals$11.isBool = function(value) {
    return typeof value == `boolean`;
  }, module2.exports = Any$7.extend({ type: `boolean`, flags: { sensitive: { default: false } }, terms: { falsy: { init: null, manifest: `values` }, truthy: { init: null, manifest: `values` } }, coerce(value, { schema: schema$2 }) {
    if (typeof value != `boolean`) {
      if (typeof value == `string`) {
        let normalized = schema$2._flags.sensitive ? value : value.toLowerCase();
        value = normalized === `true` ? true : normalized === `false` ? false : value;
      }
      return typeof value != `boolean` && (value = schema$2.$_terms.truthy && schema$2.$_terms.truthy.has(value, null, null, !schema$2._flags.sensitive) || (schema$2.$_terms.falsy && schema$2.$_terms.falsy.has(value, null, null, !schema$2._flags.sensitive) ? false : value)), { value };
    }
  }, validate(value, { error }) {
    if (typeof value != `boolean`) return { value, errors: error(`boolean.base`) };
  }, rules: { truthy: { method(...values$3) {
    Common$10.verifyFlat(values$3, `truthy`);
    let obj = this.clone();
    obj.$_terms.truthy = obj.$_terms.truthy || new Values();
    for (let i$4 = 0; i$4 < values$3.length; ++i$4) {
      let value = values$3[i$4];
      assert$37(value !== void 0, `Cannot call truthy with undefined`), obj.$_terms.truthy.add(value);
    }
    return obj;
  } }, falsy: { method(...values$3) {
    Common$10.verifyFlat(values$3, `falsy`);
    let obj = this.clone();
    obj.$_terms.falsy = obj.$_terms.falsy || new Values();
    for (let i$4 = 0; i$4 < values$3.length; ++i$4) {
      let value = values$3[i$4];
      assert$37(value !== void 0, `Cannot call falsy with undefined`), obj.$_terms.falsy.add(value);
    }
    return obj;
  } }, sensitive: { method(enabled = true) {
    return this.$_setFlag(`sensitive`, enabled);
  } } }, cast: { number: { from: internals$11.isBool, to(value, helpers$8) {
    return value ? 1 : 0;
  } }, string: { from: internals$11.isBool, to(value, helpers$8) {
    return value ? `true` : `false`;
  } } }, manifest: { build(obj, desc$1) {
    return desc$1.truthy && (obj = obj.truthy(...desc$1.truthy)), desc$1.falsy && (obj = obj.falsy(...desc$1.falsy)), obj;
  } }, messages: { "boolean.base": `{{#label}} must be a boolean` } });
}), require_date = __commonJSMin$1((exports$12, module2) => {
  let { assert: assert$36 } = require_lib$4(), Any$6 = require_any(), Common$9 = require_common$3(), Template$4 = require_template(), internals$10 = {};
  internals$10.isDate = function(value) {
    return value instanceof Date;
  }, module2.exports = Any$6.extend({ type: `date`, coerce: { from: [`number`, `string`], method(value, { schema: schema$2 }) {
    return { value: internals$10.parse(value, schema$2._flags.format) || value };
  } }, validate(value, { schema: schema$2, error, prefs }) {
    if (value instanceof Date && !isNaN(value.getTime())) return;
    let format = schema$2._flags.format;
    return !prefs.convert || !format || typeof value != `string` ? { value, errors: error(`date.base`) } : { value, errors: error(`date.format`, { format }) };
  }, rules: { compare: { method: false, validate(value, helpers$8, { date }, { name: name$2, operator: operator$1, args: args$1 }) {
    let to = date === `now` ? Date.now() : date.getTime();
    return Common$9.compare(value.getTime(), to, operator$1) ? value : helpers$8.error(`date.` + name$2, { limit: args$1.date, value });
  }, args: [{ name: `date`, ref: true, normalize: (date) => date === `now` ? date : internals$10.parse(date), assert: (date) => date !== null, message: `must have a valid date format` }] }, format: { method(format) {
    return assert$36([`iso`, `javascript`, `unix`].includes(format), `Unknown date format`, format), this.$_setFlag(`format`, format);
  } }, greater: { method(date) {
    return this.$_addRule({ name: `greater`, method: `compare`, args: { date }, operator: `>` });
  } }, iso: { method() {
    return this.format(`iso`);
  } }, less: { method(date) {
    return this.$_addRule({ name: `less`, method: `compare`, args: { date }, operator: `<` });
  } }, max: { method(date) {
    return this.$_addRule({ name: `max`, method: `compare`, args: { date }, operator: `<=` });
  } }, min: { method(date) {
    return this.$_addRule({ name: `min`, method: `compare`, args: { date }, operator: `>=` });
  } }, timestamp: { method(type = `javascript`) {
    return assert$36([`javascript`, `unix`].includes(type), `"type" must be one of "javascript, unix"`), this.format(type);
  } } }, cast: { number: { from: internals$10.isDate, to(value, helpers$8) {
    return value.getTime();
  } }, string: { from: internals$10.isDate, to(value, { prefs }) {
    return Template$4.date(value, prefs);
  } } }, messages: { "date.base": `{{#label}} must be a valid date`, "date.format": `{{#label}} must be in {msg("date.format." + #format) || #format} format`, "date.greater": `{{#label}} must be greater than {{:#limit}}`, "date.less": `{{#label}} must be less than {{:#limit}}`, "date.max": `{{#label}} must be less than or equal to {{:#limit}}`, "date.min": `{{#label}} must be greater than or equal to {{:#limit}}`, "date.format.iso": `ISO 8601 date`, "date.format.javascript": `timestamp or number of milliseconds`, "date.format.unix": `timestamp or number of seconds` } }), internals$10.parse = function(value, format) {
    if (value instanceof Date) return value;
    if (typeof value != `string` && (isNaN(value) || !isFinite(value)) || /^\s*$/.test(value)) return null;
    if (format === `iso`) return Common$9.isIsoDate(value) ? internals$10.date(value.toString()) : null;
    let original = value;
    if (typeof value == `string` && /^[+-]?\d+(\.\d+)?$/.test(value) && (value = parseFloat(value)), format) {
      if (format === `javascript`) return internals$10.date(1 * value);
      if (format === `unix`) return internals$10.date(1e3 * value);
      if (typeof original == `string`) return null;
    }
    return internals$10.date(value);
  }, internals$10.date = function(value) {
    let date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
  };
}), require_lib$1 = __commonJSMin$1((exports$12) => {
  let { assert: assert$35 } = require_lib$4(), internals$9 = {};
  exports$12.Sorter = class {
    constructor() {
      this._items = [], this.nodes = [];
    }
    add(nodes, options) {
      options ??= {};
      let before = [].concat(options.before ?? []), after = [].concat(options.after ?? []), group = options.group ?? `?`, sort$2 = options.sort ?? 0;
      assert$35(!before.includes(group), `Item cannot come before itself: ${group}`), assert$35(!before.includes(`?`), `Item cannot come before unassociated items`), assert$35(!after.includes(group), `Item cannot come after itself: ${group}`), assert$35(!after.includes(`?`), `Item cannot come after unassociated items`), Array.isArray(nodes) || (nodes = [nodes]);
      for (let node of nodes) {
        let item = { seq: this._items.length, sort: sort$2, before, after, group, node };
        this._items.push(item);
      }
      if (!options.manual) {
        let valid$2 = this._sort();
        assert$35(valid$2, `item`, group === `?` ? `` : `added into group ${group}`, `created a dependencies error`);
      }
      return this.nodes;
    }
    merge(others) {
      Array.isArray(others) || (others = [others]);
      for (let other of others) if (other) for (let item of other._items) this._items.push(Object.assign({}, item));
      this._items.sort(internals$9.mergeSort);
      for (let i$4 = 0; i$4 < this._items.length; ++i$4) this._items[i$4].seq = i$4;
      let valid$2 = this._sort();
      return assert$35(valid$2, `merge created a dependencies error`), this.nodes;
    }
    sort() {
      let valid$2 = this._sort();
      return assert$35(valid$2, `sort created a dependencies error`), this.nodes;
    }
    _sort() {
      let graph = {}, graphAfters = /* @__PURE__ */ Object.create(null), groups = /* @__PURE__ */ Object.create(null);
      for (let item of this._items) {
        let seq = item.seq, group = item.group;
        groups[group] = groups[group] ?? [], groups[group].push(seq), graph[seq] = item.before;
        for (let after of item.after) graphAfters[after] = graphAfters[after] ?? [], graphAfters[after].push(seq);
      }
      for (let node in graph) {
        let expandedGroups = [];
        for (let graphNodeItem in graph[node]) {
          let group = graph[node][graphNodeItem];
          groups[group] = groups[group] ?? [], expandedGroups.push(...groups[group]);
        }
        graph[node] = expandedGroups;
      }
      for (let group in graphAfters) if (groups[group]) for (let node of groups[group]) graph[node].push(...graphAfters[group]);
      let ancestors = {};
      for (let node in graph) {
        let children = graph[node];
        for (let child of children) ancestors[child] = ancestors[child] ?? [], ancestors[child].push(node);
      }
      let visited = {}, sorted = [];
      for (let i$4 = 0; i$4 < this._items.length; ++i$4) {
        let next = i$4;
        if (ancestors[i$4]) {
          next = null;
          for (let j$1 = 0; j$1 < this._items.length; ++j$1) {
            if (visited[j$1] === true) continue;
            ancestors[j$1] || (ancestors[j$1] = []);
            let shouldSeeCount = ancestors[j$1].length, seenCount = 0;
            for (let k = 0; k < shouldSeeCount; ++k) visited[ancestors[j$1][k]] && ++seenCount;
            if (seenCount === shouldSeeCount) {
              next = j$1;
              break;
            }
          }
        }
        next !== null && (visited[next] = true, sorted.push(next));
      }
      if (sorted.length !== this._items.length) return false;
      let seqIndex = {};
      for (let item of this._items) seqIndex[item.seq] = item;
      this._items = [], this.nodes = [];
      for (let value of sorted) {
        let sortedItem = seqIndex[value];
        this.nodes.push(sortedItem.node), this._items.push(sortedItem);
      }
      return true;
    }
  }, internals$9.mergeSort = (a$22, b2) => a$22.sort === b2.sort ? 0 : a$22.sort < b2.sort ? -1 : 1;
}), require_keys$1 = __commonJSMin$1((exports$12, module2) => {
  let { applyToDefaults, assert: assert$34, clone: Clone } = require_lib$4(), Topo = require_lib$1(), Any$5 = require_any(), Common$8 = require_common$3(), Compile$3 = require_compile(), Errors$3 = require_errors$2(), Ref$5 = require_ref$2(), Template$3 = require_template(), internals$8 = { renameDefaults: { alias: false, multiple: false, override: false } };
  module2.exports = Any$5.extend({ type: `_keys`, properties: { typeof: `object` }, flags: { unknown: { default: void 0 } }, terms: { dependencies: { init: null }, keys: { init: null, manifest: { mapped: { from: `schema`, to: `key` } } }, patterns: { init: null }, renames: { init: null } }, args(schema$2, keys$10) {
    return schema$2.keys(keys$10);
  }, validate(value, { schema: schema$2, error, state, prefs }) {
    if (!value || typeof value !== schema$2.$_property(`typeof`) || Array.isArray(value)) return { value, errors: error(`object.base`, { type: schema$2.$_property(`typeof`) }) };
    if (!schema$2.$_terms.renames && !schema$2.$_terms.dependencies && !schema$2.$_terms.keys && !schema$2.$_terms.patterns && !schema$2.$_terms.externals) return;
    value = internals$8.clone(value, prefs);
    let errors = [];
    if (schema$2.$_terms.renames && !internals$8.rename(schema$2, value, state, prefs, errors) || !schema$2.$_terms.keys && !schema$2.$_terms.patterns && !schema$2.$_terms.dependencies) return { value, errors };
    let unprocessed = new Set(Object.keys(value));
    if (schema$2.$_terms.keys) {
      let ancestors = [value, ...state.ancestors];
      for (let child of schema$2.$_terms.keys) {
        let key = child.key, item = value[key];
        unprocessed.delete(key);
        let localState = state.localize([...state.path, key], ancestors, child), result = child.schema.$_validate(item, localState, prefs);
        if (result.errors) {
          if (prefs.abortEarly) return { value, errors: result.errors };
          result.value !== void 0 && (value[key] = result.value), errors.push(...result.errors);
        } else child.schema._flags.result === `strip` || result.value === void 0 && item !== void 0 ? delete value[key] : result.value !== void 0 && (value[key] = result.value);
      }
    }
    if (unprocessed.size || schema$2._flags._hasPatternMatch) {
      let early = internals$8.unknown(schema$2, value, unprocessed, errors, state, prefs);
      if (early) return early;
    }
    if (schema$2.$_terms.dependencies) for (let dep of schema$2.$_terms.dependencies) {
      if (dep.key !== null && internals$8.isPresent(dep.options)(dep.key.resolve(value, state, prefs, null, { shadow: false })) === false) continue;
      let failed = internals$8.dependencies[dep.rel](schema$2, dep, value, state, prefs);
      if (failed) {
        let report = schema$2.$_createError(failed.code, value, failed.context, state, prefs);
        if (prefs.abortEarly) return { value, errors: report };
        errors.push(report);
      }
    }
    return { value, errors };
  }, rules: { and: { method(...peers) {
    return Common$8.verifyFlat(peers, `and`), internals$8.dependency(this, `and`, null, peers);
  } }, append: { method(schema$2) {
    return schema$2 == null || Object.keys(schema$2).length === 0 ? this : this.keys(schema$2);
  } }, assert: { method(subject, schema$2, message) {
    Template$3.isTemplate(subject) || (subject = Compile$3.ref(subject)), assert$34(message === void 0 || typeof message == `string`, `Message must be a string`), schema$2 = this.$_compile(schema$2, { appendPath: true });
    let obj = this.$_addRule({ name: `assert`, args: { subject, schema: schema$2, message } });
    return obj.$_mutateRegister(subject), obj.$_mutateRegister(schema$2), obj;
  }, validate(value, { error, prefs, state }, { subject, schema: schema$2, message }) {
    let about = subject.resolve(value, state, prefs), path = Ref$5.isRef(subject) ? subject.absolute(state) : [];
    return schema$2.$_match(about, state.localize(path, [value, ...state.ancestors], schema$2), prefs) ? value : error(`object.assert`, { subject, message });
  }, args: [`subject`, `schema`, `message`], multi: true }, instance: { method(constructor, name$2) {
    return assert$34(typeof constructor == `function`, `constructor must be a function`), name$2 ||= constructor.name, this.$_addRule({ name: `instance`, args: { constructor, name: name$2 } });
  }, validate(value, helpers$8, { constructor, name: name$2 }) {
    return value instanceof constructor ? value : helpers$8.error(`object.instance`, { type: name$2, value });
  }, args: [`constructor`, `name`] }, keys: { method(schema$2) {
    assert$34(schema$2 === void 0 || typeof schema$2 == `object`, `Object schema must be a valid object`), assert$34(!Common$8.isSchema(schema$2), `Object schema cannot be a joi schema`);
    let obj = this.clone();
    if (!schema$2) obj.$_terms.keys = null;
    else if (!Object.keys(schema$2).length) obj.$_terms.keys = new internals$8.Keys();
    else for (let key in obj.$_terms.keys = obj.$_terms.keys ? obj.$_terms.keys.filter((child) => !schema$2.hasOwnProperty(child.key)) : new internals$8.Keys(), schema$2) Common$8.tryWithPath(() => obj.$_terms.keys.push({ key, schema: this.$_compile(schema$2[key]) }), key);
    return obj.$_mutateRebuild();
  } }, length: { method(limit) {
    return this.$_addRule({ name: `length`, args: { limit }, operator: `=` });
  }, validate(value, helpers$8, { limit }, { name: name$2, operator: operator$1, args: args$1 }) {
    return Common$8.compare(Object.keys(value).length, limit, operator$1) ? value : helpers$8.error(`object.` + name$2, { limit: args$1.limit, value });
  }, args: [{ name: `limit`, ref: true, assert: Common$8.limit, message: `must be a positive integer` }] }, max: { method(limit) {
    return this.$_addRule({ name: `max`, method: `length`, args: { limit }, operator: `<=` });
  } }, min: { method(limit) {
    return this.$_addRule({ name: `min`, method: `length`, args: { limit }, operator: `>=` });
  } }, nand: { method(...peers) {
    return Common$8.verifyFlat(peers, `nand`), internals$8.dependency(this, `nand`, null, peers);
  } }, or: { method(...peers) {
    return Common$8.verifyFlat(peers, `or`), internals$8.dependency(this, `or`, null, peers);
  } }, oxor: { method(...peers) {
    return internals$8.dependency(this, `oxor`, null, peers);
  } }, pattern: { method(pattern, schema$2, options = {}) {
    let isRegExp$3 = pattern instanceof RegExp;
    isRegExp$3 || (pattern = this.$_compile(pattern, { appendPath: true })), assert$34(schema$2 !== void 0, `Invalid rule`), Common$8.assertOptions(options, [`fallthrough`, `matches`]), isRegExp$3 && assert$34(!pattern.flags.includes(`g`) && !pattern.flags.includes(`y`), `pattern should not use global or sticky mode`), schema$2 = this.$_compile(schema$2, { appendPath: true });
    let obj = this.clone();
    obj.$_terms.patterns = obj.$_terms.patterns || [];
    let config = { [isRegExp$3 ? `regex` : `schema`]: pattern, rule: schema$2 };
    return options.matches && (config.matches = this.$_compile(options.matches), config.matches.type !== `array` && (config.matches = config.matches.$_root.array().items(config.matches)), obj.$_mutateRegister(config.matches), obj.$_setFlag(`_hasPatternMatch`, true, { clone: false })), options.fallthrough && (config.fallthrough = true), obj.$_terms.patterns.push(config), obj.$_mutateRegister(schema$2), obj;
  } }, ref: { method() {
    return this.$_addRule(`ref`);
  }, validate(value, helpers$8) {
    return Ref$5.isRef(value) ? value : helpers$8.error(`object.refType`, { value });
  } }, regex: { method() {
    return this.$_addRule(`regex`);
  }, validate(value, helpers$8) {
    return value instanceof RegExp ? value : helpers$8.error(`object.regex`, { value });
  } }, rename: { method(from$2, to, options = {}) {
    assert$34(typeof from$2 == `string` || from$2 instanceof RegExp, `Rename missing the from argument`), assert$34(typeof to == `string` || to instanceof Template$3, `Invalid rename to argument`), assert$34(to !== from$2, `Cannot rename key to same name:`, from$2), Common$8.assertOptions(options, [`alias`, `ignoreUndefined`, `override`, `multiple`]);
    let obj = this.clone();
    obj.$_terms.renames = obj.$_terms.renames || [];
    for (let rename of obj.$_terms.renames) assert$34(rename.from !== from$2, `Cannot rename the same key multiple times`);
    return to instanceof Template$3 && obj.$_mutateRegister(to), obj.$_terms.renames.push({ from: from$2, to, options: applyToDefaults(internals$8.renameDefaults, options) }), obj;
  } }, schema: { method(type = `any`) {
    return this.$_addRule({ name: `schema`, args: { type } });
  }, validate(value, helpers$8, { type }) {
    return Common$8.isSchema(value) && (type === `any` || value.type === type) ? value : helpers$8.error(`object.schema`, { type });
  } }, unknown: { method(allow) {
    return this.$_setFlag(`unknown`, allow !== false);
  } }, with: { method(key, peers, options = {}) {
    return internals$8.dependency(this, `with`, key, peers, options);
  } }, without: { method(key, peers, options = {}) {
    return internals$8.dependency(this, `without`, key, peers, options);
  } }, xor: { method(...peers) {
    return Common$8.verifyFlat(peers, `xor`), internals$8.dependency(this, `xor`, null, peers);
  } } }, overrides: { default(value, options) {
    return value === void 0 && (value = Common$8.symbols.deepDefault), this.$_parent(`default`, value, options);
  }, isAsync() {
    if (this.$_terms.externals?.length) return true;
    if (this.$_terms.keys?.length) {
      for (let key of this.$_terms.keys) if (key.schema.isAsync()) return true;
    }
    if (this.$_terms.patterns?.length) {
      for (let pattern of this.$_terms.patterns) if (pattern.rule.isAsync()) return true;
    }
    return false;
  } }, rebuild(schema$2) {
    if (schema$2.$_terms.keys) {
      let topo = new Topo.Sorter();
      for (let child of schema$2.$_terms.keys) Common$8.tryWithPath(() => topo.add(child, { after: child.schema.$_rootReferences(), group: child.key }), child.key);
      schema$2.$_terms.keys = new internals$8.Keys(...topo.nodes);
    }
  }, manifest: { build(obj, desc$1) {
    if (desc$1.keys && (obj = obj.keys(desc$1.keys)), desc$1.dependencies) for (let { rel, key = null, peers, options } of desc$1.dependencies) obj = internals$8.dependency(obj, rel, key, peers, options);
    if (desc$1.patterns) for (let { regex, schema: schema$2, rule, fallthrough, matches } of desc$1.patterns) obj = obj.pattern(regex || schema$2, rule, { fallthrough, matches });
    if (desc$1.renames) for (let { from: from$2, to, options } of desc$1.renames) obj = obj.rename(from$2, to, options);
    return obj;
  } }, messages: { "object.and": `{{#label}} contains {{#presentWithLabels}} without its required peers {{#missingWithLabels}}`, "object.assert": '{{#label}} is invalid because {if(#subject.key, `"` + #subject.key + `" failed to ` + (#message || "pass the assertion test"), #message || "the assertion failed")}', "object.base": `{{#label}} must be of type {{#type}}`, "object.instance": `{{#label}} must be an instance of {{:#type}}`, "object.length": `{{#label}} must have {{#limit}} key{if(#limit == 1, "", "s")}`, "object.max": `{{#label}} must have less than or equal to {{#limit}} key{if(#limit == 1, "", "s")}`, "object.min": `{{#label}} must have at least {{#limit}} key{if(#limit == 1, "", "s")}`, "object.missing": `{{#label}} must contain at least one of {{#peersWithLabels}}`, "object.nand": `{{:#mainWithLabel}} must not exist simultaneously with {{#peersWithLabels}}`, "object.oxor": `{{#label}} contains a conflict between optional exclusive peers {{#peersWithLabels}}`, "object.pattern.match": `{{#label}} keys failed to match pattern requirements`, "object.refType": `{{#label}} must be a Joi reference`, "object.regex": `{{#label}} must be a RegExp object`, "object.rename.multiple": `{{#label}} cannot rename {{:#from}} because multiple renames are disabled and another key was already renamed to {{:#to}}`, "object.rename.override": `{{#label}} cannot rename {{:#from}} because override is disabled and target {{:#to}} exists`, "object.schema": `{{#label}} must be a Joi schema of {{#type}} type`, "object.unknown": `{{#label}} is not allowed`, "object.with": `{{:#mainWithLabel}} missing required peer {{:#peerWithLabel}}`, "object.without": `{{:#mainWithLabel}} conflict with forbidden peer {{:#peerWithLabel}}`, "object.xor": `{{#label}} contains a conflict between exclusive peers {{#peersWithLabels}}` } }), internals$8.clone = function(value, prefs) {
    if (typeof value == `object`) {
      if (prefs.nonEnumerables) return Clone(value, { shallow: true });
      let clone$21 = Object.create(Object.getPrototypeOf(value));
      return Object.assign(clone$21, value), clone$21;
    }
    let clone$20 = function(...args$1) {
      return value.apply(this, args$1);
    };
    return clone$20.prototype = Clone(value.prototype), Object.defineProperty(clone$20, `name`, { value: value.name, writable: false }), Object.defineProperty(clone$20, `length`, { value: value.length, writable: false }), Object.assign(clone$20, value), clone$20;
  }, internals$8.dependency = function(schema$2, rel, key, peers, options) {
    assert$34(key === null || typeof key == `string`, rel, `key must be a strings`), options ||= peers.length > 1 && typeof peers[peers.length - 1] == `object` ? peers.pop() : {}, Common$8.assertOptions(options, [`separator`, `isPresent`]), peers = [].concat(peers);
    let separator = Common$8.default(options.separator, `.`), paths = [];
    for (let peer of peers) assert$34(typeof peer == `string`, rel, `peers must be strings`), paths.push(Compile$3.ref(peer, { separator, ancestor: 0, prefix: false }));
    key !== null && (key = Compile$3.ref(key, { separator, ancestor: 0, prefix: false }));
    let obj = schema$2.clone();
    return obj.$_terms.dependencies = obj.$_terms.dependencies || [], obj.$_terms.dependencies.push(new internals$8.Dependency(rel, key, paths, peers, options)), obj;
  }, internals$8.dependencies = { and(schema$2, dep, value, state, prefs) {
    let missing = [], present = [], count = dep.peers.length, isPresent = internals$8.isPresent(dep.options);
    for (let peer of dep.peers) isPresent(peer.resolve(value, state, prefs, null, { shadow: false })) === false ? missing.push(peer.key) : present.push(peer.key);
    if (missing.length !== count && present.length !== count) return { code: `object.and`, context: { present, presentWithLabels: internals$8.keysToLabels(schema$2, present), missing, missingWithLabels: internals$8.keysToLabels(schema$2, missing) } };
  }, nand(schema$2, dep, value, state, prefs) {
    let present = [], isPresent = internals$8.isPresent(dep.options);
    for (let peer of dep.peers) isPresent(peer.resolve(value, state, prefs, null, { shadow: false })) && present.push(peer.key);
    if (present.length !== dep.peers.length) return;
    let main$2 = dep.paths[0], values$3 = dep.paths.slice(1);
    return { code: `object.nand`, context: { main: main$2, mainWithLabel: internals$8.keysToLabels(schema$2, main$2), peers: values$3, peersWithLabels: internals$8.keysToLabels(schema$2, values$3) } };
  }, or(schema$2, dep, value, state, prefs) {
    let isPresent = internals$8.isPresent(dep.options);
    for (let peer of dep.peers) if (isPresent(peer.resolve(value, state, prefs, null, { shadow: false }))) return;
    return { code: `object.missing`, context: { peers: dep.paths, peersWithLabels: internals$8.keysToLabels(schema$2, dep.paths) } };
  }, oxor(schema$2, dep, value, state, prefs) {
    let present = [], isPresent = internals$8.isPresent(dep.options);
    for (let peer of dep.peers) isPresent(peer.resolve(value, state, prefs, null, { shadow: false })) && present.push(peer.key);
    if (!present.length || present.length === 1) return;
    let context = { peers: dep.paths, peersWithLabels: internals$8.keysToLabels(schema$2, dep.paths) };
    return context.present = present, context.presentWithLabels = internals$8.keysToLabels(schema$2, present), { code: `object.oxor`, context };
  }, with(schema$2, dep, value, state, prefs) {
    let isPresent = internals$8.isPresent(dep.options);
    for (let peer of dep.peers) if (isPresent(peer.resolve(value, state, prefs, null, { shadow: false })) === false) return { code: `object.with`, context: { main: dep.key.key, mainWithLabel: internals$8.keysToLabels(schema$2, dep.key.key), peer: peer.key, peerWithLabel: internals$8.keysToLabels(schema$2, peer.key) } };
  }, without(schema$2, dep, value, state, prefs) {
    let isPresent = internals$8.isPresent(dep.options);
    for (let peer of dep.peers) if (isPresent(peer.resolve(value, state, prefs, null, { shadow: false }))) return { code: `object.without`, context: { main: dep.key.key, mainWithLabel: internals$8.keysToLabels(schema$2, dep.key.key), peer: peer.key, peerWithLabel: internals$8.keysToLabels(schema$2, peer.key) } };
  }, xor(schema$2, dep, value, state, prefs) {
    let present = [], isPresent = internals$8.isPresent(dep.options);
    for (let peer of dep.peers) isPresent(peer.resolve(value, state, prefs, null, { shadow: false })) && present.push(peer.key);
    if (present.length === 1) return;
    let context = { peers: dep.paths, peersWithLabels: internals$8.keysToLabels(schema$2, dep.paths) };
    return present.length === 0 ? { code: `object.missing`, context } : (context.present = present, context.presentWithLabels = internals$8.keysToLabels(schema$2, present), { code: `object.xor`, context });
  } }, internals$8.keysToLabels = function(schema$2, keys$10) {
    return Array.isArray(keys$10) ? keys$10.map((key) => schema$2.$_mapLabels(key)) : schema$2.$_mapLabels(keys$10);
  }, internals$8.isPresent = function(options) {
    return typeof options.isPresent == `function` ? options.isPresent : (resolved) => resolved !== void 0;
  }, internals$8.rename = function(schema$2, value, state, prefs, errors) {
    let renamed = {};
    for (let rename of schema$2.$_terms.renames) {
      let matches = [], pattern = typeof rename.from != `string`;
      if (!pattern) Object.prototype.hasOwnProperty.call(value, rename.from) && (value[rename.from] !== void 0 || !rename.options.ignoreUndefined) && matches.push(rename);
      else for (let from$2 in value) {
        if (value[from$2] === void 0 && rename.options.ignoreUndefined || from$2 === rename.to) continue;
        let match$2 = rename.from.exec(from$2);
        if (!match$2) continue;
        matches.push({ from: from$2, to: rename.to, match: match$2 });
      }
      for (let match$2 of matches) {
        let from$2 = match$2.from, to = match$2.to;
        if (to instanceof Template$3 && (to = to.render(value, state, prefs, match$2.match)), from$2 === to) continue;
        if (!rename.options.multiple && renamed[to] && (errors.push(schema$2.$_createError(`object.rename.multiple`, value, { from: from$2, to, pattern }, state, prefs)), prefs.abortEarly) || Object.prototype.hasOwnProperty.call(value, to) && !rename.options.override && !renamed[to] && (errors.push(schema$2.$_createError(`object.rename.override`, value, { from: from$2, to, pattern }, state, prefs)), prefs.abortEarly)) return false;
        value[from$2] === void 0 ? delete value[to] : value[to] = value[from$2], renamed[to] = true, rename.options.alias || delete value[from$2];
      }
    }
    return true;
  }, internals$8.unknown = function(schema$2, value, unprocessed, errors, state, prefs) {
    if (schema$2.$_terms.patterns) {
      let hasMatches = false, matches = schema$2.$_terms.patterns.map((pattern) => {
        if (pattern.matches) return hasMatches = true, [];
      }), ancestors = [value, ...state.ancestors];
      for (let key of unprocessed) {
        let item = value[key], path = [...state.path, key];
        for (let i$4 = 0; i$4 < schema$2.$_terms.patterns.length; ++i$4) {
          let pattern = schema$2.$_terms.patterns[i$4];
          if (pattern.regex) {
            let match$2 = pattern.regex.test(key);
            if (state.mainstay.tracer.debug(state, `rule`, `pattern.${i$4}`, match$2 ? `pass` : `error`), !match$2) continue;
          } else if (!pattern.schema.$_match(key, state.nest(pattern.schema, `pattern.${i$4}`), prefs)) continue;
          unprocessed.delete(key);
          let localState = state.localize(path, ancestors, { schema: pattern.rule, key }), result = pattern.rule.$_validate(item, localState, prefs);
          if (result.errors) {
            if (prefs.abortEarly) return { value, errors: result.errors };
            errors.push(...result.errors);
          }
          if (pattern.matches && matches[i$4].push(key), value[key] = result.value, !pattern.fallthrough) break;
        }
      }
      if (hasMatches) for (let i$4 = 0; i$4 < matches.length; ++i$4) {
        let match$2 = matches[i$4];
        if (!match$2) continue;
        let stpm = schema$2.$_terms.patterns[i$4].matches, localState = state.localize(state.path, ancestors, stpm), result = stpm.$_validate(match$2, localState, prefs);
        if (result.errors) {
          let details = Errors$3.details(result.errors, { override: false });
          details.matches = match$2;
          let report = schema$2.$_createError(`object.pattern.match`, value, details, state, prefs);
          if (prefs.abortEarly) return { value, errors: report };
          errors.push(report);
        }
      }
    }
    if (!unprocessed.size || !schema$2.$_terms.keys && !schema$2.$_terms.patterns) return;
    if (prefs.stripUnknown && schema$2._flags.unknown === void 0 || prefs.skipFunctions) {
      let stripUnknown = prefs.stripUnknown ? prefs.stripUnknown === true ? true : !!prefs.stripUnknown.objects : false;
      for (let key of unprocessed) stripUnknown ? (delete value[key], unprocessed.delete(key)) : typeof value[key] == `function` && unprocessed.delete(key);
    }
    let forbidUnknown = !Common$8.default(schema$2._flags.unknown, prefs.allowUnknown);
    if (forbidUnknown) for (let unprocessedKey of unprocessed) {
      let localState = state.localize([...state.path, unprocessedKey], []), report = schema$2.$_createError(`object.unknown`, value[unprocessedKey], { child: unprocessedKey }, localState, prefs, { flags: false });
      if (prefs.abortEarly) return { value, errors: report };
      errors.push(report);
    }
  }, internals$8.Dependency = class {
    constructor(rel, key, peers, paths, options) {
      this.rel = rel, this.key = key, this.peers = peers, this.paths = paths, this.options = options;
    }
    describe() {
      let desc$1 = { rel: this.rel, peers: this.paths };
      return this.key !== null && (desc$1.key = this.key.key), this.peers[0].separator !== `.` && (desc$1.options = { ...desc$1.options, separator: this.peers[0].separator }), this.options.isPresent && (desc$1.options = { ...desc$1.options, isPresent: this.options.isPresent }), desc$1;
    }
  }, internals$8.Keys = class extends Array {
    concat(source) {
      let result = this.slice(), keys$10 = /* @__PURE__ */ new Map();
      for (let i$4 = 0; i$4 < result.length; ++i$4) keys$10.set(result[i$4].key, i$4);
      for (let item of source) {
        let key = item.key, pos = keys$10.get(key);
        pos === void 0 ? result.push(item) : result[pos] = { key, schema: result[pos].schema.concat(item.schema) };
      }
      return result;
    }
  };
}), require_function = __commonJSMin$1((exports$12, module2) => {
  let { assert: assert$33 } = require_lib$4(), Keys$1 = require_keys$1();
  module2.exports = Keys$1.extend({ type: `function`, properties: { typeof: `function` }, rules: { arity: { method(n$4) {
    return assert$33(Number.isSafeInteger(n$4) && n$4 >= 0, `n must be a positive integer`), this.$_addRule({ name: `arity`, args: { n: n$4 } });
  }, validate(value, helpers$8, { n: n$4 }) {
    return value.length === n$4 ? value : helpers$8.error(`function.arity`, { n: n$4 });
  } }, class: { method() {
    return this.$_addRule(`class`);
  }, validate(value, helpers$8) {
    return /^\s*class\s/.test(value.toString()) ? value : helpers$8.error(`function.class`, { value });
  } }, minArity: { method(n$4) {
    return assert$33(Number.isSafeInteger(n$4) && n$4 > 0, `n must be a strict positive integer`), this.$_addRule({ name: `minArity`, args: { n: n$4 } });
  }, validate(value, helpers$8, { n: n$4 }) {
    return value.length >= n$4 ? value : helpers$8.error(`function.minArity`, { n: n$4 });
  } }, maxArity: { method(n$4) {
    return assert$33(Number.isSafeInteger(n$4) && n$4 >= 0, `n must be a positive integer`), this.$_addRule({ name: `maxArity`, args: { n: n$4 } });
  }, validate(value, helpers$8, { n: n$4 }) {
    return value.length <= n$4 ? value : helpers$8.error(`function.maxArity`, { n: n$4 });
  } } }, messages: { "function.arity": `{{#label}} must have an arity of {{#n}}`, "function.class": `{{#label}} must be a class`, "function.maxArity": `{{#label}} must have an arity lesser or equal to {{#n}}`, "function.minArity": `{{#label}} must have an arity greater or equal to {{#n}}` } });
}), require_link = __commonJSMin$1((exports$12, module2) => {
  let { assert: assert$32 } = require_lib$4(), Any$4 = require_any(), Common$7 = require_common$3(), Compile$2 = require_compile(), Errors$2 = require_errors$2(), internals$7 = {};
  module2.exports = Any$4.extend({ type: `link`, properties: { schemaChain: true }, terms: { link: { init: null, manifest: `single`, register: false } }, args(schema$2, ref) {
    return schema$2.ref(ref);
  }, validate(value, { schema: schema$2, state, prefs }) {
    assert$32(schema$2.$_terms.link, `Uninitialized link schema`);
    let linked = internals$7.generate(schema$2, value, state, prefs), ref = schema$2.$_terms.link[0].ref;
    return linked.$_validate(value, state.nest(linked, `link:${ref.display}:${linked.type}`), prefs);
  }, generate(schema$2, value, state, prefs) {
    return internals$7.generate(schema$2, value, state, prefs);
  }, rules: { ref: { method(ref) {
    assert$32(!this.$_terms.link, `Cannot reinitialize schema`), ref = Compile$2.ref(ref), assert$32(ref.type === `value` || ref.type === `local`, `Invalid reference type:`, ref.type), assert$32(ref.type === `local` || ref.ancestor === `root` || ref.ancestor > 0, `Link cannot reference itself`);
    let obj = this.clone();
    return obj.$_terms.link = [{ ref }], obj;
  } }, relative: { method(enabled = true) {
    return this.$_setFlag(`relative`, enabled);
  } } }, overrides: { concat(source) {
    assert$32(this.$_terms.link, `Uninitialized link schema`), assert$32(Common$7.isSchema(source), `Invalid schema object`), assert$32(source.type !== `link`, `Cannot merge type link with another link`);
    let obj = this.clone();
    return obj.$_terms.whens || (obj.$_terms.whens = []), obj.$_terms.whens.push({ concat: source }), obj.$_mutateRebuild();
  } }, manifest: { build(obj, desc$1) {
    return assert$32(desc$1.link, `Invalid link description missing link`), obj.ref(desc$1.link);
  } } }), internals$7.generate = function(schema$2, value, state, prefs) {
    let linked = state.mainstay.links.get(schema$2);
    if (linked) return linked._generate(value, state, prefs).schema;
    let ref = schema$2.$_terms.link[0].ref, { perspective, path } = internals$7.perspective(ref, state);
    internals$7.assert(perspective, `which is outside of schema boundaries`, ref, schema$2, state, prefs);
    try {
      linked = path.length ? perspective.$_reach(path) : perspective;
    } catch {
      internals$7.assert(false, `to non-existing schema`, ref, schema$2, state, prefs);
    }
    return internals$7.assert(linked.type !== `link`, `which is another link`, ref, schema$2, state, prefs), schema$2._flags.relative || state.mainstay.links.set(schema$2, linked), linked._generate(value, state, prefs).schema;
  }, internals$7.perspective = function(ref, state) {
    if (ref.type === `local`) {
      for (let { schema: schema$2, key } of state.schemas) {
        let id = schema$2._flags.id || key;
        if (id === ref.path[0]) return { perspective: schema$2, path: ref.path.slice(1) };
        if (schema$2.$_terms.shared) {
          for (let shared of schema$2.$_terms.shared) if (shared._flags.id === ref.path[0]) return { perspective: shared, path: ref.path.slice(1) };
        }
      }
      return { perspective: null, path: null };
    }
    return ref.ancestor === `root` ? { perspective: state.schemas[state.schemas.length - 1].schema, path: ref.path } : { perspective: state.schemas[ref.ancestor] && state.schemas[ref.ancestor].schema, path: ref.path };
  }, internals$7.assert = function(condition, message, ref, schema$2, state, prefs) {
    condition || assert$32(false, `"${Errors$2.label(schema$2._flags, state, prefs)}" contains link reference "${ref.display}" ${message}`);
  };
}), require_number = __commonJSMin$1((exports$12, module2) => {
  let { assert: assert$31 } = require_lib$4(), Any$3 = require_any(), Common$6 = require_common$3(), internals$6 = { numberRx: /^\s*[+-]?(?:(?:\d+(?:\.\d*)?)|(?:\.\d+))(?:e([+-]?\d+))?\s*$/i, precisionRx: /(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/, exponentialPartRegex: /[eE][+-]?\d+$/, leadingSignAndZerosRegex: /^[+-]?(0*)?/, dotRegex: /\./, trailingZerosRegex: /0+$/, decimalPlaces(value) {
    let str = value.toString(), dindex = str.indexOf(`.`), eindex = str.indexOf(`e`);
    return (dindex < 0 ? 0 : (eindex < 0 ? str.length : eindex) - dindex - 1) + (eindex < 0 ? 0 : Math.max(0, -parseInt(str.slice(eindex + 1))));
  } };
  module2.exports = Any$3.extend({ type: `number`, flags: { unsafe: { default: false } }, coerce: { from: `string`, method(value, { schema: schema$2, error }) {
    let matches = value.match(internals$6.numberRx);
    if (!matches) return;
    value = value.trim();
    let result = { value: parseFloat(value) };
    if (result.value === 0 && (result.value = 0), !schema$2._flags.unsafe) if (value.match(/e/i)) {
      if (internals$6.extractSignificantDigits(value) !== internals$6.extractSignificantDigits(String(result.value))) return result.errors = error(`number.unsafe`), result;
    } else {
      let string = result.value.toString();
      if (string.match(/e/i)) return result;
      if (string !== internals$6.normalizeDecimal(value)) return result.errors = error(`number.unsafe`), result;
    }
    return result;
  } }, validate(value, { schema: schema$2, error, prefs }) {
    if (value === 1 / 0 || value === -1 / 0) return { value, errors: error(`number.infinity`) };
    if (!Common$6.isNumber(value)) return { value, errors: error(`number.base`) };
    let result = { value };
    if (prefs.convert) {
      let rule = schema$2.$_getRule(`precision`);
      if (rule) {
        let precision = 10 ** rule.args.limit;
        result.value = Math.round(result.value * precision) / precision;
      }
    }
    return result.value === 0 && (result.value = 0), !schema$2._flags.unsafe && (value > 2 ** 53 - 1 || value < -9007199254740991) && (result.errors = error(`number.unsafe`)), result;
  }, rules: { compare: { method: false, validate(value, helpers$8, { limit }, { name: name$2, operator: operator$1, args: args$1 }) {
    return Common$6.compare(value, limit, operator$1) ? value : helpers$8.error(`number.` + name$2, { limit: args$1.limit, value });
  }, args: [{ name: `limit`, ref: true, assert: Common$6.isNumber, message: `must be a number` }] }, greater: { method(limit) {
    return this.$_addRule({ name: `greater`, method: `compare`, args: { limit }, operator: `>` });
  } }, integer: { method() {
    return this.$_addRule(`integer`);
  }, validate(value, helpers$8) {
    return Math.trunc(value) - value === 0 ? value : helpers$8.error(`number.integer`);
  } }, less: { method(limit) {
    return this.$_addRule({ name: `less`, method: `compare`, args: { limit }, operator: `<` });
  } }, max: { method(limit) {
    return this.$_addRule({ name: `max`, method: `compare`, args: { limit }, operator: `<=` });
  } }, min: { method(limit) {
    return this.$_addRule({ name: `min`, method: `compare`, args: { limit }, operator: `>=` });
  } }, multiple: { method(base$3) {
    let baseDecimalPlace = typeof base$3 == `number` ? internals$6.decimalPlaces(base$3) : null, pfactor = 10 ** baseDecimalPlace;
    return this.$_addRule({ name: `multiple`, args: { base: base$3, baseDecimalPlace, pfactor } });
  }, validate(value, helpers$8, { base: base$3, baseDecimalPlace, pfactor }, options) {
    let valueDecimalPlace = internals$6.decimalPlaces(value);
    return valueDecimalPlace > baseDecimalPlace ? helpers$8.error(`number.multiple`, { multiple: options.args.base, value }) : Math.round(pfactor * value) % Math.round(pfactor * base$3) === 0 ? value : helpers$8.error(`number.multiple`, { multiple: options.args.base, value });
  }, args: [{ name: `base`, ref: true, assert: (value) => typeof value == `number` && isFinite(value) && value > 0, message: `must be a positive number` }, `baseDecimalPlace`, `pfactor`], multi: true }, negative: { method() {
    return this.sign(`negative`);
  } }, port: { method() {
    return this.$_addRule(`port`);
  }, validate(value, helpers$8) {
    return Number.isSafeInteger(value) && value >= 0 && value <= 65535 ? value : helpers$8.error(`number.port`);
  } }, positive: { method() {
    return this.sign(`positive`);
  } }, precision: { method(limit) {
    return assert$31(Number.isSafeInteger(limit), `limit must be an integer`), this.$_addRule({ name: `precision`, args: { limit } });
  }, validate(value, helpers$8, { limit }) {
    let places = value.toString().match(internals$6.precisionRx), decimals = Math.max((places[1] ? places[1].length : 0) - (places[2] ? parseInt(places[2], 10) : 0), 0);
    return decimals <= limit ? value : helpers$8.error(`number.precision`, { limit, value });
  }, convert: true }, sign: { method(sign$2) {
    return assert$31([`negative`, `positive`].includes(sign$2), `Invalid sign`, sign$2), this.$_addRule({ name: `sign`, args: { sign: sign$2 } });
  }, validate(value, helpers$8, { sign: sign$2 }) {
    return sign$2 === `negative` && value < 0 || sign$2 === `positive` && value > 0 ? value : helpers$8.error(`number.${sign$2}`);
  } }, unsafe: { method(enabled = true) {
    return assert$31(typeof enabled == `boolean`, `enabled must be a boolean`), this.$_setFlag(`unsafe`, enabled);
  } } }, cast: { string: { from: (value) => typeof value == `number`, to(value, helpers$8) {
    return value.toString();
  } } }, messages: { "number.base": `{{#label}} must be a number`, "number.greater": `{{#label}} must be greater than {{#limit}}`, "number.infinity": `{{#label}} cannot be infinity`, "number.integer": `{{#label}} must be an integer`, "number.less": `{{#label}} must be less than {{#limit}}`, "number.max": `{{#label}} must be less than or equal to {{#limit}}`, "number.min": `{{#label}} must be greater than or equal to {{#limit}}`, "number.multiple": `{{#label}} must be a multiple of {{#multiple}}`, "number.negative": `{{#label}} must be a negative number`, "number.port": `{{#label}} must be a valid port`, "number.positive": `{{#label}} must be a positive number`, "number.precision": `{{#label}} must have no more than {{#limit}} decimal places`, "number.unsafe": `{{#label}} must be a safe number` } }), internals$6.extractSignificantDigits = function(value) {
    return value.replace(internals$6.exponentialPartRegex, ``).replace(internals$6.dotRegex, ``).replace(internals$6.trailingZerosRegex, ``).replace(internals$6.leadingSignAndZerosRegex, ``);
  }, internals$6.normalizeDecimal = function(str) {
    return str = str.replace(/^\+/, ``).replace(/\.0*$/, ``).replace(/^(-?)\.([^\.]*)$/, `$10.$2`).replace(/^(-?)0+([0-9])/, `$1$2`), str.includes(`.`) && str.endsWith(`0`) && (str = str.replace(/0+$/, ``)), str === `-0` ? `0` : str;
  };
}), require_object = __commonJSMin$1((exports$12, module2) => {
  let Keys = require_keys$1();
  module2.exports = Keys.extend({ type: `object`, cast: { map: { from: (value) => value && typeof value == `object`, to(value, helpers$8) {
    return new Map(Object.entries(value));
  } } } });
});
function toErr(msg, code$2, err$1) {
  throw err$1 = TypeError(msg), err$1.code = code$2, err$1;
}
function invalid(str) {
  toErr(`Invalid URL: ` + str, `ERR_INVALID_URL`);
}
function args(both, len$2, x$1, y$1) {
  x$1 = `The "name" `, y$1 = `argument`, both && (x$1 += `and "value" `, y$1 += `s`), len$2 < ++both && toErr(x$1 + y$1 + ` must be specified`, `ERR_MISSING_ARGS`);
}
function toIter(arr, supported) {
  var val, j$1 = 0, iter = { next: function() {
    return val = arr[j$1++], { value: val, done: j$1 > arr.length };
  } };
  return supported && (iter[Symbol.iterator] = function() {
    return iter;
  }), iter;
}
function URLSearchParams(init$1, ref) {
  var k, i$4, x$1, supp, tmp, $ = this, list = [];
  try {
    supp = !!Symbol.iterator;
  } catch {
    supp = false;
  }
  if (init$1) {
    if (init$1.keys && init$1.getAll) init$1.forEach(function(v$1, k$1) {
      toAppend(k$1, v$1);
    });
    else if (init$1.pop) for (i$4 = 0; i$4 < init$1.length; i$4++) toAppend.apply(0, init$1[i$4]);
    else if (typeof init$1 == `object`) for (k in init$1) toSet(k, init$1[k]);
    else if (typeof init$1 == `string`) for (init$1[0] == `?` && (init$1 = init$1.substring(1)), x$1 = decodeURIComponent(init$1).split(`&`); k = x$1.shift(); ) i$4 = k.indexOf(`=`), ~i$4 || (i$4 = k.length), toAppend(k.substring(0, i$4), k.substring(++i$4));
  }
  function toSet(key, val) {
    for (args(1, arguments.length), val = String(val), x$1 = false, i$4 = list.length; i$4--; ) tmp = list[i$4], tmp[0] == key && (x$1 ? list.splice(i$4, 1) : (tmp[1] = val, x$1 = true));
    x$1 || list.push([key, val]), cascade();
  }
  function toAppend(key, val) {
    args(1, arguments.length), list.push([key, String(val)]), cascade();
  }
  function toStr$7() {
    for (tmp = ``, i$4 = 0; i$4 < list.length; i$4++) tmp && (tmp += `&`), tmp += encodeURIComponent(list[i$4][0]) + `=` + encodeURIComponent(list[i$4][1]);
    return tmp.replace(/%20/g, `+`);
  }
  function cascade() {
    ref && (ref.search = list.length ? `?` + toStr$7().replace(/=$/, ``) : ``);
  }
  return $.append = toAppend, $.delete = function(key) {
    for (args(0, arguments.length), i$4 = list.length; i$4--; ) list[i$4][0] == key && list.splice(i$4, 1);
    cascade();
  }, $.entries = function() {
    return toIter(list, supp);
  }, $.forEach = function(fn$1) {
    for (typeof fn$1 != `function` && toErr(`Callback must be a function`, `ERR_INVALID_CALLBACK`), i$4 = 0; i$4 < list.length; i$4++) fn$1(list[i$4][1], list[i$4][0]);
  }, $.get = function(key) {
    for (args(0, arguments.length), i$4 = 0; i$4 < list.length; i$4++) if (list[i$4][0] == key) return list[i$4][1];
    return null;
  }, $.getAll = function(key) {
    for (args(0, arguments.length), tmp = [], i$4 = 0; i$4 < list.length; i$4++) list[i$4][0] == key && tmp.push(list[i$4][1]);
    return tmp;
  }, $.has = function(key) {
    for (args(0, arguments.length), i$4 = 0; i$4 < list.length; i$4++) if (list[i$4][0] == key) return true;
    return false;
  }, $.keys = function() {
    for (tmp = [], i$4 = 0; i$4 < list.length; i$4++) tmp.push(list[i$4][0]);
    return toIter(tmp, supp);
  }, $.set = toSet, $.sort = function() {
    for (x$1 = [], tmp = [], i$4 = 0; i$4 < list.length; x$1.push(list[i$4++][0])) ;
    for (x$1.sort(); k = x$1.shift(); ) for (i$4 = 0; i$4 < list.length; i$4++) if (list[i$4][0] == k) {
      tmp.push(list.splice(i$4, 1).shift());
      break;
    }
    list = tmp, cascade();
  }, $.toString = toStr$7, $.values = function() {
    for (tmp = [], i$4 = 0; i$4 < list.length; i$4++) tmp.push(list[i$4][1]);
    return toIter(tmp, supp);
  }, supp && ($[Symbol.iterator] = $.entries), $;
}
function URL$1(url, base$3) {
  var tmp = document.createElement(`a`), link = document.createElement(`a`), input = document.createElement(`input`), segs, usp, $ = this, rgx = /(blob|ftp|wss?|https?):/;
  if (input.type = `url`, base$3 = String(base$3 || ``).trim(), (input.value = base$3) && !input.checkValidity()) return invalid(base$3);
  if (url = String(url).trim(), input.value = url || 0, input.checkValidity()) link.href = url;
  else if (base$3) link.href = base$3, url && (usp = url.match(/^\/+/), usp && usp[0].length == 2 ? link.href = link.protocol + url : /[?#]/.test(url[0]) ? link.href += url : url[0] == `/` || link.pathname == `/` ? link.href = link.origin + `/` + url.replace(/^\/+/, ``) : (segs = link.pathname.split(`/`), base$3 = url.replace(/^(\.\/)?/, ``).split(`../`), link.href = link.origin + segs.slice(0, Math.max(1, segs.length - base$3.length)).concat(base$3.pop()).join(`/`)));
  else return invalid(url);
  function proxy(key) {
    return tmp.href = link.href, tmp.protocol = `http:`, key == `protocol` || key == `href` || rgx.test(link.protocol) ? link[key] : key == `origin` ? rgx.test(link.protocol) ? link[key] : `null` : tmp[key];
  }
  function block$1(key, readonly, getter, out) {
    return out = { enumerable: true }, readonly || (out.set = function(val) {
      val != null && (link[key] = String(val), (key == `href` || key == `search`) && (usp = new URLSearchParams(link.search, link)));
    }), out.get = getter || function() {
      return proxy(key);
    }, out;
  }
  return usp = new URLSearchParams(link.search, link), $.toString = $.toJSON = link.toString.bind(link), Object.defineProperties($, { href: block$1(`href`), protocol: block$1(`protocol`), username: block$1(`username`), password: block$1(`password`), hostname: block$1(`hostname`), host: block$1(`host`), port: block$1(`port`), search: block$1(`search`), hash: block$1(`hash`), pathname: block$1(`pathname`), origin: block$1(`origin`, 1), searchParams: block$1(`searchParams`, 1, function() {
    return usp;
  }) });
}
const errorCodes = { EMPTY_STRING: `Address must be a non-empty string`, FORBIDDEN_UNICODE: `Address contains forbidden Unicode characters`, MULTIPLE_AT_CHAR: `Address cannot contain more than one @ character`, MISSING_AT_CHAR: `Address must contain one @ character`, EMPTY_LOCAL: `Address local part cannot be empty`, ADDRESS_TOO_LONG: `Address too long`, LOCAL_TOO_LONG: `Address local part too long`, EMPTY_LOCAL_SEGMENT: `Address local part contains empty dot-separated segment`, INVALID_LOCAL_CHARS: `Address local part contains invalid character`, DOMAIN_NON_EMPTY_STRING: `Domain must be a non-empty string`, DOMAIN_TOO_LONG: `Domain too long`, DOMAIN_INVALID_UNICODE_CHARS: `Domain contains forbidden Unicode characters`, DOMAIN_INVALID_CHARS: `Domain contains invalid character`, DOMAIN_INVALID_TLDS_CHARS: `Domain contains invalid tld character`, DOMAIN_SEGMENTS_COUNT: `Domain lacks the minimum required number of segments`, DOMAIN_SEGMENTS_COUNT_MAX: `Domain contains too many segments`, DOMAIN_FORBIDDEN_TLDS: `Domain uses forbidden TLD`, DOMAIN_EMPTY_SEGMENT: `Domain contains empty dot-separated segment`, DOMAIN_LONG_SEGMENT: `Domain contains dot-separated segment that is too long` };
function errorCode(code$2) {
  return { code: code$2, error: errorCodes[code$2] };
}
function isTldsAllow(tlds$1) {
  return !!tlds$1.allow;
}
function analyzeDomain(domain, options = {}) {
  if (!domain) return errorCode(`DOMAIN_NON_EMPTY_STRING`);
  if (typeof domain != `string`) throw Error(`Invalid input: domain must be a string`);
  if (domain.length > 256) return errorCode(`DOMAIN_TOO_LONG`);
  let ascii$2 = !NON_ASCII_RX$1.test(domain);
  if (!ascii$2) {
    if (options.allowUnicode === false) return errorCode(`DOMAIN_INVALID_UNICODE_CHARS`);
    domain = domain.normalize(`NFC`);
  }
  if (DOMAIN_CONTROL_RX.test(domain)) return errorCode(`DOMAIN_INVALID_CHARS`);
  domain = punycode(domain), options.allowFullyQualified && domain[domain.length - 1] === `.` && (domain = domain.slice(0, -1));
  let minDomainSegments = options.minDomainSegments || MIN_DOMAIN_SEGMENTS, segments = domain.split(`.`);
  if (segments.length < minDomainSegments) return errorCode(`DOMAIN_SEGMENTS_COUNT`);
  if (options.maxDomainSegments && segments.length > options.maxDomainSegments) return errorCode(`DOMAIN_SEGMENTS_COUNT_MAX`);
  let tlds$1 = options.tlds;
  if (tlds$1) {
    let tld = segments[segments.length - 1].toLowerCase();
    if (isTldsAllow(tlds$1)) {
      if (!tlds$1.allow.has(tld)) return errorCode(`DOMAIN_FORBIDDEN_TLDS`);
    } else if (tlds$1.deny.has(tld)) return errorCode(`DOMAIN_FORBIDDEN_TLDS`);
  }
  for (let i$4 = 0; i$4 < segments.length; ++i$4) {
    let segment = segments[i$4];
    if (!segment.length) return errorCode(`DOMAIN_EMPTY_SEGMENT`);
    if (segment.length > 63) return errorCode(`DOMAIN_LONG_SEGMENT`);
    if (i$4 < segments.length - 1) {
      if (options.allowUnderscore) {
        if (!DOMAIN_UNDERSCORE_SEGMENT_RX.test(segment)) return errorCode(`DOMAIN_INVALID_CHARS`);
      } else if (!DOMAIN_SEGMENT_RX.test(segment)) return errorCode(`DOMAIN_INVALID_CHARS`);
    } else if (!TLD_SEGMENT_RX.test(segment)) return errorCode(`DOMAIN_INVALID_TLDS_CHARS`);
  }
  return null;
}
function isDomainValid$1(domain, options) {
  return !analyzeDomain(domain, options);
}
function punycode(domain) {
  domain.includes(`%`) && (domain = domain.replace(/%/g, `%25`));
  try {
    return new URL_IMPL(`http://${domain}`).host;
  } catch {
    return domain;
  }
}
function validateDomainOptions(options) {
  if (options) {
    if (typeof options.tlds != `object`) throw Error(`Invalid options: tlds must be a boolean or an object`);
    if (isTldsAllow(options.tlds)) {
      if (!(options.tlds.allow instanceof Set)) throw Error(`Invalid options: tlds.allow must be a Set object or true`);
      if (options.tlds.deny) throw Error(`Invalid options: cannot specify both tlds.allow and tlds.deny lists`);
    } else if (!(options.tlds.deny instanceof Set)) throw Error(`Invalid options: tlds.deny must be a Set object`);
  }
}
var MIN_DOMAIN_SEGMENTS, NON_ASCII_RX$1, DOMAIN_CONTROL_RX, TLD_SEGMENT_RX, DOMAIN_SEGMENT_RX, DOMAIN_UNDERSCORE_SEGMENT_RX, URL_IMPL, init_domain = __esmMin(() => {
  MIN_DOMAIN_SEGMENTS = 2, NON_ASCII_RX$1 = /[^\x00-\x7f]/, DOMAIN_CONTROL_RX = /[\x00-\x20@\:\/\\#!\$&\'\(\)\*\+,;=\?]/, TLD_SEGMENT_RX = /^[a-zA-Z](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$/, DOMAIN_SEGMENT_RX = /^[a-zA-Z0-9](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$/, DOMAIN_UNDERSCORE_SEGMENT_RX = /^[a-zA-Z0-9_](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$/, URL_IMPL = URL$1 || URL;
}), require_shams$1 = __commonJSMin$1((exports$12, module2) => {
  module2.exports = function() {
    if (typeof Symbol != `function` || typeof Object.getOwnPropertySymbols != `function`) return false;
    if (typeof Symbol.iterator == `symbol`) return true;
    var obj = {}, sym = Symbol(`test`), symObj = Object(sym);
    if (typeof sym == `string` || Object.prototype.toString.call(sym) !== `[object Symbol]` || Object.prototype.toString.call(symObj) !== `[object Symbol]`) return false;
    var symVal = 42;
    for (var _ in obj[sym] = symVal, obj) return false;
    if (typeof Object.keys == `function` && Object.keys(obj).length !== 0 || typeof Object.getOwnPropertyNames == `function` && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym || !Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor == `function`) {
      var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
      if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
  };
}), require_shams = __commonJSMin$1((exports$12, module2) => {
  var hasSymbols$3 = require_shams$1();
  module2.exports = function() {
    return hasSymbols$3() && !!Symbol.toStringTag;
  };
}), require_es_object_atoms = __commonJSMin$1((exports$12, module2) => {
  module2.exports = Object;
}), require_es_errors = __commonJSMin$1((exports$12, module2) => {
  module2.exports = Error;
}), require_eval = __commonJSMin$1((exports$12, module2) => {
  module2.exports = EvalError;
}), require_range$1 = __commonJSMin$1((exports$12, module2) => {
  module2.exports = RangeError;
}), require_ref$1 = __commonJSMin$1((exports$12, module2) => {
  module2.exports = ReferenceError;
}), require_syntax = __commonJSMin$1((exports$12, module2) => {
  module2.exports = SyntaxError;
}), require_type = __commonJSMin$1((exports$12, module2) => {
  module2.exports = TypeError;
}), require_uri = __commonJSMin$1((exports$12, module2) => {
  module2.exports = URIError;
}), require_abs = __commonJSMin$1((exports$12, module2) => {
  module2.exports = Math.abs;
}), require_floor = __commonJSMin$1((exports$12, module2) => {
  module2.exports = Math.floor;
}), require_max = __commonJSMin$1((exports$12, module2) => {
  module2.exports = Math.max;
}), require_min = __commonJSMin$1((exports$12, module2) => {
  module2.exports = Math.min;
}), require_pow = __commonJSMin$1((exports$12, module2) => {
  module2.exports = Math.pow;
}), require_round = __commonJSMin$1((exports$12, module2) => {
  module2.exports = Math.round;
}), require_isNaN = __commonJSMin$1((exports$12, module2) => {
  module2.exports = Number.isNaN || function(a$22) {
    return a$22 !== a$22;
  };
}), require_sign = __commonJSMin$1((exports$12, module2) => {
  var $isNaN = require_isNaN();
  module2.exports = function(number) {
    return $isNaN(number) || number === 0 ? number : number < 0 ? -1 : 1;
  };
}), require_gOPD = __commonJSMin$1((exports$12, module2) => {
  module2.exports = Object.getOwnPropertyDescriptor;
}), require_gopd = __commonJSMin$1((exports$12, module2) => {
  var $gOPD$1 = require_gOPD();
  if ($gOPD$1) try {
    $gOPD$1([], `length`);
  } catch {
    $gOPD$1 = null;
  }
  module2.exports = $gOPD$1;
}), require_es_define_property = __commonJSMin$1((exports$12, module2) => {
  var $defineProperty$4 = Object.defineProperty || false;
  if ($defineProperty$4) try {
    $defineProperty$4({}, `a`, { value: 1 });
  } catch {
    $defineProperty$4 = false;
  }
  module2.exports = $defineProperty$4;
}), require_has_symbols = __commonJSMin$1((exports$12, module2) => {
  var origSymbol = typeof Symbol < `u` && Symbol, hasSymbolSham = require_shams$1();
  module2.exports = function() {
    return typeof origSymbol != `function` || typeof Symbol != `function` || typeof origSymbol(`foo`) != `symbol` || typeof Symbol(`bar`) != `symbol` ? false : hasSymbolSham();
  };
}), require_Reflect_getPrototypeOf = __commonJSMin$1((exports$12, module2) => {
  module2.exports = typeof Reflect < `u` && Reflect.getPrototypeOf || null;
}), require_Object_getPrototypeOf = __commonJSMin$1((exports$12, module2) => {
  var $Object$3 = require_es_object_atoms();
  module2.exports = $Object$3.getPrototypeOf || null;
}), require_implementation$4 = __commonJSMin$1((exports$12, module2) => {
  var ERROR_MESSAGE = `Function.prototype.bind called on incompatible `, toStr$6 = Object.prototype.toString, max$2 = Math.max, funcType = `[object Function]`, concatty = function(a$22, b2) {
    for (var arr = [], i$4 = 0; i$4 < a$22.length; i$4 += 1) arr[i$4] = a$22[i$4];
    for (var j$1 = 0; j$1 < b2.length; j$1 += 1) arr[j$1 + a$22.length] = b2[j$1];
    return arr;
  }, slicy = function(arrLike, offset$2) {
    for (var arr = [], i$4 = offset$2 || 0, j$1 = 0; i$4 < arrLike.length; i$4 += 1, j$1 += 1) arr[j$1] = arrLike[i$4];
    return arr;
  }, joiny = function(arr, joiner) {
    for (var str = ``, i$4 = 0; i$4 < arr.length; i$4 += 1) str += arr[i$4], i$4 + 1 < arr.length && (str += joiner);
    return str;
  };
  module2.exports = function(that) {
    var target = this;
    if (typeof target != `function` || toStr$6.apply(target) !== funcType) throw TypeError(ERROR_MESSAGE + target);
    for (var args$1 = slicy(arguments, 1), bound, binder = function() {
      if (this instanceof bound) {
        var result = target.apply(this, concatty(args$1, arguments));
        return Object(result) === result ? result : this;
      }
      return target.apply(that, concatty(args$1, arguments));
    }, boundLength = max$2(0, target.length - args$1.length), boundArgs = [], i$4 = 0; i$4 < boundLength; i$4++) boundArgs[i$4] = `$` + i$4;
    if (bound = Function(`binder`, `return function (` + joiny(boundArgs, `,`) + `){ return binder.apply(this,arguments); }`)(binder), target.prototype) {
      var Empty = function() {
      };
      Empty.prototype = target.prototype, bound.prototype = new Empty(), Empty.prototype = null;
    }
    return bound;
  };
}), require_function_bind = __commonJSMin$1((exports$12, module2) => {
  var implementation$5 = require_implementation$4();
  module2.exports = Function.prototype.bind || implementation$5;
}), require_functionCall = __commonJSMin$1((exports$12, module2) => {
  module2.exports = Function.prototype.call;
}), require_functionApply = __commonJSMin$1((exports$12, module2) => {
  module2.exports = Function.prototype.apply;
}), require_reflectApply = __commonJSMin$1((exports$12, module2) => {
  module2.exports = typeof Reflect < `u` && Reflect && Reflect.apply;
}), require_actualApply = __commonJSMin$1((exports$12, module2) => {
  var bind$4 = require_function_bind(), $apply$2 = require_functionApply(), $call$2 = require_functionCall(), $reflectApply = require_reflectApply();
  module2.exports = $reflectApply || bind$4.call($call$2, $apply$2);
}), require_call_bind_apply_helpers = __commonJSMin$1((exports$12, module2) => {
  var bind$3 = require_function_bind(), $TypeError$5 = require_type(), $call$1 = require_functionCall(), $actualApply = require_actualApply();
  module2.exports = function(args$1) {
    if (args$1.length < 1 || typeof args$1[0] != `function`) throw new $TypeError$5(`a function is required`);
    return $actualApply(bind$3, $call$1, args$1);
  };
}), require_get$1 = __commonJSMin$1((exports$12, module2) => {
  var callBind$4 = require_call_bind_apply_helpers(), gOPD$3 = require_gopd(), hasProtoAccessor;
  try {
    hasProtoAccessor = [].__proto__ === Array.prototype;
  } catch (e$22) {
    if (!e$22 || typeof e$22 != `object` || !(`code` in e$22) || e$22.code !== `ERR_PROTO_ACCESS`) throw e$22;
  }
  var desc = !!hasProtoAccessor && gOPD$3 && gOPD$3(Object.prototype, `__proto__`), $Object$2 = Object, $getPrototypeOf = $Object$2.getPrototypeOf;
  module2.exports = desc && typeof desc.get == `function` ? callBind$4([desc.get]) : typeof $getPrototypeOf == `function` ? function(value) {
    return $getPrototypeOf(value == null ? value : $Object$2(value));
  } : false;
}), require_get_proto = __commonJSMin$1((exports$12, module2) => {
  var reflectGetProto = require_Reflect_getPrototypeOf(), originalGetProto = require_Object_getPrototypeOf(), getDunderProto = require_get$1();
  module2.exports = reflectGetProto ? function(O) {
    return reflectGetProto(O);
  } : originalGetProto ? function(O) {
    if (!O || typeof O != `object` && typeof O != `function`) throw TypeError(`getProto: not an object`);
    return originalGetProto(O);
  } : getDunderProto ? function(O) {
    return getDunderProto(O);
  } : null;
}), require_hasown = __commonJSMin$1((exports$12, module2) => {
  var call$1 = Function.prototype.call, $hasOwn = Object.prototype.hasOwnProperty, bind$2 = require_function_bind();
  module2.exports = bind$2.call(call$1, $hasOwn);
}), require_get_intrinsic = __commonJSMin$1((exports$12, module2) => {
  var undefined$1, $Object$1 = require_es_object_atoms(), $Error = require_es_errors(), $EvalError = require_eval(), $RangeError = require_range$1(), $ReferenceError = require_ref$1(), $SyntaxError$1 = require_syntax(), $TypeError$4 = require_type(), $URIError = require_uri(), abs = require_abs(), floor = require_floor(), max$1 = require_max(), min = require_min(), pow = require_pow(), round$1 = require_round(), sign$1 = require_sign(), $Function = Function, getEvalledConstructor = function(expressionSyntax) {
    try {
      return $Function(`"use strict"; return (` + expressionSyntax + `).constructor;`)();
    } catch {
    }
  }, $gOPD = require_gopd(), $defineProperty$3 = require_es_define_property(), throwTypeError = function() {
    throw new $TypeError$4();
  }, ThrowTypeError = $gOPD ? (function() {
    try {
      return arguments.callee, throwTypeError;
    } catch {
      try {
        return $gOPD(arguments, `callee`).get;
      } catch {
        return throwTypeError;
      }
    }
  })() : throwTypeError, hasSymbols$2 = require_has_symbols()(), getProto$2 = require_get_proto(), $ObjectGPO = require_Object_getPrototypeOf(), $ReflectGPO = require_Reflect_getPrototypeOf(), $apply$1 = require_functionApply(), $call = require_functionCall(), needsEval = {}, TypedArray = typeof Uint8Array > `u` || !getProto$2 ? undefined$1 : getProto$2(Uint8Array), INTRINSICS = { __proto__: null, "%AggregateError%": typeof AggregateError > `u` ? undefined$1 : AggregateError, "%Array%": Array, "%ArrayBuffer%": typeof ArrayBuffer > `u` ? undefined$1 : ArrayBuffer, "%ArrayIteratorPrototype%": hasSymbols$2 && getProto$2 ? getProto$2([][Symbol.iterator]()) : undefined$1, "%AsyncFromSyncIteratorPrototype%": undefined$1, "%AsyncFunction%": needsEval, "%AsyncGenerator%": needsEval, "%AsyncGeneratorFunction%": needsEval, "%AsyncIteratorPrototype%": needsEval, "%Atomics%": typeof Atomics > `u` ? undefined$1 : Atomics, "%BigInt%": typeof BigInt > `u` ? undefined$1 : BigInt, "%BigInt64Array%": typeof BigInt64Array > `u` ? undefined$1 : BigInt64Array, "%BigUint64Array%": typeof BigUint64Array > `u` ? undefined$1 : BigUint64Array, "%Boolean%": Boolean, "%DataView%": typeof DataView > `u` ? undefined$1 : DataView, "%Date%": Date, "%decodeURI%": decodeURI, "%decodeURIComponent%": decodeURIComponent, "%encodeURI%": encodeURI, "%encodeURIComponent%": encodeURIComponent, "%Error%": $Error, "%eval%": eval, "%EvalError%": $EvalError, "%Float16Array%": typeof Float16Array > `u` ? undefined$1 : Float16Array, "%Float32Array%": typeof Float32Array > `u` ? undefined$1 : Float32Array, "%Float64Array%": typeof Float64Array > `u` ? undefined$1 : Float64Array, "%FinalizationRegistry%": typeof FinalizationRegistry > `u` ? undefined$1 : FinalizationRegistry, "%Function%": $Function, "%GeneratorFunction%": needsEval, "%Int8Array%": typeof Int8Array > `u` ? undefined$1 : Int8Array, "%Int16Array%": typeof Int16Array > `u` ? undefined$1 : Int16Array, "%Int32Array%": typeof Int32Array > `u` ? undefined$1 : Int32Array, "%isFinite%": isFinite, "%isNaN%": isNaN, "%IteratorPrototype%": hasSymbols$2 && getProto$2 ? getProto$2(getProto$2([][Symbol.iterator]())) : undefined$1, "%JSON%": typeof JSON == `object` ? JSON : undefined$1, "%Map%": typeof Map > `u` ? undefined$1 : Map, "%MapIteratorPrototype%": typeof Map > `u` || !hasSymbols$2 || !getProto$2 ? undefined$1 : getProto$2((/* @__PURE__ */ new Map())[Symbol.iterator]()), "%Math%": Math, "%Number%": Number, "%Object%": $Object$1, "%Object.getOwnPropertyDescriptor%": $gOPD, "%parseFloat%": parseFloat, "%parseInt%": parseInt, "%Promise%": typeof Promise > `u` ? undefined$1 : Promise, "%Proxy%": typeof Proxy > `u` ? undefined$1 : Proxy, "%RangeError%": $RangeError, "%ReferenceError%": $ReferenceError, "%Reflect%": typeof Reflect > `u` ? undefined$1 : Reflect, "%RegExp%": RegExp, "%Set%": typeof Set > `u` ? undefined$1 : Set, "%SetIteratorPrototype%": typeof Set > `u` || !hasSymbols$2 || !getProto$2 ? undefined$1 : getProto$2((/* @__PURE__ */ new Set())[Symbol.iterator]()), "%SharedArrayBuffer%": typeof SharedArrayBuffer > `u` ? undefined$1 : SharedArrayBuffer, "%String%": String, "%StringIteratorPrototype%": hasSymbols$2 && getProto$2 ? getProto$2(``[Symbol.iterator]()) : undefined$1, "%Symbol%": hasSymbols$2 ? Symbol : undefined$1, "%SyntaxError%": $SyntaxError$1, "%ThrowTypeError%": ThrowTypeError, "%TypedArray%": TypedArray, "%TypeError%": $TypeError$4, "%Uint8Array%": typeof Uint8Array > `u` ? undefined$1 : Uint8Array, "%Uint8ClampedArray%": typeof Uint8ClampedArray > `u` ? undefined$1 : Uint8ClampedArray, "%Uint16Array%": typeof Uint16Array > `u` ? undefined$1 : Uint16Array, "%Uint32Array%": typeof Uint32Array > `u` ? undefined$1 : Uint32Array, "%URIError%": $URIError, "%WeakMap%": typeof WeakMap > `u` ? undefined$1 : WeakMap, "%WeakRef%": typeof WeakRef > `u` ? undefined$1 : WeakRef, "%WeakSet%": typeof WeakSet > `u` ? undefined$1 : WeakSet, "%Function.prototype.call%": $call, "%Function.prototype.apply%": $apply$1, "%Object.defineProperty%": $defineProperty$3, "%Object.getPrototypeOf%": $ObjectGPO, "%Math.abs%": abs, "%Math.floor%": floor, "%Math.max%": max$1, "%Math.min%": min, "%Math.pow%": pow, "%Math.round%": round$1, "%Math.sign%": sign$1, "%Reflect.getPrototypeOf%": $ReflectGPO };
  if (getProto$2) try {
    null.error;
  } catch (e$22) {
    var errorProto = getProto$2(getProto$2(e$22));
    INTRINSICS[`%Error.prototype%`] = errorProto;
  }
  var doEval = function doEval$1(name$2) {
    var value;
    if (name$2 === `%AsyncFunction%`) value = getEvalledConstructor(`async function () {}`);
    else if (name$2 === `%GeneratorFunction%`) value = getEvalledConstructor(`function* () {}`);
    else if (name$2 === `%AsyncGeneratorFunction%`) value = getEvalledConstructor(`async function* () {}`);
    else if (name$2 === `%AsyncGenerator%`) {
      var fn$1 = doEval$1(`%AsyncGeneratorFunction%`);
      fn$1 && (value = fn$1.prototype);
    } else if (name$2 === `%AsyncIteratorPrototype%`) {
      var gen = doEval$1(`%AsyncGenerator%`);
      gen && getProto$2 && (value = getProto$2(gen.prototype));
    }
    return INTRINSICS[name$2] = value, value;
  }, LEGACY_ALIASES = { __proto__: null, "%ArrayBufferPrototype%": [`ArrayBuffer`, `prototype`], "%ArrayPrototype%": [`Array`, `prototype`], "%ArrayProto_entries%": [`Array`, `prototype`, `entries`], "%ArrayProto_forEach%": [`Array`, `prototype`, `forEach`], "%ArrayProto_keys%": [`Array`, `prototype`, `keys`], "%ArrayProto_values%": [`Array`, `prototype`, `values`], "%AsyncFunctionPrototype%": [`AsyncFunction`, `prototype`], "%AsyncGenerator%": [`AsyncGeneratorFunction`, `prototype`], "%AsyncGeneratorPrototype%": [`AsyncGeneratorFunction`, `prototype`, `prototype`], "%BooleanPrototype%": [`Boolean`, `prototype`], "%DataViewPrototype%": [`DataView`, `prototype`], "%DatePrototype%": [`Date`, `prototype`], "%ErrorPrototype%": [`Error`, `prototype`], "%EvalErrorPrototype%": [`EvalError`, `prototype`], "%Float32ArrayPrototype%": [`Float32Array`, `prototype`], "%Float64ArrayPrototype%": [`Float64Array`, `prototype`], "%FunctionPrototype%": [`Function`, `prototype`], "%Generator%": [`GeneratorFunction`, `prototype`], "%GeneratorPrototype%": [`GeneratorFunction`, `prototype`, `prototype`], "%Int8ArrayPrototype%": [`Int8Array`, `prototype`], "%Int16ArrayPrototype%": [`Int16Array`, `prototype`], "%Int32ArrayPrototype%": [`Int32Array`, `prototype`], "%JSONParse%": [`JSON`, `parse`], "%JSONStringify%": [`JSON`, `stringify`], "%MapPrototype%": [`Map`, `prototype`], "%NumberPrototype%": [`Number`, `prototype`], "%ObjectPrototype%": [`Object`, `prototype`], "%ObjProto_toString%": [`Object`, `prototype`, `toString`], "%ObjProto_valueOf%": [`Object`, `prototype`, `valueOf`], "%PromisePrototype%": [`Promise`, `prototype`], "%PromiseProto_then%": [`Promise`, `prototype`, `then`], "%Promise_all%": [`Promise`, `all`], "%Promise_reject%": [`Promise`, `reject`], "%Promise_resolve%": [`Promise`, `resolve`], "%RangeErrorPrototype%": [`RangeError`, `prototype`], "%ReferenceErrorPrototype%": [`ReferenceError`, `prototype`], "%RegExpPrototype%": [`RegExp`, `prototype`], "%SetPrototype%": [`Set`, `prototype`], "%SharedArrayBufferPrototype%": [`SharedArrayBuffer`, `prototype`], "%StringPrototype%": [`String`, `prototype`], "%SymbolPrototype%": [`Symbol`, `prototype`], "%SyntaxErrorPrototype%": [`SyntaxError`, `prototype`], "%TypedArrayPrototype%": [`TypedArray`, `prototype`], "%TypeErrorPrototype%": [`TypeError`, `prototype`], "%Uint8ArrayPrototype%": [`Uint8Array`, `prototype`], "%Uint8ClampedArrayPrototype%": [`Uint8ClampedArray`, `prototype`], "%Uint16ArrayPrototype%": [`Uint16Array`, `prototype`], "%Uint32ArrayPrototype%": [`Uint32Array`, `prototype`], "%URIErrorPrototype%": [`URIError`, `prototype`], "%WeakMapPrototype%": [`WeakMap`, `prototype`], "%WeakSetPrototype%": [`WeakSet`, `prototype`] }, bind$1 = require_function_bind(), hasOwn$1 = require_hasown(), $concat = bind$1.call($call, Array.prototype.concat), $spliceApply = bind$1.call($apply$1, Array.prototype.splice), $replace = bind$1.call($call, String.prototype.replace), $strSlice = bind$1.call($call, String.prototype.slice), $exec$2 = bind$1.call($call, RegExp.prototype.exec), rePropName$1 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, reEscapeChar$1 = /\\(\\)?/g, stringToPath$2 = function(string) {
    var first$1 = $strSlice(string, 0, 1), last$2 = $strSlice(string, -1);
    if (first$1 === `%` && last$2 !== `%`) throw new $SyntaxError$1("invalid intrinsic syntax, expected closing `%`");
    if (last$2 === `%` && first$1 !== `%`) throw new $SyntaxError$1("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    return $replace(string, rePropName$1, function(match$2, number, quote, subString) {
      result[result.length] = quote ? $replace(subString, reEscapeChar$1, `$1`) : number || match$2;
    }), result;
  }, getBaseIntrinsic = function(name$2, allowMissing) {
    var intrinsicName = name$2, alias;
    if (hasOwn$1(LEGACY_ALIASES, intrinsicName) && (alias = LEGACY_ALIASES[intrinsicName], intrinsicName = `%` + alias[0] + `%`), hasOwn$1(INTRINSICS, intrinsicName)) {
      var value = INTRINSICS[intrinsicName];
      if (value === needsEval && (value = doEval(intrinsicName)), value === void 0 && !allowMissing) throw new $TypeError$4(`intrinsic ` + name$2 + ` exists, but is not available. Please file an issue!`);
      return { alias, name: intrinsicName, value };
    }
    throw new $SyntaxError$1(`intrinsic ` + name$2 + ` does not exist!`);
  };
  module2.exports = function(name$2, allowMissing) {
    if (typeof name$2 != `string` || name$2.length === 0) throw new $TypeError$4(`intrinsic name must be a non-empty string`);
    if (arguments.length > 1 && typeof allowMissing != `boolean`) throw new $TypeError$4(`"allowMissing" argument must be a boolean`);
    if ($exec$2(/^%?[^%]*%?$/, name$2) === null) throw new $SyntaxError$1("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = stringToPath$2(name$2), intrinsicBaseName = parts.length > 0 ? parts[0] : ``, intrinsic = getBaseIntrinsic(`%` + intrinsicBaseName + `%`, allowMissing), intrinsicRealName = intrinsic.name, value = intrinsic.value, skipFurtherCaching = false, alias = intrinsic.alias;
    alias && (intrinsicBaseName = alias[0], $spliceApply(parts, $concat([0, 1], alias)));
    for (var i$4 = 1, isOwn = true; i$4 < parts.length; i$4 += 1) {
      var part = parts[i$4], first$1 = $strSlice(part, 0, 1), last$2 = $strSlice(part, -1);
      if ((first$1 === `"` || first$1 === `'` || first$1 === "`" || last$2 === `"` || last$2 === `'` || last$2 === "`") && first$1 !== last$2) throw new $SyntaxError$1(`property names with quotes must have matching quotes`);
      if ((part === `constructor` || !isOwn) && (skipFurtherCaching = true), intrinsicBaseName += `.` + part, intrinsicRealName = `%` + intrinsicBaseName + `%`, hasOwn$1(INTRINSICS, intrinsicRealName)) value = INTRINSICS[intrinsicRealName];
      else if (value != null) {
        if (!(part in value)) {
          if (!allowMissing) throw new $TypeError$4(`base intrinsic for ` + name$2 + ` exists, but the property is not available.`);
          return;
        }
        if ($gOPD && i$4 + 1 >= parts.length) {
          var desc$1 = $gOPD(value, part);
          isOwn = !!desc$1, value = isOwn && `get` in desc$1 && !(`originalValue` in desc$1.get) ? desc$1.get : value[part];
        } else isOwn = hasOwn$1(value, part), value = value[part];
        isOwn && !skipFurtherCaching && (INTRINSICS[intrinsicRealName] = value);
      }
    }
    return value;
  };
}), require_call_bound = __commonJSMin$1((exports$12, module2) => {
  var GetIntrinsic$2 = require_get_intrinsic(), callBindBasic$1 = require_call_bind_apply_helpers(), $indexOf$2 = callBindBasic$1([GetIntrinsic$2(`%String.prototype.indexOf%`)]);
  module2.exports = function(name$2, allowMissing) {
    var intrinsic = GetIntrinsic$2(name$2, !!allowMissing);
    return typeof intrinsic == `function` && $indexOf$2(name$2, `.prototype.`) > -1 ? callBindBasic$1([intrinsic]) : intrinsic;
  };
}), require_is_arguments = __commonJSMin$1((exports$12, module2) => {
  var hasToStringTag$4 = require_shams()(), callBound$6 = require_call_bound(), $toString$2 = callBound$6(`Object.prototype.toString`), isStandardArguments = function(value) {
    return hasToStringTag$4 && value && typeof value == `object` && Symbol.toStringTag in value ? false : $toString$2(value) === `[object Arguments]`;
  }, isLegacyArguments = function(value) {
    return isStandardArguments(value) ? true : typeof value == `object` && !!value && `length` in value && typeof value.length == `number` && value.length >= 0 && $toString$2(value) !== `[object Array]` && `callee` in value && $toString$2(value.callee) === `[object Function]`;
  }, supportsStandardArguments = (function() {
    return isStandardArguments(arguments);
  })();
  isStandardArguments.isLegacyArguments = isLegacyArguments, module2.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;
}), require_is_regex = __commonJSMin$1((exports$12, module2) => {
  var callBound$5 = require_call_bound(), hasToStringTag$3 = require_shams()(), hasOwn = require_hasown(), gOPD$2 = require_gopd(), fn;
  if (hasToStringTag$3) {
    var $exec$1 = callBound$5(`RegExp.prototype.exec`), isRegexMarker = {}, throwRegexMarker = function() {
      throw isRegexMarker;
    }, badStringifier = { toString: throwRegexMarker, valueOf: throwRegexMarker };
    typeof Symbol.toPrimitive == `symbol` && (badStringifier[Symbol.toPrimitive] = throwRegexMarker), fn = function(value) {
      if (!value || typeof value != `object`) return false;
      var descriptor = gOPD$2(value, `lastIndex`), hasLastIndexDataProperty = descriptor && hasOwn(descriptor, `value`);
      if (!hasLastIndexDataProperty) return false;
      try {
        $exec$1(value, badStringifier);
      } catch (e$22) {
        return e$22 === isRegexMarker;
      }
    };
  } else {
    var $toString$1 = callBound$5(`Object.prototype.toString`), regexClass = `[object RegExp]`;
    fn = function(value) {
      return !value || typeof value != `object` && typeof value != `function` ? false : $toString$1(value) === regexClass;
    };
  }
  module2.exports = fn;
}), require_safe_regex_test = __commonJSMin$1((exports$12, module2) => {
  var callBound$4 = require_call_bound(), isRegex = require_is_regex(), $exec = callBound$4(`RegExp.prototype.exec`), $TypeError$3 = require_type();
  module2.exports = function(regex) {
    if (!isRegex(regex)) throw new $TypeError$3("`regex` must be a RegExp");
    return function(s$6) {
      return $exec(regex, s$6) !== null;
    };
  };
}), require_is_generator_function = __commonJSMin$1((exports$12, module2) => {
  var callBound$3 = require_call_bound(), safeRegexTest = require_safe_regex_test(), isFnRegex = safeRegexTest(/^\s*(?:function)?\*/), hasToStringTag$2 = require_shams()(), getProto$1 = require_get_proto(), toStr$5 = callBound$3(`Object.prototype.toString`), fnToStr$1 = callBound$3(`Function.prototype.toString`), getGeneratorFunc = function() {
    if (!hasToStringTag$2) return false;
    try {
      return Function(`return function*() {}`)();
    } catch {
    }
  }, GeneratorFunction;
  module2.exports = function(fn$1) {
    if (typeof fn$1 != `function`) return false;
    if (isFnRegex(fnToStr$1(fn$1))) return true;
    if (!hasToStringTag$2) {
      var str = toStr$5(fn$1);
      return str === `[object GeneratorFunction]`;
    }
    if (!getProto$1) return false;
    if (GeneratorFunction === void 0) {
      var generatorFunc = getGeneratorFunc();
      GeneratorFunction = generatorFunc ? getProto$1(generatorFunc) : false;
    }
    return getProto$1(fn$1) === GeneratorFunction;
  };
}), require_is_callable = __commonJSMin$1((exports$12, module2) => {
  var fnToStr = Function.prototype.toString, reflectApply = typeof Reflect == `object` && Reflect !== null && Reflect.apply, badArrayLike, isCallableMarker;
  if (typeof reflectApply == `function` && typeof Object.defineProperty == `function`) try {
    badArrayLike = Object.defineProperty({}, `length`, { get: function() {
      throw isCallableMarker;
    } }), isCallableMarker = {}, reflectApply(function() {
      throw 42;
    }, null, badArrayLike);
  } catch (_) {
    _ !== isCallableMarker && (reflectApply = null);
  }
  else reflectApply = null;
  var constructorRegex = /^\s*class\b/, isES6ClassFn = function(value) {
    try {
      var fnStr = fnToStr.call(value);
      return constructorRegex.test(fnStr);
    } catch {
      return false;
    }
  }, tryFunctionObject = function(value) {
    try {
      return isES6ClassFn(value) ? false : (fnToStr.call(value), true);
    } catch {
      return false;
    }
  }, toStr$4 = Object.prototype.toString, objectClass = `[object Object]`, fnClass = `[object Function]`, genClass = `[object GeneratorFunction]`, ddaClass = `[object HTMLAllCollection]`, ddaClass2 = `[object HTML document.all class]`, ddaClass3 = `[object HTMLCollection]`, hasToStringTag$1 = typeof Symbol == `function` && !!Symbol.toStringTag, isIE68 = !(0 in [,]), isDDA = function() {
    return false;
  };
  if (typeof document == `object`) {
    var all = document.all;
    toStr$4.call(all) === toStr$4.call(document.all) && (isDDA = function(value) {
      if ((isIE68 || !value) && (value === void 0 || typeof value == `object`)) try {
        var str = toStr$4.call(value);
        return (str === ddaClass || str === ddaClass2 || str === ddaClass3 || str === objectClass) && value(``) == null;
      } catch {
      }
      return false;
    });
  }
  module2.exports = reflectApply ? function(value) {
    if (isDDA(value)) return true;
    if (!value || typeof value != `function` && typeof value != `object`) return false;
    try {
      reflectApply(value, null, badArrayLike);
    } catch (e$22) {
      if (e$22 !== isCallableMarker) return false;
    }
    return !isES6ClassFn(value) && tryFunctionObject(value);
  } : function(value) {
    if (isDDA(value)) return true;
    if (!value || typeof value != `function` && typeof value != `object`) return false;
    if (hasToStringTag$1) return tryFunctionObject(value);
    if (isES6ClassFn(value)) return false;
    var strClass = toStr$4.call(value);
    return strClass !== fnClass && strClass !== genClass && !/^\[object HTML/.test(strClass) ? false : tryFunctionObject(value);
  };
}), require_for_each = __commonJSMin$1((exports$12, module2) => {
  var isCallable = require_is_callable(), toStr$3 = Object.prototype.toString, hasOwnProperty$22 = Object.prototype.hasOwnProperty, forEachArray = function(array, iterator, receiver) {
    for (var i$4 = 0, len$2 = array.length; i$4 < len$2; i$4++) hasOwnProperty$22.call(array, i$4) && (receiver == null ? iterator(array[i$4], i$4, array) : iterator.call(receiver, array[i$4], i$4, array));
  }, forEachString = function(string, iterator, receiver) {
    for (var i$4 = 0, len$2 = string.length; i$4 < len$2; i$4++) receiver == null ? iterator(string.charAt(i$4), i$4, string) : iterator.call(receiver, string.charAt(i$4), i$4, string);
  }, forEachObject = function(object, iterator, receiver) {
    for (var k in object) hasOwnProperty$22.call(object, k) && (receiver == null ? iterator(object[k], k, object) : iterator.call(receiver, object[k], k, object));
  };
  function isArray$23(x$1) {
    return toStr$3.call(x$1) === `[object Array]`;
  }
  module2.exports = function(list, iterator, thisArg) {
    if (!isCallable(iterator)) throw TypeError(`iterator must be a function`);
    var receiver;
    arguments.length >= 3 && (receiver = thisArg), isArray$23(list) ? forEachArray(list, iterator, receiver) : typeof list == `string` ? forEachString(list, iterator, receiver) : forEachObject(list, iterator, receiver);
  };
}), require_possible_typed_array_names = __commonJSMin$1((exports$12, module2) => {
  module2.exports = [`Float16Array`, `Float32Array`, `Float64Array`, `Int8Array`, `Int16Array`, `Int32Array`, `Uint8Array`, `Uint8ClampedArray`, `Uint16Array`, `Uint32Array`, `BigInt64Array`, `BigUint64Array`];
}), require_available_typed_arrays = __commonJSMin$1((exports$12, module2) => {
  var possibleNames = require_possible_typed_array_names(), g$1 = typeof globalThis > `u` ? {} : globalThis;
  module2.exports = function() {
    for (var out = [], i$4 = 0; i$4 < possibleNames.length; i$4++) typeof g$1[possibleNames[i$4]] == `function` && (out[out.length] = possibleNames[i$4]);
    return out;
  };
}), require_define_data_property = __commonJSMin$1((exports$12, module2) => {
  var $defineProperty$2 = require_es_define_property(), $SyntaxError = require_syntax(), $TypeError$2 = require_type(), gopd = require_gopd();
  module2.exports = function(obj, property$2, value) {
    if (!obj || typeof obj != `object` && typeof obj != `function`) throw new $TypeError$2("`obj` must be an object or a function`");
    if (typeof property$2 != `string` && typeof property$2 != `symbol`) throw new $TypeError$2("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] != `boolean` && arguments[3] !== null) throw new $TypeError$2("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] != `boolean` && arguments[4] !== null) throw new $TypeError$2("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] != `boolean` && arguments[5] !== null) throw new $TypeError$2("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] != `boolean`) throw new $TypeError$2("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null, nonWritable = arguments.length > 4 ? arguments[4] : null, nonConfigurable = arguments.length > 5 ? arguments[5] : null, loose = arguments.length > 6 ? arguments[6] : false, desc$1 = !!gopd && gopd(obj, property$2);
    if ($defineProperty$2) $defineProperty$2(obj, property$2, { configurable: nonConfigurable === null && desc$1 ? desc$1.configurable : !nonConfigurable, enumerable: nonEnumerable === null && desc$1 ? desc$1.enumerable : !nonEnumerable, value, writable: nonWritable === null && desc$1 ? desc$1.writable : !nonWritable });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) obj[property$2] = value;
    else throw new $SyntaxError(`This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.`);
  };
}), require_has_property_descriptors = __commonJSMin$1((exports$12, module2) => {
  var $defineProperty$1 = require_es_define_property(), hasPropertyDescriptors = function() {
    return !!$defineProperty$1;
  };
  hasPropertyDescriptors.hasArrayLengthDefineBug = function() {
    if (!$defineProperty$1) return null;
    try {
      return $defineProperty$1([], `length`, { value: 1 }).length !== 1;
    } catch {
      return true;
    }
  }, module2.exports = hasPropertyDescriptors;
}), require_set_function_length = __commonJSMin$1((exports$12, module2) => {
  var GetIntrinsic$1 = require_get_intrinsic(), define$5 = require_define_data_property(), hasDescriptors = require_has_property_descriptors()(), gOPD$1 = require_gopd(), $TypeError$1 = require_type(), $floor = GetIntrinsic$1(`%Math.floor%`);
  module2.exports = function(fn$1, length) {
    if (typeof fn$1 != `function`) throw new $TypeError$1("`fn` is not a function");
    if (typeof length != `number` || length < 0 || length > 4294967295 || $floor(length) !== length) throw new $TypeError$1("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2], functionLengthIsConfigurable = true, functionLengthIsWritable = true;
    if (`length` in fn$1 && gOPD$1) {
      var desc$1 = gOPD$1(fn$1, `length`);
      desc$1 && !desc$1.configurable && (functionLengthIsConfigurable = false), desc$1 && !desc$1.writable && (functionLengthIsWritable = false);
    }
    return (functionLengthIsConfigurable || functionLengthIsWritable || !loose) && (hasDescriptors ? define$5(fn$1, `length`, length, true, true) : define$5(fn$1, `length`, length)), fn$1;
  };
}), require_applyBind = __commonJSMin$1((exports$12, module2) => {
  var bind = require_function_bind(), $apply = require_functionApply(), actualApply = require_actualApply();
  module2.exports = function() {
    return actualApply(bind, $apply, arguments);
  };
}), require_call_bind = __commonJSMin$1((exports$12, module2) => {
  var setFunctionLength = require_set_function_length(), $defineProperty = require_es_define_property(), callBindBasic = require_call_bind_apply_helpers(), applyBind = require_applyBind();
  module2.exports = function(originalFunction) {
    var func = callBindBasic(arguments), adjustedLength = originalFunction.length - (arguments.length - 1);
    return setFunctionLength(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
  }, $defineProperty ? $defineProperty(module2.exports, `apply`, { value: applyBind }) : module2.exports.apply = applyBind;
}), require_which_typed_array = __commonJSMin$1((exports$12, module2) => {
  var forEach$1 = require_for_each(), availableTypedArrays = require_available_typed_arrays(), callBind$3 = require_call_bind(), callBound$2 = require_call_bound(), gOPD = require_gopd(), getProto = require_get_proto(), $toString = callBound$2(`Object.prototype.toString`), hasToStringTag = require_shams()(), g2 = typeof globalThis > `u` ? {} : globalThis, typedArrays = availableTypedArrays(), $slice = callBound$2(`String.prototype.slice`), $indexOf$1 = callBound$2(`Array.prototype.indexOf`, true) || function(array, value) {
    for (var i$4 = 0; i$4 < array.length; i$4 += 1) if (array[i$4] === value) return i$4;
    return -1;
  }, cache$1 = { __proto__: null };
  hasToStringTag && gOPD && getProto ? forEach$1(typedArrays, function(typedArray) {
    var arr = new g2[typedArray]();
    if (Symbol.toStringTag in arr && getProto) {
      var proto = getProto(arr), descriptor = gOPD(proto, Symbol.toStringTag);
      if (!descriptor && proto) {
        var superProto = getProto(proto);
        descriptor = gOPD(superProto, Symbol.toStringTag);
      }
      cache$1[`$` + typedArray] = callBind$3(descriptor.get);
    }
  }) : forEach$1(typedArrays, function(typedArray) {
    var arr = new g2[typedArray](), fn$1 = arr.slice || arr.set;
    fn$1 && (cache$1[`$` + typedArray] = callBind$3(fn$1));
  });
  var tryTypedArrays = function(value) {
    var found = false;
    return forEach$1(cache$1, function(getter, typedArray) {
      if (!found) try {
        `$` + getter(value) === typedArray && (found = $slice(typedArray, 1));
      } catch {
      }
    }), found;
  }, trySlices = function(value) {
    var found = false;
    return forEach$1(cache$1, function(getter, name$2) {
      if (!found) try {
        getter(value), found = $slice(name$2, 1);
      } catch {
      }
    }), found;
  };
  module2.exports = function(value) {
    if (!value || typeof value != `object`) return false;
    if (!hasToStringTag) {
      var tag = $slice($toString(value), 8, -1);
      return $indexOf$1(typedArrays, tag) > -1 ? tag : tag === `Object` ? trySlices(value) : false;
    }
    return gOPD ? tryTypedArrays(value) : null;
  };
}), require_is_typed_array = __commonJSMin$1((exports$12, module2) => {
  var whichTypedArray$1 = require_which_typed_array();
  module2.exports = function(value) {
    return !!whichTypedArray$1(value);
  };
}), require_types = __commonJSMin$1((exports$12) => {
  var isArgumentsObject = require_is_arguments(), isGeneratorFunction = require_is_generator_function(), whichTypedArray = require_which_typed_array(), isTypedArray$7 = require_is_typed_array();
  function uncurryThis$1(f$32) {
    return f$32.call.bind(f$32);
  }
  var BigIntSupported = typeof BigInt < `u`, SymbolSupported = typeof Symbol < `u`, ObjectToString = uncurryThis$1(Object.prototype.toString), numberValue = uncurryThis$1(Number.prototype.valueOf), stringValue = uncurryThis$1(String.prototype.valueOf), booleanValue = uncurryThis$1(Boolean.prototype.valueOf);
  if (BigIntSupported) var bigIntValue = uncurryThis$1(BigInt.prototype.valueOf);
  if (SymbolSupported) var symbolValue = uncurryThis$1(Symbol.prototype.valueOf);
  function checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value != `object`) return false;
    try {
      return prototypeValueOf(value), true;
    } catch {
      return false;
    }
  }
  exports$12.isArgumentsObject = isArgumentsObject, exports$12.isGeneratorFunction = isGeneratorFunction, exports$12.isTypedArray = isTypedArray$7;
  function isPromise$1(input) {
    return typeof Promise < `u` && input instanceof Promise || typeof input == `object` && !!input && typeof input.then == `function` && typeof input.catch == `function`;
  }
  exports$12.isPromise = isPromise$1;
  function isArrayBufferView$1(value) {
    return typeof ArrayBuffer < `u` && ArrayBuffer.isView ? ArrayBuffer.isView(value) : isTypedArray$7(value) || isDataView(value);
  }
  exports$12.isArrayBufferView = isArrayBufferView$1;
  function isUint8Array(value) {
    return whichTypedArray(value) === `Uint8Array`;
  }
  exports$12.isUint8Array = isUint8Array;
  function isUint8ClampedArray(value) {
    return whichTypedArray(value) === `Uint8ClampedArray`;
  }
  exports$12.isUint8ClampedArray = isUint8ClampedArray;
  function isUint16Array(value) {
    return whichTypedArray(value) === `Uint16Array`;
  }
  exports$12.isUint16Array = isUint16Array;
  function isUint32Array(value) {
    return whichTypedArray(value) === `Uint32Array`;
  }
  exports$12.isUint32Array = isUint32Array;
  function isInt8Array(value) {
    return whichTypedArray(value) === `Int8Array`;
  }
  exports$12.isInt8Array = isInt8Array;
  function isInt16Array(value) {
    return whichTypedArray(value) === `Int16Array`;
  }
  exports$12.isInt16Array = isInt16Array;
  function isInt32Array(value) {
    return whichTypedArray(value) === `Int32Array`;
  }
  exports$12.isInt32Array = isInt32Array;
  function isFloat32Array$1(value) {
    return whichTypedArray(value) === `Float32Array`;
  }
  exports$12.isFloat32Array = isFloat32Array$1;
  function isFloat64Array$1(value) {
    return whichTypedArray(value) === `Float64Array`;
  }
  exports$12.isFloat64Array = isFloat64Array$1;
  function isBigInt64Array(value) {
    return whichTypedArray(value) === `BigInt64Array`;
  }
  exports$12.isBigInt64Array = isBigInt64Array;
  function isBigUint64Array(value) {
    return whichTypedArray(value) === `BigUint64Array`;
  }
  exports$12.isBigUint64Array = isBigUint64Array;
  function isMapToString(value) {
    return ObjectToString(value) === `[object Map]`;
  }
  isMapToString.working = typeof Map < `u` && isMapToString(/* @__PURE__ */ new Map());
  function isMap$3(value) {
    return typeof Map > `u` ? false : isMapToString.working ? isMapToString(value) : value instanceof Map;
  }
  exports$12.isMap = isMap$3;
  function isSetToString(value) {
    return ObjectToString(value) === `[object Set]`;
  }
  isSetToString.working = typeof Set < `u` && isSetToString(/* @__PURE__ */ new Set());
  function isSet$3(value) {
    return typeof Set > `u` ? false : isSetToString.working ? isSetToString(value) : value instanceof Set;
  }
  exports$12.isSet = isSet$3;
  function isWeakMapToString(value) {
    return ObjectToString(value) === `[object WeakMap]`;
  }
  isWeakMapToString.working = typeof WeakMap < `u` && isWeakMapToString(/* @__PURE__ */ new WeakMap());
  function isWeakMap(value) {
    return typeof WeakMap > `u` ? false : isWeakMapToString.working ? isWeakMapToString(value) : value instanceof WeakMap;
  }
  exports$12.isWeakMap = isWeakMap;
  function isWeakSetToString(value) {
    return ObjectToString(value) === `[object WeakSet]`;
  }
  isWeakSetToString.working = typeof WeakSet < `u` && isWeakSetToString(/* @__PURE__ */ new WeakSet());
  function isWeakSet(value) {
    return isWeakSetToString(value);
  }
  exports$12.isWeakSet = isWeakSet;
  function isArrayBufferToString(value) {
    return ObjectToString(value) === `[object ArrayBuffer]`;
  }
  isArrayBufferToString.working = typeof ArrayBuffer < `u` && isArrayBufferToString(new ArrayBuffer());
  function isArrayBuffer(value) {
    return typeof ArrayBuffer > `u` ? false : isArrayBufferToString.working ? isArrayBufferToString(value) : value instanceof ArrayBuffer;
  }
  exports$12.isArrayBuffer = isArrayBuffer;
  function isDataViewToString(value) {
    return ObjectToString(value) === `[object DataView]`;
  }
  isDataViewToString.working = typeof ArrayBuffer < `u` && typeof DataView < `u` && isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
  function isDataView(value) {
    return typeof DataView > `u` ? false : isDataViewToString.working ? isDataViewToString(value) : value instanceof DataView;
  }
  exports$12.isDataView = isDataView;
  var SharedArrayBufferCopy = typeof SharedArrayBuffer < `u` ? SharedArrayBuffer : void 0;
  function isSharedArrayBufferToString(value) {
    return ObjectToString(value) === `[object SharedArrayBuffer]`;
  }
  function isSharedArrayBuffer(value) {
    return SharedArrayBufferCopy === void 0 ? false : (isSharedArrayBufferToString.working === void 0 && (isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy())), isSharedArrayBufferToString.working ? isSharedArrayBufferToString(value) : value instanceof SharedArrayBufferCopy);
  }
  exports$12.isSharedArrayBuffer = isSharedArrayBuffer;
  function isAsyncFunction(value) {
    return ObjectToString(value) === `[object AsyncFunction]`;
  }
  exports$12.isAsyncFunction = isAsyncFunction;
  function isMapIterator(value) {
    return ObjectToString(value) === `[object Map Iterator]`;
  }
  exports$12.isMapIterator = isMapIterator;
  function isSetIterator(value) {
    return ObjectToString(value) === `[object Set Iterator]`;
  }
  exports$12.isSetIterator = isSetIterator;
  function isGeneratorObject(value) {
    return ObjectToString(value) === `[object Generator]`;
  }
  exports$12.isGeneratorObject = isGeneratorObject;
  function isWebAssemblyCompiledModule(value) {
    return ObjectToString(value) === `[object WebAssembly.Module]`;
  }
  exports$12.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;
  function isNumberObject$1(value) {
    return checkBoxedPrimitive(value, numberValue);
  }
  exports$12.isNumberObject = isNumberObject$1;
  function isStringObject$1(value) {
    return checkBoxedPrimitive(value, stringValue);
  }
  exports$12.isStringObject = isStringObject$1;
  function isBooleanObject$1(value) {
    return checkBoxedPrimitive(value, booleanValue);
  }
  exports$12.isBooleanObject = isBooleanObject$1;
  function isBigIntObject$1(value) {
    return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
  }
  exports$12.isBigIntObject = isBigIntObject$1;
  function isSymbolObject$1(value) {
    return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
  }
  exports$12.isSymbolObject = isSymbolObject$1;
  function isBoxedPrimitive$1(value) {
    return isNumberObject$1(value) || isStringObject$1(value) || isBooleanObject$1(value) || isBigIntObject$1(value) || isSymbolObject$1(value);
  }
  exports$12.isBoxedPrimitive = isBoxedPrimitive$1;
  function isAnyArrayBuffer$1(value) {
    return typeof Uint8Array < `u` && (isArrayBuffer(value) || isSharedArrayBuffer(value));
  }
  exports$12.isAnyArrayBuffer = isAnyArrayBuffer$1, [`isProxy`, `isExternal`, `isModuleNamespaceObject`].forEach(function(method$1) {
    Object.defineProperty(exports$12, method$1, { enumerable: false, value: function() {
      throw Error(method$1 + ` is not supported in userland`);
    } });
  });
}), require_isBuffer$1 = __commonJSMin$1((exports$12, module2) => {
  init_dist$1(), module2.exports = function(arg) {
    return arg instanceof Buffer$1;
  };
}), require_inherits_browser = __commonJSMin$1((exports$12, module2) => {
  typeof Object.create == `function` ? module2.exports = function(ctor, superCtor) {
    superCtor && (ctor.super_ = superCtor, ctor.prototype = Object.create(superCtor.prototype, { constructor: { value: ctor, enumerable: false, writable: true, configurable: true } }));
  } : module2.exports = function(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor;
      var TempCtor = function() {
      };
      TempCtor.prototype = superCtor.prototype, ctor.prototype = new TempCtor(), ctor.prototype.constructor = ctor;
    }
  };
}), require_inherits = __commonJSMin$1((exports$12, module2) => {
  try {
    var util$2 = require_util();
    if (typeof util$2.inherits != `function`) throw ``;
    module2.exports = util$2.inherits;
  } catch {
    module2.exports = require_inherits_browser();
  }
}), require_util = __commonJSMin$1((exports$12) => {
  init_dist();
  var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function(obj) {
    for (var keys$10 = Object.keys(obj), descriptors = {}, i$4 = 0; i$4 < keys$10.length; i$4++) descriptors[keys$10[i$4]] = Object.getOwnPropertyDescriptor(obj, keys$10[i$4]);
    return descriptors;
  }, formatRegExp = /%[sdj%]/g;
  exports$12.format = function(f$32) {
    if (!isString$19(f$32)) {
      for (var objects = [], i$4 = 0; i$4 < arguments.length; i$4++) objects.push(inspect$3(arguments[i$4]));
      return objects.join(` `);
    }
    for (var i$4 = 1, args$1 = arguments, len$2 = args$1.length, str = String(f$32).replace(formatRegExp, function(x$2) {
      if (x$2 === `%%`) return `%`;
      if (i$4 >= len$2) return x$2;
      switch (x$2) {
        case `%s`:
          return String(args$1[i$4++]);
        case `%d`:
          return Number(args$1[i$4++]);
        case `%j`:
          try {
            return JSON.stringify(args$1[i$4++]);
          } catch {
            return `[Circular]`;
          }
        default:
          return x$2;
      }
    }), x$1 = args$1[i$4]; i$4 < len$2; x$1 = args$1[++i$4]) isNull(x$1) || !isObject$25(x$1) ? str += ` ` + x$1 : str += ` ` + inspect$3(x$1);
    return str;
  }, exports$12.deprecate = function(fn$1, msg) {
    if (process$1 !== void 0 && process$1.noDeprecation === true) return fn$1;
    if (process$1 === void 0) return function() {
      return exports$12.deprecate(fn$1, msg).apply(this, arguments);
    };
    var warned$1 = false;
    function deprecated() {
      if (!warned$1) {
        if (process$1.throwDeprecation) throw Error(msg);
        process$1.traceDeprecation ? console.trace(msg) : console.error(msg), warned$1 = true;
      }
      return fn$1.apply(this, arguments);
    }
    return deprecated;
  };
  var debugs = {}, debugEnvRegex = /^$/;
  if (process$1.env.NODE_DEBUG) {
    var debugEnv = process$1.env.NODE_DEBUG;
    debugEnv = debugEnv.replace(/[|\\{}()[\]^$+?.]/g, `\\$&`).replace(/\*/g, `.*`).replace(/,/g, `$|^`).toUpperCase(), debugEnvRegex = RegExp(`^` + debugEnv + `$`, `i`);
  }
  exports$12.debuglog = function(set) {
    if (set = set.toUpperCase(), !debugs[set]) if (debugEnvRegex.test(set)) {
      var pid = process$1.pid;
      debugs[set] = function() {
        var msg = exports$12.format.apply(exports$12, arguments);
        console.error(`%s %d: %s`, set, pid, msg);
      };
    } else debugs[set] = function() {
    };
    return debugs[set];
  };
  function inspect$3(obj, opts) {
    var ctx = { seen: [], stylize: stylizeNoColor };
    return arguments.length >= 3 && (ctx.depth = arguments[2]), arguments.length >= 4 && (ctx.colors = arguments[3]), isBoolean$2(opts) ? ctx.showHidden = opts : opts && exports$12._extend(ctx, opts), isUndefined$4(ctx.showHidden) && (ctx.showHidden = false), isUndefined$4(ctx.depth) && (ctx.depth = 2), isUndefined$4(ctx.colors) && (ctx.colors = false), isUndefined$4(ctx.customInspect) && (ctx.customInspect = true), ctx.colors && (ctx.stylize = stylizeWithColor), formatValue(ctx, obj, ctx.depth);
  }
  exports$12.inspect = inspect$3, inspect$3.colors = { bold: [1, 22], italic: [3, 23], underline: [4, 24], inverse: [7, 27], white: [37, 39], grey: [90, 39], black: [30, 39], blue: [34, 39], cyan: [36, 39], green: [32, 39], magenta: [35, 39], red: [31, 39], yellow: [33, 39] }, inspect$3.styles = { special: `cyan`, number: `yellow`, boolean: `yellow`, undefined: `grey`, null: `bold`, string: `green`, date: `magenta`, regexp: `red` };
  function stylizeWithColor(str, styleType) {
    var style = inspect$3.styles[styleType];
    return style ? `\x1B[` + inspect$3.colors[style][0] + `m` + str + `\x1B[` + inspect$3.colors[style][1] + `m` : str;
  }
  function stylizeNoColor(str, styleType) {
    return str;
  }
  function arrayToHash(array) {
    var hash$4 = {};
    return array.forEach(function(val, idx) {
      hash$4[val] = true;
    }), hash$4;
  }
  function formatValue(ctx, value, recurseTimes) {
    if (ctx.customInspect && value && isFunction$11(value.inspect) && value.inspect !== exports$12.inspect && !(value.constructor && value.constructor.prototype === value)) {
      var ret = value.inspect(recurseTimes, ctx);
      return isString$19(ret) || (ret = formatValue(ctx, ret, recurseTimes)), ret;
    }
    var primitive = formatPrimitive(ctx, value);
    if (primitive) return primitive;
    var keys$10 = Object.keys(value), visibleKeys = arrayToHash(keys$10);
    if (ctx.showHidden && (keys$10 = Object.getOwnPropertyNames(value)), isError2(value) && (keys$10.indexOf(`message`) >= 0 || keys$10.indexOf(`description`) >= 0)) return formatError(value);
    if (keys$10.length === 0) {
      if (isFunction$11(value)) {
        var name$2 = value.name ? `: ` + value.name : ``;
        return ctx.stylize(`[Function` + name$2 + `]`, `special`);
      }
      if (isRegExp$2(value)) return ctx.stylize(RegExp.prototype.toString.call(value), `regexp`);
      if (isDate$3(value)) return ctx.stylize(Date.prototype.toString.call(value), `date`);
      if (isError2(value)) return formatError(value);
    }
    var base$3 = ``, array = false, braces = [`{`, `}`];
    if (isArray$22(value) && (array = true, braces = [`[`, `]`]), isFunction$11(value)) {
      var n$4 = value.name ? `: ` + value.name : ``;
      base$3 = ` [Function` + n$4 + `]`;
    }
    if (isRegExp$2(value) && (base$3 = ` ` + RegExp.prototype.toString.call(value)), isDate$3(value) && (base$3 = ` ` + Date.prototype.toUTCString.call(value)), isError2(value) && (base$3 = ` ` + formatError(value)), keys$10.length === 0 && (!array || value.length == 0)) return braces[0] + base$3 + braces[1];
    if (recurseTimes < 0) return isRegExp$2(value) ? ctx.stylize(RegExp.prototype.toString.call(value), `regexp`) : ctx.stylize(`[Object]`, `special`);
    ctx.seen.push(value);
    var output;
    return output = array ? formatArray(ctx, value, recurseTimes, visibleKeys, keys$10) : keys$10.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    }), ctx.seen.pop(), reduceToSingleString(output, base$3, braces);
  }
  function formatPrimitive(ctx, value) {
    if (isUndefined$4(value)) return ctx.stylize(`undefined`, `undefined`);
    if (isString$19(value)) {
      var simple$2 = `'` + JSON.stringify(value).replace(/^"|"$/g, ``).replace(/'/g, `\\'`).replace(/\\"/g, `"`) + `'`;
      return ctx.stylize(simple$2, `string`);
    }
    if (isNumber$5(value)) return ctx.stylize(`` + value, `number`);
    if (isBoolean$2(value)) return ctx.stylize(`` + value, `boolean`);
    if (isNull(value)) return ctx.stylize(`null`, `null`);
  }
  function formatError(value) {
    return `[` + Error.prototype.toString.call(value) + `]`;
  }
  function formatArray(ctx, value, recurseTimes, visibleKeys, keys$10) {
    for (var output = [], i$4 = 0, l$4 = value.length; i$4 < l$4; ++i$4) hasOwnProperty$21(value, String(i$4)) ? output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i$4), true)) : output.push(``);
    return keys$10.forEach(function(key) {
      key.match(/^\d+$/) || output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    }), output;
  }
  function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name$2, str, desc$1;
    if (desc$1 = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] }, desc$1.get ? str = desc$1.set ? ctx.stylize(`[Getter/Setter]`, `special`) : ctx.stylize(`[Getter]`, `special`) : desc$1.set && (str = ctx.stylize(`[Setter]`, `special`)), hasOwnProperty$21(visibleKeys, key) || (name$2 = `[` + key + `]`), str || (ctx.seen.indexOf(desc$1.value) < 0 ? (str = isNull(recurseTimes) ? formatValue(ctx, desc$1.value, null) : formatValue(ctx, desc$1.value, recurseTimes - 1), str.indexOf(`
`) > -1 && (str = array ? str.split(`
`).map(function(line) {
      return `  ` + line;
    }).join(`
`).slice(2) : `
` + str.split(`
`).map(function(line) {
      return `   ` + line;
    }).join(`
`))) : str = ctx.stylize(`[Circular]`, `special`)), isUndefined$4(name$2)) {
      if (array && key.match(/^\d+$/)) return str;
      name$2 = JSON.stringify(`` + key), name$2.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (name$2 = name$2.slice(1, -1), name$2 = ctx.stylize(name$2, `name`)) : (name$2 = name$2.replace(/'/g, `\\'`).replace(/\\"/g, `"`).replace(/(^"|"$)/g, `'`), name$2 = ctx.stylize(name$2, `string`));
    }
    return name$2 + `: ` + str;
  }
  function reduceToSingleString(output, base$3, braces) {
    var numLinesEst = 0, length = output.reduce(function(prev, cur) {
      return numLinesEst++, cur.indexOf(`
`) >= 0 && numLinesEst++, prev + cur.replace(/\u001b\[\d\d?m/g, ``).length + 1;
    }, 0);
    return length > 60 ? braces[0] + (base$3 === `` ? `` : base$3 + `
 `) + ` ` + output.join(`,
  `) + ` ` + braces[1] : braces[0] + base$3 + ` ` + output.join(`, `) + ` ` + braces[1];
  }
  exports$12.types = require_types();
  function isArray$22(ar) {
    return Array.isArray(ar);
  }
  exports$12.isArray = isArray$22;
  function isBoolean$2(arg) {
    return typeof arg == `boolean`;
  }
  exports$12.isBoolean = isBoolean$2;
  function isNull(arg) {
    return arg === null;
  }
  exports$12.isNull = isNull;
  function isNullOrUndefined(arg) {
    return arg == null;
  }
  exports$12.isNullOrUndefined = isNullOrUndefined;
  function isNumber$5(arg) {
    return typeof arg == `number`;
  }
  exports$12.isNumber = isNumber$5;
  function isString$19(arg) {
    return typeof arg == `string`;
  }
  exports$12.isString = isString$19;
  function isSymbol$5(arg) {
    return typeof arg == `symbol`;
  }
  exports$12.isSymbol = isSymbol$5;
  function isUndefined$4(arg) {
    return arg === void 0;
  }
  exports$12.isUndefined = isUndefined$4;
  function isRegExp$2(re$5) {
    return isObject$25(re$5) && objectToString$3(re$5) === `[object RegExp]`;
  }
  exports$12.isRegExp = isRegExp$2, exports$12.types.isRegExp = isRegExp$2;
  function isObject$25(arg) {
    return typeof arg == `object` && !!arg;
  }
  exports$12.isObject = isObject$25;
  function isDate$3(d$12) {
    return isObject$25(d$12) && objectToString$3(d$12) === `[object Date]`;
  }
  exports$12.isDate = isDate$3, exports$12.types.isDate = isDate$3;
  function isError2(e$22) {
    return isObject$25(e$22) && (objectToString$3(e$22) === `[object Error]` || e$22 instanceof Error);
  }
  exports$12.isError = isError2, exports$12.types.isNativeError = isError2;
  function isFunction$11(arg) {
    return typeof arg == `function`;
  }
  exports$12.isFunction = isFunction$11;
  function isPrimitive2(arg) {
    return arg === null || typeof arg == `boolean` || typeof arg == `number` || typeof arg == `string` || typeof arg == `symbol` || arg === void 0;
  }
  exports$12.isPrimitive = isPrimitive2, exports$12.isBuffer = require_isBuffer$1();
  function objectToString$3(o$2) {
    return Object.prototype.toString.call(o$2);
  }
  function pad(n$4) {
    return n$4 < 10 ? `0` + n$4.toString(10) : n$4.toString(10);
  }
  var months$2 = [`Jan`, `Feb`, `Mar`, `Apr`, `May`, `Jun`, `Jul`, `Aug`, `Sep`, `Oct`, `Nov`, `Dec`];
  function timestamp() {
    var d$12 = /* @__PURE__ */ new Date(), time = [pad(d$12.getHours()), pad(d$12.getMinutes()), pad(d$12.getSeconds())].join(`:`);
    return [d$12.getDate(), months$2[d$12.getMonth()], time].join(` `);
  }
  exports$12.log = function() {
    console.log(`%s - %s`, timestamp(), exports$12.format.apply(exports$12, arguments));
  }, exports$12.inherits = require_inherits(), exports$12._extend = function(origin, add) {
    if (!add || !isObject$25(add)) return origin;
    for (var keys$10 = Object.keys(add), i$4 = keys$10.length; i$4--; ) origin[keys$10[i$4]] = add[keys$10[i$4]];
    return origin;
  };
  function hasOwnProperty$21(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  }
  var kCustomPromisifiedSymbol = typeof Symbol < `u` ? Symbol(`util.promisify.custom`) : void 0;
  exports$12.promisify = function(original) {
    if (typeof original != `function`) throw TypeError(`The "original" argument must be of type Function`);
    if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
      var fn$1 = original[kCustomPromisifiedSymbol];
      if (typeof fn$1 != `function`) throw TypeError(`The "util.promisify.custom" argument must be of type Function`);
      return Object.defineProperty(fn$1, kCustomPromisifiedSymbol, { value: fn$1, enumerable: false, writable: false, configurable: true }), fn$1;
    }
    function fn$1() {
      for (var promiseResolve, promiseReject, promise = new Promise(function(resolve, reject$2) {
        promiseResolve = resolve, promiseReject = reject$2;
      }), args$1 = [], i$4 = 0; i$4 < arguments.length; i$4++) args$1.push(arguments[i$4]);
      args$1.push(function(err$1, value) {
        err$1 ? promiseReject(err$1) : promiseResolve(value);
      });
      try {
        original.apply(this, args$1);
      } catch (err$1) {
        promiseReject(err$1);
      }
      return promise;
    }
    return Object.setPrototypeOf(fn$1, Object.getPrototypeOf(original)), kCustomPromisifiedSymbol && Object.defineProperty(fn$1, kCustomPromisifiedSymbol, { value: fn$1, enumerable: false, writable: false, configurable: true }), Object.defineProperties(fn$1, getOwnPropertyDescriptors(original));
  }, exports$12.promisify.custom = kCustomPromisifiedSymbol;
  function callbackifyOnRejected(reason, cb) {
    if (!reason) {
      var newReason = Error(`Promise was rejected with a falsy value`);
      newReason.reason = reason, reason = newReason;
    }
    return cb(reason);
  }
  function callbackify$2(original) {
    if (typeof original != `function`) throw TypeError(`The "original" argument must be of type Function`);
    function callbackified() {
      for (var args$1 = [], i$4 = 0; i$4 < arguments.length; i$4++) args$1.push(arguments[i$4]);
      var maybeCb = args$1.pop();
      if (typeof maybeCb != `function`) throw TypeError(`The last argument must be of type Function`);
      var self$1 = this, cb = function() {
        return maybeCb.apply(self$1, arguments);
      };
      original.apply(this, args$1).then(function(ret) {
        process$1.nextTick(cb.bind(null, null, ret));
      }, function(rej) {
        process$1.nextTick(callbackifyOnRejected.bind(null, rej, cb));
      });
    }
    return Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original)), Object.defineProperties(callbackified, getOwnPropertyDescriptors(original)), callbackified;
  }
  exports$12.callbackify = callbackify$2;
});
function analyzeEmail(email, options) {
  return validateEmail(email, options);
}
function isEmailValid$1(email, options) {
  return !validateEmail(email, options);
}
function validateEmail(email, options = {}) {
  if (typeof email != `string`) throw Error(`Invalid input: email must be a string`);
  if (!email) return errorCode(`EMPTY_STRING`);
  let ascii$2 = !NON_ASCII_RX.test(email);
  if (!ascii$2) {
    if (options.allowUnicode === false) return errorCode(`FORBIDDEN_UNICODE`);
    email = email.normalize(`NFC`);
  }
  let parts = email.split(`@`);
  if (parts.length !== 2) return parts.length > 2 ? errorCode(`MULTIPLE_AT_CHAR`) : errorCode(`MISSING_AT_CHAR`);
  let [local, domain] = parts;
  if (!local) return errorCode(`EMPTY_LOCAL`);
  if (!options.ignoreLength) {
    if (email.length > 254) return errorCode(`ADDRESS_TOO_LONG`);
    if (ENCODER_IMPL.encode(local).length > 64) return errorCode(`LOCAL_TOO_LONG`);
  }
  return validateLocal(local, ascii$2) || analyzeDomain(domain, options);
}
function validateLocal(local, ascii$2) {
  let segments = local.split(`.`);
  for (let segment of segments) {
    if (!segment.length) return errorCode(`EMPTY_LOCAL_SEGMENT`);
    if (ascii$2) {
      if (!ATEXT_RX.test(segment)) return errorCode(`INVALID_LOCAL_CHARS`);
      continue;
    }
    for (let char of segment) {
      if (ATEXT_RX.test(char)) continue;
      let binary = toBinary(char);
      if (!ATOM_RX.test(binary)) return errorCode(`INVALID_LOCAL_CHARS`);
    }
  }
  return null;
}
function toBinary(char) {
  return Array.from(ENCODER_IMPL.encode(char), (v$1) => String.fromCharCode(v$1)).join(``);
}
var import_util$2, NON_ASCII_RX, ENCODER_IMPL, ATEXT_RX, ATOM_RX, init_email = __esmMin(() => {
  import_util$2 = __toESM(require_util()), init_domain(), NON_ASCII_RX = /[^\x00-\x7f]/, ENCODER_IMPL = new (import_util$2.TextEncoder || TextEncoder)(), ATEXT_RX = /^[\w!#\$%&'\*\+\-/=\?\^`\{\|\}~]+$/, ATOM_RX = new RegExp([`(?:[\\xc2-\\xdf][\\x80-\\xbf])`, `(?:\\xe0[\\xa0-\\xbf][\\x80-\\xbf])|(?:[\\xe1-\\xec][\\x80-\\xbf]{2})|(?:\\xed[\\x80-\\x9f][\\x80-\\xbf])|(?:[\\xee-\\xef][\\x80-\\xbf]{2})`, `(?:\\xf0[\\x90-\\xbf][\\x80-\\xbf]{2})|(?:[\\xf1-\\xf3][\\x80-\\xbf]{3})|(?:\\xf4[\\x80-\\x8f][\\x80-\\xbf]{2})`].join(`|`));
});
function generate$1() {
  let rfc3986$1 = {}, hexDigit = `\\dA-Fa-f`, hexDigitOnly = `[` + hexDigit + `]`, unreserved = `\\w-\\.~`, subDelims = `!\\$&'\\(\\)\\*\\+,;=`, pctEncoded = `%` + hexDigit, pchar = unreserved + pctEncoded + subDelims + `:@`, pcharOnly = `[` + pchar + `]`, decOctect = `(?:0{0,2}\\d|0?[1-9]\\d|1\\d\\d|2[0-4]\\d|25[0-5])`;
  rfc3986$1.ipv4address = `(?:` + decOctect + `\\.){3}(?:0{0,2}\\d|0?[1-9]\\d|1\\d\\d|2[0-4]\\d|25[0-5])`;
  let h16 = hexDigitOnly + `{1,4}`, ls32 = `(?:` + h16 + `:[\\dA-Fa-f]{1,4}|` + rfc3986$1.ipv4address + `)`, IPv6SixHex = `(?:` + h16 + `:){6}` + ls32, IPv6FiveHex = `::(?:` + h16 + `:){5}` + ls32, IPv6FourHex = `(?:` + h16 + `)?::(?:[\\dA-Fa-f]{1,4}:){4}` + ls32, IPv6ThreeHex = `(?:(?:` + h16 + `:){0,1}[\\dA-Fa-f]{1,4})?::(?:[\\dA-Fa-f]{1,4}:){3}` + ls32, IPv6TwoHex = `(?:(?:` + h16 + `:){0,2}[\\dA-Fa-f]{1,4})?::(?:[\\dA-Fa-f]{1,4}:){2}` + ls32, IPv6OneHex = `(?:(?:` + h16 + `:){0,3}[\\dA-Fa-f]{1,4})?::[\\dA-Fa-f]{1,4}:` + ls32, IPv6NoneHex = `(?:(?:` + h16 + `:){0,4}[\\dA-Fa-f]{1,4})?::` + ls32;
  rfc3986$1.ipv4Cidr = `(?:\\d|[1-2]\\d|3[0-2])`, rfc3986$1.ipv6Cidr = `(?:0{0,2}\\d|0?[1-9]\\d|1[01]\\d|12[0-8])`, rfc3986$1.ipv6address = `(?:` + IPv6SixHex + `|` + IPv6FiveHex + `|` + IPv6FourHex + `|` + IPv6ThreeHex + `|` + IPv6TwoHex + `|` + IPv6OneHex + `|` + IPv6NoneHex + `|(?:(?:[\\dA-Fa-f]{1,4}:){0,5}[\\dA-Fa-f]{1,4})?::[\\dA-Fa-f]{1,4}|(?:(?:[\\dA-Fa-f]{1,4}:){0,6}[\\dA-Fa-f]{1,4})?::)`, rfc3986$1.ipvFuture = `v` + hexDigitOnly + `+\\.[\\w-\\.~!\\$&'\\(\\)\\*\\+,;=:]+`, rfc3986$1.scheme = `[a-zA-Z][a-zA-Z\\d+-\\.]*`, rfc3986$1.schemeRegex = new RegExp(rfc3986$1.scheme);
  let userinfo = `[` + unreserved + pctEncoded + subDelims + `:]*`, IPLiteral = `\\[(?:` + rfc3986$1.ipv6address + `|` + rfc3986$1.ipvFuture + `)\\]`, host = `(?:` + IPLiteral + `|` + rfc3986$1.ipv4address + `|[\\w-\\.~%\\dA-Fa-f!\\$&'\\(\\)\\*\\+,;=]{1,255})`, authority = `(?:` + userinfo + `@)?` + host + `(?::\\d*)?`, authorityCapture = `(?:` + userinfo + `@)?(` + host + `)(?::\\d*)?`, segment = pcharOnly + `*`, segmentNz = pcharOnly + `+`, segmentNzNc = `[` + unreserved + pctEncoded + subDelims + `@]+`, pathAbEmpty = `(?:\\/` + segment + `)*`, pathAbsolute = `\\/(?:` + segmentNz + pathAbEmpty + `)?`, pathRootless = segmentNz + pathAbEmpty, pathNoScheme = segmentNzNc + pathAbEmpty, pathAbNoAuthority = `(?:\\/\\/\\/` + segment + pathAbEmpty + `)`;
  return rfc3986$1.hierPart = `(?:(?:\\/\\/` + authority + pathAbEmpty + `)|` + pathAbsolute + `|` + pathRootless + `|` + pathAbNoAuthority + `)`, rfc3986$1.hierPartCapture = `(?:(?:\\/\\/` + authorityCapture + pathAbEmpty + `)|` + pathAbsolute + `|` + pathRootless + `)`, rfc3986$1.relativeRef = `(?:(?:\\/\\/` + authority + pathAbEmpty + `)|` + pathAbsolute + `|` + pathNoScheme + `|)`, rfc3986$1.relativeRefCapture = `(?:(?:\\/\\/` + authorityCapture + pathAbEmpty + `)|` + pathAbsolute + `|` + pathNoScheme + `|)`, rfc3986$1.query = `[` + pchar + `\\/\\?]*(?=#|$)`, rfc3986$1.queryWithSquareBrackets = `[` + pchar + `\\[\\]\\/\\?]*(?=#|$)`, rfc3986$1.fragment = `[` + pchar + `\\/\\?]*`, rfc3986$1;
}
function createRegex(options) {
  let rfc = rfc3986, query = options.allowQuerySquareBrackets ? rfc.queryWithSquareBrackets : rfc.query, suffix = `(?:\\?` + query + `)?(?:#` + rfc.fragment + `)?`, relative = options.domain ? rfc.relativeRefCapture : rfc.relativeRef;
  if (options.relativeOnly) return wrap$1(relative + suffix);
  let customScheme = ``;
  if (options.scheme) {
    (0, import_assert.default)(options.scheme instanceof RegExp || typeof options.scheme == `string` || Array.isArray(options.scheme), `scheme must be a RegExp, String, or Array`);
    let schemes = [].concat(options.scheme);
    (0, import_assert.default)(schemes.length >= 1, `scheme must have at least 1 scheme specified`);
    let selections = [];
    for (let i$4 = 0; i$4 < schemes.length; ++i$4) {
      let scheme$1 = schemes[i$4];
      (0, import_assert.default)(scheme$1 instanceof RegExp || typeof scheme$1 == `string`, `scheme at position ` + i$4 + ` must be a RegExp or String`), scheme$1 instanceof RegExp ? selections.push(scheme$1.source.toString()) : ((0, import_assert.default)(rfc.schemeRegex.test(scheme$1), `scheme at position ` + i$4 + ` must be a valid scheme`), selections.push((0, import_escapeRegex.default)(scheme$1)));
    }
    customScheme = selections.join(`|`);
  }
  let scheme = customScheme ? `(?:` + customScheme + `)` : rfc.scheme, absolute = `(?:` + scheme + `:` + (options.domain ? rfc.hierPartCapture : rfc.hierPart) + `)`, prefix = options.allowRelative ? `(?:` + absolute + `|` + relative + `)` : absolute;
  return wrap$1(prefix + suffix, customScheme);
}
function wrap$1(raw, scheme = null) {
  return raw = `(?=.)(?!https?:/(?:$|[^/]))(?!https?:///)(?!https?:[^/])${raw}`, { raw, regex: RegExp(`^${raw}$`), scheme };
}
function uriRegex$1(options = {}) {
  return options.scheme || options.allowRelative || options.relativeOnly || options.allowQuerySquareBrackets || options.domain ? createRegex(options) : genericUriRegex;
}
var rfc3986, ipVersions, genericUriRegex, init_uri = __esmMin(() => {
  init_lib(), rfc3986 = generate$1(), ipVersions = { v4Cidr: rfc3986.ipv4Cidr, v6Cidr: rfc3986.ipv6Cidr, ipv4: rfc3986.ipv4address, ipv6: rfc3986.ipv6address, ipvfuture: rfc3986.ipvFuture }, genericUriRegex = createRegex({});
});
function ipRegex$1(options = {}) {
  let cidr = options.cidr || `optional`;
  (0, import_assert.default)([`required`, `optional`, `forbidden`].includes(cidr), `options.cidr must be one of required, optional, forbidden`), (0, import_assert.default)(options.version === void 0 || typeof options.version == `string` || Array.isArray(options.version), `options.version must be a string or an array of string`);
  let versions = options.version || [`ipv4`, `ipv6`, `ipvfuture`];
  Array.isArray(versions) || (versions = [versions]), (0, import_assert.default)(versions.length >= 1, `options.version must have at least 1 version specified`);
  for (let version$4 of versions) (0, import_assert.default)(typeof version$4 == `string` && version$4 === version$4.toLowerCase(), `Invalid options.version value`), (0, import_assert.default)([`ipv4`, `ipv6`, `ipvfuture`].includes(version$4), `options.version contains unknown version ` + version$4 + ` - must be one of ipv4, ipv6, ipvfuture`);
  versions = Array.from(new Set(versions));
  let parts = versions.map((version$4) => {
    if (cidr === `forbidden`) return ipVersions[version$4];
    let cidrpart = `\\/${version$4 === `ipv4` ? ipVersions.v4Cidr : ipVersions.v6Cidr}`;
    return cidr === `required` ? `${ipVersions[version$4]}${cidrpart}` : `${ipVersions[version$4]}(?:${cidrpart})?`;
  }), raw = `(?:${parts.join(`|`)})`, regex = RegExp(`^${raw}$`);
  return { cidr, versions, regex, raw };
}
var init_ip = __esmMin(() => {
  init_lib(), init_uri();
});
const HEX = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, a: 10, A: 10, b: 11, B: 11, c: 12, C: 12, d: 13, D: 13, e: 14, E: 14, f: 15, F: 15 }, UTF8 = { accept: 12, reject: 0, data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 8, 7, 7, 10, 9, 9, 9, 11, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 12, 0, 0, 0, 0, 24, 36, 48, 60, 72, 84, 96, 0, 12, 12, 12, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0, 0, 24, 24, 24, 0, 0, 0, 0, 0, 0, 0, 0, 0, 24, 24, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 48, 48, 48, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 48, 48, 0, 0, 0, 0, 0, 0, 0, 0, 0, 48, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 127, 63, 63, 63, 0, 31, 15, 15, 15, 7, 7, 7] };
function uriDecode(string) {
  let percentPos = string.indexOf(`%`);
  if (percentPos === -1) return string;
  let decoded = ``, last$2 = 0, codepoint = 0, startOfOctets = percentPos, state = UTF8.accept;
  for (; percentPos > -1 && percentPos < string.length; ) {
    let high = resolveHex(string[percentPos + 1], 4), low = resolveHex(string[percentPos + 2], 0), byte = high | low, type = UTF8.data[byte];
    if (state = UTF8.data[256 + state + type], codepoint = codepoint << 6 | byte & UTF8.data[364 + type], state === UTF8.accept) {
      decoded += string.slice(last$2, startOfOctets), decoded += codepoint <= 65535 ? String.fromCharCode(codepoint) : String.fromCharCode(55232 + (codepoint >> 10), 56320 + (codepoint & 1023)), codepoint = 0, last$2 = percentPos + 3, percentPos = string.indexOf(`%`, last$2), startOfOctets = percentPos;
      continue;
    }
    if (state === UTF8.reject || (percentPos += 3, percentPos >= string.length || string[percentPos] !== `%`)) return null;
  }
  return decoded + string.slice(last$2);
}
function resolveHex(char, shift) {
  let i$4 = HEX[char];
  return i$4 === void 0 ? 255 : i$4 << shift;
}
var esm_exports = {};
__export(esm_exports, { analyzeDomain: () => analyzeDomain, analyzeEmail: () => analyzeEmail, errorCodes: () => errorCodes, ipRegex: () => ipRegex$1, isDomainValid: () => isDomainValid$1, isEmailValid: () => isEmailValid$1, uriDecode: () => uriDecode, uriRegex: () => uriRegex$1, validateDomainOptions: () => validateDomainOptions });
var init_esm = __esmMin(() => {
  init_domain(), init_email(), init_ip(), init_uri();
}), require_tlds = __commonJSMin$1((exports$12) => {
  Object.defineProperty(exports$12, `__esModule`, { value: true }), exports$12.TLDS = `AAA.AARP.ABB.ABBOTT.ABBVIE.ABC.ABLE.ABOGADO.ABUDHABI.AC.ACADEMY.ACCENTURE.ACCOUNTANT.ACCOUNTANTS.ACO.ACTOR.AD.ADS.ADULT.AE.AEG.AERO.AETNA.AF.AFL.AFRICA.AG.AGAKHAN.AGENCY.AI.AIG.AIRBUS.AIRFORCE.AIRTEL.AKDN.AL.ALIBABA.ALIPAY.ALLFINANZ.ALLSTATE.ALLY.ALSACE.ALSTOM.AM.AMAZON.AMERICANEXPRESS.AMERICANFAMILY.AMEX.AMFAM.AMICA.AMSTERDAM.ANALYTICS.ANDROID.ANQUAN.ANZ.AO.AOL.APARTMENTS.APP.APPLE.AQ.AQUARELLE.AR.ARAB.ARAMCO.ARCHI.ARMY.ARPA.ART.ARTE.AS.ASDA.ASIA.ASSOCIATES.AT.ATHLETA.ATTORNEY.AU.AUCTION.AUDI.AUDIBLE.AUDIO.AUSPOST.AUTHOR.AUTO.AUTOS.AW.AWS.AX.AXA.AZ.AZURE.BA.BABY.BAIDU.BANAMEX.BAND.BANK.BAR.BARCELONA.BARCLAYCARD.BARCLAYS.BAREFOOT.BARGAINS.BASEBALL.BASKETBALL.BAUHAUS.BAYERN.BB.BBC.BBT.BBVA.BCG.BCN.BD.BE.BEATS.BEAUTY.BEER.BERLIN.BEST.BESTBUY.BET.BF.BG.BH.BHARTI.BI.BIBLE.BID.BIKE.BING.BINGO.BIO.BIZ.BJ.BLACK.BLACKFRIDAY.BLOCKBUSTER.BLOG.BLOOMBERG.BLUE.BM.BMS.BMW.BN.BNPPARIBAS.BO.BOATS.BOEHRINGER.BOFA.BOM.BOND.BOO.BOOK.BOOKING.BOSCH.BOSTIK.BOSTON.BOT.BOUTIQUE.BOX.BR.BRADESCO.BRIDGESTONE.BROADWAY.BROKER.BROTHER.BRUSSELS.BS.BT.BUILD.BUILDERS.BUSINESS.BUY.BUZZ.BV.BW.BY.BZ.BZH.CA.CAB.CAFE.CAL.CALL.CALVINKLEIN.CAM.CAMERA.CAMP.CANON.CAPETOWN.CAPITAL.CAPITALONE.CAR.CARAVAN.CARDS.CARE.CAREER.CAREERS.CARS.CASA.CASE.CASH.CASINO.CAT.CATERING.CATHOLIC.CBA.CBN.CBRE.CC.CD.CENTER.CEO.CERN.CF.CFA.CFD.CG.CH.CHANEL.CHANNEL.CHARITY.CHASE.CHAT.CHEAP.CHINTAI.CHRISTMAS.CHROME.CHURCH.CI.CIPRIANI.CIRCLE.CISCO.CITADEL.CITI.CITIC.CITY.CK.CL.CLAIMS.CLEANING.CLICK.CLINIC.CLINIQUE.CLOTHING.CLOUD.CLUB.CLUBMED.CM.CN.CO.COACH.CODES.COFFEE.COLLEGE.COLOGNE.COM.COMMBANK.COMMUNITY.COMPANY.COMPARE.COMPUTER.COMSEC.CONDOS.CONSTRUCTION.CONSULTING.CONTACT.CONTRACTORS.COOKING.COOL.COOP.CORSICA.COUNTRY.COUPON.COUPONS.COURSES.CPA.CR.CREDIT.CREDITCARD.CREDITUNION.CRICKET.CROWN.CRS.CRUISE.CRUISES.CU.CUISINELLA.CV.CW.CX.CY.CYMRU.CYOU.CZ.DAD.DANCE.DATA.DATE.DATING.DATSUN.DAY.DCLK.DDS.DE.DEAL.DEALER.DEALS.DEGREE.DELIVERY.DELL.DELOITTE.DELTA.DEMOCRAT.DENTAL.DENTIST.DESI.DESIGN.DEV.DHL.DIAMONDS.DIET.DIGITAL.DIRECT.DIRECTORY.DISCOUNT.DISCOVER.DISH.DIY.DJ.DK.DM.DNP.DO.DOCS.DOCTOR.DOG.DOMAINS.DOT.DOWNLOAD.DRIVE.DTV.DUBAI.DUPONT.DURBAN.DVAG.DVR.DZ.EARTH.EAT.EC.ECO.EDEKA.EDU.EDUCATION.EE.EG.EMAIL.EMERCK.ENERGY.ENGINEER.ENGINEERING.ENTERPRISES.EPSON.EQUIPMENT.ER.ERICSSON.ERNI.ES.ESQ.ESTATE.ET.EU.EUROVISION.EUS.EVENTS.EXCHANGE.EXPERT.EXPOSED.EXPRESS.EXTRASPACE.FAGE.FAIL.FAIRWINDS.FAITH.FAMILY.FAN.FANS.FARM.FARMERS.FASHION.FAST.FEDEX.FEEDBACK.FERRARI.FERRERO.FI.FIDELITY.FIDO.FILM.FINAL.FINANCE.FINANCIAL.FIRE.FIRESTONE.FIRMDALE.FISH.FISHING.FIT.FITNESS.FJ.FK.FLICKR.FLIGHTS.FLIR.FLORIST.FLOWERS.FLY.FM.FO.FOO.FOOD.FOOTBALL.FORD.FOREX.FORSALE.FORUM.FOUNDATION.FOX.FR.FREE.FRESENIUS.FRL.FROGANS.FRONTIER.FTR.FUJITSU.FUN.FUND.FURNITURE.FUTBOL.FYI.GA.GAL.GALLERY.GALLO.GALLUP.GAME.GAMES.GAP.GARDEN.GAY.GB.GBIZ.GD.GDN.GE.GEA.GENT.GENTING.GEORGE.GF.GG.GGEE.GH.GI.GIFT.GIFTS.GIVES.GIVING.GL.GLASS.GLE.GLOBAL.GLOBO.GM.GMAIL.GMBH.GMO.GMX.GN.GODADDY.GOLD.GOLDPOINT.GOLF.GOO.GOODYEAR.GOOG.GOOGLE.GOP.GOT.GOV.GP.GQ.GR.GRAINGER.GRAPHICS.GRATIS.GREEN.GRIPE.GROCERY.GROUP.GS.GT.GU.GUCCI.GUGE.GUIDE.GUITARS.GURU.GW.GY.HAIR.HAMBURG.HANGOUT.HAUS.HBO.HDFC.HDFCBANK.HEALTH.HEALTHCARE.HELP.HELSINKI.HERE.HERMES.HIPHOP.HISAMITSU.HITACHI.HIV.HK.HKT.HM.HN.HOCKEY.HOLDINGS.HOLIDAY.HOMEDEPOT.HOMEGOODS.HOMES.HOMESENSE.HONDA.HORSE.HOSPITAL.HOST.HOSTING.HOT.HOTELS.HOTMAIL.HOUSE.HOW.HR.HSBC.HT.HU.HUGHES.HYATT.HYUNDAI.IBM.ICBC.ICE.ICU.ID.IE.IEEE.IFM.IKANO.IL.IM.IMAMAT.IMDB.IMMO.IMMOBILIEN.IN.INC.INDUSTRIES.INFINITI.INFO.ING.INK.INSTITUTE.INSURANCE.INSURE.INT.INTERNATIONAL.INTUIT.INVESTMENTS.IO.IPIRANGA.IQ.IR.IRISH.IS.ISMAILI.IST.ISTANBUL.IT.ITAU.ITV.JAGUAR.JAVA.JCB.JE.JEEP.JETZT.JEWELRY.JIO.JLL.JM.JMP.JNJ.JO.JOBS.JOBURG.JOT.JOY.JP.JPMORGAN.JPRS.JUEGOS.JUNIPER.KAUFEN.KDDI.KE.KERRYHOTELS.KERRYPROPERTIES.KFH.KG.KH.KI.KIA.KIDS.KIM.KINDLE.KITCHEN.KIWI.KM.KN.KOELN.KOMATSU.KOSHER.KP.KPMG.KPN.KR.KRD.KRED.KUOKGROUP.KW.KY.KYOTO.KZ.LA.LACAIXA.LAMBORGHINI.LAMER.LAND.LANDROVER.LANXESS.LASALLE.LAT.LATINO.LATROBE.LAW.LAWYER.LB.LC.LDS.LEASE.LECLERC.LEFRAK.LEGAL.LEGO.LEXUS.LGBT.LI.LIDL.LIFE.LIFEINSURANCE.LIFESTYLE.LIGHTING.LIKE.LILLY.LIMITED.LIMO.LINCOLN.LINK.LIVE.LIVING.LK.LLC.LLP.LOAN.LOANS.LOCKER.LOCUS.LOL.LONDON.LOTTE.LOTTO.LOVE.LPL.LPLFINANCIAL.LR.LS.LT.LTD.LTDA.LU.LUNDBECK.LUXE.LUXURY.LV.LY.MA.MADRID.MAIF.MAISON.MAKEUP.MAN.MANAGEMENT.MANGO.MAP.MARKET.MARKETING.MARKETS.MARRIOTT.MARSHALLS.MATTEL.MBA.MC.MCKINSEY.MD.ME.MED.MEDIA.MEET.MELBOURNE.MEME.MEMORIAL.MEN.MENU.MERCKMSD.MG.MH.MIAMI.MICROSOFT.MIL.MINI.MINT.MIT.MITSUBISHI.MK.ML.MLB.MLS.MM.MMA.MN.MO.MOBI.MOBILE.MODA.MOE.MOI.MOM.MONASH.MONEY.MONSTER.MORMON.MORTGAGE.MOSCOW.MOTO.MOTORCYCLES.MOV.MOVIE.MP.MQ.MR.MS.MSD.MT.MTN.MTR.MU.MUSEUM.MUSIC.MV.MW.MX.MY.MZ.NA.NAB.NAGOYA.NAME.NAVY.NBA.NC.NE.NEC.NET.NETBANK.NETFLIX.NETWORK.NEUSTAR.NEW.NEWS.NEXT.NEXTDIRECT.NEXUS.NF.NFL.NG.NGO.NHK.NI.NICO.NIKE.NIKON.NINJA.NISSAN.NISSAY.NL.NO.NOKIA.NORTON.NOW.NOWRUZ.NOWTV.NP.NR.NRA.NRW.NTT.NU.NYC.NZ.OBI.OBSERVER.OFFICE.OKINAWA.OLAYAN.OLAYANGROUP.OLLO.OM.OMEGA.ONE.ONG.ONL.ONLINE.OOO.OPEN.ORACLE.ORANGE.ORG.ORGANIC.ORIGINS.OSAKA.OTSUKA.OTT.OVH.PA.PAGE.PANASONIC.PARIS.PARS.PARTNERS.PARTS.PARTY.PAY.PCCW.PE.PET.PF.PFIZER.PG.PH.PHARMACY.PHD.PHILIPS.PHONE.PHOTO.PHOTOGRAPHY.PHOTOS.PHYSIO.PICS.PICTET.PICTURES.PID.PIN.PING.PINK.PIONEER.PIZZA.PK.PL.PLACE.PLAY.PLAYSTATION.PLUMBING.PLUS.PM.PN.PNC.POHL.POKER.POLITIE.PORN.POST.PR.PRAXI.PRESS.PRIME.PRO.PROD.PRODUCTIONS.PROF.PROGRESSIVE.PROMO.PROPERTIES.PROPERTY.PROTECTION.PRU.PRUDENTIAL.PS.PT.PUB.PW.PWC.PY.QA.QPON.QUEBEC.QUEST.RACING.RADIO.RE.READ.REALESTATE.REALTOR.REALTY.RECIPES.RED.REDUMBRELLA.REHAB.REISE.REISEN.REIT.RELIANCE.REN.RENT.RENTALS.REPAIR.REPORT.REPUBLICAN.REST.RESTAURANT.REVIEW.REVIEWS.REXROTH.RICH.RICHARDLI.RICOH.RIL.RIO.RIP.RO.ROCKS.RODEO.ROGERS.ROOM.RS.RSVP.RU.RUGBY.RUHR.RUN.RW.RWE.RYUKYU.SA.SAARLAND.SAFE.SAFETY.SAKURA.SALE.SALON.SAMSCLUB.SAMSUNG.SANDVIK.SANDVIKCOROMANT.SANOFI.SAP.SARL.SAS.SAVE.SAXO.SB.SBI.SBS.SC.SCB.SCHAEFFLER.SCHMIDT.SCHOLARSHIPS.SCHOOL.SCHULE.SCHWARZ.SCIENCE.SCOT.SD.SE.SEARCH.SEAT.SECURE.SECURITY.SEEK.SELECT.SENER.SERVICES.SEVEN.SEW.SEX.SEXY.SFR.SG.SH.SHANGRILA.SHARP.SHELL.SHIA.SHIKSHA.SHOES.SHOP.SHOPPING.SHOUJI.SHOW.SI.SILK.SINA.SINGLES.SITE.SJ.SK.SKI.SKIN.SKY.SKYPE.SL.SLING.SM.SMART.SMILE.SN.SNCF.SO.SOCCER.SOCIAL.SOFTBANK.SOFTWARE.SOHU.SOLAR.SOLUTIONS.SONG.SONY.SOY.SPA.SPACE.SPORT.SPOT.SR.SRL.SS.ST.STADA.STAPLES.STAR.STATEBANK.STATEFARM.STC.STCGROUP.STOCKHOLM.STORAGE.STORE.STREAM.STUDIO.STUDY.STYLE.SU.SUCKS.SUPPLIES.SUPPLY.SUPPORT.SURF.SURGERY.SUZUKI.SV.SWATCH.SWISS.SX.SY.SYDNEY.SYSTEMS.SZ.TAB.TAIPEI.TALK.TAOBAO.TARGET.TATAMOTORS.TATAR.TATTOO.TAX.TAXI.TC.TCI.TD.TDK.TEAM.TECH.TECHNOLOGY.TEL.TEMASEK.TENNIS.TEVA.TF.TG.TH.THD.THEATER.THEATRE.TIAA.TICKETS.TIENDA.TIPS.TIRES.TIROL.TJ.TJMAXX.TJX.TK.TKMAXX.TL.TM.TMALL.TN.TO.TODAY.TOKYO.TOOLS.TOP.TORAY.TOSHIBA.TOTAL.TOURS.TOWN.TOYOTA.TOYS.TR.TRADE.TRADING.TRAINING.TRAVEL.TRAVELERS.TRAVELERSINSURANCE.TRUST.TRV.TT.TUBE.TUI.TUNES.TUSHU.TV.TVS.TW.TZ.UA.UBANK.UBS.UG.UK.UNICOM.UNIVERSITY.UNO.UOL.UPS.US.UY.UZ.VA.VACATIONS.VANA.VANGUARD.VC.VE.VEGAS.VENTURES.VERISIGN.VERSICHERUNG.VET.VG.VI.VIAJES.VIDEO.VIG.VIKING.VILLAS.VIN.VIP.VIRGIN.VISA.VISION.VIVA.VIVO.VLAANDEREN.VN.VODKA.VOLVO.VOTE.VOTING.VOTO.VOYAGE.VU.WALES.WALMART.WALTER.WANG.WANGGOU.WATCH.WATCHES.WEATHER.WEATHERCHANNEL.WEBCAM.WEBER.WEBSITE.WED.WEDDING.WEIBO.WEIR.WF.WHOSWHO.WIEN.WIKI.WILLIAMHILL.WIN.WINDOWS.WINE.WINNERS.WME.WOLTERSKLUWER.WOODSIDE.WORK.WORKS.WORLD.WOW.WS.WTC.WTF.XBOX.XEROX.XIHUAN.XIN.XN--11B4C3D.XN--1CK2E1B.XN--1QQW23A.XN--2SCRJ9C.XN--30RR7Y.XN--3BST00M.XN--3DS443G.XN--3E0B707E.XN--3HCRJ9C.XN--3PXU8K.XN--42C2D9A.XN--45BR5CYL.XN--45BRJ9C.XN--45Q11C.XN--4DBRK0CE.XN--4GBRIM.XN--54B7FTA0CC.XN--55QW42G.XN--55QX5D.XN--5SU34J936BGSG.XN--5TZM5G.XN--6FRZ82G.XN--6QQ986B3XL.XN--80ADXHKS.XN--80AO21A.XN--80AQECDR1A.XN--80ASEHDB.XN--80ASWG.XN--8Y0A063A.XN--90A3AC.XN--90AE.XN--90AIS.XN--9DBQ2A.XN--9ET52U.XN--9KRT00A.XN--B4W605FERD.XN--BCK1B9A5DRE4C.XN--C1AVG.XN--C2BR7G.XN--CCK2B3B.XN--CCKWCXETD.XN--CG4BKI.XN--CLCHC0EA0B2G2A9GCD.XN--CZR694B.XN--CZRS0T.XN--CZRU2D.XN--D1ACJ3B.XN--D1ALF.XN--E1A4C.XN--ECKVDTC9D.XN--EFVY88H.XN--FCT429K.XN--FHBEI.XN--FIQ228C5HS.XN--FIQ64B.XN--FIQS8S.XN--FIQZ9S.XN--FJQ720A.XN--FLW351E.XN--FPCRJ9C3D.XN--FZC2C9E2C.XN--FZYS8D69UVGM.XN--G2XX48C.XN--GCKR3F0F.XN--GECRJ9C.XN--GK3AT1E.XN--H2BREG3EVE.XN--H2BRJ9C.XN--H2BRJ9C8C.XN--HXT814E.XN--I1B6B1A6A2E.XN--IMR513N.XN--IO0A7I.XN--J1AEF.XN--J1AMH.XN--J6W193G.XN--JLQ480N2RG.XN--JVR189M.XN--KCRX77D1X4A.XN--KPRW13D.XN--KPRY57D.XN--KPUT3I.XN--L1ACC.XN--LGBBAT1AD8J.XN--MGB9AWBF.XN--MGBA3A3EJT.XN--MGBA3A4F16A.XN--MGBA7C0BBN0A.XN--MGBAAM7A8H.XN--MGBAB2BD.XN--MGBAH1A3HJKRD.XN--MGBAI9AZGQP6J.XN--MGBAYH7GPA.XN--MGBBH1A.XN--MGBBH1A71E.XN--MGBC0A9AZCG.XN--MGBCA7DZDO.XN--MGBCPQ6GPA1A.XN--MGBERP4A5D4AR.XN--MGBGU82A.XN--MGBI4ECEXP.XN--MGBPL2FH.XN--MGBT3DHD.XN--MGBTX2B.XN--MGBX4CD0AB.XN--MIX891F.XN--MK1BU44C.XN--MXTQ1M.XN--NGBC5AZD.XN--NGBE9E0A.XN--NGBRX.XN--NODE.XN--NQV7F.XN--NQV7FS00EMA.XN--NYQY26A.XN--O3CW4H.XN--OGBPF8FL.XN--OTU796D.XN--P1ACF.XN--P1AI.XN--PGBS0DH.XN--PSSY2U.XN--Q7CE6A.XN--Q9JYB4C.XN--QCKA1PMC.XN--QXA6A.XN--QXAM.XN--RHQV96G.XN--ROVU88B.XN--RVC1E0AM3E.XN--S9BRJ9C.XN--SES554G.XN--T60B56A.XN--TCKWE.XN--TIQ49XQYJ.XN--UNUP4Y.XN--VERMGENSBERATER-CTB.XN--VERMGENSBERATUNG-PWB.XN--VHQUV.XN--VUQ861B.XN--W4R85EL8FHU5DNRA.XN--W4RS40L.XN--WGBH1C.XN--WGBL6A.XN--XHQ521B.XN--XKC2AL3HYE2A.XN--XKC2DL3A5EE0H.XN--Y9A3AQ.XN--YFRO4I67O.XN--YGBI2AMMX.XN--ZFR164B.XXX.XYZ.YACHTS.YAHOO.YAMAXUN.YANDEX.YE.YODOBASHI.YOGA.YOKOHAMA.YOU.YOUTUBE.YT.YUN.ZA.ZAPPOS.ZARA.ZERO.ZIP.ZM.ZONE.ZUERICH.ZW`.split(`.`);
}), require_commonjs = __commonJSMin$1((exports$12) => {
  Object.defineProperty(exports$12, `__esModule`, { value: true });
  let tlds_js_1 = require_tlds();
  exports$12.tlds = new Set(tlds_js_1.TLDS.map((tld) => tld.toLowerCase()));
}), require_string$1 = __commonJSMin$1((exports$12, module2) => {
  init_dist$1();
  let { assert: assert$28, escapeRegex } = require_lib$4(), { isDomainValid, isEmailValid, ipRegex, uriRegex } = (init_esm(), __toCommonJS(esm_exports)), Tlds = require_commonjs(), Any$2 = require_any(), Common$5 = require_common$3(), internals$5 = { tlds: Tlds.tlds instanceof Set ? { tlds: { allow: Tlds.tlds, deny: null } } : false, base64Regex: { true: { true: /^(?:[\w\-]{2}[\w\-]{2})*(?:[\w\-]{2}==|[\w\-]{3}=)?$/, false: /^(?:[A-Za-z0-9+\/]{2}[A-Za-z0-9+\/]{2})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/ }, false: { true: /^(?:[\w\-]{2}[\w\-]{2})*(?:[\w\-]{2}(==)?|[\w\-]{3}=?)?$/, false: /^(?:[A-Za-z0-9+\/]{2}[A-Za-z0-9+\/]{2})*(?:[A-Za-z0-9+\/]{2}(==)?|[A-Za-z0-9+\/]{3}=?)?$/ } }, dataUriRegex: /^data:[\w+.-]+\/[\w+.-]+;((charset=[\w-]+|base64),)?(.*)$/, hexRegex: { withPrefix: /^0x[0-9a-f]+$/i, withOptionalPrefix: /^(?:0x)?[0-9a-f]+$/i, withoutPrefix: /^[0-9a-f]+$/i }, ipRegex: ipRegex({ cidr: `forbidden` }).regex, isoDurationRegex: /^P(?!$)(\d+Y)?(\d+M)?(\d+W)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?$/, guidBrackets: { "{": `}`, "[": `]`, "(": `)`, "": `` }, guidVersions: { uuidv1: `1`, uuidv2: `2`, uuidv3: `3`, uuidv4: `4`, uuidv5: `5`, uuidv6: `6`, uuidv7: `7`, uuidv8: `8` }, guidSeparators: /* @__PURE__ */ new Set([void 0, true, false, `-`, `:`]), normalizationForms: [`NFC`, `NFD`, `NFKC`, `NFKD`] };
  module2.exports = Any$2.extend({ type: `string`, flags: { insensitive: { default: false }, truncate: { default: false } }, terms: { replacements: { init: null } }, coerce: { from: `string`, method(value, { schema: schema$2, state, prefs }) {
    let normalize = schema$2.$_getRule(`normalize`);
    normalize && (value = value.normalize(normalize.args.form));
    let casing = schema$2.$_getRule(`case`);
    casing && (value = casing.args.direction === `upper` ? value.toLocaleUpperCase() : value.toLocaleLowerCase());
    let trim = schema$2.$_getRule(`trim`);
    if (trim && trim.args.enabled && (value = value.trim()), schema$2.$_terms.replacements) for (let replacement of schema$2.$_terms.replacements) value = value.replace(replacement.pattern, replacement.replacement);
    let hex = schema$2.$_getRule(`hex`);
    if (hex && hex.args.options.byteAligned && value.length % 2 != 0 && (value = `0${value}`), schema$2.$_getRule(`isoDate`)) {
      let iso = internals$5.isoDate(value);
      iso && (value = iso);
    }
    if (schema$2._flags.truncate) {
      let rule = schema$2.$_getRule(`max`);
      if (rule) {
        let limit = rule.args.limit;
        if (Common$5.isResolvable(limit) && (limit = limit.resolve(value, state, prefs), !Common$5.limit(limit))) return { value, errors: schema$2.$_createError(`any.ref`, limit, { ref: rule.args.limit, arg: `limit`, reason: `must be a positive integer` }, state, prefs) };
        value = value.slice(0, limit);
      }
    }
    return { value };
  } }, validate(value, { schema: schema$2, error }) {
    if (typeof value != `string`) return { value, errors: error(`string.base`) };
    if (value === ``) {
      let min$1 = schema$2.$_getRule(`min`);
      return min$1 && min$1.args.limit === 0 ? void 0 : { value, errors: error(`string.empty`) };
    }
  }, rules: { alphanum: { method() {
    return this.$_addRule(`alphanum`);
  }, validate(value, helpers$8) {
    return /^[a-zA-Z0-9]+$/.test(value) ? value : helpers$8.error(`string.alphanum`);
  } }, base64: { method(options = {}) {
    return Common$5.assertOptions(options, [`paddingRequired`, `urlSafe`]), options = { urlSafe: false, paddingRequired: true, ...options }, assert$28(typeof options.paddingRequired == `boolean`, `paddingRequired must be boolean`), assert$28(typeof options.urlSafe == `boolean`, `urlSafe must be boolean`), this.$_addRule({ name: `base64`, args: { options } });
  }, validate(value, helpers$8, { options }) {
    let regex = internals$5.base64Regex[options.paddingRequired][options.urlSafe];
    return regex.test(value) ? value : helpers$8.error(`string.base64`);
  } }, case: { method(direction$1) {
    return assert$28([`lower`, `upper`].includes(direction$1), `Invalid case:`, direction$1), this.$_addRule({ name: `case`, args: { direction: direction$1 } });
  }, validate(value, helpers$8, { direction: direction$1 }) {
    return direction$1 === `lower` && value === value.toLocaleLowerCase() || direction$1 === `upper` && value === value.toLocaleUpperCase() ? value : helpers$8.error(`string.${direction$1}case`);
  }, convert: true }, creditCard: { method() {
    return this.$_addRule(`creditCard`);
  }, validate(value, helpers$8) {
    let i$4 = value.length, sum = 0, mul = 1;
    for (; i$4--; ) {
      let char = value.charAt(i$4) * mul;
      sum += char - (char > 9) * 9, mul ^= 3;
    }
    return sum > 0 && sum % 10 == 0 ? value : helpers$8.error(`string.creditCard`);
  } }, dataUri: { method(options = {}) {
    return Common$5.assertOptions(options, [`paddingRequired`]), options = { paddingRequired: true, ...options }, assert$28(typeof options.paddingRequired == `boolean`, `paddingRequired must be boolean`), this.$_addRule({ name: `dataUri`, args: { options } });
  }, validate(value, helpers$8, { options }) {
    let matches = value.match(internals$5.dataUriRegex);
    if (matches) {
      if (!matches[2] || matches[2] !== `base64`) return value;
      let base64regex = internals$5.base64Regex[options.paddingRequired].false;
      if (base64regex.test(matches[3])) return value;
    }
    return helpers$8.error(`string.dataUri`);
  } }, domain: { method(options) {
    options && Common$5.assertOptions(options, [`allowFullyQualified`, `allowUnicode`, `allowUnderscore`, `maxDomainSegments`, `minDomainSegments`, `tlds`]);
    let address = internals$5.addressOptions(options);
    return this.$_addRule({ name: `domain`, args: { options }, address });
  }, validate(value, helpers$8, args$1, { address }) {
    return isDomainValid(value, address) ? value : helpers$8.error(`string.domain`);
  } }, email: { method(options = {}) {
    Common$5.assertOptions(options, [`allowFullyQualified`, `allowUnicode`, `ignoreLength`, `maxDomainSegments`, `minDomainSegments`, `multiple`, `separator`, `tlds`]), assert$28(options.multiple === void 0 || typeof options.multiple == `boolean`, `multiple option must be an boolean`);
    let address = internals$5.addressOptions(options), regex = RegExp(`\\s*[${options.separator ? escapeRegex(options.separator) : `,`}]\\s*`);
    return this.$_addRule({ name: `email`, args: { options }, regex, address });
  }, validate(value, helpers$8, { options }, { regex, address }) {
    let emails = options.multiple ? value.split(regex) : [value], invalids = [];
    for (let email of emails) isEmailValid(email, address) || invalids.push(email);
    return invalids.length ? helpers$8.error(`string.email`, { value, invalids }) : value;
  } }, guid: { alias: `uuid`, method(options = {}) {
    Common$5.assertOptions(options, [`version`, `separator`, `wrapper`]), assert$28(options.wrapper === void 0 || typeof options.wrapper == `boolean` || typeof options.wrapper == `string` && typeof internals$5.guidBrackets[options.wrapper] == `string`, `"wrapper" must be true, false, or one of "${Object.keys(internals$5.guidBrackets).filter(Boolean).join(`", "`)}"`);
    let versionNumbers = ``;
    if (options.version) {
      let versions = [].concat(options.version);
      assert$28(versions.length >= 1, `version must have at least 1 valid version specified`);
      let set = /* @__PURE__ */ new Set();
      for (let i$4 = 0; i$4 < versions.length; ++i$4) {
        let version$4 = versions[i$4];
        assert$28(typeof version$4 == `string`, `version at position ` + i$4 + ` must be a string`);
        let versionNumber = internals$5.guidVersions[version$4.toLowerCase()];
        assert$28(versionNumber, `version at position ` + i$4 + ` must be one of ` + Object.keys(internals$5.guidVersions).join(`, `)), assert$28(!set.has(versionNumber), `version at position ` + i$4 + ` must not be a duplicate`), versionNumbers += versionNumber, set.add(versionNumber);
      }
    }
    assert$28(internals$5.guidSeparators.has(options.separator), `separator must be one of true, false, "-", or ":"`);
    let separator = options.separator === void 0 ? `[:-]?` : options.separator === true ? `[:-]` : options.separator === false ? `[]?` : `\\${options.separator}`, wrapperStart, wrapperEnd;
    options.wrapper === void 0 ? (wrapperStart = `[\\[{\\(]?`, wrapperEnd = `[\\]}\\)]?`) : options.wrapper === true ? (wrapperStart = `[\\[{\\(]`, wrapperEnd = `[\\]}\\)]`) : options.wrapper === false ? (wrapperStart = ``, wrapperEnd = ``) : (wrapperStart = escapeRegex(options.wrapper), wrapperEnd = escapeRegex(internals$5.guidBrackets[options.wrapper]));
    let regex = RegExp(`^(${wrapperStart})[0-9A-F]{8}(${separator})[0-9A-F]{4}\\2?[${versionNumbers || `0-9A-F`}][0-9A-F]{3}\\2?[${versionNumbers ? `89AB` : `0-9A-F`}][0-9A-F]{3}\\2?[0-9A-F]{12}(${wrapperEnd})$`, `i`);
    return this.$_addRule({ name: `guid`, args: { options }, regex });
  }, validate(value, helpers$8, args$1, { regex }) {
    let results = regex.exec(value);
    if (!results) return helpers$8.error(`string.guid`);
    let open = results[1], close = results[results.length - 1];
    return (open || close) && internals$5.guidBrackets[open] !== close ? helpers$8.error(`string.guid`) : value;
  } }, hex: { method(options = {}) {
    return Common$5.assertOptions(options, [`byteAligned`, `prefix`]), options = { byteAligned: false, prefix: false, ...options }, assert$28(typeof options.byteAligned == `boolean`, `byteAligned must be boolean`), assert$28(typeof options.prefix == `boolean` || options.prefix === `optional`, `prefix must be boolean or "optional"`), this.$_addRule({ name: `hex`, args: { options } });
  }, validate(value, helpers$8, { options }) {
    let re$5 = options.prefix === `optional` ? internals$5.hexRegex.withOptionalPrefix : options.prefix === true ? internals$5.hexRegex.withPrefix : internals$5.hexRegex.withoutPrefix;
    return re$5.test(value) ? options.byteAligned && value.length % 2 != 0 ? helpers$8.error(`string.hexAlign`) : value : helpers$8.error(`string.hex`);
  } }, hostname: { method() {
    return this.$_addRule(`hostname`);
  }, validate(value, helpers$8) {
    return isDomainValid(value, { minDomainSegments: 1 }) || internals$5.ipRegex.test(value) ? value : helpers$8.error(`string.hostname`);
  } }, insensitive: { method() {
    return this.$_setFlag(`insensitive`, true);
  } }, ip: { method(options = {}) {
    Common$5.assertOptions(options, [`cidr`, `version`]);
    let { cidr, versions, regex } = ipRegex(options), version$4 = options.version ? versions : void 0;
    return this.$_addRule({ name: `ip`, args: { options: { cidr, version: version$4 } }, regex });
  }, validate(value, helpers$8, { options }, { regex }) {
    return regex.test(value) ? value : options.version ? helpers$8.error(`string.ipVersion`, { value, cidr: options.cidr, version: options.version }) : helpers$8.error(`string.ip`, { value, cidr: options.cidr });
  } }, isoDate: { method() {
    return this.$_addRule(`isoDate`);
  }, validate(value, { error }) {
    return internals$5.isoDate(value) ? value : error(`string.isoDate`);
  } }, isoDuration: { method() {
    return this.$_addRule(`isoDuration`);
  }, validate(value, helpers$8) {
    return internals$5.isoDurationRegex.test(value) ? value : helpers$8.error(`string.isoDuration`);
  } }, length: { method(limit, encoding) {
    return internals$5.length(this, `length`, limit, `=`, encoding);
  }, validate(value, helpers$8, { limit, encoding }, { name: name$2, operator: operator$1, args: args$1 }) {
    let length = encoding ? Buffer$1 && Buffer$1.byteLength(value, encoding) : value.length;
    return Common$5.compare(length, limit, operator$1) ? value : helpers$8.error(`string.` + name$2, { limit: args$1.limit, value, encoding });
  }, args: [{ name: `limit`, ref: true, assert: Common$5.limit, message: `must be a positive integer` }, `encoding`] }, lowercase: { method() {
    return this.case(`lower`);
  } }, max: { method(limit, encoding) {
    return internals$5.length(this, `max`, limit, `<=`, encoding);
  }, args: [`limit`, `encoding`] }, min: { method(limit, encoding) {
    return internals$5.length(this, `min`, limit, `>=`, encoding);
  }, args: [`limit`, `encoding`] }, normalize: { method(form = `NFC`) {
    return assert$28(internals$5.normalizationForms.includes(form), `normalization form must be one of ` + internals$5.normalizationForms.join(`, `)), this.$_addRule({ name: `normalize`, args: { form } });
  }, validate(value, { error }, { form }) {
    return value === value.normalize(form) ? value : error(`string.normalize`, { value, form });
  }, convert: true }, pattern: { alias: `regex`, method(regex, options = {}) {
    assert$28(regex instanceof RegExp, `regex must be a RegExp`), assert$28(!regex.flags.includes(`g`) && !regex.flags.includes(`y`), `regex should not use global or sticky mode`), typeof options == `string` && (options = { name: options }), Common$5.assertOptions(options, [`invert`, `name`]);
    let errorCode$1 = [`string.pattern`, options.invert ? `.invert` : ``, options.name ? `.name` : `.base`].join(``);
    return this.$_addRule({ name: `pattern`, args: { regex, options }, errorCode: errorCode$1 });
  }, validate(value, helpers$8, { regex, options }, { errorCode: errorCode$1 }) {
    let patternMatch = regex.test(value);
    return patternMatch ^ options.invert ? value : helpers$8.error(errorCode$1, { name: options.name, regex, value });
  }, args: [`regex`, `options`], multi: true }, replace: { method(pattern, replacement) {
    typeof pattern == `string` && (pattern = new RegExp(escapeRegex(pattern), `g`)), assert$28(pattern instanceof RegExp, `pattern must be a RegExp`), assert$28(typeof replacement == `string`, `replacement must be a String`);
    let obj = this.clone();
    return obj.$_terms.replacements || (obj.$_terms.replacements = []), obj.$_terms.replacements.push({ pattern, replacement }), obj;
  } }, token: { method() {
    return this.$_addRule(`token`);
  }, validate(value, helpers$8) {
    return /^\w+$/.test(value) ? value : helpers$8.error(`string.token`);
  } }, trim: { method(enabled = true) {
    return assert$28(typeof enabled == `boolean`, `enabled must be a boolean`), this.$_addRule({ name: `trim`, args: { enabled } });
  }, validate(value, helpers$8, { enabled }) {
    return !enabled || value === value.trim() ? value : helpers$8.error(`string.trim`);
  }, convert: true }, truncate: { method(enabled = true) {
    return assert$28(typeof enabled == `boolean`, `enabled must be a boolean`), this.$_setFlag(`truncate`, enabled);
  } }, uppercase: { method() {
    return this.case(`upper`);
  } }, uri: { method(options = {}) {
    Common$5.assertOptions(options, [`allowRelative`, `allowQuerySquareBrackets`, `domain`, `relativeOnly`, `scheme`, `encodeUri`]), options.domain && Common$5.assertOptions(options.domain, [`allowFullyQualified`, `allowUnicode`, `maxDomainSegments`, `minDomainSegments`, `tlds`]);
    let { regex, scheme } = uriRegex(options), domain = options.domain ? internals$5.addressOptions(options.domain) : null;
    return this.$_addRule({ name: `uri`, args: { options }, regex, domain, scheme });
  }, validate(value, helpers$8, { options }, { regex, domain, scheme }) {
    if ([`http:/`, `https:/`].includes(value)) return helpers$8.error(`string.uri`);
    let match$2 = regex.exec(value);
    if (!match$2 && helpers$8.prefs.convert && options.encodeUri) {
      let encoded = encodeURI(value);
      match$2 = regex.exec(encoded), match$2 && (value = encoded);
    }
    if (match$2) {
      let matched = match$2[1] || match$2[2];
      return domain && (!options.allowRelative || matched) && !isDomainValid(matched, domain) ? helpers$8.error(`string.domain`, { value: matched }) : value;
    }
    return options.relativeOnly ? helpers$8.error(`string.uriRelativeOnly`) : options.scheme ? helpers$8.error(`string.uriCustomScheme`, { scheme, value }) : helpers$8.error(`string.uri`);
  } } }, manifest: { build(obj, desc$1) {
    if (desc$1.replacements) for (let { pattern, replacement } of desc$1.replacements) obj = obj.replace(pattern, replacement);
    return obj;
  } }, messages: { "string.alphanum": `{{#label}} must only contain alpha-numeric characters`, "string.base": `{{#label}} must be a string`, "string.base64": `{{#label}} must be a valid base64 string`, "string.creditCard": `{{#label}} must be a credit card`, "string.dataUri": `{{#label}} must be a valid dataUri string`, "string.domain": `{{#label}} must contain a valid domain name`, "string.email": `{{#label}} must be a valid email`, "string.empty": `{{#label}} is not allowed to be empty`, "string.guid": `{{#label}} must be a valid GUID`, "string.hex": `{{#label}} must only contain hexadecimal characters`, "string.hexAlign": `{{#label}} hex decoded representation must be byte aligned`, "string.hostname": `{{#label}} must be a valid hostname`, "string.ip": `{{#label}} must be a valid ip address with a {{#cidr}} CIDR`, "string.ipVersion": `{{#label}} must be a valid ip address of one of the following versions {{#version}} with a {{#cidr}} CIDR`, "string.isoDate": `{{#label}} must be in iso format`, "string.isoDuration": `{{#label}} must be a valid ISO 8601 duration`, "string.length": `{{#label}} length must be {{#limit}} characters long`, "string.lowercase": `{{#label}} must only contain lowercase characters`, "string.max": `{{#label}} length must be less than or equal to {{#limit}} characters long`, "string.min": `{{#label}} length must be at least {{#limit}} characters long`, "string.normalize": `{{#label}} must be unicode normalized in the {{#form}} form`, "string.token": `{{#label}} must only contain alpha-numeric and underscore characters`, "string.pattern.base": `{{#label}} with value {:[.]} fails to match the required pattern: {{#regex}}`, "string.pattern.name": `{{#label}} with value {:[.]} fails to match the {{#name}} pattern`, "string.pattern.invert.base": `{{#label}} with value {:[.]} matches the inverted pattern: {{#regex}}`, "string.pattern.invert.name": `{{#label}} with value {:[.]} matches the inverted {{#name}} pattern`, "string.trim": `{{#label}} must not have leading or trailing whitespace`, "string.uri": `{{#label}} must be a valid uri`, "string.uriCustomScheme": `{{#label}} must be a valid uri with a scheme matching the {{#scheme}} pattern`, "string.uriRelativeOnly": `{{#label}} must be a valid relative uri`, "string.uppercase": `{{#label}} must only contain uppercase characters` } }), internals$5.addressOptions = function(options) {
    if (!options) return internals$5.tlds || options;
    if (assert$28(options.minDomainSegments === void 0 || Number.isSafeInteger(options.minDomainSegments) && options.minDomainSegments > 0, `minDomainSegments must be a positive integer`), assert$28(options.maxDomainSegments === void 0 || Number.isSafeInteger(options.maxDomainSegments) && options.maxDomainSegments > 0, `maxDomainSegments must be a positive integer`), options.tlds === false) return options;
    if (options.tlds === true || options.tlds === void 0) return assert$28(internals$5.tlds, `Built-in TLD list disabled`), Object.assign({}, options, internals$5.tlds);
    assert$28(typeof options.tlds == `object`, `tlds must be true, false, or an object`);
    let deny = options.tlds.deny;
    if (deny) return Array.isArray(deny) && (options = Object.assign({}, options, { tlds: { deny: new Set(deny) } })), assert$28(options.tlds.deny instanceof Set, `tlds.deny must be an array, Set, or boolean`), assert$28(!options.tlds.allow, `Cannot specify both tlds.allow and tlds.deny lists`), internals$5.validateTlds(options.tlds.deny, `tlds.deny`), options;
    let allow = options.tlds.allow;
    return allow ? allow === true ? (assert$28(internals$5.tlds, `Built-in TLD list disabled`), Object.assign({}, options, internals$5.tlds)) : (Array.isArray(allow) && (options = Object.assign({}, options, { tlds: { allow: new Set(allow) } })), assert$28(options.tlds.allow instanceof Set, `tlds.allow must be an array, Set, or boolean`), internals$5.validateTlds(options.tlds.allow, `tlds.allow`), options) : { ...options, tlds: false };
  }, internals$5.validateTlds = function(set, source) {
    for (let tld of set) assert$28(isDomainValid(tld, { minDomainSegments: 1, maxDomainSegments: 1 }), `${source} must contain valid top level domain names`);
  }, internals$5.isoDate = function(value) {
    if (!Common$5.isIsoDate(value)) return null;
    /.*T.*[+-]\d\d$/.test(value) && (value += `00`);
    let date = new Date(value);
    return isNaN(date.getTime()) ? null : date.toISOString();
  }, internals$5.length = function(schema$2, name$2, limit, operator$1, encoding) {
    return assert$28(!encoding || Buffer$1 && Buffer$1.isEncoding(encoding), `Invalid encoding:`, encoding), schema$2.$_addRule({ name: name$2, method: `length`, args: { limit, encoding }, operator: operator$1 });
  };
}), require_symbol = __commonJSMin$1((exports$12, module2) => {
  let { assert: assert$27 } = require_lib$4(), Any$1 = require_any(), internals$4 = {};
  internals$4.Map = class extends Map {
    slice() {
      return new internals$4.Map(this);
    }
  }, module2.exports = Any$1.extend({ type: `symbol`, terms: { map: { init: new internals$4.Map() } }, coerce: { method(value, { schema: schema$2, error }) {
    let lookup$2 = schema$2.$_terms.map.get(value);
    return lookup$2 && (value = lookup$2), !schema$2._flags.only || typeof value == `symbol` ? { value } : { value, errors: error(`symbol.map`, { map: schema$2.$_terms.map }) };
  } }, validate(value, { error }) {
    if (typeof value != `symbol`) return { value, errors: error(`symbol.base`) };
  }, rules: { map: { method(iterable) {
    iterable && !iterable[Symbol.iterator] && typeof iterable == `object` && (iterable = Object.entries(iterable)), assert$27(iterable && iterable[Symbol.iterator], `Iterable must be an iterable or object`);
    let obj = this.clone(), symbols = [];
    for (let entry of iterable) {
      assert$27(entry && entry[Symbol.iterator], `Entry must be an iterable`);
      let [key, value] = entry;
      assert$27(typeof key != `object` && typeof key != `function` && typeof key != `symbol`, `Key must not be of type object, function, or Symbol`), assert$27(typeof value == `symbol`, `Value must be a Symbol`), obj.$_terms.map.set(key, value), symbols.push(value);
    }
    return obj.valid(...symbols);
  } } }, manifest: { build(obj, desc$1) {
    return desc$1.map && (obj = obj.map(desc$1.map)), obj;
  } }, messages: { "symbol.base": `{{#label}} must be a symbol`, "symbol.map": `{{#label}} must be one of {{#map}}` } });
}), require_binary = __commonJSMin$1((exports$12, module2) => {
  init_dist$1();
  let { assert: assert$26 } = require_lib$4(), Any = require_any(), Common$4 = require_common$3();
  module2.exports = Any.extend({ type: `binary`, coerce: { from: [`string`, `object`], method(value, { schema: schema$2 }) {
    if (typeof value == `string` || value !== null && value.type === `Buffer`) try {
      return { value: Buffer$1.from(value, schema$2._flags.encoding) };
    } catch {
    }
  } }, validate(value, { error }) {
    if (!Buffer$1.isBuffer(value)) return { value, errors: error(`binary.base`) };
  }, rules: { encoding: { method(encoding) {
    return assert$26(Buffer$1.isEncoding(encoding), `Invalid encoding:`, encoding), this.$_setFlag(`encoding`, encoding);
  } }, length: { method(limit) {
    return this.$_addRule({ name: `length`, method: `length`, args: { limit }, operator: `=` });
  }, validate(value, helpers$8, { limit }, { name: name$2, operator: operator$1, args: args$1 }) {
    return Common$4.compare(value.length, limit, operator$1) ? value : helpers$8.error(`binary.` + name$2, { limit: args$1.limit, value });
  }, args: [{ name: `limit`, ref: true, assert: Common$4.limit, message: `must be a positive integer` }] }, max: { method(limit) {
    return this.$_addRule({ name: `max`, method: `length`, args: { limit }, operator: `<=` });
  } }, min: { method(limit) {
    return this.$_addRule({ name: `min`, method: `length`, args: { limit }, operator: `>=` });
  } } }, cast: { string: { from: (value) => Buffer$1.isBuffer(value), to(value, helpers$8) {
    return value.toString();
  } } }, messages: { "binary.base": `{{#label}} must be a buffer or a string`, "binary.length": `{{#label}} must be {{#limit}} bytes`, "binary.max": `{{#label}} must be less than or equal to {{#limit}} bytes`, "binary.min": `{{#label}} must be at least {{#limit}} bytes` } });
}), require_lib = __commonJSMin$1((exports$12, module2) => {
  init_dist$1();
  let { assert: assert$25, clone: clone$9 } = require_lib$4(), Cache$1 = require_cache(), Common$3 = require_common$3(), Compile$1 = require_compile(), Errors$1 = require_errors$2(), Extend$1 = require_extend$1(), Manifest$1 = require_manifest(), Ref$4 = require_ref$2(), Template$2 = require_template(), Trace$1 = require_trace(), Schemas$2, internals$3 = { types: { alternatives: require_alternatives(), any: require_any(), array: require_array(), boolean: require_boolean(), date: require_date(), function: require_function(), link: require_link(), number: require_number(), object: require_object(), string: require_string$1(), symbol: require_symbol() }, aliases: { alt: `alternatives`, bool: `boolean`, func: `function` } };
  Buffer$1 && (internals$3.types.binary = require_binary()), internals$3.root = function() {
    let root$11 = { _types: new Set(Object.keys(internals$3.types)) };
    for (let type of root$11._types) root$11[type] = function(...args$1) {
      return assert$25(!args$1.length || [`alternatives`, `link`, `object`].includes(type), `The`, type, `type does not allow arguments`), internals$3.generate(this, internals$3.types[type], args$1);
    };
    for (let method$1 of [`allow`, `custom`, `disallow`, `equal`, `exist`, `forbidden`, `invalid`, `not`, `only`, `optional`, `options`, `prefs`, `preferences`, `required`, `strip`, `valid`, `when`]) root$11[method$1] = function(...args$1) {
      return this.any()[method$1](...args$1);
    };
    for (let alias in Object.assign(root$11, internals$3.methods), internals$3.aliases) {
      let target = internals$3.aliases[alias];
      root$11[alias] = root$11[target];
    }
    return root$11.x = root$11.expression, Trace$1.setup && Trace$1.setup(root$11), root$11;
  }, internals$3.methods = { ValidationError: Errors$1.ValidationError, version: Common$3.version, cache: Cache$1.provider, assert(value, schema$2, ...args$1) {
    internals$3.assert(value, schema$2, true, args$1);
  }, attempt(value, schema$2, ...args$1) {
    return internals$3.assert(value, schema$2, false, args$1);
  }, build(desc$1) {
    return assert$25(typeof Manifest$1.build == `function`, `Manifest functionality disabled`), Manifest$1.build(this, desc$1);
  }, checkPreferences(prefs) {
    Common$3.checkPreferences(prefs);
  }, compile(schema$2, options) {
    return Compile$1.compile(this, schema$2, options);
  }, defaults(modifier) {
    assert$25(typeof modifier == `function`, `modifier must be a function`);
    let joi = Object.assign({}, this);
    for (let type of joi._types) {
      let schema$2 = modifier(joi[type]());
      assert$25(Common$3.isSchema(schema$2), `modifier must return a valid schema object`), joi[type] = function(...args$1) {
        return internals$3.generate(this, schema$2, args$1);
      };
    }
    return joi;
  }, expression(...args$1) {
    return new Template$2(...args$1);
  }, extend(...extensions) {
    Common$3.verifyFlat(extensions, `extend`), Schemas$2 ||= require_schemas(), assert$25(extensions.length, `You need to provide at least one extension`), this.assert(extensions, Schemas$2.extensions);
    let joi = Object.assign({}, this);
    joi._types = new Set(joi._types);
    for (let extension of extensions) {
      typeof extension == `function` && (extension = extension(joi)), this.assert(extension, Schemas$2.extension);
      let expanded = internals$3.expandExtension(extension, joi);
      for (let item of expanded) {
        assert$25(joi[item.type] === void 0 || joi._types.has(item.type), `Cannot override name`, item.type);
        let base$3 = item.base || this.any(), schema$2 = Extend$1.type(base$3, item);
        joi._types.add(item.type), joi[item.type] = function(...args$1) {
          return internals$3.generate(this, schema$2, args$1);
        };
      }
    }
    return joi;
  }, isError: Errors$1.ValidationError.isError, isExpression: Template$2.isTemplate, isRef: Ref$4.isRef, isSchema: Common$3.isSchema, in(...args$1) {
    return Ref$4.in(...args$1);
  }, override: Common$3.symbols.override, ref(...args$1) {
    return Ref$4.create(...args$1);
  }, types() {
    let types$1 = {};
    for (let type of this._types) types$1[type] = this[type]();
    for (let target in internals$3.aliases) types$1[target] = this[target]();
    return types$1;
  } }, internals$3.assert = function(value, schema$2, annotate, args$1) {
    let message = args$1[0] instanceof Error || typeof args$1[0] == `string` ? args$1[0] : null, options = message === null ? args$1[0] : args$1[1], result = schema$2.validate(value, Common$3.preferences({ errors: { stack: true } }, options || {})), error = result.error;
    if (!error) return result.value;
    if (message instanceof Error) throw message;
    let display = annotate && typeof error.annotate == `function` ? error.annotate() : error.message;
    throw error instanceof Errors$1.ValidationError || (error = clone$9(error)), error.message = message ? `${message} ${display}` : display, error;
  }, internals$3.generate = function(root$11, schema$2, args$1) {
    return assert$25(root$11, `Must be invoked on a Joi instance.`), schema$2.$_root = root$11, !schema$2._definition.args || !args$1.length ? schema$2 : schema$2._definition.args(schema$2, ...args$1);
  }, internals$3.expandExtension = function(extension, joi) {
    if (typeof extension.type == `string`) return [extension];
    let extended = [];
    for (let type of joi._types) if (extension.type.test(type)) {
      let item = Object.assign({}, extension);
      item.type = type, item.base = joi[type](), extended.push(item);
    }
    return extended;
  }, module2.exports = internals$3.root();
}), require_schemas = __commonJSMin$1((exports$12) => {
  let Joi$1 = require_lib(), internals$2 = {};
  internals$2.wrap = Joi$1.string().min(1).max(2).allow(false), exports$12.preferences = Joi$1.object({ allowUnknown: Joi$1.boolean(), abortEarly: Joi$1.boolean(), artifacts: Joi$1.boolean(), cache: Joi$1.boolean(), context: Joi$1.object(), convert: Joi$1.boolean(), dateFormat: Joi$1.valid(`date`, `iso`, `string`, `time`, `utc`), debug: Joi$1.boolean(), errors: { escapeHtml: Joi$1.boolean(), label: Joi$1.valid(`path`, `key`, false), language: [Joi$1.string(), Joi$1.object().ref()], render: Joi$1.boolean(), stack: Joi$1.boolean(), wrap: { label: internals$2.wrap, array: internals$2.wrap, string: internals$2.wrap } }, externals: Joi$1.boolean(), messages: Joi$1.object(), noDefaults: Joi$1.boolean(), nonEnumerables: Joi$1.boolean(), presence: Joi$1.valid(`required`, `optional`, `forbidden`), skipFunctions: Joi$1.boolean(), stripUnknown: Joi$1.object({ arrays: Joi$1.boolean(), objects: Joi$1.boolean() }).or(`arrays`, `objects`).allow(true, false), warnings: Joi$1.boolean() }).strict(), internals$2.nameRx = /^[a-zA-Z0-9]\w*$/, internals$2.rule = Joi$1.object({ alias: Joi$1.array().items(Joi$1.string().pattern(internals$2.nameRx)).single(), args: Joi$1.array().items(Joi$1.string(), Joi$1.object({ name: Joi$1.string().pattern(internals$2.nameRx).required(), ref: Joi$1.boolean(), assert: Joi$1.alternatives([Joi$1.function(), Joi$1.object().schema()]).conditional(`ref`, { is: true, then: Joi$1.required() }), normalize: Joi$1.function(), message: Joi$1.string().when(`assert`, { is: Joi$1.function(), then: Joi$1.required() }) })), convert: Joi$1.boolean(), manifest: Joi$1.boolean(), method: Joi$1.function().allow(false), multi: Joi$1.boolean(), validate: Joi$1.function() }), exports$12.extension = Joi$1.object({ type: Joi$1.alternatives([Joi$1.string(), Joi$1.object().regex()]).required(), args: Joi$1.function(), cast: Joi$1.object().pattern(internals$2.nameRx, Joi$1.object({ from: Joi$1.function().maxArity(1).required(), to: Joi$1.function().minArity(1).maxArity(2).required() })), base: Joi$1.object().schema().when(`type`, { is: Joi$1.object().regex(), then: Joi$1.forbidden() }), coerce: [Joi$1.function().maxArity(3), Joi$1.object({ method: Joi$1.function().maxArity(3).required(), from: Joi$1.array().items(Joi$1.string()).single() })], flags: Joi$1.object().pattern(internals$2.nameRx, Joi$1.object({ setter: Joi$1.string(), default: Joi$1.any() })), manifest: { build: Joi$1.function().arity(2) }, messages: [Joi$1.object(), Joi$1.string()], modifiers: Joi$1.object().pattern(internals$2.nameRx, Joi$1.function().minArity(1).maxArity(2)), overrides: Joi$1.object().pattern(internals$2.nameRx, Joi$1.function()), prepare: Joi$1.function().maxArity(3), rebuild: Joi$1.function().arity(1), rules: Joi$1.object().pattern(internals$2.nameRx, internals$2.rule), terms: Joi$1.object().pattern(internals$2.nameRx, Joi$1.object({ init: Joi$1.array().allow(null).required(), manifest: Joi$1.object().pattern(/.+/, [Joi$1.valid(`schema`, `single`), Joi$1.object({ mapped: Joi$1.object({ from: Joi$1.string().required(), to: Joi$1.string().required() }).required() })]) })), validate: Joi$1.function().maxArity(3) }).strict(), exports$12.extensions = Joi$1.array().items(Joi$1.object(), Joi$1.function().arity(1)).strict(), internals$2.desc = { buffer: Joi$1.object({ buffer: Joi$1.string() }), func: Joi$1.object({ function: Joi$1.function().required(), options: { literal: true } }), override: Joi$1.object({ override: true }), ref: Joi$1.object({ ref: Joi$1.object({ type: Joi$1.valid(`value`, `global`, `local`), path: Joi$1.array().required(), separator: Joi$1.string().length(1).allow(false), ancestor: Joi$1.number().min(0).integer().allow(`root`), map: Joi$1.array().items(Joi$1.array().length(2)).min(1), adjust: Joi$1.function(), iterables: Joi$1.boolean(), in: Joi$1.boolean(), render: Joi$1.boolean() }).required() }), regex: Joi$1.object({ regex: Joi$1.string().min(3) }), special: Joi$1.object({ special: Joi$1.valid(`deep`).required() }), template: Joi$1.object({ template: Joi$1.string().required(), options: Joi$1.object() }), value: Joi$1.object({ value: Joi$1.alternatives([Joi$1.object(), Joi$1.array()]).required() }) }, internals$2.desc.entity = Joi$1.alternatives([Joi$1.array().items(Joi$1.link(`...`)), Joi$1.boolean(), Joi$1.function(), Joi$1.number(), Joi$1.string(), internals$2.desc.buffer, internals$2.desc.func, internals$2.desc.ref, internals$2.desc.regex, internals$2.desc.special, internals$2.desc.template, internals$2.desc.value, Joi$1.link(`/`)]), internals$2.desc.values = Joi$1.array().items(null, Joi$1.boolean(), Joi$1.function(), Joi$1.number().allow(1 / 0, -1 / 0), Joi$1.string().allow(``), Joi$1.symbol(), internals$2.desc.buffer, internals$2.desc.func, internals$2.desc.override, internals$2.desc.ref, internals$2.desc.regex, internals$2.desc.template, internals$2.desc.value), internals$2.desc.messages = Joi$1.object().pattern(/.+/, [Joi$1.string(), internals$2.desc.template, Joi$1.object().pattern(/.+/, [Joi$1.string(), internals$2.desc.template])]), exports$12.description = Joi$1.object({ type: Joi$1.string().required(), flags: Joi$1.object({ cast: Joi$1.string(), default: Joi$1.any(), description: Joi$1.string(), empty: Joi$1.link(`/`), failover: internals$2.desc.entity, id: Joi$1.string(), label: Joi$1.string(), only: true, presence: [`optional`, `required`, `forbidden`], result: [`raw`, `strip`], strip: Joi$1.boolean(), unit: Joi$1.string() }).unknown(), preferences: { allowUnknown: Joi$1.boolean(), abortEarly: Joi$1.boolean(), artifacts: Joi$1.boolean(), cache: Joi$1.boolean(), convert: Joi$1.boolean(), dateFormat: [`date`, `iso`, `string`, `time`, `utc`], errors: { escapeHtml: Joi$1.boolean(), label: [`path`, `key`], language: [Joi$1.string(), internals$2.desc.ref], wrap: { label: internals$2.wrap, array: internals$2.wrap } }, externals: Joi$1.boolean(), messages: internals$2.desc.messages, noDefaults: Joi$1.boolean(), nonEnumerables: Joi$1.boolean(), presence: [`required`, `optional`, `forbidden`], skipFunctions: Joi$1.boolean(), stripUnknown: Joi$1.object({ arrays: Joi$1.boolean(), objects: Joi$1.boolean() }).or(`arrays`, `objects`).allow(true, false), warnings: Joi$1.boolean() }, allow: internals$2.desc.values, invalid: internals$2.desc.values, rules: Joi$1.array().min(1).items({ name: Joi$1.string().required(), args: Joi$1.object().min(1), keep: Joi$1.boolean(), message: [Joi$1.string(), internals$2.desc.messages], warn: Joi$1.boolean() }), keys: Joi$1.object().pattern(/.*/, Joi$1.link(`/`)), link: internals$2.desc.ref }).pattern(/^[a-z]\w*$/, Joi$1.any());
}), require_common$3 = __commonJSMin$1((exports$12) => {
  let { assert: Assert, AssertError } = require_lib$4(), Pkg = (init_package$1(), __toCommonJS(package_exports$1).default), Messages$2, Schemas$1, internals$1 = { isoDate: /^(?:[-+]\d{2})?(?:\d{4}(?!\d{2}\b))(?:(-?)(?:(?:0[1-9]|1[0-2])(?:\1(?:[12]\d|0[1-9]|3[01]))?|W(?:[0-4]\d|5[0-2])(?:-?[1-7])?|(?:00[1-9]|0[1-9]\d|[12]\d{2}|3(?:[0-5]\d|6[1-6])))(?![T]$|[T][\d]+Z$)(?:[T\s](?:(?:(?:[01]\d|2[0-3])(?:(:?)[0-5]\d)?|24\:?00)(?:[.,]\d+(?!:))?)(?:\2[0-5]\d(?:[.,]\d+)?)?(?:[Z]|(?:[+-])(?:[01]\d|2[0-3])(?::?[0-5]\d)?)?)?)?$/ };
  exports$12.version = Pkg.version, exports$12.defaults = { abortEarly: true, allowUnknown: false, artifacts: false, cache: true, context: null, convert: true, dateFormat: `iso`, errors: { escapeHtml: false, label: `path`, language: null, render: true, stack: false, wrap: { label: `"`, array: `[]` } }, externals: true, messages: {}, nonEnumerables: false, noDefaults: false, presence: `optional`, skipFunctions: false, stripUnknown: false, warnings: false }, exports$12.symbols = { any: Symbol.for(`@hapi/joi/schema`), arraySingle: Symbol(`arraySingle`), deepDefault: Symbol(`deepDefault`), errors: Symbol(`errors`), literal: Symbol(`literal`), override: Symbol(`override`), parent: Symbol(`parent`), prefs: Symbol(`prefs`), ref: Symbol(`ref`), template: Symbol(`template`), values: Symbol(`values`) }, exports$12.assertOptions = function(options, keys$10, name$2 = `Options`) {
    Assert(options && typeof options == `object` && !Array.isArray(options), `Options must be of type object`);
    let unknownKeys = Object.keys(options).filter((k) => !keys$10.includes(k));
    Assert(unknownKeys.length === 0, `${name$2} contain unknown keys: ${unknownKeys}`);
  }, exports$12.checkPreferences = function(prefs) {
    Schemas$1 ||= require_schemas();
    let result = Schemas$1.preferences.validate(prefs);
    if (result.error) throw new AssertError([result.error.details[0].message]);
  }, exports$12.compare = function(a$22, b2, operator$1) {
    switch (operator$1) {
      case `=`:
        return a$22 === b2;
      case `>`:
        return a$22 > b2;
      case `<`:
        return a$22 < b2;
      case `>=`:
        return a$22 >= b2;
      case `<=`:
        return a$22 <= b2;
    }
  }, exports$12.default = function(value, defaultValue) {
    return value === void 0 ? defaultValue : value;
  }, exports$12.isIsoDate = function(date) {
    return internals$1.isoDate.test(date);
  }, exports$12.isNumber = function(value) {
    return typeof value == `number` && !isNaN(value);
  }, exports$12.isResolvable = function(obj) {
    return obj ? obj[exports$12.symbols.ref] || obj[exports$12.symbols.template] : false;
  }, exports$12.isSchema = function(schema$2, options = {}) {
    let any = schema$2 && schema$2[exports$12.symbols.any];
    return any ? (Assert(options.legacy || any.version === exports$12.version, `Cannot mix different versions of joi schemas`), true) : false;
  }, exports$12.isValues = function(obj) {
    return obj[exports$12.symbols.values];
  }, exports$12.limit = function(value) {
    return Number.isSafeInteger(value) && value >= 0;
  }, exports$12.preferences = function(target, source) {
    Messages$2 ||= require_messages(), target ||= {}, source ||= {};
    let merged = Object.assign({}, target, source);
    return source.errors && target.errors && (merged.errors = Object.assign({}, target.errors, source.errors), merged.errors.wrap = Object.assign({}, target.errors.wrap, source.errors.wrap)), source.messages && (merged.messages = Messages$2.compile(source.messages, target.messages)), delete merged[exports$12.symbols.prefs], merged;
  }, exports$12.tryWithPath = function(fn$1, key, options = {}) {
    try {
      return fn$1();
    } catch (err$1) {
      throw err$1.path === void 0 ? err$1.path = key : err$1.path = key + `.` + err$1.path, options.append && (err$1.message = `${err$1.message} (${err$1.path})`), err$1;
    }
  }, exports$12.validateArg = function(value, label, { assert: assert$54, message }) {
    if (exports$12.isSchema(assert$54)) {
      let result = assert$54.validate(value);
      return result.error ? result.error.message : void 0;
    } else if (!assert$54(value)) return label ? `${label} ${message}` : message;
  }, exports$12.verifyFlat = function(args$1, method$1) {
    for (let arg of args$1) Assert(!Array.isArray(arg), `Method no longer accepts array arguments:`, method$1);
  };
}), require_annotate = __commonJSMin$1((exports$12) => {
  let { clone: clone$8 } = require_lib$4(), Common$2 = require_common$3(), internals = { annotations: Symbol(`annotations`) };
  exports$12.error = function(stripColorCodes) {
    if (!this._original || typeof this._original != `object`) return this.details[0].message;
    let redFgEscape = stripColorCodes ? `` : `\x1B[31m`, redBgEscape = stripColorCodes ? `` : `\x1B[41m`, endColor = stripColorCodes ? `` : `\x1B[0m`, obj = clone$8(this._original);
    for (let i$4 = this.details.length - 1; i$4 >= 0; --i$4) {
      let pos = i$4 + 1, error = this.details[i$4], path = error.path, node = obj;
      for (let j$1 = 0; ; ++j$1) {
        let seg = path[j$1];
        if (Common$2.isSchema(node) && (node = node.clone()), j$1 + 1 < path.length && typeof node[seg] != `string`) node = node[seg];
        else {
          let refAnnotations = node[internals.annotations] || { errors: {}, missing: {} };
          node[internals.annotations] = refAnnotations;
          let cacheKey = seg || error.context.key;
          node[seg] === void 0 ? refAnnotations.missing[cacheKey] = pos : (refAnnotations.errors[cacheKey] = refAnnotations.errors[cacheKey] || [], refAnnotations.errors[cacheKey].push(pos));
          break;
        }
      }
    }
    let replacers = { key: /_\$key\$_([, \d]+)_\$end\$_"/g, missing: /"_\$miss\$_([^|]+)\|(\d+)_\$end\$_": "__missing__"/g, arrayIndex: /\s*"_\$idx\$_([, \d]+)_\$end\$_",?\n(.*)/g, specials: /"\[(NaN|Symbol.*|-?Infinity|function.*|\(.*)]"/g }, message = internals.safeStringify(obj, 2).replace(replacers.key, ($0, $1) => `" ${redFgEscape}[${$1}]${endColor}`).replace(replacers.missing, ($0, $1, $2) => `${redBgEscape}"${$1}"${endColor}${redFgEscape} [${$2}]: -- missing --${endColor}`).replace(replacers.arrayIndex, ($0, $1, $2) => `
${$2} ${redFgEscape}[${$1}]${endColor}`).replace(replacers.specials, ($0, $1) => $1);
    message = `${message}
${redFgEscape}`;
    for (let i$4 = 0; i$4 < this.details.length; ++i$4) {
      let pos = i$4 + 1;
      message = `${message}
[${pos}] ${this.details[i$4].message}`;
    }
    return message += endColor, message;
  }, internals.safeStringify = function(obj, spaces) {
    return JSON.stringify(obj, internals.serializer(), spaces);
  }, internals.serializer = function() {
    let keys$10 = [], stack = [], cycleReplacer = (key, value) => stack[0] === value ? `[Circular ~]` : `[Circular ~.` + keys$10.slice(0, stack.indexOf(value)).join(`.`) + `]`;
    return function(key, value) {
      if (stack.length > 0) {
        let thisPos = stack.indexOf(this);
        ~thisPos ? (stack.length = thisPos + 1, keys$10.length = thisPos + 1, keys$10[thisPos] = key) : (stack.push(this), keys$10.push(key)), ~stack.indexOf(value) && (value = cycleReplacer.call(this, key, value));
      } else stack.push(value);
      if (value) {
        let annotations = value[internals.annotations];
        if (annotations) {
          if (Array.isArray(value)) {
            let annotated = [];
            for (let i$4 = 0; i$4 < value.length; ++i$4) annotations.errors[i$4] && annotated.push(`_$idx$_${annotations.errors[i$4].sort().join(`, `)}_$end$_`), annotated.push(value[i$4]);
            value = annotated;
          } else {
            for (let errorKey in annotations.errors) value[`${errorKey}_$key$_${annotations.errors[errorKey].sort().join(`, `)}_$end$_`] = value[errorKey], value[errorKey] = void 0;
            for (let missingKey in annotations.missing) value[`_$miss$_${missingKey}|${annotations.missing[missingKey]}_$end$_`] = `__missing__`;
          }
          return value;
        }
      }
      return value === 1 / 0 || value === -1 / 0 || Number.isNaN(value) || typeof value == `function` || typeof value == `symbol` ? `[` + value.toString() + `]` : value;
    };
  };
}), require_errors$2 = __commonJSMin$1((exports$12) => {
  let Annotate = require_annotate(), Common$1 = require_common$3(), Template$1 = require_template();
  exports$12.Report = class {
    constructor(code$2, value, local, flags, messages$3, state, prefs) {
      if (this.code = code$2, this.flags = flags, this.messages = messages$3, this.path = state.path, this.prefs = prefs, this.state = state, this.value = value, this.message = null, this.template = null, this.local = local || {}, this.local.label = exports$12.label(this.flags, this.state, this.prefs, this.messages), this.value !== void 0 && !this.local.hasOwnProperty(`value`) && (this.local.value = this.value), this.path.length) {
        let key = this.path[this.path.length - 1];
        typeof key != `object` && (this.local.key = key);
      }
    }
    _setTemplate(template) {
      if (this.template = template, !this.flags.label && this.path.length === 0) {
        let localized = this._template(this.template, `root`);
        localized && (this.local.label = localized);
      }
    }
    toString() {
      if (this.message) return this.message;
      let code$2 = this.code;
      if (!this.prefs.errors.render) return this.code;
      let template = this._template(this.template) || this._template(this.prefs.messages) || this._template(this.messages);
      return template === void 0 ? `Error code "${code$2}" is not defined, your custom type is missing the correct messages definition` : (this.message = template.render(this.value, this.state, this.prefs, this.local, { errors: this.prefs.errors, messages: [this.prefs.messages, this.messages] }), this.prefs.errors.label || (this.message = this.message.replace(/^"" /, ``).trim()), this.message);
    }
    _template(messages$3, code$2) {
      return exports$12.template(this.value, messages$3, code$2 || this.code, this.state, this.prefs);
    }
  }, exports$12.path = function(path) {
    let label = ``;
    for (let segment of path) {
      if (typeof segment == `object`) continue;
      typeof segment == `string` ? (label && (label += `.`), label += segment) : label += `[${segment}]`;
    }
    return label;
  }, exports$12.template = function(value, messages$3, code$2, state, prefs) {
    if (!messages$3) return;
    if (Template$1.isTemplate(messages$3)) return code$2 === `root` ? null : messages$3;
    let lang = prefs.errors.language;
    if (Common$1.isResolvable(lang) && (lang = lang.resolve(value, state, prefs)), lang && messages$3[lang]) {
      if (messages$3[lang][code$2] !== void 0) return messages$3[lang][code$2];
      if (messages$3[lang][`*`] !== void 0) return messages$3[lang][`*`];
    }
    return messages$3[code$2] ? messages$3[code$2] : messages$3[`*`];
  }, exports$12.label = function(flags, state, prefs, messages$3) {
    if (!prefs.errors.label) return ``;
    if (flags.label) return flags.label;
    let path = state.path;
    prefs.errors.label === `key` && state.path.length > 1 && (path = state.path.slice(-1));
    let normalized = exports$12.path(path);
    return normalized || exports$12.template(null, prefs.messages, `root`, state, prefs) || messages$3 && exports$12.template(null, messages$3, `root`, state, prefs) || `value`;
  }, exports$12.process = function(errors, original, prefs) {
    if (!errors) return null;
    let { override, message, details } = exports$12.details(errors);
    if (override) return override;
    if (prefs.errors.stack) return new exports$12.ValidationError(message, details, original);
    let limit = Error.stackTraceLimit;
    Error.stackTraceLimit = 0;
    let validationError = new exports$12.ValidationError(message, details, original);
    return Error.stackTraceLimit = limit, validationError;
  }, exports$12.details = function(errors, options = {}) {
    let messages$3 = [], details = [];
    for (let item of errors) {
      if (item instanceof Error) {
        if (options.override !== false) return { override: item };
        let message$1 = item.toString();
        messages$3.push(message$1), details.push({ message: message$1, type: `override`, context: { error: item } });
        continue;
      }
      let message = item.toString();
      messages$3.push(message), details.push({ message, path: item.path.filter((v$1) => typeof v$1 != `object`), type: item.code, context: item.local });
    }
    return messages$3.length > 1 && (messages$3 = [...new Set(messages$3)]), { message: messages$3.join(`. `), details };
  }, exports$12.ValidationError = class extends Error {
    constructor(message, details, original) {
      super(message), this._original = original, this.details = details;
    }
    static isError(err$1) {
      return err$1 instanceof exports$12.ValidationError;
    }
  }, exports$12.ValidationError.prototype.isJoi = true, exports$12.ValidationError.prototype.name = `ValidationError`, exports$12.ValidationError.prototype.annotate = Annotate.error;
}), import_errors$1 = __toESM(require_errors$2()), import_common$1 = __toESM(require_common$3()), import_template$1 = __toESM(require_template());
const templateCtor = import_template$1.default, commonCtor = import_common$1.default;
Object.defineProperty(import_errors$1.default, `template`, { value: function(value, messages$3, code$2, state, prefs) {
  if (!messages$3) return;
  if (templateCtor.isTemplate(messages$3)) return code$2 === `root` ? null : messages$3;
  let lang = prefs.errors.language;
  if (commonCtor.isResolvable(lang) && (lang = lang.resolve(value, state, prefs)), lang && messages$3[lang]) {
    if (messages$3[lang][code$2] !== void 0) return messages$3[lang][code$2];
    if (messages$3[lang][`*`] !== void 0) return messages$3[lang][`*`];
  }
  return messages$3[code$2] ? messages$3[code$2] : messages$3[`*`];
} });
const json = (root$11) => root$11;
var require_TimeoutError = __commonJSMin$1((exports$12) => {
  Object.defineProperty(exports$12, `__esModule`, { value: true });
  var TimeoutError$2 = class extends Error {
  };
  exports$12.TimeoutError = TimeoutError$2;
}), require_PromiseInspection = __commonJSMin$1((exports$12) => {
  Object.defineProperty(exports$12, `__esModule`, { value: true });
  var PromiseInspection = class {
    constructor(args$1) {
      this._value = args$1.value, this._error = args$1.error;
    }
    value() {
      return this._value;
    }
    reason() {
      return this._error;
    }
    isRejected() {
      return !!this._error;
    }
    isFulfilled() {
      return !!this._value;
    }
  };
  exports$12.PromiseInspection = PromiseInspection;
}), require_utils$6 = __commonJSMin$1((exports$12) => {
  Object.defineProperty(exports$12, `__esModule`, { value: true });
  let PromiseInspection_1 = require_PromiseInspection();
  function defer$2() {
    let resolve = null, reject$2 = null, promise = new Promise((resolver, rejecter) => {
      resolve = resolver, reject$2 = rejecter;
    });
    return { promise, resolve, reject: reject$2 };
  }
  exports$12.defer = defer$2;
  function now$2() {
    return Date.now();
  }
  exports$12.now = now$2;
  function duration(t1, t2) {
    return Math.abs(t2 - t1);
  }
  exports$12.duration = duration;
  function checkOptionalTime(time) {
    return time === void 0 ? true : checkRequiredTime(time);
  }
  exports$12.checkOptionalTime = checkOptionalTime;
  function checkRequiredTime(time) {
    return typeof time == `number` && time === Math.round(time) && time > 0;
  }
  exports$12.checkRequiredTime = checkRequiredTime;
  function delay(millis) {
    return new Promise((resolve) => setTimeout(resolve, millis));
  }
  exports$12.delay = delay;
  function reflect(promise) {
    return promise.then((value) => new PromiseInspection_1.PromiseInspection({ value })).catch((error) => new PromiseInspection_1.PromiseInspection({ error }));
  }
  exports$12.reflect = reflect;
  function tryPromise(cb) {
    try {
      let result = cb();
      return Promise.resolve(result);
    } catch (err$1) {
      return Promise.reject(err$1);
    }
  }
  exports$12.tryPromise = tryPromise;
}), require_PendingOperation = __commonJSMin$1((exports$12) => {
  Object.defineProperty(exports$12, `__esModule`, { value: true });
  let TimeoutError_1$1 = require_TimeoutError(), utils_1$2 = require_utils$6();
  var PendingOperation = class {
    constructor(timeoutMillis) {
      this.timeoutMillis = timeoutMillis, this.deferred = utils_1$2.defer(), this.possibleTimeoutCause = null, this.isRejected = false, this.promise = timeout$4(this.deferred.promise, timeoutMillis).catch((err$1) => (err$1 instanceof TimeoutError_1$1.TimeoutError && (err$1 = this.possibleTimeoutCause ? new TimeoutError_1$1.TimeoutError(this.possibleTimeoutCause.message) : new TimeoutError_1$1.TimeoutError(`operation timed out for an unknown reason`)), this.isRejected = true, Promise.reject(err$1)));
    }
    abort() {
      this.reject(Error(`aborted`));
    }
    reject(err$1) {
      this.deferred.reject(err$1);
    }
    resolve(value) {
      this.deferred.resolve(value);
    }
  };
  exports$12.PendingOperation = PendingOperation;
  function timeout$4(promise, time) {
    return new Promise((resolve, reject$2) => {
      let timeoutHandle = setTimeout(() => reject$2(new TimeoutError_1$1.TimeoutError()), time);
      promise.then((result) => {
        clearTimeout(timeoutHandle), resolve(result);
      }).catch((err$1) => {
        clearTimeout(timeoutHandle), reject$2(err$1);
      });
    });
  }
}), require_Resource = __commonJSMin$1((exports$12) => {
  Object.defineProperty(exports$12, `__esModule`, { value: true });
  let utils_1$1 = require_utils$6();
  var Resource = class Resource2 {
    constructor(resource) {
      this.resource = resource, this.resource = resource, this.timestamp = utils_1$1.now(), this.deferred = utils_1$1.defer();
    }
    get promise() {
      return this.deferred.promise;
    }
    resolve() {
      return this.deferred.resolve(void 0), new Resource2(this.resource);
    }
  };
  exports$12.Resource = Resource;
}), require_events = __commonJSMin$1((exports$12, module2) => {
  var R$1 = typeof Reflect == `object` ? Reflect : null, ReflectApply = R$1 && typeof R$1.apply == `function` ? R$1.apply : function(target, receiver, args$1) {
    return Function.prototype.apply.call(target, receiver, args$1);
  }, ReflectOwnKeys;
  ReflectOwnKeys = R$1 && typeof R$1.ownKeys == `function` ? R$1.ownKeys : Object.getOwnPropertySymbols ? function(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
  } : function(target) {
    return Object.getOwnPropertyNames(target);
  };
  function ProcessEmitWarning(warning) {
    console && console.warn && console.warn(warning);
  }
  var NumberIsNaN = Number.isNaN || function(value) {
    return value !== value;
  };
  function EventEmitter$7() {
    EventEmitter$7.init.call(this);
  }
  module2.exports = EventEmitter$7, module2.exports.once = once$2, EventEmitter$7.EventEmitter = EventEmitter$7, EventEmitter$7.prototype._events = void 0, EventEmitter$7.prototype._eventsCount = 0, EventEmitter$7.prototype._maxListeners = void 0;
  var defaultMaxListeners = 10;
  function checkListener(listener) {
    if (typeof listener != `function`) throw TypeError(`The "listener" argument must be of type Function. Received type ` + typeof listener);
  }
  Object.defineProperty(EventEmitter$7, `defaultMaxListeners`, { enumerable: true, get: function() {
    return defaultMaxListeners;
  }, set: function(arg) {
    if (typeof arg != `number` || arg < 0 || NumberIsNaN(arg)) throw RangeError(`The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ` + arg + `.`);
    defaultMaxListeners = arg;
  } }), EventEmitter$7.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, EventEmitter$7.prototype.setMaxListeners = function(n$4) {
    if (typeof n$4 != `number` || n$4 < 0 || NumberIsNaN(n$4)) throw RangeError(`The value of "n" is out of range. It must be a non-negative number. Received ` + n$4 + `.`);
    return this._maxListeners = n$4, this;
  };
  function _getMaxListeners(that) {
    return that._maxListeners === void 0 ? EventEmitter$7.defaultMaxListeners : that._maxListeners;
  }
  EventEmitter$7.prototype.getMaxListeners = function() {
    return _getMaxListeners(this);
  }, EventEmitter$7.prototype.emit = function(type) {
    for (var args$1 = [], i$4 = 1; i$4 < arguments.length; i$4++) args$1.push(arguments[i$4]);
    var doError = type === `error`, events = this._events;
    if (events !== void 0) doError &&= events.error === void 0;
    else if (!doError) return false;
    if (doError) {
      var er;
      if (args$1.length > 0 && (er = args$1[0]), er instanceof Error) throw er;
      var err$1 = Error(`Unhandled error.` + (er ? ` (` + er.message + `)` : ``));
      throw err$1.context = er, err$1;
    }
    var handler = events[type];
    if (handler === void 0) return false;
    if (typeof handler == `function`) ReflectApply(handler, this, args$1);
    else for (var len$2 = handler.length, listeners = arrayClone(handler, len$2), i$4 = 0; i$4 < len$2; ++i$4) ReflectApply(listeners[i$4], this, args$1);
    return true;
  };
  function _addListener(target, type, listener, prepend) {
    var m$3, events, existing;
    if (checkListener(listener), events = target._events, events === void 0 ? (events = target._events = /* @__PURE__ */ Object.create(null), target._eventsCount = 0) : (events.newListener !== void 0 && (target.emit(`newListener`, type, listener.listener ? listener.listener : listener), events = target._events), existing = events[type]), existing === void 0) existing = events[type] = listener, ++target._eventsCount;
    else if (typeof existing == `function` ? existing = events[type] = prepend ? [listener, existing] : [existing, listener] : prepend ? existing.unshift(listener) : existing.push(listener), m$3 = _getMaxListeners(target), m$3 > 0 && existing.length > m$3 && !existing.warned) {
      existing.warned = true;
      var w$1 = Error(`Possible EventEmitter memory leak detected. ` + existing.length + ` ` + String(type) + ` listeners added. Use emitter.setMaxListeners() to increase limit`);
      w$1.name = `MaxListenersExceededWarning`, w$1.emitter = target, w$1.type = type, w$1.count = existing.length, ProcessEmitWarning(w$1);
    }
    return target;
  }
  EventEmitter$7.prototype.addListener = function(type, listener) {
    return _addListener(this, type, listener, false);
  }, EventEmitter$7.prototype.on = EventEmitter$7.prototype.addListener, EventEmitter$7.prototype.prependListener = function(type, listener) {
    return _addListener(this, type, listener, true);
  };
  function onceWrapper() {
    if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = true, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function _onceWrap(target, type, listener) {
    var state = { fired: false, wrapFn: void 0, target, type, listener }, wrapped = onceWrapper.bind(state);
    return wrapped.listener = listener, state.wrapFn = wrapped, wrapped;
  }
  EventEmitter$7.prototype.once = function(type, listener) {
    return checkListener(listener), this.on(type, _onceWrap(this, type, listener)), this;
  }, EventEmitter$7.prototype.prependOnceListener = function(type, listener) {
    return checkListener(listener), this.prependListener(type, _onceWrap(this, type, listener)), this;
  }, EventEmitter$7.prototype.removeListener = function(type, listener) {
    var list, events, position, i$4, originalListener;
    if (checkListener(listener), events = this._events, events === void 0 || (list = events[type], list === void 0)) return this;
    if (list === listener || list.listener === listener) --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete events[type], events.removeListener && this.emit(`removeListener`, type, list.listener || listener));
    else if (typeof list != `function`) {
      for (position = -1, i$4 = list.length - 1; i$4 >= 0; i$4--) if (list[i$4] === listener || list[i$4].listener === listener) {
        originalListener = list[i$4].listener, position = i$4;
        break;
      }
      if (position < 0) return this;
      position === 0 ? list.shift() : spliceOne(list, position), list.length === 1 && (events[type] = list[0]), events.removeListener !== void 0 && this.emit(`removeListener`, type, originalListener || listener);
    }
    return this;
  }, EventEmitter$7.prototype.off = EventEmitter$7.prototype.removeListener, EventEmitter$7.prototype.removeAllListeners = function(type) {
    var listeners, events, i$4;
    if (events = this._events, events === void 0) return this;
    if (events.removeListener === void 0) return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : events[type] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete events[type]), this;
    if (arguments.length === 0) {
      var keys$10 = Object.keys(events), key;
      for (i$4 = 0; i$4 < keys$10.length; ++i$4) key = keys$10[i$4], key !== `removeListener` && this.removeAllListeners(key);
      return this.removeAllListeners(`removeListener`), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (listeners = events[type], typeof listeners == `function`) this.removeListener(type, listeners);
    else if (listeners !== void 0) for (i$4 = listeners.length - 1; i$4 >= 0; i$4--) this.removeListener(type, listeners[i$4]);
    return this;
  };
  function _listeners(target, type, unwrap) {
    var events = target._events;
    if (events === void 0) return [];
    var evlistener = events[type];
    return evlistener === void 0 ? [] : typeof evlistener == `function` ? unwrap ? [evlistener.listener || evlistener] : [evlistener] : unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
  }
  EventEmitter$7.prototype.listeners = function(type) {
    return _listeners(this, type, true);
  }, EventEmitter$7.prototype.rawListeners = function(type) {
    return _listeners(this, type, false);
  }, EventEmitter$7.listenerCount = function(emitter, type) {
    return typeof emitter.listenerCount == `function` ? emitter.listenerCount(type) : listenerCount.call(emitter, type);
  }, EventEmitter$7.prototype.listenerCount = listenerCount;
  function listenerCount(type) {
    var events = this._events;
    if (events !== void 0) {
      var evlistener = events[type];
      if (typeof evlistener == `function`) return 1;
      if (evlistener !== void 0) return evlistener.length;
    }
    return 0;
  }
  EventEmitter$7.prototype.eventNames = function() {
    return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
  };
  function arrayClone(arr, n$4) {
    for (var copy = Array(n$4), i$4 = 0; i$4 < n$4; ++i$4) copy[i$4] = arr[i$4];
    return copy;
  }
  function spliceOne(list, index$2) {
    for (; index$2 + 1 < list.length; index$2++) list[index$2] = list[index$2 + 1];
    list.pop();
  }
  function unwrapListeners(arr) {
    for (var ret = Array(arr.length), i$4 = 0; i$4 < ret.length; ++i$4) ret[i$4] = arr[i$4].listener || arr[i$4];
    return ret;
  }
  function once$2(emitter, name$2) {
    return new Promise(function(resolve, reject$2) {
      function errorListener(err$1) {
        emitter.removeListener(name$2, resolver), reject$2(err$1);
      }
      function resolver() {
        typeof emitter.removeListener == `function` && emitter.removeListener(`error`, errorListener), resolve([].slice.call(arguments));
      }
      eventTargetAgnosticAddListener(emitter, name$2, resolver, { once: true }), name$2 !== `error` && addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    });
  }
  function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    typeof emitter.on == `function` && eventTargetAgnosticAddListener(emitter, `error`, handler, flags);
  }
  function eventTargetAgnosticAddListener(emitter, name$2, listener, flags) {
    if (typeof emitter.on == `function`) flags.once ? emitter.once(name$2, listener) : emitter.on(name$2, listener);
    else if (typeof emitter.addEventListener == `function`) emitter.addEventListener(name$2, function wrapListener(arg) {
      flags.once && emitter.removeEventListener(name$2, wrapListener), listener(arg);
    });
    else throw TypeError(`The "emitter" argument must be of type EventEmitter. Received type ` + typeof emitter);
  }
}), init_setImmediate = __esmMin(() => {
  init_dist(), (function(global2, undefined$2) {
    if (global2.setImmediate) return;
    var nextHandle = 1, tasksByHandle = {}, currentlyRunningATask = false, doc = global2.document, registerImmediate;
    function setImmediate(callback) {
      typeof callback != `function` && (callback = Function(`` + callback));
      for (var args$1 = Array(arguments.length - 1), i$4 = 0; i$4 < args$1.length; i$4++) args$1[i$4] = arguments[i$4 + 1];
      var task = { callback, args: args$1 };
      return tasksByHandle[nextHandle] = task, registerImmediate(nextHandle), nextHandle++;
    }
    function clearImmediate(handle) {
      delete tasksByHandle[handle];
    }
    function run(task) {
      var callback = task.callback, args$1 = task.args;
      switch (args$1.length) {
        case 0:
          callback();
          break;
        case 1:
          callback(args$1[0]);
          break;
        case 2:
          callback(args$1[0], args$1[1]);
          break;
        case 3:
          callback(args$1[0], args$1[1], args$1[2]);
          break;
        default:
          callback.apply(undefined$2, args$1);
          break;
      }
    }
    function runIfPresent(handle) {
      if (currentlyRunningATask) setTimeout(runIfPresent, 0, handle);
      else {
        var task = tasksByHandle[handle];
        if (task) {
          currentlyRunningATask = true;
          try {
            run(task);
          } finally {
            clearImmediate(handle), currentlyRunningATask = false;
          }
        }
      }
    }
    function installNextTickImplementation() {
      registerImmediate = function(handle) {
        process$1.nextTick(function() {
          runIfPresent(handle);
        });
      };
    }
    function canUsePostMessage() {
      if (global2.postMessage && !global2.importScripts) {
        var postMessageIsAsynchronous = true, oldOnMessage = global2.onmessage;
        return global2.onmessage = function() {
          postMessageIsAsynchronous = false;
        }, global2.postMessage(``, `*`), global2.onmessage = oldOnMessage, postMessageIsAsynchronous;
      }
    }
    function installPostMessageImplementation() {
      var messagePrefix = `setImmediate$` + Math.random() + `$`, onGlobalMessage = function(event) {
        event.source === global2 && typeof event.data == `string` && event.data.indexOf(messagePrefix) === 0 && runIfPresent(+event.data.slice(messagePrefix.length));
      };
      global2.addEventListener ? global2.addEventListener(`message`, onGlobalMessage, false) : global2.attachEvent(`onmessage`, onGlobalMessage), registerImmediate = function(handle) {
        global2.postMessage(messagePrefix + handle, `*`);
      };
    }
    function installMessageChannelImplementation() {
      var channel = new MessageChannel();
      channel.port1.onmessage = function(event) {
        var handle = event.data;
        runIfPresent(handle);
      }, registerImmediate = function(handle) {
        channel.port2.postMessage(handle);
      };
    }
    function installReadyStateChangeImplementation() {
      var html = doc.documentElement;
      registerImmediate = function(handle) {
        var script = doc.createElement(`script`);
        script.onreadystatechange = function() {
          runIfPresent(handle), script.onreadystatechange = null, html.removeChild(script), script = null;
        }, html.appendChild(script);
      };
    }
    function installSetTimeoutImplementation() {
      registerImmediate = function(handle) {
        setTimeout(runIfPresent, 0, handle);
      };
    }
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global2);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global2, {}.toString.call(global2.process) === `[object process]` ? installNextTickImplementation() : canUsePostMessage() ? installPostMessageImplementation() : global2.MessageChannel ? installMessageChannelImplementation() : doc && `onreadystatechange` in doc.createElement(`script`) ? installReadyStateChangeImplementation() : installSetTimeoutImplementation(), attachTo.setImmediate = setImmediate, attachTo.clearImmediate = clearImmediate;
  })(typeof self > `u` ? {} : self);
}), require_main = __commonJSMin$1((exports$12) => {
  var scope = {}, apply$2 = Function.prototype.apply;
  exports$12.setTimeout = function() {
    return new Timeout(apply$2.call(setTimeout, scope, arguments), clearTimeout);
  }, exports$12.setInterval = function() {
    return new Timeout(apply$2.call(setInterval, scope, arguments), clearInterval);
  }, exports$12.clearTimeout = exports$12.clearInterval = function(timeout$5) {
    timeout$5 && timeout$5.close();
  };
  function Timeout(id, clearFn) {
    this._id = id, this._clearFn = clearFn;
  }
  Timeout.prototype.unref = Timeout.prototype.ref = function() {
  }, Timeout.prototype.close = function() {
    this._clearFn.call(scope, this._id);
  }, exports$12.enroll = function(item, msecs) {
    clearTimeout(item._idleTimeoutId), item._idleTimeout = msecs;
  }, exports$12.unenroll = function(item) {
    clearTimeout(item._idleTimeoutId), item._idleTimeout = -1;
  }, exports$12._unrefActive = exports$12.active = function(item) {
    clearTimeout(item._idleTimeoutId);
    var msecs = item._idleTimeout;
    msecs >= 0 && (item._idleTimeoutId = setTimeout(function() {
      item._onTimeout && item._onTimeout();
    }, msecs));
  }, init_setImmediate(), exports$12.setImmediate = typeof self < `u` && self.setImmediate || {}.setImmediate || exports$12 && exports$12.setImmediate, exports$12.clearImmediate = typeof self < `u` && self.clearImmediate || {}.clearImmediate || exports$12 && exports$12.clearImmediate;
}), require_Pool = __commonJSMin$1((exports$12) => {
  Object.defineProperty(exports$12, `__esModule`, { value: true });
  let PendingOperation_1 = require_PendingOperation(), Resource_1 = require_Resource(), utils_1 = require_utils$6(), events_1 = require_events(), timers_1 = require_main();
  var Pool$2 = class {
    constructor(opt) {
      if (this.destroyed = false, this.emitter = new events_1.EventEmitter(), opt ||= {}, !opt.create) throw Error(`Tarn: opt.create function most be provided`);
      if (!opt.destroy) throw Error(`Tarn: opt.destroy function most be provided`);
      if (typeof opt.min != `number` || opt.min < 0 || opt.min !== Math.round(opt.min)) throw Error(`Tarn: opt.min must be an integer >= 0`);
      if (typeof opt.max != `number` || opt.max <= 0 || opt.max !== Math.round(opt.max)) throw Error(`Tarn: opt.max must be an integer > 0`);
      if (opt.min > opt.max) throw Error(`Tarn: opt.max is smaller than opt.min`);
      if (!utils_1.checkOptionalTime(opt.acquireTimeoutMillis)) throw Error(`Tarn: invalid opt.acquireTimeoutMillis ` + JSON.stringify(opt.acquireTimeoutMillis));
      if (!utils_1.checkOptionalTime(opt.createTimeoutMillis)) throw Error(`Tarn: invalid opt.createTimeoutMillis ` + JSON.stringify(opt.createTimeoutMillis));
      if (!utils_1.checkOptionalTime(opt.destroyTimeoutMillis)) throw Error(`Tarn: invalid opt.destroyTimeoutMillis ` + JSON.stringify(opt.destroyTimeoutMillis));
      if (!utils_1.checkOptionalTime(opt.idleTimeoutMillis)) throw Error(`Tarn: invalid opt.idleTimeoutMillis ` + JSON.stringify(opt.idleTimeoutMillis));
      if (!utils_1.checkOptionalTime(opt.reapIntervalMillis)) throw Error(`Tarn: invalid opt.reapIntervalMillis ` + JSON.stringify(opt.reapIntervalMillis));
      if (!utils_1.checkOptionalTime(opt.createRetryIntervalMillis)) throw Error(`Tarn: invalid opt.createRetryIntervalMillis ` + JSON.stringify(opt.createRetryIntervalMillis));
      let allowedKeys = { create: true, validate: true, destroy: true, log: true, min: true, max: true, acquireTimeoutMillis: true, createTimeoutMillis: true, destroyTimeoutMillis: true, idleTimeoutMillis: true, reapIntervalMillis: true, createRetryIntervalMillis: true, propagateCreateError: true };
      for (let key of Object.keys(opt)) if (!allowedKeys[key]) throw Error(`Tarn: unsupported option opt.${key}`);
      this.creator = opt.create, this.destroyer = opt.destroy, this.validate = typeof opt.validate == `function` ? opt.validate : () => true, this.log = opt.log || (() => {
      }), this.acquireTimeoutMillis = opt.acquireTimeoutMillis || 3e4, this.createTimeoutMillis = opt.createTimeoutMillis || 3e4, this.destroyTimeoutMillis = opt.destroyTimeoutMillis || 5e3, this.idleTimeoutMillis = opt.idleTimeoutMillis || 3e4, this.reapIntervalMillis = opt.reapIntervalMillis || 1e3, this.createRetryIntervalMillis = opt.createRetryIntervalMillis || 200, this.propagateCreateError = !!opt.propagateCreateError, this.min = opt.min, this.max = opt.max, this.used = [], this.free = [], this.pendingCreates = [], this.pendingAcquires = [], this.pendingDestroys = [], this.pendingValidations = [], this.destroyed = false, this.interval = null, this.eventId = 1;
    }
    numUsed() {
      return this.used.length;
    }
    numFree() {
      return this.free.length;
    }
    numPendingAcquires() {
      return this.pendingAcquires.length;
    }
    numPendingValidations() {
      return this.pendingValidations.length;
    }
    numPendingCreates() {
      return this.pendingCreates.length;
    }
    acquire() {
      let eventId = this.eventId++;
      this._executeEventHandlers(`acquireRequest`, eventId);
      let pendingAcquire = new PendingOperation_1.PendingOperation(this.acquireTimeoutMillis);
      return this.pendingAcquires.push(pendingAcquire), pendingAcquire.promise = pendingAcquire.promise.then((resource) => (this._executeEventHandlers(`acquireSuccess`, eventId, resource), resource)).catch((err$1) => (this._executeEventHandlers(`acquireFail`, eventId, err$1), remove(this.pendingAcquires, pendingAcquire), Promise.reject(err$1))), this._tryAcquireOrCreate(), pendingAcquire;
    }
    release(resource) {
      this._executeEventHandlers(`release`, resource);
      for (let i$4 = 0, l$4 = this.used.length; i$4 < l$4; ++i$4) {
        let used = this.used[i$4];
        if (used.resource === resource) return this.used.splice(i$4, 1), this.free.push(used.resolve()), this._tryAcquireOrCreate(), true;
      }
      return false;
    }
    isEmpty() {
      return [this.numFree(), this.numUsed(), this.numPendingAcquires(), this.numPendingValidations(), this.numPendingCreates()].reduce((total, value) => total + value) === 0;
    }
    check() {
      let timestamp$1 = utils_1.now(), newFree = [], minKeep = this.min - this.used.length, maxDestroy = this.free.length - minKeep, numDestroyed = 0;
      this.free.forEach((free) => {
        utils_1.duration(timestamp$1, free.timestamp) >= this.idleTimeoutMillis && numDestroyed < maxDestroy ? (numDestroyed++, this._destroy(free.resource)) : newFree.push(free);
      }), this.free = newFree, this.isEmpty() && this._stopReaping();
    }
    destroy() {
      let eventId = this.eventId++;
      return this._executeEventHandlers(`poolDestroyRequest`, eventId), this._stopReaping(), this.destroyed = true, utils_1.reflect(Promise.all(this.pendingCreates.map((create) => utils_1.reflect(create.promise))).then(() => new Promise((resolve, reject$2) => {
        if (this.numPendingValidations() === 0) {
          resolve();
          return;
        }
        let interval = setInterval(() => {
          this.numPendingValidations() === 0 && (timers_1.clearInterval(interval), resolve());
        }, 100);
      })).then(() => Promise.all(this.used.map((used) => utils_1.reflect(used.promise)))).then(() => Promise.all(this.pendingAcquires.map((acquire) => (acquire.abort(), utils_1.reflect(acquire.promise))))).then(() => Promise.all(this.free.map((free) => utils_1.reflect(this._destroy(free.resource))))).then(() => Promise.all(this.pendingDestroys.map((pd) => pd.promise))).then(() => {
        this.free = [], this.pendingAcquires = [];
      })).then((res) => (this._executeEventHandlers(`poolDestroySuccess`, eventId), this.emitter.removeAllListeners(), res));
    }
    on(event, listener) {
      this.emitter.on(event, listener);
    }
    removeListener(event, listener) {
      this.emitter.removeListener(event, listener);
    }
    removeAllListeners(event) {
      this.emitter.removeAllListeners(event);
    }
    _tryAcquireOrCreate() {
      this.destroyed || (this._hasFreeResources() ? this._doAcquire() : this._shouldCreateMoreResources() && this._doCreate());
    }
    _hasFreeResources() {
      return this.free.length > 0;
    }
    _doAcquire() {
      for (; this._canAcquire(); ) {
        let pendingAcquire = this.pendingAcquires.shift(), free = this.free.pop();
        if (free === void 0 || pendingAcquire === void 0) {
          let errMessage = `this.free was empty while trying to acquire resource`;
          throw this.log(`Tarn: ${errMessage}`, `warn`), Error(`Internal error, should never happen. ${errMessage}`);
        }
        this.pendingValidations.push(pendingAcquire), this.used.push(free);
        let abortAbleValidation = new PendingOperation_1.PendingOperation(this.acquireTimeoutMillis);
        pendingAcquire.promise.catch((err$1) => {
          abortAbleValidation.abort();
        }), abortAbleValidation.promise.catch((err$1) => (this.log(`Tarn: resource validator threw an exception ` + err$1.stack, `warn`), false)).then((validationSuccess) => {
          try {
            validationSuccess && !pendingAcquire.isRejected ? (this._startReaping(), pendingAcquire.resolve(free.resource)) : (remove(this.used, free), validationSuccess ? this.free.push(free) : (this._destroy(free.resource), setTimeout(() => {
              this._tryAcquireOrCreate();
            }, 0)), pendingAcquire.isRejected || this.pendingAcquires.unshift(pendingAcquire));
          } finally {
            remove(this.pendingValidations, pendingAcquire);
          }
        }), this._validateResource(free.resource).then((validationSuccess) => {
          abortAbleValidation.resolve(validationSuccess);
        }).catch((err$1) => {
          abortAbleValidation.reject(err$1);
        });
      }
    }
    _canAcquire() {
      return this.free.length > 0 && this.pendingAcquires.length > 0;
    }
    _validateResource(resource) {
      try {
        return Promise.resolve(this.validate(resource));
      } catch (err$1) {
        return Promise.reject(err$1);
      }
    }
    _shouldCreateMoreResources() {
      return this.used.length + this.pendingCreates.length < this.max && this.pendingCreates.length < this.pendingAcquires.length;
    }
    _doCreate() {
      let pendingAcquiresBeforeCreate = this.pendingAcquires.slice(), pendingCreate = this._create();
      pendingCreate.promise.then(() => (this._tryAcquireOrCreate(), null)).catch((err$1) => {
        this.propagateCreateError && this.pendingAcquires.length !== 0 && this.pendingAcquires[0].reject(err$1), pendingAcquiresBeforeCreate.forEach((pendingAcquire) => {
          pendingAcquire.possibleTimeoutCause = err$1;
        }), utils_1.delay(this.createRetryIntervalMillis).then(() => this._tryAcquireOrCreate());
      });
    }
    _create() {
      let eventId = this.eventId++;
      this._executeEventHandlers(`createRequest`, eventId);
      let pendingCreate = new PendingOperation_1.PendingOperation(this.createTimeoutMillis);
      return pendingCreate.promise = pendingCreate.promise.catch((err$1) => {
        throw remove(this.pendingCreates, pendingCreate) && this._executeEventHandlers(`createFail`, eventId, err$1), err$1;
      }), this.pendingCreates.push(pendingCreate), callbackOrPromise(this.creator).then((resource) => pendingCreate.isRejected ? (this.destroyer(resource), null) : (remove(this.pendingCreates, pendingCreate), this.free.push(new Resource_1.Resource(resource)), pendingCreate.resolve(resource), this._executeEventHandlers(`createSuccess`, eventId, resource), null)).catch((err$1) => pendingCreate.isRejected ? null : (remove(this.pendingCreates, pendingCreate) && this._executeEventHandlers(`createFail`, eventId, err$1), pendingCreate.reject(err$1), null)), pendingCreate;
    }
    _destroy(resource) {
      let eventId = this.eventId++;
      this._executeEventHandlers(`destroyRequest`, eventId, resource);
      let pendingDestroy = new PendingOperation_1.PendingOperation(this.destroyTimeoutMillis), retVal = Promise.resolve().then(() => this.destroyer(resource));
      return retVal.then(() => {
        pendingDestroy.resolve(resource);
      }).catch((err$1) => {
        pendingDestroy.reject(err$1);
      }), this.pendingDestroys.push(pendingDestroy), pendingDestroy.promise.then((res) => (this._executeEventHandlers(`destroySuccess`, eventId, resource), res)).catch((err$1) => this._logDestroyerError(eventId, resource, err$1)).then((res) => {
        let index$2 = this.pendingDestroys.findIndex((pd) => pd === pendingDestroy);
        return this.pendingDestroys.splice(index$2, 1), res;
      });
    }
    _logDestroyerError(eventId, resource, err$1) {
      this._executeEventHandlers(`destroyFail`, eventId, resource, err$1), this.log(`Tarn: resource destroyer threw an exception ` + err$1.stack, `warn`);
    }
    _startReaping() {
      this.interval || (this._executeEventHandlers(`startReaping`), this.interval = setInterval(() => this.check(), this.reapIntervalMillis));
    }
    _stopReaping() {
      this.interval !== null && (this._executeEventHandlers(`stopReaping`), timers_1.clearInterval(this.interval)), this.interval = null;
    }
    _executeEventHandlers(eventName, ...args$1) {
      let listeners = this.emitter.listeners(eventName);
      listeners.forEach((listener) => {
        try {
          listener(...args$1);
        } catch (err$1) {
          this.log(`Tarn: event handler "${eventName}" threw an exception ${err$1.stack}`, `warn`);
        }
      });
    }
  };
  exports$12.Pool = Pool$2;
  function remove(arr, item) {
    let idx = arr.indexOf(item);
    return idx === -1 ? false : (arr.splice(idx, 1), true);
  }
  function callbackOrPromise(func) {
    return new Promise((resolve, reject$2) => {
      let callback = (err$1, resource) => {
        err$1 ? reject$2(err$1) : resolve(resource);
      };
      utils_1.tryPromise(() => func(callback)).then((res) => {
        res && resolve(res);
      }).catch((err$1) => {
        reject$2(err$1);
      });
    });
  }
}), require_tarn = __commonJSMin$1((exports$12, module2) => {
  Object.defineProperty(exports$12, `__esModule`, { value: true });
  let Pool_1 = require_Pool();
  exports$12.Pool = Pool_1.Pool;
  let TimeoutError_1 = require_TimeoutError();
  exports$12.TimeoutError = TimeoutError_1.TimeoutError, module2.exports = { Pool: Pool_1.Pool, TimeoutError: TimeoutError_1.TimeoutError };
}), require_ms = __commonJSMin$1((exports$12, module2) => {
  var s$5 = 1e3, m$2 = s$5 * 60, h = m$2 * 60, d2 = h * 24, w = d2 * 7, y = d2 * 365.25;
  module2.exports = function(val, options) {
    options ||= {};
    var type = typeof val;
    if (type === `string` && val.length > 0) return parse$12(val);
    if (type === `number` && isFinite(val)) return options.long ? fmtLong(val) : fmtShort(val);
    throw Error(`val is not a non-empty string or a valid number. val=` + JSON.stringify(val));
  };
  function parse$12(str) {
    if (str = String(str), !(str.length > 100)) {
      var match$2 = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
      if (match$2) {
        var n$4 = parseFloat(match$2[1]), type = (match$2[2] || `ms`).toLowerCase();
        switch (type) {
          case `years`:
          case `year`:
          case `yrs`:
          case `yr`:
          case `y`:
            return n$4 * y;
          case `weeks`:
          case `week`:
          case `w`:
            return n$4 * w;
          case `days`:
          case `day`:
          case `d`:
            return n$4 * d2;
          case `hours`:
          case `hour`:
          case `hrs`:
          case `hr`:
          case `h`:
            return n$4 * h;
          case `minutes`:
          case `minute`:
          case `mins`:
          case `min`:
          case `m`:
            return n$4 * m$2;
          case `seconds`:
          case `second`:
          case `secs`:
          case `sec`:
          case `s`:
            return n$4 * s$5;
          case `milliseconds`:
          case `millisecond`:
          case `msecs`:
          case `msec`:
          case `ms`:
            return n$4;
          default:
            return;
        }
      }
    }
  }
  function fmtShort(ms) {
    var msAbs = Math.abs(ms);
    return msAbs >= d2 ? Math.round(ms / d2) + `d` : msAbs >= h ? Math.round(ms / h) + `h` : msAbs >= m$2 ? Math.round(ms / m$2) + `m` : msAbs >= s$5 ? Math.round(ms / s$5) + `s` : ms + `ms`;
  }
  function fmtLong(ms) {
    var msAbs = Math.abs(ms);
    return msAbs >= d2 ? plural(ms, msAbs, d2, `day`) : msAbs >= h ? plural(ms, msAbs, h, `hour`) : msAbs >= m$2 ? plural(ms, msAbs, m$2, `minute`) : msAbs >= s$5 ? plural(ms, msAbs, s$5, `second`) : ms + ` ms`;
  }
  function plural(ms, msAbs, n$4, name$2) {
    var isPlural = msAbs >= n$4 * 1.5;
    return Math.round(ms / n$4) + ` ` + name$2 + (isPlural ? `s` : ``);
  }
}), require_common$2 = __commonJSMin$1((exports$12, module2) => {
  function setup(env$1) {
    createDebug.debug = createDebug, createDebug.default = createDebug, createDebug.coerce = coerce$3, createDebug.disable = disable, createDebug.enable = enable, createDebug.enabled = enabled, createDebug.humanize = require_ms(), createDebug.destroy = destroy$1, Object.keys(env$1).forEach((key) => {
      createDebug[key] = env$1[key];
    }), createDebug.names = [], createDebug.skips = [], createDebug.formatters = {};
    function selectColor(namespace) {
      let hash$4 = 0;
      for (let i$4 = 0; i$4 < namespace.length; i$4++) hash$4 = (hash$4 << 5) - hash$4 + namespace.charCodeAt(i$4), hash$4 |= 0;
      return createDebug.colors[Math.abs(hash$4) % createDebug.colors.length];
    }
    createDebug.selectColor = selectColor;
    function createDebug(namespace) {
      let prevTime, enableOverride = null, namespacesCache, enabledCache;
      function debug$13(...args$1) {
        if (!debug$13.enabled) return;
        let self$1 = debug$13, curr = Number(/* @__PURE__ */ new Date()), ms = curr - (prevTime || curr);
        self$1.diff = ms, self$1.prev = prevTime, self$1.curr = curr, prevTime = curr, args$1[0] = createDebug.coerce(args$1[0]), typeof args$1[0] != `string` && args$1.unshift(`%O`);
        let index$2 = 0;
        args$1[0] = args$1[0].replace(/%([a-zA-Z%])/g, (match$2, format) => {
          if (match$2 === `%%`) return `%`;
          index$2++;
          let formatter = createDebug.formatters[format];
          if (typeof formatter == `function`) {
            let val = args$1[index$2];
            match$2 = formatter.call(self$1, val), args$1.splice(index$2, 1), index$2--;
          }
          return match$2;
        }), createDebug.formatArgs.call(self$1, args$1);
        let logFn = self$1.log || createDebug.log;
        logFn.apply(self$1, args$1);
      }
      return debug$13.namespace = namespace, debug$13.useColors = createDebug.useColors(), debug$13.color = createDebug.selectColor(namespace), debug$13.extend = extend$4, debug$13.destroy = createDebug.destroy, Object.defineProperty(debug$13, `enabled`, { enumerable: true, configurable: false, get: () => enableOverride === null ? (namespacesCache !== createDebug.namespaces && (namespacesCache = createDebug.namespaces, enabledCache = createDebug.enabled(namespace)), enabledCache) : enableOverride, set: (v$1) => {
        enableOverride = v$1;
      } }), typeof createDebug.init == `function` && createDebug.init(debug$13), debug$13;
    }
    function extend$4(namespace, delimiter) {
      let newDebug = createDebug(this.namespace + (delimiter === void 0 ? `:` : delimiter) + namespace);
      return newDebug.log = this.log, newDebug;
    }
    function enable(namespaces) {
      createDebug.save(namespaces), createDebug.namespaces = namespaces, createDebug.names = [], createDebug.skips = [];
      let i$4, split = (typeof namespaces == `string` ? namespaces : ``).split(/[\s,]+/), len$2 = split.length;
      for (i$4 = 0; i$4 < len$2; i$4++) split[i$4] && (namespaces = split[i$4].replace(/\*/g, `.*?`), namespaces[0] === `-` ? createDebug.skips.push(RegExp(`^` + namespaces.slice(1) + `$`)) : createDebug.names.push(RegExp(`^` + namespaces + `$`)));
    }
    function disable() {
      let namespaces = [...createDebug.names.map(toNamespace), ...createDebug.skips.map(toNamespace).map((namespace) => `-` + namespace)].join(`,`);
      return createDebug.enable(``), namespaces;
    }
    function enabled(name$2) {
      if (name$2[name$2.length - 1] === `*`) return true;
      let i$4, len$2;
      for (i$4 = 0, len$2 = createDebug.skips.length; i$4 < len$2; i$4++) if (createDebug.skips[i$4].test(name$2)) return false;
      for (i$4 = 0, len$2 = createDebug.names.length; i$4 < len$2; i$4++) if (createDebug.names[i$4].test(name$2)) return true;
      return false;
    }
    function toNamespace(regexp) {
      return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, `*`);
    }
    function coerce$3(val) {
      return val instanceof Error ? val.stack || val.message : val;
    }
    function destroy$1() {
      console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
    }
    return createDebug.enable(createDebug.load()), createDebug;
  }
  module2.exports = setup;
}), require_browser$3 = __commonJSMin$1((exports$12, module2) => {
  init_dist(), exports$12.formatArgs = formatArgs$1, exports$12.save = save$1, exports$12.load = load$1, exports$12.useColors = useColors$1, exports$12.storage = localstorage(), exports$12.destroy = /* @__PURE__ */ (() => {
    let warned$1 = false;
    return () => {
      warned$1 || (warned$1 = true, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
    };
  })(), exports$12.colors = `#0000CC.#0000FF.#0033CC.#0033FF.#0066CC.#0066FF.#0099CC.#0099FF.#00CC00.#00CC33.#00CC66.#00CC99.#00CCCC.#00CCFF.#3300CC.#3300FF.#3333CC.#3333FF.#3366CC.#3366FF.#3399CC.#3399FF.#33CC00.#33CC33.#33CC66.#33CC99.#33CCCC.#33CCFF.#6600CC.#6600FF.#6633CC.#6633FF.#66CC00.#66CC33.#9900CC.#9900FF.#9933CC.#9933FF.#99CC00.#99CC33.#CC0000.#CC0033.#CC0066.#CC0099.#CC00CC.#CC00FF.#CC3300.#CC3333.#CC3366.#CC3399.#CC33CC.#CC33FF.#CC6600.#CC6633.#CC9900.#CC9933.#CCCC00.#CCCC33.#FF0000.#FF0033.#FF0066.#FF0099.#FF00CC.#FF00FF.#FF3300.#FF3333.#FF3366.#FF3399.#FF33CC.#FF33FF.#FF6600.#FF6633.#FF9900.#FF9933.#FFCC00.#FFCC33`.split(`.`);
  function useColors$1() {
    return typeof window < `u` && window.process && (window.process.type === `renderer` || window.process.__nwjs) ? true : typeof navigator < `u` && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? false : typeof document < `u` && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window < `u` && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator < `u` && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || typeof navigator < `u` && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  function formatArgs$1(args$1) {
    if (args$1[0] = (this.useColors ? `%c` : ``) + this.namespace + (this.useColors ? ` %c` : ` `) + args$1[0] + (this.useColors ? `%c ` : ` `) + `+` + module2.exports.humanize(this.diff), !this.useColors) return;
    let c$12 = `color: ` + this.color;
    args$1.splice(1, 0, c$12, `color: inherit`);
    let index$2 = 0, lastC = 0;
    args$1[0].replace(/%[a-zA-Z%]/g, (match$2) => {
      match$2 !== `%%` && (index$2++, match$2 === `%c` && (lastC = index$2));
    }), args$1.splice(lastC, 0, c$12);
  }
  exports$12.log = console.debug || console.log || (() => {
  });
  function save$1(namespaces) {
    try {
      namespaces ? exports$12.storage.setItem(`debug`, namespaces) : exports$12.storage.removeItem(`debug`);
    } catch {
    }
  }
  function load$1() {
    let r$2;
    try {
      r$2 = exports$12.storage.getItem(`debug`);
    } catch {
    }
    return !r$2 && process$1 !== void 0 && `env` in process$1 && (r$2 = process$1.env.DEBUG), r$2;
  }
  function localstorage() {
    try {
      return localStorage;
    } catch {
    }
  }
  module2.exports = require_common$2()(exports$12);
  let { formatters: formatters$1 } = module2.exports;
  formatters$1.j = function(v$1) {
    try {
      return JSON.stringify(v$1);
    } catch (error) {
      return `[UnexpectedJSONParseError]: ` + error.message;
    }
  };
}), require_has_flag = __commonJSMin$1((exports$12, module2) => {
  init_dist(), module2.exports = (flag, argv) => {
    argv ||= process$1.argv;
    let prefix = flag.startsWith(`-`) ? `` : flag.length === 1 ? `-` : `--`, pos = argv.indexOf(prefix + flag), terminatorPos = argv.indexOf(`--`);
    return pos !== -1 && (terminatorPos === -1 ? true : pos < terminatorPos);
  };
}), require_supports_color = __commonJSMin$1((exports$12, module2) => {
  init_dist();
  let os = __require$1(`os`), hasFlag = require_has_flag(), env = process$1.env, forceColor;
  hasFlag(`no-color`) || hasFlag(`no-colors`) || hasFlag(`color=false`) ? forceColor = false : (hasFlag(`color`) || hasFlag(`colors`) || hasFlag(`color=true`) || hasFlag(`color=always`)) && (forceColor = true), `FORCE_COLOR` in env && (forceColor = env.FORCE_COLOR.length === 0 || parseInt(env.FORCE_COLOR, 10) !== 0);
  function translateLevel(level) {
    return level === 0 ? false : { level, hasBasic: true, has256: level >= 2, has16m: level >= 3 };
  }
  function supportsColor(stream$1) {
    if (forceColor === false) return 0;
    if (hasFlag(`color=16m`) || hasFlag(`color=full`) || hasFlag(`color=truecolor`)) return 3;
    if (hasFlag(`color=256`)) return 2;
    if (stream$1 && !stream$1.isTTY && forceColor !== true) return 0;
    let min$1 = forceColor ? 1 : 0;
    if (process$1.platform === `win32`) {
      let osRelease = os.release().split(`.`);
      return Number(process$1.versions.node.split(`.`)[0]) >= 8 && Number(osRelease[0]) >= 10 && Number(osRelease[2]) >= 10586 ? Number(osRelease[2]) >= 14931 ? 3 : 2 : 1;
    }
    if (`CI` in env) return [`TRAVIS`, `CIRCLECI`, `APPVEYOR`, `GITLAB_CI`].some((sign$2) => sign$2 in env) || env.CI_NAME === `codeship` ? 1 : min$1;
    if (`TEAMCITY_VERSION` in env) return /^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(env.TEAMCITY_VERSION) ? 1 : 0;
    if (env.COLORTERM === `truecolor`) return 3;
    if (`TERM_PROGRAM` in env) {
      let version$4 = parseInt((env.TERM_PROGRAM_VERSION || ``).split(`.`)[0], 10);
      switch (env.TERM_PROGRAM) {
        case `iTerm.app`:
          return version$4 >= 3 ? 3 : 2;
        case `Apple_Terminal`:
          return 2;
      }
    }
    return /-256(color)?$/i.test(env.TERM) ? 2 : /^screen|^xterm|^vt100|^vt220|^rxvt|color|ansi|cygwin|linux/i.test(env.TERM) || `COLORTERM` in env ? 1 : (env.TERM, min$1);
  }
  function getSupportLevel(stream$1) {
    let level = supportsColor(stream$1);
    return translateLevel(level);
  }
  module2.exports = { supportsColor: getSupportLevel, stdout: getSupportLevel(process$1.stdout), stderr: getSupportLevel(process$1.stderr) };
}), require_node$2 = __commonJSMin$1((exports$12, module2) => {
  init_dist();
  let tty = __require$1(`tty`), util$1 = require_util();
  exports$12.init = init, exports$12.log = log, exports$12.formatArgs = formatArgs, exports$12.save = save, exports$12.load = load, exports$12.useColors = useColors, exports$12.destroy = util$1.deprecate(() => {
  }, "Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."), exports$12.colors = [6, 2, 3, 4, 5, 1];
  try {
    let supportsColor$1 = require_supports_color();
    supportsColor$1 && (supportsColor$1.stderr || supportsColor$1).level >= 2 && (exports$12.colors = [20, 21, 26, 27, 32, 33, 38, 39, 40, 41, 42, 43, 44, 45, 56, 57, 62, 63, 68, 69, 74, 75, 76, 77, 78, 79, 80, 81, 92, 93, 98, 99, 112, 113, 128, 129, 134, 135, 148, 149, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 178, 179, 184, 185, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 214, 215, 220, 221]);
  } catch {
  }
  exports$12.inspectOpts = Object.keys(process$1.env).filter((key) => /^debug_/i.test(key)).reduce((obj, key) => {
    let prop = key.substring(6).toLowerCase().replace(/_([a-z])/g, (_, k) => k.toUpperCase()), val = process$1.env[key];
    return val = /^(yes|on|true|enabled)$/i.test(val) ? true : /^(no|off|false|disabled)$/i.test(val) ? false : val === `null` ? null : Number(val), obj[prop] = val, obj;
  }, {});
  function useColors() {
    return `colors` in exports$12.inspectOpts ? !!exports$12.inspectOpts.colors : tty.isatty(process$1.stderr.fd);
  }
  function formatArgs(args$1) {
    let { namespace: name$2, useColors: useColors$2 } = this;
    if (useColors$2) {
      let c$12 = this.color, colorCode = `\x1B[3` + (c$12 < 8 ? c$12 : `8;5;` + c$12), prefix = `  ${colorCode};1m${name$2} \x1B[0m`;
      args$1[0] = prefix + args$1[0].split(`
`).join(`
` + prefix), args$1.push(colorCode + `m+` + module2.exports.humanize(this.diff) + `\x1B[0m`);
    } else args$1[0] = getDate() + name$2 + ` ` + args$1[0];
  }
  function getDate() {
    return exports$12.inspectOpts.hideDate ? `` : (/* @__PURE__ */ new Date()).toISOString() + ` `;
  }
  function log(...args$1) {
    return process$1.stderr.write(util$1.format(...args$1) + `
`);
  }
  function save(namespaces) {
    namespaces ? process$1.env.DEBUG = namespaces : delete process$1.env.DEBUG;
  }
  function load() {
    return process$1.env.DEBUG;
  }
  function init(debug$13) {
    debug$13.inspectOpts = {};
    let keys$10 = Object.keys(exports$12.inspectOpts);
    for (let i$4 = 0; i$4 < keys$10.length; i$4++) debug$13.inspectOpts[keys$10[i$4]] = exports$12.inspectOpts[keys$10[i$4]];
  }
  module2.exports = require_common$2()(exports$12);
  let { formatters } = module2.exports;
  formatters.o = function(v$1) {
    return this.inspectOpts.colors = this.useColors, util$1.inspect(v$1, this.inspectOpts).split(`
`).map((str) => str.trim()).join(` `);
  }, formatters.O = function(v$1) {
    return this.inspectOpts.colors = this.useColors, util$1.inspect(v$1, this.inspectOpts);
  };
}), require_src = __commonJSMin$1((exports$12, module2) => {
  init_dist(), process$1 === void 0 || process$1.type === `renderer` || process$1.browser === true || process$1.__nwjs ? module2.exports = require_browser$3() : module2.exports = require_node$2();
}), require__freeGlobal = __commonJSMin$1((exports$12, module2) => {
  var freeGlobal$2 = {}.Object === Object && {};
  module2.exports = freeGlobal$2;
}), require__root = __commonJSMin$1((exports$12, module2) => {
  var freeGlobal$1 = require__freeGlobal(), freeSelf = typeof self == `object` && self && self.Object === Object && self, root$10 = freeGlobal$1 || freeSelf || Function(`return this`)();
  module2.exports = root$10;
}), require__Symbol = __commonJSMin$1((exports$12, module2) => {
  var root$9 = require__root(), Symbol$8 = root$9.Symbol;
  module2.exports = Symbol$8;
}), require__getRawTag = __commonJSMin$1((exports$12, module2) => {
  var Symbol$7 = require__Symbol(), objectProto$20 = Object.prototype, hasOwnProperty$20 = objectProto$20.hasOwnProperty, nativeObjectToString$1 = objectProto$20.toString, symToStringTag$1 = Symbol$7 ? Symbol$7.toStringTag : void 0;
  function getRawTag$1(value) {
    var isOwn = hasOwnProperty$20.call(value, symToStringTag$1), tag = value[symToStringTag$1];
    try {
      value[symToStringTag$1] = void 0;
      var unmasked = true;
    } catch {
    }
    var result = nativeObjectToString$1.call(value);
    return unmasked && (isOwn ? value[symToStringTag$1] = tag : delete value[symToStringTag$1]), result;
  }
  module2.exports = getRawTag$1;
}), require__objectToString = __commonJSMin$1((exports$12, module2) => {
  var objectProto$19 = Object.prototype, nativeObjectToString = objectProto$19.toString;
  function objectToString$2(value) {
    return nativeObjectToString.call(value);
  }
  module2.exports = objectToString$2;
}), require__baseGetTag = __commonJSMin$1((exports$12, module2) => {
  var Symbol$6 = require__Symbol(), getRawTag = require__getRawTag(), objectToString$1 = require__objectToString(), nullTag = `[object Null]`, undefinedTag = `[object Undefined]`, symToStringTag = Symbol$6 ? Symbol$6.toStringTag : void 0;
  function baseGetTag$7(value) {
    return value == null ? value === void 0 ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString$1(value);
  }
  module2.exports = baseGetTag$7;
}), require_isObject = __commonJSMin$1((exports$12, module2) => {
  function isObject$24(value) {
    var type = typeof value;
    return value != null && (type == `object` || type == `function`);
  }
  module2.exports = isObject$24;
}), require_isFunction = __commonJSMin$1((exports$12, module2) => {
  var baseGetTag$6 = require__baseGetTag(), isObject$23 = require_isObject(), asyncTag = `[object AsyncFunction]`, funcTag$2 = `[object Function]`, genTag$1 = `[object GeneratorFunction]`, proxyTag = `[object Proxy]`;
  function isFunction$10(value) {
    if (!isObject$23(value)) return false;
    var tag = baseGetTag$6(value);
    return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
  }
  module2.exports = isFunction$10;
}), require__coreJsData = __commonJSMin$1((exports$12, module2) => {
  var root$8 = require__root(), coreJsData$1 = root$8[`__core-js_shared__`];
  module2.exports = coreJsData$1;
}), require__isMasked = __commonJSMin$1((exports$12, module2) => {
  var coreJsData = require__coreJsData(), maskSrcKey = (function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || ``);
    return uid ? `Symbol(src)_1.` + uid : ``;
  })();
  function isMasked$1(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  module2.exports = isMasked$1;
}), require__toSource = __commonJSMin$1((exports$12, module2) => {
  var funcProto$2 = Function.prototype, funcToString$2 = funcProto$2.toString;
  function toSource$2(func) {
    if (func != null) {
      try {
        return funcToString$2.call(func);
      } catch {
      }
      try {
        return func + ``;
      } catch {
      }
    }
    return ``;
  }
  module2.exports = toSource$2;
}), require__baseIsNative = __commonJSMin$1((exports$12, module2) => {
  var isFunction$9 = require_isFunction(), isMasked = require__isMasked(), isObject$22 = require_isObject(), toSource$1 = require__toSource(), reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reIsHostCtor = /^\[object .+?Constructor\]$/, funcProto$1 = Function.prototype, objectProto$18 = Object.prototype, funcToString$1 = funcProto$1.toString, hasOwnProperty$19 = objectProto$18.hasOwnProperty, reIsNative = RegExp(`^` + funcToString$1.call(hasOwnProperty$19).replace(reRegExpChar, `\\$&`).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, `$1.*?`) + `$`);
  function baseIsNative$1(value) {
    if (!isObject$22(value) || isMasked(value)) return false;
    var pattern = isFunction$9(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource$1(value));
  }
  module2.exports = baseIsNative$1;
}), require__getValue = __commonJSMin$1((exports$12, module2) => {
  function getValue$1(object, key) {
    return object?.[key];
  }
  module2.exports = getValue$1;
}), require__getNative = __commonJSMin$1((exports$12, module2) => {
  var baseIsNative = require__baseIsNative(), getValue = require__getValue();
  function getNative$7(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : void 0;
  }
  module2.exports = getNative$7;
}), require__defineProperty = __commonJSMin$1((exports$12, module2) => {
  var getNative$6 = require__getNative(), defineProperty$3 = (function() {
    try {
      var func = getNative$6(Object, `defineProperty`);
      return func({}, ``, {}), func;
    } catch {
    }
  })();
  module2.exports = defineProperty$3;
}), require__baseAssignValue = __commonJSMin$1((exports$12, module2) => {
  var defineProperty$2 = require__defineProperty();
  function baseAssignValue$3(object, key, value) {
    key == `__proto__` && defineProperty$2 ? defineProperty$2(object, key, { configurable: true, enumerable: true, value, writable: true }) : object[key] = value;
  }
  module2.exports = baseAssignValue$3;
}), require_eq$1 = __commonJSMin$1((exports$12, module2) => {
  function eq$8(value, other) {
    return value === other || value !== value && other !== other;
  }
  module2.exports = eq$8;
}), require__assignValue = __commonJSMin$1((exports$12, module2) => {
  var baseAssignValue$2 = require__baseAssignValue(), eq$7 = require_eq$1(), objectProto$17 = Object.prototype, hasOwnProperty$18 = objectProto$17.hasOwnProperty;
  function assignValue$4(object, key, value) {
    var objValue = object[key];
    (!(hasOwnProperty$18.call(object, key) && eq$7(objValue, value)) || value === void 0 && !(key in object)) && baseAssignValue$2(object, key, value);
  }
  module2.exports = assignValue$4;
}), require__copyObject = __commonJSMin$1((exports$12, module2) => {
  var assignValue$3 = require__assignValue(), baseAssignValue$1 = require__baseAssignValue();
  function copyObject$6(source, props, object, customizer) {
    var isNew = !object;
    object ||= {};
    for (var index$2 = -1, length = props.length; ++index$2 < length; ) {
      var key = props[index$2], newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;
      newValue === void 0 && (newValue = source[key]), isNew ? baseAssignValue$1(object, key, newValue) : assignValue$3(object, key, newValue);
    }
    return object;
  }
  module2.exports = copyObject$6;
}), require_identity = __commonJSMin$1((exports$12, module2) => {
  function identity$12(value) {
    return value;
  }
  module2.exports = identity$12;
}), require__apply = __commonJSMin$1((exports$12, module2) => {
  function apply$1(func, thisArg, args$1) {
    switch (args$1.length) {
      case 0:
        return func.call(thisArg);
      case 1:
        return func.call(thisArg, args$1[0]);
      case 2:
        return func.call(thisArg, args$1[0], args$1[1]);
      case 3:
        return func.call(thisArg, args$1[0], args$1[1], args$1[2]);
    }
    return func.apply(thisArg, args$1);
  }
  module2.exports = apply$1;
}), require__overRest = __commonJSMin$1((exports$12, module2) => {
  var apply = require__apply(), nativeMax$1 = Math.max;
  function overRest$1(func, start, transform$2) {
    return start = nativeMax$1(start === void 0 ? func.length - 1 : start, 0), function() {
      for (var args$1 = arguments, index$2 = -1, length = nativeMax$1(args$1.length - start, 0), array = Array(length); ++index$2 < length; ) array[index$2] = args$1[start + index$2];
      index$2 = -1;
      for (var otherArgs = Array(start + 1); ++index$2 < start; ) otherArgs[index$2] = args$1[index$2];
      return otherArgs[start] = transform$2(array), apply(func, this, otherArgs);
    };
  }
  module2.exports = overRest$1;
}), require_constant = __commonJSMin$1((exports$12, module2) => {
  function constant$2(value) {
    return function() {
      return value;
    };
  }
  module2.exports = constant$2;
}), require__baseSetToString = __commonJSMin$1((exports$12, module2) => {
  var constant$1 = require_constant(), defineProperty$1 = require__defineProperty(), identity$11 = require_identity(), baseSetToString$1 = defineProperty$1 ? function(func, string) {
    return defineProperty$1(func, `toString`, { configurable: true, enumerable: false, value: constant$1(string), writable: true });
  } : identity$11;
  module2.exports = baseSetToString$1;
}), require__shortOut = __commonJSMin$1((exports$12, module2) => {
  var HOT_COUNT = 800, HOT_SPAN = 16, nativeNow = Date.now;
  function shortOut$1(func) {
    var count = 0, lastCalled = 0;
    return function() {
      var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
      if (lastCalled = stamp, remaining > 0) {
        if (++count >= HOT_COUNT) return arguments[0];
      } else count = 0;
      return func.apply(void 0, arguments);
    };
  }
  module2.exports = shortOut$1;
}), require__setToString = __commonJSMin$1((exports$12, module2) => {
  var baseSetToString = require__baseSetToString(), shortOut = require__shortOut(), setToString$1 = shortOut(baseSetToString);
  module2.exports = setToString$1;
}), require__baseRest = __commonJSMin$1((exports$12, module2) => {
  var identity$10 = require_identity(), overRest = require__overRest(), setToString = require__setToString();
  function baseRest$3(func, start) {
    return setToString(overRest(func, start, identity$10), func + ``);
  }
  module2.exports = baseRest$3;
}), require_isLength = __commonJSMin$1((exports$12, module2) => {
  var MAX_SAFE_INTEGER$3 = 9007199254740991;
  function isLength$3(value) {
    return typeof value == `number` && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$3;
  }
  module2.exports = isLength$3;
}), require_isArrayLike = __commonJSMin$1((exports$12, module2) => {
  var isFunction$8 = require_isFunction(), isLength$2 = require_isLength();
  function isArrayLike$8(value) {
    return value != null && isLength$2(value.length) && !isFunction$8(value);
  }
  module2.exports = isArrayLike$8;
}), require__isIndex = __commonJSMin$1((exports$12, module2) => {
  var MAX_SAFE_INTEGER$2 = 9007199254740991, reIsUint = /^(?:0|[1-9]\d*)$/;
  function isIndex$4(value, length) {
    var type = typeof value;
    return length ??= MAX_SAFE_INTEGER$2, !!length && (type == `number` || type != `symbol` && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
  }
  module2.exports = isIndex$4;
}), require__isIterateeCall = __commonJSMin$1((exports$12, module2) => {
  var eq$6 = require_eq$1(), isArrayLike$7 = require_isArrayLike(), isIndex$3 = require__isIndex(), isObject$21 = require_isObject();
  function isIterateeCall$3(value, index$2, object) {
    if (!isObject$21(object)) return false;
    var type = typeof index$2;
    return (type == `number` ? isArrayLike$7(object) && isIndex$3(index$2, object.length) : type == `string` && index$2 in object) ? eq$6(object[index$2], value) : false;
  }
  module2.exports = isIterateeCall$3;
}), require__createAssigner = __commonJSMin$1((exports$12, module2) => {
  var baseRest$2 = require__baseRest(), isIterateeCall$2 = require__isIterateeCall();
  function createAssigner$2(assigner) {
    return baseRest$2(function(object, sources) {
      var index$2 = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : void 0, guard = length > 2 ? sources[2] : void 0;
      for (customizer = assigner.length > 3 && typeof customizer == `function` ? (length--, customizer) : void 0, guard && isIterateeCall$2(sources[0], sources[1], guard) && (customizer = length < 3 ? void 0 : customizer, length = 1), object = Object(object); ++index$2 < length; ) {
        var source = sources[index$2];
        source && assigner(object, source, index$2, customizer);
      }
      return object;
    });
  }
  module2.exports = createAssigner$2;
}), require__isPrototype = __commonJSMin$1((exports$12, module2) => {
  var objectProto$16 = Object.prototype;
  function isPrototype$5(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == `function` && Ctor.prototype || objectProto$16;
    return value === proto;
  }
  module2.exports = isPrototype$5;
}), require__baseTimes = __commonJSMin$1((exports$12, module2) => {
  function baseTimes$1(n$4, iteratee) {
    for (var index$2 = -1, result = Array(n$4); ++index$2 < n$4; ) result[index$2] = iteratee(index$2);
    return result;
  }
  module2.exports = baseTimes$1;
}), require_isObjectLike = __commonJSMin$1((exports$12, module2) => {
  function isObjectLike$9(value) {
    return typeof value == `object` && !!value;
  }
  module2.exports = isObjectLike$9;
}), require__baseIsArguments = __commonJSMin$1((exports$12, module2) => {
  var baseGetTag$5 = require__baseGetTag(), isObjectLike$8 = require_isObjectLike(), argsTag$3 = `[object Arguments]`;
  function baseIsArguments$1(value) {
    return isObjectLike$8(value) && baseGetTag$5(value) == argsTag$3;
  }
  module2.exports = baseIsArguments$1;
}), require_isArguments$1 = __commonJSMin$1((exports$12, module2) => {
  var baseIsArguments = require__baseIsArguments(), isObjectLike$7 = require_isObjectLike(), objectProto$15 = Object.prototype, hasOwnProperty$17 = objectProto$15.hasOwnProperty, propertyIsEnumerable$2 = objectProto$15.propertyIsEnumerable, isArguments$4 = baseIsArguments(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? baseIsArguments : function(value) {
    return isObjectLike$7(value) && hasOwnProperty$17.call(value, `callee`) && !propertyIsEnumerable$2.call(value, `callee`);
  };
  module2.exports = isArguments$4;
}), require_isArray = __commonJSMin$1((exports$12, module2) => {
  var isArray$21 = Array.isArray;
  module2.exports = isArray$21;
}), require_stubFalse = __commonJSMin$1((exports$12, module2) => {
  function stubFalse$1() {
    return false;
  }
  module2.exports = stubFalse$1;
}), require_isBuffer = __commonJSMin$1((exports$12, module2) => {
  var root$7 = require__root(), stubFalse = require_stubFalse(), freeExports$2 = typeof exports$12 == `object` && exports$12 && !exports$12.nodeType && exports$12, freeModule$2 = freeExports$2 && typeof module2 == `object` && module2 && !module2.nodeType && module2, moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2, Buffer$26 = moduleExports$2 ? root$7.Buffer : void 0, nativeIsBuffer = Buffer$26 ? Buffer$26.isBuffer : void 0, isBuffer$5 = nativeIsBuffer || stubFalse;
  module2.exports = isBuffer$5;
}), require__baseIsTypedArray = __commonJSMin$1((exports$12, module2) => {
  var baseGetTag$4 = require__baseGetTag(), isLength$1 = require_isLength(), isObjectLike$6 = require_isObjectLike(), argsTag$2 = `[object Arguments]`, arrayTag$2 = `[object Array]`, boolTag$3 = `[object Boolean]`, dateTag$3 = `[object Date]`, errorTag$2 = `[object Error]`, funcTag$1 = `[object Function]`, mapTag$7 = `[object Map]`, numberTag$3 = `[object Number]`, objectTag$4 = `[object Object]`, regexpTag$3 = `[object RegExp]`, setTag$7 = `[object Set]`, stringTag$4 = `[object String]`, weakMapTag$2 = `[object WeakMap]`, arrayBufferTag$3 = `[object ArrayBuffer]`, dataViewTag$4 = `[object DataView]`, float32Tag$2 = `[object Float32Array]`, float64Tag$2 = `[object Float64Array]`, int8Tag$2 = `[object Int8Array]`, int16Tag$2 = `[object Int16Array]`, int32Tag$2 = `[object Int32Array]`, uint8Tag$2 = `[object Uint8Array]`, uint8ClampedTag$2 = `[object Uint8ClampedArray]`, uint16Tag$2 = `[object Uint16Array]`, uint32Tag$2 = `[object Uint32Array]`, typedArrayTags = {};
  typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true, typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] = typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$3] = typedArrayTags[dataViewTag$4] = typedArrayTags[dateTag$3] = typedArrayTags[errorTag$2] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$7] = typedArrayTags[numberTag$3] = typedArrayTags[objectTag$4] = typedArrayTags[regexpTag$3] = typedArrayTags[setTag$7] = typedArrayTags[stringTag$4] = typedArrayTags[weakMapTag$2] = false;
  function baseIsTypedArray$1(value) {
    return isObjectLike$6(value) && isLength$1(value.length) && !!typedArrayTags[baseGetTag$4(value)];
  }
  module2.exports = baseIsTypedArray$1;
}), require__baseUnary = __commonJSMin$1((exports$12, module2) => {
  function baseUnary$3(func) {
    return function(value) {
      return func(value);
    };
  }
  module2.exports = baseUnary$3;
}), require__nodeUtil = __commonJSMin$1((exports$12, module2) => {
  var freeGlobal = require__freeGlobal(), freeExports$1 = typeof exports$12 == `object` && exports$12 && !exports$12.nodeType && exports$12, freeModule$1 = freeExports$1 && typeof module2 == `object` && module2 && !module2.nodeType && module2, moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1, freeProcess = moduleExports$1 && freeGlobal.process, nodeUtil$3 = (function() {
    try {
      var types$1 = freeModule$1 && freeModule$1.require && freeModule$1.require(`util`).types;
      return types$1 || freeProcess && freeProcess.binding && freeProcess.binding(`util`);
    } catch {
    }
  })();
  module2.exports = nodeUtil$3;
}), require_isTypedArray = __commonJSMin$1((exports$12, module2) => {
  var baseIsTypedArray = require__baseIsTypedArray(), baseUnary$2 = require__baseUnary(), nodeUtil$2 = require__nodeUtil(), nodeIsTypedArray = nodeUtil$2 && nodeUtil$2.isTypedArray, isTypedArray$6 = nodeIsTypedArray ? baseUnary$2(nodeIsTypedArray) : baseIsTypedArray;
  module2.exports = isTypedArray$6;
}), require__arrayLikeKeys = __commonJSMin$1((exports$12, module2) => {
  var baseTimes = require__baseTimes(), isArguments$3 = require_isArguments$1(), isArray$20 = require_isArray(), isBuffer$4 = require_isBuffer(), isIndex$2 = require__isIndex(), isTypedArray$5 = require_isTypedArray(), objectProto$14 = Object.prototype, hasOwnProperty$16 = objectProto$14.hasOwnProperty;
  function arrayLikeKeys$2(value, inherited) {
    var isArr = isArray$20(value), isArg = !isArr && isArguments$3(value), isBuff = !isArr && !isArg && isBuffer$4(value), isType = !isArr && !isArg && !isBuff && isTypedArray$5(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for (var key in value) (inherited || hasOwnProperty$16.call(value, key)) && !(skipIndexes && (key == `length` || isBuff && (key == `offset` || key == `parent`) || isType && (key == `buffer` || key == `byteLength` || key == `byteOffset`) || isIndex$2(key, length))) && result.push(key);
    return result;
  }
  module2.exports = arrayLikeKeys$2;
}), require__overArg = __commonJSMin$1((exports$12, module2) => {
  function overArg$2(func, transform$2) {
    return function(arg) {
      return func(transform$2(arg));
    };
  }
  module2.exports = overArg$2;
}), require__nativeKeys = __commonJSMin$1((exports$12, module2) => {
  var overArg$1 = require__overArg(), nativeKeys$1 = overArg$1(Object.keys, Object);
  module2.exports = nativeKeys$1;
}), require__baseKeys = __commonJSMin$1((exports$12, module2) => {
  var isPrototype$4 = require__isPrototype(), nativeKeys = require__nativeKeys(), objectProto$13 = Object.prototype, hasOwnProperty$15 = objectProto$13.hasOwnProperty;
  function baseKeys$2(object) {
    if (!isPrototype$4(object)) return nativeKeys(object);
    var result = [];
    for (var key in Object(object)) hasOwnProperty$15.call(object, key) && key != `constructor` && result.push(key);
    return result;
  }
  module2.exports = baseKeys$2;
}), require_keys = __commonJSMin$1((exports$12, module2) => {
  var arrayLikeKeys$1 = require__arrayLikeKeys(), baseKeys$1 = require__baseKeys(), isArrayLike$6 = require_isArrayLike();
  function keys$9(object) {
    return isArrayLike$6(object) ? arrayLikeKeys$1(object) : baseKeys$1(object);
  }
  module2.exports = keys$9;
}), require_assign = __commonJSMin$1((exports$12, module2) => {
  var assignValue$2 = require__assignValue(), copyObject$5 = require__copyObject(), createAssigner$1 = require__createAssigner(), isArrayLike$5 = require_isArrayLike(), isPrototype$3 = require__isPrototype(), keys$8 = require_keys(), objectProto$12 = Object.prototype, hasOwnProperty$14 = objectProto$12.hasOwnProperty, assign$7 = createAssigner$1(function(object, source) {
    if (isPrototype$3(source) || isArrayLike$5(source)) {
      copyObject$5(source, keys$8(source), object);
      return;
    }
    for (var key in source) hasOwnProperty$14.call(source, key) && assignValue$2(object, key, source[key]);
  });
  module2.exports = assign$7;
}), require__getPrototype = __commonJSMin$1((exports$12, module2) => {
  var overArg = require__overArg(), getPrototype$4 = overArg(Object.getPrototypeOf, Object);
  module2.exports = getPrototype$4;
}), require_isPlainObject = __commonJSMin$1((exports$12, module2) => {
  var baseGetTag$3 = require__baseGetTag(), getPrototype$3 = require__getPrototype(), isObjectLike$5 = require_isObjectLike(), objectTag$3 = `[object Object]`, funcProto = Function.prototype, objectProto$11 = Object.prototype, funcToString = funcProto.toString, hasOwnProperty$13 = objectProto$11.hasOwnProperty, objectCtorString = funcToString.call(Object);
  function isPlainObject$9(value) {
    if (!isObjectLike$5(value) || baseGetTag$3(value) != objectTag$3) return false;
    var proto = getPrototype$3(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty$13.call(proto, `constructor`) && proto.constructor;
    return typeof Ctor == `function` && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
  }
  module2.exports = isPlainObject$9;
}), require__arrayReduce = __commonJSMin$1((exports$12, module2) => {
  function arrayReduce$1(array, iteratee, accumulator, initAccum) {
    var index$2 = -1, length = array == null ? 0 : array.length;
    for (initAccum && length && (accumulator = array[++index$2]); ++index$2 < length; ) accumulator = iteratee(accumulator, array[index$2], index$2, array);
    return accumulator;
  }
  module2.exports = arrayReduce$1;
}), require__createBaseFor = __commonJSMin$1((exports$12, module2) => {
  function createBaseFor$1(fromRight) {
    return function(object, iteratee, keysFunc) {
      for (var index$2 = -1, iterable = Object(object), props = keysFunc(object), length = props.length; length--; ) {
        var key = props[fromRight ? length : ++index$2];
        if (iteratee(iterable[key], key, iterable) === false) break;
      }
      return object;
    };
  }
  module2.exports = createBaseFor$1;
}), require__baseFor = __commonJSMin$1((exports$12, module2) => {
  var createBaseFor = require__createBaseFor(), baseFor$1 = createBaseFor();
  module2.exports = baseFor$1;
}), require__baseForOwn = __commonJSMin$1((exports$12, module2) => {
  var baseFor = require__baseFor(), keys$7 = require_keys();
  function baseForOwn$2(object, iteratee) {
    return object && baseFor(object, iteratee, keys$7);
  }
  module2.exports = baseForOwn$2;
}), require__createBaseEach = __commonJSMin$1((exports$12, module2) => {
  var isArrayLike$4 = require_isArrayLike();
  function createBaseEach$1(eachFunc, fromRight) {
    return function(collection, iteratee) {
      if (collection == null) return collection;
      if (!isArrayLike$4(collection)) return eachFunc(collection, iteratee);
      for (var length = collection.length, index$2 = fromRight ? length : -1, iterable = Object(collection); (fromRight ? index$2-- : ++index$2 < length) && iteratee(iterable[index$2], index$2, iterable) !== false; ) ;
      return collection;
    };
  }
  module2.exports = createBaseEach$1;
}), require__baseEach = __commonJSMin$1((exports$12, module2) => {
  var baseForOwn$1 = require__baseForOwn(), createBaseEach = require__createBaseEach(), baseEach$6 = createBaseEach(baseForOwn$1);
  module2.exports = baseEach$6;
}), require__listCacheClear = __commonJSMin$1((exports$12, module2) => {
  function listCacheClear$1() {
    this.__data__ = [], this.size = 0;
  }
  module2.exports = listCacheClear$1;
}), require__assocIndexOf = __commonJSMin$1((exports$12, module2) => {
  var eq$5 = require_eq$1();
  function assocIndexOf$4(array, key) {
    for (var length = array.length; length--; ) if (eq$5(array[length][0], key)) return length;
    return -1;
  }
  module2.exports = assocIndexOf$4;
}), require__listCacheDelete = __commonJSMin$1((exports$12, module2) => {
  var assocIndexOf$3 = require__assocIndexOf(), arrayProto = Array.prototype, splice = arrayProto.splice;
  function listCacheDelete$1(key) {
    var data = this.__data__, index$2 = assocIndexOf$3(data, key);
    if (index$2 < 0) return false;
    var lastIndex = data.length - 1;
    return index$2 == lastIndex ? data.pop() : splice.call(data, index$2, 1), --this.size, true;
  }
  module2.exports = listCacheDelete$1;
}), require__listCacheGet = __commonJSMin$1((exports$12, module2) => {
  var assocIndexOf$2 = require__assocIndexOf();
  function listCacheGet$1(key) {
    var data = this.__data__, index$2 = assocIndexOf$2(data, key);
    return index$2 < 0 ? void 0 : data[index$2][1];
  }
  module2.exports = listCacheGet$1;
}), require__listCacheHas = __commonJSMin$1((exports$12, module2) => {
  var assocIndexOf$1 = require__assocIndexOf();
  function listCacheHas$1(key) {
    return assocIndexOf$1(this.__data__, key) > -1;
  }
  module2.exports = listCacheHas$1;
}), require__listCacheSet = __commonJSMin$1((exports$12, module2) => {
  var assocIndexOf = require__assocIndexOf();
  function listCacheSet$1(key, value) {
    var data = this.__data__, index$2 = assocIndexOf(data, key);
    return index$2 < 0 ? (++this.size, data.push([key, value])) : data[index$2][1] = value, this;
  }
  module2.exports = listCacheSet$1;
}), require__ListCache = __commonJSMin$1((exports$12, module2) => {
  var listCacheClear = require__listCacheClear(), listCacheDelete = require__listCacheDelete(), listCacheGet = require__listCacheGet(), listCacheHas = require__listCacheHas(), listCacheSet = require__listCacheSet();
  function ListCache$4(entries) {
    var index$2 = -1, length = entries == null ? 0 : entries.length;
    for (this.clear(); ++index$2 < length; ) {
      var entry = entries[index$2];
      this.set(entry[0], entry[1]);
    }
  }
  ListCache$4.prototype.clear = listCacheClear, ListCache$4.prototype.delete = listCacheDelete, ListCache$4.prototype.get = listCacheGet, ListCache$4.prototype.has = listCacheHas, ListCache$4.prototype.set = listCacheSet, module2.exports = ListCache$4;
}), require__stackClear = __commonJSMin$1((exports$12, module2) => {
  var ListCache$3 = require__ListCache();
  function stackClear$1() {
    this.__data__ = new ListCache$3(), this.size = 0;
  }
  module2.exports = stackClear$1;
}), require__stackDelete = __commonJSMin$1((exports$12, module2) => {
  function stackDelete$1(key) {
    var data = this.__data__, result = data.delete(key);
    return this.size = data.size, result;
  }
  module2.exports = stackDelete$1;
}), require__stackGet = __commonJSMin$1((exports$12, module2) => {
  function stackGet$1(key) {
    return this.__data__.get(key);
  }
  module2.exports = stackGet$1;
}), require__stackHas = __commonJSMin$1((exports$12, module2) => {
  function stackHas$1(key) {
    return this.__data__.has(key);
  }
  module2.exports = stackHas$1;
}), require__Map = __commonJSMin$1((exports$12, module2) => {
  var getNative$5 = require__getNative(), root$6 = require__root(), Map$4 = getNative$5(root$6, `Map`);
  module2.exports = Map$4;
}), require__nativeCreate = __commonJSMin$1((exports$12, module2) => {
  var getNative$4 = require__getNative(), nativeCreate$4 = getNative$4(Object, `create`);
  module2.exports = nativeCreate$4;
}), require__hashClear = __commonJSMin$1((exports$12, module2) => {
  var nativeCreate$3 = require__nativeCreate();
  function hashClear$1() {
    this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {}, this.size = 0;
  }
  module2.exports = hashClear$1;
}), require__hashDelete = __commonJSMin$1((exports$12, module2) => {
  function hashDelete$1(key) {
    var result = this.has(key) && delete this.__data__[key];
    return this.size -= result ? 1 : 0, result;
  }
  module2.exports = hashDelete$1;
}), require__hashGet = __commonJSMin$1((exports$12, module2) => {
  var nativeCreate$2 = require__nativeCreate(), HASH_UNDEFINED$2 = `__lodash_hash_undefined__`, objectProto$10 = Object.prototype, hasOwnProperty$12 = objectProto$10.hasOwnProperty;
  function hashGet$1(key) {
    var data = this.__data__;
    if (nativeCreate$2) {
      var result = data[key];
      return result === HASH_UNDEFINED$2 ? void 0 : result;
    }
    return hasOwnProperty$12.call(data, key) ? data[key] : void 0;
  }
  module2.exports = hashGet$1;
}), require__hashHas = __commonJSMin$1((exports$12, module2) => {
  var nativeCreate$1 = require__nativeCreate(), objectProto$9 = Object.prototype, hasOwnProperty$11 = objectProto$9.hasOwnProperty;
  function hashHas$1(key) {
    var data = this.__data__;
    return nativeCreate$1 ? data[key] !== void 0 : hasOwnProperty$11.call(data, key);
  }
  module2.exports = hashHas$1;
}), require__hashSet = __commonJSMin$1((exports$12, module2) => {
  var nativeCreate = require__nativeCreate(), HASH_UNDEFINED$1 = `__lodash_hash_undefined__`;
  function hashSet$1(key, value) {
    var data = this.__data__;
    return this.size += this.has(key) ? 0 : 1, data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED$1 : value, this;
  }
  module2.exports = hashSet$1;
}), require__Hash = __commonJSMin$1((exports$12, module2) => {
  var hashClear = require__hashClear(), hashDelete = require__hashDelete(), hashGet = require__hashGet(), hashHas = require__hashHas(), hashSet = require__hashSet();
  function Hash$1(entries) {
    var index$2 = -1, length = entries == null ? 0 : entries.length;
    for (this.clear(); ++index$2 < length; ) {
      var entry = entries[index$2];
      this.set(entry[0], entry[1]);
    }
  }
  Hash$1.prototype.clear = hashClear, Hash$1.prototype.delete = hashDelete, Hash$1.prototype.get = hashGet, Hash$1.prototype.has = hashHas, Hash$1.prototype.set = hashSet, module2.exports = Hash$1;
}), require__mapCacheClear = __commonJSMin$1((exports$12, module2) => {
  var Hash = require__Hash(), ListCache$2 = require__ListCache(), Map$3 = require__Map();
  function mapCacheClear$1() {
    this.size = 0, this.__data__ = { hash: new Hash(), map: new (Map$3 || ListCache$2)(), string: new Hash() };
  }
  module2.exports = mapCacheClear$1;
}), require__isKeyable = __commonJSMin$1((exports$12, module2) => {
  function isKeyable$1(value) {
    var type = typeof value;
    return type == `string` || type == `number` || type == `symbol` || type == `boolean` ? value !== `__proto__` : value === null;
  }
  module2.exports = isKeyable$1;
}), require__getMapData = __commonJSMin$1((exports$12, module2) => {
  var isKeyable = require__isKeyable();
  function getMapData$4(map$8, key) {
    var data = map$8.__data__;
    return isKeyable(key) ? data[typeof key == `string` ? `string` : `hash`] : data.map;
  }
  module2.exports = getMapData$4;
}), require__mapCacheDelete = __commonJSMin$1((exports$12, module2) => {
  var getMapData$3 = require__getMapData();
  function mapCacheDelete$1(key) {
    var result = getMapData$3(this, key).delete(key);
    return this.size -= result ? 1 : 0, result;
  }
  module2.exports = mapCacheDelete$1;
}), require__mapCacheGet = __commonJSMin$1((exports$12, module2) => {
  var getMapData$2 = require__getMapData();
  function mapCacheGet$1(key) {
    return getMapData$2(this, key).get(key);
  }
  module2.exports = mapCacheGet$1;
}), require__mapCacheHas = __commonJSMin$1((exports$12, module2) => {
  var getMapData$1 = require__getMapData();
  function mapCacheHas$1(key) {
    return getMapData$1(this, key).has(key);
  }
  module2.exports = mapCacheHas$1;
}), require__mapCacheSet = __commonJSMin$1((exports$12, module2) => {
  var getMapData = require__getMapData();
  function mapCacheSet$1(key, value) {
    var data = getMapData(this, key), size = data.size;
    return data.set(key, value), this.size += data.size == size ? 0 : 1, this;
  }
  module2.exports = mapCacheSet$1;
}), require__MapCache = __commonJSMin$1((exports$12, module2) => {
  var mapCacheClear = require__mapCacheClear(), mapCacheDelete = require__mapCacheDelete(), mapCacheGet = require__mapCacheGet(), mapCacheHas = require__mapCacheHas(), mapCacheSet = require__mapCacheSet();
  function MapCache$3(entries) {
    var index$2 = -1, length = entries == null ? 0 : entries.length;
    for (this.clear(); ++index$2 < length; ) {
      var entry = entries[index$2];
      this.set(entry[0], entry[1]);
    }
  }
  MapCache$3.prototype.clear = mapCacheClear, MapCache$3.prototype.delete = mapCacheDelete, MapCache$3.prototype.get = mapCacheGet, MapCache$3.prototype.has = mapCacheHas, MapCache$3.prototype.set = mapCacheSet, module2.exports = MapCache$3;
}), require__stackSet = __commonJSMin$1((exports$12, module2) => {
  var ListCache$1 = require__ListCache(), Map$2 = require__Map(), MapCache$2 = require__MapCache(), LARGE_ARRAY_SIZE$1 = 200;
  function stackSet$1(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache$1) {
      var pairs = data.__data__;
      if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE$1 - 1) return pairs.push([key, value]), this.size = ++data.size, this;
      data = this.__data__ = new MapCache$2(pairs);
    }
    return data.set(key, value), this.size = data.size, this;
  }
  module2.exports = stackSet$1;
}), require__Stack = __commonJSMin$1((exports$12, module2) => {
  var ListCache = require__ListCache(), stackClear = require__stackClear(), stackDelete = require__stackDelete(), stackGet = require__stackGet(), stackHas = require__stackHas(), stackSet = require__stackSet();
  function Stack$3(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
  }
  Stack$3.prototype.clear = stackClear, Stack$3.prototype.delete = stackDelete, Stack$3.prototype.get = stackGet, Stack$3.prototype.has = stackHas, Stack$3.prototype.set = stackSet, module2.exports = Stack$3;
}), require__setCacheAdd = __commonJSMin$1((exports$12, module2) => {
  var HASH_UNDEFINED = `__lodash_hash_undefined__`;
  function setCacheAdd$1(value) {
    return this.__data__.set(value, HASH_UNDEFINED), this;
  }
  module2.exports = setCacheAdd$1;
}), require__setCacheHas = __commonJSMin$1((exports$12, module2) => {
  function setCacheHas$1(value) {
    return this.__data__.has(value);
  }
  module2.exports = setCacheHas$1;
}), require__SetCache = __commonJSMin$1((exports$12, module2) => {
  var MapCache$1 = require__MapCache(), setCacheAdd = require__setCacheAdd(), setCacheHas = require__setCacheHas();
  function SetCache$2(values$3) {
    var index$2 = -1, length = values$3 == null ? 0 : values$3.length;
    for (this.__data__ = new MapCache$1(); ++index$2 < length; ) this.add(values$3[index$2]);
  }
  SetCache$2.prototype.add = SetCache$2.prototype.push = setCacheAdd, SetCache$2.prototype.has = setCacheHas, module2.exports = SetCache$2;
}), require__arraySome = __commonJSMin$1((exports$12, module2) => {
  function arraySome$2(array, predicate) {
    for (var index$2 = -1, length = array == null ? 0 : array.length; ++index$2 < length; ) if (predicate(array[index$2], index$2, array)) return true;
    return false;
  }
  module2.exports = arraySome$2;
}), require__cacheHas = __commonJSMin$1((exports$12, module2) => {
  function cacheHas$2(cache$2, key) {
    return cache$2.has(key);
  }
  module2.exports = cacheHas$2;
}), require__equalArrays = __commonJSMin$1((exports$12, module2) => {
  var SetCache$1 = require__SetCache(), arraySome$1 = require__arraySome(), cacheHas$1 = require__cacheHas(), COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
  function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    var arrStacked = stack.get(array), othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index$2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache$1() : void 0;
    for (stack.set(array, other), stack.set(other, array); ++index$2 < arrLength; ) {
      var arrValue = array[index$2], othValue = other[index$2];
      if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index$2, other, array, stack) : customizer(arrValue, othValue, index$2, array, other, stack);
      if (compared !== void 0) {
        if (compared) continue;
        result = false;
        break;
      }
      if (seen) {
        if (!arraySome$1(other, function(othValue$1, othIndex) {
          if (!cacheHas$1(seen, othIndex) && (arrValue === othValue$1 || equalFunc(arrValue, othValue$1, bitmask, customizer, stack))) return seen.push(othIndex);
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
        result = false;
        break;
      }
    }
    return stack.delete(array), stack.delete(other), result;
  }
  module2.exports = equalArrays$2;
}), require__Uint8Array = __commonJSMin$1((exports$12, module2) => {
  var root$5 = require__root(), Uint8Array$3 = root$5.Uint8Array;
  module2.exports = Uint8Array$3;
}), require__mapToArray = __commonJSMin$1((exports$12, module2) => {
  function mapToArray$2(map$8) {
    var index$2 = -1, result = Array(map$8.size);
    return map$8.forEach(function(value, key) {
      result[++index$2] = [key, value];
    }), result;
  }
  module2.exports = mapToArray$2;
}), require__setToArray = __commonJSMin$1((exports$12, module2) => {
  function setToArray$4(set) {
    var index$2 = -1, result = Array(set.size);
    return set.forEach(function(value) {
      result[++index$2] = value;
    }), result;
  }
  module2.exports = setToArray$4;
}), require__equalByTag = __commonJSMin$1((exports$12, module2) => {
  var Symbol$5 = require__Symbol(), Uint8Array$2 = require__Uint8Array(), eq$4 = require_eq$1(), equalArrays$1 = require__equalArrays(), mapToArray$1 = require__mapToArray(), setToArray$3 = require__setToArray(), COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2, boolTag$2 = `[object Boolean]`, dateTag$2 = `[object Date]`, errorTag$1 = `[object Error]`, mapTag$6 = `[object Map]`, numberTag$2 = `[object Number]`, regexpTag$2 = `[object RegExp]`, setTag$6 = `[object Set]`, stringTag$3 = `[object String]`, symbolTag$3 = `[object Symbol]`, arrayBufferTag$2 = `[object ArrayBuffer]`, dataViewTag$3 = `[object DataView]`, symbolProto$2 = Symbol$5 ? Symbol$5.prototype : void 0, symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : void 0;
  function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
      case dataViewTag$3:
        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
        object = object.buffer, other = other.buffer;
      case arrayBufferTag$2:
        return !(object.byteLength != other.byteLength || !equalFunc(new Uint8Array$2(object), new Uint8Array$2(other)));
      case boolTag$2:
      case dateTag$2:
      case numberTag$2:
        return eq$4(+object, +other);
      case errorTag$1:
        return object.name == other.name && object.message == other.message;
      case regexpTag$2:
      case stringTag$3:
        return object == other + ``;
      case mapTag$6:
        var convert = mapToArray$1;
      case setTag$6:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
        if (convert ||= setToArray$3, object.size != other.size && !isPartial) return false;
        var stacked = stack.get(object);
        if (stacked) return stacked == other;
        bitmask |= COMPARE_UNORDERED_FLAG$2, stack.set(object, other);
        var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
        return stack.delete(object), result;
      case symbolTag$3:
        if (symbolValueOf$1) return symbolValueOf$1.call(object) == symbolValueOf$1.call(other);
    }
    return false;
  }
  module2.exports = equalByTag$1;
}), require__arrayPush = __commonJSMin$1((exports$12, module2) => {
  function arrayPush$3(array, values$3) {
    for (var index$2 = -1, length = values$3.length, offset$2 = array.length; ++index$2 < length; ) array[offset$2 + index$2] = values$3[index$2];
    return array;
  }
  module2.exports = arrayPush$3;
}), require__baseGetAllKeys = __commonJSMin$1((exports$12, module2) => {
  var arrayPush$2 = require__arrayPush(), isArray$19 = require_isArray();
  function baseGetAllKeys$2(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray$19(object) ? result : arrayPush$2(result, symbolsFunc(object));
  }
  module2.exports = baseGetAllKeys$2;
}), require__arrayFilter = __commonJSMin$1((exports$12, module2) => {
  function arrayFilter$3(array, predicate) {
    for (var index$2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result = []; ++index$2 < length; ) {
      var value = array[index$2];
      predicate(value, index$2, array) && (result[resIndex++] = value);
    }
    return result;
  }
  module2.exports = arrayFilter$3;
}), require_stubArray = __commonJSMin$1((exports$12, module2) => {
  function stubArray$2() {
    return [];
  }
  module2.exports = stubArray$2;
}), require__getSymbols = __commonJSMin$1((exports$12, module2) => {
  var arrayFilter$2 = require__arrayFilter(), stubArray$1 = require_stubArray(), objectProto$8 = Object.prototype, propertyIsEnumerable$1 = objectProto$8.propertyIsEnumerable, nativeGetSymbols$1 = Object.getOwnPropertySymbols, getSymbols$3 = nativeGetSymbols$1 ? function(object) {
    return object == null ? [] : (object = Object(object), arrayFilter$2(nativeGetSymbols$1(object), function(symbol) {
      return propertyIsEnumerable$1.call(object, symbol);
    }));
  } : stubArray$1;
  module2.exports = getSymbols$3;
}), require__getAllKeys = __commonJSMin$1((exports$12, module2) => {
  var baseGetAllKeys$1 = require__baseGetAllKeys(), getSymbols$2 = require__getSymbols(), keys$6 = require_keys();
  function getAllKeys$2(object) {
    return baseGetAllKeys$1(object, keys$6, getSymbols$2);
  }
  module2.exports = getAllKeys$2;
}), require__equalObjects = __commonJSMin$1((exports$12, module2) => {
  var getAllKeys$1 = require__getAllKeys(), COMPARE_PARTIAL_FLAG$3 = 1, objectProto$7 = Object.prototype, hasOwnProperty$10 = objectProto$7.hasOwnProperty;
  function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, objProps = getAllKeys$1(object), objLength = objProps.length, othProps = getAllKeys$1(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    for (var index$2 = objLength; index$2--; ) {
      var key = objProps[index$2];
      if (!(isPartial ? key in other : hasOwnProperty$10.call(other, key))) return false;
    }
    var objStacked = stack.get(object), othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other), stack.set(other, object);
    for (var skipCtor = isPartial; ++index$2 < objLength; ) {
      key = objProps[index$2];
      var objValue = object[key], othValue = other[key];
      if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
      if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
        result = false;
        break;
      }
      skipCtor ||= key == `constructor`;
    }
    if (result && !skipCtor) {
      var objCtor = object.constructor, othCtor = other.constructor;
      objCtor != othCtor && `constructor` in object && `constructor` in other && !(typeof objCtor == `function` && objCtor instanceof objCtor && typeof othCtor == `function` && othCtor instanceof othCtor) && (result = false);
    }
    return stack.delete(object), stack.delete(other), result;
  }
  module2.exports = equalObjects$1;
}), require__DataView = __commonJSMin$1((exports$12, module2) => {
  var getNative$3 = require__getNative(), root$4 = require__root(), DataView$2 = getNative$3(root$4, `DataView`);
  module2.exports = DataView$2;
}), require__Promise = __commonJSMin$1((exports$12, module2) => {
  var getNative$2 = require__getNative(), root$3 = require__root(), Promise$2 = getNative$2(root$3, `Promise`);
  module2.exports = Promise$2;
}), require__Set = __commonJSMin$1((exports$12, module2) => {
  var getNative$1 = require__getNative(), root$2 = require__root(), Set$3 = getNative$1(root$2, `Set`);
  module2.exports = Set$3;
}), require__WeakMap = __commonJSMin$1((exports$12, module2) => {
  var getNative = require__getNative(), root$1 = require__root(), WeakMap$2 = getNative(root$1, `WeakMap`);
  module2.exports = WeakMap$2;
}), require__getTag = __commonJSMin$1((exports$12, module2) => {
  var DataView$1 = require__DataView(), Map$1 = require__Map(), Promise$1 = require__Promise(), Set$2 = require__Set(), WeakMap$1 = require__WeakMap(), baseGetTag$2 = require__baseGetTag(), toSource = require__toSource(), mapTag$5 = `[object Map]`, objectTag$2 = `[object Object]`, promiseTag = `[object Promise]`, setTag$5 = `[object Set]`, weakMapTag$1 = `[object WeakMap]`, dataViewTag$2 = `[object DataView]`, dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$2), weakMapCtorString = toSource(WeakMap$1), getTag$6 = baseGetTag$2;
  (DataView$1 && getTag$6(new DataView$1(new ArrayBuffer(1))) != dataViewTag$2 || Map$1 && getTag$6(new Map$1()) != mapTag$5 || Promise$1 && getTag$6(Promise$1.resolve()) != promiseTag || Set$2 && getTag$6(new Set$2()) != setTag$5 || WeakMap$1 && getTag$6(new WeakMap$1()) != weakMapTag$1) && (getTag$6 = function(value) {
    var result = baseGetTag$2(value), Ctor = result == objectTag$2 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : ``;
    if (ctorString) switch (ctorString) {
      case dataViewCtorString:
        return dataViewTag$2;
      case mapCtorString:
        return mapTag$5;
      case promiseCtorString:
        return promiseTag;
      case setCtorString:
        return setTag$5;
      case weakMapCtorString:
        return weakMapTag$1;
    }
    return result;
  }), module2.exports = getTag$6;
}), require__baseIsEqualDeep = __commonJSMin$1((exports$12, module2) => {
  var Stack$2 = require__Stack(), equalArrays = require__equalArrays(), equalByTag = require__equalByTag(), equalObjects = require__equalObjects(), getTag$5 = require__getTag(), isArray$18 = require_isArray(), isBuffer$3 = require_isBuffer(), isTypedArray$4 = require_isTypedArray(), COMPARE_PARTIAL_FLAG$2 = 1, argsTag$1 = `[object Arguments]`, arrayTag$1 = `[object Array]`, objectTag$1 = `[object Object]`, objectProto$6 = Object.prototype, hasOwnProperty$9 = objectProto$6.hasOwnProperty;
  function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray$18(object), othIsArr = isArray$18(other), objTag = objIsArr ? arrayTag$1 : getTag$5(object), othTag = othIsArr ? arrayTag$1 : getTag$5(other);
    objTag = objTag == argsTag$1 ? objectTag$1 : objTag, othTag = othTag == argsTag$1 ? objectTag$1 : othTag;
    var objIsObj = objTag == objectTag$1, othIsObj = othTag == objectTag$1, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer$3(object)) {
      if (!isBuffer$3(other)) return false;
      objIsArr = true, objIsObj = false;
    }
    if (isSameTag && !objIsObj) return stack ||= new Stack$2(), objIsArr || isTypedArray$4(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
      var objIsWrapped = objIsObj && hasOwnProperty$9.call(object, `__wrapped__`), othIsWrapped = othIsObj && hasOwnProperty$9.call(other, `__wrapped__`);
      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
        return stack ||= new Stack$2(), equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
      }
    }
    return isSameTag ? (stack ||= new Stack$2(), equalObjects(object, other, bitmask, customizer, equalFunc, stack)) : false;
  }
  module2.exports = baseIsEqualDeep$1;
}), require__baseIsEqual = __commonJSMin$1((exports$12, module2) => {
  var baseIsEqualDeep = require__baseIsEqualDeep(), isObjectLike$4 = require_isObjectLike();
  function baseIsEqual$2(value, other, bitmask, customizer, stack) {
    return value === other ? true : value == null || other == null || !isObjectLike$4(value) && !isObjectLike$4(other) ? value !== value && other !== other : baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$2, stack);
  }
  module2.exports = baseIsEqual$2;
}), require__baseIsMatch = __commonJSMin$1((exports$12, module2) => {
  var Stack$1 = require__Stack(), baseIsEqual$1 = require__baseIsEqual(), COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
  function baseIsMatch$1(object, source, matchData, customizer) {
    var index$2 = matchData.length, length = index$2, noCustomizer = !customizer;
    if (object == null) return !length;
    for (object = Object(object); index$2--; ) {
      var data = matchData[index$2];
      if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    for (; ++index$2 < length; ) {
      data = matchData[index$2];
      var key = data[0], objValue = object[key], srcValue = data[1];
      if (noCustomizer && data[2]) {
        if (objValue === void 0 && !(key in object)) return false;
      } else {
        var stack = new Stack$1();
        if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
        if (!(result === void 0 ? baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) return false;
      }
    }
    return true;
  }
  module2.exports = baseIsMatch$1;
}), require__isStrictComparable = __commonJSMin$1((exports$12, module2) => {
  var isObject$20 = require_isObject();
  function isStrictComparable$2(value) {
    return value === value && !isObject$20(value);
  }
  module2.exports = isStrictComparable$2;
}), require__getMatchData = __commonJSMin$1((exports$12, module2) => {
  var isStrictComparable$1 = require__isStrictComparable(), keys$5 = require_keys();
  function getMatchData$1(object) {
    for (var result = keys$5(object), length = result.length; length--; ) {
      var key = result[length], value = object[key];
      result[length] = [key, value, isStrictComparable$1(value)];
    }
    return result;
  }
  module2.exports = getMatchData$1;
}), require__matchesStrictComparable = __commonJSMin$1((exports$12, module2) => {
  function matchesStrictComparable$2(key, srcValue) {
    return function(object) {
      return object == null ? false : object[key] === srcValue && (srcValue !== void 0 || key in Object(object));
    };
  }
  module2.exports = matchesStrictComparable$2;
}), require__baseMatches = __commonJSMin$1((exports$12, module2) => {
  var baseIsMatch = require__baseIsMatch(), getMatchData = require__getMatchData(), matchesStrictComparable$1 = require__matchesStrictComparable();
  function baseMatches$1(source) {
    var matchData = getMatchData(source);
    return matchData.length == 1 && matchData[0][2] ? matchesStrictComparable$1(matchData[0][0], matchData[0][1]) : function(object) {
      return object === source || baseIsMatch(object, source, matchData);
    };
  }
  module2.exports = baseMatches$1;
}), require_isSymbol = __commonJSMin$1((exports$12, module2) => {
  var baseGetTag$1 = require__baseGetTag(), isObjectLike$3 = require_isObjectLike(), symbolTag$2 = `[object Symbol]`;
  function isSymbol$4(value) {
    return typeof value == `symbol` || isObjectLike$3(value) && baseGetTag$1(value) == symbolTag$2;
  }
  module2.exports = isSymbol$4;
}), require__isKey = __commonJSMin$1((exports$12, module2) => {
  var isArray$17 = require_isArray(), isSymbol$3 = require_isSymbol(), reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
  function isKey$3(value, object) {
    if (isArray$17(value)) return false;
    var type = typeof value;
    return type == `number` || type == `symbol` || type == `boolean` || value == null || isSymbol$3(value) ? true : reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
  }
  module2.exports = isKey$3;
}), require_memoize = __commonJSMin$1((exports$12, module2) => {
  var MapCache = require__MapCache(), FUNC_ERROR_TEXT$2 = `Expected a function`;
  function memoize$1(func, resolver) {
    if (typeof func != `function` || resolver != null && typeof resolver != `function`) throw TypeError(FUNC_ERROR_TEXT$2);
    var memoized = function() {
      var args$1 = arguments, key = resolver ? resolver.apply(this, args$1) : args$1[0], cache$2 = memoized.cache;
      if (cache$2.has(key)) return cache$2.get(key);
      var result = func.apply(this, args$1);
      return memoized.cache = cache$2.set(key, result) || cache$2, result;
    };
    return memoized.cache = new (memoize$1.Cache || MapCache)(), memoized;
  }
  memoize$1.Cache = MapCache, module2.exports = memoize$1;
}), require__memoizeCapped = __commonJSMin$1((exports$12, module2) => {
  var memoize = require_memoize(), MAX_MEMOIZE_SIZE = 500;
  function memoizeCapped$1(func) {
    var result = memoize(func, function(key) {
      return cache$2.size === MAX_MEMOIZE_SIZE && cache$2.clear(), key;
    }), cache$2 = result.cache;
    return result;
  }
  module2.exports = memoizeCapped$1;
}), require__stringToPath = __commonJSMin$1((exports$12, module2) => {
  var memoizeCapped = require__memoizeCapped(), rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, reEscapeChar = /\\(\\)?/g, stringToPath$1 = memoizeCapped(function(string) {
    var result = [];
    return string.charCodeAt(0) === 46 && result.push(``), string.replace(rePropName, function(match$2, number, quote, subString) {
      result.push(quote ? subString.replace(reEscapeChar, `$1`) : number || match$2);
    }), result;
  });
  module2.exports = stringToPath$1;
}), require__arrayMap = __commonJSMin$1((exports$12, module2) => {
  function arrayMap$4(array, iteratee) {
    for (var index$2 = -1, length = array == null ? 0 : array.length, result = Array(length); ++index$2 < length; ) result[index$2] = iteratee(array[index$2], index$2, array);
    return result;
  }
  module2.exports = arrayMap$4;
}), require__baseToString = __commonJSMin$1((exports$12, module2) => {
  var Symbol$4 = require__Symbol(), arrayMap$3 = require__arrayMap(), isArray$16 = require_isArray(), isSymbol$2 = require_isSymbol(), INFINITY$3 = 1 / 0, symbolProto$1 = Symbol$4 ? Symbol$4.prototype : void 0, symbolToString = symbolProto$1 ? symbolProto$1.toString : void 0;
  function baseToString$1(value) {
    if (typeof value == `string`) return value;
    if (isArray$16(value)) return arrayMap$3(value, baseToString$1) + ``;
    if (isSymbol$2(value)) return symbolToString ? symbolToString.call(value) : ``;
    var result = value + ``;
    return result == `0` && 1 / value == -INFINITY$3 ? `-0` : result;
  }
  module2.exports = baseToString$1;
}), require_toString = __commonJSMin$1((exports$12, module2) => {
  var baseToString = require__baseToString();
  function toString$3(value) {
    return value == null ? `` : baseToString(value);
  }
  module2.exports = toString$3;
}), require__castPath = __commonJSMin$1((exports$12, module2) => {
  var isArray$15 = require_isArray(), isKey$2 = require__isKey(), stringToPath = require__stringToPath(), toString$2 = require_toString();
  function castPath$4(value, object) {
    return isArray$15(value) ? value : isKey$2(value, object) ? [value] : stringToPath(toString$2(value));
  }
  module2.exports = castPath$4;
}), require__toKey = __commonJSMin$1((exports$12, module2) => {
  var isSymbol$1 = require_isSymbol(), INFINITY$2 = 1 / 0;
  function toKey$5(value) {
    if (typeof value == `string` || isSymbol$1(value)) return value;
    var result = value + ``;
    return result == `0` && 1 / value == -INFINITY$2 ? `-0` : result;
  }
  module2.exports = toKey$5;
}), require__baseGet = __commonJSMin$1((exports$12, module2) => {
  var castPath$3 = require__castPath(), toKey$4 = require__toKey();
  function baseGet$3(object, path) {
    path = castPath$3(path, object);
    for (var index$2 = 0, length = path.length; object != null && index$2 < length; ) object = object[toKey$4(path[index$2++])];
    return index$2 && index$2 == length ? object : void 0;
  }
  module2.exports = baseGet$3;
}), require_get = __commonJSMin$1((exports$12, module2) => {
  var baseGet$2 = require__baseGet();
  function get$1(object, path, defaultValue) {
    var result = object == null ? void 0 : baseGet$2(object, path);
    return result === void 0 ? defaultValue : result;
  }
  module2.exports = get$1;
}), require__baseHasIn = __commonJSMin$1((exports$12, module2) => {
  function baseHasIn$1(object, key) {
    return object != null && key in Object(object);
  }
  module2.exports = baseHasIn$1;
}), require__hasPath = __commonJSMin$1((exports$12, module2) => {
  var castPath$2 = require__castPath(), isArguments$2 = require_isArguments$1(), isArray$14 = require_isArray(), isIndex$1 = require__isIndex(), isLength = require_isLength(), toKey$3 = require__toKey();
  function hasPath$2(object, path, hasFunc) {
    path = castPath$2(path, object);
    for (var index$2 = -1, length = path.length, result = false; ++index$2 < length; ) {
      var key = toKey$3(path[index$2]);
      if (!(result = object != null && hasFunc(object, key))) break;
      object = object[key];
    }
    return result || ++index$2 != length ? result : (length = object == null ? 0 : object.length, !!length && isLength(length) && isIndex$1(key, length) && (isArray$14(object) || isArguments$2(object)));
  }
  module2.exports = hasPath$2;
}), require_hasIn = __commonJSMin$1((exports$12, module2) => {
  var baseHasIn = require__baseHasIn(), hasPath$1 = require__hasPath();
  function hasIn$1(object, path) {
    return object != null && hasPath$1(object, path, baseHasIn);
  }
  module2.exports = hasIn$1;
}), require__baseMatchesProperty = __commonJSMin$1((exports$12, module2) => {
  var baseIsEqual = require__baseIsEqual(), get = require_get(), hasIn = require_hasIn(), isKey$1 = require__isKey(), isStrictComparable = require__isStrictComparable(), matchesStrictComparable = require__matchesStrictComparable(), toKey$2 = require__toKey(), COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
  function baseMatchesProperty$1(path, srcValue) {
    return isKey$1(path) && isStrictComparable(srcValue) ? matchesStrictComparable(toKey$2(path), srcValue) : function(object) {
      var objValue = get(object, path);
      return objValue === void 0 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
  }
  module2.exports = baseMatchesProperty$1;
}), require__baseProperty = __commonJSMin$1((exports$12, module2) => {
  function baseProperty$1(key) {
    return function(object) {
      return object?.[key];
    };
  }
  module2.exports = baseProperty$1;
}), require__basePropertyDeep = __commonJSMin$1((exports$12, module2) => {
  var baseGet$1 = require__baseGet();
  function basePropertyDeep$1(path) {
    return function(object) {
      return baseGet$1(object, path);
    };
  }
  module2.exports = basePropertyDeep$1;
}), require_property = __commonJSMin$1((exports$12, module2) => {
  var baseProperty = require__baseProperty(), basePropertyDeep = require__basePropertyDeep(), isKey = require__isKey(), toKey$1 = require__toKey();
  function property$1(path) {
    return isKey(path) ? baseProperty(toKey$1(path)) : basePropertyDeep(path);
  }
  module2.exports = property$1;
}), require__baseIteratee = __commonJSMin$1((exports$12, module2) => {
  var baseMatches = require__baseMatches(), baseMatchesProperty = require__baseMatchesProperty(), identity$9 = require_identity(), isArray$13 = require_isArray(), property = require_property();
  function baseIteratee$9(value) {
    return typeof value == `function` ? value : value == null ? identity$9 : typeof value == `object` ? isArray$13(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value) : property(value);
  }
  module2.exports = baseIteratee$9;
}), require__baseReduce = __commonJSMin$1((exports$12, module2) => {
  function baseReduce$1(collection, iteratee, accumulator, initAccum, eachFunc) {
    return eachFunc(collection, function(value, index$2, collection$1) {
      accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index$2, collection$1);
    }), accumulator;
  }
  module2.exports = baseReduce$1;
}), require_reduce = __commonJSMin$1((exports$12, module2) => {
  var arrayReduce = require__arrayReduce(), baseEach$5 = require__baseEach(), baseIteratee$8 = require__baseIteratee(), baseReduce = require__baseReduce(), isArray$12 = require_isArray();
  function reduce$5(collection, iteratee, accumulator) {
    var func = isArray$12(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
    return func(collection, baseIteratee$8(iteratee, 4), accumulator, initAccum, baseEach$5);
  }
  module2.exports = reduce$5;
}), require__arrayEach = __commonJSMin$1((exports$12, module2) => {
  function arrayEach$3(array, iteratee) {
    for (var index$2 = -1, length = array == null ? 0 : array.length; ++index$2 < length && iteratee(array[index$2], index$2, array) !== false; ) ;
    return array;
  }
  module2.exports = arrayEach$3;
}), require__baseCreate = __commonJSMin$1((exports$12, module2) => {
  var isObject$19 = require_isObject(), objectCreate = Object.create, baseCreate$2 = /* @__PURE__ */ (function() {
    function object() {
    }
    return function(proto) {
      if (!isObject$19(proto)) return {};
      if (objectCreate) return objectCreate(proto);
      object.prototype = proto;
      var result = new object();
      return object.prototype = void 0, result;
    };
  })();
  module2.exports = baseCreate$2;
}), require_transform = __commonJSMin$1((exports$12, module2) => {
  var arrayEach$2 = require__arrayEach(), baseCreate$1 = require__baseCreate(), baseForOwn = require__baseForOwn(), baseIteratee$7 = require__baseIteratee(), getPrototype$2 = require__getPrototype(), isArray$11 = require_isArray(), isBuffer$2 = require_isBuffer(), isFunction$7 = require_isFunction(), isObject$18 = require_isObject(), isTypedArray$3 = require_isTypedArray();
  function transform$1(object, iteratee, accumulator) {
    var isArr = isArray$11(object), isArrLike = isArr || isBuffer$2(object) || isTypedArray$3(object);
    if (iteratee = baseIteratee$7(iteratee, 4), accumulator == null) {
      var Ctor = object && object.constructor;
      accumulator = isArrLike ? isArr ? new Ctor() : [] : isObject$18(object) && isFunction$7(Ctor) ? baseCreate$1(getPrototype$2(object)) : {};
    }
    return (isArrLike ? arrayEach$2 : baseForOwn)(object, function(value, index$2, object$1) {
      return iteratee(accumulator, value, index$2, object$1);
    }), accumulator;
  }
  module2.exports = transform$1;
}), require_errors$1 = __commonJSMin$1((exports$12, module2) => {
  function _typeof$3(o$2) {
    "@babel/helpers - typeof";
    return _typeof$3 = typeof Symbol == `function` && typeof Symbol.iterator == `symbol` ? function(o$3) {
      return typeof o$3;
    } : function(o$3) {
      return o$3 && typeof Symbol == `function` && o$3.constructor === Symbol && o$3 !== Symbol.prototype ? `symbol` : typeof o$3;
    }, _typeof$3(o$2);
  }
  function _createClass$3(Constructor, protoProps, staticProps) {
    return Object.defineProperty(Constructor, `prototype`, { writable: false }), Constructor;
  }
  function _classCallCheck$3(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw TypeError(`Cannot call a class as a function`);
  }
  function _inherits$1(subClass, superClass) {
    if (typeof superClass != `function` && superClass !== null) throw TypeError(`Super expression must either be null or a function`);
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), Object.defineProperty(subClass, `prototype`, { writable: false }), superClass && _setPrototypeOf$1(subClass, superClass);
  }
  function _setPrototypeOf$1(o$2, p$1) {
    return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o$3, p$2) {
      return o$3.__proto__ = p$2, o$3;
    }, _setPrototypeOf$1(o$2, p$1);
  }
  function _createSuper$1(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
    return function() {
      var Super = _getPrototypeOf$1(Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf$1(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else result = Super.apply(this, arguments);
      return _possibleConstructorReturn$1(this, result);
    };
  }
  function _possibleConstructorReturn$1(self$1, call$2) {
    if (call$2 && (_typeof$3(call$2) === `object` || typeof call$2 == `function`)) return call$2;
    if (call$2 !== void 0) throw TypeError(`Derived constructors may only return object or undefined`);
    return _assertThisInitialized$1(self$1);
  }
  function _assertThisInitialized$1(self$1) {
    if (self$1 === void 0) throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
    return self$1;
  }
  function _isNativeReflectConstruct$1() {
    if (typeof Reflect > `u` || !Reflect.construct || Reflect.construct.sham) return false;
    if (typeof Proxy == `function`) return true;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), true;
    } catch {
      return false;
    }
  }
  function _getPrototypeOf$1(o$2) {
    return _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(o$3) {
      return o$3.__proto__ || Object.getPrototypeOf(o$3);
    }, _getPrototypeOf$1(o$2);
  }
  var codes$1 = {}, assert$24, util;
  function createErrorType$1(code$2, message, Base$4) {
    Base$4 ||= Error;
    function getMessage(arg1, arg2, arg3) {
      return typeof message == `string` ? message : message(arg1, arg2, arg3);
    }
    var NodeError = (function(_Base) {
      _inherits$1(NodeError$1, _Base);
      var _super = _createSuper$1(NodeError$1);
      function NodeError$1(arg1, arg2, arg3) {
        var _this;
        return _classCallCheck$3(this, NodeError$1), _this = _super.call(this, getMessage(arg1, arg2, arg3)), _this.code = code$2, _this;
      }
      return _createClass$3(NodeError$1);
    })(Base$4);
    codes$1[code$2] = NodeError;
  }
  function oneOf$3(expected, thing) {
    if (Array.isArray(expected)) {
      var len$2 = expected.length;
      return expected = expected.map(function(i$4) {
        return String(i$4);
      }), len$2 > 2 ? `one of ${thing} ${expected.slice(0, len$2 - 1).join(`, `)}, or ` + expected[len$2 - 1] : len$2 === 2 ? `one of ${thing} ${expected[0]} or ${expected[1]}` : `of ${thing} ${expected[0]}`;
    } else return `of ${thing} ${String(expected)}`;
  }
  function startsWith$1(str, search, pos) {
    return str.substr(0, search.length) === search;
  }
  function endsWith$2(str, search, this_len) {
    return (this_len === void 0 || this_len > str.length) && (this_len = str.length), str.substring(this_len - search.length, this_len) === search;
  }
  function includes$1(str, search, start) {
    return typeof start != `number` && (start = 0), start + search.length > str.length ? false : str.indexOf(search, start) !== -1;
  }
  createErrorType$1(`ERR_AMBIGUOUS_ARGUMENT`, `The "%s" argument is ambiguous. %s`, TypeError), createErrorType$1(`ERR_INVALID_ARG_TYPE`, function(name$2, expected, actual) {
    assert$24 === void 0 && (assert$24 = require_assert()), assert$24(typeof name$2 == `string`, `'name' must be a string`);
    var determiner;
    typeof expected == `string` && startsWith$1(expected, `not `) ? (determiner = `must not be`, expected = expected.replace(/^not /, ``)) : determiner = `must be`;
    var msg;
    if (endsWith$2(name$2, ` argument`)) msg = `The ${name$2} ${determiner} ${oneOf$3(expected, `type`)}`;
    else {
      var type = includes$1(name$2, `.`) ? `property` : `argument`;
      msg = `The "${name$2}" ${type} ${determiner} ${oneOf$3(expected, `type`)}`;
    }
    return msg += `. Received type ${_typeof$3(actual)}`, msg;
  }, TypeError), createErrorType$1(`ERR_INVALID_ARG_VALUE`, function(name$2, value) {
    var reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : `is invalid`;
    util === void 0 && (util = require_util());
    var inspected = util.inspect(value);
    return inspected.length > 128 && (inspected = `${inspected.slice(0, 128)}...`), `The argument '${name$2}' ${reason}. Received ${inspected}`;
  }, TypeError), createErrorType$1(`ERR_INVALID_RETURN_VALUE`, function(input, name$2, value) {
    var type;
    return type = value && value.constructor && value.constructor.name ? `instance of ${value.constructor.name}` : `type ${_typeof$3(value)}`, `Expected ${input} to be returned from the "${name$2}" function but got ${type}.`;
  }, TypeError), createErrorType$1(`ERR_MISSING_ARGS`, function() {
    for (var _len = arguments.length, args$1 = Array(_len), _key = 0; _key < _len; _key++) args$1[_key] = arguments[_key];
    assert$24 === void 0 && (assert$24 = require_assert()), assert$24(args$1.length > 0, `At least one arg needs to be specified`);
    var msg = `The `, len$2 = args$1.length;
    switch (args$1 = args$1.map(function(a$22) {
      return `"${a$22}"`;
    }), len$2) {
      case 1:
        msg += `${args$1[0]} argument`;
        break;
      case 2:
        msg += `${args$1[0]} and ${args$1[1]} arguments`;
        break;
      default:
        msg += args$1.slice(0, len$2 - 1).join(`, `), msg += `, and ${args$1[len$2 - 1]} arguments`;
        break;
    }
    return `${msg} must be specified`;
  }, TypeError), module2.exports.codes = codes$1;
}), require_assertion_error = __commonJSMin$1((exports$12, module2) => {
  init_dist();
  function ownKeys$2(e$22, r$2) {
    var t$7 = Object.keys(e$22);
    if (Object.getOwnPropertySymbols) {
      var o$2 = Object.getOwnPropertySymbols(e$22);
      r$2 && (o$2 = o$2.filter(function(r$3) {
        return Object.getOwnPropertyDescriptor(e$22, r$3).enumerable;
      })), t$7.push.apply(t$7, o$2);
    }
    return t$7;
  }
  function _objectSpread$2(e$22) {
    for (var r$2 = 1; r$2 < arguments.length; r$2++) {
      var t$7 = arguments[r$2] == null ? {} : arguments[r$2];
      r$2 % 2 ? ownKeys$2(Object(t$7), true).forEach(function(r$3) {
        _defineProperty$3(e$22, r$3, t$7[r$3]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e$22, Object.getOwnPropertyDescriptors(t$7)) : ownKeys$2(Object(t$7)).forEach(function(r$3) {
        Object.defineProperty(e$22, r$3, Object.getOwnPropertyDescriptor(t$7, r$3));
      });
    }
    return e$22;
  }
  function _defineProperty$3(obj, key, value) {
    return key = _toPropertyKey$4(key), key in obj ? Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true }) : obj[key] = value, obj;
  }
  function _classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw TypeError(`Cannot call a class as a function`);
  }
  function _defineProperties$2(target, props) {
    for (var i$4 = 0; i$4 < props.length; i$4++) {
      var descriptor = props[i$4];
      descriptor.enumerable = descriptor.enumerable || false, descriptor.configurable = true, `value` in descriptor && (descriptor.writable = true), Object.defineProperty(target, _toPropertyKey$4(descriptor.key), descriptor);
    }
  }
  function _createClass$2(Constructor, protoProps, staticProps) {
    return protoProps && _defineProperties$2(Constructor.prototype, protoProps), Object.defineProperty(Constructor, `prototype`, { writable: false }), Constructor;
  }
  function _toPropertyKey$4(arg) {
    var key = _toPrimitive$4(arg, `string`);
    return _typeof$2(key) === `symbol` ? key : String(key);
  }
  function _toPrimitive$4(input, hint) {
    if (_typeof$2(input) !== `object` || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint);
      if (_typeof$2(res) !== `object`) return res;
      throw TypeError(`@@toPrimitive must return a primitive value.`);
    }
    return String(input);
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass != `function` && superClass !== null) throw TypeError(`Super expression must either be null or a function`);
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), Object.defineProperty(subClass, `prototype`, { writable: false }), superClass && _setPrototypeOf(subClass, superClass);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function() {
      var Super = _getPrototypeOf(Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else result = Super.apply(this, arguments);
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self$1, call$2) {
    if (call$2 && (_typeof$2(call$2) === `object` || typeof call$2 == `function`)) return call$2;
    if (call$2 !== void 0) throw TypeError(`Derived constructors may only return object or undefined`);
    return _assertThisInitialized(self$1);
  }
  function _assertThisInitialized(self$1) {
    if (self$1 === void 0) throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
    return self$1;
  }
  function _wrapNativeSuper(Class) {
    var _cache = typeof Map == `function` ? /* @__PURE__ */ new Map() : void 0;
    return _wrapNativeSuper = function(Class$1) {
      if (Class$1 === null || !_isNativeFunction(Class$1)) return Class$1;
      if (typeof Class$1 != `function`) throw TypeError(`Super expression must either be null or a function`);
      if (_cache !== void 0) {
        if (_cache.has(Class$1)) return _cache.get(Class$1);
        _cache.set(Class$1, Wrapper);
      }
      function Wrapper() {
        return _construct(Class$1, arguments, _getPrototypeOf(this).constructor);
      }
      return Wrapper.prototype = Object.create(Class$1.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }), _setPrototypeOf(Wrapper, Class$1);
    }, _wrapNativeSuper(Class);
  }
  function _construct(Parent, args$1, Class) {
    return _construct = _isNativeReflectConstruct() ? Reflect.construct.bind() : function(Parent$1, args$2, Class$1) {
      var a$22 = [null];
      a$22.push.apply(a$22, args$2);
      var Constructor = Function.bind.apply(Parent$1, a$22), instance = new Constructor();
      return Class$1 && _setPrototypeOf(instance, Class$1.prototype), instance;
    }, _construct.apply(null, arguments);
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect > `u` || !Reflect.construct || Reflect.construct.sham) return false;
    if (typeof Proxy == `function`) return true;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), true;
    } catch {
      return false;
    }
  }
  function _isNativeFunction(fn$1) {
    return Function.toString.call(fn$1).indexOf(`[native code]`) !== -1;
  }
  function _setPrototypeOf(o$2, p$1) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o$3, p$2) {
      return o$3.__proto__ = p$2, o$3;
    }, _setPrototypeOf(o$2, p$1);
  }
  function _getPrototypeOf(o$2) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(o$3) {
      return o$3.__proto__ || Object.getPrototypeOf(o$3);
    }, _getPrototypeOf(o$2);
  }
  function _typeof$2(o$2) {
    "@babel/helpers - typeof";
    return _typeof$2 = typeof Symbol == `function` && typeof Symbol.iterator == `symbol` ? function(o$3) {
      return typeof o$3;
    } : function(o$3) {
      return o$3 && typeof Symbol == `function` && o$3.constructor === Symbol && o$3 !== Symbol.prototype ? `symbol` : typeof o$3;
    }, _typeof$2(o$2);
  }
  var _require$4 = require_util(), inspect$2 = _require$4.inspect, _require2$2 = require_errors$1(), ERR_INVALID_ARG_TYPE$4 = _require2$2.codes.ERR_INVALID_ARG_TYPE;
  function endsWith$1(str, search, this_len) {
    return (this_len === void 0 || this_len > str.length) && (this_len = str.length), str.substring(this_len - search.length, this_len) === search;
  }
  function repeat(str, count) {
    if (count = Math.floor(count), str.length == 0 || count == 0) return ``;
    var maxCount = str.length * count;
    for (count = Math.floor(Math.log(count) / Math.log(2)); count; ) str += str, count--;
    return str += str.substring(0, maxCount - str.length), str;
  }
  var blue = ``, green = ``, red = ``, white = ``, kReadableOperator = { deepStrictEqual: `Expected values to be strictly deep-equal:`, strictEqual: `Expected values to be strictly equal:`, strictEqualObject: `Expected "actual" to be reference-equal to "expected":`, deepEqual: `Expected values to be loosely deep-equal:`, equal: `Expected values to be loosely equal:`, notDeepStrictEqual: `Expected "actual" not to be strictly deep-equal to:`, notStrictEqual: `Expected "actual" to be strictly unequal to:`, notStrictEqualObject: `Expected "actual" not to be reference-equal to "expected":`, notDeepEqual: `Expected "actual" not to be loosely deep-equal to:`, notEqual: `Expected "actual" to be loosely unequal to:`, notIdentical: `Values identical but not reference-equal:` }, kMaxShortLength = 10;
  function copyError(source) {
    var keys$10 = Object.keys(source), target = Object.create(Object.getPrototypeOf(source));
    return keys$10.forEach(function(key) {
      target[key] = source[key];
    }), Object.defineProperty(target, `message`, { value: source.message }), target;
  }
  function inspectValue(val) {
    return inspect$2(val, { compact: false, customInspect: false, depth: 1e3, maxArrayLength: 1 / 0, showHidden: false, breakLength: 1 / 0, showProxy: false, sorted: true, getters: true });
  }
  function createErrDiff(actual, expected, operator$1) {
    var other = ``, res = ``, lastPos = 0, end = ``, skipped = false, actualInspected = inspectValue(actual), actualLines = actualInspected.split(`
`), expectedLines = inspectValue(expected).split(`
`), i$4 = 0, indicator = ``;
    if (operator$1 === `strictEqual` && _typeof$2(actual) === `object` && _typeof$2(expected) === `object` && actual !== null && expected !== null && (operator$1 = `strictEqualObject`), actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
      var inputLength = actualLines[0].length + expectedLines[0].length;
      if (inputLength <= kMaxShortLength) {
        if ((_typeof$2(actual) !== `object` || actual === null) && (_typeof$2(expected) !== `object` || expected === null) && (actual !== 0 || expected !== 0)) return `${kReadableOperator[operator$1]}

${actualLines[0]} !== ${expectedLines[0]}
`;
      } else if (operator$1 !== `strictEqualObject`) {
        var maxLength = process$1.stderr && process$1.stderr.isTTY ? process$1.stderr.columns : 80;
        if (inputLength < maxLength) {
          for (; actualLines[0][i$4] === expectedLines[0][i$4]; ) i$4++;
          i$4 > 2 && (indicator = `
  ${repeat(` `, i$4)}^`, i$4 = 0);
        }
      }
    }
    for (var a$22 = actualLines[actualLines.length - 1], b2 = expectedLines[expectedLines.length - 1]; a$22 === b2 && (i$4++ < 2 ? end = `
  ${a$22}${end}` : other = a$22, actualLines.pop(), expectedLines.pop(), !(actualLines.length === 0 || expectedLines.length === 0)); ) a$22 = actualLines[actualLines.length - 1], b2 = expectedLines[expectedLines.length - 1];
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    if (maxLines === 0) {
      var _actualLines = actualInspected.split(`
`);
      if (_actualLines.length > 30) for (_actualLines[26] = `${blue}...${white}`; _actualLines.length > 27; ) _actualLines.pop();
      return `${kReadableOperator.notIdentical}

${_actualLines.join(`
`)}
`;
    }
    i$4 > 3 && (end = `
${blue}...${white}${end}`, skipped = true), other !== `` && (end = `
  ${other}${end}`, other = ``);
    var printedLines = 0, msg = kReadableOperator[operator$1] + `
${green}+ actual${white} ${red}- expected${white}`, skippedMsg = ` ${blue}...${white} Lines skipped`;
    for (i$4 = 0; i$4 < maxLines; i$4++) {
      var cur = i$4 - lastPos;
      if (actualLines.length < i$4 + 1) cur > 1 && i$4 > 2 && (cur > 4 ? (res += `
${blue}...${white}`, skipped = true) : cur > 3 && (res += `
  ${expectedLines[i$4 - 2]}`, printedLines++), res += `
  ${expectedLines[i$4 - 1]}`, printedLines++), lastPos = i$4, other += `
${red}-${white} ${expectedLines[i$4]}`, printedLines++;
      else if (expectedLines.length < i$4 + 1) cur > 1 && i$4 > 2 && (cur > 4 ? (res += `
${blue}...${white}`, skipped = true) : cur > 3 && (res += `
  ${actualLines[i$4 - 2]}`, printedLines++), res += `
  ${actualLines[i$4 - 1]}`, printedLines++), lastPos = i$4, res += `
${green}+${white} ${actualLines[i$4]}`, printedLines++;
      else {
        var expectedLine = expectedLines[i$4], actualLine = actualLines[i$4], divergingLines = actualLine !== expectedLine && (!endsWith$1(actualLine, `,`) || actualLine.slice(0, -1) !== expectedLine);
        divergingLines && endsWith$1(expectedLine, `,`) && expectedLine.slice(0, -1) === actualLine && (divergingLines = false, actualLine += `,`), divergingLines ? (cur > 1 && i$4 > 2 && (cur > 4 ? (res += `
${blue}...${white}`, skipped = true) : cur > 3 && (res += `
  ${actualLines[i$4 - 2]}`, printedLines++), res += `
  ${actualLines[i$4 - 1]}`, printedLines++), lastPos = i$4, res += `
${green}+${white} ${actualLine}`, other += `
${red}-${white} ${expectedLine}`, printedLines += 2) : (res += other, other = ``, (cur === 1 || i$4 === 0) && (res += `
  ${actualLine}`, printedLines++));
      }
      if (printedLines > 20 && i$4 < maxLines - 2) return `${msg}${skippedMsg}
${res}
${blue}...${white}${other}
${blue}...${white}`;
    }
    return `${msg}${skipped ? skippedMsg : ``}
${res}${other}${end}${indicator}`;
  }
  var AssertionError$1 = (function(_Error, _inspect$custom) {
    _inherits(AssertionError$2, _Error);
    var _super = _createSuper(AssertionError$2);
    function AssertionError$2(options) {
      var _this;
      if (_classCallCheck$2(this, AssertionError$2), _typeof$2(options) !== `object` || options === null) throw new ERR_INVALID_ARG_TYPE$4(`options`, `Object`, options);
      var message = options.message, operator$1 = options.operator, stackStartFn = options.stackStartFn, actual = options.actual, expected = options.expected, limit = Error.stackTraceLimit;
      if (Error.stackTraceLimit = 0, message != null) _this = _super.call(this, String(message));
      else if (process$1.stderr && process$1.stderr.isTTY && (process$1.stderr && process$1.stderr.getColorDepth && process$1.stderr.getColorDepth() !== 1 ? (blue = `\x1B[34m`, green = `\x1B[32m`, white = `\x1B[39m`, red = `\x1B[31m`) : (blue = ``, green = ``, white = ``, red = ``)), _typeof$2(actual) === `object` && actual !== null && _typeof$2(expected) === `object` && expected !== null && `stack` in actual && actual instanceof Error && `stack` in expected && expected instanceof Error && (actual = copyError(actual), expected = copyError(expected)), operator$1 === `deepStrictEqual` || operator$1 === `strictEqual`) _this = _super.call(this, createErrDiff(actual, expected, operator$1));
      else if (operator$1 === `notDeepStrictEqual` || operator$1 === `notStrictEqual`) {
        var base$3 = kReadableOperator[operator$1], res = inspectValue(actual).split(`
`);
        if (operator$1 === `notStrictEqual` && _typeof$2(actual) === `object` && actual !== null && (base$3 = kReadableOperator.notStrictEqualObject), res.length > 30) for (res[26] = `${blue}...${white}`; res.length > 27; ) res.pop();
        _this = res.length === 1 ? _super.call(this, `${base$3} ${res[0]}`) : _super.call(this, `${base$3}

${res.join(`
`)}
`);
      } else {
        var _res = inspectValue(actual), other = ``, knownOperators = kReadableOperator[operator$1];
        operator$1 === `notDeepEqual` || operator$1 === `notEqual` ? (_res = `${kReadableOperator[operator$1]}

${_res}`, _res.length > 1024 && (_res = `${_res.slice(0, 1021)}...`)) : (other = `${inspectValue(expected)}`, _res.length > 512 && (_res = `${_res.slice(0, 509)}...`), other.length > 512 && (other = `${other.slice(0, 509)}...`), operator$1 === `deepEqual` || operator$1 === `equal` ? _res = `${knownOperators}

${_res}

should equal

` : other = ` ${operator$1} ${other}`), _this = _super.call(this, `${_res}${other}`);
      }
      return Error.stackTraceLimit = limit, _this.generatedMessage = !message, Object.defineProperty(_assertThisInitialized(_this), `name`, { value: `AssertionError [ERR_ASSERTION]`, enumerable: false, writable: true, configurable: true }), _this.code = `ERR_ASSERTION`, _this.actual = actual, _this.expected = expected, _this.operator = operator$1, Error.captureStackTrace && Error.captureStackTrace(_assertThisInitialized(_this), stackStartFn), _this.stack, _this.name = `AssertionError`, _possibleConstructorReturn(_this);
    }
    return _createClass$2(AssertionError$2, [{ key: `toString`, value: function() {
      return `${this.name} [${this.code}]: ${this.message}`;
    } }, { key: _inspect$custom, value: function(recurseTimes, ctx) {
      return inspect$2(this, _objectSpread$2(_objectSpread$2({}, ctx), {}, { customInspect: false, depth: 0 }));
    } }]), AssertionError$2;
  })(_wrapNativeSuper(Error), inspect$2.custom);
  module2.exports = AssertionError$1;
}), require_isArguments = __commonJSMin$1((exports$12, module2) => {
  var toStr$2 = Object.prototype.toString;
  module2.exports = function(value) {
    var str = toStr$2.call(value), isArgs$2 = str === `[object Arguments]`;
    return isArgs$2 ||= str !== `[object Array]` && typeof value == `object` && !!value && typeof value.length == `number` && value.length >= 0 && toStr$2.call(value.callee) === `[object Function]`, isArgs$2;
  };
}), require_implementation$3 = __commonJSMin$1((exports$12, module2) => {
  var keysShim$1;
  if (!Object.keys) {
    var has$5 = Object.prototype.hasOwnProperty, toStr$1 = Object.prototype.toString, isArgs$1 = require_isArguments(), isEnumerable = Object.prototype.propertyIsEnumerable, hasDontEnumBug = !isEnumerable.call({ toString: null }, `toString`), hasProtoEnumBug = isEnumerable.call(function() {
    }, `prototype`), dontEnums = [`toString`, `toLocaleString`, `valueOf`, `hasOwnProperty`, `isPrototypeOf`, `propertyIsEnumerable`, `constructor`], equalsConstructorPrototype = function(o$2) {
      var ctor = o$2.constructor;
      return ctor && ctor.prototype === o$2;
    }, excludedKeys = { $applicationCache: true, $console: true, $external: true, $frame: true, $frameElement: true, $frames: true, $innerHeight: true, $innerWidth: true, $onmozfullscreenchange: true, $onmozfullscreenerror: true, $outerHeight: true, $outerWidth: true, $pageXOffset: true, $pageYOffset: true, $parent: true, $scrollLeft: true, $scrollTop: true, $scrollX: true, $scrollY: true, $self: true, $webkitIndexedDB: true, $webkitStorageInfo: true, $window: true }, hasAutomationEqualityBug = (function() {
      if (typeof window > `u`) return false;
      for (var k in window) try {
        if (!excludedKeys[`$` + k] && has$5.call(window, k) && window[k] !== null && typeof window[k] == `object`) try {
          equalsConstructorPrototype(window[k]);
        } catch {
          return true;
        }
      } catch {
        return true;
      }
      return false;
    })(), equalsConstructorPrototypeIfNotBuggy = function(o$2) {
      if (typeof window > `u` || !hasAutomationEqualityBug) return equalsConstructorPrototype(o$2);
      try {
        return equalsConstructorPrototype(o$2);
      } catch {
        return false;
      }
    };
    keysShim$1 = function(object) {
      var isObject$26 = typeof object == `object` && !!object, isFunction$12 = toStr$1.call(object) === `[object Function]`, isArguments$5 = isArgs$1(object), isString$20 = isObject$26 && toStr$1.call(object) === `[object String]`, theKeys = [];
      if (!isObject$26 && !isFunction$12 && !isArguments$5) throw TypeError(`Object.keys called on a non-object`);
      var skipProto = hasProtoEnumBug && isFunction$12;
      if (isString$20 && object.length > 0 && !has$5.call(object, 0)) for (var i$4 = 0; i$4 < object.length; ++i$4) theKeys.push(String(i$4));
      if (isArguments$5 && object.length > 0) for (var j$1 = 0; j$1 < object.length; ++j$1) theKeys.push(String(j$1));
      else for (var name$2 in object) !(skipProto && name$2 === `prototype`) && has$5.call(object, name$2) && theKeys.push(String(name$2));
      if (hasDontEnumBug) for (var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object), k = 0; k < dontEnums.length; ++k) !(skipConstructor && dontEnums[k] === `constructor`) && has$5.call(object, dontEnums[k]) && theKeys.push(dontEnums[k]);
      return theKeys;
    };
  }
  module2.exports = keysShim$1;
}), require_object_keys = __commonJSMin$1((exports$12, module2) => {
  var slice = Array.prototype.slice, isArgs = require_isArguments(), origKeys = Object.keys, keysShim = origKeys ? function(o$2) {
    return origKeys(o$2);
  } : require_implementation$3(), originalKeys = Object.keys;
  keysShim.shim = function() {
    if (Object.keys) {
      var keysWorksWithArguments = (function() {
        var args$1 = Object.keys(arguments);
        return args$1 && args$1.length === arguments.length;
      })(1, 2);
      keysWorksWithArguments || (Object.keys = function(object) {
        return isArgs(object) ? originalKeys(slice.call(object)) : originalKeys(object);
      });
    } else Object.keys = keysShim;
    return Object.keys || keysShim;
  }, module2.exports = keysShim;
}), require_implementation$2 = __commonJSMin$1((exports$12, module2) => {
  var objectKeys$1 = require_object_keys(), hasSymbols$1 = require_shams$1()(), callBound$1 = require_call_bound(), $Object = require_es_object_atoms(), $push = callBound$1(`Array.prototype.push`), $propIsEnumerable = callBound$1(`Object.prototype.propertyIsEnumerable`), originalGetSymbols = hasSymbols$1 ? $Object.getOwnPropertySymbols : null;
  module2.exports = function(target, source1) {
    if (target == null) throw TypeError(`target must be an object`);
    var to = $Object(target);
    if (arguments.length === 1) return to;
    for (var s$6 = 1; s$6 < arguments.length; ++s$6) {
      var from$2 = $Object(arguments[s$6]), keys$10 = objectKeys$1(from$2), getSymbols$4 = hasSymbols$1 && ($Object.getOwnPropertySymbols || originalGetSymbols);
      if (getSymbols$4) for (var syms = getSymbols$4(from$2), j$1 = 0; j$1 < syms.length; ++j$1) {
        var key = syms[j$1];
        $propIsEnumerable(from$2, key) && $push(keys$10, key);
      }
      for (var i$4 = 0; i$4 < keys$10.length; ++i$4) {
        var nextKey = keys$10[i$4];
        if ($propIsEnumerable(from$2, nextKey)) {
          var propValue = from$2[nextKey];
          to[nextKey] = propValue;
        }
      }
    }
    return to;
  };
}), require_polyfill$2 = __commonJSMin$1((exports$12, module2) => {
  var implementation$4 = require_implementation$2(), lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    for (var str = `abcdefghijklmnopqrst`, letters = str.split(``), map$8 = {}, i$4 = 0; i$4 < letters.length; ++i$4) map$8[letters[i$4]] = letters[i$4];
    var obj = Object.assign({}, map$8), actual = ``;
    for (var k in obj) actual += k;
    return str !== actual;
  }, assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    var thrower = Object.preventExtensions({ 1: 2 });
    try {
      Object.assign(thrower, `xy`);
    } catch {
      return thrower[1] === `y`;
    }
    return false;
  };
  module2.exports = function() {
    return !Object.assign || lacksProperEnumerationOrder() || assignHasPendingExceptions() ? implementation$4 : Object.assign;
  };
}), require_implementation$1 = __commonJSMin$1((exports$12, module2) => {
  var numberIsNaN$1 = function(value) {
    return value !== value;
  };
  module2.exports = function(a$22, b2) {
    return a$22 === 0 && b2 === 0 ? 1 / a$22 == 1 / b2 : !!(a$22 === b2 || numberIsNaN$1(a$22) && numberIsNaN$1(b2));
  };
}), require_polyfill$1 = __commonJSMin$1((exports$12, module2) => {
  var implementation$3 = require_implementation$1();
  module2.exports = function() {
    return typeof Object.is == `function` ? Object.is : implementation$3;
  };
}), require_callBound = __commonJSMin$1((exports$12, module2) => {
  var GetIntrinsic = require_get_intrinsic(), callBind$2 = require_call_bind(), $indexOf = callBind$2(GetIntrinsic(`String.prototype.indexOf`));
  module2.exports = function(name$2, allowMissing) {
    var intrinsic = GetIntrinsic(name$2, !!allowMissing);
    return typeof intrinsic == `function` && $indexOf(name$2, `.prototype.`) > -1 ? callBind$2(intrinsic) : intrinsic;
  };
}), require_define_properties = __commonJSMin$1((exports$12, module2) => {
  var keys$4 = require_object_keys(), hasSymbols = typeof Symbol == `function` && typeof Symbol(`foo`) == `symbol`, toStr = Object.prototype.toString, concat = Array.prototype.concat, defineDataProperty = require_define_data_property(), isFunction$6 = function(fn$1) {
    return typeof fn$1 == `function` && toStr.call(fn$1) === `[object Function]`;
  }, supportsDescriptors = require_has_property_descriptors()(), defineProperty = function(object, name$2, value, predicate) {
    if (name$2 in object) {
      if (predicate === true) {
        if (object[name$2] === value) return;
      } else if (!isFunction$6(predicate) || !predicate()) return;
    }
    supportsDescriptors ? defineDataProperty(object, name$2, value, true) : defineDataProperty(object, name$2, value);
  }, defineProperties = function(object, map$8) {
    var predicates = arguments.length > 2 ? arguments[2] : {}, props = keys$4(map$8);
    hasSymbols && (props = concat.call(props, Object.getOwnPropertySymbols(map$8)));
    for (var i$4 = 0; i$4 < props.length; i$4 += 1) defineProperty(object, props[i$4], map$8[props[i$4]], predicates[props[i$4]]);
  };
  defineProperties.supportsDescriptors = !!supportsDescriptors, module2.exports = defineProperties;
}), require_shim$1 = __commonJSMin$1((exports$12, module2) => {
  var getPolyfill$3 = require_polyfill$1(), define$4 = require_define_properties();
  module2.exports = function() {
    var polyfill$2 = getPolyfill$3();
    return define$4(Object, { is: polyfill$2 }, { is: function() {
      return Object.is !== polyfill$2;
    } }), polyfill$2;
  };
}), require_object_is = __commonJSMin$1((exports$12, module2) => {
  var define$3 = require_define_properties(), callBind$1 = require_call_bind(), implementation$2 = require_implementation$1(), getPolyfill$2 = require_polyfill$1(), shim$1 = require_shim$1(), polyfill$1 = callBind$1(getPolyfill$2(), Object);
  define$3(polyfill$1, { getPolyfill: getPolyfill$2, implementation: implementation$2, shim: shim$1 }), module2.exports = polyfill$1;
}), require_implementation = __commonJSMin$1((exports$12, module2) => {
  module2.exports = function(value) {
    return value !== value;
  };
}), require_polyfill = __commonJSMin$1((exports$12, module2) => {
  var implementation$1 = require_implementation();
  module2.exports = function() {
    return Number.isNaN && !Number.isNaN(`a`) ? Number.isNaN : implementation$1;
  };
}), require_shim = __commonJSMin$1((exports$12, module2) => {
  var define$2 = require_define_properties(), getPolyfill$1 = require_polyfill();
  module2.exports = function() {
    var polyfill$2 = getPolyfill$1();
    return define$2(Number, { isNaN: polyfill$2 }, { isNaN: function() {
      return Number.isNaN !== polyfill$2;
    } }), polyfill$2;
  };
}), require_is_nan = __commonJSMin$1((exports$12, module2) => {
  var callBind = require_call_bind(), define$1 = require_define_properties(), implementation = require_implementation(), getPolyfill = require_polyfill(), shim = require_shim(), polyfill = callBind(getPolyfill(), Number);
  define$1(polyfill, { getPolyfill, implementation, shim }), module2.exports = polyfill;
}), require_comparisons = __commonJSMin$1((exports$12, module2) => {
  function _slicedToArray(arr, i$4) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i$4) || _unsupportedIterableToArray(arr, i$4) || _nonIterableRest();
  }
  function _nonIterableRest() {
    throw TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function _unsupportedIterableToArray(o$2, minLen) {
    if (o$2) {
      if (typeof o$2 == `string`) return _arrayLikeToArray(o$2, minLen);
      var n$4 = Object.prototype.toString.call(o$2).slice(8, -1);
      if (n$4 === `Object` && o$2.constructor && (n$4 = o$2.constructor.name), n$4 === `Map` || n$4 === `Set`) return Array.from(o$2);
      if (n$4 === `Arguments` || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n$4)) return _arrayLikeToArray(o$2, minLen);
    }
  }
  function _arrayLikeToArray(arr, len$2) {
    (len$2 == null || len$2 > arr.length) && (len$2 = arr.length);
    for (var i$4 = 0, arr2 = Array(len$2); i$4 < len$2; i$4++) arr2[i$4] = arr[i$4];
    return arr2;
  }
  function _iterableToArrayLimit(r$2, l$4) {
    var t$7 = r$2 == null ? null : typeof Symbol < `u` && r$2[Symbol.iterator] || r$2[`@@iterator`];
    if (t$7 != null) {
      var e$22, n$4, i$4, u, a$22 = [], f$32 = true, o$2 = false;
      try {
        if (i$4 = (t$7 = t$7.call(r$2)).next, l$4 === 0) ;
        else for (; !(f$32 = (e$22 = i$4.call(t$7)).done) && (a$22.push(e$22.value), a$22.length !== l$4); f$32 = true) ;
      } catch (r$3) {
        o$2 = true, n$4 = r$3;
      } finally {
        try {
          if (!f$32 && t$7.return != null && (u = t$7.return(), Object(u) !== u)) return;
        } finally {
          if (o$2) throw n$4;
        }
      }
      return a$22;
    }
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  function _typeof$1(o$2) {
    "@babel/helpers - typeof";
    return _typeof$1 = typeof Symbol == `function` && typeof Symbol.iterator == `symbol` ? function(o$3) {
      return typeof o$3;
    } : function(o$3) {
      return o$3 && typeof Symbol == `function` && o$3.constructor === Symbol && o$3 !== Symbol.prototype ? `symbol` : typeof o$3;
    }, _typeof$1(o$2);
  }
  var regexFlagsSupported = /a/g.flags !== void 0, arrayFromSet = function(set) {
    var array = [];
    return set.forEach(function(value) {
      return array.push(value);
    }), array;
  }, arrayFromMap = function(map$8) {
    var array = [];
    return map$8.forEach(function(value, key) {
      return array.push([key, value]);
    }), array;
  }, objectIs$1 = Object.is ? Object.is : require_object_is(), objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
  }, numberIsNaN = Number.isNaN ? Number.isNaN : require_is_nan();
  function uncurryThis(f$32) {
    return f$32.call.bind(f$32);
  }
  var hasOwnProperty$8 = uncurryThis(Object.prototype.hasOwnProperty), propertyIsEnumerable = uncurryThis(Object.prototype.propertyIsEnumerable), objectToString = uncurryThis(Object.prototype.toString), _require$types$1 = require_util().types, isAnyArrayBuffer = _require$types$1.isAnyArrayBuffer, isArrayBufferView = _require$types$1.isArrayBufferView, isDate$2 = _require$types$1.isDate, isMap$2 = _require$types$1.isMap, isRegExp$1 = _require$types$1.isRegExp, isSet$2 = _require$types$1.isSet, isNativeError = _require$types$1.isNativeError, isBoxedPrimitive = _require$types$1.isBoxedPrimitive, isNumberObject = _require$types$1.isNumberObject, isStringObject = _require$types$1.isStringObject, isBooleanObject = _require$types$1.isBooleanObject, isBigIntObject = _require$types$1.isBigIntObject, isSymbolObject = _require$types$1.isSymbolObject, isFloat32Array = _require$types$1.isFloat32Array, isFloat64Array = _require$types$1.isFloat64Array;
  function isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for (var i$4 = 0; i$4 < key.length; i$4++) {
      var code$2 = key.charCodeAt(i$4);
      if (code$2 < 48 || code$2 > 57) return true;
    }
    return key.length === 10 && key >= 2 ** 32;
  }
  function getOwnNonIndexProperties(value) {
    return Object.keys(value).filter(isNonIndex).concat(objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
  }
  function compare$15(a$22, b2) {
    if (a$22 === b2) return 0;
    for (var x$1 = a$22.length, y$1 = b2.length, i$4 = 0, len$2 = Math.min(x$1, y$1); i$4 < len$2; ++i$4) if (a$22[i$4] !== b2[i$4]) {
      x$1 = a$22[i$4], y$1 = b2[i$4];
      break;
    }
    return x$1 < y$1 ? -1 : y$1 < x$1 ? 1 : 0;
  }
  var kStrict = true, kLoose = false, kNoIterator = 0, kIsArray = 1, kIsSet = 2, kIsMap = 3;
  function areSimilarRegExps(a$22, b2) {
    return regexFlagsSupported ? a$22.source === b2.source && a$22.flags === b2.flags : RegExp.prototype.toString.call(a$22) === RegExp.prototype.toString.call(b2);
  }
  function areSimilarFloatArrays(a$22, b2) {
    if (a$22.byteLength !== b2.byteLength) return false;
    for (var offset$2 = 0; offset$2 < a$22.byteLength; offset$2++) if (a$22[offset$2] !== b2[offset$2]) return false;
    return true;
  }
  function areSimilarTypedArrays(a$22, b2) {
    return a$22.byteLength === b2.byteLength ? compare$15(new Uint8Array(a$22.buffer, a$22.byteOffset, a$22.byteLength), new Uint8Array(b2.buffer, b2.byteOffset, b2.byteLength)) === 0 : false;
  }
  function areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && compare$15(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
  }
  function isEqualBoxedPrimitive(val1, val2) {
    return isNumberObject(val1) ? isNumberObject(val2) && objectIs$1(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2)) : isStringObject(val1) ? isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2) : isBooleanObject(val1) ? isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2) : isBigIntObject(val1) ? isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2) : isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
  }
  function innerDeepEqual(val1, val2, strict$1, memos) {
    if (val1 === val2) return val1 === 0 && strict$1 ? objectIs$1(val1, val2) : true;
    if (strict$1) {
      if (_typeof$1(val1) !== `object`) return typeof val1 == `number` && numberIsNaN(val1) && numberIsNaN(val2);
      if (_typeof$1(val2) !== `object` || val1 === null || val2 === null || Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
      if (val1 === null || _typeof$1(val1) !== `object`) return val2 === null || _typeof$1(val2) !== `object` ? val1 == val2 : false;
      if (val2 === null || _typeof$1(val2) !== `object`) return false;
    }
    var val1Tag = objectToString(val1), val2Tag = objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
      if (val1.length !== val2.length) return false;
      var keys1 = getOwnNonIndexProperties(val1), keys2 = getOwnNonIndexProperties(val2);
      return keys1.length === keys2.length ? keyCheck(val1, val2, strict$1, memos, kIsArray, keys1) : false;
    }
    if (val1Tag === `[object Object]` && (!isMap$2(val1) && isMap$2(val2) || !isSet$2(val1) && isSet$2(val2))) return false;
    if (isDate$2(val1)) {
      if (!isDate$2(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if (isRegExp$1(val1)) {
      if (!isRegExp$1(val2) || !areSimilarRegExps(val1, val2)) return false;
    } else if (isNativeError(val1) || val1 instanceof Error) {
      if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if (isArrayBufferView(val1)) {
      if (!strict$1 && (isFloat32Array(val1) || isFloat64Array(val1))) {
        if (!areSimilarFloatArrays(val1, val2)) return false;
      } else if (!areSimilarTypedArrays(val1, val2)) return false;
      var _keys = getOwnNonIndexProperties(val1), _keys2 = getOwnNonIndexProperties(val2);
      return _keys.length === _keys2.length ? keyCheck(val1, val2, strict$1, memos, kNoIterator, _keys) : false;
    } else if (isSet$2(val1)) return !isSet$2(val2) || val1.size !== val2.size ? false : keyCheck(val1, val2, strict$1, memos, kIsSet);
    else if (isMap$2(val1)) return !isMap$2(val2) || val1.size !== val2.size ? false : keyCheck(val1, val2, strict$1, memos, kIsMap);
    else if (isAnyArrayBuffer(val1)) {
      if (!areEqualArrayBuffers(val1, val2)) return false;
    } else if (isBoxedPrimitive(val1) && !isEqualBoxedPrimitive(val1, val2)) return false;
    return keyCheck(val1, val2, strict$1, memos, kNoIterator);
  }
  function getEnumerables(val, keys$10) {
    return keys$10.filter(function(k) {
      return propertyIsEnumerable(val, k);
    });
  }
  function keyCheck(val1, val2, strict$1, memos, iterationType, aKeys) {
    if (arguments.length === 5) {
      aKeys = Object.keys(val1);
      var bKeys = Object.keys(val2);
      if (aKeys.length !== bKeys.length) return false;
    }
    for (var i$4 = 0; i$4 < aKeys.length; i$4++) if (!hasOwnProperty$8(val2, aKeys[i$4])) return false;
    if (strict$1 && arguments.length === 5) {
      var symbolKeysA = objectGetOwnPropertySymbols(val1);
      if (symbolKeysA.length !== 0) {
        var count = 0;
        for (i$4 = 0; i$4 < symbolKeysA.length; i$4++) {
          var key = symbolKeysA[i$4];
          if (propertyIsEnumerable(val1, key)) {
            if (!propertyIsEnumerable(val2, key)) return false;
            aKeys.push(key), count++;
          } else if (propertyIsEnumerable(val2, key)) return false;
        }
        var symbolKeysB = objectGetOwnPropertySymbols(val2);
        if (symbolKeysA.length !== symbolKeysB.length && getEnumerables(val2, symbolKeysB).length !== count) return false;
      } else {
        var _symbolKeysB = objectGetOwnPropertySymbols(val2);
        if (_symbolKeysB.length !== 0 && getEnumerables(val2, _symbolKeysB).length !== 0) return false;
      }
    }
    if (aKeys.length === 0 && (iterationType === kNoIterator || iterationType === kIsArray && val1.length === 0 || val1.size === 0)) return true;
    if (memos === void 0) memos = { val1: /* @__PURE__ */ new Map(), val2: /* @__PURE__ */ new Map(), position: 0 };
    else {
      var val2MemoA = memos.val1.get(val1);
      if (val2MemoA !== void 0) {
        var val2MemoB = memos.val2.get(val2);
        if (val2MemoB !== void 0) return val2MemoA === val2MemoB;
      }
      memos.position++;
    }
    memos.val1.set(val1, memos.position), memos.val2.set(val2, memos.position);
    var areEq = objEquiv(val1, val2, strict$1, aKeys, memos, iterationType);
    return memos.val1.delete(val1), memos.val2.delete(val2), areEq;
  }
  function setHasEqualElement(set, val1, strict$1, memo) {
    for (var setValues = arrayFromSet(set), i$4 = 0; i$4 < setValues.length; i$4++) {
      var val2 = setValues[i$4];
      if (innerDeepEqual(val1, val2, strict$1, memo)) return set.delete(val2), true;
    }
    return false;
  }
  function findLooseMatchingPrimitives(prim) {
    switch (_typeof$1(prim)) {
      case `undefined`:
        return null;
      case `object`:
        return;
      case `symbol`:
        return false;
      case `string`:
        prim = +prim;
      case `number`:
        if (numberIsNaN(prim)) return false;
    }
    return true;
  }
  function setMightHaveLoosePrim(a$22, b2, prim) {
    var altValue = findLooseMatchingPrimitives(prim);
    return altValue ?? (b2.has(altValue) && !a$22.has(altValue));
  }
  function mapMightHaveLoosePrim(a$22, b2, prim, item, memo) {
    var altValue = findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b2.get(altValue);
    return curB === void 0 && !b2.has(altValue) || !innerDeepEqual(item, curB, false, memo) ? false : !a$22.has(altValue) && innerDeepEqual(item, curB, false, memo);
  }
  function setEquiv(a$22, b2, strict$1, memo) {
    for (var set = null, aValues = arrayFromSet(a$22), i$4 = 0; i$4 < aValues.length; i$4++) {
      var val = aValues[i$4];
      if (_typeof$1(val) === `object` && val !== null) set === null && (set = /* @__PURE__ */ new Set()), set.add(val);
      else if (!b2.has(val)) {
        if (strict$1 || !setMightHaveLoosePrim(a$22, b2, val)) return false;
        set === null && (set = /* @__PURE__ */ new Set()), set.add(val);
      }
    }
    if (set !== null) {
      for (var bValues = arrayFromSet(b2), _i = 0; _i < bValues.length; _i++) {
        var _val = bValues[_i];
        if (_typeof$1(_val) === `object` && _val !== null) {
          if (!setHasEqualElement(set, _val, strict$1, memo)) return false;
        } else if (!strict$1 && !a$22.has(_val) && !setHasEqualElement(set, _val, strict$1, memo)) return false;
      }
      return set.size === 0;
    }
    return true;
  }
  function mapHasEqualEntry(set, map$8, key1, item1, strict$1, memo) {
    for (var setValues = arrayFromSet(set), i$4 = 0; i$4 < setValues.length; i$4++) {
      var key2 = setValues[i$4];
      if (innerDeepEqual(key1, key2, strict$1, memo) && innerDeepEqual(item1, map$8.get(key2), strict$1, memo)) return set.delete(key2), true;
    }
    return false;
  }
  function mapEquiv(a$22, b2, strict$1, memo) {
    for (var set = null, aEntries = arrayFromMap(a$22), i$4 = 0; i$4 < aEntries.length; i$4++) {
      var _aEntries$i = _slicedToArray(aEntries[i$4], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
      if (_typeof$1(key) === `object` && key !== null) set === null && (set = /* @__PURE__ */ new Set()), set.add(key);
      else {
        var item2 = b2.get(key);
        if (item2 === void 0 && !b2.has(key) || !innerDeepEqual(item1, item2, strict$1, memo)) {
          if (strict$1 || !mapMightHaveLoosePrim(a$22, b2, key, item1, memo)) return false;
          set === null && (set = /* @__PURE__ */ new Set()), set.add(key);
        }
      }
    }
    if (set !== null) {
      for (var bEntries = arrayFromMap(b2), _i2 = 0; _i2 < bEntries.length; _i2++) {
        var _bEntries$_i = _slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
        if (_typeof$1(_key) === `object` && _key !== null) {
          if (!mapHasEqualEntry(set, a$22, _key, item, strict$1, memo)) return false;
        } else if (!strict$1 && (!a$22.has(_key) || !innerDeepEqual(a$22.get(_key), item, false, memo)) && !mapHasEqualEntry(set, a$22, _key, item, false, memo)) return false;
      }
      return set.size === 0;
    }
    return true;
  }
  function objEquiv(a$22, b2, strict$1, keys$10, memos, iterationType) {
    var i$4 = 0;
    if (iterationType === kIsSet) {
      if (!setEquiv(a$22, b2, strict$1, memos)) return false;
    } else if (iterationType === kIsMap) {
      if (!mapEquiv(a$22, b2, strict$1, memos)) return false;
    } else if (iterationType === kIsArray) for (; i$4 < a$22.length; i$4++) if (hasOwnProperty$8(a$22, i$4)) {
      if (!hasOwnProperty$8(b2, i$4) || !innerDeepEqual(a$22[i$4], b2[i$4], strict$1, memos)) return false;
    } else if (hasOwnProperty$8(b2, i$4)) return false;
    else {
      for (var keysA = Object.keys(a$22); i$4 < keysA.length; i$4++) {
        var key = keysA[i$4];
        if (!hasOwnProperty$8(b2, key) || !innerDeepEqual(a$22[key], b2[key], strict$1, memos)) return false;
      }
      return keysA.length === Object.keys(b2).length;
    }
    for (i$4 = 0; i$4 < keys$10.length; i$4++) {
      var _key2 = keys$10[i$4];
      if (!innerDeepEqual(a$22[_key2], b2[_key2], strict$1, memos)) return false;
    }
    return true;
  }
  function isDeepEqual$1(val1, val2) {
    return innerDeepEqual(val1, val2, kLoose);
  }
  function isDeepStrictEqual$1(val1, val2) {
    return innerDeepEqual(val1, val2, kStrict);
  }
  module2.exports = { isDeepEqual: isDeepEqual$1, isDeepStrictEqual: isDeepStrictEqual$1 };
}), require_assert = __commonJSMin$1((exports$12, module2) => {
  init_dist();
  function _typeof(o$2) {
    "@babel/helpers - typeof";
    return _typeof = typeof Symbol == `function` && typeof Symbol.iterator == `symbol` ? function(o$3) {
      return typeof o$3;
    } : function(o$3) {
      return o$3 && typeof Symbol == `function` && o$3.constructor === Symbol && o$3 !== Symbol.prototype ? `symbol` : typeof o$3;
    }, _typeof(o$2);
  }
  function _createClass$1(Constructor, protoProps, staticProps) {
    return Object.defineProperty(Constructor, `prototype`, { writable: false }), Constructor;
  }
  function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw TypeError(`Cannot call a class as a function`);
  }
  var _require$3 = require_errors$1(), _require$codes$4 = _require$3.codes, ERR_AMBIGUOUS_ARGUMENT = _require$codes$4.ERR_AMBIGUOUS_ARGUMENT, ERR_INVALID_ARG_TYPE$3 = _require$codes$4.ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE = _require$codes$4.ERR_INVALID_ARG_VALUE, ERR_INVALID_RETURN_VALUE = _require$codes$4.ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS$1 = _require$codes$4.ERR_MISSING_ARGS, AssertionError = require_assertion_error(), _require2$1 = require_util(), inspect$1 = _require2$1.inspect, _require$types = require_util().types, isPromise = _require$types.isPromise, isRegExp = _require$types.isRegExp, objectAssign = require_polyfill$2()(), objectIs = require_polyfill$1()(), RegExpPrototypeTest = require_callBound()(`RegExp.prototype.test`), isDeepEqual, isDeepStrictEqual;
  function lazyLoadComparison() {
    var comparison = require_comparisons();
    isDeepEqual = comparison.isDeepEqual, isDeepStrictEqual = comparison.isDeepStrictEqual;
  }
  var warned = false, assert$23 = module2.exports = ok, NO_EXCEPTION_SENTINEL = {};
  function innerFail(obj) {
    throw obj.message instanceof Error ? obj.message : new AssertionError(obj);
  }
  function fail(actual, expected, message, operator$1, stackStartFn) {
    var argsLen = arguments.length, internalMessage;
    if (argsLen === 0) internalMessage = `Failed`;
    else if (argsLen === 1) message = actual, actual = void 0;
    else {
      if (warned === false) {
        warned = true;
        var warn = process$1.emitWarning ? process$1.emitWarning : console.warn.bind(console);
        warn(`assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.`, `DeprecationWarning`, `DEP0094`);
      }
      argsLen === 2 && (operator$1 = `!=`);
    }
    if (message instanceof Error) throw message;
    var errArgs = { actual, expected, operator: operator$1 === void 0 ? `fail` : operator$1, stackStartFn: stackStartFn || fail };
    message !== void 0 && (errArgs.message = message);
    var err$1 = new AssertionError(errArgs);
    throw internalMessage && (err$1.message = internalMessage, err$1.generatedMessage = true), err$1;
  }
  assert$23.fail = fail, assert$23.AssertionError = AssertionError;
  function innerOk(fn$1, argLen, value, message) {
    if (!value) {
      var generatedMessage = false;
      if (argLen === 0) generatedMessage = true, message = "No value argument passed to `assert.ok()`";
      else if (message instanceof Error) throw message;
      var err$1 = new AssertionError({ actual: value, expected: true, message, operator: `==`, stackStartFn: fn$1 });
      throw err$1.generatedMessage = generatedMessage, err$1;
    }
  }
  function ok() {
    for (var _len = arguments.length, args$1 = Array(_len), _key = 0; _key < _len; _key++) args$1[_key] = arguments[_key];
    innerOk.apply(void 0, [ok, args$1.length].concat(args$1));
  }
  assert$23.ok = ok, assert$23.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS$1(`actual`, `expected`);
    actual != expected && innerFail({ actual, expected, message, operator: `==`, stackStartFn: equal });
  }, assert$23.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS$1(`actual`, `expected`);
    actual == expected && innerFail({ actual, expected, message, operator: `!=`, stackStartFn: notEqual });
  }, assert$23.deepEqual = function deepEqual$5(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS$1(`actual`, `expected`);
    isDeepEqual === void 0 && lazyLoadComparison(), isDeepEqual(actual, expected) || innerFail({ actual, expected, message, operator: `deepEqual`, stackStartFn: deepEqual$5 });
  }, assert$23.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS$1(`actual`, `expected`);
    isDeepEqual === void 0 && lazyLoadComparison(), isDeepEqual(actual, expected) && innerFail({ actual, expected, message, operator: `notDeepEqual`, stackStartFn: notDeepEqual });
  }, assert$23.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS$1(`actual`, `expected`);
    isDeepEqual === void 0 && lazyLoadComparison(), isDeepStrictEqual(actual, expected) || innerFail({ actual, expected, message, operator: `deepStrictEqual`, stackStartFn: deepStrictEqual });
  }, assert$23.notDeepStrictEqual = notDeepStrictEqual;
  function notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS$1(`actual`, `expected`);
    isDeepEqual === void 0 && lazyLoadComparison(), isDeepStrictEqual(actual, expected) && innerFail({ actual, expected, message, operator: `notDeepStrictEqual`, stackStartFn: notDeepStrictEqual });
  }
  assert$23.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS$1(`actual`, `expected`);
    objectIs(actual, expected) || innerFail({ actual, expected, message, operator: `strictEqual`, stackStartFn: strictEqual });
  }, assert$23.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS$1(`actual`, `expected`);
    objectIs(actual, expected) && innerFail({ actual, expected, message, operator: `notStrictEqual`, stackStartFn: notStrictEqual });
  };
  var Comparison = _createClass$1(function Comparison$1(obj, keys$10, actual) {
    var _this = this;
    _classCallCheck$1(this, Comparison$1), keys$10.forEach(function(key) {
      key in obj && (actual !== void 0 && typeof actual[key] == `string` && isRegExp(obj[key]) && RegExpPrototypeTest(obj[key], actual[key]) ? _this[key] = actual[key] : _this[key] = obj[key]);
    });
  });
  function compareExceptionKey(actual, expected, key, message, keys$10, fn$1) {
    if (!(key in actual) || !isDeepStrictEqual(actual[key], expected[key])) {
      if (!message) {
        var a$22 = new Comparison(actual, keys$10), b2 = new Comparison(expected, keys$10, actual), err$1 = new AssertionError({ actual: a$22, expected: b2, operator: `deepStrictEqual`, stackStartFn: fn$1 });
        throw err$1.actual = actual, err$1.expected = expected, err$1.operator = fn$1.name, err$1;
      }
      innerFail({ actual, expected, message, operator: fn$1.name, stackStartFn: fn$1 });
    }
  }
  function expectedException(actual, expected, msg, fn$1) {
    if (typeof expected != `function`) {
      if (isRegExp(expected)) return RegExpPrototypeTest(expected, actual);
      if (arguments.length === 2) throw new ERR_INVALID_ARG_TYPE$3(`expected`, [`Function`, `RegExp`], expected);
      if (_typeof(actual) !== `object` || actual === null) {
        var err$1 = new AssertionError({ actual, expected, message: msg, operator: `deepStrictEqual`, stackStartFn: fn$1 });
        throw err$1.operator = fn$1.name, err$1;
      }
      var keys$10 = Object.keys(expected);
      if (expected instanceof Error) keys$10.push(`name`, `message`);
      else if (keys$10.length === 0) throw new ERR_INVALID_ARG_VALUE(`error`, expected, `may not be an empty object`);
      return isDeepEqual === void 0 && lazyLoadComparison(), keys$10.forEach(function(key) {
        typeof actual[key] == `string` && isRegExp(expected[key]) && RegExpPrototypeTest(expected[key], actual[key]) || compareExceptionKey(actual, expected, key, msg, keys$10, fn$1);
      }), true;
    }
    return expected.prototype !== void 0 && actual instanceof expected ? true : Error.isPrototypeOf(expected) ? false : expected.call({}, actual) === true;
  }
  function getActual(fn$1) {
    if (typeof fn$1 != `function`) throw new ERR_INVALID_ARG_TYPE$3(`fn`, `Function`, fn$1);
    try {
      fn$1();
    } catch (e$22) {
      return e$22;
    }
    return NO_EXCEPTION_SENTINEL;
  }
  function checkIsPromise(obj) {
    return isPromise(obj) || obj !== null && _typeof(obj) === `object` && typeof obj.then == `function` && typeof obj.catch == `function`;
  }
  function waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
      var resultPromise;
      if (typeof promiseFn == `function`) {
        if (resultPromise = promiseFn(), !checkIsPromise(resultPromise)) throw new ERR_INVALID_RETURN_VALUE(`instance of Promise`, `promiseFn`, resultPromise);
      } else if (checkIsPromise(promiseFn)) resultPromise = promiseFn;
      else throw new ERR_INVALID_ARG_TYPE$3(`promiseFn`, [`Function`, `Promise`], promiseFn);
      return Promise.resolve().then(function() {
        return resultPromise;
      }).then(function() {
        return NO_EXCEPTION_SENTINEL;
      }).catch(function(e$22) {
        return e$22;
      });
    });
  }
  function expectsError(stackStartFn, actual, error, message) {
    if (typeof error == `string`) {
      if (arguments.length === 4) throw new ERR_INVALID_ARG_TYPE$3(`error`, [`Object`, `Error`, `Function`, `RegExp`], error);
      if (_typeof(actual) === `object` && actual !== null) {
        if (actual.message === error) throw new ERR_AMBIGUOUS_ARGUMENT(`error/message`, `The error message "${actual.message}" is identical to the message.`);
      } else if (actual === error) throw new ERR_AMBIGUOUS_ARGUMENT(`error/message`, `The error "${actual}" is identical to the message.`);
      message = error, error = void 0;
    } else if (error != null && _typeof(error) !== `object` && typeof error != `function`) throw new ERR_INVALID_ARG_TYPE$3(`error`, [`Object`, `Error`, `Function`, `RegExp`], error);
    if (actual === NO_EXCEPTION_SENTINEL) {
      var details = ``;
      error && error.name && (details += ` (${error.name})`), details += message ? `: ${message}` : `.`;
      var fnType = stackStartFn.name === `rejects` ? `rejection` : `exception`;
      innerFail({ actual: void 0, expected: error, operator: stackStartFn.name, message: `Missing expected ${fnType}${details}`, stackStartFn });
    }
    if (error && !expectedException(actual, error, message, stackStartFn)) throw actual;
  }
  function expectsNoError(stackStartFn, actual, error, message) {
    if (actual !== NO_EXCEPTION_SENTINEL) {
      if (typeof error == `string` && (message = error, error = void 0), !error || expectedException(actual, error)) {
        var details = message ? `: ${message}` : `.`, fnType = stackStartFn.name === `doesNotReject` ? `rejection` : `exception`;
        innerFail({ actual, expected: error, operator: stackStartFn.name, message: `Got unwanted ${fnType}${details}
Actual message: "${actual && actual.message}"`, stackStartFn });
      }
      throw actual;
    }
  }
  assert$23.throws = function throws(promiseFn) {
    for (var _len2 = arguments.length, args$1 = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) args$1[_key2 - 1] = arguments[_key2];
    expectsError.apply(void 0, [throws, getActual(promiseFn)].concat(args$1));
  }, assert$23.rejects = function rejects(promiseFn) {
    for (var _len3 = arguments.length, args$1 = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) args$1[_key3 - 1] = arguments[_key3];
    return waitForActual(promiseFn).then(function(result) {
      return expectsError.apply(void 0, [rejects, result].concat(args$1));
    });
  }, assert$23.doesNotThrow = function doesNotThrow(fn$1) {
    for (var _len4 = arguments.length, args$1 = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) args$1[_key4 - 1] = arguments[_key4];
    expectsNoError.apply(void 0, [doesNotThrow, getActual(fn$1)].concat(args$1));
  }, assert$23.doesNotReject = function doesNotReject(fn$1) {
    for (var _len5 = arguments.length, args$1 = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) args$1[_key5 - 1] = arguments[_key5];
    return waitForActual(fn$1).then(function(result) {
      return expectsNoError.apply(void 0, [doesNotReject, result].concat(args$1));
    });
  }, assert$23.ifError = function ifError(err$1) {
    if (err$1 != null) {
      var message = `ifError got unwanted exception: `;
      _typeof(err$1) === `object` && typeof err$1.message == `string` ? err$1.message.length === 0 && err$1.constructor ? message += err$1.constructor.name : message += err$1.message : message += inspect$1(err$1);
      var newErr = new AssertionError({ actual: err$1, expected: null, operator: `ifError`, message, stackStartFn: ifError }), origStack = err$1.stack;
      if (typeof origStack == `string`) {
        var tmp2 = origStack.split(`
`);
        tmp2.shift();
        for (var tmp1 = newErr.stack.split(`
`), i$4 = 0; i$4 < tmp2.length; i$4++) {
          var pos = tmp1.indexOf(tmp2[i$4]);
          if (pos !== -1) {
            tmp1 = tmp1.slice(0, pos);
            break;
          }
        }
        newErr.stack = `${tmp1.join(`
`)}
${tmp2.join(`
`)}`;
      }
      throw newErr;
    }
  };
  function internalMatch(string, regexp, message, fn$1, fnName) {
    if (!isRegExp(regexp)) throw new ERR_INVALID_ARG_TYPE$3(`regexp`, `RegExp`, regexp);
    var match$2 = fnName === `match`;
    if (typeof string != `string` || RegExpPrototypeTest(regexp, string) !== match$2) {
      if (message instanceof Error) throw message;
      var generatedMessage = !message;
      message ||= typeof string == `string` ? (match$2 ? `The input did not match the regular expression ` : `The input was expected to not match the regular expression `) + `${inspect$1(regexp)}. Input:

${inspect$1(string)}
` : `The "string" argument must be of type string. Received type ${_typeof(string)} (${inspect$1(string)})`;
      var err$1 = new AssertionError({ actual: string, expected: regexp, message, operator: fnName, stackStartFn: fn$1 });
      throw err$1.generatedMessage = generatedMessage, err$1;
    }
  }
  assert$23.match = function match$2(string, regexp, message) {
    internalMatch(string, regexp, message, match$2, `match`);
  }, assert$23.doesNotMatch = function doesNotMatch(string, regexp, message) {
    internalMatch(string, regexp, message, doesNotMatch, `doesNotMatch`);
  };
  function strict() {
    for (var _len6 = arguments.length, args$1 = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) args$1[_key6] = arguments[_key6];
    innerOk.apply(void 0, [strict, args$1.length].concat(args$1));
  }
  assert$23.strict = objectAssign(strict, assert$23, { equal: assert$23.strictEqual, deepEqual: assert$23.deepStrictEqual, notEqual: assert$23.notStrictEqual, notDeepEqual: assert$23.notDeepStrictEqual }), assert$23.strict.strict = assert$23.strict;
}), require__baseAssign = __commonJSMin$1((exports$12, module2) => {
  var copyObject$4 = require__copyObject(), keys$3 = require_keys();
  function baseAssign$1(object, source) {
    return object && copyObject$4(source, keys$3(source), object);
  }
  module2.exports = baseAssign$1;
}), require__nativeKeysIn = __commonJSMin$1((exports$12, module2) => {
  function nativeKeysIn$1(object) {
    var result = [];
    if (object != null) for (var key in Object(object)) result.push(key);
    return result;
  }
  module2.exports = nativeKeysIn$1;
}), require__baseKeysIn = __commonJSMin$1((exports$12, module2) => {
  var isObject$17 = require_isObject(), isPrototype$2 = require__isPrototype(), nativeKeysIn = require__nativeKeysIn(), objectProto$5 = Object.prototype, hasOwnProperty$7 = objectProto$5.hasOwnProperty;
  function baseKeysIn$1(object) {
    if (!isObject$17(object)) return nativeKeysIn(object);
    var isProto = isPrototype$2(object), result = [];
    for (var key in object) key == `constructor` && (isProto || !hasOwnProperty$7.call(object, key)) || result.push(key);
    return result;
  }
  module2.exports = baseKeysIn$1;
}), require_keysIn = __commonJSMin$1((exports$12, module2) => {
  var arrayLikeKeys = require__arrayLikeKeys(), baseKeysIn = require__baseKeysIn(), isArrayLike$3 = require_isArrayLike();
  function keysIn$5(object) {
    return isArrayLike$3(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
  }
  module2.exports = keysIn$5;
}), require__baseAssignIn = __commonJSMin$1((exports$12, module2) => {
  var copyObject$3 = require__copyObject(), keysIn$4 = require_keysIn();
  function baseAssignIn$1(object, source) {
    return object && copyObject$3(source, keysIn$4(source), object);
  }
  module2.exports = baseAssignIn$1;
}), require__cloneBuffer = __commonJSMin$1((exports$12, module2) => {
  var root = require__root(), freeExports = typeof exports$12 == `object` && exports$12 && !exports$12.nodeType && exports$12, freeModule = freeExports && typeof module2 == `object` && module2 && !module2.nodeType && module2, moduleExports = freeModule && freeModule.exports === freeExports, Buffer$25 = moduleExports ? root.Buffer : void 0, allocUnsafe = Buffer$25 ? Buffer$25.allocUnsafe : void 0;
  function cloneBuffer$1(buffer$3, isDeep) {
    if (isDeep) return buffer$3.slice();
    var length = buffer$3.length, result = allocUnsafe ? allocUnsafe(length) : new buffer$3.constructor(length);
    return buffer$3.copy(result), result;
  }
  module2.exports = cloneBuffer$1;
}), require__copyArray = __commonJSMin$1((exports$12, module2) => {
  function copyArray$2(source, array) {
    var index$2 = -1, length = source.length;
    for (array ||= Array(length); ++index$2 < length; ) array[index$2] = source[index$2];
    return array;
  }
  module2.exports = copyArray$2;
}), require__copySymbols = __commonJSMin$1((exports$12, module2) => {
  var copyObject$2 = require__copyObject(), getSymbols$1 = require__getSymbols();
  function copySymbols$1(source, object) {
    return copyObject$2(source, getSymbols$1(source), object);
  }
  module2.exports = copySymbols$1;
}), require__getSymbolsIn = __commonJSMin$1((exports$12, module2) => {
  var arrayPush$1 = require__arrayPush(), getPrototype$1 = require__getPrototype(), getSymbols = require__getSymbols(), stubArray = require_stubArray(), nativeGetSymbols = Object.getOwnPropertySymbols, getSymbolsIn$2 = nativeGetSymbols ? function(object) {
    for (var result = []; object; ) arrayPush$1(result, getSymbols(object)), object = getPrototype$1(object);
    return result;
  } : stubArray;
  module2.exports = getSymbolsIn$2;
}), require__copySymbolsIn = __commonJSMin$1((exports$12, module2) => {
  var copyObject$1 = require__copyObject(), getSymbolsIn$1 = require__getSymbolsIn();
  function copySymbolsIn$1(source, object) {
    return copyObject$1(source, getSymbolsIn$1(source), object);
  }
  module2.exports = copySymbolsIn$1;
}), require__getAllKeysIn = __commonJSMin$1((exports$12, module2) => {
  var baseGetAllKeys = require__baseGetAllKeys(), getSymbolsIn = require__getSymbolsIn(), keysIn$3 = require_keysIn();
  function getAllKeysIn$2(object) {
    return baseGetAllKeys(object, keysIn$3, getSymbolsIn);
  }
  module2.exports = getAllKeysIn$2;
}), require__initCloneArray = __commonJSMin$1((exports$12, module2) => {
  var objectProto$4 = Object.prototype, hasOwnProperty$6 = objectProto$4.hasOwnProperty;
  function initCloneArray$1(array) {
    var length = array.length, result = new array.constructor(length);
    return length && typeof array[0] == `string` && hasOwnProperty$6.call(array, `index`) && (result.index = array.index, result.input = array.input), result;
  }
  module2.exports = initCloneArray$1;
}), require__cloneArrayBuffer = __commonJSMin$1((exports$12, module2) => {
  var Uint8Array$1 = require__Uint8Array();
  function cloneArrayBuffer$3(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    return new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer)), result;
  }
  module2.exports = cloneArrayBuffer$3;
}), require__cloneDataView = __commonJSMin$1((exports$12, module2) => {
  var cloneArrayBuffer$2 = require__cloneArrayBuffer();
  function cloneDataView$1(dataView, isDeep) {
    var buffer$3 = isDeep ? cloneArrayBuffer$2(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer$3, dataView.byteOffset, dataView.byteLength);
  }
  module2.exports = cloneDataView$1;
}), require__cloneRegExp = __commonJSMin$1((exports$12, module2) => {
  var reFlags = /\w*$/;
  function cloneRegExp$1(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    return result.lastIndex = regexp.lastIndex, result;
  }
  module2.exports = cloneRegExp$1;
}), require__cloneSymbol = __commonJSMin$1((exports$12, module2) => {
  var Symbol$3 = require__Symbol(), symbolProto = Symbol$3 ? Symbol$3.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
  function cloneSymbol$1(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
  }
  module2.exports = cloneSymbol$1;
}), require__cloneTypedArray = __commonJSMin$1((exports$12, module2) => {
  var cloneArrayBuffer$1 = require__cloneArrayBuffer();
  function cloneTypedArray$1(typedArray, isDeep) {
    var buffer$3 = isDeep ? cloneArrayBuffer$1(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer$3, typedArray.byteOffset, typedArray.length);
  }
  module2.exports = cloneTypedArray$1;
}), require__initCloneByTag = __commonJSMin$1((exports$12, module2) => {
  var cloneArrayBuffer = require__cloneArrayBuffer(), cloneDataView = require__cloneDataView(), cloneRegExp = require__cloneRegExp(), cloneSymbol = require__cloneSymbol(), cloneTypedArray = require__cloneTypedArray(), boolTag$1 = `[object Boolean]`, dateTag$1 = `[object Date]`, mapTag$4 = `[object Map]`, numberTag$1 = `[object Number]`, regexpTag$1 = `[object RegExp]`, setTag$4 = `[object Set]`, stringTag$2 = `[object String]`, symbolTag$1 = `[object Symbol]`, arrayBufferTag$1 = `[object ArrayBuffer]`, dataViewTag$1 = `[object DataView]`, float32Tag$1 = `[object Float32Array]`, float64Tag$1 = `[object Float64Array]`, int8Tag$1 = `[object Int8Array]`, int16Tag$1 = `[object Int16Array]`, int32Tag$1 = `[object Int32Array]`, uint8Tag$1 = `[object Uint8Array]`, uint8ClampedTag$1 = `[object Uint8ClampedArray]`, uint16Tag$1 = `[object Uint16Array]`, uint32Tag$1 = `[object Uint32Array]`;
  function initCloneByTag$1(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch (tag) {
      case arrayBufferTag$1:
        return cloneArrayBuffer(object);
      case boolTag$1:
      case dateTag$1:
        return new Ctor(+object);
      case dataViewTag$1:
        return cloneDataView(object, isDeep);
      case float32Tag$1:
      case float64Tag$1:
      case int8Tag$1:
      case int16Tag$1:
      case int32Tag$1:
      case uint8Tag$1:
      case uint8ClampedTag$1:
      case uint16Tag$1:
      case uint32Tag$1:
        return cloneTypedArray(object, isDeep);
      case mapTag$4:
        return new Ctor();
      case numberTag$1:
      case stringTag$2:
        return new Ctor(object);
      case regexpTag$1:
        return cloneRegExp(object);
      case setTag$4:
        return new Ctor();
      case symbolTag$1:
        return cloneSymbol(object);
    }
  }
  module2.exports = initCloneByTag$1;
}), require__initCloneObject = __commonJSMin$1((exports$12, module2) => {
  var baseCreate = require__baseCreate(), getPrototype = require__getPrototype(), isPrototype$1 = require__isPrototype();
  function initCloneObject$1(object) {
    return typeof object.constructor == `function` && !isPrototype$1(object) ? baseCreate(getPrototype(object)) : {};
  }
  module2.exports = initCloneObject$1;
}), require__baseIsMap = __commonJSMin$1((exports$12, module2) => {
  var getTag$4 = require__getTag(), isObjectLike$2 = require_isObjectLike(), mapTag$3 = `[object Map]`;
  function baseIsMap$1(value) {
    return isObjectLike$2(value) && getTag$4(value) == mapTag$3;
  }
  module2.exports = baseIsMap$1;
}), require_isMap = __commonJSMin$1((exports$12, module2) => {
  var baseIsMap = require__baseIsMap(), baseUnary$1 = require__baseUnary(), nodeUtil$1 = require__nodeUtil(), nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap, isMap$1 = nodeIsMap ? baseUnary$1(nodeIsMap) : baseIsMap;
  module2.exports = isMap$1;
}), require__baseIsSet = __commonJSMin$1((exports$12, module2) => {
  var getTag$3 = require__getTag(), isObjectLike$1 = require_isObjectLike(), setTag$3 = `[object Set]`;
  function baseIsSet$1(value) {
    return isObjectLike$1(value) && getTag$3(value) == setTag$3;
  }
  module2.exports = baseIsSet$1;
}), require_isSet = __commonJSMin$1((exports$12, module2) => {
  var baseIsSet = require__baseIsSet(), baseUnary = require__baseUnary(), nodeUtil = require__nodeUtil(), nodeIsSet = nodeUtil && nodeUtil.isSet, isSet$1 = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
  module2.exports = isSet$1;
}), require__baseClone = __commonJSMin$1((exports$12, module2) => {
  var Stack = require__Stack(), arrayEach$1 = require__arrayEach(), assignValue$1 = require__assignValue(), baseAssign = require__baseAssign(), baseAssignIn = require__baseAssignIn(), cloneBuffer = require__cloneBuffer(), copyArray$1 = require__copyArray(), copySymbols = require__copySymbols(), copySymbolsIn = require__copySymbolsIn(), getAllKeys = require__getAllKeys(), getAllKeysIn$1 = require__getAllKeysIn(), getTag$2 = require__getTag(), initCloneArray = require__initCloneArray(), initCloneByTag = require__initCloneByTag(), initCloneObject = require__initCloneObject(), isArray$10 = require_isArray(), isBuffer$1 = require_isBuffer(), isMap2 = require_isMap(), isObject$16 = require_isObject(), isSet2 = require_isSet(), keys$2 = require_keys(), keysIn$2 = require_keysIn(), CLONE_DEEP_FLAG$1 = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG$2 = 4, argsTag = `[object Arguments]`, arrayTag = `[object Array]`, boolTag = `[object Boolean]`, dateTag = `[object Date]`, errorTag = `[object Error]`, funcTag = `[object Function]`, genTag = `[object GeneratorFunction]`, mapTag$2 = `[object Map]`, numberTag = `[object Number]`, objectTag = `[object Object]`, regexpTag = `[object RegExp]`, setTag$2 = `[object Set]`, stringTag$1 = `[object String]`, symbolTag = `[object Symbol]`, weakMapTag = `[object WeakMap]`, arrayBufferTag = `[object ArrayBuffer]`, dataViewTag = `[object DataView]`, float32Tag = `[object Float32Array]`, float64Tag = `[object Float64Array]`, int8Tag = `[object Int8Array]`, int16Tag = `[object Int16Array]`, int32Tag = `[object Int32Array]`, uint8Tag = `[object Uint8Array]`, uint8ClampedTag = `[object Uint8ClampedArray]`, uint16Tag = `[object Uint16Array]`, uint32Tag = `[object Uint32Array]`, cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag$2] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag$2] = cloneableTags[stringTag$1] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true, cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
  function baseClone$2(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & CLONE_DEEP_FLAG$1, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG$2;
    if (customizer && (result = object ? customizer(value, key, object, stack) : customizer(value)), result !== void 0) return result;
    if (!isObject$16(value)) return value;
    var isArr = isArray$10(value);
    if (isArr) {
      if (result = initCloneArray(value), !isDeep) return copyArray$1(value, result);
    } else {
      var tag = getTag$2(value), isFunc = tag == funcTag || tag == genTag;
      if (isBuffer$1(value)) return cloneBuffer(value, isDeep);
      if (tag == objectTag || tag == argsTag || isFunc && !object) {
        if (result = isFlat || isFunc ? {} : initCloneObject(value), !isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      } else {
        if (!cloneableTags[tag]) return object ? value : {};
        result = initCloneByTag(value, tag, isDeep);
      }
    }
    stack ||= new Stack();
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result), isSet2(value) ? value.forEach(function(subValue) {
      result.add(baseClone$2(subValue, bitmask, customizer, subValue, value, stack));
    }) : isMap2(value) && value.forEach(function(subValue, key$1) {
      result.set(key$1, baseClone$2(subValue, bitmask, customizer, key$1, value, stack));
    });
    var keysFunc = isFull ? isFlat ? getAllKeysIn$1 : getAllKeys : isFlat ? keysIn$2 : keys$2, props = isArr ? void 0 : keysFunc(value);
    return arrayEach$1(props || value, function(subValue, key$1) {
      props && (key$1 = subValue, subValue = value[key$1]), assignValue$1(result, key$1, baseClone$2(subValue, bitmask, customizer, key$1, value, stack));
    }), result;
  }
  module2.exports = baseClone$2;
}), require_clone = __commonJSMin$1((exports$12, module2) => {
  var baseClone$1 = require__baseClone(), CLONE_SYMBOLS_FLAG$1 = 4;
  function clone$7(value) {
    return baseClone$1(value, CLONE_SYMBOLS_FLAG$1);
  }
  module2.exports = clone$7;
}), require__castFunction = __commonJSMin$1((exports$12, module2) => {
  var identity$8 = require_identity();
  function castFunction$1(value) {
    return typeof value == `function` ? value : identity$8;
  }
  module2.exports = castFunction$1;
}), require_forEach = __commonJSMin$1((exports$12, module2) => {
  var arrayEach = require__arrayEach(), baseEach$4 = require__baseEach(), castFunction = require__castFunction(), isArray$9 = require_isArray();
  function forEach(collection, iteratee) {
    var func = isArray$9(collection) ? arrayEach : baseEach$4;
    return func(collection, castFunction(iteratee));
  }
  module2.exports = forEach;
}), require_each = __commonJSMin$1((exports$12, module2) => {
  module2.exports = require_forEach();
}), require_isEmpty = __commonJSMin$1((exports$12, module2) => {
  var baseKeys = require__baseKeys(), getTag$1 = require__getTag(), isArguments$1 = require_isArguments$1(), isArray$8 = require_isArray(), isArrayLike$2 = require_isArrayLike(), isBuffer = require_isBuffer(), isPrototype = require__isPrototype(), isTypedArray$2 = require_isTypedArray(), mapTag$1 = `[object Map]`, setTag$1 = `[object Set]`, objectProto$3 = Object.prototype, hasOwnProperty$5 = objectProto$3.hasOwnProperty;
  function isEmpty$12(value) {
    if (value == null) return true;
    if (isArrayLike$2(value) && (isArray$8(value) || typeof value == `string` || typeof value.splice == `function` || isBuffer(value) || isTypedArray$2(value) || isArguments$1(value))) return !value.length;
    var tag = getTag$1(value);
    if (tag == mapTag$1 || tag == setTag$1) return !value.size;
    if (isPrototype(value)) return !baseKeys(value).length;
    for (var key in value) if (hasOwnProperty$5.call(value, key)) return false;
    return true;
  }
  module2.exports = isEmpty$12;
}), require_last = __commonJSMin$1((exports$12, module2) => {
  function last$1(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : void 0;
  }
  module2.exports = last$1;
}), require__baseFilter = __commonJSMin$1((exports$12, module2) => {
  var baseEach$3 = require__baseEach();
  function baseFilter$2(collection, predicate) {
    var result = [];
    return baseEach$3(collection, function(value, index$2, collection$1) {
      predicate(value, index$2, collection$1) && result.push(value);
    }), result;
  }
  module2.exports = baseFilter$2;
}), require_negate = __commonJSMin$1((exports$12, module2) => {
  var FUNC_ERROR_TEXT$1 = `Expected a function`;
  function negate$2(predicate) {
    if (typeof predicate != `function`) throw TypeError(FUNC_ERROR_TEXT$1);
    return function() {
      var args$1 = arguments;
      switch (args$1.length) {
        case 0:
          return !predicate.call(this);
        case 1:
          return !predicate.call(this, args$1[0]);
        case 2:
          return !predicate.call(this, args$1[0], args$1[1]);
        case 3:
          return !predicate.call(this, args$1[0], args$1[1], args$1[2]);
      }
      return !predicate.apply(this, args$1);
    };
  }
  module2.exports = negate$2;
}), require_reject = __commonJSMin$1((exports$12, module2) => {
  var arrayFilter$1 = require__arrayFilter(), baseFilter$1 = require__baseFilter(), baseIteratee$6 = require__baseIteratee(), isArray$7 = require_isArray(), negate$1 = require_negate();
  function reject$1(collection, predicate) {
    var func = isArray$7(collection) ? arrayFilter$1 : baseFilter$1;
    return func(collection, negate$1(baseIteratee$6(predicate, 3)));
  }
  module2.exports = reject$1;
}), require__baseSlice = __commonJSMin$1((exports$12, module2) => {
  function baseSlice$1(array, start, end) {
    var index$2 = -1, length = array.length;
    start < 0 && (start = -start > length ? 0 : length + start), end = end > length ? length : end, end < 0 && (end += length), length = start > end ? 0 : end - start >>> 0, start >>>= 0;
    for (var result = Array(length); ++index$2 < length; ) result[index$2] = array[index$2 + start];
    return result;
  }
  module2.exports = baseSlice$1;
}), require_tail = __commonJSMin$1((exports$12, module2) => {
  var baseSlice = require__baseSlice();
  function tail$4(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseSlice(array, 1, length) : [];
  }
  module2.exports = tail$4;
}), require_isString = __commonJSMin$1((exports$12, module2) => {
  var baseGetTag = require__baseGetTag(), isArray$6 = require_isArray(), isObjectLike = require_isObjectLike(), stringTag = `[object String]`;
  function isString$18(value) {
    return typeof value == `string` || !isArray$6(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
  }
  module2.exports = isString$18;
}), require__iteratorToArray = __commonJSMin$1((exports$12, module2) => {
  function iteratorToArray$1(iterator) {
    for (var data, result = []; !(data = iterator.next()).done; ) result.push(data.value);
    return result;
  }
  module2.exports = iteratorToArray$1;
}), require__asciiToArray = __commonJSMin$1((exports$12, module2) => {
  function asciiToArray$1(string) {
    return string.split(``);
  }
  module2.exports = asciiToArray$1;
}), require__hasUnicode = __commonJSMin$1((exports$12, module2) => {
  var rsAstralRange$1 = `\\ud800-\\udfff`, rsComboMarksRange$1 = `\\u0300-\\u036f`, reComboHalfMarksRange$1 = `\\ufe20-\\ufe2f`, rsComboSymbolsRange$1 = `\\u20d0-\\u20ff`, rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1, rsVarRange$1 = `\\ufe0e\\ufe0f`, rsZWJ$1 = `\\u200d`, reHasUnicode = RegExp(`[` + rsZWJ$1 + rsAstralRange$1 + rsComboRange$1 + rsVarRange$1 + `]`);
  function hasUnicode$1(string) {
    return reHasUnicode.test(string);
  }
  module2.exports = hasUnicode$1;
}), require__unicodeToArray = __commonJSMin$1((exports$12, module2) => {
  var rsAstralRange = `\\ud800-\\udfff`, rsComboMarksRange = `\\u0300-\\u036f`, reComboHalfMarksRange = `\\ufe20-\\ufe2f`, rsComboSymbolsRange = `\\u20d0-\\u20ff`, rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = `\\ufe0e\\ufe0f`, rsAstral = `[` + rsAstralRange + `]`, rsCombo = `[` + rsComboRange + `]`, rsFitz = `\\ud83c[\\udffb-\\udfff]`, rsModifier = `(?:` + rsCombo + `|` + rsFitz + `)`, rsNonAstral = `[^` + rsAstralRange + `]`, rsRegional = `(?:\\ud83c[\\udde6-\\uddff]){2}`, rsSurrPair = `[\\ud800-\\udbff][\\udc00-\\udfff]`, rsZWJ = `\\u200d`, reOptMod = rsModifier + `?`, rsOptVar = `[` + rsVarRange + `]?`, rsOptJoin = `(?:` + rsZWJ + `(?:` + [rsNonAstral, rsRegional, rsSurrPair].join(`|`) + `)` + rsOptVar + reOptMod + `)*`, rsSeq = rsOptVar + reOptMod + rsOptJoin, rsSymbol = `(?:` + [rsNonAstral + rsCombo + `?`, rsCombo, rsRegional, rsSurrPair, rsAstral].join(`|`) + `)`, reUnicode = RegExp(rsFitz + `(?=` + rsFitz + `)|` + rsSymbol + rsSeq, `g`);
  function unicodeToArray$1(string) {
    return string.match(reUnicode) || [];
  }
  module2.exports = unicodeToArray$1;
}), require__stringToArray = __commonJSMin$1((exports$12, module2) => {
  var asciiToArray = require__asciiToArray(), hasUnicode = require__hasUnicode(), unicodeToArray = require__unicodeToArray();
  function stringToArray$1(string) {
    return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
  }
  module2.exports = stringToArray$1;
}), require__baseValues = __commonJSMin$1((exports$12, module2) => {
  var arrayMap$2 = require__arrayMap();
  function baseValues$1(object, props) {
    return arrayMap$2(props, function(key) {
      return object[key];
    });
  }
  module2.exports = baseValues$1;
}), require_values = __commonJSMin$1((exports$12, module2) => {
  var baseValues = require__baseValues(), keys$1 = require_keys();
  function values$2(object) {
    return object == null ? [] : baseValues(object, keys$1(object));
  }
  module2.exports = values$2;
}), require_toArray = __commonJSMin$1((exports$12, module2) => {
  var Symbol$2 = require__Symbol(), copyArray = require__copyArray(), getTag = require__getTag(), isArrayLike$1 = require_isArrayLike(), isString$17 = require_isString(), iteratorToArray = require__iteratorToArray(), mapToArray = require__mapToArray(), setToArray$2 = require__setToArray(), stringToArray = require__stringToArray(), values$1 = require_values(), mapTag = `[object Map]`, setTag = `[object Set]`, symIterator = Symbol$2 ? Symbol$2.iterator : void 0;
  function toArray$7(value) {
    if (!value) return [];
    if (isArrayLike$1(value)) return isString$17(value) ? stringToArray(value) : copyArray(value);
    if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
    var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray$2 : values$1;
    return func(value);
  }
  module2.exports = toArray$7;
}), require_constants$3 = __commonJSMin$1((exports$12, module2) => {
  let CLIENT_ALIASES$1 = Object.freeze({ pg: `postgres`, postgresql: `postgres`, sqlite: `sqlite3` }), SUPPORTED_CLIENTS$1 = Object.freeze([`mssql`, `mysql`, `mysql2`, `oracledb`, `postgres`, `pgnative`, `redshift`, `sqlite3`, `cockroachdb`, `better-sqlite3`].concat(Object.keys(CLIENT_ALIASES$1))), DRIVER_NAMES = Object.freeze({ MsSQL: `mssql`, MySQL: `mysql`, MySQL2: `mysql2`, Oracle: `oracledb`, PostgreSQL: `pg`, PgNative: `pgnative`, Redshift: `pg-redshift`, SQLite: `sqlite3`, CockroachDB: `cockroachdb`, BetterSQLite3: `better-sqlite3` }), POOL_CONFIG_OPTIONS$2 = Object.freeze([`maxWaitingClients`, `testOnBorrow`, `fifo`, `priorityRange`, `autostart`, `evictionRunIntervalMillis`, `numTestsPerRun`, `softIdleTimeoutMillis`, `Promise`]), COMMA_NO_PAREN_REGEX = /,[\s](?![^(]*\))/g;
  module2.exports = { CLIENT_ALIASES: CLIENT_ALIASES$1, SUPPORTED_CLIENTS: SUPPORTED_CLIENTS$1, POOL_CONFIG_OPTIONS: POOL_CONFIG_OPTIONS$2, COMMA_NO_PAREN_REGEX, DRIVER_NAMES };
}), require_is = __commonJSMin$1((exports$12, module2) => {
  function isString$16(value) {
    return typeof value == `string`;
  }
  function isNumber$4(value) {
    return typeof value == `number`;
  }
  function isBoolean$1(value) {
    return typeof value == `boolean`;
  }
  function isUndefined$32(value) {
    return value === void 0;
  }
  function isObject$15(value) {
    return typeof value == `object` && !!value;
  }
  function isFunction$5(value) {
    return typeof value == `function`;
  }
  module2.exports = { isString: isString$16, isNumber: isNumber$4, isBoolean: isBoolean$1, isUndefined: isUndefined$32, isObject: isObject$15, isFunction: isFunction$5 };
}), require_helpers$1 = __commonJSMin$1((exports$12, module2) => {
  let isPlainObject$8 = require_isPlainObject(), isTypedArray$1 = require_isTypedArray(), { CLIENT_ALIASES } = require_constants$3(), { isFunction: isFunction$4 } = require_is();
  function normalizeArr$2(...args$1) {
    return Array.isArray(args$1[0]) ? args$1[0] : args$1;
  }
  function containsUndefined(mixed) {
    let argContainsUndefined = false;
    if (isTypedArray$1(mixed)) return false;
    if (mixed && isFunction$4(mixed.toSQL)) return argContainsUndefined;
    if (Array.isArray(mixed)) for (let i$4 = 0; i$4 < mixed.length && !argContainsUndefined; i$4++) argContainsUndefined = containsUndefined(mixed[i$4]);
    else isPlainObject$8(mixed) ? Object.keys(mixed).forEach((key) => {
      argContainsUndefined ||= containsUndefined(mixed[key]);
    }) : argContainsUndefined = mixed === void 0;
    return argContainsUndefined;
  }
  function getUndefinedIndices(mixed) {
    let indices = [];
    return Array.isArray(mixed) ? mixed.forEach((item, index$2) => {
      containsUndefined(item) && indices.push(index$2);
    }) : isPlainObject$8(mixed) ? Object.keys(mixed).forEach((key) => {
      containsUndefined(mixed[key]) && indices.push(key);
    }) : indices.push(0), indices;
  }
  function addQueryContext$3(Target) {
    Target.prototype.queryContext = function(context) {
      return context === void 0 ? this._queryContext : (this._queryContext = context, this);
    };
  }
  function resolveClientNameWithAliases$1(clientName) {
    return CLIENT_ALIASES[clientName] || clientName;
  }
  function toNumber$7(val, fallback) {
    if (val == null) return fallback;
    let number = parseInt(val, 10);
    return isNaN(number) ? fallback : number;
  }
  module2.exports = { addQueryContext: addQueryContext$3, containsUndefined, getUndefinedIndices, normalizeArr: normalizeArr$2, resolveClientNameWithAliases: resolveClientNameWithAliases$1, toNumber: toNumber$7 };
}), require_joinclause = __commonJSMin$1((exports$12, module2) => {
  let assert$22 = require_assert();
  function getClauseFromArguments(compilerType, bool, first$1, operator$1, second) {
    if (typeof first$1 == `function`) return { type: `onWrapped`, value: first$1, bool };
    switch (arguments.length) {
      case 3:
        return { type: `onRaw`, value: first$1, bool };
      case 4:
        return { type: compilerType, column: first$1, operator: `=`, value: operator$1, bool };
      default:
        return { type: compilerType, column: first$1, operator: operator$1, value: second, bool };
    }
  }
  var JoinClause$2 = class {
    constructor(table$2, type, schema$2) {
      this.schema = schema$2, this.table = table$2, this.joinType = type, this.and = this, this.clauses = [];
    }
    get or() {
      return this._bool(`or`);
    }
    on(first$1) {
      if (typeof first$1 == `object` && typeof first$1.toSQL != `function`) {
        let keys$10 = Object.keys(first$1), i$4 = -1, method$1 = this._bool() === `or` ? `orOn` : `on`;
        for (; ++i$4 < keys$10.length; ) this[method$1](keys$10[i$4], first$1[keys$10[i$4]]);
        return this;
      }
      let data = getClauseFromArguments(`onBasic`, this._bool(), ...arguments);
      return data && this.clauses.push(data), this;
    }
    orOn(first$1, operator$1, second) {
      return this._bool(`or`).on.apply(this, arguments);
    }
    onJsonPathEquals(columnFirst, jsonPathFirst, columnSecond, jsonPathSecond) {
      return this.clauses.push({ type: `onJsonPathEquals`, columnFirst, jsonPathFirst, columnSecond, jsonPathSecond, bool: this._bool(), not: this._not() }), this;
    }
    orOnJsonPathEquals(columnFirst, jsonPathFirst, columnSecond, jsonPathSecond) {
      return this._bool(`or`).onJsonPathEquals.apply(this, arguments);
    }
    using(column) {
      return this.clauses.push({ type: `onUsing`, column, bool: this._bool() });
    }
    onVal(first$1) {
      if (typeof first$1 == `object` && typeof first$1.toSQL != `function`) {
        let keys$10 = Object.keys(first$1), i$4 = -1, method$1 = this._bool() === `or` ? `orOnVal` : `onVal`;
        for (; ++i$4 < keys$10.length; ) this[method$1](keys$10[i$4], first$1[keys$10[i$4]]);
        return this;
      }
      let data = getClauseFromArguments(`onVal`, this._bool(), ...arguments);
      return data && this.clauses.push(data), this;
    }
    andOnVal() {
      return this.onVal(...arguments);
    }
    orOnVal() {
      return this._bool(`or`).onVal(...arguments);
    }
    onBetween(column, values$3) {
      return assert$22(Array.isArray(values$3), `The second argument to onBetween must be an array.`), assert$22(values$3.length === 2, `You must specify 2 values for the onBetween clause`), this.clauses.push({ type: `onBetween`, column, value: values$3, bool: this._bool(), not: this._not() }), this;
    }
    onNotBetween(column, values$3) {
      return this._not(true).onBetween(column, values$3);
    }
    orOnBetween(column, values$3) {
      return this._bool(`or`).onBetween(column, values$3);
    }
    orOnNotBetween(column, values$3) {
      return this._bool(`or`)._not(true).onBetween(column, values$3);
    }
    onIn(column, values$3) {
      return Array.isArray(values$3) && values$3.length === 0 ? this.on(1, `=`, 0) : (this.clauses.push({ type: `onIn`, column, value: values$3, not: this._not(), bool: this._bool() }), this);
    }
    onNotIn(column, values$3) {
      return this._not(true).onIn(column, values$3);
    }
    orOnIn(column, values$3) {
      return this._bool(`or`).onIn(column, values$3);
    }
    orOnNotIn(column, values$3) {
      return this._bool(`or`)._not(true).onIn(column, values$3);
    }
    onNull(column) {
      return this.clauses.push({ type: `onNull`, column, not: this._not(), bool: this._bool() }), this;
    }
    orOnNull(callback) {
      return this._bool(`or`).onNull(callback);
    }
    onNotNull(callback) {
      return this._not(true).onNull(callback);
    }
    orOnNotNull(callback) {
      return this._not(true)._bool(`or`).onNull(callback);
    }
    onExists(callback) {
      return this.clauses.push({ type: `onExists`, value: callback, not: this._not(), bool: this._bool() }), this;
    }
    orOnExists(callback) {
      return this._bool(`or`).onExists(callback);
    }
    onNotExists(callback) {
      return this._not(true).onExists(callback);
    }
    orOnNotExists(callback) {
      return this._not(true)._bool(`or`).onExists(callback);
    }
    type(type) {
      return this.joinType = type, this;
    }
    _bool(bool) {
      if (arguments.length === 1) return this._boolFlag = bool, this;
      let ret = this._boolFlag || `and`;
      return this._boolFlag = `and`, ret;
    }
    _not(val) {
      if (arguments.length === 1) return this._notFlag = val, this;
      let ret = this._notFlag;
      return this._notFlag = false, ret;
    }
  };
  Object.assign(JoinClause$2.prototype, { grouping: `join` }), JoinClause$2.prototype.andOn = JoinClause$2.prototype.on, JoinClause$2.prototype.andOnIn = JoinClause$2.prototype.onIn, JoinClause$2.prototype.andOnNotIn = JoinClause$2.prototype.onNotIn, JoinClause$2.prototype.andOnNull = JoinClause$2.prototype.onNull, JoinClause$2.prototype.andOnNotNull = JoinClause$2.prototype.onNotNull, JoinClause$2.prototype.andOnExists = JoinClause$2.prototype.onExists, JoinClause$2.prototype.andOnNotExists = JoinClause$2.prototype.onNotExists, JoinClause$2.prototype.andOnBetween = JoinClause$2.prototype.onBetween, JoinClause$2.prototype.andOnNotBetween = JoinClause$2.prototype.onNotBetween, JoinClause$2.prototype.andOnJsonPathEquals = JoinClause$2.prototype.onJsonPathEquals, module2.exports = JoinClause$2;
}), require_analytic = __commonJSMin$1((exports$12, module2) => {
  let assert$21 = require_assert();
  var Analytic$1 = class {
    constructor(method$1, schema$2, alias, orderBy, partitions) {
      this.schema = schema$2, this.type = `analytic`, this.method = method$1, this.order = orderBy || [], this.partitions = partitions || [], this.alias = alias, this.and = this, this.grouping = `columns`;
    }
    partitionBy(column, direction$1) {
      return assert$21(Array.isArray(column) || typeof column == `string`, `The argument to an analytic partitionBy function must be either a string
            or an array of string.`), Array.isArray(column) ? this.partitions = this.partitions.concat(column) : this.partitions.push({ column, order: direction$1 }), this;
    }
    orderBy(column, direction$1) {
      return assert$21(Array.isArray(column) || typeof column == `string`, `The argument to an analytic orderBy function must be either a string
            or an array of string.`), Array.isArray(column) ? this.order = this.order.concat(column) : this.order.push({ column, order: direction$1 }), this;
    }
  };
  module2.exports = Analytic$1;
}), require_save_async_stack = __commonJSMin$1((exports$12, module2) => {
  module2.exports = function(instance, lines) {
    instance.client.config.asyncStackTraces && (instance._asyncStack = { error: Error(), lines });
  };
}), require_constants$2 = __commonJSMin$1((exports$12, module2) => {
  module2.exports = { lockMode: { forShare: `forShare`, forUpdate: `forUpdate`, forNoKeyUpdate: `forNoKeyUpdate`, forKeyShare: `forKeyShare` }, waitMode: { skipLocked: `skipLocked`, noWait: `noWait` } };
}), require_noop$1 = __commonJSMin$1((exports$12, module2) => {
  module2.exports = function() {
  };
}), require_finally_mixin = __commonJSMin$1((exports$12, module2) => {
  let noop$5 = require_noop$1(), finallyMixin$2 = (prototype) => Object.assign(prototype, { finally(onFinally) {
    return this.then().finally(onFinally);
  } });
  module2.exports = Promise.prototype.finally ? finallyMixin$2 : noop$5;
}), require_query_executioner = __commonJSMin$1((exports$12, module2) => {
  let _debugQuery = require_src()(`knex:query`), debugBindings$2 = require_src()(`knex:bindings`), debugQuery = (sql, txId) => _debugQuery(sql.replace(/%/g, `%%`), txId), { isString: isString$15 } = require_is();
  function formatQuery$1(sql, bindings, timeZone, client) {
    bindings = bindings == null ? [] : [].concat(bindings);
    let index$2 = 0;
    return sql.replace(/\\?\?/g, (match$2) => {
      if (match$2 === `\\?`) return `?`;
      if (index$2 === bindings.length) return match$2;
      let value = bindings[index$2++];
      return client._escapeBinding(value, { timeZone });
    });
  }
  function enrichQueryObject$2(connection, queryParam, client) {
    let queryObject = isString$15(queryParam) ? { sql: queryParam } : queryParam;
    queryObject.bindings = client.prepBindings(queryObject.bindings), queryObject.sql = client.positionBindings(queryObject.sql);
    let { __knexUid, __knexTxId } = connection;
    return client.emit(`query`, Object.assign({ __knexUid, __knexTxId }, queryObject)), debugQuery(queryObject.sql, __knexTxId), debugBindings$2(queryObject.bindings, __knexTxId), queryObject;
  }
  function executeQuery$2(connection, queryObject, client) {
    return client._query(connection, queryObject).catch((err$1) => {
      throw client.config && client.config.compileSqlOnError === false ? err$1.message = queryObject.sql + ` - ` + err$1.message : err$1.message = formatQuery$1(queryObject.sql, queryObject.bindings, void 0, client) + ` - ` + err$1.message, client.emit(`query-error`, err$1, Object.assign({ __knexUid: connection.__knexUid, __knexTxId: connection.__knexUid }, queryObject)), err$1;
    });
  }
  module2.exports = { enrichQueryObject: enrichQueryObject$2, executeQuery: executeQuery$2, formatQuery: formatQuery$1 };
}), require_builder_interface_augmenter = __commonJSMin$1((exports$12, module2) => {
  let clone$6 = require_clone(), isEmpty$11 = require_isEmpty(), { callbackify: callbackify$1 } = require_util(), finallyMixin$1 = require_finally_mixin(), { formatQuery } = require_query_executioner();
  function augmentWithBuilderInterface$3(Target) {
    Target.prototype.toQuery = function(tz) {
      let data = this.toSQL(this._method, tz);
      return Array.isArray(data) || (data = [data]), data.length ? data.map((statement) => formatQuery(statement.sql, statement.bindings, tz, this.client)).reduce((a$22, c$12) => a$22.concat(a$22.endsWith(`;`) ? `
` : `;
`, c$12)) : ``;
    }, Target.prototype.then = function() {
      let result = this.client.runner(this).run();
      return this.client.config.asyncStackTraces && (result = result.catch((err$1) => {
        err$1.originalStack = err$1.stack;
        let firstLine = err$1.stack.split(`
`)[0], { error, lines } = this._asyncStack, stackByLines = error.stack.split(`
`), asyncStack = stackByLines.slice(lines);
        throw asyncStack.unshift(firstLine), err$1.stack = asyncStack.join(`
`), err$1;
      })), result.then.apply(result, arguments);
    }, Target.prototype.options = function(opts) {
      return this._options = this._options || [], this._options.push(clone$6(opts) || {}), this;
    }, Target.prototype.connection = function(connection) {
      return this._connection = connection, this.client.processPassedConnection(connection), this;
    }, Target.prototype.debug = function(enabled) {
      return this._debug = arguments.length ? enabled : true, this;
    }, Target.prototype.transacting = function(transaction) {
      if (transaction && transaction.client && (transaction.client.transacting ? this.client = transaction.client : transaction.client.logger.warn(`Invalid transaction value: ${transaction.client}`)), isEmpty$11(transaction)) throw this.client.logger.error(`Invalid value on transacting call, potential bug`), Error(`Invalid transacting value (null, undefined or empty object)`);
      return this;
    }, Target.prototype.stream = function(options) {
      return this.client.runner(this).stream(options);
    }, Target.prototype.pipe = function(writable, options) {
      return this.client.runner(this).pipe(writable, options);
    }, Target.prototype.asCallback = function(cb) {
      let promise = this.then();
      return callbackify$1(() => promise)(cb), promise;
    }, Target.prototype.catch = function(onReject) {
      return this.then().catch(onReject);
    }, Object.defineProperty(Target.prototype, Symbol.toStringTag, { get: () => `object` }), finallyMixin$1(Target.prototype);
  }
  module2.exports = { augmentWithBuilderInterface: augmentWithBuilderInterface$3 };
}), require_querybuilder = __commonJSMin$1((exports$12, module2) => {
  let assert$20 = require_assert(), { EventEmitter: EventEmitter$6 } = require_events(), assign$6 = require_assign(), clone$5 = require_clone(), each$4 = require_each(), isEmpty$10 = require_isEmpty(), isPlainObject$7 = require_isPlainObject(), last = require_last(), reject = require_reject(), tail$3 = require_tail(), toArray$6 = require_toArray(), { addQueryContext: addQueryContext$2, normalizeArr: normalizeArr$1 } = require_helpers$1(), JoinClause$1 = require_joinclause(), Analytic = require_analytic(), saveAsyncStack$2 = require_save_async_stack(), { isBoolean, isNumber: isNumber$3, isObject: isObject$14, isString: isString$14, isFunction: isFunction$3 } = require_is(), { lockMode, waitMode } = require_constants$2(), { augmentWithBuilderInterface: augmentWithBuilderInterface$2 } = require_builder_interface_augmenter(), SELECT_COMMANDS = /* @__PURE__ */ new Set([`pluck`, `first`, `select`]), CLEARABLE_STATEMENTS = /* @__PURE__ */ new Set([`with`, `select`, `columns`, `hintComments`, `where`, `union`, `join`, `group`, `order`, `having`, `limit`, `offset`, `counter`, `counters`]), LOCK_MODES = /* @__PURE__ */ new Set([lockMode.forShare, lockMode.forUpdate, lockMode.forNoKeyUpdate, lockMode.forKeyShare]);
  var Builder = class Builder2 extends EventEmitter$6 {
    constructor(client) {
      super(), this.client = client, this.and = this, this._single = {}, this._comments = [], this._statements = [], this._method = `select`, client.config && (saveAsyncStack$2(this, 5), this._debug = client.config.debug), this._joinFlag = `inner`, this._boolFlag = `and`, this._notFlag = false, this._asColumnFlag = false;
    }
    toString() {
      return this.toQuery();
    }
    toSQL(method$1, tz) {
      return this.client.queryCompiler(this).toSQL(method$1 || this._method, tz);
    }
    clone() {
      let cloned = new this.constructor(this.client);
      return cloned._method = this._method, cloned._single = clone$5(this._single), cloned._comments = clone$5(this._comments), cloned._statements = clone$5(this._statements), cloned._debug = this._debug, this._options !== void 0 && (cloned._options = clone$5(this._options)), this._queryContext !== void 0 && (cloned._queryContext = clone$5(this._queryContext)), this._connection !== void 0 && (cloned._connection = this._connection), cloned;
    }
    timeout(ms, { cancel } = {}) {
      return isNumber$3(ms) && ms > 0 && (this._timeout = ms, cancel && (this.client.assertCanCancelQuery(), this._cancelOnTimeout = true)), this;
    }
    isValidStatementArg(statement) {
      return typeof statement == `function` || statement instanceof Builder2 || statement && statement.isRawInstance;
    }
    _validateWithArgs(alias, statementOrColumnList, nothingOrStatement, method$1) {
      let [query, columnList] = nothingOrStatement === void 0 ? [statementOrColumnList, void 0] : [nothingOrStatement, statementOrColumnList];
      if (typeof alias != `string`) throw Error(`${method$1}() first argument must be a string`);
      if (this.isValidStatementArg(query) && columnList === void 0) return;
      let isNonEmptyNameList = Array.isArray(columnList) && columnList.length > 0 && columnList.every((it) => typeof it == `string`);
      if (!isNonEmptyNameList) throw Error(`${method$1}() second argument must be a statement or non-empty column name list.`);
      if (!this.isValidStatementArg(query)) throw Error(`${method$1}() third argument must be a function / QueryBuilder or a raw when its second argument is a column name list`);
    }
    with(alias, statementOrColumnList, nothingOrStatement) {
      return this._validateWithArgs(alias, statementOrColumnList, nothingOrStatement, `with`), this.withWrapped(alias, statementOrColumnList, nothingOrStatement);
    }
    withMaterialized(alias, statementOrColumnList, nothingOrStatement) {
      throw Error(`With materialized is not supported by this dialect`);
    }
    withNotMaterialized(alias, statementOrColumnList, nothingOrStatement) {
      throw Error(`With materialized is not supported by this dialect`);
    }
    withWrapped(alias, statementOrColumnList, nothingOrStatement, materialized) {
      let [query, columnList] = nothingOrStatement === void 0 ? [statementOrColumnList, void 0] : [nothingOrStatement, statementOrColumnList], statement = { grouping: `with`, type: `withWrapped`, alias, columnList, value: query };
      return materialized !== void 0 && (statement.materialized = materialized), this._statements.push(statement), this;
    }
    withRecursive(alias, statementOrColumnList, nothingOrStatement) {
      return this._validateWithArgs(alias, statementOrColumnList, nothingOrStatement, `withRecursive`), this.withRecursiveWrapped(alias, statementOrColumnList, nothingOrStatement);
    }
    withRecursiveWrapped(alias, statementOrColumnList, nothingOrStatement) {
      return this.withWrapped(alias, statementOrColumnList, nothingOrStatement), this._statements[this._statements.length - 1].recursive = true, this;
    }
    columns(column) {
      return !column && column !== 0 || this._statements.push({ grouping: `columns`, value: normalizeArr$1(...arguments) }), this;
    }
    comment(txt) {
      if (!isString$14(txt)) throw Error(`Comment must be a string`);
      let forbiddenChars = [`/*`, `*/`, `?`];
      if (forbiddenChars.some((chars) => txt.includes(chars))) throw Error(`Cannot include ${forbiddenChars.join(`, `)} in comment`);
      return this._comments.push({ comment: txt }), this;
    }
    as(column) {
      return this._single.as = column, this;
    }
    hintComment(hints) {
      if (hints = Array.isArray(hints) ? hints : [hints], hints.some((hint) => !isString$14(hint))) throw Error(`Hint comment must be a string`);
      if (hints.some((hint) => hint.includes(`/*`) || hint.includes(`*/`))) throw Error(`Hint comment cannot include "/*" or "*/"`);
      if (hints.some((hint) => hint.includes(`?`))) throw Error(`Hint comment cannot include "?"`);
      return this._statements.push({ grouping: `hintComments`, value: hints }), this;
    }
    withSchema(schemaName) {
      return this._single.schema = schemaName, this;
    }
    table(tableName, options = {}) {
      return this._single.table = tableName, this._single.only = options.only === true, this;
    }
    distinct(...args$1) {
      return this._statements.push({ grouping: `columns`, value: normalizeArr$1(...args$1), distinct: true }), this;
    }
    distinctOn(...args$1) {
      if (isEmpty$10(args$1)) throw Error(`distinctOn requires at least on argument`);
      return this._statements.push({ grouping: `columns`, value: normalizeArr$1(...args$1), distinctOn: true }), this;
    }
    join(table$2, first$1, ...args$1) {
      let join, schema$2 = table$2 instanceof Builder2 || typeof table$2 == `function` ? void 0 : this._single.schema, joinType = this._joinType();
      return typeof first$1 == `function` ? (join = new JoinClause$1(table$2, joinType, schema$2), first$1.call(join, join)) : joinType === `raw` ? join = new JoinClause$1(this.client.raw(table$2, first$1), `raw`) : (join = new JoinClause$1(table$2, joinType, schema$2), first$1 && join.on(first$1, ...args$1)), this._statements.push(join), this;
    }
    using(tables) {
      throw Error(`'using' function is only available in PostgreSQL dialect with Delete statements.`);
    }
    innerJoin(...args$1) {
      return this._joinType(`inner`).join(...args$1);
    }
    leftJoin(...args$1) {
      return this._joinType(`left`).join(...args$1);
    }
    leftOuterJoin(...args$1) {
      return this._joinType(`left outer`).join(...args$1);
    }
    rightJoin(...args$1) {
      return this._joinType(`right`).join(...args$1);
    }
    rightOuterJoin(...args$1) {
      return this._joinType(`right outer`).join(...args$1);
    }
    outerJoin(...args$1) {
      return this._joinType(`outer`).join(...args$1);
    }
    fullOuterJoin(...args$1) {
      return this._joinType(`full outer`).join(...args$1);
    }
    crossJoin(...args$1) {
      return this._joinType(`cross`).join(...args$1);
    }
    joinRaw(...args$1) {
      return this._joinType(`raw`).join(...args$1);
    }
    get or() {
      return this._bool(`or`);
    }
    get not() {
      return this._not(true);
    }
    where(column, operator$1, value) {
      let argsLength = arguments.length;
      if (column === false || column === true) return this.where(1, `=`, column ? 1 : 0);
      if (typeof column == `function`) return this.whereWrapped(column);
      if (isObject$14(column) && !column.isRawInstance) return this._objectWhere(column);
      if (column && column.isRawInstance && argsLength === 1) return this.whereRaw(column);
      if (argsLength === 2 && (value = operator$1, operator$1 = `=`, value === null)) return this.whereNull(column);
      let checkOperator = `${operator$1}`.toLowerCase().trim();
      if (argsLength === 3) {
        if (checkOperator === `in` || checkOperator === `not in`) return this._not(checkOperator === `not in`).whereIn(column, value);
        if (checkOperator === `between` || checkOperator === `not between`) return this._not(checkOperator === `not between`).whereBetween(column, value);
      }
      return value === null && (checkOperator === `is` || checkOperator === `is not`) ? this._not(checkOperator === `is not`).whereNull(column) : (this._statements.push({ grouping: `where`, type: `whereBasic`, column, operator: operator$1, value, not: this._not(), bool: this._bool(), asColumn: this._asColumnFlag }), this);
    }
    whereColumn(...args$1) {
      return this._asColumnFlag = true, this.where(...args$1), this._asColumnFlag = false, this;
    }
    orWhere(column, ...args$1) {
      this._bool(`or`);
      let obj = column;
      return isObject$14(obj) && !obj.isRawInstance ? this.whereWrapped(function() {
        for (let key in obj) this.andWhere(key, obj[key]);
      }) : this.where(column, ...args$1);
    }
    orWhereColumn(column, ...args$1) {
      this._bool(`or`);
      let obj = column;
      return isObject$14(obj) && !obj.isRawInstance ? this.whereWrapped(function() {
        for (let key in obj) this.andWhereColumn(key, `=`, obj[key]);
      }) : this.whereColumn(column, ...args$1);
    }
    whereNot(column, ...args$1) {
      return args$1.length >= 2 && (args$1[0] === `in` || args$1[0] === `between`) && this.client.logger.warn(`whereNot is not suitable for "in" and "between" type subqueries. You should use "not in" and "not between" instead.`), this._not(true).where(column, ...args$1);
    }
    whereNotColumn(...args$1) {
      return this._not(true).whereColumn(...args$1);
    }
    orWhereNot(...args$1) {
      return this._bool(`or`).whereNot(...args$1);
    }
    orWhereNotColumn(...args$1) {
      return this._bool(`or`).whereNotColumn(...args$1);
    }
    _objectWhere(obj) {
      let boolVal = this._bool(), notVal = this._not() ? `Not` : ``;
      for (let key in obj) this[boolVal + `Where` + notVal](key, obj[key]);
      return this;
    }
    whereRaw(sql, bindings) {
      let raw = sql.isRawInstance ? sql : this.client.raw(sql, bindings);
      return this._statements.push({ grouping: `where`, type: `whereRaw`, value: raw, not: this._not(), bool: this._bool() }), this;
    }
    orWhereRaw(sql, bindings) {
      return this._bool(`or`).whereRaw(sql, bindings);
    }
    whereWrapped(callback) {
      return this._statements.push({ grouping: `where`, type: `whereWrapped`, value: callback, not: this._not(), bool: this._bool() }), this;
    }
    whereExists(callback) {
      return this._statements.push({ grouping: `where`, type: `whereExists`, value: callback, not: this._not(), bool: this._bool() }), this;
    }
    orWhereExists(callback) {
      return this._bool(`or`).whereExists(callback);
    }
    whereNotExists(callback) {
      return this._not(true).whereExists(callback);
    }
    orWhereNotExists(callback) {
      return this._bool(`or`).whereNotExists(callback);
    }
    whereIn(column, values$3) {
      return Array.isArray(values$3) && isEmpty$10(values$3) ? this.where(this._not()) : (this._statements.push({ grouping: `where`, type: `whereIn`, column, value: values$3, not: this._not(), bool: this._bool() }), this);
    }
    orWhereIn(column, values$3) {
      return this._bool(`or`).whereIn(column, values$3);
    }
    whereNotIn(column, values$3) {
      return this._not(true).whereIn(column, values$3);
    }
    orWhereNotIn(column, values$3) {
      return this._bool(`or`)._not(true).whereIn(column, values$3);
    }
    whereNull(column) {
      return this._statements.push({ grouping: `where`, type: `whereNull`, column, not: this._not(), bool: this._bool() }), this;
    }
    orWhereNull(column) {
      return this._bool(`or`).whereNull(column);
    }
    whereNotNull(column) {
      return this._not(true).whereNull(column);
    }
    orWhereNotNull(column) {
      return this._bool(`or`).whereNotNull(column);
    }
    whereBetween(column, values$3) {
      return assert$20(Array.isArray(values$3), `The second argument to whereBetween must be an array.`), assert$20(values$3.length === 2, `You must specify 2 values for the whereBetween clause`), this._statements.push({ grouping: `where`, type: `whereBetween`, column, value: values$3, not: this._not(), bool: this._bool() }), this;
    }
    whereNotBetween(column, values$3) {
      return this._not(true).whereBetween(column, values$3);
    }
    orWhereBetween(column, values$3) {
      return this._bool(`or`).whereBetween(column, values$3);
    }
    orWhereNotBetween(column, values$3) {
      return this._bool(`or`).whereNotBetween(column, values$3);
    }
    _whereLike(type, column, value) {
      return this._statements.push({ grouping: `where`, type, column, value, not: this._not(), bool: this._bool(), asColumn: this._asColumnFlag }), this;
    }
    whereLike(column, value) {
      return this._whereLike(`whereLike`, column, value);
    }
    orWhereLike(column, value) {
      return this._bool(`or`)._whereLike(`whereLike`, column, value);
    }
    whereILike(column, value) {
      return this._whereLike(`whereILike`, column, value);
    }
    orWhereILike(column, value) {
      return this._bool(`or`)._whereLike(`whereILike`, column, value);
    }
    groupBy(item) {
      return item && item.isRawInstance ? this.groupByRaw.apply(this, arguments) : (this._statements.push({ grouping: `group`, type: `groupByBasic`, value: normalizeArr$1(...arguments) }), this);
    }
    groupByRaw(sql, bindings) {
      let raw = sql.isRawInstance ? sql : this.client.raw(sql, bindings);
      return this._statements.push({ grouping: `group`, type: `groupByRaw`, value: raw }), this;
    }
    orderBy(column, direction$1, nulls = ``) {
      return Array.isArray(column) ? this._orderByArray(column) : (this._statements.push({ grouping: `order`, type: `orderByBasic`, value: column, direction: direction$1, nulls }), this);
    }
    _orderByArray(columnDefs) {
      for (let i$4 = 0; i$4 < columnDefs.length; i$4++) {
        let columnInfo = columnDefs[i$4];
        isObject$14(columnInfo) ? this._statements.push({ grouping: `order`, type: `orderByBasic`, value: columnInfo.column, direction: columnInfo.order, nulls: columnInfo.nulls }) : (isString$14(columnInfo) || isNumber$3(columnInfo)) && this._statements.push({ grouping: `order`, type: `orderByBasic`, value: columnInfo });
      }
      return this;
    }
    orderByRaw(sql, bindings) {
      let raw = sql.isRawInstance ? sql : this.client.raw(sql, bindings);
      return this._statements.push({ grouping: `order`, type: `orderByRaw`, value: raw }), this;
    }
    _union(clause, args$1) {
      let callbacks = args$1[0], wrap$2 = args$1[1];
      if (args$1.length === 1 || args$1.length === 2 && isBoolean(wrap$2)) {
        Array.isArray(callbacks) || (callbacks = [callbacks]);
        for (let i$4 = 0, l$4 = callbacks.length; i$4 < l$4; i$4++) this._statements.push({ grouping: `union`, clause, value: callbacks[i$4], wrap: wrap$2 || false });
      } else callbacks = toArray$6(args$1).slice(0, args$1.length - 1), wrap$2 = args$1[args$1.length - 1], isBoolean(wrap$2) || (callbacks.push(wrap$2), wrap$2 = false), this._union(clause, [callbacks, wrap$2]);
      return this;
    }
    union(...args$1) {
      return this._union(`union`, args$1);
    }
    unionAll(...args$1) {
      return this._union(`union all`, args$1);
    }
    intersect(...args$1) {
      return this._union(`intersect`, args$1);
    }
    except(...args$1) {
      return this._union(`except`, args$1);
    }
    having(column, operator$1, value) {
      return column.isRawInstance && arguments.length === 1 ? this.havingRaw(column) : typeof column == `function` ? this.havingWrapped(column) : (this._statements.push({ grouping: `having`, type: `havingBasic`, column, operator: operator$1, value, bool: this._bool(), not: this._not() }), this);
    }
    orHaving(column, ...args$1) {
      this._bool(`or`);
      let obj = column;
      return isObject$14(obj) && !obj.isRawInstance ? this.havingWrapped(function() {
        for (let key in obj) this.andHaving(key, obj[key]);
      }) : this.having(column, ...args$1);
    }
    havingWrapped(callback) {
      return this._statements.push({ grouping: `having`, type: `havingWrapped`, value: callback, bool: this._bool(), not: this._not() }), this;
    }
    havingNull(column) {
      return this._statements.push({ grouping: `having`, type: `havingNull`, column, not: this._not(), bool: this._bool() }), this;
    }
    orHavingNull(callback) {
      return this._bool(`or`).havingNull(callback);
    }
    havingNotNull(callback) {
      return this._not(true).havingNull(callback);
    }
    orHavingNotNull(callback) {
      return this._not(true)._bool(`or`).havingNull(callback);
    }
    havingExists(callback) {
      return this._statements.push({ grouping: `having`, type: `havingExists`, value: callback, not: this._not(), bool: this._bool() }), this;
    }
    orHavingExists(callback) {
      return this._bool(`or`).havingExists(callback);
    }
    havingNotExists(callback) {
      return this._not(true).havingExists(callback);
    }
    orHavingNotExists(callback) {
      return this._not(true)._bool(`or`).havingExists(callback);
    }
    havingBetween(column, values$3) {
      return assert$20(Array.isArray(values$3), `The second argument to havingBetween must be an array.`), assert$20(values$3.length === 2, `You must specify 2 values for the havingBetween clause`), this._statements.push({ grouping: `having`, type: `havingBetween`, column, value: values$3, not: this._not(), bool: this._bool() }), this;
    }
    orHavingBetween(column, values$3) {
      return this._bool(`or`).havingBetween(column, values$3);
    }
    havingNotBetween(column, values$3) {
      return this._not(true).havingBetween(column, values$3);
    }
    orHavingNotBetween(column, values$3) {
      return this._not(true)._bool(`or`).havingBetween(column, values$3);
    }
    havingIn(column, values$3) {
      return Array.isArray(values$3) && isEmpty$10(values$3) ? this.where(this._not()) : (this._statements.push({ grouping: `having`, type: `havingIn`, column, value: values$3, not: this._not(), bool: this._bool() }), this);
    }
    orHavingIn(column, values$3) {
      return this._bool(`or`).havingIn(column, values$3);
    }
    havingNotIn(column, values$3) {
      return this._not(true).havingIn(column, values$3);
    }
    orHavingNotIn(column, values$3) {
      return this._bool(`or`)._not(true).havingIn(column, values$3);
    }
    havingRaw(sql, bindings) {
      let raw = sql.isRawInstance ? sql : this.client.raw(sql, bindings);
      return this._statements.push({ grouping: `having`, type: `havingRaw`, value: raw, bool: this._bool(), not: this._not() }), this;
    }
    orHavingRaw(sql, bindings) {
      return this._bool(`or`).havingRaw(sql, bindings);
    }
    _setSkipBinding(attribute, options) {
      let skipBinding = options;
      isObject$14(options) && (skipBinding = options.skipBinding), this._single.skipBinding = this._single.skipBinding || {}, this._single.skipBinding[attribute] = skipBinding;
    }
    offset(value, options) {
      if (value == null || value.isRawInstance || value instanceof Builder2) this._single.offset = value;
      else {
        let val = parseInt(value, 10);
        if (isNaN(val)) this.client.logger.warn(`A valid integer must be provided to offset`);
        else if (val < 0) throw Error(`A non-negative integer must be provided to offset.`);
        else this._single.offset = val;
      }
      return this._setSkipBinding(`offset`, options), this;
    }
    limit(value, options) {
      let val = parseInt(value, 10);
      return isNaN(val) ? this.client.logger.warn(`A valid integer must be provided to limit`) : (this._single.limit = val, this._setSkipBinding(`limit`, options)), this;
    }
    count(column, options) {
      return this._aggregate(`count`, column || `*`, options);
    }
    min(column, options) {
      return this._aggregate(`min`, column, options);
    }
    max(column, options) {
      return this._aggregate(`max`, column, options);
    }
    sum(column, options) {
      return this._aggregate(`sum`, column, options);
    }
    avg(column, options) {
      return this._aggregate(`avg`, column, options);
    }
    countDistinct(...columns) {
      let options;
      return columns.length > 1 && isPlainObject$7(last(columns)) && ([options] = columns.splice(columns.length - 1, 1)), columns.length ? columns.length === 1 && (columns = columns[0]) : columns = `*`, this._aggregate(`count`, columns, { ...options, distinct: true });
    }
    sumDistinct(column, options) {
      return this._aggregate(`sum`, column, { ...options, distinct: true });
    }
    avgDistinct(column, options) {
      return this._aggregate(`avg`, column, { ...options, distinct: true });
    }
    increment(column, amount = 1) {
      if (isObject$14(column)) {
        for (let key in column) this._counter(key, column[key]);
        return this;
      }
      return this._counter(column, amount);
    }
    decrement(column, amount = 1) {
      if (isObject$14(column)) {
        for (let key in column) this._counter(key, -column[key]);
        return this;
      }
      return this._counter(column, -amount);
    }
    clearCounters() {
      return this._single.counter = {}, this;
    }
    first(...args$1) {
      if (this._method && this._method !== `select`) throw Error(`Cannot chain .first() on "${this._method}" query`);
      return this.select(normalizeArr$1(...args$1)), this._method = `first`, this.limit(1), this;
    }
    connection(_connection) {
      return this._connection = _connection, this.client.processPassedConnection(_connection), this;
    }
    pluck(column) {
      if (this._method && this._method !== `select`) throw Error(`Cannot chain .pluck() on "${this._method}" query`);
      return this._method = `pluck`, this._single.pluck = column, this._statements.push({ grouping: `columns`, type: `pluck`, value: column }), this;
    }
    clearSelect() {
      return this._clearGrouping(`columns`), this;
    }
    clearWhere() {
      return this._clearGrouping(`where`), this;
    }
    clearGroup() {
      return this._clearGrouping(`group`), this;
    }
    clearOrder() {
      return this._clearGrouping(`order`), this;
    }
    clearHaving() {
      return this._clearGrouping(`having`), this;
    }
    clear(statement) {
      if (!CLEARABLE_STATEMENTS.has(statement)) throw Error(`Knex Error: unknown statement '${statement}'`);
      return statement.startsWith(`counter`) ? this.clearCounters() : (statement === `select` && (statement = `columns`), this._clearGrouping(statement), this);
    }
    insert(values$3, returning, options) {
      return this._method = `insert`, isEmpty$10(returning) || this.returning(returning, options), this._single.insert = values$3, this;
    }
    update(values$3, returning, options) {
      let ret, obj = this._single.update || {};
      if (this._method = `update`, isString$14(values$3)) isPlainObject$7(returning) ? obj[values$3] = JSON.stringify(returning) : obj[values$3] = returning, arguments.length > 2 && (ret = arguments[2]);
      else {
        let keys$10 = Object.keys(values$3);
        this._single.update && this.client.logger.warn(`Update called multiple times with objects.`);
        let i$4 = -1;
        for (; ++i$4 < keys$10.length; ) obj[keys$10[i$4]] = values$3[keys$10[i$4]];
        ret = arguments[1];
      }
      return isEmpty$10(ret) || this.returning(ret, options), this._single.update = obj, this;
    }
    returning(returning, options) {
      return this._single.returning = returning, this._single.options = options, this;
    }
    onConflict(columns) {
      return typeof columns == `string` && (columns = [columns]), new OnConflictBuilder(this, columns || true);
    }
    delete(ret, options) {
      return this._method = `del`, isEmpty$10(ret) || this.returning(ret, options), this;
    }
    truncate(tableName) {
      return this._method = `truncate`, tableName && (this._single.table = tableName), this;
    }
    columnInfo(column) {
      return this._method = `columnInfo`, this._single.columnInfo = column, this;
    }
    forUpdate(...tables) {
      return this._single.lock = lockMode.forUpdate, tables.length === 1 && Array.isArray(tables[0]) ? this._single.lockTables = tables[0] : this._single.lockTables = tables, this;
    }
    forShare(...tables) {
      return this._single.lock = lockMode.forShare, this._single.lockTables = tables, this;
    }
    forNoKeyUpdate(...tables) {
      return this._single.lock = lockMode.forNoKeyUpdate, this._single.lockTables = tables, this;
    }
    forKeyShare(...tables) {
      return this._single.lock = lockMode.forKeyShare, this._single.lockTables = tables, this;
    }
    skipLocked() {
      if (!this._isSelectQuery()) throw Error(`Cannot chain .skipLocked() on "${this._method}" query!`);
      if (!this._hasLockMode()) throw Error(`.skipLocked() can only be used after a call to .forShare() or .forUpdate()!`);
      if (this._single.waitMode === waitMode.noWait) throw Error(`.skipLocked() cannot be used together with .noWait()!`);
      return this._single.waitMode = waitMode.skipLocked, this;
    }
    noWait() {
      if (!this._isSelectQuery()) throw Error(`Cannot chain .noWait() on "${this._method}" query!`);
      if (!this._hasLockMode()) throw Error(`.noWait() can only be used after a call to .forShare() or .forUpdate()!`);
      if (this._single.waitMode === waitMode.skipLocked) throw Error(`.noWait() cannot be used together with .skipLocked()!`);
      return this._single.waitMode = waitMode.noWait, this;
    }
    fromJS(obj) {
      return each$4(obj, (val, key) => {
        typeof this[key] != `function` && this.client.logger.warn(`Knex Error: unknown key ${key}`), Array.isArray(val) ? this[key].apply(this, val) : this[key](val);
      }), this;
    }
    fromRaw(sql, bindings) {
      let raw = sql.isRawInstance ? sql : this.client.raw(sql, bindings);
      return this.from(raw);
    }
    modify(callback) {
      return callback.apply(this, [this].concat(tail$3(arguments))), this;
    }
    upsert(values$3, returning, options) {
      throw Error(`Upsert is not yet supported for dialect ${this.client.dialect}`);
    }
    _json(nameFunction, params) {
      return this._statements.push({ grouping: `columns`, type: `json`, method: nameFunction, params }), this;
    }
    jsonExtract() {
      let column = arguments[0], path, alias, singleValue = true;
      return arguments.length >= 2 && (path = arguments[1]), arguments.length >= 3 && (alias = arguments[2]), arguments.length === 4 && (singleValue = arguments[3]), arguments.length === 2 && Array.isArray(arguments[0]) && isBoolean(arguments[1]) && (singleValue = arguments[1]), this._json(`jsonExtract`, { column, path, alias, singleValue });
    }
    jsonSet(column, path, value, alias) {
      return this._json(`jsonSet`, { column, path, value, alias });
    }
    jsonInsert(column, path, value, alias) {
      return this._json(`jsonInsert`, { column, path, value, alias });
    }
    jsonRemove(column, path, alias) {
      return this._json(`jsonRemove`, { column, path, alias });
    }
    _isJsonObject(jsonValue) {
      return isObject$14(jsonValue) && !(jsonValue instanceof Builder2);
    }
    _whereJsonWrappedValue(type, column, value) {
      let whereJsonClause = { grouping: `where`, type, column, value, not: this._not(), bool: this._bool(), asColumn: this._asColumnFlag };
      arguments[3] && (whereJsonClause.operator = arguments[3]), arguments[4] && (whereJsonClause.jsonPath = arguments[4]), this._statements.push(whereJsonClause);
    }
    whereJsonObject(column, value) {
      return this._whereJsonWrappedValue(`whereJsonObject`, column, value), this;
    }
    orWhereJsonObject(column, value) {
      return this._bool(`or`).whereJsonObject(column, value);
    }
    whereNotJsonObject(column, value) {
      return this._not(true).whereJsonObject(column, value);
    }
    orWhereNotJsonObject(column, value) {
      return this._bool(`or`).whereNotJsonObject(column, value);
    }
    whereJsonPath(column, path, operator$1, value) {
      return this._whereJsonWrappedValue(`whereJsonPath`, column, value, operator$1, path), this;
    }
    orWhereJsonPath(column, path, operator$1, value) {
      return this._bool(`or`).whereJsonPath(column, path, operator$1, value);
    }
    whereJsonSupersetOf(column, value) {
      return this._whereJsonWrappedValue(`whereJsonSupersetOf`, column, value), this;
    }
    whereJsonNotSupersetOf(column, value) {
      return this._not(true).whereJsonSupersetOf(column, value);
    }
    orWhereJsonSupersetOf(column, value) {
      return this._bool(`or`).whereJsonSupersetOf(column, value);
    }
    orWhereJsonNotSupersetOf(column, value) {
      return this._bool(`or`).whereJsonNotSupersetOf(column, value);
    }
    whereJsonSubsetOf(column, value) {
      return this._whereJsonWrappedValue(`whereJsonSubsetOf`, column, value), this;
    }
    whereJsonNotSubsetOf(column, value) {
      return this._not(true).whereJsonSubsetOf(column, value);
    }
    orWhereJsonSubsetOf(column, value) {
      return this._bool(`or`).whereJsonSubsetOf(column, value);
    }
    orWhereJsonNotSubsetOf(column, value) {
      return this._bool(`or`).whereJsonNotSubsetOf(column, value);
    }
    whereJsonHasNone(column, values$3) {
      return this._not(true).whereJsonHasAll(column, values$3), this;
    }
    _analytic(alias, second, third) {
      let analytic, { schema: schema$2 } = this._single, method$1 = this._analyticMethod();
      if (alias = typeof alias == `string` ? alias : null, assert$20(typeof second == `function` || second.isRawInstance || Array.isArray(second) || typeof second == `string` || typeof second == `object`, `The second argument to an analytic function must be either a function, a raw,
       an array of string or object, an object or a single string.`), third && assert$20(Array.isArray(third) || typeof third == `string` || typeof third == `object`, `The third argument to an analytic function must be either a string, an array of string or object or an object.`), isFunction$3(second)) analytic = new Analytic(method$1, schema$2, alias), second.call(analytic, analytic);
      else if (second.isRawInstance) {
        let raw = second;
        analytic = { grouping: `columns`, type: `analytic`, method: method$1, raw, alias };
      } else {
        let order$2 = Array.isArray(second) ? second : [second], partitions = third || [];
        partitions = Array.isArray(partitions) ? partitions : [partitions], analytic = { grouping: `columns`, type: `analytic`, method: method$1, order: order$2, alias, partitions };
      }
      return this._statements.push(analytic), this;
    }
    rank(...args$1) {
      return this._analyticMethod(`rank`)._analytic(...args$1);
    }
    denseRank(...args$1) {
      return this._analyticMethod(`dense_rank`)._analytic(...args$1);
    }
    rowNumber(...args$1) {
      return this._analyticMethod(`row_number`)._analytic(...args$1);
    }
    _counter(column, amount) {
      return amount = parseFloat(amount), this._method = `update`, this._single.counter = this._single.counter || {}, this._single.counter[column] = amount, this;
    }
    _bool(val) {
      if (arguments.length === 1) return this._boolFlag = val, this;
      let ret = this._boolFlag;
      return this._boolFlag = `and`, ret;
    }
    _not(val) {
      if (arguments.length === 1) return this._notFlag = val, this;
      let ret = this._notFlag;
      return this._notFlag = false, ret;
    }
    _joinType(val) {
      if (arguments.length === 1) return this._joinFlag = val, this;
      let ret = this._joinFlag || `inner`;
      return this._joinFlag = `inner`, ret;
    }
    _analyticMethod(val) {
      return arguments.length === 1 ? (this._analyticFlag = val, this) : this._analyticFlag || `row_number`;
    }
    _aggregate(method$1, column, options = {}) {
      return this._statements.push({ grouping: `columns`, type: column.isRawInstance ? `aggregateRaw` : `aggregate`, method: method$1, value: column, aggregateDistinct: options.distinct || false, alias: options.as }), this;
    }
    _clearGrouping(grouping) {
      grouping in this._single ? this._single[grouping] = void 0 : this._statements = reject(this._statements, { grouping });
    }
    _isSelectQuery() {
      return SELECT_COMMANDS.has(this._method);
    }
    _hasLockMode() {
      return LOCK_MODES.has(this._single.lock);
    }
  };
  Builder.prototype.select = Builder.prototype.columns, Builder.prototype.column = Builder.prototype.columns, Builder.prototype.andWhereNot = Builder.prototype.whereNot, Builder.prototype.andWhereNotColumn = Builder.prototype.whereNotColumn, Builder.prototype.andWhere = Builder.prototype.where, Builder.prototype.andWhereColumn = Builder.prototype.whereColumn, Builder.prototype.andWhereRaw = Builder.prototype.whereRaw, Builder.prototype.andWhereBetween = Builder.prototype.whereBetween, Builder.prototype.andWhereNotBetween = Builder.prototype.whereNotBetween, Builder.prototype.andWhereJsonObject = Builder.prototype.whereJsonObject, Builder.prototype.andWhereNotJsonObject = Builder.prototype.whereNotJsonObject, Builder.prototype.andWhereJsonPath = Builder.prototype.whereJsonPath, Builder.prototype.andWhereLike = Builder.prototype.whereLike, Builder.prototype.andWhereILike = Builder.prototype.whereILike, Builder.prototype.andHaving = Builder.prototype.having, Builder.prototype.andHavingIn = Builder.prototype.havingIn, Builder.prototype.andHavingNotIn = Builder.prototype.havingNotIn, Builder.prototype.andHavingNull = Builder.prototype.havingNull, Builder.prototype.andHavingNotNull = Builder.prototype.havingNotNull, Builder.prototype.andHavingExists = Builder.prototype.havingExists, Builder.prototype.andHavingNotExists = Builder.prototype.havingNotExists, Builder.prototype.andHavingBetween = Builder.prototype.havingBetween, Builder.prototype.andHavingNotBetween = Builder.prototype.havingNotBetween, Builder.prototype.from = Builder.prototype.table, Builder.prototype.into = Builder.prototype.table, Builder.prototype.del = Builder.prototype.delete, augmentWithBuilderInterface$2(Builder), addQueryContext$2(Builder), Builder.extend = (methodName, fn$1) => {
    if (Object.prototype.hasOwnProperty.call(Builder.prototype, methodName)) throw Error(`Can't extend QueryBuilder with existing method ('${methodName}').`);
    assign$6(Builder.prototype, { [methodName]: fn$1 });
  };
  var OnConflictBuilder = class {
    constructor(builder, columns) {
      this.builder = builder, this._columns = columns;
    }
    ignore() {
      return this.builder._single.onConflict = this._columns, this.builder._single.ignore = true, this.builder;
    }
    merge(updates) {
      return this.builder._single.onConflict = this._columns, this.builder._single.merge = { updates }, this.builder;
    }
    then() {
      throw Error(`Incomplete onConflict clause. .onConflict() must be directly followed by either .merge() or .ignore()`);
    }
  };
  module2.exports = Builder;
}), require_formatterUtils = __commonJSMin$1((exports$12, module2) => {
  let { isObject: isObject$13 } = require_is();
  function compileCallback$5(callback, method$1, client, bindingsHolder) {
    let builder = client.queryBuilder();
    callback.call(builder, builder);
    let compiler = client.queryCompiler(builder, bindingsHolder.bindings);
    return compiler.toSQL(method$1 || builder._method || `select`);
  }
  function wrapAsIdentifier$2(value, builder, client) {
    let queryContext = builder.queryContext();
    return client.wrapIdentifier((value || ``).trim(), queryContext);
  }
  function formatDefault$3(value, type, client) {
    return value === void 0 ? `` : value === null ? `null` : value && value.isRawInstance ? value.toQuery() : type === `bool` ? (value === `false` && (value = 0), `'${value ? 1 : 0}'`) : (type === `json` || type === `jsonb`) && isObject$13(value) ? `'${JSON.stringify(value)}'` : client._escapeBinding(value.toString());
  }
  module2.exports = { compileCallback: compileCallback$5, wrapAsIdentifier: wrapAsIdentifier$2, formatDefault: formatDefault$3 };
}), require_wrappingFormatter = __commonJSMin$1((exports$12, module2) => {
  let transform = require_transform(), QueryBuilder$13 = require_querybuilder(), { compileCallback: compileCallback$4, wrapAsIdentifier: wrapAsIdentifier$1 } = require_formatterUtils(), orderBys = [`asc`, `desc`], operators = transform([`=`, `<`, `>`, `<=`, `>=`, `<>`, `!=`, `like`, `not like`, `between`, `not between`, `ilike`, `not ilike`, `exists`, `not exist`, `rlike`, `not rlike`, `regexp`, `not regexp`, `match`, `&`, `|`, `^`, `<<`, `>>`, `~`, `~=`, `~*`, `!~`, `!~*`, `#`, `&&`, `@>`, `<@`, `||`, `&<`, `&>`, `-|-`, `@@`, `!!`, [`?`, `\\?`], [`?|`, `\\?|`], [`?&`, `\\?&`]], (result, key) => {
    Array.isArray(key) ? result[key[0]] = key[1] : result[key] = key;
  }, {});
  function columnize$1(target, builder, client, bindingHolder) {
    let columns = Array.isArray(target) ? target : [target], str = ``, i$4 = -1;
    for (; ++i$4 < columns.length; ) i$4 > 0 && (str += `, `), str += wrap(columns[i$4], void 0, builder, client, bindingHolder);
    return str;
  }
  function wrap(value, isParameter, builder, client, bindingHolder) {
    let raw = unwrapRaw$3(value, isParameter, builder, client, bindingHolder);
    if (raw) return raw;
    switch (typeof value) {
      case `function`:
        return outputQuery$3(compileCallback$4(value, void 0, client, bindingHolder), true, builder, client);
      case `object`:
        return parseObject(value, builder, client, bindingHolder);
      case `number`:
        return value;
      default:
        return wrapString$2(value + ``, builder, client);
    }
  }
  function unwrapRaw$3(value, isParameter, builder, client, bindingsHolder) {
    let query;
    if (value instanceof QueryBuilder$13) return query = client.queryCompiler(value).toSQL(), query.bindings && bindingsHolder.bindings.push(...query.bindings), outputQuery$3(query, isParameter, builder, client);
    if (value && value.isRawInstance) return value.client = client, builder._queryContext && (value.queryContext = () => builder._queryContext), query = value.toSQL(), query.bindings && bindingsHolder.bindings.push(...query.bindings), query.sql;
    isParameter && bindingsHolder.bindings.push(value);
  }
  function operator(value, builder, client, bindingsHolder) {
    let raw = unwrapRaw$3(value, void 0, builder, client, bindingsHolder);
    if (raw) return raw;
    let operator$1 = operators[(value || ``).toLowerCase()];
    if (!operator$1) throw TypeError(`The operator "${value}" is not permitted`);
    return operator$1;
  }
  function wrapString$2(value, builder, client) {
    let asIndex = value.toLowerCase().indexOf(` as `);
    if (asIndex !== -1) {
      let first$1 = value.slice(0, asIndex), second = value.slice(asIndex + 4);
      return client.alias(wrapString$2(first$1, builder, client), wrapAsIdentifier$1(second, builder, client));
    }
    let wrapped = [], i$4 = -1, segments = value.split(`.`);
    for (; ++i$4 < segments.length; ) value = segments[i$4], i$4 === 0 && segments.length > 1 ? wrapped.push(wrapString$2((value || ``).trim(), builder, client)) : wrapped.push(wrapAsIdentifier$1(value, builder, client));
    return wrapped.join(`.`);
  }
  function parseObject(obj, builder, client, formatter) {
    let ret = [];
    for (let alias in obj) {
      let queryOrIdentifier = obj[alias];
      if (typeof queryOrIdentifier == `function`) {
        let compiled = compileCallback$4(queryOrIdentifier, void 0, client, formatter);
        compiled.as = alias, ret.push(outputQuery$3(compiled, true, builder, client));
      } else queryOrIdentifier instanceof QueryBuilder$13 ? ret.push(client.alias(`(${wrap(queryOrIdentifier, void 0, builder, client, formatter)})`, wrapAsIdentifier$1(alias, builder, client))) : ret.push(client.alias(wrap(queryOrIdentifier, void 0, builder, client, formatter), wrapAsIdentifier$1(alias, builder, client)));
    }
    return ret.join(`, `);
  }
  function outputQuery$3(compiled, isParameter, builder, client) {
    let sql = compiled.sql || ``;
    return sql && (compiled.method === `select` || compiled.method === `first`) && (isParameter || compiled.as) && (sql = `(${sql})`, compiled.as) ? client.alias(sql, wrapString$2(compiled.as, builder, client)) : sql;
  }
  function rawOrFn(value, method$1, builder, client, bindingHolder) {
    return typeof value == `function` ? outputQuery$3(compileCallback$4(value, method$1, client, bindingHolder), void 0, builder, client) : unwrapRaw$3(value, void 0, builder, client, bindingHolder) || ``;
  }
  function direction(value, builder, client, bindingsHolder) {
    let raw = unwrapRaw$3(value, void 0, builder, client, bindingsHolder);
    return raw || (orderBys.indexOf((value || ``).toLowerCase()) === -1 ? `asc` : value);
  }
  module2.exports = { columnize: columnize$1, direction, operator, outputQuery: outputQuery$3, rawOrFn, unwrapRaw: unwrapRaw$3, wrap, wrapString: wrapString$2 };
}), require_rawFormatter = __commonJSMin$1((exports$12, module2) => {
  let { columnize } = require_wrappingFormatter();
  function replaceRawArrBindings$1(raw, client) {
    let bindingsHolder = { bindings: [] }, builder = raw, expectedBindings = raw.bindings.length, values$3 = raw.bindings, index$2 = 0, sql = raw.sql.replace(/\\?\?\??/g, function(match$2) {
      if (match$2 === `\\?`) return match$2;
      let value = values$3[index$2++];
      return match$2 === `??` ? columnize(value, builder, client, bindingsHolder) : client.parameter(value, builder, bindingsHolder);
    });
    if (expectedBindings !== index$2) throw Error(`Expected ${expectedBindings} bindings, saw ${index$2}`);
    return { method: `raw`, sql, bindings: bindingsHolder.bindings };
  }
  function replaceKeyBindings$1(raw, client) {
    let bindingsHolder = { bindings: [] }, builder = raw, values$3 = raw.bindings, regex = /\\?(:(\w+):(?=::)|:(\w+):(?!:)|:(\w+))/g, sql = raw.sql.replace(regex, function(match$2, p1, p2, p3, p4) {
      if (match$2 !== p1) return p1;
      let part = p2 || p3 || p4, key = match$2.trim(), isIdentifier = key[key.length - 1] === `:`, value = values$3[part];
      return value === void 0 ? (Object.prototype.hasOwnProperty.call(values$3, part) && bindingsHolder.bindings.push(value), match$2) : isIdentifier ? match$2.replace(p1, columnize(value, builder, client, bindingsHolder)) : match$2.replace(p1, client.parameter(value, builder, bindingsHolder));
    });
    return { method: `raw`, sql, bindings: bindingsHolder.bindings };
  }
  module2.exports = { replaceKeyBindings: replaceKeyBindings$1, replaceRawArrBindings: replaceRawArrBindings$1 };
}), require_nanoid = __commonJSMin$1((exports$12, module2) => {
  let urlAlphabet = `ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW`, numberAlphabet = `0123456789`;
  function nanoid$2(size = 21) {
    let id = ``, i$4 = size;
    for (; i$4--; ) id += urlAlphabet[Math.random() * 64 | 0];
    return id;
  }
  function nanonum$1(size = 21) {
    let id = ``, i$4 = size;
    for (; i$4--; ) id += numberAlphabet[Math.random() * 10 | 0];
    return id;
  }
  module2.exports = { nanoid: nanoid$2, nanonum: nanonum$1 };
}), require_raw = __commonJSMin$1((exports$12, module2) => {
  let { EventEmitter: EventEmitter$5 } = require_events(), debug$12 = require_src(), assign$5 = require_assign(), isPlainObject$6 = require_isPlainObject(), reduce$4 = require_reduce(), { replaceRawArrBindings, replaceKeyBindings } = require_rawFormatter(), helpers$7 = require_helpers$1(), saveAsyncStack$1 = require_save_async_stack(), { nanoid: nanoid$1 } = require_nanoid(), { isNumber: isNumber$22, isObject: isObject$12 } = require_is(), { augmentWithBuilderInterface: augmentWithBuilderInterface$1 } = require_builder_interface_augmenter(), debugBindings$1 = debug$12(`knex:bindings`);
  var Raw$7 = class extends EventEmitter$5 {
    constructor(client) {
      super(), this.client = client, this.sql = ``, this.bindings = [], this._wrappedBefore = void 0, this._wrappedAfter = void 0, client && client.config && (this._debug = client.config.debug, saveAsyncStack$1(this, 4));
    }
    set(sql, bindings) {
      return this.sql = sql, this.bindings = isObject$12(bindings) && !bindings.toSQL || bindings === void 0 ? bindings : [bindings], this;
    }
    timeout(ms, { cancel } = {}) {
      return isNumber$22(ms) && ms > 0 && (this._timeout = ms, cancel && (this.client.assertCanCancelQuery(), this._cancelOnTimeout = true)), this;
    }
    wrap(before, after) {
      return this._wrappedBefore = before, this._wrappedAfter = after, this;
    }
    toString() {
      return this.toQuery();
    }
    toSQL(method$1, tz) {
      let obj;
      if (obj = Array.isArray(this.bindings) ? replaceRawArrBindings(this, this.client) : this.bindings && isPlainObject$6(this.bindings) ? replaceKeyBindings(this, this.client) : { method: `raw`, sql: this.sql, bindings: this.bindings === void 0 ? [] : [this.bindings] }, this._wrappedBefore && (obj.sql = this._wrappedBefore + obj.sql), this._wrappedAfter && (obj.sql += this._wrappedAfter), obj.options = reduce$4(this._options, assign$5, {}), this._timeout && (obj.timeout = this._timeout, this._cancelOnTimeout && (obj.cancelOnTimeout = this._cancelOnTimeout)), obj.bindings = obj.bindings || [], helpers$7.containsUndefined(obj.bindings)) {
        let undefinedBindingIndices = helpers$7.getUndefinedIndices(this.bindings);
        throw debugBindings$1(obj.bindings), Error(`Undefined binding(s) detected for keys [${undefinedBindingIndices}] when compiling RAW query: ${obj.sql}`);
      }
      return obj.__knexQueryUid = nanoid$1(), Object.defineProperties(obj, { toNative: { value: () => ({ sql: this.client.positionBindings(obj.sql), bindings: this.client.prepBindings(obj.bindings) }), enumerable: false } }), obj;
    }
  };
  Raw$7.prototype.isRawInstance = true, augmentWithBuilderInterface$1(Raw$7), helpers$7.addQueryContext(Raw$7), module2.exports = Raw$7;
}), require_ref = __commonJSMin$1((exports$12, module2) => {
  let Raw$6 = require_raw();
  var Ref$3 = class extends Raw$6 {
    constructor(client, ref) {
      super(client), this.ref = ref, this._schema = null, this._alias = null;
    }
    withSchema(schema$2) {
      return this._schema = schema$2, this;
    }
    as(alias) {
      return this._alias = alias, this;
    }
    toSQL() {
      let string = this._schema ? `${this._schema}.${this.ref}` : this.ref, formatter = this.client.formatter(this), ref = formatter.columnize(string), sql = this._alias ? `${ref} as ${formatter.wrap(this._alias)}` : ref;
      return this.set(sql, []), super.toSQL(...arguments);
    }
  };
  module2.exports = Ref$3;
}), require_string = __commonJSMin$1((exports$12, module2) => {
  init_dist$1();
  let charsRegex = /[\0\b\t\n\r\x1a"'\\]/g, charsMap = { "\0": `\\0`, "\b": `\\b`, "	": `\\t`, "\n": `\\n`, "\r": `\\r`, "": `\\Z`, '"': `\\"`, "'": `\\'`, "\\": `\\\\` };
  function wrapEscape(escapeFn) {
    return function finalEscape(val, ctx = {}) {
      return escapeFn(val, finalEscape, ctx);
    };
  }
  function makeEscape$4(config = {}) {
    let finalEscapeDate = config.escapeDate || dateToString, finalEscapeArray = config.escapeArray || arrayToList, finalEscapeBuffer = config.escapeBuffer || bufferToString, finalEscapeString = config.escapeString || escapeString, finalEscapeObject = config.escapeObject || escapeObject, finalWrap = config.wrap || wrapEscape;
    function escapeFn(val, finalEscape, ctx) {
      if (val == null) return `NULL`;
      switch (typeof val) {
        case `boolean`:
          return val ? `true` : `false`;
        case `number`:
          return val + ``;
        case `object`:
          if (val instanceof Date) val = finalEscapeDate(val, finalEscape, ctx);
          else if (Array.isArray(val)) return finalEscapeArray(val, finalEscape, ctx);
          else if (Buffer$1.isBuffer(val)) return finalEscapeBuffer(val, finalEscape, ctx);
          else return finalEscapeObject(val, finalEscape, ctx);
      }
      return finalEscapeString(val, finalEscape, ctx);
    }
    return finalWrap ? finalWrap(escapeFn) : escapeFn;
  }
  function escapeObject(val, finalEscape, ctx) {
    return val && typeof val.toSQL == `function` ? val.toSQL(ctx) : JSON.stringify(val);
  }
  function arrayToList(array, finalEscape, ctx) {
    let sql = ``;
    for (let i$4 = 0; i$4 < array.length; i$4++) {
      let val = array[i$4];
      Array.isArray(val) ? sql += (i$4 === 0 ? `` : `, `) + `(` + arrayToList(val, finalEscape, ctx) + `)` : sql += (i$4 === 0 ? `` : `, `) + finalEscape(val, ctx);
    }
    return sql;
  }
  function bufferToString(buffer$3) {
    return `X` + escapeString(buffer$3.toString(`hex`));
  }
  function escapeString(val, finalEscape, ctx) {
    let chunkIndex = charsRegex.lastIndex = 0, escapedVal = ``, match$2;
    for (; match$2 = charsRegex.exec(val); ) escapedVal += val.slice(chunkIndex, match$2.index) + charsMap[match$2[0]], chunkIndex = charsRegex.lastIndex;
    return chunkIndex === 0 ? `'` + val + `'` : chunkIndex < val.length ? `'` + escapedVal + val.slice(chunkIndex) + `'` : `'` + escapedVal + `'`;
  }
  function dateToString(date, finalEscape, ctx = {}) {
    let timeZone = ctx.timeZone || `local`, dt = new Date(date), year, month, day, hour, minute, second, millisecond;
    if (timeZone === `local`) year = dt.getFullYear(), month = dt.getMonth() + 1, day = dt.getDate(), hour = dt.getHours(), minute = dt.getMinutes(), second = dt.getSeconds(), millisecond = dt.getMilliseconds();
    else {
      let tz = convertTimezone(timeZone);
      tz !== false && tz !== 0 && dt.setTime(dt.getTime() + tz * 6e4), year = dt.getUTCFullYear(), month = dt.getUTCMonth() + 1, day = dt.getUTCDate(), hour = dt.getUTCHours(), minute = dt.getUTCMinutes(), second = dt.getUTCSeconds(), millisecond = dt.getUTCMilliseconds();
    }
    return zeroPad(year, 4) + `-` + zeroPad(month, 2) + `-` + zeroPad(day, 2) + ` ` + zeroPad(hour, 2) + `:` + zeroPad(minute, 2) + `:` + zeroPad(second, 2) + `.` + zeroPad(millisecond, 3);
  }
  function zeroPad(number, length) {
    for (number = number.toString(); number.length < length; ) number = `0` + number;
    return number;
  }
  function convertTimezone(tz) {
    if (tz === `Z`) return 0;
    let m$3 = tz.match(/([+\-\s])(\d\d):?(\d\d)?/);
    return m$3 ? (m$3[1] == `-` ? -1 : 1) * (parseInt(m$3[2], 10) + (m$3[3] ? parseInt(m$3[3], 10) : 0) / 60) * 60 : false;
  }
  module2.exports = { arrayToList, bufferToString, dateToString, escapeString, charsRegex, charsMap, escapeObject, makeEscape: makeEscape$4 };
});
function isString$13(value) {
  return typeof value == `string`;
}
function isFunction$2(value) {
  return typeof value == `function`;
}
function resolveIsEnabledColors$1(enableColorsParam) {
  return enableColorsParam === null ? process$1 && process$1.stdout ? process$1.stdout.isTTY : false : enableColorsParam;
}
var Logger$2, logger_default, init_logger$1 = __esmMin(() => {
  init_dist(), Logger$2 = class {
    _inspectionDepth = 5;
    _enableColors = false;
    _debug = () => {
    };
    _warn = () => {
    };
    _error = () => {
    };
    _deprecate = () => {
    };
    constructor(config = {}) {
      let { log: { debug: debug$13, warn, error, deprecate, inspectionDepth, enableColors } = {} } = config;
      this._inspectionDepth = inspectionDepth || 5, this._enableColors = resolveIsEnabledColors$1(enableColors) || false, this._debug = debug$13, this._warn = warn, this._error = error, this._deprecate = deprecate;
    }
    _log(message, userFn, colorFn) {
      if (userFn !== null && !isFunction$2(userFn)) throw TypeError(`Extensions to knex logger must be functions!`);
      if (isFunction$2(userFn)) {
        userFn(message);
        return;
      }
      isString$13(message) || (message = message.toString()), console.log(colorFn ? colorFn(message) : message);
    }
    debug(message) {
      this._log(message, this._debug);
    }
    warn(message) {
      this._log(message, this._warn);
    }
    error(message) {
      this._log(message, this._error);
    }
    deprecate(method$1, alternative) {
      let message = `${method$1} is deprecated, please use ${alternative}`;
      this._log(message, this._deprecate);
    }
  }, logger_default = Logger$2;
}), require_uniqueId = __commonJSMin$1((exports$12, module2) => {
  var toString$1 = require_toString(), idCounter = 0;
  function uniqueId$3(prefix) {
    var id = ++idCounter;
    return toString$1(prefix) + id;
  }
  module2.exports = uniqueId$3;
}), require_cloneDeep = __commonJSMin$1((exports$12, module2) => {
  var baseClone = require__baseClone(), CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
  function cloneDeep$2(value) {
    return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
  }
  module2.exports = cloneDeep$2;
}), require_timeout = __commonJSMin$1((exports$12, module2) => {
  var KnexTimeoutError$6 = class extends Error {
    constructor(message) {
      super(message), this.name = `KnexTimeoutError`;
    }
  };
  function timeout$3(promise, ms) {
    return new Promise(function(resolve, reject$2) {
      let id = setTimeout(function() {
        reject$2(new KnexTimeoutError$6(`operation timed out`));
      }, ms);
      function wrappedResolve(value) {
        clearTimeout(id), resolve(value);
      }
      function wrappedReject(err$1) {
        clearTimeout(id), reject$2(err$1);
      }
      promise.then(wrappedResolve, wrappedReject);
    });
  }
  module2.exports.KnexTimeoutError = KnexTimeoutError$6, module2.exports.timeout = timeout$3;
}), require_formatter = __commonJSMin$1((exports$12, module2) => {
  let { columnize: columnize_$11, wrap: wrap_$4 } = require_wrappingFormatter();
  var Formatter$7 = class {
    constructor(client, builder) {
      this.client = client, this.builder = builder, this.bindings = [];
    }
    columnize(target) {
      return columnize_$11(target, this.builder, this.client, this);
    }
    wrap(value, isParameter) {
      return wrap_$4(value, isParameter, this.builder, this.client, this);
    }
  };
  module2.exports = Formatter$7;
}), require_security = __commonJSMin$1((exports$12, module2) => {
  function setHiddenProperty$4(target, source, propertyName = `password`) {
    source ||= target, Object.defineProperty(target, propertyName, { enumerable: false, value: source[propertyName] });
  }
  module2.exports = { setHiddenProperty: setHiddenProperty$4 };
}), require_ensure_connection_callback = __commonJSMin$1((exports$12, module2) => {
  function ensureConnectionCallback$1(runner) {
    runner.client.emit(`start`, runner.builder), runner.builder.emit(`start`, runner.builder);
    let sql = runner.builder.toSQL();
    return runner.builder._debug && runner.client.logger.debug(sql), Array.isArray(sql) ? runner.queryArray(sql) : runner.query(sql);
  }
  function ensureConnectionStreamCallback$1(runner, params) {
    try {
      let sql = runner.builder.toSQL();
      if (Array.isArray(sql) && params.hasHandler) throw Error(`The stream may only be used with a single query statement.`);
      return runner.client.stream(runner.connection, sql, params.stream, params.options);
    } catch (e$22) {
      throw params.stream.emit(`error`, e$22), e$22;
    }
  }
  module2.exports = { ensureConnectionCallback: ensureConnectionCallback$1, ensureConnectionStreamCallback: ensureConnectionStreamCallback$1 };
}), require_stream = __commonJSMin$1((exports$12, module2) => {
  module2.exports = require_stream_browserify();
}), require_buffer_list = __commonJSMin$1((exports$12, module2) => {
  function ownKeys$1(object, enumerableOnly) {
    var keys$10 = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys$10.push.apply(keys$10, symbols);
    }
    return keys$10;
  }
  function _objectSpread$1(target) {
    for (var i$4 = 1; i$4 < arguments.length; i$4++) {
      var source = arguments[i$4] == null ? {} : arguments[i$4];
      i$4 % 2 ? ownKeys$1(Object(source), true).forEach(function(key) {
        _defineProperty$2(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty$2(obj, key, value) {
    return key = _toPropertyKey$2(key), key in obj ? Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true }) : obj[key] = value, obj;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw TypeError(`Cannot call a class as a function`);
  }
  function _defineProperties(target, props) {
    for (var i$4 = 0; i$4 < props.length; i$4++) {
      var descriptor = props[i$4];
      descriptor.enumerable = descriptor.enumerable || false, descriptor.configurable = true, `value` in descriptor && (descriptor.writable = true), Object.defineProperty(target, _toPropertyKey$2(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    return protoProps && _defineProperties(Constructor.prototype, protoProps), Object.defineProperty(Constructor, `prototype`, { writable: false }), Constructor;
  }
  function _toPropertyKey$2(arg) {
    var key = _toPrimitive$2(arg, `string`);
    return typeof key == `symbol` ? key : String(key);
  }
  function _toPrimitive$2(input, hint) {
    if (typeof input != `object` || !input) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint);
      if (typeof res != `object`) return res;
      throw TypeError(`@@toPrimitive must return a primitive value.`);
    }
    return String(input);
  }
  var _require$2 = (init_dist$1(), __toCommonJS(dist_exports)), Buffer$24 = _require$2.Buffer, _require2 = require_util(), inspect = _require2.inspect, custom = inspect && inspect.custom || `inspect`;
  function copyBuffer(src$1, target, offset$2) {
    Buffer$24.prototype.copy.call(src$1, target, offset$2);
  }
  module2.exports = (function() {
    function BufferList$1() {
      _classCallCheck(this, BufferList$1), this.head = null, this.tail = null, this.length = 0;
    }
    return _createClass(BufferList$1, [{ key: `push`, value: function(v$1) {
      var entry = { data: v$1, next: null };
      this.length > 0 ? this.tail.next = entry : this.head = entry, this.tail = entry, ++this.length;
    } }, { key: `unshift`, value: function(v$1) {
      var entry = { data: v$1, next: this.head };
      this.length === 0 && (this.tail = entry), this.head = entry, ++this.length;
    } }, { key: `shift`, value: function() {
      if (this.length !== 0) {
        var ret = this.head.data;
        return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, ret;
      }
    } }, { key: `clear`, value: function() {
      this.head = this.tail = null, this.length = 0;
    } }, { key: `join`, value: function(s$6) {
      if (this.length === 0) return ``;
      for (var p$1 = this.head, ret = `` + p$1.data; p$1 = p$1.next; ) ret += s$6 + p$1.data;
      return ret;
    } }, { key: `concat`, value: function(n$4) {
      if (this.length === 0) return Buffer$24.alloc(0);
      for (var ret = Buffer$24.allocUnsafe(n$4 >>> 0), p$1 = this.head, i$4 = 0; p$1; ) copyBuffer(p$1.data, ret, i$4), i$4 += p$1.data.length, p$1 = p$1.next;
      return ret;
    } }, { key: `consume`, value: function(n$4, hasStrings) {
      var ret;
      return n$4 < this.head.data.length ? (ret = this.head.data.slice(0, n$4), this.head.data = this.head.data.slice(n$4)) : ret = n$4 === this.head.data.length ? this.shift() : hasStrings ? this._getString(n$4) : this._getBuffer(n$4), ret;
    } }, { key: `first`, value: function() {
      return this.head.data;
    } }, { key: `_getString`, value: function(n$4) {
      var p$1 = this.head, c$12 = 1, ret = p$1.data;
      for (n$4 -= ret.length; p$1 = p$1.next; ) {
        var str = p$1.data, nb = n$4 > str.length ? str.length : n$4;
        if (nb === str.length ? ret += str : ret += str.slice(0, n$4), n$4 -= nb, n$4 === 0) {
          nb === str.length ? (++c$12, p$1.next ? this.head = p$1.next : this.head = this.tail = null) : (this.head = p$1, p$1.data = str.slice(nb));
          break;
        }
        ++c$12;
      }
      return this.length -= c$12, ret;
    } }, { key: `_getBuffer`, value: function(n$4) {
      var ret = Buffer$24.allocUnsafe(n$4), p$1 = this.head, c$12 = 1;
      for (p$1.data.copy(ret), n$4 -= p$1.data.length; p$1 = p$1.next; ) {
        var buf = p$1.data, nb = n$4 > buf.length ? buf.length : n$4;
        if (buf.copy(ret, ret.length - n$4, 0, nb), n$4 -= nb, n$4 === 0) {
          nb === buf.length ? (++c$12, p$1.next ? this.head = p$1.next : this.head = this.tail = null) : (this.head = p$1, p$1.data = buf.slice(nb));
          break;
        }
        ++c$12;
      }
      return this.length -= c$12, ret;
    } }, { key: custom, value: function(_, options) {
      return inspect(this, _objectSpread$1(_objectSpread$1({}, options), {}, { depth: 0, customInspect: false }));
    } }]), BufferList$1;
  })();
}), require_destroy = __commonJSMin$1((exports$12, module2) => {
  init_dist();
  function destroy(err$1, cb) {
    var _this = this, readableDestroyed = this._readableState && this._readableState.destroyed, writableDestroyed = this._writableState && this._writableState.destroyed;
    return readableDestroyed || writableDestroyed ? (cb ? cb(err$1) : err$1 && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = true, process$1.nextTick(emitErrorNT, this, err$1)) : process$1.nextTick(emitErrorNT, this, err$1)), this) : (this._readableState && (this._readableState.destroyed = true), this._writableState && (this._writableState.destroyed = true), this._destroy(err$1 || null, function(err$2) {
      !cb && err$2 ? _this._writableState ? _this._writableState.errorEmitted ? process$1.nextTick(emitCloseNT, _this) : (_this._writableState.errorEmitted = true, process$1.nextTick(emitErrorAndCloseNT, _this, err$2)) : process$1.nextTick(emitErrorAndCloseNT, _this, err$2) : cb ? (process$1.nextTick(emitCloseNT, _this), cb(err$2)) : process$1.nextTick(emitCloseNT, _this);
    }), this);
  }
  function emitErrorAndCloseNT(self$1, err$1) {
    emitErrorNT(self$1, err$1), emitCloseNT(self$1);
  }
  function emitCloseNT(self$1) {
    self$1._writableState && !self$1._writableState.emitClose || self$1._readableState && !self$1._readableState.emitClose || self$1.emit(`close`);
  }
  function undestroy() {
    this._readableState && (this._readableState.destroyed = false, this._readableState.reading = false, this._readableState.ended = false, this._readableState.endEmitted = false), this._writableState && (this._writableState.destroyed = false, this._writableState.ended = false, this._writableState.ending = false, this._writableState.finalCalled = false, this._writableState.prefinished = false, this._writableState.finished = false, this._writableState.errorEmitted = false);
  }
  function emitErrorNT(self$1, err$1) {
    self$1.emit(`error`, err$1);
  }
  function errorOrDestroy$2(stream$1, err$1) {
    var rState = stream$1._readableState, wState = stream$1._writableState;
    rState && rState.autoDestroy || wState && wState.autoDestroy ? stream$1.destroy(err$1) : stream$1.emit(`error`, err$1);
  }
  module2.exports = { destroy, undestroy, errorOrDestroy: errorOrDestroy$2 };
}), require_errors = __commonJSMin$1((exports$12, module2) => {
  let codes = {};
  function createErrorType(code$2, message, Base$4) {
    Base$4 ||= Error;
    function getMessage(arg1, arg2, arg3) {
      return typeof message == `string` ? message : message(arg1, arg2, arg3);
    }
    class NodeError extends Base$4 {
      constructor(arg1, arg2, arg3) {
        super(getMessage(arg1, arg2, arg3));
      }
    }
    NodeError.prototype.name = Base$4.name, NodeError.prototype.code = code$2, codes[code$2] = NodeError;
  }
  function oneOf$2(expected, thing) {
    if (Array.isArray(expected)) {
      let len$2 = expected.length;
      return expected = expected.map((i$4) => String(i$4)), len$2 > 2 ? `one of ${thing} ${expected.slice(0, len$2 - 1).join(`, `)}, or ` + expected[len$2 - 1] : len$2 === 2 ? `one of ${thing} ${expected[0]} or ${expected[1]}` : `of ${thing} ${expected[0]}`;
    } else return `of ${thing} ${String(expected)}`;
  }
  function startsWith(str, search, pos) {
    return str.substr(0, search.length) === search;
  }
  function endsWith(str, search, this_len) {
    return (this_len === void 0 || this_len > str.length) && (this_len = str.length), str.substring(this_len - search.length, this_len) === search;
  }
  function includes(str, search, start) {
    return typeof start != `number` && (start = 0), start + search.length > str.length ? false : str.indexOf(search, start) !== -1;
  }
  createErrorType(`ERR_INVALID_OPT_VALUE`, function(name$2, value) {
    return `The value "` + value + `" is invalid for option "` + name$2 + `"`;
  }, TypeError), createErrorType(`ERR_INVALID_ARG_TYPE`, function(name$2, expected, actual) {
    let determiner;
    typeof expected == `string` && startsWith(expected, `not `) ? (determiner = `must not be`, expected = expected.replace(/^not /, ``)) : determiner = `must be`;
    let msg;
    if (endsWith(name$2, ` argument`)) msg = `The ${name$2} ${determiner} ${oneOf$2(expected, `type`)}`;
    else {
      let type = includes(name$2, `.`) ? `property` : `argument`;
      msg = `The "${name$2}" ${type} ${determiner} ${oneOf$2(expected, `type`)}`;
    }
    return msg += `. Received type ${typeof actual}`, msg;
  }, TypeError), createErrorType(`ERR_STREAM_PUSH_AFTER_EOF`, `stream.push() after EOF`), createErrorType(`ERR_METHOD_NOT_IMPLEMENTED`, function(name$2) {
    return `The ` + name$2 + ` method is not implemented`;
  }), createErrorType(`ERR_STREAM_PREMATURE_CLOSE`, `Premature close`), createErrorType(`ERR_STREAM_DESTROYED`, function(name$2) {
    return `Cannot call ` + name$2 + ` after a stream was destroyed`;
  }), createErrorType(`ERR_MULTIPLE_CALLBACK`, `Callback called multiple times`), createErrorType(`ERR_STREAM_CANNOT_PIPE`, `Cannot pipe, not readable`), createErrorType(`ERR_STREAM_WRITE_AFTER_END`, `write after end`), createErrorType(`ERR_STREAM_NULL_VALUES`, `May not write null values to stream`, TypeError), createErrorType(`ERR_UNKNOWN_ENCODING`, function(arg) {
    return `Unknown encoding: ` + arg;
  }, TypeError), createErrorType(`ERR_STREAM_UNSHIFT_AFTER_END_EVENT`, `stream.unshift() after end event`), module2.exports.codes = codes;
}), require_state = __commonJSMin$1((exports$12, module2) => {
  var ERR_INVALID_OPT_VALUE = require_errors().codes.ERR_INVALID_OPT_VALUE;
  function highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark == null ? isDuplex ? options[duplexKey] : null : options.highWaterMark;
  }
  function getHighWaterMark$2(state, options, duplexKey, isDuplex) {
    var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
      if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
        var name$2 = isDuplex ? duplexKey : `highWaterMark`;
        throw new ERR_INVALID_OPT_VALUE(name$2, hwm);
      }
      return Math.floor(hwm);
    }
    return state.objectMode ? 16 : 16 * 1024;
  }
  module2.exports = { getHighWaterMark: getHighWaterMark$2 };
}), require_node$1 = __commonJSMin$1((exports$12, module2) => {
  module2.exports = require_util().deprecate;
}), require__stream_writable = __commonJSMin$1((exports$12, module2) => {
  init_dist(), module2.exports = Writable$1;
  function CorkedRequest(state) {
    var _this = this;
    this.next = null, this.entry = null, this.finish = function() {
      onCorkedFinish(_this, state);
    };
  }
  var Duplex$3;
  Writable$1.WritableState = WritableState;
  var internalUtil = { deprecate: require_node$1() }, Stream$2 = require_stream(), Buffer$23 = (init_dist$1(), __toCommonJS(dist_exports)).Buffer, OurUint8Array$1 = {}.Uint8Array || function() {
  };
  function _uint8ArrayToBuffer$1(chunk) {
    return Buffer$23.from(chunk);
  }
  function _isUint8Array$1(obj) {
    return Buffer$23.isBuffer(obj) || obj instanceof OurUint8Array$1;
  }
  var destroyImpl$1 = require_destroy(), _require$1 = require_state(), getHighWaterMark$1 = _require$1.getHighWaterMark, _require$codes$3 = require_errors().codes, ERR_INVALID_ARG_TYPE$2 = _require$codes$3.ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED$2 = _require$codes$3.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK$1 = _require$codes$3.ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE = _require$codes$3.ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED$1 = _require$codes$3.ERR_STREAM_DESTROYED, ERR_STREAM_NULL_VALUES = _require$codes$3.ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END = _require$codes$3.ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING = _require$codes$3.ERR_UNKNOWN_ENCODING, errorOrDestroy$1 = destroyImpl$1.errorOrDestroy;
  require_inherits()(Writable$1, Stream$2);
  function nop() {
  }
  function WritableState(options, stream$1, isDuplex) {
    Duplex$3 ||= require__stream_duplex(), options ||= {}, typeof isDuplex != `boolean` && (isDuplex = stream$1 instanceof Duplex$3), this.objectMode = !!options.objectMode, isDuplex && (this.objectMode = this.objectMode || !!options.writableObjectMode), this.highWaterMark = getHighWaterMark$1(this, options, `writableHighWaterMark`, isDuplex), this.finalCalled = false, this.needDrain = false, this.ending = false, this.ended = false, this.finished = false, this.destroyed = false;
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode, this.defaultEncoding = options.defaultEncoding || `utf8`, this.length = 0, this.writing = false, this.corked = 0, this.sync = true, this.bufferProcessing = false, this.onwrite = function(er) {
      onwrite(stream$1, er);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = false, this.errorEmitted = false, this.emitClose = options.emitClose !== false, this.autoDestroy = !!options.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new CorkedRequest(this);
  }
  WritableState.prototype.getBuffer = function() {
    for (var current = this.bufferedRequest, out = []; current; ) out.push(current), current = current.next;
    return out;
  }, (function() {
    try {
      Object.defineProperty(WritableState.prototype, `buffer`, { get: internalUtil.deprecate(function() {
        return this.getBuffer();
      }, `_writableState.buffer is deprecated. Use _writableState.getBuffer instead.`, `DEP0003`) });
    } catch {
    }
  })();
  var realHasInstance;
  typeof Symbol == `function` && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == `function` ? (realHasInstance = Function.prototype[Symbol.hasInstance], Object.defineProperty(Writable$1, Symbol.hasInstance, { value: function(object) {
    return realHasInstance.call(this, object) ? true : this === Writable$1 ? object && object._writableState instanceof WritableState : false;
  } })) : realHasInstance = function(object) {
    return object instanceof this;
  };
  function Writable$1(options) {
    Duplex$3 ||= require__stream_duplex();
    var isDuplex = this instanceof Duplex$3;
    if (!isDuplex && !realHasInstance.call(Writable$1, this)) return new Writable$1(options);
    this._writableState = new WritableState(options, this, isDuplex), this.writable = true, options && (typeof options.write == `function` && (this._write = options.write), typeof options.writev == `function` && (this._writev = options.writev), typeof options.destroy == `function` && (this._destroy = options.destroy), typeof options.final == `function` && (this._final = options.final)), Stream$2.call(this);
  }
  Writable$1.prototype.pipe = function() {
    errorOrDestroy$1(this, new ERR_STREAM_CANNOT_PIPE());
  };
  function writeAfterEnd(stream$1, cb) {
    var er = new ERR_STREAM_WRITE_AFTER_END();
    errorOrDestroy$1(stream$1, er), process$1.nextTick(cb, er);
  }
  function validChunk(stream$1, state, chunk, cb) {
    var er;
    return chunk === null ? er = new ERR_STREAM_NULL_VALUES() : typeof chunk != `string` && !state.objectMode && (er = new ERR_INVALID_ARG_TYPE$2(`chunk`, [`string`, `Buffer`], chunk)), er ? (errorOrDestroy$1(stream$1, er), process$1.nextTick(cb, er), false) : true;
  }
  Writable$1.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState, ret = false, isBuf = !state.objectMode && _isUint8Array$1(chunk);
    return isBuf && !Buffer$23.isBuffer(chunk) && (chunk = _uint8ArrayToBuffer$1(chunk)), typeof encoding == `function` && (cb = encoding, encoding = null), isBuf ? encoding = `buffer` : encoding ||= state.defaultEncoding, typeof cb != `function` && (cb = nop), state.ending ? writeAfterEnd(this, cb) : (isBuf || validChunk(this, state, chunk, cb)) && (state.pendingcb++, ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb)), ret;
  }, Writable$1.prototype.cork = function() {
    this._writableState.corked++;
  }, Writable$1.prototype.uncork = function() {
    var state = this._writableState;
    state.corked && (state.corked--, !state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest && clearBuffer(this, state));
  }, Writable$1.prototype.setDefaultEncoding = function(encoding) {
    if (typeof encoding == `string` && (encoding = encoding.toLowerCase()), !([`hex`, `utf8`, `utf-8`, `ascii`, `binary`, `base64`, `ucs2`, `ucs-2`, `utf16le`, `utf-16le`, `raw`].indexOf((encoding + ``).toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
    return this._writableState.defaultEncoding = encoding, this;
  }, Object.defineProperty(Writable$1.prototype, `writableBuffer`, { enumerable: false, get: function() {
    return this._writableState && this._writableState.getBuffer();
  } });
  function decodeChunk(state, chunk, encoding) {
    return !state.objectMode && state.decodeStrings !== false && typeof chunk == `string` && (chunk = Buffer$23.from(chunk, encoding)), chunk;
  }
  Object.defineProperty(Writable$1.prototype, `writableHighWaterMark`, { enumerable: false, get: function() {
    return this._writableState.highWaterMark;
  } });
  function writeOrBuffer(stream$1, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
      var newChunk = decodeChunk(state, chunk, encoding);
      chunk !== newChunk && (isBuf = true, encoding = `buffer`, chunk = newChunk);
    }
    var len$2 = state.objectMode ? 1 : chunk.length;
    state.length += len$2;
    var ret = state.length < state.highWaterMark;
    if (ret || (state.needDrain = true), state.writing || state.corked) {
      var last$2 = state.lastBufferedRequest;
      state.lastBufferedRequest = { chunk, encoding, isBuf, callback: cb, next: null }, last$2 ? last$2.next = state.lastBufferedRequest : state.bufferedRequest = state.lastBufferedRequest, state.bufferedRequestCount += 1;
    } else doWrite(stream$1, state, false, len$2, chunk, encoding, cb);
    return ret;
  }
  function doWrite(stream$1, state, writev, len$2, chunk, encoding, cb) {
    state.writelen = len$2, state.writecb = cb, state.writing = true, state.sync = true, state.destroyed ? state.onwrite(new ERR_STREAM_DESTROYED$1(`write`)) : writev ? stream$1._writev(chunk, state.onwrite) : stream$1._write(chunk, encoding, state.onwrite), state.sync = false;
  }
  function onwriteError(stream$1, state, sync$1, er, cb) {
    --state.pendingcb, sync$1 ? (process$1.nextTick(cb, er), process$1.nextTick(finishMaybe, stream$1, state), stream$1._writableState.errorEmitted = true, errorOrDestroy$1(stream$1, er)) : (cb(er), stream$1._writableState.errorEmitted = true, errorOrDestroy$1(stream$1, er), finishMaybe(stream$1, state));
  }
  function onwriteStateUpdate(state) {
    state.writing = false, state.writecb = null, state.length -= state.writelen, state.writelen = 0;
  }
  function onwrite(stream$1, er) {
    var state = stream$1._writableState, sync$1 = state.sync, cb = state.writecb;
    if (typeof cb != `function`) throw new ERR_MULTIPLE_CALLBACK$1();
    if (onwriteStateUpdate(state), er) onwriteError(stream$1, state, sync$1, er, cb);
    else {
      var finished$1 = needFinish(state) || stream$1.destroyed;
      !finished$1 && !state.corked && !state.bufferProcessing && state.bufferedRequest && clearBuffer(stream$1, state), sync$1 ? process$1.nextTick(afterWrite, stream$1, state, finished$1, cb) : afterWrite(stream$1, state, finished$1, cb);
    }
  }
  function afterWrite(stream$1, state, finished$1, cb) {
    finished$1 || onwriteDrain(stream$1, state), state.pendingcb--, cb(), finishMaybe(stream$1, state);
  }
  function onwriteDrain(stream$1, state) {
    state.length === 0 && state.needDrain && (state.needDrain = false, stream$1.emit(`drain`));
  }
  function clearBuffer(stream$1, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream$1._writev && entry && entry.next) {
      var l$4 = state.bufferedRequestCount, buffer$3 = Array(l$4), holder = state.corkedRequestsFree;
      holder.entry = entry;
      for (var count = 0, allBuffers = true; entry; ) buffer$3[count] = entry, entry.isBuf || (allBuffers = false), entry = entry.next, count += 1;
      buffer$3.allBuffers = allBuffers, doWrite(stream$1, state, true, state.length, buffer$3, ``, holder.finish), state.pendingcb++, state.lastBufferedRequest = null, holder.next ? (state.corkedRequestsFree = holder.next, holder.next = null) : state.corkedRequestsFree = new CorkedRequest(state), state.bufferedRequestCount = 0;
    } else {
      for (; entry; ) {
        var chunk = entry.chunk, encoding = entry.encoding, cb = entry.callback, len$2 = state.objectMode ? 1 : chunk.length;
        if (doWrite(stream$1, state, false, len$2, chunk, encoding, cb), entry = entry.next, state.bufferedRequestCount--, state.writing) break;
      }
      entry === null && (state.lastBufferedRequest = null);
    }
    state.bufferedRequest = entry, state.bufferProcessing = false;
  }
  Writable$1.prototype._write = function(chunk, encoding, cb) {
    cb(new ERR_METHOD_NOT_IMPLEMENTED$2(`_write()`));
  }, Writable$1.prototype._writev = null, Writable$1.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    return typeof chunk == `function` ? (cb = chunk, chunk = null, encoding = null) : typeof encoding == `function` && (cb = encoding, encoding = null), chunk != null && this.write(chunk, encoding), state.corked && (state.corked = 1, this.uncork()), state.ending || endWritable(this, state, cb), this;
  }, Object.defineProperty(Writable$1.prototype, `writableLength`, { enumerable: false, get: function() {
    return this._writableState.length;
  } });
  function needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
  }
  function callFinal(stream$1, state) {
    stream$1._final(function(err$1) {
      state.pendingcb--, err$1 && errorOrDestroy$1(stream$1, err$1), state.prefinished = true, stream$1.emit(`prefinish`), finishMaybe(stream$1, state);
    });
  }
  function prefinish$1(stream$1, state) {
    !state.prefinished && !state.finalCalled && (typeof stream$1._final == `function` && !state.destroyed ? (state.pendingcb++, state.finalCalled = true, process$1.nextTick(callFinal, stream$1, state)) : (state.prefinished = true, stream$1.emit(`prefinish`)));
  }
  function finishMaybe(stream$1, state) {
    var need = needFinish(state);
    if (need && (prefinish$1(stream$1, state), state.pendingcb === 0 && (state.finished = true, stream$1.emit(`finish`), state.autoDestroy))) {
      var rState = stream$1._readableState;
      (!rState || rState.autoDestroy && rState.endEmitted) && stream$1.destroy();
    }
    return need;
  }
  function endWritable(stream$1, state, cb) {
    state.ending = true, finishMaybe(stream$1, state), cb && (state.finished ? process$1.nextTick(cb) : stream$1.once(`finish`, cb)), state.ended = true, stream$1.writable = false;
  }
  function onCorkedFinish(corkReq, state, err$1) {
    var entry = corkReq.entry;
    for (corkReq.entry = null; entry; ) {
      var cb = entry.callback;
      state.pendingcb--, cb(err$1), entry = entry.next;
    }
    state.corkedRequestsFree.next = corkReq;
  }
  Object.defineProperty(Writable$1.prototype, `destroyed`, { enumerable: false, get: function() {
    return this._writableState === void 0 ? false : this._writableState.destroyed;
  }, set: function(value) {
    this._writableState && (this._writableState.destroyed = value);
  } }), Writable$1.prototype.destroy = destroyImpl$1.destroy, Writable$1.prototype._undestroy = destroyImpl$1.undestroy, Writable$1.prototype._destroy = function(err$1, cb) {
    cb(err$1);
  };
}), require__stream_duplex = __commonJSMin$1((exports$12, module2) => {
  init_dist();
  var objectKeys = Object.keys || function(obj) {
    var keys$10 = [];
    for (var key in obj) keys$10.push(key);
    return keys$10;
  };
  module2.exports = Duplex$2;
  var Readable$1 = require__stream_readable(), Writable = require__stream_writable();
  require_inherits()(Duplex$2, Readable$1);
  for (var keys = objectKeys(Writable.prototype), v = 0; v < keys.length; v++) {
    var method = keys[v];
    Duplex$2.prototype[method] || (Duplex$2.prototype[method] = Writable.prototype[method]);
  }
  function Duplex$2(options) {
    if (!(this instanceof Duplex$2)) return new Duplex$2(options);
    Readable$1.call(this, options), Writable.call(this, options), this.allowHalfOpen = true, options && (options.readable === false && (this.readable = false), options.writable === false && (this.writable = false), options.allowHalfOpen === false && (this.allowHalfOpen = false, this.once(`end`, onend)));
  }
  Object.defineProperty(Duplex$2.prototype, `writableHighWaterMark`, { enumerable: false, get: function() {
    return this._writableState.highWaterMark;
  } }), Object.defineProperty(Duplex$2.prototype, `writableBuffer`, { enumerable: false, get: function() {
    return this._writableState && this._writableState.getBuffer();
  } }), Object.defineProperty(Duplex$2.prototype, `writableLength`, { enumerable: false, get: function() {
    return this._writableState.length;
  } });
  function onend() {
    this._writableState.ended || process$1.nextTick(onEndNT, this);
  }
  function onEndNT(self$1) {
    self$1.end();
  }
  Object.defineProperty(Duplex$2.prototype, `destroyed`, { enumerable: false, get: function() {
    return this._readableState === void 0 || this._writableState === void 0 ? false : this._readableState.destroyed && this._writableState.destroyed;
  }, set: function(value) {
    this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = value, this._writableState.destroyed = value);
  } });
}), require_safe_buffer = __commonJSMin$1((exports$12, module2) => {
  var buffer$1 = (init_dist$1(), __toCommonJS(dist_exports)), Buffer$22 = buffer$1.Buffer;
  function copyProps(src$1, dst) {
    for (var key in src$1) dst[key] = src$1[key];
  }
  Buffer$22.from && Buffer$22.alloc && Buffer$22.allocUnsafe && Buffer$22.allocUnsafeSlow ? module2.exports = buffer$1 : (copyProps(buffer$1, exports$12), exports$12.Buffer = SafeBuffer);
  function SafeBuffer(arg, encodingOrOffset, length) {
    return Buffer$22(arg, encodingOrOffset, length);
  }
  SafeBuffer.prototype = Object.create(Buffer$22.prototype), copyProps(Buffer$22, SafeBuffer), SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg == `number`) throw TypeError(`Argument must not be a number`);
    return Buffer$22(arg, encodingOrOffset, length);
  }, SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size != `number`) throw TypeError(`Argument must be a number`);
    var buf = Buffer$22(size);
    return fill === void 0 ? buf.fill(0) : typeof encoding == `string` ? buf.fill(fill, encoding) : buf.fill(fill), buf;
  }, SafeBuffer.allocUnsafe = function(size) {
    if (typeof size != `number`) throw TypeError(`Argument must be a number`);
    return Buffer$22(size);
  }, SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size != `number`) throw TypeError(`Argument must be a number`);
    return buffer$1.SlowBuffer(size);
  };
}), require_string_decoder = __commonJSMin$1((exports$12) => {
  var Buffer$21 = require_safe_buffer().Buffer, isEncoding = Buffer$21.isEncoding || function(encoding) {
    switch (encoding = `` + encoding, encoding && encoding.toLowerCase()) {
      case `hex`:
      case `utf8`:
      case `utf-8`:
      case `ascii`:
      case `binary`:
      case `base64`:
      case `ucs2`:
      case `ucs-2`:
      case `utf16le`:
      case `utf-16le`:
      case `raw`:
        return true;
      default:
        return false;
    }
  };
  function _normalizeEncoding(enc) {
    if (!enc) return `utf8`;
    for (var retried; ; ) switch (enc) {
      case `utf8`:
      case `utf-8`:
        return `utf8`;
      case `ucs2`:
      case `ucs-2`:
      case `utf16le`:
      case `utf-16le`:
        return `utf16le`;
      case `latin1`:
      case `binary`:
        return `latin1`;
      case `base64`:
      case `ascii`:
      case `hex`:
        return enc;
      default:
        if (retried) return;
        enc = (`` + enc).toLowerCase(), retried = true;
    }
  }
  function normalizeEncoding(enc) {
    var nenc = _normalizeEncoding(enc);
    if (typeof nenc != `string` && (Buffer$21.isEncoding === isEncoding || !isEncoding(enc))) throw Error(`Unknown encoding: ` + enc);
    return nenc || enc;
  }
  exports$12.StringDecoder = StringDecoder$1;
  function StringDecoder$1(encoding) {
    this.encoding = normalizeEncoding(encoding);
    var nb;
    switch (this.encoding) {
      case `utf16le`:
        this.text = utf16Text, this.end = utf16End, nb = 4;
        break;
      case `utf8`:
        this.fillLast = utf8FillLast, nb = 4;
        break;
      case `base64`:
        this.text = base64Text, this.end = base64End, nb = 3;
        break;
      default:
        this.write = simpleWrite, this.end = simpleEnd;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = Buffer$21.allocUnsafe(nb);
  }
  StringDecoder$1.prototype.write = function(buf) {
    if (buf.length === 0) return ``;
    var r$2, i$4;
    if (this.lastNeed) {
      if (r$2 = this.fillLast(buf), r$2 === void 0) return ``;
      i$4 = this.lastNeed, this.lastNeed = 0;
    } else i$4 = 0;
    return i$4 < buf.length ? r$2 ? r$2 + this.text(buf, i$4) : this.text(buf, i$4) : r$2 || ``;
  }, StringDecoder$1.prototype.end = utf8End, StringDecoder$1.prototype.text = utf8Text, StringDecoder$1.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) return buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length), this.lastNeed -= buf.length;
  };
  function utf8CheckByte(byte) {
    return byte <= 127 ? 0 : byte >> 5 == 6 ? 2 : byte >> 4 == 14 ? 3 : byte >> 3 == 30 ? 4 : byte >> 6 == 2 ? -1 : -2;
  }
  function utf8CheckIncomplete(self$1, buf, i$4) {
    var j$1 = buf.length - 1;
    if (j$1 < i$4) return 0;
    var nb = utf8CheckByte(buf[j$1]);
    return nb >= 0 ? (nb > 0 && (self$1.lastNeed = nb - 1), nb) : --j$1 < i$4 || nb === -2 ? 0 : (nb = utf8CheckByte(buf[j$1]), nb >= 0 ? (nb > 0 && (self$1.lastNeed = nb - 2), nb) : --j$1 < i$4 || nb === -2 ? 0 : (nb = utf8CheckByte(buf[j$1]), nb >= 0 ? (nb > 0 && (nb === 2 ? nb = 0 : self$1.lastNeed = nb - 3), nb) : 0));
  }
  function utf8CheckExtraBytes(self$1, buf, p$1) {
    if ((buf[0] & 192) != 128) return self$1.lastNeed = 0, `�`;
    if (self$1.lastNeed > 1 && buf.length > 1) {
      if ((buf[1] & 192) != 128) return self$1.lastNeed = 1, `�`;
      if (self$1.lastNeed > 2 && buf.length > 2 && (buf[2] & 192) != 128) return self$1.lastNeed = 2, `�`;
    }
  }
  function utf8FillLast(buf) {
    var p$1 = this.lastTotal - this.lastNeed, r$2 = utf8CheckExtraBytes(this, buf);
    if (r$2 !== void 0) return r$2;
    if (this.lastNeed <= buf.length) return buf.copy(this.lastChar, p$1, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    buf.copy(this.lastChar, p$1, 0, buf.length), this.lastNeed -= buf.length;
  }
  function utf8Text(buf, i$4) {
    var total = utf8CheckIncomplete(this, buf, i$4);
    if (!this.lastNeed) return buf.toString(`utf8`, i$4);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    return buf.copy(this.lastChar, 0, end), buf.toString(`utf8`, i$4, end);
  }
  function utf8End(buf) {
    var r$2 = buf && buf.length ? this.write(buf) : ``;
    return this.lastNeed ? r$2 + `�` : r$2;
  }
  function utf16Text(buf, i$4) {
    if ((buf.length - i$4) % 2 == 0) {
      var r$2 = buf.toString(`utf16le`, i$4);
      if (r$2) {
        var c$12 = r$2.charCodeAt(r$2.length - 1);
        if (c$12 >= 55296 && c$12 <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = buf[buf.length - 2], this.lastChar[1] = buf[buf.length - 1], r$2.slice(0, -1);
      }
      return r$2;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = buf[buf.length - 1], buf.toString(`utf16le`, i$4, buf.length - 1);
  }
  function utf16End(buf) {
    var r$2 = buf && buf.length ? this.write(buf) : ``;
    if (this.lastNeed) {
      var end = this.lastTotal - this.lastNeed;
      return r$2 + this.lastChar.toString(`utf16le`, 0, end);
    }
    return r$2;
  }
  function base64Text(buf, i$4) {
    var n$4 = (buf.length - i$4) % 3;
    return n$4 === 0 ? buf.toString(`base64`, i$4) : (this.lastNeed = 3 - n$4, this.lastTotal = 3, n$4 === 1 ? this.lastChar[0] = buf[buf.length - 1] : (this.lastChar[0] = buf[buf.length - 2], this.lastChar[1] = buf[buf.length - 1]), buf.toString(`base64`, i$4, buf.length - n$4));
  }
  function base64End(buf) {
    var r$2 = buf && buf.length ? this.write(buf) : ``;
    return this.lastNeed ? r$2 + this.lastChar.toString(`base64`, 0, 3 - this.lastNeed) : r$2;
  }
  function simpleWrite(buf) {
    return buf.toString(this.encoding);
  }
  function simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : ``;
  }
}), require_end_of_stream = __commonJSMin$1((exports$12, module2) => {
  var ERR_STREAM_PREMATURE_CLOSE = require_errors().codes.ERR_STREAM_PREMATURE_CLOSE;
  function once$1(callback) {
    var called = false;
    return function() {
      if (!called) {
        called = true;
        for (var _len = arguments.length, args$1 = Array(_len), _key = 0; _key < _len; _key++) args$1[_key] = arguments[_key];
        callback.apply(this, args$1);
      }
    };
  }
  function noop$4() {
  }
  function isRequest$1(stream$1) {
    return stream$1.setHeader && typeof stream$1.abort == `function`;
  }
  function eos$1(stream$1, opts, callback) {
    if (typeof opts == `function`) return eos$1(stream$1, null, opts);
    opts ||= {}, callback = once$1(callback || noop$4);
    var readable = opts.readable || opts.readable !== false && stream$1.readable, writable = opts.writable || opts.writable !== false && stream$1.writable, onlegacyfinish = function() {
      stream$1.writable || onfinish();
    }, writableEnded = stream$1._writableState && stream$1._writableState.finished, onfinish = function() {
      writable = false, writableEnded = true, readable || callback.call(stream$1);
    }, readableEnded = stream$1._readableState && stream$1._readableState.endEmitted, onend$1 = function() {
      readable = false, readableEnded = true, writable || callback.call(stream$1);
    }, onerror = function(err$1) {
      callback.call(stream$1, err$1);
    }, onclose = function() {
      var err$1;
      if (readable && !readableEnded) return (!stream$1._readableState || !stream$1._readableState.ended) && (err$1 = new ERR_STREAM_PREMATURE_CLOSE()), callback.call(stream$1, err$1);
      if (writable && !writableEnded) return (!stream$1._writableState || !stream$1._writableState.ended) && (err$1 = new ERR_STREAM_PREMATURE_CLOSE()), callback.call(stream$1, err$1);
    }, onrequest = function() {
      stream$1.req.on(`finish`, onfinish);
    };
    return isRequest$1(stream$1) ? (stream$1.on(`complete`, onfinish), stream$1.on(`abort`, onclose), stream$1.req ? onrequest() : stream$1.on(`request`, onrequest)) : writable && !stream$1._writableState && (stream$1.on(`end`, onlegacyfinish), stream$1.on(`close`, onlegacyfinish)), stream$1.on(`end`, onend$1), stream$1.on(`finish`, onfinish), opts.error !== false && stream$1.on(`error`, onerror), stream$1.on(`close`, onclose), function() {
      stream$1.removeListener(`complete`, onfinish), stream$1.removeListener(`abort`, onclose), stream$1.removeListener(`request`, onrequest), stream$1.req && stream$1.req.removeListener(`finish`, onfinish), stream$1.removeListener(`end`, onlegacyfinish), stream$1.removeListener(`close`, onlegacyfinish), stream$1.removeListener(`finish`, onfinish), stream$1.removeListener(`end`, onend$1), stream$1.removeListener(`error`, onerror), stream$1.removeListener(`close`, onclose);
    };
  }
  module2.exports = eos$1;
}), require_async_iterator = __commonJSMin$1((exports$12, module2) => {
  init_dist();
  var _Object$setPrototypeO;
  function _defineProperty$1(obj, key, value) {
    return key = _toPropertyKey$1(key), key in obj ? Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true }) : obj[key] = value, obj;
  }
  function _toPropertyKey$1(arg) {
    var key = _toPrimitive$1(arg, `string`);
    return typeof key == `symbol` ? key : String(key);
  }
  function _toPrimitive$1(input, hint) {
    if (typeof input != `object` || !input) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint);
      if (typeof res != `object`) return res;
      throw TypeError(`@@toPrimitive must return a primitive value.`);
    }
    return String(input);
  }
  var finished = require_end_of_stream(), kLastResolve = Symbol(`lastResolve`), kLastReject = Symbol(`lastReject`), kError = Symbol(`error`), kEnded = Symbol(`ended`), kLastPromise = Symbol(`lastPromise`), kHandlePromise = Symbol(`handlePromise`), kStream = Symbol(`stream`);
  function createIterResult(value, done$1) {
    return { value, done: done$1 };
  }
  function readAndResolve(iter) {
    var resolve = iter[kLastResolve];
    if (resolve !== null) {
      var data = iter[kStream].read();
      data !== null && (iter[kLastPromise] = null, iter[kLastResolve] = null, iter[kLastReject] = null, resolve(createIterResult(data, false)));
    }
  }
  function onReadable(iter) {
    process$1.nextTick(readAndResolve, iter);
  }
  function wrapForNext(lastPromise, iter) {
    return function(resolve, reject$2) {
      lastPromise.then(function() {
        if (iter[kEnded]) {
          resolve(createIterResult(void 0, true));
          return;
        }
        iter[kHandlePromise](resolve, reject$2);
      }, reject$2);
    };
  }
  var AsyncIteratorPrototype = Object.getPrototypeOf(function() {
  }), ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = { get stream() {
    return this[kStream];
  }, next: function() {
    var _this = this, error = this[kError];
    if (error !== null) return Promise.reject(error);
    if (this[kEnded]) return Promise.resolve(createIterResult(void 0, true));
    if (this[kStream].destroyed) return new Promise(function(resolve, reject$2) {
      process$1.nextTick(function() {
        _this[kError] ? reject$2(_this[kError]) : resolve(createIterResult(void 0, true));
      });
    });
    var lastPromise = this[kLastPromise], promise;
    if (lastPromise) promise = new Promise(wrapForNext(lastPromise, this));
    else {
      var data = this[kStream].read();
      if (data !== null) return Promise.resolve(createIterResult(data, false));
      promise = new Promise(this[kHandlePromise]);
    }
    return this[kLastPromise] = promise, promise;
  } }, _defineProperty$1(_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
  }), _defineProperty$1(_Object$setPrototypeO, `return`, function() {
    var _this2 = this;
    return new Promise(function(resolve, reject$2) {
      _this2[kStream].destroy(null, function(err$1) {
        if (err$1) {
          reject$2(err$1);
          return;
        }
        resolve(createIterResult(void 0, true));
      });
    });
  }), _Object$setPrototypeO), AsyncIteratorPrototype), createReadableStreamAsyncIterator$1 = function(stream$1) {
    var _Object$create, iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty$1(_Object$create, kStream, { value: stream$1, writable: true }), _defineProperty$1(_Object$create, kLastResolve, { value: null, writable: true }), _defineProperty$1(_Object$create, kLastReject, { value: null, writable: true }), _defineProperty$1(_Object$create, kError, { value: null, writable: true }), _defineProperty$1(_Object$create, kEnded, { value: stream$1._readableState.endEmitted, writable: true }), _defineProperty$1(_Object$create, kHandlePromise, { value: function(resolve, reject$2) {
      var data = iterator[kStream].read();
      data ? (iterator[kLastPromise] = null, iterator[kLastResolve] = null, iterator[kLastReject] = null, resolve(createIterResult(data, false))) : (iterator[kLastResolve] = resolve, iterator[kLastReject] = reject$2);
    }, writable: true }), _Object$create));
    return iterator[kLastPromise] = null, finished(stream$1, function(err$1) {
      if (err$1 && err$1.code !== `ERR_STREAM_PREMATURE_CLOSE`) {
        var reject$2 = iterator[kLastReject];
        reject$2 !== null && (iterator[kLastPromise] = null, iterator[kLastResolve] = null, iterator[kLastReject] = null, reject$2(err$1)), iterator[kError] = err$1;
        return;
      }
      var resolve = iterator[kLastResolve];
      resolve !== null && (iterator[kLastPromise] = null, iterator[kLastResolve] = null, iterator[kLastReject] = null, resolve(createIterResult(void 0, true))), iterator[kEnded] = true;
    }), stream$1.on(`readable`, onReadable.bind(null, iterator)), iterator;
  };
  module2.exports = createReadableStreamAsyncIterator$1;
}), require_from = __commonJSMin$1((exports$12, module2) => {
  function asyncGeneratorStep(gen, resolve, reject$2, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg), value = info.value;
    } catch (error) {
      reject$2(error);
      return;
    }
    info.done ? resolve(value) : Promise.resolve(value).then(_next, _throw);
  }
  function _asyncToGenerator(fn$1) {
    return function() {
      var self$1 = this, args$1 = arguments;
      return new Promise(function(resolve, reject$2) {
        var gen = fn$1.apply(self$1, args$1);
        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject$2, _next, _throw, `next`, value);
        }
        function _throw(err$1) {
          asyncGeneratorStep(gen, resolve, reject$2, _next, _throw, `throw`, err$1);
        }
        _next(void 0);
      });
    };
  }
  function ownKeys(object, enumerableOnly) {
    var keys$10 = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys$10.push.apply(keys$10, symbols);
    }
    return keys$10;
  }
  function _objectSpread(target) {
    for (var i$4 = 1; i$4 < arguments.length; i$4++) {
      var source = arguments[i$4] == null ? {} : arguments[i$4];
      i$4 % 2 ? ownKeys(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty(obj, key, value) {
    return key = _toPropertyKey(key), key in obj ? Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true }) : obj[key] = value, obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, `string`);
    return typeof key == `symbol` ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (typeof input != `object` || !input) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint);
      if (typeof res != `object`) return res;
      throw TypeError(`@@toPrimitive must return a primitive value.`);
    }
    return String(input);
  }
  var ERR_INVALID_ARG_TYPE$1 = require_errors().codes.ERR_INVALID_ARG_TYPE;
  function from$1(Readable$2, iterable, opts) {
    var iterator;
    if (iterable && typeof iterable.next == `function`) iterator = iterable;
    else if (iterable && iterable[Symbol.asyncIterator]) iterator = iterable[Symbol.asyncIterator]();
    else if (iterable && iterable[Symbol.iterator]) iterator = iterable[Symbol.iterator]();
    else throw new ERR_INVALID_ARG_TYPE$1(`iterable`, [`Iterable`], iterable);
    var readable = new Readable$2(_objectSpread({ objectMode: true }, opts)), reading = false;
    readable._read = function() {
      reading || (reading = true, next());
    };
    function next() {
      return _next2.apply(this, arguments);
    }
    function _next2() {
      return _next2 = _asyncToGenerator(function* () {
        try {
          var _yield$iterator$next = yield iterator.next(), value = _yield$iterator$next.value, done$1 = _yield$iterator$next.done;
          done$1 ? readable.push(null) : readable.push(yield value) ? next() : reading = false;
        } catch (err$1) {
          readable.destroy(err$1);
        }
      }), _next2.apply(this, arguments);
    }
    return readable;
  }
  module2.exports = from$1;
}), require__stream_readable = __commonJSMin$1((exports$12, module2) => {
  init_dist(), module2.exports = Readable;
  var Duplex$1;
  Readable.ReadableState = ReadableState;
  require_events().EventEmitter;
  var EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
  }, Stream$1 = require_stream(), Buffer$20 = (init_dist$1(), __toCommonJS(dist_exports)).Buffer, OurUint8Array = {}.Uint8Array || function() {
  };
  function _uint8ArrayToBuffer(chunk) {
    return Buffer$20.from(chunk);
  }
  function _isUint8Array(obj) {
    return Buffer$20.isBuffer(obj) || obj instanceof OurUint8Array;
  }
  var debugUtil = require_util(), debug$11;
  debug$11 = debugUtil && debugUtil.debuglog ? debugUtil.debuglog(`stream`) : function() {
  };
  var BufferList = require_buffer_list(), destroyImpl = require_destroy(), _require = require_state(), getHighWaterMark = _require.getHighWaterMark, _require$codes$2 = require_errors().codes, ERR_INVALID_ARG_TYPE = _require$codes$2.ERR_INVALID_ARG_TYPE, ERR_STREAM_PUSH_AFTER_EOF = _require$codes$2.ERR_STREAM_PUSH_AFTER_EOF, ERR_METHOD_NOT_IMPLEMENTED$1 = _require$codes$2.ERR_METHOD_NOT_IMPLEMENTED, ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes$2.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, StringDecoder, createReadableStreamAsyncIterator, from;
  require_inherits()(Readable, Stream$1);
  var errorOrDestroy = destroyImpl.errorOrDestroy, kProxyEvents = [`error`, `close`, `destroy`, `pause`, `resume`];
  function prependListener(emitter, event, fn$1) {
    if (typeof emitter.prependListener == `function`) return emitter.prependListener(event, fn$1);
    !emitter._events || !emitter._events[event] ? emitter.on(event, fn$1) : Array.isArray(emitter._events[event]) ? emitter._events[event].unshift(fn$1) : emitter._events[event] = [fn$1, emitter._events[event]];
  }
  function ReadableState(options, stream$1, isDuplex) {
    Duplex$1 ||= require__stream_duplex(), options ||= {}, typeof isDuplex != `boolean` && (isDuplex = stream$1 instanceof Duplex$1), this.objectMode = !!options.objectMode, isDuplex && (this.objectMode = this.objectMode || !!options.readableObjectMode), this.highWaterMark = getHighWaterMark(this, options, `readableHighWaterMark`, isDuplex), this.buffer = new BufferList(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = false, this.endEmitted = false, this.reading = false, this.sync = true, this.needReadable = false, this.emittedReadable = false, this.readableListening = false, this.resumeScheduled = false, this.paused = true, this.emitClose = options.emitClose !== false, this.autoDestroy = !!options.autoDestroy, this.destroyed = false, this.defaultEncoding = options.defaultEncoding || `utf8`, this.awaitDrain = 0, this.readingMore = false, this.decoder = null, this.encoding = null, options.encoding && (StringDecoder ||= require_string_decoder().StringDecoder, this.decoder = new StringDecoder(options.encoding), this.encoding = options.encoding);
  }
  function Readable(options) {
    if (Duplex$1 ||= require__stream_duplex(), !(this instanceof Readable)) return new Readable(options);
    var isDuplex = this instanceof Duplex$1;
    this._readableState = new ReadableState(options, this, isDuplex), this.readable = true, options && (typeof options.read == `function` && (this._read = options.read), typeof options.destroy == `function` && (this._destroy = options.destroy)), Stream$1.call(this);
  }
  Object.defineProperty(Readable.prototype, `destroyed`, { enumerable: false, get: function() {
    return this._readableState === void 0 ? false : this._readableState.destroyed;
  }, set: function(value) {
    this._readableState && (this._readableState.destroyed = value);
  } }), Readable.prototype.destroy = destroyImpl.destroy, Readable.prototype._undestroy = destroyImpl.undestroy, Readable.prototype._destroy = function(err$1, cb) {
    cb(err$1);
  }, Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState, skipChunkCheck;
    return state.objectMode ? skipChunkCheck = true : typeof chunk == `string` && (encoding ||= state.defaultEncoding, encoding !== state.encoding && (chunk = Buffer$20.from(chunk, encoding), encoding = ``), skipChunkCheck = true), readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
  }, Readable.prototype.unshift = function(chunk) {
    return readableAddChunk(this, chunk, null, true, false);
  };
  function readableAddChunk(stream$1, chunk, encoding, addToFront, skipChunkCheck) {
    debug$11(`readableAddChunk`, chunk);
    var state = stream$1._readableState;
    if (chunk === null) state.reading = false, onEofChunk(stream$1, state);
    else {
      var er;
      if (skipChunkCheck || (er = chunkInvalid(state, chunk)), er) errorOrDestroy(stream$1, er);
      else if (state.objectMode || chunk && chunk.length > 0) if (typeof chunk != `string` && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer$20.prototype && (chunk = _uint8ArrayToBuffer(chunk)), addToFront) state.endEmitted ? errorOrDestroy(stream$1, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT()) : addChunk(stream$1, state, chunk, true);
      else if (state.ended) errorOrDestroy(stream$1, new ERR_STREAM_PUSH_AFTER_EOF());
      else if (state.destroyed) return false;
      else state.reading = false, state.decoder && !encoding ? (chunk = state.decoder.write(chunk), state.objectMode || chunk.length !== 0 ? addChunk(stream$1, state, chunk, false) : maybeReadMore(stream$1, state)) : addChunk(stream$1, state, chunk, false);
      else addToFront || (state.reading = false, maybeReadMore(stream$1, state));
    }
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
  }
  function addChunk(stream$1, state, chunk, addToFront) {
    state.flowing && state.length === 0 && !state.sync ? (state.awaitDrain = 0, stream$1.emit(`data`, chunk)) : (state.length += state.objectMode ? 1 : chunk.length, addToFront ? state.buffer.unshift(chunk) : state.buffer.push(chunk), state.needReadable && emitReadable(stream$1)), maybeReadMore(stream$1, state);
  }
  function chunkInvalid(state, chunk) {
    var er;
    return !_isUint8Array(chunk) && typeof chunk != `string` && chunk !== void 0 && !state.objectMode && (er = new ERR_INVALID_ARG_TYPE(`chunk`, [`string`, `Buffer`, `Uint8Array`], chunk)), er;
  }
  Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
  }, Readable.prototype.setEncoding = function(enc) {
    StringDecoder ||= require_string_decoder().StringDecoder;
    var decoder = new StringDecoder(enc);
    this._readableState.decoder = decoder, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var p$1 = this._readableState.buffer.head, content = ``; p$1 !== null; ) content += decoder.write(p$1.data), p$1 = p$1.next;
    return this._readableState.buffer.clear(), content !== `` && this._readableState.buffer.push(content), this._readableState.length = content.length, this;
  };
  var MAX_HWM = 1073741824;
  function computeNewHighWaterMark(n$4) {
    return n$4 >= MAX_HWM ? n$4 = MAX_HWM : (n$4--, n$4 |= n$4 >>> 1, n$4 |= n$4 >>> 2, n$4 |= n$4 >>> 4, n$4 |= n$4 >>> 8, n$4 |= n$4 >>> 16, n$4++), n$4;
  }
  function howMuchToRead(n$4, state) {
    return n$4 <= 0 || state.length === 0 && state.ended ? 0 : state.objectMode ? 1 : n$4 === n$4 ? (n$4 > state.highWaterMark && (state.highWaterMark = computeNewHighWaterMark(n$4)), n$4 <= state.length ? n$4 : state.ended ? state.length : (state.needReadable = true, 0)) : state.flowing && state.length ? state.buffer.head.data.length : state.length;
  }
  Readable.prototype.read = function(n$4) {
    debug$11(`read`, n$4), n$4 = parseInt(n$4, 10);
    var state = this._readableState, nOrig = n$4;
    if (n$4 !== 0 && (state.emittedReadable = false), n$4 === 0 && state.needReadable && ((state.highWaterMark === 0 ? state.length > 0 : state.length >= state.highWaterMark) || state.ended)) return debug$11(`read: emitReadable`, state.length, state.ended), state.length === 0 && state.ended ? endReadable(this) : emitReadable(this), null;
    if (n$4 = howMuchToRead(n$4, state), n$4 === 0 && state.ended) return state.length === 0 && endReadable(this), null;
    var doRead = state.needReadable;
    debug$11(`need readable`, doRead), (state.length === 0 || state.length - n$4 < state.highWaterMark) && (doRead = true, debug$11(`length less than watermark`, doRead)), state.ended || state.reading ? (doRead = false, debug$11(`reading or ended`, doRead)) : doRead && (debug$11(`do read`), state.reading = true, state.sync = true, state.length === 0 && (state.needReadable = true), this._read(state.highWaterMark), state.sync = false, state.reading || (n$4 = howMuchToRead(nOrig, state)));
    var ret;
    return ret = n$4 > 0 ? fromList(n$4, state) : null, ret === null ? (state.needReadable = state.length <= state.highWaterMark, n$4 = 0) : (state.length -= n$4, state.awaitDrain = 0), state.length === 0 && (state.ended || (state.needReadable = true), nOrig !== n$4 && state.ended && endReadable(this)), ret !== null && this.emit(`data`, ret), ret;
  };
  function onEofChunk(stream$1, state) {
    if (debug$11(`onEofChunk`), !state.ended) {
      if (state.decoder) {
        var chunk = state.decoder.end();
        chunk && chunk.length && (state.buffer.push(chunk), state.length += state.objectMode ? 1 : chunk.length);
      }
      state.ended = true, state.sync ? emitReadable(stream$1) : (state.needReadable = false, state.emittedReadable || (state.emittedReadable = true, emitReadable_(stream$1)));
    }
  }
  function emitReadable(stream$1) {
    var state = stream$1._readableState;
    debug$11(`emitReadable`, state.needReadable, state.emittedReadable), state.needReadable = false, state.emittedReadable || (debug$11(`emitReadable`, state.flowing), state.emittedReadable = true, process$1.nextTick(emitReadable_, stream$1));
  }
  function emitReadable_(stream$1) {
    var state = stream$1._readableState;
    debug$11(`emitReadable_`, state.destroyed, state.length, state.ended), !state.destroyed && (state.length || state.ended) && (stream$1.emit(`readable`), state.emittedReadable = false), state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark, flow(stream$1);
  }
  function maybeReadMore(stream$1, state) {
    state.readingMore || (state.readingMore = true, process$1.nextTick(maybeReadMore_, stream$1, state));
  }
  function maybeReadMore_(stream$1, state) {
    for (; !state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0); ) {
      var len$2 = state.length;
      if (debug$11(`maybeReadMore read 0`), stream$1.read(0), len$2 === state.length) break;
    }
    state.readingMore = false;
  }
  Readable.prototype._read = function(n$4) {
    errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED$1(`_read()`));
  }, Readable.prototype.pipe = function(dest, pipeOpts) {
    var src$1 = this, state = this._readableState;
    switch (state.pipesCount) {
      case 0:
        state.pipes = dest;
        break;
      case 1:
        state.pipes = [state.pipes, dest];
        break;
      default:
        state.pipes.push(dest);
        break;
    }
    state.pipesCount += 1, debug$11(`pipe count=%d opts=%j`, state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process$1.stdout && dest !== process$1.stderr, endFn = doEnd ? onend$1 : unpipe;
    state.endEmitted ? process$1.nextTick(endFn) : src$1.once(`end`, endFn), dest.on(`unpipe`, onunpipe);
    function onunpipe(readable, unpipeInfo) {
      debug$11(`onunpipe`), readable === src$1 && unpipeInfo && unpipeInfo.hasUnpiped === false && (unpipeInfo.hasUnpiped = true, cleanup());
    }
    function onend$1() {
      debug$11(`onend`), dest.end();
    }
    var ondrain = pipeOnDrain(src$1);
    dest.on(`drain`, ondrain);
    var cleanedUp = false;
    function cleanup() {
      debug$11(`cleanup`), dest.removeListener(`close`, onclose), dest.removeListener(`finish`, onfinish), dest.removeListener(`drain`, ondrain), dest.removeListener(`error`, onerror), dest.removeListener(`unpipe`, onunpipe), src$1.removeListener(`end`, onend$1), src$1.removeListener(`end`, unpipe), src$1.removeListener(`data`, ondata), cleanedUp = true, state.awaitDrain && (!dest._writableState || dest._writableState.needDrain) && ondrain();
    }
    src$1.on(`data`, ondata);
    function ondata(chunk) {
      debug$11(`ondata`);
      var ret = dest.write(chunk);
      debug$11(`dest.write`, ret), ret === false && ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf$2(state.pipes, dest) !== -1) && !cleanedUp && (debug$11(`false write response, pause`, state.awaitDrain), state.awaitDrain++), src$1.pause());
    }
    function onerror(er) {
      debug$11(`onerror`, er), unpipe(), dest.removeListener(`error`, onerror), EElistenerCount(dest, `error`) === 0 && errorOrDestroy(dest, er);
    }
    prependListener(dest, `error`, onerror);
    function onclose() {
      dest.removeListener(`finish`, onfinish), unpipe();
    }
    dest.once(`close`, onclose);
    function onfinish() {
      debug$11(`onfinish`), dest.removeListener(`close`, onclose), unpipe();
    }
    dest.once(`finish`, onfinish);
    function unpipe() {
      debug$11(`unpipe`), src$1.unpipe(dest);
    }
    return dest.emit(`pipe`, src$1), state.flowing || (debug$11(`pipe resume`), src$1.resume()), dest;
  };
  function pipeOnDrain(src$1) {
    return function() {
      var state = src$1._readableState;
      debug$11(`pipeOnDrain`, state.awaitDrain), state.awaitDrain && state.awaitDrain--, state.awaitDrain === 0 && EElistenerCount(src$1, `data`) && (state.flowing = true, flow(src$1));
    };
  }
  Readable.prototype.unpipe = function(dest) {
    var state = this._readableState, unpipeInfo = { hasUnpiped: false };
    if (state.pipesCount === 0) return this;
    if (state.pipesCount === 1) return dest && dest !== state.pipes ? this : (dest ||= state.pipes, state.pipes = null, state.pipesCount = 0, state.flowing = false, dest && dest.emit(`unpipe`, this, unpipeInfo), this);
    if (!dest) {
      var dests = state.pipes, len$2 = state.pipesCount;
      state.pipes = null, state.pipesCount = 0, state.flowing = false;
      for (var i$4 = 0; i$4 < len$2; i$4++) dests[i$4].emit(`unpipe`, this, { hasUnpiped: false });
      return this;
    }
    var index$2 = indexOf$2(state.pipes, dest);
    return index$2 === -1 ? this : (state.pipes.splice(index$2, 1), --state.pipesCount, state.pipesCount === 1 && (state.pipes = state.pipes[0]), dest.emit(`unpipe`, this, unpipeInfo), this);
  }, Readable.prototype.on = function(ev, fn$1) {
    var res = Stream$1.prototype.on.call(this, ev, fn$1), state = this._readableState;
    return ev === `data` ? (state.readableListening = this.listenerCount(`readable`) > 0, state.flowing !== false && this.resume()) : ev === `readable` && !state.endEmitted && !state.readableListening && (state.readableListening = state.needReadable = true, state.flowing = false, state.emittedReadable = false, debug$11(`on readable`, state.length, state.reading), state.length ? emitReadable(this) : state.reading || process$1.nextTick(nReadingNextTick, this)), res;
  }, Readable.prototype.addListener = Readable.prototype.on, Readable.prototype.removeListener = function(ev, fn$1) {
    var res = Stream$1.prototype.removeListener.call(this, ev, fn$1);
    return ev === `readable` && process$1.nextTick(updateReadableListening, this), res;
  }, Readable.prototype.removeAllListeners = function(ev) {
    var res = Stream$1.prototype.removeAllListeners.apply(this, arguments);
    return (ev === `readable` || ev === void 0) && process$1.nextTick(updateReadableListening, this), res;
  };
  function updateReadableListening(self$1) {
    var state = self$1._readableState;
    state.readableListening = self$1.listenerCount(`readable`) > 0, state.resumeScheduled && !state.paused ? state.flowing = true : self$1.listenerCount(`data`) > 0 && self$1.resume();
  }
  function nReadingNextTick(self$1) {
    debug$11(`readable nexttick read 0`), self$1.read(0);
  }
  Readable.prototype.resume = function() {
    var state = this._readableState;
    return state.flowing || (debug$11(`resume`), state.flowing = !state.readableListening, resume(this, state)), state.paused = false, this;
  };
  function resume(stream$1, state) {
    state.resumeScheduled || (state.resumeScheduled = true, process$1.nextTick(resume_, stream$1, state));
  }
  function resume_(stream$1, state) {
    debug$11(`resume`, state.reading), state.reading || stream$1.read(0), state.resumeScheduled = false, stream$1.emit(`resume`), flow(stream$1), state.flowing && !state.reading && stream$1.read(0);
  }
  Readable.prototype.pause = function() {
    return debug$11(`call pause flowing=%j`, this._readableState.flowing), this._readableState.flowing !== false && (debug$11(`pause`), this._readableState.flowing = false, this.emit(`pause`)), this._readableState.paused = true, this;
  };
  function flow(stream$1) {
    var state = stream$1._readableState;
    for (debug$11(`flow`, state.flowing); state.flowing && stream$1.read() !== null; ) ;
  }
  Readable.prototype.wrap = function(stream$1) {
    var _this = this, state = this._readableState, paused = false;
    for (var i$4 in stream$1.on(`end`, function() {
      if (debug$11(`wrapped end`), state.decoder && !state.ended) {
        var chunk = state.decoder.end();
        chunk && chunk.length && _this.push(chunk);
      }
      _this.push(null);
    }), stream$1.on(`data`, function(chunk) {
      if (debug$11(`wrapped data`), state.decoder && (chunk = state.decoder.write(chunk)), !(state.objectMode && chunk == null) && !(!state.objectMode && (!chunk || !chunk.length))) {
        var ret = _this.push(chunk);
        ret || (paused = true, stream$1.pause());
      }
    }), stream$1) this[i$4] === void 0 && typeof stream$1[i$4] == `function` && (this[i$4] = /* @__PURE__ */ (function(method$1) {
      return function() {
        return stream$1[method$1].apply(stream$1, arguments);
      };
    })(i$4));
    for (var n$4 = 0; n$4 < kProxyEvents.length; n$4++) stream$1.on(kProxyEvents[n$4], this.emit.bind(this, kProxyEvents[n$4]));
    return this._read = function(n$5) {
      debug$11(`wrapped _read`, n$5), paused && (paused = false, stream$1.resume());
    }, this;
  }, typeof Symbol == `function` && (Readable.prototype[Symbol.asyncIterator] = function() {
    return createReadableStreamAsyncIterator === void 0 && (createReadableStreamAsyncIterator = require_async_iterator()), createReadableStreamAsyncIterator(this);
  }), Object.defineProperty(Readable.prototype, `readableHighWaterMark`, { enumerable: false, get: function() {
    return this._readableState.highWaterMark;
  } }), Object.defineProperty(Readable.prototype, `readableBuffer`, { enumerable: false, get: function() {
    return this._readableState && this._readableState.buffer;
  } }), Object.defineProperty(Readable.prototype, `readableFlowing`, { enumerable: false, get: function() {
    return this._readableState.flowing;
  }, set: function(state) {
    this._readableState && (this._readableState.flowing = state);
  } }), Readable._fromList = fromList, Object.defineProperty(Readable.prototype, `readableLength`, { enumerable: false, get: function() {
    return this._readableState.length;
  } });
  function fromList(n$4, state) {
    if (state.length === 0) return null;
    var ret;
    return state.objectMode ? ret = state.buffer.shift() : !n$4 || n$4 >= state.length ? (ret = state.decoder ? state.buffer.join(``) : state.buffer.length === 1 ? state.buffer.first() : state.buffer.concat(state.length), state.buffer.clear()) : ret = state.buffer.consume(n$4, state.decoder), ret;
  }
  function endReadable(stream$1) {
    var state = stream$1._readableState;
    debug$11(`endReadable`, state.endEmitted), state.endEmitted || (state.ended = true, process$1.nextTick(endReadableNT, state, stream$1));
  }
  function endReadableNT(state, stream$1) {
    if (debug$11(`endReadableNT`, state.endEmitted, state.length), !state.endEmitted && state.length === 0 && (state.endEmitted = true, stream$1.readable = false, stream$1.emit(`end`), state.autoDestroy)) {
      var wState = stream$1._writableState;
      (!wState || wState.autoDestroy && wState.finished) && stream$1.destroy();
    }
  }
  typeof Symbol == `function` && (Readable.from = function(iterable, opts) {
    return from === void 0 && (from = require_from()), from(Readable, iterable, opts);
  });
  function indexOf$2(xs, x$1) {
    for (var i$4 = 0, l$4 = xs.length; i$4 < l$4; i$4++) if (xs[i$4] === x$1) return i$4;
    return -1;
  }
}), require__stream_transform = __commonJSMin$1((exports$12, module2) => {
  module2.exports = Transform$3;
  var _require$codes$1 = require_errors().codes, ERR_METHOD_NOT_IMPLEMENTED = _require$codes$1.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes$1.ERR_MULTIPLE_CALLBACK, ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes$1.ERR_TRANSFORM_ALREADY_TRANSFORMING, ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes$1.ERR_TRANSFORM_WITH_LENGTH_0, Duplex = require__stream_duplex();
  require_inherits()(Transform$3, Duplex);
  function afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit(`error`, new ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null, ts.writecb = null, data != null && this.push(data), cb(er);
    var rs = this._readableState;
    rs.reading = false, (rs.needReadable || rs.length < rs.highWaterMark) && this._read(rs.highWaterMark);
  }
  function Transform$3(options) {
    if (!(this instanceof Transform$3)) return new Transform$3(options);
    Duplex.call(this, options), this._transformState = { afterTransform: afterTransform.bind(this), needTransform: false, transforming: false, writecb: null, writechunk: null, writeencoding: null }, this._readableState.needReadable = true, this._readableState.sync = false, options && (typeof options.transform == `function` && (this._transform = options.transform), typeof options.flush == `function` && (this._flush = options.flush)), this.on(`prefinish`, prefinish);
  }
  function prefinish() {
    var _this = this;
    typeof this._flush == `function` && !this._readableState.destroyed ? this._flush(function(er, data) {
      done(_this, er, data);
    }) : done(this, null, null);
  }
  Transform$3.prototype.push = function(chunk, encoding) {
    return this._transformState.needTransform = false, Duplex.prototype.push.call(this, chunk, encoding);
  }, Transform$3.prototype._transform = function(chunk, encoding, cb) {
    cb(new ERR_METHOD_NOT_IMPLEMENTED(`_transform()`));
  }, Transform$3.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    if (ts.writecb = cb, ts.writechunk = chunk, ts.writeencoding = encoding, !ts.transforming) {
      var rs = this._readableState;
      (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) && this._read(rs.highWaterMark);
    }
  }, Transform$3.prototype._read = function(n$4) {
    var ts = this._transformState;
    ts.writechunk !== null && !ts.transforming ? (ts.transforming = true, this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform)) : ts.needTransform = true;
  }, Transform$3.prototype._destroy = function(err$1, cb) {
    Duplex.prototype._destroy.call(this, err$1, function(err2) {
      cb(err2);
    });
  };
  function done(stream$1, er, data) {
    if (er) return stream$1.emit(`error`, er);
    if (data != null && stream$1.push(data), stream$1._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream$1._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream$1.push(null);
  }
}), require__stream_passthrough = __commonJSMin$1((exports$12, module2) => {
  module2.exports = PassThrough;
  var Transform$2 = require__stream_transform();
  require_inherits()(PassThrough, Transform$2);
  function PassThrough(options) {
    if (!(this instanceof PassThrough)) return new PassThrough(options);
    Transform$2.call(this, options);
  }
  PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
  };
}), require_pipeline = __commonJSMin$1((exports$12, module2) => {
  var eos;
  function once(callback) {
    var called = false;
    return function() {
      called || (called = true, callback.apply(void 0, arguments));
    };
  }
  var _require$codes = require_errors().codes, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
  function noop$3(err$1) {
    if (err$1) throw err$1;
  }
  function isRequest(stream$1) {
    return stream$1.setHeader && typeof stream$1.abort == `function`;
  }
  function destroyer(stream$1, reading, writing, callback) {
    callback = once(callback);
    var closed = false;
    stream$1.on(`close`, function() {
      closed = true;
    }), eos === void 0 && (eos = require_end_of_stream()), eos(stream$1, { readable: reading, writable: writing }, function(err$1) {
      if (err$1) return callback(err$1);
      closed = true, callback();
    });
    var destroyed = false;
    return function(err$1) {
      if (!closed && !destroyed) {
        if (destroyed = true, isRequest(stream$1)) return stream$1.abort();
        if (typeof stream$1.destroy == `function`) return stream$1.destroy();
        callback(err$1 || new ERR_STREAM_DESTROYED(`pipe`));
      }
    };
  }
  function call(fn$1) {
    fn$1();
  }
  function pipe(from$2, to) {
    return from$2.pipe(to);
  }
  function popCallback(streams) {
    return !streams.length || typeof streams[streams.length - 1] != `function` ? noop$3 : streams.pop();
  }
  function pipeline() {
    for (var _len = arguments.length, streams = Array(_len), _key = 0; _key < _len; _key++) streams[_key] = arguments[_key];
    var callback = popCallback(streams);
    if (Array.isArray(streams[0]) && (streams = streams[0]), streams.length < 2) throw new ERR_MISSING_ARGS(`streams`);
    var error, destroys = streams.map(function(stream$1, i$4) {
      var reading = i$4 < streams.length - 1, writing = i$4 > 0;
      return destroyer(stream$1, reading, writing, function(err$1) {
        error ||= err$1, err$1 && destroys.forEach(call), !reading && (destroys.forEach(call), callback(error));
      });
    });
    return streams.reduce(pipe);
  }
  module2.exports = pipeline;
}), require_stream_browserify = __commonJSMin$1((exports$12, module2) => {
  module2.exports = Stream;
  var EE = require_events().EventEmitter, inherits$13 = require_inherits();
  inherits$13(Stream, EE), Stream.Readable = require__stream_readable(), Stream.Writable = require__stream_writable(), Stream.Duplex = require__stream_duplex(), Stream.Transform = require__stream_transform(), Stream.PassThrough = require__stream_passthrough(), Stream.finished = require_end_of_stream(), Stream.pipeline = require_pipeline(), Stream.Stream = Stream;
  function Stream() {
    EE.call(this);
  }
  Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
      dest.writable && dest.write(chunk) === false && source.pause && source.pause();
    }
    source.on(`data`, ondata);
    function ondrain() {
      source.readable && source.resume && source.resume();
    }
    dest.on(`drain`, ondrain), !dest._isStdio && (!options || options.end !== false) && (source.on(`end`, onend$1), source.on(`close`, onclose));
    var didOnEnd = false;
    function onend$1() {
      didOnEnd || (didOnEnd = true, dest.end());
    }
    function onclose() {
      didOnEnd || (didOnEnd = true, typeof dest.destroy == `function` && dest.destroy());
    }
    function onerror(er) {
      if (cleanup(), EE.listenerCount(this, `error`) === 0) throw er;
    }
    source.on(`error`, onerror), dest.on(`error`, onerror);
    function cleanup() {
      source.removeListener(`data`, ondata), dest.removeListener(`drain`, ondrain), source.removeListener(`end`, onend$1), source.removeListener(`close`, onclose), source.removeListener(`error`, onerror), dest.removeListener(`error`, onerror), source.removeListener(`end`, cleanup), source.removeListener(`close`, cleanup), dest.removeListener(`close`, cleanup);
    }
    return source.on(`end`, cleanup), source.on(`close`, cleanup), dest.on(`close`, cleanup), dest.emit(`pipe`, source), dest;
  };
}), require_runner = __commonJSMin$1((exports$12, module2) => {
  let { KnexTimeoutError: KnexTimeoutError$5 } = require_timeout(), { timeout: timeout$2 } = require_timeout(), { ensureConnectionCallback, ensureConnectionStreamCallback } = require_ensure_connection_callback(), Transform$1;
  var Runner$2 = class Runner$22 {
    constructor(client, builder) {
      this.client = client, this.builder = builder, this.queries = [], this.connection = void 0;
    }
    async run() {
      let runner = this;
      try {
        let res = await this.ensureConnection(ensureConnectionCallback);
        return runner.builder.emit(`end`), res;
      } catch (err$1) {
        throw runner.builder._events && runner.builder._events.error && runner.builder.emit(`error`, err$1), err$1;
      }
    }
    stream(optionsOrHandler, handlerOrNil) {
      let firstOptionIsHandler = typeof optionsOrHandler == `function` && arguments.length === 1, options = firstOptionIsHandler ? {} : optionsOrHandler, handler = firstOptionIsHandler ? optionsOrHandler : handlerOrNil, hasHandler = typeof handler == `function`;
      Transform$1 ||= require_stream_browserify().Transform;
      let queryContext = this.builder.queryContext(), stream$1 = new Transform$1({ objectMode: true, transform: (chunk, _, callback) => {
        callback(null, this.client.postProcessResponse(chunk, queryContext));
      } });
      stream$1.on(`close`, () => {
        this.client.releaseConnection(this.connection);
      }), stream$1.on(`pipe`, (sourceStream) => {
        let cleanSourceStream = () => {
          sourceStream.closed || sourceStream.destroy();
        };
        stream$1.closed ? cleanSourceStream() : stream$1.on(`close`, cleanSourceStream);
      });
      let connectionAcquirePromise = this.ensureConnection(ensureConnectionStreamCallback, { options, hasHandler, stream: stream$1 }).catch((err$1) => {
        this.connection || stream$1.emit(`error`, err$1);
      });
      return hasHandler ? (handler(stream$1), connectionAcquirePromise) : stream$1;
    }
    pipe(writable, options) {
      return this.stream(options).pipe(writable);
    }
    async query(obj) {
      let { __knexUid, __knexTxId } = this.connection;
      this.builder.emit(`query`, Object.assign({ __knexUid, __knexTxId }, obj));
      let runner = this, queryContext = this.builder.queryContext();
      typeof obj == `object` && obj && (obj.queryContext = queryContext);
      let queryPromise = this.client.query(this.connection, obj);
      return obj.timeout && (queryPromise = timeout$2(queryPromise, obj.timeout)), queryPromise.then((resp) => this.client.processResponse(resp, runner)).then((processedResponse) => {
        let postProcessedResponse = this.client.postProcessResponse(processedResponse, queryContext);
        return this.builder.emit(`query-response`, postProcessedResponse, Object.assign({ __knexUid, __knexTxId }, obj), this.builder), this.client.emit(`query-response`, postProcessedResponse, Object.assign({ __knexUid, __knexTxId }, obj), this.builder), postProcessedResponse;
      }).catch((error) => {
        if (!(error instanceof KnexTimeoutError$5)) return Promise.reject(error);
        let { timeout: timeout$5, sql, bindings } = obj, cancelQuery;
        return obj.cancelOnTimeout ? cancelQuery = this.client.cancelQuery(this.connection) : (this.connection.__knex__disposed = error, cancelQuery = Promise.resolve()), cancelQuery.catch((cancelError) => {
          throw this.connection.__knex__disposed = error, Object.assign(cancelError, { message: `After query timeout of ${timeout$5}ms exceeded, cancelling of query failed.`, sql, bindings, timeout: timeout$5 });
        }).then(() => {
          throw Object.assign(error, { message: `Defined query timeout of ${timeout$5}ms exceeded when running query.`, sql, bindings, timeout: timeout$5 });
        });
      }).catch((error) => {
        throw this.builder.emit(`query-error`, error, Object.assign({ __knexUid, __knexTxId, queryContext }, obj)), error;
      });
    }
    async queryArray(queries) {
      if (queries.length === 1) {
        let query = queries[0];
        if (!query.statementsProducer) return this.query(query);
        let statements = await query.statementsProducer(void 0, this.connection), sqlQueryObjects = statements.sql.map((statement) => ({ sql: statement, bindings: query.bindings })), preQueryObjects = statements.pre.map((statement) => ({ sql: statement, bindings: query.bindings })), postQueryObjects = statements.post.map((statement) => ({ sql: statement, bindings: query.bindings })), results$1 = [];
        await this.queryArray(preQueryObjects);
        try {
          await this.client.transaction(async (trx) => {
            let transactionRunner = new Runner$22(trx.client, this.builder);
            if (transactionRunner.connection = this.connection, results$1 = await transactionRunner.queryArray(sqlQueryObjects), statements.check) {
              let foreignViolations = await trx.raw(statements.check);
              if (foreignViolations.length > 0) throw Error(`FOREIGN KEY constraint failed`);
            }
          }, { connection: this.connection });
        } finally {
          await this.queryArray(postQueryObjects);
        }
        return results$1;
      }
      let results = [];
      for (let query of queries) results.push(await this.queryArray([query]));
      return results;
    }
    async ensureConnection(cb, cbParams) {
      if (this.builder._connection && (this.connection = this.builder._connection), this.connection) return cb(this, cbParams);
      let acquiredConnection;
      try {
        acquiredConnection = await this.client.acquireConnection();
      } catch (error) {
        if (!(error instanceof KnexTimeoutError$5)) return Promise.reject(error);
        throw this.builder && (error.sql = this.builder.sql, error.bindings = this.builder.bindings), error;
      }
      try {
        return this.connection = acquiredConnection, await cb(this, cbParams);
      } finally {
        await this.client.releaseConnection(acquiredConnection);
      }
    }
  };
  module2.exports = Runner$2;
}), require_builder = __commonJSMin$1((exports$12, module2) => {
  let { EventEmitter: EventEmitter$4 } = require_events(), toArray$5 = require_toArray(), assign$4 = require_assign(), { addQueryContext: addQueryContext$1 } = require_helpers$1(), saveAsyncStack = require_save_async_stack(), { augmentWithBuilderInterface } = require_builder_interface_augmenter();
  var SchemaBuilder$2 = class extends EventEmitter$4 {
    constructor(client) {
      super(), this.client = client, this._sequence = [], client.config && (this._debug = client.config.debug, saveAsyncStack(this, 4));
    }
    withSchema(schemaName) {
      return this._schema = schemaName, this;
    }
    toString() {
      return this.toQuery();
    }
    toSQL() {
      return this.client.schemaCompiler(this).toSQL();
    }
    async generateDdlCommands() {
      return await this.client.schemaCompiler(this).generateDdlCommands();
    }
  };
  `createTable.createTableIfNotExists.createTableLike.createView.createViewOrReplace.createMaterializedView.refreshMaterializedView.dropView.dropViewIfExists.dropMaterializedView.dropMaterializedViewIfExists.createSchema.createSchemaIfNotExists.dropSchema.dropSchemaIfExists.createExtension.createExtensionIfNotExists.dropExtension.dropExtensionIfExists.table.alterTable.view.alterView.hasTable.hasColumn.dropTable.renameTable.renameView.dropTableIfExists.raw`.split(`.`).forEach(function(method$1) {
    SchemaBuilder$2.prototype[method$1] = function() {
      return method$1 === `createTableIfNotExists` && this.client.logger.warn([`Use async .hasTable to check if table exists and then use plain .createTable. Since `, `.createTableIfNotExists actually just generates plain "CREATE TABLE IF NOT EXIST..." `, `query it will not work correctly if there are any alter table queries generated for `, `columns afterwards. To not break old migrations this function is left untouched for now`, `, but it should not be used when writing new code and it is removed from documentation.`].join(``)), method$1 === `table` && (method$1 = `alterTable`), method$1 === `view` && (method$1 = `alterView`), this._sequence.push({ method: method$1, args: toArray$5(arguments) }), this;
    };
  }), SchemaBuilder$2.extend = (methodName, fn$1) => {
    if (Object.prototype.hasOwnProperty.call(SchemaBuilder$2.prototype, methodName)) throw Error(`Can't extend SchemaBuilder with existing method ('${methodName}').`);
    assign$4(SchemaBuilder$2.prototype, { [methodName]: fn$1 });
  }, augmentWithBuilderInterface(SchemaBuilder$2), addQueryContext$1(SchemaBuilder$2), module2.exports = SchemaBuilder$2;
}), require_helpers = __commonJSMin$1((exports$12, module2) => {
  let tail$2 = require_tail(), { isString: isString$12 } = require_is();
  function pushQuery$3(query) {
    query && (isString$12(query) && (query = { sql: query }), query.bindings ||= this.bindingsHolder.bindings, this.sequence.push(query), this.formatter = this.client.formatter(this._commonBuilder), this.bindings = [], this.formatter.bindings = this.bindings);
  }
  function pushAdditional$2(fn$1) {
    let child = new this.constructor(this.client, this.tableCompiler, this.columnBuilder);
    fn$1.call(child, tail$2(arguments)), this.sequence.additional = (this.sequence.additional || []).concat(child.sequence);
  }
  function unshiftQuery$2(query) {
    query && (isString$12(query) && (query = { sql: query }), query.bindings ||= this.bindingsHolder.bindings, this.sequence.unshift(query), this.formatter = this.client.formatter(this._commonBuilder), this.bindings = [], this.formatter.bindings = this.bindings);
  }
  module2.exports = { pushAdditional: pushAdditional$2, pushQuery: pushQuery$3, unshiftQuery: unshiftQuery$2 };
}), require_compiler$1 = __commonJSMin$1((exports$12, module2) => {
  let { pushQuery: pushQuery$2, pushAdditional: pushAdditional$1, unshiftQuery: unshiftQuery$1 } = require_helpers();
  var SchemaCompiler$13 = class {
    constructor(client, builder) {
      this.builder = builder, this._commonBuilder = this.builder, this.client = client, this.schema = builder._schema, this.bindings = [], this.bindingsHolder = this, this.formatter = client.formatter(builder), this.formatter.bindings = this.bindings, this.sequence = [];
    }
    createSchema() {
      throwOnlyPGError(`createSchema`);
    }
    createSchemaIfNotExists() {
      throwOnlyPGError(`createSchemaIfNotExists`);
    }
    dropSchema() {
      throwOnlyPGError(`dropSchema`);
    }
    dropSchemaIfExists() {
      throwOnlyPGError(`dropSchemaIfExists`);
    }
    dropTable(tableName) {
      this.pushQuery(this.dropTablePrefix + this.formatter.wrap(prefixedTableName$1(this.schema, tableName)));
    }
    dropTableIfExists(tableName) {
      this.pushQuery(this.dropTablePrefix + `if exists ` + this.formatter.wrap(prefixedTableName$1(this.schema, tableName)));
    }
    dropView(viewName) {
      this._dropView(viewName, false, false);
    }
    dropViewIfExists(viewName) {
      this._dropView(viewName, true, false);
    }
    dropMaterializedView(viewName) {
      throw Error(`materialized views are not supported by this dialect.`);
    }
    dropMaterializedViewIfExists(viewName) {
      throw Error(`materialized views are not supported by this dialect.`);
    }
    renameView(from$2, to) {
      throw Error(`rename view is not supported by this dialect (instead drop then create another view).`);
    }
    refreshMaterializedView() {
      throw Error(`materialized views are not supported by this dialect.`);
    }
    _dropView(viewName, ifExists, materialized) {
      this.pushQuery((materialized ? this.dropMaterializedViewPrefix : this.dropViewPrefix) + (ifExists ? `if exists ` : ``) + this.formatter.wrap(prefixedTableName$1(this.schema, viewName)));
    }
    raw(sql, bindings) {
      this.sequence.push(this.client.raw(sql, bindings).toSQL());
    }
    toSQL() {
      let sequence = this.builder._sequence;
      for (let i$4 = 0, l$4 = sequence.length; i$4 < l$4; i$4++) {
        let query = sequence[i$4];
        this[query.method].apply(this, query.args);
      }
      return this.sequence;
    }
    async generateDdlCommands() {
      let generatedCommands = this.toSQL();
      return { pre: [], sql: Array.isArray(generatedCommands) ? generatedCommands : [generatedCommands], check: null, post: [] };
    }
  };
  SchemaCompiler$13.prototype.dropTablePrefix = `drop table `, SchemaCompiler$13.prototype.dropViewPrefix = `drop view `, SchemaCompiler$13.prototype.dropMaterializedViewPrefix = `drop materialized view `, SchemaCompiler$13.prototype.alterViewPrefix = `alter view `, SchemaCompiler$13.prototype.alterTable = buildTable(`alter`), SchemaCompiler$13.prototype.createTable = buildTable(`create`), SchemaCompiler$13.prototype.createTableIfNotExists = buildTable(`createIfNot`), SchemaCompiler$13.prototype.createTableLike = buildTable(`createLike`), SchemaCompiler$13.prototype.createView = buildView(`create`), SchemaCompiler$13.prototype.createViewOrReplace = buildView(`createOrReplace`), SchemaCompiler$13.prototype.createMaterializedView = buildView(`createMaterializedView`), SchemaCompiler$13.prototype.alterView = buildView(`alter`), SchemaCompiler$13.prototype.pushQuery = pushQuery$2, SchemaCompiler$13.prototype.pushAdditional = pushAdditional$1, SchemaCompiler$13.prototype.unshiftQuery = unshiftQuery$1;
  function build(builder) {
    let queryContext = this.builder.queryContext();
    queryContext !== void 0 && builder.queryContext() === void 0 && builder.queryContext(queryContext), builder.setSchema(this.schema);
    let sql = builder.toSQL();
    for (let i$4 = 0, l$4 = sql.length; i$4 < l$4; i$4++) this.sequence.push(sql[i$4]);
  }
  function buildTable(type) {
    return type === `createLike` ? function(tableName, tableNameLike, fn$1) {
      let builder = this.client.tableBuilder(type, tableName, tableNameLike, fn$1);
      build.call(this, builder);
    } : function(tableName, fn$1) {
      let builder = this.client.tableBuilder(type, tableName, null, fn$1);
      build.call(this, builder);
    };
  }
  function buildView(type) {
    return function(viewName, fn$1) {
      let builder = this.client.viewBuilder(type, viewName, fn$1);
      build.call(this, builder);
    };
  }
  function prefixedTableName$1(prefix, table$2) {
    return prefix ? `${prefix}.${table$2}` : table$2;
  }
  function throwOnlyPGError(operationName) {
    throw Error(`${operationName} is not supported for this dialect (only PostgreSQL supports it currently).`);
  }
  module2.exports = SchemaCompiler$13;
}), require_assignIn = __commonJSMin$1((exports$12, module2) => {
  var copyObject = require__copyObject(), createAssigner = require__createAssigner(), keysIn$1 = require_keysIn(), assignIn = createAssigner(function(object, source) {
    copyObject(source, keysIn$1(source), object);
  });
  module2.exports = assignIn;
}), require_extend = __commonJSMin$1((exports$12, module2) => {
  module2.exports = require_assignIn();
}), require_tablebuilder = __commonJSMin$1((exports$12, module2) => {
  let each$3 = require_each(), extend$3 = require_extend(), assign$3 = require_assign(), toArray$4 = require_toArray(), helpers$6 = require_helpers$1(), { isString: isString$11, isFunction: isFunction$1, isObject: isObject$11 } = require_is();
  var TableBuilder$2 = class {
    constructor(client, method$1, tableName, tableNameLike, fn$1) {
      if (this.client = client, this._fn = fn$1, this._method = method$1, this._schemaName = void 0, this._tableName = tableName, this._tableNameLike = tableNameLike, this._statements = [], this._single = {}, !tableNameLike && !isFunction$1(this._fn)) throw TypeError("A callback function must be supplied to calls against `.createTable` and `.table`");
    }
    setSchema(schemaName) {
      this._schemaName = schemaName;
    }
    toSQL() {
      return this._method === `alter` && extend$3(this, AlterMethods$2), this._fn && this._fn.call(this, this), this.client.tableCompiler(this).toSQL();
    }
    timestamps(useTimestamps, defaultToNow, useCamelCase) {
      isObject$11(useTimestamps) && ({ useTimestamps, defaultToNow, useCamelCase } = useTimestamps);
      let method$1 = useTimestamps === true ? `timestamp` : `datetime`, createdAt = this[method$1](useCamelCase ? `createdAt` : `created_at`), updatedAt = this[method$1](useCamelCase ? `updatedAt` : `updated_at`);
      if (defaultToNow === true) {
        let now$3 = this.client.raw(`CURRENT_TIMESTAMP`);
        createdAt.notNullable().defaultTo(now$3), updatedAt.notNullable().defaultTo(now$3);
      }
    }
    comment(value) {
      if (typeof value != `string`) throw TypeError(`Table comment must be string`);
      this._single.comment = value;
    }
    foreign(column, keyName) {
      let foreignData = { column, keyName };
      this._statements.push({ grouping: `alterTable`, method: `foreign`, args: [foreignData] });
      let returnObj = { references(tableColumn) {
        let pieces;
        return isString$11(tableColumn) && (pieces = tableColumn.split(`.`)), !pieces || pieces.length === 1 ? (foreignData.references = pieces ? pieces[0] : tableColumn, { on(tableName) {
          if (typeof tableName != `string`) throw TypeError(`Expected tableName to be a string, got: ${typeof tableName}`);
          return foreignData.inTable = tableName, returnObj;
        }, inTable() {
          return this.on.apply(this, arguments);
        } }) : (foreignData.inTable = pieces[0], foreignData.references = pieces[1], returnObj);
      }, withKeyName(keyName$1) {
        return foreignData.keyName = keyName$1, returnObj;
      }, onUpdate(statement) {
        return foreignData.onUpdate = statement, returnObj;
      }, onDelete(statement) {
        return foreignData.onDelete = statement, returnObj;
      }, deferrable: (type) => {
        let unSupported = [`mysql`, `mssql`, `redshift`, `mysql2`, `oracledb`];
        if (unSupported.indexOf(this.client.dialect) !== -1) throw Error(`${this.client.dialect} does not support deferrable`);
        return foreignData.deferrable = type, returnObj;
      }, _columnBuilder(builder) {
        return extend$3(builder, returnObj), returnObj = builder, builder;
      } };
      return returnObj;
    }
    check(checkPredicate, bindings, constraintName$2) {
      return this._statements.push({ grouping: `checks`, args: [checkPredicate, bindings, constraintName$2] }), this;
    }
  };
  [`index`, `primary`, `unique`, `dropPrimary`, `dropUnique`, `dropIndex`, `dropForeign`].forEach((method$1) => {
    TableBuilder$2.prototype[method$1] = function() {
      return this._statements.push({ grouping: `alterTable`, method: method$1, args: toArray$4(arguments) }), this;
    };
  });
  let specialMethods = { mysql: [`engine`, `charset`, `collate`], postgresql: [`inherits`] };
  each$3(specialMethods, function(methods$1, dialect) {
    methods$1.forEach(function(method$1) {
      TableBuilder$2.prototype[method$1] = function(value) {
        if (this.client.dialect !== dialect) throw Error(`Knex only supports ${method$1} statement with ${dialect}.`);
        if (this._method === `alter`) throw Error(`Knex does not support altering the ${method$1} outside of create table, please use knex.raw statement.`);
        this._single[method$1] = value;
      };
    });
  }), helpers$6.addQueryContext(TableBuilder$2);
  let columnTypes = `tinyint.smallint.mediumint.int.bigint.decimal.float.double.real.bit.boolean.serial.date.datetime.timestamp.time.year.geometry.geography.point.char.varchar.tinytext.tinyText.text.mediumtext.mediumText.longtext.longText.binary.varbinary.tinyblob.tinyBlob.mediumblob.mediumBlob.blob.longblob.longBlob.enum.set.bool.dateTime.increments.bigincrements.bigIncrements.integer.biginteger.bigInteger.string.json.jsonb.uuid.enu.specificType`.split(`.`);
  columnTypes.forEach((type) => {
    TableBuilder$2.prototype[type] = function() {
      let args$1 = toArray$4(arguments), builder = this.client.columnBuilder(this, type, args$1);
      return this._statements.push({ grouping: `columns`, builder }), builder;
    };
  });
  let AlterMethods$2 = { renameColumn(from$2, to) {
    return this._statements.push({ grouping: `alterTable`, method: `renameColumn`, args: [from$2, to] }), this;
  }, dropTimestamps() {
    return this.dropColumns(arguments[0] === true ? [`createdAt`, `updatedAt`] : [`created_at`, `updated_at`]);
  }, setNullable(column) {
    return this._statements.push({ grouping: `alterTable`, method: `setNullable`, args: [column] }), this;
  }, check(checkPredicate, bindings, constraintName$2) {
    this._statements.push({ grouping: `alterTable`, method: `check`, args: [checkPredicate, bindings, constraintName$2] });
  }, dropChecks() {
    this._statements.push({ grouping: `alterTable`, method: `dropChecks`, args: toArray$4(arguments) });
  }, dropNullable(column) {
    return this._statements.push({ grouping: `alterTable`, method: `dropNullable`, args: [column] }), this;
  } };
  AlterMethods$2.dropColumn = AlterMethods$2.dropColumns = function() {
    return this._statements.push({ grouping: `alterTable`, method: `dropColumn`, args: toArray$4(arguments) }), this;
  }, TableBuilder$2.extend = (methodName, fn$1) => {
    if (Object.prototype.hasOwnProperty.call(TableBuilder$2.prototype, methodName)) throw Error(`Can't extend TableBuilder with existing method ('${methodName}').`);
    assign$3(TableBuilder$2.prototype, { [methodName]: fn$1 });
  }, module2.exports = TableBuilder$2;
}), require_method_constants = __commonJSMin$1((exports$12, module2) => {
  module2.exports = `with.withRecursive.withMaterialized.withNotMaterialized.select.as.columns.column.from.fromJS.fromRaw.into.withSchema.table.distinct.join.joinRaw.innerJoin.leftJoin.leftOuterJoin.rightJoin.rightOuterJoin.outerJoin.fullOuterJoin.crossJoin.where.andWhere.orWhere.whereNot.orWhereNot.whereLike.andWhereLike.orWhereLike.whereILike.andWhereILike.orWhereILike.whereRaw.whereWrapped.havingWrapped.orWhereRaw.whereExists.orWhereExists.whereNotExists.orWhereNotExists.whereIn.orWhereIn.whereNotIn.orWhereNotIn.whereNull.orWhereNull.whereNotNull.orWhereNotNull.whereBetween.whereNotBetween.andWhereBetween.andWhereNotBetween.orWhereBetween.orWhereNotBetween.groupBy.groupByRaw.orderBy.orderByRaw.union.unionAll.intersect.except.having.havingRaw.orHaving.orHavingRaw.offset.limit.count.countDistinct.min.max.sum.sumDistinct.avg.avgDistinct.increment.decrement.first.debug.pluck.clearSelect.clearWhere.clearGroup.clearOrder.clearHaving.insert.update.returning.del.delete.truncate.transacting.connection.jsonExtract.jsonSet.jsonInsert.jsonRemove.whereJsonObject.orWhereJsonObject.andWhereJsonObject.whereNotJsonObject.orWhereNotJsonObject.andWhereNotJsonObject.whereJsonPath.orWhereJsonPath.andWhereJsonPath.whereJsonSupersetOf.orWhereJsonSupersetOf.andWhereJsonSupersetOf.whereJsonNotSupersetOf.orWhereJsonNotSupersetOf.andWhereJsonNotSupersetOf.whereJsonSubsetOf.orWhereJsonSubsetOf.andWhereJsonSubsetOf.whereJsonNotSubsetOf.orWhereJsonNotSubsetOf.andWhereJsonNotSubsetOf`.split(`.`);
}), require_FunctionHelper = __commonJSMin$1((exports$12, module2) => {
  init_dist$1();
  var FunctionHelper$1 = class {
    constructor(client) {
      this.client = client;
    }
    now(precision) {
      return typeof precision == `number` ? this.client.raw(`CURRENT_TIMESTAMP(${precision})`) : this.client.raw(`CURRENT_TIMESTAMP`);
    }
    uuid() {
      switch (this.client.driverName) {
        case `sqlite3`:
        case `better-sqlite3`:
          return this.client.raw(`(lower(hex(randomblob(4))) || '-' || lower(hex(randomblob(2))) || '-4' || substr(lower(hex(randomblob(2))),2) || '-' || substr('89ab',abs(random()) % 4 + 1, 1) || substr(lower(hex(randomblob(2))),2) || '-' || lower(hex(randomblob(6))))`);
        case `mssql`:
          return this.client.raw(`(NEWID())`);
        case `pg`:
        case `pgnative`:
        case `cockroachdb`:
          return this.client.raw(`(gen_random_uuid())`);
        case `oracle`:
        case `oracledb`:
          return this.client.raw(`(random_uuid())`);
        case `mysql`:
        case `mysql2`:
          return this.client.raw(`(UUID())`);
        default:
          throw Error(`${this.client.driverName} does not have a uuid function`);
      }
    }
    uuidToBin(uuid, ordered = true) {
      let buf = Buffer$1.from(uuid.replace(/-/g, ``), `hex`);
      return ordered ? Buffer$1.concat([buf.slice(6, 8), buf.slice(4, 6), buf.slice(0, 4), buf.slice(8, 16)]) : Buffer$1.concat([buf.slice(0, 4), buf.slice(4, 6), buf.slice(6, 8), buf.slice(8, 16)]);
    }
    binToUuid(bin, ordered = true) {
      let buf = Buffer$1.from(bin, `hex`);
      return ordered ? [buf.toString(`hex`, 4, 8), buf.toString(`hex`, 2, 4), buf.toString(`hex`, 0, 2), buf.toString(`hex`, 8, 10), buf.toString(`hex`, 10, 16)].join(`-`) : [buf.toString(`hex`, 0, 4), buf.toString(`hex`, 4, 6), buf.toString(`hex`, 6, 8), buf.toString(`hex`, 8, 10), buf.toString(`hex`, 10, 16)].join(`-`);
    }
  };
  module2.exports = FunctionHelper$1;
});
function makeKnex(client) {
  function knex$2(tableName, options) {
    return createQueryBuilder(knex$2.context, tableName, options);
  }
  return redefineProperties(knex$2, client), knex$2;
}
var import_events$2, import_method_constants$1, import_FunctionHelper, KNEX_PROPERTY_DEFINITIONS, CONTEXT_METHODS, createQueryBuilder, addInternalListener, copyEventListeners, initContext, redefineProperties, init_make_knex = __esmMin(() => {
  import_events$2 = __toESM(require_events()), import_method_constants$1 = __toESM(require_method_constants()), import_FunctionHelper = __toESM(require_FunctionHelper()), KNEX_PROPERTY_DEFINITIONS = { client: { get() {
    return this.context.client;
  }, set(client) {
    this.context.client = client;
  }, configurable: true }, userParams: { get() {
    return this.context.userParams;
  }, set(userParams) {
    this.context.userParams = userParams;
  }, configurable: true }, fn: { get() {
    return new import_FunctionHelper.default(this.client);
  }, configurable: true } }, CONTEXT_METHODS = [`raw`, `transaction`, `transactionProvider`, `initialize`, `destroy`, `ref`, `withUserParams`, `queryBuilder`, `disableProcessing`, `enableProcessing`];
  for (let m$3 of CONTEXT_METHODS) KNEX_PROPERTY_DEFINITIONS[m$3] = { value: function(...args$1) {
    return this.context[m$3](...args$1);
  }, configurable: true };
  createQueryBuilder = (knexContext, tableName, options) => {
    let qb = knexContext.queryBuilder();
    return tableName ? qb.table(tableName, options) : qb;
  }, addInternalListener = (knex$2, eventName, listener) => {
    knex$2.client.on(eventName, listener), knex$2._internalListeners.push({ eventName, listener });
  }, copyEventListeners = (eventName, sourceKnex, targetKnex) => {
    let listeners = sourceKnex.listeners(eventName);
    listeners.forEach((listener) => {
      targetKnex.on(eventName, listener);
    });
  }, initContext = (knexFn) => {
    let knexContext = knexFn.context || {};
    Object.assign(knexContext, { queryBuilder() {
      return this.client.queryBuilder();
    }, raw() {
      return this.client.raw.apply(this.client, arguments);
    }, batchInsert(table$2, batch, chunkSize = 1e3) {
      return batchInsert(this, table$2, batch, chunkSize);
    }, transaction(container, _config) {
      !_config && isObject(container) && (_config = container, container = null);
      let config = Object.assign({}, _config);
      return config.userParams = this.userParams || {}, config.doNotRejectOnRollback === void 0 && (config.doNotRejectOnRollback = true), this._transaction(container, config);
    }, _transaction(container, config, outerTx = null) {
      if (container) {
        let trx = this.client.transaction(container, config, outerTx);
        return trx;
      } else return new Promise((resolve, reject$2) => {
        this.client.transaction(resolve, config, outerTx).catch(reject$2);
      });
    }, transactionProvider(config) {
      let trx;
      return () => (trx ||= this.transaction(void 0, config), trx);
    }, initialize(config) {
      return this.client.initializePool(config);
    }, destroy(callback) {
      return this.client.destroy(callback);
    }, ref(ref) {
      return this.client.ref(ref);
    }, disableProcessing() {
      this.userParams.isProcessingDisabled || (this.userParams.wrapIdentifier = this.client.config.wrapIdentifier, this.userParams.postProcessResponse = this.client.config.postProcessResponse, this.client.config.wrapIdentifier = null, this.client.config.postProcessResponse = null, this.userParams.isProcessingDisabled = true);
    }, enableProcessing() {
      this.userParams.isProcessingDisabled && (this.client.config.wrapIdentifier = this.userParams.wrapIdentifier, this.client.config.postProcessResponse = this.userParams.postProcessResponse, this.userParams.isProcessingDisabled = false);
    }, withUserParams(params) {
      let knexClone = shallowCloneFunction(knexFn);
      return this.client && (knexClone.client = Object.create(this.client.constructor.prototype), merge(knexClone.client, this.client), knexClone.client.config = Object.assign({}, this.client.config), this.client.config.password && setHiddenProperty(knexClone.client.config, this.client.config)), redefineProperties(knexClone, knexClone.client), copyEventListeners(`query`, knexFn, knexClone), copyEventListeners(`query-error`, knexFn, knexClone), copyEventListeners(`query-response`, knexFn, knexClone), copyEventListeners(`start`, knexFn, knexClone), knexClone.userParams = params, knexClone;
    } }), knexFn.context ||= knexContext;
  }, redefineProperties = (knex$2, client) => {
    for (let method$1 of import_method_constants$1.default) knex$2[method$1] = function() {
      let builder = this.queryBuilder();
      return builder[method$1].apply(builder, arguments);
    };
    Object.defineProperties(knex$2, KNEX_PROPERTY_DEFINITIONS), initContext(knex$2), knex$2.client = client, knex$2.userParams = {};
    let ee$1 = new import_events$2.EventEmitter();
    for (let key in ee$1) knex$2[key] = ee$1[key];
    knex$2._internalListeners && knex$2._internalListeners.forEach(({ eventName, listener }) => {
      knex$2.client.removeListener(eventName, listener);
    }), knex$2._internalListeners = [], addInternalListener(knex$2, `start`, (obj) => {
      knex$2.emit(`start`, obj);
    }), addInternalListener(knex$2, `query`, (obj) => {
      knex$2.emit(`query`, obj);
    }), addInternalListener(knex$2, `query-error`, (err$1, obj) => {
      knex$2.emit(`query-error`, err$1, obj);
    }), addInternalListener(knex$2, `query-response`, (response, obj, builder) => {
      knex$2.emit(`query-response`, response, obj, builder);
    });
  };
}), transaction_exports = {};
__export(transaction_exports, { default: () => transaction_default });
function DEFAULT_CONFIG() {
  return { userParams: {}, doNotRejectOnRollback: true };
}
function makeTransactor(trx, connection, trxClient) {
  let transactor = makeKnex(trxClient);
  return transactor.context.withUserParams = () => {
    throw Error(`Cannot set user params on a transaction - it can only inherit params from main knex instance`);
  }, transactor.isTransaction = true, transactor.userParams = trx.userParams || {}, transactor.context.transaction = function(container, options) {
    return options ? options.doNotRejectOnRollback === void 0 && (options.doNotRejectOnRollback = true) : options = { doNotRejectOnRollback: true }, this._transaction(container, options, trx);
  }, transactor.savepoint = function(container, options) {
    return transactor.transaction(container, options);
  }, trx.client.transacting ? (transactor.commit = (value) => trx.release(connection, value), transactor.rollback = (error) => trx.rollbackTo(connection, error)) : (transactor.commit = (value) => trx.commit(connection, value), transactor.rollback = (error) => trx.rollback(connection, error)), transactor.isCompleted = () => trx.isCompleted(), transactor;
}
function makeTxClient(trx, client, connection) {
  let trxClient = Object.create(client.constructor.prototype);
  trxClient.version = client.version, trxClient.config = client.config, trxClient.driver = client.driver, trxClient.connectionSettings = client.connectionSettings, trxClient.transacting = true, trxClient.valueForUndefined = client.valueForUndefined, trxClient.logger = client.logger, trxClient.on(`start`, function(arg) {
    trx.emit(`start`, arg), client.emit(`start`, arg);
  }), trxClient.on(`query`, function(arg) {
    trx.emit(`query`, arg), client.emit(`query`, arg);
  }), trxClient.on(`query-error`, function(err$1, obj) {
    trx.emit(`query-error`, err$1, obj), client.emit(`query-error`, err$1, obj);
  }), trxClient.on(`query-response`, function(response, obj, builder) {
    trx.emit(`query-response`, response, obj, builder), client.emit(`query-response`, response, obj, builder);
  });
  let cachedQuery = trxClient.query;
  trxClient.query = function(conn, obj) {
    let completed = trx.isCompleted();
    return new Promise(function(resolve, reject$2) {
      try {
        if (conn !== connection) throw Error(`Invalid connection for transaction query.`);
        completed && completedError(trx, obj), resolve(cachedQuery.call(trxClient, conn, obj));
      } catch (e$22) {
        reject$2(e$22);
      }
    });
  };
  let cachedStream = trxClient.stream;
  return trxClient.stream = function(conn, obj, stream$1, options) {
    let completed = trx.isCompleted();
    return new Promise(function(resolve, reject$2) {
      try {
        if (conn !== connection) throw Error(`Invalid connection for transaction query.`);
        completed && completedError(trx, obj), resolve(cachedStream.call(trxClient, conn, obj, stream$1, options));
      } catch (e$22) {
        reject$2(e$22);
      }
    });
  }, trxClient.acquireConnection = function() {
    return Promise.resolve(connection);
  }, trxClient.releaseConnection = function() {
    return Promise.resolve();
  }, trxClient;
}
function completedError(_trx, _obj) {
  throw Error(`Transaction query already complete, run with DEBUG=knex:tx for more info`);
}
var import_util$1, import_events$1, import_uniqueId$1, import_timeout$2, import_finally_mixin, validIsolationLevels, Transaction$16, transaction_default, init_transaction = __esmMin(() => {
  init_make_knex(), import_util$1 = __toESM(require_util()), import_events$1 = __toESM(require_events()), import_uniqueId$1 = __toESM(require_uniqueId()), import_timeout$2 = __toESM(require_timeout()), import_finally_mixin = __toESM(require_finally_mixin()), validIsolationLevels = [`read uncommitted`, `read committed`, `snapshot`, `repeatable read`, `serializable`], Transaction$16 = class extends import_events$1.EventEmitter {
    userParams;
    doNotRejectOnRollback;
    txid;
    client;
    logger;
    outerTx;
    trxClient;
    _completed;
    _debug;
    readOnly;
    isolationLevel;
    _lastChild;
    _promise;
    _resolver;
    _rejecter;
    transactor;
    constructor(client, container, config = DEFAULT_CONFIG(), outerTx = null) {
      super(), this.userParams = config.userParams, this.doNotRejectOnRollback = config.doNotRejectOnRollback, this.txid = (0, import_uniqueId$1.default)(`trx`), this.client = client, this.logger = client.logger, this.outerTx = outerTx, this.trxClient = void 0, this._completed = false, this._debug = client.config && client.config.debug, this.readOnly = config.readOnly, config.isolationLevel && this.setIsolationLevel(config.isolationLevel), this._lastChild = Promise.resolve();
      let previousSibling = outerTx ? outerTx._lastChild : Promise.resolve(), basePromise = previousSibling.then(() => this._evaluateContainer(config, container));
      this._promise = basePromise.then((x$1) => x$1), outerTx && (outerTx._lastChild = basePromise.catch(() => {
      }));
    }
    isCompleted() {
      return this._completed || this.outerTx && this.outerTx.isCompleted() || false;
    }
    begin(conn) {
      let trxMode = [this.isolationLevel ? `ISOLATION LEVEL ${this.isolationLevel}` : ``, this.readOnly ? `READ ONLY` : ``].join(` `).trim();
      return trxMode.length === 0 ? this.query(conn, `BEGIN;`) : this.query(conn, `SET TRANSACTION ${trxMode};`).then(() => this.query(conn, `BEGIN;`));
    }
    savepoint(conn) {
      return this.query(conn, `SAVEPOINT ${this.txid};`);
    }
    commit(conn, value) {
      return this.query(conn, `COMMIT;`, 1, value);
    }
    release(conn, value) {
      return this.query(conn, `RELEASE SAVEPOINT ${this.txid};`, 1, value);
    }
    setIsolationLevel(isolationLevel) {
      if (!validIsolationLevels.includes(isolationLevel)) throw Error(`Invalid isolationLevel, supported isolation levels are: ${JSON.stringify(validIsolationLevels)}`);
      return this.isolationLevel = isolationLevel, this;
    }
    rollback(conn, error) {
      return (0, import_timeout$2.timeout)(this.query(conn, `ROLLBACK`, 2, error), 5e3).catch((err$1) => {
        if (!(err$1 instanceof import_timeout$2.KnexTimeoutError)) return Promise.reject(err$1);
        this._rejecter(error);
      });
    }
    rollbackTo(conn, error) {
      return (0, import_timeout$2.timeout)(this.query(conn, `ROLLBACK TO SAVEPOINT ${this.txid}`, 2, error), 5e3).catch((err$1) => {
        if (!(err$1 instanceof import_timeout$2.KnexTimeoutError)) return Promise.reject(err$1);
        this._rejecter(error);
      });
    }
    query(conn, sql, status, value) {
      let q = this.trxClient.query(conn, sql).catch((err$1) => {
        status = 2, value = err$1, this._completed = true;
      }).then((res) => {
        if (status === 1 && this._resolver(value), status === 2) {
          if (value === void 0) {
            if (this.doNotRejectOnRollback && /^ROLLBACK\b/i.test(sql)) {
              this._resolver();
              return;
            }
            value = Error(`Transaction rejected with non-error: ${value}`);
          }
          this._rejecter(value);
        }
        return res;
      });
      return (status === 1 || status === 2) && (this._completed = true), q;
    }
    debug(enabled) {
      return this._debug = arguments.length ? enabled : true, this;
    }
    async _evaluateContainer(config, container) {
      return this.acquireConnection(config, (connection) => {
        let trxClient = this.trxClient = makeTxClient(this, this.client, connection), init$1 = this.client.transacting ? this.savepoint(connection) : this.begin(connection), executionPromise = new Promise((resolver, rejecter) => {
          this._resolver = resolver, this._rejecter = rejecter;
        });
        return init$1.then(() => makeTransactor(this, connection, trxClient)).then((transactor) => {
          this.transactor = transactor, this.outerTx && (transactor.parentTransaction = this.outerTx.transactor), transactor.executionPromise = executionPromise;
          let result;
          try {
            result = container(transactor);
          } catch (err$1) {
            result = Promise.reject(err$1);
          }
          return result && result.then && typeof result.then == `function` && result.then((val) => transactor.commit(val)).catch((err$1) => transactor.rollback(err$1)), null;
        }).catch((e$22) => this._rejecter(e$22)), executionPromise;
      });
    }
    async acquireConnection(config, cb) {
      let configConnection = config && config.connection, connection = configConnection || await this.client.acquireConnection();
      try {
        return connection.__knexTxId = this.txid, await cb(connection);
      } finally {
        configConnection || this.client.releaseConnection(connection);
      }
    }
    then(onResolve, onReject) {
      return this._promise.then(onResolve, onReject);
    }
    catch(...args$1) {
      return this._promise.catch(...args$1);
    }
    asCallback(cb) {
      return (0, import_util$1.callbackify)(() => this._promise)(cb), this._promise;
    }
  }, (0, import_finally_mixin.default)(Transaction$16.prototype), transaction_default = Transaction$16;
}), require_compact = __commonJSMin$1((exports$12, module2) => {
  function compact$3(array) {
    for (var index$2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result = []; ++index$2 < length; ) {
      var value = array[index$2];
      value && (result[resIndex++] = value);
    }
    return result;
  }
  module2.exports = compact$3;
}), require__arrayAggregator = __commonJSMin$1((exports$12, module2) => {
  function arrayAggregator$1(array, setter, iteratee, accumulator) {
    for (var index$2 = -1, length = array == null ? 0 : array.length; ++index$2 < length; ) {
      var value = array[index$2];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }
  module2.exports = arrayAggregator$1;
}), require__baseAggregator = __commonJSMin$1((exports$12, module2) => {
  var baseEach$2 = require__baseEach();
  function baseAggregator$1(collection, setter, iteratee, accumulator) {
    return baseEach$2(collection, function(value, key, collection$1) {
      setter(accumulator, value, iteratee(value), collection$1);
    }), accumulator;
  }
  module2.exports = baseAggregator$1;
}), require__createAggregator = __commonJSMin$1((exports$12, module2) => {
  var arrayAggregator = require__arrayAggregator(), baseAggregator = require__baseAggregator(), baseIteratee$5 = require__baseIteratee(), isArray$5 = require_isArray();
  function createAggregator$1(setter, initializer) {
    return function(collection, iteratee) {
      var func = isArray$5(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
      return func(collection, setter, baseIteratee$5(iteratee, 2), accumulator);
    };
  }
  module2.exports = createAggregator$1;
}), require_groupBy = __commonJSMin$1((exports$12, module2) => {
  var baseAssignValue = require__baseAssignValue(), createAggregator = require__createAggregator(), objectProto$2 = Object.prototype, hasOwnProperty$4 = objectProto$2.hasOwnProperty, groupBy$4 = createAggregator(function(result, value, key) {
    hasOwnProperty$4.call(result, key) ? result[key].push(value) : baseAssignValue(result, key, [value]);
  });
  module2.exports = groupBy$4;
}), require__baseHas = __commonJSMin$1((exports$12, module2) => {
  var objectProto$1 = Object.prototype, hasOwnProperty$3 = objectProto$1.hasOwnProperty;
  function baseHas$1(object, key) {
    return object != null && hasOwnProperty$3.call(object, key);
  }
  module2.exports = baseHas$1;
}), require_has = __commonJSMin$1((exports$12, module2) => {
  var baseHas = require__baseHas(), hasPath = require__hasPath();
  function has$4(object, path) {
    return object != null && hasPath(object, path, baseHas);
  }
  module2.exports = has$4;
}), require__baseMap = __commonJSMin$1((exports$12, module2) => {
  var baseEach$1 = require__baseEach(), isArrayLike = require_isArrayLike();
  function baseMap$1(collection, iteratee) {
    var index$2 = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
    return baseEach$1(collection, function(value, key, collection$1) {
      result[++index$2] = iteratee(value, key, collection$1);
    }), result;
  }
  module2.exports = baseMap$1;
}), require_map = __commonJSMin$1((exports$12, module2) => {
  var arrayMap$1 = require__arrayMap(), baseIteratee$4 = require__baseIteratee(), baseMap = require__baseMap(), isArray$4 = require_isArray();
  function map$7(collection, iteratee) {
    var func = isArray$4(collection) ? arrayMap$1 : baseMap;
    return func(collection, baseIteratee$4(iteratee, 3));
  }
  module2.exports = map$7;
}), require__baseSet = __commonJSMin$1((exports$12, module2) => {
  var assignValue = require__assignValue(), castPath$1 = require__castPath(), isIndex = require__isIndex(), isObject$10 = require_isObject(), toKey = require__toKey();
  function baseSet$1(object, path, value, customizer) {
    if (!isObject$10(object)) return object;
    path = castPath$1(path, object);
    for (var index$2 = -1, length = path.length, lastIndex = length - 1, nested = object; nested != null && ++index$2 < length; ) {
      var key = toKey(path[index$2]), newValue = value;
      if (key === `__proto__` || key === `constructor` || key === `prototype`) return object;
      if (index$2 != lastIndex) {
        var objValue = nested[key];
        newValue = customizer ? customizer(objValue, key, nested) : void 0, newValue === void 0 && (newValue = isObject$10(objValue) ? objValue : isIndex(path[index$2 + 1]) ? [] : {});
      }
      assignValue(nested, key, newValue), nested = nested[key];
    }
    return object;
  }
  module2.exports = baseSet$1;
}), require__basePickBy = __commonJSMin$1((exports$12, module2) => {
  var baseGet = require__baseGet(), baseSet = require__baseSet(), castPath = require__castPath();
  function basePickBy$1(object, paths, predicate) {
    for (var index$2 = -1, length = paths.length, result = {}; ++index$2 < length; ) {
      var path = paths[index$2], value = baseGet(object, path);
      predicate(value, path) && baseSet(result, castPath(path, object), value);
    }
    return result;
  }
  module2.exports = basePickBy$1;
}), require_pickBy = __commonJSMin$1((exports$12, module2) => {
  var arrayMap = require__arrayMap(), baseIteratee$3 = require__baseIteratee(), basePickBy = require__basePickBy(), getAllKeysIn = require__getAllKeysIn();
  function pickBy$1(object, predicate) {
    if (object == null) return {};
    var props = arrayMap(getAllKeysIn(object), function(prop) {
      return [prop];
    });
    return predicate = baseIteratee$3(predicate), basePickBy(object, props, function(value, path) {
      return predicate(value, path[0]);
    });
  }
  module2.exports = pickBy$1;
}), require_omitBy = __commonJSMin$1((exports$12, module2) => {
  var baseIteratee$2 = require__baseIteratee(), negate = require_negate(), pickBy = require_pickBy();
  function omitBy$1(object, predicate) {
    return pickBy(object, negate(baseIteratee$2(predicate)));
  }
  module2.exports = omitBy$1;
}), require_querycompiler = __commonJSMin$1((exports$12, module2) => {
  let helpers$5 = require_helpers$1(), Raw$5 = require_raw(), QueryBuilder$12 = require_querybuilder(), JoinClause = require_joinclause(), debug$10 = require_src(), assign$2 = require_assign(), compact$2 = require_compact(), groupBy$3 = require_groupBy(), has$3 = require_has(), isEmpty$9 = require_isEmpty(), map$6 = require_map(), omitBy = require_omitBy(), reduce$3 = require_reduce(), { nanoid } = require_nanoid(), { isString: isString$10, isUndefined: isUndefined$22 } = require_is(), { columnize: columnize_$10, direction: direction_, operator: operator_$4, wrap: wrap_$3, unwrapRaw: unwrapRaw_, rawOrFn: rawOrFn_ } = require_wrappingFormatter(), debugBindings = debug$10(`knex:bindings`), components$2 = [`comments`, `columns`, `join`, `where`, `union`, `group`, `having`, `order`, `limit`, `offset`, `lock`, `waitMode`];
  var QueryCompiler$14 = class {
    constructor(client, builder, bindings) {
      this.client = client, this.method = builder._method || `select`, this.options = builder._options, this.single = builder._single, this.queryComments = builder._comments, this.timeout = builder._timeout || false, this.cancelOnTimeout = builder._cancelOnTimeout || false, this.grouped = groupBy$3(builder._statements, `grouping`), this.formatter = client.formatter(builder), this._emptyInsertValue = `default values`, this.first = this.select, this.bindings = bindings || [], this.formatter.bindings = this.bindings, this.bindingsHolder = this, this.builder = this.formatter.builder;
    }
    toSQL(method$1, tz) {
      this._undefinedInWhereClause = false, this.undefinedBindingsInfo = [], method$1 ||= this.method;
      let val = this[method$1]() || ``, query = { method: method$1, options: reduce$3(this.options, assign$2, {}), timeout: this.timeout, cancelOnTimeout: this.cancelOnTimeout, bindings: this.bindingsHolder.bindings || [], __knexQueryUid: nanoid() };
      if (Object.defineProperties(query, { toNative: { value: () => ({ sql: this.client.positionBindings(query.sql), bindings: this.client.prepBindings(query.bindings) }), enumerable: false } }), isString$10(val) ? query.sql = val : assign$2(query, val), (method$1 === `select` || method$1 === `first`) && this.single.as && (query.as = this.single.as), this._undefinedInWhereClause) throw debugBindings(query.bindings), Error(`Undefined binding(s) detected when compiling ${method$1.toUpperCase()}. Undefined column(s): [${this.undefinedBindingsInfo.join(`, `)}] query: ${query.sql}`);
      return query;
    }
    select() {
      let sql = this.with(), unionStatement = ``, firstStatements = [], endStatements = [];
      components$2.forEach((component) => {
        let statement = this[component](this);
        switch (component) {
          case `union`:
            unionStatement = statement;
            break;
          case `comments`:
          case `columns`:
          case `join`:
          case `where`:
            firstStatements.push(statement);
            break;
          default:
            endStatements.push(statement);
            break;
        }
      });
      let wrapMainQuery = this.grouped.union && this.grouped.union.map((u) => u.wrap).some((u) => u);
      if (this.onlyUnions()) {
        let statements = compact$2(firstStatements.concat(endStatements)).join(` `);
        sql += unionStatement + (statements ? ` ` + statements : ``);
      } else {
        let allStatements = (wrapMainQuery ? `(` : ``) + compact$2(firstStatements).join(` `) + (wrapMainQuery ? `)` : ``), endStat = compact$2(endStatements).join(` `);
        sql += allStatements + (unionStatement ? ` ` + unionStatement : ``) + (endStat && ` ` + endStat);
      }
      return sql;
    }
    pluck() {
      let toPluck = this.single.pluck;
      return toPluck.indexOf(`.`) !== -1 && (toPluck = toPluck.split(`.`).slice(-1)[0]), { sql: this.select(), pluck: toPluck };
    }
    insert() {
      let insertValues = this.single.insert || [], sql = this.with() + `insert into ${this.tableName} `, body = this._insertBody(insertValues);
      return body === `` ? `` : sql + body;
    }
    _onConflictClause(columns) {
      return columns instanceof Raw$5 ? this.formatter.wrap(columns) : `(${this.formatter.columnize(columns)})`;
    }
    _buildInsertValues(insertData) {
      let sql = ``, i$4 = -1;
      for (; ++i$4 < insertData.values.length; ) i$4 !== 0 && (sql += `), (`), sql += this.client.parameterize(insertData.values[i$4], this.client.valueForUndefined, this.builder, this.bindingsHolder);
      return sql;
    }
    _insertBody(insertValues) {
      let sql = ``;
      if (Array.isArray(insertValues)) {
        if (insertValues.length === 0) return ``;
      } else if (typeof insertValues == `object` && isEmpty$9(insertValues)) return sql + this._emptyInsertValue;
      let insertData = this._prepInsert(insertValues);
      return typeof insertData == `string` ? sql += insertData : insertData.columns.length ? (sql += `(${columnize_$10(insertData.columns, this.builder, this.client, this.bindingsHolder)}`, sql += `) values (` + this._buildInsertValues(insertData) + `)`) : insertValues.length === 1 && insertValues[0] ? sql += this._emptyInsertValue : sql = ``, sql;
    }
    update() {
      let withSQL = this.with(), { tableName } = this, updateData = this._prepUpdate(this.single.update), wheres = this.where();
      return withSQL + `update ${this.single.only ? `only ` : ``}${tableName} set ` + updateData.join(`, `) + (wheres ? ` ${wheres}` : ``);
    }
    _hintComments() {
      let hints = this.grouped.hintComments || [];
      return hints = hints.map((hint) => compact$2(hint.value).join(` `)), hints = compact$2(hints).join(` `), hints ? `/*+ ${hints} */ ` : ``;
    }
    columns() {
      let distinctClause = ``;
      if (this.onlyUnions()) return ``;
      let hints = this._hintComments(), columns = this.grouped.columns || [], i$4 = -1, sql = [];
      if (columns) for (; ++i$4 < columns.length; ) {
        let stmt = columns[i$4];
        if (stmt.distinct && (distinctClause = `distinct `), stmt.distinctOn) {
          distinctClause = this.distinctOn(stmt.value);
          continue;
        }
        stmt.type === `aggregate` ? sql.push(...this.aggregate(stmt)) : stmt.type === `aggregateRaw` ? sql.push(this.aggregateRaw(stmt)) : stmt.type === `analytic` ? sql.push(this.analytic(stmt)) : stmt.type === `json` ? sql.push(this.json(stmt)) : stmt.value && stmt.value.length > 0 && sql.push(columnize_$10(stmt.value, this.builder, this.client, this.bindingsHolder));
      }
      sql.length === 0 && (sql = [`*`]);
      let select = this.onlyJson() ? `` : `select `;
      return `${select}${hints}${distinctClause}` + sql.join(`, `) + (this.tableName ? ` from ${this.single.only ? `only ` : ``}${this.tableName}` : ``);
    }
    comments() {
      return this.queryComments.length ? this.queryComments.map((comment) => `/* ${comment.comment} */`).join(` `) : ``;
    }
    _aggregate(stmt, { aliasSeparator = ` as `, distinctParentheses } = {}) {
      let value = stmt.value, method$1 = stmt.method, distinct = stmt.aggregateDistinct ? `distinct ` : ``, wrap$2 = (identifier$2) => wrap_$3(identifier$2, void 0, this.builder, this.client, this.bindingsHolder), addAlias = (value$1, alias$1) => alias$1 ? value$1 + aliasSeparator + wrap$2(alias$1) : value$1, aggregateArray = (value$1, alias$1) => {
        let columns = value$1.map(wrap$2).join(`, `);
        if (distinct) {
          let openParen = distinctParentheses ? `(` : ` `, closeParen = distinctParentheses ? `)` : ``;
          columns = distinct.trim() + openParen + columns + closeParen;
        }
        let aggregated = `${method$1}(${columns})`;
        return addAlias(aggregated, alias$1);
      }, aggregateString = (value$1, alias$1) => {
        let aggregated = `${method$1}(${distinct + wrap$2(value$1)})`;
        return addAlias(aggregated, alias$1);
      };
      if (Array.isArray(value)) return [aggregateArray(value)];
      if (typeof value == `object`) {
        if (stmt.alias) throw Error(`When using an object explicit alias can not be used`);
        return Object.entries(value).map(([alias$1, column$1]) => Array.isArray(column$1) ? aggregateArray(column$1, alias$1) : aggregateString(column$1, alias$1));
      }
      let splitOn = value.toLowerCase().indexOf(` as `), column = value, { alias } = stmt;
      if (splitOn !== -1) {
        if (column = value.slice(0, splitOn), alias) throw Error(`Found multiple aliases for same column: ${column}`);
        alias = value.slice(splitOn + 4);
      }
      return [aggregateString(column, alias)];
    }
    aggregate(stmt) {
      return this._aggregate(stmt);
    }
    aggregateRaw(stmt) {
      let distinct = stmt.aggregateDistinct ? `distinct ` : ``;
      return `${stmt.method}(${distinct + unwrapRaw_(stmt.value, void 0, this.builder, this.client, this.bindingsHolder)})`;
    }
    _joinTable(join) {
      return join.schema && !(join.table instanceof Raw$5) ? `${join.schema}.${join.table}` : join.table;
    }
    join() {
      let sql = ``, i$4 = -1, joins = this.grouped.join;
      if (!joins) return ``;
      for (; ++i$4 < joins.length; ) {
        let join = joins[i$4], table$2 = this._joinTable(join);
        if (i$4 > 0 && (sql += ` `), join.joinType === `raw`) sql += unwrapRaw_(join.table, void 0, this.builder, this.client, this.bindingsHolder);
        else {
          sql += join.joinType + ` join ` + wrap_$3(table$2, void 0, this.builder, this.client, this.bindingsHolder);
          let ii = -1;
          for (; ++ii < join.clauses.length; ) {
            let clause = join.clauses[ii];
            ii > 0 ? sql += ` ${clause.bool} ` : sql += ` ${clause.type === `onUsing` ? `using` : `on`} `;
            let val = this[clause.type](clause);
            val && (sql += val);
          }
        }
      }
      return sql;
    }
    onBetween(statement) {
      return wrap_$3(statement.column, void 0, this.builder, this.client, this.bindingsHolder) + ` ` + this._not(statement, `between`) + ` ` + statement.value.map((value) => this.client.parameter(value, this.builder, this.bindingsHolder)).join(` and `);
    }
    onNull(statement) {
      return wrap_$3(statement.column, void 0, this.builder, this.client, this.bindingsHolder) + ` is ` + this._not(statement, `null`);
    }
    onExists(statement) {
      return this._not(statement, `exists`) + ` (` + rawOrFn_(statement.value, void 0, this.builder, this.client, this.bindingsHolder) + `)`;
    }
    onIn(statement) {
      if (Array.isArray(statement.column)) return this.multiOnIn(statement);
      let values$3;
      return values$3 = statement.value instanceof Raw$5 ? this.client.parameter(statement.value, this.builder, this.formatter) : this.client.parameterize(statement.value, void 0, this.builder, this.bindingsHolder), wrap_$3(statement.column, void 0, this.builder, this.client, this.bindingsHolder) + ` ` + this._not(statement, `in `) + this.wrap(values$3);
    }
    multiOnIn(statement) {
      let i$4 = -1, sql = `(${columnize_$10(statement.column, this.builder, this.client, this.bindingsHolder)}) `;
      for (sql += this._not(statement, `in `) + `((`; ++i$4 < statement.value.length; ) i$4 !== 0 && (sql += `),(`), sql += this.client.parameterize(statement.value[i$4], void 0, this.builder, this.bindingsHolder);
      return sql + `))`;
    }
    where() {
      let wheres = this.grouped.where;
      if (!wheres) return;
      let sql = [], i$4 = -1;
      for (; ++i$4 < wheres.length; ) {
        let stmt = wheres[i$4];
        Object.prototype.hasOwnProperty.call(stmt, `value`) && helpers$5.containsUndefined(stmt.value) && (this.undefinedBindingsInfo.push(stmt.column), this._undefinedInWhereClause = true);
        let val = this[stmt.type](stmt);
        val && (sql.length === 0 ? sql[0] = `where` : sql.push(stmt.bool), sql.push(val));
      }
      return sql.length > 1 ? sql.join(` `) : ``;
    }
    group() {
      return this._groupsOrders(`group`);
    }
    order() {
      return this._groupsOrders(`order`);
    }
    having() {
      let havings = this.grouped.having;
      if (!havings) return ``;
      let sql = [`having`];
      for (let i$4 = 0, l$4 = havings.length; i$4 < l$4; i$4++) {
        let s$6 = havings[i$4], val = this[s$6.type](s$6);
        val && (sql.length === 0 && (sql[0] = `where`), (sql.length > 1 || sql.length === 1 && sql[0] !== `having`) && sql.push(s$6.bool), sql.push(val));
      }
      return sql.length > 1 ? sql.join(` `) : ``;
    }
    havingRaw(statement) {
      return this._not(statement, ``) + unwrapRaw_(statement.value, void 0, this.builder, this.client, this.bindingsHolder);
    }
    havingWrapped(statement) {
      let val = rawOrFn_(statement.value, `where`, this.builder, this.client, this.bindingsHolder);
      return val && this._not(statement, ``) + `(` + val.slice(6) + `)` || ``;
    }
    havingBasic(statement) {
      return this._not(statement, ``) + wrap_$3(statement.column, void 0, this.builder, this.client, this.bindingsHolder) + ` ` + operator_$4(statement.operator, this.builder, this.client, this.bindingsHolder) + ` ` + this.client.parameter(statement.value, this.builder, this.bindingsHolder);
    }
    havingNull(statement) {
      return wrap_$3(statement.column, void 0, this.builder, this.client, this.bindingsHolder) + ` is ` + this._not(statement, `null`);
    }
    havingExists(statement) {
      return this._not(statement, `exists`) + ` (` + rawOrFn_(statement.value, void 0, this.builder, this.client, this.bindingsHolder) + `)`;
    }
    havingBetween(statement) {
      return wrap_$3(statement.column, void 0, this.builder, this.client, this.bindingsHolder) + ` ` + this._not(statement, `between`) + ` ` + statement.value.map((value) => this.client.parameter(value, this.builder, this.bindingsHolder)).join(` and `);
    }
    havingIn(statement) {
      return Array.isArray(statement.column) ? this.multiHavingIn(statement) : wrap_$3(statement.column, void 0, this.builder, this.client, this.bindingsHolder) + ` ` + this._not(statement, `in `) + this.wrap(this.client.parameterize(statement.value, void 0, this.builder, this.bindingsHolder));
    }
    multiHavingIn(statement) {
      return this.multiOnIn(statement);
    }
    union() {
      let onlyUnions = this.onlyUnions(), unions = this.grouped.union;
      if (!unions) return ``;
      let sql = ``;
      for (let i$4 = 0, l$4 = unions.length; i$4 < l$4; i$4++) {
        let union = unions[i$4];
        i$4 > 0 && (sql += ` `), (i$4 > 0 || !onlyUnions) && (sql += union.clause + ` `);
        let statement = rawOrFn_(union.value, void 0, this.builder, this.client, this.bindingsHolder);
        if (statement) {
          let wrap$2 = union.wrap;
          wrap$2 && (sql += `(`), sql += statement, wrap$2 && (sql += `)`);
        }
      }
      return sql;
    }
    onlyUnions() {
      return (!this.grouped.columns || !!this.grouped.columns[0].value) && this.grouped.union && !this.tableName;
    }
    _getValueOrParameterFromAttribute(attribute, rawValue) {
      return this.single.skipBinding[attribute] === true ? rawValue ?? this.single[attribute] : this.client.parameter(this.single[attribute], this.builder, this.bindingsHolder);
    }
    onlyJson() {
      return !this.tableName && this.grouped.columns && this.grouped.columns.length === 1 && this.grouped.columns[0].type === `json`;
    }
    limit() {
      let noLimit = !this.single.limit && this.single.limit !== 0;
      return noLimit ? `` : `limit ${this._getValueOrParameterFromAttribute(`limit`)}`;
    }
    offset() {
      return this.single.offset ? `offset ${this._getValueOrParameterFromAttribute(`offset`)}` : ``;
    }
    del() {
      let { tableName } = this, withSQL = this.with(), wheres = this.where(), joins = this.join(), deleteSelector = joins ? tableName + ` ` : ``;
      return withSQL + `delete ${deleteSelector}from ${this.single.only ? `only ` : ``}${tableName}` + (joins ? ` ${joins}` : ``) + (wheres ? ` ${wheres}` : ``);
    }
    truncate() {
      return `truncate ${this.tableName}`;
    }
    lock() {
      if (this.single.lock) return this[this.single.lock]();
    }
    waitMode() {
      if (this.single.waitMode) return this[this.single.waitMode]();
    }
    skipLocked() {
      throw Error(`.skipLocked() is currently only supported on MySQL 8.0+ and PostgreSQL 9.5+`);
    }
    noWait() {
      throw Error(`.noWait() is currently only supported on MySQL 8.0+, MariaDB 10.3.0+ and PostgreSQL 9.5+`);
    }
    distinctOn(value) {
      throw Error(`.distinctOn() is currently only supported on PostgreSQL`);
    }
    onWrapped(clause) {
      let self$1 = this, wrapJoin = new JoinClause();
      clause.value.call(wrapJoin, wrapJoin);
      let sql = ``;
      for (let ii = 0; ii < wrapJoin.clauses.length; ii++) {
        let wrapClause = wrapJoin.clauses[ii];
        ii > 0 && (sql += ` ${wrapClause.bool} `);
        let val = self$1[wrapClause.type](wrapClause);
        val && (sql += val);
      }
      return sql.length ? `(${sql})` : ``;
    }
    onBasic(clause) {
      let toWrap = clause.value instanceof QueryBuilder$12;
      return wrap_$3(clause.column, void 0, this.builder, this.client, this.bindingsHolder) + ` ` + operator_$4(clause.operator, this.builder, this.client, this.bindingsHolder) + ` ` + (toWrap ? `(` : ``) + wrap_$3(clause.value, void 0, this.builder, this.client, this.bindingsHolder) + (toWrap ? `)` : ``);
    }
    onVal(clause) {
      return wrap_$3(clause.column, void 0, this.builder, this.client, this.bindingsHolder) + ` ` + operator_$4(clause.operator, this.builder, this.client, this.bindingsHolder) + ` ` + this.client.parameter(clause.value, this.builder, this.bindingsHolder);
    }
    onRaw(clause) {
      return unwrapRaw_(clause.value, void 0, this.builder, this.client, this.bindingsHolder);
    }
    onUsing(clause) {
      return `(` + columnize_$10(clause.column, this.builder, this.client, this.bindingsHolder) + `)`;
    }
    _valueClause(statement) {
      return statement.asColumn ? wrap_$3(statement.value, void 0, this.builder, this.client, this.bindingsHolder) : this.client.parameter(statement.value, this.builder, this.bindingsHolder);
    }
    _columnClause(statement) {
      let columns;
      return columns = Array.isArray(statement.column) ? `(${columnize_$10(statement.column, this.builder, this.client, this.bindingsHolder)})` : wrap_$3(statement.column, void 0, this.builder, this.client, this.bindingsHolder), columns;
    }
    whereIn(statement) {
      let values$3 = this.client.values(statement.value, this.builder, this.bindingsHolder);
      return `${this._columnClause(statement)} ${this._not(statement, `in `)}${values$3}`;
    }
    whereLike(statement) {
      return `${this._columnClause(statement)} ${this._not(statement, `like `)}${this._valueClause(statement)}`;
    }
    whereILike(statement) {
      return `${this._columnClause(statement)} ${this._not(statement, `ilike `)}${this._valueClause(statement)}`;
    }
    whereNull(statement) {
      return wrap_$3(statement.column, void 0, this.builder, this.client, this.bindingsHolder) + ` is ` + this._not(statement, `null`);
    }
    whereBasic(statement) {
      return this._not(statement, ``) + wrap_$3(statement.column, void 0, this.builder, this.client, this.bindingsHolder) + ` ` + operator_$4(statement.operator, this.builder, this.client, this.bindingsHolder) + ` ` + this._valueClause(statement);
    }
    whereExists(statement) {
      return this._not(statement, `exists`) + ` (` + rawOrFn_(statement.value, void 0, this.builder, this.client, this.bindingsHolder) + `)`;
    }
    whereWrapped(statement) {
      let val = rawOrFn_(statement.value, `where`, this.builder, this.client, this.bindingsHolder);
      return val && this._not(statement, ``) + `(` + val.slice(6) + `)` || ``;
    }
    whereBetween(statement) {
      return wrap_$3(statement.column, void 0, this.builder, this.client, this.bindingsHolder) + ` ` + this._not(statement, `between`) + ` ` + statement.value.map((value) => this.client.parameter(value, this.builder, this.bindingsHolder)).join(` and `);
    }
    whereRaw(statement) {
      return this._not(statement, ``) + unwrapRaw_(statement.value, void 0, this.builder, this.client, this.bindingsHolder);
    }
    _jsonWrapValue(jsonValue) {
      if (!this.builder._isJsonObject(jsonValue)) try {
        return JSON.stringify(JSON.parse(jsonValue.replace(/\n|\t/g, ``)));
      } catch {
        return jsonValue;
      }
      return JSON.stringify(jsonValue);
    }
    _jsonValueClause(statement) {
      return statement.value = this._jsonWrapValue(statement.value), this._valueClause(statement);
    }
    whereJsonObject(statement) {
      return `${this._columnClause(statement)} ${statement.not ? `!=` : `=`} ${this._jsonValueClause(statement)}`;
    }
    wrap(str) {
      return str.charAt(0) === `(` ? str : `(${str})`;
    }
    json(stmt) {
      return this[stmt.method](stmt.params);
    }
    analytic(stmt) {
      let sql = ``, self$1 = this;
      return sql += stmt.method + `() over (`, stmt.raw ? sql += stmt.raw : (stmt.partitions.length && (sql += `partition by `, sql += map$6(stmt.partitions, function(partition) {
        return isString$10(partition) ? self$1.formatter.columnize(partition) : self$1.formatter.columnize(partition.column) + (partition.order ? ` ` + partition.order : ``);
      }).join(`, `) + ` `), sql += `order by `, sql += map$6(stmt.order, function(order$2) {
        return isString$10(order$2) ? self$1.formatter.columnize(order$2) : self$1.formatter.columnize(order$2.column) + (order$2.order ? ` ` + order$2.order : ``);
      }).join(`, `)), sql += `)`, stmt.alias && (sql += ` as ` + stmt.alias), sql;
    }
    with() {
      if (!this.grouped.with || !this.grouped.with.length) return ``;
      let withs = this.grouped.with;
      if (!withs) return;
      let sql = [], i$4 = -1, isRecursive = false;
      for (; ++i$4 < withs.length; ) {
        let stmt = withs[i$4];
        stmt.recursive && (isRecursive = true);
        let val = this[stmt.type](stmt);
        sql.push(val);
      }
      return `with ${isRecursive ? `recursive ` : ``}${sql.join(`, `)} `;
    }
    withWrapped(statement) {
      let val = rawOrFn_(statement.value, void 0, this.builder, this.client, this.bindingsHolder), columnList = statement.columnList ? `(` + columnize_$10(statement.columnList, this.builder, this.client, this.bindingsHolder) + `)` : ``, materialized = statement.materialized === void 0 ? `` : statement.materialized ? `materialized ` : `not materialized `;
      return val && columnize_$10(statement.alias, this.builder, this.client, this.bindingsHolder) + columnList + ` as ` + materialized + `(` + val + `)` || ``;
    }
    _not(statement, str) {
      return statement.not ? `not ${str}` : str;
    }
    _prepInsert(data) {
      let isRaw = rawOrFn_(data, void 0, this.builder, this.client, this.bindingsHolder);
      if (isRaw) return isRaw;
      let columns = [], values$3 = [];
      Array.isArray(data) || (data = data ? [data] : []);
      let i$4 = -1;
      for (; ++i$4 < data.length && data[i$4] != null; ) {
        i$4 === 0 && (columns = Object.keys(data[i$4]).sort());
        let row = Array(columns.length), keys$10 = Object.keys(data[i$4]), j$1 = -1;
        for (; ++j$1 < keys$10.length; ) {
          let key = keys$10[j$1], idx = columns.indexOf(key);
          if (idx === -1) {
            columns = columns.concat(key).sort(), idx = columns.indexOf(key);
            let k = -1;
            for (; ++k < values$3.length; ) values$3[k].splice(idx, 0, void 0);
            row.splice(idx, 0, void 0);
          }
          row[idx] = data[i$4][key];
        }
        values$3.push(row);
      }
      return { columns, values: values$3 };
    }
    _prepUpdate(data = {}) {
      let { counter = {} } = this.single;
      for (let column of Object.keys(counter)) {
        if (has$3(data, column)) {
          this.client.logger.warn(`increment/decrement called for a column that has already been specified in main .update() call. Ignoring increment/decrement and using value from .update() call.`);
          continue;
        }
        let value = counter[column], symbol = value < 0 ? `-` : `+`;
        symbol === `-` && (value = -value), data[column] = this.client.raw(`?? ${symbol} ?`, [column, value]);
      }
      data = omitBy(data, isUndefined$22);
      let vals = [], columns = Object.keys(data), i$4 = -1;
      for (; ++i$4 < columns.length; ) vals.push(wrap_$3(columns[i$4], void 0, this.builder, this.client, this.bindingsHolder) + ` = ` + this.client.parameter(data[columns[i$4]], this.builder, this.bindingsHolder));
      if (isEmpty$9(vals)) throw Error([`Empty .update() call detected!`, `Update data does not contain any values to update.`, `This will result in a faulty query.`, this.single.table ? `Table: ${this.single.table}.` : ``, this.single.update ? `Columns: ${Object.keys(this.single.update)}.` : ``].join(` `));
      return vals;
    }
    _formatGroupsItemValue(value, nulls) {
      let { formatter } = this, nullOrder = ``;
      nulls === `last` ? nullOrder = ` is null` : nulls === `first` && (nullOrder = ` is not null`);
      let groupOrder;
      return groupOrder = value instanceof Raw$5 ? unwrapRaw_(value, void 0, this.builder, this.client, this.bindingsHolder) : value instanceof QueryBuilder$12 || nulls ? `(` + formatter.columnize(value) + nullOrder + `)` : formatter.columnize(value), groupOrder;
    }
    _basicGroupOrder(item, type) {
      let column = this._formatGroupsItemValue(item.value, item.nulls), direction$1 = type === `order` && item.type !== `orderByRaw` ? ` ${direction_(item.direction, this.builder, this.client, this.bindingsHolder)}` : ``;
      return column + direction$1;
    }
    _groupOrder(item, type) {
      return this._basicGroupOrder(item, type);
    }
    _groupOrderNulls(item, type) {
      let column = this._formatGroupsItemValue(item.value), direction$1 = type === `order` && item.type !== `orderByRaw` ? ` ${direction_(item.direction, this.builder, this.client, this.bindingsHolder)}` : ``;
      return item.nulls && !(item.value instanceof Raw$5) ? `${column}${direction$1 || ``} nulls ${item.nulls}` : column + direction$1;
    }
    _groupsOrders(type) {
      let items = this.grouped[type];
      if (!items) return ``;
      let sql = items.map((item) => this._groupOrder(item, type));
      return sql.length ? type + ` by ` + sql.join(`, `) : ``;
    }
    get tableName() {
      if (!this._tableName) {
        let tableName = this.single.table, schemaName = this.single.schema;
        if (tableName && schemaName) {
          let isQueryBuilder = tableName instanceof QueryBuilder$12, isRawQuery = tableName instanceof Raw$5, isFunction$12 = typeof tableName == `function`;
          !isQueryBuilder && !isRawQuery && !isFunction$12 && (tableName = `${schemaName}.${tableName}`);
        }
        this._tableName = tableName ? wrap_$3(tableName, tableName instanceof QueryBuilder$12, this.builder, this.client, this.bindingsHolder) : ``;
      }
      return this._tableName;
    }
    _jsonPathWrap(extraction) {
      return this.client.parameter(extraction.path || extraction[1], this.builder, this.bindingsHolder);
    }
    _jsonExtract(nameFunction, params) {
      let extractions;
      return extractions = Array.isArray(params.column) ? params.column : [params], Array.isArray(nameFunction) || (nameFunction = [nameFunction]), extractions.map((extraction) => {
        let jsonCol = `${columnize_$10(extraction.column || extraction[0], this.builder, this.client, this.bindingsHolder)}, ${this._jsonPathWrap(extraction)}`;
        nameFunction.forEach((f$32) => {
          jsonCol = f$32 + `(` + jsonCol + `)`;
        });
        let alias = extraction.alias || extraction[2];
        return alias ? this.client.alias(jsonCol, this.formatter.wrap(alias)) : jsonCol;
      }).join(`, `);
    }
    _jsonSet(nameFunction, params) {
      let jsonSet = `${nameFunction}(${columnize_$10(params.column, this.builder, this.client, this.bindingsHolder)}, ${this.client.parameter(params.path, this.builder, this.bindingsHolder)}, ${this.client.parameter(params.value, this.builder, this.bindingsHolder)})`;
      return params.alias ? this.client.alias(jsonSet, this.formatter.wrap(params.alias)) : jsonSet;
    }
    _whereJsonPath(nameFunction, statement) {
      return `${nameFunction}(${this._columnClause(statement)}, ${this._jsonPathWrap({ path: statement.jsonPath })}) ${operator_$4(statement.operator, this.builder, this.client, this.bindingsHolder)} ${this._jsonValueClause(statement)}`;
    }
    _onJsonPathEquals(nameJoinFunction, clause) {
      return nameJoinFunction + `(` + wrap_$3(clause.columnFirst, void 0, this.builder, this.client, this.bindingsHolder) + `, ` + this.client.parameter(clause.jsonPathFirst, this.builder, this.bindingsHolder) + `) = ` + nameJoinFunction + `(` + wrap_$3(clause.columnSecond, void 0, this.builder, this.client, this.bindingsHolder) + `, ` + this.client.parameter(clause.jsonPathSecond, this.builder, this.bindingsHolder) + `)`;
    }
  };
  module2.exports = QueryCompiler$14;
}), require_viewbuilder = __commonJSMin$1((exports$12, module2) => {
  let helpers$4 = require_helpers$1(), extend$2 = require_extend(), assign$1 = require_assign();
  var ViewBuilder$8 = class {
    constructor(client, method$1, viewName, fn$1) {
      this.client = client, this._method = method$1, this._schemaName = void 0, this._columns = void 0, this._fn = fn$1, this._viewName = viewName, this._statements = [], this._single = {};
    }
    setSchema(schemaName) {
      this._schemaName = schemaName;
    }
    columns(columns) {
      this._columns = columns;
    }
    as(selectQuery) {
      this._selectQuery = selectQuery;
    }
    checkOption() {
      throw Error(`check option definition is not supported by this dialect.`);
    }
    localCheckOption() {
      throw Error(`check option definition is not supported by this dialect.`);
    }
    cascadedCheckOption() {
      throw Error(`check option definition is not supported by this dialect.`);
    }
    toSQL() {
      return this._method === `alter` && extend$2(this, AlterMethods$1), this._fn.call(this, this), this.client.viewCompiler(this).toSQL();
    }
  };
  let AlterMethods$1 = { column(column) {
    let self$1 = this;
    return { rename: function(newName) {
      return self$1._statements.push({ grouping: `alterView`, method: `renameColumn`, args: [column, newName] }), this;
    }, defaultTo: function(defaultValue) {
      return self$1._statements.push({ grouping: `alterView`, method: `defaultTo`, args: [column, defaultValue] }), this;
    } };
  } };
  helpers$4.addQueryContext(ViewBuilder$8), ViewBuilder$8.extend = (methodName, fn$1) => {
    if (Object.prototype.hasOwnProperty.call(ViewBuilder$8.prototype, methodName)) throw Error(`Can't extend ViewBuilder with existing method ('${methodName}').`);
    assign$1(ViewBuilder$8.prototype, { [methodName]: fn$1 });
  }, module2.exports = ViewBuilder$8;
}), require__baseFindIndex = __commonJSMin$1((exports$12, module2) => {
  function baseFindIndex$1(array, predicate, fromIndex, fromRight) {
    for (var length = array.length, index$2 = fromIndex + (fromRight ? 1 : -1); fromRight ? index$2-- : ++index$2 < length; ) if (predicate(array[index$2], index$2, array)) return index$2;
    return -1;
  }
  module2.exports = baseFindIndex$1;
}), require__baseIsNaN = __commonJSMin$1((exports$12, module2) => {
  function baseIsNaN$1(value) {
    return value !== value;
  }
  module2.exports = baseIsNaN$1;
}), require__strictIndexOf = __commonJSMin$1((exports$12, module2) => {
  function strictIndexOf$1(array, value, fromIndex) {
    for (var index$2 = fromIndex - 1, length = array.length; ++index$2 < length; ) if (array[index$2] === value) return index$2;
    return -1;
  }
  module2.exports = strictIndexOf$1;
}), require__baseIndexOf = __commonJSMin$1((exports$12, module2) => {
  var baseFindIndex = require__baseFindIndex(), baseIsNaN = require__baseIsNaN(), strictIndexOf = require__strictIndexOf();
  function baseIndexOf$2(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
  }
  module2.exports = baseIndexOf$2;
}), require__trimmedEndIndex = __commonJSMin$1((exports$12, module2) => {
  var reWhitespace = /\s/;
  function trimmedEndIndex$1(string) {
    for (var index$2 = string.length; index$2-- && reWhitespace.test(string.charAt(index$2)); ) ;
    return index$2;
  }
  module2.exports = trimmedEndIndex$1;
}), require__baseTrim = __commonJSMin$1((exports$12, module2) => {
  var trimmedEndIndex = require__trimmedEndIndex(), reTrimStart = /^\s+/;
  function baseTrim$1(string) {
    return string && string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, ``);
  }
  module2.exports = baseTrim$1;
}), require_toNumber = __commonJSMin$1((exports$12, module2) => {
  var baseTrim = require__baseTrim(), isObject$9 = require_isObject(), isSymbol = require_isSymbol(), NAN = NaN, reIsBadHex = /^[-+]0x[0-9a-f]+$/i, reIsBinary = /^0b[01]+$/i, reIsOctal = /^0o[0-7]+$/i, freeParseInt = parseInt;
  function toNumber$6(value) {
    if (typeof value == `number`) return value;
    if (isSymbol(value)) return NAN;
    if (isObject$9(value)) {
      var other = typeof value.valueOf == `function` ? value.valueOf() : value;
      value = isObject$9(other) ? other + `` : other;
    }
    if (typeof value != `string`) return value === 0 ? value : +value;
    value = baseTrim(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
  }
  module2.exports = toNumber$6;
}), require_toFinite = __commonJSMin$1((exports$12, module2) => {
  var toNumber$5 = require_toNumber(), INFINITY$1 = 1 / 0, MAX_INTEGER = 17976931348623157e292;
  function toFinite$1(value) {
    if (!value) return value === 0 ? value : 0;
    if (value = toNumber$5(value), value === INFINITY$1 || value === -INFINITY$1) {
      var sign$2 = value < 0 ? -1 : 1;
      return sign$2 * MAX_INTEGER;
    }
    return value === value ? value : 0;
  }
  module2.exports = toFinite$1;
}), require_toInteger = __commonJSMin$1((exports$12, module2) => {
  var toFinite = require_toFinite();
  function toInteger$1(value) {
    var result = toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
  }
  module2.exports = toInteger$1;
}), require_indexOf = __commonJSMin$1((exports$12, module2) => {
  var baseIndexOf$1 = require__baseIndexOf(), toInteger = require_toInteger(), nativeMax = Math.max;
  function indexOf$1(array, value, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index$2 = fromIndex == null ? 0 : toInteger(fromIndex);
    return index$2 < 0 && (index$2 = nativeMax(length + index$2, 0)), baseIndexOf$1(array, value, index$2);
  }
  module2.exports = indexOf$1;
}), require_tablecompiler = __commonJSMin$1((exports$12, module2) => {
  let { pushAdditional, pushQuery: pushQuery$1, unshiftQuery } = require_helpers(), helpers$3 = require_helpers$1(), groupBy$2 = require_groupBy(), indexOf = require_indexOf(), isEmpty$8 = require_isEmpty(), tail$1 = require_tail(), { normalizeArr } = require_helpers$1();
  var TableCompiler$16 = class {
    constructor(client, tableBuilder) {
      this.client = client, this.tableBuilder = tableBuilder, this._commonBuilder = this.tableBuilder, this.method = tableBuilder._method, this.schemaNameRaw = tableBuilder._schemaName, this.tableNameRaw = tableBuilder._tableName, this.tableNameLikeRaw = tableBuilder._tableNameLike, this.single = tableBuilder._single, this.grouped = groupBy$2(tableBuilder._statements, `grouping`), this.formatter = client.formatter(tableBuilder), this.bindings = [], this.formatter.bindings = this.bindings, this.bindingsHolder = this, this.sequence = [], this._formatting = client.config && client.config.formatting, this.checksCount = 0;
    }
    toSQL() {
      return this[this.method](), this.sequence;
    }
    create(ifNot, like) {
      let columnBuilders = this.getColumns(), columns = columnBuilders.map((col) => col.toSQL()), columnTypes$1 = this.getColumnTypes(columns);
      this.createAlterTableMethods && this.alterTableForCreate(columnTypes$1), this.createQuery(columnTypes$1, ifNot, like), this.columnQueries(columns), delete this.single.comment, this.alterTable();
    }
    createIfNot() {
      this.create(true);
    }
    createLike() {
      this.create(false, true);
    }
    createLikeIfNot() {
      this.create(true, true);
    }
    alter() {
      let addColBuilders = this.getColumns(), addColumns = addColBuilders.map((col) => col.toSQL()), alterColBuilders = this.getColumns(`alter`), alterColumns = alterColBuilders.map((col) => col.toSQL()), addColumnTypes = this.getColumnTypes(addColumns), alterColumnTypes = this.getColumnTypes(alterColumns);
      this.addColumns(addColumnTypes), this.alterColumns(alterColumnTypes, alterColBuilders), this.columnQueries(addColumns), this.columnQueries(alterColumns), this.alterTable();
    }
    foreign(foreignData) {
      if (foreignData.inTable && foreignData.references) {
        let keyName = foreignData.keyName ? this.formatter.wrap(foreignData.keyName) : this._indexCommand(`foreign`, this.tableNameRaw, foreignData.column), column = this.formatter.columnize(foreignData.column), references = this.formatter.columnize(foreignData.references), inTable = this.formatter.wrap(foreignData.inTable), onUpdate = foreignData.onUpdate ? (this.lowerCase ? ` on update ` : ` ON UPDATE `) + foreignData.onUpdate : ``, onDelete = foreignData.onDelete ? (this.lowerCase ? ` on delete ` : ` ON DELETE `) + foreignData.onDelete : ``, deferrable$2 = foreignData.deferrable ? this.lowerCase ? ` deferrable initially ${foreignData.deferrable.toLowerCase()} ` : ` DEFERRABLE INITIALLY ${foreignData.deferrable.toUpperCase()} ` : ``;
        this.lowerCase ? this.pushQuery((this.forCreate ? `` : `alter table ${this.tableName()} add `) + `constraint ` + keyName + ` foreign key (` + column + `) references ` + inTable + ` (` + references + `)` + onUpdate + onDelete + deferrable$2) : this.pushQuery((this.forCreate ? `` : `ALTER TABLE ${this.tableName()} ADD `) + `CONSTRAINT ` + keyName + ` FOREIGN KEY (` + column + `) REFERENCES ` + inTable + ` (` + references + `)` + onUpdate + onDelete + deferrable$2);
      }
    }
    getColumnTypes(columns) {
      return columns.reduce(function(memo, columnSQL) {
        let column = columnSQL[0];
        return memo.sql.push(column.sql), memo.bindings.concat(column.bindings), memo;
      }, { sql: [], bindings: [] });
    }
    columnQueries(columns) {
      let queries = columns.reduce(function(memo, columnSQL) {
        let column = tail$1(columnSQL);
        return isEmpty$8(column) ? memo : memo.concat(column);
      }, []);
      for (let q of queries) this.pushQuery(q);
    }
    addColumns(columns, prefix) {
      if (prefix ||= this.addColumnsPrefix, columns.sql.length > 0) {
        let columnSql = columns.sql.map((column) => prefix + column);
        this.pushQuery({ sql: (this.lowerCase ? `alter table ` : `ALTER TABLE `) + this.tableName() + ` ` + columnSql.join(`, `), bindings: columns.bindings });
      }
    }
    alterColumns(columns, colBuilders) {
      columns.sql.length > 0 && this.addColumns(columns, this.alterColumnsPrefix, colBuilders);
    }
    getColumns(method$1) {
      let columns = this.grouped.columns || [];
      method$1 ||= `add`;
      let queryContext = this.tableBuilder.queryContext();
      return columns.filter((column) => column.builder._method === method$1).map((column) => (queryContext !== void 0 && column.builder.queryContext() === void 0 && column.builder.queryContext(queryContext), this.client.columnCompiler(this, column.builder)));
    }
    tableName() {
      let name$2 = this.schemaNameRaw ? `${this.schemaNameRaw}.${this.tableNameRaw}` : this.tableNameRaw;
      return this.formatter.wrap(name$2);
    }
    tableNameLike() {
      let name$2 = this.schemaNameRaw ? `${this.schemaNameRaw}.${this.tableNameLikeRaw}` : this.tableNameLikeRaw;
      return this.formatter.wrap(name$2);
    }
    alterTable() {
      let alterTable = this.grouped.alterTable || [];
      for (let i$4 = 0, l$4 = alterTable.length; i$4 < l$4; i$4++) {
        let statement = alterTable[i$4];
        this[statement.method] ? this[statement.method].apply(this, statement.args) : this.client.logger.error(`Debug: ${statement.method} does not exist`);
      }
      for (let item in this.single) typeof this[item] == `function` && this[item](this.single[item]);
    }
    alterTableForCreate(columnTypes$1) {
      this.forCreate = true;
      let savedSequence = this.sequence, alterTable = this.grouped.alterTable || [];
      this.grouped.alterTable = [];
      for (let i$4 = 0, l$4 = alterTable.length; i$4 < l$4; i$4++) {
        let statement = alterTable[i$4];
        if (indexOf(this.createAlterTableMethods, statement.method) < 0) {
          this.grouped.alterTable.push(statement);
          continue;
        }
        this[statement.method] ? (this.sequence = [], this[statement.method].apply(this, statement.args), columnTypes$1.sql.push(this.sequence[0].sql)) : this.client.logger.error(`Debug: ${statement.method} does not exist`);
      }
      this.sequence = savedSequence, this.forCreate = false;
    }
    dropIndex(value) {
      this.pushQuery(`drop index${value}`);
    }
    dropUnique() {
      throw Error(`Method implemented in the dialect driver`);
    }
    dropForeign() {
      throw Error(`Method implemented in the dialect driver`);
    }
    dropColumn() {
      let columns = helpers$3.normalizeArr.apply(null, arguments), drops = (Array.isArray(columns) ? columns : [columns]).map((column) => this.dropColumnPrefix + this.formatter.wrap(column));
      this.pushQuery((this.lowerCase ? `alter table ` : `ALTER TABLE `) + this.tableName() + ` ` + drops.join(`, `));
    }
    _setNullableState(column, nullable) {
      let tableName = this.tableName(), columnName = this.formatter.columnize(column), alterColumnPrefix = this.alterColumnsPrefix;
      return this.pushQuery({ sql: `SELECT 1`, output: () => this.client.queryBuilder().from(this.tableNameRaw).columnInfo(column).then((columnInfo) => {
        if (isEmpty$8(columnInfo)) throw Error(`.setNullable: Column ${columnName} does not exist in table ${tableName}.`);
        let nullableType = nullable ? `null` : `not null`, columnType = columnInfo.type + (columnInfo.maxLength ? `(${columnInfo.maxLength})` : ``), defaultValue = columnInfo.defaultValue !== null && columnInfo.defaultValue !== void 0 ? `default '${columnInfo.defaultValue}'` : ``, sql = `alter table ${tableName} ${alterColumnPrefix} ${columnName} ${columnType} ${nullableType} ${defaultValue}`;
        return this.client.raw(sql);
      }) });
    }
    setNullable(column) {
      return this._setNullableState(column, true);
    }
    dropNullable(column) {
      return this._setNullableState(column, false);
    }
    dropChecks(checkConstraintNames) {
      if (checkConstraintNames === void 0) return ``;
      checkConstraintNames = normalizeArr(checkConstraintNames);
      let tableName = this.tableName(), sql = `alter table ${tableName} ${checkConstraintNames.map((constraint) => `drop constraint ${constraint}`).join(`, `)}`;
      this.pushQuery(sql);
    }
    check(checkPredicate, bindings, constraintName$2) {
      let tableName = this.tableName(), checkConstraint = constraintName$2;
      checkConstraint || (this.checksCount++, checkConstraint = tableName + `_` + this.checksCount);
      let sql = `alter table ${tableName} add constraint ${checkConstraint} check(${checkPredicate})`;
      this.pushQuery(sql);
    }
    _addChecks() {
      return this.grouped.checks ? `, ` + this.grouped.checks.map((c$12) => `${c$12.args[2] ? `constraint ` + c$12.args[2] + ` ` : ``}check (${this.client.raw(c$12.args[0], c$12.args[1])})`).join(`, `) : ``;
    }
    _indexCommand(type, tableName, columns) {
      Array.isArray(columns) || (columns = columns ? [columns] : []);
      let table$2 = tableName.replace(/\.|-/g, `_`), indexName = (table$2 + `_` + columns.join(`_`) + `_` + type).toLowerCase();
      return this.formatter.wrap(indexName);
    }
    _getPrimaryKeys() {
      return (this.grouped.alterTable || []).filter((a$22) => a$22.method === `primary`).flatMap((a$22) => a$22.args).flat();
    }
    _canBeAddPrimaryKey(options) {
      return options.primaryKey && this._getPrimaryKeys().length === 0;
    }
    _getIncrementsColumnNames() {
      return this.grouped.columns.filter((c$12) => c$12.builder._type === `increments`).map((c$12) => c$12.builder._args[0]);
    }
    _getBigIncrementsColumnNames() {
      return this.grouped.columns.filter((c$12) => c$12.builder._type === `bigincrements`).map((c$12) => c$12.builder._args[0]);
    }
  };
  TableCompiler$16.prototype.pushQuery = pushQuery$1, TableCompiler$16.prototype.pushAdditional = pushAdditional, TableCompiler$16.prototype.unshiftQuery = unshiftQuery, TableCompiler$16.prototype.lowerCase = true, TableCompiler$16.prototype.createAlterTableMethods = null, TableCompiler$16.prototype.addColumnsPrefix = `add column `, TableCompiler$16.prototype.alterColumnsPrefix = `alter column `, TableCompiler$16.prototype.modifyColumnPrefix = `modify column `, TableCompiler$16.prototype.dropColumnPrefix = `drop column `, module2.exports = TableCompiler$16;
}), require_columnbuilder = __commonJSMin$1((exports$12, module2) => {
  let extend$1 = require_extend(), assign = require_assign(), toArray$3 = require_toArray(), { addQueryContext } = require_helpers$1();
  var ColumnBuilder$6 = class {
    constructor(client, tableBuilder, type, args$1) {
      this.client = client, this._method = `add`, this._single = {}, this._modifiers = {}, this._statements = [], this._type = columnAlias[type] || type, this._args = args$1, this._tableBuilder = tableBuilder, tableBuilder._method === `alter` && extend$1(this, AlterMethods);
    }
    references(value) {
      return this._tableBuilder.foreign.call(this._tableBuilder, this._args[0], void 0, this)._columnBuilder(this).references(value);
    }
  };
  let modifiers = [`default`, `defaultsTo`, `defaultTo`, `unsigned`, `nullable`, `first`, `after`, `comment`, `collate`, `check`, `checkPositive`, `checkNegative`, `checkIn`, `checkNotIn`, `checkBetween`, `checkLength`, `checkRegex`], aliasMethod = { default: `defaultTo`, defaultsTo: `defaultTo` };
  modifiers.forEach(function(method$1) {
    let key = aliasMethod[method$1] || method$1;
    ColumnBuilder$6.prototype[method$1] = function() {
      return this._modifiers[key] = toArray$3(arguments), this;
    };
  }), addQueryContext(ColumnBuilder$6), ColumnBuilder$6.prototype.notNull = ColumnBuilder$6.prototype.notNullable = function() {
    return this.nullable(false);
  }, [`index`, `primary`, `unique`].forEach(function(method$1) {
    ColumnBuilder$6.prototype[method$1] = function() {
      return this._type.toLowerCase().indexOf(`increments`) === -1 && this._tableBuilder[method$1].apply(this._tableBuilder, [this._args[0]].concat(toArray$3(arguments))), this;
    };
  }), ColumnBuilder$6.extend = (methodName, fn$1) => {
    if (Object.prototype.hasOwnProperty.call(ColumnBuilder$6.prototype, methodName)) throw Error(`Can't extend ColumnBuilder with existing method ('${methodName}').`);
    assign(ColumnBuilder$6.prototype, { [methodName]: fn$1 });
  };
  let AlterMethods = {};
  AlterMethods.drop = function() {
    return this._single.drop = true, this;
  }, AlterMethods.alterType = function(type) {
    return this._statements.push({ grouping: `alterType`, value: type }), this;
  }, AlterMethods.alter = function({ alterNullable = true, alterType = true } = {}) {
    return this._method = `alter`, this.alterNullable = alterNullable, this.alterType = alterType, this;
  };
  let columnAlias = { float: `floating`, enum: `enu`, boolean: `bool`, string: `varchar`, bigint: `bigInteger` };
  module2.exports = ColumnBuilder$6;
}), require_viewcompiler = __commonJSMin$1((exports$12, module2) => {
  let { pushQuery } = require_helpers(), groupBy$1 = require_groupBy(), { columnize: columnize_$9 } = require_wrappingFormatter();
  var ViewCompiler$14 = class {
    constructor(client, viewBuilder) {
      this.client = client, this.viewBuilder = viewBuilder, this._commonBuilder = this.viewBuilder, this.method = viewBuilder._method, this.schemaNameRaw = viewBuilder._schemaName, this.viewNameRaw = viewBuilder._viewName, this.single = viewBuilder._single, this.selectQuery = viewBuilder._selectQuery, this.columns = viewBuilder._columns, this.grouped = groupBy$1(viewBuilder._statements, `grouping`), this.formatter = client.formatter(viewBuilder), this.bindings = [], this.formatter.bindings = this.bindings, this.bindingsHolder = this, this.sequence = [];
    }
    toSQL() {
      return this[this.method](), this.sequence;
    }
    create() {
      this.createQuery(this.columns, this.selectQuery);
    }
    createOrReplace() {
      throw Error(`replace views is not supported by this dialect.`);
    }
    createMaterializedView() {
      throw Error(`materialized views are not supported by this dialect.`);
    }
    createQuery(columns, selectQuery, materialized, replace) {
      let createStatement = `create ` + (materialized ? `materialized ` : ``) + (replace ? `or replace ` : ``) + `view `, columnList = columns ? ` (` + columnize_$9(columns, this.viewBuilder, this.client, this.bindingsHolder) + `)` : ``, sql = createStatement + this.viewName() + columnList;
      switch (sql += ` as `, sql += selectQuery.toString(), this.single.checkOption) {
        case `default_option`:
          sql += ` with check option`;
          break;
        case `local`:
          sql += ` with local check option`;
          break;
        case `cascaded`:
          sql += ` with cascaded check option`;
          break;
      }
      this.pushQuery({ sql });
    }
    renameView(from$2, to) {
      throw Error(`rename view is not supported by this dialect (instead drop, then create another view).`);
    }
    refreshMaterializedView() {
      throw Error(`materialized views are not supported by this dialect.`);
    }
    alter() {
      this.alterView();
    }
    alterView() {
      let alterView = this.grouped.alterView || [];
      for (let i$4 = 0, l$4 = alterView.length; i$4 < l$4; i$4++) {
        let statement = alterView[i$4];
        this[statement.method] ? this[statement.method].apply(this, statement.args) : this.client.logger.error(`Debug: ${statement.method} does not exist`);
      }
      for (let item in this.single) typeof this[item] == `function` && this[item](this.single[item]);
    }
    renameColumn(from$2, to) {
      throw Error(`rename column of views is not supported by this dialect.`);
    }
    defaultTo(column, defaultValue) {
      throw Error(`change default values of views is not supported by this dialect.`);
    }
    viewName() {
      let name$2 = this.schemaNameRaw ? `${this.schemaNameRaw}.${this.viewNameRaw}` : this.viewNameRaw;
      return this.formatter.wrap(name$2);
    }
  };
  ViewCompiler$14.prototype.pushQuery = pushQuery, module2.exports = ViewCompiler$14;
}), require_head = __commonJSMin$1((exports$12, module2) => {
  function head(array) {
    return array && array.length ? array[0] : void 0;
  }
  module2.exports = head;
}), require_first = __commonJSMin$1((exports$12, module2) => {
  module2.exports = require_head();
}), require_columncompiler = __commonJSMin$1((exports$12, module2) => {
  let helpers$2 = require_helpers(), groupBy = require_groupBy(), first = require_first(), has$2 = require_has(), tail = require_tail(), { toNumber: toNumber$4 } = require_helpers$1(), { formatDefault: formatDefault$2 } = require_formatterUtils(), { operator: operator_$3 } = require_wrappingFormatter();
  var ColumnCompiler$16 = class {
    constructor(client, tableCompiler, columnBuilder) {
      this.client = client, this.tableCompiler = tableCompiler, this.columnBuilder = columnBuilder, this._commonBuilder = this.columnBuilder, this.args = columnBuilder._args, this.type = columnBuilder._type.toLowerCase(), this.grouped = groupBy(columnBuilder._statements, `grouping`), this.modified = columnBuilder._modifiers, this.isIncrements = this.type.indexOf(`increments`) !== -1, this.formatter = client.formatter(columnBuilder), this.bindings = [], this.formatter.bindings = this.bindings, this.bindingsHolder = this, this.sequence = [], this.modifiers = [], this.checksCount = 0;
    }
    _addCheckModifiers() {
      this.modifiers.push(`check`, `checkPositive`, `checkNegative`, `checkIn`, `checkNotIn`, `checkBetween`, `checkLength`, `checkRegex`);
    }
    defaults(label) {
      if (Object.prototype.hasOwnProperty.call(this._defaultMap, label)) return this._defaultMap[label].bind(this)();
      throw Error(`There is no default for the specified identifier ${label}`);
    }
    toSQL() {
      return this.pushQuery(this.compileColumn()), this.sequence.additional && (this.sequence = this.sequence.concat(this.sequence.additional)), this.sequence;
    }
    compileColumn() {
      return this.formatter.wrap(this.getColumnName()) + ` ` + this.getColumnType() + this.getModifiers();
    }
    getColumnName() {
      let value = first(this.args);
      return value || this.defaults(`columnName`);
    }
    getColumnType() {
      if (!this._columnType) {
        let type = this[this.type];
        this._columnType = typeof type == `function` ? type.apply(this, tail(this.args)) : type;
      }
      return this._columnType;
    }
    getModifiers() {
      let modifiers$1 = [];
      for (let i$4 = 0, l$4 = this.modifiers.length; i$4 < l$4; i$4++) {
        let modifier = this.modifiers[i$4];
        if ((!this.isIncrements || this.isIncrements && modifier === `comment`) && has$2(this.modified, modifier)) {
          let val = this[modifier].apply(this, this.modified[modifier]);
          val && modifiers$1.push(val);
        }
      }
      return modifiers$1.length > 0 ? ` ${modifiers$1.join(` `)}` : ``;
    }
    varchar(length) {
      return `varchar(${toNumber$4(length, 255)})`;
    }
    floating(precision, scale) {
      return `float(${toNumber$4(precision, 8)}, ${toNumber$4(scale, 2)})`;
    }
    decimal(precision, scale) {
      if (precision === null) throw Error(`Specifying no precision on decimal columns is not supported for that SQL dialect.`);
      return `decimal(${toNumber$4(precision, 8)}, ${toNumber$4(scale, 2)})`;
    }
    specifictype(type) {
      return type;
    }
    nullable(nullable) {
      return nullable === false ? `not null` : `null`;
    }
    notNullable() {
      return this.nullable(false);
    }
    defaultTo(value) {
      return `default ${formatDefault$2(value, this.type, this.client)}`;
    }
    increments(options = { primaryKey: true }) {
      return `integer not null` + (this.tableCompiler._canBeAddPrimaryKey(options) ? ` primary key` : ``) + ` autoincrement`;
    }
    bigincrements(options = { primaryKey: true }) {
      return this.increments(options);
    }
    _pushAlterCheckQuery(checkPredicate, constraintName$2) {
      let checkName = constraintName$2;
      checkName || (this.checksCount++, checkName = this.tableCompiler.tableNameRaw + `_` + this.getColumnName() + `_` + this.checksCount), this.pushAdditional(function() {
        this.pushQuery(`alter table ${this.tableCompiler.tableName()} add constraint ${checkName} check(${checkPredicate})`);
      });
    }
    _checkConstraintName(constraintName$2) {
      return constraintName$2 ? `constraint ${constraintName$2} ` : ``;
    }
    _check(checkPredicate, constraintName$2) {
      return this.columnBuilder._method === `alter` ? (this._pushAlterCheckQuery(checkPredicate, constraintName$2), ``) : `${this._checkConstraintName(constraintName$2)}check (${checkPredicate})`;
    }
    checkPositive(constraintName$2) {
      return this._check(`${this.formatter.wrap(this.getColumnName())} ${operator_$3(`>`, this.columnBuilder, this.bindingsHolder)} 0`, constraintName$2);
    }
    checkNegative(constraintName$2) {
      return this._check(`${this.formatter.wrap(this.getColumnName())} ${operator_$3(`<`, this.columnBuilder, this.bindingsHolder)} 0`, constraintName$2);
    }
    _checkIn(values$3, constraintName$2, not) {
      return this._check(`${this.formatter.wrap(this.getColumnName())} ${not ? `not ` : ``}in (${values$3.map((v$1) => this.client._escapeBinding(v$1)).join(`,`)})`, constraintName$2);
    }
    checkIn(values$3, constraintName$2) {
      return this._checkIn(values$3, constraintName$2);
    }
    checkNotIn(values$3, constraintName$2) {
      return this._checkIn(values$3, constraintName$2, true);
    }
    checkBetween(intervals, constraintName$2) {
      intervals.length === 2 && !Array.isArray(intervals[0]) && !Array.isArray(intervals[1]) && (intervals = [intervals]);
      let intervalChecks = intervals.map((interval) => `${this.formatter.wrap(this.getColumnName())} between ${this.client._escapeBinding(interval[0])} and ${this.client._escapeBinding(interval[1])}`).join(` or `);
      return this._check(intervalChecks, constraintName$2);
    }
    checkLength(operator$1, length, constraintName$2) {
      return this._check(`length(${this.formatter.wrap(this.getColumnName())}) ${operator_$3(operator$1, this.columnBuilder, this.bindingsHolder)} ${toNumber$4(length)}`, constraintName$2);
    }
  };
  ColumnCompiler$16.prototype.binary = `blob`, ColumnCompiler$16.prototype.bool = `boolean`, ColumnCompiler$16.prototype.date = `date`, ColumnCompiler$16.prototype.datetime = `datetime`, ColumnCompiler$16.prototype.time = `time`, ColumnCompiler$16.prototype.timestamp = `timestamp`, ColumnCompiler$16.prototype.geometry = `geometry`, ColumnCompiler$16.prototype.geography = `geography`, ColumnCompiler$16.prototype.point = `point`, ColumnCompiler$16.prototype.enu = `varchar`, ColumnCompiler$16.prototype.bit = ColumnCompiler$16.prototype.json = `text`, ColumnCompiler$16.prototype.uuid = ({ useBinaryUuid = false, primaryKey = false } = {}) => useBinaryUuid ? `binary(16)` : `char(36)`, ColumnCompiler$16.prototype.integer = ColumnCompiler$16.prototype.smallint = ColumnCompiler$16.prototype.mediumint = `integer`, ColumnCompiler$16.prototype.biginteger = `bigint`, ColumnCompiler$16.prototype.text = `text`, ColumnCompiler$16.prototype.tinyint = `tinyint`, ColumnCompiler$16.prototype.pushQuery = helpers$2.pushQuery, ColumnCompiler$16.prototype.pushAdditional = helpers$2.pushAdditional, ColumnCompiler$16.prototype.unshiftQuery = helpers$2.unshiftQuery, ColumnCompiler$16.prototype._defaultMap = { columnName: function() {
    if (!this.isIncrements) throw Error(`You did not specify a column name for the ${this.type} column.`);
    return `id`;
  } }, module2.exports = ColumnCompiler$16;
}), import_util = __toESM(require_util()), import_tarn = __toESM(require_tarn()), import_events = __toESM(require_events()), import_raw = __toESM(require_raw()), import_ref$1 = __toESM(require_ref()), import_string$1 = __toESM(require_string());
init_logger$1();
var import_uniqueId = __toESM(require_uniqueId()), import_cloneDeep = __toESM(require_cloneDeep()), import_timeout$1 = __toESM(require_timeout()), import_constants = __toESM(require_constants$3()), import_formatter = __toESM(require_formatter()), import_security = __toESM(require_security()), import_runner = __toESM(require_runner()), import_isPlainObject = __toESM(require_isPlainObject()), import_builder = __toESM(require_builder()), import_formatterUtils = __toESM(require_formatterUtils()), import_compiler = __toESM(require_compiler$1()), import_querybuilder$1 = __toESM(require_querybuilder()), import_tablebuilder = __toESM(require_tablebuilder());
init_transaction();
var import_querycompiler = __toESM(require_querycompiler()), import_viewbuilder = __toESM(require_viewbuilder()), import_tablecompiler = __toESM(require_tablecompiler()), import_columnbuilder = __toESM(require_columnbuilder()), import_viewcompiler = __toESM(require_viewcompiler()), import_columncompiler = __toESM(require_columncompiler()), import_wrappingFormatter = __toESM(require_wrappingFormatter()), import_query_executioner = __toESM(require_query_executioner()), Client = class extends import_events.EventEmitter {
  config;
  logger;
  version;
  connectionConfigProvider;
  connectionConfigExpirationChecker;
  connectionSettings;
  driver;
  pool;
  valueForUndefined;
  dialect;
  driverName;
  constructor(config = {}) {
    super(), this.config = config, this.logger = new logger_default(config), this.config.connection && this.config.connection.password && (0, import_security.setHiddenProperty)(this.config.connection), this.dialect && !this.config.client && this.logger.warn(`Using 'this.dialect' to identify the client is deprecated and support for it will be removed in the future. Please use configuration option 'client' instead.`);
    let dbClient = this.config.client || this.dialect;
    if (!dbClient) throw Error(`knex: Required configuration option 'client' is missing.`);
    config.version && (this.version = config.version), config.connection && typeof config.connection == `function` ? (this.connectionConfigProvider = config.connection, this.connectionConfigExpirationChecker = () => true) : (this.connectionSettings = (0, import_cloneDeep.default)(config.connection || {}), config.connection && config.connection.password && (0, import_security.setHiddenProperty)(this.connectionSettings, config.connection), this.connectionConfigExpirationChecker = null), this.driverName && config.connection && (this.initializeDriver(), (!config.pool || config.pool && config.pool.max !== 0) && this.initializePool(config)), this.valueForUndefined = this.raw(`DEFAULT`), config.useNullAsDefault && (this.valueForUndefined = null);
  }
  formatter(builder) {
    return new import_formatter.default(this, builder);
  }
  queryBuilder() {
    return new import_querybuilder$1.default(this);
  }
  transaction(container, config, outerTx) {
    return new transaction_default(this, container, config, outerTx);
  }
  queryCompiler(builder, formatter) {
    return new import_querycompiler.default(this, builder, formatter);
  }
  schemaBuilder() {
    return new import_builder.default(this);
  }
  schemaCompiler(builder) {
    return new import_compiler.default(this, builder);
  }
  tableBuilder(type, tableName, tableNameLike, fn$1) {
    return new import_tablebuilder.default(this, type, tableName, tableNameLike, fn$1);
  }
  viewBuilder(type, viewBuilder, fn$1) {
    return new import_viewbuilder.default(this, type, viewBuilder, fn$1);
  }
  tableCompiler(tableBuilder) {
    return new import_tablecompiler.default(this, tableBuilder);
  }
  viewCompiler(viewCompiler) {
    return new import_viewcompiler.default(this, viewCompiler);
  }
  columnBuilder(tableBuilder, type, args$1) {
    return new import_columnbuilder.default(this, tableBuilder, type, args$1);
  }
  columnCompiler(tableBuilder, columnBuilder) {
    return new import_columncompiler.default(this, tableBuilder, columnBuilder);
  }
  runner(builder) {
    return new import_runner.default(this, builder);
  }
  raw() {
    return new import_raw.default(this).set(...arguments);
  }
  ref() {
    return new import_ref$1.default(this, ...arguments);
  }
  query(connection, queryParam) {
    let queryObject = (0, import_query_executioner.enrichQueryObject)(connection, queryParam, this);
    return (0, import_query_executioner.executeQuery)(connection, queryObject, this);
  }
  stream(connection, queryParam, stream$1, options) {
    let queryObject = (0, import_query_executioner.enrichQueryObject)(connection, queryParam, this);
    return this._stream(connection, queryObject, stream$1, options);
  }
  prepBindings(bindings) {
    return bindings;
  }
  positionBindings(sql) {
    return sql;
  }
  postProcessResponse(resp, queryContext) {
    return this.config.postProcessResponse ? this.config.postProcessResponse(resp, queryContext) : resp;
  }
  wrapIdentifier(value, queryContext) {
    return this.customWrapIdentifier(value, this.wrapIdentifierImpl, queryContext);
  }
  customWrapIdentifier(value, origImpl, queryContext) {
    return this.config.wrapIdentifier ? this.config.wrapIdentifier(value, origImpl, queryContext) : origImpl(value);
  }
  wrapIdentifierImpl(value) {
    return value === `*` ? `*` : `"${value.replace(/"/g, `""`)}"`;
  }
  initializeDriver() {
    try {
      this.driver = this._driver();
    } catch (e$22) {
      let message = `Knex: run
$ npm install ${this.driverName} --save`;
      throw this.logger.error(`${message}
${e$22.message}
${e$22.stack}`), Error(`${message}
${e$22.message}`);
    }
  }
  poolDefaults() {
    return { min: 2, max: 10, propagateCreateError: true };
  }
  getPoolSettings(poolConfig) {
    poolConfig = { ...this.poolDefaults(), ...poolConfig }, import_constants.POOL_CONFIG_OPTIONS.forEach((option) => {
      option in poolConfig && this.logger.warn([`Pool config option "${option}" is no longer supported.`, `See https://github.com/Vincit/tarn.js for possible pool config options.`].join(` `));
    });
    let DEFAULT_ACQUIRE_TIMEOUT = 6e4, timeouts = [this.config.acquireConnectionTimeout, poolConfig.acquireTimeoutMillis].filter((timeout$5) => timeout$5 !== void 0);
    timeouts.length || timeouts.push(DEFAULT_ACQUIRE_TIMEOUT), poolConfig.acquireTimeoutMillis = Math.min(...timeouts);
    let updatePoolConnectionSettingsFromProvider = async () => {
      if (!this.connectionConfigProvider || !this.connectionConfigExpirationChecker || !this.connectionConfigExpirationChecker()) return;
      let providerResult = await this.connectionConfigProvider();
      providerResult.expirationChecker ? (this.connectionConfigExpirationChecker = providerResult.expirationChecker, delete providerResult.expirationChecker) : this.connectionConfigExpirationChecker = null, this.connectionSettings = providerResult;
    };
    return Object.assign(poolConfig, { create: async () => {
      await updatePoolConnectionSettingsFromProvider();
      let connection = await this.acquireRawConnection();
      return connection.__knexUid = (0, import_uniqueId.default)(`__knexUid`), poolConfig.afterCreate && await (0, import_util.promisify)(poolConfig.afterCreate)(connection), connection;
    }, destroy: (connection) => {
      if (connection !== void 0) return this.destroyRawConnection(connection);
    }, validate: (connection) => connection.__knex__disposed ? (this.logger.warn(`Connection Error: ${connection.__knex__disposed}`), false) : this.validateConnection(connection) });
  }
  initializePool(config = this.config) {
    if (this.pool) {
      this.logger.warn(`The pool has already been initialized`);
      return;
    }
    let tarnPoolConfig = { ...this.getPoolSettings(config.pool) };
    tarnPoolConfig.afterCreate && delete tarnPoolConfig.afterCreate, this.pool = new import_tarn.Pool(tarnPoolConfig);
  }
  validateConnection(_connection) {
    return true;
  }
  async acquireConnection() {
    if (!this.pool) throw Error(`Unable to acquire a connection`);
    try {
      let connection = await this.pool.acquire().promise;
      return connection.config && (connection.config.password && (0, import_security.setHiddenProperty)(connection.config), connection.config.authentication && connection.config.authentication.options && connection.config.authentication.options.password && (0, import_security.setHiddenProperty)(connection.config.authentication.options)), connection;
    } catch (error) {
      let convertedError = error;
      throw error instanceof import_tarn.TimeoutError && (convertedError = new import_timeout$1.KnexTimeoutError(`Knex: Timeout acquiring a connection. The pool is probably full. Are you missing a .transacting(trx) call?`)), convertedError;
    }
  }
  releaseConnection(connection) {
    this.pool.release(connection);
    return Promise.resolve();
  }
  async destroy(callback) {
    try {
      this.pool && this.pool.destroy && await this.pool.destroy(), this.pool = void 0, typeof callback == `function` && callback();
    } catch (err$1) {
      if (typeof callback == `function`) return callback(err$1);
      throw err$1;
    }
  }
  database() {
    return this.connectionSettings.database;
  }
  toString() {
    return `[object KnexClient]`;
  }
  assertCanCancelQuery() {
    if (!this.canCancelQuery) throw Error(`Query cancelling not supported for this dialect`);
  }
  cancelQuery() {
    throw Error(`Query cancelling not supported for this dialect`);
  }
  alias(first$1, second) {
    return first$1 + ` as ` + second;
  }
  parameter(value, builder, bindingsHolder) {
    return typeof value == `function` ? (0, import_wrappingFormatter.outputQuery)((0, import_formatterUtils.compileCallback)(value, void 0, this, bindingsHolder), true, builder, this) : (0, import_wrappingFormatter.unwrapRaw)(value, true, builder, this, bindingsHolder) || `?`;
  }
  parameterize(values$3, notSetValue, builder, bindingsHolder) {
    if (typeof values$3 == `function`) return this.parameter(values$3, builder, bindingsHolder);
    values$3 = Array.isArray(values$3) ? values$3 : [values$3];
    let str = ``, i$4 = -1;
    for (; ++i$4 < values$3.length; ) {
      i$4 > 0 && (str += `, `);
      let value = values$3[i$4];
      (0, import_isPlainObject.default)(value) && (value = JSON.stringify(value)), str += this.parameter(value === void 0 ? notSetValue : value, builder, bindingsHolder);
    }
    return str;
  }
  values(values$3, builder, bindingsHolder) {
    return Array.isArray(values$3) ? Array.isArray(values$3[0]) ? `(${values$3.map((value) => `(${this.parameterize(value, void 0, builder, bindingsHolder)})`).join(`, `)})` : `(${this.parameterize(values$3, void 0, builder, bindingsHolder)})` : values$3 && values$3.isRawInstance ? `(${this.parameter(values$3, builder, bindingsHolder)})` : this.parameter(values$3, builder, bindingsHolder);
  }
  processPassedConnection(_connection) {
  }
  toPathForJson(jsonPath) {
    return jsonPath;
  }
};
Object.assign(Client.prototype, { _escapeBinding: (0, import_string$1.makeEscape)({ escapeString(str) {
  return `'${str.replace(/'/g, `''`)}'`;
} }), canCancelQuery: false });
var require_defaults = __commonJSMin$1((exports$12, module2) => {
  var baseRest$1 = require__baseRest(), eq$3 = require_eq$1(), isIterateeCall$1 = require__isIterateeCall(), keysIn = require_keysIn(), objectProto = Object.prototype, hasOwnProperty$2 = objectProto.hasOwnProperty, defaults$2 = baseRest$1(function(object, sources) {
    object = Object(object);
    var index$2 = -1, length = sources.length, guard = length > 2 ? sources[2] : void 0;
    for (guard && isIterateeCall$1(sources[0], sources[1], guard) && (length = 1); ++index$2 < length; ) for (var source = sources[index$2], props = keysIn(source), propsIndex = -1, propsLength = props.length; ++propsIndex < propsLength; ) {
      var key = props[propsIndex], value = object[key];
      (value === void 0 || eq$3(value, objectProto[key]) && !hasOwnProperty$2.call(object, key)) && (object[key] = source[key]);
    }
    return object;
  });
  module2.exports = defaults$2;
}), logger_exports = {};
__export(logger_exports, { default: () => stdin_default });
function isString$9(value) {
  return typeof value == `string`;
}
function isFunction(value) {
  return typeof value == `function`;
}
function resolveIsEnabledColors(enableColorsParam) {
  return enableColorsParam === null ? logger_default && logger_default.stdout ? logger_default.stdout.isTTY : false : enableColorsParam;
}
var Logger$1, stdin_default, init_logger = __esmMin(() => {
  init_logger$1(), Logger$1 = class {
    _inspectionDepth = 5;
    _enableColors = false;
    _debug = () => {
    };
    _warn = () => {
    };
    _error = () => {
    };
    _deprecate = () => {
    };
    constructor(config = {}) {
      let { log: { debug: debug$13, warn, error, deprecate, inspectionDepth, enableColors } = {} } = config;
      this._inspectionDepth = inspectionDepth || 5, this._enableColors = resolveIsEnabledColors(enableColors) || false, this._debug = debug$13, this._warn = warn, this._error = error, this._deprecate = deprecate;
    }
    _log(message, userFn, colorFn) {
      if (userFn !== null && !isFunction(userFn)) throw TypeError(`Extensions to knex logger must be functions!`);
      if (isFunction(userFn)) {
        userFn(message);
        return;
      }
      isString$9(message) || (message = message.toString()), console.log(colorFn ? colorFn(message) : message);
    }
    debug(message) {
      this._log(message, this._debug);
    }
    warn(message) {
      this._log(message, this._warn);
    }
    error(message) {
      this._log(message, this._error);
    }
    deprecate(method$1, alternative) {
      let message = `${method$1} is deprecated, please use ${alternative}`;
      this._log(message, this._deprecate);
    }
  }, stdin_default = Logger$1;
}), require_client = __commonJSMin$1((exports$12, module2) => {
  let { Pool, TimeoutError } = require_tarn(), { EventEmitter } = require_events(), { promisify: promisify$4 } = require_util(), { makeEscape: makeEscape$2 } = require_string(), cloneDeep = require_cloneDeep(), defaults$1 = require_defaults(), uniqueId = require_uniqueId(), Runner = require_runner(), Transaction$15 = (init_transaction(), __toCommonJS(transaction_exports)), { executeQuery, enrichQueryObject } = require_query_executioner(), QueryBuilder$10 = require_querybuilder(), QueryCompiler$12 = require_querycompiler(), SchemaBuilder = require_builder(), SchemaCompiler$11 = require_compiler$1(), TableBuilder = require_tablebuilder(), TableCompiler$14 = require_tablecompiler(), ColumnBuilder$4 = require_columnbuilder(), ColumnCompiler$14 = require_columncompiler(), { KnexTimeoutError: KnexTimeoutError$2 } = require_timeout(), { outputQuery: outputQuery$1, unwrapRaw: unwrapRaw$1 } = require_wrappingFormatter(), { compileCallback: compileCallback$2 } = require_formatterUtils(), Raw$3 = require_raw(), Ref$1 = require_ref(), Formatter$5 = require_formatter(), Logger = (init_logger(), __toCommonJS(logger_exports)), { POOL_CONFIG_OPTIONS } = require_constants$3(), ViewBuilder$6 = require_viewbuilder(), ViewCompiler$12 = require_viewcompiler(), isPlainObject$4 = require_isPlainObject(), { setHiddenProperty: setHiddenProperty$2 } = require_security(), debug$9 = require_src()(`knex:client`);
  var Client$7 = class extends EventEmitter {
    constructor(config = {}) {
      super(), this.config = config, this.logger = new Logger(config), this.config.connection && this.config.connection.password && setHiddenProperty$2(this.config.connection), this.dialect && !this.config.client && this.logger.warn(`Using 'this.dialect' to identify the client is deprecated and support for it will be removed in the future. Please use configuration option 'client' instead.`);
      let dbClient = this.config.client || this.dialect;
      if (!dbClient) throw Error(`knex: Required configuration option 'client' is missing.`);
      config.version && (this.version = config.version), config.connection && config.connection instanceof Function ? (this.connectionConfigProvider = config.connection, this.connectionConfigExpirationChecker = () => true) : (this.connectionSettings = cloneDeep(config.connection || {}), config.connection && config.connection.password && setHiddenProperty$2(this.connectionSettings, config.connection), this.connectionConfigExpirationChecker = null), this.driverName && config.connection && (this.initializeDriver(), (!config.pool || config.pool && config.pool.max !== 0) && this.initializePool(config)), this.valueForUndefined = this.raw(`DEFAULT`), config.useNullAsDefault && (this.valueForUndefined = null);
    }
    formatter(builder) {
      return new Formatter$5(this, builder);
    }
    queryBuilder() {
      return new QueryBuilder$10(this);
    }
    queryCompiler(builder, formatter) {
      return new QueryCompiler$12(this, builder, formatter);
    }
    schemaBuilder() {
      return new SchemaBuilder(this);
    }
    schemaCompiler(builder) {
      return new SchemaCompiler$11(this, builder);
    }
    tableBuilder(type, tableName, tableNameLike, fn$1) {
      return new TableBuilder(this, type, tableName, tableNameLike, fn$1);
    }
    viewBuilder(type, viewBuilder, fn$1) {
      return new ViewBuilder$6(this, type, viewBuilder, fn$1);
    }
    tableCompiler(tableBuilder) {
      return new TableCompiler$14(this, tableBuilder);
    }
    viewCompiler(viewCompiler) {
      return new ViewCompiler$12(this, viewCompiler);
    }
    columnBuilder(tableBuilder, type, args$1) {
      return new ColumnBuilder$4(this, tableBuilder, type, args$1);
    }
    columnCompiler(tableBuilder, columnBuilder) {
      return new ColumnCompiler$14(this, tableBuilder, columnBuilder);
    }
    runner(builder) {
      return new Runner(this, builder);
    }
    transaction(container, config, outerTx) {
      return new Transaction$15(this, container, config, outerTx);
    }
    raw() {
      return new Raw$3(this).set(...arguments);
    }
    ref() {
      return new Ref$1(this, ...arguments);
    }
    query(connection, queryParam) {
      let queryObject = enrichQueryObject(connection, queryParam, this);
      return executeQuery(connection, queryObject, this);
    }
    stream(connection, queryParam, stream$1, options) {
      let queryObject = enrichQueryObject(connection, queryParam, this);
      return this._stream(connection, queryObject, stream$1, options);
    }
    prepBindings(bindings) {
      return bindings;
    }
    positionBindings(sql) {
      return sql;
    }
    postProcessResponse(resp, queryContext) {
      return this.config.postProcessResponse ? this.config.postProcessResponse(resp, queryContext) : resp;
    }
    wrapIdentifier(value, queryContext) {
      return this.customWrapIdentifier(value, this.wrapIdentifierImpl, queryContext);
    }
    customWrapIdentifier(value, origImpl, queryContext) {
      return this.config.wrapIdentifier ? this.config.wrapIdentifier(value, origImpl, queryContext) : origImpl(value);
    }
    wrapIdentifierImpl(value) {
      return value === `*` ? `*` : `"${value.replace(/"/g, `""`)}"`;
    }
    initializeDriver() {
      try {
        this.driver = this._driver();
      } catch (e$22) {
        let message = `Knex: run
$ npm install ${this.driverName} --save`;
        throw this.logger.error(`${message}
${e$22.message}
${e$22.stack}`), Error(`${message}
${e$22.message}`);
      }
    }
    poolDefaults() {
      return { min: 2, max: 10, propagateCreateError: true };
    }
    getPoolSettings(poolConfig) {
      poolConfig = defaults$1({}, poolConfig, this.poolDefaults()), POOL_CONFIG_OPTIONS.forEach((option) => {
        option in poolConfig && this.logger.warn([`Pool config option "${option}" is no longer supported.`, `See https://github.com/Vincit/tarn.js for possible pool config options.`].join(` `));
      });
      let DEFAULT_ACQUIRE_TIMEOUT = 6e4, timeouts = [this.config.acquireConnectionTimeout, poolConfig.acquireTimeoutMillis].filter((timeout$5) => timeout$5 !== void 0);
      timeouts.length || timeouts.push(DEFAULT_ACQUIRE_TIMEOUT), poolConfig.acquireTimeoutMillis = Math.min(...timeouts);
      let updatePoolConnectionSettingsFromProvider = async () => {
        if (!this.connectionConfigProvider || !this.connectionConfigExpirationChecker || !this.connectionConfigExpirationChecker()) return;
        let providerResult = await this.connectionConfigProvider();
        providerResult.expirationChecker ? (this.connectionConfigExpirationChecker = providerResult.expirationChecker, delete providerResult.expirationChecker) : this.connectionConfigExpirationChecker = null, this.connectionSettings = providerResult;
      };
      return Object.assign(poolConfig, { create: async () => {
        await updatePoolConnectionSettingsFromProvider();
        let connection = await this.acquireRawConnection();
        return connection.__knexUid = uniqueId(`__knexUid`), poolConfig.afterCreate && await promisify$4(poolConfig.afterCreate)(connection), connection;
      }, destroy: (connection) => {
        if (connection !== void 0) return this.destroyRawConnection(connection);
      }, validate: (connection) => connection.__knex__disposed ? (this.logger.warn(`Connection Error: ${connection.__knex__disposed}`), false) : this.validateConnection(connection) });
    }
    initializePool(config = this.config) {
      if (this.pool) {
        this.logger.warn(`The pool has already been initialized`);
        return;
      }
      let tarnPoolConfig = { ...this.getPoolSettings(config.pool) };
      tarnPoolConfig.afterCreate && delete tarnPoolConfig.afterCreate, this.pool = new Pool(tarnPoolConfig);
    }
    validateConnection(connection) {
      return true;
    }
    async acquireConnection() {
      if (!this.pool) throw Error(`Unable to acquire a connection`);
      try {
        let connection = await this.pool.acquire().promise;
        return debug$9(`acquired connection from pool: %s`, connection.__knexUid), connection.config && (connection.config.password && setHiddenProperty$2(connection.config), connection.config.authentication && connection.config.authentication.options && connection.config.authentication.options.password && setHiddenProperty$2(connection.config.authentication.options)), connection;
      } catch (error) {
        let convertedError = error;
        throw error instanceof TimeoutError && (convertedError = new KnexTimeoutError$2(`Knex: Timeout acquiring a connection. The pool is probably full. Are you missing a .transacting(trx) call?`)), convertedError;
      }
    }
    releaseConnection(connection) {
      debug$9(`releasing connection to pool: %s`, connection.__knexUid);
      let didRelease = this.pool.release(connection);
      return didRelease || debug$9(`pool refused connection: %s`, connection.__knexUid), Promise.resolve();
    }
    async destroy(callback) {
      try {
        this.pool && this.pool.destroy && await this.pool.destroy(), this.pool = void 0, typeof callback == `function` && callback();
      } catch (err$1) {
        if (typeof callback == `function`) return callback(err$1);
        throw err$1;
      }
    }
    database() {
      return this.connectionSettings.database;
    }
    toString() {
      return `[object KnexClient]`;
    }
    assertCanCancelQuery() {
      if (!this.canCancelQuery) throw Error(`Query cancelling not supported for this dialect`);
    }
    cancelQuery() {
      throw Error(`Query cancelling not supported for this dialect`);
    }
    alias(first$1, second) {
      return first$1 + ` as ` + second;
    }
    parameter(value, builder, bindingsHolder) {
      return typeof value == `function` ? outputQuery$1(compileCallback$2(value, void 0, this, bindingsHolder), true, builder, this) : unwrapRaw$1(value, true, builder, this, bindingsHolder) || `?`;
    }
    parameterize(values$3, notSetValue, builder, bindingsHolder) {
      if (typeof values$3 == `function`) return this.parameter(values$3, builder, bindingsHolder);
      values$3 = Array.isArray(values$3) ? values$3 : [values$3];
      let str = ``, i$4 = -1;
      for (; ++i$4 < values$3.length; ) {
        i$4 > 0 && (str += `, `);
        let value = values$3[i$4];
        isPlainObject$4(value) && (value = JSON.stringify(value)), str += this.parameter(value === void 0 ? notSetValue : value, builder, bindingsHolder);
      }
      return str;
    }
    values(values$3, builder, bindingsHolder) {
      return Array.isArray(values$3) ? Array.isArray(values$3[0]) ? `(${values$3.map((value) => `(${this.parameterize(value, void 0, builder, bindingsHolder)})`).join(`, `)})` : `(${this.parameterize(values$3, void 0, builder, bindingsHolder)})` : values$3 && values$3.isRawInstance ? `(${this.parameter(values$3, builder, bindingsHolder)})` : this.parameter(values$3, builder, bindingsHolder);
    }
    processPassedConnection(connection) {
    }
    toPathForJson(jsonPath) {
      return jsonPath;
    }
  };
  Object.assign(Client$7.prototype, { _escapeBinding: makeEscape$2({ escapeString(str) {
    return `'${str.replace(/'/g, `''`)}'`;
  } }), canCancelQuery: false }), module2.exports = Client$7;
}), require_pg_connection_string = __commonJSMin$1((exports$12, module2) => {
  function parse$11(str) {
    if (str.charAt(0) === `/`) {
      let config$1 = str.split(` `);
      return { host: config$1[0], database: config$1[1] };
    }
    let config = {}, result, dummyHost = false;
    / |%[^a-f0-9]|%[a-f0-9][^a-f0-9]/i.test(str) && (str = encodeURI(str).replace(/\%25(\d\d)/g, `%$1`));
    try {
      result = new URL(str, `postgres://base`);
    } catch {
      result = new URL(str.replace(`@/`, `@___DUMMY___/`), `postgres://base`), dummyHost = true;
    }
    for (let entry of result.searchParams.entries()) config[entry[0]] = entry[1];
    if (config.user = config.user || decodeURIComponent(result.username), config.password = config.password || decodeURIComponent(result.password), result.protocol == `socket:`) return config.host = decodeURI(result.pathname), config.database = result.searchParams.get(`db`), config.client_encoding = result.searchParams.get(`encoding`), config;
    let hostname = dummyHost ? `` : result.hostname;
    config.host ? hostname && /^%2f/i.test(hostname) && (result.pathname = hostname + result.pathname) : config.host = decodeURIComponent(hostname), config.port ||= result.port;
    let pathname = result.pathname.slice(1) || null;
    config.database = pathname ? decodeURI(pathname) : null, (config.ssl === `true` || config.ssl === `1`) && (config.ssl = true), config.ssl === `0` && (config.ssl = false), (config.sslcert || config.sslkey || config.sslrootcert || config.sslmode) && (config.ssl = {});
    let fs = config.sslcert || config.sslkey || config.sslrootcert ? __require$1(`fs`) : null;
    switch (config.sslcert && (config.ssl.cert = fs.readFileSync(config.sslcert).toString()), config.sslkey && (config.ssl.key = fs.readFileSync(config.sslkey).toString()), config.sslrootcert && (config.ssl.ca = fs.readFileSync(config.sslrootcert).toString()), config.sslmode) {
      case `disable`:
        config.ssl = false;
        break;
      case `prefer`:
      case `require`:
      case `verify-ca`:
      case `verify-full`:
        break;
      case `no-verify`:
        config.ssl.rejectUnauthorized = false;
        break;
    }
    return config;
  }
  module2.exports = parse$11, parse$11.parse = parse$11;
}), require_parse_connection = __commonJSMin$1((exports$12, module2) => {
  init_dist();
  let { parse: parse$10 } = require_pg_connection_string(), parsePG = parse$10, isWindows = process$1 && process$1.platform && process$1.platform === `win32`;
  function tryParse(str) {
    try {
      return new URL(str);
    } catch {
      return null;
    }
  }
  module2.exports = function(str) {
    let parsed = tryParse(str), isDriveLetter = isWindows && parsed && parsed.protocol.length === 2;
    if (!parsed || isDriveLetter) return { client: `sqlite3`, connection: { filename: str } };
    let { protocol } = parsed;
    protocol.slice(-1) === `:` && (protocol = protocol.slice(0, -1));
    let isPG = [`postgresql`, `postgres`].includes(protocol);
    return { client: protocol, connection: isPG ? parsePG(str) : connectionObject(parsed) };
  };
  function connectionObject(parsed) {
    let connection = {}, db = parsed.pathname;
    if (db[0] === `/` && (db = db.slice(1)), connection.database = db, parsed.hostname && (parsed.protocol.indexOf(`mssql`) === 0 ? connection.server = parsed.hostname : connection.host = parsed.hostname), parsed.port && (connection.port = parsed.port), (parsed.username || parsed.password) && (connection.user = decodeURIComponent(parsed.username)), parsed.password && (connection.password = decodeURIComponent(parsed.password)), parsed.searchParams) for (let [key, value] of parsed.searchParams.entries()) {
      let isNestedConfigSupported = [`mysql:`, `mariadb:`, `mssql:`].includes(parsed.protocol);
      if (isNestedConfigSupported) try {
        connection[key] = JSON.parse(value);
      } catch {
        connection[key] = value;
      }
      else connection[key] = value;
    }
    return connection;
  }
}), require_sqlite_transaction = __commonJSMin$1((exports$12, module2) => {
  let Transaction$14 = (init_transaction(), __toCommonJS(transaction_exports));
  var Transaction_Sqlite = class extends Transaction$14 {
    begin(conn) {
      return this.isolationLevel && this.client.logger.warn(`sqlite3 only supports serializable transactions, ignoring the isolation level param`), this.readOnly && this.client.logger.warn(`sqlite3 implicitly handles read vs write transactions`), this.query(conn, `BEGIN;`);
    }
  };
  module2.exports = Transaction_Sqlite;
}), require_sqlite_querycompiler = __commonJSMin$1((exports$12, module2) => {
  let constant = require_constant(), each$2 = require_each(), identity$7 = require_identity(), isEmpty$7 = require_isEmpty(), reduce$2 = require_reduce(), QueryCompiler$11 = require_querycompiler(), noop$2 = require_noop$1(), { isString: isString$8 } = require_is(), { wrapString: wrapString$1, columnize: columnize_$8 } = require_wrappingFormatter(), emptyStr = constant(``);
  var QueryCompiler_SQLite3 = class extends QueryCompiler$11 {
    constructor(client, builder, formatter) {
      super(client, builder, formatter), this.forShare = emptyStr, this.forKeyShare = emptyStr, this.forUpdate = emptyStr, this.forNoKeyUpdate = emptyStr;
    }
    insert() {
      let insertValues = this.single.insert || [], sql = this.with() + `insert into ${this.tableName} `;
      if (Array.isArray(insertValues)) {
        if (insertValues.length === 0) return ``;
        if (insertValues.length === 1 && insertValues[0] && isEmpty$7(insertValues[0])) return { sql: sql + this._emptyInsertValue };
      } else if (typeof insertValues == `object` && isEmpty$7(insertValues)) return { sql: sql + this._emptyInsertValue };
      let insertData = this._prepInsert(insertValues);
      if (isString$8(insertData)) return { sql: sql + insertData };
      if (insertData.columns.length === 0) return { sql: `` };
      if (sql += `(${this.formatter.columnize(insertData.columns)})`, this.client.valueForUndefined !== null && insertData.values.forEach((bindings) => {
        each$2(bindings, (binding) => {
          if (binding === void 0) throw TypeError("`sqlite` does not support inserting default values. Specify values explicitly or use the `useNullAsDefault` config flag. (see docs https://knexjs.org/guide/query-builder.html#insert).");
        });
      }), insertData.values.length === 1) {
        let parameters = this.client.parameterize(insertData.values[0], this.client.valueForUndefined, this.builder, this.bindingsHolder);
        sql += ` values (${parameters})`;
        let { onConflict: onConflict$1, ignore: ignore$3, merge: merge$5 } = this.single;
        if (onConflict$1 && ignore$3) sql += this._ignore(onConflict$1);
        else if (onConflict$1 && merge$5) {
          sql += this._merge(merge$5.updates, onConflict$1, insertValues);
          let wheres = this.where();
          wheres && (sql += ` ${wheres}`);
        }
        let { returning: returning$1 } = this.single;
        return returning$1 && (sql += this._returning(returning$1)), { sql, returning: returning$1 };
      }
      let blocks = [], i$4 = -1;
      for (; ++i$4 < insertData.values.length; ) {
        let i2 = -1, block$1 = blocks[i$4] = [], current = insertData.values[i$4];
        for (current = current === void 0 ? this.client.valueForUndefined : current; ++i2 < insertData.columns.length; ) block$1.push(this.client.alias(this.client.parameter(current[i2], this.builder, this.bindingsHolder), this.formatter.wrap(insertData.columns[i2])));
        blocks[i$4] = block$1.join(`, `);
      }
      sql += ` select ` + blocks.join(` union all select `);
      let { onConflict, ignore: ignore$2, merge: merge$4 } = this.single;
      onConflict && ignore$2 ? sql += ` where true` + this._ignore(onConflict) : onConflict && merge$4 && (sql += ` where true` + this._merge(merge$4.updates, onConflict, insertValues));
      let { returning } = this.single;
      return returning && (sql += this._returning(returning)), { sql, returning };
    }
    update() {
      let withSQL = this.with(), updateData = this._prepUpdate(this.single.update), wheres = this.where(), { returning } = this.single;
      return { sql: withSQL + `update ${this.single.only ? `only ` : ``}${this.tableName} set ${updateData.join(`, `)}` + (wheres ? ` ${wheres}` : ``) + this._returning(returning), returning };
    }
    _ignore(columns) {
      return columns === true ? ` on conflict do nothing` : ` on conflict ${this._onConflictClause(columns)} do nothing`;
    }
    _merge(updates, columns, insert) {
      let sql = ` on conflict ${this._onConflictClause(columns)} do update set `;
      if (updates && Array.isArray(updates)) return sql += updates.map((column) => wrapString$1(column.split(`.`).pop(), this.formatter.builder, this.client, this.formatter)).map((column) => `${column} = excluded.${column}`).join(`, `), sql;
      if (updates && typeof updates == `object`) {
        let updateData = this._prepUpdate(updates);
        return typeof updateData == `string` ? sql += updateData : sql += updateData.join(`,`), sql;
      } else {
        let insertData = this._prepInsert(insert);
        if (typeof insertData == `string`) throw Error(`If using merge with a raw insert query, then updates must be provided`);
        return sql += insertData.columns.map((column) => wrapString$1(column.split(`.`).pop(), this.builder, this.client)).map((column) => `${column} = excluded.${column}`).join(`, `), sql;
      }
    }
    _returning(value) {
      return value ? ` returning ${this.formatter.columnize(value)}` : ``;
    }
    truncate() {
      let { table: table$2 } = this.single;
      return { sql: `delete from ${this.tableName}`, output() {
        return this.query({ sql: `delete from sqlite_sequence where name = '${table$2}'` }).catch(noop$2);
      } };
    }
    columnInfo() {
      let column = this.single.columnInfo, table$2 = this.client.customWrapIdentifier(this.single.table, identity$7);
      return { sql: `PRAGMA table_info(\`${table$2}\`)`, output(resp) {
        let maxLengthRegex = /.*\((\d+)\)/, out = reduce$2(resp, function(columns, val) {
          let { type } = val, maxLength = type.match(maxLengthRegex);
          return maxLength &&= maxLength[1], type = maxLength ? type.split(`(`)[0] : type, columns[val.name] = { type: type.toLowerCase(), maxLength, nullable: !val.notnull, defaultValue: val.dflt_value }, columns;
        }, {});
        return column && out[column] || out;
      } };
    }
    limit() {
      let noLimit = !this.single.limit && this.single.limit !== 0;
      return noLimit && !this.single.offset ? `` : (this.single.limit = noLimit ? -1 : this.single.limit, `limit ${this._getValueOrParameterFromAttribute(`limit`)}`);
    }
    jsonExtract(params) {
      return this._jsonExtract(`json_extract`, params);
    }
    jsonSet(params) {
      return this._jsonSet(`json_set`, params);
    }
    jsonInsert(params) {
      return this._jsonSet(`json_insert`, params);
    }
    jsonRemove(params) {
      let jsonCol = `json_remove(${columnize_$8(params.column, this.builder, this.client, this.bindingsHolder)},${this.client.parameter(params.path, this.builder, this.bindingsHolder)})`;
      return params.alias ? this.client.alias(jsonCol, this.formatter.wrap(params.alias)) : jsonCol;
    }
    whereJsonPath(statement) {
      return this._whereJsonPath(`json_extract`, statement);
    }
    whereJsonSupersetOf(statement) {
      throw Error(`Json superset where clause not actually supported by SQLite`);
    }
    whereJsonSubsetOf(statement) {
      throw Error(`Json subset where clause not actually supported by SQLite`);
    }
    onJsonPathEquals(clause) {
      return this._onJsonPathEquals(`json_extract`, clause);
    }
  };
  module2.exports = QueryCompiler_SQLite3;
}), require__baseSome = __commonJSMin$1((exports$12, module2) => {
  var baseEach = require__baseEach();
  function baseSome$1(collection, predicate) {
    var result;
    return baseEach(collection, function(value, index$2, collection$1) {
      return result = predicate(value, index$2, collection$1), !result;
    }), !!result;
  }
  module2.exports = baseSome$1;
}), require_some = __commonJSMin$1((exports$12, module2) => {
  var arraySome = require__arraySome(), baseIteratee$1 = require__baseIteratee(), baseSome = require__baseSome(), isArray$3 = require_isArray(), isIterateeCall = require__isIterateeCall();
  function some$1(collection, predicate, guard) {
    var func = isArray$3(collection) ? arraySome : baseSome;
    return guard && isIterateeCall(collection, predicate, guard) && (predicate = void 0), func(collection, baseIteratee$1(predicate, 3));
  }
  module2.exports = some$1;
}), require_sqlite_compiler = __commonJSMin$1((exports$12, module2) => {
  let SchemaCompiler$10 = require_compiler$1(), some = require_some();
  var SchemaCompiler_SQLite3 = class extends SchemaCompiler$10 {
    constructor(client, builder) {
      super(client, builder);
    }
    hasTable(tableName) {
      let sql = `select * from sqlite_master where type = 'table' and name = ${this.client.parameter(this.formatter.wrap(tableName).replace(/`/g, ``), this.builder, this.bindingsHolder)}`;
      this.pushQuery({ sql, output: (resp) => resp.length > 0 });
    }
    hasColumn(tableName, column) {
      this.pushQuery({ sql: `PRAGMA table_info(${this.formatter.wrap(tableName)})`, output(resp) {
        return some(resp, (col) => this.client.wrapIdentifier(col.name.toLowerCase()) === this.client.wrapIdentifier(column.toLowerCase()));
      } });
    }
    renameTable(from$2, to) {
      this.pushQuery(`alter table ${this.formatter.wrap(from$2)} rename to ${this.formatter.wrap(to)}`);
    }
    async generateDdlCommands() {
      let sequence = this.builder._sequence;
      for (let i$4 = 0, l$4 = sequence.length; i$4 < l$4; i$4++) {
        let query = sequence[i$4];
        this[query.method].apply(this, query.args);
      }
      let commandSources = this.sequence;
      if (commandSources.length === 1 && commandSources[0].statementsProducer) return commandSources[0].statementsProducer();
      {
        let result = [];
        for (let commandSource of commandSources) {
          let command = commandSource.sql;
          Array.isArray(command) ? result.push(...command) : result.push(command);
        }
        return { pre: [], sql: result, check: null, post: [] };
      }
    }
  };
  module2.exports = SchemaCompiler_SQLite3;
}), require_sqlite_columncompiler = __commonJSMin$1((exports$12, module2) => {
  let ColumnCompiler$13 = require_columncompiler();
  var ColumnCompiler_SQLite3 = class extends ColumnCompiler$13 {
    constructor() {
      super(...arguments), this.modifiers = [`nullable`, `defaultTo`], this._addCheckModifiers();
    }
    enu(allowed) {
      return `text check (${this.formatter.wrap(this.args[0])} in ('${allowed.join(`', '`)}'))`;
    }
    _pushAlterCheckQuery(checkPredicate, constraintName$2) {
      throw Error(`Alter table with to add constraints is not permitted in SQLite`);
    }
    checkRegex(regexes, constraintName$2) {
      return this._check(`${this.formatter.wrap(this.getColumnName())} REGEXP ${this.client._escapeBinding(regexes)}`, constraintName$2);
    }
  };
  ColumnCompiler_SQLite3.prototype.json = `json`, ColumnCompiler_SQLite3.prototype.jsonb = `json`, ColumnCompiler_SQLite3.prototype.double = ColumnCompiler_SQLite3.prototype.decimal = ColumnCompiler_SQLite3.prototype.floating = `float`, ColumnCompiler_SQLite3.prototype.timestamp = `datetime`, ColumnCompiler_SQLite3.prototype.increments = ColumnCompiler_SQLite3.prototype.bigincrements = `integer not null primary key autoincrement`, module2.exports = ColumnCompiler_SQLite3;
}), require_filter = __commonJSMin$1((exports$12, module2) => {
  var arrayFilter = require__arrayFilter(), baseFilter = require__baseFilter(), baseIteratee = require__baseIteratee(), isArray$2 = require_isArray();
  function filter$1(collection, predicate) {
    var func = isArray$2(collection) ? arrayFilter : baseFilter;
    return func(collection, baseIteratee(predicate, 3));
  }
  module2.exports = filter$1;
}), require_sqlite_tablecompiler = __commonJSMin$1((exports$12, module2) => {
  let filter = require_filter(), values = require_values(), identity$6 = require_identity(), { isObject: isObject$8 } = require_is(), TableCompiler$13 = require_tablecompiler(), { formatDefault: formatDefault$1 } = require_formatterUtils();
  var TableCompiler_SQLite3 = class extends TableCompiler$13 {
    constructor() {
      super(...arguments);
    }
    createQuery(columns, ifNot, like) {
      let createStatement = ifNot ? `create table if not exists ` : `create table `, sql = createStatement + this.tableName();
      like && this.tableNameLike() ? sql += ` as select * from ` + this.tableNameLike() + ` where 0=1` : (sql += ` (` + columns.sql.join(`, `), sql += this.foreignKeys() || ``, sql += this.primaryKeys() || ``, sql += this._addChecks(), sql += `)`), this.pushQuery(sql), like && this.addColumns(columns, this.addColumnsPrefix);
    }
    addColumns(columns, prefix, colCompilers) {
      if (prefix === this.alterColumnsPrefix) {
        let compiler = this, columnsInfo = colCompilers.map((col) => {
          let name$2 = this.client.customWrapIdentifier(col.getColumnName(), identity$6, col.columnBuilder.queryContext()), type = col.getColumnType(), defaultTo = col.modified.defaultTo ? formatDefault$1(col.modified.defaultTo[0], col.type, this.client) : null, notNull = col.modified.nullable && col.modified.nullable[0] === false;
          return { name: name$2, type, defaultTo, notNull };
        });
        this.pushQuery({ sql: `PRAGMA table_info(${this.tableName()})`, statementsProducer(pragma, connection) {
          return compiler.client.ddl(compiler, pragma, connection).alterColumn(columnsInfo);
        } });
      } else for (let i$4 = 0, l$4 = columns.sql.length; i$4 < l$4; i$4++) this.pushQuery({ sql: `alter table ${this.tableName()} add column ${columns.sql[i$4]}`, bindings: columns.bindings[i$4] });
    }
    dropUnique(columns, indexName) {
      indexName = indexName ? this.formatter.wrap(indexName) : this._indexCommand(`unique`, this.tableNameRaw, columns), this.pushQuery(`drop index ${indexName}`);
    }
    dropForeign(columns, indexName) {
      let compiler = this;
      columns = Array.isArray(columns) ? columns : [columns], columns = columns.map((column) => this.client.customWrapIdentifier(column, identity$6)), indexName = this.client.customWrapIdentifier(indexName, identity$6), this.pushQuery({ sql: `PRAGMA table_info(${this.tableName()})`, output(pragma) {
        return compiler.client.ddl(compiler, pragma, this.connection).dropForeign(columns, indexName);
      } });
    }
    dropPrimary(constraintName$2) {
      let compiler = this;
      constraintName$2 = this.client.customWrapIdentifier(constraintName$2, identity$6), this.pushQuery({ sql: `PRAGMA table_info(${this.tableName()})`, output(pragma) {
        return compiler.client.ddl(compiler, pragma, this.connection).dropPrimary(constraintName$2);
      } });
    }
    dropIndex(columns, indexName) {
      indexName = indexName ? this.formatter.wrap(indexName) : this._indexCommand(`index`, this.tableNameRaw, columns), this.pushQuery(`drop index ${indexName}`);
    }
    unique(columns, indexName) {
      let deferrable$2, predicate;
      isObject$8(indexName) && ({ indexName, deferrable: deferrable$2, predicate } = indexName), deferrable$2 && deferrable$2 !== `not deferrable` && this.client.logger.warn(`sqlite3: unique index \`${indexName}\` will not be deferrable ${deferrable$2} because sqlite3 does not support deferred constraints.`), indexName = indexName ? this.formatter.wrap(indexName) : this._indexCommand(`unique`, this.tableNameRaw, columns), columns = this.formatter.columnize(columns);
      let predicateQuery = predicate ? ` ` + this.client.queryCompiler(predicate).where() : ``;
      this.pushQuery(`create unique index ${indexName} on ${this.tableName()} (${columns})${predicateQuery}`);
    }
    index(columns, indexName, options) {
      indexName = indexName ? this.formatter.wrap(indexName) : this._indexCommand(`index`, this.tableNameRaw, columns), columns = this.formatter.columnize(columns);
      let predicate;
      isObject$8(options) && ({ predicate } = options);
      let predicateQuery = predicate ? ` ` + this.client.queryCompiler(predicate).where() : ``;
      this.pushQuery(`create index ${indexName} on ${this.tableName()} (${columns})${predicateQuery}`);
    }
    primary(columns, constraintName$2) {
      let compiler = this;
      columns = Array.isArray(columns) ? columns : [columns], columns = columns.map((column) => this.client.customWrapIdentifier(column, identity$6));
      let deferrable$2;
      isObject$8(constraintName$2) && ({ constraintName: constraintName$2, deferrable: deferrable$2 } = constraintName$2), deferrable$2 && deferrable$2 !== `not deferrable` && this.client.logger.warn(`sqlite3: primary key constraint \`${constraintName$2}\` will not be deferrable ${deferrable$2} because sqlite3 does not support deferred constraints.`), constraintName$2 = this.client.customWrapIdentifier(constraintName$2, identity$6), this.method !== `create` && this.method !== `createIfNot` && this.pushQuery({ sql: `PRAGMA table_info(${this.tableName()})`, output(pragma) {
        return compiler.client.ddl(compiler, pragma, this.connection).primary(columns, constraintName$2);
      } });
    }
    foreign(foreignInfo) {
      let compiler = this;
      this.method !== `create` && this.method !== `createIfNot` && (foreignInfo.column = Array.isArray(foreignInfo.column) ? foreignInfo.column : [foreignInfo.column], foreignInfo.column = foreignInfo.column.map((column) => this.client.customWrapIdentifier(column, identity$6)), foreignInfo.inTable = this.client.customWrapIdentifier(foreignInfo.inTable, identity$6), foreignInfo.references = Array.isArray(foreignInfo.references) ? foreignInfo.references : [foreignInfo.references], foreignInfo.references = foreignInfo.references.map((column) => this.client.customWrapIdentifier(column, identity$6)), this.pushQuery({ sql: `PRAGMA table_info(${this.tableName()})`, statementsProducer(pragma, connection) {
        return compiler.client.ddl(compiler, pragma, connection).foreign(foreignInfo);
      } }));
    }
    primaryKeys() {
      let pks = filter(this.grouped.alterTable || [], { method: `primary` });
      if (pks.length > 0 && pks[0].args.length > 0) {
        let columns = pks[0].args[0], constraintName$2 = pks[0].args[1] || ``;
        constraintName$2 &&= ` constraint ` + this.formatter.wrap(constraintName$2);
        let needUniqueCols = this.grouped.columns.filter((t$7) => t$7.builder._type === `increments`).length > 0;
        return `,${constraintName$2} ${needUniqueCols ? `unique` : `primary key`} (${this.formatter.columnize(columns)})`;
      }
    }
    foreignKeys() {
      let sql = ``, foreignKeys = filter(this.grouped.alterTable || [], { method: `foreign` });
      for (let i$4 = 0, l$4 = foreignKeys.length; i$4 < l$4; i$4++) {
        let foreign = foreignKeys[i$4].args[0], column = this.formatter.columnize(foreign.column), references = this.formatter.columnize(foreign.references), foreignTable = this.formatter.wrap(foreign.inTable), constraintName$2 = foreign.keyName || ``;
        constraintName$2 &&= ` constraint ` + this.formatter.wrap(constraintName$2), sql += `,${constraintName$2} foreign key(${column}) references ${foreignTable}(${references})`, foreign.onDelete && (sql += ` on delete ${foreign.onDelete}`), foreign.onUpdate && (sql += ` on update ${foreign.onUpdate}`);
      }
      return sql;
    }
    createTableBlock() {
      return this.getColumns().concat().join(`,`);
    }
    renameColumn(from$2, to) {
      this.pushQuery({ sql: `alter table ${this.tableName()} rename ${this.formatter.wrap(from$2)} to ${this.formatter.wrap(to)}` });
    }
    _setNullableState(column, isNullable) {
      let compiler = this;
      this.pushQuery({ sql: `PRAGMA table_info(${this.tableName()})`, statementsProducer(pragma, connection) {
        return compiler.client.ddl(compiler, pragma, connection).setNullable(column, isNullable);
      } });
    }
    dropColumn() {
      let compiler = this, columns = values(arguments), columnsWrapped = columns.map((column) => this.client.customWrapIdentifier(column, identity$6));
      this.pushQuery({ sql: `PRAGMA table_info(${this.tableName()})`, output(pragma) {
        return compiler.client.ddl(compiler, pragma, this.connection).dropColumn(columnsWrapped);
      } });
    }
  };
  module2.exports = TableCompiler_SQLite3;
}), require_sqlite_viewcompiler = __commonJSMin$1((exports$12, module2) => {
  let ViewCompiler$11 = require_viewcompiler(), { columnize: columnize_$7 } = require_wrappingFormatter();
  var ViewCompiler_SQLite3 = class extends ViewCompiler$11 {
    constructor(client, viewCompiler) {
      super(client, viewCompiler);
    }
    createOrReplace() {
      let columns = this.columns, selectQuery = this.selectQuery.toString(), viewName = this.viewName(), columnList = columns ? ` (` + columnize_$7(columns, this.viewBuilder, this.client, this.bindingsHolder) + `)` : ``, dropSql = `drop view if exists ${viewName}`, createSql = `create view ${viewName}${columnList} as ${selectQuery}`;
      this.pushQuery({ sql: dropSql }), this.pushQuery({ sql: createSql });
    }
  };
  module2.exports = ViewCompiler_SQLite3;
}), require_sqlite_ddl_operations = __commonJSMin$1((exports$12, module2) => {
  function copyData$1(sourceTable, targetTable, columns) {
    return `INSERT INTO "${targetTable}" SELECT ${columns === void 0 ? `*` : columns.map((column) => `"${column}"`).join(`, `)} FROM "${sourceTable}";`;
  }
  function dropOriginal$1(tableName) {
    return `DROP TABLE "${tableName}"`;
  }
  function renameTable$1(tableName, alteredName) {
    return `ALTER TABLE "${tableName}" RENAME TO "${alteredName}"`;
  }
  function getTableSql$1(tableName) {
    return `SELECT type, sql FROM sqlite_master WHERE (type='table' OR (type='index' AND sql IS NOT NULL)) AND lower(tbl_name)='${tableName.toLowerCase()}'`;
  }
  function isForeignCheckEnabled$1() {
    return `PRAGMA foreign_keys`;
  }
  function setForeignCheck$1(enable) {
    return `PRAGMA foreign_keys = ${enable ? `ON` : `OFF`}`;
  }
  function executeForeignCheck$1() {
    return `PRAGMA foreign_key_check`;
  }
  module2.exports = { copyData: copyData$1, dropOriginal: dropOriginal$1, renameTable: renameTable$1, getTableSql: getTableSql$1, isForeignCheckEnabled: isForeignCheckEnabled$1, setForeignCheck: setForeignCheck$1, executeForeignCheck: executeForeignCheck$1 };
}), require_tokenizer = __commonJSMin$1((exports$12, module2) => {
  function tokenize$1(text, tokens) {
    let compiledRegex = new RegExp(Object.entries(tokens).map(([type, regex]) => `(?<${type}>${regex.source})`).join(`|`), `yi`), index$2 = 0, ast = [];
    for (; index$2 < text.length; ) {
      compiledRegex.lastIndex = index$2;
      let result = text.match(compiledRegex);
      if (result !== null) {
        let [type, text$1] = Object.entries(result.groups).find(([name$2, group]) => group !== void 0);
        index$2 += text$1.length, type.startsWith(`_`) || ast.push({ type, text: text$1 });
      } else throw Error(`No matching tokenizer rule found at: [${text.substring(index$2)}]`);
    }
    return ast;
  }
  module2.exports = { tokenize: tokenize$1 };
}), require_parser_combinator = __commonJSMin$1((exports$12, module2) => {
  function s$4(sequence, post = (v$1) => v$1) {
    return function({ index: index$2 = 0, input }) {
      let position = index$2, ast = [];
      for (let parser of sequence) {
        let result = parser({ index: position, input });
        if (result.success) position = result.index, ast.push(result.ast);
        else return result;
      }
      return { success: true, ast: post(ast), index: position, input };
    };
  }
  function a$1(alternative, post = (v$1) => v$1) {
    return function({ index: index$2 = 0, input }) {
      for (let parser of alternative) {
        let result = parser({ index: index$2, input });
        if (result.success) return { success: true, ast: post(result.ast), index: result.index, input };
      }
      return { success: false, ast: null, index: index$2, input };
    };
  }
  function m$1(many, post = (v$1) => v$1) {
    return function({ index: index$2 = 0, input }) {
      let result = {}, position = index$2, ast = [];
      do
        result = many({ index: position, input }), result.success && (position = result.index, ast.push(result.ast));
      while (result.success);
      return ast.length > 0 ? { success: true, ast: post(ast), index: position, input } : { success: false, ast: null, index: position, input };
    };
  }
  function o$1(optional, post = (v$1) => v$1) {
    return function({ index: index$2 = 0, input }) {
      let result = optional({ index: index$2, input });
      return result.success ? { success: true, ast: post(result.ast), index: result.index, input } : { success: true, ast: post(null), index: index$2, input };
    };
  }
  function l$3(lookahead, post = (v$1) => v$1) {
    return function({ index: index$2 = 0, input }) {
      let result = lookahead.do({ index: index$2, input });
      if (result.success) {
        let resultNext = lookahead.next({ index: result.index, input });
        if (resultNext.success) return { success: true, ast: post(result.ast), index: result.index, input };
      }
      return { success: false, ast: null, index: index$2, input };
    };
  }
  function n$3(negative, post = (v$1) => v$1) {
    return function({ index: index$2 = 0, input }) {
      let result = negative.do({ index: index$2, input });
      if (result.success) {
        let resultNot = negative.not({ index: index$2, input });
        if (!resultNot.success) return { success: true, ast: post(result.ast), index: result.index, input };
      }
      return { success: false, ast: null, index: index$2, input };
    };
  }
  function t$6(token, post = (v$1) => v$1.text) {
    return function({ index: index$2 = 0, input }) {
      let result = input[index$2];
      return result !== void 0 && (token.type === void 0 || token.type === result.type) && (token.text === void 0 || token.text.toUpperCase() === result.text.toUpperCase()) ? { success: true, ast: post(result), index: index$2 + 1, input } : { success: false, ast: null, index: index$2, input };
    };
  }
  let e$1 = function({ index: index$2 = 0, input }) {
    return { success: true, ast: null, index: index$2, input };
  }, f$2 = function({ index: index$2 = 0, input }) {
    return { success: index$2 === input.length, ast: null, index: index$2, input };
  };
  module2.exports = { s: s$4, a: a$1, m: m$1, o: o$1, l: l$3, n: n$3, t: t$6, e: e$1, f: f$2 };
}), require_parser = __commonJSMin$1((exports$12, module2) => {
  let { tokenize } = require_tokenizer(), { s: s$3, a: a2, m, o, l: l$2, n: n$2, t: t$5, e: e2, f: f$1 } = require_parser_combinator(), TOKENS = { keyword: /(?:ABORT|ACTION|ADD|AFTER|ALL|ALTER|ALWAYS|ANALYZE|AND|AS|ASC|ATTACH|AUTOINCREMENT|BEFORE|BEGIN|BETWEEN|BY|CASCADE|CASE|CAST|CHECK|COLLATE|COLUMN|COMMIT|CONFLICT|CONSTRAINT|CREATE|CROSS|CURRENT|CURRENT_DATE|CURRENT_TIME|CURRENT_TIMESTAMP|DATABASE|DEFAULT|DEFERRED|DEFERRABLE|DELETE|DESC|DETACH|DISTINCT|DO|DROP|END|EACH|ELSE|ESCAPE|EXCEPT|EXCLUSIVE|EXCLUDE|EXISTS|EXPLAIN|FAIL|FILTER|FIRST|FOLLOWING|FOR|FOREIGN|FROM|FULL|GENERATED|GLOB|GROUP|GROUPS|HAVING|IF|IGNORE|IMMEDIATE|IN|INDEX|INDEXED|INITIALLY|INNER|INSERT|INSTEAD|INTERSECT|INTO|IS|ISNULL|JOIN|KEY|LAST|LEFT|LIKE|LIMIT|MATCH|MATERIALIZED|NATURAL|NO|NOT|NOTHING|NOTNULL|NULL|NULLS|OF|OFFSET|ON|OR|ORDER|OTHERS|OUTER|OVER|PARTITION|PLAN|PRAGMA|PRECEDING|PRIMARY|QUERY|RAISE|RANGE|RECURSIVE|REFERENCES|REGEXP|REINDEX|RELEASE|RENAME|REPLACE|RESTRICT|RETURNING|RIGHT|ROLLBACK|ROW|ROWS|SAVEPOINT|SELECT|SET|TABLE|TEMP|TEMPORARY|THEN|TIES|TO|TRANSACTION|TRIGGER|UNBOUNDED|UNION|UNIQUE|UPDATE|USING|VACUUM|VALUES|VIEW|VIRTUAL|WHEN|WHERE|WINDOW|WITH|WITHOUT)(?=\s+|-|\(|\)|;|\+|\*|\/|%|==|=|<=|<>|<<|<|>=|>>|>|!=|,|&|~|\|\||\||\.)/, id: /"[^"]*(?:""[^"]*)*"|`[^`]*(?:``[^`]*)*`|\[[^[\]]*\]|[a-z_][a-z0-9_$]*/, string: /'[^']*(?:''[^']*)*'/, blob: /x'(?:[0-9a-f][0-9a-f])+'/, numeric: /(?:\d+(?:\.\d*)?|\.\d+)(?:e(?:\+|-)?\d+)?|0x[0-9a-f]+/, variable: /\?\d*|[@$:][a-z0-9_$]+/, operator: /-|\(|\)|;|\+|\*|\/|%|==|=|<=|<>|<<|<|>=|>>|>|!=|,|&|~|\|\||\||\./, _ws: /\s+/ };
  function parseCreateTable$1(sql) {
    let result = createTable$1({ input: tokenize(sql, TOKENS) });
    if (!result.success) throw Error(`Parsing CREATE TABLE failed at [${result.input.slice(result.index).map((t$7) => t$7.text).join(` `)}] of "${sql}"`);
    return result.ast;
  }
  function parseCreateIndex$1(sql) {
    let result = createIndex$1({ input: tokenize(sql, TOKENS) });
    if (!result.success) throw Error(`Parsing CREATE INDEX failed at [${result.input.slice(result.index).map((t$7) => t$7.text).join(` `)}] of "${sql}"`);
    return result.ast;
  }
  function createTable$1(ctx) {
    return s$3([t$5({ text: `CREATE` }, (v$1) => null), temporary$1, t$5({ text: `TABLE` }, (v$1) => null), exists$1, schema$1, table$1, t$5({ text: `(` }, (v$1) => null), columnDefinitionList$1, tableConstraintList$1, t$5({ text: `)` }, (v$1) => null), rowid$1, f$1], (v$1) => Object.assign({}, ...v$1.filter((x$1) => x$1 !== null)))(ctx);
  }
  function temporary$1(ctx) {
    return a2([t$5({ text: `TEMP` }), t$5({ text: `TEMPORARY` }), e2], (v$1) => ({ temporary: v$1 !== null }))(ctx);
  }
  function rowid$1(ctx) {
    return o(s$3([t$5({ text: `WITHOUT` }), t$5({ text: `ROWID` })]), (v$1) => ({ rowid: v$1 !== null }))(ctx);
  }
  function columnDefinitionList$1(ctx) {
    return a2([s$3([columnDefinition$1, t$5({ text: `,` }), columnDefinitionList$1], (v$1) => ({ columns: [v$1[0]].concat(v$1[2].columns) })), s$3([columnDefinition$1], (v$1) => ({ columns: [v$1[0]] }))])(ctx);
  }
  function columnDefinition$1(ctx) {
    return s$3([s$3([identifier$1], (v$1) => ({ name: v$1[0] })), typeName$1, columnConstraintList$1], (v$1) => Object.assign({}, ...v$1))(ctx);
  }
  function typeName$1(ctx) {
    return o(s$3([m(t$5({ type: `id` })), a2([s$3([t$5({ text: `(` }), signedNumber, t$5({ text: `,` }), signedNumber, t$5({ text: `)` })], (v$1) => `(${v$1[1]}, ${v$1[3]})`), s$3([t$5({ text: `(` }), signedNumber, t$5({ text: `)` })], (v$1) => `(${v$1[1]})`), e2])], (v$1) => `${v$1[0].join(` `)}${v$1[1] || ``}`), (v$1) => ({ type: v$1 }))(ctx);
  }
  function columnConstraintList$1(ctx) {
    return o(m(columnConstraint), (v$1) => ({ constraints: Object.assign({ primary: null, notnull: null, null: null, unique: null, check: null, default: null, collate: null, references: null, as: null }, ...v$1 || []) }))(ctx);
  }
  function columnConstraint(ctx) {
    return a2([primaryColumnConstraint$1, notnullColumnConstraint$1, nullColumnConstraint$1, uniqueColumnConstraint$1, checkColumnConstraint$1, defaultColumnConstraint$1, collateColumnConstraint$1, referencesColumnConstraint$1, asColumnConstraint$1])(ctx);
  }
  function primaryColumnConstraint$1(ctx) {
    return s$3([constraintName$1, t$5({ text: `PRIMARY` }, (v$1) => null), t$5({ text: `KEY` }, (v$1) => null), order$1, conflictClause$1, autoincrement$1], (v$1) => ({ primary: Object.assign({}, ...v$1.filter((x$1) => x$1 !== null)) }))(ctx);
  }
  function autoincrement$1(ctx) {
    return o(t$5({ text: `AUTOINCREMENT` }), (v$1) => ({ autoincrement: v$1 !== null }))(ctx);
  }
  function notnullColumnConstraint$1(ctx) {
    return s$3([constraintName$1, t$5({ text: `NOT` }, (v$1) => null), t$5({ text: `NULL` }, (v$1) => null), conflictClause$1], (v$1) => ({ notnull: Object.assign({}, ...v$1.filter((x$1) => x$1 !== null)) }))(ctx);
  }
  function nullColumnConstraint$1(ctx) {
    return s$3([constraintName$1, t$5({ text: `NULL` }, (v$1) => null), conflictClause$1], (v$1) => ({ null: Object.assign({}, ...v$1.filter((x$1) => x$1 !== null)) }))(ctx);
  }
  function uniqueColumnConstraint$1(ctx) {
    return s$3([constraintName$1, t$5({ text: `UNIQUE` }, (v$1) => null), conflictClause$1], (v$1) => ({ unique: Object.assign({}, ...v$1.filter((x$1) => x$1 !== null)) }))(ctx);
  }
  function checkColumnConstraint$1(ctx) {
    return s$3([constraintName$1, t$5({ text: `CHECK` }, (v$1) => null), t$5({ text: `(` }, (v$1) => null), s$3([expression$1], (v$1) => ({ expression: v$1[0] })), t$5({ text: `)` }, (v$1) => null)], (v$1) => ({ check: Object.assign({}, ...v$1.filter((x$1) => x$1 !== null)) }))(ctx);
  }
  function defaultColumnConstraint$1(ctx) {
    return s$3([constraintName$1, t$5({ text: `DEFAULT` }, (v$1) => null), a2([s$3([t$5({ text: `(` }), expression$1, t$5({ text: `)` })], (v$1) => ({ value: v$1[1], expression: true })), s$3([literalValue], (v$1) => ({ value: v$1[0], expression: false })), s$3([signedNumber], (v$1) => ({ value: v$1[0], expression: false }))])], (v$1) => ({ default: Object.assign({}, ...v$1.filter((x$1) => x$1 !== null)) }))(ctx);
  }
  function collateColumnConstraint$1(ctx) {
    return s$3([constraintName$1, t$5({ text: `COLLATE` }, (v$1) => null), t$5({ type: `id` }, (v$1) => ({ collation: v$1.text }))], (v$1) => ({ collate: Object.assign({}, ...v$1.filter((x$1) => x$1 !== null)) }))(ctx);
  }
  function referencesColumnConstraint$1(ctx) {
    return s$3([constraintName$1, s$3([foreignKeyClause$1], (v$1) => v$1[0].references)], (v$1) => ({ references: Object.assign({}, ...v$1.filter((x$1) => x$1 !== null)) }))(ctx);
  }
  function asColumnConstraint$1(ctx) {
    return s$3([constraintName$1, o(s$3([t$5({ text: `GENERATED` }), t$5({ text: `ALWAYS` })]), (v$1) => ({ generated: v$1 !== null })), t$5({ text: `AS` }, (v$1) => null), t$5({ text: `(` }, (v$1) => null), s$3([expression$1], (v$1) => ({ expression: v$1[0] })), t$5({ text: `)` }, (v$1) => null), a2([t$5({ text: `STORED` }), t$5({ text: `VIRTUAL` }), e2], (v$1) => ({ mode: v$1 ? v$1.toUpperCase() : null }))], (v$1) => ({ as: Object.assign({}, ...v$1.filter((x$1) => x$1 !== null)) }))(ctx);
  }
  function tableConstraintList$1(ctx) {
    return o(m(s$3([t$5({ text: `,` }), tableConstraint$1], (v$1) => v$1[1])), (v$1) => ({ constraints: v$1 || [] }))(ctx);
  }
  function tableConstraint$1(ctx) {
    return a2([primaryTableConstraint$1, uniqueTableConstraint$1, checkTableConstraint$1, foreignTableConstraint$1])(ctx);
  }
  function primaryTableConstraint$1(ctx) {
    return s$3([constraintName$1, t$5({ text: `PRIMARY` }, (v$1) => null), t$5({ text: `KEY` }, (v$1) => null), t$5({ text: `(` }, (v$1) => null), indexedColumnList$1, t$5({ text: `)` }, (v$1) => null), conflictClause$1], (v$1) => Object.assign({ type: `PRIMARY KEY` }, ...v$1.filter((x$1) => x$1 !== null)))(ctx);
  }
  function uniqueTableConstraint$1(ctx) {
    return s$3([constraintName$1, t$5({ text: `UNIQUE` }, (v$1) => null), t$5({ text: `(` }, (v$1) => null), indexedColumnList$1, t$5({ text: `)` }, (v$1) => null), conflictClause$1], (v$1) => Object.assign({ type: `UNIQUE` }, ...v$1.filter((x$1) => x$1 !== null)))(ctx);
  }
  function conflictClause$1(ctx) {
    return o(s$3([t$5({ text: `ON` }), t$5({ text: `CONFLICT` }), a2([t$5({ text: `ROLLBACK` }), t$5({ text: `ABORT` }), t$5({ text: `FAIL` }), t$5({ text: `IGNORE` }), t$5({ text: `REPLACE` })])], (v$1) => v$1[2]), (v$1) => ({ conflict: v$1 ? v$1.toUpperCase() : null }))(ctx);
  }
  function checkTableConstraint$1(ctx) {
    return s$3([constraintName$1, t$5({ text: `CHECK` }, (v$1) => null), t$5({ text: `(` }, (v$1) => null), s$3([expression$1], (v$1) => ({ expression: v$1[0] })), t$5({ text: `)` }, (v$1) => null)], (v$1) => Object.assign({ type: `CHECK` }, ...v$1.filter((x$1) => x$1 !== null)))(ctx);
  }
  function foreignTableConstraint$1(ctx) {
    return s$3([constraintName$1, t$5({ text: `FOREIGN` }, (v$1) => null), t$5({ text: `KEY` }, (v$1) => null), t$5({ text: `(` }, (v$1) => null), columnNameList$1, t$5({ text: `)` }, (v$1) => null), foreignKeyClause$1], (v$1) => Object.assign({ type: `FOREIGN KEY` }, ...v$1.filter((x$1) => x$1 !== null)))(ctx);
  }
  function foreignKeyClause$1(ctx) {
    return s$3([t$5({ text: `REFERENCES` }, (v$1) => null), table$1, columnNameListOptional$1, o(m(a2([deleteReference$1, updateReference$1, matchReference$1])), (v$1) => Object.assign({ delete: null, update: null, match: null }, ...v$1 || [])), deferrable$1], (v$1) => ({ references: Object.assign({}, ...v$1.filter((x$1) => x$1 !== null)) }))(ctx);
  }
  function columnNameListOptional$1(ctx) {
    return o(s$3([t$5({ text: `(` }), columnNameList$1, t$5({ text: `)` })], (v$1) => v$1[1]), (v$1) => ({ columns: v$1 ? v$1.columns : [] }))(ctx);
  }
  function columnNameList$1(ctx) {
    return s$3([o(m(s$3([identifier$1, t$5({ text: `,` })], (v$1) => v$1[0])), (v$1) => v$1 === null ? [] : v$1), identifier$1], (v$1) => ({ columns: v$1[0].concat([v$1[1]]) }))(ctx);
  }
  function deleteReference$1(ctx) {
    return s$3([t$5({ text: `ON` }), t$5({ text: `DELETE` }), onAction], (v$1) => ({ delete: v$1[2] }))(ctx);
  }
  function updateReference$1(ctx) {
    return s$3([t$5({ text: `ON` }), t$5({ text: `UPDATE` }), onAction], (v$1) => ({ update: v$1[2] }))(ctx);
  }
  function matchReference$1(ctx) {
    return s$3([t$5({ text: `MATCH` }), a2([t$5({ type: `keyword` }), t$5({ type: `id` })])], (v$1) => ({ match: v$1[1] }))(ctx);
  }
  function deferrable$1(ctx) {
    return o(s$3([o(t$5({ text: `NOT` })), t$5({ text: `DEFERRABLE` }), o(s$3([t$5({ text: `INITIALLY` }), a2([t$5({ text: `DEFERRED` }), t$5({ text: `IMMEDIATE` })])], (v$1) => v$1[1].toUpperCase()))]), (v$1) => ({ deferrable: v$1 ? { not: v$1[0] !== null, initially: v$1[2] } : null }))(ctx);
  }
  function constraintName$1(ctx) {
    return o(s$3([t$5({ text: `CONSTRAINT` }), identifier$1], (v$1) => v$1[1]), (v$1) => ({ name: v$1 }))(ctx);
  }
  function createIndex$1(ctx) {
    return s$3([t$5({ text: `CREATE` }, (v$1) => null), unique$1, t$5({ text: `INDEX` }, (v$1) => null), exists$1, schema$1, index$1, t$5({ text: `ON` }, (v$1) => null), table$1, t$5({ text: `(` }, (v$1) => null), indexedColumnList$1, t$5({ text: `)` }, (v$1) => null), where$1, f$1], (v$1) => Object.assign({}, ...v$1.filter((x$1) => x$1 !== null)))(ctx);
  }
  function unique$1(ctx) {
    return o(t$5({ text: `UNIQUE` }), (v$1) => ({ unique: v$1 !== null }))(ctx);
  }
  function exists$1(ctx) {
    return o(s$3([t$5({ text: `IF` }), t$5({ text: `NOT` }), t$5({ text: `EXISTS` })]), (v$1) => ({ exists: v$1 !== null }))(ctx);
  }
  function schema$1(ctx) {
    return o(s$3([identifier$1, t$5({ text: `.` })], (v$1) => v$1[0]), (v$1) => ({ schema: v$1 }))(ctx);
  }
  function index$1(ctx) {
    return s$3([identifier$1], (v$1) => ({ index: v$1[0] }))(ctx);
  }
  function table$1(ctx) {
    return s$3([identifier$1], (v$1) => ({ table: v$1[0] }))(ctx);
  }
  function where$1(ctx) {
    return o(s$3([t$5({ text: `WHERE` }), expression$1], (v$1) => v$1[1]), (v$1) => ({ where: v$1 }))(ctx);
  }
  function indexedColumnList$1(ctx) {
    return a2([s$3([indexedColumn$1, t$5({ text: `,` }), indexedColumnList$1], (v$1) => ({ columns: [v$1[0]].concat(v$1[2].columns) })), s$3([indexedColumnExpression$1, t$5({ text: `,` }), indexedColumnList$1], (v$1) => ({ columns: [v$1[0]].concat(v$1[2].columns) })), l$2({ do: indexedColumn$1, next: t$5({ text: `)` }) }, (v$1) => ({ columns: [v$1] })), l$2({ do: indexedColumnExpression$1, next: t$5({ text: `)` }) }, (v$1) => ({ columns: [v$1] }))])(ctx);
  }
  function indexedColumn$1(ctx) {
    return s$3([s$3([identifier$1], (v$1) => ({ name: v$1[0], expression: false })), collation$1, order$1], (v$1) => Object.assign({}, ...v$1.filter((x$1) => x$1 !== null)))(ctx);
  }
  function indexedColumnExpression$1(ctx) {
    return s$3([s$3([indexedExpression$1], (v$1) => ({ name: v$1[0], expression: true })), collation$1, order$1], (v$1) => Object.assign({}, ...v$1.filter((x$1) => x$1 !== null)))(ctx);
  }
  function collation$1(ctx) {
    return o(s$3([t$5({ text: `COLLATE` }), t$5({ type: `id` })], (v$1) => v$1[1]), (v$1) => ({ collation: v$1 }))(ctx);
  }
  function order$1(ctx) {
    return a2([t$5({ text: `ASC` }), t$5({ text: `DESC` }), e2], (v$1) => ({ order: v$1 ? v$1.toUpperCase() : null }))(ctx);
  }
  function indexedExpression$1(ctx) {
    return m(a2([n$2({ do: t$5({ type: `keyword` }), not: a2([t$5({ text: `COLLATE` }), t$5({ text: `ASC` }), t$5({ text: `DESC` })]) }), t$5({ type: `id` }), t$5({ type: `string` }), t$5({ type: `blob` }), t$5({ type: `numeric` }), t$5({ type: `variable` }), n$2({ do: t$5({ type: `operator` }), not: a2([t$5({ text: `(` }), t$5({ text: `)` }), t$5({ text: `,` })]) }), s$3([t$5({ text: `(` }), o(expression$1), t$5({ text: `)` })], (v$1) => v$1[1] || [])]))(ctx);
  }
  function expression$1(ctx) {
    return m(a2([t$5({ type: `keyword` }), t$5({ type: `id` }), t$5({ type: `string` }), t$5({ type: `blob` }), t$5({ type: `numeric` }), t$5({ type: `variable` }), n$2({ do: t$5({ type: `operator` }), not: a2([t$5({ text: `(` }), t$5({ text: `)` })]) }), s$3([t$5({ text: `(` }), o(expression$1), t$5({ text: `)` })], (v$1) => v$1[1] || [])]))(ctx);
  }
  function identifier$1(ctx) {
    return a2([t$5({ type: `id` }), t$5({ type: `string` })], (v$1) => /^["`['][^]*["`\]']$/.test(v$1) ? v$1.substring(1, v$1.length - 1) : v$1)(ctx);
  }
  function onAction(ctx) {
    return a2([s$3([t$5({ text: `SET` }), t$5({ text: `NULL` })], (v$1) => `${v$1[0]} ${v$1[1]}`), s$3([t$5({ text: `SET` }), t$5({ text: `DEFAULT` })], (v$1) => `${v$1[0]} ${v$1[1]}`), t$5({ text: `CASCADE` }), t$5({ text: `RESTRICT` }), s$3([t$5({ text: `NO` }), t$5({ text: `ACTION` })], (v$1) => `${v$1[0]} ${v$1[1]}`)], (v$1) => v$1.toUpperCase())(ctx);
  }
  function literalValue(ctx) {
    return a2([t$5({ type: `numeric` }), t$5({ type: `string` }), t$5({ type: `id` }), t$5({ type: `blob` }), t$5({ text: `NULL` }), t$5({ text: `TRUE` }), t$5({ text: `FALSE` }), t$5({ text: `CURRENT_TIME` }), t$5({ text: `CURRENT_DATE` }), t$5({ text: `CURRENT_TIMESTAMP` })])(ctx);
  }
  function signedNumber(ctx) {
    return s$3([a2([t$5({ text: `+` }), t$5({ text: `-` }), e2]), t$5({ type: `numeric` })], (v$1) => `${v$1[0] || ``}${v$1[1]}`)(ctx);
  }
  module2.exports = { parseCreateTable: parseCreateTable$1, parseCreateIndex: parseCreateIndex$1 };
}), require_compiler = __commonJSMin$1((exports$12, module2) => {
  function compileCreateTable$1(ast, wrap$2 = (v$1) => v$1) {
    return createTable(ast, wrap$2);
  }
  function compileCreateIndex$1(ast, wrap$2 = (v$1) => v$1) {
    return createIndex(ast, wrap$2);
  }
  function createTable(ast, wrap$2) {
    return `CREATE${temporary(ast)} TABLE${exists(ast)} ${schema(ast, wrap$2)}${table(ast, wrap$2)} (${columnDefinitionList(ast, wrap$2)}${tableConstraintList(ast, wrap$2)})${rowid(ast)}`;
  }
  function temporary(ast, wrap$2) {
    return ast.temporary ? ` TEMP` : ``;
  }
  function rowid(ast, wrap$2) {
    return ast.rowid ? ` WITHOUT ROWID` : ``;
  }
  function columnDefinitionList(ast, wrap$2) {
    return ast.columns.map((column) => columnDefinition(column, wrap$2)).join(`, `);
  }
  function columnDefinition(ast, wrap$2) {
    return `${identifier(ast.name, wrap$2)}${typeName(ast)}${columnConstraintList(ast.constraints, wrap$2)}`;
  }
  function typeName(ast, wrap$2) {
    return ast.type === null ? `` : ` ${ast.type}`;
  }
  function columnConstraintList(ast, wrap$2) {
    return `${primaryColumnConstraint(ast, wrap$2)}${notnullColumnConstraint(ast, wrap$2)}${nullColumnConstraint(ast, wrap$2)}${uniqueColumnConstraint(ast, wrap$2)}${checkColumnConstraint(ast, wrap$2)}${defaultColumnConstraint(ast, wrap$2)}${collateColumnConstraint(ast, wrap$2)}${referencesColumnConstraint(ast, wrap$2)}${asColumnConstraint(ast, wrap$2)}`;
  }
  function primaryColumnConstraint(ast, wrap$2) {
    return ast.primary === null ? `` : ` ${constraintName(ast.primary, wrap$2)}PRIMARY KEY${order(ast.primary)}${conflictClause(ast.primary)}${autoincrement(ast.primary)}`;
  }
  function autoincrement(ast, wrap$2) {
    return ast.autoincrement ? ` AUTOINCREMENT` : ``;
  }
  function notnullColumnConstraint(ast, wrap$2) {
    return ast.notnull === null ? `` : ` ${constraintName(ast.notnull, wrap$2)}NOT NULL${conflictClause(ast.notnull)}`;
  }
  function nullColumnConstraint(ast, wrap$2) {
    return ast.null === null ? `` : ` ${constraintName(ast.null, wrap$2)}NULL${conflictClause(ast.null)}`;
  }
  function uniqueColumnConstraint(ast, wrap$2) {
    return ast.unique === null ? `` : ` ${constraintName(ast.unique, wrap$2)}UNIQUE${conflictClause(ast.unique)}`;
  }
  function checkColumnConstraint(ast, wrap$2) {
    return ast.check === null ? `` : ` ${constraintName(ast.check, wrap$2)}CHECK (${expression(ast.check.expression)})`;
  }
  function defaultColumnConstraint(ast, wrap$2) {
    return ast.default === null ? `` : ` ${constraintName(ast.default, wrap$2)}DEFAULT ${ast.default.expression ? `(${expression(ast.default.value)})` : ast.default.value}`;
  }
  function collateColumnConstraint(ast, wrap$2) {
    return ast.collate === null ? `` : ` ${constraintName(ast.collate, wrap$2)}COLLATE ${ast.collate.collation}`;
  }
  function referencesColumnConstraint(ast, wrap$2) {
    return ast.references === null ? `` : ` ${constraintName(ast.references, wrap$2)}${foreignKeyClause(ast.references, wrap$2)}`;
  }
  function asColumnConstraint(ast, wrap$2) {
    return ast.as === null ? `` : ` ${constraintName(ast.as, wrap$2)}${ast.as.generated ? `GENERATED ALWAYS ` : ``}AS (${expression(ast.as.expression)})${ast.as.mode === null ? `` : ` ${ast.as.mode}`}`;
  }
  function tableConstraintList(ast, wrap$2) {
    return ast.constraints.reduce((constraintList, constraint) => `${constraintList}, ${tableConstraint(constraint, wrap$2)}`, ``);
  }
  function tableConstraint(ast, wrap$2) {
    switch (ast.type) {
      case `PRIMARY KEY`:
        return primaryTableConstraint(ast, wrap$2);
      case `UNIQUE`:
        return uniqueTableConstraint(ast, wrap$2);
      case `CHECK`:
        return checkTableConstraint(ast, wrap$2);
      case `FOREIGN KEY`:
        return foreignTableConstraint(ast, wrap$2);
    }
  }
  function primaryTableConstraint(ast, wrap$2) {
    return `${constraintName(ast, wrap$2)}PRIMARY KEY (${indexedColumnList(ast, wrap$2)})${conflictClause(ast)}`;
  }
  function uniqueTableConstraint(ast, wrap$2) {
    return `${constraintName(ast, wrap$2)}UNIQUE (${indexedColumnList(ast, wrap$2)})${conflictClause(ast)}`;
  }
  function conflictClause(ast, wrap$2) {
    return ast.conflict === null ? `` : ` ON CONFLICT ${ast.conflict}`;
  }
  function checkTableConstraint(ast, wrap$2) {
    return `${constraintName(ast, wrap$2)}CHECK (${expression(ast.expression)})`;
  }
  function foreignTableConstraint(ast, wrap$2) {
    return `${constraintName(ast, wrap$2)}FOREIGN KEY (${columnNameList(ast, wrap$2)}) ${foreignKeyClause(ast.references, wrap$2)}`;
  }
  function foreignKeyClause(ast, wrap$2) {
    return `REFERENCES ${table(ast, wrap$2)}${columnNameListOptional(ast, wrap$2)}${deleteUpdateMatchList(ast)}${deferrable(ast.deferrable)}`;
  }
  function columnNameListOptional(ast, wrap$2) {
    return ast.columns.length > 0 ? ` (${columnNameList(ast, wrap$2)})` : ``;
  }
  function columnNameList(ast, wrap$2) {
    return ast.columns.map((column) => identifier(column, wrap$2)).join(`, `);
  }
  function deleteUpdateMatchList(ast, wrap$2) {
    return `${deleteReference(ast)}${updateReference(ast)}${matchReference(ast)}`;
  }
  function deleteReference(ast, wrap$2) {
    return ast.delete === null ? `` : ` ON DELETE ${ast.delete}`;
  }
  function updateReference(ast, wrap$2) {
    return ast.update === null ? `` : ` ON UPDATE ${ast.update}`;
  }
  function matchReference(ast, wrap$2) {
    return ast.match === null ? `` : ` MATCH ${ast.match}`;
  }
  function deferrable(ast, wrap$2) {
    return ast === null ? `` : ` ${ast.not ? `NOT ` : ``}DEFERRABLE${ast.initially === null ? `` : ` INITIALLY ${ast.initially}`}`;
  }
  function constraintName(ast, wrap$2) {
    return ast.name === null ? `` : `CONSTRAINT ${identifier(ast.name, wrap$2)} `;
  }
  function createIndex(ast, wrap$2) {
    return `CREATE${unique(ast)} INDEX${exists(ast)} ${schema(ast, wrap$2)}${index(ast, wrap$2)} on ${table(ast, wrap$2)} (${indexedColumnList(ast, wrap$2)})${where(ast)}`;
  }
  function unique(ast, wrap$2) {
    return ast.unique ? ` UNIQUE` : ``;
  }
  function exists(ast, wrap$2) {
    return ast.exists ? ` IF NOT EXISTS` : ``;
  }
  function schema(ast, wrap$2) {
    return ast.schema === null ? `` : `${identifier(ast.schema, wrap$2)}.`;
  }
  function index(ast, wrap$2) {
    return identifier(ast.index, wrap$2);
  }
  function table(ast, wrap$2) {
    return identifier(ast.table, wrap$2);
  }
  function where(ast, wrap$2) {
    return ast.where === null ? `` : ` where ${expression(ast.where)}`;
  }
  function indexedColumnList(ast, wrap$2) {
    return ast.columns.map((column) => column.expression ? indexedColumnExpression(column) : indexedColumn(column, wrap$2)).join(`, `);
  }
  function indexedColumn(ast, wrap$2) {
    return `${identifier(ast.name, wrap$2)}${collation(ast)}${order(ast)}`;
  }
  function indexedColumnExpression(ast, wrap$2) {
    return `${indexedExpression(ast.name)}${collation(ast)}${order(ast)}`;
  }
  function collation(ast, wrap$2) {
    return ast.collation === null ? `` : ` COLLATE ${ast.collation}`;
  }
  function order(ast, wrap$2) {
    return ast.order === null ? `` : ` ${ast.order}`;
  }
  function indexedExpression(ast, wrap$2) {
    return expression(ast);
  }
  function expression(ast, wrap$2) {
    return ast.reduce((expr, e$22) => Array.isArray(e$22) ? `${expr}(${expression(e$22)})` : expr ? `${expr} ${e$22}` : e$22, ``);
  }
  function identifier(ast, wrap$2) {
    return wrap$2(ast);
  }
  module2.exports = { compileCreateTable: compileCreateTable$1, compileCreateIndex: compileCreateIndex$1 };
}), require_utils$5 = __commonJSMin$1((exports$12, module2) => {
  function isEqualId$1(first$1, second) {
    return first$1.toLowerCase() === second.toLowerCase();
  }
  function includesId$1(list, id) {
    return list.some((item) => isEqualId$1(item, id));
  }
  module2.exports = { isEqualId: isEqualId$1, includesId: includesId$1 };
}), require_ddl = __commonJSMin$1((exports$12, module2) => {
  let identity$5 = require_identity(), { nanonum } = require_nanoid(), { copyData, dropOriginal, renameTable, getTableSql, isForeignCheckEnabled, setForeignCheck, executeForeignCheck } = require_sqlite_ddl_operations(), { parseCreateTable, parseCreateIndex } = require_parser(), { compileCreateTable, compileCreateIndex } = require_compiler(), { isEqualId, includesId } = require_utils$5();
  var SQLite3_DDL$1 = class {
    constructor(client, tableCompiler, pragma, connection) {
      this.client = client, this.tableCompiler = tableCompiler, this.pragma = pragma, this.tableNameRaw = this.tableCompiler.tableNameRaw, this.alteredName = `_knex_temp_alter${nanonum(3)}`, this.connection = connection, this.formatter = (value) => this.client.customWrapIdentifier(value, identity$5), this.wrap = (value) => this.client.wrapIdentifierImpl(value);
    }
    tableName() {
      return this.formatter(this.tableNameRaw);
    }
    getTableSql() {
      let tableName = this.tableName();
      return this.client.transaction(async (trx) => {
        trx.disableProcessing();
        let result = await trx.raw(getTableSql(tableName));
        return trx.enableProcessing(), { createTable: result.filter((create) => create.type === `table`)[0].sql, createIndices: result.filter((create) => create.type === `index`).map((create) => create.sql) };
      }, { connection: this.connection });
    }
    async isForeignCheckEnabled() {
      let result = await this.client.raw(isForeignCheckEnabled()).connection(this.connection);
      return result[0].foreign_keys === 1;
    }
    async setForeignCheck(enable) {
      await this.client.raw(setForeignCheck(enable)).connection(this.connection);
    }
    renameTable(trx) {
      return trx.raw(renameTable(this.alteredName, this.tableName()));
    }
    dropOriginal(trx) {
      return trx.raw(dropOriginal(this.tableName()));
    }
    copyData(trx, columns) {
      return trx.raw(copyData(this.tableName(), this.alteredName, columns));
    }
    async alterColumn(columns) {
      let { createTable: createTable$2, createIndices } = await this.getTableSql(), parsedTable = parseCreateTable(createTable$2);
      parsedTable.table = this.alteredName, parsedTable.columns = parsedTable.columns.map((column) => {
        let newColumnInfo = columns.find((c$12) => isEqualId(c$12.name, column.name));
        return newColumnInfo && (column.type = newColumnInfo.type, column.constraints.default = newColumnInfo.defaultTo === null ? null : { name: null, value: newColumnInfo.defaultTo, expression: false }, column.constraints.notnull = newColumnInfo.notNull ? { name: null, conflict: null } : null, column.constraints.null = newColumnInfo.notNull ? null : column.constraints.null), column;
      });
      let newTable = compileCreateTable(parsedTable, this.wrap);
      return this.generateAlterCommands(newTable, createIndices);
    }
    async dropColumn(columns) {
      let { createTable: createTable$2, createIndices } = await this.getTableSql(), parsedTable = parseCreateTable(createTable$2);
      if (parsedTable.table = this.alteredName, parsedTable.columns = parsedTable.columns.filter((parsedColumn) => parsedColumn.expression || !includesId(columns, parsedColumn.name)), parsedTable.columns.length === 0) throw Error(`Unable to drop last column from table`);
      parsedTable.constraints = parsedTable.constraints.filter((constraint) => constraint.type === `PRIMARY KEY` || constraint.type === `UNIQUE` ? constraint.columns.every((constraintColumn) => constraintColumn.expression || !includesId(columns, constraintColumn.name)) : constraint.type === `FOREIGN KEY` ? constraint.columns.every((constraintColumnName) => !includesId(columns, constraintColumnName)) && (constraint.references.table !== parsedTable.table || constraint.references.columns.every((referenceColumnName) => !includesId(columns, referenceColumnName))) : true);
      let newColumns = parsedTable.columns.map((column) => column.name), newTable = compileCreateTable(parsedTable, this.wrap), newIndices = [];
      for (let createIndex$2 of createIndices) {
        let parsedIndex = parseCreateIndex(createIndex$2);
        parsedIndex.columns = parsedIndex.columns.filter((parsedColumn) => parsedColumn.expression || !includesId(columns, parsedColumn.name)), parsedIndex.columns.length > 0 && newIndices.push(compileCreateIndex(parsedIndex, this.wrap));
      }
      return this.alter(newTable, newIndices, newColumns);
    }
    async dropForeign(columns, foreignKeyName) {
      let { createTable: createTable$2, createIndices } = await this.getTableSql(), parsedTable = parseCreateTable(createTable$2);
      parsedTable.table = this.alteredName, foreignKeyName || (parsedTable.columns = parsedTable.columns.map((column) => ({ ...column, references: includesId(columns, column.name) ? null : column.references }))), parsedTable.constraints = parsedTable.constraints.filter((constraint) => constraint.type === `FOREIGN KEY` ? foreignKeyName ? !constraint.name || !isEqualId(constraint.name, foreignKeyName) : constraint.columns.every((constraintColumnName) => !includesId(columns, constraintColumnName)) : true);
      let newTable = compileCreateTable(parsedTable, this.wrap);
      return this.alter(newTable, createIndices);
    }
    async dropPrimary(constraintName$2) {
      let { createTable: createTable$2, createIndices } = await this.getTableSql(), parsedTable = parseCreateTable(createTable$2);
      parsedTable.table = this.alteredName, parsedTable.columns = parsedTable.columns.map((column) => ({ ...column, primary: null })), parsedTable.constraints = parsedTable.constraints.filter((constraint) => constraint.type === `PRIMARY KEY` ? constraintName$2 ? !constraint.name || !isEqualId(constraint.name, constraintName$2) : false : true);
      let newTable = compileCreateTable(parsedTable, this.wrap);
      return this.alter(newTable, createIndices);
    }
    async primary(columns, constraintName$2) {
      let { createTable: createTable$2, createIndices } = await this.getTableSql(), parsedTable = parseCreateTable(createTable$2);
      parsedTable.table = this.alteredName, parsedTable.columns = parsedTable.columns.map((column) => ({ ...column, primary: null })), parsedTable.constraints = parsedTable.constraints.filter((constraint) => constraint.type !== `PRIMARY KEY`), parsedTable.constraints.push({ type: `PRIMARY KEY`, name: constraintName$2 || null, columns: columns.map((column) => ({ name: column, expression: false, collation: null, order: null })), conflict: null });
      let newTable = compileCreateTable(parsedTable, this.wrap);
      return this.alter(newTable, createIndices);
    }
    async foreign(foreignInfo) {
      let { createTable: createTable$2, createIndices } = await this.getTableSql(), parsedTable = parseCreateTable(createTable$2);
      parsedTable.table = this.alteredName, parsedTable.constraints.push({ type: `FOREIGN KEY`, name: foreignInfo.keyName || null, columns: foreignInfo.column, references: { table: foreignInfo.inTable, columns: foreignInfo.references, delete: foreignInfo.onDelete || null, update: foreignInfo.onUpdate || null, match: null, deferrable: null } });
      let newTable = compileCreateTable(parsedTable, this.wrap);
      return this.generateAlterCommands(newTable, createIndices);
    }
    async setNullable(column, isNullable) {
      let { createTable: createTable$2, createIndices } = await this.getTableSql(), parsedTable = parseCreateTable(createTable$2);
      parsedTable.table = this.alteredName;
      let parsedColumn = parsedTable.columns.find((c$12) => isEqualId(column, c$12.name));
      if (!parsedColumn) throw Error(`.setNullable: Column ${column} does not exist in table ${this.tableName()}.`);
      parsedColumn.constraints.notnull = isNullable ? null : { name: null, conflict: null }, parsedColumn.constraints.null = isNullable ? parsedColumn.constraints.null : null;
      let newTable = compileCreateTable(parsedTable, this.wrap);
      return this.generateAlterCommands(newTable, createIndices);
    }
    async alter(newSql, createIndices, columns) {
      let wasForeignCheckEnabled = await this.isForeignCheckEnabled();
      wasForeignCheckEnabled && await this.setForeignCheck(false);
      try {
        await this.client.transaction(async (trx) => {
          await trx.raw(newSql), await this.copyData(trx, columns), await this.dropOriginal(trx), await this.renameTable(trx);
          for (let createIndex$2 of createIndices) await trx.raw(createIndex$2);
          if (wasForeignCheckEnabled) {
            let foreignViolations = await trx.raw(executeForeignCheck());
            if (foreignViolations.length > 0) throw Error(`FOREIGN KEY constraint failed`);
          }
        }, { connection: this.connection });
      } finally {
        wasForeignCheckEnabled && await this.setForeignCheck(true);
      }
    }
    async generateAlterCommands(newSql, createIndices, columns) {
      let sql = [], pre$1 = [], post = [], check = null;
      sql.push(newSql), sql.push(copyData(this.tableName(), this.alteredName, columns)), sql.push(dropOriginal(this.tableName())), sql.push(renameTable(this.alteredName, this.tableName()));
      for (let createIndex$2 of createIndices) sql.push(createIndex$2);
      let isForeignCheckEnabled$2 = await this.isForeignCheckEnabled();
      return isForeignCheckEnabled$2 && (pre$1.push(setForeignCheck(false)), post.push(setForeignCheck(true)), check = executeForeignCheck()), { pre: pre$1, sql, check, post };
    }
  };
  module2.exports = SQLite3_DDL$1;
}), require_sqlite_querybuilder = __commonJSMin$1((exports$12, module2) => {
  let QueryBuilder$9 = require_querybuilder();
  module2.exports = class extends QueryBuilder$9 {
    withMaterialized(alias, statementOrColumnList, nothingOrStatement) {
      return this._validateWithArgs(alias, statementOrColumnList, nothingOrStatement, `with`), this.withWrapped(alias, statementOrColumnList, nothingOrStatement, true);
    }
    withNotMaterialized(alias, statementOrColumnList, nothingOrStatement) {
      return this._validateWithArgs(alias, statementOrColumnList, nothingOrStatement, `with`), this.withWrapped(alias, statementOrColumnList, nothingOrStatement, false);
    }
  };
}), require_sqlite3 = __commonJSMin$1((exports$12, module2) => {
  let defaults = require_defaults(), map$5 = require_map(), { promisify: promisify$3 } = require_util(), Client$6 = require_client(), Raw$2 = require_raw(), Transaction$13 = require_sqlite_transaction(), SqliteQueryCompiler = require_sqlite_querycompiler(), SchemaCompiler$9 = require_sqlite_compiler(), ColumnCompiler$12 = require_sqlite_columncompiler(), TableCompiler$12 = require_sqlite_tablecompiler(), ViewCompiler$10 = require_sqlite_viewcompiler(), SQLite3_DDL = require_ddl(), Formatter$4 = require_formatter(), QueryBuilder$8 = require_sqlite_querybuilder();
  var Client_SQLite3$1 = class extends Client$6 {
    constructor(config) {
      super(config), config.connection && config.connection.filename === void 0 && this.logger.warn("Could not find `connection.filename` in config. Please specify the database path and name to avoid errors. (see docs https://knexjs.org/guide/#configuration-options)"), config.useNullAsDefault === void 0 && this.logger.warn("sqlite does not support inserting default values. Set the `useNullAsDefault` flag to hide this warning. (see docs https://knexjs.org/guide/query-builder.html#insert).");
    }
    _driver() {
      return __require$1(`sqlite3`);
    }
    schemaCompiler() {
      return new SchemaCompiler$9(this, ...arguments);
    }
    transaction() {
      return new Transaction$13(this, ...arguments);
    }
    queryCompiler(builder, formatter) {
      return new SqliteQueryCompiler(this, builder, formatter);
    }
    queryBuilder() {
      return new QueryBuilder$8(this);
    }
    viewCompiler(builder, formatter) {
      return new ViewCompiler$10(this, builder, formatter);
    }
    columnCompiler() {
      return new ColumnCompiler$12(this, ...arguments);
    }
    tableCompiler() {
      return new TableCompiler$12(this, ...arguments);
    }
    ddl(compiler, pragma, connection) {
      return new SQLite3_DDL(this, compiler, pragma, connection);
    }
    wrapIdentifierImpl(value) {
      return value === `*` ? `*` : `\`${value.replace(/`/g, "``")}\``;
    }
    acquireRawConnection() {
      return new Promise((resolve, reject$2) => {
        let flags = this.driver.OPEN_READWRITE | this.driver.OPEN_CREATE;
        if (this.connectionSettings.flags) {
          if (!Array.isArray(this.connectionSettings.flags)) throw Error(`flags must be an array of strings`);
          this.connectionSettings.flags.forEach((_flag) => {
            if (!_flag.startsWith(`OPEN_`) || !this.driver[_flag]) throw Error(`flag ${_flag} not supported by node-sqlite3`);
            flags |= this.driver[_flag];
          });
        }
        let db = new this.driver.Database(this.connectionSettings.filename, flags, (err$1) => {
          if (err$1) return reject$2(err$1);
          resolve(db);
        });
      });
    }
    async destroyRawConnection(connection) {
      let close = promisify$3((cb) => connection.close(cb));
      return close();
    }
    _query(connection, obj) {
      if (!obj.sql) throw Error(`The query is empty`);
      let { method: method$1 } = obj, callMethod;
      switch (method$1) {
        case `insert`:
        case `update`:
          callMethod = obj.returning ? `all` : `run`;
          break;
        case `counter`:
        case `del`:
          callMethod = `run`;
          break;
        default:
          callMethod = `all`;
      }
      return new Promise(function(resolver, rejecter) {
        if (!connection || !connection[callMethod]) return rejecter(Error(`Error calling ${callMethod} on connection.`));
        connection[callMethod](obj.sql, obj.bindings, function(err$1, response) {
          return err$1 ? rejecter(err$1) : (obj.response = response, obj.context = this, resolver(obj));
        });
      });
    }
    _stream(connection, obj, stream$1) {
      if (!obj.sql) throw Error(`The query is empty`);
      let client = this;
      return new Promise(function(resolver, rejecter) {
        return stream$1.on(`error`, rejecter), stream$1.on(`end`, resolver), client._query(connection, obj).then((obj$1) => obj$1.response).then((rows) => rows.forEach((row) => stream$1.write(row))).catch(function(err$1) {
          stream$1.emit(`error`, err$1);
        }).then(function() {
          stream$1.end();
        });
      });
    }
    processResponse(obj, runner) {
      let ctx = obj.context, { response, returning } = obj;
      if (obj.output) return obj.output.call(runner, response);
      switch (obj.method) {
        case `select`:
          return response;
        case `first`:
          return response[0];
        case `pluck`:
          return map$5(response, obj.pluck);
        case `insert`:
          return returning && response ? response : [ctx.lastID];
        case `update`:
          return returning && response ? response : ctx.changes;
        case `del`:
        case `counter`:
          return ctx.changes;
        default:
          return response;
      }
    }
    poolDefaults() {
      return defaults({ min: 1, max: 1 }, super.poolDefaults());
    }
    formatter(builder) {
      return new Formatter$4(this, builder);
    }
    values(values$3, builder, formatter) {
      return Array.isArray(values$3) ? Array.isArray(values$3[0]) ? `( values ${values$3.map((value) => `(${this.parameterize(value, void 0, builder, formatter)})`).join(`, `)})` : `(${this.parameterize(values$3, void 0, builder, formatter)})` : values$3 instanceof Raw$2 ? `(${this.parameter(values$3, builder, formatter)})` : this.parameter(values$3, builder, formatter);
    }
  };
  Object.assign(Client_SQLite3$1.prototype, { dialect: `sqlite3`, driverName: `sqlite3` }), module2.exports = Client_SQLite3$1;
}), require_better_sqlite3 = __commonJSMin$1((exports$12, module2) => {
  let Client_SQLite3 = require_sqlite3();
  var Client_BetterSQLite3 = class extends Client_SQLite3 {
    _driver() {
      return __require$1(`better-sqlite3`);
    }
    async acquireRawConnection() {
      let options = this.connectionSettings.options || {};
      return new this.driver(this.connectionSettings.filename, { nativeBinding: options.nativeBinding, readonly: !!options.readonly });
    }
    async destroyRawConnection(connection) {
      return connection.close();
    }
    async _query(connection, obj) {
      if (!obj.sql) throw Error(`The query is empty`);
      if (!connection) throw Error(`No connection provided`);
      let statement = connection.prepare(obj.sql), bindings = this._formatBindings(obj.bindings);
      if (statement.reader) {
        let response$1 = await statement.all(bindings);
        return obj.response = response$1, obj;
      }
      let response = await statement.run(bindings);
      return obj.response = response, obj.context = { lastID: response.lastInsertRowid, changes: response.changes }, obj;
    }
    _formatBindings(bindings) {
      return bindings ? bindings.map((binding) => binding instanceof Date ? binding.valueOf() : typeof binding == `boolean` ? Number(binding) : binding) : [];
    }
  };
  Object.assign(Client_BetterSQLite3.prototype, { driverName: `better-sqlite3` }), module2.exports = Client_BetterSQLite3;
}), require_pg_transaction = __commonJSMin$1((exports$12, module2) => {
  let Transaction$12 = (init_transaction(), __toCommonJS(transaction_exports));
  var Transaction_PG = class extends Transaction$12 {
    begin(conn) {
      let trxMode = [this.isolationLevel ? `ISOLATION LEVEL ${this.isolationLevel}` : ``, this.readOnly ? `READ ONLY` : ``].join(` `).trim();
      return trxMode.length === 0 ? this.query(conn, `BEGIN;`) : this.query(conn, `BEGIN TRANSACTION ${trxMode};`);
    }
  };
  module2.exports = Transaction_PG;
}), require_pg_querycompiler = __commonJSMin$1((exports$12, module2) => {
  let identity$4 = require_identity(), reduce$1 = require_reduce(), QueryCompiler$10 = require_querycompiler(), { wrapString, columnize: columnize_$6, operator: operator_$2, wrap: wrap_$2 } = require_wrappingFormatter();
  var QueryCompiler_PG$2 = class extends QueryCompiler$10 {
    constructor(client, builder, formatter) {
      super(client, builder, formatter), this._defaultInsertValue = `default`;
    }
    truncate() {
      return `truncate ${this.tableName} restart identity`;
    }
    insert() {
      let sql = super.insert();
      if (sql === ``) return sql;
      let { returning, onConflict, ignore: ignore$2, merge: merge$4, insert } = this.single;
      if (onConflict && ignore$2 && (sql += this._ignore(onConflict)), onConflict && merge$4) {
        sql += this._merge(merge$4.updates, onConflict, insert);
        let wheres = this.where();
        wheres && (sql += ` ${wheres}`);
      }
      return returning && (sql += this._returning(returning)), { sql, returning };
    }
    update() {
      let withSQL = this.with(), updateData = this._prepUpdate(this.single.update), wheres = this.where(), { returning, updateFrom } = this.single;
      return { sql: withSQL + `update ${this.single.only ? `only ` : ``}${this.tableName} set ${updateData.join(`, `)}` + this._updateFrom(updateFrom) + (wheres ? ` ${wheres}` : ``) + this._returning(returning), returning };
    }
    using() {
      let usingTables = this.single.using;
      if (!usingTables) return;
      let sql = `using `;
      return Array.isArray(usingTables) ? sql += usingTables.map((table$2) => this.formatter.wrap(table$2)).join(`,`) : sql += this.formatter.wrap(usingTables), sql;
    }
    del() {
      let { tableName } = this, withSQL = this.with(), wheres = this.where() || ``, using = this.using() || ``, joins = this.grouped.join, tableJoins = [];
      if (Array.isArray(joins)) {
        for (let join of joins) {
          tableJoins.push(wrap_$2(this._joinTable(join), void 0, this.builder, this.client, this.bindingsHolder));
          let joinWheres = [];
          for (let clause of join.clauses) joinWheres.push(this.whereBasic({ column: clause.column, operator: `=`, value: clause.value, asColumn: true }));
          joinWheres.length > 0 && (wheres += (wheres ? ` and ` : `where `) + joinWheres.join(` and `));
        }
        tableJoins.length > 0 && (using += (using ? `,` : `using `) + tableJoins.join(`,`));
      }
      let sql = withSQL + `delete from ${this.single.only ? `only ` : ``}${tableName}` + (using ? ` ${using}` : ``) + (wheres ? ` ${wheres}` : ``), { returning } = this.single;
      return { sql: sql + this._returning(returning), returning };
    }
    aggregate(stmt) {
      return this._aggregate(stmt, { distinctParentheses: true });
    }
    _returning(value) {
      return value ? ` returning ${this.formatter.columnize(value)}` : ``;
    }
    _updateFrom(name$2) {
      return name$2 ? ` from ${this.formatter.wrap(name$2)}` : ``;
    }
    _ignore(columns) {
      return columns === true ? ` on conflict do nothing` : ` on conflict ${this._onConflictClause(columns)} do nothing`;
    }
    _merge(updates, columns, insert) {
      let sql = ` on conflict ${this._onConflictClause(columns)} do update set `;
      if (updates && Array.isArray(updates)) return sql += updates.map((column) => wrapString(column.split(`.`).pop(), this.formatter.builder, this.client, this.formatter)).map((column) => `${column} = excluded.${column}`).join(`, `), sql;
      if (updates && typeof updates == `object`) {
        let updateData = this._prepUpdate(updates);
        return typeof updateData == `string` ? sql += updateData : sql += updateData.join(`,`), sql;
      } else {
        let insertData = this._prepInsert(insert);
        if (typeof insertData == `string`) throw Error(`If using merge with a raw insert query, then updates must be provided`);
        return sql += insertData.columns.map((column) => wrapString(column.split(`.`).pop(), this.builder, this.client)).map((column) => `${column} = excluded.${column}`).join(`, `), sql;
      }
    }
    _tableNames(tables) {
      let schemaName = this.single.schema, sql = [];
      for (let i$4 = 0; i$4 < tables.length; i$4++) {
        let tableName = tables[i$4];
        tableName && (schemaName && (tableName = `${schemaName}.${tableName}`), sql.push(this.formatter.wrap(tableName)));
      }
      return sql.join(`, `);
    }
    _lockingClause(lockMode$1) {
      let tables = this.single.lockTables || [];
      return lockMode$1 + (tables.length ? ` of ` + this._tableNames(tables) : ``);
    }
    _groupOrder(item, type) {
      return super._groupOrderNulls(item, type);
    }
    forUpdate() {
      return this._lockingClause(`for update`);
    }
    forShare() {
      return this._lockingClause(`for share`);
    }
    forNoKeyUpdate() {
      return this._lockingClause(`for no key update`);
    }
    forKeyShare() {
      return this._lockingClause(`for key share`);
    }
    skipLocked() {
      return `skip locked`;
    }
    noWait() {
      return `nowait`;
    }
    columnInfo() {
      let column = this.single.columnInfo, schema$2 = this.single.schema, table$2 = this.client.customWrapIdentifier(this.single.table, identity$4);
      schema$2 &&= this.client.customWrapIdentifier(schema$2, identity$4);
      let sql = `select * from information_schema.columns where table_name = ? and table_catalog = current_database()`, bindings = [table$2];
      return this._buildColumnInfoQuery(schema$2, sql, bindings, column);
    }
    _buildColumnInfoQuery(schema$2, sql, bindings, column) {
      return schema$2 ? (sql += ` and table_schema = ?`, bindings.push(schema$2)) : sql += ` and table_schema = current_schema()`, { sql, bindings, output(resp) {
        let out = reduce$1(resp.rows, function(columns, val) {
          return columns[val.column_name] = { type: val.data_type, maxLength: val.character_maximum_length, nullable: val.is_nullable === `YES`, defaultValue: val.column_default }, columns;
        }, {});
        return column && out[column] || out;
      } };
    }
    distinctOn(value) {
      return `distinct on (` + this.formatter.columnize(value) + `) `;
    }
    jsonExtract(params) {
      return this._jsonExtract(`jsonb_path_query`, params);
    }
    jsonSet(params) {
      return this._jsonSet(`jsonb_set`, Object.assign({}, params, { path: this.client.toPathForJson(params.path) }));
    }
    jsonInsert(params) {
      return this._jsonSet(`jsonb_insert`, Object.assign({}, params, { path: this.client.toPathForJson(params.path) }));
    }
    jsonRemove(params) {
      let jsonCol = `${columnize_$6(params.column, this.builder, this.client, this.bindingsHolder)} #- ${this.client.parameter(this.client.toPathForJson(params.path), this.builder, this.bindingsHolder)}`;
      return params.alias ? this.client.alias(jsonCol, this.formatter.wrap(params.alias)) : jsonCol;
    }
    whereJsonPath(statement) {
      let castValue = ``;
      return castValue = !isNaN(statement.value) && parseInt(statement.value) ? `::int` : !isNaN(statement.value) && parseFloat(statement.value) ? `::float` : ` #>> '{}'`, `jsonb_path_query_first(${this._columnClause(statement)}, ${this.client.parameter(statement.jsonPath, this.builder, this.bindingsHolder)})${castValue} ${operator_$2(statement.operator, this.builder, this.client, this.bindingsHolder)} ${this._jsonValueClause(statement)}`;
    }
    whereJsonSupersetOf(statement) {
      return this._not(statement, `${wrap_$2(statement.column, void 0, this.builder, this.client, this.bindingsHolder)} @> ${this._jsonValueClause(statement)}`);
    }
    whereJsonSubsetOf(statement) {
      return this._not(statement, `${columnize_$6(statement.column, this.builder, this.client, this.bindingsHolder)} <@ ${this._jsonValueClause(statement)}`);
    }
    onJsonPathEquals(clause) {
      return this._onJsonPathEquals(`jsonb_path_query_first`, clause);
    }
  };
  module2.exports = QueryCompiler_PG$2;
}), require_pg_querybuilder = __commonJSMin$1((exports$12, module2) => {
  let QueryBuilder$7 = require_querybuilder();
  module2.exports = class extends QueryBuilder$7 {
    updateFrom(name$2) {
      return this._single.updateFrom = name$2, this;
    }
    using(tables) {
      return this._single.using = tables, this;
    }
    withMaterialized(alias, statementOrColumnList, nothingOrStatement) {
      return this._validateWithArgs(alias, statementOrColumnList, nothingOrStatement, `with`), this.withWrapped(alias, statementOrColumnList, nothingOrStatement, true);
    }
    withNotMaterialized(alias, statementOrColumnList, nothingOrStatement) {
      return this._validateWithArgs(alias, statementOrColumnList, nothingOrStatement, `with`), this.withWrapped(alias, statementOrColumnList, nothingOrStatement, false);
    }
  };
}), require_pg_columncompiler = __commonJSMin$1((exports$12, module2) => {
  let ColumnCompiler$11 = require_columncompiler(), { isObject: isObject$7 } = require_is(), { toNumber: toNumber$3 } = require_helpers$1(), commentEscapeRegex$1 = RegExp(`(?<!')'(?!')`, `g`);
  var ColumnCompiler_PG$2 = class extends ColumnCompiler$11 {
    constructor(client, tableCompiler, columnBuilder) {
      super(client, tableCompiler, columnBuilder), this.modifiers = [`nullable`, `defaultTo`, `comment`], this._addCheckModifiers();
    }
    bit(column) {
      return column.length === false ? `bit` : `bit(${column.length})`;
    }
    enu(allowed, options) {
      options ||= {};
      let values$3 = options.useNative && options.existingType ? void 0 : allowed.join(`', '`);
      if (options.useNative) {
        let enumName = ``, schemaName = options.schemaName || this.tableCompiler.schemaNameRaw;
        return schemaName && (enumName += `"${schemaName}".`), enumName += `"${options.enumName}"`, options.existingType || this.tableCompiler.unshiftQuery(`create type ${enumName} as enum ('${values$3}')`), enumName;
      }
      return `text check (${this.formatter.wrap(this.args[0])} in ('${values$3}'))`;
    }
    decimal(precision, scale) {
      return precision === null ? `decimal` : `decimal(${toNumber$3(precision, 8)}, ${toNumber$3(scale, 2)})`;
    }
    json(jsonb) {
      return jsonb && this.client.logger.deprecate(`json(true)`, `jsonb()`), jsonColumn(this.client, jsonb);
    }
    jsonb() {
      return jsonColumn(this.client, true);
    }
    checkRegex(regex, constraintName$2) {
      return this._check(`${this.formatter.wrap(this.getColumnName())} ~ ${this.client._escapeBinding(regex)}`, constraintName$2);
    }
    datetime(withoutTz = false, precision) {
      let useTz;
      return isObject$7(withoutTz) ? { useTz, precision } = withoutTz : useTz = !withoutTz, useTz = typeof useTz == `boolean` ? useTz : true, precision = precision == null ? `` : `(` + precision + `)`, `${useTz ? `timestamptz` : `timestamp`}${precision}`;
    }
    timestamp(withoutTz = false, precision) {
      return this.datetime(withoutTz, precision);
    }
    comment(comment) {
      let columnName = this.args[0] || this.defaults(`columnName`), escapedComment = comment ? `'${comment.replace(commentEscapeRegex$1, `''`)}'` : `NULL`;
      this.pushAdditional(function() {
        this.pushQuery(`comment on column ${this.tableCompiler.tableName()}.` + this.formatter.wrap(columnName) + ` is ${escapedComment}`);
      }, comment);
    }
    increments(options = { primaryKey: true }) {
      return `serial` + (this.tableCompiler._canBeAddPrimaryKey(options) ? ` primary key` : ``);
    }
    bigincrements(options = { primaryKey: true }) {
      return `bigserial` + (this.tableCompiler._canBeAddPrimaryKey(options) ? ` primary key` : ``);
    }
    uuid(options = { primaryKey: false }) {
      return `uuid` + (this.tableCompiler._canBeAddPrimaryKey(options) ? ` primary key` : ``);
    }
  };
  ColumnCompiler_PG$2.prototype.bigint = `bigint`, ColumnCompiler_PG$2.prototype.binary = `bytea`, ColumnCompiler_PG$2.prototype.bool = `boolean`, ColumnCompiler_PG$2.prototype.double = `double precision`, ColumnCompiler_PG$2.prototype.floating = `real`, ColumnCompiler_PG$2.prototype.smallint = `smallint`, ColumnCompiler_PG$2.prototype.tinyint = `smallint`;
  function jsonColumn(client, jsonb) {
    return !client.version || client.config.client === `cockroachdb` || client.config.jsonbSupport === true || parseFloat(client.version) >= 9.2 ? jsonb ? `jsonb` : `json` : `text`;
  }
  module2.exports = ColumnCompiler_PG$2;
}), require_pg_tablecompiler = __commonJSMin$1((exports$12, module2) => {
  let has$1 = require_has(), TableCompiler$11 = require_tablecompiler(), { isObject: isObject$6, isString: isString$7 } = require_is();
  var TableCompiler_PG$1 = class extends TableCompiler$11 {
    constructor(client, tableBuilder) {
      super(client, tableBuilder);
    }
    renameColumn(from$2, to) {
      return this.pushQuery({ sql: `alter table ${this.tableName()} rename ${this.formatter.wrap(from$2)} to ${this.formatter.wrap(to)}` });
    }
    _setNullableState(column, isNullable) {
      let constraintAction = isNullable ? `drop not null` : `set not null`, sql = `alter table ${this.tableName()} alter column ${this.formatter.wrap(column)} ${constraintAction}`;
      return this.pushQuery({ sql });
    }
    compileAdd(builder) {
      let table$2 = this.formatter.wrap(builder), columns = this.prefixArray(`add column`, this.getColumns(builder));
      return this.pushQuery({ sql: `alter table ${table$2} ${columns.join(`, `)}` });
    }
    createQuery(columns, ifNot, like) {
      let createStatement = ifNot ? `create table if not exists ` : `create table `, columnsSql = ` (${columns.sql.join(`, `)}${this.primaryKeys() || ``}${this._addChecks()})`, sql = createStatement + this.tableName() + (like && this.tableNameLike() ? ` (like ` + this.tableNameLike() + ` including all` + (columns.sql.length ? `, ` + columns.sql.join(`, `) : ``) + `)` : columnsSql);
      this.single.inherits && (sql += ` inherits (${this.formatter.wrap(this.single.inherits)})`), this.pushQuery({ sql, bindings: columns.bindings });
      let hasComment = has$1(this.single, `comment`);
      hasComment && this.comment(this.single.comment);
    }
    primaryKeys() {
      let pks = (this.grouped.alterTable || []).filter((k) => k.method === `primary`);
      if (pks.length > 0 && pks[0].args.length > 0) {
        let columns = pks[0].args[0], constraintName$2 = pks[0].args[1] || ``, deferrable$2;
        return isObject$6(constraintName$2) && ({ constraintName: constraintName$2, deferrable: deferrable$2 } = constraintName$2), deferrable$2 = deferrable$2 ? ` deferrable initially ${deferrable$2}` : ``, constraintName$2 = constraintName$2 ? this.formatter.wrap(constraintName$2) : this.formatter.wrap(`${this.tableNameRaw}_pkey`), `, constraint ${constraintName$2} primary key (${this.formatter.columnize(columns)})${deferrable$2}`;
      }
    }
    addColumns(columns, prefix, colCompilers) {
      if (prefix === this.alterColumnsPrefix) for (let col of colCompilers) this._addColumn(col);
      else super.addColumns(columns, prefix);
    }
    _addColumn(col) {
      let quotedTableName = this.tableName(), type = col.getColumnType(), colName = this.client.wrapIdentifier(col.getColumnName(), col.columnBuilder.queryContext()), isEnum = col.type === `enu`;
      this.pushQuery({ sql: `alter table ${quotedTableName} alter column ${colName} drop default`, bindings: [] });
      let alterNullable = col.columnBuilder.alterNullable;
      alterNullable && this.pushQuery({ sql: `alter table ${quotedTableName} alter column ${colName} drop not null`, bindings: [] });
      let alterType = col.columnBuilder.alterType;
      alterType && this.pushQuery({ sql: `alter table ${quotedTableName} alter column ${colName} type ${type} using (${colName}${isEnum ? `::text::` : `::`}${type})`, bindings: [] });
      let defaultTo = col.modified.defaultTo;
      if (defaultTo) {
        let modifier = col.defaultTo.apply(col, defaultTo);
        this.pushQuery({ sql: `alter table ${quotedTableName} alter column ${colName} set ${modifier}`, bindings: [] });
      }
      if (alterNullable) {
        let nullable = col.modified.nullable;
        nullable && nullable[0] === false && this.pushQuery({ sql: `alter table ${quotedTableName} alter column ${colName} set not null`, bindings: [] });
      }
    }
    comment(comment) {
      this.pushQuery(`comment on table ${this.tableName()} is '${this.single.comment}'`);
    }
    primary(columns, constraintName$2) {
      let deferrable$2;
      isObject$6(constraintName$2) && ({ constraintName: constraintName$2, deferrable: deferrable$2 } = constraintName$2), deferrable$2 = deferrable$2 ? ` deferrable initially ${deferrable$2}` : ``, constraintName$2 = constraintName$2 ? this.formatter.wrap(constraintName$2) : this.formatter.wrap(`${this.tableNameRaw}_pkey`), this.method !== `create` && this.method !== `createIfNot` && this.pushQuery(`alter table ${this.tableName()} add constraint ${constraintName$2} primary key (${this.formatter.columnize(columns)})${deferrable$2}`);
    }
    unique(columns, indexName) {
      let deferrable$2, useConstraint = true, predicate;
      if (isObject$6(indexName) && ({ indexName, deferrable: deferrable$2, useConstraint, predicate } = indexName, useConstraint === void 0 && (useConstraint = !!deferrable$2 || !predicate)), !useConstraint && deferrable$2 && deferrable$2 !== `not deferrable`) throw Error(`postgres cannot create deferrable index`);
      if (useConstraint && predicate) throw Error(`postgres cannot create constraint with predicate`);
      if (deferrable$2 = deferrable$2 ? ` deferrable initially ${deferrable$2}` : ``, indexName = indexName ? this.formatter.wrap(indexName) : this._indexCommand(`unique`, this.tableNameRaw, columns), useConstraint) this.pushQuery(`alter table ${this.tableName()} add constraint ${indexName} unique (` + this.formatter.columnize(columns) + `)` + deferrable$2);
      else {
        let predicateQuery = predicate ? ` ` + this.client.queryCompiler(predicate).where() : ``;
        this.pushQuery(`create unique index ${indexName} on ${this.tableName()} (${this.formatter.columnize(columns)})${predicateQuery}`);
      }
    }
    index(columns, indexName, options) {
      indexName = indexName ? this.formatter.wrap(indexName) : this._indexCommand(`index`, this.tableNameRaw, columns);
      let predicate, storageEngineIndexType, indexType;
      isString$7(options) ? storageEngineIndexType = options : isObject$6(options) && ({ indexType, storageEngineIndexType, predicate } = options);
      let predicateQuery = predicate ? ` ` + this.client.queryCompiler(predicate).where() : ``;
      this.pushQuery(`create${typeof indexType == `string` && indexType.toLowerCase() === `unique` ? ` unique` : ``} index ${indexName} on ${this.tableName()}${storageEngineIndexType && ` using ${storageEngineIndexType}` || ``} (` + this.formatter.columnize(columns) + `)${predicateQuery}`);
    }
    dropPrimary(constraintName$2) {
      constraintName$2 = constraintName$2 ? this.formatter.wrap(constraintName$2) : this.formatter.wrap(this.tableNameRaw + `_pkey`), this.pushQuery(`alter table ${this.tableName()} drop constraint ${constraintName$2}`);
    }
    dropIndex(columns, indexName) {
      indexName = indexName ? this.formatter.wrap(indexName) : this._indexCommand(`index`, this.tableNameRaw, columns), indexName = this.schemaNameRaw ? `${this.formatter.wrap(this.schemaNameRaw)}.${indexName}` : indexName, this.pushQuery(`drop index ${indexName}`);
    }
    dropUnique(columns, indexName) {
      indexName = indexName ? this.formatter.wrap(indexName) : this._indexCommand(`unique`, this.tableNameRaw, columns), this.pushQuery(`alter table ${this.tableName()} drop constraint ${indexName}`);
    }
    dropForeign(columns, indexName) {
      indexName = indexName ? this.formatter.wrap(indexName) : this._indexCommand(`foreign`, this.tableNameRaw, columns), this.pushQuery(`alter table ${this.tableName()} drop constraint ${indexName}`);
    }
  };
  module2.exports = TableCompiler_PG$1;
}), require_pg_viewcompiler = __commonJSMin$1((exports$12, module2) => {
  let ViewCompiler$9 = require_viewcompiler();
  var ViewCompiler_PG$2 = class extends ViewCompiler$9 {
    constructor(client, viewCompiler) {
      super(client, viewCompiler);
    }
    renameColumn(from$2, to) {
      return this.pushQuery({ sql: `alter view ${this.viewName()} rename ${this.formatter.wrap(from$2)} to ${this.formatter.wrap(to)}` });
    }
    defaultTo(column, defaultValue) {
      return this.pushQuery({ sql: `alter view ${this.viewName()} alter ${this.formatter.wrap(column)} set default ${defaultValue}` });
    }
    createOrReplace() {
      this.createQuery(this.columns, this.selectQuery, false, true);
    }
    createMaterializedView() {
      this.createQuery(this.columns, this.selectQuery, true);
    }
  };
  module2.exports = ViewCompiler_PG$2;
}), require_pg_viewbuilder = __commonJSMin$1((exports$12, module2) => {
  let ViewBuilder$5 = require_viewbuilder();
  var ViewBuilder_PG = class extends ViewBuilder$5 {
    constructor() {
      super(...arguments);
    }
    checkOption() {
      this._single.checkOption = `default_option`;
    }
    localCheckOption() {
      this._single.checkOption = `local`;
    }
    cascadedCheckOption() {
      this._single.checkOption = `cascaded`;
    }
  };
  module2.exports = ViewBuilder_PG;
}), require_pg_compiler = __commonJSMin$1((exports$12, module2) => {
  let SchemaCompiler$8 = require_compiler$1();
  var SchemaCompiler_PG$1 = class extends SchemaCompiler$8 {
    constructor(client, builder) {
      super(client, builder);
    }
    hasTable(tableName) {
      let sql = `select * from information_schema.tables where table_name = ?`, bindings = [tableName];
      this.schema ? (sql += ` and table_schema = ?`, bindings.push(this.schema)) : sql += ` and table_schema = current_schema()`, this.pushQuery({ sql, bindings, output(resp) {
        return resp.rows.length > 0;
      } });
    }
    hasColumn(tableName, columnName) {
      let sql = `select * from information_schema.columns where table_name = ? and column_name = ?`, bindings = [tableName, columnName];
      this.schema ? (sql += ` and table_schema = ?`, bindings.push(this.schema)) : sql += ` and table_schema = current_schema()`, this.pushQuery({ sql, bindings, output(resp) {
        return resp.rows.length > 0;
      } });
    }
    qualifiedTableName(tableName) {
      let name$2 = this.schema ? `${this.schema}.${tableName}` : tableName;
      return this.formatter.wrap(name$2);
    }
    renameTable(from$2, to) {
      this.pushQuery(`alter table ${this.qualifiedTableName(from$2)} rename to ${this.formatter.wrap(to)}`);
    }
    createSchema(schemaName) {
      this.pushQuery(`create schema ${this.formatter.wrap(schemaName)}`);
    }
    createSchemaIfNotExists(schemaName) {
      this.pushQuery(`create schema if not exists ${this.formatter.wrap(schemaName)}`);
    }
    dropSchema(schemaName, cascade = false) {
      this.pushQuery(`drop schema ${this.formatter.wrap(schemaName)}${cascade ? ` cascade` : ``}`);
    }
    dropSchemaIfExists(schemaName, cascade = false) {
      this.pushQuery(`drop schema if exists ${this.formatter.wrap(schemaName)}${cascade ? ` cascade` : ``}`);
    }
    dropExtension(extensionName) {
      this.pushQuery(`drop extension ${this.formatter.wrap(extensionName)}`);
    }
    dropExtensionIfExists(extensionName) {
      this.pushQuery(`drop extension if exists ${this.formatter.wrap(extensionName)}`);
    }
    createExtension(extensionName) {
      this.pushQuery(`create extension ${this.formatter.wrap(extensionName)}`);
    }
    createExtensionIfNotExists(extensionName) {
      this.pushQuery(`create extension if not exists ${this.formatter.wrap(extensionName)}`);
    }
    renameView(from$2, to) {
      this.pushQuery(this.alterViewPrefix + `${this.formatter.wrap(from$2)} rename to ${this.formatter.wrap(to)}`);
    }
    refreshMaterializedView(viewName, concurrently = false) {
      this.pushQuery({ sql: `refresh materialized view${concurrently ? ` concurrently` : ``} ${this.formatter.wrap(viewName)}` });
    }
    dropMaterializedView(viewName) {
      this._dropView(viewName, false, true);
    }
    dropMaterializedViewIfExists(viewName) {
      this._dropView(viewName, true, true);
    }
  };
  module2.exports = SchemaCompiler_PG$1;
}), require_postgres$1 = __commonJSMin$1(() => {
}), require_postgres = __commonJSMin$1((exports$12, module2) => {
  init_dist();
  let extend = require_extend(), map$4 = require_map(), { promisify: promisify$2 } = require_util(), Client$5 = require_client(), Transaction$11 = require_pg_transaction(), QueryCompiler$9 = require_pg_querycompiler(), QueryBuilder$6 = require_pg_querybuilder(), ColumnCompiler$10 = require_pg_columncompiler(), TableCompiler$10 = require_pg_tablecompiler(), ViewCompiler$8 = require_pg_viewcompiler(), ViewBuilder$4 = require_pg_viewbuilder(), SchemaCompiler$7 = require_pg_compiler(), { makeEscape: makeEscape$1 } = require_string(), { isString: isString$6 } = require_is();
  var Client_PG$2 = class extends Client$5 {
    constructor(config) {
      super(config), config.returning && (this.defaultReturning = config.returning), config.searchPath && (this.searchPath = config.searchPath);
    }
    transaction() {
      return new Transaction$11(this, ...arguments);
    }
    queryBuilder() {
      return new QueryBuilder$6(this);
    }
    queryCompiler(builder, formatter) {
      return new QueryCompiler$9(this, builder, formatter);
    }
    columnCompiler() {
      return new ColumnCompiler$10(this, ...arguments);
    }
    schemaCompiler() {
      return new SchemaCompiler$7(this, ...arguments);
    }
    tableCompiler() {
      return new TableCompiler$10(this, ...arguments);
    }
    viewCompiler() {
      return new ViewCompiler$8(this, ...arguments);
    }
    viewBuilder() {
      return new ViewBuilder$4(this, ...arguments);
    }
    _driver() {
      return __require$1(`pg`);
    }
    wrapIdentifierImpl(value) {
      if (value === `*`) return value;
      let arrayAccessor = ``, arrayAccessorMatch = value.match(/(.*?)(\[[0-9]+\])/);
      return arrayAccessorMatch && (value = arrayAccessorMatch[1], arrayAccessor = arrayAccessorMatch[2]), `"${value.replace(/"/g, `""`)}"${arrayAccessor}`;
    }
    _acquireOnlyConnection() {
      let connection = new this.driver.Client(this.connectionSettings);
      return connection.on(`error`, (err$1) => {
        connection.__knex__disposed = err$1;
      }), connection.on(`end`, (err$1) => {
        connection.__knex__disposed = err$1 || `Connection ended unexpectedly`;
      }), connection.connect().then(() => connection);
    }
    acquireRawConnection() {
      let client = this;
      return this._acquireOnlyConnection().then(function(connection) {
        return client.version ? connection : client.checkVersion(connection).then(function(version$4) {
          return client.version = version$4, connection;
        });
      }).then(async function(connection) {
        return await client.setSchemaSearchPath(connection), connection;
      });
    }
    async destroyRawConnection(connection) {
      let end = promisify$2((cb) => connection.end(cb));
      return end();
    }
    checkVersion(connection) {
      return new Promise((resolve, reject$2) => {
        connection.query(`select version();`, (err$1, resp) => {
          if (err$1) return reject$2(err$1);
          resolve(this._parseVersion(resp.rows[0].version));
        });
      });
    }
    _parseVersion(versionString) {
      return /^PostgreSQL (.*?)( |$)/.exec(versionString)[1];
    }
    positionBindings(sql) {
      let questionCount = 0;
      return sql.replace(/(\\*)(\?)/g, function(match$2, escapes) {
        return escapes.length % 2 ? `?` : (questionCount++, `$${questionCount}`);
      });
    }
    setSchemaSearchPath(connection, searchPath) {
      let path = searchPath || this.searchPath;
      if (!path) return Promise.resolve(true);
      if (!Array.isArray(path) && !isString$6(path)) throw TypeError(`knex: Expected searchPath to be Array/String, got: ${typeof path}`);
      if (isString$6(path)) {
        if (path.includes(`,`)) {
          let parts = path.split(`,`), arraySyntax = `[${parts.map((searchPath$1) => `'${searchPath$1}'`).join(`, `)}]`;
          this.logger.warn(`Detected comma in searchPath "${path}".If you are trying to specify multiple schemas, use Array syntax: ${arraySyntax}`);
        }
        path = [path];
      }
      return path = path.map((schemaName) => `"${schemaName}"`).join(`,`), new Promise(function(resolver, rejecter) {
        connection.query(`set search_path to ${path}`, function(err$1) {
          if (err$1) return rejecter(err$1);
          resolver(true);
        });
      });
    }
    _stream(connection, obj, stream$1, options) {
      if (!obj.sql) throw Error(`The query is empty`);
      let PGQueryStream = process$1.browser ? void 0 : require_postgres$1(), sql = obj.sql;
      return new Promise(function(resolver, rejecter) {
        let queryStream = connection.query(new PGQueryStream(sql, obj.bindings, options), (err$1) => {
          rejecter(err$1);
        });
        queryStream.on(`error`, function(error) {
          rejecter(error), stream$1.emit(`error`, error);
        }), stream$1.on(`end`, resolver), queryStream.pipe(stream$1);
      });
    }
    _query(connection, obj) {
      if (!obj.sql) throw Error(`The query is empty`);
      let queryConfig = { text: obj.sql, values: obj.bindings || [] };
      return obj.options && (queryConfig = extend(queryConfig, obj.options)), new Promise(function(resolver, rejecter) {
        connection.query(queryConfig, function(err$1, response) {
          if (err$1) return rejecter(err$1);
          obj.response = response, resolver(obj);
        });
      });
    }
    processResponse(obj, runner) {
      let resp = obj.response;
      if (obj.output) return obj.output.call(runner, resp);
      if (obj.method === `raw`) return resp;
      let { returning } = obj;
      if (resp.command === `SELECT`) return obj.method === `first` ? resp.rows[0] : obj.method === `pluck` ? map$4(resp.rows, obj.pluck) : resp.rows;
      if (returning) {
        let returns = [];
        for (let i$4 = 0, l$4 = resp.rows.length; i$4 < l$4; i$4++) {
          let row = resp.rows[i$4];
          returns[i$4] = row;
        }
        return returns;
      }
      return resp.command === `UPDATE` || resp.command === `DELETE` ? resp.rowCount : resp;
    }
    async cancelQuery(connectionToKill) {
      let conn = await this.acquireRawConnection();
      try {
        return await this._wrappedCancelQueryCall(conn, connectionToKill);
      } finally {
        await this.destroyRawConnection(conn).catch((err$1) => {
          this.logger.warn(`Connection Error: ${err$1}`);
        });
      }
    }
    _wrappedCancelQueryCall(conn, connectionToKill) {
      return this._query(conn, { sql: `SELECT pg_cancel_backend($1);`, bindings: [connectionToKill.processID], options: {} });
    }
    toPathForJson(jsonPath) {
      let PG_PATH_REGEX = /^{.*}$/;
      return jsonPath.match(PG_PATH_REGEX) ? jsonPath : `{` + jsonPath.replace(/^(\$\.)/, ``).replace(`.`, `,`).replace(/\[([0-9]+)]/, `,$1`) + `}`;
    }
  };
  Object.assign(Client_PG$2.prototype, { dialect: `postgresql`, driverName: `pg`, canCancelQuery: true, _escapeBinding: makeEscape$1({ escapeArray(val, esc) {
    return esc(arrayString(val, esc));
  }, escapeString(str) {
    let hasBackslash = false, escaped = `'`;
    for (let i$4 = 0; i$4 < str.length; i$4++) {
      let c$12 = str[i$4];
      c$12 === `'` ? escaped += c$12 + c$12 : c$12 === `\\` ? (escaped += c$12 + c$12, hasBackslash = true) : escaped += c$12;
    }
    return escaped += `'`, hasBackslash === true && (escaped = `E` + escaped), escaped;
  }, escapeObject(val, prepareValue, timezone, seen = []) {
    if (val && typeof val.toPostgres == `function`) {
      if (seen ||= [], seen.indexOf(val) !== -1) throw Error(`circular reference detected while preparing "${val}" for query`);
      return seen.push(val), prepareValue(val.toPostgres(prepareValue), seen);
    }
    return JSON.stringify(val);
  } }) });
  function arrayString(arr, esc) {
    let result = `{`;
    for (let i$4 = 0; i$4 < arr.length; i$4++) {
      i$4 > 0 && (result += `,`);
      let val = arr[i$4];
      val == null ? result += `NULL` : Array.isArray(val) ? result += arrayString(val, esc) : typeof val == `number` ? result += val : result += JSON.stringify(typeof val == `string` ? val : esc(val));
    }
    return result + `}`;
  }
  module2.exports = Client_PG$2;
}), require_crdb_querycompiler = __commonJSMin$1((exports$12, module2) => {
  let QueryCompiler_PG$1 = require_pg_querycompiler(), { columnize: columnize_$5, wrap: wrap_$1, operator: operator_$1 } = require_wrappingFormatter();
  var QueryCompiler_CRDB = class extends QueryCompiler_PG$1 {
    truncate() {
      return `truncate ${this.tableName}`;
    }
    upsert() {
      let sql = this._upsert();
      if (sql === ``) return sql;
      let { returning } = this.single;
      return returning && (sql += this._returning(returning)), { sql, returning };
    }
    _upsert() {
      let upsertValues = this.single.upsert || [], sql = this.with() + `upsert into ${this.tableName} `, body = this._insertBody(upsertValues);
      return body === `` ? `` : sql + body;
    }
    _groupOrder(item, type) {
      return this._basicGroupOrder(item, type);
    }
    whereJsonPath(statement) {
      let castValue = ``;
      return castValue = !isNaN(statement.value) && parseInt(statement.value) ? `::int` : !isNaN(statement.value) && parseFloat(statement.value) ? `::float` : ` #>> '{}'`, `json_extract_path(${this._columnClause(statement)}, ${this.client.toArrayPathFromJsonPath(statement.jsonPath, this.builder, this.bindingsHolder)})${castValue} ${operator_$1(statement.operator, this.builder, this.client, this.bindingsHolder)} ${this._jsonValueClause(statement)}`;
    }
    _jsonExtract(nameFunction, params) {
      let extractions;
      return extractions = Array.isArray(params.column) ? params.column : [params], extractions.map((extraction) => {
        let jsonCol = `json_extract_path(${columnize_$5(extraction.column || extraction[0], this.builder, this.client, this.bindingsHolder)}, ${this.client.toArrayPathFromJsonPath(extraction.path || extraction[1], this.builder, this.bindingsHolder)})`, alias = extraction.alias || extraction[2];
        return alias ? this.client.alias(jsonCol, this.formatter.wrap(alias)) : jsonCol;
      }).join(`, `);
    }
    _onJsonPathEquals(nameJoinFunction, clause) {
      return `json_extract_path(` + wrap_$1(clause.columnFirst, void 0, this.builder, this.client, this.bindingsHolder) + `, ` + this.client.toArrayPathFromJsonPath(clause.jsonPathFirst, this.builder, this.bindingsHolder) + `) = json_extract_path(` + wrap_$1(clause.columnSecond, void 0, this.builder, this.client, this.bindingsHolder) + `, ` + this.client.toArrayPathFromJsonPath(clause.jsonPathSecond, this.builder, this.bindingsHolder) + `)`;
    }
  };
  module2.exports = QueryCompiler_CRDB;
}), require_crdb_columncompiler = __commonJSMin$1((exports$12, module2) => {
  let ColumnCompiler_PG$1 = require_pg_columncompiler();
  var ColumnCompiler_CRDB = class extends ColumnCompiler_PG$1 {
    uuid(options = { primaryKey: false }) {
      return `uuid` + (this.tableCompiler._canBeAddPrimaryKey(options) ? ` primary key default gen_random_uuid()` : ``);
    }
  };
  module2.exports = ColumnCompiler_CRDB;
}), require_crdb_tablecompiler = __commonJSMin$1((exports$12, module2) => {
  let TableCompiler$9 = require_pg_tablecompiler();
  var TableCompiler_CRDB = class extends TableCompiler$9 {
    constructor(client, tableBuilder) {
      super(client, tableBuilder);
    }
    addColumns(columns, prefix, colCompilers) {
      if (prefix === this.alterColumnsPrefix) for (let col of colCompilers) this.client.logger.warn(`Experimental alter column in use, see issue: https://github.com/cockroachdb/cockroach/issues/49329`), this.pushQuery({ sql: `SET enable_experimental_alter_column_type_general = true`, bindings: [] }), super._addColumn(col);
      else super.addColumns(columns, prefix);
    }
    dropUnique(columns, indexName) {
      indexName = indexName ? this.formatter.wrap(indexName) : this._indexCommand(`unique`, this.tableNameRaw, columns), this.pushQuery(`drop index ${this.tableName()}@${indexName} cascade `);
    }
  };
  module2.exports = TableCompiler_CRDB;
}), require_crdb_viewcompiler = __commonJSMin$1((exports$12, module2) => {
  let ViewCompiler_PG$1 = require_pg_viewcompiler();
  var ViewCompiler_CRDB = class extends ViewCompiler_PG$1 {
    renameColumn(from$2, to) {
      throw Error(`rename column of views is not supported by this dialect.`);
    }
    defaultTo(column, defaultValue) {
      throw Error(`change default values of views is not supported by this dialect.`);
    }
  };
  module2.exports = ViewCompiler_CRDB;
}), require_crdb_querybuilder = __commonJSMin$1((exports$12, module2) => {
  let QueryBuilder$5 = require_querybuilder(), isEmpty$6 = require_isEmpty();
  module2.exports = class extends QueryBuilder$5 {
    upsert(values$3, returning, options) {
      return this._method = `upsert`, isEmpty$6(returning) || this.returning(returning, options), this._single.upsert = values$3, this;
    }
  };
}), require_cockroachdb = __commonJSMin$1((exports$12, module2) => {
  let Client_PostgreSQL = require_postgres(), Transaction$10 = require_pg_transaction(), QueryCompiler$8 = require_crdb_querycompiler(), ColumnCompiler$9 = require_crdb_columncompiler(), TableCompiler$8 = require_crdb_tablecompiler(), ViewCompiler$7 = require_crdb_viewcompiler(), QueryBuilder$4 = require_crdb_querybuilder();
  var Client_CockroachDB = class extends Client_PostgreSQL {
    transaction() {
      return new Transaction$10(this, ...arguments);
    }
    queryCompiler(builder, formatter) {
      return new QueryCompiler$8(this, builder, formatter);
    }
    columnCompiler() {
      return new ColumnCompiler$9(this, ...arguments);
    }
    tableCompiler() {
      return new TableCompiler$8(this, ...arguments);
    }
    viewCompiler() {
      return new ViewCompiler$7(this, ...arguments);
    }
    queryBuilder() {
      return new QueryBuilder$4(this);
    }
    _parseVersion(versionString) {
      return versionString.split(` `)[2];
    }
    async cancelQuery(connectionToKill) {
      try {
        return await this._wrappedCancelQueryCall(null, connectionToKill);
      } catch (err$1) {
        throw this.logger.warn(`Connection Error: ${err$1}`), err$1;
      }
    }
    _wrappedCancelQueryCall(emptyConnection, connectionToKill) {
      if (!(connectionToKill.activeQuery.processID === 0 && connectionToKill.activeQuery.secretKey === 0)) return connectionToKill.cancel(connectionToKill, connectionToKill.activeQuery);
    }
    toArrayPathFromJsonPath(jsonPath, builder, bindingsHolder) {
      return jsonPath.replace(/^(\$\.)/, ``).replace(/\[([0-9]+)]/, `.$1`).split(`.`).map((function(v$1) {
        return this.parameter(v$1, builder, bindingsHolder);
      }).bind(this)).join(`, `);
    }
  };
  Object.assign(Client_CockroachDB.prototype, { driverName: `cockroachdb` }), module2.exports = Client_CockroachDB;
}), require_isNil = __commonJSMin$1((exports$12, module2) => {
  function isNil$1(value) {
    return value == null;
  }
  module2.exports = isNil$1;
}), require_mssql_formatter = __commonJSMin$1((exports$12, module2) => {
  let Formatter$3 = require_formatter();
  var MSSQL_Formatter$1 = class extends Formatter$3 {
    columnizeWithPrefix(prefix, target) {
      let columns = typeof target == `string` ? [target] : target, str = ``, i$4 = -1;
      for (; ++i$4 < columns.length; ) i$4 > 0 && (str += `, `), str += prefix + this.wrap(columns[i$4]);
      return str;
    }
    escapingStringDelimiters(string) {
      return (string || ``).replace(/'/g, `''`);
    }
  };
  module2.exports = MSSQL_Formatter$1;
}), require_transaction$4 = __commonJSMin$1((exports$12, module2) => {
  let Transaction$9 = (init_transaction(), __toCommonJS(transaction_exports)), debug$8 = require_src()(`knex:tx`);
  var Transaction_MSSQL = class extends Transaction$9 {
    begin(conn) {
      return debug$8(`transaction::begin id=%s`, this.txid), new Promise((resolve, reject$2) => {
        conn.beginTransaction((err$1) => {
          if (err$1) return debug$8(`transaction::begin error id=%s message=%s`, this.txid, err$1.message), reject$2(err$1);
          resolve();
        }, this.outerTx ? this.txid : void 0, nameToIsolationLevelEnum(this.isolationLevel));
      }).then(this._resolver, this._rejecter);
    }
    savepoint(conn) {
      return debug$8(`transaction::savepoint id=%s`, this.txid), new Promise((resolve, reject$2) => {
        conn.saveTransaction((err$1) => {
          if (err$1) return debug$8(`transaction::savepoint id=%s message=%s`, this.txid, err$1.message), reject$2(err$1);
          this.trxClient.emit(`query`, { __knexUid: this.trxClient.__knexUid, __knexTxId: this.trxClient.__knexTxId, autogenerated: true, sql: this.outerTx ? `SAVE TRANSACTION [${this.txid}]` : `SAVE TRANSACTION` }), resolve();
        }, this.outerTx ? this.txid : void 0);
      });
    }
    commit(conn, value) {
      return debug$8(`transaction::commit id=%s`, this.txid), new Promise((resolve, reject$2) => {
        conn.commitTransaction((err$1) => {
          if (err$1) return debug$8(`transaction::commit error id=%s message=%s`, this.txid, err$1.message), reject$2(err$1);
          this._completed = true, resolve(value);
        }, this.outerTx ? this.txid : void 0);
      }).then(() => this._resolver(value), this._rejecter);
    }
    release(conn, value) {
      return this._resolver(value);
    }
    rollback(conn, error) {
      return this._completed = true, debug$8(`transaction::rollback id=%s`, this.txid), new Promise((_resolve, reject$2) => {
        if (!conn.inTransaction) return reject$2(error || Error(`Transaction rejected with non-error: undefined`));
        if (conn.state.name !== `LoggedIn`) return reject$2(Error(`Can't rollback transaction. There is a request in progress`));
        conn.rollbackTransaction((err$1) => {
          err$1 && debug$8(`transaction::rollback error id=%s message=%s`, this.txid, err$1.message), reject$2(err$1 || error || Error(`Transaction rejected with non-error: undefined`));
        }, this.outerTx ? this.txid : void 0);
      }).catch((err$1) => {
        if (!error && this.doNotRejectOnRollback) {
          this._resolver();
          return;
        }
        if (error) try {
          err$1.originalError = error;
        } catch {
        }
        this._rejecter(err$1);
      });
    }
    rollbackTo(conn, error) {
      return this.rollback(conn, error).then(() => void this.trxClient.emit(`query`, { __knexUid: this.trxClient.__knexUid, __knexTxId: this.trxClient.__knexTxId, autogenerated: true, sql: `ROLLBACK TRANSACTION` }));
    }
  };
  module2.exports = Transaction_MSSQL;
  function nameToIsolationLevelEnum(level) {
    if (!level) return;
    level = level.toUpperCase().replace(` `, `_`);
    let knownEnum = isolationEnum[level];
    if (!knownEnum) throw Error(`Unknown Isolation level, was expecting one of: ${JSON.stringify(humanReadableKeys)}`);
    return knownEnum;
  }
  let isolationEnum = { READ_UNCOMMITTED: 1, READ_COMMITTED: 2, REPEATABLE_READ: 3, SERIALIZABLE: 4, SNAPSHOT: 5 }, humanReadableKeys = Object.keys(isolationEnum).map((key) => key.toLowerCase().replace(`_`, ` `));
}), require_mssql_querycompiler = __commonJSMin$1((exports$12, module2) => {
  let QueryCompiler$7 = require_querycompiler(), compact$1 = require_compact(), identity$3 = require_identity(), isEmpty$5 = require_isEmpty(), Raw$1 = require_raw(), { columnize: columnize_$4 } = require_wrappingFormatter(), components$1 = [`comments`, `columns`, `join`, `lock`, `where`, `union`, `group`, `having`, `order`, `limit`, `offset`];
  var QueryCompiler_MSSQL = class extends QueryCompiler$7 {
    constructor(client, builder, formatter) {
      super(client, builder, formatter);
      let { onConflict } = this.single;
      if (onConflict) throw Error(`.onConflict() is not supported for mssql.`);
      this._emptyInsertValue = `default values`;
    }
    with() {
      let undoList = [];
      if (this.grouped.with) for (let stmt of this.grouped.with) stmt.recursive && (undoList.push(stmt), stmt.recursive = false);
      let result = super.with();
      for (let stmt of undoList) stmt.recursive = true;
      return result;
    }
    select() {
      let sql = this.with(), statements = components$1.map((component) => this[component](this));
      return sql + compact$1(statements).join(` `);
    }
    insert() {
      return this.single.options && this.single.options.includeTriggerModifications ? this.insertWithTriggers() : this.standardInsert();
    }
    insertWithTriggers() {
      let insertValues = this.single.insert || [], { returning } = this.single, sql = this.with() + `${this._buildTempTable(returning)}insert into ${this.tableName} `, returningSql = returning ? this._returning(`insert`, returning, true) + ` ` : ``;
      if (Array.isArray(insertValues)) {
        if (insertValues.length === 0) return ``;
      } else if (typeof insertValues == `object` && isEmpty$5(insertValues)) return { sql: sql + returningSql + this._emptyInsertValue + this._buildReturningSelect(returning), returning };
      return sql += this._buildInsertData(insertValues, returningSql), returning && (sql += this._buildReturningSelect(returning)), { sql, returning };
    }
    _buildInsertData(insertValues, returningSql) {
      let sql = ``, insertData = this._prepInsert(insertValues);
      if (typeof insertData == `string`) sql += insertData;
      else if (insertData.columns.length) sql += `(${this.formatter.columnize(insertData.columns)}`, sql += `) ${returningSql}values (` + this._buildInsertValues(insertData) + `)`;
      else if (insertValues.length === 1 && insertValues[0]) sql += returningSql + this._emptyInsertValue;
      else return ``;
      return sql;
    }
    standardInsert() {
      let insertValues = this.single.insert || [], sql = this.with() + `insert into ${this.tableName} `, { returning } = this.single, returningSql = returning ? this._returning(`insert`, returning) + ` ` : ``;
      if (Array.isArray(insertValues)) {
        if (insertValues.length === 0) return ``;
      } else if (typeof insertValues == `object` && isEmpty$5(insertValues)) return { sql: sql + returningSql + this._emptyInsertValue, returning };
      return sql += this._buildInsertData(insertValues, returningSql), { sql, returning };
    }
    update() {
      return this.single.options && this.single.options.includeTriggerModifications ? this.updateWithTriggers() : this.standardUpdate();
    }
    updateWithTriggers() {
      let top = this.top(), withSQL = this.with(), updates = this._prepUpdate(this.single.update), join = this.join(), where$2 = this.where(), order$2 = this.order(), { returning } = this.single, declaredTemp = this._buildTempTable(returning);
      return { sql: withSQL + declaredTemp + `update ${top ? top + ` ` : ``}${this.tableName} set ` + updates.join(`, `) + (returning ? ` ${this._returning(`update`, returning, true)}` : ``) + (join ? ` from ${this.tableName} ${join}` : ``) + (where$2 ? ` ${where$2}` : ``) + (order$2 ? ` ${order$2}` : ``) + (returning ? this._buildReturningSelect(returning) : this._returning(`rowcount`, `@@rowcount`)), returning: returning || `@@rowcount` };
    }
    _formatGroupsItemValue(value, nulls) {
      let column = super._formatGroupsItemValue(value);
      if (nulls && !(value instanceof Raw$1)) {
        let collNulls = `IIF(${column} is null,`;
        if (nulls === `first`) return `${collNulls}0,1)`;
        if (nulls === `last`) return `${collNulls}1,0)`;
      }
      return column;
    }
    standardUpdate() {
      let top = this.top(), withSQL = this.with(), updates = this._prepUpdate(this.single.update), join = this.join(), where$2 = this.where(), order$2 = this.order(), { returning } = this.single;
      return { sql: withSQL + `update ${top ? top + ` ` : ``}${this.tableName} set ` + updates.join(`, `) + (returning ? ` ${this._returning(`update`, returning)}` : ``) + (join ? ` from ${this.tableName} ${join}` : ``) + (where$2 ? ` ${where$2}` : ``) + (order$2 ? ` ${order$2}` : ``) + (returning ? `` : this._returning(`rowcount`, `@@rowcount`)), returning: returning || `@@rowcount` };
    }
    del() {
      return this.single.options && this.single.options.includeTriggerModifications ? this.deleteWithTriggers() : this.standardDelete();
    }
    deleteWithTriggers() {
      let withSQL = this.with(), { tableName } = this, wheres = this.where(), joins = this.join(), { returning } = this.single, returningStr = returning ? ` ${this._returning(`del`, returning, true)}` : ``, deleteSelector = joins ? `${tableName}${returningStr} ` : ``;
      return { sql: withSQL + `${this._buildTempTable(returning)}delete ${deleteSelector}from ${tableName}` + (joins ? `` : returningStr) + (joins ? ` ${joins}` : ``) + (wheres ? ` ${wheres}` : ``) + (returning ? this._buildReturningSelect(returning) : this._returning(`rowcount`, `@@rowcount`)), returning: returning || `@@rowcount` };
    }
    standardDelete() {
      let withSQL = this.with(), { tableName } = this, wheres = this.where(), joins = this.join(), { returning } = this.single, returningStr = returning ? ` ${this._returning(`del`, returning)}` : ``, deleteSelector = joins ? `${tableName}${returningStr} ` : ``;
      return { sql: withSQL + `delete ${deleteSelector}from ${tableName}` + (joins ? `` : returningStr) + (joins ? ` ${joins}` : ``) + (wheres ? ` ${wheres}` : ``) + (returning ? `` : this._returning(`rowcount`, `@@rowcount`)), returning: returning || `@@rowcount` };
    }
    columns() {
      let distinctClause = ``;
      if (this.onlyUnions()) return ``;
      let top = this.top(), hints = this._hintComments(), columns = this.grouped.columns || [], i$4 = -1, sql = [];
      if (columns) for (; ++i$4 < columns.length; ) {
        let stmt = columns[i$4];
        if (stmt.distinct && (distinctClause = `distinct `), stmt.distinctOn) {
          distinctClause = this.distinctOn(stmt.value);
          continue;
        }
        stmt.type === `aggregate` ? sql.push(...this.aggregate(stmt)) : stmt.type === `aggregateRaw` ? sql.push(this.aggregateRaw(stmt)) : stmt.type === `analytic` ? sql.push(this.analytic(stmt)) : stmt.type === `json` ? sql.push(this.json(stmt)) : stmt.value && stmt.value.length > 0 && sql.push(this.formatter.columnize(stmt.value));
      }
      sql.length === 0 && (sql = [`*`]);
      let select = this.onlyJson() ? `` : `select `;
      return `${select}${hints}${distinctClause}` + (top ? top + ` ` : ``) + sql.join(`, `) + (this.tableName ? ` from ${this.tableName}` : ``);
    }
    _returning(method$1, value, withTrigger) {
      switch (method$1) {
        case `update`:
        case `insert`:
          return value ? `output ${this.formatter.columnizeWithPrefix(`inserted.`, value)}${withTrigger ? ` into #out` : ``}` : ``;
        case `del`:
          return value ? `output ${this.formatter.columnizeWithPrefix(`deleted.`, value)}${withTrigger ? ` into #out` : ``}` : ``;
        case `rowcount`:
          return value ? `;select @@rowcount` : ``;
      }
    }
    _buildTempTable(values$3) {
      if (values$3 && values$3.length > 0) {
        let selections = ``;
        selections = Array.isArray(values$3) ? values$3.map((value) => `[t].${this.formatter.columnize(value)}`).join(`,`) : `[t].${this.formatter.columnize(values$3)}`;
        let sql = `select top(0) ${selections} into #out `;
        return sql += `from ${this.tableName} as t `, sql += `left join ${this.tableName} on 0=1;`, sql;
      }
      return ``;
    }
    _buildReturningSelect(values$3) {
      if (values$3 && values$3.length > 0) {
        let selections = ``;
        selections = Array.isArray(values$3) ? values$3.map((value) => `${this.formatter.columnize(value)}`).join(`,`) : this.formatter.columnize(values$3);
        let sql = `; select ${selections} from #out; `;
        return sql += `drop table #out;`, sql;
      }
      return ``;
    }
    truncate() {
      return `truncate table ${this.tableName}`;
    }
    forUpdate() {
      return `with (UPDLOCK)`;
    }
    forShare() {
      return `with (HOLDLOCK)`;
    }
    columnInfo() {
      let column = this.single.columnInfo, schema$2 = this.single.schema, table$2 = this.client.customWrapIdentifier(this.single.table, identity$3);
      schema$2 &&= this.client.customWrapIdentifier(schema$2, identity$3);
      let sql = `select [COLUMN_NAME], [COLUMN_DEFAULT], [DATA_TYPE], [CHARACTER_MAXIMUM_LENGTH], [IS_NULLABLE] from INFORMATION_SCHEMA.COLUMNS where table_name = ? and table_catalog = ?`, bindings = [table$2, this.client.database()];
      return schema$2 ? (sql += ` and table_schema = ?`, bindings.push(schema$2)) : sql += ` and table_schema = 'dbo'`, { sql, bindings, output(resp) {
        let out = resp.reduce((columns, val) => (columns[val[0].value] = { defaultValue: val[1].value, type: val[2].value, maxLength: val[3].value, nullable: val[4].value === `YES` }, columns), {});
        return column && out[column] || out;
      } };
    }
    top() {
      let noLimit = !this.single.limit && this.single.limit !== 0, noOffset = !this.single.offset;
      return noLimit || !noOffset ? `` : `top (${this._getValueOrParameterFromAttribute(`limit`)})`;
    }
    limit() {
      return ``;
    }
    offset() {
      let noLimit = !this.single.limit && this.single.limit !== 0, noOffset = !this.single.offset;
      if (noOffset) return ``;
      let offset$2 = `offset ${noOffset ? `0` : this._getValueOrParameterFromAttribute(`offset`)} rows`;
      return noLimit || (offset$2 += ` fetch next ${this._getValueOrParameterFromAttribute(`limit`)} rows only`), offset$2;
    }
    whereLike(statement) {
      return `${this._columnClause(statement)} collate SQL_Latin1_General_CP1_CS_AS ${this._not(statement, `like `)}${this._valueClause(statement)}`;
    }
    whereILike(statement) {
      return `${this._columnClause(statement)} collate SQL_Latin1_General_CP1_CI_AS ${this._not(statement, `like `)}${this._valueClause(statement)}`;
    }
    jsonExtract(params) {
      return this._jsonExtract(params.singleValue ? `JSON_VALUE` : `JSON_QUERY`, params);
    }
    jsonSet(params) {
      return this._jsonSet(`JSON_MODIFY`, params);
    }
    jsonInsert(params) {
      return this._jsonSet(`JSON_MODIFY`, params);
    }
    jsonRemove(params) {
      let jsonCol = `JSON_MODIFY(${columnize_$4(params.column, this.builder, this.client, this.bindingsHolder)},${this.client.parameter(params.path, this.builder, this.bindingsHolder)}, NULL)`;
      return params.alias ? this.client.alias(jsonCol, this.formatter.wrap(params.alias)) : jsonCol;
    }
    whereJsonPath(statement) {
      return this._whereJsonPath(`JSON_VALUE`, statement);
    }
    whereJsonSupersetOf(statement) {
      throw Error(`Json superset where clause not actually supported by MSSQL`);
    }
    whereJsonSubsetOf(statement) {
      throw Error(`Json subset where clause not actually supported by MSSQL`);
    }
    _getExtracts(statement, operator$1) {
      let column = columnize_$4(statement.column, this.builder, this.client, this.bindingsHolder);
      return (Array.isArray(statement.values) ? statement.values : [statement.values]).map(function(value) {
        return `JSON_VALUE(` + column + `,` + this.client.parameter(value, this.builder, this.bindingsHolder) + `)`;
      }, this).join(operator$1);
    }
    onJsonPathEquals(clause) {
      return this._onJsonPathEquals(`JSON_VALUE`, clause);
    }
  };
  module2.exports = QueryCompiler_MSSQL;
}), require_mssql_compiler = __commonJSMin$1((exports$12, module2) => {
  let SchemaCompiler$6 = require_compiler$1();
  var SchemaCompiler_MSSQL = class extends SchemaCompiler$6 {
    constructor(client, builder) {
      super(client, builder);
    }
    dropTableIfExists(tableName) {
      let name$2 = this.formatter.wrap(prefixedTableName(this.schema, tableName));
      this.pushQuery(`if object_id('${name$2}', 'U') is not null DROP TABLE ${name$2}`);
    }
    dropViewIfExists(viewName) {
      let name$2 = this.formatter.wrap(prefixedTableName(this.schema, viewName));
      this.pushQuery(`if object_id('${name$2}', 'V') is not null DROP VIEW ${name$2}`);
    }
    renameTable(tableName, to) {
      this.pushQuery(`exec sp_rename ${this.client.parameter(prefixedTableName(this.schema, tableName), this.builder, this.bindingsHolder)}, ${this.client.parameter(to, this.builder, this.bindingsHolder)}`);
    }
    renameView(viewTable, to) {
      this.pushQuery(`exec sp_rename ${this.client.parameter(prefixedTableName(this.schema, viewTable), this.builder, this.bindingsHolder)}, ${this.client.parameter(to, this.builder, this.bindingsHolder)}`);
    }
    hasTable(tableName) {
      let formattedTable = this.client.parameter(prefixedTableName(this.schema, tableName), this.builder, this.bindingsHolder), bindings = [tableName], sql = `SELECT TABLE_NAME FROM INFORMATION_SCHEMA.TABLES WHERE TABLE_NAME = ${formattedTable}`;
      this.schema && (sql += ` AND TABLE_SCHEMA = ?`, bindings.push(this.schema)), this.pushQuery({ sql, bindings, output: (resp) => resp.length > 0 });
    }
    hasColumn(tableName, column) {
      let formattedColumn = this.client.parameter(column, this.builder, this.bindingsHolder), formattedTable = this.client.parameter(this.formatter.wrap(prefixedTableName(this.schema, tableName)), this.builder, this.bindingsHolder), sql = `select object_id from sys.columns where name = ${formattedColumn} and object_id = object_id(${formattedTable})`;
      this.pushQuery({ sql, output: (resp) => resp.length > 0 });
    }
  };
  SchemaCompiler_MSSQL.prototype.dropTablePrefix = `DROP TABLE `;
  function prefixedTableName(prefix, table$2) {
    return prefix ? `${prefix}.${table$2}` : table$2;
  }
  module2.exports = SchemaCompiler_MSSQL;
}), require_mssql_tablecompiler = __commonJSMin$1((exports$12, module2) => {
  let TableCompiler$7 = require_tablecompiler(), helpers$1 = require_helpers$1(), { isObject: isObject$5 } = require_is();
  var TableCompiler_MSSQL = class extends TableCompiler$7 {
    constructor(client, tableBuilder) {
      super(client, tableBuilder);
    }
    createQuery(columns, ifNot, like) {
      let createStatement = ifNot ? `if object_id('${this.tableName()}', 'U') is null ` : ``;
      like ? createStatement += `SELECT * INTO ${this.tableName()} FROM ${this.tableNameLike()} WHERE 0=1` : createStatement += `CREATE TABLE ` + this.tableName() + (this._formatting ? ` (
    ` : ` (`) + columns.sql.join(this._formatting ? `,
    ` : `, `) + this._addChecks() + `)`, this.pushQuery(createStatement), this.single.comment && this.comment(this.single.comment), like && this.addColumns(columns, this.addColumnsPrefix);
    }
    comment(comment) {
      if (!comment) return;
      comment.length > 7500 / 2 && this.client.logger.warn(`Your comment might be longer than the max comment length for MSSQL of 7,500 bytes.`);
      let value = this.formatter.escapingStringDelimiters(comment), level0name = this.formatter.escapingStringDelimiters(this.schemaNameRaw || `dbo`), level1name = this.formatter.escapingStringDelimiters(this.tableNameRaw), args$1 = `N'MS_Description', N'${value}', N'Schema', N'${level0name}', N'Table', N'${level1name}'`, isAlreadyDefined = `EXISTS(SELECT * FROM sys.fn_listextendedproperty(N'MS_Description', N'Schema', N'${level0name}', N'Table', N'${level1name}', NULL, NULL))`;
      this.pushQuery(`IF ${isAlreadyDefined}
  EXEC sys.sp_updateextendedproperty ${args$1}
ELSE
  EXEC sys.sp_addextendedproperty ${args$1}`);
    }
    addColumns(columns, prefix) {
      prefix ||= this.addColumnsPrefix, columns.sql.length > 0 && this.pushQuery({ sql: (this.lowerCase ? `alter table ` : `ALTER TABLE `) + this.tableName() + ` ` + prefix + columns.sql.join(`, `), bindings: columns.bindings });
    }
    alterColumns(columns, colBuilder) {
      for (let i$4 = 0, l$4 = colBuilder.length; i$4 < l$4; i$4++) {
        let builder = colBuilder[i$4];
        if (builder.modified.defaultTo) {
          let schema$2 = this.schemaNameRaw || `dbo`, baseQuery = `
              DECLARE @constraint varchar(100) = (SELECT default_constraints.name
                                                  FROM sys.all_columns
                                                  INNER JOIN sys.tables
                                                    ON all_columns.object_id = tables.object_id
                                                  INNER JOIN sys.schemas
                                                    ON tables.schema_id = schemas.schema_id
                                                  INNER JOIN sys.default_constraints
                                                    ON all_columns.default_object_id = default_constraints.object_id
                                                  WHERE schemas.name = '${schema$2}'
                                                  AND tables.name = '${this.tableNameRaw}'
                                                  AND all_columns.name = '${builder.getColumnName()}')

              IF @constraint IS NOT NULL EXEC('ALTER TABLE ${this.tableNameRaw} DROP CONSTRAINT ' + @constraint)`;
          this.pushQuery(baseQuery);
        }
      }
      columns.sql.forEach((sql) => {
        this.pushQuery({ sql: (this.lowerCase ? `alter table ` : `ALTER TABLE `) + this.tableName() + ` ` + (this.lowerCase ? this.alterColumnPrefix.toLowerCase() : this.alterColumnPrefix) + sql, bindings: columns.bindings });
      });
    }
    dropColumn() {
      let _this2 = this, columns = helpers$1.normalizeArr.apply(null, arguments), columnsArray = Array.isArray(columns) ? columns : [columns], drops = columnsArray.map((column) => _this2.formatter.wrap(column)), schema$2 = this.schemaNameRaw || `dbo`;
      for (let column of columns) {
        let baseQuery = `
              DECLARE @constraint varchar(100) = (SELECT default_constraints.name
                                                  FROM sys.all_columns
                                                  INNER JOIN sys.tables
                                                    ON all_columns.object_id = tables.object_id
                                                  INNER JOIN sys.schemas
                                                    ON tables.schema_id = schemas.schema_id
                                                  INNER JOIN sys.default_constraints
                                                    ON all_columns.default_object_id = default_constraints.object_id
                                                  WHERE schemas.name = '${schema$2}'
                                                  AND tables.name = '${this.tableNameRaw}'
                                                  AND all_columns.name = '${column}')

              IF @constraint IS NOT NULL EXEC('ALTER TABLE ${this.tableNameRaw} DROP CONSTRAINT ' + @constraint)`;
        this.pushQuery(baseQuery);
      }
      this.pushQuery((this.lowerCase ? `alter table ` : `ALTER TABLE `) + this.tableName() + ` ` + this.dropColumnPrefix + drops.join(`, `));
    }
    changeType() {
    }
    renameColumn(from$2, to) {
      this.pushQuery(`exec sp_rename ${this.client.parameter(this.tableName() + `.` + from$2, this.tableBuilder, this.bindingsHolder)}, ${this.client.parameter(to, this.tableBuilder, this.bindingsHolder)}, 'COLUMN'`);
    }
    dropFKRefs(runner, refs) {
      let formatter = this.client.formatter(this.tableBuilder);
      return Promise.all(refs.map(function(ref) {
        let constraintName$2 = formatter.wrap(ref.CONSTRAINT_NAME), tableName = formatter.wrap(ref.TABLE_NAME);
        return runner.query({ sql: `ALTER TABLE ${tableName} DROP CONSTRAINT ${constraintName$2}` });
      }));
    }
    createFKRefs(runner, refs) {
      let formatter = this.client.formatter(this.tableBuilder);
      return Promise.all(refs.map(function(ref) {
        let tableName = formatter.wrap(ref.TABLE_NAME), keyName = formatter.wrap(ref.CONSTRAINT_NAME), column = formatter.columnize(ref.COLUMN_NAME), references = formatter.columnize(ref.REFERENCED_COLUMN_NAME), inTable = formatter.wrap(ref.REFERENCED_TABLE_NAME), onUpdate = ` ON UPDATE ${ref.UPDATE_RULE}`, onDelete = ` ON DELETE ${ref.DELETE_RULE}`;
        return runner.query({ sql: `ALTER TABLE ${tableName} ADD CONSTRAINT ${keyName} FOREIGN KEY (` + column + `) REFERENCES ` + inTable + ` (` + references + `)` + onUpdate + onDelete });
      }));
    }
    index(columns, indexName, options) {
      indexName = indexName ? this.formatter.wrap(indexName) : this._indexCommand(`index`, this.tableNameRaw, columns);
      let predicate;
      isObject$5(options) && ({ predicate } = options);
      let predicateQuery = predicate ? ` ` + this.client.queryCompiler(predicate).where() : ``;
      this.pushQuery(`CREATE INDEX ${indexName} ON ${this.tableName()} (${this.formatter.columnize(columns)})${predicateQuery}`);
    }
    primary(columns, constraintName$2) {
      let deferrable$2;
      isObject$5(constraintName$2) && ({ constraintName: constraintName$2, deferrable: deferrable$2 } = constraintName$2), deferrable$2 && deferrable$2 !== `not deferrable` && this.client.logger.warn(`mssql: primary key constraint [${constraintName$2}] will not be deferrable ${deferrable$2} because mssql does not support deferred constraints.`), constraintName$2 = constraintName$2 ? this.formatter.wrap(constraintName$2) : this.formatter.wrap(`${this.tableNameRaw}_pkey`), this.forCreate ? this.pushQuery(`CONSTRAINT ${constraintName$2} PRIMARY KEY (${this.formatter.columnize(columns)})`) : this.pushQuery(`ALTER TABLE ${this.tableName()} ADD CONSTRAINT ${constraintName$2} PRIMARY KEY (${this.formatter.columnize(columns)})`);
    }
    unique(columns, indexName) {
      let deferrable$2, useConstraint = false, predicate;
      if (isObject$5(indexName) && ({ indexName, deferrable: deferrable$2, useConstraint, predicate } = indexName), deferrable$2 && deferrable$2 !== `not deferrable` && this.client.logger.warn(`mssql: unique index [${indexName}] will not be deferrable ${deferrable$2} because mssql does not support deferred constraints.`), useConstraint && predicate) throw Error(`mssql cannot create constraint with predicate`);
      if (indexName = indexName ? this.formatter.wrap(indexName) : this._indexCommand(`unique`, this.tableNameRaw, columns), Array.isArray(columns) || (columns = [columns]), useConstraint) this.pushQuery(`ALTER TABLE ${this.tableName()} ADD CONSTRAINT ${indexName} UNIQUE (${this.formatter.columnize(columns)})`);
      else {
        let predicateQuery = predicate ? ` ` + this.client.queryCompiler(predicate).where() : ` WHERE ` + columns.map((column) => this.formatter.columnize(column) + ` IS NOT NULL`).join(` AND `);
        this.pushQuery(`CREATE UNIQUE INDEX ${indexName} ON ${this.tableName()} (${this.formatter.columnize(columns)})${predicateQuery}`);
      }
    }
    dropIndex(columns, indexName) {
      indexName = indexName ? this.formatter.wrap(indexName) : this._indexCommand(`index`, this.tableNameRaw, columns), this.pushQuery(`DROP INDEX ${indexName} ON ${this.tableName()}`);
    }
    dropForeign(columns, indexName) {
      indexName = indexName ? this.formatter.wrap(indexName) : this._indexCommand(`foreign`, this.tableNameRaw, columns), this.pushQuery(`ALTER TABLE ${this.tableName()} DROP CONSTRAINT ${indexName}`);
    }
    dropPrimary(constraintName$2) {
      constraintName$2 = constraintName$2 ? this.formatter.wrap(constraintName$2) : this.formatter.wrap(`${this.tableNameRaw}_pkey`), this.pushQuery(`ALTER TABLE ${this.tableName()} DROP CONSTRAINT ${constraintName$2}`);
    }
    dropUnique(column, indexName) {
      indexName = indexName ? this.formatter.wrap(indexName) : this._indexCommand(`unique`, this.tableNameRaw, column), this.pushQuery(`DROP INDEX ${indexName} ON ${this.tableName()}`);
    }
  };
  TableCompiler_MSSQL.prototype.createAlterTableMethods = [`foreign`, `primary`], TableCompiler_MSSQL.prototype.lowerCase = false, TableCompiler_MSSQL.prototype.addColumnsPrefix = `ADD `, TableCompiler_MSSQL.prototype.dropColumnPrefix = `DROP COLUMN `, TableCompiler_MSSQL.prototype.alterColumnPrefix = `ALTER COLUMN `, module2.exports = TableCompiler_MSSQL;
}), require_mssql_viewcompiler = __commonJSMin$1((exports$12, module2) => {
  let ViewCompiler$6 = require_viewcompiler(), { columnize: columnize_$3 } = require_wrappingFormatter();
  var ViewCompiler_MSSQL = class extends ViewCompiler$6 {
    constructor(client, viewCompiler) {
      super(client, viewCompiler);
    }
    createQuery(columns, selectQuery, materialized, replace) {
      let createStatement = `CREATE ` + (replace ? `OR ALTER ` : ``) + `VIEW `, sql = createStatement + this.viewName(), columnList = columns ? ` (` + columnize_$3(columns, this.viewBuilder, this.client, this.bindingsHolder) + `)` : ``;
      sql += columnList, sql += ` AS `, sql += selectQuery.toString(), this.pushQuery({ sql });
    }
    renameColumn(from$2, to) {
      this.pushQuery(`exec sp_rename ${this.client.parameter(this.viewName() + `.` + from$2, this.viewBuilder, this.bindingsHolder)}, ${this.client.parameter(to, this.viewBuilder, this.bindingsHolder)}, 'COLUMN'`);
    }
    createOrReplace() {
      this.createQuery(this.columns, this.selectQuery, false, true);
    }
  };
  module2.exports = ViewCompiler_MSSQL;
}), require_mssql_columncompiler = __commonJSMin$1((exports$12, module2) => {
  let ColumnCompiler$8 = require_columncompiler(), { toNumber: toNumber$2 } = require_helpers$1(), { formatDefault } = require_formatterUtils(), { operator: operator_ } = require_wrappingFormatter();
  var ColumnCompiler_MSSQL = class extends ColumnCompiler$8 {
    constructor(client, tableCompiler, columnBuilder) {
      super(client, tableCompiler, columnBuilder), this.modifiers = [`nullable`, `defaultTo`, `first`, `after`, `comment`], this._addCheckModifiers();
    }
    double(precision, scale) {
      return `float`;
    }
    floating(precision, scale) {
      return `float`;
    }
    integer() {
      return `int`;
    }
    tinyint() {
      return `tinyint`;
    }
    varchar(length) {
      return `nvarchar(${toNumber$2(length, 255)})`;
    }
    timestamp({ useTz = false } = {}) {
      return useTz ? `datetimeoffset` : `datetime2`;
    }
    bit(length) {
      return length > 1 && this.client.logger.warn(`Bit field is exactly 1 bit length for MSSQL`), `bit`;
    }
    binary(length) {
      return length ? `varbinary(${toNumber$2(length)})` : `varbinary(max)`;
    }
    first() {
      return this.client.logger.warn(`Column first modifier not available for MSSQL`), ``;
    }
    after(column) {
      return this.client.logger.warn(`Column after modifier not available for MSSQL`), ``;
    }
    defaultTo(value, { constraintName: constraintName$2 } = {}) {
      let formattedValue = formatDefault(value, this.type, this.client);
      return constraintName$2 = constraintName$2 === void 0 ? `${this.tableCompiler.tableNameRaw}_${this.getColumnName()}_default`.toLowerCase() : constraintName$2, this.columnBuilder._method === `alter` ? (this.pushAdditional(function() {
        this.pushQuery(`ALTER TABLE ${this.tableCompiler.tableName()} ADD CONSTRAINT ${this.formatter.wrap(constraintName$2)} DEFAULT ${formattedValue} FOR ${this.formatter.wrap(this.getColumnName())}`);
      }), ``) : constraintName$2 ? `CONSTRAINT ${this.formatter.wrap(constraintName$2)} DEFAULT ${formattedValue}` : `DEFAULT ${formattedValue}`;
    }
    comment(comment) {
      if (!comment) return;
      comment && comment.length > 7500 / 2 && this.client.logger.warn(`Your comment might be longer than the max comment length for MSSQL of 7,500 bytes.`);
      let value = this.formatter.escapingStringDelimiters(comment), level0name = this.tableCompiler.schemaNameRaw || `dbo`, level1name = this.formatter.escapingStringDelimiters(this.tableCompiler.tableNameRaw), level2name = this.formatter.escapingStringDelimiters(this.args[0] || this.defaults(`columnName`)), args$1 = `N'MS_Description', N'${value}', N'Schema', N'${level0name}', N'Table', N'${level1name}', N'Column', N'${level2name}'`;
      return this.pushAdditional(function() {
        let isAlreadyDefined = `EXISTS(SELECT * FROM sys.fn_listextendedproperty(N'MS_Description', N'Schema', N'${level0name}', N'Table', N'${level1name}', N'Column', N'${level2name}'))`;
        this.pushQuery(`IF ${isAlreadyDefined}
  EXEC sys.sp_updateextendedproperty ${args$1}
ELSE
  EXEC sys.sp_addextendedproperty ${args$1}`);
      }), ``;
    }
    checkLength(operator$1, length, constraintName$2) {
      return this._check(`LEN(${this.formatter.wrap(this.getColumnName())}) ${operator_(operator$1, this.columnBuilder, this.bindingsHolder)} ${toNumber$2(length)}`, constraintName$2);
    }
    checkRegex(regex, constraintName$2) {
      return this._check(`${this.formatter.wrap(this.getColumnName())} LIKE ${this.client._escapeBinding(`%` + regex + `%`)}`, constraintName$2);
    }
    increments(options = { primaryKey: true }) {
      return `int identity(1,1) not null` + (this.tableCompiler._canBeAddPrimaryKey(options) ? ` primary key` : ``);
    }
    bigincrements(options = { primaryKey: true }) {
      return `bigint identity(1,1) not null` + (this.tableCompiler._canBeAddPrimaryKey(options) ? ` primary key` : ``);
    }
  };
  ColumnCompiler_MSSQL.prototype.bigint = `bigint`, ColumnCompiler_MSSQL.prototype.mediumint = `int`, ColumnCompiler_MSSQL.prototype.smallint = `smallint`, ColumnCompiler_MSSQL.prototype.text = `nvarchar(max)`, ColumnCompiler_MSSQL.prototype.mediumtext = `nvarchar(max)`, ColumnCompiler_MSSQL.prototype.longtext = `nvarchar(max)`, ColumnCompiler_MSSQL.prototype.json = ColumnCompiler_MSSQL.prototype.jsonb = `nvarchar(max)`, ColumnCompiler_MSSQL.prototype.enu = `nvarchar(100)`, ColumnCompiler_MSSQL.prototype.uuid = ({ useBinaryUuid = false } = {}) => useBinaryUuid ? `binary(16)` : `uniqueidentifier`, ColumnCompiler_MSSQL.prototype.datetime = `datetime2`, ColumnCompiler_MSSQL.prototype.bool = `bit`, module2.exports = ColumnCompiler_MSSQL;
}), require_mssql = __commonJSMin$1((exports$12, module2) => {
  init_dist$1(), init_dist();
  let map$3 = require_map(), isNil = require_isNil(), Client$4 = require_client(), MSSQL_Formatter = require_mssql_formatter(), Transaction$8 = require_transaction$4(), QueryCompiler$6 = require_mssql_querycompiler(), SchemaCompiler$5 = require_mssql_compiler(), TableCompiler$6 = require_mssql_tablecompiler(), ViewCompiler$5 = require_mssql_viewcompiler(), ColumnCompiler$7 = require_mssql_columncompiler(), QueryBuilder$3 = require_querybuilder(), { setHiddenProperty: setHiddenProperty$1 } = require_security(), debug$7 = require_src()(`knex:mssql`), SQL_INT4 = { MIN: -2147483648, MAX: 2147483647 }, SQL_BIGINT_SAFE = { MIN: -9007199254740991, MAX: 9007199254740991 };
  var Client_MSSQL = class extends Client$4 {
    constructor(config = {}) {
      super(config);
    }
    _generateConnection() {
      let settings = this.connectionSettings;
      settings.options = settings.options || {};
      let cfg = { authentication: { type: settings.type || `default`, options: { userName: settings.userName || settings.user, password: settings.password, domain: settings.domain, token: settings.token, clientId: settings.clientId, clientSecret: settings.clientSecret, tenantId: settings.tenantId, msiEndpoint: settings.msiEndpoint } }, server: settings.server || settings.host, options: { database: settings.database, encrypt: settings.encrypt || false, port: settings.port || 1433, connectTimeout: settings.connectionTimeout || settings.timeout || 15e3, requestTimeout: isNil(settings.requestTimeout) ? 15e3 : settings.requestTimeout, rowCollectionOnDone: false, rowCollectionOnRequestCompletion: false, useColumnNames: false, tdsVersion: settings.options.tdsVersion || `7_4`, appName: settings.options.appName || `knex`, trustServerCertificate: false, ...settings.options } };
      return cfg.authentication.options.password && setHiddenProperty$1(cfg.authentication.options), cfg.options.instanceName && delete cfg.options.port, isNaN(cfg.options.requestTimeout) && (cfg.options.requestTimeout = 15e3), cfg.options.requestTimeout === 1 / 0 && (cfg.options.requestTimeout = 0), cfg.options.requestTimeout < 0 && (cfg.options.requestTimeout = 0), settings.debug && (cfg.options.debug = { packet: true, token: true, data: true, payload: true }), cfg;
    }
    _driver() {
      let tds$1 = __require$1(`tedious`);
      return tds$1;
    }
    formatter() {
      return new MSSQL_Formatter(this, ...arguments);
    }
    transaction() {
      return new Transaction$8(this, ...arguments);
    }
    queryCompiler() {
      return new QueryCompiler$6(this, ...arguments);
    }
    schemaCompiler() {
      return new SchemaCompiler$5(this, ...arguments);
    }
    tableCompiler() {
      return new TableCompiler$6(this, ...arguments);
    }
    viewCompiler() {
      return new ViewCompiler$5(this, ...arguments);
    }
    queryBuilder() {
      let b2 = new QueryBuilder$3(this);
      return b2;
    }
    columnCompiler() {
      return new ColumnCompiler$7(this, ...arguments);
    }
    wrapIdentifierImpl(value) {
      return value === `*` ? `*` : `[${value.replace(/[[\]]+/g, ``)}]`;
    }
    acquireRawConnection() {
      return new Promise((resolver, rejecter) => {
        debug$7(`connection::connection new connection requested`);
        let Driver = this._driver(), settings = Object.assign({}, this._generateConnection()), connection = new Driver.Connection(settings);
        connection.connect((err$1) => err$1 ? (debug$7(`connection::connect error: %s`, err$1.message), rejecter(err$1)) : (debug$7(`connection::connect connected to server`), connection.connected = true, connection.on(`error`, (e$22) => {
          debug$7(`connection::error message=%s`, e$22.message), connection.__knex__disposed = e$22, connection.connected = false;
        }), connection.once(`end`, () => {
          connection.connected = false, connection.__knex__disposed = `Connection to server was terminated.`, debug$7(`connection::end connection ended.`);
        }), resolver(connection)));
      });
    }
    validateConnection(connection) {
      return connection && connection.connected;
    }
    destroyRawConnection(connection) {
      return debug$7(`connection::destroy`), new Promise((resolve) => {
        connection.once(`end`, () => {
          resolve();
        }), connection.close();
      });
    }
    positionBindings(sql) {
      let questionCount = -1;
      return sql.replace(/\\?\?/g, (match$2) => match$2 === `\\?` ? `?` : (questionCount += 1, `@p${questionCount}`));
    }
    _chomp(connection) {
      if (connection.state.name === `LoggedIn`) {
        let nextRequest = this.requestQueue.pop();
        nextRequest && (debug$7(`connection::query executing query, %d more in queue`, this.requestQueue.length), connection.execSql(nextRequest));
      }
    }
    _enqueueRequest(request, connection) {
      this.requestQueue.push(request), this._chomp(connection);
    }
    _makeRequest(query, callback) {
      let Driver = this._driver(), sql = typeof query == `string` ? query : query.sql, rowCount = 0;
      if (!sql) throw Error(`The query is empty`);
      debug$7(`request::request sql=%s`, sql);
      let request = new Driver.Request(sql, (err$1, remoteRowCount) => {
        if (err$1) return debug$7(`request::error message=%s`, err$1.message), callback(err$1);
        rowCount = remoteRowCount, debug$7(`request::callback rowCount=%d`, rowCount);
      });
      return request.on(`prepared`, () => {
        debug$7(`request %s::request prepared`, this.id);
      }), request.on(`done`, (rowCount$1, more) => {
        debug$7(`request::done rowCount=%d more=%s`, rowCount$1, more);
      }), request.on(`doneProc`, (rowCount$1, more) => {
        debug$7(`request::doneProc id=%s rowCount=%d more=%s`, request.id, rowCount$1, more);
      }), request.on(`doneInProc`, (rowCount$1, more) => {
        debug$7(`request::doneInProc id=%s rowCount=%d more=%s`, request.id, rowCount$1, more);
      }), request.once(`requestCompleted`, () => (debug$7(`request::completed id=%s`, request.id), callback(null, rowCount))), request.on(`error`, (err$1) => (debug$7(`request::error id=%s message=%s`, request.id, err$1.message), callback(err$1))), request;
    }
    _stream(connection, query, stream$1) {
      return new Promise((resolve, reject$2) => {
        let request = this._makeRequest(query, (err$1) => {
          if (err$1) return stream$1.emit(`error`, err$1), reject$2(err$1);
          resolve();
        });
        request.on(`row`, (row) => {
          stream$1.write(row.reduce((prev, curr) => ({ ...prev, [curr.metadata.colName]: curr.value }), {}));
        }), request.on(`error`, (err$1) => {
          stream$1.emit(`error`, err$1), reject$2(err$1);
        }), request.once(`requestCompleted`, () => {
          stream$1.end(), resolve();
        }), this._assignBindings(request, query.bindings), this._enqueueRequest(request, connection);
      });
    }
    _assignBindings(request, bindings) {
      if (Array.isArray(bindings)) for (let i$4 = 0; i$4 < bindings.length; i$4++) {
        let binding = bindings[i$4];
        this._setReqInput(request, i$4, binding);
      }
    }
    _scaleForBinding(binding) {
      if (binding % 1 == 0) throw Error(`The binding value ${binding} must be a decimal number.`);
      return { scale: 10 };
    }
    _typeForBinding(binding) {
      let Driver = this._driver();
      if (this.connectionSettings.options && this.connectionSettings.options.mapBinding) {
        let result = this.connectionSettings.options.mapBinding(binding);
        if (result) return [result.value, result.type];
      }
      switch (typeof binding) {
        case `string`:
          return [binding, Driver.TYPES.NVarChar];
        case `boolean`:
          return [binding, Driver.TYPES.Bit];
        case `number`:
          if (binding % 1 != 0) return [binding, Driver.TYPES.Float];
          if (binding < SQL_INT4.MIN || binding > SQL_INT4.MAX) {
            if (binding < SQL_BIGINT_SAFE.MIN || binding > SQL_BIGINT_SAFE.MAX) throw Error(`Bigint must be safe integer or must be passed as string, saw ${binding}`);
            return [binding, Driver.TYPES.BigInt];
          }
          return [binding, Driver.TYPES.Int];
        default:
          return binding instanceof Date ? [binding, Driver.TYPES.DateTime] : binding instanceof Buffer$1 ? [binding, Driver.TYPES.VarBinary] : [binding, Driver.TYPES.NVarChar];
      }
    }
    _query(connection, query) {
      return new Promise((resolve, reject$2) => {
        let rows = [], request = this._makeRequest(query, (err$1, count) => {
          if (err$1) return reject$2(err$1);
          query.response = rows, process$1.nextTick(() => this._chomp(connection)), resolve(query);
        });
        request.on(`row`, (row) => {
          debug$7(`request::row`), rows.push(row);
        }), this._assignBindings(request, query.bindings), this._enqueueRequest(request, connection);
      });
    }
    _setReqInput(req, i$4, inputBinding) {
      let [binding, tediousType] = this._typeForBinding(inputBinding), bindingName = `p${i$4}`, options;
      typeof binding == `number` && binding % 1 != 0 && (options = this._scaleForBinding(binding)), debug$7(`request::binding pos=%d type=%s value=%s`, i$4, tediousType.name, binding), Buffer$1.isBuffer(binding) && (options = { length: `max` }), req.addParameter(bindingName, tediousType, binding, options);
    }
    processResponse(query, runner) {
      if (query == null) return;
      let { response } = query, { method: method$1 } = query;
      if (query.output || (response = response.map((row) => row.reduce((columns, r$2) => {
        let colName = r$2.metadata.colName;
        return columns[colName] ? (Array.isArray(columns[colName]) || (columns[colName] = [columns[colName]]), columns[colName].push(r$2.value)) : columns[colName] = r$2.value, columns;
      }, {})), query.output)) return query.output.call(runner, response);
      switch (method$1) {
        case `select`:
          return response;
        case `first`:
          return response[0];
        case `pluck`:
          return map$3(response, query.pluck);
        case `insert`:
        case `del`:
        case `update`:
        case `counter`:
          return query.returning && query.returning === `@@rowcount` ? response[0][``] : response;
        default:
          return response;
      }
    }
  };
  Object.assign(Client_MSSQL.prototype, { requestQueue: [], dialect: `mssql`, driverName: `mssql` }), module2.exports = Client_MSSQL;
}), require__baseDelay = __commonJSMin$1((exports$12, module2) => {
  var FUNC_ERROR_TEXT = `Expected a function`;
  function baseDelay$1(func, wait$1, args$1) {
    if (typeof func != `function`) throw TypeError(FUNC_ERROR_TEXT);
    return setTimeout(function() {
      func.apply(void 0, args$1);
    }, wait$1);
  }
  module2.exports = baseDelay$1;
}), require_defer = __commonJSMin$1((exports$12, module2) => {
  var baseDelay = require__baseDelay(), baseRest = require__baseRest(), defer$1 = baseRest(function(func, args$1) {
    return baseDelay(func, 1, args$1);
  });
  module2.exports = defer$1;
}), require_transaction$3 = __commonJSMin$1((exports$12, module2) => {
  let Transaction$7 = (init_transaction(), __toCommonJS(transaction_exports)), Debug = require_src(), debug$6 = Debug(`knex:tx`);
  var Transaction_MySQL = class extends Transaction$7 {
    query(conn, sql, status, value) {
      let t$7 = this, q = this.trxClient.query(conn, sql).catch((err$1) => {
        if (err$1.errno === 1305) {
          this.trxClient.logger.warn(`Transaction was implicitly committed, do not mix transactions and DDL with MySQL (#805)`);
          return;
        }
        status = 2, value = err$1, t$7._completed = true, debug$6(`%s error running transaction query`, t$7.txid);
      }).then(function(res) {
        if (status === 1 && t$7._resolver(value), status === 2) {
          if (value === void 0) {
            if (t$7.doNotRejectOnRollback && /^ROLLBACK\b/i.test(sql)) {
              t$7._resolver();
              return;
            }
            value = Error(`Transaction rejected with non-error: ${value}`);
          }
          t$7._rejecter(value);
        }
        return res;
      });
      return (status === 1 || status === 2) && (t$7._completed = true), q;
    }
  };
  module2.exports = Transaction_MySQL;
}), require_mysql_querybuilder = __commonJSMin$1((exports$12, module2) => {
  let QueryBuilder$2 = require_querybuilder(), isEmpty$4 = require_isEmpty();
  module2.exports = class extends QueryBuilder$2 {
    upsert(values$3, returning, options) {
      return this._method = `upsert`, isEmpty$4(returning) || this.returning(returning, options), this._single.upsert = values$3, this;
    }
  };
}), require_mysql_querycompiler = __commonJSMin$1((exports$12, module2) => {
  let assert$19 = require_assert(), identity$2 = require_identity(), isPlainObject$3 = require_isPlainObject(), isEmpty$3 = require_isEmpty(), QueryCompiler$5 = require_querycompiler(), { wrapAsIdentifier } = require_formatterUtils(), { columnize: columnize_$2, wrap: wrap_ } = require_wrappingFormatter(), isPlainObjectOrArray = (value) => isPlainObject$3(value) || Array.isArray(value);
  var QueryCompiler_MySQL = class extends QueryCompiler$5 {
    constructor(client, builder, formatter) {
      super(client, builder, formatter);
      let { returning } = this.single;
      returning && this.client.logger.warn(`.returning() is not supported by mysql and will not have any effect.`), this._emptyInsertValue = `() values ()`;
    }
    del() {
      let sql = super.del();
      if (sql === ``) return sql;
      let comments = this.comments();
      return (comments === `` ? `` : comments + ` `) + sql;
    }
    insert() {
      let sql = super.insert();
      if (sql === ``) return sql;
      let comments = this.comments();
      sql = (comments === `` ? `` : comments + ` `) + sql;
      let { ignore: ignore$2, merge: merge$4, insert } = this.single;
      if (ignore$2 && (sql = sql.replace(`insert into`, `insert ignore into`)), merge$4) {
        sql += this._merge(merge$4.updates, insert);
        let wheres = this.where();
        if (wheres) throw Error(`.onConflict().merge().where() is not supported for mysql`);
      }
      return sql;
    }
    upsert() {
      let upsertValues = this.single.upsert || [], sql = this.with() + `replace into ${this.tableName} `, body = this._insertBody(upsertValues);
      return body === `` ? `` : sql + body;
    }
    _merge(updates, insert) {
      let sql = ` on duplicate key update `;
      if (updates && Array.isArray(updates)) return sql + updates.map((column) => wrapAsIdentifier(column, this.formatter.builder, this.client)).map((column) => `${column} = values(${column})`).join(`, `);
      if (updates && typeof updates == `object`) {
        let updateData = this._prepUpdate(updates);
        return sql + updateData.join(`,`);
      } else {
        let insertData = this._prepInsert(insert);
        if (typeof insertData == `string`) throw Error(`If using merge with a raw insert query, then updates must be provided`);
        return sql + insertData.columns.map((column) => wrapAsIdentifier(column, this.builder, this.client)).map((column) => `${column} = values(${column})`).join(`, `);
      }
    }
    update() {
      let comments = this.comments(), withSQL = this.with(), join = this.join(), updates = this._prepUpdate(this.single.update), where$2 = this.where(), order$2 = this.order(), limit = this.limit();
      return (comments === `` ? `` : comments + ` `) + withSQL + `update ${this.tableName}` + (join ? ` ${join}` : ``) + ` set ` + updates.join(`, `) + (where$2 ? ` ${where$2}` : ``) + (order$2 ? ` ${order$2}` : ``) + (limit ? ` ${limit}` : ``);
    }
    forUpdate() {
      return `for update`;
    }
    forShare() {
      return `lock in share mode`;
    }
    skipLocked() {
      return `skip locked`;
    }
    noWait() {
      return `nowait`;
    }
    columnInfo() {
      let column = this.single.columnInfo, table$2 = this.client.customWrapIdentifier(this.single.table, identity$2);
      return { sql: `select * from information_schema.columns where table_name = ? and table_schema = ?`, bindings: [table$2, this.client.database()], output(resp) {
        let out = resp.reduce(function(columns, val) {
          return columns[val.COLUMN_NAME] = { defaultValue: val.COLUMN_DEFAULT === `NULL` ? null : val.COLUMN_DEFAULT, type: val.DATA_TYPE, maxLength: val.CHARACTER_MAXIMUM_LENGTH, nullable: val.IS_NULLABLE === `YES` }, columns;
        }, {});
        return column && out[column] || out;
      } };
    }
    limit() {
      let noLimit = !this.single.limit && this.single.limit !== 0;
      if (noLimit && !this.single.offset) return ``;
      let limit = this.single.offset && noLimit ? `18446744073709551615` : this._getValueOrParameterFromAttribute(`limit`);
      return `limit ${limit}`;
    }
    whereBasic(statement) {
      return assert$19(!isPlainObjectOrArray(statement.value), `The values in where clause must not be object or array.`), super.whereBasic(statement);
    }
    whereRaw(statement) {
      return assert$19(isEmpty$3(statement.value.bindings) || !Object.values(statement.value.bindings).some(isPlainObjectOrArray), `The values in where clause must not be object or array.`), super.whereRaw(statement);
    }
    whereLike(statement) {
      return `${this._columnClause(statement)} ${this._not(statement, `like `)}${this._valueClause(statement)} COLLATE utf8_bin`;
    }
    whereILike(statement) {
      return `${this._columnClause(statement)} ${this._not(statement, `like `)}${this._valueClause(statement)}`;
    }
    jsonExtract(params) {
      return this._jsonExtract([`json_extract`, `json_unquote`], params);
    }
    jsonSet(params) {
      return this._jsonSet(`json_set`, params);
    }
    jsonInsert(params) {
      return this._jsonSet(`json_insert`, params);
    }
    jsonRemove(params) {
      let jsonCol = `json_remove(${columnize_$2(params.column, this.builder, this.client, this.bindingsHolder)},${this.client.parameter(params.path, this.builder, this.bindingsHolder)})`;
      return params.alias ? this.client.alias(jsonCol, this.formatter.wrap(params.alias)) : jsonCol;
    }
    whereJsonObject(statement) {
      return this._not(statement, `json_contains(${this._columnClause(statement)}, ${this._jsonValueClause(statement)})`);
    }
    whereJsonPath(statement) {
      return this._whereJsonPath(`json_extract`, statement);
    }
    whereJsonSupersetOf(statement) {
      return this._not(statement, `json_contains(${wrap_(statement.column, void 0, this.builder, this.client, this.bindingsHolder)},${this._jsonValueClause(statement)})`);
    }
    whereJsonSubsetOf(statement) {
      return this._not(statement, `json_contains(${this._jsonValueClause(statement)},${wrap_(statement.column, void 0, this.builder, this.client, this.bindingsHolder)})`);
    }
    onJsonPathEquals(clause) {
      return this._onJsonPathEquals(`json_extract`, clause);
    }
  };
  module2.exports = QueryCompiler_MySQL;
}), require_mysql_compiler = __commonJSMin$1((exports$12, module2) => {
  let SchemaCompiler$4 = require_compiler$1();
  var SchemaCompiler_MySQL = class extends SchemaCompiler$4 {
    constructor(client, builder) {
      super(client, builder);
    }
    renameTable(tableName, to) {
      this.pushQuery(`rename table ${this.formatter.wrap(tableName)} to ${this.formatter.wrap(to)}`);
    }
    renameView(from$2, to) {
      this.renameTable(from$2, to);
    }
    hasTable(tableName) {
      let sql = `select * from information_schema.tables where table_name = ?`, bindings = [tableName];
      this.schema ? (sql += ` and table_schema = ?`, bindings.push(this.schema)) : sql += ` and table_schema = database()`, this.pushQuery({ sql, bindings, output: function(resp) {
        return resp.length > 0;
      } });
    }
    hasColumn(tableName, column) {
      this.pushQuery({ sql: `show columns from ${this.formatter.wrap(tableName)}`, output(resp) {
        return resp.some((row) => this.client.wrapIdentifier(row.Field.toLowerCase()) === this.client.wrapIdentifier(column.toLowerCase()));
      } });
    }
  };
  module2.exports = SchemaCompiler_MySQL;
}), require_mysql_tablecompiler = __commonJSMin$1((exports$12, module2) => {
  let TableCompiler$5 = require_tablecompiler(), { isObject: isObject$4, isString: isString$5 } = require_is();
  var TableCompiler_MySQL = class extends TableCompiler$5 {
    constructor(client, tableBuilder) {
      super(client, tableBuilder);
    }
    createQuery(columns, ifNot, like) {
      let createStatement = ifNot ? `create table if not exists ` : `create table `, { client } = this, conn = {}, columnsSql = ` (` + columns.sql.join(`, `);
      columnsSql += this.primaryKeys() || ``, columnsSql += this._addChecks(), columnsSql += `)`;
      let sql = createStatement + this.tableName() + (like && this.tableNameLike() ? ` like ` + this.tableNameLike() : columnsSql);
      client.connectionSettings && (conn = client.connectionSettings);
      let charset = this.single.charset || conn.charset || ``, collation$2 = this.single.collate || conn.collate || ``, engine = this.single.engine || ``;
      if (charset && !like && (sql += ` default character set ${charset}`), collation$2 && (sql += ` collate ${collation$2}`), engine && (sql += ` engine = ${engine}`), this.single.comment) {
        let comment = this.single.comment || ``, MAX_COMMENT_LENGTH = 1024;
        comment.length > MAX_COMMENT_LENGTH && this.client.logger.warn(`The max length for a table comment is ${MAX_COMMENT_LENGTH} characters`), sql += ` comment = '${comment}'`;
      }
      this.pushQuery(sql), like && this.addColumns(columns, this.addColumnsPrefix);
    }
    comment(comment) {
      this.pushQuery(`alter table ${this.tableName()} comment = '${comment}'`);
    }
    changeType() {
    }
    renameColumn(from$2, to) {
      let compiler = this, table$2 = this.tableName(), wrapped = this.formatter.wrap(from$2) + ` ` + this.formatter.wrap(to);
      this.pushQuery({ sql: `show full fields from ${table$2} where field = ` + this.client.parameter(from$2, this.tableBuilder, this.bindingsHolder), output(resp) {
        let column = resp[0], runner = this;
        return compiler.getFKRefs(runner).then(([refs]) => new Promise((resolve, reject$2) => {
          try {
            refs.length || resolve(), resolve(compiler.dropFKRefs(runner, refs));
          } catch (e$22) {
            reject$2(e$22);
          }
        }).then(function() {
          let sql = `alter table ${table$2} change ${wrapped} ${column.Type}`;
          return String(column.Null).toUpperCase() === `YES` ? sql += ` NULL` : sql += ` NOT NULL`, column.Default !== void 0 && column.Default !== null && (sql += ` DEFAULT '${column.Default}'`), column.Collation !== void 0 && column.Collation !== null && (sql += ` COLLATE '${column.Collation}'`), column.Extra == `auto_increment` && (sql += ` AUTO_INCREMENT`), runner.query({ sql });
        }).then(function() {
          if (refs.length) return compiler.createFKRefs(runner, refs.map(function(ref) {
            return ref.REFERENCED_COLUMN_NAME === from$2 && (ref.REFERENCED_COLUMN_NAME = to), ref.COLUMN_NAME === from$2 && (ref.COLUMN_NAME = to), ref;
          }));
        }));
      } });
    }
    primaryKeys() {
      let pks = (this.grouped.alterTable || []).filter((k) => k.method === `primary`);
      if (pks.length > 0 && pks[0].args.length > 0) {
        let columns = pks[0].args[0], constraintName$2 = pks[0].args[1] || ``;
        if (constraintName$2 &&= ` constraint ` + this.formatter.wrap(constraintName$2), this.grouped.columns) {
          let incrementsCols = this._getIncrementsColumnNames();
          incrementsCols.length && incrementsCols.forEach((c$12) => {
            columns.includes(c$12) || columns.unshift(c$12);
          });
          let bigIncrementsCols = this._getBigIncrementsColumnNames();
          bigIncrementsCols.length && bigIncrementsCols.forEach((c$12) => {
            columns.includes(c$12) || columns.unshift(c$12);
          });
        }
        return `,${constraintName$2} primary key (${this.formatter.columnize(columns)})`;
      }
    }
    getFKRefs(runner) {
      let bindingsHolder = { bindings: [] }, sql = `SELECT KCU.CONSTRAINT_NAME, KCU.TABLE_NAME, KCU.COLUMN_NAME,        KCU.REFERENCED_TABLE_NAME, KCU.REFERENCED_COLUMN_NAME,        RC.UPDATE_RULE, RC.DELETE_RULE FROM INFORMATION_SCHEMA.KEY_COLUMN_USAGE AS KCU JOIN INFORMATION_SCHEMA.REFERENTIAL_CONSTRAINTS AS RC        USING(CONSTRAINT_NAME)WHERE KCU.REFERENCED_TABLE_NAME = ` + this.client.parameter(this.tableNameRaw, this.tableBuilder, bindingsHolder) + `   AND KCU.CONSTRAINT_SCHEMA = ` + this.client.parameter(this.client.database(), this.tableBuilder, bindingsHolder) + `   AND RC.CONSTRAINT_SCHEMA = ` + this.client.parameter(this.client.database(), this.tableBuilder, bindingsHolder);
      return runner.query({ sql, bindings: bindingsHolder.bindings });
    }
    dropFKRefs(runner, refs) {
      let formatter = this.client.formatter(this.tableBuilder);
      return Promise.all(refs.map(function(ref) {
        let constraintName$2 = formatter.wrap(ref.CONSTRAINT_NAME), tableName = formatter.wrap(ref.TABLE_NAME);
        return runner.query({ sql: `alter table ${tableName} drop foreign key ${constraintName$2}` });
      }));
    }
    createFKRefs(runner, refs) {
      let formatter = this.client.formatter(this.tableBuilder);
      return Promise.all(refs.map(function(ref) {
        let tableName = formatter.wrap(ref.TABLE_NAME), keyName = formatter.wrap(ref.CONSTRAINT_NAME), column = formatter.columnize(ref.COLUMN_NAME), references = formatter.columnize(ref.REFERENCED_COLUMN_NAME), inTable = formatter.wrap(ref.REFERENCED_TABLE_NAME), onUpdate = ` ON UPDATE ${ref.UPDATE_RULE}`, onDelete = ` ON DELETE ${ref.DELETE_RULE}`;
        return runner.query({ sql: `alter table ${tableName} add constraint ${keyName} foreign key (` + column + `) references ` + inTable + ` (` + references + `)` + onUpdate + onDelete });
      }));
    }
    index(columns, indexName, options) {
      let storageEngineIndexType, indexType;
      isString$5(options) ? indexType = options : isObject$4(options) && ({ indexType, storageEngineIndexType } = options), indexName = indexName ? this.formatter.wrap(indexName) : this._indexCommand(`index`, this.tableNameRaw, columns), storageEngineIndexType = storageEngineIndexType ? ` using ${storageEngineIndexType}` : ``, this.pushQuery(`alter table ${this.tableName()} add${indexType ? ` ${indexType}` : ``} index ${indexName}(${this.formatter.columnize(columns)})${storageEngineIndexType}`);
    }
    primary(columns, constraintName$2) {
      let deferrable$2;
      isObject$4(constraintName$2) && ({ constraintName: constraintName$2, deferrable: deferrable$2 } = constraintName$2), deferrable$2 && deferrable$2 !== `not deferrable` && this.client.logger.warn(`mysql: primary key constraint \`${constraintName$2}\` will not be deferrable ${deferrable$2} because mysql does not support deferred constraints.`), constraintName$2 = constraintName$2 ? this.formatter.wrap(constraintName$2) : this.formatter.wrap(`${this.tableNameRaw}_pkey`);
      let primaryCols = columns, incrementsCols = [], bigIncrementsCols = [];
      this.grouped.columns && (incrementsCols = this._getIncrementsColumnNames(), incrementsCols && incrementsCols.forEach((c$12) => {
        primaryCols.includes(c$12) || primaryCols.unshift(c$12);
      }), bigIncrementsCols = this._getBigIncrementsColumnNames(), bigIncrementsCols && bigIncrementsCols.forEach((c$12) => {
        primaryCols.includes(c$12) || primaryCols.unshift(c$12);
      })), this.method !== `create` && this.method !== `createIfNot` && this.pushQuery(`alter table ${this.tableName()} add primary key ${constraintName$2}(${this.formatter.columnize(primaryCols)})`), incrementsCols.length && this.pushQuery(`alter table ${this.tableName()} modify column ${this.formatter.columnize(incrementsCols)} int unsigned not null auto_increment`), bigIncrementsCols.length && this.pushQuery(`alter table ${this.tableName()} modify column ${this.formatter.columnize(bigIncrementsCols)} bigint unsigned not null auto_increment`);
    }
    unique(columns, indexName) {
      let storageEngineIndexType, deferrable$2;
      isObject$4(indexName) && ({ indexName, deferrable: deferrable$2, storageEngineIndexType } = indexName), deferrable$2 && deferrable$2 !== `not deferrable` && this.client.logger.warn(`mysql: unique index \`${indexName}\` will not be deferrable ${deferrable$2} because mysql does not support deferred constraints.`), indexName = indexName ? this.formatter.wrap(indexName) : this._indexCommand(`unique`, this.tableNameRaw, columns), storageEngineIndexType = storageEngineIndexType ? ` using ${storageEngineIndexType}` : ``, this.pushQuery(`alter table ${this.tableName()} add unique ${indexName}(${this.formatter.columnize(columns)})${storageEngineIndexType}`);
    }
    dropIndex(columns, indexName) {
      indexName = indexName ? this.formatter.wrap(indexName) : this._indexCommand(`index`, this.tableNameRaw, columns), this.pushQuery(`alter table ${this.tableName()} drop index ${indexName}`);
    }
    dropForeign(columns, indexName) {
      indexName = indexName ? this.formatter.wrap(indexName) : this._indexCommand(`foreign`, this.tableNameRaw, columns), this.pushQuery(`alter table ${this.tableName()} drop foreign key ${indexName}`);
    }
    dropPrimary() {
      this.pushQuery(`alter table ${this.tableName()} drop primary key`);
    }
    dropUnique(column, indexName) {
      indexName = indexName ? this.formatter.wrap(indexName) : this._indexCommand(`unique`, this.tableNameRaw, column), this.pushQuery(`alter table ${this.tableName()} drop index ${indexName}`);
    }
  };
  TableCompiler_MySQL.prototype.addColumnsPrefix = `add `, TableCompiler_MySQL.prototype.alterColumnsPrefix = `modify `, TableCompiler_MySQL.prototype.dropColumnPrefix = `drop `, module2.exports = TableCompiler_MySQL;
}), require_mysql_columncompiler = __commonJSMin$1((exports$12, module2) => {
  let ColumnCompiler$6 = require_columncompiler(), { isObject: isObject$3 } = require_is(), { toNumber: toNumber$1 } = require_helpers$1(), commentEscapeRegex = RegExp(`(?<!\\\\)'`, `g`);
  var ColumnCompiler_MySQL = class extends ColumnCompiler$6 {
    constructor(client, tableCompiler, columnBuilder) {
      super(client, tableCompiler, columnBuilder), this.modifiers = [`unsigned`, `nullable`, `defaultTo`, `comment`, `collate`, `first`, `after`], this._addCheckModifiers();
    }
    double(precision, scale) {
      return precision ? `double(${toNumber$1(precision, 8)}, ${toNumber$1(scale, 2)})` : `double`;
    }
    integer(length) {
      return length = length ? `(${toNumber$1(length, 11)})` : ``, `int${length}`;
    }
    tinyint(length) {
      return length = length ? `(${toNumber$1(length, 1)})` : ``, `tinyint${length}`;
    }
    text(column) {
      switch (column) {
        case `medium`:
        case `mediumtext`:
          return `mediumtext`;
        case `long`:
        case `longtext`:
          return `longtext`;
        default:
          return `text`;
      }
    }
    mediumtext() {
      return this.text(`medium`);
    }
    longtext() {
      return this.text(`long`);
    }
    enu(allowed) {
      return `enum('${allowed.join(`', '`)}')`;
    }
    datetime(precision) {
      return isObject$3(precision) && ({ precision } = precision), typeof precision == `number` ? `datetime(${precision})` : `datetime`;
    }
    timestamp(precision) {
      return isObject$3(precision) && ({ precision } = precision), typeof precision == `number` ? `timestamp(${precision})` : `timestamp`;
    }
    time(precision) {
      return isObject$3(precision) && ({ precision } = precision), typeof precision == `number` ? `time(${precision})` : `time`;
    }
    bit(length) {
      return length ? `bit(${toNumber$1(length)})` : `bit`;
    }
    binary(length) {
      return length ? `varbinary(${toNumber$1(length)})` : `blob`;
    }
    json() {
      return `json`;
    }
    jsonb() {
      return `json`;
    }
    defaultTo(value) {
      if (value == null) return;
      if ((this.type === `json` || this.type === `jsonb`) && isObject$3(value)) return `default ('${JSON.stringify(value)}')`;
      let defaultVal = super.defaultTo.apply(this, arguments);
      return this.type !== `blob` && this.type.indexOf(`text`) === -1 ? defaultVal : ``;
    }
    unsigned() {
      return `unsigned`;
    }
    comment(comment) {
      return comment && comment.length > 255 && this.client.logger.warn(`Your comment is longer than the max comment length for MySQL`), comment && `comment '${comment.replace(commentEscapeRegex, `\\'`)}'`;
    }
    first() {
      return `first`;
    }
    after(column) {
      return `after ${this.formatter.wrap(column)}`;
    }
    collate(collation$2) {
      return collation$2 && `collate '${collation$2}'`;
    }
    checkRegex(regex, constraintName$2) {
      return this._check(`${this.formatter.wrap(this.getColumnName())} REGEXP ${this.client._escapeBinding(regex)}`, constraintName$2);
    }
    increments(options = { primaryKey: true }) {
      return `int unsigned not null` + (this.tableCompiler._canBeAddPrimaryKey(options) ? ` auto_increment primary key` : ``);
    }
    bigincrements(options = { primaryKey: true }) {
      return `bigint unsigned not null` + (this.tableCompiler._canBeAddPrimaryKey(options) ? ` auto_increment primary key` : ``);
    }
  };
  ColumnCompiler_MySQL.prototype.bigint = `bigint`, ColumnCompiler_MySQL.prototype.mediumint = `mediumint`, ColumnCompiler_MySQL.prototype.smallint = `smallint`, module2.exports = ColumnCompiler_MySQL;
}), require_mysql_viewcompiler = __commonJSMin$1((exports$12, module2) => {
  let ViewCompiler$4 = require_viewcompiler();
  var ViewCompiler_MySQL = class extends ViewCompiler$4 {
    constructor(client, viewCompiler) {
      super(client, viewCompiler);
    }
    createOrReplace() {
      this.createQuery(this.columns, this.selectQuery, false, true);
    }
  };
  module2.exports = ViewCompiler_MySQL;
}), require_mysql_viewbuilder = __commonJSMin$1((exports$12, module2) => {
  let ViewBuilder$3 = require_viewbuilder();
  var ViewBuilder_MySQL = class extends ViewBuilder$3 {
    constructor() {
      super(...arguments);
    }
    checkOption() {
      this._single.checkOption = `default_option`;
    }
    localCheckOption() {
      this._single.checkOption = `local`;
    }
    cascadedCheckOption() {
      this._single.checkOption = `cascaded`;
    }
  };
  module2.exports = ViewBuilder_MySQL;
}), require_mysql = __commonJSMin$1((exports$12, module2) => {
  let defer = require_defer(), map$2 = require_map(), { promisify: promisify$1 } = require_util(), Client$3 = require_client(), Transaction$6 = require_transaction$3(), QueryBuilder$1 = require_mysql_querybuilder(), QueryCompiler$4 = require_mysql_querycompiler(), SchemaCompiler$3 = require_mysql_compiler(), TableCompiler$4 = require_mysql_tablecompiler(), ColumnCompiler$5 = require_mysql_columncompiler(), { makeEscape } = require_string(), ViewCompiler$3 = require_mysql_viewcompiler(), ViewBuilder$2 = require_mysql_viewbuilder();
  var Client_MySQL$1 = class extends Client$3 {
    _driver() {
      return __require$1(`mysql`);
    }
    queryBuilder() {
      return new QueryBuilder$1(this);
    }
    queryCompiler(builder, formatter) {
      return new QueryCompiler$4(this, builder, formatter);
    }
    schemaCompiler() {
      return new SchemaCompiler$3(this, ...arguments);
    }
    tableCompiler() {
      return new TableCompiler$4(this, ...arguments);
    }
    viewCompiler() {
      return new ViewCompiler$3(this, ...arguments);
    }
    viewBuilder() {
      return new ViewBuilder$2(this, ...arguments);
    }
    columnCompiler() {
      return new ColumnCompiler$5(this, ...arguments);
    }
    transaction() {
      return new Transaction$6(this, ...arguments);
    }
    wrapIdentifierImpl(value) {
      return value === `*` ? `*` : `\`${value.replace(/`/g, "``")}\``;
    }
    acquireRawConnection() {
      return new Promise((resolver, rejecter) => {
        let connection = this.driver.createConnection(this.connectionSettings);
        connection.on(`error`, (err$1) => {
          connection.__knex__disposed = err$1;
        }), connection.connect((err$1) => {
          if (err$1) return connection.removeAllListeners(), rejecter(err$1);
          resolver(connection);
        });
      });
    }
    async destroyRawConnection(connection) {
      try {
        let end = promisify$1((cb) => connection.end(cb));
        return await end();
      } catch (err$1) {
        connection.__knex__disposed = err$1;
      } finally {
        defer(() => connection.removeAllListeners());
      }
    }
    validateConnection(connection) {
      return connection.state === `connected` || connection.state === `authenticated`;
    }
    _stream(connection, obj, stream$1, options) {
      if (!obj.sql) throw Error(`The query is empty`);
      options ||= {};
      let queryOptions = Object.assign({ sql: obj.sql }, obj.options);
      return new Promise((resolver, rejecter) => {
        stream$1.on(`error`, rejecter), stream$1.on(`end`, resolver);
        let queryStream = connection.query(queryOptions, obj.bindings).stream(options);
        queryStream.on(`error`, (err$1) => {
          rejecter(err$1), stream$1.emit(`error`, err$1);
        }), queryStream.pipe(stream$1);
      });
    }
    _query(connection, obj) {
      if ((!obj || typeof obj == `string`) && (obj = { sql: obj }), !obj.sql) throw Error(`The query is empty`);
      return new Promise(function(resolver, rejecter) {
        if (!obj.sql) {
          resolver();
          return;
        }
        let queryOptions = Object.assign({ sql: obj.sql }, obj.options);
        connection.query(queryOptions, obj.bindings, function(err$1, rows, fields) {
          if (err$1) return rejecter(err$1);
          obj.response = [rows, fields], resolver(obj);
        });
      });
    }
    processResponse(obj, runner) {
      if (obj == null) return;
      let { response } = obj, { method: method$1 } = obj, rows = response[0], fields = response[1];
      if (obj.output) return obj.output.call(runner, rows, fields);
      switch (method$1) {
        case `select`:
          return rows;
        case `first`:
          return rows[0];
        case `pluck`:
          return map$2(rows, obj.pluck);
        case `insert`:
          return [rows.insertId];
        case `del`:
        case `update`:
        case `counter`:
          return rows.affectedRows;
        default:
          return response;
      }
    }
    async cancelQuery(connectionToKill) {
      let conn = await this.acquireRawConnection();
      try {
        return await this._wrappedCancelQueryCall(conn, connectionToKill);
      } finally {
        await this.destroyRawConnection(conn), conn.__knex__disposed && this.logger.warn(`Connection Error: ${conn.__knex__disposed}`);
      }
    }
    _wrappedCancelQueryCall(conn, connectionToKill) {
      return this._query(conn, { sql: `KILL QUERY ?`, bindings: [connectionToKill.threadId], options: {} });
    }
  };
  Object.assign(Client_MySQL$1.prototype, { dialect: `mysql`, driverName: `mysql`, _escapeBinding: makeEscape(), canCancelQuery: true }), module2.exports = Client_MySQL$1;
}), require_transaction$2 = __commonJSMin$1((exports$12, module2) => {
  let Transaction$5 = (init_transaction(), __toCommonJS(transaction_exports)), debug$5 = require_src()(`knex:tx`);
  var Transaction_MySQL2 = class extends Transaction$5 {
    query(conn, sql, status, value) {
      let t$7 = this, q = this.trxClient.query(conn, sql).catch((err$1) => {
        if (err$1.code === `ER_SP_DOES_NOT_EXIST`) {
          this.trxClient.logger.warn(`Transaction was implicitly committed, do not mix transactions and DDL with MySQL (#805)`);
          return;
        }
        status = 2, value = err$1, t$7._completed = true, debug$5(`%s error running transaction query`, t$7.txid);
      }).then(function(res) {
        if (status === 1 && t$7._resolver(value), status === 2) {
          if (value === void 0) {
            if (t$7.doNotRejectOnRollback && /^ROLLBACK\b/i.test(sql)) {
              t$7._resolver();
              return;
            }
            value = Error(`Transaction rejected with non-error: ${value}`);
          }
          return t$7._rejecter(value), res;
        }
      });
      return (status === 1 || status === 2) && (t$7._completed = true), q;
    }
  };
  module2.exports = Transaction_MySQL2;
}), require_mysql2 = __commonJSMin$1((exports$12, module2) => {
  init_dist();
  let Client_MySQL = require_mysql(), Transaction$4 = require_transaction$2();
  var Client_MySQL2 = class extends Client_MySQL {
    transaction() {
      return new Transaction$4(this, ...arguments);
    }
    _driver() {
      return __require$1(`mysql2`);
    }
    initializeDriver() {
      try {
        this.driver = this._driver();
      } catch (e$22) {
        let message = `Knex: run
$ npm install ${this.driverName}`, nodeMajorVersion = process$1.version.replace(/^v/, ``).split(`.`)[0];
        throw nodeMajorVersion <= 12 && (message += `@3.2.0`, this.logger.error(`Mysql2 version 3.2.0 is the latest version to support Node.js 12 or lower.`)), message += ` --save`, this.logger.error(`${message}
${e$22.message}
${e$22.stack}`), Error(`${message}
${e$22.message}`);
      }
    }
    validateConnection(connection) {
      return connection && !connection._fatalError && !connection._protocolError && !connection._closing && !connection.stream.destroyed;
    }
  };
  Object.assign(Client_MySQL2.prototype, { driverName: `mysql2` }), module2.exports = Client_MySQL2;
}), require_randombytes = __commonJSMin$1((exports$12, module2) => {
  module2.exports = require_crypto_browserify().randomBytes;
}), require_create_hash = __commonJSMin$1((exports$12, module2) => {
  module2.exports = require_crypto_browserify().createHash;
}), require_create_hmac = __commonJSMin$1((exports$12, module2) => {
  module2.exports = require_crypto_browserify().createHmac;
}), algorithms_exports = {};
__export(algorithms_exports, { DSA: () => DSA, default: () => algorithms_default, md5WithRSAEncryption: () => md5WithRSAEncryption, ripemd160WithRSA: () => ripemd160WithRSA, sha224: () => sha224, sha224WithRSAEncryption: () => sha224WithRSAEncryption, sha256: () => sha256, sha256WithRSAEncryption: () => sha256WithRSAEncryption, sha384: () => sha384, sha384WithRSAEncryption: () => sha384WithRSAEncryption, sha512: () => sha512, sha512WithRSAEncryption: () => sha512WithRSAEncryption });
var sha224WithRSAEncryption, sha256WithRSAEncryption, sha384WithRSAEncryption, sha512WithRSAEncryption, sha256, sha224, sha384, sha512, DSA, ripemd160WithRSA, md5WithRSAEncryption, algorithms_default, init_algorithms = __esmMin(() => {
  sha224WithRSAEncryption = { sign: `rsa`, hash: `sha224`, id: `302d300d06096086480165030402040500041c` }, sha256WithRSAEncryption = { sign: `rsa`, hash: `sha256`, id: `3031300d060960864801650304020105000420` }, sha384WithRSAEncryption = { sign: `rsa`, hash: `sha384`, id: `3041300d060960864801650304020205000430` }, sha512WithRSAEncryption = { sign: `rsa`, hash: `sha512`, id: `3051300d060960864801650304020305000440` }, sha256 = { sign: `ecdsa`, hash: `sha256`, id: `` }, sha224 = { sign: `ecdsa`, hash: `sha224`, id: `` }, sha384 = { sign: `ecdsa`, hash: `sha384`, id: `` }, sha512 = { sign: `ecdsa`, hash: `sha512`, id: `` }, DSA = { sign: `dsa`, hash: `sha1`, id: `` }, ripemd160WithRSA = { sign: `rsa`, hash: `rmd160`, id: `3021300906052b2403020105000414` }, md5WithRSAEncryption = { sign: `rsa`, hash: `md5`, id: `3020300c06082a864886f70d020505000410` }, algorithms_default = { sha224WithRSAEncryption, "RSA-SHA224": { sign: `ecdsa/rsa`, hash: `sha224`, id: `302d300d06096086480165030402040500041c` }, sha256WithRSAEncryption, "RSA-SHA256": { sign: `ecdsa/rsa`, hash: `sha256`, id: `3031300d060960864801650304020105000420` }, sha384WithRSAEncryption, "RSA-SHA384": { sign: `ecdsa/rsa`, hash: `sha384`, id: `3041300d060960864801650304020205000430` }, sha512WithRSAEncryption, "RSA-SHA512": { sign: `ecdsa/rsa`, hash: `sha512`, id: `3051300d060960864801650304020305000440` }, "RSA-SHA1": { sign: `rsa`, hash: `sha1`, id: `3021300906052b0e03021a05000414` }, "ecdsa-with-SHA1": { sign: `ecdsa`, hash: `sha1`, id: `` }, sha256, sha224, sha384, sha512, "DSA-SHA": { sign: `dsa`, hash: `sha1`, id: `` }, "DSA-SHA1": { sign: `dsa`, hash: `sha1`, id: `` }, DSA, "DSA-WITH-SHA224": { sign: `dsa`, hash: `sha224`, id: `` }, "DSA-SHA224": { sign: `dsa`, hash: `sha224`, id: `` }, "DSA-WITH-SHA256": { sign: `dsa`, hash: `sha256`, id: `` }, "DSA-SHA256": { sign: `dsa`, hash: `sha256`, id: `` }, "DSA-WITH-SHA384": { sign: `dsa`, hash: `sha384`, id: `` }, "DSA-SHA384": { sign: `dsa`, hash: `sha384`, id: `` }, "DSA-WITH-SHA512": { sign: `dsa`, hash: `sha512`, id: `` }, "DSA-SHA512": { sign: `dsa`, hash: `sha512`, id: `` }, "DSA-RIPEMD160": { sign: `dsa`, hash: `rmd160`, id: `` }, ripemd160WithRSA, "RSA-RIPEMD160": { sign: `rsa`, hash: `rmd160`, id: `3021300906052b2403020105000414` }, md5WithRSAEncryption, "RSA-MD5": { sign: `rsa`, hash: `md5`, id: `3020300c06082a864886f70d020505000410` } };
}), require_algos = __commonJSMin$1((exports$12, module2) => {
  module2.exports = (init_algorithms(), __toCommonJS(algorithms_exports).default);
}), require_precondition = __commonJSMin$1((exports$12, module2) => {
  var MAX_ALLOC = 2 ** 30 - 1;
  module2.exports = function(iterations, keylen) {
    if (typeof iterations != `number`) throw TypeError(`Iterations not a number`);
    if (iterations < 0) throw TypeError(`Bad iterations`);
    if (typeof keylen != `number`) throw TypeError(`Key length not a number`);
    if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) throw TypeError(`Bad key length`);
  };
}), require_default_encoding = __commonJSMin$1((exports$12, module2) => {
  init_dist();
  var defaultEncoding$3;
  if ({}.process && {}.process.browser) defaultEncoding$3 = `utf-8`;
  else if ({}.process && {}.process.version) {
    var pVersionMajor = parseInt(process$1.version.split(`.`)[0].slice(1), 10);
    defaultEncoding$3 = pVersionMajor >= 6 ? `utf-8` : `binary`;
  } else defaultEncoding$3 = `utf-8`;
  module2.exports = defaultEncoding$3;
}), require_isarray = __commonJSMin$1((exports$12, module2) => {
  var toString = {}.toString;
  module2.exports = Array.isArray || function(arr) {
    return toString.call(arr) == `[object Array]`;
  };
}), require_typed_array_buffer = __commonJSMin$1((exports$12, module2) => {
  var $TypeError = require_type(), callBound = require_call_bound(), $typedArrayBuffer = callBound(`TypedArray.prototype.buffer`, true), isTypedArray2 = require_is_typed_array();
  module2.exports = $typedArrayBuffer || function(x$1) {
    if (!isTypedArray2(x$1)) throw new $TypeError(`Not a Typed Array`);
    return x$1.buffer;
  };
}), require_to_buffer$1 = __commonJSMin$1((exports$12, module2) => {
  var Buffer$19 = require_safe_buffer().Buffer, isArray$1 = require_isarray(), typedArrayBuffer = require_typed_array_buffer(), isView$1 = ArrayBuffer.isView || function(obj) {
    try {
      return typedArrayBuffer(obj), true;
    } catch {
      return false;
    }
  }, useUint8Array$2 = typeof Uint8Array < `u`, useArrayBuffer$2 = typeof ArrayBuffer < `u` && typeof Uint8Array < `u`, useFromArrayBuffer = useArrayBuffer$2 && (Buffer$19.prototype instanceof Uint8Array || Buffer$19.TYPED_ARRAY_SUPPORT);
  module2.exports = function(data, encoding) {
    if (data instanceof Buffer$19) return data;
    if (typeof data == `string`) return Buffer$19.from(data, encoding);
    if (useArrayBuffer$2 && isView$1(data)) {
      if (data.byteLength === 0) return Buffer$19.alloc(0);
      if (useFromArrayBuffer) {
        var res = Buffer$19.from(data.buffer, data.byteOffset, data.byteLength);
        if (res.byteLength === data.byteLength) return res;
      }
      var uint8 = data instanceof Uint8Array ? data : new Uint8Array(data.buffer, data.byteOffset, data.byteLength), result = Buffer$19.from(uint8);
      if (result.length === data.byteLength) return result;
    }
    if (useUint8Array$2 && data instanceof Uint8Array) return Buffer$19.from(data);
    var isArr = isArray$1(data);
    if (isArr) for (var i$4 = 0; i$4 < data.length; i$4 += 1) {
      var x$1 = data[i$4];
      if (typeof x$1 != `number` || x$1 < 0 || x$1 > 255 || ~~x$1 !== x$1) throw RangeError(`Array items must be numbers in the range 0-255.`);
    }
    if (isArr || Buffer$19.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer == `function` && data.constructor.isBuffer(data)) return Buffer$19.from(data);
    throw TypeError(`The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.`);
  };
}), require_to_buffer = __commonJSMin$1((exports$12, module2) => {
  var Buffer$18 = require_safe_buffer().Buffer, toBuffer$4 = require_to_buffer$1(), useUint8Array$1 = typeof Uint8Array < `u`, useArrayBuffer$1 = useUint8Array$1 && typeof ArrayBuffer < `u`, isView = useArrayBuffer$1 && ArrayBuffer.isView;
  module2.exports = function(thing, encoding, name$2) {
    if (typeof thing == `string` || Buffer$18.isBuffer(thing) || useUint8Array$1 && thing instanceof Uint8Array || isView && isView(thing)) return toBuffer$4(thing, encoding);
    throw TypeError(name$2 + ` must be a string, a Buffer, a Uint8Array, or a DataView`);
  };
}), require_sync = __commonJSMin$1((exports$12, module2) => {
  var sizes = { __proto__: null, md5: 16, sha1: 20, sha224: 28, sha256: 32, sha384: 48, sha512: 64, "sha512-256": 32, rmd160: 20, ripemd160: 20 }, mapping = { __proto__: null, "sha-1": `sha1`, "sha-224": `sha224`, "sha-256": `sha256`, "sha-384": `sha384`, "sha-512": `sha512`, "ripemd-160": `ripemd160` }, createHmac = require_create_hmac(), Buffer$17 = require_safe_buffer().Buffer, checkParameters$2 = require_precondition(), defaultEncoding$2 = require_default_encoding(), toBuffer$3 = require_to_buffer();
  function pbkdf2(password, salt, iterations, keylen, digest) {
    checkParameters$2(iterations, keylen), password = toBuffer$3(password, defaultEncoding$2, `Password`), salt = toBuffer$3(salt, defaultEncoding$2, `Salt`);
    var lowerDigest = (digest || `sha1`).toLowerCase(), mappedDigest = mapping[lowerDigest] || lowerDigest, size = sizes[mappedDigest];
    if (typeof size != `number` || !size) throw TypeError(`Digest algorithm not supported: ` + digest);
    var DK = Buffer$17.allocUnsafe(keylen), block1 = Buffer$17.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    for (var destPos = 0, hLen = size, l$4 = Math.ceil(keylen / hLen), i$4 = 1; i$4 <= l$4; i$4++) {
      block1.writeUInt32BE(i$4, salt.length);
      for (var T = createHmac(mappedDigest, password).update(block1).digest(), U = T, j$1 = 1; j$1 < iterations; j$1++) {
        U = createHmac(mappedDigest, password).update(U).digest();
        for (var k = 0; k < hLen; k++) T[k] ^= U[k];
      }
      T.copy(DK, destPos), destPos += hLen;
    }
    return DK;
  }
  module2.exports = pbkdf2;
}), require_async = __commonJSMin$1((exports$12, module2) => {
  var Buffer$16 = require_safe_buffer().Buffer, checkParameters$1 = require_precondition(), defaultEncoding$1 = require_default_encoding(), sync = require_sync(), toBuffer$2 = require_to_buffer(), ZERO_BUF, subtle = {}.crypto && {}.crypto.subtle, toBrowser = { sha: `SHA-1`, "sha-1": `SHA-1`, sha1: `SHA-1`, sha256: `SHA-256`, "sha-256": `SHA-256`, sha384: `SHA-384`, "sha-384": `SHA-384`, "sha-512": `SHA-512`, sha512: `SHA-512` }, checks = [], nextTick;
  function getNextTick() {
    return nextTick || (nextTick = {}.process && {}.process.nextTick ? {}.process.nextTick : {}.queueMicrotask ? {}.queueMicrotask : {}.setImmediate ? {}.setImmediate : {}.setTimeout, nextTick);
  }
  function browserPbkdf2(password, salt, iterations, length, algo) {
    return subtle.importKey(`raw`, password, { name: `PBKDF2` }, false, [`deriveBits`]).then(function(key) {
      return subtle.deriveBits({ name: `PBKDF2`, salt, iterations, hash: { name: algo } }, key, length << 3);
    }).then(function(res) {
      return Buffer$16.from(res);
    });
  }
  function checkNative(algo) {
    if ({}.process && !{}.process.browser || !subtle || !subtle.importKey || !subtle.deriveBits) return Promise.resolve(false);
    if (checks[algo] !== void 0) return checks[algo];
    ZERO_BUF ||= Buffer$16.alloc(8);
    var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo).then(function() {
      return true;
    }, function() {
      return false;
    });
    return checks[algo] = prom, prom;
  }
  function resolvePromise(promise, callback) {
    promise.then(function(out) {
      getNextTick()(function() {
        callback(null, out);
      });
    }, function(e$22) {
      getNextTick()(function() {
        callback(e$22);
      });
    });
  }
  module2.exports = function(password, salt, iterations, keylen, digest, callback) {
    typeof digest == `function` && (callback = digest, digest = void 0), digest ||= `sha1`;
    var algo = toBrowser[digest.toLowerCase()];
    if (!algo || typeof {}.Promise != `function`) {
      getNextTick()(function() {
        var out;
        try {
          out = sync(password, salt, iterations, keylen, digest);
        } catch (e$22) {
          callback(e$22);
          return;
        }
        callback(null, out);
      });
      return;
    }
    if (checkParameters$1(iterations, keylen), password = toBuffer$2(password, defaultEncoding$1, `Password`), salt = toBuffer$2(salt, defaultEncoding$1, `Salt`), typeof callback != `function`) throw Error(`No callback provided to pbkdf2`);
    resolvePromise(checkNative(algo).then(function(resp) {
      return resp ? browserPbkdf2(password, salt, iterations, keylen, algo) : sync(password, salt, iterations, keylen, digest);
    }), callback);
  };
}), require_pbkdf2 = __commonJSMin$1((exports$12) => {
  var nativeImpl = require_crypto_browserify(), checkParameters = require_precondition(), defaultEncoding = require_default_encoding(), toBuffer$1 = require_to_buffer();
  function nativePBKDF2(password, salt, iterations, keylen, digest, callback) {
    if (checkParameters(iterations, keylen), password = toBuffer$1(password, defaultEncoding, `Password`), salt = toBuffer$1(salt, defaultEncoding, `Salt`), typeof digest == `function` && (callback = digest, digest = `sha1`), typeof callback != `function`) throw Error(`No callback provided to pbkdf2`);
    return nativeImpl.pbkdf2(password, salt, iterations, keylen, digest, callback);
  }
  function nativePBKDF2Sync(password, salt, iterations, keylen, digest) {
    return checkParameters(iterations, keylen), password = toBuffer$1(password, defaultEncoding, `Password`), salt = toBuffer$1(salt, defaultEncoding, `Salt`), digest ||= `sha1`, nativeImpl.pbkdf2Sync(password, salt, iterations, keylen, digest);
  }
  !nativeImpl.pbkdf2Sync || nativeImpl.pbkdf2Sync.toString().indexOf(`keylen, digest`) === -1 ? (exports$12.pbkdf2Sync = require_sync(), exports$12.pbkdf2 = require_async()) : (exports$12.pbkdf2Sync = nativePBKDF2Sync, exports$12.pbkdf2 = nativePBKDF2);
}), require_browserify_cipher = __commonJSMin$1((exports$12) => {
  var crypto$7 = require_crypto_browserify();
  exports$12.createCipher = exports$12.Cipher = crypto$7.createCipher, exports$12.createCipheriv = exports$12.Cipheriv = crypto$7.createCipheriv, exports$12.createDecipher = exports$12.Decipher = crypto$7.createDecipher, exports$12.createDecipheriv = exports$12.Decipheriv = crypto$7.createDecipheriv, exports$12.listCiphers = exports$12.getCiphers = crypto$7.getCiphers;
}), require_diffie_hellman = __commonJSMin$1((exports$12) => {
  var crypto$6 = require_crypto_browserify();
  exports$12.DiffieHellmanGroup = crypto$6.DiffieHellmanGroup, exports$12.createDiffieHellmanGroup = crypto$6.createDiffieHellmanGroup, exports$12.getDiffieHellman = crypto$6.getDiffieHellman, exports$12.createDiffieHellman = crypto$6.createDiffieHellman, exports$12.DiffieHellman = crypto$6.DiffieHellman;
}), require_browserify_sign = __commonJSMin$1((exports$12) => {
  var crypto$5 = require_crypto_browserify();
  exports$12.createSign = crypto$5.createSign, exports$12.Sign = crypto$5.Sign, exports$12.createVerify = crypto$5.createVerify, exports$12.Verify = crypto$5.Verify;
}), package_exports = {};
__export(package_exports, { author: () => author, bugs: () => bugs, default: () => package_default, dependencies: () => dependencies, description: () => description, devDependencies: () => devDependencies, files: () => files, homepage: () => homepage, keywords: () => keywords, license: () => license, main: () => main, name: () => name, repository: () => repository, scripts: () => scripts, version: () => version$2 });
var name, version$2, description, main, files, scripts, repository, keywords, author, license, bugs, homepage, devDependencies, dependencies, package_default, init_package = __esmMin(() => {
  name = `elliptic`, version$2 = `6.6.1`, description = `EC cryptography`, main = `lib/elliptic.js`, files = [`lib`], scripts = { lint: `eslint lib test`, "lint:fix": `npm run lint -- --fix`, unit: `istanbul test _mocha --reporter=spec test/index.js`, test: `npm run lint && npm run unit`, version: `grunt dist && git add dist/` }, repository = { type: `git`, url: `git@github.com:indutny/elliptic` }, keywords = [`EC`, `Elliptic`, `curve`, `Cryptography`], author = `Fedor Indutny <fedor@indutny.com>`, license = `MIT`, bugs = { url: `https://github.com/indutny/elliptic/issues` }, homepage = `https://github.com/indutny/elliptic`, devDependencies = { brfs: `^2.0.2`, coveralls: `^3.1.0`, eslint: `^7.6.0`, grunt: `^1.2.1`, "grunt-browserify": `^5.3.0`, "grunt-cli": `^1.3.2`, "grunt-contrib-connect": `^3.0.0`, "grunt-contrib-copy": `^1.0.0`, "grunt-contrib-uglify": `^5.0.0`, "grunt-mocha-istanbul": `^5.0.2`, "grunt-saucelabs": `^9.0.1`, istanbul: `^0.4.5`, mocha: `^8.0.1` }, dependencies = { "bn.js": `^4.11.9`, brorand: `^1.1.0`, "hash.js": `^1.0.0`, "hmac-drbg": `^1.0.1`, inherits: `^2.0.4`, "minimalistic-assert": `^1.0.1`, "minimalistic-crypto-utils": `^1.0.1` }, package_default = { name, version: version$2, description, main, files, scripts, repository, keywords, author, license, bugs, homepage, devDependencies, dependencies };
}), require_bn$1 = __commonJSMin$1((exports$12, module2) => {
  (function(module$12, exports$13) {
    function assert$54(val, msg) {
      if (!val) throw Error(msg || `Assertion failed`);
    }
    function inherits$14(ctor, superCtor) {
      ctor.super_ = superCtor;
      var TempCtor = function() {
      };
      TempCtor.prototype = superCtor.prototype, ctor.prototype = new TempCtor(), ctor.prototype.constructor = ctor;
    }
    function BN$14(number, base$3, endian) {
      if (BN$14.isBN(number)) return number;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, number !== null && ((base$3 === `le` || base$3 === `be`) && (endian = base$3, base$3 = 10), this._init(number || 0, base$3 || 10, endian || `be`));
    }
    typeof module$12 == `object` ? module$12.exports = BN$14 : exports$13.BN = BN$14, BN$14.BN = BN$14, BN$14.wordSize = 26;
    var Buffer$27;
    try {
      Buffer$27 = typeof window < `u` && window.Buffer !== void 0 ? window.Buffer : (init_dist$1(), __toCommonJS(dist_exports)).Buffer;
    } catch {
    }
    BN$14.isBN = function(num) {
      return num instanceof BN$14 ? true : typeof num == `object` && !!num && num.constructor.wordSize === BN$14.wordSize && Array.isArray(num.words);
    }, BN$14.max = function(left, right) {
      return left.cmp(right) > 0 ? left : right;
    }, BN$14.min = function(left, right) {
      return left.cmp(right) < 0 ? left : right;
    }, BN$14.prototype._init = function(number, base$3, endian) {
      if (typeof number == `number`) return this._initNumber(number, base$3, endian);
      if (typeof number == `object`) return this._initArray(number, base$3, endian);
      base$3 === `hex` && (base$3 = 16), assert$54(base$3 === (base$3 | 0) && base$3 >= 2 && base$3 <= 36), number = number.toString().replace(/\s+/g, ``);
      var start = 0;
      number[0] === `-` && (start++, this.negative = 1), start < number.length && (base$3 === 16 ? this._parseHex(number, start, endian) : (this._parseBase(number, base$3, start), endian === `le` && this._initArray(this.toArray(), base$3, endian)));
    }, BN$14.prototype._initNumber = function(number, base$3, endian) {
      number < 0 && (this.negative = 1, number = -number), number < 67108864 ? (this.words = [number & 67108863], this.length = 1) : number < 4503599627370496 ? (this.words = [number & 67108863, number / 67108864 & 67108863], this.length = 2) : (assert$54(number < 9007199254740992), this.words = [number & 67108863, number / 67108864 & 67108863, 1], this.length = 3), endian === `le` && this._initArray(this.toArray(), base$3, endian);
    }, BN$14.prototype._initArray = function(number, base$3, endian) {
      if (assert$54(typeof number.length == `number`), number.length <= 0) return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(number.length / 3), this.words = Array(this.length);
      for (var i$4 = 0; i$4 < this.length; i$4++) this.words[i$4] = 0;
      var j$1, w$1, off = 0;
      if (endian === `be`) for (i$4 = number.length - 1, j$1 = 0; i$4 >= 0; i$4 -= 3) w$1 = number[i$4] | number[i$4 - 1] << 8 | number[i$4 - 2] << 16, this.words[j$1] |= w$1 << off & 67108863, this.words[j$1 + 1] = w$1 >>> 26 - off & 67108863, off += 24, off >= 26 && (off -= 26, j$1++);
      else if (endian === `le`) for (i$4 = 0, j$1 = 0; i$4 < number.length; i$4 += 3) w$1 = number[i$4] | number[i$4 + 1] << 8 | number[i$4 + 2] << 16, this.words[j$1] |= w$1 << off & 67108863, this.words[j$1 + 1] = w$1 >>> 26 - off & 67108863, off += 24, off >= 26 && (off -= 26, j$1++);
      return this.strip();
    };
    function parseHex4Bits(string, index$2) {
      var c$12 = string.charCodeAt(index$2);
      return c$12 >= 65 && c$12 <= 70 ? c$12 - 55 : c$12 >= 97 && c$12 <= 102 ? c$12 - 87 : c$12 - 48 & 15;
    }
    function parseHexByte(string, lowerBound, index$2) {
      var r$2 = parseHex4Bits(string, index$2);
      return index$2 - 1 >= lowerBound && (r$2 |= parseHex4Bits(string, index$2 - 1) << 4), r$2;
    }
    BN$14.prototype._parseHex = function(number, start, endian) {
      this.length = Math.ceil((number.length - start) / 6), this.words = Array(this.length);
      for (var i$4 = 0; i$4 < this.length; i$4++) this.words[i$4] = 0;
      var off = 0, j$1 = 0, w$1;
      if (endian === `be`) for (i$4 = number.length - 1; i$4 >= start; i$4 -= 2) w$1 = parseHexByte(number, start, i$4) << off, this.words[j$1] |= w$1 & 67108863, off >= 18 ? (off -= 18, j$1 += 1, this.words[j$1] |= w$1 >>> 26) : off += 8;
      else {
        var parseLength = number.length - start;
        for (i$4 = parseLength % 2 == 0 ? start + 1 : start; i$4 < number.length; i$4 += 2) w$1 = parseHexByte(number, start, i$4) << off, this.words[j$1] |= w$1 & 67108863, off >= 18 ? (off -= 18, j$1 += 1, this.words[j$1] |= w$1 >>> 26) : off += 8;
      }
      this.strip();
    };
    function parseBase(str, start, end, mul) {
      for (var r$2 = 0, len$2 = Math.min(str.length, end), i$4 = start; i$4 < len$2; i$4++) {
        var c$12 = str.charCodeAt(i$4) - 48;
        r$2 *= mul, c$12 >= 49 ? r$2 += c$12 - 49 + 10 : c$12 >= 17 ? r$2 += c$12 - 17 + 10 : r$2 += c$12;
      }
      return r$2;
    }
    BN$14.prototype._parseBase = function(number, base$3, start) {
      this.words = [0], this.length = 1;
      for (var limbLen = 0, limbPow = 1; limbPow <= 67108863; limbPow *= base$3) limbLen++;
      limbLen--, limbPow = limbPow / base$3 | 0;
      for (var total = number.length - start, mod = total % limbLen, end = Math.min(total, total - mod) + start, word = 0, i$4 = start; i$4 < end; i$4 += limbLen) word = parseBase(number, i$4, i$4 + limbLen, base$3), this.imuln(limbPow), this.words[0] + word < 67108864 ? this.words[0] += word : this._iaddn(word);
      if (mod !== 0) {
        var pow$1 = 1;
        for (word = parseBase(number, i$4, number.length, base$3), i$4 = 0; i$4 < mod; i$4++) pow$1 *= base$3;
        this.imuln(pow$1), this.words[0] + word < 67108864 ? this.words[0] += word : this._iaddn(word);
      }
      this.strip();
    }, BN$14.prototype.copy = function(dest) {
      dest.words = Array(this.length);
      for (var i$4 = 0; i$4 < this.length; i$4++) dest.words[i$4] = this.words[i$4];
      dest.length = this.length, dest.negative = this.negative, dest.red = this.red;
    }, BN$14.prototype.clone = function() {
      var r$2 = new BN$14(null);
      return this.copy(r$2), r$2;
    }, BN$14.prototype._expand = function(size) {
      for (; this.length < size; ) this.words[this.length++] = 0;
      return this;
    }, BN$14.prototype.strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; ) this.length--;
      return this._normSign();
    }, BN$14.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, BN$14.prototype.inspect = function() {
      return (this.red ? `<BN-R: ` : `<BN: `) + this.toString(16) + `>`;
    };
    var zeros = `.0.00.000.0000.00000.000000.0000000.00000000.000000000.0000000000.00000000000.000000000000.0000000000000.00000000000000.000000000000000.0000000000000000.00000000000000000.000000000000000000.0000000000000000000.00000000000000000000.000000000000000000000.0000000000000000000000.00000000000000000000000.000000000000000000000000.0000000000000000000000000`.split(`.`), groupSizes = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5], groupBases = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];
    BN$14.prototype.toString = function(base$3, padding) {
      base$3 ||= 10, padding = padding | 0 || 1;
      var out;
      if (base$3 === 16 || base$3 === `hex`) {
        out = ``;
        for (var off = 0, carry = 0, i$4 = 0; i$4 < this.length; i$4++) {
          var w$1 = this.words[i$4], word = ((w$1 << off | carry) & 16777215).toString(16);
          carry = w$1 >>> 24 - off & 16777215, off += 2, off >= 26 && (off -= 26, i$4--), out = carry !== 0 || i$4 !== this.length - 1 ? zeros[6 - word.length] + word + out : word + out;
        }
        for (carry !== 0 && (out = carry.toString(16) + out); out.length % padding !== 0; ) out = `0` + out;
        return this.negative !== 0 && (out = `-` + out), out;
      }
      if (base$3 === (base$3 | 0) && base$3 >= 2 && base$3 <= 36) {
        var groupSize = groupSizes[base$3], groupBase = groupBases[base$3];
        out = ``;
        var c$12 = this.clone();
        for (c$12.negative = 0; !c$12.isZero(); ) {
          var r$2 = c$12.modn(groupBase).toString(base$3);
          c$12 = c$12.idivn(groupBase), out = c$12.isZero() ? r$2 + out : zeros[groupSize - r$2.length] + r$2 + out;
        }
        for (this.isZero() && (out = `0` + out); out.length % padding !== 0; ) out = `0` + out;
        return this.negative !== 0 && (out = `-` + out), out;
      }
      assert$54(false, `Base should be between 2 and 36`);
    }, BN$14.prototype.toNumber = function() {
      var ret = this.words[0];
      return this.length === 2 ? ret += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? ret += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && assert$54(false, `Number can only safely store up to 53 bits`), this.negative === 0 ? ret : -ret;
    }, BN$14.prototype.toJSON = function() {
      return this.toString(16);
    }, BN$14.prototype.toBuffer = function(endian, length) {
      return assert$54(Buffer$27 !== void 0), this.toArrayLike(Buffer$27, endian, length);
    }, BN$14.prototype.toArray = function(endian, length) {
      return this.toArrayLike(Array, endian, length);
    }, BN$14.prototype.toArrayLike = function(ArrayType, endian, length) {
      var byteLength$2 = this.byteLength(), reqLength = length || Math.max(1, byteLength$2);
      assert$54(byteLength$2 <= reqLength, `byte array longer than desired length`), assert$54(reqLength > 0, `Requested array length <= 0`), this.strip();
      var littleEndian = endian === `le`, res = new ArrayType(reqLength), b2, i$4, q = this.clone();
      if (littleEndian) {
        for (i$4 = 0; !q.isZero(); i$4++) b2 = q.andln(255), q.iushrn(8), res[i$4] = b2;
        for (; i$4 < reqLength; i$4++) res[i$4] = 0;
      } else {
        for (i$4 = 0; i$4 < reqLength - byteLength$2; i$4++) res[i$4] = 0;
        for (i$4 = 0; !q.isZero(); i$4++) b2 = q.andln(255), q.iushrn(8), res[reqLength - i$4 - 1] = b2;
      }
      return res;
    }, Math.clz32 ? BN$14.prototype._countBits = function(w$1) {
      return 32 - Math.clz32(w$1);
    } : BN$14.prototype._countBits = function(w$1) {
      var t$7 = w$1, r$2 = 0;
      return t$7 >= 4096 && (r$2 += 13, t$7 >>>= 13), t$7 >= 64 && (r$2 += 7, t$7 >>>= 7), t$7 >= 8 && (r$2 += 4, t$7 >>>= 4), t$7 >= 2 && (r$2 += 2, t$7 >>>= 2), r$2 + t$7;
    }, BN$14.prototype._zeroBits = function(w$1) {
      if (w$1 === 0) return 26;
      var t$7 = w$1, r$2 = 0;
      return t$7 & 8191 || (r$2 += 13, t$7 >>>= 13), t$7 & 127 || (r$2 += 7, t$7 >>>= 7), t$7 & 15 || (r$2 += 4, t$7 >>>= 4), t$7 & 3 || (r$2 += 2, t$7 >>>= 2), t$7 & 1 || r$2++, r$2;
    }, BN$14.prototype.bitLength = function() {
      var w$1 = this.words[this.length - 1], hi = this._countBits(w$1);
      return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
      for (var w$1 = Array(num.bitLength()), bit = 0; bit < w$1.length; bit++) {
        var off = bit / 26 | 0, wbit = bit % 26;
        w$1[bit] = (num.words[off] & 1 << wbit) >>> wbit;
      }
      return w$1;
    }
    BN$14.prototype.zeroBits = function() {
      if (this.isZero()) return 0;
      for (var r$2 = 0, i$4 = 0; i$4 < this.length; i$4++) {
        var b2 = this._zeroBits(this.words[i$4]);
        if (r$2 += b2, b2 !== 26) break;
      }
      return r$2;
    }, BN$14.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, BN$14.prototype.toTwos = function(width) {
      return this.negative === 0 ? this.clone() : this.abs().inotn(width).iaddn(1);
    }, BN$14.prototype.fromTwos = function(width) {
      return this.testn(width - 1) ? this.notn(width).iaddn(1).ineg() : this.clone();
    }, BN$14.prototype.isNeg = function() {
      return this.negative !== 0;
    }, BN$14.prototype.neg = function() {
      return this.clone().ineg();
    }, BN$14.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, BN$14.prototype.iuor = function(num) {
      for (; this.length < num.length; ) this.words[this.length++] = 0;
      for (var i$4 = 0; i$4 < num.length; i$4++) this.words[i$4] = this.words[i$4] | num.words[i$4];
      return this.strip();
    }, BN$14.prototype.ior = function(num) {
      return assert$54((this.negative | num.negative) === 0), this.iuor(num);
    }, BN$14.prototype.or = function(num) {
      return this.length > num.length ? this.clone().ior(num) : num.clone().ior(this);
    }, BN$14.prototype.uor = function(num) {
      return this.length > num.length ? this.clone().iuor(num) : num.clone().iuor(this);
    }, BN$14.prototype.iuand = function(num) {
      var b2;
      b2 = this.length > num.length ? num : this;
      for (var i$4 = 0; i$4 < b2.length; i$4++) this.words[i$4] = this.words[i$4] & num.words[i$4];
      return this.length = b2.length, this.strip();
    }, BN$14.prototype.iand = function(num) {
      return assert$54((this.negative | num.negative) === 0), this.iuand(num);
    }, BN$14.prototype.and = function(num) {
      return this.length > num.length ? this.clone().iand(num) : num.clone().iand(this);
    }, BN$14.prototype.uand = function(num) {
      return this.length > num.length ? this.clone().iuand(num) : num.clone().iuand(this);
    }, BN$14.prototype.iuxor = function(num) {
      var a$22, b2;
      this.length > num.length ? (a$22 = this, b2 = num) : (a$22 = num, b2 = this);
      for (var i$4 = 0; i$4 < b2.length; i$4++) this.words[i$4] = a$22.words[i$4] ^ b2.words[i$4];
      if (this !== a$22) for (; i$4 < a$22.length; i$4++) this.words[i$4] = a$22.words[i$4];
      return this.length = a$22.length, this.strip();
    }, BN$14.prototype.ixor = function(num) {
      return assert$54((this.negative | num.negative) === 0), this.iuxor(num);
    }, BN$14.prototype.xor = function(num) {
      return this.length > num.length ? this.clone().ixor(num) : num.clone().ixor(this);
    }, BN$14.prototype.uxor = function(num) {
      return this.length > num.length ? this.clone().iuxor(num) : num.clone().iuxor(this);
    }, BN$14.prototype.inotn = function(width) {
      assert$54(typeof width == `number` && width >= 0);
      var bytesNeeded = Math.ceil(width / 26) | 0, bitsLeft = width % 26;
      this._expand(bytesNeeded), bitsLeft > 0 && bytesNeeded--;
      for (var i$4 = 0; i$4 < bytesNeeded; i$4++) this.words[i$4] = ~this.words[i$4] & 67108863;
      return bitsLeft > 0 && (this.words[i$4] = ~this.words[i$4] & 67108863 >> 26 - bitsLeft), this.strip();
    }, BN$14.prototype.notn = function(width) {
      return this.clone().inotn(width);
    }, BN$14.prototype.setn = function(bit, val) {
      assert$54(typeof bit == `number` && bit >= 0);
      var off = bit / 26 | 0, wbit = bit % 26;
      return this._expand(off + 1), val ? this.words[off] = this.words[off] | 1 << wbit : this.words[off] = this.words[off] & ~(1 << wbit), this.strip();
    }, BN$14.prototype.iadd = function(num) {
      var r$2;
      if (this.negative !== 0 && num.negative === 0) return this.negative = 0, r$2 = this.isub(num), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && num.negative !== 0) return num.negative = 0, r$2 = this.isub(num), num.negative = 1, r$2._normSign();
      var a$22, b2;
      this.length > num.length ? (a$22 = this, b2 = num) : (a$22 = num, b2 = this);
      for (var carry = 0, i$4 = 0; i$4 < b2.length; i$4++) r$2 = (a$22.words[i$4] | 0) + (b2.words[i$4] | 0) + carry, this.words[i$4] = r$2 & 67108863, carry = r$2 >>> 26;
      for (; carry !== 0 && i$4 < a$22.length; i$4++) r$2 = (a$22.words[i$4] | 0) + carry, this.words[i$4] = r$2 & 67108863, carry = r$2 >>> 26;
      if (this.length = a$22.length, carry !== 0) this.words[this.length] = carry, this.length++;
      else if (a$22 !== this) for (; i$4 < a$22.length; i$4++) this.words[i$4] = a$22.words[i$4];
      return this;
    }, BN$14.prototype.add = function(num) {
      var res;
      return num.negative !== 0 && this.negative === 0 ? (num.negative = 0, res = this.sub(num), num.negative ^= 1, res) : num.negative === 0 && this.negative !== 0 ? (this.negative = 0, res = num.sub(this), this.negative = 1, res) : this.length > num.length ? this.clone().iadd(num) : num.clone().iadd(this);
    }, BN$14.prototype.isub = function(num) {
      if (num.negative !== 0) {
        num.negative = 0;
        var r$2 = this.iadd(num);
        return num.negative = 1, r$2._normSign();
      } else if (this.negative !== 0) return this.negative = 0, this.iadd(num), this.negative = 1, this._normSign();
      var cmp$3 = this.cmp(num);
      if (cmp$3 === 0) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var a$22, b2;
      cmp$3 > 0 ? (a$22 = this, b2 = num) : (a$22 = num, b2 = this);
      for (var carry = 0, i$4 = 0; i$4 < b2.length; i$4++) r$2 = (a$22.words[i$4] | 0) - (b2.words[i$4] | 0) + carry, carry = r$2 >> 26, this.words[i$4] = r$2 & 67108863;
      for (; carry !== 0 && i$4 < a$22.length; i$4++) r$2 = (a$22.words[i$4] | 0) + carry, carry = r$2 >> 26, this.words[i$4] = r$2 & 67108863;
      if (carry === 0 && i$4 < a$22.length && a$22 !== this) for (; i$4 < a$22.length; i$4++) this.words[i$4] = a$22.words[i$4];
      return this.length = Math.max(this.length, i$4), a$22 !== this && (this.negative = 1), this.strip();
    }, BN$14.prototype.sub = function(num) {
      return this.clone().isub(num);
    };
    function smallMulTo(self$1, num, out) {
      out.negative = num.negative ^ self$1.negative;
      var len$2 = self$1.length + num.length | 0;
      out.length = len$2, len$2 = len$2 - 1 | 0;
      var a$22 = self$1.words[0] | 0, b2 = num.words[0] | 0, r$2 = a$22 * b2, lo = r$2 & 67108863, carry = r$2 / 67108864 | 0;
      out.words[0] = lo;
      for (var k = 1; k < len$2; k++) {
        for (var ncarry = carry >>> 26, rword = carry & 67108863, maxJ = Math.min(k, num.length - 1), j$1 = Math.max(0, k - self$1.length + 1); j$1 <= maxJ; j$1++) {
          var i$4 = k - j$1 | 0;
          a$22 = self$1.words[i$4] | 0, b2 = num.words[j$1] | 0, r$2 = a$22 * b2 + rword, ncarry += r$2 / 67108864 | 0, rword = r$2 & 67108863;
        }
        out.words[k] = rword | 0, carry = ncarry | 0;
      }
      return carry === 0 ? out.length-- : out.words[k] = carry | 0, out.strip();
    }
    var comb10MulTo = function(self$1, num, out) {
      var a$22 = self$1.words, b2 = num.words, o$2 = out.words, c$12 = 0, lo, mid, hi, a0 = a$22[0] | 0, al0 = a0 & 8191, ah0 = a0 >>> 13, a1 = a$22[1] | 0, al1 = a1 & 8191, ah1 = a1 >>> 13, a2 = a$22[2] | 0, al2 = a2 & 8191, ah2 = a2 >>> 13, a3 = a$22[3] | 0, al3 = a3 & 8191, ah3 = a3 >>> 13, a4 = a$22[4] | 0, al4 = a4 & 8191, ah4 = a4 >>> 13, a5 = a$22[5] | 0, al5 = a5 & 8191, ah5 = a5 >>> 13, a6 = a$22[6] | 0, al6 = a6 & 8191, ah6 = a6 >>> 13, a7 = a$22[7] | 0, al7 = a7 & 8191, ah7 = a7 >>> 13, a8 = a$22[8] | 0, al8 = a8 & 8191, ah8 = a8 >>> 13, a9 = a$22[9] | 0, al9 = a9 & 8191, ah9 = a9 >>> 13, b0 = b2[0] | 0, bl0 = b0 & 8191, bh0 = b0 >>> 13, b1 = b2[1] | 0, bl1 = b1 & 8191, bh1 = b1 >>> 13, b22 = b2[2] | 0, bl2 = b22 & 8191, bh2 = b22 >>> 13, b3 = b2[3] | 0, bl3 = b3 & 8191, bh3 = b3 >>> 13, b4 = b2[4] | 0, bl4 = b4 & 8191, bh4 = b4 >>> 13, b5 = b2[5] | 0, bl5 = b5 & 8191, bh5 = b5 >>> 13, b6 = b2[6] | 0, bl6 = b6 & 8191, bh6 = b6 >>> 13, b7 = b2[7] | 0, bl7 = b7 & 8191, bh7 = b7 >>> 13, b8 = b2[8] | 0, bl8 = b8 & 8191, bh8 = b8 >>> 13, b9 = b2[9] | 0, bl9 = b9 & 8191, bh9 = b9 >>> 13;
      out.negative = self$1.negative ^ num.negative, out.length = 19, lo = Math.imul(al0, bl0), mid = Math.imul(al0, bh0), mid = mid + Math.imul(ah0, bl0) | 0, hi = Math.imul(ah0, bh0);
      var w0 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0, w0 &= 67108863, lo = Math.imul(al1, bl0), mid = Math.imul(al1, bh0), mid = mid + Math.imul(ah1, bl0) | 0, hi = Math.imul(ah1, bh0), lo = lo + Math.imul(al0, bl1) | 0, mid = mid + Math.imul(al0, bh1) | 0, mid = mid + Math.imul(ah0, bl1) | 0, hi = hi + Math.imul(ah0, bh1) | 0;
      var w1 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0, w1 &= 67108863, lo = Math.imul(al2, bl0), mid = Math.imul(al2, bh0), mid = mid + Math.imul(ah2, bl0) | 0, hi = Math.imul(ah2, bh0), lo = lo + Math.imul(al1, bl1) | 0, mid = mid + Math.imul(al1, bh1) | 0, mid = mid + Math.imul(ah1, bl1) | 0, hi = hi + Math.imul(ah1, bh1) | 0, lo = lo + Math.imul(al0, bl2) | 0, mid = mid + Math.imul(al0, bh2) | 0, mid = mid + Math.imul(ah0, bl2) | 0, hi = hi + Math.imul(ah0, bh2) | 0;
      var w2 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0, w2 &= 67108863, lo = Math.imul(al3, bl0), mid = Math.imul(al3, bh0), mid = mid + Math.imul(ah3, bl0) | 0, hi = Math.imul(ah3, bh0), lo = lo + Math.imul(al2, bl1) | 0, mid = mid + Math.imul(al2, bh1) | 0, mid = mid + Math.imul(ah2, bl1) | 0, hi = hi + Math.imul(ah2, bh1) | 0, lo = lo + Math.imul(al1, bl2) | 0, mid = mid + Math.imul(al1, bh2) | 0, mid = mid + Math.imul(ah1, bl2) | 0, hi = hi + Math.imul(ah1, bh2) | 0, lo = lo + Math.imul(al0, bl3) | 0, mid = mid + Math.imul(al0, bh3) | 0, mid = mid + Math.imul(ah0, bl3) | 0, hi = hi + Math.imul(ah0, bh3) | 0;
      var w3 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0, w3 &= 67108863, lo = Math.imul(al4, bl0), mid = Math.imul(al4, bh0), mid = mid + Math.imul(ah4, bl0) | 0, hi = Math.imul(ah4, bh0), lo = lo + Math.imul(al3, bl1) | 0, mid = mid + Math.imul(al3, bh1) | 0, mid = mid + Math.imul(ah3, bl1) | 0, hi = hi + Math.imul(ah3, bh1) | 0, lo = lo + Math.imul(al2, bl2) | 0, mid = mid + Math.imul(al2, bh2) | 0, mid = mid + Math.imul(ah2, bl2) | 0, hi = hi + Math.imul(ah2, bh2) | 0, lo = lo + Math.imul(al1, bl3) | 0, mid = mid + Math.imul(al1, bh3) | 0, mid = mid + Math.imul(ah1, bl3) | 0, hi = hi + Math.imul(ah1, bh3) | 0, lo = lo + Math.imul(al0, bl4) | 0, mid = mid + Math.imul(al0, bh4) | 0, mid = mid + Math.imul(ah0, bl4) | 0, hi = hi + Math.imul(ah0, bh4) | 0;
      var w4 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0, w4 &= 67108863, lo = Math.imul(al5, bl0), mid = Math.imul(al5, bh0), mid = mid + Math.imul(ah5, bl0) | 0, hi = Math.imul(ah5, bh0), lo = lo + Math.imul(al4, bl1) | 0, mid = mid + Math.imul(al4, bh1) | 0, mid = mid + Math.imul(ah4, bl1) | 0, hi = hi + Math.imul(ah4, bh1) | 0, lo = lo + Math.imul(al3, bl2) | 0, mid = mid + Math.imul(al3, bh2) | 0, mid = mid + Math.imul(ah3, bl2) | 0, hi = hi + Math.imul(ah3, bh2) | 0, lo = lo + Math.imul(al2, bl3) | 0, mid = mid + Math.imul(al2, bh3) | 0, mid = mid + Math.imul(ah2, bl3) | 0, hi = hi + Math.imul(ah2, bh3) | 0, lo = lo + Math.imul(al1, bl4) | 0, mid = mid + Math.imul(al1, bh4) | 0, mid = mid + Math.imul(ah1, bl4) | 0, hi = hi + Math.imul(ah1, bh4) | 0, lo = lo + Math.imul(al0, bl5) | 0, mid = mid + Math.imul(al0, bh5) | 0, mid = mid + Math.imul(ah0, bl5) | 0, hi = hi + Math.imul(ah0, bh5) | 0;
      var w5 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0, w5 &= 67108863, lo = Math.imul(al6, bl0), mid = Math.imul(al6, bh0), mid = mid + Math.imul(ah6, bl0) | 0, hi = Math.imul(ah6, bh0), lo = lo + Math.imul(al5, bl1) | 0, mid = mid + Math.imul(al5, bh1) | 0, mid = mid + Math.imul(ah5, bl1) | 0, hi = hi + Math.imul(ah5, bh1) | 0, lo = lo + Math.imul(al4, bl2) | 0, mid = mid + Math.imul(al4, bh2) | 0, mid = mid + Math.imul(ah4, bl2) | 0, hi = hi + Math.imul(ah4, bh2) | 0, lo = lo + Math.imul(al3, bl3) | 0, mid = mid + Math.imul(al3, bh3) | 0, mid = mid + Math.imul(ah3, bl3) | 0, hi = hi + Math.imul(ah3, bh3) | 0, lo = lo + Math.imul(al2, bl4) | 0, mid = mid + Math.imul(al2, bh4) | 0, mid = mid + Math.imul(ah2, bl4) | 0, hi = hi + Math.imul(ah2, bh4) | 0, lo = lo + Math.imul(al1, bl5) | 0, mid = mid + Math.imul(al1, bh5) | 0, mid = mid + Math.imul(ah1, bl5) | 0, hi = hi + Math.imul(ah1, bh5) | 0, lo = lo + Math.imul(al0, bl6) | 0, mid = mid + Math.imul(al0, bh6) | 0, mid = mid + Math.imul(ah0, bl6) | 0, hi = hi + Math.imul(ah0, bh6) | 0;
      var w6 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0, w6 &= 67108863, lo = Math.imul(al7, bl0), mid = Math.imul(al7, bh0), mid = mid + Math.imul(ah7, bl0) | 0, hi = Math.imul(ah7, bh0), lo = lo + Math.imul(al6, bl1) | 0, mid = mid + Math.imul(al6, bh1) | 0, mid = mid + Math.imul(ah6, bl1) | 0, hi = hi + Math.imul(ah6, bh1) | 0, lo = lo + Math.imul(al5, bl2) | 0, mid = mid + Math.imul(al5, bh2) | 0, mid = mid + Math.imul(ah5, bl2) | 0, hi = hi + Math.imul(ah5, bh2) | 0, lo = lo + Math.imul(al4, bl3) | 0, mid = mid + Math.imul(al4, bh3) | 0, mid = mid + Math.imul(ah4, bl3) | 0, hi = hi + Math.imul(ah4, bh3) | 0, lo = lo + Math.imul(al3, bl4) | 0, mid = mid + Math.imul(al3, bh4) | 0, mid = mid + Math.imul(ah3, bl4) | 0, hi = hi + Math.imul(ah3, bh4) | 0, lo = lo + Math.imul(al2, bl5) | 0, mid = mid + Math.imul(al2, bh5) | 0, mid = mid + Math.imul(ah2, bl5) | 0, hi = hi + Math.imul(ah2, bh5) | 0, lo = lo + Math.imul(al1, bl6) | 0, mid = mid + Math.imul(al1, bh6) | 0, mid = mid + Math.imul(ah1, bl6) | 0, hi = hi + Math.imul(ah1, bh6) | 0, lo = lo + Math.imul(al0, bl7) | 0, mid = mid + Math.imul(al0, bh7) | 0, mid = mid + Math.imul(ah0, bl7) | 0, hi = hi + Math.imul(ah0, bh7) | 0;
      var w7 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0, w7 &= 67108863, lo = Math.imul(al8, bl0), mid = Math.imul(al8, bh0), mid = mid + Math.imul(ah8, bl0) | 0, hi = Math.imul(ah8, bh0), lo = lo + Math.imul(al7, bl1) | 0, mid = mid + Math.imul(al7, bh1) | 0, mid = mid + Math.imul(ah7, bl1) | 0, hi = hi + Math.imul(ah7, bh1) | 0, lo = lo + Math.imul(al6, bl2) | 0, mid = mid + Math.imul(al6, bh2) | 0, mid = mid + Math.imul(ah6, bl2) | 0, hi = hi + Math.imul(ah6, bh2) | 0, lo = lo + Math.imul(al5, bl3) | 0, mid = mid + Math.imul(al5, bh3) | 0, mid = mid + Math.imul(ah5, bl3) | 0, hi = hi + Math.imul(ah5, bh3) | 0, lo = lo + Math.imul(al4, bl4) | 0, mid = mid + Math.imul(al4, bh4) | 0, mid = mid + Math.imul(ah4, bl4) | 0, hi = hi + Math.imul(ah4, bh4) | 0, lo = lo + Math.imul(al3, bl5) | 0, mid = mid + Math.imul(al3, bh5) | 0, mid = mid + Math.imul(ah3, bl5) | 0, hi = hi + Math.imul(ah3, bh5) | 0, lo = lo + Math.imul(al2, bl6) | 0, mid = mid + Math.imul(al2, bh6) | 0, mid = mid + Math.imul(ah2, bl6) | 0, hi = hi + Math.imul(ah2, bh6) | 0, lo = lo + Math.imul(al1, bl7) | 0, mid = mid + Math.imul(al1, bh7) | 0, mid = mid + Math.imul(ah1, bl7) | 0, hi = hi + Math.imul(ah1, bh7) | 0, lo = lo + Math.imul(al0, bl8) | 0, mid = mid + Math.imul(al0, bh8) | 0, mid = mid + Math.imul(ah0, bl8) | 0, hi = hi + Math.imul(ah0, bh8) | 0;
      var w8 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0, w8 &= 67108863, lo = Math.imul(al9, bl0), mid = Math.imul(al9, bh0), mid = mid + Math.imul(ah9, bl0) | 0, hi = Math.imul(ah9, bh0), lo = lo + Math.imul(al8, bl1) | 0, mid = mid + Math.imul(al8, bh1) | 0, mid = mid + Math.imul(ah8, bl1) | 0, hi = hi + Math.imul(ah8, bh1) | 0, lo = lo + Math.imul(al7, bl2) | 0, mid = mid + Math.imul(al7, bh2) | 0, mid = mid + Math.imul(ah7, bl2) | 0, hi = hi + Math.imul(ah7, bh2) | 0, lo = lo + Math.imul(al6, bl3) | 0, mid = mid + Math.imul(al6, bh3) | 0, mid = mid + Math.imul(ah6, bl3) | 0, hi = hi + Math.imul(ah6, bh3) | 0, lo = lo + Math.imul(al5, bl4) | 0, mid = mid + Math.imul(al5, bh4) | 0, mid = mid + Math.imul(ah5, bl4) | 0, hi = hi + Math.imul(ah5, bh4) | 0, lo = lo + Math.imul(al4, bl5) | 0, mid = mid + Math.imul(al4, bh5) | 0, mid = mid + Math.imul(ah4, bl5) | 0, hi = hi + Math.imul(ah4, bh5) | 0, lo = lo + Math.imul(al3, bl6) | 0, mid = mid + Math.imul(al3, bh6) | 0, mid = mid + Math.imul(ah3, bl6) | 0, hi = hi + Math.imul(ah3, bh6) | 0, lo = lo + Math.imul(al2, bl7) | 0, mid = mid + Math.imul(al2, bh7) | 0, mid = mid + Math.imul(ah2, bl7) | 0, hi = hi + Math.imul(ah2, bh7) | 0, lo = lo + Math.imul(al1, bl8) | 0, mid = mid + Math.imul(al1, bh8) | 0, mid = mid + Math.imul(ah1, bl8) | 0, hi = hi + Math.imul(ah1, bh8) | 0, lo = lo + Math.imul(al0, bl9) | 0, mid = mid + Math.imul(al0, bh9) | 0, mid = mid + Math.imul(ah0, bl9) | 0, hi = hi + Math.imul(ah0, bh9) | 0;
      var w9 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0, w9 &= 67108863, lo = Math.imul(al9, bl1), mid = Math.imul(al9, bh1), mid = mid + Math.imul(ah9, bl1) | 0, hi = Math.imul(ah9, bh1), lo = lo + Math.imul(al8, bl2) | 0, mid = mid + Math.imul(al8, bh2) | 0, mid = mid + Math.imul(ah8, bl2) | 0, hi = hi + Math.imul(ah8, bh2) | 0, lo = lo + Math.imul(al7, bl3) | 0, mid = mid + Math.imul(al7, bh3) | 0, mid = mid + Math.imul(ah7, bl3) | 0, hi = hi + Math.imul(ah7, bh3) | 0, lo = lo + Math.imul(al6, bl4) | 0, mid = mid + Math.imul(al6, bh4) | 0, mid = mid + Math.imul(ah6, bl4) | 0, hi = hi + Math.imul(ah6, bh4) | 0, lo = lo + Math.imul(al5, bl5) | 0, mid = mid + Math.imul(al5, bh5) | 0, mid = mid + Math.imul(ah5, bl5) | 0, hi = hi + Math.imul(ah5, bh5) | 0, lo = lo + Math.imul(al4, bl6) | 0, mid = mid + Math.imul(al4, bh6) | 0, mid = mid + Math.imul(ah4, bl6) | 0, hi = hi + Math.imul(ah4, bh6) | 0, lo = lo + Math.imul(al3, bl7) | 0, mid = mid + Math.imul(al3, bh7) | 0, mid = mid + Math.imul(ah3, bl7) | 0, hi = hi + Math.imul(ah3, bh7) | 0, lo = lo + Math.imul(al2, bl8) | 0, mid = mid + Math.imul(al2, bh8) | 0, mid = mid + Math.imul(ah2, bl8) | 0, hi = hi + Math.imul(ah2, bh8) | 0, lo = lo + Math.imul(al1, bl9) | 0, mid = mid + Math.imul(al1, bh9) | 0, mid = mid + Math.imul(ah1, bl9) | 0, hi = hi + Math.imul(ah1, bh9) | 0;
      var w10 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0, w10 &= 67108863, lo = Math.imul(al9, bl2), mid = Math.imul(al9, bh2), mid = mid + Math.imul(ah9, bl2) | 0, hi = Math.imul(ah9, bh2), lo = lo + Math.imul(al8, bl3) | 0, mid = mid + Math.imul(al8, bh3) | 0, mid = mid + Math.imul(ah8, bl3) | 0, hi = hi + Math.imul(ah8, bh3) | 0, lo = lo + Math.imul(al7, bl4) | 0, mid = mid + Math.imul(al7, bh4) | 0, mid = mid + Math.imul(ah7, bl4) | 0, hi = hi + Math.imul(ah7, bh4) | 0, lo = lo + Math.imul(al6, bl5) | 0, mid = mid + Math.imul(al6, bh5) | 0, mid = mid + Math.imul(ah6, bl5) | 0, hi = hi + Math.imul(ah6, bh5) | 0, lo = lo + Math.imul(al5, bl6) | 0, mid = mid + Math.imul(al5, bh6) | 0, mid = mid + Math.imul(ah5, bl6) | 0, hi = hi + Math.imul(ah5, bh6) | 0, lo = lo + Math.imul(al4, bl7) | 0, mid = mid + Math.imul(al4, bh7) | 0, mid = mid + Math.imul(ah4, bl7) | 0, hi = hi + Math.imul(ah4, bh7) | 0, lo = lo + Math.imul(al3, bl8) | 0, mid = mid + Math.imul(al3, bh8) | 0, mid = mid + Math.imul(ah3, bl8) | 0, hi = hi + Math.imul(ah3, bh8) | 0, lo = lo + Math.imul(al2, bl9) | 0, mid = mid + Math.imul(al2, bh9) | 0, mid = mid + Math.imul(ah2, bl9) | 0, hi = hi + Math.imul(ah2, bh9) | 0;
      var w11 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0, w11 &= 67108863, lo = Math.imul(al9, bl3), mid = Math.imul(al9, bh3), mid = mid + Math.imul(ah9, bl3) | 0, hi = Math.imul(ah9, bh3), lo = lo + Math.imul(al8, bl4) | 0, mid = mid + Math.imul(al8, bh4) | 0, mid = mid + Math.imul(ah8, bl4) | 0, hi = hi + Math.imul(ah8, bh4) | 0, lo = lo + Math.imul(al7, bl5) | 0, mid = mid + Math.imul(al7, bh5) | 0, mid = mid + Math.imul(ah7, bl5) | 0, hi = hi + Math.imul(ah7, bh5) | 0, lo = lo + Math.imul(al6, bl6) | 0, mid = mid + Math.imul(al6, bh6) | 0, mid = mid + Math.imul(ah6, bl6) | 0, hi = hi + Math.imul(ah6, bh6) | 0, lo = lo + Math.imul(al5, bl7) | 0, mid = mid + Math.imul(al5, bh7) | 0, mid = mid + Math.imul(ah5, bl7) | 0, hi = hi + Math.imul(ah5, bh7) | 0, lo = lo + Math.imul(al4, bl8) | 0, mid = mid + Math.imul(al4, bh8) | 0, mid = mid + Math.imul(ah4, bl8) | 0, hi = hi + Math.imul(ah4, bh8) | 0, lo = lo + Math.imul(al3, bl9) | 0, mid = mid + Math.imul(al3, bh9) | 0, mid = mid + Math.imul(ah3, bl9) | 0, hi = hi + Math.imul(ah3, bh9) | 0;
      var w12 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0, w12 &= 67108863, lo = Math.imul(al9, bl4), mid = Math.imul(al9, bh4), mid = mid + Math.imul(ah9, bl4) | 0, hi = Math.imul(ah9, bh4), lo = lo + Math.imul(al8, bl5) | 0, mid = mid + Math.imul(al8, bh5) | 0, mid = mid + Math.imul(ah8, bl5) | 0, hi = hi + Math.imul(ah8, bh5) | 0, lo = lo + Math.imul(al7, bl6) | 0, mid = mid + Math.imul(al7, bh6) | 0, mid = mid + Math.imul(ah7, bl6) | 0, hi = hi + Math.imul(ah7, bh6) | 0, lo = lo + Math.imul(al6, bl7) | 0, mid = mid + Math.imul(al6, bh7) | 0, mid = mid + Math.imul(ah6, bl7) | 0, hi = hi + Math.imul(ah6, bh7) | 0, lo = lo + Math.imul(al5, bl8) | 0, mid = mid + Math.imul(al5, bh8) | 0, mid = mid + Math.imul(ah5, bl8) | 0, hi = hi + Math.imul(ah5, bh8) | 0, lo = lo + Math.imul(al4, bl9) | 0, mid = mid + Math.imul(al4, bh9) | 0, mid = mid + Math.imul(ah4, bl9) | 0, hi = hi + Math.imul(ah4, bh9) | 0;
      var w13 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0, w13 &= 67108863, lo = Math.imul(al9, bl5), mid = Math.imul(al9, bh5), mid = mid + Math.imul(ah9, bl5) | 0, hi = Math.imul(ah9, bh5), lo = lo + Math.imul(al8, bl6) | 0, mid = mid + Math.imul(al8, bh6) | 0, mid = mid + Math.imul(ah8, bl6) | 0, hi = hi + Math.imul(ah8, bh6) | 0, lo = lo + Math.imul(al7, bl7) | 0, mid = mid + Math.imul(al7, bh7) | 0, mid = mid + Math.imul(ah7, bl7) | 0, hi = hi + Math.imul(ah7, bh7) | 0, lo = lo + Math.imul(al6, bl8) | 0, mid = mid + Math.imul(al6, bh8) | 0, mid = mid + Math.imul(ah6, bl8) | 0, hi = hi + Math.imul(ah6, bh8) | 0, lo = lo + Math.imul(al5, bl9) | 0, mid = mid + Math.imul(al5, bh9) | 0, mid = mid + Math.imul(ah5, bl9) | 0, hi = hi + Math.imul(ah5, bh9) | 0;
      var w14 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0, w14 &= 67108863, lo = Math.imul(al9, bl6), mid = Math.imul(al9, bh6), mid = mid + Math.imul(ah9, bl6) | 0, hi = Math.imul(ah9, bh6), lo = lo + Math.imul(al8, bl7) | 0, mid = mid + Math.imul(al8, bh7) | 0, mid = mid + Math.imul(ah8, bl7) | 0, hi = hi + Math.imul(ah8, bh7) | 0, lo = lo + Math.imul(al7, bl8) | 0, mid = mid + Math.imul(al7, bh8) | 0, mid = mid + Math.imul(ah7, bl8) | 0, hi = hi + Math.imul(ah7, bh8) | 0, lo = lo + Math.imul(al6, bl9) | 0, mid = mid + Math.imul(al6, bh9) | 0, mid = mid + Math.imul(ah6, bl9) | 0, hi = hi + Math.imul(ah6, bh9) | 0;
      var w15 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0, w15 &= 67108863, lo = Math.imul(al9, bl7), mid = Math.imul(al9, bh7), mid = mid + Math.imul(ah9, bl7) | 0, hi = Math.imul(ah9, bh7), lo = lo + Math.imul(al8, bl8) | 0, mid = mid + Math.imul(al8, bh8) | 0, mid = mid + Math.imul(ah8, bl8) | 0, hi = hi + Math.imul(ah8, bh8) | 0, lo = lo + Math.imul(al7, bl9) | 0, mid = mid + Math.imul(al7, bh9) | 0, mid = mid + Math.imul(ah7, bl9) | 0, hi = hi + Math.imul(ah7, bh9) | 0;
      var w16 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0, w16 &= 67108863, lo = Math.imul(al9, bl8), mid = Math.imul(al9, bh8), mid = mid + Math.imul(ah9, bl8) | 0, hi = Math.imul(ah9, bh8), lo = lo + Math.imul(al8, bl9) | 0, mid = mid + Math.imul(al8, bh9) | 0, mid = mid + Math.imul(ah8, bl9) | 0, hi = hi + Math.imul(ah8, bh9) | 0;
      var w17 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0, w17 &= 67108863, lo = Math.imul(al9, bl9), mid = Math.imul(al9, bh9), mid = mid + Math.imul(ah9, bl9) | 0, hi = Math.imul(ah9, bh9);
      var w18 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      return c$12 = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0, w18 &= 67108863, o$2[0] = w0, o$2[1] = w1, o$2[2] = w2, o$2[3] = w3, o$2[4] = w4, o$2[5] = w5, o$2[6] = w6, o$2[7] = w7, o$2[8] = w8, o$2[9] = w9, o$2[10] = w10, o$2[11] = w11, o$2[12] = w12, o$2[13] = w13, o$2[14] = w14, o$2[15] = w15, o$2[16] = w16, o$2[17] = w17, o$2[18] = w18, c$12 !== 0 && (o$2[19] = c$12, out.length++), out;
    };
    Math.imul || (comb10MulTo = smallMulTo);
    function bigMulTo(self$1, num, out) {
      out.negative = num.negative ^ self$1.negative, out.length = self$1.length + num.length;
      for (var carry = 0, hncarry = 0, k = 0; k < out.length - 1; k++) {
        var ncarry = hncarry;
        hncarry = 0;
        for (var rword = carry & 67108863, maxJ = Math.min(k, num.length - 1), j$1 = Math.max(0, k - self$1.length + 1); j$1 <= maxJ; j$1++) {
          var i$4 = k - j$1, a$22 = self$1.words[i$4] | 0, b2 = num.words[j$1] | 0, r$2 = a$22 * b2, lo = r$2 & 67108863;
          ncarry = ncarry + (r$2 / 67108864 | 0) | 0, lo = lo + rword | 0, rword = lo & 67108863, ncarry = ncarry + (lo >>> 26) | 0, hncarry += ncarry >>> 26, ncarry &= 67108863;
        }
        out.words[k] = rword, carry = ncarry, ncarry = hncarry;
      }
      return carry === 0 ? out.length-- : out.words[k] = carry, out.strip();
    }
    function jumboMulTo(self$1, num, out) {
      var fftm = new FFTM();
      return fftm.mulp(self$1, num, out);
    }
    BN$14.prototype.mulTo = function(num, out) {
      var res, len$2 = this.length + num.length;
      return res = this.length === 10 && num.length === 10 ? comb10MulTo(this, num, out) : len$2 < 63 ? smallMulTo(this, num, out) : len$2 < 1024 ? bigMulTo(this, num, out) : jumboMulTo(this, num, out), res;
    };
    function FFTM(x$1, y$1) {
      this.x = x$1, this.y = y$1;
    }
    FFTM.prototype.makeRBT = function(N) {
      for (var t$7 = Array(N), l$4 = BN$14.prototype._countBits(N) - 1, i$4 = 0; i$4 < N; i$4++) t$7[i$4] = this.revBin(i$4, l$4, N);
      return t$7;
    }, FFTM.prototype.revBin = function(x$1, l$4, N) {
      if (x$1 === 0 || x$1 === N - 1) return x$1;
      for (var rb = 0, i$4 = 0; i$4 < l$4; i$4++) rb |= (x$1 & 1) << l$4 - i$4 - 1, x$1 >>= 1;
      return rb;
    }, FFTM.prototype.permute = function(rbt, rws, iws, rtws, itws, N) {
      for (var i$4 = 0; i$4 < N; i$4++) rtws[i$4] = rws[rbt[i$4]], itws[i$4] = iws[rbt[i$4]];
    }, FFTM.prototype.transform = function(rws, iws, rtws, itws, N, rbt) {
      this.permute(rbt, rws, iws, rtws, itws, N);
      for (var s$6 = 1; s$6 < N; s$6 <<= 1) for (var l$4 = s$6 << 1, rtwdf = Math.cos(2 * Math.PI / l$4), itwdf = Math.sin(2 * Math.PI / l$4), p$1 = 0; p$1 < N; p$1 += l$4) for (var rtwdf_ = rtwdf, itwdf_ = itwdf, j$1 = 0; j$1 < s$6; j$1++) {
        var re$5 = rtws[p$1 + j$1], ie = itws[p$1 + j$1], ro = rtws[p$1 + j$1 + s$6], io = itws[p$1 + j$1 + s$6], rx = rtwdf_ * ro - itwdf_ * io;
        io = rtwdf_ * io + itwdf_ * ro, ro = rx, rtws[p$1 + j$1] = re$5 + ro, itws[p$1 + j$1] = ie + io, rtws[p$1 + j$1 + s$6] = re$5 - ro, itws[p$1 + j$1 + s$6] = ie - io, j$1 !== l$4 && (rx = rtwdf * rtwdf_ - itwdf * itwdf_, itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_, rtwdf_ = rx);
      }
    }, FFTM.prototype.guessLen13b = function(n$4, m$3) {
      var N = Math.max(m$3, n$4) | 1, odd = N & 1, i$4 = 0;
      for (N = N / 2 | 0; N; N >>>= 1) i$4++;
      return 1 << i$4 + 1 + odd;
    }, FFTM.prototype.conjugate = function(rws, iws, N) {
      if (!(N <= 1)) for (var i$4 = 0; i$4 < N / 2; i$4++) {
        var t$7 = rws[i$4];
        rws[i$4] = rws[N - i$4 - 1], rws[N - i$4 - 1] = t$7, t$7 = iws[i$4], iws[i$4] = -iws[N - i$4 - 1], iws[N - i$4 - 1] = -t$7;
      }
    }, FFTM.prototype.normalize13b = function(ws, N) {
      for (var carry = 0, i$4 = 0; i$4 < N / 2; i$4++) {
        var w$1 = Math.round(ws[2 * i$4 + 1] / N) * 8192 + Math.round(ws[2 * i$4] / N) + carry;
        ws[i$4] = w$1 & 67108863, carry = w$1 < 67108864 ? 0 : w$1 / 67108864 | 0;
      }
      return ws;
    }, FFTM.prototype.convert13b = function(ws, len$2, rws, N) {
      for (var carry = 0, i$4 = 0; i$4 < len$2; i$4++) carry += ws[i$4] | 0, rws[2 * i$4] = carry & 8191, carry >>>= 13, rws[2 * i$4 + 1] = carry & 8191, carry >>>= 13;
      for (i$4 = 2 * len$2; i$4 < N; ++i$4) rws[i$4] = 0;
      assert$54(carry === 0), assert$54((carry & -8192) == 0);
    }, FFTM.prototype.stub = function(N) {
      for (var ph = Array(N), i$4 = 0; i$4 < N; i$4++) ph[i$4] = 0;
      return ph;
    }, FFTM.prototype.mulp = function(x$1, y$1, out) {
      var N = 2 * this.guessLen13b(x$1.length, y$1.length), rbt = this.makeRBT(N), _ = this.stub(N), rws = Array(N), rwst = Array(N), iwst = Array(N), nrws = Array(N), nrwst = Array(N), niwst = Array(N), rmws = out.words;
      rmws.length = N, this.convert13b(x$1.words, x$1.length, rws, N), this.convert13b(y$1.words, y$1.length, nrws, N), this.transform(rws, _, rwst, iwst, N, rbt), this.transform(nrws, _, nrwst, niwst, N, rbt);
      for (var i$4 = 0; i$4 < N; i$4++) {
        var rx = rwst[i$4] * nrwst[i$4] - iwst[i$4] * niwst[i$4];
        iwst[i$4] = rwst[i$4] * niwst[i$4] + iwst[i$4] * nrwst[i$4], rwst[i$4] = rx;
      }
      return this.conjugate(rwst, iwst, N), this.transform(rwst, iwst, rmws, _, N, rbt), this.conjugate(rmws, _, N), this.normalize13b(rmws, N), out.negative = x$1.negative ^ y$1.negative, out.length = x$1.length + y$1.length, out.strip();
    }, BN$14.prototype.mul = function(num) {
      var out = new BN$14(null);
      return out.words = Array(this.length + num.length), this.mulTo(num, out);
    }, BN$14.prototype.mulf = function(num) {
      var out = new BN$14(null);
      return out.words = Array(this.length + num.length), jumboMulTo(this, num, out);
    }, BN$14.prototype.imul = function(num) {
      return this.clone().mulTo(num, this);
    }, BN$14.prototype.imuln = function(num) {
      assert$54(typeof num == `number`), assert$54(num < 67108864);
      for (var carry = 0, i$4 = 0; i$4 < this.length; i$4++) {
        var w$1 = (this.words[i$4] | 0) * num, lo = (w$1 & 67108863) + (carry & 67108863);
        carry >>= 26, carry += w$1 / 67108864 | 0, carry += lo >>> 26, this.words[i$4] = lo & 67108863;
      }
      return carry !== 0 && (this.words[i$4] = carry, this.length++), this.length = num === 0 ? 1 : this.length, this;
    }, BN$14.prototype.muln = function(num) {
      return this.clone().imuln(num);
    }, BN$14.prototype.sqr = function() {
      return this.mul(this);
    }, BN$14.prototype.isqr = function() {
      return this.imul(this.clone());
    }, BN$14.prototype.pow = function(num) {
      var w$1 = toBitArray(num);
      if (w$1.length === 0) return new BN$14(1);
      for (var res = this, i$4 = 0; i$4 < w$1.length && w$1[i$4] === 0; i$4++, res = res.sqr()) ;
      if (++i$4 < w$1.length) for (var q = res.sqr(); i$4 < w$1.length; i$4++, q = q.sqr()) w$1[i$4] !== 0 && (res = res.mul(q));
      return res;
    }, BN$14.prototype.iushln = function(bits$1) {
      assert$54(typeof bits$1 == `number` && bits$1 >= 0);
      var r$2 = bits$1 % 26, s$6 = (bits$1 - r$2) / 26, carryMask = 67108863 >>> 26 - r$2 << 26 - r$2, i$4;
      if (r$2 !== 0) {
        var carry = 0;
        for (i$4 = 0; i$4 < this.length; i$4++) {
          var newCarry = this.words[i$4] & carryMask, c$12 = (this.words[i$4] | 0) - newCarry << r$2;
          this.words[i$4] = c$12 | carry, carry = newCarry >>> 26 - r$2;
        }
        carry && (this.words[i$4] = carry, this.length++);
      }
      if (s$6 !== 0) {
        for (i$4 = this.length - 1; i$4 >= 0; i$4--) this.words[i$4 + s$6] = this.words[i$4];
        for (i$4 = 0; i$4 < s$6; i$4++) this.words[i$4] = 0;
        this.length += s$6;
      }
      return this.strip();
    }, BN$14.prototype.ishln = function(bits$1) {
      return assert$54(this.negative === 0), this.iushln(bits$1);
    }, BN$14.prototype.iushrn = function(bits$1, hint, extended) {
      assert$54(typeof bits$1 == `number` && bits$1 >= 0);
      var h$1;
      h$1 = hint ? (hint - hint % 26) / 26 : 0;
      var r$2 = bits$1 % 26, s$6 = Math.min((bits$1 - r$2) / 26, this.length), mask = 67108863 ^ 67108863 >>> r$2 << r$2, maskedWords = extended;
      if (h$1 -= s$6, h$1 = Math.max(0, h$1), maskedWords) {
        for (var i$4 = 0; i$4 < s$6; i$4++) maskedWords.words[i$4] = this.words[i$4];
        maskedWords.length = s$6;
      }
      if (s$6 !== 0) if (this.length > s$6) for (this.length -= s$6, i$4 = 0; i$4 < this.length; i$4++) this.words[i$4] = this.words[i$4 + s$6];
      else this.words[0] = 0, this.length = 1;
      var carry = 0;
      for (i$4 = this.length - 1; i$4 >= 0 && (carry !== 0 || i$4 >= h$1); i$4--) {
        var word = this.words[i$4] | 0;
        this.words[i$4] = carry << 26 - r$2 | word >>> r$2, carry = word & mask;
      }
      return maskedWords && carry !== 0 && (maskedWords.words[maskedWords.length++] = carry), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
    }, BN$14.prototype.ishrn = function(bits$1, hint, extended) {
      return assert$54(this.negative === 0), this.iushrn(bits$1, hint, extended);
    }, BN$14.prototype.shln = function(bits$1) {
      return this.clone().ishln(bits$1);
    }, BN$14.prototype.ushln = function(bits$1) {
      return this.clone().iushln(bits$1);
    }, BN$14.prototype.shrn = function(bits$1) {
      return this.clone().ishrn(bits$1);
    }, BN$14.prototype.ushrn = function(bits$1) {
      return this.clone().iushrn(bits$1);
    }, BN$14.prototype.testn = function(bit) {
      assert$54(typeof bit == `number` && bit >= 0);
      var r$2 = bit % 26, s$6 = (bit - r$2) / 26, q = 1 << r$2;
      if (this.length <= s$6) return false;
      var w$1 = this.words[s$6];
      return !!(w$1 & q);
    }, BN$14.prototype.imaskn = function(bits$1) {
      assert$54(typeof bits$1 == `number` && bits$1 >= 0);
      var r$2 = bits$1 % 26, s$6 = (bits$1 - r$2) / 26;
      if (assert$54(this.negative === 0, `imaskn works only with positive numbers`), this.length <= s$6) return this;
      if (r$2 !== 0 && s$6++, this.length = Math.min(s$6, this.length), r$2 !== 0) {
        var mask = 67108863 ^ 67108863 >>> r$2 << r$2;
        this.words[this.length - 1] &= mask;
      }
      return this.strip();
    }, BN$14.prototype.maskn = function(bits$1) {
      return this.clone().imaskn(bits$1);
    }, BN$14.prototype.iaddn = function(num) {
      return assert$54(typeof num == `number`), assert$54(num < 67108864), num < 0 ? this.isubn(-num) : this.negative === 0 ? this._iaddn(num) : this.length === 1 && (this.words[0] | 0) < num ? (this.words[0] = num - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(num), this.negative = 1, this);
    }, BN$14.prototype._iaddn = function(num) {
      this.words[0] += num;
      for (var i$4 = 0; i$4 < this.length && this.words[i$4] >= 67108864; i$4++) this.words[i$4] -= 67108864, i$4 === this.length - 1 ? this.words[i$4 + 1] = 1 : this.words[i$4 + 1]++;
      return this.length = Math.max(this.length, i$4 + 1), this;
    }, BN$14.prototype.isubn = function(num) {
      if (assert$54(typeof num == `number`), assert$54(num < 67108864), num < 0) return this.iaddn(-num);
      if (this.negative !== 0) return this.negative = 0, this.iaddn(num), this.negative = 1, this;
      if (this.words[0] -= num, this.length === 1 && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
      else for (var i$4 = 0; i$4 < this.length && this.words[i$4] < 0; i$4++) this.words[i$4] += 67108864, --this.words[i$4 + 1];
      return this.strip();
    }, BN$14.prototype.addn = function(num) {
      return this.clone().iaddn(num);
    }, BN$14.prototype.subn = function(num) {
      return this.clone().isubn(num);
    }, BN$14.prototype.iabs = function() {
      return this.negative = 0, this;
    }, BN$14.prototype.abs = function() {
      return this.clone().iabs();
    }, BN$14.prototype._ishlnsubmul = function(num, mul, shift) {
      var len$2 = num.length + shift, i$4;
      this._expand(len$2);
      var w$1, carry = 0;
      for (i$4 = 0; i$4 < num.length; i$4++) {
        w$1 = (this.words[i$4 + shift] | 0) + carry;
        var right = (num.words[i$4] | 0) * mul;
        w$1 -= right & 67108863, carry = (w$1 >> 26) - (right / 67108864 | 0), this.words[i$4 + shift] = w$1 & 67108863;
      }
      for (; i$4 < this.length - shift; i$4++) w$1 = (this.words[i$4 + shift] | 0) + carry, carry = w$1 >> 26, this.words[i$4 + shift] = w$1 & 67108863;
      if (carry === 0) return this.strip();
      for (assert$54(carry === -1), carry = 0, i$4 = 0; i$4 < this.length; i$4++) w$1 = -(this.words[i$4] | 0) + carry, carry = w$1 >> 26, this.words[i$4] = w$1 & 67108863;
      return this.negative = 1, this.strip();
    }, BN$14.prototype._wordDiv = function(num, mode) {
      var shift = this.length - num.length, a$22 = this.clone(), b2 = num, bhi = b2.words[b2.length - 1] | 0, bhiBits = this._countBits(bhi);
      shift = 26 - bhiBits, shift !== 0 && (b2 = b2.ushln(shift), a$22.iushln(shift), bhi = b2.words[b2.length - 1] | 0);
      var m$3 = a$22.length - b2.length, q;
      if (mode !== `mod`) {
        q = new BN$14(null), q.length = m$3 + 1, q.words = Array(q.length);
        for (var i$4 = 0; i$4 < q.length; i$4++) q.words[i$4] = 0;
      }
      var diff$4 = a$22.clone()._ishlnsubmul(b2, 1, m$3);
      diff$4.negative === 0 && (a$22 = diff$4, q && (q.words[m$3] = 1));
      for (var j$1 = m$3 - 1; j$1 >= 0; j$1--) {
        var qj = (a$22.words[b2.length + j$1] | 0) * 67108864 + (a$22.words[b2.length + j$1 - 1] | 0);
        for (qj = Math.min(qj / bhi | 0, 67108863), a$22._ishlnsubmul(b2, qj, j$1); a$22.negative !== 0; ) qj--, a$22.negative = 0, a$22._ishlnsubmul(b2, 1, j$1), a$22.isZero() || (a$22.negative ^= 1);
        q && (q.words[j$1] = qj);
      }
      return q && q.strip(), a$22.strip(), mode !== `div` && shift !== 0 && a$22.iushrn(shift), { div: q || null, mod: a$22 };
    }, BN$14.prototype.divmod = function(num, mode, positive) {
      if (assert$54(!num.isZero()), this.isZero()) return { div: new BN$14(0), mod: new BN$14(0) };
      var div, mod, res;
      return this.negative !== 0 && num.negative === 0 ? (res = this.neg().divmod(num, mode), mode !== `mod` && (div = res.div.neg()), mode !== `div` && (mod = res.mod.neg(), positive && mod.negative !== 0 && mod.iadd(num)), { div, mod }) : this.negative === 0 && num.negative !== 0 ? (res = this.divmod(num.neg(), mode), mode !== `mod` && (div = res.div.neg()), { div, mod: res.mod }) : (this.negative & num.negative) === 0 ? num.length > this.length || this.cmp(num) < 0 ? { div: new BN$14(0), mod: this } : num.length === 1 ? mode === `div` ? { div: this.divn(num.words[0]), mod: null } : mode === `mod` ? { div: null, mod: new BN$14(this.modn(num.words[0])) } : { div: this.divn(num.words[0]), mod: new BN$14(this.modn(num.words[0])) } : this._wordDiv(num, mode) : (res = this.neg().divmod(num.neg(), mode), mode !== `div` && (mod = res.mod.neg(), positive && mod.negative !== 0 && mod.isub(num)), { div: res.div, mod });
    }, BN$14.prototype.div = function(num) {
      return this.divmod(num, `div`, false).div;
    }, BN$14.prototype.mod = function(num) {
      return this.divmod(num, `mod`, false).mod;
    }, BN$14.prototype.umod = function(num) {
      return this.divmod(num, `mod`, true).mod;
    }, BN$14.prototype.divRound = function(num) {
      var dm = this.divmod(num);
      if (dm.mod.isZero()) return dm.div;
      var mod = dm.div.negative === 0 ? dm.mod : dm.mod.isub(num), half = num.ushrn(1), r2 = num.andln(1), cmp$3 = mod.cmp(half);
      return cmp$3 < 0 || r2 === 1 && cmp$3 === 0 ? dm.div : dm.div.negative === 0 ? dm.div.iaddn(1) : dm.div.isubn(1);
    }, BN$14.prototype.modn = function(num) {
      assert$54(num <= 67108863);
      for (var p$1 = (1 << 26) % num, acc = 0, i$4 = this.length - 1; i$4 >= 0; i$4--) acc = (p$1 * acc + (this.words[i$4] | 0)) % num;
      return acc;
    }, BN$14.prototype.idivn = function(num) {
      assert$54(num <= 67108863);
      for (var carry = 0, i$4 = this.length - 1; i$4 >= 0; i$4--) {
        var w$1 = (this.words[i$4] | 0) + carry * 67108864;
        this.words[i$4] = w$1 / num | 0, carry = w$1 % num;
      }
      return this.strip();
    }, BN$14.prototype.divn = function(num) {
      return this.clone().idivn(num);
    }, BN$14.prototype.egcd = function(p$1) {
      assert$54(p$1.negative === 0), assert$54(!p$1.isZero());
      var x$1 = this, y$1 = p$1.clone();
      x$1 = x$1.negative === 0 ? x$1.clone() : x$1.umod(p$1);
      for (var A = new BN$14(1), B = new BN$14(0), C = new BN$14(0), D = new BN$14(1), g$22 = 0; x$1.isEven() && y$1.isEven(); ) x$1.iushrn(1), y$1.iushrn(1), ++g$22;
      for (var yp = y$1.clone(), xp = x$1.clone(); !x$1.isZero(); ) {
        for (var i$4 = 0, im = 1; (x$1.words[0] & im) === 0 && i$4 < 26; ++i$4, im <<= 1) ;
        if (i$4 > 0) for (x$1.iushrn(i$4); i$4-- > 0; ) (A.isOdd() || B.isOdd()) && (A.iadd(yp), B.isub(xp)), A.iushrn(1), B.iushrn(1);
        for (var j$1 = 0, jm = 1; (y$1.words[0] & jm) === 0 && j$1 < 26; ++j$1, jm <<= 1) ;
        if (j$1 > 0) for (y$1.iushrn(j$1); j$1-- > 0; ) (C.isOdd() || D.isOdd()) && (C.iadd(yp), D.isub(xp)), C.iushrn(1), D.iushrn(1);
        x$1.cmp(y$1) >= 0 ? (x$1.isub(y$1), A.isub(C), B.isub(D)) : (y$1.isub(x$1), C.isub(A), D.isub(B));
      }
      return { a: C, b: D, gcd: y$1.iushln(g$22) };
    }, BN$14.prototype._invmp = function(p$1) {
      assert$54(p$1.negative === 0), assert$54(!p$1.isZero());
      var a$22 = this, b2 = p$1.clone();
      a$22 = a$22.negative === 0 ? a$22.clone() : a$22.umod(p$1);
      for (var x1 = new BN$14(1), x2 = new BN$14(0), delta = b2.clone(); a$22.cmpn(1) > 0 && b2.cmpn(1) > 0; ) {
        for (var i$4 = 0, im = 1; (a$22.words[0] & im) === 0 && i$4 < 26; ++i$4, im <<= 1) ;
        if (i$4 > 0) for (a$22.iushrn(i$4); i$4-- > 0; ) x1.isOdd() && x1.iadd(delta), x1.iushrn(1);
        for (var j$1 = 0, jm = 1; (b2.words[0] & jm) === 0 && j$1 < 26; ++j$1, jm <<= 1) ;
        if (j$1 > 0) for (b2.iushrn(j$1); j$1-- > 0; ) x2.isOdd() && x2.iadd(delta), x2.iushrn(1);
        a$22.cmp(b2) >= 0 ? (a$22.isub(b2), x1.isub(x2)) : (b2.isub(a$22), x2.isub(x1));
      }
      var res;
      return res = a$22.cmpn(1) === 0 ? x1 : x2, res.cmpn(0) < 0 && res.iadd(p$1), res;
    }, BN$14.prototype.gcd = function(num) {
      if (this.isZero()) return num.abs();
      if (num.isZero()) return this.abs();
      var a$22 = this.clone(), b2 = num.clone();
      a$22.negative = 0, b2.negative = 0;
      for (var shift = 0; a$22.isEven() && b2.isEven(); shift++) a$22.iushrn(1), b2.iushrn(1);
      do {
        for (; a$22.isEven(); ) a$22.iushrn(1);
        for (; b2.isEven(); ) b2.iushrn(1);
        var r$2 = a$22.cmp(b2);
        if (r$2 < 0) {
          var t$7 = a$22;
          a$22 = b2, b2 = t$7;
        } else if (r$2 === 0 || b2.cmpn(1) === 0) break;
        a$22.isub(b2);
      } while (true);
      return b2.iushln(shift);
    }, BN$14.prototype.invm = function(num) {
      return this.egcd(num).a.umod(num);
    }, BN$14.prototype.isEven = function() {
      return (this.words[0] & 1) == 0;
    }, BN$14.prototype.isOdd = function() {
      return (this.words[0] & 1) == 1;
    }, BN$14.prototype.andln = function(num) {
      return this.words[0] & num;
    }, BN$14.prototype.bincn = function(bit) {
      assert$54(typeof bit == `number`);
      var r$2 = bit % 26, s$6 = (bit - r$2) / 26, q = 1 << r$2;
      if (this.length <= s$6) return this._expand(s$6 + 1), this.words[s$6] |= q, this;
      for (var carry = q, i$4 = s$6; carry !== 0 && i$4 < this.length; i$4++) {
        var w$1 = this.words[i$4] | 0;
        w$1 += carry, carry = w$1 >>> 26, w$1 &= 67108863, this.words[i$4] = w$1;
      }
      return carry !== 0 && (this.words[i$4] = carry, this.length++), this;
    }, BN$14.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, BN$14.prototype.cmpn = function(num) {
      var negative = num < 0;
      if (this.negative !== 0 && !negative) return -1;
      if (this.negative === 0 && negative) return 1;
      this.strip();
      var res;
      if (this.length > 1) res = 1;
      else {
        negative && (num = -num), assert$54(num <= 67108863, `Number is too big`);
        var w$1 = this.words[0] | 0;
        res = w$1 === num ? 0 : w$1 < num ? -1 : 1;
      }
      return this.negative === 0 ? res : -res | 0;
    }, BN$14.prototype.cmp = function(num) {
      if (this.negative !== 0 && num.negative === 0) return -1;
      if (this.negative === 0 && num.negative !== 0) return 1;
      var res = this.ucmp(num);
      return this.negative === 0 ? res : -res | 0;
    }, BN$14.prototype.ucmp = function(num) {
      if (this.length > num.length) return 1;
      if (this.length < num.length) return -1;
      for (var res = 0, i$4 = this.length - 1; i$4 >= 0; i$4--) {
        var a$22 = this.words[i$4] | 0, b2 = num.words[i$4] | 0;
        if (a$22 !== b2) {
          a$22 < b2 ? res = -1 : a$22 > b2 && (res = 1);
          break;
        }
      }
      return res;
    }, BN$14.prototype.gtn = function(num) {
      return this.cmpn(num) === 1;
    }, BN$14.prototype.gt = function(num) {
      return this.cmp(num) === 1;
    }, BN$14.prototype.gten = function(num) {
      return this.cmpn(num) >= 0;
    }, BN$14.prototype.gte = function(num) {
      return this.cmp(num) >= 0;
    }, BN$14.prototype.ltn = function(num) {
      return this.cmpn(num) === -1;
    }, BN$14.prototype.lt = function(num) {
      return this.cmp(num) === -1;
    }, BN$14.prototype.lten = function(num) {
      return this.cmpn(num) <= 0;
    }, BN$14.prototype.lte = function(num) {
      return this.cmp(num) <= 0;
    }, BN$14.prototype.eqn = function(num) {
      return this.cmpn(num) === 0;
    }, BN$14.prototype.eq = function(num) {
      return this.cmp(num) === 0;
    }, BN$14.red = function(num) {
      return new Red(num);
    }, BN$14.prototype.toRed = function(ctx) {
      return assert$54(!this.red, `Already a number in reduction context`), assert$54(this.negative === 0, `red works only with positives`), ctx.convertTo(this)._forceRed(ctx);
    }, BN$14.prototype.fromRed = function() {
      return assert$54(this.red, `fromRed works only with numbers in reduction context`), this.red.convertFrom(this);
    }, BN$14.prototype._forceRed = function(ctx) {
      return this.red = ctx, this;
    }, BN$14.prototype.forceRed = function(ctx) {
      return assert$54(!this.red, `Already a number in reduction context`), this._forceRed(ctx);
    }, BN$14.prototype.redAdd = function(num) {
      return assert$54(this.red, `redAdd works only with red numbers`), this.red.add(this, num);
    }, BN$14.prototype.redIAdd = function(num) {
      return assert$54(this.red, `redIAdd works only with red numbers`), this.red.iadd(this, num);
    }, BN$14.prototype.redSub = function(num) {
      return assert$54(this.red, `redSub works only with red numbers`), this.red.sub(this, num);
    }, BN$14.prototype.redISub = function(num) {
      return assert$54(this.red, `redISub works only with red numbers`), this.red.isub(this, num);
    }, BN$14.prototype.redShl = function(num) {
      return assert$54(this.red, `redShl works only with red numbers`), this.red.shl(this, num);
    }, BN$14.prototype.redMul = function(num) {
      return assert$54(this.red, `redMul works only with red numbers`), this.red._verify2(this, num), this.red.mul(this, num);
    }, BN$14.prototype.redIMul = function(num) {
      return assert$54(this.red, `redMul works only with red numbers`), this.red._verify2(this, num), this.red.imul(this, num);
    }, BN$14.prototype.redSqr = function() {
      return assert$54(this.red, `redSqr works only with red numbers`), this.red._verify1(this), this.red.sqr(this);
    }, BN$14.prototype.redISqr = function() {
      return assert$54(this.red, `redISqr works only with red numbers`), this.red._verify1(this), this.red.isqr(this);
    }, BN$14.prototype.redSqrt = function() {
      return assert$54(this.red, `redSqrt works only with red numbers`), this.red._verify1(this), this.red.sqrt(this);
    }, BN$14.prototype.redInvm = function() {
      return assert$54(this.red, `redInvm works only with red numbers`), this.red._verify1(this), this.red.invm(this);
    }, BN$14.prototype.redNeg = function() {
      return assert$54(this.red, `redNeg works only with red numbers`), this.red._verify1(this), this.red.neg(this);
    }, BN$14.prototype.redPow = function(num) {
      return assert$54(this.red && !num.red, `redPow(normalNum)`), this.red._verify1(this), this.red.pow(this, num);
    };
    var primes = { k256: null, p224: null, p192: null, p25519: null };
    function MPrime(name$2, p$1) {
      this.name = name$2, this.p = new BN$14(p$1, 16), this.n = this.p.bitLength(), this.k = new BN$14(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function() {
      var tmp = new BN$14(null);
      return tmp.words = Array(Math.ceil(this.n / 13)), tmp;
    }, MPrime.prototype.ireduce = function(num) {
      var r$2 = num, rlen;
      do
        this.split(r$2, this.tmp), r$2 = this.imulK(r$2), r$2 = r$2.iadd(this.tmp), rlen = r$2.bitLength();
      while (rlen > this.n);
      var cmp$3 = rlen < this.n ? -1 : r$2.ucmp(this.p);
      return cmp$3 === 0 ? (r$2.words[0] = 0, r$2.length = 1) : cmp$3 > 0 ? r$2.isub(this.p) : r$2.strip === void 0 ? r$2._strip() : r$2.strip(), r$2;
    }, MPrime.prototype.split = function(input, out) {
      input.iushrn(this.n, 0, out);
    }, MPrime.prototype.imulK = function(num) {
      return num.imul(this.k);
    };
    function K256() {
      MPrime.call(this, `k256`, `ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f`);
    }
    inherits$14(K256, MPrime), K256.prototype.split = function(input, output) {
      for (var mask = 4194303, outLen = Math.min(input.length, 9), i$4 = 0; i$4 < outLen; i$4++) output.words[i$4] = input.words[i$4];
      if (output.length = outLen, input.length <= 9) {
        input.words[0] = 0, input.length = 1;
        return;
      }
      var prev = input.words[9];
      for (output.words[output.length++] = prev & mask, i$4 = 10; i$4 < input.length; i$4++) {
        var next = input.words[i$4] | 0;
        input.words[i$4 - 10] = (next & mask) << 4 | prev >>> 22, prev = next;
      }
      prev >>>= 22, input.words[i$4 - 10] = prev, prev === 0 && input.length > 10 ? input.length -= 10 : input.length -= 9;
    }, K256.prototype.imulK = function(num) {
      num.words[num.length] = 0, num.words[num.length + 1] = 0, num.length += 2;
      for (var lo = 0, i$4 = 0; i$4 < num.length; i$4++) {
        var w$1 = num.words[i$4] | 0;
        lo += w$1 * 977, num.words[i$4] = lo & 67108863, lo = w$1 * 64 + (lo / 67108864 | 0);
      }
      return num.words[num.length - 1] === 0 && (num.length--, num.words[num.length - 1] === 0 && num.length--), num;
    };
    function P224() {
      MPrime.call(this, `p224`, `ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001`);
    }
    inherits$14(P224, MPrime);
    function P192() {
      MPrime.call(this, `p192`, `ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff`);
    }
    inherits$14(P192, MPrime);
    function P25519() {
      MPrime.call(this, `25519`, `7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed`);
    }
    inherits$14(P25519, MPrime), P25519.prototype.imulK = function(num) {
      for (var carry = 0, i$4 = 0; i$4 < num.length; i$4++) {
        var hi = (num.words[i$4] | 0) * 19 + carry, lo = hi & 67108863;
        hi >>>= 26, num.words[i$4] = lo, carry = hi;
      }
      return carry !== 0 && (num.words[num.length++] = carry), num;
    }, BN$14._prime = function(name$2) {
      if (primes[name$2]) return primes[name$2];
      var prime$1;
      if (name$2 === `k256`) prime$1 = new K256();
      else if (name$2 === `p224`) prime$1 = new P224();
      else if (name$2 === `p192`) prime$1 = new P192();
      else if (name$2 === `p25519`) prime$1 = new P25519();
      else throw Error(`Unknown prime ` + name$2);
      return primes[name$2] = prime$1, prime$1;
    };
    function Red(m$3) {
      if (typeof m$3 == `string`) {
        var prime = BN$14._prime(m$3);
        this.m = prime.p, this.prime = prime;
      } else assert$54(m$3.gtn(1), `modulus must be greater than 1`), this.m = m$3, this.prime = null;
    }
    Red.prototype._verify1 = function(a$22) {
      assert$54(a$22.negative === 0, `red works only with positives`), assert$54(a$22.red, `red works only with red numbers`);
    }, Red.prototype._verify2 = function(a$22, b2) {
      assert$54((a$22.negative | b2.negative) === 0, `red works only with positives`), assert$54(a$22.red && a$22.red === b2.red, `red works only with red numbers`);
    }, Red.prototype.imod = function(a$22) {
      return this.prime ? this.prime.ireduce(a$22)._forceRed(this) : a$22.umod(this.m)._forceRed(this);
    }, Red.prototype.neg = function(a$22) {
      return a$22.isZero() ? a$22.clone() : this.m.sub(a$22)._forceRed(this);
    }, Red.prototype.add = function(a$22, b2) {
      this._verify2(a$22, b2);
      var res = a$22.add(b2);
      return res.cmp(this.m) >= 0 && res.isub(this.m), res._forceRed(this);
    }, Red.prototype.iadd = function(a$22, b2) {
      this._verify2(a$22, b2);
      var res = a$22.iadd(b2);
      return res.cmp(this.m) >= 0 && res.isub(this.m), res;
    }, Red.prototype.sub = function(a$22, b2) {
      this._verify2(a$22, b2);
      var res = a$22.sub(b2);
      return res.cmpn(0) < 0 && res.iadd(this.m), res._forceRed(this);
    }, Red.prototype.isub = function(a$22, b2) {
      this._verify2(a$22, b2);
      var res = a$22.isub(b2);
      return res.cmpn(0) < 0 && res.iadd(this.m), res;
    }, Red.prototype.shl = function(a$22, num) {
      return this._verify1(a$22), this.imod(a$22.ushln(num));
    }, Red.prototype.imul = function(a$22, b2) {
      return this._verify2(a$22, b2), this.imod(a$22.imul(b2));
    }, Red.prototype.mul = function(a$22, b2) {
      return this._verify2(a$22, b2), this.imod(a$22.mul(b2));
    }, Red.prototype.isqr = function(a$22) {
      return this.imul(a$22, a$22.clone());
    }, Red.prototype.sqr = function(a$22) {
      return this.mul(a$22, a$22);
    }, Red.prototype.sqrt = function(a$22) {
      if (a$22.isZero()) return a$22.clone();
      var mod3 = this.m.andln(3);
      if (assert$54(mod3 % 2 == 1), mod3 === 3) {
        var pow$1 = this.m.add(new BN$14(1)).iushrn(2);
        return this.pow(a$22, pow$1);
      }
      for (var q = this.m.subn(1), s$6 = 0; !q.isZero() && q.andln(1) === 0; ) s$6++, q.iushrn(1);
      assert$54(!q.isZero());
      var one = new BN$14(1).toRed(this), nOne = one.redNeg(), lpow = this.m.subn(1).iushrn(1), z$1 = this.m.bitLength();
      for (z$1 = new BN$14(2 * z$1 * z$1).toRed(this); this.pow(z$1, lpow).cmp(nOne) !== 0; ) z$1.redIAdd(nOne);
      for (var c$12 = this.pow(z$1, q), r$2 = this.pow(a$22, q.addn(1).iushrn(1)), t$7 = this.pow(a$22, q), m$3 = s$6; t$7.cmp(one) !== 0; ) {
        for (var tmp = t$7, i$4 = 0; tmp.cmp(one) !== 0; i$4++) tmp = tmp.redSqr();
        assert$54(i$4 < m$3);
        var b2 = this.pow(c$12, new BN$14(1).iushln(m$3 - i$4 - 1));
        r$2 = r$2.redMul(b2), c$12 = b2.redSqr(), t$7 = t$7.redMul(c$12), m$3 = i$4;
      }
      return r$2;
    }, Red.prototype.invm = function(a$22) {
      var inv = a$22._invmp(this.m);
      return inv.negative === 0 ? this.imod(inv) : (inv.negative = 0, this.imod(inv).redNeg());
    }, Red.prototype.pow = function(a$22, num) {
      if (num.isZero()) return new BN$14(1).toRed(this);
      if (num.cmpn(1) === 0) return a$22.clone();
      var windowSize = 4, wnd = Array(1 << windowSize);
      wnd[0] = new BN$14(1).toRed(this), wnd[1] = a$22;
      for (var i$4 = 2; i$4 < wnd.length; i$4++) wnd[i$4] = this.mul(wnd[i$4 - 1], a$22);
      var res = wnd[0], current = 0, currentLen = 0, start = num.bitLength() % 26;
      for (start === 0 && (start = 26), i$4 = num.length - 1; i$4 >= 0; i$4--) {
        for (var word = num.words[i$4], j$1 = start - 1; j$1 >= 0; j$1--) {
          var bit = word >> j$1 & 1;
          if (res !== wnd[0] && (res = this.sqr(res)), bit === 0 && current === 0) {
            currentLen = 0;
            continue;
          }
          current <<= 1, current |= bit, currentLen++, !(currentLen !== windowSize && (i$4 !== 0 || j$1 !== 0)) && (res = this.mul(res, wnd[current]), currentLen = 0, current = 0);
        }
        start = 26;
      }
      return res;
    }, Red.prototype.convertTo = function(num) {
      var r$2 = num.umod(this.m);
      return r$2 === num ? r$2.clone() : r$2;
    }, Red.prototype.convertFrom = function(num) {
      var res = num.clone();
      return res.red = null, res;
    }, BN$14.mont = function(num) {
      return new Mont(num);
    };
    function Mont(m$3) {
      Red.call(this, m$3), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new BN$14(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    inherits$14(Mont, Red), Mont.prototype.convertTo = function(num) {
      return this.imod(num.ushln(this.shift));
    }, Mont.prototype.convertFrom = function(num) {
      var r$2 = this.imod(num.mul(this.rinv));
      return r$2.red = null, r$2;
    }, Mont.prototype.imul = function(a$22, b2) {
      if (a$22.isZero() || b2.isZero()) return a$22.words[0] = 0, a$22.length = 1, a$22;
      var t$7 = a$22.imul(b2), c$12 = t$7.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), u = t$7.isub(c$12).iushrn(this.shift), res = u;
      return u.cmp(this.m) >= 0 ? res = u.isub(this.m) : u.cmpn(0) < 0 && (res = u.iadd(this.m)), res._forceRed(this);
    }, Mont.prototype.mul = function(a$22, b2) {
      if (a$22.isZero() || b2.isZero()) return new BN$14(0)._forceRed(this);
      var t$7 = a$22.mul(b2), c$12 = t$7.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), u = t$7.isub(c$12).iushrn(this.shift), res = u;
      return u.cmp(this.m) >= 0 ? res = u.isub(this.m) : u.cmpn(0) < 0 && (res = u.iadd(this.m)), res._forceRed(this);
    }, Mont.prototype.invm = function(a$22) {
      var res = this.imod(a$22._invmp(this.m).mul(this.r2));
      return res._forceRed(this);
    };
  })(module2 === void 0 || module2, exports$12);
}), require_minimalistic_assert = __commonJSMin$1((exports$12, module2) => {
  module2.exports = assert$18;
  function assert$18(val, msg) {
    if (!val) throw Error(msg || `Assertion failed`);
  }
  assert$18.equal = function(l$4, r$2, msg) {
    if (l$4 != r$2) throw Error(msg || `Assertion failed: ` + l$4 + ` != ` + r$2);
  };
}), require_utils$4 = __commonJSMin$1((exports$12) => {
  var utils$24 = exports$12;
  function toArray$2(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg != `string`) {
      for (var i$4 = 0; i$4 < msg.length; i$4++) res[i$4] = msg[i$4] | 0;
      return res;
    }
    if (enc === `hex`) {
      msg = msg.replace(/[^a-z0-9]+/gi, ``), msg.length % 2 != 0 && (msg = `0` + msg);
      for (var i$4 = 0; i$4 < msg.length; i$4 += 2) res.push(parseInt(msg[i$4] + msg[i$4 + 1], 16));
    } else for (var i$4 = 0; i$4 < msg.length; i$4++) {
      var c$12 = msg.charCodeAt(i$4), hi = c$12 >> 8, lo = c$12 & 255;
      hi ? res.push(hi, lo) : res.push(lo);
    }
    return res;
  }
  utils$24.toArray = toArray$2;
  function zero2$1(word) {
    return word.length === 1 ? `0` + word : word;
  }
  utils$24.zero2 = zero2$1;
  function toHex$1(msg) {
    for (var res = ``, i$4 = 0; i$4 < msg.length; i$4++) res += zero2$1(msg[i$4].toString(16));
    return res;
  }
  utils$24.toHex = toHex$1, utils$24.encode = function(arr, enc) {
    return enc === `hex` ? toHex$1(arr) : arr;
  };
}), require_utils$3 = __commonJSMin$1((exports$12) => {
  var utils$23 = exports$12, BN$13 = require_bn$1(), minAssert = require_minimalistic_assert(), minUtils = require_utils$4();
  utils$23.assert = minAssert, utils$23.toArray = minUtils.toArray, utils$23.zero2 = minUtils.zero2, utils$23.toHex = minUtils.toHex, utils$23.encode = minUtils.encode;
  function getNAF$1(num, w$1, bits$1) {
    var naf = Array(Math.max(num.bitLength(), bits$1) + 1), i$4;
    for (i$4 = 0; i$4 < naf.length; i$4 += 1) naf[i$4] = 0;
    var ws = 1 << w$1 + 1, k = num.clone();
    for (i$4 = 0; i$4 < naf.length; i$4++) {
      var z$1, mod = k.andln(ws - 1);
      k.isOdd() ? (z$1 = mod > (ws >> 1) - 1 ? (ws >> 1) - mod : mod, k.isubn(z$1)) : z$1 = 0, naf[i$4] = z$1, k.iushrn(1);
    }
    return naf;
  }
  utils$23.getNAF = getNAF$1;
  function getJSF$1(k1, k2) {
    var jsf = [[], []];
    k1 = k1.clone(), k2 = k2.clone();
    for (var d1 = 0, d2 = 0, m8; k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0; ) {
      var m14 = k1.andln(3) + d1 & 3, m24 = k2.andln(3) + d2 & 3;
      m14 === 3 && (m14 = -1), m24 === 3 && (m24 = -1);
      var u1;
      m14 & 1 ? (m8 = k1.andln(7) + d1 & 7, u1 = (m8 === 3 || m8 === 5) && m24 === 2 ? -m14 : m14) : u1 = 0, jsf[0].push(u1);
      var u2;
      m24 & 1 ? (m8 = k2.andln(7) + d2 & 7, u2 = (m8 === 3 || m8 === 5) && m14 === 2 ? -m24 : m24) : u2 = 0, jsf[1].push(u2), 2 * d1 === u1 + 1 && (d1 = 1 - d1), 2 * d2 === u2 + 1 && (d2 = 1 - d2), k1.iushrn(1), k2.iushrn(1);
    }
    return jsf;
  }
  utils$23.getJSF = getJSF$1;
  function cachedProperty$2(obj, name$2, computer) {
    var key = `_` + name$2;
    obj.prototype[name$2] = function() {
      return this[key] === void 0 ? this[key] = computer.call(this) : this[key];
    };
  }
  utils$23.cachedProperty = cachedProperty$2;
  function parseBytes$3(bytes) {
    return typeof bytes == `string` ? utils$23.toArray(bytes, `hex`) : bytes;
  }
  utils$23.parseBytes = parseBytes$3;
  function intFromLE(bytes) {
    return new BN$13(bytes, `hex`, `le`);
  }
  utils$23.intFromLE = intFromLE;
}), require_brorand = __commonJSMin$1((exports$12, module2) => {
  var r$1;
  module2.exports = function(len$2) {
    return r$1 ||= new Rand(null), r$1.generate(len$2);
  };
  function Rand(rand$1) {
    this.rand = rand$1;
  }
  if (module2.exports.Rand = Rand, Rand.prototype.generate = function(len$2) {
    return this._rand(len$2);
  }, Rand.prototype._rand = function(n$4) {
    if (this.rand.getBytes) return this.rand.getBytes(n$4);
    for (var res = new Uint8Array(n$4), i$4 = 0; i$4 < res.length; i$4++) res[i$4] = this.rand.getByte();
    return res;
  }, typeof self == `object`) self.crypto && self.crypto.getRandomValues ? Rand.prototype._rand = function(n$4) {
    var arr = new Uint8Array(n$4);
    return self.crypto.getRandomValues(arr), arr;
  } : self.msCrypto && self.msCrypto.getRandomValues ? Rand.prototype._rand = function(n$4) {
    var arr = new Uint8Array(n$4);
    return self.msCrypto.getRandomValues(arr), arr;
  } : typeof window == `object` && (Rand.prototype._rand = function() {
    throw Error(`Not implemented yet`);
  });
  else try {
    var crypto$4 = require_crypto_browserify();
    if (typeof crypto$4.randomBytes != `function`) throw Error(`Not supported`);
    Rand.prototype._rand = function(n$4) {
      return crypto$4.randomBytes(n$4);
    };
  } catch {
  }
}), require_base$1 = __commonJSMin$1((exports$12, module2) => {
  var BN$12 = require_bn$1(), utils$22 = require_utils$3(), getNAF = utils$22.getNAF, getJSF = utils$22.getJSF, assert$17 = utils$22.assert;
  function BaseCurve(type, conf) {
    this.type = type, this.p = new BN$12(conf.p, 16), this.red = conf.prime ? BN$12.red(conf.prime) : BN$12.mont(this.p), this.zero = new BN$12(0).toRed(this.red), this.one = new BN$12(1).toRed(this.red), this.two = new BN$12(2).toRed(this.red), this.n = conf.n && new BN$12(conf.n, 16), this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed), this._wnafT1 = [, , , ,], this._wnafT2 = [, , , ,], this._wnafT3 = [, , , ,], this._wnafT4 = [, , , ,], this._bitLength = this.n ? this.n.bitLength() : 0;
    var adjustCount = this.n && this.p.div(this.n);
    !adjustCount || adjustCount.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = true, this.redN = this.n.toRed(this.red));
  }
  module2.exports = BaseCurve, BaseCurve.prototype.point = function() {
    throw Error(`Not implemented`);
  }, BaseCurve.prototype.validate = function() {
    throw Error(`Not implemented`);
  }, BaseCurve.prototype._fixedNafMul = function(p$1, k) {
    assert$17(p$1.precomputed);
    var doubles = p$1._getDoubles(), naf = getNAF(k, 1, this._bitLength), I = (1 << doubles.step + 1) - (doubles.step % 2 == 0 ? 2 : 1);
    I /= 3;
    var repr = [], j$1, nafW;
    for (j$1 = 0; j$1 < naf.length; j$1 += doubles.step) {
      nafW = 0;
      for (var l$4 = j$1 + doubles.step - 1; l$4 >= j$1; l$4--) nafW = (nafW << 1) + naf[l$4];
      repr.push(nafW);
    }
    for (var a$22 = this.jpoint(null, null, null), b2 = this.jpoint(null, null, null), i$4 = I; i$4 > 0; i$4--) {
      for (j$1 = 0; j$1 < repr.length; j$1++) nafW = repr[j$1], nafW === i$4 ? b2 = b2.mixedAdd(doubles.points[j$1]) : nafW === -i$4 && (b2 = b2.mixedAdd(doubles.points[j$1].neg()));
      a$22 = a$22.add(b2);
    }
    return a$22.toP();
  }, BaseCurve.prototype._wnafMul = function(p$1, k) {
    var w$1 = 4, nafPoints = p$1._getNAFPoints(w$1);
    w$1 = nafPoints.wnd;
    for (var wnd = nafPoints.points, naf = getNAF(k, w$1, this._bitLength), acc = this.jpoint(null, null, null), i$4 = naf.length - 1; i$4 >= 0; i$4--) {
      for (var l$4 = 0; i$4 >= 0 && naf[i$4] === 0; i$4--) l$4++;
      if (i$4 >= 0 && l$4++, acc = acc.dblp(l$4), i$4 < 0) break;
      var z$1 = naf[i$4];
      assert$17(z$1 !== 0), acc = p$1.type === `affine` ? z$1 > 0 ? acc.mixedAdd(wnd[z$1 - 1 >> 1]) : acc.mixedAdd(wnd[-z$1 - 1 >> 1].neg()) : z$1 > 0 ? acc.add(wnd[z$1 - 1 >> 1]) : acc.add(wnd[-z$1 - 1 >> 1].neg());
    }
    return p$1.type === `affine` ? acc.toP() : acc;
  }, BaseCurve.prototype._wnafMulAdd = function(defW, points, coeffs, len$2, jacobianResult) {
    var wndWidth = this._wnafT1, wnd = this._wnafT2, naf = this._wnafT3, max$3 = 0, i$4, j$1, p$1;
    for (i$4 = 0; i$4 < len$2; i$4++) {
      p$1 = points[i$4];
      var nafPoints = p$1._getNAFPoints(defW);
      wndWidth[i$4] = nafPoints.wnd, wnd[i$4] = nafPoints.points;
    }
    for (i$4 = len$2 - 1; i$4 >= 1; i$4 -= 2) {
      var a$22 = i$4 - 1, b2 = i$4;
      if (wndWidth[a$22] !== 1 || wndWidth[b2] !== 1) {
        naf[a$22] = getNAF(coeffs[a$22], wndWidth[a$22], this._bitLength), naf[b2] = getNAF(coeffs[b2], wndWidth[b2], this._bitLength), max$3 = Math.max(naf[a$22].length, max$3), max$3 = Math.max(naf[b2].length, max$3);
        continue;
      }
      var comb = [points[a$22], null, null, points[b2]];
      points[a$22].y.cmp(points[b2].y) === 0 ? (comb[1] = points[a$22].add(points[b2]), comb[2] = points[a$22].toJ().mixedAdd(points[b2].neg())) : points[a$22].y.cmp(points[b2].y.redNeg()) === 0 ? (comb[1] = points[a$22].toJ().mixedAdd(points[b2]), comb[2] = points[a$22].add(points[b2].neg())) : (comb[1] = points[a$22].toJ().mixedAdd(points[b2]), comb[2] = points[a$22].toJ().mixedAdd(points[b2].neg()));
      var index$2 = [-3, -1, -5, -7, 0, 7, 5, 1, 3], jsf = getJSF(coeffs[a$22], coeffs[b2]);
      for (max$3 = Math.max(jsf[0].length, max$3), naf[a$22] = Array(max$3), naf[b2] = Array(max$3), j$1 = 0; j$1 < max$3; j$1++) {
        var ja = jsf[0][j$1] | 0, jb = jsf[1][j$1] | 0;
        naf[a$22][j$1] = index$2[(ja + 1) * 3 + (jb + 1)], naf[b2][j$1] = 0, wnd[a$22] = comb;
      }
    }
    var acc = this.jpoint(null, null, null), tmp = this._wnafT4;
    for (i$4 = max$3; i$4 >= 0; i$4--) {
      for (var k = 0; i$4 >= 0; ) {
        var zero = true;
        for (j$1 = 0; j$1 < len$2; j$1++) tmp[j$1] = naf[j$1][i$4] | 0, tmp[j$1] !== 0 && (zero = false);
        if (!zero) break;
        k++, i$4--;
      }
      if (i$4 >= 0 && k++, acc = acc.dblp(k), i$4 < 0) break;
      for (j$1 = 0; j$1 < len$2; j$1++) {
        var z$1 = tmp[j$1];
        z$1 !== 0 && (z$1 > 0 ? p$1 = wnd[j$1][z$1 - 1 >> 1] : z$1 < 0 && (p$1 = wnd[j$1][-z$1 - 1 >> 1].neg()), acc = p$1.type === `affine` ? acc.mixedAdd(p$1) : acc.add(p$1));
      }
    }
    for (i$4 = 0; i$4 < len$2; i$4++) wnd[i$4] = null;
    return jacobianResult ? acc : acc.toP();
  };
  function BasePoint(curve$2, type) {
    this.curve = curve$2, this.type = type, this.precomputed = null;
  }
  BaseCurve.BasePoint = BasePoint, BasePoint.prototype.eq = function() {
    throw Error(`Not implemented`);
  }, BasePoint.prototype.validate = function() {
    return this.curve.validate(this);
  }, BaseCurve.prototype.decodePoint = function(bytes, enc) {
    bytes = utils$22.toArray(bytes, enc);
    var len$2 = this.p.byteLength();
    if ((bytes[0] === 4 || bytes[0] === 6 || bytes[0] === 7) && bytes.length - 1 == 2 * len$2) {
      bytes[0] === 6 ? assert$17(bytes[bytes.length - 1] % 2 == 0) : bytes[0] === 7 && assert$17(bytes[bytes.length - 1] % 2 == 1);
      var res = this.point(bytes.slice(1, 1 + len$2), bytes.slice(1 + len$2, 1 + 2 * len$2));
      return res;
    } else if ((bytes[0] === 2 || bytes[0] === 3) && bytes.length - 1 === len$2) return this.pointFromX(bytes.slice(1, 1 + len$2), bytes[0] === 3);
    throw Error(`Unknown point format`);
  }, BasePoint.prototype.encodeCompressed = function(enc) {
    return this.encode(enc, true);
  }, BasePoint.prototype._encode = function(compact$4) {
    var len$2 = this.curve.p.byteLength(), x$1 = this.getX().toArray(`be`, len$2);
    return compact$4 ? [this.getY().isEven() ? 2 : 3].concat(x$1) : [4].concat(x$1, this.getY().toArray(`be`, len$2));
  }, BasePoint.prototype.encode = function(enc, compact$4) {
    return utils$22.encode(this._encode(compact$4), enc);
  }, BasePoint.prototype.precompute = function(power) {
    if (this.precomputed) return this;
    var precomputed = { doubles: null, naf: null, beta: null };
    return precomputed.naf = this._getNAFPoints(8), precomputed.doubles = this._getDoubles(4, power), precomputed.beta = this._getBeta(), this.precomputed = precomputed, this;
  }, BasePoint.prototype._hasDoubles = function(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    return doubles ? doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step) : false;
  }, BasePoint.prototype._getDoubles = function(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    for (var doubles = [this], acc = this, i$4 = 0; i$4 < power; i$4 += step) {
      for (var j$1 = 0; j$1 < step; j$1++) acc = acc.dbl();
      doubles.push(acc);
    }
    return { step, points: doubles };
  }, BasePoint.prototype._getNAFPoints = function(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    for (var res = [this], max$3 = (1 << wnd) - 1, dbl = max$3 === 1 ? null : this.dbl(), i$4 = 1; i$4 < max$3; i$4++) res[i$4] = res[i$4 - 1].add(dbl);
    return { wnd, points: res };
  }, BasePoint.prototype._getBeta = function() {
    return null;
  }, BasePoint.prototype.dblp = function(k) {
    for (var r$2 = this, i$4 = 0; i$4 < k; i$4++) r$2 = r$2.dbl();
    return r$2;
  };
}), require_short = __commonJSMin$1((exports$12, module2) => {
  var utils$21 = require_utils$3(), BN$11 = require_bn$1(), inherits$12 = require_inherits(), Base$2 = require_base$1(), assert$16 = utils$21.assert;
  function ShortCurve(conf) {
    Base$2.call(this, `short`, conf), this.a = new BN$11(conf.a, 16).toRed(this.red), this.b = new BN$11(conf.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(conf), this._endoWnafT1 = [, , , ,], this._endoWnafT2 = [, , , ,];
  }
  inherits$12(ShortCurve, Base$2), module2.exports = ShortCurve, ShortCurve.prototype._getEndomorphism = function(conf) {
    if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
      var beta, lambda;
      if (conf.beta) beta = new BN$11(conf.beta, 16).toRed(this.red);
      else {
        var betas = this._getEndoRoots(this.p);
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1], beta = beta.toRed(this.red);
      }
      if (conf.lambda) lambda = new BN$11(conf.lambda, 16);
      else {
        var lambdas = this._getEndoRoots(this.n);
        this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0 ? lambda = lambdas[0] : (lambda = lambdas[1], assert$16(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0));
      }
      var basis;
      return basis = conf.basis ? conf.basis.map(function(vec) {
        return { a: new BN$11(vec.a, 16), b: new BN$11(vec.b, 16) };
      }) : this._getEndoBasis(lambda), { beta, lambda, basis };
    }
  }, ShortCurve.prototype._getEndoRoots = function(num) {
    var red$1 = num === this.p ? this.red : BN$11.mont(num), tinv = new BN$11(2).toRed(red$1).redInvm(), ntinv = tinv.redNeg(), s$6 = new BN$11(3).toRed(red$1).redNeg().redSqrt().redMul(tinv), l1 = ntinv.redAdd(s$6).fromRed(), l2 = ntinv.redSub(s$6).fromRed();
    return [l1, l2];
  }, ShortCurve.prototype._getEndoBasis = function(lambda) {
    for (var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), u = lambda, v$1 = this.n.clone(), x1 = new BN$11(1), y1 = new BN$11(0), x2 = new BN$11(0), y2 = new BN$11(1), a0, b0, a1, b1, a2, b2, prevR, i$4 = 0, r$2, x$1; u.cmpn(0) !== 0; ) {
      var q = v$1.div(u);
      r$2 = v$1.sub(q.mul(u)), x$1 = x2.sub(q.mul(x1));
      var y$1 = y2.sub(q.mul(y1));
      if (!a1 && r$2.cmp(aprxSqrt) < 0) a0 = prevR.neg(), b0 = x1, a1 = r$2.neg(), b1 = x$1;
      else if (a1 && ++i$4 === 2) break;
      prevR = r$2, v$1 = u, u = r$2, x2 = x1, x1 = x$1, y2 = y1, y1 = y$1;
    }
    a2 = r$2.neg(), b2 = x$1;
    var len1 = a1.sqr().add(b1.sqr()), len2 = a2.sqr().add(b2.sqr());
    return len2.cmp(len1) >= 0 && (a2 = a0, b2 = b0), a1.negative && (a1 = a1.neg(), b1 = b1.neg()), a2.negative && (a2 = a2.neg(), b2 = b2.neg()), [{ a: a1, b: b1 }, { a: a2, b: b2 }];
  }, ShortCurve.prototype._endoSplit = function(k) {
    var basis = this.endo.basis, v1 = basis[0], v2 = basis[1], c1 = v2.b.mul(k).divRound(this.n), c2 = v1.b.neg().mul(k).divRound(this.n), p1 = c1.mul(v1.a), p2 = c2.mul(v2.a), q1 = c1.mul(v1.b), q2 = c2.mul(v2.b), k1 = k.sub(p1).sub(p2), k2 = q1.add(q2).neg();
    return { k1, k2 };
  }, ShortCurve.prototype.pointFromX = function(x$1, odd) {
    x$1 = new BN$11(x$1, 16), x$1.red || (x$1 = x$1.toRed(this.red));
    var y2 = x$1.redSqr().redMul(x$1).redIAdd(x$1.redMul(this.a)).redIAdd(this.b), y$1 = y2.redSqrt();
    if (y$1.redSqr().redSub(y2).cmp(this.zero) !== 0) throw Error(`invalid point`);
    var isOdd = y$1.fromRed().isOdd();
    return (odd && !isOdd || !odd && isOdd) && (y$1 = y$1.redNeg()), this.point(x$1, y$1);
  }, ShortCurve.prototype.validate = function(point) {
    if (point.inf) return true;
    var x$1 = point.x, y$1 = point.y, ax = this.a.redMul(x$1), rhs = x$1.redSqr().redMul(x$1).redIAdd(ax).redIAdd(this.b);
    return y$1.redSqr().redISub(rhs).cmpn(0) === 0;
  }, ShortCurve.prototype._endoWnafMulAdd = function(points, coeffs, jacobianResult) {
    for (var npoints = this._endoWnafT1, ncoeffs = this._endoWnafT2, i$4 = 0; i$4 < points.length; i$4++) {
      var split = this._endoSplit(coeffs[i$4]), p$1 = points[i$4], beta = p$1._getBeta();
      split.k1.negative && (split.k1.ineg(), p$1 = p$1.neg(true)), split.k2.negative && (split.k2.ineg(), beta = beta.neg(true)), npoints[i$4 * 2] = p$1, npoints[i$4 * 2 + 1] = beta, ncoeffs[i$4 * 2] = split.k1, ncoeffs[i$4 * 2 + 1] = split.k2;
    }
    for (var res = this._wnafMulAdd(1, npoints, ncoeffs, i$4 * 2, jacobianResult), j$1 = 0; j$1 < i$4 * 2; j$1++) npoints[j$1] = null, ncoeffs[j$1] = null;
    return res;
  };
  function Point$2(curve$2, x$1, y$1, isRed) {
    Base$2.BasePoint.call(this, curve$2, `affine`), x$1 === null && y$1 === null ? (this.x = null, this.y = null, this.inf = true) : (this.x = new BN$11(x$1, 16), this.y = new BN$11(y$1, 16), isRed && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = false);
  }
  inherits$12(Point$2, Base$2.BasePoint), ShortCurve.prototype.point = function(x$1, y$1, isRed) {
    return new Point$2(this, x$1, y$1, isRed);
  }, ShortCurve.prototype.pointFromJSON = function(obj, red$1) {
    return Point$2.fromJSON(this, obj, red$1);
  }, Point$2.prototype._getBeta = function() {
    if (this.curve.endo) {
      var pre$1 = this.precomputed;
      if (pre$1 && pre$1.beta) return pre$1.beta;
      var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
      if (pre$1) {
        var curve$2 = this.curve, endoMul = function(p$1) {
          return curve$2.point(p$1.x.redMul(curve$2.endo.beta), p$1.y);
        };
        pre$1.beta = beta, beta.precomputed = { beta: null, naf: pre$1.naf && { wnd: pre$1.naf.wnd, points: pre$1.naf.points.map(endoMul) }, doubles: pre$1.doubles && { step: pre$1.doubles.step, points: pre$1.doubles.points.map(endoMul) } };
      }
      return beta;
    }
  }, Point$2.prototype.toJSON = function() {
    return this.precomputed ? [this.x, this.y, this.precomputed && { doubles: this.precomputed.doubles && { step: this.precomputed.doubles.step, points: this.precomputed.doubles.points.slice(1) }, naf: this.precomputed.naf && { wnd: this.precomputed.naf.wnd, points: this.precomputed.naf.points.slice(1) } }] : [this.x, this.y];
  }, Point$2.fromJSON = function(curve$2, obj, red$1) {
    typeof obj == `string` && (obj = JSON.parse(obj));
    var res = curve$2.point(obj[0], obj[1], red$1);
    if (!obj[2]) return res;
    function obj2point(obj$1) {
      return curve$2.point(obj$1[0], obj$1[1], red$1);
    }
    var pre$1 = obj[2];
    return res.precomputed = { beta: null, doubles: pre$1.doubles && { step: pre$1.doubles.step, points: [res].concat(pre$1.doubles.points.map(obj2point)) }, naf: pre$1.naf && { wnd: pre$1.naf.wnd, points: [res].concat(pre$1.naf.points.map(obj2point)) } }, res;
  }, Point$2.prototype.inspect = function() {
    return this.isInfinity() ? `<EC Point Infinity>` : `<EC Point x: ` + this.x.fromRed().toString(16, 2) + ` y: ` + this.y.fromRed().toString(16, 2) + `>`;
  }, Point$2.prototype.isInfinity = function() {
    return this.inf;
  }, Point$2.prototype.add = function(p$1) {
    if (this.inf) return p$1;
    if (p$1.inf) return this;
    if (this.eq(p$1)) return this.dbl();
    if (this.neg().eq(p$1) || this.x.cmp(p$1.x) === 0) return this.curve.point(null, null);
    var c$12 = this.y.redSub(p$1.y);
    c$12.cmpn(0) !== 0 && (c$12 = c$12.redMul(this.x.redSub(p$1.x).redInvm()));
    var nx = c$12.redSqr().redISub(this.x).redISub(p$1.x), ny = c$12.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
  }, Point$2.prototype.dbl = function() {
    if (this.inf) return this;
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a$22 = this.curve.a, x2 = this.x.redSqr(), dyinv = ys1.redInvm(), c$12 = x2.redAdd(x2).redIAdd(x2).redIAdd(a$22).redMul(dyinv), nx = c$12.redSqr().redISub(this.x.redAdd(this.x)), ny = c$12.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
  }, Point$2.prototype.getX = function() {
    return this.x.fromRed();
  }, Point$2.prototype.getY = function() {
    return this.y.fromRed();
  }, Point$2.prototype.mul = function(k) {
    return k = new BN$11(k, 16), this.isInfinity() ? this : this._hasDoubles(k) ? this.curve._fixedNafMul(this, k) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [k]) : this.curve._wnafMul(this, k);
  }, Point$2.prototype.mulAdd = function(k1, p2, k2) {
    var points = [this, p2], coeffs = [k1, k2];
    return this.curve.endo ? this.curve._endoWnafMulAdd(points, coeffs) : this.curve._wnafMulAdd(1, points, coeffs, 2);
  }, Point$2.prototype.jmulAdd = function(k1, p2, k2) {
    var points = [this, p2], coeffs = [k1, k2];
    return this.curve.endo ? this.curve._endoWnafMulAdd(points, coeffs, true) : this.curve._wnafMulAdd(1, points, coeffs, 2, true);
  }, Point$2.prototype.eq = function(p$1) {
    return this === p$1 || this.inf === p$1.inf && (this.inf || this.x.cmp(p$1.x) === 0 && this.y.cmp(p$1.y) === 0);
  }, Point$2.prototype.neg = function(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
      var pre$1 = this.precomputed, negate$3 = function(p$1) {
        return p$1.neg();
      };
      res.precomputed = { naf: pre$1.naf && { wnd: pre$1.naf.wnd, points: pre$1.naf.points.map(negate$3) }, doubles: pre$1.doubles && { step: pre$1.doubles.step, points: pre$1.doubles.points.map(negate$3) } };
    }
    return res;
  }, Point$2.prototype.toJ = function() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
  };
  function JPoint(curve$2, x$1, y$1, z$1) {
    Base$2.BasePoint.call(this, curve$2, `jacobian`), x$1 === null && y$1 === null && z$1 === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new BN$11(0)) : (this.x = new BN$11(x$1, 16), this.y = new BN$11(y$1, 16), this.z = new BN$11(z$1, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
  }
  inherits$12(JPoint, Base$2.BasePoint), ShortCurve.prototype.jpoint = function(x$1, y$1, z$1) {
    return new JPoint(this, x$1, y$1, z$1);
  }, JPoint.prototype.toP = function() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm(), zinv2 = zinv.redSqr(), ax = this.x.redMul(zinv2), ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
  }, JPoint.prototype.neg = function() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
  }, JPoint.prototype.add = function(p$1) {
    if (this.isInfinity()) return p$1;
    if (p$1.isInfinity()) return this;
    var pz2 = p$1.z.redSqr(), z2 = this.z.redSqr(), u1 = this.x.redMul(pz2), u2 = p$1.x.redMul(z2), s1 = this.y.redMul(pz2.redMul(p$1.z)), s2 = p$1.y.redMul(z2.redMul(this.z)), h$1 = u1.redSub(u2), r$2 = s1.redSub(s2);
    if (h$1.cmpn(0) === 0) return r$2.cmpn(0) === 0 ? this.dbl() : this.curve.jpoint(null, null, null);
    var h2 = h$1.redSqr(), h3 = h2.redMul(h$1), v$1 = u1.redMul(h2), nx = r$2.redSqr().redIAdd(h3).redISub(v$1).redISub(v$1), ny = r$2.redMul(v$1.redISub(nx)).redISub(s1.redMul(h3)), nz = this.z.redMul(p$1.z).redMul(h$1);
    return this.curve.jpoint(nx, ny, nz);
  }, JPoint.prototype.mixedAdd = function(p$1) {
    if (this.isInfinity()) return p$1.toJ();
    if (p$1.isInfinity()) return this;
    var z2 = this.z.redSqr(), u1 = this.x, u2 = p$1.x.redMul(z2), s1 = this.y, s2 = p$1.y.redMul(z2).redMul(this.z), h$1 = u1.redSub(u2), r$2 = s1.redSub(s2);
    if (h$1.cmpn(0) === 0) return r$2.cmpn(0) === 0 ? this.dbl() : this.curve.jpoint(null, null, null);
    var h2 = h$1.redSqr(), h3 = h2.redMul(h$1), v$1 = u1.redMul(h2), nx = r$2.redSqr().redIAdd(h3).redISub(v$1).redISub(v$1), ny = r$2.redMul(v$1.redISub(nx)).redISub(s1.redMul(h3)), nz = this.z.redMul(h$1);
    return this.curve.jpoint(nx, ny, nz);
  }, JPoint.prototype.dblp = function(pow$1) {
    if (pow$1 === 0 || this.isInfinity()) return this;
    if (!pow$1) return this.dbl();
    var i$4;
    if (this.curve.zeroA || this.curve.threeA) {
      var r$2 = this;
      for (i$4 = 0; i$4 < pow$1; i$4++) r$2 = r$2.dbl();
      return r$2;
    }
    var a$22 = this.curve.a, tinv = this.curve.tinv, jx = this.x, jy = this.y, jz = this.z, jz4 = jz.redSqr().redSqr(), jyd = jy.redAdd(jy);
    for (i$4 = 0; i$4 < pow$1; i$4++) {
      var jx2 = jx.redSqr(), jyd2 = jyd.redSqr(), jyd4 = jyd2.redSqr(), c$12 = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a$22.redMul(jz4)), t1 = jx.redMul(jyd2), nx = c$12.redSqr().redISub(t1.redAdd(t1)), t2 = t1.redISub(nx), dny = c$12.redMul(t2);
      dny = dny.redIAdd(dny).redISub(jyd4);
      var nz = jyd.redMul(jz);
      i$4 + 1 < pow$1 && (jz4 = jz4.redMul(jyd4)), jx = nx, jz = nz, jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
  }, JPoint.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
  }, JPoint.prototype._zeroDbl = function() {
    var nx, ny, nz;
    if (this.zOne) {
      var xx = this.x.redSqr(), yy = this.y.redSqr(), yyyy = yy.redSqr(), s$6 = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
      s$6 = s$6.redIAdd(s$6);
      var m$3 = xx.redAdd(xx).redIAdd(xx), t$7 = m$3.redSqr().redISub(s$6).redISub(s$6), yyyy8 = yyyy.redIAdd(yyyy);
      yyyy8 = yyyy8.redIAdd(yyyy8), yyyy8 = yyyy8.redIAdd(yyyy8), nx = t$7, ny = m$3.redMul(s$6.redISub(t$7)).redISub(yyyy8), nz = this.y.redAdd(this.y);
    } else {
      var a$22 = this.x.redSqr(), b2 = this.y.redSqr(), c$12 = b2.redSqr(), d$12 = this.x.redAdd(b2).redSqr().redISub(a$22).redISub(c$12);
      d$12 = d$12.redIAdd(d$12);
      var e$22 = a$22.redAdd(a$22).redIAdd(a$22), f$32 = e$22.redSqr(), c8 = c$12.redIAdd(c$12);
      c8 = c8.redIAdd(c8), c8 = c8.redIAdd(c8), nx = f$32.redISub(d$12).redISub(d$12), ny = e$22.redMul(d$12.redISub(nx)).redISub(c8), nz = this.y.redMul(this.z), nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
  }, JPoint.prototype._threeDbl = function() {
    var nx, ny, nz;
    if (this.zOne) {
      var xx = this.x.redSqr(), yy = this.y.redSqr(), yyyy = yy.redSqr(), s$6 = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
      s$6 = s$6.redIAdd(s$6);
      var m$3 = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a), t$7 = m$3.redSqr().redISub(s$6).redISub(s$6);
      nx = t$7;
      var yyyy8 = yyyy.redIAdd(yyyy);
      yyyy8 = yyyy8.redIAdd(yyyy8), yyyy8 = yyyy8.redIAdd(yyyy8), ny = m$3.redMul(s$6.redISub(t$7)).redISub(yyyy8), nz = this.y.redAdd(this.y);
    } else {
      var delta = this.z.redSqr(), gamma = this.y.redSqr(), beta = this.x.redMul(gamma), alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
      alpha = alpha.redAdd(alpha).redIAdd(alpha);
      var beta4 = beta.redIAdd(beta);
      beta4 = beta4.redIAdd(beta4);
      var beta8 = beta4.redAdd(beta4);
      nx = alpha.redSqr().redISub(beta8), nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
      var ggamma8 = gamma.redSqr();
      ggamma8 = ggamma8.redIAdd(ggamma8), ggamma8 = ggamma8.redIAdd(ggamma8), ggamma8 = ggamma8.redIAdd(ggamma8), ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
  }, JPoint.prototype._dbl = function() {
    var a$22 = this.curve.a, jx = this.x, jy = this.y, jz = this.z, jz4 = jz.redSqr().redSqr(), jx2 = jx.redSqr(), jy2 = jy.redSqr(), c$12 = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a$22.redMul(jz4)), jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2), nx = c$12.redSqr().redISub(t1.redAdd(t1)), t2 = t1.redISub(nx), jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8), jyd8 = jyd8.redIAdd(jyd8), jyd8 = jyd8.redIAdd(jyd8);
    var ny = c$12.redMul(t2).redISub(jyd8), nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
  }, JPoint.prototype.trpl = function() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    var xx = this.x.redSqr(), yy = this.y.redSqr(), zz = this.z.redSqr(), yyyy = yy.redSqr(), m$3 = xx.redAdd(xx).redIAdd(xx), mm = m$3.redSqr(), e$22 = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e$22 = e$22.redIAdd(e$22), e$22 = e$22.redAdd(e$22).redIAdd(e$22), e$22 = e$22.redISub(mm);
    var ee$1 = e$22.redSqr(), t$7 = yyyy.redIAdd(yyyy);
    t$7 = t$7.redIAdd(t$7), t$7 = t$7.redIAdd(t$7), t$7 = t$7.redIAdd(t$7);
    var u = m$3.redIAdd(e$22).redSqr().redISub(mm).redISub(ee$1).redISub(t$7), yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4), yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee$1).redISub(yyu4);
    nx = nx.redIAdd(nx), nx = nx.redIAdd(nx);
    var ny = this.y.redMul(u.redMul(t$7.redISub(u)).redISub(e$22.redMul(ee$1)));
    ny = ny.redIAdd(ny), ny = ny.redIAdd(ny), ny = ny.redIAdd(ny);
    var nz = this.z.redAdd(e$22).redSqr().redISub(zz).redISub(ee$1);
    return this.curve.jpoint(nx, ny, nz);
  }, JPoint.prototype.mul = function(k, kbase) {
    return k = new BN$11(k, kbase), this.curve._wnafMul(this, k);
  }, JPoint.prototype.eq = function(p$1) {
    if (p$1.type === `affine`) return this.eq(p$1.toJ());
    if (this === p$1) return true;
    var z2 = this.z.redSqr(), pz2 = p$1.z.redSqr();
    if (this.x.redMul(pz2).redISub(p$1.x.redMul(z2)).cmpn(0) !== 0) return false;
    var z3 = z2.redMul(this.z), pz3 = pz2.redMul(p$1.z);
    return this.y.redMul(pz3).redISub(p$1.y.redMul(z3)).cmpn(0) === 0;
  }, JPoint.prototype.eqXToP = function(x$1) {
    var zs = this.z.redSqr(), rx = x$1.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    for (var xc = x$1.clone(), t$7 = this.curve.redN.redMul(zs); ; ) {
      if (xc.iadd(this.curve.n), xc.cmp(this.curve.p) >= 0) return false;
      if (rx.redIAdd(t$7), this.x.cmp(rx) === 0) return true;
    }
  }, JPoint.prototype.inspect = function() {
    return this.isInfinity() ? `<EC JPoint Infinity>` : `<EC JPoint x: ` + this.x.toString(16, 2) + ` y: ` + this.y.toString(16, 2) + ` z: ` + this.z.toString(16, 2) + `>`;
  }, JPoint.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  };
}), require_mont = __commonJSMin$1((exports$12, module2) => {
  var BN$10 = require_bn$1(), inherits$11 = require_inherits(), Base$1 = require_base$1(), utils$20 = require_utils$3();
  function MontCurve(conf) {
    Base$1.call(this, `mont`, conf), this.a = new BN$10(conf.a, 16).toRed(this.red), this.b = new BN$10(conf.b, 16).toRed(this.red), this.i4 = new BN$10(4).toRed(this.red).redInvm(), this.two = new BN$10(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
  }
  inherits$11(MontCurve, Base$1), module2.exports = MontCurve, MontCurve.prototype.validate = function(point) {
    var x$1 = point.normalize().x, x2 = x$1.redSqr(), rhs = x2.redMul(x$1).redAdd(x2.redMul(this.a)).redAdd(x$1), y$1 = rhs.redSqrt();
    return y$1.redSqr().cmp(rhs) === 0;
  };
  function Point$1(curve$2, x$1, z$1) {
    Base$1.BasePoint.call(this, curve$2, `projective`), x$1 === null && z$1 === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new BN$10(x$1, 16), this.z = new BN$10(z$1, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
  }
  inherits$11(Point$1, Base$1.BasePoint), MontCurve.prototype.decodePoint = function(bytes, enc) {
    return this.point(utils$20.toArray(bytes, enc), 1);
  }, MontCurve.prototype.point = function(x$1, z$1) {
    return new Point$1(this, x$1, z$1);
  }, MontCurve.prototype.pointFromJSON = function(obj) {
    return Point$1.fromJSON(this, obj);
  }, Point$1.prototype.precompute = function() {
  }, Point$1.prototype._encode = function() {
    return this.getX().toArray(`be`, this.curve.p.byteLength());
  }, Point$1.fromJSON = function(curve$2, obj) {
    return new Point$1(curve$2, obj[0], obj[1] || curve$2.one);
  }, Point$1.prototype.inspect = function() {
    return this.isInfinity() ? `<EC Point Infinity>` : `<EC Point x: ` + this.x.fromRed().toString(16, 2) + ` z: ` + this.z.fromRed().toString(16, 2) + `>`;
  }, Point$1.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, Point$1.prototype.dbl = function() {
    var a$22 = this.x.redAdd(this.z), aa = a$22.redSqr(), b2 = this.x.redSub(this.z), bb = b2.redSqr(), c$12 = aa.redSub(bb), nx = aa.redMul(bb), nz = c$12.redMul(bb.redAdd(this.curve.a24.redMul(c$12)));
    return this.curve.point(nx, nz);
  }, Point$1.prototype.add = function() {
    throw Error(`Not supported on Montgomery curve`);
  }, Point$1.prototype.diffAdd = function(p$1, diff$4) {
    var a$22 = this.x.redAdd(this.z), b2 = this.x.redSub(this.z), c$12 = p$1.x.redAdd(p$1.z), d$12 = p$1.x.redSub(p$1.z), da = d$12.redMul(a$22), cb = c$12.redMul(b2), nx = diff$4.z.redMul(da.redAdd(cb).redSqr()), nz = diff$4.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
  }, Point$1.prototype.mul = function(k) {
    for (var t$7 = k.clone(), a$22 = this, b2 = this.curve.point(null, null), c$12 = this, bits$1 = []; t$7.cmpn(0) !== 0; t$7.iushrn(1)) bits$1.push(t$7.andln(1));
    for (var i$4 = bits$1.length - 1; i$4 >= 0; i$4--) bits$1[i$4] === 0 ? (a$22 = a$22.diffAdd(b2, c$12), b2 = b2.dbl()) : (b2 = a$22.diffAdd(b2, c$12), a$22 = a$22.dbl());
    return b2;
  }, Point$1.prototype.mulAdd = function() {
    throw Error(`Not supported on Montgomery curve`);
  }, Point$1.prototype.jumlAdd = function() {
    throw Error(`Not supported on Montgomery curve`);
  }, Point$1.prototype.eq = function(other) {
    return this.getX().cmp(other.getX()) === 0;
  }, Point$1.prototype.normalize = function() {
    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
  }, Point$1.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  };
}), require_edwards = __commonJSMin$1((exports$12, module2) => {
  var utils$19 = require_utils$3(), BN$9 = require_bn$1(), inherits$10 = require_inherits(), Base = require_base$1(), assert$15 = utils$19.assert;
  function EdwardsCurve(conf) {
    this.twisted = (conf.a | 0) != 1, this.mOneA = this.twisted && (conf.a | 0) == -1, this.extended = this.mOneA, Base.call(this, `edwards`, conf), this.a = new BN$9(conf.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new BN$9(conf.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new BN$9(conf.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), assert$15(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (conf.c | 0) == 1;
  }
  inherits$10(EdwardsCurve, Base), module2.exports = EdwardsCurve, EdwardsCurve.prototype._mulA = function(num) {
    return this.mOneA ? num.redNeg() : this.a.redMul(num);
  }, EdwardsCurve.prototype._mulC = function(num) {
    return this.oneC ? num : this.c.redMul(num);
  }, EdwardsCurve.prototype.jpoint = function(x$1, y$1, z$1, t$7) {
    return this.point(x$1, y$1, z$1, t$7);
  }, EdwardsCurve.prototype.pointFromX = function(x$1, odd) {
    x$1 = new BN$9(x$1, 16), x$1.red || (x$1 = x$1.toRed(this.red));
    var x2 = x$1.redSqr(), rhs = this.c2.redSub(this.a.redMul(x2)), lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2)), y2 = rhs.redMul(lhs.redInvm()), y$1 = y2.redSqrt();
    if (y$1.redSqr().redSub(y2).cmp(this.zero) !== 0) throw Error(`invalid point`);
    var isOdd = y$1.fromRed().isOdd();
    return (odd && !isOdd || !odd && isOdd) && (y$1 = y$1.redNeg()), this.point(x$1, y$1);
  }, EdwardsCurve.prototype.pointFromY = function(y$1, odd) {
    y$1 = new BN$9(y$1, 16), y$1.red || (y$1 = y$1.toRed(this.red));
    var y2 = y$1.redSqr(), lhs = y2.redSub(this.c2), rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a), x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
      if (odd) throw Error(`invalid point`);
      return this.point(this.zero, y$1);
    }
    var x$1 = x2.redSqrt();
    if (x$1.redSqr().redSub(x2).cmp(this.zero) !== 0) throw Error(`invalid point`);
    return x$1.fromRed().isOdd() !== odd && (x$1 = x$1.redNeg()), this.point(x$1, y$1);
  }, EdwardsCurve.prototype.validate = function(point) {
    if (point.isInfinity()) return true;
    point.normalize();
    var x2 = point.x.redSqr(), y2 = point.y.redSqr(), lhs = x2.redMul(this.a).redAdd(y2), rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
  };
  function Point(curve$2, x$1, y$1, z$1, t$7) {
    Base.BasePoint.call(this, curve$2, `projective`), x$1 === null && y$1 === null && z$1 === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = true) : (this.x = new BN$9(x$1, 16), this.y = new BN$9(y$1, 16), this.z = z$1 ? new BN$9(z$1, 16) : this.curve.one, this.t = t$7 && new BN$9(t$7, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
  }
  inherits$10(Point, Base.BasePoint), EdwardsCurve.prototype.pointFromJSON = function(obj) {
    return Point.fromJSON(this, obj);
  }, EdwardsCurve.prototype.point = function(x$1, y$1, z$1, t$7) {
    return new Point(this, x$1, y$1, z$1, t$7);
  }, Point.fromJSON = function(curve$2, obj) {
    return new Point(curve$2, obj[0], obj[1], obj[2]);
  }, Point.prototype.inspect = function() {
    return this.isInfinity() ? `<EC Point Infinity>` : `<EC Point x: ` + this.x.fromRed().toString(16, 2) + ` y: ` + this.y.fromRed().toString(16, 2) + ` z: ` + this.z.fromRed().toString(16, 2) + `>`;
  }, Point.prototype.isInfinity = function() {
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
  }, Point.prototype._extDbl = function() {
    var a$22 = this.x.redSqr(), b2 = this.y.redSqr(), c$12 = this.z.redSqr();
    c$12 = c$12.redIAdd(c$12);
    var d$12 = this.curve._mulA(a$22), e$22 = this.x.redAdd(this.y).redSqr().redISub(a$22).redISub(b2), g$22 = d$12.redAdd(b2), f$32 = g$22.redSub(c$12), h$1 = d$12.redSub(b2), nx = e$22.redMul(f$32), ny = g$22.redMul(h$1), nt = e$22.redMul(h$1), nz = f$32.redMul(g$22);
    return this.curve.point(nx, ny, nz, nt);
  }, Point.prototype._projDbl = function() {
    var b2 = this.x.redAdd(this.y).redSqr(), c$12 = this.x.redSqr(), d$12 = this.y.redSqr(), nx, ny, nz, e$22, h$1, j$1;
    if (this.curve.twisted) {
      e$22 = this.curve._mulA(c$12);
      var f$32 = e$22.redAdd(d$12);
      this.zOne ? (nx = b2.redSub(c$12).redSub(d$12).redMul(f$32.redSub(this.curve.two)), ny = f$32.redMul(e$22.redSub(d$12)), nz = f$32.redSqr().redSub(f$32).redSub(f$32)) : (h$1 = this.z.redSqr(), j$1 = f$32.redSub(h$1).redISub(h$1), nx = b2.redSub(c$12).redISub(d$12).redMul(j$1), ny = f$32.redMul(e$22.redSub(d$12)), nz = f$32.redMul(j$1));
    } else e$22 = c$12.redAdd(d$12), h$1 = this.curve._mulC(this.z).redSqr(), j$1 = e$22.redSub(h$1).redSub(h$1), nx = this.curve._mulC(b2.redISub(e$22)).redMul(j$1), ny = this.curve._mulC(e$22).redMul(c$12.redISub(d$12)), nz = e$22.redMul(j$1);
    return this.curve.point(nx, ny, nz);
  }, Point.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
  }, Point.prototype._extAdd = function(p$1) {
    var a$22 = this.y.redSub(this.x).redMul(p$1.y.redSub(p$1.x)), b2 = this.y.redAdd(this.x).redMul(p$1.y.redAdd(p$1.x)), c$12 = this.t.redMul(this.curve.dd).redMul(p$1.t), d$12 = this.z.redMul(p$1.z.redAdd(p$1.z)), e$22 = b2.redSub(a$22), f$32 = d$12.redSub(c$12), g$22 = d$12.redAdd(c$12), h$1 = b2.redAdd(a$22), nx = e$22.redMul(f$32), ny = g$22.redMul(h$1), nt = e$22.redMul(h$1), nz = f$32.redMul(g$22);
    return this.curve.point(nx, ny, nz, nt);
  }, Point.prototype._projAdd = function(p$1) {
    var a$22 = this.z.redMul(p$1.z), b2 = a$22.redSqr(), c$12 = this.x.redMul(p$1.x), d$12 = this.y.redMul(p$1.y), e$22 = this.curve.d.redMul(c$12).redMul(d$12), f$32 = b2.redSub(e$22), g$22 = b2.redAdd(e$22), tmp = this.x.redAdd(this.y).redMul(p$1.x.redAdd(p$1.y)).redISub(c$12).redISub(d$12), nx = a$22.redMul(f$32).redMul(tmp), ny, nz;
    return this.curve.twisted ? (ny = a$22.redMul(g$22).redMul(d$12.redSub(this.curve._mulA(c$12))), nz = f$32.redMul(g$22)) : (ny = a$22.redMul(g$22).redMul(d$12.redSub(c$12)), nz = this.curve._mulC(f$32).redMul(g$22)), this.curve.point(nx, ny, nz);
  }, Point.prototype.add = function(p$1) {
    return this.isInfinity() ? p$1 : p$1.isInfinity() ? this : this.curve.extended ? this._extAdd(p$1) : this._projAdd(p$1);
  }, Point.prototype.mul = function(k) {
    return this._hasDoubles(k) ? this.curve._fixedNafMul(this, k) : this.curve._wnafMul(this, k);
  }, Point.prototype.mulAdd = function(k1, p$1, k2) {
    return this.curve._wnafMulAdd(1, [this, p$1], [k1, k2], 2, false);
  }, Point.prototype.jmulAdd = function(k1, p$1, k2) {
    return this.curve._wnafMulAdd(1, [this, p$1], [k1, k2], 2, true);
  }, Point.prototype.normalize = function() {
    if (this.zOne) return this;
    var zi = this.z.redInvm();
    return this.x = this.x.redMul(zi), this.y = this.y.redMul(zi), this.t &&= this.t.redMul(zi), this.z = this.curve.one, this.zOne = true, this;
  }, Point.prototype.neg = function() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
  }, Point.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, Point.prototype.getY = function() {
    return this.normalize(), this.y.fromRed();
  }, Point.prototype.eq = function(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
  }, Point.prototype.eqXToP = function(x$1) {
    var rx = x$1.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    for (var xc = x$1.clone(), t$7 = this.curve.redN.redMul(this.z); ; ) {
      if (xc.iadd(this.curve.n), xc.cmp(this.curve.p) >= 0) return false;
      if (rx.redIAdd(t$7), this.x.cmp(rx) === 0) return true;
    }
  }, Point.prototype.toP = Point.prototype.normalize, Point.prototype.mixedAdd = Point.prototype.add;
}), require_curve = __commonJSMin$1((exports$12) => {
  var curve$1 = exports$12;
  curve$1.base = require_base$1(), curve$1.short = require_short(), curve$1.mont = require_mont(), curve$1.edwards = require_edwards();
}), require_utils$2 = __commonJSMin$1((exports$12) => {
  var assert$14 = require_minimalistic_assert(), inherits$9 = require_inherits();
  exports$12.inherits = inherits$9;
  function isSurrogatePair(msg, i$4) {
    return (msg.charCodeAt(i$4) & 64512) != 55296 || i$4 < 0 || i$4 + 1 >= msg.length ? false : (msg.charCodeAt(i$4 + 1) & 64512) == 56320;
  }
  function toArray$1(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg == `string`) if (enc) {
      if (enc === `hex`) for (msg = msg.replace(/[^a-z0-9]+/gi, ``), msg.length % 2 != 0 && (msg = `0` + msg), i$4 = 0; i$4 < msg.length; i$4 += 2) res.push(parseInt(msg[i$4] + msg[i$4 + 1], 16));
    } else for (var p$1 = 0, i$4 = 0; i$4 < msg.length; i$4++) {
      var c$12 = msg.charCodeAt(i$4);
      c$12 < 128 ? res[p$1++] = c$12 : c$12 < 2048 ? (res[p$1++] = c$12 >> 6 | 192, res[p$1++] = c$12 & 63 | 128) : isSurrogatePair(msg, i$4) ? (c$12 = 65536 + ((c$12 & 1023) << 10) + (msg.charCodeAt(++i$4) & 1023), res[p$1++] = c$12 >> 18 | 240, res[p$1++] = c$12 >> 12 & 63 | 128, res[p$1++] = c$12 >> 6 & 63 | 128, res[p$1++] = c$12 & 63 | 128) : (res[p$1++] = c$12 >> 12 | 224, res[p$1++] = c$12 >> 6 & 63 | 128, res[p$1++] = c$12 & 63 | 128);
    }
    else for (i$4 = 0; i$4 < msg.length; i$4++) res[i$4] = msg[i$4] | 0;
    return res;
  }
  exports$12.toArray = toArray$1;
  function toHex(msg) {
    for (var res = ``, i$4 = 0; i$4 < msg.length; i$4++) res += zero2(msg[i$4].toString(16));
    return res;
  }
  exports$12.toHex = toHex;
  function htonl(w$1) {
    var res = w$1 >>> 24 | w$1 >>> 8 & 65280 | w$1 << 8 & 16711680 | (w$1 & 255) << 24;
    return res >>> 0;
  }
  exports$12.htonl = htonl;
  function toHex32(msg, endian) {
    for (var res = ``, i$4 = 0; i$4 < msg.length; i$4++) {
      var w$1 = msg[i$4];
      endian === `little` && (w$1 = htonl(w$1)), res += zero8(w$1.toString(16));
    }
    return res;
  }
  exports$12.toHex32 = toHex32;
  function zero2(word) {
    return word.length === 1 ? `0` + word : word;
  }
  exports$12.zero2 = zero2;
  function zero8(word) {
    return word.length === 7 ? `0` + word : word.length === 6 ? `00` + word : word.length === 5 ? `000` + word : word.length === 4 ? `0000` + word : word.length === 3 ? `00000` + word : word.length === 2 ? `000000` + word : word.length === 1 ? `0000000` + word : word;
  }
  exports$12.zero8 = zero8;
  function join32(msg, start, end, endian) {
    var len$2 = end - start;
    assert$14(len$2 % 4 == 0);
    for (var res = Array(len$2 / 4), i$4 = 0, k = start; i$4 < res.length; i$4++, k += 4) {
      var w$1;
      w$1 = endian === `big` ? msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3] : msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k], res[i$4] = w$1 >>> 0;
    }
    return res;
  }
  exports$12.join32 = join32;
  function split32(msg, endian) {
    for (var res = Array(msg.length * 4), i$4 = 0, k = 0; i$4 < msg.length; i$4++, k += 4) {
      var m$3 = msg[i$4];
      endian === `big` ? (res[k] = m$3 >>> 24, res[k + 1] = m$3 >>> 16 & 255, res[k + 2] = m$3 >>> 8 & 255, res[k + 3] = m$3 & 255) : (res[k + 3] = m$3 >>> 24, res[k + 2] = m$3 >>> 16 & 255, res[k + 1] = m$3 >>> 8 & 255, res[k] = m$3 & 255);
    }
    return res;
  }
  exports$12.split32 = split32;
  function rotr32$1(w$1, b2) {
    return w$1 >>> b2 | w$1 << 32 - b2;
  }
  exports$12.rotr32 = rotr32$1;
  function rotl32$2(w$1, b2) {
    return w$1 << b2 | w$1 >>> 32 - b2;
  }
  exports$12.rotl32 = rotl32$2;
  function sum32$3(a$22, b2) {
    return a$22 + b2 >>> 0;
  }
  exports$12.sum32 = sum32$3;
  function sum32_3$1(a$22, b2, c$12) {
    return a$22 + b2 + c$12 >>> 0;
  }
  exports$12.sum32_3 = sum32_3$1;
  function sum32_4$2(a$22, b2, c$12, d$12) {
    return a$22 + b2 + c$12 + d$12 >>> 0;
  }
  exports$12.sum32_4 = sum32_4$2;
  function sum32_5$2(a$22, b2, c$12, d$12, e$22) {
    return a$22 + b2 + c$12 + d$12 + e$22 >>> 0;
  }
  exports$12.sum32_5 = sum32_5$2;
  function sum64$1(buf, pos, ah, al) {
    var bh = buf[pos], bl = buf[pos + 1], lo = al + bl >>> 0, hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0, buf[pos + 1] = lo;
  }
  exports$12.sum64 = sum64$1;
  function sum64_hi$1(ah, al, bh, bl) {
    var lo = al + bl >>> 0, hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
  }
  exports$12.sum64_hi = sum64_hi$1;
  function sum64_lo$1(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
  }
  exports$12.sum64_lo = sum64_lo$1;
  function sum64_4_hi$1(ah, al, bh, bl, ch, cl, dh$1, dl) {
    var carry = 0, lo = al;
    lo = lo + bl >>> 0, carry += lo < al ? 1 : 0, lo = lo + cl >>> 0, carry += lo < cl ? 1 : 0, lo = lo + dl >>> 0, carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh$1 + carry;
    return hi >>> 0;
  }
  exports$12.sum64_4_hi = sum64_4_hi$1;
  function sum64_4_lo$1(ah, al, bh, bl, ch, cl, dh$1, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
  }
  exports$12.sum64_4_lo = sum64_4_lo$1;
  function sum64_5_hi$1(ah, al, bh, bl, ch, cl, dh$1, dl, eh, el) {
    var carry = 0, lo = al;
    lo = lo + bl >>> 0, carry += lo < al ? 1 : 0, lo = lo + cl >>> 0, carry += lo < cl ? 1 : 0, lo = lo + dl >>> 0, carry += lo < dl ? 1 : 0, lo = lo + el >>> 0, carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh$1 + eh + carry;
    return hi >>> 0;
  }
  exports$12.sum64_5_hi = sum64_5_hi$1;
  function sum64_5_lo$1(ah, al, bh, bl, ch, cl, dh$1, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
  }
  exports$12.sum64_5_lo = sum64_5_lo$1;
  function rotr64_hi$1(ah, al, num) {
    var r$2 = al << 32 - num | ah >>> num;
    return r$2 >>> 0;
  }
  exports$12.rotr64_hi = rotr64_hi$1;
  function rotr64_lo$1(ah, al, num) {
    var r$2 = ah << 32 - num | al >>> num;
    return r$2 >>> 0;
  }
  exports$12.rotr64_lo = rotr64_lo$1;
  function shr64_hi$1(ah, al, num) {
    return ah >>> num;
  }
  exports$12.shr64_hi = shr64_hi$1;
  function shr64_lo$1(ah, al, num) {
    var r$2 = ah << 32 - num | al >>> num;
    return r$2 >>> 0;
  }
  exports$12.shr64_lo = shr64_lo$1;
}), require_common$1 = __commonJSMin$1((exports$12) => {
  var utils$18 = require_utils$2(), assert$13 = require_minimalistic_assert();
  function BlockHash$4() {
    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = `big`, this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
  }
  exports$12.BlockHash = BlockHash$4, BlockHash$4.prototype.update = function(msg, enc) {
    if (msg = utils$18.toArray(msg, enc), this.pending ? this.pending = this.pending.concat(msg) : this.pending = msg, this.pendingTotal += msg.length, this.pending.length >= this._delta8) {
      msg = this.pending;
      var r$2 = msg.length % this._delta8;
      this.pending = msg.slice(msg.length - r$2, msg.length), this.pending.length === 0 && (this.pending = null), msg = utils$18.join32(msg, 0, msg.length - r$2, this.endian);
      for (var i$4 = 0; i$4 < msg.length; i$4 += this._delta32) this._update(msg, i$4, i$4 + this._delta32);
    }
    return this;
  }, BlockHash$4.prototype.digest = function(enc) {
    return this.update(this._pad()), assert$13(this.pending === null), this._digest(enc);
  }, BlockHash$4.prototype._pad = function() {
    var len$2 = this.pendingTotal, bytes = this._delta8, k = bytes - (len$2 + this.padLength) % bytes, res = Array(k + this.padLength);
    res[0] = 128;
    for (var i$4 = 1; i$4 < k; i$4++) res[i$4] = 0;
    if (len$2 <<= 3, this.endian === `big`) {
      for (var t$7 = 8; t$7 < this.padLength; t$7++) res[i$4++] = 0;
      res[i$4++] = 0, res[i$4++] = 0, res[i$4++] = 0, res[i$4++] = 0, res[i$4++] = len$2 >>> 24 & 255, res[i$4++] = len$2 >>> 16 & 255, res[i$4++] = len$2 >>> 8 & 255, res[i$4++] = len$2 & 255;
    } else for (res[i$4++] = len$2 & 255, res[i$4++] = len$2 >>> 8 & 255, res[i$4++] = len$2 >>> 16 & 255, res[i$4++] = len$2 >>> 24 & 255, res[i$4++] = 0, res[i$4++] = 0, res[i$4++] = 0, res[i$4++] = 0, t$7 = 8; t$7 < this.padLength; t$7++) res[i$4++] = 0;
    return res;
  };
}), require_common = __commonJSMin$1((exports$12) => {
  var utils$17 = require_utils$2(), rotr32 = utils$17.rotr32;
  function ft_1$1(s$6, x$1, y$1, z$1) {
    if (s$6 === 0) return ch32$1(x$1, y$1, z$1);
    if (s$6 === 1 || s$6 === 3) return p32(x$1, y$1, z$1);
    if (s$6 === 2) return maj32$1(x$1, y$1, z$1);
  }
  exports$12.ft_1 = ft_1$1;
  function ch32$1(x$1, y$1, z$1) {
    return x$1 & y$1 ^ ~x$1 & z$1;
  }
  exports$12.ch32 = ch32$1;
  function maj32$1(x$1, y$1, z$1) {
    return x$1 & y$1 ^ x$1 & z$1 ^ y$1 & z$1;
  }
  exports$12.maj32 = maj32$1;
  function p32(x$1, y$1, z$1) {
    return x$1 ^ y$1 ^ z$1;
  }
  exports$12.p32 = p32;
  function s0_256$1(x$1) {
    return rotr32(x$1, 2) ^ rotr32(x$1, 13) ^ rotr32(x$1, 22);
  }
  exports$12.s0_256 = s0_256$1;
  function s1_256$1(x$1) {
    return rotr32(x$1, 6) ^ rotr32(x$1, 11) ^ rotr32(x$1, 25);
  }
  exports$12.s1_256 = s1_256$1;
  function g0_256$1(x$1) {
    return rotr32(x$1, 7) ^ rotr32(x$1, 18) ^ x$1 >>> 3;
  }
  exports$12.g0_256 = g0_256$1;
  function g1_256$1(x$1) {
    return rotr32(x$1, 17) ^ rotr32(x$1, 19) ^ x$1 >>> 10;
  }
  exports$12.g1_256 = g1_256$1;
}), require__1 = __commonJSMin$1((exports$12, module2) => {
  var utils$16 = require_utils$2(), common$3 = require_common$1(), shaCommon$1 = require_common(), rotl32$1 = utils$16.rotl32, sum32$2 = utils$16.sum32, sum32_5$1 = utils$16.sum32_5, ft_1 = shaCommon$1.ft_1, BlockHash$3 = common$3.BlockHash, sha1_K = [1518500249, 1859775393, 2400959708, 3395469782];
  function SHA1() {
    if (!(this instanceof SHA1)) return new SHA1();
    BlockHash$3.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.W = Array(80);
  }
  utils$16.inherits(SHA1, BlockHash$3), module2.exports = SHA1, SHA1.blockSize = 512, SHA1.outSize = 160, SHA1.hmacStrength = 80, SHA1.padLength = 64, SHA1.prototype._update = function(msg, start) {
    for (var W$1 = this.W, i$4 = 0; i$4 < 16; i$4++) W$1[i$4] = msg[start + i$4];
    for (; i$4 < W$1.length; i$4++) W$1[i$4] = rotl32$1(W$1[i$4 - 3] ^ W$1[i$4 - 8] ^ W$1[i$4 - 14] ^ W$1[i$4 - 16], 1);
    var a$22 = this.h[0], b2 = this.h[1], c$12 = this.h[2], d$12 = this.h[3], e$22 = this.h[4];
    for (i$4 = 0; i$4 < W$1.length; i$4++) {
      var s$6 = ~~(i$4 / 20), t$7 = sum32_5$1(rotl32$1(a$22, 5), ft_1(s$6, b2, c$12, d$12), e$22, W$1[i$4], sha1_K[s$6]);
      e$22 = d$12, d$12 = c$12, c$12 = rotl32$1(b2, 30), b2 = a$22, a$22 = t$7;
    }
    this.h[0] = sum32$2(this.h[0], a$22), this.h[1] = sum32$2(this.h[1], b2), this.h[2] = sum32$2(this.h[2], c$12), this.h[3] = sum32$2(this.h[3], d$12), this.h[4] = sum32$2(this.h[4], e$22);
  }, SHA1.prototype._digest = function(enc) {
    return enc === `hex` ? utils$16.toHex32(this.h, `big`) : utils$16.split32(this.h, `big`);
  };
}), require__256 = __commonJSMin$1((exports$12, module2) => {
  var utils$15 = require_utils$2(), common$2 = require_common$1(), shaCommon = require_common(), assert$12 = require_minimalistic_assert(), sum32$1 = utils$15.sum32, sum32_4$1 = utils$15.sum32_4, sum32_5 = utils$15.sum32_5, ch32 = shaCommon.ch32, maj32 = shaCommon.maj32, s0_256 = shaCommon.s0_256, s1_256 = shaCommon.s1_256, g0_256 = shaCommon.g0_256, g1_256 = shaCommon.g1_256, BlockHash$2 = common$2.BlockHash, sha256_K = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];
  function SHA256$1() {
    if (!(this instanceof SHA256$1)) return new SHA256$1();
    BlockHash$2.call(this), this.h = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], this.k = sha256_K, this.W = Array(64);
  }
  utils$15.inherits(SHA256$1, BlockHash$2), module2.exports = SHA256$1, SHA256$1.blockSize = 512, SHA256$1.outSize = 256, SHA256$1.hmacStrength = 192, SHA256$1.padLength = 64, SHA256$1.prototype._update = function(msg, start) {
    for (var W$1 = this.W, i$4 = 0; i$4 < 16; i$4++) W$1[i$4] = msg[start + i$4];
    for (; i$4 < W$1.length; i$4++) W$1[i$4] = sum32_4$1(g1_256(W$1[i$4 - 2]), W$1[i$4 - 7], g0_256(W$1[i$4 - 15]), W$1[i$4 - 16]);
    var a$22 = this.h[0], b2 = this.h[1], c$12 = this.h[2], d$12 = this.h[3], e$22 = this.h[4], f$32 = this.h[5], g$22 = this.h[6], h$1 = this.h[7];
    for (assert$12(this.k.length === W$1.length), i$4 = 0; i$4 < W$1.length; i$4++) {
      var T1 = sum32_5(h$1, s1_256(e$22), ch32(e$22, f$32, g$22), this.k[i$4], W$1[i$4]), T2 = sum32$1(s0_256(a$22), maj32(a$22, b2, c$12));
      h$1 = g$22, g$22 = f$32, f$32 = e$22, e$22 = sum32$1(d$12, T1), d$12 = c$12, c$12 = b2, b2 = a$22, a$22 = sum32$1(T1, T2);
    }
    this.h[0] = sum32$1(this.h[0], a$22), this.h[1] = sum32$1(this.h[1], b2), this.h[2] = sum32$1(this.h[2], c$12), this.h[3] = sum32$1(this.h[3], d$12), this.h[4] = sum32$1(this.h[4], e$22), this.h[5] = sum32$1(this.h[5], f$32), this.h[6] = sum32$1(this.h[6], g$22), this.h[7] = sum32$1(this.h[7], h$1);
  }, SHA256$1.prototype._digest = function(enc) {
    return enc === `hex` ? utils$15.toHex32(this.h, `big`) : utils$15.split32(this.h, `big`);
  };
}), require__224 = __commonJSMin$1((exports$12, module2) => {
  var utils$14 = require_utils$2(), SHA256 = require__256();
  function SHA224() {
    if (!(this instanceof SHA224)) return new SHA224();
    SHA256.call(this), this.h = [3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428];
  }
  utils$14.inherits(SHA224, SHA256), module2.exports = SHA224, SHA224.blockSize = 512, SHA224.outSize = 224, SHA224.hmacStrength = 192, SHA224.padLength = 64, SHA224.prototype._digest = function(enc) {
    return enc === `hex` ? utils$14.toHex32(this.h.slice(0, 7), `big`) : utils$14.split32(this.h.slice(0, 7), `big`);
  };
}), require__512 = __commonJSMin$1((exports$12, module2) => {
  var utils$13 = require_utils$2(), common$1 = require_common$1(), assert$11 = require_minimalistic_assert(), rotr64_hi = utils$13.rotr64_hi, rotr64_lo = utils$13.rotr64_lo, shr64_hi = utils$13.shr64_hi, shr64_lo = utils$13.shr64_lo, sum64 = utils$13.sum64, sum64_hi = utils$13.sum64_hi, sum64_lo = utils$13.sum64_lo, sum64_4_hi = utils$13.sum64_4_hi, sum64_4_lo = utils$13.sum64_4_lo, sum64_5_hi = utils$13.sum64_5_hi, sum64_5_lo = utils$13.sum64_5_lo, BlockHash$1 = common$1.BlockHash, sha512_K = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591];
  function SHA512$1() {
    if (!(this instanceof SHA512$1)) return new SHA512$1();
    BlockHash$1.call(this), this.h = [1779033703, 4089235720, 3144134277, 2227873595, 1013904242, 4271175723, 2773480762, 1595750129, 1359893119, 2917565137, 2600822924, 725511199, 528734635, 4215389547, 1541459225, 327033209], this.k = sha512_K, this.W = Array(160);
  }
  utils$13.inherits(SHA512$1, BlockHash$1), module2.exports = SHA512$1, SHA512$1.blockSize = 1024, SHA512$1.outSize = 512, SHA512$1.hmacStrength = 192, SHA512$1.padLength = 128, SHA512$1.prototype._prepareBlock = function(msg, start) {
    for (var W$1 = this.W, i$4 = 0; i$4 < 32; i$4++) W$1[i$4] = msg[start + i$4];
    for (; i$4 < W$1.length; i$4 += 2) {
      var c0_hi = g1_512_hi(W$1[i$4 - 4], W$1[i$4 - 3]), c0_lo = g1_512_lo(W$1[i$4 - 4], W$1[i$4 - 3]), c1_hi = W$1[i$4 - 14], c1_lo = W$1[i$4 - 13], c2_hi = g0_512_hi(W$1[i$4 - 30], W$1[i$4 - 29]), c2_lo = g0_512_lo(W$1[i$4 - 30], W$1[i$4 - 29]), c3_hi = W$1[i$4 - 32], c3_lo = W$1[i$4 - 31];
      W$1[i$4] = sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo), W$1[i$4 + 1] = sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
  }, SHA512$1.prototype._update = function(msg, start) {
    this._prepareBlock(msg, start);
    var W$1 = this.W, ah = this.h[0], al = this.h[1], bh = this.h[2], bl = this.h[3], ch = this.h[4], cl = this.h[5], dh$1 = this.h[6], dl = this.h[7], eh = this.h[8], el = this.h[9], fh = this.h[10], fl$1 = this.h[11], gh = this.h[12], gl = this.h[13], hh = this.h[14], hl = this.h[15];
    assert$11(this.k.length === W$1.length);
    for (var i$4 = 0; i$4 < W$1.length; i$4 += 2) {
      var c0_hi = hh, c0_lo = hl, c1_hi = s1_512_hi(eh, el), c1_lo = s1_512_lo(eh, el), c2_hi = ch64_hi(eh, el, fh, fl$1, gh), c2_lo = ch64_lo(eh, el, fh, fl$1, gh, gl), c3_hi = this.k[i$4], c3_lo = this.k[i$4 + 1], c4_hi = W$1[i$4], c4_lo = W$1[i$4 + 1], T1_hi = sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo), T1_lo = sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
      c0_hi = s0_512_hi(ah, al), c0_lo = s0_512_lo(ah, al), c1_hi = maj64_hi(ah, al, bh, bl, ch), c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);
      var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo), T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
      hh = gh, hl = gl, gh = fh, gl = fl$1, fh = eh, fl$1 = el, eh = sum64_hi(dh$1, dl, T1_hi, T1_lo), el = sum64_lo(dl, dl, T1_hi, T1_lo), dh$1 = ch, dl = cl, ch = bh, cl = bl, bh = ah, bl = al, ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo), al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    sum64(this.h, 0, ah, al), sum64(this.h, 2, bh, bl), sum64(this.h, 4, ch, cl), sum64(this.h, 6, dh$1, dl), sum64(this.h, 8, eh, el), sum64(this.h, 10, fh, fl$1), sum64(this.h, 12, gh, gl), sum64(this.h, 14, hh, hl);
  }, SHA512$1.prototype._digest = function(enc) {
    return enc === `hex` ? utils$13.toHex32(this.h, `big`) : utils$13.split32(this.h, `big`);
  };
  function ch64_hi(xh, xl, yh, yl, zh) {
    var r$2 = xh & yh ^ ~xh & zh;
    return r$2 < 0 && (r$2 += 4294967296), r$2;
  }
  function ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r$2 = xl & yl ^ ~xl & zl;
    return r$2 < 0 && (r$2 += 4294967296), r$2;
  }
  function maj64_hi(xh, xl, yh, yl, zh) {
    var r$2 = xh & yh ^ xh & zh ^ yh & zh;
    return r$2 < 0 && (r$2 += 4294967296), r$2;
  }
  function maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r$2 = xl & yl ^ xl & zl ^ yl & zl;
    return r$2 < 0 && (r$2 += 4294967296), r$2;
  }
  function s0_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 28), c1_hi = rotr64_hi(xl, xh, 2), c2_hi = rotr64_hi(xl, xh, 7), r$2 = c0_hi ^ c1_hi ^ c2_hi;
    return r$2 < 0 && (r$2 += 4294967296), r$2;
  }
  function s0_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 28), c1_lo = rotr64_lo(xl, xh, 2), c2_lo = rotr64_lo(xl, xh, 7), r$2 = c0_lo ^ c1_lo ^ c2_lo;
    return r$2 < 0 && (r$2 += 4294967296), r$2;
  }
  function s1_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 14), c1_hi = rotr64_hi(xh, xl, 18), c2_hi = rotr64_hi(xl, xh, 9), r$2 = c0_hi ^ c1_hi ^ c2_hi;
    return r$2 < 0 && (r$2 += 4294967296), r$2;
  }
  function s1_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 14), c1_lo = rotr64_lo(xh, xl, 18), c2_lo = rotr64_lo(xl, xh, 9), r$2 = c0_lo ^ c1_lo ^ c2_lo;
    return r$2 < 0 && (r$2 += 4294967296), r$2;
  }
  function g0_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 1), c1_hi = rotr64_hi(xh, xl, 8), c2_hi = shr64_hi(xh, xl, 7), r$2 = c0_hi ^ c1_hi ^ c2_hi;
    return r$2 < 0 && (r$2 += 4294967296), r$2;
  }
  function g0_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 1), c1_lo = rotr64_lo(xh, xl, 8), c2_lo = shr64_lo(xh, xl, 7), r$2 = c0_lo ^ c1_lo ^ c2_lo;
    return r$2 < 0 && (r$2 += 4294967296), r$2;
  }
  function g1_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 19), c1_hi = rotr64_hi(xl, xh, 29), c2_hi = shr64_hi(xh, xl, 6), r$2 = c0_hi ^ c1_hi ^ c2_hi;
    return r$2 < 0 && (r$2 += 4294967296), r$2;
  }
  function g1_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 19), c1_lo = rotr64_lo(xl, xh, 29), c2_lo = shr64_lo(xh, xl, 6), r$2 = c0_lo ^ c1_lo ^ c2_lo;
    return r$2 < 0 && (r$2 += 4294967296), r$2;
  }
}), require__384 = __commonJSMin$1((exports$12, module2) => {
  var utils$12 = require_utils$2(), SHA512 = require__512();
  function SHA384() {
    if (!(this instanceof SHA384)) return new SHA384();
    SHA512.call(this), this.h = [3418070365, 3238371032, 1654270250, 914150663, 2438529370, 812702999, 355462360, 4144912697, 1731405415, 4290775857, 2394180231, 1750603025, 3675008525, 1694076839, 1203062813, 3204075428];
  }
  utils$12.inherits(SHA384, SHA512), module2.exports = SHA384, SHA384.blockSize = 1024, SHA384.outSize = 384, SHA384.hmacStrength = 192, SHA384.padLength = 128, SHA384.prototype._digest = function(enc) {
    return enc === `hex` ? utils$12.toHex32(this.h.slice(0, 12), `big`) : utils$12.split32(this.h.slice(0, 12), `big`);
  };
}), require_sha = __commonJSMin$1((exports$12) => {
  exports$12.sha1 = require__1(), exports$12.sha224 = require__224(), exports$12.sha256 = require__256(), exports$12.sha384 = require__384(), exports$12.sha512 = require__512();
}), require_ripemd = __commonJSMin$1((exports$12) => {
  var utils$11 = require_utils$2(), common = require_common$1(), rotl32 = utils$11.rotl32, sum32 = utils$11.sum32, sum32_3 = utils$11.sum32_3, sum32_4 = utils$11.sum32_4, BlockHash = common.BlockHash;
  function RIPEMD160() {
    if (!(this instanceof RIPEMD160)) return new RIPEMD160();
    BlockHash.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = `little`;
  }
  utils$11.inherits(RIPEMD160, BlockHash), exports$12.ripemd160 = RIPEMD160, RIPEMD160.blockSize = 512, RIPEMD160.outSize = 160, RIPEMD160.hmacStrength = 192, RIPEMD160.padLength = 64, RIPEMD160.prototype._update = function(msg, start) {
    for (var A = this.h[0], B = this.h[1], C = this.h[2], D = this.h[3], E = this.h[4], Ah = A, Bh = B, Ch = C, Dh = D, Eh = E, j$1 = 0; j$1 < 80; j$1++) {
      var T = sum32(rotl32(sum32_4(A, f2(j$1, B, C, D), msg[r[j$1] + start], K(j$1)), s$2[j$1]), E);
      A = E, E = D, D = rotl32(C, 10), C = B, B = T, T = sum32(rotl32(sum32_4(Ah, f2(79 - j$1, Bh, Ch, Dh), msg[rh[j$1] + start], Kh(j$1)), sh[j$1]), Eh), Ah = Eh, Eh = Dh, Dh = rotl32(Ch, 10), Ch = Bh, Bh = T;
    }
    T = sum32_3(this.h[1], C, Dh), this.h[1] = sum32_3(this.h[2], D, Eh), this.h[2] = sum32_3(this.h[3], E, Ah), this.h[3] = sum32_3(this.h[4], A, Bh), this.h[4] = sum32_3(this.h[0], B, Ch), this.h[0] = T;
  }, RIPEMD160.prototype._digest = function(enc) {
    return enc === `hex` ? utils$11.toHex32(this.h, `little`) : utils$11.split32(this.h, `little`);
  };
  function f2(j$1, x$1, y$1, z$1) {
    return j$1 <= 15 ? x$1 ^ y$1 ^ z$1 : j$1 <= 31 ? x$1 & y$1 | ~x$1 & z$1 : j$1 <= 47 ? (x$1 | ~y$1) ^ z$1 : j$1 <= 63 ? x$1 & z$1 | y$1 & ~z$1 : x$1 ^ (y$1 | ~z$1);
  }
  function K(j$1) {
    return j$1 <= 15 ? 0 : j$1 <= 31 ? 1518500249 : j$1 <= 47 ? 1859775393 : j$1 <= 63 ? 2400959708 : 2840853838;
  }
  function Kh(j$1) {
    return j$1 <= 15 ? 1352829926 : j$1 <= 31 ? 1548603684 : j$1 <= 47 ? 1836072691 : j$1 <= 63 ? 2053994217 : 0;
  }
  var r = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13], rh = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11], s$2 = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6], sh = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11];
}), require_hmac = __commonJSMin$1((exports$12, module2) => {
  var utils$10 = require_utils$2(), assert$10 = require_minimalistic_assert();
  function Hmac(hash$4, key, enc) {
    if (!(this instanceof Hmac)) return new Hmac(hash$4, key, enc);
    this.Hash = hash$4, this.blockSize = hash$4.blockSize / 8, this.outSize = hash$4.outSize / 8, this.inner = null, this.outer = null, this._init(utils$10.toArray(key, enc));
  }
  module2.exports = Hmac, Hmac.prototype._init = function(key) {
    key.length > this.blockSize && (key = new this.Hash().update(key).digest()), assert$10(key.length <= this.blockSize);
    for (var i$4 = key.length; i$4 < this.blockSize; i$4++) key.push(0);
    for (i$4 = 0; i$4 < key.length; i$4++) key[i$4] ^= 54;
    for (this.inner = new this.Hash().update(key), i$4 = 0; i$4 < key.length; i$4++) key[i$4] ^= 106;
    this.outer = new this.Hash().update(key);
  }, Hmac.prototype.update = function(msg, enc) {
    return this.inner.update(msg, enc), this;
  }, Hmac.prototype.digest = function(enc) {
    return this.outer.update(this.inner.digest()), this.outer.digest(enc);
  };
}), require_hash = __commonJSMin$1((exports$12) => {
  var hash$3 = exports$12;
  hash$3.utils = require_utils$2(), hash$3.common = require_common$1(), hash$3.sha = require_sha(), hash$3.ripemd = require_ripemd(), hash$3.hmac = require_hmac(), hash$3.sha1 = hash$3.sha.sha1, hash$3.sha256 = hash$3.sha.sha256, hash$3.sha224 = hash$3.sha.sha224, hash$3.sha384 = hash$3.sha.sha384, hash$3.sha512 = hash$3.sha.sha512, hash$3.ripemd160 = hash$3.ripemd.ripemd160;
}), require_secp256k1 = __commonJSMin$1((exports$12, module2) => {
  module2.exports = { doubles: { step: 4, points: [[`e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a`, `f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821`], [`8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508`, `11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf`], [`175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739`, `d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695`], [`363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640`, `4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9`], [`8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c`, `4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36`], [`723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda`, `96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f`], [`eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa`, `5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999`], [`100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0`, `cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09`], [`e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d`, `9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d`], [`feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d`, `e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088`], [`da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1`, `9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d`], [`53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0`, `5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8`], [`8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047`, `10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a`], [`385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862`, `283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453`], [`6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7`, `7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160`], [`3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd`, `56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0`], [`85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83`, `7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6`], [`948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a`, `53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589`], [`6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8`, `bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17`], [`e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d`, `4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda`], [`e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725`, `7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd`], [`213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754`, `4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2`], [`4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c`, `17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6`], [`fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6`, `6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f`], [`76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39`, `c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01`], [`c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891`, `893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3`], [`d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b`, `febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f`], [`b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03`, `2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7`], [`e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d`, `eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78`], [`a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070`, `7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1`], [`90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4`, `e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150`], [`8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da`, `662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82`], [`e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11`, `1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc`], [`8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e`, `efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b`], [`e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41`, `2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51`], [`b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef`, `67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45`], [`d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8`, `db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120`], [`324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d`, `648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84`], [`4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96`, `35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d`], [`9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd`, `ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d`], [`6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5`, `9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8`], [`a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266`, `40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8`], [`7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71`, `34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac`], [`928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac`, `c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f`], [`85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751`, `1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962`], [`ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e`, `493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907`], [`827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241`, `c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec`], [`eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3`, `be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d`], [`e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f`, `4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414`], [`1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19`, `aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd`], [`146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be`, `b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0`], [`fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9`, `6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811`], [`da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2`, `8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1`], [`a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13`, `7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c`], [`174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c`, `ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73`], [`959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba`, `2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd`], [`d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151`, `e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405`], [`64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073`, `d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589`], [`8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458`, `38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e`], [`13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b`, `69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27`], [`bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366`, `d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1`], [`8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa`, `40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482`], [`8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0`, `620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945`], [`dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787`, `7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573`], [`f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e`, `ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82`]] }, naf: { wnd: 7, points: [[`f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9`, `388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672`], [`2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4`, `d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6`], [`5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc`, `6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da`], [`acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe`, `cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37`], [`774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb`, `d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b`], [`f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8`, `ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81`], [`d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e`, `581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58`], [`defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34`, `4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77`], [`2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c`, `85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a`], [`352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5`, `321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c`], [`2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f`, `2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67`], [`9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714`, `73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402`], [`daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729`, `a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55`], [`c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db`, `2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482`], [`6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4`, `e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82`], [`1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5`, `b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396`], [`605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479`, `2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49`], [`62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d`, `80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf`], [`80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f`, `1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a`], [`7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb`, `d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7`], [`d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9`, `eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933`], [`49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963`, `758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a`], [`77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74`, `958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6`], [`f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530`, `e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37`], [`463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b`, `5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e`], [`f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247`, `cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6`], [`caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1`, `cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476`], [`2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120`, `4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40`], [`7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435`, `91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61`], [`754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18`, `673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683`], [`e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8`, `59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5`], [`186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb`, `3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b`], [`df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f`, `55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417`], [`5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143`, `efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868`], [`290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba`, `e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a`], [`af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45`, `f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6`], [`766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a`, `744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996`], [`59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e`, `c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e`], [`f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8`, `e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d`], [`7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c`, `30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2`], [`948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519`, `e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e`], [`7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab`, `100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437`], [`3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca`, `ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311`], [`d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf`, `8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4`], [`1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610`, `68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575`], [`733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4`, `f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d`], [`15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c`, `d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d`], [`a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940`, `edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629`], [`e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980`, `a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06`], [`311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3`, `66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374`], [`34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf`, `9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee`], [`f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63`, `4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1`], [`d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448`, `fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b`], [`32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf`, `5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661`], [`7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5`, `8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6`], [`ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6`, `8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e`], [`16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5`, `5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d`], [`eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99`, `f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc`], [`78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51`, `f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4`], [`494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5`, `42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c`], [`a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5`, `204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b`], [`c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997`, `4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913`], [`841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881`, `73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154`], [`5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5`, `39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865`], [`36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66`, `d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc`], [`336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726`, `ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224`], [`8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede`, `6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e`], [`1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94`, `60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6`], [`85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31`, `3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511`], [`29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51`, `b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b`], [`a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252`, `ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2`], [`4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5`, `cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c`], [`d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b`, `6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3`], [`ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4`, `322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d`], [`af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f`, `6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700`], [`e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889`, `2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4`], [`591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246`, `b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196`], [`11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984`, `998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4`], [`3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a`, `b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257`], [`cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030`, `bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13`], [`c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197`, `6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096`], [`c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593`, `c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38`], [`a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef`, `21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f`], [`347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38`, `60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448`], [`da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a`, `49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a`], [`c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111`, `5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4`], [`4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502`, `7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437`], [`3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea`, `be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7`], [`cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26`, `8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d`], [`b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986`, `39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a`], [`d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e`, `62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54`], [`48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4`, `25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77`], [`dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda`, `ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517`], [`6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859`, `cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10`], [`e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f`, `f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125`], [`eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c`, `6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e`], [`13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942`, `fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1`], [`ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a`, `1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2`], [`b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80`, `5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423`], [`ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d`, `438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8`], [`8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1`, `cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758`], [`52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63`, `c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375`], [`e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352`, `6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d`], [`7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193`, `ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec`], [`5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00`, `9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0`], [`32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58`, `ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c`], [`e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7`, `d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4`], [`8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8`, `c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f`], [`4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e`, `67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649`], [`3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d`, `cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826`], [`674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b`, `299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5`], [`d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f`, `f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87`], [`30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6`, `462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b`], [`be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297`, `62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc`], [`93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a`, `7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c`], [`b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c`, `ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f`], [`d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52`, `4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a`], [`d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb`, `bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46`], [`463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065`, `bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f`], [`7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917`, `603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03`], [`74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9`, `cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08`], [`30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3`, `553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8`], [`9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57`, `712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373`], [`176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66`, `ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3`], [`75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8`, `9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8`], [`809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721`, `9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1`], [`1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180`, `4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9`]] } };
}), require_curves = __commonJSMin$1((exports$12) => {
  var curves$2 = exports$12, hash$2 = require_hash(), curve = require_curve(), utils$9 = require_utils$3(), assert$9 = utils$9.assert;
  function PresetCurve(options) {
    options.type === `short` ? this.curve = new curve.short(options) : options.type === `edwards` ? this.curve = new curve.edwards(options) : this.curve = new curve.mont(options), this.g = this.curve.g, this.n = this.curve.n, this.hash = options.hash, assert$9(this.g.validate(), `Invalid curve`), assert$9(this.g.mul(this.n).isInfinity(), `Invalid curve, G*N != O`);
  }
  curves$2.PresetCurve = PresetCurve;
  function defineCurve(name$2, options) {
    Object.defineProperty(curves$2, name$2, { configurable: true, enumerable: true, get: function() {
      var curve$2 = new PresetCurve(options);
      return Object.defineProperty(curves$2, name$2, { configurable: true, enumerable: true, value: curve$2 }), curve$2;
    } });
  }
  defineCurve(`p192`, { type: `short`, prime: `p192`, p: `ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff`, a: `ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc`, b: `64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1`, n: `ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831`, hash: hash$2.sha256, gRed: false, g: [`188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012`, `07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811`] }), defineCurve(`p224`, { type: `short`, prime: `p224`, p: `ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001`, a: `ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe`, b: `b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4`, n: `ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d`, hash: hash$2.sha256, gRed: false, g: [`b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21`, `bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34`] }), defineCurve(`p256`, { type: `short`, prime: null, p: `ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff`, a: `ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc`, b: `5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b`, n: `ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551`, hash: hash$2.sha256, gRed: false, g: [`6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296`, `4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5`] }), defineCurve(`p384`, { type: `short`, prime: null, p: `ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff`, a: `ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc`, b: `b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef`, n: `ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973`, hash: hash$2.sha384, gRed: false, g: [`aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7`, `3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f`] }), defineCurve(`p521`, { type: `short`, prime: null, p: `000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff`, a: `000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc`, b: `00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00`, n: `000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409`, hash: hash$2.sha512, gRed: false, g: [`000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66`, `00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650`] }), defineCurve(`curve25519`, { type: `mont`, prime: `p25519`, p: `7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed`, a: `76d06`, b: `1`, n: `1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed`, hash: hash$2.sha256, gRed: false, g: [`9`] }), defineCurve(`ed25519`, { type: `edwards`, prime: `p25519`, p: `7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed`, a: `-1`, c: `1`, d: `52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3`, n: `1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed`, hash: hash$2.sha256, gRed: false, g: [`216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a`, `6666666666666666666666666666666666666666666666666666666666666658`] });
  var pre;
  try {
    pre = require_secp256k1();
  } catch {
    pre = void 0;
  }
  defineCurve(`secp256k1`, { type: `short`, prime: `k256`, p: `ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f`, a: `0`, b: `7`, n: `ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141`, h: `1`, hash: hash$2.sha256, beta: `7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee`, lambda: `5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72`, basis: [{ a: `3086d221a7d46bcde86c90e49284eb15`, b: `-e4437ed6010e88286f547fa90abfe4c3` }, { a: `114ca50f7a8e2f3f657c1108d9d44cfd8`, b: `3086d221a7d46bcde86c90e49284eb15` }], gRed: false, g: [`79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798`, `483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8`, pre] });
}), require_hmac_drbg = __commonJSMin$1((exports$12, module2) => {
  var hash$1 = require_hash(), utils$8 = require_utils$4(), assert$8 = require_minimalistic_assert();
  function HmacDRBG$1(options) {
    if (!(this instanceof HmacDRBG$1)) return new HmacDRBG$1(options);
    this.hash = options.hash, this.predResist = !!options.predResist, this.outLen = this.hash.outSize, this.minEntropy = options.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
    var entropy = utils$8.toArray(options.entropy, options.entropyEnc || `hex`), nonce = utils$8.toArray(options.nonce, options.nonceEnc || `hex`), pers = utils$8.toArray(options.pers, options.persEnc || `hex`);
    assert$8(entropy.length >= this.minEntropy / 8, `Not enough entropy. Minimum is: ` + this.minEntropy + ` bits`), this._init(entropy, nonce, pers);
  }
  module2.exports = HmacDRBG$1, HmacDRBG$1.prototype._init = function(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = Array(this.outLen / 8), this.V = Array(this.outLen / 8);
    for (var i$4 = 0; i$4 < this.V.length; i$4++) this.K[i$4] = 0, this.V[i$4] = 1;
    this._update(seed), this._reseed = 1, this.reseedInterval = 281474976710656;
  }, HmacDRBG$1.prototype._hmac = function() {
    return new hash$1.hmac(this.hash, this.K);
  }, HmacDRBG$1.prototype._update = function(seed) {
    var kmac = this._hmac().update(this.V).update([0]);
    seed && (kmac = kmac.update(seed)), this.K = kmac.digest(), this.V = this._hmac().update(this.V).digest(), seed && (this.K = this._hmac().update(this.V).update([1]).update(seed).digest(), this.V = this._hmac().update(this.V).digest());
  }, HmacDRBG$1.prototype.reseed = function(entropy, entropyEnc, add, addEnc) {
    typeof entropyEnc != `string` && (addEnc = add, add = entropyEnc, entropyEnc = null), entropy = utils$8.toArray(entropy, entropyEnc), add = utils$8.toArray(add, addEnc), assert$8(entropy.length >= this.minEntropy / 8, `Not enough entropy. Minimum is: ` + this.minEntropy + ` bits`), this._update(entropy.concat(add || [])), this._reseed = 1;
  }, HmacDRBG$1.prototype.generate = function(len$2, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw Error(`Reseed is required`);
    typeof enc != `string` && (addEnc = add, add = enc, enc = null), add && (add = utils$8.toArray(add, addEnc || `hex`), this._update(add));
    for (var temp = []; temp.length < len$2; ) this.V = this._hmac().update(this.V).digest(), temp = temp.concat(this.V);
    var res = temp.slice(0, len$2);
    return this._update(add), this._reseed++, utils$8.encode(res, enc);
  };
}), require_key$1 = __commonJSMin$1((exports$12, module2) => {
  var BN$8 = require_bn$1(), utils$7 = require_utils$3(), assert$7 = utils$7.assert;
  function KeyPair$3(ec$1, options) {
    this.ec = ec$1, this.priv = null, this.pub = null, options.priv && this._importPrivate(options.priv, options.privEnc), options.pub && this._importPublic(options.pub, options.pubEnc);
  }
  module2.exports = KeyPair$3, KeyPair$3.fromPublic = function(ec$1, pub, enc) {
    return pub instanceof KeyPair$3 ? pub : new KeyPair$3(ec$1, { pub, pubEnc: enc });
  }, KeyPair$3.fromPrivate = function(ec$1, priv, enc) {
    return priv instanceof KeyPair$3 ? priv : new KeyPair$3(ec$1, { priv, privEnc: enc });
  }, KeyPair$3.prototype.validate = function() {
    var pub = this.getPublic();
    return pub.isInfinity() ? { result: false, reason: `Invalid public key` } : pub.validate() ? pub.mul(this.ec.curve.n).isInfinity() ? { result: true, reason: null } : { result: false, reason: `Public key * N != O` } : { result: false, reason: `Public key is not a point` };
  }, KeyPair$3.prototype.getPublic = function(compact$4, enc) {
    return typeof compact$4 == `string` && (enc = compact$4, compact$4 = null), this.pub ||= this.ec.g.mul(this.priv), enc ? this.pub.encode(enc, compact$4) : this.pub;
  }, KeyPair$3.prototype.getPrivate = function(enc) {
    return enc === `hex` ? this.priv.toString(16, 2) : this.priv;
  }, KeyPair$3.prototype._importPrivate = function(key, enc) {
    this.priv = new BN$8(key, enc || 16), this.priv = this.priv.umod(this.ec.curve.n);
  }, KeyPair$3.prototype._importPublic = function(key, enc) {
    if (key.x || key.y) {
      this.ec.curve.type === `mont` ? assert$7(key.x, `Need x coordinate`) : (this.ec.curve.type === `short` || this.ec.curve.type === `edwards`) && assert$7(key.x && key.y, `Need both x and y coordinate`), this.pub = this.ec.curve.point(key.x, key.y);
      return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
  }, KeyPair$3.prototype.derive = function(pub) {
    return pub.validate() || assert$7(pub.validate(), `public point not validated`), pub.mul(this.priv).getX();
  }, KeyPair$3.prototype.sign = function(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
  }, KeyPair$3.prototype.verify = function(msg, signature, options) {
    return this.ec.verify(msg, signature, this, void 0, options);
  }, KeyPair$3.prototype.inspect = function() {
    return `<Key priv: ` + (this.priv && this.priv.toString(16, 2)) + ` pub: ` + (this.pub && this.pub.inspect()) + ` >`;
  };
}), require_signature$1 = __commonJSMin$1((exports$12, module2) => {
  var BN$7 = require_bn$1(), utils$6 = require_utils$3(), assert$6 = utils$6.assert;
  function Signature$3(options, enc) {
    if (options instanceof Signature$3) return options;
    this._importDER(options, enc) || (assert$6(options.r && options.s, `Signature without r or s`), this.r = new BN$7(options.r, 16), this.s = new BN$7(options.s, 16), options.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = options.recoveryParam);
  }
  module2.exports = Signature$3;
  function Position() {
    this.place = 0;
  }
  function getLength(buf, p$1) {
    var initial = buf[p$1.place++];
    if (!(initial & 128)) return initial;
    var octetLen = initial & 15;
    if (octetLen === 0 || octetLen > 4 || buf[p$1.place] === 0) return false;
    for (var val = 0, i$4 = 0, off = p$1.place; i$4 < octetLen; i$4++, off++) val <<= 8, val |= buf[off], val >>>= 0;
    return val <= 127 ? false : (p$1.place = off, val);
  }
  function rmPadding(buf) {
    for (var i$4 = 0, len$2 = buf.length - 1; !buf[i$4] && !(buf[i$4 + 1] & 128) && i$4 < len$2; ) i$4++;
    return i$4 === 0 ? buf : buf.slice(i$4);
  }
  Signature$3.prototype._importDER = function(data, enc) {
    data = utils$6.toArray(data, enc);
    var p$1 = new Position();
    if (data[p$1.place++] !== 48) return false;
    var len$2 = getLength(data, p$1);
    if (len$2 === false || len$2 + p$1.place !== data.length || data[p$1.place++] !== 2) return false;
    var rlen = getLength(data, p$1);
    if (rlen === false || data[p$1.place] & 128) return false;
    var r$2 = data.slice(p$1.place, rlen + p$1.place);
    if (p$1.place += rlen, data[p$1.place++] !== 2) return false;
    var slen = getLength(data, p$1);
    if (slen === false || data.length !== slen + p$1.place || data[p$1.place] & 128) return false;
    var s$6 = data.slice(p$1.place, slen + p$1.place);
    if (r$2[0] === 0) if (r$2[1] & 128) r$2 = r$2.slice(1);
    else return false;
    if (s$6[0] === 0) if (s$6[1] & 128) s$6 = s$6.slice(1);
    else return false;
    return this.r = new BN$7(r$2), this.s = new BN$7(s$6), this.recoveryParam = null, true;
  };
  function constructLength(arr, len$2) {
    if (len$2 < 128) {
      arr.push(len$2);
      return;
    }
    var octets = 1 + (Math.log(len$2) / Math.LN2 >>> 3);
    for (arr.push(octets | 128); --octets; ) arr.push(len$2 >>> (octets << 3) & 255);
    arr.push(len$2);
  }
  Signature$3.prototype.toDER = function(enc) {
    var r$2 = this.r.toArray(), s$6 = this.s.toArray();
    for (r$2[0] & 128 && (r$2 = [0].concat(r$2)), s$6[0] & 128 && (s$6 = [0].concat(s$6)), r$2 = rmPadding(r$2), s$6 = rmPadding(s$6); !s$6[0] && !(s$6[1] & 128); ) s$6 = s$6.slice(1);
    var arr = [2];
    constructLength(arr, r$2.length), arr = arr.concat(r$2), arr.push(2), constructLength(arr, s$6.length);
    var backHalf = arr.concat(s$6), res = [48];
    return constructLength(res, backHalf.length), res = res.concat(backHalf), utils$6.encode(res, enc);
  };
}), require_ec = __commonJSMin$1((exports$12, module2) => {
  var BN$6 = require_bn$1(), HmacDRBG = require_hmac_drbg(), utils$5 = require_utils$3(), curves$1 = require_curves(), rand = require_brorand(), assert$5 = utils$5.assert, KeyPair$2 = require_key$1(), Signature$2 = require_signature$1();
  function EC(options) {
    if (!(this instanceof EC)) return new EC(options);
    typeof options == `string` && (assert$5(Object.prototype.hasOwnProperty.call(curves$1, options), `Unknown curve ` + options), options = curves$1[options]), options instanceof curves$1.PresetCurve && (options = { curve: options }), this.curve = options.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = options.curve.g, this.g.precompute(options.curve.n.bitLength() + 1), this.hash = options.hash || options.curve.hash;
  }
  module2.exports = EC, EC.prototype.keyPair = function(options) {
    return new KeyPair$2(this, options);
  }, EC.prototype.keyFromPrivate = function(priv, enc) {
    return KeyPair$2.fromPrivate(this, priv, enc);
  }, EC.prototype.keyFromPublic = function(pub, enc) {
    return KeyPair$2.fromPublic(this, pub, enc);
  }, EC.prototype.genKeyPair = function(options) {
    options ||= {};
    for (var drbg = new HmacDRBG({ hash: this.hash, pers: options.pers, persEnc: options.persEnc || `utf8`, entropy: options.entropy || rand(this.hash.hmacStrength), entropyEnc: options.entropy && options.entropyEnc || `utf8`, nonce: this.n.toArray() }), bytes = this.n.byteLength(), ns2 = this.n.sub(new BN$6(2)); ; ) {
      var priv = new BN$6(drbg.generate(bytes));
      if (!(priv.cmp(ns2) > 0)) return priv.iaddn(1), this.keyFromPrivate(priv);
    }
  }, EC.prototype._truncateToN = function(msg, truncOnly, bitLength) {
    var byteLength$2;
    if (BN$6.isBN(msg) || typeof msg == `number`) msg = new BN$6(msg, 16), byteLength$2 = msg.byteLength();
    else if (typeof msg == `object`) byteLength$2 = msg.length, msg = new BN$6(msg, 16);
    else {
      var str = msg.toString();
      byteLength$2 = str.length + 1 >>> 1, msg = new BN$6(str, 16);
    }
    typeof bitLength != `number` && (bitLength = byteLength$2 * 8);
    var delta = bitLength - this.n.bitLength();
    return delta > 0 && (msg = msg.ushrn(delta)), !truncOnly && msg.cmp(this.n) >= 0 ? msg.sub(this.n) : msg;
  }, EC.prototype.sign = function(msg, key, enc, options) {
    if (typeof enc == `object` && (options = enc, enc = null), options ||= {}, typeof msg != `string` && typeof msg != `number` && !BN$6.isBN(msg)) {
      assert$5(typeof msg == `object` && msg && typeof msg.length == `number`, `Expected message to be an array-like, a hex string, or a BN instance`), assert$5(msg.length >>> 0 === msg.length);
      for (var i$4 = 0; i$4 < msg.length; i$4++) assert$5((msg[i$4] & 255) === msg[i$4]);
    }
    key = this.keyFromPrivate(key, enc), msg = this._truncateToN(msg, false, options.msgBitLength), assert$5(!msg.isNeg(), `Can not sign a negative message`);
    var bytes = this.n.byteLength(), bkey = key.getPrivate().toArray(`be`, bytes), nonce = msg.toArray(`be`, bytes);
    assert$5(new BN$6(nonce).eq(msg), `Can not sign message`);
    for (var drbg = new HmacDRBG({ hash: this.hash, entropy: bkey, nonce, pers: options.pers, persEnc: options.persEnc || `utf8` }), ns1 = this.n.sub(new BN$6(1)), iter = 0; ; iter++) {
      var k = options.k ? options.k(iter) : new BN$6(drbg.generate(this.n.byteLength()));
      if (k = this._truncateToN(k, true), !(k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)) {
        var kp = this.g.mul(k);
        if (!kp.isInfinity()) {
          var kpX = kp.getX(), r$2 = kpX.umod(this.n);
          if (r$2.cmpn(0) !== 0) {
            var s$6 = k.invm(this.n).mul(r$2.mul(key.getPrivate()).iadd(msg));
            if (s$6 = s$6.umod(this.n), s$6.cmpn(0) !== 0) {
              var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r$2) === 0 ? 0 : 2);
              return options.canonical && s$6.cmp(this.nh) > 0 && (s$6 = this.n.sub(s$6), recoveryParam ^= 1), new Signature$2({ r: r$2, s: s$6, recoveryParam });
            }
          }
        }
      }
    }
  }, EC.prototype.verify = function(msg, signature, key, enc, options) {
    options ||= {}, msg = this._truncateToN(msg, false, options.msgBitLength), key = this.keyFromPublic(key, enc), signature = new Signature$2(signature, `hex`);
    var r$2 = signature.r, s$6 = signature.s;
    if (r$2.cmpn(1) < 0 || r$2.cmp(this.n) >= 0 || s$6.cmpn(1) < 0 || s$6.cmp(this.n) >= 0) return false;
    var sinv = s$6.invm(this.n), u1 = sinv.mul(msg).umod(this.n), u2 = sinv.mul(r$2).umod(this.n), p$1;
    return this.curve._maxwellTrick ? (p$1 = this.g.jmulAdd(u1, key.getPublic(), u2), p$1.isInfinity() ? false : p$1.eqXToP(r$2)) : (p$1 = this.g.mulAdd(u1, key.getPublic(), u2), p$1.isInfinity() ? false : p$1.getX().umod(this.n).cmp(r$2) === 0);
  }, EC.prototype.recoverPubKey = function(msg, signature, j$1, enc) {
    assert$5((3 & j$1) === j$1, `The recovery param is more than two bits`), signature = new Signature$2(signature, enc);
    var n$4 = this.n, e$22 = new BN$6(msg), r$2 = signature.r, s$6 = signature.s, isYOdd = j$1 & 1, isSecondKey = j$1 >> 1;
    if (r$2.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw Error(`Unable to find sencond key candinate`);
    r$2 = isSecondKey ? this.curve.pointFromX(r$2.add(this.curve.n), isYOdd) : this.curve.pointFromX(r$2, isYOdd);
    var rInv = signature.r.invm(n$4), s1 = n$4.sub(e$22).mul(rInv).umod(n$4), s2 = s$6.mul(rInv).umod(n$4);
    return this.g.mulAdd(s1, r$2, s2);
  }, EC.prototype.getKeyRecoveryParam = function(e$22, signature, Q, enc) {
    if (signature = new Signature$2(signature, enc), signature.recoveryParam !== null) return signature.recoveryParam;
    for (var i$4 = 0; i$4 < 4; i$4++) {
      var Qprime;
      try {
        Qprime = this.recoverPubKey(e$22, signature, i$4);
      } catch {
        continue;
      }
      if (Qprime.eq(Q)) return i$4;
    }
    throw Error(`Unable to find valid recovery factor`);
  };
}), require_key = __commonJSMin$1((exports$12, module2) => {
  var utils$4 = require_utils$3(), assert$4 = utils$4.assert, parseBytes$2 = utils$4.parseBytes, cachedProperty$1 = utils$4.cachedProperty;
  function KeyPair$1(eddsa, params) {
    this.eddsa = eddsa, this._secret = parseBytes$2(params.secret), eddsa.isPoint(params.pub) ? this._pub = params.pub : this._pubBytes = parseBytes$2(params.pub);
  }
  KeyPair$1.fromPublic = function(eddsa, pub) {
    return pub instanceof KeyPair$1 ? pub : new KeyPair$1(eddsa, { pub });
  }, KeyPair$1.fromSecret = function(eddsa, secret) {
    return secret instanceof KeyPair$1 ? secret : new KeyPair$1(eddsa, { secret });
  }, KeyPair$1.prototype.secret = function() {
    return this._secret;
  }, cachedProperty$1(KeyPair$1, `pubBytes`, function() {
    return this.eddsa.encodePoint(this.pub());
  }), cachedProperty$1(KeyPair$1, `pub`, function() {
    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
  }), cachedProperty$1(KeyPair$1, `privBytes`, function() {
    var eddsa = this.eddsa, hash$4 = this.hash(), lastIx = eddsa.encodingLength - 1, a$22 = hash$4.slice(0, eddsa.encodingLength);
    return a$22[0] &= 248, a$22[lastIx] &= 127, a$22[lastIx] |= 64, a$22;
  }), cachedProperty$1(KeyPair$1, `priv`, function() {
    return this.eddsa.decodeInt(this.privBytes());
  }), cachedProperty$1(KeyPair$1, `hash`, function() {
    return this.eddsa.hash().update(this.secret()).digest();
  }), cachedProperty$1(KeyPair$1, `messagePrefix`, function() {
    return this.hash().slice(this.eddsa.encodingLength);
  }), KeyPair$1.prototype.sign = function(message) {
    return assert$4(this._secret, `KeyPair can only verify`), this.eddsa.sign(message, this);
  }, KeyPair$1.prototype.verify = function(message, sig) {
    return this.eddsa.verify(message, sig, this);
  }, KeyPair$1.prototype.getSecret = function(enc) {
    return assert$4(this._secret, `KeyPair is public only`), utils$4.encode(this.secret(), enc);
  }, KeyPair$1.prototype.getPublic = function(enc) {
    return utils$4.encode(this.pubBytes(), enc);
  }, module2.exports = KeyPair$1;
}), require_signature = __commonJSMin$1((exports$12, module2) => {
  var BN$5 = require_bn$1(), utils$3 = require_utils$3(), assert$3 = utils$3.assert, cachedProperty = utils$3.cachedProperty, parseBytes$1 = utils$3.parseBytes;
  function Signature$1(eddsa, sig) {
    this.eddsa = eddsa, typeof sig != `object` && (sig = parseBytes$1(sig)), Array.isArray(sig) && (assert$3(sig.length === eddsa.encodingLength * 2, `Signature has invalid size`), sig = { R: sig.slice(0, eddsa.encodingLength), S: sig.slice(eddsa.encodingLength) }), assert$3(sig.R && sig.S, `Signature without R or S`), eddsa.isPoint(sig.R) && (this._R = sig.R), sig.S instanceof BN$5 && (this._S = sig.S), this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded, this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
  }
  cachedProperty(Signature$1, `S`, function() {
    return this.eddsa.decodeInt(this.Sencoded());
  }), cachedProperty(Signature$1, `R`, function() {
    return this.eddsa.decodePoint(this.Rencoded());
  }), cachedProperty(Signature$1, `Rencoded`, function() {
    return this.eddsa.encodePoint(this.R());
  }), cachedProperty(Signature$1, `Sencoded`, function() {
    return this.eddsa.encodeInt(this.S());
  }), Signature$1.prototype.toBytes = function() {
    return this.Rencoded().concat(this.Sencoded());
  }, Signature$1.prototype.toHex = function() {
    return utils$3.encode(this.toBytes(), `hex`).toUpperCase();
  }, module2.exports = Signature$1;
}), require_eddsa = __commonJSMin$1((exports$12, module2) => {
  var hash = require_hash(), curves = require_curves(), utils$2 = require_utils$3(), assert$2 = utils$2.assert, parseBytes = utils$2.parseBytes, KeyPair = require_key(), Signature = require_signature();
  function EDDSA(curve$2) {
    if (assert$2(curve$2 === `ed25519`, `only tested with ed25519 so far`), !(this instanceof EDDSA)) return new EDDSA(curve$2);
    curve$2 = curves[curve$2].curve, this.curve = curve$2, this.g = curve$2.g, this.g.precompute(curve$2.n.bitLength() + 1), this.pointClass = curve$2.point().constructor, this.encodingLength = Math.ceil(curve$2.n.bitLength() / 8), this.hash = hash.sha512;
  }
  module2.exports = EDDSA, EDDSA.prototype.sign = function(message, secret) {
    message = parseBytes(message);
    var key = this.keyFromSecret(secret), r$2 = this.hashInt(key.messagePrefix(), message), R$2 = this.g.mul(r$2), Rencoded = this.encodePoint(R$2), s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv()), S = r$2.add(s_).umod(this.curve.n);
    return this.makeSignature({ R: R$2, S, Rencoded });
  }, EDDSA.prototype.verify = function(message, sig, pub) {
    if (message = parseBytes(message), sig = this.makeSignature(sig), sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub), h$1 = this.hashInt(sig.Rencoded(), key.pubBytes(), message), SG = this.g.mul(sig.S()), RplusAh = sig.R().add(key.pub().mul(h$1));
    return RplusAh.eq(SG);
  }, EDDSA.prototype.hashInt = function() {
    for (var hash$4 = this.hash(), i$4 = 0; i$4 < arguments.length; i$4++) hash$4.update(arguments[i$4]);
    return utils$2.intFromLE(hash$4.digest()).umod(this.curve.n);
  }, EDDSA.prototype.keyFromPublic = function(pub) {
    return KeyPair.fromPublic(this, pub);
  }, EDDSA.prototype.keyFromSecret = function(secret) {
    return KeyPair.fromSecret(this, secret);
  }, EDDSA.prototype.makeSignature = function(sig) {
    return sig instanceof Signature ? sig : new Signature(this, sig);
  }, EDDSA.prototype.encodePoint = function(point) {
    var enc = point.getY().toArray(`le`, this.encodingLength);
    return enc[this.encodingLength - 1] |= point.getX().isOdd() ? 128 : 0, enc;
  }, EDDSA.prototype.decodePoint = function(bytes) {
    bytes = utils$2.parseBytes(bytes);
    var lastIx = bytes.length - 1, normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129), xIsOdd = (bytes[lastIx] & 128) != 0, y$1 = utils$2.intFromLE(normed);
    return this.curve.pointFromY(y$1, xIsOdd);
  }, EDDSA.prototype.encodeInt = function(num) {
    return num.toArray(`le`, this.encodingLength);
  }, EDDSA.prototype.decodeInt = function(bytes) {
    return utils$2.intFromLE(bytes);
  }, EDDSA.prototype.isPoint = function(val) {
    return val instanceof this.pointClass;
  };
}), require_elliptic = __commonJSMin$1((exports$12) => {
  var elliptic$1 = exports$12;
  elliptic$1.version = (init_package(), __toCommonJS(package_exports).default).version, elliptic$1.utils = require_utils$3(), elliptic$1.rand = require_brorand(), elliptic$1.curve = require_curve(), elliptic$1.curves = require_curves(), elliptic$1.ec = require_ec(), elliptic$1.eddsa = require_eddsa();
}), require_browser$2 = __commonJSMin$1((exports$12, module2) => {
  init_dist$1();
  var elliptic = require_elliptic(), BN$4 = require_bn$1();
  module2.exports = function(curve$2) {
    return new ECDH(curve$2);
  };
  var aliases = { secp256k1: { name: `secp256k1`, byteLength: 32 }, secp224r1: { name: `p224`, byteLength: 28 }, prime256v1: { name: `p256`, byteLength: 32 }, prime192v1: { name: `p192`, byteLength: 24 }, ed25519: { name: `ed25519`, byteLength: 32 }, secp384r1: { name: `p384`, byteLength: 48 }, secp521r1: { name: `p521`, byteLength: 66 } };
  aliases.p224 = aliases.secp224r1, aliases.p256 = aliases.secp256r1 = aliases.prime256v1, aliases.p192 = aliases.secp192r1 = aliases.prime192v1, aliases.p384 = aliases.secp384r1, aliases.p521 = aliases.secp521r1;
  function ECDH(curve$2) {
    this.curveType = aliases[curve$2], this.curveType ||= { name: curve$2 }, this.curve = new elliptic.ec(this.curveType.name), this.keys = void 0;
  }
  ECDH.prototype.generateKeys = function(enc, format) {
    return this.keys = this.curve.genKeyPair(), this.getPublicKey(enc, format);
  }, ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc ||= `utf8`, Buffer$1.isBuffer(other) || (other = new Buffer$1(other, inenc));
    var otherPub = this.curve.keyFromPublic(other).getPublic(), out = otherPub.mul(this.keys.getPrivate()).getX();
    return formatReturnValue(out, enc, this.curveType.byteLength);
  }, ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === `compressed`, true);
    return format === `hybrid` && (key[key.length - 1] % 2 ? key[0] = 7 : key[0] = 6), formatReturnValue(key, enc);
  }, ECDH.prototype.getPrivateKey = function(enc) {
    return formatReturnValue(this.keys.getPrivate(), enc);
  }, ECDH.prototype.setPublicKey = function(pub, enc) {
    return enc ||= `utf8`, Buffer$1.isBuffer(pub) || (pub = new Buffer$1(pub, enc)), this.keys._importPublic(pub), this;
  }, ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc ||= `utf8`, Buffer$1.isBuffer(priv) || (priv = new Buffer$1(priv, enc));
    var _priv = new BN$4(priv);
    return _priv = _priv.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(_priv), this;
  };
  function formatReturnValue(bn, enc, len$2) {
    Array.isArray(bn) || (bn = bn.toArray());
    var buf = new Buffer$1(bn);
    if (len$2 && buf.length < len$2) {
      var zeros = new Buffer$1(len$2 - buf.length);
      zeros.fill(0), buf = Buffer$1.concat([zeros, buf]);
    }
    return enc ? buf.toString(enc) : buf;
  }
}), require_create_ecdh = __commonJSMin$1((exports$12, module2) => {
  var createECDH = require_crypto_browserify().createECDH;
  module2.exports = createECDH || require_browser$2();
}), require_api = __commonJSMin$1((exports$12) => {
  var asn1$5 = require_asn1$1(), inherits$8 = require_inherits(), api = exports$12;
  api.define = function(name$2, body) {
    return new Entity(name$2, body);
  };
  function Entity(name$2, body) {
    this.name = name$2, this.body = body, this.decoders = {}, this.encoders = {};
  }
  Entity.prototype._createNamed = function(base$3) {
    var named;
    try {
      named = __require$1(`vm`).runInThisContext(`(function ` + this.name + `(entity) {
  this._initNamed(entity);
})`);
    } catch {
      named = function(entity) {
        this._initNamed(entity);
      };
    }
    return inherits$8(named, base$3), named.prototype._initNamed = function(entity) {
      base$3.call(this, entity);
    }, new named(this);
  }, Entity.prototype._getDecoder = function(enc) {
    return enc ||= `der`, this.decoders.hasOwnProperty(enc) || (this.decoders[enc] = this._createNamed(asn1$5.decoders[enc])), this.decoders[enc];
  }, Entity.prototype.decode = function(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
  }, Entity.prototype._getEncoder = function(enc) {
    return enc ||= `der`, this.encoders.hasOwnProperty(enc) || (this.encoders[enc] = this._createNamed(asn1$5.encoders[enc])), this.encoders[enc];
  }, Entity.prototype.encode = function(data, enc, reporter) {
    return this._getEncoder(enc).encode(data, reporter);
  };
}), require_reporter = __commonJSMin$1((exports$12) => {
  var inherits$7 = require_inherits();
  function Reporter$2(options) {
    this._reporterState = { obj: null, path: [], options: options || {}, errors: [] };
  }
  exports$12.Reporter = Reporter$2, Reporter$2.prototype.isError = function(obj) {
    return obj instanceof ReporterError;
  }, Reporter$2.prototype.save = function() {
    var state = this._reporterState;
    return { obj: state.obj, pathLen: state.path.length };
  }, Reporter$2.prototype.restore = function(data) {
    var state = this._reporterState;
    state.obj = data.obj, state.path = state.path.slice(0, data.pathLen);
  }, Reporter$2.prototype.enterKey = function(key) {
    return this._reporterState.path.push(key);
  }, Reporter$2.prototype.exitKey = function(index$2) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index$2 - 1);
  }, Reporter$2.prototype.leaveKey = function(index$2, key, value) {
    var state = this._reporterState;
    this.exitKey(index$2), state.obj !== null && (state.obj[key] = value);
  }, Reporter$2.prototype.path = function() {
    return this._reporterState.path.join(`/`);
  }, Reporter$2.prototype.enterObject = function() {
    var state = this._reporterState, prev = state.obj;
    return state.obj = {}, prev;
  }, Reporter$2.prototype.leaveObject = function(prev) {
    var state = this._reporterState, now$3 = state.obj;
    return state.obj = prev, now$3;
  }, Reporter$2.prototype.error = function(msg) {
    var err$1, state = this._reporterState, inherited = msg instanceof ReporterError;
    if (err$1 = inherited ? msg : new ReporterError(state.path.map(function(elem) {
      return `[` + JSON.stringify(elem) + `]`;
    }).join(``), msg.message || msg, msg.stack), !state.options.partial) throw err$1;
    return inherited || state.errors.push(err$1), err$1;
  }, Reporter$2.prototype.wrapResult = function(result) {
    var state = this._reporterState;
    return state.options.partial ? { result: this.isError(result) ? null : result, errors: state.errors } : result;
  };
  function ReporterError(path, msg) {
    this.path = path, this.rethrow(msg);
  }
  inherits$7(ReporterError, Error), ReporterError.prototype.rethrow = function(msg) {
    if (this.message = msg + ` at: ` + (this.path || `(shallow)`), Error.captureStackTrace && Error.captureStackTrace(this, ReporterError), !this.stack) try {
      throw Error(this.message);
    } catch (e$22) {
      this.stack = e$22.stack;
    }
    return this;
  };
}), require_buffer = __commonJSMin$1((exports$12) => {
  var inherits$6 = require_inherits(), Reporter$1 = require_base().Reporter, Buffer$15 = (init_dist$1(), __toCommonJS(dist_exports)).Buffer;
  function DecoderBuffer$1(base$3, options) {
    if (Reporter$1.call(this, options), !Buffer$15.isBuffer(base$3)) {
      this.error(`Input not Buffer`);
      return;
    }
    this.base = base$3, this.offset = 0, this.length = base$3.length;
  }
  inherits$6(DecoderBuffer$1, Reporter$1), exports$12.DecoderBuffer = DecoderBuffer$1, DecoderBuffer$1.prototype.save = function() {
    return { offset: this.offset, reporter: Reporter$1.prototype.save.call(this) };
  }, DecoderBuffer$1.prototype.restore = function(save$2) {
    var res = new DecoderBuffer$1(this.base);
    return res.offset = save$2.offset, res.length = this.offset, this.offset = save$2.offset, Reporter$1.prototype.restore.call(this, save$2.reporter), res;
  }, DecoderBuffer$1.prototype.isEmpty = function() {
    return this.offset === this.length;
  }, DecoderBuffer$1.prototype.readUInt8 = function(fail$1) {
    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, true) : this.error(fail$1 || `DecoderBuffer overrun`);
  }, DecoderBuffer$1.prototype.skip = function(bytes, fail$1) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail$1 || `DecoderBuffer overrun`);
    var res = new DecoderBuffer$1(this.base);
    return res._reporterState = this._reporterState, res.offset = this.offset, res.length = this.offset + bytes, this.offset += bytes, res;
  }, DecoderBuffer$1.prototype.raw = function(save$2) {
    return this.base.slice(save$2 ? save$2.offset : this.offset, this.length);
  };
  function EncoderBuffer$1(value, reporter) {
    if (Array.isArray(value)) this.length = 0, this.value = value.map(function(item) {
      return item instanceof EncoderBuffer$1 || (item = new EncoderBuffer$1(item, reporter)), this.length += item.length, item;
    }, this);
    else if (typeof value == `number`) {
      if (!(0 <= value && value <= 255)) return reporter.error(`non-byte EncoderBuffer value`);
      this.value = value, this.length = 1;
    } else if (typeof value == `string`) this.value = value, this.length = Buffer$15.byteLength(value);
    else if (Buffer$15.isBuffer(value)) this.value = value, this.length = value.length;
    else return reporter.error(`Unsupported type: ` + typeof value);
  }
  exports$12.EncoderBuffer = EncoderBuffer$1, EncoderBuffer$1.prototype.join = function(out, offset$2) {
    return out ||= new Buffer$15(this.length), offset$2 ||= 0, this.length === 0 || (Array.isArray(this.value) ? this.value.forEach(function(item) {
      item.join(out, offset$2), offset$2 += item.length;
    }) : (typeof this.value == `number` ? out[offset$2] = this.value : typeof this.value == `string` ? out.write(this.value, offset$2) : Buffer$15.isBuffer(this.value) && this.value.copy(out, offset$2), offset$2 += this.length)), out;
  };
}), require_node = __commonJSMin$1((exports$12, module2) => {
  var Reporter = require_base().Reporter, EncoderBuffer = require_base().EncoderBuffer, DecoderBuffer = require_base().DecoderBuffer, assert$1 = require_minimalistic_assert(), tags = `seq.seqof.set.setof.objid.bool.gentime.utctime.null_.enum.int.objDesc.bitstr.bmpstr.charstr.genstr.graphstr.ia5str.iso646str.numstr.octstr.printstr.t61str.unistr.utf8str.videostr`.split(`.`), methods = [`key`, `obj`, `use`, `optional`, `explicit`, `implicit`, `def`, `choice`, `any`, `contains`].concat(tags), overrided = [`_peekTag`, `_decodeTag`, `_use`, `_decodeStr`, `_decodeObjid`, `_decodeTime`, `_decodeNull`, `_decodeInt`, `_decodeBool`, `_decodeList`, `_encodeComposite`, `_encodeStr`, `_encodeObjid`, `_encodeTime`, `_encodeNull`, `_encodeInt`, `_encodeBool`];
  function Node(enc, parent) {
    var state = {};
    this._baseState = state, state.enc = enc, state.parent = parent || null, state.children = null, state.tag = null, state.args = null, state.reverseArgs = null, state.choice = null, state.optional = false, state.any = false, state.obj = false, state.use = null, state.useDecoder = null, state.key = null, state.default = null, state.explicit = null, state.implicit = null, state.contains = null, state.parent || (state.children = [], this._wrap());
  }
  module2.exports = Node;
  var stateProps = [`enc`, `parent`, `children`, `tag`, `args`, `reverseArgs`, `choice`, `optional`, `any`, `obj`, `use`, `alteredUse`, `key`, `default`, `explicit`, `implicit`, `contains`];
  Node.prototype.clone = function() {
    var state = this._baseState, cstate = {};
    stateProps.forEach(function(prop) {
      cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    return res._baseState = cstate, res;
  }, Node.prototype._wrap = function() {
    var state = this._baseState;
    methods.forEach(function(method$1) {
      this[method$1] = function() {
        var clone$20 = new this.constructor(this);
        return state.children.push(clone$20), clone$20[method$1].apply(clone$20, arguments);
      };
    }, this);
  }, Node.prototype._init = function(body) {
    var state = this._baseState;
    assert$1(state.parent === null), body.call(this), state.children = state.children.filter(function(child) {
      return child._baseState.parent === this;
    }, this), assert$1.equal(state.children.length, 1, `Root node can have only one child`);
  }, Node.prototype._useArgs = function(args$1) {
    var state = this._baseState, children = args$1.filter(function(arg) {
      return arg instanceof this.constructor;
    }, this);
    args$1 = args$1.filter(function(arg) {
      return !(arg instanceof this.constructor);
    }, this), children.length !== 0 && (assert$1(state.children === null), state.children = children, children.forEach(function(child) {
      child._baseState.parent = this;
    }, this)), args$1.length !== 0 && (assert$1(state.args === null), state.args = args$1, state.reverseArgs = args$1.map(function(arg) {
      if (typeof arg != `object` || arg.constructor !== Object) return arg;
      var res = {};
      return Object.keys(arg).forEach(function(key) {
        key == (key | 0) && (key |= 0);
        var value = arg[key];
        res[value] = key;
      }), res;
    }));
  }, overrided.forEach(function(method$1) {
    Node.prototype[method$1] = function() {
      var state = this._baseState;
      throw Error(method$1 + ` not implemented for encoding: ` + state.enc);
    };
  }), tags.forEach(function(tag) {
    Node.prototype[tag] = function() {
      var state = this._baseState, args$1 = Array.prototype.slice.call(arguments);
      return assert$1(state.tag === null), state.tag = tag, this._useArgs(args$1), this;
    };
  }), Node.prototype.use = function(item) {
    assert$1(item);
    var state = this._baseState;
    return assert$1(state.use === null), state.use = item, this;
  }, Node.prototype.optional = function() {
    var state = this._baseState;
    return state.optional = true, this;
  }, Node.prototype.def = function(val) {
    var state = this._baseState;
    return assert$1(state.default === null), state.default = val, state.optional = true, this;
  }, Node.prototype.explicit = function(num) {
    var state = this._baseState;
    return assert$1(state.explicit === null && state.implicit === null), state.explicit = num, this;
  }, Node.prototype.implicit = function(num) {
    var state = this._baseState;
    return assert$1(state.explicit === null && state.implicit === null), state.implicit = num, this;
  }, Node.prototype.obj = function() {
    var state = this._baseState, args$1 = Array.prototype.slice.call(arguments);
    return state.obj = true, args$1.length !== 0 && this._useArgs(args$1), this;
  }, Node.prototype.key = function(newKey) {
    var state = this._baseState;
    return assert$1(state.key === null), state.key = newKey, this;
  }, Node.prototype.any = function() {
    var state = this._baseState;
    return state.any = true, this;
  }, Node.prototype.choice = function(obj) {
    var state = this._baseState;
    return assert$1(state.choice === null), state.choice = obj, this._useArgs(Object.keys(obj).map(function(key) {
      return obj[key];
    })), this;
  }, Node.prototype.contains = function(item) {
    var state = this._baseState;
    return assert$1(state.use === null), state.contains = item, this;
  }, Node.prototype._decode = function(input, options) {
    var state = this._baseState;
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state.default, present = true, prevKey = null;
    if (state.key !== null && (prevKey = input.enterKey(state.key)), state.optional) {
      var tag = null;
      if (state.explicit === null ? state.implicit === null ? state.tag !== null && (tag = state.tag) : tag = state.implicit : tag = state.explicit, tag === null && !state.any) {
        var save$2 = input.save();
        try {
          state.choice === null ? this._decodeGeneric(state.tag, input, options) : this._decodeChoice(input, options), present = true;
        } catch {
          present = false;
        }
        input.restore(save$2);
      } else if (present = this._peekTag(input, tag, state.any), input.isError(present)) return present;
    }
    var prevObj;
    if (state.obj && present && (prevObj = input.enterObject()), present) {
      if (state.explicit !== null) {
        var explicit = this._decodeTag(input, state.explicit);
        if (input.isError(explicit)) return explicit;
        input = explicit;
      }
      var start = input.offset;
      if (state.use === null && state.choice === null) {
        if (state.any) var save$2 = input.save();
        var body = this._decodeTag(input, state.implicit === null ? state.tag : state.implicit, state.any);
        if (input.isError(body)) return body;
        state.any ? result = input.raw(save$2) : input = body;
      }
      if (options && options.track && state.tag !== null && options.track(input.path(), start, input.length, `tagged`), options && options.track && state.tag !== null && options.track(input.path(), input.offset, input.length, `content`), result = state.any ? result : state.choice === null ? this._decodeGeneric(state.tag, input, options) : this._decodeChoice(input, options), input.isError(result)) return result;
      if (!state.any && state.choice === null && state.children !== null && state.children.forEach(function(child) {
        child._decode(input, options);
      }), state.contains && (state.tag === `octstr` || state.tag === `bitstr`)) {
        var data = new DecoderBuffer(result);
        result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
      }
    }
    return state.obj && present && (result = input.leaveObject(prevObj)), state.key !== null && (result !== null || present === true) ? input.leaveKey(prevKey, state.key, result) : prevKey !== null && input.exitKey(prevKey), result;
  }, Node.prototype._decodeGeneric = function(tag, input, options) {
    var state = this._baseState;
    return tag === `seq` || tag === `set` ? null : tag === `seqof` || tag === `setof` ? this._decodeList(input, tag, state.args[0], options) : /str$/.test(tag) ? this._decodeStr(input, tag, options) : tag === `objid` && state.args ? this._decodeObjid(input, state.args[0], state.args[1], options) : tag === `objid` ? this._decodeObjid(input, null, null, options) : tag === `gentime` || tag === `utctime` ? this._decodeTime(input, tag, options) : tag === `null_` ? this._decodeNull(input, options) : tag === `bool` ? this._decodeBool(input, options) : tag === `objDesc` ? this._decodeStr(input, tag, options) : tag === `int` || tag === `enum` ? this._decodeInt(input, state.args && state.args[0], options) : state.use === null ? input.error(`unknown tag: ` + tag) : this._getUse(state.use, input._reporterState.obj)._decode(input, options);
  }, Node.prototype._getUse = function(entity, obj) {
    var state = this._baseState;
    return state.useDecoder = this._use(entity, obj), assert$1(state.useDecoder._baseState.parent === null), state.useDecoder = state.useDecoder._baseState.children[0], state.implicit !== state.useDecoder._baseState.implicit && (state.useDecoder = state.useDecoder.clone(), state.useDecoder._baseState.implicit = state.implicit), state.useDecoder;
  }, Node.prototype._decodeChoice = function(input, options) {
    var state = this._baseState, result = null, match$2 = false;
    return Object.keys(state.choice).some(function(key) {
      var save$2 = input.save(), node = state.choice[key];
      try {
        var value = node._decode(input, options);
        if (input.isError(value)) return false;
        result = { type: key, value }, match$2 = true;
      } catch {
        return input.restore(save$2), false;
      }
      return true;
    }, this), match$2 ? result : input.error(`Choice not matched`);
  }, Node.prototype._createEncoderBuffer = function(data) {
    return new EncoderBuffer(data, this.reporter);
  }, Node.prototype._encode = function(data, reporter, parent) {
    var state = this._baseState;
    if (!(state.default !== null && state.default === data)) {
      var result = this._encodeValue(data, reporter, parent);
      if (result !== void 0 && !this._skipDefault(result, reporter, parent)) return result;
    }
  }, Node.prototype._encodeValue = function(data, reporter, parent) {
    var state = this._baseState;
    if (state.parent === null) return state.children[0]._encode(data, reporter || new Reporter());
    var result = null;
    if (this.reporter = reporter, state.optional && data === void 0) if (state.default !== null) data = state.default;
    else return;
    var content = null, primitive = false;
    if (state.any) result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) content = this._getUse(state.contains, parent)._encode(data, reporter), primitive = true;
    else if (state.children) content = state.children.map(function(child$1) {
      if (child$1._baseState.tag === `null_`) return child$1._encode(null, reporter, data);
      if (child$1._baseState.key === null) return reporter.error(`Child should have a key`);
      var prevKey = reporter.enterKey(child$1._baseState.key);
      if (typeof data != `object`) return reporter.error(`Child expected, but input is not object`);
      var res = child$1._encode(data[child$1._baseState.key], reporter, data);
      return reporter.leaveKey(prevKey), res;
    }, this).filter(function(child$1) {
      return child$1;
    }), content = this._createEncoderBuffer(content);
    else if (state.tag === `seqof` || state.tag === `setof`) {
      if (!(state.args && state.args.length === 1)) return reporter.error(`Too many args for : ` + state.tag);
      if (!Array.isArray(data)) return reporter.error(`seqof/setof, but data is not Array`);
      var child = this.clone();
      child._baseState.implicit = null, content = this._createEncoderBuffer(data.map(function(item) {
        var state$1 = this._baseState;
        return this._getUse(state$1.args[0], data)._encode(item, reporter);
      }, child));
    } else state.use === null ? (content = this._encodePrimitive(state.tag, data), primitive = true) : result = this._getUse(state.use, parent)._encode(data, reporter);
    var result;
    if (!state.any && state.choice === null) {
      var tag = state.implicit === null ? state.tag : state.implicit, cls = state.implicit === null ? `universal` : `context`;
      tag === null ? state.use === null && reporter.error(`Tag could be omitted only for .use()`) : state.use === null && (result = this._encodeComposite(tag, primitive, cls, content));
    }
    return state.explicit !== null && (result = this._encodeComposite(state.explicit, false, `context`, result)), result;
  }, Node.prototype._encodeChoice = function(data, reporter) {
    var state = this._baseState, node = state.choice[data.type];
    return node || assert$1(false, data.type + ` not found in ` + JSON.stringify(Object.keys(state.choice))), node._encode(data.value, reporter);
  }, Node.prototype._encodePrimitive = function(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    if (tag === `objid` && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    if (tag === `objid`) return this._encodeObjid(data, null, null);
    if (tag === `gentime` || tag === `utctime`) return this._encodeTime(data, tag);
    if (tag === `null_`) return this._encodeNull();
    if (tag === `int` || tag === `enum`) return this._encodeInt(data, state.args && state.reverseArgs[0]);
    if (tag === `bool`) return this._encodeBool(data);
    if (tag === `objDesc`) return this._encodeStr(data, tag);
    throw Error(`Unsupported tag: ` + tag);
  }, Node.prototype._isNumstr = function(str) {
    return /^[0-9 ]*$/.test(str);
  }, Node.prototype._isPrintstr = function(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
  };
}), require_base = __commonJSMin$1((exports$12) => {
  var base$2 = exports$12;
  base$2.Reporter = require_reporter().Reporter, base$2.DecoderBuffer = require_buffer().DecoderBuffer, base$2.EncoderBuffer = require_buffer().EncoderBuffer, base$2.Node = require_node();
}), require_der$2 = __commonJSMin$1((exports$12) => {
  var constants$2 = require_constants$1();
  exports$12.tagClass = { 0: `universal`, 1: `application`, 2: `context`, 3: `private` }, exports$12.tagClassByName = constants$2._reverse(exports$12.tagClass), exports$12.tag = { 0: `end`, 1: `bool`, 2: `int`, 3: `bitstr`, 4: `octstr`, 5: `null_`, 6: `objid`, 7: `objDesc`, 8: `external`, 9: `real`, 10: `enum`, 11: `embed`, 12: `utf8str`, 13: `relativeOid`, 16: `seq`, 17: `set`, 18: `numstr`, 19: `printstr`, 20: `t61str`, 21: `videostr`, 22: `ia5str`, 23: `utctime`, 24: `gentime`, 25: `graphstr`, 26: `iso646str`, 27: `genstr`, 28: `unistr`, 29: `charstr`, 30: `bmpstr` }, exports$12.tagByName = constants$2._reverse(exports$12.tag);
}), require_constants$1 = __commonJSMin$1((exports$12) => {
  var constants$1 = exports$12;
  constants$1._reverse = function(map$8) {
    var res = {};
    return Object.keys(map$8).forEach(function(key) {
      (key | 0) == key && (key |= 0);
      var value = map$8[key];
      res[value] = key;
    }), res;
  }, constants$1.der = require_der$2();
}), require_der$1 = __commonJSMin$1((exports$12, module2) => {
  var inherits$5 = require_inherits(), asn1$4 = require_asn1$1(), base$1 = asn1$4.base, bignum = asn1$4.bignum, der$1 = asn1$4.constants.der;
  function DERDecoder$1(entity) {
    this.enc = `der`, this.name = entity.name, this.entity = entity, this.tree = new DERNode$1(), this.tree._init(entity.body);
  }
  module2.exports = DERDecoder$1, DERDecoder$1.prototype.decode = function(data, options) {
    return data instanceof base$1.DecoderBuffer || (data = new base$1.DecoderBuffer(data, options)), this.tree._decode(data, options);
  };
  function DERNode$1(parent) {
    base$1.Node.call(this, `der`, parent);
  }
  inherits$5(DERNode$1, base$1.Node), DERNode$1.prototype._peekTag = function(buffer$3, tag, any) {
    if (buffer$3.isEmpty()) return false;
    var state = buffer$3.save(), decodedTag = derDecodeTag(buffer$3, `Failed to peek tag: "` + tag + `"`);
    return buffer$3.isError(decodedTag) ? decodedTag : (buffer$3.restore(state), decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + `of` === tag || any);
  }, DERNode$1.prototype._decodeTag = function(buffer$3, tag, any) {
    var decodedTag = derDecodeTag(buffer$3, `Failed to decode tag of "` + tag + `"`);
    if (buffer$3.isError(decodedTag)) return decodedTag;
    var len$2 = derDecodeLen(buffer$3, decodedTag.primitive, `Failed to get length of "` + tag + `"`);
    if (buffer$3.isError(len$2)) return len$2;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + `of` !== tag) return buffer$3.error(`Failed to match tag: "` + tag + `"`);
    if (decodedTag.primitive || len$2 !== null) return buffer$3.skip(len$2, `Failed to match body of: "` + tag + `"`);
    var state = buffer$3.save(), res = this._skipUntilEnd(buffer$3, `Failed to skip indefinite length body: "` + this.tag + `"`);
    return buffer$3.isError(res) ? res : (len$2 = buffer$3.offset - state.offset, buffer$3.restore(state), buffer$3.skip(len$2, `Failed to match body of: "` + tag + `"`));
  }, DERNode$1.prototype._skipUntilEnd = function(buffer$3, fail$1) {
    for (; ; ) {
      var tag = derDecodeTag(buffer$3, fail$1);
      if (buffer$3.isError(tag)) return tag;
      var len$2 = derDecodeLen(buffer$3, tag.primitive, fail$1);
      if (buffer$3.isError(len$2)) return len$2;
      var res;
      if (res = tag.primitive || len$2 !== null ? buffer$3.skip(len$2) : this._skipUntilEnd(buffer$3, fail$1), buffer$3.isError(res)) return res;
      if (tag.tagStr === `end`) break;
    }
  }, DERNode$1.prototype._decodeList = function(buffer$3, tag, decoder, options) {
    for (var result = []; !buffer$3.isEmpty(); ) {
      var possibleEnd = this._peekTag(buffer$3, `end`);
      if (buffer$3.isError(possibleEnd)) return possibleEnd;
      var res = decoder.decode(buffer$3, `der`, options);
      if (buffer$3.isError(res) && possibleEnd) break;
      result.push(res);
    }
    return result;
  }, DERNode$1.prototype._decodeStr = function(buffer$3, tag) {
    if (tag === `bitstr`) {
      var unused = buffer$3.readUInt8();
      return buffer$3.isError(unused) ? unused : { unused, data: buffer$3.raw() };
    } else if (tag === `bmpstr`) {
      var raw = buffer$3.raw();
      if (raw.length % 2 == 1) return buffer$3.error(`Decoding of string type: bmpstr length mismatch`);
      for (var str = ``, i$4 = 0; i$4 < raw.length / 2; i$4++) str += String.fromCharCode(raw.readUInt16BE(i$4 * 2));
      return str;
    } else if (tag === `numstr`) {
      var numstr = buffer$3.raw().toString(`ascii`);
      return this._isNumstr(numstr) ? numstr : buffer$3.error(`Decoding of string type: numstr unsupported characters`);
    } else if (tag === `octstr`) return buffer$3.raw();
    else if (tag === `objDesc`) return buffer$3.raw();
    else if (tag === `printstr`) {
      var printstr = buffer$3.raw().toString(`ascii`);
      return this._isPrintstr(printstr) ? printstr : buffer$3.error(`Decoding of string type: printstr unsupported characters`);
    } else if (/str$/.test(tag)) return buffer$3.raw().toString();
    else return buffer$3.error(`Decoding of string type: ` + tag + ` unsupported`);
  }, DERNode$1.prototype._decodeObjid = function(buffer$3, values$3, relative) {
    for (var result, identifiers$1 = [], ident = 0; !buffer$3.isEmpty(); ) {
      var subident = buffer$3.readUInt8();
      ident <<= 7, ident |= subident & 127, subident & 128 || (identifiers$1.push(ident), ident = 0);
    }
    subident & 128 && identifiers$1.push(ident);
    var first$1 = identifiers$1[0] / 40 | 0, second = identifiers$1[0] % 40;
    if (result = relative ? identifiers$1 : [first$1, second].concat(identifiers$1.slice(1)), values$3) {
      var tmp = values$3[result.join(` `)];
      tmp === void 0 && (tmp = values$3[result.join(`.`)]), tmp !== void 0 && (result = tmp);
    }
    return result;
  }, DERNode$1.prototype._decodeTime = function(buffer$3, tag) {
    var str = buffer$3.raw().toString();
    if (tag === `gentime`) var year = str.slice(0, 4) | 0, mon = str.slice(4, 6) | 0, day = str.slice(6, 8) | 0, hour = str.slice(8, 10) | 0, min$1 = str.slice(10, 12) | 0, sec = str.slice(12, 14) | 0;
    else if (tag === `utctime`) {
      var year = str.slice(0, 2) | 0, mon = str.slice(2, 4) | 0, day = str.slice(4, 6) | 0, hour = str.slice(6, 8) | 0, min$1 = str.slice(8, 10) | 0, sec = str.slice(10, 12) | 0;
      year = year < 70 ? 2e3 + year : 1900 + year;
    } else return buffer$3.error(`Decoding ` + tag + ` time is not supported yet`);
    return Date.UTC(year, mon - 1, day, hour, min$1, sec, 0);
  }, DERNode$1.prototype._decodeNull = function(buffer$3) {
    return null;
  }, DERNode$1.prototype._decodeBool = function(buffer$3) {
    var res = buffer$3.readUInt8();
    return buffer$3.isError(res) ? res : res !== 0;
  }, DERNode$1.prototype._decodeInt = function(buffer$3, values$3) {
    var raw = buffer$3.raw(), res = new bignum(raw);
    return values$3 && (res = values$3[res.toString(10)] || res), res;
  }, DERNode$1.prototype._use = function(entity, obj) {
    return typeof entity == `function` && (entity = entity(obj)), entity._getDecoder(`der`).tree;
  };
  function derDecodeTag(buf, fail$1) {
    var tag = buf.readUInt8(fail$1);
    if (buf.isError(tag)) return tag;
    var cls = der$1.tagClass[tag >> 6], primitive = (tag & 32) == 0;
    if ((tag & 31) == 31) {
      var oct = tag;
      for (tag = 0; (oct & 128) == 128; ) {
        if (oct = buf.readUInt8(fail$1), buf.isError(oct)) return oct;
        tag <<= 7, tag |= oct & 127;
      }
    } else tag &= 31;
    var tagStr = der$1.tag[tag];
    return { cls, primitive, tag, tagStr };
  }
  function derDecodeLen(buf, primitive, fail$1) {
    var len$2 = buf.readUInt8(fail$1);
    if (buf.isError(len$2)) return len$2;
    if (!primitive && len$2 === 128) return null;
    if (!(len$2 & 128)) return len$2;
    var num = len$2 & 127;
    if (num > 4) return buf.error(`length octect is too long`);
    len$2 = 0;
    for (var i$4 = 0; i$4 < num; i$4++) {
      len$2 <<= 8;
      var j$1 = buf.readUInt8(fail$1);
      if (buf.isError(j$1)) return j$1;
      len$2 |= j$1;
    }
    return len$2;
  }
}), require_pem$1 = __commonJSMin$1((exports$12, module2) => {
  var inherits$4 = require_inherits(), Buffer$14 = (init_dist$1(), __toCommonJS(dist_exports)).Buffer, DERDecoder = require_der$1();
  function PEMDecoder(entity) {
    DERDecoder.call(this, entity), this.enc = `pem`;
  }
  inherits$4(PEMDecoder, DERDecoder), module2.exports = PEMDecoder, PEMDecoder.prototype.decode = function(data, options) {
    for (var lines = data.toString().split(/[\r\n]+/g), label = options.label.toUpperCase(), re$5 = /^-----(BEGIN|END) ([^-]+)-----$/, start = -1, end = -1, i$4 = 0; i$4 < lines.length; i$4++) {
      var match$2 = lines[i$4].match(re$5);
      if (match$2 !== null && match$2[2] === label) if (start === -1) {
        if (match$2[1] !== `BEGIN`) break;
        start = i$4;
      } else {
        if (match$2[1] !== `END`) break;
        end = i$4;
        break;
      }
    }
    if (start === -1 || end === -1) throw Error(`PEM section not found for: ` + label);
    var base64 = lines.slice(start + 1, end).join(``);
    base64.replace(/[^a-z0-9\+\/=]+/gi, ``);
    var input = new Buffer$14(base64, `base64`);
    return DERDecoder.prototype.decode.call(this, input, options);
  };
}), require_decoders = __commonJSMin$1((exports$12) => {
  var decoders = exports$12;
  decoders.der = require_der$1(), decoders.pem = require_pem$1();
}), require_der = __commonJSMin$1((exports$12, module2) => {
  var inherits$3 = require_inherits(), Buffer$13 = (init_dist$1(), __toCommonJS(dist_exports)).Buffer, asn1$3 = require_asn1$1(), base = asn1$3.base, der = asn1$3.constants.der;
  function DEREncoder$1(entity) {
    this.enc = `der`, this.name = entity.name, this.entity = entity, this.tree = new DERNode(), this.tree._init(entity.body);
  }
  module2.exports = DEREncoder$1, DEREncoder$1.prototype.encode = function(data, reporter) {
    return this.tree._encode(data, reporter).join();
  };
  function DERNode(parent) {
    base.Node.call(this, `der`, parent);
  }
  inherits$3(DERNode, base.Node), DERNode.prototype._encodeComposite = function(tag, primitive, cls, content) {
    var encodedTag = encodeTag(tag, primitive, cls, this.reporter);
    if (content.length < 128) {
      var header = new Buffer$13(2);
      return header[0] = encodedTag, header[1] = content.length, this._createEncoderBuffer([header, content]);
    }
    for (var lenOctets = 1, i$4 = content.length; i$4 >= 256; i$4 >>= 8) lenOctets++;
    var header = new Buffer$13(2 + lenOctets);
    header[0] = encodedTag, header[1] = 128 | lenOctets;
    for (var i$4 = 1 + lenOctets, j$1 = content.length; j$1 > 0; i$4--, j$1 >>= 8) header[i$4] = j$1 & 255;
    return this._createEncoderBuffer([header, content]);
  }, DERNode.prototype._encodeStr = function(str, tag) {
    if (tag === `bitstr`) return this._createEncoderBuffer([str.unused | 0, str.data]);
    if (tag === `bmpstr`) {
      for (var buf = new Buffer$13(str.length * 2), i$4 = 0; i$4 < str.length; i$4++) buf.writeUInt16BE(str.charCodeAt(i$4), i$4 * 2);
      return this._createEncoderBuffer(buf);
    } else if (tag === `numstr`) return this._isNumstr(str) ? this._createEncoderBuffer(str) : this.reporter.error(`Encoding of string type: numstr supports only digits and space`);
    else if (tag === `printstr`) return this._isPrintstr(str) ? this._createEncoderBuffer(str) : this.reporter.error(`Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark`);
    else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === `objDesc`) return this._createEncoderBuffer(str);
    else return this.reporter.error(`Encoding of string type: ` + tag + ` unsupported`);
  }, DERNode.prototype._encodeObjid = function(id, values$3, relative) {
    if (typeof id == `string`) {
      if (!values$3) return this.reporter.error(`string objid given, but no values map found`);
      if (!values$3.hasOwnProperty(id)) return this.reporter.error(`objid not found in values map`);
      id = values$3[id].split(/[\s\.]+/g);
      for (var i$4 = 0; i$4 < id.length; i$4++) id[i$4] |= 0;
    } else if (Array.isArray(id)) {
      id = id.slice();
      for (var i$4 = 0; i$4 < id.length; i$4++) id[i$4] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error(`objid() should be either array or string, got: ` + JSON.stringify(id));
    if (!relative) {
      if (id[1] >= 40) return this.reporter.error(`Second objid identifier OOB`);
      id.splice(0, 2, id[0] * 40 + id[1]);
    }
    for (var size = 0, i$4 = 0; i$4 < id.length; i$4++) {
      var ident = id[i$4];
      for (size++; ident >= 128; ident >>= 7) size++;
    }
    for (var objid = new Buffer$13(size), offset$2 = objid.length - 1, i$4 = id.length - 1; i$4 >= 0; i$4--) {
      var ident = id[i$4];
      for (objid[offset$2--] = ident & 127; (ident >>= 7) > 0; ) objid[offset$2--] = 128 | ident & 127;
    }
    return this._createEncoderBuffer(objid);
  };
  function two(num) {
    return num < 10 ? `0` + num : num;
  }
  DERNode.prototype._encodeTime = function(time, tag) {
    var str, date = new Date(time);
    return tag === `gentime` ? str = [two(date.getFullYear()), two(date.getUTCMonth() + 1), two(date.getUTCDate()), two(date.getUTCHours()), two(date.getUTCMinutes()), two(date.getUTCSeconds()), `Z`].join(``) : tag === `utctime` ? str = [two(date.getFullYear() % 100), two(date.getUTCMonth() + 1), two(date.getUTCDate()), two(date.getUTCHours()), two(date.getUTCMinutes()), two(date.getUTCSeconds()), `Z`].join(``) : this.reporter.error(`Encoding ` + tag + ` time is not supported yet`), this._encodeStr(str, `octstr`);
  }, DERNode.prototype._encodeNull = function() {
    return this._createEncoderBuffer(``);
  }, DERNode.prototype._encodeInt = function(num, values$3) {
    if (typeof num == `string`) {
      if (!values$3) return this.reporter.error(`String int or enum given, but no values map`);
      if (!values$3.hasOwnProperty(num)) return this.reporter.error(`Values map doesn't contain: ` + JSON.stringify(num));
      num = values$3[num];
    }
    if (typeof num != `number` && !Buffer$13.isBuffer(num)) {
      var numArray = num.toArray();
      !num.sign && numArray[0] & 128 && numArray.unshift(0), num = new Buffer$13(numArray);
    }
    if (Buffer$13.isBuffer(num)) {
      var size = num.length;
      num.length === 0 && size++;
      var out = new Buffer$13(size);
      return num.copy(out), num.length === 0 && (out[0] = 0), this._createEncoderBuffer(out);
    }
    if (num < 128) return this._createEncoderBuffer(num);
    if (num < 256) return this._createEncoderBuffer([0, num]);
    for (var size = 1, i$4 = num; i$4 >= 256; i$4 >>= 8) size++;
    for (var out = Array(size), i$4 = out.length - 1; i$4 >= 0; i$4--) out[i$4] = num & 255, num >>= 8;
    return out[0] & 128 && out.unshift(0), this._createEncoderBuffer(new Buffer$13(out));
  }, DERNode.prototype._encodeBool = function(value) {
    return this._createEncoderBuffer(value ? 255 : 0);
  }, DERNode.prototype._use = function(entity, obj) {
    return typeof entity == `function` && (entity = entity(obj)), entity._getEncoder(`der`).tree;
  }, DERNode.prototype._skipDefault = function(dataBuffer, reporter, parent) {
    var state = this._baseState, i$4;
    if (state.default === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === void 0 && (state.defaultBuffer = this._encodeValue(state.default, reporter, parent).join()), data.length !== state.defaultBuffer.length) return false;
    for (i$4 = 0; i$4 < data.length; i$4++) if (data[i$4] !== state.defaultBuffer[i$4]) return false;
    return true;
  };
  function encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === `seqof` ? tag = `seq` : tag === `setof` && (tag = `set`), der.tagByName.hasOwnProperty(tag)) res = der.tagByName[tag];
    else if (typeof tag == `number` && (tag | 0) === tag) res = tag;
    else return reporter.error(`Unknown tag: ` + tag);
    return res >= 31 ? reporter.error(`Multi-octet tag encoding unsupported`) : (primitive || (res |= 32), res |= der.tagClassByName[cls || `universal`] << 6, res);
  }
}), require_pem = __commonJSMin$1((exports$12, module2) => {
  var inherits$2 = require_inherits(), DEREncoder = require_der();
  function PEMEncoder(entity) {
    DEREncoder.call(this, entity), this.enc = `pem`;
  }
  inherits$2(PEMEncoder, DEREncoder), module2.exports = PEMEncoder, PEMEncoder.prototype.encode = function(data, options) {
    for (var buf = DEREncoder.prototype.encode.call(this, data), p$1 = buf.toString(`base64`), out = [`-----BEGIN ` + options.label + `-----`], i$4 = 0; i$4 < p$1.length; i$4 += 64) out.push(p$1.slice(i$4, i$4 + 64));
    return out.push(`-----END ` + options.label + `-----`), out.join(`
`);
  };
}), require_encoders = __commonJSMin$1((exports$12) => {
  var encoders = exports$12;
  encoders.der = require_der(), encoders.pem = require_pem();
}), require_asn1$1 = __commonJSMin$1((exports$12) => {
  var asn1$2 = exports$12;
  asn1$2.bignum = require_bn$1(), asn1$2.define = require_api().define, asn1$2.base = require_base(), asn1$2.constants = require_constants$1(), asn1$2.decoders = require_decoders(), asn1$2.encoders = require_encoders();
}), require_certificate = __commonJSMin$1((exports$12, module2) => {
  var asn = require_asn1$1(), Time = asn.define(`Time`, function() {
    this.choice({ utcTime: this.utctime(), generalTime: this.gentime() });
  }), AttributeTypeValue = asn.define(`AttributeTypeValue`, function() {
    this.seq().obj(this.key(`type`).objid(), this.key(`value`).any());
  }), AlgorithmIdentifier$1 = asn.define(`AlgorithmIdentifier`, function() {
    this.seq().obj(this.key(`algorithm`).objid(), this.key(`parameters`).optional(), this.key(`curve`).objid().optional());
  }), SubjectPublicKeyInfo = asn.define(`SubjectPublicKeyInfo`, function() {
    this.seq().obj(this.key(`algorithm`).use(AlgorithmIdentifier$1), this.key(`subjectPublicKey`).bitstr());
  }), RelativeDistinguishedName = asn.define(`RelativeDistinguishedName`, function() {
    this.setof(AttributeTypeValue);
  }), RDNSequence = asn.define(`RDNSequence`, function() {
    this.seqof(RelativeDistinguishedName);
  }), Name = asn.define(`Name`, function() {
    this.choice({ rdnSequence: this.use(RDNSequence) });
  }), Validity = asn.define(`Validity`, function() {
    this.seq().obj(this.key(`notBefore`).use(Time), this.key(`notAfter`).use(Time));
  }), Extension = asn.define(`Extension`, function() {
    this.seq().obj(this.key(`extnID`).objid(), this.key(`critical`).bool().def(false), this.key(`extnValue`).octstr());
  }), TBSCertificate = asn.define(`TBSCertificate`, function() {
    this.seq().obj(this.key(`version`).explicit(0).int().optional(), this.key(`serialNumber`).int(), this.key(`signature`).use(AlgorithmIdentifier$1), this.key(`issuer`).use(Name), this.key(`validity`).use(Validity), this.key(`subject`).use(Name), this.key(`subjectPublicKeyInfo`).use(SubjectPublicKeyInfo), this.key(`issuerUniqueID`).implicit(1).bitstr().optional(), this.key(`subjectUniqueID`).implicit(2).bitstr().optional(), this.key(`extensions`).explicit(3).seqof(Extension).optional());
  }), X509Certificate = asn.define(`X509Certificate`, function() {
    this.seq().obj(this.key(`tbsCertificate`).use(TBSCertificate), this.key(`signatureAlgorithm`).use(AlgorithmIdentifier$1), this.key(`signatureValue`).bitstr());
  });
  module2.exports = X509Certificate;
}), require_asn1 = __commonJSMin$1((exports$12) => {
  var asn1$1 = require_asn1$1();
  exports$12.certificate = require_certificate();
  var RSAPrivateKey = asn1$1.define(`RSAPrivateKey`, function() {
    this.seq().obj(this.key(`version`).int(), this.key(`modulus`).int(), this.key(`publicExponent`).int(), this.key(`privateExponent`).int(), this.key(`prime1`).int(), this.key(`prime2`).int(), this.key(`exponent1`).int(), this.key(`exponent2`).int(), this.key(`coefficient`).int());
  });
  exports$12.RSAPrivateKey = RSAPrivateKey;
  var RSAPublicKey = asn1$1.define(`RSAPublicKey`, function() {
    this.seq().obj(this.key(`modulus`).int(), this.key(`publicExponent`).int());
  });
  exports$12.RSAPublicKey = RSAPublicKey;
  var AlgorithmIdentifier = asn1$1.define(`AlgorithmIdentifier`, function() {
    this.seq().obj(this.key(`algorithm`).objid(), this.key(`none`).null_().optional(), this.key(`curve`).objid().optional(), this.key(`params`).seq().obj(this.key(`p`).int(), this.key(`q`).int(), this.key(`g`).int()).optional());
  }), PublicKey = asn1$1.define(`SubjectPublicKeyInfo`, function() {
    this.seq().obj(this.key(`algorithm`).use(AlgorithmIdentifier), this.key(`subjectPublicKey`).bitstr());
  });
  exports$12.PublicKey = PublicKey;
  var PrivateKeyInfo = asn1$1.define(`PrivateKeyInfo`, function() {
    this.seq().obj(this.key(`version`).int(), this.key(`algorithm`).use(AlgorithmIdentifier), this.key(`subjectPrivateKey`).octstr());
  });
  exports$12.PrivateKey = PrivateKeyInfo;
  var EncryptedPrivateKeyInfo = asn1$1.define(`EncryptedPrivateKeyInfo`, function() {
    this.seq().obj(this.key(`algorithm`).seq().obj(this.key(`id`).objid(), this.key(`decrypt`).seq().obj(this.key(`kde`).seq().obj(this.key(`id`).objid(), this.key(`kdeparams`).seq().obj(this.key(`salt`).octstr(), this.key(`iters`).int())), this.key(`cipher`).seq().obj(this.key(`algo`).objid(), this.key(`iv`).octstr()))), this.key(`subjectPrivateKey`).octstr());
  });
  exports$12.EncryptedPrivateKey = EncryptedPrivateKeyInfo;
  var DSAPrivateKey = asn1$1.define(`DSAPrivateKey`, function() {
    this.seq().obj(this.key(`version`).int(), this.key(`p`).int(), this.key(`q`).int(), this.key(`g`).int(), this.key(`pub_key`).int(), this.key(`priv_key`).int());
  });
  exports$12.DSAPrivateKey = DSAPrivateKey, exports$12.DSAparam = asn1$1.define(`DSAparam`, function() {
    this.int();
  });
  var ECParameters = asn1$1.define(`ECParameters`, function() {
    this.choice({ namedCurve: this.objid() });
  }), ECPrivateKey = asn1$1.define(`ECPrivateKey`, function() {
    this.seq().obj(this.key(`version`).int(), this.key(`privateKey`).octstr(), this.key(`parameters`).optional().explicit(0).use(ECParameters), this.key(`publicKey`).optional().explicit(1).bitstr());
  });
  exports$12.ECPrivateKey = ECPrivateKey, exports$12.signature = asn1$1.define(`signature`, function() {
    this.seq().obj(this.key(`r`).int(), this.key(`s`).int());
  });
}), aesid_exports = {};
__export(aesid_exports, { default: () => aesid_default });
var aesid_default, init_aesid = __esmMin(() => {
  aesid_default = { "2.16.840.1.101.3.4.1.1": `aes-128-ecb`, "2.16.840.1.101.3.4.1.2": `aes-128-cbc`, "2.16.840.1.101.3.4.1.3": `aes-128-ofb`, "2.16.840.1.101.3.4.1.4": `aes-128-cfb`, "2.16.840.1.101.3.4.1.21": `aes-192-ecb`, "2.16.840.1.101.3.4.1.22": `aes-192-cbc`, "2.16.840.1.101.3.4.1.23": `aes-192-ofb`, "2.16.840.1.101.3.4.1.24": `aes-192-cfb`, "2.16.840.1.101.3.4.1.41": `aes-256-ecb`, "2.16.840.1.101.3.4.1.42": `aes-256-cbc`, "2.16.840.1.101.3.4.1.43": `aes-256-ofb`, "2.16.840.1.101.3.4.1.44": `aes-256-cfb` };
}), require_hash_base = __commonJSMin$1((exports$12, module2) => {
  var Buffer$12 = require_safe_buffer().Buffer, Transform = require_stream_browserify().Transform, inherits$1 = require_inherits();
  function HashBase$1(blockSize) {
    Transform.call(this), this._block = Buffer$12.allocUnsafe(blockSize), this._blockSize = blockSize, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = false;
  }
  inherits$1(HashBase$1, Transform), HashBase$1.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
      this.update(chunk, encoding);
    } catch (err$1) {
      error = err$1;
    }
    callback(error);
  }, HashBase$1.prototype._flush = function(callback) {
    var error = null;
    try {
      this.push(this.digest());
    } catch (err$1) {
      error = err$1;
    }
    callback(error);
  };
  var useUint8Array = typeof Uint8Array < `u`, useArrayBuffer = typeof ArrayBuffer < `u` && typeof Uint8Array < `u` && ArrayBuffer.isView && (Buffer$12.prototype instanceof Uint8Array || Buffer$12.TYPED_ARRAY_SUPPORT);
  function toBuffer(data, encoding) {
    if (data instanceof Buffer$12) return data;
    if (typeof data == `string`) return Buffer$12.from(data, encoding);
    if (useArrayBuffer && ArrayBuffer.isView(data)) {
      if (data.byteLength === 0) return Buffer$12.alloc(0);
      var res = Buffer$12.from(data.buffer, data.byteOffset, data.byteLength);
      if (res.byteLength === data.byteLength) return res;
    }
    if (useUint8Array && data instanceof Uint8Array || Buffer$12.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer == `function` && data.constructor.isBuffer(data)) return Buffer$12.from(data);
    throw TypeError(`The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.`);
  }
  HashBase$1.prototype.update = function(data, encoding) {
    if (this._finalized) throw Error(`Digest already called`);
    data = toBuffer(data, encoding);
    for (var block$1 = this._block, offset$2 = 0; this._blockOffset + data.length - offset$2 >= this._blockSize; ) {
      for (var i$4 = this._blockOffset; i$4 < this._blockSize; ) block$1[i$4++] = data[offset$2++];
      this._update(), this._blockOffset = 0;
    }
    for (; offset$2 < data.length; ) block$1[this._blockOffset++] = data[offset$2++];
    for (var j$1 = 0, carry = data.length * 8; carry > 0; ++j$1) this._length[j$1] += carry, carry = this._length[j$1] / 4294967296 | 0, carry > 0 && (this._length[j$1] -= 4294967296 * carry);
    return this;
  }, HashBase$1.prototype._update = function() {
    throw Error(`_update is not implemented`);
  }, HashBase$1.prototype.digest = function(encoding) {
    if (this._finalized) throw Error(`Digest already called`);
    this._finalized = true;
    var digest = this._digest();
    encoding !== void 0 && (digest = digest.toString(encoding)), this._block.fill(0), this._blockOffset = 0;
    for (var i$4 = 0; i$4 < 4; ++i$4) this._length[i$4] = 0;
    return digest;
  }, HashBase$1.prototype._digest = function() {
    throw Error(`_digest is not implemented`);
  }, module2.exports = HashBase$1;
}), require_md5 = __commonJSMin$1((exports$12, module2) => {
  var inherits = require_inherits(), HashBase = require_hash_base(), Buffer$11 = require_safe_buffer().Buffer, ARRAY16 = Array(16);
  function MD5$1() {
    HashBase.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
  }
  inherits(MD5$1, HashBase), MD5$1.prototype._update = function() {
    for (var M$1 = ARRAY16, i$4 = 0; i$4 < 16; ++i$4) M$1[i$4] = this._block.readInt32LE(i$4 * 4);
    var a$22 = this._a, b2 = this._b, c$12 = this._c, d$12 = this._d;
    a$22 = fnF(a$22, b2, c$12, d$12, M$1[0], 3614090360, 7), d$12 = fnF(d$12, a$22, b2, c$12, M$1[1], 3905402710, 12), c$12 = fnF(c$12, d$12, a$22, b2, M$1[2], 606105819, 17), b2 = fnF(b2, c$12, d$12, a$22, M$1[3], 3250441966, 22), a$22 = fnF(a$22, b2, c$12, d$12, M$1[4], 4118548399, 7), d$12 = fnF(d$12, a$22, b2, c$12, M$1[5], 1200080426, 12), c$12 = fnF(c$12, d$12, a$22, b2, M$1[6], 2821735955, 17), b2 = fnF(b2, c$12, d$12, a$22, M$1[7], 4249261313, 22), a$22 = fnF(a$22, b2, c$12, d$12, M$1[8], 1770035416, 7), d$12 = fnF(d$12, a$22, b2, c$12, M$1[9], 2336552879, 12), c$12 = fnF(c$12, d$12, a$22, b2, M$1[10], 4294925233, 17), b2 = fnF(b2, c$12, d$12, a$22, M$1[11], 2304563134, 22), a$22 = fnF(a$22, b2, c$12, d$12, M$1[12], 1804603682, 7), d$12 = fnF(d$12, a$22, b2, c$12, M$1[13], 4254626195, 12), c$12 = fnF(c$12, d$12, a$22, b2, M$1[14], 2792965006, 17), b2 = fnF(b2, c$12, d$12, a$22, M$1[15], 1236535329, 22), a$22 = fnG(a$22, b2, c$12, d$12, M$1[1], 4129170786, 5), d$12 = fnG(d$12, a$22, b2, c$12, M$1[6], 3225465664, 9), c$12 = fnG(c$12, d$12, a$22, b2, M$1[11], 643717713, 14), b2 = fnG(b2, c$12, d$12, a$22, M$1[0], 3921069994, 20), a$22 = fnG(a$22, b2, c$12, d$12, M$1[5], 3593408605, 5), d$12 = fnG(d$12, a$22, b2, c$12, M$1[10], 38016083, 9), c$12 = fnG(c$12, d$12, a$22, b2, M$1[15], 3634488961, 14), b2 = fnG(b2, c$12, d$12, a$22, M$1[4], 3889429448, 20), a$22 = fnG(a$22, b2, c$12, d$12, M$1[9], 568446438, 5), d$12 = fnG(d$12, a$22, b2, c$12, M$1[14], 3275163606, 9), c$12 = fnG(c$12, d$12, a$22, b2, M$1[3], 4107603335, 14), b2 = fnG(b2, c$12, d$12, a$22, M$1[8], 1163531501, 20), a$22 = fnG(a$22, b2, c$12, d$12, M$1[13], 2850285829, 5), d$12 = fnG(d$12, a$22, b2, c$12, M$1[2], 4243563512, 9), c$12 = fnG(c$12, d$12, a$22, b2, M$1[7], 1735328473, 14), b2 = fnG(b2, c$12, d$12, a$22, M$1[12], 2368359562, 20), a$22 = fnH(a$22, b2, c$12, d$12, M$1[5], 4294588738, 4), d$12 = fnH(d$12, a$22, b2, c$12, M$1[8], 2272392833, 11), c$12 = fnH(c$12, d$12, a$22, b2, M$1[11], 1839030562, 16), b2 = fnH(b2, c$12, d$12, a$22, M$1[14], 4259657740, 23), a$22 = fnH(a$22, b2, c$12, d$12, M$1[1], 2763975236, 4), d$12 = fnH(d$12, a$22, b2, c$12, M$1[4], 1272893353, 11), c$12 = fnH(c$12, d$12, a$22, b2, M$1[7], 4139469664, 16), b2 = fnH(b2, c$12, d$12, a$22, M$1[10], 3200236656, 23), a$22 = fnH(a$22, b2, c$12, d$12, M$1[13], 681279174, 4), d$12 = fnH(d$12, a$22, b2, c$12, M$1[0], 3936430074, 11), c$12 = fnH(c$12, d$12, a$22, b2, M$1[3], 3572445317, 16), b2 = fnH(b2, c$12, d$12, a$22, M$1[6], 76029189, 23), a$22 = fnH(a$22, b2, c$12, d$12, M$1[9], 3654602809, 4), d$12 = fnH(d$12, a$22, b2, c$12, M$1[12], 3873151461, 11), c$12 = fnH(c$12, d$12, a$22, b2, M$1[15], 530742520, 16), b2 = fnH(b2, c$12, d$12, a$22, M$1[2], 3299628645, 23), a$22 = fnI(a$22, b2, c$12, d$12, M$1[0], 4096336452, 6), d$12 = fnI(d$12, a$22, b2, c$12, M$1[7], 1126891415, 10), c$12 = fnI(c$12, d$12, a$22, b2, M$1[14], 2878612391, 15), b2 = fnI(b2, c$12, d$12, a$22, M$1[5], 4237533241, 21), a$22 = fnI(a$22, b2, c$12, d$12, M$1[12], 1700485571, 6), d$12 = fnI(d$12, a$22, b2, c$12, M$1[3], 2399980690, 10), c$12 = fnI(c$12, d$12, a$22, b2, M$1[10], 4293915773, 15), b2 = fnI(b2, c$12, d$12, a$22, M$1[1], 2240044497, 21), a$22 = fnI(a$22, b2, c$12, d$12, M$1[8], 1873313359, 6), d$12 = fnI(d$12, a$22, b2, c$12, M$1[15], 4264355552, 10), c$12 = fnI(c$12, d$12, a$22, b2, M$1[6], 2734768916, 15), b2 = fnI(b2, c$12, d$12, a$22, M$1[13], 1309151649, 21), a$22 = fnI(a$22, b2, c$12, d$12, M$1[4], 4149444226, 6), d$12 = fnI(d$12, a$22, b2, c$12, M$1[11], 3174756917, 10), c$12 = fnI(c$12, d$12, a$22, b2, M$1[2], 718787259, 15), b2 = fnI(b2, c$12, d$12, a$22, M$1[9], 3951481745, 21), this._a = this._a + a$22 | 0, this._b = this._b + b2 | 0, this._c = this._c + c$12 | 0, this._d = this._d + d$12 | 0;
  }, MD5$1.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var buffer$3 = Buffer$11.allocUnsafe(16);
    return buffer$3.writeInt32LE(this._a, 0), buffer$3.writeInt32LE(this._b, 4), buffer$3.writeInt32LE(this._c, 8), buffer$3.writeInt32LE(this._d, 12), buffer$3;
  };
  function rotl(x$1, n$4) {
    return x$1 << n$4 | x$1 >>> 32 - n$4;
  }
  function fnF(a$22, b2, c$12, d$12, m$3, k, s$6) {
    return rotl(a$22 + (b2 & c$12 | ~b2 & d$12) + m$3 + k | 0, s$6) + b2 | 0;
  }
  function fnG(a$22, b2, c$12, d$12, m$3, k, s$6) {
    return rotl(a$22 + (b2 & d$12 | c$12 & ~d$12) + m$3 + k | 0, s$6) + b2 | 0;
  }
  function fnH(a$22, b2, c$12, d$12, m$3, k, s$6) {
    return rotl(a$22 + (b2 ^ c$12 ^ d$12) + m$3 + k | 0, s$6) + b2 | 0;
  }
  function fnI(a$22, b2, c$12, d$12, m$3, k, s$6) {
    return rotl(a$22 + (c$12 ^ (b2 | ~d$12)) + m$3 + k | 0, s$6) + b2 | 0;
  }
  module2.exports = MD5$1;
}), require_evp_bytestokey = __commonJSMin$1((exports$12, module2) => {
  var Buffer$10 = require_safe_buffer().Buffer, MD5 = require_md5();
  function EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (Buffer$10.isBuffer(password) || (password = Buffer$10.from(password, `binary`)), salt && (Buffer$10.isBuffer(salt) || (salt = Buffer$10.from(salt, `binary`)), salt.length !== 8)) throw RangeError(`salt should be Buffer with 8 byte length`);
    for (var keyLen = keyBits / 8, key = Buffer$10.alloc(keyLen), iv = Buffer$10.alloc(ivLen || 0), tmp = Buffer$10.alloc(0); keyLen > 0 || ivLen > 0; ) {
      var hash$4 = new MD5();
      hash$4.update(tmp), hash$4.update(password), salt && hash$4.update(salt), tmp = hash$4.digest();
      var used = 0;
      if (keyLen > 0) {
        var keyStart = key.length - keyLen;
        used = Math.min(keyLen, tmp.length), tmp.copy(key, keyStart, 0, used), keyLen -= used;
      }
      if (used < tmp.length && ivLen > 0) {
        var ivStart = iv.length - ivLen, length = Math.min(ivLen, tmp.length - used);
        tmp.copy(iv, ivStart, used, used + length), ivLen -= length;
      }
    }
    return tmp.fill(0), { key, iv };
  }
  module2.exports = EVP_BytesToKey;
}), require_browserify_aes = __commonJSMin$1((exports$12) => {
  var crypto$3 = require_crypto_browserify();
  exports$12.createCipher = exports$12.Cipher = crypto$3.createCipher, exports$12.createCipheriv = exports$12.Cipheriv = crypto$3.createCipheriv, exports$12.createDecipher = exports$12.Decipher = crypto$3.createDecipher, exports$12.createDecipheriv = exports$12.Decipheriv = crypto$3.createDecipheriv, exports$12.listCiphers = exports$12.getCiphers = crypto$3.getCiphers;
}), require_fixProc = __commonJSMin$1((exports$12, module2) => {
  var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, evp = require_evp_bytestokey(), ciphers$1 = require_browserify_aes(), Buffer$9 = require_safe_buffer().Buffer;
  module2.exports = function(okey, password) {
    var key = okey.toString(), match$2 = key.match(findProc), decrypted;
    if (match$2) {
      var suite = `aes` + match$2[1], iv = Buffer$9.from(match$2[2], `hex`), cipherText = Buffer$9.from(match$2[3].replace(/[\r\n]/g, ``), `base64`), cipherKey = evp(password, iv.slice(0, 8), parseInt(match$2[1], 10)).key, out = [], cipher = ciphers$1.createDecipheriv(suite, cipherKey, iv);
      out.push(cipher.update(cipherText)), out.push(cipher.final()), decrypted = Buffer$9.concat(out);
    } else {
      var match2 = key.match(fullRegex);
      decrypted = Buffer$9.from(match2[2].replace(/[\r\n]/g, ``), `base64`);
    }
    var tag = key.match(startRegex)[1];
    return { tag, data: decrypted };
  };
}), require_parse_asn1 = __commonJSMin$1((exports$12, module2) => {
  var asn1 = require_asn1(), aesid = (init_aesid(), __toCommonJS(aesid_exports).default), fixProc = require_fixProc(), ciphers = require_browserify_aes(), compat = require_pbkdf2(), Buffer$8 = require_safe_buffer().Buffer;
  function decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt, iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), algo = aesid[data.algorithm.decrypt.cipher.algo.join(`.`)], iv = data.algorithm.decrypt.cipher.iv, cipherText = data.subjectPrivateKey, keylen = parseInt(algo.split(`-`)[1], 10) / 8, key = compat.pbkdf2Sync(password, salt, iters, keylen, `sha1`), cipher = ciphers.createDecipheriv(algo, key, iv), out = [];
    return out.push(cipher.update(cipherText)), out.push(cipher.final()), Buffer$8.concat(out);
  }
  function parseKeys$2(buffer$3) {
    var password;
    typeof buffer$3 == `object` && !Buffer$8.isBuffer(buffer$3) && (password = buffer$3.passphrase, buffer$3 = buffer$3.key), typeof buffer$3 == `string` && (buffer$3 = Buffer$8.from(buffer$3));
    var stripped = fixProc(buffer$3, password), type = stripped.tag, data = stripped.data, subtype, ndata;
    switch (type) {
      case `CERTIFICATE`:
        ndata = asn1.certificate.decode(data, `der`).tbsCertificate.subjectPublicKeyInfo;
      case `PUBLIC KEY`:
        switch (ndata ||= asn1.PublicKey.decode(data, `der`), subtype = ndata.algorithm.algorithm.join(`.`), subtype) {
          case `1.2.840.113549.1.1.1`:
            return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, `der`);
          case `1.2.840.10045.2.1`:
            return ndata.subjectPrivateKey = ndata.subjectPublicKey, { type: `ec`, data: ndata };
          case `1.2.840.10040.4.1`:
            return ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, `der`), { type: `dsa`, data: ndata.algorithm.params };
          default:
            throw Error(`unknown key id ` + subtype);
        }
      case `ENCRYPTED PRIVATE KEY`:
        data = asn1.EncryptedPrivateKey.decode(data, `der`), data = decrypt(data, password);
      case `PRIVATE KEY`:
        switch (ndata = asn1.PrivateKey.decode(data, `der`), subtype = ndata.algorithm.algorithm.join(`.`), subtype) {
          case `1.2.840.113549.1.1.1`:
            return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, `der`);
          case `1.2.840.10045.2.1`:
            return { curve: ndata.algorithm.curve, privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, `der`).privateKey };
          case `1.2.840.10040.4.1`:
            return ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, `der`), { type: `dsa`, params: ndata.algorithm.params };
          default:
            throw Error(`unknown key id ` + subtype);
        }
      case `RSA PUBLIC KEY`:
        return asn1.RSAPublicKey.decode(data, `der`);
      case `RSA PRIVATE KEY`:
        return asn1.RSAPrivateKey.decode(data, `der`);
      case `DSA PRIVATE KEY`:
        return { type: `dsa`, params: asn1.DSAPrivateKey.decode(data, `der`) };
      case `EC PRIVATE KEY`:
        return data = asn1.ECPrivateKey.decode(data, `der`), { curve: data.parameters.value, privateKey: data.privateKey };
      default:
        throw Error(`unknown key type ` + type);
    }
  }
  parseKeys$2.signature = asn1.signature, module2.exports = parseKeys$2;
}), require_mgf = __commonJSMin$1((exports$12, module2) => {
  var createHash$2 = require_create_hash(), Buffer$7 = require_safe_buffer().Buffer;
  module2.exports = function(seed, len$2) {
    for (var t$7 = Buffer$7.alloc(0), i$4 = 0, c$12; t$7.length < len$2; ) c$12 = i2ops(i$4++), t$7 = Buffer$7.concat([t$7, createHash$2(`sha1`).update(seed).update(c$12).digest()]);
    return t$7.slice(0, len$2);
  };
  function i2ops(c$12) {
    var out = Buffer$7.allocUnsafe(4);
    return out.writeUInt32BE(c$12, 0), out;
  }
}), require_xor = __commonJSMin$1((exports$12, module2) => {
  module2.exports = function(a$22, b2) {
    for (var len$2 = a$22.length, i$4 = -1; ++i$4 < len$2; ) a$22[i$4] ^= b2[i$4];
    return a$22;
  };
}), require_withPublic = __commonJSMin$1((exports$12, module2) => {
  var BN$3 = require_bn$1(), Buffer$6 = require_safe_buffer().Buffer;
  function withPublic$2(paddedMsg, key) {
    return Buffer$6.from(paddedMsg.toRed(BN$3.mont(key.modulus)).redPow(new BN$3(key.publicExponent)).fromRed().toArray());
  }
  module2.exports = withPublic$2;
}), require_bn = __commonJSMin$1((exports$12, module2) => {
  (function(module$12, exports$13) {
    function assert$54(val, msg) {
      if (!val) throw Error(msg || `Assertion failed`);
    }
    function inherits$14(ctor, superCtor) {
      ctor.super_ = superCtor;
      var TempCtor = function() {
      };
      TempCtor.prototype = superCtor.prototype, ctor.prototype = new TempCtor(), ctor.prototype.constructor = ctor;
    }
    function BN$14(number, base$3, endian) {
      if (BN$14.isBN(number)) return number;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, number !== null && ((base$3 === `le` || base$3 === `be`) && (endian = base$3, base$3 = 10), this._init(number || 0, base$3 || 10, endian || `be`));
    }
    typeof module$12 == `object` ? module$12.exports = BN$14 : exports$13.BN = BN$14, BN$14.BN = BN$14, BN$14.wordSize = 26;
    var Buffer$27;
    try {
      Buffer$27 = typeof window < `u` && window.Buffer !== void 0 ? window.Buffer : (init_dist$1(), __toCommonJS(dist_exports)).Buffer;
    } catch {
    }
    BN$14.isBN = function(num) {
      return num instanceof BN$14 ? true : typeof num == `object` && !!num && num.constructor.wordSize === BN$14.wordSize && Array.isArray(num.words);
    }, BN$14.max = function(left, right) {
      return left.cmp(right) > 0 ? left : right;
    }, BN$14.min = function(left, right) {
      return left.cmp(right) < 0 ? left : right;
    }, BN$14.prototype._init = function(number, base$3, endian) {
      if (typeof number == `number`) return this._initNumber(number, base$3, endian);
      if (typeof number == `object`) return this._initArray(number, base$3, endian);
      base$3 === `hex` && (base$3 = 16), assert$54(base$3 === (base$3 | 0) && base$3 >= 2 && base$3 <= 36), number = number.toString().replace(/\s+/g, ``);
      var start = 0;
      number[0] === `-` && (start++, this.negative = 1), start < number.length && (base$3 === 16 ? this._parseHex(number, start, endian) : (this._parseBase(number, base$3, start), endian === `le` && this._initArray(this.toArray(), base$3, endian)));
    }, BN$14.prototype._initNumber = function(number, base$3, endian) {
      number < 0 && (this.negative = 1, number = -number), number < 67108864 ? (this.words = [number & 67108863], this.length = 1) : number < 4503599627370496 ? (this.words = [number & 67108863, number / 67108864 & 67108863], this.length = 2) : (assert$54(number < 9007199254740992), this.words = [number & 67108863, number / 67108864 & 67108863, 1], this.length = 3), endian === `le` && this._initArray(this.toArray(), base$3, endian);
    }, BN$14.prototype._initArray = function(number, base$3, endian) {
      if (assert$54(typeof number.length == `number`), number.length <= 0) return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(number.length / 3), this.words = Array(this.length);
      for (var i$4 = 0; i$4 < this.length; i$4++) this.words[i$4] = 0;
      var j$1, w$1, off = 0;
      if (endian === `be`) for (i$4 = number.length - 1, j$1 = 0; i$4 >= 0; i$4 -= 3) w$1 = number[i$4] | number[i$4 - 1] << 8 | number[i$4 - 2] << 16, this.words[j$1] |= w$1 << off & 67108863, this.words[j$1 + 1] = w$1 >>> 26 - off & 67108863, off += 24, off >= 26 && (off -= 26, j$1++);
      else if (endian === `le`) for (i$4 = 0, j$1 = 0; i$4 < number.length; i$4 += 3) w$1 = number[i$4] | number[i$4 + 1] << 8 | number[i$4 + 2] << 16, this.words[j$1] |= w$1 << off & 67108863, this.words[j$1 + 1] = w$1 >>> 26 - off & 67108863, off += 24, off >= 26 && (off -= 26, j$1++);
      return this._strip();
    };
    function parseHex4Bits(string, index$2) {
      var c$12 = string.charCodeAt(index$2);
      if (c$12 >= 48 && c$12 <= 57) return c$12 - 48;
      if (c$12 >= 65 && c$12 <= 70) return c$12 - 55;
      if (c$12 >= 97 && c$12 <= 102) return c$12 - 87;
      assert$54(false, `Invalid character in ` + string);
    }
    function parseHexByte(string, lowerBound, index$2) {
      var r$2 = parseHex4Bits(string, index$2);
      return index$2 - 1 >= lowerBound && (r$2 |= parseHex4Bits(string, index$2 - 1) << 4), r$2;
    }
    BN$14.prototype._parseHex = function(number, start, endian) {
      this.length = Math.ceil((number.length - start) / 6), this.words = Array(this.length);
      for (var i$4 = 0; i$4 < this.length; i$4++) this.words[i$4] = 0;
      var off = 0, j$1 = 0, w$1;
      if (endian === `be`) for (i$4 = number.length - 1; i$4 >= start; i$4 -= 2) w$1 = parseHexByte(number, start, i$4) << off, this.words[j$1] |= w$1 & 67108863, off >= 18 ? (off -= 18, j$1 += 1, this.words[j$1] |= w$1 >>> 26) : off += 8;
      else {
        var parseLength = number.length - start;
        for (i$4 = parseLength % 2 == 0 ? start + 1 : start; i$4 < number.length; i$4 += 2) w$1 = parseHexByte(number, start, i$4) << off, this.words[j$1] |= w$1 & 67108863, off >= 18 ? (off -= 18, j$1 += 1, this.words[j$1] |= w$1 >>> 26) : off += 8;
      }
      this._strip();
    };
    function parseBase(str, start, end, mul) {
      for (var r$2 = 0, b2 = 0, len$2 = Math.min(str.length, end), i$4 = start; i$4 < len$2; i$4++) {
        var c$12 = str.charCodeAt(i$4) - 48;
        r$2 *= mul, b2 = c$12 >= 49 ? c$12 - 49 + 10 : c$12 >= 17 ? c$12 - 17 + 10 : c$12, assert$54(c$12 >= 0 && b2 < mul, `Invalid character`), r$2 += b2;
      }
      return r$2;
    }
    BN$14.prototype._parseBase = function(number, base$3, start) {
      this.words = [0], this.length = 1;
      for (var limbLen = 0, limbPow = 1; limbPow <= 67108863; limbPow *= base$3) limbLen++;
      limbLen--, limbPow = limbPow / base$3 | 0;
      for (var total = number.length - start, mod = total % limbLen, end = Math.min(total, total - mod) + start, word = 0, i$4 = start; i$4 < end; i$4 += limbLen) word = parseBase(number, i$4, i$4 + limbLen, base$3), this.imuln(limbPow), this.words[0] + word < 67108864 ? this.words[0] += word : this._iaddn(word);
      if (mod !== 0) {
        var pow$1 = 1;
        for (word = parseBase(number, i$4, number.length, base$3), i$4 = 0; i$4 < mod; i$4++) pow$1 *= base$3;
        this.imuln(pow$1), this.words[0] + word < 67108864 ? this.words[0] += word : this._iaddn(word);
      }
      this._strip();
    }, BN$14.prototype.copy = function(dest) {
      dest.words = Array(this.length);
      for (var i$4 = 0; i$4 < this.length; i$4++) dest.words[i$4] = this.words[i$4];
      dest.length = this.length, dest.negative = this.negative, dest.red = this.red;
    };
    function move(dest, src$1) {
      dest.words = src$1.words, dest.length = src$1.length, dest.negative = src$1.negative, dest.red = src$1.red;
    }
    if (BN$14.prototype._move = function(dest) {
      move(dest, this);
    }, BN$14.prototype.clone = function() {
      var r$2 = new BN$14(null);
      return this.copy(r$2), r$2;
    }, BN$14.prototype._expand = function(size) {
      for (; this.length < size; ) this.words[this.length++] = 0;
      return this;
    }, BN$14.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; ) this.length--;
      return this._normSign();
    }, BN$14.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < `u` && typeof Symbol.for == `function`) try {
      BN$14.prototype[Symbol.for(`nodejs.util.inspect.custom`)] = inspect$4;
    } catch {
      BN$14.prototype.inspect = inspect$4;
    }
    else BN$14.prototype.inspect = inspect$4;
    function inspect$4() {
      return (this.red ? `<BN-R: ` : `<BN: `) + this.toString(16) + `>`;
    }
    var zeros = `.0.00.000.0000.00000.000000.0000000.00000000.000000000.0000000000.00000000000.000000000000.0000000000000.00000000000000.000000000000000.0000000000000000.00000000000000000.000000000000000000.0000000000000000000.00000000000000000000.000000000000000000000.0000000000000000000000.00000000000000000000000.000000000000000000000000.0000000000000000000000000`.split(`.`), groupSizes = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5], groupBases = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];
    BN$14.prototype.toString = function(base$3, padding) {
      base$3 ||= 10, padding = padding | 0 || 1;
      var out;
      if (base$3 === 16 || base$3 === `hex`) {
        out = ``;
        for (var off = 0, carry = 0, i$4 = 0; i$4 < this.length; i$4++) {
          var w$1 = this.words[i$4], word = ((w$1 << off | carry) & 16777215).toString(16);
          carry = w$1 >>> 24 - off & 16777215, off += 2, off >= 26 && (off -= 26, i$4--), out = carry !== 0 || i$4 !== this.length - 1 ? zeros[6 - word.length] + word + out : word + out;
        }
        for (carry !== 0 && (out = carry.toString(16) + out); out.length % padding !== 0; ) out = `0` + out;
        return this.negative !== 0 && (out = `-` + out), out;
      }
      if (base$3 === (base$3 | 0) && base$3 >= 2 && base$3 <= 36) {
        var groupSize = groupSizes[base$3], groupBase = groupBases[base$3];
        out = ``;
        var c$12 = this.clone();
        for (c$12.negative = 0; !c$12.isZero(); ) {
          var r$2 = c$12.modrn(groupBase).toString(base$3);
          c$12 = c$12.idivn(groupBase), out = c$12.isZero() ? r$2 + out : zeros[groupSize - r$2.length] + r$2 + out;
        }
        for (this.isZero() && (out = `0` + out); out.length % padding !== 0; ) out = `0` + out;
        return this.negative !== 0 && (out = `-` + out), out;
      }
      assert$54(false, `Base should be between 2 and 36`);
    }, BN$14.prototype.toNumber = function() {
      var ret = this.words[0];
      return this.length === 2 ? ret += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? ret += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && assert$54(false, `Number can only safely store up to 53 bits`), this.negative === 0 ? ret : -ret;
    }, BN$14.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, Buffer$27 && (BN$14.prototype.toBuffer = function(endian, length) {
      return this.toArrayLike(Buffer$27, endian, length);
    }), BN$14.prototype.toArray = function(endian, length) {
      return this.toArrayLike(Array, endian, length);
    };
    var allocate = function(ArrayType, size) {
      return ArrayType.allocUnsafe ? ArrayType.allocUnsafe(size) : new ArrayType(size);
    };
    BN$14.prototype.toArrayLike = function(ArrayType, endian, length) {
      this._strip();
      var byteLength$2 = this.byteLength(), reqLength = length || Math.max(1, byteLength$2);
      assert$54(byteLength$2 <= reqLength, `byte array longer than desired length`), assert$54(reqLength > 0, `Requested array length <= 0`);
      var res = allocate(ArrayType, reqLength), postfix = endian === `le` ? `LE` : `BE`;
      return this[`_toArrayLike` + postfix](res, byteLength$2), res;
    }, BN$14.prototype._toArrayLikeLE = function(res, byteLength$2) {
      for (var position = 0, carry = 0, i$4 = 0, shift = 0; i$4 < this.length; i$4++) {
        var word = this.words[i$4] << shift | carry;
        res[position++] = word & 255, position < res.length && (res[position++] = word >> 8 & 255), position < res.length && (res[position++] = word >> 16 & 255), shift === 6 ? (position < res.length && (res[position++] = word >> 24 & 255), carry = 0, shift = 0) : (carry = word >>> 24, shift += 2);
      }
      if (position < res.length) for (res[position++] = carry; position < res.length; ) res[position++] = 0;
    }, BN$14.prototype._toArrayLikeBE = function(res, byteLength$2) {
      for (var position = res.length - 1, carry = 0, i$4 = 0, shift = 0; i$4 < this.length; i$4++) {
        var word = this.words[i$4] << shift | carry;
        res[position--] = word & 255, position >= 0 && (res[position--] = word >> 8 & 255), position >= 0 && (res[position--] = word >> 16 & 255), shift === 6 ? (position >= 0 && (res[position--] = word >> 24 & 255), carry = 0, shift = 0) : (carry = word >>> 24, shift += 2);
      }
      if (position >= 0) for (res[position--] = carry; position >= 0; ) res[position--] = 0;
    }, Math.clz32 ? BN$14.prototype._countBits = function(w$1) {
      return 32 - Math.clz32(w$1);
    } : BN$14.prototype._countBits = function(w$1) {
      var t$7 = w$1, r$2 = 0;
      return t$7 >= 4096 && (r$2 += 13, t$7 >>>= 13), t$7 >= 64 && (r$2 += 7, t$7 >>>= 7), t$7 >= 8 && (r$2 += 4, t$7 >>>= 4), t$7 >= 2 && (r$2 += 2, t$7 >>>= 2), r$2 + t$7;
    }, BN$14.prototype._zeroBits = function(w$1) {
      if (w$1 === 0) return 26;
      var t$7 = w$1, r$2 = 0;
      return t$7 & 8191 || (r$2 += 13, t$7 >>>= 13), t$7 & 127 || (r$2 += 7, t$7 >>>= 7), t$7 & 15 || (r$2 += 4, t$7 >>>= 4), t$7 & 3 || (r$2 += 2, t$7 >>>= 2), t$7 & 1 || r$2++, r$2;
    }, BN$14.prototype.bitLength = function() {
      var w$1 = this.words[this.length - 1], hi = this._countBits(w$1);
      return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
      for (var w$1 = Array(num.bitLength()), bit = 0; bit < w$1.length; bit++) {
        var off = bit / 26 | 0, wbit = bit % 26;
        w$1[bit] = num.words[off] >>> wbit & 1;
      }
      return w$1;
    }
    BN$14.prototype.zeroBits = function() {
      if (this.isZero()) return 0;
      for (var r$2 = 0, i$4 = 0; i$4 < this.length; i$4++) {
        var b2 = this._zeroBits(this.words[i$4]);
        if (r$2 += b2, b2 !== 26) break;
      }
      return r$2;
    }, BN$14.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, BN$14.prototype.toTwos = function(width) {
      return this.negative === 0 ? this.clone() : this.abs().inotn(width).iaddn(1);
    }, BN$14.prototype.fromTwos = function(width) {
      return this.testn(width - 1) ? this.notn(width).iaddn(1).ineg() : this.clone();
    }, BN$14.prototype.isNeg = function() {
      return this.negative !== 0;
    }, BN$14.prototype.neg = function() {
      return this.clone().ineg();
    }, BN$14.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, BN$14.prototype.iuor = function(num) {
      for (; this.length < num.length; ) this.words[this.length++] = 0;
      for (var i$4 = 0; i$4 < num.length; i$4++) this.words[i$4] = this.words[i$4] | num.words[i$4];
      return this._strip();
    }, BN$14.prototype.ior = function(num) {
      return assert$54((this.negative | num.negative) === 0), this.iuor(num);
    }, BN$14.prototype.or = function(num) {
      return this.length > num.length ? this.clone().ior(num) : num.clone().ior(this);
    }, BN$14.prototype.uor = function(num) {
      return this.length > num.length ? this.clone().iuor(num) : num.clone().iuor(this);
    }, BN$14.prototype.iuand = function(num) {
      var b2;
      b2 = this.length > num.length ? num : this;
      for (var i$4 = 0; i$4 < b2.length; i$4++) this.words[i$4] = this.words[i$4] & num.words[i$4];
      return this.length = b2.length, this._strip();
    }, BN$14.prototype.iand = function(num) {
      return assert$54((this.negative | num.negative) === 0), this.iuand(num);
    }, BN$14.prototype.and = function(num) {
      return this.length > num.length ? this.clone().iand(num) : num.clone().iand(this);
    }, BN$14.prototype.uand = function(num) {
      return this.length > num.length ? this.clone().iuand(num) : num.clone().iuand(this);
    }, BN$14.prototype.iuxor = function(num) {
      var a$22, b2;
      this.length > num.length ? (a$22 = this, b2 = num) : (a$22 = num, b2 = this);
      for (var i$4 = 0; i$4 < b2.length; i$4++) this.words[i$4] = a$22.words[i$4] ^ b2.words[i$4];
      if (this !== a$22) for (; i$4 < a$22.length; i$4++) this.words[i$4] = a$22.words[i$4];
      return this.length = a$22.length, this._strip();
    }, BN$14.prototype.ixor = function(num) {
      return assert$54((this.negative | num.negative) === 0), this.iuxor(num);
    }, BN$14.prototype.xor = function(num) {
      return this.length > num.length ? this.clone().ixor(num) : num.clone().ixor(this);
    }, BN$14.prototype.uxor = function(num) {
      return this.length > num.length ? this.clone().iuxor(num) : num.clone().iuxor(this);
    }, BN$14.prototype.inotn = function(width) {
      assert$54(typeof width == `number` && width >= 0);
      var bytesNeeded = Math.ceil(width / 26) | 0, bitsLeft = width % 26;
      this._expand(bytesNeeded), bitsLeft > 0 && bytesNeeded--;
      for (var i$4 = 0; i$4 < bytesNeeded; i$4++) this.words[i$4] = ~this.words[i$4] & 67108863;
      return bitsLeft > 0 && (this.words[i$4] = ~this.words[i$4] & 67108863 >> 26 - bitsLeft), this._strip();
    }, BN$14.prototype.notn = function(width) {
      return this.clone().inotn(width);
    }, BN$14.prototype.setn = function(bit, val) {
      assert$54(typeof bit == `number` && bit >= 0);
      var off = bit / 26 | 0, wbit = bit % 26;
      return this._expand(off + 1), val ? this.words[off] = this.words[off] | 1 << wbit : this.words[off] = this.words[off] & ~(1 << wbit), this._strip();
    }, BN$14.prototype.iadd = function(num) {
      var r$2;
      if (this.negative !== 0 && num.negative === 0) return this.negative = 0, r$2 = this.isub(num), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && num.negative !== 0) return num.negative = 0, r$2 = this.isub(num), num.negative = 1, r$2._normSign();
      var a$22, b2;
      this.length > num.length ? (a$22 = this, b2 = num) : (a$22 = num, b2 = this);
      for (var carry = 0, i$4 = 0; i$4 < b2.length; i$4++) r$2 = (a$22.words[i$4] | 0) + (b2.words[i$4] | 0) + carry, this.words[i$4] = r$2 & 67108863, carry = r$2 >>> 26;
      for (; carry !== 0 && i$4 < a$22.length; i$4++) r$2 = (a$22.words[i$4] | 0) + carry, this.words[i$4] = r$2 & 67108863, carry = r$2 >>> 26;
      if (this.length = a$22.length, carry !== 0) this.words[this.length] = carry, this.length++;
      else if (a$22 !== this) for (; i$4 < a$22.length; i$4++) this.words[i$4] = a$22.words[i$4];
      return this;
    }, BN$14.prototype.add = function(num) {
      var res;
      return num.negative !== 0 && this.negative === 0 ? (num.negative = 0, res = this.sub(num), num.negative ^= 1, res) : num.negative === 0 && this.negative !== 0 ? (this.negative = 0, res = num.sub(this), this.negative = 1, res) : this.length > num.length ? this.clone().iadd(num) : num.clone().iadd(this);
    }, BN$14.prototype.isub = function(num) {
      if (num.negative !== 0) {
        num.negative = 0;
        var r$2 = this.iadd(num);
        return num.negative = 1, r$2._normSign();
      } else if (this.negative !== 0) return this.negative = 0, this.iadd(num), this.negative = 1, this._normSign();
      var cmp$3 = this.cmp(num);
      if (cmp$3 === 0) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var a$22, b2;
      cmp$3 > 0 ? (a$22 = this, b2 = num) : (a$22 = num, b2 = this);
      for (var carry = 0, i$4 = 0; i$4 < b2.length; i$4++) r$2 = (a$22.words[i$4] | 0) - (b2.words[i$4] | 0) + carry, carry = r$2 >> 26, this.words[i$4] = r$2 & 67108863;
      for (; carry !== 0 && i$4 < a$22.length; i$4++) r$2 = (a$22.words[i$4] | 0) + carry, carry = r$2 >> 26, this.words[i$4] = r$2 & 67108863;
      if (carry === 0 && i$4 < a$22.length && a$22 !== this) for (; i$4 < a$22.length; i$4++) this.words[i$4] = a$22.words[i$4];
      return this.length = Math.max(this.length, i$4), a$22 !== this && (this.negative = 1), this._strip();
    }, BN$14.prototype.sub = function(num) {
      return this.clone().isub(num);
    };
    function smallMulTo(self$1, num, out) {
      out.negative = num.negative ^ self$1.negative;
      var len$2 = self$1.length + num.length | 0;
      out.length = len$2, len$2 = len$2 - 1 | 0;
      var a$22 = self$1.words[0] | 0, b2 = num.words[0] | 0, r$2 = a$22 * b2, lo = r$2 & 67108863, carry = r$2 / 67108864 | 0;
      out.words[0] = lo;
      for (var k = 1; k < len$2; k++) {
        for (var ncarry = carry >>> 26, rword = carry & 67108863, maxJ = Math.min(k, num.length - 1), j$1 = Math.max(0, k - self$1.length + 1); j$1 <= maxJ; j$1++) {
          var i$4 = k - j$1 | 0;
          a$22 = self$1.words[i$4] | 0, b2 = num.words[j$1] | 0, r$2 = a$22 * b2 + rword, ncarry += r$2 / 67108864 | 0, rword = r$2 & 67108863;
        }
        out.words[k] = rword | 0, carry = ncarry | 0;
      }
      return carry === 0 ? out.length-- : out.words[k] = carry | 0, out._strip();
    }
    var comb10MulTo = function(self$1, num, out) {
      var a$22 = self$1.words, b2 = num.words, o$2 = out.words, c$12 = 0, lo, mid, hi, a0 = a$22[0] | 0, al0 = a0 & 8191, ah0 = a0 >>> 13, a1 = a$22[1] | 0, al1 = a1 & 8191, ah1 = a1 >>> 13, a2 = a$22[2] | 0, al2 = a2 & 8191, ah2 = a2 >>> 13, a3 = a$22[3] | 0, al3 = a3 & 8191, ah3 = a3 >>> 13, a4 = a$22[4] | 0, al4 = a4 & 8191, ah4 = a4 >>> 13, a5 = a$22[5] | 0, al5 = a5 & 8191, ah5 = a5 >>> 13, a6 = a$22[6] | 0, al6 = a6 & 8191, ah6 = a6 >>> 13, a7 = a$22[7] | 0, al7 = a7 & 8191, ah7 = a7 >>> 13, a8 = a$22[8] | 0, al8 = a8 & 8191, ah8 = a8 >>> 13, a9 = a$22[9] | 0, al9 = a9 & 8191, ah9 = a9 >>> 13, b0 = b2[0] | 0, bl0 = b0 & 8191, bh0 = b0 >>> 13, b1 = b2[1] | 0, bl1 = b1 & 8191, bh1 = b1 >>> 13, b22 = b2[2] | 0, bl2 = b22 & 8191, bh2 = b22 >>> 13, b3 = b2[3] | 0, bl3 = b3 & 8191, bh3 = b3 >>> 13, b4 = b2[4] | 0, bl4 = b4 & 8191, bh4 = b4 >>> 13, b5 = b2[5] | 0, bl5 = b5 & 8191, bh5 = b5 >>> 13, b6 = b2[6] | 0, bl6 = b6 & 8191, bh6 = b6 >>> 13, b7 = b2[7] | 0, bl7 = b7 & 8191, bh7 = b7 >>> 13, b8 = b2[8] | 0, bl8 = b8 & 8191, bh8 = b8 >>> 13, b9 = b2[9] | 0, bl9 = b9 & 8191, bh9 = b9 >>> 13;
      out.negative = self$1.negative ^ num.negative, out.length = 19, lo = Math.imul(al0, bl0), mid = Math.imul(al0, bh0), mid = mid + Math.imul(ah0, bl0) | 0, hi = Math.imul(ah0, bh0);
      var w0 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0, w0 &= 67108863, lo = Math.imul(al1, bl0), mid = Math.imul(al1, bh0), mid = mid + Math.imul(ah1, bl0) | 0, hi = Math.imul(ah1, bh0), lo = lo + Math.imul(al0, bl1) | 0, mid = mid + Math.imul(al0, bh1) | 0, mid = mid + Math.imul(ah0, bl1) | 0, hi = hi + Math.imul(ah0, bh1) | 0;
      var w1 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0, w1 &= 67108863, lo = Math.imul(al2, bl0), mid = Math.imul(al2, bh0), mid = mid + Math.imul(ah2, bl0) | 0, hi = Math.imul(ah2, bh0), lo = lo + Math.imul(al1, bl1) | 0, mid = mid + Math.imul(al1, bh1) | 0, mid = mid + Math.imul(ah1, bl1) | 0, hi = hi + Math.imul(ah1, bh1) | 0, lo = lo + Math.imul(al0, bl2) | 0, mid = mid + Math.imul(al0, bh2) | 0, mid = mid + Math.imul(ah0, bl2) | 0, hi = hi + Math.imul(ah0, bh2) | 0;
      var w2 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0, w2 &= 67108863, lo = Math.imul(al3, bl0), mid = Math.imul(al3, bh0), mid = mid + Math.imul(ah3, bl0) | 0, hi = Math.imul(ah3, bh0), lo = lo + Math.imul(al2, bl1) | 0, mid = mid + Math.imul(al2, bh1) | 0, mid = mid + Math.imul(ah2, bl1) | 0, hi = hi + Math.imul(ah2, bh1) | 0, lo = lo + Math.imul(al1, bl2) | 0, mid = mid + Math.imul(al1, bh2) | 0, mid = mid + Math.imul(ah1, bl2) | 0, hi = hi + Math.imul(ah1, bh2) | 0, lo = lo + Math.imul(al0, bl3) | 0, mid = mid + Math.imul(al0, bh3) | 0, mid = mid + Math.imul(ah0, bl3) | 0, hi = hi + Math.imul(ah0, bh3) | 0;
      var w3 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0, w3 &= 67108863, lo = Math.imul(al4, bl0), mid = Math.imul(al4, bh0), mid = mid + Math.imul(ah4, bl0) | 0, hi = Math.imul(ah4, bh0), lo = lo + Math.imul(al3, bl1) | 0, mid = mid + Math.imul(al3, bh1) | 0, mid = mid + Math.imul(ah3, bl1) | 0, hi = hi + Math.imul(ah3, bh1) | 0, lo = lo + Math.imul(al2, bl2) | 0, mid = mid + Math.imul(al2, bh2) | 0, mid = mid + Math.imul(ah2, bl2) | 0, hi = hi + Math.imul(ah2, bh2) | 0, lo = lo + Math.imul(al1, bl3) | 0, mid = mid + Math.imul(al1, bh3) | 0, mid = mid + Math.imul(ah1, bl3) | 0, hi = hi + Math.imul(ah1, bh3) | 0, lo = lo + Math.imul(al0, bl4) | 0, mid = mid + Math.imul(al0, bh4) | 0, mid = mid + Math.imul(ah0, bl4) | 0, hi = hi + Math.imul(ah0, bh4) | 0;
      var w4 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0, w4 &= 67108863, lo = Math.imul(al5, bl0), mid = Math.imul(al5, bh0), mid = mid + Math.imul(ah5, bl0) | 0, hi = Math.imul(ah5, bh0), lo = lo + Math.imul(al4, bl1) | 0, mid = mid + Math.imul(al4, bh1) | 0, mid = mid + Math.imul(ah4, bl1) | 0, hi = hi + Math.imul(ah4, bh1) | 0, lo = lo + Math.imul(al3, bl2) | 0, mid = mid + Math.imul(al3, bh2) | 0, mid = mid + Math.imul(ah3, bl2) | 0, hi = hi + Math.imul(ah3, bh2) | 0, lo = lo + Math.imul(al2, bl3) | 0, mid = mid + Math.imul(al2, bh3) | 0, mid = mid + Math.imul(ah2, bl3) | 0, hi = hi + Math.imul(ah2, bh3) | 0, lo = lo + Math.imul(al1, bl4) | 0, mid = mid + Math.imul(al1, bh4) | 0, mid = mid + Math.imul(ah1, bl4) | 0, hi = hi + Math.imul(ah1, bh4) | 0, lo = lo + Math.imul(al0, bl5) | 0, mid = mid + Math.imul(al0, bh5) | 0, mid = mid + Math.imul(ah0, bl5) | 0, hi = hi + Math.imul(ah0, bh5) | 0;
      var w5 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0, w5 &= 67108863, lo = Math.imul(al6, bl0), mid = Math.imul(al6, bh0), mid = mid + Math.imul(ah6, bl0) | 0, hi = Math.imul(ah6, bh0), lo = lo + Math.imul(al5, bl1) | 0, mid = mid + Math.imul(al5, bh1) | 0, mid = mid + Math.imul(ah5, bl1) | 0, hi = hi + Math.imul(ah5, bh1) | 0, lo = lo + Math.imul(al4, bl2) | 0, mid = mid + Math.imul(al4, bh2) | 0, mid = mid + Math.imul(ah4, bl2) | 0, hi = hi + Math.imul(ah4, bh2) | 0, lo = lo + Math.imul(al3, bl3) | 0, mid = mid + Math.imul(al3, bh3) | 0, mid = mid + Math.imul(ah3, bl3) | 0, hi = hi + Math.imul(ah3, bh3) | 0, lo = lo + Math.imul(al2, bl4) | 0, mid = mid + Math.imul(al2, bh4) | 0, mid = mid + Math.imul(ah2, bl4) | 0, hi = hi + Math.imul(ah2, bh4) | 0, lo = lo + Math.imul(al1, bl5) | 0, mid = mid + Math.imul(al1, bh5) | 0, mid = mid + Math.imul(ah1, bl5) | 0, hi = hi + Math.imul(ah1, bh5) | 0, lo = lo + Math.imul(al0, bl6) | 0, mid = mid + Math.imul(al0, bh6) | 0, mid = mid + Math.imul(ah0, bl6) | 0, hi = hi + Math.imul(ah0, bh6) | 0;
      var w6 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0, w6 &= 67108863, lo = Math.imul(al7, bl0), mid = Math.imul(al7, bh0), mid = mid + Math.imul(ah7, bl0) | 0, hi = Math.imul(ah7, bh0), lo = lo + Math.imul(al6, bl1) | 0, mid = mid + Math.imul(al6, bh1) | 0, mid = mid + Math.imul(ah6, bl1) | 0, hi = hi + Math.imul(ah6, bh1) | 0, lo = lo + Math.imul(al5, bl2) | 0, mid = mid + Math.imul(al5, bh2) | 0, mid = mid + Math.imul(ah5, bl2) | 0, hi = hi + Math.imul(ah5, bh2) | 0, lo = lo + Math.imul(al4, bl3) | 0, mid = mid + Math.imul(al4, bh3) | 0, mid = mid + Math.imul(ah4, bl3) | 0, hi = hi + Math.imul(ah4, bh3) | 0, lo = lo + Math.imul(al3, bl4) | 0, mid = mid + Math.imul(al3, bh4) | 0, mid = mid + Math.imul(ah3, bl4) | 0, hi = hi + Math.imul(ah3, bh4) | 0, lo = lo + Math.imul(al2, bl5) | 0, mid = mid + Math.imul(al2, bh5) | 0, mid = mid + Math.imul(ah2, bl5) | 0, hi = hi + Math.imul(ah2, bh5) | 0, lo = lo + Math.imul(al1, bl6) | 0, mid = mid + Math.imul(al1, bh6) | 0, mid = mid + Math.imul(ah1, bl6) | 0, hi = hi + Math.imul(ah1, bh6) | 0, lo = lo + Math.imul(al0, bl7) | 0, mid = mid + Math.imul(al0, bh7) | 0, mid = mid + Math.imul(ah0, bl7) | 0, hi = hi + Math.imul(ah0, bh7) | 0;
      var w7 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0, w7 &= 67108863, lo = Math.imul(al8, bl0), mid = Math.imul(al8, bh0), mid = mid + Math.imul(ah8, bl0) | 0, hi = Math.imul(ah8, bh0), lo = lo + Math.imul(al7, bl1) | 0, mid = mid + Math.imul(al7, bh1) | 0, mid = mid + Math.imul(ah7, bl1) | 0, hi = hi + Math.imul(ah7, bh1) | 0, lo = lo + Math.imul(al6, bl2) | 0, mid = mid + Math.imul(al6, bh2) | 0, mid = mid + Math.imul(ah6, bl2) | 0, hi = hi + Math.imul(ah6, bh2) | 0, lo = lo + Math.imul(al5, bl3) | 0, mid = mid + Math.imul(al5, bh3) | 0, mid = mid + Math.imul(ah5, bl3) | 0, hi = hi + Math.imul(ah5, bh3) | 0, lo = lo + Math.imul(al4, bl4) | 0, mid = mid + Math.imul(al4, bh4) | 0, mid = mid + Math.imul(ah4, bl4) | 0, hi = hi + Math.imul(ah4, bh4) | 0, lo = lo + Math.imul(al3, bl5) | 0, mid = mid + Math.imul(al3, bh5) | 0, mid = mid + Math.imul(ah3, bl5) | 0, hi = hi + Math.imul(ah3, bh5) | 0, lo = lo + Math.imul(al2, bl6) | 0, mid = mid + Math.imul(al2, bh6) | 0, mid = mid + Math.imul(ah2, bl6) | 0, hi = hi + Math.imul(ah2, bh6) | 0, lo = lo + Math.imul(al1, bl7) | 0, mid = mid + Math.imul(al1, bh7) | 0, mid = mid + Math.imul(ah1, bl7) | 0, hi = hi + Math.imul(ah1, bh7) | 0, lo = lo + Math.imul(al0, bl8) | 0, mid = mid + Math.imul(al0, bh8) | 0, mid = mid + Math.imul(ah0, bl8) | 0, hi = hi + Math.imul(ah0, bh8) | 0;
      var w8 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0, w8 &= 67108863, lo = Math.imul(al9, bl0), mid = Math.imul(al9, bh0), mid = mid + Math.imul(ah9, bl0) | 0, hi = Math.imul(ah9, bh0), lo = lo + Math.imul(al8, bl1) | 0, mid = mid + Math.imul(al8, bh1) | 0, mid = mid + Math.imul(ah8, bl1) | 0, hi = hi + Math.imul(ah8, bh1) | 0, lo = lo + Math.imul(al7, bl2) | 0, mid = mid + Math.imul(al7, bh2) | 0, mid = mid + Math.imul(ah7, bl2) | 0, hi = hi + Math.imul(ah7, bh2) | 0, lo = lo + Math.imul(al6, bl3) | 0, mid = mid + Math.imul(al6, bh3) | 0, mid = mid + Math.imul(ah6, bl3) | 0, hi = hi + Math.imul(ah6, bh3) | 0, lo = lo + Math.imul(al5, bl4) | 0, mid = mid + Math.imul(al5, bh4) | 0, mid = mid + Math.imul(ah5, bl4) | 0, hi = hi + Math.imul(ah5, bh4) | 0, lo = lo + Math.imul(al4, bl5) | 0, mid = mid + Math.imul(al4, bh5) | 0, mid = mid + Math.imul(ah4, bl5) | 0, hi = hi + Math.imul(ah4, bh5) | 0, lo = lo + Math.imul(al3, bl6) | 0, mid = mid + Math.imul(al3, bh6) | 0, mid = mid + Math.imul(ah3, bl6) | 0, hi = hi + Math.imul(ah3, bh6) | 0, lo = lo + Math.imul(al2, bl7) | 0, mid = mid + Math.imul(al2, bh7) | 0, mid = mid + Math.imul(ah2, bl7) | 0, hi = hi + Math.imul(ah2, bh7) | 0, lo = lo + Math.imul(al1, bl8) | 0, mid = mid + Math.imul(al1, bh8) | 0, mid = mid + Math.imul(ah1, bl8) | 0, hi = hi + Math.imul(ah1, bh8) | 0, lo = lo + Math.imul(al0, bl9) | 0, mid = mid + Math.imul(al0, bh9) | 0, mid = mid + Math.imul(ah0, bl9) | 0, hi = hi + Math.imul(ah0, bh9) | 0;
      var w9 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0, w9 &= 67108863, lo = Math.imul(al9, bl1), mid = Math.imul(al9, bh1), mid = mid + Math.imul(ah9, bl1) | 0, hi = Math.imul(ah9, bh1), lo = lo + Math.imul(al8, bl2) | 0, mid = mid + Math.imul(al8, bh2) | 0, mid = mid + Math.imul(ah8, bl2) | 0, hi = hi + Math.imul(ah8, bh2) | 0, lo = lo + Math.imul(al7, bl3) | 0, mid = mid + Math.imul(al7, bh3) | 0, mid = mid + Math.imul(ah7, bl3) | 0, hi = hi + Math.imul(ah7, bh3) | 0, lo = lo + Math.imul(al6, bl4) | 0, mid = mid + Math.imul(al6, bh4) | 0, mid = mid + Math.imul(ah6, bl4) | 0, hi = hi + Math.imul(ah6, bh4) | 0, lo = lo + Math.imul(al5, bl5) | 0, mid = mid + Math.imul(al5, bh5) | 0, mid = mid + Math.imul(ah5, bl5) | 0, hi = hi + Math.imul(ah5, bh5) | 0, lo = lo + Math.imul(al4, bl6) | 0, mid = mid + Math.imul(al4, bh6) | 0, mid = mid + Math.imul(ah4, bl6) | 0, hi = hi + Math.imul(ah4, bh6) | 0, lo = lo + Math.imul(al3, bl7) | 0, mid = mid + Math.imul(al3, bh7) | 0, mid = mid + Math.imul(ah3, bl7) | 0, hi = hi + Math.imul(ah3, bh7) | 0, lo = lo + Math.imul(al2, bl8) | 0, mid = mid + Math.imul(al2, bh8) | 0, mid = mid + Math.imul(ah2, bl8) | 0, hi = hi + Math.imul(ah2, bh8) | 0, lo = lo + Math.imul(al1, bl9) | 0, mid = mid + Math.imul(al1, bh9) | 0, mid = mid + Math.imul(ah1, bl9) | 0, hi = hi + Math.imul(ah1, bh9) | 0;
      var w10 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0, w10 &= 67108863, lo = Math.imul(al9, bl2), mid = Math.imul(al9, bh2), mid = mid + Math.imul(ah9, bl2) | 0, hi = Math.imul(ah9, bh2), lo = lo + Math.imul(al8, bl3) | 0, mid = mid + Math.imul(al8, bh3) | 0, mid = mid + Math.imul(ah8, bl3) | 0, hi = hi + Math.imul(ah8, bh3) | 0, lo = lo + Math.imul(al7, bl4) | 0, mid = mid + Math.imul(al7, bh4) | 0, mid = mid + Math.imul(ah7, bl4) | 0, hi = hi + Math.imul(ah7, bh4) | 0, lo = lo + Math.imul(al6, bl5) | 0, mid = mid + Math.imul(al6, bh5) | 0, mid = mid + Math.imul(ah6, bl5) | 0, hi = hi + Math.imul(ah6, bh5) | 0, lo = lo + Math.imul(al5, bl6) | 0, mid = mid + Math.imul(al5, bh6) | 0, mid = mid + Math.imul(ah5, bl6) | 0, hi = hi + Math.imul(ah5, bh6) | 0, lo = lo + Math.imul(al4, bl7) | 0, mid = mid + Math.imul(al4, bh7) | 0, mid = mid + Math.imul(ah4, bl7) | 0, hi = hi + Math.imul(ah4, bh7) | 0, lo = lo + Math.imul(al3, bl8) | 0, mid = mid + Math.imul(al3, bh8) | 0, mid = mid + Math.imul(ah3, bl8) | 0, hi = hi + Math.imul(ah3, bh8) | 0, lo = lo + Math.imul(al2, bl9) | 0, mid = mid + Math.imul(al2, bh9) | 0, mid = mid + Math.imul(ah2, bl9) | 0, hi = hi + Math.imul(ah2, bh9) | 0;
      var w11 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0, w11 &= 67108863, lo = Math.imul(al9, bl3), mid = Math.imul(al9, bh3), mid = mid + Math.imul(ah9, bl3) | 0, hi = Math.imul(ah9, bh3), lo = lo + Math.imul(al8, bl4) | 0, mid = mid + Math.imul(al8, bh4) | 0, mid = mid + Math.imul(ah8, bl4) | 0, hi = hi + Math.imul(ah8, bh4) | 0, lo = lo + Math.imul(al7, bl5) | 0, mid = mid + Math.imul(al7, bh5) | 0, mid = mid + Math.imul(ah7, bl5) | 0, hi = hi + Math.imul(ah7, bh5) | 0, lo = lo + Math.imul(al6, bl6) | 0, mid = mid + Math.imul(al6, bh6) | 0, mid = mid + Math.imul(ah6, bl6) | 0, hi = hi + Math.imul(ah6, bh6) | 0, lo = lo + Math.imul(al5, bl7) | 0, mid = mid + Math.imul(al5, bh7) | 0, mid = mid + Math.imul(ah5, bl7) | 0, hi = hi + Math.imul(ah5, bh7) | 0, lo = lo + Math.imul(al4, bl8) | 0, mid = mid + Math.imul(al4, bh8) | 0, mid = mid + Math.imul(ah4, bl8) | 0, hi = hi + Math.imul(ah4, bh8) | 0, lo = lo + Math.imul(al3, bl9) | 0, mid = mid + Math.imul(al3, bh9) | 0, mid = mid + Math.imul(ah3, bl9) | 0, hi = hi + Math.imul(ah3, bh9) | 0;
      var w12 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0, w12 &= 67108863, lo = Math.imul(al9, bl4), mid = Math.imul(al9, bh4), mid = mid + Math.imul(ah9, bl4) | 0, hi = Math.imul(ah9, bh4), lo = lo + Math.imul(al8, bl5) | 0, mid = mid + Math.imul(al8, bh5) | 0, mid = mid + Math.imul(ah8, bl5) | 0, hi = hi + Math.imul(ah8, bh5) | 0, lo = lo + Math.imul(al7, bl6) | 0, mid = mid + Math.imul(al7, bh6) | 0, mid = mid + Math.imul(ah7, bl6) | 0, hi = hi + Math.imul(ah7, bh6) | 0, lo = lo + Math.imul(al6, bl7) | 0, mid = mid + Math.imul(al6, bh7) | 0, mid = mid + Math.imul(ah6, bl7) | 0, hi = hi + Math.imul(ah6, bh7) | 0, lo = lo + Math.imul(al5, bl8) | 0, mid = mid + Math.imul(al5, bh8) | 0, mid = mid + Math.imul(ah5, bl8) | 0, hi = hi + Math.imul(ah5, bh8) | 0, lo = lo + Math.imul(al4, bl9) | 0, mid = mid + Math.imul(al4, bh9) | 0, mid = mid + Math.imul(ah4, bl9) | 0, hi = hi + Math.imul(ah4, bh9) | 0;
      var w13 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0, w13 &= 67108863, lo = Math.imul(al9, bl5), mid = Math.imul(al9, bh5), mid = mid + Math.imul(ah9, bl5) | 0, hi = Math.imul(ah9, bh5), lo = lo + Math.imul(al8, bl6) | 0, mid = mid + Math.imul(al8, bh6) | 0, mid = mid + Math.imul(ah8, bl6) | 0, hi = hi + Math.imul(ah8, bh6) | 0, lo = lo + Math.imul(al7, bl7) | 0, mid = mid + Math.imul(al7, bh7) | 0, mid = mid + Math.imul(ah7, bl7) | 0, hi = hi + Math.imul(ah7, bh7) | 0, lo = lo + Math.imul(al6, bl8) | 0, mid = mid + Math.imul(al6, bh8) | 0, mid = mid + Math.imul(ah6, bl8) | 0, hi = hi + Math.imul(ah6, bh8) | 0, lo = lo + Math.imul(al5, bl9) | 0, mid = mid + Math.imul(al5, bh9) | 0, mid = mid + Math.imul(ah5, bl9) | 0, hi = hi + Math.imul(ah5, bh9) | 0;
      var w14 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0, w14 &= 67108863, lo = Math.imul(al9, bl6), mid = Math.imul(al9, bh6), mid = mid + Math.imul(ah9, bl6) | 0, hi = Math.imul(ah9, bh6), lo = lo + Math.imul(al8, bl7) | 0, mid = mid + Math.imul(al8, bh7) | 0, mid = mid + Math.imul(ah8, bl7) | 0, hi = hi + Math.imul(ah8, bh7) | 0, lo = lo + Math.imul(al7, bl8) | 0, mid = mid + Math.imul(al7, bh8) | 0, mid = mid + Math.imul(ah7, bl8) | 0, hi = hi + Math.imul(ah7, bh8) | 0, lo = lo + Math.imul(al6, bl9) | 0, mid = mid + Math.imul(al6, bh9) | 0, mid = mid + Math.imul(ah6, bl9) | 0, hi = hi + Math.imul(ah6, bh9) | 0;
      var w15 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0, w15 &= 67108863, lo = Math.imul(al9, bl7), mid = Math.imul(al9, bh7), mid = mid + Math.imul(ah9, bl7) | 0, hi = Math.imul(ah9, bh7), lo = lo + Math.imul(al8, bl8) | 0, mid = mid + Math.imul(al8, bh8) | 0, mid = mid + Math.imul(ah8, bl8) | 0, hi = hi + Math.imul(ah8, bh8) | 0, lo = lo + Math.imul(al7, bl9) | 0, mid = mid + Math.imul(al7, bh9) | 0, mid = mid + Math.imul(ah7, bl9) | 0, hi = hi + Math.imul(ah7, bh9) | 0;
      var w16 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0, w16 &= 67108863, lo = Math.imul(al9, bl8), mid = Math.imul(al9, bh8), mid = mid + Math.imul(ah9, bl8) | 0, hi = Math.imul(ah9, bh8), lo = lo + Math.imul(al8, bl9) | 0, mid = mid + Math.imul(al8, bh9) | 0, mid = mid + Math.imul(ah8, bl9) | 0, hi = hi + Math.imul(ah8, bh9) | 0;
      var w17 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      c$12 = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0, w17 &= 67108863, lo = Math.imul(al9, bl9), mid = Math.imul(al9, bh9), mid = mid + Math.imul(ah9, bl9) | 0, hi = Math.imul(ah9, bh9);
      var w18 = (c$12 + lo | 0) + ((mid & 8191) << 13) | 0;
      return c$12 = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0, w18 &= 67108863, o$2[0] = w0, o$2[1] = w1, o$2[2] = w2, o$2[3] = w3, o$2[4] = w4, o$2[5] = w5, o$2[6] = w6, o$2[7] = w7, o$2[8] = w8, o$2[9] = w9, o$2[10] = w10, o$2[11] = w11, o$2[12] = w12, o$2[13] = w13, o$2[14] = w14, o$2[15] = w15, o$2[16] = w16, o$2[17] = w17, o$2[18] = w18, c$12 !== 0 && (o$2[19] = c$12, out.length++), out;
    };
    Math.imul || (comb10MulTo = smallMulTo);
    function bigMulTo(self$1, num, out) {
      out.negative = num.negative ^ self$1.negative, out.length = self$1.length + num.length;
      for (var carry = 0, hncarry = 0, k = 0; k < out.length - 1; k++) {
        var ncarry = hncarry;
        hncarry = 0;
        for (var rword = carry & 67108863, maxJ = Math.min(k, num.length - 1), j$1 = Math.max(0, k - self$1.length + 1); j$1 <= maxJ; j$1++) {
          var i$4 = k - j$1, a$22 = self$1.words[i$4] | 0, b2 = num.words[j$1] | 0, r$2 = a$22 * b2, lo = r$2 & 67108863;
          ncarry = ncarry + (r$2 / 67108864 | 0) | 0, lo = lo + rword | 0, rword = lo & 67108863, ncarry = ncarry + (lo >>> 26) | 0, hncarry += ncarry >>> 26, ncarry &= 67108863;
        }
        out.words[k] = rword, carry = ncarry, ncarry = hncarry;
      }
      return carry === 0 ? out.length-- : out.words[k] = carry, out._strip();
    }
    function jumboMulTo(self$1, num, out) {
      return bigMulTo(self$1, num, out);
    }
    BN$14.prototype.mulTo = function(num, out) {
      var res, len$2 = this.length + num.length;
      return res = this.length === 10 && num.length === 10 ? comb10MulTo(this, num, out) : len$2 < 63 ? smallMulTo(this, num, out) : len$2 < 1024 ? bigMulTo(this, num, out) : jumboMulTo(this, num, out), res;
    };
    BN$14.prototype.mul = function(num) {
      var out = new BN$14(null);
      return out.words = Array(this.length + num.length), this.mulTo(num, out);
    }, BN$14.prototype.mulf = function(num) {
      var out = new BN$14(null);
      return out.words = Array(this.length + num.length), jumboMulTo(this, num, out);
    }, BN$14.prototype.imul = function(num) {
      return this.clone().mulTo(num, this);
    }, BN$14.prototype.imuln = function(num) {
      var isNegNum = num < 0;
      isNegNum && (num = -num), assert$54(typeof num == `number`), assert$54(num < 67108864);
      for (var carry = 0, i$4 = 0; i$4 < this.length; i$4++) {
        var w$1 = (this.words[i$4] | 0) * num, lo = (w$1 & 67108863) + (carry & 67108863);
        carry >>= 26, carry += w$1 / 67108864 | 0, carry += lo >>> 26, this.words[i$4] = lo & 67108863;
      }
      return carry !== 0 && (this.words[i$4] = carry, this.length++), this.length = num === 0 ? 1 : this.length, isNegNum ? this.ineg() : this;
    }, BN$14.prototype.muln = function(num) {
      return this.clone().imuln(num);
    }, BN$14.prototype.sqr = function() {
      return this.mul(this);
    }, BN$14.prototype.isqr = function() {
      return this.imul(this.clone());
    }, BN$14.prototype.pow = function(num) {
      var w$1 = toBitArray(num);
      if (w$1.length === 0) return new BN$14(1);
      for (var res = this, i$4 = 0; i$4 < w$1.length && w$1[i$4] === 0; i$4++, res = res.sqr()) ;
      if (++i$4 < w$1.length) for (var q = res.sqr(); i$4 < w$1.length; i$4++, q = q.sqr()) w$1[i$4] !== 0 && (res = res.mul(q));
      return res;
    }, BN$14.prototype.iushln = function(bits$1) {
      assert$54(typeof bits$1 == `number` && bits$1 >= 0);
      var r$2 = bits$1 % 26, s$6 = (bits$1 - r$2) / 26, carryMask = 67108863 >>> 26 - r$2 << 26 - r$2, i$4;
      if (r$2 !== 0) {
        var carry = 0;
        for (i$4 = 0; i$4 < this.length; i$4++) {
          var newCarry = this.words[i$4] & carryMask, c$12 = (this.words[i$4] | 0) - newCarry << r$2;
          this.words[i$4] = c$12 | carry, carry = newCarry >>> 26 - r$2;
        }
        carry && (this.words[i$4] = carry, this.length++);
      }
      if (s$6 !== 0) {
        for (i$4 = this.length - 1; i$4 >= 0; i$4--) this.words[i$4 + s$6] = this.words[i$4];
        for (i$4 = 0; i$4 < s$6; i$4++) this.words[i$4] = 0;
        this.length += s$6;
      }
      return this._strip();
    }, BN$14.prototype.ishln = function(bits$1) {
      return assert$54(this.negative === 0), this.iushln(bits$1);
    }, BN$14.prototype.iushrn = function(bits$1, hint, extended) {
      assert$54(typeof bits$1 == `number` && bits$1 >= 0);
      var h$1;
      h$1 = hint ? (hint - hint % 26) / 26 : 0;
      var r$2 = bits$1 % 26, s$6 = Math.min((bits$1 - r$2) / 26, this.length), mask = 67108863 ^ 67108863 >>> r$2 << r$2, maskedWords = extended;
      if (h$1 -= s$6, h$1 = Math.max(0, h$1), maskedWords) {
        for (var i$4 = 0; i$4 < s$6; i$4++) maskedWords.words[i$4] = this.words[i$4];
        maskedWords.length = s$6;
      }
      if (s$6 !== 0) if (this.length > s$6) for (this.length -= s$6, i$4 = 0; i$4 < this.length; i$4++) this.words[i$4] = this.words[i$4 + s$6];
      else this.words[0] = 0, this.length = 1;
      var carry = 0;
      for (i$4 = this.length - 1; i$4 >= 0 && (carry !== 0 || i$4 >= h$1); i$4--) {
        var word = this.words[i$4] | 0;
        this.words[i$4] = carry << 26 - r$2 | word >>> r$2, carry = word & mask;
      }
      return maskedWords && carry !== 0 && (maskedWords.words[maskedWords.length++] = carry), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, BN$14.prototype.ishrn = function(bits$1, hint, extended) {
      return assert$54(this.negative === 0), this.iushrn(bits$1, hint, extended);
    }, BN$14.prototype.shln = function(bits$1) {
      return this.clone().ishln(bits$1);
    }, BN$14.prototype.ushln = function(bits$1) {
      return this.clone().iushln(bits$1);
    }, BN$14.prototype.shrn = function(bits$1) {
      return this.clone().ishrn(bits$1);
    }, BN$14.prototype.ushrn = function(bits$1) {
      return this.clone().iushrn(bits$1);
    }, BN$14.prototype.testn = function(bit) {
      assert$54(typeof bit == `number` && bit >= 0);
      var r$2 = bit % 26, s$6 = (bit - r$2) / 26, q = 1 << r$2;
      if (this.length <= s$6) return false;
      var w$1 = this.words[s$6];
      return !!(w$1 & q);
    }, BN$14.prototype.imaskn = function(bits$1) {
      assert$54(typeof bits$1 == `number` && bits$1 >= 0);
      var r$2 = bits$1 % 26, s$6 = (bits$1 - r$2) / 26;
      if (assert$54(this.negative === 0, `imaskn works only with positive numbers`), this.length <= s$6) return this;
      if (r$2 !== 0 && s$6++, this.length = Math.min(s$6, this.length), r$2 !== 0) {
        var mask = 67108863 ^ 67108863 >>> r$2 << r$2;
        this.words[this.length - 1] &= mask;
      }
      return this._strip();
    }, BN$14.prototype.maskn = function(bits$1) {
      return this.clone().imaskn(bits$1);
    }, BN$14.prototype.iaddn = function(num) {
      return assert$54(typeof num == `number`), assert$54(num < 67108864), num < 0 ? this.isubn(-num) : this.negative === 0 ? this._iaddn(num) : this.length === 1 && (this.words[0] | 0) <= num ? (this.words[0] = num - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(num), this.negative = 1, this);
    }, BN$14.prototype._iaddn = function(num) {
      this.words[0] += num;
      for (var i$4 = 0; i$4 < this.length && this.words[i$4] >= 67108864; i$4++) this.words[i$4] -= 67108864, i$4 === this.length - 1 ? this.words[i$4 + 1] = 1 : this.words[i$4 + 1]++;
      return this.length = Math.max(this.length, i$4 + 1), this;
    }, BN$14.prototype.isubn = function(num) {
      if (assert$54(typeof num == `number`), assert$54(num < 67108864), num < 0) return this.iaddn(-num);
      if (this.negative !== 0) return this.negative = 0, this.iaddn(num), this.negative = 1, this;
      if (this.words[0] -= num, this.length === 1 && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
      else for (var i$4 = 0; i$4 < this.length && this.words[i$4] < 0; i$4++) this.words[i$4] += 67108864, --this.words[i$4 + 1];
      return this._strip();
    }, BN$14.prototype.addn = function(num) {
      return this.clone().iaddn(num);
    }, BN$14.prototype.subn = function(num) {
      return this.clone().isubn(num);
    }, BN$14.prototype.iabs = function() {
      return this.negative = 0, this;
    }, BN$14.prototype.abs = function() {
      return this.clone().iabs();
    }, BN$14.prototype._ishlnsubmul = function(num, mul, shift) {
      var len$2 = num.length + shift, i$4;
      this._expand(len$2);
      var w$1, carry = 0;
      for (i$4 = 0; i$4 < num.length; i$4++) {
        w$1 = (this.words[i$4 + shift] | 0) + carry;
        var right = (num.words[i$4] | 0) * mul;
        w$1 -= right & 67108863, carry = (w$1 >> 26) - (right / 67108864 | 0), this.words[i$4 + shift] = w$1 & 67108863;
      }
      for (; i$4 < this.length - shift; i$4++) w$1 = (this.words[i$4 + shift] | 0) + carry, carry = w$1 >> 26, this.words[i$4 + shift] = w$1 & 67108863;
      if (carry === 0) return this._strip();
      for (assert$54(carry === -1), carry = 0, i$4 = 0; i$4 < this.length; i$4++) w$1 = -(this.words[i$4] | 0) + carry, carry = w$1 >> 26, this.words[i$4] = w$1 & 67108863;
      return this.negative = 1, this._strip();
    }, BN$14.prototype._wordDiv = function(num, mode) {
      var shift = this.length - num.length, a$22 = this.clone(), b2 = num, bhi = b2.words[b2.length - 1] | 0, bhiBits = this._countBits(bhi);
      shift = 26 - bhiBits, shift !== 0 && (b2 = b2.ushln(shift), a$22.iushln(shift), bhi = b2.words[b2.length - 1] | 0);
      var m$3 = a$22.length - b2.length, q;
      if (mode !== `mod`) {
        q = new BN$14(null), q.length = m$3 + 1, q.words = Array(q.length);
        for (var i$4 = 0; i$4 < q.length; i$4++) q.words[i$4] = 0;
      }
      var diff$4 = a$22.clone()._ishlnsubmul(b2, 1, m$3);
      diff$4.negative === 0 && (a$22 = diff$4, q && (q.words[m$3] = 1));
      for (var j$1 = m$3 - 1; j$1 >= 0; j$1--) {
        var qj = (a$22.words[b2.length + j$1] | 0) * 67108864 + (a$22.words[b2.length + j$1 - 1] | 0);
        for (qj = Math.min(qj / bhi | 0, 67108863), a$22._ishlnsubmul(b2, qj, j$1); a$22.negative !== 0; ) qj--, a$22.negative = 0, a$22._ishlnsubmul(b2, 1, j$1), a$22.isZero() || (a$22.negative ^= 1);
        q && (q.words[j$1] = qj);
      }
      return q && q._strip(), a$22._strip(), mode !== `div` && shift !== 0 && a$22.iushrn(shift), { div: q || null, mod: a$22 };
    }, BN$14.prototype.divmod = function(num, mode, positive) {
      if (assert$54(!num.isZero()), this.isZero()) return { div: new BN$14(0), mod: new BN$14(0) };
      var div, mod, res;
      return this.negative !== 0 && num.negative === 0 ? (res = this.neg().divmod(num, mode), mode !== `mod` && (div = res.div.neg()), mode !== `div` && (mod = res.mod.neg(), positive && mod.negative !== 0 && mod.iadd(num)), { div, mod }) : this.negative === 0 && num.negative !== 0 ? (res = this.divmod(num.neg(), mode), mode !== `mod` && (div = res.div.neg()), { div, mod: res.mod }) : (this.negative & num.negative) === 0 ? num.length > this.length || this.cmp(num) < 0 ? { div: new BN$14(0), mod: this } : num.length === 1 ? mode === `div` ? { div: this.divn(num.words[0]), mod: null } : mode === `mod` ? { div: null, mod: new BN$14(this.modrn(num.words[0])) } : { div: this.divn(num.words[0]), mod: new BN$14(this.modrn(num.words[0])) } : this._wordDiv(num, mode) : (res = this.neg().divmod(num.neg(), mode), mode !== `div` && (mod = res.mod.neg(), positive && mod.negative !== 0 && mod.isub(num)), { div: res.div, mod });
    }, BN$14.prototype.div = function(num) {
      return this.divmod(num, `div`, false).div;
    }, BN$14.prototype.mod = function(num) {
      return this.divmod(num, `mod`, false).mod;
    }, BN$14.prototype.umod = function(num) {
      return this.divmod(num, `mod`, true).mod;
    }, BN$14.prototype.divRound = function(num) {
      var dm = this.divmod(num);
      if (dm.mod.isZero()) return dm.div;
      var mod = dm.div.negative === 0 ? dm.mod : dm.mod.isub(num), half = num.ushrn(1), r2 = num.andln(1), cmp$3 = mod.cmp(half);
      return cmp$3 < 0 || r2 === 1 && cmp$3 === 0 ? dm.div : dm.div.negative === 0 ? dm.div.iaddn(1) : dm.div.isubn(1);
    }, BN$14.prototype.modrn = function(num) {
      var isNegNum = num < 0;
      isNegNum && (num = -num), assert$54(num <= 67108863);
      for (var p$1 = (1 << 26) % num, acc = 0, i$4 = this.length - 1; i$4 >= 0; i$4--) acc = (p$1 * acc + (this.words[i$4] | 0)) % num;
      return isNegNum ? -acc : acc;
    }, BN$14.prototype.modn = function(num) {
      return this.modrn(num);
    }, BN$14.prototype.idivn = function(num) {
      var isNegNum = num < 0;
      isNegNum && (num = -num), assert$54(num <= 67108863);
      for (var carry = 0, i$4 = this.length - 1; i$4 >= 0; i$4--) {
        var w$1 = (this.words[i$4] | 0) + carry * 67108864;
        this.words[i$4] = w$1 / num | 0, carry = w$1 % num;
      }
      return this._strip(), isNegNum ? this.ineg() : this;
    }, BN$14.prototype.divn = function(num) {
      return this.clone().idivn(num);
    }, BN$14.prototype.egcd = function(p$1) {
      assert$54(p$1.negative === 0), assert$54(!p$1.isZero());
      var x$1 = this, y$1 = p$1.clone();
      x$1 = x$1.negative === 0 ? x$1.clone() : x$1.umod(p$1);
      for (var A = new BN$14(1), B = new BN$14(0), C = new BN$14(0), D = new BN$14(1), g$22 = 0; x$1.isEven() && y$1.isEven(); ) x$1.iushrn(1), y$1.iushrn(1), ++g$22;
      for (var yp = y$1.clone(), xp = x$1.clone(); !x$1.isZero(); ) {
        for (var i$4 = 0, im = 1; (x$1.words[0] & im) === 0 && i$4 < 26; ++i$4, im <<= 1) ;
        if (i$4 > 0) for (x$1.iushrn(i$4); i$4-- > 0; ) (A.isOdd() || B.isOdd()) && (A.iadd(yp), B.isub(xp)), A.iushrn(1), B.iushrn(1);
        for (var j$1 = 0, jm = 1; (y$1.words[0] & jm) === 0 && j$1 < 26; ++j$1, jm <<= 1) ;
        if (j$1 > 0) for (y$1.iushrn(j$1); j$1-- > 0; ) (C.isOdd() || D.isOdd()) && (C.iadd(yp), D.isub(xp)), C.iushrn(1), D.iushrn(1);
        x$1.cmp(y$1) >= 0 ? (x$1.isub(y$1), A.isub(C), B.isub(D)) : (y$1.isub(x$1), C.isub(A), D.isub(B));
      }
      return { a: C, b: D, gcd: y$1.iushln(g$22) };
    }, BN$14.prototype._invmp = function(p$1) {
      assert$54(p$1.negative === 0), assert$54(!p$1.isZero());
      var a$22 = this, b2 = p$1.clone();
      a$22 = a$22.negative === 0 ? a$22.clone() : a$22.umod(p$1);
      for (var x1 = new BN$14(1), x2 = new BN$14(0), delta = b2.clone(); a$22.cmpn(1) > 0 && b2.cmpn(1) > 0; ) {
        for (var i$4 = 0, im = 1; (a$22.words[0] & im) === 0 && i$4 < 26; ++i$4, im <<= 1) ;
        if (i$4 > 0) for (a$22.iushrn(i$4); i$4-- > 0; ) x1.isOdd() && x1.iadd(delta), x1.iushrn(1);
        for (var j$1 = 0, jm = 1; (b2.words[0] & jm) === 0 && j$1 < 26; ++j$1, jm <<= 1) ;
        if (j$1 > 0) for (b2.iushrn(j$1); j$1-- > 0; ) x2.isOdd() && x2.iadd(delta), x2.iushrn(1);
        a$22.cmp(b2) >= 0 ? (a$22.isub(b2), x1.isub(x2)) : (b2.isub(a$22), x2.isub(x1));
      }
      var res;
      return res = a$22.cmpn(1) === 0 ? x1 : x2, res.cmpn(0) < 0 && res.iadd(p$1), res;
    }, BN$14.prototype.gcd = function(num) {
      if (this.isZero()) return num.abs();
      if (num.isZero()) return this.abs();
      var a$22 = this.clone(), b2 = num.clone();
      a$22.negative = 0, b2.negative = 0;
      for (var shift = 0; a$22.isEven() && b2.isEven(); shift++) a$22.iushrn(1), b2.iushrn(1);
      do {
        for (; a$22.isEven(); ) a$22.iushrn(1);
        for (; b2.isEven(); ) b2.iushrn(1);
        var r$2 = a$22.cmp(b2);
        if (r$2 < 0) {
          var t$7 = a$22;
          a$22 = b2, b2 = t$7;
        } else if (r$2 === 0 || b2.cmpn(1) === 0) break;
        a$22.isub(b2);
      } while (true);
      return b2.iushln(shift);
    }, BN$14.prototype.invm = function(num) {
      return this.egcd(num).a.umod(num);
    }, BN$14.prototype.isEven = function() {
      return (this.words[0] & 1) == 0;
    }, BN$14.prototype.isOdd = function() {
      return (this.words[0] & 1) == 1;
    }, BN$14.prototype.andln = function(num) {
      return this.words[0] & num;
    }, BN$14.prototype.bincn = function(bit) {
      assert$54(typeof bit == `number`);
      var r$2 = bit % 26, s$6 = (bit - r$2) / 26, q = 1 << r$2;
      if (this.length <= s$6) return this._expand(s$6 + 1), this.words[s$6] |= q, this;
      for (var carry = q, i$4 = s$6; carry !== 0 && i$4 < this.length; i$4++) {
        var w$1 = this.words[i$4] | 0;
        w$1 += carry, carry = w$1 >>> 26, w$1 &= 67108863, this.words[i$4] = w$1;
      }
      return carry !== 0 && (this.words[i$4] = carry, this.length++), this;
    }, BN$14.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, BN$14.prototype.cmpn = function(num) {
      var negative = num < 0;
      if (this.negative !== 0 && !negative) return -1;
      if (this.negative === 0 && negative) return 1;
      this._strip();
      var res;
      if (this.length > 1) res = 1;
      else {
        negative && (num = -num), assert$54(num <= 67108863, `Number is too big`);
        var w$1 = this.words[0] | 0;
        res = w$1 === num ? 0 : w$1 < num ? -1 : 1;
      }
      return this.negative === 0 ? res : -res | 0;
    }, BN$14.prototype.cmp = function(num) {
      if (this.negative !== 0 && num.negative === 0) return -1;
      if (this.negative === 0 && num.negative !== 0) return 1;
      var res = this.ucmp(num);
      return this.negative === 0 ? res : -res | 0;
    }, BN$14.prototype.ucmp = function(num) {
      if (this.length > num.length) return 1;
      if (this.length < num.length) return -1;
      for (var res = 0, i$4 = this.length - 1; i$4 >= 0; i$4--) {
        var a$22 = this.words[i$4] | 0, b2 = num.words[i$4] | 0;
        if (a$22 !== b2) {
          a$22 < b2 ? res = -1 : a$22 > b2 && (res = 1);
          break;
        }
      }
      return res;
    }, BN$14.prototype.gtn = function(num) {
      return this.cmpn(num) === 1;
    }, BN$14.prototype.gt = function(num) {
      return this.cmp(num) === 1;
    }, BN$14.prototype.gten = function(num) {
      return this.cmpn(num) >= 0;
    }, BN$14.prototype.gte = function(num) {
      return this.cmp(num) >= 0;
    }, BN$14.prototype.ltn = function(num) {
      return this.cmpn(num) === -1;
    }, BN$14.prototype.lt = function(num) {
      return this.cmp(num) === -1;
    }, BN$14.prototype.lten = function(num) {
      return this.cmpn(num) <= 0;
    }, BN$14.prototype.lte = function(num) {
      return this.cmp(num) <= 0;
    }, BN$14.prototype.eqn = function(num) {
      return this.cmpn(num) === 0;
    }, BN$14.prototype.eq = function(num) {
      return this.cmp(num) === 0;
    }, BN$14.red = function(num) {
      return new Red(num);
    }, BN$14.prototype.toRed = function(ctx) {
      return assert$54(!this.red, `Already a number in reduction context`), assert$54(this.negative === 0, `red works only with positives`), ctx.convertTo(this)._forceRed(ctx);
    }, BN$14.prototype.fromRed = function() {
      return assert$54(this.red, `fromRed works only with numbers in reduction context`), this.red.convertFrom(this);
    }, BN$14.prototype._forceRed = function(ctx) {
      return this.red = ctx, this;
    }, BN$14.prototype.forceRed = function(ctx) {
      return assert$54(!this.red, `Already a number in reduction context`), this._forceRed(ctx);
    }, BN$14.prototype.redAdd = function(num) {
      return assert$54(this.red, `redAdd works only with red numbers`), this.red.add(this, num);
    }, BN$14.prototype.redIAdd = function(num) {
      return assert$54(this.red, `redIAdd works only with red numbers`), this.red.iadd(this, num);
    }, BN$14.prototype.redSub = function(num) {
      return assert$54(this.red, `redSub works only with red numbers`), this.red.sub(this, num);
    }, BN$14.prototype.redISub = function(num) {
      return assert$54(this.red, `redISub works only with red numbers`), this.red.isub(this, num);
    }, BN$14.prototype.redShl = function(num) {
      return assert$54(this.red, `redShl works only with red numbers`), this.red.shl(this, num);
    }, BN$14.prototype.redMul = function(num) {
      return assert$54(this.red, `redMul works only with red numbers`), this.red._verify2(this, num), this.red.mul(this, num);
    }, BN$14.prototype.redIMul = function(num) {
      return assert$54(this.red, `redMul works only with red numbers`), this.red._verify2(this, num), this.red.imul(this, num);
    }, BN$14.prototype.redSqr = function() {
      return assert$54(this.red, `redSqr works only with red numbers`), this.red._verify1(this), this.red.sqr(this);
    }, BN$14.prototype.redISqr = function() {
      return assert$54(this.red, `redISqr works only with red numbers`), this.red._verify1(this), this.red.isqr(this);
    }, BN$14.prototype.redSqrt = function() {
      return assert$54(this.red, `redSqrt works only with red numbers`), this.red._verify1(this), this.red.sqrt(this);
    }, BN$14.prototype.redInvm = function() {
      return assert$54(this.red, `redInvm works only with red numbers`), this.red._verify1(this), this.red.invm(this);
    }, BN$14.prototype.redNeg = function() {
      return assert$54(this.red, `redNeg works only with red numbers`), this.red._verify1(this), this.red.neg(this);
    }, BN$14.prototype.redPow = function(num) {
      return assert$54(this.red && !num.red, `redPow(normalNum)`), this.red._verify1(this), this.red.pow(this, num);
    };
    var primes = { k256: null, p224: null, p192: null, p25519: null };
    function MPrime(name$2, p$1) {
      this.name = name$2, this.p = new BN$14(p$1, 16), this.n = this.p.bitLength(), this.k = new BN$14(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function() {
      var tmp = new BN$14(null);
      return tmp.words = Array(Math.ceil(this.n / 13)), tmp;
    }, MPrime.prototype.ireduce = function(num) {
      var r$2 = num, rlen;
      do
        this.split(r$2, this.tmp), r$2 = this.imulK(r$2), r$2 = r$2.iadd(this.tmp), rlen = r$2.bitLength();
      while (rlen > this.n);
      var cmp$3 = rlen < this.n ? -1 : r$2.ucmp(this.p);
      return cmp$3 === 0 ? (r$2.words[0] = 0, r$2.length = 1) : cmp$3 > 0 ? r$2.isub(this.p) : r$2.strip === void 0 ? r$2._strip() : r$2.strip(), r$2;
    }, MPrime.prototype.split = function(input, out) {
      input.iushrn(this.n, 0, out);
    }, MPrime.prototype.imulK = function(num) {
      return num.imul(this.k);
    };
    function K256() {
      MPrime.call(this, `k256`, `ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f`);
    }
    inherits$14(K256, MPrime), K256.prototype.split = function(input, output) {
      for (var mask = 4194303, outLen = Math.min(input.length, 9), i$4 = 0; i$4 < outLen; i$4++) output.words[i$4] = input.words[i$4];
      if (output.length = outLen, input.length <= 9) {
        input.words[0] = 0, input.length = 1;
        return;
      }
      var prev = input.words[9];
      for (output.words[output.length++] = prev & mask, i$4 = 10; i$4 < input.length; i$4++) {
        var next = input.words[i$4] | 0;
        input.words[i$4 - 10] = (next & mask) << 4 | prev >>> 22, prev = next;
      }
      prev >>>= 22, input.words[i$4 - 10] = prev, prev === 0 && input.length > 10 ? input.length -= 10 : input.length -= 9;
    }, K256.prototype.imulK = function(num) {
      num.words[num.length] = 0, num.words[num.length + 1] = 0, num.length += 2;
      for (var lo = 0, i$4 = 0; i$4 < num.length; i$4++) {
        var w$1 = num.words[i$4] | 0;
        lo += w$1 * 977, num.words[i$4] = lo & 67108863, lo = w$1 * 64 + (lo / 67108864 | 0);
      }
      return num.words[num.length - 1] === 0 && (num.length--, num.words[num.length - 1] === 0 && num.length--), num;
    };
    function P224() {
      MPrime.call(this, `p224`, `ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001`);
    }
    inherits$14(P224, MPrime);
    function P192() {
      MPrime.call(this, `p192`, `ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff`);
    }
    inherits$14(P192, MPrime);
    function P25519() {
      MPrime.call(this, `25519`, `7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed`);
    }
    inherits$14(P25519, MPrime), P25519.prototype.imulK = function(num) {
      for (var carry = 0, i$4 = 0; i$4 < num.length; i$4++) {
        var hi = (num.words[i$4] | 0) * 19 + carry, lo = hi & 67108863;
        hi >>>= 26, num.words[i$4] = lo, carry = hi;
      }
      return carry !== 0 && (num.words[num.length++] = carry), num;
    }, BN$14._prime = function(name$2) {
      if (primes[name$2]) return primes[name$2];
      var prime$1;
      if (name$2 === `k256`) prime$1 = new K256();
      else if (name$2 === `p224`) prime$1 = new P224();
      else if (name$2 === `p192`) prime$1 = new P192();
      else if (name$2 === `p25519`) prime$1 = new P25519();
      else throw Error(`Unknown prime ` + name$2);
      return primes[name$2] = prime$1, prime$1;
    };
    function Red(m$3) {
      if (typeof m$3 == `string`) {
        var prime = BN$14._prime(m$3);
        this.m = prime.p, this.prime = prime;
      } else assert$54(m$3.gtn(1), `modulus must be greater than 1`), this.m = m$3, this.prime = null;
    }
    Red.prototype._verify1 = function(a$22) {
      assert$54(a$22.negative === 0, `red works only with positives`), assert$54(a$22.red, `red works only with red numbers`);
    }, Red.prototype._verify2 = function(a$22, b2) {
      assert$54((a$22.negative | b2.negative) === 0, `red works only with positives`), assert$54(a$22.red && a$22.red === b2.red, `red works only with red numbers`);
    }, Red.prototype.imod = function(a$22) {
      return this.prime ? this.prime.ireduce(a$22)._forceRed(this) : (move(a$22, a$22.umod(this.m)._forceRed(this)), a$22);
    }, Red.prototype.neg = function(a$22) {
      return a$22.isZero() ? a$22.clone() : this.m.sub(a$22)._forceRed(this);
    }, Red.prototype.add = function(a$22, b2) {
      this._verify2(a$22, b2);
      var res = a$22.add(b2);
      return res.cmp(this.m) >= 0 && res.isub(this.m), res._forceRed(this);
    }, Red.prototype.iadd = function(a$22, b2) {
      this._verify2(a$22, b2);
      var res = a$22.iadd(b2);
      return res.cmp(this.m) >= 0 && res.isub(this.m), res;
    }, Red.prototype.sub = function(a$22, b2) {
      this._verify2(a$22, b2);
      var res = a$22.sub(b2);
      return res.cmpn(0) < 0 && res.iadd(this.m), res._forceRed(this);
    }, Red.prototype.isub = function(a$22, b2) {
      this._verify2(a$22, b2);
      var res = a$22.isub(b2);
      return res.cmpn(0) < 0 && res.iadd(this.m), res;
    }, Red.prototype.shl = function(a$22, num) {
      return this._verify1(a$22), this.imod(a$22.ushln(num));
    }, Red.prototype.imul = function(a$22, b2) {
      return this._verify2(a$22, b2), this.imod(a$22.imul(b2));
    }, Red.prototype.mul = function(a$22, b2) {
      return this._verify2(a$22, b2), this.imod(a$22.mul(b2));
    }, Red.prototype.isqr = function(a$22) {
      return this.imul(a$22, a$22.clone());
    }, Red.prototype.sqr = function(a$22) {
      return this.mul(a$22, a$22);
    }, Red.prototype.sqrt = function(a$22) {
      if (a$22.isZero()) return a$22.clone();
      var mod3 = this.m.andln(3);
      if (assert$54(mod3 % 2 == 1), mod3 === 3) {
        var pow$1 = this.m.add(new BN$14(1)).iushrn(2);
        return this.pow(a$22, pow$1);
      }
      for (var q = this.m.subn(1), s$6 = 0; !q.isZero() && q.andln(1) === 0; ) s$6++, q.iushrn(1);
      assert$54(!q.isZero());
      var one = new BN$14(1).toRed(this), nOne = one.redNeg(), lpow = this.m.subn(1).iushrn(1), z$1 = this.m.bitLength();
      for (z$1 = new BN$14(2 * z$1 * z$1).toRed(this); this.pow(z$1, lpow).cmp(nOne) !== 0; ) z$1.redIAdd(nOne);
      for (var c$12 = this.pow(z$1, q), r$2 = this.pow(a$22, q.addn(1).iushrn(1)), t$7 = this.pow(a$22, q), m$3 = s$6; t$7.cmp(one) !== 0; ) {
        for (var tmp = t$7, i$4 = 0; tmp.cmp(one) !== 0; i$4++) tmp = tmp.redSqr();
        assert$54(i$4 < m$3);
        var b2 = this.pow(c$12, new BN$14(1).iushln(m$3 - i$4 - 1));
        r$2 = r$2.redMul(b2), c$12 = b2.redSqr(), t$7 = t$7.redMul(c$12), m$3 = i$4;
      }
      return r$2;
    }, Red.prototype.invm = function(a$22) {
      var inv = a$22._invmp(this.m);
      return inv.negative === 0 ? this.imod(inv) : (inv.negative = 0, this.imod(inv).redNeg());
    }, Red.prototype.pow = function(a$22, num) {
      if (num.isZero()) return new BN$14(1).toRed(this);
      if (num.cmpn(1) === 0) return a$22.clone();
      var windowSize = 4, wnd = Array(1 << windowSize);
      wnd[0] = new BN$14(1).toRed(this), wnd[1] = a$22;
      for (var i$4 = 2; i$4 < wnd.length; i$4++) wnd[i$4] = this.mul(wnd[i$4 - 1], a$22);
      var res = wnd[0], current = 0, currentLen = 0, start = num.bitLength() % 26;
      for (start === 0 && (start = 26), i$4 = num.length - 1; i$4 >= 0; i$4--) {
        for (var word = num.words[i$4], j$1 = start - 1; j$1 >= 0; j$1--) {
          var bit = word >> j$1 & 1;
          if (res !== wnd[0] && (res = this.sqr(res)), bit === 0 && current === 0) {
            currentLen = 0;
            continue;
          }
          current <<= 1, current |= bit, currentLen++, !(currentLen !== windowSize && (i$4 !== 0 || j$1 !== 0)) && (res = this.mul(res, wnd[current]), currentLen = 0, current = 0);
        }
        start = 26;
      }
      return res;
    }, Red.prototype.convertTo = function(num) {
      var r$2 = num.umod(this.m);
      return r$2 === num ? r$2.clone() : r$2;
    }, Red.prototype.convertFrom = function(num) {
      var res = num.clone();
      return res.red = null, res;
    }, BN$14.mont = function(num) {
      return new Mont(num);
    };
    function Mont(m$3) {
      Red.call(this, m$3), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new BN$14(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    inherits$14(Mont, Red), Mont.prototype.convertTo = function(num) {
      return this.imod(num.ushln(this.shift));
    }, Mont.prototype.convertFrom = function(num) {
      var r$2 = this.imod(num.mul(this.rinv));
      return r$2.red = null, r$2;
    }, Mont.prototype.imul = function(a$22, b2) {
      if (a$22.isZero() || b2.isZero()) return a$22.words[0] = 0, a$22.length = 1, a$22;
      var t$7 = a$22.imul(b2), c$12 = t$7.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), u = t$7.isub(c$12).iushrn(this.shift), res = u;
      return u.cmp(this.m) >= 0 ? res = u.isub(this.m) : u.cmpn(0) < 0 && (res = u.iadd(this.m)), res._forceRed(this);
    }, Mont.prototype.mul = function(a$22, b2) {
      if (a$22.isZero() || b2.isZero()) return new BN$14(0)._forceRed(this);
      var t$7 = a$22.mul(b2), c$12 = t$7.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), u = t$7.isub(c$12).iushrn(this.shift), res = u;
      return u.cmp(this.m) >= 0 ? res = u.isub(this.m) : u.cmpn(0) < 0 && (res = u.iadd(this.m)), res._forceRed(this);
    }, Mont.prototype.invm = function(a$22) {
      var res = this.imod(a$22._invmp(this.m).mul(this.r2));
      return res._forceRed(this);
    };
  })(module2 === void 0 || module2, exports$12);
}), require_browserify_rsa = __commonJSMin$1((exports$12, module2) => {
  var BN$2 = require_bn(), randomBytes$1 = require_randombytes(), Buffer$5 = require_safe_buffer().Buffer;
  function getr(priv) {
    var len$2 = priv.modulus.byteLength(), r$2;
    do
      r$2 = new BN$2(randomBytes$1(len$2));
    while (r$2.cmp(priv.modulus) >= 0 || !r$2.umod(priv.prime1) || !r$2.umod(priv.prime2));
    return r$2;
  }
  function blind(priv) {
    var r$2 = getr(priv), blinder = r$2.toRed(BN$2.mont(priv.modulus)).redPow(new BN$2(priv.publicExponent)).fromRed();
    return { blinder, unblinder: r$2.invm(priv.modulus) };
  }
  function crt$2(msg, priv) {
    var blinds = blind(priv), len$2 = priv.modulus.byteLength(), blinded = new BN$2(msg).mul(blinds.blinder).umod(priv.modulus), c1 = blinded.toRed(BN$2.mont(priv.prime1)), c2 = blinded.toRed(BN$2.mont(priv.prime2)), qinv = priv.coefficient, p$1 = priv.prime1, q = priv.prime2, m1 = c1.redPow(priv.exponent1).fromRed(), m2 = c2.redPow(priv.exponent2).fromRed(), h$1 = m1.isub(m2).imul(qinv).umod(p$1).imul(q);
    return m2.iadd(h$1).imul(blinds.unblinder).umod(priv.modulus).toArrayLike(Buffer$5, `be`, len$2);
  }
  crt$2.getr = getr, module2.exports = crt$2;
}), require_publicEncrypt = __commonJSMin$1((exports$12, module2) => {
  var parseKeys$1 = require_parse_asn1(), randomBytes = require_randombytes(), createHash$1 = require_create_hash(), mgf$1 = require_mgf(), xor$1 = require_xor(), BN$1 = require_bn$1(), withPublic$1 = require_withPublic(), crt$1 = require_browserify_rsa(), Buffer$4 = require_safe_buffer().Buffer;
  module2.exports = function(publicKey, msg, reverse) {
    var padding;
    padding = publicKey.padding ? publicKey.padding : reverse ? 1 : 4;
    var key = parseKeys$1(publicKey), paddedMsg;
    if (padding === 4) paddedMsg = oaep$1(key, msg);
    else if (padding === 1) paddedMsg = pkcs1$1(key, msg, reverse);
    else if (padding === 3) {
      if (paddedMsg = new BN$1(msg), paddedMsg.cmp(key.modulus) >= 0) throw Error(`data too long for modulus`);
    } else throw Error(`unknown padding`);
    return reverse ? crt$1(paddedMsg, key) : withPublic$1(paddedMsg, key);
  };
  function oaep$1(key, msg) {
    var k = key.modulus.byteLength(), mLen = msg.length, iHash = createHash$1(`sha1`).update(Buffer$4.alloc(0)).digest(), hLen = iHash.length, hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw Error(`message too long`);
    var ps = Buffer$4.alloc(k - mLen - hLen2 - 2), dblen = k - hLen - 1, seed = randomBytes(hLen), maskedDb = xor$1(Buffer$4.concat([iHash, ps, Buffer$4.alloc(1, 1), msg], dblen), mgf$1(seed, dblen)), maskedSeed = xor$1(seed, mgf$1(maskedDb, hLen));
    return new BN$1(Buffer$4.concat([Buffer$4.alloc(1), maskedSeed, maskedDb], k));
  }
  function pkcs1$1(key, msg, reverse) {
    var mLen = msg.length, k = key.modulus.byteLength();
    if (mLen > k - 11) throw Error(`message too long`);
    var ps;
    return ps = reverse ? Buffer$4.alloc(k - mLen - 3, 255) : nonZero(k - mLen - 3), new BN$1(Buffer$4.concat([Buffer$4.from([0, reverse ? 1 : 2]), ps, Buffer$4.alloc(1), msg], k));
  }
  function nonZero(len$2) {
    for (var out = Buffer$4.allocUnsafe(len$2), i$4 = 0, cache$2 = randomBytes(len$2 * 2), cur = 0, num; i$4 < len$2; ) cur === cache$2.length && (cache$2 = randomBytes(len$2 * 2), cur = 0), num = cache$2[cur++], num && (out[i$4++] = num);
    return out;
  }
}), require_privateDecrypt = __commonJSMin$1((exports$12, module2) => {
  var parseKeys = require_parse_asn1(), mgf = require_mgf(), xor = require_xor(), BN = require_bn$1(), crt = require_browserify_rsa(), createHash = require_create_hash(), withPublic = require_withPublic(), Buffer$3 = require_safe_buffer().Buffer;
  module2.exports = function(privateKey, enc, reverse) {
    var padding;
    padding = privateKey.padding ? privateKey.padding : reverse ? 1 : 4;
    var key = parseKeys(privateKey), k = key.modulus.byteLength();
    if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) throw Error(`decryption error`);
    var msg;
    msg = reverse ? withPublic(new BN(enc), key) : crt(enc, key);
    var zBuffer = Buffer$3.alloc(k - msg.length);
    if (msg = Buffer$3.concat([zBuffer, msg], k), padding === 4) return oaep(key, msg);
    if (padding === 1) return pkcs1(key, msg, reverse);
    if (padding === 3) return msg;
    throw Error(`unknown padding`);
  };
  function oaep(key, msg) {
    var k = key.modulus.byteLength(), iHash = createHash(`sha1`).update(Buffer$3.alloc(0)).digest(), hLen = iHash.length;
    if (msg[0] !== 0) throw Error(`decryption error`);
    var maskedSeed = msg.slice(1, hLen + 1), maskedDb = msg.slice(hLen + 1), seed = xor(maskedSeed, mgf(maskedDb, hLen)), db = xor(maskedDb, mgf(seed, k - hLen - 1));
    if (compare$14(iHash, db.slice(0, hLen))) throw Error(`decryption error`);
    for (var i$4 = hLen; db[i$4] === 0; ) i$4++;
    if (db[i$4++] !== 1) throw Error(`decryption error`);
    return db.slice(i$4);
  }
  function pkcs1(key, msg, reverse) {
    for (var p1 = msg.slice(0, 2), i$4 = 2, status = 0; msg[i$4++] !== 0; ) if (i$4 >= msg.length) {
      status++;
      break;
    }
    var ps = msg.slice(2, i$4 - 1);
    if ((p1.toString(`hex`) !== `0002` && !reverse || p1.toString(`hex`) !== `0001` && reverse) && status++, ps.length < 8 && status++, status) throw Error(`decryption error`);
    return msg.slice(i$4);
  }
  function compare$14(a$22, b2) {
    a$22 = Buffer$3.from(a$22), b2 = Buffer$3.from(b2);
    var dif = 0, len$2 = a$22.length;
    a$22.length !== b2.length && (dif++, len$2 = Math.min(a$22.length, b2.length));
    for (var i$4 = -1; ++i$4 < len$2; ) dif += a$22[i$4] ^ b2[i$4];
    return dif;
  }
}), require_browser$1 = __commonJSMin$1((exports$12) => {
  exports$12.publicEncrypt = require_publicEncrypt(), exports$12.privateDecrypt = require_privateDecrypt(), exports$12.privateEncrypt = function(key, buf) {
    return exports$12.publicEncrypt(key, buf, true);
  }, exports$12.publicDecrypt = function(key, buf) {
    return exports$12.privateDecrypt(key, buf, true);
  };
}), require_public_encrypt = __commonJSMin$1((exports$12) => {
  var crypto$2 = require_crypto_browserify();
  typeof crypto$2.publicEncrypt != `function` && (crypto$2 = require_browser$1()), exports$12.publicEncrypt = crypto$2.publicEncrypt, exports$12.privateDecrypt = crypto$2.privateDecrypt, typeof crypto$2.privateEncrypt == `function` ? exports$12.privateEncrypt = crypto$2.privateEncrypt : exports$12.privateEncrypt = require_browser$1().privateEncrypt, typeof crypto$2.publicDecrypt == `function` ? exports$12.publicDecrypt = crypto$2.publicDecrypt : exports$12.publicDecrypt = require_browser$1().publicDecrypt;
}), require_browser = __commonJSMin$1((exports$12) => {
  init_dist();
  function oldBrowser() {
    throw Error(`secure random number generation not supported by this browser
use chrome, FireFox or Internet Explorer 11`);
  }
  var safeBuffer = require_safe_buffer(), randombytes = require_randombytes(), Buffer$2 = safeBuffer.Buffer, kBufferMaxLength = safeBuffer.kMaxLength, crypto$1 = {}.crypto || {}.msCrypto, kMaxUint32 = 2 ** 32 - 1;
  function assertOffset(offset$2, length) {
    if (typeof offset$2 != `number` || offset$2 !== offset$2) throw TypeError(`offset must be a number`);
    if (offset$2 > kMaxUint32 || offset$2 < 0) throw TypeError(`offset must be a uint32`);
    if (offset$2 > kBufferMaxLength || offset$2 > length) throw RangeError(`offset out of range`);
  }
  function assertSize(size, offset$2, length) {
    if (typeof size != `number` || size !== size) throw TypeError(`size must be a number`);
    if (size > kMaxUint32 || size < 0) throw TypeError(`size must be a uint32`);
    if (size + offset$2 > length || size > kBufferMaxLength) throw RangeError(`buffer too small`);
  }
  crypto$1 && crypto$1.getRandomValues || !process$1.browser ? (exports$12.randomFill = randomFill, exports$12.randomFillSync = randomFillSync) : (exports$12.randomFill = oldBrowser, exports$12.randomFillSync = oldBrowser);
  function randomFill(buf, offset$2, size, cb) {
    if (!Buffer$2.isBuffer(buf) && !(buf instanceof {}.Uint8Array)) throw TypeError(`"buf" argument must be a Buffer or Uint8Array`);
    if (typeof offset$2 == `function`) cb = offset$2, offset$2 = 0, size = buf.length;
    else if (typeof size == `function`) cb = size, size = buf.length - offset$2;
    else if (typeof cb != `function`) throw TypeError(`"cb" argument must be a function`);
    return assertOffset(offset$2, buf.length), assertSize(size, offset$2, buf.length), actualFill(buf, offset$2, size, cb);
  }
  function actualFill(buf, offset$2, size, cb) {
    if (process$1.browser) {
      var ourBuf = buf.buffer, uint = new Uint8Array(ourBuf, offset$2, size);
      if (crypto$1.getRandomValues(uint), cb) {
        process$1.nextTick(function() {
          cb(null, buf);
        });
        return;
      }
      return buf;
    }
    if (cb) {
      randombytes(size, function(err$1, bytes$1) {
        if (err$1) return cb(err$1);
        bytes$1.copy(buf, offset$2), cb(null, buf);
      });
      return;
    }
    var bytes = randombytes(size);
    return bytes.copy(buf, offset$2), buf;
  }
  function randomFillSync(buf, offset$2, size) {
    if (offset$2 === void 0 && (offset$2 = 0), !Buffer$2.isBuffer(buf) && !(buf instanceof {}.Uint8Array)) throw TypeError(`"buf" argument must be a Buffer or Uint8Array`);
    return assertOffset(offset$2, buf.length), size === void 0 && (size = buf.length - offset$2), assertSize(size, offset$2, buf.length), actualFill(buf, offset$2, size);
  }
}), require_randomfill = __commonJSMin$1((exports$12, module2) => {
  var crypto = require_crypto_browserify();
  typeof crypto.randomFill == `function` && typeof crypto.randomFillSync == `function` ? (exports$12.randomFill = crypto.randomFill, exports$12.randomFillSync = crypto.randomFillSync) : module2.exports = require_browser();
}), require_crypto_browserify = __commonJSMin$1((exports$12) => {
  exports$12.randomBytes = exports$12.rng = exports$12.pseudoRandomBytes = exports$12.prng = require_randombytes(), exports$12.createHash = exports$12.Hash = require_create_hash(), exports$12.createHmac = exports$12.Hmac = require_create_hmac();
  var algos = require_algos(), algoKeys = Object.keys(algos), hashes = [`sha1`, `sha224`, `sha256`, `sha384`, `sha512`, `md5`, `rmd160`].concat(algoKeys);
  exports$12.getHashes = function() {
    return hashes;
  };
  var p = require_pbkdf2();
  exports$12.pbkdf2 = p.pbkdf2, exports$12.pbkdf2Sync = p.pbkdf2Sync;
  var aes = require_browserify_cipher();
  exports$12.Cipher = aes.Cipher, exports$12.createCipher = aes.createCipher, exports$12.Cipheriv = aes.Cipheriv, exports$12.createCipheriv = aes.createCipheriv, exports$12.Decipher = aes.Decipher, exports$12.createDecipher = aes.createDecipher, exports$12.Decipheriv = aes.Decipheriv, exports$12.createDecipheriv = aes.createDecipheriv, exports$12.getCiphers = aes.getCiphers, exports$12.listCiphers = aes.listCiphers;
  var dh = require_diffie_hellman();
  exports$12.DiffieHellmanGroup = dh.DiffieHellmanGroup, exports$12.createDiffieHellmanGroup = dh.createDiffieHellmanGroup, exports$12.getDiffieHellman = dh.getDiffieHellman, exports$12.createDiffieHellman = dh.createDiffieHellman, exports$12.DiffieHellman = dh.DiffieHellman;
  var sign = require_browserify_sign();
  exports$12.createSign = sign.createSign, exports$12.Sign = sign.Sign, exports$12.createVerify = sign.createVerify, exports$12.Verify = sign.Verify, exports$12.createECDH = require_create_ecdh();
  var publicEncrypt = require_public_encrypt();
  exports$12.publicEncrypt = publicEncrypt.publicEncrypt, exports$12.privateEncrypt = publicEncrypt.privateEncrypt, exports$12.publicDecrypt = publicEncrypt.publicDecrypt, exports$12.privateDecrypt = publicEncrypt.privateDecrypt;
  var rf = require_randomfill();
  exports$12.randomFill = rf.randomFill, exports$12.randomFillSync = rf.randomFillSync, exports$12.createCredentials = function() {
    throw Error(`sorry, createCredentials is not implemented yet
we accept pull requests
https://github.com/browserify/crypto-browserify`);
  }, exports$12.constants = { DH_CHECK_P_NOT_SAFE_PRIME: 2, DH_CHECK_P_NOT_PRIME: 1, DH_UNABLE_TO_CHECK_GENERATOR: 4, DH_NOT_SUITABLE_GENERATOR: 8, NPN_ENABLED: 1, ALPN_ENABLED: 1, RSA_PKCS1_PADDING: 1, RSA_SSLV23_PADDING: 2, RSA_NO_PADDING: 3, RSA_PKCS1_OAEP_PADDING: 4, RSA_X931_PADDING: 5, RSA_PKCS1_PSS_PADDING: 6, POINT_CONVERSION_COMPRESSED: 2, POINT_CONVERSION_UNCOMPRESSED: 4, POINT_CONVERSION_HYBRID: 6 };
}), require_utils$1 = __commonJSMin$1((exports$12, module2) => {
  var NameHelper$1 = class {
    constructor(oracleVersion) {
      this.oracleVersion = oracleVersion;
      let versionParts = oracleVersion.split(`.`).map((versionPart) => parseInt(versionPart));
      versionParts[0] > 12 || versionParts[0] === 12 && versionParts[1] >= 2 ? this.limit = 128 : this.limit = 30;
    }
    generateCombinedName(logger, postfix, name$2, subNames) {
      let crypto$8 = require_crypto_browserify();
      Array.isArray(subNames) || (subNames = subNames ? [subNames] : []);
      let table$2 = name$2.replace(/\.|-/g, `_`), subNamesPart = subNames.join(`_`), result = `${table$2}_${subNamesPart.length ? subNamesPart + `_` : ``}${postfix}`.toLowerCase();
      return result.length > this.limit && (logger.warn(`Automatically generated name "${result}" exceeds ${this.limit} character limit for Oracle Database ${this.oracleVersion}. Using base64 encoded sha1 of that name instead.`), result = crypto$8.createHash(`sha1`).update(result).digest(`base64`).replace(`=`, ``)), result;
    }
  };
  function wrapSqlWithCatch(sql, errorNumberToCatch) {
    return `begin execute immediate '${sql.replace(/'/g, `''`)}'; exception when others then if sqlcode != ${errorNumberToCatch} then raise; end if; end;`;
  }
  function ReturningHelper$4(columnName) {
    this.columnName = columnName;
  }
  ReturningHelper$4.prototype.toString = function() {
    return `[object ReturningHelper:${this.columnName}]`;
  };
  function isConnectionError$1(err$1) {
    return `DPI-1010.DPI-1080.ORA-03114.ORA-03113.ORA-03135.ORA-12514.ORA-00022.ORA-00028.ORA-00031.ORA-00045.ORA-00378.ORA-00602.ORA-00603.ORA-00609.ORA-01012.ORA-01041.ORA-01043.ORA-01089.ORA-01092.ORA-02396.ORA-03122.ORA-12153.ORA-12537.ORA-12547.ORA-12570.ORA-12583.ORA-27146.ORA-28511.ORA-56600.NJS-024.NJS-003`.split(`.`).some(function(prefix) {
      return err$1.message.indexOf(prefix) === 0;
    });
  }
  module2.exports = { NameHelper: NameHelper$1, isConnectionError: isConnectionError$1, wrapSqlWithCatch, ReturningHelper: ReturningHelper$4 };
}), require_trigger = __commonJSMin$1((exports$12, module2) => {
  let { NameHelper } = require_utils$1();
  var Trigger$3 = class {
    constructor(oracleVersion) {
      this.nameHelper = new NameHelper(oracleVersion);
    }
    renameColumnTrigger(logger, tableName, columnName, to) {
      let triggerName = this.nameHelper.generateCombinedName(logger, `autoinc_trg`, tableName), sequenceName = this.nameHelper.generateCombinedName(logger, `seq`, tableName);
      return `DECLARE PK_NAME VARCHAR(200); IS_AUTOINC NUMBER := 0; BEGIN  EXECUTE IMMEDIATE ('ALTER TABLE "${tableName}" RENAME COLUMN "${columnName}" TO "${to}"');  SELECT COUNT(*) INTO IS_AUTOINC from "USER_TRIGGERS" where trigger_name = '${triggerName}';  IF (IS_AUTOINC > 0) THEN    SELECT cols.column_name INTO PK_NAME    FROM all_constraints cons, all_cons_columns cols    WHERE cons.constraint_type = 'P'    AND cons.constraint_name = cols.constraint_name    AND cons.owner = cols.owner    AND cols.table_name = '${tableName}';    IF ('${to}' = PK_NAME) THEN      EXECUTE IMMEDIATE ('DROP TRIGGER "${triggerName}"');      EXECUTE IMMEDIATE ('create or replace trigger "${triggerName}"      BEFORE INSERT on "${tableName}" for each row        declare        checking number := 1;        begin          if (:new."${to}" is null) then            while checking >= 1 loop              select "${sequenceName}".nextval into :new."${to}" from dual;              select count("${to}") into checking from "${tableName}"              where "${to}" = :new."${to}";            end loop;          end if;        end;');    end if;  end if;END;`;
    }
    createAutoIncrementTrigger(logger, tableName, schemaName) {
      let tableQuoted = `"${tableName}"`, tableUnquoted = tableName, schemaQuoted = schemaName ? `"${schemaName}".` : ``, constraintOwner = schemaName ? `'${schemaName}'` : `cols.owner`, triggerName = this.nameHelper.generateCombinedName(logger, `autoinc_trg`, tableName), sequenceNameUnquoted = this.nameHelper.generateCombinedName(logger, `seq`, tableName), sequenceNameQuoted = `"${sequenceNameUnquoted}"`;
      return `DECLARE PK_NAME VARCHAR(200); BEGIN  EXECUTE IMMEDIATE ('CREATE SEQUENCE ${schemaQuoted}${sequenceNameQuoted}');  SELECT cols.column_name INTO PK_NAME  FROM all_constraints cons, all_cons_columns cols  WHERE cons.constraint_type = 'P'  AND cons.constraint_name = cols.constraint_name  AND cons.owner = ${constraintOwner}  AND cols.table_name = '${tableUnquoted}';  execute immediate ('create or replace trigger ${schemaQuoted}"${triggerName}"  BEFORE INSERT on ${schemaQuoted}${tableQuoted}  for each row  declare  checking number := 1;  begin    if (:new."' || PK_NAME || '" is null) then      while checking >= 1 loop        select ${schemaQuoted}${sequenceNameQuoted}.nextval into :new."' || PK_NAME || '" from dual;        select count("' || PK_NAME || '") into checking from ${schemaQuoted}${tableQuoted}        where "' || PK_NAME || '" = :new."' || PK_NAME || '";      end loop;    end if;  end;'); END;`;
    }
    renameTableAndAutoIncrementTrigger(logger, tableName, to) {
      let triggerName = this.nameHelper.generateCombinedName(logger, `autoinc_trg`, tableName), sequenceName = this.nameHelper.generateCombinedName(logger, `seq`, tableName), toTriggerName = this.nameHelper.generateCombinedName(logger, `autoinc_trg`, to), toSequenceName = this.nameHelper.generateCombinedName(logger, `seq`, to);
      return `DECLARE PK_NAME VARCHAR(200); IS_AUTOINC NUMBER := 0; BEGIN  EXECUTE IMMEDIATE ('RENAME "${tableName}" TO "${to}"');  SELECT COUNT(*) INTO IS_AUTOINC from "USER_TRIGGERS" where trigger_name = '${triggerName}';  IF (IS_AUTOINC > 0) THEN    EXECUTE IMMEDIATE ('DROP TRIGGER "${triggerName}"');    EXECUTE IMMEDIATE ('RENAME "${sequenceName}" TO "${toSequenceName}"');    SELECT cols.column_name INTO PK_NAME    FROM all_constraints cons, all_cons_columns cols    WHERE cons.constraint_type = 'P'    AND cons.constraint_name = cols.constraint_name    AND cons.owner = cols.owner    AND cols.table_name = '${to}';    EXECUTE IMMEDIATE ('create or replace trigger "${toTriggerName}"    BEFORE INSERT on "${to}" for each row      declare      checking number := 1;      begin        if (:new."' || PK_NAME || '" is null) then          while checking >= 1 loop            select "${toSequenceName}".nextval into :new."' || PK_NAME || '" from dual;            select count("' || PK_NAME || '") into checking from "${to}"            where "' || PK_NAME || '" = :new."' || PK_NAME || '";          end loop;        end if;      end;');  end if;END;`;
    }
  };
  module2.exports = Trigger$3;
}), require_oracle_compiler = __commonJSMin$1((exports$12, module2) => {
  let SchemaCompiler$2 = require_compiler$1(), utils$1 = require_utils$1(), Trigger$2 = require_trigger();
  var SchemaCompiler_Oracle = class extends SchemaCompiler$2 {
    constructor() {
      super(...arguments);
    }
    renameTable(tableName, to) {
      let trigger = new Trigger$2(this.client.version), renameTable$2 = trigger.renameTableAndAutoIncrementTrigger(this.client.logger, tableName, to);
      this.pushQuery(renameTable$2);
    }
    hasTable(tableName) {
      this.pushQuery({ sql: `select TABLE_NAME from USER_TABLES where TABLE_NAME = ` + this.client.parameter(tableName, this.builder, this.bindingsHolder), output(resp) {
        return resp.length > 0;
      } });
    }
    hasColumn(tableName, column) {
      let sql = `select COLUMN_NAME from ALL_TAB_COLUMNS where TABLE_NAME = ${this.client.parameter(tableName, this.builder, this.bindingsHolder)} and COLUMN_NAME = ${this.client.parameter(column, this.builder, this.bindingsHolder)}`;
      this.pushQuery({ sql, output: (resp) => resp.length > 0 });
    }
    dropSequenceIfExists(sequenceName) {
      let prefix = this.schema ? `"${this.schema}".` : ``;
      this.pushQuery(utils$1.wrapSqlWithCatch(`drop sequence ${prefix}${this.formatter.wrap(sequenceName)}`, -2289));
    }
    _dropRelatedSequenceIfExists(tableName) {
      let nameHelper = new utils$1.NameHelper(this.client.version), sequenceName = nameHelper.generateCombinedName(this.client.logger, `seq`, tableName);
      this.dropSequenceIfExists(sequenceName);
    }
    dropTable(tableName) {
      let prefix = this.schema ? `"${this.schema}".` : ``;
      this.pushQuery(`drop table ${prefix}${this.formatter.wrap(tableName)}`), this._dropRelatedSequenceIfExists(tableName);
    }
    dropTableIfExists(tableName) {
      this.dropObject(tableName, `table`);
    }
    dropViewIfExists(viewName) {
      this.dropObject(viewName, `view`);
    }
    dropObject(objectName, type) {
      let prefix = this.schema ? `"${this.schema}".` : ``, errorCode$1 = -942;
      type === `materialized view` && (errorCode$1 = -12003), this.pushQuery(utils$1.wrapSqlWithCatch(`drop ${type} ${prefix}${this.formatter.wrap(objectName)}`, errorCode$1)), this._dropRelatedSequenceIfExists(objectName);
    }
    refreshMaterializedView(viewName) {
      return this.pushQuery({ sql: `BEGIN DBMS_MVIEW.REFRESH('${this.schemaNameRaw ? this.schemaNameRaw + `.` : ``}${viewName}'); END;` });
    }
    dropMaterializedView(viewName) {
      this._dropView(viewName, false, true);
    }
    dropMaterializedViewIfExists(viewName) {
      this.dropObject(viewName, `materialized view`);
    }
  };
  module2.exports = SchemaCompiler_Oracle;
}), require_oracle_columnbuilder = __commonJSMin$1((exports$12, module2) => {
  let ColumnBuilder$3 = require_columnbuilder(), toArray = require_toArray();
  var ColumnBuilder_Oracle = class extends ColumnBuilder$3 {
    constructor() {
      super(...arguments);
    }
    checkIn() {
      return this._modifiers.checkIn = toArray(arguments), this;
    }
  };
  module2.exports = ColumnBuilder_Oracle;
}), require__arrayIncludes = __commonJSMin$1((exports$12, module2) => {
  var baseIndexOf = require__baseIndexOf();
  function arrayIncludes$1(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }
  module2.exports = arrayIncludes$1;
}), require__arrayIncludesWith = __commonJSMin$1((exports$12, module2) => {
  function arrayIncludesWith$1(array, value, comparator) {
    for (var index$2 = -1, length = array == null ? 0 : array.length; ++index$2 < length; ) if (comparator(value, array[index$2])) return true;
    return false;
  }
  module2.exports = arrayIncludesWith$1;
}), require_noop = __commonJSMin$1((exports$12, module2) => {
  function noop$1() {
  }
  module2.exports = noop$1;
}), require__createSet = __commonJSMin$1((exports$12, module2) => {
  var Set$1 = require__Set(), noop = require_noop(), setToArray$1 = require__setToArray(), INFINITY = 1 / 0, createSet$1 = Set$1 && 1 / setToArray$1(new Set$1([, -0]))[1] == INFINITY ? function(values$3) {
    return new Set$1(values$3);
  } : noop;
  module2.exports = createSet$1;
}), require__baseUniq = __commonJSMin$1((exports$12, module2) => {
  var SetCache = require__SetCache(), arrayIncludes = require__arrayIncludes(), arrayIncludesWith = require__arrayIncludesWith(), cacheHas = require__cacheHas(), createSet = require__createSet(), setToArray = require__setToArray(), LARGE_ARRAY_SIZE = 200;
  function baseUniq$1(array, iteratee, comparator) {
    var index$2 = -1, includes$2 = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) isCommon = false, includes$2 = arrayIncludesWith;
    else if (length >= LARGE_ARRAY_SIZE) {
      var set = iteratee ? null : createSet(array);
      if (set) return setToArray(set);
      isCommon = false, includes$2 = cacheHas, seen = new SetCache();
    } else seen = iteratee ? [] : result;
    outer: for (; ++index$2 < length; ) {
      var value = array[index$2], computed = iteratee ? iteratee(value) : value;
      if (value = comparator || value !== 0 ? value : 0, isCommon && computed === computed) {
        for (var seenIndex = seen.length; seenIndex--; ) if (seen[seenIndex] === computed) continue outer;
        iteratee && seen.push(computed), result.push(value);
      } else includes$2(seen, computed, comparator) || (seen !== result && seen.push(computed), result.push(value));
    }
    return result;
  }
  module2.exports = baseUniq$1;
}), require_uniq = __commonJSMin$1((exports$12, module2) => {
  var baseUniq = require__baseUniq();
  function uniq$1(array) {
    return array && array.length ? baseUniq(array) : [];
  }
  module2.exports = uniq$1;
}), require_incrementUtils = __commonJSMin$1((exports$12, module2) => {
  let Trigger$1 = require_trigger();
  function createAutoIncrementTriggerAndSequence$1(columnCompiler) {
    let trigger = new Trigger$1(columnCompiler.client.version);
    columnCompiler.pushAdditional(function() {
      let tableName = this.tableCompiler.tableNameRaw, schemaName = this.tableCompiler.schemaNameRaw, createTriggerSQL = trigger.createAutoIncrementTrigger(this.client.logger, tableName, schemaName);
      this.pushQuery(createTriggerSQL);
    });
  }
  module2.exports = { createAutoIncrementTriggerAndSequence: createAutoIncrementTriggerAndSequence$1 };
}), require_oracle_columncompiler = __commonJSMin$1((exports$12, module2) => {
  let uniq = require_uniq(), Raw = require_raw(), ColumnCompiler$4 = require_columncompiler(), { createAutoIncrementTriggerAndSequence } = require_incrementUtils(), { toNumber } = require_helpers$1();
  var ColumnCompiler_Oracle$1 = class extends ColumnCompiler$4 {
    constructor() {
      super(...arguments), this.modifiers = [`defaultTo`, `checkIn`, `nullable`, `comment`];
    }
    increments(options = { primaryKey: true }) {
      return createAutoIncrementTriggerAndSequence(this), `integer not null` + (this.tableCompiler._canBeAddPrimaryKey(options) ? ` primary key` : ``);
    }
    bigincrements(options = { primaryKey: true }) {
      return createAutoIncrementTriggerAndSequence(this), `number(20, 0) not null` + (this.tableCompiler._canBeAddPrimaryKey(options) ? ` primary key` : ``);
    }
    floating(precision) {
      let parsedPrecision = toNumber(precision, 0);
      return `float${parsedPrecision ? `(${parsedPrecision})` : ``}`;
    }
    double(precision, scale) {
      return `number(${toNumber(precision, 8)}, ${toNumber(scale, 2)})`;
    }
    decimal(precision, scale) {
      return precision === null ? `decimal` : `decimal(${toNumber(precision, 8)}, ${toNumber(scale, 2)})`;
    }
    integer(length) {
      return length ? `number(${toNumber(length, 11)})` : `integer`;
    }
    enu(allowed) {
      allowed = uniq(allowed);
      let maxLength = (allowed || []).reduce((maxLength$1, name$2) => Math.max(maxLength$1, String(name$2).length), 1);
      return this.columnBuilder._modifiers.checkIn = [allowed], `varchar2(${maxLength})`;
    }
    datetime(without) {
      return without ? `timestamp` : `timestamp with time zone`;
    }
    timestamp(without) {
      return without ? `timestamp` : `timestamp with time zone`;
    }
    bool() {
      return this.columnBuilder._modifiers.checkIn = [[0, 1]], `number(1, 0)`;
    }
    varchar(length) {
      return `varchar2(${toNumber(length, 255)})`;
    }
    comment(comment) {
      let columnName = this.args[0] || this.defaults(`columnName`);
      this.pushAdditional(function() {
        this.pushQuery(`comment on column ${this.tableCompiler.tableName()}.` + this.formatter.wrap(columnName) + ` is '` + (comment || ``) + `'`);
      }, comment);
    }
    checkIn(value) {
      return value === void 0 ? `` : (value = value instanceof Raw ? value.toQuery() : Array.isArray(value) ? value.map((v$1) => `'${v$1}'`).join(`, `) : `'${value}'`, `check (${this.formatter.wrap(this.args[0])} in (${value}))`);
    }
  };
  ColumnCompiler_Oracle$1.prototype.tinyint = `smallint`, ColumnCompiler_Oracle$1.prototype.smallint = `smallint`, ColumnCompiler_Oracle$1.prototype.mediumint = `integer`, ColumnCompiler_Oracle$1.prototype.biginteger = `number(20, 0)`, ColumnCompiler_Oracle$1.prototype.text = `clob`, ColumnCompiler_Oracle$1.prototype.time = `timestamp with time zone`, ColumnCompiler_Oracle$1.prototype.bit = `clob`, ColumnCompiler_Oracle$1.prototype.json = `clob`, module2.exports = ColumnCompiler_Oracle$1;
}), require_oracle_tablecompiler = __commonJSMin$1((exports$12, module2) => {
  let utils = require_utils$1(), TableCompiler$3 = require_tablecompiler(), helpers = require_helpers$1(), Trigger = require_trigger(), { isObject: isObject$2 } = require_is();
  var TableCompiler_Oracle$1 = class extends TableCompiler$3 {
    constructor() {
      super(...arguments);
    }
    addColumns(columns, prefix) {
      if (columns.sql.length > 0) {
        prefix ||= this.addColumnsPrefix;
        let columnSql = columns.sql, alter = this.lowerCase ? `alter table ` : `ALTER TABLE `, sql = `${alter}${this.tableName()} ${prefix}`;
        columns.sql.length > 1 ? sql += `(${columnSql.join(`, `)})` : sql += columnSql.join(`, `), this.pushQuery({ sql, bindings: columns.bindings });
      }
    }
    renameColumn(from$2, to) {
      let tableName = this.tableName().slice(1, -1), trigger = new Trigger(this.client.version);
      return this.pushQuery(trigger.renameColumnTrigger(this.client.logger, tableName, from$2, to));
    }
    compileAdd(builder) {
      let table$2 = this.formatter.wrap(builder), columns = this.prefixArray(`add column`, this.getColumns(builder));
      return this.pushQuery({ sql: `alter table ${table$2} ${columns.join(`, `)}` });
    }
    createQuery(columns, ifNot, like) {
      let columnsSql = like && this.tableNameLike() ? ` as (select * from ` + this.tableNameLike() + ` where 0=1)` : ` (` + columns.sql.join(`, `) + this._addChecks() + `)`, sql = `create table ${this.tableName()}${columnsSql}`;
      this.pushQuery({ sql: ifNot ? utils.wrapSqlWithCatch(sql, -955) : sql, bindings: columns.bindings }), this.single.comment && this.comment(this.single.comment), like && this.addColumns(columns, this.addColumnsPrefix);
    }
    comment(comment) {
      this.pushQuery(`comment on table ${this.tableName()} is '${comment}'`);
    }
    dropColumn() {
      let columns = helpers.normalizeArr.apply(null, arguments);
      this.pushQuery(`alter table ${this.tableName()} drop (${this.formatter.columnize(columns)})`);
    }
    _indexCommand(type, tableName, columns) {
      let nameHelper = new utils.NameHelper(this.client.version);
      return this.formatter.wrap(nameHelper.generateCombinedName(this.client.logger, type, tableName, columns));
    }
    primary(columns, constraintName$2) {
      let deferrable$2;
      isObject$2(constraintName$2) && ({ constraintName: constraintName$2, deferrable: deferrable$2 } = constraintName$2), deferrable$2 = deferrable$2 ? ` deferrable initially ${deferrable$2}` : ``, constraintName$2 = constraintName$2 ? this.formatter.wrap(constraintName$2) : this.formatter.wrap(`${this.tableNameRaw}_pkey`);
      let primaryCols = columns, incrementsCols = [];
      this.grouped.columns && (incrementsCols = this._getIncrementsColumnNames(), incrementsCols && incrementsCols.forEach((c$12) => {
        primaryCols.includes(c$12) || primaryCols.unshift(c$12);
      })), this.pushQuery(`alter table ${this.tableName()} add constraint ${constraintName$2} primary key (${this.formatter.columnize(primaryCols)})${deferrable$2}`);
    }
    dropPrimary(constraintName$2) {
      constraintName$2 = constraintName$2 ? this.formatter.wrap(constraintName$2) : this.formatter.wrap(this.tableNameRaw + `_pkey`), this.pushQuery(`alter table ${this.tableName()} drop constraint ${constraintName$2}`);
    }
    index(columns, indexName) {
      indexName = indexName ? this.formatter.wrap(indexName) : this._indexCommand(`index`, this.tableNameRaw, columns), this.pushQuery(`create index ${indexName} on ${this.tableName()} (` + this.formatter.columnize(columns) + `)`);
    }
    dropIndex(columns, indexName) {
      indexName = indexName ? this.formatter.wrap(indexName) : this._indexCommand(`index`, this.tableNameRaw, columns), this.pushQuery(`drop index ${indexName}`);
    }
    unique(columns, indexName) {
      let deferrable$2;
      isObject$2(indexName) && ({ indexName, deferrable: deferrable$2 } = indexName), deferrable$2 = deferrable$2 ? ` deferrable initially ${deferrable$2}` : ``, indexName = indexName ? this.formatter.wrap(indexName) : this._indexCommand(`unique`, this.tableNameRaw, columns), this.pushQuery(`alter table ${this.tableName()} add constraint ${indexName} unique (` + this.formatter.columnize(columns) + `)` + deferrable$2);
    }
    dropUnique(columns, indexName) {
      indexName = indexName ? this.formatter.wrap(indexName) : this._indexCommand(`unique`, this.tableNameRaw, columns), this.pushQuery(`alter table ${this.tableName()} drop constraint ${indexName}`);
    }
    dropForeign(columns, indexName) {
      indexName = indexName ? this.formatter.wrap(indexName) : this._indexCommand(`foreign`, this.tableNameRaw, columns), this.pushQuery(`alter table ${this.tableName()} drop constraint ${indexName}`);
    }
  };
  TableCompiler_Oracle$1.prototype.addColumnsPrefix = `add `, TableCompiler_Oracle$1.prototype.alterColumnsPrefix = `modify `, module2.exports = TableCompiler_Oracle$1;
}), require_oracle = __commonJSMin$1((exports$12, module2) => {
  let { ReturningHelper: ReturningHelper$3 } = require_utils$1(), { isConnectionError } = require_utils$1(), Client$2 = require_client(), SchemaCompiler$1 = require_oracle_compiler(), ColumnBuilder$2 = require_oracle_columnbuilder(), ColumnCompiler$3 = require_oracle_columncompiler(), TableCompiler$2 = require_oracle_tablecompiler();
  var Client_Oracle$1 = class extends Client$2 {
    schemaCompiler() {
      return new SchemaCompiler$1(this, ...arguments);
    }
    columnBuilder() {
      return new ColumnBuilder$2(this, ...arguments);
    }
    columnCompiler() {
      return new ColumnCompiler$3(this, ...arguments);
    }
    tableCompiler() {
      return new TableCompiler$2(this, ...arguments);
    }
    database() {
      return this.connectionSettings.database;
    }
    positionBindings(sql) {
      let questionCount = 0;
      return sql.replace(/\?/g, function() {
        return questionCount += 1, `:${questionCount}`;
      });
    }
    _stream(connection, obj, stream$1, options) {
      if (!obj.sql) throw Error(`The query is empty`);
      return new Promise(function(resolver, rejecter) {
        stream$1.on(`error`, (err$1) => {
          isConnectionError(err$1) && (connection.__knex__disposed = err$1), rejecter(err$1);
        }), stream$1.on(`end`, resolver);
        let queryStream = connection.queryStream(obj.sql, obj.bindings, options);
        queryStream.pipe(stream$1), queryStream.on(`error`, function(error) {
          rejecter(error), stream$1.emit(`error`, error);
        });
      });
    }
    alias(first$1, second) {
      return first$1 + ` ` + second;
    }
    parameter(value, builder, formatter) {
      return value instanceof ReturningHelper$3 && this.driver ? value = new this.driver.OutParam(this.driver.OCCISTRING) : typeof value == `boolean` && (value = value ? 1 : 0), super.parameter(value, builder, formatter);
    }
  };
  Object.assign(Client_Oracle$1.prototype, { dialect: `oracle`, driverName: `oracle` }), module2.exports = Client_Oracle$1;
}), require__isFlattenable = __commonJSMin$1((exports$12, module2) => {
  var Symbol$1 = require__Symbol(), isArguments = require_isArguments$1(), isArray2 = require_isArray(), spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : void 0;
  function isFlattenable$1(value) {
    return isArray2(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
  }
  module2.exports = isFlattenable$1;
}), require__baseFlatten = __commonJSMin$1((exports$12, module2) => {
  var arrayPush = require__arrayPush(), isFlattenable = require__isFlattenable();
  function baseFlatten$1(array, depth, predicate, isStrict, result) {
    var index$2 = -1, length = array.length;
    for (predicate ||= isFlattenable, result ||= []; ++index$2 < length; ) {
      var value = array[index$2];
      depth > 0 && predicate(value) ? depth > 1 ? baseFlatten$1(value, depth - 1, predicate, isStrict, result) : arrayPush(result, value) : isStrict || (result[result.length] = value);
    }
    return result;
  }
  module2.exports = baseFlatten$1;
}), require_flatten = __commonJSMin$1((exports$12, module2) => {
  var baseFlatten = require__baseFlatten();
  function flatten$1(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten(array, 1) : [];
  }
  module2.exports = flatten$1;
}), require_oracle_querycompiler = __commonJSMin$1((exports$12, module2) => {
  let compact = require_compact(), identity$1 = require_identity(), isEmpty$2 = require_isEmpty(), isPlainObject$2 = require_isPlainObject(), reduce = require_reduce(), QueryCompiler$3 = require_querycompiler(), { ReturningHelper: ReturningHelper$2 } = require_utils$1(), { isString: isString$4 } = require_is(), components = [`comments`, `columns`, `join`, `where`, `union`, `group`, `having`, `order`, `lock`];
  var QueryCompiler_Oracle = class extends QueryCompiler$3 {
    constructor(client, builder, formatter) {
      super(client, builder, formatter);
      let { onConflict } = this.single;
      if (onConflict) throw Error(`.onConflict() is not supported for oracledb.`);
      this.first = this.select;
    }
    insert() {
      let insertValues = this.single.insert || [], { returning } = this.single;
      if (!Array.isArray(insertValues) && isPlainObject$2(this.single.insert) && (insertValues = [this.single.insert]), returning && !Array.isArray(returning) && (returning = [returning]), Array.isArray(insertValues) && insertValues.length === 1 && isEmpty$2(insertValues[0])) return this._addReturningToSqlAndConvert(`insert into ${this.tableName} (${this.formatter.wrap(this.single.returning)}) values (default)`, returning, this.tableName);
      if (isEmpty$2(this.single.insert) && typeof this.single.insert != `function`) return ``;
      let insertData = this._prepInsert(insertValues), sql = {};
      if (isString$4(insertData)) return this._addReturningToSqlAndConvert(`insert into ${this.tableName} ${insertData}`, returning);
      if (insertData.values.length === 1) return this._addReturningToSqlAndConvert(`insert into ${this.tableName} (${this.formatter.columnize(insertData.columns)}) values (${this.client.parameterize(insertData.values[0], void 0, this.builder, this.bindingsHolder)})`, returning, this.tableName);
      let insertDefaultsOnly = insertData.columns.length === 0;
      return sql.sql = `begin ` + insertData.values.map((value) => {
        let returningHelper, parameterizedValues = insertDefaultsOnly ? `` : this.client.parameterize(value, this.client.valueForUndefined, this.builder, this.bindingsHolder), returningValues = Array.isArray(returning) ? returning : [returning], subSql = `insert into ${this.tableName} `;
        returning && (returningHelper = new ReturningHelper$2(returningValues.join(`:`)), sql.outParams = (sql.outParams || []).concat(returningHelper)), insertDefaultsOnly ? subSql += `(${this.formatter.wrap(this.single.returning)}) values (default)` : subSql += `(${this.formatter.columnize(insertData.columns)}) values (${parameterizedValues})`, subSql += returning ? ` returning ROWID into ${this.client.parameter(returningHelper, this.builder, this.bindingsHolder)}` : ``, subSql = this.formatter.client.positionBindings(subSql);
        let parameterizedValuesWithoutDefault = parameterizedValues.replace(`DEFAULT, `, ``).replace(`, DEFAULT`, ``);
        return `execute immediate '${subSql.replace(/'/g, `''`)}` + (parameterizedValuesWithoutDefault || returning ? `' using ` : ``) + parameterizedValuesWithoutDefault + (parameterizedValuesWithoutDefault && returning ? `, ` : ``) + (returning ? `out ?` : ``) + `;`;
      }).join(` `) + `end;`, returning && (sql.returning = returning, sql.returningSql = `select ${this.formatter.columnize(returning)} from ` + this.tableName + ` where ROWID in (` + sql.outParams.map((v$1, i$4) => `:${i$4 + 1}`).join(`, `) + `) order by case ROWID ` + sql.outParams.map((v$1, i$4) => `when CHARTOROWID(:${i$4 + 1}) then ${i$4}`).join(` `) + ` end`), sql;
    }
    update() {
      let updates = this._prepUpdate(this.single.update), where$2 = this.where(), { returning } = this.single, sql = `update ${this.tableName} set ` + updates.join(`, `) + (where$2 ? ` ${where$2}` : ``);
      return returning ? (Array.isArray(returning) || (returning = [returning]), this._addReturningToSqlAndConvert(sql, returning, this.tableName)) : sql;
    }
    truncate() {
      return `truncate table ${this.tableName}`;
    }
    forUpdate() {
      return `for update`;
    }
    forShare() {
      return this.client.logger.warn(`lock for share is not supported by oracle dialect`), ``;
    }
    columnInfo() {
      let column = this.single.columnInfo, table$2 = this.client.customWrapIdentifier(this.single.table, identity$1), sql = `select * from xmltable( '/ROWSET/ROW'
      passing dbms_xmlgen.getXMLType('
      select char_col_decl_length, column_name, data_type, data_default, nullable
      from all_tab_columns where table_name = ''${table$2}'' ')
      columns
      CHAR_COL_DECL_LENGTH number, COLUMN_NAME varchar2(200), DATA_TYPE varchar2(106),
      DATA_DEFAULT clob, NULLABLE varchar2(1))`;
      return { sql, output(resp) {
        let out = reduce(resp, function(columns, val) {
          return columns[val.COLUMN_NAME] = { type: val.DATA_TYPE, defaultValue: val.DATA_DEFAULT, maxLength: val.CHAR_COL_DECL_LENGTH, nullable: val.NULLABLE === `Y` }, columns;
        }, {});
        return column && out[column] || out;
      } };
    }
    select() {
      let query = this.with(), statements = components.map((component) => this[component]());
      return query += compact(statements).join(` `), this._surroundQueryWithLimitAndOffset(query);
    }
    aggregate(stmt) {
      return this._aggregate(stmt, { aliasSeparator: ` ` });
    }
    _addReturningToSqlAndConvert(sql, returning, tableName) {
      let res = { sql };
      if (!returning) return res;
      let returningValues = Array.isArray(returning) ? returning : [returning], returningHelper = new ReturningHelper$2(returningValues.join(`:`));
      return res.sql = sql + ` returning ROWID into ` + this.client.parameter(returningHelper, this.builder, this.bindingsHolder), res.returningSql = `select ${this.formatter.columnize(returning)} from ${tableName} where ROWID = :1`, res.outParams = [returningHelper], res.returning = returning, res;
    }
    _surroundQueryWithLimitAndOffset(query) {
      let { limit } = this.single, { offset: offset$2 } = this.single, hasLimit = limit || limit === 0 || limit === `0`;
      if (limit = +limit, !hasLimit && !offset$2) return query;
      if (query ||= ``, hasLimit && !offset$2) return `select * from (${query}) where rownum <= ${this._getValueOrParameterFromAttribute(`limit`, limit)}`;
      let endRow = +offset$2 + (hasLimit ? limit : 1e13);
      return `select * from (select row_.*, ROWNUM rownum_ from (` + query + `) row_ where rownum <= ` + (this.single.skipBinding.offset ? endRow : this.client.parameter(endRow, this.builder, this.bindingsHolder)) + `) where rownum_ > ` + this._getValueOrParameterFromAttribute(`offset`, offset$2);
    }
  };
  module2.exports = QueryCompiler_Oracle;
}), require_utils = __commonJSMin$1((exports$12, module2) => {
  init_dist$1();
  let Utils = require_utils$1(), { promisify } = require_util(), stream = require_stream_browserify();
  function BlobHelper$2(columnName, value) {
    this.columnName = columnName, this.value = value, this.returning = false;
  }
  BlobHelper$2.prototype.toString = function() {
    return `[object BlobHelper:` + this.columnName + `]`;
  };
  function readStream(stream$1, type) {
    return new Promise((resolve, reject$2) => {
      let data = type === `string` ? `` : Buffer$1.alloc(0);
      stream$1.on(`error`, function(err$1) {
        reject$2(err$1);
      }), stream$1.on(`data`, function(chunk) {
        type === `string` ? data += chunk : data = Buffer$1.concat([data, chunk]);
      }), stream$1.on(`end`, function() {
        resolve(data);
      });
    });
  }
  let lobProcessing = function(stream$1) {
    let oracledb = __require$1(`oracledb`), type;
    if (stream$1.type) stream$1.type === oracledb.BLOB ? type = `buffer` : stream$1.type === oracledb.CLOB && (type = `string`);
    else if (stream$1.iLob) stream$1.iLob.type === oracledb.CLOB ? type = `string` : stream$1.iLob.type === oracledb.BLOB && (type = `buffer`);
    else throw Error(`Unrecognized oracledb lob stream type`);
    return type === `string` && stream$1.setEncoding(`utf-8`), readStream(stream$1, type);
  };
  function monkeyPatchConnection$1(connection, client) {
    if (connection.executeAsync) return;
    connection.commitAsync = function() {
      return new Promise((commitResolve, commitReject) => {
        this.commit(function(err$1) {
          if (err$1) return commitReject(err$1);
          commitResolve();
        });
      });
    }, connection.rollbackAsync = function() {
      return new Promise((rollbackResolve, rollbackReject) => {
        this.rollback(function(err$1) {
          if (err$1) return rollbackReject(err$1);
          rollbackResolve();
        });
      });
    };
    let fetchAsync = promisify(function(sql, bindParams, options, cb) {
      if (options ||= {}, options.outFormat = client.driver.OUT_FORMAT_OBJECT || client.driver.OBJECT, !options.outFormat) throw Error(`not found oracledb.outFormat constants`);
      options.resultSet ? connection.execute(sql, bindParams || [], options, function(err$1, result) {
        if (err$1) return Utils.isConnectionError(err$1) && (connection.close().catch(function(err$2) {
        }), connection.__knex__disposed = err$1), cb(err$1);
        let fetchResult = { rows: [], resultSet: result.resultSet }, numRows = 100, fetchRowsFromRS = function(connection$1, resultSet, numRows$1) {
          resultSet.getRows(numRows$1, function(err$2, rows) {
            if (err$2) Utils.isConnectionError(err$2) && (connection$1.close().catch(function(err$3) {
            }), connection$1.__knex__disposed = err$2), resultSet.close(function() {
              return cb(err$2);
            });
            else if (rows.length === 0) return cb(null, fetchResult);
            else if (rows.length > 0) if (rows.length === numRows$1) fetchResult.rows = fetchResult.rows.concat(rows), fetchRowsFromRS(connection$1, resultSet, numRows$1);
            else return fetchResult.rows = fetchResult.rows.concat(rows), cb(null, fetchResult);
          });
        };
        fetchRowsFromRS(connection, result.resultSet, numRows);
      }) : connection.execute(sql, bindParams || [], options, function(err$1, result) {
        return err$1 ? (Utils.isConnectionError(err$1) && (connection.close().catch(function(err$2) {
        }), connection.__knex__disposed = err$1), cb(err$1)) : cb(null, result);
      });
    });
    connection.executeAsync = function(sql, bindParams, options) {
      return fetchAsync(sql, bindParams, options).then(async (results) => {
        let closeResultSet = () => results.resultSet ? promisify(results.resultSet.close).call(results.resultSet) : Promise.resolve(), lobs = [];
        if (results.rows && Array.isArray(results.rows)) for (let i$4 = 0; i$4 < results.rows.length; i$4++) {
          let row = results.rows[i$4];
          for (let column in row) row[column] instanceof stream.Readable && lobs.push({ index: i$4, key: column, stream: row[column] });
        }
        try {
          for (let lob of lobs) results.rows[lob.index][lob.key] = await lobProcessing(lob.stream);
        } catch (e$22) {
          throw await closeResultSet().catch(() => {
          }), e$22;
        }
        return await closeResultSet(), results;
      });
    };
  }
  Utils.BlobHelper = BlobHelper$2, Utils.monkeyPatchConnection = monkeyPatchConnection$1, module2.exports = Utils;
}), require_oracledb_querycompiler = __commonJSMin$1((exports$12, module2) => {
  init_dist$1();
  let clone$4 = require_clone(), each$1 = require_each(), isEmpty$1 = require_isEmpty(), isPlainObject$1 = require_isPlainObject(), Oracle_Compiler = require_oracle_querycompiler(), ReturningHelper$1 = require_utils().ReturningHelper, BlobHelper$1 = require_utils().BlobHelper, { isString: isString$3 } = require_is(), { columnize: columnize_$1 } = require_wrappingFormatter();
  var Oracledb_Compiler = class extends Oracle_Compiler {
    insert() {
      let self$1 = this, outBindPrep = this._prepOutbindings(this.single.insert, this.single.returning), outBinding = outBindPrep.outBinding, returning = outBindPrep.returning, insertValues = outBindPrep.values;
      if (Array.isArray(insertValues) && insertValues.length === 1 && isEmpty$1(insertValues[0])) {
        let returningFragment = this.single.returning ? ` (` + this.formatter.wrap(this.single.returning) + `)` : ``;
        return this._addReturningToSqlAndConvert(`insert into ` + this.tableName + returningFragment + ` values (default)`, outBinding[0], this.tableName, returning);
      }
      if (isEmpty$1(this.single.insert) && typeof this.single.insert != `function`) return ``;
      let insertData = this._prepInsert(insertValues), sql = {};
      if (isString$3(insertData)) return this._addReturningToSqlAndConvert(`insert into ` + this.tableName + ` ` + insertData, outBinding[0], this.tableName, returning);
      if (insertData.values.length === 1) return this._addReturningToSqlAndConvert(`insert into ` + this.tableName + ` (` + this.formatter.columnize(insertData.columns) + `) values (` + this.client.parameterize(insertData.values[0], void 0, this.builder, this.bindingsHolder) + `)`, outBinding[0], this.tableName, returning);
      let insertDefaultsOnly = insertData.columns.length === 0;
      return sql.returning = returning, sql.sql = `begin ` + insertData.values.map(function(value, index$2) {
        let parameterizedValues = insertDefaultsOnly ? `` : self$1.client.parameterize(value, self$1.client.valueForUndefined, self$1.builder, self$1.bindingsHolder), subSql = `insert into ` + self$1.tableName;
        insertDefaultsOnly ? subSql += ` (` + self$1.formatter.wrap(self$1.single.returning) + `) values (default)` : subSql += ` (` + self$1.formatter.columnize(insertData.columns) + `) values (` + parameterizedValues + `)`;
        let returningClause = ``, intoClause = ``, usingClause = ``, outClause = ``;
        each$1(value, function(val) {
          val instanceof BlobHelper$1 || (usingClause += ` ?,`);
        }), usingClause = usingClause.slice(0, -1), outBinding[index$2].forEach(function(ret) {
          let columnName = ret.columnName || ret;
          if (returningClause += self$1.formatter.wrap(columnName) + `,`, intoClause += ` ?,`, outClause += ` out ?,`, ret instanceof BlobHelper$1) return self$1.formatter.bindings.push(ret);
          self$1.formatter.bindings.push(new ReturningHelper$1(columnName));
        }), returningClause = returningClause.slice(0, -1), intoClause = intoClause.slice(0, -1), outClause = outClause.slice(0, -1), returningClause && intoClause && (subSql += ` returning ` + returningClause + ` into` + intoClause), subSql = self$1.formatter.client.positionBindings(subSql);
        let parameterizedValuesWithoutDefaultAndBlob = parameterizedValues.replace(/DEFAULT, /g, ``).replace(/, DEFAULT/g, ``).replace(`EMPTY_BLOB(), `, ``).replace(`, EMPTY_BLOB()`, ``);
        return `execute immediate '` + subSql.replace(/'/g, `''`) + (parameterizedValuesWithoutDefaultAndBlob || value ? `' using ` : ``) + parameterizedValuesWithoutDefaultAndBlob + (parameterizedValuesWithoutDefaultAndBlob && outClause ? `,` : ``) + outClause + `;`;
      }).join(` `) + `end;`, sql.outBinding = outBinding, returning[0] === `*` && (sql.returningSql = function() {
        return `select * from ` + self$1.tableName + ` where ROWID in (` + this.outBinding.map(function(v$1, i$4) {
          return `:` + (i$4 + 1);
        }).join(`, `) + `) order by case ROWID ` + this.outBinding.map(function(v$1, i$4) {
          return `when CHARTOROWID(:` + (i$4 + 1) + `) then ` + i$4;
        }).join(` `) + ` end`;
      }), sql;
    }
    with() {
      let undoList = [];
      if (this.grouped.with) for (let stmt of this.grouped.with) stmt.recursive && (undoList.push(stmt), stmt.recursive = false);
      let result = super.with();
      for (let stmt of undoList) stmt.recursive = true;
      return result;
    }
    _addReturningToSqlAndConvert(sql, outBinding, tableName, returning) {
      let self$1 = this, res = { sql };
      if (!outBinding) return res;
      let returningValues = Array.isArray(outBinding) ? outBinding : [outBinding], returningClause = ``, intoClause = ``;
      return returningValues.forEach(function(ret) {
        let columnName = ret.columnName || ret;
        if (returningClause += self$1.formatter.wrap(columnName) + `,`, intoClause += `?,`, ret instanceof BlobHelper$1) return self$1.formatter.bindings.push(ret);
        self$1.formatter.bindings.push(new ReturningHelper$1(columnName));
      }), res.sql = sql, returningClause = returningClause.slice(0, -1), intoClause = intoClause.slice(0, -1), returningClause && intoClause && (res.sql += ` returning ` + returningClause + ` into ` + intoClause), res.outBinding = [outBinding], returning[0] === `*` && (res.returningSql = function() {
        return `select * from ` + self$1.tableName + ` where ROWID = :1`;
      }), res.returning = returning, res;
    }
    _prepOutbindings(paramValues, paramReturning) {
      let result = {}, params = paramValues || [], returning = paramReturning || [];
      !Array.isArray(params) && isPlainObject$1(paramValues) && (params = [params]), returning && !Array.isArray(returning) && (returning = [returning]);
      let outBinding = [];
      return each$1(params, function(values$3, index$2) {
        returning[0] === `*` ? outBinding[index$2] = [`ROWID`] : outBinding[index$2] = clone$4(returning), each$1(values$3, function(value, key) {
          if (value instanceof Buffer$1) {
            values$3[key] = new BlobHelper$1(key, value);
            let blobIndex = outBinding[index$2].indexOf(key);
            blobIndex >= 0 && (outBinding[index$2].splice(blobIndex, 1), values$3[key].returning = true), outBinding[index$2].push(values$3[key]);
          }
          value === void 0 && delete params[index$2][key];
        });
      }), result.returning = returning, result.outBinding = outBinding, result.values = params, result;
    }
    _groupOrder(item, type) {
      return super._groupOrderNulls(item, type);
    }
    update() {
      let self$1 = this, sql = {}, outBindPrep = this._prepOutbindings(this.single.update || this.single.counter, this.single.returning), outBinding = outBindPrep.outBinding, returning = outBindPrep.returning, updates = this._prepUpdate(this.single.update), where$2 = this.where(), returningClause = ``, intoClause = ``;
      return isEmpty$1(updates) && typeof this.single.update != `function` ? `` : (outBinding.forEach(function(out) {
        out.forEach(function(ret) {
          let columnName = ret.columnName || ret;
          if (returningClause += self$1.formatter.wrap(columnName) + `,`, intoClause += ` ?,`, ret instanceof BlobHelper$1) return self$1.formatter.bindings.push(ret);
          self$1.formatter.bindings.push(new ReturningHelper$1(columnName));
        });
      }), returningClause = returningClause.slice(0, -1), intoClause = intoClause.slice(0, -1), sql.outBinding = outBinding, sql.returning = returning, sql.sql = `update ` + this.tableName + ` set ` + updates.join(`, `) + (where$2 ? ` ` + where$2 : ``), outBinding.length && !isEmpty$1(outBinding[0]) && (sql.sql += ` returning ` + returningClause + ` into` + intoClause), returning[0] === `*` && (sql.returningSql = function() {
        let sql$1 = `select * from ` + self$1.tableName, modifiedRowsCount = this.rowsAffected.length || this.rowsAffected, returningSqlIn = ` where ROWID in (`, returningSqlOrderBy = `) order by case ROWID `;
        for (let i$4 = 0; i$4 < modifiedRowsCount; i$4++) this.returning[0] === `*` && (returningSqlIn += `:` + (i$4 + 1) + `, `, returningSqlOrderBy += `when CHARTOROWID(:` + (i$4 + 1) + `) then ` + i$4 + ` `);
        return this.returning[0] === `*` && (this.returning = this.returning.slice(0, -1), returningSqlIn = returningSqlIn.slice(0, -2), returningSqlOrderBy = returningSqlOrderBy.slice(0, -1)), sql$1 += returningSqlIn + returningSqlOrderBy + ` end`;
      }), sql);
    }
    _jsonPathWrap(extraction) {
      return `'${extraction.path || extraction[1]}'`;
    }
    jsonExtract(params) {
      return this._jsonExtract(params.singleValue ? `json_value` : `json_query`, params);
    }
    jsonSet(params) {
      return `json_transform(${columnize_$1(params.column, this.builder, this.client, this.bindingsHolder)}, set ${this.client.parameter(params.path, this.builder, this.bindingsHolder)} = ${this.client.parameter(params.value, this.builder, this.bindingsHolder)})`;
    }
    jsonInsert(params) {
      return `json_transform(${columnize_$1(params.column, this.builder, this.client, this.bindingsHolder)}, insert ${this.client.parameter(params.path, this.builder, this.bindingsHolder)} = ${this.client.parameter(params.value, this.builder, this.bindingsHolder)})`;
    }
    jsonRemove(params) {
      let jsonCol = `json_transform(${columnize_$1(params.column, this.builder, this.client, this.bindingsHolder)}, remove ${this.client.parameter(params.path, this.builder, this.bindingsHolder)})`;
      return params.alias ? this.client.alias(jsonCol, this.formatter.wrap(params.alias)) : jsonCol;
    }
    whereJsonPath(statement) {
      return this._whereJsonPath(`json_value`, statement);
    }
    whereJsonSupersetOf(statement) {
      throw Error(`Json superset where clause not actually supported by Oracle`);
    }
    whereJsonSubsetOf(statement) {
      throw Error(`Json subset where clause not actually supported by Oracle`);
    }
    onJsonPathEquals(clause) {
      return this._onJsonPathEquals(`json_value`, clause);
    }
  };
  module2.exports = Oracledb_Compiler;
}), require_oracledb_tablecompiler = __commonJSMin$1((exports$12, module2) => {
  let TableCompiler_Oracle = require_oracle_tablecompiler();
  var TableCompiler_Oracledb = class extends TableCompiler_Oracle {
    constructor(client, tableBuilder) {
      super(client, tableBuilder);
    }
    _setNullableState(column, isNullable) {
      let nullability = isNullable ? `NULL` : `NOT NULL`, sql = `alter table ${this.tableName()} modify (${this.formatter.wrap(column)} ${nullability})`;
      return this.pushQuery({ sql });
    }
  };
  module2.exports = TableCompiler_Oracledb;
}), require_oracledb_columncompiler = __commonJSMin$1((exports$12, module2) => {
  let ColumnCompiler_Oracle = require_oracle_columncompiler(), { isObject: isObject$12 } = require_is();
  var ColumnCompiler_Oracledb = class extends ColumnCompiler_Oracle {
    constructor() {
      super(...arguments), this.modifiers = [`defaultTo`, `nullable`, `comment`, `checkJson`], this._addCheckModifiers();
    }
    datetime(withoutTz) {
      let useTz;
      return isObject$12(withoutTz) ? { useTz } = withoutTz : useTz = !withoutTz, useTz ? `timestamp with local time zone` : `timestamp`;
    }
    timestamp(withoutTz) {
      let useTz;
      return isObject$12(withoutTz) ? { useTz } = withoutTz : useTz = !withoutTz, useTz ? `timestamp with local time zone` : `timestamp`;
    }
    checkRegex(regex, constraintName$2) {
      return this._check(`REGEXP_LIKE(${this.formatter.wrap(this.getColumnName())},${this.client._escapeBinding(regex)})`, constraintName$2);
    }
    json() {
      return this.columnBuilder._modifiers.checkJson = [this.formatter.columnize(this.getColumnName())], `varchar2(4000)`;
    }
    jsonb() {
      return this.json();
    }
    checkJson(column) {
      return `check (${column} is json)`;
    }
  };
  ColumnCompiler_Oracledb.prototype.time = `timestamp with local time zone`, ColumnCompiler_Oracledb.prototype.uuid = ({ useBinaryUuid = false } = {}) => useBinaryUuid ? `raw(16)` : `char(36)`, module2.exports = ColumnCompiler_Oracledb;
}), require_oracledb_viewcompiler = __commonJSMin$1((exports$12, module2) => {
  let ViewCompiler$2 = require_viewcompiler();
  var ViewCompiler_Oracledb = class extends ViewCompiler$2 {
    constructor(client, viewCompiler) {
      super(client, viewCompiler);
    }
    createOrReplace() {
      this.createQuery(this.columns, this.selectQuery, false, true);
    }
    createMaterializedView() {
      this.createQuery(this.columns, this.selectQuery, true);
    }
  };
  module2.exports = ViewCompiler_Oracledb;
}), require_oracledb_viewbuilder = __commonJSMin$1((exports$12, module2) => {
  let ViewBuilder$1 = require_viewbuilder();
  var ViewBuilder_Oracledb = class extends ViewBuilder$1 {
    constructor() {
      super(...arguments);
    }
    checkOption() {
      this._single.checkOption = `default_option`;
    }
  };
  module2.exports = ViewBuilder_Oracledb;
}), require_transaction$1 = __commonJSMin$1((exports$12, module2) => {
  let Transaction$3 = (init_transaction(), __toCommonJS(transaction_exports)), { timeout, KnexTimeoutError: KnexTimeoutError$1 } = require_timeout(), debugTx = require_src()(`knex:tx`);
  module2.exports = class extends Transaction$3 {
    begin(conn) {
      return this.isolationLevel && this.client.logger.warn(`Transaction isolation is not currently supported for Oracle`), Promise.resolve();
    }
    async commit(conn, value) {
      this._completed = true;
      try {
        await conn.commitAsync(), this._resolver(value);
      } catch (err$1) {
        this._rejecter(err$1);
      }
    }
    release(conn, value) {
      return this._resolver(value);
    }
    rollback(conn, err$1) {
      return this._completed = true, debugTx(`%s: rolling back`, this.txid), timeout(conn.rollbackAsync(), 5e3).catch((e$22) => {
        if (!(e$22 instanceof KnexTimeoutError$1)) return Promise.reject(e$22);
        this._rejecter(e$22);
      }).then(() => {
        if (err$1 === void 0) {
          if (this.doNotRejectOnRollback) {
            this._resolver();
            return;
          }
          err$1 = Error(`Transaction rejected with non-error: ${err$1}`);
        }
        this._rejecter(err$1);
      });
    }
    savepoint(conn) {
      return this.query(conn, `SAVEPOINT ${this.txid}`);
    }
    async acquireConnection(config, cb) {
      let configConnection = config && config.connection, connection = configConnection || await this.client.acquireConnection();
      try {
        return connection.__knexTxId = this.txid, connection.isTransaction = true, await cb(connection);
      } finally {
        debugTx(`%s: releasing connection`, this.txid), connection.isTransaction = false;
        try {
          await connection.commitAsync();
        } catch (err$1) {
          this._rejecter(err$1);
        } finally {
          configConnection ? debugTx(`%s: not releasing external connection`, this.txid) : await this.client.releaseConnection(connection);
        }
      }
    }
  };
}), require_oracledb = __commonJSMin$1((exports$12, module2) => {
  init_dist();
  let each = require_each(), flatten = require_flatten(), isEmpty = require_isEmpty(), map$1 = require_map(), Formatter$2 = require_formatter(), QueryCompiler$2 = require_oracledb_querycompiler(), TableCompiler$1 = require_oracledb_tablecompiler(), ColumnCompiler$2 = require_oracledb_columncompiler(), { BlobHelper, ReturningHelper, monkeyPatchConnection } = require_utils(), ViewCompiler$1 = require_oracledb_viewcompiler(), ViewBuilder = require_oracledb_viewbuilder(), Transaction$2 = require_transaction$1(), Client_Oracle = require_oracle(), { isString: isString$2 } = require_is(), { outputQuery, unwrapRaw } = require_wrappingFormatter(), { compileCallback: compileCallback$1 } = require_formatterUtils();
  var Client_Oracledb = class extends Client_Oracle {
    constructor(config) {
      super(config), this.version &&= parseVersion(this.version), this.driver && (process$1.env.UV_THREADPOOL_SIZE = process$1.env.UV_THREADPOOL_SIZE || 1, process$1.env.UV_THREADPOOL_SIZE = parseInt(process$1.env.UV_THREADPOOL_SIZE) + this.driver.poolMax);
    }
    _driver() {
      let client = this, oracledb = __require$1(`oracledb`);
      return client.fetchAsString = [], this.config.fetchAsString && Array.isArray(this.config.fetchAsString) && this.config.fetchAsString.forEach(function(type) {
        isString$2(type) && (type = type.toUpperCase(), oracledb[type] && (type !== `NUMBER` && type !== `DATE` && type !== `CLOB` && type !== `BUFFER` && this.logger.warn(`Only "date", "number", "clob" and "buffer" are supported for fetchAsString`), client.fetchAsString.push(oracledb[type])));
      }), oracledb;
    }
    queryCompiler(builder, formatter) {
      return new QueryCompiler$2(this, builder, formatter);
    }
    tableCompiler() {
      return new TableCompiler$1(this, ...arguments);
    }
    columnCompiler() {
      return new ColumnCompiler$2(this, ...arguments);
    }
    viewBuilder() {
      return new ViewBuilder(this, ...arguments);
    }
    viewCompiler() {
      return new ViewCompiler$1(this, ...arguments);
    }
    formatter(builder) {
      return new Formatter$2(this, builder);
    }
    transaction() {
      return new Transaction$2(this, ...arguments);
    }
    prepBindings(bindings) {
      return map$1(bindings, (value) => value instanceof BlobHelper && this.driver ? { type: this.driver.BLOB, dir: this.driver.BIND_OUT } : value instanceof ReturningHelper && this.driver ? { type: this.driver.STRING, dir: this.driver.BIND_OUT } : typeof value == `boolean` ? value ? 1 : 0 : value);
    }
    parameter(value, builder, formatter) {
      return typeof value == `function` ? outputQuery(compileCallback$1(value, void 0, this, formatter), true, builder, this) : value instanceof BlobHelper ? (formatter.bindings.push(value.value), `?`) : unwrapRaw(value, true, builder, this, formatter) || `?`;
    }
    acquireRawConnection() {
      return new Promise((resolver, rejecter) => {
        let oracleDbConfig = this.connectionSettings.externalAuth ? { externalAuth: this.connectionSettings.externalAuth } : { user: this.connectionSettings.user, password: this.connectionSettings.password };
        oracleDbConfig.connectString = resolveConnectString(this.connectionSettings), this.connectionSettings.prefetchRowCount && (oracleDbConfig.prefetchRows = this.connectionSettings.prefetchRowCount), this.connectionSettings.stmtCacheSize !== void 0 && (oracleDbConfig.stmtCacheSize = this.connectionSettings.stmtCacheSize), this.driver.fetchAsString = this.fetchAsString, this.driver.getConnection(oracleDbConfig, (err$1, connection) => {
          if (err$1) return rejecter(err$1);
          monkeyPatchConnection(connection, this), resolver(connection);
        });
      });
    }
    destroyRawConnection(connection) {
      return connection.release();
    }
    async acquireConnection() {
      let connection = await super.acquireConnection();
      return this.checkVersion(connection), connection;
    }
    checkVersion(connection) {
      if (this.version) return this.version;
      let detectedVersion = parseVersion(connection.oracleServerVersionString);
      if (!detectedVersion) throw Error(this.version === null ? `Invalid Oracledb version number format passed to knex. Unable to successfully auto-detect as fallback. Please specify a valid oracledb version.` : `Unable to detect Oracledb version number automatically. Please specify the version in knex configuration.`);
      return this.version = detectedVersion, detectedVersion;
    }
    _query(connection, obj) {
      if (!obj.sql) throw Error(`The query is empty`);
      let options = Object.assign({}, obj.options, { autoCommit: false });
      return obj.method === `select` && (options.resultSet = true), connection.executeAsync(obj.sql, obj.bindings, options).then(async function(response) {
        let outBinds = flatten(response.outBinds);
        if (obj.response = response.rows || [], obj.rowsAffected = response.rows ? response.rows.rowsAffected : response.rowsAffected, obj.method === `raw` && outBinds.length > 0) return { response: outBinds };
        if (obj.method === `update`) {
          let modifiedRowsCount = obj.rowsAffected.length || obj.rowsAffected, updatedObjOutBinding = [], updatedOutBinds = [], updateOutBinds = (i$4) => function(value, index$2) {
            let OutBindsOffset = index$2 * modifiedRowsCount;
            updatedOutBinds.push(outBinds[i$4 + OutBindsOffset]);
          };
          for (let i$4 = 0; i$4 < modifiedRowsCount; i$4++) updatedObjOutBinding.push(obj.outBinding[0]), each(obj.outBinding[0], updateOutBinds(i$4));
          outBinds = updatedOutBinds, obj.outBinding = updatedObjOutBinding;
        }
        if (!obj.returning && outBinds.length === 0) return connection.isTransaction || await connection.commitAsync(), obj;
        let rowIds = [], offset$2 = 0;
        for (let line = 0; line < obj.outBinding.length; line++) {
          let ret = obj.outBinding[line];
          offset$2 += obj.outBinding[line - 1] ? obj.outBinding[line - 1].length : 0;
          for (let index$2 = 0; index$2 < ret.length; index$2++) {
            let out = ret[index$2];
            await new Promise(function(bindResolver, bindRejecter) {
              if (out instanceof BlobHelper) {
                let blob = outBinds[index$2 + offset$2];
                out.returning && (obj.response[line] = obj.response[line] || {}, obj.response[line][out.columnName] = out.value), blob.on(`error`, function(err$1) {
                  bindRejecter(err$1);
                }), blob.on(`finish`, function() {
                  bindResolver();
                }), blob.write(out.value), blob.end();
              } else obj.outBinding[line][index$2] === `ROWID` ? (rowIds.push(outBinds[index$2 + offset$2]), bindResolver()) : (obj.response[line] = obj.response[line] || {}, obj.response[line][out] = outBinds[index$2 + offset$2], bindResolver());
            });
          }
        }
        if (obj.returningSql) {
          let response$1 = await connection.executeAsync(obj.returningSql(), rowIds, { resultSet: true });
          obj.response = response$1.rows;
        }
        return connection.isTransaction || await connection.commitAsync(), obj;
      });
    }
    processResponse(obj, runner) {
      let { response } = obj;
      if (obj.output) return obj.output.call(runner, response);
      switch (obj.method) {
        case `select`:
          return response;
        case `first`:
          return response[0];
        case `pluck`:
          return map$1(response, obj.pluck);
        case `insert`:
        case `del`:
        case `update`:
        case `counter`:
          return obj.returning && !isEmpty(obj.returning) || obj.returningSql ? response : obj.rowsAffected === void 0 ? 1 : obj.rowsAffected;
        default:
          return response;
      }
    }
    processPassedConnection(connection) {
      this.checkVersion(connection), monkeyPatchConnection(connection, this);
    }
  };
  Client_Oracledb.prototype.driverName = `oracledb`;
  function parseVersion(versionString) {
    try {
      let versionParts = versionString.split(`.`).slice(0, 2);
      versionParts.forEach((versionPart, idx) => {
        versionParts[idx] = versionPart.replace(/\D$/, ``);
      });
      let version$4 = versionParts.join(`.`);
      return version$4.match(/^\d+\.?\d*$/) ? version$4 : null;
    } catch {
      return null;
    }
  }
  function resolveConnectString(connectionSettings) {
    return connectionSettings.connectString ? connectionSettings.connectString : connectionSettings.port ? connectionSettings.host + `:` + connectionSettings.port + `/` + connectionSettings.database : connectionSettings.host + `/` + connectionSettings.database;
  }
  module2.exports = Client_Oracledb;
}), require_pgnative = __commonJSMin$1((exports$12, module2) => {
  let Client_PG$1 = require_postgres();
  var Client_PgNative = class extends Client_PG$1 {
    constructor(...args$1) {
      super(...args$1), this.driverName = `pgnative`, this.canCancelQuery = true;
    }
    _driver() {
      return __require$1(`pg`).native;
    }
    _stream(connection, obj, stream$1, options) {
      if (!obj.sql) throw Error(`The query is empty`);
      let client = this;
      return new Promise((resolver, rejecter) => (stream$1.on(`error`, rejecter), stream$1.on(`end`, resolver), client._query(connection, obj).then((obj$1) => obj$1.response).then(({ rows }) => rows.forEach((row) => stream$1.write(row))).catch(function(err$1) {
        stream$1.emit(`error`, err$1);
      }).then(function() {
        stream$1.end();
      })));
    }
    async cancelQuery(connectionToKill) {
      try {
        return await this._wrappedCancelQueryCall(null, connectionToKill);
      } catch (err$1) {
        throw this.logger.warn(`Connection Error: ${err$1}`), err$1;
      }
    }
    _wrappedCancelQueryCall(emptyConnection, connectionToKill) {
      return new Promise(function(resolve, reject$2) {
        connectionToKill.native.cancel(function(err$1) {
          if (err$1) {
            reject$2(err$1);
            return;
          }
          resolve(true);
        });
      });
    }
  };
  module2.exports = Client_PgNative;
}), require_transaction = __commonJSMin$1((exports$12, module2) => {
  let Transaction$1 = (init_transaction(), __toCommonJS(transaction_exports));
  module2.exports = class extends Transaction$1 {
    begin(conn) {
      let trxMode = [this.isolationLevel ? `ISOLATION LEVEL ${this.isolationLevel}` : ``, this.readOnly ? `READ ONLY` : ``].join(` `).trim();
      return trxMode.length === 0 ? this.query(conn, `BEGIN;`) : this.query(conn, `BEGIN ${trxMode};`);
    }
    savepoint(conn) {
      return this.trxClient.logger(`Redshift does not support savepoints.`), Promise.resolve();
    }
    release(conn, value) {
      return this.trxClient.logger(`Redshift does not support savepoints.`), Promise.resolve();
    }
    rollbackTo(conn, error) {
      return this.trxClient.logger(`Redshift does not support savepoints.`), Promise.resolve();
    }
  };
}), require_redshift_querycompiler = __commonJSMin$1((exports$12, module2) => {
  let QueryCompiler$1 = require_querycompiler(), QueryCompiler_PG = require_pg_querycompiler(), identity = require_identity(), { columnize: columnize_ } = require_wrappingFormatter();
  var QueryCompiler_Redshift = class extends QueryCompiler_PG {
    truncate() {
      return `truncate ${this.tableName.toLowerCase()}`;
    }
    insert() {
      let sql = QueryCompiler$1.prototype.insert.apply(this, arguments);
      return sql === `` ? sql : (this._slightReturn(), { sql });
    }
    update() {
      let sql = QueryCompiler$1.prototype.update.apply(this, arguments);
      return this._slightReturn(), { sql };
    }
    del() {
      let sql = QueryCompiler$1.prototype.del.apply(this, arguments);
      return this._slightReturn(), { sql };
    }
    _slightReturn() {
      this.single.isReturning && this.client.logger.warn(`insert/update/delete returning is not supported by redshift dialect`);
    }
    forUpdate() {
      return this.client.logger.warn(`table lock is not supported by redshift dialect`), ``;
    }
    forShare() {
      return this.client.logger.warn(`lock for share is not supported by redshift dialect`), ``;
    }
    forNoKeyUpdate() {
      return this.client.logger.warn(`table lock is not supported by redshift dialect`), ``;
    }
    forKeyShare() {
      return this.client.logger.warn(`lock for share is not supported by redshift dialect`), ``;
    }
    columnInfo() {
      let column = this.single.columnInfo, schema$2 = this.single.schema, table$2 = this.client.customWrapIdentifier(this.single.table, identity);
      schema$2 &&= this.client.customWrapIdentifier(schema$2, identity);
      let sql = `select * from information_schema.columns where table_name = ? and table_catalog = ?`, bindings = [table$2.toLowerCase(), this.client.database().toLowerCase()];
      return this._buildColumnInfoQuery(schema$2, sql, bindings, column);
    }
    jsonExtract(params) {
      let extractions;
      return extractions = Array.isArray(params.column) ? params.column : [params], extractions.map((extraction) => {
        let jsonCol = `json_extract_path_text(${columnize_(extraction.column || extraction[0], this.builder, this.client, this.bindingsHolder)}, ${this.client.toPathForJson(params.path || extraction[1], this.builder, this.bindingsHolder)})`, alias = extraction.alias || extraction[2];
        return alias ? this.client.alias(jsonCol, this.formatter.wrap(alias)) : jsonCol;
      }).join(`, `);
    }
    jsonSet(params) {
      throw Error(`Json set is not supported by Redshift`);
    }
    jsonInsert(params) {
      throw Error(`Json insert is not supported by Redshift`);
    }
    jsonRemove(params) {
      throw Error(`Json remove is not supported by Redshift`);
    }
    whereJsonPath(statement) {
      return this._whereJsonPath(`json_extract_path_text`, Object.assign({}, statement, { path: this.client.toPathForJson(statement.path) }));
    }
    whereJsonSupersetOf(statement) {
      throw Error(`Json superset is not supported by Redshift`);
    }
    whereJsonSubsetOf(statement) {
      throw Error(`Json subset is not supported by Redshift`);
    }
    onJsonPathEquals(clause) {
      return this._onJsonPathEquals(`json_extract_path_text`, clause);
    }
  };
  module2.exports = QueryCompiler_Redshift;
}), require_redshift_columnbuilder = __commonJSMin$1((exports$12, module2) => {
  let ColumnBuilder$1 = require_columnbuilder();
  var ColumnBuilder_Redshift = class extends ColumnBuilder$1 {
    constructor() {
      super(...arguments);
    }
    primary() {
      return this.notNullable(), super.primary(...arguments);
    }
    index() {
      return this.client.logger.warn(`Redshift does not support the creation of indexes.`), this;
    }
  };
  module2.exports = ColumnBuilder_Redshift;
}), require_redshift_columncompiler = __commonJSMin$1((exports$12, module2) => {
  let ColumnCompiler_PG = require_pg_columncompiler(), ColumnCompiler$1 = require_columncompiler();
  var ColumnCompiler_Redshift = class extends ColumnCompiler_PG {
    constructor() {
      super(...arguments);
    }
    bit(column) {
      return column.length === false ? `char(1)` : `char(${column.length})`;
    }
    datetime(without) {
      return without ? `timestamp` : `timestamptz`;
    }
    timestamp(without) {
      return without ? `timestamp` : `timestamptz`;
    }
    comment(comment) {
      this.pushAdditional(function() {
        this.pushQuery(`comment on column ${this.tableCompiler.tableName()}.` + this.formatter.wrap(this.args[0]) + ` is ` + (comment ? `'${comment}'` : `NULL`));
      }, comment);
    }
  };
  ColumnCompiler_Redshift.prototype.increments = ({ primaryKey = true } = {}) => `integer identity(1,1)` + (primaryKey ? ` primary key` : ``) + ` not null`, ColumnCompiler_Redshift.prototype.bigincrements = ({ primaryKey = true } = {}) => `bigint identity(1,1)` + (primaryKey ? ` primary key` : ``) + ` not null`, ColumnCompiler_Redshift.prototype.binary = `varchar(max)`, ColumnCompiler_Redshift.prototype.blob = `varchar(max)`, ColumnCompiler_Redshift.prototype.enu = `varchar(255)`, ColumnCompiler_Redshift.prototype.enum = `varchar(255)`, ColumnCompiler_Redshift.prototype.json = `varchar(max)`, ColumnCompiler_Redshift.prototype.jsonb = `varchar(max)`, ColumnCompiler_Redshift.prototype.longblob = `varchar(max)`, ColumnCompiler_Redshift.prototype.mediumblob = `varchar(16777218)`, ColumnCompiler_Redshift.prototype.set = `text`, ColumnCompiler_Redshift.prototype.text = `varchar(max)`, ColumnCompiler_Redshift.prototype.tinyblob = `varchar(256)`, ColumnCompiler_Redshift.prototype.uuid = ColumnCompiler$1.prototype.uuid, ColumnCompiler_Redshift.prototype.varbinary = `varchar(max)`, ColumnCompiler_Redshift.prototype.bigint = `bigint`, ColumnCompiler_Redshift.prototype.bool = `boolean`, ColumnCompiler_Redshift.prototype.double = `double precision`, ColumnCompiler_Redshift.prototype.floating = `real`, ColumnCompiler_Redshift.prototype.smallint = `smallint`, ColumnCompiler_Redshift.prototype.tinyint = `smallint`, module2.exports = ColumnCompiler_Redshift;
}), require_redshift_tablecompiler = __commonJSMin$1((exports$12, module2) => {
  let has = require_has(), TableCompiler_PG = require_pg_tablecompiler();
  var TableCompiler_Redshift = class extends TableCompiler_PG {
    constructor() {
      super(...arguments);
    }
    index(columns, indexName, options) {
      this.client.logger.warn(`Redshift does not support the creation of indexes.`);
    }
    dropIndex(columns, indexName) {
      this.client.logger.warn(`Redshift does not support the deletion of indexes.`);
    }
    createQuery(columns, ifNot, like) {
      let createStatement = ifNot ? `create table if not exists ` : `create table `, columnsSql = ` (` + columns.sql.join(`, `) + this._addChecks() + `)`, sql = createStatement + this.tableName() + (like && this.tableNameLike() ? ` (like ` + this.tableNameLike() + `)` : columnsSql);
      this.single.inherits && (sql += ` like (${this.formatter.wrap(this.single.inherits)})`), this.pushQuery({ sql, bindings: columns.bindings });
      let hasComment = has(this.single, `comment`);
      hasComment && this.comment(this.single.comment), like && this.addColumns(columns, this.addColumnsPrefix);
    }
    primary(columns, constraintName$2) {
      let self$1 = this;
      constraintName$2 = constraintName$2 ? self$1.formatter.wrap(constraintName$2) : self$1.formatter.wrap(`${this.tableNameRaw}_pkey`), columns.constructor !== Array && (columns = [columns]);
      let thiscolumns = self$1.grouped.columns;
      if (thiscolumns) for (let i$4 = 0; i$4 < columns.length; i$4++) {
        let exists$2 = thiscolumns.find((tcb) => tcb.grouping === `columns` && tcb.builder && tcb.builder._method === `add` && tcb.builder._args && tcb.builder._args.indexOf(columns[i$4]) > -1);
        exists$2 &&= exists$2.builder;
        let nullable = !(exists$2 && exists$2._modifiers && exists$2._modifiers.nullable && exists$2._modifiers.nullable[0] === false);
        if (nullable) return exists$2 ? this.client.logger.warn(`Redshift does not allow primary keys to contain nullable columns.`) : this.client.logger.warn(`Redshift does not allow primary keys to contain nonexistent columns.`);
      }
      return self$1.pushQuery(`alter table ${self$1.tableName()} add constraint ${constraintName$2} primary key (${self$1.formatter.columnize(columns)})`);
    }
    addColumns(columns, prefix, colCompilers) {
      if (prefix === this.alterColumnsPrefix) super.addColumns(columns, prefix, colCompilers);
      else {
        prefix ||= this.addColumnsPrefix, colCompilers ||= this.getColumns();
        for (let col of colCompilers) {
          let quotedTableName = this.tableName(), colCompiled = col.compileColumn();
          this.pushQuery({ sql: `alter table ${quotedTableName} ${prefix}${colCompiled}`, bindings: [] });
        }
      }
    }
  };
  module2.exports = TableCompiler_Redshift;
}), require_redshift_compiler = __commonJSMin$1((exports$12, module2) => {
  let SchemaCompiler_PG = require_pg_compiler();
  var SchemaCompiler_Redshift = class extends SchemaCompiler_PG {
    constructor() {
      super(...arguments);
    }
  };
  module2.exports = SchemaCompiler_Redshift;
}), require_redshift_viewcompiler = __commonJSMin$1((exports$12, module2) => {
  let ViewCompiler_PG = require_pg_viewcompiler();
  var ViewCompiler_Redshift = class extends ViewCompiler_PG {
    constructor(client, viewCompiler) {
      super(client, viewCompiler);
    }
  };
  module2.exports = ViewCompiler_Redshift;
}), require_redshift = __commonJSMin$1((exports$12, module2) => {
  let Client_PG = require_postgres(), map = require_map(), Transaction = require_transaction(), QueryCompiler = require_redshift_querycompiler(), ColumnBuilder = require_redshift_columnbuilder(), ColumnCompiler = require_redshift_columncompiler(), TableCompiler = require_redshift_tablecompiler(), SchemaCompiler = require_redshift_compiler(), ViewCompiler = require_redshift_viewcompiler();
  var Client_Redshift = class extends Client_PG {
    transaction() {
      return new Transaction(this, ...arguments);
    }
    queryCompiler(builder, formatter) {
      return new QueryCompiler(this, builder, formatter);
    }
    columnBuilder() {
      return new ColumnBuilder(this, ...arguments);
    }
    columnCompiler() {
      return new ColumnCompiler(this, ...arguments);
    }
    tableCompiler() {
      return new TableCompiler(this, ...arguments);
    }
    schemaCompiler() {
      return new SchemaCompiler(this, ...arguments);
    }
    viewCompiler() {
      return new ViewCompiler(this, ...arguments);
    }
    _driver() {
      return __require$1(`pg`);
    }
    processResponse(obj, runner) {
      let resp = obj.response;
      return obj.output ? obj.output.call(runner, resp) : obj.method === `raw` ? resp : resp.command === `SELECT` ? obj.method === `first` ? resp.rows[0] : obj.method === `pluck` ? map(resp.rows, obj.pluck) : resp.rows : resp.command === `INSERT` || resp.command === `UPDATE` || resp.command === `DELETE` ? resp.rowCount : resp;
    }
    toPathForJson(jsonPath, builder, bindingsHolder) {
      return jsonPath.replace(/^(\$\.)/, ``).split(`.`).map((function(v$1) {
        return this.parameter(v$1, builder, bindingsHolder);
      }).bind(this)).join(`, `);
    }
  };
  Object.assign(Client_Redshift.prototype, { dialect: `redshift`, driverName: `pg-redshift` }), module2.exports = Client_Redshift;
}), require_dialects = __commonJSMin$1((exports$12) => {
  Object.defineProperty(exports$12, `__esModule`, { value: true });
  let { resolveClientNameWithAliases } = require_helpers$1(), dbNameToDialectLoader = Object.freeze({ "better-sqlite3": () => require_better_sqlite3(), cockroachdb: () => require_cockroachdb(), mssql: () => require_mssql(), mysql: () => require_mysql(), mysql2: () => require_mysql2(), oracle: () => require_oracle(), oracledb: () => require_oracledb(), pgnative: () => require_pgnative(), postgres: () => require_postgres(), redshift: () => require_redshift(), sqlite3: () => require_sqlite3() });
  function getDialectByNameOrAlias$1(clientName) {
    let resolvedClientName = resolveClientNameWithAliases(clientName), dialectLoader = dbNameToDialectLoader[resolvedClientName];
    if (!dialectLoader) throw Error(`Invalid clientName given: ${clientName}`);
    return dialectLoader();
  }
  exports$12.getDialectByNameOrAlias = getDialectByNameOrAlias$1;
}), require_config_resolver = __commonJSMin$1((exports$12, module2) => {
  let Client$1 = require_client(), { SUPPORTED_CLIENTS } = require_constants$3(), parseConnection = require_parse_connection(), { getDialectByNameOrAlias } = require_dialects();
  function resolveConfig$1(config) {
    let Dialect, resolvedConfig, parsedConfig = typeof config == `string` ? Object.assign(parseConnection(config), arguments[2]) : config;
    if (arguments.length === 0 || !parsedConfig.client && !parsedConfig.dialect) Dialect = Client$1;
    else if (typeof parsedConfig.client == `function`) Dialect = parsedConfig.client;
    else {
      let clientName = parsedConfig.client || parsedConfig.dialect;
      if (!SUPPORTED_CLIENTS.includes(clientName)) throw Error(`knex: Unknown configuration option 'client' value ${clientName}. Note that it is case-sensitive, check documentation for supported values.`);
      Dialect = getDialectByNameOrAlias(clientName);
    }
    return resolvedConfig = typeof parsedConfig.connection == `string` ? Object.assign({}, parsedConfig, { connection: parseConnection(parsedConfig.connection).connection }) : Object.assign({}, parsedConfig), { resolvedConfig, Dialect };
  }
  module2.exports = { resolveConfig: resolveConfig$1 };
});
init_make_knex();
var import_timeout = __toESM(require_timeout()), import_querybuilder = __toESM(require_querybuilder()), import_method_constants = __toESM(require_method_constants()), import_config_resolver = __toESM(require_config_resolver());
function knex$1(config, ...additional) {
  let { resolvedConfig, Dialect } = (0, import_config_resolver.resolveConfig)(config, ...additional), newKnex = makeKnex(new Dialect(resolvedConfig));
  return resolvedConfig.userParams && (newKnex.userParams = resolvedConfig.userParams), newKnex;
}
knex$1.Client = Client, knex$1.KnexTimeoutError = import_timeout.KnexTimeoutError, knex$1.QueryBuilder = { extend: function(methodName, fn$1) {
  import_querybuilder.default.extend(methodName, fn$1), import_method_constants.default.push(methodName);
} }, init_lib();
var import_ref = __toESM(require_ref$2()), import_cache = __toESM(require_cache()), import_trace = __toESM(require_trace()), import_common = __toESM(require_common$3()), import_errors = __toESM(require_errors$2()), import_extend = __toESM(require_extend$1()), import_compile = __toESM(require_compile()), import_schemas = __toESM(require_schemas()), import_manifest = __toESM(require_manifest()), import_template = __toESM(require_template()), import_any = __toESM(require_any()), import_date = __toESM(require_date()), import_link = __toESM(require_link()), import_array = __toESM(require_array()), import_number = __toESM(require_number()), import_object = __toESM(require_object()), import_string = __toESM(require_string$1()), import_symbol = __toESM(require_symbol()), import_binary = __toESM(require_binary()), import_boolean = __toESM(require_boolean()), import_function = __toESM(require_function()), import_alternatives = __toESM(require_alternatives()), RootFactory = class RootFactory2 {
  static $_cachedDescriptions = /* @__PURE__ */ new WeakMap();
  static types = { alternatives: import_alternatives.default, any: import_any.default, array: import_array.default, boolean: import_boolean.default, date: import_date.default, function: import_function.default, link: import_link.default, number: import_number.default, object: import_object.default, string: import_string.default, symbol: import_symbol.default, binary: import_binary.default };
  static aliases = { alt: `alternatives`, bool: `boolean`, func: `function` };
  static assertValue(value, schema$2, annotate, args$1) {
    let message = args$1[0] instanceof Error || typeof args$1[0] == `string` ? args$1[0] : null, options = message === null ? args$1[0] : args$1[1], result = schema$2.validate(value, import_common.preferences({ errors: { stack: true } }, options || {})), error = result.error;
    if (!error) return result.value;
    if (message instanceof Error) throw message;
    let display = annotate && typeof error.annotate == `function` ? error.annotate() : error.message;
    throw error instanceof import_errors.ValidationError || (error = (0, import_clone.default)(error)), error.message = message ? `${message} ${display}` : display, error;
  }
  static generate(root$11, schema$2, args$1) {
    (0, import_assert.default)(root$11, `Must be invoked on a Joi instance.`);
    let cloned = schema$2.clone();
    return cloned.$_root = root$11, !cloned._definition.args || !args$1.length ? cloned : cloned._definition.args(cloned, ...args$1);
  }
  static expandExtension(extension, joi) {
    if (typeof extension.type == `string`) return [extension];
    let extended = [];
    for (let type of joi._types) if (extension.type.test(type)) {
      let item = { ...extension };
      item.type = type, item.base = joi[type](), extended.push(item);
    }
    return extended;
  }
  static getMethods() {
    return { ValidationError: import_errors.ValidationError, version: import_common.version, cache: import_cache.provider, assert(value, schema$2, ...args$1) {
      RootFactory2.assertValue(value, schema$2, true, args$1);
    }, attempt(value, schema$2, ...args$1) {
      return RootFactory2.assertValue(value, schema$2, false, args$1);
    }, build(desc$1) {
      return (0, import_assert.default)(typeof import_manifest.build == `function`, `Manifest functionality disabled`), import_manifest.build(this, desc$1);
    }, checkPreferences(prefs) {
      import_common.checkPreferences(prefs);
    }, compile(schema$2, options) {
      return import_compile.compile(this, schema$2, options);
    }, defaults(modifier) {
      (0, import_assert.default)(typeof modifier == `function`, `modifier must be a function`);
      let joi = { ...this };
      for (let type of joi._types) {
        let schema$2 = modifier(joi[type]());
        (0, import_assert.default)(import_common.isSchema(schema$2), `modifier must return a valid schema object`), joi[type] = function(...args$1) {
          return RootFactory2.generate(this, schema$2, args$1);
        };
      }
      return joi;
    }, expression(...args$1) {
      return new import_template.default(...args$1);
    }, extend(...extensions) {
      import_common.verifyFlat(extensions, `extend`), (0, import_assert.default)(extensions.length, `You need to provide at least one extension`), this.assert(extensions, import_schemas.extensions);
      let joi = { ...this };
      joi._types = new Set(joi._types);
      for (let extension of extensions) {
        typeof extension == `function` && (extension = extension(joi)), this.assert(extension, import_schemas.extension);
        let expanded = RootFactory2.expandExtension(extension, joi);
        for (let item of expanded) {
          (0, import_assert.default)(joi[item.type] === void 0 || joi._types.has(item.type), `Cannot override name`, item.type);
          let base$3 = item.base || this.any(), schema$2 = import_extend.type(base$3, item);
          joi._types.add(item.type), joi[item.type] = function(...args$1) {
            return RootFactory2.generate(this, schema$2, args$1);
          };
        }
      }
      return joi;
    }, isError: import_errors.ValidationError.isError, isExpression: import_template.default.isTemplate, isRef: import_ref.isRef, isSchema: import_common.isSchema, in(...args$1) {
      return import_ref.in(...args$1);
    }, override: import_common.symbols.override, ref(...args$1) {
      return import_ref.create(...args$1);
    }, types() {
      let result = {};
      for (let type of this._types) result[type] = this[type]();
      for (let target in RootFactory2.aliases) result[target] = this[target]();
      return result;
    } };
  }
  static create(options = {}) {
    let instance = { _types: new Set(Object.keys(RootFactory2.types)) };
    for (let type of instance._types) instance[type] = function(...args$1) {
      (0, import_assert.default)(!args$1.length || [`alternatives`, `link`, `object`].includes(type), `The`, type, `type does not allow arguments`);
      let schema$2 = RootFactory2.types[type];
      if (options.schemaTypeModifiers?.length) {
        for (let modifier of options.schemaTypeModifiers) schema$2 = modifier(schema$2, this, args$1);
        if (type === `link` && args$1.length && schema$2.$_root) return schema$2;
      }
      return RootFactory2.generate(this, schema$2, args$1);
    };
    let shortcuts = [`allow`, `custom`, `disallow`, `equal`, `exist`, `forbidden`, `invalid`, `not`, `only`, `optional`, `options`, `prefs`, `preferences`, `required`, `strip`, `valid`, `when`];
    if (options.shortcutsModifiers?.length) for (let modifier of options.shortcutsModifiers) shortcuts = modifier(shortcuts);
    for (let method$1 of shortcuts) instance[method$1] = function(...args$1) {
      return this.any()[method$1](...args$1);
    };
    Object.assign(instance, RootFactory2.getMethods());
    for (let [alias, original] of Object.entries(RootFactory2.aliases)) instance[alias] = instance[original];
    return instance.x = instance.expression, import_trace.setup && import_trace.setup(instance), instance;
  }
}, import_messages$1 = __toESM(require_messages());
const knexMessages = { "knex.unique": `The {{#label}} has already been taken`, "knex.exists": `The selected {{#label}} is invalid`, "knex.missingConnection": `Database connection not provided for {{#label}}`, "knex.invalidTable": `Invalid table for {{#label}}`, "knex.invalidColumn": `Invalid column for {{#label}}`, "knex.internal": `Database validation error on {{#label}}` }, knexClientCache = /* @__PURE__ */ new WeakMap(), isReference$1 = (obj, root$11) => root$11.isRef(obj), resolveKnex = (connection) => {
  let db = knex$1;
  if (typeof connection != `function` && !(typeof connection == `object` && connection && !Array.isArray(connection))) throw Error(`Invalid Knex connection or QueryClientContract instance`);
  if (typeof connection.getReadClient == `function`) return connection.getReadClient();
  if (typeof connection.ref == `function`) return connection;
  if (typeof connection == `object` && connection && `client` in connection && `connection` in connection) {
    let cached = knexClientCache.get(connection);
    if (cached) return cached;
    let config = { client: connection.client, dialect: connection.dialect, connection: connection.connection, jsonbSupport: connection.jsonbSupport, version: connection.version, postProcessResponse: connection.postProcessResponse, wrapIdentifier: connection.wrapIdentifier, acquireConnectionTimeout: connection.acquireConnectionTimeout, useNullAsDefault: connection.useNullAsDefault, searchPath: connection.searchPath, fetchAsString: connection.fetchAsString, pool: connection.pool }, conn = db(config);
    return knexClientCache.set(connection, conn), conn;
  }
  throw Error(`Invalid Knex connection or QueryClientContract instance`);
}, resolveQueryBuilder = (connection, table$2) => {
  let conn = resolveKnex(connection);
  return { client: conn, query: conn.table(table$2) };
}, getMergableMessages$1 = (schema$2) => {
  if (`_definition` in schema$2) {
    let def = schema$2._definition;
    if (`messages` in def && def.messages) return typeof def.messages == `string` ? {} : def.messages;
  }
  return {};
};
function setKnexConnection(connection) {
  this.$_terms !== void 0 && (`keys` in this.$_terms && this.$_terms.keys !== null && this.$_terms.keys.forEach((item, index$2) => {
    this.$_terms.keys[index$2].schema = setKnexConnection.call(item.schema, connection);
  }), `matches` in this.$_terms && this.$_terms.matches !== null && (this.$_terms.matches = this.$_terms.matches.map((match$2) => ({ ...match$2, schema: match$2.schema ? setKnexConnection.call(match$2.schema, connection) : void 0, switch: match$2.switch ? match$2.switch.map((branch) => ({ is: branch.is ? setKnexConnection.call(branch.is, connection) : void 0, then: branch.then ? setKnexConnection.call(branch.then, connection) : void 0, else: branch.else ? setKnexConnection.call(branch.else, connection) : void 0 })) : void 0 }))), `_exclusions` in this.$_terms && this.$_terms._exclusions !== null && (this.$_terms._exclusions = this.$_terms._exclusions.map((exclusion) => setKnexConnection.call(exclusion, connection))), `_inclusions` in this.$_terms && this.$_terms._inclusions !== null && (this.$_terms._inclusions = this.$_terms._inclusions.map((inclusion) => setKnexConnection.call(inclusion, connection))), `_requireds` in this.$_terms && this.$_terms._requireds !== null && (this.$_terms._requireds = this.$_terms._requireds.map((required) => setKnexConnection.call(required, connection))), `items` in this.$_terms && this.$_terms.items !== null && (this.$_terms.items = this.$_terms.items.map((item) => setKnexConnection.call(item, connection))));
  let toSet = this.$_knex || this.$_getFlag(`knexConnection`) || connection;
  return this.$_knex = toSet, this.$_setFlag(`knexConnection`, toSet);
}
function findKnexConnection() {
  if (this.$_knex) return this.$_knex;
  let connection = this.$_getFlag?.(`knexConnection`);
  if (connection) return connection;
  let current = this;
  for (; current && `$_super` in current && current.$_super; ) if (current = current.$_super, connection = current.$_getFlag?.(`knexConnection`), connection) return connection;
}
const knex = (schema$2, root$11, args$1) => {
  let prototype = Object.getPrototypeOf(schema$2), originalMessages = getMergableMessages$1(schema$2), mergedMessages = import_messages$1.merge(originalMessages, knexMessages);
  return prototype._definition.messages = mergedMessages, prototype._definition.flags.knexConnection = { default: void 0, setter: `knex` }, prototype._definition.flags.knexFunctionArgs = { default: {}, setter: `setKnexFunctionArgs` }, prototype.setKnexFunctionArgs ||= function(knexFunctionArgs) {
    return this.$_setFlag(`knexFunctionArgs`, knexFunctionArgs);
  }, prototype.setArgsForFnCall ||= function(id, knexFunctionArgs) {
    let currentArgs = this.$_getFlag(`knexFunctionArgs`) || {};
    return knexFunctionArgs = { ...currentArgs, [id]: knexFunctionArgs }, this.$_setFlag(`knexFunctionArgs`, knexFunctionArgs);
  }, prototype.getArgsForFnCall ||= function(id) {
    return this.$_getFlag(`knexFunctionArgs`)[id];
  }, prototype.knex ||= function(connection) {
    return setKnexConnection.call(this, connection);
  }, prototype.db ||= function(connection) {
    return setKnexConnection.call(this, connection);
  }, prototype.uniqueInDb ||= function(table$2, column, options) {
    let opts = { caseInsensitive: false, filter: () => {
    }, ...options }, returnable = this.setArgsForFnCall(`uniqueInDb`, { table: table$2, column, options: opts }), connection = findKnexConnection.call(returnable);
    return returnable.external(async (value, helpers$8) => {
      let { prefs, state, error, schema: localSchema } = helpers$8;
      if (!connection && localSchema._flags && (connection = localSchema._flags.knexConnection), !connection) return error(`knex.missingConnection`, { value });
      let { table: tableArg, column: columnArg, options: optsArg } = localSchema.getArgsForFnCall(`uniqueInDb`), resolvedTable = isReference$1(tableArg, localSchema.$_root) ? tableArg.resolve(value, state, prefs) : tableArg, resolvedColumn = isReference$1(columnArg, localSchema.$_root) ? columnArg.resolve(value, state, prefs) : columnArg;
      if (!resolvedTable || typeof resolvedTable != `string`) return error(`knex.invalidTable`, { value, table: resolvedTable, column: resolvedColumn });
      if (!resolvedColumn || typeof resolvedColumn != `string`) return error(`knex.invalidColumn`, { value, table: resolvedTable, column: resolvedColumn });
      if (value == null) return value;
      let { client, query } = resolveQueryBuilder(connection, resolvedTable);
      try {
        if (query.select(resolvedColumn).limit(1), optsArg.caseInsensitive ? query.whereRaw(`lower(${resolvedColumn}) = ?`, [client.raw(`lower(?)`, [value])]) : query.where(resolvedColumn, value), optsArg.filter) {
          let { error: errorFn, warn: warnFn, message: messageFn, ...safeHelpers } = helpers$8;
          await optsArg.filter(query, value, resolvedColumn, safeHelpers);
        }
        let row = await query.first();
        return row ? error(`knex.unique`, { value, table: resolvedTable, column: resolvedColumn }) : value;
      } catch (err$1) {
        return error(`knex.internal`, { value, table: resolvedTable, column: resolvedColumn, error: err$1 });
      }
    }, `uniqueInDb`);
  }, prototype.existsInDb ||= function(table$2, column, options) {
    let opts = { caseInsensitive: false, filter: () => {
    }, ...options }, returnable = this.setArgsForFnCall(`existsInDb`, { table: table$2, column, options: opts }), connection = findKnexConnection.call(returnable);
    return returnable.external(async (value, helpers$8) => {
      let { prefs, state, error, schema: localSchema } = helpers$8;
      if (!connection && localSchema._flags && (connection = localSchema._flags.knexConnection), !connection) return error(`knex.missingConnection`, { value });
      let { table: tableArg, column: columnArg, options: optsArg } = localSchema.getArgsForFnCall(`existsInDb`), resolvedTable = isReference$1(tableArg, localSchema.$_root) ? tableArg.resolve(value, state, prefs) : tableArg, resolvedColumn = isReference$1(columnArg, localSchema.$_root) ? columnArg.resolve(value, state, prefs) : columnArg;
      if (!resolvedTable || typeof resolvedTable != `string`) return error(`knex.invalidTable`, { value, table: resolvedTable, column: resolvedColumn });
      if (!resolvedColumn || typeof resolvedColumn != `string`) return error(`knex.invalidColumn`, { value, table: resolvedTable, column: resolvedColumn });
      if (value == null) return value;
      let { client, query } = resolveQueryBuilder(connection, resolvedTable);
      try {
        if (query.select(resolvedColumn).limit(1), optsArg.caseInsensitive ? query.whereRaw(`lower(${resolvedColumn}) = ?`, [client.raw(`lower(?)`, [value])]) : query.where(resolvedColumn, value), optsArg.filter) {
          let { error: errorFn, warn: warnFn, message: messageFn, ...safeHelpers } = helpers$8;
          await optsArg.filter(query, value, resolvedColumn, safeHelpers);
        }
        let row = await query.first();
        return row ? value : error(`knex.exists`, { value, table: resolvedTable, column: resolvedColumn });
      } catch (err$1) {
        return error(`knex.internal`, { value, table: resolvedTable, column: resolvedColumn, error: err$1 });
      }
    }, `existsInDb`);
  }, RootFactory.generate(root$11, schema$2, args$1);
};
var import_messages = __toESM(require_messages());
const fqdnMessages = { "string.fqdn": `{{#label}} must be a valid fully qualified domain name` }, getMergableMessages = (schema$2) => {
  if (`_definition` in schema$2) {
    let def = schema$2._definition;
    if (`messages` in def && def.messages) return typeof def.messages == `string` ? {} : def.messages;
  }
  return {};
}, fqdn = (schema$2, root$11, args$1) => {
  if (schema$2.type !== `string`) return schema$2;
  let prototype = Object.getPrototypeOf(schema$2), originalMessages = getMergableMessages(schema$2), mergedMessages = import_messages.merge(originalMessages, fqdnMessages);
  return prototype._definition.messages = mergedMessages, prototype._definition.rules.fqdn = { method() {
    return this.addRule(`fqdn`);
  }, validate(value, helpers$8) {
    if (typeof value != `string` || value.trim().length === 0) return;
    if (value.includes(`..`)) return helpers$8.error(`string.fqdn`);
    let labels = value.split(`.`);
    for (let label of labels) if (label.length === 0 || label.length > 63 || label.startsWith(`-`) || label.endsWith(`-`) || !/^[a-zA-Z0-9-]+$/.test(label)) return helpers$8.error(`string.fqdn`);
    return value;
  } }, prototype.fqdn ||= function() {
    return this.$_addRule({ name: `fqdn` });
  }, RootFactory.generate(root$11, schema$2, args$1);
};
var De = (t$7) => {
  throw TypeError(t$7);
}, Ne = (t$7, o$2, r$2) => o$2.has(t$7) || De(`Cannot ` + r$2), M = (t$7, o$2, r$2) => (Ne(t$7, o$2, `read from private field`), r$2 ? r$2.call(t$7) : o$2.get(t$7)), ee = (t$7, o$2, r$2) => o$2.has(t$7) ? De(`Cannot add the same private member more than once`) : o$2 instanceof WeakSet ? o$2.add(t$7) : o$2.set(t$7, r$2), X = (t$7, o$2, r$2, u) => (Ne(t$7, o$2, `write to private field`), u ? u.call(t$7, r$2) : o$2.set(t$7, r$2), r$2), ne = (t$7, o$2, r$2) => (Ne(t$7, o$2, `access private method`), r$2), LuxonError$1 = class extends Error {
}, ZoneIsAbstractError$1 = class extends LuxonError$1 {
  constructor() {
    super(`Zone is an abstract class`);
  }
};
var Zone$1 = class {
  get type() {
    throw new ZoneIsAbstractError$1();
  }
  get name() {
    throw new ZoneIsAbstractError$1();
  }
  get ianaName() {
    return this.name;
  }
  get isUniversal() {
    throw new ZoneIsAbstractError$1();
  }
  offsetName(o$2, r$2) {
    throw new ZoneIsAbstractError$1();
  }
  formatOffset(o$2, r$2) {
    throw new ZoneIsAbstractError$1();
  }
  offset(o$2) {
    throw new ZoneIsAbstractError$1();
  }
  equals(o$2) {
    throw new ZoneIsAbstractError$1();
  }
  get isValid() {
    throw new ZoneIsAbstractError$1();
  }
};
const dtfCache$1 = /* @__PURE__ */ new Map();
function makeDTF$1(t$7) {
  let o$2 = dtfCache$1.get(t$7);
  return o$2 === void 0 && (o$2 = new Intl.DateTimeFormat(`en-US`, { hour12: false, timeZone: t$7, year: `numeric`, month: `2-digit`, day: `2-digit`, hour: `2-digit`, minute: `2-digit`, second: `2-digit`, era: `short` }), dtfCache$1.set(t$7, o$2)), o$2;
}
const typeToPos$1 = { year: 0, month: 1, day: 2, era: 3, hour: 4, minute: 5, second: 6 };
function hackyOffset$1(t$7, o$2) {
  let r$2 = t$7.format(o$2).replace(/\u200E/g, ``), u = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(r$2), [, h$1, m$3, y$1, S, _, C, O] = u;
  return [y$1, h$1, m$3, S, _, C, O];
}
function partsOffset$1(t$7, o$2) {
  let r$2 = t$7.formatToParts(o$2), u = [];
  for (let h$1 = 0; h$1 < r$2.length; h$1++) {
    let { type: m$3, value: y$1 } = r$2[h$1], S = typeToPos$1[m$3];
    m$3 === `era` ? u[S] = y$1 : isUndefined$1(S) || (u[S] = parseInt(y$1, 10));
  }
  return u;
}
const ianaZoneCache$1 = /* @__PURE__ */ new Map();
var IANAZone$1 = class IANAZone$12 extends Zone$1 {
  static create(o$2) {
    let r$2 = ianaZoneCache$1.get(o$2);
    return r$2 === void 0 && ianaZoneCache$1.set(o$2, r$2 = new IANAZone$12(o$2)), r$2;
  }
  static resetCache() {
    ianaZoneCache$1.clear(), dtfCache$1.clear();
  }
  static isValidSpecifier(o$2) {
    return this.isValidZone(o$2);
  }
  static isValidZone(o$2) {
    if (!o$2) return false;
    try {
      return new Intl.DateTimeFormat(`en-US`, { timeZone: o$2 }).format(), true;
    } catch {
      return false;
    }
  }
  constructor(o$2) {
    super(), this.zoneName = o$2, this.valid = IANAZone$12.isValidZone(o$2);
  }
  get type() {
    return `iana`;
  }
  get name() {
    return this.zoneName;
  }
  get isUniversal() {
    return false;
  }
  offsetName(o$2, { format: r$2, locale: u }) {
    return parseZoneInfo$1(o$2, r$2, u, this.name);
  }
  formatOffset(o$2, r$2) {
    return formatOffset$1(this.offset(o$2), r$2);
  }
  offset(o$2) {
    if (!this.valid) return NaN;
    let r$2 = new Date(o$2);
    if (isNaN(r$2)) return NaN;
    let u = makeDTF$1(this.name), [h$1, m$3, y$1, S, _, C, O] = u.formatToParts ? partsOffset$1(u, r$2) : hackyOffset$1(u, r$2);
    S === `BC` && (h$1 = -Math.abs(h$1) + 1);
    let R$2 = objToLocalTS$1({ year: h$1, month: m$3, day: y$1, hour: _ === 24 ? 0 : _, minute: C, second: O, millisecond: 0 }), U = +r$2, F = U % 1e3;
    return U -= F >= 0 ? F : 1e3 + F, (R$2 - U) / (60 * 1e3);
  }
  equals(o$2) {
    return o$2.type === `iana` && o$2.name === this.name;
  }
  get isValid() {
    return this.valid;
  }
};
let singleton$2 = null;
var FixedOffsetZone$1 = class FixedOffsetZone$12 extends Zone$1 {
  static get utcInstance() {
    return singleton$2 === null && (singleton$2 = new FixedOffsetZone$12(0)), singleton$2;
  }
  static instance(o$2) {
    return o$2 === 0 ? FixedOffsetZone$12.utcInstance : new FixedOffsetZone$12(o$2);
  }
  static parseSpecifier(o$2) {
    if (o$2) {
      let r$2 = o$2.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r$2) return new FixedOffsetZone$12(signedOffset$1(r$2[1], r$2[2]));
    }
    return null;
  }
  constructor(o$2) {
    super(), this.fixed = o$2;
  }
  get type() {
    return `fixed`;
  }
  get name() {
    return this.fixed === 0 ? `UTC` : `UTC${formatOffset$1(this.fixed, `narrow`)}`;
  }
  get ianaName() {
    return this.fixed === 0 ? `Etc/UTC` : `Etc/GMT${formatOffset$1(-this.fixed, `narrow`)}`;
  }
  offsetName() {
    return this.name;
  }
  formatOffset(o$2, r$2) {
    return formatOffset$1(this.fixed, r$2);
  }
  get isUniversal() {
    return true;
  }
  offset() {
    return this.fixed;
  }
  equals(o$2) {
    return o$2.type === `fixed` && o$2.fixed === this.fixed;
  }
  get isValid() {
    return true;
  }
};
function isUndefined$1(t$7) {
  return typeof t$7 > `u`;
}
function padStart$1(t$7, o$2 = 2) {
  let r$2 = t$7 < 0, u;
  return u = r$2 ? `-` + (`` + -t$7).padStart(o$2, `0`) : (`` + t$7).padStart(o$2, `0`), u;
}
function parseInteger$1(t$7) {
  if (!(isUndefined$1(t$7) || t$7 === null || t$7 === ``)) return parseInt(t$7, 10);
}
function parseMillis$1(t$7) {
  if (!(isUndefined$1(t$7) || t$7 === null || t$7 === ``)) {
    let o$2 = parseFloat(`0.` + t$7) * 1e3;
    return Math.floor(o$2);
  }
}
function objToLocalTS$1(t$7) {
  let o$2 = Date.UTC(t$7.year, t$7.month - 1, t$7.day, t$7.hour, t$7.minute, t$7.second, t$7.millisecond);
  return t$7.year < 100 && t$7.year >= 0 && (o$2 = new Date(o$2), o$2.setUTCFullYear(t$7.year, t$7.month - 1, t$7.day)), +o$2;
}
function parseZoneInfo$1(t$7, o$2, r$2, u = null) {
  let h$1 = new Date(t$7), m$3 = { hourCycle: `h23`, year: `numeric`, month: `2-digit`, day: `2-digit`, hour: `2-digit`, minute: `2-digit` };
  u && (m$3.timeZone = u);
  let y$1 = { timeZoneName: o$2, ...m$3 }, S = new Intl.DateTimeFormat(r$2, y$1).formatToParts(h$1).find((_) => _.type.toLowerCase() === `timezonename`);
  return S ? S.value : null;
}
function signedOffset$1(t$7, o$2) {
  let r$2 = parseInt(t$7, 10);
  Number.isNaN(r$2) && (r$2 = 0);
  let u = parseInt(o$2, 10) || 0, h$1 = r$2 < 0 || Object.is(r$2, -0) ? -u : u;
  return r$2 * 60 + h$1;
}
function formatOffset$1(t$7, o$2) {
  let r$2 = Math.trunc(Math.abs(t$7 / 60)), u = Math.trunc(Math.abs(t$7 % 60)), h$1 = t$7 >= 0 ? `+` : `-`;
  switch (o$2) {
    case `short`:
      return `${h$1}${padStart$1(r$2, 2)}:${padStart$1(u, 2)}`;
    case `narrow`:
      return `${h$1}${r$2}${u > 0 ? `:${u}` : ``}`;
    case `techie`:
      return `${h$1}${padStart$1(r$2, 2)}${padStart$1(u, 2)}`;
    default:
      throw RangeError(`Value format ${o$2} is out of range for property format`);
  }
}
const ianaRegex$1 = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function combineRegexes$1(...t$7) {
  let o$2 = t$7.reduce((r$2, u) => r$2 + u.source, ``);
  return RegExp(`^${o$2}$`);
}
function combineExtractors$1(...t$7) {
  return (o$2) => t$7.reduce(([r$2, u, h$1], m$3) => {
    let [y$1, S, _] = m$3(o$2, h$1);
    return [{ ...r$2, ...y$1 }, S || u, _];
  }, [{}, null, 1]).slice(0, 2);
}
function simpleParse$1(...t$7) {
  return (o$2, r$2) => {
    let u = {}, h$1;
    for (h$1 = 0; h$1 < t$7.length; h$1++) u[t$7[h$1]] = parseInteger$1(o$2[r$2 + h$1]);
    return [u, null, r$2 + h$1];
  };
}
const offsetRegex$1 = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/, isoExtendedZone$1 = `(?:${offsetRegex$1.source}?(?:\\[(${ianaRegex$1.source})\\])?)?`, isoTimeBaseRegex$1 = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, isoTimeRegex$1 = RegExp(`${isoTimeBaseRegex$1.source}${isoExtendedZone$1}`), isoTimeExtensionRegex$1 = RegExp(`(?:T${isoTimeRegex$1.source})?`), isoYmdRegex$1 = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, isoWeekRegex$1 = /(\d{4})-?W(\d\d)(?:-?(\d))?/, isoOrdinalRegex$1 = /(\d{4})-?(\d{3})/, extractISOWeekData$1 = simpleParse$1(`weekYear`, `weekNumber`, `weekDay`), extractISOOrdinalData$1 = simpleParse$1(`year`, `ordinal`), sqlYmdRegex$1 = /(\d{4})-(\d\d)-(\d\d)/, sqlTimeRegex$1 = RegExp(`${isoTimeBaseRegex$1.source} ?(?:${offsetRegex$1.source}|(${ianaRegex$1.source}))?`), sqlTimeExtensionRegex$1 = RegExp(`(?: ${sqlTimeRegex$1.source})?`);
function int$1(t$7, o$2, r$2) {
  let u = t$7[o$2];
  return isUndefined$1(u) ? r$2 : parseInteger$1(u);
}
function extractISOYmd$1(t$7, o$2) {
  return [{ year: int$1(t$7, o$2), month: int$1(t$7, o$2 + 1, 1), day: int$1(t$7, o$2 + 2, 1) }, null, o$2 + 3];
}
function extractISOTime$1(t$7, o$2) {
  return [{ hours: int$1(t$7, o$2, 0), minutes: int$1(t$7, o$2 + 1, 0), seconds: int$1(t$7, o$2 + 2, 0), milliseconds: parseMillis$1(t$7[o$2 + 3]) }, null, o$2 + 4];
}
function extractISOOffset$1(t$7, o$2) {
  let r$2 = !t$7[o$2] && !t$7[o$2 + 1], u = signedOffset$1(t$7[o$2 + 1], t$7[o$2 + 2]), h$1 = r$2 ? null : FixedOffsetZone$1.instance(u);
  return [{}, h$1, o$2 + 3];
}
function extractIANAZone$1(t$7, o$2) {
  let r$2 = t$7[o$2] ? IANAZone$1.create(t$7[o$2]) : null;
  return [{}, r$2, o$2 + 1];
}
combineRegexes$1(isoYmdRegex$1, isoTimeExtensionRegex$1);
combineRegexes$1(isoWeekRegex$1, isoTimeExtensionRegex$1);
combineRegexes$1(isoOrdinalRegex$1, isoTimeExtensionRegex$1);
combineRegexes$1(isoTimeRegex$1);
combineExtractors$1(extractISOYmd$1, extractISOTime$1, extractISOOffset$1, extractIANAZone$1);
combineExtractors$1(extractISOWeekData$1, extractISOTime$1, extractISOOffset$1, extractIANAZone$1);
combineExtractors$1(extractISOOrdinalData$1, extractISOTime$1, extractISOOffset$1, extractIANAZone$1);
combineExtractors$1(extractISOTime$1, extractISOOffset$1, extractIANAZone$1);
combineExtractors$1(extractISOTime$1);
combineRegexes$1(sqlYmdRegex$1, sqlTimeExtensionRegex$1);
combineRegexes$1(sqlTimeRegex$1);
combineExtractors$1(extractISOTime$1, extractISOOffset$1, extractIANAZone$1);
const countries$1 = Object.freeze(/* @__PURE__ */ new Map([[`AD`, `Andorra`], [`AE`, `United Arab Emirates`], [`AF`, `Afghanistan`], [`AG`, `Antigua and Barbuda`], [`AI`, `Anguilla`], [`AL`, `Albania`], [`AM`, `Armenia`], [`AO`, `Angola`], [`AQ`, `Antarctica`], [`AR`, `Argentina`], [`AS`, `American Samoa`], [`AT`, `Austria`], [`AU`, `Australia`], [`AW`, `Aruba`], [`AX`, `Aland Islands`], [`AZ`, `Azerbaijan`], [`BA`, `Bosnia and Herzegovina`], [`BB`, `Barbados`], [`BD`, `Bangladesh`], [`BE`, `Belgium`], [`BF`, `Burkina Faso`], [`BG`, `Bulgaria`], [`BH`, `Bahrain`], [`BI`, `Burundi`], [`BJ`, `Benin`], [`BL`, `Saint Barthelemy`], [`BM`, `Bermuda`], [`BN`, `Brunei`], [`BO`, `Bolivia`], [`BQ`, `Bonaire, Saint Eustatius and Saba`], [`BR`, `Brazil`], [`BS`, `Bahamas`], [`BT`, `Bhutan`], [`BV`, `Bouvet Island`], [`BW`, `Botswana`], [`BY`, `Belarus`], [`BZ`, `Belize`], [`CA`, `Canada`], [`CC`, `Cocos Islands`], [`CD`, `Democratic Republic of the Congo`], [`CF`, `Central African Republic`], [`CG`, `Republic of the Congo`], [`CH`, `Switzerland`], [`CI`, `Ivory Coast`], [`CK`, `Cook Islands`], [`CL`, `Chile`], [`CM`, `Cameroon`], [`CN`, `China`], [`CO`, `Colombia`], [`CR`, `Costa Rica`], [`CU`, `Cuba`], [`CV`, `Cape Verde`], [`CW`, `Curacao`], [`CX`, `Christmas Island`], [`CY`, `Cyprus`], [`CZ`, `Czech Republic`], [`DE`, `Germany`], [`DJ`, `Djibouti`], [`DK`, `Denmark`], [`DM`, `Dominica`], [`DO`, `Dominican Republic`], [`DZ`, `Algeria`], [`EC`, `Ecuador`], [`EE`, `Estonia`], [`EG`, `Egypt`], [`EH`, `Western Sahara`], [`ER`, `Eritrea`], [`ES`, `Spain`], [`ET`, `Ethiopia`], [`FI`, `Finland`], [`FJ`, `Fiji`], [`FK`, `Falkland Islands`], [`FM`, `Micronesia`], [`FO`, `Faroe Islands`], [`FR`, `France`], [`GA`, `Gabon`], [`GB`, `United Kingdom`], [`GD`, `Grenada`], [`GE`, `Georgia`], [`GF`, `French Guiana`], [`GG`, `Guernsey`], [`GH`, `Ghana`], [`GI`, `Gibraltar`], [`GL`, `Greenland`], [`GM`, `Gambia`], [`GN`, `Guinea`], [`GP`, `Guadeloupe`], [`GQ`, `Equatorial Guinea`], [`GR`, `Greece`], [`GS`, `South Georgia and the South Sandwich Islands`], [`GT`, `Guatemala`], [`GU`, `Guam`], [`GW`, `Guinea-Bissau`], [`GY`, `Guyana`], [`HK`, `Hong Kong`], [`HM`, `Heard Island and McDonald Islands`], [`HN`, `Honduras`], [`HR`, `Croatia`], [`HT`, `Haiti`], [`HU`, `Hungary`], [`ID`, `Indonesia`], [`IE`, `Ireland`], [`IL`, `Israel`], [`IM`, `Isle of Man`], [`IN`, `India`], [`IO`, `British Indian Ocean Territory`], [`IQ`, `Iraq`], [`IR`, `Iran`], [`IS`, `Iceland`], [`IT`, `Italy`], [`JE`, `Jersey`], [`JM`, `Jamaica`], [`JO`, `Jordan`], [`JP`, `Japan`], [`KE`, `Kenya`], [`KG`, `Kyrgyzstan`], [`KH`, `Cambodia`], [`KI`, `Kiribati`], [`KM`, `Comoros`], [`KN`, `Saint Kitts and Nevis`], [`KP`, `North Korea`], [`KR`, `South Korea`], [`KW`, `Kuwait`], [`KY`, `Cayman Islands`], [`KZ`, `Kazakhstan`], [`LA`, `Laos`], [`LB`, `Lebanon`], [`LC`, `Saint Lucia`], [`LI`, `Liechtenstein`], [`LK`, `Sri Lanka`], [`LR`, `Liberia`], [`LS`, `Lesotho`], [`LT`, `Lithuania`], [`LU`, `Luxembourg`], [`LV`, `Latvia`], [`LY`, `Libya`], [`MA`, `Morocco`], [`MC`, `Monaco`], [`MD`, `Moldova`], [`ME`, `Montenegro`], [`MF`, `Saint Martin`], [`MG`, `Madagascar`], [`MH`, `Marshall Islands`], [`MK`, `Macedonia`], [`ML`, `Mali`], [`MM`, `Myanmar`], [`MN`, `Mongolia`], [`MO`, `Macao`], [`MP`, `Northern Mariana Islands`], [`MQ`, `Martinique`], [`MR`, `Mauritania`], [`MS`, `Montserrat`], [`MT`, `Malta`], [`MU`, `Mauritius`], [`MV`, `Maldives`], [`MW`, `Malawi`], [`MX`, `Mexico`], [`MY`, `Malaysia`], [`MZ`, `Mozambique`], [`NA`, `Namibia`], [`NC`, `New Caledonia`], [`NE`, `Niger`], [`NF`, `Norfolk Island`], [`NG`, `Nigeria`], [`NI`, `Nicaragua`], [`NL`, `Netherlands`], [`NO`, `Norway`], [`NP`, `Nepal`], [`NR`, `Nauru`], [`NU`, `Niue`], [`NZ`, `New Zealand`], [`OM`, `Oman`], [`PA`, `Panama`], [`PE`, `Peru`], [`PF`, `French Polynesia`], [`PG`, `Papua New Guinea`], [`PH`, `Philippines`], [`PK`, `Pakistan`], [`PL`, `Poland`], [`PM`, `Saint Pierre and Miquelon`], [`PN`, `Pitcairn`], [`PR`, `Puerto Rico`], [`PS`, `Palestinian Territory`], [`PT`, `Portugal`], [`PW`, `Palau`], [`PY`, `Paraguay`], [`QA`, `Qatar`], [`RE`, `Reunion`], [`RO`, `Romania`], [`RS`, `Serbia`], [`RU`, `Russia`], [`RW`, `Rwanda`], [`SA`, `Saudi Arabia`], [`SB`, `Solomon Islands`], [`SC`, `Seychelles`], [`SD`, `Sudan`], [`SE`, `Sweden`], [`SG`, `Singapore`], [`SH`, `Saint Helena`], [`SI`, `Slovenia`], [`SJ`, `Svalbard and Jan Mayen`], [`SK`, `Slovakia`], [`SL`, `Sierra Leone`], [`SM`, `San Marino`], [`SN`, `Senegal`], [`SO`, `Somalia`], [`SR`, `Suriname`], [`SS`, `South Sudan`], [`ST`, `Sao Tome and Principe`], [`SV`, `El Salvador`], [`SX`, `Sint Maarten`], [`SY`, `Syria`], [`SZ`, `Swaziland`], [`TC`, `Turks and Caicos Islands`], [`TD`, `Chad`], [`TF`, `French Southern Territories`], [`TG`, `Togo`], [`TH`, `Thailand`], [`TJ`, `Tajikistan`], [`TK`, `Tokelau`], [`TL`, `East Timor`], [`TM`, `Turkmenistan`], [`TN`, `Tunisia`], [`TO`, `Tonga`], [`TR`, `Turkey`], [`TT`, `Trinidad and Tobago`], [`TV`, `Tuvalu`], [`TW`, `Taiwan`], [`TZ`, `Tanzania`], [`UA`, `Ukraine`], [`UG`, `Uganda`], [`UM`, `United States Minor Outlying Islands`], [`US`, `United States`], [`UY`, `Uruguay`], [`UZ`, `Uzbekistan`], [`VA`, `Vatican`], [`VC`, `Saint Vincent and the Grenadines`], [`VE`, `Venezuela`], [`VG`, `British Virgin Islands`], [`VI`, `U.S. Virgin Islands`], [`VN`, `Vietnam`], [`VU`, `Vanuatu`], [`WF`, `Wallis and Futuna`], [`WS`, `Samoa`], [`XK`, `Kosovo`], [`YE`, `Yemen`], [`YT`, `Mayotte`], [`ZA`, `South Africa`], [`ZM`, `Zambia`], [`ZW`, `Zimbabwe`]])), timezones$1 = Object.freeze(/* @__PURE__ */ new Map([[`AD`, `Europe/Andorra`], [`AE`, `Asia/Dubai`], [`AF`, `Asia/Kabul`], [`AG`, `America/Antigua`], [`AI`, `America/Anguilla`], [`AL`, `Europe/Tirane`], [`AM`, `Asia/Yerevan`], [`AO`, `Africa/Luanda`], [`AQ`, `Antarctica/Casey`], [`AR`, `America/Argentina/Buenos_Aires`], [`AS`, `Pacific/Pago_Pago`], [`AT`, `Europe/Vienna`], [`AU`, `Australia/Sydney`], [`AW`, `America/Aruba`], [`AX`, `Europe/Mariehamn`], [`AZ`, `Asia/Baku`], [`BA`, `Europe/Sarajevo`], [`BB`, `America/Barbados`], [`BD`, `Asia/Dhaka`], [`BE`, `Europe/Brussels`], [`BF`, `Africa/Ouagadougou`], [`BG`, `Europe/Sofia`], [`BH`, `Asia/Bahrain`], [`BI`, `Africa/Bujumbura`], [`BJ`, `Africa/Porto-Novo`], [`BL`, `America/St_Barthelemy`], [`BM`, `Atlantic/Bermuda`], [`BN`, `Asia/Brunei`], [`BO`, `America/La_Paz`], [`BQ`, `America/Kralendijk`], [`BR`, `America/Sao_Paulo`], [`BS`, `America/Nassau`], [`BT`, `Asia/Thimphu`], [`BW`, `Africa/Gaborone`], [`BY`, `Europe/Minsk`], [`BZ`, `America/Belize`], [`CA`, `America/Toronto`], [`CC`, `Indian/Cocos`], [`CD`, `Africa/Kinshasa`], [`CF`, `Africa/Bangui`], [`CG`, `Africa/Brazzaville`], [`CH`, `Europe/Zurich`], [`CI`, `Africa/Abidjan`], [`CK`, `Pacific/Rarotonga`], [`CL`, `America/Santiago`], [`CM`, `Africa/Douala`], [`CN`, `Asia/Shanghai`], [`CO`, `America/Bogota`], [`CR`, `America/Costa_Rica`], [`CU`, `America/Havana`], [`CV`, `Atlantic/Cape_Verde`], [`CW`, `America/Curacao`], [`CX`, `Indian/Christmas`], [`CY`, `Asia/Nicosia`], [`CZ`, `Europe/Prague`], [`DE`, `Europe/Berlin`], [`DJ`, `Africa/Djibouti`], [`DK`, `Europe/Copenhagen`], [`DM`, `America/Dominica`], [`DO`, `America/Santo_Domingo`], [`DZ`, `Africa/Algiers`], [`EC`, `America/Guayaquil`], [`EE`, `Europe/Tallinn`], [`EG`, `Africa/Cairo`], [`EH`, `Africa/El_Aaiun`], [`ER`, `Africa/Asmara`], [`ES`, `Europe/Madrid`], [`ET`, `Africa/Addis_Ababa`], [`FI`, `Europe/Helsinki`], [`FJ`, `Pacific/Fiji`], [`FK`, `Atlantic/Stanley`], [`FM`, `Pacific/Pohnpei`], [`FO`, `Atlantic/Faroe`], [`FR`, `Europe/Paris`], [`GA`, `Africa/Libreville`], [`GB`, `Europe/London`], [`GD`, `America/Grenada`], [`GE`, `Asia/Tbilisi`], [`GF`, `America/Cayenne`], [`GG`, `Europe/Guernsey`], [`GH`, `Africa/Accra`], [`GI`, `Europe/Gibraltar`], [`GL`, `America/Godthab`], [`GM`, `Africa/Banjul`], [`GN`, `Africa/Conakry`], [`GP`, `America/Guadeloupe`], [`GQ`, `Africa/Malabo`], [`GR`, `Europe/Athens`], [`GS`, `Atlantic/South_Georgia`], [`GT`, `America/Guatemala`], [`GU`, `Pacific/Guam`], [`GW`, `Africa/Bissau`], [`GY`, `America/Guyana`], [`HK`, `Asia/Hong_Kong`], [`HN`, `America/Tegucigalpa`], [`HR`, `Europe/Zagreb`], [`HT`, `America/Port-au-Prince`], [`HU`, `Europe/Budapest`], [`ID`, `Asia/Jakarta`], [`IE`, `Europe/Dublin`], [`IL`, `Asia/Jerusalem`], [`IM`, `Europe/Isle_of_Man`], [`IN`, `Asia/Kolkata`], [`IO`, `Indian/Chagos`], [`IQ`, `Asia/Baghdad`], [`IR`, `Asia/Tehran`], [`IS`, `Atlantic/Reykjavik`], [`IT`, `Europe/Rome`], [`JE`, `Europe/Jersey`], [`JM`, `America/Jamaica`], [`JO`, `Asia/Amman`], [`JP`, `Asia/Tokyo`], [`KE`, `Africa/Nairobi`], [`KG`, `Asia/Bishkek`], [`KH`, `Asia/Phnom_Penh`], [`KI`, `Pacific/Tarawa`], [`KM`, `Indian/Comoro`], [`KN`, `America/St_Kitts`], [`KP`, `Asia/Pyongyang`], [`KR`, `Asia/Seoul`], [`KW`, `Asia/Kuwait`], [`KY`, `America/Cayman`], [`KZ`, `Asia/Almaty`], [`LA`, `Asia/Vientiane`], [`LB`, `Asia/Beirut`], [`LC`, `America/St_Lucia`], [`LI`, `Europe/Vaduz`], [`LK`, `Asia/Colombo`], [`LR`, `Africa/Monrovia`], [`LS`, `Africa/Maseru`], [`LT`, `Europe/Vilnius`], [`LU`, `Europe/Luxembourg`], [`LV`, `Europe/Riga`], [`LY`, `Africa/Tripoli`], [`MA`, `Africa/Casablanca`], [`MC`, `Europe/Monaco`], [`MD`, `Europe/Chisinau`], [`ME`, `Europe/Podgorica`], [`MF`, `America/Marigot`], [`MG`, `Indian/Antananarivo`], [`MH`, `Pacific/Majuro`], [`MK`, `Europe/Skopje`], [`ML`, `Africa/Bamako`], [`MM`, `Asia/Yangon`], [`MN`, `Asia/Ulaanbaatar`], [`MO`, `Asia/Macau`], [`MP`, `Pacific/Saipan`], [`MQ`, `America/Martinique`], [`MR`, `Africa/Nouakchott`], [`MS`, `America/Montserrat`], [`MT`, `Europe/Malta`], [`MU`, `Indian/Mauritius`], [`MV`, `Indian/Maldives`], [`MW`, `Africa/Blantyre`], [`MX`, `America/Mexico_City`], [`MY`, `Asia/Kuala_Lumpur`], [`MZ`, `Africa/Maputo`], [`NA`, `Africa/Windhoek`], [`NC`, `Pacific/Noumea`], [`NE`, `Africa/Niamey`], [`NF`, `Pacific/Norfolk`], [`NG`, `Africa/Lagos`], [`NI`, `America/Managua`], [`NL`, `Europe/Amsterdam`], [`NO`, `Europe/Oslo`], [`NP`, `Asia/Kathmandu`], [`NR`, `Pacific/Nauru`], [`NU`, `Pacific/Niue`], [`NZ`, `Pacific/Auckland`], [`OM`, `Asia/Muscat`], [`PA`, `America/Panama`], [`PE`, `America/Lima`], [`PF`, `Pacific/Tahiti`], [`PG`, `Pacific/Port_Moresby`], [`PH`, `Asia/Manila`], [`PK`, `Asia/Karachi`], [`PL`, `Europe/Warsaw`], [`PM`, `America/Miquelon`], [`PN`, `Pacific/Pitcairn`], [`PR`, `America/Puerto_Rico`], [`PS`, `Asia/Gaza`], [`PT`, `Europe/Lisbon`], [`PW`, `Pacific/Palau`], [`PY`, `America/Asuncion`], [`QA`, `Asia/Qatar`], [`RE`, `Indian/Reunion`], [`RO`, `Europe/Bucharest`], [`RS`, `Europe/Belgrade`], [`RU`, `Europe/Moscow`], [`RW`, `Africa/Kigali`], [`SA`, `Asia/Riyadh`], [`SB`, `Pacific/Guadalcanal`], [`SC`, `Indian/Mahe`], [`SD`, `Africa/Khartoum`], [`SE`, `Europe/Stockholm`], [`SG`, `Asia/Singapore`], [`SH`, `Atlantic/St_Helena`], [`SI`, `Europe/Ljubljana`], [`SJ`, `Arctic/Longyearbyen`], [`SK`, `Europe/Bratislava`], [`SL`, `Africa/Freetown`], [`SM`, `Europe/San_Marino`], [`SN`, `Africa/Dakar`], [`SO`, `Africa/Mogadishu`], [`SR`, `America/Paramaribo`], [`SS`, `Africa/Juba`], [`ST`, `Africa/Sao_Tome`], [`SV`, `America/El_Salvador`], [`SX`, `America/Lower_Princes`], [`SY`, `Asia/Damascus`], [`SZ`, `Africa/Mbabane`], [`TC`, `America/Grand_Turk`], [`TD`, `Africa/Ndjamena`], [`TF`, `Indian/Kerguelen`], [`TG`, `Africa/Lome`], [`TH`, `Asia/Bangkok`], [`TJ`, `Asia/Dushanbe`], [`TK`, `Pacific/Fakaofo`], [`TL`, `Asia/Dili`], [`TM`, `Asia/Ashgabat`], [`TN`, `Africa/Tunis`], [`TO`, `Pacific/Tongatapu`], [`TR`, `Europe/Istanbul`], [`TT`, `America/Port_of_Spain`], [`TV`, `Pacific/Funafuti`], [`TW`, `Asia/Taipei`], [`TZ`, `Africa/Dar_es_Salaam`], [`UA`, `Europe/Kiev`], [`UG`, `Africa/Kampala`], [`UM`, `Pacific/Wake`], [`US`, `America/New_York`], [`UY`, `America/Montevideo`], [`UZ`, `Asia/Tashkent`], [`VA`, `Europe/Vatican`], [`VC`, `America/St_Vincent`], [`VE`, `America/Caracas`], [`VG`, `America/Tortola`], [`VI`, `America/St_Thomas`], [`VN`, `Asia/Ho_Chi_Minh`], [`VU`, `Pacific/Efate`], [`WF`, `Pacific/Wallis`], [`WS`, `Pacific/Apia`], [`YE`, `Asia/Aden`], [`YT`, `Indian/Mayotte`], [`ZA`, `Africa/Johannesburg`], [`ZM`, `Africa/Lusaka`], [`ZW`, `Africa/Harare`]])), isos$1 = Object.freeze(/* @__PURE__ */ new Set([...countries$1.keys()]));
const areaCodeMap$1 = { 201: `US`, 202: `US`, 203: `US`, 204: `CA`, 205: `US`, 206: `US`, 207: `US`, 208: `US`, 209: `US`, 210: `US`, 212: `US`, 213: `US`, 214: `US`, 215: `US`, 216: `US`, 217: `US`, 218: `US`, 219: `US`, 220: `US`, 223: `US`, 224: `US`, 225: `US`, 226: `CA`, 227: `US`, 228: `US`, 229: `US`, 231: `US`, 234: `US`, 236: `CA`, 239: `US`, 240: `US`, 242: `BS`, 246: `BB`, 248: `US`, 249: `CA`, 250: `CA`, 251: `US`, 252: `US`, 253: `US`, 254: `US`, 256: `US`, 260: `US`, 262: `US`, 263: `CA`, 264: `AI`, 267: `US`, 268: `AG`, 269: `US`, 270: `US`, 272: `US`, 276: `US`, 279: `US`, 281: `US`, 283: `US`, 284: `VG`, 289: `CA`, 301: `US`, 302: `US`, 303: `US`, 304: `US`, 305: `US`, 306: `CA`, 307: `US`, 308: `US`, 309: `US`, 310: `US`, 312: `US`, 313: `US`, 314: `US`, 315: `US`, 316: `US`, 317: `US`, 318: `US`, 319: `US`, 320: `US`, 321: `US`, 323: `US`, 325: `US`, 326: `US`, 329: `US`, 330: `US`, 331: `US`, 332: `US`, 334: `US`, 336: `US`, 337: `US`, 339: `US`, 340: `VI`, 341: `US`, 343: `CA`, 345: `KY`, 346: `US`, 347: `US`, 350: `US`, 351: `US`, 352: `US`, 354: `CA`, 360: `US`, 361: `US`, 364: `US`, 365: `CA`, 367: `CA`, 368: `CA`, 369: `US`, 380: `US`, 382: `CA`, 385: `US`, 386: `US`, 401: `US`, 402: `US`, 403: `CA`, 404: `US`, 405: `US`, 406: `US`, 407: `US`, 408: `US`, 409: `US`, 410: `US`, 412: `US`, 413: `US`, 414: `US`, 415: `US`, 416: `CA`, 417: `US`, 418: `CA`, 419: `US`, 423: `US`, 424: `US`, 425: `US`, 428: `CA`, 430: `US`, 431: `CA`, 432: `US`, 434: `US`, 435: `US`, 437: `CA`, 438: `CA`, 440: `US`, 441: `BM`, 442: `US`, 443: `US`, 445: `US`, 447: `US`, 448: `US`, 450: `CA`, 458: `US`, 463: `US`, 464: `US`, 468: `CA`, 469: `US`, 470: `US`, 473: `GD`, 474: `CA`, 475: `US`, 478: `US`, 479: `US`, 480: `US`, 484: `US`, 500: `US`, 501: `US`, 502: `US`, 503: `US`, 504: `US`, 505: `US`, 506: `CA`, 507: `US`, 508: `US`, 509: `US`, 510: `US`, 512: `US`, 513: `US`, 514: `CA`, 515: `US`, 516: `US`, 517: `US`, 518: `US`, 519: `CA`, 520: `US`, 521: `US`, 522: `US`, 525: `US`, 526: `US`, 527: `US`, 528: `US`, 529: `US`, 530: `US`, 531: `US`, 533: `US`, 534: `US`, 539: `US`, 540: `US`, 541: `US`, 544: `US`, 548: `CA`, 551: `US`, 557: `US`, 559: `US`, 561: `US`, 562: `US`, 563: `US`, 564: `US`, 566: `US`, 567: `US`, 570: `US`, 571: `US`, 572: `US`, 573: `US`, 574: `US`, 575: `US`, 577: `US`, 579: `CA`, 580: `US`, 581: `CA`, 582: `US`, 584: `CA`, 585: `US`, 586: `US`, 587: `CA`, 588: `US`, 600: `CA`, 601: `US`, 602: `US`, 603: `US`, 604: `CA`, 605: `US`, 606: `US`, 607: `US`, 608: `US`, 609: `US`, 610: `US`, 612: `US`, 613: `CA`, 614: `US`, 615: `US`, 616: `US`, 617: `US`, 618: `US`, 619: `US`, 620: `US`, 622: `CA`, 623: `US`, 626: `US`, 628: `US`, 629: `US`, 630: `US`, 631: `US`, 636: `US`, 639: `CA`, 640: `US`, 641: `US`, 646: `US`, 647: `CA`, 649: `TC`, 650: `US`, 651: `US`, 656: `US`, 657: `US`, 658: `JM`, 659: `US`, 660: `US`, 661: `US`, 662: `US`, 664: `MS`, 667: `US`, 669: `US`, 670: `MP`, 671: `GU`, 672: `CA`, 678: `US`, 680: `US`, 681: `US`, 682: `US`, 683: `CA`, 684: `AS`, 689: `US`, 701: `US`, 702: `US`, 703: `US`, 704: `US`, 705: `CA`, 706: `US`, 707: `US`, 708: `US`, 709: `CA`, 712: `US`, 713: `US`, 714: `US`, 715: `US`, 716: `US`, 717: `US`, 718: `US`, 719: `US`, 720: `US`, 721: `SX`, 724: `US`, 725: `US`, 726: `US`, 727: `US`, 731: `US`, 732: `US`, 734: `US`, 737: `US`, 740: `US`, 742: `CA`, 743: `US`, 747: `US`, 753: `CA`, 754: `US`, 757: `US`, 758: `LC`, 760: `US`, 762: `US`, 763: `US`, 765: `US`, 767: `DM`, 769: `US`, 770: `US`, 771: `US`, 772: `US`, 773: `US`, 774: `US`, 775: `US`, 778: `CA`, 779: `US`, 780: `CA`, 781: `US`, 782: `CA`, 784: `VC`, 785: `US`, 786: `US`, 787: `PR`, 800: `US`, 801: `US`, 802: `US`, 803: `US`, 804: `US`, 805: `US`, 806: `US`, 807: `CA`, 808: `US`, 809: `DO`, 810: `US`, 812: `US`, 813: `US`, 814: `US`, 815: `US`, 816: `US`, 817: `US`, 818: `US`, 819: `CA`, 820: `US`, 825: `CA`, 826: `US`, 828: `US`, 829: `DO`, 830: `US`, 831: `US`, 832: `US`, 833: `US`, 835: `US`, 838: `US`, 839: `US`, 840: `US`, 843: `US`, 844: `US`, 845: `US`, 847: `US`, 848: `US`, 849: `DO`, 850: `US`, 854: `US`, 855: `US`, 856: `US`, 857: `US`, 858: `US`, 859: `US`, 860: `US`, 862: `US`, 863: `US`, 864: `US`, 865: `US`, 866: `US`, 867: `CA`, 868: `TT`, 869: `KN`, 870: `US`, 872: `US`, 873: `CA`, 876: `JM`, 877: `US`, 878: `US`, 888: `US`, 900: `US`, 901: `US`, 902: `CA`, 903: `US`, 904: `US`, 905: `CA`, 906: `US`, 907: `US`, 908: `US`, 909: `US`, 910: `US`, 912: `US`, 913: `US`, 914: `US`, 915: `US`, 916: `US`, 917: `US`, 918: `US`, 919: `US`, 920: `US`, 925: `US`, 928: `US`, 929: `US`, 930: `US`, 931: `US`, 934: `US`, 936: `US`, 937: `US`, 938: `US`, 939: `PR`, 940: `US`, 941: `US`, 943: `US`, 945: `US`, 947: `US`, 948: `US`, 949: `US`, 951: `US`, 952: `US`, 954: `US`, 956: `US`, 959: `US`, 970: `US`, 971: `US`, 972: `US`, 973: `US`, 978: `US`, 979: `US`, 980: `US`, 984: `US`, 985: `US`, 986: `US`, 989: `US` }, nanpaCountries$1 = [`US`, `CA`, `BS`, `BB`, `AI`, `AG`, `VG`, `VI`, `KY`, `BM`, `GD`, `TC`, `JM`, `MS`, `MP`, `GU`, `AS`, `SX`, `LC`, `DM`, `VC`, `PR`, `DO`, `TT`, `KN`];
for (var commonjsGlobal = typeof globalThis < `u` ? globalThis : typeof window < `u` ? window : {}, allCountries = [[`Afghanistan (‫افغانستان‬‎)`, `af`, `93`, `+..-..-...-....`], [`Åland Islands`, `ax`, `358`, ``], [`Albania (Shqipëri)`, `al`, `355`, `+...(...)...-...`], [`Algeria (‫الجزائر‬‎)`, `dz`, `213`, `+...-..-...-....`], [`American Samoa`, `as`, `1684`, `+.(...)...-....`], [`Andorra`, `ad`, `376`, `+...-...-...`], [`Angola`, `ao`, `244`, `+...(...)...-...`], [`Anguilla`, `ai`, `1264`, `+.(...)...-....`], [`Antarctica`, `aq`, `672`, ``], [`Antigua and Barbuda`, `ag`, `1268`, `+.(...)...-....`], [`Argentina`, `ar`, `54`, `+..(...)...-....`], [`Armenia (Հայաստան)`, `am`, `374`, `+...-..-...-...`], [`Aruba`, `aw`, `297`, `+...-...-....`], [`Australia`, `au`, `61`, `+.. ... ... ...`], [`Austria (Österreich)`, `at`, `43`, `+..(...)...-....`], [`Azerbaijan (Azərbaycan)`, `az`, `994`, `+...-..-...-..-..`], [`Bahamas`, `bs`, `1242`, `+.(...)...-....`], [`Bahrain (‫البحرين‬‎)`, `bh`, `973`, `+...-....-....`], [`Bangladesh (বাংলাদেশ)`, `bd`, `880`, `+...-..-...-...`], [`Barbados`, `bb`, `1246`, `+.(...)...-....`], [`Belarus (Беларусь)`, `by`, `375`, `+...(..)...-..-..`], [`Belgium (België)`, `be`, `32`, `+.. ... .. .. ..`], [`Belize`, `bz`, `501`, `+...-...-....`], [`Benin (Bénin)`, `bj`, `229`, `+...-..-..-....`], [`Bermuda`, `bm`, `1441`, `+.(...)...-....`], [`Bhutan (འབྲུག)`, `bt`, `975`, `+...-.-...-...`], [`Bolivia`, `bo`, `591`, `+...-.-...-....`], [`Bosnia and Herzegovina (Босна и Херцеговина)`, `ba`, `387`, `+...-..-....`], [`Botswana`, `bw`, `267`, `+...-..-...-...`], [`Bouvet Island`, `bv`, `47`, ``], [`Brazil (Brasil)`, `br`, `55`, `+..-..-....-....`], [`British Indian Ocean Territory`, `io`, `246`, `+...-...-....`], [`British Virgin Islands`, `vg`, `1284`, `+.(...)...-....`], [`Brunei`, `bn`, `673`, `+...-...-....`], [`Bulgaria (България)`, `bg`, `359`, `+...(...)...-...`], [`Burkina Faso`, `bf`, `226`, `+...-..-..-....`], [`Burundi (Uburundi)`, `bi`, `257`, `+...-..-..-....`], [`Cambodia (កម្ពុជា)`, `kh`, `855`, `+...-..-...-...`], [`Cameroon (Cameroun)`, `cm`, `237`, `+...-....-....`], [`Canada`, `ca`, `1`, `+. (...) ...-....`, 1, `204.236.249.250.289.306.343.365.387.403.416.418.431.437.438.450.506.514.519.548.579.581.587.604.613.639.647.672.705.709.742.778.780.782.807.819.825.867.873.902.905`.split(`.`)], [`Cape Verde (Kabu Verdi)`, `cv`, `238`, `+...(...)..-..`], [`Caribbean Netherlands`, `bq`, `599`, `+...-...-....`, 1], [`Cayman Islands`, `ky`, `1345`, `+.(...)...-....`], [`Central African Republic (République centrafricaine)`, `cf`, `236`, `+...-..-..-....`], [`Chad (Tchad)`, `td`, `235`, `+...-..-..-..-..`], [`Chile`, `cl`, `56`, `+..-.-....-....`], [`China (中国)`, `cn`, `86`, `+.. ..-........`], [`Christmas Island`, `cx`, `61`, ``], [`Cocos (Keeling) Islands`, `cc`, `61`, ``], [`Colombia`, `co`, `57`, `+..(...)...-....`], [`Comoros (‫جزر القمر‬‎)`, `km`, `269`, `+...-..-.....`], [`Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)`, `cd`, `243`, `+...(...)...-...`], [`Congo (Republic) (Congo-Brazzaville)`, `cg`, `242`, `+...-..-...-....`], [`Cook Islands`, `ck`, `682`, `+...-..-...`], [`Costa Rica`, `cr`, `506`, `+... ....-....`], [`Côte d’Ivoire`, `ci`, `225`, `+...-..-...-...`], [`Croatia (Hrvatska)`, `hr`, `385`, `+...-..-...-...`], [`Cuba`, `cu`, `53`, `+..-.-...-....`], [`Curaçao`, `cw`, `599`, `+...-...-....`, 0], [`Cyprus (Κύπρος)`, `cy`, `357`, `+...-..-...-...`], [`Czech Republic (Česká republika)`, `cz`, `420`, `+...(...)...-...`], [`Denmark (Danmark)`, `dk`, `45`, `+.. .. .. .. ..`], [`Djibouti`, `dj`, `253`, `+...-..-..-..-..`], [`Dominica`, `dm`, `1767`, `+.(...)...-....`], [`Dominican Republic (República Dominicana)`, `do`, `1`, `+.(...)...-....`, 2, [`809`, `829`, `849`]], [`Ecuador`, `ec`, `593`, `+...-.-...-....`], [`Egypt (‫مصر‬‎)`, `eg`, `20`, `+..(...)...-....`], [`El Salvador`, `sv`, `503`, `+... ....-....`], [`Equatorial Guinea (Guinea Ecuatorial)`, `gq`, `240`, `+...-..-...-....`], [`Eritrea`, `er`, `291`, `+...-.-...-...`], [`Estonia (Eesti)`, `ee`, `372`, `+...-...-....`], [`Ethiopia`, `et`, `251`, `+...-..-...-....`], [`Falkland Islands (Islas Malvinas)`, `fk`, `500`, `+...-.....`], [`Faroe Islands (Føroyar)`, `fo`, `298`, `+...-...-...`], [`Fiji`, `fj`, `679`, `+...-..-.....`], [`Finland (Suomi)`, `fi`, `358`, `+... .. .... ....`], [`France`, `fr`, `33`, `+.. . .. .. .. ..`], [`French Guiana (Guyane française)`, `gf`, `594`, `+...-.....-....`], [`French Polynesia (Polynésie française)`, `pf`, `689`, `+...-..-..-..`], [`French Southern and Antarctic Lands`, `tf`, `262`, ``], [`Gabon`, `ga`, `241`, `+...-.-..-..-..`], [`Gambia`, `gm`, `220`, `+...(...)..-..`], [`Georgia (საქართველო)`, `ge`, `995`, `+...(...)...-...`], [`Germany (Deutschland)`, `de`, `49`, `+.. ... .......`], [`Ghana (Gaana)`, `gh`, `233`, `+...(...)...-...`], [`Gibraltar`, `gi`, `350`, `+...-...-.....`], [`Greece (Ελλάδα)`, `gr`, `30`, `+..(...)...-....`], [`Greenland (Kalaallit Nunaat)`, `gl`, `299`, `+...-..-..-..`], [`Grenada`, `gd`, `1473`, `+.(...)...-....`], [`Guadeloupe`, `gp`, `590`, ``, 0], [`Guam`, `gu`, `1671`, `+.(...)...-....`], [`Guatemala`, `gt`, `502`, `+... ....-....`], [`Guernsey`, `gg`, `44`, ``], [`Guinea (Guinée)`, `gn`, `224`, `+...-..-...-...`], [`Guinea-Bissau (Guiné Bissau)`, `gw`, `245`, `+...-.-......`], [`Guyana`, `gy`, `592`, `+...-...-....`], [`Haiti`, `ht`, `509`, `+... ....-....`], [`Heard Island and McDonald Islands`, `hm`, `672`, ``], [`Honduras`, `hn`, `504`, `+...-....-....`], [`Hong Kong (香港)`, `hk`, `852`, `+... .... ....`], [`Hungary (Magyarország)`, `hu`, `36`, `+..(...)...-...`], [`Iceland (Ísland)`, `is`, `354`, `+... ... ....`], [`India (भारत)`, `in`, `91`, `+.. .....-.....`], [`Indonesia`, `id`, `62`, `+..-..-...-..`], [`Iran (‫ایران‬‎)`, `ir`, `98`, `+..(...)...-....`], [`Iraq (‫العراق‬‎)`, `iq`, `964`, `+...(...)...-....`], [`Ireland`, `ie`, `353`, `+... .. .......`], [`Isle of Man`, `im`, `44`, ``], [`Israel (‫ישראל‬‎)`, `il`, `972`, `+...-.-...-....`], [`Italy (Italia)`, `it`, `39`, `+.. ... ......`, 0], [`Jamaica`, `jm`, `1876`, `+.(...)...-....`], [`Japan (日本)`, `jp`, `81`, `+.. ... .. ....`], [`Jersey`, `je`, `44`, ``], [`Jordan (‫الأردن‬‎)`, `jo`, `962`, `+...-.-....-....`], [`Kazakhstan (Казахстан)`, `kz`, `7`, `+. ... ...-..-..`, 1], [`Kenya`, `ke`, `254`, `+...-...-......`], [`Kiribati`, `ki`, `686`, `+...-..-...`], [`Kosovo`, `xk`, `383`, ``], [`Kuwait (‫الكويت‬‎)`, `kw`, `965`, `+...-....-....`], [`Kyrgyzstan (Кыргызстан)`, `kg`, `996`, `+...(...)...-...`], [`Laos (ລາວ)`, `la`, `856`, `+...-..-...-...`], [`Latvia (Latvija)`, `lv`, `371`, `+...-..-...-...`], [`Lebanon (‫لبنان‬‎)`, `lb`, `961`, `+...-.-...-...`], [`Lesotho`, `ls`, `266`, `+...-.-...-....`], [`Liberia`, `lr`, `231`, `+...-..-...-...`], [`Libya (‫ليبيا‬‎)`, `ly`, `218`, `+...-..-...-...`], [`Liechtenstein`, `li`, `423`, `+...(...)...-....`], [`Lithuania (Lietuva)`, `lt`, `370`, `+...(...)..-...`], [`Luxembourg`, `lu`, `352`, `+...(...)...-...`], [`Macau (澳門)`, `mo`, `853`, `+...-....-....`], [`Macedonia (FYROM) (Македонија)`, `mk`, `389`, `+...-..-...-...`], [`Madagascar (Madagasikara)`, `mg`, `261`, `+...-..-..-.....`], [`Malawi`, `mw`, `265`, `+...-.-....-....`], [`Malaysia`, `my`, `60`, `+.. ..-....-....`], [`Maldives`, `mv`, `960`, `+...-...-....`], [`Mali`, `ml`, `223`, `+...-..-..-....`], [`Malta`, `mt`, `356`, `+...-....-....`], [`Marshall Islands`, `mh`, `692`, `+...-...-....`], [`Martinique`, `mq`, `596`, `+...(...)..-..-..`], [`Mauritania (‫موريتانيا‬‎)`, `mr`, `222`, `+...-..-..-....`], [`Mauritius (Moris)`, `mu`, `230`, `+...-...-....`], [`Mayotte`, `yt`, `262`, ``], [`Mexico (México)`, `mx`, `52`, `+..-..-..-....`], [`Micronesia`, `fm`, `691`, `+...-...-....`], [`Moldova (Republica Moldova)`, `md`, `373`, `+...-....-....`], [`Monaco`, `mc`, `377`, `+...-..-...-...`], [`Mongolia (Монгол)`, `mn`, `976`, `+...-..-..-....`], [`Montenegro (Crna Gora)`, `me`, `382`, `+...-..-...-...`], [`Montserrat`, `ms`, `1664`, `+.(...)...-....`], [`Morocco (‫المغرب‬‎)`, `ma`, `212`, `+...-..-....-...`], [`Mozambique (Moçambique)`, `mz`, `258`, `+...-..-...-...`], [`Myanmar (Burma) (မြန်မာ)`, `mm`, `95`, `+..-...-...`], [`Namibia (Namibië)`, `na`, `264`, `+...-..-...-....`], [`Nauru`, `nr`, `674`, `+...-...-....`], [`Nepal (नेपाल)`, `np`, `977`, `+...-..-...-...`], [`Netherlands (Nederland)`, `nl`, `31`, `+.. .. ........`], [`New Caledonia (Nouvelle-Calédonie)`, `nc`, `687`, `+...-..-....`], [`New Zealand`, `nz`, `64`, `+.. ...-...-....`], [`Nicaragua`, `ni`, `505`, `+...-....-....`], [`Niger (Nijar)`, `ne`, `227`, `+...-..-..-....`], [`Nigeria`, `ng`, `234`, `+...-..-...-..`], [`Niue`, `nu`, `683`, `+...-....`], [`Norfolk Island`, `nf`, `672`, `+...-...-...`], [`North Korea (조선 민주주의 인민 공화국)`, `kp`, `850`, `+...-...-...`], [`Northern Mariana Islands`, `mp`, `1670`, `+.(...)...-....`], [`Norway (Norge)`, `no`, `47`, `+.. ... .. ...`], [`Oman (‫عُمان‬‎)`, `om`, `968`, `+...-..-...-...`], [`Pakistan (‫پاکستان‬‎)`, `pk`, `92`, `+.. ...-.......`], [`Palau`, `pw`, `680`, `+...-...-....`], [`Palestine (‫فلسطين‬‎)`, `ps`, `970`, `+...-..-...-....`], [`Panama (Panamá)`, `pa`, `507`, `+...-...-....`], [`Papua New Guinea`, `pg`, `675`, `+...(...)..-...`], [`Paraguay`, `py`, `595`, `+...(...)...-...`], [`Peru (Perú)`, `pe`, `51`, `+..(...)...-...`], [`Philippines`, `ph`, `63`, `+.. ... ....`], [`Pitcairn Islands`, `pn`, `64`, ``], [`Poland (Polska)`, `pl`, `48`, `+.. ...-...-...`], [`Portugal`, `pt`, `351`, `+...-..-...-....`], [`Puerto Rico`, `pr`, `1`, `+. (...) ...-....`, 3, [`787`, `939`]], [`Qatar (‫قطر‬‎)`, `qa`, `974`, `+...-....-....`], [`Réunion (La Réunion)`, `re`, `262`, `+...-.....-....`], [`Romania (România)`, `ro`, `40`, `+..-..-...-....`], [`Russia (Россия)`, `ru`, `7`, `+. ... ...-..-..`, 0], [`Rwanda`, `rw`, `250`, `+...(...)...-...`], [`Saint Barthélemy (Saint-Barthélemy)`, `bl`, `590`, ``, 1], [`Saint Helena`, `sh`, `290`], [`Saint Kitts and Nevis`, `kn`, `1869`, `+.(...)...-....`], [`Saint Lucia`, `lc`, `1758`, `+.(...)...-....`], [`Saint Martin (Saint-Martin (partie française))`, `mf`, `590`, ``, 2], [`Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)`, `pm`, `508`], [`Saint Vincent and the Grenadines`, `vc`, `1784`, `+.(...)...-....`], [`Samoa`, `ws`, `685`, `+...-..-....`], [`San Marino`, `sm`, `378`, `+...-....-......`], [`São Tomé and Príncipe (São Tomé e Príncipe)`, `st`, `239`, `+...-..-.....`], [`Saudi Arabia (‫المملكة العربية السعودية‬‎)`, `sa`, `966`, `+...-..-...-....`], [`Senegal (Sénégal)`, `sn`, `221`, `+...-..-...-....`], [`Serbia (Србија)`, `rs`, `381`, `+...-..-...-....`], [`Seychelles`, `sc`, `248`, `+...-.-...-...`], [`Sierra Leone`, `sl`, `232`, `+...-..-......`], [`Singapore`, `sg`, `65`, `+.. ....-....`], [`Sint Maarten`, `sx`, `1721`, `+.(...)...-....`], [`Slovakia (Slovensko)`, `sk`, `421`, `+...(...)...-...`], [`Slovenia (Slovenija)`, `si`, `386`, `+...-..-...-...`], [`Solomon Islands`, `sb`, `677`, `+...-.....`], [`Somalia (Soomaaliya)`, `so`, `252`, `+...-.-...-...`], [`South Africa`, `za`, `27`, `+..-..-...-....`], [`South Georgia and the South Sandwich Islands`, `gs`, `500`, ``], [`South Korea (대한민국)`, `kr`, `82`, `+..-..-...-....`], [`South Sudan (‫جنوب السودان‬‎)`, `ss`, `211`, `+...-..-...-....`], [`Spain (España)`, `es`, `34`, `+.. ... ... ...`], [`Sri Lanka (ශ්‍රී ලංකාව)`, `lk`, `94`, `+..-..-...-....`], [`Sudan (‫السودان‬‎)`, `sd`, `249`, `+...-..-...-....`], [`Suriname`, `sr`, `597`, `+...-...-...`], [`Svalbard and Jan Mayen`, `sj`, `47`, ``], [`Swaziland`, `sz`, `268`, `+...-..-..-....`], [`Sweden (Sverige)`, `se`, `46`, `+.. .. ... .. ..`], [`Switzerland (Schweiz)`, `ch`, `41`, `+.. .. ... .. ..`], [`Syria (‫سوريا‬‎)`, `sy`, `963`, `+...-..-....-...`], [`Taiwan (台灣)`, `tw`, `886`, `+...-....-....`], [`Tajikistan`, `tj`, `992`, `+...-..-...-....`], [`Tanzania`, `tz`, `255`, `+...-..-...-....`], [`Thailand (ไทย)`, `th`, `66`, `+..-..-...-...`], [`Timor-Leste`, `tl`, `670`, `+...-...-....`], [`Togo`, `tg`, `228`, `+...-..-...-...`], [`Tokelau`, `tk`, `690`, `+...-....`], [`Tonga`, `to`, `676`, `+...-.....`], [`Trinidad and Tobago`, `tt`, `1868`, `+.(...)...-....`], [`Tunisia (‫تونس‬‎)`, `tn`, `216`, `+...-..-...-...`], [`Turkey (Türkiye)`, `tr`, `90`, `+.. ... ... .. ..`], [`Turkmenistan`, `tm`, `993`, `+...-.-...-....`], [`Turks and Caicos Islands`, `tc`, `1649`, `+.(...)...-....`], [`Tuvalu`, `tv`, `688`, `+...-.....`], [`U.S. Virgin Islands`, `vi`, `1340`, `+.(...)...-....`], [`Uganda`, `ug`, `256`, `+...(...)...-...`], [`Ukraine (Україна)`, `ua`, `380`, `+...(..)...-..-..`], [`United Arab Emirates (‫الإمارات العربية المتحدة‬‎)`, `ae`, `971`, `+...-.-...-....`], [`United Kingdom`, `gb`, `44`, `+.. .... ......`], [`United States`, `us`, `1`, `+. (...) ...-....`, 0], [`United States Minor Outlying Islands`, `um`, `1`, ``, 2], [`Uruguay`, `uy`, `598`, `+...-.-...-..-..`], [`Uzbekistan (Oʻzbekiston)`, `uz`, `998`, `+...-..-...-....`], [`Vanuatu`, `vu`, `678`, `+...-.....`], [`Vatican City (Città del Vaticano)`, `va`, `39`, `+.. .. .... ....`, 1], [`Venezuela`, `ve`, `58`, `+..(...)...-....`], [`Vietnam (Việt Nam)`, `vn`, `84`, `+..-..-....-...`], [`Wallis and Futuna`, `wf`, `681`, `+...-..-....`], [`Western Sahara`, `eh`, `212`, `+...-..-....`], [`Yemen (‫اليمن‬‎)`, `ye`, `967`, `+...-.-...-...`], [`Zambia`, `zm`, `260`, `+...-..-...-....`], [`Zimbabwe`, `zw`, `263`, `+...-.-......`]], allCountryCodes = {}, iso2Lookup = {}, addCountryCode = function(t$7, o$2, r$2) {
  o$2 in allCountryCodes || (allCountryCodes[o$2] = []);
  var u = r$2 || 0;
  allCountryCodes[o$2][u] = t$7;
}, i$1 = 0; i$1 < allCountries.length; i$1++) {
  var c = allCountries[i$1];
  if (allCountries[i$1] = { name: c[0], iso2: c[1], dialCode: c[2], priority: c[4] || 0 }, c[3] && (allCountries[i$1].format = c[3]), c[5]) {
    allCountries[i$1].hasAreaCodes = true;
    for (var j = 0; j < c[5].length; j++) {
      var dialCode = c[2] + c[5][j];
      addCountryCode(c[1], dialCode);
    }
  }
  iso2Lookup[allCountries[i$1].iso2] = i$1, addCountryCode(c[1], c[2], c[4]);
}
var country_telephone_data = { allCountries, iso2Lookup, allCountryCodes };
function commonjsRequire(t$7) {
  throw Error(`Could not dynamically require "` + t$7 + `". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.`);
}
var libphonenumber = { exports: {} };
libphonenumber.exports, (function(module$1, exports$1) {
  (function(t$7) {
    module$1.exports = t$7();
  })(function() {
    return (/* @__PURE__ */ (function() {
      function t$7(o$2, r$2, u) {
        function h$1(S, _) {
          if (!r$2[S]) {
            if (!o$2[S]) {
              var C = typeof commonjsRequire == `function` && commonjsRequire;
              if (!_ && C) return C(S, true);
              if (m$3) return m$3(S, true);
              var O = Error(`Cannot find module '` + S + `'`);
              throw O.code = `MODULE_NOT_FOUND`, O;
            }
            var I = r$2[S] = { exports: {} };
            o$2[S][0].call(I.exports, function(R$2) {
              var U = o$2[S][1][R$2];
              return h$1(U || R$2);
            }, I, I.exports, t$7, o$2, r$2, u);
          }
          return r$2[S].exports;
        }
        for (var m$3 = typeof commonjsRequire == `function` && commonjsRequire, y$1 = 0; y$1 < u.length; y$1++) h$1(u[y$1]);
        return h$1;
      }
      return t$7;
    })())({ 1: [function(require$1, module$2, exports$2) {
      (function(global) {
        (function() {
          var $jscomp = $jscomp || {};
          $jscomp.scope = {}, $jscomp.createTemplateTagFirstArg = function(t$7) {
            return t$7.raw = t$7;
          }, $jscomp.createTemplateTagFirstArgWithRaw = function(t$7, o$2) {
            return t$7.raw = o$2, t$7;
          }, $jscomp.arrayIteratorImpl = function(t$7) {
            var o$2 = 0;
            return function() {
              return o$2 < t$7.length ? { done: false, value: t$7[o$2++] } : { done: true };
            };
          }, $jscomp.arrayIterator = function(t$7) {
            return { next: $jscomp.arrayIteratorImpl(t$7) };
          }, $jscomp.makeIterator = function(t$7) {
            var o$2 = typeof Symbol < `u` && Symbol.iterator && t$7[Symbol.iterator];
            return o$2 ? o$2.call(t$7) : $jscomp.arrayIterator(t$7);
          }, $jscomp.arrayFromIterator = function(t$7) {
            for (var o$2, r$2 = []; !(o$2 = t$7.next()).done; ) r$2.push(o$2.value);
            return r$2;
          }, $jscomp.arrayFromIterable = function(t$7) {
            return t$7 instanceof Array ? t$7 : $jscomp.arrayFromIterator($jscomp.makeIterator(t$7));
          }, $jscomp.checkStringArgs = function(t$7, o$2, r$2) {
            if (t$7 == null) throw TypeError(`The 'this' value for String.prototype.` + r$2 + ` must not be null or undefined`);
            if (o$2 instanceof RegExp) throw TypeError(`First argument to String.prototype.` + r$2 + ` must not be a regular expression`);
            return t$7 + ``;
          }, $jscomp.ASSUME_ES5 = false, $jscomp.ASSUME_NO_NATIVE_MAP = false, $jscomp.ASSUME_NO_NATIVE_SET = false, $jscomp.SIMPLE_FROUND_POLYFILL = false, $jscomp.ISOLATE_POLYFILLS = false, $jscomp.FORCE_POLYFILL_PROMISE = false, $jscomp.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION = false, $jscomp.defineProperty = $jscomp.ASSUME_ES5 || typeof Object.defineProperties == `function` ? Object.defineProperty : function(t$7, o$2, r$2) {
            return t$7 == Array.prototype || t$7 == Object.prototype || (t$7[o$2] = r$2.value), t$7;
          }, $jscomp.getGlobal = function(t$7) {
            t$7 = [typeof globalThis == `object` && globalThis, t$7, typeof window == `object` && window, typeof self == `object` && self, typeof global == `object` && global];
            for (var o$2 = 0; o$2 < t$7.length; ++o$2) {
              var r$2 = t$7[o$2];
              if (r$2 && r$2.Math == Math) return r$2;
            }
            throw Error(`Cannot find global object`);
          }, $jscomp.global = $jscomp.getGlobal(this), $jscomp.IS_SYMBOL_NATIVE = typeof Symbol == `function` && typeof Symbol(`x`) == `symbol`, $jscomp.TRUST_ES6_POLYFILLS = !$jscomp.ISOLATE_POLYFILLS || $jscomp.IS_SYMBOL_NATIVE, $jscomp.polyfills = {}, $jscomp.propertyToPolyfillSymbol = {}, $jscomp.POLYFILL_PREFIX = `$jscp$`, $jscomp.polyfill = function(t$7, o$2, r$2, u) {
            o$2 && ($jscomp.ISOLATE_POLYFILLS ? $jscomp.polyfillIsolated(t$7, o$2, r$2, u) : $jscomp.polyfillUnisolated(t$7, o$2, r$2, u));
          }, $jscomp.polyfillUnisolated = function(t$7, o$2, r$2, u) {
            for (r$2 = $jscomp.global, t$7 = t$7.split(`.`), u = 0; u < t$7.length - 1; u++) {
              var h$1 = t$7[u];
              if (!(h$1 in r$2)) return;
              r$2 = r$2[h$1];
            }
            t$7 = t$7[t$7.length - 1], u = r$2[t$7], o$2 = o$2(u), o$2 != u && o$2 != null && $jscomp.defineProperty(r$2, t$7, { configurable: true, writable: true, value: o$2 });
          }, $jscomp.polyfillIsolated = function(t$7, o$2, r$2, u) {
            var h$1 = t$7.split(`.`);
            t$7 = h$1.length === 1, u = h$1[0], u = !t$7 && u in $jscomp.polyfills ? $jscomp.polyfills : $jscomp.global;
            for (var m$3 = 0; m$3 < h$1.length - 1; m$3++) {
              var y$1 = h$1[m$3];
              if (!(y$1 in u)) return;
              u = u[y$1];
            }
            h$1 = h$1[h$1.length - 1], r$2 = $jscomp.IS_SYMBOL_NATIVE && r$2 === `es6` ? u[h$1] : null, o$2 = o$2(r$2), o$2 != null && (t$7 ? $jscomp.defineProperty($jscomp.polyfills, h$1, { configurable: true, writable: true, value: o$2 }) : o$2 !== r$2 && ($jscomp.propertyToPolyfillSymbol[h$1] = $jscomp.IS_SYMBOL_NATIVE ? $jscomp.global.Symbol(h$1) : $jscomp.POLYFILL_PREFIX + h$1, h$1 = $jscomp.propertyToPolyfillSymbol[h$1], $jscomp.defineProperty(u, h$1, { configurable: true, writable: true, value: o$2 })));
          }, $jscomp.polyfill(`String.prototype.endsWith`, function(t$7) {
            return t$7 || function(o$2, r$2) {
              var u = $jscomp.checkStringArgs(this, o$2, `endsWith`);
              o$2 += ``, r$2 === void 0 && (r$2 = u.length), r$2 = Math.max(0, Math.min(r$2 | 0, u.length));
              for (var h$1 = o$2.length; 0 < h$1 && 0 < r$2; ) if (u[--r$2] != o$2[--h$1]) return false;
              return 0 >= h$1;
            };
          }, `es6`, `es3`), $jscomp.findInternal = function(t$7, o$2, r$2) {
            t$7 instanceof String && (t$7 = String(t$7));
            for (var u = t$7.length, h$1 = 0; h$1 < u; h$1++) {
              var m$3 = t$7[h$1];
              if (o$2.call(r$2, m$3, h$1, t$7)) return { i: h$1, v: m$3 };
            }
            return { i: -1, v: void 0 };
          }, $jscomp.polyfill(`Array.prototype.find`, function(t$7) {
            return t$7 || function(o$2, r$2) {
              return $jscomp.findInternal(this, o$2, r$2).v;
            };
          }, `es6`, `es3`), $jscomp.polyfill(`String.prototype.startsWith`, function(t$7) {
            return t$7 || function(o$2, r$2) {
              var u = $jscomp.checkStringArgs(this, o$2, `startsWith`);
              o$2 += ``;
              var h$1 = u.length, m$3 = o$2.length;
              r$2 = Math.max(0, Math.min(r$2 | 0, u.length));
              for (var y$1 = 0; y$1 < m$3 && r$2 < h$1; ) if (u[r$2++] != o$2[y$1++]) return false;
              return y$1 >= m$3;
            };
          }, `es6`, `es3`), $jscomp.polyfill(`String.prototype.repeat`, function(t$7) {
            return t$7 || function(o$2) {
              var r$2 = $jscomp.checkStringArgs(this, null, `repeat`);
              if (0 > o$2 || 1342177279 < o$2) throw RangeError(`Invalid count value`);
              o$2 |= 0;
              for (var u = ``; o$2; ) o$2 & 1 && (u += r$2), (o$2 >>>= 1) && (r$2 += r$2);
              return u;
            };
          }, `es6`, `es3`), $jscomp.initSymbol = function() {
          }, $jscomp.polyfill(`Symbol`, function(t$7) {
            if (t$7) return t$7;
            var o$2 = function(h$1, m$3) {
              this.$jscomp$symbol$id_ = h$1, $jscomp.defineProperty(this, `description`, { configurable: true, writable: true, value: m$3 });
            };
            o$2.prototype.toString = function() {
              return this.$jscomp$symbol$id_;
            };
            var r$2 = 0, u = function(h$1) {
              if (this instanceof u) throw TypeError(`Symbol is not a constructor`);
              return new o$2(`jscomp_symbol_` + (h$1 || ``) + `_` + r$2++, h$1);
            };
            return u;
          }, `es6`, `es3`), $jscomp.polyfill(`Symbol.iterator`, function(t$7) {
            if (t$7) return t$7;
            t$7 = Symbol(`Symbol.iterator`);
            for (var o$2 = `Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array`.split(` `), r$2 = 0; r$2 < o$2.length; r$2++) {
              var u = $jscomp.global[o$2[r$2]];
              typeof u == `function` && typeof u.prototype[t$7] != `function` && $jscomp.defineProperty(u.prototype, t$7, { configurable: true, writable: true, value: function() {
                return $jscomp.iteratorPrototype($jscomp.arrayIteratorImpl(this));
              } });
            }
            return t$7;
          }, `es6`, `es3`), $jscomp.iteratorPrototype = function(t$7) {
            return t$7 = { next: t$7 }, t$7[Symbol.iterator] = function() {
              return this;
            }, t$7;
          }, $jscomp.iteratorFromArray = function(t$7, o$2) {
            t$7 instanceof String && (t$7 += ``);
            var r$2 = 0, u = false, h$1 = { next: function() {
              if (!u && r$2 < t$7.length) {
                var m$3 = r$2++;
                return { value: o$2(m$3, t$7[m$3]), done: false };
              }
              return u = true, { done: true, value: void 0 };
            } };
            return h$1[Symbol.iterator] = function() {
              return h$1;
            }, h$1;
          }, $jscomp.polyfill(`Array.prototype.keys`, function(t$7) {
            return t$7 || function() {
              return $jscomp.iteratorFromArray(this, function(o$2) {
                return o$2;
              });
            };
          }, `es6`, `es3`), $jscomp.polyfill(`Object.is`, function(t$7) {
            return t$7 || function(o$2, r$2) {
              return o$2 === r$2 ? o$2 !== 0 || 1 / o$2 == 1 / r$2 : o$2 !== o$2 && r$2 !== r$2;
            };
          }, `es6`, `es3`), $jscomp.polyfill(`Array.prototype.includes`, function(t$7) {
            return t$7 || function(o$2, r$2) {
              var u = this;
              u instanceof String && (u = String(u));
              var h$1 = u.length;
              for (r$2 ||= 0, 0 > r$2 && (r$2 = Math.max(r$2 + h$1, 0)); r$2 < h$1; r$2++) {
                var m$3 = u[r$2];
                if (m$3 === o$2 || Object.is(m$3, o$2)) return true;
              }
              return false;
            };
          }, `es7`, `es3`), $jscomp.polyfill(`String.prototype.includes`, function(t$7) {
            return t$7 || function(o$2, r$2) {
              return $jscomp.checkStringArgs(this, o$2, `includes`).indexOf(o$2, r$2 || 0) !== -1;
            };
          }, `es6`, `es3`);
          var COMPILED = true, goog = goog || {};
          goog.global = this || self, goog.exportPath_ = function(t$7, o$2, r$2, u) {
            t$7 = t$7.split(`.`), u ||= goog.global, t$7[0] in u || typeof u.execScript > `u` || u.execScript(`var ` + t$7[0]);
            for (var h$1; t$7.length && (h$1 = t$7.shift()); ) if (t$7.length || o$2 === void 0) u = u[h$1] && u[h$1] !== Object.prototype[h$1] ? u[h$1] : u[h$1] = {};
            else if (!r$2 && goog.isObject(o$2) && goog.isObject(u[h$1])) for (var m$3 in o$2) o$2.hasOwnProperty(m$3) && (u[h$1][m$3] = o$2[m$3]);
            else u[h$1] = o$2;
          }, goog.define = function(t$7, o$2) {
            if (!COMPILED) {
              var r$2 = goog.global.CLOSURE_UNCOMPILED_DEFINES, u = goog.global.CLOSURE_DEFINES;
              r$2 && r$2.nodeType === void 0 && Object.prototype.hasOwnProperty.call(r$2, t$7) ? o$2 = r$2[t$7] : u && u.nodeType === void 0 && Object.prototype.hasOwnProperty.call(u, t$7) && (o$2 = u[t$7]);
            }
            return o$2;
          }, goog.FEATURESET_YEAR = 2012, goog.DEBUG = true, goog.LOCALE = `en`, goog.TRUSTED_SITE = true, goog.DISALLOW_TEST_ONLY_CODE = COMPILED && !goog.DEBUG, goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = false, goog.provide = function(t$7) {
            if (goog.isInModuleLoader_()) throw Error(`goog.provide cannot be used within a module.`);
            if (!COMPILED && goog.isProvided_(t$7)) throw Error(`Namespace "` + t$7 + `" already declared.`);
            goog.constructNamespace_(t$7);
          }, goog.constructNamespace_ = function(t$7, o$2, r$2) {
            if (!COMPILED) {
              delete goog.implicitNamespaces_[t$7];
              for (var u = t$7; (u = u.substring(0, u.lastIndexOf(`.`))) && !goog.getObjectByName(u); ) goog.implicitNamespaces_[u] = true;
            }
            goog.exportPath_(t$7, o$2, r$2);
          }, goog.getScriptNonce = function(t$7) {
            return t$7 && t$7 != goog.global ? goog.getScriptNonce_(t$7.document) : (goog.cspNonce_ === null && (goog.cspNonce_ = goog.getScriptNonce_(goog.global.document)), goog.cspNonce_);
          }, goog.NONCE_PATTERN_ = /^[\w+/_-]+[=]{0,2}$/, goog.cspNonce_ = null, goog.getScriptNonce_ = function(t$7) {
            return (t$7 = t$7.querySelector && t$7.querySelector(`script[nonce]`)) && (t$7 = t$7.nonce || t$7.getAttribute(`nonce`)) && goog.NONCE_PATTERN_.test(t$7) ? t$7 : ``;
          }, goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/, goog.module = function(t$7) {
            if (typeof t$7 != `string` || !t$7 || t$7.search(goog.VALID_MODULE_RE_) == -1) throw Error(`Invalid module identifier`);
            if (!goog.isInGoogModuleLoader_()) throw Error(`Module ` + t$7 + ` has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.`);
            if (goog.moduleLoaderState_.moduleName) throw Error(`goog.module may only be called once per module.`);
            if (goog.moduleLoaderState_.moduleName = t$7, !COMPILED) {
              if (goog.isProvided_(t$7)) throw Error(`Namespace "` + t$7 + `" already declared.`);
              delete goog.implicitNamespaces_[t$7];
            }
          }, goog.module.get = function(t$7) {
            return goog.module.getInternal_(t$7);
          }, goog.module.getInternal_ = function(t$7) {
            if (!COMPILED) {
              if (t$7 in goog.loadedModules_) return goog.loadedModules_[t$7].exports;
              if (!goog.implicitNamespaces_[t$7]) return t$7 = goog.getObjectByName(t$7), t$7 ?? null;
            }
            return null;
          }, goog.ModuleType = { ES6: `es6`, GOOG: `goog` }, goog.moduleLoaderState_ = null, goog.isInModuleLoader_ = function() {
            return goog.isInGoogModuleLoader_() || goog.isInEs6ModuleLoader_();
          }, goog.isInGoogModuleLoader_ = function() {
            return !!goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.GOOG;
          }, goog.isInEs6ModuleLoader_ = function() {
            if (goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.ES6) return true;
            var t$7 = goog.global.$jscomp;
            return t$7 && typeof t$7.getCurrentModulePath == `function` ? !!t$7.getCurrentModulePath() : false;
          }, goog.module.declareLegacyNamespace = function() {
            if (!COMPILED && !goog.isInGoogModuleLoader_()) throw Error(`goog.module.declareLegacyNamespace must be called from within a goog.module`);
            if (!COMPILED && !goog.moduleLoaderState_.moduleName) throw Error(`goog.module must be called prior to goog.module.declareLegacyNamespace.`);
            goog.moduleLoaderState_.declareLegacyNamespace = true;
          }, goog.declareModuleId = function(t$7) {
            if (!COMPILED) {
              if (!goog.isInEs6ModuleLoader_()) throw Error(`goog.declareModuleId may only be called from within an ES6 module`);
              if (goog.moduleLoaderState_ && goog.moduleLoaderState_.moduleName) throw Error(`goog.declareModuleId may only be called once per module.`);
              if (t$7 in goog.loadedModules_) throw Error(`Module with namespace "` + t$7 + `" already exists.`);
            }
            if (goog.moduleLoaderState_) goog.moduleLoaderState_.moduleName = t$7;
            else {
              var o$2 = goog.global.$jscomp;
              if (!o$2 || typeof o$2.getCurrentModulePath != `function`) throw Error(`Module with namespace "` + t$7 + `" has been loaded incorrectly.`);
              o$2 = o$2.require(o$2.getCurrentModulePath()), goog.loadedModules_[t$7] = { exports: o$2, type: goog.ModuleType.ES6, moduleId: t$7 };
            }
          }, goog.setTestOnly = function(t$7) {
            if (goog.DISALLOW_TEST_ONLY_CODE) throw t$7 ||= ``, Error(`Importing test-only code into non-debug environment` + (t$7 ? `: ` + t$7 : `.`));
          }, goog.forwardDeclare = function(t$7) {
          }, COMPILED || (goog.isProvided_ = function(t$7) {
            return t$7 in goog.loadedModules_ || !goog.implicitNamespaces_[t$7] && goog.getObjectByName(t$7) != null;
          }, goog.implicitNamespaces_ = { "goog.module": true }), goog.getObjectByName = function(t$7, o$2) {
            t$7 = t$7.split(`.`), o$2 ||= goog.global;
            for (var r$2 = 0; r$2 < t$7.length; r$2++) if (o$2 = o$2[t$7[r$2]], o$2 == null) return null;
            return o$2;
          }, goog.addDependency = function(t$7, o$2, r$2, u) {
            !COMPILED && goog.DEPENDENCIES_ENABLED && goog.debugLoader_.addDependency(t$7, o$2, r$2, u);
          }, goog.ENABLE_DEBUG_LOADER = true, goog.logToConsole_ = function(t$7) {
            goog.global.console && goog.global.console.error(t$7);
          }, goog.require = function(t$7) {
            if (!COMPILED) {
              if (goog.ENABLE_DEBUG_LOADER && goog.debugLoader_.requested(t$7), goog.isProvided_(t$7)) {
                if (goog.isInModuleLoader_()) return goog.module.getInternal_(t$7);
              } else if (goog.ENABLE_DEBUG_LOADER) {
                var o$2 = goog.moduleLoaderState_;
                goog.moduleLoaderState_ = null;
                try {
                  goog.debugLoader_.load_(t$7);
                } finally {
                  goog.moduleLoaderState_ = o$2;
                }
              }
              return null;
            }
          }, goog.requireType = function(t$7) {
            return {};
          }, goog.basePath = ``, goog.nullFunction = function() {
          }, goog.abstractMethod = function() {
            throw Error(`unimplemented abstract method`);
          }, goog.addSingletonGetter = function(t$7) {
            t$7.instance_ = void 0, t$7.getInstance = function() {
              return t$7.instance_ ? t$7.instance_ : (goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = t$7), t$7.instance_ = new t$7());
            };
          }, goog.instantiatedSingletons_ = [], goog.LOAD_MODULE_USING_EVAL = true, goog.SEAL_MODULE_EXPORTS = goog.DEBUG, goog.loadedModules_ = {}, goog.DEPENDENCIES_ENABLED = !COMPILED && goog.ENABLE_DEBUG_LOADER, goog.TRANSPILE = `detect`, goog.ASSUME_ES_MODULES_TRANSPILED = false, goog.TRANSPILE_TO_LANGUAGE = ``, goog.TRANSPILER = `transpile.js`, goog.hasBadLetScoping = null, goog.useSafari10Workaround = function() {
            if (goog.hasBadLetScoping == null) {
              try {
                var a$2 = !eval(`"use strict";let x = 1; function f() { return typeof x; };f() == "number";`);
              } catch {
                a$2 = false;
              }
              goog.hasBadLetScoping = a$2;
            }
            return goog.hasBadLetScoping;
          }, goog.workaroundSafari10EvalBug = function(t$7) {
            return `(function(){` + t$7 + `
;})();
`;
          }, goog.loadModule = function(t$7) {
            var o$2 = goog.moduleLoaderState_;
            try {
              goog.moduleLoaderState_ = { moduleName: ``, declareLegacyNamespace: false, type: goog.ModuleType.GOOG };
              var r$2 = {}, u = r$2;
              if (typeof t$7 == `function`) u = t$7.call(void 0, u);
              else if (typeof t$7 == `string`) goog.useSafari10Workaround() && (t$7 = goog.workaroundSafari10EvalBug(t$7)), u = goog.loadModuleFromSource_.call(void 0, u, t$7);
              else throw Error(`Invalid module definition`);
              var h$1 = goog.moduleLoaderState_.moduleName;
              if (typeof h$1 == `string` && h$1) goog.moduleLoaderState_.declareLegacyNamespace ? goog.constructNamespace_(h$1, u, r$2 !== u) : goog.SEAL_MODULE_EXPORTS && Object.seal && typeof u == `object` && u && Object.seal(u), goog.loadedModules_[h$1] = { exports: u, type: goog.ModuleType.GOOG, moduleId: goog.moduleLoaderState_.moduleName };
              else throw Error(`Invalid module name "` + h$1 + `"`);
            } finally {
              goog.moduleLoaderState_ = o$2;
            }
          }, goog.loadModuleFromSource_ = function(a$2, b) {
            return eval(b), a$2;
          }, goog.normalizePath_ = function(t$7) {
            t$7 = t$7.split(`/`);
            for (var o$2 = 0; o$2 < t$7.length; ) t$7[o$2] == `.` ? t$7.splice(o$2, 1) : o$2 && t$7[o$2] == `..` && t$7[o$2 - 1] && t$7[o$2 - 1] != `..` ? t$7.splice(--o$2, 2) : o$2++;
            return t$7.join(`/`);
          }, goog.loadFileSync_ = function(t$7) {
            if (goog.global.CLOSURE_LOAD_FILE_SYNC) return goog.global.CLOSURE_LOAD_FILE_SYNC(t$7);
            try {
              var o$2 = new goog.global.XMLHttpRequest();
              return o$2.open(`get`, t$7, false), o$2.send(), o$2.status == 0 || o$2.status == 200 ? o$2.responseText : null;
            } catch {
              return null;
            }
          }, goog.transpile_ = function(t$7, o$2, r$2) {
            var u = goog.global.$jscomp;
            u || (goog.global.$jscomp = u = {});
            var h$1 = u.transpile;
            if (!h$1) {
              var m$3 = goog.basePath + goog.TRANSPILER, y$1 = goog.loadFileSync_(m$3);
              if (y$1) {
                if ((function() {
                  (0, eval)(y$1 + `
//# sourceURL=` + m$3);
                }).call(goog.global), goog.global.$gwtExport && goog.global.$gwtExport.$jscomp && !goog.global.$gwtExport.$jscomp.transpile) throw Error(`The transpiler did not properly export the "transpile" method. $gwtExport: ` + JSON.stringify(goog.global.$gwtExport));
                goog.global.$jscomp.transpile = goog.global.$gwtExport.$jscomp.transpile, u = goog.global.$jscomp, h$1 = u.transpile;
              }
            }
            return h$1 ||= u.transpile = function(S, _) {
              return goog.logToConsole_(_ + ` requires transpilation but no transpiler was found.`), S;
            }, h$1(t$7, o$2, r$2);
          }, goog.typeOf = function(t$7) {
            var o$2 = typeof t$7;
            return o$2 == `object` ? t$7 ? Array.isArray(t$7) ? `array` : o$2 : `null` : o$2;
          }, goog.isArrayLike = function(t$7) {
            var o$2 = goog.typeOf(t$7);
            return o$2 == `array` || o$2 == `object` && typeof t$7.length == `number`;
          }, goog.isDateLike = function(t$7) {
            return goog.isObject(t$7) && typeof t$7.getFullYear == `function`;
          }, goog.isObject = function(t$7) {
            var o$2 = typeof t$7;
            return o$2 == `object` && t$7 != null || o$2 == `function`;
          }, goog.getUid = function(t$7) {
            return Object.prototype.hasOwnProperty.call(t$7, goog.UID_PROPERTY_) && t$7[goog.UID_PROPERTY_] || (t$7[goog.UID_PROPERTY_] = ++goog.uidCounter_);
          }, goog.hasUid = function(t$7) {
            return !!t$7[goog.UID_PROPERTY_];
          }, goog.removeUid = function(t$7) {
            t$7 !== null && `removeAttribute` in t$7 && t$7.removeAttribute(goog.UID_PROPERTY_);
            try {
              delete t$7[goog.UID_PROPERTY_];
            } catch {
            }
          }, goog.UID_PROPERTY_ = `closure_uid_` + (1e9 * Math.random() >>> 0), goog.uidCounter_ = 0, goog.cloneObject = function(t$7) {
            var o$2 = goog.typeOf(t$7);
            if (o$2 == `object` || o$2 == `array`) {
              if (typeof t$7.clone == `function`) return t$7.clone();
              for (var r$2 in o$2 = o$2 == `array` ? [] : {}, t$7) o$2[r$2] = goog.cloneObject(t$7[r$2]);
              return o$2;
            }
            return t$7;
          }, goog.bindNative_ = function(t$7, o$2, r$2) {
            return t$7.call.apply(t$7.bind, arguments);
          }, goog.bindJs_ = function(t$7, o$2, r$2) {
            if (!t$7) throw Error();
            if (2 < arguments.length) {
              var u = Array.prototype.slice.call(arguments, 2);
              return function() {
                var h$1 = Array.prototype.slice.call(arguments);
                return Array.prototype.unshift.apply(h$1, u), t$7.apply(o$2, h$1);
              };
            }
            return function() {
              return t$7.apply(o$2, arguments);
            };
          }, goog.bind = function(t$7, o$2, r$2) {
            return Function.prototype.bind && Function.prototype.bind.toString().indexOf(`native code`) != -1 ? goog.bind = goog.bindNative_ : goog.bind = goog.bindJs_, goog.bind.apply(null, arguments);
          }, goog.partial = function(t$7, o$2) {
            var r$2 = Array.prototype.slice.call(arguments, 1);
            return function() {
              var u = r$2.slice();
              return u.push.apply(u, arguments), t$7.apply(this, u);
            };
          }, goog.mixin = function(t$7, o$2) {
            for (var r$2 in o$2) t$7[r$2] = o$2[r$2];
          }, goog.now = function() {
            return Date.now();
          }, goog.globalEval = function(t$7) {
            (0, eval)(t$7);
          }, goog.getCssName = function(t$7, o$2) {
            if (String(t$7).charAt(0) == `.`) throw Error(`className passed in goog.getCssName must not start with ".". You passed: ` + t$7);
            var r$2 = function(h$1) {
              return goog.cssNameMapping_[h$1] || h$1;
            }, u = function(h$1) {
              h$1 = h$1.split(`-`);
              for (var m$3 = [], y$1 = 0; y$1 < h$1.length; y$1++) m$3.push(r$2(h$1[y$1]));
              return m$3.join(`-`);
            };
            return u = goog.cssNameMapping_ ? goog.cssNameMappingStyle_ == `BY_WHOLE` ? r$2 : u : function(h$1) {
              return h$1;
            }, t$7 = o$2 ? t$7 + `-` + u(o$2) : u(t$7), goog.global.CLOSURE_CSS_NAME_MAP_FN ? goog.global.CLOSURE_CSS_NAME_MAP_FN(t$7) : t$7;
          }, goog.setCssNameMapping = function(t$7, o$2) {
            goog.cssNameMapping_ = t$7, goog.cssNameMappingStyle_ = o$2;
          }, !COMPILED && goog.global.CLOSURE_CSS_NAME_MAPPING && (goog.cssNameMapping_ = goog.global.CLOSURE_CSS_NAME_MAPPING), goog.getMsg = function(t$7, o$2, r$2) {
            return r$2 && r$2.html && (t$7 = t$7.replace(/</g, `&lt;`)), r$2 && r$2.unescapeHtmlEntities && (t$7 = t$7.replace(/&lt;/g, `<`).replace(/&gt;/g, `>`).replace(/&apos;/g, `'`).replace(/&quot;/g, `"`).replace(/&amp;/g, `&`)), o$2 && (t$7 = t$7.replace(/\{\$([^}]+)}/g, function(u, h$1) {
              return o$2 != null && h$1 in o$2 ? o$2[h$1] : u;
            })), t$7;
          }, goog.getMsgWithFallback = function(t$7, o$2) {
            return t$7;
          }, goog.exportSymbol = function(t$7, o$2, r$2) {
            goog.exportPath_(t$7, o$2, true, r$2);
          }, goog.exportProperty = function(t$7, o$2, r$2) {
            t$7[o$2] = r$2;
          }, goog.inherits = function(t$7, o$2) {
            function r$2() {
            }
            r$2.prototype = o$2.prototype, t$7.superClass_ = o$2.prototype, t$7.prototype = new r$2(), t$7.prototype.constructor = t$7, t$7.base = function(u, h$1, m$3) {
              for (var y$1 = Array(arguments.length - 2), S = 2; S < arguments.length; S++) y$1[S - 2] = arguments[S];
              return o$2.prototype[h$1].apply(u, y$1);
            };
          }, goog.scope = function(t$7) {
            if (goog.isInModuleLoader_()) throw Error(`goog.scope is not supported within a module.`);
            t$7.call(goog.global);
          }, COMPILED || (goog.global.COMPILED = COMPILED), goog.defineClass = function(t$7, o$2) {
            var r$2 = o$2.constructor, u = o$2.statics;
            return r$2 && r$2 != Object.prototype.constructor || (r$2 = function() {
              throw Error(`cannot instantiate an interface (no constructor defined).`);
            }), r$2 = goog.defineClass.createSealingConstructor_(r$2, t$7), t$7 && goog.inherits(r$2, t$7), delete o$2.constructor, delete o$2.statics, goog.defineClass.applyProperties_(r$2.prototype, o$2), u != null && (u instanceof Function ? u(r$2) : goog.defineClass.applyProperties_(r$2, u)), r$2;
          }, goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG, goog.defineClass.createSealingConstructor_ = function(t$7, o$2) {
            return goog.defineClass.SEAL_CLASS_INSTANCES ? function() {
              var r$2 = t$7.apply(this, arguments) || this;
              return r$2[goog.UID_PROPERTY_] = r$2[goog.UID_PROPERTY_], r$2;
            } : t$7;
          }, goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = `constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf`.split(` `), goog.defineClass.applyProperties_ = function(t$7, o$2) {
            for (var r$2 in o$2) Object.prototype.hasOwnProperty.call(o$2, r$2) && (t$7[r$2] = o$2[r$2]);
            for (var u = 0; u < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length; u++) r$2 = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[u], Object.prototype.hasOwnProperty.call(o$2, r$2) && (t$7[r$2] = o$2[r$2]);
          }, !COMPILED && goog.DEPENDENCIES_ENABLED && (goog.inHtmlDocument_ = function() {
            var t$7 = goog.global.document;
            return t$7 != null && `write` in t$7;
          }, goog.isDocumentLoading_ = function() {
            var t$7 = goog.global.document;
            return t$7.attachEvent ? t$7.readyState != `complete` : t$7.readyState == `loading`;
          }, goog.findBasePath_ = function() {
            if (goog.global.CLOSURE_BASE_PATH != null && typeof goog.global.CLOSURE_BASE_PATH == `string`) goog.basePath = goog.global.CLOSURE_BASE_PATH;
            else if (goog.inHtmlDocument_()) {
              var t$7 = goog.global.document, o$2 = t$7.currentScript;
              for (t$7 = o$2 ? [o$2] : t$7.getElementsByTagName(`SCRIPT`), o$2 = t$7.length - 1; 0 <= o$2; --o$2) {
                var r$2 = t$7[o$2].src, u = r$2.lastIndexOf(`?`);
                if (u = u == -1 ? r$2.length : u, r$2.substr(u - 7, 7) == `base.js`) {
                  goog.basePath = r$2.substr(0, u - 7);
                  break;
                }
              }
            }
          }, goog.findBasePath_(), goog.Transpiler = function() {
            this.requiresTranspilation_ = null, this.transpilationTarget_ = goog.TRANSPILE_TO_LANGUAGE;
          }, goog.Transpiler.prototype.createRequiresTranspilation_ = function() {
            function a$2(t$7, o$2) {
              e$2 ? d$1[t$7] = true : o$2() ? (c$1 = t$7, d$1[t$7] = false) : e$2 = d$1[t$7] = true;
            }
            function b(g$2) {
              try {
                return !!eval(g$2);
              } catch {
                return false;
              }
            }
            var c$1 = `es3`, d$1 = { es3: false }, e$2 = false, f$3 = goog.global.navigator && goog.global.navigator.userAgent ? goog.global.navigator.userAgent : ``;
            return a$2(`es5`, function() {
              return b(`[1,].length==1`);
            }), a$2(`es6`, function() {
              return f$3.match(/Edge\/(\d+)(\.\d)*/i) ? false : b(`(()=>{"use strict";class X{constructor(){if(new.target!=String)throw 1;this.x=42}}let q=Reflect.construct(X,[],String);if(q.x!=42||!(q instanceof String))throw 1;for(const a of[2,3]){if(a==2)continue;function f(z={a}){let a=0;return z.a}{function f(){return 0;}}return f()==3}})()`);
            }), a$2(`es7`, function() {
              return b(`2 ** 2 == 4`);
            }), a$2(`es8`, function() {
              return b(`async () => 1, true`);
            }), a$2(`es9`, function() {
              return b(`({...rest} = {}), true`);
            }), a$2(`es_next`, function() {
              return false;
            }), { target: c$1, map: d$1 };
          }, goog.Transpiler.prototype.needsTranspile = function(t$7, o$2) {
            if (goog.TRANSPILE == `always`) return true;
            if (goog.TRANSPILE == `never`) return false;
            if (!this.requiresTranspilation_) {
              var r$2 = this.createRequiresTranspilation_();
              this.requiresTranspilation_ = r$2.map, this.transpilationTarget_ = this.transpilationTarget_ || r$2.target;
            }
            if (t$7 in this.requiresTranspilation_) return this.requiresTranspilation_[t$7] ? true : !(!goog.inHtmlDocument_() || o$2 != `es6` || `noModule` in goog.global.document.createElement(`script`));
            throw Error(`Unknown language mode: ` + t$7);
          }, goog.Transpiler.prototype.transpile = function(t$7, o$2) {
            return goog.transpile_(t$7, o$2, this.transpilationTarget_);
          }, goog.transpiler_ = new goog.Transpiler(), goog.protectScriptTag_ = function(t$7) {
            return t$7.replace(/<\/(SCRIPT)/gi, `\\x3c/$1`);
          }, goog.DebugLoader_ = function() {
            this.dependencies_ = {}, this.idToPath_ = {}, this.written_ = {}, this.loadingDeps_ = [], this.depsToLoad_ = [], this.paused_ = false, this.factory_ = new goog.DependencyFactory(goog.transpiler_), this.deferredCallbacks_ = {}, this.deferredQueue_ = [];
          }, goog.DebugLoader_.prototype.bootstrap = function(t$7, o$2) {
            function r$2() {
              u && (goog.global.setTimeout(u, 0), u = null);
            }
            var u = o$2;
            if (t$7.length) {
              o$2 = [];
              for (var h$1 = 0; h$1 < t$7.length; h$1++) {
                var m$3 = this.getPathFromDeps_(t$7[h$1]);
                if (!m$3) throw Error(`Unregonized namespace: ` + t$7[h$1]);
                o$2.push(this.dependencies_[m$3]);
              }
              m$3 = goog.require;
              var y$1 = 0;
              for (h$1 = 0; h$1 < t$7.length; h$1++) m$3(t$7[h$1]), o$2[h$1].onLoad(function() {
                ++y$1 == t$7.length && r$2();
              });
            } else r$2();
          }, goog.DebugLoader_.prototype.loadClosureDeps = function() {
            this.depsToLoad_.push(this.factory_.createDependency(goog.normalizePath_(goog.basePath + `deps.js`), `deps.js`, [], [], {}, false)), this.loadDeps_();
          }, goog.DebugLoader_.prototype.requested = function(t$7, o$2) {
            (t$7 = this.getPathFromDeps_(t$7)) && (o$2 || this.areDepsLoaded_(this.dependencies_[t$7].requires)) && (o$2 = this.deferredCallbacks_[t$7]) && (delete this.deferredCallbacks_[t$7], o$2());
          }, goog.DebugLoader_.prototype.setDependencyFactory = function(t$7) {
            this.factory_ = t$7;
          }, goog.DebugLoader_.prototype.load_ = function(t$7) {
            if (this.getPathFromDeps_(t$7)) {
              var o$2 = this, r$2 = [], u = function(h$1) {
                var m$3 = o$2.getPathFromDeps_(h$1);
                if (!m$3) throw Error(`Bad dependency path or symbol: ` + h$1);
                if (!o$2.written_[m$3]) {
                  for (o$2.written_[m$3] = true, h$1 = o$2.dependencies_[m$3], m$3 = 0; m$3 < h$1.requires.length; m$3++) goog.isProvided_(h$1.requires[m$3]) || u(h$1.requires[m$3]);
                  r$2.push(h$1);
                }
              };
              u(t$7), t$7 = !!this.depsToLoad_.length, this.depsToLoad_ = this.depsToLoad_.concat(r$2), this.paused_ || t$7 || this.loadDeps_();
            } else throw t$7 = `goog.require could not find: ` + t$7, goog.logToConsole_(t$7), Error(t$7);
          }, goog.DebugLoader_.prototype.loadDeps_ = function() {
            for (var t$7 = this, o$2 = this.paused_; this.depsToLoad_.length && !o$2; ) (function() {
              var r$2 = false, u = t$7.depsToLoad_.shift(), h$1 = false;
              t$7.loading_(u);
              var m$3 = { pause: function() {
                if (r$2) throw Error(`Cannot call pause after the call to load.`);
                o$2 = true;
              }, resume: function() {
                r$2 ? t$7.resume_() : o$2 = false;
              }, loaded: function() {
                if (h$1) throw Error(`Double call to loaded.`);
                h$1 = true, t$7.loaded_(u);
              }, pending: function() {
                for (var y$1 = [], S = 0; S < t$7.loadingDeps_.length; S++) y$1.push(t$7.loadingDeps_[S]);
                return y$1;
              }, setModuleState: function(y$1) {
                goog.moduleLoaderState_ = { type: y$1, moduleName: ``, declareLegacyNamespace: false };
              }, registerEs6ModuleExports: function(y$1, S, _) {
                _ && (goog.loadedModules_[_] = { exports: S, type: goog.ModuleType.ES6, moduleId: _ || `` });
              }, registerGoogModuleExports: function(y$1, S) {
                goog.loadedModules_[y$1] = { exports: S, type: goog.ModuleType.GOOG, moduleId: y$1 };
              }, clearModuleState: function() {
                goog.moduleLoaderState_ = null;
              }, defer: function(y$1) {
                if (r$2) throw Error(`Cannot register with defer after the call to load.`);
                t$7.defer_(u, y$1);
              }, areDepsLoaded: function() {
                return t$7.areDepsLoaded_(u.requires);
              } };
              try {
                u.load(m$3);
              } finally {
                r$2 = true;
              }
            })();
            o$2 && this.pause_();
          }, goog.DebugLoader_.prototype.pause_ = function() {
            this.paused_ = true;
          }, goog.DebugLoader_.prototype.resume_ = function() {
            this.paused_ && (this.paused_ = false, this.loadDeps_());
          }, goog.DebugLoader_.prototype.loading_ = function(t$7) {
            this.loadingDeps_.push(t$7);
          }, goog.DebugLoader_.prototype.loaded_ = function(t$7) {
            for (var o$2 = 0; o$2 < this.loadingDeps_.length; o$2++) if (this.loadingDeps_[o$2] == t$7) {
              this.loadingDeps_.splice(o$2, 1);
              break;
            }
            for (o$2 = 0; o$2 < this.deferredQueue_.length; o$2++) if (this.deferredQueue_[o$2] == t$7.path) {
              this.deferredQueue_.splice(o$2, 1);
              break;
            }
            if (this.loadingDeps_.length == this.deferredQueue_.length && !this.depsToLoad_.length) for (; this.deferredQueue_.length; ) this.requested(this.deferredQueue_.shift(), true);
            t$7.loaded();
          }, goog.DebugLoader_.prototype.areDepsLoaded_ = function(t$7) {
            for (var o$2 = 0; o$2 < t$7.length; o$2++) {
              var r$2 = this.getPathFromDeps_(t$7[o$2]);
              if (!r$2 || !(r$2 in this.deferredCallbacks_ || goog.isProvided_(t$7[o$2]))) return false;
            }
            return true;
          }, goog.DebugLoader_.prototype.getPathFromDeps_ = function(t$7) {
            return t$7 in this.idToPath_ ? this.idToPath_[t$7] : t$7 in this.dependencies_ ? t$7 : null;
          }, goog.DebugLoader_.prototype.defer_ = function(t$7, o$2) {
            this.deferredCallbacks_[t$7.path] = o$2, this.deferredQueue_.push(t$7.path);
          }, goog.LoadController = function() {
          }, goog.LoadController.prototype.pause = function() {
          }, goog.LoadController.prototype.resume = function() {
          }, goog.LoadController.prototype.loaded = function() {
          }, goog.LoadController.prototype.pending = function() {
          }, goog.LoadController.prototype.registerEs6ModuleExports = function(t$7, o$2, r$2) {
          }, goog.LoadController.prototype.setModuleState = function(t$7) {
          }, goog.LoadController.prototype.clearModuleState = function() {
          }, goog.LoadController.prototype.defer = function(t$7) {
          }, goog.LoadController.prototype.areDepsLoaded = function() {
          }, goog.Dependency = function(t$7, o$2, r$2, u, h$1) {
            this.path = t$7, this.relativePath = o$2, this.provides = r$2, this.requires = u, this.loadFlags = h$1, this.loaded_ = false, this.loadCallbacks_ = [];
          }, goog.Dependency.prototype.getPathName = function() {
            var t$7 = this.path, o$2 = t$7.indexOf(`://`);
            return 0 <= o$2 && (t$7 = t$7.substring(o$2 + 3), o$2 = t$7.indexOf(`/`), 0 <= o$2 && (t$7 = t$7.substring(o$2 + 1))), t$7;
          }, goog.Dependency.prototype.onLoad = function(t$7) {
            this.loaded_ ? t$7() : this.loadCallbacks_.push(t$7);
          }, goog.Dependency.prototype.loaded = function() {
            this.loaded_ = true;
            var t$7 = this.loadCallbacks_;
            this.loadCallbacks_ = [];
            for (var o$2 = 0; o$2 < t$7.length; o$2++) t$7[o$2]();
          }, goog.Dependency.defer_ = false, goog.Dependency.callbackMap_ = {}, goog.Dependency.registerCallback_ = function(t$7) {
            var o$2 = Math.random().toString(32);
            return goog.Dependency.callbackMap_[o$2] = t$7, o$2;
          }, goog.Dependency.unregisterCallback_ = function(t$7) {
            delete goog.Dependency.callbackMap_[t$7];
          }, goog.Dependency.callback_ = function(t$7, o$2) {
            if (t$7 in goog.Dependency.callbackMap_) {
              for (var r$2 = goog.Dependency.callbackMap_[t$7], u = [], h$1 = 1; h$1 < arguments.length; h$1++) u.push(arguments[h$1]);
              r$2.apply(void 0, u);
            } else throw Error(`Callback key ` + t$7 + ` does not exist (was base.js loaded more than once?).`);
          }, goog.Dependency.prototype.load = function(t$7) {
            if (goog.global.CLOSURE_IMPORT_SCRIPT) goog.global.CLOSURE_IMPORT_SCRIPT(this.path) ? t$7.loaded() : t$7.pause();
            else if (goog.inHtmlDocument_()) {
              var o$2 = goog.global.document;
              if (o$2.readyState == `complete` && !goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING) {
                if (/\bdeps.js$/.test(this.path)) {
                  t$7.loaded();
                  return;
                }
                throw Error(`Cannot write "` + this.path + `" after document load`);
              }
              var r$2 = goog.getScriptNonce();
              if (!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING && goog.isDocumentLoading_()) {
                var u = function(S) {
                  S.readyState && S.readyState != `complete` ? S.onload = u : (goog.Dependency.unregisterCallback_(h$1), t$7.loaded());
                }, h$1 = goog.Dependency.registerCallback_(u);
                r$2 = r$2 ? ` nonce="` + r$2 + `"` : ``;
                var m$3 = `<script src="` + this.path + `"` + r$2 + (goog.Dependency.defer_ ? ` defer` : ``) + ` id="script-` + h$1 + `"><\/script>`;
                m$3 += `<script` + r$2 + `>`, m$3 = goog.Dependency.defer_ ? m$3 + (`document.getElementById('script-` + h$1 + `').onload = function() {
  goog.Dependency.callback_('` + h$1 + `', this);
};
`) : m$3 + (`goog.Dependency.callback_('` + h$1 + `', document.getElementById('script-` + h$1 + `'));`), m$3 += `<\/script>`, o$2.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(m$3) : m$3);
              } else {
                var y$1 = o$2.createElement(`script`);
                y$1.defer = goog.Dependency.defer_, y$1.async = false, r$2 && (y$1.nonce = r$2), goog.DebugLoader_.IS_OLD_IE_ ? (t$7.pause(), y$1.onreadystatechange = function() {
                  (y$1.readyState == `loaded` || y$1.readyState == `complete`) && (t$7.loaded(), t$7.resume());
                }) : y$1.onload = function() {
                  y$1.onload = null, t$7.loaded();
                }, y$1.src = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScriptURL(this.path) : this.path, o$2.head.appendChild(y$1);
              }
            } else goog.logToConsole_(`Cannot use default debug loader outside of HTML documents.`), this.relativePath == `deps.js` ? (goog.logToConsole_(`Consider setting CLOSURE_IMPORT_SCRIPT before loading base.js, or setting CLOSURE_NO_DEPS to true.`), t$7.loaded()) : t$7.pause();
          }, goog.Es6ModuleDependency = function(t$7, o$2, r$2, u, h$1) {
            goog.Dependency.call(this, t$7, o$2, r$2, u, h$1);
          }, goog.inherits(goog.Es6ModuleDependency, goog.Dependency), goog.Es6ModuleDependency.prototype.load = function(t$7) {
            function o$2(C, O) {
              var I = ``, R$2 = goog.getScriptNonce();
              R$2 && (I = ` nonce="` + R$2 + `"`), C = O ? `<script type="module" crossorigin` + I + `>` + O + `<\/script>` : `<script type="module" crossorigin src="` + C + `"` + I + `><\/script>`, u.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(C) : C);
            }
            function r$2(C, O) {
              var I = u.createElement(`script`);
              I.defer = true, I.async = false, I.type = `module`, I.setAttribute(`crossorigin`, true);
              var R$2 = goog.getScriptNonce();
              R$2 && (I.nonce = R$2), O ? I.text = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScript(O) : O : I.src = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScriptURL(C) : C, u.head.appendChild(I);
            }
            if (goog.global.CLOSURE_IMPORT_SCRIPT) goog.global.CLOSURE_IMPORT_SCRIPT(this.path) ? t$7.loaded() : t$7.pause();
            else if (goog.inHtmlDocument_()) {
              var u = goog.global.document, h$1 = this;
              if (goog.isDocumentLoading_()) {
                var m$3 = o$2;
                goog.Dependency.defer_ = true;
              } else m$3 = r$2;
              var y$1 = goog.Dependency.registerCallback_(function() {
                goog.Dependency.unregisterCallback_(y$1), t$7.setModuleState(goog.ModuleType.ES6);
              });
              m$3(void 0, `goog.Dependency.callback_("` + y$1 + `")`), m$3(this.path, void 0);
              var S = goog.Dependency.registerCallback_(function(C) {
                goog.Dependency.unregisterCallback_(S), t$7.registerEs6ModuleExports(h$1.path, C, goog.moduleLoaderState_.moduleName);
              });
              m$3(void 0, `import * as m from "` + this.path + `"; goog.Dependency.callback_("` + S + `", m)`);
              var _ = goog.Dependency.registerCallback_(function() {
                goog.Dependency.unregisterCallback_(_), t$7.clearModuleState(), t$7.loaded();
              });
              m$3(void 0, `goog.Dependency.callback_("` + _ + `")`);
            } else goog.logToConsole_(`Cannot use default debug loader outside of HTML documents.`), t$7.pause();
          }, goog.TransformedDependency = function(t$7, o$2, r$2, u, h$1) {
            goog.Dependency.call(this, t$7, o$2, r$2, u, h$1), this.contents_ = null, this.lazyFetch_ = !goog.inHtmlDocument_() || !(`noModule` in goog.global.document.createElement(`script`));
          }, goog.inherits(goog.TransformedDependency, goog.Dependency), goog.TransformedDependency.prototype.load = function(t$7) {
            function o$2() {
              h$1.contents_ = goog.loadFileSync_(h$1.path), h$1.contents_ && (h$1.contents_ = h$1.transform(h$1.contents_), h$1.contents_ && (h$1.contents_ += `
//# sourceURL=` + h$1.path));
            }
            function r$2() {
              if (h$1.lazyFetch_ && o$2(), h$1.contents_) {
                m$3 && t$7.setModuleState(goog.ModuleType.ES6);
                try {
                  var O = h$1.contents_;
                  if (h$1.contents_ = null, goog.globalEval(O), m$3) var I = goog.moduleLoaderState_.moduleName;
                } finally {
                  m$3 && t$7.clearModuleState();
                }
                m$3 && goog.global.$jscomp.require.ensure([h$1.getPathName()], function() {
                  t$7.registerEs6ModuleExports(h$1.path, goog.global.$jscomp.require(h$1.getPathName()), I);
                }), t$7.loaded();
              }
            }
            function u() {
              var O = goog.global.document, I = goog.Dependency.registerCallback_(function() {
                goog.Dependency.unregisterCallback_(I), r$2();
              }), R$2 = goog.getScriptNonce();
              R$2 = `<script` + (R$2 ? ` nonce="` + R$2 + `"` : ``) + `>` + goog.protectScriptTag_(`goog.Dependency.callback_("` + I + `");`) + `<\/script>`, O.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(R$2) : R$2);
            }
            var h$1 = this;
            if (goog.global.CLOSURE_IMPORT_SCRIPT) o$2(), this.contents_ && goog.global.CLOSURE_IMPORT_SCRIPT(``, this.contents_) ? (this.contents_ = null, t$7.loaded()) : t$7.pause();
            else {
              var m$3 = this.loadFlags.module == goog.ModuleType.ES6;
              this.lazyFetch_ || o$2();
              var y$1 = 1 < t$7.pending().length, S = y$1 && goog.DebugLoader_.IS_OLD_IE_;
              if (y$1 = goog.Dependency.defer_ && (y$1 || goog.isDocumentLoading_()), S || y$1) t$7.defer(function() {
                r$2();
              });
              else {
                var _ = goog.global.document;
                if (S = goog.inHtmlDocument_() && `ActiveXObject` in goog.global, m$3 && goog.inHtmlDocument_() && goog.isDocumentLoading_() && !S) {
                  goog.Dependency.defer_ = true, t$7.pause();
                  var C = _.onreadystatechange;
                  _.onreadystatechange = function() {
                    _.readyState == `interactive` && (_.onreadystatechange = C, r$2(), t$7.resume()), typeof C == `function` && C.apply(void 0, arguments);
                  };
                } else !goog.DebugLoader_.IS_OLD_IE_ && goog.inHtmlDocument_() && goog.isDocumentLoading_() ? u() : r$2();
              }
            }
          }, goog.TransformedDependency.prototype.transform = function(t$7) {
          }, goog.TranspiledDependency = function(t$7, o$2, r$2, u, h$1, m$3) {
            goog.TransformedDependency.call(this, t$7, o$2, r$2, u, h$1), this.transpiler = m$3;
          }, goog.inherits(goog.TranspiledDependency, goog.TransformedDependency), goog.TranspiledDependency.prototype.transform = function(t$7) {
            return this.transpiler.transpile(t$7, this.getPathName());
          }, goog.PreTranspiledEs6ModuleDependency = function(t$7, o$2, r$2, u, h$1) {
            goog.TransformedDependency.call(this, t$7, o$2, r$2, u, h$1);
          }, goog.inherits(goog.PreTranspiledEs6ModuleDependency, goog.TransformedDependency), goog.PreTranspiledEs6ModuleDependency.prototype.transform = function(t$7) {
            return t$7;
          }, goog.GoogModuleDependency = function(t$7, o$2, r$2, u, h$1, m$3, y$1) {
            goog.TransformedDependency.call(this, t$7, o$2, r$2, u, h$1), this.needsTranspile_ = m$3, this.transpiler_ = y$1;
          }, goog.inherits(goog.GoogModuleDependency, goog.TransformedDependency), goog.GoogModuleDependency.prototype.transform = function(t$7) {
            return this.needsTranspile_ && (t$7 = this.transpiler_.transpile(t$7, this.getPathName())), goog.LOAD_MODULE_USING_EVAL && goog.global.JSON !== void 0 ? `goog.loadModule(` + goog.global.JSON.stringify(t$7 + `
//# sourceURL=` + this.path + `
`) + `);` : `goog.loadModule(function(exports) {"use strict";` + t$7 + `
;return exports});
//# sourceURL=` + this.path + `
`;
          }, goog.DebugLoader_.IS_OLD_IE_ = !(goog.global.atob || !goog.global.document || !goog.global.document.all), goog.DebugLoader_.prototype.addDependency = function(t$7, o$2, r$2, u) {
            o$2 ||= [], t$7 = t$7.replace(/\\/g, `/`);
            var h$1 = goog.normalizePath_(goog.basePath + t$7);
            for (u && typeof u != `boolean` || (u = u ? { module: goog.ModuleType.GOOG } : {}), r$2 = this.factory_.createDependency(h$1, t$7, o$2, r$2, u, goog.transpiler_.needsTranspile(u.lang || `es3`, u.module)), this.dependencies_[h$1] = r$2, r$2 = 0; r$2 < o$2.length; r$2++) this.idToPath_[o$2[r$2]] = h$1;
            this.idToPath_[t$7] = h$1;
          }, goog.DependencyFactory = function(t$7) {
            this.transpiler = t$7;
          }, goog.DependencyFactory.prototype.createDependency = function(t$7, o$2, r$2, u, h$1, m$3) {
            return h$1.module == goog.ModuleType.GOOG ? new goog.GoogModuleDependency(t$7, o$2, r$2, u, h$1, m$3, this.transpiler) : m$3 ? new goog.TranspiledDependency(t$7, o$2, r$2, u, h$1, this.transpiler) : h$1.module == goog.ModuleType.ES6 ? goog.TRANSPILE == `never` && goog.ASSUME_ES_MODULES_TRANSPILED ? new goog.PreTranspiledEs6ModuleDependency(t$7, o$2, r$2, u, h$1) : new goog.Es6ModuleDependency(t$7, o$2, r$2, u, h$1) : new goog.Dependency(t$7, o$2, r$2, u, h$1);
          }, goog.debugLoader_ = new goog.DebugLoader_(), goog.loadClosureDeps = function() {
            goog.debugLoader_.loadClosureDeps();
          }, goog.setDependencyFactory = function(t$7) {
            goog.debugLoader_.setDependencyFactory(t$7);
          }, goog.TRUSTED_TYPES_POLICY_ = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + `#base`) : null, goog.global.CLOSURE_NO_DEPS || goog.debugLoader_.loadClosureDeps(), goog.bootstrap = function(t$7, o$2) {
            goog.debugLoader_.bootstrap(t$7, o$2);
          }), goog.TRUSTED_TYPES_POLICY_NAME = `goog`, goog.identity_ = function(t$7) {
            return t$7;
          }, goog.createTrustedTypesPolicy = function(t$7) {
            var o$2 = null, r$2 = goog.global.trustedTypes;
            if (!r$2 || !r$2.createPolicy) return o$2;
            try {
              o$2 = r$2.createPolicy(t$7, { createHTML: goog.identity_, createScript: goog.identity_, createScriptURL: goog.identity_ });
            } catch (u) {
              goog.logToConsole_(u.message);
            }
            return o$2;
          }, goog.debug = {};
          function module$contents$goog$debug$Error_DebugError(t$7) {
            if (Error.captureStackTrace) Error.captureStackTrace(this, module$contents$goog$debug$Error_DebugError);
            else {
              var o$2 = Error().stack;
              o$2 && (this.stack = o$2);
            }
            t$7 && (this.message = String(t$7)), this.reportErrorToServer = true;
          }
          goog.inherits(module$contents$goog$debug$Error_DebugError, Error), module$contents$goog$debug$Error_DebugError.prototype.name = `CustomError`, goog.debug.Error = module$contents$goog$debug$Error_DebugError, goog.dom = {}, goog.dom.NodeType = { ELEMENT: 1, ATTRIBUTE: 2, TEXT: 3, CDATA_SECTION: 4, ENTITY_REFERENCE: 5, ENTITY: 6, PROCESSING_INSTRUCTION: 7, COMMENT: 8, DOCUMENT: 9, DOCUMENT_TYPE: 10, DOCUMENT_FRAGMENT: 11, NOTATION: 12 }, goog.asserts = {}, goog.asserts.ENABLE_ASSERTS = goog.DEBUG, goog.asserts.AssertionError = function(t$7, o$2) {
            module$contents$goog$debug$Error_DebugError.call(this, goog.asserts.subs_(t$7, o$2)), this.messagePattern = t$7;
          }, goog.inherits(goog.asserts.AssertionError, module$contents$goog$debug$Error_DebugError), goog.asserts.AssertionError.prototype.name = `AssertionError`, goog.asserts.DEFAULT_ERROR_HANDLER = function(t$7) {
            throw t$7;
          }, goog.asserts.errorHandler_ = goog.asserts.DEFAULT_ERROR_HANDLER, goog.asserts.subs_ = function(t$7, o$2) {
            t$7 = t$7.split(`%s`);
            for (var r$2 = ``, u = t$7.length - 1, h$1 = 0; h$1 < u; h$1++) r$2 += t$7[h$1] + (h$1 < o$2.length ? o$2[h$1] : `%s`);
            return r$2 + t$7[u];
          }, goog.asserts.doAssertFailure_ = function(t$7, o$2, r$2, u) {
            var h$1 = `Assertion failed`;
            if (r$2) {
              h$1 += `: ` + r$2;
              var m$3 = u;
            } else t$7 && (h$1 += `: ` + t$7, m$3 = o$2);
            t$7 = new goog.asserts.AssertionError(`` + h$1, m$3 || []), goog.asserts.errorHandler_(t$7);
          }, goog.asserts.setErrorHandler = function(t$7) {
            goog.asserts.ENABLE_ASSERTS && (goog.asserts.errorHandler_ = t$7);
          }, goog.asserts.assert = function(t$7, o$2, r$2) {
            return goog.asserts.ENABLE_ASSERTS && !t$7 && goog.asserts.doAssertFailure_(``, null, o$2, Array.prototype.slice.call(arguments, 2)), t$7;
          }, goog.asserts.assertExists = function(t$7, o$2, r$2) {
            return goog.asserts.ENABLE_ASSERTS && t$7 == null && goog.asserts.doAssertFailure_(`Expected to exist: %s.`, [t$7], o$2, Array.prototype.slice.call(arguments, 2)), t$7;
          }, goog.asserts.fail = function(t$7, o$2) {
            goog.asserts.ENABLE_ASSERTS && goog.asserts.errorHandler_(new goog.asserts.AssertionError(`Failure` + (t$7 ? `: ` + t$7 : ``), Array.prototype.slice.call(arguments, 1)));
          }, goog.asserts.assertNumber = function(t$7, o$2, r$2) {
            return goog.asserts.ENABLE_ASSERTS && typeof t$7 != `number` && goog.asserts.doAssertFailure_(`Expected number but got %s: %s.`, [goog.typeOf(t$7), t$7], o$2, Array.prototype.slice.call(arguments, 2)), t$7;
          }, goog.asserts.assertString = function(t$7, o$2, r$2) {
            return goog.asserts.ENABLE_ASSERTS && typeof t$7 != `string` && goog.asserts.doAssertFailure_(`Expected string but got %s: %s.`, [goog.typeOf(t$7), t$7], o$2, Array.prototype.slice.call(arguments, 2)), t$7;
          }, goog.asserts.assertFunction = function(t$7, o$2, r$2) {
            return goog.asserts.ENABLE_ASSERTS && typeof t$7 != `function` && goog.asserts.doAssertFailure_(`Expected function but got %s: %s.`, [goog.typeOf(t$7), t$7], o$2, Array.prototype.slice.call(arguments, 2)), t$7;
          }, goog.asserts.assertObject = function(t$7, o$2, r$2) {
            return goog.asserts.ENABLE_ASSERTS && !goog.isObject(t$7) && goog.asserts.doAssertFailure_(`Expected object but got %s: %s.`, [goog.typeOf(t$7), t$7], o$2, Array.prototype.slice.call(arguments, 2)), t$7;
          }, goog.asserts.assertArray = function(t$7, o$2, r$2) {
            return goog.asserts.ENABLE_ASSERTS && !Array.isArray(t$7) && goog.asserts.doAssertFailure_(`Expected array but got %s: %s.`, [goog.typeOf(t$7), t$7], o$2, Array.prototype.slice.call(arguments, 2)), t$7;
          }, goog.asserts.assertBoolean = function(t$7, o$2, r$2) {
            return goog.asserts.ENABLE_ASSERTS && typeof t$7 != `boolean` && goog.asserts.doAssertFailure_(`Expected boolean but got %s: %s.`, [goog.typeOf(t$7), t$7], o$2, Array.prototype.slice.call(arguments, 2)), t$7;
          }, goog.asserts.assertElement = function(t$7, o$2, r$2) {
            return !goog.asserts.ENABLE_ASSERTS || goog.isObject(t$7) && t$7.nodeType == goog.dom.NodeType.ELEMENT || goog.asserts.doAssertFailure_(`Expected Element but got %s: %s.`, [goog.typeOf(t$7), t$7], o$2, Array.prototype.slice.call(arguments, 2)), t$7;
          }, goog.asserts.assertInstanceof = function(t$7, o$2, r$2, u) {
            return !goog.asserts.ENABLE_ASSERTS || t$7 instanceof o$2 || goog.asserts.doAssertFailure_(`Expected instanceof %s but got %s.`, [goog.asserts.getType_(o$2), goog.asserts.getType_(t$7)], r$2, Array.prototype.slice.call(arguments, 3)), t$7;
          }, goog.asserts.assertFinite = function(t$7, o$2, r$2) {
            return !goog.asserts.ENABLE_ASSERTS || typeof t$7 == `number` && isFinite(t$7) || goog.asserts.doAssertFailure_(`Expected %s to be a finite number but it is not.`, [t$7], o$2, Array.prototype.slice.call(arguments, 2)), t$7;
          }, goog.asserts.assertObjectPrototypeIsIntact = function() {
            for (var t$7 in Object.prototype) goog.asserts.fail(t$7 + ` should not be enumerable in Object.prototype.`);
          }, goog.asserts.getType_ = function(t$7) {
            return t$7 instanceof Function ? t$7.displayName || t$7.name || `unknown type name` : t$7 instanceof Object ? t$7.constructor.displayName || t$7.constructor.name || Object.prototype.toString.call(t$7) : t$7 === null ? `null` : typeof t$7;
          }, goog.array = {}, goog.NATIVE_ARRAY_PROTOTYPES = goog.TRUSTED_SITE;
          var module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS = 2012 < goog.FEATURESET_YEAR;
          goog.array.ASSUME_NATIVE_FUNCTIONS = module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS;
          function module$contents$goog$array_peek(t$7) {
            return t$7[t$7.length - 1];
          }
          goog.array.peek = module$contents$goog$array_peek, goog.array.last = module$contents$goog$array_peek;
          var module$contents$goog$array_indexOf = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.indexOf) ? function(t$7, o$2, r$2) {
            return goog.asserts.assert(t$7.length != null), Array.prototype.indexOf.call(t$7, o$2, r$2);
          } : function(t$7, o$2, r$2) {
            if (r$2 = r$2 == null ? 0 : 0 > r$2 ? Math.max(0, t$7.length + r$2) : r$2, typeof t$7 == `string`) return typeof o$2 != `string` || o$2.length != 1 ? -1 : t$7.indexOf(o$2, r$2);
            for (; r$2 < t$7.length; r$2++) if (r$2 in t$7 && t$7[r$2] === o$2) return r$2;
            return -1;
          };
          goog.array.indexOf = module$contents$goog$array_indexOf;
          var module$contents$goog$array_lastIndexOf = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.lastIndexOf) ? function(t$7, o$2, r$2) {
            return goog.asserts.assert(t$7.length != null), Array.prototype.lastIndexOf.call(t$7, o$2, r$2 ?? t$7.length - 1);
          } : function(t$7, o$2, r$2) {
            if (r$2 ??= t$7.length - 1, 0 > r$2 && (r$2 = Math.max(0, t$7.length + r$2)), typeof t$7 == `string`) return typeof o$2 != `string` || o$2.length != 1 ? -1 : t$7.lastIndexOf(o$2, r$2);
            for (; 0 <= r$2; r$2--) if (r$2 in t$7 && t$7[r$2] === o$2) return r$2;
            return -1;
          };
          goog.array.lastIndexOf = module$contents$goog$array_lastIndexOf;
          var module$contents$goog$array_forEach = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.forEach) ? function(t$7, o$2, r$2) {
            goog.asserts.assert(t$7.length != null), Array.prototype.forEach.call(t$7, o$2, r$2);
          } : function(t$7, o$2, r$2) {
            for (var u = t$7.length, h$1 = typeof t$7 == `string` ? t$7.split(``) : t$7, m$3 = 0; m$3 < u; m$3++) m$3 in h$1 && o$2.call(r$2, h$1[m$3], m$3, t$7);
          };
          goog.array.forEach = module$contents$goog$array_forEach;
          function module$contents$goog$array_forEachRight(t$7, o$2, r$2) {
            var u = t$7.length, h$1 = typeof t$7 == `string` ? t$7.split(``) : t$7;
            for (--u; 0 <= u; --u) u in h$1 && o$2.call(r$2, h$1[u], u, t$7);
          }
          goog.array.forEachRight = module$contents$goog$array_forEachRight;
          var module$contents$goog$array_filter = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.filter) ? function(t$7, o$2, r$2) {
            return goog.asserts.assert(t$7.length != null), Array.prototype.filter.call(t$7, o$2, r$2);
          } : function(t$7, o$2, r$2) {
            for (var u = t$7.length, h$1 = [], m$3 = 0, y$1 = typeof t$7 == `string` ? t$7.split(``) : t$7, S = 0; S < u; S++) if (S in y$1) {
              var _ = y$1[S];
              o$2.call(r$2, _, S, t$7) && (h$1[m$3++] = _);
            }
            return h$1;
          };
          goog.array.filter = module$contents$goog$array_filter;
          var module$contents$goog$array_map = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.map) ? function(t$7, o$2, r$2) {
            return goog.asserts.assert(t$7.length != null), Array.prototype.map.call(t$7, o$2, r$2);
          } : function(t$7, o$2, r$2) {
            for (var u = t$7.length, h$1 = Array(u), m$3 = typeof t$7 == `string` ? t$7.split(``) : t$7, y$1 = 0; y$1 < u; y$1++) y$1 in m$3 && (h$1[y$1] = o$2.call(r$2, m$3[y$1], y$1, t$7));
            return h$1;
          };
          goog.array.map = module$contents$goog$array_map;
          var module$contents$goog$array_reduce = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduce) ? function(t$7, o$2, r$2, u) {
            return goog.asserts.assert(t$7.length != null), u && (o$2 = goog.bind(o$2, u)), Array.prototype.reduce.call(t$7, o$2, r$2);
          } : function(t$7, o$2, r$2, u) {
            var h$1 = r$2;
            return module$contents$goog$array_forEach(t$7, function(m$3, y$1) {
              h$1 = o$2.call(u, h$1, m$3, y$1, t$7);
            }), h$1;
          };
          goog.array.reduce = module$contents$goog$array_reduce;
          var module$contents$goog$array_reduceRight = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduceRight) ? function(t$7, o$2, r$2, u) {
            return goog.asserts.assert(t$7.length != null), goog.asserts.assert(o$2 != null), u && (o$2 = goog.bind(o$2, u)), Array.prototype.reduceRight.call(t$7, o$2, r$2);
          } : function(t$7, o$2, r$2, u) {
            var h$1 = r$2;
            return module$contents$goog$array_forEachRight(t$7, function(m$3, y$1) {
              h$1 = o$2.call(u, h$1, m$3, y$1, t$7);
            }), h$1;
          };
          goog.array.reduceRight = module$contents$goog$array_reduceRight;
          var module$contents$goog$array_some = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.some) ? function(t$7, o$2, r$2) {
            return goog.asserts.assert(t$7.length != null), Array.prototype.some.call(t$7, o$2, r$2);
          } : function(t$7, o$2, r$2) {
            for (var u = t$7.length, h$1 = typeof t$7 == `string` ? t$7.split(``) : t$7, m$3 = 0; m$3 < u; m$3++) if (m$3 in h$1 && o$2.call(r$2, h$1[m$3], m$3, t$7)) return true;
            return false;
          };
          goog.array.some = module$contents$goog$array_some;
          var module$contents$goog$array_every = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.every) ? function(t$7, o$2, r$2) {
            return goog.asserts.assert(t$7.length != null), Array.prototype.every.call(t$7, o$2, r$2);
          } : function(t$7, o$2, r$2) {
            for (var u = t$7.length, h$1 = typeof t$7 == `string` ? t$7.split(``) : t$7, m$3 = 0; m$3 < u; m$3++) if (m$3 in h$1 && !o$2.call(r$2, h$1[m$3], m$3, t$7)) return false;
            return true;
          };
          goog.array.every = module$contents$goog$array_every;
          function module$contents$goog$array_count(t$7, o$2, r$2) {
            var u = 0;
            return module$contents$goog$array_forEach(t$7, function(h$1, m$3, y$1) {
              o$2.call(r$2, h$1, m$3, y$1) && ++u;
            }, r$2), u;
          }
          goog.array.count = module$contents$goog$array_count;
          function module$contents$goog$array_find(t$7, o$2, r$2) {
            return o$2 = module$contents$goog$array_findIndex(t$7, o$2, r$2), 0 > o$2 ? null : typeof t$7 == `string` ? t$7.charAt(o$2) : t$7[o$2];
          }
          goog.array.find = module$contents$goog$array_find;
          function module$contents$goog$array_findIndex(t$7, o$2, r$2) {
            for (var u = t$7.length, h$1 = typeof t$7 == `string` ? t$7.split(``) : t$7, m$3 = 0; m$3 < u; m$3++) if (m$3 in h$1 && o$2.call(r$2, h$1[m$3], m$3, t$7)) return m$3;
            return -1;
          }
          goog.array.findIndex = module$contents$goog$array_findIndex;
          function module$contents$goog$array_findRight(t$7, o$2, r$2) {
            return o$2 = module$contents$goog$array_findIndexRight(t$7, o$2, r$2), 0 > o$2 ? null : typeof t$7 == `string` ? t$7.charAt(o$2) : t$7[o$2];
          }
          goog.array.findRight = module$contents$goog$array_findRight;
          function module$contents$goog$array_findIndexRight(t$7, o$2, r$2) {
            var u = t$7.length, h$1 = typeof t$7 == `string` ? t$7.split(``) : t$7;
            for (--u; 0 <= u; u--) if (u in h$1 && o$2.call(r$2, h$1[u], u, t$7)) return u;
            return -1;
          }
          goog.array.findIndexRight = module$contents$goog$array_findIndexRight;
          function module$contents$goog$array_contains(t$7, o$2) {
            return 0 <= module$contents$goog$array_indexOf(t$7, o$2);
          }
          goog.array.contains = module$contents$goog$array_contains;
          function module$contents$goog$array_isEmpty(t$7) {
            return t$7.length == 0;
          }
          goog.array.isEmpty = module$contents$goog$array_isEmpty;
          function module$contents$goog$array_clear(t$7) {
            if (!Array.isArray(t$7)) for (var o$2 = t$7.length - 1; 0 <= o$2; o$2--) delete t$7[o$2];
            t$7.length = 0;
          }
          goog.array.clear = module$contents$goog$array_clear;
          function module$contents$goog$array_insert(t$7, o$2) {
            module$contents$goog$array_contains(t$7, o$2) || t$7.push(o$2);
          }
          goog.array.insert = module$contents$goog$array_insert;
          function module$contents$goog$array_insertAt(t$7, o$2, r$2) {
            module$contents$goog$array_splice(t$7, r$2, 0, o$2);
          }
          goog.array.insertAt = module$contents$goog$array_insertAt;
          function module$contents$goog$array_insertArrayAt(t$7, o$2, r$2) {
            goog.partial(module$contents$goog$array_splice, t$7, r$2, 0).apply(null, o$2);
          }
          goog.array.insertArrayAt = module$contents$goog$array_insertArrayAt;
          function module$contents$goog$array_insertBefore(t$7, o$2, r$2) {
            var u;
            arguments.length == 2 || 0 > (u = module$contents$goog$array_indexOf(t$7, r$2)) ? t$7.push(o$2) : module$contents$goog$array_insertAt(t$7, o$2, u);
          }
          goog.array.insertBefore = module$contents$goog$array_insertBefore;
          function module$contents$goog$array_remove(t$7, o$2) {
            o$2 = module$contents$goog$array_indexOf(t$7, o$2);
            var r$2;
            return (r$2 = 0 <= o$2) && module$contents$goog$array_removeAt(t$7, o$2), r$2;
          }
          goog.array.remove = module$contents$goog$array_remove;
          function module$contents$goog$array_removeLast(t$7, o$2) {
            return o$2 = module$contents$goog$array_lastIndexOf(t$7, o$2), 0 <= o$2 ? (module$contents$goog$array_removeAt(t$7, o$2), true) : false;
          }
          goog.array.removeLast = module$contents$goog$array_removeLast;
          function module$contents$goog$array_removeAt(t$7, o$2) {
            return goog.asserts.assert(t$7.length != null), Array.prototype.splice.call(t$7, o$2, 1).length == 1;
          }
          goog.array.removeAt = module$contents$goog$array_removeAt;
          function module$contents$goog$array_removeIf(t$7, o$2, r$2) {
            return o$2 = module$contents$goog$array_findIndex(t$7, o$2, r$2), 0 <= o$2 ? (module$contents$goog$array_removeAt(t$7, o$2), true) : false;
          }
          goog.array.removeIf = module$contents$goog$array_removeIf;
          function module$contents$goog$array_removeAllIf(t$7, o$2, r$2) {
            var u = 0;
            return module$contents$goog$array_forEachRight(t$7, function(h$1, m$3) {
              o$2.call(r$2, h$1, m$3, t$7) && module$contents$goog$array_removeAt(t$7, m$3) && u++;
            }), u;
          }
          goog.array.removeAllIf = module$contents$goog$array_removeAllIf;
          function module$contents$goog$array_concat(t$7) {
            return Array.prototype.concat.apply([], arguments);
          }
          goog.array.concat = module$contents$goog$array_concat;
          function module$contents$goog$array_join(t$7) {
            return Array.prototype.concat.apply([], arguments);
          }
          goog.array.join = module$contents$goog$array_join;
          function module$contents$goog$array_toArray(t$7) {
            var o$2 = t$7.length;
            if (0 < o$2) {
              for (var r$2 = Array(o$2), u = 0; u < o$2; u++) r$2[u] = t$7[u];
              return r$2;
            }
            return [];
          }
          var module$contents$goog$array_clone = goog.array.toArray = module$contents$goog$array_toArray;
          goog.array.clone = module$contents$goog$array_clone;
          function module$contents$goog$array_extend(t$7, o$2) {
            for (var r$2 = 1; r$2 < arguments.length; r$2++) {
              var u = arguments[r$2];
              if (goog.isArrayLike(u)) {
                var h$1 = t$7.length || 0, m$3 = u.length || 0;
                t$7.length = h$1 + m$3;
                for (var y$1 = 0; y$1 < m$3; y$1++) t$7[h$1 + y$1] = u[y$1];
              } else t$7.push(u);
            }
          }
          goog.array.extend = module$contents$goog$array_extend;
          function module$contents$goog$array_splice(t$7, o$2, r$2, u) {
            return goog.asserts.assert(t$7.length != null), Array.prototype.splice.apply(t$7, module$contents$goog$array_slice(arguments, 1));
          }
          goog.array.splice = module$contents$goog$array_splice;
          function module$contents$goog$array_slice(t$7, o$2, r$2) {
            return goog.asserts.assert(t$7.length != null), 2 >= arguments.length ? Array.prototype.slice.call(t$7, o$2) : Array.prototype.slice.call(t$7, o$2, r$2);
          }
          goog.array.slice = module$contents$goog$array_slice;
          function module$contents$goog$array_removeDuplicates(t$7, o$2, r$2) {
            o$2 ||= t$7;
            var u = function(_) {
              return goog.isObject(_) ? `o` + goog.getUid(_) : (typeof _).charAt(0) + _;
            };
            r$2 ||= u, u = {};
            for (var h$1 = 0, m$3 = 0; m$3 < t$7.length; ) {
              var y$1 = t$7[m$3++], S = r$2(y$1);
              Object.prototype.hasOwnProperty.call(u, S) || (u[S] = true, o$2[h$1++] = y$1);
            }
            o$2.length = h$1;
          }
          goog.array.removeDuplicates = module$contents$goog$array_removeDuplicates;
          function module$contents$goog$array_binarySearch(t$7, o$2, r$2) {
            return module$contents$goog$array_binarySearch_(t$7, r$2 || module$contents$goog$array_defaultCompare, false, o$2);
          }
          goog.array.binarySearch = module$contents$goog$array_binarySearch;
          function module$contents$goog$array_binarySelect(t$7, o$2, r$2) {
            return module$contents$goog$array_binarySearch_(t$7, o$2, true, void 0, r$2);
          }
          goog.array.binarySelect = module$contents$goog$array_binarySelect;
          function module$contents$goog$array_binarySearch_(t$7, o$2, r$2, u, h$1) {
            for (var m$3 = 0, y$1 = t$7.length, S; m$3 < y$1; ) {
              var _ = m$3 + (y$1 - m$3 >>> 1), C = r$2 ? o$2.call(h$1, t$7[_], _, t$7) : o$2(u, t$7[_]);
              0 < C ? m$3 = _ + 1 : (y$1 = _, S = !C);
            }
            return S ? m$3 : -m$3 - 1;
          }
          function module$contents$goog$array_sort(t$7, o$2) {
            t$7.sort(o$2 || module$contents$goog$array_defaultCompare);
          }
          goog.array.sort = module$contents$goog$array_sort;
          function module$contents$goog$array_stableSort(t$7, o$2) {
            for (var r$2 = Array(t$7.length), u = 0; u < t$7.length; u++) r$2[u] = { index: u, value: t$7[u] };
            var h$1 = o$2 || module$contents$goog$array_defaultCompare;
            for (module$contents$goog$array_sort(r$2, function(m$3, y$1) {
              return h$1(m$3.value, y$1.value) || m$3.index - y$1.index;
            }), u = 0; u < t$7.length; u++) t$7[u] = r$2[u].value;
          }
          goog.array.stableSort = module$contents$goog$array_stableSort;
          function module$contents$goog$array_sortByKey(t$7, o$2, r$2) {
            var u = r$2 || module$contents$goog$array_defaultCompare;
            module$contents$goog$array_sort(t$7, function(h$1, m$3) {
              return u(o$2(h$1), o$2(m$3));
            });
          }
          goog.array.sortByKey = module$contents$goog$array_sortByKey;
          function module$contents$goog$array_sortObjectsByKey(t$7, o$2, r$2) {
            module$contents$goog$array_sortByKey(t$7, function(u) {
              return u[o$2];
            }, r$2);
          }
          goog.array.sortObjectsByKey = module$contents$goog$array_sortObjectsByKey;
          function module$contents$goog$array_isSorted(t$7, o$2, r$2) {
            o$2 ||= module$contents$goog$array_defaultCompare;
            for (var u = 1; u < t$7.length; u++) {
              var h$1 = o$2(t$7[u - 1], t$7[u]);
              if (0 < h$1 || h$1 == 0 && r$2) return false;
            }
            return true;
          }
          goog.array.isSorted = module$contents$goog$array_isSorted;
          function module$contents$goog$array_equals(t$7, o$2, r$2) {
            if (!goog.isArrayLike(t$7) || !goog.isArrayLike(o$2) || t$7.length != o$2.length) return false;
            var u = t$7.length;
            r$2 ||= module$contents$goog$array_defaultCompareEquality;
            for (var h$1 = 0; h$1 < u; h$1++) if (!r$2(t$7[h$1], o$2[h$1])) return false;
            return true;
          }
          goog.array.equals = module$contents$goog$array_equals;
          function module$contents$goog$array_compare3(t$7, o$2, r$2) {
            r$2 ||= module$contents$goog$array_defaultCompare;
            for (var u = Math.min(t$7.length, o$2.length), h$1 = 0; h$1 < u; h$1++) {
              var m$3 = r$2(t$7[h$1], o$2[h$1]);
              if (m$3 != 0) return m$3;
            }
            return module$contents$goog$array_defaultCompare(t$7.length, o$2.length);
          }
          goog.array.compare3 = module$contents$goog$array_compare3;
          function module$contents$goog$array_defaultCompare(t$7, o$2) {
            return t$7 > o$2 ? 1 : t$7 < o$2 ? -1 : 0;
          }
          goog.array.defaultCompare = module$contents$goog$array_defaultCompare;
          function module$contents$goog$array_inverseDefaultCompare(t$7, o$2) {
            return -module$contents$goog$array_defaultCompare(t$7, o$2);
          }
          goog.array.inverseDefaultCompare = module$contents$goog$array_inverseDefaultCompare;
          function module$contents$goog$array_defaultCompareEquality(t$7, o$2) {
            return t$7 === o$2;
          }
          goog.array.defaultCompareEquality = module$contents$goog$array_defaultCompareEquality;
          function module$contents$goog$array_binaryInsert(t$7, o$2, r$2) {
            return r$2 = module$contents$goog$array_binarySearch(t$7, o$2, r$2), 0 > r$2 ? (module$contents$goog$array_insertAt(t$7, o$2, -(r$2 + 1)), true) : false;
          }
          goog.array.binaryInsert = module$contents$goog$array_binaryInsert;
          function module$contents$goog$array_binaryRemove(t$7, o$2, r$2) {
            return o$2 = module$contents$goog$array_binarySearch(t$7, o$2, r$2), 0 <= o$2 ? module$contents$goog$array_removeAt(t$7, o$2) : false;
          }
          goog.array.binaryRemove = module$contents$goog$array_binaryRemove;
          function module$contents$goog$array_bucket(t$7, o$2, r$2) {
            for (var u = {}, h$1 = 0; h$1 < t$7.length; h$1++) {
              var m$3 = t$7[h$1], y$1 = o$2.call(r$2, m$3, h$1, t$7);
              y$1 !== void 0 && (u[y$1] || (u[y$1] = [])).push(m$3);
            }
            return u;
          }
          goog.array.bucket = module$contents$goog$array_bucket;
          function module$contents$goog$array_toObject(t$7, o$2, r$2) {
            var u = {};
            return module$contents$goog$array_forEach(t$7, function(h$1, m$3) {
              u[o$2.call(r$2, h$1, m$3, t$7)] = h$1;
            }), u;
          }
          goog.array.toObject = module$contents$goog$array_toObject;
          function module$contents$goog$array_range(t$7, o$2, r$2) {
            var u = [], h$1 = 0, m$3 = t$7;
            if (r$2 ||= 1, o$2 !== void 0 && (h$1 = t$7, m$3 = o$2), 0 > r$2 * (m$3 - h$1)) return [];
            if (0 < r$2) for (t$7 = h$1; t$7 < m$3; t$7 += r$2) u.push(t$7);
            else for (t$7 = h$1; t$7 > m$3; t$7 += r$2) u.push(t$7);
            return u;
          }
          goog.array.range = module$contents$goog$array_range;
          function module$contents$goog$array_repeat(t$7, o$2) {
            for (var r$2 = [], u = 0; u < o$2; u++) r$2[u] = t$7;
            return r$2;
          }
          goog.array.repeat = module$contents$goog$array_repeat;
          function module$contents$goog$array_flatten(t$7) {
            for (var o$2 = [], r$2 = 0; r$2 < arguments.length; r$2++) {
              var u = arguments[r$2];
              if (Array.isArray(u)) for (var h$1 = 0; h$1 < u.length; h$1 += 8192) {
                var m$3 = module$contents$goog$array_slice(u, h$1, h$1 + 8192);
                m$3 = module$contents$goog$array_flatten.apply(null, m$3);
                for (var y$1 = 0; y$1 < m$3.length; y$1++) o$2.push(m$3[y$1]);
              }
              else o$2.push(u);
            }
            return o$2;
          }
          goog.array.flatten = module$contents$goog$array_flatten;
          function module$contents$goog$array_rotate(t$7, o$2) {
            return goog.asserts.assert(t$7.length != null), t$7.length && (o$2 %= t$7.length, 0 < o$2 ? Array.prototype.unshift.apply(t$7, t$7.splice(-o$2, o$2)) : 0 > o$2 && Array.prototype.push.apply(t$7, t$7.splice(0, -o$2))), t$7;
          }
          goog.array.rotate = module$contents$goog$array_rotate;
          function module$contents$goog$array_moveItem(t$7, o$2, r$2) {
            goog.asserts.assert(0 <= o$2 && o$2 < t$7.length), goog.asserts.assert(0 <= r$2 && r$2 < t$7.length), o$2 = Array.prototype.splice.call(t$7, o$2, 1), Array.prototype.splice.call(t$7, r$2, 0, o$2[0]);
          }
          goog.array.moveItem = module$contents$goog$array_moveItem;
          function module$contents$goog$array_zip(t$7) {
            if (!arguments.length) return [];
            for (var o$2 = [], r$2 = arguments[0].length, u = 1; u < arguments.length; u++) arguments[u].length < r$2 && (r$2 = arguments[u].length);
            for (u = 0; u < r$2; u++) {
              for (var h$1 = [], m$3 = 0; m$3 < arguments.length; m$3++) h$1.push(arguments[m$3][u]);
              o$2.push(h$1);
            }
            return o$2;
          }
          goog.array.zip = module$contents$goog$array_zip;
          function module$contents$goog$array_shuffle(t$7, o$2) {
            o$2 ||= Math.random;
            for (var r$2 = t$7.length - 1; 0 < r$2; r$2--) {
              var u = Math.floor(o$2() * (r$2 + 1)), h$1 = t$7[r$2];
              t$7[r$2] = t$7[u], t$7[u] = h$1;
            }
          }
          goog.array.shuffle = module$contents$goog$array_shuffle;
          function module$contents$goog$array_copyByIndex(t$7, o$2) {
            var r$2 = [];
            return module$contents$goog$array_forEach(o$2, function(u) {
              r$2.push(t$7[u]);
            }), r$2;
          }
          goog.array.copyByIndex = module$contents$goog$array_copyByIndex;
          function module$contents$goog$array_concatMap(t$7, o$2, r$2) {
            return module$contents$goog$array_concat.apply([], module$contents$goog$array_map(t$7, o$2, r$2));
          }
          goog.array.concatMap = module$contents$goog$array_concatMap, goog.dom.asserts = {}, goog.dom.asserts.assertIsLocation = function(t$7) {
            if (goog.asserts.ENABLE_ASSERTS) {
              var o$2 = goog.dom.asserts.getWindow_(t$7);
              o$2 && (!t$7 || !(t$7 instanceof o$2.Location) && t$7 instanceof o$2.Element) && goog.asserts.fail(`Argument is not a Location (or a non-Element mock); got: %s`, goog.dom.asserts.debugStringForType_(t$7));
            }
            return t$7;
          }, goog.dom.asserts.assertIsElementType_ = function(t$7, o$2) {
            if (goog.asserts.ENABLE_ASSERTS) {
              var r$2 = goog.dom.asserts.getWindow_(t$7);
              r$2 && typeof r$2[o$2] < `u` && (t$7 && (t$7 instanceof r$2[o$2] || !(t$7 instanceof r$2.Location || t$7 instanceof r$2.Element)) || goog.asserts.fail(`Argument is not a %s (or a non-Element, non-Location mock); got: %s`, o$2, goog.dom.asserts.debugStringForType_(t$7)));
            }
            return t$7;
          }, goog.dom.asserts.assertIsHTMLAnchorElement = function(t$7) {
            return goog.dom.asserts.assertIsElementType_(t$7, `HTMLAnchorElement`);
          }, goog.dom.asserts.assertIsHTMLButtonElement = function(t$7) {
            return goog.dom.asserts.assertIsElementType_(t$7, `HTMLButtonElement`);
          }, goog.dom.asserts.assertIsHTMLLinkElement = function(t$7) {
            return goog.dom.asserts.assertIsElementType_(t$7, `HTMLLinkElement`);
          }, goog.dom.asserts.assertIsHTMLImageElement = function(t$7) {
            return goog.dom.asserts.assertIsElementType_(t$7, `HTMLImageElement`);
          }, goog.dom.asserts.assertIsHTMLAudioElement = function(t$7) {
            return goog.dom.asserts.assertIsElementType_(t$7, `HTMLAudioElement`);
          }, goog.dom.asserts.assertIsHTMLVideoElement = function(t$7) {
            return goog.dom.asserts.assertIsElementType_(t$7, `HTMLVideoElement`);
          }, goog.dom.asserts.assertIsHTMLInputElement = function(t$7) {
            return goog.dom.asserts.assertIsElementType_(t$7, `HTMLInputElement`);
          }, goog.dom.asserts.assertIsHTMLTextAreaElement = function(t$7) {
            return goog.dom.asserts.assertIsElementType_(t$7, `HTMLTextAreaElement`);
          }, goog.dom.asserts.assertIsHTMLCanvasElement = function(t$7) {
            return goog.dom.asserts.assertIsElementType_(t$7, `HTMLCanvasElement`);
          }, goog.dom.asserts.assertIsHTMLEmbedElement = function(t$7) {
            return goog.dom.asserts.assertIsElementType_(t$7, `HTMLEmbedElement`);
          }, goog.dom.asserts.assertIsHTMLFormElement = function(t$7) {
            return goog.dom.asserts.assertIsElementType_(t$7, `HTMLFormElement`);
          }, goog.dom.asserts.assertIsHTMLFrameElement = function(t$7) {
            return goog.dom.asserts.assertIsElementType_(t$7, `HTMLFrameElement`);
          }, goog.dom.asserts.assertIsHTMLIFrameElement = function(t$7) {
            return goog.dom.asserts.assertIsElementType_(t$7, `HTMLIFrameElement`);
          }, goog.dom.asserts.assertIsHTMLObjectElement = function(t$7) {
            return goog.dom.asserts.assertIsElementType_(t$7, `HTMLObjectElement`);
          }, goog.dom.asserts.assertIsHTMLScriptElement = function(t$7) {
            return goog.dom.asserts.assertIsElementType_(t$7, `HTMLScriptElement`);
          }, goog.dom.asserts.debugStringForType_ = function(t$7) {
            if (goog.isObject(t$7)) try {
              return t$7.constructor.displayName || t$7.constructor.name || Object.prototype.toString.call(t$7);
            } catch {
              return `<object could not be stringified>`;
            }
            else return t$7 === void 0 ? `undefined` : t$7 === null ? `null` : typeof t$7;
          }, goog.dom.asserts.getWindow_ = function(t$7) {
            try {
              var o$2 = t$7 && t$7.ownerDocument, r$2 = o$2 && (o$2.defaultView || o$2.parentWindow);
              if (r$2 ||= goog.global, r$2.Element && r$2.Location) return r$2;
            } catch {
            }
            return null;
          }, goog.dom.HtmlElement = function() {
          }, goog.functions = {}, goog.functions.constant = function(t$7) {
            return function() {
              return t$7;
            };
          }, goog.functions.FALSE = function() {
            return false;
          }, goog.functions.TRUE = function() {
            return true;
          }, goog.functions.NULL = function() {
            return null;
          }, goog.functions.identity = function(t$7, o$2) {
            return t$7;
          }, goog.functions.error = function(t$7) {
            return function() {
              throw Error(t$7);
            };
          }, goog.functions.fail = function(t$7) {
            return function() {
              throw t$7;
            };
          }, goog.functions.lock = function(t$7, o$2) {
            return o$2 ||= 0, function() {
              return t$7.apply(this, Array.prototype.slice.call(arguments, 0, o$2));
            };
          }, goog.functions.nth = function(t$7) {
            return function() {
              return arguments[t$7];
            };
          }, goog.functions.partialRight = function(t$7, o$2) {
            var r$2 = Array.prototype.slice.call(arguments, 1);
            return function() {
              var u = this;
              u === goog.global && (u = void 0);
              var h$1 = Array.prototype.slice.call(arguments);
              return h$1.push.apply(h$1, r$2), t$7.apply(u, h$1);
            };
          }, goog.functions.withReturnValue = function(t$7, o$2) {
            return goog.functions.sequence(t$7, goog.functions.constant(o$2));
          }, goog.functions.equalTo = function(t$7, o$2) {
            return function(r$2) {
              return o$2 ? t$7 == r$2 : t$7 === r$2;
            };
          }, goog.functions.compose = function(t$7, o$2) {
            var r$2 = arguments, u = r$2.length;
            return function() {
              var h$1;
              u && (h$1 = r$2[u - 1].apply(this, arguments));
              for (var m$3 = u - 2; 0 <= m$3; m$3--) h$1 = r$2[m$3].call(this, h$1);
              return h$1;
            };
          }, goog.functions.sequence = function(t$7) {
            var o$2 = arguments, r$2 = o$2.length;
            return function() {
              for (var u, h$1 = 0; h$1 < r$2; h$1++) u = o$2[h$1].apply(this, arguments);
              return u;
            };
          }, goog.functions.and = function(t$7) {
            var o$2 = arguments, r$2 = o$2.length;
            return function() {
              for (var u = 0; u < r$2; u++) if (!o$2[u].apply(this, arguments)) return false;
              return true;
            };
          }, goog.functions.or = function(t$7) {
            var o$2 = arguments, r$2 = o$2.length;
            return function() {
              for (var u = 0; u < r$2; u++) if (o$2[u].apply(this, arguments)) return true;
              return false;
            };
          }, goog.functions.not = function(t$7) {
            return function() {
              return !t$7.apply(this, arguments);
            };
          }, goog.functions.create = function(t$7, o$2) {
            var r$2 = function() {
            };
            return r$2.prototype = t$7.prototype, r$2 = new r$2(), t$7.apply(r$2, Array.prototype.slice.call(arguments, 1)), r$2;
          }, goog.functions.CACHE_RETURN_VALUE = true, goog.functions.cacheReturnValue = function(t$7) {
            var o$2 = false, r$2;
            return function() {
              return goog.functions.CACHE_RETURN_VALUE ? (o$2 || (r$2 = t$7(), o$2 = true), r$2) : t$7();
            };
          }, goog.functions.once = function(t$7) {
            var o$2 = t$7;
            return function() {
              if (o$2) {
                var r$2 = o$2;
                o$2 = null, r$2();
              }
            };
          }, goog.functions.debounce = function(t$7, o$2, r$2) {
            var u = 0;
            return function(h$1) {
              goog.global.clearTimeout(u);
              var m$3 = arguments;
              u = goog.global.setTimeout(function() {
                t$7.apply(r$2, m$3);
              }, o$2);
            };
          }, goog.functions.throttle = function(t$7, o$2, r$2) {
            var u = 0, h$1 = false, m$3 = [], y$1 = function() {
              u = 0, h$1 && (h$1 = false, S());
            }, S = function() {
              u = goog.global.setTimeout(y$1, o$2), t$7.apply(r$2, m$3);
            };
            return function(_) {
              m$3 = arguments, u ? h$1 = true : S();
            };
          }, goog.functions.rateLimit = function(t$7, o$2, r$2) {
            var u = 0, h$1 = function() {
              u = 0;
            };
            return function(m$3) {
              u || (u = goog.global.setTimeout(h$1, o$2), t$7.apply(r$2, arguments));
            };
          }, goog.functions.isFunction = function(t$7) {
            return typeof t$7 == `function`;
          }, goog.dom.TagName = function() {
          }, goog.dom.TagName.cast = function(t$7, o$2) {
            return t$7;
          }, goog.dom.TagName.prototype.toString = function() {
          }, goog.dom.TagName.A = `A`, goog.dom.TagName.ABBR = `ABBR`, goog.dom.TagName.ACRONYM = `ACRONYM`, goog.dom.TagName.ADDRESS = `ADDRESS`, goog.dom.TagName.APPLET = `APPLET`, goog.dom.TagName.AREA = `AREA`, goog.dom.TagName.ARTICLE = `ARTICLE`, goog.dom.TagName.ASIDE = `ASIDE`, goog.dom.TagName.AUDIO = `AUDIO`, goog.dom.TagName.B = `B`, goog.dom.TagName.BASE = `BASE`, goog.dom.TagName.BASEFONT = `BASEFONT`, goog.dom.TagName.BDI = `BDI`, goog.dom.TagName.BDO = `BDO`, goog.dom.TagName.BIG = `BIG`, goog.dom.TagName.BLOCKQUOTE = `BLOCKQUOTE`, goog.dom.TagName.BODY = `BODY`, goog.dom.TagName.BR = `BR`, goog.dom.TagName.BUTTON = `BUTTON`, goog.dom.TagName.CANVAS = `CANVAS`, goog.dom.TagName.CAPTION = `CAPTION`, goog.dom.TagName.CENTER = `CENTER`, goog.dom.TagName.CITE = `CITE`, goog.dom.TagName.CODE = `CODE`, goog.dom.TagName.COL = `COL`, goog.dom.TagName.COLGROUP = `COLGROUP`, goog.dom.TagName.COMMAND = `COMMAND`, goog.dom.TagName.DATA = `DATA`, goog.dom.TagName.DATALIST = `DATALIST`, goog.dom.TagName.DD = `DD`, goog.dom.TagName.DEL = `DEL`, goog.dom.TagName.DETAILS = `DETAILS`, goog.dom.TagName.DFN = `DFN`, goog.dom.TagName.DIALOG = `DIALOG`, goog.dom.TagName.DIR = `DIR`, goog.dom.TagName.DIV = `DIV`, goog.dom.TagName.DL = `DL`, goog.dom.TagName.DT = `DT`, goog.dom.TagName.EM = `EM`, goog.dom.TagName.EMBED = `EMBED`, goog.dom.TagName.FIELDSET = `FIELDSET`, goog.dom.TagName.FIGCAPTION = `FIGCAPTION`, goog.dom.TagName.FIGURE = `FIGURE`, goog.dom.TagName.FONT = `FONT`, goog.dom.TagName.FOOTER = `FOOTER`, goog.dom.TagName.FORM = `FORM`, goog.dom.TagName.FRAME = `FRAME`, goog.dom.TagName.FRAMESET = `FRAMESET`, goog.dom.TagName.H1 = `H1`, goog.dom.TagName.H2 = `H2`, goog.dom.TagName.H3 = `H3`, goog.dom.TagName.H4 = `H4`, goog.dom.TagName.H5 = `H5`, goog.dom.TagName.H6 = `H6`, goog.dom.TagName.HEAD = `HEAD`, goog.dom.TagName.HEADER = `HEADER`, goog.dom.TagName.HGROUP = `HGROUP`, goog.dom.TagName.HR = `HR`, goog.dom.TagName.HTML = `HTML`, goog.dom.TagName.I = `I`, goog.dom.TagName.IFRAME = `IFRAME`, goog.dom.TagName.IMG = `IMG`, goog.dom.TagName.INPUT = `INPUT`, goog.dom.TagName.INS = `INS`, goog.dom.TagName.ISINDEX = `ISINDEX`, goog.dom.TagName.KBD = `KBD`, goog.dom.TagName.KEYGEN = `KEYGEN`, goog.dom.TagName.LABEL = `LABEL`, goog.dom.TagName.LEGEND = `LEGEND`, goog.dom.TagName.LI = `LI`, goog.dom.TagName.LINK = `LINK`, goog.dom.TagName.MAIN = `MAIN`, goog.dom.TagName.MAP = `MAP`, goog.dom.TagName.MARK = `MARK`, goog.dom.TagName.MATH = `MATH`, goog.dom.TagName.MENU = `MENU`, goog.dom.TagName.MENUITEM = `MENUITEM`, goog.dom.TagName.META = `META`, goog.dom.TagName.METER = `METER`, goog.dom.TagName.NAV = `NAV`, goog.dom.TagName.NOFRAMES = `NOFRAMES`, goog.dom.TagName.NOSCRIPT = `NOSCRIPT`, goog.dom.TagName.OBJECT = `OBJECT`, goog.dom.TagName.OL = `OL`, goog.dom.TagName.OPTGROUP = `OPTGROUP`, goog.dom.TagName.OPTION = `OPTION`, goog.dom.TagName.OUTPUT = `OUTPUT`, goog.dom.TagName.P = `P`, goog.dom.TagName.PARAM = `PARAM`, goog.dom.TagName.PICTURE = `PICTURE`, goog.dom.TagName.PRE = `PRE`, goog.dom.TagName.PROGRESS = `PROGRESS`, goog.dom.TagName.Q = `Q`, goog.dom.TagName.RP = `RP`, goog.dom.TagName.RT = `RT`, goog.dom.TagName.RTC = `RTC`, goog.dom.TagName.RUBY = `RUBY`, goog.dom.TagName.S = `S`, goog.dom.TagName.SAMP = `SAMP`, goog.dom.TagName.SCRIPT = `SCRIPT`, goog.dom.TagName.SECTION = `SECTION`, goog.dom.TagName.SELECT = `SELECT`, goog.dom.TagName.SMALL = `SMALL`, goog.dom.TagName.SOURCE = `SOURCE`, goog.dom.TagName.SPAN = `SPAN`, goog.dom.TagName.STRIKE = `STRIKE`, goog.dom.TagName.STRONG = `STRONG`, goog.dom.TagName.STYLE = `STYLE`, goog.dom.TagName.SUB = `SUB`, goog.dom.TagName.SUMMARY = `SUMMARY`, goog.dom.TagName.SUP = `SUP`, goog.dom.TagName.SVG = `SVG`, goog.dom.TagName.TABLE = `TABLE`, goog.dom.TagName.TBODY = `TBODY`, goog.dom.TagName.TD = `TD`, goog.dom.TagName.TEMPLATE = `TEMPLATE`, goog.dom.TagName.TEXTAREA = `TEXTAREA`, goog.dom.TagName.TFOOT = `TFOOT`, goog.dom.TagName.TH = `TH`, goog.dom.TagName.THEAD = `THEAD`, goog.dom.TagName.TIME = `TIME`, goog.dom.TagName.TITLE = `TITLE`, goog.dom.TagName.TR = `TR`, goog.dom.TagName.TRACK = `TRACK`, goog.dom.TagName.TT = `TT`, goog.dom.TagName.U = `U`, goog.dom.TagName.UL = `UL`, goog.dom.TagName.VAR = `VAR`, goog.dom.TagName.VIDEO = `VIDEO`, goog.dom.TagName.WBR = `WBR`, goog.object = {}, goog.object.forEach = function(t$7, o$2, r$2) {
            for (var u in t$7) o$2.call(r$2, t$7[u], u, t$7);
          }, goog.object.filter = function(t$7, o$2, r$2) {
            var u = {}, h$1;
            for (h$1 in t$7) o$2.call(r$2, t$7[h$1], h$1, t$7) && (u[h$1] = t$7[h$1]);
            return u;
          }, goog.object.map = function(t$7, o$2, r$2) {
            var u = {}, h$1;
            for (h$1 in t$7) u[h$1] = o$2.call(r$2, t$7[h$1], h$1, t$7);
            return u;
          }, goog.object.some = function(t$7, o$2, r$2) {
            for (var u in t$7) if (o$2.call(r$2, t$7[u], u, t$7)) return true;
            return false;
          }, goog.object.every = function(t$7, o$2, r$2) {
            for (var u in t$7) if (!o$2.call(r$2, t$7[u], u, t$7)) return false;
            return true;
          }, goog.object.getCount = function(t$7) {
            var o$2 = 0, r$2;
            for (r$2 in t$7) o$2++;
            return o$2;
          }, goog.object.getAnyKey = function(t$7) {
            for (var o$2 in t$7) return o$2;
          }, goog.object.getAnyValue = function(t$7) {
            for (var o$2 in t$7) return t$7[o$2];
          }, goog.object.contains = function(t$7, o$2) {
            return goog.object.containsValue(t$7, o$2);
          }, goog.object.getValues = function(t$7) {
            var o$2 = [], r$2 = 0, u;
            for (u in t$7) o$2[r$2++] = t$7[u];
            return o$2;
          }, goog.object.getKeys = function(t$7) {
            var o$2 = [], r$2 = 0, u;
            for (u in t$7) o$2[r$2++] = u;
            return o$2;
          }, goog.object.getValueByKeys = function(t$7, o$2) {
            var r$2 = goog.isArrayLike(o$2), u = r$2 ? o$2 : arguments;
            for (r$2 = r$2 ? 0 : 1; r$2 < u.length; r$2++) {
              if (t$7 == null) return;
              t$7 = t$7[u[r$2]];
            }
            return t$7;
          }, goog.object.containsKey = function(t$7, o$2) {
            return t$7 !== null && o$2 in t$7;
          }, goog.object.containsValue = function(t$7, o$2) {
            for (var r$2 in t$7) if (t$7[r$2] == o$2) return true;
            return false;
          }, goog.object.findKey = function(t$7, o$2, r$2) {
            for (var u in t$7) if (o$2.call(r$2, t$7[u], u, t$7)) return u;
          }, goog.object.findValue = function(t$7, o$2, r$2) {
            return (o$2 = goog.object.findKey(t$7, o$2, r$2)) && t$7[o$2];
          }, goog.object.isEmpty = function(t$7) {
            for (var o$2 in t$7) return false;
            return true;
          }, goog.object.clear = function(t$7) {
            for (var o$2 in t$7) delete t$7[o$2];
          }, goog.object.remove = function(t$7, o$2) {
            var r$2;
            return (r$2 = o$2 in t$7) && delete t$7[o$2], r$2;
          }, goog.object.add = function(t$7, o$2, r$2) {
            if (t$7 !== null && o$2 in t$7) throw Error(`The object already contains the key "` + o$2 + `"`);
            goog.object.set(t$7, o$2, r$2);
          }, goog.object.get = function(t$7, o$2, r$2) {
            return t$7 !== null && o$2 in t$7 ? t$7[o$2] : r$2;
          }, goog.object.set = function(t$7, o$2, r$2) {
            t$7[o$2] = r$2;
          }, goog.object.setIfUndefined = function(t$7, o$2, r$2) {
            return o$2 in t$7 ? t$7[o$2] : t$7[o$2] = r$2;
          }, goog.object.setWithReturnValueIfNotSet = function(t$7, o$2, r$2) {
            return o$2 in t$7 ? t$7[o$2] : (r$2 = r$2(), t$7[o$2] = r$2);
          }, goog.object.equals = function(t$7, o$2) {
            for (var r$2 in t$7) if (!(r$2 in o$2) || t$7[r$2] !== o$2[r$2]) return false;
            for (var u in o$2) if (!(u in t$7)) return false;
            return true;
          }, goog.object.clone = function(t$7) {
            var o$2 = {}, r$2;
            for (r$2 in t$7) o$2[r$2] = t$7[r$2];
            return o$2;
          }, goog.object.unsafeClone = function(t$7) {
            if (!t$7 || typeof t$7 != `object`) return t$7;
            if (typeof t$7.clone == `function`) return t$7.clone();
            var o$2 = Array.isArray(t$7) ? [] : typeof ArrayBuffer != `function` || typeof ArrayBuffer.isView != `function` || !ArrayBuffer.isView(t$7) || t$7 instanceof DataView ? {} : new t$7.constructor(t$7.length), r$2;
            for (r$2 in t$7) o$2[r$2] = goog.object.unsafeClone(t$7[r$2]);
            return o$2;
          }, goog.object.transpose = function(t$7) {
            var o$2 = {}, r$2;
            for (r$2 in t$7) o$2[t$7[r$2]] = r$2;
            return o$2;
          }, goog.object.PROTOTYPE_FIELDS_ = `constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf`.split(` `), goog.object.extend = function(t$7, o$2) {
            for (var r$2, u, h$1 = 1; h$1 < arguments.length; h$1++) {
              for (r$2 in u = arguments[h$1], u) t$7[r$2] = u[r$2];
              for (var m$3 = 0; m$3 < goog.object.PROTOTYPE_FIELDS_.length; m$3++) r$2 = goog.object.PROTOTYPE_FIELDS_[m$3], Object.prototype.hasOwnProperty.call(u, r$2) && (t$7[r$2] = u[r$2]);
            }
          }, goog.object.create = function(t$7) {
            var o$2 = arguments.length;
            if (o$2 == 1 && Array.isArray(arguments[0])) return goog.object.create.apply(null, arguments[0]);
            if (o$2 % 2) throw Error(`Uneven number of arguments`);
            for (var r$2 = {}, u = 0; u < o$2; u += 2) r$2[arguments[u]] = arguments[u + 1];
            return r$2;
          }, goog.object.createSet = function(t$7) {
            var o$2 = arguments.length;
            if (o$2 == 1 && Array.isArray(arguments[0])) return goog.object.createSet.apply(null, arguments[0]);
            for (var r$2 = {}, u = 0; u < o$2; u++) r$2[arguments[u]] = true;
            return r$2;
          }, goog.object.createImmutableView = function(t$7) {
            var o$2 = t$7;
            return Object.isFrozen && !Object.isFrozen(t$7) && (o$2 = Object.create(t$7), Object.freeze(o$2)), o$2;
          }, goog.object.isImmutableView = function(t$7) {
            return !!Object.isFrozen && Object.isFrozen(t$7);
          }, goog.object.getAllPropertyNames = function(t$7, o$2, r$2) {
            if (!t$7) return [];
            if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) return goog.object.getKeys(t$7);
            for (var u = {}; t$7 && (t$7 !== Object.prototype || o$2) && (t$7 !== Function.prototype || r$2); ) {
              for (var h$1 = Object.getOwnPropertyNames(t$7), m$3 = 0; m$3 < h$1.length; m$3++) u[h$1[m$3]] = true;
              t$7 = Object.getPrototypeOf(t$7);
            }
            return goog.object.getKeys(u);
          }, goog.object.getSuperClass = function(t$7) {
            return (t$7 = Object.getPrototypeOf(t$7.prototype)) && t$7.constructor;
          }, goog.dom.tags = {}, goog.dom.tags.VOID_TAGS_ = { area: true, base: true, br: true, col: true, command: true, embed: true, hr: true, img: true, input: true, keygen: true, link: true, meta: true, param: true, source: true, track: true, wbr: true }, goog.dom.tags.isVoidTag = function(t$7) {
            return goog.dom.tags.VOID_TAGS_[t$7] === true;
          }, goog.string = {}, goog.string.TypedString = function() {
          }, goog.string.Const = function(t$7, o$2) {
            this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ = t$7 === goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ && o$2 || ``, this.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ = goog.string.Const.TYPE_MARKER_;
          }, goog.string.Const.prototype.implementsGoogStringTypedString = true, goog.string.Const.prototype.getTypedStringValue = function() {
            return this.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
          }, goog.DEBUG && (goog.string.Const.prototype.toString = function() {
            return `Const{` + this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ + `}`;
          }), goog.string.Const.unwrap = function(t$7) {
            return t$7 instanceof goog.string.Const && t$7.constructor === goog.string.Const && t$7.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ === goog.string.Const.TYPE_MARKER_ ? t$7.stringConstValueWithSecurityContract__googStringSecurityPrivate_ : (goog.asserts.fail(`expected object of type Const, got '` + t$7 + `'`), `type_error:Const`);
          }, goog.string.Const.from = function(t$7) {
            return new goog.string.Const(goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_, t$7);
          }, goog.string.Const.TYPE_MARKER_ = {}, goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.string.Const.EMPTY = goog.string.Const.from(``), goog.html = {}, goog.html.trustedtypes = {}, goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse = function() {
            return goog.TRUSTED_TYPES_POLICY_NAME ? (goog.html.trustedtypes.cachedPolicy_ === void 0 && (goog.html.trustedtypes.cachedPolicy_ = goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + `#html`)), goog.html.trustedtypes.cachedPolicy_) : null;
          };
          var module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE = {}, module$contents$goog$html$SafeScript_SafeScript = function(t$7, o$2) {
            this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = o$2 === module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE ? t$7 : ``, this.implementsGoogStringTypedString = true;
          };
          module$contents$goog$html$SafeScript_SafeScript.fromConstant = function(t$7) {
            return t$7 = goog.string.Const.unwrap(t$7), t$7.length === 0 ? module$contents$goog$html$SafeScript_SafeScript.EMPTY : module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(t$7);
          }, module$contents$goog$html$SafeScript_SafeScript.fromConstantAndArgs = function(t$7, o$2) {
            for (var r$2 = [], u = 1; u < arguments.length; u++) r$2.push(module$contents$goog$html$SafeScript_SafeScript.stringify_(arguments[u]));
            return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(`(` + goog.string.Const.unwrap(t$7) + `)(` + r$2.join(`, `) + `);`);
          }, module$contents$goog$html$SafeScript_SafeScript.fromJson = function(t$7) {
            return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(module$contents$goog$html$SafeScript_SafeScript.stringify_(t$7));
          }, module$contents$goog$html$SafeScript_SafeScript.prototype.getTypedStringValue = function() {
            return this.privateDoNotAccessOrElseSafeScriptWrappedValue_.toString();
          }, module$contents$goog$html$SafeScript_SafeScript.unwrap = function(t$7) {
            return module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript(t$7).toString();
          }, module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript = function(t$7) {
            return t$7 instanceof module$contents$goog$html$SafeScript_SafeScript && t$7.constructor === module$contents$goog$html$SafeScript_SafeScript ? t$7.privateDoNotAccessOrElseSafeScriptWrappedValue_ : ((0, goog.asserts.fail)(`expected object of type SafeScript, got '` + t$7 + `' of type ` + goog.typeOf(t$7)), `type_error:SafeScript`);
          }, module$contents$goog$html$SafeScript_SafeScript.stringify_ = function(t$7) {
            return JSON.stringify(t$7).replace(/</g, `\\x3c`);
          }, module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse = function(t$7) {
            var o$2 = goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();
            return t$7 = o$2 ? o$2.createScript(t$7) : t$7, new module$contents$goog$html$SafeScript_SafeScript(t$7, module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE);
          }, goog.DEBUG && (module$contents$goog$html$SafeScript_SafeScript.prototype.toString = function() {
            return `SafeScript{` + this.privateDoNotAccessOrElseSafeScriptWrappedValue_ + `}`;
          }), module$contents$goog$html$SafeScript_SafeScript.EMPTY = (function() {
            return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(``);
          })(), goog.html.SafeScript = module$contents$goog$html$SafeScript_SafeScript, goog.fs = {}, goog.fs.url = {}, goog.fs.url.createObjectUrl = function(t$7) {
            return goog.fs.url.getUrlObject_().createObjectURL(t$7);
          }, goog.fs.url.revokeObjectUrl = function(t$7) {
            goog.fs.url.getUrlObject_().revokeObjectURL(t$7);
          }, goog.fs.url.UrlObject_ = function() {
          }, goog.fs.url.UrlObject_.prototype.createObjectURL = function(t$7) {
          }, goog.fs.url.UrlObject_.prototype.revokeObjectURL = function(t$7) {
          }, goog.fs.url.getUrlObject_ = function() {
            var t$7 = goog.fs.url.findUrlObject_();
            if (t$7 != null) return t$7;
            throw Error(`This browser doesn't seem to support blob URLs`);
          }, goog.fs.url.findUrlObject_ = function() {
            return goog.global.URL !== void 0 && goog.global.URL.createObjectURL !== void 0 ? goog.global.URL : goog.global.webkitURL !== void 0 && goog.global.webkitURL.createObjectURL !== void 0 ? goog.global.webkitURL : goog.global.createObjectURL === void 0 ? null : goog.global;
          }, goog.fs.url.browserSupportsObjectUrls = function() {
            return goog.fs.url.findUrlObject_() != null;
          }, goog.fs.blob = {}, goog.fs.blob.getBlob = function(t$7) {
            var o$2 = goog.global.BlobBuilder || goog.global.WebKitBlobBuilder;
            if (o$2 !== void 0) {
              o$2 = new o$2();
              for (var r$2 = 0; r$2 < arguments.length; r$2++) o$2.append(arguments[r$2]);
              return o$2.getBlob();
            }
            return goog.fs.blob.getBlobWithProperties(module$contents$goog$array_toArray(arguments));
          }, goog.fs.blob.getBlobWithProperties = function(t$7, o$2, r$2) {
            var u = goog.global.BlobBuilder || goog.global.WebKitBlobBuilder;
            if (u !== void 0) {
              u = new u();
              for (var h$1 = 0; h$1 < t$7.length; h$1++) u.append(t$7[h$1], r$2);
              return u.getBlob(o$2);
            }
            if (goog.global.Blob !== void 0) return u = {}, o$2 && (u.type = o$2), r$2 && (u.endings = r$2), new Blob(t$7, u);
            throw Error(`This browser doesn't seem to support creating Blobs`);
          }, goog.i18n = {}, goog.i18n.bidi = {}, goog.i18n.bidi.FORCE_RTL = false, goog.i18n.bidi.IS_RTL = goog.i18n.bidi.FORCE_RTL || (goog.LOCALE.substring(0, 2).toLowerCase() == `ar` || goog.LOCALE.substring(0, 2).toLowerCase() == `fa` || goog.LOCALE.substring(0, 2).toLowerCase() == `he` || goog.LOCALE.substring(0, 2).toLowerCase() == `iw` || goog.LOCALE.substring(0, 2).toLowerCase() == `ps` || goog.LOCALE.substring(0, 2).toLowerCase() == `sd` || goog.LOCALE.substring(0, 2).toLowerCase() == `ug` || goog.LOCALE.substring(0, 2).toLowerCase() == `ur` || goog.LOCALE.substring(0, 2).toLowerCase() == `yi`) && (goog.LOCALE.length == 2 || goog.LOCALE.substring(2, 3) == `-` || goog.LOCALE.substring(2, 3) == `_`) || 3 <= goog.LOCALE.length && goog.LOCALE.substring(0, 3).toLowerCase() == `ckb` && (goog.LOCALE.length == 3 || goog.LOCALE.substring(3, 4) == `-` || goog.LOCALE.substring(3, 4) == `_`) || 7 <= goog.LOCALE.length && (goog.LOCALE.substring(2, 3) == `-` || goog.LOCALE.substring(2, 3) == `_`) && (goog.LOCALE.substring(3, 7).toLowerCase() == `adlm` || goog.LOCALE.substring(3, 7).toLowerCase() == `arab` || goog.LOCALE.substring(3, 7).toLowerCase() == `hebr` || goog.LOCALE.substring(3, 7).toLowerCase() == `nkoo` || goog.LOCALE.substring(3, 7).toLowerCase() == `rohg` || goog.LOCALE.substring(3, 7).toLowerCase() == `thaa`) || 8 <= goog.LOCALE.length && (goog.LOCALE.substring(3, 4) == `-` || goog.LOCALE.substring(3, 4) == `_`) && (goog.LOCALE.substring(4, 8).toLowerCase() == `adlm` || goog.LOCALE.substring(4, 8).toLowerCase() == `arab` || goog.LOCALE.substring(4, 8).toLowerCase() == `hebr` || goog.LOCALE.substring(4, 8).toLowerCase() == `nkoo` || goog.LOCALE.substring(4, 8).toLowerCase() == `rohg` || goog.LOCALE.substring(4, 8).toLowerCase() == `thaa`), goog.i18n.bidi.Format = { LRE: `‪`, RLE: `‫`, PDF: `‬`, LRM: `‎`, RLM: `‏` }, goog.i18n.bidi.Dir = { LTR: 1, RTL: -1, NEUTRAL: 0 }, goog.i18n.bidi.RIGHT = `right`, goog.i18n.bidi.LEFT = `left`, goog.i18n.bidi.I18N_RIGHT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.LEFT : goog.i18n.bidi.RIGHT, goog.i18n.bidi.I18N_LEFT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, goog.i18n.bidi.toDir = function(t$7, o$2) {
            return typeof t$7 == `number` ? 0 < t$7 ? goog.i18n.bidi.Dir.LTR : 0 > t$7 ? goog.i18n.bidi.Dir.RTL : o$2 ? null : goog.i18n.bidi.Dir.NEUTRAL : t$7 == null ? null : t$7 ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
          }, goog.i18n.bidi.ltrChars_ = `A-Za-zÀ-ÖØ-öø-ʸ̀-֐ऀ-῿‎Ⰰ-\uD801\uD804-\uD839\uD83C-\uDBFF豈-﬜︀-﹯﻽-￿`, goog.i18n.bidi.rtlChars_ = `֑-ۯۺ-ࣿ‏\uD802-\uD803\uD83A-\uD83Bיִ-﷿ﹰ-ﻼ`, goog.i18n.bidi.htmlSkipReg_ = /<[^>]*>|&[^;]+;/g, goog.i18n.bidi.stripHtmlIfNeeded_ = function(t$7, o$2) {
            return o$2 ? t$7.replace(goog.i18n.bidi.htmlSkipReg_, ``) : t$7;
          }, goog.i18n.bidi.rtlCharReg_ = RegExp(`[` + goog.i18n.bidi.rtlChars_ + `]`), goog.i18n.bidi.ltrCharReg_ = RegExp(`[` + goog.i18n.bidi.ltrChars_ + `]`), goog.i18n.bidi.hasAnyRtl = function(t$7, o$2) {
            return goog.i18n.bidi.rtlCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(t$7, o$2));
          }, goog.i18n.bidi.hasRtlChar = goog.i18n.bidi.hasAnyRtl, goog.i18n.bidi.hasAnyLtr = function(t$7, o$2) {
            return goog.i18n.bidi.ltrCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(t$7, o$2));
          }, goog.i18n.bidi.ltrRe_ = RegExp(`^[` + goog.i18n.bidi.ltrChars_ + `]`), goog.i18n.bidi.rtlRe_ = RegExp(`^[` + goog.i18n.bidi.rtlChars_ + `]`), goog.i18n.bidi.isRtlChar = function(t$7) {
            return goog.i18n.bidi.rtlRe_.test(t$7);
          }, goog.i18n.bidi.isLtrChar = function(t$7) {
            return goog.i18n.bidi.ltrRe_.test(t$7);
          }, goog.i18n.bidi.isNeutralChar = function(t$7) {
            return !goog.i18n.bidi.isLtrChar(t$7) && !goog.i18n.bidi.isRtlChar(t$7);
          }, goog.i18n.bidi.ltrDirCheckRe_ = RegExp(`^[^` + goog.i18n.bidi.rtlChars_ + `]*[` + goog.i18n.bidi.ltrChars_ + `]`), goog.i18n.bidi.rtlDirCheckRe_ = RegExp(`^[^` + goog.i18n.bidi.ltrChars_ + `]*[` + goog.i18n.bidi.rtlChars_ + `]`), goog.i18n.bidi.startsWithRtl = function(t$7, o$2) {
            return goog.i18n.bidi.rtlDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(t$7, o$2));
          }, goog.i18n.bidi.isRtlText = goog.i18n.bidi.startsWithRtl, goog.i18n.bidi.startsWithLtr = function(t$7, o$2) {
            return goog.i18n.bidi.ltrDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(t$7, o$2));
          }, goog.i18n.bidi.isLtrText = goog.i18n.bidi.startsWithLtr, goog.i18n.bidi.isRequiredLtrRe_ = /^http:\/\/.*/, goog.i18n.bidi.isNeutralText = function(t$7, o$2) {
            return t$7 = goog.i18n.bidi.stripHtmlIfNeeded_(t$7, o$2), goog.i18n.bidi.isRequiredLtrRe_.test(t$7) || !goog.i18n.bidi.hasAnyLtr(t$7) && !goog.i18n.bidi.hasAnyRtl(t$7);
          }, goog.i18n.bidi.ltrExitDirCheckRe_ = RegExp(`[` + goog.i18n.bidi.ltrChars_ + `][^` + goog.i18n.bidi.rtlChars_ + `]*$`), goog.i18n.bidi.rtlExitDirCheckRe_ = RegExp(`[` + goog.i18n.bidi.rtlChars_ + `][^` + goog.i18n.bidi.ltrChars_ + `]*$`), goog.i18n.bidi.endsWithLtr = function(t$7, o$2) {
            return goog.i18n.bidi.ltrExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(t$7, o$2));
          }, goog.i18n.bidi.isLtrExitText = goog.i18n.bidi.endsWithLtr, goog.i18n.bidi.endsWithRtl = function(t$7, o$2) {
            return goog.i18n.bidi.rtlExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(t$7, o$2));
          }, goog.i18n.bidi.isRtlExitText = goog.i18n.bidi.endsWithRtl, goog.i18n.bidi.rtlLocalesRe_ = /^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Adlm|Arab|Hebr|Nkoo|Rohg|Thaa))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i, goog.i18n.bidi.isRtlLanguage = function(t$7) {
            return goog.i18n.bidi.rtlLocalesRe_.test(t$7);
          }, goog.i18n.bidi.bracketGuardTextRe_ = /(\(.*?\)+)|(\[.*?\]+)|(\{.*?\}+)|(<.*?>+)/g, goog.i18n.bidi.guardBracketInText = function(t$7, o$2) {
            return o$2 = (o$2 === void 0 ? goog.i18n.bidi.hasAnyRtl(t$7) : o$2) ? goog.i18n.bidi.Format.RLM : goog.i18n.bidi.Format.LRM, t$7.replace(goog.i18n.bidi.bracketGuardTextRe_, o$2 + `$&` + o$2);
          }, goog.i18n.bidi.enforceRtlInHtml = function(t$7) {
            return t$7.charAt(0) == `<` ? t$7.replace(/<\w+/, `$& dir=rtl`) : `
<span dir=rtl>` + t$7 + `</span>`;
          }, goog.i18n.bidi.enforceRtlInText = function(t$7) {
            return goog.i18n.bidi.Format.RLE + t$7 + goog.i18n.bidi.Format.PDF;
          }, goog.i18n.bidi.enforceLtrInHtml = function(t$7) {
            return t$7.charAt(0) == `<` ? t$7.replace(/<\w+/, `$& dir=ltr`) : `
<span dir=ltr>` + t$7 + `</span>`;
          }, goog.i18n.bidi.enforceLtrInText = function(t$7) {
            return goog.i18n.bidi.Format.LRE + t$7 + goog.i18n.bidi.Format.PDF;
          }, goog.i18n.bidi.dimensionsRe_ = /:\s*([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)/g, goog.i18n.bidi.leftRe_ = /left/gi, goog.i18n.bidi.rightRe_ = /right/gi, goog.i18n.bidi.tempRe_ = /%%%%/g, goog.i18n.bidi.mirrorCSS = function(t$7) {
            return t$7.replace(goog.i18n.bidi.dimensionsRe_, `:$1 $4 $3 $2`).replace(goog.i18n.bidi.leftRe_, `%%%%`).replace(goog.i18n.bidi.rightRe_, goog.i18n.bidi.LEFT).replace(goog.i18n.bidi.tempRe_, goog.i18n.bidi.RIGHT);
          }, goog.i18n.bidi.doubleQuoteSubstituteRe_ = /([\u0591-\u05f2])"/g, goog.i18n.bidi.singleQuoteSubstituteRe_ = /([\u0591-\u05f2])'/g, goog.i18n.bidi.normalizeHebrewQuote = function(t$7) {
            return t$7.replace(goog.i18n.bidi.doubleQuoteSubstituteRe_, `$1״`).replace(goog.i18n.bidi.singleQuoteSubstituteRe_, `$1׳`);
          }, goog.i18n.bidi.wordSeparatorRe_ = /\s+/, goog.i18n.bidi.hasNumeralsRe_ = /[\d\u06f0-\u06f9]/, goog.i18n.bidi.rtlDetectionThreshold_ = 0.4, goog.i18n.bidi.estimateDirection = function(t$7, o$2) {
            var r$2 = 0, u = 0, h$1 = false;
            for (t$7 = goog.i18n.bidi.stripHtmlIfNeeded_(t$7, o$2).split(goog.i18n.bidi.wordSeparatorRe_), o$2 = 0; o$2 < t$7.length; o$2++) {
              var m$3 = t$7[o$2];
              goog.i18n.bidi.startsWithRtl(m$3) ? (r$2++, u++) : goog.i18n.bidi.isRequiredLtrRe_.test(m$3) ? h$1 = true : goog.i18n.bidi.hasAnyLtr(m$3) ? u++ : goog.i18n.bidi.hasNumeralsRe_.test(m$3) && (h$1 = true);
            }
            return u == 0 ? h$1 ? goog.i18n.bidi.Dir.LTR : goog.i18n.bidi.Dir.NEUTRAL : r$2 / u > goog.i18n.bidi.rtlDetectionThreshold_ ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
          }, goog.i18n.bidi.detectRtlDirectionality = function(t$7, o$2) {
            return goog.i18n.bidi.estimateDirection(t$7, o$2) == goog.i18n.bidi.Dir.RTL;
          }, goog.i18n.bidi.setElementDirAndAlign = function(t$7, o$2) {
            t$7 && (o$2 = goog.i18n.bidi.toDir(o$2)) && (t$7.style.textAlign = o$2 == goog.i18n.bidi.Dir.RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, t$7.dir = o$2 == goog.i18n.bidi.Dir.RTL ? `rtl` : `ltr`);
          }, goog.i18n.bidi.setElementDirByTextDirectionality = function(t$7, o$2) {
            switch (goog.i18n.bidi.estimateDirection(o$2)) {
              case goog.i18n.bidi.Dir.LTR:
                t$7.dir !== `ltr` && (t$7.dir = `ltr`);
                break;
              case goog.i18n.bidi.Dir.RTL:
                t$7.dir !== `rtl` && (t$7.dir = `rtl`);
                break;
              default:
                t$7.removeAttribute(`dir`);
            }
          }, goog.i18n.bidi.DirectionalString = function() {
          }, goog.html.TrustedResourceUrl = function(t$7, o$2) {
            this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = o$2 === goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_ ? t$7 : ``;
          }, goog.html.TrustedResourceUrl.prototype.implementsGoogStringTypedString = true, goog.html.TrustedResourceUrl.prototype.getTypedStringValue = function() {
            return this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_.toString();
          }, goog.html.TrustedResourceUrl.prototype.implementsGoogI18nBidiDirectionalString = true, goog.html.TrustedResourceUrl.prototype.getDirection = function() {
            return goog.i18n.bidi.Dir.LTR;
          }, goog.html.TrustedResourceUrl.prototype.cloneWithParams = function(t$7, o$2) {
            var r$2 = goog.html.TrustedResourceUrl.unwrap(this);
            r$2 = goog.html.TrustedResourceUrl.URL_PARAM_PARSER_.exec(r$2);
            var u = r$2[3] || ``;
            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(r$2[1] + goog.html.TrustedResourceUrl.stringifyParams_(`?`, r$2[2] || ``, t$7) + goog.html.TrustedResourceUrl.stringifyParams_(`#`, u, o$2));
          }, goog.DEBUG && (goog.html.TrustedResourceUrl.prototype.toString = function() {
            return `TrustedResourceUrl{` + this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ + `}`;
          }), goog.html.TrustedResourceUrl.unwrap = function(t$7) {
            return goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(t$7).toString();
          }, goog.html.TrustedResourceUrl.unwrapTrustedScriptURL = function(t$7) {
            return t$7 instanceof goog.html.TrustedResourceUrl && t$7.constructor === goog.html.TrustedResourceUrl ? t$7.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ : (goog.asserts.fail(`expected object of type TrustedResourceUrl, got '` + t$7 + `' of type ` + goog.typeOf(t$7)), `type_error:TrustedResourceUrl`);
          }, goog.html.TrustedResourceUrl.format = function(t$7, o$2) {
            var r$2 = goog.string.Const.unwrap(t$7);
            if (!goog.html.TrustedResourceUrl.BASE_URL_.test(r$2)) throw Error(`Invalid TrustedResourceUrl format: ` + r$2);
            return t$7 = r$2.replace(goog.html.TrustedResourceUrl.FORMAT_MARKER_, function(u, h$1) {
              if (!Object.prototype.hasOwnProperty.call(o$2, h$1)) throw Error(`Found marker, "` + h$1 + `", in format string, "` + r$2 + `", but no valid label mapping found in args: ` + JSON.stringify(o$2));
              return u = o$2[h$1], u instanceof goog.string.Const ? goog.string.Const.unwrap(u) : encodeURIComponent(String(u));
            }), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(t$7);
          }, goog.html.TrustedResourceUrl.FORMAT_MARKER_ = /%{(\w+)}/g, goog.html.TrustedResourceUrl.BASE_URL_ = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i, goog.html.TrustedResourceUrl.URL_PARAM_PARSER_ = /^([^?#]*)(\?[^#]*)?(#[\s\S]*)?/, goog.html.TrustedResourceUrl.formatWithParams = function(t$7, o$2, r$2, u) {
            return goog.html.TrustedResourceUrl.format(t$7, o$2).cloneWithParams(r$2, u);
          }, goog.html.TrustedResourceUrl.fromConstant = function(t$7) {
            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(t$7));
          }, goog.html.TrustedResourceUrl.fromConstants = function(t$7) {
            for (var o$2 = ``, r$2 = 0; r$2 < t$7.length; r$2++) o$2 += goog.string.Const.unwrap(t$7[r$2]);
            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(o$2);
          }, goog.html.TrustedResourceUrl.fromSafeScript = function(t$7) {
            return t$7 = goog.fs.blob.getBlobWithProperties([module$contents$goog$html$SafeScript_SafeScript.unwrap(t$7)], `text/javascript`), t$7 = goog.fs.url.createObjectUrl(t$7), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(t$7);
          }, goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse = function(t$7) {
            var o$2 = goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();
            return t$7 = o$2 ? o$2.createScriptURL(t$7) : t$7, new goog.html.TrustedResourceUrl(t$7, goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_);
          }, goog.html.TrustedResourceUrl.stringifyParams_ = function(t$7, o$2, r$2) {
            if (r$2 == null) return o$2;
            if (typeof r$2 == `string`) return r$2 ? t$7 + encodeURIComponent(r$2) : ``;
            for (var u in r$2) if (Object.prototype.hasOwnProperty.call(r$2, u)) {
              var h$1 = r$2[u];
              h$1 = Array.isArray(h$1) ? h$1 : [h$1];
              for (var m$3 = 0; m$3 < h$1.length; m$3++) {
                var y$1 = h$1[m$3];
                y$1 != null && (o$2 ||= t$7, o$2 += (o$2.length > t$7.length ? `&` : ``) + encodeURIComponent(u) + `=` + encodeURIComponent(String(y$1)));
              }
            }
            return o$2;
          }, goog.string.internal = {}, goog.string.internal.startsWith = function(t$7, o$2) {
            return t$7.lastIndexOf(o$2, 0) == 0;
          }, goog.string.internal.endsWith = function(t$7, o$2) {
            var r$2 = t$7.length - o$2.length;
            return 0 <= r$2 && t$7.indexOf(o$2, r$2) == r$2;
          }, goog.string.internal.caseInsensitiveStartsWith = function(t$7, o$2) {
            return goog.string.internal.caseInsensitiveCompare(o$2, t$7.substr(0, o$2.length)) == 0;
          }, goog.string.internal.caseInsensitiveEndsWith = function(t$7, o$2) {
            return goog.string.internal.caseInsensitiveCompare(o$2, t$7.substr(t$7.length - o$2.length, o$2.length)) == 0;
          }, goog.string.internal.caseInsensitiveEquals = function(t$7, o$2) {
            return t$7.toLowerCase() == o$2.toLowerCase();
          }, goog.string.internal.isEmptyOrWhitespace = function(t$7) {
            return /^[\s\xa0]*$/.test(t$7);
          }, goog.string.internal.trim = goog.TRUSTED_SITE && String.prototype.trim ? function(t$7) {
            return t$7.trim();
          } : function(t$7) {
            return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(t$7)[1];
          }, goog.string.internal.caseInsensitiveCompare = function(t$7, o$2) {
            return t$7 = String(t$7).toLowerCase(), o$2 = String(o$2).toLowerCase(), t$7 < o$2 ? -1 : t$7 == o$2 ? 0 : 1;
          }, goog.string.internal.newLineToBr = function(t$7, o$2) {
            return t$7.replace(/(\r\n|\r|\n)/g, o$2 ? `<br />` : `<br>`);
          }, goog.string.internal.htmlEscape = function(t$7, o$2) {
            if (o$2) t$7 = t$7.replace(goog.string.internal.AMP_RE_, `&amp;`).replace(goog.string.internal.LT_RE_, `&lt;`).replace(goog.string.internal.GT_RE_, `&gt;`).replace(goog.string.internal.QUOT_RE_, `&quot;`).replace(goog.string.internal.SINGLE_QUOTE_RE_, `&#39;`).replace(goog.string.internal.NULL_RE_, `&#0;`);
            else {
              if (!goog.string.internal.ALL_RE_.test(t$7)) return t$7;
              t$7.indexOf(`&`) != -1 && (t$7 = t$7.replace(goog.string.internal.AMP_RE_, `&amp;`)), t$7.indexOf(`<`) != -1 && (t$7 = t$7.replace(goog.string.internal.LT_RE_, `&lt;`)), t$7.indexOf(`>`) != -1 && (t$7 = t$7.replace(goog.string.internal.GT_RE_, `&gt;`)), t$7.indexOf(`"`) != -1 && (t$7 = t$7.replace(goog.string.internal.QUOT_RE_, `&quot;`)), t$7.indexOf(`'`) != -1 && (t$7 = t$7.replace(goog.string.internal.SINGLE_QUOTE_RE_, `&#39;`)), t$7.indexOf(`\0`) != -1 && (t$7 = t$7.replace(goog.string.internal.NULL_RE_, `&#0;`));
            }
            return t$7;
          }, goog.string.internal.AMP_RE_ = /&/g, goog.string.internal.LT_RE_ = /</g, goog.string.internal.GT_RE_ = />/g, goog.string.internal.QUOT_RE_ = /"/g, goog.string.internal.SINGLE_QUOTE_RE_ = /'/g, goog.string.internal.NULL_RE_ = /\x00/g, goog.string.internal.ALL_RE_ = /[\x00&<>"']/, goog.string.internal.whitespaceEscape = function(t$7, o$2) {
            return goog.string.internal.newLineToBr(t$7.replace(/  /g, ` &#160;`), o$2);
          }, goog.string.internal.contains = function(t$7, o$2) {
            return t$7.indexOf(o$2) != -1;
          }, goog.string.internal.caseInsensitiveContains = function(t$7, o$2) {
            return goog.string.internal.contains(t$7.toLowerCase(), o$2.toLowerCase());
          }, goog.string.internal.compareVersions = function(t$7, o$2) {
            var r$2 = 0;
            t$7 = goog.string.internal.trim(String(t$7)).split(`.`), o$2 = goog.string.internal.trim(String(o$2)).split(`.`);
            for (var u = Math.max(t$7.length, o$2.length), h$1 = 0; r$2 == 0 && h$1 < u; h$1++) {
              var m$3 = t$7[h$1] || ``, y$1 = o$2[h$1] || ``;
              do {
                if (m$3 = /(\d*)(\D*)(.*)/.exec(m$3) || [``, ``, ``, ``], y$1 = /(\d*)(\D*)(.*)/.exec(y$1) || [``, ``, ``, ``], m$3[0].length == 0 && y$1[0].length == 0) break;
                r$2 = m$3[1].length == 0 ? 0 : parseInt(m$3[1], 10);
                var S = y$1[1].length == 0 ? 0 : parseInt(y$1[1], 10);
                r$2 = goog.string.internal.compareElements_(r$2, S) || goog.string.internal.compareElements_(m$3[2].length == 0, y$1[2].length == 0) || goog.string.internal.compareElements_(m$3[2], y$1[2]), m$3 = m$3[3], y$1 = y$1[3];
              } while (r$2 == 0);
            }
            return r$2;
          }, goog.string.internal.compareElements_ = function(t$7, o$2) {
            return t$7 < o$2 ? -1 : t$7 > o$2 ? 1 : 0;
          }, goog.html.SafeUrl = function(t$7, o$2) {
            this.privateDoNotAccessOrElseSafeUrlWrappedValue_ = o$2 === goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_ ? t$7 : ``;
          }, goog.html.SafeUrl.INNOCUOUS_STRING = `about:invalid#zClosurez`, goog.html.SafeUrl.prototype.implementsGoogStringTypedString = true, goog.html.SafeUrl.prototype.getTypedStringValue = function() {
            return this.privateDoNotAccessOrElseSafeUrlWrappedValue_.toString();
          }, goog.html.SafeUrl.prototype.implementsGoogI18nBidiDirectionalString = true, goog.html.SafeUrl.prototype.getDirection = function() {
            return goog.i18n.bidi.Dir.LTR;
          }, goog.DEBUG && (goog.html.SafeUrl.prototype.toString = function() {
            return `SafeUrl{` + this.privateDoNotAccessOrElseSafeUrlWrappedValue_ + `}`;
          }), goog.html.SafeUrl.unwrap = function(t$7) {
            return t$7 instanceof goog.html.SafeUrl && t$7.constructor === goog.html.SafeUrl ? t$7.privateDoNotAccessOrElseSafeUrlWrappedValue_ : (goog.asserts.fail(`expected object of type SafeUrl, got '` + t$7 + `' of type ` + goog.typeOf(t$7)), `type_error:SafeUrl`);
          }, goog.html.SafeUrl.fromConstant = function(t$7) {
            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(t$7));
          }, goog.html.SAFE_MIME_TYPE_PATTERN_ = /^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-matroska|x-wav|wav|webm)|font\/\w+|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|video\/(?:mpeg|mp4|ogg|webm|quicktime|x-matroska))(?:;\w+=(?:\w+|"[\w;,= ]+"))*$/i, goog.html.SafeUrl.isSafeMimeType = function(t$7) {
            return goog.html.SAFE_MIME_TYPE_PATTERN_.test(t$7);
          }, goog.html.SafeUrl.fromBlob = function(t$7) {
            return t$7 = goog.html.SafeUrl.isSafeMimeType(t$7.type) ? goog.fs.url.createObjectUrl(t$7) : goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t$7);
          }, goog.html.SafeUrl.revokeObjectUrl = function(t$7) {
            t$7 = t$7.getTypedStringValue(), t$7 !== goog.html.SafeUrl.INNOCUOUS_STRING && goog.fs.url.revokeObjectUrl(t$7);
          }, goog.html.SafeUrl.fromMediaSource = function(t$7) {
            return goog.asserts.assert(`MediaSource` in goog.global, `No support for MediaSource`), t$7 = t$7 instanceof MediaSource ? goog.fs.url.createObjectUrl(t$7) : goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t$7);
          }, goog.html.DATA_URL_PATTERN_ = /^data:(.*);base64,[a-z0-9+\/]+=*$/i, goog.html.SafeUrl.tryFromDataUrl = function(t$7) {
            t$7 = String(t$7), t$7 = t$7.replace(/(%0A|%0D)/g, ``);
            var o$2 = t$7.match(goog.html.DATA_URL_PATTERN_);
            return o$2 && goog.html.SafeUrl.isSafeMimeType(o$2[1]) ? goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t$7) : null;
          }, goog.html.SafeUrl.fromDataUrl = function(t$7) {
            return goog.html.SafeUrl.tryFromDataUrl(t$7) || goog.html.SafeUrl.INNOCUOUS_URL;
          }, goog.html.SafeUrl.fromTelUrl = function(t$7) {
            return goog.string.internal.caseInsensitiveStartsWith(t$7, `tel:`) || (t$7 = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t$7);
          }, goog.html.SIP_URL_PATTERN_ = /^sip[s]?:[+a-z0-9_.!$%&'*\/=^`{|}~-]+@([a-z0-9-]+\.)+[a-z0-9]{2,63}$/i, goog.html.SafeUrl.fromSipUrl = function(t$7) {
            return goog.html.SIP_URL_PATTERN_.test(decodeURIComponent(t$7)) || (t$7 = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t$7);
          }, goog.html.SafeUrl.fromFacebookMessengerUrl = function(t$7) {
            return goog.string.internal.caseInsensitiveStartsWith(t$7, `fb-messenger://share`) || (t$7 = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t$7);
          }, goog.html.SafeUrl.fromWhatsAppUrl = function(t$7) {
            return goog.string.internal.caseInsensitiveStartsWith(t$7, `whatsapp://send`) || (t$7 = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t$7);
          }, goog.html.SafeUrl.fromSmsUrl = function(t$7) {
            return goog.string.internal.caseInsensitiveStartsWith(t$7, `sms:`) && goog.html.SafeUrl.isSmsUrlBodyValid_(t$7) || (t$7 = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t$7);
          }, goog.html.SafeUrl.isSmsUrlBodyValid_ = function(t$7) {
            var o$2 = t$7.indexOf(`#`);
            if (0 < o$2 && (t$7 = t$7.substring(0, o$2)), o$2 = t$7.match(/[?&]body=/gi), !o$2) return true;
            if (1 < o$2.length) return false;
            if (t$7 = t$7.match(/[?&]body=([^&]*)/)[1], !t$7) return true;
            try {
              decodeURIComponent(t$7);
            } catch {
              return false;
            }
            return /^(?:[a-z0-9\-_.~]|%[0-9a-f]{2})+$/i.test(t$7);
          }, goog.html.SafeUrl.fromSshUrl = function(t$7) {
            return goog.string.internal.caseInsensitiveStartsWith(t$7, `ssh://`) || (t$7 = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t$7);
          }, goog.html.SafeUrl.sanitizeChromeExtensionUrl = function(t$7, o$2) {
            return goog.html.SafeUrl.sanitizeExtensionUrl_(/^chrome-extension:\/\/([^\/]+)\//, t$7, o$2);
          }, goog.html.SafeUrl.sanitizeFirefoxExtensionUrl = function(t$7, o$2) {
            return goog.html.SafeUrl.sanitizeExtensionUrl_(/^moz-extension:\/\/([^\/]+)\//, t$7, o$2);
          }, goog.html.SafeUrl.sanitizeEdgeExtensionUrl = function(t$7, o$2) {
            return goog.html.SafeUrl.sanitizeExtensionUrl_(/^ms-browser-extension:\/\/([^\/]+)\//, t$7, o$2);
          }, goog.html.SafeUrl.sanitizeExtensionUrl_ = function(t$7, o$2, r$2) {
            return (t$7 = t$7.exec(o$2)) ? (t$7 = t$7[1], (r$2 instanceof goog.string.Const ? [goog.string.Const.unwrap(r$2)] : r$2.map(function(u) {
              return goog.string.Const.unwrap(u);
            })).indexOf(t$7) == -1 && (o$2 = goog.html.SafeUrl.INNOCUOUS_STRING)) : o$2 = goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(o$2);
          }, goog.html.SafeUrl.fromTrustedResourceUrl = function(t$7) {
            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.TrustedResourceUrl.unwrap(t$7));
          }, goog.html.SAFE_URL_PATTERN_ = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i, goog.html.SafeUrl.SAFE_URL_PATTERN = goog.html.SAFE_URL_PATTERN_, goog.html.SafeUrl.trySanitize = function(t$7) {
            return t$7 instanceof goog.html.SafeUrl ? t$7 : (t$7 = typeof t$7 == `object` && t$7.implementsGoogStringTypedString ? t$7.getTypedStringValue() : String(t$7), goog.html.SAFE_URL_PATTERN_.test(t$7) ? goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t$7) : goog.html.SafeUrl.tryFromDataUrl(t$7));
          }, goog.html.SafeUrl.sanitize = function(t$7) {
            return goog.html.SafeUrl.trySanitize(t$7) || goog.html.SafeUrl.INNOCUOUS_URL;
          }, goog.html.SafeUrl.sanitizeAssertUnchanged = function(t$7, o$2) {
            return t$7 instanceof goog.html.SafeUrl ? t$7 : (t$7 = typeof t$7 == `object` && t$7.implementsGoogStringTypedString ? t$7.getTypedStringValue() : String(t$7), o$2 && /^data:/i.test(t$7) && (o$2 = goog.html.SafeUrl.fromDataUrl(t$7), o$2.getTypedStringValue() == t$7) ? o$2 : (goog.asserts.assert(goog.html.SAFE_URL_PATTERN_.test(t$7), `%s does not match the safe URL pattern`, t$7) || (t$7 = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t$7)));
          }, goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse = function(t$7) {
            return new goog.html.SafeUrl(t$7, goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_);
          }, goog.html.SafeUrl.INNOCUOUS_URL = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.ABOUT_BLANK = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(`about:blank`), goog.html.SafeStyle = function(t$7, o$2) {
            this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = o$2 === goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_ ? t$7 : ``;
          }, goog.html.SafeStyle.prototype.implementsGoogStringTypedString = true, goog.html.SafeStyle.fromConstant = function(t$7) {
            return t$7 = goog.string.Const.unwrap(t$7), t$7.length === 0 ? goog.html.SafeStyle.EMPTY : (goog.asserts.assert(goog.string.internal.endsWith(t$7, `;`), `Last character of style string is not ';': ` + t$7), goog.asserts.assert(goog.string.internal.contains(t$7, `:`), `Style string must contain at least one ':', to specify a "name: value" pair: ` + t$7), goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(t$7));
          }, goog.html.SafeStyle.prototype.getTypedStringValue = function() {
            return this.privateDoNotAccessOrElseSafeStyleWrappedValue_;
          }, goog.DEBUG && (goog.html.SafeStyle.prototype.toString = function() {
            return `SafeStyle{` + this.privateDoNotAccessOrElseSafeStyleWrappedValue_ + `}`;
          }), goog.html.SafeStyle.unwrap = function(t$7) {
            return t$7 instanceof goog.html.SafeStyle && t$7.constructor === goog.html.SafeStyle ? t$7.privateDoNotAccessOrElseSafeStyleWrappedValue_ : (goog.asserts.fail(`expected object of type SafeStyle, got '` + t$7 + `' of type ` + goog.typeOf(t$7)), `type_error:SafeStyle`);
          }, goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse = function(t$7) {
            return new goog.html.SafeStyle(t$7, goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_);
          }, goog.html.SafeStyle.EMPTY = goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(``), goog.html.SafeStyle.INNOCUOUS_STRING = `zClosurez`, goog.html.SafeStyle.create = function(t$7) {
            var o$2 = ``, r$2;
            for (r$2 in t$7) if (Object.prototype.hasOwnProperty.call(t$7, r$2)) {
              if (!/^[-_a-zA-Z0-9]+$/.test(r$2)) throw Error(`Name allows only [-_a-zA-Z0-9], got: ` + r$2);
              var u = t$7[r$2];
              u != null && (u = Array.isArray(u) ? module$contents$goog$array_map(u, goog.html.SafeStyle.sanitizePropertyValue_).join(` `) : goog.html.SafeStyle.sanitizePropertyValue_(u), o$2 += r$2 + `:` + u + `;`);
            }
            return o$2 ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(o$2) : goog.html.SafeStyle.EMPTY;
          }, goog.html.SafeStyle.sanitizePropertyValue_ = function(t$7) {
            if (t$7 instanceof goog.html.SafeUrl) return `url("` + goog.html.SafeUrl.unwrap(t$7).replace(/</g, `%3c`).replace(/[\\"]/g, `\\$&`) + `")`;
            if (t$7 = t$7 instanceof goog.string.Const ? goog.string.Const.unwrap(t$7) : goog.html.SafeStyle.sanitizePropertyValueString_(String(t$7)), /[{;}]/.test(t$7)) throw new goog.asserts.AssertionError(`Value does not allow [{;}], got: %s.`, [t$7]);
            return t$7;
          }, goog.html.SafeStyle.sanitizePropertyValueString_ = function(t$7) {
            var o$2 = t$7.replace(goog.html.SafeStyle.FUNCTIONS_RE_, `$1`).replace(goog.html.SafeStyle.FUNCTIONS_RE_, `$1`).replace(goog.html.SafeStyle.URL_RE_, `url`);
            if (goog.html.SafeStyle.VALUE_RE_.test(o$2)) {
              if (goog.html.SafeStyle.COMMENT_RE_.test(t$7)) return goog.asserts.fail(`String value disallows comments, got: ` + t$7), goog.html.SafeStyle.INNOCUOUS_STRING;
              if (!goog.html.SafeStyle.hasBalancedQuotes_(t$7)) return goog.asserts.fail(`String value requires balanced quotes, got: ` + t$7), goog.html.SafeStyle.INNOCUOUS_STRING;
              if (!goog.html.SafeStyle.hasBalancedSquareBrackets_(t$7)) return goog.asserts.fail(`String value requires balanced square brackets and one identifier per pair of brackets, got: ` + t$7), goog.html.SafeStyle.INNOCUOUS_STRING;
            } else return goog.asserts.fail(`String value allows only ` + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + ` and simple functions, got: ` + t$7), goog.html.SafeStyle.INNOCUOUS_STRING;
            return goog.html.SafeStyle.sanitizeUrl_(t$7);
          }, goog.html.SafeStyle.hasBalancedQuotes_ = function(t$7) {
            for (var o$2 = true, r$2 = true, u = 0; u < t$7.length; u++) {
              var h$1 = t$7.charAt(u);
              h$1 == `'` && r$2 ? o$2 = !o$2 : h$1 == `"` && o$2 && (r$2 = !r$2);
            }
            return o$2 && r$2;
          }, goog.html.SafeStyle.hasBalancedSquareBrackets_ = function(t$7) {
            for (var o$2 = true, r$2 = /^[-_a-zA-Z0-9]$/, u = 0; u < t$7.length; u++) {
              var h$1 = t$7.charAt(u);
              if (h$1 == `]`) {
                if (o$2) return false;
                o$2 = true;
              } else if (h$1 == `[`) {
                if (!o$2) return false;
                o$2 = false;
              } else if (!o$2 && !r$2.test(h$1)) return false;
            }
            return o$2;
          }, goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ = `[-,."'%_!# a-zA-Z0-9\\[\\]]`, goog.html.SafeStyle.VALUE_RE_ = RegExp(`^` + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + `+$`), goog.html.SafeStyle.URL_RE_ = /\b(url\([ \t\n]*)('[ -&(-\[\]-~]*'|"[ !#-\[\]-~]*"|[!#-&*-\[\]-~]*)([ \t\n]*\))/g, goog.html.SafeStyle.ALLOWED_FUNCTIONS_ = `calc cubic-bezier fit-content hsl hsla linear-gradient matrix minmax repeat rgb rgba (rotate|scale|translate)(X|Y|Z|3d)?`.split(` `), goog.html.SafeStyle.FUNCTIONS_RE_ = RegExp(`\\b(` + goog.html.SafeStyle.ALLOWED_FUNCTIONS_.join(`|`) + `)\\([-+*/0-9a-z.%\\[\\], ]+\\)`, `g`), goog.html.SafeStyle.COMMENT_RE_ = /\/\*/, goog.html.SafeStyle.sanitizeUrl_ = function(t$7) {
            return t$7.replace(goog.html.SafeStyle.URL_RE_, function(o$2, r$2, u, h$1) {
              var m$3 = ``;
              return u = u.replace(/^(['"])(.*)\1$/, function(y$1, S, _) {
                return m$3 = S, _;
              }), o$2 = goog.html.SafeUrl.sanitize(u).getTypedStringValue(), r$2 + m$3 + o$2 + m$3 + h$1;
            });
          }, goog.html.SafeStyle.concat = function(t$7) {
            var o$2 = ``, r$2 = function(u) {
              Array.isArray(u) ? module$contents$goog$array_forEach(u, r$2) : o$2 += goog.html.SafeStyle.unwrap(u);
            };
            return module$contents$goog$array_forEach(arguments, r$2), o$2 ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(o$2) : goog.html.SafeStyle.EMPTY;
          };
          var module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE = {}, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet = function(t$7, o$2) {
            this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = o$2 === module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE ? t$7 : ``, this.implementsGoogStringTypedString = true;
          };
          module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createRule = function(t$7, o$2) {
            if ((0, goog.string.internal.contains)(t$7, `<`)) throw Error(`Selector does not allow '<', got: ` + t$7);
            var r$2 = t$7.replace(/('|")((?!\1)[^\r\n\f\\]|\\[\s\S])*\1/g, ``);
            if (!/^[-_a-zA-Z0-9#.:* ,>+~[\]()=^$|]+$/.test(r$2)) throw Error(`Selector allows only [-_a-zA-Z0-9#.:* ,>+~[\\]()=^$|] and strings, got: ` + t$7);
            if (!module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.hasBalancedBrackets_(r$2)) throw Error(`() and [] in selector must be balanced, got: ` + t$7);
            return o$2 instanceof goog.html.SafeStyle || (o$2 = goog.html.SafeStyle.create(o$2)), t$7 = t$7 + `{` + goog.html.SafeStyle.unwrap(o$2).replace(/</g, `\\3C `) + `}`, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(t$7);
          }, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.hasBalancedBrackets_ = function(t$7) {
            for (var o$2 = { "(": `)`, "[": `]` }, r$2 = [], u = 0; u < t$7.length; u++) {
              var h$1 = t$7[u];
              if (o$2[h$1]) r$2.push(o$2[h$1]);
              else if (goog.object.contains(o$2, h$1) && r$2.pop() != h$1) return false;
            }
            return r$2.length == 0;
          }, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.concat = function(t$7) {
            var o$2 = ``, r$2 = function(u) {
              Array.isArray(u) ? module$contents$goog$array_forEach(u, r$2) : o$2 += module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap(u);
            };
            return module$contents$goog$array_forEach(arguments, r$2), module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(o$2);
          }, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.fromConstant = function(t$7) {
            return t$7 = goog.string.Const.unwrap(t$7), t$7.length === 0 ? module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.EMPTY : ((0, goog.asserts.assert)(!(0, goog.string.internal.contains)(t$7, `<`), `Forbidden '<' character in style sheet string: ` + t$7), module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(t$7));
          }, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.prototype.getTypedStringValue = function() {
            return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
          }, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap = function(t$7) {
            return t$7 instanceof module$contents$goog$html$SafeStyleSheet_SafeStyleSheet && t$7.constructor === module$contents$goog$html$SafeStyleSheet_SafeStyleSheet ? t$7.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ : ((0, goog.asserts.fail)(`expected object of type SafeStyleSheet, got '` + t$7 + `' of type ` + goog.typeOf(t$7)), `type_error:SafeStyleSheet`);
          }, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse = function(t$7) {
            return new module$contents$goog$html$SafeStyleSheet_SafeStyleSheet(t$7, module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE);
          }, goog.DEBUG && (module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.prototype.toString = function() {
            return `SafeStyleSheet{` + this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ + `}`;
          }), module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.EMPTY = module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(``), goog.html.SafeStyleSheet = module$contents$goog$html$SafeStyleSheet_SafeStyleSheet, goog.labs = {}, goog.labs.userAgent = {}, goog.labs.userAgent.util = {}, goog.labs.userAgent.util.getNativeUserAgentString_ = function() {
            var t$7 = goog.labs.userAgent.util.getNavigator_();
            return (t$7 &&= t$7.userAgent) ? t$7 : ``;
          }, goog.labs.userAgent.util.getNavigator_ = function() {
            return goog.global.navigator;
          }, goog.labs.userAgent.util.userAgent_ = goog.labs.userAgent.util.getNativeUserAgentString_(), goog.labs.userAgent.util.setUserAgent = function(t$7) {
            goog.labs.userAgent.util.userAgent_ = t$7 || goog.labs.userAgent.util.getNativeUserAgentString_();
          }, goog.labs.userAgent.util.getUserAgent = function() {
            return goog.labs.userAgent.util.userAgent_;
          }, goog.labs.userAgent.util.matchUserAgent = function(t$7) {
            var o$2 = goog.labs.userAgent.util.getUserAgent();
            return goog.string.internal.contains(o$2, t$7);
          }, goog.labs.userAgent.util.matchUserAgentIgnoreCase = function(t$7) {
            var o$2 = goog.labs.userAgent.util.getUserAgent();
            return goog.string.internal.caseInsensitiveContains(o$2, t$7);
          }, goog.labs.userAgent.util.extractVersionTuples = function(t$7) {
            for (var o$2 = /(\w[\w ]+)\/([^\s]+)\s*(?:\((.*?)\))?/g, r$2 = [], u; u = o$2.exec(t$7); ) r$2.push([u[1], u[2], u[3] || void 0]);
            return r$2;
          }, goog.labs.userAgent.browser = {}, goog.labs.userAgent.browser.matchOpera_ = function() {
            return goog.labs.userAgent.util.matchUserAgent(`Opera`);
          }, goog.labs.userAgent.browser.matchIE_ = function() {
            return goog.labs.userAgent.util.matchUserAgent(`Trident`) || goog.labs.userAgent.util.matchUserAgent(`MSIE`);
          }, goog.labs.userAgent.browser.matchEdgeHtml_ = function() {
            return goog.labs.userAgent.util.matchUserAgent(`Edge`);
          }, goog.labs.userAgent.browser.matchEdgeChromium_ = function() {
            return goog.labs.userAgent.util.matchUserAgent(`Edg/`);
          }, goog.labs.userAgent.browser.matchOperaChromium_ = function() {
            return goog.labs.userAgent.util.matchUserAgent(`OPR`);
          }, goog.labs.userAgent.browser.matchFirefox_ = function() {
            return goog.labs.userAgent.util.matchUserAgent(`Firefox`) || goog.labs.userAgent.util.matchUserAgent(`FxiOS`);
          }, goog.labs.userAgent.browser.matchSafari_ = function() {
            return goog.labs.userAgent.util.matchUserAgent(`Safari`) && !(goog.labs.userAgent.browser.matchChrome_() || goog.labs.userAgent.browser.matchCoast_() || goog.labs.userAgent.browser.matchOpera_() || goog.labs.userAgent.browser.matchEdgeHtml_() || goog.labs.userAgent.browser.matchEdgeChromium_() || goog.labs.userAgent.browser.matchOperaChromium_() || goog.labs.userAgent.browser.matchFirefox_() || goog.labs.userAgent.browser.isSilk() || goog.labs.userAgent.util.matchUserAgent(`Android`));
          }, goog.labs.userAgent.browser.matchCoast_ = function() {
            return goog.labs.userAgent.util.matchUserAgent(`Coast`);
          }, goog.labs.userAgent.browser.matchIosWebview_ = function() {
            return (goog.labs.userAgent.util.matchUserAgent(`iPad`) || goog.labs.userAgent.util.matchUserAgent(`iPhone`)) && !goog.labs.userAgent.browser.matchSafari_() && !goog.labs.userAgent.browser.matchChrome_() && !goog.labs.userAgent.browser.matchCoast_() && !goog.labs.userAgent.browser.matchFirefox_() && goog.labs.userAgent.util.matchUserAgent(`AppleWebKit`);
          }, goog.labs.userAgent.browser.matchChrome_ = function() {
            return (goog.labs.userAgent.util.matchUserAgent(`Chrome`) || goog.labs.userAgent.util.matchUserAgent(`CriOS`)) && !goog.labs.userAgent.browser.matchEdgeHtml_();
          }, goog.labs.userAgent.browser.matchAndroidBrowser_ = function() {
            return goog.labs.userAgent.util.matchUserAgent(`Android`) && !(goog.labs.userAgent.browser.isChrome() || goog.labs.userAgent.browser.isFirefox() || goog.labs.userAgent.browser.isOpera() || goog.labs.userAgent.browser.isSilk());
          }, goog.labs.userAgent.browser.isOpera = goog.labs.userAgent.browser.matchOpera_, goog.labs.userAgent.browser.isIE = goog.labs.userAgent.browser.matchIE_, goog.labs.userAgent.browser.isEdge = goog.labs.userAgent.browser.matchEdgeHtml_, goog.labs.userAgent.browser.isEdgeChromium = goog.labs.userAgent.browser.matchEdgeChromium_, goog.labs.userAgent.browser.isOperaChromium = goog.labs.userAgent.browser.matchOperaChromium_, goog.labs.userAgent.browser.isFirefox = goog.labs.userAgent.browser.matchFirefox_, goog.labs.userAgent.browser.isSafari = goog.labs.userAgent.browser.matchSafari_, goog.labs.userAgent.browser.isCoast = goog.labs.userAgent.browser.matchCoast_, goog.labs.userAgent.browser.isIosWebview = goog.labs.userAgent.browser.matchIosWebview_, goog.labs.userAgent.browser.isChrome = goog.labs.userAgent.browser.matchChrome_, goog.labs.userAgent.browser.isAndroidBrowser = goog.labs.userAgent.browser.matchAndroidBrowser_, goog.labs.userAgent.browser.isSilk = function() {
            return goog.labs.userAgent.util.matchUserAgent(`Silk`);
          }, goog.labs.userAgent.browser.getVersion = function() {
            function t$7(h$1) {
              return h$1 = module$contents$goog$array_find(h$1, u), r$2[h$1] || ``;
            }
            var o$2 = goog.labs.userAgent.util.getUserAgent();
            if (goog.labs.userAgent.browser.isIE()) return goog.labs.userAgent.browser.getIEVersion_(o$2);
            o$2 = goog.labs.userAgent.util.extractVersionTuples(o$2);
            var r$2 = {};
            module$contents$goog$array_forEach(o$2, function(h$1) {
              r$2[h$1[0]] = h$1[1];
            });
            var u = goog.partial(goog.object.containsKey, r$2);
            return goog.labs.userAgent.browser.isOpera() ? t$7([`Version`, `Opera`]) : goog.labs.userAgent.browser.isEdge() ? t$7([`Edge`]) : goog.labs.userAgent.browser.isEdgeChromium() ? t$7([`Edg`]) : goog.labs.userAgent.browser.isChrome() ? t$7([`Chrome`, `CriOS`, `HeadlessChrome`]) : (o$2 = o$2[2]) && o$2[1] || ``;
          }, goog.labs.userAgent.browser.isVersionOrHigher = function(t$7) {
            return 0 <= goog.string.internal.compareVersions(goog.labs.userAgent.browser.getVersion(), t$7);
          }, goog.labs.userAgent.browser.getIEVersion_ = function(t$7) {
            var o$2 = /rv: *([\d\.]*)/.exec(t$7);
            if (o$2 && o$2[1]) return o$2[1];
            o$2 = ``;
            var r$2 = /MSIE +([\d\.]+)/.exec(t$7);
            if (r$2 && r$2[1]) if (t$7 = /Trident\/(\d.\d)/.exec(t$7), r$2[1] == `7.0`) if (t$7 && t$7[1]) switch (t$7[1]) {
              case `4.0`:
                o$2 = `8.0`;
                break;
              case `5.0`:
                o$2 = `9.0`;
                break;
              case `6.0`:
                o$2 = `10.0`;
                break;
              case `7.0`:
                o$2 = `11.0`;
            }
            else o$2 = `7.0`;
            else o$2 = r$2[1];
            return o$2;
          }, goog.html.SafeHtml = function(t$7, o$2, r$2) {
            this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = r$2 === goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_ ? t$7 : ``, this.dir_ = o$2;
          }, goog.html.SafeHtml.ENABLE_ERROR_MESSAGES = goog.DEBUG, goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE = true, goog.html.SafeHtml.prototype.implementsGoogI18nBidiDirectionalString = true, goog.html.SafeHtml.prototype.getDirection = function() {
            return this.dir_;
          }, goog.html.SafeHtml.prototype.implementsGoogStringTypedString = true, goog.html.SafeHtml.prototype.getTypedStringValue = function() {
            return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_.toString();
          }, goog.DEBUG && (goog.html.SafeHtml.prototype.toString = function() {
            return `SafeHtml{` + this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ + `}`;
          }), goog.html.SafeHtml.unwrap = function(t$7) {
            return goog.html.SafeHtml.unwrapTrustedHTML(t$7).toString();
          }, goog.html.SafeHtml.unwrapTrustedHTML = function(t$7) {
            return t$7 instanceof goog.html.SafeHtml && t$7.constructor === goog.html.SafeHtml ? t$7.privateDoNotAccessOrElseSafeHtmlWrappedValue_ : (goog.asserts.fail(`expected object of type SafeHtml, got '` + t$7 + `' of type ` + goog.typeOf(t$7)), `type_error:SafeHtml`);
          }, goog.html.SafeHtml.htmlEscape = function(t$7) {
            if (t$7 instanceof goog.html.SafeHtml) return t$7;
            var o$2 = typeof t$7 == `object`, r$2 = null;
            return o$2 && t$7.implementsGoogI18nBidiDirectionalString && (r$2 = t$7.getDirection()), t$7 = o$2 && t$7.implementsGoogStringTypedString ? t$7.getTypedStringValue() : String(t$7), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.htmlEscape(t$7), r$2);
          }, goog.html.SafeHtml.htmlEscapePreservingNewlines = function(t$7) {
            return t$7 instanceof goog.html.SafeHtml ? t$7 : (t$7 = goog.html.SafeHtml.htmlEscape(t$7), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.newLineToBr(goog.html.SafeHtml.unwrap(t$7)), t$7.getDirection()));
          }, goog.html.SafeHtml.htmlEscapePreservingNewlinesAndSpaces = function(t$7) {
            return t$7 instanceof goog.html.SafeHtml ? t$7 : (t$7 = goog.html.SafeHtml.htmlEscape(t$7), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.whitespaceEscape(goog.html.SafeHtml.unwrap(t$7)), t$7.getDirection()));
          }, goog.html.SafeHtml.from = goog.html.SafeHtml.htmlEscape, goog.html.SafeHtml.comment = function(t$7) {
            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(`<!--` + goog.string.internal.htmlEscape(t$7) + `-->`, null);
          }, goog.html.SafeHtml.VALID_NAMES_IN_TAG_ = /^[a-zA-Z0-9-]+$/, goog.html.SafeHtml.URL_ATTRIBUTES_ = { action: true, cite: true, data: true, formaction: true, href: true, manifest: true, poster: true, src: true }, goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_ = goog.object.createSet(goog.dom.TagName.APPLET, goog.dom.TagName.BASE, goog.dom.TagName.EMBED, goog.dom.TagName.IFRAME, goog.dom.TagName.LINK, goog.dom.TagName.MATH, goog.dom.TagName.META, goog.dom.TagName.OBJECT, goog.dom.TagName.SCRIPT, goog.dom.TagName.STYLE, goog.dom.TagName.SVG, goog.dom.TagName.TEMPLATE), goog.html.SafeHtml.create = function(t$7, o$2, r$2) {
            return goog.html.SafeHtml.verifyTagName(String(t$7)), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(String(t$7), o$2, r$2);
          }, goog.html.SafeHtml.verifyTagName = function(t$7) {
            if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(t$7)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? `Invalid tag name <` + t$7 + `>.` : ``);
            if (t$7.toUpperCase() in goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? `Tag name <` + t$7 + `> is not allowed for SafeHtml.` : ``);
          }, goog.html.SafeHtml.createIframe = function(t$7, o$2, r$2, u) {
            t$7 && goog.html.TrustedResourceUrl.unwrap(t$7);
            var h$1 = {};
            return h$1.src = t$7 || null, h$1.srcdoc = o$2 && goog.html.SafeHtml.unwrap(o$2), t$7 = goog.html.SafeHtml.combineAttributes(h$1, { sandbox: `` }, r$2), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(`iframe`, t$7, u);
          }, goog.html.SafeHtml.createSandboxIframe = function(t$7, o$2, r$2, u) {
            if (!goog.html.SafeHtml.canUseSandboxIframe()) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? `The browser does not support sandboxed iframes.` : ``);
            var h$1 = {};
            return h$1.src = t$7 ? goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(t$7)) : null, h$1.srcdoc = o$2 || null, h$1.sandbox = ``, t$7 = goog.html.SafeHtml.combineAttributes(h$1, {}, r$2), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(`iframe`, t$7, u);
          }, goog.html.SafeHtml.canUseSandboxIframe = function() {
            return goog.global.HTMLIFrameElement && `sandbox` in goog.global.HTMLIFrameElement.prototype;
          }, goog.html.SafeHtml.createScriptSrc = function(t$7, o$2) {
            return goog.html.TrustedResourceUrl.unwrap(t$7), t$7 = goog.html.SafeHtml.combineAttributes({ src: t$7 }, {}, o$2), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(`script`, t$7);
          }, goog.html.SafeHtml.createScript = function(t$7, o$2) {
            for (var r$2 in o$2) if (Object.prototype.hasOwnProperty.call(o$2, r$2)) {
              var u = r$2.toLowerCase();
              if (u == `language` || u == `src` || u == `text` || u == `type`) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? `Cannot set "` + u + `" attribute` : ``);
            }
            for (r$2 = ``, t$7 = module$contents$goog$array_concat(t$7), u = 0; u < t$7.length; u++) r$2 += module$contents$goog$html$SafeScript_SafeScript.unwrap(t$7[u]);
            return t$7 = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(r$2, goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(`script`, o$2, t$7);
          }, goog.html.SafeHtml.createStyle = function(t$7, o$2) {
            o$2 = goog.html.SafeHtml.combineAttributes({ type: `text/css` }, {}, o$2);
            var r$2 = ``;
            t$7 = module$contents$goog$array_concat(t$7);
            for (var u = 0; u < t$7.length; u++) r$2 += module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap(t$7[u]);
            return t$7 = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(r$2, goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(`style`, o$2, t$7);
          }, goog.html.SafeHtml.createMetaRefresh = function(t$7, o$2) {
            return t$7 = goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(t$7)), (goog.labs.userAgent.browser.isIE() || goog.labs.userAgent.browser.isEdge()) && goog.string.internal.contains(t$7, `;`) && (t$7 = `'` + t$7.replace(/'/g, `%27`) + `'`), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(`meta`, { "http-equiv": `refresh`, content: (o$2 || 0) + `; url=` + t$7 });
          }, goog.html.SafeHtml.getAttrNameAndValue_ = function(t$7, o$2, r$2) {
            if (r$2 instanceof goog.string.Const) r$2 = goog.string.Const.unwrap(r$2);
            else if (o$2.toLowerCase() == `style`) if (goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE) r$2 = goog.html.SafeHtml.getStyleValue_(r$2);
            else throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? `Attribute "style" not supported.` : ``);
            else {
              if (/^on/i.test(o$2)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? `Attribute "` + o$2 + `" requires goog.string.Const value, "` + r$2 + `" given.` : ``);
              if (o$2.toLowerCase() in goog.html.SafeHtml.URL_ATTRIBUTES_) if (r$2 instanceof goog.html.TrustedResourceUrl) r$2 = goog.html.TrustedResourceUrl.unwrap(r$2);
              else if (r$2 instanceof goog.html.SafeUrl) r$2 = goog.html.SafeUrl.unwrap(r$2);
              else if (typeof r$2 == `string`) r$2 = goog.html.SafeUrl.sanitize(r$2).getTypedStringValue();
              else throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? `Attribute "` + o$2 + `" on tag "` + t$7 + `" requires goog.html.SafeUrl, goog.string.Const, or string, value "` + r$2 + `" given.` : ``);
            }
            return r$2.implementsGoogStringTypedString && (r$2 = r$2.getTypedStringValue()), goog.asserts.assert(typeof r$2 == `string` || typeof r$2 == `number`, `String or number value expected, got ` + typeof r$2 + ` with value: ` + r$2), o$2 + `="` + goog.string.internal.htmlEscape(String(r$2)) + `"`;
          }, goog.html.SafeHtml.getStyleValue_ = function(t$7) {
            if (!goog.isObject(t$7)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? `The "style" attribute requires goog.html.SafeStyle or map of style properties, ` + typeof t$7 + ` given: ` + t$7 : ``);
            return t$7 instanceof goog.html.SafeStyle || (t$7 = goog.html.SafeStyle.create(t$7)), goog.html.SafeStyle.unwrap(t$7);
          }, goog.html.SafeHtml.createWithDir = function(t$7, o$2, r$2, u) {
            return o$2 = goog.html.SafeHtml.create(o$2, r$2, u), o$2.dir_ = t$7, o$2;
          }, goog.html.SafeHtml.join = function(t$7, o$2) {
            t$7 = goog.html.SafeHtml.htmlEscape(t$7);
            var r$2 = t$7.getDirection(), u = [], h$1 = function(m$3) {
              Array.isArray(m$3) ? module$contents$goog$array_forEach(m$3, h$1) : (m$3 = goog.html.SafeHtml.htmlEscape(m$3), u.push(goog.html.SafeHtml.unwrap(m$3)), m$3 = m$3.getDirection(), r$2 == goog.i18n.bidi.Dir.NEUTRAL ? r$2 = m$3 : m$3 != goog.i18n.bidi.Dir.NEUTRAL && r$2 != m$3 && (r$2 = null));
            };
            return module$contents$goog$array_forEach(o$2, h$1), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(u.join(goog.html.SafeHtml.unwrap(t$7)), r$2);
          }, goog.html.SafeHtml.concat = function(t$7) {
            return goog.html.SafeHtml.join(goog.html.SafeHtml.EMPTY, Array.prototype.slice.call(arguments));
          }, goog.html.SafeHtml.concatWithDir = function(t$7, o$2) {
            var r$2 = goog.html.SafeHtml.concat(module$contents$goog$array_slice(arguments, 1));
            return r$2.dir_ = t$7, r$2;
          }, goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse = function(t$7, o$2) {
            var r$2 = goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();
            return t$7 = r$2 ? r$2.createHTML(t$7) : t$7, new goog.html.SafeHtml(t$7, o$2, goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_);
          }, goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse = function(t$7, o$2, r$2) {
            var u = null, h$1 = `<` + t$7 + goog.html.SafeHtml.stringifyAttributes(t$7, o$2);
            return r$2 == null ? r$2 = [] : Array.isArray(r$2) || (r$2 = [r$2]), goog.dom.tags.isVoidTag(t$7.toLowerCase()) ? (goog.asserts.assert(!r$2.length, `Void tag <` + t$7 + `> does not allow content.`), h$1 += `>`) : (u = goog.html.SafeHtml.concat(r$2), h$1 += `>` + goog.html.SafeHtml.unwrap(u) + `</` + t$7 + `>`, u = u.getDirection()), (t$7 = o$2 && o$2.dir) && (u = /^(ltr|rtl|auto)$/i.test(t$7) ? goog.i18n.bidi.Dir.NEUTRAL : null), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(h$1, u);
          }, goog.html.SafeHtml.stringifyAttributes = function(t$7, o$2) {
            var r$2 = ``;
            if (o$2) {
              for (var u in o$2) if (Object.prototype.hasOwnProperty.call(o$2, u)) {
                if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(u)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? `Invalid attribute name "` + u + `".` : ``);
                var h$1 = o$2[u];
                h$1 != null && (r$2 += ` ` + goog.html.SafeHtml.getAttrNameAndValue_(t$7, u, h$1));
              }
            }
            return r$2;
          }, goog.html.SafeHtml.combineAttributes = function(t$7, o$2, r$2) {
            var u = {}, h$1;
            for (h$1 in t$7) Object.prototype.hasOwnProperty.call(t$7, h$1) && (goog.asserts.assert(h$1.toLowerCase() == h$1, `Must be lower case`), u[h$1] = t$7[h$1]);
            for (h$1 in o$2) Object.prototype.hasOwnProperty.call(o$2, h$1) && (goog.asserts.assert(h$1.toLowerCase() == h$1, `Must be lower case`), u[h$1] = o$2[h$1]);
            if (r$2) {
              for (h$1 in r$2) if (Object.prototype.hasOwnProperty.call(r$2, h$1)) {
                var m$3 = h$1.toLowerCase();
                if (m$3 in t$7) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? `Cannot override "` + m$3 + `" attribute, got "` + h$1 + `" with value "` + r$2[h$1] + `"` : ``);
                m$3 in o$2 && delete u[m$3], u[h$1] = r$2[h$1];
              }
            }
            return u;
          }, goog.html.SafeHtml.DOCTYPE_HTML = (function() {
            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(`<!DOCTYPE html>`, goog.i18n.bidi.Dir.NEUTRAL);
          })(), goog.html.SafeHtml.EMPTY = new goog.html.SafeHtml(goog.global.trustedTypes && goog.global.trustedTypes.emptyHTML || ``, goog.i18n.bidi.Dir.NEUTRAL, goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_), goog.html.SafeHtml.BR = (function() {
            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(`<br>`, goog.i18n.bidi.Dir.NEUTRAL);
          })(), goog.html.uncheckedconversions = {}, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract = function(t$7, o$2, r$2) {
            return goog.asserts.assertString(goog.string.Const.unwrap(t$7), `must provide justification`), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(t$7)), `must provide non-empty justification`), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(o$2, r$2 || null);
          }, goog.html.uncheckedconversions.safeScriptFromStringKnownToSatisfyTypeContract = function(t$7, o$2) {
            return goog.asserts.assertString(goog.string.Const.unwrap(t$7), `must provide justification`), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(t$7)), `must provide non-empty justification`), module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(o$2);
          }, goog.html.uncheckedconversions.safeStyleFromStringKnownToSatisfyTypeContract = function(t$7, o$2) {
            return goog.asserts.assertString(goog.string.Const.unwrap(t$7), `must provide justification`), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(t$7)), `must provide non-empty justification`), goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(o$2);
          }, goog.html.uncheckedconversions.safeStyleSheetFromStringKnownToSatisfyTypeContract = function(t$7, o$2) {
            return goog.asserts.assertString(goog.string.Const.unwrap(t$7), `must provide justification`), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(t$7)), `must provide non-empty justification`), module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(o$2);
          }, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract = function(t$7, o$2) {
            return goog.asserts.assertString(goog.string.Const.unwrap(t$7), `must provide justification`), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(t$7)), `must provide non-empty justification`), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(o$2);
          }, goog.html.uncheckedconversions.trustedResourceUrlFromStringKnownToSatisfyTypeContract = function(t$7, o$2) {
            return goog.asserts.assertString(goog.string.Const.unwrap(t$7), `must provide justification`), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(t$7)), `must provide non-empty justification`), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(o$2);
          }, goog.dom.safe = {}, goog.dom.safe.InsertAdjacentHtmlPosition = { AFTERBEGIN: `afterbegin`, AFTEREND: `afterend`, BEFOREBEGIN: `beforebegin`, BEFOREEND: `beforeend` }, goog.dom.safe.insertAdjacentHtml = function(t$7, o$2, r$2) {
            t$7.insertAdjacentHTML(o$2, goog.html.SafeHtml.unwrapTrustedHTML(r$2));
          }, goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_ = { MATH: true, SCRIPT: true, STYLE: true, SVG: true, TEMPLATE: true }, goog.dom.safe.isInnerHtmlCleanupRecursive_ = goog.functions.cacheReturnValue(function() {
            if (goog.DEBUG && typeof document > `u`) return false;
            var t$7 = document.createElement(`div`), o$2 = document.createElement(`div`);
            return o$2.appendChild(document.createElement(`div`)), t$7.appendChild(o$2), goog.DEBUG && !t$7.firstChild ? false : (o$2 = t$7.firstChild.firstChild, t$7.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(goog.html.SafeHtml.EMPTY), !o$2.parentElement);
          }), goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse = function(t$7, o$2) {
            if (goog.dom.safe.isInnerHtmlCleanupRecursive_()) for (; t$7.lastChild; ) t$7.removeChild(t$7.lastChild);
            t$7.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(o$2);
          }, goog.dom.safe.setInnerHtml = function(t$7, o$2) {
            if (goog.asserts.ENABLE_ASSERTS && t$7.tagName) {
              var r$2 = t$7.tagName.toUpperCase();
              if (goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_[r$2]) throw Error(`goog.dom.safe.setInnerHtml cannot be used to set content of ` + t$7.tagName + `.`);
            }
            goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse(t$7, o$2);
          }, goog.dom.safe.setInnerHtmlFromConstant = function(t$7, o$2) {
            goog.dom.safe.setInnerHtml(t$7, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from(`Constant HTML to be immediatelly used.`), goog.string.Const.unwrap(o$2)));
          }, goog.dom.safe.setOuterHtml = function(t$7, o$2) {
            t$7.outerHTML = goog.html.SafeHtml.unwrapTrustedHTML(o$2);
          }, goog.dom.safe.setFormElementAction = function(t$7, o$2) {
            o$2 = o$2 instanceof goog.html.SafeUrl ? o$2 : goog.html.SafeUrl.sanitizeAssertUnchanged(o$2), goog.dom.asserts.assertIsHTMLFormElement(t$7).action = goog.html.SafeUrl.unwrap(o$2);
          }, goog.dom.safe.setButtonFormAction = function(t$7, o$2) {
            o$2 = o$2 instanceof goog.html.SafeUrl ? o$2 : goog.html.SafeUrl.sanitizeAssertUnchanged(o$2), goog.dom.asserts.assertIsHTMLButtonElement(t$7).formAction = goog.html.SafeUrl.unwrap(o$2);
          }, goog.dom.safe.setInputFormAction = function(t$7, o$2) {
            o$2 = o$2 instanceof goog.html.SafeUrl ? o$2 : goog.html.SafeUrl.sanitizeAssertUnchanged(o$2), goog.dom.asserts.assertIsHTMLInputElement(t$7).formAction = goog.html.SafeUrl.unwrap(o$2);
          }, goog.dom.safe.setStyle = function(t$7, o$2) {
            t$7.style.cssText = goog.html.SafeStyle.unwrap(o$2);
          }, goog.dom.safe.documentWrite = function(t$7, o$2) {
            t$7.write(goog.html.SafeHtml.unwrapTrustedHTML(o$2));
          }, goog.dom.safe.setAnchorHref = function(t$7, o$2) {
            goog.dom.asserts.assertIsHTMLAnchorElement(t$7), o$2 = o$2 instanceof goog.html.SafeUrl ? o$2 : goog.html.SafeUrl.sanitizeAssertUnchanged(o$2), t$7.href = goog.html.SafeUrl.unwrap(o$2);
          }, goog.dom.safe.setImageSrc = function(t$7, o$2) {
            if (goog.dom.asserts.assertIsHTMLImageElement(t$7), !(o$2 instanceof goog.html.SafeUrl)) {
              var r$2 = /^data:image\//i.test(o$2);
              o$2 = goog.html.SafeUrl.sanitizeAssertUnchanged(o$2, r$2);
            }
            t$7.src = goog.html.SafeUrl.unwrap(o$2);
          }, goog.dom.safe.setAudioSrc = function(t$7, o$2) {
            if (goog.dom.asserts.assertIsHTMLAudioElement(t$7), !(o$2 instanceof goog.html.SafeUrl)) {
              var r$2 = /^data:audio\//i.test(o$2);
              o$2 = goog.html.SafeUrl.sanitizeAssertUnchanged(o$2, r$2);
            }
            t$7.src = goog.html.SafeUrl.unwrap(o$2);
          }, goog.dom.safe.setVideoSrc = function(t$7, o$2) {
            if (goog.dom.asserts.assertIsHTMLVideoElement(t$7), !(o$2 instanceof goog.html.SafeUrl)) {
              var r$2 = /^data:video\//i.test(o$2);
              o$2 = goog.html.SafeUrl.sanitizeAssertUnchanged(o$2, r$2);
            }
            t$7.src = goog.html.SafeUrl.unwrap(o$2);
          }, goog.dom.safe.setEmbedSrc = function(t$7, o$2) {
            goog.dom.asserts.assertIsHTMLEmbedElement(t$7), t$7.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(o$2);
          }, goog.dom.safe.setFrameSrc = function(t$7, o$2) {
            goog.dom.asserts.assertIsHTMLFrameElement(t$7), t$7.src = goog.html.TrustedResourceUrl.unwrap(o$2);
          }, goog.dom.safe.setIframeSrc = function(t$7, o$2) {
            goog.dom.asserts.assertIsHTMLIFrameElement(t$7), t$7.src = goog.html.TrustedResourceUrl.unwrap(o$2);
          }, goog.dom.safe.setIframeSrcdoc = function(t$7, o$2) {
            goog.dom.asserts.assertIsHTMLIFrameElement(t$7), t$7.srcdoc = goog.html.SafeHtml.unwrapTrustedHTML(o$2);
          }, goog.dom.safe.setLinkHrefAndRel = function(t$7, o$2, r$2) {
            goog.dom.asserts.assertIsHTMLLinkElement(t$7), t$7.rel = r$2, goog.string.internal.caseInsensitiveContains(r$2, `stylesheet`) ? (goog.asserts.assert(o$2 instanceof goog.html.TrustedResourceUrl, `URL must be TrustedResourceUrl because "rel" contains "stylesheet"`), t$7.href = goog.html.TrustedResourceUrl.unwrap(o$2)) : t$7.href = o$2 instanceof goog.html.TrustedResourceUrl ? goog.html.TrustedResourceUrl.unwrap(o$2) : o$2 instanceof goog.html.SafeUrl ? goog.html.SafeUrl.unwrap(o$2) : goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitizeAssertUnchanged(o$2));
          }, goog.dom.safe.setObjectData = function(t$7, o$2) {
            goog.dom.asserts.assertIsHTMLObjectElement(t$7), t$7.data = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(o$2);
          }, goog.dom.safe.setScriptSrc = function(t$7, o$2) {
            goog.dom.asserts.assertIsHTMLScriptElement(t$7), t$7.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(o$2), goog.dom.safe.setNonceForScriptElement_(t$7);
          }, goog.dom.safe.setScriptContent = function(t$7, o$2) {
            goog.dom.asserts.assertIsHTMLScriptElement(t$7), t$7.textContent = module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript(o$2), goog.dom.safe.setNonceForScriptElement_(t$7);
          }, goog.dom.safe.setNonceForScriptElement_ = function(t$7) {
            var o$2 = goog.getScriptNonce(t$7.ownerDocument && t$7.ownerDocument.defaultView);
            o$2 && t$7.setAttribute(`nonce`, o$2);
          }, goog.dom.safe.setLocationHref = function(t$7, o$2) {
            goog.dom.asserts.assertIsLocation(t$7), o$2 = o$2 instanceof goog.html.SafeUrl ? o$2 : goog.html.SafeUrl.sanitizeAssertUnchanged(o$2), t$7.href = goog.html.SafeUrl.unwrap(o$2);
          }, goog.dom.safe.assignLocation = function(t$7, o$2) {
            goog.dom.asserts.assertIsLocation(t$7), o$2 = o$2 instanceof goog.html.SafeUrl ? o$2 : goog.html.SafeUrl.sanitizeAssertUnchanged(o$2), t$7.assign(goog.html.SafeUrl.unwrap(o$2));
          }, goog.dom.safe.replaceLocation = function(t$7, o$2) {
            o$2 = o$2 instanceof goog.html.SafeUrl ? o$2 : goog.html.SafeUrl.sanitizeAssertUnchanged(o$2), t$7.replace(goog.html.SafeUrl.unwrap(o$2));
          }, goog.dom.safe.openInWindow = function(t$7, o$2, r$2, u, h$1) {
            return t$7 = t$7 instanceof goog.html.SafeUrl ? t$7 : goog.html.SafeUrl.sanitizeAssertUnchanged(t$7), o$2 ||= goog.global, r$2 = r$2 instanceof goog.string.Const ? goog.string.Const.unwrap(r$2) : r$2 || ``, o$2.open(goog.html.SafeUrl.unwrap(t$7), r$2, u, h$1);
          }, goog.dom.safe.parseFromStringHtml = function(t$7, o$2) {
            return goog.dom.safe.parseFromString(t$7, o$2, `text/html`);
          }, goog.dom.safe.parseFromString = function(t$7, o$2, r$2) {
            return t$7.parseFromString(goog.html.SafeHtml.unwrapTrustedHTML(o$2), r$2);
          }, goog.dom.safe.createImageFromBlob = function(t$7) {
            if (!/^image\/.*/g.test(t$7.type)) throw Error(`goog.dom.safe.createImageFromBlob only accepts MIME type image/.*.`);
            var o$2 = goog.global.URL.createObjectURL(t$7);
            return t$7 = new goog.global.Image(), t$7.onload = function() {
              goog.global.URL.revokeObjectURL(o$2);
            }, goog.dom.safe.setImageSrc(t$7, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract(goog.string.Const.from(`Image blob URL.`), o$2)), t$7;
          }, goog.string.DETECT_DOUBLE_ESCAPING = false, goog.string.FORCE_NON_DOM_HTML_UNESCAPING = false, goog.string.Unicode = { NBSP: ` ` }, goog.string.startsWith = goog.string.internal.startsWith, goog.string.endsWith = goog.string.internal.endsWith, goog.string.caseInsensitiveStartsWith = goog.string.internal.caseInsensitiveStartsWith, goog.string.caseInsensitiveEndsWith = goog.string.internal.caseInsensitiveEndsWith, goog.string.caseInsensitiveEquals = goog.string.internal.caseInsensitiveEquals, goog.string.subs = function(t$7, o$2) {
            for (var r$2 = t$7.split(`%s`), u = ``, h$1 = Array.prototype.slice.call(arguments, 1); h$1.length && 1 < r$2.length; ) u += r$2.shift() + h$1.shift();
            return u + r$2.join(`%s`);
          }, goog.string.collapseWhitespace = function(t$7) {
            return t$7.replace(/[\s\xa0]+/g, ` `).replace(/^\s+|\s+$/g, ``);
          }, goog.string.isEmptyOrWhitespace = goog.string.internal.isEmptyOrWhitespace, goog.string.isEmptyString = function(t$7) {
            return t$7.length == 0;
          }, goog.string.isEmpty = goog.string.isEmptyOrWhitespace, goog.string.isEmptyOrWhitespaceSafe = function(t$7) {
            return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(t$7));
          }, goog.string.isEmptySafe = goog.string.isEmptyOrWhitespaceSafe, goog.string.isBreakingWhitespace = function(t$7) {
            return !/[^\t\n\r ]/.test(t$7);
          }, goog.string.isAlpha = function(t$7) {
            return !/[^a-zA-Z]/.test(t$7);
          }, goog.string.isNumeric = function(t$7) {
            return !/[^0-9]/.test(t$7);
          }, goog.string.isAlphaNumeric = function(t$7) {
            return !/[^a-zA-Z0-9]/.test(t$7);
          }, goog.string.isSpace = function(t$7) {
            return t$7 == ` `;
          }, goog.string.isUnicodeChar = function(t$7) {
            return t$7.length == 1 && ` ` <= t$7 && `~` >= t$7 || `` <= t$7 && `�` >= t$7;
          }, goog.string.stripNewlines = function(t$7) {
            return t$7.replace(/(\r\n|\r|\n)+/g, ` `);
          }, goog.string.canonicalizeNewlines = function(t$7) {
            return t$7.replace(/(\r\n|\r|\n)/g, `
`);
          }, goog.string.normalizeWhitespace = function(t$7) {
            return t$7.replace(/\xa0|\s/g, ` `);
          }, goog.string.normalizeSpaces = function(t$7) {
            return t$7.replace(/\xa0|[ \t]+/g, ` `);
          }, goog.string.collapseBreakingSpaces = function(t$7) {
            return t$7.replace(/[\t\r\n ]+/g, ` `).replace(/^[\t\r\n ]+|[\t\r\n ]+$/g, ``);
          }, goog.string.trim = goog.string.internal.trim, goog.string.trimLeft = function(t$7) {
            return t$7.replace(/^[\s\xa0]+/, ``);
          }, goog.string.trimRight = function(t$7) {
            return t$7.replace(/[\s\xa0]+$/, ``);
          }, goog.string.caseInsensitiveCompare = goog.string.internal.caseInsensitiveCompare, goog.string.numberAwareCompare_ = function(t$7, o$2, r$2) {
            if (t$7 == o$2) return 0;
            if (!t$7) return -1;
            if (!o$2) return 1;
            for (var u = t$7.toLowerCase().match(r$2), h$1 = o$2.toLowerCase().match(r$2), m$3 = Math.min(u.length, h$1.length), y$1 = 0; y$1 < m$3; y$1++) {
              r$2 = u[y$1];
              var S = h$1[y$1];
              if (r$2 != S) return t$7 = parseInt(r$2, 10), !isNaN(t$7) && (o$2 = parseInt(S, 10), !isNaN(o$2) && t$7 - o$2) ? t$7 - o$2 : r$2 < S ? -1 : 1;
            }
            return u.length == h$1.length ? t$7 < o$2 ? -1 : 1 : u.length - h$1.length;
          }, goog.string.intAwareCompare = function(t$7, o$2) {
            return goog.string.numberAwareCompare_(t$7, o$2, /\d+|\D+/g);
          }, goog.string.floatAwareCompare = function(t$7, o$2) {
            return goog.string.numberAwareCompare_(t$7, o$2, /\d+|\.\d+|\D+/g);
          }, goog.string.numerateCompare = goog.string.floatAwareCompare, goog.string.urlEncode = function(t$7) {
            return encodeURIComponent(String(t$7));
          }, goog.string.urlDecode = function(t$7) {
            return decodeURIComponent(t$7.replace(/\+/g, ` `));
          }, goog.string.newLineToBr = goog.string.internal.newLineToBr, goog.string.htmlEscape = function(t$7, o$2) {
            return t$7 = goog.string.internal.htmlEscape(t$7, o$2), goog.string.DETECT_DOUBLE_ESCAPING && (t$7 = t$7.replace(goog.string.E_RE_, `&#101;`)), t$7;
          }, goog.string.E_RE_ = /e/g, goog.string.unescapeEntities = function(t$7) {
            return goog.string.contains(t$7, `&`) ? !goog.string.FORCE_NON_DOM_HTML_UNESCAPING && `document` in goog.global ? goog.string.unescapeEntitiesUsingDom_(t$7) : goog.string.unescapePureXmlEntities_(t$7) : t$7;
          }, goog.string.unescapeEntitiesWithDocument = function(t$7, o$2) {
            return goog.string.contains(t$7, `&`) ? goog.string.unescapeEntitiesUsingDom_(t$7, o$2) : t$7;
          }, goog.string.unescapeEntitiesUsingDom_ = function(t$7, o$2) {
            var r$2 = { "&amp;": `&`, "&lt;": `<`, "&gt;": `>`, "&quot;": `"` }, u = o$2 ? o$2.createElement(`div`) : goog.global.document.createElement(`div`);
            return t$7.replace(goog.string.HTML_ENTITY_PATTERN_, function(h$1, m$3) {
              var y$1 = r$2[h$1];
              return y$1 || (m$3.charAt(0) == `#` && (m$3 = +(`0` + m$3.substr(1)), isNaN(m$3) || (y$1 = String.fromCharCode(m$3))), y$1 || (goog.dom.safe.setInnerHtml(u, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from(`Single HTML entity.`), h$1 + ` `)), y$1 = u.firstChild.nodeValue.slice(0, -1)), r$2[h$1] = y$1);
            });
          }, goog.string.unescapePureXmlEntities_ = function(t$7) {
            return t$7.replace(/&([^;]+);/g, function(o$2, r$2) {
              switch (r$2) {
                case `amp`:
                  return `&`;
                case `lt`:
                  return `<`;
                case `gt`:
                  return `>`;
                case `quot`:
                  return `"`;
                default:
                  return r$2.charAt(0) != `#` || (r$2 = +(`0` + r$2.substr(1)), isNaN(r$2)) ? o$2 : String.fromCharCode(r$2);
              }
            });
          }, goog.string.HTML_ENTITY_PATTERN_ = /&([^;\s<&]+);?/g, goog.string.whitespaceEscape = function(t$7, o$2) {
            return goog.string.newLineToBr(t$7.replace(/  /g, ` &#160;`), o$2);
          }, goog.string.preserveSpaces = function(t$7) {
            return t$7.replace(/(^|[\n ]) /g, `$1` + goog.string.Unicode.NBSP);
          }, goog.string.stripQuotes = function(t$7, o$2) {
            for (var r$2 = o$2.length, u = 0; u < r$2; u++) {
              var h$1 = r$2 == 1 ? o$2 : o$2.charAt(u);
              if (t$7.charAt(0) == h$1 && t$7.charAt(t$7.length - 1) == h$1) return t$7.substring(1, t$7.length - 1);
            }
            return t$7;
          }, goog.string.truncate = function(t$7, o$2, r$2) {
            return r$2 && (t$7 = goog.string.unescapeEntities(t$7)), t$7.length > o$2 && (t$7 = t$7.substring(0, o$2 - 3) + `...`), r$2 && (t$7 = goog.string.htmlEscape(t$7)), t$7;
          }, goog.string.truncateMiddle = function(t$7, o$2, r$2, u) {
            if (r$2 && (t$7 = goog.string.unescapeEntities(t$7)), u && t$7.length > o$2) {
              u > o$2 && (u = o$2);
              var h$1 = t$7.length - u;
              t$7 = t$7.substring(0, o$2 - u) + `...` + t$7.substring(h$1);
            } else t$7.length > o$2 && (u = Math.floor(o$2 / 2), h$1 = t$7.length - u, t$7 = t$7.substring(0, u + o$2 % 2) + `...` + t$7.substring(h$1));
            return r$2 && (t$7 = goog.string.htmlEscape(t$7)), t$7;
          }, goog.string.specialEscapeChars_ = { "\0": `\\0`, "\b": `\\b`, "\f": `\\f`, "\n": `\\n`, "\r": `\\r`, "	": `\\t`, "\v": `\\x0B`, '"': `\\"`, "\\": `\\\\`, "<": `\\u003C` }, goog.string.jsEscapeCache_ = { "'": `\\'` }, goog.string.quote = function(t$7) {
            t$7 = String(t$7);
            for (var o$2 = [`"`], r$2 = 0; r$2 < t$7.length; r$2++) {
              var u = t$7.charAt(r$2), h$1 = u.charCodeAt(0);
              o$2[r$2 + 1] = goog.string.specialEscapeChars_[u] || (31 < h$1 && 127 > h$1 ? u : goog.string.escapeChar(u));
            }
            return o$2.push(`"`), o$2.join(``);
          }, goog.string.escapeString = function(t$7) {
            for (var o$2 = [], r$2 = 0; r$2 < t$7.length; r$2++) o$2[r$2] = goog.string.escapeChar(t$7.charAt(r$2));
            return o$2.join(``);
          }, goog.string.escapeChar = function(t$7) {
            if (t$7 in goog.string.jsEscapeCache_) return goog.string.jsEscapeCache_[t$7];
            if (t$7 in goog.string.specialEscapeChars_) return goog.string.jsEscapeCache_[t$7] = goog.string.specialEscapeChars_[t$7];
            var o$2 = t$7.charCodeAt(0);
            if (31 < o$2 && 127 > o$2) var r$2 = t$7;
            else 256 > o$2 ? (r$2 = `\\x`, (16 > o$2 || 256 < o$2) && (r$2 += `0`)) : (r$2 = `\\u`, 4096 > o$2 && (r$2 += `0`)), r$2 += o$2.toString(16).toUpperCase();
            return goog.string.jsEscapeCache_[t$7] = r$2;
          }, goog.string.contains = goog.string.internal.contains, goog.string.caseInsensitiveContains = goog.string.internal.caseInsensitiveContains, goog.string.countOf = function(t$7, o$2) {
            return t$7 && o$2 ? t$7.split(o$2).length - 1 : 0;
          }, goog.string.removeAt = function(t$7, o$2, r$2) {
            var u = t$7;
            return 0 <= o$2 && o$2 < t$7.length && 0 < r$2 && (u = t$7.substr(0, o$2) + t$7.substr(o$2 + r$2, t$7.length - o$2 - r$2)), u;
          }, goog.string.remove = function(t$7, o$2) {
            return t$7.replace(o$2, ``);
          }, goog.string.removeAll = function(t$7, o$2) {
            return o$2 = new RegExp(goog.string.regExpEscape(o$2), `g`), t$7.replace(o$2, ``);
          }, goog.string.replaceAll = function(t$7, o$2, r$2) {
            return o$2 = new RegExp(goog.string.regExpEscape(o$2), `g`), t$7.replace(o$2, r$2.replace(/\$/g, `$$$$`));
          }, goog.string.regExpEscape = function(t$7) {
            return String(t$7).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, `\\$1`).replace(/\x08/g, `\\x08`);
          }, goog.string.repeat = String.prototype.repeat ? function(t$7, o$2) {
            return t$7.repeat(o$2);
          } : function(t$7, o$2) {
            return Array(o$2 + 1).join(t$7);
          }, goog.string.padNumber = function(t$7, o$2, r$2) {
            return t$7 = r$2 === void 0 ? String(t$7) : t$7.toFixed(r$2), r$2 = t$7.indexOf(`.`), r$2 == -1 && (r$2 = t$7.length), goog.string.repeat(`0`, Math.max(0, o$2 - r$2)) + t$7;
          }, goog.string.makeSafe = function(t$7) {
            return t$7 == null ? `` : String(t$7);
          }, goog.string.buildString = function(t$7) {
            return Array.prototype.join.call(arguments, ``);
          }, goog.string.getRandomString = function() {
            return Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ goog.now()).toString(36);
          }, goog.string.compareVersions = goog.string.internal.compareVersions, goog.string.hashCode = function(t$7) {
            for (var o$2 = 0, r$2 = 0; r$2 < t$7.length; ++r$2) o$2 = 31 * o$2 + t$7.charCodeAt(r$2) >>> 0;
            return o$2;
          }, goog.string.uniqueStringCounter_ = 2147483648 * Math.random() | 0, goog.string.createUniqueString = function() {
            return `goog_` + goog.string.uniqueStringCounter_++;
          }, goog.string.toNumber = function(t$7) {
            var o$2 = Number(t$7);
            return o$2 == 0 && goog.string.isEmptyOrWhitespace(t$7) ? NaN : o$2;
          }, goog.string.isLowerCamelCase = function(t$7) {
            return /^[a-z]+([A-Z][a-z]*)*$/.test(t$7);
          }, goog.string.isUpperCamelCase = function(t$7) {
            return /^([A-Z][a-z]*)+$/.test(t$7);
          }, goog.string.toCamelCase = function(t$7) {
            return String(t$7).replace(/\-([a-z])/g, function(o$2, r$2) {
              return r$2.toUpperCase();
            });
          }, goog.string.toSelectorCase = function(t$7) {
            return String(t$7).replace(/([A-Z])/g, `-$1`).toLowerCase();
          }, goog.string.toTitleCase = function(t$7, o$2) {
            return o$2 = typeof o$2 == `string` ? goog.string.regExpEscape(o$2) : `\\s`, t$7.replace(RegExp(`(^` + (o$2 ? `|[` + o$2 + `]+` : ``) + `)([a-z])`, `g`), function(r$2, u, h$1) {
              return u + h$1.toUpperCase();
            });
          }, goog.string.capitalize = function(t$7) {
            return String(t$7.charAt(0)).toUpperCase() + String(t$7.substr(1)).toLowerCase();
          }, goog.string.parseInt = function(t$7) {
            return isFinite(t$7) && (t$7 = String(t$7)), typeof t$7 == `string` ? /^\s*-?0x/i.test(t$7) ? parseInt(t$7, 16) : parseInt(t$7, 10) : NaN;
          }, goog.string.splitLimit = function(t$7, o$2, r$2) {
            t$7 = t$7.split(o$2);
            for (var u = []; 0 < r$2 && t$7.length; ) u.push(t$7.shift()), r$2--;
            return t$7.length && u.push(t$7.join(o$2)), u;
          }, goog.string.lastComponent = function(t$7, o$2) {
            if (o$2) typeof o$2 == `string` && (o$2 = [o$2]);
            else return t$7;
            for (var r$2 = -1, u = 0; u < o$2.length; u++) if (o$2[u] != ``) {
              var h$1 = t$7.lastIndexOf(o$2[u]);
              h$1 > r$2 && (r$2 = h$1);
            }
            return r$2 == -1 ? t$7 : t$7.slice(r$2 + 1);
          }, goog.string.editDistance = function(t$7, o$2) {
            var r$2 = [], u = [];
            if (t$7 == o$2) return 0;
            if (!t$7.length || !o$2.length) return Math.max(t$7.length, o$2.length);
            for (var h$1 = 0; h$1 < o$2.length + 1; h$1++) r$2[h$1] = h$1;
            for (h$1 = 0; h$1 < t$7.length; h$1++) {
              u[0] = h$1 + 1;
              for (var m$3 = 0; m$3 < o$2.length; m$3++) u[m$3 + 1] = Math.min(u[m$3] + 1, r$2[m$3 + 1] + 1, r$2[m$3] + +(t$7[h$1] != o$2[m$3]));
              for (m$3 = 0; m$3 < r$2.length; m$3++) r$2[m$3] = u[m$3];
            }
            return u[o$2.length];
          }, goog.proto2 = {}, goog.proto2.Descriptor = function(t$7, o$2, r$2) {
            for (this.messageType_ = t$7, this.name_ = o$2.name || null, this.fullName_ = o$2.fullName || null, this.containingType_ = o$2.containingType, this.fields_ = {}, t$7 = 0; t$7 < r$2.length; t$7++) o$2 = r$2[t$7], this.fields_[o$2.getTag()] = o$2;
          }, goog.proto2.Descriptor.prototype.getName = function() {
            return this.name_;
          }, goog.proto2.Descriptor.prototype.getFullName = function() {
            return this.fullName_;
          }, goog.proto2.Descriptor.prototype.getContainingType = function() {
            return this.containingType_ ? this.containingType_.getDescriptor() : null;
          }, goog.proto2.Descriptor.prototype.getFields = function() {
            var t$7 = goog.object.getValues(this.fields_);
            return module$contents$goog$array_sort(t$7, function(o$2, r$2) {
              return o$2.getTag() - r$2.getTag();
            }), t$7;
          }, goog.proto2.Descriptor.prototype.getFieldsMap = function() {
            return this.fields_;
          }, goog.proto2.Descriptor.prototype.findFieldByName = function(t$7) {
            return goog.object.findValue(this.fields_, function(o$2, r$2, u) {
              return o$2.getName() == t$7;
            }) || null;
          }, goog.proto2.Descriptor.prototype.findFieldByTag = function(t$7) {
            return goog.asserts.assert(goog.string.isNumeric(t$7)), this.fields_[parseInt(t$7, 10)] || null;
          }, goog.proto2.Descriptor.prototype.createMessageInstance = function() {
            return new this.messageType_();
          }, goog.proto2.FieldDescriptor = function(t$7, o$2, r$2) {
            switch (this.parent_ = t$7, goog.asserts.assert(goog.string.isNumeric(o$2)), this.tag_ = o$2, this.name_ = r$2.name, this.isPacked_ = !!r$2.packed, this.isRepeated_ = !!r$2.repeated, this.isRequired_ = !!r$2.required, this.fieldType_ = r$2.fieldType, this.nativeType_ = r$2.type, this.deserializationConversionPermitted_ = false, this.fieldType_) {
              case goog.proto2.FieldDescriptor.FieldType.INT64:
              case goog.proto2.FieldDescriptor.FieldType.UINT64:
              case goog.proto2.FieldDescriptor.FieldType.FIXED64:
              case goog.proto2.FieldDescriptor.FieldType.SFIXED64:
              case goog.proto2.FieldDescriptor.FieldType.SINT64:
              case goog.proto2.FieldDescriptor.FieldType.FLOAT:
              case goog.proto2.FieldDescriptor.FieldType.DOUBLE:
                this.deserializationConversionPermitted_ = true;
            }
            this.defaultValue_ = r$2.defaultValue;
          }, goog.proto2.FieldDescriptor.FieldType = { DOUBLE: 1, FLOAT: 2, INT64: 3, UINT64: 4, INT32: 5, FIXED64: 6, FIXED32: 7, BOOL: 8, STRING: 9, GROUP: 10, MESSAGE: 11, BYTES: 12, UINT32: 13, ENUM: 14, SFIXED32: 15, SFIXED64: 16, SINT32: 17, SINT64: 18 }, goog.proto2.FieldDescriptor.prototype.getTag = function() {
            return this.tag_;
          }, goog.proto2.FieldDescriptor.prototype.getContainingType = function() {
            return this.parent_.prototype.getDescriptor();
          }, goog.proto2.FieldDescriptor.prototype.getName = function() {
            return this.name_;
          }, goog.proto2.FieldDescriptor.prototype.getDefaultValue = function() {
            if (this.defaultValue_ === void 0) {
              var t$7 = this.nativeType_;
              if (t$7 === Boolean) this.defaultValue_ = false;
              else if (t$7 === Number) this.defaultValue_ = 0;
              else if (t$7 === String) this.defaultValue_ = this.deserializationConversionPermitted_ ? `0` : ``;
              else return new t$7();
            }
            return this.defaultValue_;
          }, goog.proto2.FieldDescriptor.prototype.getFieldType = function() {
            return this.fieldType_;
          }, goog.proto2.FieldDescriptor.prototype.getNativeType = function() {
            return this.nativeType_;
          }, goog.proto2.FieldDescriptor.prototype.deserializationConversionPermitted = function() {
            return this.deserializationConversionPermitted_;
          }, goog.proto2.FieldDescriptor.prototype.getFieldMessageType = function() {
            return this.nativeType_.prototype.getDescriptor();
          }, goog.proto2.FieldDescriptor.prototype.isCompositeType = function() {
            return this.fieldType_ == goog.proto2.FieldDescriptor.FieldType.MESSAGE || this.fieldType_ == goog.proto2.FieldDescriptor.FieldType.GROUP;
          }, goog.proto2.FieldDescriptor.prototype.isPacked = function() {
            return this.isPacked_;
          }, goog.proto2.FieldDescriptor.prototype.isRepeated = function() {
            return this.isRepeated_;
          }, goog.proto2.FieldDescriptor.prototype.isRequired = function() {
            return this.isRequired_;
          }, goog.proto2.FieldDescriptor.prototype.isOptional = function() {
            return !this.isRepeated_ && !this.isRequired_;
          }, goog.proto2.Message = function() {
            this.values_ = {}, this.fields_ = this.getDescriptor().getFieldsMap(), this.deserializedFields_ = this.lazyDeserializer_ = null;
          }, goog.proto2.Message.FieldType = { DOUBLE: 1, FLOAT: 2, INT64: 3, UINT64: 4, INT32: 5, FIXED64: 6, FIXED32: 7, BOOL: 8, STRING: 9, GROUP: 10, MESSAGE: 11, BYTES: 12, UINT32: 13, ENUM: 14, SFIXED32: 15, SFIXED64: 16, SINT32: 17, SINT64: 18 }, goog.proto2.Message.prototype.initializeForLazyDeserializer = function(t$7, o$2) {
            this.lazyDeserializer_ = t$7, this.values_ = o$2, this.deserializedFields_ = {};
          }, goog.proto2.Message.prototype.setUnknown = function(t$7, o$2) {
            goog.asserts.assert(!this.fields_[t$7], `Field is not unknown in this message`), goog.asserts.assert(1 <= t$7, `Tag ` + t$7 + ` has value "` + o$2 + `" in descriptor ` + this.getDescriptor().getName()), goog.asserts.assert(o$2 !== null, `Value cannot be null`), this.values_[t$7] = o$2, this.deserializedFields_ && delete this.deserializedFields_[t$7];
          }, goog.proto2.Message.prototype.forEachUnknown = function(t$7, o$2) {
            for (var r$2 in o$2 ||= this, this.values_) {
              var u = Number(r$2);
              this.fields_[u] || t$7.call(o$2, u, this.values_[r$2]);
            }
          }, goog.proto2.Message.prototype.getDescriptor = goog.abstractMethod, goog.proto2.Message.prototype.has = function(t$7) {
            return goog.asserts.assert(t$7.getContainingType() == this.getDescriptor(), `The current message does not contain the given field`), this.has$Value(t$7.getTag());
          }, goog.proto2.Message.prototype.arrayOf = function(t$7) {
            return goog.asserts.assert(t$7.getContainingType() == this.getDescriptor(), `The current message does not contain the given field`), this.array$Values(t$7.getTag());
          }, goog.proto2.Message.prototype.countOf = function(t$7) {
            return goog.asserts.assert(t$7.getContainingType() == this.getDescriptor(), `The current message does not contain the given field`), this.count$Values(t$7.getTag());
          }, goog.proto2.Message.prototype.get = function(t$7, o$2) {
            return goog.asserts.assert(t$7.getContainingType() == this.getDescriptor(), `The current message does not contain the given field`), this.get$Value(t$7.getTag(), o$2);
          }, goog.proto2.Message.prototype.getOrDefault = function(t$7, o$2) {
            return goog.asserts.assert(t$7.getContainingType() == this.getDescriptor(), `The current message does not contain the given field`), this.get$ValueOrDefault(t$7.getTag(), o$2);
          }, goog.proto2.Message.prototype.set = function(t$7, o$2) {
            goog.asserts.assert(t$7.getContainingType() == this.getDescriptor(), `The current message does not contain the given field`), this.set$Value(t$7.getTag(), o$2);
          }, goog.proto2.Message.prototype.add = function(t$7, o$2) {
            goog.asserts.assert(t$7.getContainingType() == this.getDescriptor(), `The current message does not contain the given field`), this.add$Value(t$7.getTag(), o$2);
          }, goog.proto2.Message.prototype.clear = function(t$7) {
            goog.asserts.assert(t$7.getContainingType() == this.getDescriptor(), `The current message does not contain the given field`), this.clear$Field(t$7.getTag());
          }, goog.proto2.Message.prototype.equals = function(t$7) {
            if (!t$7 || this.constructor != t$7.constructor) return false;
            for (var o$2 = this.getDescriptor().getFields(), r$2 = 0; r$2 < o$2.length; r$2++) {
              var u = o$2[r$2], h$1 = u.getTag();
              if (this.has$Value(h$1) != t$7.has$Value(h$1)) return false;
              if (this.has$Value(h$1)) {
                var m$3 = u.isCompositeType(), y$1 = this.getValueForTag_(h$1);
                if (h$1 = t$7.getValueForTag_(h$1), u.isRepeated()) {
                  if (y$1.length != h$1.length) return false;
                  for (u = 0; u < y$1.length; u++) {
                    var S = y$1[u], _ = h$1[u];
                    if (m$3 ? !S.equals(_) : S != _) return false;
                  }
                } else if (m$3 ? !y$1.equals(h$1) : y$1 != h$1) return false;
              }
            }
            return true;
          }, goog.proto2.Message.prototype.copyFrom = function(t$7) {
            goog.asserts.assert(this.constructor == t$7.constructor, `The source message must have the same type.`), this != t$7 && (this.values_ = {}, this.deserializedFields_ &&= {}, this.mergeFrom(t$7));
          }, goog.proto2.Message.prototype.mergeFrom = function(t$7) {
            goog.asserts.assert(this.constructor == t$7.constructor, `The source message must have the same type.`);
            for (var o$2 = this.getDescriptor().getFields(), r$2 = 0; r$2 < o$2.length; r$2++) {
              var u = o$2[r$2], h$1 = u.getTag();
              if (t$7.has$Value(h$1)) {
                this.deserializedFields_ && delete this.deserializedFields_[u.getTag()];
                var m$3 = u.isCompositeType();
                if (u.isRepeated()) {
                  u = t$7.array$Values(h$1);
                  for (var y$1 = 0; y$1 < u.length; y$1++) this.add$Value(h$1, m$3 ? u[y$1].clone() : u[y$1]);
                } else u = t$7.getValueForTag_(h$1), m$3 ? (m$3 = this.getValueForTag_(h$1)) ? m$3.mergeFrom(u) : this.set$Value(h$1, u.clone()) : this.set$Value(h$1, u);
              }
            }
          }, goog.proto2.Message.prototype.clone = function() {
            var t$7 = new this.constructor();
            return t$7.copyFrom(this), t$7;
          }, goog.proto2.Message.prototype.initDefaults = function(t$7) {
            for (var o$2 = this.getDescriptor().getFields(), r$2 = 0; r$2 < o$2.length; r$2++) {
              var u = o$2[r$2], h$1 = u.getTag(), m$3 = u.isCompositeType();
              if (this.has$Value(h$1) || u.isRepeated() || (m$3 ? this.values_[h$1] = new (u.getNativeType())() : t$7 && (this.values_[h$1] = u.getDefaultValue())), m$3) if (u.isRepeated()) for (u = this.array$Values(h$1), h$1 = 0; h$1 < u.length; h$1++) u[h$1].initDefaults(t$7);
              else this.get$Value(h$1).initDefaults(t$7);
            }
          }, goog.proto2.Message.prototype.has$Value = function(t$7) {
            return this.values_[t$7] != null;
          }, goog.proto2.Message.prototype.getValueForTag_ = function(t$7) {
            var o$2 = this.values_[t$7];
            return o$2 == null ? null : this.lazyDeserializer_ ? t$7 in this.deserializedFields_ ? this.deserializedFields_[t$7] : (o$2 = this.lazyDeserializer_.deserializeField(this, this.fields_[t$7], o$2), this.deserializedFields_[t$7] = o$2) : o$2;
          }, goog.proto2.Message.prototype.get$Value = function(t$7, o$2) {
            var r$2 = this.getValueForTag_(t$7);
            return this.fields_[t$7].isRepeated() ? (t$7 = o$2 || 0, goog.asserts.assert(0 <= t$7 && t$7 < r$2.length, `Given index %s is out of bounds.  Repeated field length: %s`, t$7, r$2.length), r$2[t$7]) : r$2;
          }, goog.proto2.Message.prototype.get$ValueOrDefault = function(t$7, o$2) {
            return this.has$Value(t$7) ? this.get$Value(t$7, o$2) : this.fields_[t$7].getDefaultValue();
          }, goog.proto2.Message.prototype.array$Values = function(t$7) {
            return this.getValueForTag_(t$7) || [];
          }, goog.proto2.Message.prototype.count$Values = function(t$7) {
            return this.fields_[t$7].isRepeated() ? this.has$Value(t$7) ? this.values_[t$7].length : 0 : this.has$Value(t$7) ? 1 : 0;
          }, goog.proto2.Message.prototype.set$Value = function(t$7, o$2) {
            goog.asserts.ENABLE_ASSERTS && this.checkFieldType_(this.fields_[t$7], o$2), this.values_[t$7] = o$2, this.deserializedFields_ && (this.deserializedFields_[t$7] = o$2);
          }, goog.proto2.Message.prototype.add$Value = function(t$7, o$2) {
            goog.asserts.ENABLE_ASSERTS && this.checkFieldType_(this.fields_[t$7], o$2), this.values_[t$7] || (this.values_[t$7] = []), this.values_[t$7].push(o$2), this.deserializedFields_ && delete this.deserializedFields_[t$7];
          }, goog.proto2.Message.prototype.checkFieldType_ = function(t$7, o$2) {
            t$7.getFieldType() == goog.proto2.FieldDescriptor.FieldType.ENUM ? goog.asserts.assertNumber(o$2) : goog.asserts.assert(Object(o$2).constructor == t$7.getNativeType());
          }, goog.proto2.Message.prototype.clear$Field = function(t$7) {
            delete this.values_[t$7], this.deserializedFields_ && delete this.deserializedFields_[t$7];
          }, goog.proto2.Message.createDescriptor = function(t$7, o$2) {
            var r$2 = [], u = o$2[0], h$1;
            for (h$1 in o$2) h$1 != 0 && r$2.push(new goog.proto2.FieldDescriptor(t$7, h$1, o$2[h$1]));
            return new goog.proto2.Descriptor(t$7, u, r$2);
          }, goog.proto2.Serializer = function() {
          }, goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS = false, goog.proto2.Serializer.prototype.serialize = goog.abstractMethod, goog.proto2.Serializer.prototype.getSerializedValue = function(t$7, o$2) {
            return t$7.isCompositeType() ? this.serialize(o$2) : typeof o$2 != `number` || isFinite(o$2) ? o$2 : o$2.toString();
          }, goog.proto2.Serializer.prototype.deserialize = function(t$7, o$2) {
            return t$7 = t$7.createMessageInstance(), this.deserializeTo(t$7, o$2), goog.asserts.assert(t$7 instanceof goog.proto2.Message), t$7;
          }, goog.proto2.Serializer.prototype.deserializeTo = goog.abstractMethod, goog.proto2.Serializer.prototype.getDeserializedValue = function(t$7, o$2) {
            if (t$7.isCompositeType()) return o$2 instanceof goog.proto2.Message ? o$2 : this.deserialize(t$7.getFieldMessageType(), o$2);
            if (t$7.getFieldType() == goog.proto2.FieldDescriptor.FieldType.ENUM) return goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS && typeof o$2 == `string` && (t$7 = t$7.getNativeType(), t$7.hasOwnProperty(o$2)) ? t$7[o$2] : typeof o$2 == `string` && goog.proto2.Serializer.INTEGER_REGEX.test(o$2) && (t$7 = Number(o$2), 0 < t$7) ? t$7 : o$2;
            if (!t$7.deserializationConversionPermitted()) return o$2;
            if (t$7 = t$7.getNativeType(), t$7 === String) {
              if (typeof o$2 == `number`) return String(o$2);
            } else if (t$7 === Number && typeof o$2 == `string` && (o$2 === `Infinity` || o$2 === `-Infinity` || o$2 === `NaN` || goog.proto2.Serializer.INTEGER_REGEX.test(o$2))) return Number(o$2);
            return o$2;
          }, goog.proto2.Serializer.INTEGER_REGEX = /^-?[0-9]+$/, goog.proto2.LazyDeserializer = function() {
          }, goog.inherits(goog.proto2.LazyDeserializer, goog.proto2.Serializer), goog.proto2.LazyDeserializer.prototype.deserialize = function(t$7, o$2) {
            return t$7 = t$7.createMessageInstance(), t$7.initializeForLazyDeserializer(this, o$2), goog.asserts.assert(t$7 instanceof goog.proto2.Message), t$7;
          }, goog.proto2.LazyDeserializer.prototype.deserializeTo = function(t$7, o$2) {
            throw Error(`Unimplemented`);
          }, goog.proto2.LazyDeserializer.prototype.deserializeField = goog.abstractMethod, goog.proto2.PbLiteSerializer = function() {
          }, goog.inherits(goog.proto2.PbLiteSerializer, goog.proto2.LazyDeserializer), goog.proto2.PbLiteSerializer.prototype.zeroIndexing_ = false, goog.proto2.PbLiteSerializer.prototype.setZeroIndexed = function(t$7) {
            this.zeroIndexing_ = t$7;
          }, goog.proto2.PbLiteSerializer.prototype.serialize = function(t$7) {
            for (var o$2 = t$7.getDescriptor().getFields(), r$2 = [], u = this.zeroIndexing_, h$1 = 0; h$1 < o$2.length; h$1++) {
              var m$3 = o$2[h$1];
              if (t$7.has(m$3)) {
                var y$1 = m$3.getTag();
                if (y$1 = u ? y$1 - 1 : y$1, m$3.isRepeated()) {
                  r$2[y$1] = [];
                  for (var S = 0; S < t$7.countOf(m$3); S++) r$2[y$1][S] = this.getSerializedValue(m$3, t$7.get(m$3, S));
                } else r$2[y$1] = this.getSerializedValue(m$3, t$7.get(m$3));
              }
            }
            return t$7.forEachUnknown(function(_, C) {
              r$2[u ? _ - 1 : _] = C;
            }), r$2;
          }, goog.proto2.PbLiteSerializer.prototype.deserializeField = function(t$7, o$2, r$2) {
            if (r$2 == null) return r$2;
            if (o$2.isRepeated()) {
              t$7 = [], goog.asserts.assert(Array.isArray(r$2), `Value must be array: %s`, r$2);
              for (var u = 0; u < r$2.length; u++) t$7[u] = this.getDeserializedValue(o$2, r$2[u]);
              return t$7;
            }
            return this.getDeserializedValue(o$2, r$2);
          }, goog.proto2.PbLiteSerializer.prototype.getSerializedValue = function(t$7, o$2) {
            return t$7.getFieldType() == goog.proto2.FieldDescriptor.FieldType.BOOL ? o$2 ? 1 : 0 : goog.proto2.Serializer.prototype.getSerializedValue.apply(this, arguments);
          }, goog.proto2.PbLiteSerializer.prototype.getDeserializedValue = function(t$7, o$2) {
            return t$7.getFieldType() == goog.proto2.FieldDescriptor.FieldType.BOOL ? (goog.asserts.assert(typeof o$2 == `number` || typeof o$2 == `boolean`, `Value is expected to be a number or boolean`), !!o$2) : goog.proto2.Serializer.prototype.getDeserializedValue.apply(this, arguments);
          }, goog.proto2.PbLiteSerializer.prototype.deserialize = function(t$7, o$2) {
            var r$2 = o$2;
            if (this.zeroIndexing_) for (var u in r$2 = [], o$2) r$2[parseInt(u, 10) + 1] = o$2[u];
            return goog.proto2.PbLiteSerializer.superClass_.deserialize.call(this, t$7, r$2);
          }, goog.string.StringBuffer = function(t$7, o$2) {
            t$7 != null && this.append.apply(this, arguments);
          }, goog.string.StringBuffer.prototype.buffer_ = ``, goog.string.StringBuffer.prototype.set = function(t$7) {
            this.buffer_ = `` + t$7;
          }, goog.string.StringBuffer.prototype.append = function(t$7, o$2, r$2) {
            if (this.buffer_ += String(t$7), o$2 != null) for (var u = 1; u < arguments.length; u++) this.buffer_ += arguments[u];
            return this;
          }, goog.string.StringBuffer.prototype.clear = function() {
            this.buffer_ = ``;
          }, goog.string.StringBuffer.prototype.getLength = function() {
            return this.buffer_.length;
          }, goog.string.StringBuffer.prototype.toString = function() {
            return this.buffer_;
          };
          var i18n$1 = { phonenumbers: {} };
          i18n$1.phonenumbers.NumberFormat = function() {
            goog.proto2.Message.call(this);
          }, goog.inherits(i18n$1.phonenumbers.NumberFormat, goog.proto2.Message), i18n$1.phonenumbers.NumberFormat.descriptor_ = null, i18n$1.phonenumbers.NumberFormat.prototype.getPattern = function() {
            return this.get$Value(1);
          }, i18n$1.phonenumbers.NumberFormat.prototype.getPatternOrDefault = function() {
            return this.get$ValueOrDefault(1);
          }, i18n$1.phonenumbers.NumberFormat.prototype.setPattern = function(t$7) {
            this.set$Value(1, t$7);
          }, i18n$1.phonenumbers.NumberFormat.prototype.hasPattern = function() {
            return this.has$Value(1);
          }, i18n$1.phonenumbers.NumberFormat.prototype.patternCount = function() {
            return this.count$Values(1);
          }, i18n$1.phonenumbers.NumberFormat.prototype.clearPattern = function() {
            this.clear$Field(1);
          }, i18n$1.phonenumbers.NumberFormat.prototype.getFormat = function() {
            return this.get$Value(2);
          }, i18n$1.phonenumbers.NumberFormat.prototype.getFormatOrDefault = function() {
            return this.get$ValueOrDefault(2);
          }, i18n$1.phonenumbers.NumberFormat.prototype.setFormat = function(t$7) {
            this.set$Value(2, t$7);
          }, i18n$1.phonenumbers.NumberFormat.prototype.hasFormat = function() {
            return this.has$Value(2);
          }, i18n$1.phonenumbers.NumberFormat.prototype.formatCount = function() {
            return this.count$Values(2);
          }, i18n$1.phonenumbers.NumberFormat.prototype.clearFormat = function() {
            this.clear$Field(2);
          }, i18n$1.phonenumbers.NumberFormat.prototype.getLeadingDigitsPattern = function(t$7) {
            return this.get$Value(3, t$7);
          }, i18n$1.phonenumbers.NumberFormat.prototype.getLeadingDigitsPatternOrDefault = function(t$7) {
            return this.get$ValueOrDefault(3, t$7);
          }, i18n$1.phonenumbers.NumberFormat.prototype.addLeadingDigitsPattern = function(t$7) {
            this.add$Value(3, t$7);
          }, i18n$1.phonenumbers.NumberFormat.prototype.leadingDigitsPatternArray = function() {
            return this.array$Values(3);
          }, i18n$1.phonenumbers.NumberFormat.prototype.hasLeadingDigitsPattern = function() {
            return this.has$Value(3);
          }, i18n$1.phonenumbers.NumberFormat.prototype.leadingDigitsPatternCount = function() {
            return this.count$Values(3);
          }, i18n$1.phonenumbers.NumberFormat.prototype.clearLeadingDigitsPattern = function() {
            this.clear$Field(3);
          }, i18n$1.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRule = function() {
            return this.get$Value(4);
          }, i18n$1.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRuleOrDefault = function() {
            return this.get$ValueOrDefault(4);
          }, i18n$1.phonenumbers.NumberFormat.prototype.setNationalPrefixFormattingRule = function(t$7) {
            this.set$Value(4, t$7);
          }, i18n$1.phonenumbers.NumberFormat.prototype.hasNationalPrefixFormattingRule = function() {
            return this.has$Value(4);
          }, i18n$1.phonenumbers.NumberFormat.prototype.nationalPrefixFormattingRuleCount = function() {
            return this.count$Values(4);
          }, i18n$1.phonenumbers.NumberFormat.prototype.clearNationalPrefixFormattingRule = function() {
            this.clear$Field(4);
          }, i18n$1.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormatting = function() {
            return this.get$Value(6);
          }, i18n$1.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormattingOrDefault = function() {
            return this.get$ValueOrDefault(6);
          }, i18n$1.phonenumbers.NumberFormat.prototype.setNationalPrefixOptionalWhenFormatting = function(t$7) {
            this.set$Value(6, t$7);
          }, i18n$1.phonenumbers.NumberFormat.prototype.hasNationalPrefixOptionalWhenFormatting = function() {
            return this.has$Value(6);
          }, i18n$1.phonenumbers.NumberFormat.prototype.nationalPrefixOptionalWhenFormattingCount = function() {
            return this.count$Values(6);
          }, i18n$1.phonenumbers.NumberFormat.prototype.clearNationalPrefixOptionalWhenFormatting = function() {
            this.clear$Field(6);
          }, i18n$1.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRule = function() {
            return this.get$Value(5);
          }, i18n$1.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRuleOrDefault = function() {
            return this.get$ValueOrDefault(5);
          }, i18n$1.phonenumbers.NumberFormat.prototype.setDomesticCarrierCodeFormattingRule = function(t$7) {
            this.set$Value(5, t$7);
          }, i18n$1.phonenumbers.NumberFormat.prototype.hasDomesticCarrierCodeFormattingRule = function() {
            return this.has$Value(5);
          }, i18n$1.phonenumbers.NumberFormat.prototype.domesticCarrierCodeFormattingRuleCount = function() {
            return this.count$Values(5);
          }, i18n$1.phonenumbers.NumberFormat.prototype.clearDomesticCarrierCodeFormattingRule = function() {
            this.clear$Field(5);
          }, i18n$1.phonenumbers.PhoneNumberDesc = function() {
            goog.proto2.Message.call(this);
          }, goog.inherits(i18n$1.phonenumbers.PhoneNumberDesc, goog.proto2.Message), i18n$1.phonenumbers.PhoneNumberDesc.descriptor_ = null, i18n$1.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPattern = function() {
            return this.get$Value(2);
          }, i18n$1.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPatternOrDefault = function() {
            return this.get$ValueOrDefault(2);
          }, i18n$1.phonenumbers.PhoneNumberDesc.prototype.setNationalNumberPattern = function(t$7) {
            this.set$Value(2, t$7);
          }, i18n$1.phonenumbers.PhoneNumberDesc.prototype.hasNationalNumberPattern = function() {
            return this.has$Value(2);
          }, i18n$1.phonenumbers.PhoneNumberDesc.prototype.nationalNumberPatternCount = function() {
            return this.count$Values(2);
          }, i18n$1.phonenumbers.PhoneNumberDesc.prototype.clearNationalNumberPattern = function() {
            this.clear$Field(2);
          }, i18n$1.phonenumbers.PhoneNumberDesc.prototype.getPossibleLength = function(t$7) {
            return this.get$Value(9, t$7);
          }, i18n$1.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthOrDefault = function(t$7) {
            return this.get$ValueOrDefault(9, t$7);
          }, i18n$1.phonenumbers.PhoneNumberDesc.prototype.addPossibleLength = function(t$7) {
            this.add$Value(9, t$7);
          }, i18n$1.phonenumbers.PhoneNumberDesc.prototype.possibleLengthArray = function() {
            return this.array$Values(9);
          }, i18n$1.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLength = function() {
            return this.has$Value(9);
          }, i18n$1.phonenumbers.PhoneNumberDesc.prototype.possibleLengthCount = function() {
            return this.count$Values(9);
          }, i18n$1.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLength = function() {
            this.clear$Field(9);
          }, i18n$1.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnly = function(t$7) {
            return this.get$Value(10, t$7);
          }, i18n$1.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnlyOrDefault = function(t$7) {
            return this.get$ValueOrDefault(10, t$7);
          }, i18n$1.phonenumbers.PhoneNumberDesc.prototype.addPossibleLengthLocalOnly = function(t$7) {
            this.add$Value(10, t$7);
          }, i18n$1.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyArray = function() {
            return this.array$Values(10);
          }, i18n$1.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLengthLocalOnly = function() {
            return this.has$Value(10);
          }, i18n$1.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyCount = function() {
            return this.count$Values(10);
          }, i18n$1.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLengthLocalOnly = function() {
            this.clear$Field(10);
          }, i18n$1.phonenumbers.PhoneNumberDesc.prototype.getExampleNumber = function() {
            return this.get$Value(6);
          }, i18n$1.phonenumbers.PhoneNumberDesc.prototype.getExampleNumberOrDefault = function() {
            return this.get$ValueOrDefault(6);
          }, i18n$1.phonenumbers.PhoneNumberDesc.prototype.setExampleNumber = function(t$7) {
            this.set$Value(6, t$7);
          }, i18n$1.phonenumbers.PhoneNumberDesc.prototype.hasExampleNumber = function() {
            return this.has$Value(6);
          }, i18n$1.phonenumbers.PhoneNumberDesc.prototype.exampleNumberCount = function() {
            return this.count$Values(6);
          }, i18n$1.phonenumbers.PhoneNumberDesc.prototype.clearExampleNumber = function() {
            this.clear$Field(6);
          }, i18n$1.phonenumbers.PhoneMetadata = function() {
            goog.proto2.Message.call(this);
          }, goog.inherits(i18n$1.phonenumbers.PhoneMetadata, goog.proto2.Message), i18n$1.phonenumbers.PhoneMetadata.descriptor_ = null, i18n$1.phonenumbers.PhoneMetadata.prototype.getGeneralDesc = function() {
            return this.get$Value(1);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getGeneralDescOrDefault = function() {
            return this.get$ValueOrDefault(1);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setGeneralDesc = function(t$7) {
            this.set$Value(1, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasGeneralDesc = function() {
            return this.has$Value(1);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.generalDescCount = function() {
            return this.count$Values(1);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearGeneralDesc = function() {
            this.clear$Field(1);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getFixedLine = function() {
            return this.get$Value(2);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getFixedLineOrDefault = function() {
            return this.get$ValueOrDefault(2);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setFixedLine = function(t$7) {
            this.set$Value(2, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasFixedLine = function() {
            return this.has$Value(2);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.fixedLineCount = function() {
            return this.count$Values(2);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearFixedLine = function() {
            this.clear$Field(2);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getMobile = function() {
            return this.get$Value(3);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getMobileOrDefault = function() {
            return this.get$ValueOrDefault(3);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setMobile = function(t$7) {
            this.set$Value(3, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasMobile = function() {
            return this.has$Value(3);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.mobileCount = function() {
            return this.count$Values(3);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearMobile = function() {
            this.clear$Field(3);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getTollFree = function() {
            return this.get$Value(4);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getTollFreeOrDefault = function() {
            return this.get$ValueOrDefault(4);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setTollFree = function(t$7) {
            this.set$Value(4, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasTollFree = function() {
            return this.has$Value(4);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.tollFreeCount = function() {
            return this.count$Values(4);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearTollFree = function() {
            this.clear$Field(4);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getPremiumRate = function() {
            return this.get$Value(5);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getPremiumRateOrDefault = function() {
            return this.get$ValueOrDefault(5);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setPremiumRate = function(t$7) {
            this.set$Value(5, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasPremiumRate = function() {
            return this.has$Value(5);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.premiumRateCount = function() {
            return this.count$Values(5);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearPremiumRate = function() {
            this.clear$Field(5);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getSharedCost = function() {
            return this.get$Value(6);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getSharedCostOrDefault = function() {
            return this.get$ValueOrDefault(6);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setSharedCost = function(t$7) {
            this.set$Value(6, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasSharedCost = function() {
            return this.has$Value(6);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.sharedCostCount = function() {
            return this.count$Values(6);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearSharedCost = function() {
            this.clear$Field(6);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getPersonalNumber = function() {
            return this.get$Value(7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getPersonalNumberOrDefault = function() {
            return this.get$ValueOrDefault(7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setPersonalNumber = function(t$7) {
            this.set$Value(7, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasPersonalNumber = function() {
            return this.has$Value(7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.personalNumberCount = function() {
            return this.count$Values(7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearPersonalNumber = function() {
            this.clear$Field(7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getVoip = function() {
            return this.get$Value(8);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getVoipOrDefault = function() {
            return this.get$ValueOrDefault(8);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setVoip = function(t$7) {
            this.set$Value(8, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasVoip = function() {
            return this.has$Value(8);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.voipCount = function() {
            return this.count$Values(8);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearVoip = function() {
            this.clear$Field(8);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getPager = function() {
            return this.get$Value(21);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getPagerOrDefault = function() {
            return this.get$ValueOrDefault(21);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setPager = function(t$7) {
            this.set$Value(21, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasPager = function() {
            return this.has$Value(21);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.pagerCount = function() {
            return this.count$Values(21);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearPager = function() {
            this.clear$Field(21);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getUan = function() {
            return this.get$Value(25);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getUanOrDefault = function() {
            return this.get$ValueOrDefault(25);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setUan = function(t$7) {
            this.set$Value(25, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasUan = function() {
            return this.has$Value(25);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.uanCount = function() {
            return this.count$Values(25);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearUan = function() {
            this.clear$Field(25);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getEmergency = function() {
            return this.get$Value(27);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getEmergencyOrDefault = function() {
            return this.get$ValueOrDefault(27);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setEmergency = function(t$7) {
            this.set$Value(27, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasEmergency = function() {
            return this.has$Value(27);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.emergencyCount = function() {
            return this.count$Values(27);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearEmergency = function() {
            this.clear$Field(27);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getVoicemail = function() {
            return this.get$Value(28);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getVoicemailOrDefault = function() {
            return this.get$ValueOrDefault(28);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setVoicemail = function(t$7) {
            this.set$Value(28, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasVoicemail = function() {
            return this.has$Value(28);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.voicemailCount = function() {
            return this.count$Values(28);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearVoicemail = function() {
            this.clear$Field(28);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getShortCode = function() {
            return this.get$Value(29);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getShortCodeOrDefault = function() {
            return this.get$ValueOrDefault(29);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setShortCode = function(t$7) {
            this.set$Value(29, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasShortCode = function() {
            return this.has$Value(29);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.shortCodeCount = function() {
            return this.count$Values(29);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearShortCode = function() {
            this.clear$Field(29);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getStandardRate = function() {
            return this.get$Value(30);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getStandardRateOrDefault = function() {
            return this.get$ValueOrDefault(30);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setStandardRate = function(t$7) {
            this.set$Value(30, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasStandardRate = function() {
            return this.has$Value(30);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.standardRateCount = function() {
            return this.count$Values(30);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearStandardRate = function() {
            this.clear$Field(30);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getCarrierSpecific = function() {
            return this.get$Value(31);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getCarrierSpecificOrDefault = function() {
            return this.get$ValueOrDefault(31);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setCarrierSpecific = function(t$7) {
            this.set$Value(31, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasCarrierSpecific = function() {
            return this.has$Value(31);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.carrierSpecificCount = function() {
            return this.count$Values(31);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearCarrierSpecific = function() {
            this.clear$Field(31);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getSmsServices = function() {
            return this.get$Value(33);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getSmsServicesOrDefault = function() {
            return this.get$ValueOrDefault(33);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setSmsServices = function(t$7) {
            this.set$Value(33, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasSmsServices = function() {
            return this.has$Value(33);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.smsServicesCount = function() {
            return this.count$Values(33);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearSmsServices = function() {
            this.clear$Field(33);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getNoInternationalDialling = function() {
            return this.get$Value(24);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getNoInternationalDiallingOrDefault = function() {
            return this.get$ValueOrDefault(24);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setNoInternationalDialling = function(t$7) {
            this.set$Value(24, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasNoInternationalDialling = function() {
            return this.has$Value(24);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.noInternationalDiallingCount = function() {
            return this.count$Values(24);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearNoInternationalDialling = function() {
            this.clear$Field(24);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getId = function() {
            return this.get$Value(9);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getIdOrDefault = function() {
            return this.get$ValueOrDefault(9);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setId = function(t$7) {
            this.set$Value(9, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasId = function() {
            return this.has$Value(9);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.idCount = function() {
            return this.count$Values(9);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearId = function() {
            this.clear$Field(9);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getCountryCode = function() {
            return this.get$Value(10);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getCountryCodeOrDefault = function() {
            return this.get$ValueOrDefault(10);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setCountryCode = function(t$7) {
            this.set$Value(10, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasCountryCode = function() {
            return this.has$Value(10);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.countryCodeCount = function() {
            return this.count$Values(10);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearCountryCode = function() {
            this.clear$Field(10);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getInternationalPrefix = function() {
            return this.get$Value(11);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getInternationalPrefixOrDefault = function() {
            return this.get$ValueOrDefault(11);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setInternationalPrefix = function(t$7) {
            this.set$Value(11, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasInternationalPrefix = function() {
            return this.has$Value(11);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.internationalPrefixCount = function() {
            return this.count$Values(11);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearInternationalPrefix = function() {
            this.clear$Field(11);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefix = function() {
            return this.get$Value(17);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefixOrDefault = function() {
            return this.get$ValueOrDefault(17);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setPreferredInternationalPrefix = function(t$7) {
            this.set$Value(17, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasPreferredInternationalPrefix = function() {
            return this.has$Value(17);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.preferredInternationalPrefixCount = function() {
            return this.count$Values(17);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearPreferredInternationalPrefix = function() {
            this.clear$Field(17);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getNationalPrefix = function() {
            return this.get$Value(12);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getNationalPrefixOrDefault = function() {
            return this.get$ValueOrDefault(12);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setNationalPrefix = function(t$7) {
            this.set$Value(12, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasNationalPrefix = function() {
            return this.has$Value(12);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.nationalPrefixCount = function() {
            return this.count$Values(12);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearNationalPrefix = function() {
            this.clear$Field(12);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefix = function() {
            return this.get$Value(13);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefixOrDefault = function() {
            return this.get$ValueOrDefault(13);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setPreferredExtnPrefix = function(t$7) {
            this.set$Value(13, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasPreferredExtnPrefix = function() {
            return this.has$Value(13);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.preferredExtnPrefixCount = function() {
            return this.count$Values(13);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearPreferredExtnPrefix = function() {
            this.clear$Field(13);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsing = function() {
            return this.get$Value(15);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsingOrDefault = function() {
            return this.get$ValueOrDefault(15);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setNationalPrefixForParsing = function(t$7) {
            this.set$Value(15, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixForParsing = function() {
            return this.has$Value(15);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.nationalPrefixForParsingCount = function() {
            return this.count$Values(15);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixForParsing = function() {
            this.clear$Field(15);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRule = function() {
            return this.get$Value(16);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRuleOrDefault = function() {
            return this.get$ValueOrDefault(16);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setNationalPrefixTransformRule = function(t$7) {
            this.set$Value(16, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixTransformRule = function() {
            return this.has$Value(16);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.nationalPrefixTransformRuleCount = function() {
            return this.count$Values(16);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixTransformRule = function() {
            this.clear$Field(16);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePattern = function() {
            return this.get$Value(18);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePatternOrDefault = function() {
            return this.get$ValueOrDefault(18);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setSameMobileAndFixedLinePattern = function(t$7) {
            this.set$Value(18, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasSameMobileAndFixedLinePattern = function() {
            return this.has$Value(18);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.sameMobileAndFixedLinePatternCount = function() {
            return this.count$Values(18);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearSameMobileAndFixedLinePattern = function() {
            this.clear$Field(18);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getNumberFormat = function(t$7) {
            return this.get$Value(19, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getNumberFormatOrDefault = function(t$7) {
            return this.get$ValueOrDefault(19, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.addNumberFormat = function(t$7) {
            this.add$Value(19, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.numberFormatArray = function() {
            return this.array$Values(19);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasNumberFormat = function() {
            return this.has$Value(19);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.numberFormatCount = function() {
            return this.count$Values(19);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearNumberFormat = function() {
            this.clear$Field(19);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormat = function(t$7) {
            return this.get$Value(20, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormatOrDefault = function(t$7) {
            return this.get$ValueOrDefault(20, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.addIntlNumberFormat = function(t$7) {
            this.add$Value(20, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.intlNumberFormatArray = function() {
            return this.array$Values(20);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasIntlNumberFormat = function() {
            return this.has$Value(20);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.intlNumberFormatCount = function() {
            return this.count$Values(20);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearIntlNumberFormat = function() {
            this.clear$Field(20);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getMainCountryForCode = function() {
            return this.get$Value(22);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getMainCountryForCodeOrDefault = function() {
            return this.get$ValueOrDefault(22);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setMainCountryForCode = function(t$7) {
            this.set$Value(22, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasMainCountryForCode = function() {
            return this.has$Value(22);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.mainCountryForCodeCount = function() {
            return this.count$Values(22);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearMainCountryForCode = function() {
            this.clear$Field(22);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getLeadingDigits = function() {
            return this.get$Value(23);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.getLeadingDigitsOrDefault = function() {
            return this.get$ValueOrDefault(23);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.setLeadingDigits = function(t$7) {
            this.set$Value(23, t$7);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.hasLeadingDigits = function() {
            return this.has$Value(23);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.leadingDigitsCount = function() {
            return this.count$Values(23);
          }, i18n$1.phonenumbers.PhoneMetadata.prototype.clearLeadingDigits = function() {
            this.clear$Field(23);
          }, i18n$1.phonenumbers.PhoneMetadataCollection = function() {
            goog.proto2.Message.call(this);
          }, goog.inherits(i18n$1.phonenumbers.PhoneMetadataCollection, goog.proto2.Message), i18n$1.phonenumbers.PhoneMetadataCollection.descriptor_ = null, i18n$1.phonenumbers.PhoneMetadataCollection.prototype.getMetadata = function(t$7) {
            return this.get$Value(1, t$7);
          }, i18n$1.phonenumbers.PhoneMetadataCollection.prototype.getMetadataOrDefault = function(t$7) {
            return this.get$ValueOrDefault(1, t$7);
          }, i18n$1.phonenumbers.PhoneMetadataCollection.prototype.addMetadata = function(t$7) {
            this.add$Value(1, t$7);
          }, i18n$1.phonenumbers.PhoneMetadataCollection.prototype.metadataArray = function() {
            return this.array$Values(1);
          }, i18n$1.phonenumbers.PhoneMetadataCollection.prototype.hasMetadata = function() {
            return this.has$Value(1);
          }, i18n$1.phonenumbers.PhoneMetadataCollection.prototype.metadataCount = function() {
            return this.count$Values(1);
          }, i18n$1.phonenumbers.PhoneMetadataCollection.prototype.clearMetadata = function() {
            this.clear$Field(1);
          }, i18n$1.phonenumbers.NumberFormat.prototype.getDescriptor = function() {
            var t$7 = i18n$1.phonenumbers.NumberFormat.descriptor_;
            return t$7 || (i18n$1.phonenumbers.NumberFormat.descriptor_ = t$7 = goog.proto2.Message.createDescriptor(i18n$1.phonenumbers.NumberFormat, { 0: { name: `NumberFormat`, fullName: `i18n.phonenumbers.NumberFormat` }, 1: { name: `pattern`, required: true, fieldType: goog.proto2.Message.FieldType.STRING, type: String }, 2: { name: `format`, required: true, fieldType: goog.proto2.Message.FieldType.STRING, type: String }, 3: { name: `leading_digits_pattern`, repeated: true, fieldType: goog.proto2.Message.FieldType.STRING, type: String }, 4: { name: `national_prefix_formatting_rule`, fieldType: goog.proto2.Message.FieldType.STRING, type: String }, 6: { name: `national_prefix_optional_when_formatting`, fieldType: goog.proto2.Message.FieldType.BOOL, defaultValue: false, type: Boolean }, 5: { name: `domestic_carrier_code_formatting_rule`, fieldType: goog.proto2.Message.FieldType.STRING, type: String } })), t$7;
          }, i18n$1.phonenumbers.NumberFormat.getDescriptor = i18n$1.phonenumbers.NumberFormat.prototype.getDescriptor, i18n$1.phonenumbers.PhoneNumberDesc.prototype.getDescriptor = function() {
            var t$7 = i18n$1.phonenumbers.PhoneNumberDesc.descriptor_;
            return t$7 || (i18n$1.phonenumbers.PhoneNumberDesc.descriptor_ = t$7 = goog.proto2.Message.createDescriptor(i18n$1.phonenumbers.PhoneNumberDesc, { 0: { name: `PhoneNumberDesc`, fullName: `i18n.phonenumbers.PhoneNumberDesc` }, 2: { name: `national_number_pattern`, fieldType: goog.proto2.Message.FieldType.STRING, type: String }, 9: { name: `possible_length`, repeated: true, fieldType: goog.proto2.Message.FieldType.INT32, type: Number }, 10: { name: `possible_length_local_only`, repeated: true, fieldType: goog.proto2.Message.FieldType.INT32, type: Number }, 6: { name: `example_number`, fieldType: goog.proto2.Message.FieldType.STRING, type: String } })), t$7;
          }, i18n$1.phonenumbers.PhoneNumberDesc.getDescriptor = i18n$1.phonenumbers.PhoneNumberDesc.prototype.getDescriptor, i18n$1.phonenumbers.PhoneMetadata.prototype.getDescriptor = function() {
            var t$7 = i18n$1.phonenumbers.PhoneMetadata.descriptor_;
            return t$7 || (i18n$1.phonenumbers.PhoneMetadata.descriptor_ = t$7 = goog.proto2.Message.createDescriptor(i18n$1.phonenumbers.PhoneMetadata, { 0: { name: `PhoneMetadata`, fullName: `i18n.phonenumbers.PhoneMetadata` }, 1: { name: `general_desc`, fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n$1.phonenumbers.PhoneNumberDesc }, 2: { name: `fixed_line`, fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n$1.phonenumbers.PhoneNumberDesc }, 3: { name: `mobile`, fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n$1.phonenumbers.PhoneNumberDesc }, 4: { name: `toll_free`, fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n$1.phonenumbers.PhoneNumberDesc }, 5: { name: `premium_rate`, fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n$1.phonenumbers.PhoneNumberDesc }, 6: { name: `shared_cost`, fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n$1.phonenumbers.PhoneNumberDesc }, 7: { name: `personal_number`, fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n$1.phonenumbers.PhoneNumberDesc }, 8: { name: `voip`, fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n$1.phonenumbers.PhoneNumberDesc }, 21: { name: `pager`, fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n$1.phonenumbers.PhoneNumberDesc }, 25: { name: `uan`, fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n$1.phonenumbers.PhoneNumberDesc }, 27: { name: `emergency`, fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n$1.phonenumbers.PhoneNumberDesc }, 28: { name: `voicemail`, fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n$1.phonenumbers.PhoneNumberDesc }, 29: { name: `short_code`, fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n$1.phonenumbers.PhoneNumberDesc }, 30: { name: `standard_rate`, fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n$1.phonenumbers.PhoneNumberDesc }, 31: { name: `carrier_specific`, fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n$1.phonenumbers.PhoneNumberDesc }, 33: { name: `sms_services`, fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n$1.phonenumbers.PhoneNumberDesc }, 24: { name: `no_international_dialling`, fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n$1.phonenumbers.PhoneNumberDesc }, 9: { name: `id`, required: true, fieldType: goog.proto2.Message.FieldType.STRING, type: String }, 10: { name: `country_code`, fieldType: goog.proto2.Message.FieldType.INT32, type: Number }, 11: { name: `international_prefix`, fieldType: goog.proto2.Message.FieldType.STRING, type: String }, 17: { name: `preferred_international_prefix`, fieldType: goog.proto2.Message.FieldType.STRING, type: String }, 12: { name: `national_prefix`, fieldType: goog.proto2.Message.FieldType.STRING, type: String }, 13: { name: `preferred_extn_prefix`, fieldType: goog.proto2.Message.FieldType.STRING, type: String }, 15: { name: `national_prefix_for_parsing`, fieldType: goog.proto2.Message.FieldType.STRING, type: String }, 16: { name: `national_prefix_transform_rule`, fieldType: goog.proto2.Message.FieldType.STRING, type: String }, 18: { name: `same_mobile_and_fixed_line_pattern`, fieldType: goog.proto2.Message.FieldType.BOOL, defaultValue: false, type: Boolean }, 19: { name: `number_format`, repeated: true, fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n$1.phonenumbers.NumberFormat }, 20: { name: `intl_number_format`, repeated: true, fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n$1.phonenumbers.NumberFormat }, 22: { name: `main_country_for_code`, fieldType: goog.proto2.Message.FieldType.BOOL, defaultValue: false, type: Boolean }, 23: { name: `leading_digits`, fieldType: goog.proto2.Message.FieldType.STRING, type: String } })), t$7;
          }, i18n$1.phonenumbers.PhoneMetadata.getDescriptor = i18n$1.phonenumbers.PhoneMetadata.prototype.getDescriptor, i18n$1.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor = function() {
            var t$7 = i18n$1.phonenumbers.PhoneMetadataCollection.descriptor_;
            return t$7 || (i18n$1.phonenumbers.PhoneMetadataCollection.descriptor_ = t$7 = goog.proto2.Message.createDescriptor(i18n$1.phonenumbers.PhoneMetadataCollection, { 0: { name: `PhoneMetadataCollection`, fullName: `i18n.phonenumbers.PhoneMetadataCollection` }, 1: { name: `metadata`, repeated: true, fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n$1.phonenumbers.PhoneMetadata } })), t$7;
          }, i18n$1.phonenumbers.PhoneMetadataCollection.getDescriptor = i18n$1.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor, i18n$1.phonenumbers.PhoneNumber = function() {
            goog.proto2.Message.call(this);
          }, goog.inherits(i18n$1.phonenumbers.PhoneNumber, goog.proto2.Message), i18n$1.phonenumbers.PhoneNumber.descriptor_ = null, i18n$1.phonenumbers.PhoneNumber.prototype.getCountryCode = function() {
            return this.get$Value(1);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.getCountryCodeOrDefault = function() {
            return this.get$ValueOrDefault(1);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.setCountryCode = function(t$7) {
            this.set$Value(1, t$7);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.hasCountryCode = function() {
            return this.has$Value(1);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.countryCodeCount = function() {
            return this.count$Values(1);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.clearCountryCode = function() {
            this.clear$Field(1);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.getNationalNumber = function() {
            return this.get$Value(2);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.getNationalNumberOrDefault = function() {
            return this.get$ValueOrDefault(2);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.setNationalNumber = function(t$7) {
            this.set$Value(2, t$7);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.hasNationalNumber = function() {
            return this.has$Value(2);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.nationalNumberCount = function() {
            return this.count$Values(2);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.clearNationalNumber = function() {
            this.clear$Field(2);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.getExtension = function() {
            return this.get$Value(3);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.getExtensionOrDefault = function() {
            return this.get$ValueOrDefault(3);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.setExtension = function(t$7) {
            this.set$Value(3, t$7);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.hasExtension = function() {
            return this.has$Value(3);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.extensionCount = function() {
            return this.count$Values(3);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.clearExtension = function() {
            this.clear$Field(3);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.getItalianLeadingZero = function() {
            return this.get$Value(4);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.getItalianLeadingZeroOrDefault = function() {
            return this.get$ValueOrDefault(4);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.setItalianLeadingZero = function(t$7) {
            this.set$Value(4, t$7);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.hasItalianLeadingZero = function() {
            return this.has$Value(4);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.italianLeadingZeroCount = function() {
            return this.count$Values(4);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.clearItalianLeadingZero = function() {
            this.clear$Field(4);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZeros = function() {
            return this.get$Value(8);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZerosOrDefault = function() {
            return this.get$ValueOrDefault(8);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.setNumberOfLeadingZeros = function(t$7) {
            this.set$Value(8, t$7);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.hasNumberOfLeadingZeros = function() {
            return this.has$Value(8);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.numberOfLeadingZerosCount = function() {
            return this.count$Values(8);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.clearNumberOfLeadingZeros = function() {
            this.clear$Field(8);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.getRawInput = function() {
            return this.get$Value(5);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.getRawInputOrDefault = function() {
            return this.get$ValueOrDefault(5);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.setRawInput = function(t$7) {
            this.set$Value(5, t$7);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.hasRawInput = function() {
            return this.has$Value(5);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.rawInputCount = function() {
            return this.count$Values(5);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.clearRawInput = function() {
            this.clear$Field(5);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.getCountryCodeSource = function() {
            return this.get$Value(6);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.getCountryCodeSourceOrDefault = function() {
            return this.get$ValueOrDefault(6);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.setCountryCodeSource = function(t$7) {
            this.set$Value(6, t$7);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.hasCountryCodeSource = function() {
            return this.has$Value(6);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.countryCodeSourceCount = function() {
            return this.count$Values(6);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.clearCountryCodeSource = function() {
            this.clear$Field(6);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCode = function() {
            return this.get$Value(7);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCodeOrDefault = function() {
            return this.get$ValueOrDefault(7);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.setPreferredDomesticCarrierCode = function(t$7) {
            this.set$Value(7, t$7);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.hasPreferredDomesticCarrierCode = function() {
            return this.has$Value(7);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.preferredDomesticCarrierCodeCount = function() {
            return this.count$Values(7);
          }, i18n$1.phonenumbers.PhoneNumber.prototype.clearPreferredDomesticCarrierCode = function() {
            this.clear$Field(7);
          }, i18n$1.phonenumbers.PhoneNumber.CountryCodeSource = { UNSPECIFIED: 0, FROM_NUMBER_WITH_PLUS_SIGN: 1, FROM_NUMBER_WITH_IDD: 5, FROM_NUMBER_WITHOUT_PLUS_SIGN: 10, FROM_DEFAULT_COUNTRY: 20 }, i18n$1.phonenumbers.PhoneNumber.prototype.getDescriptor = function() {
            var t$7 = i18n$1.phonenumbers.PhoneNumber.descriptor_;
            return t$7 || (i18n$1.phonenumbers.PhoneNumber.descriptor_ = t$7 = goog.proto2.Message.createDescriptor(i18n$1.phonenumbers.PhoneNumber, { 0: { name: `PhoneNumber`, fullName: `i18n.phonenumbers.PhoneNumber` }, 1: { name: `country_code`, required: true, fieldType: goog.proto2.Message.FieldType.INT32, type: Number }, 2: { name: `national_number`, required: true, fieldType: goog.proto2.Message.FieldType.UINT64, type: Number }, 3: { name: `extension`, fieldType: goog.proto2.Message.FieldType.STRING, type: String }, 4: { name: `italian_leading_zero`, fieldType: goog.proto2.Message.FieldType.BOOL, type: Boolean }, 8: { name: `number_of_leading_zeros`, fieldType: goog.proto2.Message.FieldType.INT32, defaultValue: 1, type: Number }, 5: { name: `raw_input`, fieldType: goog.proto2.Message.FieldType.STRING, type: String }, 6: { name: `country_code_source`, fieldType: goog.proto2.Message.FieldType.ENUM, defaultValue: i18n$1.phonenumbers.PhoneNumber.CountryCodeSource.UNSPECIFIED, type: i18n$1.phonenumbers.PhoneNumber.CountryCodeSource }, 7: { name: `preferred_domestic_carrier_code`, fieldType: goog.proto2.Message.FieldType.STRING, type: String } })), t$7;
          }, i18n$1.phonenumbers.PhoneNumber.ctor = i18n$1.phonenumbers.PhoneNumber, i18n$1.phonenumbers.PhoneNumber.ctor.getDescriptor = i18n$1.phonenumbers.PhoneNumber.prototype.getDescriptor, i18n$1.phonenumbers.metadata = {}, i18n$1.phonenumbers.metadata.countryCodeToRegionCodeMap = { 1: `US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI`.split(` `), 7: [`RU`, `KZ`], 20: [`EG`], 27: [`ZA`], 30: [`GR`], 31: [`NL`], 32: [`BE`], 33: [`FR`], 34: [`ES`], 36: [`HU`], 39: [`IT`, `VA`], 40: [`RO`], 41: [`CH`], 43: [`AT`], 44: [`GB`, `GG`, `IM`, `JE`], 45: [`DK`], 46: [`SE`], 47: [`NO`, `SJ`], 48: [`PL`], 49: [`DE`], 51: [`PE`], 52: [`MX`], 53: [`CU`], 54: [`AR`], 55: [`BR`], 56: [`CL`], 57: [`CO`], 58: [`VE`], 60: [`MY`], 61: [`AU`, `CC`, `CX`], 62: [`ID`], 63: [`PH`], 64: [`NZ`], 65: [`SG`], 66: [`TH`], 81: [`JP`], 82: [`KR`], 84: [`VN`], 86: [`CN`], 90: [`TR`], 91: [`IN`], 92: [`PK`], 93: [`AF`], 94: [`LK`], 95: [`MM`], 98: [`IR`], 211: [`SS`], 212: [`MA`, `EH`], 213: [`DZ`], 216: [`TN`], 218: [`LY`], 220: [`GM`], 221: [`SN`], 222: [`MR`], 223: [`ML`], 224: [`GN`], 225: [`CI`], 226: [`BF`], 227: [`NE`], 228: [`TG`], 229: [`BJ`], 230: [`MU`], 231: [`LR`], 232: [`SL`], 233: [`GH`], 234: [`NG`], 235: [`TD`], 236: [`CF`], 237: [`CM`], 238: [`CV`], 239: [`ST`], 240: [`GQ`], 241: [`GA`], 242: [`CG`], 243: [`CD`], 244: [`AO`], 245: [`GW`], 246: [`IO`], 247: [`AC`], 248: [`SC`], 249: [`SD`], 250: [`RW`], 251: [`ET`], 252: [`SO`], 253: [`DJ`], 254: [`KE`], 255: [`TZ`], 256: [`UG`], 257: [`BI`], 258: [`MZ`], 260: [`ZM`], 261: [`MG`], 262: [`RE`, `YT`], 263: [`ZW`], 264: [`NA`], 265: [`MW`], 266: [`LS`], 267: [`BW`], 268: [`SZ`], 269: [`KM`], 290: [`SH`, `TA`], 291: [`ER`], 297: [`AW`], 298: [`FO`], 299: [`GL`], 350: [`GI`], 351: [`PT`], 352: [`LU`], 353: [`IE`], 354: [`IS`], 355: [`AL`], 356: [`MT`], 357: [`CY`], 358: [`FI`, `AX`], 359: [`BG`], 370: [`LT`], 371: [`LV`], 372: [`EE`], 373: [`MD`], 374: [`AM`], 375: [`BY`], 376: [`AD`], 377: [`MC`], 378: [`SM`], 380: [`UA`], 381: [`RS`], 382: [`ME`], 383: [`XK`], 385: [`HR`], 386: [`SI`], 387: [`BA`], 389: [`MK`], 420: [`CZ`], 421: [`SK`], 423: [`LI`], 500: [`FK`], 501: [`BZ`], 502: [`GT`], 503: [`SV`], 504: [`HN`], 505: [`NI`], 506: [`CR`], 507: [`PA`], 508: [`PM`], 509: [`HT`], 590: [`GP`, `BL`, `MF`], 591: [`BO`], 592: [`GY`], 593: [`EC`], 594: [`GF`], 595: [`PY`], 596: [`MQ`], 597: [`SR`], 598: [`UY`], 599: [`CW`, `BQ`], 670: [`TL`], 672: [`NF`], 673: [`BN`], 674: [`NR`], 675: [`PG`], 676: [`TO`], 677: [`SB`], 678: [`VU`], 679: [`FJ`], 680: [`PW`], 681: [`WF`], 682: [`CK`], 683: [`NU`], 685: [`WS`], 686: [`KI`], 687: [`NC`], 688: [`TV`], 689: [`PF`], 690: [`TK`], 691: [`FM`], 692: [`MH`], 800: [`001`], 808: [`001`], 850: [`KP`], 852: [`HK`], 853: [`MO`], 855: [`KH`], 856: [`LA`], 870: [`001`], 878: [`001`], 880: [`BD`], 881: [`001`], 882: [`001`], 883: [`001`], 886: [`TW`], 888: [`001`], 960: [`MV`], 961: [`LB`], 962: [`JO`], 963: [`SY`], 964: [`IQ`], 965: [`KW`], 966: [`SA`], 967: [`YE`], 968: [`OM`], 970: [`PS`], 971: [`AE`], 972: [`IL`], 973: [`BH`], 974: [`QA`], 975: [`BT`], 976: [`MN`], 977: [`NP`], 979: [`001`], 992: [`TJ`], 993: [`TM`], 994: [`AZ`], 995: [`GE`], 996: [`KG`], 998: [`UZ`] }, i18n$1.phonenumbers.metadata.countryToMetadata = { AC: [, [, , `(?:[01589]\\d|[46])\\d{4}`, , , , , , , [5, 6]], [, , `6[2-467]\\d{3}`, , , , `62889`, , , [5]], [, , `4\\d{4}`, , , , `40123`, , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `AC`, 247, `00`, , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `(?:0[1-9]|[1589]\\d)\\d{4}`, , , , `542011`, , , [6]], , , [, , , , , , , , , [-1]]], AD: [, [, , `(?:1|6\\d)\\d{7}|[135-9]\\d{5}`, , , , , , , [6, 8, 9]], [, , `[78]\\d{5}`, , , , `712345`, , , [6]], [, , `690\\d{6}|[356]\\d{5}`, , , , `312345`, , , [6, 9]], [, , `180[02]\\d{4}`, , , , `18001234`, , , [8]], [, , `[19]\\d{5}`, , , , `912345`, , , [6]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `AD`, 376, `00`, , , , , , , , [[, `(\\d{3})(\\d{3})`, `$1 $2`, [`[135-9]`]], [, `(\\d{4})(\\d{4})`, `$1 $2`, [`1`]], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`6`]]], , [, , , , , , , , , [-1]], , , [, , `1800\\d{4}`, , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AE: [, [, , `(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}`, , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]], [, , `[2-4679][2-8]\\d{6}`, , , , `22345678`, , , [8], [7]], [, , `5[024-68]\\d{7}`, , , , `501234567`, , , [9]], [, , `400\\d{6}|800\\d{2,9}`, , , , `800123456`], [, , `900[02]\\d{5}`, , , , `900234567`, , , [9]], [, , `700[05]\\d{5}`, , , , `700012345`, , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `AE`, 971, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{2,9})`, `$1 $2`, [`60|8`]], [, `(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[236]|[479][2-8]`], `0$1`], [, `(\\d{3})(\\d)(\\d{5})`, `$1 $2 $3`, [`[479]`]], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`5`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `600[25]\\d{5}`, , , , `600212345`, , , [9]], , , [, , , , , , , , , [-1]]], AF: [, [, , `[2-7]\\d{8}`, , , , , , , [9], [7]], [, , `(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}`, , , , `234567890`, , , , [7]], [, , `7\\d{8}`, , , , `701234567`, , , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `AF`, 93, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{4})`, `$1 $2`, [`[1-9]`]], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[2-7]`], `0$1`]], [[, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[2-7]`], `0$1`]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AG: [, [, , `(?:268|[58]\\d\\d|900)\\d{7}`, , , , , , , [10], [7]], [, , `268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}`, , , , `2684601234`, , , , [7]], [, , `268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}`, , , , `2684641234`, , , , [7]], [, , `8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`, , , , `8002123456`], [, , `900[2-9]\\d{6}`, , , , `9002123456`], [, , , , , , , , , [-1]], [, , `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}`, , , , `5002345678`], [, , `26848[01]\\d{4}`, , , , `2684801234`, , , , [7]], `AG`, 1, `011`, `1`, , , `([457]\\d{6})$|1`, `268$1`, , , , , [, , `26840[69]\\d{4}`, , , , `2684061234`, , , , [7]], , `268`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AI: [, [, , `(?:264|[58]\\d\\d|900)\\d{7}`, , , , , , , [10], [7]], [, , `264(?:292|4(?:6[12]|9[78]))\\d{4}`, , , , `2644612345`, , , , [7]], [, , `264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}`, , , , `2642351234`, , , , [7]], [, , `8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`, , , , `8002123456`], [, , `900[2-9]\\d{6}`, , , , `9002123456`], [, , , , , , , , , [-1]], [, , `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}`, , , , `5002345678`], [, , , , , , , , , [-1]], `AI`, 1, `011`, `1`, , , `([2457]\\d{6})$|1`, `264$1`, , , , , [, , `264724\\d{4}`, , , , `2647241234`, , , , [7]], , `264`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AL: [, [, , `(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}`, , , , , , , [6, 7, 8, 9], [5]], [, , `4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}`, , , , `22345678`, , , [8], [5, 6, 7]], [, , `6(?:[78][2-9]|9\\d)\\d{6}`, , , , `672123456`, , , [9]], [, , `800\\d{4}`, , , , `8001234`, , , [7]], [, , `900[1-9]\\d\\d`, , , , `900123`, , , [6]], [, , `808[1-9]\\d\\d`, , , , `808123`, , , [6]], [, , `700[2-9]\\d{4}`, , , , `70021234`, , , [8]], [, , , , , , , , , [-1]], `AL`, 355, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{3,4})`, `$1 $2`, [`80|9`], `0$1`], [, `(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3`, [`4[2-6]`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[2358][2-5]|4`], `0$1`], [, `(\\d{3})(\\d{5})`, `$1 $2`, [`[23578]`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`6`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AM: [, [, , `(?:[1-489]\\d|55|60|77)\\d{6}`, , , , , , , [8], [5, 6]], [, , `(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}`, , , , `10123456`, , , , [5, 6]], [, , `(?:33|4[1349]|55|77|88|9[13-9])\\d{6}`, , , , `77123456`], [, , `800\\d{5}`, , , , `80012345`], [, , `90[016]\\d{5}`, , , , `90012345`], [, , `80[1-4]\\d{5}`, , , , `80112345`], [, , , , , , , , , [-1]], [, , `60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}`, , , , `60271234`], `AM`, 374, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{2})(\\d{3})`, `$1 $2 $3`, [`[89]0`], `0 $1`], [, `(\\d{3})(\\d{5})`, `$1 $2`, [`2|3[12]`], `(0$1)`], [, `(\\d{2})(\\d{6})`, `$1 $2`, [`1|47`], `(0$1)`], [, `(\\d{2})(\\d{6})`, `$1 $2`, [`[3-9]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AO: [, [, , `[29]\\d{8}`, , , , , , , [9]], [, , `2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}`, , , , `222123456`], [, , `9[1-79]\\d{7}`, , , , `923123456`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `AO`, 244, `00`, , , , , , , , [[, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[29]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AR: [, [, , `(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}`, , , , , , , [10, 11], [6, 7, 8]], [, , `3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:21[2-6]|(?:3[06]|49)4|6(?:04|1[2-8])|9[17][4-6])|3(?:(?:36|64)4|4(?:1[2-8]|[25][4-6]|84)|5(?:1[2-9]|[38][4-6])|8(?:[17][2-6]|3[4-6]|8[3-68])))\\d{6}|(?:2(?:23|64|99)|3(?:43|85))[3-6]\\d{6}|(?:2(?:657|9(?:54|66))|3(?:487|7(?:55|77)|865))[2-8]\\d{5}|(?:2(?:[28]0|37|6[36]|9[48])|3(?:62|7[069]|80))[45]\\d{6}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:2(?:62|81)|320|622|9(?:42|83))|3(?:329|4(?:62|76|89)|564))[2-6]\\d{5}|(?:2(?:284|3(?:02|23)|477|920)|3(?:4(?:46|[89]2)|541|878))[2-7]\\d{5}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|35|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}`, , , , `1123456789`, , , [10], [6, 7, 8]], [, , `93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:21[2-6]|(?:3[06]|49)4|6(?:04|1[2-8])|9[17][4-6])|3(?:(?:36|64)4|4(?:1[2-8]|[25][4-6]|84)|5(?:1[2-9]|[38][4-6])|8(?:[17][2-6]|3[4-6]|8[3-68]))))\\d{6}|9(?:2(?:23|64|99)|3(?:43|85))[3-6]\\d{6}|9(?:2(?:657|9(?:54|66))|3(?:487|7(?:55|77)|865))[2-8]\\d{5}|9(?:2(?:[28]0|37|6[36]|9[48])|3(?:62|7[069]|80))[45]\\d{6}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:2(?:62|81)|320|622|9(?:42|83))|3(?:329|4(?:62|76|89)|564))[2-6]\\d{5}|9(?:2(?:284|3(?:02|23)|477|920)|3(?:4(?:46|[89]2)|541|878))[2-7]\\d{5}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|35|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}`, , , , `91123456789`, , , , [6, 7, 8]], [, , `800\\d{7,8}`, , , , `8001234567`], [, , `60[04579]\\d{7}`, , , , `6001234567`, , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `AR`, 54, `00`, `0`, , , `0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?`, `9$1`, , , [[, `(\\d{3})`, `$1`, [`0|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478])|911`]], [, `(\\d{2})(\\d{4})`, `$1-$2`, [`[1-9]`]], [, `(\\d{3})(\\d{4})`, `$1-$2`, [`[2-9]`]], [, `(\\d{4})(\\d{4})`, `$1-$2`, [`[1-8]`]], [, `(\\d{4})(\\d{2})(\\d{4})`, `$1 $2-$3`, [`2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])`, `2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)`, `2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]`, `2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]`], `0$1`, , 1], [, `(\\d{2})(\\d{4})(\\d{4})`, `$1 $2-$3`, [`1`], `0$1`, , 1], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1-$2-$3`, [`[68]`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2-$3`, [`[23]`], `0$1`, , 1], [, `(\\d)(\\d{4})(\\d{2})(\\d{4})`, `$2 15-$3-$4`, [`9(?:2[2-469]|3[3-578])`, `9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))`, `9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)`, `9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]`, `9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]`], `0$1`], [, `(\\d)(\\d{2})(\\d{4})(\\d{4})`, `$2 15-$3-$4`, [`91`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{5})`, `$1-$2-$3`, [`8`], `0$1`], [, `(\\d)(\\d{3})(\\d{3})(\\d{4})`, `$2 15-$3-$4`, [`9`], `0$1`]], [[, `(\\d{4})(\\d{2})(\\d{4})`, `$1 $2-$3`, [`2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])`, `2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)`, `2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]`, `2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]`], `0$1`, , 1], [, `(\\d{2})(\\d{4})(\\d{4})`, `$1 $2-$3`, [`1`], `0$1`, , 1], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1-$2-$3`, [`[68]`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2-$3`, [`[23]`], `0$1`, , 1], [, `(\\d)(\\d{4})(\\d{2})(\\d{4})`, `$1 $2 $3-$4`, [`9(?:2[2-469]|3[3-578])`, `9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))`, `9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)`, `9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]`, `9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]`]], [, `(\\d)(\\d{2})(\\d{4})(\\d{4})`, `$1 $2 $3-$4`, [`91`]], [, `(\\d{3})(\\d{3})(\\d{5})`, `$1-$2-$3`, [`8`], `0$1`], [, `(\\d)(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3-$4`, [`9`]]], [, , , , , , , , , [-1]], , , [, , `810\\d{7}`, , , , , , , [10]], [, , `810\\d{7}`, , , , `8101234567`, , , [10]], , , [, , , , , , , , , [-1]]], AS: [, [, , `(?:[58]\\d\\d|684|900)\\d{7}`, , , , , , , [10], [7]], [, , `6846(?:22|33|44|55|77|88|9[19])\\d{4}`, , , , `6846221234`, , , , [7]], [, , `684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}`, , , , `6847331234`, , , , [7]], [, , `8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`, , , , `8002123456`], [, , `900[2-9]\\d{6}`, , , , `9002123456`], [, , , , , , , , , [-1]], [, , `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}`, , , , `5002345678`], [, , , , , , , , , [-1]], `AS`, 1, `011`, `1`, , , `([267]\\d{6})$|1`, `684$1`, , , , , [, , , , , , , , , [-1]], , `684`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AT: [, [, , `1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}`, , , , , , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [3]], [, , `1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}`, , , , `1234567890`, , , , [3]], [, , `6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}`, , , , `664123456`, , , [7, 8, 9, 10, 11, 12, 13]], [, , `800\\d{6,10}`, , , , `800123456`, , , [9, 10, 11, 12, 13]], [, , `(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}`, , , , `900123456`, , , [9, 10, 11, 12, 13]], [, , `8(?:10|2[018])\\d{6,10}|828\\d{5}`, , , , `810123456`, , , [8, 9, 10, 11, 12, 13]], [, , , , , , , , , [-1]], [, , `5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}`, , , , `780123456`, , , [5, 6, 7, 8, 9, 10, 11, 12, 13]], `AT`, 43, `00`, `0`, , , `0`, , , , [[, `(\\d{4})`, `$1`, [`14`]], [, `(\\d)(\\d{3,12})`, `$1 $2`, [`1(?:11|[2-9])`], `0$1`], [, `(\\d{3})(\\d{2})`, `$1 $2`, [`517`], `0$1`], [, `(\\d{2})(\\d{3,5})`, `$1 $2`, [`5[079]`], `0$1`], [, `(\\d{6})`, `$1`, [`[18]`]], [, `(\\d{3})(\\d{3,10})`, `$1 $2`, [`(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]`], `0$1`], [, `(\\d{4})(\\d{3,9})`, `$1 $2`, [`[2-467]|5[2-6]`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`5`], `0$1`], [, `(\\d{2})(\\d{4})(\\d{4,7})`, `$1 $2 $3`, [`5`], `0$1`]], [[, `(\\d)(\\d{3,12})`, `$1 $2`, [`1(?:11|[2-9])`], `0$1`], [, `(\\d{3})(\\d{2})`, `$1 $2`, [`517`], `0$1`], [, `(\\d{2})(\\d{3,5})`, `$1 $2`, [`5[079]`], `0$1`], [, `(\\d{3})(\\d{3,10})`, `$1 $2`, [`(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]`], `0$1`], [, `(\\d{4})(\\d{3,9})`, `$1 $2`, [`[2-467]|5[2-6]`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`5`], `0$1`], [, `(\\d{2})(\\d{4})(\\d{4,7})`, `$1 $2 $3`, [`5`], `0$1`]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AU: [, [, , `1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}`, , , , , , , [5, 6, 7, 8, 9, 10, 12]], [, , `(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}`, , , , `212345678`, , , [9], [8]], [, , `4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}`, , , , `412345678`, , , [9]], [, , `180(?:0\\d{3}|2)\\d{3}`, , , , `1800123456`, , , [7, 10]], [, , `190[0-26]\\d{6}`, , , , `1900123456`, , , [10]], [, , `13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}`, , , , `1300123456`, , , [6, 8, 10, 12]], [, , , , , , , , , [-1]], [, , `14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}`, , , , `147101234`, , , [9]], `AU`, 61, `001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011`, `0`, , , `(183[12])|0`, , `0011`, , [[, `(\\d{2})(\\d{3,4})`, `$1 $2`, [`16`], `0$1`], [, `(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3`, [`13`]], [, `(\\d{3})(\\d{3})`, `$1 $2`, [`19`]], [, `(\\d{3})(\\d{4})`, `$1 $2`, [`180`, `1802`]], [, `(\\d{4})(\\d{3,4})`, `$1 $2`, [`19`]], [, `(\\d{2})(\\d{3})(\\d{2,4})`, `$1 $2 $3`, [`16`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`14|4`], `0$1`], [, `(\\d)(\\d{4})(\\d{4})`, `$1 $2 $3`, [`[2378]`], `(0$1)`, `$CC ($1)`], [, `(\\d{4})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`1(?:30|[89])`]], [, `(\\d{4})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`130`]]], [[, `(\\d{2})(\\d{3,4})`, `$1 $2`, [`16`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{2,4})`, `$1 $2 $3`, [`16`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`14|4`], `0$1`], [, `(\\d)(\\d{4})(\\d{4})`, `$1 $2 $3`, [`[2378]`], `(0$1)`, `$CC ($1)`], [, `(\\d{4})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`1(?:30|[89])`]]], [, , `163\\d{2,6}`, , , , `1631234`, , , [5, 6, 7, 8, 9]], 1, , [, , `1(?:3(?:00\\d{5}|45[0-4])|802)\\d{3}|1[38]00\\d{6}|13\\d{4}`, , , , , , , [6, 7, 8, 10, 12]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AW: [, [, , `(?:[25-79]\\d\\d|800)\\d{4}`, , , , , , , [7]], [, , `5(?:2\\d|8[1-9])\\d{4}`, , , , `5212345`], [, , `(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}`, , , , `5601234`], [, , `800\\d{4}`, , , , `8001234`], [, , `900\\d{4}`, , , , `9001234`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `(?:28\\d|501)\\d{4}`, , , , `5011234`], `AW`, 297, `00`, , , , , , , , [[, `(\\d{3})(\\d{4})`, `$1 $2`, [`[25-9]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AX: [, [, , `2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}`, , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]], [, , `18[1-8]\\d{3,6}`, , , , `181234567`, , , [6, 7, 8, 9]], [, , `4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}`, , , , `412345678`, , , [6, 7, 8, 9, 10]], [, , `800\\d{4,6}`, , , , `800123456`, , , [7, 8, 9]], [, , `[67]00\\d{5,6}`, , , , `600123456`, , , [8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `AX`, 358, `00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))`, `0`, , , `0`, , `00`, , , , [, , , , , , , , , [-1]], , `18`, [, , , , , , , , , [-1]], [, , `20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}`, , , , `10112345`], , , [, , , , , , , , , [-1]]], AZ: [, [, , `365\\d{6}|(?:[124579]\\d|60|88)\\d{7}`, , , , , , , [9], [7]], [, , `(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}`, , , , `123123456`, , , , [7]], [, , `36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}`, , , , `401234567`], [, , `88\\d{7}`, , , , `881234567`], [, , `900200\\d{3}`, , , , `900200123`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `AZ`, 994, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3`, [`[1-9]`]], [, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`90`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`1[28]|2|365|46`, `1[28]|2|365[45]|46`, `1[28]|2|365(?:4|5[02])|46`], `(0$1)`], [, `(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[13-9]`], `0$1`]], [[, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`90`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`1[28]|2|365|46`, `1[28]|2|365[45]|46`, `1[28]|2|365(?:4|5[02])|46`], `(0$1)`], [, `(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[13-9]`], `0$1`]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BA: [, [, , `6\\d{8}|(?:[35689]\\d|49|70)\\d{6}`, , , , , , , [8, 9], [6]], [, , `(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}`, , , , `30212345`, , , [8], [6]], [, , `6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}`, , , , `61123456`], [, , `8[08]\\d{6}`, , , , `80123456`, , , [8]], [, , `9[0246]\\d{6}`, , , , `90123456`, , , [8]], [, , `8[12]\\d{6}`, , , , `82123456`, , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `BA`, 387, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{3})`, `$1-$2`, [`[2-9]`]], [, `(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`6[1-3]|[7-9]`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3})`, `$1 $2-$3`, [`[3-5]|6[56]`], `0$1`], [, `(\\d{2})(\\d{2})(\\d{2})(\\d{3})`, `$1 $2 $3 $4`, [`6`], `0$1`]], [[, `(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`6[1-3]|[7-9]`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3})`, `$1 $2-$3`, [`[3-5]|6[56]`], `0$1`], [, `(\\d{2})(\\d{2})(\\d{2})(\\d{3})`, `$1 $2 $3 $4`, [`6`], `0$1`]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}`, , , , `70341234`, , , [8]], , , [, , , , , , , , , [-1]]], BB: [, [, , `(?:246|[58]\\d\\d|900)\\d{7}`, , , , , , , [10], [7]], [, , `246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}`, , , , `2464123456`, , , , [7]], [, , `246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}`, , , , `2462501234`, , , , [7]], [, , `8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`, , , , `8002123456`], [, , `(?:246976|900[2-9]\\d\\d)\\d{4}`, , , , `9002123456`, , , , [7]], [, , , , , , , , , [-1]], [, , `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}`, , , , `5002345678`], [, , `24631\\d{5}`, , , , `2463101234`, , , , [7]], `BB`, 1, `011`, `1`, , , `([2-9]\\d{6})$|1`, `246$1`, , , , , [, , , , , , , , , [-1]], , `246`, [, , , , , , , , , [-1]], [, , `246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}`, , , , `2464301234`, , , , [7]], , , [, , , , , , , , , [-1]]], BD: [, [, , `[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}`, , , , , , , [6, 7, 8, 9, 10]], [, , `(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:[23]\\d|[45])\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}`, , , , `27111234`], [, , `(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}`, , , , `1812345678`, , , [10]], [, , `80[03]\\d{7}`, , , , `8001234567`, , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}`, , , , `9604123456`, , , [10]], `BD`, 880, `00`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{4,6})`, `$1-$2`, [`31[5-8]|[459]1`], `0$1`], [, `(\\d{3})(\\d{3,7})`, `$1-$2`, [`3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]`], `0$1`], [, `(\\d{4})(\\d{3,6})`, `$1-$2`, [`[13-9]|2[23]`], `0$1`], [, `(\\d)(\\d{7,8})`, `$1-$2`, [`2`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BE: [, [, , `4\\d{8}|[1-9]\\d{7}`, , , , , , , [8, 9]], [, , `80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}`, , , , `12345678`, , , [8]], [, , `4[5-9]\\d{7}`, , , , `470123456`, , , [9]], [, , `800[1-9]\\d{4}`, , , , `80012345`, , , [8]], [, , `(?:70(?:2[0-57]|3[04-7]|44|6[4-69]|7[0579])|90\\d\\d)\\d{4}`, , , , `90012345`, , , [8]], [, , `7879\\d{4}`, , , , `78791234`, , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `BE`, 32, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{2})(\\d{3})`, `$1 $2 $3`, [`(?:80|9)0`], `0$1`], [, `(\\d)(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[239]|4[23]`], `0$1`], [, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[15-8]`], `0$1`], [, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`4`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `78(?:0[57]|1[014-8]|2[25]|3[15-8]|48|[56]0|7[06-8]|9\\d)\\d{4}`, , , , `78102345`, , , [8]], , , [, , , , , , , , , [-1]]], BF: [, [, , `[025-7]\\d{7}`, , , , , , , [8]], [, , `2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}`, , , , `20491234`], [, , `(?:0[1-7]|5[0-8]|[67]\\d)\\d{6}`, , , , `70123456`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `BF`, 226, `00`, , , , , , , , [[, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[025-7]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BG: [, [, , `00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}`, , , , , , , [6, 7, 8, 9, 12], [4, 5]], [, , `2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}`, , , , `2123456`, , , [6, 7, 8], [4, 5]], [, , `(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}`, , , , `43012345`, , , [8, 9]], [, , `(?:00800\\d\\d|800)\\d{5}`, , , , `80012345`, , , [8, 12]], [, , `90\\d{6}`, , , , `90123456`, , , [8]], [, , `700\\d{5}`, , , , `70012345`, , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `BG`, 359, `00`, `0`, , , `0`, , , , [[, `(\\d{6})`, `$1`, [`1`]], [, `(\\d)(\\d)(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`2`], `0$1`], [, `(\\d{3})(\\d{4})`, `$1 $2`, [`43[1-6]|70[1-9]`], `0$1`], [, `(\\d)(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`2`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{2,3})`, `$1 $2 $3`, [`[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]`], `0$1`], [, `(\\d{3})(\\d{2})(\\d{3})`, `$1 $2 $3`, [`(?:70|8)0`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{2})`, `$1 $2 $3`, [`43[1-7]|7`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[48]|9[08]`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`9`], `0$1`]], [[, `(\\d)(\\d)(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`2`], `0$1`], [, `(\\d{3})(\\d{4})`, `$1 $2`, [`43[1-6]|70[1-9]`], `0$1`], [, `(\\d)(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`2`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{2,3})`, `$1 $2 $3`, [`[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]`], `0$1`], [, `(\\d{3})(\\d{2})(\\d{3})`, `$1 $2 $3`, [`(?:70|8)0`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{2})`, `$1 $2 $3`, [`43[1-7]|7`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[48]|9[08]`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`9`], `0$1`]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BH: [, [, , `[136-9]\\d{7}`, , , , , , , [8]], [, , `(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|55|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}`, , , , `17001234`], [, , `(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}`, , , , `36001234`], [, , `8[02369]\\d{6}`, , , , `80123456`], [, , `(?:87|9[0-8])\\d{6}`, , , , `90123456`], [, , `84\\d{6}`, , , , `84123456`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `BH`, 973, `00`, , , , , , , , [[, `(\\d{4})(\\d{4})`, `$1 $2`, [`[13679]|8[02-4679]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BI: [, [, , `(?:[267]\\d|31)\\d{6}`, , , , , , , [8]], [, , `(?:22|31)\\d{6}`, , , , `22201234`], [, , `(?:29|[67][125-9])\\d{6}`, , , , `79561234`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `BI`, 257, `00`, , , , , , , , [[, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[2367]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BJ: [, [, , `(?:01\\d|[24-689])\\d{7}`, , , , , , , [8, 10]], [, , `2090\\d{4}|(?:012\\d\\d|2(?:02|1[037]|2[45]|3[68]|4\\d))\\d{5}`, , , , `0120211234`], [, , `(?:01(?:2[5-9]|[4-69]\\d)|4[0-8]|[56]\\d|9[013-9])\\d{6}`, , , , `0195123456`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `857[58]\\d{4}`, , , , `85751234`, , , [8]], `BJ`, 229, `00`, , , , , , , , [[, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[24-689]`]], [, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4 $5`, [`0`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `81\\d{6}`, , , , `81123456`, , , [8]], , , [, , , , , , , , , [-1]]], BL: [, [, , `(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}`, , , , , , , [9]], [, , `590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}`, , , , `590271234`], [, , `(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}`, , , , `690001234`], [, , `80[0-5]\\d{6}`, , , , `800012345`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}`, , , , `976012345`], `BL`, 590, `00`, `0`, , , `0`, , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BM: [, [, , `(?:441|[58]\\d\\d|900)\\d{7}`, , , , , , , [10], [7]], [, , `441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}`, , , , `4414123456`, , , , [7]], [, , `441(?:[2378]\\d|5[0-39]|9[02])\\d{5}`, , , , `4413701234`, , , , [7]], [, , `8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`, , , , `8002123456`], [, , `900[2-9]\\d{6}`, , , , `9002123456`], [, , , , , , , , , [-1]], [, , `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}`, , , , `5002345678`], [, , , , , , , , , [-1]], `BM`, 1, `011`, `1`, , , `([2-9]\\d{6})$|1`, `441$1`, , , , , [, , , , , , , , , [-1]], , `441`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BN: [, [, , `[2-578]\\d{6}`, , , , , , , [7]], [, , `22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}`, , , , `2345678`], [, , `(?:22[89]|[78]\\d\\d)\\d{4}`, , , , `7123456`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `5[34]\\d{5}`, , , , `5345678`], `BN`, 673, `00`, , , , , , , , [[, `(\\d{3})(\\d{4})`, `$1 $2`, [`[2-578]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BO: [, [, , `8001\\d{5}|(?:[2-467]\\d|50)\\d{6}`, , , , , , , [8, 9], [7]], [, , `(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}`, , , , `22123456`, , , [8], [7]], [, , `[67]\\d{7}`, , , , `71234567`, , , [8]], [, , `8001[07]\\d{4}`, , , , `800171234`, , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `50\\d{6}`, , , , `50123456`, , , [8], [7]], `BO`, 591, `00(?:1\\d)?`, `0`, , , `0(1\\d)?`, , , , [[, `(\\d)(\\d{7})`, `$1 $2`, [`[235]|4[46]`], , `0$CC $1`], [, `(\\d{8})`, `$1`, [`[67]`], , `0$CC $1`], [, `(\\d{3})(\\d{2})(\\d{4})`, `$1 $2 $3`, [`8`], , `0$CC $1`]], , [, , , , , , , , , [-1]], , , [, , `8001[07]\\d{4}`, , , , , , , [9]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BQ: [, [, , `(?:[34]1|7\\d)\\d{5}`, , , , , , , [7]], [, , `(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}`, , , , `7151234`], [, , `(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}`, , , , `3181234`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `BQ`, 599, `00`, , , , , , , , , , [, , , , , , , , , [-1]], , `[347]`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BR: [, [, , `(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}`, , , , , , , [8, 9, 10, 11]], [, , `(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}`, , , , `1123456789`, , , [10], [8]], [, , `(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}`, , , , `11961234567`, , , [10, 11], [8, 9]], [, , `800\\d{6,7}`, , , , `800123456`, , , [9, 10]], [, , `300\\d{6}|[59]00\\d{6,7}`, , , , `300123456`, , , [9, 10]], [, , `(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}`, , , , `40041234`, , , [8, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `BR`, 55, `00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)`, `0`, , , `(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?`, `$2`, , , [[, `(\\d{3,6})`, `$1`, [`1(?:1[25-8]|2[357-9]|3[02-68]|4[12568]|5|6[0-8]|8[015]|9[0-47-9])|321|610`]], [, `(\\d{4})(\\d{4})`, `$1-$2`, [`300|4(?:0[02]|37)`, `4(?:02|37)0|[34]00`]], [, `(\\d{4})(\\d{4})`, `$1-$2`, [`[2-57]`, `[2357]|4(?:[0-24-9]|3(?:[0-689]|7[1-9]))`]], [, `(\\d{3})(\\d{2,3})(\\d{4})`, `$1 $2 $3`, [`(?:[358]|90)0`], `0$1`], [, `(\\d{5})(\\d{4})`, `$1-$2`, [`9`]], [, `(\\d{2})(\\d{4})(\\d{4})`, `$1 $2-$3`, [`(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]`], `($1)`, `0 $CC ($1)`], [, `(\\d{2})(\\d{5})(\\d{4})`, `$1 $2-$3`, [`[16][1-9]|[2-57-9]`], `($1)`, `0 $CC ($1)`]], [[, `(\\d{4})(\\d{4})`, `$1-$2`, [`300|4(?:0[02]|37)`, `4(?:02|37)0|[34]00`]], [, `(\\d{3})(\\d{2,3})(\\d{4})`, `$1 $2 $3`, [`(?:[358]|90)0`], `0$1`], [, `(\\d{2})(\\d{4})(\\d{4})`, `$1 $2-$3`, [`(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]`], `($1)`, `0 $CC ($1)`], [, `(\\d{2})(\\d{5})(\\d{4})`, `$1 $2-$3`, [`[16][1-9]|[2-57-9]`], `($1)`, `0 $CC ($1)`]], [, , , , , , , , , [-1]], , , [, , `30(?:0\\d{5,7}|3\\d{7})|40(?:0\\d|20)\\d{4}|800\\d{6,7}`, , , , , , , [8, 9, 10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BS: [, [, , `(?:242|[58]\\d\\d|900)\\d{7}`, , , , , , , [10], [7]], [, , `242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}`, , , , `2423456789`, , , , [7]], [, , `242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|3[0-4]|[89]9))\\d{4}`, , , , `2423591234`, , , , [7]], [, , `242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`, , , , `8002123456`, , , , [7]], [, , `900[2-9]\\d{6}`, , , , `9002123456`], [, , , , , , , , , [-1]], [, , `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}`, , , , `5002345678`], [, , , , , , , , , [-1]], `BS`, 1, `011`, `1`, , , `([3-8]\\d{6})$|1`, `242$1`, , , , , [, , , , , , , , , [-1]], , `242`, [, , , , , , , , , [-1]], [, , `242225\\d{4}`, , , , `2422250123`], , , [, , , , , , , , , [-1]]], BT: [, [, , `[17]\\d{7}|[2-8]\\d{6}`, , , , , , , [7, 8], [6]], [, , `(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}`, , , , `2345678`, , , [7], [6]], [, , `(?:1[67]|77)\\d{6}`, , , , `17123456`, , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `BT`, 975, `00`, , , , , , , , [[, `(\\d{3})(\\d{3})`, `$1 $2`, [`[2-7]`]], [, `(\\d)(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[2-68]|7[246]`]], [, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`1[67]|7`]]], [[, `(\\d)(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[2-68]|7[246]`]], [, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`1[67]|7`]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BW: [, [, , `(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}`, , , , , , , [7, 8, 10]], [, , `(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[013467]))\\d{4}`, , , , `2401234`, , , [7]], [, , `(?:321|7[1-8]\\d)\\d{5}`, , , , `71123456`, , , [8]], [, , `(?:0800|800\\d)\\d{6}`, , , , `0800012345`, , , [10]], [, , `90\\d{5}`, , , , `9012345`, , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `79(?:1(?:[0-2]\\d|3[0-3])|2[0-7]\\d)\\d{3}`, , , , `79101234`, , , [8]], `BW`, 267, `00`, , , , , , , , [[, `(\\d{2})(\\d{5})`, `$1 $2`, [`90`]], [, `(\\d{3})(\\d{4})`, `$1 $2`, [`[24-6]|3[15-9]`]], [, `(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[37]`]], [, `(\\d{4})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`0`]], [, `(\\d{3})(\\d{4})(\\d{3})`, `$1 $2 $3`, [`8`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BY: [, [, , `(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}`, , , , , , , [6, 7, 8, 9, 10, 11], [5]], [, , `(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}`, , , , `152450911`, , , [9], [5, 6, 7]], [, , `(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}`, , , , `294911911`, , , [9]], [, , `800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}`, , , , `8011234567`], [, , `(?:810|902)\\d{7}`, , , , `9021234567`, , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `249\\d{6}`, , , , `249123456`, , , [9]], `BY`, 375, `810`, `8`, , , `0|80?`, , `8~10`, , [[, `(\\d{3})(\\d{3})`, `$1 $2`, [`800`], `8 $1`], [, `(\\d{3})(\\d{2})(\\d{2,4})`, `$1 $2 $3`, [`800`], `8 $1`], [, `(\\d{4})(\\d{2})(\\d{3})`, `$1 $2-$3`, [`1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])`, `1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])`], `8 0$1`], [, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2-$3-$4`, [`1(?:[56]|7[467])|2[1-3]`], `8 0$1`], [, `(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2-$3-$4`, [`[1-4]`], `8 0$1`], [, `(\\d{3})(\\d{3,4})(\\d{4})`, `$1 $2 $3`, [`[89]`], `8 $1`]], , [, , , , , , , , , [-1]], , , [, , `800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}`], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BZ: [, [, , `(?:0800\\d|[2-8])\\d{6}`, , , , , , , [7, 11]], [, , `(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}`, , , , `2221234`, , , [7]], [, , `6[0-35-7]\\d{5}`, , , , `6221234`, , , [7]], [, , `0800\\d{7}`, , , , `08001234123`, , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `BZ`, 501, `00`, , , , , , , , [[, `(\\d{3})(\\d{4})`, `$1-$2`, [`[2-8]`]], [, `(\\d)(\\d{3})(\\d{4})(\\d{3})`, `$1-$2-$3-$4`, [`0`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CA: [, [, , `[2-9]\\d{9}|3\\d{6}`, , , , , , , [7, 10]], [, , `(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}`, , , , `5062345678`, , , [10], [7]], [, , `(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}`, , , , `5062345678`, , , [10], [7]], [, , `8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`, , , , `8002123456`, , , [10]], [, , `900[2-9]\\d{6}`, , , , `9002123456`, , , [10]], [, , , , , , , , , [-1]], [, , `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}`, , , , `5002345678`, , , [10]], [, , `600[2-9]\\d{6}`, , , , `6002012345`, , , [10]], `CA`, 1, `011`, `1`, , , `1`, , , 1, , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `310\\d{4}`, , , , `3101234`, , , [7]], , , [, , , , , , , , , [-1]]], CC: [, [, , `1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}`, , , , , , , [6, 7, 8, 9, 10, 12]], [, , `8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}`, , , , `891621234`, , , [9], [8]], [, , `4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}`, , , , `412345678`, , , [9]], [, , `180(?:0\\d{3}|2)\\d{3}`, , , , `1800123456`, , , [7, 10]], [, , `190[0-26]\\d{6}`, , , , `1900123456`, , , [10]], [, , `13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}`, , , , `1300123456`, , , [6, 8, 10, 12]], [, , , , , , , , , [-1]], [, , `14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}`, , , , `147101234`, , , [9]], `CC`, 61, `001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011`, `0`, , , `([59]\\d{7})$|0`, `8$1`, `0011`, , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CD: [, [, , `(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}`, , , , , , , [7, 8, 9, 10]], [, , `(?:(?:12|573)\\d\\d|276)\\d{5}|[1-6]\\d{6}`, , , , `1234567`], [, , `88\\d{5}|(?:8[0-69]|9[017-9])\\d{7}`, , , , `991234567`, , , [7, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `CD`, 243, `00`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{2})(\\d{3})`, `$1 $2 $3`, [`88`], `0$1`], [, `(\\d{2})(\\d{5})`, `$1 $2`, [`[1-6]`], `0$1`], [, `(\\d{2})(\\d{2})(\\d{4})`, `$1 $2 $3`, [`2`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`1`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[89]`], `0$1`], [, `(\\d{2})(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3 $4`, [`5`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CF: [, [, , `(?:[27]\\d{3}|8776)\\d{4}`, , , , , , , [8]], [, , `2[12]\\d{6}`, , , , `21612345`], [, , `7[024-7]\\d{6}`, , , , `70012345`], [, , , , , , , , , [-1]], [, , `8776\\d{4}`, , , , `87761234`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `CF`, 236, `00`, , , , , , , , [[, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[278]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CG: [, [, , `222\\d{6}|(?:0\\d|80)\\d{7}`, , , , , , , [9]], [, , `222[1-589]\\d{5}`, , , , `222123456`], [, , `026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}`, , , , `061234567`], [, , , , , , , , , [-1]], [, , `80[0-2]\\d{6}`, , , , `800123456`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `CG`, 242, `00`, , , , , , , , [[, `(\\d)(\\d{4})(\\d{4})`, `$1 $2 $3`, [`8`]], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[02]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CH: [, [, , `8\\d{11}|[2-9]\\d{8}`, , , , , , , [9, 12]], [, , `(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}`, , , , `212345678`, , , [9]], [, , `(?:6[89]|7[235-9])\\d{7}`, , , , `781234567`, , , [9]], [, , `800\\d{6}`, , , , `800123456`, , , [9]], [, , `90[016]\\d{6}`, , , , `900123456`, , , [9]], [, , `84[0248]\\d{6}`, , , , `840123456`, , , [9]], [, , `878\\d{6}`, , , , `878123456`, , , [9]], [, , , , , , , , , [-1]], `CH`, 41, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`8[047]|90`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[2-79]|81`], `0$1`], [, `(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4 $5`, [`8`], `0$1`]], , [, , `74[0248]\\d{6}`, , , , `740123456`, , , [9]], , , [, , , , , , , , , [-1]], [, , `5[18]\\d{7}`, , , , `581234567`, , , [9]], , , [, , `860\\d{9}`, , , , `860123456789`, , , [12]]], CI: [, [, , `[02]\\d{9}`, , , , , , , [10]], [, , `2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}`, , , , `2123456789`], [, , `0[157]\\d{8}`, , , , `0123456789`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `CI`, 225, `00`, , , , , , , , [[, `(\\d{2})(\\d{2})(\\d)(\\d{5})`, `$1 $2 $3 $4`, [`2`]], [, `(\\d{2})(\\d{2})(\\d{2})(\\d{4})`, `$1 $2 $3 $4`, [`0`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CK: [, [, , `[2-578]\\d{4}`, , , , , , , [5]], [, , `(?:2\\d|3[13-7]|4[1-5])\\d{3}`, , , , `21234`], [, , `[578]\\d{4}`, , , , `71234`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `CK`, 682, `00`, , , , , , , , [[, `(\\d{2})(\\d{3})`, `$1 $2`, [`[2-578]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CL: [, [, , `12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}`, , , , , , , [9, 10, 11]], [, , `2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}`, , , , `221234567`, , , [9]], [, , `2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}`, , , , `221234567`, , , [9]], [, , `(?:123|8)00\\d{6}`, , , , `800123456`, , , [9, 11]], [, , , , , , , , , [-1]], [, , `600\\d{7,8}`, , , , `6001234567`, , , [10, 11]], [, , , , , , , , , [-1]], [, , `44\\d{7}`, , , , `441234567`, , , [9]], `CL`, 56, `(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0`, , , , , , , 1, [[, `(\\d{4})`, `$1`, [`1(?:[03-589]|21)|[29]0|78`]], [, `(\\d{5})(\\d{4})`, `$1 $2`, [`219`, `2196`], `($1)`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`44`]], [, `(\\d)(\\d{4})(\\d{4})`, `$1 $2 $3`, [`2[1-36]`], `($1)`], [, `(\\d)(\\d{4})(\\d{4})`, `$1 $2 $3`, [`9[2-9]`]], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])`], `($1)`], [, `(\\d{3})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`60|8`]], [, `(\\d{4})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`1`]], [, `(\\d{3})(\\d{3})(\\d{2})(\\d{3})`, `$1 $2 $3 $4`, [`60`]]], [[, `(\\d{5})(\\d{4})`, `$1 $2`, [`219`, `2196`], `($1)`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`44`]], [, `(\\d)(\\d{4})(\\d{4})`, `$1 $2 $3`, [`2[1-36]`], `($1)`], [, `(\\d)(\\d{4})(\\d{4})`, `$1 $2 $3`, [`9[2-9]`]], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])`], `($1)`], [, `(\\d{3})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`60|8`]], [, `(\\d{4})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`1`]], [, `(\\d{3})(\\d{3})(\\d{2})(\\d{3})`, `$1 $2 $3 $4`, [`60`]]], [, , , , , , , , , [-1]], , , [, , `600\\d{7,8}`, , , , , , , [10, 11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CM: [, [, , `[26]\\d{8}|88\\d{6,7}`, , , , , , , [8, 9]], [, , `2(?:22|33)\\d{6}`, , , , `222123456`, , , [9]], [, , `(?:24[23]|6(?:[25-9]\\d|40))\\d{6}`, , , , `671234567`, , , [9]], [, , `88\\d{6,7}`, , , , `88012345`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `CM`, 237, `00`, , , , , , , , [[, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`88`]], [, `(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4 $5`, [`[26]|88`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CN: [, [, , `(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}`, , , , , , , [7, 8, 9, 10, 11, 12], [5, 6]], [, , `(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|2(?:[02-57-9]\\d{3}|1(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))|(?:41[03]|8078|9(?:78|94))\\d\\d)\\d{5}|(?:10|2[0-57-9])(?:1(?:00|23)\\d\\d|95\\d{3,4})|(?:41[03]|9(?:78|94))(?:100\\d\\d|95\\d{3,4})|8078123|(?:43[35]|754|851)\\d{7,8}|(?:43[35]|754|851)(?:1(?:00\\d|23)\\d|95\\d{3,4})|(?:3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[13-9]\\d{6}|2(?:[0-24-9]\\d{5}|3\\d(?:\\d{4})?))|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[24-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[13-9]\\d{5}|2(?:[0-24-9]\\d{4}|3\\d(?:\\d{3})?))|9(?:[0-46-9]\\d{5}|5\\d{3,5}))`, , , , `1012345678`, , , [7, 8, 9, 10, 11], [5, 6]], [, , `1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}`, , , , `13123456789`, , , [11]], [, , `(?:(?:10|21)8|8)00\\d{7}`, , , , `8001234567`, , , [10, 12]], [, , `16[08]\\d{5}`, , , , `16812345`, , , [8]], [, , `10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}`, , , , `4001234567`, , , [7, 8, 9, 10, 11], [5, 6]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `CN`, 86, `00|1(?:[12]\\d|79)\\d\\d00`, `0`, , , `(1(?:[12]\\d|79)\\d\\d)|0`, , `00`, , [[, `(\\d{5,6})`, `$1`, [`1(?:00|2[13])|9[56]`, `1(?:00|2(?:1|39))|9[56]`, `1(?:00|2(?:1|395))|9[56]`]], [, `(\\d{5,6})`, `$1`, [`1(?:0|23)|781|[1-9]12`, `1(?:0|23)|7812|[1-9]123`, `1(?:0|23(?:[0-8]|9[0-46-9]))|78123|[1-9]123`]], [, `(\\d{2})(\\d{5,6})`, `$1 $2`, [`(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]`, `(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1`, `10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12`, `10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123`, `10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123`], `0$1`, `$CC $1`], [, `(\\d{3})(\\d{4})`, `$1 $2`, [`[1-9]`, `1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])`, `1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|[3-9]`, `1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|1[03]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9]|78|94)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-9]|1(?:[013-9]|2[0-24-9]))`, `1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|1[03]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:0(?:[0-689]|7[0-79])|1[01459]|2[0-489]|[46]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9]|78|94)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-9]|1(?:[013-9]|2[0-24-9]))`]], [, `(\\d{4})(\\d{4})`, `$1 $2`, [`16[08]`]], [, `(\\d{3})(\\d{5,6})`, `$1 $2`, [`3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]`, `(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]`, `85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])`, `85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])`], `0$1`, `$CC $1`], [, `(\\d{4})(\\d{4})`, `$1 $2`, [`[1-9]`, `1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[0-8]|9[0-47-9])|6)|[3-9]`, `1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|26|3(?:[0268]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23][0-8])|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:33|85[23]9)[0-46-9]|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[0-8]|9[0-47-9])`, `1(?:0[02-8]|[1-9])|2(?:[0-57-9][0-8]|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23](?:[02-8]|1[1-9]|9[0-46-9]))|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:10|2[0-57-9])9[0-47-9]|(?:101|58|85[23]10)[1-9]|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])`]], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`(?:4|80)0`]], [, `(\\d{2})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`10|2(?:[02-57-9]|1[1-9])`, `10|2(?:[02-57-9]|1[1-9])`, `10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])`], `0$1`, `$CC $1`, 1], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]`], `0$1`, `$CC $1`, 1], [, `(\\d{3})(\\d{7,8})`, `$1 $2`, [`9`]], [, `(\\d{4})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`80`], `0$1`, `$CC $1`, 1], [, `(\\d{3})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`[3-578]`], `0$1`, `$CC $1`, 1], [, `(\\d{3})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`1[3-9]`], , `$CC $1`], [, `(\\d{2})(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3 $4`, [`[12]`], `0$1`, , 1]], [[, `(\\d{2})(\\d{5,6})`, `$1 $2`, [`(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]`, `(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1`, `10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12`, `10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123`, `10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123`], `0$1`, `$CC $1`], [, `(\\d{3})(\\d{5,6})`, `$1 $2`, [`3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]`, `(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]`, `85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])`, `85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])`], `0$1`, `$CC $1`], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`(?:4|80)0`]], [, `(\\d{2})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`10|2(?:[02-57-9]|1[1-9])`, `10|2(?:[02-57-9]|1[1-9])`, `10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])`], `0$1`, `$CC $1`, 1], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]`], `0$1`, `$CC $1`, 1], [, `(\\d{3})(\\d{7,8})`, `$1 $2`, [`9`]], [, `(\\d{4})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`80`], `0$1`, `$CC $1`, 1], [, `(\\d{3})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`[3-578]`], `0$1`, `$CC $1`, 1], [, `(\\d{3})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`1[3-9]`], , `$CC $1`], [, `(\\d{2})(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3 $4`, [`[12]`], `0$1`, , 1]], [, , , , , , , , , [-1]], , , [, , `(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}`, , , , , , , [10, 11, 12]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CO: [, [, , `(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}`, , , , , , , [8, 10, 11], [4, 7]], [, , `601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|(?:46|60(?:[124-7][2-9]|8[1-9]))\\d{6}`, , , , `6012345678`, , , [8, 10], [4, 7]], [, , `333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}`, , , , `3211234567`, , , [10]], [, , `1800\\d{7}`, , , , `18001234567`, , , [11]], [, , `(?:19(?:0[01]|4[78])|901)\\d{7}`, , , , `19001234567`, , , [10, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `CO`, 57, `00(?:4(?:[14]4|56)|[579])`, `0`, , , `0([3579]|4(?:[14]4|56))?`, , , , [[, `(\\d{4})(\\d{4})`, `$1 $2`, [`46`]], [, `(\\d{3})(\\d{7})`, `$1 $2`, [`6|90`], `($1)`, `0$CC $1`], [, `(\\d{3})(\\d{7})`, `$1 $2`, [`3[0-357]|91`], , `0$CC $1`], [, `(\\d)(\\d{3})(\\d{7})`, `$1-$2-$3`, [`1`], `0$1`]], [[, `(\\d{4})(\\d{4})`, `$1 $2`, [`46`]], [, `(\\d{3})(\\d{7})`, `$1 $2`, [`6|90`], `($1)`, `0$CC $1`], [, `(\\d{3})(\\d{7})`, `$1 $2`, [`3[0-357]|91`], , `0$CC $1`], [, `(\\d)(\\d{3})(\\d{7})`, `$1 $2 $3`, [`1`]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CR: [, [, , `(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}`, , , , , , , [8, 10]], [, , `210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}`, , , , `22123456`, , , [8]], [, , `(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}`, , , , `83123456`, , , [8]], [, , `800\\d{7}`, , , , `8001234567`, , , [10]], [, , `90[059]\\d{7}`, , , , `9001234567`, , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `(?:210[0-6]|4\\d{3}|5100)\\d{4}`, , , , `40001234`, , , [8]], `CR`, 506, `00`, , , , `(19(?:0[0-2468]|1[09]|20|66|77|99))`, , , , [[, `(\\d{4})(\\d{4})`, `$1 $2`, [`[2-7]|8[3-9]`], , `$CC $1`], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1-$2-$3`, [`[89]`], , `$CC $1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CU: [, [, , `(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}`, , , , , , , [6, 7, 8, 10], [4, 5]], [, , `(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}`, , , , `71234567`, , , , [4, 5]], [, , `(?:5\\d|6[2-4])\\d{6}`, , , , `51234567`, , , [8]], [, , `800\\d{7}`, , , , `8001234567`, , , [10]], [, , , , , , , , , [-1]], [, , `807\\d{7}`, , , , `8071234567`, , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `CU`, 53, `119`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{4,6})`, `$1 $2`, [`2[1-4]|[34]`], `(0$1)`], [, `(\\d)(\\d{6,7})`, `$1 $2`, [`7`], `(0$1)`], [, `(\\d)(\\d{7})`, `$1 $2`, [`[56]`], `0$1`], [, `(\\d{3})(\\d{7})`, `$1 $2`, [`8`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CV: [, [, , `(?:[2-59]\\d\\d|800)\\d{4}`, , , , , , , [7]], [, , `2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}`, , , , `2211234`], [, , `(?:36|5[1-389]|9\\d)\\d{5}`, , , , `9911234`], [, , `800\\d{4}`, , , , `8001234`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `(?:3[3-5]|4[356])\\d{5}`, , , , `3401234`], `CV`, 238, `0`, , , , , , , , [[, `(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3`, [`[2-589]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CW: [, [, , `(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}`, , , , , , , [7, 8]], [, , `9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}`, , , , `94351234`], [, , `953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}`, , , , `95181234`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `60[0-2]\\d{4}`, , , , `6001234`, , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `CW`, 599, `00`, , , , , , , , [[, `(\\d{3})(\\d{4})`, `$1 $2`, [`[3467]`]], [, `(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3`, [`9[4-8]`]]], , [, , `955\\d{5}`, , , , `95581234`, , , [8]], 1, `[69]`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CX: [, [, , `1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}`, , , , , , , [6, 7, 8, 9, 10, 12]], [, , `8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}`, , , , `891641234`, , , [9], [8]], [, , `4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}`, , , , `412345678`, , , [9]], [, , `180(?:0\\d{3}|2)\\d{3}`, , , , `1800123456`, , , [7, 10]], [, , `190[0-26]\\d{6}`, , , , `1900123456`, , , [10]], [, , `13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}`, , , , `1300123456`, , , [6, 8, 10, 12]], [, , , , , , , , , [-1]], [, , `14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}`, , , , `147101234`, , , [9]], `CX`, 61, `001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011`, `0`, , , `([59]\\d{7})$|0`, `8$1`, `0011`, , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CY: [, [, , `(?:[279]\\d|[58]0)\\d{6}`, , , , , , , [8]], [, , `2[2-6]\\d{6}`, , , , `22345678`], [, , `9(?:10|[4-79]\\d)\\d{5}`, , , , `96123456`], [, , `800\\d{5}`, , , , `80001234`], [, , `90[09]\\d{5}`, , , , `90012345`], [, , `80[1-9]\\d{5}`, , , , `80112345`], [, , `700\\d{5}`, , , , `70012345`], [, , , , , , , , , [-1]], `CY`, 357, `00`, , , , , , , , [[, `(\\d{2})(\\d{6})`, `$1 $2`, [`[257-9]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `(?:50|77)\\d{6}`, , , , `77123456`], , , [, , , , , , , , , [-1]]], CZ: [, [, , `(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}`, , , , , , , [9, 10, 11, 12]], [, , `(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}`, , , , `212345678`, , , [9]], [, , `(?:60[1-8]\\d|7(?:0(?:[2-5]\\d|60)|19[01]|[2379]\\d\\d))\\d{5}`, , , , `601123456`, , , [9]], [, , `800\\d{6}`, , , , `800123456`, , , [9]], [, , `9(?:0[05689]|76)\\d{6}`, , , , `900123456`, , , [9]], [, , `8[134]\\d{7}`, , , , `811234567`, , , [9]], [, , `70[01]\\d{6}`, , , , `700123456`, , , [9]], [, , `9[17]0\\d{6}`, , , , `910123456`, , , [9]], `CZ`, 420, `00`, , , , , , , , [[, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[2-8]|9[015-7]`]], [, `(\\d{2})(\\d{3})(\\d{3})(\\d{2})`, `$1 $2 $3 $4`, [`96`]], [, `(\\d{2})(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3 $4`, [`9`]], [, `(\\d{3})(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3 $4`, [`9`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `9(?:5\\d|7[2-4])\\d{6}`, , , , `972123456`, , , [9]], , , [, , `9(?:3\\d{9}|6\\d{7,10})`, , , , `93123456789`]], DE: [, [, , `[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}`, , , , , , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [2, 3]], [, , `32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}`, , , , `30123456`, , , [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [2, 3, 4]], [, , `16[023]\\d{7,8}|1(?:5310|7[0-57-9]\\d)\\d{6}|1(?:5[0-25-9]|76)\\d{8}`, , , , `15123456789`, , , [10, 11]], [, , `800\\d{7,12}`, , , , `8001234567890`, , , [10, 11, 12, 13, 14, 15]], [, , `(?:137[7-9]|900(?:[135]|9\\d))\\d{6}`, , , , `9001234567`, , , [10, 11]], [, , `180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}`, , , , `18012345`, , , [7, 8, 9, 10, 11, 12, 13, 14]], [, , `700\\d{8}`, , , , `70012345678`, , , [11]], [, , , , , , , , , [-1]], `DE`, 49, `00`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{3,13})`, `$1 $2`, [`3[02]|40|[68]9`], `0$1`], [, `(\\d{3})(\\d{3,12})`, `$1 $2`, [`2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1`, `2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1`], `0$1`], [, `(\\d{4})(\\d{2,11})`, `$1 $2`, [`[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]`, `[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]`], `0$1`], [, `(\\d{3})(\\d{4})`, `$1 $2`, [`138`], `0$1`], [, `(\\d{5})(\\d{2,10})`, `$1 $2`, [`3`], `0$1`], [, `(\\d{3})(\\d{5,11})`, `$1 $2`, [`181`], `0$1`], [, `(\\d{3})(\\d)(\\d{4,10})`, `$1 $2 $3`, [`1(?:3|80)|9`], `0$1`], [, `(\\d{3})(\\d{7,8})`, `$1 $2`, [`1[67]`], `0$1`], [, `(\\d{3})(\\d{7,12})`, `$1 $2`, [`8`], `0$1`], [, `(\\d{5})(\\d{6})`, `$1 $2`, [`185`, `1850`, `18500`], `0$1`], [, `(\\d{3})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`7`], `0$1`], [, `(\\d{4})(\\d{7})`, `$1 $2`, [`18[68]`], `0$1`], [, `(\\d{4})(\\d{7})`, `$1 $2`, [`15[1279]`], `0$1`], [, `(\\d{5})(\\d{6})`, `$1 $2`, [`15[03568]`, `15(?:[0568]|31)`], `0$1`], [, `(\\d{3})(\\d{8})`, `$1 $2`, [`18`], `0$1`], [, `(\\d{3})(\\d{2})(\\d{7,8})`, `$1 $2 $3`, [`1(?:6[023]|7)`], `0$1`], [, `(\\d{4})(\\d{2})(\\d{7})`, `$1 $2 $3`, [`15[279]`], `0$1`], [, `(\\d{3})(\\d{2})(\\d{8})`, `$1 $2 $3`, [`15`], `0$1`]], , [, , `16(?:4\\d{1,10}|[89]\\d{1,11})`, , , , `16412345`, , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]], [, , `18(?:1\\d{5,11}|[2-9]\\d{8})`, , , , `18500123456`, , , [8, 9, 10, 11, 12, 13, 14]], , , [, , `1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}`, , , , `177991234567`, , , [12, 13]]], DJ: [, [, , `(?:2\\d|77)\\d{6}`, , , , , , , [8]], [, , `2(?:1[2-5]|7[45])\\d{5}`, , , , `21360003`], [, , `77\\d{6}`, , , , `77831001`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `DJ`, 253, `00`, , , , , , , , [[, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[27]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], DK: [, [, , `[2-9]\\d{7}`, , , , , , , [8]], [, , `(?:(?:2\\d|9[1-46-9])\\d|3(?:[0-37]\\d|4[013]|5[0-58]|6[01347-9]|8[0-8]|9[0-79])|4(?:[0-25]\\d|[34][02-9]|6[013-579]|7[013579]|8[0-47]|9[0-27])|5(?:[0-36]\\d|4[0146-9]|5[03-57-9]|7[0568]|8[0-358]|9[0-69])|6(?:[013578]\\d|2[0-68]|4[02-8]|6[01689]|9[015689])|7(?:[0-69]\\d|7[03-9]|8[0147])|8(?:[16-9]\\d|2[0-58]))\\d{5}`, , , , `32123456`], [, , `(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}`, , , , `34412345`], [, , `80\\d{6}`, , , , `80123456`], [, , `90\\d{6}`, , , , `90123456`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `DK`, 45, `00`, , , , , , , , [[, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[2-9]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], DM: [, [, , `(?:[58]\\d\\d|767|900)\\d{7}`, , , , , , , [10], [7]], [, , `767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}`, , , , `7674201234`, , , , [7]], [, , `767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}`, , , , `7672251234`, , , , [7]], [, , `8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`, , , , `8002123456`], [, , `900[2-9]\\d{6}`, , , , `9002123456`], [, , , , , , , , , [-1]], [, , `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}`, , , , `5002345678`], [, , , , , , , , , [-1]], `DM`, 1, `011`, `1`, , , `([2-7]\\d{6})$|1`, `767$1`, , , , , [, , , , , , , , , [-1]], , `767`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], DO: [, [, , `(?:[58]\\d\\d|900)\\d{7}`, , , , , , , [10], [7]], [, , `8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}`, , , , `8092345678`, , , , [7]], [, , `8[024]9[2-9]\\d{6}`, , , , `8092345678`, , , , [7]], [, , `8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}`, , , , `8002123456`], [, , `900[2-9]\\d{6}`, , , , `9002123456`], [, , , , , , , , , [-1]], [, , `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}`, , , , `5002345678`], [, , , , , , , , , [-1]], `DO`, 1, `011`, `1`, , , `1`, , , , , , [, , , , , , , , , [-1]], , `8001|8[024]9`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], DZ: [, [, , `(?:[1-4]|[5-79]\\d|80)\\d{7}`, , , , , , , [8, 9]], [, , `9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}`, , , , `12345678`], [, , `(?:5(?:4[0-29]|5\\d|6[0-3])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}`, , , , `551234567`, , , [9]], [, , `800\\d{6}`, , , , `800123456`, , , [9]], [, , `80[3-689]1\\d{5}`, , , , `808123456`, , , [9]], [, , `80[12]1\\d{5}`, , , , `801123456`, , , [9]], [, , , , , , , , , [-1]], [, , `98[23]\\d{6}`, , , , `983123456`, , , [9]], `DZ`, 213, `00`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[1-4]`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`9`], `0$1`], [, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[5-8]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], EC: [, [, , `1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}`, , , , , , , [8, 9, 10, 11], [7]], [, , `[2-7][2-7]\\d{6}`, , , , `22123456`, , , [8], [7]], [, , `964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}`, , , , `991234567`, , , [9]], [, , `1800\\d{7}|1[78]00\\d{6}`, , , , `18001234567`, , , [10, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `[2-7]890\\d{4}`, , , , `28901234`, , , [8]], `EC`, 593, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{4})`, `$1-$2`, [`[2-7]`]], [, `(\\d)(\\d{3})(\\d{4})`, `$1 $2-$3`, [`[2-7]`], `(0$1)`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`9`], `0$1`], [, `(\\d{4})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`1`]]], [[, `(\\d)(\\d{3})(\\d{4})`, `$1-$2-$3`, [`[2-7]`]], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`9`], `0$1`], [, `(\\d{4})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`1`]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], EE: [, [, , `8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}`, , , , , , , [7, 8, 10]], [, , `(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}`, , , , `3212345`, , , [7]], [, , `(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[2-6]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-69]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}`, , , , `51234567`, , , [7, 8]], [, , `800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}`, , , , `80012345`], [, , `(?:40\\d\\d|900)\\d{4}`, , , , `9001234`, , , [7, 8]], [, , , , , , , , , [-1]], [, , `70[0-2]\\d{5}`, , , , `70012345`, , , [8]], [, , , , , , , , , [-1]], `EE`, 372, `00`, , , , , , , , [[, `(\\d{3})(\\d{4})`, `$1 $2`, [`[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88`, `[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88`]], [, `(\\d{4})(\\d{3,4})`, `$1 $2`, [`[45]|8(?:00|[1-49])`, `[45]|8(?:00[1-9]|[1-49])`]], [, `(\\d{2})(\\d{2})(\\d{4})`, `$1 $2 $3`, [`7`]], [, `(\\d{4})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`8`]]], , [, , , , , , , , , [-1]], , , [, , `800[2-9]\\d{3}`, , , , , , , [7]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], EG: [, [, , `[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}`, , , , , , , [8, 9, 10], [6, 7]], [, , `13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2\\d|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}`, , , , `234567890`, , , [8, 9], [6, 7]], [, , `1[0-25]\\d{8}`, , , , `1001234567`, , , [10]], [, , `800\\d{7}`, , , , `8001234567`, , , [10]], [, , `900\\d{7}`, , , , `9001234567`, , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `EG`, 20, `00`, `0`, , , `0`, , , , [[, `(\\d)(\\d{7,8})`, `$1 $2`, [`[23]`], `0$1`], [, `(\\d{2})(\\d{6,7})`, `$1 $2`, [`1[35]|[4-6]|8[2468]|9[235-7]`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[89]`], `0$1`], [, `(\\d{2})(\\d{8})`, `$1 $2`, [`1`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], EH: [, [, , `[5-8]\\d{8}`, , , , , , , [9]], [, , `528[89]\\d{5}`, , , , `528812345`], [, , `(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}`, , , , `650123456`], [, , `80[0-7]\\d{6}`, , , , `801234567`], [, , `89\\d{7}`, , , , `891234567`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}`, , , , `592401234`], `EH`, 212, `00`, `0`, , , `0`, , , , , , [, , , , , , , , , [-1]], , `528[89]`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ER: [, [, , `[178]\\d{6}`, , , , , , , [7], [6]], [, , `(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}`, , , , `8370362`, , , , [6]], [, , `(?:17[1-3]|7\\d\\d)\\d{4}`, , , , `7123456`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `ER`, 291, `00`, `0`, , , `0`, , , , [[, `(\\d)(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[178]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ES: [, [, , `[5-9]\\d{8}`, , , , , , , [9]], [, , `96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}`, , , , `810123456`], [, , `(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}`, , , , `612345678`], [, , `[89]00\\d{6}`, , , , `800123456`], [, , `80[367]\\d{6}`, , , , `803123456`], [, , `90[12]\\d{6}`, , , , `901123456`], [, , `70\\d{7}`, , , , `701234567`], [, , , , , , , , , [-1]], `ES`, 34, `00`, , , , , , , , [[, `(\\d{4})`, `$1`, [`905`]], [, `(\\d{6})`, `$1`, [`[79]9`]], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[89]00`]], [, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[5-9]`]]], [[, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[89]00`]], [, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[5-9]`]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `51\\d{7}`, , , , `511234567`], , , [, , , , , , , , , [-1]]], ET: [, [, , `(?:11|[2-579]\\d)\\d{7}`, , , , , , , [9], [7]], [, , `11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8]|7\\d)|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}`, , , , `111112345`, , , , [7]], [, , `700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}`, , , , `911234567`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `ET`, 251, `00`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[1-579]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], FI: [, [, , `[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}`, , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]], [, , `1[3-7][1-8]\\d{3,6}|(?:19[1-8]|[23568][1-8]\\d|9(?:00|[1-8]\\d))\\d{2,6}`, , , , `131234567`, , , [5, 6, 7, 8, 9]], [, , `4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}`, , , , `412345678`, , , [6, 7, 8, 9, 10]], [, , `800\\d{4,6}`, , , , `800123456`, , , [7, 8, 9]], [, , `[67]00\\d{5,6}`, , , , `600123456`, , , [8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `FI`, 358, `00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))`, `0`, , , `0`, , `00`, , [[, `(\\d{5})`, `$1`, [`75[12]`], `0$1`], [, `(\\d{5})`, `$1`, [`20[2-59]`], `0$1`], [, `(\\d{6})`, `$1`, [`11`]], [, `(\\d{3})(\\d{3,7})`, `$1 $2`, [`(?:[1-3]0|[68])0|70[07-9]`], `0$1`], [, `(\\d{2})(\\d{4,8})`, `$1 $2`, [`[14]|2[09]|50|7[135]`], `0$1`], [, `(\\d{2})(\\d{6,10})`, `$1 $2`, [`7`], `0$1`], [, `(\\d)(\\d{4,9})`, `$1 $2`, [`(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9`], `0$1`]], [[, `(\\d{5})`, `$1`, [`20[2-59]`], `0$1`], [, `(\\d{3})(\\d{3,7})`, `$1 $2`, [`(?:[1-3]0|[68])0|70[07-9]`], `0$1`], [, `(\\d{2})(\\d{4,8})`, `$1 $2`, [`[14]|2[09]|50|7[135]`], `0$1`], [, `(\\d{2})(\\d{6,10})`, `$1 $2`, [`7`], `0$1`], [, `(\\d)(\\d{4,9})`, `$1 $2`, [`(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9`], `0$1`]], [, , , , , , , , , [-1]], 1, `1[03-79]|[2-9]`, [, , `20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}`], [, , `20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}`, , , , `10112345`], , , [, , , , , , , , , [-1]]], FJ: [, [, , `45\\d{5}|(?:0800\\d|[235-9])\\d{6}`, , , , , , , [7, 11]], [, , `603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}`, , , , `3212345`, , , [7]], [, , `(?:[279]\\d|45|5[01568]|8[034679])\\d{5}`, , , , `7012345`, , , [7]], [, , `0800\\d{7}`, , , , `08001234567`, , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `FJ`, 679, `0(?:0|52)`, , , , , , `00`, , [[, `(\\d{3})(\\d{4})`, `$1 $2`, [`[235-9]|45`]], [, `(\\d{4})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`0`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], FK: [, [, , `[2-7]\\d{4}`, , , , , , , [5]], [, , `[2-47]\\d{4}`, , , , `31234`], [, , `[56]\\d{4}`, , , , `51234`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `FK`, 500, `00`, , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], FM: [, [, , `(?:[39]\\d\\d|820)\\d{4}`, , , , , , , [7]], [, , `31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}`, , , , `3201234`], [, , `31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}`, , , , `3501234`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `FM`, 691, `00`, , , , , , , , [[, `(\\d{3})(\\d{4})`, `$1 $2`, [`[389]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], FO: [, [, , `[2-9]\\d{5}`, , , , , , , [6]], [, , `(?:20|[34]\\d|8[19])\\d{4}`, , , , `201234`], [, , `(?:[27][1-9]|5\\d|9[16])\\d{4}`, , , , `211234`], [, , `80[257-9]\\d{3}`, , , , `802123`], [, , `90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d`, , , , `901123`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `(?:6[0-36]|88)\\d{4}`, , , , `601234`], `FO`, 298, `00`, , , , `(10(?:01|[12]0|88))`, , , , [[, `(\\d{6})`, `$1`, [`[2-9]`], , `$CC $1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], FR: [, [, , `[1-9]\\d{8}`, , , , , , , [9]], [, , `(?:26[013-9]|59[1-35-9])\\d{6}|(?:[13]\\d|2[0-57-9]|4[1-9]|5[0-8])\\d{7}`, , , , `123456789`], [, , `(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}`, , , , `612345678`], [, , `80[0-5]\\d{6}`, , , , `801234567`], [, , `836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}`, , , , `891123456`], [, , `8(?:1[01]|2[0156]|4[024]|84)\\d{6}`, , , , `884012345`], [, , , , , , , , , [-1]], [, , `9\\d{8}`, , , , `912345678`], `FR`, 33, `00`, `0`, , , `0`, , , , [[, `(\\d{4})`, `$1`, [`10`]], [, `(\\d{3})(\\d{3})`, `$1 $2`, [`1`]], [, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`8`], `0 $1`], [, `(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4 $5`, [`[1-79]`], `0$1`]], [[, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`8`], `0 $1`], [, `(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4 $5`, [`[1-79]`], `0$1`]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `80[6-9]\\d{6}`, , , , `806123456`], , , [, , , , , , , , , [-1]]], GA: [, [, , `(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}`, , , , , , , [7, 8]], [, , `[01]1\\d{6}`, , , , `01441234`, , , [8]], [, , `(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}`, , , , `06031234`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `GA`, 241, `00`, , , , `0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})`, `$1`, , , [[, `(\\d)(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[2-7]`], `0$1`], [, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`0`]], [, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`11|[67]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GB: [, [, , `[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}`, , , , , , , [7, 9, 10], [4, 5, 6, 8]], [, , `(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}`, , , , `1212345678`, , , [9, 10], [4, 5, 6, 7, 8]], [, , `7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}`, , , , `7400123456`, , , [10]], [, , `80[08]\\d{7}|800\\d{6}|8001111`, , , , `8001234567`], [, , `(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d`, , , , `9012345678`, , , [7, 10]], [, , , , , , , , , [-1]], [, , `70\\d{8}`, , , , `7012345678`, , , [10]], [, , `56\\d{8}`, , , , `5612345678`, , , [10]], `GB`, 44, `00`, `0`, ` x`, , `0`, , , , [[, `(\\d{3})(\\d{4})`, `$1 $2`, [`800`, `8001`, `80011`, `800111`, `8001111`], `0$1`], [, `(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3`, [`845`, `8454`, `84546`, `845464`], `0$1`], [, `(\\d{3})(\\d{6})`, `$1 $2`, [`800`], `0$1`], [, `(\\d{5})(\\d{4,5})`, `$1 $2`, [`1(?:38|5[23]|69|76|94)`, `1(?:(?:38|69)7|5(?:24|39)|768|946)`, `1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)`], `0$1`], [, `(\\d{4})(\\d{5,6})`, `$1 $2`, [`1(?:[2-69][02-9]|[78])`], `0$1`], [, `(\\d{2})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`[25]|7(?:0|6[02-9])`, `[25]|7(?:0|6(?:[03-9]|2[356]))`], `0$1`], [, `(\\d{4})(\\d{6})`, `$1 $2`, [`7`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[1389]`], `0$1`]], , [, , `76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}`, , , , `7640123456`, , , [10]], 1, , [, , , , , , , , , [-1]], [, , `(?:3[0347]|55)\\d{8}`, , , , `5512345678`, , , [10]], , , [, , , , , , , , , [-1]]], GD: [, [, , `(?:473|[58]\\d\\d|900)\\d{7}`, , , , , , , [10], [7]], [, , `473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-4]|5[579]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}`, , , , `4732691234`, , , , [7]], [, , `473(?:4(?:0[2-79]|1[04-9]|2[0-5]|49|5[68])|5(?:2[01]|3[3-8])|901)\\d{4}`, , , , `4734031234`, , , , [7]], [, , `8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`, , , , `8002123456`], [, , `900[2-9]\\d{6}`, , , , `9002123456`], [, , , , , , , , , [-1]], [, , `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}`, , , , `5002345678`], [, , , , , , , , , [-1]], `GD`, 1, `011`, `1`, , , `([2-9]\\d{6})$|1`, `473$1`, , , , , [, , , , , , , , , [-1]], , `473`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GE: [, [, , `(?:[3-57]\\d\\d|800)\\d{6}`, , , , , , , [9], [6, 7]], [, , `(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}`, , , , `322123456`, , , , [6, 7]], [, , `5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|5(?:0(?:0[17]0|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}|(?:5(?:0(?:0(?:0\\d|11|22|3[0-6]|44|5[05]|77|88|9[09])|(?:[14]\\d|77)\\d|22[02])|1(?:1(?:[03][01]|[124]\\d|5[2-6]|7[0-4])|4\\d\\d)|[23]555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200|333|444)|6[89]\\d\\d|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}`, , , , `555123456`], [, , `800\\d{6}`, , , , `800123456`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `70[67]\\d{6}`, , , , `706123456`], `GE`, 995, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`70`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`32`], `0$1`], [, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[57]`]], [, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[348]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , `70[67]\\d{6}`], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GF: [, [, , `(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}`, , , , , , , [9]], [, , `594(?:[02-49]\\d|1[0-5]|5[6-9]|6[0-3]|80)\\d{4}`, , , , `594101234`], [, , `(?:694(?:[0-249]\\d|3[0-8])|7093[0-3])\\d{4}`, , , , `694201234`], [, , `80[0-5]\\d{6}`, , , , `800012345`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `9(?:(?:396|76\\d)\\d|476[0-5])\\d{4}`, , , , `976012345`], `GF`, 594, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[5-7]|9[47]`], `0$1`], [, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[89]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GG: [, [, , `(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?`, , , , , , , [7, 9, 10], [6]], [, , `1481[25-9]\\d{5}`, , , , `1481256789`, , , [10], [6]], [, , `7(?:(?:781|839)\\d|911[17])\\d{5}`, , , , `7781123456`, , , [10]], [, , `80[08]\\d{7}|800\\d{6}|8001111`, , , , `8001234567`], [, , `(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d`, , , , `9012345678`, , , [7, 10]], [, , , , , , , , , [-1]], [, , `70\\d{8}`, , , , `7012345678`, , , [10]], [, , `56\\d{8}`, , , , `5612345678`, , , [10]], `GG`, 44, `00`, `0`, , , `([25-9]\\d{5})$|0`, `1481$1`, , , , , [, , `76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}`, , , , `7640123456`, , , [10]], , , [, , , , , , , , , [-1]], [, , `(?:3[0347]|55)\\d{8}`, , , , `5512345678`, , , [10]], , , [, , , , , , , , , [-1]]], GH: [, [, , `(?:[235]\\d{3}|800)\\d{5}`, , , , , , , [8, 9], [7]], [, , `3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}`, , , , `302345678`, , , [9], [7]], [, , `(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}`, , , , `231234567`, , , [9]], [, , `800\\d{5}`, , , , `80012345`, , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `GH`, 233, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{4})`, `$1 $2`, [`[237]|8[0-2]`]], [, `(\\d{3})(\\d{5})`, `$1 $2`, [`8`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[235]`], `0$1`]], [[, `(\\d{3})(\\d{5})`, `$1 $2`, [`8`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[235]`], `0$1`]], [, , , , , , , , , [-1]], , , [, , `800\\d{5}`, , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GI: [, [, , `(?:[25]\\d|60)\\d{6}`, , , , , , , [8]], [, , `2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}`, , , , `20012345`], [, , `5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}`, , , , `57123456`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `GI`, 350, `00`, , , , , , , , [[, `(\\d{3})(\\d{5})`, `$1 $2`, [`2`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GL: [, [, , `(?:19|[2-689]\\d|70)\\d{4}`, , , , , , , [6]], [, , `(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}`, , , , `321000`], [, , `[245]\\d{5}`, , , , `221234`], [, , `80\\d{4}`, , , , `801234`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `3[89]\\d{4}`, , , , `381234`], `GL`, 299, `00`, , , , , , , , [[, `(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3`, [`19|[2-9]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GM: [, [, , `[2-9]\\d{6}`, , , , , , , [7]], [, , `(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}`, , , , `5661234`], [, , `(?:[23679]\\d|4[015]|5[0-489])\\d{5}`, , , , `3012345`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `GM`, 220, `00`, , , , , , , , [[, `(\\d{3})(\\d{4})`, `$1 $2`, [`[2-9]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GN: [, [, , `722\\d{6}|(?:3|6\\d)\\d{7}`, , , , , , , [8, 9]], [, , `3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}`, , , , `30241234`, , , [8]], [, , `6[0-356]\\d{7}`, , , , `601123456`, , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `722\\d{6}`, , , , `722123456`, , , [9]], `GN`, 224, `00`, , , , , , , , [[, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`3`]], [, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[67]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GP: [, [, , `(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}`, , , , , , , [9]], [, , `590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}`, , , , `590201234`], [, , `(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}`, , , , `690001234`], [, , `80[0-5]\\d{6}`, , , , `800012345`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}`, , , , `976012345`], `GP`, 590, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[5-79]`], `0$1`], [, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`8`], `0$1`]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GQ: [, [, , `222\\d{6}|(?:3\\d|55|[89]0)\\d{7}`, , , , , , , [9]], [, , `33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}`, , , , `333091234`], [, , `(?:222|55\\d)\\d{6}`, , , , `222123456`], [, , `80\\d[1-9]\\d{5}`, , , , `800123456`], [, , `90\\d[1-9]\\d{5}`, , , , `900123456`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `GQ`, 240, `00`, , , , , , , , [[, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[235]`]], [, `(\\d{3})(\\d{6})`, `$1 $2`, [`[89]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GR: [, [, , `5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}`, , , , , , , [10, 11, 12]], [, , `2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}`, , , , `2123456789`, , , [10]], [, , `68[57-9]\\d{7}|(?:69|94)\\d{8}`, , , , `6912345678`, , , [10]], [, , `800\\d{7,9}`, , , , `8001234567`], [, , `90[19]\\d{7}`, , , , `9091234567`, , , [10]], [, , `8(?:0[16]|12|[27]5|50)\\d{7}`, , , , `8011234567`, , , [10]], [, , `70\\d{8}`, , , , `7012345678`, , , [10]], [, , , , , , , , , [-1]], `GR`, 30, `00`, , , , , , , , [[, `(\\d{2})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`21|7`]], [, `(\\d{4})(\\d{6})`, `$1 $2`, [`2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5`]], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[2689]`]], [, `(\\d{3})(\\d{3,4})(\\d{5})`, `$1 $2 $3`, [`8`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `5005000\\d{3}`, , , , `5005000123`, , , [10]], , , [, , , , , , , , , [-1]]], GT: [, [, , `80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}`, , , , , , , [8, 11]], [, , `[267][2-9]\\d{6}`, , , , `22456789`, , , [8]], [, , `(?:[3-5]\\d\\d|80[0-4])\\d{5}`, , , , `51234567`, , , [8]], [, , `18[01]\\d{8}`, , , , `18001112222`, , , [11]], [, , `19\\d{9}`, , , , `19001112222`, , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `GT`, 502, `00`, , , , , , , , [[, `(\\d{4})(\\d{4})`, `$1 $2`, [`[2-8]`]], [, `(\\d{4})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`1`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GU: [, [, , `(?:[58]\\d\\d|671|900)\\d{7}`, , , , , , , [10], [7]], [, , `671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}`, , , , `6713001234`, , , , [7]], [, , `671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}`, , , , `6713001234`, , , , [7]], [, , `8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`, , , , `8002123456`], [, , `900[2-9]\\d{6}`, , , , `9002123456`], [, , , , , , , , , [-1]], [, , `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}`, , , , `5002345678`], [, , , , , , , , , [-1]], `GU`, 1, `011`, `1`, , , `([2-9]\\d{6})$|1`, `671$1`, , 1, , , [, , , , , , , , , [-1]], , `671`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GW: [, [, , `[49]\\d{8}|4\\d{6}`, , , , , , , [7, 9]], [, , `443\\d{6}`, , , , `443201234`, , , [9]], [, , `9(?:5\\d|6[569]|77)\\d{6}`, , , , `955012345`, , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `40\\d{5}`, , , , `4012345`, , , [7]], `GW`, 245, `00`, , , , , , , , [[, `(\\d{3})(\\d{4})`, `$1 $2`, [`40`]], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[49]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GY: [, [, , `(?:[2-8]\\d{3}|9008)\\d{3}`, , , , , , , [7]], [, , `(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|50[0-6]|77[1-57])\\d{4}`, , , , `2201234`], [, , `510\\d{4}|(?:6\\d|7[0-5])\\d{5}`, , , , `6091234`], [, , `(?:289|8(?:00|6[28]|88|99))\\d{4}`, , , , `2891234`], [, , `9008\\d{3}`, , , , `9008123`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `515\\d{4}`, , , , `5151234`], `GY`, 592, `001`, , , , , , , , [[, `(\\d{3})(\\d{4})`, `$1 $2`, [`[2-9]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], HK: [, [, , `8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}`, , , , , , , [5, 6, 7, 8, 9, 11]], [, , `(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[579]\\d|6[0-2]))|58(?:0[1-9]|1[2-9]))\\d{4}`, , , , `21234567`, , , [8]], [, , `(?:4(?:44[0-25-9]|6(?:1[0-7]|4[0-57-9]|6[0-4])|7(?:4[0-2]|6[0-5]))|5(?:73[0-6]|95[0-8])|6(?:26[013-8]|66[0-3])|70(?:7[1-8]|8[0-4])|84(?:4[0-2]|8[0-35-9])|9(?:29[013-9]|39[014-9]|59[0-4]|899))\\d{4}|(?:4(?:4[0-35-9]|6[02357-9]|7[05])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[1-49]|84[0-39]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}`, , , , `51234567`, , , [8]], [, , `800\\d{6}`, , , , `800123456`, , , [9]], [, , `900(?:[0-24-9]\\d{7}|3\\d{1,4})`, , , , `90012345678`, , , [5, 6, 7, 8, 11]], [, , , , , , , , , [-1]], [, , `8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}`, , , , `81123456`, , , [8]], [, , , , , , , , , [-1]], `HK`, 852, `00(?:30|5[09]|[126-9]?)`, , , , , , `00`, , [[, `(\\d{3})(\\d{2,5})`, `$1 $2`, [`900`, `9003`]], [, `(\\d{4})(\\d{4})`, `$1 $2`, [`[2-7]|8[1-4]|9(?:0[1-9]|[1-8])`]], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`8`]], [, `(\\d{3})(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3 $4`, [`9`]]], , [, , `7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}`, , , , `71123456`, , , [8]], , , [, , , , , , , , , [-1]], [, , `30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}`, , , , `30161234`, , , [8]], , , [, , , , , , , , , [-1]]], HN: [, [, , `8\\d{10}|[237-9]\\d{7}`, , , , , , , [8, 11]], [, , `2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-7]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}`, , , , `22123456`, , , [8]], [, , `[37-9]\\d{7}`, , , , `91234567`, , , [8]], [, , `8002\\d{7}`, , , , `80021234567`, , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `HN`, 504, `00`, , , , , , , , [[, `(\\d{4})(\\d{4})`, `$1-$2`, [`[237-9]`]], [, `(\\d{3})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`8`]]], [[, `(\\d{4})(\\d{4})`, `$1-$2`, [`[237-9]`]]], [, , , , , , , , , [-1]], , , [, , `8002\\d{7}`, , , , , , , [11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], HR: [, [, , `(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}`, , , , , , , [6, 7, 8, 9]], [, , `1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}`, , , , `12345678`, , , [8, 9], [6, 7]], [, , `9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-79])))\\d{4}|98\\d{6}`, , , , `921234567`, , , [8, 9]], [, , `80\\d{5,7}`, , , , `800123456`, , , [7, 8, 9]], [, , `6[01459]\\d{6}|6[01]\\d{4,5}`, , , , `611234`, , , [6, 7, 8]], [, , , , , , , , , [-1]], [, , `7[45]\\d{6}`, , , , `74123456`, , , [8]], [, , , , , , , , , [-1]], `HR`, 385, `00`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{2})(\\d{2,3})`, `$1 $2 $3`, [`6[01]`], `0$1`], [, `(\\d{3})(\\d{2})(\\d{2,3})`, `$1 $2 $3`, [`8`], `0$1`], [, `(\\d)(\\d{4})(\\d{3})`, `$1 $2 $3`, [`1`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`6|7[245]`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`9`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[2-57]`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`8`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `62\\d{6,7}|72\\d{6}`, , , , `62123456`, , , [8, 9]], , , [, , , , , , , , , [-1]]], HT: [, [, , `(?:[2-489]\\d|55)\\d{6}`, , , , , , , [8]], [, , `2(?:2\\d|5[1-5]|81|9[149])\\d{5}`, , , , `22453300`], [, , `(?:[34]\\d|55)\\d{6}`, , , , `34101234`], [, , `8\\d{7}`, , , , `80012345`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}`, , , , `98901234`], `HT`, 509, `00`, , , , , , , , [[, `(\\d{2})(\\d{2})(\\d{4})`, `$1 $2 $3`, [`[2-589]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], HU: [, [, , `[235-7]\\d{8}|[1-9]\\d{7}`, , , , , , , [8, 9], [6, 7]], [, , `(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}`, , , , `12345678`, , , [8], [6, 7]], [, , `(?:[257]0|3[01])\\d{7}`, , , , `201234567`, , , [9]], [, , `(?:[48]0\\d|680[29])\\d{5}`, , , , `80123456`], [, , `9[01]\\d{6}`, , , , `90123456`, , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `21\\d{7}`, , , , `211234567`, , , [9]], `HU`, 36, `00`, `06`, , , `06`, , , , [[, `(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3`, [`1`], `(06 $1)`], [, `(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]`], `(06 $1)`], [, `(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[2-9]`], `06 $1`]], , [, , , , , , , , , [-1]], , , [, , `(?:[48]0\\d|680[29])\\d{5}`], [, , `38\\d{7}`, , , , `381234567`, , , [9]], , , [, , , , , , , , , [-1]]], ID: [, [, , `00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}`, , , , , , , [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [5, 6]], [, , `2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}`, , , , `218350123`, , , [7, 8, 9, 10, 11], [5, 6]], [, , `8[1-35-9]\\d{7,10}`, , , , `812345678`, , , [9, 10, 11, 12]], [, , `00(?:1803\\d{5,11}|7803\\d{7})|(?:177\\d|800)\\d{5,7}`, , , , `8001234567`, , , [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], [, , `809\\d{7}`, , , , `8091234567`, , , [10]], [, , `804\\d{7}`, , , , `8041234567`, , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `ID`, 62, `00[89]`, `0`, , , `0`, , , , [[, `(\\d)(\\d{3})(\\d{3})`, `$1 $2 $3`, [`15`]], [, `(\\d{2})(\\d{5,9})`, `$1 $2`, [`2[124]|[36]1`], `(0$1)`], [, `(\\d{3})(\\d{5,7})`, `$1 $2`, [`800`], `0$1`], [, `(\\d{3})(\\d{5,8})`, `$1 $2`, [`[2-79]`], `(0$1)`], [, `(\\d{3})(\\d{3,4})(\\d{3})`, `$1-$2-$3`, [`8[1-35-9]`], `0$1`], [, `(\\d{3})(\\d{6,8})`, `$1 $2`, [`1`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`804`], `0$1`], [, `(\\d{3})(\\d)(\\d{3})(\\d{3})`, `$1 $2 $3 $4`, [`80`], `0$1`], [, `(\\d{3})(\\d{4})(\\d{4,5})`, `$1-$2-$3`, [`8`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3})(\\d{2,8})`, `$1 $2 $3 $4`, [`001`]], [, `(\\d{2})(\\d{4})(\\d{3})(\\d{4})`, `$1 $2 $3 $4`, [`0`]]], [[, `(\\d)(\\d{3})(\\d{3})`, `$1 $2 $3`, [`15`]], [, `(\\d{2})(\\d{5,9})`, `$1 $2`, [`2[124]|[36]1`], `(0$1)`], [, `(\\d{3})(\\d{5,7})`, `$1 $2`, [`800`], `0$1`], [, `(\\d{3})(\\d{5,8})`, `$1 $2`, [`[2-79]`], `(0$1)`], [, `(\\d{3})(\\d{3,4})(\\d{3})`, `$1-$2-$3`, [`8[1-35-9]`], `0$1`], [, `(\\d{3})(\\d{6,8})`, `$1 $2`, [`1`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`804`], `0$1`], [, `(\\d{3})(\\d)(\\d{3})(\\d{3})`, `$1 $2 $3 $4`, [`80`], `0$1`], [, `(\\d{3})(\\d{4})(\\d{4,5})`, `$1-$2-$3`, [`8`], `0$1`]], [, , , , , , , , , [-1]], , , [, , `001803\\d{5,11}|(?:007803\\d|8071)\\d{6}`, , , , , , , [10, 11, 12, 13, 14, 15, 16, 17]], [, , `(?:1500|8071\\d{3})\\d{3}`, , , , `8071123456`, , , [7, 10]], , , [, , , , , , , , , [-1]]], IE: [, [, , `(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}`, , , , , , , [7, 8, 9, 10], [5, 6]], [, , `(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}`, , , , `2212345`, , , , [5, 6]], [, , `8(?:22|[35-9]\\d)\\d{6}`, , , , `850123456`, , , [9]], [, , `1800\\d{6}`, , , , `1800123456`, , , [10]], [, , `15(?:1[2-8]|[2-8]0|9[089])\\d{6}`, , , , `1520123456`, , , [10]], [, , `18[59]0\\d{6}`, , , , `1850123456`, , , [10]], [, , `700\\d{6}`, , , , `700123456`, , , [9]], [, , `76\\d{7}`, , , , `761234567`, , , [9]], `IE`, 353, `00`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{5})`, `$1 $2`, [`2[24-9]|47|58|6[237-9]|9[35-9]`], `(0$1)`], [, `(\\d{3})(\\d{5})`, `$1 $2`, [`[45]0`], `(0$1)`], [, `(\\d)(\\d{3,4})(\\d{4})`, `$1 $2 $3`, [`1`], `(0$1)`], [, `(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[2569]|4[1-69]|7[14]`], `(0$1)`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`70`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`81`], `(0$1)`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[78]`], `0$1`], [, `(\\d{4})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`1`]], [, `(\\d{2})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`4`], `(0$1)`], [, `(\\d{2})(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3 $4`, [`8`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , `18[59]0\\d{6}`, , , , , , , [10]], [, , `818\\d{6}`, , , , `818123456`, , , [9]], , , [, , `88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}`, , , , `8551234567`, , , [10]]], IL: [, [, , `1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}`, , , , , , , [7, 8, 9, 10, 11, 12]], [, , `153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}`, , , , `21234567`, , , [8, 11, 12], [7]], [, , `55(?:410|57[0-289])\\d{4}|5(?:(?:[0-2][02-9]|[36]\\d|[49][2-9]|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}`, , , , `502345678`, , , [9]], [, , `1(?:255|80[019]\\d{3})\\d{3}`, , , , `1800123456`, , , [7, 10]], [, , `1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}`, , , , `1919123456`, , , [8, 10]], [, , `1700\\d{6}`, , , , `1700123456`, , , [10]], [, , , , , , , , , [-1]], [, , `7(?:38(?:0\\d|5[0-2569]|88)|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}`, , , , `771234567`, , , [9]], `IL`, 972, `0(?:0|1[2-9])`, `0`, , , `0`, , , , [[, `(\\d{4})(\\d{3})`, `$1-$2`, [`125`]], [, `(\\d{4})(\\d{2})(\\d{2})`, `$1-$2-$3`, [`121`]], [, `(\\d)(\\d{3})(\\d{4})`, `$1-$2-$3`, [`[2-489]`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1-$2-$3`, [`[57]`], `0$1`], [, `(\\d{4})(\\d{3})(\\d{3})`, `$1-$2-$3`, [`12`]], [, `(\\d{4})(\\d{6})`, `$1-$2`, [`159`]], [, `(\\d)(\\d{3})(\\d{3})(\\d{3})`, `$1-$2-$3-$4`, [`1[7-9]`]], [, `(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})`, `$1-$2 $3-$4`, [`15`]]], , [, , , , , , , , , [-1]], , , [, , `1700\\d{6}`, , , , , , , [10]], [, , `1599\\d{6}`, , , , `1599123456`, , , [10]], , , [, , `151\\d{8,9}`, , , , `15112340000`, , , [11, 12]]], IM: [, [, , `1624\\d{6}|(?:[3578]\\d|90)\\d{8}`, , , , , , , [10], [6]], [, , `1624(?:230|[5-8]\\d\\d)\\d{3}`, , , , `1624756789`, , , , [6]], [, , `76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}`, , , , `7924123456`], [, , `808162\\d{4}`, , , , `8081624567`], [, , `8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}`, , , , `9016247890`], [, , , , , , , , , [-1]], [, , `70\\d{8}`, , , , `7012345678`], [, , `56\\d{8}`, , , , `5612345678`], `IM`, 44, `00`, `0`, , , `([25-8]\\d{5})$|0`, `1624$1`, , , , , [, , , , , , , , , [-1]], , `74576|(?:16|7[56])24`, [, , , , , , , , , [-1]], [, , `3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}`, , , , `5512345678`], , , [, , , , , , , , , [-1]]], IN: [, [, , `(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}`, , , , , , , [8, 9, 10, 11, 12, 13], [6, 7]], [, , `2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}`, , , , `7410410123`, , , [10], [6, 7, 8]], [, , `(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}`, , , , `8123456789`, , , [10]], [, , `000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))`, , , , `1800123456`], [, , `186[12]\\d{9}`, , , , `1861123456789`, , , [13]], [, , `1860\\d{7}`, , , , `18603451234`, , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `IN`, 91, `00`, `0`, , , `0`, , , , [[, `(\\d{7})`, `$1`, [`575`]], [, `(\\d{8})`, `$1`, [`5(?:0|2[23]|3[03]|[67]1|88)`, `5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)`, `5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)`], , , 1], [, `(\\d{4})(\\d{4,5})`, `$1 $2`, [`180`, `1800`], , , 1], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`140`], , , 1], [, `(\\d{2})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`11|2[02]|33|4[04]|79[1-7]|80[2-46]`, `11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])`, `11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])`], `0$1`, , 1], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]`, `1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]`, `1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]`], `0$1`, , 1], [, `(\\d{4})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807`, `1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]`, `1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]`], `0$1`, , 1], [, `(\\d{5})(\\d{5})`, `$1 $2`, [`[6-9]`], `0$1`, , 1], [, `(\\d{4})(\\d{2,4})(\\d{4})`, `$1 $2 $3`, [`1(?:6|8[06])`, `1(?:6|8[06]0)`], , , 1], [, `(\\d{3})(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3 $4`, [`0`]], [, `(\\d{4})(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3 $4`, [`18`], , , 1]], [[, `(\\d{8})`, `$1`, [`5(?:0|2[23]|3[03]|[67]1|88)`, `5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)`, `5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)`], , , 1], [, `(\\d{4})(\\d{4,5})`, `$1 $2`, [`180`, `1800`], , , 1], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`140`], , , 1], [, `(\\d{2})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`11|2[02]|33|4[04]|79[1-7]|80[2-46]`, `11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])`, `11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])`], `0$1`, , 1], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]`, `1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]`, `1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]`], `0$1`, , 1], [, `(\\d{4})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807`, `1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]`, `1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]`], `0$1`, , 1], [, `(\\d{5})(\\d{5})`, `$1 $2`, [`[6-9]`], `0$1`, , 1], [, `(\\d{4})(\\d{2,4})(\\d{4})`, `$1 $2 $3`, [`1(?:6|8[06])`, `1(?:6|8[06]0)`], , , 1], [, `(\\d{4})(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3 $4`, [`18`], , , 1]], [, , , , , , , , , [-1]], , , [, , `1(?:600\\d{6}|800\\d{4,9})|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}`], [, , `140\\d{7}`, , , , `1409305260`, , , [10]], , , [, , , , , , , , , [-1]]], IO: [, [, , `3\\d{6}`, , , , , , , [7]], [, , `37\\d{5}`, , , , `3709100`], [, , `38\\d{5}`, , , , `3801234`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `IO`, 246, `00`, , , , , , , , [[, `(\\d{3})(\\d{4})`, `$1 $2`, [`3`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], IQ: [, [, , `(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}`, , , , , , , [8, 9, 10], [6, 7]], [, , `1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}`, , , , `12345678`, , , [8, 9], [6, 7]], [, , `7[3-9]\\d{8}`, , , , `7912345678`, , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `IQ`, 964, `00`, `0`, , , `0`, , , , [[, `(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3`, [`1`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[2-6]`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`7`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], IR: [, [, , `[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}`, , , , , , , [4, 5, 6, 7, 10], [8]], [, , `(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|(?:12\\d|30[0-2])\\d|2(?:121|[2689]0\\d)|4(?:111|40\\d))\\d{4}`, , , , `2123456789`, , , [6, 7, 10], [4, 5, 8]], [, , `9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}`, , , , `9123456789`, , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `IR`, 98, `00`, `0`, , , `0`, , , , [[, `(\\d{4,5})`, `$1`, [`96`], `0$1`], [, `(\\d{2})(\\d{4,5})`, `$1 $2`, [`(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`9`], `0$1`], [, `(\\d{2})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`[1-8]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , `9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))`, , , , , , , [4, 5, 10]], [, , `96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])`, , , , `9601`, , , [4, 5]], , , [, , , , , , , , , [-1]]], IS: [, [, , `(?:38\\d|[4-9])\\d{6}`, , , , , , , [7, 9]], [, , `(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}`, , , , `4101234`, , , [7]], [, , `(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}`, , , , `6111234`], [, , `80[0-8]\\d{4}`, , , , `8001234`, , , [7]], [, , `90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}`, , , , `9001234`, , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `49[0-24-79]\\d{4}`, , , , `4921234`, , , [7]], `IS`, 354, `00|1(?:0(?:01|[12]0)|100)`, , , , , , `00`, , [[, `(\\d{3})(\\d{4})`, `$1 $2`, [`[4-9]`]], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`3`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `809\\d{4}`, , , , `8091234`, , , [7]], , , [, , `(?:689|8(?:7[18]|80)|95[48])\\d{4}`, , , , `6891234`, , , [7]]], IT: [, [, , `0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?`, , , , , , , [6, 7, 8, 9, 10, 11, 12]], [, , `0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}`, , , , `0212345678`, , , [6, 7, 8, 9, 10, 11]], [, , `3[2-9]\\d{7,8}|(?:31|43)\\d{8}`, , , , `3123456789`, , , [9, 10]], [, , `80(?:0\\d{3}|3)\\d{3}`, , , , `800123456`, , , [6, 9]], [, , `(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}`, , , , `899123456`, , , [6, 8, 9, 10]], [, , `84(?:[08]\\d{3}|[17])\\d{3}`, , , , `848123456`, , , [6, 9]], [, , `1(?:78\\d|99)\\d{6}`, , , , `1781234567`, , , [9, 10]], [, , `55\\d{8}`, , , , `5512345678`, , , [10]], `IT`, 39, `00`, , , , , , , , [[, `(\\d{4,5})`, `$1`, [`1(?:0|9[246])`, `1(?:0|9(?:2[2-9]|[46]))`]], [, `(\\d{6})`, `$1`, [`1(?:1|92)`]], [, `(\\d{2})(\\d{4,6})`, `$1 $2`, [`0[26]`]], [, `(\\d{3})(\\d{3,6})`, `$1 $2`, [`0[13-57-9][0159]|8(?:03|4[17]|9[2-5])`, `0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))`]], [, `(\\d{4})(\\d{2,6})`, `$1 $2`, [`0(?:[13-579][2-46-8]|8[236-8])`]], [, `(\\d{4})(\\d{4})`, `$1 $2`, [`894`]], [, `(\\d{2})(\\d{3,4})(\\d{4})`, `$1 $2 $3`, [`0[26]|5`]], [, `(\\d{3})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`1(?:44|[679])|[378]|43`]], [, `(\\d{3})(\\d{3,4})(\\d{4})`, `$1 $2 $3`, [`0[13-57-9][0159]|14`]], [, `(\\d{2})(\\d{4})(\\d{5})`, `$1 $2 $3`, [`0[26]`]], [, `(\\d{4})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`0`]], [, `(\\d{3})(\\d{4})(\\d{4,5})`, `$1 $2 $3`, [`3`]]], [[, `(\\d{2})(\\d{4,6})`, `$1 $2`, [`0[26]`]], [, `(\\d{3})(\\d{3,6})`, `$1 $2`, [`0[13-57-9][0159]|8(?:03|4[17]|9[2-5])`, `0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))`]], [, `(\\d{4})(\\d{2,6})`, `$1 $2`, [`0(?:[13-579][2-46-8]|8[236-8])`]], [, `(\\d{4})(\\d{4})`, `$1 $2`, [`894`]], [, `(\\d{2})(\\d{3,4})(\\d{4})`, `$1 $2 $3`, [`0[26]|5`]], [, `(\\d{3})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`1(?:44|[679])|[378]|43`]], [, `(\\d{3})(\\d{3,4})(\\d{4})`, `$1 $2 $3`, [`0[13-57-9][0159]|14`]], [, `(\\d{2})(\\d{4})(\\d{5})`, `$1 $2 $3`, [`0[26]`]], [, `(\\d{4})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`0`]], [, `(\\d{3})(\\d{4})(\\d{4,5})`, `$1 $2 $3`, [`3`]]], [, , , , , , , , , [-1]], 1, , [, , `848\\d{6}`, , , , , , , [9]], [, , , , , , , , , [-1]], , , [, , `3[2-8]\\d{9,10}`, , , , `33101234501`, , , [11, 12]]], JE: [, [, , `1534\\d{6}|(?:[3578]\\d|90)\\d{8}`, , , , , , , [10], [6]], [, , `1534[0-24-8]\\d{5}`, , , , `1534456789`, , , , [6]], [, , `7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}`, , , , `7797712345`], [, , `80(?:07(?:35|81)|8901)\\d{4}`, , , , `8007354567`], [, , `(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}`, , , , `9018105678`], [, , , , , , , , , [-1]], [, , `701511\\d{4}`, , , , `7015115678`], [, , `56\\d{8}`, , , , `5612345678`], `JE`, 44, `00`, `0`, , , `([0-24-8]\\d{5})$|0`, `1534$1`, , , , , [, , `76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}`, , , , `7640123456`], , , [, , , , , , , , , [-1]], [, , `(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}`, , , , `5512345678`], , , [, , , , , , , , , [-1]]], JM: [, [, , `(?:[58]\\d\\d|658|900)\\d{7}`, , , , , , , [10], [7]], [, , `8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}`, , , , `8765230123`, , , , [7]], [, , `(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}`, , , , `8762101234`, , , , [7]], [, , `8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`, , , , `8002123456`], [, , `900[2-9]\\d{6}`, , , , `9002123456`], [, , , , , , , , , [-1]], [, , `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}`, , , , `5002345678`], [, , , , , , , , , [-1]], `JM`, 1, `011`, `1`, , , `1`, , , , , , [, , , , , , , , , [-1]], , `658|876`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], JO: [, [, , `(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}`, , , , , , , [8, 9]], [, , `87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}`, , , , `62001234`, , , [8]], [, , `7(?:[78][0-25-9]|9\\d)\\d{6}`, , , , `790123456`, , , [9]], [, , `80\\d{6}`, , , , `80012345`, , , [8]], [, , `9\\d{7}`, , , , `90012345`, , , [8]], [, , `85\\d{6}`, , , , `85012345`, , , [8]], [, , `70\\d{7}`, , , , `700123456`, , , [9]], [, , , , , , , , , [-1]], `JO`, 962, `00`, `0`, , , `0`, , , , [[, `(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[2356]|87`], `(0$1)`], [, `(\\d{3})(\\d{5,6})`, `$1 $2`, [`[89]`], `0$1`], [, `(\\d{2})(\\d{7})`, `$1 $2`, [`70`], `0$1`], [, `(\\d)(\\d{4})(\\d{4})`, `$1 $2 $3`, [`7`], `0$1`]], , [, , `74(?:66|77)\\d{5}`, , , , `746612345`, , , [9]], , , [, , , , , , , , , [-1]], [, , `8(?:10|8\\d)\\d{5}`, , , , `88101234`, , , [8]], , , [, , , , , , , , , [-1]]], JP: [, [, , `00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}`, , , , , , , [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], [, , `(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}`, , , , `312345678`, , , [9]], [, , `[7-9]0[1-9]\\d{7}`, , , , `9012345678`, , , [10]], [, , `00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}`, , , , `120123456`], [, , `990\\d{6}`, , , , `990123456`, , , [9]], [, , , , , , , , , [-1]], [, , `60\\d{7}`, , , , `601234567`, , , [9]], [, , `50[1-9]\\d{7}`, , , , `5012345678`, , , [10]], `JP`, 81, `010`, `0`, , , `(000[259]\\d{6})$|(?:(?:003768)0?)|0`, `$1`, , , [[, `(\\d{4})(\\d{4})`, `$1-$2`, [`007`, `0077`, `00777`, `00777[01]`]], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1-$2-$3`, [`(?:12|57|99)0`], `0$1`], [, `(\\d{4})(\\d)(\\d{4})`, `$1-$2-$3`, [`1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])`, `1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]`, `1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1-$2-$3`, [`60`], `0$1`], [, `(\\d)(\\d{4})(\\d{4})`, `$1-$2-$3`, [`[36]|4(?:2[09]|7[01])`, `[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1-$2-$3`, [`1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])`, `1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]`, `1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]`], `0$1`], [, `(\\d{3})(\\d{2})(\\d{4})`, `$1-$2-$3`, [`[14]|[289][2-9]|5[3-9]|7[2-4679]`], `0$1`], [, `(\\d{4})(\\d{2})(\\d{3,4})`, `$1-$2-$3`, [`007`, `0077`]], [, `(\\d{4})(\\d{2})(\\d{4})`, `$1-$2-$3`, [`008`]], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1-$2-$3`, [`800`], `0$1`], [, `(\\d{2})(\\d{4})(\\d{4})`, `$1-$2-$3`, [`[257-9]`], `0$1`], [, `(\\d{4})(\\d{3})(\\d{3,4})`, `$1-$2-$3`, [`0`]], [, `(\\d{4})(\\d{4})(\\d{4,5})`, `$1-$2-$3`, [`0`]], [, `(\\d{4})(\\d{5})(\\d{5,6})`, `$1-$2-$3`, [`0`]], [, `(\\d{4})(\\d{6})(\\d{6,7})`, `$1-$2-$3`, [`0`]]], [[, `(\\d{3})(\\d{3})(\\d{3})`, `$1-$2-$3`, [`(?:12|57|99)0`], `0$1`], [, `(\\d{4})(\\d)(\\d{4})`, `$1-$2-$3`, [`1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])`, `1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]`, `1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1-$2-$3`, [`60`], `0$1`], [, `(\\d)(\\d{4})(\\d{4})`, `$1-$2-$3`, [`[36]|4(?:2[09]|7[01])`, `[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1-$2-$3`, [`1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])`, `1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]`, `1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]`], `0$1`], [, `(\\d{3})(\\d{2})(\\d{4})`, `$1-$2-$3`, [`[14]|[289][2-9]|5[3-9]|7[2-4679]`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1-$2-$3`, [`800`], `0$1`], [, `(\\d{2})(\\d{4})(\\d{4})`, `$1-$2-$3`, [`[257-9]`], `0$1`]], [, , `20\\d{8}`, , , , `2012345678`, , , [10]], , , [, , `00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66|78)\\d{6,13}`], [, , `570\\d{6}`, , , , `570123456`, , , [9]], , , [, , , , , , , , , [-1]]], KE: [, [, , `(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}`, , , , , , , [7, 8, 9, 10]], [, , `(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}`, , , , `202012345`, , , [7, 8, 9]], [, , `(?:1(?:0[0-8]|1[0-7]|2[014]|30)|7\\d\\d)\\d{6}`, , , , `712123456`, , , [9]], [, , `800[02-8]\\d{5,6}`, , , , `800223456`, , , [9, 10]], [, , `900[02-9]\\d{5}`, , , , `900223456`, , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `KE`, 254, `000`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{5,7})`, `$1 $2`, [`[24-6]`], `0$1`], [, `(\\d{3})(\\d{6})`, `$1 $2`, [`[17]`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[89]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KG: [, [, , `8\\d{9}|[235-9]\\d{8}`, , , , , , , [9, 10], [5, 6]], [, , `312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}`, , , , `312123456`, , , [9], [5, 6]], [, , `312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}`, , , , `700123456`, , , [9]], [, , `800\\d{6,7}`, , , , `800123456`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `KG`, 996, `00`, `0`, , , `0`, , , , [[, `(\\d{4})(\\d{5})`, `$1 $2`, [`3(?:1[346]|[24-79])`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[235-79]|88`], `0$1`], [, `(\\d{3})(\\d{3})(\\d)(\\d{2,3})`, `$1 $2 $3 $4`, [`8`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KH: [, [, , `1\\d{9}|[1-9]\\d{7,8}`, , , , , , , [8, 9, 10], [6, 7]], [, , `23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})`, , , , `23756789`, , , [8, 9], [6, 7]], [, , `(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}`, , , , `91234567`, , , [8, 9]], [, , `1800(?:1\\d|2[019])\\d{4}`, , , , `1800123456`, , , [10]], [, , `1900(?:1\\d|2[09])\\d{4}`, , , , `1900123456`, , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `KH`, 855, `00[14-9]`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[1-9]`], `0$1`], [, `(\\d{4})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`1`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KI: [, [, , `(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}`, , , , , , , [5, 8]], [, , `(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}`, , , , `31234`], [, , `(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}`, , , , `72001234`, , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `30(?:0[01]\\d\\d|12(?:11|20))\\d\\d`, , , , `30010000`, , , [8]], `KI`, 686, `00`, `0`, , , `0`, , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KM: [, [, , `[3478]\\d{6}`, , , , , , , [7], [4]], [, , `7[4-7]\\d{5}`, , , , `7712345`, , , , [4]], [, , `[34]\\d{6}`, , , , `3212345`], [, , , , , , , , , [-1]], [, , `8\\d{6}`, , , , `8001234`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `KM`, 269, `00`, , , , , , , , [[, `(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3`, [`[3478]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KN: [, [, , `(?:[58]\\d\\d|900)\\d{7}`, , , , , , , [10], [7]], [, , `869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}`, , , , `8692361234`, , , , [7]], [, , `869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}`, , , , `8697652917`, , , , [7]], [, , `8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`, , , , `8002123456`], [, , `900[2-9]\\d{6}`, , , , `9002123456`], [, , , , , , , , , [-1]], [, , `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}`, , , , `5002345678`], [, , , , , , , , , [-1]], `KN`, 1, `011`, `1`, , , `([2-7]\\d{6})$|1`, `869$1`, , , , , [, , , , , , , , , [-1]], , `869`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KP: [, [, , `85\\d{6}|(?:19\\d|[2-7])\\d{7}`, , , , , , , [8, 10], [6, 7]], [, , `(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}`, , , , `21234567`, , , , [6, 7]], [, , `19[1-3]\\d{7}`, , , , `1921234567`, , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `KP`, 850, `00|99`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`8`], `0$1`], [, `(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[2-7]`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`1`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , `238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}`, , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KR: [, [, , `00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}`, , , , , , , [5, 6, 8, 9, 10, 11, 12, 13, 14], [3, 4, 7]], [, , `(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}`, , , , `22123456`, , , [5, 6, 8, 9, 10], [3, 4, 7]], [, , `1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}`, , , , `1020000000`, , , [9, 10]], [, , `00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|[38]0)\\d{7}`, , , , `801234567`, , , [9, 11, 12, 13, 14]], [, , `60[2-9]\\d{6}`, , , , `602345678`, , , [9]], [, , , , , , , , , [-1]], [, , `50\\d{8,9}`, , , , `5012345678`, , , [10, 11]], [, , `70\\d{8}`, , , , `7012345678`, , , [10]], `KR`, 82, `00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))`, `0`, , , `0(8(?:[1-46-8]|5\\d\\d))?`, , , , [[, `(\\d{5})`, `$1`, [`1[016-9]1`, `1[016-9]11`, `1[016-9]114`], `0$1`], [, `(\\d{2})(\\d{3,4})`, `$1-$2`, [`(?:3[1-3]|[46][1-4]|5[1-5])1`], `0$1`, `0$CC-$1`], [, `(\\d{4})(\\d{4})`, `$1-$2`, [`1`]], [, `(\\d)(\\d{3,4})(\\d{4})`, `$1-$2-$3`, [`2`], `0$1`, `0$CC-$1`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1-$2-$3`, [`[36]0|8`], `0$1`, `0$CC-$1`], [, `(\\d{2})(\\d{3,4})(\\d{4})`, `$1-$2-$3`, [`[1346]|5[1-5]`], `0$1`, `0$CC-$1`], [, `(\\d{2})(\\d{4})(\\d{4})`, `$1-$2-$3`, [`[57]`], `0$1`, `0$CC-$1`], [, `(\\d{5})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`003`, `0030`]], [, `(\\d{2})(\\d{5})(\\d{4})`, `$1-$2-$3`, [`5`], `0$1`, `0$CC-$1`], [, `(\\d{5})(\\d{3,4})(\\d{4})`, `$1 $2 $3`, [`0`]], [, `(\\d{5})(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3 $4`, [`0`]]], [[, `(\\d{2})(\\d{3,4})`, `$1-$2`, [`(?:3[1-3]|[46][1-4]|5[1-5])1`], `0$1`, `0$CC-$1`], [, `(\\d{4})(\\d{4})`, `$1-$2`, [`1`]], [, `(\\d)(\\d{3,4})(\\d{4})`, `$1-$2-$3`, [`2`], `0$1`, `0$CC-$1`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1-$2-$3`, [`[36]0|8`], `0$1`, `0$CC-$1`], [, `(\\d{2})(\\d{3,4})(\\d{4})`, `$1-$2-$3`, [`[1346]|5[1-5]`], `0$1`, `0$CC-$1`], [, `(\\d{2})(\\d{4})(\\d{4})`, `$1-$2-$3`, [`[57]`], `0$1`, `0$CC-$1`], [, `(\\d{2})(\\d{5})(\\d{4})`, `$1-$2-$3`, [`5`], `0$1`, `0$CC-$1`]], [, , `15\\d{7,8}`, , , , `1523456789`, , , [9, 10]], , , [, , `00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})`, , , , , , , [11, 12, 13, 14]], [, , `1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[0168]|88)|8(?:00|33|55|77|99))\\d{4}`, , , , `15441234`, , , [8]], , , [, , , , , , , , , [-1]]], KW: [, [, , `18\\d{5}|(?:[2569]\\d|41)\\d{6}`, , , , , , , [7, 8]], [, , `2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}`, , , , `22345678`, , , [8]], [, , `(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}`, , , , `50012345`, , , [8]], [, , `18\\d{5}`, , , , `1801234`, , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `KW`, 965, `00`, , , , , , , , [[, `(\\d{4})(\\d{3,4})`, `$1 $2`, [`[169]|2(?:[235]|4[1-35-9])|52`]], [, `(\\d{3})(\\d{5})`, `$1 $2`, [`[245]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KY: [, [, , `(?:345|[58]\\d\\d|900)\\d{7}`, , , , , , , [10], [7]], [, , `345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|[48]8)|9(?:14|4[035-9]))\\d{4}`, , , , `3452221234`, , , , [7]], [, , `345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}`, , , , `3453231234`, , , , [7]], [, , `8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`, , , , `8002345678`], [, , `(?:345976|900[2-9]\\d\\d)\\d{4}`, , , , `9002345678`], [, , , , , , , , , [-1]], [, , `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}`, , , , `5002345678`], [, , , , , , , , , [-1]], `KY`, 1, `011`, `1`, , , `([2-9]\\d{6})$|1`, `345$1`, , , , , [, , `345849\\d{4}`, , , , `3458491234`], , `345`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KZ: [, [, , `(?:33622|8\\d{8})\\d{5}|[78]\\d{9}`, , , , , , , [10, 14], [5, 6, 7]], [, , `(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}`, , , , `7123456789`, , , [10], [5, 6, 7]], [, , `7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}`, , , , `7710009998`, , , [10]], [, , `8(?:00|108\\d{3})\\d{7}`, , , , `8001234567`], [, , `809\\d{7}`, , , , `8091234567`, , , [10]], [, , , , , , , , , [-1]], [, , `808\\d{7}`, , , , `8081234567`, , , [10]], [, , `751\\d{7}`, , , , `7511234567`, , , [10]], `KZ`, 7, `810`, `8`, , , `8`, , `8~10`, , , , [, , , , , , , , , [-1]], , `33|7`, [, , `751\\d{7}`, , , , , , , [10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LA: [, [, , `[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}`, , , , , , , [8, 9, 10], [6]], [, , `(?:2[13]|[35-7][14]|41|8[1468])\\d{6}`, , , , `21212862`, , , [8], [6]], [, , `208[78]\\d{6}|(?:20[23579]|30[24])\\d{7}`, , , , `2023123456`, , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `LA`, 856, `00`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`2[13]|3[14]|[4-8]`], `0$1`], [, `(\\d{2})(\\d{2})(\\d{2})(\\d{3})`, `$1 $2 $3 $4`, [`30[0135-9]`], `0$1`], [, `(\\d{2})(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3 $4`, [`[23]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `30[0135-9]\\d{6}`, , , , `301234567`, , , [9]], , , [, , , , , , , , , [-1]]], LB: [, [, , `[27-9]\\d{7}|[13-9]\\d{6}`, , , , , , , [7, 8]], [, , `7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}`, , , , `1123456`], [, , `793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}`, , , , `71123456`], [, , , , , , , , , [-1]], [, , `9[01]\\d{6}`, , , , `90123456`, , , [8]], [, , `80\\d{6}`, , , , `80123456`, , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `LB`, 961, `00`, `0`, , , `0`, , , , [[, `(\\d)(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[27-9]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LC: [, [, , `(?:[58]\\d\\d|758|900)\\d{7}`, , , , , , , [10], [7]], [, , `758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}`, , , , `7584305678`, , , , [7]], [, , `758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}`, , , , `7582845678`, , , , [7]], [, , `8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`, , , , `8002123456`], [, , `900[2-9]\\d{6}`, , , , `9002123456`], [, , , , , , , , , [-1]], [, , `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}`, , , , `5002345678`], [, , , , , , , , , [-1]], `LC`, 1, `011`, `1`, , , `([2-8]\\d{6})$|1`, `758$1`, , , , , [, , , , , , , , , [-1]], , `758`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LI: [, [, , `[68]\\d{8}|(?:[2378]\\d|90)\\d{5}`, , , , , , , [7, 9]], [, , `(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}`, , , , `2345678`, , , [7]], [, , `(?:6(?:(?:4[5-9]|5[0-469])\\d|6(?:[024-6]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}`, , , , `660234567`], [, , `8002[28]\\d\\d|80(?:05\\d|9)\\d{4}`, , , , `8002222`], [, , `90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d`, , , , `9002222`, , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `LI`, 423, `00`, `0`, , , `(1001)|0`, , , , [[, `(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3`, [`[2379]|8(?:0[09]|7)`, `[2379]|8(?:0(?:02|9)|7)`], , `$CC $1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`8`]], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`69`], , `$CC $1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`6`], , `$CC $1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `870(?:28|87)\\d\\d`, , , , `8702812`, , , [7]], , , [, , `697(?:42|56|[78]\\d)\\d{4}`, , , , `697861234`, , , [9]]], LK: [, [, , `[1-9]\\d{8}`, , , , , , , [9], [7]], [, , `(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}`, , , , `112345678`, , , , [7]], [, , `7(?:[0-25-8]\\d|4[0-4])\\d{6}`, , , , `712345678`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `LK`, 94, `00`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`7`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[1-689]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `1973\\d{5}`, , , , `197312345`], , , [, , , , , , , , , [-1]]], LR: [, [, , `(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}`, , , , , , , [7, 8, 9]], [, , `2\\d{7}`, , , , `21234567`, , , [8]], [, , `(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}`, , , , `770123456`, , , [7, 9]], [, , , , , , , , , [-1]], [, , `332(?:02|[34]\\d)\\d{4}`, , , , `332021234`, , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `LR`, 231, `00`, `0`, , , `0`, , , , [[, `(\\d)(\\d{3})(\\d{3})`, `$1 $2 $3`, [`4[67]|[56]`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`2`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[2-578]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LS: [, [, , `(?:[256]\\d\\d|800)\\d{5}`, , , , , , , [8]], [, , `2\\d{7}`, , , , `22123456`], [, , `[56]\\d{7}`, , , , `50123456`], [, , `800[1256]\\d{4}`, , , , `80021234`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `LS`, 266, `00`, , , , , , , , [[, `(\\d{4})(\\d{4})`, `$1 $2`, [`[2568]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LT: [, [, , `(?:[3469]\\d|52|[78]0)\\d{6}`, , , , , , , [8]], [, , `(?:3[1478]|4[124-6]|52)\\d{6}`, , , , `31234567`], [, , `6\\d{7}`, , , , `61234567`], [, , `80[02]\\d{5}`, , , , `80012345`], [, , `9(?:0[0239]|10)\\d{5}`, , , , `90012345`], [, , `808\\d{5}`, , , , `80812345`], [, , `70[05]\\d{5}`, , , , `70012345`], [, , `[89]01\\d{5}`, , , , `80123456`], `LT`, 370, `00`, `0`, , , `[08]`, , , , [[, `(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3`, [`52[0-7]`], `(0-$1)`, , 1], [, `(\\d{3})(\\d{2})(\\d{3})`, `$1 $2 $3`, [`[7-9]`], `0 $1`, , 1], [, `(\\d{2})(\\d{6})`, `$1 $2`, [`37|4(?:[15]|6[1-8])`], `(0-$1)`, , 1], [, `(\\d{3})(\\d{5})`, `$1 $2`, [`[3-6]`], `(0-$1)`, , 1]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `70[67]\\d{5}`, , , , `70712345`], , , [, , , , , , , , , [-1]]], LU: [, [, , `35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}`, , , , , , , [4, 5, 6, 7, 8, 9, 10, 11]], [, , `(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}`, , , , `27123456`], [, , `6(?:[269][18]|5[1568]|7[189]|81)\\d{6}`, , , , `628123456`, , , [9]], [, , `800\\d{5}`, , , , `80012345`, , , [8]], [, , `90[015]\\d{5}`, , , , `90012345`, , , [8]], [, , `801\\d{5}`, , , , `80112345`, , , [8]], [, , , , , , , , , [-1]], [, , `20(?:1\\d{5}|[2-689]\\d{1,7})`, , , , `20201234`, , , [4, 5, 6, 7, 8, 9, 10]], `LU`, 352, `00`, , , , `(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)`, , , , [[, `(\\d{2})(\\d{3})`, `$1 $2`, [`2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])`], , `$CC $1`], [, `(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3`, [`2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])`], , `$CC $1`], [, `(\\d{2})(\\d{2})(\\d{3})`, `$1 $2 $3`, [`20[2-689]`], , `$CC $1`], [, `(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})`, `$1 $2 $3 $4`, [`2(?:[0367]|4[3-8])`], , `$CC $1`], [, `(\\d{3})(\\d{2})(\\d{3})`, `$1 $2 $3`, [`80[01]|90[015]`], , `$CC $1`], [, `(\\d{2})(\\d{2})(\\d{2})(\\d{3})`, `$1 $2 $3 $4`, [`20`], , `$CC $1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`6`], , `$CC $1`], [, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})`, `$1 $2 $3 $4 $5`, [`2(?:[0367]|4[3-8])`], , `$CC $1`], [, `(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})`, `$1 $2 $3 $4`, [`[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]`], , `$CC $1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LV: [, [, , `(?:[268]\\d|90)\\d{6}`, , , , , , , [8]], [, , `6\\d{7}`, , , , `63123456`], [, , `23(?:23[0-57-9]|33[0238])\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[024-9]|3[0-24-9]))\\d{4}`, , , , `21234567`], [, , `80\\d{6}`, , , , `80123456`], [, , `90\\d{6}`, , , , `90123456`], [, , `81\\d{6}`, , , , `81123456`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `LV`, 371, `00`, , , , , , , , [[, `(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[269]|8[01]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LY: [, [, , `[2-9]\\d{8}`, , , , , , , [9], [7]], [, , `(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}`, , , , `212345678`, , , , [7]], [, , `9[1-6]\\d{7}`, , , , `912345678`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `LY`, 218, `00`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{7})`, `$1-$2`, [`[2-9]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MA: [, [, , `[5-8]\\d{8}`, , , , , , , [9]], [, , `5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}`, , , , `520123456`], [, , `(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}`, , , , `650123456`], [, , `80[0-7]\\d{6}`, , , , `801234567`], [, , `89\\d{7}`, , , , `891234567`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}`, , , , `592401234`], `MA`, 212, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`5[45]`], `0$1`], [, `(\\d{4})(\\d{5})`, `$1-$2`, [`5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)`], `0$1`], [, `(\\d{2})(\\d{7})`, `$1-$2`, [`8`], `0$1`], [, `(\\d{3})(\\d{6})`, `$1-$2`, [`[5-7]`], `0$1`]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MC: [, [, , `(?:[3489]|6\\d)\\d{7}`, , , , , , , [8, 9]], [, , `(?:870|9[2-47-9]\\d)\\d{5}`, , , , `99123456`, , , [8]], [, , `4(?:[469]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}`, , , , `612345678`], [, , `(?:800|90\\d)\\d{5}`, , , , `90123456`, , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `MC`, 377, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{3})(\\d{2})`, `$1 $2 $3`, [`87`]], [, `(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`4`], `0$1`], [, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[389]`]], [, `(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4 $5`, [`6`], `0$1`]], [[, `(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`4`], `0$1`], [, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[389]`]], [, `(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4 $5`, [`6`], `0$1`]], [, , , , , , , , , [-1]], , , [, , `8[07]0\\d{5}`, , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MD: [, [, , `(?:[235-7]\\d|[89]0)\\d{6}`, , , , , , , [8]], [, , `(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}`, , , , `22212345`], [, , `562\\d{5}|(?:6\\d|7[16-9])\\d{6}`, , , , `62112345`], [, , `800\\d{5}`, , , , `80012345`], [, , `90[056]\\d{5}`, , , , `90012345`], [, , `808\\d{5}`, , , , `80812345`], [, , , , , , , , , [-1]], [, , `3[08]\\d{6}`, , , , `30123456`], `MD`, 373, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{5})`, `$1 $2`, [`[89]`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`22|3`], `0$1`], [, `(\\d{3})(\\d{2})(\\d{3})`, `$1 $2 $3`, [`[25-7]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `803\\d{5}`, , , , `80312345`], , , [, , , , , , , , , [-1]]], ME: [, [, , `(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}`, , , , , , , [8, 9], [6]], [, , `(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}`, , , , `30234567`, , , [8], [6]], [, , `6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}`, , , , `67622901`, , , [8]], [, , `80(?:[0-2578]|9\\d)\\d{5}`, , , , `80080002`], [, , `9(?:4[1568]|5[178])\\d{5}`, , , , `94515151`, , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `78[1-49]\\d{5}`, , , , `78108780`, , , [8]], `ME`, 382, `00`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[2-9]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `77[1-9]\\d{5}`, , , , `77273012`, , , [8]], , , [, , , , , , , , , [-1]]], MF: [, [, , `(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}`, , , , , , , [9]], [, , `590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}`, , , , `590271234`], [, , `(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}`, , , , `690001234`], [, , `80[0-5]\\d{6}`, , , , `800012345`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}`, , , , `976012345`], `MF`, 590, `00`, `0`, , , `0`, , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MG: [, [, , `[23]\\d{8}`, , , , , , , [9], [7]], [, , `2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[356]|8[268]|9[2457])\\d{5}`, , , , `202123456`, , , , [7]], [, , `3[2-47-9]\\d{7}`, , , , `321234567`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `22\\d{7}`, , , , `221234567`], `MG`, 261, `00`, `0`, , , `([24-9]\\d{6})$|0`, `20$1`, , , [[, `(\\d{2})(\\d{2})(\\d{3})(\\d{2})`, `$1 $2 $3 $4`, [`[23]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MH: [, [, , `329\\d{4}|(?:[256]\\d|45)\\d{5}`, , , , , , , [7]], [, , `(?:247|528|625)\\d{4}`, , , , `2471234`], [, , `(?:(?:23|54)5|329|45[35-8])\\d{4}`, , , , `2351234`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `635\\d{4}`, , , , `6351234`], `MH`, 692, `011`, `1`, , , `1`, , , , [[, `(\\d{3})(\\d{4})`, `$1-$2`, [`[2-6]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MK: [, [, , `[2-578]\\d{7}`, , , , , , , [8], [6, 7]], [, , `(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}`, , , , `22012345`, , , , [6, 7]], [, , `7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-48]\\d|6[01]|7[01578])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}`, , , , `72345678`], [, , `800\\d{5}`, , , , `80012345`], [, , `5\\d{7}`, , , , `50012345`], [, , `8(?:0[1-9]|[1-9]\\d)\\d{5}`, , , , `80123456`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `MK`, 389, `00`, `0`, , , `0`, , , , [[, `(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3`, [`2|34[47]|4(?:[37]7|5[47]|64)`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[347]`], `0$1`], [, `(\\d{3})(\\d)(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[58]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ML: [, [, , `[24-9]\\d{7}`, , , , , , , [8]], [, , `2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}`, , , , `20212345`], [, , `2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-49])\\d{6}`, , , , `65012345`], [, , `80\\d{6}`, , , , `80012345`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `ML`, 223, `00`, , , , , , , , [[, `(\\d{4})`, `$1`, [`67[057-9]|74[045]`, `67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)`]], [, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[24-9]`]]], [[, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[24-9]`]]], [, , , , , , , , , [-1]], , , [, , `80\\d{6}`], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MM: [, [, , `1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}`, , , , , , , [6, 7, 8, 9, 10], [5]], [, , `(?:1(?:(?:12|[28]\\d|3[56]|7[3-6]|9[0-6])\\d|4(?:2[29]|62|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|[26]2|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5(?:2\\d|470))|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:3\\d\\d|4[67]0|8(?:[01459]\\d|8))))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|(?:[35]2|64)\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}`, , , , `1234567`, , , [6, 7, 8, 9], [5]], [, , `(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}`, , , , `92123456`, , , [7, 8, 9, 10]], [, , `80080(?:0[1-9]|2\\d)\\d{3}`, , , , `8008001234`, , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `1333\\d{4}|[12]468\\d{4}`, , , , `13331234`, , , [8]], `MM`, 95, `00`, `0`, , , `0`, , , , [[, `(\\d)(\\d{2})(\\d{3})`, `$1 $2 $3`, [`16|2`], `0$1`], [, `(\\d{2})(\\d{2})(\\d{3})`, `$1 $2 $3`, [`4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]`], `0$1`], [, `(\\d)(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[12]|452|678|86`, `[12]|452|6788|86`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[4-7]|8[1-35]`], `0$1`], [, `(\\d)(\\d{3})(\\d{4,6})`, `$1 $2 $3`, [`9(?:2[0-4]|[35-9]|4[137-9])`], `0$1`], [, `(\\d)(\\d{4})(\\d{4})`, `$1 $2 $3`, [`2`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`8`], `0$1`], [, `(\\d)(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3 $4`, [`92`], `0$1`], [, `(\\d)(\\d{5})(\\d{4})`, `$1 $2 $3`, [`9`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MN: [, [, , `[12]\\d{7,9}|[5-9]\\d{7}`, , , , , , , [8, 9, 10], [4, 5, 6]], [, , `[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}`, , , , `53123456`, , , , [4, 5, 6]], [, , `(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|8[015689]|9[013-9])\\d{6}`, , , , `88123456`, , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `712[0-79]\\d{4}|7(?:1[013-9]|[25-9]\\d)\\d{5}`, , , , `75123456`, , , [8]], `MN`, 976, `001`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{2})(\\d{4})`, `$1 $2 $3`, [`[12]1`], `0$1`], [, `(\\d{4})(\\d{4})`, `$1 $2`, [`[5-9]`]], [, `(\\d{3})(\\d{5,6})`, `$1 $2`, [`[12]2[1-3]`], `0$1`], [, `(\\d{4})(\\d{5,6})`, `$1 $2`, [`[12](?:27|3[2-8]|4[2-68]|5[1-4689])`, `[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]`], `0$1`], [, `(\\d{5})(\\d{4,5})`, `$1 $2`, [`[12]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MO: [, [, , `0800\\d{3}|(?:28|[68]\\d)\\d{6}`, , , , , , , [7, 8]], [, , `(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}`, , , , `28212345`, , , [8]], [, , `6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}`, , , , `66123456`, , , [8]], [, , `0800\\d{3}`, , , , `0800501`, , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `MO`, 853, `00`, , , , , , , , [[, `(\\d{4})(\\d{3})`, `$1 $2`, [`0`]], [, `(\\d{4})(\\d{4})`, `$1 $2`, [`[268]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MP: [, [, , `[58]\\d{9}|(?:67|90)0\\d{7}`, , , , , , , [10], [7]], [, , `670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}`, , , , `6702345678`, , , , [7]], [, , `670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}`, , , , `6702345678`, , , , [7]], [, , `8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`, , , , `8002123456`], [, , `900[2-9]\\d{6}`, , , , `9002123456`], [, , , , , , , , , [-1]], [, , `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}`, , , , `5002345678`], [, , , , , , , , , [-1]], `MP`, 1, `011`, `1`, , , `([2-9]\\d{6})$|1`, `670$1`, , 1, , , [, , , , , , , , , [-1]], , `670`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MQ: [, [, , `(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}`, , , , , , , [9]], [, , `(?:596(?:[03-7]\\d|1[05]|2[7-9]|8[0-39]|9[04-9])|80[6-9]\\d\\d|9(?:477[6-9]|767[4589]))\\d{4}`, , , , `596301234`], [, , `(?:69[67]\\d\\d|7091[0-3])\\d{4}`, , , , `696201234`], [, , `80[0-5]\\d{6}`, , , , `800012345`], [, , `8[129]\\d{7}`, , , , `810123456`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `9(?:397[0-3]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}`, , , , `976612345`], `MQ`, 596, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[5-79]|8(?:0[6-9]|[36])`], `0$1`], [, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`8`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MR: [, [, , `(?:[2-4]\\d\\d|800)\\d{5}`, , , , , , , [8]], [, , `(?:25[08]|35\\d|45[1-7])\\d{5}`, , , , `35123456`], [, , `[2-4][0-46-9]\\d{6}`, , , , `22123456`], [, , `800\\d{5}`, , , , `80012345`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `MR`, 222, `00`, , , , , , , , [[, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[2-48]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MS: [, [, , `(?:[58]\\d\\d|664|900)\\d{7}`, , , , , , , [10], [7]], [, , `6644(?:1[0-3]|91)\\d{4}`, , , , `6644912345`, , , , [7]], [, , `664(?:3(?:49|9[1-6])|49[2-6])\\d{4}`, , , , `6644923456`, , , , [7]], [, , `8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`, , , , `8002123456`], [, , `900[2-9]\\d{6}`, , , , `9002123456`], [, , , , , , , , , [-1]], [, , `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}`, , , , `5002345678`], [, , , , , , , , , [-1]], `MS`, 1, `011`, `1`, , , `([34]\\d{6})$|1`, `664$1`, , , , , [, , , , , , , , , [-1]], , `664`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MT: [, [, , `3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}`, , , , , , , [8]], [, , `20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}`, , , , `21001234`], [, , `(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}`, , , , `96961234`], [, , `800(?:02|[3467]\\d)\\d{3}`, , , , `80071234`], [, , `5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}`, , , , `50037123`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `3550\\d{4}`, , , , `35501234`], `MT`, 356, `00`, , , , , , , , [[, `(\\d{4})(\\d{4})`, `$1 $2`, [`[2357-9]`]]], , [, , `7117\\d{4}`, , , , `71171234`], , , [, , , , , , , , , [-1]], [, , `501\\d{5}`, , , , `50112345`], , , [, , , , , , , , , [-1]]], MU: [, [, , `(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}`, , , , , , , [7, 8, 10]], [, , `(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-8]|71)|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}`, , , , `54480123`, , , [7, 8]], [, , `5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-4]|3[013]))\\d{5}`, , , , `52512345`, , , [8]], [, , `802\\d{7}|80[0-2]\\d{4}`, , , , `8001234`, , , [7, 10]], [, , `30\\d{5}`, , , , `3012345`, , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `3(?:20|9\\d)\\d{4}`, , , , `3201234`, , , [7]], `MU`, 230, `0(?:0|[24-7]0|3[03])`, , , , , , `020`, , [[, `(\\d{3})(\\d{4})`, `$1 $2`, [`[2-46]|8[013]`]], [, `(\\d{4})(\\d{4})`, `$1 $2`, [`[57]`]], [, `(\\d{5})(\\d{5})`, `$1 $2`, [`8`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MV: [, [, , `(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}`, , , , , , , [7, 10]], [, , `(?:3(?:0[0-4]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}`, , , , `6701234`, , , [7]], [, , `(?:46[46]|[79]\\d\\d)\\d{4}`, , , , `7712345`, , , [7]], [, , `800\\d{7}`, , , , `8001234567`, , , [10]], [, , `900\\d{7}`, , , , `9001234567`, , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `MV`, 960, `0(?:0|19)`, , , , , , `00`, , [[, `(\\d{3})(\\d{4})`, `$1-$2`, [`[34679]`]], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[89]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `4(?:0[01]|50)\\d{4}`, , , , `4001234`, , , [7]], , , [, , , , , , , , , [-1]]], MW: [, [, , `(?:[1289]\\d|31|77)\\d{7}|1\\d{6}`, , , , , , , [7, 9]], [, , `(?:1[2-9]|2[12]\\d\\d)\\d{5}`, , , , `1234567`], [, , `111\\d{6}|(?:31|77|[89][89])\\d{7}`, , , , `991234567`, , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `MW`, 265, `00`, `0`, , , `0`, , , , [[, `(\\d)(\\d{3})(\\d{3})`, `$1 $2 $3`, [`1[2-9]`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`2`], `0$1`], [, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[137-9]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MX: [, [, , `[2-9]\\d{9}`, , , , , , , [10], [7, 8]], [, , `657[12]\\d{6}|(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}`, , , , `2001234567`, , , , [7, 8]], [, , `657[12]\\d{6}|(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}`, , , , `2221234567`, , , , [7, 8]], [, , `8(?:00|88)\\d{7}`, , , , `8001234567`], [, , `900\\d{7}`, , , , `9001234567`], [, , `300\\d{7}`, , , , `3001234567`], [, , `500\\d{7}`, , , , `5001234567`], [, , , , , , , , , [-1]], `MX`, 52, `0[09]`, , , , , , `00`, , [[, `(\\d{5})`, `$1`, [`53`]], [, `(\\d{2})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`33|5[56]|81`]], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[2-9]`]]], [[, `(\\d{2})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`33|5[56]|81`]], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[2-9]`]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MY: [, [, , `1\\d{8,9}|(?:3\\d|[4-9])\\d{7}`, , , , , , , [8, 9, 10], [6, 7]], [, , `4270\\d{4}|(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}`, , , , `323856789`, , , [8, 9], [6, 7]], [, , `1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}`, , , , `123456789`, , , [9, 10]], [, , `1[378]00\\d{6}`, , , , `1300123456`, , , [10]], [, , `1600\\d{6}`, , , , `1600123456`, , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}`, , , , `1546012345`, , , [10]], `MY`, 60, `00`, `0`, , , `0`, , , , [[, `(\\d)(\\d{3})(\\d{4})`, `$1-$2 $3`, [`[4-79]`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3,4})`, `$1-$2 $3`, [`1(?:[02469]|[378][1-9]|53)|8`, `1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8`], `0$1`], [, `(\\d)(\\d{4})(\\d{4})`, `$1-$2 $3`, [`3`], `0$1`], [, `(\\d)(\\d{3})(\\d{2})(\\d{4})`, `$1-$2-$3-$4`, [`1(?:[367]|80)`]], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1-$2 $3`, [`15`], `0$1`], [, `(\\d{2})(\\d{4})(\\d{4})`, `$1-$2 $3`, [`1`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MZ: [, [, , `(?:2|8\\d)\\d{7}`, , , , , , , [8, 9]], [, , `2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}`, , , , `21123456`, , , [8]], [, , `8[2-79]\\d{7}`, , , , `821234567`, , , [9]], [, , `800\\d{6}`, , , , `800123456`, , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `MZ`, 258, `00`, , , , , , , , [[, `(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`2|8[2-79]`]], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`8`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NA: [, [, , `[68]\\d{7,8}`, , , , , , , [8, 9]], [, , `64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}`, , , , `61221234`], [, , `(?:60|8[1245])\\d{7}`, , , , `811234567`, , , [9]], [, , `80\\d{7}`, , , , `800123456`, , , [9]], [, , `8701\\d{5}`, , , , `870123456`, , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `8(?:3\\d\\d|86)\\d{5}`, , , , `88612345`], `NA`, 264, `00`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`88`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`6`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`87`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`8`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NC: [, [, , `(?:050|[2-57-9]\\d\\d)\\d{3}`, , , , , , , [6]], [, , `(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}`, , , , `201234`], [, , `(?:5[0-4]|[79]\\d|8[0-79])\\d{4}`, , , , `751234`], [, , `050\\d{3}`, , , , `050012`], [, , `36\\d{4}`, , , , `366711`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `NC`, 687, `00`, , , , , , , , [[, `(\\d{3})`, `$1`, [`5[6-8]`]], [, `(\\d{2})(\\d{2})(\\d{2})`, `$1.$2.$3`, [`[02-57-9]`]]], [[, `(\\d{2})(\\d{2})(\\d{2})`, `$1.$2.$3`, [`[02-57-9]`]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NE: [, [, , `[027-9]\\d{7}`, , , , , , , [8]], [, , `2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}`, , , , `20201234`], [, , `(?:23|7[0467]|[89]\\d)\\d{6}`, , , , `93123456`], [, , `08\\d{6}`, , , , `08123456`], [, , `09\\d{6}`, , , , `09123456`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `NE`, 227, `00`, , , , , , , , [[, `(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`08`]], [, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[089]|2[013]|7[0467]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NF: [, [, , `[13]\\d{5}`, , , , , , , [6], [5]], [, , `(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}`, , , , `106609`, , , , [5]], [, , `(?:14|3[58])\\d{4}`, , , , `381234`, , , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `NF`, 672, `00`, , , , `([0-258]\\d{4})$`, `3$1`, , , [[, `(\\d{2})(\\d{4})`, `$1 $2`, [`1[0-3]`]], [, `(\\d)(\\d{5})`, `$1 $2`, [`[13]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NG: [, [, , `38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}`, , , , , , , [8, 10, 11, 12, 13, 14], [6, 7]], [, , `(?:20(?:[1259]\\d|3[013-9]|4[1-8]|6[024-689]|7[1-79]|8[2-9])|38)\\d{6}`, , , , `2033123456`, , , [8, 10], [6, 7]], [, , `(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}`, , , , `8021234567`, , , [10]], [, , `800\\d{7,11}`, , , , `80017591759`, , , [10, 11, 12, 13, 14]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `NG`, 234, `009`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{3})(\\d{2,3})`, `$1 $2 $3`, [`3`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[7-9]`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`20[129]`], `0$1`], [, `(\\d{4})(\\d{2})(\\d{4})`, `$1 $2 $3`, [`2`], `0$1`], [, `(\\d{3})(\\d{4})(\\d{4,5})`, `$1 $2 $3`, [`[78]`], `0$1`], [, `(\\d{3})(\\d{5})(\\d{5,6})`, `$1 $2 $3`, [`[78]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `700\\d{7,11}`, , , , `7001234567`, , , [10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]]], NI: [, [, , `(?:1800|[25-8]\\d{3})\\d{4}`, , , , , , , [8]], [, , `2\\d{7}`, , , , `21234567`], [, , `(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}`, , , , `81234567`], [, , `1800\\d{4}`, , , , `18001234`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `NI`, 505, `00`, , , , , , , , [[, `(\\d{4})(\\d{4})`, `$1 $2`, [`[125-8]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NL: [, [, , `(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}`, , , , , , , [5, 6, 7, 8, 9, 10, 11]], [, , `(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}`, , , , `101234567`, , , [9]], [, , `(?:6[1-58]|970\\d)\\d{7}`, , , , `612345678`, , , [9, 11]], [, , `800\\d{4,7}`, , , , `8001234`, , , [7, 8, 9, 10]], [, , `90[069]\\d{4,7}`, , , , `9061234`, , , [7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `(?:85|91)\\d{7}`, , , , `851234567`, , , [9]], `NL`, 31, `00`, `0`, , , `0`, , , , [[, `(\\d{4})`, `$1`, [`1[238]|[34]`]], [, `(\\d{2})(\\d{3,4})`, `$1 $2`, [`14`]], [, `(\\d{6})`, `$1`, [`1`]], [, `(\\d{3})(\\d{4,7})`, `$1 $2`, [`[89]0`], `0$1`], [, `(\\d{2})(\\d{7})`, `$1 $2`, [`66`], `0$1`], [, `(\\d)(\\d{8})`, `$1 $2`, [`6`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`1[16-8]|2[259]|3[124]|4[17-9]|5[124679]`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[1-578]|91`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{5})`, `$1 $2 $3`, [`9`], `0$1`]], [[, `(\\d{3})(\\d{4,7})`, `$1 $2`, [`[89]0`], `0$1`], [, `(\\d{2})(\\d{7})`, `$1 $2`, [`66`], `0$1`], [, `(\\d)(\\d{8})`, `$1 $2`, [`6`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`1[16-8]|2[259]|3[124]|4[17-9]|5[124679]`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[1-578]|91`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{5})`, `$1 $2 $3`, [`9`], `0$1`]], [, , `66\\d{7}`, , , , `662345678`, , , [9]], , , [, , `140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d`, , , , , , , [5, 6]], [, , `140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d`, , , , `14020`, , , [5, 6, 9]], , , [, , , , , , , , , [-1]]], NO: [, [, , `(?:0|[2-9]\\d{3})\\d{4}`, , , , , , , [5, 8]], [, , `(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}`, , , , `21234567`, , , [8]], [, , `(?:4[015-8]|9\\d)\\d{6}`, , , , `40612345`, , , [8]], [, , `80[01]\\d{5}`, , , , `80012345`, , , [8]], [, , `82[09]\\d{5}`, , , , `82012345`, , , [8]], [, , `810(?:0[0-6]|[2-8]\\d)\\d{3}`, , , , `81021234`, , , [8]], [, , `880\\d{5}`, , , , `88012345`, , , [8]], [, , `85[0-5]\\d{5}`, , , , `85012345`, , , [8]], `NO`, 47, `00`, , , , , , , , [[, `(\\d{3})(\\d{2})(\\d{3})`, `$1 $2 $3`, [`8`]], [, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[2-79]`]]], , [, , , , , , , , , [-1]], 1, `[02-689]|7[0-8]`, [, , , , , , , , , [-1]], [, , `(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}`, , , , `02000`], , , [, , `81[23]\\d{5}`, , , , `81212345`, , , [8]]], NP: [, [, , `(?:1\\d|9)\\d{9}|[1-9]\\d{7}`, , , , , , , [8, 10, 11], [6, 7]], [, , `(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}`, , , , `14567890`, , , [8], [6, 7]], [, , `9(?:00|6[0-3]|7[024-6]|8[0-24-68])\\d{7}`, , , , `9841234567`, , , [10]], [, , `1(?:66001|800\\d\\d)\\d{5}`, , , , `16600101234`, , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `NP`, 977, `00`, `0`, , , `0`, , , , [[, `(\\d)(\\d{7})`, `$1-$2`, [`1[2-6]`], `0$1`], [, `(\\d{2})(\\d{6})`, `$1-$2`, [`1[01]|[2-8]|9(?:[1-59]|[67][2-6])`], `0$1`], [, `(\\d{3})(\\d{7})`, `$1-$2`, [`9`]], [, `(\\d{4})(\\d{2})(\\d{5})`, `$1-$2-$3`, [`1`]]], [[, `(\\d)(\\d{7})`, `$1-$2`, [`1[2-6]`], `0$1`], [, `(\\d{2})(\\d{6})`, `$1-$2`, [`1[01]|[2-8]|9(?:[1-59]|[67][2-6])`], `0$1`], [, `(\\d{3})(\\d{7})`, `$1-$2`, [`9`]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NR: [, [, , `(?:444|(?:55|8\\d)\\d|666)\\d{4}`, , , , , , , [7]], [, , `444\\d{4}`, , , , `4441234`], [, , `(?:55[3-9]|666|8\\d\\d)\\d{4}`, , , , `5551234`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `NR`, 674, `00`, , , , , , , , [[, `(\\d{3})(\\d{4})`, `$1 $2`, [`[4-68]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NU: [, [, , `(?:[4-7]|888\\d)\\d{3}`, , , , , , , [4, 7]], [, , `[47]\\d{3}`, , , , `7012`, , , [4]], [, , `(?:[56]|888[1-9])\\d{3}`, , , , `8884012`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `NU`, 683, `00`, , , , , , , , [[, `(\\d{3})(\\d{4})`, `$1 $2`, [`8`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NZ: [, [, , `[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}`, , , , , , , [5, 6, 7, 8, 9, 10]], [, , `240\\d{5}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}`, , , , `32345678`, , , [8], [7]], [, , `2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}`, , , , `211234567`, , , [8, 9, 10]], [, , `508\\d{6,7}|80\\d{6,8}`, , , , `800123456`, , , [8, 9, 10]], [, , `(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}`, , , , `900123456`, , , [7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , `70\\d{7}`, , , , `701234567`, , , [9]], [, , , , , , , , , [-1]], `NZ`, 64, `0(?:0|161)`, `0`, , , `0`, , `00`, , [[, `(\\d{2})(\\d{3,8})`, `$1 $2`, [`8[1-79]`], `0$1`], [, `(\\d{3})(\\d{2})(\\d{2,3})`, `$1 $2 $3`, [`50[036-8]|8|90`, `50(?:[0367]|88)|8|90`], `0$1`], [, `(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3`, [`24|[346]|7[2-57-9]|9[2-9]`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`2(?:10|74)|[589]`], `0$1`], [, `(\\d{2})(\\d{3,4})(\\d{4})`, `$1 $2 $3`, [`1|2[028]`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3,5})`, `$1 $2 $3`, [`2(?:[169]|7[0-35-9])|7`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}`, , , , `83012378`], , , [, , , , , , , , , [-1]]], OM: [, [, , `(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}`, , , , , , , [7, 8, 9]], [, , `2[1-6]\\d{6}`, , , , `23123456`, , , [8]], [, , `(?:1505|90[1-9]\\d)\\d{4}|(?:7[126-9]|9[1-9])\\d{6}`, , , , `92123456`, , , [8]], [, , `8007\\d{4,5}|(?:500|800[05])\\d{4}`, , , , `80071234`], [, , `900\\d{5}`, , , , `90012345`, , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `OM`, 968, `00`, , , , , , , , [[, `(\\d{3})(\\d{4,6})`, `$1 $2`, [`[58]`]], [, `(\\d{2})(\\d{6})`, `$1 $2`, [`2`]], [, `(\\d{4})(\\d{4})`, `$1 $2`, [`[179]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PA: [, [, , `(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}`, , , , , , , [7, 8, 10, 11]], [, , `(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[07-9]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}`, , , , `2001234`, , , [7]], [, , `(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}`, , , , `61234567`, , , [7, 8]], [, , `800\\d{4,5}|(?:00800|800\\d)\\d{6}`, , , , `8001234`], [, , `(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}`, , , , `8601234`, , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `PA`, 507, `00`, , , , , , , , [[, `(\\d{3})(\\d{4})`, `$1-$2`, [`[1-57-9]`]], [, `(\\d{4})(\\d{4})`, `$1-$2`, [`[68]`]], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`8`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PE: [, [, , `(?:[14-8]|9\\d)\\d{7}`, , , , , , , [8, 9], [6, 7]], [, , `(?:(?:(?:4[34]|5[14])[0-8]|687)\\d|7(?:173|(?:3[0-8]|55)\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[0569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}`, , , , `11234567`, , , [8], [6, 7]], [, , `9\\d{8}`, , , , `912345678`, , , [9]], [, , `800\\d{5}`, , , , `80012345`, , , [8]], [, , `805\\d{5}`, , , , `80512345`, , , [8]], [, , `801\\d{5}`, , , , `80112345`, , , [8]], [, , `80[24]\\d{5}`, , , , `80212345`, , , [8]], [, , , , , , , , , [-1]], `PE`, 51, `00|19(?:1[124]|77|90)00`, `0`, ` Anexo `, , `0`, , `00`, , [[, `(\\d{3})(\\d{5})`, `$1 $2`, [`80`], `(0$1)`], [, `(\\d)(\\d{7})`, `$1 $2`, [`1`], `(0$1)`], [, `(\\d{2})(\\d{6})`, `$1 $2`, [`[4-8]`], `(0$1)`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`9`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PF: [, [, , `4\\d{5}(?:\\d{2})?|8\\d{7,8}`, , , , , , , [6, 8, 9]], [, , `4(?:0[4-689]|9[4-68])\\d{5}`, , , , `40412345`, , , [8]], [, , `8[7-9]\\d{6}`, , , , `87123456`, , , [8]], [, , `80[0-5]\\d{6}`, , , , `800012345`, , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `499\\d{5}`, , , , `49901234`, , , [8]], `PF`, 689, `00`, , , , , , , , [[, `(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3`, [`44`]], [, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`4|8[7-9]`]], [, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`8`]]], , [, , , , , , , , , [-1]], , , [, , `44\\d{4}`, , , , , , , [6]], [, , `44\\d{4}`, , , , `440123`, , , [6]], , , [, , , , , , , , , [-1]]], PG: [, [, , `(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}`, , , , , , , [7, 8]], [, , `(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}`, , , , `3123456`, , , [7]], [, , `(?:7\\d|8[1-38])\\d{6}`, , , , `70123456`, , , [8]], [, , `180\\d{4}`, , , , `1801234`, , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `2(?:0[0-57]|7[568])\\d{4}`, , , , `2751234`, , , [7]], `PG`, 675, `00|140[1-3]`, , , , , , `00`, , [[, `(\\d{3})(\\d{4})`, `$1 $2`, [`18|[2-69]|85`]], [, `(\\d{4})(\\d{4})`, `$1 $2`, [`[78]`]]], , [, , `27[01]\\d{4}`, , , , `2700123`, , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PH: [, [, , `(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}`, , , , , , , [6, 8, 9, 10, 11, 12, 13], [4, 5, 7]], [, , `(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}`, , , , `232345678`, , , [6, 8, 9, 10], [4, 5, 7]], [, , `(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}`, , , , `9051234567`, , , [10]], [, , `1800\\d{7,9}`, , , , `180012345678`, , , [11, 12, 13]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `PH`, 63, `00`, `0`, , , `0`, , , , [[, `(\\d)(\\d{5})`, `$1 $2`, [`2`], `(0$1)`], [, `(\\d{4})(\\d{4,6})`, `$1 $2`, [`3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2`, `3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))`], `(0$1)`], [, `(\\d{5})(\\d{4})`, `$1 $2`, [`346|4(?:27|9[35])|883`, `3469|4(?:279|9(?:30|56))|8834`], `(0$1)`], [, `(\\d)(\\d{4})(\\d{4})`, `$1 $2 $3`, [`2`], `(0$1)`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[3-7]|8[2-8]`], `(0$1)`], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[89]`], `0$1`], [, `(\\d{4})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`1`]], [, `(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})`, `$1 $2 $3 $4`, [`1`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PK: [, [, , `122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}`, , , , , , , [8, 9, 10, 11, 12], [5, 6, 7]], [, , `(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}`, , , , `2123456789`, , , [9, 10], [5, 6, 7, 8]], [, , `3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}`, , , , `3012345678`, , , [10]], [, , `800\\d{5}(?:\\d{3})?`, , , , `80012345`, , , [8, 11]], [, , `900\\d{5}`, , , , `90012345`, , , [8]], [, , , , , , , , , [-1]], [, , `122\\d{6}`, , , , `122044444`, , , [9]], [, , , , , , , , , [-1]], `PK`, 92, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{3})(\\d{2,7})`, `$1 $2 $3`, [`[89]0`], `0$1`], [, `(\\d{4})(\\d{5})`, `$1 $2`, [`1`]], [, `(\\d{3})(\\d{6,7})`, `$1 $2`, [`2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])`, `9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]`], `(0$1)`], [, `(\\d{2})(\\d{7,8})`, `$1 $2`, [`(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]`], `(0$1)`], [, `(\\d{5})(\\d{5})`, `$1 $2`, [`58`], `(0$1)`], [, `(\\d{3})(\\d{7})`, `$1 $2`, [`3`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3 $4`, [`2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91`], `(0$1)`], [, `(\\d{3})(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3 $4`, [`[24-9]`], `(0$1)`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}`, , , , `21111825888`, , , [11, 12]], , , [, , , , , , , , , [-1]]], PL: [, [, , `(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}`, , , , , , , [6, 7, 8, 9, 10]], [, , `47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))`, , , , `123456789`, , , [7, 9]], [, , `21(?:1[013-5]|2\\d|3[4-9])\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}`, , , , `512345678`, , , [9]], [, , `800\\d{6,7}`, , , , `800123456`, , , [9, 10]], [, , `70[01346-8]\\d{6}`, , , , `701234567`, , , [9]], [, , `801\\d{6}`, , , , `801234567`, , , [9]], [, , , , , , , , , [-1]], [, , `39\\d{7}`, , , , `391234567`, , , [9]], `PL`, 48, `00`, , , , , , , , [[, `(\\d{5})`, `$1`, [`19`]], [, `(\\d{3})(\\d{3})`, `$1 $2`, [`11|20|64`]], [, `(\\d{2})(\\d{2})(\\d{3})`, `$1 $2 $3`, [`(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1`, `(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19`]], [, `(\\d{3})(\\d{2})(\\d{2,3})`, `$1 $2 $3`, [`64`]], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)`]], [, `(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`1[2-8]|[2-7]|8[1-79]|9[145]`]], [, `(\\d{3})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`8`]]], , [, , `64\\d{4,7}`, , , , `641234567`, , , [6, 7, 8, 9]], , , [, , , , , , , , , [-1]], [, , `804\\d{6}`, , , , `804123456`, , , [9]], , , [, , , , , , , , , [-1]]], PM: [, [, , `[45]\\d{5}|(?:708|8\\d\\d)\\d{6}`, , , , , , , [6, 9]], [, , `(?:4[1-35-9]|5[0-47-9]|80[6-9]\\d\\d)\\d{4}`, , , , `430123`], [, , `(?:4[02-489]|5[02-9]|708(?:4[0-5]|5[0-6]))\\d{4}`, , , , `551234`], [, , `80[0-5]\\d{6}`, , , , `800012345`, , , [9]], [, , `8[129]\\d{7}`, , , , `810123456`, , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `PM`, 508, `00`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3`, [`[45]`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`7`]], [, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`8`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PR: [, [, , `(?:[589]\\d\\d|787)\\d{7}`, , , , , , , [10], [7]], [, , `(?:787|939)[2-9]\\d{6}`, , , , `7872345678`, , , , [7]], [, , `(?:787|939)[2-9]\\d{6}`, , , , `7872345678`, , , , [7]], [, , `8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`, , , , `8002345678`], [, , `900[2-9]\\d{6}`, , , , `9002345678`], [, , , , , , , , , [-1]], [, , `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}`, , , , `5002345678`], [, , , , , , , , , [-1]], `PR`, 1, `011`, `1`, , , `1`, , , 1, , , [, , , , , , , , , [-1]], , `787|939`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PS: [, [, , `[2489]2\\d{6}|(?:1\\d|5)\\d{8}`, , , , , , , [8, 9, 10], [7]], [, , `(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}`, , , , `22234567`, , , [8], [7]], [, , `5[69]\\d{7}`, , , , `599123456`, , , [9]], [, , `1800\\d{6}`, , , , `1800123456`, , , [10]], [, , , , , , , , , [-1]], [, , `1700\\d{6}`, , , , `1700123456`, , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `PS`, 970, `00`, `0`, , , `0`, , , , [[, `(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[2489]`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`5`], `0$1`], [, `(\\d{4})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`1`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PT: [, [, , `1693\\d{5}|(?:[26-9]\\d|30)\\d{7}`, , , , , , , [9]], [, , `2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}`, , , , `212345678`], [, , `6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}`, , , , `912345678`], [, , `80[02]\\d{6}`, , , , `800123456`], [, , `(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}`, , , , `760123456`], [, , `80(?:8\\d|9[1579])\\d{5}`, , , , `808123456`], [, , `884[0-4689]\\d{5}`, , , , `884123456`], [, , `30\\d{7}`, , , , `301234567`], `PT`, 351, `00`, , , , , , , , [[, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`2[12]`]], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`16|[236-9]`]]], , [, , `6(?:222\\d|8988)\\d{4}`, , , , `622212345`], , , [, , , , , , , , , [-1]], [, , `70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}`, , , , `707123456`], , , [, , `600\\d{6}|6[06]92(?:0\\d|3[349]|49)\\d{3}`, , , , `600110000`]], PW: [, [, , `(?:[24-8]\\d\\d|345|900)\\d{4}`, , , , , , , [7]], [, , `(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}`, , , , `2771234`], [, , `(?:(?:46|83)[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}`, , , , `6201234`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `PW`, 680, `01[12]`, , , , , , , , [[, `(\\d{3})(\\d{4})`, `$1 $2`, [`[2-9]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PY: [, [, , `59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}`, , , , , , , [6, 7, 8, 9, 10, 11], [5]], [, , `(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}`, , , , `212345678`, , , [7, 8, 9], [5, 6]], [, , `9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}`, , , , `961456789`, , , [9]], [, , `9800\\d{5,7}`, , , , `98000123456`, , , [9, 10, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `8700[0-4]\\d{4}`, , , , `870012345`, , , [9]], `PY`, 595, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{3,6})`, `$1 $2`, [`[2-9]0`], `0$1`], [, `(\\d{2})(\\d{5})`, `$1 $2`, [`[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]`], `(0$1)`], [, `(\\d{3})(\\d{4,5})`, `$1 $2`, [`2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85`], `(0$1)`], [, `(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]`], `(0$1)`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`87`]], [, `(\\d{3})(\\d{6})`, `$1 $2`, [`9(?:[5-79]|8[1-7])`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[2-8]`], `0$1`], [, `(\\d{4})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`9`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `[2-9]0\\d{4,7}`, , , , `201234567`, , , [6, 7, 8, 9]], , , [, , , , , , , , , [-1]]], QA: [, [, , `800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}`, , , , , , , [7, 8, 9, 11]], [, , `4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}`, , , , `44123456`, , , [8]], [, , `[35-7]\\d{7}`, , , , `33123456`, , , [8]], [, , `800\\d{4}|(?:0080[01]|800)\\d{6}`, , , , `8001234`, , , [7, 9, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `QA`, 974, `00`, , , , , , , , [[, `(\\d{3})(\\d{4})`, `$1 $2`, [`2[16]|8`]], [, `(\\d{4})(\\d{4})`, `$1 $2`, [`[3-7]`]]], , [, , `2[16]\\d{5}`, , , , `2123456`, , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], RE: [, [, , `709\\d{6}|(?:26|[689]\\d)\\d{7}`, , , , , , , [9]], [, , `26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}`, , , , `262161234`], [, , `(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}`, , , , `692123456`], [, , `80\\d{7}`, , , , `801234567`], [, , `89[1-37-9]\\d{6}`, , , , `891123456`], [, , `8(?:1[019]|2[0156]|84|90)\\d{6}`, , , , `810123456`], [, , , , , , , , , [-1]], [, , `9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}`, , , , `939901234`], `RE`, 262, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[26-9]`], `0$1`]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], RO: [, [, , `(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}`, , , , , , , [6, 9]], [, , `[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d`, , , , `211234567`], [, , `(?:630|702)0\\d{5}|(?:6(?:00|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}`, , , , `712034567`, , , [9]], [, , `800\\d{6}`, , , , `800123456`, , , [9]], [, , `90[0136]\\d{6}`, , , , `900123456`, , , [9]], [, , `801\\d{6}`, , , , `801123456`, , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `RO`, 40, `00`, `0`, ` int `, , `0`, , , , [[, `(\\d{3})(\\d{3})`, `$1 $2`, [`2[3-6]`, `2[3-6]\\d9`], `0$1`], [, `(\\d{2})(\\d{4})`, `$1 $2`, [`219|31`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[23]1`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[236-9]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `(?:37\\d|80[578])\\d{6}`, , , , `372123456`, , , [9]], , , [, , , , , , , , , [-1]]], RS: [, [, , `38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}`, , , , , , , [6, 7, 8, 9, 10, 11, 12], [4, 5]], [, , `(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}`, , , , `10234567`, , , [7, 8, 9, 10, 11, 12], [4, 5, 6]], [, , `6(?:[0-689]|7\\d)\\d{6,7}`, , , , `601234567`, , , [8, 9, 10]], [, , `800\\d{3,9}`, , , , `80012345`], [, , `(?:78\\d|90[0169])\\d{3,7}`, , , , `90012345`, , , [6, 7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `RS`, 381, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{3,9})`, `$1 $2`, [`(?:2[389]|39)0|[7-9]`], `0$1`], [, `(\\d{2})(\\d{5,10})`, `$1 $2`, [`[1-36]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `7[06]\\d{4,10}`, , , , `700123456`], , , [, , , , , , , , , [-1]]], RU: [, [, , `8\\d{13}|[347-9]\\d{9}`, , , , , , , [10, 14], [7]], [, , `(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}`, , , , `3011234567`, , , [10], [7]], [, , `9\\d{9}`, , , , `9123456789`, , , [10]], [, , `8(?:0[04]|108\\d{3})\\d{7}`, , , , `8001234567`], [, , `80[39]\\d{7}`, , , , `8091234567`, , , [10]], [, , , , , , , , , [-1]], [, , `808\\d{7}`, , , , `8081234567`, , , [10]], [, , , , , , , , , [-1]], `RU`, 7, `810`, `8`, , , `8`, , `8~10`, , [[, `(\\d{3})(\\d{2})(\\d{2})`, `$1-$2-$3`, [`[0-79]`]], [, `(\\d{4})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`7(?:1[0-8]|2[1-9])`, `7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))`, `7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2`], `8 ($1)`, , 1], [, `(\\d{5})(\\d)(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`7(?:1[0-68]|2[1-9])`, `7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))`, `7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]`], `8 ($1)`, , 1], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`7`], `8 ($1)`, , 1], [, `(\\d{3})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2-$3-$4`, [`[349]|8(?:[02-7]|1[1-8])`], `8 ($1)`, , 1], [, `(\\d{4})(\\d{4})(\\d{3})(\\d{3})`, `$1 $2 $3 $4`, [`8`], `8 ($1)`]], [[, `(\\d{4})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`7(?:1[0-8]|2[1-9])`, `7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))`, `7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2`], `8 ($1)`, , 1], [, `(\\d{5})(\\d)(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`7(?:1[0-68]|2[1-9])`, `7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))`, `7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]`], `8 ($1)`, , 1], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`7`], `8 ($1)`, , 1], [, `(\\d{3})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2-$3-$4`, [`[349]|8(?:[02-7]|1[1-8])`], `8 ($1)`, , 1], [, `(\\d{4})(\\d{4})(\\d{3})(\\d{3})`, `$1 $2 $3 $4`, [`8`], `8 ($1)`]], [, , , , , , , , , [-1]], 1, `3[04-689]|[489]`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], RW: [, [, , `(?:06|[27]\\d\\d|[89]00)\\d{6}`, , , , , , , [8, 9]], [, , `(?:06|2[23568]\\d)\\d{6}`, , , , `250123456`], [, , `7[237-9]\\d{7}`, , , , `720123456`, , , [9]], [, , `800\\d{6}`, , , , `800123456`, , , [9]], [, , `900\\d{6}`, , , , `900123456`, , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `RW`, 250, `00`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`0`]], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`2`]], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[7-9]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SA: [, [, , `92\\d{7}|(?:[15]|8\\d)\\d{8}`, , , , , , , [9, 10], [7]], [, , `1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}`, , , , `112345678`, , , [9], [7]], [, , `579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}`, , , , `512345678`, , , [9]], [, , `800\\d{7}`, , , , `8001234567`, , , [10]], [, , `925\\d{6}`, , , , `925012345`, , , [9]], [, , `920\\d{6}`, , , , `920012345`, , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `SA`, 966, `00`, `0`, , , `0`, , , , [[, `(\\d{4})(\\d{5})`, `$1 $2`, [`9`]], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`1`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`5`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`81`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`8`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `811\\d{7}`, , , , `8110123456`, , , [10]], , , [, , , , , , , , , [-1]]], SB: [, [, , `[6-9]\\d{6}|[1-6]\\d{4}`, , , , , , , [5, 7]], [, , `(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}`, , , , `40123`, , , [5]], [, , `48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}`, , , , `7421234`], [, , `1[38]\\d{3}`, , , , `18123`, , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `5[12]\\d{3}`, , , , `51123`, , , [5]], `SB`, 677, `0[01]`, , , , , , , , [[, `(\\d{2})(\\d{5})`, `$1 $2`, [`6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SC: [, [, , `(?:[2489]\\d|64)\\d{5}`, , , , , , , [7]], [, , `4[2-46]\\d{5}`, , , , `4217123`], [, , `2[125-8]\\d{5}`, , , , `2510123`], [, , `800[08]\\d{3}`, , , , `8000000`], [, , `85\\d{5}`, , , , `8512345`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `971\\d{4}|(?:64|95)\\d{5}`, , , , `6412345`], `SC`, 248, `010|0[0-2]`, , , , , , `00`, , [[, `(\\d)(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[246]|9[57]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SD: [, [, , `[19]\\d{8}`, , , , , , , [9]], [, , `1(?:5\\d|8[35-7])\\d{6}`, , , , `153123456`], [, , `(?:1[0-2]|9[0-3569])\\d{7}`, , , , `911231234`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `SD`, 249, `00`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[19]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SE: [, [, , `(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}`, , , , , , , [6, 7, 8, 9, 10, 12]], [, , `(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}`, , , , `8123456`, , , [7, 8, 9]], [, , `7[02369]\\d{7}`, , , , `701234567`, , , [9]], [, , `20\\d{4,7}`, , , , `20123456`, , , [6, 7, 8, 9]], [, , `649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}`, , , , `9001234567`, , , [7, 8, 9, 10]], [, , `77[0-7]\\d{6}`, , , , `771234567`, , , [9]], [, , `75[1-8]\\d{6}`, , , , `751234567`, , , [9]], [, , , , , , , , , [-1]], `SE`, 46, `00`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{2,3})(\\d{2})`, `$1-$2 $3`, [`20`], `0$1`], [, `(\\d{3})(\\d{4})`, `$1-$2`, [`9(?:00|39|44|9)`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{2})`, `$1-$2 $3`, [`[12][136]|3[356]|4[0246]|6[03]|90[1-9]`], `0$1`], [, `(\\d)(\\d{2,3})(\\d{2})(\\d{2})`, `$1-$2 $3 $4`, [`8`], `0$1`], [, `(\\d{3})(\\d{2,3})(\\d{2})`, `$1-$2 $3`, [`1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])`], `0$1`], [, `(\\d{3})(\\d{2,3})(\\d{3})`, `$1-$2 $3`, [`9(?:00|39|44)`], `0$1`], [, `(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})`, `$1-$2 $3 $4`, [`1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1-$2 $3 $4`, [`10|7`], `0$1`], [, `(\\d)(\\d{3})(\\d{3})(\\d{2})`, `$1-$2 $3 $4`, [`8`], `0$1`], [, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1-$2 $3 $4`, [`[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])`], `0$1`], [, `(\\d{3})(\\d{2})(\\d{2})(\\d{3})`, `$1-$2 $3 $4`, [`9`], `0$1`], [, `(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1-$2 $3 $4 $5`, [`[26]`], `0$1`]], [[, `(\\d{2})(\\d{2,3})(\\d{2})`, `$1 $2 $3`, [`20`]], [, `(\\d{3})(\\d{4})`, `$1 $2`, [`9(?:00|39|44|9)`]], [, `(\\d{2})(\\d{3})(\\d{2})`, `$1 $2 $3`, [`[12][136]|3[356]|4[0246]|6[03]|90[1-9]`]], [, `(\\d)(\\d{2,3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`8`]], [, `(\\d{3})(\\d{2,3})(\\d{2})`, `$1 $2 $3`, [`1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])`]], [, `(\\d{3})(\\d{2,3})(\\d{3})`, `$1 $2 $3`, [`9(?:00|39|44)`]], [, `(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]`]], [, `(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`10|7`]], [, `(\\d)(\\d{3})(\\d{3})(\\d{2})`, `$1 $2 $3 $4`, [`8`]], [, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])`]], [, `(\\d{3})(\\d{2})(\\d{2})(\\d{3})`, `$1 $2 $3 $4`, [`9`]], [, `(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4 $5`, [`[26]`]]], [, , `74[02-9]\\d{6}`, , , , `740123456`, , , [9]], , , [, , , , , , , , , [-1]], [, , `10[1-8]\\d{6}`, , , , `102345678`, , , [9]], , , [, , `(?:25[245]|67[3-68])\\d{9}`, , , , `254123456789`, , , [12]]], SG: [, [, , `(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}`, , , , , , , [8, 10, 11]], [, , `662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}`, , , , `61234567`, , , [8]], [, , `896[0-4]\\d{4}|(?:8(?:0[1-9]|[1-8]\\d|9[0-5])|9[0-8]\\d)\\d{5}`, , , , `81234567`, , , [8]], [, , `(?:18|8)00\\d{7}`, , , , `18001234567`, , , [10, 11]], [, , `1900\\d{7}`, , , , `19001234567`, , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `(?:3[12]\\d|666)\\d{5}`, , , , `31234567`, , , [8]], `SG`, 65, `0[0-3]\\d`, , , , , , , , [[, `(\\d{4,5})`, `$1`, [`1[013-9]|77`, `1(?:[013-8]|9(?:0[1-9]|[1-9]))|77`]], [, `(\\d{4})(\\d{4})`, `$1 $2`, [`[369]|8(?:0[1-9]|[1-9])`]], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`8`]], [, `(\\d{4})(\\d{4})(\\d{3})`, `$1 $2 $3`, [`7`]], [, `(\\d{4})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`1`]]], [[, `(\\d{4})(\\d{4})`, `$1 $2`, [`[369]|8(?:0[1-9]|[1-9])`]], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`8`]], [, `(\\d{4})(\\d{4})(\\d{3})`, `$1 $2 $3`, [`7`]], [, `(\\d{4})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`1`]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `7000\\d{7}`, , , , `70001234567`, , , [11]], , , [, , , , , , , , , [-1]]], SH: [, [, , `(?:[256]\\d|8)\\d{3}`, , , , , , , [4, 5]], [, , `2(?:[0-57-9]\\d|6[4-9])\\d\\d`, , , , `22158`], [, , `[56]\\d{4}`, , , , `51234`, , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `262\\d\\d`, , , , `26212`, , , [5]], `SH`, 290, `00`, , , , , , , , , , [, , , , , , , , , [-1]], 1, `[256]`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SI: [, [, , `[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}`, , , , , , , [5, 6, 7, 8]], [, , `(?:[1-357][2-8]|4[24-8])\\d{6}`, , , , `12345678`, , , [8], [7]], [, , `65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}`, , , , `31234567`, , , [8]], [, , `80\\d{4,6}`, , , , `80123456`, , , [6, 7, 8]], [, , `89[1-3]\\d{2,5}|90\\d{4,6}`, , , , `90123456`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}`, , , , `59012345`, , , [8]], `SI`, 386, `00|10(?:22|66|88|99)`, `0`, , , `0`, , `00`, , [[, `(\\d{2})(\\d{3,6})`, `$1 $2`, [`8[09]|9`], `0$1`], [, `(\\d{3})(\\d{5})`, `$1 $2`, [`59|8`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[37][01]|4[0139]|51|6`], `0$1`], [, `(\\d)(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[1-57]`], `(0$1)`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SJ: [, [, , `0\\d{4}|(?:[489]\\d|79)\\d{6}`, , , , , , , [5, 8]], [, , `79\\d{6}`, , , , `79123456`, , , [8]], [, , `(?:4[015-8]|9\\d)\\d{6}`, , , , `41234567`, , , [8]], [, , `80[01]\\d{5}`, , , , `80012345`, , , [8]], [, , `82[09]\\d{5}`, , , , `82012345`, , , [8]], [, , `810(?:0[0-6]|[2-8]\\d)\\d{3}`, , , , `81021234`, , , [8]], [, , `880\\d{5}`, , , , `88012345`, , , [8]], [, , `85[0-5]\\d{5}`, , , , `85012345`, , , [8]], `SJ`, 47, `00`, , , , , , , , , , [, , , , , , , , , [-1]], , `79`, [, , , , , , , , , [-1]], [, , `(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}`, , , , `02000`], , , [, , `81[23]\\d{5}`, , , , `81212345`, , , [8]]], SK: [, [, , `[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}`, , , , , , , [6, 7, 9]], [, , `(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d`, , , , `221234567`], [, , `909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}`, , , , `912123456`, , , [9]], [, , `800\\d{6}`, , , , `800123456`, , , [9]], [, , `9(?:00|[78]\\d)\\d{6}`, , , , `900123456`, , , [9]], [, , `8[5-9]\\d{7}`, , , , `850123456`, , , [9]], [, , , , , , , , , [-1]], [, , `6(?:02|5[0-4]|9[0-6])\\d{6}`, , , , `690123456`, , , [9]], `SK`, 421, `00`, `0`, , , `0`, , , , [[, `(\\d)(\\d{2})(\\d{3,4})`, `$1 $2 $3`, [`21`], `0$1`], [, `(\\d{2})(\\d{2})(\\d{2,3})`, `$1 $2 $3`, [`[3-5][1-8]1`, `[3-5][1-8]1[67]`], `0$1`], [, `(\\d{4})(\\d{3})`, `$1 $2`, [`909`, `9090`], `0$1`], [, `(\\d)(\\d{3})(\\d{3})(\\d{2})`, `$1/$2 $3 $4`, [`2`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[689]`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1/$2 $3 $4`, [`[3-5]`], `0$1`]], [[, `(\\d)(\\d{2})(\\d{3,4})`, `$1 $2 $3`, [`21`], `0$1`], [, `(\\d{2})(\\d{2})(\\d{2,3})`, `$1 $2 $3`, [`[3-5][1-8]1`, `[3-5][1-8]1[67]`], `0$1`], [, `(\\d)(\\d{3})(\\d{3})(\\d{2})`, `$1/$2 $3 $4`, [`2`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[689]`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1/$2 $3 $4`, [`[3-5]`], `0$1`]], [, , `9090\\d{3}`, , , , `9090123`, , , [7]], , , [, , `9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}`, , , , , , , [7, 9]], [, , `96\\d{7}`, , , , `961234567`, , , [9]], , , [, , , , , , , , , [-1]]], SL: [, [, , `(?:[237-9]\\d|66)\\d{6}`, , , , , , , [8], [6]], [, , `22[2-4][2-9]\\d{4}`, , , , `22221234`, , , , [6]], [, , `(?:25|3[0-5]|66|7[2-9]|8[08]|9[09])\\d{6}`, , , , `25123456`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `SL`, 232, `00`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{6})`, `$1 $2`, [`[236-9]`], `(0$1)`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SM: [, [, , `(?:0549|[5-7]\\d)\\d{6}`, , , , , , , [8, 10], [6]], [, , `0549(?:8[0157-9]|9\\d)\\d{4}`, , , , `0549886377`, , , [10], [6]], [, , `6[16]\\d{6}`, , , , `66661212`, , , [8]], [, , , , , , , , , [-1]], [, , `7[178]\\d{6}`, , , , `71123456`, , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `5[158]\\d{6}`, , , , `58001110`, , , [8]], `SM`, 378, `00`, , , , `([89]\\d{5})$`, `0549$1`, , , [[, `(\\d{6})`, `$1`, [`[89]`]], [, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[5-7]`]], [, `(\\d{4})(\\d{6})`, `$1 $2`, [`0`]]], [[, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[5-7]`]], [, `(\\d{4})(\\d{6})`, `$1 $2`, [`0`]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SN: [, [, , `(?:[378]\\d|93)\\d{7}`, , , , , , , [9]], [, , `3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}`, , , , `301012345`], [, , `7(?:(?:[06-8]\\d|[19]0|21)\\d|5(?:0[01]|[19]0|2[25]|3[36]|[4-7]\\d|8[35]))\\d{5}`, , , , `701234567`], [, , `800\\d{6}`, , , , `800123456`], [, , `88[4689]\\d{6}`, , , , `884123456`], [, , `81[02468]\\d{6}`, , , , `810123456`], [, , , , , , , , , [-1]], [, , `(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}`, , , , `933301234`], `SN`, 221, `00`, , , , , , , , [[, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`8`]], [, `(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[379]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SO: [, [, , `[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}`, , , , , , , [6, 7, 8, 9]], [, , `(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}`, , , , `4012345`, , , [6, 7]], [, , `(?:(?:15|(?:3[59]|4[89]|6\\d|7[79]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}`, , , , `71123456`, , , [7, 8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `SO`, 252, `00`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{4})`, `$1 $2`, [`8[125]`]], [, `(\\d{6})`, `$1`, [`[134]`]], [, `(\\d)(\\d{6})`, `$1 $2`, [`[15]|2[0-79]|3[0-46-8]|4[0-7]`]], [, `(\\d)(\\d{7})`, `$1 $2`, [`(?:2|90)4|[67]`]], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[348]|64|79|90`]], [, `(\\d{2})(\\d{5,7})`, `$1 $2`, [`1|28|6[0-35-9]|77|9[2-9]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SR: [, [, , `(?:[2-5]|68|[78]\\d)\\d{5}`, , , , , , , [6, 7]], [, , `(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}`, , , , `211234`], [, , `(?:7[124-7]|8[124-9])\\d{5}`, , , , `7412345`, , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `56\\d{4}`, , , , `561234`, , , [6]], `SR`, 597, `00`, , , , , , , , [[, `(\\d{2})(\\d{2})(\\d{2})`, `$1-$2-$3`, [`56`]], [, `(\\d{3})(\\d{3})`, `$1-$2`, [`[2-5]`]], [, `(\\d{3})(\\d{4})`, `$1-$2`, [`[6-8]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SS: [, [, , `[19]\\d{8}`, , , , , , , [9]], [, , `1[89]\\d{7}`, , , , `181234567`], [, , `(?:12|9[1257-9])\\d{7}`, , , , `977123456`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `SS`, 211, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[19]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ST: [, [, , `(?:22|9\\d)\\d{5}`, , , , , , , [7]], [, , `22\\d{5}`, , , , `2221234`], [, , `900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}`, , , , `9812345`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `ST`, 239, `00`, , , , , , , , [[, `(\\d{3})(\\d{4})`, `$1 $2`, [`[29]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SV: [, [, , `[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?`, , , , , , , [7, 8, 11]], [, , `2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}`, , , , `21234567`, , , [8]], [, , `[67]\\d{7}`, , , , `70123456`, , , [8]], [, , `800\\d{8}|80[01]\\d{4}`, , , , `8001234`, , , [7, 11]], [, , `900\\d{4}(?:\\d{4})?`, , , , `9001234`, , , [7, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `SV`, 503, `00`, , , , , , , , [[, `(\\d{3})(\\d{4})`, `$1 $2`, [`[89]`]], [, `(\\d{4})(\\d{4})`, `$1 $2`, [`[267]`]], [, `(\\d{3})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`[89]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SX: [, [, , `7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}`, , , , , , , [10], [7]], [, , `7215(?:4[2-8]|8[239]|9[056])\\d{4}`, , , , `7215425678`, , , , [7]], [, , `7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}`, , , , `7215205678`, , , , [7]], [, , `8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`, , , , `8002123456`], [, , `900[2-9]\\d{6}`, , , , `9002123456`], [, , , , , , , , , [-1]], [, , `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}`, , , , `5002345678`], [, , , , , , , , , [-1]], `SX`, 1, `011`, `1`, , , `(5\\d{6})$|1`, `721$1`, , , , , [, , , , , , , , , [-1]], , `721`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SY: [, [, , `[1-359]\\d{8}|[1-5]\\d{7}`, , , , , , , [8, 9], [6, 7]], [, , `21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}`, , , , `112345678`, , , , [6, 7]], [, , `(?:50|9[1-689])\\d{7}`, , , , `944567890`, , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `SY`, 963, `00`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[1-4]|5[1-3]`], `0$1`, , 1], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[59]`], `0$1`, , 1]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SZ: [, [, , `0800\\d{4}|(?:[237]\\d|900)\\d{6}`, , , , , , , [8, 9]], [, , `[23][2-5]\\d{6}`, , , , `22171234`, , , [8]], [, , `7[6-9]\\d{6}`, , , , `76123456`, , , [8]], [, , `0800\\d{4}`, , , , `08001234`, , , [8]], [, , `900\\d{6}`, , , , `900012345`, , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `70\\d{6}`, , , , `70012345`, , , [8]], `SZ`, 268, `00`, , , , , , , , [[, `(\\d{4})(\\d{4})`, `$1 $2`, [`[0237]`]], [, `(\\d{5})(\\d{4})`, `$1 $2`, [`9`]]], , [, , , , , , , , , [-1]], , , [, , `0800\\d{4}`, , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TA: [, [, , `8\\d{3}`, , , , , , , [4]], [, , `8\\d{3}`, , , , `8999`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `TA`, 290, `00`, , , , , , , , , , [, , , , , , , , , [-1]], , `8`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TC: [, [, , `(?:[58]\\d\\d|649|900)\\d{7}`, , , , , , , [10], [7]], [, , `649(?:266|712|9(?:4\\d|50))\\d{4}`, , , , `6497121234`, , , , [7]], [, , `649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}`, , , , `6492311234`, , , , [7]], [, , `8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`, , , , `8002345678`], [, , `900[2-9]\\d{6}`, , , , `9002345678`], [, , , , , , , , , [-1]], [, , `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}`, , , , `5002345678`], [, , `649(?:71[01]|966)\\d{4}`, , , , `6497101234`, , , , [7]], `TC`, 1, `011`, `1`, , , `([2-479]\\d{6})$|1`, `649$1`, , , , , [, , , , , , , , , [-1]], , `649`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TD: [, [, , `(?:22|[689]\\d|77)\\d{6}`, , , , , , , [8]], [, , `22(?:[37-9]0|5[0-5]|6[89])\\d{4}`, , , , `22501234`], [, , `(?:[69]\\d|77|8[56])\\d{6}`, , , , `63012345`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `TD`, 235, `00|16`, , , , , , `00`, , [[, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[26-9]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TG: [, [, , `[279]\\d{7}`, , , , , , , [8]], [, , `2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}`, , , , `22212345`], [, , `(?:7[0-29]|9[0-36-9])\\d{6}`, , , , `90112345`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `TG`, 228, `00`, , , , , , , , [[, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[279]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TH: [, [, , `(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}`, , , , , , , [8, 9, 10, 13]], [, , `(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}`, , , , `21234567`, , , [8]], [, , `67(?:1[0-8]|2[4-7])\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}`, , , , `812345678`, , , [9]], [, , `(?:001800\\d|1800)\\d{6}`, , , , `1800123456`, , , [10, 13]], [, , `1900\\d{6}`, , , , `1900123456`, , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `6[08]\\d{7}`, , , , `601234567`, , , [9]], `TH`, 66, `00[1-9]`, `0`, , , `0`, , , , [[, `(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3`, [`2`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[13-9]`], `0$1`], [, `(\\d{4})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`1`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TJ: [, [, , `[0-57-9]\\d{8}`, , , , , , , [9], [3, 5, 6, 7]], [, , `(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}`, , , , `372123456`, , , , [3, 5, 6, 7]], [, , `(?:33[03-9]|4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:[09]\\d|1[0178]|2[02]|[34]0|5[05]|7[01578]|8[078])\\d{7}`, , , , `917123456`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `TJ`, 992, `810`, , , , , , `8~10`, , [[, `(\\d{6})(\\d)(\\d{2})`, `$1 $2 $3`, [`331`, `3317`]], [, `(\\d{3})(\\d{2})(\\d{4})`, `$1 $2 $3`, [`44[02-479]|[34]7`]], [, `(\\d{4})(\\d)(\\d{4})`, `$1 $2 $3`, [`3(?:[1245]|3[12])`]], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[0-57-9]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TK: [, [, , `[2-47]\\d{3,6}`, , , , , , , [4, 5, 6, 7]], [, , `(?:2[2-4]|[34]\\d)\\d{2,5}`, , , , `3101`], [, , `7[2-4]\\d{2,5}`, , , , `7290`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `TK`, 690, `00`, , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TL: [, [, , `7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}`, , , , , , , [7, 8]], [, , `(?:2[1-5]|3[1-9]|4[1-4])\\d{5}`, , , , `2112345`, , , [7]], [, , `7[2-8]\\d{6}`, , , , `77212345`, , , [8]], [, , `80\\d{5}`, , , , `8012345`, , , [7]], [, , `90\\d{5}`, , , , `9012345`, , , [7]], [, , , , , , , , , [-1]], [, , `70\\d{5}`, , , , `7012345`, , , [7]], [, , , , , , , , , [-1]], `TL`, 670, `00`, , , , , , , , [[, `(\\d{3})(\\d{4})`, `$1 $2`, [`[2-489]|70`]], [, `(\\d{4})(\\d{4})`, `$1 $2`, [`7`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TM: [, [, , `(?:[1-6]\\d|71)\\d{6}`, , , , , , , [8]], [, , `(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}`, , , , `12345678`], [, , `(?:6\\d|71)\\d{6}`, , , , `66123456`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `TM`, 993, `810`, `8`, , , `8`, , `8~10`, , [[, `(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2-$3-$4`, [`12`], `(8 $1)`], [, `(\\d{3})(\\d)(\\d{2})(\\d{2})`, `$1 $2-$3-$4`, [`[1-5]`], `(8 $1)`], [, `(\\d{2})(\\d{6})`, `$1 $2`, [`[67]`], `8 $1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TN: [, [, , `[2-57-9]\\d{7}`, , , , , , , [8]], [, , `81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}`, , , , `30010123`], [, , `3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}`, , , , `20123456`], [, , `8010\\d{4}`, , , , `80101234`], [, , `88\\d{6}`, , , , `88123456`], [, , `8[12]10\\d{4}`, , , , `81101234`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `TN`, 216, `00`, , , , , , , , [[, `(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[2-57-9]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TO: [, [, , `(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}`, , , , , , , [5, 7]], [, , `(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}`, , , , `20123`, , , [5]], [, , `(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}`, , , , `7715123`, , , [7]], [, , `0800\\d{3}`, , , , `0800222`, , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `55[0-37-9]\\d{4}`, , , , `5510123`, , , [7]], `TO`, 676, `00`, , , , , , , , [[, `(\\d{2})(\\d{3})`, `$1-$2`, [`[2-4]|50|6[09]|7[0-24-69]|8[05]`]], [, `(\\d{4})(\\d{3})`, `$1 $2`, [`0`]], [, `(\\d{3})(\\d{4})`, `$1 $2`, [`[5-9]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TR: [, [, , `4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}`, , , , , , , [7, 10, 12, 13]], [, , `(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}`, , , , `2123456789`, , , [10]], [, , `561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}`, , , , `5012345678`, , , [10]], [, , `8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})`, , , , `8001234567`, , , [10, 12, 13]], [, , `(?:8[89]8|900)\\d{7}`, , , , `9001234567`, , , [10]], [, , , , , , , , , [-1]], [, , `592(?:21[12]|461)\\d{4}`, , , , `5922121234`, , , [10]], [, , `850\\d{7}`, , , , `8500123456`, , , [10]], `TR`, 90, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d)(\\d{3})`, `$1 $2 $3`, [`444`], , , 1], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`512|8[01589]|90`], `0$1`, , 1], [, `(\\d{3})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`5(?:[0-59]|61)`, `5(?:[0-59]|61[06])`, `5(?:[0-59]|61[06]1)`], `0$1`, , 1], [, `(\\d{3})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[24][1-8]|3[1-9]`], `(0$1)`, , 1], [, `(\\d{3})(\\d{3})(\\d{6,7})`, `$1 $2 $3`, [`80`], `0$1`, , 1]], [[, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`512|8[01589]|90`], `0$1`, , 1], [, `(\\d{3})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`5(?:[0-59]|61)`, `5(?:[0-59]|61[06])`, `5(?:[0-59]|61[06]1)`], `0$1`, , 1], [, `(\\d{3})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[24][1-8]|3[1-9]`], `(0$1)`, , 1], [, `(\\d{3})(\\d{3})(\\d{6,7})`, `$1 $2 $3`, [`80`], `0$1`, , 1]], [, , `512\\d{7}`, , , , `5123456789`, , , [10]], , , [, , `(?:444|811\\d{3})\\d{4}`, , , , , , , [7, 10]], [, , `444\\d{4}`, , , , `4441444`, , , [7]], , , [, , , , , , , , , [-1]]], TT: [, [, , `(?:[58]\\d\\d|900)\\d{7}`, , , , , , , [10], [7]], [, , `868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}`, , , , `8682211234`, , , , [7]], [, , `868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}`, , , , `8682911234`, , , , [7]], [, , `8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`, , , , `8002345678`], [, , `900[2-9]\\d{6}`, , , , `9002345678`], [, , , , , , , , , [-1]], [, , `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}`, , , , `5002345678`], [, , , , , , , , , [-1]], `TT`, 1, `011`, `1`, , , `([2-46-8]\\d{6})$|1`, `868$1`, , , , , [, , , , , , , , , [-1]], , `868`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , `868619\\d{4}`, , , , `8686191234`, , , , [7]]], TV: [, [, , `(?:2|7\\d\\d|90)\\d{4}`, , , , , , , [5, 6, 7]], [, , `2[02-9]\\d{3}`, , , , `20123`, , , [5]], [, , `(?:7[01]\\d|90)\\d{4}`, , , , `901234`, , , [6, 7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `TV`, 688, `00`, , , , , , , , [[, `(\\d{2})(\\d{3})`, `$1 $2`, [`2`]], [, `(\\d{2})(\\d{4})`, `$1 $2`, [`90`]], [, `(\\d{2})(\\d{5})`, `$1 $2`, [`7`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TW: [, [, , `[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}`, , , , , , , [7, 8, 9, 10, 11]], [, , `(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}`, , , , `221234567`, , , [8, 9]], [, , `(?:40001[0-2]|9[0-8]\\d{4})\\d{3}`, , , , `912345678`, , , [9]], [, , `80[0-79]\\d{6}|800\\d{5}`, , , , `800123456`, , , [8, 9]], [, , `20(?:[013-9]\\d\\d|2)\\d{4}`, , , , `203123456`, , , [7, 9]], [, , , , , , , , , [-1]], [, , `99\\d{7}`, , , , `990123456`, , , [9]], [, , `7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}`, , , , `7012345678`, , , [10, 11]], `TW`, 886, `0(?:0[25-79]|19)`, `0`, `#`, , `0`, , , , [[, `(\\d{2})(\\d)(\\d{4})`, `$1 $2 $3`, [`202`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[258]0`], `0$1`], [, `(\\d)(\\d{3,4})(\\d{4})`, `$1 $2 $3`, [`[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]`, `[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[49]`], `0$1`], [, `(\\d{2})(\\d{4})(\\d{4,5})`, `$1 $2 $3`, [`7`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `50[0-46-9]\\d{6}`, , , , `500123456`, , , [9]], , , [, , , , , , , , , [-1]]], TZ: [, [, , `(?:[25-8]\\d|41|90)\\d{7}`, , , , , , , [9]], [, , `2[2-8]\\d{7}`, , , , `222345678`], [, , `(?:6[125-9]|7[13-9])\\d{7}`, , , , `621234567`], [, , `80[08]\\d{6}`, , , , `800123456`], [, , `90\\d{7}`, , , , `900123456`], [, , `8(?:40|6[01])\\d{6}`, , , , `840123456`], [, , , , , , , , , [-1]], [, , `41\\d{7}`, , , , `412345678`], `TZ`, 255, `00[056]`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{2})(\\d{4})`, `$1 $2 $3`, [`[89]`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[24]`], `0$1`], [, `(\\d{2})(\\d{7})`, `$1 $2`, [`5`]], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[67]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , `(?:8(?:[04]0|6[01])|90\\d)\\d{6}`], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], UA: [, [, , `[89]\\d{9}|[3-9]\\d{8}`, , , , , , , [9, 10], [5, 6, 7]], [, , `(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}`, , , , `311234567`, , , [9], [5, 6, 7]], [, , `790\\d{6}|(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}`, , , , `501234567`, , , [9]], [, , `800[1-8]\\d{5,6}`, , , , `800123456`], [, , `900[239]\\d{5,6}`, , , , `900212345`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `89[1-579]\\d{6}`, , , , `891234567`, , , [9]], `UA`, 380, `00`, `0`, , , `0`, , `0~0`, , [[, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]`, `6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]`], `0$1`], [, `(\\d{4})(\\d{5})`, `$1 $2`, [`3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])`, `3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[3-7]|89|9[1-9]`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[89]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], UG: [, [, , `800\\d{6}|(?:[29]0|[347]\\d)\\d{7}`, , , , , , , [9], [5, 6, 7]], [, , `20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|3[1-4]|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}`, , , , `312345678`, , , , [5, 6, 7]], [, , `72[48]0\\d{5}|7(?:[015-8]\\d|2[067]|36|4[0-6]|9[89])\\d{6}`, , , , `712345678`], [, , `800[1-3]\\d{5}`, , , , `800123456`], [, , `90[1-3]\\d{6}`, , , , `901123456`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `UG`, 256, `00[057]`, `0`, , , `0`, , , , [[, `(\\d{4})(\\d{5})`, `$1 $2`, [`202`, `2024`], `0$1`], [, `(\\d{3})(\\d{6})`, `$1 $2`, [`[27-9]|4(?:6[45]|[7-9])`], `0$1`], [, `(\\d{2})(\\d{7})`, `$1 $2`, [`[34]`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], US: [, [, , `[2-9]\\d{9}|3\\d{6}`, , , , , , , [10], [7]], [, , `(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}`, , , , `2015550123`, , , , [7]], [, , `(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}`, , , , `2015550123`, , , , [7]], [, , `8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`, , , , `8002345678`], [, , `900[2-9]\\d{6}`, , , , `9002345678`], [, , , , , , , , , [-1]], [, , `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}`, , , , `5002345678`], [, , `305209\\d{4}`, , , , `3052090123`, , , , [7]], `US`, 1, `011`, `1`, , , `1`, , , 1, [[, `(\\d{3})(\\d{4})`, `$1-$2`, [`310`], , , 1], [, `(\\d{3})(\\d{4})`, `$1-$2`, [`[24-9]|3(?:[02-9]|1[1-9])`]], [, `(\\d{3})(\\d{3})(\\d{4})`, `($1) $2-$3`, [`[2-9]`], , , 1]], [[, `(\\d{3})(\\d{4})`, `$1-$2`, [`310`], , , 1], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1-$2-$3`, [`[2-9]`]]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], UY: [, [, , `0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}`, , , , , , , [6, 7, 8, 9, 10, 11, 12, 13]], [, , `(?:1(?:770|9(?:20|[89]7))|(?:2\\d|4[2-7])\\d\\d)\\d{4}`, , , , `21231234`, , , [8], [7]], [, , `9[1-9]\\d{6}`, , , , `94231234`, , , [8]], [, , `0004\\d{2,9}|(?:405|80[05])\\d{4}`, , , , `8001234`], [, , `90[0-8]\\d{4}`, , , , `9001234`, , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `UY`, 598, `0(?:0|1[3-9]\\d)`, `0`, ` int. `, , `0`, , `00`, , [[, `(\\d{3})(\\d{3,4})`, `$1 $2`, [`0`]], [, `(\\d{3})(\\d{4})`, `$1 $2`, [`[49]0|8`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`9`], `0$1`], [, `(\\d{4})(\\d{4})`, `$1 $2`, [`[124]`]], [, `(\\d{3})(\\d{3})(\\d{2,4})`, `$1 $2 $3`, [`0`]], [, `(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})`, `$1 $2 $3 $4`, [`0`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], UZ: [, [, , `(?:20|33|[5-79]\\d|88)\\d{7}`, , , , , , , [9]], [, , `(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|[69]\\d\\d|7(?:[23]\\d|7[69]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|[68]\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}`, , , , `669050123`], [, , `(?:(?:[25]0|33|88|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079])))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}`, , , , `912345678`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `UZ`, 998, `00`, , , , , , , , [[, `(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[235-9]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], VA: [, [, , `0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}`, , , , , , , [6, 7, 8, 9, 10, 11, 12]], [, , `06698\\d{1,6}`, , , , `0669812345`, , , [6, 7, 8, 9, 10, 11]], [, , `3[1-9]\\d{8}|3[2-9]\\d{7}`, , , , `3123456789`, , , [9, 10]], [, , `80(?:0\\d{3}|3)\\d{3}`, , , , `800123456`, , , [6, 9]], [, , `(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}`, , , , `899123456`, , , [6, 8, 9, 10]], [, , `84(?:[08]\\d{3}|[17])\\d{3}`, , , , `848123456`, , , [6, 9]], [, , `1(?:78\\d|99)\\d{6}`, , , , `1781234567`, , , [9, 10]], [, , `55\\d{8}`, , , , `5512345678`, , , [10]], `VA`, 39, `00`, , , , , , , , , , [, , , , , , , , , [-1]], , `06698`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , `3[2-8]\\d{9,10}`, , , , `33101234501`, , , [11, 12]]], VC: [, [, , `(?:[58]\\d\\d|784|900)\\d{7}`, , , , , , , [10], [7]], [, , `784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}`, , , , `7842661234`, , , , [7]], [, , `784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}`, , , , `7844301234`, , , , [7]], [, , `8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`, , , , `8002345678`], [, , `900[2-9]\\d{6}`, , , , `9002345678`], [, , , , , , , , , [-1]], [, , `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}`, , , , `5002345678`], [, , `78451[0-2]\\d{4}`, , , , `7845101234`, , , , [7]], `VC`, 1, `011`, `1`, , , `([2-7]\\d{6})$|1`, `784$1`, , , , , [, , , , , , , , , [-1]], , `784`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], VE: [, [, , `[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}`, , , , , , , [10], [7]], [, , `(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}`, , , , `2121234567`, , , , [7]], [, , `4(?:1[24-8]|2[46])\\d{7}`, , , , `4121234567`], [, , `800\\d{7}`, , , , `8001234567`], [, , `90[01]\\d{7}`, , , , `9001234567`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `VE`, 58, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{7})`, `$1-$2`, [`[24-689]`], `0$1`, `$CC $1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `501\\d{7}`, , , , `5010123456`, , , , [7]], , , [, , , , , , , , , [-1]]], VG: [, [, , `(?:284|[58]\\d\\d|900)\\d{7}`, , , , , , , [10], [7]], [, , `284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}`, , , , `2842291234`, , , , [7]], [, , `284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}`, , , , `2843001234`, , , , [7]], [, , `8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`, , , , `8002345678`], [, , `900[2-9]\\d{6}`, , , , `9002345678`], [, , , , , , , , , [-1]], [, , `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}`, , , , `5002345678`], [, , , , , , , , , [-1]], `VG`, 1, `011`, `1`, , , `([2-578]\\d{6})$|1`, `284$1`, , , , , [, , , , , , , , , [-1]], , `284`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], VI: [, [, , `[58]\\d{9}|(?:34|90)0\\d{7}`, , , , , , , [10], [7]], [, , `340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}`, , , , `3406421234`, , , , [7]], [, , `340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}`, , , , `3406421234`, , , , [7]], [, , `8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`, , , , `8002345678`], [, , `900[2-9]\\d{6}`, , , , `9002345678`], [, , , , , , , , , [-1]], [, , `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}`, , , , `5002345678`], [, , , , , , , , , [-1]], `VI`, 1, `011`, `1`, , , `([2-9]\\d{6})$|1`, `340$1`, , 1, , , [, , , , , , , , , [-1]], , `340`, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], VN: [, [, , `[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}`, , , , , , , [7, 8, 9, 10]], [, , `2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}`, , , , `2101234567`, , , [10]], [, , `(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}`, , , , `912345678`, , , [9]], [, , `1800\\d{4,6}|12(?:0[13]|28)\\d{4}`, , , , `1800123456`, , , [8, 9, 10]], [, , `1900\\d{4,6}`, , , , `1900123456`, , , [8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `672\\d{6}`, , , , `672012345`, , , [9]], `VN`, 84, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{4})`, `$1 $2`, [`[17]99`], `0$1`, , 1], [, `(\\d{2})(\\d{5})`, `$1 $2`, [`80`], `0$1`, , 1], [, `(\\d{3})(\\d{4,5})`, `$1 $2`, [`69`], `0$1`, , 1], [, `(\\d{4})(\\d{4,6})`, `$1 $2`, [`1`], , , 1], [, `(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`6`], `0$1`, , 1], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[357-9]`], `0$1`, , 1], [, `(\\d{2})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`2[48]`], `0$1`, , 1], [, `(\\d{3})(\\d{4})(\\d{3})`, `$1 $2 $3`, [`2`], `0$1`, , 1]], [[, `(\\d{2})(\\d{5})`, `$1 $2`, [`80`], `0$1`, , 1], [, `(\\d{4})(\\d{4,6})`, `$1 $2`, [`1`], , , 1], [, `(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`6`], `0$1`, , 1], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[357-9]`], `0$1`, , 1], [, `(\\d{2})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`2[48]`], `0$1`, , 1], [, `(\\d{3})(\\d{4})(\\d{3})`, `$1 $2 $3`, [`2`], `0$1`, , 1]], [, , , , , , , , , [-1]], , , [, , `[17]99\\d{4}|69\\d{5,6}`, , , , , , , [7, 8]], [, , `(?:[17]99|80\\d)\\d{4}|69\\d{5,6}`, , , , `1992000`, , , [7, 8]], , , [, , , , , , , , , [-1]]], VU: [, [, , `[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}`, , , , , , , [5, 7]], [, , `(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}`, , , , `22123`, , , [5]], [, , `(?:[58]\\d|7[013-7])\\d{5}`, , , , `5912345`, , , [7]], [, , `81[18]\\d\\d`, , , , `81123`, , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `9(?:0[1-9]|1[01])\\d{4}`, , , , `9010123`, , , [7]], `VU`, 678, `00`, , , , , , , , [[, `(\\d{3})(\\d{4})`, `$1 $2`, [`[57-9]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `(?:3[03]|900\\d)\\d{3}`, , , , `30123`], , , [, , , , , , , , , [-1]]], WF: [, [, , `(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}`, , , , , , , [6, 9]], [, , `72\\d{4}`, , , , `721234`, , , [6]], [, , `(?:72|8[23])\\d{4}`, , , , `821234`, , , [6]], [, , `80[0-5]\\d{6}`, , , , `800012345`, , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `9[23]\\d{4}`, , , , `921234`, , , [6]], `WF`, 681, `00`, , , , , , , , [[, `(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3`, [`[47-9]`]], [, `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`8`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , `[48]0\\d{4}`, , , , `401234`, , , [6]]], WS: [, [, , `(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}`, , , , , , , [5, 6, 7, 10]], [, , `6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}`, , , , `22123`, , , [5, 6]], [, , `(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}`, , , , `7212345`, , , [7, 10]], [, , `800\\d{3}`, , , , `800123`, , , [6]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `WS`, 685, `0`, , , , , , , , [[, `(\\d{5})`, `$1`, [`[2-5]|6[1-9]`]], [, `(\\d{3})(\\d{3,7})`, `$1 $2`, [`[68]`]], [, `(\\d{2})(\\d{5})`, `$1 $2`, [`7`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], XK: [, [, , `2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}`, , , , , , , [8, 9, 10, 11, 12]], [, , `38\\d{6,10}|(?:2[89]|39)(?:0\\d{5,6}|[1-9]\\d{5})`, , , , `28012345`], [, , `4[3-9]\\d{6}`, , , , `43201234`, , , [8]], [, , `800\\d{5}`, , , , `80001234`, , , [8]], [, , `900\\d{5}`, , , , `90001234`, , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `XK`, 383, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{5})`, `$1 $2`, [`[89]`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[2-4]`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`2|39`], `0$1`], [, `(\\d{2})(\\d{7,10})`, `$1 $2`, [`3`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], YE: [, [, , `(?:1|7\\d)\\d{7}|[1-7]\\d{6}`, , , , , , , [7, 8, 9], [6]], [, , `78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}`, , , , `1234567`, , , [7, 8], [6]], [, , `7[01378]\\d{7}`, , , , `712345678`, , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `YE`, 967, `00`, `0`, , , `0`, , , , [[, `(\\d)(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[1-6]|7(?:[24-6]|8[0-7])`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`7`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], YT: [, [, , `7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}`, , , , , , , [9]], [, , `269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}`, , , , `269601234`], [, , `(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}`, , , , `639012345`], [, , `80\\d{7}`, , , , `801234567`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `9(?:(?:39|47)8[01]|769\\d)\\d{4}`, , , , `939801234`], `YT`, 262, `00`, `0`, , , `0`, , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ZA: [, [, , `[1-79]\\d{8}|8\\d{4,9}`, , , , , , , [5, 6, 7, 8, 9, 10]], [, , `(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}`, , , , `101234567`, , , [9]], [, , `(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d\\d|7(?:[0-46-9]\\d|5[0-4]))\\d\\d|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}`, , , , `711234567`, , , [5, 6, 7, 8, 9]], [, , `80\\d{7}`, , , , `801234567`, , , [9]], [, , `(?:86[2-9]|9[0-2]\\d)\\d{6}`, , , , `862345678`, , , [9]], [, , `860\\d{6}`, , , , `860123456`, , , [9]], [, , , , , , , , , [-1]], [, , `87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}`, , , , `871234567`, , , [9]], `ZA`, 27, `00`, `0`, , , `0`, , , , [[, `(\\d{2})(\\d{3,4})`, `$1 $2`, [`8[1-4]`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{2,3})`, `$1 $2 $3`, [`8[1-4]`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`860`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[1-9]`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`8`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `861\\d{6,7}`, , , , `861123456`, , , [9, 10]], , , [, , , , , , , , , [-1]]], ZM: [, [, , `800\\d{6}|(?:21|63|[79]\\d)\\d{7}`, , , , , , , [9], [6]], [, , `21[1-8]\\d{6}`, , , , `211234567`, , , , [6]], [, , `(?:7[5-79]|9[5-8])\\d{7}`, , , , `955123456`], [, , `800\\d{6}`, , , , `800123456`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `63\\d{7}`, , , , `630123456`], `ZM`, 260, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{3})`, `$1 $2`, [`[1-9]`]], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[28]`], `0$1`], [, `(\\d{2})(\\d{7})`, `$1 $2`, [`[79]`], `0$1`]], [[, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[28]`], `0$1`], [, `(\\d{2})(\\d{7})`, `$1 $2`, [`[79]`], `0$1`]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ZW: [, [, , `2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}`, , , , , , , [5, 6, 7, 8, 9, 10], [3, 4]], [, , `(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}`, , , , `1312345`, , , , [3, 4]], [, , `7(?:[1278]\\d|3[1-9])\\d{6}`, , , , `712345678`, , , [9]], [, , `80(?:[01]\\d|20|8[0-8])\\d{3}`, , , , `8001234`, , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `86(?:1[12]|22|30|44|55|77|8[368])\\d{6}`, , , , `8686123456`, , , [10]], `ZW`, 263, `00`, `0`, , , `0`, , , , [[, `(\\d{3})(\\d{3,5})`, `$1 $2`, [`2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]`], `0$1`], [, `(\\d)(\\d{3})(\\d{2,4})`, `$1 $2 $3`, [`[49]`], `0$1`], [, `(\\d{3})(\\d{4})`, `$1 $2`, [`80`], `0$1`], [, `(\\d{2})(\\d{7})`, `$1 $2`, [`24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2`, `2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]`], `(0$1)`], [, `(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`7`], `0$1`], [, `(\\d{3})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)`, `2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)`], `0$1`], [, `(\\d{4})(\\d{6})`, `$1 $2`, [`8`], `0$1`], [, `(\\d{2})(\\d{3,5})`, `$1 $2`, [`1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]`], `0$1`], [, `(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`29[013-9]|39|54`], `0$1`], [, `(\\d{4})(\\d{3,5})`, `$1 $2`, [`(?:25|54)8`, `258|5483`], `0$1`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 800: [, [, , `(?:00|[1-9]\\d)\\d{6}`, , , , , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `(?:00|[1-9]\\d)\\d{6}`, , , , `12345678`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `001`, 800, , , , , , , , 1, [[, `(\\d{4})(\\d{4})`, `$1 $2`, [`\\d`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 808: [, [, , `[1-9]\\d{7}`, , , , , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `[1-9]\\d{7}`, , , , `12345678`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `001`, 808, , , , , , , , 1, [[, `(\\d{4})(\\d{4})`, `$1 $2`, [`[1-9]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 870: [, [, , `7\\d{11}|[235-7]\\d{8}`, , , , , , , [9, 12]], [, , , , , , , , , [-1]], [, , `(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}`, , , , `301234567`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `2\\d{8}`, , , , `201234567`, , , [9]], `001`, 870, , , , , , , , , [[, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[235-7]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 878: [, [, , `10\\d{10}`, , , , , , , [12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `10\\d{10}`, , , , `101234567890`], `001`, 878, , , , , , , , 1, [[, `(\\d{2})(\\d{5})(\\d{5})`, `$1 $2 $3`, [`1`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 881: [, [, , `6\\d{9}|[0-36-9]\\d{8}`, , , , , , , [9, 10]], [, , , , , , , , , [-1]], [, , `6\\d{9}|[0-36-9]\\d{8}`, , , , `612345678`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `001`, 881, , , , , , , , , [[, `(\\d)(\\d{3})(\\d{5})`, `$1 $2 $3`, [`[0-37-9]`]], [, `(\\d)(\\d{3})(\\d{5,6})`, `$1 $2 $3`, [`6`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 882: [, [, , `[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?`, , , , , , , [7, 8, 9, 10, 11, 12]], [, , , , , , , , , [-1]], [, , `342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}`, , , , `3421234`, , , [7, 8, 9, 10, 12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}`, , , , `390123456789`], `001`, 882, , , , , , , , , [[, `(\\d{2})(\\d{5})`, `$1 $2`, [`16|342`]], [, `(\\d{2})(\\d{6})`, `$1 $2`, [`49`]], [, `(\\d{2})(\\d{2})(\\d{4})`, `$1 $2 $3`, [`1[36]|9`]], [, `(\\d{2})(\\d{4})(\\d{3})`, `$1 $2 $3`, [`3[23]`]], [, `(\\d{2})(\\d{3,4})(\\d{4})`, `$1 $2 $3`, [`16`]], [, `(\\d{2})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`10|23|3(?:[15]|4[57])|4|51`]], [, `(\\d{3})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`34`]], [, `(\\d{2})(\\d{4,5})(\\d{5})`, `$1 $2 $3`, [`[1-35]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , `348[57]\\d{7}`, , , , `34851234567`, , , [11]]], 883: [, [, , `(?:[1-4]\\d|51)\\d{6,10}`, , , , , , , [8, 9, 10, 11, 12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}`, , , , `510012345`], `001`, 883, , , , , , , , 1, [[, `(\\d{3})(\\d{3})(\\d{2,8})`, `$1 $2 $3`, [`[14]|2[24-689]|3[02-689]|51[24-9]`]], [, `(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`510`]], [, `(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`21`]], [, `(\\d{4})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`51[13]`]], [, `(\\d{3})(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3 $4`, [`[235]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 888: [, [, , `\\d{11}`, , , , , , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `001`, 888, , , , , , , , 1, [[, `(\\d{3})(\\d{3})(\\d{5})`, `$1 $2 $3`]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , `\\d{11}`, , , , `12345678901`], , , [, , , , , , , , , [-1]]], 979: [, [, , `[1359]\\d{8}`, , , , , , , [9], [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , `[1359]\\d{8}`, , , , `123456789`, , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], `001`, 979, , , , , , , , 1, [[, `(\\d)(\\d{4})(\\d{4})`, `$1 $2 $3`, [`[1359]`]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]] }, i18n$1.phonenumbers.PhoneNumberUtil = function() {
            this.regionToMetadataMap = {};
          }, goog.addSingletonGetter(i18n$1.phonenumbers.PhoneNumberUtil), i18n$1.phonenumbers.Error = { INVALID_COUNTRY_CODE: `Invalid country calling code`, NOT_A_NUMBER: `The string supplied did not seem to be a phone number`, TOO_SHORT_AFTER_IDD: `Phone number too short after IDD`, TOO_SHORT_NSN: `The string supplied is too short to be a phone number`, TOO_LONG: `The string supplied is too long to be a phone number` }, i18n$1.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_ = 1, i18n$1.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ = 2, i18n$1.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_ = 17, i18n$1.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_ = 3, i18n$1.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_ = 250, i18n$1.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_ = `ZZ`, i18n$1.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_ = { 54: `9` }, i18n$1.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_ = [52, 54, 55], i18n$1.phonenumbers.PhoneNumberUtil.PLUS_SIGN = `+`, i18n$1.phonenumbers.PhoneNumberUtil.STAR_SIGN_ = `*`, i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ = `;ext=`, i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_ = `tel:`, i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_ = `;phone-context=`, i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_ = `;isub=`, i18n$1.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS = { 0: `0`, 1: `1`, 2: `2`, 3: `3`, 4: `4`, 5: `5`, 6: `6`, 7: `7`, 8: `8`, 9: `9`, "０": `0`, "１": `1`, "２": `2`, "３": `3`, "４": `4`, "５": `5`, "６": `6`, "７": `7`, "８": `8`, "９": `9`, "٠": `0`, "١": `1`, "٢": `2`, "٣": `3`, "٤": `4`, "٥": `5`, "٦": `6`, "٧": `7`, "٨": `8`, "٩": `9`, "۰": `0`, "۱": `1`, "۲": `2`, "۳": `3`, "۴": `4`, "۵": `5`, "۶": `6`, "۷": `7`, "۸": `8`, "۹": `9` }, i18n$1.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_ = { 0: `0`, 1: `1`, 2: `2`, 3: `3`, 4: `4`, 5: `5`, 6: `6`, 7: `7`, 8: `8`, 9: `9`, "+": i18n$1.phonenumbers.PhoneNumberUtil.PLUS_SIGN, "*": `*`, "#": `#` }, i18n$1.phonenumbers.PhoneNumberUtil.ALPHA_MAPPINGS_ = { A: `2`, B: `2`, C: `2`, D: `3`, E: `3`, F: `3`, G: `4`, H: `4`, I: `4`, J: `5`, K: `5`, L: `5`, M: `6`, N: `6`, O: `6`, P: `7`, Q: `7`, R: `7`, S: `7`, T: `8`, U: `8`, V: `8`, W: `9`, X: `9`, Y: `9`, Z: `9` }, i18n$1.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_ = { 0: `0`, 1: `1`, 2: `2`, 3: `3`, 4: `4`, 5: `5`, 6: `6`, 7: `7`, 8: `8`, 9: `9`, "０": `0`, "１": `1`, "２": `2`, "３": `3`, "４": `4`, "５": `5`, "６": `6`, "７": `7`, "８": `8`, "９": `9`, "٠": `0`, "١": `1`, "٢": `2`, "٣": `3`, "٤": `4`, "٥": `5`, "٦": `6`, "٧": `7`, "٨": `8`, "٩": `9`, "۰": `0`, "۱": `1`, "۲": `2`, "۳": `3`, "۴": `4`, "۵": `5`, "۶": `6`, "۷": `7`, "۸": `8`, "۹": `9`, A: `2`, B: `2`, C: `2`, D: `3`, E: `3`, F: `3`, G: `4`, H: `4`, I: `4`, J: `5`, K: `5`, L: `5`, M: `6`, N: `6`, O: `6`, P: `7`, Q: `7`, R: `7`, S: `7`, T: `8`, U: `8`, V: `8`, W: `9`, X: `9`, Y: `9`, Z: `9` }, i18n$1.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_ = { 0: `0`, 1: `1`, 2: `2`, 3: `3`, 4: `4`, 5: `5`, 6: `6`, 7: `7`, 8: `8`, 9: `9`, A: `A`, B: `B`, C: `C`, D: `D`, E: `E`, F: `F`, G: `G`, H: `H`, I: `I`, J: `J`, K: `K`, L: `L`, M: `M`, N: `N`, O: `O`, P: `P`, Q: `Q`, R: `R`, S: `S`, T: `T`, U: `U`, V: `V`, W: `W`, X: `X`, Y: `Y`, Z: `Z`, a: `A`, b: `B`, c: `C`, d: `D`, e: `E`, f: `F`, g: `G`, h: `H`, i: `I`, j: `J`, k: `K`, l: `L`, m: `M`, n: `N`, o: `O`, p: `P`, q: `Q`, r: `R`, s: `S`, t: `T`, u: `U`, v: `V`, w: `W`, x: `X`, y: `Y`, z: `Z`, "-": `-`, "－": `-`, "‐": `-`, "‑": `-`, "‒": `-`, "–": `-`, "—": `-`, "―": `-`, "−": `-`, "/": `/`, "／": `/`, " ": ` `, "　": ` `, "⁠": ` `, ".": `.`, "．": `.` }, i18n$1.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_ = /[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?/, i18n$1.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION = `-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～`, i18n$1.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ = `0-9０-９٠-٩۰-۹`, i18n$1.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ = `A-Za-z`, i18n$1.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ = `+＋`, i18n$1.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN = RegExp(`[` + i18n$1.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + `]+`), i18n$1.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN = RegExp(`^[` + i18n$1.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + `]+`), i18n$1.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_ = `[` + i18n$1.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + `]+`, i18n$1.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN = RegExp(`([` + i18n$1.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + `])`), i18n$1.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_ = RegExp(`[` + i18n$1.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + i18n$1.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + `]`), i18n$1.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_ = /[\\\/] *x/, i18n$1.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_ = RegExp(`[^` + i18n$1.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + i18n$1.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + `#]+$`), i18n$1.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_ = /(?:.*?[A-Za-z]){3}.*/, i18n$1.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_ = `[` + i18n$1.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + `]{` + i18n$1.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ + `}`, i18n$1.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_ = `[` + i18n$1.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + `]*(?:[` + i18n$1.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + i18n$1.phonenumbers.PhoneNumberUtil.STAR_SIGN_ + `]*[` + i18n$1.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + `]){3,}[` + i18n$1.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + i18n$1.phonenumbers.PhoneNumberUtil.STAR_SIGN_ + i18n$1.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + i18n$1.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + `]*`, i18n$1.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_ = ` ext. `, i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_VISUAL_SEPARATOR_ = `[\\-\\.\\(\\)]?`, i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_DIGIT_ = `([` + i18n$1.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + `]|` + i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_VISUAL_SEPARATOR_ + `)`, i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_ = `^\\` + i18n$1.phonenumbers.PhoneNumberUtil.PLUS_SIGN + i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_DIGIT_ + `*[` + i18n$1.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + `]` + i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_DIGIT_ + `*$`, i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_), i18n$1.phonenumbers.PhoneNumberUtil.ALPHANUM_ = i18n$1.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + i18n$1.phonenumbers.PhoneNumberUtil.VALID_DIGITS_, i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINLABEL_ = `[` + i18n$1.phonenumbers.PhoneNumberUtil.ALPHANUM_ + `]+((\\-)*[` + i18n$1.phonenumbers.PhoneNumberUtil.ALPHANUM_ + `])*`, i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_TOPLABEL_ = `[` + i18n$1.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + `]+((\\-)*[` + i18n$1.phonenumbers.PhoneNumberUtil.ALPHANUM_ + `])*`, i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_ = `^(` + i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINLABEL_ + `\\.)*` + i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_TOPLABEL_ + `\\.?$`, i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_PATTERN_ = new RegExp(i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_), i18n$1.phonenumbers.PhoneNumberUtil.extnDigits_ = function(t$7) {
            return `([` + i18n$1.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + `]{1,` + t$7 + `})`;
          }, i18n$1.phonenumbers.PhoneNumberUtil.createExtnPattern_ = function() {
            var t$7 = i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ + i18n$1.phonenumbers.PhoneNumberUtil.extnDigits_(`20`), o$2 = `[  \\t,]*(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)[:\\.．]?[  \\t,-]*` + i18n$1.phonenumbers.PhoneNumberUtil.extnDigits_(`20`) + `#?`, r$2 = `[  \\t,]*(?:[xｘ#＃~～]|int|ｉｎｔ)[:\\.．]?[  \\t,-]*` + i18n$1.phonenumbers.PhoneNumberUtil.extnDigits_(`9`) + `#?`, u = `[- ]+` + i18n$1.phonenumbers.PhoneNumberUtil.extnDigits_(`6`) + `#`, h$1 = `[  \\t]*(?:,{2}|;)[:\\.．]?[  \\t,-]*` + i18n$1.phonenumbers.PhoneNumberUtil.extnDigits_(`15`) + `#?`, m$3 = `[  \\t]*(?:,)+[:\\.．]?[  \\t,-]*` + i18n$1.phonenumbers.PhoneNumberUtil.extnDigits_(`9`) + `#?`;
            return t$7 + `|` + o$2 + `|` + r$2 + `|` + u + `|` + h$1 + `|` + m$3;
          }, i18n$1.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_ = RegExp(`(?:` + i18n$1.phonenumbers.PhoneNumberUtil.createExtnPattern_() + `)$`, `i`), i18n$1.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_ = RegExp(`^` + i18n$1.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_ + `$|^` + i18n$1.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_ + `(?:` + i18n$1.phonenumbers.PhoneNumberUtil.createExtnPattern_() + `)?$`, `i`), i18n$1.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_ = /\D+/, i18n$1.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_ = /(\$\d)/, i18n$1.phonenumbers.PhoneNumberUtil.NP_PATTERN_ = /\$NP/, i18n$1.phonenumbers.PhoneNumberUtil.FG_PATTERN_ = /\$FG/, i18n$1.phonenumbers.PhoneNumberUtil.CC_PATTERN_ = /\$CC/, i18n$1.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_ = /^\(?\$1\)?$/, i18n$1.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY = `001`, i18n$1.phonenumbers.PhoneNumberFormat = { E164: 0, INTERNATIONAL: 1, NATIONAL: 2, RFC3966: 3 }, i18n$1.phonenumbers.PhoneNumberType = { FIXED_LINE: 0, MOBILE: 1, FIXED_LINE_OR_MOBILE: 2, TOLL_FREE: 3, PREMIUM_RATE: 4, SHARED_COST: 5, VOIP: 6, PERSONAL_NUMBER: 7, PAGER: 8, UAN: 9, VOICEMAIL: 10, UNKNOWN: -1 }, i18n$1.phonenumbers.PhoneNumberUtil.MatchType = { NOT_A_NUMBER: 0, NO_MATCH: 1, SHORT_NSN_MATCH: 2, NSN_MATCH: 3, EXACT_MATCH: 4 }, i18n$1.phonenumbers.PhoneNumberUtil.ValidationResult = { IS_POSSIBLE: 0, IS_POSSIBLE_LOCAL_ONLY: 4, INVALID_COUNTRY_CODE: 1, TOO_SHORT: 2, INVALID_LENGTH: 5, TOO_LONG: 3 }, i18n$1.phonenumbers.PhoneNumberUtil.extractPossibleNumber = function(t$7) {
            var o$2 = t$7.search(i18n$1.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_);
            return 0 <= o$2 ? (t$7 = t$7.substring(o$2), t$7 = t$7.replace(i18n$1.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_, ``), o$2 = t$7.search(i18n$1.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_), 0 <= o$2 && (t$7 = t$7.substring(0, o$2))) : t$7 = ``, t$7;
          }, i18n$1.phonenumbers.PhoneNumberUtil.isViablePhoneNumber = function(t$7) {
            return t$7.length < i18n$1.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ ? false : i18n$1.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n$1.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_, t$7);
          }, i18n$1.phonenumbers.PhoneNumberUtil.normalize = function(t$7) {
            return i18n$1.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n$1.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_, t$7) ? i18n$1.phonenumbers.PhoneNumberUtil.normalizeHelper_(t$7, i18n$1.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_, true) : i18n$1.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(t$7);
          }, i18n$1.phonenumbers.PhoneNumberUtil.normalizeSB_ = function(t$7) {
            var o$2 = i18n$1.phonenumbers.PhoneNumberUtil.normalize(t$7.toString());
            t$7.clear(), t$7.append(o$2);
          }, i18n$1.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly = function(t$7) {
            return i18n$1.phonenumbers.PhoneNumberUtil.normalizeHelper_(t$7, i18n$1.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS, true);
          }, i18n$1.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly = function(t$7) {
            return i18n$1.phonenumbers.PhoneNumberUtil.normalizeHelper_(t$7, i18n$1.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_, true);
          }, i18n$1.phonenumbers.PhoneNumberUtil.convertAlphaCharactersInNumber = function(t$7) {
            return i18n$1.phonenumbers.PhoneNumberUtil.normalizeHelper_(t$7, i18n$1.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_, false);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.getLengthOfGeographicalAreaCode = function(t$7) {
            var o$2 = this.getMetadataForRegion(this.getRegionCodeForNumber(t$7));
            return o$2 != null && (o$2.hasNationalPrefix() || t$7.hasItalianLeadingZero()) && this.isNumberGeographical(t$7) ? this.getLengthOfNationalDestinationCode(t$7) : 0;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.getLengthOfNationalDestinationCode = function(t$7) {
            if (t$7.hasExtension()) {
              var o$2 = t$7.clone();
              o$2.clearExtension();
            } else o$2 = t$7;
            return o$2 = this.format(o$2, i18n$1.phonenumbers.PhoneNumberFormat.INTERNATIONAL).split(i18n$1.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_), o$2[0].length == 0 && o$2.shift(), 2 >= o$2.length ? 0 : this.getNumberType(t$7) == i18n$1.phonenumbers.PhoneNumberType.MOBILE && (t$7 = i18n$1.phonenumbers.PhoneNumberUtil.getCountryMobileToken(t$7.getCountryCodeOrDefault()), t$7 != ``) ? o$2[2].length + t$7.length : o$2[1].length;
          }, i18n$1.phonenumbers.PhoneNumberUtil.getCountryMobileToken = function(t$7) {
            return i18n$1.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_[t$7] || ``;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.getSupportedRegions = function() {
            return Object.keys(i18n$1.phonenumbers.metadata.countryToMetadata).filter(function(t$7) {
              return isNaN(t$7);
            });
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.getSupportedGlobalNetworkCallingCodes = function() {
            return Object.keys(i18n$1.phonenumbers.metadata.countryToMetadata).filter(function(t$7) {
              return !isNaN(t$7);
            }).map(function(t$7) {
              return parseInt(t$7, 10);
            });
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.getSupportedCallingCodes = function() {
            var t$7 = Object.keys(i18n$1.phonenumbers.metadata.countryCodeToRegionCodeMap);
            return [].concat($jscomp.arrayFromIterable(this.getSupportedGlobalNetworkCallingCodes()), $jscomp.arrayFromIterable(t$7.map(function(o$2) {
              return parseInt(o$2, 10);
            })));
          }, i18n$1.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_ = function(t$7) {
            return t$7 != null && (t$7.possibleLengthCount() != 1 || t$7.possibleLengthArray()[0] != -1);
          }, i18n$1.phonenumbers.PhoneNumberUtil.descHasData_ = function(t$7) {
            return t$7 != null && (t$7.hasExampleNumber() || i18n$1.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(t$7) || t$7.hasNationalNumberPattern());
          }, i18n$1.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_ = function(t$7) {
            var o$2 = [];
            return goog.object.forEach(i18n$1.phonenumbers.PhoneNumberType, function(r$2) {
              if (r$2 != i18n$1.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE && r$2 != i18n$1.phonenumbers.PhoneNumberType.UNKNOWN) {
                var u = i18n$1.phonenumbers.PhoneNumberUtil.getNumberDescByType_(t$7, r$2);
                i18n$1.phonenumbers.PhoneNumberUtil.descHasData_(u) && o$2.push(r$2);
              }
            }), o$2;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForRegion = function(t$7) {
            return this.isValidRegionCode_(t$7) ? i18n$1.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(this.getMetadataForRegion(t$7)) : [];
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForNonGeoEntity = function(t$7) {
            return t$7 = this.getMetadataForNonGeographicalRegion(t$7), t$7 == null ? [] : i18n$1.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(t$7);
          }, i18n$1.phonenumbers.PhoneNumberUtil.normalizeHelper_ = function(t$7, o$2, r$2) {
            for (var u = new goog.string.StringBuffer(), h$1, m$3, y$1 = t$7.length, S = 0; S < y$1; ++S) h$1 = t$7.charAt(S), m$3 = o$2[h$1.toUpperCase()], m$3 == null ? r$2 || u.append(h$1) : u.append(m$3);
            return u.toString();
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.formattingRuleHasFirstGroupOnly = function(t$7) {
            return t$7.length == 0 || i18n$1.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_.test(t$7);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.isNumberGeographical = function(t$7) {
            var o$2 = this.getNumberType(t$7);
            return o$2 == i18n$1.phonenumbers.PhoneNumberType.FIXED_LINE || o$2 == i18n$1.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE || i18n$1.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_.includes(t$7.getCountryCodeOrDefault()) && o$2 == i18n$1.phonenumbers.PhoneNumberType.MOBILE;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.isValidRegionCode_ = function(t$7) {
            return t$7 != null && isNaN(t$7) && t$7.toUpperCase() in i18n$1.phonenumbers.metadata.countryToMetadata;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.hasValidCountryCallingCode_ = function(t$7) {
            return t$7 in i18n$1.phonenumbers.metadata.countryCodeToRegionCodeMap;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.format = function(t$7, o$2) {
            if (t$7.getNationalNumber() == 0 && t$7.hasRawInput()) {
              var r$2 = t$7.getRawInputOrDefault();
              if (0 < r$2.length) return r$2;
            }
            r$2 = t$7.getCountryCodeOrDefault();
            var u = this.getNationalSignificantNumber(t$7);
            if (o$2 == i18n$1.phonenumbers.PhoneNumberFormat.E164) return this.prefixNumberWithCountryCallingCode_(r$2, i18n$1.phonenumbers.PhoneNumberFormat.E164, u, ``);
            if (!this.hasValidCountryCallingCode_(r$2)) return u;
            var h$1 = this.getRegionCodeForCountryCode(r$2);
            return h$1 = this.getMetadataForRegionOrCallingCode_(r$2, h$1), t$7 = this.maybeGetFormattedExtension_(t$7, h$1, o$2), u = this.formatNsn_(u, h$1, o$2), this.prefixNumberWithCountryCallingCode_(r$2, o$2, u, t$7);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.formatByPattern = function(t$7, o$2, r$2) {
            var u = t$7.getCountryCodeOrDefault(), h$1 = this.getNationalSignificantNumber(t$7);
            if (!this.hasValidCountryCallingCode_(u)) return h$1;
            var m$3 = this.getRegionCodeForCountryCode(u);
            m$3 = this.getMetadataForRegionOrCallingCode_(u, m$3);
            var y$1 = this.chooseFormattingPatternForNumber_(r$2, h$1);
            if (y$1 != null) {
              if (r$2 = y$1.clone(), y$1 = y$1.getNationalPrefixFormattingRuleOrDefault(), 0 < y$1.length) {
                var S = m$3.getNationalPrefixOrDefault();
                0 < S.length ? (y$1 = y$1.replace(i18n$1.phonenumbers.PhoneNumberUtil.NP_PATTERN_, S).replace(i18n$1.phonenumbers.PhoneNumberUtil.FG_PATTERN_, `$1`), r$2.setNationalPrefixFormattingRule(y$1)) : r$2.clearNationalPrefixFormattingRule();
              }
              h$1 = this.formatNsnUsingPattern_(h$1, r$2, o$2);
            }
            return t$7 = this.maybeGetFormattedExtension_(t$7, m$3, o$2), this.prefixNumberWithCountryCallingCode_(u, o$2, h$1, t$7);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithCarrierCode = function(t$7, o$2) {
            var r$2 = t$7.getCountryCodeOrDefault(), u = this.getNationalSignificantNumber(t$7);
            if (!this.hasValidCountryCallingCode_(r$2)) return u;
            var h$1 = this.getRegionCodeForCountryCode(r$2);
            return h$1 = this.getMetadataForRegionOrCallingCode_(r$2, h$1), t$7 = this.maybeGetFormattedExtension_(t$7, h$1, i18n$1.phonenumbers.PhoneNumberFormat.NATIONAL), o$2 = this.formatNsn_(u, h$1, i18n$1.phonenumbers.PhoneNumberFormat.NATIONAL, o$2), this.prefixNumberWithCountryCallingCode_(r$2, i18n$1.phonenumbers.PhoneNumberFormat.NATIONAL, o$2, t$7);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegionOrCallingCode_ = function(t$7, o$2) {
            return i18n$1.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY == o$2 ? this.getMetadataForNonGeographicalRegion(t$7) : this.getMetadataForRegion(o$2);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithPreferredCarrierCode = function(t$7, o$2) {
            return this.formatNationalNumberWithCarrierCode(t$7, 0 < t$7.getPreferredDomesticCarrierCodeOrDefault().length ? t$7.getPreferredDomesticCarrierCodeOrDefault() : o$2);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.formatNumberForMobileDialing = function(t$7, o$2, r$2) {
            var u = t$7.getCountryCodeOrDefault();
            if (!this.hasValidCountryCallingCode_(u)) return t$7.hasRawInput() ? t$7.getRawInputOrDefault() : ``;
            var h$1 = ``;
            t$7 = t$7.clone(), t$7.clearExtension();
            var m$3 = this.getRegionCodeForCountryCode(u), y$1 = this.getNumberType(t$7), S = y$1 != i18n$1.phonenumbers.PhoneNumberType.UNKNOWN;
            if (o$2 == m$3) h$1 = y$1 == i18n$1.phonenumbers.PhoneNumberType.FIXED_LINE || y$1 == i18n$1.phonenumbers.PhoneNumberType.MOBILE || y$1 == i18n$1.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE, m$3 == `BR` && h$1 ? h$1 = 0 < t$7.getPreferredDomesticCarrierCodeOrDefault().length ? this.formatNationalNumberWithPreferredCarrierCode(t$7, ``) : `` : u == i18n$1.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_ ? (o$2 = this.getMetadataForRegion(o$2), h$1 = this.canBeInternationallyDialled(t$7) && this.testNumberLength_(this.getNationalSignificantNumber(t$7), o$2) != i18n$1.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT ? this.format(t$7, i18n$1.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(t$7, i18n$1.phonenumbers.PhoneNumberFormat.NATIONAL)) : h$1 = (m$3 == i18n$1.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY || (m$3 == `MX` || m$3 == `CL` || m$3 == `UZ`) && h$1) && this.canBeInternationallyDialled(t$7) ? this.format(t$7, i18n$1.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(t$7, i18n$1.phonenumbers.PhoneNumberFormat.NATIONAL);
            else if (S && this.canBeInternationallyDialled(t$7)) return r$2 ? this.format(t$7, i18n$1.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(t$7, i18n$1.phonenumbers.PhoneNumberFormat.E164);
            return r$2 ? h$1 : i18n$1.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(h$1);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryCallingNumber = function(t$7, o$2) {
            if (!this.isValidRegionCode_(o$2)) return this.format(t$7, i18n$1.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
            var r$2 = t$7.getCountryCodeOrDefault(), u = this.getNationalSignificantNumber(t$7);
            if (!this.hasValidCountryCallingCode_(r$2)) return u;
            if (r$2 == i18n$1.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_) {
              if (this.isNANPACountry(o$2)) return r$2 + ` ` + this.format(t$7, i18n$1.phonenumbers.PhoneNumberFormat.NATIONAL);
            } else if (r$2 == this.getCountryCodeForValidRegion_(o$2)) return this.format(t$7, i18n$1.phonenumbers.PhoneNumberFormat.NATIONAL);
            var h$1 = this.getMetadataForRegion(o$2), m$3 = h$1.getInternationalPrefixOrDefault();
            return o$2 = ``, h$1.hasPreferredInternationalPrefix() ? o$2 = h$1.getPreferredInternationalPrefixOrDefault() : i18n$1.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n$1.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_, m$3) && (o$2 = m$3), h$1 = this.getRegionCodeForCountryCode(r$2), h$1 = this.getMetadataForRegionOrCallingCode_(r$2, h$1), u = this.formatNsn_(u, h$1, i18n$1.phonenumbers.PhoneNumberFormat.INTERNATIONAL), t$7 = this.maybeGetFormattedExtension_(t$7, h$1, i18n$1.phonenumbers.PhoneNumberFormat.INTERNATIONAL), 0 < o$2.length ? o$2 + ` ` + r$2 + ` ` + u + t$7 : this.prefixNumberWithCountryCallingCode_(r$2, i18n$1.phonenumbers.PhoneNumberFormat.INTERNATIONAL, u, t$7);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.formatInOriginalFormat = function(t$7, o$2) {
            if (t$7.hasRawInput() && !this.hasFormattingPatternForNumber_(t$7)) return t$7.getRawInputOrDefault();
            if (!t$7.hasCountryCodeSource()) return this.format(t$7, i18n$1.phonenumbers.PhoneNumberFormat.NATIONAL);
            switch (t$7.getCountryCodeSource()) {
              case i18n$1.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN:
                o$2 = this.format(t$7, i18n$1.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
                break;
              case i18n$1.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD:
                o$2 = this.formatOutOfCountryCallingNumber(t$7, o$2);
                break;
              case i18n$1.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN:
                o$2 = this.format(t$7, i18n$1.phonenumbers.PhoneNumberFormat.INTERNATIONAL).substring(1);
                break;
              default:
                var r$2 = this.getRegionCodeForCountryCode(t$7.getCountryCodeOrDefault()), u = this.getNddPrefixForRegion(r$2, true);
                if (o$2 = this.format(t$7, i18n$1.phonenumbers.PhoneNumberFormat.NATIONAL), u != null && u.length != 0 && !this.rawInputContainsNationalPrefix_(t$7.getRawInputOrDefault(), u, r$2) && (r$2 = this.getMetadataForRegion(r$2), u = this.getNationalSignificantNumber(t$7), r$2 = this.chooseFormattingPatternForNumber_(r$2.numberFormatArray(), u), r$2 != null)) {
                  u = r$2.getNationalPrefixFormattingRuleOrDefault();
                  var h$1 = u.indexOf(`$1`);
                  0 >= h$1 || (u = u.substring(0, h$1), u = i18n$1.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(u), u.length != 0 && (o$2 = r$2.clone(), o$2.clearNationalPrefixFormattingRule(), o$2 = this.formatByPattern(t$7, i18n$1.phonenumbers.PhoneNumberFormat.NATIONAL, [o$2])));
                }
            }
            return t$7 = t$7.getRawInputOrDefault(), o$2 != null && 0 < t$7.length && (r$2 = i18n$1.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(o$2), u = i18n$1.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(t$7), r$2 != u && (o$2 = t$7)), o$2;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.rawInputContainsNationalPrefix_ = function(t$7, o$2, r$2) {
            if (t$7 = i18n$1.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(t$7), goog.string.startsWith(t$7, o$2)) try {
              return this.isValidNumber(this.parse(t$7.substring(o$2.length), r$2));
            } catch {
            }
            return false;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.hasFormattingPatternForNumber_ = function(t$7) {
            var o$2 = t$7.getCountryCodeOrDefault(), r$2 = this.getRegionCodeForCountryCode(o$2);
            return o$2 = this.getMetadataForRegionOrCallingCode_(o$2, r$2), o$2 == null ? false : (t$7 = this.getNationalSignificantNumber(t$7), this.chooseFormattingPatternForNumber_(o$2.numberFormatArray(), t$7) != null);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryKeepingAlphaChars = function(t$7, o$2) {
            var r$2 = t$7.getRawInputOrDefault();
            if (r$2.length == 0) return this.formatOutOfCountryCallingNumber(t$7, o$2);
            var u = t$7.getCountryCodeOrDefault();
            if (!this.hasValidCountryCallingCode_(u)) return r$2;
            r$2 = i18n$1.phonenumbers.PhoneNumberUtil.normalizeHelper_(r$2, i18n$1.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_, true);
            var h$1 = this.getNationalSignificantNumber(t$7);
            if (3 < h$1.length) {
              var m$3 = r$2.indexOf(h$1.substring(0, 3));
              m$3 != -1 && (r$2 = r$2.substring(m$3));
            }
            if (m$3 = this.getMetadataForRegion(o$2), u == i18n$1.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_) {
              if (this.isNANPACountry(o$2)) return u + ` ` + r$2;
            } else if (m$3 != null && u == this.getCountryCodeForValidRegion_(o$2)) return u = this.chooseFormattingPatternForNumber_(m$3.numberFormatArray(), h$1), u == null ? r$2 : (u = u.clone(), u.setPattern(`(\\d+)(.*)`), u.setFormat(`$1$2`), this.formatNsnUsingPattern_(r$2, u, i18n$1.phonenumbers.PhoneNumberFormat.NATIONAL));
            return o$2 = ``, m$3 != null && (o$2 = m$3.getInternationalPrefixOrDefault(), o$2 = i18n$1.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n$1.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_, o$2) ? o$2 : m$3.getPreferredInternationalPrefixOrDefault()), m$3 = this.getRegionCodeForCountryCode(u), m$3 = this.getMetadataForRegionOrCallingCode_(u, m$3), t$7 = this.maybeGetFormattedExtension_(t$7, m$3, i18n$1.phonenumbers.PhoneNumberFormat.INTERNATIONAL), 0 < o$2.length ? o$2 + ` ` + u + ` ` + r$2 + t$7 : this.prefixNumberWithCountryCallingCode_(u, i18n$1.phonenumbers.PhoneNumberFormat.INTERNATIONAL, r$2, t$7);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.getNationalSignificantNumber = function(t$7) {
            if (!t$7.hasNationalNumber()) return ``;
            var o$2 = `` + t$7.getNationalNumber();
            return t$7.hasItalianLeadingZero() && t$7.getItalianLeadingZero() && 0 < t$7.getNumberOfLeadingZerosOrDefault() ? Array(t$7.getNumberOfLeadingZerosOrDefault() + 1).join(`0`) + o$2 : o$2;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.prefixNumberWithCountryCallingCode_ = function(t$7, o$2, r$2, u) {
            switch (o$2) {
              case i18n$1.phonenumbers.PhoneNumberFormat.E164:
                return i18n$1.phonenumbers.PhoneNumberUtil.PLUS_SIGN + t$7 + r$2 + u;
              case i18n$1.phonenumbers.PhoneNumberFormat.INTERNATIONAL:
                return i18n$1.phonenumbers.PhoneNumberUtil.PLUS_SIGN + t$7 + ` ` + r$2 + u;
              case i18n$1.phonenumbers.PhoneNumberFormat.RFC3966:
                return i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_ + i18n$1.phonenumbers.PhoneNumberUtil.PLUS_SIGN + t$7 + `-` + r$2 + u;
              default:
                return r$2 + u;
            }
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.formatNsn_ = function(t$7, o$2, r$2, u) {
            return o$2 = o$2.intlNumberFormatArray().length == 0 || r$2 == i18n$1.phonenumbers.PhoneNumberFormat.NATIONAL ? o$2.numberFormatArray() : o$2.intlNumberFormatArray(), o$2 = this.chooseFormattingPatternForNumber_(o$2, t$7), o$2 == null ? t$7 : this.formatNsnUsingPattern_(t$7, o$2, r$2, u);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.chooseFormattingPatternForNumber_ = function(t$7, o$2) {
            for (var r$2, u = t$7.length, h$1 = 0; h$1 < u; ++h$1) {
              r$2 = t$7[h$1];
              var m$3 = r$2.leadingDigitsPatternCount();
              if ((m$3 == 0 || o$2.search(r$2.getLeadingDigitsPattern(m$3 - 1)) == 0) && (m$3 = new RegExp(r$2.getPattern()), i18n$1.phonenumbers.PhoneNumberUtil.matchesEntirely(m$3, o$2))) return r$2;
            }
            return null;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.formatNsnUsingPattern_ = function(t$7, o$2, r$2, u) {
            var h$1 = o$2.getFormatOrDefault(), m$3 = new RegExp(o$2.getPattern()), y$1 = o$2.getDomesticCarrierCodeFormattingRuleOrDefault();
            return r$2 == i18n$1.phonenumbers.PhoneNumberFormat.NATIONAL && u != null && 0 < u.length && 0 < y$1.length ? (o$2 = y$1.replace(i18n$1.phonenumbers.PhoneNumberUtil.CC_PATTERN_, u), h$1 = h$1.replace(i18n$1.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_, o$2), t$7 = t$7.replace(m$3, h$1)) : (o$2 = o$2.getNationalPrefixFormattingRuleOrDefault(), t$7 = r$2 == i18n$1.phonenumbers.PhoneNumberFormat.NATIONAL && o$2 != null && 0 < o$2.length ? t$7.replace(m$3, h$1.replace(i18n$1.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_, o$2)) : t$7.replace(m$3, h$1)), r$2 == i18n$1.phonenumbers.PhoneNumberFormat.RFC3966 && (t$7 = t$7.replace(RegExp(`^` + i18n$1.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_), ``), t$7 = t$7.replace(new RegExp(i18n$1.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_, `g`), `-`)), t$7;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.getExampleNumber = function(t$7) {
            return this.getExampleNumberForType(t$7, i18n$1.phonenumbers.PhoneNumberType.FIXED_LINE);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForType = function(t$7, o$2) {
            if (!this.isValidRegionCode_(t$7)) return null;
            o$2 = i18n$1.phonenumbers.PhoneNumberUtil.getNumberDescByType_(this.getMetadataForRegion(t$7), o$2);
            try {
              if (o$2.hasExampleNumber()) return this.parse(o$2.getExampleNumber(), t$7);
            } catch {
            }
            return null;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForNonGeoEntity = function(t$7) {
            var o$2 = this.getMetadataForNonGeographicalRegion(t$7);
            if (o$2 != null && (o$2 = [o$2.getMobile(), o$2.getTollFree(), o$2.getSharedCost(), o$2.getVoip(), o$2.getVoicemail(), o$2.getUan(), o$2.getPremiumRate()].find(function(r$2, u) {
              return r$2.hasExampleNumber();
            }), o$2 !== void 0)) try {
              return this.parse(`+` + t$7 + o$2.getExampleNumber(), `ZZ`);
            } catch {
            }
            return null;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.maybeGetFormattedExtension_ = function(t$7, o$2, r$2) {
            return t$7.hasExtension() && t$7.getExtension().length != 0 ? r$2 == i18n$1.phonenumbers.PhoneNumberFormat.RFC3966 ? i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ + t$7.getExtension() : o$2.hasPreferredExtnPrefix() ? o$2.getPreferredExtnPrefix() + t$7.getExtensionOrDefault() : i18n$1.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_ + t$7.getExtensionOrDefault() : ``;
          }, i18n$1.phonenumbers.PhoneNumberUtil.getNumberDescByType_ = function(t$7, o$2) {
            switch (o$2) {
              case i18n$1.phonenumbers.PhoneNumberType.PREMIUM_RATE:
                return t$7.getPremiumRate();
              case i18n$1.phonenumbers.PhoneNumberType.TOLL_FREE:
                return t$7.getTollFree();
              case i18n$1.phonenumbers.PhoneNumberType.MOBILE:
                return t$7.getMobile();
              case i18n$1.phonenumbers.PhoneNumberType.FIXED_LINE:
              case i18n$1.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE:
                return t$7.getFixedLine();
              case i18n$1.phonenumbers.PhoneNumberType.SHARED_COST:
                return t$7.getSharedCost();
              case i18n$1.phonenumbers.PhoneNumberType.VOIP:
                return t$7.getVoip();
              case i18n$1.phonenumbers.PhoneNumberType.PERSONAL_NUMBER:
                return t$7.getPersonalNumber();
              case i18n$1.phonenumbers.PhoneNumberType.PAGER:
                return t$7.getPager();
              case i18n$1.phonenumbers.PhoneNumberType.UAN:
                return t$7.getUan();
              case i18n$1.phonenumbers.PhoneNumberType.VOICEMAIL:
                return t$7.getVoicemail();
              default:
                return t$7.getGeneralDesc();
            }
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.getNumberType = function(t$7) {
            var o$2 = this.getRegionCodeForNumber(t$7);
            return o$2 = this.getMetadataForRegionOrCallingCode_(t$7.getCountryCodeOrDefault(), o$2), o$2 == null ? i18n$1.phonenumbers.PhoneNumberType.UNKNOWN : (t$7 = this.getNationalSignificantNumber(t$7), this.getNumberTypeHelper_(t$7, o$2));
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.getNumberTypeHelper_ = function(t$7, o$2) {
            return this.isNumberMatchingDesc_(t$7, o$2.getGeneralDesc()) ? this.isNumberMatchingDesc_(t$7, o$2.getPremiumRate()) ? i18n$1.phonenumbers.PhoneNumberType.PREMIUM_RATE : this.isNumberMatchingDesc_(t$7, o$2.getTollFree()) ? i18n$1.phonenumbers.PhoneNumberType.TOLL_FREE : this.isNumberMatchingDesc_(t$7, o$2.getSharedCost()) ? i18n$1.phonenumbers.PhoneNumberType.SHARED_COST : this.isNumberMatchingDesc_(t$7, o$2.getVoip()) ? i18n$1.phonenumbers.PhoneNumberType.VOIP : this.isNumberMatchingDesc_(t$7, o$2.getPersonalNumber()) ? i18n$1.phonenumbers.PhoneNumberType.PERSONAL_NUMBER : this.isNumberMatchingDesc_(t$7, o$2.getPager()) ? i18n$1.phonenumbers.PhoneNumberType.PAGER : this.isNumberMatchingDesc_(t$7, o$2.getUan()) ? i18n$1.phonenumbers.PhoneNumberType.UAN : this.isNumberMatchingDesc_(t$7, o$2.getVoicemail()) ? i18n$1.phonenumbers.PhoneNumberType.VOICEMAIL : this.isNumberMatchingDesc_(t$7, o$2.getFixedLine()) ? o$2.getSameMobileAndFixedLinePattern() || this.isNumberMatchingDesc_(t$7, o$2.getMobile()) ? i18n$1.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE : i18n$1.phonenumbers.PhoneNumberType.FIXED_LINE : !o$2.getSameMobileAndFixedLinePattern() && this.isNumberMatchingDesc_(t$7, o$2.getMobile()) ? i18n$1.phonenumbers.PhoneNumberType.MOBILE : i18n$1.phonenumbers.PhoneNumberType.UNKNOWN : i18n$1.phonenumbers.PhoneNumberType.UNKNOWN;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegion = function(t$7) {
            if (t$7 == null) return null;
            t$7 = t$7.toUpperCase();
            var o$2 = this.regionToMetadataMap[t$7];
            if (o$2 == null) {
              o$2 = new goog.proto2.PbLiteSerializer();
              var r$2 = i18n$1.phonenumbers.metadata.countryToMetadata[t$7];
              if (r$2 == null) return null;
              o$2 = o$2.deserialize(i18n$1.phonenumbers.PhoneMetadata.getDescriptor(), r$2), this.regionToMetadataMap[t$7] = o$2;
            }
            return o$2;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.getMetadataForNonGeographicalRegion = function(t$7) {
            return this.getMetadataForRegion(`` + t$7);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.isNumberMatchingDesc_ = function(t$7, o$2) {
            var r$2 = t$7.length;
            return 0 < o$2.possibleLengthCount() && o$2.possibleLengthArray().indexOf(r$2) == -1 ? false : i18n$1.phonenumbers.PhoneNumberUtil.matchesEntirely(o$2.getNationalNumberPatternOrDefault(), t$7);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.isValidNumber = function(t$7) {
            var o$2 = this.getRegionCodeForNumber(t$7);
            return this.isValidNumberForRegion(t$7, o$2);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.isValidNumberForRegion = function(t$7, o$2) {
            var r$2 = t$7.getCountryCodeOrDefault(), u = this.getMetadataForRegionOrCallingCode_(r$2, o$2);
            return u == null || i18n$1.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY != o$2 && r$2 != this.getCountryCodeForValidRegion_(o$2) ? false : (t$7 = this.getNationalSignificantNumber(t$7), this.getNumberTypeHelper_(t$7, u) != i18n$1.phonenumbers.PhoneNumberType.UNKNOWN);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumber = function(t$7) {
            if (t$7 == null) return null;
            var o$2 = t$7.getCountryCodeOrDefault();
            return o$2 = i18n$1.phonenumbers.metadata.countryCodeToRegionCodeMap[o$2], o$2 == null ? null : o$2.length == 1 ? o$2[0] : this.getRegionCodeForNumberFromRegionList_(t$7, o$2);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumberFromRegionList_ = function(t$7, o$2) {
            t$7 = this.getNationalSignificantNumber(t$7);
            for (var r$2, u = o$2.length, h$1 = 0; h$1 < u; h$1++) {
              r$2 = o$2[h$1];
              var m$3 = this.getMetadataForRegion(r$2);
              if (m$3.hasLeadingDigits()) {
                if (t$7.search(m$3.getLeadingDigits()) == 0) return r$2;
              } else if (this.getNumberTypeHelper_(t$7, m$3) != i18n$1.phonenumbers.PhoneNumberType.UNKNOWN) return r$2;
            }
            return null;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForCountryCode = function(t$7) {
            return t$7 = i18n$1.phonenumbers.metadata.countryCodeToRegionCodeMap[t$7], t$7 == null ? i18n$1.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_ : t$7[0];
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.getRegionCodesForCountryCode = function(t$7) {
            return t$7 = i18n$1.phonenumbers.metadata.countryCodeToRegionCodeMap[t$7], t$7 ?? [];
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForRegion = function(t$7) {
            return this.isValidRegionCode_(t$7) ? this.getCountryCodeForValidRegion_(t$7) : 0;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForValidRegion_ = function(t$7) {
            var o$2 = this.getMetadataForRegion(t$7);
            if (o$2 == null) throw Error(`Invalid region code: ` + t$7);
            return o$2.getCountryCodeOrDefault();
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.getNddPrefixForRegion = function(t$7, o$2) {
            return t$7 = this.getMetadataForRegion(t$7), t$7 == null || (t$7 = t$7.getNationalPrefixOrDefault(), t$7.length == 0) ? null : (o$2 && (t$7 = t$7.replace(`~`, ``)), t$7);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.isNANPACountry = function(t$7) {
            return t$7 != null && i18n$1.phonenumbers.metadata.countryCodeToRegionCodeMap[i18n$1.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_].includes(t$7.toUpperCase());
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.isAlphaNumber = function(t$7) {
            return i18n$1.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(t$7) ? (t$7 = new goog.string.StringBuffer(t$7), this.maybeStripExtension(t$7), i18n$1.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n$1.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_, t$7.toString())) : false;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumber = function(t$7) {
            return t$7 = this.isPossibleNumberWithReason(t$7), t$7 == i18n$1.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE || t$7 == i18n$1.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForType = function(t$7, o$2) {
            return t$7 = this.isPossibleNumberForTypeWithReason(t$7, o$2), t$7 == i18n$1.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE || t$7 == i18n$1.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.testNumberLength_ = function(t$7, o$2) {
            return this.testNumberLengthForType_(t$7, o$2, i18n$1.phonenumbers.PhoneNumberType.UNKNOWN);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.testNumberLengthForType_ = function(t$7, o$2, r$2) {
            var u = i18n$1.phonenumbers.PhoneNumberUtil.getNumberDescByType_(o$2, r$2), h$1 = u.possibleLengthCount() == 0 ? o$2.getGeneralDesc().possibleLengthArray() : u.possibleLengthArray();
            if (u = u.possibleLengthLocalOnlyArray(), r$2 == i18n$1.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE) if (i18n$1.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(i18n$1.phonenumbers.PhoneNumberUtil.getNumberDescByType_(o$2, i18n$1.phonenumbers.PhoneNumberType.FIXED_LINE))) r$2 = i18n$1.phonenumbers.PhoneNumberUtil.getNumberDescByType_(o$2, i18n$1.phonenumbers.PhoneNumberType.MOBILE), i18n$1.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(r$2) && (h$1 = h$1.concat(r$2.possibleLengthCount() == 0 ? o$2.getGeneralDesc().possibleLengthArray() : r$2.possibleLengthArray()), h$1.sort(), u.length == 0 ? u = r$2.possibleLengthLocalOnlyArray() : (u = u.concat(r$2.possibleLengthLocalOnlyArray()), u.sort()));
            else return this.testNumberLengthForType_(t$7, o$2, i18n$1.phonenumbers.PhoneNumberType.MOBILE);
            return h$1[0] == -1 ? i18n$1.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH : (t$7 = t$7.length, -1 < u.indexOf(t$7) ? i18n$1.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY : (o$2 = h$1[0], o$2 == t$7 ? i18n$1.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE : o$2 > t$7 ? i18n$1.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT : h$1[h$1.length - 1] < t$7 ? i18n$1.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG : -1 < h$1.indexOf(t$7, 1) ? i18n$1.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE : i18n$1.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH));
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberWithReason = function(t$7) {
            return this.isPossibleNumberForTypeWithReason(t$7, i18n$1.phonenumbers.PhoneNumberType.UNKNOWN);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForTypeWithReason = function(t$7, o$2) {
            var r$2 = this.getNationalSignificantNumber(t$7);
            if (t$7 = t$7.getCountryCodeOrDefault(), !this.hasValidCountryCallingCode_(t$7)) return i18n$1.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_COUNTRY_CODE;
            var u = this.getRegionCodeForCountryCode(t$7);
            return t$7 = this.getMetadataForRegionOrCallingCode_(t$7, u), this.testNumberLengthForType_(r$2, t$7, o$2);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberString = function(t$7, o$2) {
            try {
              return this.isPossibleNumber(this.parse(t$7, o$2));
            } catch {
              return false;
            }
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.truncateTooLongNumber = function(t$7) {
            if (this.isValidNumber(t$7)) return true;
            var o$2 = t$7.clone(), r$2 = t$7.getNationalNumberOrDefault();
            do
              if (r$2 = Math.floor(r$2 / 10), o$2.setNationalNumber(r$2), r$2 == 0 || this.isPossibleNumberWithReason(o$2) == i18n$1.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT) return false;
            while (!this.isValidNumber(o$2));
            return t$7.setNationalNumber(r$2), true;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.extractCountryCode = function(t$7, o$2) {
            if (t$7 = t$7.toString(), t$7.length == 0 || t$7.charAt(0) == `0`) return 0;
            for (var r$2, u = t$7.length, h$1 = 1; h$1 <= i18n$1.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_ && h$1 <= u; ++h$1) if (r$2 = parseInt(t$7.substring(0, h$1), 10), r$2 in i18n$1.phonenumbers.metadata.countryCodeToRegionCodeMap) return o$2.append(t$7.substring(h$1)), r$2;
            return 0;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.maybeExtractCountryCode = function(t$7, o$2, r$2, u, h$1) {
            if (t$7.length == 0) return 0;
            t$7 = new goog.string.StringBuffer(t$7);
            var m$3;
            if (o$2 != null && (m$3 = o$2.getInternationalPrefix()), m$3 ??= `NonMatch`, m$3 = this.maybeStripInternationalPrefixAndNormalize(t$7, m$3), u && h$1.setCountryCodeSource(m$3), m$3 != i18n$1.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY) {
              if (t$7.getLength() <= i18n$1.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_) throw Error(i18n$1.phonenumbers.Error.TOO_SHORT_AFTER_IDD);
              if (o$2 = this.extractCountryCode(t$7, r$2), o$2 != 0) return h$1.setCountryCode(o$2), o$2;
              throw Error(i18n$1.phonenumbers.Error.INVALID_COUNTRY_CODE);
            }
            if (o$2 != null) {
              m$3 = o$2.getCountryCodeOrDefault();
              var y$1 = `` + m$3, S = t$7.toString();
              if (goog.string.startsWith(S, y$1) && (y$1 = new goog.string.StringBuffer(S.substring(y$1.length)), S = o$2.getGeneralDesc(), S = new RegExp(S.getNationalNumberPatternOrDefault()), this.maybeStripNationalPrefixAndCarrierCode(y$1, o$2, null), y$1 = y$1.toString(), !i18n$1.phonenumbers.PhoneNumberUtil.matchesEntirely(S, t$7.toString()) && i18n$1.phonenumbers.PhoneNumberUtil.matchesEntirely(S, y$1) || this.testNumberLength_(t$7.toString(), o$2) == i18n$1.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG)) return r$2.append(y$1), u && h$1.setCountryCodeSource(i18n$1.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN), h$1.setCountryCode(m$3), m$3;
            }
            return h$1.setCountryCode(0), 0;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.parsePrefixAsIdd_ = function(t$7, o$2) {
            var r$2 = o$2.toString();
            if (r$2.search(t$7) == 0) {
              t$7 = r$2.match(t$7)[0].length;
              var u = r$2.substring(t$7).match(i18n$1.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN);
              return u && u[1] != null && 0 < u[1].length && i18n$1.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(u[1]) == `0` ? false : (o$2.clear(), o$2.append(r$2.substring(t$7)), true);
            }
            return false;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.maybeStripInternationalPrefixAndNormalize = function(t$7, o$2) {
            var r$2 = t$7.toString();
            return r$2.length == 0 ? i18n$1.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY : i18n$1.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(r$2) ? (r$2 = r$2.replace(i18n$1.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN, ``), t$7.clear(), t$7.append(i18n$1.phonenumbers.PhoneNumberUtil.normalize(r$2)), i18n$1.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN) : (o$2 = new RegExp(o$2), i18n$1.phonenumbers.PhoneNumberUtil.normalizeSB_(t$7), this.parsePrefixAsIdd_(o$2, t$7) ? i18n$1.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD : i18n$1.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.maybeStripNationalPrefixAndCarrierCode = function(t$7, o$2, r$2) {
            var u = t$7.toString(), h$1 = u.length, m$3 = o$2.getNationalPrefixForParsing();
            if (h$1 == 0 || m$3 == null || m$3.length == 0) return false;
            var y$1 = RegExp(`^(?:` + m$3 + `)`);
            if (h$1 = y$1.exec(u)) {
              m$3 = new RegExp(o$2.getGeneralDesc().getNationalNumberPatternOrDefault());
              var S = i18n$1.phonenumbers.PhoneNumberUtil.matchesEntirely(m$3, u), _ = h$1.length - 1;
              if (o$2 = o$2.getNationalPrefixTransformRule(), o$2 == null || o$2.length == 0 || h$1[_] == null || h$1[_].length == 0) {
                if (S && !i18n$1.phonenumbers.PhoneNumberUtil.matchesEntirely(m$3, u.substring(h$1[0].length))) return false;
                r$2 != null && 0 < _ && h$1[_] != null && r$2.append(h$1[1]), t$7.set(u.substring(h$1[0].length));
              } else {
                if (u = u.replace(y$1, o$2), S && !i18n$1.phonenumbers.PhoneNumberUtil.matchesEntirely(m$3, u)) return false;
                r$2 != null && 0 < _ && r$2.append(h$1[1]), t$7.set(u);
              }
              return true;
            }
            return false;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.maybeStripExtension = function(t$7) {
            var o$2 = t$7.toString(), r$2 = o$2.search(i18n$1.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_);
            if (0 <= r$2 && i18n$1.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(o$2.substring(0, r$2))) {
              for (var u = o$2.match(i18n$1.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_), h$1 = u.length, m$3 = 1; m$3 < h$1; ++m$3) if (u[m$3] != null && 0 < u[m$3].length) return t$7.clear(), t$7.append(o$2.substring(0, r$2)), u[m$3];
            }
            return ``;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.checkRegionForParsing_ = function(t$7, o$2) {
            return this.isValidRegionCode_(o$2) || t$7 != null && 0 < t$7.length && i18n$1.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(t$7);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.parse = function(t$7, o$2) {
            return this.parseHelper_(t$7, o$2, false, true);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.parseAndKeepRawInput = function(t$7, o$2) {
            if (!this.isValidRegionCode_(o$2) && 0 < t$7.length && t$7.charAt(0) != i18n$1.phonenumbers.PhoneNumberUtil.PLUS_SIGN) throw Error(i18n$1.phonenumbers.Error.INVALID_COUNTRY_CODE);
            return this.parseHelper_(t$7, o$2, true, true);
          }, i18n$1.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_ = function(t$7, o$2) {
            if (1 < t$7.length && t$7.charAt(0) == `0`) {
              o$2.setItalianLeadingZero(true);
              for (var r$2 = 1; r$2 < t$7.length - 1 && t$7.charAt(r$2) == `0`; ) r$2++;
              r$2 != 1 && o$2.setNumberOfLeadingZeros(r$2);
            }
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.parseHelper_ = function(t$7, o$2, r$2, u) {
            if (t$7 == null) throw Error(i18n$1.phonenumbers.Error.NOT_A_NUMBER);
            if (t$7.length > i18n$1.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_) throw Error(i18n$1.phonenumbers.Error.TOO_LONG);
            var h$1 = new goog.string.StringBuffer();
            if (this.buildNationalNumberForParsing_(t$7, h$1), !i18n$1.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(h$1.toString())) throw Error(i18n$1.phonenumbers.Error.NOT_A_NUMBER);
            if (u && !this.checkRegionForParsing_(h$1.toString(), o$2)) throw Error(i18n$1.phonenumbers.Error.INVALID_COUNTRY_CODE);
            u = new i18n$1.phonenumbers.PhoneNumber(), r$2 && u.setRawInput(t$7), t$7 = this.maybeStripExtension(h$1), 0 < t$7.length && u.setExtension(t$7);
            var m$3 = this.getMetadataForRegion(o$2);
            t$7 = new goog.string.StringBuffer();
            var y$1 = 0, S = h$1.toString();
            try {
              y$1 = this.maybeExtractCountryCode(S, m$3, t$7, r$2, u);
            } catch (_) {
              if (_.message == i18n$1.phonenumbers.Error.INVALID_COUNTRY_CODE && i18n$1.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(S)) {
                if (S = S.replace(i18n$1.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN, ``), y$1 = this.maybeExtractCountryCode(S, m$3, t$7, r$2, u), y$1 == 0) throw _;
              } else throw _;
            }
            if (y$1 == 0 ? (i18n$1.phonenumbers.PhoneNumberUtil.normalizeSB_(h$1), t$7.append(h$1.toString()), o$2 == null ? r$2 && u.clearCountryCodeSource() : (y$1 = m$3.getCountryCodeOrDefault(), u.setCountryCode(y$1))) : (h$1 = this.getRegionCodeForCountryCode(y$1), h$1 != o$2 && (m$3 = this.getMetadataForRegionOrCallingCode_(y$1, h$1))), t$7.getLength() < i18n$1.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ || (m$3 != null && (o$2 = new goog.string.StringBuffer(), h$1 = new goog.string.StringBuffer(t$7.toString()), this.maybeStripNationalPrefixAndCarrierCode(h$1, m$3, o$2), m$3 = this.testNumberLength_(h$1.toString(), m$3), y$1 = i18n$1.phonenumbers.PhoneNumberUtil.ValidationResult, m$3 != y$1.TOO_SHORT && m$3 != y$1.IS_POSSIBLE_LOCAL_ONLY && m$3 != y$1.INVALID_LENGTH && (t$7 = h$1, r$2 && 0 < o$2.toString().length && u.setPreferredDomesticCarrierCode(o$2.toString()))), r$2 = t$7.toString(), t$7 = r$2.length, t$7 < i18n$1.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_)) throw Error(i18n$1.phonenumbers.Error.TOO_SHORT_NSN);
            if (t$7 > i18n$1.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_) throw Error(i18n$1.phonenumbers.Error.TOO_LONG);
            return i18n$1.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_(r$2, u), u.setNationalNumber(parseInt(r$2, 10)), u;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.extractPhoneContext_ = function(t$7) {
            var o$2 = t$7.indexOf(i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_);
            if (o$2 === -1) return null;
            if (o$2 += i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_.length, o$2 >= t$7.length) return ``;
            var r$2 = t$7.indexOf(`;`, o$2);
            return r$2 === -1 ? t$7.substring(o$2) : t$7.substring(o$2, r$2);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.isPhoneContextValid_ = function(t$7) {
            if (t$7 == null) return true;
            if (t$7.length === 0) return false;
            var o$2 = i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.exec(t$7);
            return t$7 = i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_PATTERN_.exec(t$7), o$2 !== null || t$7 !== null;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.buildNationalNumberForParsing_ = function(t$7, o$2) {
            var r$2 = i18n$1.phonenumbers.PhoneNumberUtil.prototype.extractPhoneContext_(t$7);
            if (!i18n$1.phonenumbers.PhoneNumberUtil.prototype.isPhoneContextValid_(r$2)) throw Error(i18n$1.phonenumbers.Error.NOT_A_NUMBER);
            if (r$2 != null) {
              r$2.charAt(0) === i18n$1.phonenumbers.PhoneNumberUtil.PLUS_SIGN && o$2.append(r$2), r$2 = t$7.indexOf(i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_), r$2 = 0 <= r$2 ? r$2 + i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_.length : 0;
              var u = t$7.indexOf(i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_);
              o$2.append(t$7.substring(r$2, u));
            } else o$2.append(i18n$1.phonenumbers.PhoneNumberUtil.extractPossibleNumber(t$7 ?? ``));
            t$7 = o$2.toString(), r$2 = t$7.indexOf(i18n$1.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_), 0 < r$2 && (o$2.clear(), o$2.append(t$7.substring(0, r$2)));
          }, i18n$1.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_ = function(t$7) {
            var o$2 = new i18n$1.phonenumbers.PhoneNumber();
            return o$2.setCountryCode(t$7.getCountryCodeOrDefault()), o$2.setNationalNumber(t$7.getNationalNumberOrDefault()), 0 < t$7.getExtensionOrDefault().length && o$2.setExtension(t$7.getExtensionOrDefault()), t$7.getItalianLeadingZero() && (o$2.setItalianLeadingZero(true), o$2.setNumberOfLeadingZeros(t$7.getNumberOfLeadingZerosOrDefault())), o$2;
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.isNumberMatch = function(t$7, o$2) {
            if (typeof t$7 == `string`) try {
              var r$2 = this.parse(t$7, i18n$1.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_);
            } catch (m$3) {
              if (m$3.message != i18n$1.phonenumbers.Error.INVALID_COUNTRY_CODE) return i18n$1.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
              if (typeof o$2 != `string`) {
                var u = this.getRegionCodeForCountryCode(o$2.getCountryCodeOrDefault());
                if (u != i18n$1.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_) {
                  try {
                    r$2 = this.parse(t$7, u);
                  } catch {
                    return i18n$1.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
                  }
                  var h$1 = this.isNumberMatch(r$2, o$2);
                  return h$1 == i18n$1.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH ? i18n$1.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH : h$1;
                }
              }
              try {
                r$2 = this.parseHelper_(t$7, null, false, false);
              } catch {
                return i18n$1.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
              }
            }
            else r$2 = t$7.clone();
            if (typeof o$2 == `string`) try {
              return h$1 = this.parse(o$2, i18n$1.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_), this.isNumberMatch(t$7, h$1);
            } catch (m$3) {
              return m$3.message == i18n$1.phonenumbers.Error.INVALID_COUNTRY_CODE ? this.isNumberMatch(o$2, r$2) : i18n$1.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
            }
            else h$1 = o$2.clone();
            return t$7 = i18n$1.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(r$2), h$1 = i18n$1.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(h$1), t$7.hasExtension() && h$1.hasExtension() && t$7.getExtension() != h$1.getExtension() ? i18n$1.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH : (o$2 = t$7.getCountryCodeOrDefault(), r$2 = h$1.getCountryCodeOrDefault(), o$2 != 0 && r$2 != 0 ? t$7.equals(h$1) ? i18n$1.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH : o$2 == r$2 && this.isNationalNumberSuffixOfTheOther_(t$7, h$1) ? i18n$1.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH : i18n$1.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH : (t$7.setCountryCode(0), h$1.setCountryCode(0), t$7.equals(h$1) ? i18n$1.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH : this.isNationalNumberSuffixOfTheOther_(t$7, h$1) ? i18n$1.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH : i18n$1.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH));
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.isNationalNumberSuffixOfTheOther_ = function(t$7, o$2) {
            return t$7 = `` + t$7.getNationalNumber(), o$2 = `` + o$2.getNationalNumber(), goog.string.endsWith(t$7, o$2) || goog.string.endsWith(o$2, t$7);
          }, i18n$1.phonenumbers.PhoneNumberUtil.prototype.canBeInternationallyDialled = function(t$7) {
            var o$2 = this.getMetadataForRegion(this.getRegionCodeForNumber(t$7));
            return o$2 == null ? true : (t$7 = this.getNationalSignificantNumber(t$7), !this.isNumberMatchingDesc_(t$7, o$2.getNoInternationalDialling()));
          }, i18n$1.phonenumbers.PhoneNumberUtil.matchesEntirely = function(t$7, o$2) {
            return !!((t$7 = typeof t$7 == `string` ? o$2.match(`^(?:` + t$7 + `)$`) : o$2.match(t$7)) && t$7[0].length == o$2.length);
          }, i18n$1.phonenumbers.PhoneNumberUtil.matchesPrefix = function(t$7, o$2) {
            return !!((t$7 = typeof t$7 == `string` ? o$2.match(`^(?:` + t$7 + `)`) : o$2.match(t$7)) && goog.string.startsWith(o$2, t$7[0]));
          }, i18n$1.phonenumbers.shortnumbermetadata = {}, i18n$1.phonenumbers.shortnumbermetadata.countryCodeToRegionCodeMap = { 0: `AC AD AE AF AG AI AL AM AO AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GR GT GU GW GY HK HN HR HT HU ID IE IL IM IN IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TG TH TJ TL TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW`.split(` `) }, i18n$1.phonenumbers.shortnumbermetadata.countryToMetadata = { AC: [, [, , `9\\d\\d`, , , , , , , [3]], , , [, , `9(?:11|99)`, , , , `911`], [, , , , , , , , , [-1]], , , , `AC`, , , , , , , , , , , , , , , , , , [, , `9(?:11|99)`, , , , `911`], , [, , `9(?:11|99)`, , , , `911`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], AD: [, [, , `1\\d\\d`, , , , , , , [3]], , , [, , `11[0268]`, , , , `110`], [, , , , , , , , , [-1]], , , , `AD`, , , , , , , , , , , , , , , , , , [, , `11[0268]`, , , , `110`], , [, , `11[0268]`, , , , `110`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], AE: [, [, , `[149]\\d{2,3}`, , , , , , , [3, 4]], , , [, , `112|99[7-9]`, , , , `112`, , , [3]], [, , , , , , , , , [-1]], , , , `AE`, , , , , , , , , , , , , , , , , , [, , `112|99[7-9]`, , , , `112`, , , [3]], , [, , `112|445[16]|99[7-9]`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , `445\\d`, , , , `4450`, , , [4]]], AF: [, [, , `[14]\\d\\d(?:\\d{2})?`, , , , , , , [3, 5]], , , [, , `1(?:0[02]|19)`, , , , `100`, , , [3]], [, , , , , , , , , [-1]], , , , `AF`, , , , , , , , , , , , , , , , , , [, , `1(?:0[02]|19)`, , , , `100`, , , [3]], , [, , `1(?:0[02]|19)|40404`, , , , `100`], [, , , , , , , , , [-1]], [, , `404\\d\\d`, , , , `40400`, , , [5]], , [, , `404\\d\\d`, , , , `40400`, , , [5]]], AG: [, [, , `[19]\\d\\d`, , , , , , , [3]], , , [, , `9(?:11|88|99)`, , , , `911`], [, , , , , , , , , [-1]], , , , `AG`, , , , , , , , , , , , , , , , , , [, , `9(?:11|99)`, , , , `911`], , [, , `176|9(?:11|88|99)`, , , , `176`], [, , , , , , , , , [-1]], [, , `176`, , , , `176`], , [, , `176`, , , , `176`]], AI: [, [, , `[19]\\d\\d`, , , , , , , [3]], , , [, , `9(?:11|88)`, , , , `911`], [, , , , , , , , , [-1]], , , , `AI`, , , , , , , , , , , , , , , , , , [, , `911`, , , , `911`], , [, , `176|9(?:11|88)`, , , , `176`], [, , , , , , , , , [-1]], [, , `176`, , , , `176`], , [, , `176`, , , , `176`]], AL: [, [, , `[15]\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `1(?:1(?:2|6[01]\\d\\d)|2[7-9]|3[15]|41)`, , , , `112`, , , [3, 6]], [, , `5\\d{4}`, , , , `50000`, , , [5]], , , , `AL`, , , , , , , , , , , , , , , , , , [, , `1(?:12|2[7-9])`, , , , `112`, , , [3]], , [, , `1(?:1(?:6(?:000|1(?:06|11|23))|8\\d\\d)|65\\d|89[12])|5\\d{4}|1(?:[1349]\\d|2[2-9])`, , , , `110`], [, , , , , , , , , [-1]], [, , `123`, , , , `123`, , , [3]], , [, , `131|5\\d{4}`, , , , `131`, , , [3, 5]]], AM: [, [, , `[148]\\d{2,4}`, , , , , , , [3, 4, 5]], , , [, , `10[1-3]`, , , , `101`, , , [3]], [, , , , , , , , , [-1]], , , , `AM`, , , , , , , , , , , , , , , , , , [, , `10[1-3]`, , , , `101`, , , [3]], , [, , `(?:1|8[1-7])\\d\\d|40404`, , , , `100`], [, , , , , , , , , [-1]], [, , `404\\d\\d`, , , , `40400`, , , [5]], , [, , `404\\d\\d`, , , , `40400`, , , [5]]], AO: [, [, , `1\\d\\d`, , , , , , , [3]], , , [, , `11[235]`, , , , `112`], [, , , , , , , , , [-1]], , , , `AO`, , , , , , , , , , , , , , , , , , [, , `11[235]`, , , , `112`], , [, , `11[235]`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], AR: [, [, , `[01389]\\d{1,4}`, , , , , , , [2, 3, 4, 5]], , , [, , `000|1(?:0[0-35-7]|1[0245]|2[015]|3[47]|4[478]|9)|911`, , , , `19`, , , [2, 3]], [, , , , , , , , , [-1]], , , , `AR`, , , , , , , , , , , , , , , , , , [, , `10[017]|911`, , , , `100`, , , [3]], , [, , `000|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478]|9)|3372|89338|911`, , , , `19`], [, , , , , , , , , [-1]], [, , `893\\d\\d`, , , , `89300`, , , [5]], , [, , `(?:337|893\\d)\\d`, , , , `3370`, , , [4, 5]]], AS: [, [, , `[49]\\d\\d(?:\\d{2})?`, , , , , , , [3, 5]], , , [, , `9(?:11|88)`, , , , `911`, , , [3]], [, , , , , , , , , [-1]], , , , `AS`, , , , , , , , , , , , , , , , , , [, , `911`, , , , `911`, , , [3]], , [, , `40404|9(?:11|88)`, , , , `911`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , `404\\d\\d`, , , , `40400`, , , [5]]], AT: [, [, , `[1268]\\d\\d(?:\\d(?:\\d{2})?)?`, , , , , , , [3, 4, 6]], , , [, , `1(?:12|2[0238]|3[03]|4[0-247])|1(?:16\\d\\d|4[58])\\d`, , , , `112`], [, , , , , , , , , [-1]], , , , `AT`, , , , , , , , , , , , , , , , , , [, , `1(?:[12]2|33|44)`, , , , `112`, , , [3]], , [, , `1(?:1(?:2|6(?:00[06]|1(?:17|23)))|2[0238]|3[03]|4(?:[0-247]|5[05]|84))|(?:220|61|8108[1-3])0`, , , , `112`], [, , , , , , , , , [-1]], [, , `(?:220|810\\d\\d)\\d|610`, , , , `610`], , [, , , , , , , , , [-1]]], AU: [, [, , `[0-27]\\d{2,7}`, , , , , , , [3, 4, 5, 6, 7, 8]], , , [, , `000|1(?:06|12|258885|55\\d)|733`, , , , `000`, , , [3, 4, 7]], [, , `1(?:2(?:34|456)|9\\d{4,6})`, , , , `1234`, , , [4, 5, 6, 7, 8]], , , , `AU`, , , , , , , , , , , , , , , , , , [, , `000|1(?:06|12)`, , , , `000`, , , [3]], , [, , `000|1(?:06|1(?:00|2|9[46])|2(?:014[1-3]|[23]\\d|(?:4|5\\d)\\d{2,3}|68[689]|72(?:20|3\\d\\d)|8(?:[013-9]\\d|2))|555|9\\d{4,6})|225|7(?:33|67)`, , , , `000`], [, , `1(?:1[09]\\d|24733)|225|767`, , , , `225`, , , [3, 4, 6]], [, , `1(?:258885|55\\d)`, , , , `1550`, , , [4, 7]], , [, , `19\\d{4,6}`, , , , `190000`, , , [6, 7, 8]]], AW: [, [, , `[19]\\d\\d`, , , , , , , [3]], , , [, , `100|911`, , , , `100`], [, , , , , , , , , [-1]], , , , `AW`, , , , , , , , , , , , , , , , , , [, , `100|911`, , , , `100`], , [, , `1(?:00|18|76)|91[13]`, , , , `100`], [, , , , , , , , , [-1]], [, , `176`, , , , `176`], , [, , `176`, , , , `176`]], AX: [, [, , `[17]\\d\\d(?:\\d{2})?`, , , , , , , [3, 5]], , , [, , `112`, , , , `112`, , , [3]], [, , , , , , , , , [-1]], , , , `AX`, , , , , , , , , , , , , , , , , , [, , `112`, , , , `112`, , , [3]], , [, , `112|75[12]\\d\\d`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], AZ: [, [, , `[148]\\d{2,3}`, , , , , , , [3, 4]], , , [, , `1(?:0[1-3]|12)`, , , , `101`, , , [3]], [, , , , , , , , , [-1]], , , , `AZ`, , , , , , , , , , , , , , , , , , [, , `1(?:0[1-3]|12)`, , , , `101`, , , [3]], , [, , `1(?:0[1-3]|12)|(?:404|880)0`, , , , `101`], [, , , , , , , , , [-1]], [, , `(?:404|880)\\d`, , , , `4040`, , , [4]], , [, , `(?:404|880)\\d`, , , , `4040`, , , [4]]], BA: [, [, , `1\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `1(?:16\\d{3}|2[2-4])`, , , , `122`, , , [3, 6]], [, , , , , , , , , [-1]], , , , `BA`, , , , , , , , , , , , , , , , , , [, , `12[2-4]`, , , , `122`, , , [3]], , [, , `1(?:16(?:00[06]|1(?:1[17]|23))|2(?:0[0-7]|[2-5]|6[0-26])|(?:[3-5]|7\\d)\\d\\d)|1(?:18|2[78])\\d\\d?`, , , , `122`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], BB: [, [, , `[2-689]\\d\\d`, , , , , , , [3]], , , [, , `988|[2359]11`, , , , `211`], [, , , , , , , , , [-1]], , , , `BB`, , , , , , , , , , , , , , , , , , [, , `[2359]11`, , , , `211`], , [, , `988|[2-689]11`, , , , `211`], [, , , , , , , , , [-1]], [, , `[468]11`, , , , `411`], , [, , , , , , , , , [-1]]], BD: [, [, , `[1579]\\d{2,4}`, , , , , , , [3, 4, 5]], , , [, , `10[0-26]|[19]99`, , , , `100`, , , [3]], [, , , , , , , , , [-1]], , , , `BD`, , , , , , , , , , , , , , , , , , [, , `10[0-2]|[19]99`, , , , `100`, , , [3]], , [, , `1(?:0(?:[0-369]|5[1-4]|7[0-4]|8[0-29])|1[16-9]|2(?:[134]|2[0-5])|3(?:1\\d?|6[3-6])|5[2-9])|5012|786|9594|[19]99|1(?:0(?:50|6\\d)|33|4(?:0|1\\d))\\d`, , , , `100`], [, , , , , , , , , [-1]], [, , `1(?:11|2[13])|(?:501|959)\\d|786`, , , , `111`, , , [3, 4]], , [, , `959\\d`, , , , `9590`, , , [4]]], BE: [, [, , `[1-9]\\d\\d(?:\\d(?:\\d{2})?)?`, , , , , , , [3, 4, 6]], , , [, , `1(?:0[0-35-8]|1[0269]|7(?:12|77)|813)|(?:116|8)\\d{3}`, , , , `100`], [, , `1(?:2[03]|40)4|(?:1(?:[24]1|3[01])|[2-79]\\d\\d)\\d`, , , , `1204`, , , [4]], , , , `BE`, , , , , , , , , , , , , , , , , , [, , `1(?:0[01]|12)`, , , , `100`, , , [3]], , [, , `1(?:0[0-8]|16117|2(?:12|3[0-24])|313|414|5(?:1[05]|5[15]|66|95)|6(?:1[167]|36|6[16])|7(?:[07][017]|1[27-9]|22|33|65)|81[39])|[2-9]\\d{3}|11[02679]|1(?:1600|45)0|1(?:[2-4]9|78)9|1[2-4]0[47]`, , , , `100`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , `[2-9]\\d{3}`, , , , `2000`, , , [4]]], BF: [, [, , `1\\d`, , , , , , , [2]], , , [, , `1[78]`, , , , `17`], [, , , , , , , , , [-1]], , , , `BF`, , , , , , , , , , , , , , , , , , [, , `1[78]`, , , , `17`], , [, , `1[78]`, , , , `17`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], BG: [, [, , `1\\d\\d(?:\\d{3})?`, , , , , , , [3, 6]], , , [, , `1(?:1(?:2|6\\d{3})|50|6[06])`, , , , `112`], [, , , , , , , , , [-1]], , , , `BG`, , , , , , , , , , , , , , , , , , [, , `1(?:12|50|6[06])`, , , , `112`, , , [3]], , [, , `1(?:1(?:2|6(?:000|111))|50|6[06])`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], BH: [, [, , `[0189]\\d\\d(?:\\d{2})?`, , , , , , , [3, 5]], , , [, , `(?:0[167]|81)\\d{3}|[19]99`, , , , `199`], [, , `9[148]\\d{3}`, , , , `91000`, , , [5]], , , , `BH`, , , , , , , , , , , , , , , , , , [, , `[19]99`, , , , `199`, , , [3]], , [, , `1(?:[02]\\d|12|4[01]|51|8[18]|9[169])|99[02489]|(?:0[167]|8[158]|9[148])\\d{3}`, , , , `100`], [, , , , , , , , , [-1]], [, , `0[67]\\d{3}|88000|98555`, , , , `06000`, , , [5]], , [, , `88000|98555`, , , , `88000`, , , [5]]], BI: [, [, , `[16-9]\\d{2,3}`, , , , , , , [3, 4]], , , [, , `11[237]|611`, , , , `112`, , , [3]], [, , , , , , , , , [-1]], , , , `BI`, , , , , , , , , , , , , , , , , , [, , `11[237]`, , , , `112`, , , [3]], , [, , `1(?:1\\d|5[2-9]|6[0-256])|611|7(?:10|77|979)|8[28]8|900`, , , , `110`], [, , , , , , , , , [-1]], [, , `611|7(?:10|77)|888|900`, , , , `611`, , , [3]], , [, , `(?:71|90)0`, , , , `710`, , , [3]]], BJ: [, [, , `[17]\\d{2,3}`, , , , , , , [3, 4]], , , [, , `1(?:1[246-8]|3[68]|6[06])|7[3-5]\\d\\d`, , , , `112`], [, , , , , , , , , [-1]], , , , `BJ`, , , , , , , , , , , , , , , , , , [, , `11[246-8]`, , , , `112`, , , [3]], , [, , `1(?:05|1[24-8]|2[02-5]|3[126-8]|5[05]|6[06]|89)|7[0-5]\\d\\d`, , , , `105`], [, , , , , , , , , [-1]], [, , `12[02-5]`, , , , `120`, , , [3]], , [, , , , , , , , , [-1]]], BL: [, [, , `1\\d`, , , , , , , [2]], , , [, , `18`, , , , `18`], [, , , , , , , , , [-1]], , , , `BL`, , , , , , , , , , , , , , , , , , [, , `18`, , , , `18`], , [, , `18`, , , , `18`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], BM: [, [, , `[19]\\d\\d`, , , , , , , [3]], , , [, , `9(?:11|88)`, , , , `911`], [, , , , , , , , , [-1]], , , , `BM`, , , , , , , , , , , , , , , , , , [, , `911`, , , , `911`], , [, , `176|9(?:11|88)`, , , , `176`], [, , , , , , , , , [-1]], [, , `176`, , , , `176`], , [, , `176`, , , , `176`]], BN: [, [, , `9\\d\\d`, , , , , , , [3]], , , [, , `99[135]`, , , , `991`], [, , , , , , , , , [-1]], , , , `BN`, , , , , , , , , , , , , , , , , , [, , `99[135]`, , , , `991`], , [, , `99[135]`, , , , `991`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], BO: [, [, , `[14]\\d\\d(?:\\d{2})?`, , , , , , , [3, 5]], , , [, , `11[089]`, , , , `110`, , , [3]], [, , , , , , , , , [-1]], , , , `BO`, , , , , , , , , , , , , , , , , , [, , `11[089]`, , , , `110`, , , [3]], , [, , `11[089]|40404`, , , , `110`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , `404\\d\\d`, , , , `40400`, , , [5]]], BQ: [, [, , `[19]\\d\\d`, , , , , , , [3]], , , [, , `112|911`, , , , `112`], [, , , , , , , , , [-1]], , , , `BQ`, , , , , , , , , , , , , , , , , , [, , `112|911`, , , , `112`], , [, , `1(?:12|76)|911`, , , , `112`], [, , , , , , , , , [-1]], [, , `176`, , , , `176`], , [, , `176`, , , , `176`]], BR: [, [, , `[1-69]\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `1(?:00|12|28|8[015]|9[0-47-9])|4(?:57|82\\d)|911`, , , , `100`, , , [3, 4]], [, , , , , , , , , [-1]], , , , `BR`, , , , , , , , , , , , , , , , , , [, , `1(?:12|28|9[023])|911`, , , , `112`, , , [3]], , [, , `1(?:0(?:[02]|3(?:1[2-579]|2[13-9]|3[124-9]|4[1-3578]|5[1-468]|6[139]|8[149]|9[168])|5[0-35-9]|6(?:0|1[0-35-8]?|2[0145]|3[0137]?|4[37-9]?|5[0-35]|6[016]?|7[137]?|8[5-8]|9[1359]))|1[25-8]|2[357-9]|3[024-68]|4[12568]|5\\d|6[0-8]|8[015]|9[0-47-9])|2(?:7(?:330|878)|85959?)|(?:32|91)1|4(?:0404?|57|828)|55555|6(?:0\\d{4}|10000)|(?:133|411)[12]`, , , , `100`], [, , `102|273\\d\\d|321`, , , , `102`, , , [3, 5]], [, , `151|(?:278|555)\\d\\d|4(?:04\\d\\d?|11\\d|57)`, , , , `151`, , , [3, 4, 5]], , [, , `285\\d{2,3}|321|40404|(?:27[38]\\d|482)\\d|6(?:0\\d|10)\\d{3}`, , , , `321`]], BS: [, [, , `9\\d\\d`, , , , , , , [3]], , , [, , `9(?:1[19]|88)`, , , , `911`], [, , , , , , , , , [-1]], , , , `BS`, , , , , , , , , , , , , , , , , , [, , `91[19]`, , , , `911`], , [, , `9(?:1[19]|88)`, , , , `911`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], BT: [, [, , `[14]\\d\\d(?:\\d{2})?`, , , , , , , [3, 5]], , , [, , `11[023]`, , , , `110`, , , [3]], [, , , , , , , , , [-1]], , , , `BT`, , , , , , , , , , , , , , , , , , [, , `11[023]`, , , , `110`, , , [3]], , [, , `11[0-6]|40404`, , , , `110`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , `404\\d\\d`, , , , `40400`, , , [5]]], BW: [, [, , `[19]\\d\\d(?:\\d{2})?`, , , , , , , [3, 5]], , , [, , `9(?:11|9[7-9])`, , , , `911`, , , [3]], [, , , , , , , , , [-1]], , , , `BW`, , , , , , , , , , , , , , , , , , [, , `9(?:11|9[7-9])`, , , , `911`, , , [3]], , [, , `1(?:1[26]|3123)|9(?:1[14]|9[1-57-9])`, , , , `112`], [, , , , , , , , , [-1]], [, , `131\\d\\d`, , , , `13100`, , , [5]], , [, , `131\\d\\d`, , , , `13100`, , , [5]]], BY: [, [, , `1\\d\\d`, , , , , , , [3]], , , [, , `1(?:0[1-3]|12)`, , , , `101`], [, , , , , , , , , [-1]], , , , `BY`, , , , , , , , , , , , , , , , , , [, , `1(?:0[1-3]|12)`, , , , `101`], , [, , `1(?:0[1-79]|1[246]|35|5[1-35]|6[89]|7[5-7]|8[58]|9[1-7])`, , , , `101`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], BZ: [, [, , `9\\d\\d?`, , , , , , , [2, 3]], , , [, , `9(?:0|11|22|66|77|9[09])`, , , , `90`], [, , , , , , , , , [-1]], , , , `BZ`, , , , , , , , , , , , , , , , , , [, , `9(?:0|11|90)`, , , , `90`], , [, , `9(?:0|11|22|66|77|9[09])`, , , , `90`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CA: [, [, , `[1-9]\\d\\d(?:\\d{2,3})?`, , , , , , , [3, 5, 6]], , , [, , `112|988|[29]11`, , , , `112`, , , [3]], [, , , , , , , , , [-1]], , , , `CA`, , , , , , , , , , , , , , , , , , [, , `112|911`, , , , `112`, , , [3]], , [, , `[1-35-9]\\d{4,5}|112|[2-8]11|9(?:11|88)`, , , , `112`], [, , , , , , , , , [-1]], [, , `[235-7]11`, , , , `211`, , , [3]], , [, , `[1-35-9]\\d{4,5}`, , , , `10000`, , , [5, 6]]], CC: [, [, , `[01]\\d\\d`, , , , , , , [3]], , , [, , `000|112`, , , , `000`], [, , , , , , , , , [-1]], , , , `CC`, , , , , , , , , , , , , , , , , , [, , `000|112`, , , , `000`], , [, , `000|112`, , , , `000`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CD: [, [, , `[14]\\d\\d(?:\\d{2})?`, , , , , , , [3, 5]], , , [, , `1(?:1[348]|77|88)`, , , , `113`, , , [3]], [, , , , , , , , , [-1]], , , , `CD`, , , , , , , , , , , , , , , , , , [, , `1(?:1[348]|77|88)`, , , , `113`, , , [3]], , [, , `1(?:1[348]|23|77|88)|40404`, , , , `113`], [, , , , , , , , , [-1]], [, , `404\\d\\d`, , , , `40400`, , , [5]], , [, , `404\\d\\d`, , , , `40400`, , , [5]]], CF: [, [, , `1\\d{2,3}`, , , , , , , [3, 4]], , , [, , `1(?:1[78]|22\\d)`, , , , `117`], [, , , , , , , , , [-1]], , , , `CF`, , , , , , , , , , , , , , , , , , [, , `1(?:1[78]|220)`, , , , `117`], , [, , `1(?:1[478]|220)`, , , , `114`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CG: [, [, , `1\\d\\d`, , , , , , , [3]], , , [, , `11[178]`, , , , `111`], [, , , , , , , , , [-1]], , , , `CG`, , , , , , , , , , , , , , , , , , [, , `11[78]`, , , , `117`], , [, , `11[126-8]`, , , , `111`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CH: [, [, , `[1-9]\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `1(?:1(?:[278]|6\\d{3})|4[47])|5200`, , , , `112`, , , [3, 4, 6]], [, , `1(?:14|8[0-2589])\\d|543|83111`, , , , `543`, , , [3, 4, 5]], , , , `CH`, , , , , , , , , , , , , , , , , , [, , `1(?:1[278]|44)`, , , , `112`, , , [3]], , [, , `1(?:0[78]\\d\\d|1(?:[278]|45|6(?:000|111))|4(?:[03-57]|1[0145])|6(?:00|[1-46])|8(?:02|1[189]|[25]0|7|8[08]|99))|[2-9]\\d{2,4}`, , , , `112`], [, , `1(?:4[035]|6[1-46])|1(?:41|60)\\d`, , , , `140`, , , [3, 4]], [, , `5(?:200|35)`, , , , `535`, , , [3, 4]], , [, , `[2-9]\\d{2,4}`, , , , `200`, , , [3, 4, 5]]], CI: [, [, , `[14]\\d{2,3}`, , , , , , , [3, 4]], , , [, , `1(?:1[01]|[78]0)`, , , , `110`, , , [3]], [, , , , , , , , , [-1]], , , , `CI`, , , , , , , , , , , , , , , , , , [, , `1(?:1[01]|[78]0)`, , , , `110`, , , [3]], , [, , `1(?:1[01]|[78]0)|4443`, , , , `110`], [, , , , , , , , , [-1]], [, , `444\\d`, , , , `4440`, , , [4]], , [, , `444\\d`, , , , `4440`, , , [4]]], CK: [, [, , `9\\d\\d`, , , , , , , [3]], , , [, , `99[689]`, , , , `996`], [, , , , , , , , , [-1]], , , , `CK`, , , , , , , , , , , , , , , , , , [, , `99[689]`, , , , `996`], , [, , `99[689]`, , , , `996`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CL: [, [, , `[1-9]\\d{2,4}`, , , , , , , [3, 4, 5]], , , [, , `1(?:213|3[1-3])|434\\d|911`, , , , `131`, , , [3, 4]], [, , `1(?:211|3(?:13|[348]0|5[01]))|(?:1(?:[05]6|[48]1|9[18])|2(?:01\\d|[23]2|77|88)|3(?:0[59]|13|3[279]|66)|4(?:[12]4|36\\d|4[017]|55)|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d`, , , , `1060`, , , [4, 5]], , , , `CL`, , , , , , , , , , , , , , , , , , [, , `13[1-3]|911`, , , , `131`, , , [3]], , [, , `1(?:00|21[13]|3(?:13|[348]0|5[01])|4(?:0[02-6]|17|[379])|818|919)|2(?:0(?:01|122)|22[47]|323|777|882)|3(?:0(?:51|99)|132|3(?:29|[37]7)|665)|43656|5(?:(?:00|415)4|5(?:66|77)|995)|6(?:131|222|366|699)|7878|8(?:011|11[28]|482|889)|9(?:01|1)1|13\\d|4(?:[13]42|243|4(?:02|15|77)|554)|(?:1(?:[05]6|98)|339|6(?:07|[35])0|9(?:[12]0|33))0`, , , , `100`], [, , `(?:200|333)\\d`, , , , `2000`, , , [4]], [, , , , , , , , , [-1]], , [, , `13(?:13|[348]0|5[01])|(?:1(?:[05]6|[28]1|4[01]|9[18])|2(?:0(?:0|1\\d)|[23]2|77|88)|3(?:0[59]|13|3[2379]|66)|436\\d|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d|4(?:[1-3]4|4[017]|55)\\d`, , , , `1060`, , , [4, 5]]], CM: [, [, , `[18]\\d{1,3}`, , , , , , , [2, 3, 4]], , , [, , `1(?:1[37]|[37])`, , , , `13`, , , [2, 3]], [, , , , , , , , , [-1]], , , , `CM`, , , , , , , , , , , , , , , , , , [, , `1(?:1[37]|[37])`, , , , `13`, , , [2, 3]], , [, , `1(?:1[37]|[37])|8711`, , , , `13`], [, , , , , , , , , [-1]], [, , `871\\d`, , , , `8710`, , , [4]], , [, , `871\\d`, , , , `8710`, , , [4]]], CN: [, [, , `[19]\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `1(?:1[09]|2(?:[02]|1\\d\\d|395))`, , , , `110`, , , [3, 5]], [, , , , , , , , , [-1]], , , , `CN`, , , , , , , , , , , , , , , , , , [, , `1(?:1[09]|20)`, , , , `110`, , , [3]], , [, , `1(?:00|1[0249]|2395|6[08])|9[56]\\d{3,4}|12[023]|1(?:0(?:[0-26]\\d|8)|21\\d)\\d`, , , , `100`], [, , `1(?:0(?:[0-26]\\d|8)\\d|1[24]|23|6[08])|9[56]\\d{3,4}|100`, , , , `100`], [, , , , , , , , , [-1]], , [, , `12110`, , , , `12110`, , , [5]]], CO: [, [, , `[1-589]\\d\\d(?:\\d{2,3})?`, , , , , , , [3, 5, 6]], , , [, , `1(?:1[29]|23|32|56)`, , , , `112`, , , [3]], [, , , , , , , , , [-1]], , , , `CO`, , , , , , , , , , , , , , , , , , [, , `1(?:1[29]|23|32|56)`, , , , `112`, , , [3]], , [, , `1(?:06|1[2-9]|2[35-7]|3[27]|4[467]|5[36]|6[4-7]|95)|(?:29002|39003)9|40404|5930\\d\\d|85432|(?:[2359][57]|8(?:7|9\\d))\\d{3}`, , , , `106`], [, , , , , , , , , [-1]], [, , `(?:40|85)4\\d\\d`, , , , `40400`, , , [5]], , [, , `(?:40|85)4\\d\\d`, , , , `40400`, , , [5]]], CR: [, [, , `[1359]\\d{2,3}`, , , , , , , [3, 4]], , , [, , `112|911`, , , , `112`, , , [3]], [, , , , , , , , , [-1]], , , , `CR`, , , , , , , , , , , , , , , , , , [, , `112|911`, , , , `112`, , , [3]], , [, , `1(?:0(?:00|15|2[2-4679])|1(?:1[0-35-9]|2|37|[46]6|7[57]|8[79]|9[0-379])|2(?:00|[12]2|34|55)|3(?:21|33)|4(?:0[06]|1[4-6])|5(?:15|5[15])|693|7(?:00|1[7-9]|2[02]|[67]7)|975)|3855|5(?:0(?:30|49)|510)|911`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , `(?:385|5(?:0[34]|51))\\d`, , , , `3850`, , , [4]]], CU: [, [, , `[12]\\d\\d(?:\\d{3,4})?`, , , , , , , [3, 6, 7]], , , [, , `10[4-7]|(?:116|204\\d)\\d{3}`, , , , `104`], [, , , , , , , , , [-1]], , , , `CU`, , , , , , , , , , , , , , , , , , [, , `10[4-6]`, , , , `104`, , , [3]], , [, , `1(?:0[4-7]|1(?:6111|8)|40)|2045252`, , , , `104`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CV: [, [, , `1\\d\\d`, , , , , , , [3]], , , [, , `13[0-2]`, , , , `130`], [, , , , , , , , , [-1]], , , , `CV`, , , , , , , , , , , , , , , , , , [, , `13[0-2]`, , , , `130`], , [, , `13[0-2]`, , , , `130`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CW: [, [, , `[19]\\d\\d`, , , , , , , [3]], , , [, , `112|911`, , , , `112`], [, , , , , , , , , [-1]], , , , `CW`, , , , , , , , , , , , , , , , , , [, , `112|911`, , , , `112`], , [, , `1(?:12|76)|911`, , , , `112`], [, , , , , , , , , [-1]], [, , `176`, , , , `176`], , [, , `176`, , , , `176`]], CX: [, [, , `[01]\\d\\d`, , , , , , , [3]], , , [, , `000|112`, , , , `000`], [, , , , , , , , , [-1]], , , , `CX`, , , , , , , , , , , , , , , , , , [, , `000|112`, , , , `000`], , [, , `000|112`, , , , `000`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CY: [, [, , `1\\d\\d(?:\\d{3})?`, , , , , , , [3, 6]], , , [, , `1(?:1(?:2|6\\d{3})|99)`, , , , `112`], [, , , , , , , , , [-1]], , , , `CY`, , , , , , , , , , , , , , , , , , [, , `1(?:12|99)`, , , , `112`, , , [3]], , [, , `1(?:1(?:2|6(?:000|111))|99)`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CZ: [, [, , `1\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `1(?:1(?:2|6(?:00[06]|1(?:11|23)))|5\\d)`, , , , `112`, , , [3, 6]], [, , , , , , , , , [-1]], , , , `CZ`, , , , , , , , , , , , , , , , , , [, , `1(?:12|5\\d)`, , , , `112`, , , [3]], , [, , `1(?:1(?:2|8\\d)|(?:2|3\\d)\\d{2,3}|5\\d|99)|1(?:16|4)\\d{3}`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], DE: [, [, , `[13]\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `11(?:[02]|6\\d{3})`, , , , `110`, , , [3, 6]], [, , , , , , , , , [-1]], , , , `DE`, , , , , , , , , , , , , , , , , , [, , `11[02]`, , , , `110`, , , [3]], , [, , `11(?:[025]|6(?:00[06]|1(?:1[167]|23))|800\\d)|3311|118\\d\\d`, , , , `110`], [, , , , , , , , , [-1]], [, , `331\\d`, , , , `3310`, , , [4]], , [, , , , , , , , , [-1]]], DJ: [, [, , `1\\d`, , , , , , , [2]], , , [, , `1[78]`, , , , `17`], [, , , , , , , , , [-1]], , , , `DJ`, , , , , , , , , , , , , , , , , , [, , `1[78]`, , , , `17`], , [, , `1[78]`, , , , `17`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], DK: [, [, , `1\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `11(?:[24]|6\\d{3})`, , , , `112`, , , [3, 6]], [, , , , , , , , , [-1]], , , , `DK`, , , , , , , , , , , , , , , , , , [, , `11[24]`, , , , `112`, , , [3]], , [, , `1(?:1(?:[2-48]|6(?:00[06]|111))|619[0-2]|8(?:01|1[0238]|28|30|5[13]|8[18]))`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], DM: [, [, , `[39]\\d\\d`, , , , , , , [3]], , , [, , `333|9(?:11|88|99)`, , , , `333`], [, , , , , , , , , [-1]], , , , `DM`, , , , , , , , , , , , , , , , , , [, , `333|9(?:11|99)`, , , , `333`], , [, , `333|9(?:11|88|99)`, , , , `333`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], DO: [, [, , `[19]\\d\\d`, , , , , , , [3]], , , [, , `112|9(?:11|88)`, , , , `112`], [, , , , , , , , , [-1]], , , , `DO`, , , , , , , , , , , , , , , , , , [, , `112|911`, , , , `112`], , [, , `112|9(?:11|88)`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], DZ: [, [, , `[17]\\d{1,3}`, , , , , , , [2, 3, 4]], , , [, , `1(?:12|[47]|54\\d)`, , , , `14`], [, , , , , , , , , [-1]], , , , `DZ`, , , , , , , , , , , , , , , , , , [, , `1(?:12|[47])`, , , , `14`, , , [2, 3]], , [, , `1(?:055|12|[47]|548)|730`, , , , `14`], [, , , , , , , , , [-1]], [, , `730`, , , , `730`, , , [3]], , [, , `730`, , , , `730`, , , [3]]], EC: [, [, , `[19]\\d\\d`, , , , , , , [3]], , , [, , `1(?:0[12]|12)|911`, , , , `101`], [, , , , , , , , , [-1]], , , , `EC`, , , , , , , , , , , , , , , , , , [, , `1(?:0[12]|12)|911`, , , , `101`], , [, , `1(?:0[12]|12)|911`, , , , `101`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], EE: [, [, , `1\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `1(?:1(?:[02]|6\\d{3})|2(?:05|28)|3(?:014|3(?:21|5\\d?)|660)|492|5(?:1[03]|410|501)|6(?:112|333|644)|7(?:012|127|89)|8(?:10|8[57])|9(?:0[134]|14))`, , , , `110`], [, , `1(?:18(?:00|[12458]\\d?)|2(?:0(?:[02-46-8]\\d?|1[0-36])|1(?:[0-4]\\d?|6[06])|2(?:[0-4]\\d?|5[25])|[367]|4(?:0[04]|[12]\\d?|4[24]|54)|55[12457])|3(?:0(?:[02]\\d?|1[13578]|3[356])|1[1347]|2[02-5]|3(?:[01347]\\d?|2[023]|88)|4(?:[35]\\d?|4[34])|5(?:3[134]|5[035])|666)|4(?:2(?:00|4\\d?)|4(?:0[01358]|1[024]|50|7\\d?)|900)|5(?:0[0-35]|1(?:[1267]\\d?|5[0-7]|82)|2(?:[014-6]\\d?|22)|330|4(?:[35]\\d?|44)|5(?:00|[1-69]\\d?)|9(?:[159]\\d?|[38]0|77))|6(?:1(?:00|1[19]|[35-9]\\d?)|2(?:2[26]|[68]\\d?)|3(?:22|36|6[36])|5|6(?:[0-359]\\d?|6[0-26])|7(?:00|55|7\\d?|8[89])|9(?:00|1\\d?|69))|7(?:0(?:[023]\\d?|1[0578])|1(?:00|2[034]|[4-9]\\d?)|2(?:[07]\\d?|20|44)|7(?:[0-57]\\d?|9[79])|8(?:0[08]|2\\d?|8[0178])|9(?:00|97))|8(?:1[127]|8[1268]|9[269])|9(?:0(?:[02]\\d?|69|9[0269])|1[1-3689]|21))`, , , , `123`, , , [3, 4, 5]], , , , `EE`, , , , , , , , , , , , , , , , , , [, , `11[02]`, , , , `110`, , , [3]], , [, , `1(?:1(?:[02-579]|6(?:000|111)|8(?:[09]\\d|[1-8]))|2[36-9]|3[7-9]|4[05-7]|5[6-8]|6[05]|7[3-6]|8[02-7]|9[3-9])|1(?:2[0-245]|3[0-6]|4[1-489]|5[0-59]|6[1-46-9]|7[0-27-9]|8[189]|9[0-2])\\d\\d?`, , , , `110`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , `1(?:18[1258]|2(?:0(?:1[036]|[46]\\d?)|166|21|4(?:0[04]|1\\d?|5[47])|[67])|3(?:0(?:1[13-578]|2\\d?|3[56])|1[15]|2[045]|3(?:[13]\\d?|2[13])|43|5(?:00|3[34]|53))|44(?:0[0135]|14|50|7\\d?)|5(?:05|1(?:[12]\\d?|5[1246]|8[12])|2(?:[01]\\d?|22)|3(?:00|3[03])|4(?:15|5\\d?)|500|9(?:5\\d?|77|80))|6(?:1[35-8]|226|3(?:22|3[36]|66)|644|7(?:00|7\\d?|89)|9(?:00|69))|7(?:01[258]|1(?:00|[15]\\d?)|2(?:44|7\\d?)|8(?:00|87|9\\d?))|8(?:1[128]|8[56]|9(?:[26]\\d?|77))|90(?:2\\d?|69|92))`, , , , `126`, , , [3, 4, 5]]], EG: [, [, , `[13]\\d\\d(?:\\d{2})?`, , , , , , , [3, 5]], , , [, , `1(?:2[23]|80)`, , , , `122`, , , [3]], [, , , , , , , , , [-1]], , , , `EG`, , , , , , , , , , , , , , , , , , [, , `1(?:2[23]|80)`, , , , `122`, , , [3]], , [, , `1(?:2[23]|[679]\\d{3}|80)|34400`, , , , `122`], [, , , , , , , , , [-1]], [, , `344\\d\\d`, , , , `34400`, , , [5]], , [, , `344\\d\\d`, , , , `34400`, , , [5]]], EH: [, [, , `1\\d\\d?`, , , , , , , [2, 3]], , , [, , `1(?:[59]|77)`, , , , `15`], [, , , , , , , , , [-1]], , , , `EH`, , , , , , , , , , , , , , , , , , [, , `1(?:[59]|77)`, , , , `15`], , [, , `1(?:[59]|77)`, , , , `15`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], ER: [, [, , `[12]\\d\\d(?:\\d{3})?`, , , , , , , [3, 6]], , , [, , `11[2-46]|(?:12[47]|20[12])\\d{3}`, , , , `112`], [, , , , , , , , , [-1]], , , , `ER`, , , , , , , , , , , , , , , , , , [, , `1(?:1[2-46]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99`, , , , `112`], , [, , `1(?:1[2-6]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], ES: [, [, , `[0-379]\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `0(?:16|6[57]|8[58])|1(?:006|12|[3-7]\\d\\d)|(?:116|20\\d)\\d{3}`, , , , `016`, , , [3, 4, 6]], [, , `[12]2\\d{1,4}|90(?:5\\d|7)|(?:118|2(?:[357]\\d|80)|3[357]\\d)\\d\\d|[79]9[57]\\d{3}`, , , , `120`], , , , `ES`, , , , , , , , , , , , , , , , , , [, , `08[58]|112`, , , , `085`, , , [3]], , [, , `0(?:1[0-26]|6[0-257]|8[058]|9[12])|1(?:0[03-57]\\d{1,3}|1(?:2|6(?:000|111)|8\\d\\d)|2\\d{1,4}|[3-9]\\d\\d)|2(?:2\\d{1,4}|80\\d\\d)|90(?:5[124578]|7)|1(?:3[34]|77)|(?:2[01]\\d|[79]9[57])\\d{3}|[23][357]\\d{3}`, , , , `010`], [, , `0(?:[16][0-2]|80|9[12])|21\\d{4}`, , , , `010`, , , [3, 6]], [, , `1(?:3[34]|77)|[12]2\\d{1,4}`, , , , `120`], , [, , `(?:2[0-2]\\d|3[357]|[79]9[57])\\d{3}|2(?:[2357]\\d|80)\\d\\d`, , , , `22000`, , , [5, 6]]], ET: [, [, , `9\\d\\d?`, , , , , , , [2, 3]], , , [, , `9(?:07|11?|2|39?|9[17])`, , , , `91`], [, , , , , , , , , [-1]], , , , `ET`, , , , , , , , , , , , , , , , , , [, , `9(?:11?|2|39?|9[17])`, , , , `91`], , [, , `9(?:07|11?|2|39?|45|9[17])`, , , , `91`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], FI: [, [, , `[17]\\d\\d(?:\\d{2,3})?`, , , , , , , [3, 5, 6]], , , [, , `11(?:2|6\\d{3})`, , , , `112`, , , [3, 6]], [, , , , , , , , , [-1]], , , , `FI`, , , , , , , , , , , , , , , , , , [, , `112`, , , , `112`, , , [3]], , [, , `11(?:2|6(?:00[06]|1(?:1[17]|23)))|(?:1[2-8]\\d|75[12])\\d\\d`, , , , `112`], [, , `1[2-8]\\d{3}`, , , , `12000`, , , [5]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], FJ: [, [, , `[0-579]\\d(?:\\d(?:\\d{2})?)?`, , , , , , , [2, 3, 5]], , , [, , `91[17]`, , , , `911`, , , [3]], [, , , , , , , , , [-1]], , , , `FJ`, , , , , , , , , , , , , , , , , , [, , `91[17]`, , , , `911`, , , [3]], , [, , `0(?:1[34]|8[1-4])|1(?:0[1-3]|[25]9)|2[289]|30|40404|91[137]|[45]4|75`, , , , `22`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , `404\\d\\d`, , , , `40400`, , , [5]]], FK: [, [, , `[19]\\d\\d`, , , , , , , [3]], , , [, , `999`, , , , `999`], [, , , , , , , , , [-1]], , , , `FK`, , , , , , , , , , , , , , , , , , [, , `999`, , , , `999`], , [, , `1\\d\\d|999`, , , , `100`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], FM: [, [, , `[39]\\d\\d(?:\\d{3})?`, , , , , , , [3, 6]], , , [, , `320\\d{3}|911`, , , , `911`], [, , , , , , , , , [-1]], , , , `FM`, , , , , , , , , , , , , , , , , , [, , `(?:32022|91)1`, , , , `911`], , [, , `(?:32022|91)1`, , , , `911`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], FO: [, [, , `1\\d{2,3}`, , , , , , , [3, 4]], , , [, , `1(?:1[24]|81\\d)`, , , , `112`], [, , , , , , , , , [-1]], , , , `FO`, , , , , , , , , , , , , , , , , , [, , `11[24]`, , , , `112`, , , [3]], , [, , `1(?:1[248]|819)|1(?:4[124]|71|8[7-9])\\d`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], FR: [, [, , `[1-8]\\d{1,5}`, , , , , , , [2, 3, 4, 5, 6]], , , [, , `1(?:1[02459]|[578]|9[167])|224|(?:3370|74)0|(?:116\\d|3[01])\\d\\d`, , , , `15`], [, , `(?:1(?:0|18\\d)|366|[4-8]\\d\\d)\\d\\d|3[2-9]\\d\\d`, , , , `1000`, , , [4, 5, 6]], , , , `FR`, , , , , , , , , , , , , , , , , , [, , `1(?:12|[578])`, , , , `15`, , , [2, 3]], , [, , `1(?:0\\d\\d|1(?:[02459]|6(?:000|111)|8\\d{3})|[578]|9[167])|2(?:0(?:00|2)0|24)|[3-8]\\d{4}|3\\d{3}|6(?:1[14]|34)|7(?:0[06]|22|40)`, , , , `15`], [, , `202\\d|6(?:1[14]|34)|70[06]`, , , , `611`, , , [3, 4]], [, , `118777|224|6(?:1[14]|34)|7(?:0[06]|22|40)|20(?:0\\d|2)\\d`, , , , `224`, , , [3, 4, 5, 6]], , [, , `114|[3-8]\\d{4}`, , , , `114`, , , [3, 5]]], GA: [, [, , `1\\d(?:\\d{2})?`, , , , , , , [2, 4]], , , [, , `18|1(?:3\\d|73)\\d`, , , , `18`], [, , , , , , , , , [-1]], , , , `GA`, , , , , , , , , , , , , , , , , , [, , `1(?:3\\d\\d|730|8)`, , , , `18`], , [, , `1(?:3\\d\\d|730|8)`, , , , `18`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], GB: [, [, , `[1-46-9]\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `1(?:05|1(?:[29]|6\\d{3})|7[56]\\d|8000)|2(?:20\\d|48)|4444|999`, , , , `105`], [, , , , , , , , , [-1]], , , , `GB`, , , , , , , , , , , , , , , , , , [, , `112|999`, , , , `112`, , , [3]], , [, , `1(?:0[015]|1(?:[129]|6(?:000|1(?:11|23))|8\\d{3})|2(?:[1-3]|50)|33|4(?:1|7\\d)|571|7(?:0\\d|[56]0)|800\\d|9[15])|2(?:0202|1300|2(?:02|11)|3(?:02|336|45)|4(?:25|8))|3[13]3|4(?:0[02]|35[01]|44[45]|5\\d)|(?:[68]\\d|7[089])\\d{3}|15\\d|2[02]2|650|789|9(?:01|99)`, , , , `100`], [, , , , , , , , , [-1]], [, , `1(?:(?:25|7[56])\\d|571)|2(?:02(?:\\d{2})?|[13]3\\d\\d|48)|4444|901`, , , , `202`, , , [3, 4, 5]], , [, , `(?:125|2(?:020|13\\d)|(?:7[089]|8[01])\\d\\d)\\d`, , , , `1250`, , , [4, 5]]], GD: [, [, , `[19]\\d\\d`, , , , , , , [3]], , , [, , `9(?:11|88)`, , , , `911`], [, , , , , , , , , [-1]], , , , `GD`, , , , , , , , , , , , , , , , , , [, , `911`, , , , `911`], , [, , `176|9(?:11|88)`, , , , `176`], [, , , , , , , , , [-1]], [, , `176`, , , , `176`], , [, , `176`, , , , `176`]], GE: [, [, , `[014]\\d\\d(?:\\d{2})?`, , , , , , , [3, 5]], , , [, , `0(?:11|33)|11[1-3]|[01]22`, , , , `011`, , , [3]], [, , , , , , , , , [-1]], , , , `GE`, , , , , , , , , , , , , , , , , , [, , `0(?:11|33)|11[1-3]|[01]22`, , , , `011`, , , [3]], , [, , `0(?:11|33)|11[1-3]|40404|[01]22`, , , , `011`], [, , , , , , , , , [-1]], [, , `404\\d\\d`, , , , `40400`, , , [5]], , [, , `404\\d\\d`, , , , `40400`, , , [5]]], GF: [, [, , `1\\d`, , , , , , , [2]], , , [, , `1[578]`, , , , `15`], [, , , , , , , , , [-1]], , , , `GF`, , , , , , , , , , , , , , , , , , [, , `1[578]`, , , , `15`], , [, , `1[578]`, , , , `15`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], GG: [, [, , `[19]\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `112|999`, , , , `112`, , , [3]], [, , , , , , , , , [-1]], , , , `GG`, , , , , , , , , , , , , , , , , , [, , `112|999`, , , , `112`, , , [3]], , [, , `1(?:0[01]|1[12]|23|41|55|9[05])|999|1(?:1[68]\\d\\d|47|800)\\d`, , , , `100`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], GH: [, [, , `[14589]\\d{2,4}`, , , , , , , [3, 4, 5]], , , [, , `19[1-3]|999`, , , , `191`, , , [3]], [, , , , , , , , , [-1]], , , , `GH`, , , , , , , , , , , , , , , , , , [, , `19[1-3]|999`, , , , `191`, , , [3]], , [, , `19[1-3]|40404|(?:54|83)00|999`, , , , `191`], [, , , , , , , , , [-1]], [, , `404\\d\\d|(?:54|83)0\\d`, , , , `5400`, , , [4, 5]], , [, , `404\\d\\d|(?:54|83)0\\d`, , , , `5400`, , , [4, 5]]], GI: [, [, , `[158]\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `1(?:00|1[25]|23|4(?:1|7\\d)|5[15]|9[02-49])|555|(?:116\\d|80)\\d\\d`, , , , `100`, , , [3, 4, 6]], [, , `8[1-69]\\d\\d`, , , , `8100`, , , [4]], , , , `GI`, , , , , , , , , , , , , , , , , , [, , `1(?:12|9[09])`, , , , `112`, , , [3]], , [, , `1(?:00|1(?:[25]|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|23|4(?:1|7[014])|5[015]|9[02-49])|555|8[0-79]\\d\\d|8(?:00|4[0-2]|8[0-589])`, , , , `100`], [, , `150|87\\d\\d`, , , , `150`, , , [3, 4]], [, , `1(?:00|1(?:5|8\\d\\d)|23|51|9[2-4])|555|8(?:00|4[0-2]|8[0-589])`, , , , `100`, , , [3, 5]], , [, , , , , , , , , [-1]]], GL: [, [, , `1\\d\\d`, , , , , , , [3]], , , [, , `112`, , , , `112`], [, , , , , , , , , [-1]], , , , `GL`, , , , , , , , , , , , , , , , , , [, , `112`, , , , `112`], , [, , `1[1-8]\\d`, , , , `110`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], GM: [, [, , `1\\d\\d?`, , , , , , , [2, 3]], , , [, , `1(?:1[6-8]|[6-8])`, , , , `16`], [, , , , , , , , , [-1]], , , , `GM`, , , , , , , , , , , , , , , , , , [, , `1(?:1[6-8]|[6-8])`, , , , `16`], , [, , `1(?:1[6-8]|[6-8])`, , , , `16`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], GN: [, [, , `[14]\\d\\d(?:\\d{2})?`, , , , , , , [3, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , `GN`, , , , , , , , , , , , , , , , , , [, , , , , , , , , [-1]], , [, , `12\\d|40404`, , , , `120`], [, , , , , , , , , [-1]], [, , `404\\d\\d`, , , , `40400`, , , [5]], , [, , `404\\d\\d`, , , , `40400`, , , [5]]], GP: [, [, , `1\\d`, , , , , , , [2]], , , [, , `1[578]`, , , , `15`], [, , , , , , , , , [-1]], , , , `GP`, , , , , , , , , , , , , , , , , , [, , `1[578]`, , , , `15`], , [, , `1[578]`, , , , `15`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], GR: [, [, , `1\\d\\d(?:\\d{2,3})?`, , , , , , , [3, 5, 6]], , , [, , `1(?:0[089]|1(?:2|6\\d{3})|66|99)`, , , , `100`, , , [3, 6]], [, , , , , , , , , [-1]], , , , `GR`, , , , , , , , , , , , , , , , , , [, , `1(?:00|12|66|99)`, , , , `100`, , , [3]], , [, , `1(?:0[089]|1(?:2|320|6(?:000|1(?:1[17]|23)))|(?:389|9)9|66)`, , , , `100`], [, , `113\\d\\d`, , , , `11300`, , , [5]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], GT: [, [, , `[14]\\d{2,4}`, , , , , , , [3, 4, 5]], , , [, , `1(?:10|2[03])`, , , , `110`, , , [3]], [, , , , , , , , , [-1]], , , , `GT`, , , , , , , , , , , , , , , , , , [, , `1(?:10|2[03])`, , , , `110`, , , [3]], , [, , `110|40404|1(?:2|[57]\\d)\\d`, , , , `110`], [, , , , , , , , , [-1]], [, , `404\\d\\d`, , , , `40400`, , , [5]], , [, , `404\\d\\d`, , , , `40400`, , , [5]]], GU: [, [, , `9\\d\\d`, , , , , , , [3]], , , [, , `9(?:11|88)`, , , , `911`], [, , , , , , , , , [-1]], , , , `GU`, , , , , , , , , , , , , , , , , , [, , `911`, , , , `911`], , [, , `9(?:11|88)`, , , , `911`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], GW: [, [, , `1\\d\\d`, , , , , , , [3]], , , [, , `11[378]`, , , , `113`], [, , , , , , , , , [-1]], , , , `GW`, , , , , , , , , , , , , , , , , , [, , `11[378]`, , , , `113`], , [, , `11[378]`, , , , `113`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], GY: [, [, , `[019]\\d{2,3}`, , , , , , , [3, 4]], , , [, , `91[1-3]`, , , , `911`, , , [3]], [, , , , , , , , , [-1]], , , , `GY`, , , , , , , , , , , , , , , , , , [, , `91[1-3]`, , , , `911`, , , [3]], , [, , `0(?:02|(?:17|80)1|444|7(?:[67]7|9)|9(?:0[78]|[2-47]))|1(?:443|5[568])|91[1-3]`, , , , `002`], [, , , , , , , , , [-1]], [, , `144\\d`, , , , `1440`, , , [4]], , [, , `144\\d`, , , , `1440`, , , [4]]], HK: [, [, , `[19]\\d{2,6}`, , , , , , , [3, 4, 5, 6, 7]], , , [, , `112|99[29]`, , , , `112`, , , [3]], [, , , , , , , , , [-1]], , , , `HK`, , , , , , , , , , , , , , , , , , [, , `112|99[29]`, , , , `112`, , , [3]], , [, , `1(?:0(?:(?:[0136]\\d|2[14])\\d{0,3}|8[138])|12|2(?:[0-3]\\d{0,4}|(?:58|8[13])\\d{0,3})|7(?:[135-9]\\d{0,4}|219\\d{0,2})|8(?:0(?:(?:[13]|60\\d)\\d|8)|1(?:0\\d|[2-8])|2(?:0[5-9]|(?:18|2)2|3|8[128])|(?:(?:3[0-689]\\d|7(?:2[1-389]|8[0235-9]|93))\\d|8)\\d|50[138]|6(?:1(?:11|86)|8)))|99[29]|10[0139]`, , , , `100`], [, , , , , , , , , [-1]], [, , `109|1(?:08|85\\d)\\d`, , , , `109`, , , [3, 4, 5]], , [, , `992`, , , , `992`, , , [3]]], HN: [, [, , `[14]\\d\\d(?:\\d{2})?`, , , , , , , [3, 5]], , , [, , `199`, , , , `199`, , , [3]], [, , , , , , , , , [-1]], , , , `HN`, , , , , , , , , , , , , , , , , , [, , `199`, , , , `199`, , , [3]], , [, , `199|40404`, , , , `199`], [, , , , , , , , , [-1]], [, , `404\\d\\d`, , , , `40400`, , , [5]], , [, , `404\\d\\d`, , , , `40400`, , , [5]]], HR: [, [, , `[19]\\d{1,5}`, , , , , , , [2, 3, 4, 5, 6]], , , [, , `1(?:12|9[2-4])|9[34]|1(?:16\\d|39)\\d\\d`, , , , `93`, , , [2, 3, 5, 6]], [, , `118\\d\\d`, , , , `11800`, , , [5]], , , , `HR`, , , , , , , , , , , , , , , , , , [, , `1(?:12|9[2-4])|9[34]`, , , , `93`, , , [2, 3]], , [, , `1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|3977|9(?:[2-5]|87))|9[34]`, , , , `93`], [, , , , , , , , , [-1]], [, , `139\\d\\d`, , , , `13900`, , , [5]], , [, , `139\\d\\d`, , , , `13900`, , , [5]]], HT: [, [, , `[14]\\d\\d(?:\\d{2})?`, , , , , , , [3, 5]], , , [, , `11[48]`, , , , `114`, , , [3]], [, , , , , , , , , [-1]], , , , `HT`, , , , , , , , , , , , , , , , , , [, , `11[48]`, , , , `114`, , , [3]], , [, , `11[48]|40404`, , , , `114`], [, , , , , , , , , [-1]], [, , `404\\d\\d`, , , , `40400`, , , [5]], , [, , `404\\d\\d`, , , , `40400`, , , [5]]], HU: [, [, , `1\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `1(?:0[457]|12|4[0-4]\\d)|1(?:16\\d|37|45)\\d\\d`, , , , `104`], [, , , , , , , , , [-1]], , , , `HU`, , , , , , , , , , , , , , , , , , [, , `1(?:0[457]|12)`, , , , `104`, , , [3]], , [, , `1(?:0[457]|1(?:2|6(?:000|1(?:11|23))|800)|2(?:0[0-4]|1[013489]|2[0-5]|3[0-46]|4[0-24-68]|5[0-2568]|6[06]|7[0-25-7]|8[028]|9[08])|37(?:00|37|7[07])|4(?:0[0-5]|1[013-8]|2[034]|3[23]|4[02-9]|5(?:00|41|67))|777|8(?:1[27-9]|2[04]|40|[589]))`, , , , `104`], [, , , , , , , , , [-1]], [, , `1(?:4[0-4]|77)\\d|1(?:18|2|45)\\d\\d`, , , , `1200`, , , [4, 5]], , [, , `184\\d`, , , , `1840`, , , [4]]], ID: [, [, , `[178]\\d\\d(?:\\d{2,3})?`, , , , , , , [3, 5, 6]], , , [, , `11[02389]`, , , , `110`, , , [3]], [, , , , , , , , , [-1]], , , , `ID`, , , , , , , , , , , , , , , , , , [, , `11[02389]`, , , , `110`, , , [3]], , [, , `1(?:1[02389]|40\\d\\d|50264)|71400|89887`, , , , `110`], [, , , , , , , , , [-1]], [, , `(?:714|898)\\d\\d`, , , , `71400`, , , [5]], , [, , `714\\d\\d`, , , , `71400`, , , [5]]], IE: [, [, , `[159]\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `11(?:2|6\\d{3})|999`, , , , `112`, , , [3, 6]], [, , `5[37]\\d{3}`, , , , `53000`, , , [5]], , , , `IE`, , , , , , , , , , , , , , , , , , [, , `112|999`, , , , `112`, , , [3]], , [, , `11(?:2|6(?:00[06]|1(?:1[17]|23)))|999|(?:1(?:18|9)|5[0137]\\d)\\d\\d`, , , , `112`], [, , `51\\d{3}`, , , , `51000`, , , [5]], [, , `51210`, , , , `51210`, , , [5]], , [, , `51210|(?:118|5[037]\\d)\\d\\d`, , , , `11800`, , , [5]]], IL: [, [, , `[12]\\d{2,4}`, , , , , , , [3, 4, 5]], , , [, , `1(?:0[0-2]|12)`, , , , `100`, , , [3]], [, , , , , , , , , [-1]], , , , `IL`, , , , , , , , , , , , , , , , , , [, , `1(?:0[0-2]|12)`, , , , `100`, , , [3]], , [, , `1(?:0[0-2]|1(?:[013-9]\\d|2)|[2-9]\\d\\d)|2407|(?:104|27)00`, , , , `100`], [, , , , , , , , , [-1]], [, , `104\\d\\d`, , , , `10400`, , , [5]], , [, , `104\\d\\d`, , , , `10400`, , , [5]]], IM: [, [, , `[189]\\d\\d(?:\\d{2,3})?`, , , , , , , [3, 5, 6]], , , [, , `999`, , , , `999`, , , [3]], [, , , , , , , , , [-1]], , , , `IM`, , , , , , , , , , , , , , , , , , [, , `999`, , , , `999`, , , [3]], , [, , `1\\d\\d(?:\\d{3})?|8(?:6444|9887)|999`, , , , `100`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , `8(?:64|98)\\d\\d`, , , , `86400`, , , [5]]], IN: [, [, , `[12578]\\d{2,8}`, , , , , , , [3, 4, 5, 6, 7, 8, 9]], , , [, , `1(?:0[0-248]|1[289]|21|[39][89]|4[01]|6(?:1|6\\d?)|8[12])|777|800|1[05]5\\d|1(?:07|51|94)\\d\\d?|(?:1(?:[05]5\\d|70)\\d|261)\\d|1(?:0[369]|10|29|3[126]|9[0-256])\\d`, , , , `100`, , , [3, 4, 5, 6]], [, , `11[67]\\d{4}|56161561`, , , , `1160000`, , , [7, 8]], , , , `IN`, , , , , , , , , , , , , , , , , , [, , `1(?:0[0-28]|12|298)|2611`, , , , `100`, , , [3, 4]], , [, , `1(?:0(?:[0-248]|3[39]|5(?:010|6)|6[3468]|7(?:[01357]|[28]0?|4[01])|9[0135-9])|1(?:00|[289])|2(?:1|98)|3(?:11|2[0-2]|63|[89])|4[01]|5(?:1(?:0[0-36]|[127])|54)|6(?:1|6[01]?)|7000|8[12]|9(?:0[013-59]|12|25|4[4-9]\\d?|50|6[1347]|[89]))|2611|5(?:0(?:0(?:0\\d|1|20?)|325|5[2-79]\\d{3,5})|1(?:234|555|717|818|96[49])|2(?:0(?:0[01]|[14]0)|151|555|666|888|9(?:06|99\\d?))|3(?:0[01]0|131|553|(?:66|77)6)|(?:464|55[05])\\d{1,3}|6(?:070|3[68]|43)|717\\d)|777|800|5(?:05(?:0|1\\d)|221|3(?:03|3[23]))\\d{1,4}|5(?:(?:04|88)0|2(?:2[0267]|3[16])|4(?:1[04]|20|3[02])|5(?:3[16]|67)|6(?:06|[67]\\d)|787|9(?:64|90))\\d\\d?|(?:1(?:05[79]|(?:1[67][0-2]|802)\\d|55[23])\\d|5(?:(?:00(?:0\\d|1)|(?:304|616)\\d\\d)\\d|1(?:0[12]|4[2-4])|2(?:2[3589]|3(?:1\\d{3}|2)|4[04]|7[78])|4(?:[02]4|32\\d{4}|4[04]|99)|5(?:1[25]|[36]5|4[45]|93)|7(?:(?:17\\d|57)\\d\\d|[27]7|88)|8(?:3[4-69]|4[01]|5[58]|88(?:8\\d\\d|9)|99)|9(?:0(?:0|2\\d{3})|55|6[67]|77|88)))\\d`, , , , `100`], [, , `5(?:14(?:2[5-9]|[34]\\d)|757555)`, , , , `51425`, , , [5, 7]], [, , `1(?:(?:1[67]\\d\\d|70)\\d\\d|55330|909)|5(?:300\\d|6161(?:17[89]|561))|1(?:[19][89]|21|4[01])`, , , , `118`, , , [3, 4, 5, 6, 7, 8]], , [, , `1(?:39|90[019])|5(?:14(?:2[5-9]|[34]\\d)|6161(?:17[89]|561)|757555)`, , , , `139`, , , [3, 4, 5, 7, 8]]], IQ: [, [, , `[1479]\\d{2,4}`, , , , , , , [3, 4, 5]], , , [, , `1(?:0[04]|15|22)`, , , , `100`, , , [3]], [, , , , , , , , , [-1]], , , , `IQ`, , , , , , , , , , , , , , , , , , [, , `1(?:0[04]|15|22)`, , , , `100`, , , [3]], , [, , `1(?:0[04]|15|22)|4432|71117|9988`, , , , `100`], [, , , , , , , , , [-1]], [, , `(?:443|711\\d|998)\\d`, , , , `4430`, , , [4, 5]], , [, , `(?:443|711\\d|998)\\d`, , , , `4430`, , , [4, 5]]], IR: [, [, , `[129]\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `1(?:1[0-68]|2[0-59]|9[0-579])|911`, , , , `110`, , , [3]], [, , , , , , , , , [-1]], , , , `IR`, , , , , , , , , , , , , , , , , , [, , `1(?:1[025]|25)|911`, , , , `110`, , , [3]], , [, , `1(?:1[0-68]|2[0-59]|3[346-8]|4(?:[0147]|[289]0)|5(?:0[14]|1[02479]|2[0-3]|39|[49]0|65)|6(?:[16]6|[27]|90)|8(?:03|1[18]|22|3[37]|4[28]|88|99)|9[0-579])|20(?:[09]0|1(?:[038]|1[079]|26|9[69])|2[01])|9(?:11|9(?:0009|90))`, , , , `110`], [, , `1(?:5[0-469]|8[0-489])\\d`, , , , `1500`, , , [4]], [, , `(?:1(?:5[0-469]|8[0-489])|99(?:0\\d\\d|9))\\d`, , , , `1500`, , , [4, 6]], , [, , `990\\d{3}`, , , , `990000`, , , [6]]], IS: [, [, , `1\\d\\d(?:\\d(?:\\d{2})?)?`, , , , , , , [3, 4, 6]], , , [, , `1(?:12|71\\d)`, , , , `112`, , , [3, 4]], [, , , , , , , , , [-1]], , , , `IS`, , , , , , , , , , , , , , , , , , [, , `112`, , , , `112`, , , [3]], , [, , `1(?:1(?:[28]|61(?:16|23))|4(?:00|1[145]|4[0146])|55|7(?:00|17|7[07-9])|8(?:[02]0|1[16-9]|88)|900)`, , , , `112`], [, , , , , , , , , [-1]], [, , `14(?:0\\d|41)`, , , , `1400`, , , [4]], , [, , `1(?:415|90\\d)`, , , , `1415`, , , [4]]], IT: [, [, , `[14]\\d{2,6}`, , , , , , , [3, 4, 5, 6, 7]], , , [, , `1(?:1(?:[2358]|6\\d{3})|87)`, , , , `112`, , , [3, 6]], [, , `(?:12|4(?:[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d`, , , , `1200`, , , [4, 5, 7]], , , , `IT`, , , , , , , , , , , , , , , , , , [, , `11[2358]`, , , , `112`, , , [3]], , [, , `1(?:0\\d{2,3}|1(?:[2-57-9]|6(?:000|111))|3[39]|4(?:82|9\\d{1,3})|5(?:00|1[58]|2[25]|3[03]|44|[59])|60|8[67]|9(?:[01]|2[2-9]|4\\d|696))|4(?:2323|5045)|(?:1(?:2|92[01])|4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , `4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|5[05])\\d\\d`, , , , `43000`, , , [5, 7]]], JE: [, [, , `[129]\\d\\d(?:\\d(?:\\d{2})?)?`, , , , , , , [3, 4, 6]], , , [, , `112|999`, , , , `112`, , , [3]], [, , , , , , , , , [-1]], , , , `JE`, , , , , , , , , , , , , , , , , , [, , `112|999`, , , , `112`, , , [3]], , [, , `1(?:00|1(?:2|8\\d{3})|23|4(?:[14]|28|7\\d)|5\\d|7(?:0[12]|[128]|35?)|808|9[0135])|23[2-4]|999`, , , , `100`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], JM: [, [, , `[19]\\d\\d`, , , , , , , [3]], , , [, , `11[029]|9(?:11|88)`, , , , `110`], [, , , , , , , , , [-1]], , , , `JM`, , , , , , , , , , , , , , , , , , [, , `11[029]|911`, , , , `110`], , [, , `1(?:1[029]|76)|9(?:11|88)`, , , , `110`], [, , , , , , , , , [-1]], [, , `176`, , , , `176`], , [, , `176`, , , , `176`]], JO: [, [, , `[19]\\d\\d(?:\\d{2})?`, , , , , , , [3, 5]], , , [, , `1(?:0[235]|1[2-6]|9[127])|911`, , , , `102`, , , [3]], [, , `9[0-4689]\\d{3}`, , , , `90000`, , , [5]], , , , `JO`, , , , , , , , , , , , , , , , , , [, , `1(?:12|9[127])|911`, , , , `112`, , , [3]], , [, , `1(?:0[2359]|1[0-68]|9[0-24-79])|9[0-4689]\\d{3}|911`, , , , `102`], [, , , , , , , , , [-1]], [, , `9[0-4689]\\d{3}`, , , , `90000`, , , [5]], , [, , `9[0-4689]\\d{3}`, , , , `90000`, , , [5]]], JP: [, [, , `[01]\\d\\d(?:\\d{7})?`, , , , , , , [3, 10]], , , [, , `11[089]`, , , , `110`, , , [3]], [, , , , , , , , , [-1]], , , , `JP`, , , , , , , , , , , , , , , , , , [, , `11[09]`, , , , `110`, , , [3]], , [, , `000[259]\\d{6}|1(?:0[24]|1[089]|44|89)`, , , , `102`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , `000[259]\\d{6}`, , , , `0002000000`, , , [10]]], KE: [, [, , `[1-9]\\d{2,4}`, , , , , , , [3, 4, 5]], , , [, , `1(?:1(?:[246]|9\\d)|5(?:01|2[127]|6[26]\\d))|999`, , , , `112`], [, , `909\\d\\d`, , , , `90900`, , , [5]], , , , `KE`, , , , , , , , , , , , , , , , , , [, , `11[24]|999`, , , , `112`, , , [3]], , [, , `1(?:0(?:[07-9]|1[0-25]|400)|1(?:[024-6]|9[0-579])|2[1-3]|3[01]|4[14]|5(?:[01][01]|2[0-24-79]|33|4[05]|5[59]|6(?:00|29|6[67]))|(?:6[035]\\d|[78])\\d|9(?:[02-9]\\d\\d|19))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99))\\d\\d|9(?:09\\d\\d|99)|8988`, , , , `100`], [, , , , , , , , , [-1]], [, , `1(?:(?:04|6[35])\\d\\d|3[01]|4[14]|5(?:1\\d|2[25]))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99)|909)\\d\\d|898\\d`, , , , `130`], , [, , `1(?:(?:04|6[035])\\d\\d|4[14]|5(?:01|55|6[26]\\d))|40404|8988|909\\d\\d`, , , , `141`]], KG: [, [, , `[14]\\d{2,3}`, , , , , , , [3, 4]], , , [, , `10[1-3]`, , , , `101`, , , [3]], [, , , , , , , , , [-1]], , , , `KG`, , , , , , , , , , , , , , , , , , [, , `10[1-3]`, , , , `101`, , , [3]], , [, , `10[1-3]|4040`, , , , `101`], [, , , , , , , , , [-1]], [, , `404\\d`, , , , `4040`, , , [4]], , [, , `404\\d`, , , , `4040`, , , [4]]], KH: [, [, , `[146]\\d\\d(?:\\d{2})?`, , , , , , , [3, 5]], , , [, , `11[7-9]|666`, , , , `117`, , , [3]], [, , , , , , , , , [-1]], , , , `KH`, , , , , , , , , , , , , , , , , , [, , `11[7-9]|666`, , , , `117`, , , [3]], , [, , `11[7-9]|40404|666`, , , , `117`], [, , , , , , , , , [-1]], [, , `404\\d\\d`, , , , `40400`, , , [5]], , [, , `404\\d\\d`, , , , `40400`, , , [5]]], KI: [, [, , `[179]\\d{2,3}`, , , , , , , [3, 4]], , , [, , `19[2-5]|99[2-4]`, , , , `192`, , , [3]], [, , , , , , , , , [-1]], , , , `KI`, , , , , , , , , , , , , , , , , , [, , `19[2-5]|99[2-4]`, , , , `192`, , , [3]], , [, , `1(?:05[0-259]|88|9[2-5])|777|99[2-4]|10[0-8]`, , , , `100`], [, , `103`, , , , `103`, , , [3]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], KM: [, [, , `1\\d`, , , , , , , [2]], , , [, , `1[78]`, , , , `17`], [, , , , , , , , , [-1]], , , , `KM`, , , , , , , , , , , , , , , , , , [, , `1[78]`, , , , `17`], , [, , `1[78]`, , , , `17`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], KN: [, [, , `[39]\\d\\d`, , , , , , , [3]], , , [, , `333|9(?:11|88|99)`, , , , `333`], [, , , , , , , , , [-1]], , , , `KN`, , , , , , , , , , , , , , , , , , [, , `333|9(?:11|99)`, , , , `333`], , [, , `333|9(?:11|88|99)`, , , , `333`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], KP: [, [, , `[18]\\d\\d`, , , , , , , [3]], , , [, , `11[29]|819`, , , , `112`], [, , , , , , , , , [-1]], , , , `KP`, , , , , , , , , , , , , , , , , , [, , `11[29]|819`, , , , `112`], , [, , `11[29]|819`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], KR: [, [, , `1\\d{2,4}`, , , , , , , [3, 4, 5]], , , [, , `1(?:1[27-9]|28|330|82)`, , , , `112`, , , [3, 4]], [, , , , , , , , , [-1]], , , , `KR`, , , , , , , , , , , , , , , , , , [, , `11[29]`, , , , `112`, , , [3]], , [, , `1(?:[016-9]114|3(?:0[01]|2|3[0-35-9]|45?|5[057]|6[569]|7[79]|8[2589]|9[0189]))|1(?:0[015]|1\\d|2[01357-9]|41|8[28])`, , , , `100`], [, , , , , , , , , [-1]], [, , `1(?:0[01]|1[4-6]|41)|1(?:[06-9]1\\d|111)\\d`, , , , `100`, , , [3, 5]], , [, , , , , , , , , [-1]]], KW: [, [, , `[18]\\d\\d(?:\\d{2})?`, , , , , , , [3, 5]], , , [, , `112`, , , , `112`, , , [3]], [, , , , , , , , , [-1]], , , , `KW`, , , , , , , , , , , , , , , , , , [, , `112`, , , , `112`, , , [3]], , [, , `1[0-7]\\d|89887`, , , , `100`], [, , , , , , , , , [-1]], [, , `898\\d\\d`, , , , `89800`, , , [5]], , [, , , , , , , , , [-1]]], KY: [, [, , `9\\d\\d`, , , , , , , [3]], , , [, , `9(?:11|88)`, , , , `911`], [, , , , , , , , , [-1]], , , , `KY`, , , , , , , , , , , , , , , , , , [, , `911`, , , , `911`], , [, , `9(?:11|88)`, , , , `911`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], KZ: [, [, , `[1-4]\\d{2,4}`, , , , , , , [3, 4, 5]], , , [, , `1(?:0[1-3]|12)|212\\d`, , , , `101`, , , [3, 4]], [, , , , , , , , , [-1]], , , , `KZ`, , , , , , , , , , , , , , , , , , [, , `1(?:0[1-3]|12)`, , , , `101`, , , [3]], , [, , `1(?:0[1-4]|12)|2121|(?:3040|404)0`, , , , `101`], [, , , , , , , , , [-1]], [, , `(?:304\\d|404)\\d`, , , , `4040`, , , [4, 5]], , [, , `(?:304\\d|404)\\d`, , , , `4040`, , , [4, 5]]], LA: [, [, , `1\\d\\d`, , , , , , , [3]], , , [, , `19[015]`, , , , `190`], [, , , , , , , , , [-1]], , , , `LA`, , , , , , , , , , , , , , , , , , [, , `19[015]`, , , , `190`], , [, , `19[015]`, , , , `190`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], LB: [, [, , `[19]\\d\\d`, , , , , , , [3]], , , [, , `1(?:12|40|75)|999`, , , , `112`], [, , , , , , , , , [-1]], , , , `LB`, , , , , , , , , , , , , , , , , , [, , `1(?:12|40|75)|999`, , , , `112`], , [, , `1(?:12|40|75)|999`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], LC: [, [, , `9\\d\\d`, , , , , , , [3]], , , [, , `9(?:11|88|99)`, , , , `911`], [, , , , , , , , , [-1]], , , , `LC`, , , , , , , , , , , , , , , , , , [, , `9(?:11|99)`, , , , `911`], , [, , `9(?:11|88|99)`, , , , `911`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], LI: [, [, , `1\\d{2,3}`, , , , , , , [3, 4]], , , [, , `1(?:1[278]|44)`, , , , `112`, , , [3]], [, , , , , , , , , [-1]], , , , `LI`, , , , , , , , , , , , , , , , , , [, , `1(?:1[278]|44)`, , , , `112`, , , [3]], , [, , `1(?:1(?:[278]|45)|4[3-57]|50|75|81[18])`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], LK: [, [, , `1\\d{2,3}`, , , , , , , [3, 4]], , , [, , `11[02689]`, , , , `110`, , , [3]], [, , , , , , , , , [-1]], , , , `LK`, , , , , , , , , , , , , , , , , , [, , `11[02689]`, , , , `110`, , , [3]], , [, , `1(?:1[024-9]|3(?:00|1[2-49]|2[23]|3[1-3]|44|5[07]|[67]9|88|9[039])|9(?:0[0-2589]|1[0-357-9]|2[0-25689]|3[0389]|4[0489]|5[014-69]|6[0-2689]|7[03579]|8[02457-9]|9[0-2569]))`, , , , `110`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], LR: [, [, , `[3489]\\d{2,3}`, , , , , , , [3, 4]], , , [, , `355|911`, , , , `355`, , , [3]], [, , , , , , , , , [-1]], , , , `LR`, , , , , , , , , , , , , , , , , , [, , `355|911`, , , , `355`, , , [3]], , [, , `355|4040|8(?:400|933)|911`, , , , `355`], [, , , , , , , , , [-1]], [, , `(?:404|8(?:40|93))\\d`, , , , `4040`, , , [4]], , [, , `(?:404|8(?:40|93))\\d`, , , , `4040`, , , [4]]], LS: [, [, , `1\\d\\d`, , , , , , , [3]], , , [, , `11[257]`, , , , `112`], [, , , , , , , , , [-1]], , , , `LS`, , , , , , , , , , , , , , , , , , [, , `11[257]`, , , , `112`], , [, , `11[257]`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], LT: [, [, , `[01]\\d(?:\\d(?:\\d{3})?)?`, , , , , , , [2, 3, 6]], , , [, , `0(?:11?|22?|33?)|1(?:0[1-3]|1(?:2|6111))|116(?:0\\d|12)\\d`, , , , `01`], [, , , , , , , , , [-1]], , , , `LT`, , , , , , , , , , , , , , , , , , [, , `0(?:11?|22?|33?)|1(?:0[1-3]|12)`, , , , `01`, , , [2, 3]], , [, , `0(?:11?|22?|33?)|1(?:0[1-3]|1(?:[27-9]|6(?:000|1(?:1[17]|23))))`, , , , `01`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], LU: [, [, , `1\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `11(?:[23]|6\\d{3})`, , , , `112`, , , [3, 6]], [, , , , , , , , , [-1]], , , , `LU`, , , , , , , , , , , , , , , , , , [, , `11[23]`, , , , `112`, , , [3]], , [, , `11(?:[23]|6(?:000|111))|1(?:18|[25]\\d|3)\\d\\d`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], LV: [, [, , `[018]\\d{1,5}`, , , , , , , [2, 3, 4, 5, 6]], , , [, , `0[1-3]|11(?:[023]|6\\d{3})`, , , , `01`, , , [2, 3, 6]], [, , `1180|821\\d\\d`, , , , `1180`, , , [4, 5]], , , , `LV`, , , , , , , , , , , , , , , , , , [, , `0[1-3]|11[023]`, , , , `01`, , , [2, 3]], , [, , `0[1-4]|1(?:1(?:[02-4]|6(?:000|111)|8[0189])|(?:5|65)5|77)|821[57]4`, , , , `01`], [, , `1181`, , , , `1181`, , , [4]], [, , `165\\d`, , , , `1650`, , , [4]], , [, , , , , , , , , [-1]]], LY: [, [, , `1\\d\\d`, , , , , , , [3]], , , [, , `19[013]`, , , , `190`], [, , , , , , , , , [-1]], , , , `LY`, , , , , , , , , , , , , , , , , , [, , `19[013]`, , , , `190`], , [, , `19[013]`, , , , `190`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MA: [, [, , `1\\d\\d?`, , , , , , , [2, 3]], , , [, , `1(?:[59]|77)`, , , , `15`], [, , , , , , , , , [-1]], , , , `MA`, , , , , , , , , , , , , , , , , , [, , `1(?:[59]|77)`, , , , `15`], , [, , `1(?:[59]|77)`, , , , `15`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MC: [, [, , `1\\d\\d?`, , , , , , , [2, 3]], , , [, , `1(?:12|[578])`, , , , `15`], [, , , , , , , , , [-1]], , , , `MC`, , , , , , , , , , , , , , , , , , [, , `1(?:12|[578])`, , , , `15`], , [, , `1(?:12|41|[578])`, , , , `15`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MD: [, [, , `[19]\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `11(?:2|6(?:000|1(?:11|2\\d)))|90[1-3]`, , , , `112`, , , [3, 6]], [, , , , , , , , , [-1]], , , , `MD`, , , , , , , , , , , , , , , , , , [, , `112|90[1-3]`, , , , `112`, , , [3]], , [, , `1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d?|99)|90[04-9])|90[1-3]|1(?:4\\d\\d|6[0-389]|9[1-4])\\d`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], ME: [, [, , `1\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `1(?:12|2[2-4])`, , , , `112`, , , [3]], [, , , , , , , , , [-1]], , , , `ME`, , , , , , , , , , , , , , , , , , [, , `1(?:12|2[2-4])`, , , , `112`, , , [3]], , [, , `1(?:1(?:(?:[013-57-9]|6\\d\\d)\\d|2)|[249]\\d{3}|5999|8(?:0[089]|1[0-8]|888))|1(?:[02-5]\\d\\d|60[06]|700)|12\\d`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MF: [, [, , `1\\d`, , , , , , , [2]], , , [, , `1[578]`, , , , `15`], [, , , , , , , , , [-1]], , , , `MF`, , , , , , , , , , , , , , , , , , [, , `1[578]`, , , , `15`], , [, , `1[578]`, , , , `15`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MG: [, [, , `1\\d\\d?`, , , , , , , [2, 3]], , , [, , `1(?:1[78]|[78])`, , , , `17`], [, , , , , , , , , [-1]], , , , `MG`, , , , , , , , , , , , , , , , , , [, , `1(?:1[78]|[78])`, , , , `17`], , [, , `1(?:1[78]|[78])`, , , , `17`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MH: [, [, , `9\\d\\d`, , , , , , , [3]], , , [, , `911`, , , , `911`], [, , , , , , , , , [-1]], , , , `MH`, , , , , , , , , , , , , , , , , , [, , `911`, , , , `911`], , [, , `911`, , , , `911`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MK: [, [, , `1\\d\\d(?:\\d(?:\\d{2})?)?`, , , , , , , [3, 4, 6]], , , [, , `1(?:1(?:2|6\\d{3})|9[2-4])`, , , , `112`, , , [3, 6]], [, , , , , , , , , [-1]], , , , `MK`, , , , , , , , , , , , , , , , , , [, , `1(?:12|9[2-4])`, , , , `112`, , , [3]], , [, , `1(?:1(?:2|8\\d)|3\\d|9[2-4])|1(?:16|2\\d)\\d{3}`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], ML: [, [, , `[136-8]\\d{1,4}`, , , , , , , [2, 3, 4, 5]], , , [, , `1[578]|(?:352|67)00|7402|(?:677|744|8000)\\d`, , , , `15`, , , [2, 4, 5]], [, , `(?:12|800)2\\d|3(?:52(?:11|2[02]|3[04-6]|99)|7574)`, , , , `1220`, , , [4, 5]], , , , `ML`, , , , , , , , , , , , , , , , , , [, , `1[578]`, , , , `15`, , , [2]], , [, , `1(?:1(?:[013-9]\\d|2)|2(?:1[02-469]|2[13])|[578])|350(?:35|57)|67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)|800[0-2][12]|3(?:52|[67]\\d)\\d\\d`, , , , `15`], [, , `37(?:433|575)|7400|8001\\d`, , , , `7400`, , , [4, 5]], [, , `3503\\d|(?:3[67]\\d|800)\\d\\d`, , , , `35030`, , , [5]], , [, , `374(?:0[24-9]|[1-9]\\d)|7400|3(?:6\\d|75)\\d\\d`, , , , `7400`, , , [4, 5]]], MM: [, [, , `1\\d\\d`, , , , , , , [3]], , , [, , `199`, , , , `199`], [, , , , , , , , , [-1]], , , , `MM`, , , , , , , , , , , , , , , , , , [, , `199`, , , , `199`], , [, , `199`, , , , `199`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MN: [, [, , `1\\d\\d`, , , , , , , [3]], , , [, , `10[0-35]`, , , , `100`], [, , , , , , , , , [-1]], , , , `MN`, , , , , , , , , , , , , , , , , , [, , `10[0-35]`, , , , `100`], , [, , `10[0-35]`, , , , `100`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MO: [, [, , `9\\d\\d`, , , , , , , [3]], , , [, , `999`, , , , `999`], [, , , , , , , , , [-1]], , , , `MO`, , , , , , , , , , , , , , , , , , [, , `999`, , , , `999`], , [, , `999`, , , , `999`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MP: [, [, , `9\\d\\d`, , , , , , , [3]], , , [, , `9(?:11|88)`, , , , `911`], [, , , , , , , , , [-1]], , , , `MP`, , , , , , , , , , , , , , , , , , [, , `911`, , , , `911`], , [, , `9(?:11|88)`, , , , `911`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MQ: [, [, , `[13]\\d(?:\\d(?:\\d(?:\\d{2})?)?)?`, , , , , , , [2, 3, 4, 6]], , , [, , `1(?:12|[578])|3[01]\\d\\d`, , , , `15`, , , [2, 3, 4]], [, , `3[2469]\\d\\d`, , , , `3200`, , , [4]], , , , `MQ`, , , , , , , , , , , , , , , , , , [, , `1(?:12|[578])`, , , , `15`, , , [2, 3]], , [, , `1(?:12|[578])|(?:118[02-9]|3[0-2469])\\d\\d`, , , , `15`], [, , `118\\d{3}`, , , , `118000`, , , [6]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MR: [, [, , `1\\d`, , , , , , , [2]], , , [, , `1[78]`, , , , `17`], [, , , , , , , , , [-1]], , , , `MR`, , , , , , , , , , , , , , , , , , [, , `1[78]`, , , , `17`], , [, , `1[78]`, , , , `17`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MS: [, [, , `[29]\\d\\d`, , , , , , , [3]], , , [, , `9(?:11|88|99)`, , , , `911`], [, , , , , , , , , [-1]], , , , `MS`, , , , , , , , , , , , , , , , , , [, , `9(?:11|99)`, , , , `911`], , [, , `211|9(?:11|88|99)`, , , , `211`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MT: [, [, , `1\\d\\d(?:\\d{3})?`, , , , , , , [3, 6]], , , [, , `11(?:2|6\\d{3})`, , , , `112`], [, , , , , , , , , [-1]], , , , `MT`, , , , , , , , , , , , , , , , , , [, , `112`, , , , `112`, , , [3]], , [, , `11(?:2|6(?:000|1(?:11|23)))`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MU: [, [, , `[189]\\d{2,4}`, , , , , , , [3, 4, 5]], , , [, , `11[45]|99[59]`, , , , `114`, , , [3]], [, , , , , , , , , [-1]], , , , `MU`, , , , , , , , , , , , , , , , , , [, , `11[45]|99[59]`, , , , `114`, , , [3]], , [, , `1\\d{2,4}|(?:8\\d\\d|99)\\d`, , , , `100`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MV: [, [, , `[14]\\d{2,3}`, , , , , , , [3, 4]], , , [, , `1(?:02|1[89])`, , , , `102`, , , [3]], [, , , , , , , , , [-1]], , , , `MV`, , , , , , , , , , , , , , , , , , [, , `1(?:02|1[89])`, , , , `102`, , , [3]], , [, , `1(?:[0-37-9]|[4-6]\\d)\\d|4040|1[45]1`, , , , `100`], [, , , , , , , , , [-1]], [, , `1[45]1`, , , , `141`, , , [3]], , [, , , , , , , , , [-1]]], MW: [, [, , `[189]\\d\\d(?:\\d{2})?`, , , , , , , [3, 5]], , , [, , `199|99[7-9]`, , , , `199`, , , [3]], [, , , , , , , , , [-1]], , , , `MW`, , , , , , , , , , , , , , , , , , [, , `199|99[7-9]`, , , , `199`, , , [3]], , [, , `199|80400|99[7-9]`, , , , `199`], [, , , , , , , , , [-1]], [, , `804\\d\\d`, , , , `80400`, , , [5]], , [, , `804\\d\\d`, , , , `80400`, , , [5]]], MX: [, [, , `[0579]\\d{2,4}`, , , , , , , [3, 4, 5]], , , [, , `0(?:6[0568]|80)|911`, , , , `060`, , , [3]], [, , `(?:530\\d|776)\\d`, , , , `7760`, , , [4, 5]], , , , `MX`, , , , , , , , , , , , , , , , , , [, , `0(?:6[0568]|80)|911`, , , , `060`, , , [3]], , [, , `0[1-9]\\d|53053|7766|911`, , , , `010`], [, , , , , , , , , [-1]], [, , `0(?:[249]0|[35][01])`, , , , `020`, , , [3]], , [, , , , , , , , , [-1]]], MY: [, [, , `[1369]\\d{2,4}`, , , , , , , [3, 4, 5]], , , [, , `112|999`, , , , `112`, , , [3]], [, , , , , , , , , [-1]], , , , `MY`, , , , , , , , , , , , , , , , , , [, , `112|999`, , , , `112`, , , [3]], , [, , `1(?:0[01348]|1(?:[02]|1[128]|311)|2(?:0[125]|[13-6]|2\\d{0,2})|(?:3[1-35-79]|7[45])\\d\\d?|5(?:454|5\\d\\d?|77|888|999?)|8(?:18?|2|8[18])|9(?:[124]\\d?|68|71|9[0679]))|66628|99[1-469]|13[5-7]|(?:1(?:0[569]|309|5[12]|7[136-9]|9[03])|3[23679]\\d\\d)\\d`, , , , `100`], [, , `666\\d\\d`, , , , `66600`, , , [5]], [, , , , , , , , , [-1]], , [, , `(?:3[23679]\\d|666)\\d\\d`, , , , `32000`, , , [5]]], MZ: [, [, , `1\\d{2,3}`, , , , , , , [3, 4]], , , [, , `1(?:1[79]|9[78])`, , , , `117`, , , [3]], [, , , , , , , , , [-1]], , , , `MZ`, , , , , , , , , , , , , , , , , , [, , `1(?:1[79]|9[78])`, , , , `117`, , , [3]], , [, , `1(?:[02-5]\\d\\d|1[79]|9[78])`, , , , `117`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], NA: [, [, , `[19]\\d{2,4}`, , , , , , , [3, 4, 5]], , , [, , `10111`, , , , `10111`, , , [5]], [, , , , , , , , , [-1]], , , , `NA`, , , , , , , , , , , , , , , , , , [, , `10111`, , , , `10111`, , , [5]], , [, , `(?:10|93)111|(?:1\\d|9)\\d\\d`, , , , `900`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], NC: [, [, , `[135]\\d{1,3}`, , , , , , , [2, 3, 4]], , , [, , `1(?:0(?:00|1[23]|3[0-2]|8\\d)|[5-8])|363\\d|577`, , , , `15`], [, , , , , , , , , [-1]], , , , `NC`, , , , , , , , , , , , , , , , , , [, , `1[5-8]`, , , , `15`, , , [2]], , [, , `1(?:0(?:0[06]|1[02-46]|20|3[0-25]|42|5[058]|77|88)|[5-8])|3631|5[6-8]\\d`, , , , `15`], [, , `5(?:67|88)`, , , , `567`, , , [3]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], NE: [, [, , `[1-3578]\\d(?:\\d(?:\\d{3})?)?`, , , , , , , [2, 3, 6]], , , [, , `1(?:18|[578])|723\\d{3}`, , , , `15`], [, , , , , , , , , [-1]], , , , `NE`, , , , , , , , , , , , , , , , , , [, , `1(?:18|[578])|723141`, , , , `15`], , [, , `1(?:0[01]|1[128]|2[034]|3[013]|[46]0|55?|[78])|222|333|555|723141|888`, , , , `15`], [, , , , , , , , , [-1]], [, , `1(?:0[01]|1[12]|2[034]|3[013]|[46]0|55)|222|333|555|888`, , , , `100`, , , [3]], , [, , , , , , , , , [-1]]], NF: [, [, , `9\\d\\d`, , , , , , , [3]], , , [, , `9(?:11|55|77)`, , , , `911`], [, , , , , , , , , [-1]], , , , `NF`, , , , , , , , , , , , , , , , , , [, , `9(?:11|55|77)`, , , , `911`], , [, , `9(?:11|55|77)`, , , , `911`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], NG: [, [, , `[14]\\d\\d(?:\\d{2})?`, , , , , , , [3, 5]], , , [, , `199`, , , , `199`, , , [3]], [, , , , , , , , , [-1]], , , , `NG`, , , , , , , , , , , , , , , , , , [, , `199`, , , , `199`, , , [3]], , [, , `199|40700`, , , , `199`], [, , , , , , , , , [-1]], [, , `407\\d\\d`, , , , `40700`, , , [5]], , [, , `407\\d\\d`, , , , `40700`, , , [5]]], NI: [, [, , `[12467]\\d{2,3}`, , , , , , , [3, 4]], , , [, , `1(?:1[58]|2[08])|737\\d`, , , , `115`], [, , , , , , , , , [-1]], , , , `NI`, , , , , , , , , , , , , , , , , , [, , `1(?:1[58]|2[08])`, , , , `115`, , , [3]], , [, , `1(?:1[58]|200)|4878|7(?:010|373)|12[0158]|(?:19|[267]1)00`, , , , `115`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], NL: [, [, , `[1349]\\d\\d(?:\\d(?:\\d{2})?)?`, , , , , , , [3, 4, 6]], , , [, , `11(?:2|6\\d{3})|911`, , , , `112`, , , [3, 6]], [, , , , , , , , , [-1]], , , , `NL`, , , , , , , , , , , , , , , , , , [, , `112|911`, , , , `112`, , , [3]], , [, , `1(?:1(?:2|6(?:00[06]|1(?:11|23)))|2(?:0[0-4]|3[34]|44)|3[03-9]\\d|400|8(?:[02-9]\\d|1[0-79]))|[34]000|911`, , , , `112`], [, , , , , , , , , [-1]], [, , `120\\d`, , , , `1200`, , , [4]], , [, , `[34]00\\d`, , , , `3000`, , , [4]]], NO: [, [, , `[01]\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `11(?:[023]|6\\d{3})`, , , , `110`, , , [3, 6]], [, , , , , , , , , [-1]], , , , `NO`, , , , , , , , , , , , , , , , , , [, , `11[023]`, , , , `110`, , , [3]], , [, , `04\\d{3}|1(?:1(?:[0239]|61(?:1[17]|23))|2[048]|4(?:12|[59])|7[57]|8[5-9]\\d|90)`, , , , `110`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , `04\\d{3}`, , , , `04000`, , , [5]]], NP: [, [, , `1\\d{2,3}`, , , , , , , [3, 4]], , , [, , `1(?:0[0-36]|12)|1(?:09|11)\\d`, , , , `100`], [, , , , , , , , , [-1]], , , , `NP`, , , , , , , , , , , , , , , , , , [, , `1(?:0[0-3]|12)`, , , , `100`, , , [3]], , [, , `1(?:0(?:[0-36]|98)|1(?:1[1-4]|2))`, , , , `100`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], NR: [, [, , `1\\d\\d`, , , , , , , [3]], , , [, , `11[0-2]`, , , , `110`], [, , , , , , , , , [-1]], , , , `NR`, , , , , , , , , , , , , , , , , , [, , `11[0-2]`, , , , `110`], , [, , `1(?:1[0-2]|23|92)`, , , , `110`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], NU: [, [, , `[019]\\d\\d`, , , , , , , [3]], , , [, , `999`, , , , `999`], [, , , , , , , , , [-1]], , , , `NU`, , , , , , , , , , , , , , , , , , [, , `999`, , , , `999`], , [, , `01[05]|101|999`, , , , `010`], [, , , , , , , , , [-1]], [, , `010`, , , , `010`], , [, , , , , , , , , [-1]]], NZ: [, [, , `\\d{3,4}`, , , , , , , [3, 4]], , , [, , `111`, , , , `111`, , , [3]], [, , `018`, , , , `018`, , , [3]], , , , `NZ`, , , , , , , , , , , , , , , , , , [, , `111`, , , , `111`, , , [3]], , [, , `018|1(?:(?:1|37)1|(?:23|94)4|7[03]7)|[2-57-9]\\d{2,3}|6(?:161|26[0-3]|742)`, , , , `018`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , `018|(?:1(?:23|37|7[03]|94)|6(?:[12]6|74))\\d|[2-57-9]\\d{2,3}`, , , , `018`]], OM: [, [, , `[19]\\d{3}`, , , , , , , [4]], , , [, , `1444|999\\d`, , , , `1444`], [, , , , , , , , , [-1]], , , , `OM`, , , , , , , , , , , , , , , , , , [, , `1444|9999`, , , , `1444`], , [, , `1(?:111|222|4(?:4[0-5]|50|66|7[7-9])|51[0-8])|9999|1(?:2[3-5]|3[0-2]|50)\\d`, , , , `1111`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PA: [, [, , `[19]\\d\\d`, , , , , , , [3]], , , [, , `911`, , , , `911`], [, , , , , , , , , [-1]], , , , `PA`, , , , , , , , , , , , , , , , , , [, , `911`, , , , `911`], , [, , `10[2-4]|911`, , , , `102`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PE: [, [, , `1\\d\\d`, , , , , , , [3]], , , [, , `1(?:05|1[67])`, , , , `105`], [, , , , , , , , , [-1]], , , , `PE`, , , , , , , , , , , , , , , , , , [, , `1(?:05|1[67])`, , , , `105`], , [, , `1(?:05|1[67])`, , , , `105`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PF: [, [, , `1\\d`, , , , , , , [2]], , , [, , `1[578]`, , , , `15`], [, , , , , , , , , [-1]], , , , `PF`, , , , , , , , , , , , , , , , , , [, , `1[578]`, , , , `15`], , [, , `1[578]`, , , , `15`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PG: [, [, , `[01]\\d{2,6}`, , , , , , , [3, 4, 5, 6, 7]], , , [, , `000|11[01]`, , , , `000`, , , [3]], [, , , , , , , , , [-1]], , , , `PG`, , , , , , , , , , , , , , , , , , [, , `000|11[01]`, , , , `000`, , , [3]], , [, , `000|1(?:1[01]|5\\d\\d|6\\d{2,5})`, , , , `000`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , `16\\d{2,5}`, , , , `1600`, , , [4, 5, 6, 7]]], PH: [, [, , `[19]\\d\\d`, , , , , , , [3]], , , [, , `11[27]|911`, , , , `112`], [, , , , , , , , , [-1]], , , , `PH`, , , , , , , , , , , , , , , , , , [, , `11[27]|911`, , , , `112`], , [, , `11[27]|911`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PK: [, [, , `1\\d{1,3}`, , , , , , , [2, 3, 4]], , , [, , `1(?:1(?:2\\d?|5)|[56])`, , , , `15`], [, , , , , , , , , [-1]], , , , `PK`, , , , , , , , , , , , , , , , , , [, , `1(?:1(?:22?|5)|[56])`, , , , `15`], , [, , `1(?:122|3[014]|[56])|11[2457-9]`, , , , `15`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PL: [, [, , `[19]\\d\\d(?:\\d{2,3})?`, , , , , , , [3, 5, 6]], , , [, , `11(?:2|6\\d{3})|99[7-9]`, , , , `112`, , , [3, 6]], [, , , , , , , , , [-1]], , , , `PL`, , , , , , , , , , , , , , , , , , [, , `112|99[7-9]`, , , , `112`, , , [3]], , [, , `1(?:1(?:2|61(?:11|23)|891[23])|9\\d{3})|9(?:8[4-7]|9[1-9])|11[68]000`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PM: [, [, , `[13]\\d(?:\\d\\d(?:\\d{2})?)?`, , , , , , , [2, 4, 6]], , , [, , `1[578]|3(?:0\\d|1[689])\\d`, , , , `15`, , , [2, 4]], [, , `3[2469]\\d\\d`, , , , `3200`, , , [4]], , , , `PM`, , , , , , , , , , , , , , , , , , [, , `1[578]`, , , , `15`, , , [2]], , [, , `1[578]|31(?:03|[689]\\d)|(?:118[02-9]|3[02469])\\d\\d`, , , , `15`], [, , `118\\d{3}`, , , , `118000`, , , [6]], [, , `310\\d`, , , , `3100`, , , [4]], , [, , , , , , , , , [-1]]], PR: [, [, , `9\\d\\d`, , , , , , , [3]], , , [, , `9(?:11|88)`, , , , `911`], [, , , , , , , , , [-1]], , , , `PR`, , , , , , , , , , , , , , , , , , [, , `911`, , , , `911`], , [, , `9(?:11|88)`, , , , `911`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PS: [, [, , `1\\d{2,3}`, , , , , , , [3, 4]], , , [, , `1(?:0[0-2]|66)`, , , , `100`, , , [3]], [, , , , , , , , , [-1]], , , , `PS`, , , , , , , , , , , , , , , , , , [, , `10[0-2]`, , , , `100`, , , [3]], , [, , `1(?:0[0-2]|122|44|66|99)`, , , , `100`], [, , , , , , , , , [-1]], [, , `112\\d`, , , , `1120`, , , [4]], , [, , , , , , , , , [-1]]], PT: [, [, , `1\\d\\d(?:\\d(?:\\d{2})?)?`, , , , , , , [3, 4, 6]], , , [, , `11[257]|1(?:16\\d\\d|5[1589]|8[279])\\d`, , , , `112`], [, , , , , , , , , [-1]], , , , `PT`, , , , , , , , , , , , , , , , , , [, , `11[25]`, , , , `112`, , , [3]], , [, , `1(?:0(?:45|5[01])|1(?:[2578]|600[06])|4(?:1[45]|4)|583|6(?:1[0236]|3[02]|9[169]))|1(?:1611|59)1|1[068]78|1[08]9[16]|1(?:0[1-38]|40|5[15]|6[258]|82)0`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PW: [, [, , `9\\d\\d`, , , , , , , [3]], , , [, , `911`, , , , `911`], [, , , , , , , , , [-1]], , , , `PW`, , , , , , , , , , , , , , , , , , [, , `911`, , , , `911`], , [, , `911`, , , , `911`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PY: [, [, , `[19]\\d\\d`, , , , , , , [3]], , , [, , `128|911`, , , , `128`], [, , , , , , , , , [-1]], , , , `PY`, , , , , , , , , , , , , , , , , , [, , `128|911`, , , , `128`], , [, , `1[1-9]\\d|911`, , , , `110`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], QA: [, [, , `[129]\\d{2,4}`, , , , , , , [3, 4, 5]], , , [, , `99\\d`, , , , `990`, , , [3]], [, , `900`, , , , `900`, , , [3]], , , , `QA`, , , , , , , , , , , , , , , , , , [, , `999`, , , , `999`, , , [3]], , [, , `9(?:00|[19]\\d)|(?:1|20|9[27]\\d)\\d\\d`, , , , `100`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], RE: [, [, , `1\\d\\d?`, , , , , , , [2, 3]], , , [, , `1(?:12|[578])`, , , , `15`], [, , , , , , , , , [-1]], , , , `RE`, , , , , , , , , , , , , , , , , , [, , `1(?:12|[578])`, , , , `15`], , [, , `1(?:12|[578])`, , , , `15`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], RO: [, [, , `[18]\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `11(?:2|6\\d{3})`, , , , `112`, , , [3, 6]], [, , `(?:1(?:18[39]|[24])|8[48])\\d\\d`, , , , `1200`, , , [4, 6]], , , , `RO`, , , , , , , , , , , , , , , , , , [, , `112`, , , , `112`, , , [3]], , [, , `1(?:1(?:2|6(?:000|1(?:11|23))|8(?:(?:01|8[18])1|119|[23]00|932))|[24]\\d\\d|9(?:0(?:00|19)|1[19]|21|3[02]|5[178]))|8[48]\\d\\d`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , `(?:1[24]|8[48])\\d\\d`, , , , `1200`, , , [4]]], RS: [, [, , `[19]\\d{1,5}`, , , , , , , [2, 3, 4, 5, 6]], , , [, , `112|9[2-4]`, , , , `92`, , , [2, 3]], [, , , , , , , , , [-1]], , , , `RS`, , , , , , , , , , , , , , , , , , [, , `112|9[2-4]`, , , , `92`, , , [2, 3]], , [, , `1[189]\\d{1,4}|9[2-4]`, , , , `92`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], RU: [, [, , `[01]\\d\\d?`, , , , , , , [2, 3]], , , [, , `112|(?:0|10)[1-3]`, , , , `01`], [, , , , , , , , , [-1]], , , , `RU`, , , , , , , , , , , , , , , , , , [, , `112|(?:0|10)[1-3]`, , , , `01`], , [, , `112|(?:0|10)[1-4]`, , , , `01`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], RW: [, [, , `[14]\\d\\d`, , , , , , , [3]], , , [, , `11[1245]`, , , , `111`], [, , , , , , , , , [-1]], , , , `RW`, , , , , , , , , , , , , , , , , , [, , `11[12]`, , , , `111`], , [, , `1(?:0[0-2]|1[0-24-6]|2[13]|70|99)|456`, , , , `100`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SA: [, [, , `[19]\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `11(?:2|6\\d{3})|9(?:11|37|9[7-9])`, , , , `112`, , , [3, 6]], [, , , , , , , , , [-1]], , , , `SA`, , , , , , , , , , , , , , , , , , [, , `112|9(?:11|9[79])`, , , , `112`, , , [3]], , [, , `1(?:1(?:00|2|6111)|410|9(?:00|1[89]|9(?:099|22|9[0-3])))|9(?:0[24-79]|11|3[379]|40|66|8[5-9]|9[02-9])`, , , , `112`], [, , `141\\d`, , , , `1410`, , , [4]], [, , `1(?:10|41)\\d|90[24679]`, , , , `902`, , , [3, 4]], , [, , , , , , , , , [-1]]], SB: [, [, , `[127-9]\\d\\d`, , , , , , , [3]], , , [, , `999`, , , , `999`], [, , , , , , , , , [-1]], , , , `SB`, , , , , , , , , , , , , , , , , , [, , `999`, , , , `999`], , [, , `1(?:[02]\\d|1[12]|[35][01]|[49][1-9]|6[2-9]|7[7-9]|8[0-8])|269|777|835|9(?:[01]1|22|33|55|77|88|99)`, , , , `100`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SC: [, [, , `[19]\\d{2,3}`, , , , , , , [3, 4]], , , [, , `1(?:1[1468]|60)|999`, , , , `111`, , , [3]], [, , , , , , , , , [-1]], , , , `SC`, , , , , , , , , , , , , , , , , , [, , `999`, , , , `999`, , , [3]], , [, , `1(?:[06]\\d|1[0-246-8]|2[0-8]|3[13]|4[0-2]|5[15]|7[124-6]|8[158]|9[015])|9(?:6\\d\\d|99)`, , , , `100`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SD: [, [, , `9\\d\\d`, , , , , , , [3]], , , [, , `999`, , , , `999`], [, , , , , , , , , [-1]], , , , `SD`, , , , , , , , , , , , , , , , , , [, , `999`, , , , `999`], , [, , `999`, , , , `999`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SE: [, [, , `[1-37-9]\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `11(?:2|(?:3|6\\d)\\d\\d|414|77)|900\\d\\d`, , , , `112`], [, , `11811[89]|72\\d{3}`, , , , `72000`, , , [5, 6]], , , , `SE`, , , , , , , , , , , , , , , , , , [, , `112|90000`, , , , `112`, , , [3, 5]], , [, , `11(?:[25]|313|6(?:00[06]|1(?:1[17]|23))|7[0-8])|2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|9(?:0(?:00|51)0|12)|(?:11(?:4|8[02-46-9])|7\\d\\d|90[2-4])\\d\\d|(?:118|90)1(?:[02-9]\\d|1[013-9])`, , , , `112`], [, , , , , , , , , [-1]], [, , `2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|912`, , , , `220`, , , [3]], , [, , `7\\d{4}`, , , , `70000`, , , [5]]], SG: [, [, , `[179]\\d{2,4}`, , , , , , , [3, 4, 5]], , , [, , `99[359]`, , , , `993`, , , [3]], [, , , , , , , , , [-1]], , , , `SG`, , , , , , , , , , , , , , , , , , [, , `99[359]`, , , , `993`, , , [3]], , [, , `1(?:(?:[01368]\\d|44)\\d|[57]\\d{2,3}|9(?:0[1-9]|[1-9]\\d))|77222|99[02-9]|100`, , , , `100`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , `772\\d\\d`, , , , `77200`, , , [5]]], SH: [, [, , `[129]\\d{2,4}`, , , , , , , [3, 4, 5]], , , [, , `9(?:11|99)`, , , , `911`, , , [3]], [, , , , , , , , , [-1]], , , , `SH`, , , , , , , , , , , , , , , , , , [, , `9(?:11|99)`, , , , `911`, , , [3]], , [, , `1\\d{2,3}|26[01]\\d\\d|9(?:11|99)`, , , , `100`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SI: [, [, , `1\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `11(?:(?:0|6\\d)\\d\\d|[23]|8\\d\\d?)`, , , , `112`], [, , , , , , , , , [-1]], , , , `SI`, , , , , , , , , , , , , , , , , , [, , `11[23]`, , , , `112`, , , [3]], , [, , `1(?:1(?:00[146]|[23]|6(?:000|1(?:11|23))|8(?:[08]|99))|9(?:059|1(?:0[12]|16)|5|70|87|9(?:00|[149])))|19(?:08|81)[09]`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SJ: [, [, , `[01]\\d\\d(?:\\d{2})?`, , , , , , , [3, 5]], , , [, , `11[023]`, , , , `110`, , , [3]], [, , , , , , , , , [-1]], , , , `SJ`, , , , , , , , , , , , , , , , , , [, , `11[023]`, , , , `110`, , , [3]], , [, , `04\\d{3}|11[023]`, , , , `110`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , `04\\d{3}`, , , , `04000`, , , [5]]], SK: [, [, , `1\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `1(?:1(?:2|6\\d{3})|5[058])`, , , , `112`, , , [3, 6]], [, , , , , , , , , [-1]], , , , `SK`, , , , , , , , , , , , , , , , , , [, , `1(?:12|5[058])`, , , , `112`, , , [3]], , [, , `1(?:1(?:2|6(?:000|111)|8[0-8])|[248]\\d{3}|5[0589])`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SL: [, [, , `[069]\\d\\d(?:\\d{2})?`, , , , , , , [3, 5]], , , [, , `(?:01|99)9`, , , , `019`, , , [3]], [, , , , , , , , , [-1]], , , , `SL`, , , , , , , , , , , , , , , , , , [, , `(?:01|99)9`, , , , `019`, , , [3]], , [, , `(?:01|99)9|60400`, , , , `019`], [, , , , , , , , , [-1]], [, , `604\\d\\d`, , , , `60400`, , , [5]], , [, , `604\\d\\d`, , , , `60400`, , , [5]]], SM: [, [, , `1\\d\\d`, , , , , , , [3]], , , [, , `11[358]`, , , , `113`], [, , , , , , , , , [-1]], , , , `SM`, , , , , , , , , , , , , , , , , , [, , `11[358]`, , , , `113`], , [, , `11[358]`, , , , `113`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SN: [, [, , `[12]\\d{1,5}`, , , , , , , [2, 3, 4, 5, 6]], , , [, , `1(?:515|[78])|2(?:00|1)\\d{3}`, , , , `17`, , , [2, 4, 5, 6]], [, , `2(?:0[246]|[468])\\d{3}`, , , , `24000`, , , [5, 6]], , , , `SN`, , , , , , , , , , , , , , , , , , [, , `1[78]`, , , , `17`, , , [2]], , [, , `1(?:1[69]|(?:[246]\\d|51)\\d)|2(?:0[0-246]|[12468])\\d{3}|1[278]`, , , , `12`], [, , `2(?:01|2)\\d{3}`, , , , `22000`, , , [5, 6]], [, , `1[46]\\d\\d`, , , , `1400`, , , [4]], , [, , `2[468]\\d{3}`, , , , `24000`, , , [5]]], SO: [, [, , `[57-9]\\d\\d`, , , , , , , [3]], , , [, , `555|888|999`, , , , `555`], [, , , , , , , , , [-1]], , , , `SO`, , , , , , , , , , , , , , , , , , [, , `555|888|999`, , , , `555`], , [, , `555|777|888|999`, , , , `555`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SR: [, [, , `1\\d{2,3}`, , , , , , , [3, 4]], , , [, , `115`, , , , `115`, , , [3]], [, , , , , , , , , [-1]], , , , `SR`, , , , , , , , , , , , , , , , , , [, , `115`, , , , `115`, , , [3]], , [, , `1\\d{2,3}`, , , , `100`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SS: [, [, , `9\\d\\d`, , , , , , , [3]], , , [, , `999`, , , , `999`], [, , , , , , , , , [-1]], , , , `SS`, , , , , , , , , , , , , , , , , , [, , `999`, , , , `999`], , [, , `999`, , , , `999`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], ST: [, [, , `1\\d\\d`, , , , , , , [3]], , , [, , `112`, , , , `112`], [, , , , , , , , , [-1]], , , , `ST`, , , , , , , , , , , , , , , , , , [, , `112`, , , , `112`], , [, , `112`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SV: [, [, , `[149]\\d\\d(?:\\d{2,3})?`, , , , , , , [3, 5, 6]], , , [, , `116\\d{3}|911`, , , , `911`, , , [3, 6]], [, , , , , , , , , [-1]], , , , `SV`, , , , , , , , , , , , , , , , , , [, , `91[13]`, , , , `911`, , , [3]], , [, , `1(?:1(?:2|6111)|2[136-8]|3[0-6]|9[05])|40404|9(?:1\\d|29)`, , , , `112`], [, , , , , , , , , [-1]], [, , `404\\d\\d`, , , , `40400`, , , [5]], , [, , `404\\d\\d`, , , , `40400`, , , [5]]], SX: [, [, , `9\\d\\d`, , , , , , , [3]], , , [, , `9(?:19|88)`, , , , `919`], [, , , , , , , , , [-1]], , , , `SX`, , , , , , , , , , , , , , , , , , [, , `919`, , , , `919`], , [, , `9(?:19|88)`, , , , `919`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SY: [, [, , `1\\d\\d`, , , , , , , [3]], , , [, , `11[023]`, , , , `110`], [, , , , , , , , , [-1]], , , , `SY`, , , , , , , , , , , , , , , , , , [, , `11[023]`, , , , `110`], , [, , `11[023]`, , , , `110`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SZ: [, [, , `9\\d\\d`, , , , , , , [3]], , , [, , `999`, , , , `999`], [, , , , , , , , , [-1]], , , , `SZ`, , , , , , , , , , , , , , , , , , [, , `999`, , , , `999`], , [, , `999`, , , , `999`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TC: [, [, , `9\\d\\d`, , , , , , , [3]], , , [, , `9(?:11|88|99)`, , , , `911`], [, , , , , , , , , [-1]], , , , `TC`, , , , , , , , , , , , , , , , , , [, , `9(?:11|99)`, , , , `911`], , [, , `9(?:11|88|99)`, , , , `911`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TD: [, [, , `1\\d`, , , , , , , [2]], , , [, , `1[78]`, , , , `17`], [, , , , , , , , , [-1]], , , , `TD`, , , , , , , , , , , , , , , , , , [, , `1[78]`, , , , `17`], , [, , `1[78]`, , , , `17`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TG: [, [, , `1\\d{2,3}`, , , , , , , [3, 4]], , , [, , `1(?:1[78]|7[127])`, , , , `117`, , , [3]], [, , , , , , , , , [-1]], , , , `TG`, , , , , , , , , , , , , , , , , , [, , `1(?:1[78]|7[127])`, , , , `117`, , , [3]], , [, , `1(?:011|1[078]|7[127])`, , , , `110`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TH: [, [, , `1\\d{2,3}`, , , , , , , [3, 4]], , , [, , `1(?:1(?:00|2[03]|3[3479]|7[67]|9[0246])|578|6(?:44|6[79]|88|9[16])|88\\d|9[19])|1[15]55`, , , , `191`], [, , `1(?:113|2[23]\\d|5(?:09|56))`, , , , `1113`, , , [4]], , , , `TH`, , , , , , , , , , , , , , , , , , [, , `1(?:669|9[19])`, , , , `191`], , [, , `1(?:0[0-2]|1(?:0[03]|1[1-35]|2[0358]|3[03-79]|4[02-489]|5[04-9]|6[04-79]|7[03-9]|8[027-9]|9[02-9])|2(?:22|3[89]|66)|3(?:18|2[23]|3[013]|5[56]|6[45]|73)|477|5(?:0\\d|4[0-37-9]|5[1-8]|6[01679]|7[12568]|8[0-24589]|9[013589])|6(?:0[0-29]|2[03]|4[3-6]|6[1-9]|7[0257-9]|8[0158]|9[014-9])|7(?:[14]9|7[27]|90)|888|9[19])`, , , , `100`], [, , `1(?:1(?:03|1[15]|2[58]|3[056]|4[02-49]|5[046-9]|7[03-589]|9[57-9])|5(?:0[0-8]|4[0-378]|5[1-478]|7[156])|6(?:20|4[356]|6[1-68]|7[057-9]|8[015]|9[0457-9]))|1(?:1[68]|26|3[1-35]|5[689]|60|7[17])\\d`, , , , `1103`, , , [4]], [, , `114[89]`, , , , `1148`, , , [4]], , [, , , , , , , , , [-1]]], TJ: [, [, , `1\\d\\d`, , , , , , , [3]], , , [, , `1(?:0[1-3]|12)`, , , , `101`], [, , , , , , , , , [-1]], , , , `TJ`, , , , , , , , , , , , , , , , , , [, , `1(?:0[1-3]|12)`, , , , `101`], , [, , `1(?:0[1-3]|12)`, , , , `101`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TL: [, [, , `1\\d\\d`, , , , , , , [3]], , , [, , `11[25]`, , , , `112`], [, , , , , , , , , [-1]], , , , `TL`, , , , , , , , , , , , , , , , , , [, , `11[25]`, , , , `112`], , [, , `1(?:0[02]|1[25]|2[0138]|72|9[07])`, , , , `100`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TM: [, [, , `0\\d`, , , , , , , [2]], , , [, , `0[1-49]`, , , , `01`], [, , , , , , , , , [-1]], , , , `TM`, , , , , , , , , , , , , , , , , , [, , `0[1-3]`, , , , `01`], , [, , `0[1-49]`, , , , `01`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TN: [, [, , `1\\d\\d`, , , , , , , [3]], , , [, , `19[078]`, , , , `190`], [, , , , , , , , , [-1]], , , , `TN`, , , , , , , , , , , , , , , , , , [, , `19[078]`, , , , `190`], , [, , `19[078]`, , , , `190`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TO: [, [, , `9\\d\\d`, , , , , , , [3]], , , [, , `9(?:11|22|33|99)`, , , , `911`], [, , , , , , , , , [-1]], , , , `TO`, , , , , , , , , , , , , , , , , , [, , `9(?:11|22|33|99)`, , , , `911`], , [, , `9(?:11|22|33|99)`, , , , `911`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TR: [, [, , `[1-9]\\d{2,4}`, , , , , , , [3, 4, 5]], , , [, , `1(?:1[02]|22|3[126]|4[04]|5[15-9]|6[18]|77|83)`, , , , `110`, , , [3]], [, , , , , , , , , [-1]], , , , `TR`, , , , , , , , , , , , , , , , , , [, , `1(?:1[02]|55)`, , , , `110`, , , [3]], , [, , `1(?:1(?:[02-79]|8(?:1[018]|2[0245]|3[2-4]|42|5[058]|6[06]|7[07]|8[01389]|9[089]))|3(?:37|[58]6|65)|471|5(?:07|78)|6(?:[02]6|99)|8(?:63|95))|2(?:077|268|4(?:17|23)|5(?:7[26]|82)|6[14]4|8\\d\\d|9(?:30|89))|3(?:0(?:05|72)|353|4(?:06|30|64)|502|674|747|851|9(?:1[29]|60))|4(?:0(?:25|3[12]|[47]2)|3(?:3[13]|[89]1)|439|5(?:43|55)|717|832)|5(?:145|290|[4-6]\\d\\d|772|833|9(?:[06]1|92))|6(?:236|6(?:12|39|8[59])|769)|7890|8(?:688|7(?:28|65)|85[06])|9(?:159|290)|1[2-9]\\d`, , , , `110`], [, , `(?:285|542)0`, , , , `2850`, , , [4]], [, , , , , , , , , [-1]], , [, , `1(?:3(?:37|[58]6|65)|4(?:4|71)|5(?:07|78)|6(?:[02]6|99)|8(?:3|63|95))|(?:2(?:07|26|4[12]|5[78]|6[14]|8\\d|9[38])|3(?:0[07]|[38]5|4[036]|50|67|74|9[16])|4(?:0[2-47]|3[389]|[48]3|5[45]|71)|5(?:14|29|[4-6]\\d|77|83|9[069])|6(?:23|6[138]|76)|789|8(?:68|7[26]|85)|9(?:15|29))\\d`, , , , `144`, , , [3, 4]]], TT: [, [, , `9\\d\\d`, , , , , , , [3]], , , [, , `9(?:88|9[09])`, , , , `988`], [, , , , , , , , , [-1]], , , , `TT`, , , , , , , , , , , , , , , , , , [, , `99[09]`, , , , `990`], , [, , `9(?:88|9[09])`, , , , `988`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TV: [, [, , `[19]\\d\\d`, , , , , , , [3]], , , [, , `911`, , , , `911`], [, , , , , , , , , [-1]], , , , `TV`, , , , , , , , , , , , , , , , , , [, , `911`, , , , `911`], , [, , `1\\d\\d|911`, , , , `100`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TW: [, [, , `1\\d{2,3}`, , , , , , , [3, 4]], , , [, , `11[0289]|1(?:81|92)\\d`, , , , `110`], [, , `10[56]`, , , , `105`, , , [3]], , , , `TW`, , , , , , , , , , , , , , , , , , [, , `11[029]`, , , , `110`, , , [3]], , [, , `1(?:0[04-6]|1[0237-9]|3[389]|6[05-8]|7[07]|8(?:0|11)|9(?:19|22|5[057]|68|8[05]|9[15689]))`, , , , `100`], [, , `1(?:65|9(?:1\\d|50|85|98))`, , , , `165`], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TZ: [, [, , `[149]\\d\\d(?:\\d{2})?`, , , , , , , [3, 5]], , , [, , `1(?:1[0-79]|9[09])|999`, , , , `110`, , , [3]], [, , , , , , , , , [-1]], , , , `TZ`, , , , , , , , , , , , , , , , , , [, , `11[0-245]|999`, , , , `110`, , , [3]], , [, , `1(?:1\\d|9[09])|46400|999`, , , , `110`], [, , , , , , , , , [-1]], [, , `464\\d\\d`, , , , `46400`, , , [5]], , [, , `464\\d\\d`, , , , `46400`, , , [5]]], UA: [, [, , `[189]\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `1(?:0[1-3]|1(?:2|6\\d{3}))`, , , , `101`, , , [3, 6]], [, , , , , , , , , [-1]], , , , `UA`, , , , , , , , , , , , , , , , , , [, , `1(?:0[1-3]|12)`, , , , `101`, , , [3]], , [, , `1(?:0[1-49]|1(?:2|6(?:000|1(?:11|23))|8\\d\\d?)|(?:[278]|5\\d)\\d)|[89]00\\d\\d?|151|1(?:06|4\\d|6)\\d\\d`, , , , `101`], [, , , , , , , , , [-1]], [, , `(?:118|[89]00)\\d\\d?`, , , , `1180`, , , [4, 5]], , [, , , , , , , , , [-1]]], UG: [, [, , `9\\d\\d`, , , , , , , [3]], , , [, , `999`, , , , `999`], [, , , , , , , , , [-1]], , , , `UG`, , , , , , , , , , , , , , , , , , [, , `999`, , , , `999`], , [, , `999`, , , , `999`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], US: [, [, , `[1-9]\\d{2,5}`, , , , , , , [3, 4, 5, 6]], , , [, , `112|611|9(?:11|33|88)`, , , , `112`, , , [3]], [, , `24280|(?:381|968)35|4(?:3355|7553|8221)|5(?:(?:489|934)2|5928)|72078|(?:323|960)40|(?:276|414)63|(?:2(?:520|744)|7390|9968)9|(?:693|732|976)88|(?:3(?:556|825)|5294|8623|9729)4|(?:3378|4136|7642|8961|9979)6|(?:4(?:6(?:15|32)|827)|(?:591|720)8|9529)7`, , , , `24280`, , , [5]], , , , `US`, , , , , , , , , , , , , , , , , , [, , `112|911`, , , , `112`, , , [3]], , [, , `11(?:2|5[1-47]|[68]\\d|7[0-57]|98)|[2-9]\\d{3,5}|[2-8]11|9(?:11|33|88)`, , , , `112`], [, , `2(?:3333|(?:4224|7562|900)2|56447|6688)|3(?:1010|2665|7404)|40404|560560|6(?:0060|22639|5246|7622)|7(?:0701|3822|4666)|8(?:(?:3825|7226)5|4816)|99099`, , , , `23333`, , , [5, 6]], [, , `336\\d\\d|[2-9]\\d{3}|[2356]11`, , , , `211`, , , [3, 4, 5]], , [, , `[2-9]\\d{4,5}`, , , , `20000`, , , [5, 6]]], UY: [, [, , `[129]\\d{2,4}`, , , , , , , [3, 4, 5]], , , [, , `128|911`, , , , `128`, , , [3]], [, , , , , , , , , [-1]], , , , `UY`, , , , , , , , , , , , , , , , , , [, , `128|911`, , , , `128`, , , [3]], , [, , `1(?:0[4-9]|1[2368]|2[0-3568]|787|997\\d?)|21997|911`, , , , `104`], [, , `178\\d`, , , , `1780`, , , [4]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], UZ: [, [, , `[04]\\d(?:\\d(?:\\d{2})?)?`, , , , , , , [2, 3, 5]], , , [, , `0(?:0[1-3]|[1-3]|50)`, , , , `01`, , , [2, 3]], [, , , , , , , , , [-1]], , , , `UZ`, , , , , , , , , , , , , , , , , , [, , `0(?:0[1-3]|[1-3]|50)`, , , , `01`, , , [2, 3]], , [, , `0(?:0[1-3]|[1-3]|50)|45400`, , , , `01`], [, , , , , , , , , [-1]], [, , `454\\d\\d`, , , , `45400`, , , [5]], , [, , `454\\d\\d`, , , , `45400`, , , [5]]], VA: [, [, , `1\\d\\d`, , , , , , , [3]], , , [, , `11[2358]`, , , , `112`], [, , , , , , , , , [-1]], , , , `VA`, , , , , , , , , , , , , , , , , , [, , `11[2358]`, , , , `112`], , [, , `11[2358]`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], VC: [, [, , `9\\d\\d`, , , , , , , [3]], , , [, , `9(?:11|88|99)`, , , , `911`], [, , , , , , , , , [-1]], , , , `VC`, , , , , , , , , , , , , , , , , , [, , `9(?:11|99)`, , , , `911`], , [, , `9(?:11|88|99)`, , , , `911`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], VE: [, [, , `[19]\\d\\d`, , , , , , , [3]], , , [, , `1(?:12|71)|911`, , , , `112`], [, , , , , , , , , [-1]], , , , `VE`, , , , , , , , , , , , , , , , , , [, , `1(?:12|71)|911`, , , , `112`], , [, , `1(?:12|71)|911`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], VG: [, [, , `9\\d\\d`, , , , , , , [3]], , , [, , `9(?:11|88|99)`, , , , `911`], [, , , , , , , , , [-1]], , , , `VG`, , , , , , , , , , , , , , , , , , [, , `9(?:11|99)`, , , , `911`], , [, , `9(?:11|88|99)`, , , , `911`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], VI: [, [, , `9\\d\\d`, , , , , , , [3]], , , [, , `9(?:11|88)`, , , , `911`], [, , , , , , , , , [-1]], , , , `VI`, , , , , , , , , , , , , , , , , , [, , `911`, , , , `911`], , [, , `9(?:11|88)`, , , , `911`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], VN: [, [, , `1\\d\\d`, , , , , , , [3]], , , [, , `11[3-5]`, , , , `113`], [, , , , , , , , , [-1]], , , , `VN`, , , , , , , , , , , , , , , , , , [, , `11[3-5]`, , , , `113`], , [, , `11[3-5]`, , , , `113`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], VU: [, [, , `1\\d\\d`, , , , , , , [3]], , , [, , `112`, , , , `112`], [, , , , , , , , , [-1]], , , , `VU`, , , , , , , , , , , , , , , , , , [, , `112`, , , , `112`], , [, , `112`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], WF: [, [, , `1\\d`, , , , , , , [2]], , , [, , `1[578]`, , , , `15`], [, , , , , , , , , [-1]], , , , `WF`, , , , , , , , , , , , , , , , , , [, , `1[578]`, , , , `15`], , [, , `1[578]`, , , , `15`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], WS: [, [, , `[19]\\d\\d`, , , , , , , [3]], , , [, , `9(?:11|9[4-69])`, , , , `911`], [, , , , , , , , , [-1]], , , , `WS`, , , , , , , , , , , , , , , , , , [, , `9(?:11|9[4-69])`, , , , `911`], , [, , `1(?:1[12]|2[0-6]|[39]0)|9(?:11|9[4-79])`, , , , `111`], [, , , , , , , , , [-1]], [, , `12[0-6]`, , , , `120`], , [, , , , , , , , , [-1]]], XK: [, [, , `1\\d\\d`, , , , , , , [3]], , , [, , `1(?:12|9[2-4])`, , , , `112`], [, , , , , , , , , [-1]], , , , `XK`, , , , , , , , , , , , , , , , , , [, , `1(?:12|9[2-4])`, , , , `112`], , [, , `1(?:12|9[2-4])`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], YE: [, [, , `1\\d\\d`, , , , , , , [3]], , , [, , `19[1459]`, , , , `191`], [, , , , , , , , , [-1]], , , , `YE`, , , , , , , , , , , , , , , , , , [, , `19[1459]`, , , , `191`], , [, , `19[1459]`, , , , `191`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], YT: [, [, , `1\\d\\d?`, , , , , , , [2, 3]], , , [, , `1(?:12|5)`, , , , `15`], [, , , , , , , , , [-1]], , , , `YT`, , , , , , , , , , , , , , , , , , [, , `1(?:12|5)`, , , , `15`], , [, , `1(?:12|5)`, , , , `15`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], ZA: [, [, , `[134]\\d{2,4}`, , , , , , , [3, 4, 5]], , , [, , `1(?:01\\d\\d|12)`, , , , `112`, , , [3, 5]], [, , `41(?:348|851)`, , , , `41348`, , , [5]], , , , `ZA`, , , , , , , , , , , , , , , , , , [, , `1(?:01(?:11|77)|12)`, , , , `112`, , , [3, 5]], , [, , `1(?:0(?:1(?:11|77)|20|7)|1[12]|77(?:3[237]|[45]7|6[279]|9[26]))|[34]\\d{4}`, , , , `107`], [, , `3(?:078[23]|7(?:064|567)|8126)|4(?:394[16]|7751|8837)|4[23]699`, , , , `30782`, , , [5]], [, , `111`, , , , `111`, , , [3]], , [, , `[34]\\d{4}`, , , , `30000`, , , [5]]], ZM: [, [, , `[19]\\d\\d`, , , , , , , [3]], , , [, , `112|99[139]`, , , , `112`], [, , , , , , , , , [-1]], , , , `ZM`, , , , , , , , , , , , , , , , , , [, , `112|99[139]`, , , , `112`], , [, , `112|99[139]`, , , , `112`], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], ZW: [, [, , `[139]\\d\\d(?:\\d{2})?`, , , , , , , [3, 5]], , , [, , `112|9(?:5[023]|61|9[3-59])`, , , , `112`, , , [3]], [, , `3[013-57-9]\\d{3}`, , , , `30000`, , , [5]], , , , `ZW`, , , , , , , , , , , , , , , , , , [, , `112|99[3-59]`, , , , `112`, , , [3]], , [, , `11[2469]|3[013-57-9]\\d{3}|9(?:5[023]|6[0-25]|9[3-59])`, , , , `112`], [, , , , , , , , , [-1]], [, , `114|9(?:5[023]|6[0-25])`, , , , `114`, , , [3]], , [, , , , , , , , , [-1]]] }, i18n$1.phonenumbers.ShortNumberInfo = function() {
            this.regionToMetadataMap = {};
          }, goog.addSingletonGetter(i18n$1.phonenumbers.ShortNumberInfo), i18n$1.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_ = [`BR`, `CL`, `NI`], i18n$1.phonenumbers.ShortNumberInfo.ShortNumberCost = { TOLL_FREE: 0, STANDARD_RATE: 1, PREMIUM_RATE: 2, UNKNOWN_COST: 3 }, i18n$1.phonenumbers.ShortNumberInfo.prototype.getRegionCodesForCountryCode_ = function(t$7) {
            return (t$7 = i18n$1.phonenumbers.metadata.countryCodeToRegionCodeMap[t$7]) ? t$7 : [];
          }, i18n$1.phonenumbers.ShortNumberInfo.prototype.regionDialingFromMatchesNumber_ = function(t$7, o$2) {
            return t$7 = this.getRegionCodesForCountryCode_(t$7.getCountryCodeOrDefault()), o$2 != null && t$7.includes(o$2);
          }, i18n$1.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumberForRegion = function(t$7, o$2) {
            return !this.regionDialingFromMatchesNumber_(t$7, o$2) || (o$2 = this.getMetadataForRegion_(o$2), !o$2) ? false : (t$7 = this.getNationalSignificantNumber_(t$7).length, o$2.getGeneralDesc().possibleLengthArray().includes(t$7));
          }, i18n$1.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumber = function(t$7) {
            var o$2 = this.getRegionCodesForCountryCode_(t$7.getCountryCodeOrDefault());
            t$7 = this.getNationalSignificantNumber_(t$7).length;
            for (var r$2 = 0; r$2 < o$2.length; r$2++) {
              var u = this.getMetadataForRegion_(o$2[r$2]);
              if (u && u.getGeneralDesc().possibleLengthArray().includes(t$7)) return true;
            }
            return false;
          }, i18n$1.phonenumbers.ShortNumberInfo.prototype.isValidShortNumberForRegion = function(t$7, o$2) {
            if (!this.regionDialingFromMatchesNumber_(t$7, o$2) || (o$2 = this.getMetadataForRegion_(o$2), !o$2)) return false;
            t$7 = this.getNationalSignificantNumber_(t$7);
            var r$2 = o$2.getGeneralDesc();
            return this.matchesPossibleNumberAndNationalNumber_(t$7, r$2) ? (o$2 = o$2.getShortCode(), this.matchesPossibleNumberAndNationalNumber_(t$7, o$2)) : false;
          }, i18n$1.phonenumbers.ShortNumberInfo.prototype.isValidShortNumber = function(t$7) {
            var o$2 = this.getRegionCodesForCountryCode_(t$7.getCountryCodeOrDefault()), r$2 = this.getRegionCodeForShortNumberFromRegionList_(t$7, o$2);
            return 1 < o$2.length && r$2 != null ? true : this.isValidShortNumberForRegion(t$7, r$2);
          }, i18n$1.phonenumbers.ShortNumberInfo.prototype.getExpectedCostForRegion = function(t$7, o$2) {
            var r$2 = i18n$1.phonenumbers.ShortNumberInfo.ShortNumberCost;
            if (!this.regionDialingFromMatchesNumber_(t$7, o$2)) return r$2.UNKNOWN_COST;
            var u = this.getMetadataForRegion_(o$2);
            return u ? (t$7 = this.getNationalSignificantNumber_(t$7), u.getGeneralDesc().possibleLengthArray().includes(t$7.length) ? this.matchesPossibleNumberAndNationalNumber_(t$7, u.getPremiumRate()) ? r$2.PREMIUM_RATE : this.matchesPossibleNumberAndNationalNumber_(t$7, u.getStandardRate()) ? r$2.STANDARD_RATE : this.matchesPossibleNumberAndNationalNumber_(t$7, u.getTollFree()) || this.isEmergencyNumber(t$7, o$2) ? r$2.TOLL_FREE : r$2.UNKNOWN_COST : r$2.UNKNOWN_COST) : r$2.UNKNOWN_COST;
          }, i18n$1.phonenumbers.ShortNumberInfo.prototype.getExpectedCost = function(t$7) {
            var o$2 = i18n$1.phonenumbers.ShortNumberInfo.ShortNumberCost, r$2 = this.getRegionCodesForCountryCode_(t$7.getCountryCodeOrDefault());
            if (r$2.length === 0) return o$2.UNKNOWN_COST;
            if (r$2.length === 1) return this.getExpectedCostForRegion(t$7, r$2[0]);
            for (var u = o$2.TOLL_FREE, h$1 = 0; h$1 < r$2.length; h$1++) {
              var m$3 = this.getExpectedCostForRegion(t$7, r$2[h$1]);
              switch (m$3) {
                case o$2.PREMIUM_RATE:
                  return o$2.PREMIUM_RATE;
                case o$2.UNKNOWN_COST:
                  u = o$2.UNKNOWN_COST;
                  break;
                case o$2.STANDARD_RATE:
                  u !== o$2.UNKNOWN_COST && (u = o$2.STANDARD_RATE);
                  break;
                case o$2.TOLL_FREE:
                  break;
                default:
                  throw Error(`Unrecognized cost for region: ` + m$3);
              }
            }
            return u;
          }, i18n$1.phonenumbers.ShortNumberInfo.prototype.getRegionCodeForShortNumberFromRegionList_ = function(t$7, o$2) {
            if (o$2.length === 0) return null;
            if (o$2.length === 1) return o$2[0];
            t$7 = this.getNationalSignificantNumber_(t$7);
            for (var r$2 = 0; r$2 < o$2.length; r$2++) {
              var u = o$2[r$2], h$1 = this.getMetadataForRegion_(u);
              if (h$1 && this.matchesPossibleNumberAndNationalNumber_(t$7, h$1.getShortCode())) return u;
            }
            return null;
          }, i18n$1.phonenumbers.ShortNumberInfo.prototype.getSupportedRegions = function() {
            return Object.keys(i18n$1.phonenumbers.shortnumbermetadata.countryToMetadata).filter(function(t$7) {
              return isNaN(t$7);
            });
          }, i18n$1.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumber = function(t$7) {
            return t$7 = this.getMetadataForRegion_(t$7), t$7 ? (t$7 = t$7.getShortCode(), t$7.hasExampleNumber() && t$7.getExampleNumber() || ``) : ``;
          }, i18n$1.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumberForCost = function(t$7, o$2) {
            if (t$7 = this.getMetadataForRegion_(t$7), !t$7) return ``;
            var r$2 = i18n$1.phonenumbers.ShortNumberInfo.ShortNumberCost, u = null;
            switch (o$2) {
              case r$2.TOLL_FREE:
                u = t$7.getTollFree();
                break;
              case r$2.STANDARD_RATE:
                u = t$7.getStandardRate();
                break;
              case r$2.PREMIUM_RATE:
                u = t$7.getPremiumRate();
            }
            return u && u.hasExampleNumber() && u.getExampleNumber() || ``;
          }, i18n$1.phonenumbers.ShortNumberInfo.prototype.connectsToEmergencyNumber = function(t$7, o$2) {
            return this.matchesEmergencyNumberHelper_(t$7, o$2, true);
          }, i18n$1.phonenumbers.ShortNumberInfo.prototype.isEmergencyNumber = function(t$7, o$2) {
            return this.matchesEmergencyNumberHelper_(t$7, o$2, false);
          }, i18n$1.phonenumbers.ShortNumberInfo.prototype.getMetadataForRegion_ = function(t$7) {
            if (!t$7) return null;
            t$7 = t$7.toUpperCase();
            var o$2 = this.regionToMetadataMap[t$7];
            if (o$2 == null) {
              o$2 = new goog.proto2.PbLiteSerializer();
              var r$2 = i18n$1.phonenumbers.shortnumbermetadata.countryToMetadata[t$7];
              if (r$2 == null) return null;
              o$2 = o$2.deserialize(i18n$1.phonenumbers.PhoneMetadata.getDescriptor(), r$2), this.regionToMetadataMap[t$7] = o$2;
            }
            return o$2;
          }, i18n$1.phonenumbers.ShortNumberInfo.prototype.matchesEmergencyNumberHelper_ = function(t$7, o$2, r$2) {
            var u = i18n$1.phonenumbers.PhoneNumberUtil.extractPossibleNumber(t$7);
            return i18n$1.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(u) || (t$7 = this.getMetadataForRegion_(o$2), t$7 == null || !t$7.hasEmergency()) ? false : (u = i18n$1.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(u), o$2 = r$2 && !i18n$1.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_.includes(o$2), r$2 = t$7.getEmergency().getNationalNumberPatternOrDefault(), i18n$1.phonenumbers.PhoneNumberUtil.matchesEntirely(r$2, u) || o$2 && i18n$1.phonenumbers.PhoneNumberUtil.matchesPrefix(r$2, u));
          }, i18n$1.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecific = function(t$7) {
            var o$2 = this.getRegionCodesForCountryCode_(t$7.getCountryCodeOrDefault());
            return o$2 = this.getRegionCodeForShortNumberFromRegionList_(t$7, o$2), t$7 = this.getNationalSignificantNumber_(t$7), o$2 = this.getMetadataForRegion_(o$2), !!o$2 && this.matchesPossibleNumberAndNationalNumber_(t$7, o$2.getCarrierSpecific());
          }, i18n$1.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecificForRegion = function(t$7, o$2) {
            return this.regionDialingFromMatchesNumber_(t$7, o$2) ? (t$7 = this.getNationalSignificantNumber_(t$7), o$2 = this.getMetadataForRegion_(o$2), !!o$2 && this.matchesPossibleNumberAndNationalNumber_(t$7, o$2.getCarrierSpecific())) : false;
          }, i18n$1.phonenumbers.ShortNumberInfo.prototype.isSmsServiceForRegion = function(t$7, o$2) {
            return this.regionDialingFromMatchesNumber_(t$7, o$2) ? (o$2 = this.getMetadataForRegion_(o$2), t$7 = this.getNationalSignificantNumber_(t$7), !!o$2 && this.matchesPossibleNumberAndNationalNumber_(t$7, o$2.getSmsServices())) : false;
          }, i18n$1.phonenumbers.ShortNumberInfo.prototype.getNationalSignificantNumber_ = function(t$7) {
            if (!t$7.hasNationalNumber()) return ``;
            var o$2 = `` + t$7.getNationalNumber();
            return t$7.hasItalianLeadingZero() && t$7.getItalianLeadingZero() && 0 < t$7.getNumberOfLeadingZerosOrDefault() ? Array(t$7.getNumberOfLeadingZerosOrDefault() + 1).join(`0`) + o$2 : o$2;
          }, i18n$1.phonenumbers.ShortNumberInfo.prototype.matchesPossibleNumberAndNationalNumber_ = function(t$7, o$2) {
            return 0 < o$2.possibleLengthArray().length && !o$2.possibleLengthArray().includes(t$7.length) ? false : i18n$1.phonenumbers.PhoneNumberUtil.matchesEntirely(o$2.getNationalNumberPatternOrDefault(), t$7.toString());
          }, i18n$1.phonenumbers.AsYouTypeFormatter = function(t$7) {
            this.DIGIT_PLACEHOLDER_ = ` `, this.DIGIT_PATTERN_ = new RegExp(this.DIGIT_PLACEHOLDER_), this.currentOutput_ = ``, this.formattingTemplate_ = new goog.string.StringBuffer(), this.currentFormattingPattern_ = ``, this.accruedInput_ = new goog.string.StringBuffer(), this.accruedInputWithoutFormatting_ = new goog.string.StringBuffer(), this.ableToFormat_ = true, this.isExpectingCountryCallingCode_ = this.isCompleteNumber_ = this.inputHasFormatting_ = false, this.phoneUtil_ = i18n$1.phonenumbers.PhoneNumberUtil.getInstance(), this.positionToRemember_ = this.originalPosition_ = this.lastMatchPosition_ = 0, this.prefixBeforeNationalNumber_ = new goog.string.StringBuffer(), this.shouldAddSpaceAfterNationalPrefix_ = false, this.extractedNationalPrefix_ = ``, this.nationalNumber_ = new goog.string.StringBuffer(), this.possibleFormats_ = [], this.defaultCountry_ = t$7, this.defaultMetadata_ = this.currentMetadata_ = this.getMetadataForRegion_(this.defaultCountry_);
          }, i18n$1.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ = ` `, i18n$1.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_ = new i18n$1.phonenumbers.PhoneMetadata(), i18n$1.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_.setInternationalPrefix(`NA`), i18n$1.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_ = RegExp(`^[` + i18n$1.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + `]*\\$1[` + i18n$1.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + `]*(\\$\\d[` + i18n$1.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + `]*)*$`), i18n$1.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_ = /[- ]/, i18n$1.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_ = 3, i18n$1.phonenumbers.AsYouTypeFormatter.prototype.getMetadataForRegion_ = function(t$7) {
            return t$7 = this.phoneUtil_.getCountryCodeForRegion(t$7), t$7 = this.phoneUtil_.getRegionCodeForCountryCode(t$7), t$7 = this.phoneUtil_.getMetadataForRegion(t$7), t$7 ?? i18n$1.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_;
          }, i18n$1.phonenumbers.AsYouTypeFormatter.prototype.maybeCreateNewTemplate_ = function() {
            for (var t$7 = this.possibleFormats_.length, o$2 = 0; o$2 < t$7; ++o$2) {
              var r$2 = this.possibleFormats_[o$2], u = r$2.getPatternOrDefault();
              if (this.currentFormattingPattern_ == u) return false;
              if (this.createFormattingTemplate_(r$2)) return this.currentFormattingPattern_ = u, this.shouldAddSpaceAfterNationalPrefix_ = i18n$1.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(r$2.getNationalPrefixFormattingRule()), this.lastMatchPosition_ = 0, true;
            }
            return this.ableToFormat_ = false;
          }, i18n$1.phonenumbers.AsYouTypeFormatter.prototype.getAvailableFormats_ = function(t$7) {
            for (var o$2 = this.isCompleteNumber_ && this.extractedNationalPrefix_.length == 0 && 0 < this.currentMetadata_.intlNumberFormatCount() ? this.currentMetadata_.intlNumberFormatArray() : this.currentMetadata_.numberFormatArray(), r$2 = o$2.length, u = 0; u < r$2; ++u) {
              var h$1 = o$2[u];
              0 < this.extractedNationalPrefix_.length && this.phoneUtil_.formattingRuleHasFirstGroupOnly(h$1.getNationalPrefixFormattingRuleOrDefault()) && !h$1.getNationalPrefixOptionalWhenFormatting() && !h$1.hasDomesticCarrierCodeFormattingRule() || (this.extractedNationalPrefix_.length != 0 || this.isCompleteNumber_ || this.phoneUtil_.formattingRuleHasFirstGroupOnly(h$1.getNationalPrefixFormattingRuleOrDefault()) || h$1.getNationalPrefixOptionalWhenFormatting()) && i18n$1.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_.test(h$1.getFormatOrDefault()) && this.possibleFormats_.push(h$1);
            }
            this.narrowDownPossibleFormats_(t$7);
          }, i18n$1.phonenumbers.AsYouTypeFormatter.prototype.narrowDownPossibleFormats_ = function(t$7) {
            for (var o$2 = [], r$2 = t$7.length - i18n$1.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_, u = this.possibleFormats_.length, h$1 = 0; h$1 < u; ++h$1) {
              var m$3 = this.possibleFormats_[h$1];
              if (m$3.leadingDigitsPatternCount() == 0) o$2.push(this.possibleFormats_[h$1]);
              else {
                var y$1 = Math.min(r$2, m$3.leadingDigitsPatternCount() - 1);
                m$3 = m$3.getLeadingDigitsPattern(y$1), t$7.search(m$3) == 0 && o$2.push(this.possibleFormats_[h$1]);
              }
            }
            this.possibleFormats_ = o$2;
          }, i18n$1.phonenumbers.AsYouTypeFormatter.prototype.createFormattingTemplate_ = function(t$7) {
            var o$2 = t$7.getPatternOrDefault();
            return this.formattingTemplate_.clear(), t$7 = this.getFormattingTemplate_(o$2, t$7.getFormatOrDefault()), 0 < t$7.length ? (this.formattingTemplate_.append(t$7), true) : false;
          }, i18n$1.phonenumbers.AsYouTypeFormatter.prototype.getFormattingTemplate_ = function(t$7, o$2) {
            var r$2 = `999999999999999`.match(t$7)[0];
            return r$2.length < this.nationalNumber_.getLength() ? `` : (t$7 = r$2.replace(new RegExp(t$7, `g`), o$2), t$7 = t$7.replace(/9/g, this.DIGIT_PLACEHOLDER_));
          }, i18n$1.phonenumbers.AsYouTypeFormatter.prototype.clear = function() {
            this.currentOutput_ = ``, this.accruedInput_.clear(), this.accruedInputWithoutFormatting_.clear(), this.formattingTemplate_.clear(), this.lastMatchPosition_ = 0, this.currentFormattingPattern_ = ``, this.prefixBeforeNationalNumber_.clear(), this.extractedNationalPrefix_ = ``, this.nationalNumber_.clear(), this.ableToFormat_ = true, this.inputHasFormatting_ = false, this.originalPosition_ = this.positionToRemember_ = 0, this.isExpectingCountryCallingCode_ = this.isCompleteNumber_ = false, this.possibleFormats_ = [], this.shouldAddSpaceAfterNationalPrefix_ = false, this.currentMetadata_ != this.defaultMetadata_ && (this.currentMetadata_ = this.getMetadataForRegion_(this.defaultCountry_));
          }, i18n$1.phonenumbers.AsYouTypeFormatter.prototype.inputDigit = function(t$7) {
            return this.currentOutput_ = this.inputDigitWithOptionToRememberPosition_(t$7, false);
          }, i18n$1.phonenumbers.AsYouTypeFormatter.prototype.inputDigitAndRememberPosition = function(t$7) {
            return this.currentOutput_ = this.inputDigitWithOptionToRememberPosition_(t$7, true);
          }, i18n$1.phonenumbers.AsYouTypeFormatter.prototype.inputDigitWithOptionToRememberPosition_ = function(t$7, o$2) {
            if (this.accruedInput_.append(t$7), o$2 && (this.originalPosition_ = this.accruedInput_.getLength()), this.isDigitOrLeadingPlusSign_(t$7) ? t$7 = this.normalizeAndAccrueDigitsAndPlusSign_(t$7, o$2) : (this.ableToFormat_ = false, this.inputHasFormatting_ = true), !this.ableToFormat_) {
              if (!this.inputHasFormatting_) {
                if (this.attemptToExtractIdd_()) {
                  if (this.attemptToExtractCountryCallingCode_()) return this.attemptToChoosePatternWithPrefixExtracted_();
                } else if (this.ableToExtractLongerNdd_()) return this.prefixBeforeNationalNumber_.append(i18n$1.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.attemptToChoosePatternWithPrefixExtracted_();
              }
              return this.accruedInput_.toString();
            }
            switch (this.accruedInputWithoutFormatting_.getLength()) {
              case 0:
              case 1:
              case 2:
                return this.accruedInput_.toString();
              case 3:
                if (this.attemptToExtractIdd_()) this.isExpectingCountryCallingCode_ = true;
                else return this.extractedNationalPrefix_ = this.removeNationalPrefixFromNationalNumber_(), this.attemptToChooseFormattingPattern_();
              default:
                return this.isExpectingCountryCallingCode_ ? (this.attemptToExtractCountryCallingCode_() && (this.isExpectingCountryCallingCode_ = false), this.prefixBeforeNationalNumber_.toString() + this.nationalNumber_.toString()) : 0 < this.possibleFormats_.length ? (t$7 = this.inputDigitHelper_(t$7), o$2 = this.attemptToFormatAccruedDigits_(), 0 < o$2.length ? o$2 : (this.narrowDownPossibleFormats_(this.nationalNumber_.toString()), this.maybeCreateNewTemplate_() ? this.inputAccruedNationalNumber_() : this.ableToFormat_ ? this.appendNationalNumber_(t$7) : this.accruedInput_.toString())) : this.attemptToChooseFormattingPattern_();
            }
          }, i18n$1.phonenumbers.AsYouTypeFormatter.prototype.attemptToChoosePatternWithPrefixExtracted_ = function() {
            return this.ableToFormat_ = true, this.isExpectingCountryCallingCode_ = false, this.possibleFormats_ = [], this.lastMatchPosition_ = 0, this.formattingTemplate_.clear(), this.currentFormattingPattern_ = ``, this.attemptToChooseFormattingPattern_();
          }, i18n$1.phonenumbers.AsYouTypeFormatter.prototype.getExtractedNationalPrefix_ = function() {
            return this.extractedNationalPrefix_;
          }, i18n$1.phonenumbers.AsYouTypeFormatter.prototype.ableToExtractLongerNdd_ = function() {
            if (0 < this.extractedNationalPrefix_.length) {
              var t$7 = this.nationalNumber_.toString();
              this.nationalNumber_.clear(), this.nationalNumber_.append(this.extractedNationalPrefix_), this.nationalNumber_.append(t$7), t$7 = this.prefixBeforeNationalNumber_.toString();
              var o$2 = t$7.lastIndexOf(this.extractedNationalPrefix_);
              this.prefixBeforeNationalNumber_.clear(), this.prefixBeforeNationalNumber_.append(t$7.substring(0, o$2));
            }
            return this.extractedNationalPrefix_ != this.removeNationalPrefixFromNationalNumber_();
          }, i18n$1.phonenumbers.AsYouTypeFormatter.prototype.isDigitOrLeadingPlusSign_ = function(t$7) {
            return i18n$1.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN.test(t$7) || this.accruedInput_.getLength() == 1 && i18n$1.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN.test(t$7);
          }, i18n$1.phonenumbers.AsYouTypeFormatter.prototype.attemptToFormatAccruedDigits_ = function() {
            for (var t$7 = this.nationalNumber_.toString(), o$2 = this.possibleFormats_.length, r$2 = 0; r$2 < o$2; ++r$2) {
              var u = this.possibleFormats_[r$2], h$1 = u.getPatternOrDefault();
              if (RegExp(`^(?:` + h$1 + `)$`).test(t$7) && (this.shouldAddSpaceAfterNationalPrefix_ = i18n$1.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(u.getNationalPrefixFormattingRule()), u = t$7.replace(new RegExp(h$1, `g`), u.getFormat()), u = this.appendNationalNumber_(u), i18n$1.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(u) == this.accruedInputWithoutFormatting_)) return u;
            }
            return ``;
          }, i18n$1.phonenumbers.AsYouTypeFormatter.prototype.appendNationalNumber_ = function(t$7) {
            var o$2 = this.prefixBeforeNationalNumber_.getLength();
            return this.shouldAddSpaceAfterNationalPrefix_ && 0 < o$2 && this.prefixBeforeNationalNumber_.toString().charAt(o$2 - 1) != i18n$1.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ ? this.prefixBeforeNationalNumber_ + i18n$1.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ + t$7 : this.prefixBeforeNationalNumber_ + t$7;
          }, i18n$1.phonenumbers.AsYouTypeFormatter.prototype.getRememberedPosition = function() {
            if (!this.ableToFormat_) return this.originalPosition_;
            for (var t$7 = 0, o$2 = 0, r$2 = this.accruedInputWithoutFormatting_.toString(), u = this.currentOutput_.toString(); t$7 < this.positionToRemember_ && o$2 < u.length; ) r$2.charAt(t$7) == u.charAt(o$2) && t$7++, o$2++;
            return o$2;
          }, i18n$1.phonenumbers.AsYouTypeFormatter.prototype.attemptToChooseFormattingPattern_ = function() {
            var t$7 = this.nationalNumber_.toString();
            return t$7.length >= i18n$1.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_ ? (this.getAvailableFormats_(t$7), t$7 = this.attemptToFormatAccruedDigits_(), 0 < t$7.length ? t$7 : this.maybeCreateNewTemplate_() ? this.inputAccruedNationalNumber_() : this.accruedInput_.toString()) : this.appendNationalNumber_(t$7);
          }, i18n$1.phonenumbers.AsYouTypeFormatter.prototype.inputAccruedNationalNumber_ = function() {
            var t$7 = this.nationalNumber_.toString(), o$2 = t$7.length;
            if (0 < o$2) {
              for (var r$2 = ``, u = 0; u < o$2; u++) r$2 = this.inputDigitHelper_(t$7.charAt(u));
              return this.ableToFormat_ ? this.appendNationalNumber_(r$2) : this.accruedInput_.toString();
            }
            return this.prefixBeforeNationalNumber_.toString();
          }, i18n$1.phonenumbers.AsYouTypeFormatter.prototype.isNanpaNumberWithNationalPrefix_ = function() {
            if (this.currentMetadata_.getCountryCode() != 1) return false;
            var t$7 = this.nationalNumber_.toString();
            return t$7.charAt(0) == `1` && t$7.charAt(1) != `0` && t$7.charAt(1) != `1`;
          }, i18n$1.phonenumbers.AsYouTypeFormatter.prototype.removeNationalPrefixFromNationalNumber_ = function() {
            var t$7 = this.nationalNumber_.toString(), o$2 = 0;
            if (this.isNanpaNumberWithNationalPrefix_()) o$2 = 1, this.prefixBeforeNationalNumber_.append(`1`).append(i18n$1.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.isCompleteNumber_ = true;
            else if (this.currentMetadata_.hasNationalPrefixForParsing()) {
              var r$2 = RegExp(`^(?:` + this.currentMetadata_.getNationalPrefixForParsing() + `)`);
              r$2 = t$7.match(r$2), r$2 != null && r$2[0] != null && 0 < r$2[0].length && (this.isCompleteNumber_ = true, o$2 = r$2[0].length, this.prefixBeforeNationalNumber_.append(t$7.substring(0, o$2)));
            }
            return this.nationalNumber_.clear(), this.nationalNumber_.append(t$7.substring(o$2)), t$7.substring(0, o$2);
          }, i18n$1.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractIdd_ = function() {
            var t$7 = this.accruedInputWithoutFormatting_.toString(), o$2 = RegExp(`^(?:\\` + i18n$1.phonenumbers.PhoneNumberUtil.PLUS_SIGN + `|` + this.currentMetadata_.getInternationalPrefix() + `)`);
            return o$2 = t$7.match(o$2), o$2 != null && o$2[0] != null && 0 < o$2[0].length ? (this.isCompleteNumber_ = true, o$2 = o$2[0].length, this.nationalNumber_.clear(), this.nationalNumber_.append(t$7.substring(o$2)), this.prefixBeforeNationalNumber_.clear(), this.prefixBeforeNationalNumber_.append(t$7.substring(0, o$2)), t$7.charAt(0) != i18n$1.phonenumbers.PhoneNumberUtil.PLUS_SIGN && this.prefixBeforeNationalNumber_.append(i18n$1.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), true) : false;
          }, i18n$1.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractCountryCallingCode_ = function() {
            if (this.nationalNumber_.getLength() == 0) return false;
            var t$7 = new goog.string.StringBuffer(), o$2 = this.phoneUtil_.extractCountryCode(this.nationalNumber_, t$7);
            return o$2 == 0 ? false : (this.nationalNumber_.clear(), this.nationalNumber_.append(t$7.toString()), t$7 = this.phoneUtil_.getRegionCodeForCountryCode(o$2), i18n$1.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY == t$7 ? this.currentMetadata_ = this.phoneUtil_.getMetadataForNonGeographicalRegion(o$2) : t$7 != this.defaultCountry_ && (this.currentMetadata_ = this.getMetadataForRegion_(t$7)), this.prefixBeforeNationalNumber_.append(`` + o$2).append(i18n$1.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.extractedNationalPrefix_ = ``, true);
          }, i18n$1.phonenumbers.AsYouTypeFormatter.prototype.normalizeAndAccrueDigitsAndPlusSign_ = function(t$7, o$2) {
            if (t$7 == i18n$1.phonenumbers.PhoneNumberUtil.PLUS_SIGN) {
              var r$2 = t$7;
              this.accruedInputWithoutFormatting_.append(t$7);
            } else r$2 = i18n$1.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS[t$7], this.accruedInputWithoutFormatting_.append(r$2), this.nationalNumber_.append(r$2);
            return o$2 && (this.positionToRemember_ = this.accruedInputWithoutFormatting_.getLength()), r$2;
          }, i18n$1.phonenumbers.AsYouTypeFormatter.prototype.inputDigitHelper_ = function(t$7) {
            var o$2 = this.formattingTemplate_.toString();
            if (0 <= o$2.substring(this.lastMatchPosition_).search(this.DIGIT_PATTERN_)) {
              var r$2 = o$2.search(this.DIGIT_PATTERN_);
              return t$7 = o$2.replace(this.DIGIT_PATTERN_, t$7), this.formattingTemplate_.clear(), this.formattingTemplate_.append(t$7), this.lastMatchPosition_ = r$2, t$7.substring(0, this.lastMatchPosition_ + 1);
            }
            return this.possibleFormats_.length == 1 && (this.ableToFormat_ = false), this.currentFormattingPattern_ = ``, this.accruedInput_.toString();
          }, Object.defineProperty(exports$2, `__esModule`, { value: true }), exports$2.default = i18n$1.phonenumbers, module$2.exports = exports$2.default;
        }).call(this);
      }).call(this, typeof commonjsGlobal < `u` ? commonjsGlobal : typeof self < `u` ? self : typeof window < `u` ? window : {});
    }, {}] }, {}, [1])(1);
  });
})(libphonenumber, libphonenumber.exports);
var libphonenumberExports = libphonenumber.exports, buffer = {}, base64Js = {};
base64Js.byteLength = byteLength, base64Js.toByteArray = toByteArray, base64Js.fromByteArray = fromByteArray;
for (var lookup = [], revLookup = [], Arr = typeof Uint8Array < `u` ? Uint8Array : Array, code = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/`, i$2 = 0, len = code.length; i$2 < len; ++i$2) lookup[i$2] = code[i$2], revLookup[code.charCodeAt(i$2)] = i$2;
revLookup[45] = 62, revLookup[95] = 63;
function getLens(t$7) {
  var o$2 = t$7.length;
  if (o$2 % 4 > 0) throw Error(`Invalid string. Length must be a multiple of 4`);
  var r$2 = t$7.indexOf(`=`);
  r$2 === -1 && (r$2 = o$2);
  var u = r$2 === o$2 ? 0 : 4 - r$2 % 4;
  return [r$2, u];
}
function byteLength(t$7) {
  var o$2 = getLens(t$7), r$2 = o$2[0], u = o$2[1];
  return (r$2 + u) * 3 / 4 - u;
}
function _byteLength(t$7, o$2, r$2) {
  return (o$2 + r$2) * 3 / 4 - r$2;
}
function toByteArray(t$7) {
  var o$2, r$2 = getLens(t$7), u = r$2[0], h$1 = r$2[1], m$3 = new Arr(_byteLength(t$7, u, h$1)), y$1 = 0, S = h$1 > 0 ? u - 4 : u, _;
  for (_ = 0; _ < S; _ += 4) o$2 = revLookup[t$7.charCodeAt(_)] << 18 | revLookup[t$7.charCodeAt(_ + 1)] << 12 | revLookup[t$7.charCodeAt(_ + 2)] << 6 | revLookup[t$7.charCodeAt(_ + 3)], m$3[y$1++] = o$2 >> 16 & 255, m$3[y$1++] = o$2 >> 8 & 255, m$3[y$1++] = o$2 & 255;
  return h$1 === 2 && (o$2 = revLookup[t$7.charCodeAt(_)] << 2 | revLookup[t$7.charCodeAt(_ + 1)] >> 4, m$3[y$1++] = o$2 & 255), h$1 === 1 && (o$2 = revLookup[t$7.charCodeAt(_)] << 10 | revLookup[t$7.charCodeAt(_ + 1)] << 4 | revLookup[t$7.charCodeAt(_ + 2)] >> 2, m$3[y$1++] = o$2 >> 8 & 255, m$3[y$1++] = o$2 & 255), m$3;
}
function tripletToBase64(t$7) {
  return lookup[t$7 >> 18 & 63] + lookup[t$7 >> 12 & 63] + lookup[t$7 >> 6 & 63] + lookup[t$7 & 63];
}
function encodeChunk(t$7, o$2, r$2) {
  for (var u, h$1 = [], m$3 = o$2; m$3 < r$2; m$3 += 3) u = (t$7[m$3] << 16 & 16711680) + (t$7[m$3 + 1] << 8 & 65280) + (t$7[m$3 + 2] & 255), h$1.push(tripletToBase64(u));
  return h$1.join(``);
}
function fromByteArray(t$7) {
  for (var o$2, r$2 = t$7.length, u = r$2 % 3, h$1 = [], m$3 = 16383, y$1 = 0, S = r$2 - u; y$1 < S; y$1 += m$3) h$1.push(encodeChunk(t$7, y$1, y$1 + m$3 > S ? S : y$1 + m$3));
  return u === 1 ? (o$2 = t$7[r$2 - 1], h$1.push(lookup[o$2 >> 2] + lookup[o$2 << 4 & 63] + `==`)) : u === 2 && (o$2 = (t$7[r$2 - 2] << 8) + t$7[r$2 - 1], h$1.push(lookup[o$2 >> 10] + lookup[o$2 >> 4 & 63] + lookup[o$2 << 2 & 63] + `=`)), h$1.join(``);
}
var ieee754 = {};
ieee754.read = function(t$7, o$2, r$2, u, h$1) {
  var m$3, y$1, S = h$1 * 8 - u - 1, _ = (1 << S) - 1, C = _ >> 1, O = -7, I = r$2 ? h$1 - 1 : 0, R$2 = r$2 ? -1 : 1, U = t$7[o$2 + I];
  for (I += R$2, m$3 = U & (1 << -O) - 1, U >>= -O, O += S; O > 0; m$3 = m$3 * 256 + t$7[o$2 + I], I += R$2, O -= 8) ;
  for (y$1 = m$3 & (1 << -O) - 1, m$3 >>= -O, O += u; O > 0; y$1 = y$1 * 256 + t$7[o$2 + I], I += R$2, O -= 8) ;
  if (m$3 === 0) m$3 = 1 - C;
  else {
    if (m$3 === _) return y$1 ? NaN : (U ? -1 : 1) * (1 / 0);
    y$1 += 2 ** u, m$3 -= C;
  }
  return (U ? -1 : 1) * y$1 * 2 ** (m$3 - u);
}, ieee754.write = function(t$7, o$2, r$2, u, h$1, m$3) {
  var y$1, S, _, C = m$3 * 8 - h$1 - 1, O = (1 << C) - 1, I = O >> 1, R$2 = h$1 === 23 ? 2 ** -24 - 2 ** -77 : 0, U = u ? 0 : m$3 - 1, F = u ? 1 : -1, G = o$2 < 0 || o$2 === 0 && 1 / o$2 < 0 ? 1 : 0;
  for (o$2 = Math.abs(o$2), isNaN(o$2) || o$2 === 1 / 0 ? (S = isNaN(o$2) ? 1 : 0, y$1 = O) : (y$1 = Math.floor(Math.log(o$2) / Math.LN2), o$2 * (_ = 2 ** -y$1) < 1 && (y$1--, _ *= 2), y$1 + I >= 1 ? o$2 += R$2 / _ : o$2 += R$2 * 2 ** (1 - I), o$2 * _ >= 2 && (y$1++, _ /= 2), y$1 + I >= O ? (S = 0, y$1 = O) : y$1 + I >= 1 ? (S = (o$2 * _ - 1) * 2 ** h$1, y$1 += I) : (S = o$2 * 2 ** (I - 1) * 2 ** h$1, y$1 = 0)); h$1 >= 8; t$7[r$2 + U] = S & 255, U += F, S /= 256, h$1 -= 8) ;
  for (y$1 = y$1 << h$1 | S, C += h$1; C > 0; t$7[r$2 + U] = y$1 & 255, U += F, y$1 /= 256, C -= 8) ;
  t$7[r$2 + U - F] |= G * 128;
}, (function(t$7) {
  let o$2 = base64Js, r$2 = ieee754, u = typeof Symbol == `function` && typeof Symbol.for == `function` ? Symbol.for(`nodejs.util.inspect.custom`) : null;
  t$7.Buffer = S, t$7.SlowBuffer = te$1, t$7.INSPECT_MAX_BYTES = 50;
  let h$1 = 2147483647;
  t$7.kMaxLength = h$1, S.TYPED_ARRAY_SUPPORT = m$3(), !S.TYPED_ARRAY_SUPPORT && typeof console < `u` && typeof console.error == `function` && console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
  function m$3() {
    try {
      let N = new Uint8Array(1), p$1 = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(p$1, Uint8Array.prototype), Object.setPrototypeOf(N, p$1), N.foo() === 42;
    } catch {
      return false;
    }
  }
  Object.defineProperty(S.prototype, `parent`, { enumerable: true, get: function() {
    if (S.isBuffer(this)) return this.buffer;
  } }), Object.defineProperty(S.prototype, `offset`, { enumerable: true, get: function() {
    if (S.isBuffer(this)) return this.byteOffset;
  } });
  function y$1(N) {
    if (N > h$1) throw RangeError(`The value "` + N + `" is invalid for option "size"`);
    let p$1 = new Uint8Array(N);
    return Object.setPrototypeOf(p$1, S.prototype), p$1;
  }
  function S(N, p$1, $) {
    if (typeof N == `number`) {
      if (typeof p$1 == `string`) throw TypeError(`The "string" argument must be of type string. Received type number`);
      return I(N);
    }
    return _(N, p$1, $);
  }
  S.poolSize = 8192;
  function _(N, p$1, $) {
    if (typeof N == `string`) return R$2(N, p$1);
    if (ArrayBuffer.isView(N)) return F(N);
    if (N == null) throw TypeError(`The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ` + typeof N);
    if (J(N, ArrayBuffer) || N && J(N.buffer, ArrayBuffer) || typeof SharedArrayBuffer < `u` && (J(N, SharedArrayBuffer) || N && J(N.buffer, SharedArrayBuffer))) return G(N, p$1, $);
    if (typeof N == `number`) throw TypeError(`The "value" argument must not be of type number. Received type number`);
    let T = N.valueOf && N.valueOf();
    if (T != null && T !== N) return S.from(T, p$1, $);
    let E = Y(N);
    if (E) return E;
    if (typeof Symbol < `u` && Symbol.toPrimitive != null && typeof N[Symbol.toPrimitive] == `function`) return S.from(N[Symbol.toPrimitive](`string`), p$1, $);
    throw TypeError(`The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ` + typeof N);
  }
  S.from = function(N, p$1, $) {
    return _(N, p$1, $);
  }, Object.setPrototypeOf(S.prototype, Uint8Array.prototype), Object.setPrototypeOf(S, Uint8Array);
  function C(N) {
    if (typeof N != `number`) throw TypeError(`"size" argument must be of type number`);
    if (N < 0) throw RangeError(`The value "` + N + `" is invalid for option "size"`);
  }
  function O(N, p$1, $) {
    return C(N), N <= 0 || p$1 === void 0 ? y$1(N) : typeof $ == `string` ? y$1(N).fill(p$1, $) : y$1(N).fill(p$1);
  }
  S.alloc = function(N, p$1, $) {
    return O(N, p$1, $);
  };
  function I(N) {
    return C(N), y$1(N < 0 ? 0 : K$1(N) | 0);
  }
  S.allocUnsafe = function(N) {
    return I(N);
  }, S.allocUnsafeSlow = function(N) {
    return I(N);
  };
  function R$2(N, p$1) {
    if ((typeof p$1 != `string` || p$1 === ``) && (p$1 = `utf8`), !S.isEncoding(p$1)) throw TypeError(`Unknown encoding: ` + p$1);
    let $ = de(N, p$1) | 0, T = y$1($), E = T.write(N, p$1);
    return E !== $ && (T = T.slice(0, E)), T;
  }
  function U(N) {
    let p$1 = N.length < 0 ? 0 : K$1(N.length) | 0, $ = y$1(p$1);
    for (let T = 0; T < p$1; T += 1) $[T] = N[T] & 255;
    return $;
  }
  function F(N) {
    if (J(N, Uint8Array)) {
      let p$1 = new Uint8Array(N);
      return G(p$1.buffer, p$1.byteOffset, p$1.byteLength);
    }
    return U(N);
  }
  function G(N, p$1, $) {
    if (p$1 < 0 || N.byteLength < p$1) throw RangeError(`"offset" is outside of buffer bounds`);
    if (N.byteLength < p$1 + ($ || 0)) throw RangeError(`"length" is outside of buffer bounds`);
    let T;
    return T = p$1 === void 0 && $ === void 0 ? new Uint8Array(N) : $ === void 0 ? new Uint8Array(N, p$1) : new Uint8Array(N, p$1, $), Object.setPrototypeOf(T, S.prototype), T;
  }
  function Y(N) {
    if (S.isBuffer(N)) {
      let p$1 = K$1(N.length) | 0, $ = y$1(p$1);
      return $.length === 0 || N.copy($, 0, 0, p$1), $;
    }
    if (N.length !== void 0) return typeof N.length != `number` || Se(N.length) ? y$1(0) : U(N);
    if (N.type === `Buffer` && Array.isArray(N.data)) return U(N.data);
  }
  function K$1(N) {
    if (N >= h$1) throw RangeError(`Attempt to allocate Buffer larger than maximum size: 0x` + h$1.toString(16) + ` bytes`);
    return N | 0;
  }
  function te$1(N) {
    return +N != N && (N = 0), S.alloc(+N);
  }
  S.isBuffer = function(p$1) {
    return p$1 != null && p$1._isBuffer === true && p$1 !== S.prototype;
  }, S.compare = function(p$1, $) {
    if (J(p$1, Uint8Array) && (p$1 = S.from(p$1, p$1.offset, p$1.byteLength)), J($, Uint8Array) && ($ = S.from($, $.offset, $.byteLength)), !S.isBuffer(p$1) || !S.isBuffer($)) throw TypeError(`The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array`);
    if (p$1 === $) return 0;
    let T = p$1.length, E = $.length;
    for (let A = 0, P$1 = Math.min(T, E); A < P$1; ++A) if (p$1[A] !== $[A]) {
      T = p$1[A], E = $[A];
      break;
    }
    return T < E ? -1 : E < T ? 1 : 0;
  }, S.isEncoding = function(p$1) {
    switch (String(p$1).toLowerCase()) {
      case `hex`:
      case `utf8`:
      case `utf-8`:
      case `ascii`:
      case `latin1`:
      case `binary`:
      case `base64`:
      case `ucs2`:
      case `ucs-2`:
      case `utf16le`:
      case `utf-16le`:
        return true;
      default:
        return false;
    }
  }, S.concat = function(p$1, $) {
    if (!Array.isArray(p$1)) throw TypeError(`"list" argument must be an Array of Buffers`);
    if (p$1.length === 0) return S.alloc(0);
    let T;
    if ($ === void 0) for ($ = 0, T = 0; T < p$1.length; ++T) $ += p$1[T].length;
    let E = S.allocUnsafe($), A = 0;
    for (T = 0; T < p$1.length; ++T) {
      let P$1 = p$1[T];
      if (J(P$1, Uint8Array)) A + P$1.length > E.length ? (S.isBuffer(P$1) || (P$1 = S.from(P$1)), P$1.copy(E, A)) : Uint8Array.prototype.set.call(E, P$1, A);
      else if (S.isBuffer(P$1)) P$1.copy(E, A);
      else throw TypeError(`"list" argument must be an Array of Buffers`);
      A += P$1.length;
    }
    return E;
  };
  function de(N, p$1) {
    if (S.isBuffer(N)) return N.length;
    if (ArrayBuffer.isView(N) || J(N, ArrayBuffer)) return N.byteLength;
    if (typeof N != `string`) throw TypeError(`The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ` + typeof N);
    let $ = N.length, T = arguments.length > 2 && arguments[2] === true;
    if (!T && $ === 0) return 0;
    let E = false;
    for (; ; ) switch (p$1) {
      case `ascii`:
      case `latin1`:
      case `binary`:
        return $;
      case `utf8`:
      case `utf-8`:
        return ye(N).length;
      case `ucs2`:
      case `ucs-2`:
      case `utf16le`:
      case `utf-16le`:
        return $ * 2;
      case `hex`:
        return $ >>> 1;
      case `base64`:
        return Me(N).length;
      default:
        if (E) return T ? -1 : ye(N).length;
        p$1 = (`` + p$1).toLowerCase(), E = true;
    }
  }
  S.byteLength = de;
  function me(N, p$1, $) {
    let T = false;
    if ((p$1 === void 0 || p$1 < 0) && (p$1 = 0), p$1 > this.length || (($ === void 0 || $ > this.length) && ($ = this.length), $ <= 0) || ($ >>>= 0, p$1 >>>= 0, $ <= p$1)) return ``;
    for (N ||= `utf8`; ; ) switch (N) {
      case `hex`:
        return He(this, p$1, $);
      case `utf8`:
      case `utf-8`:
        return _e(this, p$1, $);
      case `ascii`:
        return Ge(this, p$1, $);
      case `latin1`:
      case `binary`:
        return ke(this, p$1, $);
      case `base64`:
        return Be(this, p$1, $);
      case `ucs2`:
      case `ucs-2`:
      case `utf16le`:
      case `utf-16le`:
        return We(this, p$1, $);
      default:
        if (T) throw TypeError(`Unknown encoding: ` + N);
        N = (N + ``).toLowerCase(), T = true;
    }
  }
  S.prototype._isBuffer = true;
  function q(N, p$1, $) {
    let T = N[p$1];
    N[p$1] = N[$], N[$] = T;
  }
  S.prototype.swap16 = function() {
    let p$1 = this.length;
    if (p$1 % 2 != 0) throw RangeError(`Buffer size must be a multiple of 16-bits`);
    for (let $ = 0; $ < p$1; $ += 2) q(this, $, $ + 1);
    return this;
  }, S.prototype.swap32 = function() {
    let p$1 = this.length;
    if (p$1 % 4 != 0) throw RangeError(`Buffer size must be a multiple of 32-bits`);
    for (let $ = 0; $ < p$1; $ += 4) q(this, $, $ + 3), q(this, $ + 1, $ + 2);
    return this;
  }, S.prototype.swap64 = function() {
    let p$1 = this.length;
    if (p$1 % 8 != 0) throw RangeError(`Buffer size must be a multiple of 64-bits`);
    for (let $ = 0; $ < p$1; $ += 8) q(this, $, $ + 7), q(this, $ + 1, $ + 6), q(this, $ + 2, $ + 5), q(this, $ + 3, $ + 4);
    return this;
  }, S.prototype.toString = function() {
    let p$1 = this.length;
    return p$1 === 0 ? `` : arguments.length === 0 ? _e(this, 0, p$1) : me.apply(this, arguments);
  }, S.prototype.toLocaleString = S.prototype.toString, S.prototype.equals = function(p$1) {
    if (!S.isBuffer(p$1)) throw TypeError(`Argument must be a Buffer`);
    return this === p$1 ? true : S.compare(this, p$1) === 0;
  }, S.prototype.inspect = function() {
    let p$1 = ``, $ = t$7.INSPECT_MAX_BYTES;
    return p$1 = this.toString(`hex`, 0, $).replace(/(.{2})/g, `$1 `).trim(), this.length > $ && (p$1 += ` ... `), `<Buffer ` + p$1 + `>`;
  }, u && (S.prototype[u] = S.prototype.inspect), S.prototype.compare = function(p$1, $, T, E, A) {
    if (J(p$1, Uint8Array) && (p$1 = S.from(p$1, p$1.offset, p$1.byteLength)), !S.isBuffer(p$1)) throw TypeError(`The "target" argument must be one of type Buffer or Uint8Array. Received type ` + typeof p$1);
    if ($ === void 0 && ($ = 0), T === void 0 && (T = p$1 ? p$1.length : 0), E === void 0 && (E = 0), A === void 0 && (A = this.length), $ < 0 || T > p$1.length || E < 0 || A > this.length) throw RangeError(`out of range index`);
    if (E >= A && $ >= T) return 0;
    if (E >= A) return -1;
    if ($ >= T) return 1;
    if ($ >>>= 0, T >>>= 0, E >>>= 0, A >>>= 0, this === p$1) return 0;
    let P$1 = A - E, D = T - $, v$1 = Math.min(P$1, D), w$1 = this.slice(E, A), x$1 = p$1.slice($, T);
    for (let L = 0; L < v$1; ++L) if (w$1[L] !== x$1[L]) {
      P$1 = w$1[L], D = x$1[L];
      break;
    }
    return P$1 < D ? -1 : D < P$1 ? 1 : 0;
  };
  function ge(N, p$1, $, T, E) {
    if (N.length === 0) return -1;
    if (typeof $ == `string` ? (T = $, $ = 0) : $ > 2147483647 ? $ = 2147483647 : $ < -2147483648 && ($ = -2147483648), $ = +$, Se($) && ($ = E ? 0 : N.length - 1), $ < 0 && ($ = N.length + $), $ >= N.length) {
      if (E) return -1;
      $ = N.length - 1;
    } else if ($ < 0) if (E) $ = 0;
    else return -1;
    if (typeof p$1 == `string` && (p$1 = S.from(p$1, T)), S.isBuffer(p$1)) return p$1.length === 0 ? -1 : ce(N, p$1, $, T, E);
    if (typeof p$1 == `number`) return p$1 &= 255, typeof Uint8Array.prototype.indexOf == `function` ? E ? Uint8Array.prototype.indexOf.call(N, p$1, $) : Uint8Array.prototype.lastIndexOf.call(N, p$1, $) : ce(N, [p$1], $, T, E);
    throw TypeError(`val must be string, number or Buffer`);
  }
  function ce(N, p$1, $, T, E) {
    let A = 1, P$1 = N.length, D = p$1.length;
    if (T !== void 0 && (T = String(T).toLowerCase(), T === `ucs2` || T === `ucs-2` || T === `utf16le` || T === `utf-16le`)) {
      if (N.length < 2 || p$1.length < 2) return -1;
      A = 2, P$1 /= 2, D /= 2, $ /= 2;
    }
    function v$1(x$1, L) {
      return A === 1 ? x$1[L] : x$1.readUInt16BE(L * A);
    }
    let w$1;
    if (E) {
      let x$1 = -1;
      for (w$1 = $; w$1 < P$1; w$1++) if (v$1(N, w$1) === v$1(p$1, x$1 === -1 ? 0 : w$1 - x$1)) {
        if (x$1 === -1 && (x$1 = w$1), w$1 - x$1 + 1 === D) return x$1 * A;
      } else x$1 !== -1 && (w$1 -= w$1 - x$1), x$1 = -1;
    } else for ($ + D > P$1 && ($ = P$1 - D), w$1 = $; w$1 >= 0; w$1--) {
      let x$1 = true;
      for (let L = 0; L < D; L++) if (v$1(N, w$1 + L) !== v$1(p$1, L)) {
        x$1 = false;
        break;
      }
      if (x$1) return w$1;
    }
    return -1;
  }
  S.prototype.includes = function(p$1, $, T) {
    return this.indexOf(p$1, $, T) !== -1;
  }, S.prototype.indexOf = function(p$1, $, T) {
    return ge(this, p$1, $, T, true);
  }, S.prototype.lastIndexOf = function(p$1, $, T) {
    return ge(this, p$1, $, T, false);
  };
  function pe(N, p$1, $, T) {
    $ = Number($) || 0;
    let E = N.length - $;
    T ? (T = Number(T), T > E && (T = E)) : T = E;
    let A = p$1.length;
    T > A / 2 && (T = A / 2);
    let P$1;
    for (P$1 = 0; P$1 < T; ++P$1) {
      let D = parseInt(p$1.substr(P$1 * 2, 2), 16);
      if (Se(D)) return P$1;
      N[$ + P$1] = D;
    }
    return P$1;
  }
  function oe(N, p$1, $, T) {
    return he(ye(p$1, N.length - $), N, $, T);
  }
  function re$5(N, p$1, $, T) {
    return he(Ze(p$1), N, $, T);
  }
  function fe(N, p$1, $, T) {
    return he(Me(p$1), N, $, T);
  }
  function xe(N, p$1, $, T) {
    return he(Ke(p$1, N.length - $), N, $, T);
  }
  S.prototype.write = function(p$1, $, T, E) {
    if ($ === void 0) E = `utf8`, T = this.length, $ = 0;
    else if (T === void 0 && typeof $ == `string`) E = $, T = this.length, $ = 0;
    else if (isFinite($)) $ >>>= 0, isFinite(T) ? (T >>>= 0, E === void 0 && (E = `utf8`)) : (E = T, T = void 0);
    else throw Error(`Buffer.write(string, encoding, offset[, length]) is no longer supported`);
    let A = this.length - $;
    if ((T === void 0 || T > A) && (T = A), p$1.length > 0 && (T < 0 || $ < 0) || $ > this.length) throw RangeError(`Attempt to write outside buffer bounds`);
    E ||= `utf8`;
    let P$1 = false;
    for (; ; ) switch (E) {
      case `hex`:
        return pe(this, p$1, $, T);
      case `utf8`:
      case `utf-8`:
        return oe(this, p$1, $, T);
      case `ascii`:
      case `latin1`:
      case `binary`:
        return re$5(this, p$1, $, T);
      case `base64`:
        return fe(this, p$1, $, T);
      case `ucs2`:
      case `ucs-2`:
      case `utf16le`:
      case `utf-16le`:
        return xe(this, p$1, $, T);
      default:
        if (P$1) throw TypeError(`Unknown encoding: ` + E);
        E = (`` + E).toLowerCase(), P$1 = true;
    }
  }, S.prototype.toJSON = function() {
    return { type: `Buffer`, data: Array.prototype.slice.call(this._arr || this, 0) };
  };
  function Be(N, p$1, $) {
    return p$1 === 0 && $ === N.length ? o$2.fromByteArray(N) : o$2.fromByteArray(N.slice(p$1, $));
  }
  function _e(N, p$1, $) {
    $ = Math.min(N.length, $);
    let T = [], E = p$1;
    for (; E < $; ) {
      let A = N[E], P$1 = null, D = A > 239 ? 4 : A > 223 ? 3 : A > 191 ? 2 : 1;
      if (E + D <= $) {
        let v$1, w$1, x$1, L;
        switch (D) {
          case 1:
            A < 128 && (P$1 = A);
            break;
          case 2:
            v$1 = N[E + 1], (v$1 & 192) == 128 && (L = (A & 31) << 6 | v$1 & 63, L > 127 && (P$1 = L));
            break;
          case 3:
            v$1 = N[E + 1], w$1 = N[E + 2], (v$1 & 192) == 128 && (w$1 & 192) == 128 && (L = (A & 15) << 12 | (v$1 & 63) << 6 | w$1 & 63, L > 2047 && (L < 55296 || L > 57343) && (P$1 = L));
            break;
          case 4:
            v$1 = N[E + 1], w$1 = N[E + 2], x$1 = N[E + 3], (v$1 & 192) == 128 && (w$1 & 192) == 128 && (x$1 & 192) == 128 && (L = (A & 15) << 18 | (v$1 & 63) << 12 | (w$1 & 63) << 6 | x$1 & 63, L > 65535 && L < 1114112 && (P$1 = L));
        }
      }
      P$1 === null ? (P$1 = 65533, D = 1) : P$1 > 65535 && (P$1 -= 65536, T.push(P$1 >>> 10 & 1023 | 55296), P$1 = 56320 | P$1 & 1023), T.push(P$1), E += D;
    }
    return Ve(T);
  }
  let Ee = 4096;
  function Ve(N) {
    let p$1 = N.length;
    if (p$1 <= Ee) return String.fromCharCode.apply(String, N);
    let $ = ``, T = 0;
    for (; T < p$1; ) $ += String.fromCharCode.apply(String, N.slice(T, T += Ee));
    return $;
  }
  function Ge(N, p$1, $) {
    let T = ``;
    $ = Math.min(N.length, $);
    for (let E = p$1; E < $; ++E) T += String.fromCharCode(N[E] & 127);
    return T;
  }
  function ke(N, p$1, $) {
    let T = ``;
    $ = Math.min(N.length, $);
    for (let E = p$1; E < $; ++E) T += String.fromCharCode(N[E]);
    return T;
  }
  function He(N, p$1, $) {
    let T = N.length;
    (!p$1 || p$1 < 0) && (p$1 = 0), (!$ || $ < 0 || $ > T) && ($ = T);
    let E = ``;
    for (let A = p$1; A < $; ++A) E += qe[N[A]];
    return E;
  }
  function We(N, p$1, $) {
    let T = N.slice(p$1, $), E = ``;
    for (let A = 0; A < T.length - 1; A += 2) E += String.fromCharCode(T[A] + T[A + 1] * 256);
    return E;
  }
  S.prototype.slice = function(p$1, $) {
    let T = this.length;
    p$1 = ~~p$1, $ = $ === void 0 ? T : ~~$, p$1 < 0 ? (p$1 += T, p$1 < 0 && (p$1 = 0)) : p$1 > T && (p$1 = T), $ < 0 ? ($ += T, $ < 0 && ($ = 0)) : $ > T && ($ = T), $ < p$1 && ($ = p$1);
    let E = this.subarray(p$1, $);
    return Object.setPrototypeOf(E, S.prototype), E;
  };
  function B(N, p$1, $) {
    if (N % 1 != 0 || N < 0) throw RangeError(`offset is not uint`);
    if (N + p$1 > $) throw RangeError(`Trying to access beyond buffer length`);
  }
  S.prototype.readUintLE = S.prototype.readUIntLE = function(p$1, $, T) {
    p$1 >>>= 0, $ >>>= 0, T || B(p$1, $, this.length);
    let E = this[p$1], A = 1, P$1 = 0;
    for (; ++P$1 < $ && (A *= 256); ) E += this[p$1 + P$1] * A;
    return E;
  }, S.prototype.readUintBE = S.prototype.readUIntBE = function(p$1, $, T) {
    p$1 >>>= 0, $ >>>= 0, T || B(p$1, $, this.length);
    let E = this[p$1 + --$], A = 1;
    for (; $ > 0 && (A *= 256); ) E += this[p$1 + --$] * A;
    return E;
  }, S.prototype.readUint8 = S.prototype.readUInt8 = function(p$1, $) {
    return p$1 >>>= 0, $ || B(p$1, 1, this.length), this[p$1];
  }, S.prototype.readUint16LE = S.prototype.readUInt16LE = function(p$1, $) {
    return p$1 >>>= 0, $ || B(p$1, 2, this.length), this[p$1] | this[p$1 + 1] << 8;
  }, S.prototype.readUint16BE = S.prototype.readUInt16BE = function(p$1, $) {
    return p$1 >>>= 0, $ || B(p$1, 2, this.length), this[p$1] << 8 | this[p$1 + 1];
  }, S.prototype.readUint32LE = S.prototype.readUInt32LE = function(p$1, $) {
    return p$1 >>>= 0, $ || B(p$1, 4, this.length), (this[p$1] | this[p$1 + 1] << 8 | this[p$1 + 2] << 16) + this[p$1 + 3] * 16777216;
  }, S.prototype.readUint32BE = S.prototype.readUInt32BE = function(p$1, $) {
    return p$1 >>>= 0, $ || B(p$1, 4, this.length), this[p$1] * 16777216 + (this[p$1 + 1] << 16 | this[p$1 + 2] << 8 | this[p$1 + 3]);
  }, S.prototype.readBigUInt64LE = Q(function(p$1) {
    p$1 >>>= 0, ae(p$1, `offset`);
    let $ = this[p$1], T = this[p$1 + 7];
    ($ === void 0 || T === void 0) && ue(p$1, this.length - 8);
    let E = $ + this[++p$1] * 2 ** 8 + this[++p$1] * 2 ** 16 + this[++p$1] * 2 ** 24, A = this[++p$1] + this[++p$1] * 2 ** 8 + this[++p$1] * 2 ** 16 + T * 2 ** 24;
    return BigInt(E) + (BigInt(A) << BigInt(32));
  }), S.prototype.readBigUInt64BE = Q(function(p$1) {
    p$1 >>>= 0, ae(p$1, `offset`);
    let $ = this[p$1], T = this[p$1 + 7];
    ($ === void 0 || T === void 0) && ue(p$1, this.length - 8);
    let E = $ * 2 ** 24 + this[++p$1] * 2 ** 16 + this[++p$1] * 2 ** 8 + this[++p$1], A = this[++p$1] * 2 ** 24 + this[++p$1] * 2 ** 16 + this[++p$1] * 2 ** 8 + T;
    return (BigInt(E) << BigInt(32)) + BigInt(A);
  }), S.prototype.readIntLE = function(p$1, $, T) {
    p$1 >>>= 0, $ >>>= 0, T || B(p$1, $, this.length);
    let E = this[p$1], A = 1, P$1 = 0;
    for (; ++P$1 < $ && (A *= 256); ) E += this[p$1 + P$1] * A;
    return A *= 128, E >= A && (E -= 2 ** (8 * $)), E;
  }, S.prototype.readIntBE = function(p$1, $, T) {
    p$1 >>>= 0, $ >>>= 0, T || B(p$1, $, this.length);
    let E = $, A = 1, P$1 = this[p$1 + --E];
    for (; E > 0 && (A *= 256); ) P$1 += this[p$1 + --E] * A;
    return A *= 128, P$1 >= A && (P$1 -= 2 ** (8 * $)), P$1;
  }, S.prototype.readInt8 = function(p$1, $) {
    return p$1 >>>= 0, $ || B(p$1, 1, this.length), this[p$1] & 128 ? (255 - this[p$1] + 1) * -1 : this[p$1];
  }, S.prototype.readInt16LE = function(p$1, $) {
    p$1 >>>= 0, $ || B(p$1, 2, this.length);
    let T = this[p$1] | this[p$1 + 1] << 8;
    return T & 32768 ? T | 4294901760 : T;
  }, S.prototype.readInt16BE = function(p$1, $) {
    p$1 >>>= 0, $ || B(p$1, 2, this.length);
    let T = this[p$1 + 1] | this[p$1] << 8;
    return T & 32768 ? T | 4294901760 : T;
  }, S.prototype.readInt32LE = function(p$1, $) {
    return p$1 >>>= 0, $ || B(p$1, 4, this.length), this[p$1] | this[p$1 + 1] << 8 | this[p$1 + 2] << 16 | this[p$1 + 3] << 24;
  }, S.prototype.readInt32BE = function(p$1, $) {
    return p$1 >>>= 0, $ || B(p$1, 4, this.length), this[p$1] << 24 | this[p$1 + 1] << 16 | this[p$1 + 2] << 8 | this[p$1 + 3];
  }, S.prototype.readBigInt64LE = Q(function(p$1) {
    p$1 >>>= 0, ae(p$1, `offset`);
    let $ = this[p$1], T = this[p$1 + 7];
    ($ === void 0 || T === void 0) && ue(p$1, this.length - 8);
    let E = this[p$1 + 4] + this[p$1 + 5] * 2 ** 8 + this[p$1 + 6] * 2 ** 16 + (T << 24);
    return (BigInt(E) << BigInt(32)) + BigInt($ + this[++p$1] * 2 ** 8 + this[++p$1] * 2 ** 16 + this[++p$1] * 2 ** 24);
  }), S.prototype.readBigInt64BE = Q(function(p$1) {
    p$1 >>>= 0, ae(p$1, `offset`);
    let $ = this[p$1], T = this[p$1 + 7];
    ($ === void 0 || T === void 0) && ue(p$1, this.length - 8);
    let E = ($ << 24) + this[++p$1] * 2 ** 16 + this[++p$1] * 2 ** 8 + this[++p$1];
    return (BigInt(E) << BigInt(32)) + BigInt(this[++p$1] * 2 ** 24 + this[++p$1] * 2 ** 16 + this[++p$1] * 2 ** 8 + T);
  }), S.prototype.readFloatLE = function(p$1, $) {
    return p$1 >>>= 0, $ || B(p$1, 4, this.length), r$2.read(this, p$1, true, 23, 4);
  }, S.prototype.readFloatBE = function(p$1, $) {
    return p$1 >>>= 0, $ || B(p$1, 4, this.length), r$2.read(this, p$1, false, 23, 4);
  }, S.prototype.readDoubleLE = function(p$1, $) {
    return p$1 >>>= 0, $ || B(p$1, 8, this.length), r$2.read(this, p$1, true, 52, 8);
  }, S.prototype.readDoubleBE = function(p$1, $) {
    return p$1 >>>= 0, $ || B(p$1, 8, this.length), r$2.read(this, p$1, false, 52, 8);
  };
  function k(N, p$1, $, T, E, A) {
    if (!S.isBuffer(N)) throw TypeError(`"buffer" argument must be a Buffer instance`);
    if (p$1 > E || p$1 < A) throw RangeError(`"value" argument is out of bounds`);
    if ($ + T > N.length) throw RangeError(`Index out of range`);
  }
  S.prototype.writeUintLE = S.prototype.writeUIntLE = function(p$1, $, T, E) {
    if (p$1 = +p$1, $ >>>= 0, T >>>= 0, !E) {
      let D = 2 ** (8 * T) - 1;
      k(this, p$1, $, T, D, 0);
    }
    let A = 1, P$1 = 0;
    for (this[$] = p$1 & 255; ++P$1 < T && (A *= 256); ) this[$ + P$1] = p$1 / A & 255;
    return $ + T;
  }, S.prototype.writeUintBE = S.prototype.writeUIntBE = function(p$1, $, T, E) {
    if (p$1 = +p$1, $ >>>= 0, T >>>= 0, !E) {
      let D = 2 ** (8 * T) - 1;
      k(this, p$1, $, T, D, 0);
    }
    let A = T - 1, P$1 = 1;
    for (this[$ + A] = p$1 & 255; --A >= 0 && (P$1 *= 256); ) this[$ + A] = p$1 / P$1 & 255;
    return $ + T;
  }, S.prototype.writeUint8 = S.prototype.writeUInt8 = function(p$1, $, T) {
    return p$1 = +p$1, $ >>>= 0, T || k(this, p$1, $, 1, 255, 0), this[$] = p$1 & 255, $ + 1;
  }, S.prototype.writeUint16LE = S.prototype.writeUInt16LE = function(p$1, $, T) {
    return p$1 = +p$1, $ >>>= 0, T || k(this, p$1, $, 2, 65535, 0), this[$] = p$1 & 255, this[$ + 1] = p$1 >>> 8, $ + 2;
  }, S.prototype.writeUint16BE = S.prototype.writeUInt16BE = function(p$1, $, T) {
    return p$1 = +p$1, $ >>>= 0, T || k(this, p$1, $, 2, 65535, 0), this[$] = p$1 >>> 8, this[$ + 1] = p$1 & 255, $ + 2;
  }, S.prototype.writeUint32LE = S.prototype.writeUInt32LE = function(p$1, $, T) {
    return p$1 = +p$1, $ >>>= 0, T || k(this, p$1, $, 4, 4294967295, 0), this[$ + 3] = p$1 >>> 24, this[$ + 2] = p$1 >>> 16, this[$ + 1] = p$1 >>> 8, this[$] = p$1 & 255, $ + 4;
  }, S.prototype.writeUint32BE = S.prototype.writeUInt32BE = function(p$1, $, T) {
    return p$1 = +p$1, $ >>>= 0, T || k(this, p$1, $, 4, 4294967295, 0), this[$] = p$1 >>> 24, this[$ + 1] = p$1 >>> 16, this[$ + 2] = p$1 >>> 8, this[$ + 3] = p$1 & 255, $ + 4;
  };
  function Ae(N, p$1, $, T, E) {
    Re(p$1, T, E, N, $, 7);
    let A = Number(p$1 & BigInt(4294967295));
    N[$++] = A, A >>= 8, N[$++] = A, A >>= 8, N[$++] = A, A >>= 8, N[$++] = A;
    let P$1 = Number(p$1 >> BigInt(32) & BigInt(4294967295));
    return N[$++] = P$1, P$1 >>= 8, N[$++] = P$1, P$1 >>= 8, N[$++] = P$1, P$1 >>= 8, N[$++] = P$1, $;
  }
  function Ce(N, p$1, $, T, E) {
    Re(p$1, T, E, N, $, 7);
    let A = Number(p$1 & BigInt(4294967295));
    N[$ + 7] = A, A >>= 8, N[$ + 6] = A, A >>= 8, N[$ + 5] = A, A >>= 8, N[$ + 4] = A;
    let P$1 = Number(p$1 >> BigInt(32) & BigInt(4294967295));
    return N[$ + 3] = P$1, P$1 >>= 8, N[$ + 2] = P$1, P$1 >>= 8, N[$ + 1] = P$1, P$1 >>= 8, N[$] = P$1, $ + 8;
  }
  S.prototype.writeBigUInt64LE = Q(function(p$1, $ = 0) {
    return Ae(this, p$1, $, BigInt(0), BigInt(`0xffffffffffffffff`));
  }), S.prototype.writeBigUInt64BE = Q(function(p$1, $ = 0) {
    return Ce(this, p$1, $, BigInt(0), BigInt(`0xffffffffffffffff`));
  }), S.prototype.writeIntLE = function(p$1, $, T, E) {
    if (p$1 = +p$1, $ >>>= 0, !E) {
      let v$1 = 2 ** (8 * T - 1);
      k(this, p$1, $, T, v$1 - 1, -v$1);
    }
    let A = 0, P$1 = 1, D = 0;
    for (this[$] = p$1 & 255; ++A < T && (P$1 *= 256); ) p$1 < 0 && D === 0 && this[$ + A - 1] !== 0 && (D = 1), this[$ + A] = (p$1 / P$1 >> 0) - D & 255;
    return $ + T;
  }, S.prototype.writeIntBE = function(p$1, $, T, E) {
    if (p$1 = +p$1, $ >>>= 0, !E) {
      let v$1 = 2 ** (8 * T - 1);
      k(this, p$1, $, T, v$1 - 1, -v$1);
    }
    let A = T - 1, P$1 = 1, D = 0;
    for (this[$ + A] = p$1 & 255; --A >= 0 && (P$1 *= 256); ) p$1 < 0 && D === 0 && this[$ + A + 1] !== 0 && (D = 1), this[$ + A] = (p$1 / P$1 >> 0) - D & 255;
    return $ + T;
  }, S.prototype.writeInt8 = function(p$1, $, T) {
    return p$1 = +p$1, $ >>>= 0, T || k(this, p$1, $, 1, 127, -128), p$1 < 0 && (p$1 = 255 + p$1 + 1), this[$] = p$1 & 255, $ + 1;
  }, S.prototype.writeInt16LE = function(p$1, $, T) {
    return p$1 = +p$1, $ >>>= 0, T || k(this, p$1, $, 2, 32767, -32768), this[$] = p$1 & 255, this[$ + 1] = p$1 >>> 8, $ + 2;
  }, S.prototype.writeInt16BE = function(p$1, $, T) {
    return p$1 = +p$1, $ >>>= 0, T || k(this, p$1, $, 2, 32767, -32768), this[$] = p$1 >>> 8, this[$ + 1] = p$1 & 255, $ + 2;
  }, S.prototype.writeInt32LE = function(p$1, $, T) {
    return p$1 = +p$1, $ >>>= 0, T || k(this, p$1, $, 4, 2147483647, -2147483648), this[$] = p$1 & 255, this[$ + 1] = p$1 >>> 8, this[$ + 2] = p$1 >>> 16, this[$ + 3] = p$1 >>> 24, $ + 4;
  }, S.prototype.writeInt32BE = function(p$1, $, T) {
    return p$1 = +p$1, $ >>>= 0, T || k(this, p$1, $, 4, 2147483647, -2147483648), p$1 < 0 && (p$1 = 4294967295 + p$1 + 1), this[$] = p$1 >>> 24, this[$ + 1] = p$1 >>> 16, this[$ + 2] = p$1 >>> 8, this[$ + 3] = p$1 & 255, $ + 4;
  }, S.prototype.writeBigInt64LE = Q(function(p$1, $ = 0) {
    return Ae(this, p$1, $, -BigInt(`0x8000000000000000`), BigInt(`0x7fffffffffffffff`));
  }), S.prototype.writeBigInt64BE = Q(function(p$1, $ = 0) {
    return Ce(this, p$1, $, -BigInt(`0x8000000000000000`), BigInt(`0x7fffffffffffffff`));
  });
  function Pe(N, p$1, $, T, E, A) {
    if ($ + T > N.length || $ < 0) throw RangeError(`Index out of range`);
  }
  function Oe(N, p$1, $, T, E) {
    return p$1 = +p$1, $ >>>= 0, E || Pe(N, p$1, $, 4), r$2.write(N, p$1, $, T, 23, 4), $ + 4;
  }
  S.prototype.writeFloatLE = function(p$1, $, T) {
    return Oe(this, p$1, $, true, T);
  }, S.prototype.writeFloatBE = function(p$1, $, T) {
    return Oe(this, p$1, $, false, T);
  };
  function Ie(N, p$1, $, T, E) {
    return p$1 = +p$1, $ >>>= 0, E || Pe(N, p$1, $, 8), r$2.write(N, p$1, $, T, 52, 8), $ + 8;
  }
  S.prototype.writeDoubleLE = function(p$1, $, T) {
    return Ie(this, p$1, $, true, T);
  }, S.prototype.writeDoubleBE = function(p$1, $, T) {
    return Ie(this, p$1, $, false, T);
  }, S.prototype.copy = function(p$1, $, T, E) {
    if (!S.isBuffer(p$1)) throw TypeError(`argument should be a Buffer`);
    if (T ||= 0, !E && E !== 0 && (E = this.length), $ >= p$1.length && ($ = p$1.length), $ ||= 0, E > 0 && E < T && (E = T), E === T || p$1.length === 0 || this.length === 0) return 0;
    if ($ < 0) throw RangeError(`targetStart out of bounds`);
    if (T < 0 || T >= this.length) throw RangeError(`Index out of range`);
    if (E < 0) throw RangeError(`sourceEnd out of bounds`);
    E > this.length && (E = this.length), p$1.length - $ < E - T && (E = p$1.length - $ + T);
    let A = E - T;
    return this === p$1 && typeof Uint8Array.prototype.copyWithin == `function` ? this.copyWithin($, T, E) : Uint8Array.prototype.set.call(p$1, this.subarray(T, E), $), A;
  }, S.prototype.fill = function(p$1, $, T, E) {
    if (typeof p$1 == `string`) {
      if (typeof $ == `string` ? (E = $, $ = 0, T = this.length) : typeof T == `string` && (E = T, T = this.length), E !== void 0 && typeof E != `string`) throw TypeError(`encoding must be a string`);
      if (typeof E == `string` && !S.isEncoding(E)) throw TypeError(`Unknown encoding: ` + E);
      if (p$1.length === 1) {
        let P$1 = p$1.charCodeAt(0);
        (E === `utf8` && P$1 < 128 || E === `latin1`) && (p$1 = P$1);
      }
    } else typeof p$1 == `number` ? p$1 &= 255 : typeof p$1 == `boolean` && (p$1 = Number(p$1));
    if ($ < 0 || this.length < $ || this.length < T) throw RangeError(`Out of range index`);
    if (T <= $) return this;
    $ >>>= 0, T = T === void 0 ? this.length : T >>> 0, p$1 ||= 0;
    let A;
    if (typeof p$1 == `number`) for (A = $; A < T; ++A) this[A] = p$1;
    else {
      let P$1 = S.isBuffer(p$1) ? p$1 : S.from(p$1, E), D = P$1.length;
      if (D === 0) throw TypeError(`The value "` + p$1 + `" is invalid for argument "value"`);
      for (A = 0; A < T - $; ++A) this[A + $] = P$1[A % D];
    }
    return this;
  };
  let ie = {};
  function $e(N, p$1, $) {
    ie[N] = class extends $ {
      constructor() {
        super(), Object.defineProperty(this, `message`, { value: p$1.apply(this, arguments), writable: true, configurable: true }), this.name = `${this.name} [${N}]`, this.stack, delete this.name;
      }
      get code() {
        return N;
      }
      set code(E) {
        Object.defineProperty(this, `code`, { configurable: true, enumerable: true, value: E, writable: true });
      }
      toString() {
        return `${this.name} [${N}]: ${this.message}`;
      }
    };
  }
  $e(`ERR_BUFFER_OUT_OF_BOUNDS`, function(N) {
    return N ? `${N} is outside of buffer bounds` : `Attempt to access memory outside buffer bounds`;
  }, RangeError), $e(`ERR_INVALID_ARG_TYPE`, function(N, p$1) {
    return `The "${N}" argument must be of type number. Received type ${typeof p$1}`;
  }, TypeError), $e(`ERR_OUT_OF_RANGE`, function(N, p$1, $) {
    let T = `The value of "${N}" is out of range.`, E = $;
    return Number.isInteger($) && Math.abs($) > 2 ** 32 ? E = Ue(String($)) : typeof $ == `bigint` && (E = String($), ($ > BigInt(2) ** BigInt(32) || $ < -(BigInt(2) ** BigInt(32))) && (E = Ue(E)), E += `n`), T += ` It must be ${p$1}. Received ${E}`, T;
  }, RangeError);
  function Ue(N) {
    let p$1 = ``, $ = N.length, T = N[0] === `-` ? 1 : 0;
    for (; $ >= T + 4; $ -= 3) p$1 = `_${N.slice($ - 3, $)}${p$1}`;
    return `${N.slice(0, $)}${p$1}`;
  }
  function Ye(N, p$1, $) {
    ae(p$1, `offset`), (N[p$1] === void 0 || N[p$1 + $] === void 0) && ue(p$1, N.length - ($ + 1));
  }
  function Re(N, p$1, $, T, E, A) {
    if (N > $ || N < p$1) {
      let P$1 = typeof p$1 == `bigint` ? `n` : ``, D;
      throw D = p$1 === 0 || p$1 === BigInt(0) ? `>= 0${P$1} and < 2${P$1} ** ${(A + 1) * 8}${P$1}` : `>= -(2${P$1} ** ${(A + 1) * 8 - 1}${P$1}) and < 2 ** ${(A + 1) * 8 - 1}${P$1}`, new ie.ERR_OUT_OF_RANGE(`value`, D, N);
    }
    Ye(T, E, A);
  }
  function ae(N, p$1) {
    if (typeof N != `number`) throw new ie.ERR_INVALID_ARG_TYPE(p$1, `number`, N);
  }
  function ue(N, p$1, $) {
    throw Math.floor(N) === N ? p$1 < 0 ? new ie.ERR_BUFFER_OUT_OF_BOUNDS() : new ie.ERR_OUT_OF_RANGE(`offset`, `>= 0 and <= ${p$1}`, N) : (ae(N, $), new ie.ERR_OUT_OF_RANGE(`offset`, `an integer`, N));
  }
  let je = /[^+/0-9A-Za-z-_]/g;
  function ze(N) {
    if (N = N.split(`=`)[0], N = N.trim().replace(je, ``), N.length < 2) return ``;
    for (; N.length % 4 != 0; ) N += `=`;
    return N;
  }
  function ye(N, p$1) {
    p$1 ||= 1 / 0;
    let $, T = N.length, E = null, A = [];
    for (let P$1 = 0; P$1 < T; ++P$1) {
      if ($ = N.charCodeAt(P$1), $ > 55295 && $ < 57344) {
        if (!E) {
          if ($ > 56319) {
            (p$1 -= 3) > -1 && A.push(239, 191, 189);
            continue;
          } else if (P$1 + 1 === T) {
            (p$1 -= 3) > -1 && A.push(239, 191, 189);
            continue;
          }
          E = $;
          continue;
        }
        if ($ < 56320) {
          (p$1 -= 3) > -1 && A.push(239, 191, 189), E = $;
          continue;
        }
        $ = (E - 55296 << 10 | $ - 56320) + 65536;
      } else E && (p$1 -= 3) > -1 && A.push(239, 191, 189);
      if (E = null, $ < 128) {
        if (--p$1 < 0) break;
        A.push($);
      } else if ($ < 2048) {
        if ((p$1 -= 2) < 0) break;
        A.push($ >> 6 | 192, $ & 63 | 128);
      } else if ($ < 65536) {
        if ((p$1 -= 3) < 0) break;
        A.push($ >> 12 | 224, $ >> 6 & 63 | 128, $ & 63 | 128);
      } else if ($ < 1114112) {
        if ((p$1 -= 4) < 0) break;
        A.push($ >> 18 | 240, $ >> 12 & 63 | 128, $ >> 6 & 63 | 128, $ & 63 | 128);
      } else throw Error(`Invalid code point`);
    }
    return A;
  }
  function Ze(N) {
    let p$1 = [];
    for (let $ = 0; $ < N.length; ++$) p$1.push(N.charCodeAt($) & 255);
    return p$1;
  }
  function Ke(N, p$1) {
    let $, T, E, A = [];
    for (let P$1 = 0; P$1 < N.length && !((p$1 -= 2) < 0); ++P$1) $ = N.charCodeAt(P$1), T = $ >> 8, E = $ % 256, A.push(E), A.push(T);
    return A;
  }
  function Me(N) {
    return o$2.toByteArray(ze(N));
  }
  function he(N, p$1, $, T) {
    let E;
    for (E = 0; E < T && !(E + $ >= p$1.length || E >= N.length); ++E) p$1[E + $] = N[E];
    return E;
  }
  function J(N, p$1) {
    return N instanceof p$1 || N != null && N.constructor != null && N.constructor.name != null && N.constructor.name === p$1.name;
  }
  function Se(N) {
    return N !== N;
  }
  let qe = (function() {
    let N = `0123456789abcdef`, p$1 = Array(256);
    for (let $ = 0; $ < 16; ++$) {
      let T = $ * 16;
      for (let E = 0; E < 16; ++E) p$1[T + E] = N[$] + N[E];
    }
    return p$1;
  })();
  function Q(N) {
    return typeof BigInt > `u` ? Je : N;
  }
  function Je() {
    throw Error(`BigInt not supported`);
  }
})(buffer);
var z, H, Z, V, se, le, W, Le, Fe, be, we, ve;
const Te = class Te$1 {
  constructor(o$2, r$2) {
    ee(this, W), ee(this, z), ee(this, H), ee(this, Z), ee(this, V), ee(this, se, false), ee(this, le, `INVALID`), X(this, z, String(o$2).replace(/\D/g, ``));
    let u = typeof r$2 == `string` ? r$2.trim().toUpperCase() : `XX`;
    X(this, H, isos$1.has(u) ? u : `XX`), X(this, Z, libphonenumberExports.PhoneNumberUtil.getInstance()), M(this, H) === `XX` && X(this, H, ne(this, W, Le).call(this, M(this, z)));
    try {
      X(this, V, M(this, Z).parseAndKeepRawInput(M(this, z), M(this, H)));
    } catch {
    }
    if (M(this, V)) try {
      X(this, se, M(this, Z).isValidNumber(M(this, V))), X(this, le, ne(this, W, we).call(this, M(this, V)));
    } catch {
    }
    M(this, se) === true && nanpaCountries$1.includes(M(this, H)) && X(this, H, ne(this, W, ve).call(this));
  }
  get country() {
    return M(this, H);
  }
  get valid() {
    return M(this, se);
  }
  get type() {
    return M(this, le);
  }
  get mobile() {
    return typeof this.type == `string` && [`MOBILE`, `FIXED_LINE_OR_MOBILE`].includes(this.type);
  }
  get raw() {
    return M(this, V) ? M(this, Z).format(M(this, V), libphonenumberExports.PhoneNumberFormat.E164).replace(/\D/g, ``) : M(this, z);
  }
  get national() {
    return M(this, V) ? M(this, Z).format(M(this, V), libphonenumberExports.PhoneNumberFormat.NATIONAL) : M(this, z);
  }
  get international() {
    return M(this, V) ? M(this, Z).format(M(this, V), libphonenumberExports.PhoneNumberFormat.INTERNATIONAL) : M(this, z);
  }
  get e164() {
    return M(this, V) ? M(this, Z).format(M(this, V), libphonenumberExports.PhoneNumberFormat.E164) : M(this, z);
  }
  get timezone() {
    return timezones$1.has(M(this, H)) ? timezones$1.get(M(this, H)) : `UTC`;
  }
  toObject() {
    return { phone: M(this, z), country: M(this, H), valid: this.valid, type: this.type, mobile: this.mobile, raw: this.raw, national: this.national, international: this.international, e164: this.e164, timezone: this.timezone };
  }
  toJSON() {
    return this.toObject();
  }
  toString() {
    return this.e164;
  }
  inspect() {
    return `Phone {
      phone: ${M(this, z)},
      country: ${M(this, H)},
      valid: ${this.valid === true ? `true` : `false`},
      type: ${this.type},
      mobile: ${this.mobile === true ? `true` : `false`},
      raw: ${this.raw},
      national: ${this.national},
      international: ${this.international},
      e164: ${this.e164},
      timezone: ${this.timezone},
    }`;
  }
  serialize() {
    let o$2 = buffer.Buffer.from(JSON.stringify({ phone: this.raw, country: this.country })).toString(`base64`);
    return buffer.Buffer.from(JSON.stringify({ phone: this.raw, country: this.country, hash: o$2 })).toString(`base64`);
  }
  static deserialize(o$2) {
    let r$2;
    try {
      r$2 = buffer.Buffer.from(o$2, `base64`).toString(`utf-8`);
    } catch {
      throw Error(`Not a valid serialized phone object`);
    }
    let u;
    try {
      u = JSON.parse(r$2);
    } catch {
      throw Error(`Not a valid serialized phone object`);
    }
    if (!u.phone || !u.country || !u.hash || buffer.Buffer.from(JSON.stringify({ phone: u.phone, country: u.country })).toString(`base64`) !== u.hash) throw Error(`Not a valid serialized phone object`);
    return new Te$1(u.phone, u.country === `XX` ? void 0 : u.country);
  }
};
z = /* @__PURE__ */ new WeakMap(), H = /* @__PURE__ */ new WeakMap(), Z = /* @__PURE__ */ new WeakMap(), V = /* @__PURE__ */ new WeakMap(), se = /* @__PURE__ */ new WeakMap(), le = /* @__PURE__ */ new WeakMap(), W = /* @__PURE__ */ new WeakSet(), Le = function(o$2) {
  let r$2 = country_telephone_data.allCountries.map((u) => ({ iso: u.iso2.toUpperCase(), prefix: String(u.dialCode).trim().replace(/\D/g, ``) })).filter((u) => o$2.substring(0, u.prefix.length) === u.prefix).sort(ne(this, W, be)).filter((u) => {
    let h$1 = this.constructor;
    return new h$1(o$2, u.iso).valid;
  });
  return r$2.length >= 1 ? r$2[0].iso : ne(this, W, Fe).call(this, o$2);
}, Fe = function(o$2) {
  let r$2 = country_telephone_data.allCountries.map((u) => ({ iso: u.iso2.toUpperCase(), prefix: String(u.dialCode).trim().replace(/\D/g, ``) })).sort(ne(this, W, be)).filter((u) => {
    let h$1 = this.constructor;
    return new h$1(o$2, u.iso).valid;
  });
  return r$2.length >= 1 ? r$2[0].iso : `XX`;
}, be = function(o$2, r$2) {
  if (o$2.prefix.length === r$2.prefix.length) {
    let u = Number.parseInt(o$2.prefix), h$1 = Number.parseInt(r$2.prefix);
    return u === h$1 ? o$2.iso.localeCompare(r$2.iso) : u > h$1 ? 1 : -1;
  }
  return o$2.prefix.length > r$2.prefix.length ? 1 : -1;
}, we = function(o$2) {
  if (!o$2) return `INVALID`;
  let r$2 = M(this, Z).getNumberType(o$2), u = Object.values(libphonenumberExports.PhoneNumberType), h$1 = Object.keys(libphonenumberExports.PhoneNumberType), m$3 = u.indexOf(r$2);
  return h$1[m$3] || `INVALID`;
}, ve = function() {
  let o$2 = this.raw.substring(1, 4);
  return areaCodeMap$1[o$2] && typeof areaCodeMap$1[o$2] == `string` ? areaCodeMap$1[o$2] : `XX`;
};
let Phone$1 = Te;
const messages = { "phone.base": `{{#label}} must be a phone number`, "phone.invalid": `{{#label}} must be a valid phone number for {{#country}}`, "phone.fixedLine": `{{#label}} must be a fixed line number for {{#country}}`, "phone.mobile": `{{#label}} must be a mobile number for {{#country}}`, "phone.strictFixedLine": `{{#label}} is not a fixed line number for {{#country}}`, "phone.strictMobile": `{{#label}} is not a mobile number for {{#country}}`, "phone.fixedLineOrMobile": `{{#label}} must be a fixed line or mobile number for {{#country}}`, "phone.tollFree": `{{#label}} must be a toll-free number for {{#country}}`, "phone.premiumRate": `{{#label}} must be a premium rate number for {{#country}}`, "phone.sharedCost": `{{#label}} must be a shared cost number for {{#country}}`, "phone.voip": `{{#label}} must be a VoIP number for {{#country}}`, "phone.personalNumber": `{{#label}} must be a personal number for {{#country}}`, "phone.pager": `{{#label}} must be a pager number for {{#country}}`, "phone.uan": `{{#label}} must be a UAN number for {{#country}}`, "phone.voicemail": `{{#label}} must be a voicemail number for {{#country}}`, "phone.unknown": `{{#label}} must be an unknown type number for {{#country}}`, "phone.types": `{{#label}} must be one of the specified phone types for {{#country}}` }, coerceCountry = (value) => {
  if (typeof value != `string`) return null;
  if (isos$1.has(value.toUpperCase())) return value.toUpperCase();
  let match$2 = null;
  return countries$1.forEach((name$2, iso) => {
    name$2.toLowerCase() === value.toLowerCase() && (match$2 = iso);
  }), match$2;
}, getPhoneObject = (value, country) => {
  let countryCoerced = coerceCountry(country);
  try {
    return new Phone$1(value, countryCoerced || void 0);
  } catch {
    return;
  }
}, evaluate = (value, operator$1, args$1) => {
  switch (operator$1) {
    case `fixedLine`:
      return [`FIXED_LINE`, `FIXED_LINE_OR_MOBILE`].includes(value.type);
    case `mobile`:
      return [`MOBILE`, `FIXED_LINE_OR_MOBILE`].includes(value.type);
    case `fixedLineOrMobile`:
      return [`FIXED_LINE`, `MOBILE`, `FIXED_LINE_OR_MOBILE`].includes(value.type);
    case `strictFixedLine`:
      return value.type === `FIXED_LINE`;
    case `strictMobile`:
      return value.type === `MOBILE`;
    case `tollFree`:
      return value.type === `TOLL_FREE`;
    case `premiumRate`:
      return value.type === `PREMIUM_RATE`;
    case `sharedCost`:
      return value.type === `SHARED_COST`;
    case `voip`:
      return value.type === `VOIP`;
    case `personalNumber`:
      return value.type === `PERSONAL_NUMBER`;
    case `pager`:
      return value.type === `PAGER`;
    case `uan`:
      return value.type === `UAN`;
    case `voicemail`:
      return value.type === `VOICEMAIL`;
    case `unknown`:
      return value.type === `UNKNOWN`;
    case `types`:
      return args$1[0].includes(value.type);
    default:
      return false;
  }
}, phone = function(joi) {
  let coerce$3 = (value, helpers$8) => typeof value == `string` || typeof value == `number` ? (value = value.toString().trim(), { value }) : { value, errors: [helpers$8.error(`phone.base`, { value: String(value) })] }, getCountryName = (iso) => {
    if (`$i18n` in joi) {
      let root$11 = joi;
      if (!countries$1.has(iso)) return iso;
      let returnable = root$11.$i18n(`country.${iso}`);
      return returnable || countries$1.get(iso) || iso;
    }
    return countries$1.get(iso) || iso;
  };
  return { type: `phone`, base: joi.any(), validate(value, { error, schema: schema$2, prefs, state }) {
    let isEmpty$13 = value == null, isRequired = schema$2._flags.presence === `required`;
    if (isEmpty$13 && !isRequired) return { value: null };
    if (isEmpty$13 && isRequired) return { value, errors: [error(`any.required`, { label: schema$2._flags.label })] };
    let arg = schema$2.$_getFlag(`country`), country = joi.isRef(arg) ? arg.resolve(value, state, prefs) : arg, pObj = getPhoneObject(value, country);
    if (pObj) {
      if (!pObj.valid) return country ? { value, errors: [error(`phone.invalid`, { value: String(value), country: getCountryName(country) })] } : { value, errors: [error(`phone.base`, { value: String(value) })] };
    } else return { value, errors: [error(`phone.base`, { value: String(value) })] };
    let as = schema$2.$_getFlag(`as`) || `e164`, formattedValue;
    switch (as) {
      case `international`:
        formattedValue = pObj.international;
        break;
      case `national`:
        formattedValue = pObj.national;
        break;
      case `raw`:
        formattedValue = pObj.raw;
        break;
      case `timezone`:
        formattedValue = pObj.timezone;
        break;
      case `type`:
        formattedValue = pObj.type;
        break;
      case `country`:
        formattedValue = pObj.country;
        break;
      default:
        formattedValue = pObj.e164;
    }
    return { value: formattedValue };
  }, flags: { country: { default: null, setter: `country` }, as: { default: `e164`, setter: `format` } }, args(...args$1) {
    let [schema$2, country] = args$1;
    return schema$2.country(country);
  }, coerce: { from: [`string`, `number`], method: coerce$3 }, rules: { check: { method: false, validate(value, helpers$8, args$1, { name: name$2, operator: operator$1 }) {
    let { state, prefs } = helpers$8, countryVal = helpers$8.schema.$_getFlag(`country`);
    joi.isRef(countryVal) && (countryVal = countryVal.resolve(value, state, prefs));
    let pObj = getPhoneObject(value, countryVal);
    if (pObj) {
      if (!pObj.valid) return countryVal ? helpers$8.error(`phone.invalid`, { value: String(value), country: getCountryName(countryVal) }) : { value, errors: [helpers$8.error(`phone.base`, { value: String(value) })] };
    } else return helpers$8.error(`phone.base`, { value: String(value) });
    let valid$2 = evaluate(pObj, operator$1, Object.values(args$1 || {}));
    return valid$2 ? value : helpers$8.error(`phone.` + name$2, { value: value.toString(), country: getCountryName(countryVal), ...args$1 });
  } }, country: { method(country) {
    return this.$_setFlag(`country`, country);
  }, args: [{ name: `country`, ref: true, assert: (value) => typeof value == `string` || joi.isRef(value), message: `must be a string or a reference` }] }, format: { method(as) {
    return this.$_setFlag(`as`, as);
  }, args: [{ name: `as`, assert: (value) => [`e164`, `international`, `national`, `raw`, `timezone`, `type`, `country`].includes(value), message: `must be one of e164, international, national, raw, timezone, type, or country` }] }, fixedLine: { method() {
    return this.$_addRule({ name: `fixedLine`, method: `check`, operator: `fixedLine` });
  } }, mobile: { method() {
    return this.$_addRule({ name: `mobile`, method: `check`, operator: `mobile` });
  } }, strictFixedLine: { method() {
    return this.$_addRule({ name: `strictFixedLine`, method: `check`, operator: `strictFixedLine` });
  } }, strictMobile: { method() {
    return this.$_addRule({ name: `strictMobile`, method: `check`, operator: `strictMobile` });
  } }, fixedLineOrMobile: { method() {
    return this.$_addRule({ name: `fixedLineOrMobile`, method: `check`, operator: `fixedLineOrMobile` });
  } }, tollFree: { method() {
    return this.$_addRule({ name: `tollFree`, method: `check`, operator: `tollFree` });
  } }, premiumRate: { method() {
    return this.$_addRule({ name: `premiumRate`, method: `check`, operator: `premiumRate` });
  } }, sharedCost: { method() {
    return this.$_addRule({ name: `sharedCost`, method: `check`, operator: `sharedCost` });
  } }, voip: { method() {
    return this.$_addRule({ name: `voip`, method: `check`, operator: `voip` });
  } }, personalNumber: { method() {
    return this.$_addRule({ name: `personalNumber`, method: `check`, operator: `personalNumber` });
  } }, pager: { method() {
    return this.$_addRule({ name: `pager`, method: `check`, operator: `pager` });
  } }, uan: { method() {
    return this.$_addRule({ name: `uan`, method: `check`, operator: `uan` });
  } }, voicemail: { method() {
    return this.$_addRule({ name: `voicemail`, method: `check`, operator: `voicemail` });
  } }, unknown: { method() {
    return this.$_addRule({ name: `unknown`, method: `check`, operator: `unknown` });
  } }, types: { method(...types$1) {
    return this.$_addRule({ name: `types`, method: `check`, operator: `types`, args: { types: types$1 } });
  } } }, cast: { string: { from: (value) => typeof value == `string` || typeof value == `number`, to: (value) => value }, number: { from: (value) => typeof value == `string` || typeof value == `number`, to(value, helpers$8) {
    let country = helpers$8.schema.$_getFlag(`country`), pObj = getPhoneObject(value, country);
    return pObj ? Number(pObj.raw) : -1;
  } }, object: { from: (value) => typeof value == `string` || typeof value == `number`, to(value, helpers$8) {
    let country = helpers$8.schema.$_getFlag(`country`), pObj = getPhoneObject(value, country);
    return pObj ? pObj.toObject() : {};
  } } }, messages };
};
var DP = 20, RM = 1, MAX_DP = 1e6, MAX_POWER = 1e6, NE = -7, PE = 21, STRICT = false, NAME = `[big.js] `, INVALID$3 = NAME + `Invalid `, INVALID_DP = INVALID$3 + `decimal places`, INVALID_RM = INVALID$3 + `rounding mode`, DIV_BY_ZERO = NAME + `Division by zero`, P = {}, UNDEFINED = void 0, NUMERIC = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
function _Big_() {
  function Big$1(n$4) {
    var x$1 = this;
    if (!(x$1 instanceof Big$1)) return n$4 === UNDEFINED && arguments.length === 0 ? _Big_() : new Big$1(n$4);
    if (n$4 instanceof Big$1) x$1.s = n$4.s, x$1.e = n$4.e, x$1.c = n$4.c.slice();
    else {
      if (typeof n$4 != `string`) {
        if (Big$1.strict === true && typeof n$4 != `bigint`) throw TypeError(INVALID$3 + `value`);
        n$4 = n$4 === 0 && 1 / n$4 < 0 ? `-0` : String(n$4);
      }
      parse$8(x$1, n$4);
    }
    x$1.constructor = Big$1;
  }
  return Big$1.prototype = P, Big$1.DP = DP, Big$1.RM = RM, Big$1.NE = NE, Big$1.PE = PE, Big$1.strict = STRICT, Big$1.roundDown = 0, Big$1.roundHalfUp = 1, Big$1.roundHalfEven = 2, Big$1.roundUp = 3, Big$1;
}
function parse$8(x$1, n$4) {
  var e$22, i$4, nl;
  if (!NUMERIC.test(n$4)) throw Error(INVALID$3 + `number`);
  for (x$1.s = n$4.charAt(0) == `-` ? (n$4 = n$4.slice(1), -1) : 1, (e$22 = n$4.indexOf(`.`)) > -1 && (n$4 = n$4.replace(`.`, ``)), (i$4 = n$4.search(/e/i)) > 0 ? (e$22 < 0 && (e$22 = i$4), e$22 += +n$4.slice(i$4 + 1), n$4 = n$4.substring(0, i$4)) : e$22 < 0 && (e$22 = n$4.length), nl = n$4.length, i$4 = 0; i$4 < nl && n$4.charAt(i$4) == `0`; ) ++i$4;
  if (i$4 == nl) x$1.c = [x$1.e = 0];
  else {
    for (; nl > 0 && n$4.charAt(--nl) == `0`; ) ;
    for (x$1.e = e$22 - i$4 - 1, x$1.c = [], e$22 = 0; i$4 <= nl; ) x$1.c[e$22++] = +n$4.charAt(i$4++);
  }
  return x$1;
}
function round(x$1, sd, rm, more) {
  var xc = x$1.c;
  if (rm === UNDEFINED && (rm = x$1.constructor.RM), rm !== 0 && rm !== 1 && rm !== 2 && rm !== 3) throw Error(INVALID_RM);
  if (sd < 1) more = rm === 3 && (more || !!xc[0]) || sd === 0 && (rm === 1 && xc[0] >= 5 || rm === 2 && (xc[0] > 5 || xc[0] === 5 && (more || xc[1] !== UNDEFINED))), xc.length = 1, more ? (x$1.e = x$1.e - sd + 1, xc[0] = 1) : xc[0] = x$1.e = 0;
  else if (sd < xc.length) {
    if (more = rm === 1 && xc[sd] >= 5 || rm === 2 && (xc[sd] > 5 || xc[sd] === 5 && (more || xc[sd + 1] !== UNDEFINED || xc[sd - 1] & 1)) || rm === 3 && (more || !!xc[0]), xc.length = sd, more) {
      for (; ++xc[--sd] > 9; ) if (xc[sd] = 0, sd === 0) {
        ++x$1.e, xc.unshift(1);
        break;
      }
    }
    for (sd = xc.length; !xc[--sd]; ) xc.pop();
  }
  return x$1;
}
function stringify(x$1, doExponential, isNonzero) {
  var e$22 = x$1.e, s$6 = x$1.c.join(``), n$4 = s$6.length;
  if (doExponential) s$6 = s$6.charAt(0) + (n$4 > 1 ? `.` + s$6.slice(1) : ``) + (e$22 < 0 ? `e` : `e+`) + e$22;
  else if (e$22 < 0) {
    for (; ++e$22; ) s$6 = `0` + s$6;
    s$6 = `0.` + s$6;
  } else if (e$22 > 0) if (++e$22 > n$4) for (e$22 -= n$4; e$22--; ) s$6 += `0`;
  else e$22 < n$4 && (s$6 = s$6.slice(0, e$22) + `.` + s$6.slice(e$22));
  else n$4 > 1 && (s$6 = s$6.charAt(0) + `.` + s$6.slice(1));
  return x$1.s < 0 && isNonzero ? `-` + s$6 : s$6;
}
P.abs = function() {
  var x$1 = new this.constructor(this);
  return x$1.s = 1, x$1;
}, P.cmp = function(y$1) {
  var isneg, x$1 = this, xc = x$1.c, yc = (y$1 = new x$1.constructor(y$1)).c, i$4 = x$1.s, j$1 = y$1.s, k = x$1.e, l$4 = y$1.e;
  if (!xc[0] || !yc[0]) return xc[0] ? i$4 : yc[0] ? -j$1 : 0;
  if (i$4 != j$1) return i$4;
  if (isneg = i$4 < 0, k != l$4) return k > l$4 ^ isneg ? 1 : -1;
  for (j$1 = (k = xc.length) < (l$4 = yc.length) ? k : l$4, i$4 = -1; ++i$4 < j$1; ) if (xc[i$4] != yc[i$4]) return xc[i$4] > yc[i$4] ^ isneg ? 1 : -1;
  return k == l$4 ? 0 : k > l$4 ^ isneg ? 1 : -1;
}, P.div = function(y$1) {
  var x$1 = this, Big$1 = x$1.constructor, a$22 = x$1.c, b2 = (y$1 = new Big$1(y$1)).c, k = x$1.s == y$1.s ? 1 : -1, dp = Big$1.DP;
  if (dp !== ~~dp || dp < 0 || dp > MAX_DP) throw Error(INVALID_DP);
  if (!b2[0]) throw Error(DIV_BY_ZERO);
  if (!a$22[0]) return y$1.s = k, y$1.c = [y$1.e = 0], y$1;
  var bl, bt, n$4, cmp$3, ri, bz = b2.slice(), ai = bl = b2.length, al = a$22.length, r$2 = a$22.slice(0, bl), rl = r$2.length, q = y$1, qc = q.c = [], qi = 0, p$1 = dp + (q.e = x$1.e - y$1.e) + 1;
  for (q.s = k, k = p$1 < 0 ? 0 : p$1, bz.unshift(0); rl++ < bl; ) r$2.push(0);
  do {
    for (n$4 = 0; n$4 < 10; n$4++) {
      if (bl != (rl = r$2.length)) cmp$3 = bl > rl ? 1 : -1;
      else for (ri = -1, cmp$3 = 0; ++ri < bl; ) if (b2[ri] != r$2[ri]) {
        cmp$3 = b2[ri] > r$2[ri] ? 1 : -1;
        break;
      }
      if (cmp$3 < 0) {
        for (bt = rl == bl ? b2 : bz; rl; ) {
          if (r$2[--rl] < bt[rl]) {
            for (ri = rl; ri && !r$2[--ri]; ) r$2[ri] = 9;
            --r$2[ri], r$2[rl] += 10;
          }
          r$2[rl] -= bt[rl];
        }
        for (; !r$2[0]; ) r$2.shift();
      } else break;
    }
    qc[qi++] = cmp$3 ? n$4 : ++n$4, r$2[0] && cmp$3 ? r$2[rl] = a$22[ai] || 0 : r$2 = [a$22[ai]];
  } while ((ai++ < al || r$2[0] !== UNDEFINED) && k--);
  return !qc[0] && qi != 1 && (qc.shift(), q.e--, p$1--), qi > p$1 && round(q, p$1, Big$1.RM, r$2[0] !== UNDEFINED), q;
}, P.eq = function(y$1) {
  return this.cmp(y$1) === 0;
}, P.gt = function(y$1) {
  return this.cmp(y$1) > 0;
}, P.gte = function(y$1) {
  return this.cmp(y$1) > -1;
}, P.lt = function(y$1) {
  return this.cmp(y$1) < 0;
}, P.lte = function(y$1) {
  return this.cmp(y$1) < 1;
}, P.minus = P.sub = function(y$1) {
  var i$4, j$1, t$7, xlty, x$1 = this, Big$1 = x$1.constructor, a$22 = x$1.s, b2 = (y$1 = new Big$1(y$1)).s;
  if (a$22 != b2) return y$1.s = -b2, x$1.plus(y$1);
  var xc = x$1.c.slice(), xe = x$1.e, yc = y$1.c, ye = y$1.e;
  if (!xc[0] || !yc[0]) return yc[0] ? y$1.s = -b2 : xc[0] ? y$1 = new Big$1(x$1) : y$1.s = 1, y$1;
  if (a$22 = xe - ye) {
    for ((xlty = a$22 < 0) ? (a$22 = -a$22, t$7 = xc) : (ye = xe, t$7 = yc), t$7.reverse(), b2 = a$22; b2--; ) t$7.push(0);
    t$7.reverse();
  } else for (j$1 = ((xlty = xc.length < yc.length) ? xc : yc).length, a$22 = b2 = 0; b2 < j$1; b2++) if (xc[b2] != yc[b2]) {
    xlty = xc[b2] < yc[b2];
    break;
  }
  if (xlty && (t$7 = xc, xc = yc, yc = t$7, y$1.s = -y$1.s), (b2 = (j$1 = yc.length) - (i$4 = xc.length)) > 0) for (; b2--; ) xc[i$4++] = 0;
  for (b2 = i$4; j$1 > a$22; ) {
    if (xc[--j$1] < yc[j$1]) {
      for (i$4 = j$1; i$4 && !xc[--i$4]; ) xc[i$4] = 9;
      --xc[i$4], xc[j$1] += 10;
    }
    xc[j$1] -= yc[j$1];
  }
  for (; xc[--b2] === 0; ) xc.pop();
  for (; xc[0] === 0; ) xc.shift(), --ye;
  return xc[0] || (y$1.s = 1, xc = [ye = 0]), y$1.c = xc, y$1.e = ye, y$1;
}, P.mod = function(y$1) {
  var ygtx, x$1 = this, Big$1 = x$1.constructor, a$22 = x$1.s, b2 = (y$1 = new Big$1(y$1)).s;
  if (!y$1.c[0]) throw Error(DIV_BY_ZERO);
  return x$1.s = y$1.s = 1, ygtx = y$1.cmp(x$1) == 1, x$1.s = a$22, y$1.s = b2, ygtx ? new Big$1(x$1) : (a$22 = Big$1.DP, b2 = Big$1.RM, Big$1.DP = Big$1.RM = 0, x$1 = x$1.div(y$1), Big$1.DP = a$22, Big$1.RM = b2, this.minus(x$1.times(y$1)));
}, P.neg = function() {
  var x$1 = new this.constructor(this);
  return x$1.s = -x$1.s, x$1;
}, P.plus = P.add = function(y$1) {
  var e$22, k, t$7, x$1 = this, Big$1 = x$1.constructor;
  if (y$1 = new Big$1(y$1), x$1.s != y$1.s) return y$1.s = -y$1.s, x$1.minus(y$1);
  var xe = x$1.e, xc = x$1.c, ye = y$1.e, yc = y$1.c;
  if (!xc[0] || !yc[0]) return yc[0] || (xc[0] ? y$1 = new Big$1(x$1) : y$1.s = x$1.s), y$1;
  if (xc = xc.slice(), e$22 = xe - ye) {
    for (e$22 > 0 ? (ye = xe, t$7 = yc) : (e$22 = -e$22, t$7 = xc), t$7.reverse(); e$22--; ) t$7.push(0);
    t$7.reverse();
  }
  for (xc.length - yc.length < 0 && (t$7 = yc, yc = xc, xc = t$7), e$22 = yc.length, k = 0; e$22; xc[e$22] %= 10) k = (xc[--e$22] = xc[e$22] + yc[e$22] + k) / 10 | 0;
  for (k && (xc.unshift(k), ++ye), e$22 = xc.length; xc[--e$22] === 0; ) xc.pop();
  return y$1.c = xc, y$1.e = ye, y$1;
}, P.pow = function(n$4) {
  var x$1 = this, one = new x$1.constructor(`1`), y$1 = one, isneg = n$4 < 0;
  if (n$4 !== ~~n$4 || n$4 < -MAX_POWER || n$4 > MAX_POWER) throw Error(INVALID$3 + `exponent`);
  for (isneg && (n$4 = -n$4); n$4 & 1 && (y$1 = y$1.times(x$1)), n$4 >>= 1, n$4; ) x$1 = x$1.times(x$1);
  return isneg ? one.div(y$1) : y$1;
}, P.prec = function(sd, rm) {
  if (sd !== ~~sd || sd < 1 || sd > MAX_DP) throw Error(INVALID$3 + `precision`);
  return round(new this.constructor(this), sd, rm);
}, P.round = function(dp, rm) {
  if (dp === UNDEFINED) dp = 0;
  else if (dp !== ~~dp || dp < -MAX_DP || dp > MAX_DP) throw Error(INVALID_DP);
  return round(new this.constructor(this), dp + this.e + 1, rm);
}, P.sqrt = function() {
  var r$2, c$12, t$7, x$1 = this, Big$1 = x$1.constructor, s$6 = x$1.s, e$22 = x$1.e, half = new Big$1(`0.5`);
  if (!x$1.c[0]) return new Big$1(x$1);
  if (s$6 < 0) throw Error(NAME + `No square root`);
  s$6 = Math.sqrt(+stringify(x$1, true, true)), s$6 === 0 || s$6 === 1 / 0 ? (c$12 = x$1.c.join(``), c$12.length + e$22 & 1 || (c$12 += `0`), s$6 = Math.sqrt(c$12), e$22 = ((e$22 + 1) / 2 | 0) - (e$22 < 0 || e$22 & 1), r$2 = new Big$1((s$6 == 1 / 0 ? `5e` : (s$6 = s$6.toExponential()).slice(0, s$6.indexOf(`e`) + 1)) + e$22)) : r$2 = new Big$1(s$6 + ``), e$22 = r$2.e + (Big$1.DP += 4);
  do
    t$7 = r$2, r$2 = half.times(t$7.plus(x$1.div(t$7)));
  while (t$7.c.slice(0, e$22).join(``) !== r$2.c.slice(0, e$22).join(``));
  return round(r$2, (Big$1.DP -= 4) + r$2.e + 1, Big$1.RM);
}, P.times = P.mul = function(y$1) {
  var c$12, x$1 = this, Big$1 = x$1.constructor, xc = x$1.c, yc = (y$1 = new Big$1(y$1)).c, a$22 = xc.length, b2 = yc.length, i$4 = x$1.e, j$1 = y$1.e;
  if (y$1.s = x$1.s == y$1.s ? 1 : -1, !xc[0] || !yc[0]) return y$1.c = [y$1.e = 0], y$1;
  for (y$1.e = i$4 + j$1, a$22 < b2 && (c$12 = xc, xc = yc, yc = c$12, j$1 = a$22, a$22 = b2, b2 = j$1), c$12 = Array(j$1 = a$22 + b2); j$1--; ) c$12[j$1] = 0;
  for (i$4 = b2; i$4--; ) {
    for (b2 = 0, j$1 = a$22 + i$4; j$1 > i$4; ) b2 = c$12[j$1] + yc[i$4] * xc[j$1 - i$4 - 1] + b2, c$12[j$1--] = b2 % 10, b2 = b2 / 10 | 0;
    c$12[j$1] = b2;
  }
  for (b2 ? ++y$1.e : c$12.shift(), i$4 = c$12.length; !c$12[--i$4]; ) c$12.pop();
  return y$1.c = c$12, y$1;
}, P.toExponential = function(dp, rm) {
  var x$1 = this, n$4 = x$1.c[0];
  if (dp !== UNDEFINED) {
    if (dp !== ~~dp || dp < 0 || dp > MAX_DP) throw Error(INVALID_DP);
    for (x$1 = round(new x$1.constructor(x$1), ++dp, rm); x$1.c.length < dp; ) x$1.c.push(0);
  }
  return stringify(x$1, true, !!n$4);
}, P.toFixed = function(dp, rm) {
  var x$1 = this, n$4 = x$1.c[0];
  if (dp !== UNDEFINED) {
    if (dp !== ~~dp || dp < 0 || dp > MAX_DP) throw Error(INVALID_DP);
    for (x$1 = round(new x$1.constructor(x$1), dp + x$1.e + 1, rm), dp = dp + x$1.e + 1; x$1.c.length < dp; ) x$1.c.push(0);
  }
  return stringify(x$1, false, !!n$4);
}, P.toJSON = P.toString = function() {
  var x$1 = this, Big$1 = x$1.constructor;
  return stringify(x$1, x$1.e <= Big$1.NE || x$1.e >= Big$1.PE, !!x$1.c[0]);
}, typeof Symbol < `u` && (P[Symbol.for(`nodejs.util.inspect.custom`)] = P.toJSON), P.toNumber = function() {
  var n$4 = +stringify(this, true, true);
  if (this.constructor.strict === true && !this.eq(n$4.toString())) throw Error(NAME + `Imprecise conversion`);
  return n$4;
}, P.toPrecision = function(sd, rm) {
  var x$1 = this, Big$1 = x$1.constructor, n$4 = x$1.c[0];
  if (sd !== UNDEFINED) {
    if (sd !== ~~sd || sd < 1 || sd > MAX_DP) throw Error(INVALID$3 + `precision`);
    for (x$1 = round(new Big$1(x$1), sd, rm); x$1.c.length < sd; ) x$1.c.push(0);
  }
  return stringify(x$1, sd <= x$1.e || x$1.e <= Big$1.NE || x$1.e >= Big$1.PE, !!n$4);
}, P.valueOf = function() {
  var x$1 = this, Big$1 = x$1.constructor;
  if (Big$1.strict === true) throw Error(NAME + `valueOf disallowed`);
  return stringify(x$1, x$1.e <= Big$1.NE || x$1.e >= Big$1.PE, true);
};
var Big = _Big_(), big_default = Big;
const messages$1 = { "bigint.base": `"{{#label}}" must be a valid bigint`, "bigint.greater": `"{{#label}}" must be greater than {{#limit}}`, "bigint.less": `"{{#label}}" must be less than {{#limit}}`, "bigint.max": `"{{#label}}" must be less than or equal to {{#limit}}`, "bigint.min": `"{{#label}}" must be greater than or equal to {{#limit}}`, "bigint.multiple": `"{{#label}}" must be a multiple of {{#limit}}`, "bigint.negative": `"{{#label}}" must be a negative bigint`, "bigint.positive": `"{{#label}}" must be a positive bigint` }, compare$13 = (value, limit, operator$1) => {
  switch (operator$1) {
    case `>`:
      return value.gt(limit);
    case `<`:
      return value.lt(limit);
    case `>=`:
      return value.gte(limit);
    case `<=`:
      return value.lte(limit);
    case `multiple`:
      return value.mod(limit).eq(0);
    default:
      return false;
  }
}, bigint = function(joi) {
  return { type: `bigint`, base: joi.any(), coerce: { from: [`string`, `number`], method(value, helpers$8) {
    if (typeof value == `bigint`) return { value };
    try {
      let asBig = big_default(value.toString());
      return asBig.eq(asBig.round(0)) ? { value: BigInt(asBig.toString()) } : { value, errors: [helpers$8.error(`bigint.base`, { value: String(value) })] };
    } catch {
      return { value, errors: [helpers$8.error(`bigint.base`, { value: String(value) })] };
    }
  } }, messages: messages$1, validate(value, { error }) {
    return typeof value == `bigint` ? { value } : { value, errors: error(`bigint.base`, { value: String(value) }) };
  }, rules: { compare: { method: false, validate(value, helpers$8, { limit }, { name: name$2, operator: operator$1 }) {
    let isEmpty$13 = value == null, isRequired = helpers$8.schema._flags.presence === `required`;
    if (isEmpty$13 && !isRequired) return null;
    if (isEmpty$13 && isRequired) return { value, errors: [helpers$8.error(`any.required`, { label: helpers$8.schema._flags.label })] };
    let big = big_default(value.toString()), threshold = big_default(limit.toString()), valid$2 = compare$13(big, threshold, operator$1);
    return valid$2 ? value : helpers$8.error(`bigint.` + name$2, { limit: limit.toString(), value: value.toString() });
  }, args: [{ name: `limit`, ref: true, assert: (value) => [`bigint`, `number`, `string`].includes(typeof value), message: `must be a bigint` }] }, greater: { method(limit) {
    return this.$_addRule({ name: `greater`, method: `compare`, args: { limit }, operator: `>` });
  } }, less: { method(limit) {
    return this.$_addRule({ name: `less`, method: `compare`, args: { limit }, operator: `<` });
  } }, max: { method(limit) {
    return this.$_addRule({ name: `max`, method: `compare`, args: { limit }, operator: `<=` });
  } }, min: { method(limit) {
    return this.$_addRule({ name: `min`, method: `compare`, args: { limit }, operator: `>=` });
  } }, multiple: { method(limit) {
    return this.$_addRule({ name: `multiple`, method: `compare`, args: { limit }, operator: `multiple` });
  } }, negative: { method() {
    return this.$_addRule(`negative`);
  }, validate(value, helpers$8) {
    return value >= 0n ? helpers$8.error(`bigint.negative`, { value: value.toString() }) : value;
  } }, positive: { method() {
    return this.$_addRule(`positive`);
  }, validate(value, helpers$8) {
    return value <= 0n ? helpers$8.error(`bigint.positive`, { value: value.toString() }) : value;
  } } }, cast: { string: { from: (value) => typeof value == `bigint`, to(value) {
    return value.toString();
  } } } };
};
var LuxonError$2 = class LuxonError3 extends Error {
}, InvalidDateTimeError = class extends LuxonError$2 {
  constructor(reason) {
    super(`Invalid DateTime: ${reason.toMessage()}`);
  }
}, InvalidIntervalError = class extends LuxonError$2 {
  constructor(reason) {
    super(`Invalid Interval: ${reason.toMessage()}`);
  }
}, InvalidDurationError = class extends LuxonError$2 {
  constructor(reason) {
    super(`Invalid Duration: ${reason.toMessage()}`);
  }
}, ConflictingSpecificationError = class extends LuxonError$2 {
}, InvalidUnitError = class extends LuxonError$2 {
  constructor(unit) {
    super(`Invalid unit ${unit}`);
  }
}, InvalidArgumentError = class extends LuxonError$2 {
}, ZoneIsAbstractError$2 = class ZoneIsAbstractError3 extends LuxonError$2 {
  constructor() {
    super(`Zone is an abstract class`);
  }
};
const n = `numeric`, s = `short`, l = `long`, DATE_SHORT = { year: n, month: n, day: n }, DATE_MED = { year: n, month: s, day: n }, DATE_MED_WITH_WEEKDAY = { year: n, month: s, day: n, weekday: s }, DATE_FULL = { year: n, month: l, day: n }, DATE_HUGE = { year: n, month: l, day: n, weekday: l }, TIME_SIMPLE = { hour: n, minute: n }, TIME_WITH_SECONDS = { hour: n, minute: n, second: n }, TIME_WITH_SHORT_OFFSET = { hour: n, minute: n, second: n, timeZoneName: s }, TIME_WITH_LONG_OFFSET = { hour: n, minute: n, second: n, timeZoneName: l }, TIME_24_SIMPLE = { hour: n, minute: n, hourCycle: `h23` }, TIME_24_WITH_SECONDS = { hour: n, minute: n, second: n, hourCycle: `h23` }, TIME_24_WITH_SHORT_OFFSET = { hour: n, minute: n, second: n, hourCycle: `h23`, timeZoneName: s }, TIME_24_WITH_LONG_OFFSET = { hour: n, minute: n, second: n, hourCycle: `h23`, timeZoneName: l }, DATETIME_SHORT = { year: n, month: n, day: n, hour: n, minute: n }, DATETIME_SHORT_WITH_SECONDS = { year: n, month: n, day: n, hour: n, minute: n, second: n }, DATETIME_MED = { year: n, month: s, day: n, hour: n, minute: n }, DATETIME_MED_WITH_SECONDS = { year: n, month: s, day: n, hour: n, minute: n, second: n }, DATETIME_MED_WITH_WEEKDAY = { year: n, month: s, day: n, weekday: s, hour: n, minute: n }, DATETIME_FULL = { year: n, month: l, day: n, hour: n, minute: n, timeZoneName: s }, DATETIME_FULL_WITH_SECONDS = { year: n, month: l, day: n, hour: n, minute: n, second: n, timeZoneName: s }, DATETIME_HUGE = { year: n, month: l, day: n, weekday: l, hour: n, minute: n, timeZoneName: l }, DATETIME_HUGE_WITH_SECONDS = { year: n, month: l, day: n, weekday: l, hour: n, minute: n, second: n, timeZoneName: l };
var Zone$2 = class Zone3 {
  get type() {
    throw new ZoneIsAbstractError$2();
  }
  get name() {
    throw new ZoneIsAbstractError$2();
  }
  get ianaName() {
    return this.name;
  }
  get isUniversal() {
    throw new ZoneIsAbstractError$2();
  }
  offsetName(ts, opts) {
    throw new ZoneIsAbstractError$2();
  }
  formatOffset(ts, format) {
    throw new ZoneIsAbstractError$2();
  }
  offset(ts) {
    throw new ZoneIsAbstractError$2();
  }
  equals(otherZone) {
    throw new ZoneIsAbstractError$2();
  }
  get isValid() {
    throw new ZoneIsAbstractError$2();
  }
};
let singleton$1 = null;
var SystemZone = class SystemZone3 extends Zone$2 {
  static get instance() {
    return singleton$1 === null && (singleton$1 = new SystemZone3()), singleton$1;
  }
  get type() {
    return `system`;
  }
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  get isUniversal() {
    return false;
  }
  offsetName(ts, { format, locale }) {
    return parseZoneInfo$2(ts, format, locale);
  }
  formatOffset(ts, format) {
    return formatOffset$2(this.offset(ts), format);
  }
  offset(ts) {
    return -new Date(ts).getTimezoneOffset();
  }
  equals(otherZone) {
    return otherZone.type === `system`;
  }
  get isValid() {
    return true;
  }
};
const dtfCache$2 = /* @__PURE__ */ new Map();
function makeDTF$2(zoneName) {
  let dtf = dtfCache$2.get(zoneName);
  return dtf === void 0 && (dtf = new Intl.DateTimeFormat(`en-US`, { hour12: false, timeZone: zoneName, year: `numeric`, month: `2-digit`, day: `2-digit`, hour: `2-digit`, minute: `2-digit`, second: `2-digit`, era: `short` }), dtfCache$2.set(zoneName, dtf)), dtf;
}
const typeToPos$2 = { year: 0, month: 1, day: 2, era: 3, hour: 4, minute: 5, second: 6 };
function hackyOffset$2(dtf, date) {
  let formatted = dtf.format(date).replace(/\u200E/g, ``), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = parsed;
  return [fYear, fMonth, fDay, fadOrBc, fHour, fMinute, fSecond];
}
function partsOffset$2(dtf, date) {
  let formatted = dtf.formatToParts(date), filled = [];
  for (let i$4 = 0; i$4 < formatted.length; i$4++) {
    let { type, value } = formatted[i$4], pos = typeToPos$2[type];
    type === `era` ? filled[pos] = value : isUndefined$2(pos) || (filled[pos] = parseInt(value, 10));
  }
  return filled;
}
const ianaZoneCache$2 = /* @__PURE__ */ new Map();
var IANAZone$2 = class IANAZone3 extends Zone$2 {
  static create(name$2) {
    let zone = ianaZoneCache$2.get(name$2);
    return zone === void 0 && ianaZoneCache$2.set(name$2, zone = new IANAZone3(name$2)), zone;
  }
  static resetCache() {
    ianaZoneCache$2.clear(), dtfCache$2.clear();
  }
  static isValidSpecifier(s$6) {
    return this.isValidZone(s$6);
  }
  static isValidZone(zone) {
    if (!zone) return false;
    try {
      return new Intl.DateTimeFormat(`en-US`, { timeZone: zone }).format(), true;
    } catch {
      return false;
    }
  }
  constructor(name$2) {
    super(), this.zoneName = name$2, this.valid = IANAZone3.isValidZone(name$2);
  }
  get type() {
    return `iana`;
  }
  get name() {
    return this.zoneName;
  }
  get isUniversal() {
    return false;
  }
  offsetName(ts, { format, locale }) {
    return parseZoneInfo$2(ts, format, locale, this.name);
  }
  formatOffset(ts, format) {
    return formatOffset$2(this.offset(ts), format);
  }
  offset(ts) {
    if (!this.valid) return NaN;
    let date = new Date(ts);
    if (isNaN(date)) return NaN;
    let dtf = makeDTF$2(this.name), [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts ? partsOffset$2(dtf, date) : hackyOffset$2(dtf, date);
    adOrBc === `BC` && (year = -Math.abs(year) + 1);
    let adjustedHour = hour === 24 ? 0 : hour, asUTC = objToLocalTS$2({ year, month, day, hour: adjustedHour, minute, second, millisecond: 0 }), asTS = +date, over = asTS % 1e3;
    return asTS -= over >= 0 ? over : 1e3 + over, (asUTC - asTS) / (60 * 1e3);
  }
  equals(otherZone) {
    return otherZone.type === `iana` && otherZone.name === this.name;
  }
  get isValid() {
    return this.valid;
  }
};
let intlLFCache = {};
function getCachedLF(locString, opts = {}) {
  let key = JSON.stringify([locString, opts]), dtf = intlLFCache[key];
  return dtf || (dtf = new Intl.ListFormat(locString, opts), intlLFCache[key] = dtf), dtf;
}
const intlDTCache = /* @__PURE__ */ new Map();
function getCachedDTF(locString, opts = {}) {
  let key = JSON.stringify([locString, opts]), dtf = intlDTCache.get(key);
  return dtf === void 0 && (dtf = new Intl.DateTimeFormat(locString, opts), intlDTCache.set(key, dtf)), dtf;
}
const intlNumCache = /* @__PURE__ */ new Map();
function getCachedINF(locString, opts = {}) {
  let key = JSON.stringify([locString, opts]), inf = intlNumCache.get(key);
  return inf === void 0 && (inf = new Intl.NumberFormat(locString, opts), intlNumCache.set(key, inf)), inf;
}
const intlRelCache = /* @__PURE__ */ new Map();
function getCachedRTF(locString, opts = {}) {
  let { base: base$3, ...cacheKeyOpts } = opts, key = JSON.stringify([locString, cacheKeyOpts]), inf = intlRelCache.get(key);
  return inf === void 0 && (inf = new Intl.RelativeTimeFormat(locString, opts), intlRelCache.set(key, inf)), inf;
}
let sysLocaleCache = null;
function systemLocale() {
  return sysLocaleCache || (sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale, sysLocaleCache);
}
const intlResolvedOptionsCache = /* @__PURE__ */ new Map();
function getCachedIntResolvedOptions(locString) {
  let opts = intlResolvedOptionsCache.get(locString);
  return opts === void 0 && (opts = new Intl.DateTimeFormat(locString).resolvedOptions(), intlResolvedOptionsCache.set(locString, opts)), opts;
}
const weekInfoCache = /* @__PURE__ */ new Map();
function getCachedWeekInfo(locString) {
  let data = weekInfoCache.get(locString);
  if (!data) {
    let locale = new Intl.Locale(locString);
    data = `getWeekInfo` in locale ? locale.getWeekInfo() : locale.weekInfo, `minimalDays` in data || (data = { ...fallbackWeekSettings, ...data }), weekInfoCache.set(locString, data);
  }
  return data;
}
function parseLocaleString(localeStr) {
  let xIndex = localeStr.indexOf(`-x-`);
  xIndex !== -1 && (localeStr = localeStr.substring(0, xIndex));
  let uIndex = localeStr.indexOf(`-u-`);
  if (uIndex === -1) return [localeStr];
  {
    let options, selectedStr;
    try {
      options = getCachedDTF(localeStr).resolvedOptions(), selectedStr = localeStr;
    } catch {
      let smaller = localeStr.substring(0, uIndex);
      options = getCachedDTF(smaller).resolvedOptions(), selectedStr = smaller;
    }
    let { numberingSystem, calendar } = options;
    return [selectedStr, numberingSystem, calendar];
  }
}
function intlConfigString(localeStr, numberingSystem, outputCalendar) {
  return outputCalendar || numberingSystem ? (localeStr.includes(`-u-`) || (localeStr += `-u`), outputCalendar && (localeStr += `-ca-${outputCalendar}`), numberingSystem && (localeStr += `-nu-${numberingSystem}`), localeStr) : localeStr;
}
function mapMonths(f$32) {
  let ms = [];
  for (let i$4 = 1; i$4 <= 12; i$4++) {
    let dt = DateTime.utc(2009, i$4, 1);
    ms.push(f$32(dt));
  }
  return ms;
}
function mapWeekdays(f$32) {
  let ms = [];
  for (let i$4 = 1; i$4 <= 7; i$4++) {
    let dt = DateTime.utc(2016, 11, 13 + i$4);
    ms.push(f$32(dt));
  }
  return ms;
}
function listStuff(loc, length, englishFn, intlFn) {
  let mode = loc.listingMode();
  return mode === `error` ? null : mode === `en` ? englishFn(length) : intlFn(length);
}
function supportsFastNumbers(loc) {
  return loc.numberingSystem && loc.numberingSystem !== `latn` ? false : loc.numberingSystem === `latn` || !loc.locale || loc.locale.startsWith(`en`) || getCachedIntResolvedOptions(loc.locale).numberingSystem === `latn`;
}
var PolyNumberFormatter = class {
  constructor(intl, forceSimple, opts) {
    this.padTo = opts.padTo || 0, this.floor = opts.floor || false;
    let { padTo, floor: floor$1, ...otherOpts } = opts;
    if (!forceSimple || Object.keys(otherOpts).length > 0) {
      let intlOpts = { useGrouping: false, ...opts };
      opts.padTo > 0 && (intlOpts.minimumIntegerDigits = opts.padTo), this.inf = getCachedINF(intl, intlOpts);
    }
  }
  format(i$4) {
    if (this.inf) {
      let fixed = this.floor ? Math.floor(i$4) : i$4;
      return this.inf.format(fixed);
    } else {
      let fixed = this.floor ? Math.floor(i$4) : roundTo(i$4, 3);
      return padStart$2(fixed, this.padTo);
    }
  }
}, PolyDateFormatter = class {
  constructor(dt, intl, opts) {
    this.opts = opts, this.originalZone = void 0;
    let z$1;
    if (this.opts.timeZone) this.dt = dt;
    else if (dt.zone.type === `fixed`) {
      let gmtOffset = -1 * (dt.offset / 60), offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
      dt.offset !== 0 && IANAZone$2.create(offsetZ).valid ? (z$1 = offsetZ, this.dt = dt) : (z$1 = `UTC`, this.dt = dt.offset === 0 ? dt : dt.setZone(`UTC`).plus({ minutes: dt.offset }), this.originalZone = dt.zone);
    } else dt.zone.type === `system` ? this.dt = dt : dt.zone.type === `iana` ? (this.dt = dt, z$1 = dt.zone.name) : (z$1 = `UTC`, this.dt = dt.setZone(`UTC`).plus({ minutes: dt.offset }), this.originalZone = dt.zone);
    let intlOpts = { ...this.opts };
    intlOpts.timeZone = intlOpts.timeZone || z$1, this.dtf = getCachedDTF(intl, intlOpts);
  }
  format() {
    return this.originalZone ? this.formatToParts().map(({ value }) => value).join(``) : this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    let parts = this.dtf.formatToParts(this.dt.toJSDate());
    return this.originalZone ? parts.map((part) => {
      if (part.type === `timeZoneName`) {
        let offsetName = this.originalZone.offsetName(this.dt.ts, { locale: this.dt.locale, format: this.opts.timeZoneName });
        return { ...part, value: offsetName };
      } else return part;
    }) : parts;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}, PolyRelFormatter = class {
  constructor(intl, isEnglish, opts) {
    this.opts = { style: `long`, ...opts }, !isEnglish && hasRelative() && (this.rtf = getCachedRTF(intl, opts));
  }
  format(count, unit) {
    return this.rtf ? this.rtf.format(count, unit) : formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== `long`);
  }
  formatToParts(count, unit) {
    return this.rtf ? this.rtf.formatToParts(count, unit) : [];
  }
};
const fallbackWeekSettings = { firstDay: 1, minimalDays: 4, weekend: [6, 7] };
var Locale = class Locale3 {
  static fromOpts(opts) {
    return Locale3.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.weekSettings, opts.defaultToEN);
  }
  static create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN = false) {
    let specifiedLocale = locale || Settings.defaultLocale, localeR = specifiedLocale || (defaultToEN ? `en-US` : systemLocale()), numberingSystemR = numberingSystem || Settings.defaultNumberingSystem, outputCalendarR = outputCalendar || Settings.defaultOutputCalendar, weekSettingsR = validateWeekSettings(weekSettings) || Settings.defaultWeekSettings;
    return new Locale3(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
  }
  static resetCache() {
    sysLocaleCache = null, intlDTCache.clear(), intlNumCache.clear(), intlRelCache.clear(), intlResolvedOptionsCache.clear(), weekInfoCache.clear();
  }
  static fromObject({ locale, numberingSystem, outputCalendar, weekSettings } = {}) {
    return Locale3.create(locale, numberingSystem, outputCalendar, weekSettings);
  }
  constructor(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
    let [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = parseLocaleString(locale);
    this.locale = parsedLocale, this.numberingSystem = numbering || parsedNumberingSystem || null, this.outputCalendar = outputCalendar || parsedOutputCalendar || null, this.weekSettings = weekSettings, this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = specifiedLocale, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached ??= supportsFastNumbers(this), this.fastNumbersCached;
  }
  listingMode() {
    let isActuallyEn = this.isEnglish(), hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === `latn`) && (this.outputCalendar === null || this.outputCalendar === `gregory`);
    return isActuallyEn && hasNoWeirdness ? `en` : `intl`;
  }
  clone(alts) {
    return !alts || Object.getOwnPropertyNames(alts).length === 0 ? this : Locale3.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, validateWeekSettings(alts.weekSettings) || this.weekSettings, alts.defaultToEN || false);
  }
  redefaultToEN(alts = {}) {
    return this.clone({ ...alts, defaultToEN: true });
  }
  redefaultToSystem(alts = {}) {
    return this.clone({ ...alts, defaultToEN: false });
  }
  months(length, format = false) {
    return listStuff(this, length, months, () => {
      let monthSpecialCase = this.intl === `ja` || this.intl.startsWith(`ja-`);
      format &= !monthSpecialCase;
      let intl = format ? { month: length, day: `numeric` } : { month: length }, formatStr = format ? `format` : `standalone`;
      if (!this.monthsCache[formatStr][length]) {
        let mapper = monthSpecialCase ? (dt) => this.dtFormatter(dt, intl).format() : (dt) => this.extract(dt, intl, `month`);
        this.monthsCache[formatStr][length] = mapMonths(mapper);
      }
      return this.monthsCache[formatStr][length];
    });
  }
  weekdays(length, format = false) {
    return listStuff(this, length, weekdays, () => {
      let intl = format ? { weekday: length, year: `numeric`, month: `long`, day: `numeric` } : { weekday: length }, formatStr = format ? `format` : `standalone`;
      return this.weekdaysCache[formatStr][length] || (this.weekdaysCache[formatStr][length] = mapWeekdays((dt) => this.extract(dt, intl, `weekday`))), this.weekdaysCache[formatStr][length];
    });
  }
  meridiems() {
    return listStuff(this, void 0, () => meridiems, () => {
      if (!this.meridiemCache) {
        let intl = { hour: `numeric`, hourCycle: `h12` };
        this.meridiemCache = [DateTime.utc(2016, 11, 13, 9), DateTime.utc(2016, 11, 13, 19)].map((dt) => this.extract(dt, intl, `dayperiod`));
      }
      return this.meridiemCache;
    });
  }
  eras(length) {
    return listStuff(this, length, eras, () => {
      let intl = { era: length };
      return this.eraCache[length] || (this.eraCache[length] = [DateTime.utc(-40, 1, 1), DateTime.utc(2017, 1, 1)].map((dt) => this.extract(dt, intl, `era`))), this.eraCache[length];
    });
  }
  extract(dt, intlOpts, field) {
    let df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find((m$3) => m$3.type.toLowerCase() === field);
    return matching ? matching.value : null;
  }
  numberFormatter(opts = {}) {
    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
  }
  dtFormatter(dt, intlOpts = {}) {
    return new PolyDateFormatter(dt, this.intl, intlOpts);
  }
  relFormatter(opts = {}) {
    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
  }
  listFormatter(opts = {}) {
    return getCachedLF(this.intl, opts);
  }
  isEnglish() {
    return this.locale === `en` || this.locale.toLowerCase() === `en-us` || getCachedIntResolvedOptions(this.intl).locale.startsWith(`en-us`);
  }
  getWeekSettings() {
    return this.weekSettings ? this.weekSettings : hasLocaleWeekInfo() ? getCachedWeekInfo(this.locale) : fallbackWeekSettings;
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(other) {
    return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
};
let singleton$3 = null;
var FixedOffsetZone$2 = class FixedOffsetZone3 extends Zone$2 {
  static get utcInstance() {
    return singleton$3 === null && (singleton$3 = new FixedOffsetZone3(0)), singleton$3;
  }
  static instance(offset$2) {
    return offset$2 === 0 ? FixedOffsetZone3.utcInstance : new FixedOffsetZone3(offset$2);
  }
  static parseSpecifier(s$6) {
    if (s$6) {
      let r$2 = s$6.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r$2) return new FixedOffsetZone3(signedOffset$2(r$2[1], r$2[2]));
    }
    return null;
  }
  constructor(offset$2) {
    super(), this.fixed = offset$2;
  }
  get type() {
    return `fixed`;
  }
  get name() {
    return this.fixed === 0 ? `UTC` : `UTC${formatOffset$2(this.fixed, `narrow`)}`;
  }
  get ianaName() {
    return this.fixed === 0 ? `Etc/UTC` : `Etc/GMT${formatOffset$2(-this.fixed, `narrow`)}`;
  }
  offsetName() {
    return this.name;
  }
  formatOffset(ts, format) {
    return formatOffset$2(this.fixed, format);
  }
  get isUniversal() {
    return true;
  }
  offset() {
    return this.fixed;
  }
  equals(otherZone) {
    return otherZone.type === `fixed` && otherZone.fixed === this.fixed;
  }
  get isValid() {
    return true;
  }
}, InvalidZone = class extends Zone$2 {
  constructor(zoneName) {
    super(), this.zoneName = zoneName;
  }
  get type() {
    return `invalid`;
  }
  get name() {
    return this.zoneName;
  }
  get isUniversal() {
    return false;
  }
  offsetName() {
    return null;
  }
  formatOffset() {
    return ``;
  }
  offset() {
    return NaN;
  }
  equals() {
    return false;
  }
  get isValid() {
    return false;
  }
};
function normalizeZone(input, defaultZone$2) {
  if (isUndefined$2(input) || input === null) return defaultZone$2;
  if (input instanceof Zone$2) return input;
  if (isString(input)) {
    let lowered = input.toLowerCase();
    return lowered === `default` ? defaultZone$2 : lowered === `local` || lowered === `system` ? SystemZone.instance : lowered === `utc` || lowered === `gmt` ? FixedOffsetZone$2.utcInstance : FixedOffsetZone$2.parseSpecifier(lowered) || IANAZone$2.create(input);
  } else if (isNumber$1(input)) return FixedOffsetZone$2.instance(input);
  else if (typeof input == `object` && `offset` in input && typeof input.offset == `function`) return input;
  else return new InvalidZone(input);
}
const numberingSystems$1 = { arab: `[٠-٩]`, arabext: `[۰-۹]`, bali: `[᭐-᭙]`, beng: `[০-৯]`, deva: `[०-९]`, fullwide: `[０-９]`, gujr: `[૦-૯]`, hanidec: `[〇|一|二|三|四|五|六|七|八|九]`, khmr: `[០-៩]`, knda: `[೦-೯]`, laoo: `[໐-໙]`, limb: `[᥆-᥏]`, mlym: `[൦-൯]`, mong: `[᠐-᠙]`, mymr: `[၀-၉]`, orya: `[୦-୯]`, tamldec: `[௦-௯]`, telu: `[౦-౯]`, thai: `[๐-๙]`, tibt: `[༠-༩]`, latn: `\\d` }, numberingSystemsUTF16 = { arab: [1632, 1641], arabext: [1776, 1785], bali: [6992, 7001], beng: [2534, 2543], deva: [2406, 2415], fullwide: [65296, 65303], gujr: [2790, 2799], khmr: [6112, 6121], knda: [3302, 3311], laoo: [3792, 3801], limb: [6470, 6479], mlym: [3430, 3439], mong: [6160, 6169], mymr: [4160, 4169], orya: [2918, 2927], tamldec: [3046, 3055], telu: [3174, 3183], thai: [3664, 3673], tibt: [3872, 3881] }, hanidecChars = numberingSystems$1.hanidec.replace(/[\[|\]]/g, ``).split(``);
function parseDigits(str) {
  let value = parseInt(str, 10);
  if (isNaN(value)) {
    value = ``;
    for (let i$4 = 0; i$4 < str.length; i$4++) {
      let code$2 = str.charCodeAt(i$4);
      if (str[i$4].search(numberingSystems$1.hanidec) !== -1) value += hanidecChars.indexOf(str[i$4]);
      else for (let key in numberingSystemsUTF16) {
        let [min$1, max$3] = numberingSystemsUTF16[key];
        code$2 >= min$1 && code$2 <= max$3 && (value += code$2 - min$1);
      }
    }
    return parseInt(value, 10);
  } else return value;
}
const digitRegexCache = /* @__PURE__ */ new Map();
function resetDigitRegexCache() {
  digitRegexCache.clear();
}
function digitRegex({ numberingSystem }, append = ``) {
  let ns = numberingSystem || `latn`, appendCache = digitRegexCache.get(ns);
  appendCache === void 0 && (appendCache = /* @__PURE__ */ new Map(), digitRegexCache.set(ns, appendCache));
  let regex = appendCache.get(append);
  return regex === void 0 && (regex = RegExp(`${numberingSystems$1[ns]}${append}`), appendCache.set(append, regex)), regex;
}
let now = () => Date.now(), defaultZone = `system`, defaultLocale = null, defaultNumberingSystem = null, defaultOutputCalendar = null, twoDigitCutoffYear = 60, throwOnInvalid, defaultWeekSettings = null;
var Settings = class {
  static get now() {
    return now;
  }
  static set now(n$4) {
    now = n$4;
  }
  static set defaultZone(zone) {
    defaultZone = zone;
  }
  static get defaultZone() {
    return normalizeZone(defaultZone, SystemZone.instance);
  }
  static get defaultLocale() {
    return defaultLocale;
  }
  static set defaultLocale(locale) {
    defaultLocale = locale;
  }
  static get defaultNumberingSystem() {
    return defaultNumberingSystem;
  }
  static set defaultNumberingSystem(numberingSystem) {
    defaultNumberingSystem = numberingSystem;
  }
  static get defaultOutputCalendar() {
    return defaultOutputCalendar;
  }
  static set defaultOutputCalendar(outputCalendar) {
    defaultOutputCalendar = outputCalendar;
  }
  static get defaultWeekSettings() {
    return defaultWeekSettings;
  }
  static set defaultWeekSettings(weekSettings) {
    defaultWeekSettings = validateWeekSettings(weekSettings);
  }
  static get twoDigitCutoffYear() {
    return twoDigitCutoffYear;
  }
  static set twoDigitCutoffYear(cutoffYear) {
    twoDigitCutoffYear = cutoffYear % 100;
  }
  static get throwOnInvalid() {
    return throwOnInvalid;
  }
  static set throwOnInvalid(t$7) {
    throwOnInvalid = t$7;
  }
  static resetCaches() {
    Locale.resetCache(), IANAZone$2.resetCache(), DateTime.resetCache(), resetDigitRegexCache();
  }
}, Invalid = class {
  constructor(reason, explanation) {
    this.reason = reason, this.explanation = explanation;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
};
const nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function unitOutOfRange(unit, value) {
  return new Invalid(`unit out of range`, `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`);
}
function dayOfWeek(year, month, day) {
  let d$12 = new Date(Date.UTC(year, month - 1, day));
  year < 100 && year >= 0 && d$12.setUTCFullYear(d$12.getUTCFullYear() - 1900);
  let js = d$12.getUTCDay();
  return js === 0 ? 7 : js;
}
function computeOrdinal(year, month, day) {
  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}
function uncomputeOrdinal(year, ordinal) {
  let table$2 = isLeapYear(year) ? leapLadder : nonLeapLadder, month0 = table$2.findIndex((i$4) => i$4 < ordinal), day = ordinal - table$2[month0];
  return { month: month0 + 1, day };
}
function isoWeekdayToLocal(isoWeekday, startOfWeek) {
  return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
function gregorianToWeek(gregObj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  let { year, month, day } = gregObj, ordinal = computeOrdinal(year, month, day), weekday = isoWeekdayToLocal(dayOfWeek(year, month, day), startOfWeek), weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
  return weekNumber < 1 ? (weekYear = year - 1, weekNumber = weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek)) : weekNumber > weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek) ? (weekYear = year + 1, weekNumber = 1) : weekYear = year, { weekYear, weekNumber, weekday, ...timeObject(gregObj) };
}
function weekToGregorian(weekData, minDaysInFirstWeek = 4, startOfWeek = 1) {
  let { weekYear, weekNumber, weekday } = weekData, weekdayOfJan4 = isoWeekdayToLocal(dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = daysInYear(weekYear), ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
  ordinal < 1 ? (year = weekYear - 1, ordinal += daysInYear(year)) : ordinal > yearInDays ? (year = weekYear + 1, ordinal -= daysInYear(weekYear)) : year = weekYear;
  let { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...timeObject(weekData) };
}
function gregorianToOrdinal(gregData) {
  let { year, month, day } = gregData, ordinal = computeOrdinal(year, month, day);
  return { year, ordinal, ...timeObject(gregData) };
}
function ordinalToGregorian(ordinalData) {
  let { year, ordinal } = ordinalData, { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...timeObject(ordinalData) };
}
function usesLocalWeekValues(obj, loc) {
  let hasLocaleWeekData = !isUndefined$2(obj.localWeekday) || !isUndefined$2(obj.localWeekNumber) || !isUndefined$2(obj.localWeekYear);
  if (hasLocaleWeekData) {
    let hasIsoWeekData = !isUndefined$2(obj.weekday) || !isUndefined$2(obj.weekNumber) || !isUndefined$2(obj.weekYear);
    if (hasIsoWeekData) throw new ConflictingSpecificationError(`Cannot mix locale-based week fields with ISO-based week fields`);
    return isUndefined$2(obj.localWeekday) || (obj.weekday = obj.localWeekday), isUndefined$2(obj.localWeekNumber) || (obj.weekNumber = obj.localWeekNumber), isUndefined$2(obj.localWeekYear) || (obj.weekYear = obj.localWeekYear), delete obj.localWeekday, delete obj.localWeekNumber, delete obj.localWeekYear, { minDaysInFirstWeek: loc.getMinDaysInFirstWeek(), startOfWeek: loc.getStartOfWeek() };
  } else return { minDaysInFirstWeek: 4, startOfWeek: 1 };
}
function hasInvalidWeekData(obj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  let validYear = isInteger(obj.weekYear), validWeek = integerBetween(obj.weekNumber, 1, weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)), validWeekday = integerBetween(obj.weekday, 1, 7);
  return validYear ? validWeek ? validWeekday ? false : unitOutOfRange(`weekday`, obj.weekday) : unitOutOfRange(`week`, obj.weekNumber) : unitOutOfRange(`weekYear`, obj.weekYear);
}
function hasInvalidOrdinalData(obj) {
  let validYear = isInteger(obj.year), validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));
  return validYear ? validOrdinal ? false : unitOutOfRange(`ordinal`, obj.ordinal) : unitOutOfRange(`year`, obj.year);
}
function hasInvalidGregorianData(obj) {
  let validYear = isInteger(obj.year), validMonth = integerBetween(obj.month, 1, 12), validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));
  return validYear ? validMonth ? validDay ? false : unitOutOfRange(`day`, obj.day) : unitOutOfRange(`month`, obj.month) : unitOutOfRange(`year`, obj.year);
}
function hasInvalidTimeData(obj) {
  let { hour, minute, second, millisecond } = obj, validHour = integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = integerBetween(minute, 0, 59), validSecond = integerBetween(second, 0, 59), validMillisecond = integerBetween(millisecond, 0, 999);
  return validHour ? validMinute ? validSecond ? validMillisecond ? false : unitOutOfRange(`millisecond`, millisecond) : unitOutOfRange(`second`, second) : unitOutOfRange(`minute`, minute) : unitOutOfRange(`hour`, hour);
}
function isUndefined$2(o$2) {
  return o$2 === void 0;
}
function isNumber$1(o$2) {
  return typeof o$2 == `number`;
}
function isInteger(o$2) {
  return typeof o$2 == `number` && o$2 % 1 == 0;
}
function isString(o$2) {
  return typeof o$2 == `string`;
}
function isDate(o$2) {
  return Object.prototype.toString.call(o$2) === `[object Date]`;
}
function hasRelative() {
  try {
    return typeof Intl < `u` && !!Intl.RelativeTimeFormat;
  } catch {
    return false;
  }
}
function hasLocaleWeekInfo() {
  try {
    return typeof Intl < `u` && !!Intl.Locale && (`weekInfo` in Intl.Locale.prototype || `getWeekInfo` in Intl.Locale.prototype);
  } catch {
    return false;
  }
}
function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [thing];
}
function bestBy(arr, by, compare$16) {
  if (arr.length !== 0) return arr.reduce((best, next) => {
    let pair = [by(next), next];
    return best && compare$16(best[0], pair[0]) === best[0] ? best : pair;
  }, null)[1];
}
function pick(obj, keys$10) {
  return keys$10.reduce((a$22, k) => (a$22[k] = obj[k], a$22), {});
}
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
function validateWeekSettings(settings) {
  if (settings == null) return null;
  if (typeof settings != `object`) throw new InvalidArgumentError(`Week settings must be an object`);
  if (!integerBetween(settings.firstDay, 1, 7) || !integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some((v$1) => !integerBetween(v$1, 1, 7))) throw new InvalidArgumentError(`Invalid week settings`);
  return { firstDay: settings.firstDay, minimalDays: settings.minimalDays, weekend: Array.from(settings.weekend) };
}
function integerBetween(thing, bottom, top) {
  return isInteger(thing) && thing >= bottom && thing <= top;
}
function floorMod(x$1, n$4) {
  return x$1 - n$4 * Math.floor(x$1 / n$4);
}
function padStart$2(input, n$4 = 2) {
  let isNeg = input < 0, padded;
  return padded = isNeg ? `-` + (`` + -input).padStart(n$4, `0`) : (`` + input).padStart(n$4, `0`), padded;
}
function parseInteger$2(string) {
  if (!(isUndefined$2(string) || string === null || string === ``)) return parseInt(string, 10);
}
function parseFloating(string) {
  if (!(isUndefined$2(string) || string === null || string === ``)) return parseFloat(string);
}
function parseMillis$2(fraction) {
  if (!(isUndefined$2(fraction) || fraction === null || fraction === ``)) {
    let f$32 = parseFloat(`0.` + fraction) * 1e3;
    return Math.floor(f$32);
  }
}
function roundTo(number, digits, rounding = `round`) {
  let factor = 10 ** digits;
  switch (rounding) {
    case `expand`:
      return number > 0 ? Math.ceil(number * factor) / factor : Math.floor(number * factor) / factor;
    case `trunc`:
      return Math.trunc(number * factor) / factor;
    case `round`:
      return Math.round(number * factor) / factor;
    case `floor`:
      return Math.floor(number * factor) / factor;
    case `ceil`:
      return Math.ceil(number * factor) / factor;
    default:
      throw RangeError(`Value rounding ${rounding} is out of range`);
  }
}
function isLeapYear(year) {
  return year % 4 == 0 && (year % 100 != 0 || year % 400 == 0);
}
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
function daysInMonth(year, month) {
  let modMonth = floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
  return modMonth === 2 ? isLeapYear(modYear) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
}
function objToLocalTS$2(obj) {
  let d$12 = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
  return obj.year < 100 && obj.year >= 0 && (d$12 = new Date(d$12), d$12.setUTCFullYear(obj.year, obj.month - 1, obj.day)), +d$12;
}
function firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
  let fwdlw = isoWeekdayToLocal(dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
  return -fwdlw + minDaysInFirstWeek - 1;
}
function weeksInWeekYear(weekYear, minDaysInFirstWeek = 4, startOfWeek = 1) {
  let weekOffset = firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek), weekOffsetNext = firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
  return (daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function untruncateYear(year) {
  return year > 99 ? year : year > Settings.twoDigitCutoffYear ? 1900 + year : 2e3 + year;
}
function parseZoneInfo$2(ts, offsetFormat, locale, timeZone = null) {
  let date = new Date(ts), intlOpts = { hourCycle: `h23`, year: `numeric`, month: `2-digit`, day: `2-digit`, hour: `2-digit`, minute: `2-digit` };
  timeZone && (intlOpts.timeZone = timeZone);
  let modified = { timeZoneName: offsetFormat, ...intlOpts }, parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find((m$3) => m$3.type.toLowerCase() === `timezonename`);
  return parsed ? parsed.value : null;
}
function signedOffset$2(offHourStr, offMinuteStr) {
  let offHour = parseInt(offHourStr, 10);
  Number.isNaN(offHour) && (offHour = 0);
  let offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
}
function asNumber(value) {
  let numericValue = Number(value);
  if (typeof value == `boolean` || value === `` || !Number.isFinite(numericValue)) throw new InvalidArgumentError(`Invalid unit value ${value}`);
  return numericValue;
}
function normalizeObject(obj, normalizer) {
  let normalized = {};
  for (let u in obj) if (hasOwnProperty(obj, u)) {
    let v$1 = obj[u];
    if (v$1 == null) continue;
    normalized[normalizer(u)] = asNumber(v$1);
  }
  return normalized;
}
function formatOffset$2(offset$2, format) {
  let hours = Math.trunc(Math.abs(offset$2 / 60)), minutes = Math.trunc(Math.abs(offset$2 % 60)), sign$2 = offset$2 >= 0 ? `+` : `-`;
  switch (format) {
    case `short`:
      return `${sign$2}${padStart$2(hours, 2)}:${padStart$2(minutes, 2)}`;
    case `narrow`:
      return `${sign$2}${hours}${minutes > 0 ? `:${minutes}` : ``}`;
    case `techie`:
      return `${sign$2}${padStart$2(hours, 2)}${padStart$2(minutes, 2)}`;
    default:
      throw RangeError(`Value format ${format} is out of range for property format`);
  }
}
function timeObject(obj) {
  return pick(obj, [`hour`, `minute`, `second`, `millisecond`]);
}
const monthsLong = [`January`, `February`, `March`, `April`, `May`, `June`, `July`, `August`, `September`, `October`, `November`, `December`], monthsShort = [`Jan`, `Feb`, `Mar`, `Apr`, `May`, `Jun`, `Jul`, `Aug`, `Sep`, `Oct`, `Nov`, `Dec`], monthsNarrow = [`J`, `F`, `M`, `A`, `M`, `J`, `J`, `A`, `S`, `O`, `N`, `D`];
function months(length) {
  switch (length) {
    case `narrow`:
      return [...monthsNarrow];
    case `short`:
      return [...monthsShort];
    case `long`:
      return [...monthsLong];
    case `numeric`:
      return [`1`, `2`, `3`, `4`, `5`, `6`, `7`, `8`, `9`, `10`, `11`, `12`];
    case `2-digit`:
      return [`01`, `02`, `03`, `04`, `05`, `06`, `07`, `08`, `09`, `10`, `11`, `12`];
    default:
      return null;
  }
}
const weekdaysLong = [`Monday`, `Tuesday`, `Wednesday`, `Thursday`, `Friday`, `Saturday`, `Sunday`], weekdaysShort = [`Mon`, `Tue`, `Wed`, `Thu`, `Fri`, `Sat`, `Sun`], weekdaysNarrow = [`M`, `T`, `W`, `T`, `F`, `S`, `S`];
function weekdays(length) {
  switch (length) {
    case `narrow`:
      return [...weekdaysNarrow];
    case `short`:
      return [...weekdaysShort];
    case `long`:
      return [...weekdaysLong];
    case `numeric`:
      return [`1`, `2`, `3`, `4`, `5`, `6`, `7`];
    default:
      return null;
  }
}
const meridiems = [`AM`, `PM`], erasLong = [`Before Christ`, `Anno Domini`], erasShort = [`BC`, `AD`], erasNarrow = [`B`, `A`];
function eras(length) {
  switch (length) {
    case `narrow`:
      return [...erasNarrow];
    case `short`:
      return [...erasShort];
    case `long`:
      return [...erasLong];
    default:
      return null;
  }
}
function meridiemForDateTime(dt) {
  return meridiems[dt.hour < 12 ? 0 : 1];
}
function weekdayForDateTime(dt, length) {
  return weekdays(length)[dt.weekday - 1];
}
function monthForDateTime(dt, length) {
  return months(length)[dt.month - 1];
}
function eraForDateTime(dt, length) {
  return eras(length)[dt.year < 0 ? 0 : 1];
}
function formatRelativeTime(unit, count, numeric$1 = `always`, narrow = false) {
  let units = { years: [`year`, `yr.`], quarters: [`quarter`, `qtr.`], months: [`month`, `mo.`], weeks: [`week`, `wk.`], days: [`day`, `day`, `days`], hours: [`hour`, `hr.`], minutes: [`minute`, `min.`], seconds: [`second`, `sec.`] }, lastable = [`hours`, `minutes`, `seconds`].indexOf(unit) === -1;
  if (numeric$1 === `auto` && lastable) {
    let isDay = unit === `days`;
    switch (count) {
      case 1:
        return isDay ? `tomorrow` : `next ${units[unit][0]}`;
      case -1:
        return isDay ? `yesterday` : `last ${units[unit][0]}`;
      case 0:
        return isDay ? `today` : `this ${units[unit][0]}`;
    }
  }
  let isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
  return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}
function stringifyTokens(splits, tokenToString) {
  let s$6 = ``;
  for (let token of splits) token.literal ? s$6 += token.val : s$6 += tokenToString(token.val);
  return s$6;
}
const macroTokenToFormatOpts = { D: DATE_SHORT, DD: DATE_MED, DDD: DATE_FULL, DDDD: DATE_HUGE, t: TIME_SIMPLE, tt: TIME_WITH_SECONDS, ttt: TIME_WITH_SHORT_OFFSET, tttt: TIME_WITH_LONG_OFFSET, T: TIME_24_SIMPLE, TT: TIME_24_WITH_SECONDS, TTT: TIME_24_WITH_SHORT_OFFSET, TTTT: TIME_24_WITH_LONG_OFFSET, f: DATETIME_SHORT, ff: DATETIME_MED, fff: DATETIME_FULL, ffff: DATETIME_HUGE, F: DATETIME_SHORT_WITH_SECONDS, FF: DATETIME_MED_WITH_SECONDS, FFF: DATETIME_FULL_WITH_SECONDS, FFFF: DATETIME_HUGE_WITH_SECONDS };
var Formatter = class Formatter3 {
  static create(locale, opts = {}) {
    return new Formatter3(locale, opts);
  }
  static parseFormat(fmt) {
    let current = null, currentFull = ``, bracketed = false, splits = [];
    for (let i$4 = 0; i$4 < fmt.length; i$4++) {
      let c$12 = fmt.charAt(i$4);
      c$12 === `'` ? ((currentFull.length > 0 || bracketed) && splits.push({ literal: bracketed || /^\s+$/.test(currentFull), val: currentFull === `` ? `'` : currentFull }), current = null, currentFull = ``, bracketed = !bracketed) : bracketed || c$12 === current ? currentFull += c$12 : (currentFull.length > 0 && splits.push({ literal: /^\s+$/.test(currentFull), val: currentFull }), currentFull = c$12, current = c$12);
    }
    return currentFull.length > 0 && splits.push({ literal: bracketed || /^\s+$/.test(currentFull), val: currentFull }), splits;
  }
  static macroTokenToFormatOpts(token) {
    return macroTokenToFormatOpts[token];
  }
  constructor(locale, formatOpts) {
    this.opts = formatOpts, this.loc = locale, this.systemLoc = null;
  }
  formatWithSystemDefault(dt, opts) {
    this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem());
    let df = this.systemLoc.dtFormatter(dt, { ...this.opts, ...opts });
    return df.format();
  }
  dtFormatter(dt, opts = {}) {
    return this.loc.dtFormatter(dt, { ...this.opts, ...opts });
  }
  formatDateTime(dt, opts) {
    return this.dtFormatter(dt, opts).format();
  }
  formatDateTimeParts(dt, opts) {
    return this.dtFormatter(dt, opts).formatToParts();
  }
  formatInterval(interval, opts) {
    let df = this.dtFormatter(interval.start, opts);
    return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
  }
  resolvedOptions(dt, opts) {
    return this.dtFormatter(dt, opts).resolvedOptions();
  }
  num(n$4, p$1 = 0, signDisplay = void 0) {
    if (this.opts.forceSimple) return padStart$2(n$4, p$1);
    let opts = { ...this.opts };
    return p$1 > 0 && (opts.padTo = p$1), signDisplay && (opts.signDisplay = signDisplay), this.loc.numberFormatter(opts).format(n$4);
  }
  formatDateTimeFromString(dt, fmt) {
    let knownEnglish = this.loc.listingMode() === `en`, useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== `gregory`, string = (opts, extract) => this.loc.extract(dt, opts, extract), formatOffset$22 = (opts) => dt.isOffsetFixed && dt.offset === 0 && opts.allowZ ? `Z` : dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : ``, meridiem = () => knownEnglish ? meridiemForDateTime(dt) : string({ hour: `numeric`, hourCycle: `h12` }, `dayperiod`), month = (length, standalone) => knownEnglish ? monthForDateTime(dt, length) : string(standalone ? { month: length } : { month: length, day: `numeric` }, `month`), weekday = (length, standalone) => knownEnglish ? weekdayForDateTime(dt, length) : string(standalone ? { weekday: length } : { weekday: length, month: `long`, day: `numeric` }, `weekday`), maybeMacro = (token) => {
      let formatOpts = Formatter3.macroTokenToFormatOpts(token);
      return formatOpts ? this.formatWithSystemDefault(dt, formatOpts) : token;
    }, era = (length) => knownEnglish ? eraForDateTime(dt, length) : string({ era: length }, `era`), tokenToString = (token) => {
      switch (token) {
        case `S`:
          return this.num(dt.millisecond);
        case `u`:
        case `SSS`:
          return this.num(dt.millisecond, 3);
        case `s`:
          return this.num(dt.second);
        case `ss`:
          return this.num(dt.second, 2);
        case `uu`:
          return this.num(Math.floor(dt.millisecond / 10), 2);
        case `uuu`:
          return this.num(Math.floor(dt.millisecond / 100));
        case `m`:
          return this.num(dt.minute);
        case `mm`:
          return this.num(dt.minute, 2);
        case `h`:
          return this.num(dt.hour % 12 == 0 ? 12 : dt.hour % 12);
        case `hh`:
          return this.num(dt.hour % 12 == 0 ? 12 : dt.hour % 12, 2);
        case `H`:
          return this.num(dt.hour);
        case `HH`:
          return this.num(dt.hour, 2);
        case `Z`:
          return formatOffset$22({ format: `narrow`, allowZ: this.opts.allowZ });
        case `ZZ`:
          return formatOffset$22({ format: `short`, allowZ: this.opts.allowZ });
        case `ZZZ`:
          return formatOffset$22({ format: `techie`, allowZ: this.opts.allowZ });
        case `ZZZZ`:
          return dt.zone.offsetName(dt.ts, { format: `short`, locale: this.loc.locale });
        case `ZZZZZ`:
          return dt.zone.offsetName(dt.ts, { format: `long`, locale: this.loc.locale });
        case `z`:
          return dt.zoneName;
        case `a`:
          return meridiem();
        case `d`:
          return useDateTimeFormatter ? string({ day: `numeric` }, `day`) : this.num(dt.day);
        case `dd`:
          return useDateTimeFormatter ? string({ day: `2-digit` }, `day`) : this.num(dt.day, 2);
        case `c`:
          return this.num(dt.weekday);
        case `ccc`:
          return weekday(`short`, true);
        case `cccc`:
          return weekday(`long`, true);
        case `ccccc`:
          return weekday(`narrow`, true);
        case `E`:
          return this.num(dt.weekday);
        case `EEE`:
          return weekday(`short`, false);
        case `EEEE`:
          return weekday(`long`, false);
        case `EEEEE`:
          return weekday(`narrow`, false);
        case `L`:
          return useDateTimeFormatter ? string({ month: `numeric`, day: `numeric` }, `month`) : this.num(dt.month);
        case `LL`:
          return useDateTimeFormatter ? string({ month: `2-digit`, day: `numeric` }, `month`) : this.num(dt.month, 2);
        case `LLL`:
          return month(`short`, true);
        case `LLLL`:
          return month(`long`, true);
        case `LLLLL`:
          return month(`narrow`, true);
        case `M`:
          return useDateTimeFormatter ? string({ month: `numeric` }, `month`) : this.num(dt.month);
        case `MM`:
          return useDateTimeFormatter ? string({ month: `2-digit` }, `month`) : this.num(dt.month, 2);
        case `MMM`:
          return month(`short`, false);
        case `MMMM`:
          return month(`long`, false);
        case `MMMMM`:
          return month(`narrow`, false);
        case `y`:
          return useDateTimeFormatter ? string({ year: `numeric` }, `year`) : this.num(dt.year);
        case `yy`:
          return useDateTimeFormatter ? string({ year: `2-digit` }, `year`) : this.num(dt.year.toString().slice(-2), 2);
        case `yyyy`:
          return useDateTimeFormatter ? string({ year: `numeric` }, `year`) : this.num(dt.year, 4);
        case `yyyyyy`:
          return useDateTimeFormatter ? string({ year: `numeric` }, `year`) : this.num(dt.year, 6);
        case `G`:
          return era(`short`);
        case `GG`:
          return era(`long`);
        case `GGGGG`:
          return era(`narrow`);
        case `kk`:
          return this.num(dt.weekYear.toString().slice(-2), 2);
        case `kkkk`:
          return this.num(dt.weekYear, 4);
        case `W`:
          return this.num(dt.weekNumber);
        case `WW`:
          return this.num(dt.weekNumber, 2);
        case `n`:
          return this.num(dt.localWeekNumber);
        case `nn`:
          return this.num(dt.localWeekNumber, 2);
        case `ii`:
          return this.num(dt.localWeekYear.toString().slice(-2), 2);
        case `iiii`:
          return this.num(dt.localWeekYear, 4);
        case `o`:
          return this.num(dt.ordinal);
        case `ooo`:
          return this.num(dt.ordinal, 3);
        case `q`:
          return this.num(dt.quarter);
        case `qq`:
          return this.num(dt.quarter, 2);
        case `X`:
          return this.num(Math.floor(dt.ts / 1e3));
        case `x`:
          return this.num(dt.ts);
        default:
          return maybeMacro(token);
      }
    };
    return stringifyTokens(Formatter3.parseFormat(fmt), tokenToString);
  }
  formatDurationFromString(dur, fmt) {
    let invertLargest = this.opts.signMode === `negativeLargestOnly` ? -1 : 1, tokenToField = (token) => {
      switch (token[0]) {
        case `S`:
          return `milliseconds`;
        case `s`:
          return `seconds`;
        case `m`:
          return `minutes`;
        case `h`:
          return `hours`;
        case `d`:
          return `days`;
        case `w`:
          return `weeks`;
        case `M`:
          return `months`;
        case `y`:
          return `years`;
        default:
          return null;
      }
    }, tokenToString = (lildur, info) => (token) => {
      let mapped = tokenToField(token);
      if (mapped) {
        let inversionFactor = info.isNegativeDuration && mapped !== info.largestUnit ? invertLargest : 1, signDisplay;
        return signDisplay = this.opts.signMode === `negativeLargestOnly` && mapped !== info.largestUnit ? `never` : this.opts.signMode === `all` ? `always` : `auto`, this.num(lildur.get(mapped) * inversionFactor, token.length, signDisplay);
      } else return token;
    }, tokens = Formatter3.parseFormat(fmt), realTokens = tokens.reduce((found, { literal, val }) => literal ? found : found.concat(val), []), collapsed = dur.shiftTo(...realTokens.map(tokenToField).filter((t$7) => t$7)), durationInfo = { isNegativeDuration: collapsed < 0, largestUnit: Object.keys(collapsed.values)[0] };
    return stringifyTokens(tokens, tokenToString(collapsed, durationInfo));
  }
};
const ianaRegex$2 = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function combineRegexes$2(...regexes) {
  let full = regexes.reduce((f$32, r$2) => f$32 + r$2.source, ``);
  return RegExp(`^${full}$`);
}
function combineExtractors$2(...extractors) {
  return (m$3) => extractors.reduce(([mergedVals, mergedZone, cursor], ex) => {
    let [val, zone, next] = ex(m$3, cursor);
    return [{ ...mergedVals, ...val }, zone || mergedZone, next];
  }, [{}, null, 1]).slice(0, 2);
}
function parse$7(s$6, ...patterns) {
  if (s$6 == null) return [null, null];
  for (let [regex, extractor] of patterns) {
    let m$3 = regex.exec(s$6);
    if (m$3) return extractor(m$3);
  }
  return [null, null];
}
function simpleParse$2(...keys$10) {
  return (match$2, cursor) => {
    let ret = {}, i$4;
    for (i$4 = 0; i$4 < keys$10.length; i$4++) ret[keys$10[i$4]] = parseInteger$2(match$2[cursor + i$4]);
    return [ret, null, cursor + i$4];
  };
}
const offsetRegex$2 = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/, isoExtendedZone$2 = `(?:${offsetRegex$2.source}?(?:\\[(${ianaRegex$2.source})\\])?)?`, isoTimeBaseRegex$2 = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, isoTimeRegex$2 = RegExp(`${isoTimeBaseRegex$2.source}${isoExtendedZone$2}`), isoTimeExtensionRegex$2 = RegExp(`(?:[Tt]${isoTimeRegex$2.source})?`), isoYmdRegex$2 = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, isoWeekRegex$2 = /(\d{4})-?W(\d\d)(?:-?(\d))?/, isoOrdinalRegex$2 = /(\d{4})-?(\d{3})/, extractISOWeekData$2 = simpleParse$2(`weekYear`, `weekNumber`, `weekDay`), extractISOOrdinalData$2 = simpleParse$2(`year`, `ordinal`), sqlYmdRegex$2 = /(\d{4})-(\d\d)-(\d\d)/, sqlTimeRegex$2 = RegExp(`${isoTimeBaseRegex$2.source} ?(?:${offsetRegex$2.source}|(${ianaRegex$2.source}))?`), sqlTimeExtensionRegex$2 = RegExp(`(?: ${sqlTimeRegex$2.source})?`);
function int$2(match$2, pos, fallback) {
  let m$3 = match$2[pos];
  return isUndefined$2(m$3) ? fallback : parseInteger$2(m$3);
}
function extractISOYmd$2(match$2, cursor) {
  let item = { year: int$2(match$2, cursor), month: int$2(match$2, cursor + 1, 1), day: int$2(match$2, cursor + 2, 1) };
  return [item, null, cursor + 3];
}
function extractISOTime$2(match$2, cursor) {
  let item = { hours: int$2(match$2, cursor, 0), minutes: int$2(match$2, cursor + 1, 0), seconds: int$2(match$2, cursor + 2, 0), milliseconds: parseMillis$2(match$2[cursor + 3]) };
  return [item, null, cursor + 4];
}
function extractISOOffset$2(match$2, cursor) {
  let local = !match$2[cursor] && !match$2[cursor + 1], fullOffset = signedOffset$2(match$2[cursor + 1], match$2[cursor + 2]), zone = local ? null : FixedOffsetZone$2.instance(fullOffset);
  return [{}, zone, cursor + 3];
}
function extractIANAZone$2(match$2, cursor) {
  let zone = match$2[cursor] ? IANAZone$2.create(match$2[cursor]) : null;
  return [{}, zone, cursor + 1];
}
const isoTimeOnly = RegExp(`^T?${isoTimeBaseRegex$2.source}$`), isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function extractISODuration(match$2) {
  let [s$6, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] = match$2, hasNegativePrefix = s$6[0] === `-`, negativeSeconds = secondStr && secondStr[0] === `-`, maybeNegate = (num, force = false) => num !== void 0 && (force || num && hasNegativePrefix) ? -num : num;
  return [{ years: maybeNegate(parseFloating(yearStr)), months: maybeNegate(parseFloating(monthStr)), weeks: maybeNegate(parseFloating(weekStr)), days: maybeNegate(parseFloating(dayStr)), hours: maybeNegate(parseFloating(hourStr)), minutes: maybeNegate(parseFloating(minuteStr)), seconds: maybeNegate(parseFloating(secondStr), secondStr === `-0`), milliseconds: maybeNegate(parseMillis$2(millisecondsStr), negativeSeconds) }];
}
const obsOffsets = { GMT: 0, EDT: -4 * 60, EST: -5 * 60, CDT: -5 * 60, CST: -6 * 60, MDT: -6 * 60, MST: -7 * 60, PDT: -7 * 60, PST: -8 * 60 };
function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  let result = { year: yearStr.length === 2 ? untruncateYear(parseInteger$2(yearStr)) : parseInteger$2(yearStr), month: monthsShort.indexOf(monthStr) + 1, day: parseInteger$2(dayStr), hour: parseInteger$2(hourStr), minute: parseInteger$2(minuteStr) };
  return secondStr && (result.second = parseInteger$2(secondStr)), weekdayStr && (result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1), result;
}
const rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function extractRFC2822(match$2) {
  let [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr, obsOffset, milOffset, offHourStr, offMinuteStr] = match$2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr), offset$2;
  return offset$2 = obsOffset ? obsOffsets[obsOffset] : milOffset ? 0 : signedOffset$2(offHourStr, offMinuteStr), [result, new FixedOffsetZone$2(offset$2)];
}
function preprocessRFC2822(s$6) {
  return s$6.replace(/\([^()]*\)|[\n\t]/g, ` `).replace(/(\s\s+)/g, ` `).trim();
}
const rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function extractRFC1123Or850(match$2) {
  let [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match$2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone$2.utcInstance];
}
function extractASCII(match$2) {
  let [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match$2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone$2.utcInstance];
}
const isoYmdWithTimeExtensionRegex = combineRegexes$2(isoYmdRegex$2, isoTimeExtensionRegex$2), isoWeekWithTimeExtensionRegex = combineRegexes$2(isoWeekRegex$2, isoTimeExtensionRegex$2), isoOrdinalWithTimeExtensionRegex = combineRegexes$2(isoOrdinalRegex$2, isoTimeExtensionRegex$2), isoTimeCombinedRegex = combineRegexes$2(isoTimeRegex$2), extractISOYmdTimeAndOffset = combineExtractors$2(extractISOYmd$2, extractISOTime$2, extractISOOffset$2, extractIANAZone$2), extractISOWeekTimeAndOffset = combineExtractors$2(extractISOWeekData$2, extractISOTime$2, extractISOOffset$2, extractIANAZone$2), extractISOOrdinalDateAndTime = combineExtractors$2(extractISOOrdinalData$2, extractISOTime$2, extractISOOffset$2, extractIANAZone$2), extractISOTimeAndOffset = combineExtractors$2(extractISOTime$2, extractISOOffset$2, extractIANAZone$2);
function parseISODate(s$6) {
  return parse$7(s$6, [isoYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset], [isoWeekWithTimeExtensionRegex, extractISOWeekTimeAndOffset], [isoOrdinalWithTimeExtensionRegex, extractISOOrdinalDateAndTime], [isoTimeCombinedRegex, extractISOTimeAndOffset]);
}
function parseRFC2822Date(s$6) {
  return parse$7(preprocessRFC2822(s$6), [rfc2822, extractRFC2822]);
}
function parseHTTPDate(s$6) {
  return parse$7(s$6, [rfc1123, extractRFC1123Or850], [rfc850, extractRFC1123Or850], [ascii, extractASCII]);
}
function parseISODuration(s$6) {
  return parse$7(s$6, [isoDuration, extractISODuration]);
}
const extractISOTimeOnly = combineExtractors$2(extractISOTime$2);
function parseISOTimeOnly(s$6) {
  return parse$7(s$6, [isoTimeOnly, extractISOTimeOnly]);
}
const sqlYmdWithTimeExtensionRegex = combineRegexes$2(sqlYmdRegex$2, sqlTimeExtensionRegex$2), sqlTimeCombinedRegex = combineRegexes$2(sqlTimeRegex$2), extractISOTimeOffsetAndIANAZone = combineExtractors$2(extractISOTime$2, extractISOOffset$2, extractIANAZone$2);
function parseSQL(s$6) {
  return parse$7(s$6, [sqlYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset], [sqlTimeCombinedRegex, extractISOTimeOffsetAndIANAZone]);
}
const INVALID$2 = `Invalid Duration`, lowOrderMatrix$1 = { weeks: { days: 7, hours: 7 * 24, minutes: 7 * 24 * 60, seconds: 7 * 24 * 60 * 60, milliseconds: 7 * 24 * 60 * 60 * 1e3 }, days: { hours: 24, minutes: 24 * 60, seconds: 24 * 60 * 60, milliseconds: 24 * 60 * 60 * 1e3 }, hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 }, minutes: { seconds: 60, milliseconds: 60 * 1e3 }, seconds: { milliseconds: 1e3 } }, casualMatrix = { years: { quarters: 4, months: 12, weeks: 52, days: 365, hours: 365 * 24, minutes: 365 * 24 * 60, seconds: 365 * 24 * 60 * 60, milliseconds: 365 * 24 * 60 * 60 * 1e3 }, quarters: { months: 3, weeks: 13, days: 91, hours: 91 * 24, minutes: 91 * 24 * 60, seconds: 91 * 24 * 60 * 60, milliseconds: 91 * 24 * 60 * 60 * 1e3 }, months: { weeks: 4, days: 30, hours: 30 * 24, minutes: 30 * 24 * 60, seconds: 30 * 24 * 60 * 60, milliseconds: 30 * 24 * 60 * 60 * 1e3 }, ...lowOrderMatrix$1 }, daysInYearAccurate = 146097 / 400, daysInMonthAccurate = 146097 / 4800, accurateMatrix = { years: { quarters: 4, months: 12, weeks: daysInYearAccurate / 7, days: daysInYearAccurate, hours: daysInYearAccurate * 24, minutes: daysInYearAccurate * 24 * 60, seconds: daysInYearAccurate * 24 * 60 * 60, milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3 }, quarters: { months: 3, weeks: daysInYearAccurate / 28, days: daysInYearAccurate / 4, hours: daysInYearAccurate * 24 / 4, minutes: daysInYearAccurate * 24 * 60 / 4, seconds: daysInYearAccurate * 24 * 60 * 60 / 4, milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3 / 4 }, months: { weeks: daysInMonthAccurate / 7, days: daysInMonthAccurate, hours: daysInMonthAccurate * 24, minutes: daysInMonthAccurate * 24 * 60, seconds: daysInMonthAccurate * 24 * 60 * 60, milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1e3 }, ...lowOrderMatrix$1 }, orderedUnits$1$1 = [`years`, `quarters`, `months`, `weeks`, `days`, `hours`, `minutes`, `seconds`, `milliseconds`], reverseUnits = orderedUnits$1$1.slice(0).reverse();
function clone$1(dur, alts, clear = false) {
  let conf = { values: clear ? alts.values : { ...dur.values, ...alts.values || {} }, loc: dur.loc.clone(alts.loc), conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy, matrix: alts.matrix || dur.matrix };
  return new Duration(conf);
}
function durationToMillis(matrix, vals) {
  let sum = vals.milliseconds ?? 0;
  for (let unit of reverseUnits.slice(1)) vals[unit] && (sum += vals[unit] * matrix[unit].milliseconds);
  return sum;
}
function normalizeValues(matrix, vals) {
  let factor = durationToMillis(matrix, vals) < 0 ? -1 : 1;
  orderedUnits$1$1.reduceRight((previous, current) => {
    if (isUndefined$2(vals[current])) return previous;
    if (previous) {
      let previousVal = vals[previous] * factor, conv = matrix[current][previous], rollUp = Math.floor(previousVal / conv);
      vals[current] += rollUp * factor, vals[previous] -= rollUp * conv * factor;
    }
    return current;
  }, null), orderedUnits$1$1.reduce((previous, current) => {
    if (isUndefined$2(vals[current])) return previous;
    if (previous) {
      let fraction = vals[previous] % 1;
      vals[previous] -= fraction, vals[current] += fraction * matrix[previous][current];
    }
    return current;
  }, null);
}
function removeZeroes(vals) {
  let newVals = {};
  for (let [key, value] of Object.entries(vals)) value !== 0 && (newVals[key] = value);
  return newVals;
}
var Duration = class Duration3 {
  constructor(config) {
    let accurate = config.conversionAccuracy === `longterm` || false, matrix = accurate ? accurateMatrix : casualMatrix;
    config.matrix && (matrix = config.matrix), this.values = config.values, this.loc = config.loc || Locale.create(), this.conversionAccuracy = accurate ? `longterm` : `casual`, this.invalid = config.invalid || null, this.matrix = matrix, this.isLuxonDuration = true;
  }
  static fromMillis(count, opts) {
    return Duration3.fromObject({ milliseconds: count }, opts);
  }
  static fromObject(obj, opts = {}) {
    if (typeof obj != `object` || !obj) throw new InvalidArgumentError(`Duration.fromObject: argument expected to be an object, got ${obj === null ? `null` : typeof obj}`);
    return new Duration3({ values: normalizeObject(obj, Duration3.normalizeUnit), loc: Locale.fromObject(opts), conversionAccuracy: opts.conversionAccuracy, matrix: opts.matrix });
  }
  static fromDurationLike(durationLike) {
    if (isNumber$1(durationLike)) return Duration3.fromMillis(durationLike);
    if (Duration3.isDuration(durationLike)) return durationLike;
    if (typeof durationLike == `object`) return Duration3.fromObject(durationLike);
    throw new InvalidArgumentError(`Unknown duration argument ${durationLike} of type ${typeof durationLike}`);
  }
  static fromISO(text, opts) {
    let [parsed] = parseISODuration(text);
    return parsed ? Duration3.fromObject(parsed, opts) : Duration3.invalid(`unparsable`, `the input "${text}" can't be parsed as ISO 8601`);
  }
  static fromISOTime(text, opts) {
    let [parsed] = parseISOTimeOnly(text);
    return parsed ? Duration3.fromObject(parsed, opts) : Duration3.invalid(`unparsable`, `the input "${text}" can't be parsed as ISO 8601`);
  }
  static invalid(reason, explanation = null) {
    if (!reason) throw new InvalidArgumentError(`need to specify a reason the Duration is invalid`);
    let invalid$1 = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) throw new InvalidDurationError(invalid$1);
    return new Duration3({ invalid: invalid$1 });
  }
  static normalizeUnit(unit) {
    let normalized = { year: `years`, years: `years`, quarter: `quarters`, quarters: `quarters`, month: `months`, months: `months`, week: `weeks`, weeks: `weeks`, day: `days`, days: `days`, hour: `hours`, hours: `hours`, minute: `minutes`, minutes: `minutes`, second: `seconds`, seconds: `seconds`, millisecond: `milliseconds`, milliseconds: `milliseconds` }[unit && unit.toLowerCase()];
    if (!normalized) throw new InvalidUnitError(unit);
    return normalized;
  }
  static isDuration(o$2) {
    return o$2 && o$2.isLuxonDuration || false;
  }
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  toFormat(fmt, opts = {}) {
    let fmtOpts = { ...opts, floor: opts.round !== false && opts.floor !== false };
    return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID$2;
  }
  toHuman(opts = {}) {
    if (!this.isValid) return INVALID$2;
    let showZeros = opts.showZeros !== false, l$4 = orderedUnits$1$1.map((unit) => {
      let val = this.values[unit];
      return isUndefined$2(val) || val === 0 && !showZeros ? null : this.loc.numberFormatter({ style: `unit`, unitDisplay: `long`, ...opts, unit: unit.slice(0, -1) }).format(val);
    }).filter((n$4) => n$4);
    return this.loc.listFormatter({ type: `conjunction`, style: opts.listStyle || `narrow`, ...opts }).format(l$4);
  }
  toObject() {
    return this.isValid ? { ...this.values } : {};
  }
  toISO() {
    if (!this.isValid) return null;
    let s$6 = `P`;
    return this.years !== 0 && (s$6 += this.years + `Y`), (this.months !== 0 || this.quarters !== 0) && (s$6 += this.months + this.quarters * 3 + `M`), this.weeks !== 0 && (s$6 += this.weeks + `W`), this.days !== 0 && (s$6 += this.days + `D`), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (s$6 += `T`), this.hours !== 0 && (s$6 += this.hours + `H`), this.minutes !== 0 && (s$6 += this.minutes + `M`), (this.seconds !== 0 || this.milliseconds !== 0) && (s$6 += roundTo(this.seconds + this.milliseconds / 1e3, 3) + `S`), s$6 === `P` && (s$6 += `T0S`), s$6;
  }
  toISOTime(opts = {}) {
    if (!this.isValid) return null;
    let millis = this.toMillis();
    if (millis < 0 || millis >= 864e5) return null;
    opts = { suppressMilliseconds: false, suppressSeconds: false, includePrefix: false, format: `extended`, ...opts, includeOffset: false };
    let dateTime = DateTime.fromMillis(millis, { zone: `UTC` });
    return dateTime.toISOTime(opts);
  }
  toJSON() {
    return this.toISO();
  }
  toString() {
    return this.toISO();
  }
  [Symbol.for(`nodejs.util.inspect.custom`)]() {
    return this.isValid ? `Duration { values: ${JSON.stringify(this.values)} }` : `Duration { Invalid, reason: ${this.invalidReason} }`;
  }
  toMillis() {
    return this.isValid ? durationToMillis(this.matrix, this.values) : NaN;
  }
  valueOf() {
    return this.toMillis();
  }
  plus(duration$1) {
    if (!this.isValid) return this;
    let dur = Duration3.fromDurationLike(duration$1), result = {};
    for (let k of orderedUnits$1$1) (hasOwnProperty(dur.values, k) || hasOwnProperty(this.values, k)) && (result[k] = dur.get(k) + this.get(k));
    return clone$1(this, { values: result }, true);
  }
  minus(duration$1) {
    if (!this.isValid) return this;
    let dur = Duration3.fromDurationLike(duration$1);
    return this.plus(dur.negate());
  }
  mapUnits(fn$1) {
    if (!this.isValid) return this;
    let result = {};
    for (let k of Object.keys(this.values)) result[k] = asNumber(fn$1(this.values[k], k));
    return clone$1(this, { values: result }, true);
  }
  get(unit) {
    return this[Duration3.normalizeUnit(unit)];
  }
  set(values$3) {
    if (!this.isValid) return this;
    let mixed = { ...this.values, ...normalizeObject(values$3, Duration3.normalizeUnit) };
    return clone$1(this, { values: mixed });
  }
  reconfigure({ locale, numberingSystem, conversionAccuracy, matrix } = {}) {
    let loc = this.loc.clone({ locale, numberingSystem }), opts = { loc, matrix, conversionAccuracy };
    return clone$1(this, opts);
  }
  as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  }
  normalize() {
    if (!this.isValid) return this;
    let vals = this.toObject();
    return normalizeValues(this.matrix, vals), clone$1(this, { values: vals }, true);
  }
  rescale() {
    if (!this.isValid) return this;
    let vals = removeZeroes(this.normalize().shiftToAll().toObject());
    return clone$1(this, { values: vals }, true);
  }
  shiftTo(...units) {
    if (!this.isValid || units.length === 0) return this;
    units = units.map((u) => Duration3.normalizeUnit(u));
    let built = {}, accumulated = {}, vals = this.toObject(), lastUnit;
    for (let k of orderedUnits$1$1) if (units.indexOf(k) >= 0) {
      lastUnit = k;
      let own = 0;
      for (let ak in accumulated) own += this.matrix[ak][k] * accumulated[ak], accumulated[ak] = 0;
      isNumber$1(vals[k]) && (own += vals[k]);
      let i$4 = Math.trunc(own);
      built[k] = i$4, accumulated[k] = (own * 1e3 - i$4 * 1e3) / 1e3;
    } else isNumber$1(vals[k]) && (accumulated[k] = vals[k]);
    for (let key in accumulated) accumulated[key] !== 0 && (built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key]);
    return normalizeValues(this.matrix, built), clone$1(this, { values: built }, true);
  }
  shiftToAll() {
    return this.isValid ? this.shiftTo(`years`, `months`, `weeks`, `days`, `hours`, `minutes`, `seconds`, `milliseconds`) : this;
  }
  negate() {
    if (!this.isValid) return this;
    let negated = {};
    for (let k of Object.keys(this.values)) negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
    return clone$1(this, { values: negated }, true);
  }
  removeZeros() {
    if (!this.isValid) return this;
    let vals = removeZeroes(this.values);
    return clone$1(this, { values: vals }, true);
  }
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  get isValid() {
    return this.invalid === null;
  }
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  equals(other) {
    if (!this.isValid || !other.isValid || !this.loc.equals(other.loc)) return false;
    function eq$9(v1, v2) {
      return v1 === void 0 || v1 === 0 ? v2 === void 0 || v2 === 0 : v1 === v2;
    }
    for (let u of orderedUnits$1$1) if (!eq$9(this.values[u], other.values[u])) return false;
    return true;
  }
};
const INVALID$1 = `Invalid Interval`;
function validateStartEnd(start, end) {
  return !start || !start.isValid ? Interval.invalid(`missing or invalid start`) : !end || !end.isValid ? Interval.invalid(`missing or invalid end`) : end < start ? Interval.invalid(`end before start`, `The end of an interval must be after its start, but you had start=${start.toISO()} and end=${end.toISO()}`) : null;
}
var Interval = class Interval3 {
  constructor(config) {
    this.s = config.start, this.e = config.end, this.invalid = config.invalid || null, this.isLuxonInterval = true;
  }
  static invalid(reason, explanation = null) {
    if (!reason) throw new InvalidArgumentError(`need to specify a reason the Interval is invalid`);
    let invalid$1 = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) throw new InvalidIntervalError(invalid$1);
    return new Interval3({ invalid: invalid$1 });
  }
  static fromDateTimes(start, end) {
    let builtStart = friendlyDateTime(start), builtEnd = friendlyDateTime(end), validateError = validateStartEnd(builtStart, builtEnd);
    return validateError ?? new Interval3({ start: builtStart, end: builtEnd });
  }
  static after(start, duration$1) {
    let dur = Duration.fromDurationLike(duration$1), dt = friendlyDateTime(start);
    return Interval3.fromDateTimes(dt, dt.plus(dur));
  }
  static before(end, duration$1) {
    let dur = Duration.fromDurationLike(duration$1), dt = friendlyDateTime(end);
    return Interval3.fromDateTimes(dt.minus(dur), dt);
  }
  static fromISO(text, opts) {
    let [s$6, e$22] = (text || ``).split(`/`, 2);
    if (s$6 && e$22) {
      let start, startIsValid;
      try {
        start = DateTime.fromISO(s$6, opts), startIsValid = start.isValid;
      } catch {
        startIsValid = false;
      }
      let end, endIsValid;
      try {
        end = DateTime.fromISO(e$22, opts), endIsValid = end.isValid;
      } catch {
        endIsValid = false;
      }
      if (startIsValid && endIsValid) return Interval3.fromDateTimes(start, end);
      if (startIsValid) {
        let dur = Duration.fromISO(e$22, opts);
        if (dur.isValid) return Interval3.after(start, dur);
      } else if (endIsValid) {
        let dur = Duration.fromISO(s$6, opts);
        if (dur.isValid) return Interval3.before(end, dur);
      }
    }
    return Interval3.invalid(`unparsable`, `the input "${text}" can't be parsed as ISO 8601`);
  }
  static isInterval(o$2) {
    return o$2 && o$2.isLuxonInterval || false;
  }
  get start() {
    return this.isValid ? this.s : null;
  }
  get end() {
    return this.isValid ? this.e : null;
  }
  get lastDateTime() {
    return this.isValid && this.e ? this.e.minus(1) : null;
  }
  get isValid() {
    return this.invalidReason === null;
  }
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  length(unit = `milliseconds`) {
    return this.isValid ? this.toDuration(unit).get(unit) : NaN;
  }
  count(unit = `milliseconds`, opts) {
    if (!this.isValid) return NaN;
    let start = this.start.startOf(unit, opts), end;
    return end = opts?.useLocaleWeeks ? this.end.reconfigure({ locale: start.locale }) : this.end, end = end.startOf(unit, opts), Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
  }
  hasSame(unit) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
  }
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  isAfter(dateTime) {
    return this.isValid ? this.s > dateTime : false;
  }
  isBefore(dateTime) {
    return this.isValid ? this.e <= dateTime : false;
  }
  contains(dateTime) {
    return this.isValid ? this.s <= dateTime && this.e > dateTime : false;
  }
  set({ start, end } = {}) {
    return this.isValid ? Interval3.fromDateTimes(start || this.s, end || this.e) : this;
  }
  splitAt(...dateTimes) {
    if (!this.isValid) return [];
    let sorted = dateTimes.map(friendlyDateTime).filter((d$12) => this.contains(d$12)).sort((a$22, b2) => a$22.toMillis() - b2.toMillis()), results = [], { s: s$6 } = this, i$4 = 0;
    for (; s$6 < this.e; ) {
      let added = sorted[i$4] || this.e, next = +added > +this.e ? this.e : added;
      results.push(Interval3.fromDateTimes(s$6, next)), s$6 = next, i$4 += 1;
    }
    return results;
  }
  splitBy(duration$1) {
    let dur = Duration.fromDurationLike(duration$1);
    if (!this.isValid || !dur.isValid || dur.as(`milliseconds`) === 0) return [];
    let { s: s$6 } = this, idx = 1, next, results = [];
    for (; s$6 < this.e; ) {
      let added = this.start.plus(dur.mapUnits((x$1) => x$1 * idx));
      next = +added > +this.e ? this.e : added, results.push(Interval3.fromDateTimes(s$6, next)), s$6 = next, idx += 1;
    }
    return results;
  }
  divideEqually(numberOfParts) {
    return this.isValid ? this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts) : [];
  }
  overlaps(other) {
    return this.e > other.s && this.s < other.e;
  }
  abutsStart(other) {
    return this.isValid ? +this.e == +other.s : false;
  }
  abutsEnd(other) {
    return this.isValid ? +other.e == +this.s : false;
  }
  engulfs(other) {
    return this.isValid ? this.s <= other.s && this.e >= other.e : false;
  }
  equals(other) {
    return !this.isValid || !other.isValid ? false : this.s.equals(other.s) && this.e.equals(other.e);
  }
  intersection(other) {
    if (!this.isValid) return this;
    let s$6 = this.s > other.s ? this.s : other.s, e$22 = this.e < other.e ? this.e : other.e;
    return s$6 >= e$22 ? null : Interval3.fromDateTimes(s$6, e$22);
  }
  union(other) {
    if (!this.isValid) return this;
    let s$6 = this.s < other.s ? this.s : other.s, e$22 = this.e > other.e ? this.e : other.e;
    return Interval3.fromDateTimes(s$6, e$22);
  }
  static merge(intervals) {
    let [found, final] = intervals.sort((a$22, b2) => a$22.s - b2.s).reduce(([sofar, current], item) => current ? current.overlaps(item) || current.abutsStart(item) ? [sofar, current.union(item)] : [sofar.concat([current]), item] : [sofar, item], [[], null]);
    return final && found.push(final), found;
  }
  static xor(intervals) {
    let start = null, currentCount = 0, results = [], ends = intervals.map((i$4) => [{ time: i$4.s, type: `s` }, { time: i$4.e, type: `e` }]), flattened = Array.prototype.concat(...ends), arr = flattened.sort((a$22, b2) => a$22.time - b2.time);
    for (let i$4 of arr) currentCount += i$4.type === `s` ? 1 : -1, currentCount === 1 ? start = i$4.time : (start && +start != +i$4.time && results.push(Interval3.fromDateTimes(start, i$4.time)), start = null);
    return Interval3.merge(results);
  }
  difference(...intervals) {
    return Interval3.xor([this].concat(intervals)).map((i$4) => this.intersection(i$4)).filter((i$4) => i$4 && !i$4.isEmpty());
  }
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : INVALID$1;
  }
  [Symbol.for(`nodejs.util.inspect.custom`)]() {
    return this.isValid ? `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }` : `Interval { Invalid, reason: ${this.invalidReason} }`;
  }
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : INVALID$1;
  }
  toISO(opts) {
    return this.isValid ? `${this.s.toISO(opts)}/${this.e.toISO(opts)}` : INVALID$1;
  }
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : INVALID$1;
  }
  toISOTime(opts) {
    return this.isValid ? `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}` : INVALID$1;
  }
  toFormat(dateFormat, { separator = ` – ` } = {}) {
    return this.isValid ? `${this.s.toFormat(dateFormat)}${separator}${this.e.toFormat(dateFormat)}` : INVALID$1;
  }
  toDuration(unit, opts) {
    return this.isValid ? this.e.diff(this.s, unit, opts) : Duration.invalid(this.invalidReason);
  }
  mapEndpoints(mapFn) {
    return Interval3.fromDateTimes(mapFn(this.s), mapFn(this.e));
  }
}, Info = class {
  static hasDST(zone = Settings.defaultZone) {
    let proto = DateTime.now().setZone(zone).set({ month: 12 });
    return !zone.isUniversal && proto.offset !== proto.set({ month: 6 }).offset;
  }
  static isValidIANAZone(zone) {
    return IANAZone$2.isValidZone(zone);
  }
  static normalizeZone(input) {
    return normalizeZone(input, Settings.defaultZone);
  }
  static getStartOfWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getStartOfWeek();
  }
  static getMinimumDaysInFirstWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getMinDaysInFirstWeek();
  }
  static getWeekendWeekdays({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getWeekendDays().slice();
  }
  static months(length = `long`, { locale = null, numberingSystem = null, locObj = null, outputCalendar = `gregory` } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
  }
  static monthsFormat(length = `long`, { locale = null, numberingSystem = null, locObj = null, outputCalendar = `gregory` } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
  }
  static weekdays(length = `long`, { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
  }
  static weekdaysFormat(length = `long`, { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
  }
  static meridiems({ locale = null } = {}) {
    return Locale.create(locale).meridiems();
  }
  static eras(length = `short`, { locale = null } = {}) {
    return Locale.create(locale, null, `gregory`).eras(length);
  }
  static features() {
    return { relative: hasRelative(), localeWeek: hasLocaleWeekInfo() };
  }
};
function dayDiff(earlier, later) {
  let utcDayStart = (dt) => dt.toUTC(0, { keepLocalTime: true }).startOf(`day`).valueOf(), ms = utcDayStart(later) - utcDayStart(earlier);
  return Math.floor(Duration.fromMillis(ms).as(`days`));
}
function highOrderDiffs(cursor, later, units) {
  let differs = [[`years`, (a$22, b2) => b2.year - a$22.year], [`quarters`, (a$22, b2) => b2.quarter - a$22.quarter + (b2.year - a$22.year) * 4], [`months`, (a$22, b2) => b2.month - a$22.month + (b2.year - a$22.year) * 12], [`weeks`, (a$22, b2) => {
    let days = dayDiff(a$22, b2);
    return (days - days % 7) / 7;
  }], [`days`, dayDiff]], results = {}, earlier = cursor, lowestOrder, highWater;
  for (let [unit, differ] of differs) units.indexOf(unit) >= 0 && (lowestOrder = unit, results[unit] = differ(cursor, later), highWater = earlier.plus(results), highWater > later ? (results[unit]--, cursor = earlier.plus(results), cursor > later && (highWater = cursor, results[unit]--, cursor = earlier.plus(results))) : cursor = highWater);
  return [cursor, results, highWater, lowestOrder];
}
function diff$2(earlier, later, units, opts) {
  let [cursor, results, highWater, lowestOrder] = highOrderDiffs(earlier, later, units), remainingMillis = later - cursor, lowerOrderUnits = units.filter((u) => [`hours`, `minutes`, `seconds`, `milliseconds`].indexOf(u) >= 0);
  lowerOrderUnits.length === 0 && (highWater < later && (highWater = cursor.plus({ [lowestOrder]: 1 })), highWater !== cursor && (results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor)));
  let duration$1 = Duration.fromObject(results, opts);
  return lowerOrderUnits.length > 0 ? Duration.fromMillis(remainingMillis, opts).shiftTo(...lowerOrderUnits).plus(duration$1) : duration$1;
}
const MISSING_FTP = `missing Intl.DateTimeFormat.formatToParts support`;
function intUnit(regex, post = (i$4) => i$4) {
  return { regex, deser: ([s$6]) => post(parseDigits(s$6)) };
}
const NBSP = ` `, spaceOrNBSP = `[ ${NBSP}]`, spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, `g`);
function fixListRegex(s$6) {
  return s$6.replace(/\./g, `\\.?`).replace(spaceOrNBSPRegExp, spaceOrNBSP);
}
function stripInsensitivities(s$6) {
  return s$6.replace(/\./g, ``).replace(spaceOrNBSPRegExp, ` `).toLowerCase();
}
function oneOf(strings, startIndex) {
  return strings === null ? null : { regex: RegExp(strings.map(fixListRegex).join(`|`)), deser: ([s$6]) => strings.findIndex((i$4) => stripInsensitivities(s$6) === stripInsensitivities(i$4)) + startIndex };
}
function offset(regex, groups) {
  return { regex, deser: ([, h$1, m$3]) => signedOffset$2(h$1, m$3), groups };
}
function simple(regex) {
  return { regex, deser: ([s$6]) => s$6 };
}
function escapeToken(value) {
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, `\\$&`);
}
function unitForToken(token, loc) {
  let one = digitRegex(loc), two$1 = digitRegex(loc, `{2}`), three = digitRegex(loc, `{3}`), four = digitRegex(loc, `{4}`), six = digitRegex(loc, `{6}`), oneOrTwo = digitRegex(loc, `{1,2}`), oneToThree = digitRegex(loc, `{1,3}`), oneToSix = digitRegex(loc, `{1,6}`), oneToNine = digitRegex(loc, `{1,9}`), twoToFour = digitRegex(loc, `{2,4}`), fourToSix = digitRegex(loc, `{4,6}`), literal = (t$7) => ({ regex: RegExp(escapeToken(t$7.val)), deser: ([s$6]) => s$6, literal: true }), unitate = (t$7) => {
    if (token.literal) return literal(t$7);
    switch (t$7.val) {
      case `G`:
        return oneOf(loc.eras(`short`), 0);
      case `GG`:
        return oneOf(loc.eras(`long`), 0);
      case `y`:
        return intUnit(oneToSix);
      case `yy`:
        return intUnit(twoToFour, untruncateYear);
      case `yyyy`:
        return intUnit(four);
      case `yyyyy`:
        return intUnit(fourToSix);
      case `yyyyyy`:
        return intUnit(six);
      case `M`:
        return intUnit(oneOrTwo);
      case `MM`:
        return intUnit(two$1);
      case `MMM`:
        return oneOf(loc.months(`short`, true), 1);
      case `MMMM`:
        return oneOf(loc.months(`long`, true), 1);
      case `L`:
        return intUnit(oneOrTwo);
      case `LL`:
        return intUnit(two$1);
      case `LLL`:
        return oneOf(loc.months(`short`, false), 1);
      case `LLLL`:
        return oneOf(loc.months(`long`, false), 1);
      case `d`:
        return intUnit(oneOrTwo);
      case `dd`:
        return intUnit(two$1);
      case `o`:
        return intUnit(oneToThree);
      case `ooo`:
        return intUnit(three);
      case `HH`:
        return intUnit(two$1);
      case `H`:
        return intUnit(oneOrTwo);
      case `hh`:
        return intUnit(two$1);
      case `h`:
        return intUnit(oneOrTwo);
      case `mm`:
        return intUnit(two$1);
      case `m`:
        return intUnit(oneOrTwo);
      case `q`:
        return intUnit(oneOrTwo);
      case `qq`:
        return intUnit(two$1);
      case `s`:
        return intUnit(oneOrTwo);
      case `ss`:
        return intUnit(two$1);
      case `S`:
        return intUnit(oneToThree);
      case `SSS`:
        return intUnit(three);
      case `u`:
        return simple(oneToNine);
      case `uu`:
        return simple(oneOrTwo);
      case `uuu`:
        return intUnit(one);
      case `a`:
        return oneOf(loc.meridiems(), 0);
      case `kkkk`:
        return intUnit(four);
      case `kk`:
        return intUnit(twoToFour, untruncateYear);
      case `W`:
        return intUnit(oneOrTwo);
      case `WW`:
        return intUnit(two$1);
      case `E`:
      case `c`:
        return intUnit(one);
      case `EEE`:
        return oneOf(loc.weekdays(`short`, false), 1);
      case `EEEE`:
        return oneOf(loc.weekdays(`long`, false), 1);
      case `ccc`:
        return oneOf(loc.weekdays(`short`, true), 1);
      case `cccc`:
        return oneOf(loc.weekdays(`long`, true), 1);
      case `Z`:
      case `ZZ`:
        return offset(RegExp(`([+-]${oneOrTwo.source})(?::(${two$1.source}))?`), 2);
      case `ZZZ`:
        return offset(RegExp(`([+-]${oneOrTwo.source})(${two$1.source})?`), 2);
      case `z`:
        return simple(/[a-z_+-/]{1,256}?/i);
      case ` `:
        return simple(/[^\S\n\r]/);
      default:
        return literal(t$7);
    }
  }, unit = unitate(token) || { invalidReason: MISSING_FTP };
  return unit.token = token, unit;
}
const partTypeStyleToTokenVal = { year: { "2-digit": `yy`, numeric: `yyyyy` }, month: { numeric: `M`, "2-digit": `MM`, short: `MMM`, long: `MMMM` }, day: { numeric: `d`, "2-digit": `dd` }, weekday: { short: `EEE`, long: `EEEE` }, dayperiod: `a`, dayPeriod: `a`, hour12: { numeric: `h`, "2-digit": `hh` }, hour24: { numeric: `H`, "2-digit": `HH` }, minute: { numeric: `m`, "2-digit": `mm` }, second: { numeric: `s`, "2-digit": `ss` }, timeZoneName: { long: `ZZZZZ`, short: `ZZZ` } };
function tokenForPart(part, formatOpts, resolvedOpts) {
  let { type, value } = part;
  if (type === `literal`) {
    let isSpace = /^\s+$/.test(value);
    return { literal: !isSpace, val: isSpace ? ` ` : value };
  }
  let style = formatOpts[type], actualType = type;
  type === `hour` && (actualType = formatOpts.hour12 == null ? formatOpts.hourCycle == null ? resolvedOpts.hour12 ? `hour12` : `hour24` : formatOpts.hourCycle === `h11` || formatOpts.hourCycle === `h12` ? `hour12` : `hour24` : formatOpts.hour12 ? `hour12` : `hour24`);
  let val = partTypeStyleToTokenVal[actualType];
  if (typeof val == `object` && (val = val[style]), val) return { literal: false, val };
}
function buildRegex(units) {
  let re$5 = units.map((u) => u.regex).reduce((f$32, r$2) => `${f$32}(${r$2.source})`, ``);
  return [`^${re$5}$`, units];
}
function match(input, regex, handlers) {
  let matches = input.match(regex);
  if (matches) {
    let all$1 = {}, matchIndex = 1;
    for (let i$4 in handlers) if (hasOwnProperty(handlers, i$4)) {
      let h$1 = handlers[i$4], groups = h$1.groups ? h$1.groups + 1 : 1;
      !h$1.literal && h$1.token && (all$1[h$1.token.val[0]] = h$1.deser(matches.slice(matchIndex, matchIndex + groups))), matchIndex += groups;
    }
    return [matches, all$1];
  } else return [matches, {}];
}
function dateTimeFromMatches(matches) {
  let toField = (token) => {
    switch (token) {
      case `S`:
        return `millisecond`;
      case `s`:
        return `second`;
      case `m`:
        return `minute`;
      case `h`:
      case `H`:
        return `hour`;
      case `d`:
        return `day`;
      case `o`:
        return `ordinal`;
      case `L`:
      case `M`:
        return `month`;
      case `y`:
        return `year`;
      case `E`:
      case `c`:
        return `weekday`;
      case `W`:
        return `weekNumber`;
      case `k`:
        return `weekYear`;
      case `q`:
        return `quarter`;
      default:
        return null;
    }
  }, zone = null, specificOffset;
  isUndefined$2(matches.z) || (zone = IANAZone$2.create(matches.z)), isUndefined$2(matches.Z) || (zone ||= new FixedOffsetZone$2(matches.Z), specificOffset = matches.Z), isUndefined$2(matches.q) || (matches.M = (matches.q - 1) * 3 + 1), isUndefined$2(matches.h) || (matches.h < 12 && matches.a === 1 ? matches.h += 12 : matches.h === 12 && matches.a === 0 && (matches.h = 0)), matches.G === 0 && matches.y && (matches.y = -matches.y), isUndefined$2(matches.u) || (matches.S = parseMillis$2(matches.u));
  let vals = Object.keys(matches).reduce((r$2, k) => {
    let f$32 = toField(k);
    return f$32 && (r$2[f$32] = matches[k]), r$2;
  }, {});
  return [vals, zone, specificOffset];
}
let dummyDateTimeCache = null;
function getDummyDateTime() {
  return dummyDateTimeCache ||= DateTime.fromMillis(1555555555555), dummyDateTimeCache;
}
function maybeExpandMacroToken(token, locale) {
  if (token.literal) return token;
  let formatOpts = Formatter.macroTokenToFormatOpts(token.val), tokens = formatOptsToTokens(formatOpts, locale);
  return tokens == null || tokens.includes(void 0) ? token : tokens;
}
function expandMacroTokens(tokens, locale) {
  return Array.prototype.concat(...tokens.map((t$7) => maybeExpandMacroToken(t$7, locale)));
}
var TokenParser = class {
  constructor(locale, format) {
    if (this.locale = locale, this.format = format, this.tokens = expandMacroTokens(Formatter.parseFormat(format), locale), this.units = this.tokens.map((t$7) => unitForToken(t$7, locale)), this.disqualifyingUnit = this.units.find((t$7) => t$7.invalidReason), !this.disqualifyingUnit) {
      let [regexString, handlers] = buildRegex(this.units);
      this.regex = RegExp(regexString, `i`), this.handlers = handlers;
    }
  }
  explainFromTokens(input) {
    if (this.isValid) {
      let [rawMatches, matches] = match(input, this.regex, this.handlers), [result, zone, specificOffset] = matches ? dateTimeFromMatches(matches) : [null, null, void 0];
      if (hasOwnProperty(matches, `a`) && hasOwnProperty(matches, `H`)) throw new ConflictingSpecificationError(`Can't include meridiem when specifying 24-hour format`);
      return { input, tokens: this.tokens, regex: this.regex, rawMatches, matches, result, zone, specificOffset };
    } else return { input, tokens: this.tokens, invalidReason: this.invalidReason };
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
};
function explainFromTokens(locale, input, format) {
  let parser = new TokenParser(locale, format);
  return parser.explainFromTokens(input);
}
function parseFromTokens(locale, input, format) {
  let { result, zone, specificOffset, invalidReason } = explainFromTokens(locale, input, format);
  return [result, zone, specificOffset, invalidReason];
}
function formatOptsToTokens(formatOpts, locale) {
  if (!formatOpts) return null;
  let formatter = Formatter.create(locale, formatOpts), df = formatter.dtFormatter(getDummyDateTime()), parts = df.formatToParts(), resolvedOpts = df.resolvedOptions();
  return parts.map((p$1) => tokenForPart(p$1, formatOpts, resolvedOpts));
}
const INVALID = `Invalid DateTime`, MAX_DATE = 864e13;
function unsupportedZone(zone) {
  return new Invalid(`unsupported zone`, `the zone "${zone.name}" is not supported`);
}
function possiblyCachedWeekData(dt) {
  return dt.weekData === null && (dt.weekData = gregorianToWeek(dt.c)), dt.weekData;
}
function possiblyCachedLocalWeekData(dt) {
  return dt.localWeekData === null && (dt.localWeekData = gregorianToWeek(dt.c, dt.loc.getMinDaysInFirstWeek(), dt.loc.getStartOfWeek())), dt.localWeekData;
}
function clone(inst, alts) {
  let current = { ts: inst.ts, zone: inst.zone, c: inst.c, o: inst.o, loc: inst.loc, invalid: inst.invalid };
  return new DateTime({ ...current, ...alts, old: current });
}
function fixOffset(localTS, o$2, tz) {
  let utcGuess = localTS - o$2 * 60 * 1e3, o2 = tz.offset(utcGuess);
  if (o$2 === o2) return [utcGuess, o$2];
  utcGuess -= (o2 - o$2) * 60 * 1e3;
  let o3 = tz.offset(utcGuess);
  return o2 === o3 ? [utcGuess, o2] : [localTS - Math.min(o2, o3) * 60 * 1e3, Math.max(o2, o3)];
}
function tsToObj(ts, offset$2) {
  ts += offset$2 * 60 * 1e3;
  let d$12 = new Date(ts);
  return { year: d$12.getUTCFullYear(), month: d$12.getUTCMonth() + 1, day: d$12.getUTCDate(), hour: d$12.getUTCHours(), minute: d$12.getUTCMinutes(), second: d$12.getUTCSeconds(), millisecond: d$12.getUTCMilliseconds() };
}
function objToTS(obj, offset$2, zone) {
  return fixOffset(objToLocalTS$2(obj), offset$2, zone);
}
function adjustTime(inst, dur) {
  let oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c$12 = { ...inst.c, year, month, day: Math.min(inst.c.day, daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7 }, millisToAdd = Duration.fromObject({ years: dur.years - Math.trunc(dur.years), quarters: dur.quarters - Math.trunc(dur.quarters), months: dur.months - Math.trunc(dur.months), weeks: dur.weeks - Math.trunc(dur.weeks), days: dur.days - Math.trunc(dur.days), hours: dur.hours, minutes: dur.minutes, seconds: dur.seconds, milliseconds: dur.milliseconds }).as(`milliseconds`), localTS = objToLocalTS$2(c$12), [ts, o$2] = fixOffset(localTS, oPre, inst.zone);
  return millisToAdd !== 0 && (ts += millisToAdd, o$2 = inst.zone.offset(ts)), { ts, o: o$2 };
}
function parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
  let { setZone, zone } = opts;
  if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
    let interpretationZone = parsedZone || zone, inst = DateTime.fromObject(parsed, { ...opts, zone: interpretationZone, specificOffset });
    return setZone ? inst : inst.setZone(zone);
  } else return DateTime.invalid(new Invalid(`unparsable`, `the input "${text}" can't be parsed as ${format}`));
}
function toTechFormat(dt, format, allowZ = true) {
  return dt.isValid ? Formatter.create(Locale.create(`en-US`), { allowZ, forceSimple: true }).formatDateTimeFromString(dt, format) : null;
}
function toISODate(o$2, extended, precision) {
  let longFormat = o$2.c.year > 9999 || o$2.c.year < 0, c$12 = ``;
  if (longFormat && o$2.c.year >= 0 && (c$12 += `+`), c$12 += padStart$2(o$2.c.year, longFormat ? 6 : 4), precision === `year`) return c$12;
  if (extended) {
    if (c$12 += `-`, c$12 += padStart$2(o$2.c.month), precision === `month`) return c$12;
    c$12 += `-`;
  } else if (c$12 += padStart$2(o$2.c.month), precision === `month`) return c$12;
  return c$12 += padStart$2(o$2.c.day), c$12;
}
function toISOTime(o$2, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision) {
  let showSeconds = !suppressSeconds || o$2.c.millisecond !== 0 || o$2.c.second !== 0, c$12 = ``;
  switch (precision) {
    case `day`:
    case `month`:
    case `year`:
      break;
    default:
      if (c$12 += padStart$2(o$2.c.hour), precision === `hour`) break;
      if (extended) {
        if (c$12 += `:`, c$12 += padStart$2(o$2.c.minute), precision === `minute`) break;
        showSeconds && (c$12 += `:`, c$12 += padStart$2(o$2.c.second));
      } else {
        if (c$12 += padStart$2(o$2.c.minute), precision === `minute`) break;
        showSeconds && (c$12 += padStart$2(o$2.c.second));
      }
      if (precision === `second`) break;
      showSeconds && (!suppressMilliseconds || o$2.c.millisecond !== 0) && (c$12 += `.`, c$12 += padStart$2(o$2.c.millisecond, 3));
  }
  return includeOffset && (o$2.isOffsetFixed && o$2.offset === 0 && !extendedZone ? c$12 += `Z` : o$2.o < 0 ? (c$12 += `-`, c$12 += padStart$2(Math.trunc(-o$2.o / 60)), c$12 += `:`, c$12 += padStart$2(Math.trunc(-o$2.o % 60))) : (c$12 += `+`, c$12 += padStart$2(Math.trunc(o$2.o / 60)), c$12 += `:`, c$12 += padStart$2(Math.trunc(o$2.o % 60)))), extendedZone && (c$12 += `[` + o$2.zone.ianaName + `]`), c$12;
}
const defaultUnitValues = { month: 1, day: 1, hour: 0, minute: 0, second: 0, millisecond: 0 }, defaultWeekUnitValues = { weekNumber: 1, weekday: 1, hour: 0, minute: 0, second: 0, millisecond: 0 }, defaultOrdinalUnitValues = { ordinal: 1, hour: 0, minute: 0, second: 0, millisecond: 0 }, orderedUnits = [`year`, `month`, `day`, `hour`, `minute`, `second`, `millisecond`], orderedWeekUnits = [`weekYear`, `weekNumber`, `weekday`, `hour`, `minute`, `second`, `millisecond`], orderedOrdinalUnits = [`year`, `ordinal`, `hour`, `minute`, `second`, `millisecond`];
function normalizeUnit(unit) {
  let normalized = { year: `year`, years: `year`, month: `month`, months: `month`, day: `day`, days: `day`, hour: `hour`, hours: `hour`, minute: `minute`, minutes: `minute`, quarter: `quarter`, quarters: `quarter`, second: `second`, seconds: `second`, millisecond: `millisecond`, milliseconds: `millisecond`, weekday: `weekday`, weekdays: `weekday`, weeknumber: `weekNumber`, weeksnumber: `weekNumber`, weeknumbers: `weekNumber`, weekyear: `weekYear`, weekyears: `weekYear`, ordinal: `ordinal` }[unit.toLowerCase()];
  if (!normalized) throw new InvalidUnitError(unit);
  return normalized;
}
function normalizeUnitWithLocalWeeks(unit) {
  switch (unit.toLowerCase()) {
    case `localweekday`:
    case `localweekdays`:
      return `localWeekday`;
    case `localweeknumber`:
    case `localweeknumbers`:
      return `localWeekNumber`;
    case `localweekyear`:
    case `localweekyears`:
      return `localWeekYear`;
    default:
      return normalizeUnit(unit);
  }
}
function guessOffsetForZone(zone) {
  if (zoneOffsetTs === void 0 && (zoneOffsetTs = Settings.now()), zone.type !== `iana`) return zone.offset(zoneOffsetTs);
  let zoneName = zone.name, offsetGuess = zoneOffsetGuessCache.get(zoneName);
  return offsetGuess === void 0 && (offsetGuess = zone.offset(zoneOffsetTs), zoneOffsetGuessCache.set(zoneName, offsetGuess)), offsetGuess;
}
function quickDT(obj, opts) {
  let zone = normalizeZone(opts.zone, Settings.defaultZone);
  if (!zone.isValid) return DateTime.invalid(unsupportedZone(zone));
  let loc = Locale.fromObject(opts), ts, o$2;
  if (isUndefined$2(obj.year)) ts = Settings.now();
  else {
    for (let u of orderedUnits) isUndefined$2(obj[u]) && (obj[u] = defaultUnitValues[u]);
    let invalid$1 = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
    if (invalid$1) return DateTime.invalid(invalid$1);
    let offsetProvis = guessOffsetForZone(zone);
    [ts, o$2] = objToTS(obj, offsetProvis, zone);
  }
  return new DateTime({ ts, zone, loc, o: o$2 });
}
function diffRelative(start, end, opts) {
  let round$2 = isUndefined$2(opts.round) ? true : opts.round, rounding = isUndefined$2(opts.rounding) ? `trunc` : opts.rounding, format = (c$12, unit) => {
    c$12 = roundTo(c$12, round$2 || opts.calendary ? 0 : 2, opts.calendary ? `round` : rounding);
    let formatter = end.loc.clone(opts).relFormatter(opts);
    return formatter.format(c$12, unit);
  }, differ = (unit) => opts.calendary ? end.hasSame(start, unit) ? 0 : end.startOf(unit).diff(start.startOf(unit), unit).get(unit) : end.diff(start, unit).get(unit);
  if (opts.unit) return format(differ(opts.unit), opts.unit);
  for (let unit of opts.units) {
    let count = differ(unit);
    if (Math.abs(count) >= 1) return format(count, unit);
  }
  return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function lastOpts(argList) {
  let opts = {}, args$1;
  return argList.length > 0 && typeof argList[argList.length - 1] == `object` ? (opts = argList[argList.length - 1], args$1 = Array.from(argList).slice(0, argList.length - 1)) : args$1 = Array.from(argList), [opts, args$1];
}
let zoneOffsetTs;
const zoneOffsetGuessCache = /* @__PURE__ */ new Map();
var DateTime = class DateTime3 {
  constructor(config) {
    let zone = config.zone || Settings.defaultZone, invalid$1 = config.invalid || (Number.isNaN(config.ts) ? new Invalid(`invalid input`) : null) || (zone.isValid ? null : unsupportedZone(zone));
    this.ts = isUndefined$2(config.ts) ? Settings.now() : config.ts;
    let c$12 = null, o$2 = null;
    if (!invalid$1) {
      let unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
      if (unchanged) [c$12, o$2] = [config.old.c, config.old.o];
      else {
        let ot = isNumber$1(config.o) && !config.old ? config.o : zone.offset(this.ts);
        c$12 = tsToObj(this.ts, ot), invalid$1 = Number.isNaN(c$12.year) ? new Invalid(`invalid input`) : null, c$12 = invalid$1 ? null : c$12, o$2 = invalid$1 ? null : ot;
      }
    }
    this._zone = zone, this.loc = config.loc || Locale.create(), this.invalid = invalid$1, this.weekData = null, this.localWeekData = null, this.c = c$12, this.o = o$2, this.isLuxonDateTime = true;
  }
  static now() {
    return new DateTime3({});
  }
  static local() {
    let [opts, args$1] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args$1;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }
  static utc() {
    let [opts, args$1] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args$1;
    return opts.zone = FixedOffsetZone$2.utcInstance, quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }
  static fromJSDate(date, options = {}) {
    let ts = isDate(date) ? date.valueOf() : NaN;
    if (Number.isNaN(ts)) return DateTime3.invalid(`invalid input`);
    let zoneToUse = normalizeZone(options.zone, Settings.defaultZone);
    return zoneToUse.isValid ? new DateTime3({ ts, zone: zoneToUse, loc: Locale.fromObject(options) }) : DateTime3.invalid(unsupportedZone(zoneToUse));
  }
  static fromMillis(milliseconds, options = {}) {
    if (isNumber$1(milliseconds)) return milliseconds < -MAX_DATE || milliseconds > MAX_DATE ? DateTime3.invalid(`Timestamp out of range`) : new DateTime3({ ts: milliseconds, zone: normalizeZone(options.zone, Settings.defaultZone), loc: Locale.fromObject(options) });
    throw new InvalidArgumentError(`fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`);
  }
  static fromSeconds(seconds, options = {}) {
    if (isNumber$1(seconds)) return new DateTime3({ ts: seconds * 1e3, zone: normalizeZone(options.zone, Settings.defaultZone), loc: Locale.fromObject(options) });
    throw new InvalidArgumentError(`fromSeconds requires a numerical input`);
  }
  static fromObject(obj, opts = {}) {
    obj ||= {};
    let zoneToUse = normalizeZone(opts.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) return DateTime3.invalid(unsupportedZone(zoneToUse));
    let loc = Locale.fromObject(opts), normalized = normalizeObject(obj, normalizeUnitWithLocalWeeks), { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, loc), tsNow = Settings.now(), offsetProvis = isUndefined$2(opts.specificOffset) ? zoneToUse.offset(tsNow) : opts.specificOffset, containsOrdinal = !isUndefined$2(normalized.ordinal), containsGregorYear = !isUndefined$2(normalized.year), containsGregorMD = !isUndefined$2(normalized.month) || !isUndefined$2(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new ConflictingSpecificationError(`Can't mix weekYear/weekNumber units with year/month/day or ordinals`);
    if (containsGregorMD && containsOrdinal) throw new ConflictingSpecificationError(`Can't mix ordinal dates with month/day`);
    let useWeekData = definiteWeekDef || normalized.weekday && !containsGregor, units, defaultValues, objNow = tsToObj(tsNow, offsetProvis);
    useWeekData ? (units = orderedWeekUnits, defaultValues = defaultWeekUnitValues, objNow = gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek)) : containsOrdinal ? (units = orderedOrdinalUnits, defaultValues = defaultOrdinalUnitValues, objNow = gregorianToOrdinal(objNow)) : (units = orderedUnits, defaultValues = defaultUnitValues);
    let foundFirst = false;
    for (let u of units) {
      let v$1 = normalized[u];
      isUndefined$2(v$1) ? foundFirst ? normalized[u] = defaultValues[u] : normalized[u] = objNow[u] : foundFirst = true;
    }
    let higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized), invalid$1 = higherOrderInvalid || hasInvalidTimeData(normalized);
    if (invalid$1) return DateTime3.invalid(invalid$1);
    let gregorian = useWeekData ? weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? ordinalToGregorian(normalized) : normalized, [tsFinal, offsetFinal] = objToTS(gregorian, offsetProvis, zoneToUse), inst = new DateTime3({ ts: tsFinal, zone: zoneToUse, o: offsetFinal, loc });
    return normalized.weekday && containsGregor && obj.weekday !== inst.weekday ? DateTime3.invalid(`mismatched weekday`, `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`) : inst.isValid ? inst : DateTime3.invalid(inst.invalid);
  }
  static fromISO(text, opts = {}) {
    let [vals, parsedZone] = parseISODate(text);
    return parseDataToDateTime(vals, parsedZone, opts, `ISO 8601`, text);
  }
  static fromRFC2822(text, opts = {}) {
    let [vals, parsedZone] = parseRFC2822Date(text);
    return parseDataToDateTime(vals, parsedZone, opts, `RFC 2822`, text);
  }
  static fromHTTP(text, opts = {}) {
    let [vals, parsedZone] = parseHTTPDate(text);
    return parseDataToDateTime(vals, parsedZone, opts, `HTTP`, opts);
  }
  static fromFormat(text, fmt, opts = {}) {
    if (isUndefined$2(text) || isUndefined$2(fmt)) throw new InvalidArgumentError(`fromFormat requires an input string and a format`);
    let { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({ locale, numberingSystem, defaultToEN: true }), [vals, parsedZone, specificOffset, invalid$1] = parseFromTokens(localeToUse, text, fmt);
    return invalid$1 ? DateTime3.invalid(invalid$1) : parseDataToDateTime(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
  }
  static fromString(text, fmt, opts = {}) {
    return DateTime3.fromFormat(text, fmt, opts);
  }
  static fromSQL(text, opts = {}) {
    let [vals, parsedZone] = parseSQL(text);
    return parseDataToDateTime(vals, parsedZone, opts, `SQL`, text);
  }
  static invalid(reason, explanation = null) {
    if (!reason) throw new InvalidArgumentError(`need to specify a reason the DateTime is invalid`);
    let invalid$1 = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) throw new InvalidDateTimeError(invalid$1);
    return new DateTime3({ invalid: invalid$1 });
  }
  static isDateTime(o$2) {
    return o$2 && o$2.isLuxonDateTime || false;
  }
  static parseFormatForOpts(formatOpts, localeOpts = {}) {
    let tokenList = formatOptsToTokens(formatOpts, Locale.fromObject(localeOpts));
    return tokenList ? tokenList.map((t$7) => t$7 ? t$7.val : null).join(``) : null;
  }
  static expandFormat(fmt, localeOpts = {}) {
    let expanded = expandMacroTokens(Formatter.parseFormat(fmt), Locale.fromObject(localeOpts));
    return expanded.map((t$7) => t$7.val).join(``);
  }
  static resetCache() {
    zoneOffsetTs = void 0, zoneOffsetGuessCache.clear();
  }
  get(unit) {
    return this[unit];
  }
  get isValid() {
    return this.invalid === null;
  }
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  get zone() {
    return this._zone;
  }
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  get weekYear() {
    return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
  }
  get weekNumber() {
    return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
  }
  get weekday() {
    return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
  }
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  get localWeekday() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekday : NaN;
  }
  get localWeekNumber() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekNumber : NaN;
  }
  get localWeekYear() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekYear : NaN;
  }
  get ordinal() {
    return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
  }
  get monthShort() {
    return this.isValid ? Info.months(`short`, { locObj: this.loc })[this.month - 1] : null;
  }
  get monthLong() {
    return this.isValid ? Info.months(`long`, { locObj: this.loc })[this.month - 1] : null;
  }
  get weekdayShort() {
    return this.isValid ? Info.weekdays(`short`, { locObj: this.loc })[this.weekday - 1] : null;
  }
  get weekdayLong() {
    return this.isValid ? Info.weekdays(`long`, { locObj: this.loc })[this.weekday - 1] : null;
  }
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, { format: `short`, locale: this.locale }) : null;
  }
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, { format: `long`, locale: this.locale }) : null;
  }
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  get isInDST() {
    return this.isOffsetFixed ? false : this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed) return [this];
    let dayMs = 864e5, minuteMs = 6e4, localTS = objToLocalTS$2(this.c), oEarlier = this.zone.offset(localTS - dayMs), oLater = this.zone.offset(localTS + dayMs), o1 = this.zone.offset(localTS - oEarlier * minuteMs), o2 = this.zone.offset(localTS - oLater * minuteMs);
    if (o1 === o2) return [this];
    let ts1 = localTS - o1 * minuteMs, ts2 = localTS - o2 * minuteMs, c1 = tsToObj(ts1, o1), c2 = tsToObj(ts2, o2);
    return c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond ? [clone(this, { ts: ts1 }), clone(this, { ts: ts2 })] : [this];
  }
  get isInLeapYear() {
    return isLeapYear(this.year);
  }
  get daysInMonth() {
    return daysInMonth(this.year, this.month);
  }
  get daysInYear() {
    return this.isValid ? daysInYear(this.year) : NaN;
  }
  get weeksInWeekYear() {
    return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
  }
  get weeksInLocalWeekYear() {
    return this.isValid ? weeksInWeekYear(this.localWeekYear, this.loc.getMinDaysInFirstWeek(), this.loc.getStartOfWeek()) : NaN;
  }
  resolvedLocaleOptions(opts = {}) {
    let { locale, numberingSystem, calendar } = Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this);
    return { locale, numberingSystem, outputCalendar: calendar };
  }
  toUTC(offset$2 = 0, opts = {}) {
    return this.setZone(FixedOffsetZone$2.instance(offset$2), opts);
  }
  toLocal() {
    return this.setZone(Settings.defaultZone);
  }
  setZone(zone, { keepLocalTime = false, keepCalendarTime = false } = {}) {
    if (zone = normalizeZone(zone, Settings.defaultZone), zone.equals(this.zone)) return this;
    if (zone.isValid) {
      let newTS = this.ts;
      if (keepLocalTime || keepCalendarTime) {
        let offsetGuess = zone.offset(this.ts), asObj = this.toObject();
        [newTS] = objToTS(asObj, offsetGuess, zone);
      }
      return clone(this, { ts: newTS, zone });
    } else return DateTime3.invalid(unsupportedZone(zone));
  }
  reconfigure({ locale, numberingSystem, outputCalendar } = {}) {
    let loc = this.loc.clone({ locale, numberingSystem, outputCalendar });
    return clone(this, { loc });
  }
  setLocale(locale) {
    return this.reconfigure({ locale });
  }
  set(values$3) {
    if (!this.isValid) return this;
    let normalized = normalizeObject(values$3, normalizeUnitWithLocalWeeks), { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, this.loc), settingWeekStuff = !isUndefined$2(normalized.weekYear) || !isUndefined$2(normalized.weekNumber) || !isUndefined$2(normalized.weekday), containsOrdinal = !isUndefined$2(normalized.ordinal), containsGregorYear = !isUndefined$2(normalized.year), containsGregorMD = !isUndefined$2(normalized.month) || !isUndefined$2(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new ConflictingSpecificationError(`Can't mix weekYear/weekNumber units with year/month/day or ordinals`);
    if (containsGregorMD && containsOrdinal) throw new ConflictingSpecificationError(`Can't mix ordinal dates with month/day`);
    let mixed;
    settingWeekStuff ? mixed = weekToGregorian({ ...gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek), ...normalized }, minDaysInFirstWeek, startOfWeek) : isUndefined$2(normalized.ordinal) ? (mixed = { ...this.toObject(), ...normalized }, isUndefined$2(normalized.day) && (mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day))) : mixed = ordinalToGregorian({ ...gregorianToOrdinal(this.c), ...normalized });
    let [ts, o$2] = objToTS(mixed, this.o, this.zone);
    return clone(this, { ts, o: o$2 });
  }
  plus(duration$1) {
    if (!this.isValid) return this;
    let dur = Duration.fromDurationLike(duration$1);
    return clone(this, adjustTime(this, dur));
  }
  minus(duration$1) {
    if (!this.isValid) return this;
    let dur = Duration.fromDurationLike(duration$1).negate();
    return clone(this, adjustTime(this, dur));
  }
  startOf(unit, { useLocaleWeeks = false } = {}) {
    if (!this.isValid) return this;
    let o$2 = {}, normalizedUnit = Duration.normalizeUnit(unit);
    switch (normalizedUnit) {
      case `years`:
        o$2.month = 1;
      case `quarters`:
      case `months`:
        o$2.day = 1;
      case `weeks`:
      case `days`:
        o$2.hour = 0;
      case `hours`:
        o$2.minute = 0;
      case `minutes`:
        o$2.second = 0;
      case `seconds`:
        o$2.millisecond = 0;
        break;
    }
    if (normalizedUnit === `weeks`) if (useLocaleWeeks) {
      let startOfWeek = this.loc.getStartOfWeek(), { weekday } = this;
      weekday < startOfWeek && (o$2.weekNumber = this.weekNumber - 1), o$2.weekday = startOfWeek;
    } else o$2.weekday = 1;
    if (normalizedUnit === `quarters`) {
      let q = Math.ceil(this.month / 3);
      o$2.month = (q - 1) * 3 + 1;
    }
    return this.set(o$2);
  }
  endOf(unit, opts) {
    return this.isValid ? this.plus({ [unit]: 1 }).startOf(unit, opts).minus(1) : this;
  }
  toFormat(fmt, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID;
  }
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : INVALID;
  }
  toLocaleParts(opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
  }
  toISO({ format = `extended`, suppressSeconds = false, suppressMilliseconds = false, includeOffset = true, extendedZone = false, precision = `milliseconds` } = {}) {
    if (!this.isValid) return null;
    precision = normalizeUnit(precision);
    let ext = format === `extended`, c$12 = toISODate(this, ext, precision);
    return orderedUnits.indexOf(precision) >= 3 && (c$12 += `T`), c$12 += toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision), c$12;
  }
  toISODate({ format = `extended`, precision = `day` } = {}) {
    return this.isValid ? toISODate(this, format === `extended`, normalizeUnit(precision)) : null;
  }
  toISOWeekDate() {
    return toTechFormat(this, `kkkk-'W'WW-c`);
  }
  toISOTime({ suppressMilliseconds = false, suppressSeconds = false, includeOffset = true, includePrefix = false, extendedZone = false, format = `extended`, precision = `milliseconds` } = {}) {
    if (!this.isValid) return null;
    precision = normalizeUnit(precision);
    let c$12 = includePrefix && orderedUnits.indexOf(precision) >= 3 ? `T` : ``;
    return c$12 + toISOTime(this, format === `extended`, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision);
  }
  toRFC2822() {
    return toTechFormat(this, `EEE, dd LLL yyyy HH:mm:ss ZZZ`, false);
  }
  toHTTP() {
    return toTechFormat(this.toUTC(), `EEE, dd LLL yyyy HH:mm:ss 'GMT'`);
  }
  toSQLDate() {
    return this.isValid ? toISODate(this, true) : null;
  }
  toSQLTime({ includeOffset = true, includeZone = false, includeOffsetSpace = true } = {}) {
    let fmt = `HH:mm:ss.SSS`;
    return (includeZone || includeOffset) && (includeOffsetSpace && (fmt += ` `), includeZone ? fmt += `z` : includeOffset && (fmt += `ZZ`)), toTechFormat(this, fmt, true);
  }
  toSQL(opts = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(opts)}` : null;
  }
  toString() {
    return this.isValid ? this.toISO() : INVALID;
  }
  [Symbol.for(`nodejs.util.inspect.custom`)]() {
    return this.isValid ? `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }` : `DateTime { Invalid, reason: ${this.invalidReason} }`;
  }
  valueOf() {
    return this.toMillis();
  }
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  toJSON() {
    return this.toISO();
  }
  toBSON() {
    return this.toJSDate();
  }
  toObject(opts = {}) {
    if (!this.isValid) return {};
    let base$3 = { ...this.c };
    return opts.includeConfig && (base$3.outputCalendar = this.outputCalendar, base$3.numberingSystem = this.loc.numberingSystem, base$3.locale = this.loc.locale), base$3;
  }
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  diff(otherDateTime, unit = `milliseconds`, opts = {}) {
    if (!this.isValid || !otherDateTime.isValid) return Duration.invalid(`created by diffing an invalid DateTime`);
    let durOpts = { locale: this.locale, numberingSystem: this.numberingSystem, ...opts }, units = maybeArray(unit).map(Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = diff$2(earlier, later, units, durOpts);
    return otherIsLater ? diffed.negate() : diffed;
  }
  diffNow(unit = `milliseconds`, opts = {}) {
    return this.diff(DateTime3.now(), unit, opts);
  }
  until(otherDateTime) {
    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
  }
  hasSame(otherDateTime, unit, opts) {
    if (!this.isValid) return false;
    let inputMs = otherDateTime.valueOf(), adjustedToZone = this.setZone(otherDateTime.zone, { keepLocalTime: true });
    return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
  }
  equals(other) {
    return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
  }
  toRelative(options = {}) {
    if (!this.isValid) return null;
    let base$3 = options.base || DateTime3.fromObject({}, { zone: this.zone }), padding = options.padding ? this < base$3 ? -options.padding : options.padding : 0, units = [`years`, `months`, `days`, `hours`, `minutes`, `seconds`], unit = options.unit;
    return Array.isArray(options.unit) && (units = options.unit, unit = void 0), diffRelative(base$3, this.plus(padding), { ...options, numeric: `always`, units, unit });
  }
  toRelativeCalendar(options = {}) {
    return this.isValid ? diffRelative(options.base || DateTime3.fromObject({}, { zone: this.zone }), this, { ...options, numeric: `auto`, units: [`years`, `months`, `days`], calendary: true }) : null;
  }
  static min(...dateTimes) {
    if (!dateTimes.every(DateTime3.isDateTime)) throw new InvalidArgumentError(`min requires all arguments be DateTimes`);
    return bestBy(dateTimes, (i$4) => i$4.valueOf(), Math.min);
  }
  static max(...dateTimes) {
    if (!dateTimes.every(DateTime3.isDateTime)) throw new InvalidArgumentError(`max requires all arguments be DateTimes`);
    return bestBy(dateTimes, (i$4) => i$4.valueOf(), Math.max);
  }
  static fromFormatExplain(text, fmt, options = {}) {
    let { locale = null, numberingSystem = null } = options, localeToUse = Locale.fromOpts({ locale, numberingSystem, defaultToEN: true });
    return explainFromTokens(localeToUse, text, fmt);
  }
  static fromStringExplain(text, fmt, options = {}) {
    return DateTime3.fromFormatExplain(text, fmt, options);
  }
  static buildFormatParser(fmt, options = {}) {
    let { locale = null, numberingSystem = null } = options, localeToUse = Locale.fromOpts({ locale, numberingSystem, defaultToEN: true });
    return new TokenParser(localeToUse, fmt);
  }
  static fromFormatParser(text, formatParser, opts = {}) {
    if (isUndefined$2(text) || isUndefined$2(formatParser)) throw new InvalidArgumentError(`fromFormatParser requires an input string and a format parser`);
    let { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({ locale, numberingSystem, defaultToEN: true });
    if (!localeToUse.equals(formatParser.locale)) throw new InvalidArgumentError(`fromFormatParser called with a locale of ${localeToUse}, but the format parser was created for ${formatParser.locale}`);
    let { result, zone, specificOffset, invalidReason } = formatParser.explainFromTokens(text);
    return invalidReason ? DateTime3.invalid(invalidReason) : parseDataToDateTime(result, zone, opts, `format ${formatParser.format}`, text, specificOffset);
  }
  static get DATE_SHORT() {
    return DATE_SHORT;
  }
  static get DATE_MED() {
    return DATE_MED;
  }
  static get DATE_MED_WITH_WEEKDAY() {
    return DATE_MED_WITH_WEEKDAY;
  }
  static get DATE_FULL() {
    return DATE_FULL;
  }
  static get DATE_HUGE() {
    return DATE_HUGE;
  }
  static get TIME_SIMPLE() {
    return TIME_SIMPLE;
  }
  static get TIME_WITH_SECONDS() {
    return TIME_WITH_SECONDS;
  }
  static get TIME_WITH_SHORT_OFFSET() {
    return TIME_WITH_SHORT_OFFSET;
  }
  static get TIME_WITH_LONG_OFFSET() {
    return TIME_WITH_LONG_OFFSET;
  }
  static get TIME_24_SIMPLE() {
    return TIME_24_SIMPLE;
  }
  static get TIME_24_WITH_SECONDS() {
    return TIME_24_WITH_SECONDS;
  }
  static get TIME_24_WITH_SHORT_OFFSET() {
    return TIME_24_WITH_SHORT_OFFSET;
  }
  static get TIME_24_WITH_LONG_OFFSET() {
    return TIME_24_WITH_LONG_OFFSET;
  }
  static get DATETIME_SHORT() {
    return DATETIME_SHORT;
  }
  static get DATETIME_SHORT_WITH_SECONDS() {
    return DATETIME_SHORT_WITH_SECONDS;
  }
  static get DATETIME_MED() {
    return DATETIME_MED;
  }
  static get DATETIME_MED_WITH_SECONDS() {
    return DATETIME_MED_WITH_SECONDS;
  }
  static get DATETIME_MED_WITH_WEEKDAY() {
    return DATETIME_MED_WITH_WEEKDAY;
  }
  static get DATETIME_FULL() {
    return DATETIME_FULL;
  }
  static get DATETIME_FULL_WITH_SECONDS() {
    return DATETIME_FULL_WITH_SECONDS;
  }
  static get DATETIME_HUGE() {
    return DATETIME_HUGE;
  }
  static get DATETIME_HUGE_WITH_SECONDS() {
    return DATETIME_HUGE_WITH_SECONDS;
  }
};
function friendlyDateTime(dateTimeish) {
  if (DateTime.isDateTime(dateTimeish)) return dateTimeish;
  if (dateTimeish && dateTimeish.valueOf && isNumber$1(dateTimeish.valueOf())) return DateTime.fromJSDate(dateTimeish);
  if (dateTimeish && typeof dateTimeish == `object`) return DateTime.fromObject(dateTimeish);
  throw new InvalidArgumentError(`Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`);
}
var require_dayjs_min = __commonJSMin$1((exports$12, module2) => {
  (function(t$7, e$22) {
    typeof exports$12 == `object` && module2 !== void 0 ? module2.exports = e$22() : typeof define == `function` && define.amd ? define(e$22) : (t$7 = typeof globalThis < `u` ? globalThis : t$7 || self).dayjs = e$22();
  })(exports$12, function() {
    var t$7 = 1e3, e$22 = 6e4, n$4 = 36e5, r$2 = `millisecond`, i$4 = `second`, s$6 = `minute`, u = `hour`, a$22 = `day`, o$2 = `week`, c$12 = `month`, f$32 = `quarter`, h$1 = `year`, d$12 = `date`, l$4 = `Invalid Date`, $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y$1 = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M$1 = { name: `en`, weekdays: `Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday`.split(`_`), months: `January_February_March_April_May_June_July_August_September_October_November_December`.split(`_`), ordinal: function(t$8) {
      var e$3 = [`th`, `st`, `nd`, `rd`], n$5 = t$8 % 100;
      return `[` + t$8 + (e$3[(n$5 - 20) % 10] || e$3[n$5] || e$3[0]) + `]`;
    } }, m$3 = function(t$8, e$3, n$5) {
      var r$3 = String(t$8);
      return !r$3 || r$3.length >= e$3 ? t$8 : `` + Array(e$3 + 1 - r$3.length).join(n$5) + t$8;
    }, v$1 = { s: m$3, z: function(t$8) {
      var e$3 = -t$8.utcOffset(), n$5 = Math.abs(e$3), r$3 = Math.floor(n$5 / 60), i$5 = n$5 % 60;
      return (e$3 <= 0 ? `+` : `-`) + m$3(r$3, 2, `0`) + `:` + m$3(i$5, 2, `0`);
    }, m: function t$8(e$3, n$5) {
      if (e$3.date() < n$5.date()) return -t$8(n$5, e$3);
      var r$3 = 12 * (n$5.year() - e$3.year()) + (n$5.month() - e$3.month()), i$5 = e$3.clone().add(r$3, c$12), s$7 = n$5 - i$5 < 0, u$1 = e$3.clone().add(r$3 + (s$7 ? -1 : 1), c$12);
      return +(-(r$3 + (n$5 - i$5) / (s$7 ? i$5 - u$1 : u$1 - i$5)) || 0);
    }, a: function(t$8) {
      return t$8 < 0 ? Math.ceil(t$8) || 0 : Math.floor(t$8);
    }, p: function(t$8) {
      return { M: c$12, y: h$1, w: o$2, d: a$22, D: d$12, h: u, m: s$6, s: i$4, ms: r$2, Q: f$32 }[t$8] || String(t$8 || ``).toLowerCase().replace(/s$/, ``);
    }, u: function(t$8) {
      return t$8 === void 0;
    } }, g$22 = `en`, D = {};
    D[g$22] = M$1;
    var p$1 = `$isDayjsObject`, S = function(t$8) {
      return t$8 instanceof _ || !(!t$8 || !t$8[p$1]);
    }, w$1 = function t$8(e$3, n$5, r$3) {
      var i$5;
      if (!e$3) return g$22;
      if (typeof e$3 == `string`) {
        var s$7 = e$3.toLowerCase();
        D[s$7] && (i$5 = s$7), n$5 && (D[s$7] = n$5, i$5 = s$7);
        var u$1 = e$3.split(`-`);
        if (!i$5 && u$1.length > 1) return t$8(u$1[0]);
      } else {
        var a$3 = e$3.name;
        D[a$3] = e$3, i$5 = a$3;
      }
      return !r$3 && i$5 && (g$22 = i$5), i$5 || !r$3 && g$22;
    }, O = function(t$8, e$3) {
      if (S(t$8)) return t$8.clone();
      var n$5 = typeof e$3 == `object` ? e$3 : {};
      return n$5.date = t$8, n$5.args = arguments, new _(n$5);
    }, b2 = v$1;
    b2.l = w$1, b2.i = S, b2.w = function(t$8, e$3) {
      return O(t$8, { locale: e$3.$L, utc: e$3.$u, x: e$3.$x, $offset: e$3.$offset });
    };
    var _ = (function() {
      function M$2(t$8) {
        this.$L = w$1(t$8.locale, null, true), this.parse(t$8), this.$x = this.$x || t$8.x || {}, this[p$1] = true;
      }
      var m$4 = M$2.prototype;
      return m$4.parse = function(t$8) {
        this.$d = (function(t$9) {
          var e$3 = t$9.date, n$5 = t$9.utc;
          if (e$3 === null) return /* @__PURE__ */ new Date(NaN);
          if (b2.u(e$3)) return /* @__PURE__ */ new Date();
          if (e$3 instanceof Date) return new Date(e$3);
          if (typeof e$3 == `string` && !/Z$/i.test(e$3)) {
            var r$3 = e$3.match($);
            if (r$3) {
              var i$5 = r$3[2] - 1 || 0, s$7 = (r$3[7] || `0`).substring(0, 3);
              return n$5 ? new Date(Date.UTC(r$3[1], i$5, r$3[3] || 1, r$3[4] || 0, r$3[5] || 0, r$3[6] || 0, s$7)) : new Date(r$3[1], i$5, r$3[3] || 1, r$3[4] || 0, r$3[5] || 0, r$3[6] || 0, s$7);
            }
          }
          return new Date(e$3);
        })(t$8), this.init();
      }, m$4.init = function() {
        var t$8 = this.$d;
        this.$y = t$8.getFullYear(), this.$M = t$8.getMonth(), this.$D = t$8.getDate(), this.$W = t$8.getDay(), this.$H = t$8.getHours(), this.$m = t$8.getMinutes(), this.$s = t$8.getSeconds(), this.$ms = t$8.getMilliseconds();
      }, m$4.$utils = function() {
        return b2;
      }, m$4.isValid = function() {
        return this.$d.toString() !== l$4;
      }, m$4.isSame = function(t$8, e$3) {
        var n$5 = O(t$8);
        return this.startOf(e$3) <= n$5 && n$5 <= this.endOf(e$3);
      }, m$4.isAfter = function(t$8, e$3) {
        return O(t$8) < this.startOf(e$3);
      }, m$4.isBefore = function(t$8, e$3) {
        return this.endOf(e$3) < O(t$8);
      }, m$4.$g = function(t$8, e$3, n$5) {
        return b2.u(t$8) ? this[e$3] : this.set(n$5, t$8);
      }, m$4.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, m$4.valueOf = function() {
        return this.$d.getTime();
      }, m$4.startOf = function(t$8, e$3) {
        var n$5 = this, r$3 = !!b2.u(e$3) || e$3, f$4 = b2.p(t$8), l$5 = function(t$9, e$4) {
          var i$5 = b2.w(n$5.$u ? Date.UTC(n$5.$y, e$4, t$9) : new Date(n$5.$y, e$4, t$9), n$5);
          return r$3 ? i$5 : i$5.endOf(a$22);
        }, $$1 = function(t$9, e$4) {
          return b2.w(n$5.toDate()[t$9].apply(n$5.toDate(`s`), (r$3 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e$4)), n$5);
        }, y$2 = this.$W, M$3 = this.$M, m$5 = this.$D, v$2 = `set` + (this.$u ? `UTC` : ``);
        switch (f$4) {
          case h$1:
            return r$3 ? l$5(1, 0) : l$5(31, 11);
          case c$12:
            return r$3 ? l$5(1, M$3) : l$5(0, M$3 + 1);
          case o$2:
            var g$3 = this.$locale().weekStart || 0, D$1 = (y$2 < g$3 ? y$2 + 7 : y$2) - g$3;
            return l$5(r$3 ? m$5 - D$1 : m$5 + (6 - D$1), M$3);
          case a$22:
          case d$12:
            return $$1(v$2 + `Hours`, 0);
          case u:
            return $$1(v$2 + `Minutes`, 1);
          case s$6:
            return $$1(v$2 + `Seconds`, 2);
          case i$4:
            return $$1(v$2 + `Milliseconds`, 3);
          default:
            return this.clone();
        }
      }, m$4.endOf = function(t$8) {
        return this.startOf(t$8, false);
      }, m$4.$set = function(t$8, e$3) {
        var n$5, o$3 = b2.p(t$8), f$4 = `set` + (this.$u ? `UTC` : ``), l$5 = (n$5 = {}, n$5[a$22] = f$4 + `Date`, n$5[d$12] = f$4 + `Date`, n$5[c$12] = f$4 + `Month`, n$5[h$1] = f$4 + `FullYear`, n$5[u] = f$4 + `Hours`, n$5[s$6] = f$4 + `Minutes`, n$5[i$4] = f$4 + `Seconds`, n$5[r$2] = f$4 + `Milliseconds`, n$5)[o$3], $$1 = o$3 === a$22 ? this.$D + (e$3 - this.$W) : e$3;
        if (o$3 === c$12 || o$3 === h$1) {
          var y$2 = this.clone().set(d$12, 1);
          y$2.$d[l$5]($$1), y$2.init(), this.$d = y$2.set(d$12, Math.min(this.$D, y$2.daysInMonth())).$d;
        } else l$5 && this.$d[l$5]($$1);
        return this.init(), this;
      }, m$4.set = function(t$8, e$3) {
        return this.clone().$set(t$8, e$3);
      }, m$4.get = function(t$8) {
        return this[b2.p(t$8)]();
      }, m$4.add = function(r$3, f$4) {
        var d$2, l$5 = this;
        r$3 = Number(r$3);
        var $$1 = b2.p(f$4), y$2 = function(t$8) {
          var e$3 = O(l$5);
          return b2.w(e$3.date(e$3.date() + Math.round(t$8 * r$3)), l$5);
        };
        if ($$1 === c$12) return this.set(c$12, this.$M + r$3);
        if ($$1 === h$1) return this.set(h$1, this.$y + r$3);
        if ($$1 === a$22) return y$2(1);
        if ($$1 === o$2) return y$2(7);
        var M$3 = (d$2 = {}, d$2[s$6] = e$22, d$2[u] = n$4, d$2[i$4] = t$7, d$2)[$$1] || 1, m$5 = this.$d.getTime() + r$3 * M$3;
        return b2.w(m$5, this);
      }, m$4.subtract = function(t$8, e$3) {
        return this.add(-1 * t$8, e$3);
      }, m$4.format = function(t$8) {
        var e$3 = this, n$5 = this.$locale();
        if (!this.isValid()) return n$5.invalidDate || l$4;
        var r$3 = t$8 || `YYYY-MM-DDTHH:mm:ssZ`, i$5 = b2.z(this), s$7 = this.$H, u$1 = this.$m, a$3 = this.$M, o$3 = n$5.weekdays, c$2 = n$5.months, f$4 = n$5.meridiem, h$2 = function(t$9, n$6, i$6, s$8) {
          return t$9 && (t$9[n$6] || t$9(e$3, r$3)) || i$6[n$6].slice(0, s$8);
        }, d$2 = function(t$9) {
          return b2.s(s$7 % 12 || 12, t$9, `0`);
        }, $$1 = f$4 || function(t$9, e$4, n$6) {
          var r$4 = t$9 < 12 ? `AM` : `PM`;
          return n$6 ? r$4.toLowerCase() : r$4;
        };
        return r$3.replace(y$1, function(t$9, r$4) {
          return r$4 || (function(t$10) {
            switch (t$10) {
              case `YY`:
                return String(e$3.$y).slice(-2);
              case `YYYY`:
                return b2.s(e$3.$y, 4, `0`);
              case `M`:
                return a$3 + 1;
              case `MM`:
                return b2.s(a$3 + 1, 2, `0`);
              case `MMM`:
                return h$2(n$5.monthsShort, a$3, c$2, 3);
              case `MMMM`:
                return h$2(c$2, a$3);
              case `D`:
                return e$3.$D;
              case `DD`:
                return b2.s(e$3.$D, 2, `0`);
              case `d`:
                return String(e$3.$W);
              case `dd`:
                return h$2(n$5.weekdaysMin, e$3.$W, o$3, 2);
              case `ddd`:
                return h$2(n$5.weekdaysShort, e$3.$W, o$3, 3);
              case `dddd`:
                return o$3[e$3.$W];
              case `H`:
                return String(s$7);
              case `HH`:
                return b2.s(s$7, 2, `0`);
              case `h`:
                return d$2(1);
              case `hh`:
                return d$2(2);
              case `a`:
                return $$1(s$7, u$1, true);
              case `A`:
                return $$1(s$7, u$1, false);
              case `m`:
                return String(u$1);
              case `mm`:
                return b2.s(u$1, 2, `0`);
              case `s`:
                return String(e$3.$s);
              case `ss`:
                return b2.s(e$3.$s, 2, `0`);
              case `SSS`:
                return b2.s(e$3.$ms, 3, `0`);
              case `Z`:
                return i$5;
            }
            return null;
          })(t$9) || i$5.replace(`:`, ``);
        });
      }, m$4.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, m$4.diff = function(r$3, d$2, l$5) {
        var $$1, y$2 = this, M$3 = b2.p(d$2), m$5 = O(r$3), v$2 = (m$5.utcOffset() - this.utcOffset()) * e$22, g$3 = this - m$5, D$1 = function() {
          return b2.m(y$2, m$5);
        };
        switch (M$3) {
          case h$1:
            $$1 = D$1() / 12;
            break;
          case c$12:
            $$1 = D$1();
            break;
          case f$32:
            $$1 = D$1() / 3;
            break;
          case o$2:
            $$1 = (g$3 - v$2) / 6048e5;
            break;
          case a$22:
            $$1 = (g$3 - v$2) / 864e5;
            break;
          case u:
            $$1 = g$3 / n$4;
            break;
          case s$6:
            $$1 = g$3 / e$22;
            break;
          case i$4:
            $$1 = g$3 / t$7;
            break;
          default:
            $$1 = g$3;
        }
        return l$5 ? $$1 : b2.a($$1);
      }, m$4.daysInMonth = function() {
        return this.endOf(c$12).$D;
      }, m$4.$locale = function() {
        return D[this.$L];
      }, m$4.locale = function(t$8, e$3) {
        if (!t$8) return this.$L;
        var n$5 = this.clone(), r$3 = w$1(t$8, e$3, true);
        return r$3 && (n$5.$L = r$3), n$5;
      }, m$4.clone = function() {
        return b2.w(this.$d, this);
      }, m$4.toDate = function() {
        return new Date(this.valueOf());
      }, m$4.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, m$4.toISOString = function() {
        return this.$d.toISOString();
      }, m$4.toString = function() {
        return this.$d.toUTCString();
      }, M$2;
    })(), k = _.prototype;
    return O.prototype = k, [[`$ms`, r$2], [`$s`, i$4], [`$m`, s$6], [`$H`, u], [`$W`, a$22], [`$M`, c$12], [`$y`, h$1], [`$D`, d$12]].forEach(function(t$8) {
      k[t$8[1]] = function(e$3) {
        return this.$g(e$3, t$8[0], t$8[1]);
      };
    }), O.extend = function(t$8, e$3) {
      return t$8.$i || (t$8(e$3, _, O), t$8.$i = true), O;
    }, O.locale = w$1, O.isDayjs = S, O.unix = function(t$8) {
      return O(1e3 * t$8);
    }, O.en = D[g$22], O.Ls = D, O.p = {}, O;
  });
});
const isInstanceOf$1 = (value, type, ctor) => {
  if (ctor !== void 0 && value instanceof ctor || ctor !== void 0 && typeof ctor[Symbol.hasInstance] == `function` && ctor[Symbol.hasInstance](value)) return true;
  if (typeof value == `object` && value) {
    let valueWithConstructor = value, constructorName = valueWithConstructor.constructor?.name;
    return constructorName === type;
  }
  return false;
}, isLuxonDateTime$1 = (value) => value instanceof DateTime ? true : typeof value != `object` || !value || !(`isLuxonDateTime` in value) ? false : value.isLuxonDateTime === true, isPlainObject = (value) => typeof value == `object` && !!value && !Array.isArray(value), isDateObjectUnits = (value) => {
  if (!isPlainObject(value)) return false;
  let keys$10 = Object.keys(value);
  if (keys$10.length === 0) return false;
  let valids = [`year`, `month`, `day`, `ordinal`, `weekYear`, `localWeekYear`, `weekNumber`, `localWeekNumber`, `weekday`, `localWeekday`, `hour`, `minute`, `second`, `millisecond`], invalidKeys = keys$10.filter((key) => !valids.includes(key));
  return invalidKeys.length > 0 ? false : keys$10.every((key) => {
    let val = value[key];
    return typeof val == `number` || val === void 0;
  });
};
var import_dayjs_min = __toESM(require_dayjs_min());
Settings.defaultZone = `utc`, Settings.defaultLocale = `en`, Settings.defaultWeekSettings = { firstDay: 7, minimalDays: 4, weekend: [6, 7] }, Settings.throwOnInvalid = false;
const removeComments = (str) => (str = str.replace(/\/\/.*$/gm, ``), str = str.replace(/\/\*[\s\S]*?\*\//g, ``), str), extractFunctionBody = (fn$1) => {
  let fnString = fn$1.toString();
  if (fnString.includes(`[native code]`)) throw Error(`Cannot extract body from native function`);
  let cleanedString = removeComments(fnString), arrowMatch = cleanedString.match(/^\s*(?:async\s+)?(?:\([^)]*\)|[^=]+)\s*=>\s*(.+)$/s);
  if (arrowMatch && !arrowMatch[1].trim().startsWith(`{`)) {
    let expression$2 = arrowMatch[1].trim().replace(/;?\s*$/, ``);
    if (expression$2.startsWith(`(`) && expression$2.endsWith(`)`)) {
      let unwrapped = expression$2.slice(1, -1).trim();
      if (unwrapped.startsWith(`{`) && unwrapped.endsWith(`}`)) return `return ${unwrapped}`;
    }
    return `return ${expression$2}`;
  }
  let braceCount = 0, inString = false, stringChar = ``, inTemplate = false, escaped = false, firstBrace = -1, lastBrace = -1;
  for (let [i$4, char] of Array.from(cleanedString).entries()) {
    if (escaped) {
      escaped = false;
      continue;
    }
    if (char === `\\`) {
      escaped = true;
      continue;
    }
    if (!inString && !inTemplate) {
      if (char === `"` || char === `'`) {
        inString = true, stringChar = char;
        continue;
      }
      if (char === "`") {
        inTemplate = true;
        continue;
      }
    } else if (inString && char === stringChar) {
      inString = false;
      continue;
    } else if (inTemplate && char === "`") {
      inTemplate = false;
      continue;
    }
    if (!inString && !inTemplate) {
      if (char === `{`) firstBrace === -1 && (firstBrace = i$4), braceCount++;
      else if (char === `}` && (braceCount--, braceCount === 0 && firstBrace !== -1)) {
        lastBrace = i$4;
        break;
      }
    }
  }
  if (firstBrace === -1 || lastBrace === -1 || firstBrace >= lastBrace) throw Error(`Unable to extract function body - no valid braces found`);
  let body = cleanedString.slice(firstBrace + 1, lastBrace).trim();
  if (/\breturn\b/.test(body)) return body;
  let beforeBrace = cleanedString.slice(0, firstBrace).trim();
  if (beforeBrace.endsWith(`=>`) || beforeBrace.endsWith(`=> (`) || beforeBrace.endsWith(`=>(`)) {
    let objectLiteralPattern = /^\s*(?:[a-zA-Z_$][\w$]*\s*:|["'`][^"'`]+["'`]\s*:|get\s+|set\s+|\[)/;
    if (objectLiteralPattern.test(body)) return `return {${body}}`;
  }
  return `return ${body}`;
}, compileCallback = (body) => {
  try {
    return Function(`dt`, `helpers`, body);
  } catch (error) {
    throw Error(`Failed to compile callback: ${error instanceof Error ? error.message : String(error)}`);
  }
}, messages$2 = { "datetime.base": `{{#label}} must be a datetime value`, "datetime.exactly": `{{#label}} must be a datetime exactly equal to {{#limit}}`, "datetime.equals": `{{#label}} must be a datetime equal to {{#limit}}`, "datetime.after": `{{#label}} must be a datetime after {{#limit}}`, "datetime.greater": `{{#label}} must be a datetime after {{#limit}}`, "datetime.before": `{{#label}} must be a datetime before {{#limit}}`, "datetime.less": `{{#label}} must be a datetime before {{#limit}}`, "datetime.afterOrEqual": `{{#label}} must be a datetime after or equal to {{#limit}}`, "datetime.min": `{{#label}} must be a datetime after or equal to {{#limit}}`, "datetime.beforeOrEqual": `{{#label}} must be a datetime before or equal to {{#limit}}`, "datetime.max": `{{#label}} must be a datetime before or equal to {{#limit}}`, "datetime.weekend": `{{#label}} is not a weekend`, "datetime.weekday": `{{#label}} is not a weekday` }, compare$12 = (value, limit, operator$1) => {
  switch (value = toDateTime(value), limit = toDateTime(limit), operator$1) {
    case `===`:
      return value.equals(limit);
    case `=`:
      return value.hasSame(limit, `millisecond`);
    case `>`:
      return value > limit;
    case `<`:
      return value < limit;
    case `>=`:
      return value >= limit;
    case `<=`:
      return value <= limit;
    default:
      return false;
  }
}, backToDateTime = (value) => value instanceof DateTime ? value : DateTime.fromObject(value.c, { zone: value.zone }).setLocale(value.loc.locale), toDateTime = (value, format) => {
  if (isLuxonDateTime$1(value)) return value instanceof DateTime ? value : backToDateTime(value);
  if (isInstanceOf$1(value, `Date`, Date)) return DateTime.fromJSDate(value);
  if (isInstanceOf$1(value, `Dayjs`) || import_dayjs_min.default.isDayjs(value)) return DateTime.fromJSDate(value.toDate());
  if (isDateObjectUnits(value)) return DateTime.fromObject(value, { zone: `utc` });
  if (typeof value == `number`) {
    let day = (0, import_dayjs_min.default)(value);
    if (day.isValid()) return DateTime.fromJSDate(day.toDate(), { zone: `utc` });
  }
  if (typeof value == `string`) {
    let isoDateTime = DateTime.fromISO(value, { setZone: true });
    if (isoDateTime.isValid) return isoDateTime;
    let luxonMethods = [DateTime.fromRFC2822, DateTime.fromHTTP, DateTime.fromSQL];
    for (let method$1 of luxonMethods) {
      let dateTime = method$1(value, { zone: `utc` });
      if (dateTime.isValid) return dateTime;
    }
    let day = (0, import_dayjs_min.default)(value);
    if (day.isValid()) return DateTime.fromJSDate(day.toDate(), { zone: `utc` });
  }
  return false;
}, coerce$2 = (value, helpers$8) => {
  let isEmpty$13 = value == null, isRequired = helpers$8.schema._flags.presence === `required`;
  if (isEmpty$13 && !isRequired) return { value: null };
  if (isEmpty$13 && isRequired) return { value, errors: [helpers$8.error(`any.required`, { label: helpers$8.schema._flags.label })] };
  let converted = toDateTime(value);
  if (converted) {
    let { schema: schema$2, prefs } = helpers$8;
    if (prefs.convert) {
      let returnable = converted;
      if (schema$2._flags.setZone && Array.isArray(schema$2._flags.setZone)) if (Array.isArray(schema$2._flags.setZone[0])) Array.from(schema$2._flags.setZone).forEach((f$32) => {
        if (!f$32) return;
        let [zone, opts] = Array.from(f$32);
        switch (zone) {
          case `utc`:
          case `UTC`:
            returnable = returnable.toUTC();
            break;
          case `local`:
            returnable = returnable.toLocal();
            break;
          default:
            returnable = returnable.setZone(zone, opts);
            break;
        }
      });
      else {
        let [zone, opts] = Array.from(schema$2._flags.setZone);
        switch (zone) {
          case `utc`:
          case `UTC`:
            returnable = returnable.toUTC();
            break;
          case `local`:
            returnable = returnable.toLocal();
            break;
          default:
            returnable = returnable.setZone(zone, opts);
            break;
        }
      }
      if (schema$2._flags.setLocale && (returnable = returnable.setLocale(schema$2._flags.setLocale)), schema$2._flags.toFormat) {
        if (Array.isArray(schema$2._flags.toFormat)) {
          let fmt = Array.from(schema$2._flags.toFormat), method$1 = fmt.shift(), processedArgs = fmt.map((arg) => {
            if (typeof arg == `string` && arg.includes(`return`)) {
              let compiledFn = compileCallback(arg);
              return compiledFn(returnable, helpers$8);
            }
            return arg;
          });
          returnable = returnable[method$1](...processedArgs);
        } else if (typeof schema$2._flags.toFormat == `string`) if (schema$2._flags.toFormat.includes(`return`)) {
          let compiledFn = compileCallback(schema$2._flags.toFormat), result = compiledFn(returnable, helpers$8);
          returnable = returnable.toFormat(result);
        } else returnable = returnable.toFormat(schema$2._flags.toFormat);
      }
      return { value: returnable };
    }
    return { value: converted };
  }
  return { value, errors: [helpers$8.error(`datetime.base`, { value: String(value) })] };
}, datetime = function(joi) {
  return { type: `datetime`, base: joi.any(), coerce: { from: [`string`, `number`, `date`, `object`], method: coerce$2 }, rules: { compare: { method: false, validate(value, helpers$8, { limit }, { name: name$2, operator: operator$1 }) {
    let src$1 = toDateTime(value), threshold = toDateTime(limit);
    if (!src$1 || !threshold) return helpers$8.error(`datetime.base`, { value: isLuxonDateTime$1(value) ? value.toLocaleString(DateTime.DATETIME_MED) : String(value) });
    let valid$2 = compare$12(src$1, threshold, operator$1);
    return valid$2 ? value : helpers$8.error(`datetime.` + name$2, { limit: threshold.toLocaleString(DateTime.DATETIME_MED), value: src$1.toLocaleString(DateTime.DATETIME_MED) });
  }, args: [{ name: `limit`, ref: true, assert: (value) => isLuxonDateTime$1(toDateTime(value)), message: `must be a datetime` }] }, exactly: { method(limit) {
    return this.$_addRule({ name: `exactly`, method: `compare`, args: { limit }, operator: `===` });
  } }, equals: { method(limit) {
    return this.$_addRule({ name: `equals`, method: `compare`, args: { limit }, operator: `=` });
  } }, after: { method(limit) {
    return this.$_addRule({ name: `after`, method: `compare`, args: { limit }, operator: `>` });
  } }, greater: { method(limit) {
    return this.$_addRule({ name: `greater`, method: `compare`, args: { limit }, operator: `>` });
  } }, before: { method(limit) {
    return this.$_addRule({ name: `before`, method: `compare`, args: { limit }, operator: `<` });
  } }, less: { method(limit) {
    return this.$_addRule({ name: `less`, method: `compare`, args: { limit }, operator: `<` });
  } }, afterOrEqual: { method(limit) {
    return this.$_addRule({ name: `afterOrEqual`, method: `compare`, args: { limit }, operator: `>=` });
  } }, min: { method(limit) {
    return this.$_addRule({ name: `min`, method: `compare`, args: { limit }, operator: `>=` });
  } }, beforeOrEqual: { method(limit) {
    return this.$_addRule({ name: `beforeOrEqual`, method: `compare`, args: { limit }, operator: `<=` });
  } }, max: { method(limit) {
    return this.$_addRule({ name: `max`, method: `compare`, args: { limit }, operator: `<=` });
  } }, weekend: { method() {
    return this.$_addRule({ name: `weekend` });
  }, validate(value, helpers$8) {
    let confirmable = toDateTime(value);
    return confirmable.isWeekend ? value : helpers$8.error(`datetime.weekend`, { value: confirmable.toLocaleString(DateTime.DATE_MED) });
  } }, weekday: { method() {
    return this.$_addRule({ name: `weekday` });
  }, validate(value, helpers$8) {
    let confirmable = toDateTime(value);
    return confirmable.isWeekend ? helpers$8.error(`datetime.weekday`, { value: confirmable.toLocaleString(DateTime.DATE_MED) }) : value;
  } }, toUTC: { method() {
    return this.$_setFlag(`setZone`, [`utc`]);
  } }, toLocal: { method() {
    return this.$_setFlag(`setZone`, [`local`]);
  } }, setZone: { method(zone, opts) {
    return this.$_setFlag(`setZone`, [zone, opts]);
  } }, toFormat: { method(format) {
    let processedFormat = typeof format == `function` ? extractFunctionBody(format) : format;
    return this.$_setFlag(`toFormat`, processedFormat, { clone: true });
  } }, toLocalizedString: { method(formatOpts) {
    let processedOpts = typeof formatOpts == `function` ? extractFunctionBody(formatOpts) : formatOpts;
    return this.$_setFlag(`toFormat`, [`toLocaleString`, processedOpts], { clone: true });
  } }, toISO: { method(opts) {
    let processedOpts = opts && typeof opts == `function` ? extractFunctionBody(opts) : opts;
    return this.$_setFlag(`toFormat`, processedOpts ? [`toISO`, processedOpts] : [`toISO`], { clone: true });
  } }, toISODate: { method(opts) {
    let processedOpts = opts && typeof opts == `function` ? extractFunctionBody(opts) : opts;
    return this.$_setFlag(`toFormat`, processedOpts ? [`toISODate`, processedOpts] : [`toISODate`], { clone: true });
  } }, toISOWeekDate: { method() {
    return this.$_setFlag(`toFormat`, [`toISOWeekDate`], { clone: true });
  } }, toISOTime: { method(opts) {
    let processedOpts = opts && typeof opts == `function` ? extractFunctionBody(opts) : opts;
    return this.$_setFlag(`toFormat`, processedOpts ? [`toISOTime`, processedOpts] : [`toISOTime`], { clone: true });
  } }, toRFC2822: { method() {
    return this.$_setFlag(`toFormat`, [`toRFC2822`], { clone: true });
  } }, toHTTP: { method() {
    return this.$_setFlag(`toFormat`, [`toHTTP`], { clone: true });
  } }, toSQLDate: { method() {
    return this.$_setFlag(`toFormat`, [`toSQLDate`], { clone: true });
  } }, toSQLTime: { method(opts) {
    let processedOpts = opts && typeof opts == `function` ? extractFunctionBody(opts) : opts;
    return this.$_setFlag(`toFormat`, processedOpts ? [`toSQLTime`, processedOpts] : [`toSQLTime`], { clone: true });
  } }, toSQL: { method(opts) {
    let processedOpts = opts && typeof opts == `function` ? extractFunctionBody(opts) : opts;
    return this.$_setFlag(`toFormat`, processedOpts ? [`toSQL`, processedOpts] : [`toSQL`], { clone: true });
  } }, toMillis: { method() {
    return this.$_setFlag(`toFormat`, [`toMillis`], { clone: true });
  } }, toSeconds: { method() {
    return this.$_setFlag(`toFormat`, [`toSeconds`], { clone: true });
  } }, toUnixInteger: { method() {
    return this.$_setFlag(`toFormat`, [`toUnixInteger`], { clone: true });
  } }, toJSON: { method() {
    return this.$_setFlag(`toFormat`, [`toJSON`], { clone: true });
  } }, toBSON: { method() {
    return this.$_setFlag(`toFormat`, [`toBSON`], { clone: true });
  } }, toObject: { method(opts) {
    let config = typeof opts == `function` ? extractFunctionBody(opts) : opts?.includeConfig === void 0 ? { includeConfig: false } : { includeConfig: opts.includeConfig };
    return this.$_setFlag(`toFormat`, [`toObject`, config], { clone: true });
  } }, toJSDate: { method() {
    return this.$_setFlag(`toFormat`, [`toJSDate`], { clone: true });
  } }, toRelative: { method(opts) {
    let processedOpts = opts && typeof opts == `function` ? extractFunctionBody(opts) : opts;
    return this.$_setFlag(`toFormat`, processedOpts ? [`toRelative`, processedOpts] : [`toRelative`], { clone: true });
  } }, setLocale: { method(locale) {
    return this.$_setFlag(`setLocale`, locale);
  } } }, messages: messages$2 };
}, generate = (root$11, schema$2, args$1) => (schema$2.$_root = root$11, !schema$2._definition.args || !args$1.length ? schema$2 : schema$2._definition.args(schema$2, ...args$1)), knownMessages = { "alternatives.all": `{{#label}} does not match all of the required types`, "alternatives.any": `{{#label}} does not match any of the allowed types`, "alternatives.match": `{{#label}} does not match any of the allowed types`, "alternatives.one": `{{#label}} matches more than one allowed type`, "alternatives.types": `{{#label}} must be one of {{#types}}`, "any.custom": `{{#label}} failed custom validation because {{#error.message}}`, "any.default": `{{#label}} threw an error when running default method`, "any.failover": `{{#label}} threw an error when running failover method`, "any.invalid": `{{#label}} contains an invalid value`, "any.only": `{{#label}} must be {if(#valids.length == 1, "", "one of ")}{{#valids}}`, "any.ref": `{{#label}} {{#arg}} references {{:#ref}} which {{#reason}}`, "any.required": `{{#label}} is required`, "any.unknown": `{{#label}} is not allowed`, "array.base": `{{#label}} must be an array`, "array.excludes": `{{#label}} contains an excluded value`, "array.hasKnown": `{{#label}} does not contain at least one required match for type {:#patternLabel}`, "array.hasUnknown": `{{#label}} does not contain at least one required match`, "array.includes": `{{#label}} does not match any of the allowed types`, "array.includesRequiredBoth": `{{#label}} does not contain {{#knownMisses}} and {{#unknownMisses}} other required value(s)`, "array.includesRequiredKnowns": `{{#label}} does not contain {{#knownMisses}}`, "array.includesRequiredUnknowns": `{{#label}} does not contain {{#unknownMisses}} required value(s)`, "array.length": `{{#label}} must contain {{#limit}} items`, "array.max": `{{#label}} must contain less than or equal to {{#limit}} items`, "array.min": `{{#label}} must contain at least {{#limit}} items`, "array.orderedLength": `{{#label}} must contain at most {{#limit}} items`, "array.sort": `{{#label}} must be sorted in {#order} order by {{#by}}`, "array.sort.mismatching": `{{#label}} cannot be sorted due to mismatching types`, "array.sort.unsupported": `{{#label}} cannot be sorted due to unsupported type {#type}`, "array.sparse": `{{#label}} must not be a sparse array item`, "array.unique": `{{#label}} contains a duplicate value`, "binary.base": `{{#label}} must be a buffer or a string`, "binary.length": `{{#label}} must be {{#limit}} bytes`, "binary.max": `{{#label}} must be less than or equal to {{#limit}} bytes`, "binary.min": `{{#label}} must be at least {{#limit}} bytes`, "boolean.base": `{{#label}} must be a boolean`, "date.base": `{{#label}} must be a valid date`, "date.format": `{{#label}} must be in {msg("date.format." + #format) || #format} format`, "date.greater": `{{#label}} must be greater than {{:#limit}}`, "date.less": `{{#label}} must be less than {{:#limit}}`, "date.max": `{{#label}} must be less than or equal to {{:#limit}}`, "date.min": `{{#label}} must be greater than or equal to {{:#limit}}`, "date.format.iso": `ISO 8601 date`, "date.format.javascript": `timestamp or number of milliseconds`, "date.format.unix": `timestamp or number of seconds`, "function.arity": `{{#label}} must have an arity of {{#n}}`, "function.class": `{{#label}} must be a class`, "function.maxArity": `{{#label}} must have an arity lesser or equal to {{#n}}`, "function.minArity": `{{#label}} must have an arity greater or equal to {{#n}}`, "object.and": `{{#label}} contains {{#presentWithLabels}} without its required peers {{#missingWithLabels}}`, "object.assert": '{{#label}} is invalid because {if(#subject.key, `"` + #subject.key + `" failed to ` + (#message || "pass the assertion test"), #message || "the assertion failed")}', "object.base": `{{#label}} must be of type {{#type}}`, "object.instance": `{{#label}} must be an instance of {{:#type}}`, "object.length": `{{#label}} must have {{#limit}} key{if(#limit == 1, "", "s")}`, "object.max": `{{#label}} must have less than or equal to {{#limit}} key{if(#limit == 1, "", "s")}`, "object.min": `{{#label}} must have at least {{#limit}} key{if(#limit == 1, "", "s")}`, "object.missing": `{{#label}} must contain at least one of {{#peersWithLabels}}`, "object.nand": `{{:#mainWithLabel}} must not exist simultaneously with {{#peersWithLabels}}`, "object.oxor": `{{#label}} contains a conflict between optional exclusive peers {{#peersWithLabels}}`, "object.pattern.match": `{{#label}} keys failed to match pattern requirements`, "object.refType": `{{#label}} must be a Joi reference`, "object.regex": `{{#label}} must be a RegExp object`, "object.rename.multiple": `{{#label}} cannot rename {{:#from}} because multiple renames are disabled and another key was already renamed to {{:#to}}`, "object.rename.override": `{{#label}} cannot rename {{:#from}} because override is disabled and target {{:#to}} exists`, "object.schema": `{{#label}} must be a Joi schema of {{#type}} type`, "object.unknown": `{{#label}} is not allowed`, "object.with": `{{:#mainWithLabel}} missing required peer {{:#peerWithLabel}}`, "object.without": `{{:#mainWithLabel}} conflict with forbidden peer {{:#peerWithLabel}}`, "object.xor": `{{#label}} contains a conflict between exclusive peers {{#peersWithLabels}}`, "number.base": `{{#label}} must be a number`, "number.greater": `{{#label}} must be greater than {{#limit}}`, "number.infinity": `{{#label}} cannot be infinity`, "number.integer": `{{#label}} must be an integer`, "number.less": `{{#label}} must be less than {{#limit}}`, "number.max": `{{#label}} must be less than or equal to {{#limit}}`, "number.min": `{{#label}} must be greater than or equal to {{#limit}}`, "number.multiple": `{{#label}} must be a multiple of {{#multiple}}`, "number.negative": `{{#label}} must be a negative number`, "number.port": `{{#label}} must be a valid port`, "number.positive": `{{#label}} must be a positive number`, "number.precision": `{{#label}} must have no more than {{#limit}} decimal places`, "number.unsafe": `{{#label}} must be a safe number`, "string.alphanum": `{{#label}} must only contain alpha-numeric characters`, "string.base": `{{#label}} must be a string`, "string.base64": `{{#label}} must be a valid base64 string`, "string.creditCard": `{{#label}} must be a credit card`, "string.dataUri": `{{#label}} must be a valid dataUri string`, "string.domain": `{{#label}} must contain a valid domain name`, "string.email": `{{#label}} must be a valid email`, "string.empty": `{{#label}} is not allowed to be empty`, "string.guid": `{{#label}} must be a valid GUID`, "string.hex": `{{#label}} must only contain hexadecimal characters`, "string.hexAlign": `{{#label}} hex decoded representation must be byte aligned`, "string.hostname": `{{#label}} must be a valid hostname`, "string.ip": `{{#label}} must be a valid ip address with a {{#cidr}} CIDR`, "string.ipVersion": `{{#label}} must be a valid ip address of one of the following versions {{#version}} with a {{#cidr}} CIDR`, "string.isoDate": `{{#label}} must be in iso format`, "string.isoDuration": `{{#label}} must be a valid ISO 8601 duration`, "string.length": `{{#label}} length must be {{#limit}} characters long`, "string.lowercase": `{{#label}} must only contain lowercase characters`, "string.max": `{{#label}} length must be less than or equal to {{#limit}} characters long`, "string.min": `{{#label}} length must be at least {{#limit}} characters long`, "string.normalize": `{{#label}} must be unicode normalized in the {{#form}} form`, "string.token": `{{#label}} must only contain alpha-numeric and underscore characters`, "string.pattern.base": `{{#label}} with value {:[.]} fails to match the required pattern: {{#regex}}`, "string.pattern.name": `{{#label}} with value {:[.]} fails to match the {{#name}} pattern`, "string.pattern.invert.base": `{{#label}} with value {:[.]} matches the inverted pattern: {{#regex}}`, "string.pattern.invert.name": `{{#label}} with value {:[.]} matches the inverted {{#name}} pattern`, "string.trim": `{{#label}} must not have leading or trailing whitespace`, "string.uri": `{{#label}} must be a valid uri`, "string.uriCustomScheme": `{{#label}} must be a valid uri with a scheme matching the {{#scheme}} pattern`, "string.uriRelativeOnly": `{{#label}} must be a valid relative uri`, "string.uppercase": `{{#label}} must only contain uppercase characters`, "symbol.base": `{{#label}} must be a symbol`, "symbol.map": `{{#label}} must be one of {{#map}}`, ...messages$1, ...messages$2, ...messages, ...knexMessages, ...fqdnMessages };
countries$1.forEach((name$2, iso) => {
  knownMessages[`country.${iso}`] = name$2;
});
let globalI18nCallback;
const i18n = (toPatch) => {
  let root$11 = toPatch, joi = Object.assign({}, root$11), joiTypes = joi.types(), originalMessages = /* @__PURE__ */ new Map();
  Object.entries(knownMessages).forEach(([key, value]) => {
    originalMessages.set(key, value);
  });
  let doUpdateI18n = (callback) => {
    globalI18nCallback = callback;
    let $t = (term) => {
      if (globalI18nCallback) try {
        let ret = globalI18nCallback(term);
        if (typeof ret == `string`) return ret;
      } catch {
      }
      return originalMessages.get(term) || term;
    }, applyMessagesToSchema = (schema$2, messages$3) => schema$2.messages({ "any.custom": $t(`any.custom`), "any.default": $t(`any.default`), "any.failover": $t(`any.failover`), "any.invalid": $t(`any.invalid`), "any.only": $t(`any.only`), "any.ref": $t(`any.ref`), "any.required": $t(`any.required`), "any.unknown": $t(`any.unknown`), ...messages$3 });
    Object.defineProperty(root$11, `$i18n`, { value: (term) => $t(term), writable: false, enumerable: true, configurable: true }), Object.keys(joiTypes).forEach((type) => {
      let t$7 = type;
      if (typeof root$11[t$7] != `function`) return;
      let baseSchema = root$11[t$7]();
      root$11[t$7] = (...args$1) => {
        let schema$2 = generate(root$11, baseSchema, args$1), knexTranslations = Object.fromEntries(Object.entries(knexMessages).map(([k]) => [k, $t(k)]));
        switch (type) {
          case `alternatives`:
            return applyMessagesToSchema(schema$2, { "alternatives.all": $t(`alternatives.all`), "alternatives.any": $t(`alternatives.any`), "alternatives.match": $t(`alternatives.match`), "alternatives.one": $t(`alternatives.one`), "alternatives.types": $t(`alternatives.types`), ...knexTranslations });
          case `any`:
            return applyMessagesToSchema(schema$2, { "any.custom": $t(`any.custom`), "any.default": $t(`any.default`), "any.failover": $t(`any.failover`), "any.invalid": $t(`any.invalid`), "any.only": $t(`any.only`), "any.ref": $t(`any.ref`), "any.required": $t(`any.required`), "any.unknown": $t(`any.unknown`), ...knexTranslations });
          case `array`:
            return applyMessagesToSchema(schema$2, { "array.base": $t(`array.base`), "array.excludes": $t(`array.excludes`), "array.hasKnown": $t(`array.hasKnown`), "array.hasUnknown": $t(`array.hasUnknown`), "array.includes": $t(`array.includes`), "array.includesRequiredBoth": $t(`array.includesRequiredBoth`), "array.includesRequiredKnowns": $t(`array.includesRequiredKnowns`), "array.includesRequiredUnknowns": $t(`array.includesRequiredUnknowns`), "array.length": $t(`array.length`), "array.max": $t(`array.max`), "array.min": $t(`array.min`), "array.orderedLength": $t(`array.orderedLength`), "array.sort": $t(`array.sort`), "array.sort.mismatching": $t(`array.sort.mismatching`), "array.sort.unsupported": $t(`array.sort.unsupported`), "array.sparse": $t(`array.sparse`), "array.unique": $t(`array.unique`), ...knexTranslations });
          case `binary`:
            return applyMessagesToSchema(schema$2, { "binary.base": $t(`binary.base`), "binary.length": $t(`binary.length`), "binary.max": $t(`binary.max`), "binary.min": $t(`binary.min`), ...knexTranslations });
          case `boolean`:
            return applyMessagesToSchema(schema$2, { "boolean.base": $t(`boolean.base`), ...knexTranslations });
          case `date`:
            return applyMessagesToSchema(schema$2, { "date.base": $t(`date.base`), "date.format": $t(`date.format`), "date.greater": $t(`date.greater`), "date.less": $t(`date.less`), "date.max": $t(`date.max`), "date.min": $t(`date.min`), "date.format.iso": $t(`date.format.iso`), "date.format.javascript": $t(`date.format.javascript`), "date.format.unix": $t(`date.format.unix`), ...knexTranslations });
          case `function`:
            return applyMessagesToSchema(schema$2, { "function.arity": $t(`function.arity`), "function.class": $t(`function.class`), "function.maxArity": $t(`function.maxArity`), "function.minArity": $t(`function.minArity`), ...knexTranslations });
          case `object`:
          case `keys`:
            return applyMessagesToSchema(schema$2, { "object.and": $t(`object.and`), "object.assert": $t(`object.assert`), "object.base": $t(`object.base`), "object.instance": $t(`object.instance`), "object.length": $t(`object.length`), "object.max": $t(`object.max`), "object.min": $t(`object.min`), "object.missing": $t(`object.missing`), "object.nand": $t(`object.nand`), "object.oxor": $t(`object.oxor`), "object.pattern.match": $t(`object.pattern.match`), "object.refType": $t(`object.refType`), "object.regex": $t(`object.regex`), "object.rename.multiple": $t(`object.rename.multiple`), "object.rename.override": $t(`object.rename.override`), "object.schema": $t(`object.schema`), "object.unknown": $t(`object.unknown`), "object.with": $t(`object.with`), "object.without": $t(`object.without`), "object.xor": $t(`object.xor`), ...knexTranslations });
          case `number`:
            return applyMessagesToSchema(schema$2, { "number.base": $t(`number.base`), "number.greater": $t(`number.greater`), "number.infinity": $t(`number.infinity`), "number.integer": $t(`number.integer`), "number.less": $t(`number.less`), "number.max": $t(`number.max`), "number.min": $t(`number.min`), "number.multiple": $t(`number.multiple`), "number.negative": $t(`number.negative`), "number.port": $t(`number.port`), "number.positive": $t(`number.positive`), "number.precision": $t(`number.precision`), "number.unsafe": $t(`number.unsafe`), ...knexTranslations });
          case `string`:
            return applyMessagesToSchema(schema$2, { "string.alphanum": $t(`string.alphanum`), "string.base": $t(`string.base`), "string.base64": $t(`string.base64`), "string.creditCard": $t(`string.creditCard`), "string.dataUri": $t(`string.dataUri`), "string.domain": $t(`string.domain`), "string.email": $t(`string.email`), "string.empty": $t(`string.empty`), "string.guid": $t(`string.guid`), "string.hex": $t(`string.hex`), "string.hexAlign": $t(`string.hexAlign`), "string.hostname": $t(`string.hostname`), "string.ip": $t(`string.ip`), "string.ipVersion": $t(`string.ipVersion`), "string.isoDate": $t(`string.isoDate`), "string.isoDuration": $t(`string.isoDuration`), "string.length": $t(`string.length`), "string.lowercase": $t(`string.lowercase`), "string.max": $t(`string.max`), "string.min": $t(`string.min`), "string.normalize": $t(`string.normalize`), "string.token": $t(`string.token`), "string.pattern.base": $t(`string.pattern.base`), "string.pattern.name": $t(`string.pattern.name`), "string.pattern.invert.base": $t(`string.pattern.invert.base`), "string.pattern.invert.name": $t(`string.pattern.invert.name`), "string.trim": $t(`string.trim`), "string.uri": $t(`string.uri`), "string.uriCustomScheme": $t(`string.uriCustomScheme`), "string.uriRelativeOnly": $t(`string.uriRelativeOnly`), "string.uppercase": $t(`string.uppercase`), ...fqdnMessages, ...knexTranslations });
          case `symbol`:
            return applyMessagesToSchema(schema$2, { "symbol.base": $t(`symbol.base`), "symbol.map": $t(`symbol.map`), ...knexTranslations });
          case `bigint`:
            return applyMessagesToSchema(schema$2, { "bigint.base": $t(`bigint.base`), "bigint.greater": $t(`bigint.greater`), "bigint.less": $t(`bigint.less`), "bigint.max": $t(`bigint.max`), "bigint.min": $t(`bigint.min`), "bigint.multiple": $t(`bigint.multiple`), "bigint.negative": $t(`bigint.negative`), "bigint.positive": $t(`bigint.positive`), ...knexTranslations });
          case `datetime`:
            return applyMessagesToSchema(schema$2, { "datetime.base": $t(`datetime.base`), "datetime.exactly": $t(`datetime.exactly`), "datetime.equals": $t(`datetime.equals`), "datetime.after": $t(`datetime.after`), "datetime.greater": $t(`datetime.greater`), "datetime.before": $t(`datetime.before`), "datetime.less": $t(`datetime.less`), "datetime.afterOrEqual": $t(`datetime.afterOrEqual`), "datetime.min": $t(`datetime.min`), "datetime.beforeOrEqual": $t(`datetime.beforeOrEqual`), "datetime.max": $t(`datetime.max`), "datetime.weekend": $t(`datetime.weekend`), "datetime.weekday": $t(`datetime.weekday`), ...knexTranslations });
          case `phone`:
            return applyMessagesToSchema(schema$2, { "phone.base": $t(`phone.base`), "phone.invalid": $t(`phone.invalid`), "phone.fixedLine": $t(`phone.fixedLine`), "phone.mobile": $t(`phone.mobile`), "phone.strictFixedLine": $t(`phone.strictFixedLine`), "phone.strictMobile": $t(`phone.strictMobile`), "phone.fixedLineOrMobile": $t(`phone.fixedLineOrMobile`), "phone.tollFree": $t(`phone.tollFree`), "phone.premiumRate": $t(`phone.premiumRate`), "phone.sharedCost": $t(`phone.sharedCost`), "phone.voip": $t(`phone.voip`), "phone.personalNumber": $t(`phone.personalNumber`), "phone.pager": $t(`phone.pager`), "phone.uan": $t(`phone.uan`), "phone.voicemail": $t(`phone.voicemail`), "phone.unknown": $t(`phone.unknown`), "phone.types": $t(`phone.types`), ...knexTranslations });
          default:
            return applyMessagesToSchema(schema$2, { ...knexTranslations });
        }
      };
    });
  };
  return Object.defineProperty(root$11, `$setI18n`, { value: (callback) => (doUpdateI18n(callback), root$11), writable: false, enumerable: true, configurable: false }), Object.defineProperty(root$11, `$clearI18n`, { value: () => (doUpdateI18n(), root$11), writable: false, enumerable: true, configurable: false }), Object.defineProperty(root$11, `$i18n`, { value: (term) => {
    try {
      return originalMessages.get(term) || term;
    } catch {
      return term;
    }
  }, writable: false, enumerable: true, configurable: true }), root$11;
}, patch = (root$11) => (root$11 = json(root$11), root$11 = i18n(root$11), root$11);
var require_constants = __commonJSMin$1((exports$12, module2) => {
  let SEMVER_SPEC_VERSION = `2.0.0`, MAX_LENGTH$2 = 256, MAX_SAFE_INTEGER$1 = 2 ** 53 - 1, MAX_SAFE_COMPONENT_LENGTH$1 = 16, MAX_SAFE_BUILD_LENGTH$1 = MAX_LENGTH$2 - 6, RELEASE_TYPES = [`major`, `premajor`, `minor`, `preminor`, `patch`, `prepatch`, `prerelease`];
  module2.exports = { MAX_LENGTH: MAX_LENGTH$2, MAX_SAFE_COMPONENT_LENGTH: MAX_SAFE_COMPONENT_LENGTH$1, MAX_SAFE_BUILD_LENGTH: MAX_SAFE_BUILD_LENGTH$1, MAX_SAFE_INTEGER: MAX_SAFE_INTEGER$1, RELEASE_TYPES, SEMVER_SPEC_VERSION, FLAG_INCLUDE_PRERELEASE: 1, FLAG_LOOSE: 2 };
}), require_debug = __commonJSMin$1((exports$12, module2) => {
  init_dist();
  let debug$4 = typeof process$1 == `object` && process$1.env && process$1.env.NODE_DEBUG && /\bsemver\b/i.test(process$1.env.NODE_DEBUG) ? (...args$1) => console.error(`SEMVER`, ...args$1) : () => {
  };
  module2.exports = debug$4;
}), require_re = __commonJSMin$1((exports$12, module2) => {
  let { MAX_SAFE_COMPONENT_LENGTH, MAX_SAFE_BUILD_LENGTH, MAX_LENGTH: MAX_LENGTH$1 } = require_constants(), debug$3 = require_debug();
  exports$12 = module2.exports = {};
  let re$4 = exports$12.re = [], safeRe = exports$12.safeRe = [], src = exports$12.src = [], safeSrc = exports$12.safeSrc = [], t$4 = exports$12.t = {}, R = 0, LETTERDASHNUMBER = `[a-zA-Z0-9-]`, safeRegexReplacements = [[`\\s`, 1], [`\\d`, MAX_LENGTH$1], [LETTERDASHNUMBER, MAX_SAFE_BUILD_LENGTH]], makeSafeRegex = (value) => {
    for (let [token, max$3] of safeRegexReplacements) value = value.split(`${token}*`).join(`${token}{0,${max$3}}`).split(`${token}+`).join(`${token}{1,${max$3}}`);
    return value;
  }, createToken = (name$2, value, isGlobal) => {
    let safe = makeSafeRegex(value), index$2 = R++;
    debug$3(name$2, index$2, value), t$4[name$2] = index$2, src[index$2] = value, safeSrc[index$2] = safe, re$4[index$2] = new RegExp(value, isGlobal ? `g` : void 0), safeRe[index$2] = new RegExp(safe, isGlobal ? `g` : void 0);
  };
  createToken(`NUMERICIDENTIFIER`, `0|[1-9]\\d*`), createToken(`NUMERICIDENTIFIERLOOSE`, `\\d+`), createToken(`NONNUMERICIDENTIFIER`, `\\d*[a-zA-Z-]${LETTERDASHNUMBER}*`), createToken(`MAINVERSION`, `(${src[t$4.NUMERICIDENTIFIER]})\\.(${src[t$4.NUMERICIDENTIFIER]})\\.(${src[t$4.NUMERICIDENTIFIER]})`), createToken(`MAINVERSIONLOOSE`, `(${src[t$4.NUMERICIDENTIFIERLOOSE]})\\.(${src[t$4.NUMERICIDENTIFIERLOOSE]})\\.(${src[t$4.NUMERICIDENTIFIERLOOSE]})`), createToken(`PRERELEASEIDENTIFIER`, `(?:${src[t$4.NONNUMERICIDENTIFIER]}|${src[t$4.NUMERICIDENTIFIER]})`), createToken(`PRERELEASEIDENTIFIERLOOSE`, `(?:${src[t$4.NONNUMERICIDENTIFIER]}|${src[t$4.NUMERICIDENTIFIERLOOSE]})`), createToken(`PRERELEASE`, `(?:-(${src[t$4.PRERELEASEIDENTIFIER]}(?:\\.${src[t$4.PRERELEASEIDENTIFIER]})*))`), createToken(`PRERELEASELOOSE`, `(?:-?(${src[t$4.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t$4.PRERELEASEIDENTIFIERLOOSE]})*))`), createToken(`BUILDIDENTIFIER`, `${LETTERDASHNUMBER}+`), createToken(`BUILD`, `(?:\\+(${src[t$4.BUILDIDENTIFIER]}(?:\\.${src[t$4.BUILDIDENTIFIER]})*))`), createToken(`FULLPLAIN`, `v?${src[t$4.MAINVERSION]}${src[t$4.PRERELEASE]}?${src[t$4.BUILD]}?`), createToken(`FULL`, `^${src[t$4.FULLPLAIN]}$`), createToken(`LOOSEPLAIN`, `[v=\\s]*${src[t$4.MAINVERSIONLOOSE]}${src[t$4.PRERELEASELOOSE]}?${src[t$4.BUILD]}?`), createToken(`LOOSE`, `^${src[t$4.LOOSEPLAIN]}$`), createToken(`GTLT`, `((?:<|>)?=?)`), createToken(`XRANGEIDENTIFIERLOOSE`, `${src[t$4.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), createToken(`XRANGEIDENTIFIER`, `${src[t$4.NUMERICIDENTIFIER]}|x|X|\\*`), createToken(`XRANGEPLAIN`, `[v=\\s]*(${src[t$4.XRANGEIDENTIFIER]})(?:\\.(${src[t$4.XRANGEIDENTIFIER]})(?:\\.(${src[t$4.XRANGEIDENTIFIER]})(?:${src[t$4.PRERELEASE]})?${src[t$4.BUILD]}?)?)?`), createToken(`XRANGEPLAINLOOSE`, `[v=\\s]*(${src[t$4.XRANGEIDENTIFIERLOOSE]})(?:\\.(${src[t$4.XRANGEIDENTIFIERLOOSE]})(?:\\.(${src[t$4.XRANGEIDENTIFIERLOOSE]})(?:${src[t$4.PRERELEASELOOSE]})?${src[t$4.BUILD]}?)?)?`), createToken(`XRANGE`, `^${src[t$4.GTLT]}\\s*${src[t$4.XRANGEPLAIN]}$`), createToken(`XRANGELOOSE`, `^${src[t$4.GTLT]}\\s*${src[t$4.XRANGEPLAINLOOSE]}$`), createToken(`COERCEPLAIN`, `(^|[^\\d])(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}})(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}}))?(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}}))?`), createToken(`COERCE`, `${src[t$4.COERCEPLAIN]}(?:$|[^\\d])`), createToken(`COERCEFULL`, src[t$4.COERCEPLAIN] + `(?:${src[t$4.PRERELEASE]})?(?:${src[t$4.BUILD]})?(?:$|[^\\d])`), createToken(`COERCERTL`, src[t$4.COERCE], true), createToken(`COERCERTLFULL`, src[t$4.COERCEFULL], true), createToken(`LONETILDE`, `(?:~>?)`), createToken(`TILDETRIM`, `(\\s*)${src[t$4.LONETILDE]}\\s+`, true), exports$12.tildeTrimReplace = `$1~`, createToken(`TILDE`, `^${src[t$4.LONETILDE]}${src[t$4.XRANGEPLAIN]}$`), createToken(`TILDELOOSE`, `^${src[t$4.LONETILDE]}${src[t$4.XRANGEPLAINLOOSE]}$`), createToken(`LONECARET`, `(?:\\^)`), createToken(`CARETTRIM`, `(\\s*)${src[t$4.LONECARET]}\\s+`, true), exports$12.caretTrimReplace = `$1^`, createToken(`CARET`, `^${src[t$4.LONECARET]}${src[t$4.XRANGEPLAIN]}$`), createToken(`CARETLOOSE`, `^${src[t$4.LONECARET]}${src[t$4.XRANGEPLAINLOOSE]}$`), createToken(`COMPARATORLOOSE`, `^${src[t$4.GTLT]}\\s*(${src[t$4.LOOSEPLAIN]})$|^$`), createToken(`COMPARATOR`, `^${src[t$4.GTLT]}\\s*(${src[t$4.FULLPLAIN]})$|^$`), createToken(`COMPARATORTRIM`, `(\\s*)${src[t$4.GTLT]}\\s*(${src[t$4.LOOSEPLAIN]}|${src[t$4.XRANGEPLAIN]})`, true), exports$12.comparatorTrimReplace = `$1$2$3`, createToken(`HYPHENRANGE`, `^\\s*(${src[t$4.XRANGEPLAIN]})\\s+-\\s+(${src[t$4.XRANGEPLAIN]})\\s*$`), createToken(`HYPHENRANGELOOSE`, `^\\s*(${src[t$4.XRANGEPLAINLOOSE]})\\s+-\\s+(${src[t$4.XRANGEPLAINLOOSE]})\\s*$`), createToken(`STAR`, `(<|>)?=?\\s*\\*`), createToken(`GTE0`, `^\\s*>=\\s*0\\.0\\.0\\s*$`), createToken(`GTE0PRE`, `^\\s*>=\\s*0\\.0\\.0-0\\s*$`);
}), require_parse_options = __commonJSMin$1((exports$12, module2) => {
  let looseOption = Object.freeze({ loose: true }), emptyOpts = Object.freeze({}), parseOptions$3 = (options) => options ? typeof options == `object` ? options : looseOption : emptyOpts;
  module2.exports = parseOptions$3;
}), require_identifiers = __commonJSMin$1((exports$12, module2) => {
  let numeric = /^[0-9]+$/, compareIdentifiers$1 = (a$22, b2) => {
    if (typeof a$22 == `number` && typeof b2 == `number`) return a$22 === b2 ? 0 : a$22 < b2 ? -1 : 1;
    let anum = numeric.test(a$22), bnum = numeric.test(b2);
    return anum && bnum && (a$22 = +a$22, b2 = +b2), a$22 === b2 ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a$22 < b2 ? -1 : 1;
  }, rcompareIdentifiers = (a$22, b2) => compareIdentifiers$1(b2, a$22);
  module2.exports = { compareIdentifiers: compareIdentifiers$1, rcompareIdentifiers };
}), require_semver$1 = __commonJSMin$1((exports$12, module2) => {
  let debug$2 = require_debug(), { MAX_LENGTH, MAX_SAFE_INTEGER } = require_constants(), { safeRe: re$3, t: t$3 } = require_re(), parseOptions$2 = require_parse_options(), { compareIdentifiers } = require_identifiers();
  var SemVer$15 = class SemVer$152 {
    constructor(version$4, options) {
      if (options = parseOptions$2(options), version$4 instanceof SemVer$152) {
        if (version$4.loose === !!options.loose && version$4.includePrerelease === !!options.includePrerelease) return version$4;
        version$4 = version$4.version;
      } else if (typeof version$4 != `string`) throw TypeError(`Invalid version. Must be a string. Got type "${typeof version$4}".`);
      if (version$4.length > MAX_LENGTH) throw TypeError(`version is longer than ${MAX_LENGTH} characters`);
      debug$2(`SemVer`, version$4, options), this.options = options, this.loose = !!options.loose, this.includePrerelease = !!options.includePrerelease;
      let m$3 = version$4.trim().match(options.loose ? re$3[t$3.LOOSE] : re$3[t$3.FULL]);
      if (!m$3) throw TypeError(`Invalid Version: ${version$4}`);
      if (this.raw = version$4, this.major = +m$3[1], this.minor = +m$3[2], this.patch = +m$3[3], this.major > MAX_SAFE_INTEGER || this.major < 0) throw TypeError(`Invalid major version`);
      if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) throw TypeError(`Invalid minor version`);
      if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) throw TypeError(`Invalid patch version`);
      m$3[4] ? this.prerelease = m$3[4].split(`.`).map((id) => {
        if (/^[0-9]+$/.test(id)) {
          let num = +id;
          if (num >= 0 && num < MAX_SAFE_INTEGER) return num;
        }
        return id;
      }) : this.prerelease = [], this.build = m$3[5] ? m$3[5].split(`.`) : [], this.format();
    }
    format() {
      return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(`.`)}`), this.version;
    }
    toString() {
      return this.version;
    }
    compare(other) {
      if (debug$2(`SemVer.compare`, this.version, this.options, other), !(other instanceof SemVer$152)) {
        if (typeof other == `string` && other === this.version) return 0;
        other = new SemVer$152(other, this.options);
      }
      return other.version === this.version ? 0 : this.compareMain(other) || this.comparePre(other);
    }
    compareMain(other) {
      return other instanceof SemVer$152 || (other = new SemVer$152(other, this.options)), this.major < other.major ? -1 : this.major > other.major ? 1 : this.minor < other.minor ? -1 : this.minor > other.minor ? 1 : this.patch < other.patch ? -1 : this.patch > other.patch ? 1 : 0;
    }
    comparePre(other) {
      if (other instanceof SemVer$152 || (other = new SemVer$152(other, this.options)), this.prerelease.length && !other.prerelease.length) return -1;
      if (!this.prerelease.length && other.prerelease.length) return 1;
      if (!this.prerelease.length && !other.prerelease.length) return 0;
      let i$4 = 0;
      do {
        let a$22 = this.prerelease[i$4], b2 = other.prerelease[i$4];
        if (debug$2(`prerelease compare`, i$4, a$22, b2), a$22 === void 0 && b2 === void 0) return 0;
        if (b2 === void 0) return 1;
        if (a$22 === void 0) return -1;
        if (a$22 === b2) continue;
        return compareIdentifiers(a$22, b2);
      } while (++i$4);
    }
    compareBuild(other) {
      other instanceof SemVer$152 || (other = new SemVer$152(other, this.options));
      let i$4 = 0;
      do {
        let a$22 = this.build[i$4], b2 = other.build[i$4];
        if (debug$2(`build compare`, i$4, a$22, b2), a$22 === void 0 && b2 === void 0) return 0;
        if (b2 === void 0) return 1;
        if (a$22 === void 0) return -1;
        if (a$22 === b2) continue;
        return compareIdentifiers(a$22, b2);
      } while (++i$4);
    }
    inc(release, identifier$2, identifierBase) {
      if (release.startsWith(`pre`)) {
        if (!identifier$2 && identifierBase === false) throw Error(`invalid increment argument: identifier is empty`);
        if (identifier$2) {
          let match$2 = `-${identifier$2}`.match(this.options.loose ? re$3[t$3.PRERELEASELOOSE] : re$3[t$3.PRERELEASE]);
          if (!match$2 || match$2[1] !== identifier$2) throw Error(`invalid identifier: ${identifier$2}`);
        }
      }
      switch (release) {
        case `premajor`:
          this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc(`pre`, identifier$2, identifierBase);
          break;
        case `preminor`:
          this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc(`pre`, identifier$2, identifierBase);
          break;
        case `prepatch`:
          this.prerelease.length = 0, this.inc(`patch`, identifier$2, identifierBase), this.inc(`pre`, identifier$2, identifierBase);
          break;
        case `prerelease`:
          this.prerelease.length === 0 && this.inc(`patch`, identifier$2, identifierBase), this.inc(`pre`, identifier$2, identifierBase);
          break;
        case `release`:
          if (this.prerelease.length === 0) throw Error(`version ${this.raw} is not a prerelease`);
          this.prerelease.length = 0;
          break;
        case `major`:
          (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
          break;
        case `minor`:
          (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
          break;
        case `patch`:
          this.prerelease.length === 0 && this.patch++, this.prerelease = [];
          break;
        case `pre`: {
          let base$3 = Number(identifierBase) ? 1 : 0;
          if (this.prerelease.length === 0) this.prerelease = [base$3];
          else {
            let i$4 = this.prerelease.length;
            for (; --i$4 >= 0; ) typeof this.prerelease[i$4] == `number` && (this.prerelease[i$4]++, i$4 = -2);
            if (i$4 === -1) {
              if (identifier$2 === this.prerelease.join(`.`) && identifierBase === false) throw Error(`invalid increment argument: identifier already exists`);
              this.prerelease.push(base$3);
            }
          }
          if (identifier$2) {
            let prerelease$2 = [identifier$2, base$3];
            identifierBase === false && (prerelease$2 = [identifier$2]), compareIdentifiers(this.prerelease[0], identifier$2) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = prerelease$2) : this.prerelease = prerelease$2;
          }
          break;
        }
        default:
          throw Error(`invalid increment argument: ${release}`);
      }
      return this.raw = this.format(), this.build.length && (this.raw += `+${this.build.join(`.`)}`), this;
    }
  };
  module2.exports = SemVer$15;
}), require_parse = __commonJSMin$1((exports$12, module2) => {
  let SemVer$14 = require_semver$1(), parse$6 = (version$4, options, throwErrors = false) => {
    if (version$4 instanceof SemVer$14) return version$4;
    try {
      return new SemVer$14(version$4, options);
    } catch (er) {
      if (!throwErrors) return null;
      throw er;
    }
  };
  module2.exports = parse$6;
}), require_valid$1 = __commonJSMin$1((exports$12, module2) => {
  let parse$5 = require_parse(), valid$1 = (version$4, options) => {
    let v$1 = parse$5(version$4, options);
    return v$1 ? v$1.version : null;
  };
  module2.exports = valid$1;
}), require_clean = __commonJSMin$1((exports$12, module2) => {
  let parse$4 = require_parse(), clean$1 = (version$4, options) => {
    let s$6 = parse$4(version$4.trim().replace(/^[=v]+/, ``), options);
    return s$6 ? s$6.version : null;
  };
  module2.exports = clean$1;
}), require_inc = __commonJSMin$1((exports$12, module2) => {
  let SemVer$13 = require_semver$1(), inc$1 = (version$4, release, options, identifier$2, identifierBase) => {
    typeof options == `string` && (identifierBase = identifier$2, identifier$2 = options, options = void 0);
    try {
      return new SemVer$13(version$4 instanceof SemVer$13 ? version$4.version : version$4, options).inc(release, identifier$2, identifierBase).version;
    } catch {
      return null;
    }
  };
  module2.exports = inc$1;
}), require_diff = __commonJSMin$1((exports$12, module2) => {
  let parse$3 = require_parse(), diff$1 = (version1, version2) => {
    let v1 = parse$3(version1, null, true), v2 = parse$3(version2, null, true), comparison = v1.compare(v2);
    if (comparison === 0) return null;
    let v1Higher = comparison > 0, highVersion = v1Higher ? v1 : v2, lowVersion = v1Higher ? v2 : v1, highHasPre = !!highVersion.prerelease.length, lowHasPre = !!lowVersion.prerelease.length;
    if (lowHasPre && !highHasPre) {
      if (!lowVersion.patch && !lowVersion.minor) return `major`;
      if (lowVersion.compareMain(highVersion) === 0) return lowVersion.minor && !lowVersion.patch ? `minor` : `patch`;
    }
    let prefix = highHasPre ? `pre` : ``;
    return v1.major === v2.major ? v1.minor === v2.minor ? v1.patch === v2.patch ? `prerelease` : prefix + `patch` : prefix + `minor` : prefix + `major`;
  };
  module2.exports = diff$1;
}), require_major = __commonJSMin$1((exports$12, module2) => {
  let SemVer$12 = require_semver$1(), major$1 = (a$22, loose) => new SemVer$12(a$22, loose).major;
  module2.exports = major$1;
}), require_minor = __commonJSMin$1((exports$12, module2) => {
  let SemVer$11 = require_semver$1(), minor$1 = (a$22, loose) => new SemVer$11(a$22, loose).minor;
  module2.exports = minor$1;
}), require_patch = __commonJSMin$1((exports$12, module2) => {
  let SemVer$10 = require_semver$1(), patch$2 = (a$22, loose) => new SemVer$10(a$22, loose).patch;
  module2.exports = patch$2;
}), require_prerelease = __commonJSMin$1((exports$12, module2) => {
  let parse$2 = require_parse(), prerelease$1 = (version$4, options) => {
    let parsed = parse$2(version$4, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
  };
  module2.exports = prerelease$1;
}), require_compare = __commonJSMin$1((exports$12, module2) => {
  let SemVer$9 = require_semver$1(), compare$11 = (a$22, b2, loose) => new SemVer$9(a$22, loose).compare(new SemVer$9(b2, loose));
  module2.exports = compare$11;
}), require_rcompare = __commonJSMin$1((exports$12, module2) => {
  let compare$10 = require_compare(), rcompare$1 = (a$22, b2, loose) => compare$10(b2, a$22, loose);
  module2.exports = rcompare$1;
}), require_compare_loose = __commonJSMin$1((exports$12, module2) => {
  let compare$9 = require_compare(), compareLoose$1 = (a$22, b2) => compare$9(a$22, b2, true);
  module2.exports = compareLoose$1;
}), require_compare_build = __commonJSMin$1((exports$12, module2) => {
  let SemVer$8 = require_semver$1(), compareBuild$3 = (a$22, b2, loose) => {
    let versionA = new SemVer$8(a$22, loose), versionB = new SemVer$8(b2, loose);
    return versionA.compare(versionB) || versionA.compareBuild(versionB);
  };
  module2.exports = compareBuild$3;
}), require_sort = __commonJSMin$1((exports$12, module2) => {
  let compareBuild$2 = require_compare_build(), sort$1 = (list, loose) => list.sort((a$22, b2) => compareBuild$2(a$22, b2, loose));
  module2.exports = sort$1;
}), require_rsort = __commonJSMin$1((exports$12, module2) => {
  let compareBuild$1 = require_compare_build(), rsort$1 = (list, loose) => list.sort((a$22, b2) => compareBuild$1(b2, a$22, loose));
  module2.exports = rsort$1;
}), require_gt = __commonJSMin$1((exports$12, module2) => {
  let compare$8 = require_compare(), gt$4 = (a$22, b2, loose) => compare$8(a$22, b2, loose) > 0;
  module2.exports = gt$4;
}), require_lt = __commonJSMin$1((exports$12, module2) => {
  let compare$7 = require_compare(), lt$3 = (a$22, b2, loose) => compare$7(a$22, b2, loose) < 0;
  module2.exports = lt$3;
}), require_eq = __commonJSMin$1((exports$12, module2) => {
  let compare$6 = require_compare(), eq$2 = (a$22, b2, loose) => compare$6(a$22, b2, loose) === 0;
  module2.exports = eq$2;
}), require_neq = __commonJSMin$1((exports$12, module2) => {
  let compare$5 = require_compare(), neq$2 = (a$22, b2, loose) => compare$5(a$22, b2, loose) !== 0;
  module2.exports = neq$2;
}), require_gte = __commonJSMin$1((exports$12, module2) => {
  let compare$4 = require_compare(), gte$3 = (a$22, b2, loose) => compare$4(a$22, b2, loose) >= 0;
  module2.exports = gte$3;
}), require_lte = __commonJSMin$1((exports$12, module2) => {
  let compare$3 = require_compare(), lte$3 = (a$22, b2, loose) => compare$3(a$22, b2, loose) <= 0;
  module2.exports = lte$3;
}), require_cmp = __commonJSMin$1((exports$12, module2) => {
  let eq$1 = require_eq(), neq$1 = require_neq(), gt$3 = require_gt(), gte$2 = require_gte(), lt$2 = require_lt(), lte$2 = require_lte(), cmp$2 = (a$22, op, b2, loose) => {
    switch (op) {
      case `===`:
        return typeof a$22 == `object` && (a$22 = a$22.version), typeof b2 == `object` && (b2 = b2.version), a$22 === b2;
      case `!==`:
        return typeof a$22 == `object` && (a$22 = a$22.version), typeof b2 == `object` && (b2 = b2.version), a$22 !== b2;
      case ``:
      case `=`:
      case `==`:
        return eq$1(a$22, b2, loose);
      case `!=`:
        return neq$1(a$22, b2, loose);
      case `>`:
        return gt$3(a$22, b2, loose);
      case `>=`:
        return gte$2(a$22, b2, loose);
      case `<`:
        return lt$2(a$22, b2, loose);
      case `<=`:
        return lte$2(a$22, b2, loose);
      default:
        throw TypeError(`Invalid operator: ${op}`);
    }
  };
  module2.exports = cmp$2;
}), require_coerce = __commonJSMin$1((exports$12, module2) => {
  let SemVer$7 = require_semver$1(), parse$1 = require_parse(), { safeRe: re$2, t: t$2 } = require_re(), coerce$1 = (version$4, options) => {
    if (version$4 instanceof SemVer$7) return version$4;
    if (typeof version$4 == `number` && (version$4 = String(version$4)), typeof version$4 != `string`) return null;
    options ||= {};
    let match$2 = null;
    if (!options.rtl) match$2 = version$4.match(options.includePrerelease ? re$2[t$2.COERCEFULL] : re$2[t$2.COERCE]);
    else {
      let coerceRtlRegex = options.includePrerelease ? re$2[t$2.COERCERTLFULL] : re$2[t$2.COERCERTL], next;
      for (; (next = coerceRtlRegex.exec(version$4)) && (!match$2 || match$2.index + match$2[0].length !== version$4.length); ) (!match$2 || next.index + next[0].length !== match$2.index + match$2[0].length) && (match$2 = next), coerceRtlRegex.lastIndex = next.index + next[1].length + next[2].length;
      coerceRtlRegex.lastIndex = -1;
    }
    if (match$2 === null) return null;
    let major$2 = match$2[2], minor$2 = match$2[3] || `0`, patch$3 = match$2[4] || `0`, prerelease$2 = options.includePrerelease && match$2[5] ? `-${match$2[5]}` : ``, build$1 = options.includePrerelease && match$2[6] ? `+${match$2[6]}` : ``;
    return parse$1(`${major$2}.${minor$2}.${patch$3}${prerelease$2}${build$1}`, options);
  };
  module2.exports = coerce$1;
}), require_lrucache = __commonJSMin$1((exports$12, module2) => {
  var LRUCache = class {
    constructor() {
      this.max = 1e3, this.map = /* @__PURE__ */ new Map();
    }
    get(key) {
      let value = this.map.get(key);
      if (value !== void 0) return this.map.delete(key), this.map.set(key, value), value;
    }
    delete(key) {
      return this.map.delete(key);
    }
    set(key, value) {
      let deleted = this.delete(key);
      if (!deleted && value !== void 0) {
        if (this.map.size >= this.max) {
          let firstKey = this.map.keys().next().value;
          this.delete(firstKey);
        }
        this.map.set(key, value);
      }
      return this;
    }
  };
  module2.exports = LRUCache;
}), require_range = __commonJSMin$1((exports$12, module2) => {
  let SPACE_CHARACTERS = /\s+/g;
  var Range$11 = class Range$112 {
    constructor(range, options) {
      if (options = parseOptions$1(options), range instanceof Range$112) return range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease ? range : new Range$112(range.raw, options);
      if (range instanceof Comparator$4) return this.raw = range.value, this.set = [[range]], this.formatted = void 0, this;
      if (this.options = options, this.loose = !!options.loose, this.includePrerelease = !!options.includePrerelease, this.raw = range.trim().replace(SPACE_CHARACTERS, ` `), this.set = this.raw.split(`||`).map((r$2) => this.parseRange(r$2.trim())).filter((c$12) => c$12.length), !this.set.length) throw TypeError(`Invalid SemVer Range: ${this.raw}`);
      if (this.set.length > 1) {
        let first$1 = this.set[0];
        if (this.set = this.set.filter((c$12) => !isNullSet(c$12[0])), this.set.length === 0) this.set = [first$1];
        else if (this.set.length > 1) {
          for (let c$12 of this.set) if (c$12.length === 1 && isAny(c$12[0])) {
            this.set = [c$12];
            break;
          }
        }
      }
      this.formatted = void 0;
    }
    get range() {
      if (this.formatted === void 0) {
        this.formatted = ``;
        for (let i$4 = 0; i$4 < this.set.length; i$4++) {
          i$4 > 0 && (this.formatted += `||`);
          let comps = this.set[i$4];
          for (let k = 0; k < comps.length; k++) k > 0 && (this.formatted += ` `), this.formatted += comps[k].toString().trim();
        }
      }
      return this.formatted;
    }
    format() {
      return this.range;
    }
    toString() {
      return this.range;
    }
    parseRange(range) {
      let memoOpts = (this.options.includePrerelease && FLAG_INCLUDE_PRERELEASE) | (this.options.loose && FLAG_LOOSE), memoKey = memoOpts + `:` + range, cached = cache.get(memoKey);
      if (cached) return cached;
      let loose = this.options.loose, hr = loose ? re$1[t$1.HYPHENRANGELOOSE] : re$1[t$1.HYPHENRANGE];
      range = range.replace(hr, hyphenReplace(this.options.includePrerelease)), debug$1(`hyphen replace`, range), range = range.replace(re$1[t$1.COMPARATORTRIM], comparatorTrimReplace), debug$1(`comparator trim`, range), range = range.replace(re$1[t$1.TILDETRIM], tildeTrimReplace), debug$1(`tilde trim`, range), range = range.replace(re$1[t$1.CARETTRIM], caretTrimReplace), debug$1(`caret trim`, range);
      let rangeList = range.split(` `).map((comp) => parseComparator(comp, this.options)).join(` `).split(/\s+/).map((comp) => replaceGTE0(comp, this.options));
      loose && (rangeList = rangeList.filter((comp) => (debug$1(`loose invalid filter`, comp, this.options), !!comp.match(re$1[t$1.COMPARATORLOOSE])))), debug$1(`range list`, rangeList);
      let rangeMap = /* @__PURE__ */ new Map(), comparators = rangeList.map((comp) => new Comparator$4(comp, this.options));
      for (let comp of comparators) {
        if (isNullSet(comp)) return [comp];
        rangeMap.set(comp.value, comp);
      }
      rangeMap.size > 1 && rangeMap.has(``) && rangeMap.delete(``);
      let result = [...rangeMap.values()];
      return cache.set(memoKey, result), result;
    }
    intersects(range, options) {
      if (!(range instanceof Range$112)) throw TypeError(`a Range is required`);
      return this.set.some((thisComparators) => isSatisfiable(thisComparators, options) && range.set.some((rangeComparators) => isSatisfiable(rangeComparators, options) && thisComparators.every((thisComparator) => rangeComparators.every((rangeComparator) => thisComparator.intersects(rangeComparator, options)))));
    }
    test(version$4) {
      if (!version$4) return false;
      if (typeof version$4 == `string`) try {
        version$4 = new SemVer$6(version$4, this.options);
      } catch {
        return false;
      }
      for (let i$4 = 0; i$4 < this.set.length; i$4++) if (testSet(this.set[i$4], version$4, this.options)) return true;
      return false;
    }
  };
  module2.exports = Range$11;
  let LRU = require_lrucache(), cache = new LRU(), parseOptions$1 = require_parse_options(), Comparator$4 = require_comparator(), debug$1 = require_debug(), SemVer$6 = require_semver$1(), { safeRe: re$1, t: t$1, comparatorTrimReplace, tildeTrimReplace, caretTrimReplace } = require_re(), { FLAG_INCLUDE_PRERELEASE, FLAG_LOOSE } = require_constants(), isNullSet = (c$12) => c$12.value === `<0.0.0-0`, isAny = (c$12) => c$12.value === ``, isSatisfiable = (comparators, options) => {
    let result = true, remainingComparators = comparators.slice(), testComparator = remainingComparators.pop();
    for (; result && remainingComparators.length; ) result = remainingComparators.every((otherComparator) => testComparator.intersects(otherComparator, options)), testComparator = remainingComparators.pop();
    return result;
  }, parseComparator = (comp, options) => (comp = comp.replace(re$1[t$1.BUILD], ``), debug$1(`comp`, comp, options), comp = replaceCarets(comp, options), debug$1(`caret`, comp), comp = replaceTildes(comp, options), debug$1(`tildes`, comp), comp = replaceXRanges(comp, options), debug$1(`xrange`, comp), comp = replaceStars(comp, options), debug$1(`stars`, comp), comp), isX = (id) => !id || id.toLowerCase() === `x` || id === `*`, replaceTildes = (comp, options) => comp.trim().split(/\s+/).map((c$12) => replaceTilde(c$12, options)).join(` `), replaceTilde = (comp, options) => {
    let r$2 = options.loose ? re$1[t$1.TILDELOOSE] : re$1[t$1.TILDE];
    return comp.replace(r$2, (_, M$1, m$3, p$1, pr) => {
      debug$1(`tilde`, comp, _, M$1, m$3, p$1, pr);
      let ret;
      return isX(M$1) ? ret = `` : isX(m$3) ? ret = `>=${M$1}.0.0 <${+M$1 + 1}.0.0-0` : isX(p$1) ? ret = `>=${M$1}.${m$3}.0 <${M$1}.${+m$3 + 1}.0-0` : pr ? (debug$1(`replaceTilde pr`, pr), ret = `>=${M$1}.${m$3}.${p$1}-${pr} <${M$1}.${+m$3 + 1}.0-0`) : ret = `>=${M$1}.${m$3}.${p$1} <${M$1}.${+m$3 + 1}.0-0`, debug$1(`tilde return`, ret), ret;
    });
  }, replaceCarets = (comp, options) => comp.trim().split(/\s+/).map((c$12) => replaceCaret(c$12, options)).join(` `), replaceCaret = (comp, options) => {
    debug$1(`caret`, comp, options);
    let r$2 = options.loose ? re$1[t$1.CARETLOOSE] : re$1[t$1.CARET], z$1 = options.includePrerelease ? `-0` : ``;
    return comp.replace(r$2, (_, M$1, m$3, p$1, pr) => {
      debug$1(`caret`, comp, _, M$1, m$3, p$1, pr);
      let ret;
      return isX(M$1) ? ret = `` : isX(m$3) ? ret = `>=${M$1}.0.0${z$1} <${+M$1 + 1}.0.0-0` : isX(p$1) ? ret = M$1 === `0` ? `>=${M$1}.${m$3}.0${z$1} <${M$1}.${+m$3 + 1}.0-0` : `>=${M$1}.${m$3}.0${z$1} <${+M$1 + 1}.0.0-0` : pr ? (debug$1(`replaceCaret pr`, pr), ret = M$1 === `0` ? m$3 === `0` ? `>=${M$1}.${m$3}.${p$1}-${pr} <${M$1}.${m$3}.${+p$1 + 1}-0` : `>=${M$1}.${m$3}.${p$1}-${pr} <${M$1}.${+m$3 + 1}.0-0` : `>=${M$1}.${m$3}.${p$1}-${pr} <${+M$1 + 1}.0.0-0`) : (debug$1(`no pr`), ret = M$1 === `0` ? m$3 === `0` ? `>=${M$1}.${m$3}.${p$1}${z$1} <${M$1}.${m$3}.${+p$1 + 1}-0` : `>=${M$1}.${m$3}.${p$1}${z$1} <${M$1}.${+m$3 + 1}.0-0` : `>=${M$1}.${m$3}.${p$1} <${+M$1 + 1}.0.0-0`), debug$1(`caret return`, ret), ret;
    });
  }, replaceXRanges = (comp, options) => (debug$1(`replaceXRanges`, comp, options), comp.split(/\s+/).map((c$12) => replaceXRange(c$12, options)).join(` `)), replaceXRange = (comp, options) => {
    comp = comp.trim();
    let r$2 = options.loose ? re$1[t$1.XRANGELOOSE] : re$1[t$1.XRANGE];
    return comp.replace(r$2, (ret, gtlt, M$1, m$3, p$1, pr) => {
      debug$1(`xRange`, comp, ret, gtlt, M$1, m$3, p$1, pr);
      let xM = isX(M$1), xm = xM || isX(m$3), xp = xm || isX(p$1), anyX = xp;
      return gtlt === `=` && anyX && (gtlt = ``), pr = options.includePrerelease ? `-0` : ``, xM ? ret = gtlt === `>` || gtlt === `<` ? `<0.0.0-0` : `*` : gtlt && anyX ? (xm && (m$3 = 0), p$1 = 0, gtlt === `>` ? (gtlt = `>=`, xm ? (M$1 = +M$1 + 1, m$3 = 0, p$1 = 0) : (m$3 = +m$3 + 1, p$1 = 0)) : gtlt === `<=` && (gtlt = `<`, xm ? M$1 = +M$1 + 1 : m$3 = +m$3 + 1), gtlt === `<` && (pr = `-0`), ret = `${gtlt + M$1}.${m$3}.${p$1}${pr}`) : xm ? ret = `>=${M$1}.0.0${pr} <${+M$1 + 1}.0.0-0` : xp && (ret = `>=${M$1}.${m$3}.0${pr} <${M$1}.${+m$3 + 1}.0-0`), debug$1(`xRange return`, ret), ret;
    });
  }, replaceStars = (comp, options) => (debug$1(`replaceStars`, comp, options), comp.trim().replace(re$1[t$1.STAR], ``)), replaceGTE0 = (comp, options) => (debug$1(`replaceGTE0`, comp, options), comp.trim().replace(re$1[options.includePrerelease ? t$1.GTE0PRE : t$1.GTE0], ``)), hyphenReplace = (incPr) => ($0, from$2, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr) => (from$2 = isX(fM) ? `` : isX(fm) ? `>=${fM}.0.0${incPr ? `-0` : ``}` : isX(fp) ? `>=${fM}.${fm}.0${incPr ? `-0` : ``}` : fpr ? `>=${from$2}` : `>=${from$2}${incPr ? `-0` : ``}`, to = isX(tM) ? `` : isX(tm) ? `<${+tM + 1}.0.0-0` : isX(tp) ? `<${tM}.${+tm + 1}.0-0` : tpr ? `<=${tM}.${tm}.${tp}-${tpr}` : incPr ? `<${tM}.${tm}.${+tp + 1}-0` : `<=${to}`, `${from$2} ${to}`.trim()), testSet = (set, version$4, options) => {
    for (let i$4 = 0; i$4 < set.length; i$4++) if (!set[i$4].test(version$4)) return false;
    if (version$4.prerelease.length && !options.includePrerelease) {
      for (let i$4 = 0; i$4 < set.length; i$4++) if (debug$1(set[i$4].semver), set[i$4].semver !== Comparator$4.ANY && set[i$4].semver.prerelease.length > 0) {
        let allowed = set[i$4].semver;
        if (allowed.major === version$4.major && allowed.minor === version$4.minor && allowed.patch === version$4.patch) return true;
      }
      return false;
    }
    return true;
  };
}), require_comparator = __commonJSMin$1((exports$12, module2) => {
  let ANY$2 = Symbol(`SemVer ANY`);
  var Comparator$3 = class Comparator$32 {
    static get ANY() {
      return ANY$2;
    }
    constructor(comp, options) {
      if (options = parseOptions(options), comp instanceof Comparator$32) {
        if (comp.loose === !!options.loose) return comp;
        comp = comp.value;
      }
      comp = comp.trim().split(/\s+/).join(` `), debug(`comparator`, comp, options), this.options = options, this.loose = !!options.loose, this.parse(comp), this.semver === ANY$2 ? this.value = `` : this.value = this.operator + this.semver.version, debug(`comp`, this);
    }
    parse(comp) {
      let r$2 = this.options.loose ? re[t.COMPARATORLOOSE] : re[t.COMPARATOR], m$3 = comp.match(r$2);
      if (!m$3) throw TypeError(`Invalid comparator: ${comp}`);
      this.operator = m$3[1] === void 0 ? `` : m$3[1], this.operator === `=` && (this.operator = ``), m$3[2] ? this.semver = new SemVer$5(m$3[2], this.options.loose) : this.semver = ANY$2;
    }
    toString() {
      return this.value;
    }
    test(version$4) {
      if (debug(`Comparator.test`, version$4, this.options.loose), this.semver === ANY$2 || version$4 === ANY$2) return true;
      if (typeof version$4 == `string`) try {
        version$4 = new SemVer$5(version$4, this.options);
      } catch {
        return false;
      }
      return cmp$1(version$4, this.operator, this.semver, this.options);
    }
    intersects(comp, options) {
      if (!(comp instanceof Comparator$32)) throw TypeError(`a Comparator is required`);
      return this.operator === `` ? this.value === `` ? true : new Range$10(comp.value, options).test(this.value) : comp.operator === `` ? comp.value === `` ? true : new Range$10(this.value, options).test(comp.semver) : (options = parseOptions(options), options.includePrerelease && (this.value === `<0.0.0-0` || comp.value === `<0.0.0-0`) || !options.includePrerelease && (this.value.startsWith(`<0.0.0`) || comp.value.startsWith(`<0.0.0`)) ? false : !!(this.operator.startsWith(`>`) && comp.operator.startsWith(`>`) || this.operator.startsWith(`<`) && comp.operator.startsWith(`<`) || this.semver.version === comp.semver.version && this.operator.includes(`=`) && comp.operator.includes(`=`) || cmp$1(this.semver, `<`, comp.semver, options) && this.operator.startsWith(`>`) && comp.operator.startsWith(`<`) || cmp$1(this.semver, `>`, comp.semver, options) && this.operator.startsWith(`<`) && comp.operator.startsWith(`>`)));
    }
  };
  module2.exports = Comparator$3;
  let parseOptions = require_parse_options(), { safeRe: re, t } = require_re(), cmp$1 = require_cmp(), debug = require_debug(), SemVer$5 = require_semver$1(), Range$10 = require_range();
}), require_satisfies = __commonJSMin$1((exports$12, module2) => {
  let Range$9 = require_range(), satisfies$4 = (version$4, range, options) => {
    try {
      range = new Range$9(range, options);
    } catch {
      return false;
    }
    return range.test(version$4);
  };
  module2.exports = satisfies$4;
}), require_to_comparators = __commonJSMin$1((exports$12, module2) => {
  let Range$8 = require_range(), toComparators$1 = (range, options) => new Range$8(range, options).set.map((comp) => comp.map((c$12) => c$12.value).join(` `).trim().split(` `));
  module2.exports = toComparators$1;
}), require_max_satisfying = __commonJSMin$1((exports$12, module2) => {
  let SemVer$4 = require_semver$1(), Range$7 = require_range(), maxSatisfying$1 = (versions, range, options) => {
    let max$3 = null, maxSV = null, rangeObj = null;
    try {
      rangeObj = new Range$7(range, options);
    } catch {
      return null;
    }
    return versions.forEach((v$1) => {
      rangeObj.test(v$1) && (!max$3 || maxSV.compare(v$1) === -1) && (max$3 = v$1, maxSV = new SemVer$4(max$3, options));
    }), max$3;
  };
  module2.exports = maxSatisfying$1;
}), require_min_satisfying = __commonJSMin$1((exports$12, module2) => {
  let SemVer$3 = require_semver$1(), Range$6 = require_range(), minSatisfying$1 = (versions, range, options) => {
    let min$1 = null, minSV = null, rangeObj = null;
    try {
      rangeObj = new Range$6(range, options);
    } catch {
      return null;
    }
    return versions.forEach((v$1) => {
      rangeObj.test(v$1) && (!min$1 || minSV.compare(v$1) === 1) && (min$1 = v$1, minSV = new SemVer$3(min$1, options));
    }), min$1;
  };
  module2.exports = minSatisfying$1;
}), require_min_version = __commonJSMin$1((exports$12, module2) => {
  let SemVer$2 = require_semver$1(), Range$5 = require_range(), gt$2 = require_gt(), minVersion$1 = (range, loose) => {
    range = new Range$5(range, loose);
    let minver = new SemVer$2(`0.0.0`);
    if (range.test(minver) || (minver = new SemVer$2(`0.0.0-0`), range.test(minver))) return minver;
    minver = null;
    for (let i$4 = 0; i$4 < range.set.length; ++i$4) {
      let comparators = range.set[i$4], setMin = null;
      comparators.forEach((comparator) => {
        let compver = new SemVer$2(comparator.semver.version);
        switch (comparator.operator) {
          case `>`:
            compver.prerelease.length === 0 ? compver.patch++ : compver.prerelease.push(0), compver.raw = compver.format();
          case ``:
          case `>=`:
            (!setMin || gt$2(compver, setMin)) && (setMin = compver);
            break;
          case `<`:
          case `<=`:
            break;
          default:
            throw Error(`Unexpected operation: ${comparator.operator}`);
        }
      }), setMin && (!minver || gt$2(minver, setMin)) && (minver = setMin);
    }
    return minver && range.test(minver) ? minver : null;
  };
  module2.exports = minVersion$1;
}), require_valid = __commonJSMin$1((exports$12, module2) => {
  let Range$4 = require_range(), validRange$1 = (range, options) => {
    try {
      return new Range$4(range, options).range || `*`;
    } catch {
      return null;
    }
  };
  module2.exports = validRange$1;
}), require_outside = __commonJSMin$1((exports$12, module2) => {
  let SemVer$1 = require_semver$1(), Comparator$2 = require_comparator(), { ANY: ANY$1 } = Comparator$2, Range$3 = require_range(), satisfies$3 = require_satisfies(), gt$1 = require_gt(), lt$1 = require_lt(), lte$1 = require_lte(), gte$1 = require_gte(), outside$3 = (version$4, range, hilo, options) => {
    version$4 = new SemVer$1(version$4, options), range = new Range$3(range, options);
    let gtfn, ltefn, ltfn, comp, ecomp;
    switch (hilo) {
      case `>`:
        gtfn = gt$1, ltefn = lte$1, ltfn = lt$1, comp = `>`, ecomp = `>=`;
        break;
      case `<`:
        gtfn = lt$1, ltefn = gte$1, ltfn = gt$1, comp = `<`, ecomp = `<=`;
        break;
      default:
        throw TypeError(`Must provide a hilo val of "<" or ">"`);
    }
    if (satisfies$3(version$4, range, options)) return false;
    for (let i$4 = 0; i$4 < range.set.length; ++i$4) {
      let comparators = range.set[i$4], high = null, low = null;
      if (comparators.forEach((comparator) => {
        comparator.semver === ANY$1 && (comparator = new Comparator$2(`>=0.0.0`)), high ||= comparator, low ||= comparator, gtfn(comparator.semver, high.semver, options) ? high = comparator : ltfn(comparator.semver, low.semver, options) && (low = comparator);
      }), high.operator === comp || high.operator === ecomp || (!low.operator || low.operator === comp) && ltefn(version$4, low.semver) || low.operator === ecomp && ltfn(version$4, low.semver)) return false;
    }
    return true;
  };
  module2.exports = outside$3;
}), require_gtr = __commonJSMin$1((exports$12, module2) => {
  let outside$2 = require_outside(), gtr$1 = (version$4, range, options) => outside$2(version$4, range, `>`, options);
  module2.exports = gtr$1;
}), require_ltr = __commonJSMin$1((exports$12, module2) => {
  let outside$1 = require_outside(), ltr$1 = (version$4, range, options) => outside$1(version$4, range, `<`, options);
  module2.exports = ltr$1;
}), require_intersects = __commonJSMin$1((exports$12, module2) => {
  let Range$2 = require_range(), intersects$1 = (r1, r2, options) => (r1 = new Range$2(r1, options), r2 = new Range$2(r2, options), r1.intersects(r2, options));
  module2.exports = intersects$1;
}), require_simplify = __commonJSMin$1((exports$12, module2) => {
  let satisfies$2 = require_satisfies(), compare$2 = require_compare();
  module2.exports = (versions, range, options) => {
    let set = [], first$1 = null, prev = null, v$1 = versions.sort((a$22, b2) => compare$2(a$22, b2, options));
    for (let version$4 of v$1) {
      let included = satisfies$2(version$4, range, options);
      included ? (prev = version$4, first$1 ||= version$4) : (prev && set.push([first$1, prev]), prev = null, first$1 = null);
    }
    first$1 && set.push([first$1, null]);
    let ranges = [];
    for (let [min$1, max$3] of set) min$1 === max$3 ? ranges.push(min$1) : !max$3 && min$1 === v$1[0] ? ranges.push(`*`) : max$3 ? min$1 === v$1[0] ? ranges.push(`<=${max$3}`) : ranges.push(`${min$1} - ${max$3}`) : ranges.push(`>=${min$1}`);
    let simplified = ranges.join(` || `), original = typeof range.raw == `string` ? range.raw : String(range);
    return simplified.length < original.length ? simplified : range;
  };
}), require_subset = __commonJSMin$1((exports$12, module2) => {
  let Range$1 = require_range(), Comparator$1 = require_comparator(), { ANY } = Comparator$1, satisfies$1 = require_satisfies(), compare$1 = require_compare(), subset$1 = (sub, dom, options = {}) => {
    if (sub === dom) return true;
    sub = new Range$1(sub, options), dom = new Range$1(dom, options);
    let sawNonNull = false;
    OUTER: for (let simpleSub of sub.set) {
      for (let simpleDom of dom.set) {
        let isSub = simpleSubset(simpleSub, simpleDom, options);
        if (sawNonNull ||= isSub !== null, isSub) continue OUTER;
      }
      if (sawNonNull) return false;
    }
    return true;
  }, minimumVersionWithPreRelease = [new Comparator$1(`>=0.0.0-0`)], minimumVersion = [new Comparator$1(`>=0.0.0`)], simpleSubset = (sub, dom, options) => {
    if (sub === dom) return true;
    if (sub.length === 1 && sub[0].semver === ANY) {
      if (dom.length === 1 && dom[0].semver === ANY) return true;
      sub = options.includePrerelease ? minimumVersionWithPreRelease : minimumVersion;
    }
    if (dom.length === 1 && dom[0].semver === ANY) {
      if (options.includePrerelease) return true;
      dom = minimumVersion;
    }
    let eqSet = /* @__PURE__ */ new Set(), gt$5, lt$4;
    for (let c$12 of sub) c$12.operator === `>` || c$12.operator === `>=` ? gt$5 = higherGT(gt$5, c$12, options) : c$12.operator === `<` || c$12.operator === `<=` ? lt$4 = lowerLT(lt$4, c$12, options) : eqSet.add(c$12.semver);
    if (eqSet.size > 1) return null;
    let gtltComp;
    if (gt$5 && lt$4 && (gtltComp = compare$1(gt$5.semver, lt$4.semver, options), gtltComp > 0 || gtltComp === 0 && (gt$5.operator !== `>=` || lt$4.operator !== `<=`))) return null;
    for (let eq$9 of eqSet) {
      if (gt$5 && !satisfies$1(eq$9, String(gt$5), options) || lt$4 && !satisfies$1(eq$9, String(lt$4), options)) return null;
      for (let c$12 of dom) if (!satisfies$1(eq$9, String(c$12), options)) return false;
      return true;
    }
    let higher, lower, hasDomLT, hasDomGT, needDomLTPre = lt$4 && !options.includePrerelease && lt$4.semver.prerelease.length ? lt$4.semver : false, needDomGTPre = gt$5 && !options.includePrerelease && gt$5.semver.prerelease.length ? gt$5.semver : false;
    needDomLTPre && needDomLTPre.prerelease.length === 1 && lt$4.operator === `<` && needDomLTPre.prerelease[0] === 0 && (needDomLTPre = false);
    for (let c$12 of dom) {
      if (hasDomGT = hasDomGT || c$12.operator === `>` || c$12.operator === `>=`, hasDomLT = hasDomLT || c$12.operator === `<` || c$12.operator === `<=`, gt$5) {
        if (needDomGTPre && c$12.semver.prerelease && c$12.semver.prerelease.length && c$12.semver.major === needDomGTPre.major && c$12.semver.minor === needDomGTPre.minor && c$12.semver.patch === needDomGTPre.patch && (needDomGTPre = false), c$12.operator === `>` || c$12.operator === `>=`) {
          if (higher = higherGT(gt$5, c$12, options), higher === c$12 && higher !== gt$5) return false;
        } else if (gt$5.operator === `>=` && !satisfies$1(gt$5.semver, String(c$12), options)) return false;
      }
      if (lt$4) {
        if (needDomLTPre && c$12.semver.prerelease && c$12.semver.prerelease.length && c$12.semver.major === needDomLTPre.major && c$12.semver.minor === needDomLTPre.minor && c$12.semver.patch === needDomLTPre.patch && (needDomLTPre = false), c$12.operator === `<` || c$12.operator === `<=`) {
          if (lower = lowerLT(lt$4, c$12, options), lower === c$12 && lower !== lt$4) return false;
        } else if (lt$4.operator === `<=` && !satisfies$1(lt$4.semver, String(c$12), options)) return false;
      }
      if (!c$12.operator && (lt$4 || gt$5) && gtltComp !== 0) return false;
    }
    return !(gt$5 && hasDomLT && !lt$4 && gtltComp !== 0 || lt$4 && hasDomGT && !gt$5 && gtltComp !== 0 || needDomGTPre || needDomLTPre);
  }, higherGT = (a$22, b2, options) => {
    if (!a$22) return b2;
    let comp = compare$1(a$22.semver, b2.semver, options);
    return comp > 0 ? a$22 : comp < 0 || b2.operator === `>` && a$22.operator === `>=` ? b2 : a$22;
  }, lowerLT = (a$22, b2, options) => {
    if (!a$22) return b2;
    let comp = compare$1(a$22.semver, b2.semver, options);
    return comp < 0 ? a$22 : comp > 0 || b2.operator === `<` && a$22.operator === `<=` ? b2 : a$22;
  };
  module2.exports = subset$1;
}), require_semver = __commonJSMin$1((exports$12, module2) => {
  let internalRe = require_re(), constants = require_constants(), SemVer = require_semver$1(), identifiers = require_identifiers(), parse2 = require_parse(), valid = require_valid$1(), clean = require_clean(), inc = require_inc(), diff2 = require_diff(), major = require_major(), minor = require_minor(), patch$1 = require_patch(), prerelease = require_prerelease(), compare = require_compare(), rcompare = require_rcompare(), compareLoose = require_compare_loose(), compareBuild = require_compare_build(), sort = require_sort(), rsort = require_rsort(), gt = require_gt(), lt = require_lt(), eq = require_eq(), neq = require_neq(), gte = require_gte(), lte = require_lte(), cmp = require_cmp(), coerce = require_coerce(), Comparator = require_comparator(), Range = require_range(), satisfies = require_satisfies(), toComparators = require_to_comparators(), maxSatisfying = require_max_satisfying(), minSatisfying = require_min_satisfying(), minVersion = require_min_version(), validRange = require_valid(), outside = require_outside(), gtr = require_gtr(), ltr = require_ltr(), intersects = require_intersects(), simplifyRange = require_simplify(), subset = require_subset();
  module2.exports = { parse: parse2, valid, clean, inc, diff: diff2, major, minor, patch: patch$1, prerelease, compare, rcompare, compareLoose, compareBuild, sort, rsort, gt, lt, eq, neq, gte, lte, cmp, coerce, Comparator, Range, satisfies, toComparators, maxSatisfying, minSatisfying, minVersion, validRange, outside, gtr, ltr, intersects, simplifyRange, subset, SemVer, re: internalRe.re, src: internalRe.src, tokens: internalRe.t, SEMVER_SPEC_VERSION: constants.SEMVER_SPEC_VERSION, RELEASE_TYPES: constants.RELEASE_TYPES, compareIdentifiers: identifiers.compareIdentifiers, rcompareIdentifiers: identifiers.rcompareIdentifiers };
}), u8 = Uint8Array, u16 = Uint16Array, i32 = Int32Array, fleb = new u8([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0]), fdeb = new u8([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0]);
new u8([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
var freb = function(eb, start) {
  for (var b2 = new u16(31), i$4 = 0; i$4 < 31; ++i$4) b2[i$4] = start += 1 << eb[i$4 - 1];
  for (var r$2 = new i32(b2[30]), i$4 = 1; i$4 < 30; ++i$4) for (var j$1 = b2[i$4]; j$1 < b2[i$4 + 1]; ++j$1) r$2[j$1] = j$1 - b2[i$4] << 5 | i$4;
  return { b: b2, r: r$2 };
}, _a = freb(fleb, 2), fl = _a.b, revfl = _a.r;
fl[28] = 258, revfl[258] = 28;
for (var _b = freb(fdeb, 0), fd = _b.b, revfd = _b.r, rev = new u16(32768), i = 0; i < 32768; ++i) {
  var x = (i & 43690) >> 1 | (i & 21845) << 1;
  x = (x & 52428) >> 2 | (x & 13107) << 2, x = (x & 61680) >> 4 | (x & 3855) << 4, rev[i] = ((x & 65280) >> 8 | (x & 255) << 8) >> 1;
}
for (var hMap = function(cd, mb, r$2) {
  for (var s$6 = cd.length, i$4 = 0, l$4 = new u16(mb); i$4 < s$6; ++i$4) cd[i$4] && ++l$4[cd[i$4] - 1];
  var le$1 = new u16(mb);
  for (i$4 = 1; i$4 < mb; ++i$4) le$1[i$4] = le$1[i$4 - 1] + l$4[i$4 - 1] << 1;
  var co;
  if (r$2) {
    co = new u16(1 << mb);
    var rvb = 15 - mb;
    for (i$4 = 0; i$4 < s$6; ++i$4) if (cd[i$4]) for (var sv = i$4 << 4 | cd[i$4], r_1 = mb - cd[i$4], v$1 = le$1[cd[i$4] - 1]++ << r_1, m$3 = v$1 | (1 << r_1) - 1; v$1 <= m$3; ++v$1) co[rev[v$1] >> rvb] = sv;
  } else for (co = new u16(s$6), i$4 = 0; i$4 < s$6; ++i$4) cd[i$4] && (co[i$4] = rev[le$1[cd[i$4] - 1]++] >> 15 - cd[i$4]);
  return co;
}, flt = new u8(288), i = 0; i < 144; ++i) flt[i] = 8;
for (var i = 144; i < 256; ++i) flt[i] = 9;
for (var i = 256; i < 280; ++i) flt[i] = 7;
for (var i = 280; i < 288; ++i) flt[i] = 8;
for (var fdt = new u8(32), i = 0; i < 32; ++i) fdt[i] = 5;
hMap(flt, 9, 0);
hMap(flt, 9, 1);
hMap(fdt, 5, 0);
hMap(fdt, 5, 1);
new i32([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]);
var et = new u8(0);
typeof TextEncoder < `u` && new TextEncoder();
var td = typeof TextDecoder < `u` && new TextDecoder(), tds = 0;
try {
  td.decode(et, { stream: true }), tds = 1;
} catch {
}
__toESM(require_semver());
const Joi = RootFactory.create({ schemaTypeModifiers: [knex, fqdn], shortcutsModifiers: [] }), validator = patch(Joi.extend(bigint).extend(datetime).extend(phone)), TLDS = `AAA.AARP.ABB.ABBOTT.ABBVIE.ABC.ABLE.ABOGADO.ABUDHABI.AC.ACADEMY.ACCENTURE.ACCOUNTANT.ACCOUNTANTS.ACO.ACTOR.AD.ADS.ADULT.AE.AEG.AERO.AETNA.AF.AFL.AFRICA.AG.AGAKHAN.AGENCY.AI.AIG.AIRBUS.AIRFORCE.AIRTEL.AKDN.AL.ALIBABA.ALIPAY.ALLFINANZ.ALLSTATE.ALLY.ALSACE.ALSTOM.AM.AMAZON.AMERICANEXPRESS.AMERICANFAMILY.AMEX.AMFAM.AMICA.AMSTERDAM.ANALYTICS.ANDROID.ANQUAN.ANZ.AO.AOL.APARTMENTS.APP.APPLE.AQ.AQUARELLE.AR.ARAB.ARAMCO.ARCHI.ARMY.ARPA.ART.ARTE.AS.ASDA.ASIA.ASSOCIATES.AT.ATHLETA.ATTORNEY.AU.AUCTION.AUDI.AUDIBLE.AUDIO.AUSPOST.AUTHOR.AUTO.AUTOS.AW.AWS.AX.AXA.AZ.AZURE.BA.BABY.BAIDU.BANAMEX.BAND.BANK.BAR.BARCELONA.BARCLAYCARD.BARCLAYS.BAREFOOT.BARGAINS.BASEBALL.BASKETBALL.BAUHAUS.BAYERN.BB.BBC.BBT.BBVA.BCG.BCN.BD.BE.BEATS.BEAUTY.BEER.BERLIN.BEST.BESTBUY.BET.BF.BG.BH.BHARTI.BI.BIBLE.BID.BIKE.BING.BINGO.BIO.BIZ.BJ.BLACK.BLACKFRIDAY.BLOCKBUSTER.BLOG.BLOOMBERG.BLUE.BM.BMS.BMW.BN.BNPPARIBAS.BO.BOATS.BOEHRINGER.BOFA.BOM.BOND.BOO.BOOK.BOOKING.BOSCH.BOSTIK.BOSTON.BOT.BOUTIQUE.BOX.BR.BRADESCO.BRIDGESTONE.BROADWAY.BROKER.BROTHER.BRUSSELS.BS.BT.BUILD.BUILDERS.BUSINESS.BUY.BUZZ.BV.BW.BY.BZ.BZH.CA.CAB.CAFE.CAL.CALL.CALVINKLEIN.CAM.CAMERA.CAMP.CANON.CAPETOWN.CAPITAL.CAPITALONE.CAR.CARAVAN.CARDS.CARE.CAREER.CAREERS.CARS.CASA.CASE.CASH.CASINO.CAT.CATERING.CATHOLIC.CBA.CBN.CBRE.CC.CD.CENTER.CEO.CERN.CF.CFA.CFD.CG.CH.CHANEL.CHANNEL.CHARITY.CHASE.CHAT.CHEAP.CHINTAI.CHRISTMAS.CHROME.CHURCH.CI.CIPRIANI.CIRCLE.CISCO.CITADEL.CITI.CITIC.CITY.CK.CL.CLAIMS.CLEANING.CLICK.CLINIC.CLINIQUE.CLOTHING.CLOUD.CLUB.CLUBMED.CM.CN.CO.COACH.CODES.COFFEE.COLLEGE.COLOGNE.COM.COMMBANK.COMMUNITY.COMPANY.COMPARE.COMPUTER.COMSEC.CONDOS.CONSTRUCTION.CONSULTING.CONTACT.CONTRACTORS.COOKING.COOL.COOP.CORSICA.COUNTRY.COUPON.COUPONS.COURSES.CPA.CR.CREDIT.CREDITCARD.CREDITUNION.CRICKET.CROWN.CRS.CRUISE.CRUISES.CU.CUISINELLA.CV.CW.CX.CY.CYMRU.CYOU.CZ.DAD.DANCE.DATA.DATE.DATING.DATSUN.DAY.DCLK.DDS.DE.DEAL.DEALER.DEALS.DEGREE.DELIVERY.DELL.DELOITTE.DELTA.DEMOCRAT.DENTAL.DENTIST.DESI.DESIGN.DEV.DHL.DIAMONDS.DIET.DIGITAL.DIRECT.DIRECTORY.DISCOUNT.DISCOVER.DISH.DIY.DJ.DK.DM.DNP.DO.DOCS.DOCTOR.DOG.DOMAINS.DOT.DOWNLOAD.DRIVE.DTV.DUBAI.DUPONT.DURBAN.DVAG.DVR.DZ.EARTH.EAT.EC.ECO.EDEKA.EDU.EDUCATION.EE.EG.EMAIL.EMERCK.ENERGY.ENGINEER.ENGINEERING.ENTERPRISES.EPSON.EQUIPMENT.ER.ERICSSON.ERNI.ES.ESQ.ESTATE.ET.EU.EUROVISION.EUS.EVENTS.EXCHANGE.EXPERT.EXPOSED.EXPRESS.EXTRASPACE.FAGE.FAIL.FAIRWINDS.FAITH.FAMILY.FAN.FANS.FARM.FARMERS.FASHION.FAST.FEDEX.FEEDBACK.FERRARI.FERRERO.FI.FIDELITY.FIDO.FILM.FINAL.FINANCE.FINANCIAL.FIRE.FIRESTONE.FIRMDALE.FISH.FISHING.FIT.FITNESS.FJ.FK.FLICKR.FLIGHTS.FLIR.FLORIST.FLOWERS.FLY.FM.FO.FOO.FOOD.FOOTBALL.FORD.FOREX.FORSALE.FORUM.FOUNDATION.FOX.FR.FREE.FRESENIUS.FRL.FROGANS.FRONTIER.FTR.FUJITSU.FUN.FUND.FURNITURE.FUTBOL.FYI.GA.GAL.GALLERY.GALLO.GALLUP.GAME.GAMES.GAP.GARDEN.GAY.GB.GBIZ.GD.GDN.GE.GEA.GENT.GENTING.GEORGE.GF.GG.GGEE.GH.GI.GIFT.GIFTS.GIVES.GIVING.GL.GLASS.GLE.GLOBAL.GLOBO.GM.GMAIL.GMBH.GMO.GMX.GN.GODADDY.GOLD.GOLDPOINT.GOLF.GOO.GOODYEAR.GOOG.GOOGLE.GOP.GOT.GOV.GP.GQ.GR.GRAINGER.GRAPHICS.GRATIS.GREEN.GRIPE.GROCERY.GROUP.GS.GT.GU.GUCCI.GUGE.GUIDE.GUITARS.GURU.GW.GY.HAIR.HAMBURG.HANGOUT.HAUS.HBO.HDFC.HDFCBANK.HEALTH.HEALTHCARE.HELP.HELSINKI.HERE.HERMES.HIPHOP.HISAMITSU.HITACHI.HIV.HK.HKT.HM.HN.HOCKEY.HOLDINGS.HOLIDAY.HOMEDEPOT.HOMEGOODS.HOMES.HOMESENSE.HONDA.HORSE.HOSPITAL.HOST.HOSTING.HOT.HOTELS.HOTMAIL.HOUSE.HOW.HR.HSBC.HT.HU.HUGHES.HYATT.HYUNDAI.IBM.ICBC.ICE.ICU.ID.IE.IEEE.IFM.IKANO.IL.IM.IMAMAT.IMDB.IMMO.IMMOBILIEN.IN.INC.INDUSTRIES.INFINITI.INFO.ING.INK.INSTITUTE.INSURANCE.INSURE.INT.INTERNATIONAL.INTUIT.INVESTMENTS.IO.IPIRANGA.IQ.IR.IRISH.IS.ISMAILI.IST.ISTANBUL.IT.ITAU.ITV.JAGUAR.JAVA.JCB.JE.JEEP.JETZT.JEWELRY.JIO.JLL.JM.JMP.JNJ.JO.JOBS.JOBURG.JOT.JOY.JP.JPMORGAN.JPRS.JUEGOS.JUNIPER.KAUFEN.KDDI.KE.KERRYHOTELS.KERRYPROPERTIES.KFH.KG.KH.KI.KIA.KIDS.KIM.KINDLE.KITCHEN.KIWI.KM.KN.KOELN.KOMATSU.KOSHER.KP.KPMG.KPN.KR.KRD.KRED.KUOKGROUP.KW.KY.KYOTO.KZ.LA.LACAIXA.LAMBORGHINI.LAMER.LAND.LANDROVER.LANXESS.LASALLE.LAT.LATINO.LATROBE.LAW.LAWYER.LB.LC.LDS.LEASE.LECLERC.LEFRAK.LEGAL.LEGO.LEXUS.LGBT.LI.LIDL.LIFE.LIFEINSURANCE.LIFESTYLE.LIGHTING.LIKE.LILLY.LIMITED.LIMO.LINCOLN.LINK.LIVE.LIVING.LK.LLC.LLP.LOAN.LOANS.LOCKER.LOCUS.LOL.LONDON.LOTTE.LOTTO.LOVE.LPL.LPLFINANCIAL.LR.LS.LT.LTD.LTDA.LU.LUNDBECK.LUXE.LUXURY.LV.LY.MA.MADRID.MAIF.MAISON.MAKEUP.MAN.MANAGEMENT.MANGO.MAP.MARKET.MARKETING.MARKETS.MARRIOTT.MARSHALLS.MATTEL.MBA.MC.MCKINSEY.MD.ME.MED.MEDIA.MEET.MELBOURNE.MEME.MEMORIAL.MEN.MENU.MERCKMSD.MG.MH.MIAMI.MICROSOFT.MIL.MINI.MINT.MIT.MITSUBISHI.MK.ML.MLB.MLS.MM.MMA.MN.MO.MOBI.MOBILE.MODA.MOE.MOI.MOM.MONASH.MONEY.MONSTER.MORMON.MORTGAGE.MOSCOW.MOTO.MOTORCYCLES.MOV.MOVIE.MP.MQ.MR.MS.MSD.MT.MTN.MTR.MU.MUSEUM.MUSIC.MV.MW.MX.MY.MZ.NA.NAB.NAGOYA.NAME.NAVY.NBA.NC.NE.NEC.NET.NETBANK.NETFLIX.NETWORK.NEUSTAR.NEW.NEWS.NEXT.NEXTDIRECT.NEXUS.NF.NFL.NG.NGO.NHK.NI.NICO.NIKE.NIKON.NINJA.NISSAN.NISSAY.NL.NO.NOKIA.NORTON.NOW.NOWRUZ.NOWTV.NP.NR.NRA.NRW.NTT.NU.NYC.NZ.OBI.OBSERVER.OFFICE.OKINAWA.OLAYAN.OLAYANGROUP.OLLO.OM.OMEGA.ONE.ONG.ONL.ONLINE.OOO.OPEN.ORACLE.ORANGE.ORG.ORGANIC.ORIGINS.OSAKA.OTSUKA.OTT.OVH.PA.PAGE.PANASONIC.PARIS.PARS.PARTNERS.PARTS.PARTY.PAY.PCCW.PE.PET.PF.PFIZER.PG.PH.PHARMACY.PHD.PHILIPS.PHONE.PHOTO.PHOTOGRAPHY.PHOTOS.PHYSIO.PICS.PICTET.PICTURES.PID.PIN.PING.PINK.PIONEER.PIZZA.PK.PL.PLACE.PLAY.PLAYSTATION.PLUMBING.PLUS.PM.PN.PNC.POHL.POKER.POLITIE.PORN.POST.PR.PRAXI.PRESS.PRIME.PRO.PROD.PRODUCTIONS.PROF.PROGRESSIVE.PROMO.PROPERTIES.PROPERTY.PROTECTION.PRU.PRUDENTIAL.PS.PT.PUB.PW.PWC.PY.QA.QPON.QUEBEC.QUEST.RACING.RADIO.RE.READ.REALESTATE.REALTOR.REALTY.RECIPES.RED.REDUMBRELLA.REHAB.REISE.REISEN.REIT.RELIANCE.REN.RENT.RENTALS.REPAIR.REPORT.REPUBLICAN.REST.RESTAURANT.REVIEW.REVIEWS.REXROTH.RICH.RICHARDLI.RICOH.RIL.RIO.RIP.RO.ROCKS.RODEO.ROGERS.ROOM.RS.RSVP.RU.RUGBY.RUHR.RUN.RW.RWE.RYUKYU.SA.SAARLAND.SAFE.SAFETY.SAKURA.SALE.SALON.SAMSCLUB.SAMSUNG.SANDVIK.SANDVIKCOROMANT.SANOFI.SAP.SARL.SAS.SAVE.SAXO.SB.SBI.SBS.SC.SCB.SCHAEFFLER.SCHMIDT.SCHOLARSHIPS.SCHOOL.SCHULE.SCHWARZ.SCIENCE.SCOT.SD.SE.SEARCH.SEAT.SECURE.SECURITY.SEEK.SELECT.SENER.SERVICES.SEVEN.SEW.SEX.SEXY.SFR.SG.SH.SHANGRILA.SHARP.SHELL.SHIA.SHIKSHA.SHOES.SHOP.SHOPPING.SHOUJI.SHOW.SI.SILK.SINA.SINGLES.SITE.SJ.SK.SKI.SKIN.SKY.SKYPE.SL.SLING.SM.SMART.SMILE.SN.SNCF.SO.SOCCER.SOCIAL.SOFTBANK.SOFTWARE.SOHU.SOLAR.SOLUTIONS.SONG.SONY.SOY.SPA.SPACE.SPORT.SPOT.SR.SRL.SS.ST.STADA.STAPLES.STAR.STATEBANK.STATEFARM.STC.STCGROUP.STOCKHOLM.STORAGE.STORE.STREAM.STUDIO.STUDY.STYLE.SU.SUCKS.SUPPLIES.SUPPLY.SUPPORT.SURF.SURGERY.SUZUKI.SV.SWATCH.SWISS.SX.SY.SYDNEY.SYSTEMS.SZ.TAB.TAIPEI.TALK.TAOBAO.TARGET.TATAMOTORS.TATAR.TATTOO.TAX.TAXI.TC.TCI.TD.TDK.TEAM.TECH.TECHNOLOGY.TEL.TEMASEK.TENNIS.TEVA.TF.TG.TH.THD.THEATER.THEATRE.TIAA.TICKETS.TIENDA.TIPS.TIRES.TIROL.TJ.TJMAXX.TJX.TK.TKMAXX.TL.TM.TMALL.TN.TO.TODAY.TOKYO.TOOLS.TOP.TORAY.TOSHIBA.TOTAL.TOURS.TOWN.TOYOTA.TOYS.TR.TRADE.TRADING.TRAINING.TRAVEL.TRAVELERS.TRAVELERSINSURANCE.TRUST.TRV.TT.TUBE.TUI.TUNES.TUSHU.TV.TVS.TW.TZ.UA.UBANK.UBS.UG.UK.UNICOM.UNIVERSITY.UNO.UOL.UPS.US.UY.UZ.VA.VACATIONS.VANA.VANGUARD.VC.VE.VEGAS.VENTURES.VERISIGN.VERSICHERUNG.VET.VG.VI.VIAJES.VIDEO.VIG.VIKING.VILLAS.VIN.VIP.VIRGIN.VISA.VISION.VIVA.VIVO.VLAANDEREN.VN.VODKA.VOLVO.VOTE.VOTING.VOTO.VOYAGE.VU.WALES.WALMART.WALTER.WANG.WANGGOU.WATCH.WATCHES.WEATHER.WEATHERCHANNEL.WEBCAM.WEBER.WEBSITE.WED.WEDDING.WEIBO.WEIR.WF.WHOSWHO.WIEN.WIKI.WILLIAMHILL.WIN.WINDOWS.WINE.WINNERS.WME.WOLTERSKLUWER.WOODSIDE.WORK.WORKS.WORLD.WOW.WS.WTC.WTF.XBOX.XEROX.XIHUAN.XIN.XN--11B4C3D.XN--1CK2E1B.XN--1QQW23A.XN--2SCRJ9C.XN--30RR7Y.XN--3BST00M.XN--3DS443G.XN--3E0B707E.XN--3HCRJ9C.XN--3PXU8K.XN--42C2D9A.XN--45BR5CYL.XN--45BRJ9C.XN--45Q11C.XN--4DBRK0CE.XN--4GBRIM.XN--54B7FTA0CC.XN--55QW42G.XN--55QX5D.XN--5SU34J936BGSG.XN--5TZM5G.XN--6FRZ82G.XN--6QQ986B3XL.XN--80ADXHKS.XN--80AO21A.XN--80AQECDR1A.XN--80ASEHDB.XN--80ASWG.XN--8Y0A063A.XN--90A3AC.XN--90AE.XN--90AIS.XN--9DBQ2A.XN--9ET52U.XN--9KRT00A.XN--B4W605FERD.XN--BCK1B9A5DRE4C.XN--C1AVG.XN--C2BR7G.XN--CCK2B3B.XN--CCKWCXETD.XN--CG4BKI.XN--CLCHC0EA0B2G2A9GCD.XN--CZR694B.XN--CZRS0T.XN--CZRU2D.XN--D1ACJ3B.XN--D1ALF.XN--E1A4C.XN--ECKVDTC9D.XN--EFVY88H.XN--FCT429K.XN--FHBEI.XN--FIQ228C5HS.XN--FIQ64B.XN--FIQS8S.XN--FIQZ9S.XN--FJQ720A.XN--FLW351E.XN--FPCRJ9C3D.XN--FZC2C9E2C.XN--FZYS8D69UVGM.XN--G2XX48C.XN--GCKR3F0F.XN--GECRJ9C.XN--GK3AT1E.XN--H2BREG3EVE.XN--H2BRJ9C.XN--H2BRJ9C8C.XN--HXT814E.XN--I1B6B1A6A2E.XN--IMR513N.XN--IO0A7I.XN--J1AEF.XN--J1AMH.XN--J6W193G.XN--JLQ480N2RG.XN--JVR189M.XN--KCRX77D1X4A.XN--KPRW13D.XN--KPRY57D.XN--KPUT3I.XN--L1ACC.XN--LGBBAT1AD8J.XN--MGB9AWBF.XN--MGBA3A3EJT.XN--MGBA3A4F16A.XN--MGBA7C0BBN0A.XN--MGBAAM7A8H.XN--MGBAB2BD.XN--MGBAH1A3HJKRD.XN--MGBAI9AZGQP6J.XN--MGBAYH7GPA.XN--MGBBH1A.XN--MGBBH1A71E.XN--MGBC0A9AZCG.XN--MGBCA7DZDO.XN--MGBCPQ6GPA1A.XN--MGBERP4A5D4AR.XN--MGBGU82A.XN--MGBI4ECEXP.XN--MGBPL2FH.XN--MGBT3DHD.XN--MGBTX2B.XN--MGBX4CD0AB.XN--MIX891F.XN--MK1BU44C.XN--MXTQ1M.XN--NGBC5AZD.XN--NGBE9E0A.XN--NGBRX.XN--NODE.XN--NQV7F.XN--NQV7FS00EMA.XN--NYQY26A.XN--O3CW4H.XN--OGBPF8FL.XN--OTU796D.XN--P1ACF.XN--P1AI.XN--PGBS0DH.XN--PSSY2U.XN--Q7CE6A.XN--Q9JYB4C.XN--QCKA1PMC.XN--QXA6A.XN--QXAM.XN--RHQV96G.XN--ROVU88B.XN--RVC1E0AM3E.XN--S9BRJ9C.XN--SES554G.XN--T60B56A.XN--TCKWE.XN--TIQ49XQYJ.XN--UNUP4Y.XN--VERMGENSBERATER-CTB.XN--VERMGENSBERATUNG-PWB.XN--VHQUV.XN--VUQ861B.XN--W4R85EL8FHU5DNRA.XN--W4RS40L.XN--WGBH1C.XN--WGBL6A.XN--XHQ521B.XN--XKC2AL3HYE2A.XN--XKC2DL3A5EE0H.XN--Y9A3AQ.XN--YFRO4I67O.XN--YGBI2AMMX.XN--ZFR164B.XXX.XYZ.YACHTS.YAHOO.YAMAXUN.YANDEX.YE.YODOBASHI.YOGA.YOKOHAMA.YOU.YOUTUBE.YT.YUN.ZA.ZAPPOS.ZARA.ZERO.ZIP.ZM.ZONE.ZUERICH.ZW`.split(`.`);
new Set(TLDS.map((tld) => tld.toLowerCase()));
init_esm();
__toESM(require_lib$3());
var import_lib$1 = __toESM(require_lib$2()), import_lib$2 = __toESM(require_lib());
import_lib$2.ValidationError;
import_lib$1.location;
var __commonJSMin = (cb, mod) => () => (mod || cb((mod = { exports: {} }).exports, mod), mod.exports), __require = /* @__PURE__ */ ((x2) => typeof require < "u" ? require : typeof Proxy < "u" ? new Proxy(x2, { get: (a2, b2) => (typeof require < "u" ? require : a2)[b2] }) : x2)(function(x2) {
  if (typeof require < "u") return require.apply(this, arguments);
  throw Error('Calling `require` for "' + x2 + "\" in an environment that doesn't expose the `require` function.");
});
const countries = Object.freeze(/* @__PURE__ */ new Map([
  ["AD", "Andorra"],
  ["AE", "United Arab Emirates"],
  ["AF", "Afghanistan"],
  ["AG", "Antigua and Barbuda"],
  ["AI", "Anguilla"],
  ["AL", "Albania"],
  ["AM", "Armenia"],
  ["AO", "Angola"],
  ["AQ", "Antarctica"],
  ["AR", "Argentina"],
  ["AS", "American Samoa"],
  ["AT", "Austria"],
  ["AU", "Australia"],
  ["AW", "Aruba"],
  ["AX", "Aland Islands"],
  ["AZ", "Azerbaijan"],
  ["BA", "Bosnia and Herzegovina"],
  ["BB", "Barbados"],
  ["BD", "Bangladesh"],
  ["BE", "Belgium"],
  ["BF", "Burkina Faso"],
  ["BG", "Bulgaria"],
  ["BH", "Bahrain"],
  ["BI", "Burundi"],
  ["BJ", "Benin"],
  ["BL", "Saint Barthelemy"],
  ["BM", "Bermuda"],
  ["BN", "Brunei"],
  ["BO", "Bolivia"],
  ["BQ", "Bonaire, Saint Eustatius and Saba"],
  ["BR", "Brazil"],
  ["BS", "Bahamas"],
  ["BT", "Bhutan"],
  ["BV", "Bouvet Island"],
  ["BW", "Botswana"],
  ["BY", "Belarus"],
  ["BZ", "Belize"],
  ["CA", "Canada"],
  ["CC", "Cocos Islands"],
  ["CD", "Democratic Republic of the Congo"],
  ["CF", "Central African Republic"],
  ["CG", "Republic of the Congo"],
  ["CH", "Switzerland"],
  ["CI", "Ivory Coast"],
  ["CK", "Cook Islands"],
  ["CL", "Chile"],
  ["CM", "Cameroon"],
  ["CN", "China"],
  ["CO", "Colombia"],
  ["CR", "Costa Rica"],
  ["CU", "Cuba"],
  ["CV", "Cape Verde"],
  ["CW", "Curacao"],
  ["CX", "Christmas Island"],
  ["CY", "Cyprus"],
  ["CZ", "Czech Republic"],
  ["DE", "Germany"],
  ["DJ", "Djibouti"],
  ["DK", "Denmark"],
  ["DM", "Dominica"],
  ["DO", "Dominican Republic"],
  ["DZ", "Algeria"],
  ["EC", "Ecuador"],
  ["EE", "Estonia"],
  ["EG", "Egypt"],
  ["EH", "Western Sahara"],
  ["ER", "Eritrea"],
  ["ES", "Spain"],
  ["ET", "Ethiopia"],
  ["FI", "Finland"],
  ["FJ", "Fiji"],
  ["FK", "Falkland Islands"],
  ["FM", "Micronesia"],
  ["FO", "Faroe Islands"],
  ["FR", "France"],
  ["GA", "Gabon"],
  ["GB", "United Kingdom"],
  ["GD", "Grenada"],
  ["GE", "Georgia"],
  ["GF", "French Guiana"],
  ["GG", "Guernsey"],
  ["GH", "Ghana"],
  ["GI", "Gibraltar"],
  ["GL", "Greenland"],
  ["GM", "Gambia"],
  ["GN", "Guinea"],
  ["GP", "Guadeloupe"],
  ["GQ", "Equatorial Guinea"],
  ["GR", "Greece"],
  ["GS", "South Georgia and the South Sandwich Islands"],
  ["GT", "Guatemala"],
  ["GU", "Guam"],
  ["GW", "Guinea-Bissau"],
  ["GY", "Guyana"],
  ["HK", "Hong Kong"],
  ["HM", "Heard Island and McDonald Islands"],
  ["HN", "Honduras"],
  ["HR", "Croatia"],
  ["HT", "Haiti"],
  ["HU", "Hungary"],
  ["ID", "Indonesia"],
  ["IE", "Ireland"],
  ["IL", "Israel"],
  ["IM", "Isle of Man"],
  ["IN", "India"],
  ["IO", "British Indian Ocean Territory"],
  ["IQ", "Iraq"],
  ["IR", "Iran"],
  ["IS", "Iceland"],
  ["IT", "Italy"],
  ["JE", "Jersey"],
  ["JM", "Jamaica"],
  ["JO", "Jordan"],
  ["JP", "Japan"],
  ["KE", "Kenya"],
  ["KG", "Kyrgyzstan"],
  ["KH", "Cambodia"],
  ["KI", "Kiribati"],
  ["KM", "Comoros"],
  ["KN", "Saint Kitts and Nevis"],
  ["KP", "North Korea"],
  ["KR", "South Korea"],
  ["KW", "Kuwait"],
  ["KY", "Cayman Islands"],
  ["KZ", "Kazakhstan"],
  ["LA", "Laos"],
  ["LB", "Lebanon"],
  ["LC", "Saint Lucia"],
  ["LI", "Liechtenstein"],
  ["LK", "Sri Lanka"],
  ["LR", "Liberia"],
  ["LS", "Lesotho"],
  ["LT", "Lithuania"],
  ["LU", "Luxembourg"],
  ["LV", "Latvia"],
  ["LY", "Libya"],
  ["MA", "Morocco"],
  ["MC", "Monaco"],
  ["MD", "Moldova"],
  ["ME", "Montenegro"],
  ["MF", "Saint Martin"],
  ["MG", "Madagascar"],
  ["MH", "Marshall Islands"],
  ["MK", "Macedonia"],
  ["ML", "Mali"],
  ["MM", "Myanmar"],
  ["MN", "Mongolia"],
  ["MO", "Macao"],
  ["MP", "Northern Mariana Islands"],
  ["MQ", "Martinique"],
  ["MR", "Mauritania"],
  ["MS", "Montserrat"],
  ["MT", "Malta"],
  ["MU", "Mauritius"],
  ["MV", "Maldives"],
  ["MW", "Malawi"],
  ["MX", "Mexico"],
  ["MY", "Malaysia"],
  ["MZ", "Mozambique"],
  ["NA", "Namibia"],
  ["NC", "New Caledonia"],
  ["NE", "Niger"],
  ["NF", "Norfolk Island"],
  ["NG", "Nigeria"],
  ["NI", "Nicaragua"],
  ["NL", "Netherlands"],
  ["NO", "Norway"],
  ["NP", "Nepal"],
  ["NR", "Nauru"],
  ["NU", "Niue"],
  ["NZ", "New Zealand"],
  ["OM", "Oman"],
  ["PA", "Panama"],
  ["PE", "Peru"],
  ["PF", "French Polynesia"],
  ["PG", "Papua New Guinea"],
  ["PH", "Philippines"],
  ["PK", "Pakistan"],
  ["PL", "Poland"],
  ["PM", "Saint Pierre and Miquelon"],
  ["PN", "Pitcairn"],
  ["PR", "Puerto Rico"],
  ["PS", "Palestinian Territory"],
  ["PT", "Portugal"],
  ["PW", "Palau"],
  ["PY", "Paraguay"],
  ["QA", "Qatar"],
  ["RE", "Reunion"],
  ["RO", "Romania"],
  ["RS", "Serbia"],
  ["RU", "Russia"],
  ["RW", "Rwanda"],
  ["SA", "Saudi Arabia"],
  ["SB", "Solomon Islands"],
  ["SC", "Seychelles"],
  ["SD", "Sudan"],
  ["SE", "Sweden"],
  ["SG", "Singapore"],
  ["SH", "Saint Helena"],
  ["SI", "Slovenia"],
  ["SJ", "Svalbard and Jan Mayen"],
  ["SK", "Slovakia"],
  ["SL", "Sierra Leone"],
  ["SM", "San Marino"],
  ["SN", "Senegal"],
  ["SO", "Somalia"],
  ["SR", "Suriname"],
  ["SS", "South Sudan"],
  ["ST", "Sao Tome and Principe"],
  ["SV", "El Salvador"],
  ["SX", "Sint Maarten"],
  ["SY", "Syria"],
  ["SZ", "Swaziland"],
  ["TC", "Turks and Caicos Islands"],
  ["TD", "Chad"],
  ["TF", "French Southern Territories"],
  ["TG", "Togo"],
  ["TH", "Thailand"],
  ["TJ", "Tajikistan"],
  ["TK", "Tokelau"],
  ["TL", "East Timor"],
  ["TM", "Turkmenistan"],
  ["TN", "Tunisia"],
  ["TO", "Tonga"],
  ["TR", "Turkey"],
  ["TT", "Trinidad and Tobago"],
  ["TV", "Tuvalu"],
  ["TW", "Taiwan"],
  ["TZ", "Tanzania"],
  ["UA", "Ukraine"],
  ["UG", "Uganda"],
  ["UM", "United States Minor Outlying Islands"],
  ["US", "United States"],
  ["UY", "Uruguay"],
  ["UZ", "Uzbekistan"],
  ["VA", "Vatican"],
  ["VC", "Saint Vincent and the Grenadines"],
  ["VE", "Venezuela"],
  ["VG", "British Virgin Islands"],
  ["VI", "U.S. Virgin Islands"],
  ["VN", "Vietnam"],
  ["VU", "Vanuatu"],
  ["WF", "Wallis and Futuna"],
  ["WS", "Samoa"],
  ["XK", "Kosovo"],
  ["YE", "Yemen"],
  ["YT", "Mayotte"],
  ["ZA", "South Africa"],
  ["ZM", "Zambia"],
  ["ZW", "Zimbabwe"]
])), timezones = Object.freeze(/* @__PURE__ */ new Map([
  ["AD", "Europe/Andorra"],
  ["AE", "Asia/Dubai"],
  ["AF", "Asia/Kabul"],
  ["AG", "America/Antigua"],
  ["AI", "America/Anguilla"],
  ["AL", "Europe/Tirane"],
  ["AM", "Asia/Yerevan"],
  ["AO", "Africa/Luanda"],
  ["AQ", "Antarctica/Casey"],
  ["AR", "America/Argentina/Buenos_Aires"],
  ["AS", "Pacific/Pago_Pago"],
  ["AT", "Europe/Vienna"],
  ["AU", "Australia/Sydney"],
  ["AW", "America/Aruba"],
  ["AX", "Europe/Mariehamn"],
  ["AZ", "Asia/Baku"],
  ["BA", "Europe/Sarajevo"],
  ["BB", "America/Barbados"],
  ["BD", "Asia/Dhaka"],
  ["BE", "Europe/Brussels"],
  ["BF", "Africa/Ouagadougou"],
  ["BG", "Europe/Sofia"],
  ["BH", "Asia/Bahrain"],
  ["BI", "Africa/Bujumbura"],
  ["BJ", "Africa/Porto-Novo"],
  ["BL", "America/St_Barthelemy"],
  ["BM", "Atlantic/Bermuda"],
  ["BN", "Asia/Brunei"],
  ["BO", "America/La_Paz"],
  ["BQ", "America/Kralendijk"],
  ["BR", "America/Sao_Paulo"],
  ["BS", "America/Nassau"],
  ["BT", "Asia/Thimphu"],
  ["BW", "Africa/Gaborone"],
  ["BY", "Europe/Minsk"],
  ["BZ", "America/Belize"],
  ["CA", "America/Toronto"],
  ["CC", "Indian/Cocos"],
  ["CD", "Africa/Kinshasa"],
  ["CF", "Africa/Bangui"],
  ["CG", "Africa/Brazzaville"],
  ["CH", "Europe/Zurich"],
  ["CI", "Africa/Abidjan"],
  ["CK", "Pacific/Rarotonga"],
  ["CL", "America/Santiago"],
  ["CM", "Africa/Douala"],
  ["CN", "Asia/Shanghai"],
  ["CO", "America/Bogota"],
  ["CR", "America/Costa_Rica"],
  ["CU", "America/Havana"],
  ["CV", "Atlantic/Cape_Verde"],
  ["CW", "America/Curacao"],
  ["CX", "Indian/Christmas"],
  ["CY", "Asia/Nicosia"],
  ["CZ", "Europe/Prague"],
  ["DE", "Europe/Berlin"],
  ["DJ", "Africa/Djibouti"],
  ["DK", "Europe/Copenhagen"],
  ["DM", "America/Dominica"],
  ["DO", "America/Santo_Domingo"],
  ["DZ", "Africa/Algiers"],
  ["EC", "America/Guayaquil"],
  ["EE", "Europe/Tallinn"],
  ["EG", "Africa/Cairo"],
  ["EH", "Africa/El_Aaiun"],
  ["ER", "Africa/Asmara"],
  ["ES", "Europe/Madrid"],
  ["ET", "Africa/Addis_Ababa"],
  ["FI", "Europe/Helsinki"],
  ["FJ", "Pacific/Fiji"],
  ["FK", "Atlantic/Stanley"],
  ["FM", "Pacific/Pohnpei"],
  ["FO", "Atlantic/Faroe"],
  ["FR", "Europe/Paris"],
  ["GA", "Africa/Libreville"],
  ["GB", "Europe/London"],
  ["GD", "America/Grenada"],
  ["GE", "Asia/Tbilisi"],
  ["GF", "America/Cayenne"],
  ["GG", "Europe/Guernsey"],
  ["GH", "Africa/Accra"],
  ["GI", "Europe/Gibraltar"],
  ["GL", "America/Godthab"],
  ["GM", "Africa/Banjul"],
  ["GN", "Africa/Conakry"],
  ["GP", "America/Guadeloupe"],
  ["GQ", "Africa/Malabo"],
  ["GR", "Europe/Athens"],
  ["GS", "Atlantic/South_Georgia"],
  ["GT", "America/Guatemala"],
  ["GU", "Pacific/Guam"],
  ["GW", "Africa/Bissau"],
  ["GY", "America/Guyana"],
  ["HK", "Asia/Hong_Kong"],
  ["HN", "America/Tegucigalpa"],
  ["HR", "Europe/Zagreb"],
  ["HT", "America/Port-au-Prince"],
  ["HU", "Europe/Budapest"],
  ["ID", "Asia/Jakarta"],
  ["IE", "Europe/Dublin"],
  ["IL", "Asia/Jerusalem"],
  ["IM", "Europe/Isle_of_Man"],
  ["IN", "Asia/Kolkata"],
  ["IO", "Indian/Chagos"],
  ["IQ", "Asia/Baghdad"],
  ["IR", "Asia/Tehran"],
  ["IS", "Atlantic/Reykjavik"],
  ["IT", "Europe/Rome"],
  ["JE", "Europe/Jersey"],
  ["JM", "America/Jamaica"],
  ["JO", "Asia/Amman"],
  ["JP", "Asia/Tokyo"],
  ["KE", "Africa/Nairobi"],
  ["KG", "Asia/Bishkek"],
  ["KH", "Asia/Phnom_Penh"],
  ["KI", "Pacific/Tarawa"],
  ["KM", "Indian/Comoro"],
  ["KN", "America/St_Kitts"],
  ["KP", "Asia/Pyongyang"],
  ["KR", "Asia/Seoul"],
  ["KW", "Asia/Kuwait"],
  ["KY", "America/Cayman"],
  ["KZ", "Asia/Almaty"],
  ["LA", "Asia/Vientiane"],
  ["LB", "Asia/Beirut"],
  ["LC", "America/St_Lucia"],
  ["LI", "Europe/Vaduz"],
  ["LK", "Asia/Colombo"],
  ["LR", "Africa/Monrovia"],
  ["LS", "Africa/Maseru"],
  ["LT", "Europe/Vilnius"],
  ["LU", "Europe/Luxembourg"],
  ["LV", "Europe/Riga"],
  ["LY", "Africa/Tripoli"],
  ["MA", "Africa/Casablanca"],
  ["MC", "Europe/Monaco"],
  ["MD", "Europe/Chisinau"],
  ["ME", "Europe/Podgorica"],
  ["MF", "America/Marigot"],
  ["MG", "Indian/Antananarivo"],
  ["MH", "Pacific/Majuro"],
  ["MK", "Europe/Skopje"],
  ["ML", "Africa/Bamako"],
  ["MM", "Asia/Yangon"],
  ["MN", "Asia/Ulaanbaatar"],
  ["MO", "Asia/Macau"],
  ["MP", "Pacific/Saipan"],
  ["MQ", "America/Martinique"],
  ["MR", "Africa/Nouakchott"],
  ["MS", "America/Montserrat"],
  ["MT", "Europe/Malta"],
  ["MU", "Indian/Mauritius"],
  ["MV", "Indian/Maldives"],
  ["MW", "Africa/Blantyre"],
  ["MX", "America/Mexico_City"],
  ["MY", "Asia/Kuala_Lumpur"],
  ["MZ", "Africa/Maputo"],
  ["NA", "Africa/Windhoek"],
  ["NC", "Pacific/Noumea"],
  ["NE", "Africa/Niamey"],
  ["NF", "Pacific/Norfolk"],
  ["NG", "Africa/Lagos"],
  ["NI", "America/Managua"],
  ["NL", "Europe/Amsterdam"],
  ["NO", "Europe/Oslo"],
  ["NP", "Asia/Kathmandu"],
  ["NR", "Pacific/Nauru"],
  ["NU", "Pacific/Niue"],
  ["NZ", "Pacific/Auckland"],
  ["OM", "Asia/Muscat"],
  ["PA", "America/Panama"],
  ["PE", "America/Lima"],
  ["PF", "Pacific/Tahiti"],
  ["PG", "Pacific/Port_Moresby"],
  ["PH", "Asia/Manila"],
  ["PK", "Asia/Karachi"],
  ["PL", "Europe/Warsaw"],
  ["PM", "America/Miquelon"],
  ["PN", "Pacific/Pitcairn"],
  ["PR", "America/Puerto_Rico"],
  ["PS", "Asia/Gaza"],
  ["PT", "Europe/Lisbon"],
  ["PW", "Pacific/Palau"],
  ["PY", "America/Asuncion"],
  ["QA", "Asia/Qatar"],
  ["RE", "Indian/Reunion"],
  ["RO", "Europe/Bucharest"],
  ["RS", "Europe/Belgrade"],
  ["RU", "Europe/Moscow"],
  ["RW", "Africa/Kigali"],
  ["SA", "Asia/Riyadh"],
  ["SB", "Pacific/Guadalcanal"],
  ["SC", "Indian/Mahe"],
  ["SD", "Africa/Khartoum"],
  ["SE", "Europe/Stockholm"],
  ["SG", "Asia/Singapore"],
  ["SH", "Atlantic/St_Helena"],
  ["SI", "Europe/Ljubljana"],
  ["SJ", "Arctic/Longyearbyen"],
  ["SK", "Europe/Bratislava"],
  ["SL", "Africa/Freetown"],
  ["SM", "Europe/San_Marino"],
  ["SN", "Africa/Dakar"],
  ["SO", "Africa/Mogadishu"],
  ["SR", "America/Paramaribo"],
  ["SS", "Africa/Juba"],
  ["ST", "Africa/Sao_Tome"],
  ["SV", "America/El_Salvador"],
  ["SX", "America/Lower_Princes"],
  ["SY", "Asia/Damascus"],
  ["SZ", "Africa/Mbabane"],
  ["TC", "America/Grand_Turk"],
  ["TD", "Africa/Ndjamena"],
  ["TF", "Indian/Kerguelen"],
  ["TG", "Africa/Lome"],
  ["TH", "Asia/Bangkok"],
  ["TJ", "Asia/Dushanbe"],
  ["TK", "Pacific/Fakaofo"],
  ["TL", "Asia/Dili"],
  ["TM", "Asia/Ashgabat"],
  ["TN", "Africa/Tunis"],
  ["TO", "Pacific/Tongatapu"],
  ["TR", "Europe/Istanbul"],
  ["TT", "America/Port_of_Spain"],
  ["TV", "Pacific/Funafuti"],
  ["TW", "Asia/Taipei"],
  ["TZ", "Africa/Dar_es_Salaam"],
  ["UA", "Europe/Kiev"],
  ["UG", "Africa/Kampala"],
  ["UM", "Pacific/Wake"],
  ["US", "America/New_York"],
  ["UY", "America/Montevideo"],
  ["UZ", "Asia/Tashkent"],
  ["VA", "Europe/Vatican"],
  ["VC", "America/St_Vincent"],
  ["VE", "America/Caracas"],
  ["VG", "America/Tortola"],
  ["VI", "America/St_Thomas"],
  ["VN", "Asia/Ho_Chi_Minh"],
  ["VU", "Pacific/Efate"],
  ["WF", "Pacific/Wallis"],
  ["WS", "Pacific/Apia"],
  ["YE", "Asia/Aden"],
  ["YT", "Indian/Mayotte"],
  ["ZA", "Africa/Johannesburg"],
  ["ZM", "Africa/Lusaka"],
  ["ZW", "Africa/Harare"]
]));
var LuxonError = class extends Error {
}, ZoneIsAbstractError = class extends LuxonError {
  constructor() {
    super("Zone is an abstract class");
  }
}, Zone = class {
  get type() {
    throw new ZoneIsAbstractError();
  }
  get name() {
    throw new ZoneIsAbstractError();
  }
  get ianaName() {
    return this.name;
  }
  get isUniversal() {
    throw new ZoneIsAbstractError();
  }
  offsetName(ts, opts) {
    throw new ZoneIsAbstractError();
  }
  formatOffset(ts, format) {
    throw new ZoneIsAbstractError();
  }
  offset(ts) {
    throw new ZoneIsAbstractError();
  }
  equals(otherZone) {
    throw new ZoneIsAbstractError();
  }
  get isValid() {
    throw new ZoneIsAbstractError();
  }
}, dtfCache = /* @__PURE__ */ new Map();
function makeDTF(zoneName) {
  let dtf = dtfCache.get(zoneName);
  return dtf === void 0 && (dtf = new Intl.DateTimeFormat("en-US", {
    hour12: false,
    timeZone: zoneName,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  }), dtfCache.set(zoneName, dtf)), dtf;
}
var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function hackyOffset(dtf, date) {
  let formatted = dtf.format(date).replace(/\u200E/g, ""), [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted);
  return [
    fYear,
    fMonth,
    fDay,
    fadOrBc,
    fHour,
    fMinute,
    fSecond
  ];
}
function partsOffset(dtf, date) {
  let formatted = dtf.formatToParts(date), filled = [];
  for (let i$12 = 0; i$12 < formatted.length; i$12++) {
    let { type, value } = formatted[i$12], pos = typeToPos[type];
    type === "era" ? filled[pos] = value : isUndefined(pos) || (filled[pos] = parseInt(value, 10));
  }
  return filled;
}
var ianaZoneCache = /* @__PURE__ */ new Map(), IANAZone = class IANAZone4 extends Zone {
  static create(name2) {
    let zone = ianaZoneCache.get(name2);
    return zone === void 0 && ianaZoneCache.set(name2, zone = new IANAZone4(name2)), zone;
  }
  static resetCache() {
    ianaZoneCache.clear(), dtfCache.clear();
  }
  static isValidSpecifier(s$12) {
    return this.isValidZone(s$12);
  }
  static isValidZone(zone) {
    if (!zone) return false;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: zone }).format(), true;
    } catch {
      return false;
    }
  }
  constructor(name2) {
    super(), this.zoneName = name2, this.valid = IANAZone4.isValidZone(name2);
  }
  get type() {
    return "iana";
  }
  get name() {
    return this.zoneName;
  }
  get isUniversal() {
    return false;
  }
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale, this.name);
  }
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  offset(ts) {
    if (!this.valid) return NaN;
    let date = new Date(ts);
    if (isNaN(date)) return NaN;
    let dtf = makeDTF(this.name), [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date);
    adOrBc === "BC" && (year = -Math.abs(year) + 1);
    let asUTC = objToLocalTS({
      year,
      month,
      day,
      hour: hour === 24 ? 0 : hour,
      minute,
      second,
      millisecond: 0
    }), asTS = +date, over = asTS % 1e3;
    return asTS -= over >= 0 ? over : 1e3 + over, (asUTC - asTS) / (60 * 1e3);
  }
  equals(otherZone) {
    return otherZone.type === "iana" && otherZone.name === this.name;
  }
  get isValid() {
    return this.valid;
  }
};
var singleton = null, FixedOffsetZone = class FixedOffsetZone4 extends Zone {
  static get utcInstance() {
    return singleton === null && (singleton = new FixedOffsetZone4(0)), singleton;
  }
  static instance(offset$12) {
    return offset$12 === 0 ? FixedOffsetZone4.utcInstance : new FixedOffsetZone4(offset$12);
  }
  static parseSpecifier(s$12) {
    if (s$12) {
      let r = s$12.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r) return new FixedOffsetZone4(signedOffset(r[1], r[2]));
    }
    return null;
  }
  constructor(offset$12) {
    super(), this.fixed = offset$12;
  }
  get type() {
    return "fixed";
  }
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${formatOffset(this.fixed, "narrow")}`;
  }
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${formatOffset(-this.fixed, "narrow")}`;
  }
  offsetName() {
    return this.name;
  }
  formatOffset(ts, format) {
    return formatOffset(this.fixed, format);
  }
  get isUniversal() {
    return true;
  }
  offset() {
    return this.fixed;
  }
  equals(otherZone) {
    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
  }
  get isValid() {
    return true;
  }
};
var numberingSystems = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
};
numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function isUndefined(o) {
  return o === void 0;
}
function padStart(input, n$12 = 2) {
  let isNeg = input < 0, padded;
  return padded = isNeg ? "-" + ("" + -input).padStart(n$12, "0") : ("" + input).padStart(n$12, "0"), padded;
}
function parseInteger(string) {
  if (!(isUndefined(string) || string === null || string === "")) return parseInt(string, 10);
}
function parseMillis(fraction) {
  if (!(isUndefined(fraction) || fraction === null || fraction === "")) {
    let f2 = parseFloat("0." + fraction) * 1e3;
    return Math.floor(f2);
  }
}
function objToLocalTS(obj) {
  let d2 = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
  return obj.year < 100 && obj.year >= 0 && (d2 = new Date(d2), d2.setUTCFullYear(obj.year, obj.month - 1, obj.day)), +d2;
}
function parseZoneInfo(ts, offsetFormat, locale, timeZone = null) {
  let date = new Date(ts), intlOpts = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  timeZone && (intlOpts.timeZone = timeZone);
  let modified = {
    timeZoneName: offsetFormat,
    ...intlOpts
  }, parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find((m) => m.type.toLowerCase() === "timezonename");
  return parsed ? parsed.value : null;
}
function signedOffset(offHourStr, offMinuteStr) {
  let offHour = parseInt(offHourStr, 10);
  Number.isNaN(offHour) && (offHour = 0);
  let offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
}
function formatOffset(offset$12, format) {
  let hours = Math.trunc(Math.abs(offset$12 / 60)), minutes = Math.trunc(Math.abs(offset$12 % 60)), sign = offset$12 >= 0 ? "+" : "-";
  switch (format) {
    case "short":
      return `${sign}${padStart(hours, 2)}:${padStart(minutes, 2)}`;
    case "narrow":
      return `${sign}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
    case "techie":
      return `${sign}${padStart(hours, 2)}${padStart(minutes, 2)}`;
    default:
      throw RangeError(`Value format ${format} is out of range for property format`);
  }
}
var ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function combineRegexes(...regexes) {
  let full = regexes.reduce((f2, r) => f2 + r.source, "");
  return RegExp(`^${full}$`);
}
function combineExtractors(...extractors) {
  return (m) => extractors.reduce(([mergedVals, mergedZone, cursor], ex) => {
    let [val, zone, next] = ex(m, cursor);
    return [
      {
        ...mergedVals,
        ...val
      },
      zone || mergedZone,
      next
    ];
  }, [
    {},
    null,
    1
  ]).slice(0, 2);
}
function simpleParse(...keys) {
  return (match$12, cursor) => {
    let ret = {}, i$12;
    for (i$12 = 0; i$12 < keys.length; i$12++) ret[keys[i$12]] = parseInteger(match$12[cursor + i$12]);
    return [
      ret,
      null,
      cursor + i$12
    ];
  };
}
var offsetRegex = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/, isoExtendedZone = `(?:${offsetRegex.source}?(?:\\[(${ianaRegex.source})\\])?)?`, isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, isoTimeRegex = RegExp(`${isoTimeBaseRegex.source}${isoExtendedZone}`), isoTimeExtensionRegex = RegExp(`(?:[Tt]${isoTimeRegex.source})?`), isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/, isoOrdinalRegex = /(\d{4})-?(\d{3})/, extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay"), extractISOOrdinalData = simpleParse("year", "ordinal"), sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/, sqlTimeRegex = RegExp(`${isoTimeBaseRegex.source} ?(?:${offsetRegex.source}|(${ianaRegex.source}))?`), sqlTimeExtensionRegex = RegExp(`(?: ${sqlTimeRegex.source})?`);
function int(match$12, pos, fallback) {
  let m = match$12[pos];
  return isUndefined(m) ? fallback : parseInteger(m);
}
function extractISOYmd(match$12, cursor) {
  return [
    {
      year: int(match$12, cursor),
      month: int(match$12, cursor + 1, 1),
      day: int(match$12, cursor + 2, 1)
    },
    null,
    cursor + 3
  ];
}
function extractISOTime(match$12, cursor) {
  return [
    {
      hours: int(match$12, cursor, 0),
      minutes: int(match$12, cursor + 1, 0),
      seconds: int(match$12, cursor + 2, 0),
      milliseconds: parseMillis(match$12[cursor + 3])
    },
    null,
    cursor + 4
  ];
}
function extractISOOffset(match$12, cursor) {
  let local = !match$12[cursor] && !match$12[cursor + 1], fullOffset = signedOffset(match$12[cursor + 1], match$12[cursor + 2]);
  return [
    {},
    local ? null : FixedOffsetZone.instance(fullOffset),
    cursor + 3
  ];
}
function extractIANAZone(match$12, cursor) {
  return [
    {},
    match$12[cursor] ? IANAZone.create(match$12[cursor]) : null,
    cursor + 1
  ];
}
RegExp(`^T?${isoTimeBaseRegex.source}$`);
combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
combineRegexes(isoTimeRegex);
combineExtractors(extractISOYmd, extractISOTime, extractISOOffset, extractIANAZone);
combineExtractors(extractISOWeekData, extractISOTime, extractISOOffset, extractIANAZone);
combineExtractors(extractISOOrdinalData, extractISOTime, extractISOOffset, extractIANAZone);
combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
combineExtractors(extractISOTime);
combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
combineRegexes(sqlTimeRegex);
combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
var lowOrderMatrix = {
  weeks: {
    days: 7,
    hours: 168,
    minutes: 10080,
    seconds: 10080 * 60,
    milliseconds: 10080 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 1440,
    seconds: 1440 * 60,
    milliseconds: 1440 * 60 * 1e3
  },
  hours: {
    minutes: 60,
    seconds: 3600,
    milliseconds: 3600 * 1e3
  },
  minutes: {
    seconds: 60,
    milliseconds: 60 * 1e3
  },
  seconds: { milliseconds: 1e3 }
};
({
  ...lowOrderMatrix
});
({
  ...lowOrderMatrix
});
var orderedUnits$1 = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
];
orderedUnits$1.slice(0).reverse();
const isos = Object.freeze(/* @__PURE__ */ new Set([...countries.keys()]));
const areaCodeMap = {
  201: "US",
  202: "US",
  203: "US",
  204: "CA",
  205: "US",
  206: "US",
  207: "US",
  208: "US",
  209: "US",
  210: "US",
  212: "US",
  213: "US",
  214: "US",
  215: "US",
  216: "US",
  217: "US",
  218: "US",
  219: "US",
  220: "US",
  223: "US",
  224: "US",
  225: "US",
  226: "CA",
  227: "US",
  228: "US",
  229: "US",
  231: "US",
  234: "US",
  236: "CA",
  239: "US",
  240: "US",
  242: "BS",
  246: "BB",
  248: "US",
  249: "CA",
  250: "CA",
  251: "US",
  252: "US",
  253: "US",
  254: "US",
  256: "US",
  260: "US",
  262: "US",
  263: "CA",
  264: "AI",
  267: "US",
  268: "AG",
  269: "US",
  270: "US",
  272: "US",
  276: "US",
  279: "US",
  281: "US",
  283: "US",
  284: "VG",
  289: "CA",
  301: "US",
  302: "US",
  303: "US",
  304: "US",
  305: "US",
  306: "CA",
  307: "US",
  308: "US",
  309: "US",
  310: "US",
  312: "US",
  313: "US",
  314: "US",
  315: "US",
  316: "US",
  317: "US",
  318: "US",
  319: "US",
  320: "US",
  321: "US",
  323: "US",
  325: "US",
  326: "US",
  329: "US",
  330: "US",
  331: "US",
  332: "US",
  334: "US",
  336: "US",
  337: "US",
  339: "US",
  340: "VI",
  341: "US",
  343: "CA",
  345: "KY",
  346: "US",
  347: "US",
  350: "US",
  351: "US",
  352: "US",
  354: "CA",
  360: "US",
  361: "US",
  364: "US",
  365: "CA",
  367: "CA",
  368: "CA",
  369: "US",
  380: "US",
  382: "CA",
  385: "US",
  386: "US",
  401: "US",
  402: "US",
  403: "CA",
  404: "US",
  405: "US",
  406: "US",
  407: "US",
  408: "US",
  409: "US",
  410: "US",
  412: "US",
  413: "US",
  414: "US",
  415: "US",
  416: "CA",
  417: "US",
  418: "CA",
  419: "US",
  423: "US",
  424: "US",
  425: "US",
  428: "CA",
  430: "US",
  431: "CA",
  432: "US",
  434: "US",
  435: "US",
  437: "CA",
  438: "CA",
  440: "US",
  441: "BM",
  442: "US",
  443: "US",
  445: "US",
  447: "US",
  448: "US",
  450: "CA",
  458: "US",
  463: "US",
  464: "US",
  468: "CA",
  469: "US",
  470: "US",
  473: "GD",
  474: "CA",
  475: "US",
  478: "US",
  479: "US",
  480: "US",
  484: "US",
  500: "US",
  501: "US",
  502: "US",
  503: "US",
  504: "US",
  505: "US",
  506: "CA",
  507: "US",
  508: "US",
  509: "US",
  510: "US",
  512: "US",
  513: "US",
  514: "CA",
  515: "US",
  516: "US",
  517: "US",
  518: "US",
  519: "CA",
  520: "US",
  521: "US",
  522: "US",
  525: "US",
  526: "US",
  527: "US",
  528: "US",
  529: "US",
  530: "US",
  531: "US",
  533: "US",
  534: "US",
  539: "US",
  540: "US",
  541: "US",
  544: "US",
  548: "CA",
  551: "US",
  557: "US",
  559: "US",
  561: "US",
  562: "US",
  563: "US",
  564: "US",
  566: "US",
  567: "US",
  570: "US",
  571: "US",
  572: "US",
  573: "US",
  574: "US",
  575: "US",
  577: "US",
  579: "CA",
  580: "US",
  581: "CA",
  582: "US",
  584: "CA",
  585: "US",
  586: "US",
  587: "CA",
  588: "US",
  600: "CA",
  601: "US",
  602: "US",
  603: "US",
  604: "CA",
  605: "US",
  606: "US",
  607: "US",
  608: "US",
  609: "US",
  610: "US",
  612: "US",
  613: "CA",
  614: "US",
  615: "US",
  616: "US",
  617: "US",
  618: "US",
  619: "US",
  620: "US",
  622: "CA",
  623: "US",
  626: "US",
  628: "US",
  629: "US",
  630: "US",
  631: "US",
  636: "US",
  639: "CA",
  640: "US",
  641: "US",
  646: "US",
  647: "CA",
  649: "TC",
  650: "US",
  651: "US",
  656: "US",
  657: "US",
  658: "JM",
  659: "US",
  660: "US",
  661: "US",
  662: "US",
  664: "MS",
  667: "US",
  669: "US",
  670: "MP",
  671: "GU",
  672: "CA",
  678: "US",
  680: "US",
  681: "US",
  682: "US",
  683: "CA",
  684: "AS",
  689: "US",
  701: "US",
  702: "US",
  703: "US",
  704: "US",
  705: "CA",
  706: "US",
  707: "US",
  708: "US",
  709: "CA",
  712: "US",
  713: "US",
  714: "US",
  715: "US",
  716: "US",
  717: "US",
  718: "US",
  719: "US",
  720: "US",
  721: "SX",
  724: "US",
  725: "US",
  726: "US",
  727: "US",
  731: "US",
  732: "US",
  734: "US",
  737: "US",
  740: "US",
  742: "CA",
  743: "US",
  747: "US",
  753: "CA",
  754: "US",
  757: "US",
  758: "LC",
  760: "US",
  762: "US",
  763: "US",
  765: "US",
  767: "DM",
  769: "US",
  770: "US",
  771: "US",
  772: "US",
  773: "US",
  774: "US",
  775: "US",
  778: "CA",
  779: "US",
  780: "CA",
  781: "US",
  782: "CA",
  784: "VC",
  785: "US",
  786: "US",
  787: "PR",
  800: "US",
  801: "US",
  802: "US",
  803: "US",
  804: "US",
  805: "US",
  806: "US",
  807: "CA",
  808: "US",
  809: "DO",
  810: "US",
  812: "US",
  813: "US",
  814: "US",
  815: "US",
  816: "US",
  817: "US",
  818: "US",
  819: "CA",
  820: "US",
  825: "CA",
  826: "US",
  828: "US",
  829: "DO",
  830: "US",
  831: "US",
  832: "US",
  833: "US",
  835: "US",
  838: "US",
  839: "US",
  840: "US",
  843: "US",
  844: "US",
  845: "US",
  847: "US",
  848: "US",
  849: "DO",
  850: "US",
  854: "US",
  855: "US",
  856: "US",
  857: "US",
  858: "US",
  859: "US",
  860: "US",
  862: "US",
  863: "US",
  864: "US",
  865: "US",
  866: "US",
  867: "CA",
  868: "TT",
  869: "KN",
  870: "US",
  872: "US",
  873: "CA",
  876: "JM",
  877: "US",
  878: "US",
  888: "US",
  900: "US",
  901: "US",
  902: "CA",
  903: "US",
  904: "US",
  905: "CA",
  906: "US",
  907: "US",
  908: "US",
  909: "US",
  910: "US",
  912: "US",
  913: "US",
  914: "US",
  915: "US",
  916: "US",
  917: "US",
  918: "US",
  919: "US",
  920: "US",
  925: "US",
  928: "US",
  929: "US",
  930: "US",
  931: "US",
  934: "US",
  936: "US",
  937: "US",
  938: "US",
  939: "PR",
  940: "US",
  941: "US",
  943: "US",
  945: "US",
  947: "US",
  948: "US",
  949: "US",
  951: "US",
  952: "US",
  954: "US",
  956: "US",
  959: "US",
  970: "US",
  971: "US",
  972: "US",
  973: "US",
  978: "US",
  979: "US",
  980: "US",
  984: "US",
  985: "US",
  986: "US",
  989: "US"
}, nanpaCountries = [
  "US",
  "CA",
  "BS",
  "BB",
  "AI",
  "AG",
  "VG",
  "VI",
  "KY",
  "BM",
  "GD",
  "TC",
  "JM",
  "MS",
  "MP",
  "GU",
  "AS",
  "SX",
  "LC",
  "DM",
  "VC",
  "PR",
  "DO",
  "TT",
  "KN"
];
var require_country_telephone_data = /* @__PURE__ */ __commonJSMin(((exports$12, module2) => {
  for (var allCountries$1 = [
    [
      "Afghanistan (‫افغانستان‬‎)",
      "af",
      "93",
      "+..-..-...-...."
    ],
    [
      "Åland Islands",
      "ax",
      "358",
      ""
    ],
    [
      "Albania (Shqipëri)",
      "al",
      "355",
      "+...(...)...-..."
    ],
    [
      "Algeria (‫الجزائر‬‎)",
      "dz",
      "213",
      "+...-..-...-...."
    ],
    [
      "American Samoa",
      "as",
      "1684",
      "+.(...)...-...."
    ],
    [
      "Andorra",
      "ad",
      "376",
      "+...-...-..."
    ],
    [
      "Angola",
      "ao",
      "244",
      "+...(...)...-..."
    ],
    [
      "Anguilla",
      "ai",
      "1264",
      "+.(...)...-...."
    ],
    [
      "Antarctica",
      "aq",
      "672",
      ""
    ],
    [
      "Antigua and Barbuda",
      "ag",
      "1268",
      "+.(...)...-...."
    ],
    [
      "Argentina",
      "ar",
      "54",
      "+..(...)...-...."
    ],
    [
      "Armenia (Հայաստան)",
      "am",
      "374",
      "+...-..-...-..."
    ],
    [
      "Aruba",
      "aw",
      "297",
      "+...-...-...."
    ],
    [
      "Australia",
      "au",
      "61",
      "+.. ... ... ..."
    ],
    [
      "Austria (Österreich)",
      "at",
      "43",
      "+..(...)...-...."
    ],
    [
      "Azerbaijan (Azərbaycan)",
      "az",
      "994",
      "+...-..-...-..-.."
    ],
    [
      "Bahamas",
      "bs",
      "1242",
      "+.(...)...-...."
    ],
    [
      "Bahrain (‫البحرين‬‎)",
      "bh",
      "973",
      "+...-....-...."
    ],
    [
      "Bangladesh (বাংলাদেশ)",
      "bd",
      "880",
      "+...-..-...-..."
    ],
    [
      "Barbados",
      "bb",
      "1246",
      "+.(...)...-...."
    ],
    [
      "Belarus (Беларусь)",
      "by",
      "375",
      "+...(..)...-..-.."
    ],
    [
      "Belgium (België)",
      "be",
      "32",
      "+.. ... .. .. .."
    ],
    [
      "Belize",
      "bz",
      "501",
      "+...-...-...."
    ],
    [
      "Benin (Bénin)",
      "bj",
      "229",
      "+...-..-..-...."
    ],
    [
      "Bermuda",
      "bm",
      "1441",
      "+.(...)...-...."
    ],
    [
      "Bhutan (འབྲུག)",
      "bt",
      "975",
      "+...-.-...-..."
    ],
    [
      "Bolivia",
      "bo",
      "591",
      "+...-.-...-...."
    ],
    [
      "Bosnia and Herzegovina (Босна и Херцеговина)",
      "ba",
      "387",
      "+...-..-...."
    ],
    [
      "Botswana",
      "bw",
      "267",
      "+...-..-...-..."
    ],
    [
      "Bouvet Island",
      "bv",
      "47",
      ""
    ],
    [
      "Brazil (Brasil)",
      "br",
      "55",
      "+..-..-....-...."
    ],
    [
      "British Indian Ocean Territory",
      "io",
      "246",
      "+...-...-...."
    ],
    [
      "British Virgin Islands",
      "vg",
      "1284",
      "+.(...)...-...."
    ],
    [
      "Brunei",
      "bn",
      "673",
      "+...-...-...."
    ],
    [
      "Bulgaria (България)",
      "bg",
      "359",
      "+...(...)...-..."
    ],
    [
      "Burkina Faso",
      "bf",
      "226",
      "+...-..-..-...."
    ],
    [
      "Burundi (Uburundi)",
      "bi",
      "257",
      "+...-..-..-...."
    ],
    [
      "Cambodia (កម្ពុជា)",
      "kh",
      "855",
      "+...-..-...-..."
    ],
    [
      "Cameroon (Cameroun)",
      "cm",
      "237",
      "+...-....-...."
    ],
    [
      "Canada",
      "ca",
      "1",
      "+. (...) ...-....",
      1,
      /* @__PURE__ */ "204.236.249.250.289.306.343.365.387.403.416.418.431.437.438.450.506.514.519.548.579.581.587.604.613.639.647.672.705.709.742.778.780.782.807.819.825.867.873.902.905".split(".")
    ],
    [
      "Cape Verde (Kabu Verdi)",
      "cv",
      "238",
      "+...(...)..-.."
    ],
    [
      "Caribbean Netherlands",
      "bq",
      "599",
      "+...-...-....",
      1
    ],
    [
      "Cayman Islands",
      "ky",
      "1345",
      "+.(...)...-...."
    ],
    [
      "Central African Republic (République centrafricaine)",
      "cf",
      "236",
      "+...-..-..-...."
    ],
    [
      "Chad (Tchad)",
      "td",
      "235",
      "+...-..-..-..-.."
    ],
    [
      "Chile",
      "cl",
      "56",
      "+..-.-....-...."
    ],
    [
      "China (中国)",
      "cn",
      "86",
      "+.. ..-........"
    ],
    [
      "Christmas Island",
      "cx",
      "61",
      ""
    ],
    [
      "Cocos (Keeling) Islands",
      "cc",
      "61",
      ""
    ],
    [
      "Colombia",
      "co",
      "57",
      "+..(...)...-...."
    ],
    [
      "Comoros (‫جزر القمر‬‎)",
      "km",
      "269",
      "+...-..-....."
    ],
    [
      "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)",
      "cd",
      "243",
      "+...(...)...-..."
    ],
    [
      "Congo (Republic) (Congo-Brazzaville)",
      "cg",
      "242",
      "+...-..-...-...."
    ],
    [
      "Cook Islands",
      "ck",
      "682",
      "+...-..-..."
    ],
    [
      "Costa Rica",
      "cr",
      "506",
      "+... ....-...."
    ],
    [
      "Côte d’Ivoire",
      "ci",
      "225",
      "+...-..-...-..."
    ],
    [
      "Croatia (Hrvatska)",
      "hr",
      "385",
      "+...-..-...-..."
    ],
    [
      "Cuba",
      "cu",
      "53",
      "+..-.-...-...."
    ],
    [
      "Curaçao",
      "cw",
      "599",
      "+...-...-....",
      0
    ],
    [
      "Cyprus (Κύπρος)",
      "cy",
      "357",
      "+...-..-...-..."
    ],
    [
      "Czech Republic (Česká republika)",
      "cz",
      "420",
      "+...(...)...-..."
    ],
    [
      "Denmark (Danmark)",
      "dk",
      "45",
      "+.. .. .. .. .."
    ],
    [
      "Djibouti",
      "dj",
      "253",
      "+...-..-..-..-.."
    ],
    [
      "Dominica",
      "dm",
      "1767",
      "+.(...)...-...."
    ],
    [
      "Dominican Republic (República Dominicana)",
      "do",
      "1",
      "+.(...)...-....",
      2,
      [
        "809",
        "829",
        "849"
      ]
    ],
    [
      "Ecuador",
      "ec",
      "593",
      "+...-.-...-...."
    ],
    [
      "Egypt (‫مصر‬‎)",
      "eg",
      "20",
      "+..(...)...-...."
    ],
    [
      "El Salvador",
      "sv",
      "503",
      "+... ....-...."
    ],
    [
      "Equatorial Guinea (Guinea Ecuatorial)",
      "gq",
      "240",
      "+...-..-...-...."
    ],
    [
      "Eritrea",
      "er",
      "291",
      "+...-.-...-..."
    ],
    [
      "Estonia (Eesti)",
      "ee",
      "372",
      "+...-...-...."
    ],
    [
      "Ethiopia",
      "et",
      "251",
      "+...-..-...-...."
    ],
    [
      "Falkland Islands (Islas Malvinas)",
      "fk",
      "500",
      "+...-....."
    ],
    [
      "Faroe Islands (Føroyar)",
      "fo",
      "298",
      "+...-...-..."
    ],
    [
      "Fiji",
      "fj",
      "679",
      "+...-..-....."
    ],
    [
      "Finland (Suomi)",
      "fi",
      "358",
      "+... .. .... ...."
    ],
    [
      "France",
      "fr",
      "33",
      "+.. . .. .. .. .."
    ],
    [
      "French Guiana (Guyane française)",
      "gf",
      "594",
      "+...-.....-...."
    ],
    [
      "French Polynesia (Polynésie française)",
      "pf",
      "689",
      "+...-..-..-.."
    ],
    [
      "French Southern and Antarctic Lands",
      "tf",
      "262",
      ""
    ],
    [
      "Gabon",
      "ga",
      "241",
      "+...-.-..-..-.."
    ],
    [
      "Gambia",
      "gm",
      "220",
      "+...(...)..-.."
    ],
    [
      "Georgia (საქართველო)",
      "ge",
      "995",
      "+...(...)...-..."
    ],
    [
      "Germany (Deutschland)",
      "de",
      "49",
      "+.. ... ......."
    ],
    [
      "Ghana (Gaana)",
      "gh",
      "233",
      "+...(...)...-..."
    ],
    [
      "Gibraltar",
      "gi",
      "350",
      "+...-...-....."
    ],
    [
      "Greece (Ελλάδα)",
      "gr",
      "30",
      "+..(...)...-...."
    ],
    [
      "Greenland (Kalaallit Nunaat)",
      "gl",
      "299",
      "+...-..-..-.."
    ],
    [
      "Grenada",
      "gd",
      "1473",
      "+.(...)...-...."
    ],
    [
      "Guadeloupe",
      "gp",
      "590",
      "",
      0
    ],
    [
      "Guam",
      "gu",
      "1671",
      "+.(...)...-...."
    ],
    [
      "Guatemala",
      "gt",
      "502",
      "+... ....-...."
    ],
    [
      "Guernsey",
      "gg",
      "44",
      ""
    ],
    [
      "Guinea (Guinée)",
      "gn",
      "224",
      "+...-..-...-..."
    ],
    [
      "Guinea-Bissau (Guiné Bissau)",
      "gw",
      "245",
      "+...-.-......"
    ],
    [
      "Guyana",
      "gy",
      "592",
      "+...-...-...."
    ],
    [
      "Haiti",
      "ht",
      "509",
      "+... ....-...."
    ],
    [
      "Heard Island and McDonald Islands",
      "hm",
      "672",
      ""
    ],
    [
      "Honduras",
      "hn",
      "504",
      "+...-....-...."
    ],
    [
      "Hong Kong (香港)",
      "hk",
      "852",
      "+... .... ...."
    ],
    [
      "Hungary (Magyarország)",
      "hu",
      "36",
      "+..(...)...-..."
    ],
    [
      "Iceland (Ísland)",
      "is",
      "354",
      "+... ... ...."
    ],
    [
      "India (भारत)",
      "in",
      "91",
      "+.. .....-....."
    ],
    [
      "Indonesia",
      "id",
      "62",
      "+..-..-...-.."
    ],
    [
      "Iran (‫ایران‬‎)",
      "ir",
      "98",
      "+..(...)...-...."
    ],
    [
      "Iraq (‫العراق‬‎)",
      "iq",
      "964",
      "+...(...)...-...."
    ],
    [
      "Ireland",
      "ie",
      "353",
      "+... .. ......."
    ],
    [
      "Isle of Man",
      "im",
      "44",
      ""
    ],
    [
      "Israel (‫ישראל‬‎)",
      "il",
      "972",
      "+...-.-...-...."
    ],
    [
      "Italy (Italia)",
      "it",
      "39",
      "+.. ... ......",
      0
    ],
    [
      "Jamaica",
      "jm",
      "1876",
      "+.(...)...-...."
    ],
    [
      "Japan (日本)",
      "jp",
      "81",
      "+.. ... .. ...."
    ],
    [
      "Jersey",
      "je",
      "44",
      ""
    ],
    [
      "Jordan (‫الأردن‬‎)",
      "jo",
      "962",
      "+...-.-....-...."
    ],
    [
      "Kazakhstan (Казахстан)",
      "kz",
      "7",
      "+. ... ...-..-..",
      1
    ],
    [
      "Kenya",
      "ke",
      "254",
      "+...-...-......"
    ],
    [
      "Kiribati",
      "ki",
      "686",
      "+...-..-..."
    ],
    [
      "Kosovo",
      "xk",
      "383",
      ""
    ],
    [
      "Kuwait (‫الكويت‬‎)",
      "kw",
      "965",
      "+...-....-...."
    ],
    [
      "Kyrgyzstan (Кыргызстан)",
      "kg",
      "996",
      "+...(...)...-..."
    ],
    [
      "Laos (ລາວ)",
      "la",
      "856",
      "+...-..-...-..."
    ],
    [
      "Latvia (Latvija)",
      "lv",
      "371",
      "+...-..-...-..."
    ],
    [
      "Lebanon (‫لبنان‬‎)",
      "lb",
      "961",
      "+...-.-...-..."
    ],
    [
      "Lesotho",
      "ls",
      "266",
      "+...-.-...-...."
    ],
    [
      "Liberia",
      "lr",
      "231",
      "+...-..-...-..."
    ],
    [
      "Libya (‫ليبيا‬‎)",
      "ly",
      "218",
      "+...-..-...-..."
    ],
    [
      "Liechtenstein",
      "li",
      "423",
      "+...(...)...-...."
    ],
    [
      "Lithuania (Lietuva)",
      "lt",
      "370",
      "+...(...)..-..."
    ],
    [
      "Luxembourg",
      "lu",
      "352",
      "+...(...)...-..."
    ],
    [
      "Macau (澳門)",
      "mo",
      "853",
      "+...-....-...."
    ],
    [
      "Macedonia (FYROM) (Македонија)",
      "mk",
      "389",
      "+...-..-...-..."
    ],
    [
      "Madagascar (Madagasikara)",
      "mg",
      "261",
      "+...-..-..-....."
    ],
    [
      "Malawi",
      "mw",
      "265",
      "+...-.-....-...."
    ],
    [
      "Malaysia",
      "my",
      "60",
      "+.. ..-....-...."
    ],
    [
      "Maldives",
      "mv",
      "960",
      "+...-...-...."
    ],
    [
      "Mali",
      "ml",
      "223",
      "+...-..-..-...."
    ],
    [
      "Malta",
      "mt",
      "356",
      "+...-....-...."
    ],
    [
      "Marshall Islands",
      "mh",
      "692",
      "+...-...-...."
    ],
    [
      "Martinique",
      "mq",
      "596",
      "+...(...)..-..-.."
    ],
    [
      "Mauritania (‫موريتانيا‬‎)",
      "mr",
      "222",
      "+...-..-..-...."
    ],
    [
      "Mauritius (Moris)",
      "mu",
      "230",
      "+...-...-...."
    ],
    [
      "Mayotte",
      "yt",
      "262",
      ""
    ],
    [
      "Mexico (México)",
      "mx",
      "52",
      "+..-..-..-...."
    ],
    [
      "Micronesia",
      "fm",
      "691",
      "+...-...-...."
    ],
    [
      "Moldova (Republica Moldova)",
      "md",
      "373",
      "+...-....-...."
    ],
    [
      "Monaco",
      "mc",
      "377",
      "+...-..-...-..."
    ],
    [
      "Mongolia (Монгол)",
      "mn",
      "976",
      "+...-..-..-...."
    ],
    [
      "Montenegro (Crna Gora)",
      "me",
      "382",
      "+...-..-...-..."
    ],
    [
      "Montserrat",
      "ms",
      "1664",
      "+.(...)...-...."
    ],
    [
      "Morocco (‫المغرب‬‎)",
      "ma",
      "212",
      "+...-..-....-..."
    ],
    [
      "Mozambique (Moçambique)",
      "mz",
      "258",
      "+...-..-...-..."
    ],
    [
      "Myanmar (Burma) (မြန်မာ)",
      "mm",
      "95",
      "+..-...-..."
    ],
    [
      "Namibia (Namibië)",
      "na",
      "264",
      "+...-..-...-...."
    ],
    [
      "Nauru",
      "nr",
      "674",
      "+...-...-...."
    ],
    [
      "Nepal (नेपाल)",
      "np",
      "977",
      "+...-..-...-..."
    ],
    [
      "Netherlands (Nederland)",
      "nl",
      "31",
      "+.. .. ........"
    ],
    [
      "New Caledonia (Nouvelle-Calédonie)",
      "nc",
      "687",
      "+...-..-...."
    ],
    [
      "New Zealand",
      "nz",
      "64",
      "+.. ...-...-...."
    ],
    [
      "Nicaragua",
      "ni",
      "505",
      "+...-....-...."
    ],
    [
      "Niger (Nijar)",
      "ne",
      "227",
      "+...-..-..-...."
    ],
    [
      "Nigeria",
      "ng",
      "234",
      "+...-..-...-.."
    ],
    [
      "Niue",
      "nu",
      "683",
      "+...-...."
    ],
    [
      "Norfolk Island",
      "nf",
      "672",
      "+...-...-..."
    ],
    [
      "North Korea (조선 민주주의 인민 공화국)",
      "kp",
      "850",
      "+...-...-..."
    ],
    [
      "Northern Mariana Islands",
      "mp",
      "1670",
      "+.(...)...-...."
    ],
    [
      "Norway (Norge)",
      "no",
      "47",
      "+.. ... .. ..."
    ],
    [
      "Oman (‫عُمان‬‎)",
      "om",
      "968",
      "+...-..-...-..."
    ],
    [
      "Pakistan (‫پاکستان‬‎)",
      "pk",
      "92",
      "+.. ...-......."
    ],
    [
      "Palau",
      "pw",
      "680",
      "+...-...-...."
    ],
    [
      "Palestine (‫فلسطين‬‎)",
      "ps",
      "970",
      "+...-..-...-...."
    ],
    [
      "Panama (Panamá)",
      "pa",
      "507",
      "+...-...-...."
    ],
    [
      "Papua New Guinea",
      "pg",
      "675",
      "+...(...)..-..."
    ],
    [
      "Paraguay",
      "py",
      "595",
      "+...(...)...-..."
    ],
    [
      "Peru (Perú)",
      "pe",
      "51",
      "+..(...)...-..."
    ],
    [
      "Philippines",
      "ph",
      "63",
      "+.. ... ...."
    ],
    [
      "Pitcairn Islands",
      "pn",
      "64",
      ""
    ],
    [
      "Poland (Polska)",
      "pl",
      "48",
      "+.. ...-...-..."
    ],
    [
      "Portugal",
      "pt",
      "351",
      "+...-..-...-...."
    ],
    [
      "Puerto Rico",
      "pr",
      "1",
      "+. (...) ...-....",
      3,
      ["787", "939"]
    ],
    [
      "Qatar (‫قطر‬‎)",
      "qa",
      "974",
      "+...-....-...."
    ],
    [
      "Réunion (La Réunion)",
      "re",
      "262",
      "+...-.....-...."
    ],
    [
      "Romania (România)",
      "ro",
      "40",
      "+..-..-...-...."
    ],
    [
      "Russia (Россия)",
      "ru",
      "7",
      "+. ... ...-..-..",
      0
    ],
    [
      "Rwanda",
      "rw",
      "250",
      "+...(...)...-..."
    ],
    [
      "Saint Barthélemy (Saint-Barthélemy)",
      "bl",
      "590",
      "",
      1
    ],
    [
      "Saint Helena",
      "sh",
      "290"
    ],
    [
      "Saint Kitts and Nevis",
      "kn",
      "1869",
      "+.(...)...-...."
    ],
    [
      "Saint Lucia",
      "lc",
      "1758",
      "+.(...)...-...."
    ],
    [
      "Saint Martin (Saint-Martin (partie française))",
      "mf",
      "590",
      "",
      2
    ],
    [
      "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
      "pm",
      "508"
    ],
    [
      "Saint Vincent and the Grenadines",
      "vc",
      "1784",
      "+.(...)...-...."
    ],
    [
      "Samoa",
      "ws",
      "685",
      "+...-..-...."
    ],
    [
      "San Marino",
      "sm",
      "378",
      "+...-....-......"
    ],
    [
      "São Tomé and Príncipe (São Tomé e Príncipe)",
      "st",
      "239",
      "+...-..-....."
    ],
    [
      "Saudi Arabia (‫المملكة العربية السعودية‬‎)",
      "sa",
      "966",
      "+...-..-...-...."
    ],
    [
      "Senegal (Sénégal)",
      "sn",
      "221",
      "+...-..-...-...."
    ],
    [
      "Serbia (Србија)",
      "rs",
      "381",
      "+...-..-...-...."
    ],
    [
      "Seychelles",
      "sc",
      "248",
      "+...-.-...-..."
    ],
    [
      "Sierra Leone",
      "sl",
      "232",
      "+...-..-......"
    ],
    [
      "Singapore",
      "sg",
      "65",
      "+.. ....-...."
    ],
    [
      "Sint Maarten",
      "sx",
      "1721",
      "+.(...)...-...."
    ],
    [
      "Slovakia (Slovensko)",
      "sk",
      "421",
      "+...(...)...-..."
    ],
    [
      "Slovenia (Slovenija)",
      "si",
      "386",
      "+...-..-...-..."
    ],
    [
      "Solomon Islands",
      "sb",
      "677",
      "+...-....."
    ],
    [
      "Somalia (Soomaaliya)",
      "so",
      "252",
      "+...-.-...-..."
    ],
    [
      "South Africa",
      "za",
      "27",
      "+..-..-...-...."
    ],
    [
      "South Georgia and the South Sandwich Islands",
      "gs",
      "500",
      ""
    ],
    [
      "South Korea (대한민국)",
      "kr",
      "82",
      "+..-..-...-...."
    ],
    [
      "South Sudan (‫جنوب السودان‬‎)",
      "ss",
      "211",
      "+...-..-...-...."
    ],
    [
      "Spain (España)",
      "es",
      "34",
      "+.. ... ... ..."
    ],
    [
      "Sri Lanka (ශ්‍රී ලංකාව)",
      "lk",
      "94",
      "+..-..-...-...."
    ],
    [
      "Sudan (‫السودان‬‎)",
      "sd",
      "249",
      "+...-..-...-...."
    ],
    [
      "Suriname",
      "sr",
      "597",
      "+...-...-..."
    ],
    [
      "Svalbard and Jan Mayen",
      "sj",
      "47",
      ""
    ],
    [
      "Swaziland",
      "sz",
      "268",
      "+...-..-..-...."
    ],
    [
      "Sweden (Sverige)",
      "se",
      "46",
      "+.. .. ... .. .."
    ],
    [
      "Switzerland (Schweiz)",
      "ch",
      "41",
      "+.. .. ... .. .."
    ],
    [
      "Syria (‫سوريا‬‎)",
      "sy",
      "963",
      "+...-..-....-..."
    ],
    [
      "Taiwan (台灣)",
      "tw",
      "886",
      "+...-....-...."
    ],
    [
      "Tajikistan",
      "tj",
      "992",
      "+...-..-...-...."
    ],
    [
      "Tanzania",
      "tz",
      "255",
      "+...-..-...-...."
    ],
    [
      "Thailand (ไทย)",
      "th",
      "66",
      "+..-..-...-..."
    ],
    [
      "Timor-Leste",
      "tl",
      "670",
      "+...-...-...."
    ],
    [
      "Togo",
      "tg",
      "228",
      "+...-..-...-..."
    ],
    [
      "Tokelau",
      "tk",
      "690",
      "+...-...."
    ],
    [
      "Tonga",
      "to",
      "676",
      "+...-....."
    ],
    [
      "Trinidad and Tobago",
      "tt",
      "1868",
      "+.(...)...-...."
    ],
    [
      "Tunisia (‫تونس‬‎)",
      "tn",
      "216",
      "+...-..-...-..."
    ],
    [
      "Turkey (Türkiye)",
      "tr",
      "90",
      "+.. ... ... .. .."
    ],
    [
      "Turkmenistan",
      "tm",
      "993",
      "+...-.-...-...."
    ],
    [
      "Turks and Caicos Islands",
      "tc",
      "1649",
      "+.(...)...-...."
    ],
    [
      "Tuvalu",
      "tv",
      "688",
      "+...-....."
    ],
    [
      "U.S. Virgin Islands",
      "vi",
      "1340",
      "+.(...)...-...."
    ],
    [
      "Uganda",
      "ug",
      "256",
      "+...(...)...-..."
    ],
    [
      "Ukraine (Україна)",
      "ua",
      "380",
      "+...(..)...-..-.."
    ],
    [
      "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)",
      "ae",
      "971",
      "+...-.-...-...."
    ],
    [
      "United Kingdom",
      "gb",
      "44",
      "+.. .... ......"
    ],
    [
      "United States",
      "us",
      "1",
      "+. (...) ...-....",
      0
    ],
    [
      "United States Minor Outlying Islands",
      "um",
      "1",
      "",
      2
    ],
    [
      "Uruguay",
      "uy",
      "598",
      "+...-.-...-..-.."
    ],
    [
      "Uzbekistan (Oʻzbekiston)",
      "uz",
      "998",
      "+...-..-...-...."
    ],
    [
      "Vanuatu",
      "vu",
      "678",
      "+...-....."
    ],
    [
      "Vatican City (Città del Vaticano)",
      "va",
      "39",
      "+.. .. .... ....",
      1
    ],
    [
      "Venezuela",
      "ve",
      "58",
      "+..(...)...-...."
    ],
    [
      "Vietnam (Việt Nam)",
      "vn",
      "84",
      "+..-..-....-..."
    ],
    [
      "Wallis and Futuna",
      "wf",
      "681",
      "+...-..-...."
    ],
    [
      "Western Sahara",
      "eh",
      "212",
      "+...-..-...."
    ],
    [
      "Yemen (‫اليمن‬‎)",
      "ye",
      "967",
      "+...-.-...-..."
    ],
    [
      "Zambia",
      "zm",
      "260",
      "+...-..-...-...."
    ],
    [
      "Zimbabwe",
      "zw",
      "263",
      "+...-.-......"
    ]
  ], allCountryCodes2 = {}, iso2Lookup2 = {}, addCountryCode2 = function(iso2, dialCode$1, priority) {
    dialCode$1 in allCountryCodes2 || (allCountryCodes2[dialCode$1] = []);
    var index = priority || 0;
    allCountryCodes2[dialCode$1][index] = iso2;
  }, i2 = 0; i2 < allCountries$1.length; i2++) {
    var c2 = allCountries$1[i2];
    if (allCountries$1[i2] = {
      name: c2[0],
      iso2: c2[1],
      dialCode: c2[2],
      priority: c2[4] || 0
    }, c2[3] && (allCountries$1[i2].format = c2[3]), c2[5]) {
      allCountries$1[i2].hasAreaCodes = true;
      for (var j2 = 0; j2 < c2[5].length; j2++) {
        var dialCode2 = c2[2] + c2[5][j2];
        addCountryCode2(c2[1], dialCode2);
      }
    }
    iso2Lookup2[allCountries$1[i2].iso2] = i2, addCountryCode2(c2[1], c2[2], c2[4]);
  }
  module2.exports = {
    allCountries: allCountries$1,
    iso2Lookup: iso2Lookup2,
    allCountryCodes: allCountryCodes2
  };
})), require_libphonenumber = /* @__PURE__ */ __commonJSMin(((exports$1, module) => {
  (function(f2) {
    if (typeof exports$1 == "object" && module !== void 0) module.exports = f2();
    else if (typeof define == "function" && define.amd) define([], f2);
    else {
      var g2 = typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : this;
      g2.libphonenumber = f2();
    }
  })(function() {
    return (/* @__PURE__ */ (function() {
      function r(e2, n$12, t) {
        function o(i$22, f2) {
          if (!n$12[i$22]) {
            if (!e2[i$22]) {
              var c$12 = typeof __require == "function" && __require;
              if (!f2 && c$12) return c$12(i$22, true);
              if (u) return u(i$22, true);
              var a2 = /* @__PURE__ */ Error("Cannot find module '" + i$22 + "'");
              throw a2.code = "MODULE_NOT_FOUND", a2;
            }
            var p = n$12[i$22] = { exports: {} };
            e2[i$22][0].call(p.exports, function(r$1) {
              var n$2 = e2[i$22][1][r$1];
              return o(n$2 || r$1);
            }, p, p.exports, r, e2, n$12, t);
          }
          return n$12[i$22].exports;
        }
        for (var u = typeof __require == "function" && __require, i$12 = 0; i$12 < t.length; i$12++) o(t[i$12]);
        return o;
      }
      return r;
    })())({ 1: [function(require$1, module$2, exports$2) {
      (function(global$1) {
        (function() {
          var $jscomp = $jscomp || {};
          $jscomp.scope = {}, $jscomp.createTemplateTagFirstArg = function(a2) {
            return a2.raw = a2;
          }, $jscomp.createTemplateTagFirstArgWithRaw = function(a2, b2) {
            return a2.raw = b2, a2;
          }, $jscomp.arrayIteratorImpl = function(a2) {
            var b2 = 0;
            return function() {
              return b2 < a2.length ? {
                done: false,
                value: a2[b2++]
              } : { done: true };
            };
          }, $jscomp.arrayIterator = function(a2) {
            return { next: $jscomp.arrayIteratorImpl(a2) };
          }, $jscomp.makeIterator = function(a2) {
            var b2 = typeof Symbol < "u" && Symbol.iterator && a2[Symbol.iterator];
            return b2 ? b2.call(a2) : $jscomp.arrayIterator(a2);
          }, $jscomp.arrayFromIterator = function(a2) {
            for (var b2, c$12 = []; !(b2 = a2.next()).done; ) c$12.push(b2.value);
            return c$12;
          }, $jscomp.arrayFromIterable = function(a2) {
            return a2 instanceof Array ? a2 : $jscomp.arrayFromIterator($jscomp.makeIterator(a2));
          }, $jscomp.checkStringArgs = function(a2, b2, c$12) {
            if (a2 == null) throw TypeError("The 'this' value for String.prototype." + c$12 + " must not be null or undefined");
            if (b2 instanceof RegExp) throw TypeError("First argument to String.prototype." + c$12 + " must not be a regular expression");
            return a2 + "";
          }, $jscomp.ASSUME_ES5 = false, $jscomp.ASSUME_NO_NATIVE_MAP = false, $jscomp.ASSUME_NO_NATIVE_SET = false, $jscomp.SIMPLE_FROUND_POLYFILL = false, $jscomp.ISOLATE_POLYFILLS = false, $jscomp.FORCE_POLYFILL_PROMISE = false, $jscomp.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION = false, $jscomp.defineProperty = $jscomp.ASSUME_ES5 || typeof Object.defineProperties == "function" ? Object.defineProperty : function(a2, b2, c$12) {
            return a2 == Array.prototype || a2 == Object.prototype || (a2[b2] = c$12.value), a2;
          }, $jscomp.getGlobal = function(a2) {
            a2 = [
              typeof globalThis == "object" && globalThis,
              a2,
              typeof window == "object" && window,
              typeof self == "object" && self,
              typeof global$1 == "object" && global$1
            ];
            for (var b2 = 0; b2 < a2.length; ++b2) {
              var c$12 = a2[b2];
              if (c$12 && c$12.Math == Math) return c$12;
            }
            throw Error("Cannot find global object");
          }, $jscomp.global = $jscomp.getGlobal(this), $jscomp.IS_SYMBOL_NATIVE = typeof Symbol == "function" && typeof Symbol("x") == "symbol", $jscomp.TRUST_ES6_POLYFILLS = !$jscomp.ISOLATE_POLYFILLS || $jscomp.IS_SYMBOL_NATIVE, $jscomp.polyfills = {}, $jscomp.propertyToPolyfillSymbol = {}, $jscomp.POLYFILL_PREFIX = "$jscp$";
          $jscomp.polyfill = function(a2, b2, c$12, d2) {
            b2 && ($jscomp.ISOLATE_POLYFILLS ? $jscomp.polyfillIsolated(a2, b2, c$12, d2) : $jscomp.polyfillUnisolated(a2, b2, c$12, d2));
          }, $jscomp.polyfillUnisolated = function(a2, b2, c$12, d2) {
            for (c$12 = $jscomp.global, a2 = a2.split("."), d2 = 0; d2 < a2.length - 1; d2++) {
              var e2 = a2[d2];
              if (!(e2 in c$12)) return;
              c$12 = c$12[e2];
            }
            a2 = a2[a2.length - 1], d2 = c$12[a2], b2 = b2(d2), b2 != d2 && b2 != null && $jscomp.defineProperty(c$12, a2, {
              configurable: true,
              writable: true,
              value: b2
            });
          }, $jscomp.polyfillIsolated = function(a2, b2, c$12, d2) {
            var e2 = a2.split(".");
            a2 = e2.length === 1, d2 = e2[0], d2 = !a2 && d2 in $jscomp.polyfills ? $jscomp.polyfills : $jscomp.global;
            for (var f2 = 0; f2 < e2.length - 1; f2++) {
              var g2 = e2[f2];
              if (!(g2 in d2)) return;
              d2 = d2[g2];
            }
            e2 = e2[e2.length - 1], c$12 = $jscomp.IS_SYMBOL_NATIVE && c$12 === "es6" ? d2[e2] : null, b2 = b2(c$12), b2 != null && (a2 ? $jscomp.defineProperty($jscomp.polyfills, e2, {
              configurable: true,
              writable: true,
              value: b2
            }) : b2 !== c$12 && ($jscomp.propertyToPolyfillSymbol[e2] = $jscomp.IS_SYMBOL_NATIVE ? $jscomp.global.Symbol(e2) : $jscomp.POLYFILL_PREFIX + e2, e2 = $jscomp.propertyToPolyfillSymbol[e2], $jscomp.defineProperty(d2, e2, {
              configurable: true,
              writable: true,
              value: b2
            })));
          }, $jscomp.polyfill("String.prototype.endsWith", function(a2) {
            return a2 || function(b2, c$12) {
              var d2 = $jscomp.checkStringArgs(this, b2, "endsWith");
              b2 += "", c$12 === void 0 && (c$12 = d2.length), c$12 = Math.max(0, Math.min(c$12 | 0, d2.length));
              for (var e2 = b2.length; 0 < e2 && 0 < c$12; ) if (d2[--c$12] != b2[--e2]) return false;
              return 0 >= e2;
            };
          }, "es6", "es3"), $jscomp.findInternal = function(a2, b2, c$12) {
            a2 instanceof String && (a2 = String(a2));
            for (var d2 = a2.length, e2 = 0; e2 < d2; e2++) {
              var f2 = a2[e2];
              if (b2.call(c$12, f2, e2, a2)) return {
                i: e2,
                v: f2
              };
            }
            return {
              i: -1,
              v: void 0
            };
          }, $jscomp.polyfill("Array.prototype.find", function(a2) {
            return a2 || function(b2, c$12) {
              return $jscomp.findInternal(this, b2, c$12).v;
            };
          }, "es6", "es3"), $jscomp.polyfill("String.prototype.startsWith", function(a2) {
            return a2 || function(b2, c$12) {
              var d2 = $jscomp.checkStringArgs(this, b2, "startsWith");
              b2 += "";
              var e2 = d2.length, f2 = b2.length;
              c$12 = Math.max(0, Math.min(c$12 | 0, d2.length));
              for (var g2 = 0; g2 < f2 && c$12 < e2; ) if (d2[c$12++] != b2[g2++]) return false;
              return g2 >= f2;
            };
          }, "es6", "es3"), $jscomp.polyfill("String.prototype.repeat", function(a2) {
            return a2 || function(b2) {
              var c$12 = $jscomp.checkStringArgs(this, null, "repeat");
              if (0 > b2 || 1342177279 < b2) throw RangeError("Invalid count value");
              b2 |= 0;
              for (var d2 = ""; b2; ) b2 & 1 && (d2 += c$12), (b2 >>>= 1) && (c$12 += c$12);
              return d2;
            };
          }, "es6", "es3"), $jscomp.initSymbol = function() {
          }, $jscomp.polyfill("Symbol", function(a2) {
            if (a2) return a2;
            var b2 = function(e2, f2) {
              this.$jscomp$symbol$id_ = e2, $jscomp.defineProperty(this, "description", {
                configurable: true,
                writable: true,
                value: f2
              });
            };
            b2.prototype.toString = function() {
              return this.$jscomp$symbol$id_;
            };
            var c$12 = 0, d2 = function(e2) {
              if (this instanceof d2) throw TypeError("Symbol is not a constructor");
              return new b2("jscomp_symbol_" + (e2 || "") + "_" + c$12++, e2);
            };
            return d2;
          }, "es6", "es3"), $jscomp.polyfill("Symbol.iterator", function(a2) {
            if (a2) return a2;
            a2 = Symbol("Symbol.iterator");
            for (var b2 = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c$12 = 0; c$12 < b2.length; c$12++) {
              var d2 = $jscomp.global[b2[c$12]];
              typeof d2 == "function" && typeof d2.prototype[a2] != "function" && $jscomp.defineProperty(d2.prototype, a2, {
                configurable: true,
                writable: true,
                value: function() {
                  return $jscomp.iteratorPrototype($jscomp.arrayIteratorImpl(this));
                }
              });
            }
            return a2;
          }, "es6", "es3"), $jscomp.iteratorPrototype = function(a2) {
            return a2 = { next: a2 }, a2[Symbol.iterator] = function() {
              return this;
            }, a2;
          }, $jscomp.iteratorFromArray = function(a2, b2) {
            a2 instanceof String && (a2 += "");
            var c$12 = 0, d2 = false, e2 = { next: function() {
              if (!d2 && c$12 < a2.length) {
                var f2 = c$12++;
                return {
                  value: b2(f2, a2[f2]),
                  done: false
                };
              }
              return d2 = true, {
                done: true,
                value: void 0
              };
            } };
            return e2[Symbol.iterator] = function() {
              return e2;
            }, e2;
          }, $jscomp.polyfill("Array.prototype.keys", function(a2) {
            return a2 || function() {
              return $jscomp.iteratorFromArray(this, function(b2) {
                return b2;
              });
            };
          }, "es6", "es3"), $jscomp.polyfill("Object.is", function(a2) {
            return a2 || function(b2, c$12) {
              return b2 === c$12 ? b2 !== 0 || 1 / b2 == 1 / c$12 : b2 !== b2 && c$12 !== c$12;
            };
          }, "es6", "es3"), $jscomp.polyfill("Array.prototype.includes", function(a2) {
            return a2 || function(b2, c$12) {
              var d2 = this;
              d2 instanceof String && (d2 = String(d2));
              var e2 = d2.length;
              for (c$12 ||= 0, 0 > c$12 && (c$12 = Math.max(c$12 + e2, 0)); c$12 < e2; c$12++) {
                var f2 = d2[c$12];
                if (f2 === b2 || Object.is(f2, b2)) return true;
              }
              return false;
            };
          }, "es7", "es3"), $jscomp.polyfill("String.prototype.includes", function(a2) {
            return a2 || function(b2, c$12) {
              return $jscomp.checkStringArgs(this, b2, "includes").indexOf(b2, c$12 || 0) !== -1;
            };
          }, "es6", "es3");
          var COMPILED = true, goog = goog || {};
          goog.global = this || self, goog.exportPath_ = function(a2, b2, c$12, d2) {
            a2 = a2.split("."), d2 ||= goog.global, a2[0] in d2 || d2.execScript === void 0 || d2.execScript("var " + a2[0]);
            for (var e2; a2.length && (e2 = a2.shift()); ) if (a2.length || b2 === void 0) d2 = d2[e2] && d2[e2] !== Object.prototype[e2] ? d2[e2] : d2[e2] = {};
            else if (!c$12 && goog.isObject(b2) && goog.isObject(d2[e2])) for (var f2 in b2) b2.hasOwnProperty(f2) && (d2[e2][f2] = b2[f2]);
            else d2[e2] = b2;
          }, goog.define = function(a2, b2) {
            if (!COMPILED) {
              var c$12 = goog.global.CLOSURE_UNCOMPILED_DEFINES, d2 = goog.global.CLOSURE_DEFINES;
              c$12 && c$12.nodeType === void 0 && Object.prototype.hasOwnProperty.call(c$12, a2) ? b2 = c$12[a2] : d2 && d2.nodeType === void 0 && Object.prototype.hasOwnProperty.call(d2, a2) && (b2 = d2[a2]);
            }
            return b2;
          }, goog.FEATURESET_YEAR = 2012, goog.DEBUG = true, goog.LOCALE = "en", goog.TRUSTED_SITE = true, goog.DISALLOW_TEST_ONLY_CODE = COMPILED && !goog.DEBUG, goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = false, goog.provide = function(a2) {
            if (goog.isInModuleLoader_()) throw Error("goog.provide cannot be used within a module.");
            if (!COMPILED && goog.isProvided_(a2)) throw Error('Namespace "' + a2 + '" already declared.');
            goog.constructNamespace_(a2);
          }, goog.constructNamespace_ = function(a2, b2, c$12) {
            if (!COMPILED) {
              delete goog.implicitNamespaces_[a2];
              for (var d2 = a2; (d2 = d2.substring(0, d2.lastIndexOf("."))) && !goog.getObjectByName(d2); ) goog.implicitNamespaces_[d2] = true;
            }
            goog.exportPath_(a2, b2, c$12);
          }, goog.getScriptNonce = function(a2) {
            return a2 && a2 != goog.global ? goog.getScriptNonce_(a2.document) : (goog.cspNonce_ === null && (goog.cspNonce_ = goog.getScriptNonce_(goog.global.document)), goog.cspNonce_);
          }, goog.NONCE_PATTERN_ = /^[\w+/_-]+[=]{0,2}$/, goog.cspNonce_ = null, goog.getScriptNonce_ = function(a2) {
            return (a2 = a2.querySelector && a2.querySelector("script[nonce]")) && (a2 = a2.nonce || a2.getAttribute("nonce")) && goog.NONCE_PATTERN_.test(a2) ? a2 : "";
          }, goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/, goog.module = function(a2) {
            if (typeof a2 != "string" || !a2 || a2.search(goog.VALID_MODULE_RE_) == -1) throw Error("Invalid module identifier");
            if (!goog.isInGoogModuleLoader_()) throw Error("Module " + a2 + " has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
            if (goog.moduleLoaderState_.moduleName) throw Error("goog.module may only be called once per module.");
            if (goog.moduleLoaderState_.moduleName = a2, !COMPILED) {
              if (goog.isProvided_(a2)) throw Error('Namespace "' + a2 + '" already declared.');
              delete goog.implicitNamespaces_[a2];
            }
          }, goog.module.get = function(a2) {
            return goog.module.getInternal_(a2);
          }, goog.module.getInternal_ = function(a2) {
            if (!COMPILED) {
              if (a2 in goog.loadedModules_) return goog.loadedModules_[a2].exports;
              if (!goog.implicitNamespaces_[a2]) return a2 = goog.getObjectByName(a2), a2 ?? null;
            }
            return null;
          }, goog.ModuleType = {
            ES6: "es6",
            GOOG: "goog"
          }, goog.moduleLoaderState_ = null, goog.isInModuleLoader_ = function() {
            return goog.isInGoogModuleLoader_() || goog.isInEs6ModuleLoader_();
          }, goog.isInGoogModuleLoader_ = function() {
            return !!goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.GOOG;
          }, goog.isInEs6ModuleLoader_ = function() {
            if (goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.ES6) return true;
            var a2 = goog.global.$jscomp;
            return a2 && typeof a2.getCurrentModulePath == "function" ? !!a2.getCurrentModulePath() : false;
          }, goog.module.declareLegacyNamespace = function() {
            if (!COMPILED && !goog.isInGoogModuleLoader_()) throw Error("goog.module.declareLegacyNamespace must be called from within a goog.module");
            if (!COMPILED && !goog.moduleLoaderState_.moduleName) throw Error("goog.module must be called prior to goog.module.declareLegacyNamespace.");
            goog.moduleLoaderState_.declareLegacyNamespace = true;
          }, goog.declareModuleId = function(a2) {
            if (!COMPILED) {
              if (!goog.isInEs6ModuleLoader_()) throw Error("goog.declareModuleId may only be called from within an ES6 module");
              if (goog.moduleLoaderState_ && goog.moduleLoaderState_.moduleName) throw Error("goog.declareModuleId may only be called once per module.");
              if (a2 in goog.loadedModules_) throw Error('Module with namespace "' + a2 + '" already exists.');
            }
            if (goog.moduleLoaderState_) goog.moduleLoaderState_.moduleName = a2;
            else {
              var b2 = goog.global.$jscomp;
              if (!b2 || typeof b2.getCurrentModulePath != "function") throw Error('Module with namespace "' + a2 + '" has been loaded incorrectly.');
              b2 = b2.require(b2.getCurrentModulePath()), goog.loadedModules_[a2] = {
                exports: b2,
                type: goog.ModuleType.ES6,
                moduleId: a2
              };
            }
          }, goog.setTestOnly = function(a2) {
            if (goog.DISALLOW_TEST_ONLY_CODE) throw a2 ||= "", Error("Importing test-only code into non-debug environment" + (a2 ? ": " + a2 : "."));
          }, goog.forwardDeclare = function(a2) {
          }, COMPILED || (goog.isProvided_ = function(a2) {
            return a2 in goog.loadedModules_ || !goog.implicitNamespaces_[a2] && goog.getObjectByName(a2) != null;
          }, goog.implicitNamespaces_ = { "goog.module": true }), goog.getObjectByName = function(a2, b2) {
            a2 = a2.split("."), b2 ||= goog.global;
            for (var c$12 = 0; c$12 < a2.length; c$12++) if (b2 = b2[a2[c$12]], b2 == null) return null;
            return b2;
          }, goog.addDependency = function(a2, b2, c$12, d2) {
            !COMPILED && goog.DEPENDENCIES_ENABLED && goog.debugLoader_.addDependency(a2, b2, c$12, d2);
          }, goog.ENABLE_DEBUG_LOADER = true, goog.logToConsole_ = function(a2) {
            goog.global.console && goog.global.console.error(a2);
          }, goog.require = function(a2) {
            if (!COMPILED) {
              if (goog.ENABLE_DEBUG_LOADER && goog.debugLoader_.requested(a2), goog.isProvided_(a2)) {
                if (goog.isInModuleLoader_()) return goog.module.getInternal_(a2);
              } else if (goog.ENABLE_DEBUG_LOADER) {
                var b2 = goog.moduleLoaderState_;
                goog.moduleLoaderState_ = null;
                try {
                  goog.debugLoader_.load_(a2);
                } finally {
                  goog.moduleLoaderState_ = b2;
                }
              }
              return null;
            }
          }, goog.requireType = function(a2) {
            return {};
          }, goog.basePath = "", goog.nullFunction = function() {
          }, goog.abstractMethod = function() {
            throw Error("unimplemented abstract method");
          }, goog.addSingletonGetter = function(a2) {
            a2.instance_ = void 0, a2.getInstance = function() {
              return a2.instance_ ? a2.instance_ : (goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = a2), a2.instance_ = new a2());
            };
          }, goog.instantiatedSingletons_ = [], goog.LOAD_MODULE_USING_EVAL = true, goog.SEAL_MODULE_EXPORTS = goog.DEBUG, goog.loadedModules_ = {}, goog.DEPENDENCIES_ENABLED = !COMPILED && goog.ENABLE_DEBUG_LOADER, goog.TRANSPILE = "detect", goog.ASSUME_ES_MODULES_TRANSPILED = false, goog.TRANSPILE_TO_LANGUAGE = "", goog.TRANSPILER = "transpile.js", goog.hasBadLetScoping = null, goog.useSafari10Workaround = function() {
            if (goog.hasBadLetScoping == null) {
              try {
                var a = !eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";');
              } catch {
                a = false;
              }
              goog.hasBadLetScoping = a;
            }
            return goog.hasBadLetScoping;
          }, goog.workaroundSafari10EvalBug = function(a2) {
            return "(function(){" + a2 + "\n;})();\n";
          }, goog.loadModule = function(a2) {
            var b2 = goog.moduleLoaderState_;
            try {
              goog.moduleLoaderState_ = {
                moduleName: "",
                declareLegacyNamespace: false,
                type: goog.ModuleType.GOOG
              };
              var c$12 = {}, d2 = c$12;
              if (typeof a2 == "function") d2 = a2.call(void 0, d2);
              else if (typeof a2 == "string") goog.useSafari10Workaround() && (a2 = goog.workaroundSafari10EvalBug(a2)), d2 = goog.loadModuleFromSource_.call(void 0, d2, a2);
              else throw Error("Invalid module definition");
              var e2 = goog.moduleLoaderState_.moduleName;
              if (typeof e2 == "string" && e2) goog.moduleLoaderState_.declareLegacyNamespace ? goog.constructNamespace_(e2, d2, c$12 !== d2) : goog.SEAL_MODULE_EXPORTS && Object.seal && typeof d2 == "object" && d2 && Object.seal(d2), goog.loadedModules_[e2] = {
                exports: d2,
                type: goog.ModuleType.GOOG,
                moduleId: goog.moduleLoaderState_.moduleName
              };
              else throw Error('Invalid module name "' + e2 + '"');
            } finally {
              goog.moduleLoaderState_ = b2;
            }
          }, goog.loadModuleFromSource_ = function(a, b) {
            return eval(b), a;
          }, goog.normalizePath_ = function(a2) {
            a2 = a2.split("/");
            for (var b2 = 0; b2 < a2.length; ) a2[b2] == "." ? a2.splice(b2, 1) : b2 && a2[b2] == ".." && a2[b2 - 1] && a2[b2 - 1] != ".." ? a2.splice(--b2, 2) : b2++;
            return a2.join("/");
          }, goog.loadFileSync_ = function(a2) {
            if (goog.global.CLOSURE_LOAD_FILE_SYNC) return goog.global.CLOSURE_LOAD_FILE_SYNC(a2);
            try {
              var b2 = new goog.global.XMLHttpRequest();
              return b2.open("get", a2, false), b2.send(), b2.status == 0 || b2.status == 200 ? b2.responseText : null;
            } catch {
              return null;
            }
          }, goog.transpile_ = function(a2, b2, c$12) {
            var d2 = goog.global.$jscomp;
            d2 || (goog.global.$jscomp = d2 = {});
            var e2 = d2.transpile;
            if (!e2) {
              var f2 = goog.basePath + goog.TRANSPILER, g2 = goog.loadFileSync_(f2);
              if (g2) {
                if ((function() {
                  (0, eval)(g2 + "\n//# sourceURL=" + f2);
                }).call(goog.global), goog.global.$gwtExport && goog.global.$gwtExport.$jscomp && !goog.global.$gwtExport.$jscomp.transpile) throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: ' + JSON.stringify(goog.global.$gwtExport));
                goog.global.$jscomp.transpile = goog.global.$gwtExport.$jscomp.transpile, d2 = goog.global.$jscomp, e2 = d2.transpile;
              }
            }
            return e2 ||= d2.transpile = function(h, k) {
              return goog.logToConsole_(k + " requires transpilation but no transpiler was found."), h;
            }, e2(a2, b2, c$12);
          }, goog.typeOf = function(a2) {
            var b2 = typeof a2;
            return b2 == "object" ? a2 ? Array.isArray(a2) ? "array" : b2 : "null" : b2;
          }, goog.isArrayLike = function(a2) {
            var b2 = goog.typeOf(a2);
            return b2 == "array" || b2 == "object" && typeof a2.length == "number";
          }, goog.isDateLike = function(a2) {
            return goog.isObject(a2) && typeof a2.getFullYear == "function";
          }, goog.isObject = function(a2) {
            var b2 = typeof a2;
            return b2 == "object" && a2 != null || b2 == "function";
          }, goog.getUid = function(a2) {
            return Object.prototype.hasOwnProperty.call(a2, goog.UID_PROPERTY_) && a2[goog.UID_PROPERTY_] || (a2[goog.UID_PROPERTY_] = ++goog.uidCounter_);
          }, goog.hasUid = function(a2) {
            return !!a2[goog.UID_PROPERTY_];
          }, goog.removeUid = function(a2) {
            a2 !== null && "removeAttribute" in a2 && a2.removeAttribute(goog.UID_PROPERTY_);
            try {
              delete a2[goog.UID_PROPERTY_];
            } catch {
            }
          }, goog.UID_PROPERTY_ = "closure_uid_" + (1e9 * Math.random() >>> 0), goog.uidCounter_ = 0, goog.cloneObject = function(a2) {
            var b2 = goog.typeOf(a2);
            if (b2 == "object" || b2 == "array") {
              if (typeof a2.clone == "function") return a2.clone();
              for (var c$12 in b2 = b2 == "array" ? [] : {}, a2) b2[c$12] = goog.cloneObject(a2[c$12]);
              return b2;
            }
            return a2;
          }, goog.bindNative_ = function(a2, b2, c$12) {
            return a2.call.apply(a2.bind, arguments);
          }, goog.bindJs_ = function(a2, b2, c$12) {
            if (!a2) throw Error();
            if (2 < arguments.length) {
              var d2 = Array.prototype.slice.call(arguments, 2);
              return function() {
                var e2 = Array.prototype.slice.call(arguments);
                return Array.prototype.unshift.apply(e2, d2), a2.apply(b2, e2);
              };
            }
            return function() {
              return a2.apply(b2, arguments);
            };
          }, goog.bind = function(a2, b2, c$12) {
            return Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? goog.bind = goog.bindNative_ : goog.bind = goog.bindJs_, goog.bind.apply(null, arguments);
          }, goog.partial = function(a2, b2) {
            var c$12 = Array.prototype.slice.call(arguments, 1);
            return function() {
              var d2 = c$12.slice();
              return d2.push.apply(d2, arguments), a2.apply(this, d2);
            };
          }, goog.mixin = function(a2, b2) {
            for (var c$12 in b2) a2[c$12] = b2[c$12];
          }, goog.now = function() {
            return Date.now();
          }, goog.globalEval = function(a2) {
            (0, eval)(a2);
          }, goog.getCssName = function(a2, b2) {
            if (String(a2).charAt(0) == ".") throw Error('className passed in goog.getCssName must not start with ".". You passed: ' + a2);
            var c$12 = function(e2) {
              return goog.cssNameMapping_[e2] || e2;
            }, d2 = function(e2) {
              e2 = e2.split("-");
              for (var f2 = [], g2 = 0; g2 < e2.length; g2++) f2.push(c$12(e2[g2]));
              return f2.join("-");
            };
            return d2 = goog.cssNameMapping_ ? goog.cssNameMappingStyle_ == "BY_WHOLE" ? c$12 : d2 : function(e2) {
              return e2;
            }, a2 = b2 ? a2 + "-" + d2(b2) : d2(a2), goog.global.CLOSURE_CSS_NAME_MAP_FN ? goog.global.CLOSURE_CSS_NAME_MAP_FN(a2) : a2;
          }, goog.setCssNameMapping = function(a2, b2) {
            goog.cssNameMapping_ = a2, goog.cssNameMappingStyle_ = b2;
          }, !COMPILED && goog.global.CLOSURE_CSS_NAME_MAPPING && (goog.cssNameMapping_ = goog.global.CLOSURE_CSS_NAME_MAPPING), goog.getMsg = function(a2, b2, c$12) {
            return c$12 && c$12.html && (a2 = a2.replace(/</g, "&lt;")), c$12 && c$12.unescapeHtmlEntities && (a2 = a2.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&apos;/g, "'").replace(/&quot;/g, '"').replace(/&amp;/g, "&")), b2 && (a2 = a2.replace(/\{\$([^}]+)}/g, function(d2, e2) {
              return b2 != null && e2 in b2 ? b2[e2] : d2;
            })), a2;
          }, goog.getMsgWithFallback = function(a2, b2) {
            return a2;
          }, goog.exportSymbol = function(a2, b2, c$12) {
            goog.exportPath_(a2, b2, true, c$12);
          }, goog.exportProperty = function(a2, b2, c$12) {
            a2[b2] = c$12;
          }, goog.inherits = function(a2, b2) {
            function c$12() {
            }
            c$12.prototype = b2.prototype, a2.superClass_ = b2.prototype, a2.prototype = new c$12(), a2.prototype.constructor = a2, a2.base = function(d2, e2, f2) {
              for (var g2 = Array(arguments.length - 2), h = 2; h < arguments.length; h++) g2[h - 2] = arguments[h];
              return b2.prototype[e2].apply(d2, g2);
            };
          }, goog.scope = function(a2) {
            if (goog.isInModuleLoader_()) throw Error("goog.scope is not supported within a module.");
            a2.call(goog.global);
          }, COMPILED || (goog.global.COMPILED = COMPILED), goog.defineClass = function(a2, b2) {
            var c$12 = b2.constructor, d2 = b2.statics;
            return c$12 && c$12 != Object.prototype.constructor || (c$12 = function() {
              throw Error("cannot instantiate an interface (no constructor defined).");
            }), c$12 = goog.defineClass.createSealingConstructor_(c$12, a2), a2 && goog.inherits(c$12, a2), delete b2.constructor, delete b2.statics, goog.defineClass.applyProperties_(c$12.prototype, b2), d2 != null && (d2 instanceof Function ? d2(c$12) : goog.defineClass.applyProperties_(c$12, d2)), c$12;
          }, goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG, goog.defineClass.createSealingConstructor_ = function(a2, b2) {
            return goog.defineClass.SEAL_CLASS_INSTANCES ? function() {
              var c$12 = a2.apply(this, arguments) || this;
              return c$12[goog.UID_PROPERTY_] = c$12[goog.UID_PROPERTY_], c$12;
            } : a2;
          }, goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "), goog.defineClass.applyProperties_ = function(a2, b2) {
            for (var c$12 in b2) Object.prototype.hasOwnProperty.call(b2, c$12) && (a2[c$12] = b2[c$12]);
            for (var d2 = 0; d2 < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length; d2++) c$12 = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[d2], Object.prototype.hasOwnProperty.call(b2, c$12) && (a2[c$12] = b2[c$12]);
          }, !COMPILED && goog.DEPENDENCIES_ENABLED && (goog.inHtmlDocument_ = function() {
            var a2 = goog.global.document;
            return a2 != null && "write" in a2;
          }, goog.isDocumentLoading_ = function() {
            var a2 = goog.global.document;
            return a2.attachEvent ? a2.readyState != "complete" : a2.readyState == "loading";
          }, goog.findBasePath_ = function() {
            if (goog.global.CLOSURE_BASE_PATH != null && typeof goog.global.CLOSURE_BASE_PATH == "string") goog.basePath = goog.global.CLOSURE_BASE_PATH;
            else if (goog.inHtmlDocument_()) {
              var a2 = goog.global.document, b2 = a2.currentScript;
              for (a2 = b2 ? [b2] : a2.getElementsByTagName("SCRIPT"), b2 = a2.length - 1; 0 <= b2; --b2) {
                var c$12 = a2[b2].src, d2 = c$12.lastIndexOf("?");
                if (d2 = d2 == -1 ? c$12.length : d2, c$12.substr(d2 - 7, 7) == "base.js") {
                  goog.basePath = c$12.substr(0, d2 - 7);
                  break;
                }
              }
            }
          }, goog.findBasePath_(), goog.Transpiler = function() {
            this.requiresTranspilation_ = null, this.transpilationTarget_ = goog.TRANSPILE_TO_LANGUAGE;
          }, goog.Transpiler.prototype.createRequiresTranspilation_ = function() {
            function a(g2, h) {
              e ? d[g2] = true : h() ? (c$1 = g2, d[g2] = false) : e = d[g2] = true;
            }
            function b(g) {
              try {
                return !!eval(g);
              } catch {
                return false;
              }
            }
            var c$1 = "es3", d = { es3: false }, e = false, f = goog.global.navigator && goog.global.navigator.userAgent ? goog.global.navigator.userAgent : "";
            return a("es5", function() {
              return b("[1,].length==1");
            }), a("es6", function() {
              return f.match(/Edge\/(\d+)(\.\d)*/i) ? false : b('(()=>{"use strict";class X{constructor(){if(new.target!=String)throw 1;this.x=42}}let q=Reflect.construct(X,[],String);if(q.x!=42||!(q instanceof String))throw 1;for(const a of[2,3]){if(a==2)continue;function f(z={a}){let a=0;return z.a}{function f(){return 0;}}return f()==3}})()');
            }), a("es7", function() {
              return b("2 ** 2 == 4");
            }), a("es8", function() {
              return b("async () => 1, true");
            }), a("es9", function() {
              return b("({...rest} = {}), true");
            }), a("es_next", function() {
              return false;
            }), {
              target: c$1,
              map: d
            };
          }, goog.Transpiler.prototype.needsTranspile = function(a2, b2) {
            if (goog.TRANSPILE == "always") return true;
            if (goog.TRANSPILE == "never") return false;
            if (!this.requiresTranspilation_) {
              var c$12 = this.createRequiresTranspilation_();
              this.requiresTranspilation_ = c$12.map, this.transpilationTarget_ = this.transpilationTarget_ || c$12.target;
            }
            if (a2 in this.requiresTranspilation_) return this.requiresTranspilation_[a2] ? true : !(!goog.inHtmlDocument_() || b2 != "es6" || "noModule" in goog.global.document.createElement("script"));
            throw Error("Unknown language mode: " + a2);
          }, goog.Transpiler.prototype.transpile = function(a2, b2) {
            return goog.transpile_(a2, b2, this.transpilationTarget_);
          }, goog.transpiler_ = new goog.Transpiler(), goog.protectScriptTag_ = function(a2) {
            return a2.replace(/<\/(SCRIPT)/gi, "\\x3c/$1");
          }, goog.DebugLoader_ = function() {
            this.dependencies_ = {}, this.idToPath_ = {}, this.written_ = {}, this.loadingDeps_ = [], this.depsToLoad_ = [], this.paused_ = false, this.factory_ = new goog.DependencyFactory(goog.transpiler_), this.deferredCallbacks_ = {}, this.deferredQueue_ = [];
          }, goog.DebugLoader_.prototype.bootstrap = function(a2, b2) {
            function c$12() {
              d2 &&= (goog.global.setTimeout(d2, 0), null);
            }
            var d2 = b2;
            if (a2.length) {
              b2 = [];
              for (var e2 = 0; e2 < a2.length; e2++) {
                var f2 = this.getPathFromDeps_(a2[e2]);
                if (!f2) throw Error("Unregonized namespace: " + a2[e2]);
                b2.push(this.dependencies_[f2]);
              }
              f2 = goog.require;
              var g2 = 0;
              for (e2 = 0; e2 < a2.length; e2++) f2(a2[e2]), b2[e2].onLoad(function() {
                ++g2 == a2.length && c$12();
              });
            } else c$12();
          }, goog.DebugLoader_.prototype.loadClosureDeps = function() {
            this.depsToLoad_.push(this.factory_.createDependency(goog.normalizePath_(goog.basePath + "deps.js"), "deps.js", [], [], {}, false)), this.loadDeps_();
          }, goog.DebugLoader_.prototype.requested = function(a2, b2) {
            (a2 = this.getPathFromDeps_(a2)) && (b2 || this.areDepsLoaded_(this.dependencies_[a2].requires)) && (b2 = this.deferredCallbacks_[a2]) && (delete this.deferredCallbacks_[a2], b2());
          }, goog.DebugLoader_.prototype.setDependencyFactory = function(a2) {
            this.factory_ = a2;
          }, goog.DebugLoader_.prototype.load_ = function(a2) {
            if (this.getPathFromDeps_(a2)) {
              var b2 = this, c$12 = [], d2 = function(e2) {
                var f2 = b2.getPathFromDeps_(e2);
                if (!f2) throw Error("Bad dependency path or symbol: " + e2);
                if (!b2.written_[f2]) {
                  for (b2.written_[f2] = true, e2 = b2.dependencies_[f2], f2 = 0; f2 < e2.requires.length; f2++) goog.isProvided_(e2.requires[f2]) || d2(e2.requires[f2]);
                  c$12.push(e2);
                }
              };
              d2(a2), a2 = !!this.depsToLoad_.length, this.depsToLoad_ = this.depsToLoad_.concat(c$12), this.paused_ || a2 || this.loadDeps_();
            } else throw a2 = "goog.require could not find: " + a2, goog.logToConsole_(a2), Error(a2);
          }, goog.DebugLoader_.prototype.loadDeps_ = function() {
            for (var a2 = this, b2 = this.paused_; this.depsToLoad_.length && !b2; ) (function() {
              var c$12 = false, d2 = a2.depsToLoad_.shift(), e2 = false;
              a2.loading_(d2);
              var f2 = {
                pause: function() {
                  if (c$12) throw Error("Cannot call pause after the call to load.");
                  b2 = true;
                },
                resume: function() {
                  c$12 ? a2.resume_() : b2 = false;
                },
                loaded: function() {
                  if (e2) throw Error("Double call to loaded.");
                  e2 = true, a2.loaded_(d2);
                },
                pending: function() {
                  for (var g2 = [], h = 0; h < a2.loadingDeps_.length; h++) g2.push(a2.loadingDeps_[h]);
                  return g2;
                },
                setModuleState: function(g2) {
                  goog.moduleLoaderState_ = {
                    type: g2,
                    moduleName: "",
                    declareLegacyNamespace: false
                  };
                },
                registerEs6ModuleExports: function(g2, h, k) {
                  k && (goog.loadedModules_[k] = {
                    exports: h,
                    type: goog.ModuleType.ES6,
                    moduleId: k || ""
                  });
                },
                registerGoogModuleExports: function(g2, h) {
                  goog.loadedModules_[g2] = {
                    exports: h,
                    type: goog.ModuleType.GOOG,
                    moduleId: g2
                  };
                },
                clearModuleState: function() {
                  goog.moduleLoaderState_ = null;
                },
                defer: function(g2) {
                  if (c$12) throw Error("Cannot register with defer after the call to load.");
                  a2.defer_(d2, g2);
                },
                areDepsLoaded: function() {
                  return a2.areDepsLoaded_(d2.requires);
                }
              };
              try {
                d2.load(f2);
              } finally {
                c$12 = true;
              }
            })();
            b2 && this.pause_();
          }, goog.DebugLoader_.prototype.pause_ = function() {
            this.paused_ = true;
          }, goog.DebugLoader_.prototype.resume_ = function() {
            this.paused_ && (this.paused_ = false, this.loadDeps_());
          }, goog.DebugLoader_.prototype.loading_ = function(a2) {
            this.loadingDeps_.push(a2);
          }, goog.DebugLoader_.prototype.loaded_ = function(a2) {
            for (var b2 = 0; b2 < this.loadingDeps_.length; b2++) if (this.loadingDeps_[b2] == a2) {
              this.loadingDeps_.splice(b2, 1);
              break;
            }
            for (b2 = 0; b2 < this.deferredQueue_.length; b2++) if (this.deferredQueue_[b2] == a2.path) {
              this.deferredQueue_.splice(b2, 1);
              break;
            }
            if (this.loadingDeps_.length == this.deferredQueue_.length && !this.depsToLoad_.length) for (; this.deferredQueue_.length; ) this.requested(this.deferredQueue_.shift(), true);
            a2.loaded();
          }, goog.DebugLoader_.prototype.areDepsLoaded_ = function(a2) {
            for (var b2 = 0; b2 < a2.length; b2++) {
              var c$12 = this.getPathFromDeps_(a2[b2]);
              if (!c$12 || !(c$12 in this.deferredCallbacks_ || goog.isProvided_(a2[b2]))) return false;
            }
            return true;
          }, goog.DebugLoader_.prototype.getPathFromDeps_ = function(a2) {
            return a2 in this.idToPath_ ? this.idToPath_[a2] : a2 in this.dependencies_ ? a2 : null;
          }, goog.DebugLoader_.prototype.defer_ = function(a2, b2) {
            this.deferredCallbacks_[a2.path] = b2, this.deferredQueue_.push(a2.path);
          }, goog.LoadController = function() {
          }, goog.LoadController.prototype.pause = function() {
          }, goog.LoadController.prototype.resume = function() {
          }, goog.LoadController.prototype.loaded = function() {
          }, goog.LoadController.prototype.pending = function() {
          }, goog.LoadController.prototype.registerEs6ModuleExports = function(a2, b2, c$12) {
          }, goog.LoadController.prototype.setModuleState = function(a2) {
          }, goog.LoadController.prototype.clearModuleState = function() {
          }, goog.LoadController.prototype.defer = function(a2) {
          }, goog.LoadController.prototype.areDepsLoaded = function() {
          }, goog.Dependency = function(a2, b2, c$12, d2, e2) {
            this.path = a2, this.relativePath = b2, this.provides = c$12, this.requires = d2, this.loadFlags = e2, this.loaded_ = false, this.loadCallbacks_ = [];
          }, goog.Dependency.prototype.getPathName = function() {
            var a2 = this.path, b2 = a2.indexOf("://");
            return 0 <= b2 && (a2 = a2.substring(b2 + 3), b2 = a2.indexOf("/"), 0 <= b2 && (a2 = a2.substring(b2 + 1))), a2;
          }, goog.Dependency.prototype.onLoad = function(a2) {
            this.loaded_ ? a2() : this.loadCallbacks_.push(a2);
          }, goog.Dependency.prototype.loaded = function() {
            this.loaded_ = true;
            var a2 = this.loadCallbacks_;
            this.loadCallbacks_ = [];
            for (var b2 = 0; b2 < a2.length; b2++) a2[b2]();
          }, goog.Dependency.defer_ = false, goog.Dependency.callbackMap_ = {}, goog.Dependency.registerCallback_ = function(a2) {
            var b2 = Math.random().toString(32);
            return goog.Dependency.callbackMap_[b2] = a2, b2;
          }, goog.Dependency.unregisterCallback_ = function(a2) {
            delete goog.Dependency.callbackMap_[a2];
          }, goog.Dependency.callback_ = function(a2, b2) {
            if (a2 in goog.Dependency.callbackMap_) {
              for (var c$12 = goog.Dependency.callbackMap_[a2], d2 = [], e2 = 1; e2 < arguments.length; e2++) d2.push(arguments[e2]);
              c$12.apply(void 0, d2);
            } else throw Error("Callback key " + a2 + " does not exist (was base.js loaded more than once?).");
          }, goog.Dependency.prototype.load = function(a2) {
            if (goog.global.CLOSURE_IMPORT_SCRIPT) goog.global.CLOSURE_IMPORT_SCRIPT(this.path) ? a2.loaded() : a2.pause();
            else if (goog.inHtmlDocument_()) {
              var b2 = goog.global.document;
              if (b2.readyState == "complete" && !goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING) {
                if (/\bdeps.js$/.test(this.path)) {
                  a2.loaded();
                  return;
                }
                throw Error('Cannot write "' + this.path + '" after document load');
              }
              var c$12 = goog.getScriptNonce();
              if (!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING && goog.isDocumentLoading_()) {
                var d2 = function(h) {
                  h.readyState && h.readyState != "complete" ? h.onload = d2 : (goog.Dependency.unregisterCallback_(e2), a2.loaded());
                }, e2 = goog.Dependency.registerCallback_(d2);
                c$12 = c$12 ? ' nonce="' + c$12 + '"' : "";
                var f2 = '<script src="' + this.path + '"' + c$12 + (goog.Dependency.defer_ ? " defer" : "") + ' id="script-' + e2 + '"><\/script>';
                f2 += "<script" + c$12 + ">", f2 = goog.Dependency.defer_ ? f2 + ("document.getElementById('script-" + e2 + "').onload = function() {\n  goog.Dependency.callback_('" + e2 + "', this);\n};\n") : f2 + ("goog.Dependency.callback_('" + e2 + "', document.getElementById('script-" + e2 + "'));"), f2 += "<\/script>", b2.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(f2) : f2);
              } else {
                var g2 = b2.createElement("script");
                g2.defer = goog.Dependency.defer_, g2.async = false, c$12 && (g2.nonce = c$12), goog.DebugLoader_.IS_OLD_IE_ ? (a2.pause(), g2.onreadystatechange = function() {
                  (g2.readyState == "loaded" || g2.readyState == "complete") && (a2.loaded(), a2.resume());
                }) : g2.onload = function() {
                  g2.onload = null, a2.loaded();
                }, g2.src = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScriptURL(this.path) : this.path, b2.head.appendChild(g2);
              }
            } else goog.logToConsole_("Cannot use default debug loader outside of HTML documents."), this.relativePath == "deps.js" ? (goog.logToConsole_("Consider setting CLOSURE_IMPORT_SCRIPT before loading base.js, or setting CLOSURE_NO_DEPS to true."), a2.loaded()) : a2.pause();
          }, goog.Es6ModuleDependency = function(a2, b2, c$12, d2, e2) {
            goog.Dependency.call(this, a2, b2, c$12, d2, e2);
          }, goog.inherits(goog.Es6ModuleDependency, goog.Dependency), goog.Es6ModuleDependency.prototype.load = function(a2) {
            function b2(l$12, p) {
              var m = "", n$12 = goog.getScriptNonce();
              n$12 && (m = ' nonce="' + n$12 + '"'), l$12 = p ? '<script type="module" crossorigin' + m + ">" + p + "<\/script>" : '<script type="module" crossorigin src="' + l$12 + '"' + m + "><\/script>", d2.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(l$12) : l$12);
            }
            function c$12(l$12, p) {
              var m = d2.createElement("script");
              m.defer = true, m.async = false, m.type = "module", m.setAttribute("crossorigin", true);
              var n$12 = goog.getScriptNonce();
              n$12 && (m.nonce = n$12), p ? m.text = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScript(p) : p : m.src = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScriptURL(l$12) : l$12, d2.head.appendChild(m);
            }
            if (goog.global.CLOSURE_IMPORT_SCRIPT) goog.global.CLOSURE_IMPORT_SCRIPT(this.path) ? a2.loaded() : a2.pause();
            else if (goog.inHtmlDocument_()) {
              var d2 = goog.global.document, e2 = this;
              if (goog.isDocumentLoading_()) {
                var f2 = b2;
                goog.Dependency.defer_ = true;
              } else f2 = c$12;
              var g2 = goog.Dependency.registerCallback_(function() {
                goog.Dependency.unregisterCallback_(g2), a2.setModuleState(goog.ModuleType.ES6);
              });
              f2(void 0, 'goog.Dependency.callback_("' + g2 + '")'), f2(this.path, void 0);
              var h = goog.Dependency.registerCallback_(function(l$12) {
                goog.Dependency.unregisterCallback_(h), a2.registerEs6ModuleExports(e2.path, l$12, goog.moduleLoaderState_.moduleName);
              });
              f2(void 0, 'import * as m from "' + this.path + '"; goog.Dependency.callback_("' + h + '", m)');
              var k = goog.Dependency.registerCallback_(function() {
                goog.Dependency.unregisterCallback_(k), a2.clearModuleState(), a2.loaded();
              });
              f2(void 0, 'goog.Dependency.callback_("' + k + '")');
            } else goog.logToConsole_("Cannot use default debug loader outside of HTML documents."), a2.pause();
          }, goog.TransformedDependency = function(a2, b2, c$12, d2, e2) {
            goog.Dependency.call(this, a2, b2, c$12, d2, e2), this.contents_ = null, this.lazyFetch_ = !goog.inHtmlDocument_() || !("noModule" in goog.global.document.createElement("script"));
          }, goog.inherits(goog.TransformedDependency, goog.Dependency), goog.TransformedDependency.prototype.load = function(a2) {
            function b2() {
              e2.contents_ = goog.loadFileSync_(e2.path), e2.contents_ && (e2.contents_ = e2.transform(e2.contents_), e2.contents_ && (e2.contents_ += "\n//# sourceURL=" + e2.path));
            }
            function c$12() {
              if (e2.lazyFetch_ && b2(), e2.contents_) {
                f2 && a2.setModuleState(goog.ModuleType.ES6);
                try {
                  var p = e2.contents_;
                  if (e2.contents_ = null, goog.globalEval(p), f2) var m = goog.moduleLoaderState_.moduleName;
                } finally {
                  f2 && a2.clearModuleState();
                }
                f2 && goog.global.$jscomp.require.ensure([e2.getPathName()], function() {
                  a2.registerEs6ModuleExports(e2.path, goog.global.$jscomp.require(e2.getPathName()), m);
                }), a2.loaded();
              }
            }
            function d2() {
              var p = goog.global.document, m = goog.Dependency.registerCallback_(function() {
                goog.Dependency.unregisterCallback_(m), c$12();
              }), n$12 = goog.getScriptNonce();
              n$12 = "<script" + (n$12 ? ' nonce="' + n$12 + '"' : "") + ">" + goog.protectScriptTag_('goog.Dependency.callback_("' + m + '");') + "<\/script>", p.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(n$12) : n$12);
            }
            var e2 = this;
            if (goog.global.CLOSURE_IMPORT_SCRIPT) b2(), this.contents_ && goog.global.CLOSURE_IMPORT_SCRIPT("", this.contents_) ? (this.contents_ = null, a2.loaded()) : a2.pause();
            else {
              var f2 = this.loadFlags.module == goog.ModuleType.ES6;
              this.lazyFetch_ || b2();
              var g2 = 1 < a2.pending().length, h = g2 && goog.DebugLoader_.IS_OLD_IE_;
              if (g2 = goog.Dependency.defer_ && (g2 || goog.isDocumentLoading_()), h || g2) a2.defer(function() {
                c$12();
              });
              else {
                var k = goog.global.document;
                if (h = goog.inHtmlDocument_() && "ActiveXObject" in goog.global, f2 && goog.inHtmlDocument_() && goog.isDocumentLoading_() && !h) {
                  goog.Dependency.defer_ = true, a2.pause();
                  var l$12 = k.onreadystatechange;
                  k.onreadystatechange = function() {
                    k.readyState == "interactive" && (k.onreadystatechange = l$12, c$12(), a2.resume()), typeof l$12 == "function" && l$12.apply(void 0, arguments);
                  };
                } else !goog.DebugLoader_.IS_OLD_IE_ && goog.inHtmlDocument_() && goog.isDocumentLoading_() ? d2() : c$12();
              }
            }
          }, goog.TransformedDependency.prototype.transform = function(a2) {
          }, goog.TranspiledDependency = function(a2, b2, c$12, d2, e2, f2) {
            goog.TransformedDependency.call(this, a2, b2, c$12, d2, e2), this.transpiler = f2;
          }, goog.inherits(goog.TranspiledDependency, goog.TransformedDependency), goog.TranspiledDependency.prototype.transform = function(a2) {
            return this.transpiler.transpile(a2, this.getPathName());
          }, goog.PreTranspiledEs6ModuleDependency = function(a2, b2, c$12, d2, e2) {
            goog.TransformedDependency.call(this, a2, b2, c$12, d2, e2);
          }, goog.inherits(goog.PreTranspiledEs6ModuleDependency, goog.TransformedDependency), goog.PreTranspiledEs6ModuleDependency.prototype.transform = function(a2) {
            return a2;
          }, goog.GoogModuleDependency = function(a2, b2, c$12, d2, e2, f2, g2) {
            goog.TransformedDependency.call(this, a2, b2, c$12, d2, e2), this.needsTranspile_ = f2, this.transpiler_ = g2;
          }, goog.inherits(goog.GoogModuleDependency, goog.TransformedDependency), goog.GoogModuleDependency.prototype.transform = function(a2) {
            return this.needsTranspile_ && (a2 = this.transpiler_.transpile(a2, this.getPathName())), goog.LOAD_MODULE_USING_EVAL && goog.global.JSON !== void 0 ? "goog.loadModule(" + goog.global.JSON.stringify(a2 + "\n//# sourceURL=" + this.path + "\n") + ");" : 'goog.loadModule(function(exports) {"use strict";' + a2 + "\n;return exports});\n//# sourceURL=" + this.path + "\n";
          }, goog.DebugLoader_.IS_OLD_IE_ = !(goog.global.atob || !goog.global.document || !goog.global.document.all), goog.DebugLoader_.prototype.addDependency = function(a2, b2, c$12, d2) {
            b2 ||= [], a2 = a2.replace(/\\/g, "/");
            var e2 = goog.normalizePath_(goog.basePath + a2);
            for (d2 && typeof d2 != "boolean" || (d2 = d2 ? { module: goog.ModuleType.GOOG } : {}), c$12 = this.factory_.createDependency(e2, a2, b2, c$12, d2, goog.transpiler_.needsTranspile(d2.lang || "es3", d2.module)), this.dependencies_[e2] = c$12, c$12 = 0; c$12 < b2.length; c$12++) this.idToPath_[b2[c$12]] = e2;
            this.idToPath_[a2] = e2;
          }, goog.DependencyFactory = function(a2) {
            this.transpiler = a2;
          }, goog.DependencyFactory.prototype.createDependency = function(a2, b2, c$12, d2, e2, f2) {
            return e2.module == goog.ModuleType.GOOG ? new goog.GoogModuleDependency(a2, b2, c$12, d2, e2, f2, this.transpiler) : f2 ? new goog.TranspiledDependency(a2, b2, c$12, d2, e2, this.transpiler) : e2.module == goog.ModuleType.ES6 ? goog.TRANSPILE == "never" && goog.ASSUME_ES_MODULES_TRANSPILED ? new goog.PreTranspiledEs6ModuleDependency(a2, b2, c$12, d2, e2) : new goog.Es6ModuleDependency(a2, b2, c$12, d2, e2) : new goog.Dependency(a2, b2, c$12, d2, e2);
          }, goog.debugLoader_ = new goog.DebugLoader_(), goog.loadClosureDeps = function() {
            goog.debugLoader_.loadClosureDeps();
          }, goog.setDependencyFactory = function(a2) {
            goog.debugLoader_.setDependencyFactory(a2);
          }, goog.TRUSTED_TYPES_POLICY_ = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#base") : null, goog.global.CLOSURE_NO_DEPS || goog.debugLoader_.loadClosureDeps(), goog.bootstrap = function(a2, b2) {
            goog.debugLoader_.bootstrap(a2, b2);
          }), goog.TRUSTED_TYPES_POLICY_NAME = "goog", goog.identity_ = function(a2) {
            return a2;
          }, goog.createTrustedTypesPolicy = function(a2) {
            var b2 = null, c$12 = goog.global.trustedTypes;
            if (!c$12 || !c$12.createPolicy) return b2;
            try {
              b2 = c$12.createPolicy(a2, {
                createHTML: goog.identity_,
                createScript: goog.identity_,
                createScriptURL: goog.identity_
              });
            } catch (d2) {
              goog.logToConsole_(d2.message);
            }
            return b2;
          }, goog.debug = {};
          function module$contents$goog$debug$Error_DebugError(a2) {
            if (Error.captureStackTrace) Error.captureStackTrace(this, module$contents$goog$debug$Error_DebugError);
            else {
              var b2 = Error().stack;
              b2 && (this.stack = b2);
            }
            a2 && (this.message = String(a2)), this.reportErrorToServer = true;
          }
          goog.inherits(module$contents$goog$debug$Error_DebugError, Error), module$contents$goog$debug$Error_DebugError.prototype.name = "CustomError", goog.debug.Error = module$contents$goog$debug$Error_DebugError, goog.dom = {}, goog.dom.NodeType = {
            ELEMENT: 1,
            ATTRIBUTE: 2,
            TEXT: 3,
            CDATA_SECTION: 4,
            ENTITY_REFERENCE: 5,
            ENTITY: 6,
            PROCESSING_INSTRUCTION: 7,
            COMMENT: 8,
            DOCUMENT: 9,
            DOCUMENT_TYPE: 10,
            DOCUMENT_FRAGMENT: 11,
            NOTATION: 12
          }, goog.asserts = {}, goog.asserts.ENABLE_ASSERTS = goog.DEBUG, goog.asserts.AssertionError = function(a2, b2) {
            module$contents$goog$debug$Error_DebugError.call(this, goog.asserts.subs_(a2, b2)), this.messagePattern = a2;
          }, goog.inherits(goog.asserts.AssertionError, module$contents$goog$debug$Error_DebugError), goog.asserts.AssertionError.prototype.name = "AssertionError", goog.asserts.DEFAULT_ERROR_HANDLER = function(a2) {
            throw a2;
          }, goog.asserts.errorHandler_ = goog.asserts.DEFAULT_ERROR_HANDLER, goog.asserts.subs_ = function(a2, b2) {
            a2 = a2.split("%s");
            for (var c$12 = "", d2 = a2.length - 1, e2 = 0; e2 < d2; e2++) c$12 += a2[e2] + (e2 < b2.length ? b2[e2] : "%s");
            return c$12 + a2[d2];
          }, goog.asserts.doAssertFailure_ = function(a2, b2, c$12, d2) {
            var e2 = "Assertion failed";
            if (c$12) {
              e2 += ": " + c$12;
              var f2 = d2;
            } else a2 && (e2 += ": " + a2, f2 = b2);
            a2 = new goog.asserts.AssertionError("" + e2, f2 || []), goog.asserts.errorHandler_(a2);
          }, goog.asserts.setErrorHandler = function(a2) {
            goog.asserts.ENABLE_ASSERTS && (goog.asserts.errorHandler_ = a2);
          }, goog.asserts.assert = function(a2, b2, c$12) {
            return goog.asserts.ENABLE_ASSERTS && !a2 && goog.asserts.doAssertFailure_("", null, b2, Array.prototype.slice.call(arguments, 2)), a2;
          }, goog.asserts.assertExists = function(a2, b2, c$12) {
            return goog.asserts.ENABLE_ASSERTS && a2 == null && goog.asserts.doAssertFailure_("Expected to exist: %s.", [a2], b2, Array.prototype.slice.call(arguments, 2)), a2;
          }, goog.asserts.fail = function(a2, b2) {
            goog.asserts.ENABLE_ASSERTS && goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure" + (a2 ? ": " + a2 : ""), Array.prototype.slice.call(arguments, 1)));
          }, goog.asserts.assertNumber = function(a2, b2, c$12) {
            return goog.asserts.ENABLE_ASSERTS && typeof a2 != "number" && goog.asserts.doAssertFailure_("Expected number but got %s: %s.", [goog.typeOf(a2), a2], b2, Array.prototype.slice.call(arguments, 2)), a2;
          }, goog.asserts.assertString = function(a2, b2, c$12) {
            return goog.asserts.ENABLE_ASSERTS && typeof a2 != "string" && goog.asserts.doAssertFailure_("Expected string but got %s: %s.", [goog.typeOf(a2), a2], b2, Array.prototype.slice.call(arguments, 2)), a2;
          }, goog.asserts.assertFunction = function(a2, b2, c$12) {
            return goog.asserts.ENABLE_ASSERTS && typeof a2 != "function" && goog.asserts.doAssertFailure_("Expected function but got %s: %s.", [goog.typeOf(a2), a2], b2, Array.prototype.slice.call(arguments, 2)), a2;
          }, goog.asserts.assertObject = function(a2, b2, c$12) {
            return goog.asserts.ENABLE_ASSERTS && !goog.isObject(a2) && goog.asserts.doAssertFailure_("Expected object but got %s: %s.", [goog.typeOf(a2), a2], b2, Array.prototype.slice.call(arguments, 2)), a2;
          }, goog.asserts.assertArray = function(a2, b2, c$12) {
            return goog.asserts.ENABLE_ASSERTS && !Array.isArray(a2) && goog.asserts.doAssertFailure_("Expected array but got %s: %s.", [goog.typeOf(a2), a2], b2, Array.prototype.slice.call(arguments, 2)), a2;
          }, goog.asserts.assertBoolean = function(a2, b2, c$12) {
            return goog.asserts.ENABLE_ASSERTS && typeof a2 != "boolean" && goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.", [goog.typeOf(a2), a2], b2, Array.prototype.slice.call(arguments, 2)), a2;
          }, goog.asserts.assertElement = function(a2, b2, c$12) {
            return !goog.asserts.ENABLE_ASSERTS || goog.isObject(a2) && a2.nodeType == goog.dom.NodeType.ELEMENT || goog.asserts.doAssertFailure_("Expected Element but got %s: %s.", [goog.typeOf(a2), a2], b2, Array.prototype.slice.call(arguments, 2)), a2;
          }, goog.asserts.assertInstanceof = function(a2, b2, c$12, d2) {
            return !goog.asserts.ENABLE_ASSERTS || a2 instanceof b2 || goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.", [goog.asserts.getType_(b2), goog.asserts.getType_(a2)], c$12, Array.prototype.slice.call(arguments, 3)), a2;
          }, goog.asserts.assertFinite = function(a2, b2, c$12) {
            return !goog.asserts.ENABLE_ASSERTS || typeof a2 == "number" && isFinite(a2) || goog.asserts.doAssertFailure_("Expected %s to be a finite number but it is not.", [a2], b2, Array.prototype.slice.call(arguments, 2)), a2;
          }, goog.asserts.assertObjectPrototypeIsIntact = function() {
            for (var a2 in Object.prototype) goog.asserts.fail(a2 + " should not be enumerable in Object.prototype.");
          }, goog.asserts.getType_ = function(a2) {
            return a2 instanceof Function ? a2.displayName || a2.name || "unknown type name" : a2 instanceof Object ? a2.constructor.displayName || a2.constructor.name || Object.prototype.toString.call(a2) : a2 === null ? "null" : typeof a2;
          }, goog.array = {}, goog.NATIVE_ARRAY_PROTOTYPES = goog.TRUSTED_SITE;
          var module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS = 2012 < goog.FEATURESET_YEAR;
          goog.array.ASSUME_NATIVE_FUNCTIONS = module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS;
          function module$contents$goog$array_peek(a2) {
            return a2[a2.length - 1];
          }
          goog.array.peek = module$contents$goog$array_peek, goog.array.last = module$contents$goog$array_peek;
          var module$contents$goog$array_indexOf = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.indexOf) ? function(a2, b2, c$12) {
            return goog.asserts.assert(a2.length != null), Array.prototype.indexOf.call(a2, b2, c$12);
          } : function(a2, b2, c$12) {
            if (c$12 = c$12 == null ? 0 : 0 > c$12 ? Math.max(0, a2.length + c$12) : c$12, typeof a2 == "string") return typeof b2 != "string" || b2.length != 1 ? -1 : a2.indexOf(b2, c$12);
            for (; c$12 < a2.length; c$12++) if (c$12 in a2 && a2[c$12] === b2) return c$12;
            return -1;
          };
          goog.array.indexOf = module$contents$goog$array_indexOf;
          var module$contents$goog$array_lastIndexOf = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.lastIndexOf) ? function(a2, b2, c$12) {
            return goog.asserts.assert(a2.length != null), Array.prototype.lastIndexOf.call(a2, b2, c$12 ?? a2.length - 1);
          } : function(a2, b2, c$12) {
            if (c$12 ??= a2.length - 1, 0 > c$12 && (c$12 = Math.max(0, a2.length + c$12)), typeof a2 == "string") return typeof b2 != "string" || b2.length != 1 ? -1 : a2.lastIndexOf(b2, c$12);
            for (; 0 <= c$12; c$12--) if (c$12 in a2 && a2[c$12] === b2) return c$12;
            return -1;
          };
          goog.array.lastIndexOf = module$contents$goog$array_lastIndexOf;
          var module$contents$goog$array_forEach = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.forEach) ? function(a2, b2, c$12) {
            goog.asserts.assert(a2.length != null), Array.prototype.forEach.call(a2, b2, c$12);
          } : function(a2, b2, c$12) {
            for (var d2 = a2.length, e2 = typeof a2 == "string" ? a2.split("") : a2, f2 = 0; f2 < d2; f2++) f2 in e2 && b2.call(c$12, e2[f2], f2, a2);
          };
          goog.array.forEach = module$contents$goog$array_forEach;
          function module$contents$goog$array_forEachRight(a2, b2, c$12) {
            var d2 = a2.length, e2 = typeof a2 == "string" ? a2.split("") : a2;
            for (--d2; 0 <= d2; --d2) d2 in e2 && b2.call(c$12, e2[d2], d2, a2);
          }
          goog.array.forEachRight = module$contents$goog$array_forEachRight;
          var module$contents$goog$array_filter = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.filter) ? function(a2, b2, c$12) {
            return goog.asserts.assert(a2.length != null), Array.prototype.filter.call(a2, b2, c$12);
          } : function(a2, b2, c$12) {
            for (var d2 = a2.length, e2 = [], f2 = 0, g2 = typeof a2 == "string" ? a2.split("") : a2, h = 0; h < d2; h++) if (h in g2) {
              var k = g2[h];
              b2.call(c$12, k, h, a2) && (e2[f2++] = k);
            }
            return e2;
          };
          goog.array.filter = module$contents$goog$array_filter;
          var module$contents$goog$array_map = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.map) ? function(a2, b2, c$12) {
            return goog.asserts.assert(a2.length != null), Array.prototype.map.call(a2, b2, c$12);
          } : function(a2, b2, c$12) {
            for (var d2 = a2.length, e2 = Array(d2), f2 = typeof a2 == "string" ? a2.split("") : a2, g2 = 0; g2 < d2; g2++) g2 in f2 && (e2[g2] = b2.call(c$12, f2[g2], g2, a2));
            return e2;
          };
          goog.array.map = module$contents$goog$array_map;
          var module$contents$goog$array_reduce = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduce) ? function(a2, b2, c$12, d2) {
            return goog.asserts.assert(a2.length != null), d2 && (b2 = goog.bind(b2, d2)), Array.prototype.reduce.call(a2, b2, c$12);
          } : function(a2, b2, c$12, d2) {
            var e2 = c$12;
            return module$contents$goog$array_forEach(a2, function(f2, g2) {
              e2 = b2.call(d2, e2, f2, g2, a2);
            }), e2;
          };
          goog.array.reduce = module$contents$goog$array_reduce;
          var module$contents$goog$array_reduceRight = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduceRight) ? function(a2, b2, c$12, d2) {
            return goog.asserts.assert(a2.length != null), goog.asserts.assert(b2 != null), d2 && (b2 = goog.bind(b2, d2)), Array.prototype.reduceRight.call(a2, b2, c$12);
          } : function(a2, b2, c$12, d2) {
            var e2 = c$12;
            return module$contents$goog$array_forEachRight(a2, function(f2, g2) {
              e2 = b2.call(d2, e2, f2, g2, a2);
            }), e2;
          };
          goog.array.reduceRight = module$contents$goog$array_reduceRight;
          var module$contents$goog$array_some = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.some) ? function(a2, b2, c$12) {
            return goog.asserts.assert(a2.length != null), Array.prototype.some.call(a2, b2, c$12);
          } : function(a2, b2, c$12) {
            for (var d2 = a2.length, e2 = typeof a2 == "string" ? a2.split("") : a2, f2 = 0; f2 < d2; f2++) if (f2 in e2 && b2.call(c$12, e2[f2], f2, a2)) return true;
            return false;
          };
          goog.array.some = module$contents$goog$array_some;
          var module$contents$goog$array_every = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.every) ? function(a2, b2, c$12) {
            return goog.asserts.assert(a2.length != null), Array.prototype.every.call(a2, b2, c$12);
          } : function(a2, b2, c$12) {
            for (var d2 = a2.length, e2 = typeof a2 == "string" ? a2.split("") : a2, f2 = 0; f2 < d2; f2++) if (f2 in e2 && !b2.call(c$12, e2[f2], f2, a2)) return false;
            return true;
          };
          goog.array.every = module$contents$goog$array_every;
          function module$contents$goog$array_count(a2, b2, c$12) {
            var d2 = 0;
            return module$contents$goog$array_forEach(a2, function(e2, f2, g2) {
              b2.call(c$12, e2, f2, g2) && ++d2;
            }, c$12), d2;
          }
          goog.array.count = module$contents$goog$array_count;
          function module$contents$goog$array_find(a2, b2, c$12) {
            return b2 = module$contents$goog$array_findIndex(a2, b2, c$12), 0 > b2 ? null : typeof a2 == "string" ? a2.charAt(b2) : a2[b2];
          }
          goog.array.find = module$contents$goog$array_find;
          function module$contents$goog$array_findIndex(a2, b2, c$12) {
            for (var d2 = a2.length, e2 = typeof a2 == "string" ? a2.split("") : a2, f2 = 0; f2 < d2; f2++) if (f2 in e2 && b2.call(c$12, e2[f2], f2, a2)) return f2;
            return -1;
          }
          goog.array.findIndex = module$contents$goog$array_findIndex;
          function module$contents$goog$array_findRight(a2, b2, c$12) {
            return b2 = module$contents$goog$array_findIndexRight(a2, b2, c$12), 0 > b2 ? null : typeof a2 == "string" ? a2.charAt(b2) : a2[b2];
          }
          goog.array.findRight = module$contents$goog$array_findRight;
          function module$contents$goog$array_findIndexRight(a2, b2, c$12) {
            var d2 = a2.length, e2 = typeof a2 == "string" ? a2.split("") : a2;
            for (--d2; 0 <= d2; d2--) if (d2 in e2 && b2.call(c$12, e2[d2], d2, a2)) return d2;
            return -1;
          }
          goog.array.findIndexRight = module$contents$goog$array_findIndexRight;
          function module$contents$goog$array_contains(a2, b2) {
            return 0 <= module$contents$goog$array_indexOf(a2, b2);
          }
          goog.array.contains = module$contents$goog$array_contains;
          function module$contents$goog$array_isEmpty(a2) {
            return a2.length == 0;
          }
          goog.array.isEmpty = module$contents$goog$array_isEmpty;
          function module$contents$goog$array_clear(a2) {
            if (!Array.isArray(a2)) for (var b2 = a2.length - 1; 0 <= b2; b2--) delete a2[b2];
            a2.length = 0;
          }
          goog.array.clear = module$contents$goog$array_clear;
          function module$contents$goog$array_insert(a2, b2) {
            module$contents$goog$array_contains(a2, b2) || a2.push(b2);
          }
          goog.array.insert = module$contents$goog$array_insert;
          function module$contents$goog$array_insertAt(a2, b2, c$12) {
            module$contents$goog$array_splice(a2, c$12, 0, b2);
          }
          goog.array.insertAt = module$contents$goog$array_insertAt;
          function module$contents$goog$array_insertArrayAt(a2, b2, c$12) {
            goog.partial(module$contents$goog$array_splice, a2, c$12, 0).apply(null, b2);
          }
          goog.array.insertArrayAt = module$contents$goog$array_insertArrayAt;
          function module$contents$goog$array_insertBefore(a2, b2, c$12) {
            var d2;
            arguments.length == 2 || 0 > (d2 = module$contents$goog$array_indexOf(a2, c$12)) ? a2.push(b2) : module$contents$goog$array_insertAt(a2, b2, d2);
          }
          goog.array.insertBefore = module$contents$goog$array_insertBefore;
          function module$contents$goog$array_remove(a2, b2) {
            b2 = module$contents$goog$array_indexOf(a2, b2);
            var c$12;
            return (c$12 = 0 <= b2) && module$contents$goog$array_removeAt(a2, b2), c$12;
          }
          goog.array.remove = module$contents$goog$array_remove;
          function module$contents$goog$array_removeLast(a2, b2) {
            return b2 = module$contents$goog$array_lastIndexOf(a2, b2), 0 <= b2 ? (module$contents$goog$array_removeAt(a2, b2), true) : false;
          }
          goog.array.removeLast = module$contents$goog$array_removeLast;
          function module$contents$goog$array_removeAt(a2, b2) {
            return goog.asserts.assert(a2.length != null), Array.prototype.splice.call(a2, b2, 1).length == 1;
          }
          goog.array.removeAt = module$contents$goog$array_removeAt;
          function module$contents$goog$array_removeIf(a2, b2, c$12) {
            return b2 = module$contents$goog$array_findIndex(a2, b2, c$12), 0 <= b2 ? (module$contents$goog$array_removeAt(a2, b2), true) : false;
          }
          goog.array.removeIf = module$contents$goog$array_removeIf;
          function module$contents$goog$array_removeAllIf(a2, b2, c$12) {
            var d2 = 0;
            return module$contents$goog$array_forEachRight(a2, function(e2, f2) {
              b2.call(c$12, e2, f2, a2) && module$contents$goog$array_removeAt(a2, f2) && d2++;
            }), d2;
          }
          goog.array.removeAllIf = module$contents$goog$array_removeAllIf;
          function module$contents$goog$array_concat(a2) {
            return Array.prototype.concat.apply([], arguments);
          }
          goog.array.concat = module$contents$goog$array_concat;
          function module$contents$goog$array_join(a2) {
            return Array.prototype.concat.apply([], arguments);
          }
          goog.array.join = module$contents$goog$array_join;
          function module$contents$goog$array_toArray(a2) {
            var b2 = a2.length;
            if (0 < b2) {
              for (var c$12 = Array(b2), d2 = 0; d2 < b2; d2++) c$12[d2] = a2[d2];
              return c$12;
            }
            return [];
          }
          var module$contents$goog$array_clone = goog.array.toArray = module$contents$goog$array_toArray;
          goog.array.clone = module$contents$goog$array_clone;
          function module$contents$goog$array_extend(a2, b2) {
            for (var c$12 = 1; c$12 < arguments.length; c$12++) {
              var d2 = arguments[c$12];
              if (goog.isArrayLike(d2)) {
                var e2 = a2.length || 0, f2 = d2.length || 0;
                a2.length = e2 + f2;
                for (var g2 = 0; g2 < f2; g2++) a2[e2 + g2] = d2[g2];
              } else a2.push(d2);
            }
          }
          goog.array.extend = module$contents$goog$array_extend;
          function module$contents$goog$array_splice(a2, b2, c$12, d2) {
            return goog.asserts.assert(a2.length != null), Array.prototype.splice.apply(a2, module$contents$goog$array_slice(arguments, 1));
          }
          goog.array.splice = module$contents$goog$array_splice;
          function module$contents$goog$array_slice(a2, b2, c$12) {
            return goog.asserts.assert(a2.length != null), 2 >= arguments.length ? Array.prototype.slice.call(a2, b2) : Array.prototype.slice.call(a2, b2, c$12);
          }
          goog.array.slice = module$contents$goog$array_slice;
          function module$contents$goog$array_removeDuplicates(a2, b2, c$12) {
            b2 ||= a2;
            var d2 = function(k) {
              return goog.isObject(k) ? "o" + goog.getUid(k) : (typeof k).charAt(0) + k;
            };
            c$12 ||= d2, d2 = {};
            for (var e2 = 0, f2 = 0; f2 < a2.length; ) {
              var g2 = a2[f2++], h = c$12(g2);
              Object.prototype.hasOwnProperty.call(d2, h) || (d2[h] = true, b2[e2++] = g2);
            }
            b2.length = e2;
          }
          goog.array.removeDuplicates = module$contents$goog$array_removeDuplicates;
          function module$contents$goog$array_binarySearch(a2, b2, c$12) {
            return module$contents$goog$array_binarySearch_(a2, c$12 || module$contents$goog$array_defaultCompare, false, b2);
          }
          goog.array.binarySearch = module$contents$goog$array_binarySearch;
          function module$contents$goog$array_binarySelect(a2, b2, c$12) {
            return module$contents$goog$array_binarySearch_(a2, b2, true, void 0, c$12);
          }
          goog.array.binarySelect = module$contents$goog$array_binarySelect;
          function module$contents$goog$array_binarySearch_(a2, b2, c$12, d2, e2) {
            for (var f2 = 0, g2 = a2.length, h; f2 < g2; ) {
              var k = f2 + (g2 - f2 >>> 1), l$12 = c$12 ? b2.call(e2, a2[k], k, a2) : b2(d2, a2[k]);
              0 < l$12 ? f2 = k + 1 : (g2 = k, h = !l$12);
            }
            return h ? f2 : -f2 - 1;
          }
          function module$contents$goog$array_sort(a2, b2) {
            a2.sort(b2 || module$contents$goog$array_defaultCompare);
          }
          goog.array.sort = module$contents$goog$array_sort;
          function module$contents$goog$array_stableSort(a2, b2) {
            for (var c$12 = Array(a2.length), d2 = 0; d2 < a2.length; d2++) c$12[d2] = {
              index: d2,
              value: a2[d2]
            };
            var e2 = b2 || module$contents$goog$array_defaultCompare;
            for (module$contents$goog$array_sort(c$12, function(f2, g2) {
              return e2(f2.value, g2.value) || f2.index - g2.index;
            }), d2 = 0; d2 < a2.length; d2++) a2[d2] = c$12[d2].value;
          }
          goog.array.stableSort = module$contents$goog$array_stableSort;
          function module$contents$goog$array_sortByKey(a2, b2, c$12) {
            var d2 = c$12 || module$contents$goog$array_defaultCompare;
            module$contents$goog$array_sort(a2, function(e2, f2) {
              return d2(b2(e2), b2(f2));
            });
          }
          goog.array.sortByKey = module$contents$goog$array_sortByKey;
          function module$contents$goog$array_sortObjectsByKey(a2, b2, c$12) {
            module$contents$goog$array_sortByKey(a2, function(d2) {
              return d2[b2];
            }, c$12);
          }
          goog.array.sortObjectsByKey = module$contents$goog$array_sortObjectsByKey;
          function module$contents$goog$array_isSorted(a2, b2, c$12) {
            b2 ||= module$contents$goog$array_defaultCompare;
            for (var d2 = 1; d2 < a2.length; d2++) {
              var e2 = b2(a2[d2 - 1], a2[d2]);
              if (0 < e2 || e2 == 0 && c$12) return false;
            }
            return true;
          }
          goog.array.isSorted = module$contents$goog$array_isSorted;
          function module$contents$goog$array_equals(a2, b2, c$12) {
            if (!goog.isArrayLike(a2) || !goog.isArrayLike(b2) || a2.length != b2.length) return false;
            var d2 = a2.length;
            c$12 ||= module$contents$goog$array_defaultCompareEquality;
            for (var e2 = 0; e2 < d2; e2++) if (!c$12(a2[e2], b2[e2])) return false;
            return true;
          }
          goog.array.equals = module$contents$goog$array_equals;
          function module$contents$goog$array_compare3(a2, b2, c$12) {
            c$12 ||= module$contents$goog$array_defaultCompare;
            for (var d2 = Math.min(a2.length, b2.length), e2 = 0; e2 < d2; e2++) {
              var f2 = c$12(a2[e2], b2[e2]);
              if (f2 != 0) return f2;
            }
            return module$contents$goog$array_defaultCompare(a2.length, b2.length);
          }
          goog.array.compare3 = module$contents$goog$array_compare3;
          function module$contents$goog$array_defaultCompare(a2, b2) {
            return a2 > b2 ? 1 : a2 < b2 ? -1 : 0;
          }
          goog.array.defaultCompare = module$contents$goog$array_defaultCompare;
          function module$contents$goog$array_inverseDefaultCompare(a2, b2) {
            return -module$contents$goog$array_defaultCompare(a2, b2);
          }
          goog.array.inverseDefaultCompare = module$contents$goog$array_inverseDefaultCompare;
          function module$contents$goog$array_defaultCompareEquality(a2, b2) {
            return a2 === b2;
          }
          goog.array.defaultCompareEquality = module$contents$goog$array_defaultCompareEquality;
          function module$contents$goog$array_binaryInsert(a2, b2, c$12) {
            return c$12 = module$contents$goog$array_binarySearch(a2, b2, c$12), 0 > c$12 ? (module$contents$goog$array_insertAt(a2, b2, -(c$12 + 1)), true) : false;
          }
          goog.array.binaryInsert = module$contents$goog$array_binaryInsert;
          function module$contents$goog$array_binaryRemove(a2, b2, c$12) {
            return b2 = module$contents$goog$array_binarySearch(a2, b2, c$12), 0 <= b2 ? module$contents$goog$array_removeAt(a2, b2) : false;
          }
          goog.array.binaryRemove = module$contents$goog$array_binaryRemove;
          function module$contents$goog$array_bucket(a2, b2, c$12) {
            for (var d2 = {}, e2 = 0; e2 < a2.length; e2++) {
              var f2 = a2[e2], g2 = b2.call(c$12, f2, e2, a2);
              g2 !== void 0 && (d2[g2] || (d2[g2] = [])).push(f2);
            }
            return d2;
          }
          goog.array.bucket = module$contents$goog$array_bucket;
          function module$contents$goog$array_toObject(a2, b2, c$12) {
            var d2 = {};
            return module$contents$goog$array_forEach(a2, function(e2, f2) {
              d2[b2.call(c$12, e2, f2, a2)] = e2;
            }), d2;
          }
          goog.array.toObject = module$contents$goog$array_toObject;
          function module$contents$goog$array_range(a2, b2, c$12) {
            var d2 = [], e2 = 0, f2 = a2;
            if (c$12 ||= 1, b2 !== void 0 && (e2 = a2, f2 = b2), 0 > c$12 * (f2 - e2)) return [];
            if (0 < c$12) for (a2 = e2; a2 < f2; a2 += c$12) d2.push(a2);
            else for (a2 = e2; a2 > f2; a2 += c$12) d2.push(a2);
            return d2;
          }
          goog.array.range = module$contents$goog$array_range;
          function module$contents$goog$array_repeat(a2, b2) {
            for (var c$12 = [], d2 = 0; d2 < b2; d2++) c$12[d2] = a2;
            return c$12;
          }
          goog.array.repeat = module$contents$goog$array_repeat;
          function module$contents$goog$array_flatten(a2) {
            for (var b2 = [], c$12 = 0; c$12 < arguments.length; c$12++) {
              var d2 = arguments[c$12];
              if (Array.isArray(d2)) for (var e2 = 0; e2 < d2.length; e2 += 8192) {
                var f2 = module$contents$goog$array_slice(d2, e2, e2 + 8192);
                f2 = module$contents$goog$array_flatten.apply(null, f2);
                for (var g2 = 0; g2 < f2.length; g2++) b2.push(f2[g2]);
              }
              else b2.push(d2);
            }
            return b2;
          }
          goog.array.flatten = module$contents$goog$array_flatten;
          function module$contents$goog$array_rotate(a2, b2) {
            return goog.asserts.assert(a2.length != null), a2.length && (b2 %= a2.length, 0 < b2 ? Array.prototype.unshift.apply(a2, a2.splice(-b2, b2)) : 0 > b2 && Array.prototype.push.apply(a2, a2.splice(0, -b2))), a2;
          }
          goog.array.rotate = module$contents$goog$array_rotate;
          function module$contents$goog$array_moveItem(a2, b2, c$12) {
            goog.asserts.assert(0 <= b2 && b2 < a2.length), goog.asserts.assert(0 <= c$12 && c$12 < a2.length), b2 = Array.prototype.splice.call(a2, b2, 1), Array.prototype.splice.call(a2, c$12, 0, b2[0]);
          }
          goog.array.moveItem = module$contents$goog$array_moveItem;
          function module$contents$goog$array_zip(a2) {
            if (!arguments.length) return [];
            for (var b2 = [], c$12 = arguments[0].length, d2 = 1; d2 < arguments.length; d2++) arguments[d2].length < c$12 && (c$12 = arguments[d2].length);
            for (d2 = 0; d2 < c$12; d2++) {
              for (var e2 = [], f2 = 0; f2 < arguments.length; f2++) e2.push(arguments[f2][d2]);
              b2.push(e2);
            }
            return b2;
          }
          goog.array.zip = module$contents$goog$array_zip;
          function module$contents$goog$array_shuffle(a2, b2) {
            b2 ||= Math.random;
            for (var c$12 = a2.length - 1; 0 < c$12; c$12--) {
              var d2 = Math.floor(b2() * (c$12 + 1)), e2 = a2[c$12];
              a2[c$12] = a2[d2], a2[d2] = e2;
            }
          }
          goog.array.shuffle = module$contents$goog$array_shuffle;
          function module$contents$goog$array_copyByIndex(a2, b2) {
            var c$12 = [];
            return module$contents$goog$array_forEach(b2, function(d2) {
              c$12.push(a2[d2]);
            }), c$12;
          }
          goog.array.copyByIndex = module$contents$goog$array_copyByIndex;
          function module$contents$goog$array_concatMap(a2, b2, c$12) {
            return module$contents$goog$array_concat.apply([], module$contents$goog$array_map(a2, b2, c$12));
          }
          goog.array.concatMap = module$contents$goog$array_concatMap, goog.dom.asserts = {}, goog.dom.asserts.assertIsLocation = function(a2) {
            if (goog.asserts.ENABLE_ASSERTS) {
              var b2 = goog.dom.asserts.getWindow_(a2);
              b2 && (!a2 || !(a2 instanceof b2.Location) && a2 instanceof b2.Element) && goog.asserts.fail("Argument is not a Location (or a non-Element mock); got: %s", goog.dom.asserts.debugStringForType_(a2));
            }
            return a2;
          }, goog.dom.asserts.assertIsElementType_ = function(a2, b2) {
            if (goog.asserts.ENABLE_ASSERTS) {
              var c$12 = goog.dom.asserts.getWindow_(a2);
              c$12 && c$12[b2] !== void 0 && (a2 && (a2 instanceof c$12[b2] || !(a2 instanceof c$12.Location || a2 instanceof c$12.Element)) || goog.asserts.fail("Argument is not a %s (or a non-Element, non-Location mock); got: %s", b2, goog.dom.asserts.debugStringForType_(a2)));
            }
            return a2;
          }, goog.dom.asserts.assertIsHTMLAnchorElement = function(a2) {
            return goog.dom.asserts.assertIsElementType_(a2, "HTMLAnchorElement");
          }, goog.dom.asserts.assertIsHTMLButtonElement = function(a2) {
            return goog.dom.asserts.assertIsElementType_(a2, "HTMLButtonElement");
          }, goog.dom.asserts.assertIsHTMLLinkElement = function(a2) {
            return goog.dom.asserts.assertIsElementType_(a2, "HTMLLinkElement");
          }, goog.dom.asserts.assertIsHTMLImageElement = function(a2) {
            return goog.dom.asserts.assertIsElementType_(a2, "HTMLImageElement");
          }, goog.dom.asserts.assertIsHTMLAudioElement = function(a2) {
            return goog.dom.asserts.assertIsElementType_(a2, "HTMLAudioElement");
          }, goog.dom.asserts.assertIsHTMLVideoElement = function(a2) {
            return goog.dom.asserts.assertIsElementType_(a2, "HTMLVideoElement");
          }, goog.dom.asserts.assertIsHTMLInputElement = function(a2) {
            return goog.dom.asserts.assertIsElementType_(a2, "HTMLInputElement");
          }, goog.dom.asserts.assertIsHTMLTextAreaElement = function(a2) {
            return goog.dom.asserts.assertIsElementType_(a2, "HTMLTextAreaElement");
          }, goog.dom.asserts.assertIsHTMLCanvasElement = function(a2) {
            return goog.dom.asserts.assertIsElementType_(a2, "HTMLCanvasElement");
          }, goog.dom.asserts.assertIsHTMLEmbedElement = function(a2) {
            return goog.dom.asserts.assertIsElementType_(a2, "HTMLEmbedElement");
          }, goog.dom.asserts.assertIsHTMLFormElement = function(a2) {
            return goog.dom.asserts.assertIsElementType_(a2, "HTMLFormElement");
          }, goog.dom.asserts.assertIsHTMLFrameElement = function(a2) {
            return goog.dom.asserts.assertIsElementType_(a2, "HTMLFrameElement");
          }, goog.dom.asserts.assertIsHTMLIFrameElement = function(a2) {
            return goog.dom.asserts.assertIsElementType_(a2, "HTMLIFrameElement");
          }, goog.dom.asserts.assertIsHTMLObjectElement = function(a2) {
            return goog.dom.asserts.assertIsElementType_(a2, "HTMLObjectElement");
          }, goog.dom.asserts.assertIsHTMLScriptElement = function(a2) {
            return goog.dom.asserts.assertIsElementType_(a2, "HTMLScriptElement");
          }, goog.dom.asserts.debugStringForType_ = function(a2) {
            if (goog.isObject(a2)) try {
              return a2.constructor.displayName || a2.constructor.name || Object.prototype.toString.call(a2);
            } catch {
              return "<object could not be stringified>";
            }
            else return a2 === void 0 ? "undefined" : a2 === null ? "null" : typeof a2;
          }, goog.dom.asserts.getWindow_ = function(a2) {
            try {
              var b2 = a2 && a2.ownerDocument, c$12 = b2 && (b2.defaultView || b2.parentWindow);
              if (c$12 ||= goog.global, c$12.Element && c$12.Location) return c$12;
            } catch {
            }
            return null;
          }, goog.dom.HtmlElement = function() {
          }, goog.functions = {}, goog.functions.constant = function(a2) {
            return function() {
              return a2;
            };
          }, goog.functions.FALSE = function() {
            return false;
          }, goog.functions.TRUE = function() {
            return true;
          }, goog.functions.NULL = function() {
            return null;
          }, goog.functions.identity = function(a2, b2) {
            return a2;
          }, goog.functions.error = function(a2) {
            return function() {
              throw Error(a2);
            };
          }, goog.functions.fail = function(a2) {
            return function() {
              throw a2;
            };
          }, goog.functions.lock = function(a2, b2) {
            return b2 ||= 0, function() {
              return a2.apply(this, Array.prototype.slice.call(arguments, 0, b2));
            };
          }, goog.functions.nth = function(a2) {
            return function() {
              return arguments[a2];
            };
          }, goog.functions.partialRight = function(a2, b2) {
            var c$12 = Array.prototype.slice.call(arguments, 1);
            return function() {
              var d2 = this;
              d2 === goog.global && (d2 = void 0);
              var e2 = Array.prototype.slice.call(arguments);
              return e2.push.apply(e2, c$12), a2.apply(d2, e2);
            };
          }, goog.functions.withReturnValue = function(a2, b2) {
            return goog.functions.sequence(a2, goog.functions.constant(b2));
          }, goog.functions.equalTo = function(a2, b2) {
            return function(c$12) {
              return b2 ? a2 == c$12 : a2 === c$12;
            };
          }, goog.functions.compose = function(a2, b2) {
            var c$12 = arguments, d2 = c$12.length;
            return function() {
              var e2;
              d2 && (e2 = c$12[d2 - 1].apply(this, arguments));
              for (var f2 = d2 - 2; 0 <= f2; f2--) e2 = c$12[f2].call(this, e2);
              return e2;
            };
          }, goog.functions.sequence = function(a2) {
            var b2 = arguments, c$12 = b2.length;
            return function() {
              for (var d2, e2 = 0; e2 < c$12; e2++) d2 = b2[e2].apply(this, arguments);
              return d2;
            };
          }, goog.functions.and = function(a2) {
            var b2 = arguments, c$12 = b2.length;
            return function() {
              for (var d2 = 0; d2 < c$12; d2++) if (!b2[d2].apply(this, arguments)) return false;
              return true;
            };
          }, goog.functions.or = function(a2) {
            var b2 = arguments, c$12 = b2.length;
            return function() {
              for (var d2 = 0; d2 < c$12; d2++) if (b2[d2].apply(this, arguments)) return true;
              return false;
            };
          }, goog.functions.not = function(a2) {
            return function() {
              return !a2.apply(this, arguments);
            };
          }, goog.functions.create = function(a2, b2) {
            var c$12 = function() {
            };
            return c$12.prototype = a2.prototype, c$12 = new c$12(), a2.apply(c$12, Array.prototype.slice.call(arguments, 1)), c$12;
          }, goog.functions.CACHE_RETURN_VALUE = true, goog.functions.cacheReturnValue = function(a2) {
            var b2 = false, c$12;
            return function() {
              return goog.functions.CACHE_RETURN_VALUE ? (b2 ||= (c$12 = a2(), true), c$12) : a2();
            };
          }, goog.functions.once = function(a2) {
            var b2 = a2;
            return function() {
              if (b2) {
                var c$12 = b2;
                b2 = null, c$12();
              }
            };
          }, goog.functions.debounce = function(a2, b2, c$12) {
            var d2 = 0;
            return function(e2) {
              goog.global.clearTimeout(d2);
              var f2 = arguments;
              d2 = goog.global.setTimeout(function() {
                a2.apply(c$12, f2);
              }, b2);
            };
          }, goog.functions.throttle = function(a2, b2, c$12) {
            var d2 = 0, e2 = false, f2 = [], g2 = function() {
              d2 = 0, e2 && (e2 = false, h());
            }, h = function() {
              d2 = goog.global.setTimeout(g2, b2), a2.apply(c$12, f2);
            };
            return function(k) {
              f2 = arguments, d2 ? e2 = true : h();
            };
          }, goog.functions.rateLimit = function(a2, b2, c$12) {
            var d2 = 0, e2 = function() {
              d2 = 0;
            };
            return function(f2) {
              d2 || (d2 = goog.global.setTimeout(e2, b2), a2.apply(c$12, arguments));
            };
          }, goog.functions.isFunction = function(a2) {
            return typeof a2 == "function";
          }, goog.dom.TagName = function() {
          }, goog.dom.TagName.cast = function(a2, b2) {
            return a2;
          }, goog.dom.TagName.prototype.toString = function() {
          }, goog.dom.TagName.A = "A", goog.dom.TagName.ABBR = "ABBR", goog.dom.TagName.ACRONYM = "ACRONYM", goog.dom.TagName.ADDRESS = "ADDRESS", goog.dom.TagName.APPLET = "APPLET", goog.dom.TagName.AREA = "AREA", goog.dom.TagName.ARTICLE = "ARTICLE", goog.dom.TagName.ASIDE = "ASIDE", goog.dom.TagName.AUDIO = "AUDIO", goog.dom.TagName.B = "B", goog.dom.TagName.BASE = "BASE", goog.dom.TagName.BASEFONT = "BASEFONT", goog.dom.TagName.BDI = "BDI", goog.dom.TagName.BDO = "BDO", goog.dom.TagName.BIG = "BIG", goog.dom.TagName.BLOCKQUOTE = "BLOCKQUOTE", goog.dom.TagName.BODY = "BODY", goog.dom.TagName.BR = "BR", goog.dom.TagName.BUTTON = "BUTTON", goog.dom.TagName.CANVAS = "CANVAS", goog.dom.TagName.CAPTION = "CAPTION", goog.dom.TagName.CENTER = "CENTER", goog.dom.TagName.CITE = "CITE", goog.dom.TagName.CODE = "CODE", goog.dom.TagName.COL = "COL", goog.dom.TagName.COLGROUP = "COLGROUP", goog.dom.TagName.COMMAND = "COMMAND", goog.dom.TagName.DATA = "DATA", goog.dom.TagName.DATALIST = "DATALIST", goog.dom.TagName.DD = "DD", goog.dom.TagName.DEL = "DEL", goog.dom.TagName.DETAILS = "DETAILS", goog.dom.TagName.DFN = "DFN", goog.dom.TagName.DIALOG = "DIALOG", goog.dom.TagName.DIR = "DIR", goog.dom.TagName.DIV = "DIV", goog.dom.TagName.DL = "DL", goog.dom.TagName.DT = "DT", goog.dom.TagName.EM = "EM", goog.dom.TagName.EMBED = "EMBED", goog.dom.TagName.FIELDSET = "FIELDSET", goog.dom.TagName.FIGCAPTION = "FIGCAPTION", goog.dom.TagName.FIGURE = "FIGURE", goog.dom.TagName.FONT = "FONT", goog.dom.TagName.FOOTER = "FOOTER", goog.dom.TagName.FORM = "FORM", goog.dom.TagName.FRAME = "FRAME", goog.dom.TagName.FRAMESET = "FRAMESET", goog.dom.TagName.H1 = "H1", goog.dom.TagName.H2 = "H2", goog.dom.TagName.H3 = "H3", goog.dom.TagName.H4 = "H4", goog.dom.TagName.H5 = "H5", goog.dom.TagName.H6 = "H6", goog.dom.TagName.HEAD = "HEAD", goog.dom.TagName.HEADER = "HEADER", goog.dom.TagName.HGROUP = "HGROUP", goog.dom.TagName.HR = "HR", goog.dom.TagName.HTML = "HTML", goog.dom.TagName.I = "I", goog.dom.TagName.IFRAME = "IFRAME", goog.dom.TagName.IMG = "IMG", goog.dom.TagName.INPUT = "INPUT", goog.dom.TagName.INS = "INS", goog.dom.TagName.ISINDEX = "ISINDEX", goog.dom.TagName.KBD = "KBD", goog.dom.TagName.KEYGEN = "KEYGEN", goog.dom.TagName.LABEL = "LABEL", goog.dom.TagName.LEGEND = "LEGEND", goog.dom.TagName.LI = "LI", goog.dom.TagName.LINK = "LINK", goog.dom.TagName.MAIN = "MAIN", goog.dom.TagName.MAP = "MAP", goog.dom.TagName.MARK = "MARK", goog.dom.TagName.MATH = "MATH", goog.dom.TagName.MENU = "MENU", goog.dom.TagName.MENUITEM = "MENUITEM", goog.dom.TagName.META = "META", goog.dom.TagName.METER = "METER", goog.dom.TagName.NAV = "NAV", goog.dom.TagName.NOFRAMES = "NOFRAMES", goog.dom.TagName.NOSCRIPT = "NOSCRIPT", goog.dom.TagName.OBJECT = "OBJECT", goog.dom.TagName.OL = "OL", goog.dom.TagName.OPTGROUP = "OPTGROUP", goog.dom.TagName.OPTION = "OPTION", goog.dom.TagName.OUTPUT = "OUTPUT", goog.dom.TagName.P = "P", goog.dom.TagName.PARAM = "PARAM", goog.dom.TagName.PICTURE = "PICTURE", goog.dom.TagName.PRE = "PRE", goog.dom.TagName.PROGRESS = "PROGRESS", goog.dom.TagName.Q = "Q", goog.dom.TagName.RP = "RP", goog.dom.TagName.RT = "RT", goog.dom.TagName.RTC = "RTC", goog.dom.TagName.RUBY = "RUBY", goog.dom.TagName.S = "S", goog.dom.TagName.SAMP = "SAMP", goog.dom.TagName.SCRIPT = "SCRIPT", goog.dom.TagName.SECTION = "SECTION", goog.dom.TagName.SELECT = "SELECT", goog.dom.TagName.SMALL = "SMALL", goog.dom.TagName.SOURCE = "SOURCE", goog.dom.TagName.SPAN = "SPAN", goog.dom.TagName.STRIKE = "STRIKE", goog.dom.TagName.STRONG = "STRONG", goog.dom.TagName.STYLE = "STYLE", goog.dom.TagName.SUB = "SUB", goog.dom.TagName.SUMMARY = "SUMMARY", goog.dom.TagName.SUP = "SUP", goog.dom.TagName.SVG = "SVG", goog.dom.TagName.TABLE = "TABLE", goog.dom.TagName.TBODY = "TBODY", goog.dom.TagName.TD = "TD", goog.dom.TagName.TEMPLATE = "TEMPLATE", goog.dom.TagName.TEXTAREA = "TEXTAREA", goog.dom.TagName.TFOOT = "TFOOT", goog.dom.TagName.TH = "TH", goog.dom.TagName.THEAD = "THEAD", goog.dom.TagName.TIME = "TIME", goog.dom.TagName.TITLE = "TITLE", goog.dom.TagName.TR = "TR", goog.dom.TagName.TRACK = "TRACK", goog.dom.TagName.TT = "TT", goog.dom.TagName.U = "U", goog.dom.TagName.UL = "UL", goog.dom.TagName.VAR = "VAR", goog.dom.TagName.VIDEO = "VIDEO", goog.dom.TagName.WBR = "WBR", goog.object = {}, goog.object.forEach = function(a2, b2, c$12) {
            for (var d2 in a2) b2.call(c$12, a2[d2], d2, a2);
          }, goog.object.filter = function(a2, b2, c$12) {
            var d2 = {}, e2;
            for (e2 in a2) b2.call(c$12, a2[e2], e2, a2) && (d2[e2] = a2[e2]);
            return d2;
          }, goog.object.map = function(a2, b2, c$12) {
            var d2 = {}, e2;
            for (e2 in a2) d2[e2] = b2.call(c$12, a2[e2], e2, a2);
            return d2;
          }, goog.object.some = function(a2, b2, c$12) {
            for (var d2 in a2) if (b2.call(c$12, a2[d2], d2, a2)) return true;
            return false;
          }, goog.object.every = function(a2, b2, c$12) {
            for (var d2 in a2) if (!b2.call(c$12, a2[d2], d2, a2)) return false;
            return true;
          }, goog.object.getCount = function(a2) {
            var b2 = 0, c$12;
            for (c$12 in a2) b2++;
            return b2;
          }, goog.object.getAnyKey = function(a2) {
            for (var b2 in a2) return b2;
          }, goog.object.getAnyValue = function(a2) {
            for (var b2 in a2) return a2[b2];
          }, goog.object.contains = function(a2, b2) {
            return goog.object.containsValue(a2, b2);
          }, goog.object.getValues = function(a2) {
            var b2 = [], c$12 = 0, d2;
            for (d2 in a2) b2[c$12++] = a2[d2];
            return b2;
          }, goog.object.getKeys = function(a2) {
            var b2 = [], c$12 = 0, d2;
            for (d2 in a2) b2[c$12++] = d2;
            return b2;
          }, goog.object.getValueByKeys = function(a2, b2) {
            var c$12 = goog.isArrayLike(b2), d2 = c$12 ? b2 : arguments;
            for (c$12 = c$12 ? 0 : 1; c$12 < d2.length; c$12++) {
              if (a2 == null) return;
              a2 = a2[d2[c$12]];
            }
            return a2;
          }, goog.object.containsKey = function(a2, b2) {
            return a2 !== null && b2 in a2;
          }, goog.object.containsValue = function(a2, b2) {
            for (var c$12 in a2) if (a2[c$12] == b2) return true;
            return false;
          }, goog.object.findKey = function(a2, b2, c$12) {
            for (var d2 in a2) if (b2.call(c$12, a2[d2], d2, a2)) return d2;
          }, goog.object.findValue = function(a2, b2, c$12) {
            return (b2 = goog.object.findKey(a2, b2, c$12)) && a2[b2];
          }, goog.object.isEmpty = function(a2) {
            for (var b2 in a2) return false;
            return true;
          }, goog.object.clear = function(a2) {
            for (var b2 in a2) delete a2[b2];
          }, goog.object.remove = function(a2, b2) {
            var c$12;
            return (c$12 = b2 in a2) && delete a2[b2], c$12;
          }, goog.object.add = function(a2, b2, c$12) {
            if (a2 !== null && b2 in a2) throw Error('The object already contains the key "' + b2 + '"');
            goog.object.set(a2, b2, c$12);
          }, goog.object.get = function(a2, b2, c$12) {
            return a2 !== null && b2 in a2 ? a2[b2] : c$12;
          }, goog.object.set = function(a2, b2, c$12) {
            a2[b2] = c$12;
          }, goog.object.setIfUndefined = function(a2, b2, c$12) {
            return b2 in a2 ? a2[b2] : a2[b2] = c$12;
          }, goog.object.setWithReturnValueIfNotSet = function(a2, b2, c$12) {
            return b2 in a2 ? a2[b2] : (c$12 = c$12(), a2[b2] = c$12);
          }, goog.object.equals = function(a2, b2) {
            for (var c$12 in a2) if (!(c$12 in b2) || a2[c$12] !== b2[c$12]) return false;
            for (var d2 in b2) if (!(d2 in a2)) return false;
            return true;
          }, goog.object.clone = function(a2) {
            var b2 = {}, c$12;
            for (c$12 in a2) b2[c$12] = a2[c$12];
            return b2;
          }, goog.object.unsafeClone = function(a2) {
            if (!a2 || typeof a2 != "object") return a2;
            if (typeof a2.clone == "function") return a2.clone();
            var b2 = Array.isArray(a2) ? [] : typeof ArrayBuffer != "function" || typeof ArrayBuffer.isView != "function" || !ArrayBuffer.isView(a2) || a2 instanceof DataView ? {} : new a2.constructor(a2.length), c$12;
            for (c$12 in a2) b2[c$12] = goog.object.unsafeClone(a2[c$12]);
            return b2;
          }, goog.object.transpose = function(a2) {
            var b2 = {}, c$12;
            for (c$12 in a2) b2[a2[c$12]] = c$12;
            return b2;
          }, goog.object.PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "), goog.object.extend = function(a2, b2) {
            for (var c$12, d2, e2 = 1; e2 < arguments.length; e2++) {
              for (c$12 in d2 = arguments[e2], d2) a2[c$12] = d2[c$12];
              for (var f2 = 0; f2 < goog.object.PROTOTYPE_FIELDS_.length; f2++) c$12 = goog.object.PROTOTYPE_FIELDS_[f2], Object.prototype.hasOwnProperty.call(d2, c$12) && (a2[c$12] = d2[c$12]);
            }
          }, goog.object.create = function(a2) {
            var b2 = arguments.length;
            if (b2 == 1 && Array.isArray(arguments[0])) return goog.object.create.apply(null, arguments[0]);
            if (b2 % 2) throw Error("Uneven number of arguments");
            for (var c$12 = {}, d2 = 0; d2 < b2; d2 += 2) c$12[arguments[d2]] = arguments[d2 + 1];
            return c$12;
          }, goog.object.createSet = function(a2) {
            var b2 = arguments.length;
            if (b2 == 1 && Array.isArray(arguments[0])) return goog.object.createSet.apply(null, arguments[0]);
            for (var c$12 = {}, d2 = 0; d2 < b2; d2++) c$12[arguments[d2]] = true;
            return c$12;
          }, goog.object.createImmutableView = function(a2) {
            var b2 = a2;
            return Object.isFrozen && !Object.isFrozen(a2) && (b2 = Object.create(a2), Object.freeze(b2)), b2;
          }, goog.object.isImmutableView = function(a2) {
            return !!Object.isFrozen && Object.isFrozen(a2);
          }, goog.object.getAllPropertyNames = function(a2, b2, c$12) {
            if (!a2) return [];
            if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) return goog.object.getKeys(a2);
            for (var d2 = {}; a2 && (a2 !== Object.prototype || b2) && (a2 !== Function.prototype || c$12); ) {
              for (var e2 = Object.getOwnPropertyNames(a2), f2 = 0; f2 < e2.length; f2++) d2[e2[f2]] = true;
              a2 = Object.getPrototypeOf(a2);
            }
            return goog.object.getKeys(d2);
          }, goog.object.getSuperClass = function(a2) {
            return (a2 = Object.getPrototypeOf(a2.prototype)) && a2.constructor;
          }, goog.dom.tags = {}, goog.dom.tags.VOID_TAGS_ = {
            area: true,
            base: true,
            br: true,
            col: true,
            command: true,
            embed: true,
            hr: true,
            img: true,
            input: true,
            keygen: true,
            link: true,
            meta: true,
            param: true,
            source: true,
            track: true,
            wbr: true
          }, goog.dom.tags.isVoidTag = function(a2) {
            return true === goog.dom.tags.VOID_TAGS_[a2];
          }, goog.string = {}, goog.string.TypedString = function() {
          }, goog.string.Const = function(a2, b2) {
            this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ = a2 === goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ && b2 || "", this.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ = goog.string.Const.TYPE_MARKER_;
          }, goog.string.Const.prototype.implementsGoogStringTypedString = true, goog.string.Const.prototype.getTypedStringValue = function() {
            return this.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
          }, goog.DEBUG && (goog.string.Const.prototype.toString = function() {
            return "Const{" + this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ + "}";
          }), goog.string.Const.unwrap = function(a2) {
            return a2 instanceof goog.string.Const && a2.constructor === goog.string.Const && a2.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ === goog.string.Const.TYPE_MARKER_ ? a2.stringConstValueWithSecurityContract__googStringSecurityPrivate_ : (goog.asserts.fail("expected object of type Const, got '" + a2 + "'"), "type_error:Const");
          }, goog.string.Const.from = function(a2) {
            return new goog.string.Const(goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_, a2);
          }, goog.string.Const.TYPE_MARKER_ = {}, goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.string.Const.EMPTY = goog.string.Const.from(""), goog.html = {}, goog.html.trustedtypes = {}, goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse = function() {
            return goog.TRUSTED_TYPES_POLICY_NAME ? (goog.html.trustedtypes.cachedPolicy_ === void 0 && (goog.html.trustedtypes.cachedPolicy_ = goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#html")), goog.html.trustedtypes.cachedPolicy_) : null;
          };
          var module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE = {}, module$contents$goog$html$SafeScript_SafeScript = function(a2, b2) {
            this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = b2 === module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE ? a2 : "", this.implementsGoogStringTypedString = true;
          };
          module$contents$goog$html$SafeScript_SafeScript.fromConstant = function(a2) {
            return a2 = goog.string.Const.unwrap(a2), a2.length === 0 ? module$contents$goog$html$SafeScript_SafeScript.EMPTY : module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(a2);
          }, module$contents$goog$html$SafeScript_SafeScript.fromConstantAndArgs = function(a2, b2) {
            for (var c$12 = [], d2 = 1; d2 < arguments.length; d2++) c$12.push(module$contents$goog$html$SafeScript_SafeScript.stringify_(arguments[d2]));
            return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("(" + goog.string.Const.unwrap(a2) + ")(" + c$12.join(", ") + ");");
          }, module$contents$goog$html$SafeScript_SafeScript.fromJson = function(a2) {
            return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(module$contents$goog$html$SafeScript_SafeScript.stringify_(a2));
          }, module$contents$goog$html$SafeScript_SafeScript.prototype.getTypedStringValue = function() {
            return this.privateDoNotAccessOrElseSafeScriptWrappedValue_.toString();
          }, module$contents$goog$html$SafeScript_SafeScript.unwrap = function(a2) {
            return module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript(a2).toString();
          }, module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript = function(a2) {
            return a2 instanceof module$contents$goog$html$SafeScript_SafeScript && a2.constructor === module$contents$goog$html$SafeScript_SafeScript ? a2.privateDoNotAccessOrElseSafeScriptWrappedValue_ : ((0, goog.asserts.fail)("expected object of type SafeScript, got '" + a2 + "' of type " + goog.typeOf(a2)), "type_error:SafeScript");
          }, module$contents$goog$html$SafeScript_SafeScript.stringify_ = function(a2) {
            return JSON.stringify(a2).replace(/</g, "\\x3c");
          }, module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse = function(a2) {
            var b2 = goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();
            return a2 = b2 ? b2.createScript(a2) : a2, new module$contents$goog$html$SafeScript_SafeScript(a2, module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE);
          }, goog.DEBUG && (module$contents$goog$html$SafeScript_SafeScript.prototype.toString = function() {
            return "SafeScript{" + this.privateDoNotAccessOrElseSafeScriptWrappedValue_ + "}";
          }), module$contents$goog$html$SafeScript_SafeScript.EMPTY = (function() {
            return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("");
          })(), goog.html.SafeScript = module$contents$goog$html$SafeScript_SafeScript, goog.fs = {}, goog.fs.url = {}, goog.fs.url.createObjectUrl = function(a2) {
            return goog.fs.url.getUrlObject_().createObjectURL(a2);
          }, goog.fs.url.revokeObjectUrl = function(a2) {
            goog.fs.url.getUrlObject_().revokeObjectURL(a2);
          }, goog.fs.url.UrlObject_ = function() {
          }, goog.fs.url.UrlObject_.prototype.createObjectURL = function(a2) {
          }, goog.fs.url.UrlObject_.prototype.revokeObjectURL = function(a2) {
          }, goog.fs.url.getUrlObject_ = function() {
            var a2 = goog.fs.url.findUrlObject_();
            if (a2 != null) return a2;
            throw Error("This browser doesn't seem to support blob URLs");
          }, goog.fs.url.findUrlObject_ = function() {
            return goog.global.URL !== void 0 && goog.global.URL.createObjectURL !== void 0 ? goog.global.URL : goog.global.webkitURL !== void 0 && goog.global.webkitURL.createObjectURL !== void 0 ? goog.global.webkitURL : goog.global.createObjectURL === void 0 ? null : goog.global;
          }, goog.fs.url.browserSupportsObjectUrls = function() {
            return goog.fs.url.findUrlObject_() != null;
          }, goog.fs.blob = {}, goog.fs.blob.getBlob = function(a2) {
            var b2 = goog.global.BlobBuilder || goog.global.WebKitBlobBuilder;
            if (b2 !== void 0) {
              b2 = new b2();
              for (var c$12 = 0; c$12 < arguments.length; c$12++) b2.append(arguments[c$12]);
              return b2.getBlob();
            }
            return goog.fs.blob.getBlobWithProperties(module$contents$goog$array_toArray(arguments));
          }, goog.fs.blob.getBlobWithProperties = function(a2, b2, c$12) {
            var d2 = goog.global.BlobBuilder || goog.global.WebKitBlobBuilder;
            if (d2 !== void 0) {
              d2 = new d2();
              for (var e2 = 0; e2 < a2.length; e2++) d2.append(a2[e2], c$12);
              return d2.getBlob(b2);
            }
            if (goog.global.Blob !== void 0) return d2 = {}, b2 && (d2.type = b2), c$12 && (d2.endings = c$12), new Blob(a2, d2);
            throw Error("This browser doesn't seem to support creating Blobs");
          }, goog.i18n = {}, goog.i18n.bidi = {}, goog.i18n.bidi.FORCE_RTL = false, goog.i18n.bidi.IS_RTL = goog.i18n.bidi.FORCE_RTL || (goog.LOCALE.substring(0, 2).toLowerCase() == "ar" || goog.LOCALE.substring(0, 2).toLowerCase() == "fa" || goog.LOCALE.substring(0, 2).toLowerCase() == "he" || goog.LOCALE.substring(0, 2).toLowerCase() == "iw" || goog.LOCALE.substring(0, 2).toLowerCase() == "ps" || goog.LOCALE.substring(0, 2).toLowerCase() == "sd" || goog.LOCALE.substring(0, 2).toLowerCase() == "ug" || goog.LOCALE.substring(0, 2).toLowerCase() == "ur" || goog.LOCALE.substring(0, 2).toLowerCase() == "yi") && (goog.LOCALE.length == 2 || goog.LOCALE.substring(2, 3) == "-" || goog.LOCALE.substring(2, 3) == "_") || 3 <= goog.LOCALE.length && goog.LOCALE.substring(0, 3).toLowerCase() == "ckb" && (goog.LOCALE.length == 3 || goog.LOCALE.substring(3, 4) == "-" || goog.LOCALE.substring(3, 4) == "_") || 7 <= goog.LOCALE.length && (goog.LOCALE.substring(2, 3) == "-" || goog.LOCALE.substring(2, 3) == "_") && (goog.LOCALE.substring(3, 7).toLowerCase() == "adlm" || goog.LOCALE.substring(3, 7).toLowerCase() == "arab" || goog.LOCALE.substring(3, 7).toLowerCase() == "hebr" || goog.LOCALE.substring(3, 7).toLowerCase() == "nkoo" || goog.LOCALE.substring(3, 7).toLowerCase() == "rohg" || goog.LOCALE.substring(3, 7).toLowerCase() == "thaa") || 8 <= goog.LOCALE.length && (goog.LOCALE.substring(3, 4) == "-" || goog.LOCALE.substring(3, 4) == "_") && (goog.LOCALE.substring(4, 8).toLowerCase() == "adlm" || goog.LOCALE.substring(4, 8).toLowerCase() == "arab" || goog.LOCALE.substring(4, 8).toLowerCase() == "hebr" || goog.LOCALE.substring(4, 8).toLowerCase() == "nkoo" || goog.LOCALE.substring(4, 8).toLowerCase() == "rohg" || goog.LOCALE.substring(4, 8).toLowerCase() == "thaa"), goog.i18n.bidi.Format = {
            LRE: "‪",
            RLE: "‫",
            PDF: "‬",
            LRM: "‎",
            RLM: "‏"
          }, goog.i18n.bidi.Dir = {
            LTR: 1,
            RTL: -1,
            NEUTRAL: 0
          }, goog.i18n.bidi.RIGHT = "right", goog.i18n.bidi.LEFT = "left", goog.i18n.bidi.I18N_RIGHT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.LEFT : goog.i18n.bidi.RIGHT, goog.i18n.bidi.I18N_LEFT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, goog.i18n.bidi.toDir = function(a2, b2) {
            return typeof a2 == "number" ? 0 < a2 ? goog.i18n.bidi.Dir.LTR : 0 > a2 ? goog.i18n.bidi.Dir.RTL : b2 ? null : goog.i18n.bidi.Dir.NEUTRAL : a2 == null ? null : a2 ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
          }, goog.i18n.bidi.ltrChars_ = "A-Za-zÀ-ÖØ-öø-ʸ̀-֐ऀ-῿‎Ⰰ-\uD801\uD804-\uD839\uD83C-\uDBFF豈-﬜︀-﹯﻽-￿", goog.i18n.bidi.rtlChars_ = "֑-ۯۺ-ࣿ‏\uD802-\uD803\uD83A-\uD83Bיִ-﷿ﹰ-ﻼ", goog.i18n.bidi.htmlSkipReg_ = /<[^>]*>|&[^;]+;/g, goog.i18n.bidi.stripHtmlIfNeeded_ = function(a2, b2) {
            return b2 ? a2.replace(goog.i18n.bidi.htmlSkipReg_, "") : a2;
          }, goog.i18n.bidi.rtlCharReg_ = /* @__PURE__ */ RegExp("[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.ltrCharReg_ = /* @__PURE__ */ RegExp("[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.hasAnyRtl = function(a2, b2) {
            return goog.i18n.bidi.rtlCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a2, b2));
          }, goog.i18n.bidi.hasRtlChar = goog.i18n.bidi.hasAnyRtl, goog.i18n.bidi.hasAnyLtr = function(a2, b2) {
            return goog.i18n.bidi.ltrCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a2, b2));
          }, goog.i18n.bidi.ltrRe_ = /* @__PURE__ */ RegExp("^[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.rtlRe_ = /* @__PURE__ */ RegExp("^[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.isRtlChar = function(a2) {
            return goog.i18n.bidi.rtlRe_.test(a2);
          }, goog.i18n.bidi.isLtrChar = function(a2) {
            return goog.i18n.bidi.ltrRe_.test(a2);
          }, goog.i18n.bidi.isNeutralChar = function(a2) {
            return !goog.i18n.bidi.isLtrChar(a2) && !goog.i18n.bidi.isRtlChar(a2);
          }, goog.i18n.bidi.ltrDirCheckRe_ = /* @__PURE__ */ RegExp("^[^" + goog.i18n.bidi.rtlChars_ + "]*[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.rtlDirCheckRe_ = /* @__PURE__ */ RegExp("^[^" + goog.i18n.bidi.ltrChars_ + "]*[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.startsWithRtl = function(a2, b2) {
            return goog.i18n.bidi.rtlDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a2, b2));
          }, goog.i18n.bidi.isRtlText = goog.i18n.bidi.startsWithRtl, goog.i18n.bidi.startsWithLtr = function(a2, b2) {
            return goog.i18n.bidi.ltrDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a2, b2));
          }, goog.i18n.bidi.isLtrText = goog.i18n.bidi.startsWithLtr, goog.i18n.bidi.isRequiredLtrRe_ = /^http:\/\/.*/, goog.i18n.bidi.isNeutralText = function(a2, b2) {
            return a2 = goog.i18n.bidi.stripHtmlIfNeeded_(a2, b2), goog.i18n.bidi.isRequiredLtrRe_.test(a2) || !goog.i18n.bidi.hasAnyLtr(a2) && !goog.i18n.bidi.hasAnyRtl(a2);
          }, goog.i18n.bidi.ltrExitDirCheckRe_ = /* @__PURE__ */ RegExp("[" + goog.i18n.bidi.ltrChars_ + "][^" + goog.i18n.bidi.rtlChars_ + "]*$"), goog.i18n.bidi.rtlExitDirCheckRe_ = /* @__PURE__ */ RegExp("[" + goog.i18n.bidi.rtlChars_ + "][^" + goog.i18n.bidi.ltrChars_ + "]*$"), goog.i18n.bidi.endsWithLtr = function(a2, b2) {
            return goog.i18n.bidi.ltrExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a2, b2));
          }, goog.i18n.bidi.isLtrExitText = goog.i18n.bidi.endsWithLtr, goog.i18n.bidi.endsWithRtl = function(a2, b2) {
            return goog.i18n.bidi.rtlExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a2, b2));
          }, goog.i18n.bidi.isRtlExitText = goog.i18n.bidi.endsWithRtl, goog.i18n.bidi.rtlLocalesRe_ = /^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Adlm|Arab|Hebr|Nkoo|Rohg|Thaa))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i, goog.i18n.bidi.isRtlLanguage = function(a2) {
            return goog.i18n.bidi.rtlLocalesRe_.test(a2);
          }, goog.i18n.bidi.bracketGuardTextRe_ = /(\(.*?\)+)|(\[.*?\]+)|(\{.*?\}+)|(<.*?>+)/g, goog.i18n.bidi.guardBracketInText = function(a2, b2) {
            return b2 = (b2 === void 0 ? goog.i18n.bidi.hasAnyRtl(a2) : b2) ? goog.i18n.bidi.Format.RLM : goog.i18n.bidi.Format.LRM, a2.replace(goog.i18n.bidi.bracketGuardTextRe_, b2 + "$&" + b2);
          }, goog.i18n.bidi.enforceRtlInHtml = function(a2) {
            return a2.charAt(0) == "<" ? a2.replace(/<\w+/, "$& dir=rtl") : "\n<span dir=rtl>" + a2 + "</span>";
          }, goog.i18n.bidi.enforceRtlInText = function(a2) {
            return goog.i18n.bidi.Format.RLE + a2 + goog.i18n.bidi.Format.PDF;
          }, goog.i18n.bidi.enforceLtrInHtml = function(a2) {
            return a2.charAt(0) == "<" ? a2.replace(/<\w+/, "$& dir=ltr") : "\n<span dir=ltr>" + a2 + "</span>";
          }, goog.i18n.bidi.enforceLtrInText = function(a2) {
            return goog.i18n.bidi.Format.LRE + a2 + goog.i18n.bidi.Format.PDF;
          }, goog.i18n.bidi.dimensionsRe_ = /:\s*([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)/g, goog.i18n.bidi.leftRe_ = /left/gi, goog.i18n.bidi.rightRe_ = /right/gi, goog.i18n.bidi.tempRe_ = /%%%%/g, goog.i18n.bidi.mirrorCSS = function(a2) {
            return a2.replace(goog.i18n.bidi.dimensionsRe_, ":$1 $4 $3 $2").replace(goog.i18n.bidi.leftRe_, "%%%%").replace(goog.i18n.bidi.rightRe_, goog.i18n.bidi.LEFT).replace(goog.i18n.bidi.tempRe_, goog.i18n.bidi.RIGHT);
          }, goog.i18n.bidi.doubleQuoteSubstituteRe_ = /([\u0591-\u05f2])"/g, goog.i18n.bidi.singleQuoteSubstituteRe_ = /([\u0591-\u05f2])'/g, goog.i18n.bidi.normalizeHebrewQuote = function(a2) {
            return a2.replace(goog.i18n.bidi.doubleQuoteSubstituteRe_, "$1״").replace(goog.i18n.bidi.singleQuoteSubstituteRe_, "$1׳");
          }, goog.i18n.bidi.wordSeparatorRe_ = /\s+/, goog.i18n.bidi.hasNumeralsRe_ = /[\d\u06f0-\u06f9]/, goog.i18n.bidi.rtlDetectionThreshold_ = 0.4, goog.i18n.bidi.estimateDirection = function(a2, b2) {
            var c$12 = 0, d2 = 0, e2 = false;
            for (a2 = goog.i18n.bidi.stripHtmlIfNeeded_(a2, b2).split(goog.i18n.bidi.wordSeparatorRe_), b2 = 0; b2 < a2.length; b2++) {
              var f2 = a2[b2];
              goog.i18n.bidi.startsWithRtl(f2) ? (c$12++, d2++) : goog.i18n.bidi.isRequiredLtrRe_.test(f2) ? e2 = true : goog.i18n.bidi.hasAnyLtr(f2) ? d2++ : goog.i18n.bidi.hasNumeralsRe_.test(f2) && (e2 = true);
            }
            return d2 == 0 ? e2 ? goog.i18n.bidi.Dir.LTR : goog.i18n.bidi.Dir.NEUTRAL : c$12 / d2 > goog.i18n.bidi.rtlDetectionThreshold_ ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
          }, goog.i18n.bidi.detectRtlDirectionality = function(a2, b2) {
            return goog.i18n.bidi.estimateDirection(a2, b2) == goog.i18n.bidi.Dir.RTL;
          }, goog.i18n.bidi.setElementDirAndAlign = function(a2, b2) {
            a2 && (b2 = goog.i18n.bidi.toDir(b2)) && (a2.style.textAlign = b2 == goog.i18n.bidi.Dir.RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, a2.dir = b2 == goog.i18n.bidi.Dir.RTL ? "rtl" : "ltr");
          }, goog.i18n.bidi.setElementDirByTextDirectionality = function(a2, b2) {
            switch (goog.i18n.bidi.estimateDirection(b2)) {
              case goog.i18n.bidi.Dir.LTR:
                a2.dir !== "ltr" && (a2.dir = "ltr");
                break;
              case goog.i18n.bidi.Dir.RTL:
                a2.dir !== "rtl" && (a2.dir = "rtl");
                break;
              default:
                a2.removeAttribute("dir");
            }
          }, goog.i18n.bidi.DirectionalString = function() {
          }, goog.html.TrustedResourceUrl = function(a2, b2) {
            this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = b2 === goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_ ? a2 : "";
          }, goog.html.TrustedResourceUrl.prototype.implementsGoogStringTypedString = true, goog.html.TrustedResourceUrl.prototype.getTypedStringValue = function() {
            return this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_.toString();
          }, goog.html.TrustedResourceUrl.prototype.implementsGoogI18nBidiDirectionalString = true, goog.html.TrustedResourceUrl.prototype.getDirection = function() {
            return goog.i18n.bidi.Dir.LTR;
          }, goog.html.TrustedResourceUrl.prototype.cloneWithParams = function(a2, b2) {
            var c$12 = goog.html.TrustedResourceUrl.unwrap(this);
            c$12 = goog.html.TrustedResourceUrl.URL_PARAM_PARSER_.exec(c$12);
            var d2 = c$12[3] || "";
            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(c$12[1] + goog.html.TrustedResourceUrl.stringifyParams_("?", c$12[2] || "", a2) + goog.html.TrustedResourceUrl.stringifyParams_("#", d2, b2));
          }, goog.DEBUG && (goog.html.TrustedResourceUrl.prototype.toString = function() {
            return "TrustedResourceUrl{" + this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ + "}";
          }), goog.html.TrustedResourceUrl.unwrap = function(a2) {
            return goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(a2).toString();
          }, goog.html.TrustedResourceUrl.unwrapTrustedScriptURL = function(a2) {
            return a2 instanceof goog.html.TrustedResourceUrl && a2.constructor === goog.html.TrustedResourceUrl ? a2.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ : (goog.asserts.fail("expected object of type TrustedResourceUrl, got '" + a2 + "' of type " + goog.typeOf(a2)), "type_error:TrustedResourceUrl");
          }, goog.html.TrustedResourceUrl.format = function(a2, b2) {
            var c$12 = goog.string.Const.unwrap(a2);
            if (!goog.html.TrustedResourceUrl.BASE_URL_.test(c$12)) throw Error("Invalid TrustedResourceUrl format: " + c$12);
            return a2 = c$12.replace(goog.html.TrustedResourceUrl.FORMAT_MARKER_, function(d2, e2) {
              if (!Object.prototype.hasOwnProperty.call(b2, e2)) throw Error('Found marker, "' + e2 + '", in format string, "' + c$12 + '", but no valid label mapping found in args: ' + JSON.stringify(b2));
              return d2 = b2[e2], d2 instanceof goog.string.Const ? goog.string.Const.unwrap(d2) : encodeURIComponent(String(d2));
            }), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(a2);
          }, goog.html.TrustedResourceUrl.FORMAT_MARKER_ = /%{(\w+)}/g, goog.html.TrustedResourceUrl.BASE_URL_ = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i, goog.html.TrustedResourceUrl.URL_PARAM_PARSER_ = /^([^?#]*)(\?[^#]*)?(#[\s\S]*)?/, goog.html.TrustedResourceUrl.formatWithParams = function(a2, b2, c$12, d2) {
            return goog.html.TrustedResourceUrl.format(a2, b2).cloneWithParams(c$12, d2);
          }, goog.html.TrustedResourceUrl.fromConstant = function(a2) {
            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a2));
          }, goog.html.TrustedResourceUrl.fromConstants = function(a2) {
            for (var b2 = "", c$12 = 0; c$12 < a2.length; c$12++) b2 += goog.string.Const.unwrap(a2[c$12]);
            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b2);
          }, goog.html.TrustedResourceUrl.fromSafeScript = function(a2) {
            return a2 = goog.fs.blob.getBlobWithProperties([module$contents$goog$html$SafeScript_SafeScript.unwrap(a2)], "text/javascript"), a2 = goog.fs.url.createObjectUrl(a2), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(a2);
          }, goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse = function(a2) {
            var b2 = goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();
            return a2 = b2 ? b2.createScriptURL(a2) : a2, new goog.html.TrustedResourceUrl(a2, goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_);
          }, goog.html.TrustedResourceUrl.stringifyParams_ = function(a2, b2, c$12) {
            if (c$12 == null) return b2;
            if (typeof c$12 == "string") return c$12 ? a2 + encodeURIComponent(c$12) : "";
            for (var d2 in c$12) if (Object.prototype.hasOwnProperty.call(c$12, d2)) {
              var e2 = c$12[d2];
              e2 = Array.isArray(e2) ? e2 : [e2];
              for (var f2 = 0; f2 < e2.length; f2++) {
                var g2 = e2[f2];
                g2 != null && (b2 ||= a2, b2 += (b2.length > a2.length ? "&" : "") + encodeURIComponent(d2) + "=" + encodeURIComponent(String(g2)));
              }
            }
            return b2;
          }, goog.string.internal = {}, goog.string.internal.startsWith = function(a2, b2) {
            return a2.lastIndexOf(b2, 0) == 0;
          }, goog.string.internal.endsWith = function(a2, b2) {
            var c$12 = a2.length - b2.length;
            return 0 <= c$12 && a2.indexOf(b2, c$12) == c$12;
          }, goog.string.internal.caseInsensitiveStartsWith = function(a2, b2) {
            return goog.string.internal.caseInsensitiveCompare(b2, a2.substr(0, b2.length)) == 0;
          }, goog.string.internal.caseInsensitiveEndsWith = function(a2, b2) {
            return goog.string.internal.caseInsensitiveCompare(b2, a2.substr(a2.length - b2.length, b2.length)) == 0;
          }, goog.string.internal.caseInsensitiveEquals = function(a2, b2) {
            return a2.toLowerCase() == b2.toLowerCase();
          }, goog.string.internal.isEmptyOrWhitespace = function(a2) {
            return /^[\s\xa0]*$/.test(a2);
          }, goog.string.internal.trim = goog.TRUSTED_SITE && String.prototype.trim ? function(a2) {
            return a2.trim();
          } : function(a2) {
            return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a2)[1];
          }, goog.string.internal.caseInsensitiveCompare = function(a2, b2) {
            return a2 = String(a2).toLowerCase(), b2 = String(b2).toLowerCase(), a2 < b2 ? -1 : a2 == b2 ? 0 : 1;
          }, goog.string.internal.newLineToBr = function(a2, b2) {
            return a2.replace(/(\r\n|\r|\n)/g, b2 ? "<br />" : "<br>");
          }, goog.string.internal.htmlEscape = function(a2, b2) {
            if (b2) a2 = a2.replace(goog.string.internal.AMP_RE_, "&amp;").replace(goog.string.internal.LT_RE_, "&lt;").replace(goog.string.internal.GT_RE_, "&gt;").replace(goog.string.internal.QUOT_RE_, "&quot;").replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;").replace(goog.string.internal.NULL_RE_, "&#0;");
            else {
              if (!goog.string.internal.ALL_RE_.test(a2)) return a2;
              a2.indexOf("&") != -1 && (a2 = a2.replace(goog.string.internal.AMP_RE_, "&amp;")), a2.indexOf("<") != -1 && (a2 = a2.replace(goog.string.internal.LT_RE_, "&lt;")), a2.indexOf(">") != -1 && (a2 = a2.replace(goog.string.internal.GT_RE_, "&gt;")), a2.indexOf('"') != -1 && (a2 = a2.replace(goog.string.internal.QUOT_RE_, "&quot;")), a2.indexOf("'") != -1 && (a2 = a2.replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;")), a2.indexOf("\0") != -1 && (a2 = a2.replace(goog.string.internal.NULL_RE_, "&#0;"));
            }
            return a2;
          }, goog.string.internal.AMP_RE_ = /&/g, goog.string.internal.LT_RE_ = /</g, goog.string.internal.GT_RE_ = />/g, goog.string.internal.QUOT_RE_ = /"/g, goog.string.internal.SINGLE_QUOTE_RE_ = /'/g, goog.string.internal.NULL_RE_ = /\x00/g, goog.string.internal.ALL_RE_ = /[\x00&<>"']/, goog.string.internal.whitespaceEscape = function(a2, b2) {
            return goog.string.internal.newLineToBr(a2.replace(/  /g, " &#160;"), b2);
          }, goog.string.internal.contains = function(a2, b2) {
            return a2.indexOf(b2) != -1;
          }, goog.string.internal.caseInsensitiveContains = function(a2, b2) {
            return goog.string.internal.contains(a2.toLowerCase(), b2.toLowerCase());
          }, goog.string.internal.compareVersions = function(a2, b2) {
            var c$12 = 0;
            a2 = goog.string.internal.trim(String(a2)).split("."), b2 = goog.string.internal.trim(String(b2)).split(".");
            for (var d2 = Math.max(a2.length, b2.length), e2 = 0; c$12 == 0 && e2 < d2; e2++) {
              var f2 = a2[e2] || "", g2 = b2[e2] || "";
              do {
                if (f2 = /(\d*)(\D*)(.*)/.exec(f2) || [
                  "",
                  "",
                  "",
                  ""
                ], g2 = /(\d*)(\D*)(.*)/.exec(g2) || [
                  "",
                  "",
                  "",
                  ""
                ], f2[0].length == 0 && g2[0].length == 0) break;
                c$12 = f2[1].length == 0 ? 0 : parseInt(f2[1], 10);
                var h = g2[1].length == 0 ? 0 : parseInt(g2[1], 10);
                c$12 = goog.string.internal.compareElements_(c$12, h) || goog.string.internal.compareElements_(f2[2].length == 0, g2[2].length == 0) || goog.string.internal.compareElements_(f2[2], g2[2]), f2 = f2[3], g2 = g2[3];
              } while (c$12 == 0);
            }
            return c$12;
          }, goog.string.internal.compareElements_ = function(a2, b2) {
            return a2 < b2 ? -1 : a2 > b2 ? 1 : 0;
          }, goog.html.SafeUrl = function(a2, b2) {
            this.privateDoNotAccessOrElseSafeUrlWrappedValue_ = b2 === goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_ ? a2 : "";
          }, goog.html.SafeUrl.INNOCUOUS_STRING = "about:invalid#zClosurez", goog.html.SafeUrl.prototype.implementsGoogStringTypedString = true, goog.html.SafeUrl.prototype.getTypedStringValue = function() {
            return this.privateDoNotAccessOrElseSafeUrlWrappedValue_.toString();
          }, goog.html.SafeUrl.prototype.implementsGoogI18nBidiDirectionalString = true, goog.html.SafeUrl.prototype.getDirection = function() {
            return goog.i18n.bidi.Dir.LTR;
          }, goog.DEBUG && (goog.html.SafeUrl.prototype.toString = function() {
            return "SafeUrl{" + this.privateDoNotAccessOrElseSafeUrlWrappedValue_ + "}";
          }), goog.html.SafeUrl.unwrap = function(a2) {
            return a2 instanceof goog.html.SafeUrl && a2.constructor === goog.html.SafeUrl ? a2.privateDoNotAccessOrElseSafeUrlWrappedValue_ : (goog.asserts.fail("expected object of type SafeUrl, got '" + a2 + "' of type " + goog.typeOf(a2)), "type_error:SafeUrl");
          }, goog.html.SafeUrl.fromConstant = function(a2) {
            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a2));
          }, goog.html.SAFE_MIME_TYPE_PATTERN_ = /^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-matroska|x-wav|wav|webm)|font\/\w+|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|video\/(?:mpeg|mp4|ogg|webm|quicktime|x-matroska))(?:;\w+=(?:\w+|"[\w;,= ]+"))*$/i, goog.html.SafeUrl.isSafeMimeType = function(a2) {
            return goog.html.SAFE_MIME_TYPE_PATTERN_.test(a2);
          }, goog.html.SafeUrl.fromBlob = function(a2) {
            return a2 = goog.html.SafeUrl.isSafeMimeType(a2.type) ? goog.fs.url.createObjectUrl(a2) : goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
          }, goog.html.SafeUrl.revokeObjectUrl = function(a2) {
            a2 = a2.getTypedStringValue(), a2 !== goog.html.SafeUrl.INNOCUOUS_STRING && goog.fs.url.revokeObjectUrl(a2);
          }, goog.html.SafeUrl.fromMediaSource = function(a2) {
            return goog.asserts.assert("MediaSource" in goog.global, "No support for MediaSource"), a2 = a2 instanceof MediaSource ? goog.fs.url.createObjectUrl(a2) : goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
          }, goog.html.DATA_URL_PATTERN_ = /^data:(.*);base64,[a-z0-9+\/]+=*$/i, goog.html.SafeUrl.tryFromDataUrl = function(a2) {
            a2 = String(a2), a2 = a2.replace(/(%0A|%0D)/g, "");
            var b2 = a2.match(goog.html.DATA_URL_PATTERN_);
            return b2 && goog.html.SafeUrl.isSafeMimeType(b2[1]) ? goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2) : null;
          }, goog.html.SafeUrl.fromDataUrl = function(a2) {
            return goog.html.SafeUrl.tryFromDataUrl(a2) || goog.html.SafeUrl.INNOCUOUS_URL;
          }, goog.html.SafeUrl.fromTelUrl = function(a2) {
            return goog.string.internal.caseInsensitiveStartsWith(a2, "tel:") || (a2 = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
          }, goog.html.SIP_URL_PATTERN_ = /^sip[s]?:[+a-z0-9_.!$%&'*\/=^`{|}~-]+@([a-z0-9-]+\.)+[a-z0-9]{2,63}$/i, goog.html.SafeUrl.fromSipUrl = function(a2) {
            return goog.html.SIP_URL_PATTERN_.test(decodeURIComponent(a2)) || (a2 = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
          }, goog.html.SafeUrl.fromFacebookMessengerUrl = function(a2) {
            return goog.string.internal.caseInsensitiveStartsWith(a2, "fb-messenger://share") || (a2 = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
          }, goog.html.SafeUrl.fromWhatsAppUrl = function(a2) {
            return goog.string.internal.caseInsensitiveStartsWith(a2, "whatsapp://send") || (a2 = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
          }, goog.html.SafeUrl.fromSmsUrl = function(a2) {
            return goog.string.internal.caseInsensitiveStartsWith(a2, "sms:") && goog.html.SafeUrl.isSmsUrlBodyValid_(a2) || (a2 = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
          }, goog.html.SafeUrl.isSmsUrlBodyValid_ = function(a2) {
            var b2 = a2.indexOf("#");
            return 0 < b2 && (a2 = a2.substring(0, b2)), b2 = a2.match(/[?&]body=/gi), b2 ? 1 < b2.length ? false : (a2 = a2.match(/[?&]body=([^&]*)/)[1], a2 ? /^(?:[a-z0-9\-_.~]|%[0-9a-f]{2})+$/i.test(a2) : true) : true;
          }, goog.html.SafeUrl.fromSshUrl = function(a2) {
            return goog.string.internal.caseInsensitiveStartsWith(a2, "ssh://") || (a2 = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
          }, goog.html.SafeUrl.sanitizeChromeExtensionUrl = function(a2, b2) {
            return goog.html.SafeUrl.sanitizeExtensionUrl_(/^chrome-extension:\/\/([^\/]+)\//, a2, b2);
          }, goog.html.SafeUrl.sanitizeFirefoxExtensionUrl = function(a2, b2) {
            return goog.html.SafeUrl.sanitizeExtensionUrl_(/^moz-extension:\/\/([^\/]+)\//, a2, b2);
          }, goog.html.SafeUrl.sanitizeEdgeExtensionUrl = function(a2, b2) {
            return goog.html.SafeUrl.sanitizeExtensionUrl_(/^ms-browser-extension:\/\/([^\/]+)\//, a2, b2);
          }, goog.html.SafeUrl.sanitizeExtensionUrl_ = function(a2, b2, c$12) {
            return (a2 = a2.exec(b2)) ? (a2 = a2[1], (c$12 instanceof goog.string.Const ? [goog.string.Const.unwrap(c$12)] : c$12.map(function(d2) {
              return goog.string.Const.unwrap(d2);
            })).indexOf(a2) == -1 && (b2 = goog.html.SafeUrl.INNOCUOUS_STRING)) : b2 = goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b2);
          }, goog.html.SafeUrl.fromTrustedResourceUrl = function(a2) {
            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.TrustedResourceUrl.unwrap(a2));
          }, goog.html.SAFE_URL_PATTERN_ = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i, goog.html.SafeUrl.SAFE_URL_PATTERN = goog.html.SAFE_URL_PATTERN_, goog.html.SafeUrl.trySanitize = function(a2) {
            return a2 instanceof goog.html.SafeUrl ? a2 : (a2 = typeof a2 == "object" && a2.implementsGoogStringTypedString ? a2.getTypedStringValue() : String(a2), goog.html.SAFE_URL_PATTERN_.test(a2) ? goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2) : goog.html.SafeUrl.tryFromDataUrl(a2));
          }, goog.html.SafeUrl.sanitize = function(a2) {
            return goog.html.SafeUrl.trySanitize(a2) || goog.html.SafeUrl.INNOCUOUS_URL;
          }, goog.html.SafeUrl.sanitizeAssertUnchanged = function(a2, b2) {
            return a2 instanceof goog.html.SafeUrl ? a2 : (a2 = typeof a2 == "object" && a2.implementsGoogStringTypedString ? a2.getTypedStringValue() : String(a2), b2 && /^data:/i.test(a2) && (b2 = goog.html.SafeUrl.fromDataUrl(a2), b2.getTypedStringValue() == a2) ? b2 : (goog.asserts.assert(goog.html.SAFE_URL_PATTERN_.test(a2), "%s does not match the safe URL pattern", a2) || (a2 = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2)));
          }, goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse = function(a2) {
            return new goog.html.SafeUrl(a2, goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_);
          }, goog.html.SafeUrl.INNOCUOUS_URL = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.ABOUT_BLANK = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse("about:blank"), goog.html.SafeStyle = function(a2, b2) {
            this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = b2 === goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_ ? a2 : "";
          }, goog.html.SafeStyle.prototype.implementsGoogStringTypedString = true, goog.html.SafeStyle.fromConstant = function(a2) {
            return a2 = goog.string.Const.unwrap(a2), a2.length === 0 ? goog.html.SafeStyle.EMPTY : (goog.asserts.assert(goog.string.internal.endsWith(a2, ";"), "Last character of style string is not ';': " + a2), goog.asserts.assert(goog.string.internal.contains(a2, ":"), `Style string must contain at least one ':', to specify a "name: value" pair: ` + a2), goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(a2));
          }, goog.html.SafeStyle.prototype.getTypedStringValue = function() {
            return this.privateDoNotAccessOrElseSafeStyleWrappedValue_;
          }, goog.DEBUG && (goog.html.SafeStyle.prototype.toString = function() {
            return "SafeStyle{" + this.privateDoNotAccessOrElseSafeStyleWrappedValue_ + "}";
          }), goog.html.SafeStyle.unwrap = function(a2) {
            return a2 instanceof goog.html.SafeStyle && a2.constructor === goog.html.SafeStyle ? a2.privateDoNotAccessOrElseSafeStyleWrappedValue_ : (goog.asserts.fail("expected object of type SafeStyle, got '" + a2 + "' of type " + goog.typeOf(a2)), "type_error:SafeStyle");
          }, goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse = function(a2) {
            return new goog.html.SafeStyle(a2, goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_);
          }, goog.html.SafeStyle.EMPTY = goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(""), goog.html.SafeStyle.INNOCUOUS_STRING = "zClosurez", goog.html.SafeStyle.create = function(a2) {
            var b2 = "", c$12;
            for (c$12 in a2) if (Object.prototype.hasOwnProperty.call(a2, c$12)) {
              if (!/^[-_a-zA-Z0-9]+$/.test(c$12)) throw Error("Name allows only [-_a-zA-Z0-9], got: " + c$12);
              var d2 = a2[c$12];
              d2 != null && (d2 = Array.isArray(d2) ? module$contents$goog$array_map(d2, goog.html.SafeStyle.sanitizePropertyValue_).join(" ") : goog.html.SafeStyle.sanitizePropertyValue_(d2), b2 += c$12 + ":" + d2 + ";");
            }
            return b2 ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b2) : goog.html.SafeStyle.EMPTY;
          }, goog.html.SafeStyle.sanitizePropertyValue_ = function(a2) {
            if (a2 instanceof goog.html.SafeUrl) return 'url("' + goog.html.SafeUrl.unwrap(a2).replace(/</g, "%3c").replace(/[\\"]/g, "\\$&") + '")';
            if (a2 = a2 instanceof goog.string.Const ? goog.string.Const.unwrap(a2) : goog.html.SafeStyle.sanitizePropertyValueString_(String(a2)), /[{;}]/.test(a2)) throw new goog.asserts.AssertionError("Value does not allow [{;}], got: %s.", [a2]);
            return a2;
          }, goog.html.SafeStyle.sanitizePropertyValueString_ = function(a2) {
            var b2 = a2.replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.URL_RE_, "url");
            if (goog.html.SafeStyle.VALUE_RE_.test(b2)) {
              if (goog.html.SafeStyle.COMMENT_RE_.test(a2)) return goog.asserts.fail("String value disallows comments, got: " + a2), goog.html.SafeStyle.INNOCUOUS_STRING;
              if (!goog.html.SafeStyle.hasBalancedQuotes_(a2)) return goog.asserts.fail("String value requires balanced quotes, got: " + a2), goog.html.SafeStyle.INNOCUOUS_STRING;
              if (!goog.html.SafeStyle.hasBalancedSquareBrackets_(a2)) return goog.asserts.fail("String value requires balanced square brackets and one identifier per pair of brackets, got: " + a2), goog.html.SafeStyle.INNOCUOUS_STRING;
            } else return goog.asserts.fail("String value allows only " + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + " and simple functions, got: " + a2), goog.html.SafeStyle.INNOCUOUS_STRING;
            return goog.html.SafeStyle.sanitizeUrl_(a2);
          }, goog.html.SafeStyle.hasBalancedQuotes_ = function(a2) {
            for (var b2 = true, c$12 = true, d2 = 0; d2 < a2.length; d2++) {
              var e2 = a2.charAt(d2);
              e2 == "'" && c$12 ? b2 = !b2 : e2 == '"' && b2 && (c$12 = !c$12);
            }
            return b2 && c$12;
          }, goog.html.SafeStyle.hasBalancedSquareBrackets_ = function(a2) {
            for (var b2 = true, c$12 = /^[-_a-zA-Z0-9]$/, d2 = 0; d2 < a2.length; d2++) {
              var e2 = a2.charAt(d2);
              if (e2 == "]") {
                if (b2) return false;
                b2 = true;
              } else if (e2 == "[") {
                if (!b2) return false;
                b2 = false;
              } else if (!b2 && !c$12.test(e2)) return false;
            }
            return b2;
          }, goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ = `[-,."'%_!# a-zA-Z0-9\\[\\]]`, goog.html.SafeStyle.VALUE_RE_ = /* @__PURE__ */ RegExp("^" + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + "+$"), goog.html.SafeStyle.URL_RE_ = /\b(url\([ \t\n]*)('[ -&(-\[\]-~]*'|"[ !#-\[\]-~]*"|[!#-&*-\[\]-~]*)([ \t\n]*\))/g, goog.html.SafeStyle.ALLOWED_FUNCTIONS_ = "calc cubic-bezier fit-content hsl hsla linear-gradient matrix minmax repeat rgb rgba (rotate|scale|translate)(X|Y|Z|3d)?".split(" "), goog.html.SafeStyle.FUNCTIONS_RE_ = RegExp("\\b(" + goog.html.SafeStyle.ALLOWED_FUNCTIONS_.join("|") + ")\\([-+*/0-9a-z.%\\[\\], ]+\\)", "g"), goog.html.SafeStyle.COMMENT_RE_ = /\/\*/, goog.html.SafeStyle.sanitizeUrl_ = function(a2) {
            return a2.replace(goog.html.SafeStyle.URL_RE_, function(b2, c$12, d2, e2) {
              var f2 = "";
              return d2 = d2.replace(/^(['"])(.*)\1$/, function(g2, h, k) {
                return f2 = h, k;
              }), b2 = goog.html.SafeUrl.sanitize(d2).getTypedStringValue(), c$12 + f2 + b2 + f2 + e2;
            });
          }, goog.html.SafeStyle.concat = function(a2) {
            var b2 = "", c$12 = function(d2) {
              Array.isArray(d2) ? module$contents$goog$array_forEach(d2, c$12) : b2 += goog.html.SafeStyle.unwrap(d2);
            };
            return module$contents$goog$array_forEach(arguments, c$12), b2 ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b2) : goog.html.SafeStyle.EMPTY;
          };
          var module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE = {}, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet = function(a2, b2) {
            this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = b2 === module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE ? a2 : "", this.implementsGoogStringTypedString = true;
          };
          module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createRule = function(a2, b2) {
            if ((0, goog.string.internal.contains)(a2, "<")) throw Error("Selector does not allow '<', got: " + a2);
            var c$12 = a2.replace(/('|")((?!\1)[^\r\n\f\\]|\\[\s\S])*\1/g, "");
            if (!/^[-_a-zA-Z0-9#.:* ,>+~[\]()=^$|]+$/.test(c$12)) throw Error("Selector allows only [-_a-zA-Z0-9#.:* ,>+~[\\]()=^$|] and strings, got: " + a2);
            if (!module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.hasBalancedBrackets_(c$12)) throw Error("() and [] in selector must be balanced, got: " + a2);
            return b2 instanceof goog.html.SafeStyle || (b2 = goog.html.SafeStyle.create(b2)), a2 = a2 + "{" + goog.html.SafeStyle.unwrap(b2).replace(/</g, "\\3C ") + "}", module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a2);
          }, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.hasBalancedBrackets_ = function(a2) {
            for (var b2 = {
              "(": ")",
              "[": "]"
            }, c$12 = [], d2 = 0; d2 < a2.length; d2++) {
              var e2 = a2[d2];
              if (b2[e2]) c$12.push(b2[e2]);
              else if (goog.object.contains(b2, e2) && c$12.pop() != e2) return false;
            }
            return c$12.length == 0;
          }, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.concat = function(a2) {
            var b2 = "", c$12 = function(d2) {
              Array.isArray(d2) ? module$contents$goog$array_forEach(d2, c$12) : b2 += module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap(d2);
            };
            return module$contents$goog$array_forEach(arguments, c$12), module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b2);
          }, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.fromConstant = function(a2) {
            return a2 = goog.string.Const.unwrap(a2), a2.length === 0 ? module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.EMPTY : ((0, goog.asserts.assert)(!(0, goog.string.internal.contains)(a2, "<"), "Forbidden '<' character in style sheet string: " + a2), module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a2));
          }, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.prototype.getTypedStringValue = function() {
            return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
          }, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap = function(a2) {
            return a2 instanceof module$contents$goog$html$SafeStyleSheet_SafeStyleSheet && a2.constructor === module$contents$goog$html$SafeStyleSheet_SafeStyleSheet ? a2.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ : ((0, goog.asserts.fail)("expected object of type SafeStyleSheet, got '" + a2 + "' of type " + goog.typeOf(a2)), "type_error:SafeStyleSheet");
          }, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse = function(a2) {
            return new module$contents$goog$html$SafeStyleSheet_SafeStyleSheet(a2, module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE);
          }, goog.DEBUG && (module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.prototype.toString = function() {
            return "SafeStyleSheet{" + this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ + "}";
          }), module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.EMPTY = module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(""), goog.html.SafeStyleSheet = module$contents$goog$html$SafeStyleSheet_SafeStyleSheet, goog.labs = {}, goog.labs.userAgent = {}, goog.labs.userAgent.util = {}, goog.labs.userAgent.util.getNativeUserAgentString_ = function() {
            var a2 = goog.labs.userAgent.util.getNavigator_();
            return (a2 &&= a2.userAgent) ? a2 : "";
          }, goog.labs.userAgent.util.getNavigator_ = function() {
            return goog.global.navigator;
          }, goog.labs.userAgent.util.userAgent_ = goog.labs.userAgent.util.getNativeUserAgentString_(), goog.labs.userAgent.util.setUserAgent = function(a2) {
            goog.labs.userAgent.util.userAgent_ = a2 || goog.labs.userAgent.util.getNativeUserAgentString_();
          }, goog.labs.userAgent.util.getUserAgent = function() {
            return goog.labs.userAgent.util.userAgent_;
          }, goog.labs.userAgent.util.matchUserAgent = function(a2) {
            var b2 = goog.labs.userAgent.util.getUserAgent();
            return goog.string.internal.contains(b2, a2);
          }, goog.labs.userAgent.util.matchUserAgentIgnoreCase = function(a2) {
            var b2 = goog.labs.userAgent.util.getUserAgent();
            return goog.string.internal.caseInsensitiveContains(b2, a2);
          }, goog.labs.userAgent.util.extractVersionTuples = function(a2) {
            for (var b2 = /(\w[\w ]+)\/([^\s]+)\s*(?:\((.*?)\))?/g, c$12 = [], d2; d2 = b2.exec(a2); ) c$12.push([
              d2[1],
              d2[2],
              d2[3] || void 0
            ]);
            return c$12;
          }, goog.labs.userAgent.browser = {}, goog.labs.userAgent.browser.matchOpera_ = function() {
            return goog.labs.userAgent.util.matchUserAgent("Opera");
          }, goog.labs.userAgent.browser.matchIE_ = function() {
            return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
          }, goog.labs.userAgent.browser.matchEdgeHtml_ = function() {
            return goog.labs.userAgent.util.matchUserAgent("Edge");
          }, goog.labs.userAgent.browser.matchEdgeChromium_ = function() {
            return goog.labs.userAgent.util.matchUserAgent("Edg/");
          }, goog.labs.userAgent.browser.matchOperaChromium_ = function() {
            return goog.labs.userAgent.util.matchUserAgent("OPR");
          }, goog.labs.userAgent.browser.matchFirefox_ = function() {
            return goog.labs.userAgent.util.matchUserAgent("Firefox") || goog.labs.userAgent.util.matchUserAgent("FxiOS");
          }, goog.labs.userAgent.browser.matchSafari_ = function() {
            return goog.labs.userAgent.util.matchUserAgent("Safari") && !(goog.labs.userAgent.browser.matchChrome_() || goog.labs.userAgent.browser.matchCoast_() || goog.labs.userAgent.browser.matchOpera_() || goog.labs.userAgent.browser.matchEdgeHtml_() || goog.labs.userAgent.browser.matchEdgeChromium_() || goog.labs.userAgent.browser.matchOperaChromium_() || goog.labs.userAgent.browser.matchFirefox_() || goog.labs.userAgent.browser.isSilk() || goog.labs.userAgent.util.matchUserAgent("Android"));
          }, goog.labs.userAgent.browser.matchCoast_ = function() {
            return goog.labs.userAgent.util.matchUserAgent("Coast");
          }, goog.labs.userAgent.browser.matchIosWebview_ = function() {
            return (goog.labs.userAgent.util.matchUserAgent("iPad") || goog.labs.userAgent.util.matchUserAgent("iPhone")) && !goog.labs.userAgent.browser.matchSafari_() && !goog.labs.userAgent.browser.matchChrome_() && !goog.labs.userAgent.browser.matchCoast_() && !goog.labs.userAgent.browser.matchFirefox_() && goog.labs.userAgent.util.matchUserAgent("AppleWebKit");
          }, goog.labs.userAgent.browser.matchChrome_ = function() {
            return (goog.labs.userAgent.util.matchUserAgent("Chrome") || goog.labs.userAgent.util.matchUserAgent("CriOS")) && !goog.labs.userAgent.browser.matchEdgeHtml_();
          }, goog.labs.userAgent.browser.matchAndroidBrowser_ = function() {
            return goog.labs.userAgent.util.matchUserAgent("Android") && !(goog.labs.userAgent.browser.isChrome() || goog.labs.userAgent.browser.isFirefox() || goog.labs.userAgent.browser.isOpera() || goog.labs.userAgent.browser.isSilk());
          }, goog.labs.userAgent.browser.isOpera = goog.labs.userAgent.browser.matchOpera_, goog.labs.userAgent.browser.isIE = goog.labs.userAgent.browser.matchIE_, goog.labs.userAgent.browser.isEdge = goog.labs.userAgent.browser.matchEdgeHtml_, goog.labs.userAgent.browser.isEdgeChromium = goog.labs.userAgent.browser.matchEdgeChromium_, goog.labs.userAgent.browser.isOperaChromium = goog.labs.userAgent.browser.matchOperaChromium_, goog.labs.userAgent.browser.isFirefox = goog.labs.userAgent.browser.matchFirefox_, goog.labs.userAgent.browser.isSafari = goog.labs.userAgent.browser.matchSafari_, goog.labs.userAgent.browser.isCoast = goog.labs.userAgent.browser.matchCoast_, goog.labs.userAgent.browser.isIosWebview = goog.labs.userAgent.browser.matchIosWebview_, goog.labs.userAgent.browser.isChrome = goog.labs.userAgent.browser.matchChrome_, goog.labs.userAgent.browser.isAndroidBrowser = goog.labs.userAgent.browser.matchAndroidBrowser_, goog.labs.userAgent.browser.isSilk = function() {
            return goog.labs.userAgent.util.matchUserAgent("Silk");
          }, goog.labs.userAgent.browser.getVersion = function() {
            function a2(e2) {
              return e2 = module$contents$goog$array_find(e2, d2), c$12[e2] || "";
            }
            var b2 = goog.labs.userAgent.util.getUserAgent();
            if (goog.labs.userAgent.browser.isIE()) return goog.labs.userAgent.browser.getIEVersion_(b2);
            b2 = goog.labs.userAgent.util.extractVersionTuples(b2);
            var c$12 = {};
            module$contents$goog$array_forEach(b2, function(e2) {
              c$12[e2[0]] = e2[1];
            });
            var d2 = goog.partial(goog.object.containsKey, c$12);
            return goog.labs.userAgent.browser.isOpera() ? a2(["Version", "Opera"]) : goog.labs.userAgent.browser.isEdge() ? a2(["Edge"]) : goog.labs.userAgent.browser.isEdgeChromium() ? a2(["Edg"]) : goog.labs.userAgent.browser.isChrome() ? a2([
              "Chrome",
              "CriOS",
              "HeadlessChrome"
            ]) : (b2 = b2[2]) && b2[1] || "";
          }, goog.labs.userAgent.browser.isVersionOrHigher = function(a2) {
            return 0 <= goog.string.internal.compareVersions(goog.labs.userAgent.browser.getVersion(), a2);
          }, goog.labs.userAgent.browser.getIEVersion_ = function(a2) {
            var b2 = /rv: *([\d\.]*)/.exec(a2);
            if (b2 && b2[1]) return b2[1];
            b2 = "";
            var c$12 = /MSIE +([\d\.]+)/.exec(a2);
            if (c$12 && c$12[1]) if (a2 = /Trident\/(\d.\d)/.exec(a2), c$12[1] == "7.0") if (a2 && a2[1]) switch (a2[1]) {
              case "4.0":
                b2 = "8.0";
                break;
              case "5.0":
                b2 = "9.0";
                break;
              case "6.0":
                b2 = "10.0";
                break;
              case "7.0":
                b2 = "11.0";
            }
            else b2 = "7.0";
            else b2 = c$12[1];
            return b2;
          }, goog.html.SafeHtml = function(a2, b2, c$12) {
            this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = c$12 === goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_ ? a2 : "", this.dir_ = b2;
          }, goog.html.SafeHtml.ENABLE_ERROR_MESSAGES = goog.DEBUG, goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE = true, goog.html.SafeHtml.prototype.implementsGoogI18nBidiDirectionalString = true, goog.html.SafeHtml.prototype.getDirection = function() {
            return this.dir_;
          }, goog.html.SafeHtml.prototype.implementsGoogStringTypedString = true, goog.html.SafeHtml.prototype.getTypedStringValue = function() {
            return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_.toString();
          }, goog.DEBUG && (goog.html.SafeHtml.prototype.toString = function() {
            return "SafeHtml{" + this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ + "}";
          }), goog.html.SafeHtml.unwrap = function(a2) {
            return goog.html.SafeHtml.unwrapTrustedHTML(a2).toString();
          }, goog.html.SafeHtml.unwrapTrustedHTML = function(a2) {
            return a2 instanceof goog.html.SafeHtml && a2.constructor === goog.html.SafeHtml ? a2.privateDoNotAccessOrElseSafeHtmlWrappedValue_ : (goog.asserts.fail("expected object of type SafeHtml, got '" + a2 + "' of type " + goog.typeOf(a2)), "type_error:SafeHtml");
          }, goog.html.SafeHtml.htmlEscape = function(a2) {
            if (a2 instanceof goog.html.SafeHtml) return a2;
            var b2 = typeof a2 == "object", c$12 = null;
            return b2 && a2.implementsGoogI18nBidiDirectionalString && (c$12 = a2.getDirection()), a2 = b2 && a2.implementsGoogStringTypedString ? a2.getTypedStringValue() : String(a2), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.htmlEscape(a2), c$12);
          }, goog.html.SafeHtml.htmlEscapePreservingNewlines = function(a2) {
            return a2 instanceof goog.html.SafeHtml ? a2 : (a2 = goog.html.SafeHtml.htmlEscape(a2), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.newLineToBr(goog.html.SafeHtml.unwrap(a2)), a2.getDirection()));
          }, goog.html.SafeHtml.htmlEscapePreservingNewlinesAndSpaces = function(a2) {
            return a2 instanceof goog.html.SafeHtml ? a2 : (a2 = goog.html.SafeHtml.htmlEscape(a2), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.whitespaceEscape(goog.html.SafeHtml.unwrap(a2)), a2.getDirection()));
          }, goog.html.SafeHtml.from = goog.html.SafeHtml.htmlEscape, goog.html.SafeHtml.comment = function(a2) {
            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!--" + goog.string.internal.htmlEscape(a2) + "-->", null);
          }, goog.html.SafeHtml.VALID_NAMES_IN_TAG_ = /^[a-zA-Z0-9-]+$/, goog.html.SafeHtml.URL_ATTRIBUTES_ = {
            action: true,
            cite: true,
            data: true,
            formaction: true,
            href: true,
            manifest: true,
            poster: true,
            src: true
          }, goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_ = goog.object.createSet(goog.dom.TagName.APPLET, goog.dom.TagName.BASE, goog.dom.TagName.EMBED, goog.dom.TagName.IFRAME, goog.dom.TagName.LINK, goog.dom.TagName.MATH, goog.dom.TagName.META, goog.dom.TagName.OBJECT, goog.dom.TagName.SCRIPT, goog.dom.TagName.STYLE, goog.dom.TagName.SVG, goog.dom.TagName.TEMPLATE), goog.html.SafeHtml.create = function(a2, b2, c$12) {
            return goog.html.SafeHtml.verifyTagName(String(a2)), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(String(a2), b2, c$12);
          }, goog.html.SafeHtml.verifyTagName = function(a2) {
            if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(a2)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "Invalid tag name <" + a2 + ">." : "");
            if (a2.toUpperCase() in goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "Tag name <" + a2 + "> is not allowed for SafeHtml." : "");
          }, goog.html.SafeHtml.createIframe = function(a2, b2, c$12, d2) {
            a2 && goog.html.TrustedResourceUrl.unwrap(a2);
            var e2 = {};
            return e2.src = a2 || null, e2.srcdoc = b2 && goog.html.SafeHtml.unwrap(b2), a2 = goog.html.SafeHtml.combineAttributes(e2, { sandbox: "" }, c$12), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", a2, d2);
          }, goog.html.SafeHtml.createSandboxIframe = function(a2, b2, c$12, d2) {
            if (!goog.html.SafeHtml.canUseSandboxIframe()) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "The browser does not support sandboxed iframes." : "");
            var e2 = {};
            return e2.src = a2 ? goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a2)) : null, e2.srcdoc = b2 || null, e2.sandbox = "", a2 = goog.html.SafeHtml.combineAttributes(e2, {}, c$12), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", a2, d2);
          }, goog.html.SafeHtml.canUseSandboxIframe = function() {
            return goog.global.HTMLIFrameElement && "sandbox" in goog.global.HTMLIFrameElement.prototype;
          }, goog.html.SafeHtml.createScriptSrc = function(a2, b2) {
            return goog.html.TrustedResourceUrl.unwrap(a2), a2 = goog.html.SafeHtml.combineAttributes({ src: a2 }, {}, b2), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", a2);
          }, goog.html.SafeHtml.createScript = function(a2, b2) {
            for (var c$12 in b2) if (Object.prototype.hasOwnProperty.call(b2, c$12)) {
              var d2 = c$12.toLowerCase();
              if (d2 == "language" || d2 == "src" || d2 == "text" || d2 == "type") throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Cannot set "' + d2 + '" attribute' : "");
            }
            for (c$12 = "", a2 = module$contents$goog$array_concat(a2), d2 = 0; d2 < a2.length; d2++) c$12 += module$contents$goog$html$SafeScript_SafeScript.unwrap(a2[d2]);
            return a2 = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c$12, goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", b2, a2);
          }, goog.html.SafeHtml.createStyle = function(a2, b2) {
            b2 = goog.html.SafeHtml.combineAttributes({ type: "text/css" }, {}, b2);
            var c$12 = "";
            a2 = module$contents$goog$array_concat(a2);
            for (var d2 = 0; d2 < a2.length; d2++) c$12 += module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap(a2[d2]);
            return a2 = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c$12, goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("style", b2, a2);
          }, goog.html.SafeHtml.createMetaRefresh = function(a2, b2) {
            return a2 = goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a2)), (goog.labs.userAgent.browser.isIE() || goog.labs.userAgent.browser.isEdge()) && goog.string.internal.contains(a2, ";") && (a2 = "'" + a2.replace(/'/g, "%27") + "'"), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("meta", {
              "http-equiv": "refresh",
              content: (b2 || 0) + "; url=" + a2
            });
          }, goog.html.SafeHtml.getAttrNameAndValue_ = function(a2, b2, c$12) {
            if (c$12 instanceof goog.string.Const) c$12 = goog.string.Const.unwrap(c$12);
            else if (b2.toLowerCase() == "style") if (goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE) c$12 = goog.html.SafeHtml.getStyleValue_(c$12);
            else throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "style" not supported.' : "");
            else {
              if (/^on/i.test(b2)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "' + b2 + '" requires goog.string.Const value, "' + c$12 + '" given.' : "");
              if (b2.toLowerCase() in goog.html.SafeHtml.URL_ATTRIBUTES_) if (c$12 instanceof goog.html.TrustedResourceUrl) c$12 = goog.html.TrustedResourceUrl.unwrap(c$12);
              else if (c$12 instanceof goog.html.SafeUrl) c$12 = goog.html.SafeUrl.unwrap(c$12);
              else if (typeof c$12 == "string") c$12 = goog.html.SafeUrl.sanitize(c$12).getTypedStringValue();
              else throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "' + b2 + '" on tag "' + a2 + '" requires goog.html.SafeUrl, goog.string.Const, or string, value "' + c$12 + '" given.' : "");
            }
            return c$12.implementsGoogStringTypedString && (c$12 = c$12.getTypedStringValue()), goog.asserts.assert(typeof c$12 == "string" || typeof c$12 == "number", "String or number value expected, got " + typeof c$12 + " with value: " + c$12), b2 + '="' + goog.string.internal.htmlEscape(String(c$12)) + '"';
          }, goog.html.SafeHtml.getStyleValue_ = function(a2) {
            if (!goog.isObject(a2)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'The "style" attribute requires goog.html.SafeStyle or map of style properties, ' + typeof a2 + " given: " + a2 : "");
            return a2 instanceof goog.html.SafeStyle || (a2 = goog.html.SafeStyle.create(a2)), goog.html.SafeStyle.unwrap(a2);
          }, goog.html.SafeHtml.createWithDir = function(a2, b2, c$12, d2) {
            return b2 = goog.html.SafeHtml.create(b2, c$12, d2), b2.dir_ = a2, b2;
          }, goog.html.SafeHtml.join = function(a2, b2) {
            a2 = goog.html.SafeHtml.htmlEscape(a2);
            var c$12 = a2.getDirection(), d2 = [], e2 = function(f2) {
              Array.isArray(f2) ? module$contents$goog$array_forEach(f2, e2) : (f2 = goog.html.SafeHtml.htmlEscape(f2), d2.push(goog.html.SafeHtml.unwrap(f2)), f2 = f2.getDirection(), c$12 == goog.i18n.bidi.Dir.NEUTRAL ? c$12 = f2 : f2 != goog.i18n.bidi.Dir.NEUTRAL && c$12 != f2 && (c$12 = null));
            };
            return module$contents$goog$array_forEach(b2, e2), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(d2.join(goog.html.SafeHtml.unwrap(a2)), c$12);
          }, goog.html.SafeHtml.concat = function(a2) {
            return goog.html.SafeHtml.join(goog.html.SafeHtml.EMPTY, Array.prototype.slice.call(arguments));
          }, goog.html.SafeHtml.concatWithDir = function(a2, b2) {
            var c$12 = goog.html.SafeHtml.concat(module$contents$goog$array_slice(arguments, 1));
            return c$12.dir_ = a2, c$12;
          }, goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse = function(a2, b2) {
            var c$12 = goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();
            return a2 = c$12 ? c$12.createHTML(a2) : a2, new goog.html.SafeHtml(a2, b2, goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_);
          }, goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse = function(a2, b2, c$12) {
            var d2 = null, e2 = "<" + a2 + goog.html.SafeHtml.stringifyAttributes(a2, b2);
            return c$12 == null ? c$12 = [] : Array.isArray(c$12) || (c$12 = [c$12]), goog.dom.tags.isVoidTag(a2.toLowerCase()) ? (goog.asserts.assert(!c$12.length, "Void tag <" + a2 + "> does not allow content."), e2 += ">") : (d2 = goog.html.SafeHtml.concat(c$12), e2 += ">" + goog.html.SafeHtml.unwrap(d2) + "</" + a2 + ">", d2 = d2.getDirection()), (a2 = b2 && b2.dir) && (d2 = /^(ltr|rtl|auto)$/i.test(a2) ? goog.i18n.bidi.Dir.NEUTRAL : null), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(e2, d2);
          }, goog.html.SafeHtml.stringifyAttributes = function(a2, b2) {
            var c$12 = "";
            if (b2) {
              for (var d2 in b2) if (Object.prototype.hasOwnProperty.call(b2, d2)) {
                if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(d2)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Invalid attribute name "' + d2 + '".' : "");
                var e2 = b2[d2];
                e2 != null && (c$12 += " " + goog.html.SafeHtml.getAttrNameAndValue_(a2, d2, e2));
              }
            }
            return c$12;
          }, goog.html.SafeHtml.combineAttributes = function(a2, b2, c$12) {
            var d2 = {}, e2;
            for (e2 in a2) Object.prototype.hasOwnProperty.call(a2, e2) && (goog.asserts.assert(e2.toLowerCase() == e2, "Must be lower case"), d2[e2] = a2[e2]);
            for (e2 in b2) Object.prototype.hasOwnProperty.call(b2, e2) && (goog.asserts.assert(e2.toLowerCase() == e2, "Must be lower case"), d2[e2] = b2[e2]);
            if (c$12) {
              for (e2 in c$12) if (Object.prototype.hasOwnProperty.call(c$12, e2)) {
                var f2 = e2.toLowerCase();
                if (f2 in a2) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Cannot override "' + f2 + '" attribute, got "' + e2 + '" with value "' + c$12[e2] + '"' : "");
                f2 in b2 && delete d2[f2], d2[e2] = c$12[e2];
              }
            }
            return d2;
          }, goog.html.SafeHtml.DOCTYPE_HTML = (function() {
            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!DOCTYPE html>", goog.i18n.bidi.Dir.NEUTRAL);
          })(), goog.html.SafeHtml.EMPTY = new goog.html.SafeHtml(goog.global.trustedTypes && goog.global.trustedTypes.emptyHTML || "", goog.i18n.bidi.Dir.NEUTRAL, goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_), goog.html.SafeHtml.BR = (function() {
            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<br>", goog.i18n.bidi.Dir.NEUTRAL);
          })(), goog.html.uncheckedconversions = {}, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract = function(a2, b2, c$12) {
            return goog.asserts.assertString(goog.string.Const.unwrap(a2), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a2)), "must provide non-empty justification"), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(b2, c$12 || null);
          }, goog.html.uncheckedconversions.safeScriptFromStringKnownToSatisfyTypeContract = function(a2, b2) {
            return goog.asserts.assertString(goog.string.Const.unwrap(a2), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a2)), "must provide non-empty justification"), module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(b2);
          }, goog.html.uncheckedconversions.safeStyleFromStringKnownToSatisfyTypeContract = function(a2, b2) {
            return goog.asserts.assertString(goog.string.Const.unwrap(a2), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a2)), "must provide non-empty justification"), goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b2);
          }, goog.html.uncheckedconversions.safeStyleSheetFromStringKnownToSatisfyTypeContract = function(a2, b2) {
            return goog.asserts.assertString(goog.string.Const.unwrap(a2), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a2)), "must provide non-empty justification"), module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b2);
          }, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract = function(a2, b2) {
            return goog.asserts.assertString(goog.string.Const.unwrap(a2), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a2)), "must provide non-empty justification"), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b2);
          }, goog.html.uncheckedconversions.trustedResourceUrlFromStringKnownToSatisfyTypeContract = function(a2, b2) {
            return goog.asserts.assertString(goog.string.Const.unwrap(a2), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a2)), "must provide non-empty justification"), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b2);
          }, goog.dom.safe = {}, goog.dom.safe.InsertAdjacentHtmlPosition = {
            AFTERBEGIN: "afterbegin",
            AFTEREND: "afterend",
            BEFOREBEGIN: "beforebegin",
            BEFOREEND: "beforeend"
          }, goog.dom.safe.insertAdjacentHtml = function(a2, b2, c$12) {
            a2.insertAdjacentHTML(b2, goog.html.SafeHtml.unwrapTrustedHTML(c$12));
          }, goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_ = {
            MATH: true,
            SCRIPT: true,
            STYLE: true,
            SVG: true,
            TEMPLATE: true
          }, goog.dom.safe.isInnerHtmlCleanupRecursive_ = goog.functions.cacheReturnValue(function() {
            if (goog.DEBUG && typeof document > "u") return false;
            var a2 = document.createElement("div"), b2 = document.createElement("div");
            return b2.appendChild(document.createElement("div")), a2.appendChild(b2), goog.DEBUG && !a2.firstChild ? false : (b2 = a2.firstChild.firstChild, a2.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(goog.html.SafeHtml.EMPTY), !b2.parentElement);
          }), goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse = function(a2, b2) {
            if (goog.dom.safe.isInnerHtmlCleanupRecursive_()) for (; a2.lastChild; ) a2.removeChild(a2.lastChild);
            a2.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(b2);
          }, goog.dom.safe.setInnerHtml = function(a2, b2) {
            if (goog.asserts.ENABLE_ASSERTS && a2.tagName) {
              var c$12 = a2.tagName.toUpperCase();
              if (goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_[c$12]) throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of " + a2.tagName + ".");
            }
            goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse(a2, b2);
          }, goog.dom.safe.setInnerHtmlFromConstant = function(a2, b2) {
            goog.dom.safe.setInnerHtml(a2, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Constant HTML to be immediatelly used."), goog.string.Const.unwrap(b2)));
          }, goog.dom.safe.setOuterHtml = function(a2, b2) {
            a2.outerHTML = goog.html.SafeHtml.unwrapTrustedHTML(b2);
          }, goog.dom.safe.setFormElementAction = function(a2, b2) {
            b2 = b2 instanceof goog.html.SafeUrl ? b2 : goog.html.SafeUrl.sanitizeAssertUnchanged(b2), goog.dom.asserts.assertIsHTMLFormElement(a2).action = goog.html.SafeUrl.unwrap(b2);
          }, goog.dom.safe.setButtonFormAction = function(a2, b2) {
            b2 = b2 instanceof goog.html.SafeUrl ? b2 : goog.html.SafeUrl.sanitizeAssertUnchanged(b2), goog.dom.asserts.assertIsHTMLButtonElement(a2).formAction = goog.html.SafeUrl.unwrap(b2);
          }, goog.dom.safe.setInputFormAction = function(a2, b2) {
            b2 = b2 instanceof goog.html.SafeUrl ? b2 : goog.html.SafeUrl.sanitizeAssertUnchanged(b2), goog.dom.asserts.assertIsHTMLInputElement(a2).formAction = goog.html.SafeUrl.unwrap(b2);
          }, goog.dom.safe.setStyle = function(a2, b2) {
            a2.style.cssText = goog.html.SafeStyle.unwrap(b2);
          }, goog.dom.safe.documentWrite = function(a2, b2) {
            a2.write(goog.html.SafeHtml.unwrapTrustedHTML(b2));
          }, goog.dom.safe.setAnchorHref = function(a2, b2) {
            goog.dom.asserts.assertIsHTMLAnchorElement(a2), b2 = b2 instanceof goog.html.SafeUrl ? b2 : goog.html.SafeUrl.sanitizeAssertUnchanged(b2), a2.href = goog.html.SafeUrl.unwrap(b2);
          }, goog.dom.safe.setImageSrc = function(a2, b2) {
            if (goog.dom.asserts.assertIsHTMLImageElement(a2), !(b2 instanceof goog.html.SafeUrl)) {
              var c$12 = /^data:image\//i.test(b2);
              b2 = goog.html.SafeUrl.sanitizeAssertUnchanged(b2, c$12);
            }
            a2.src = goog.html.SafeUrl.unwrap(b2);
          }, goog.dom.safe.setAudioSrc = function(a2, b2) {
            if (goog.dom.asserts.assertIsHTMLAudioElement(a2), !(b2 instanceof goog.html.SafeUrl)) {
              var c$12 = /^data:audio\//i.test(b2);
              b2 = goog.html.SafeUrl.sanitizeAssertUnchanged(b2, c$12);
            }
            a2.src = goog.html.SafeUrl.unwrap(b2);
          }, goog.dom.safe.setVideoSrc = function(a2, b2) {
            if (goog.dom.asserts.assertIsHTMLVideoElement(a2), !(b2 instanceof goog.html.SafeUrl)) {
              var c$12 = /^data:video\//i.test(b2);
              b2 = goog.html.SafeUrl.sanitizeAssertUnchanged(b2, c$12);
            }
            a2.src = goog.html.SafeUrl.unwrap(b2);
          }, goog.dom.safe.setEmbedSrc = function(a2, b2) {
            goog.dom.asserts.assertIsHTMLEmbedElement(a2), a2.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b2);
          }, goog.dom.safe.setFrameSrc = function(a2, b2) {
            goog.dom.asserts.assertIsHTMLFrameElement(a2), a2.src = goog.html.TrustedResourceUrl.unwrap(b2);
          }, goog.dom.safe.setIframeSrc = function(a2, b2) {
            goog.dom.asserts.assertIsHTMLIFrameElement(a2), a2.src = goog.html.TrustedResourceUrl.unwrap(b2);
          }, goog.dom.safe.setIframeSrcdoc = function(a2, b2) {
            goog.dom.asserts.assertIsHTMLIFrameElement(a2), a2.srcdoc = goog.html.SafeHtml.unwrapTrustedHTML(b2);
          }, goog.dom.safe.setLinkHrefAndRel = function(a2, b2, c$12) {
            goog.dom.asserts.assertIsHTMLLinkElement(a2), a2.rel = c$12, goog.string.internal.caseInsensitiveContains(c$12, "stylesheet") ? (goog.asserts.assert(b2 instanceof goog.html.TrustedResourceUrl, 'URL must be TrustedResourceUrl because "rel" contains "stylesheet"'), a2.href = goog.html.TrustedResourceUrl.unwrap(b2)) : a2.href = b2 instanceof goog.html.TrustedResourceUrl ? goog.html.TrustedResourceUrl.unwrap(b2) : b2 instanceof goog.html.SafeUrl ? goog.html.SafeUrl.unwrap(b2) : goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitizeAssertUnchanged(b2));
          }, goog.dom.safe.setObjectData = function(a2, b2) {
            goog.dom.asserts.assertIsHTMLObjectElement(a2), a2.data = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b2);
          }, goog.dom.safe.setScriptSrc = function(a2, b2) {
            goog.dom.asserts.assertIsHTMLScriptElement(a2), a2.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b2), goog.dom.safe.setNonceForScriptElement_(a2);
          }, goog.dom.safe.setScriptContent = function(a2, b2) {
            goog.dom.asserts.assertIsHTMLScriptElement(a2), a2.textContent = module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript(b2), goog.dom.safe.setNonceForScriptElement_(a2);
          }, goog.dom.safe.setNonceForScriptElement_ = function(a2) {
            var b2 = goog.getScriptNonce(a2.ownerDocument && a2.ownerDocument.defaultView);
            b2 && a2.setAttribute("nonce", b2);
          }, goog.dom.safe.setLocationHref = function(a2, b2) {
            goog.dom.asserts.assertIsLocation(a2), b2 = b2 instanceof goog.html.SafeUrl ? b2 : goog.html.SafeUrl.sanitizeAssertUnchanged(b2), a2.href = goog.html.SafeUrl.unwrap(b2);
          }, goog.dom.safe.assignLocation = function(a2, b2) {
            goog.dom.asserts.assertIsLocation(a2), b2 = b2 instanceof goog.html.SafeUrl ? b2 : goog.html.SafeUrl.sanitizeAssertUnchanged(b2), a2.assign(goog.html.SafeUrl.unwrap(b2));
          }, goog.dom.safe.replaceLocation = function(a2, b2) {
            b2 = b2 instanceof goog.html.SafeUrl ? b2 : goog.html.SafeUrl.sanitizeAssertUnchanged(b2), a2.replace(goog.html.SafeUrl.unwrap(b2));
          }, goog.dom.safe.openInWindow = function(a2, b2, c$12, d2, e2) {
            return a2 = a2 instanceof goog.html.SafeUrl ? a2 : goog.html.SafeUrl.sanitizeAssertUnchanged(a2), b2 ||= goog.global, c$12 = c$12 instanceof goog.string.Const ? goog.string.Const.unwrap(c$12) : c$12 || "", b2.open(goog.html.SafeUrl.unwrap(a2), c$12, d2, e2);
          }, goog.dom.safe.parseFromStringHtml = function(a2, b2) {
            return goog.dom.safe.parseFromString(a2, b2, "text/html");
          }, goog.dom.safe.parseFromString = function(a2, b2, c$12) {
            return a2.parseFromString(goog.html.SafeHtml.unwrapTrustedHTML(b2), c$12);
          }, goog.dom.safe.createImageFromBlob = function(a2) {
            if (!/^image\/.*/g.test(a2.type)) throw Error("goog.dom.safe.createImageFromBlob only accepts MIME type image/.*.");
            var b2 = goog.global.URL.createObjectURL(a2);
            return a2 = new goog.global.Image(), a2.onload = function() {
              goog.global.URL.revokeObjectURL(b2);
            }, goog.dom.safe.setImageSrc(a2, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Image blob URL."), b2)), a2;
          }, goog.string.DETECT_DOUBLE_ESCAPING = false, goog.string.FORCE_NON_DOM_HTML_UNESCAPING = false, goog.string.Unicode = { NBSP: " " }, goog.string.startsWith = goog.string.internal.startsWith, goog.string.endsWith = goog.string.internal.endsWith, goog.string.caseInsensitiveStartsWith = goog.string.internal.caseInsensitiveStartsWith, goog.string.caseInsensitiveEndsWith = goog.string.internal.caseInsensitiveEndsWith, goog.string.caseInsensitiveEquals = goog.string.internal.caseInsensitiveEquals, goog.string.subs = function(a2, b2) {
            for (var c$12 = a2.split("%s"), d2 = "", e2 = Array.prototype.slice.call(arguments, 1); e2.length && 1 < c$12.length; ) d2 += c$12.shift() + e2.shift();
            return d2 + c$12.join("%s");
          }, goog.string.collapseWhitespace = function(a2) {
            return a2.replace(/[\s\xa0]+/g, " ").replace(/^\s+|\s+$/g, "");
          }, goog.string.isEmptyOrWhitespace = goog.string.internal.isEmptyOrWhitespace, goog.string.isEmptyString = function(a2) {
            return a2.length == 0;
          }, goog.string.isEmpty = goog.string.isEmptyOrWhitespace, goog.string.isEmptyOrWhitespaceSafe = function(a2) {
            return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(a2));
          }, goog.string.isEmptySafe = goog.string.isEmptyOrWhitespaceSafe, goog.string.isBreakingWhitespace = function(a2) {
            return !/[^\t\n\r ]/.test(a2);
          }, goog.string.isAlpha = function(a2) {
            return !/[^a-zA-Z]/.test(a2);
          }, goog.string.isNumeric = function(a2) {
            return !/[^0-9]/.test(a2);
          }, goog.string.isAlphaNumeric = function(a2) {
            return !/[^a-zA-Z0-9]/.test(a2);
          }, goog.string.isSpace = function(a2) {
            return a2 == " ";
          }, goog.string.isUnicodeChar = function(a2) {
            return a2.length == 1 && " " <= a2 && "~" >= a2 || "" <= a2 && "�" >= a2;
          }, goog.string.stripNewlines = function(a2) {
            return a2.replace(/(\r\n|\r|\n)+/g, " ");
          }, goog.string.canonicalizeNewlines = function(a2) {
            return a2.replace(/(\r\n|\r|\n)/g, "\n");
          }, goog.string.normalizeWhitespace = function(a2) {
            return a2.replace(/\xa0|\s/g, " ");
          }, goog.string.normalizeSpaces = function(a2) {
            return a2.replace(/\xa0|[ \t]+/g, " ");
          }, goog.string.collapseBreakingSpaces = function(a2) {
            return a2.replace(/[\t\r\n ]+/g, " ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g, "");
          }, goog.string.trim = goog.string.internal.trim, goog.string.trimLeft = function(a2) {
            return a2.replace(/^[\s\xa0]+/, "");
          }, goog.string.trimRight = function(a2) {
            return a2.replace(/[\s\xa0]+$/, "");
          }, goog.string.caseInsensitiveCompare = goog.string.internal.caseInsensitiveCompare, goog.string.numberAwareCompare_ = function(a2, b2, c$12) {
            if (a2 == b2) return 0;
            if (!a2) return -1;
            if (!b2) return 1;
            for (var d2 = a2.toLowerCase().match(c$12), e2 = b2.toLowerCase().match(c$12), f2 = Math.min(d2.length, e2.length), g2 = 0; g2 < f2; g2++) {
              c$12 = d2[g2];
              var h = e2[g2];
              if (c$12 != h) return a2 = parseInt(c$12, 10), !isNaN(a2) && (b2 = parseInt(h, 10), !isNaN(b2) && a2 - b2) ? a2 - b2 : c$12 < h ? -1 : 1;
            }
            return d2.length == e2.length ? a2 < b2 ? -1 : 1 : d2.length - e2.length;
          }, goog.string.intAwareCompare = function(a2, b2) {
            return goog.string.numberAwareCompare_(a2, b2, /\d+|\D+/g);
          }, goog.string.floatAwareCompare = function(a2, b2) {
            return goog.string.numberAwareCompare_(a2, b2, /\d+|\.\d+|\D+/g);
          }, goog.string.numerateCompare = goog.string.floatAwareCompare, goog.string.urlEncode = function(a2) {
            return encodeURIComponent(String(a2));
          }, goog.string.urlDecode = function(a2) {
            return decodeURIComponent(a2.replace(/\+/g, " "));
          }, goog.string.newLineToBr = goog.string.internal.newLineToBr, goog.string.htmlEscape = function(a2, b2) {
            return a2 = goog.string.internal.htmlEscape(a2, b2), goog.string.DETECT_DOUBLE_ESCAPING && (a2 = a2.replace(goog.string.E_RE_, "&#101;")), a2;
          }, goog.string.E_RE_ = /e/g, goog.string.unescapeEntities = function(a2) {
            return goog.string.contains(a2, "&") ? !goog.string.FORCE_NON_DOM_HTML_UNESCAPING && "document" in goog.global ? goog.string.unescapeEntitiesUsingDom_(a2) : goog.string.unescapePureXmlEntities_(a2) : a2;
          }, goog.string.unescapeEntitiesWithDocument = function(a2, b2) {
            return goog.string.contains(a2, "&") ? goog.string.unescapeEntitiesUsingDom_(a2, b2) : a2;
          }, goog.string.unescapeEntitiesUsingDom_ = function(a2, b2) {
            var c$12 = {
              "&amp;": "&",
              "&lt;": "<",
              "&gt;": ">",
              "&quot;": '"'
            }, d2 = b2 ? b2.createElement("div") : goog.global.document.createElement("div");
            return a2.replace(goog.string.HTML_ENTITY_PATTERN_, function(e2, f2) {
              var g2 = c$12[e2];
              return g2 || (f2.charAt(0) == "#" && (f2 = Number("0" + f2.substr(1)), isNaN(f2) || (g2 = String.fromCharCode(f2))), g2 ||= (goog.dom.safe.setInnerHtml(d2, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Single HTML entity."), e2 + " ")), d2.firstChild.nodeValue.slice(0, -1)), c$12[e2] = g2);
            });
          }, goog.string.unescapePureXmlEntities_ = function(a2) {
            return a2.replace(/&([^;]+);/g, function(b2, c$12) {
              switch (c$12) {
                case "amp":
                  return "&";
                case "lt":
                  return "<";
                case "gt":
                  return ">";
                case "quot":
                  return '"';
                default:
                  return c$12.charAt(0) != "#" || (c$12 = Number("0" + c$12.substr(1)), isNaN(c$12)) ? b2 : String.fromCharCode(c$12);
              }
            });
          }, goog.string.HTML_ENTITY_PATTERN_ = /&([^;\s<&]+);?/g, goog.string.whitespaceEscape = function(a2, b2) {
            return goog.string.newLineToBr(a2.replace(/  /g, " &#160;"), b2);
          }, goog.string.preserveSpaces = function(a2) {
            return a2.replace(/(^|[\n ]) /g, "$1" + goog.string.Unicode.NBSP);
          }, goog.string.stripQuotes = function(a2, b2) {
            for (var c$12 = b2.length, d2 = 0; d2 < c$12; d2++) {
              var e2 = c$12 == 1 ? b2 : b2.charAt(d2);
              if (a2.charAt(0) == e2 && a2.charAt(a2.length - 1) == e2) return a2.substring(1, a2.length - 1);
            }
            return a2;
          }, goog.string.truncate = function(a2, b2, c$12) {
            return c$12 && (a2 = goog.string.unescapeEntities(a2)), a2.length > b2 && (a2 = a2.substring(0, b2 - 3) + "..."), c$12 && (a2 = goog.string.htmlEscape(a2)), a2;
          }, goog.string.truncateMiddle = function(a2, b2, c$12, d2) {
            if (c$12 && (a2 = goog.string.unescapeEntities(a2)), d2 && a2.length > b2) {
              d2 > b2 && (d2 = b2);
              var e2 = a2.length - d2;
              a2 = a2.substring(0, b2 - d2) + "..." + a2.substring(e2);
            } else a2.length > b2 && (d2 = Math.floor(b2 / 2), e2 = a2.length - d2, a2 = a2.substring(0, d2 + b2 % 2) + "..." + a2.substring(e2));
            return c$12 && (a2 = goog.string.htmlEscape(a2)), a2;
          }, goog.string.specialEscapeChars_ = {
            "\0": "\\0",
            "\b": "\\b",
            "\f": "\\f",
            "\n": "\\n",
            "\r": "\\r",
            "	": "\\t",
            "\v": "\\x0B",
            '"': '\\"',
            "\\": "\\\\",
            "<": "\\u003C"
          }, goog.string.jsEscapeCache_ = { "'": "\\'" }, goog.string.quote = function(a2) {
            a2 = String(a2);
            for (var b2 = ['"'], c$12 = 0; c$12 < a2.length; c$12++) {
              var d2 = a2.charAt(c$12), e2 = d2.charCodeAt(0);
              b2[c$12 + 1] = goog.string.specialEscapeChars_[d2] || (31 < e2 && 127 > e2 ? d2 : goog.string.escapeChar(d2));
            }
            return b2.push('"'), b2.join("");
          }, goog.string.escapeString = function(a2) {
            for (var b2 = [], c$12 = 0; c$12 < a2.length; c$12++) b2[c$12] = goog.string.escapeChar(a2.charAt(c$12));
            return b2.join("");
          }, goog.string.escapeChar = function(a2) {
            if (a2 in goog.string.jsEscapeCache_) return goog.string.jsEscapeCache_[a2];
            if (a2 in goog.string.specialEscapeChars_) return goog.string.jsEscapeCache_[a2] = goog.string.specialEscapeChars_[a2];
            var b2 = a2.charCodeAt(0);
            if (31 < b2 && 127 > b2) var c$12 = a2;
            else 256 > b2 ? (c$12 = "\\x", (16 > b2 || 256 < b2) && (c$12 += "0")) : (c$12 = "\\u", 4096 > b2 && (c$12 += "0")), c$12 += b2.toString(16).toUpperCase();
            return goog.string.jsEscapeCache_[a2] = c$12;
          }, goog.string.contains = goog.string.internal.contains, goog.string.caseInsensitiveContains = goog.string.internal.caseInsensitiveContains, goog.string.countOf = function(a2, b2) {
            return a2 && b2 ? a2.split(b2).length - 1 : 0;
          }, goog.string.removeAt = function(a2, b2, c$12) {
            var d2 = a2;
            return 0 <= b2 && b2 < a2.length && 0 < c$12 && (d2 = a2.substr(0, b2) + a2.substr(b2 + c$12, a2.length - b2 - c$12)), d2;
          }, goog.string.remove = function(a2, b2) {
            return a2.replace(b2, "");
          }, goog.string.removeAll = function(a2, b2) {
            return b2 = new RegExp(goog.string.regExpEscape(b2), "g"), a2.replace(b2, "");
          }, goog.string.replaceAll = function(a2, b2, c$12) {
            return b2 = new RegExp(goog.string.regExpEscape(b2), "g"), a2.replace(b2, c$12.replace(/\$/g, "$$$$"));
          }, goog.string.regExpEscape = function(a2) {
            return String(a2).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08");
          }, goog.string.repeat = String.prototype.repeat ? function(a2, b2) {
            return a2.repeat(b2);
          } : function(a2, b2) {
            return Array(b2 + 1).join(a2);
          }, goog.string.padNumber = function(a2, b2, c$12) {
            return a2 = c$12 === void 0 ? String(a2) : a2.toFixed(c$12), c$12 = a2.indexOf("."), c$12 == -1 && (c$12 = a2.length), goog.string.repeat("0", Math.max(0, b2 - c$12)) + a2;
          }, goog.string.makeSafe = function(a2) {
            return a2 == null ? "" : String(a2);
          }, goog.string.buildString = function(a2) {
            return Array.prototype.join.call(arguments, "");
          }, goog.string.getRandomString = function() {
            return Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ goog.now()).toString(36);
          }, goog.string.compareVersions = goog.string.internal.compareVersions, goog.string.hashCode = function(a2) {
            for (var b2 = 0, c$12 = 0; c$12 < a2.length; ++c$12) b2 = 31 * b2 + a2.charCodeAt(c$12) >>> 0;
            return b2;
          }, goog.string.uniqueStringCounter_ = 2147483648 * Math.random() | 0, goog.string.createUniqueString = function() {
            return "goog_" + goog.string.uniqueStringCounter_++;
          }, goog.string.toNumber = function(a2) {
            var b2 = Number(a2);
            return b2 == 0 && goog.string.isEmptyOrWhitespace(a2) ? NaN : b2;
          }, goog.string.isLowerCamelCase = function(a2) {
            return /^[a-z]+([A-Z][a-z]*)*$/.test(a2);
          }, goog.string.isUpperCamelCase = function(a2) {
            return /^([A-Z][a-z]*)+$/.test(a2);
          }, goog.string.toCamelCase = function(a2) {
            return String(a2).replace(/\-([a-z])/g, function(b2, c$12) {
              return c$12.toUpperCase();
            });
          }, goog.string.toSelectorCase = function(a2) {
            return String(a2).replace(/([A-Z])/g, "-$1").toLowerCase();
          }, goog.string.toTitleCase = function(a2, b2) {
            return b2 = typeof b2 == "string" ? goog.string.regExpEscape(b2) : "\\s", a2.replace(RegExp("(^" + (b2 ? "|[" + b2 + "]+" : "") + ")([a-z])", "g"), function(c$12, d2, e2) {
              return d2 + e2.toUpperCase();
            });
          }, goog.string.capitalize = function(a2) {
            return String(a2.charAt(0)).toUpperCase() + String(a2.substr(1)).toLowerCase();
          }, goog.string.parseInt = function(a2) {
            return isFinite(a2) && (a2 = String(a2)), typeof a2 == "string" ? /^\s*-?0x/i.test(a2) ? parseInt(a2, 16) : parseInt(a2, 10) : NaN;
          }, goog.string.splitLimit = function(a2, b2, c$12) {
            a2 = a2.split(b2);
            for (var d2 = []; 0 < c$12 && a2.length; ) d2.push(a2.shift()), c$12--;
            return a2.length && d2.push(a2.join(b2)), d2;
          }, goog.string.lastComponent = function(a2, b2) {
            if (b2) typeof b2 == "string" && (b2 = [b2]);
            else return a2;
            for (var c$12 = -1, d2 = 0; d2 < b2.length; d2++) if (b2[d2] != "") {
              var e2 = a2.lastIndexOf(b2[d2]);
              e2 > c$12 && (c$12 = e2);
            }
            return c$12 == -1 ? a2 : a2.slice(c$12 + 1);
          }, goog.string.editDistance = function(a2, b2) {
            var c$12 = [], d2 = [];
            if (a2 == b2) return 0;
            if (!a2.length || !b2.length) return Math.max(a2.length, b2.length);
            for (var e2 = 0; e2 < b2.length + 1; e2++) c$12[e2] = e2;
            for (e2 = 0; e2 < a2.length; e2++) {
              d2[0] = e2 + 1;
              for (var f2 = 0; f2 < b2.length; f2++) d2[f2 + 1] = Math.min(d2[f2] + 1, c$12[f2 + 1] + 1, c$12[f2] + Number(a2[e2] != b2[f2]));
              for (f2 = 0; f2 < c$12.length; f2++) c$12[f2] = d2[f2];
            }
            return d2[b2.length];
          }, goog.proto2 = {}, goog.proto2.Descriptor = function(a2, b2, c$12) {
            for (this.messageType_ = a2, this.name_ = b2.name || null, this.fullName_ = b2.fullName || null, this.containingType_ = b2.containingType, this.fields_ = {}, a2 = 0; a2 < c$12.length; a2++) b2 = c$12[a2], this.fields_[b2.getTag()] = b2;
          }, goog.proto2.Descriptor.prototype.getName = function() {
            return this.name_;
          }, goog.proto2.Descriptor.prototype.getFullName = function() {
            return this.fullName_;
          }, goog.proto2.Descriptor.prototype.getContainingType = function() {
            return this.containingType_ ? this.containingType_.getDescriptor() : null;
          }, goog.proto2.Descriptor.prototype.getFields = function() {
            var a2 = goog.object.getValues(this.fields_);
            return module$contents$goog$array_sort(a2, function(b2, c$12) {
              return b2.getTag() - c$12.getTag();
            }), a2;
          }, goog.proto2.Descriptor.prototype.getFieldsMap = function() {
            return this.fields_;
          }, goog.proto2.Descriptor.prototype.findFieldByName = function(a2) {
            return goog.object.findValue(this.fields_, function(b2, c$12, d2) {
              return b2.getName() == a2;
            }) || null;
          }, goog.proto2.Descriptor.prototype.findFieldByTag = function(a2) {
            return goog.asserts.assert(goog.string.isNumeric(a2)), this.fields_[parseInt(a2, 10)] || null;
          }, goog.proto2.Descriptor.prototype.createMessageInstance = function() {
            return new this.messageType_();
          }, goog.proto2.FieldDescriptor = function(a2, b2, c$12) {
            switch (this.parent_ = a2, goog.asserts.assert(goog.string.isNumeric(b2)), this.tag_ = b2, this.name_ = c$12.name, this.isPacked_ = !!c$12.packed, this.isRepeated_ = !!c$12.repeated, this.isRequired_ = !!c$12.required, this.fieldType_ = c$12.fieldType, this.nativeType_ = c$12.type, this.deserializationConversionPermitted_ = false, this.fieldType_) {
              case goog.proto2.FieldDescriptor.FieldType.INT64:
              case goog.proto2.FieldDescriptor.FieldType.UINT64:
              case goog.proto2.FieldDescriptor.FieldType.FIXED64:
              case goog.proto2.FieldDescriptor.FieldType.SFIXED64:
              case goog.proto2.FieldDescriptor.FieldType.SINT64:
              case goog.proto2.FieldDescriptor.FieldType.FLOAT:
              case goog.proto2.FieldDescriptor.FieldType.DOUBLE:
                this.deserializationConversionPermitted_ = true;
            }
            this.defaultValue_ = c$12.defaultValue;
          }, goog.proto2.FieldDescriptor.FieldType = {
            DOUBLE: 1,
            FLOAT: 2,
            INT64: 3,
            UINT64: 4,
            INT32: 5,
            FIXED64: 6,
            FIXED32: 7,
            BOOL: 8,
            STRING: 9,
            GROUP: 10,
            MESSAGE: 11,
            BYTES: 12,
            UINT32: 13,
            ENUM: 14,
            SFIXED32: 15,
            SFIXED64: 16,
            SINT32: 17,
            SINT64: 18
          }, goog.proto2.FieldDescriptor.prototype.getTag = function() {
            return this.tag_;
          }, goog.proto2.FieldDescriptor.prototype.getContainingType = function() {
            return this.parent_.prototype.getDescriptor();
          }, goog.proto2.FieldDescriptor.prototype.getName = function() {
            return this.name_;
          }, goog.proto2.FieldDescriptor.prototype.getDefaultValue = function() {
            if (this.defaultValue_ === void 0) {
              var a2 = this.nativeType_;
              if (a2 === Boolean) this.defaultValue_ = false;
              else if (a2 === Number) this.defaultValue_ = 0;
              else if (a2 === String) this.defaultValue_ = this.deserializationConversionPermitted_ ? "0" : "";
              else return new a2();
            }
            return this.defaultValue_;
          }, goog.proto2.FieldDescriptor.prototype.getFieldType = function() {
            return this.fieldType_;
          }, goog.proto2.FieldDescriptor.prototype.getNativeType = function() {
            return this.nativeType_;
          }, goog.proto2.FieldDescriptor.prototype.deserializationConversionPermitted = function() {
            return this.deserializationConversionPermitted_;
          }, goog.proto2.FieldDescriptor.prototype.getFieldMessageType = function() {
            return this.nativeType_.prototype.getDescriptor();
          }, goog.proto2.FieldDescriptor.prototype.isCompositeType = function() {
            return this.fieldType_ == goog.proto2.FieldDescriptor.FieldType.MESSAGE || this.fieldType_ == goog.proto2.FieldDescriptor.FieldType.GROUP;
          }, goog.proto2.FieldDescriptor.prototype.isPacked = function() {
            return this.isPacked_;
          }, goog.proto2.FieldDescriptor.prototype.isRepeated = function() {
            return this.isRepeated_;
          }, goog.proto2.FieldDescriptor.prototype.isRequired = function() {
            return this.isRequired_;
          }, goog.proto2.FieldDescriptor.prototype.isOptional = function() {
            return !this.isRepeated_ && !this.isRequired_;
          }, goog.proto2.Message = function() {
            this.values_ = {}, this.fields_ = this.getDescriptor().getFieldsMap(), this.deserializedFields_ = this.lazyDeserializer_ = null;
          }, goog.proto2.Message.FieldType = {
            DOUBLE: 1,
            FLOAT: 2,
            INT64: 3,
            UINT64: 4,
            INT32: 5,
            FIXED64: 6,
            FIXED32: 7,
            BOOL: 8,
            STRING: 9,
            GROUP: 10,
            MESSAGE: 11,
            BYTES: 12,
            UINT32: 13,
            ENUM: 14,
            SFIXED32: 15,
            SFIXED64: 16,
            SINT32: 17,
            SINT64: 18
          }, goog.proto2.Message.prototype.initializeForLazyDeserializer = function(a2, b2) {
            this.lazyDeserializer_ = a2, this.values_ = b2, this.deserializedFields_ = {};
          }, goog.proto2.Message.prototype.setUnknown = function(a2, b2) {
            goog.asserts.assert(!this.fields_[a2], "Field is not unknown in this message"), goog.asserts.assert(1 <= a2, "Tag " + a2 + ' has value "' + b2 + '" in descriptor ' + this.getDescriptor().getName()), goog.asserts.assert(b2 !== null, "Value cannot be null"), this.values_[a2] = b2, this.deserializedFields_ && delete this.deserializedFields_[a2];
          }, goog.proto2.Message.prototype.forEachUnknown = function(a2, b2) {
            for (var c$12 in b2 ||= this, this.values_) {
              var d2 = Number(c$12);
              this.fields_[d2] || a2.call(b2, d2, this.values_[c$12]);
            }
          }, goog.proto2.Message.prototype.getDescriptor = goog.abstractMethod, goog.proto2.Message.prototype.has = function(a2) {
            return goog.asserts.assert(a2.getContainingType() == this.getDescriptor(), "The current message does not contain the given field"), this.has$Value(a2.getTag());
          }, goog.proto2.Message.prototype.arrayOf = function(a2) {
            return goog.asserts.assert(a2.getContainingType() == this.getDescriptor(), "The current message does not contain the given field"), this.array$Values(a2.getTag());
          }, goog.proto2.Message.prototype.countOf = function(a2) {
            return goog.asserts.assert(a2.getContainingType() == this.getDescriptor(), "The current message does not contain the given field"), this.count$Values(a2.getTag());
          }, goog.proto2.Message.prototype.get = function(a2, b2) {
            return goog.asserts.assert(a2.getContainingType() == this.getDescriptor(), "The current message does not contain the given field"), this.get$Value(a2.getTag(), b2);
          }, goog.proto2.Message.prototype.getOrDefault = function(a2, b2) {
            return goog.asserts.assert(a2.getContainingType() == this.getDescriptor(), "The current message does not contain the given field"), this.get$ValueOrDefault(a2.getTag(), b2);
          }, goog.proto2.Message.prototype.set = function(a2, b2) {
            goog.asserts.assert(a2.getContainingType() == this.getDescriptor(), "The current message does not contain the given field"), this.set$Value(a2.getTag(), b2);
          }, goog.proto2.Message.prototype.add = function(a2, b2) {
            goog.asserts.assert(a2.getContainingType() == this.getDescriptor(), "The current message does not contain the given field"), this.add$Value(a2.getTag(), b2);
          }, goog.proto2.Message.prototype.clear = function(a2) {
            goog.asserts.assert(a2.getContainingType() == this.getDescriptor(), "The current message does not contain the given field"), this.clear$Field(a2.getTag());
          }, goog.proto2.Message.prototype.equals = function(a2) {
            if (!a2 || this.constructor != a2.constructor) return false;
            for (var b2 = this.getDescriptor().getFields(), c$12 = 0; c$12 < b2.length; c$12++) {
              var d2 = b2[c$12], e2 = d2.getTag();
              if (this.has$Value(e2) != a2.has$Value(e2)) return false;
              if (this.has$Value(e2)) {
                var f2 = d2.isCompositeType(), g2 = this.getValueForTag_(e2);
                if (e2 = a2.getValueForTag_(e2), d2.isRepeated()) {
                  if (g2.length != e2.length) return false;
                  for (d2 = 0; d2 < g2.length; d2++) {
                    var h = g2[d2], k = e2[d2];
                    if (f2 ? !h.equals(k) : h != k) return false;
                  }
                } else if (f2 ? !g2.equals(e2) : g2 != e2) return false;
              }
            }
            return true;
          }, goog.proto2.Message.prototype.copyFrom = function(a2) {
            goog.asserts.assert(this.constructor == a2.constructor, "The source message must have the same type."), this != a2 && (this.values_ = {}, this.deserializedFields_ &&= {}, this.mergeFrom(a2));
          }, goog.proto2.Message.prototype.mergeFrom = function(a2) {
            goog.asserts.assert(this.constructor == a2.constructor, "The source message must have the same type.");
            for (var b2 = this.getDescriptor().getFields(), c$12 = 0; c$12 < b2.length; c$12++) {
              var d2 = b2[c$12], e2 = d2.getTag();
              if (a2.has$Value(e2)) {
                this.deserializedFields_ && delete this.deserializedFields_[d2.getTag()];
                var f2 = d2.isCompositeType();
                if (d2.isRepeated()) {
                  d2 = a2.array$Values(e2);
                  for (var g2 = 0; g2 < d2.length; g2++) this.add$Value(e2, f2 ? d2[g2].clone() : d2[g2]);
                } else d2 = a2.getValueForTag_(e2), f2 ? (f2 = this.getValueForTag_(e2)) ? f2.mergeFrom(d2) : this.set$Value(e2, d2.clone()) : this.set$Value(e2, d2);
              }
            }
          }, goog.proto2.Message.prototype.clone = function() {
            var a2 = new this.constructor();
            return a2.copyFrom(this), a2;
          }, goog.proto2.Message.prototype.initDefaults = function(a2) {
            for (var b2 = this.getDescriptor().getFields(), c$12 = 0; c$12 < b2.length; c$12++) {
              var d2 = b2[c$12], e2 = d2.getTag(), f2 = d2.isCompositeType();
              if (this.has$Value(e2) || d2.isRepeated() || (f2 ? this.values_[e2] = new (d2.getNativeType())() : a2 && (this.values_[e2] = d2.getDefaultValue())), f2) if (d2.isRepeated()) for (d2 = this.array$Values(e2), e2 = 0; e2 < d2.length; e2++) d2[e2].initDefaults(a2);
              else this.get$Value(e2).initDefaults(a2);
            }
          }, goog.proto2.Message.prototype.has$Value = function(a2) {
            return this.values_[a2] != null;
          }, goog.proto2.Message.prototype.getValueForTag_ = function(a2) {
            var b2 = this.values_[a2];
            return b2 == null ? null : this.lazyDeserializer_ ? a2 in this.deserializedFields_ ? this.deserializedFields_[a2] : (b2 = this.lazyDeserializer_.deserializeField(this, this.fields_[a2], b2), this.deserializedFields_[a2] = b2) : b2;
          }, goog.proto2.Message.prototype.get$Value = function(a2, b2) {
            var c$12 = this.getValueForTag_(a2);
            return this.fields_[a2].isRepeated() ? (a2 = b2 || 0, goog.asserts.assert(0 <= a2 && a2 < c$12.length, "Given index %s is out of bounds.  Repeated field length: %s", a2, c$12.length), c$12[a2]) : c$12;
          }, goog.proto2.Message.prototype.get$ValueOrDefault = function(a2, b2) {
            return this.has$Value(a2) ? this.get$Value(a2, b2) : this.fields_[a2].getDefaultValue();
          }, goog.proto2.Message.prototype.array$Values = function(a2) {
            return this.getValueForTag_(a2) || [];
          }, goog.proto2.Message.prototype.count$Values = function(a2) {
            return this.fields_[a2].isRepeated() ? this.has$Value(a2) ? this.values_[a2].length : 0 : this.has$Value(a2) ? 1 : 0;
          }, goog.proto2.Message.prototype.set$Value = function(a2, b2) {
            goog.asserts.ENABLE_ASSERTS && this.checkFieldType_(this.fields_[a2], b2), this.values_[a2] = b2, this.deserializedFields_ && (this.deserializedFields_[a2] = b2);
          }, goog.proto2.Message.prototype.add$Value = function(a2, b2) {
            goog.asserts.ENABLE_ASSERTS && this.checkFieldType_(this.fields_[a2], b2), this.values_[a2] || (this.values_[a2] = []), this.values_[a2].push(b2), this.deserializedFields_ && delete this.deserializedFields_[a2];
          }, goog.proto2.Message.prototype.checkFieldType_ = function(a2, b2) {
            a2.getFieldType() == goog.proto2.FieldDescriptor.FieldType.ENUM ? goog.asserts.assertNumber(b2) : goog.asserts.assert(Object(b2).constructor == a2.getNativeType());
          }, goog.proto2.Message.prototype.clear$Field = function(a2) {
            delete this.values_[a2], this.deserializedFields_ && delete this.deserializedFields_[a2];
          }, goog.proto2.Message.createDescriptor = function(a2, b2) {
            var c$12 = [], d2 = b2[0], e2;
            for (e2 in b2) e2 != 0 && c$12.push(new goog.proto2.FieldDescriptor(a2, e2, b2[e2]));
            return new goog.proto2.Descriptor(a2, d2, c$12);
          }, goog.proto2.Serializer = function() {
          }, goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS = false, goog.proto2.Serializer.prototype.serialize = goog.abstractMethod, goog.proto2.Serializer.prototype.getSerializedValue = function(a2, b2) {
            return a2.isCompositeType() ? this.serialize(b2) : typeof b2 != "number" || isFinite(b2) ? b2 : b2.toString();
          }, goog.proto2.Serializer.prototype.deserialize = function(a2, b2) {
            return a2 = a2.createMessageInstance(), this.deserializeTo(a2, b2), goog.asserts.assert(a2 instanceof goog.proto2.Message), a2;
          }, goog.proto2.Serializer.prototype.deserializeTo = goog.abstractMethod, goog.proto2.Serializer.prototype.getDeserializedValue = function(a2, b2) {
            if (a2.isCompositeType()) return b2 instanceof goog.proto2.Message ? b2 : this.deserialize(a2.getFieldMessageType(), b2);
            if (a2.getFieldType() == goog.proto2.FieldDescriptor.FieldType.ENUM) return goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS && typeof b2 == "string" && (a2 = a2.getNativeType(), a2.hasOwnProperty(b2)) ? a2[b2] : typeof b2 == "string" && goog.proto2.Serializer.INTEGER_REGEX.test(b2) && (a2 = Number(b2), 0 < a2) ? a2 : b2;
            if (!a2.deserializationConversionPermitted()) return b2;
            if (a2 = a2.getNativeType(), a2 === String) {
              if (typeof b2 == "number") return String(b2);
            } else if (a2 === Number && typeof b2 == "string" && (b2 === "Infinity" || b2 === "-Infinity" || b2 === "NaN" || goog.proto2.Serializer.INTEGER_REGEX.test(b2))) return Number(b2);
            return b2;
          }, goog.proto2.Serializer.INTEGER_REGEX = /^-?[0-9]+$/, goog.proto2.LazyDeserializer = function() {
          }, goog.inherits(goog.proto2.LazyDeserializer, goog.proto2.Serializer), goog.proto2.LazyDeserializer.prototype.deserialize = function(a2, b2) {
            return a2 = a2.createMessageInstance(), a2.initializeForLazyDeserializer(this, b2), goog.asserts.assert(a2 instanceof goog.proto2.Message), a2;
          }, goog.proto2.LazyDeserializer.prototype.deserializeTo = function(a2, b2) {
            throw Error("Unimplemented");
          }, goog.proto2.LazyDeserializer.prototype.deserializeField = goog.abstractMethod, goog.proto2.PbLiteSerializer = function() {
          }, goog.inherits(goog.proto2.PbLiteSerializer, goog.proto2.LazyDeserializer), goog.proto2.PbLiteSerializer.prototype.zeroIndexing_ = false, goog.proto2.PbLiteSerializer.prototype.setZeroIndexed = function(a2) {
            this.zeroIndexing_ = a2;
          }, goog.proto2.PbLiteSerializer.prototype.serialize = function(a2) {
            for (var b2 = a2.getDescriptor().getFields(), c$12 = [], d2 = this.zeroIndexing_, e2 = 0; e2 < b2.length; e2++) {
              var f2 = b2[e2];
              if (a2.has(f2)) {
                var g2 = f2.getTag();
                if (g2 = d2 ? g2 - 1 : g2, f2.isRepeated()) {
                  c$12[g2] = [];
                  for (var h = 0; h < a2.countOf(f2); h++) c$12[g2][h] = this.getSerializedValue(f2, a2.get(f2, h));
                } else c$12[g2] = this.getSerializedValue(f2, a2.get(f2));
              }
            }
            return a2.forEachUnknown(function(k, l$12) {
              c$12[d2 ? k - 1 : k] = l$12;
            }), c$12;
          }, goog.proto2.PbLiteSerializer.prototype.deserializeField = function(a2, b2, c$12) {
            if (c$12 == null) return c$12;
            if (b2.isRepeated()) {
              a2 = [], goog.asserts.assert(Array.isArray(c$12), "Value must be array: %s", c$12);
              for (var d2 = 0; d2 < c$12.length; d2++) a2[d2] = this.getDeserializedValue(b2, c$12[d2]);
              return a2;
            }
            return this.getDeserializedValue(b2, c$12);
          }, goog.proto2.PbLiteSerializer.prototype.getSerializedValue = function(a2, b2) {
            return a2.getFieldType() == goog.proto2.FieldDescriptor.FieldType.BOOL ? b2 ? 1 : 0 : goog.proto2.Serializer.prototype.getSerializedValue.apply(this, arguments);
          }, goog.proto2.PbLiteSerializer.prototype.getDeserializedValue = function(a2, b2) {
            return a2.getFieldType() == goog.proto2.FieldDescriptor.FieldType.BOOL ? (goog.asserts.assert(typeof b2 == "number" || typeof b2 == "boolean", "Value is expected to be a number or boolean"), !!b2) : goog.proto2.Serializer.prototype.getDeserializedValue.apply(this, arguments);
          }, goog.proto2.PbLiteSerializer.prototype.deserialize = function(a2, b2) {
            var c$12 = b2;
            if (this.zeroIndexing_) for (var d2 in c$12 = [], b2) c$12[parseInt(d2, 10) + 1] = b2[d2];
            return goog.proto2.PbLiteSerializer.superClass_.deserialize.call(this, a2, c$12);
          }, goog.string.StringBuffer = function(a2, b2) {
            a2 != null && this.append.apply(this, arguments);
          }, goog.string.StringBuffer.prototype.buffer_ = "", goog.string.StringBuffer.prototype.set = function(a2) {
            this.buffer_ = "" + a2;
          }, goog.string.StringBuffer.prototype.append = function(a2, b2, c$12) {
            if (this.buffer_ += String(a2), b2 != null) for (var d2 = 1; d2 < arguments.length; d2++) this.buffer_ += arguments[d2];
            return this;
          }, goog.string.StringBuffer.prototype.clear = function() {
            this.buffer_ = "";
          }, goog.string.StringBuffer.prototype.getLength = function() {
            return this.buffer_.length;
          }, goog.string.StringBuffer.prototype.toString = function() {
            return this.buffer_;
          };
          var i18n = { phonenumbers: {} };
          i18n.phonenumbers.NumberFormat = function() {
            goog.proto2.Message.call(this);
          }, goog.inherits(i18n.phonenumbers.NumberFormat, goog.proto2.Message), i18n.phonenumbers.NumberFormat.descriptor_ = null, i18n.phonenumbers.NumberFormat.prototype.getPattern = function() {
            return this.get$Value(1);
          }, i18n.phonenumbers.NumberFormat.prototype.getPatternOrDefault = function() {
            return this.get$ValueOrDefault(1);
          }, i18n.phonenumbers.NumberFormat.prototype.setPattern = function(a2) {
            this.set$Value(1, a2);
          }, i18n.phonenumbers.NumberFormat.prototype.hasPattern = function() {
            return this.has$Value(1);
          }, i18n.phonenumbers.NumberFormat.prototype.patternCount = function() {
            return this.count$Values(1);
          }, i18n.phonenumbers.NumberFormat.prototype.clearPattern = function() {
            this.clear$Field(1);
          }, i18n.phonenumbers.NumberFormat.prototype.getFormat = function() {
            return this.get$Value(2);
          }, i18n.phonenumbers.NumberFormat.prototype.getFormatOrDefault = function() {
            return this.get$ValueOrDefault(2);
          }, i18n.phonenumbers.NumberFormat.prototype.setFormat = function(a2) {
            this.set$Value(2, a2);
          }, i18n.phonenumbers.NumberFormat.prototype.hasFormat = function() {
            return this.has$Value(2);
          }, i18n.phonenumbers.NumberFormat.prototype.formatCount = function() {
            return this.count$Values(2);
          }, i18n.phonenumbers.NumberFormat.prototype.clearFormat = function() {
            this.clear$Field(2);
          }, i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPattern = function(a2) {
            return this.get$Value(3, a2);
          }, i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPatternOrDefault = function(a2) {
            return this.get$ValueOrDefault(3, a2);
          }, i18n.phonenumbers.NumberFormat.prototype.addLeadingDigitsPattern = function(a2) {
            this.add$Value(3, a2);
          }, i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternArray = function() {
            return this.array$Values(3);
          }, i18n.phonenumbers.NumberFormat.prototype.hasLeadingDigitsPattern = function() {
            return this.has$Value(3);
          }, i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternCount = function() {
            return this.count$Values(3);
          }, i18n.phonenumbers.NumberFormat.prototype.clearLeadingDigitsPattern = function() {
            this.clear$Field(3);
          }, i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRule = function() {
            return this.get$Value(4);
          }, i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRuleOrDefault = function() {
            return this.get$ValueOrDefault(4);
          }, i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixFormattingRule = function(a2) {
            this.set$Value(4, a2);
          }, i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixFormattingRule = function() {
            return this.has$Value(4);
          }, i18n.phonenumbers.NumberFormat.prototype.nationalPrefixFormattingRuleCount = function() {
            return this.count$Values(4);
          }, i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixFormattingRule = function() {
            this.clear$Field(4);
          }, i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormatting = function() {
            return this.get$Value(6);
          }, i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormattingOrDefault = function() {
            return this.get$ValueOrDefault(6);
          }, i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixOptionalWhenFormatting = function(a2) {
            this.set$Value(6, a2);
          }, i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixOptionalWhenFormatting = function() {
            return this.has$Value(6);
          }, i18n.phonenumbers.NumberFormat.prototype.nationalPrefixOptionalWhenFormattingCount = function() {
            return this.count$Values(6);
          }, i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixOptionalWhenFormatting = function() {
            this.clear$Field(6);
          }, i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRule = function() {
            return this.get$Value(5);
          }, i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRuleOrDefault = function() {
            return this.get$ValueOrDefault(5);
          }, i18n.phonenumbers.NumberFormat.prototype.setDomesticCarrierCodeFormattingRule = function(a2) {
            this.set$Value(5, a2);
          }, i18n.phonenumbers.NumberFormat.prototype.hasDomesticCarrierCodeFormattingRule = function() {
            return this.has$Value(5);
          }, i18n.phonenumbers.NumberFormat.prototype.domesticCarrierCodeFormattingRuleCount = function() {
            return this.count$Values(5);
          }, i18n.phonenumbers.NumberFormat.prototype.clearDomesticCarrierCodeFormattingRule = function() {
            this.clear$Field(5);
          }, i18n.phonenumbers.PhoneNumberDesc = function() {
            goog.proto2.Message.call(this);
          }, goog.inherits(i18n.phonenumbers.PhoneNumberDesc, goog.proto2.Message), i18n.phonenumbers.PhoneNumberDesc.descriptor_ = null, i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPattern = function() {
            return this.get$Value(2);
          }, i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPatternOrDefault = function() {
            return this.get$ValueOrDefault(2);
          }, i18n.phonenumbers.PhoneNumberDesc.prototype.setNationalNumberPattern = function(a2) {
            this.set$Value(2, a2);
          }, i18n.phonenumbers.PhoneNumberDesc.prototype.hasNationalNumberPattern = function() {
            return this.has$Value(2);
          }, i18n.phonenumbers.PhoneNumberDesc.prototype.nationalNumberPatternCount = function() {
            return this.count$Values(2);
          }, i18n.phonenumbers.PhoneNumberDesc.prototype.clearNationalNumberPattern = function() {
            this.clear$Field(2);
          }, i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLength = function(a2) {
            return this.get$Value(9, a2);
          }, i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthOrDefault = function(a2) {
            return this.get$ValueOrDefault(9, a2);
          }, i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLength = function(a2) {
            this.add$Value(9, a2);
          }, i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthArray = function() {
            return this.array$Values(9);
          }, i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLength = function() {
            return this.has$Value(9);
          }, i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthCount = function() {
            return this.count$Values(9);
          }, i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLength = function() {
            this.clear$Field(9);
          }, i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnly = function(a2) {
            return this.get$Value(10, a2);
          }, i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnlyOrDefault = function(a2) {
            return this.get$ValueOrDefault(10, a2);
          }, i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLengthLocalOnly = function(a2) {
            this.add$Value(10, a2);
          }, i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyArray = function() {
            return this.array$Values(10);
          }, i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLengthLocalOnly = function() {
            return this.has$Value(10);
          }, i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyCount = function() {
            return this.count$Values(10);
          }, i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLengthLocalOnly = function() {
            this.clear$Field(10);
          }, i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumber = function() {
            return this.get$Value(6);
          }, i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumberOrDefault = function() {
            return this.get$ValueOrDefault(6);
          }, i18n.phonenumbers.PhoneNumberDesc.prototype.setExampleNumber = function(a2) {
            this.set$Value(6, a2);
          }, i18n.phonenumbers.PhoneNumberDesc.prototype.hasExampleNumber = function() {
            return this.has$Value(6);
          }, i18n.phonenumbers.PhoneNumberDesc.prototype.exampleNumberCount = function() {
            return this.count$Values(6);
          }, i18n.phonenumbers.PhoneNumberDesc.prototype.clearExampleNumber = function() {
            this.clear$Field(6);
          }, i18n.phonenumbers.PhoneMetadata = function() {
            goog.proto2.Message.call(this);
          }, goog.inherits(i18n.phonenumbers.PhoneMetadata, goog.proto2.Message), i18n.phonenumbers.PhoneMetadata.descriptor_ = null, i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDesc = function() {
            return this.get$Value(1);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDescOrDefault = function() {
            return this.get$ValueOrDefault(1);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setGeneralDesc = function(a2) {
            this.set$Value(1, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasGeneralDesc = function() {
            return this.has$Value(1);
          }, i18n.phonenumbers.PhoneMetadata.prototype.generalDescCount = function() {
            return this.count$Values(1);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearGeneralDesc = function() {
            this.clear$Field(1);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getFixedLine = function() {
            return this.get$Value(2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getFixedLineOrDefault = function() {
            return this.get$ValueOrDefault(2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setFixedLine = function(a2) {
            this.set$Value(2, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasFixedLine = function() {
            return this.has$Value(2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.fixedLineCount = function() {
            return this.count$Values(2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearFixedLine = function() {
            this.clear$Field(2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getMobile = function() {
            return this.get$Value(3);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getMobileOrDefault = function() {
            return this.get$ValueOrDefault(3);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setMobile = function(a2) {
            this.set$Value(3, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasMobile = function() {
            return this.has$Value(3);
          }, i18n.phonenumbers.PhoneMetadata.prototype.mobileCount = function() {
            return this.count$Values(3);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearMobile = function() {
            this.clear$Field(3);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getTollFree = function() {
            return this.get$Value(4);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getTollFreeOrDefault = function() {
            return this.get$ValueOrDefault(4);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setTollFree = function(a2) {
            this.set$Value(4, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasTollFree = function() {
            return this.has$Value(4);
          }, i18n.phonenumbers.PhoneMetadata.prototype.tollFreeCount = function() {
            return this.count$Values(4);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearTollFree = function() {
            this.clear$Field(4);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRate = function() {
            return this.get$Value(5);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRateOrDefault = function() {
            return this.get$ValueOrDefault(5);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setPremiumRate = function(a2) {
            this.set$Value(5, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasPremiumRate = function() {
            return this.has$Value(5);
          }, i18n.phonenumbers.PhoneMetadata.prototype.premiumRateCount = function() {
            return this.count$Values(5);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearPremiumRate = function() {
            this.clear$Field(5);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getSharedCost = function() {
            return this.get$Value(6);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getSharedCostOrDefault = function() {
            return this.get$ValueOrDefault(6);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setSharedCost = function(a2) {
            this.set$Value(6, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasSharedCost = function() {
            return this.has$Value(6);
          }, i18n.phonenumbers.PhoneMetadata.prototype.sharedCostCount = function() {
            return this.count$Values(6);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearSharedCost = function() {
            this.clear$Field(6);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumber = function() {
            return this.get$Value(7);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumberOrDefault = function() {
            return this.get$ValueOrDefault(7);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setPersonalNumber = function(a2) {
            this.set$Value(7, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasPersonalNumber = function() {
            return this.has$Value(7);
          }, i18n.phonenumbers.PhoneMetadata.prototype.personalNumberCount = function() {
            return this.count$Values(7);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearPersonalNumber = function() {
            this.clear$Field(7);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getVoip = function() {
            return this.get$Value(8);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getVoipOrDefault = function() {
            return this.get$ValueOrDefault(8);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setVoip = function(a2) {
            this.set$Value(8, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasVoip = function() {
            return this.has$Value(8);
          }, i18n.phonenumbers.PhoneMetadata.prototype.voipCount = function() {
            return this.count$Values(8);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearVoip = function() {
            this.clear$Field(8);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getPager = function() {
            return this.get$Value(21);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getPagerOrDefault = function() {
            return this.get$ValueOrDefault(21);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setPager = function(a2) {
            this.set$Value(21, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasPager = function() {
            return this.has$Value(21);
          }, i18n.phonenumbers.PhoneMetadata.prototype.pagerCount = function() {
            return this.count$Values(21);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearPager = function() {
            this.clear$Field(21);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getUan = function() {
            return this.get$Value(25);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getUanOrDefault = function() {
            return this.get$ValueOrDefault(25);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setUan = function(a2) {
            this.set$Value(25, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasUan = function() {
            return this.has$Value(25);
          }, i18n.phonenumbers.PhoneMetadata.prototype.uanCount = function() {
            return this.count$Values(25);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearUan = function() {
            this.clear$Field(25);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getEmergency = function() {
            return this.get$Value(27);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getEmergencyOrDefault = function() {
            return this.get$ValueOrDefault(27);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setEmergency = function(a2) {
            this.set$Value(27, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasEmergency = function() {
            return this.has$Value(27);
          }, i18n.phonenumbers.PhoneMetadata.prototype.emergencyCount = function() {
            return this.count$Values(27);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearEmergency = function() {
            this.clear$Field(27);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getVoicemail = function() {
            return this.get$Value(28);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getVoicemailOrDefault = function() {
            return this.get$ValueOrDefault(28);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setVoicemail = function(a2) {
            this.set$Value(28, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasVoicemail = function() {
            return this.has$Value(28);
          }, i18n.phonenumbers.PhoneMetadata.prototype.voicemailCount = function() {
            return this.count$Values(28);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearVoicemail = function() {
            this.clear$Field(28);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getShortCode = function() {
            return this.get$Value(29);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getShortCodeOrDefault = function() {
            return this.get$ValueOrDefault(29);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setShortCode = function(a2) {
            this.set$Value(29, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasShortCode = function() {
            return this.has$Value(29);
          }, i18n.phonenumbers.PhoneMetadata.prototype.shortCodeCount = function() {
            return this.count$Values(29);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearShortCode = function() {
            this.clear$Field(29);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getStandardRate = function() {
            return this.get$Value(30);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getStandardRateOrDefault = function() {
            return this.get$ValueOrDefault(30);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setStandardRate = function(a2) {
            this.set$Value(30, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasStandardRate = function() {
            return this.has$Value(30);
          }, i18n.phonenumbers.PhoneMetadata.prototype.standardRateCount = function() {
            return this.count$Values(30);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearStandardRate = function() {
            this.clear$Field(30);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getCarrierSpecific = function() {
            return this.get$Value(31);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getCarrierSpecificOrDefault = function() {
            return this.get$ValueOrDefault(31);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setCarrierSpecific = function(a2) {
            this.set$Value(31, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasCarrierSpecific = function() {
            return this.has$Value(31);
          }, i18n.phonenumbers.PhoneMetadata.prototype.carrierSpecificCount = function() {
            return this.count$Values(31);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearCarrierSpecific = function() {
            this.clear$Field(31);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getSmsServices = function() {
            return this.get$Value(33);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getSmsServicesOrDefault = function() {
            return this.get$ValueOrDefault(33);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setSmsServices = function(a2) {
            this.set$Value(33, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasSmsServices = function() {
            return this.has$Value(33);
          }, i18n.phonenumbers.PhoneMetadata.prototype.smsServicesCount = function() {
            return this.count$Values(33);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearSmsServices = function() {
            this.clear$Field(33);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDialling = function() {
            return this.get$Value(24);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDiallingOrDefault = function() {
            return this.get$ValueOrDefault(24);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setNoInternationalDialling = function(a2) {
            this.set$Value(24, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasNoInternationalDialling = function() {
            return this.has$Value(24);
          }, i18n.phonenumbers.PhoneMetadata.prototype.noInternationalDiallingCount = function() {
            return this.count$Values(24);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearNoInternationalDialling = function() {
            this.clear$Field(24);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getId = function() {
            return this.get$Value(9);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getIdOrDefault = function() {
            return this.get$ValueOrDefault(9);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setId = function(a2) {
            this.set$Value(9, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasId = function() {
            return this.has$Value(9);
          }, i18n.phonenumbers.PhoneMetadata.prototype.idCount = function() {
            return this.count$Values(9);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearId = function() {
            this.clear$Field(9);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getCountryCode = function() {
            return this.get$Value(10);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getCountryCodeOrDefault = function() {
            return this.get$ValueOrDefault(10);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setCountryCode = function(a2) {
            this.set$Value(10, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasCountryCode = function() {
            return this.has$Value(10);
          }, i18n.phonenumbers.PhoneMetadata.prototype.countryCodeCount = function() {
            return this.count$Values(10);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearCountryCode = function() {
            this.clear$Field(10);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefix = function() {
            return this.get$Value(11);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefixOrDefault = function() {
            return this.get$ValueOrDefault(11);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setInternationalPrefix = function(a2) {
            this.set$Value(11, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasInternationalPrefix = function() {
            return this.has$Value(11);
          }, i18n.phonenumbers.PhoneMetadata.prototype.internationalPrefixCount = function() {
            return this.count$Values(11);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearInternationalPrefix = function() {
            this.clear$Field(11);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefix = function() {
            return this.get$Value(17);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefixOrDefault = function() {
            return this.get$ValueOrDefault(17);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setPreferredInternationalPrefix = function(a2) {
            this.set$Value(17, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredInternationalPrefix = function() {
            return this.has$Value(17);
          }, i18n.phonenumbers.PhoneMetadata.prototype.preferredInternationalPrefixCount = function() {
            return this.count$Values(17);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredInternationalPrefix = function() {
            this.clear$Field(17);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefix = function() {
            return this.get$Value(12);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixOrDefault = function() {
            return this.get$ValueOrDefault(12);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefix = function(a2) {
            this.set$Value(12, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefix = function() {
            return this.has$Value(12);
          }, i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixCount = function() {
            return this.count$Values(12);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefix = function() {
            this.clear$Field(12);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefix = function() {
            return this.get$Value(13);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefixOrDefault = function() {
            return this.get$ValueOrDefault(13);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setPreferredExtnPrefix = function(a2) {
            this.set$Value(13, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredExtnPrefix = function() {
            return this.has$Value(13);
          }, i18n.phonenumbers.PhoneMetadata.prototype.preferredExtnPrefixCount = function() {
            return this.count$Values(13);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredExtnPrefix = function() {
            this.clear$Field(13);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsing = function() {
            return this.get$Value(15);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsingOrDefault = function() {
            return this.get$ValueOrDefault(15);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixForParsing = function(a2) {
            this.set$Value(15, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixForParsing = function() {
            return this.has$Value(15);
          }, i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixForParsingCount = function() {
            return this.count$Values(15);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixForParsing = function() {
            this.clear$Field(15);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRule = function() {
            return this.get$Value(16);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRuleOrDefault = function() {
            return this.get$ValueOrDefault(16);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixTransformRule = function(a2) {
            this.set$Value(16, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixTransformRule = function() {
            return this.has$Value(16);
          }, i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixTransformRuleCount = function() {
            return this.count$Values(16);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixTransformRule = function() {
            this.clear$Field(16);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePattern = function() {
            return this.get$Value(18);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePatternOrDefault = function() {
            return this.get$ValueOrDefault(18);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setSameMobileAndFixedLinePattern = function(a2) {
            this.set$Value(18, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasSameMobileAndFixedLinePattern = function() {
            return this.has$Value(18);
          }, i18n.phonenumbers.PhoneMetadata.prototype.sameMobileAndFixedLinePatternCount = function() {
            return this.count$Values(18);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearSameMobileAndFixedLinePattern = function() {
            this.clear$Field(18);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormat = function(a2) {
            return this.get$Value(19, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormatOrDefault = function(a2) {
            return this.get$ValueOrDefault(19, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.addNumberFormat = function(a2) {
            this.add$Value(19, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.numberFormatArray = function() {
            return this.array$Values(19);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasNumberFormat = function() {
            return this.has$Value(19);
          }, i18n.phonenumbers.PhoneMetadata.prototype.numberFormatCount = function() {
            return this.count$Values(19);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearNumberFormat = function() {
            this.clear$Field(19);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormat = function(a2) {
            return this.get$Value(20, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormatOrDefault = function(a2) {
            return this.get$ValueOrDefault(20, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.addIntlNumberFormat = function(a2) {
            this.add$Value(20, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatArray = function() {
            return this.array$Values(20);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasIntlNumberFormat = function() {
            return this.has$Value(20);
          }, i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatCount = function() {
            return this.count$Values(20);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearIntlNumberFormat = function() {
            this.clear$Field(20);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCode = function() {
            return this.get$Value(22);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCodeOrDefault = function() {
            return this.get$ValueOrDefault(22);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setMainCountryForCode = function(a2) {
            this.set$Value(22, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasMainCountryForCode = function() {
            return this.has$Value(22);
          }, i18n.phonenumbers.PhoneMetadata.prototype.mainCountryForCodeCount = function() {
            return this.count$Values(22);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearMainCountryForCode = function() {
            this.clear$Field(22);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigits = function() {
            return this.get$Value(23);
          }, i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigitsOrDefault = function() {
            return this.get$ValueOrDefault(23);
          }, i18n.phonenumbers.PhoneMetadata.prototype.setLeadingDigits = function(a2) {
            this.set$Value(23, a2);
          }, i18n.phonenumbers.PhoneMetadata.prototype.hasLeadingDigits = function() {
            return this.has$Value(23);
          }, i18n.phonenumbers.PhoneMetadata.prototype.leadingDigitsCount = function() {
            return this.count$Values(23);
          }, i18n.phonenumbers.PhoneMetadata.prototype.clearLeadingDigits = function() {
            this.clear$Field(23);
          }, i18n.phonenumbers.PhoneMetadataCollection = function() {
            goog.proto2.Message.call(this);
          }, goog.inherits(i18n.phonenumbers.PhoneMetadataCollection, goog.proto2.Message), i18n.phonenumbers.PhoneMetadataCollection.descriptor_ = null, i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadata = function(a2) {
            return this.get$Value(1, a2);
          }, i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadataOrDefault = function(a2) {
            return this.get$ValueOrDefault(1, a2);
          }, i18n.phonenumbers.PhoneMetadataCollection.prototype.addMetadata = function(a2) {
            this.add$Value(1, a2);
          }, i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataArray = function() {
            return this.array$Values(1);
          }, i18n.phonenumbers.PhoneMetadataCollection.prototype.hasMetadata = function() {
            return this.has$Value(1);
          }, i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataCount = function() {
            return this.count$Values(1);
          }, i18n.phonenumbers.PhoneMetadataCollection.prototype.clearMetadata = function() {
            this.clear$Field(1);
          }, i18n.phonenumbers.NumberFormat.prototype.getDescriptor = function() {
            var a2 = i18n.phonenumbers.NumberFormat.descriptor_;
            return a2 || (i18n.phonenumbers.NumberFormat.descriptor_ = a2 = goog.proto2.Message.createDescriptor(i18n.phonenumbers.NumberFormat, {
              0: {
                name: "NumberFormat",
                fullName: "i18n.phonenumbers.NumberFormat"
              },
              1: {
                name: "pattern",
                required: true,
                fieldType: goog.proto2.Message.FieldType.STRING,
                type: String
              },
              2: {
                name: "format",
                required: true,
                fieldType: goog.proto2.Message.FieldType.STRING,
                type: String
              },
              3: {
                name: "leading_digits_pattern",
                repeated: true,
                fieldType: goog.proto2.Message.FieldType.STRING,
                type: String
              },
              4: {
                name: "national_prefix_formatting_rule",
                fieldType: goog.proto2.Message.FieldType.STRING,
                type: String
              },
              6: {
                name: "national_prefix_optional_when_formatting",
                fieldType: goog.proto2.Message.FieldType.BOOL,
                defaultValue: false,
                type: Boolean
              },
              5: {
                name: "domestic_carrier_code_formatting_rule",
                fieldType: goog.proto2.Message.FieldType.STRING,
                type: String
              }
            })), a2;
          }, i18n.phonenumbers.NumberFormat.getDescriptor = i18n.phonenumbers.NumberFormat.prototype.getDescriptor, i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor = function() {
            var a2 = i18n.phonenumbers.PhoneNumberDesc.descriptor_;
            return a2 || (i18n.phonenumbers.PhoneNumberDesc.descriptor_ = a2 = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumberDesc, {
              0: {
                name: "PhoneNumberDesc",
                fullName: "i18n.phonenumbers.PhoneNumberDesc"
              },
              2: {
                name: "national_number_pattern",
                fieldType: goog.proto2.Message.FieldType.STRING,
                type: String
              },
              9: {
                name: "possible_length",
                repeated: true,
                fieldType: goog.proto2.Message.FieldType.INT32,
                type: Number
              },
              10: {
                name: "possible_length_local_only",
                repeated: true,
                fieldType: goog.proto2.Message.FieldType.INT32,
                type: Number
              },
              6: {
                name: "example_number",
                fieldType: goog.proto2.Message.FieldType.STRING,
                type: String
              }
            })), a2;
          }, i18n.phonenumbers.PhoneNumberDesc.getDescriptor = i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor, i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor = function() {
            var a2 = i18n.phonenumbers.PhoneMetadata.descriptor_;
            return a2 || (i18n.phonenumbers.PhoneMetadata.descriptor_ = a2 = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadata, {
              0: {
                name: "PhoneMetadata",
                fullName: "i18n.phonenumbers.PhoneMetadata"
              },
              1: {
                name: "general_desc",
                fieldType: goog.proto2.Message.FieldType.MESSAGE,
                type: i18n.phonenumbers.PhoneNumberDesc
              },
              2: {
                name: "fixed_line",
                fieldType: goog.proto2.Message.FieldType.MESSAGE,
                type: i18n.phonenumbers.PhoneNumberDesc
              },
              3: {
                name: "mobile",
                fieldType: goog.proto2.Message.FieldType.MESSAGE,
                type: i18n.phonenumbers.PhoneNumberDesc
              },
              4: {
                name: "toll_free",
                fieldType: goog.proto2.Message.FieldType.MESSAGE,
                type: i18n.phonenumbers.PhoneNumberDesc
              },
              5: {
                name: "premium_rate",
                fieldType: goog.proto2.Message.FieldType.MESSAGE,
                type: i18n.phonenumbers.PhoneNumberDesc
              },
              6: {
                name: "shared_cost",
                fieldType: goog.proto2.Message.FieldType.MESSAGE,
                type: i18n.phonenumbers.PhoneNumberDesc
              },
              7: {
                name: "personal_number",
                fieldType: goog.proto2.Message.FieldType.MESSAGE,
                type: i18n.phonenumbers.PhoneNumberDesc
              },
              8: {
                name: "voip",
                fieldType: goog.proto2.Message.FieldType.MESSAGE,
                type: i18n.phonenumbers.PhoneNumberDesc
              },
              21: {
                name: "pager",
                fieldType: goog.proto2.Message.FieldType.MESSAGE,
                type: i18n.phonenumbers.PhoneNumberDesc
              },
              25: {
                name: "uan",
                fieldType: goog.proto2.Message.FieldType.MESSAGE,
                type: i18n.phonenumbers.PhoneNumberDesc
              },
              27: {
                name: "emergency",
                fieldType: goog.proto2.Message.FieldType.MESSAGE,
                type: i18n.phonenumbers.PhoneNumberDesc
              },
              28: {
                name: "voicemail",
                fieldType: goog.proto2.Message.FieldType.MESSAGE,
                type: i18n.phonenumbers.PhoneNumberDesc
              },
              29: {
                name: "short_code",
                fieldType: goog.proto2.Message.FieldType.MESSAGE,
                type: i18n.phonenumbers.PhoneNumberDesc
              },
              30: {
                name: "standard_rate",
                fieldType: goog.proto2.Message.FieldType.MESSAGE,
                type: i18n.phonenumbers.PhoneNumberDesc
              },
              31: {
                name: "carrier_specific",
                fieldType: goog.proto2.Message.FieldType.MESSAGE,
                type: i18n.phonenumbers.PhoneNumberDesc
              },
              33: {
                name: "sms_services",
                fieldType: goog.proto2.Message.FieldType.MESSAGE,
                type: i18n.phonenumbers.PhoneNumberDesc
              },
              24: {
                name: "no_international_dialling",
                fieldType: goog.proto2.Message.FieldType.MESSAGE,
                type: i18n.phonenumbers.PhoneNumberDesc
              },
              9: {
                name: "id",
                required: true,
                fieldType: goog.proto2.Message.FieldType.STRING,
                type: String
              },
              10: {
                name: "country_code",
                fieldType: goog.proto2.Message.FieldType.INT32,
                type: Number
              },
              11: {
                name: "international_prefix",
                fieldType: goog.proto2.Message.FieldType.STRING,
                type: String
              },
              17: {
                name: "preferred_international_prefix",
                fieldType: goog.proto2.Message.FieldType.STRING,
                type: String
              },
              12: {
                name: "national_prefix",
                fieldType: goog.proto2.Message.FieldType.STRING,
                type: String
              },
              13: {
                name: "preferred_extn_prefix",
                fieldType: goog.proto2.Message.FieldType.STRING,
                type: String
              },
              15: {
                name: "national_prefix_for_parsing",
                fieldType: goog.proto2.Message.FieldType.STRING,
                type: String
              },
              16: {
                name: "national_prefix_transform_rule",
                fieldType: goog.proto2.Message.FieldType.STRING,
                type: String
              },
              18: {
                name: "same_mobile_and_fixed_line_pattern",
                fieldType: goog.proto2.Message.FieldType.BOOL,
                defaultValue: false,
                type: Boolean
              },
              19: {
                name: "number_format",
                repeated: true,
                fieldType: goog.proto2.Message.FieldType.MESSAGE,
                type: i18n.phonenumbers.NumberFormat
              },
              20: {
                name: "intl_number_format",
                repeated: true,
                fieldType: goog.proto2.Message.FieldType.MESSAGE,
                type: i18n.phonenumbers.NumberFormat
              },
              22: {
                name: "main_country_for_code",
                fieldType: goog.proto2.Message.FieldType.BOOL,
                defaultValue: false,
                type: Boolean
              },
              23: {
                name: "leading_digits",
                fieldType: goog.proto2.Message.FieldType.STRING,
                type: String
              }
            })), a2;
          }, i18n.phonenumbers.PhoneMetadata.getDescriptor = i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor, i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor = function() {
            var a2 = i18n.phonenumbers.PhoneMetadataCollection.descriptor_;
            return a2 || (i18n.phonenumbers.PhoneMetadataCollection.descriptor_ = a2 = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadataCollection, {
              0: {
                name: "PhoneMetadataCollection",
                fullName: "i18n.phonenumbers.PhoneMetadataCollection"
              },
              1: {
                name: "metadata",
                repeated: true,
                fieldType: goog.proto2.Message.FieldType.MESSAGE,
                type: i18n.phonenumbers.PhoneMetadata
              }
            })), a2;
          }, i18n.phonenumbers.PhoneMetadataCollection.getDescriptor = i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor, i18n.phonenumbers.PhoneNumber = function() {
            goog.proto2.Message.call(this);
          }, goog.inherits(i18n.phonenumbers.PhoneNumber, goog.proto2.Message), i18n.phonenumbers.PhoneNumber.descriptor_ = null, i18n.phonenumbers.PhoneNumber.prototype.getCountryCode = function() {
            return this.get$Value(1);
          }, i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeOrDefault = function() {
            return this.get$ValueOrDefault(1);
          }, i18n.phonenumbers.PhoneNumber.prototype.setCountryCode = function(a2) {
            this.set$Value(1, a2);
          }, i18n.phonenumbers.PhoneNumber.prototype.hasCountryCode = function() {
            return this.has$Value(1);
          }, i18n.phonenumbers.PhoneNumber.prototype.countryCodeCount = function() {
            return this.count$Values(1);
          }, i18n.phonenumbers.PhoneNumber.prototype.clearCountryCode = function() {
            this.clear$Field(1);
          }, i18n.phonenumbers.PhoneNumber.prototype.getNationalNumber = function() {
            return this.get$Value(2);
          }, i18n.phonenumbers.PhoneNumber.prototype.getNationalNumberOrDefault = function() {
            return this.get$ValueOrDefault(2);
          }, i18n.phonenumbers.PhoneNumber.prototype.setNationalNumber = function(a2) {
            this.set$Value(2, a2);
          }, i18n.phonenumbers.PhoneNumber.prototype.hasNationalNumber = function() {
            return this.has$Value(2);
          }, i18n.phonenumbers.PhoneNumber.prototype.nationalNumberCount = function() {
            return this.count$Values(2);
          }, i18n.phonenumbers.PhoneNumber.prototype.clearNationalNumber = function() {
            this.clear$Field(2);
          }, i18n.phonenumbers.PhoneNumber.prototype.getExtension = function() {
            return this.get$Value(3);
          }, i18n.phonenumbers.PhoneNumber.prototype.getExtensionOrDefault = function() {
            return this.get$ValueOrDefault(3);
          }, i18n.phonenumbers.PhoneNumber.prototype.setExtension = function(a2) {
            this.set$Value(3, a2);
          }, i18n.phonenumbers.PhoneNumber.prototype.hasExtension = function() {
            return this.has$Value(3);
          }, i18n.phonenumbers.PhoneNumber.prototype.extensionCount = function() {
            return this.count$Values(3);
          }, i18n.phonenumbers.PhoneNumber.prototype.clearExtension = function() {
            this.clear$Field(3);
          }, i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZero = function() {
            return this.get$Value(4);
          }, i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZeroOrDefault = function() {
            return this.get$ValueOrDefault(4);
          }, i18n.phonenumbers.PhoneNumber.prototype.setItalianLeadingZero = function(a2) {
            this.set$Value(4, a2);
          }, i18n.phonenumbers.PhoneNumber.prototype.hasItalianLeadingZero = function() {
            return this.has$Value(4);
          }, i18n.phonenumbers.PhoneNumber.prototype.italianLeadingZeroCount = function() {
            return this.count$Values(4);
          }, i18n.phonenumbers.PhoneNumber.prototype.clearItalianLeadingZero = function() {
            this.clear$Field(4);
          }, i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZeros = function() {
            return this.get$Value(8);
          }, i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZerosOrDefault = function() {
            return this.get$ValueOrDefault(8);
          }, i18n.phonenumbers.PhoneNumber.prototype.setNumberOfLeadingZeros = function(a2) {
            this.set$Value(8, a2);
          }, i18n.phonenumbers.PhoneNumber.prototype.hasNumberOfLeadingZeros = function() {
            return this.has$Value(8);
          }, i18n.phonenumbers.PhoneNumber.prototype.numberOfLeadingZerosCount = function() {
            return this.count$Values(8);
          }, i18n.phonenumbers.PhoneNumber.prototype.clearNumberOfLeadingZeros = function() {
            this.clear$Field(8);
          }, i18n.phonenumbers.PhoneNumber.prototype.getRawInput = function() {
            return this.get$Value(5);
          }, i18n.phonenumbers.PhoneNumber.prototype.getRawInputOrDefault = function() {
            return this.get$ValueOrDefault(5);
          }, i18n.phonenumbers.PhoneNumber.prototype.setRawInput = function(a2) {
            this.set$Value(5, a2);
          }, i18n.phonenumbers.PhoneNumber.prototype.hasRawInput = function() {
            return this.has$Value(5);
          }, i18n.phonenumbers.PhoneNumber.prototype.rawInputCount = function() {
            return this.count$Values(5);
          }, i18n.phonenumbers.PhoneNumber.prototype.clearRawInput = function() {
            this.clear$Field(5);
          }, i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSource = function() {
            return this.get$Value(6);
          }, i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSourceOrDefault = function() {
            return this.get$ValueOrDefault(6);
          }, i18n.phonenumbers.PhoneNumber.prototype.setCountryCodeSource = function(a2) {
            this.set$Value(6, a2);
          }, i18n.phonenumbers.PhoneNumber.prototype.hasCountryCodeSource = function() {
            return this.has$Value(6);
          }, i18n.phonenumbers.PhoneNumber.prototype.countryCodeSourceCount = function() {
            return this.count$Values(6);
          }, i18n.phonenumbers.PhoneNumber.prototype.clearCountryCodeSource = function() {
            this.clear$Field(6);
          }, i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCode = function() {
            return this.get$Value(7);
          }, i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCodeOrDefault = function() {
            return this.get$ValueOrDefault(7);
          }, i18n.phonenumbers.PhoneNumber.prototype.setPreferredDomesticCarrierCode = function(a2) {
            this.set$Value(7, a2);
          }, i18n.phonenumbers.PhoneNumber.prototype.hasPreferredDomesticCarrierCode = function() {
            return this.has$Value(7);
          }, i18n.phonenumbers.PhoneNumber.prototype.preferredDomesticCarrierCodeCount = function() {
            return this.count$Values(7);
          }, i18n.phonenumbers.PhoneNumber.prototype.clearPreferredDomesticCarrierCode = function() {
            this.clear$Field(7);
          }, i18n.phonenumbers.PhoneNumber.CountryCodeSource = {
            UNSPECIFIED: 0,
            FROM_NUMBER_WITH_PLUS_SIGN: 1,
            FROM_NUMBER_WITH_IDD: 5,
            FROM_NUMBER_WITHOUT_PLUS_SIGN: 10,
            FROM_DEFAULT_COUNTRY: 20
          }, i18n.phonenumbers.PhoneNumber.prototype.getDescriptor = function() {
            var a2 = i18n.phonenumbers.PhoneNumber.descriptor_;
            return a2 || (i18n.phonenumbers.PhoneNumber.descriptor_ = a2 = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumber, {
              0: {
                name: "PhoneNumber",
                fullName: "i18n.phonenumbers.PhoneNumber"
              },
              1: {
                name: "country_code",
                required: true,
                fieldType: goog.proto2.Message.FieldType.INT32,
                type: Number
              },
              2: {
                name: "national_number",
                required: true,
                fieldType: goog.proto2.Message.FieldType.UINT64,
                type: Number
              },
              3: {
                name: "extension",
                fieldType: goog.proto2.Message.FieldType.STRING,
                type: String
              },
              4: {
                name: "italian_leading_zero",
                fieldType: goog.proto2.Message.FieldType.BOOL,
                type: Boolean
              },
              8: {
                name: "number_of_leading_zeros",
                fieldType: goog.proto2.Message.FieldType.INT32,
                defaultValue: 1,
                type: Number
              },
              5: {
                name: "raw_input",
                fieldType: goog.proto2.Message.FieldType.STRING,
                type: String
              },
              6: {
                name: "country_code_source",
                fieldType: goog.proto2.Message.FieldType.ENUM,
                defaultValue: i18n.phonenumbers.PhoneNumber.CountryCodeSource.UNSPECIFIED,
                type: i18n.phonenumbers.PhoneNumber.CountryCodeSource
              },
              7: {
                name: "preferred_domestic_carrier_code",
                fieldType: goog.proto2.Message.FieldType.STRING,
                type: String
              }
            })), a2;
          }, i18n.phonenumbers.PhoneNumber.ctor = i18n.phonenumbers.PhoneNumber, i18n.phonenumbers.PhoneNumber.ctor.getDescriptor = i18n.phonenumbers.PhoneNumber.prototype.getDescriptor, i18n.phonenumbers.metadata = {}, i18n.phonenumbers.metadata.countryCodeToRegionCodeMap = {
            1: "US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "),
            7: ["RU", "KZ"],
            20: ["EG"],
            27: ["ZA"],
            30: ["GR"],
            31: ["NL"],
            32: ["BE"],
            33: ["FR"],
            34: ["ES"],
            36: ["HU"],
            39: ["IT", "VA"],
            40: ["RO"],
            41: ["CH"],
            43: ["AT"],
            44: [
              "GB",
              "GG",
              "IM",
              "JE"
            ],
            45: ["DK"],
            46: ["SE"],
            47: ["NO", "SJ"],
            48: ["PL"],
            49: ["DE"],
            51: ["PE"],
            52: ["MX"],
            53: ["CU"],
            54: ["AR"],
            55: ["BR"],
            56: ["CL"],
            57: ["CO"],
            58: ["VE"],
            60: ["MY"],
            61: [
              "AU",
              "CC",
              "CX"
            ],
            62: ["ID"],
            63: ["PH"],
            64: ["NZ"],
            65: ["SG"],
            66: ["TH"],
            81: ["JP"],
            82: ["KR"],
            84: ["VN"],
            86: ["CN"],
            90: ["TR"],
            91: ["IN"],
            92: ["PK"],
            93: ["AF"],
            94: ["LK"],
            95: ["MM"],
            98: ["IR"],
            211: ["SS"],
            212: ["MA", "EH"],
            213: ["DZ"],
            216: ["TN"],
            218: ["LY"],
            220: ["GM"],
            221: ["SN"],
            222: ["MR"],
            223: ["ML"],
            224: ["GN"],
            225: ["CI"],
            226: ["BF"],
            227: ["NE"],
            228: ["TG"],
            229: ["BJ"],
            230: ["MU"],
            231: ["LR"],
            232: ["SL"],
            233: ["GH"],
            234: ["NG"],
            235: ["TD"],
            236: ["CF"],
            237: ["CM"],
            238: ["CV"],
            239: ["ST"],
            240: ["GQ"],
            241: ["GA"],
            242: ["CG"],
            243: ["CD"],
            244: ["AO"],
            245: ["GW"],
            246: ["IO"],
            247: ["AC"],
            248: ["SC"],
            249: ["SD"],
            250: ["RW"],
            251: ["ET"],
            252: ["SO"],
            253: ["DJ"],
            254: ["KE"],
            255: ["TZ"],
            256: ["UG"],
            257: ["BI"],
            258: ["MZ"],
            260: ["ZM"],
            261: ["MG"],
            262: ["RE", "YT"],
            263: ["ZW"],
            264: ["NA"],
            265: ["MW"],
            266: ["LS"],
            267: ["BW"],
            268: ["SZ"],
            269: ["KM"],
            290: ["SH", "TA"],
            291: ["ER"],
            297: ["AW"],
            298: ["FO"],
            299: ["GL"],
            350: ["GI"],
            351: ["PT"],
            352: ["LU"],
            353: ["IE"],
            354: ["IS"],
            355: ["AL"],
            356: ["MT"],
            357: ["CY"],
            358: ["FI", "AX"],
            359: ["BG"],
            370: ["LT"],
            371: ["LV"],
            372: ["EE"],
            373: ["MD"],
            374: ["AM"],
            375: ["BY"],
            376: ["AD"],
            377: ["MC"],
            378: ["SM"],
            380: ["UA"],
            381: ["RS"],
            382: ["ME"],
            383: ["XK"],
            385: ["HR"],
            386: ["SI"],
            387: ["BA"],
            389: ["MK"],
            420: ["CZ"],
            421: ["SK"],
            423: ["LI"],
            500: ["FK"],
            501: ["BZ"],
            502: ["GT"],
            503: ["SV"],
            504: ["HN"],
            505: ["NI"],
            506: ["CR"],
            507: ["PA"],
            508: ["PM"],
            509: ["HT"],
            590: [
              "GP",
              "BL",
              "MF"
            ],
            591: ["BO"],
            592: ["GY"],
            593: ["EC"],
            594: ["GF"],
            595: ["PY"],
            596: ["MQ"],
            597: ["SR"],
            598: ["UY"],
            599: ["CW", "BQ"],
            670: ["TL"],
            672: ["NF"],
            673: ["BN"],
            674: ["NR"],
            675: ["PG"],
            676: ["TO"],
            677: ["SB"],
            678: ["VU"],
            679: ["FJ"],
            680: ["PW"],
            681: ["WF"],
            682: ["CK"],
            683: ["NU"],
            685: ["WS"],
            686: ["KI"],
            687: ["NC"],
            688: ["TV"],
            689: ["PF"],
            690: ["TK"],
            691: ["FM"],
            692: ["MH"],
            800: ["001"],
            808: ["001"],
            850: ["KP"],
            852: ["HK"],
            853: ["MO"],
            855: ["KH"],
            856: ["LA"],
            870: ["001"],
            878: ["001"],
            880: ["BD"],
            881: ["001"],
            882: ["001"],
            883: ["001"],
            886: ["TW"],
            888: ["001"],
            960: ["MV"],
            961: ["LB"],
            962: ["JO"],
            963: ["SY"],
            964: ["IQ"],
            965: ["KW"],
            966: ["SA"],
            967: ["YE"],
            968: ["OM"],
            970: ["PS"],
            971: ["AE"],
            972: ["IL"],
            973: ["BH"],
            974: ["QA"],
            975: ["BT"],
            976: ["MN"],
            977: ["NP"],
            979: ["001"],
            992: ["TJ"],
            993: ["TM"],
            994: ["AZ"],
            995: ["GE"],
            996: ["KG"],
            998: ["UZ"]
          }, i18n.phonenumbers.metadata.countryToMetadata = {
            AC: [
              ,
              [
                ,
                ,
                "(?:[01589]\\d|[46])\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [5, 6]
              ],
              [
                ,
                ,
                "6[2-467]\\d{3}",
                ,
                ,
                ,
                "62889",
                ,
                ,
                [5]
              ],
              [
                ,
                ,
                "4\\d{4}",
                ,
                ,
                ,
                "40123",
                ,
                ,
                [5]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "AC",
              247,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:0[1-9]|[1589]\\d)\\d{4}",
                ,
                ,
                ,
                "542011",
                ,
                ,
                [6]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            AD: [
              ,
              [
                ,
                ,
                "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  6,
                  8,
                  9
                ]
              ],
              [
                ,
                ,
                "[78]\\d{5}",
                ,
                ,
                ,
                "712345",
                ,
                ,
                [6]
              ],
              [
                ,
                ,
                "690\\d{6}|[356]\\d{5}",
                ,
                ,
                ,
                "312345",
                ,
                ,
                [6, 9]
              ],
              [
                ,
                ,
                "180[02]\\d{4}",
                ,
                ,
                ,
                "18001234",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "[19]\\d{5}",
                ,
                ,
                ,
                "912345",
                ,
                ,
                [6]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "AD",
              376,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{3})",
                  "$1 $2",
                  ["[135-9]"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{4})",
                  "$1 $2",
                  ["1"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["6"]
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "1800\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            AE: [
              ,
              [
                ,
                ,
                "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  5,
                  6,
                  7,
                  8,
                  9,
                  10,
                  11,
                  12
                ]
              ],
              [
                ,
                ,
                "[2-4679][2-8]\\d{6}",
                ,
                ,
                ,
                "22345678",
                ,
                ,
                [8],
                [7]
              ],
              [
                ,
                ,
                "5[024-68]\\d{7}",
                ,
                ,
                ,
                "501234567",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "400\\d{6}|800\\d{2,9}",
                ,
                ,
                ,
                "800123456"
              ],
              [
                ,
                ,
                "900[02]\\d{5}",
                ,
                ,
                ,
                "900234567",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "700[05]\\d{5}",
                ,
                ,
                ,
                "700012345",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "AE",
              971,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{2,9})",
                  "$1 $2",
                  ["60|8"]
                ],
                [
                  ,
                  "(\\d)(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["[236]|[479][2-8]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d)(\\d{5})",
                  "$1 $2 $3",
                  ["[479]"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["5"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "600[25]\\d{5}",
                ,
                ,
                ,
                "600212345",
                ,
                ,
                [9]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            AF: [
              ,
              [
                ,
                ,
                "[2-7]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9],
                [7]
              ],
              [
                ,
                ,
                "(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}",
                ,
                ,
                ,
                "234567890",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "7\\d{8}",
                ,
                ,
                ,
                "701234567",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "AF",
              93,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{4})",
                "$1 $2",
                ["[1-9]"]
              ], [
                ,
                "(\\d{2})(\\d{3})(\\d{4})",
                "$1 $2 $3",
                ["[2-7]"],
                "0$1"
              ]],
              [[
                ,
                "(\\d{2})(\\d{3})(\\d{4})",
                "$1 $2 $3",
                ["[2-7]"],
                "0$1"
              ]],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            AG: [
              ,
              [
                ,
                ,
                "(?:268|[58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}",
                ,
                ,
                ,
                "2684601234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}",
                ,
                ,
                ,
                "2684641234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
              ],
              [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ],
              [
                ,
                ,
                "26848[01]\\d{4}",
                ,
                ,
                ,
                "2684801234",
                ,
                ,
                ,
                [7]
              ],
              "AG",
              1,
              "011",
              "1",
              ,
              ,
              "([457]\\d{6})$|1",
              "268$1",
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "26840[69]\\d{4}",
                ,
                ,
                ,
                "2684061234",
                ,
                ,
                ,
                [7]
              ],
              ,
              "268",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            AI: [
              ,
              [
                ,
                ,
                "(?:264|[58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "264(?:292|4(?:6[12]|9[78]))\\d{4}",
                ,
                ,
                ,
                "2644612345",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}",
                ,
                ,
                ,
                "2642351234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
              ],
              [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "AI",
              1,
              "011",
              "1",
              ,
              ,
              "([2457]\\d{6})$|1",
              "264$1",
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "264724\\d{4}",
                ,
                ,
                ,
                "2647241234",
                ,
                ,
                ,
                [7]
              ],
              ,
              "264",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            AL: [
              ,
              [
                ,
                ,
                "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  6,
                  7,
                  8,
                  9
                ],
                [5]
              ],
              [
                ,
                ,
                "4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}",
                ,
                ,
                ,
                "22345678",
                ,
                ,
                [8],
                [
                  5,
                  6,
                  7
                ]
              ],
              [
                ,
                ,
                "6(?:[78][2-9]|9\\d)\\d{6}",
                ,
                ,
                ,
                "672123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "800\\d{4}",
                ,
                ,
                ,
                "8001234",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "900[1-9]\\d\\d",
                ,
                ,
                ,
                "900123",
                ,
                ,
                [6]
              ],
              [
                ,
                ,
                "808[1-9]\\d\\d",
                ,
                ,
                ,
                "808123",
                ,
                ,
                [6]
              ],
              [
                ,
                ,
                "700[2-9]\\d{4}",
                ,
                ,
                ,
                "70021234",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "AL",
              355,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{3,4})",
                  "$1 $2",
                  ["80|9"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["4[2-6]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["[2358][2-5]|4"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{5})",
                  "$1 $2",
                  ["[23578]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["6"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            AM: [
              ,
              [
                ,
                ,
                "(?:[1-489]\\d|55|60|77)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8],
                [5, 6]
              ],
              [
                ,
                ,
                "(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}",
                ,
                ,
                ,
                "10123456",
                ,
                ,
                ,
                [5, 6]
              ],
              [
                ,
                ,
                "(?:33|4[1349]|55|77|88|9[13-9])\\d{6}",
                ,
                ,
                ,
                "77123456"
              ],
              [
                ,
                ,
                "800\\d{5}",
                ,
                ,
                ,
                "80012345"
              ],
              [
                ,
                ,
                "90[016]\\d{5}",
                ,
                ,
                ,
                "90012345"
              ],
              [
                ,
                ,
                "80[1-4]\\d{5}",
                ,
                ,
                ,
                "80112345"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}",
                ,
                ,
                ,
                "60271234"
              ],
              "AM",
              374,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{3})",
                  "$1 $2 $3",
                  ["[89]0"],
                  "0 $1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{5})",
                  "$1 $2",
                  ["2|3[12]"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{2})(\\d{6})",
                  "$1 $2",
                  ["1|47"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{2})(\\d{6})",
                  "$1 $2",
                  ["[3-9]"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            AO: [
              ,
              [
                ,
                ,
                "[29]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}",
                ,
                ,
                ,
                "222123456"
              ],
              [
                ,
                ,
                "9[1-79]\\d{7}",
                ,
                ,
                ,
                "923123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "AO",
              244,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[29]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            AR: [
              ,
              [
                ,
                ,
                "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10, 11],
                [
                  6,
                  7,
                  8
                ]
              ],
              [
                ,
                ,
                "3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68])))\\d{6}|(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
                ,
                ,
                ,
                "1123456789",
                ,
                ,
                [10],
                [
                  6,
                  7,
                  8
                ]
              ],
              [
                ,
                ,
                "93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|9(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68]))))\\d{6}|9(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
                ,
                ,
                ,
                "91123456789",
                ,
                ,
                ,
                [
                  6,
                  7,
                  8
                ]
              ],
              [
                ,
                ,
                "800\\d{7,8}",
                ,
                ,
                ,
                "8001234567"
              ],
              [
                ,
                ,
                "60[04579]\\d{7}",
                ,
                ,
                ,
                "6001234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "AR",
              54,
              "00",
              "0",
              ,
              ,
              "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
              "9$1",
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})",
                  "$1",
                  ["0|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478])|911"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})",
                  "$1-$2",
                  ["[1-9]"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})",
                  "$1-$2",
                  ["[2-9]"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{4})",
                  "$1-$2",
                  ["[1-8]"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{2})(\\d{4})",
                  "$1 $2-$3",
                  [
                    "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                    "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                    "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                    "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                  ],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{4})",
                  "$1 $2-$3",
                  ["1"],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1-$2-$3",
                  ["[68]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2-$3",
                  ["[23]"],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                  "$2 15-$3-$4",
                  [
                    "9(?:2[2-469]|3[3-578])",
                    "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                    "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                    "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                    "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                  ],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                  "$2 15-$3-$4",
                  ["91"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{5})",
                  "$1-$2-$3",
                  ["8"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                  "$2 15-$3-$4",
                  ["9"],
                  "0$1"
                ]
              ],
              [
                [
                  ,
                  "(\\d{4})(\\d{2})(\\d{4})",
                  "$1 $2-$3",
                  [
                    "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                    "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                    "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                    "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                  ],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{4})",
                  "$1 $2-$3",
                  ["1"],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1-$2-$3",
                  ["[68]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2-$3",
                  ["[23]"],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                  "$1 $2 $3-$4",
                  [
                    "9(?:2[2-469]|3[3-578])",
                    "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                    "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                    "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                    "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                  ]
                ],
                [
                  ,
                  "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                  "$1 $2 $3-$4",
                  ["91"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{5})",
                  "$1-$2-$3",
                  ["8"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3-$4",
                  ["9"]
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "810\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "810\\d{7}",
                ,
                ,
                ,
                "8101234567",
                ,
                ,
                [10]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            AS: [
              ,
              [
                ,
                ,
                "(?:[58]\\d\\d|684|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "6846(?:22|33|44|55|77|88|9[19])\\d{4}",
                ,
                ,
                ,
                "6846221234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}",
                ,
                ,
                ,
                "6847331234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
              ],
              [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "AS",
              1,
              "011",
              "1",
              ,
              ,
              "([267]\\d{6})$|1",
              "684$1",
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "684",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            AT: [
              ,
              [
                ,
                ,
                "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  4,
                  5,
                  6,
                  7,
                  8,
                  9,
                  10,
                  11,
                  12,
                  13
                ],
                [3]
              ],
              [
                ,
                ,
                "1(?:11\\d|[2-9]\\d{3,11})|(?:316|463)\\d{3,10}|648[34]\\d{3,9}|(?:51|66|73)2\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-7]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}",
                ,
                ,
                ,
                "1234567890",
                ,
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                "6(?:485|(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d)\\d{3,9}",
                ,
                ,
                ,
                "664123456",
                ,
                ,
                [
                  7,
                  8,
                  9,
                  10,
                  11,
                  12,
                  13
                ]
              ],
              [
                ,
                ,
                "800\\d{6,10}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [
                  9,
                  10,
                  11,
                  12,
                  13
                ]
              ],
              [
                ,
                ,
                "(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}",
                ,
                ,
                ,
                "900123456",
                ,
                ,
                [
                  9,
                  10,
                  11,
                  12,
                  13
                ]
              ],
              [
                ,
                ,
                "8(?:10|2[018])\\d{6,10}|828\\d{5}",
                ,
                ,
                ,
                "810123456",
                ,
                ,
                [
                  8,
                  9,
                  10,
                  11,
                  12,
                  13
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}",
                ,
                ,
                ,
                "780123456",
                ,
                ,
                [
                  5,
                  6,
                  7,
                  8,
                  9,
                  10,
                  11,
                  12,
                  13
                ]
              ],
              "AT",
              43,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{4})",
                  "$1",
                  ["14"]
                ],
                [
                  ,
                  "(\\d)(\\d{3,12})",
                  "$1 $2",
                  ["1(?:11|[2-9])"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})",
                  "$1 $2",
                  ["517"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3,5})",
                  "$1 $2",
                  ["5[079]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{6})",
                  "$1",
                  ["[18]"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3,10})",
                  "$1 $2",
                  ["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{3,9})",
                  "$1 $2",
                  ["[2-467]|5[2-6]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["5"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{4,7})",
                  "$1 $2 $3",
                  ["5"],
                  "0$1"
                ]
              ],
              [
                [
                  ,
                  "(\\d)(\\d{3,12})",
                  "$1 $2",
                  ["1(?:11|[2-9])"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})",
                  "$1 $2",
                  ["517"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3,5})",
                  "$1 $2",
                  ["5[079]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3,10})",
                  "$1 $2",
                  ["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{3,9})",
                  "$1 $2",
                  ["[2-467]|5[2-6]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["5"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{4,7})",
                  "$1 $2 $3",
                  ["5"],
                  "0$1"
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            AU: [
              ,
              [
                ,
                ,
                "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  5,
                  6,
                  7,
                  8,
                  9,
                  10,
                  12
                ]
              ],
              [
                ,
                ,
                "(?:(?:2(?:(?:[0-26-9]\\d|3[0-8]|5[0135-9])\\d|4(?:[02-9]\\d|10))|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90))|7(?:[013-57-9]\\d|2[0-8])\\d)\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|[34]\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                ,
                ,
                ,
                "212345678",
                ,
                ,
                [9],
                [8]
              ],
              [
                ,
                ,
                "4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-37-9])\\d{6}",
                ,
                ,
                ,
                "412345678",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "180(?:0\\d{3}|2)\\d{3}",
                ,
                ,
                ,
                "1800123456",
                ,
                ,
                [7, 10]
              ],
              [
                ,
                ,
                "190[0-26]\\d{6}",
                ,
                ,
                ,
                "1900123456",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                ,
                ,
                ,
                "1300123456",
                ,
                ,
                [
                  6,
                  8,
                  10,
                  12
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                ,
                ,
                ,
                "147101234",
                ,
                ,
                [9]
              ],
              "AU",
              61,
              "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
              "0",
              ,
              ,
              "(183[12])|0",
              ,
              "0011",
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{3,4})",
                  "$1 $2",
                  ["16"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3",
                  ["13"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})",
                  "$1 $2",
                  ["19"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})",
                  "$1 $2",
                  ["180", "1802"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{3,4})",
                  "$1 $2",
                  ["19"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{2,4})",
                  "$1 $2 $3",
                  ["16"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["14|4"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["[2378]"],
                  "(0$1)",
                  "$CC ($1)"
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["1(?:30|[89])"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["130"]
                ]
              ],
              [
                [
                  ,
                  "(\\d{2})(\\d{3,4})",
                  "$1 $2",
                  ["16"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{2,4})",
                  "$1 $2 $3",
                  ["16"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["14|4"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["[2378]"],
                  "(0$1)",
                  "$CC ($1)"
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["1(?:30|[89])"]
                ]
              ],
              [
                ,
                ,
                "163\\d{2,6}",
                ,
                ,
                ,
                "1631234",
                ,
                ,
                [
                  5,
                  6,
                  7,
                  8,
                  9
                ]
              ],
              1,
              ,
              [
                ,
                ,
                "1(?:3(?:00\\d{5}|45[0-4])|802)\\d{3}|1[38]00\\d{6}|13\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  6,
                  7,
                  8,
                  10,
                  12
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            AW: [
              ,
              [
                ,
                ,
                "(?:[25-79]\\d\\d|800)\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "5(?:2\\d|8[1-9])\\d{4}",
                ,
                ,
                ,
                "5212345"
              ],
              [
                ,
                ,
                "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}",
                ,
                ,
                ,
                "5601234"
              ],
              [
                ,
                ,
                "800\\d{4}",
                ,
                ,
                ,
                "8001234"
              ],
              [
                ,
                ,
                "900\\d{4}",
                ,
                ,
                ,
                "9001234"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:28\\d|501)\\d{4}",
                ,
                ,
                ,
                "5011234"
              ],
              "AW",
              297,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{4})",
                "$1 $2",
                ["[25-9]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            AX: [
              ,
              [
                ,
                ,
                "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  5,
                  6,
                  7,
                  8,
                  9,
                  10,
                  11,
                  12
                ]
              ],
              [
                ,
                ,
                "18[1-8]\\d{3,6}",
                ,
                ,
                ,
                "181234567",
                ,
                ,
                [
                  6,
                  7,
                  8,
                  9
                ]
              ],
              [
                ,
                ,
                "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
                ,
                ,
                ,
                "412345678",
                ,
                ,
                [
                  6,
                  7,
                  8,
                  9,
                  10
                ]
              ],
              [
                ,
                ,
                "800\\d{4,6}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [
                  7,
                  8,
                  9
                ]
              ],
              [
                ,
                ,
                "[67]00\\d{5,6}",
                ,
                ,
                ,
                "600123456",
                ,
                ,
                [8, 9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "AX",
              358,
              "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
              "0",
              ,
              ,
              "0",
              ,
              "00",
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "18",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
                ,
                ,
                ,
                "10112345"
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            AZ: [
              ,
              [
                ,
                ,
                "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9],
                [7]
              ],
              [
                ,
                ,
                "(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}",
                ,
                ,
                ,
                "123123456",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}",
                ,
                ,
                ,
                "401234567"
              ],
              [
                ,
                ,
                "88\\d{7}",
                ,
                ,
                ,
                "881234567"
              ],
              [
                ,
                ,
                "900200\\d{3}",
                ,
                ,
                ,
                "900200123"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "AZ",
              994,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{2})",
                  "$1 $2 $3",
                  ["[1-9]"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["90"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  [
                    "1[28]|2|365|46",
                    "1[28]|2|365[45]|46",
                    "1[28]|2|365(?:4|5[02])|46"
                  ],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["[13-9]"],
                  "0$1"
                ]
              ],
              [
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["90"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  [
                    "1[28]|2|365|46",
                    "1[28]|2|365[45]|46",
                    "1[28]|2|365(?:4|5[02])|46"
                  ],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["[13-9]"],
                  "0$1"
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BA: [
              ,
              [
                ,
                ,
                "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9],
                [6]
              ],
              [
                ,
                ,
                "(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}",
                ,
                ,
                ,
                "30212345",
                ,
                ,
                [8],
                [6]
              ],
              [
                ,
                ,
                "6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}",
                ,
                ,
                ,
                "61123456"
              ],
              [
                ,
                ,
                "8[08]\\d{6}",
                ,
                ,
                ,
                "80123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "9[0246]\\d{6}",
                ,
                ,
                ,
                "90123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "8[12]\\d{6}",
                ,
                ,
                ,
                "82123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "BA",
              387,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{3})",
                  "$1-$2",
                  ["[2-9]"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["6[1-3]|[7-9]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3})",
                  "$1 $2-$3",
                  ["[3-5]|6[56]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                  "$1 $2 $3 $4",
                  ["6"],
                  "0$1"
                ]
              ],
              [
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["6[1-3]|[7-9]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3})",
                  "$1 $2-$3",
                  ["[3-5]|6[56]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                  "$1 $2 $3 $4",
                  ["6"],
                  "0$1"
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}",
                ,
                ,
                ,
                "70341234",
                ,
                ,
                [8]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BB: [
              ,
              [
                ,
                ,
                "(?:246|[58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}",
                ,
                ,
                ,
                "2464123456",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}",
                ,
                ,
                ,
                "2462501234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
              ],
              [
                ,
                ,
                "(?:246976|900[2-9]\\d\\d)\\d{4}",
                ,
                ,
                ,
                "9002123456",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ],
              [
                ,
                ,
                "24631\\d{5}",
                ,
                ,
                ,
                "2463101234",
                ,
                ,
                ,
                [7]
              ],
              "BB",
              1,
              "011",
              "1",
              ,
              ,
              "([2-9]\\d{6})$|1",
              "246$1",
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "246",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}",
                ,
                ,
                ,
                "2464301234",
                ,
                ,
                ,
                [7]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BD: [
              ,
              [
                ,
                ,
                "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  6,
                  7,
                  8,
                  9,
                  10
                ]
              ],
              [
                ,
                ,
                "(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:[23]\\d|[45])\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}",
                ,
                ,
                ,
                "27111234"
              ],
              [
                ,
                ,
                "(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}",
                ,
                ,
                ,
                "1812345678",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "80[03]\\d{7}",
                ,
                ,
                ,
                "8001234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}",
                ,
                ,
                ,
                "9604123456",
                ,
                ,
                [10]
              ],
              "BD",
              880,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{4,6})",
                  "$1-$2",
                  ["31[5-8]|[459]1"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3,7})",
                  "$1-$2",
                  ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{3,6})",
                  "$1-$2",
                  ["[13-9]|2[23]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{7,8})",
                  "$1-$2",
                  ["2"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BE: [
              ,
              [
                ,
                ,
                "4\\d{8}|[1-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9]
              ],
              [
                ,
                ,
                "80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}",
                ,
                ,
                ,
                "12345678",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "4[5-9]\\d{7}",
                ,
                ,
                ,
                "470123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "800[1-9]\\d{4}",
                ,
                ,
                ,
                "80012345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "(?:70(?:2[0-57]|3[04-7]|44|6[04-69]|7[0579])|90\\d\\d)\\d{4}",
                ,
                ,
                ,
                "90012345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "7879\\d{4}",
                ,
                ,
                ,
                "78791234",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "BE",
              32,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{3})",
                  "$1 $2 $3",
                  ["(?:80|9)0"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["[239]|4[23]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["[15-8]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["4"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "78(?:0[578]|1[014-8]|2[25]|3[15-8]|48|5[05]|60|7[06-8]|9\\d)\\d{4}",
                ,
                ,
                ,
                "78102345",
                ,
                ,
                [8]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BF: [
              ,
              [
                ,
                ,
                "(?:[025-7]\\d|44)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}",
                ,
                ,
                ,
                "20491234"
              ],
              [
                ,
                ,
                "(?:0[1-7]|44|5[0-8]|[67]\\d)\\d{6}",
                ,
                ,
                ,
                "70123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "BF",
              226,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[024-7]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BG: [
              ,
              [
                ,
                ,
                "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  6,
                  7,
                  8,
                  9,
                  12
                ],
                [4, 5]
              ],
              [
                ,
                ,
                "2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}",
                ,
                ,
                ,
                "2123456",
                ,
                ,
                [
                  6,
                  7,
                  8
                ],
                [4, 5]
              ],
              [
                ,
                ,
                "(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}",
                ,
                ,
                ,
                "43012345",
                ,
                ,
                [8, 9]
              ],
              [
                ,
                ,
                "(?:00800\\d\\d|800)\\d{5}",
                ,
                ,
                ,
                "80012345",
                ,
                ,
                [8, 12]
              ],
              [
                ,
                ,
                "90\\d{6}",
                ,
                ,
                ,
                "90123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "700\\d{5}",
                ,
                ,
                ,
                "70012345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "BG",
              359,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{6})",
                  "$1",
                  ["1"]
                ],
                [
                  ,
                  "(\\d)(\\d)(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["2"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})",
                  "$1 $2",
                  ["43[1-6]|70[1-9]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["2"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{2,3})",
                  "$1 $2 $3",
                  ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{3})",
                  "$1 $2 $3",
                  ["(?:70|8)0"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{2})",
                  "$1 $2 $3",
                  ["43[1-7]|7"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["[48]|9[08]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["9"],
                  "0$1"
                ]
              ],
              [
                [
                  ,
                  "(\\d)(\\d)(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["2"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})",
                  "$1 $2",
                  ["43[1-6]|70[1-9]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["2"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{2,3})",
                  "$1 $2 $3",
                  ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{3})",
                  "$1 $2 $3",
                  ["(?:70|8)0"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{2})",
                  "$1 $2 $3",
                  ["43[1-7]|7"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["[48]|9[08]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["9"],
                  "0$1"
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BH: [
              ,
              [
                ,
                ,
                "[136-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|55|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}",
                ,
                ,
                ,
                "17001234"
              ],
              [
                ,
                ,
                "(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}",
                ,
                ,
                ,
                "36001234"
              ],
              [
                ,
                ,
                "8[02369]\\d{6}",
                ,
                ,
                ,
                "80123456"
              ],
              [
                ,
                ,
                "(?:87|9[0-8])\\d{6}",
                ,
                ,
                ,
                "90123456"
              ],
              [
                ,
                ,
                "84\\d{6}",
                ,
                ,
                ,
                "84123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "BH",
              973,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{4})(\\d{4})",
                "$1 $2",
                ["[13679]|8[02-4679]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BI: [
              ,
              [
                ,
                ,
                "(?:[267]\\d|31)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "(?:22|31)\\d{6}",
                ,
                ,
                ,
                "22201234"
              ],
              [
                ,
                ,
                "(?:29|6[124-9]|7[125-9])\\d{6}",
                ,
                ,
                ,
                "79561234"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "BI",
              257,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[2367]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BJ: [
              ,
              [
                ,
                ,
                "(?:01\\d|[24-689])\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 10]
              ],
              [
                ,
                ,
                "2090\\d{4}|(?:012\\d\\d|2(?:02|1[037]|2[45]|3[68]|4\\d))\\d{5}",
                ,
                ,
                ,
                "0120211234"
              ],
              [
                ,
                ,
                "(?:01(?:2[5-9]|[4-69]\\d)|4[0-8]|[56]\\d|9[013-9])\\d{6}",
                ,
                ,
                ,
                "0195123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "857[58]\\d{4}",
                ,
                ,
                ,
                "85751234",
                ,
                ,
                [8]
              ],
              "BJ",
              229,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[24-689]"]
              ], [
                ,
                "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4 $5",
                ["0"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "81\\d{6}",
                ,
                ,
                ,
                "81123456",
                ,
                ,
                [8]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BL: [
              ,
              [
                ,
                ,
                "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}",
                ,
                ,
                ,
                "590271234"
              ],
              [
                ,
                ,
                "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}",
                ,
                ,
                ,
                "690001234"
              ],
              [
                ,
                ,
                "80[0-5]\\d{6}",
                ,
                ,
                ,
                "800012345"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}",
                ,
                ,
                ,
                "976012345"
              ],
              "BL",
              590,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BM: [
              ,
              [
                ,
                ,
                "(?:441|[58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}",
                ,
                ,
                ,
                "4414123456",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "441(?:[2378]\\d|5[0-39]|9[02])\\d{5}",
                ,
                ,
                ,
                "4413701234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
              ],
              [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "BM",
              1,
              "011",
              "1",
              ,
              ,
              "([2-9]\\d{6})$|1",
              "441$1",
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "441",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BN: [
              ,
              [
                ,
                ,
                "[2-578]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}",
                ,
                ,
                ,
                "2345678"
              ],
              [
                ,
                ,
                "(?:22[89]|[78]\\d\\d)\\d{4}",
                ,
                ,
                ,
                "7123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "5[34]\\d{5}",
                ,
                ,
                ,
                "5345678"
              ],
              "BN",
              673,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{4})",
                "$1 $2",
                ["[2-578]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BO: [
              ,
              [
                ,
                ,
                "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9],
                [7]
              ],
              [
                ,
                ,
                "(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}",
                ,
                ,
                ,
                "22123456",
                ,
                ,
                [8],
                [7]
              ],
              [
                ,
                ,
                "[67]\\d{7}",
                ,
                ,
                ,
                "71234567",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "8001[07]\\d{4}",
                ,
                ,
                ,
                "800171234",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "50\\d{6}",
                ,
                ,
                ,
                "50123456",
                ,
                ,
                [8],
                [7]
              ],
              "BO",
              591,
              "00(?:1\\d)?",
              "0",
              ,
              ,
              "0(1\\d)?",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d)(\\d{7})",
                  "$1 $2",
                  ["[235]|4[46]"],
                  ,
                  "0$CC $1"
                ],
                [
                  ,
                  "(\\d{8})",
                  "$1",
                  ["[67]"],
                  ,
                  "0$CC $1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{4})",
                  "$1 $2 $3",
                  ["8"],
                  ,
                  "0$CC $1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "8001[07]\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BQ: [
              ,
              [
                ,
                ,
                "(?:[34]1|7\\d)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}",
                ,
                ,
                ,
                "7151234"
              ],
              [
                ,
                ,
                "(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}",
                ,
                ,
                ,
                "3181234"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "BQ",
              599,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "[347]",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BR: [
              ,
              [
                ,
                ,
                "[1-467]\\d{9,10}|55[0-46-9]\\d{8}|[34]\\d{7}|55\\d{7,8}|(?:5[0-46-9]|[89]\\d)\\d{7,9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  8,
                  9,
                  10,
                  11
                ]
              ],
              [
                ,
                ,
                "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}",
                ,
                ,
                ,
                "1123456789",
                ,
                ,
                [10],
                [8]
              ],
              [
                ,
                ,
                "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}",
                ,
                ,
                ,
                "11961234567",
                ,
                ,
                [10, 11],
                [8, 9]
              ],
              [
                ,
                ,
                "800\\d{6,7}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [9, 10]
              ],
              [
                ,
                ,
                "[59]00\\d{6,7}",
                ,
                ,
                ,
                "500123456",
                ,
                ,
                [9, 10]
              ],
              [
                ,
                ,
                "(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370|864))\\d{4}|300\\d{5}",
                ,
                ,
                ,
                "40041234",
                ,
                ,
                [8, 10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "BR",
              55,
              "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
              "0",
              ,
              ,
              "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
              "$2",
              ,
              ,
              [
                [
                  ,
                  "(\\d{3,6})",
                  "$1",
                  ["1(?:1[25-8]|2[357-9]|3[02-68]|4[12568]|5|6[0-8]|8[015]|9[0-47-9])|321|610"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{4})",
                  "$1-$2",
                  ["300|4(?:0[02]|37|86)", "300|4(?:0(?:0|20)|370|864)"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{4})",
                  "$1-$2",
                  ["[2-57]", "[2357]|4(?:[0-24-9]|3(?:[0-689]|7[1-9]))"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{2,3})(\\d{4})",
                  "$1 $2 $3",
                  ["(?:[358]|90)0"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{5})(\\d{4})",
                  "$1-$2",
                  ["9"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{4})",
                  "$1 $2-$3",
                  ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],
                  "($1)",
                  "0 $CC ($1)"
                ],
                [
                  ,
                  "(\\d{2})(\\d{5})(\\d{4})",
                  "$1 $2-$3",
                  ["[16][1-9]|[2-57-9]"],
                  "($1)",
                  "0 $CC ($1)"
                ]
              ],
              [
                [
                  ,
                  "(\\d{4})(\\d{4})",
                  "$1-$2",
                  ["300|4(?:0[02]|37|86)", "300|4(?:0(?:0|20)|370|864)"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{2,3})(\\d{4})",
                  "$1 $2 $3",
                  ["(?:[358]|90)0"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{4})",
                  "$1 $2-$3",
                  ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],
                  "($1)",
                  "0 $CC ($1)"
                ],
                [
                  ,
                  "(\\d{2})(\\d{5})(\\d{4})",
                  "$1 $2-$3",
                  ["[16][1-9]|[2-57-9]"],
                  "($1)",
                  "0 $CC ($1)"
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|864))\\d{4}|800\\d{6,7}|300\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  8,
                  9,
                  10
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BS: [
              ,
              [
                ,
                ,
                "(?:242|[58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}",
                ,
                ,
                ,
                "2423456789",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|3[0-4]|[89]9))\\d{4}",
                ,
                ,
                ,
                "2423591234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "BS",
              1,
              "011",
              "1",
              ,
              ,
              "([3-8]\\d{6})$|1",
              "242$1",
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "242",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "242225\\d{4}",
                ,
                ,
                ,
                "2422250123"
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BT: [
              ,
              [
                ,
                ,
                "[178]\\d{7}|[2-8]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 8],
                [6]
              ],
              [
                ,
                ,
                "(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}",
                ,
                ,
                ,
                "2345678",
                ,
                ,
                [7],
                [6]
              ],
              [
                ,
                ,
                "(?:1[67]|[78]7)\\d{6}",
                ,
                ,
                ,
                "17123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "BT",
              975,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{3})",
                  "$1 $2",
                  ["[2-7]"]
                ],
                [
                  ,
                  "(\\d)(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["[2-6]|7[246]|8[2-4]"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["1[67]|[78]"]
                ]
              ],
              [[
                ,
                "(\\d)(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[2-6]|7[246]|8[2-4]"]
              ], [
                ,
                "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["1[67]|[78]"]
              ]],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BW: [
              ,
              [
                ,
                ,
                "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  7,
                  8,
                  10
                ]
              ],
              [
                ,
                ,
                "(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[013467]))\\d{4}",
                ,
                ,
                ,
                "2401234",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "(?:321|7[1-8]\\d)\\d{5}",
                ,
                ,
                ,
                "71123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "(?:0800|800\\d)\\d{6}",
                ,
                ,
                ,
                "0800012345",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "90\\d{5}",
                ,
                ,
                ,
                "9012345",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "79(?:1(?:[0-2]\\d|3[0-8])|2[0-7]\\d)\\d{3}",
                ,
                ,
                ,
                "79101234",
                ,
                ,
                [8]
              ],
              "BW",
              267,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{5})",
                  "$1 $2",
                  ["90"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})",
                  "$1 $2",
                  ["[24-6]|3[15-9]"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["[37]"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["0"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})(\\d{3})",
                  "$1 $2 $3",
                  ["8"]
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BY: [
              ,
              [
                ,
                ,
                "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  6,
                  7,
                  8,
                  9,
                  10,
                  11
                ],
                [5]
              ],
              [
                ,
                ,
                "(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}",
                ,
                ,
                ,
                "152450911",
                ,
                ,
                [9],
                [
                  5,
                  6,
                  7
                ]
              ],
              [
                ,
                ,
                "(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",
                ,
                ,
                ,
                "294911911",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}",
                ,
                ,
                ,
                "8011234567"
              ],
              [
                ,
                ,
                "(?:810|902)\\d{7}",
                ,
                ,
                ,
                "9021234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "249\\d{6}",
                ,
                ,
                ,
                "249123456",
                ,
                ,
                [9]
              ],
              "BY",
              375,
              "810",
              "8",
              ,
              ,
              "0|80?",
              ,
              "8~10",
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{3})",
                  "$1 $2",
                  ["800"],
                  "8 $1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{2,4})",
                  "$1 $2 $3",
                  ["800"],
                  "8 $1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{2})(\\d{3})",
                  "$1 $2-$3",
                  ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],
                  "8 0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2-$3-$4",
                  ["1(?:[56]|7[467])|2[1-3]"],
                  "8 0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                  "$1 $2-$3-$4",
                  ["[1-4]"],
                  "8 0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3,4})(\\d{4})",
                  "$1 $2 $3",
                  ["[89]"],
                  "8 $1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BZ: [
              ,
              [
                ,
                ,
                "(?:0800\\d|[2-8])\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 11]
              ],
              [
                ,
                ,
                "(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}",
                ,
                ,
                ,
                "2221234",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "6[0-35-7]\\d{5}",
                ,
                ,
                ,
                "6221234",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "0800\\d{7}",
                ,
                ,
                ,
                "08001234123",
                ,
                ,
                [11]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "BZ",
              501,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{4})",
                "$1-$2",
                ["[2-8]"]
              ], [
                ,
                "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                "$1-$2-$3-$4",
                ["0"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CA: [
              ,
              [
                ,
                ,
                "[2-9]\\d{9}|3\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 10]
              ],
              [
                ,
                ,
                "(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",
                ,
                ,
                ,
                "5062345678",
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",
                ,
                ,
                ,
                "5062345678",
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}",
                ,
                ,
                ,
                "5219023456",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "600[2-9]\\d{6}",
                ,
                ,
                ,
                "6002012345",
                ,
                ,
                [10]
              ],
              "CA",
              1,
              "011",
              "1",
              ,
              ,
              "1",
              ,
              ,
              1,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "310\\d{4}",
                ,
                ,
                ,
                "3101234",
                ,
                ,
                [7]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CC: [
              ,
              [
                ,
                ,
                "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  6,
                  7,
                  8,
                  9,
                  10,
                  12
                ]
              ],
              [
                ,
                ,
                "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                ,
                ,
                ,
                "891621234",
                ,
                ,
                [9],
                [8]
              ],
              [
                ,
                ,
                "4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-37-9])\\d{6}",
                ,
                ,
                ,
                "412345678",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "180(?:0\\d{3}|2)\\d{3}",
                ,
                ,
                ,
                "1800123456",
                ,
                ,
                [7, 10]
              ],
              [
                ,
                ,
                "190[0-26]\\d{6}",
                ,
                ,
                ,
                "1900123456",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                ,
                ,
                ,
                "1300123456",
                ,
                ,
                [
                  6,
                  8,
                  10,
                  12
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                ,
                ,
                ,
                "147101234",
                ,
                ,
                [9]
              ],
              "CC",
              61,
              "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
              "0",
              ,
              ,
              "([59]\\d{7})$|0",
              "8$1",
              "0011",
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CD: [
              ,
              [
                ,
                ,
                "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  7,
                  8,
                  9,
                  10
                ]
              ],
              [
                ,
                ,
                "(?:(?:12|573)\\d\\d|276)\\d{5}|[1-6]\\d{6}",
                ,
                ,
                ,
                "1234567"
              ],
              [
                ,
                ,
                "88\\d{5}|(?:8[0-69]|9[017-9])\\d{7}",
                ,
                ,
                ,
                "991234567",
                ,
                ,
                [7, 9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "CD",
              243,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{3})",
                  "$1 $2 $3",
                  ["88"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{5})",
                  "$1 $2",
                  ["[1-6]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{4})",
                  "$1 $2 $3",
                  ["2"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["1"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["[89]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                  "$1 $2 $3 $4",
                  ["5"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CF: [
              ,
              [
                ,
                ,
                "(?:[27]\\d{3}|8776)\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "2[12]\\d{6}",
                ,
                ,
                ,
                "21612345"
              ],
              [
                ,
                ,
                "7[024-7]\\d{6}",
                ,
                ,
                ,
                "70012345"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "8776\\d{4}",
                ,
                ,
                ,
                "87761234"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "CF",
              236,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[278]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CG: [
              ,
              [
                ,
                ,
                "222\\d{6}|(?:0\\d|80)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "222[1-589]\\d{5}",
                ,
                ,
                ,
                "222123456"
              ],
              [
                ,
                ,
                "026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}",
                ,
                ,
                ,
                "061234567"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "80[0-2]\\d{6}",
                ,
                ,
                ,
                "800123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "CG",
              242,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d)(\\d{4})(\\d{4})",
                "$1 $2 $3",
                ["8"]
              ], [
                ,
                "(\\d{2})(\\d{3})(\\d{4})",
                "$1 $2 $3",
                ["[02]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CH: [
              ,
              [
                ,
                ,
                "8\\d{11}|[2-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9, 12]
              ],
              [
                ,
                ,
                "(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}",
                ,
                ,
                ,
                "212345678",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "(?:6[89]|7[235-9])\\d{7}",
                ,
                ,
                ,
                "781234567",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "800\\d{6}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "90[016]\\d{6}",
                ,
                ,
                ,
                "900123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "84[0248]\\d{6}",
                ,
                ,
                ,
                "840123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "878\\d{6}",
                ,
                ,
                ,
                "878123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "CH",
              41,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["8[047]|90"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["[2-79]|81"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4 $5",
                  ["8"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                "74[0248]\\d{6}",
                ,
                ,
                ,
                "740123456",
                ,
                ,
                [9]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "5[18]\\d{7}",
                ,
                ,
                ,
                "581234567",
                ,
                ,
                [9]
              ],
              ,
              ,
              [
                ,
                ,
                "860\\d{9}",
                ,
                ,
                ,
                "860123456789",
                ,
                ,
                [12]
              ]
            ],
            CI: [
              ,
              [
                ,
                ,
                "[02]\\d{9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}",
                ,
                ,
                ,
                "2123456789"
              ],
              [
                ,
                ,
                "0[157]\\d{8}",
                ,
                ,
                ,
                "0123456789"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "CI",
              225,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                "$1 $2 $3 $4",
                ["2"]
              ], [
                ,
                "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                "$1 $2 $3 $4",
                ["0"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CK: [
              ,
              [
                ,
                ,
                "[2-578]\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [5]
              ],
              [
                ,
                ,
                "(?:2\\d|3[13-7]|4[1-5])\\d{3}",
                ,
                ,
                ,
                "21234"
              ],
              [
                ,
                ,
                "[578]\\d{4}",
                ,
                ,
                ,
                "71234"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "CK",
              682,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{3})",
                "$1 $2",
                ["[2-578]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CL: [
              ,
              [
                ,
                ,
                "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  9,
                  10,
                  11
                ]
              ],
              [
                ,
                ,
                "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|2\\d{3}|3(?:(?:2\\d|50)\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-389]|9[0-8])|600)|646[59])|(?:(?:3[2-5]|[47][1-35]|5[1-3578])\\d|6(?:00|[13-57]\\d)|8(?:0[1-9]|[1-9]\\d))\\d\\d|9(?:(?:10[01]|(?:[2458]\\d|7[1-9])\\d)\\d|3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}",
                ,
                ,
                ,
                "600123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|2\\d{3}|3(?:(?:2\\d|50)\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-389]|9[0-8])|600)|646[59])|(?:(?:3[2-5]|[47][1-35]|5[1-3578]|6[13-57])\\d|8(?:0[1-8]|[1-9]\\d))\\d\\d|9(?:(?:10[01]|(?:[2458]\\d|7[1-9])\\d)\\d|3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}",
                ,
                ,
                ,
                "221234567",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "(?:123|8)00\\d{6}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [9, 11]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "600\\d{7,8}",
                ,
                ,
                ,
                "6001234567",
                ,
                ,
                [10, 11]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "44\\d{7}",
                ,
                ,
                ,
                "441234567",
                ,
                ,
                [9]
              ],
              "CL",
              56,
              "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{4})",
                  "$1",
                  ["1(?:[03-589]|21)|[29]0|78"]
                ],
                [
                  ,
                  "(\\d{5})(\\d{4})",
                  "$1 $2",
                  ["219", "2196"],
                  "($1)"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["60|809"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["44"]
                ],
                [
                  ,
                  "(\\d)(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["2[1-36]"],
                  "($1)"
                ],
                [
                  ,
                  "(\\d)(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["9(?:10|[2-9])"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-8]|[1-9])"],
                  "($1)"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["60|8"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["1"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                  "$1 $2 $3 $4",
                  ["60"]
                ]
              ],
              [
                [
                  ,
                  "(\\d{5})(\\d{4})",
                  "$1 $2",
                  ["219", "2196"],
                  "($1)"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["60|809"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["44"]
                ],
                [
                  ,
                  "(\\d)(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["2[1-36]"],
                  "($1)"
                ],
                [
                  ,
                  "(\\d)(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["9(?:10|[2-9])"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-8]|[1-9])"],
                  "($1)"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["60|8"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["1"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                  "$1 $2 $3 $4",
                  ["60"]
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "600\\d{7,8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10, 11]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CM: [
              ,
              [
                ,
                ,
                "[26]\\d{8}|88\\d{6,7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9]
              ],
              [
                ,
                ,
                "2(?:22|33)\\d{6}",
                ,
                ,
                ,
                "222123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "(?:24[23]|6(?:[25-9]\\d|40))\\d{6}",
                ,
                ,
                ,
                "671234567",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "88\\d{6,7}",
                ,
                ,
                ,
                "88012345"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "CM",
              237,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["88"]
              ], [
                ,
                "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4 $5",
                ["[26]|88"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CN: [
              ,
              [
                ,
                ,
                "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  7,
                  8,
                  9,
                  10,
                  11,
                  12
                ],
                [5, 6]
              ],
              [
                ,
                ,
                "(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|2(?:[02-57-9]\\d{3}|1(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))|(?:41[03]|8078|9(?:78|94))\\d\\d)\\d{5}|(?:10|2[0-57-9])(?:1(?:00|23)\\d\\d|95\\d{3,4})|(?:41[03]|9(?:78|94))(?:100\\d\\d|95\\d{3,4})|8078123|(?:43[35]|754|851)\\d{7,8}|(?:43[35]|754|851)(?:1(?:00\\d|23)\\d|95\\d{3,4})|(?:3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[13-9]\\d{6}|2(?:[0-24-9]\\d{5}|3\\d(?:\\d{4})?))|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[24-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[13-9]\\d{5}|2(?:[0-24-9]\\d{4}|3\\d(?:\\d{3})?))|9(?:[0-46-9]\\d{5}|5\\d{3,5}))",
                ,
                ,
                ,
                "1012345678",
                ,
                ,
                [
                  7,
                  8,
                  9,
                  10,
                  11
                ],
                [5, 6]
              ],
              [
                ,
                ,
                "1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}",
                ,
                ,
                ,
                "13123456789",
                ,
                ,
                [11]
              ],
              [
                ,
                ,
                "(?:(?:10|21)8|8)00\\d{7}",
                ,
                ,
                ,
                "8001234567",
                ,
                ,
                [10, 12]
              ],
              [
                ,
                ,
                "16[08]\\d{5}",
                ,
                ,
                ,
                "16812345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",
                ,
                ,
                ,
                "4001234567",
                ,
                ,
                [
                  7,
                  8,
                  9,
                  10,
                  11
                ],
                [5, 6]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "CN",
              86,
              "00|1(?:[12]\\d|79)\\d\\d00",
              "0",
              ,
              ,
              "(1(?:[12]\\d|79)\\d\\d)|0",
              ,
              "00",
              ,
              [
                [
                  ,
                  "(\\d{5,6})",
                  "$1",
                  [
                    "1(?:00|2[13])|9[56]",
                    "1(?:00|2(?:1|39))|9[56]",
                    "1(?:00|2(?:1|395))|9[56]"
                  ]
                ],
                [
                  ,
                  "(\\d{5,6})",
                  "$1",
                  [
                    "1(?:0|23)|781|[1-9]12",
                    "1(?:0|23)|7812|[1-9]123",
                    "1(?:0|23(?:[0-8]|9[0-46-9]))|78123|[1-9]123"
                  ]
                ],
                [
                  ,
                  "(\\d{2})(\\d{5,6})",
                  "$1 $2",
                  [
                    "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
                    "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
                    "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
                    "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
                    "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
                  ],
                  "0$1",
                  "$CC $1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})",
                  "$1 $2",
                  [
                    "[1-9]",
                    "1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])",
                    "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|[3-9]",
                    "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|1[03]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9]|78|94)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-9]|1(?:[013-9]|2[0-24-9]))",
                    "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|1[03]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:0(?:[0-689]|7[0-79])|1[01459]|2[0-489]|[46]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9]|78|94)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-9]|1(?:[013-9]|2[0-24-9]))"
                  ]
                ],
                [
                  ,
                  "(\\d{4})(\\d{4})",
                  "$1 $2",
                  ["16[08]"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{5,6})",
                  "$1 $2",
                  [
                    "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                    "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                    "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                    "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                  ],
                  "0$1",
                  "$CC $1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{4})",
                  "$1 $2",
                  [
                    "[1-9]",
                    "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[0-8]|9[0-47-9])|6)|[3-9]",
                    "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|26|3(?:[0268]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23][0-8])|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:33|85[23]9)[0-46-9]|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[0-8]|9[0-47-9])",
                    "1(?:0[02-8]|[1-9])|2(?:[0-57-9][0-8]|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23](?:[02-8]|1[1-9]|9[0-46-9]))|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:10|2[0-57-9])9[0-47-9]|(?:101|58|85[23]10)[1-9]|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"
                  ]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["(?:4|80)0"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  [
                    "10|2(?:[02-57-9]|1[1-9])",
                    "10|2(?:[02-57-9]|1[1-9])",
                    "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                  ],
                  "0$1",
                  "$CC $1",
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],
                  "0$1",
                  "$CC $1",
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{7,8})",
                  "$1 $2",
                  ["9"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["80"],
                  "0$1",
                  "$CC $1",
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["[3-578]"],
                  "0$1",
                  "$CC $1",
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["1[3-9]"],
                  ,
                  "$CC $1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3 $4",
                  ["[12]"],
                  "0$1",
                  ,
                  1
                ]
              ],
              [
                [
                  ,
                  "(\\d{2})(\\d{5,6})",
                  "$1 $2",
                  [
                    "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
                    "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
                    "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
                    "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
                    "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
                  ],
                  "0$1",
                  "$CC $1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{5,6})",
                  "$1 $2",
                  [
                    "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                    "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                    "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                    "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                  ],
                  "0$1",
                  "$CC $1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["(?:4|80)0"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  [
                    "10|2(?:[02-57-9]|1[1-9])",
                    "10|2(?:[02-57-9]|1[1-9])",
                    "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                  ],
                  "0$1",
                  "$CC $1",
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],
                  "0$1",
                  "$CC $1",
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{7,8})",
                  "$1 $2",
                  ["9"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["80"],
                  "0$1",
                  "$CC $1",
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["[3-578]"],
                  "0$1",
                  "$CC $1",
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["1[3-9]"],
                  ,
                  "$CC $1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3 $4",
                  ["[12]"],
                  "0$1",
                  ,
                  1
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  10,
                  11,
                  12
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CO: [
              ,
              [
                ,
                ,
                "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  8,
                  10,
                  11
                ],
                [4, 7]
              ],
              [
                ,
                ,
                "601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|(?:46|60(?:[18][1-9]|[24-7][2-9]))\\d{6}",
                ,
                ,
                ,
                "6012345678",
                ,
                ,
                [8, 10],
                [4, 7]
              ],
              [
                ,
                ,
                "333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:(?:0[0-5]|1\\d|5[01]|70)\\d|2(?:[0-3]\\d|4[1-9])|3(?:00|3[0-24-9]))|9(?:101|408))\\d{6}",
                ,
                ,
                ,
                "3211234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "1800\\d{7}",
                ,
                ,
                ,
                "18001234567",
                ,
                ,
                [11]
              ],
              [
                ,
                ,
                "(?:19(?:0[01]|4[78])|901)\\d{7}",
                ,
                ,
                ,
                "19001234567",
                ,
                ,
                [10, 11]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "CO",
              57,
              "00(?:4(?:[14]4|56)|[579])",
              "0",
              ,
              ,
              "0([3579]|4(?:[14]4|56))?",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{4})(\\d{4})",
                  "$1 $2",
                  ["46"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{7})",
                  "$1 $2",
                  ["6|90"],
                  "($1)",
                  "0$CC $1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{7})",
                  "$1 $2",
                  ["3[0-357]|9[14]"],
                  ,
                  "0$CC $1"
                ],
                [
                  ,
                  "(\\d)(\\d{3})(\\d{7})",
                  "$1-$2-$3",
                  ["1"],
                  "0$1"
                ]
              ],
              [
                [
                  ,
                  "(\\d{4})(\\d{4})",
                  "$1 $2",
                  ["46"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{7})",
                  "$1 $2",
                  ["6|90"],
                  "($1)",
                  "0$CC $1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{7})",
                  "$1 $2",
                  ["3[0-357]|9[14]"],
                  ,
                  "0$CC $1"
                ],
                [
                  ,
                  "(\\d)(\\d{3})(\\d{7})",
                  "$1 $2 $3",
                  ["1"]
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CR: [
              ,
              [
                ,
                ,
                "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 10]
              ],
              [
                ,
                ,
                "210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}",
                ,
                ,
                ,
                "22123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}",
                ,
                ,
                ,
                "83123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "800\\d{7}",
                ,
                ,
                ,
                "8001234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "90[059]\\d{7}",
                ,
                ,
                ,
                "9001234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:210[0-6]|4\\d{3}|5100)\\d{4}",
                ,
                ,
                ,
                "40001234",
                ,
                ,
                [8]
              ],
              "CR",
              506,
              "00",
              ,
              ,
              ,
              "(19(?:0[0-2468]|1[09]|20|66|77|99))",
              ,
              ,
              ,
              [[
                ,
                "(\\d{4})(\\d{4})",
                "$1 $2",
                ["[2-7]|8[3-9]"],
                ,
                "$CC $1"
              ], [
                ,
                "(\\d{3})(\\d{3})(\\d{4})",
                "$1-$2-$3",
                ["[89]"],
                ,
                "$CC $1"
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CU: [
              ,
              [
                ,
                ,
                "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  6,
                  7,
                  8,
                  10
                ],
                [4, 5]
              ],
              [
                ,
                ,
                "(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}",
                ,
                ,
                ,
                "71234567",
                ,
                ,
                ,
                [4, 5]
              ],
              [
                ,
                ,
                "(?:5\\d|6[2-4])\\d{6}",
                ,
                ,
                ,
                "51234567",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "800\\d{7}",
                ,
                ,
                ,
                "8001234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "807\\d{7}",
                ,
                ,
                ,
                "8071234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "CU",
              53,
              "119",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{4,6})",
                  "$1 $2",
                  ["2[1-4]|[34]"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d)(\\d{6,7})",
                  "$1 $2",
                  ["7"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d)(\\d{7})",
                  "$1 $2",
                  ["[56]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{7})",
                  "$1 $2",
                  ["8"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CV: [
              ,
              [
                ,
                ,
                "(?:[2-59]\\d\\d|800)\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}",
                ,
                ,
                ,
                "2211234"
              ],
              [
                ,
                ,
                "(?:36|5[1-389]|9\\d)\\d{5}",
                ,
                ,
                ,
                "9911234"
              ],
              [
                ,
                ,
                "800\\d{4}",
                ,
                ,
                ,
                "8001234"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:3[3-5]|4[356])\\d{5}",
                ,
                ,
                ,
                "3401234"
              ],
              "CV",
              238,
              "0",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{2})(\\d{2})",
                "$1 $2 $3",
                ["[2-589]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CW: [
              ,
              [
                ,
                ,
                "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 8]
              ],
              [
                ,
                ,
                "9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}",
                ,
                ,
                ,
                "94351234"
              ],
              [
                ,
                ,
                "953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}",
                ,
                ,
                ,
                "95181234"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "60[0-2]\\d{4}",
                ,
                ,
                ,
                "6001234",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "CW",
              599,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{4})",
                "$1 $2",
                ["[3467]"]
              ], [
                ,
                "(\\d)(\\d{3})(\\d{4})",
                "$1 $2 $3",
                ["9[4-8]"]
              ]],
              ,
              [
                ,
                ,
                "955\\d{5}",
                ,
                ,
                ,
                "95581234",
                ,
                ,
                [8]
              ],
              1,
              "[69]",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CX: [
              ,
              [
                ,
                ,
                "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  6,
                  7,
                  8,
                  9,
                  10,
                  12
                ]
              ],
              [
                ,
                ,
                "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                ,
                ,
                ,
                "891641234",
                ,
                ,
                [9],
                [8]
              ],
              [
                ,
                ,
                "4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-37-9])\\d{6}",
                ,
                ,
                ,
                "412345678",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "180(?:0\\d{3}|2)\\d{3}",
                ,
                ,
                ,
                "1800123456",
                ,
                ,
                [7, 10]
              ],
              [
                ,
                ,
                "190[0-26]\\d{6}",
                ,
                ,
                ,
                "1900123456",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                ,
                ,
                ,
                "1300123456",
                ,
                ,
                [
                  6,
                  8,
                  10,
                  12
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                ,
                ,
                ,
                "147101234",
                ,
                ,
                [9]
              ],
              "CX",
              61,
              "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
              "0",
              ,
              ,
              "([59]\\d{7})$|0",
              "8$1",
              "0011",
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CY: [
              ,
              [
                ,
                ,
                "(?:[279]\\d|[58]0)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "2[2-6]\\d{6}",
                ,
                ,
                ,
                "22345678"
              ],
              [
                ,
                ,
                "9(?:10|[4-79]\\d)\\d{5}",
                ,
                ,
                ,
                "96123456"
              ],
              [
                ,
                ,
                "800\\d{5}",
                ,
                ,
                ,
                "80001234"
              ],
              [
                ,
                ,
                "90[09]\\d{5}",
                ,
                ,
                ,
                "90012345"
              ],
              [
                ,
                ,
                "80[1-9]\\d{5}",
                ,
                ,
                ,
                "80112345"
              ],
              [
                ,
                ,
                "700\\d{5}",
                ,
                ,
                ,
                "70012345"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "CY",
              357,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{6})",
                "$1 $2",
                ["[257-9]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:50|77)\\d{6}",
                ,
                ,
                ,
                "77123456"
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CZ: [
              ,
              [
                ,
                ,
                "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  9,
                  10,
                  11,
                  12
                ]
              ],
              [
                ,
                ,
                "(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}",
                ,
                ,
                ,
                "212345678",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "7(?:060\\d|19(?:[0-4]\\d|50))\\d{4}|(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}",
                ,
                ,
                ,
                "601123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "800\\d{6}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "9(?:0[05689]|76)\\d{6}",
                ,
                ,
                ,
                "900123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "8[134]\\d{7}",
                ,
                ,
                ,
                "811234567",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "70[01]\\d{6}",
                ,
                ,
                ,
                "700123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "9[17]0\\d{6}",
                ,
                ,
                ,
                "910123456",
                ,
                ,
                [9]
              ],
              "CZ",
              420,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["[2-8]|9[015-7]"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["96"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3 $4",
                  ["9"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3 $4",
                  ["9"]
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "9(?:5\\d|7[2-4])\\d{6}",
                ,
                ,
                ,
                "972123456",
                ,
                ,
                [9]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:3\\d{9}|6\\d{7,10})",
                ,
                ,
                ,
                "93123456789"
              ]
            ],
            DE: [
              ,
              [
                ,
                ,
                "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  4,
                  5,
                  6,
                  7,
                  8,
                  9,
                  10,
                  11,
                  12,
                  13,
                  14,
                  15
                ],
                [2, 3]
              ],
              [
                ,
                ,
                "32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}",
                ,
                ,
                ,
                "30123456",
                ,
                ,
                [
                  5,
                  6,
                  7,
                  8,
                  9,
                  10,
                  11,
                  12,
                  13,
                  14,
                  15
                ],
                [
                  2,
                  3,
                  4
                ]
              ],
              [
                ,
                ,
                "1(?:(?:5(?:[0-25-9]\\d\\d|3(?:10|33))|7[26-9]\\d\\d)\\d{6}|6[023]\\d{7,8})|17\\d{8}",
                ,
                ,
                ,
                "15123456789",
                ,
                ,
                [10, 11]
              ],
              [
                ,
                ,
                "800\\d{7,12}",
                ,
                ,
                ,
                "8001234567890",
                ,
                ,
                [
                  10,
                  11,
                  12,
                  13,
                  14,
                  15
                ]
              ],
              [
                ,
                ,
                "(?:137[7-9]|900(?:[135]|9\\d))\\d{6}",
                ,
                ,
                ,
                "9001234567",
                ,
                ,
                [10, 11]
              ],
              [
                ,
                ,
                "180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}",
                ,
                ,
                ,
                "18012345",
                ,
                ,
                [
                  7,
                  8,
                  9,
                  10,
                  11,
                  12,
                  13,
                  14
                ]
              ],
              [
                ,
                ,
                "700\\d{8}",
                ,
                ,
                ,
                "70012345678",
                ,
                ,
                [11]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "DE",
              49,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{3,13})",
                  "$1 $2",
                  ["3[02]|40|[68]9"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{6})",
                  "$1",
                  ["227", "2277"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3,12})",
                  "$1 $2",
                  ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{2,11})",
                  "$1 $2",
                  ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})",
                  "$1 $2",
                  ["138"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{5})(\\d{2,10})",
                  "$1 $2",
                  ["3"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{5,11})",
                  "$1 $2",
                  ["181"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d)(\\d{4,10})",
                  "$1 $2 $3",
                  ["1(?:3|80)|9"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{7,8})",
                  "$1 $2",
                  ["1[67]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{7,12})",
                  "$1 $2",
                  ["8"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{5})(\\d{6})",
                  "$1 $2",
                  [
                    "185",
                    "1850",
                    "18500"
                  ],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["7"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{7})",
                  "$1 $2",
                  ["18[68]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{7})",
                  "$1 $2",
                  ["15[1279]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{5})(\\d{6})",
                  "$1 $2",
                  ["15[03568]", "15(?:[0568]|3[13])"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{8})",
                  "$1 $2",
                  ["18"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{7,8})",
                  "$1 $2 $3",
                  ["1(?:6[023]|7)"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{2})(\\d{7})",
                  "$1 $2 $3",
                  ["15[279]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{8})",
                  "$1 $2 $3",
                  ["15"],
                  "0$1"
                ]
              ],
              [
                [
                  ,
                  "(\\d{2})(\\d{3,13})",
                  "$1 $2",
                  ["3[02]|40|[68]9"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3,12})",
                  "$1 $2",
                  ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{2,11})",
                  "$1 $2",
                  ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})",
                  "$1 $2",
                  ["138"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{5})(\\d{2,10})",
                  "$1 $2",
                  ["3"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{5,11})",
                  "$1 $2",
                  ["181"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d)(\\d{4,10})",
                  "$1 $2 $3",
                  ["1(?:3|80)|9"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{7,8})",
                  "$1 $2",
                  ["1[67]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{7,12})",
                  "$1 $2",
                  ["8"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{5})(\\d{6})",
                  "$1 $2",
                  [
                    "185",
                    "1850",
                    "18500"
                  ],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["7"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{7})",
                  "$1 $2",
                  ["18[68]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{7})",
                  "$1 $2",
                  ["15[1279]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{5})(\\d{6})",
                  "$1 $2",
                  ["15[03568]", "15(?:[0568]|3[13])"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{8})",
                  "$1 $2",
                  ["18"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{7,8})",
                  "$1 $2 $3",
                  ["1(?:6[023]|7)"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{2})(\\d{7})",
                  "$1 $2 $3",
                  ["15[279]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{8})",
                  "$1 $2 $3",
                  ["15"],
                  "0$1"
                ]
              ],
              [
                ,
                ,
                "16(?:4\\d{1,10}|[89]\\d{1,11})",
                ,
                ,
                ,
                "16412345",
                ,
                ,
                [
                  4,
                  5,
                  6,
                  7,
                  8,
                  9,
                  10,
                  11,
                  12,
                  13,
                  14
                ]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "18(?:1\\d{5,11}|[2-9]\\d{8})",
                ,
                ,
                ,
                "18500123456",
                ,
                ,
                [
                  8,
                  9,
                  10,
                  11,
                  12,
                  13,
                  14
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}",
                ,
                ,
                ,
                "177991234567",
                ,
                ,
                [12, 13]
              ]
            ],
            DJ: [
              ,
              [
                ,
                ,
                "(?:2\\d|77)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "2(?:1[2-5]|7[45])\\d{5}",
                ,
                ,
                ,
                "21360003"
              ],
              [
                ,
                ,
                "77\\d{6}",
                ,
                ,
                ,
                "77831001"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "DJ",
              253,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[27]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            DK: [
              ,
              [
                ,
                ,
                "[2-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "(?:2(?:[0-59][1-9]|[6-8]\\d)|3(?:[0-3][1-9]|4[13]|5[1-58]|6[1347-9]|7\\d|8[1-8]|9[1-79])|4(?:[0-25][1-9]|[34][2-9]|6[13-579]|7[13579]|8[1-47]|9[127])|5(?:[0-36][1-9]|4[146-9]|5[3-57-9]|7[568]|8[1-358]|9[1-69])|6(?:[0135][1-9]|2[1-68]|4[2-8]|6[1689]|[78]\\d|9[15689])|7(?:[0-69][1-9]|7[3-9]|8[147])|8(?:[16-9][1-9]|2[1-58])|9(?:[1-47-9][1-9]|6\\d))\\d{5}",
                ,
                ,
                ,
                "32123456"
              ],
              [
                ,
                ,
                "(?:2[6-8]|37|6[78]|96)\\d{6}|(?:2[0-59]|3[0-689]|[457]\\d|6[0-69]|8[126-9]|9[1-47-9])[1-9]\\d{5}",
                ,
                ,
                ,
                "34412345"
              ],
              [
                ,
                ,
                "80\\d{6}",
                ,
                ,
                ,
                "80123456"
              ],
              [
                ,
                ,
                "90\\d{6}",
                ,
                ,
                ,
                "90123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "DK",
              45,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[2-9]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            DM: [
              ,
              [
                ,
                ,
                "(?:[58]\\d\\d|767|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}",
                ,
                ,
                ,
                "7674201234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}",
                ,
                ,
                ,
                "7672251234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
              ],
              [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "DM",
              1,
              "011",
              "1",
              ,
              ,
              "([2-7]\\d{6})$|1",
              "767$1",
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "767",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            DO: [
              ,
              [
                ,
                ,
                "(?:[58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}",
                ,
                ,
                ,
                "8092345678",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "8[024]9[2-9]\\d{6}",
                ,
                ,
                ,
                "8092345678",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "800(?:14|[2-9]\\d)\\d{5}|8[024]9[01]\\d{6}|8(?:33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
              ],
              [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "DO",
              1,
              "011",
              "1",
              ,
              ,
              "1",
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "8001|8[024]9",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            DZ: [
              ,
              [
                ,
                ,
                "(?:[1-4]|[5-79]\\d|80)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9]
              ],
              [
                ,
                ,
                "9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}",
                ,
                ,
                ,
                "12345678"
              ],
              [
                ,
                ,
                "(?:5(?:4[0-29]|5\\d|6[0-3])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}",
                ,
                ,
                ,
                "551234567",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "800\\d{6}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "80[3-689]1\\d{5}",
                ,
                ,
                ,
                "808123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "80[12]1\\d{5}",
                ,
                ,
                ,
                "801123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "98[23]\\d{6}",
                ,
                ,
                ,
                "983123456",
                ,
                ,
                [9]
              ],
              "DZ",
              213,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["[1-4]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["9"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["[5-8]"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            EC: [
              ,
              [
                ,
                ,
                "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  8,
                  9,
                  10,
                  11
                ],
                [7]
              ],
              [
                ,
                ,
                "[2-7][2-7]\\d{6}",
                ,
                ,
                ,
                "22123456",
                ,
                ,
                [8],
                [7]
              ],
              [
                ,
                ,
                "964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}",
                ,
                ,
                ,
                "991234567",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "1800\\d{7}|1[78]00\\d{6}",
                ,
                ,
                ,
                "18001234567",
                ,
                ,
                [10, 11]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "[2-7]890\\d{4}",
                ,
                ,
                ,
                "28901234",
                ,
                ,
                [8]
              ],
              "EC",
              593,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{4})",
                  "$1-$2",
                  ["[2-7]"]
                ],
                [
                  ,
                  "(\\d)(\\d{3})(\\d{4})",
                  "$1 $2-$3",
                  ["[2-7]"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["9"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["1"]
                ]
              ],
              [
                [
                  ,
                  "(\\d)(\\d{3})(\\d{4})",
                  "$1-$2-$3",
                  ["[2-7]"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["9"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["1"]
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            EE: [
              ,
              [
                ,
                ,
                "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  7,
                  8,
                  10
                ]
              ],
              [
                ,
                ,
                "(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}",
                ,
                ,
                ,
                "3212345",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[2-6]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-69]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}",
                ,
                ,
                ,
                "51234567",
                ,
                ,
                [7, 8]
              ],
              [
                ,
                ,
                "800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}",
                ,
                ,
                ,
                "80012345"
              ],
              [
                ,
                ,
                "(?:40\\d\\d|900)\\d{4}",
                ,
                ,
                ,
                "9001234",
                ,
                ,
                [7, 8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "70[0-2]\\d{5}",
                ,
                ,
                ,
                "70012345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "EE",
              372,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{4})",
                  "$1 $2",
                  ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{3,4})",
                  "$1 $2",
                  ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{4})",
                  "$1 $2 $3",
                  ["7"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["8"]
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "800[2-9]\\d{3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            EG: [
              ,
              [
                ,
                ,
                "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  8,
                  9,
                  10
                ],
                [6, 7]
              ],
              [
                ,
                ,
                "13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2\\d|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}",
                ,
                ,
                ,
                "234567890",
                ,
                ,
                [8, 9],
                [6, 7]
              ],
              [
                ,
                ,
                "1[0-25]\\d{8}",
                ,
                ,
                ,
                "1001234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "800\\d{7}",
                ,
                ,
                ,
                "8001234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "900\\d{7}",
                ,
                ,
                ,
                "9001234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "EG",
              20,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d)(\\d{7,8})",
                  "$1 $2",
                  ["[23]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{6,7})",
                  "$1 $2",
                  ["1[35]|[4-6]|8[2468]|9[235-7]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["[89]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{8})",
                  "$1 $2",
                  ["1"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            EH: [
              ,
              [
                ,
                ,
                "[5-8]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "528[89]\\d{5}",
                ,
                ,
                ,
                "528812345"
              ],
              [
                ,
                ,
                "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-8]|5[0-5]|8[0-7]))\\d{6}",
                ,
                ,
                ,
                "650123456"
              ],
              [
                ,
                ,
                "80[0-7]\\d{6}",
                ,
                ,
                ,
                "801234567"
              ],
              [
                ,
                ,
                "89\\d{7}",
                ,
                ,
                ,
                "891234567"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}",
                ,
                ,
                ,
                "592401234"
              ],
              "EH",
              212,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "528[89]",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            ER: [
              ,
              [
                ,
                ,
                "[178]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7],
                [6]
              ],
              [
                ,
                ,
                "(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}",
                ,
                ,
                ,
                "8370362",
                ,
                ,
                ,
                [6]
              ],
              [
                ,
                ,
                "(?:17[1-3]|7\\d\\d)\\d{4}",
                ,
                ,
                ,
                "7123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "ER",
              291,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [[
                ,
                "(\\d)(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[178]"],
                "0$1"
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            ES: [
              ,
              [
                ,
                ,
                "[5-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}",
                ,
                ,
                ,
                "810123456"
              ],
              [
                ,
                ,
                "(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}",
                ,
                ,
                ,
                "612345678"
              ],
              [
                ,
                ,
                "[89]00\\d{6}",
                ,
                ,
                ,
                "800123456"
              ],
              [
                ,
                ,
                "80[367]\\d{6}",
                ,
                ,
                ,
                "803123456"
              ],
              [
                ,
                ,
                "90[12]\\d{6}",
                ,
                ,
                ,
                "901123456"
              ],
              [
                ,
                ,
                "70\\d{7}",
                ,
                ,
                ,
                "701234567"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "ES",
              34,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{4})",
                  "$1",
                  ["905"]
                ],
                [
                  ,
                  "(\\d{6})",
                  "$1",
                  ["[79]9"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["[89]00"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["[5-9]"]
                ]
              ],
              [[
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[89]00"]
              ], [
                ,
                "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[5-9]"]
              ]],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "51\\d{7}",
                ,
                ,
                ,
                "511234567"
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            ET: [
              ,
              [
                ,
                ,
                "(?:11|[2-579]\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9],
                [7]
              ],
              [
                ,
                ,
                "11667[01]\\d{3}|(?:11(?:1(?:1[1-468]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8]|7\\d)|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",
                ,
                ,
                ,
                "111112345",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}",
                ,
                ,
                ,
                "911234567"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "ET",
              251,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{3})(\\d{4})",
                "$1 $2 $3",
                ["[1-579]"],
                "0$1"
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            FI: [
              ,
              [
                ,
                ,
                "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  5,
                  6,
                  7,
                  8,
                  9,
                  10,
                  11,
                  12
                ]
              ],
              [
                ,
                ,
                "1[3-7][1-8]\\d{3,6}|(?:19[1-8]|[23568][1-8]\\d|9(?:00|[1-8]\\d))\\d{2,6}",
                ,
                ,
                ,
                "131234567",
                ,
                ,
                [
                  5,
                  6,
                  7,
                  8,
                  9
                ]
              ],
              [
                ,
                ,
                "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
                ,
                ,
                ,
                "412345678",
                ,
                ,
                [
                  6,
                  7,
                  8,
                  9,
                  10
                ]
              ],
              [
                ,
                ,
                "800\\d{4,6}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [
                  7,
                  8,
                  9
                ]
              ],
              [
                ,
                ,
                "[67]00\\d{5,6}",
                ,
                ,
                ,
                "600123456",
                ,
                ,
                [8, 9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "FI",
              358,
              "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
              "0",
              ,
              ,
              "0",
              ,
              "00",
              ,
              [
                [
                  ,
                  "(\\d{5})",
                  "$1",
                  ["75[12]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{5})",
                  "$1",
                  ["20[2-59]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{6})",
                  "$1",
                  ["11"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3,7})",
                  "$1 $2",
                  ["(?:[1-3]0|[68])0|70[07-9]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{4,8})",
                  "$1 $2",
                  ["[14]|2[09]|50|7[135]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{6,10})",
                  "$1 $2",
                  ["7"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{4,9})",
                  "$1 $2",
                  ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"],
                  "0$1"
                ]
              ],
              [
                [
                  ,
                  "(\\d{5})",
                  "$1",
                  ["20[2-59]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3,7})",
                  "$1 $2",
                  ["(?:[1-3]0|[68])0|70[07-9]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{4,8})",
                  "$1 $2",
                  ["[14]|2[09]|50|7[135]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{6,10})",
                  "$1 $2",
                  ["7"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{4,9})",
                  "$1 $2",
                  ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"],
                  "0$1"
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              1,
              "1[03-79]|[2-9]",
              [
                ,
                ,
                "20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}"
              ],
              [
                ,
                ,
                "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
                ,
                ,
                ,
                "10112345"
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            FJ: [
              ,
              [
                ,
                ,
                "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 11]
              ],
              [
                ,
                ,
                "603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}",
                ,
                ,
                ,
                "3212345",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}",
                ,
                ,
                ,
                "7012345",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "0800\\d{7}",
                ,
                ,
                ,
                "08001234567",
                ,
                ,
                [11]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "FJ",
              679,
              "0(?:0|52)",
              ,
              ,
              ,
              ,
              ,
              "00",
              ,
              [[
                ,
                "(\\d{3})(\\d{4})",
                "$1 $2",
                ["[235-9]|45"]
              ], [
                ,
                "(\\d{4})(\\d{3})(\\d{4})",
                "$1 $2 $3",
                ["0"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            FK: [
              ,
              [
                ,
                ,
                "[2-7]\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [5]
              ],
              [
                ,
                ,
                "[2-47]\\d{4}",
                ,
                ,
                ,
                "31234"
              ],
              [
                ,
                ,
                "[56]\\d{4}",
                ,
                ,
                ,
                "51234"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "FK",
              500,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            FM: [
              ,
              [
                ,
                ,
                "(?:[39]\\d\\d|820)\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}",
                ,
                ,
                ,
                "3201234"
              ],
              [
                ,
                ,
                "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}",
                ,
                ,
                ,
                "3501234"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "FM",
              691,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{4})",
                "$1 $2",
                ["[389]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            FO: [
              ,
              [
                ,
                ,
                "[2-9]\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [6]
              ],
              [
                ,
                ,
                "(?:20|[34]\\d|8[19])\\d{4}",
                ,
                ,
                ,
                "201234"
              ],
              [
                ,
                ,
                "(?:[27][1-9]|5\\d|9[16])\\d{4}",
                ,
                ,
                ,
                "211234"
              ],
              [
                ,
                ,
                "80[257-9]\\d{3}",
                ,
                ,
                ,
                "802123"
              ],
              [
                ,
                ,
                "90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d",
                ,
                ,
                ,
                "901123"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:6[0-36]|88)\\d{4}",
                ,
                ,
                ,
                "601234"
              ],
              "FO",
              298,
              "00",
              ,
              ,
              ,
              "(10(?:01|[12]0|88))",
              ,
              ,
              ,
              [[
                ,
                "(\\d{6})",
                "$1",
                ["[2-9]"],
                ,
                "$CC $1"
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            FR: [
              ,
              [
                ,
                ,
                "[1-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "(?:26[013-9]|59[1-35-9])\\d{6}|(?:[13]\\d|2[0-57-9]|4[1-9]|5[0-8])\\d{7}",
                ,
                ,
                ,
                "123456789"
              ],
              [
                ,
                ,
                "(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}",
                ,
                ,
                ,
                "612345678"
              ],
              [
                ,
                ,
                "80[0-5]\\d{6}",
                ,
                ,
                ,
                "801234567"
              ],
              [
                ,
                ,
                "836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}",
                ,
                ,
                ,
                "891123456"
              ],
              [
                ,
                ,
                "8(?:1[01]|2[0156]|4[024]|84)\\d{6}",
                ,
                ,
                ,
                "884012345"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "9\\d{8}",
                ,
                ,
                ,
                "912345678"
              ],
              "FR",
              33,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{4})",
                  "$1",
                  ["10"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})",
                  "$1 $2",
                  ["1"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["8"],
                  "0 $1"
                ],
                [
                  ,
                  "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4 $5",
                  ["[1-79]"],
                  "0$1"
                ]
              ],
              [[
                ,
                "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["8"],
                "0 $1"
              ], [
                ,
                "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4 $5",
                ["[1-79]"],
                "0$1"
              ]],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "80[6-9]\\d{6}",
                ,
                ,
                ,
                "806123456"
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GA: [
              ,
              [
                ,
                ,
                "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 8]
              ],
              [
                ,
                ,
                "[01]1\\d{6}",
                ,
                ,
                ,
                "01441234",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}",
                ,
                ,
                ,
                "06031234"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "GA",
              241,
              "00",
              ,
              ,
              ,
              "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
              "$1",
              ,
              ,
              [
                [
                  ,
                  "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["[2-7]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["0"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["11|[67]"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GB: [
              ,
              [
                ,
                ,
                "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  7,
                  9,
                  10
                ],
                [
                  4,
                  5,
                  6,
                  8
                ]
              ],
              [
                ,
                ,
                "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                ,
                ,
                ,
                "1212345678",
                ,
                ,
                [9, 10],
                [
                  4,
                  5,
                  6,
                  7,
                  8
                ]
              ],
              [
                ,
                ,
                "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                ,
                ,
                ,
                "7400123456",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "80[08]\\d{7}|800\\d{6}|8001111",
                ,
                ,
                ,
                "8001234567"
              ],
              [
                ,
                ,
                "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                ,
                ,
                ,
                "9012345678",
                ,
                ,
                [7, 10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "70\\d{8}",
                ,
                ,
                ,
                "7012345678",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "56\\d{8}",
                ,
                ,
                ,
                "5612345678",
                ,
                ,
                [10]
              ],
              "GB",
              44,
              "00",
              "0",
              " x",
              ,
              "0|180020",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{4})",
                  "$1 $2",
                  [
                    "800",
                    "8001",
                    "80011",
                    "800111",
                    "8001111"
                  ],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{2})",
                  "$1 $2 $3",
                  [
                    "845",
                    "8454",
                    "84546",
                    "845464"
                  ],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{6})",
                  "$1 $2",
                  ["800"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{5})(\\d{4,5})",
                  "$1 $2",
                  [
                    "1(?:38|5[23]|69|76|94)",
                    "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                    "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                  ],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{5,6})",
                  "$1 $2",
                  ["1(?:[2-69][02-9]|[78])"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{6})",
                  "$1 $2",
                  ["7"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["[1389]"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                ,
                ,
                ,
                "7640123456",
                ,
                ,
                [10]
              ],
              1,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:3[0347]|55)\\d{8}",
                ,
                ,
                ,
                "5512345678",
                ,
                ,
                [10]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GD: [
              ,
              [
                ,
                ,
                "(?:473|[58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-4]|5[59]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}",
                ,
                ,
                ,
                "4732691234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|49|5[6-8])|5(?:2[01]|3[3-8])|901)\\d{4}",
                ,
                ,
                ,
                "4734031234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
              ],
              [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "GD",
              1,
              "011",
              "1",
              ,
              ,
              "([2-9]\\d{6})$|1",
              "473$1",
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "473",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GE: [
              ,
              [
                ,
                ,
                "(?:[3-57]\\d\\d|800)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9],
                [6, 7]
              ],
              [
                ,
                ,
                "(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}",
                ,
                ,
                ,
                "322123456",
                ,
                ,
                ,
                [6, 7]
              ],
              [
                ,
                ,
                "5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|5(?:0(?:0[17]0|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}|(?:5(?:0(?:0(?:0\\d|11|22|3[0-6]|44|5[05]|77|88|9[09])|(?:[14]\\d|77)\\d|22[02])|1(?:1(?:[03][01]|[124]\\d|5[2-6]|7[0-4])|4\\d\\d)|[23]555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200|333|444)|6[89]\\d\\d|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}",
                ,
                ,
                ,
                "555123456"
              ],
              [
                ,
                ,
                "800\\d{6}",
                ,
                ,
                ,
                "800123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "70[67]\\d{6}",
                ,
                ,
                ,
                "706123456"
              ],
              "GE",
              995,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["70"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["32"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["[57]"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["[348]"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "70[67]\\d{6}"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GF: [
              ,
              [
                ,
                ,
                "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "594(?:[02-49]\\d|1[0-5]|5[6-9]|6[0-3]|80)\\d{4}",
                ,
                ,
                ,
                "594101234"
              ],
              [
                ,
                ,
                "(?:694(?:[0-249]\\d|3[0-8])|7093[0-3])\\d{4}",
                ,
                ,
                ,
                "694201234"
              ],
              [
                ,
                ,
                "80[0-5]\\d{6}",
                ,
                ,
                ,
                "800012345"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "9(?:(?:396|76\\d)\\d|476[0-6])\\d{4}",
                ,
                ,
                ,
                "976012345"
              ],
              "GF",
              594,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[5-7]|9[47]"],
                "0$1"
              ], [
                ,
                "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[89]"],
                "0$1"
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GG: [
              ,
              [
                ,
                ,
                "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  7,
                  9,
                  10
                ],
                [6]
              ],
              [
                ,
                ,
                "1481[25-9]\\d{5}",
                ,
                ,
                ,
                "1481256789",
                ,
                ,
                [10],
                [6]
              ],
              [
                ,
                ,
                "7(?:(?:781|839)\\d|911[17])\\d{5}",
                ,
                ,
                ,
                "7781123456",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "80[08]\\d{7}|800\\d{6}|8001111",
                ,
                ,
                ,
                "8001234567"
              ],
              [
                ,
                ,
                "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                ,
                ,
                ,
                "9012345678",
                ,
                ,
                [7, 10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "70\\d{8}",
                ,
                ,
                ,
                "7012345678",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "56\\d{8}",
                ,
                ,
                ,
                "5612345678",
                ,
                ,
                [10]
              ],
              "GG",
              44,
              "00",
              "0",
              ,
              ,
              "([25-9]\\d{5})$|0|180020",
              "1481$1",
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                ,
                ,
                ,
                "7640123456",
                ,
                ,
                [10]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:3[0347]|55)\\d{8}",
                ,
                ,
                ,
                "5512345678",
                ,
                ,
                [10]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GH: [
              ,
              [
                ,
                ,
                "(?:[235]\\d{3}|800)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9],
                [7]
              ],
              [
                ,
                ,
                "3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}",
                ,
                ,
                ,
                "302345678",
                ,
                ,
                [9],
                [7]
              ],
              [
                ,
                ,
                "(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}",
                ,
                ,
                ,
                "231234567",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "800\\d{5}",
                ,
                ,
                ,
                "80012345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "GH",
              233,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{4})",
                  "$1 $2",
                  ["[237]|8[0-2]"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{5})",
                  "$1 $2",
                  ["8"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["[235]"],
                  "0$1"
                ]
              ],
              [[
                ,
                "(\\d{3})(\\d{5})",
                "$1 $2",
                ["8"],
                "0$1"
              ], [
                ,
                "(\\d{2})(\\d{3})(\\d{4})",
                "$1 $2 $3",
                ["[235]"],
                "0$1"
              ]],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "800\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GI: [
              ,
              [
                ,
                ,
                "(?:[25]\\d|60)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}",
                ,
                ,
                ,
                "20012345"
              ],
              [
                ,
                ,
                "5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}",
                ,
                ,
                ,
                "57123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "GI",
              350,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{5})",
                "$1 $2",
                ["2"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GL: [
              ,
              [
                ,
                ,
                "(?:19|[2-689]\\d|70)\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [6]
              ],
              [
                ,
                ,
                "(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}",
                ,
                ,
                ,
                "321000"
              ],
              [
                ,
                ,
                "[245]\\d{5}",
                ,
                ,
                ,
                "221234"
              ],
              [
                ,
                ,
                "80\\d{4}",
                ,
                ,
                ,
                "801234"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "3[89]\\d{4}",
                ,
                ,
                ,
                "381234"
              ],
              "GL",
              299,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3",
                ["19|[2-9]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GM: [
              ,
              [
                ,
                ,
                "[2-9]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8[0-589]\\d\\d)\\d{3}",
                ,
                ,
                ,
                "5661234"
              ],
              [
                ,
                ,
                "556\\d{4}|(?:[23679]\\d|4[015]|5[0-489]|8[67])\\d{5}",
                ,
                ,
                ,
                "3012345"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "GM",
              220,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{4})",
                "$1 $2",
                ["[2-9]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GN: [
              ,
              [
                ,
                ,
                "722\\d{6}|(?:3|6\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9]
              ],
              [
                ,
                ,
                "3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}",
                ,
                ,
                ,
                "30241234",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "6[0-356]\\d{7}",
                ,
                ,
                ,
                "601123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "722\\d{6}",
                ,
                ,
                ,
                "722123456",
                ,
                ,
                [9]
              ],
              "GN",
              224,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["3"]
              ], [
                ,
                "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[67]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GP: [
              ,
              [
                ,
                ,
                "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}",
                ,
                ,
                ,
                "590201234"
              ],
              [
                ,
                ,
                "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}",
                ,
                ,
                ,
                "690001234"
              ],
              [
                ,
                ,
                "80[0-5]\\d{6}",
                ,
                ,
                ,
                "800012345"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}",
                ,
                ,
                ,
                "976012345"
              ],
              "GP",
              590,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[5-79]"],
                "0$1"
              ], [
                ,
                "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["8"],
                "0$1"
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              1,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GQ: [
              ,
              [
                ,
                ,
                "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}",
                ,
                ,
                ,
                "333091234"
              ],
              [
                ,
                ,
                "(?:222|55\\d)\\d{6}",
                ,
                ,
                ,
                "222123456"
              ],
              [
                ,
                ,
                "80\\d[1-9]\\d{5}",
                ,
                ,
                ,
                "800123456"
              ],
              [
                ,
                ,
                "90\\d[1-9]\\d{5}",
                ,
                ,
                ,
                "900123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "GQ",
              240,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[235]"]
              ], [
                ,
                "(\\d{3})(\\d{6})",
                "$1 $2",
                ["[89]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GR: [
              ,
              [
                ,
                ,
                "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  10,
                  11,
                  12
                ]
              ],
              [
                ,
                ,
                "2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
                ,
                ,
                ,
                "2123456789",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "68[57-9]\\d{7}|(?:69|94)\\d{8}",
                ,
                ,
                ,
                "6912345678",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "800\\d{7,9}",
                ,
                ,
                ,
                "8001234567"
              ],
              [
                ,
                ,
                "90[19]\\d{7}",
                ,
                ,
                ,
                "9091234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "8(?:0[16]|12|[27]5|50)\\d{7}",
                ,
                ,
                ,
                "8011234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "70\\d{8}",
                ,
                ,
                ,
                "7012345678",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "GR",
              30,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["21|7"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{6})",
                  "$1 $2",
                  ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["[2689]"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3,4})(\\d{5})",
                  "$1 $2 $3",
                  ["8"]
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "5005000\\d{3}",
                ,
                ,
                ,
                "5005000123",
                ,
                ,
                [10]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GT: [
              ,
              [
                ,
                ,
                "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 11]
              ],
              [
                ,
                ,
                "[267][2-9]\\d{6}",
                ,
                ,
                ,
                "22456789",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "(?:[3-5]\\d\\d|80[0-4])\\d{5}",
                ,
                ,
                ,
                "51234567",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "18[01]\\d{8}",
                ,
                ,
                ,
                "18001112222",
                ,
                ,
                [11]
              ],
              [
                ,
                ,
                "19\\d{9}",
                ,
                ,
                ,
                "19001112222",
                ,
                ,
                [11]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "GT",
              502,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{4})(\\d{4})",
                "$1 $2",
                ["[2-8]"]
              ], [
                ,
                "(\\d{4})(\\d{3})(\\d{4})",
                "$1 $2 $3",
                ["1"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GU: [
              ,
              [
                ,
                ,
                "(?:[58]\\d\\d|671|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",
                ,
                ,
                ,
                "6713001234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",
                ,
                ,
                ,
                "6713001234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
              ],
              [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "GU",
              1,
              "011",
              "1",
              ,
              ,
              "([2-9]\\d{6})$|1",
              "671$1",
              ,
              1,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "671",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GW: [
              ,
              [
                ,
                ,
                "[49]\\d{8}|4\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 9]
              ],
              [
                ,
                ,
                "443\\d{6}",
                ,
                ,
                ,
                "443201234",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "9(?:5\\d|6[569]|77)\\d{6}",
                ,
                ,
                ,
                "955012345",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "40\\d{5}",
                ,
                ,
                ,
                "4012345",
                ,
                ,
                [7]
              ],
              "GW",
              245,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{4})",
                "$1 $2",
                ["40"]
              ], [
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[49]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GY: [
              ,
              [
                ,
                ,
                "(?:[2-8]\\d{3}|9008)\\d{3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|50[0-6]|77[1-57])\\d{4}",
                ,
                ,
                ,
                "2201234"
              ],
              [
                ,
                ,
                "(?:51[01]|6\\d\\d|7(?:[0-5]\\d|6[0-39]|70))\\d{4}",
                ,
                ,
                ,
                "6091234"
              ],
              [
                ,
                ,
                "(?:289|8(?:00|6[28]|88|99))\\d{4}",
                ,
                ,
                ,
                "2891234"
              ],
              [
                ,
                ,
                "9008\\d{3}",
                ,
                ,
                ,
                "9008123"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "515\\d{4}",
                ,
                ,
                ,
                "5151234"
              ],
              "GY",
              592,
              "001",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{4})",
                "$1 $2",
                ["[2-9]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            HK: [
              ,
              [
                ,
                ,
                "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  5,
                  6,
                  7,
                  8,
                  9,
                  11
                ]
              ],
              [
                ,
                ,
                "(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[579]\\d|6[0-5]))|58(?:0[1-9]|1[2-9]))\\d{4}",
                ,
                ,
                ,
                "21234567",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "(?:4(?:44[0-35-9]|6(?:4[0-57-9]|6[0-4])|7(?:3[0-4]|4[0-48]|6[0-5]))|5(?:35[4-8]|73[0-6]|95[0-8])|6(?:26[013-8]|(?:66|78)[0-5])|70(?:7[1-8]|8[0-8])|84(?:4[0-2]|8[0-35-9])|9(?:29[013-9]|39[014-9]|59[0-4]|899))\\d{4}|(?:4(?:4[0-35-9]|6[0-357-9]|7[0-25])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[1-59]|84[0-39]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}",
                ,
                ,
                ,
                "51234567",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "800\\d{6}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "900(?:[0-24-9]\\d{7}|3\\d{1,4})",
                ,
                ,
                ,
                "90012345678",
                ,
                ,
                [
                  5,
                  6,
                  7,
                  8,
                  11
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}",
                ,
                ,
                ,
                "81123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "HK",
              852,
              "00(?:30|5[09]|[126-9]?)",
              ,
              ,
              ,
              ,
              ,
              "00",
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{2,5})",
                  "$1 $2",
                  ["900", "9003"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{4})",
                  "$1 $2",
                  ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["8"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                  "$1 $2 $3 $4",
                  ["9"]
                ]
              ],
              ,
              [
                ,
                ,
                "7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}",
                ,
                ,
                ,
                "71123456",
                ,
                ,
                [8]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}",
                ,
                ,
                ,
                "30161234",
                ,
                ,
                [8]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            HN: [
              ,
              [
                ,
                ,
                "8\\d{10}|[237-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 11]
              ],
              [
                ,
                ,
                "2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-7]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}",
                ,
                ,
                ,
                "22123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "[37-9]\\d{7}",
                ,
                ,
                ,
                "91234567",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "8002\\d{7}",
                ,
                ,
                ,
                "80021234567",
                ,
                ,
                [11]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "HN",
              504,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{4})(\\d{4})",
                "$1-$2",
                ["[237-9]"]
              ], [
                ,
                "(\\d{3})(\\d{4})(\\d{4})",
                "$1 $2 $3",
                ["8"]
              ]],
              [[
                ,
                "(\\d{4})(\\d{4})",
                "$1-$2",
                ["[237-9]"]
              ]],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "8002\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [11]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            HR: [
              ,
              [
                ,
                ,
                "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  7,
                  8,
                  9
                ],
                [6]
              ],
              [
                ,
                ,
                "1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}",
                ,
                ,
                ,
                "12345678",
                ,
                ,
                [8, 9],
                [6, 7]
              ],
              [
                ,
                ,
                "9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-79])))\\d{4}|98\\d{6}",
                ,
                ,
                ,
                "921234567",
                ,
                ,
                [8, 9]
              ],
              [
                ,
                ,
                "80\\d{5,7}",
                ,
                ,
                ,
                "800123456"
              ],
              [
                ,
                ,
                "6[01459]\\d{6}|6[01]\\d{5}",
                ,
                ,
                ,
                "6001234",
                ,
                ,
                [7, 8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "7[45]\\d{6}",
                ,
                ,
                ,
                "74123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "HR",
              385,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{3})",
                  "$1 $2 $3",
                  ["6[01]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{2,3})",
                  "$1 $2 $3",
                  ["8"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{4})(\\d{3})",
                  "$1 $2 $3",
                  ["1"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["6|7[245]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["9"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["[2-57]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["8"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "62\\d{6,7}|72\\d{6}",
                ,
                ,
                ,
                "62123456",
                ,
                ,
                [8, 9]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            HT: [
              ,
              [
                ,
                ,
                "[2-589]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "2(?:2\\d|5[1-5]|81|9[149])\\d{5}",
                ,
                ,
                ,
                "22453300"
              ],
              [
                ,
                ,
                "(?:[34]\\d|5[56])\\d{6}",
                ,
                ,
                ,
                "34101234"
              ],
              [
                ,
                ,
                "8\\d{7}",
                ,
                ,
                ,
                "80012345"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}",
                ,
                ,
                ,
                "98901234"
              ],
              "HT",
              509,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{2})(\\d{4})",
                "$1 $2 $3",
                ["[2-589]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            HU: [
              ,
              [
                ,
                ,
                "[235-7]\\d{8}|[1-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9],
                [6, 7]
              ],
              [
                ,
                ,
                "(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}",
                ,
                ,
                ,
                "12345678",
                ,
                ,
                [8],
                [6, 7]
              ],
              [
                ,
                ,
                "(?:[257]0|3[01])\\d{7}",
                ,
                ,
                ,
                "201234567",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "(?:[48]0\\d|680[29])\\d{5}",
                ,
                ,
                ,
                "80123456"
              ],
              [
                ,
                ,
                "9[01]\\d{6}",
                ,
                ,
                ,
                "90123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "21\\d{7}",
                ,
                ,
                ,
                "211234567",
                ,
                ,
                [9]
              ],
              "HU",
              36,
              "00",
              "06",
              ,
              ,
              "06",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d)(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["1"],
                  "(06 $1)"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],
                  "(06 $1)"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["[2-9]"],
                  "06 $1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "(?:[48]0\\d|680[29])\\d{5}"
              ],
              [
                ,
                ,
                "38\\d{7}",
                ,
                ,
                ,
                "381234567",
                ,
                ,
                [9]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            ID: [
              ,
              [
                ,
                ,
                "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  7,
                  8,
                  9,
                  10,
                  11,
                  12,
                  13,
                  14,
                  15,
                  16,
                  17
                ],
                [5, 6]
              ],
              [
                ,
                ,
                "2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}",
                ,
                ,
                ,
                "218350123",
                ,
                ,
                [
                  7,
                  8,
                  9,
                  10,
                  11
                ],
                [5, 6]
              ],
              [
                ,
                ,
                "8[1-35-9]\\d{7,10}",
                ,
                ,
                ,
                "812345678",
                ,
                ,
                [
                  9,
                  10,
                  11,
                  12
                ]
              ],
              [
                ,
                ,
                "00(?:1803\\d{5,11}|7803\\d{7})|(?:177\\d|800)\\d{5,7}",
                ,
                ,
                ,
                "8001234567",
                ,
                ,
                [
                  8,
                  9,
                  10,
                  11,
                  12,
                  13,
                  14,
                  15,
                  16,
                  17
                ]
              ],
              [
                ,
                ,
                "809\\d{7}",
                ,
                ,
                ,
                "8091234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "804\\d{7}",
                ,
                ,
                ,
                "8041234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "ID",
              62,
              "00[89]",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d)(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["15"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{5,9})",
                  "$1 $2",
                  ["2[124]|[36]1"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{3})(\\d{5,7})",
                  "$1 $2",
                  ["800"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{5,8})",
                  "$1 $2",
                  ["[2-79]"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3,4})(\\d{3})",
                  "$1-$2-$3",
                  ["8[1-35-9]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{6,8})",
                  "$1 $2",
                  ["1"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["804"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                  "$1 $2 $3 $4",
                  ["80"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})(\\d{4,5})",
                  "$1-$2-$3",
                  ["8"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})(\\d{2,8})",
                  "$1 $2 $3 $4",
                  ["001"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{3})(\\d{4})",
                  "$1 $2 $3 $4",
                  ["0"]
                ]
              ],
              [
                [
                  ,
                  "(\\d)(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["15"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{5,9})",
                  "$1 $2",
                  ["2[124]|[36]1"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{3})(\\d{5,7})",
                  "$1 $2",
                  ["800"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{5,8})",
                  "$1 $2",
                  ["[2-79]"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3,4})(\\d{3})",
                  "$1-$2-$3",
                  ["8[1-35-9]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{6,8})",
                  "$1 $2",
                  ["1"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["804"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                  "$1 $2 $3 $4",
                  ["80"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})(\\d{4,5})",
                  "$1-$2-$3",
                  ["8"],
                  "0$1"
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "001803\\d{5,11}|(?:007803\\d|8071)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  10,
                  11,
                  12,
                  13,
                  14,
                  15,
                  16,
                  17
                ]
              ],
              [
                ,
                ,
                "(?:1500|8071\\d{3})\\d{3}",
                ,
                ,
                ,
                "8071123456",
                ,
                ,
                [7, 10]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            IE: [
              ,
              [
                ,
                ,
                "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  7,
                  8,
                  9,
                  10
                ],
                [5, 6]
              ],
              [
                ,
                ,
                "(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}",
                ,
                ,
                ,
                "2212345",
                ,
                ,
                ,
                [5, 6]
              ],
              [
                ,
                ,
                "8(?:22|[35-9]\\d)\\d{6}",
                ,
                ,
                ,
                "850123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "1800\\d{6}",
                ,
                ,
                ,
                "1800123456",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "15(?:1[2-8]|[2-8]0|9[089])\\d{6}",
                ,
                ,
                ,
                "1520123456",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "18[59]0\\d{6}",
                ,
                ,
                ,
                "1850123456",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "700\\d{6}",
                ,
                ,
                ,
                "700123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "76\\d{7}",
                ,
                ,
                ,
                "761234567",
                ,
                ,
                [9]
              ],
              "IE",
              353,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{5})",
                  "$1 $2",
                  ["2[24-9]|47|58|6[237-9]|9[35-9]"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{3})(\\d{5})",
                  "$1 $2",
                  ["[45]0"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d)(\\d{3,4})(\\d{4})",
                  "$1 $2 $3",
                  ["1"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["[2569]|4[1-69]|7[14]"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["70"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["81"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["[78]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["1"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["4"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                  "$1 $2 $3 $4",
                  ["8"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "18[59]0\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "818\\d{6}",
                ,
                ,
                ,
                "818123456",
                ,
                ,
                [9]
              ],
              ,
              ,
              [
                ,
                ,
                "88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}",
                ,
                ,
                ,
                "8551234567",
                ,
                ,
                [10]
              ]
            ],
            IL: [
              ,
              [
                ,
                ,
                "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  7,
                  8,
                  9,
                  10,
                  11,
                  12
                ]
              ],
              [
                ,
                ,
                "153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}",
                ,
                ,
                ,
                "21234567",
                ,
                ,
                [
                  8,
                  11,
                  12
                ],
                [7]
              ],
              [
                ,
                ,
                "55(?:4(?:0[01]|10|5[0-7])|57[0-289])\\d{4}|5(?:(?:[0-2][02-9]|[36]\\d|[49][2-9]|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}",
                ,
                ,
                ,
                "502345678",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "1(?:255|80[019]\\d{3})\\d{3}",
                ,
                ,
                ,
                "1800123456",
                ,
                ,
                [7, 10]
              ],
              [
                ,
                ,
                "1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}",
                ,
                ,
                ,
                "1919123456",
                ,
                ,
                [8, 10]
              ],
              [
                ,
                ,
                "1700\\d{6}",
                ,
                ,
                ,
                "1700123456",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "7(?:38(?:[05]\\d|8[018])|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}",
                ,
                ,
                ,
                "771234567",
                ,
                ,
                [9]
              ],
              "IL",
              972,
              "0(?:0|1[2-9])",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{4})(\\d{3})",
                  "$1-$2",
                  ["125"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{2})(\\d{2})",
                  "$1-$2-$3",
                  ["121"]
                ],
                [
                  ,
                  "(\\d)(\\d{3})(\\d{4})",
                  "$1-$2-$3",
                  ["[2-489]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1-$2-$3",
                  ["[57]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})(\\d{3})",
                  "$1-$2-$3",
                  ["12"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{6})",
                  "$1-$2",
                  ["159"]
                ],
                [
                  ,
                  "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                  "$1-$2-$3-$4",
                  ["1[7-9]"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                  "$1-$2 $3-$4",
                  ["15"]
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "1700\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "1599\\d{6}",
                ,
                ,
                ,
                "1599123456",
                ,
                ,
                [10]
              ],
              ,
              ,
              [
                ,
                ,
                "151\\d{8,9}",
                ,
                ,
                ,
                "15112340000",
                ,
                ,
                [11, 12]
              ]
            ],
            IM: [
              ,
              [
                ,
                ,
                "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [6]
              ],
              [
                ,
                ,
                "1624(?:230|[5-8]\\d\\d)\\d{3}",
                ,
                ,
                ,
                "1624756789",
                ,
                ,
                ,
                [6]
              ],
              [
                ,
                ,
                "76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}",
                ,
                ,
                ,
                "7924123456"
              ],
              [
                ,
                ,
                "808162\\d{4}",
                ,
                ,
                ,
                "8081624567"
              ],
              [
                ,
                ,
                "8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}",
                ,
                ,
                ,
                "9016247890"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "70\\d{8}",
                ,
                ,
                ,
                "7012345678"
              ],
              [
                ,
                ,
                "56\\d{8}",
                ,
                ,
                ,
                "5612345678"
              ],
              "IM",
              44,
              "00",
              "0",
              ,
              ,
              "([25-8]\\d{5})$|0|180020",
              "1624$1",
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "74576|(?:16|7[56])24",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}",
                ,
                ,
                ,
                "5512345678"
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            IN: [
              ,
              [
                ,
                ,
                "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  8,
                  9,
                  10,
                  11,
                  12,
                  13
                ],
                [6, 7]
              ],
              [
                ,
                ,
                "2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}",
                ,
                ,
                ,
                "7410410123",
                ,
                ,
                [10],
                [
                  6,
                  7,
                  8
                ]
              ],
              [
                ,
                ,
                "(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",
                ,
                ,
                ,
                "8123456789",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))",
                ,
                ,
                ,
                "1800123456"
              ],
              [
                ,
                ,
                "186[12]\\d{9}",
                ,
                ,
                ,
                "1861123456789",
                ,
                ,
                [13]
              ],
              [
                ,
                ,
                "1860\\d{7}",
                ,
                ,
                ,
                "18603451234",
                ,
                ,
                [11]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "IN",
              91,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{7})",
                  "$1",
                  ["575"]
                ],
                [
                  ,
                  "(\\d{8})",
                  "$1",
                  [
                    "5(?:0|2[23]|3[03]|[67]1|88)",
                    "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                    "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                  ],
                  ,
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{4})(\\d{4,5})",
                  "$1 $2",
                  ["180", "1800"],
                  ,
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["140"],
                  ,
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  [
                    "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                    "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                    "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                  ],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  [
                    "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                    "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                    "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                  ],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  [
                    "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                    "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                    "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                  ],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{5})(\\d{5})",
                  "$1 $2",
                  ["[6-9]"],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{4})(\\d{2,4})(\\d{4})",
                  "$1 $2 $3",
                  ["1(?:6|8[06])", "1(?:6|8[06]0)"],
                  ,
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3 $4",
                  ["0"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3 $4",
                  ["18"],
                  ,
                  ,
                  1
                ]
              ],
              [
                [
                  ,
                  "(\\d{8})",
                  "$1",
                  [
                    "5(?:0|2[23]|3[03]|[67]1|88)",
                    "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                    "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                  ],
                  ,
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{4})(\\d{4,5})",
                  "$1 $2",
                  ["180", "1800"],
                  ,
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["140"],
                  ,
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  [
                    "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                    "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                    "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                  ],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  [
                    "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                    "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                    "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                  ],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  [
                    "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                    "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                    "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                  ],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{5})(\\d{5})",
                  "$1 $2",
                  ["[6-9]"],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{4})(\\d{2,4})(\\d{4})",
                  "$1 $2 $3",
                  ["1(?:6|8[06])", "1(?:6|8[06]0)"],
                  ,
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3 $4",
                  ["18"],
                  ,
                  ,
                  1
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:600\\d{6}|800\\d{4,9})|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}"
              ],
              [
                ,
                ,
                "140\\d{7}",
                ,
                ,
                ,
                "1409305260",
                ,
                ,
                [10]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            IO: [
              ,
              [
                ,
                ,
                "3\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "37\\d{5}",
                ,
                ,
                ,
                "3709100"
              ],
              [
                ,
                ,
                "38\\d{5}",
                ,
                ,
                ,
                "3801234"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "IO",
              246,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{4})",
                "$1 $2",
                ["3"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            IQ: [
              ,
              [
                ,
                ,
                "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  8,
                  9,
                  10
                ],
                [6, 7]
              ],
              [
                ,
                ,
                "1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}",
                ,
                ,
                ,
                "12345678",
                ,
                ,
                [8, 9],
                [6, 7]
              ],
              [
                ,
                ,
                "7[3-9]\\d{8}",
                ,
                ,
                ,
                "7912345678",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "IQ",
              964,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d)(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["1"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["[2-6]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["7"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            IR: [
              ,
              [
                ,
                ,
                "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  4,
                  5,
                  6,
                  7,
                  10
                ],
                [8]
              ],
              [
                ,
                ,
                "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|(?:12\\d|30[0-2])\\d|2(?:121|[2689]0\\d)|4(?:111|40\\d))\\d{4}",
                ,
                ,
                ,
                "2123456789",
                ,
                ,
                [
                  6,
                  7,
                  10
                ],
                [
                  4,
                  5,
                  8
                ]
              ],
              [
                ,
                ,
                "9(?:(?:0[0-5]|[13]\\d|2[0-3])\\d\\d|9(?:[0-46]\\d\\d|5(?:10|5\\d)|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}",
                ,
                ,
                ,
                "9123456789",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "IR",
              98,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{4,5})",
                  "$1",
                  ["96"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{4,5})",
                  "$1 $2",
                  ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["9"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["[1-8]"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  4,
                  5,
                  10
                ]
              ],
              [
                ,
                ,
                "96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])",
                ,
                ,
                ,
                "9601",
                ,
                ,
                [4, 5]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            IS: [
              ,
              [
                ,
                ,
                "(?:38\\d|[4-9])\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 9]
              ],
              [
                ,
                ,
                "(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}",
                ,
                ,
                ,
                "4101234",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}",
                ,
                ,
                ,
                "6111234"
              ],
              [
                ,
                ,
                "80[0-8]\\d{4}",
                ,
                ,
                ,
                "8001234",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}",
                ,
                ,
                ,
                "9001234",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "49[0-24-79]\\d{4}",
                ,
                ,
                ,
                "4921234",
                ,
                ,
                [7]
              ],
              "IS",
              354,
              "00|1(?:0(?:01|[12]0)|100)",
              ,
              ,
              ,
              ,
              ,
              "00",
              ,
              [[
                ,
                "(\\d{3})(\\d{4})",
                "$1 $2",
                ["[4-9]"]
              ], [
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["3"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "809\\d{4}",
                ,
                ,
                ,
                "8091234",
                ,
                ,
                [7]
              ],
              ,
              ,
              [
                ,
                ,
                "(?:689|8(?:7[18]|80)|95[48])\\d{4}",
                ,
                ,
                ,
                "6891234",
                ,
                ,
                [7]
              ]
            ],
            IT: [
              ,
              [
                ,
                ,
                "0\\d{5,11}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  6,
                  7,
                  8,
                  9,
                  10,
                  11,
                  12
                ]
              ],
              [
                ,
                ,
                "0(?:669[0-79]\\d{1,6}|831\\d{2,8})|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[2356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
                ,
                ,
                ,
                "0212345678"
              ],
              [
                ,
                ,
                "3[2-9]\\d{7,8}|(?:31|43)\\d{8}",
                ,
                ,
                ,
                "3123456789",
                ,
                ,
                [9, 10]
              ],
              [
                ,
                ,
                "80(?:0\\d{3}|3)\\d{3}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [6, 9]
              ],
              [
                ,
                ,
                "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                ,
                ,
                ,
                "899123456",
                ,
                ,
                [
                  6,
                  8,
                  9,
                  10
                ]
              ],
              [
                ,
                ,
                "84(?:[08]\\d{3}|[17])\\d{3}",
                ,
                ,
                ,
                "848123456",
                ,
                ,
                [6, 9]
              ],
              [
                ,
                ,
                "1(?:78\\d|99)\\d{6}",
                ,
                ,
                ,
                "1781234567",
                ,
                ,
                [9, 10]
              ],
              [
                ,
                ,
                "55\\d{8}",
                ,
                ,
                ,
                "5512345678",
                ,
                ,
                [10]
              ],
              "IT",
              39,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{4,5})",
                  "$1",
                  ["1(?:0|9[246])", "1(?:0|9(?:2[2-9]|[46]))"]
                ],
                [
                  ,
                  "(\\d{6})",
                  "$1",
                  ["1(?:1|92)"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{4,6})",
                  "$1 $2",
                  ["0[26]"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3,6})",
                  "$1 $2",
                  ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{2,6})",
                  "$1 $2",
                  ["0(?:[13-579][2-46-8]|8[236-8])"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{4})",
                  "$1 $2",
                  ["894"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{3,4})(\\d{4})",
                  "$1 $2 $3",
                  ["0[26]|5"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["1(?:44|[679])|[378]|43"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3,4})(\\d{4})",
                  "$1 $2 $3",
                  ["0[13-57-9][0159]|14"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{5})",
                  "$1 $2 $3",
                  ["0[26]"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["0"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})(\\d{4,5})",
                  "$1 $2 $3",
                  ["[03]"]
                ]
              ],
              [
                [
                  ,
                  "(\\d{2})(\\d{4,6})",
                  "$1 $2",
                  ["0[26]"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3,6})",
                  "$1 $2",
                  ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{2,6})",
                  "$1 $2",
                  ["0(?:[13-579][2-46-8]|8[236-8])"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{4})",
                  "$1 $2",
                  ["894"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{3,4})(\\d{4})",
                  "$1 $2 $3",
                  ["0[26]|5"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["1(?:44|[679])|[378]|43"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3,4})(\\d{4})",
                  "$1 $2 $3",
                  ["0[13-57-9][0159]|14"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{5})",
                  "$1 $2 $3",
                  ["0[26]"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["0"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})(\\d{4,5})",
                  "$1 $2 $3",
                  ["[03]"]
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              1,
              ,
              [
                ,
                ,
                "848\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "3[2-8]\\d{9,10}",
                ,
                ,
                ,
                "33101234501",
                ,
                ,
                [11, 12]
              ]
            ],
            JE: [
              ,
              [
                ,
                ,
                "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [6]
              ],
              [
                ,
                ,
                "1534[0-24-8]\\d{5}",
                ,
                ,
                ,
                "1534456789",
                ,
                ,
                ,
                [6]
              ],
              [
                ,
                ,
                "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}",
                ,
                ,
                ,
                "7797712345"
              ],
              [
                ,
                ,
                "80(?:07(?:35|81)|8901)\\d{4}",
                ,
                ,
                ,
                "8007354567"
              ],
              [
                ,
                ,
                "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}",
                ,
                ,
                ,
                "9018105678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "701511\\d{4}",
                ,
                ,
                ,
                "7015115678"
              ],
              [
                ,
                ,
                "56\\d{8}",
                ,
                ,
                ,
                "5612345678"
              ],
              "JE",
              44,
              "00",
              "0",
              ,
              ,
              "([0-24-8]\\d{5})$|0|180020",
              "1534$1",
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                ,
                ,
                ,
                "7640123456"
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}",
                ,
                ,
                ,
                "5512345678"
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            JM: [
              ,
              [
                ,
                ,
                "(?:[58]\\d\\d|658|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}",
                ,
                ,
                ,
                "8765230123",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}",
                ,
                ,
                ,
                "8762101234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
              ],
              [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "JM",
              1,
              "011",
              "1",
              ,
              ,
              "1",
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "658|876",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            JO: [
              ,
              [
                ,
                ,
                "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9]
              ],
              [
                ,
                ,
                "87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}",
                ,
                ,
                ,
                "62001234",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "7(?:[78][0-25-9]|9\\d)\\d{6}",
                ,
                ,
                ,
                "790123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "80\\d{6}",
                ,
                ,
                ,
                "80012345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "9\\d{7}",
                ,
                ,
                ,
                "90012345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "85\\d{6}",
                ,
                ,
                ,
                "85012345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "70\\d{7}",
                ,
                ,
                ,
                "700123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "JO",
              962,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d)(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["[2356]|87"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{3})(\\d{5,6})",
                  "$1 $2",
                  ["[89]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{7})",
                  "$1 $2",
                  ["70"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["7"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                "74(?:66|77)\\d{5}",
                ,
                ,
                ,
                "746612345",
                ,
                ,
                [9]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "8(?:10|8\\d)\\d{5}",
                ,
                ,
                ,
                "88101234",
                ,
                ,
                [8]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            JP: [
              ,
              [
                ,
                ,
                "00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  8,
                  9,
                  10,
                  11,
                  12,
                  13,
                  14,
                  15,
                  16,
                  17
                ]
              ],
              [
                ,
                ,
                "(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}",
                ,
                ,
                ,
                "312345678",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "(?:601[0-4]0|[7-9]0[1-9]\\d\\d)\\d{5}",
                ,
                ,
                ,
                "9012345678",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}",
                ,
                ,
                ,
                "120123456"
              ],
              [
                ,
                ,
                "990\\d{6}",
                ,
                ,
                ,
                "990123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "60\\d{7}",
                ,
                ,
                ,
                "601234567",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "50[1-9]\\d{7}",
                ,
                ,
                ,
                "5012345678",
                ,
                ,
                [10]
              ],
              "JP",
              81,
              "010",
              "0",
              ,
              ,
              "(000[2569]\\d{4,6})$|(?:(?:003768)0?)|0",
              "$1",
              ,
              ,
              [
                [
                  ,
                  "(\\d{4})(\\d{4})",
                  "$1-$2",
                  [
                    "007",
                    "0077",
                    "00777",
                    "00777[01]"
                  ]
                ],
                [
                  ,
                  "(\\d{8,10})",
                  "$1",
                  ["000"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1-$2-$3",
                  ["(?:12|57|99)0"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d)(\\d{4})",
                  "$1-$2-$3",
                  [
                    "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                    "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                    "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                  ],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1-$2-$3",
                  ["60"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{4})(\\d{4})",
                  "$1-$2-$3",
                  ["3|4(?:2[09]|7[01])|6[1-9]", "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1-$2-$3",
                  [
                    "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                    "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                    "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                  ],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{4})",
                  "$1-$2-$3",
                  ["[14]|[289][2-9]|5[3-9]|7[2-4679]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{2})(\\d{3,4})",
                  "$1-$2-$3",
                  ["007", "0077"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{2})(\\d{4})",
                  "$1-$2-$3",
                  ["008"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1-$2-$3",
                  ["800"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{4})",
                  "$1-$2-$3",
                  ["[25-9]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})(\\d{3,4})",
                  "$1-$2-$3",
                  ["0"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{4})(\\d{4,5})",
                  "$1-$2-$3",
                  ["0"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{5})(\\d{5,6})",
                  "$1-$2-$3",
                  ["0"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{6})(\\d{6,7})",
                  "$1-$2-$3",
                  ["0"]
                ]
              ],
              [
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1-$2-$3",
                  ["(?:12|57|99)0"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d)(\\d{4})",
                  "$1-$2-$3",
                  [
                    "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                    "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                    "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                  ],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1-$2-$3",
                  ["60"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{4})(\\d{4})",
                  "$1-$2-$3",
                  ["3|4(?:2[09]|7[01])|6[1-9]", "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1-$2-$3",
                  [
                    "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                    "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                    "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                  ],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{4})",
                  "$1-$2-$3",
                  ["[14]|[289][2-9]|5[3-9]|7[2-4679]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1-$2-$3",
                  ["800"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{4})",
                  "$1-$2-$3",
                  ["[25-9]"],
                  "0$1"
                ]
              ],
              [
                ,
                ,
                "20\\d{8}",
                ,
                ,
                ,
                "2012345678",
                ,
                ,
                [10]
              ],
              ,
              ,
              [
                ,
                ,
                "00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66|78)\\d{6,13}"
              ],
              [
                ,
                ,
                "570\\d{6}",
                ,
                ,
                ,
                "570123456",
                ,
                ,
                [9]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            KE: [
              ,
              [
                ,
                ,
                "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  7,
                  8,
                  9,
                  10
                ]
              ],
              [
                ,
                ,
                "(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}",
                ,
                ,
                ,
                "202012345",
                ,
                ,
                [
                  7,
                  8,
                  9
                ]
              ],
              [
                ,
                ,
                "(?:1(?:0[0-8]|1[0-7]|2[014]|30)|7\\d\\d)\\d{6}",
                ,
                ,
                ,
                "712123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "800[02-8]\\d{5,6}",
                ,
                ,
                ,
                "800223456",
                ,
                ,
                [9, 10]
              ],
              [
                ,
                ,
                "900[02-9]\\d{5}",
                ,
                ,
                ,
                "900223456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "KE",
              254,
              "000",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{5,7})",
                  "$1 $2",
                  ["[24-6]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{6})",
                  "$1 $2",
                  ["[17]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["[89]"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            KG: [
              ,
              [
                ,
                ,
                "8\\d{9}|[235-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9, 10],
                [5, 6]
              ],
              [
                ,
                ,
                "312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}",
                ,
                ,
                ,
                "312123456",
                ,
                ,
                [9],
                [5, 6]
              ],
              [
                ,
                ,
                "312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}",
                ,
                ,
                ,
                "700123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "800\\d{6,7}",
                ,
                ,
                ,
                "800123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "KG",
              996,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{4})(\\d{5})",
                  "$1 $2",
                  ["3(?:1[346]|[24-79])"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["[235-79]|88"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                  "$1 $2 $3 $4",
                  ["8"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            KH: [
              ,
              [
                ,
                ,
                "1\\d{9}|[1-9]\\d{7,8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  8,
                  9,
                  10
                ],
                [6, 7]
              ],
              [
                ,
                ,
                "23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})",
                ,
                ,
                ,
                "23756789",
                ,
                ,
                [8, 9],
                [6, 7]
              ],
              [
                ,
                ,
                "(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}",
                ,
                ,
                ,
                "91234567",
                ,
                ,
                [8, 9]
              ],
              [
                ,
                ,
                "1800(?:1\\d|2[019])\\d{4}",
                ,
                ,
                ,
                "1800123456",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "1900(?:1\\d|2[09])\\d{4}",
                ,
                ,
                ,
                "1900123456",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "KH",
              855,
              "00[14-9]",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{3})(\\d{3,4})",
                "$1 $2 $3",
                ["[1-9]"],
                "0$1"
              ], [
                ,
                "(\\d{4})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["1"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            KI: [
              ,
              [
                ,
                ,
                "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [5, 8]
              ],
              [
                ,
                ,
                "(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}",
                ,
                ,
                ,
                "31234"
              ],
              [
                ,
                ,
                "(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}",
                ,
                ,
                ,
                "72001234",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "30(?:0[01]\\d\\d|12(?:11|20))\\d\\d",
                ,
                ,
                ,
                "30010000",
                ,
                ,
                [8]
              ],
              "KI",
              686,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            KM: [
              ,
              [
                ,
                ,
                "[3478]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7],
                [4]
              ],
              [
                ,
                ,
                "7[4-7]\\d{5}",
                ,
                ,
                ,
                "7712345",
                ,
                ,
                ,
                [4]
              ],
              [
                ,
                ,
                "[34]\\d{6}",
                ,
                ,
                ,
                "3212345"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "8\\d{6}",
                ,
                ,
                ,
                "8001234"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "KM",
              269,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{2})(\\d{2})",
                "$1 $2 $3",
                ["[3478]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            KN: [
              ,
              [
                ,
                ,
                "(?:[58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}",
                ,
                ,
                ,
                "8692361234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}",
                ,
                ,
                ,
                "8697652917",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
              ],
              [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "KN",
              1,
              "011",
              "1",
              ,
              ,
              "([2-7]\\d{6})$|1",
              "869$1",
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "869",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            KP: [
              ,
              [
                ,
                ,
                "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 10],
                [6, 7]
              ],
              [
                ,
                ,
                "(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}",
                ,
                ,
                ,
                "21234567",
                ,
                ,
                ,
                [6, 7]
              ],
              [
                ,
                ,
                "19[1-3]\\d{7}",
                ,
                ,
                ,
                "1921234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "KP",
              850,
              "00|99",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["8"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["[2-7]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["1"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            KR: [
              ,
              [
                ,
                ,
                "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  5,
                  6,
                  8,
                  9,
                  10,
                  11,
                  12,
                  13,
                  14
                ],
                [
                  3,
                  4,
                  7
                ]
              ],
              [
                ,
                ,
                "(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}",
                ,
                ,
                ,
                "22123456",
                ,
                ,
                [
                  5,
                  6,
                  8,
                  9,
                  10
                ],
                [
                  3,
                  4,
                  7
                ]
              ],
              [
                ,
                ,
                "1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}",
                ,
                ,
                ,
                "1020000000",
                ,
                ,
                [9, 10]
              ],
              [
                ,
                ,
                "00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|[38]0)\\d{7}",
                ,
                ,
                ,
                "801234567",
                ,
                ,
                [
                  9,
                  11,
                  12,
                  13,
                  14
                ]
              ],
              [
                ,
                ,
                "60[2-9]\\d{6}",
                ,
                ,
                ,
                "602345678",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "50\\d{8,9}",
                ,
                ,
                ,
                "5012345678",
                ,
                ,
                [10, 11]
              ],
              [
                ,
                ,
                "70\\d{8}",
                ,
                ,
                ,
                "7012345678",
                ,
                ,
                [10]
              ],
              "KR",
              82,
              "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
              "0",
              ,
              ,
              "0(8(?:[1-46-8]|5\\d\\d))?",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{5})",
                  "$1",
                  [
                    "1[016-9]1",
                    "1[016-9]11",
                    "1[016-9]114"
                  ],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3,4})",
                  "$1-$2",
                  ["(?:3[1-3]|[46][1-4]|5[1-5])1"],
                  "0$1",
                  "0$CC-$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{4})",
                  "$1-$2",
                  ["1"]
                ],
                [
                  ,
                  "(\\d)(\\d{3,4})(\\d{4})",
                  "$1-$2-$3",
                  ["2"],
                  "0$1",
                  "0$CC-$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1-$2-$3",
                  ["[36]0|8"],
                  "0$1",
                  "0$CC-$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3,4})(\\d{4})",
                  "$1-$2-$3",
                  ["[1346]|5[1-5]"],
                  "0$1",
                  "0$CC-$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{4})",
                  "$1-$2-$3",
                  ["[57]"],
                  "0$1",
                  "0$CC-$1"
                ],
                [
                  ,
                  "(\\d{5})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["003", "0030"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{5})(\\d{4})",
                  "$1-$2-$3",
                  ["5"],
                  "0$1",
                  "0$CC-$1"
                ],
                [
                  ,
                  "(\\d{5})(\\d{3,4})(\\d{4})",
                  "$1 $2 $3",
                  ["0"]
                ],
                [
                  ,
                  "(\\d{5})(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3 $4",
                  ["0"]
                ]
              ],
              [
                [
                  ,
                  "(\\d{2})(\\d{3,4})",
                  "$1-$2",
                  ["(?:3[1-3]|[46][1-4]|5[1-5])1"],
                  "0$1",
                  "0$CC-$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{4})",
                  "$1-$2",
                  ["1"]
                ],
                [
                  ,
                  "(\\d)(\\d{3,4})(\\d{4})",
                  "$1-$2-$3",
                  ["2"],
                  "0$1",
                  "0$CC-$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1-$2-$3",
                  ["[36]0|8"],
                  "0$1",
                  "0$CC-$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3,4})(\\d{4})",
                  "$1-$2-$3",
                  ["[1346]|5[1-5]"],
                  "0$1",
                  "0$CC-$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{4})",
                  "$1-$2-$3",
                  ["[57]"],
                  "0$1",
                  "0$CC-$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{5})(\\d{4})",
                  "$1-$2-$3",
                  ["5"],
                  "0$1",
                  "0$CC-$1"
                ]
              ],
              [
                ,
                ,
                "15\\d{7,8}",
                ,
                ,
                ,
                "1523456789",
                ,
                ,
                [9, 10]
              ],
              ,
              ,
              [
                ,
                ,
                "00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  11,
                  12,
                  13,
                  14
                ]
              ],
              [
                ,
                ,
                "1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[0168]|88)|8(?:00|33|55|77|99))\\d{4}",
                ,
                ,
                ,
                "15441234",
                ,
                ,
                [8]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            KW: [
              ,
              [
                ,
                ,
                "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 8]
              ],
              [
                ,
                ,
                "2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}",
                ,
                ,
                ,
                "22345678",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:00|1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}",
                ,
                ,
                ,
                "50012345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "18\\d{5}",
                ,
                ,
                ,
                "1801234",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "KW",
              965,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{4})(\\d{3,4})",
                "$1 $2",
                ["[169]|2(?:[235]|4[1-35-9])|52"]
              ], [
                ,
                "(\\d{3})(\\d{5})",
                "$1 $2",
                ["[245]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            KY: [
              ,
              [
                ,
                ,
                "(?:345|[58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|4[89]|88)|9(?:14|4[035-9]))\\d{4}",
                ,
                ,
                ,
                "3452221234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}",
                ,
                ,
                ,
                "3453231234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002345678"
              ],
              [
                ,
                ,
                "(?:345976|900[2-9]\\d\\d)\\d{4}",
                ,
                ,
                ,
                "9002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "KY",
              1,
              "011",
              "1",
              ,
              ,
              "([2-9]\\d{6})$|1",
              "345$1",
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "345",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            KZ: [
              ,
              [
                ,
                ,
                "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10, 14],
                [
                  5,
                  6,
                  7
                ]
              ],
              [
                ,
                ,
                "(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}",
                ,
                ,
                ,
                "7123456789",
                ,
                ,
                [10],
                [
                  5,
                  6,
                  7
                ]
              ],
              [
                ,
                ,
                "7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}",
                ,
                ,
                ,
                "7710009998",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "8(?:00|108\\d{3})\\d{7}",
                ,
                ,
                ,
                "8001234567"
              ],
              [
                ,
                ,
                "809\\d{7}",
                ,
                ,
                ,
                "8091234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "808\\d{7}",
                ,
                ,
                ,
                "8081234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "751\\d{7}",
                ,
                ,
                ,
                "7511234567",
                ,
                ,
                [10]
              ],
              "KZ",
              7,
              "810",
              "8",
              ,
              ,
              "8",
              ,
              "8~10",
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "33622|7",
              [
                ,
                ,
                "751\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            LA: [
              ,
              [
                ,
                ,
                "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  8,
                  9,
                  10
                ],
                [6]
              ],
              [
                ,
                ,
                "(?:2[13]|[35-7][14]|41|8[1468])\\d{6}",
                ,
                ,
                ,
                "21212862",
                ,
                ,
                [8],
                [6]
              ],
              [
                ,
                ,
                "(?:20(?:[23579]\\d|8[78])|30[24]\\d)\\d{6}|30\\d{7}",
                ,
                ,
                ,
                "2023123456",
                ,
                ,
                [9, 10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "LA",
              856,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["2[13]|3[14]|[4-8]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                  "$1 $2 $3 $4",
                  ["3"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                  "$1 $2 $3 $4",
                  ["[23]"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            LB: [
              ,
              [
                ,
                ,
                "[27-9]\\d{7}|[13-9]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 8]
              ],
              [
                ,
                ,
                "7(?:62|8[0-6]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}",
                ,
                ,
                ,
                "1123456"
              ],
              [
                ,
                ,
                "(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[7-9]|9[1-3]))\\d{5}",
                ,
                ,
                ,
                "71123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "9[01]\\d{6}",
                ,
                ,
                ,
                "90123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "80\\d{6}",
                ,
                ,
                ,
                "80123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "LB",
              961,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [[
                ,
                "(\\d)(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[13-69]|7(?:[2-57]|62|8[0-6]|9[04-9])|8[02-9]"],
                "0$1"
              ], [
                ,
                "(\\d{2})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[27-9]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            LC: [
              ,
              [
                ,
                ,
                "(?:[58]\\d\\d|758|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}",
                ,
                ,
                ,
                "7584305678",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}",
                ,
                ,
                ,
                "7582845678",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
              ],
              [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "LC",
              1,
              "011",
              "1",
              ,
              ,
              "([2-8]\\d{6})$|1",
              "758$1",
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "758",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            LI: [
              ,
              [
                ,
                ,
                "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 9]
              ],
              [
                ,
                ,
                "(?:2(?:01|1[27]|2[024]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}",
                ,
                ,
                ,
                "2345678",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "(?:6(?:(?:4[5-9]|5\\d)\\d|6(?:[024-6]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}",
                ,
                ,
                ,
                "660234567"
              ],
              [
                ,
                ,
                "8002[28]\\d\\d|80(?:05\\d|9)\\d{4}",
                ,
                ,
                ,
                "8002222"
              ],
              [
                ,
                ,
                "90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d",
                ,
                ,
                ,
                "9002222",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "LI",
              423,
              "00",
              "0",
              ,
              ,
              "(1001)|0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{2})",
                  "$1 $2 $3",
                  ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"],
                  ,
                  "$CC $1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["8"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["69"],
                  ,
                  "$CC $1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["6"],
                  ,
                  "$CC $1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "870(?:28|87)\\d\\d",
                ,
                ,
                ,
                "8702812",
                ,
                ,
                [7]
              ],
              ,
              ,
              [
                ,
                ,
                "697(?:42|56|[78]\\d)\\d{4}",
                ,
                ,
                ,
                "697861234",
                ,
                ,
                [9]
              ]
            ],
            LK: [
              ,
              [
                ,
                ,
                "[1-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9],
                [7]
              ],
              [
                ,
                ,
                "(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}",
                ,
                ,
                ,
                "112345678",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "7(?:[0-25-8]\\d|4[0-4])\\d{6}",
                ,
                ,
                ,
                "712345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "LK",
              94,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{3})(\\d{4})",
                "$1 $2 $3",
                ["7"],
                "0$1"
              ], [
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[1-689]"],
                "0$1"
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "1973\\d{5}",
                ,
                ,
                ,
                "197312345"
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            LR: [
              ,
              [
                ,
                ,
                "(?:[2457]\\d|33|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  7,
                  8,
                  9
                ]
              ],
              [
                ,
                ,
                "2\\d{7}",
                ,
                ,
                ,
                "21234567",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "(?:(?:(?:22|33)0|555|7(?:6[01]|7\\d)|88\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}",
                ,
                ,
                ,
                "770123456",
                ,
                ,
                [7, 9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "332(?:02|[34]\\d)\\d{4}",
                ,
                ,
                ,
                "332021234",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "LR",
              231,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d)(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["4[67]|[56]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["2"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["[2-578]"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            LS: [
              ,
              [
                ,
                ,
                "(?:[256]\\d\\d|800)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "2\\d{7}",
                ,
                ,
                ,
                "22123456"
              ],
              [
                ,
                ,
                "[56]\\d{7}",
                ,
                ,
                ,
                "50123456"
              ],
              [
                ,
                ,
                "800[1256]\\d{4}",
                ,
                ,
                ,
                "80021234"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "LS",
              266,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{4})(\\d{4})",
                "$1 $2",
                ["[2568]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            LT: [
              ,
              [
                ,
                ,
                "(?:[3469]\\d|52|[78]0)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "(?:3[1478]|4[124-6]|52)\\d{6}",
                ,
                ,
                ,
                "31234567"
              ],
              [
                ,
                ,
                "6\\d{7}",
                ,
                ,
                ,
                "61234567"
              ],
              [
                ,
                ,
                "80[02]\\d{5}",
                ,
                ,
                ,
                "80012345"
              ],
              [
                ,
                ,
                "9(?:0[0239]|10)\\d{5}",
                ,
                ,
                ,
                "90012345"
              ],
              [
                ,
                ,
                "808\\d{5}",
                ,
                ,
                ,
                "80812345"
              ],
              [
                ,
                ,
                "70[05]\\d{5}",
                ,
                ,
                ,
                "70012345"
              ],
              [
                ,
                ,
                "[89]01\\d{5}",
                ,
                ,
                ,
                "80123456"
              ],
              "LT",
              370,
              "00",
              "0",
              ,
              ,
              "[08]",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d)(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["52[0-7]"],
                  "(0-$1)",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{3})",
                  "$1 $2 $3",
                  ["[7-9]"],
                  "0 $1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{2})(\\d{6})",
                  "$1 $2",
                  ["37|4(?:[15]|6[1-8])"],
                  "(0-$1)",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{5})",
                  "$1 $2",
                  ["[3-6]"],
                  "(0-$1)",
                  ,
                  1
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "70[67]\\d{5}",
                ,
                ,
                ,
                "70712345"
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            LU: [
              ,
              [
                ,
                ,
                "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  4,
                  5,
                  6,
                  7,
                  8,
                  9,
                  10,
                  11
                ]
              ],
              [
                ,
                ,
                "(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}",
                ,
                ,
                ,
                "27123456"
              ],
              [
                ,
                ,
                "6(?:[269][18]|5[1568]|7[189]|81)\\d{6}",
                ,
                ,
                ,
                "628123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "800\\d{5}",
                ,
                ,
                ,
                "80012345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "90[015]\\d{5}",
                ,
                ,
                ,
                "90012345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "801\\d{5}",
                ,
                ,
                ,
                "80112345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "20(?:1\\d{5}|[2-689]\\d{1,7})",
                ,
                ,
                ,
                "20201234",
                ,
                ,
                [
                  4,
                  5,
                  6,
                  7,
                  8,
                  9,
                  10
                ]
              ],
              "LU",
              352,
              "00",
              ,
              ,
              ,
              "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{3})",
                  "$1 $2",
                  ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"],
                  ,
                  "$CC $1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3",
                  ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"],
                  ,
                  "$CC $1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{3})",
                  "$1 $2 $3",
                  ["20[2-689]"],
                  ,
                  "$CC $1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                  "$1 $2 $3 $4",
                  ["2(?:[0367]|4[3-8])"],
                  ,
                  "$CC $1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{3})",
                  "$1 $2 $3",
                  ["80[01]|90[015]"],
                  ,
                  "$CC $1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                  "$1 $2 $3 $4",
                  ["20"],
                  ,
                  "$CC $1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["6"],
                  ,
                  "$CC $1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                  "$1 $2 $3 $4 $5",
                  ["2(?:[0367]|4[3-8])"],
                  ,
                  "$CC $1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                  "$1 $2 $3 $4",
                  ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"],
                  ,
                  "$CC $1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            LV: [
              ,
              [
                ,
                ,
                "(?:[268]\\d|78|90)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "6\\d{7}",
                ,
                ,
                ,
                "63123456"
              ],
              [
                ,
                ,
                "2333[0-8]\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[02-9]|3[0-24-9]))\\d{4}",
                ,
                ,
                ,
                "21234567"
              ],
              [
                ,
                ,
                "80\\d{6}",
                ,
                ,
                ,
                "80123456"
              ],
              [
                ,
                ,
                "90\\d{6}",
                ,
                ,
                ,
                "90123456"
              ],
              [
                ,
                ,
                "81\\d{6}",
                ,
                ,
                ,
                "81123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "LV",
              371,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[2679]|8[01]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            LY: [
              ,
              [
                ,
                ,
                "[2-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9],
                [7]
              ],
              [
                ,
                ,
                "(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}",
                ,
                ,
                ,
                "212345678",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "9[1-6]\\d{7}",
                ,
                ,
                ,
                "912345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "LY",
              218,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{7})",
                "$1-$2",
                ["[2-9]"],
                "0$1"
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MA: [
              ,
              [
                ,
                ,
                "[5-8]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}",
                ,
                ,
                ,
                "520123456"
              ],
              [
                ,
                ,
                "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-8]|5[0-5]|8[0-7]))\\d{6}",
                ,
                ,
                ,
                "650123456"
              ],
              [
                ,
                ,
                "80[0-7]\\d{6}",
                ,
                ,
                ,
                "801234567"
              ],
              [
                ,
                ,
                "89\\d{7}",
                ,
                ,
                ,
                "891234567"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}",
                ,
                ,
                ,
                "592401234"
              ],
              "MA",
              212,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["5[45]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{5})",
                  "$1-$2",
                  ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{7})",
                  "$1-$2",
                  ["8"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{6})",
                  "$1-$2",
                  ["[5-7]"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              1,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MC: [
              ,
              [
                ,
                ,
                "(?:[3489]|6\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9]
              ],
              [
                ,
                ,
                "(?:870|9[2-47-9]\\d)\\d{5}",
                ,
                ,
                ,
                "99123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "4(?:[469]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}",
                ,
                ,
                ,
                "612345678"
              ],
              [
                ,
                ,
                "(?:800|90\\d)\\d{5}",
                ,
                ,
                ,
                "90123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "MC",
              377,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{2})",
                  "$1 $2 $3",
                  ["87"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["4"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["[389]"]
                ],
                [
                  ,
                  "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4 $5",
                  ["6"],
                  "0$1"
                ]
              ],
              [
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["4"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["[389]"]
                ],
                [
                  ,
                  "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4 $5",
                  ["6"],
                  "0$1"
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "8[07]0\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MD: [
              ,
              [
                ,
                ,
                "(?:[235-7]\\d|[89]0)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}",
                ,
                ,
                ,
                "22212345"
              ],
              [
                ,
                ,
                "562\\d{5}|(?:6\\d|7[16-9])\\d{6}",
                ,
                ,
                ,
                "62112345"
              ],
              [
                ,
                ,
                "800\\d{5}",
                ,
                ,
                ,
                "80012345"
              ],
              [
                ,
                ,
                "90[056]\\d{5}",
                ,
                ,
                ,
                "90012345"
              ],
              [
                ,
                ,
                "808\\d{5}",
                ,
                ,
                ,
                "80812345"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "3[08]\\d{6}",
                ,
                ,
                ,
                "30123456"
              ],
              "MD",
              373,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{5})",
                  "$1 $2",
                  ["[89]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["22|3"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{3})",
                  "$1 $2 $3",
                  ["[25-7]"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "803\\d{5}",
                ,
                ,
                ,
                "80312345"
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            ME: [
              ,
              [
                ,
                ,
                "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9],
                [6]
              ],
              [
                ,
                ,
                "(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}",
                ,
                ,
                ,
                "30234567",
                ,
                ,
                [8],
                [6]
              ],
              [
                ,
                ,
                "6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}",
                ,
                ,
                ,
                "60123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "80(?:[0-2578]|9\\d)\\d{5}",
                ,
                ,
                ,
                "80080002"
              ],
              [
                ,
                ,
                "9(?:4[1568]|5[178])\\d{5}",
                ,
                ,
                ,
                "94515151",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "78[1-49]\\d{5}",
                ,
                ,
                ,
                "78108780",
                ,
                ,
                [8]
              ],
              "ME",
              382,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{3})(\\d{3,4})",
                "$1 $2 $3",
                ["[2-9]"],
                "0$1"
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "77[1-9]\\d{5}",
                ,
                ,
                ,
                "77273012",
                ,
                ,
                [8]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MF: [
              ,
              [
                ,
                ,
                "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}",
                ,
                ,
                ,
                "590271234"
              ],
              [
                ,
                ,
                "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}",
                ,
                ,
                ,
                "690001234"
              ],
              [
                ,
                ,
                "80[0-5]\\d{6}",
                ,
                ,
                ,
                "800012345"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}",
                ,
                ,
                ,
                "976012345"
              ],
              "MF",
              590,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MG: [
              ,
              [
                ,
                ,
                "[23]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9],
                [7]
              ],
              [
                ,
                ,
                "2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[356]|8[268]|9[2457])\\d{5}",
                ,
                ,
                ,
                "202123456",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "3[2-47-9]\\d{7}",
                ,
                ,
                ,
                "321234567"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "22\\d{7}",
                ,
                ,
                ,
                "221234567"
              ],
              "MG",
              261,
              "00",
              "0",
              ,
              ,
              "([24-9]\\d{6})$|0",
              "20$1",
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                "$1 $2 $3 $4",
                ["[23]"],
                "0$1"
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MH: [
              ,
              [
                ,
                ,
                "329\\d{4}|(?:[256]\\d|45)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "(?:247|528|625)\\d{4}",
                ,
                ,
                ,
                "2471234"
              ],
              [
                ,
                ,
                "(?:(?:23|54)5|329|45[35-8])\\d{4}",
                ,
                ,
                ,
                "2351234"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "635\\d{4}",
                ,
                ,
                ,
                "6351234"
              ],
              "MH",
              692,
              "011",
              "1",
              ,
              ,
              "1",
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{4})",
                "$1-$2",
                ["[2-6]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MK: [
              ,
              [
                ,
                ,
                "[2-578]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8],
                [6, 7]
              ],
              [
                ,
                ,
                "(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}",
                ,
                ,
                ,
                "22012345",
                ,
                ,
                ,
                [6, 7]
              ],
              [
                ,
                ,
                "7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-478]\\d|6[01])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}",
                ,
                ,
                ,
                "72345678"
              ],
              [
                ,
                ,
                "800\\d{5}",
                ,
                ,
                ,
                "80012345"
              ],
              [
                ,
                ,
                "5\\d{7}",
                ,
                ,
                ,
                "50012345"
              ],
              [
                ,
                ,
                "8(?:0[1-9]|[1-9]\\d)\\d{5}",
                ,
                ,
                ,
                "80123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "MK",
              389,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d)(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["2|34[47]|4(?:[37]7|5[47]|64)"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["[347]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["[58]"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            ML: [
              ,
              [
                ,
                ,
                "[24-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-59]))\\d{5}",
                ,
                ,
                ,
                "20212345"
              ],
              [
                ,
                ,
                "2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[0-3]|[679]\\d|8[2-59])\\d{6}",
                ,
                ,
                ,
                "65012345"
              ],
              [
                ,
                ,
                "80\\d{6}",
                ,
                ,
                ,
                "80012345"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "ML",
              223,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{4})",
                "$1",
                ["67[057-9]|74[045]", "67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)"]
              ], [
                ,
                "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[24-9]"]
              ]],
              [[
                ,
                "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[24-9]"]
              ]],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "80\\d{6}"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MM: [
              ,
              [
                ,
                ,
                "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  6,
                  7,
                  8,
                  9,
                  10
                ],
                [5]
              ],
              [
                ,
                ,
                "(?:1(?:(?:12|[28]\\d|3[56]|7[3-6]|9[0-6])\\d|4(?:2[29]|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|22|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5(?:2\\d|470))|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:3\\d\\d|4[67]0|8(?:[01459]\\d|8))))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|(?:[35]2|64)\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}",
                ,
                ,
                ,
                "1234567",
                ,
                ,
                [
                  6,
                  7,
                  8,
                  9
                ],
                [5]
              ],
              [
                ,
                ,
                "(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}",
                ,
                ,
                ,
                "92123456",
                ,
                ,
                [
                  7,
                  8,
                  9,
                  10
                ]
              ],
              [
                ,
                ,
                "80080(?:0[1-9]|2\\d)\\d{3}",
                ,
                ,
                ,
                "8008001234",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "1333\\d{4}",
                ,
                ,
                ,
                "13331234",
                ,
                ,
                [8]
              ],
              "MM",
              95,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d)(\\d{2})(\\d{3})",
                  "$1 $2 $3",
                  ["16|2"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{3})",
                  "$1 $2 $3",
                  ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["[12]|452|678|86", "[12]|452|6788|86"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["[4-7]|8[1-35]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{3})(\\d{4,6})",
                  "$1 $2 $3",
                  ["9(?:2[0-4]|[35-9]|4[137-9])"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["2"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["8"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3 $4",
                  ["92"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{5})(\\d{4})",
                  "$1 $2 $3",
                  ["9"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MN: [
              ,
              [
                ,
                ,
                "[12]\\d{7,9}|[5-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  8,
                  9,
                  10
                ],
                [
                  4,
                  5,
                  6
                ]
              ],
              [
                ,
                ,
                "[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}",
                ,
                ,
                ,
                "53123456",
                ,
                ,
                ,
                [
                  4,
                  5,
                  6
                ]
              ],
              [
                ,
                ,
                "92[0139]\\d{5}|(?:5[05]|6[069]|7[28]|8[0135689]|9[013-9])\\d{6}",
                ,
                ,
                ,
                "88123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "712[0-79]\\d{4}|7(?:1[013-9]|[5-79]\\d)\\d{5}",
                ,
                ,
                ,
                "75123456",
                ,
                ,
                [8]
              ],
              "MN",
              976,
              "001",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{4})",
                  "$1 $2 $3",
                  ["[12]1"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{4})",
                  "$1 $2",
                  ["[5-9]"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{5,6})",
                  "$1 $2",
                  ["[12]2[1-3]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{5,6})",
                  "$1 $2",
                  ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{5})(\\d{4,5})",
                  "$1 $2",
                  ["[12]"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MO: [
              ,
              [
                ,
                ,
                "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 8]
              ],
              [
                ,
                ,
                "(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}",
                ,
                ,
                ,
                "28212345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}",
                ,
                ,
                ,
                "66123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "0800\\d{3}",
                ,
                ,
                ,
                "0800501",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "MO",
              853,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{4})(\\d{3})",
                "$1 $2",
                ["0"]
              ], [
                ,
                "(\\d{4})(\\d{4})",
                "$1 $2",
                ["[268]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MP: [
              ,
              [
                ,
                ,
                "[58]\\d{9}|(?:67|90)0\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
                ,
                ,
                ,
                "6702345678",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
                ,
                ,
                ,
                "6702345678",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
              ],
              [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "MP",
              1,
              "011",
              "1",
              ,
              ,
              "([2-9]\\d{6})$|1",
              "670$1",
              ,
              1,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "670",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MQ: [
              ,
              [
                ,
                ,
                "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "(?:596(?:[03-7]\\d|1[05]|2[7-9]|8[0-39]|9[04-9])|80[6-9]\\d\\d|9(?:477[6-9]|767[4589]))\\d{4}",
                ,
                ,
                ,
                "596301234"
              ],
              [
                ,
                ,
                "(?:69[67]\\d\\d|7091[0-3])\\d{4}",
                ,
                ,
                ,
                "696201234"
              ],
              [
                ,
                ,
                "80[0-5]\\d{6}",
                ,
                ,
                ,
                "800012345"
              ],
              [
                ,
                ,
                "8[129]\\d{7}",
                ,
                ,
                ,
                "810123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "9(?:397[0-3]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}",
                ,
                ,
                ,
                "976612345"
              ],
              "MQ",
              596,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[5-79]|8(?:0[6-9]|[36])"],
                "0$1"
              ], [
                ,
                "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["8"],
                "0$1"
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MR: [
              ,
              [
                ,
                ,
                "(?:[2-4]\\d\\d|800)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "(?:25[08]|35\\d|45[1-7])\\d{5}",
                ,
                ,
                ,
                "35123456"
              ],
              [
                ,
                ,
                "[2-4][0-46-9]\\d{6}",
                ,
                ,
                ,
                "22123456"
              ],
              [
                ,
                ,
                "800\\d{5}",
                ,
                ,
                ,
                "80012345"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "MR",
              222,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[2-48]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MS: [
              ,
              [
                ,
                ,
                "(?:[58]\\d\\d|664|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "6644(?:1[0-3]|91)\\d{4}",
                ,
                ,
                ,
                "6644912345",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "664(?:3(?:49|9[1-6])|49[2-6])\\d{4}",
                ,
                ,
                ,
                "6644923456",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
              ],
              [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "MS",
              1,
              "011",
              "1",
              ,
              ,
              "([34]\\d{6})$|1",
              "664$1",
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "664",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MT: [
              ,
              [
                ,
                ,
                "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}",
                ,
                ,
                ,
                "21001234"
              ],
              [
                ,
                ,
                "(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}",
                ,
                ,
                ,
                "96961234"
              ],
              [
                ,
                ,
                "800(?:02|[3467]\\d)\\d{3}",
                ,
                ,
                ,
                "80071234"
              ],
              [
                ,
                ,
                "5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}",
                ,
                ,
                ,
                "50037123"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "3550\\d{4}",
                ,
                ,
                ,
                "35501234"
              ],
              "MT",
              356,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{4})(\\d{4})",
                "$1 $2",
                ["[2357-9]"]
              ]],
              ,
              [
                ,
                ,
                "7117\\d{4}",
                ,
                ,
                ,
                "71171234"
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "501\\d{5}",
                ,
                ,
                ,
                "50112345"
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MU: [
              ,
              [
                ,
                ,
                "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  7,
                  8,
                  10
                ]
              ],
              [
                ,
                ,
                "(?:2(?:[0346-8]\\d|1[0-8])|4(?:[013568]\\d|2[4-8]|71|90)|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}",
                ,
                ,
                ,
                "54480123",
                ,
                ,
                [7, 8]
              ],
              [
                ,
                ,
                "5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-6]|3[013]))\\d{5}",
                ,
                ,
                ,
                "52512345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "802\\d{7}|80[0-2]\\d{4}",
                ,
                ,
                ,
                "8001234",
                ,
                ,
                [7, 10]
              ],
              [
                ,
                ,
                "30\\d{5}",
                ,
                ,
                ,
                "3012345",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "3(?:20|9\\d)\\d{4}",
                ,
                ,
                ,
                "3201234",
                ,
                ,
                [7]
              ],
              "MU",
              230,
              "0(?:0|[24-7]0|3[03])",
              ,
              ,
              ,
              ,
              ,
              "020",
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{4})",
                  "$1 $2",
                  ["[2-46]|8[013]"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{4})",
                  "$1 $2",
                  ["[57]"]
                ],
                [
                  ,
                  "(\\d{5})(\\d{5})",
                  "$1 $2",
                  ["8"]
                ]
              ],
              ,
              [
                ,
                ,
                "219\\d{4}",
                ,
                ,
                ,
                "2190123",
                ,
                ,
                [7]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MV: [
              ,
              [
                ,
                ,
                "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 10]
              ],
              [
                ,
                ,
                "(?:3(?:0[0-4]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}",
                ,
                ,
                ,
                "6701234",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "(?:46[46]|[79]\\d\\d)\\d{4}",
                ,
                ,
                ,
                "7712345",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "800\\d{7}",
                ,
                ,
                ,
                "8001234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "900\\d{7}",
                ,
                ,
                ,
                "9001234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "MV",
              960,
              "0(?:0|19)",
              ,
              ,
              ,
              ,
              ,
              "00",
              ,
              [[
                ,
                "(\\d{3})(\\d{4})",
                "$1-$2",
                ["[34679]"]
              ], [
                ,
                "(\\d{3})(\\d{3})(\\d{4})",
                "$1 $2 $3",
                ["[89]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "4(?:0[01]|50)\\d{4}",
                ,
                ,
                ,
                "4001234",
                ,
                ,
                [7]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MW: [
              ,
              [
                ,
                ,
                "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 9]
              ],
              [
                ,
                ,
                "(?:1[2-9]|2[12]\\d\\d)\\d{5}",
                ,
                ,
                ,
                "1234567"
              ],
              [
                ,
                ,
                "111\\d{6}|(?:31|77|[89][89])\\d{7}",
                ,
                ,
                ,
                "991234567",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "MW",
              265,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d)(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["1[2-9]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["2"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["[137-9]"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MX: [
              ,
              [
                ,
                ,
                "[2-9]\\d{9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7, 8]
              ],
              [
                ,
                ,
                "(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}",
                ,
                ,
                ,
                "2001234567",
                ,
                ,
                ,
                [7, 8]
              ],
              [
                ,
                ,
                "(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}",
                ,
                ,
                ,
                "2221234567",
                ,
                ,
                ,
                [7, 8]
              ],
              [
                ,
                ,
                "8(?:00|88)\\d{7}",
                ,
                ,
                ,
                "8001234567"
              ],
              [
                ,
                ,
                "900\\d{7}",
                ,
                ,
                ,
                "9001234567"
              ],
              [
                ,
                ,
                "300\\d{7}",
                ,
                ,
                ,
                "3001234567"
              ],
              [
                ,
                ,
                "500\\d{7}",
                ,
                ,
                ,
                "5001234567"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "MX",
              52,
              "0[09]",
              ,
              ,
              ,
              ,
              ,
              "00",
              ,
              [
                [
                  ,
                  "(\\d{5})",
                  "$1",
                  ["53"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["33|5[56]|81"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["[2-9]"]
                ]
              ],
              [[
                ,
                "(\\d{2})(\\d{4})(\\d{4})",
                "$1 $2 $3",
                ["33|5[56]|81"]
              ], [
                ,
                "(\\d{3})(\\d{3})(\\d{4})",
                "$1 $2 $3",
                ["[2-9]"]
              ]],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MY: [
              ,
              [
                ,
                ,
                "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  8,
                  9,
                  10
                ],
                [6, 7]
              ],
              [
                ,
                ,
                "427[01]\\d{4}|(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}",
                ,
                ,
                ,
                "323856789",
                ,
                ,
                [8, 9],
                [6, 7]
              ],
              [
                ,
                ,
                "1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}",
                ,
                ,
                ,
                "123456789",
                ,
                ,
                [9, 10]
              ],
              [
                ,
                ,
                "1[378]00\\d{6}",
                ,
                ,
                ,
                "1300123456",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "1600\\d{6}",
                ,
                ,
                ,
                "1600123456",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}",
                ,
                ,
                ,
                "1546012345",
                ,
                ,
                [10]
              ],
              "MY",
              60,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d)(\\d{3})(\\d{4})",
                  "$1-$2 $3",
                  ["[4-79]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3,4})",
                  "$1-$2 $3",
                  ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{4})(\\d{4})",
                  "$1-$2 $3",
                  ["3"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                  "$1-$2-$3-$4",
                  ["1(?:[367]|80)"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1-$2 $3",
                  ["15"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{4})",
                  "$1-$2 $3",
                  ["1"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MZ: [
              ,
              [
                ,
                ,
                "(?:2|8\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9]
              ],
              [
                ,
                ,
                "2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}",
                ,
                ,
                ,
                "21123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "8[2-79]\\d{7}",
                ,
                ,
                ,
                "821234567",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "800\\d{6}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "MZ",
              258,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{3})(\\d{3,4})",
                "$1 $2 $3",
                ["2|8[2-79]"]
              ], [
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["8"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            NA: [
              ,
              [
                ,
                ,
                "[68]\\d{7,8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9]
              ],
              [
                ,
                ,
                "64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}",
                ,
                ,
                ,
                "61221234"
              ],
              [
                ,
                ,
                "(?:60|8[1245])\\d{7}",
                ,
                ,
                ,
                "811234567",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "80\\d{7}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "8701\\d{5}",
                ,
                ,
                ,
                "870123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "8(?:3\\d\\d|86)\\d{5}",
                ,
                ,
                ,
                "88612345"
              ],
              "NA",
              264,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["88"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["6"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["87"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["8"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            NC: [
              ,
              [
                ,
                ,
                "(?:050|[2-57-9]\\d\\d)\\d{3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [6]
              ],
              [
                ,
                ,
                "(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}",
                ,
                ,
                ,
                "201234"
              ],
              [
                ,
                ,
                "(?:[579]\\d|8[0-79])\\d{4}",
                ,
                ,
                ,
                "751234"
              ],
              [
                ,
                ,
                "050\\d{3}",
                ,
                ,
                ,
                "050012"
              ],
              [
                ,
                ,
                "36\\d{4}",
                ,
                ,
                ,
                "366711"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "NC",
              687,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})",
                "$1",
                ["5[6-8]"]
              ], [
                ,
                "(\\d{2})(\\d{2})(\\d{2})",
                "$1.$2.$3",
                ["[02-57-9]"]
              ]],
              [[
                ,
                "(\\d{2})(\\d{2})(\\d{2})",
                "$1.$2.$3",
                ["[02-57-9]"]
              ]],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            NE: [
              ,
              [
                ,
                ,
                "[027-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}",
                ,
                ,
                ,
                "20201234"
              ],
              [
                ,
                ,
                "(?:23|7[0467]|[89]\\d)\\d{6}",
                ,
                ,
                ,
                "93123456"
              ],
              [
                ,
                ,
                "08\\d{6}",
                ,
                ,
                ,
                "08123456"
              ],
              [
                ,
                ,
                "09\\d{6}",
                ,
                ,
                ,
                "09123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "NE",
              227,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["08"]
              ], [
                ,
                "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[089]|2[013]|7[0467]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            NF: [
              ,
              [
                ,
                ,
                "[13]\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [6],
                [5]
              ],
              [
                ,
                ,
                "(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}",
                ,
                ,
                ,
                "106609",
                ,
                ,
                ,
                [5]
              ],
              [
                ,
                ,
                "(?:14|3[58])\\d{4}",
                ,
                ,
                ,
                "381234",
                ,
                ,
                ,
                [5]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "NF",
              672,
              "00",
              ,
              ,
              ,
              "([0-258]\\d{4})$",
              "3$1",
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{4})",
                "$1 $2",
                ["1[0-3]"]
              ], [
                ,
                "(\\d)(\\d{5})",
                "$1 $2",
                ["[13]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            NG: [
              ,
              [
                ,
                ,
                "(?:20|9\\d)\\d{8}|[78]\\d{9,13}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  10,
                  11,
                  12,
                  13,
                  14
                ],
                [6, 7]
              ],
              [
                ,
                ,
                "20(?:[1259]\\d|3[013-9]|4[1-8]|6[024-689]|7[1-79]|8[2-9])\\d{6}",
                ,
                ,
                ,
                "2033123456",
                ,
                ,
                [10],
                [6, 7]
              ],
              [
                ,
                ,
                "(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}",
                ,
                ,
                ,
                "8021234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "800\\d{7,11}",
                ,
                ,
                ,
                "80017591759"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "NG",
              234,
              "009",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["[7-9]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["20[129]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{2})(\\d{4})",
                  "$1 $2 $3",
                  ["2"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})(\\d{4,5})",
                  "$1 $2 $3",
                  ["[78]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{5})(\\d{5,6})",
                  "$1 $2 $3",
                  ["[78]"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "700\\d{7,11}",
                ,
                ,
                ,
                "7001234567"
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            NI: [
              ,
              [
                ,
                ,
                "(?:1800|[25-8]\\d{3})\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "2\\d{7}",
                ,
                ,
                ,
                "21234567"
              ],
              [
                ,
                ,
                "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}",
                ,
                ,
                ,
                "81234567"
              ],
              [
                ,
                ,
                "1800\\d{4}",
                ,
                ,
                ,
                "18001234"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "NI",
              505,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{4})(\\d{4})",
                "$1 $2",
                ["[125-8]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            NL: [
              ,
              [
                ,
                ,
                "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  5,
                  6,
                  7,
                  8,
                  9,
                  10,
                  11
                ]
              ],
              [
                ,
                ,
                "(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}",
                ,
                ,
                ,
                "101234567",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "(?:6[1-58]|970\\d)\\d{7}",
                ,
                ,
                ,
                "612345678",
                ,
                ,
                [9, 11]
              ],
              [
                ,
                ,
                "800\\d{4,7}",
                ,
                ,
                ,
                "8001234",
                ,
                ,
                [
                  7,
                  8,
                  9,
                  10
                ]
              ],
              [
                ,
                ,
                "90[069]\\d{4,7}",
                ,
                ,
                ,
                "9061234",
                ,
                ,
                [
                  7,
                  8,
                  9,
                  10
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:85|91)\\d{7}",
                ,
                ,
                ,
                "851234567",
                ,
                ,
                [9]
              ],
              "NL",
              31,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{4})",
                  "$1",
                  ["1[238]|[34]"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{3,4})",
                  "$1 $2",
                  ["14"]
                ],
                [
                  ,
                  "(\\d{6})",
                  "$1",
                  ["1"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{4,7})",
                  "$1 $2",
                  ["[89]0"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{7})",
                  "$1 $2",
                  ["66"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{8})",
                  "$1 $2",
                  ["6"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["[1-578]|91"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{5})",
                  "$1 $2 $3",
                  ["9"],
                  "0$1"
                ]
              ],
              [
                [
                  ,
                  "(\\d{3})(\\d{4,7})",
                  "$1 $2",
                  ["[89]0"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{7})",
                  "$1 $2",
                  ["66"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{8})",
                  "$1 $2",
                  ["6"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["[1-578]|91"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{5})",
                  "$1 $2 $3",
                  ["9"],
                  "0$1"
                ]
              ],
              [
                ,
                ,
                "66\\d{7}",
                ,
                ,
                ,
                "662345678",
                ,
                ,
                [9]
              ],
              ,
              ,
              [
                ,
                ,
                "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [5, 6]
              ],
              [
                ,
                ,
                "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d",
                ,
                ,
                ,
                "14020",
                ,
                ,
                [
                  5,
                  6,
                  9
                ]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            NO: [
              ,
              [
                ,
                ,
                "(?:0|[2-9]\\d{3})\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [5, 8]
              ],
              [
                ,
                ,
                "(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}",
                ,
                ,
                ,
                "21234567",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "(?:4[015-8]|9\\d)\\d{6}",
                ,
                ,
                ,
                "40612345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "80[01]\\d{5}",
                ,
                ,
                ,
                "80012345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "82[09]\\d{5}",
                ,
                ,
                ,
                "82012345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "810(?:0[0-6]|[2-8]\\d)\\d{3}",
                ,
                ,
                ,
                "81021234",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "880\\d{5}",
                ,
                ,
                ,
                "88012345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "85[0-5]\\d{5}",
                ,
                ,
                ,
                "85012345",
                ,
                ,
                [8]
              ],
              "NO",
              47,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{2})(\\d{3})",
                "$1 $2 $3",
                ["8"]
              ], [
                ,
                "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[2-79]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              1,
              "[02-689]|7[0-8]",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}",
                ,
                ,
                ,
                "02000"
              ],
              ,
              ,
              [
                ,
                ,
                "81[23]\\d{5}",
                ,
                ,
                ,
                "81212345",
                ,
                ,
                [8]
              ]
            ],
            NP: [
              ,
              [
                ,
                ,
                "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  8,
                  10,
                  11
                ],
                [6, 7]
              ],
              [
                ,
                ,
                "(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}",
                ,
                ,
                ,
                "14567890",
                ,
                ,
                [8],
                [6, 7]
              ],
              [
                ,
                ,
                "9(?:00|6[0-3]|7[0-24-6]|8[0-24-68])\\d{7}",
                ,
                ,
                ,
                "9841234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "1(?:66001|800\\d\\d)\\d{5}",
                ,
                ,
                ,
                "16600101234",
                ,
                ,
                [11]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "NP",
              977,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d)(\\d{7})",
                  "$1-$2",
                  ["1[2-6]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{6})",
                  "$1-$2",
                  ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{7})",
                  "$1-$2",
                  ["9"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{2})(\\d{5})",
                  "$1-$2-$3",
                  ["1"]
                ]
              ],
              [
                [
                  ,
                  "(\\d)(\\d{7})",
                  "$1-$2",
                  ["1[2-6]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{6})",
                  "$1-$2",
                  ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{7})",
                  "$1-$2",
                  ["9"]
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            NR: [
              ,
              [
                ,
                ,
                "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "444\\d{4}",
                ,
                ,
                ,
                "4441234"
              ],
              [
                ,
                ,
                "(?:222|55[3-9]|666|777|8\\d\\d|999)\\d{4}",
                ,
                ,
                ,
                "5551234"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "NR",
              674,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{4})",
                "$1 $2",
                ["[24-9]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            NU: [
              ,
              [
                ,
                ,
                "(?:[4-7]|888\\d)\\d{3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [4, 7]
              ],
              [
                ,
                ,
                "[47]\\d{3}",
                ,
                ,
                ,
                "7012",
                ,
                ,
                [4]
              ],
              [
                ,
                ,
                "(?:[56]|888[1-9])\\d{3}",
                ,
                ,
                ,
                "8884012"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "NU",
              683,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{4})",
                "$1 $2",
                ["8"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            NZ: [
              ,
              [
                ,
                ,
                "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  5,
                  6,
                  7,
                  8,
                  9,
                  10
                ]
              ],
              [
                ,
                ,
                "240\\d{5}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}",
                ,
                ,
                ,
                "32345678",
                ,
                ,
                [8],
                [7]
              ],
              [
                ,
                ,
                "2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}",
                ,
                ,
                ,
                "211234567",
                ,
                ,
                [
                  8,
                  9,
                  10
                ]
              ],
              [
                ,
                ,
                "508\\d{6,7}|80\\d{6,8}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [
                  8,
                  9,
                  10
                ]
              ],
              [
                ,
                ,
                "(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}",
                ,
                ,
                ,
                "900123456",
                ,
                ,
                [
                  7,
                  8,
                  9,
                  10
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "70\\d{7}",
                ,
                ,
                ,
                "701234567",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "NZ",
              64,
              "0(?:0|161)",
              "0",
              ,
              ,
              "0",
              ,
              "00",
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{3,8})",
                  "$1 $2",
                  ["8[1-79]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{2,3})",
                  "$1 $2 $3",
                  ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["24|[346]|7[2-57-9]|9[2-9]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["2(?:10|74)|[589]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3,4})(\\d{4})",
                  "$1 $2 $3",
                  ["1|2[028]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3,5})",
                  "$1 $2 $3",
                  ["2(?:[169]|7[0-35-9])|7"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}",
                ,
                ,
                ,
                "83012378"
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            OM: [
              ,
              [
                ,
                ,
                "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  7,
                  8,
                  9
                ]
              ],
              [
                ,
                ,
                "2[1-6]\\d{6}",
                ,
                ,
                ,
                "23123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "1505\\d{4}|(?:7(?:[125-9]\\d|41)|9(?:0[1-9]|[1-9]\\d))\\d{5}",
                ,
                ,
                ,
                "92123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "8007\\d{4,5}|(?:500|800[05])\\d{4}",
                ,
                ,
                ,
                "80071234"
              ],
              [
                ,
                ,
                "900\\d{5}",
                ,
                ,
                ,
                "90012345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "OM",
              968,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{4,6})",
                  "$1 $2",
                  ["[58]"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{6})",
                  "$1 $2",
                  ["2"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{4})",
                  "$1 $2",
                  ["[179]"]
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            PA: [
              ,
              [
                ,
                ,
                "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  7,
                  8,
                  10,
                  11
                ]
              ],
              [
                ,
                ,
                "(?:1(?:0\\d|1[0479]|2[37]|3[0137]|4[17]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[047-9]\\d|1[0-8]|2[0-5]|33|5[0-35]|6[068])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[4-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}",
                ,
                ,
                ,
                "2001234",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}",
                ,
                ,
                ,
                "61234567",
                ,
                ,
                [7, 8]
              ],
              [
                ,
                ,
                "800\\d{4,5}|(?:00800|800\\d)\\d{6}",
                ,
                ,
                ,
                "8001234"
              ],
              [
                ,
                ,
                "(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}",
                ,
                ,
                ,
                "8601234",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "PA",
              507,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{4})",
                  "$1-$2",
                  ["[1-57-9]"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{4})",
                  "$1-$2",
                  ["[68]"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["8"]
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            PE: [
              ,
              [
                ,
                ,
                "(?:[14-8]|9\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9],
                [6, 7]
              ],
              [
                ,
                ,
                "(?:(?:(?:4[34]|5[14])[0-8]|687)\\d|7(?:173|(?:3[0-8]|55)\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[0569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}",
                ,
                ,
                ,
                "11234567",
                ,
                ,
                [8],
                [6, 7]
              ],
              [
                ,
                ,
                "9\\d{8}",
                ,
                ,
                ,
                "912345678",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "800\\d{5}",
                ,
                ,
                ,
                "80012345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "805\\d{5}",
                ,
                ,
                ,
                "80512345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "801\\d{5}",
                ,
                ,
                ,
                "80112345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "80[24]\\d{5}",
                ,
                ,
                ,
                "80212345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "PE",
              51,
              "00|19(?:1[124]|77|90)00",
              "0",
              " Anexo ",
              ,
              "0",
              ,
              "00",
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{5})",
                  "$1 $2",
                  ["80"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d)(\\d{7})",
                  "$1 $2",
                  ["1"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{2})(\\d{6})",
                  "$1 $2",
                  ["[4-8]"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["9"]
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            PF: [
              ,
              [
                ,
                ,
                "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  6,
                  8,
                  9
                ]
              ],
              [
                ,
                ,
                "4(?:0[4-689]|9[4-68])\\d{5}",
                ,
                ,
                ,
                "40412345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "8[7-9]\\d{6}",
                ,
                ,
                ,
                "87123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "80[0-5]\\d{6}",
                ,
                ,
                ,
                "800012345",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "499\\d{5}",
                ,
                ,
                ,
                "49901234",
                ,
                ,
                [8]
              ],
              "PF",
              689,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3",
                  ["44"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["4|8[7-9]"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["8"]
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "44\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [6]
              ],
              [
                ,
                ,
                "44\\d{4}",
                ,
                ,
                ,
                "440123",
                ,
                ,
                [6]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            PG: [
              ,
              [
                ,
                ,
                "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 8]
              ],
              [
                ,
                ,
                "(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}",
                ,
                ,
                ,
                "3123456",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "(?:7\\d|8[1-48])\\d{6}",
                ,
                ,
                ,
                "70123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "180\\d{4}",
                ,
                ,
                ,
                "1801234",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "2(?:0[0-57]|7[568])\\d{4}",
                ,
                ,
                ,
                "2751234",
                ,
                ,
                [7]
              ],
              "PG",
              675,
              "00|140[1-3]",
              ,
              ,
              ,
              ,
              ,
              "00",
              ,
              [[
                ,
                "(\\d{3})(\\d{4})",
                "$1 $2",
                ["18|[2-69]|85"]
              ], [
                ,
                "(\\d{4})(\\d{4})",
                "$1 $2",
                ["[78]"]
              ]],
              ,
              [
                ,
                ,
                "27[01]\\d{4}",
                ,
                ,
                ,
                "2700123",
                ,
                ,
                [7]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            PH: [
              ,
              [
                ,
                ,
                "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  6,
                  8,
                  9,
                  10,
                  11,
                  12,
                  13
                ],
                [
                  4,
                  5,
                  7
                ]
              ],
              [
                ,
                ,
                "(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}",
                ,
                ,
                ,
                "232345678",
                ,
                ,
                [
                  6,
                  8,
                  9,
                  10
                ],
                [
                  4,
                  5,
                  7
                ]
              ],
              [
                ,
                ,
                "(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}",
                ,
                ,
                ,
                "9051234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "1800\\d{7,9}",
                ,
                ,
                ,
                "180012345678",
                ,
                ,
                [
                  11,
                  12,
                  13
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "PH",
              63,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d)(\\d{5})",
                  "$1 $2",
                  ["2"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{4})(\\d{4,6})",
                  "$1 $2",
                  ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{5})(\\d{4})",
                  "$1 $2",
                  ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d)(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["2"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["[3-7]|8[2-8]"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["[89]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["1"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                  "$1 $2 $3 $4",
                  ["1"]
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            PK: [
              ,
              [
                ,
                ,
                "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  8,
                  9,
                  10,
                  11,
                  12
                ],
                [
                  5,
                  6,
                  7
                ]
              ],
              [
                ,
                ,
                "(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}",
                ,
                ,
                ,
                "2123456789",
                ,
                ,
                [9, 10],
                [
                  5,
                  6,
                  7,
                  8
                ]
              ],
              [
                ,
                ,
                "3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}",
                ,
                ,
                ,
                "3012345678",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "800\\d{5}(?:\\d{3})?",
                ,
                ,
                ,
                "80012345",
                ,
                ,
                [8, 11]
              ],
              [
                ,
                ,
                "900\\d{5}",
                ,
                ,
                ,
                "90012345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "122\\d{6}",
                ,
                ,
                ,
                "122044444",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "PK",
              92,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{2,7})",
                  "$1 $2 $3",
                  ["[89]0"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{5})",
                  "$1 $2",
                  ["1"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{6,7})",
                  "$1 $2",
                  ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{2})(\\d{7,8})",
                  "$1 $2",
                  ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{5})(\\d{5})",
                  "$1 $2",
                  ["58"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{3})(\\d{7})",
                  "$1 $2",
                  ["3"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3 $4",
                  ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3 $4",
                  ["[24-9]"],
                  "(0$1)"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",
                ,
                ,
                ,
                "21111825888",
                ,
                ,
                [11, 12]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            PL: [
              ,
              [
                ,
                ,
                "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  6,
                  7,
                  8,
                  9,
                  10
                ]
              ],
              [
                ,
                ,
                "47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))",
                ,
                ,
                ,
                "123456789",
                ,
                ,
                [7, 9]
              ],
              [
                ,
                ,
                "2131[89]\\d{4}|21(?:1[013-5]|2\\d|3[2-9])\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}",
                ,
                ,
                ,
                "512345678",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "800\\d{6,7}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [9, 10]
              ],
              [
                ,
                ,
                "70[01346-8]\\d{6}",
                ,
                ,
                ,
                "701234567",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "801\\d{6}",
                ,
                ,
                ,
                "801234567",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "39\\d{7}",
                ,
                ,
                ,
                "391234567",
                ,
                ,
                [9]
              ],
              "PL",
              48,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{5})",
                  "$1",
                  ["19"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})",
                  "$1 $2",
                  ["11|20|64"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{3})",
                  "$1 $2 $3",
                  ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{2,3})",
                  "$1 $2 $3",
                  ["64"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["1[2-8]|[2-7]|8[1-79]|9[145]"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["8"]
                ]
              ],
              ,
              [
                ,
                ,
                "64\\d{4,7}",
                ,
                ,
                ,
                "641234567",
                ,
                ,
                [
                  6,
                  7,
                  8,
                  9
                ]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "804\\d{6}",
                ,
                ,
                ,
                "804123456",
                ,
                ,
                [9]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            PM: [
              ,
              [
                ,
                ,
                "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [6, 9]
              ],
              [
                ,
                ,
                "(?:4[1-35-9]|5[0-47-9]|80[6-9]\\d\\d)\\d{4}",
                ,
                ,
                ,
                "430123"
              ],
              [
                ,
                ,
                "(?:4[02-489]|5[02-9]|708(?:4[0-5]|5[0-6]))\\d{4}",
                ,
                ,
                ,
                "551234"
              ],
              [
                ,
                ,
                "80[0-5]\\d{6}",
                ,
                ,
                ,
                "800012345",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "8[129]\\d{7}",
                ,
                ,
                ,
                "810123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "PM",
              508,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3",
                  ["[45]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["7"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["8"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            PR: [
              ,
              [
                ,
                ,
                "(?:[589]\\d\\d|787)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "(?:787|939)[2-9]\\d{6}",
                ,
                ,
                ,
                "7872345678",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "(?:787|939)[2-9]\\d{6}",
                ,
                ,
                ,
                "7872345678",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002345678"
              ],
              [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "PR",
              1,
              "011",
              "1",
              ,
              ,
              "1",
              ,
              ,
              1,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "787|939",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            PS: [
              ,
              [
                ,
                ,
                "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  8,
                  9,
                  10
                ],
                [7]
              ],
              [
                ,
                ,
                "(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}",
                ,
                ,
                ,
                "22234567",
                ,
                ,
                [8],
                [7]
              ],
              [
                ,
                ,
                "5[69]\\d{7}",
                ,
                ,
                ,
                "599123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "1800\\d{6}",
                ,
                ,
                ,
                "1800123456",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "1700\\d{6}",
                ,
                ,
                ,
                "1700123456",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "PS",
              970,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d)(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["[2489]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["5"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["1"]
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            PT: [
              ,
              [
                ,
                ,
                "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}",
                ,
                ,
                ,
                "212345678"
              ],
              [
                ,
                ,
                "6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}",
                ,
                ,
                ,
                "912345678"
              ],
              [
                ,
                ,
                "80[02]\\d{6}",
                ,
                ,
                ,
                "800123456"
              ],
              [
                ,
                ,
                "(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}",
                ,
                ,
                ,
                "760123456"
              ],
              [
                ,
                ,
                "80(?:8\\d|9[1579])\\d{5}",
                ,
                ,
                ,
                "808123456"
              ],
              [
                ,
                ,
                "884[0-4689]\\d{5}",
                ,
                ,
                ,
                "884123456"
              ],
              [
                ,
                ,
                "30\\d{7}",
                ,
                ,
                ,
                "301234567"
              ],
              "PT",
              351,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{3})(\\d{4})",
                "$1 $2 $3",
                ["2[12]"]
              ], [
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["16|[236-9]"]
              ]],
              ,
              [
                ,
                ,
                "6(?:222\\d|89(?:00|88|99))\\d{4}",
                ,
                ,
                ,
                "622212345"
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}",
                ,
                ,
                ,
                "707123456"
              ],
              ,
              ,
              [
                ,
                ,
                "600\\d{6}|6[06]92(?:0\\d|3[349]|49)\\d{3}",
                ,
                ,
                ,
                "600110000"
              ]
            ],
            PW: [
              ,
              [
                ,
                ,
                "(?:[24-8]\\d\\d|345|900)\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}",
                ,
                ,
                ,
                "2771234"
              ],
              [
                ,
                ,
                "(?:(?:46|83)[0-5]|(?:6[2-4689]|78)0)\\d{4}|(?:45|77|88)\\d{5}",
                ,
                ,
                ,
                "6201234"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "PW",
              680,
              "01[12]",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{4})",
                "$1 $2",
                ["[2-9]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            PY: [
              ,
              [
                ,
                ,
                "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  6,
                  7,
                  8,
                  9,
                  10,
                  11
                ],
                [5]
              ],
              [
                ,
                ,
                "(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}",
                ,
                ,
                ,
                "212345678",
                ,
                ,
                [
                  7,
                  8,
                  9
                ],
                [5, 6]
              ],
              [
                ,
                ,
                "9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}",
                ,
                ,
                ,
                "961456789",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "9800\\d{5,7}",
                ,
                ,
                ,
                "98000123456",
                ,
                ,
                [
                  9,
                  10,
                  11
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "8700[0-4]\\d{4}",
                ,
                ,
                ,
                "870012345",
                ,
                ,
                [9]
              ],
              "PY",
              595,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{3,6})",
                  "$1 $2",
                  ["[2-9]0"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{5})",
                  "$1 $2",
                  ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{3})(\\d{4,5})",
                  "$1 $2",
                  ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["87"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{6})",
                  "$1 $2",
                  ["9(?:[5-79]|8[1-7])"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["[2-8]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["9"]
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "[2-9]0\\d{4,7}",
                ,
                ,
                ,
                "201234567",
                ,
                ,
                [
                  6,
                  7,
                  8,
                  9
                ]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            QA: [
              ,
              [
                ,
                ,
                "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  7,
                  8,
                  9,
                  11
                ]
              ],
              [
                ,
                ,
                "4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}",
                ,
                ,
                ,
                "44123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "[35-7]\\d{7}",
                ,
                ,
                ,
                "33123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "800\\d{4}|(?:0080[01]|800)\\d{6}",
                ,
                ,
                ,
                "8001234",
                ,
                ,
                [
                  7,
                  9,
                  11
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "QA",
              974,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{4})",
                "$1 $2",
                ["2[136]|8"]
              ], [
                ,
                "(\\d{4})(\\d{4})",
                "$1 $2",
                ["[3-7]"]
              ]],
              ,
              [
                ,
                ,
                "2[136]\\d{5}",
                ,
                ,
                ,
                "2123456",
                ,
                ,
                [7]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            RE: [
              ,
              [
                ,
                ,
                "709\\d{6}|(?:26|[689]\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}",
                ,
                ,
                ,
                "262161234"
              ],
              [
                ,
                ,
                "(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}",
                ,
                ,
                ,
                "692123456"
              ],
              [
                ,
                ,
                "80\\d{7}",
                ,
                ,
                ,
                "801234567"
              ],
              [
                ,
                ,
                "89[1-37-9]\\d{6}",
                ,
                ,
                ,
                "891123456"
              ],
              [
                ,
                ,
                "8(?:1[019]|2[0156]|84|90)\\d{6}",
                ,
                ,
                ,
                "810123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}",
                ,
                ,
                ,
                "939901234"
              ],
              "RE",
              262,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[26-9]"],
                "0$1"
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              1,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            RO: [
              ,
              [
                ,
                ,
                "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [6, 9]
              ],
              [
                ,
                ,
                "[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d",
                ,
                ,
                ,
                "211234567"
              ],
              [
                ,
                ,
                "(?:630|702)0\\d{5}|(?:6(?:00|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}",
                ,
                ,
                ,
                "712034567",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "800\\d{6}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "90[0136]\\d{6}",
                ,
                ,
                ,
                "900123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "801\\d{6}",
                ,
                ,
                ,
                "801123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "RO",
              40,
              "00",
              "0",
              " int ",
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{3})",
                  "$1 $2",
                  ["2[3-6]", "2[3-6]\\d9"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})",
                  "$1 $2",
                  ["219|31"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["[23]1"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["[236-9]"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:37\\d|80[578])\\d{6}",
                ,
                ,
                ,
                "372123456",
                ,
                ,
                [9]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            RS: [
              ,
              [
                ,
                ,
                "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  6,
                  7,
                  8,
                  9,
                  10,
                  11,
                  12
                ],
                [4, 5]
              ],
              [
                ,
                ,
                "(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}",
                ,
                ,
                ,
                "10234567",
                ,
                ,
                [
                  7,
                  8,
                  9,
                  10,
                  11,
                  12
                ],
                [
                  4,
                  5,
                  6
                ]
              ],
              [
                ,
                ,
                "6(?:[0-689]|7\\d)\\d{6,7}",
                ,
                ,
                ,
                "601234567",
                ,
                ,
                [
                  8,
                  9,
                  10
                ]
              ],
              [
                ,
                ,
                "800\\d{3,9}",
                ,
                ,
                ,
                "80012345"
              ],
              [
                ,
                ,
                "(?:78\\d|90[0169])\\d{3,7}",
                ,
                ,
                ,
                "90012345",
                ,
                ,
                [
                  6,
                  7,
                  8,
                  9,
                  10
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "RS",
              381,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{3,9})",
                "$1 $2",
                ["(?:2[389]|39)0|[7-9]"],
                "0$1"
              ], [
                ,
                "(\\d{2})(\\d{5,10})",
                "$1 $2",
                ["[1-36]"],
                "0$1"
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "7[06]\\d{4,10}",
                ,
                ,
                ,
                "700123456"
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            RU: [
              ,
              [
                ,
                ,
                "8\\d{13}|[347-9]\\d{9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10, 14],
                [7]
              ],
              [
                ,
                ,
                "336(?:[013-9]\\d|2[013-9])\\d{5}|(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15-7]|6[0-35-79]|7[1-37-9]))\\d{7}",
                ,
                ,
                ,
                "3011234567",
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "9\\d{9}",
                ,
                ,
                ,
                "9123456789",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "8(?:0[04]|108\\d{3})\\d{7}",
                ,
                ,
                ,
                "8001234567"
              ],
              [
                ,
                ,
                "80[39]\\d{7}",
                ,
                ,
                ,
                "8091234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "808\\d{7}",
                ,
                ,
                ,
                "8081234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "RU",
              7,
              "810",
              "8",
              ,
              ,
              "8",
              ,
              "8~10",
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{2})",
                  "$1-$2-$3",
                  ["[0-79]"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  [
                    "7(?:1[0-8]|2[1-9])",
                    "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                    "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                  ],
                  "8 ($1)",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  [
                    "7(?:1[0-68]|2[1-9])",
                    "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                    "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                  ],
                  "8 ($1)",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["7"],
                  "8 ($1)",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                  "$1 $2-$3-$4",
                  ["[349]|8(?:[02-7]|1[1-8])"],
                  "8 ($1)",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                  "$1 $2 $3 $4",
                  ["8"],
                  "8 ($1)"
                ]
              ],
              [
                [
                  ,
                  "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  [
                    "7(?:1[0-8]|2[1-9])",
                    "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                    "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                  ],
                  "8 ($1)",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  [
                    "7(?:1[0-68]|2[1-9])",
                    "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                    "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                  ],
                  "8 ($1)",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["7"],
                  "8 ($1)",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                  "$1 $2-$3-$4",
                  ["[349]|8(?:[02-7]|1[1-8])"],
                  "8 ($1)",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                  "$1 $2 $3 $4",
                  ["8"],
                  "8 ($1)"
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              1,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            RW: [
              ,
              [
                ,
                ,
                "(?:06|[27]\\d\\d|[89]00)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9]
              ],
              [
                ,
                ,
                "(?:06|2[23568]\\d)\\d{6}",
                ,
                ,
                ,
                "250123456"
              ],
              [
                ,
                ,
                "7[237-9]\\d{7}",
                ,
                ,
                ,
                "720123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "800\\d{6}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "900\\d{6}",
                ,
                ,
                ,
                "900123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "RW",
              250,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["0"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["2"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["[7-9]"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SA: [
              ,
              [
                ,
                ,
                "(?:[15]\\d|800|92)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9, 10],
                [7]
              ],
              [
                ,
                ,
                "1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}",
                ,
                ,
                ,
                "112345678",
                ,
                ,
                [9],
                [7]
              ],
              [
                ,
                ,
                "579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}",
                ,
                ,
                ,
                "512345678",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "800\\d{7}",
                ,
                ,
                ,
                "8001234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "925\\d{6}",
                ,
                ,
                ,
                "925012345",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "920\\d{6}",
                ,
                ,
                ,
                "920012345",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "SA",
              966,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{4})(\\d{5})",
                  "$1 $2",
                  ["9"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["1"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["5"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["8"]
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SB: [
              ,
              [
                ,
                ,
                "[6-9]\\d{6}|[1-6]\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [5, 7]
              ],
              [
                ,
                ,
                "(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}",
                ,
                ,
                ,
                "40123",
                ,
                ,
                [5]
              ],
              [
                ,
                ,
                "48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}",
                ,
                ,
                ,
                "7421234"
              ],
              [
                ,
                ,
                "1[38]\\d{3}",
                ,
                ,
                ,
                "18123",
                ,
                ,
                [5]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "5[12]\\d{3}",
                ,
                ,
                ,
                "51123",
                ,
                ,
                [5]
              ],
              "SB",
              677,
              "0[01]",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{5})",
                "$1 $2",
                ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SC: [
              ,
              [
                ,
                ,
                "(?:[2489]\\d|64)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "4[2-46]\\d{5}",
                ,
                ,
                ,
                "4217123"
              ],
              [
                ,
                ,
                "2[125-8]\\d{5}",
                ,
                ,
                ,
                "2510123"
              ],
              [
                ,
                ,
                "800[08]\\d{3}",
                ,
                ,
                ,
                "8000000"
              ],
              [
                ,
                ,
                "85\\d{5}",
                ,
                ,
                ,
                "8512345"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "971\\d{4}|(?:64|95)\\d{5}",
                ,
                ,
                ,
                "6412345"
              ],
              "SC",
              248,
              "010|0[0-2]",
              ,
              ,
              ,
              ,
              ,
              "00",
              ,
              [[
                ,
                "(\\d)(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[246]|9[57]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SD: [
              ,
              [
                ,
                ,
                "[19]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "1(?:5\\d|8[35-7])\\d{6}",
                ,
                ,
                ,
                "153123456"
              ],
              [
                ,
                ,
                "(?:1[0-2]|9[0-3569])\\d{7}",
                ,
                ,
                ,
                "911231234"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "SD",
              249,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{3})(\\d{4})",
                "$1 $2 $3",
                ["[19]"],
                "0$1"
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SE: [
              ,
              [
                ,
                ,
                "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  6,
                  7,
                  8,
                  9,
                  10,
                  12
                ]
              ],
              [
                ,
                ,
                "(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}",
                ,
                ,
                ,
                "8123456",
                ,
                ,
                [
                  7,
                  8,
                  9
                ]
              ],
              [
                ,
                ,
                "7[02369]\\d{7}",
                ,
                ,
                ,
                "701234567",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "20\\d{4,7}",
                ,
                ,
                ,
                "20123456",
                ,
                ,
                [
                  6,
                  7,
                  8,
                  9
                ]
              ],
              [
                ,
                ,
                "649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}",
                ,
                ,
                ,
                "9001234567",
                ,
                ,
                [
                  7,
                  8,
                  9,
                  10
                ]
              ],
              [
                ,
                ,
                "77[0-7]\\d{6}",
                ,
                ,
                ,
                "771234567",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "75[1-8]\\d{6}",
                ,
                ,
                ,
                "751234567",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "SE",
              46,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{2,3})(\\d{2})",
                  "$1-$2 $3",
                  ["20"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})",
                  "$1-$2",
                  ["9(?:00|39|44|9)"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{2})",
                  "$1-$2 $3",
                  ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                  "$1-$2 $3 $4",
                  ["8"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2,3})(\\d{2})",
                  "$1-$2 $3",
                  ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2,3})(\\d{3})",
                  "$1-$2 $3",
                  ["9(?:00|39|44)"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                  "$1-$2 $3 $4",
                  ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                  "$1-$2 $3 $4",
                  ["10|7"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                  "$1-$2 $3 $4",
                  ["8"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                  "$1-$2 $3 $4",
                  ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                  "$1-$2 $3 $4",
                  ["9"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                  "$1-$2 $3 $4 $5",
                  ["[26]"],
                  "0$1"
                ]
              ],
              [
                [
                  ,
                  "(\\d{2})(\\d{2,3})(\\d{2})",
                  "$1 $2 $3",
                  ["20"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})",
                  "$1 $2",
                  ["9(?:00|39|44|9)"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{2})",
                  "$1 $2 $3",
                  ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"]
                ],
                [
                  ,
                  "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["8"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{2,3})(\\d{2})",
                  "$1 $2 $3",
                  ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{2,3})(\\d{3})",
                  "$1 $2 $3",
                  ["9(?:00|39|44)"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["10|7"]
                ],
                [
                  ,
                  "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["8"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                  "$1 $2 $3 $4",
                  ["9"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4 $5",
                  ["[26]"]
                ]
              ],
              [
                ,
                ,
                "74[02-9]\\d{6}",
                ,
                ,
                ,
                "740123456",
                ,
                ,
                [9]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "10[1-8]\\d{6}",
                ,
                ,
                ,
                "102345678",
                ,
                ,
                [9]
              ],
              ,
              ,
              [
                ,
                ,
                "(?:25[245]|67[3-68])\\d{9}",
                ,
                ,
                ,
                "254123456789",
                ,
                ,
                [12]
              ]
            ],
            SG: [
              ,
              [
                ,
                ,
                "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  8,
                  10,
                  11
                ]
              ],
              [
                ,
                ,
                "662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}",
                ,
                ,
                ,
                "61234567",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "898[02-8]\\d{4}|(?:8(?:0[1-9]|[1-8]\\d|9[0-7])|9[0-8]\\d)\\d{5}",
                ,
                ,
                ,
                "81234567",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "(?:18|8)00\\d{7}",
                ,
                ,
                ,
                "18001234567",
                ,
                ,
                [10, 11]
              ],
              [
                ,
                ,
                "1900\\d{7}",
                ,
                ,
                ,
                "19001234567",
                ,
                ,
                [11]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:3[12]\\d|666)\\d{5}",
                ,
                ,
                ,
                "31234567",
                ,
                ,
                [8]
              ],
              "SG",
              65,
              "0[0-3]\\d",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{4,5})",
                  "$1",
                  ["1[013-9]|77", "1(?:[013-8]|9(?:0[1-9]|[1-9]))|77"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{4})",
                  "$1 $2",
                  ["[369]|8(?:0[1-9]|[1-9])"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["8"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{4})(\\d{3})",
                  "$1 $2 $3",
                  ["7"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["1"]
                ]
              ],
              [
                [
                  ,
                  "(\\d{4})(\\d{4})",
                  "$1 $2",
                  ["[369]|8(?:0[1-9]|[1-9])"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["8"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{4})(\\d{3})",
                  "$1 $2 $3",
                  ["7"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["1"]
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "7000\\d{7}",
                ,
                ,
                ,
                "70001234567",
                ,
                ,
                [11]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SH: [
              ,
              [
                ,
                ,
                "(?:[256]\\d|8)\\d{3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [4, 5]
              ],
              [
                ,
                ,
                "2(?:[0-57-9]\\d|6[4-9])\\d\\d",
                ,
                ,
                ,
                "22158"
              ],
              [
                ,
                ,
                "[56]\\d{4}",
                ,
                ,
                ,
                "51234",
                ,
                ,
                [5]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "262\\d\\d",
                ,
                ,
                ,
                "26212",
                ,
                ,
                [5]
              ],
              "SH",
              290,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              1,
              "[256]",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SI: [
              ,
              [
                ,
                ,
                "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  5,
                  6,
                  7,
                  8
                ]
              ],
              [
                ,
                ,
                "(?:[1-357][2-8]|4[24-8])\\d{6}",
                ,
                ,
                ,
                "12345678",
                ,
                ,
                [8],
                [7]
              ],
              [
                ,
                ,
                "65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}",
                ,
                ,
                ,
                "31234567",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "80\\d{4,6}",
                ,
                ,
                ,
                "80123456",
                ,
                ,
                [
                  6,
                  7,
                  8
                ]
              ],
              [
                ,
                ,
                "89[1-3]\\d{2,5}|90\\d{4,6}",
                ,
                ,
                ,
                "90123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}",
                ,
                ,
                ,
                "59012345",
                ,
                ,
                [8]
              ],
              "SI",
              386,
              "00|10(?:22|66|88|99)",
              "0",
              ,
              ,
              "0",
              ,
              "00",
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{3,6})",
                  "$1 $2",
                  ["8[09]|9"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{5})",
                  "$1 $2",
                  ["59|8"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["[37][01]|4[0139]|51|6"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["[1-57]"],
                  "(0$1)"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SJ: [
              ,
              [
                ,
                ,
                "0\\d{4}|(?:[489]\\d|79)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [5, 8]
              ],
              [
                ,
                ,
                "79\\d{6}",
                ,
                ,
                ,
                "79123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "(?:4[015-8]|9\\d)\\d{6}",
                ,
                ,
                ,
                "41234567",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "80[01]\\d{5}",
                ,
                ,
                ,
                "80012345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "82[09]\\d{5}",
                ,
                ,
                ,
                "82012345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "810(?:0[0-6]|[2-8]\\d)\\d{3}",
                ,
                ,
                ,
                "81021234",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "880\\d{5}",
                ,
                ,
                ,
                "88012345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "85[0-5]\\d{5}",
                ,
                ,
                ,
                "85012345",
                ,
                ,
                [8]
              ],
              "SJ",
              47,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "79",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}",
                ,
                ,
                ,
                "02000"
              ],
              ,
              ,
              [
                ,
                ,
                "81[23]\\d{5}",
                ,
                ,
                ,
                "81212345",
                ,
                ,
                [8]
              ]
            ],
            SK: [
              ,
              [
                ,
                ,
                "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  6,
                  7,
                  9
                ]
              ],
              [
                ,
                ,
                "(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d",
                ,
                ,
                ,
                "221234567"
              ],
              [
                ,
                ,
                "909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}",
                ,
                ,
                ,
                "912123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "800\\d{6}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "9(?:00|[78]\\d)\\d{6}",
                ,
                ,
                ,
                "900123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "8[5-9]\\d{7}",
                ,
                ,
                ,
                "850123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "6(?:02|5[0-4]|9[0-6])\\d{6}",
                ,
                ,
                ,
                "690123456",
                ,
                ,
                [9]
              ],
              "SK",
              421,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d)(\\d{2})(\\d{3,4})",
                  "$1 $2 $3",
                  ["21"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{2,3})",
                  "$1 $2 $3",
                  ["[3-5][1-8]1", "[3-5][1-8]1[67]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})",
                  "$1 $2",
                  ["909", "9090"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                  "$1/$2 $3 $4",
                  ["2"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["[689]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                  "$1/$2 $3 $4",
                  ["[3-5]"],
                  "0$1"
                ]
              ],
              [
                [
                  ,
                  "(\\d)(\\d{2})(\\d{3,4})",
                  "$1 $2 $3",
                  ["21"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{2,3})",
                  "$1 $2 $3",
                  ["[3-5][1-8]1", "[3-5][1-8]1[67]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                  "$1/$2 $3 $4",
                  ["2"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["[689]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                  "$1/$2 $3 $4",
                  ["[3-5]"],
                  "0$1"
                ]
              ],
              [
                ,
                ,
                "9090\\d{3}",
                ,
                ,
                ,
                "9090123",
                ,
                ,
                [7]
              ],
              ,
              ,
              [
                ,
                ,
                "9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 9]
              ],
              [
                ,
                ,
                "96\\d{7}",
                ,
                ,
                ,
                "961234567",
                ,
                ,
                [9]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SL: [
              ,
              [
                ,
                ,
                "(?:[237-9]\\d|66)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8],
                [6]
              ],
              [
                ,
                ,
                "22[2-4][2-9]\\d{4}",
                ,
                ,
                ,
                "22221234",
                ,
                ,
                ,
                [6]
              ],
              [
                ,
                ,
                "(?:25|3[0-5]|66|7[1-9]|8[08]|9[09])\\d{6}",
                ,
                ,
                ,
                "25123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "SL",
              232,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{6})",
                "$1 $2",
                ["[236-9]"],
                "(0$1)"
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SM: [
              ,
              [
                ,
                ,
                "(?:0549|[5-7]\\d)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 10],
                [6]
              ],
              [
                ,
                ,
                "0549(?:8[0157-9]|9\\d)\\d{4}",
                ,
                ,
                ,
                "0549886377",
                ,
                ,
                [10],
                [6]
              ],
              [
                ,
                ,
                "6[16]\\d{6}",
                ,
                ,
                ,
                "66661212",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "7[178]\\d{6}",
                ,
                ,
                ,
                "71123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "5[158]\\d{6}",
                ,
                ,
                ,
                "58001110",
                ,
                ,
                [8]
              ],
              "SM",
              378,
              "00",
              ,
              ,
              ,
              "([89]\\d{5})$",
              "0549$1",
              ,
              ,
              [
                [
                  ,
                  "(\\d{6})",
                  "$1",
                  ["[89]"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["[5-7]"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{6})",
                  "$1 $2",
                  ["0"]
                ]
              ],
              [[
                ,
                "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[5-7]"]
              ], [
                ,
                "(\\d{4})(\\d{6})",
                "$1 $2",
                ["0"]
              ]],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SN: [
              ,
              [
                ,
                ,
                "(?:[378]\\d|93)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}",
                ,
                ,
                ,
                "301012345"
              ],
              [
                ,
                ,
                "7(?:(?:[06-8]\\d|[19]0|21)\\d|5(?:0[01]|[19]0|2[25]|3[356]|[4-7]\\d|8[35]))\\d{5}",
                ,
                ,
                ,
                "701234567"
              ],
              [
                ,
                ,
                "800\\d{6}",
                ,
                ,
                ,
                "800123456"
              ],
              [
                ,
                ,
                "88[4689]\\d{6}",
                ,
                ,
                ,
                "884123456"
              ],
              [
                ,
                ,
                "81[02468]\\d{6}",
                ,
                ,
                ,
                "810123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}",
                ,
                ,
                ,
                "933301234"
              ],
              "SN",
              221,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["8"]
              ], [
                ,
                "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[379]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SO: [
              ,
              [
                ,
                ,
                "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  6,
                  7,
                  8,
                  9
                ]
              ],
              [
                ,
                ,
                "(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}",
                ,
                ,
                ,
                "4012345",
                ,
                ,
                [6, 7]
              ],
              [
                ,
                ,
                "(?:(?:15|(?:3[59]|4[89]|6\\d|7[679]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}",
                ,
                ,
                ,
                "71123456",
                ,
                ,
                [
                  7,
                  8,
                  9
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "SO",
              252,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{4})",
                  "$1 $2",
                  ["8[125]"]
                ],
                [
                  ,
                  "(\\d{6})",
                  "$1",
                  ["[134]"]
                ],
                [
                  ,
                  "(\\d)(\\d{6})",
                  "$1 $2",
                  ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]
                ],
                [
                  ,
                  "(\\d)(\\d{7})",
                  "$1 $2",
                  ["(?:2|90)4|[67]"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["[348]|64|79|90"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{5,7})",
                  "$1 $2",
                  ["1|28|6[0-35-9]|7[67]|9[2-9]"]
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SR: [
              ,
              [
                ,
                ,
                "(?:[2-5]|[6-8]\\d|90)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [6, 7]
              ],
              [
                ,
                ,
                "(?:2[1-3]|3[0-7]|4\\d|5[2-58])\\d{4}",
                ,
                ,
                ,
                "211234",
                ,
                ,
                [6]
              ],
              [
                ,
                ,
                "(?:6[08]|7[124-7]|8[1-9])\\d{5}",
                ,
                ,
                ,
                "7412345",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "80\\d{5}",
                ,
                ,
                ,
                "8012345",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "90\\d{5}",
                ,
                ,
                ,
                "9012345",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "56\\d{4}",
                ,
                ,
                ,
                "561234",
                ,
                ,
                [6]
              ],
              "SR",
              597,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{2})",
                  "$1-$2-$3",
                  ["56"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})",
                  "$1-$2",
                  ["[2-5]"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})",
                  "$1-$2",
                  ["[6-9]"]
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SS: [
              ,
              [
                ,
                ,
                "[19]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "1[89]\\d{7}",
                ,
                ,
                ,
                "181234567"
              ],
              [
                ,
                ,
                "(?:12|9[1257-9])\\d{7}",
                ,
                ,
                ,
                "977123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "SS",
              211,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[19]"],
                "0$1"
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            ST: [
              ,
              [
                ,
                ,
                "(?:22|9\\d)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "22\\d{5}",
                ,
                ,
                ,
                "2221234"
              ],
              [
                ,
                ,
                "900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}",
                ,
                ,
                ,
                "9812345"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "ST",
              239,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{4})",
                "$1 $2",
                ["[29]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SV: [
              ,
              [
                ,
                ,
                "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  7,
                  8,
                  11
                ]
              ],
              [
                ,
                ,
                "2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}",
                ,
                ,
                ,
                "21234567",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "[67]\\d{7}",
                ,
                ,
                ,
                "70123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "800\\d{8}|80[01]\\d{4}",
                ,
                ,
                ,
                "8001234",
                ,
                ,
                [7, 11]
              ],
              [
                ,
                ,
                "900\\d{4}(?:\\d{4})?",
                ,
                ,
                ,
                "9001234",
                ,
                ,
                [7, 11]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "SV",
              503,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{4})",
                  "$1 $2",
                  ["[89]"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{4})",
                  "$1 $2",
                  ["[267]"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["[89]"]
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SX: [
              ,
              [
                ,
                ,
                "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "7215(?:4[2-8]|8[239]|9[056])\\d{4}",
                ,
                ,
                ,
                "7215425678",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}",
                ,
                ,
                ,
                "7215205678",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
              ],
              [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "SX",
              1,
              "011",
              "1",
              ,
              ,
              "(5\\d{6})$|1",
              "721$1",
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "721",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SY: [
              ,
              [
                ,
                ,
                "[1-359]\\d{8}|[1-5]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9],
                [6, 7]
              ],
              [
                ,
                ,
                "21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}",
                ,
                ,
                ,
                "112345678",
                ,
                ,
                ,
                [6, 7]
              ],
              [
                ,
                ,
                "(?:50|9[1-9])\\d{7}",
                ,
                ,
                ,
                "944567890",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "SY",
              963,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{3})(\\d{3,4})",
                "$1 $2 $3",
                ["[1-4]|5[1-3]"],
                "0$1",
                ,
                1
              ], [
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[59]"],
                "0$1",
                ,
                1
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SZ: [
              ,
              [
                ,
                ,
                "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9]
              ],
              [
                ,
                ,
                "[23][2-5]\\d{6}",
                ,
                ,
                ,
                "22171234",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "7[5-9]\\d{6}",
                ,
                ,
                ,
                "76123456",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "0800\\d{4}",
                ,
                ,
                ,
                "08001234",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "900\\d{6}",
                ,
                ,
                ,
                "900012345",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "70\\d{6}",
                ,
                ,
                ,
                "70012345",
                ,
                ,
                [8]
              ],
              "SZ",
              268,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{4})(\\d{4})",
                "$1 $2",
                ["[0237]"]
              ], [
                ,
                "(\\d{5})(\\d{4})",
                "$1 $2",
                ["9"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "0800\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TA: [
              ,
              [
                ,
                ,
                "8\\d{3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [4]
              ],
              [
                ,
                ,
                "8\\d{3}",
                ,
                ,
                ,
                "8999"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "TA",
              290,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "8",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TC: [
              ,
              [
                ,
                ,
                "(?:[58]\\d\\d|649|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "649(?:266|712|9(?:4\\d|50))\\d{4}",
                ,
                ,
                ,
                "6497121234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}",
                ,
                ,
                ,
                "6492311234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002345678"
              ],
              [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ],
              [
                ,
                ,
                "649(?:71[01]|966)\\d{4}",
                ,
                ,
                ,
                "6497101234",
                ,
                ,
                ,
                [7]
              ],
              "TC",
              1,
              "011",
              "1",
              ,
              ,
              "([2-479]\\d{6})$|1",
              "649$1",
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "649",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TD: [
              ,
              [
                ,
                ,
                "(?:22|30|[689]\\d|77)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "22(?:[37-9]0|5[0-5]|6[89])\\d{4}",
                ,
                ,
                ,
                "22501234"
              ],
              [
                ,
                ,
                "(?:30|[69]\\d|77|8[56])\\d{6}",
                ,
                ,
                ,
                "63012345"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "TD",
              235,
              "00|16",
              ,
              ,
              ,
              ,
              ,
              "00",
              ,
              [[
                ,
                "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[236-9]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TG: [
              ,
              [
                ,
                ,
                "[279]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}",
                ,
                ,
                ,
                "22212345"
              ],
              [
                ,
                ,
                "(?:7[0-29]|9[0-36-9])\\d{6}",
                ,
                ,
                ,
                "90112345"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "TG",
              228,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[279]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TH: [
              ,
              [
                ,
                ,
                "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  8,
                  9,
                  10,
                  13
                ]
              ],
              [
                ,
                ,
                "(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}",
                ,
                ,
                ,
                "21234567",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "67(?:1[0-8]|2[4-7])\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}",
                ,
                ,
                ,
                "812345678",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "(?:001800\\d|1800)\\d{6}",
                ,
                ,
                ,
                "1800123456",
                ,
                ,
                [10, 13]
              ],
              [
                ,
                ,
                "1900\\d{6}",
                ,
                ,
                ,
                "1900123456",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "6[08]\\d{7}",
                ,
                ,
                ,
                "601234567",
                ,
                ,
                [9]
              ],
              "TH",
              66,
              "00[1-9]",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d)(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["2"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["[13-9]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["1"]
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TJ: [
              ,
              [
                ,
                ,
                "[0-57-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9],
                [
                  3,
                  5,
                  6,
                  7
                ]
              ],
              [
                ,
                ,
                "(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}",
                ,
                ,
                ,
                "372123456",
                ,
                ,
                ,
                [
                  3,
                  5,
                  6,
                  7
                ]
              ],
              [
                ,
                ,
                "(?:33[03-9]|4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:[09]\\d|1[0-27-9]|2[0-27]|[34]0|5[05]|7[01578]|8[078])\\d{7}",
                ,
                ,
                ,
                "917123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "TJ",
              992,
              "810",
              ,
              ,
              ,
              ,
              ,
              "8~10",
              ,
              [
                [
                  ,
                  "(\\d{6})(\\d)(\\d{2})",
                  "$1 $2 $3",
                  ["331", "3317"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{4})",
                  "$1 $2 $3",
                  ["44[02-479]|[34]7"]
                ],
                [
                  ,
                  "(\\d{4})(\\d)(\\d{4})",
                  "$1 $2 $3",
                  ["3(?:[1245]|3[12])"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["[0-57-9]"]
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TK: [
              ,
              [
                ,
                ,
                "[2-47]\\d{3,6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  4,
                  5,
                  6,
                  7
                ]
              ],
              [
                ,
                ,
                "(?:2[2-4]|[34]\\d)\\d{2,5}",
                ,
                ,
                ,
                "3101"
              ],
              [
                ,
                ,
                "7[2-4]\\d{2,5}",
                ,
                ,
                ,
                "7290"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "TK",
              690,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TL: [
              ,
              [
                ,
                ,
                "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 8]
              ],
              [
                ,
                ,
                "(?:2[1-5]|3[1-9]|4[1-4])\\d{5}",
                ,
                ,
                ,
                "2112345",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "7[2-8]\\d{6}",
                ,
                ,
                ,
                "77212345",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "80\\d{5}",
                ,
                ,
                ,
                "8012345",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "90\\d{5}",
                ,
                ,
                ,
                "9012345",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "70\\d{5}",
                ,
                ,
                ,
                "7012345",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "TL",
              670,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{4})",
                "$1 $2",
                ["[2-489]|70"]
              ], [
                ,
                "(\\d{4})(\\d{4})",
                "$1 $2",
                ["7"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TM: [
              ,
              [
                ,
                ,
                "(?:[1-6]\\d|71)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}",
                ,
                ,
                ,
                "12345678"
              ],
              [
                ,
                ,
                "(?:6\\d|71)\\d{6}",
                ,
                ,
                ,
                "66123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "TM",
              993,
              "810",
              "8",
              ,
              ,
              "8",
              ,
              "8~10",
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                  "$1 $2-$3-$4",
                  ["12"],
                  "(8 $1)"
                ],
                [
                  ,
                  "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                  "$1 $2-$3-$4",
                  ["[1-5]"],
                  "(8 $1)"
                ],
                [
                  ,
                  "(\\d{2})(\\d{6})",
                  "$1 $2",
                  ["[67]"],
                  "8 $1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TN: [
              ,
              [
                ,
                ,
                "[2-57-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}",
                ,
                ,
                ,
                "30010123"
              ],
              [
                ,
                ,
                "3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}",
                ,
                ,
                ,
                "20123456"
              ],
              [
                ,
                ,
                "8010\\d{4}",
                ,
                ,
                ,
                "80101234"
              ],
              [
                ,
                ,
                "88\\d{6}",
                ,
                ,
                ,
                "88123456"
              ],
              [
                ,
                ,
                "8[12]10\\d{4}",
                ,
                ,
                ,
                "81101234"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "TN",
              216,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[2-57-9]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TO: [
              ,
              [
                ,
                ,
                "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [5, 7]
              ],
              [
                ,
                ,
                "(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}",
                ,
                ,
                ,
                "20123",
                ,
                ,
                [5]
              ],
              [
                ,
                ,
                "(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",
                ,
                ,
                ,
                "7715123",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "0800\\d{3}",
                ,
                ,
                ,
                "0800222",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "55[0-37-9]\\d{4}",
                ,
                ,
                ,
                "5510123",
                ,
                ,
                [7]
              ],
              "TO",
              676,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{3})",
                  "$1-$2",
                  ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{3})",
                  "$1 $2",
                  ["0"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})",
                  "$1 $2",
                  ["[5-9]"]
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TR: [
              ,
              [
                ,
                ,
                "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  7,
                  10,
                  12,
                  13
                ]
              ],
              [
                ,
                ,
                "(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}",
                ,
                ,
                ,
                "2123456789",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}",
                ,
                ,
                ,
                "5012345678",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})",
                ,
                ,
                ,
                "8001234567",
                ,
                ,
                [
                  10,
                  12,
                  13
                ]
              ],
              [
                ,
                ,
                "(?:8[89]8|900)\\d{7}",
                ,
                ,
                ,
                "9001234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "592(?:21[12]|461)\\d{4}",
                ,
                ,
                ,
                "5922121234",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "850\\d{7}",
                ,
                ,
                ,
                "8500123456",
                ,
                ,
                [10]
              ],
              "TR",
              90,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d)(\\d{3})",
                  "$1 $2 $3",
                  ["444"],
                  ,
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["512|8[01589]|90"],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  [
                    "5(?:[0-59]|61)",
                    "5(?:[0-59]|61[06])",
                    "5(?:[0-59]|61[06]1)"
                  ],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["[24][1-8]|3[1-9]"],
                  "(0$1)",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{6,7})",
                  "$1 $2 $3",
                  ["80"],
                  "0$1",
                  ,
                  1
                ]
              ],
              [
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["512|8[01589]|90"],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  [
                    "5(?:[0-59]|61)",
                    "5(?:[0-59]|61[06])",
                    "5(?:[0-59]|61[06]1)"
                  ],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["[24][1-8]|3[1-9]"],
                  "(0$1)",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{6,7})",
                  "$1 $2 $3",
                  ["80"],
                  "0$1",
                  ,
                  1
                ]
              ],
              [
                ,
                ,
                "512\\d{7}",
                ,
                ,
                ,
                "5123456789",
                ,
                ,
                [10]
              ],
              ,
              ,
              [
                ,
                ,
                "(?:444|811\\d{3})\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 10]
              ],
              [
                ,
                ,
                "444\\d{4}",
                ,
                ,
                ,
                "4441444",
                ,
                ,
                [7]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TT: [
              ,
              [
                ,
                ,
                "(?:[58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}",
                ,
                ,
                ,
                "8682211234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}",
                ,
                ,
                ,
                "8682911234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002345678"
              ],
              [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "TT",
              1,
              "011",
              "1",
              ,
              ,
              "([2-46-8]\\d{6})$|1",
              "868$1",
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "868",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "868619\\d{4}",
                ,
                ,
                ,
                "8686191234",
                ,
                ,
                ,
                [7]
              ]
            ],
            TV: [
              ,
              [
                ,
                ,
                "(?:2|7\\d\\d|90)\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  5,
                  6,
                  7
                ]
              ],
              [
                ,
                ,
                "2[02-9]\\d{3}",
                ,
                ,
                ,
                "20123",
                ,
                ,
                [5]
              ],
              [
                ,
                ,
                "(?:7[01]\\d|90)\\d{4}",
                ,
                ,
                ,
                "901234",
                ,
                ,
                [6, 7]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "TV",
              688,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{3})",
                  "$1 $2",
                  ["2"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})",
                  "$1 $2",
                  ["90"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{5})",
                  "$1 $2",
                  ["7"]
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TW: [
              ,
              [
                ,
                ,
                "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  7,
                  8,
                  9,
                  10,
                  11
                ]
              ],
              [
                ,
                ,
                "(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}",
                ,
                ,
                ,
                "221234567",
                ,
                ,
                [8, 9]
              ],
              [
                ,
                ,
                "(?:40001[0-2]|9[0-8]\\d{4})\\d{3}",
                ,
                ,
                ,
                "912345678",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "80[0-79]\\d{6}|800\\d{5}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [8, 9]
              ],
              [
                ,
                ,
                "20(?:[013-9]\\d\\d|2)\\d{4}",
                ,
                ,
                ,
                "203123456",
                ,
                ,
                [7, 9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "99\\d{7}",
                ,
                ,
                ,
                "990123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}",
                ,
                ,
                ,
                "7012345678",
                ,
                ,
                [10, 11]
              ],
              "TW",
              886,
              "0(?:0[25-79]|19)",
              "0",
              "#",
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d)(\\d{4})",
                  "$1 $2 $3",
                  ["202"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["[258]0"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{3,4})(\\d{4})",
                  "$1 $2 $3",
                  ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["[49]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{4,5})",
                  "$1 $2 $3",
                  ["7"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "50[0-46-9]\\d{6}",
                ,
                ,
                ,
                "500123456",
                ,
                ,
                [9]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TZ: [
              ,
              [
                ,
                ,
                "(?:[25-8]\\d|41|90)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "2[2-8]\\d{7}",
                ,
                ,
                ,
                "222345678"
              ],
              [
                ,
                ,
                "(?:6[125-9]|7[13-9])\\d{7}",
                ,
                ,
                ,
                "621234567"
              ],
              [
                ,
                ,
                "80[08]\\d{6}",
                ,
                ,
                ,
                "800123456"
              ],
              [
                ,
                ,
                "90\\d{7}",
                ,
                ,
                ,
                "900123456"
              ],
              [
                ,
                ,
                "8(?:40|6[01])\\d{6}",
                ,
                ,
                ,
                "840123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "41\\d{7}",
                ,
                ,
                ,
                "412345678"
              ],
              "TZ",
              255,
              "00[056]",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{2})(\\d{4})",
                  "$1 $2 $3",
                  ["[89]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["[24]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{7})",
                  "$1 $2",
                  ["5"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["[67]"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "(?:8(?:[04]0|6[01])|90\\d)\\d{6}"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            UA: [
              ,
              [
                ,
                ,
                "[89]\\d{9}|[3-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9, 10],
                [
                  5,
                  6,
                  7
                ]
              ],
              [
                ,
                ,
                "(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}",
                ,
                ,
                ,
                "311234567",
                ,
                ,
                [9],
                [
                  5,
                  6,
                  7
                ]
              ],
              [
                ,
                ,
                "790\\d{6}|(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}",
                ,
                ,
                ,
                "501234567",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "800[1-8]\\d{5,6}",
                ,
                ,
                ,
                "800123456"
              ],
              [
                ,
                ,
                "900[239]\\d{5,6}",
                ,
                ,
                ,
                "900212345"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "89[1-579]\\d{6}",
                ,
                ,
                ,
                "891234567",
                ,
                ,
                [9]
              ],
              "UA",
              380,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              "0~0",
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{5})",
                  "$1 $2",
                  ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["[3-7]|89|9[1-9]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["[89]"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            UG: [
              ,
              [
                ,
                ,
                "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9],
                [
                  5,
                  6,
                  7
                ]
              ],
              [
                ,
                ,
                "20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|3[1-4]|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}",
                ,
                ,
                ,
                "312345678",
                ,
                ,
                ,
                [
                  5,
                  6,
                  7
                ]
              ],
              [
                ,
                ,
                "72[48]0\\d{5}|7(?:[014-8]\\d|2[067]|36|9[0189])\\d{6}",
                ,
                ,
                ,
                "712345678"
              ],
              [
                ,
                ,
                "800[1-3]\\d{5}",
                ,
                ,
                ,
                "800123456"
              ],
              [
                ,
                ,
                "90[1-3]\\d{6}",
                ,
                ,
                ,
                "901123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "UG",
              256,
              "00[057]",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{4})(\\d{5})",
                  "$1 $2",
                  ["202", "2024"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{6})",
                  "$1 $2",
                  ["[27-9]|4(?:6[45]|[7-9])"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{7})",
                  "$1 $2",
                  ["[34]"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            US: [
              ,
              [
                ,
                ,
                "[2-9]\\d{9}|3\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-68]))\\d{4}|(?:2742|305[3-9]|(?:472|983)[2-47-9]|505[2-57-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-269])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}",
                ,
                ,
                ,
                "2015550123",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-68]))\\d{4}|(?:2742|305[3-9]|(?:472|983)[2-47-9]|505[2-57-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-269])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}",
                ,
                ,
                ,
                "2015550123",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002345678"
              ],
              [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ],
              [
                ,
                ,
                "305209\\d{4}",
                ,
                ,
                ,
                "3052090123",
                ,
                ,
                ,
                [7]
              ],
              "US",
              1,
              "011",
              "1",
              ,
              ,
              "1",
              ,
              ,
              1,
              [
                [
                  ,
                  "(\\d{3})(\\d{4})",
                  "$1-$2",
                  ["310"],
                  ,
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})",
                  "$1-$2",
                  ["[24-9]|3(?:[02-9]|1[1-9])"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "($1) $2-$3",
                  ["[2-9]"],
                  ,
                  ,
                  1
                ]
              ],
              [[
                ,
                "(\\d{3})(\\d{4})",
                "$1-$2",
                ["310"],
                ,
                ,
                1
              ], [
                ,
                "(\\d{3})(\\d{3})(\\d{4})",
                "$1-$2-$3",
                ["[2-9]"]
              ]],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              1,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            UY: [
              ,
              [
                ,
                ,
                "0004\\d{2,9}|[1249]\\d{7}|2\\d{3,4}|(?:[49]\\d|80)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  4,
                  5,
                  6,
                  7,
                  8,
                  9,
                  10,
                  11,
                  12,
                  13
                ]
              ],
              [
                ,
                ,
                "(?:1(?:770|9(?:20|[89]7))|(?:2\\d|4[2-7])\\d\\d)\\d{4}",
                ,
                ,
                ,
                "21231234",
                ,
                ,
                [8],
                [7]
              ],
              [
                ,
                ,
                "9[1-9]\\d{6}",
                ,
                ,
                ,
                "94231234",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "0004\\d{2,9}|(?:405|80[05])\\d{4}",
                ,
                ,
                ,
                "8001234",
                ,
                ,
                [
                  6,
                  7,
                  8,
                  9,
                  10,
                  11,
                  12,
                  13
                ]
              ],
              [
                ,
                ,
                "90[0-8]\\d{4}",
                ,
                ,
                ,
                "9001234",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "UY",
              598,
              "0(?:0|1[3-9]\\d)",
              "0",
              " int. ",
              ,
              "0",
              ,
              "00",
              ,
              [
                [
                  ,
                  "(\\d{4,5})",
                  "$1",
                  ["21"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3,4})",
                  "$1 $2",
                  ["0"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})",
                  "$1 $2",
                  ["[49]0|8"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["9"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{4})",
                  "$1 $2",
                  ["[124]"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{2,4})",
                  "$1 $2 $3",
                  ["0"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                  "$1 $2 $3 $4",
                  ["0"]
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "21\\d{2,3}",
                ,
                ,
                ,
                "21123",
                ,
                ,
                [4, 5]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            UZ: [
              ,
              [
                ,
                ,
                "(?:20|33|[5-9]\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|[69]\\d\\d|7(?:[23]\\d|7[69]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|[168]\\d\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}",
                ,
                ,
                ,
                "669050123"
              ],
              [
                ,
                ,
                "(?:(?:[25]0|33|8[78]|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079])))|7(?:[07]\\d{3}|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}",
                ,
                ,
                ,
                "912345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "UZ",
              998,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[235-9]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            VA: [
              ,
              [
                ,
                ,
                "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  6,
                  7,
                  8,
                  9,
                  10,
                  11,
                  12
                ]
              ],
              [
                ,
                ,
                "06698\\d{1,6}",
                ,
                ,
                ,
                "0669812345",
                ,
                ,
                [
                  6,
                  7,
                  8,
                  9,
                  10,
                  11
                ]
              ],
              [
                ,
                ,
                "3[1-9]\\d{8}|3[2-9]\\d{7}",
                ,
                ,
                ,
                "3123456789",
                ,
                ,
                [9, 10]
              ],
              [
                ,
                ,
                "80(?:0\\d{3}|3)\\d{3}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [6, 9]
              ],
              [
                ,
                ,
                "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                ,
                ,
                ,
                "899123456",
                ,
                ,
                [
                  6,
                  8,
                  9,
                  10
                ]
              ],
              [
                ,
                ,
                "84(?:[08]\\d{3}|[17])\\d{3}",
                ,
                ,
                ,
                "848123456",
                ,
                ,
                [6, 9]
              ],
              [
                ,
                ,
                "1(?:78\\d|99)\\d{6}",
                ,
                ,
                ,
                "1781234567",
                ,
                ,
                [9, 10]
              ],
              [
                ,
                ,
                "55\\d{8}",
                ,
                ,
                ,
                "5512345678",
                ,
                ,
                [10]
              ],
              "VA",
              39,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "06698",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "3[2-8]\\d{9,10}",
                ,
                ,
                ,
                "33101234501",
                ,
                ,
                [11, 12]
              ]
            ],
            VC: [
              ,
              [
                ,
                ,
                "(?:[58]\\d\\d|784|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}",
                ,
                ,
                ,
                "7842661234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}",
                ,
                ,
                ,
                "7844301234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002345678"
              ],
              [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ],
              [
                ,
                ,
                "78451[0-2]\\d{4}",
                ,
                ,
                ,
                "7845101234",
                ,
                ,
                ,
                [7]
              ],
              "VC",
              1,
              "011",
              "1",
              ,
              ,
              "([2-7]\\d{6})$|1",
              "784$1",
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "784",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            VE: [
              ,
              [
                ,
                ,
                "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}",
                ,
                ,
                ,
                "2121234567",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "4(?:1[24-8]|2[246])\\d{7}",
                ,
                ,
                ,
                "4121234567"
              ],
              [
                ,
                ,
                "800\\d{7}",
                ,
                ,
                ,
                "8001234567"
              ],
              [
                ,
                ,
                "90[01]\\d{7}",
                ,
                ,
                ,
                "9001234567"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "VE",
              58,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{7})",
                "$1-$2",
                ["[24-689]"],
                "0$1",
                "$CC $1"
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "501\\d{7}",
                ,
                ,
                ,
                "5010123456",
                ,
                ,
                ,
                [7]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            VG: [
              ,
              [
                ,
                ,
                "(?:284|[58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}",
                ,
                ,
                ,
                "2842291234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}",
                ,
                ,
                ,
                "2843001234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002345678"
              ],
              [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "VG",
              1,
              "011",
              "1",
              ,
              ,
              "([2-578]\\d{6})$|1",
              "284$1",
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "284",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            VI: [
              ,
              [
                ,
                ,
                "[58]\\d{9}|(?:34|90)0\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ],
              [
                ,
                ,
                "340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
                ,
                ,
                ,
                "3406421234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
                ,
                ,
                ,
                "3406421234",
                ,
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002345678"
              ],
              [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "VI",
              1,
              "011",
              "1",
              ,
              ,
              "([2-9]\\d{6})$|1",
              "340$1",
              ,
              1,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              "340",
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            VN: [
              ,
              [
                ,
                ,
                "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  7,
                  8,
                  9,
                  10
                ]
              ],
              [
                ,
                ,
                "2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}",
                ,
                ,
                ,
                "2101234567",
                ,
                ,
                [10]
              ],
              [
                ,
                ,
                "(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}",
                ,
                ,
                ,
                "912345678",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "1800\\d{4,6}|12(?:0[13]|28)\\d{4}",
                ,
                ,
                ,
                "1800123456",
                ,
                ,
                [
                  8,
                  9,
                  10
                ]
              ],
              [
                ,
                ,
                "1900\\d{4,6}",
                ,
                ,
                ,
                "1900123456",
                ,
                ,
                [
                  8,
                  9,
                  10
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "672\\d{6}",
                ,
                ,
                ,
                "672012345",
                ,
                ,
                [9]
              ],
              "VN",
              84,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{4})",
                  "$1 $2",
                  ["[17]99"],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{2})(\\d{5})",
                  "$1 $2",
                  ["80"],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{4,5})",
                  "$1 $2",
                  ["69"],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{4})(\\d{4,6})",
                  "$1 $2",
                  ["1"],
                  ,
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["6"],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["[357-9]"],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["2[48]"],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})(\\d{3})",
                  "$1 $2 $3",
                  ["2"],
                  "0$1",
                  ,
                  1
                ]
              ],
              [
                [
                  ,
                  "(\\d{2})(\\d{5})",
                  "$1 $2",
                  ["80"],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{4})(\\d{4,6})",
                  "$1 $2",
                  ["1"],
                  ,
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                  "$1 $2 $3 $4",
                  ["6"],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["[357-9]"],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["2[48]"],
                  "0$1",
                  ,
                  1
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})(\\d{3})",
                  "$1 $2 $3",
                  ["2"],
                  "0$1",
                  ,
                  1
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "[17]99\\d{4}|69\\d{5,6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 8]
              ],
              [
                ,
                ,
                "(?:[17]99|80\\d)\\d{4}|69\\d{5,6}",
                ,
                ,
                ,
                "1992000",
                ,
                ,
                [7, 8]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            VU: [
              ,
              [
                ,
                ,
                "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [5, 7]
              ],
              [
                ,
                ,
                "(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}",
                ,
                ,
                ,
                "22123",
                ,
                ,
                [5]
              ],
              [
                ,
                ,
                "(?:[58]\\d|7[013-7])\\d{5}",
                ,
                ,
                ,
                "5912345",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                "81[18]\\d\\d",
                ,
                ,
                ,
                "81123",
                ,
                ,
                [5]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "9(?:0[1-9]|1[01])\\d{4}",
                ,
                ,
                ,
                "9010123",
                ,
                ,
                [7]
              ],
              "VU",
              678,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{4})",
                "$1 $2",
                ["[57-9]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:3[03]|900\\d)\\d{3}",
                ,
                ,
                ,
                "30123"
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            WF: [
              ,
              [
                ,
                ,
                "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [6, 9]
              ],
              [
                ,
                ,
                "72\\d{4}",
                ,
                ,
                ,
                "721234",
                ,
                ,
                [6]
              ],
              [
                ,
                ,
                "(?:72|8[23])\\d{4}",
                ,
                ,
                ,
                "821234",
                ,
                ,
                [6]
              ],
              [
                ,
                ,
                "80[0-5]\\d{6}",
                ,
                ,
                ,
                "800012345",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "9[23]\\d{4}",
                ,
                ,
                ,
                "921234",
                ,
                ,
                [6]
              ],
              "WF",
              681,
              "00",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3",
                ["[47-9]"]
              ], [
                ,
                "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["8"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "[48]0\\d{4}",
                ,
                ,
                ,
                "401234",
                ,
                ,
                [6]
              ]
            ],
            WS: [
              ,
              [
                ,
                ,
                "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  5,
                  6,
                  7,
                  10
                ]
              ],
              [
                ,
                ,
                "6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}",
                ,
                ,
                ,
                "22123",
                ,
                ,
                [5, 6]
              ],
              [
                ,
                ,
                "(?:7[1-35-8]|8(?:[3-7]|9\\d{3}))\\d{5}",
                ,
                ,
                ,
                "7212345",
                ,
                ,
                [7, 10]
              ],
              [
                ,
                ,
                "800\\d{3}",
                ,
                ,
                ,
                "800123",
                ,
                ,
                [6]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "WS",
              685,
              "0",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{5})",
                  "$1",
                  ["[2-5]|6[1-9]"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3,7})",
                  "$1 $2",
                  ["[68]"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{5})",
                  "$1 $2",
                  ["7"]
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            XK: [
              ,
              [
                ,
                ,
                "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  8,
                  9,
                  10,
                  11,
                  12
                ]
              ],
              [
                ,
                ,
                "38\\d{6,10}|(?:2[89]|39)(?:0\\d{5,6}|[1-9]\\d{5})",
                ,
                ,
                ,
                "28012345"
              ],
              [
                ,
                ,
                "4[3-9]\\d{6}",
                ,
                ,
                ,
                "43201234",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "800\\d{5}",
                ,
                ,
                ,
                "80001234",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                "900\\d{5}",
                ,
                ,
                ,
                "90001234",
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "XK",
              383,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{5})",
                  "$1 $2",
                  ["[89]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["[2-4]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["2|39"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{7,10})",
                  "$1 $2",
                  ["3"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            YE: [
              ,
              [
                ,
                ,
                "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  7,
                  8,
                  9
                ],
                [6]
              ],
              [
                ,
                ,
                "78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}",
                ,
                ,
                ,
                "1234567",
                ,
                ,
                [7, 8],
                [6]
              ],
              [
                ,
                ,
                "7[01378]\\d{7}",
                ,
                ,
                ,
                "712345678",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "YE",
              967,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [[
                ,
                "(\\d)(\\d{3})(\\d{3,4})",
                "$1 $2 $3",
                ["[1-6]|7(?:[24-6]|8[0-7])"],
                "0$1"
              ], [
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["7"],
                "0$1"
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            YT: [
              ,
              [
                ,
                ,
                "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}",
                ,
                ,
                ,
                "269601234"
              ],
              [
                ,
                ,
                "(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}",
                ,
                ,
                ,
                "639012345"
              ],
              [
                ,
                ,
                "80\\d{7}",
                ,
                ,
                ,
                "801234567"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "9(?:(?:39|47)8[01]|769\\d)\\d{4}",
                ,
                ,
                ,
                "939801234"
              ],
              "YT",
              262,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            ZA: [
              ,
              [
                ,
                ,
                "[1-79]\\d{8}|8\\d{4,9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  5,
                  6,
                  7,
                  8,
                  9,
                  10
                ]
              ],
              [
                ,
                ,
                "(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}",
                ,
                ,
                ,
                "101234567",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:50[0-2]|6\\d\\d|7(?:[0-46-9]\\d|5[0-4]))\\d\\d|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}",
                ,
                ,
                ,
                "711234567",
                ,
                ,
                [
                  5,
                  6,
                  7,
                  8,
                  9
                ]
              ],
              [
                ,
                ,
                "80\\d{7}",
                ,
                ,
                ,
                "801234567",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "(?:86[2-9]|9[0-2]\\d)\\d{6}",
                ,
                ,
                ,
                "862345678",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "860\\d{6}",
                ,
                ,
                ,
                "860123456",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}",
                ,
                ,
                ,
                "871234567",
                ,
                ,
                [9]
              ],
              "ZA",
              27,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{3,4})",
                  "$1 $2",
                  ["8[1-4]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{2,3})",
                  "$1 $2 $3",
                  ["8[1-4]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["860"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["[1-9]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["8"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "861\\d{6,7}",
                ,
                ,
                ,
                "861123456",
                ,
                ,
                [9, 10]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            ZM: [
              ,
              [
                ,
                ,
                "800\\d{6}|(?:21|[579]\\d|63)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9],
                [6]
              ],
              [
                ,
                ,
                "21[1-8]\\d{6}",
                ,
                ,
                ,
                "211234567",
                ,
                ,
                ,
                [6]
              ],
              [
                ,
                ,
                "(?:[59][5-8]|7[5-9])\\d{7}",
                ,
                ,
                ,
                "955123456"
              ],
              [
                ,
                ,
                "800\\d{6}",
                ,
                ,
                ,
                "800123456"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "63\\d{7}",
                ,
                ,
                ,
                "630123456"
              ],
              "ZM",
              260,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{3})",
                  "$1 $2",
                  ["[1-9]"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["[28]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{7})",
                  "$1 $2",
                  ["[579]"],
                  "0$1"
                ]
              ],
              [[
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[28]"],
                "0$1"
              ], [
                ,
                "(\\d{2})(\\d{7})",
                "$1 $2",
                ["[579]"],
                "0$1"
              ]],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            ZW: [
              ,
              [
                ,
                ,
                "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  5,
                  6,
                  7,
                  8,
                  9,
                  10
                ],
                [3, 4]
              ],
              [
                ,
                ,
                "(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}",
                ,
                ,
                ,
                "1312345",
                ,
                ,
                ,
                [3, 4]
              ],
              [
                ,
                ,
                "7(?:[1278]\\d|3[1-9])\\d{6}",
                ,
                ,
                ,
                "712345678",
                ,
                ,
                [9]
              ],
              [
                ,
                ,
                "80(?:[01]\\d|20|8[0-8])\\d{3}",
                ,
                ,
                ,
                "8001234",
                ,
                ,
                [7]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "86(?:1[12]|22|30|44|55|77|8[368])\\d{6}",
                ,
                ,
                ,
                "8686123456",
                ,
                ,
                [10]
              ],
              "ZW",
              263,
              "00",
              "0",
              ,
              ,
              "0",
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{3})(\\d{3,5})",
                  "$1 $2",
                  ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d)(\\d{3})(\\d{2,4})",
                  "$1 $2 $3",
                  ["[49]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})",
                  "$1 $2",
                  ["80"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{7})",
                  "$1 $2",
                  ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"],
                  "(0$1)"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["7"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{6})",
                  "$1 $2",
                  ["8"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3,5})",
                  "$1 $2",
                  ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3,4})",
                  "$1 $2 $3",
                  ["29[013-9]|39|54"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{3,5})",
                  "$1 $2",
                  ["(?:25|54)8", "258|5483"],
                  "0$1"
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            800: [
              ,
              [
                ,
                ,
                "(?:00|[1-9]\\d)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:00|[1-9]\\d)\\d{6}",
                ,
                ,
                ,
                "12345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "001",
              800,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              1,
              [[
                ,
                "(\\d{4})(\\d{4})",
                "$1 $2",
                ["\\d"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            808: [
              ,
              [
                ,
                ,
                "[1-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "[1-9]\\d{7}",
                ,
                ,
                ,
                "12345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "001",
              808,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              1,
              [[
                ,
                "(\\d{4})(\\d{4})",
                "$1 $2",
                ["[1-9]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            870: [
              ,
              [
                ,
                ,
                "7\\d{11}|[235-7]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9, 12]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}",
                ,
                ,
                ,
                "301234567"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "2\\d{8}",
                ,
                ,
                ,
                "201234567",
                ,
                ,
                [9]
              ],
              "001",
              870,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[235-7]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            878: [
              ,
              [
                ,
                ,
                "10\\d{10}",
                ,
                ,
                ,
                ,
                ,
                ,
                [12]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "10\\d{10}",
                ,
                ,
                ,
                "101234567890"
              ],
              "001",
              878,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              1,
              [[
                ,
                "(\\d{2})(\\d{5})(\\d{5})",
                "$1 $2 $3",
                ["1"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            881: [
              ,
              [
                ,
                ,
                "6\\d{9}|[0-36-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9, 10]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "6\\d{9}|[0-36-9]\\d{8}",
                ,
                ,
                ,
                "612345678"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "001",
              881,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [[
                ,
                "(\\d)(\\d{3})(\\d{5})",
                "$1 $2 $3",
                ["[0-37-9]"]
              ], [
                ,
                "(\\d)(\\d{3})(\\d{5,6})",
                "$1 $2 $3",
                ["6"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            882: [
              ,
              [
                ,
                ,
                "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  7,
                  8,
                  9,
                  10,
                  11,
                  12
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                ,
                ,
                ,
                "3421234",
                ,
                ,
                [
                  7,
                  8,
                  9,
                  10,
                  12
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}",
                ,
                ,
                ,
                "390123456789"
              ],
              "001",
              882,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                [
                  ,
                  "(\\d{2})(\\d{5})",
                  "$1 $2",
                  ["16|342"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{6})",
                  "$1 $2",
                  ["49"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{2})(\\d{4})",
                  "$1 $2 $3",
                  ["1[36]|9"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{3})",
                  "$1 $2 $3",
                  ["3[23]"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{3,4})(\\d{4})",
                  "$1 $2 $3",
                  ["16"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["10|23|3(?:[15]|4[57])|4|51"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["34"]
                ],
                [
                  ,
                  "(\\d{2})(\\d{4,5})(\\d{5})",
                  "$1 $2 $3",
                  ["[1-35]"]
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                "348[57]\\d{7}",
                ,
                ,
                ,
                "34851234567",
                ,
                ,
                [11]
              ]
            ],
            883: [
              ,
              [
                ,
                ,
                "(?:[1-4]\\d|51)\\d{6,10}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  8,
                  9,
                  10,
                  11,
                  12
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}",
                ,
                ,
                ,
                "510012345"
              ],
              "001",
              883,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              1,
              [
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{2,8})",
                  "$1 $2 $3",
                  ["[14]|2[24-689]|3[02-689]|51[24-9]"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3",
                  ["510"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{4})",
                  "$1 $2 $3",
                  ["21"]
                ],
                [
                  ,
                  "(\\d{4})(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["51[13]"]
                ],
                [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                  "$1 $2 $3 $4",
                  ["[235]"]
                ]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            888: [
              ,
              [
                ,
                ,
                "\\d{11}",
                ,
                ,
                ,
                ,
                ,
                ,
                [11]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "001",
              888,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              1,
              [[
                ,
                "(\\d{3})(\\d{3})(\\d{5})",
                "$1 $2 $3"
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "\\d{11}",
                ,
                ,
                ,
                "12345678901"
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            979: [
              ,
              [
                ,
                ,
                "[1359]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9],
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "[1359]\\d{8}",
                ,
                ,
                ,
                "123456789",
                ,
                ,
                ,
                [8]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              "001",
              979,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              1,
              [[
                ,
                "(\\d)(\\d{4})(\\d{4})",
                "$1 $2 $3",
                ["[1359]"]
              ]],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ]
          }, i18n.phonenumbers.PhoneNumberUtil = function() {
            this.regionToMetadataMap = {};
          }, goog.addSingletonGetter(i18n.phonenumbers.PhoneNumberUtil), i18n.phonenumbers.Error = {
            INVALID_COUNTRY_CODE: "Invalid country calling code",
            NOT_A_NUMBER: "The string supplied did not seem to be a phone number",
            TOO_SHORT_AFTER_IDD: "Phone number too short after IDD",
            TOO_SHORT_NSN: "The string supplied is too short to be a phone number",
            TOO_LONG: "The string supplied is too long to be a phone number"
          }, i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_ = 1, i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ = 2, i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_ = 17, i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_ = 3, i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_ = 250, i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_ = "ZZ", i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_ = { 54: "9" }, i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_ = [
            52,
            54,
            55
          ], i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN = "+", i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ = "*", i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ = ";ext=", i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_ = "tel:", i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_ = ";phone-context=", i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_ = ";isub=", i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS = {
            0: "0",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            "０": "0",
            "１": "1",
            "２": "2",
            "３": "3",
            "４": "4",
            "５": "5",
            "６": "6",
            "７": "7",
            "８": "8",
            "９": "9",
            "٠": "0",
            "١": "1",
            "٢": "2",
            "٣": "3",
            "٤": "4",
            "٥": "5",
            "٦": "6",
            "٧": "7",
            "٨": "8",
            "٩": "9",
            "۰": "0",
            "۱": "1",
            "۲": "2",
            "۳": "3",
            "۴": "4",
            "۵": "5",
            "۶": "6",
            "۷": "7",
            "۸": "8",
            "۹": "9"
          }, i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_ = {
            0: "0",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            "+": i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN,
            "*": "*",
            "#": "#"
          }, i18n.phonenumbers.PhoneNumberUtil.ALPHA_MAPPINGS_ = {
            A: "2",
            B: "2",
            C: "2",
            D: "3",
            E: "3",
            F: "3",
            G: "4",
            H: "4",
            I: "4",
            J: "5",
            K: "5",
            L: "5",
            M: "6",
            N: "6",
            O: "6",
            P: "7",
            Q: "7",
            R: "7",
            S: "7",
            T: "8",
            U: "8",
            V: "8",
            W: "9",
            X: "9",
            Y: "9",
            Z: "9"
          }, i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_ = {
            0: "0",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            "０": "0",
            "１": "1",
            "２": "2",
            "３": "3",
            "４": "4",
            "５": "5",
            "６": "6",
            "７": "7",
            "８": "8",
            "９": "9",
            "٠": "0",
            "١": "1",
            "٢": "2",
            "٣": "3",
            "٤": "4",
            "٥": "5",
            "٦": "6",
            "٧": "7",
            "٨": "8",
            "٩": "9",
            "۰": "0",
            "۱": "1",
            "۲": "2",
            "۳": "3",
            "۴": "4",
            "۵": "5",
            "۶": "6",
            "۷": "7",
            "۸": "8",
            "۹": "9",
            A: "2",
            B: "2",
            C: "2",
            D: "3",
            E: "3",
            F: "3",
            G: "4",
            H: "4",
            I: "4",
            J: "5",
            K: "5",
            L: "5",
            M: "6",
            N: "6",
            O: "6",
            P: "7",
            Q: "7",
            R: "7",
            S: "7",
            T: "8",
            U: "8",
            V: "8",
            W: "9",
            X: "9",
            Y: "9",
            Z: "9"
          }, i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_ = {
            0: "0",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            A: "A",
            B: "B",
            C: "C",
            D: "D",
            E: "E",
            F: "F",
            G: "G",
            H: "H",
            I: "I",
            J: "J",
            K: "K",
            L: "L",
            M: "M",
            N: "N",
            O: "O",
            P: "P",
            Q: "Q",
            R: "R",
            S: "S",
            T: "T",
            U: "U",
            V: "V",
            W: "W",
            X: "X",
            Y: "Y",
            Z: "Z",
            a: "A",
            b: "B",
            c: "C",
            d: "D",
            e: "E",
            f: "F",
            g: "G",
            h: "H",
            i: "I",
            j: "J",
            k: "K",
            l: "L",
            m: "M",
            n: "N",
            o: "O",
            p: "P",
            q: "Q",
            r: "R",
            s: "S",
            t: "T",
            u: "U",
            v: "V",
            w: "W",
            x: "X",
            y: "Y",
            z: "Z",
            "-": "-",
            "－": "-",
            "‐": "-",
            "‑": "-",
            "‒": "-",
            "–": "-",
            "—": "-",
            "―": "-",
            "−": "-",
            "/": "/",
            "／": "/",
            " ": " ",
            "　": " ",
            "⁠": " ",
            ".": ".",
            "．": "."
          }, i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_ = /[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?/, i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION = "-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～", i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ = "0-9０-９٠-٩۰-۹", i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ = "A-Za-z", i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ = "+＋", i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN = /* @__PURE__ */ RegExp("[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]+"), i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN = /* @__PURE__ */ RegExp("^[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]+"), i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]+", i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN = /* @__PURE__ */ RegExp("([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "])"), i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_ = /* @__PURE__ */ RegExp("[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]"), i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_ = /[\\\/] *x/, i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_ = /* @__PURE__ */ RegExp("[^" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + "#]+$"), i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_ = /(?:.*?[A-Za-z]){3}.*/, i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]{" + i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ + "}", i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_ = "[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]*(?:[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ + "]*[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]){3,}[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]*", i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_ = " ext. ", i18n.phonenumbers.PhoneNumberUtil.RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?", i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_DIGIT_ = "([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]|" + i18n.phonenumbers.PhoneNumberUtil.RFC3966_VISUAL_SEPARATOR_ + ")", i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_DIGIT_ + "*[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]" + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_DIGIT_ + "*$", i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_), i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_ = i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_, i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINLABEL_ = "[" + i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_ + "]+((\\-)*[" + i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_ + "])*", i18n.phonenumbers.PhoneNumberUtil.RFC3966_TOPLABEL_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + "]+((\\-)*[" + i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_ + "])*", i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_ = "^(" + i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINLABEL_ + "\\.)*" + i18n.phonenumbers.PhoneNumberUtil.RFC3966_TOPLABEL_ + "\\.?$", i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_PATTERN_ = new RegExp(i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_), i18n.phonenumbers.PhoneNumberUtil.extnDigits_ = function(a2) {
            return "([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]{1," + a2 + "})";
          }, i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_ = function() {
            var a2 = i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("20"), b2 = "[  \\t,]*(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)[:\\.．]?[  \\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("20") + "#?", c$12 = "[  \\t,]*(?:[xｘ#＃~～]|int|ｉｎｔ)[:\\.．]?[  \\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("9") + "#?", d2 = "[- ]+" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("6") + "#", e2 = "[  \\t]*(?:,{2}|;)[:\\.．]?[  \\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("15") + "#?", f2 = "[  \\t]*(?:,)+[:\\.．]?[  \\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("9") + "#?";
            return a2 + "|" + b2 + "|" + c$12 + "|" + d2 + "|" + e2 + "|" + f2;
          }, i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_ = RegExp("(?:" + i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_() + ")$", "i"), i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_ = RegExp("^" + i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_ + "$|^" + i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_ + "(?:" + i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_() + ")?$", "i"), i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_ = /\D+/, i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_ = /(\$\d)/, i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_ = /\$NP/, i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_ = /\$FG/, i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_ = /\$CC/, i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_ = /^\(?\$1\)?$/, i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY = "001", i18n.phonenumbers.PhoneNumberFormat = {
            E164: 0,
            INTERNATIONAL: 1,
            NATIONAL: 2,
            RFC3966: 3
          }, i18n.phonenumbers.PhoneNumberType = {
            FIXED_LINE: 0,
            MOBILE: 1,
            FIXED_LINE_OR_MOBILE: 2,
            TOLL_FREE: 3,
            PREMIUM_RATE: 4,
            SHARED_COST: 5,
            VOIP: 6,
            PERSONAL_NUMBER: 7,
            PAGER: 8,
            UAN: 9,
            VOICEMAIL: 10,
            UNKNOWN: -1
          }, i18n.phonenumbers.PhoneNumberUtil.MatchType = {
            NOT_A_NUMBER: 0,
            NO_MATCH: 1,
            SHORT_NSN_MATCH: 2,
            NSN_MATCH: 3,
            EXACT_MATCH: 4
          }, i18n.phonenumbers.PhoneNumberUtil.ValidationResult = {
            IS_POSSIBLE: 0,
            IS_POSSIBLE_LOCAL_ONLY: 4,
            INVALID_COUNTRY_CODE: 1,
            TOO_SHORT: 2,
            INVALID_LENGTH: 5,
            TOO_LONG: 3
          }, i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber = function(a2) {
            var b2 = a2.search(i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_);
            return 0 <= b2 ? (a2 = a2.substring(b2), a2 = a2.replace(i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_, ""), b2 = a2.search(i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_), 0 <= b2 && (a2 = a2.substring(0, b2))) : a2 = "", a2;
          }, i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber = function(a2) {
            return a2.length < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ ? false : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_, a2);
          }, i18n.phonenumbers.PhoneNumberUtil.normalize = function(a2) {
            return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_, a2) ? i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a2, i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_, true) : i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(a2);
          }, i18n.phonenumbers.PhoneNumberUtil.normalizeSB_ = function(a2) {
            var b2 = i18n.phonenumbers.PhoneNumberUtil.normalize(a2.toString());
            a2.clear(), a2.append(b2);
          }, i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly = function(a2) {
            return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a2, i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS, true);
          }, i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly = function(a2) {
            return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a2, i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_, true);
          }, i18n.phonenumbers.PhoneNumberUtil.convertAlphaCharactersInNumber = function(a2) {
            return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a2, i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_, false);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfGeographicalAreaCode = function(a2) {
            var b2 = this.getMetadataForRegion(this.getRegionCodeForNumber(a2));
            return b2 != null && (b2.hasNationalPrefix() || a2.hasItalianLeadingZero()) && this.isNumberGeographical(a2) ? this.getLengthOfNationalDestinationCode(a2) : 0;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfNationalDestinationCode = function(a2) {
            if (a2.hasExtension()) {
              var b2 = a2.clone();
              b2.clearExtension();
            } else b2 = a2;
            return b2 = this.format(b2, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).split(i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_), b2[0].length == 0 && b2.shift(), 2 >= b2.length ? 0 : this.getNumberType(a2) == i18n.phonenumbers.PhoneNumberType.MOBILE && (a2 = i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken(a2.getCountryCodeOrDefault()), a2 != "") ? b2[2].length + a2.length : b2[1].length;
          }, i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken = function(a2) {
            return i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_[a2] || "";
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedRegions = function() {
            return Object.keys(i18n.phonenumbers.metadata.countryToMetadata).filter(function(a2) {
              return isNaN(a2);
            });
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedGlobalNetworkCallingCodes = function() {
            return Object.keys(i18n.phonenumbers.metadata.countryToMetadata).filter(function(a2) {
              return !isNaN(a2);
            }).map(function(a2) {
              return parseInt(a2, 10);
            });
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedCallingCodes = function() {
            var a2 = Object.keys(i18n.phonenumbers.metadata.countryCodeToRegionCodeMap);
            return [].concat($jscomp.arrayFromIterable(this.getSupportedGlobalNetworkCallingCodes()), $jscomp.arrayFromIterable(a2.map(function(b2) {
              return parseInt(b2, 10);
            })));
          }, i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_ = function(a2) {
            return a2 != null && (a2.possibleLengthCount() != 1 || a2.possibleLengthArray()[0] != -1);
          }, i18n.phonenumbers.PhoneNumberUtil.descHasData_ = function(a2) {
            return a2 != null && (a2.hasExampleNumber() || i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(a2) || a2.hasNationalNumberPattern());
          }, i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_ = function(a2) {
            var b2 = [];
            return goog.object.forEach(i18n.phonenumbers.PhoneNumberType, function(c$12) {
              if (c$12 != i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE && c$12 != i18n.phonenumbers.PhoneNumberType.UNKNOWN) {
                var d2 = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(a2, c$12);
                i18n.phonenumbers.PhoneNumberUtil.descHasData_(d2) && b2.push(c$12);
              }
            }), b2;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForRegion = function(a2) {
            return this.isValidRegionCode_(a2) ? i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(this.getMetadataForRegion(a2)) : [];
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForNonGeoEntity = function(a2) {
            return a2 = this.getMetadataForNonGeographicalRegion(a2), a2 == null ? [] : i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(a2);
          }, i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_ = function(a2, b2, c$12) {
            for (var d2 = new goog.string.StringBuffer(), e2, f2, g2 = a2.length, h = 0; h < g2; ++h) e2 = a2.charAt(h), f2 = b2[e2.toUpperCase()], f2 == null ? c$12 || d2.append(e2) : d2.append(f2);
            return d2.toString();
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.formattingRuleHasFirstGroupOnly = function(a2) {
            return a2.length == 0 || i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_.test(a2);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberGeographical = function(a2) {
            var b2 = this.getNumberType(a2);
            return b2 == i18n.phonenumbers.PhoneNumberType.FIXED_LINE || b2 == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE || i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_.includes(a2.getCountryCodeOrDefault()) && b2 == i18n.phonenumbers.PhoneNumberType.MOBILE;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.isValidRegionCode_ = function(a2) {
            return a2 != null && isNaN(a2) && a2.toUpperCase() in i18n.phonenumbers.metadata.countryToMetadata;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.hasValidCountryCallingCode_ = function(a2) {
            return a2 in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.format = function(a2, b2) {
            if (a2.getNationalNumber() == 0 && a2.hasRawInput()) {
              var c$12 = a2.getRawInputOrDefault();
              if (0 < c$12.length) return c$12;
            }
            c$12 = a2.getCountryCodeOrDefault();
            var d2 = this.getNationalSignificantNumber(a2);
            if (b2 == i18n.phonenumbers.PhoneNumberFormat.E164) return this.prefixNumberWithCountryCallingCode_(c$12, i18n.phonenumbers.PhoneNumberFormat.E164, d2, "");
            if (!this.hasValidCountryCallingCode_(c$12)) return d2;
            var e2 = this.getRegionCodeForCountryCode(c$12);
            return e2 = this.getMetadataForRegionOrCallingCode_(c$12, e2), a2 = this.maybeGetFormattedExtension_(a2, e2, b2), d2 = this.formatNsn_(d2, e2, b2), this.prefixNumberWithCountryCallingCode_(c$12, b2, d2, a2);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatByPattern = function(a2, b2, c$12) {
            var d2 = a2.getCountryCodeOrDefault(), e2 = this.getNationalSignificantNumber(a2);
            if (!this.hasValidCountryCallingCode_(d2)) return e2;
            var f2 = this.getRegionCodeForCountryCode(d2);
            f2 = this.getMetadataForRegionOrCallingCode_(d2, f2);
            var g2 = this.chooseFormattingPatternForNumber_(c$12, e2);
            if (g2 != null) {
              if (c$12 = g2.clone(), g2 = g2.getNationalPrefixFormattingRuleOrDefault(), 0 < g2.length) {
                var h = f2.getNationalPrefixOrDefault();
                0 < h.length ? (g2 = g2.replace(i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_, h).replace(i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_, "$1"), c$12.setNationalPrefixFormattingRule(g2)) : c$12.clearNationalPrefixFormattingRule();
              }
              e2 = this.formatNsnUsingPattern_(e2, c$12, b2);
            }
            return a2 = this.maybeGetFormattedExtension_(a2, f2, b2), this.prefixNumberWithCountryCallingCode_(d2, b2, e2, a2);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithCarrierCode = function(a2, b2) {
            var c$12 = a2.getCountryCodeOrDefault(), d2 = this.getNationalSignificantNumber(a2);
            if (!this.hasValidCountryCallingCode_(c$12)) return d2;
            var e2 = this.getRegionCodeForCountryCode(c$12);
            return e2 = this.getMetadataForRegionOrCallingCode_(c$12, e2), a2 = this.maybeGetFormattedExtension_(a2, e2, i18n.phonenumbers.PhoneNumberFormat.NATIONAL), b2 = this.formatNsn_(d2, e2, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, b2), this.prefixNumberWithCountryCallingCode_(c$12, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, b2, a2);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegionOrCallingCode_ = function(a2, b2) {
            return i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY == b2 ? this.getMetadataForNonGeographicalRegion(a2) : this.getMetadataForRegion(b2);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithPreferredCarrierCode = function(a2, b2) {
            return this.formatNationalNumberWithCarrierCode(a2, 0 < a2.getPreferredDomesticCarrierCodeOrDefault().length ? a2.getPreferredDomesticCarrierCodeOrDefault() : b2);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatNumberForMobileDialing = function(a2, b2, c$12) {
            var d2 = a2.getCountryCodeOrDefault();
            if (!this.hasValidCountryCallingCode_(d2)) return a2.hasRawInput() ? a2.getRawInputOrDefault() : "";
            var e2 = "";
            a2 = a2.clone(), a2.clearExtension();
            var f2 = this.getRegionCodeForCountryCode(d2), g2 = this.getNumberType(a2), h = g2 != i18n.phonenumbers.PhoneNumberType.UNKNOWN;
            if (b2 == f2) e2 = g2 == i18n.phonenumbers.PhoneNumberType.FIXED_LINE || g2 == i18n.phonenumbers.PhoneNumberType.MOBILE || g2 == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE, f2 == "BR" && e2 ? e2 = 0 < a2.getPreferredDomesticCarrierCodeOrDefault().length ? this.formatNationalNumberWithPreferredCarrierCode(a2, "") : "" : d2 == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_ ? (b2 = this.getMetadataForRegion(b2), e2 = this.canBeInternationallyDialled(a2) && this.testNumberLength_(this.getNationalSignificantNumber(a2), b2) != i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT ? this.format(a2, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a2, i18n.phonenumbers.PhoneNumberFormat.NATIONAL)) : e2 = (f2 == i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY || (f2 == "MX" || f2 == "CL" || f2 == "UZ") && e2) && this.canBeInternationallyDialled(a2) ? this.format(a2, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a2, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
            else if (h && this.canBeInternationallyDialled(a2)) return c$12 ? this.format(a2, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a2, i18n.phonenumbers.PhoneNumberFormat.E164);
            return c$12 ? e2 : i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(e2);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryCallingNumber = function(a2, b2) {
            if (!this.isValidRegionCode_(b2)) return this.format(a2, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
            var c$12 = a2.getCountryCodeOrDefault(), d2 = this.getNationalSignificantNumber(a2);
            if (!this.hasValidCountryCallingCode_(c$12)) return d2;
            if (c$12 == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_) {
              if (this.isNANPACountry(b2)) return c$12 + " " + this.format(a2, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
            } else if (c$12 == this.getCountryCodeForValidRegion_(b2)) return this.format(a2, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
            var e2 = this.getMetadataForRegion(b2), f2 = e2.getInternationalPrefixOrDefault();
            return b2 = "", e2.hasPreferredInternationalPrefix() ? b2 = e2.getPreferredInternationalPrefixOrDefault() : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_, f2) && (b2 = f2), e2 = this.getRegionCodeForCountryCode(c$12), e2 = this.getMetadataForRegionOrCallingCode_(c$12, e2), d2 = this.formatNsn_(d2, e2, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL), a2 = this.maybeGetFormattedExtension_(a2, e2, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL), 0 < b2.length ? b2 + " " + c$12 + " " + d2 + a2 : this.prefixNumberWithCountryCallingCode_(c$12, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL, d2, a2);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatInOriginalFormat = function(a2, b2) {
            if (a2.hasRawInput() && !this.hasFormattingPatternForNumber_(a2)) return a2.getRawInputOrDefault();
            if (!a2.hasCountryCodeSource()) return this.format(a2, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
            switch (a2.getCountryCodeSource()) {
              case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN:
                b2 = this.format(a2, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
                break;
              case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD:
                b2 = this.formatOutOfCountryCallingNumber(a2, b2);
                break;
              case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN:
                b2 = this.format(a2, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).substring(1);
                break;
              default:
                var c$12 = this.getRegionCodeForCountryCode(a2.getCountryCodeOrDefault()), d2 = this.getNddPrefixForRegion(c$12, true);
                if (b2 = this.format(a2, i18n.phonenumbers.PhoneNumberFormat.NATIONAL), d2 != null && d2.length != 0 && !this.rawInputContainsNationalPrefix_(a2.getRawInputOrDefault(), d2, c$12) && (c$12 = this.getMetadataForRegion(c$12), d2 = this.getNationalSignificantNumber(a2), c$12 = this.chooseFormattingPatternForNumber_(c$12.numberFormatArray(), d2), c$12 != null)) {
                  d2 = c$12.getNationalPrefixFormattingRuleOrDefault();
                  var e2 = d2.indexOf("$1");
                  0 >= e2 || (d2 = d2.substring(0, e2), d2 = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d2), d2.length != 0 && (b2 = c$12.clone(), b2.clearNationalPrefixFormattingRule(), b2 = this.formatByPattern(a2, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, [b2])));
                }
            }
            return a2 = a2.getRawInputOrDefault(), b2 != null && 0 < a2.length && (c$12 = i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(b2), d2 = i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(a2), c$12 != d2 && (b2 = a2)), b2;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.rawInputContainsNationalPrefix_ = function(a2, b2, c$12) {
            if (a2 = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(a2), goog.string.startsWith(a2, b2)) try {
              return this.isValidNumber(this.parse(a2.substring(b2.length), c$12));
            } catch {
            }
            return false;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.hasFormattingPatternForNumber_ = function(a2) {
            var b2 = a2.getCountryCodeOrDefault(), c$12 = this.getRegionCodeForCountryCode(b2);
            return b2 = this.getMetadataForRegionOrCallingCode_(b2, c$12), b2 == null ? false : (a2 = this.getNationalSignificantNumber(a2), this.chooseFormattingPatternForNumber_(b2.numberFormatArray(), a2) != null);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryKeepingAlphaChars = function(a2, b2) {
            var c$12 = a2.getRawInputOrDefault();
            if (c$12.length == 0) return this.formatOutOfCountryCallingNumber(a2, b2);
            var d2 = a2.getCountryCodeOrDefault();
            if (!this.hasValidCountryCallingCode_(d2)) return c$12;
            c$12 = i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(c$12, i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_, true);
            var e2 = this.getNationalSignificantNumber(a2);
            if (3 < e2.length) {
              var f2 = c$12.indexOf(e2.substring(0, 3));
              f2 != -1 && (c$12 = c$12.substring(f2));
            }
            if (f2 = this.getMetadataForRegion(b2), d2 == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_) {
              if (this.isNANPACountry(b2)) return d2 + " " + c$12;
            } else if (f2 != null && d2 == this.getCountryCodeForValidRegion_(b2)) return d2 = this.chooseFormattingPatternForNumber_(f2.numberFormatArray(), e2), d2 == null ? c$12 : (d2 = d2.clone(), d2.setPattern("(\\d+)(.*)"), d2.setFormat("$1$2"), this.formatNsnUsingPattern_(c$12, d2, i18n.phonenumbers.PhoneNumberFormat.NATIONAL));
            return b2 = "", f2 != null && (b2 = f2.getInternationalPrefixOrDefault(), b2 = i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_, b2) ? b2 : f2.getPreferredInternationalPrefixOrDefault()), f2 = this.getRegionCodeForCountryCode(d2), f2 = this.getMetadataForRegionOrCallingCode_(d2, f2), a2 = this.maybeGetFormattedExtension_(a2, f2, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL), 0 < b2.length ? b2 + " " + d2 + " " + c$12 + a2 : this.prefixNumberWithCountryCallingCode_(d2, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL, c$12, a2);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.getNationalSignificantNumber = function(a2) {
            if (!a2.hasNationalNumber()) return "";
            var b2 = "" + a2.getNationalNumber();
            return a2.hasItalianLeadingZero() && a2.getItalianLeadingZero() && 0 < a2.getNumberOfLeadingZerosOrDefault() ? Array(a2.getNumberOfLeadingZerosOrDefault() + 1).join("0") + b2 : b2;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.prefixNumberWithCountryCallingCode_ = function(a2, b2, c$12, d2) {
            switch (b2) {
              case i18n.phonenumbers.PhoneNumberFormat.E164:
                return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a2 + c$12 + d2;
              case i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL:
                return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a2 + " " + c$12 + d2;
              case i18n.phonenumbers.PhoneNumberFormat.RFC3966:
                return i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_ + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a2 + "-" + c$12 + d2;
              default:
                return c$12 + d2;
            }
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsn_ = function(a2, b2, c$12, d2) {
            return b2 = b2.intlNumberFormatArray().length == 0 || c$12 == i18n.phonenumbers.PhoneNumberFormat.NATIONAL ? b2.numberFormatArray() : b2.intlNumberFormatArray(), b2 = this.chooseFormattingPatternForNumber_(b2, a2), b2 == null ? a2 : this.formatNsnUsingPattern_(a2, b2, c$12, d2);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.chooseFormattingPatternForNumber_ = function(a2, b2) {
            for (var c$12, d2 = a2.length, e2 = 0; e2 < d2; ++e2) {
              c$12 = a2[e2];
              var f2 = c$12.leadingDigitsPatternCount();
              if ((f2 == 0 || b2.search(c$12.getLeadingDigitsPattern(f2 - 1)) == 0) && (f2 = new RegExp(c$12.getPattern()), i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f2, b2))) return c$12;
            }
            return null;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsnUsingPattern_ = function(a2, b2, c$12, d2) {
            var e2 = b2.getFormatOrDefault(), f2 = new RegExp(b2.getPattern()), g2 = b2.getDomesticCarrierCodeFormattingRuleOrDefault();
            return c$12 == i18n.phonenumbers.PhoneNumberFormat.NATIONAL && d2 != null && 0 < d2.length && 0 < g2.length ? (b2 = g2.replace(i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_, d2), e2 = e2.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_, b2), a2 = a2.replace(f2, e2)) : (b2 = b2.getNationalPrefixFormattingRuleOrDefault(), a2 = c$12 == i18n.phonenumbers.PhoneNumberFormat.NATIONAL && b2 != null && 0 < b2.length ? a2.replace(f2, e2.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_, b2)) : a2.replace(f2, e2)), c$12 == i18n.phonenumbers.PhoneNumberFormat.RFC3966 && (a2 = a2.replace(/* @__PURE__ */ RegExp("^" + i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_), ""), a2 = a2.replace(new RegExp(i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_, "g"), "-")), a2;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumber = function(a2) {
            return this.getExampleNumberForType(a2, i18n.phonenumbers.PhoneNumberType.FIXED_LINE);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForType = function(a2, b2) {
            if (!this.isValidRegionCode_(a2)) return null;
            b2 = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(this.getMetadataForRegion(a2), b2);
            try {
              if (b2.hasExampleNumber()) return this.parse(b2.getExampleNumber(), a2);
            } catch {
            }
            return null;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForNonGeoEntity = function(a2) {
            var b2 = this.getMetadataForNonGeographicalRegion(a2);
            if (b2 != null && (b2 = [
              b2.getMobile(),
              b2.getTollFree(),
              b2.getSharedCost(),
              b2.getVoip(),
              b2.getVoicemail(),
              b2.getUan(),
              b2.getPremiumRate()
            ].find(function(c$12, d2) {
              return c$12.hasExampleNumber();
            }), b2 !== void 0)) try {
              return this.parse("+" + a2 + b2.getExampleNumber(), "ZZ");
            } catch {
            }
            return null;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.maybeGetFormattedExtension_ = function(a2, b2, c$12) {
            return a2.hasExtension() && a2.getExtension().length != 0 ? c$12 == i18n.phonenumbers.PhoneNumberFormat.RFC3966 ? i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ + a2.getExtension() : b2.hasPreferredExtnPrefix() ? b2.getPreferredExtnPrefix() + a2.getExtensionOrDefault() : i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_ + a2.getExtensionOrDefault() : "";
          }, i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_ = function(a2, b2) {
            switch (b2) {
              case i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE:
                return a2.getPremiumRate();
              case i18n.phonenumbers.PhoneNumberType.TOLL_FREE:
                return a2.getTollFree();
              case i18n.phonenumbers.PhoneNumberType.MOBILE:
                return a2.getMobile();
              case i18n.phonenumbers.PhoneNumberType.FIXED_LINE:
              case i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE:
                return a2.getFixedLine();
              case i18n.phonenumbers.PhoneNumberType.SHARED_COST:
                return a2.getSharedCost();
              case i18n.phonenumbers.PhoneNumberType.VOIP:
                return a2.getVoip();
              case i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER:
                return a2.getPersonalNumber();
              case i18n.phonenumbers.PhoneNumberType.PAGER:
                return a2.getPager();
              case i18n.phonenumbers.PhoneNumberType.UAN:
                return a2.getUan();
              case i18n.phonenumbers.PhoneNumberType.VOICEMAIL:
                return a2.getVoicemail();
              default:
                return a2.getGeneralDesc();
            }
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberType = function(a2) {
            var b2 = this.getRegionCodeForNumber(a2);
            return b2 = this.getMetadataForRegionOrCallingCode_(a2.getCountryCodeOrDefault(), b2), b2 == null ? i18n.phonenumbers.PhoneNumberType.UNKNOWN : (a2 = this.getNationalSignificantNumber(a2), this.getNumberTypeHelper_(a2, b2));
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberTypeHelper_ = function(a2, b2) {
            return this.isNumberMatchingDesc_(a2, b2.getGeneralDesc()) ? this.isNumberMatchingDesc_(a2, b2.getPremiumRate()) ? i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE : this.isNumberMatchingDesc_(a2, b2.getTollFree()) ? i18n.phonenumbers.PhoneNumberType.TOLL_FREE : this.isNumberMatchingDesc_(a2, b2.getSharedCost()) ? i18n.phonenumbers.PhoneNumberType.SHARED_COST : this.isNumberMatchingDesc_(a2, b2.getVoip()) ? i18n.phonenumbers.PhoneNumberType.VOIP : this.isNumberMatchingDesc_(a2, b2.getPersonalNumber()) ? i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER : this.isNumberMatchingDesc_(a2, b2.getPager()) ? i18n.phonenumbers.PhoneNumberType.PAGER : this.isNumberMatchingDesc_(a2, b2.getUan()) ? i18n.phonenumbers.PhoneNumberType.UAN : this.isNumberMatchingDesc_(a2, b2.getVoicemail()) ? i18n.phonenumbers.PhoneNumberType.VOICEMAIL : this.isNumberMatchingDesc_(a2, b2.getFixedLine()) ? b2.getSameMobileAndFixedLinePattern() || this.isNumberMatchingDesc_(a2, b2.getMobile()) ? i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE : i18n.phonenumbers.PhoneNumberType.FIXED_LINE : !b2.getSameMobileAndFixedLinePattern() && this.isNumberMatchingDesc_(a2, b2.getMobile()) ? i18n.phonenumbers.PhoneNumberType.MOBILE : i18n.phonenumbers.PhoneNumberType.UNKNOWN : i18n.phonenumbers.PhoneNumberType.UNKNOWN;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegion = function(a2) {
            if (a2 == null) return null;
            a2 = a2.toUpperCase();
            var b2 = this.regionToMetadataMap[a2];
            if (b2 == null) {
              b2 = new goog.proto2.PbLiteSerializer();
              var c$12 = i18n.phonenumbers.metadata.countryToMetadata[a2];
              if (c$12 == null) return null;
              b2 = b2.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(), c$12), this.regionToMetadataMap[a2] = b2;
            }
            return b2;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForNonGeographicalRegion = function(a2) {
            return this.getMetadataForRegion("" + a2);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatchingDesc_ = function(a2, b2) {
            var c$12 = a2.length;
            return 0 < b2.possibleLengthCount() && b2.possibleLengthArray().indexOf(c$12) == -1 ? false : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(b2.getNationalNumberPatternOrDefault(), a2);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumber = function(a2) {
            var b2 = this.getRegionCodeForNumber(a2);
            return this.isValidNumberForRegion(a2, b2);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumberForRegion = function(a2, b2) {
            var c$12 = a2.getCountryCodeOrDefault(), d2 = this.getMetadataForRegionOrCallingCode_(c$12, b2);
            return d2 == null || i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY != b2 && c$12 != this.getCountryCodeForValidRegion_(b2) ? false : (a2 = this.getNationalSignificantNumber(a2), this.getNumberTypeHelper_(a2, d2) != i18n.phonenumbers.PhoneNumberType.UNKNOWN);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumber = function(a2) {
            if (a2 == null) return null;
            var b2 = a2.getCountryCodeOrDefault();
            return b2 = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[b2], b2 == null ? null : b2.length == 1 ? b2[0] : this.getRegionCodeForNumberFromRegionList_(a2, b2);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumberFromRegionList_ = function(a2, b2) {
            a2 = this.getNationalSignificantNumber(a2);
            for (var c$12, d2 = b2.length, e2 = 0; e2 < d2; e2++) {
              c$12 = b2[e2];
              var f2 = this.getMetadataForRegion(c$12);
              if (f2.hasLeadingDigits()) {
                if (a2.search(f2.getLeadingDigits()) == 0) return c$12;
              } else if (this.getNumberTypeHelper_(a2, f2) != i18n.phonenumbers.PhoneNumberType.UNKNOWN) return c$12;
            }
            return null;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForCountryCode = function(a2) {
            return a2 = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a2], a2 == null ? i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_ : a2[0];
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodesForCountryCode = function(a2) {
            return a2 = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a2], a2 ?? [];
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForRegion = function(a2) {
            return this.isValidRegionCode_(a2) ? this.getCountryCodeForValidRegion_(a2) : 0;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForValidRegion_ = function(a2) {
            var b2 = this.getMetadataForRegion(a2);
            if (b2 == null) throw Error("Invalid region code: " + a2);
            return b2.getCountryCodeOrDefault();
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.getNddPrefixForRegion = function(a2, b2) {
            return a2 = this.getMetadataForRegion(a2), a2 == null || (a2 = a2.getNationalPrefixOrDefault(), a2.length == 0) ? null : (b2 && (a2 = a2.replace("~", "")), a2);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.isNANPACountry = function(a2) {
            return a2 != null && i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_].includes(a2.toUpperCase());
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.isAlphaNumber = function(a2) {
            return i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(a2) ? (a2 = new goog.string.StringBuffer(a2), this.maybeStripExtension(a2), i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_, a2.toString())) : false;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumber = function(a2) {
            return a2 = this.isPossibleNumberWithReason(a2), a2 == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE || a2 == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForType = function(a2, b2) {
            return a2 = this.isPossibleNumberForTypeWithReason(a2, b2), a2 == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE || a2 == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLength_ = function(a2, b2) {
            return this.testNumberLengthForType_(a2, b2, i18n.phonenumbers.PhoneNumberType.UNKNOWN);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLengthForType_ = function(a2, b2, c$12) {
            var d2 = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b2, c$12), e2 = d2.possibleLengthCount() == 0 ? b2.getGeneralDesc().possibleLengthArray() : d2.possibleLengthArray();
            if (d2 = d2.possibleLengthLocalOnlyArray(), c$12 == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE) if (i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b2, i18n.phonenumbers.PhoneNumberType.FIXED_LINE))) c$12 = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b2, i18n.phonenumbers.PhoneNumberType.MOBILE), i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(c$12) && (e2 = e2.concat(c$12.possibleLengthCount() == 0 ? b2.getGeneralDesc().possibleLengthArray() : c$12.possibleLengthArray()), e2.sort(), d2.length == 0 ? d2 = c$12.possibleLengthLocalOnlyArray() : (d2 = d2.concat(c$12.possibleLengthLocalOnlyArray()), d2.sort()));
            else return this.testNumberLengthForType_(a2, b2, i18n.phonenumbers.PhoneNumberType.MOBILE);
            return e2[0] == -1 ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH : (a2 = a2.length, -1 < d2.indexOf(a2) ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY : (b2 = e2[0], b2 == a2 ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE : b2 > a2 ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT : e2[e2.length - 1] < a2 ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG : -1 < e2.indexOf(a2, 1) ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE : i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH));
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberWithReason = function(a2) {
            return this.isPossibleNumberForTypeWithReason(a2, i18n.phonenumbers.PhoneNumberType.UNKNOWN);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForTypeWithReason = function(a2, b2) {
            var c$12 = this.getNationalSignificantNumber(a2);
            if (a2 = a2.getCountryCodeOrDefault(), !this.hasValidCountryCallingCode_(a2)) return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_COUNTRY_CODE;
            var d2 = this.getRegionCodeForCountryCode(a2);
            return a2 = this.getMetadataForRegionOrCallingCode_(a2, d2), this.testNumberLengthForType_(c$12, a2, b2);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberString = function(a2, b2) {
            try {
              return this.isPossibleNumber(this.parse(a2, b2));
            } catch {
              return false;
            }
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.truncateTooLongNumber = function(a2) {
            if (this.isValidNumber(a2)) return true;
            var b2 = a2.clone(), c$12 = a2.getNationalNumberOrDefault();
            do
              if (c$12 = Math.floor(c$12 / 10), b2.setNationalNumber(c$12), c$12 == 0 || this.isPossibleNumberWithReason(b2) == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT) return false;
            while (!this.isValidNumber(b2));
            return a2.setNationalNumber(c$12), true;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.extractCountryCode = function(a2, b2) {
            if (a2 = a2.toString(), a2.length == 0 || a2.charAt(0) == "0") return 0;
            for (var c$12, d2 = a2.length, e2 = 1; e2 <= i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_ && e2 <= d2; ++e2) if (c$12 = parseInt(a2.substring(0, e2), 10), c$12 in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap) return b2.append(a2.substring(e2)), c$12;
            return 0;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.maybeExtractCountryCode = function(a2, b2, c$12, d2, e2) {
            if (a2.length == 0) return 0;
            a2 = new goog.string.StringBuffer(a2);
            var f2;
            if (b2 != null && (f2 = b2.getInternationalPrefix()), f2 ??= "NonMatch", f2 = this.maybeStripInternationalPrefixAndNormalize(a2, f2), d2 && e2.setCountryCodeSource(f2), f2 != i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY) {
              if (a2.getLength() <= i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_) throw Error(i18n.phonenumbers.Error.TOO_SHORT_AFTER_IDD);
              if (b2 = this.extractCountryCode(a2, c$12), b2 != 0) return e2.setCountryCode(b2), b2;
              throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
            }
            if (b2 != null) {
              f2 = b2.getCountryCodeOrDefault();
              var g2 = "" + f2, h = a2.toString();
              if (goog.string.startsWith(h, g2) && (g2 = new goog.string.StringBuffer(h.substring(g2.length)), h = b2.getGeneralDesc(), h = new RegExp(h.getNationalNumberPatternOrDefault()), this.maybeStripNationalPrefixAndCarrierCode(g2, b2, null), g2 = g2.toString(), !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(h, a2.toString()) && i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(h, g2) || this.testNumberLength_(a2.toString(), b2) == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG)) return c$12.append(g2), d2 && e2.setCountryCodeSource(i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN), e2.setCountryCode(f2), f2;
            }
            return e2.setCountryCode(0), 0;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.parsePrefixAsIdd_ = function(a2, b2) {
            var c$12 = b2.toString();
            if (c$12.search(a2) == 0) {
              a2 = c$12.match(a2)[0].length;
              var d2 = c$12.substring(a2).match(i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN);
              return d2 && d2[1] != null && 0 < d2[1].length && i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d2[1]) == "0" ? false : (b2.clear(), b2.append(c$12.substring(a2)), true);
            }
            return false;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripInternationalPrefixAndNormalize = function(a2, b2) {
            var c$12 = a2.toString();
            return c$12.length == 0 ? i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY : i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(c$12) ? (c$12 = c$12.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN, ""), a2.clear(), a2.append(i18n.phonenumbers.PhoneNumberUtil.normalize(c$12)), i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN) : (b2 = new RegExp(b2), i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(a2), this.parsePrefixAsIdd_(b2, a2) ? i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD : i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripNationalPrefixAndCarrierCode = function(a2, b2, c$12) {
            var d2 = a2.toString(), e2 = d2.length, f2 = b2.getNationalPrefixForParsing();
            if (e2 == 0 || f2 == null || f2.length == 0) return false;
            var g2 = /* @__PURE__ */ RegExp("^(?:" + f2 + ")");
            if (e2 = g2.exec(d2)) {
              f2 = new RegExp(b2.getGeneralDesc().getNationalNumberPatternOrDefault());
              var h = i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f2, d2), k = e2.length - 1;
              if (b2 = b2.getNationalPrefixTransformRule(), b2 == null || b2.length == 0 || e2[k] == null || e2[k].length == 0) {
                if (h && !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f2, d2.substring(e2[0].length))) return false;
                c$12 != null && 0 < k && e2[k] != null && c$12.append(e2[1]), a2.set(d2.substring(e2[0].length));
              } else {
                if (d2 = d2.replace(g2, b2), h && !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f2, d2)) return false;
                c$12 != null && 0 < k && c$12.append(e2[1]), a2.set(d2);
              }
              return true;
            }
            return false;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripExtension = function(a2) {
            var b2 = a2.toString(), c$12 = b2.search(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_);
            if (0 <= c$12 && i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(b2.substring(0, c$12))) {
              for (var d2 = b2.match(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_), e2 = d2.length, f2 = 1; f2 < e2; ++f2) if (d2[f2] != null && 0 < d2[f2].length) return a2.clear(), a2.append(b2.substring(0, c$12)), d2[f2];
            }
            return "";
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.checkRegionForParsing_ = function(a2, b2) {
            return this.isValidRegionCode_(b2) || a2 != null && 0 < a2.length && i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(a2);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.parse = function(a2, b2) {
            return this.parseHelper_(a2, b2, false, true);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.parseAndKeepRawInput = function(a2, b2) {
            if (!this.isValidRegionCode_(b2) && 0 < a2.length && a2.charAt(0) != i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
            return this.parseHelper_(a2, b2, true, true);
          }, i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_ = function(a2, b2) {
            if (1 < a2.length && a2.charAt(0) == "0") {
              b2.setItalianLeadingZero(true);
              for (var c$12 = 1; c$12 < a2.length - 1 && a2.charAt(c$12) == "0"; ) c$12++;
              c$12 != 1 && b2.setNumberOfLeadingZeros(c$12);
            }
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.parseHelper_ = function(a2, b2, c$12, d2) {
            if (a2 == null) throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
            if (a2.length > i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_) throw Error(i18n.phonenumbers.Error.TOO_LONG);
            var e2 = new goog.string.StringBuffer();
            if (this.buildNationalNumberForParsing_(a2, e2), !i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(e2.toString())) throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
            if (d2 && !this.checkRegionForParsing_(e2.toString(), b2)) throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
            d2 = new i18n.phonenumbers.PhoneNumber(), c$12 && d2.setRawInput(a2), a2 = this.maybeStripExtension(e2), 0 < a2.length && d2.setExtension(a2);
            var f2 = this.getMetadataForRegion(b2);
            a2 = new goog.string.StringBuffer();
            var g2 = 0, h = e2.toString();
            try {
              g2 = this.maybeExtractCountryCode(h, f2, a2, c$12, d2);
            } catch (k) {
              if (k.message == i18n.phonenumbers.Error.INVALID_COUNTRY_CODE && i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(h)) {
                if (h = h.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN, ""), g2 = this.maybeExtractCountryCode(h, f2, a2, c$12, d2), g2 == 0) throw k;
              } else throw k;
            }
            if (g2 == 0 ? (i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(e2), a2.append(e2.toString()), b2 == null ? c$12 && d2.clearCountryCodeSource() : (g2 = f2.getCountryCodeOrDefault(), d2.setCountryCode(g2))) : (e2 = this.getRegionCodeForCountryCode(g2), e2 != b2 && (f2 = this.getMetadataForRegionOrCallingCode_(g2, e2))), a2.getLength() < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ || (f2 != null && (b2 = new goog.string.StringBuffer(), e2 = new goog.string.StringBuffer(a2.toString()), this.maybeStripNationalPrefixAndCarrierCode(e2, f2, b2), f2 = this.testNumberLength_(e2.toString(), f2), g2 = i18n.phonenumbers.PhoneNumberUtil.ValidationResult, f2 != g2.TOO_SHORT && f2 != g2.IS_POSSIBLE_LOCAL_ONLY && f2 != g2.INVALID_LENGTH && (a2 = e2, c$12 && 0 < b2.toString().length && d2.setPreferredDomesticCarrierCode(b2.toString()))), c$12 = a2.toString(), a2 = c$12.length, a2 < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_)) throw Error(i18n.phonenumbers.Error.TOO_SHORT_NSN);
            if (a2 > i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_) throw Error(i18n.phonenumbers.Error.TOO_LONG);
            return i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_(c$12, d2), d2.setNationalNumber(parseInt(c$12, 10)), d2;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.extractPhoneContext_ = function(a2) {
            var b2 = a2.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_);
            if (b2 === -1) return null;
            if (b2 += i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_.length, b2 >= a2.length) return "";
            var c$12 = a2.indexOf(";", b2);
            return c$12 === -1 ? a2.substring(b2) : a2.substring(b2, c$12);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.isPhoneContextValid_ = function(a2) {
            if (a2 == null) return true;
            if (a2.length === 0) return false;
            var b2 = i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.exec(a2);
            return a2 = i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_PATTERN_.exec(a2), b2 !== null || a2 !== null;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.buildNationalNumberForParsing_ = function(a2, b2) {
            var c$12 = i18n.phonenumbers.PhoneNumberUtil.prototype.extractPhoneContext_(a2);
            if (!i18n.phonenumbers.PhoneNumberUtil.prototype.isPhoneContextValid_(c$12)) throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
            if (c$12 != null) {
              c$12.charAt(0) === i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN && b2.append(c$12), c$12 = a2.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_), c$12 = 0 <= c$12 ? c$12 + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_.length : 0;
              var d2 = a2.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_);
              b2.append(a2.substring(c$12, d2));
            } else b2.append(i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(a2 ?? ""));
            a2 = b2.toString(), c$12 = a2.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_), 0 < c$12 && (b2.clear(), b2.append(a2.substring(0, c$12)));
          }, i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_ = function(a2) {
            var b2 = new i18n.phonenumbers.PhoneNumber();
            return b2.setCountryCode(a2.getCountryCodeOrDefault()), b2.setNationalNumber(a2.getNationalNumberOrDefault()), 0 < a2.getExtensionOrDefault().length && b2.setExtension(a2.getExtensionOrDefault()), a2.getItalianLeadingZero() && (b2.setItalianLeadingZero(true), b2.setNumberOfLeadingZeros(a2.getNumberOfLeadingZerosOrDefault())), b2;
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatch = function(a2, b2) {
            if (typeof a2 == "string") try {
              var c$12 = this.parse(a2, i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_);
            } catch (f2) {
              if (f2.message != i18n.phonenumbers.Error.INVALID_COUNTRY_CODE) return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
              if (typeof b2 != "string") {
                var d2 = this.getRegionCodeForCountryCode(b2.getCountryCodeOrDefault());
                if (d2 != i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_) {
                  try {
                    c$12 = this.parse(a2, d2);
                  } catch {
                    return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
                  }
                  var e2 = this.isNumberMatch(c$12, b2);
                  return e2 == i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH : e2;
                }
              }
              try {
                c$12 = this.parseHelper_(a2, null, false, false);
              } catch {
                return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
              }
            }
            else c$12 = a2.clone();
            if (typeof b2 == "string") try {
              return e2 = this.parse(b2, i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_), this.isNumberMatch(a2, e2);
            } catch (f2) {
              return f2.message == i18n.phonenumbers.Error.INVALID_COUNTRY_CODE ? this.isNumberMatch(b2, c$12) : i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
            }
            else e2 = b2.clone();
            return a2 = i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(c$12), e2 = i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(e2), a2.hasExtension() && e2.hasExtension() && a2.getExtension() != e2.getExtension() ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH : (b2 = a2.getCountryCodeOrDefault(), c$12 = e2.getCountryCodeOrDefault(), b2 != 0 && c$12 != 0 ? a2.equals(e2) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH : b2 == c$12 && this.isNationalNumberSuffixOfTheOther_(a2, e2) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH : i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH : (a2.setCountryCode(0), e2.setCountryCode(0), a2.equals(e2) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH : this.isNationalNumberSuffixOfTheOther_(a2, e2) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH : i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH));
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.isNationalNumberSuffixOfTheOther_ = function(a2, b2) {
            return a2 = "" + a2.getNationalNumber(), b2 = "" + b2.getNationalNumber(), goog.string.endsWith(a2, b2) || goog.string.endsWith(b2, a2);
          }, i18n.phonenumbers.PhoneNumberUtil.prototype.canBeInternationallyDialled = function(a2) {
            var b2 = this.getMetadataForRegion(this.getRegionCodeForNumber(a2));
            return b2 == null ? true : (a2 = this.getNationalSignificantNumber(a2), !this.isNumberMatchingDesc_(a2, b2.getNoInternationalDialling()));
          }, i18n.phonenumbers.PhoneNumberUtil.matchesEntirely = function(a2, b2) {
            return !!((a2 = b2.match(RegExp("^(?:" + (typeof a2 == "string" ? a2 : a2.source) + ")$", "i"))) && a2[0].length == b2.length);
          }, i18n.phonenumbers.PhoneNumberUtil.matchesPrefix = function(a2, b2) {
            return !!((a2 = typeof a2 == "string" ? b2.match("^(?:" + a2 + ")") : b2.match(a2)) && goog.string.startsWith(b2, a2[0]));
          }, i18n.phonenumbers.shortnumbermetadata = {}, i18n.phonenumbers.shortnumbermetadata.countryCodeToRegionCodeMap = { 0: "AC AD AE AF AG AI AL AM AO AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GR GT GU GW GY HK HN HR HT HU ID IE IL IM IN IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TG TH TJ TL TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW".split(" ") }, i18n.phonenumbers.shortnumbermetadata.countryToMetadata = {
            AC: [
              ,
              [
                ,
                ,
                "9\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:11|99)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "AC",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "9(?:11|99)",
                ,
                ,
                ,
                "911"
              ],
              ,
              [
                ,
                ,
                "9(?:11|99)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            AD: [
              ,
              [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "11[0268]",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "AD",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[0268]",
                ,
                ,
                ,
                "110"
              ],
              ,
              [
                ,
                ,
                "11[0268]",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            AE: [
              ,
              [
                ,
                ,
                "[149]\\d{2,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "112|99[7-9]",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "AE",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112|99[7-9]",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "112|445[16]|99[7-9]",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                "445\\d",
                ,
                ,
                ,
                "4450",
                ,
                ,
                [4]
              ]
            ],
            AF: [
              ,
              [
                ,
                ,
                "[14]\\d\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:0[02]|19)",
                ,
                ,
                ,
                "100",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "AF",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:0[02]|19)",
                ,
                ,
                ,
                "100",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0[02]|19)|40404",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ]
            ],
            AG: [
              ,
              [
                ,
                ,
                "[19]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:11|88|99)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "AG",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "9(?:11|99)",
                ,
                ,
                ,
                "911"
              ],
              ,
              [
                ,
                ,
                "176|9(?:11|88|99)",
                ,
                ,
                ,
                "176"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "176",
                ,
                ,
                ,
                "176"
              ],
              ,
              [
                ,
                ,
                "176",
                ,
                ,
                ,
                "176"
              ]
            ],
            AI: [
              ,
              [
                ,
                ,
                "[19]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:11|88)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "AI",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "911",
                ,
                ,
                ,
                "911"
              ],
              ,
              [
                ,
                ,
                "176|9(?:11|88)",
                ,
                ,
                ,
                "176"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "176",
                ,
                ,
                ,
                "176"
              ],
              ,
              [
                ,
                ,
                "176",
                ,
                ,
                ,
                "176"
              ]
            ],
            AL: [
              ,
              [
                ,
                ,
                "[15]\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1(?:2|6[01]\\d\\d)|2[7-9]|3[15]|41)",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3, 6]
              ],
              [
                ,
                ,
                "5\\d{4}",
                ,
                ,
                ,
                "50000",
                ,
                ,
                [5]
              ],
              ,
              ,
              ,
              "AL",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:12|2[7-9])",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1(?:6(?:000|1(?:06|11|23))|8\\d\\d)|65\\d|89[12])|5\\d{4}|1(?:[1349]\\d|2[2-9])",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "123",
                ,
                ,
                ,
                "123",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "131|5\\d{4}",
                ,
                ,
                ,
                "131",
                ,
                ,
                [3, 5]
              ]
            ],
            AM: [
              ,
              [
                ,
                ,
                "[148]\\d{2,4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "10[1-3]",
                ,
                ,
                ,
                "101",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "AM",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "10[1-3]",
                ,
                ,
                ,
                "101",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "(?:1|8[1-7])\\d\\d|40404",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ]
            ],
            AO: [
              ,
              [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "11[235]",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "AO",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[235]",
                ,
                ,
                ,
                "112"
              ],
              ,
              [
                ,
                ,
                "11[235]",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            AR: [
              ,
              [
                ,
                ,
                "[01389]\\d{1,4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  2,
                  3,
                  4,
                  5
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "000|1(?:0[0-35-7]|1[0245]|2[015]|3[47]|4[478]|9)|911",
                ,
                ,
                ,
                "19",
                ,
                ,
                [2, 3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "AR",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "10[017]|911",
                ,
                ,
                ,
                "100",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "000|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478]|9)|3372|89338|911",
                ,
                ,
                ,
                "19"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "893\\d\\d",
                ,
                ,
                ,
                "89300",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "(?:337|893\\d)\\d",
                ,
                ,
                ,
                "3370",
                ,
                ,
                [4, 5]
              ]
            ],
            AS: [
              ,
              [
                ,
                ,
                "[49]\\d\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:11|88)",
                ,
                ,
                ,
                "911",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "AS",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "911",
                ,
                ,
                ,
                "911",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "40404|9(?:11|88)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ]
            ],
            AT: [
              ,
              [
                ,
                ,
                "[1268]\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:12|2[0238]|3[03]|4[0-247])|1(?:16\\d\\d|4[58])\\d",
                ,
                ,
                ,
                "112",
                ,
                ,
                [
                  3,
                  4,
                  6
                ]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "AT",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:[12]2|33|44)",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1(?:2|6(?:00[06]|1(?:17|23)))|2[0238]|3[03]|4(?:[0-247]|5[05]|84))|(?:2(?:066|20)|61|8108[1-3])0",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "220\\d|610|(?:206|810\\d)\\d\\d",
                ,
                ,
                ,
                "610"
              ],
              ,
              [
                ,
                ,
                "206\\d\\d",
                ,
                ,
                ,
                "20600",
                ,
                ,
                [5]
              ]
            ],
            AU: [
              ,
              [
                ,
                ,
                "[0-27]\\d{2,7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6,
                  7,
                  8
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "000|1(?:06|12|258885|55\\d)|733",
                ,
                ,
                ,
                "000",
                ,
                ,
                [
                  3,
                  4,
                  7
                ]
              ],
              [
                ,
                ,
                "1(?:2(?:34|456)|9\\d{4,6})",
                ,
                ,
                ,
                "1234",
                ,
                ,
                [
                  4,
                  5,
                  6,
                  7,
                  8
                ]
              ],
              ,
              ,
              ,
              "AU",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "000|1(?:06|12)",
                ,
                ,
                ,
                "000",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "000|1(?:06|1(?:00|2|9[46])|2(?:014[1-3]|[23]\\d|(?:4|5\\d)\\d{2,3}|68[689]|72(?:20|3\\d\\d)|8(?:[013-9]\\d|2))|555|9\\d{4,6})|225|7(?:33|67)",
                ,
                ,
                ,
                "000"
              ],
              [
                ,
                ,
                "1(?:1[09]\\d|24733)|225|767",
                ,
                ,
                ,
                "225",
                ,
                ,
                [
                  3,
                  4,
                  6
                ]
              ],
              [
                ,
                ,
                "1(?:258885|55\\d)",
                ,
                ,
                ,
                "1550",
                ,
                ,
                [4, 7]
              ],
              ,
              [
                ,
                ,
                "19\\d{4,6}",
                ,
                ,
                ,
                "190000",
                ,
                ,
                [
                  6,
                  7,
                  8
                ]
              ]
            ],
            AW: [
              ,
              [
                ,
                ,
                "[19]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "100|911",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "AW",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "100|911",
                ,
                ,
                ,
                "100"
              ],
              ,
              [
                ,
                ,
                "1(?:00|18|76)|91[13]",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "176",
                ,
                ,
                ,
                "176"
              ],
              ,
              [
                ,
                ,
                "176",
                ,
                ,
                ,
                "176"
              ]
            ],
            AX: [
              ,
              [
                ,
                ,
                "[17]\\d\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5]
              ],
              ,
              ,
              [
                ,
                ,
                "112",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "AX",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "112|75[12]\\d\\d",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            AZ: [
              ,
              [
                ,
                ,
                "[148]\\d{2,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:0[1-3]|12)",
                ,
                ,
                ,
                "101",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "AZ",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:0[1-3]|12)",
                ,
                ,
                ,
                "101",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0[1-3]|12)|(?:404|880)0",
                ,
                ,
                ,
                "101"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:404|880)\\d",
                ,
                ,
                ,
                "4040",
                ,
                ,
                [4]
              ],
              ,
              [
                ,
                ,
                "(?:404|880)\\d",
                ,
                ,
                ,
                "4040",
                ,
                ,
                [4]
              ]
            ],
            BA: [
              ,
              [
                ,
                ,
                "1\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:16\\d{3}|2[2-4])",
                ,
                ,
                ,
                "122",
                ,
                ,
                [3, 6]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "BA",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "12[2-4]",
                ,
                ,
                ,
                "122",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:16(?:00[06]|1(?:1[17]|23))|2(?:0[0-7]|[2-5]|6[0-26])|(?:[3-5]|7\\d)\\d\\d)|1(?:18|2[78])\\d\\d?",
                ,
                ,
                ,
                "122"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BB: [
              ,
              [
                ,
                ,
                "[2-689]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "988|[2359]11",
                ,
                ,
                ,
                "211"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "BB",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "[2359]11",
                ,
                ,
                ,
                "211"
              ],
              ,
              [
                ,
                ,
                "988|[2-689]11",
                ,
                ,
                ,
                "211"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "[468]11",
                ,
                ,
                ,
                "411"
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BD: [
              ,
              [
                ,
                ,
                "[1579]\\d{2,4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "10[0-26]|[19]99",
                ,
                ,
                ,
                "100",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "BD",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "10[0-2]|[19]99",
                ,
                ,
                ,
                "100",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0(?:[0-369]|5[1-4]|7[0-4]|8[0-29])|1[16-9]|2(?:[134]|2[0-5])|3(?:1\\d?|6[3-6])|5[2-9])|5012|786|9594|[19]99|1(?:0(?:50|6\\d)|33|4(?:0|1\\d))\\d",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "1(?:11|2[13])|(?:501|959)\\d|786",
                ,
                ,
                ,
                "111",
                ,
                ,
                [3, 4]
              ],
              ,
              [
                ,
                ,
                "959\\d",
                ,
                ,
                ,
                "9590",
                ,
                ,
                [4]
              ]
            ],
            BE: [
              ,
              [
                ,
                ,
                "[1-9]\\d\\d(?:\\d(?:\\d{2})?)?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:0[0-35-8]|1[0269]|7(?:12|77)|813)|(?:116|8)\\d{3}",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                "1(?:2[03]|40)4|(?:1(?:[24]1|3[01])|[2-79]\\d\\d)\\d",
                ,
                ,
                ,
                "1204",
                ,
                ,
                [4]
              ],
              ,
              ,
              ,
              "BE",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:0[01]|12)",
                ,
                ,
                ,
                "100",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0[0-8]|16117|2(?:12|3[0-24])|313|414|5(?:1[05]|5[15]|66|95)|6(?:1[167]|36|6[16])|7(?:[07][017]|1[27-9]|22|33|65)|81[39])|[2-9]\\d{3}|11[02679]|1(?:1600|45)0|1(?:[2-4]9|78)9|1[2-4]0[47]",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                "[2-9]\\d{3}",
                ,
                ,
                ,
                "2000",
                ,
                ,
                [4]
              ]
            ],
            BF: [
              ,
              [
                ,
                ,
                "1\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [2]
              ],
              ,
              ,
              [
                ,
                ,
                "1[78]",
                ,
                ,
                ,
                "17"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "BF",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1[78]",
                ,
                ,
                ,
                "17"
              ],
              ,
              [
                ,
                ,
                "1[78]",
                ,
                ,
                ,
                "17"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BG: [
              ,
              [
                ,
                ,
                "1\\d\\d(?:\\d{3})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 6]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1(?:2|6\\d{3})|50|6[06])",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "BG",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:12|50|6[06])",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1(?:2|6(?:000|111))|50|6[06])",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BH: [
              ,
              [
                ,
                ,
                "[0189]\\d\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5]
              ],
              ,
              ,
              [
                ,
                ,
                "(?:0[167]|81)\\d{3}|[19]99",
                ,
                ,
                ,
                "199"
              ],
              [
                ,
                ,
                "9[148]\\d{3}",
                ,
                ,
                ,
                "91000",
                ,
                ,
                [5]
              ],
              ,
              ,
              ,
              "BH",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "[19]99",
                ,
                ,
                ,
                "199",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:[02]\\d|12|4[01]|51|8[18]|9[169])|99[02489]|(?:0[167]|8[158]|9[148])\\d{3}",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "0[67]\\d{3}|88000|98555",
                ,
                ,
                ,
                "06000",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "88000|98555",
                ,
                ,
                ,
                "88000",
                ,
                ,
                [5]
              ]
            ],
            BI: [
              ,
              [
                ,
                ,
                "[16-9]\\d{2,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "11[237]|611",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "BI",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[237]",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1\\d|5[2-9]|6[0-256])|611|7(?:10|77|979)|8[28]8|900",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "611|7(?:10|77)|888|900",
                ,
                ,
                ,
                "611",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "(?:71|90)0",
                ,
                ,
                ,
                "710",
                ,
                ,
                [3]
              ]
            ],
            BJ: [
              ,
              [
                ,
                ,
                "[17]\\d{2,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1[246-8]|3[68]|6[06])|7[3-5]\\d\\d",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "BJ",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[246-8]",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:05|1[24-8]|2[02-5]|3[126-8]|5[05]|6[06]|89)|7[0-5]\\d\\d",
                ,
                ,
                ,
                "105"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "12[02-5]",
                ,
                ,
                ,
                "120",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BL: [
              ,
              [
                ,
                ,
                "1\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [2]
              ],
              ,
              ,
              [
                ,
                ,
                "18",
                ,
                ,
                ,
                "18"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "BL",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "18",
                ,
                ,
                ,
                "18"
              ],
              ,
              [
                ,
                ,
                "18",
                ,
                ,
                ,
                "18"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BM: [
              ,
              [
                ,
                ,
                "[19]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:11|88)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "BM",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "911",
                ,
                ,
                ,
                "911"
              ],
              ,
              [
                ,
                ,
                "176|9(?:11|88)",
                ,
                ,
                ,
                "176"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "176",
                ,
                ,
                ,
                "176"
              ],
              ,
              [
                ,
                ,
                "176",
                ,
                ,
                ,
                "176"
              ]
            ],
            BN: [
              ,
              [
                ,
                ,
                "9\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "99[135]",
                ,
                ,
                ,
                "991"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "BN",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "99[135]",
                ,
                ,
                ,
                "991"
              ],
              ,
              [
                ,
                ,
                "99[135]",
                ,
                ,
                ,
                "991"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BO: [
              ,
              [
                ,
                ,
                "[14]\\d\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5]
              ],
              ,
              ,
              [
                ,
                ,
                "11[089]",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "BO",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[089]",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "11[089]|40404",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ]
            ],
            BQ: [
              ,
              [
                ,
                ,
                "[19]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "112|911",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "BQ",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112|911",
                ,
                ,
                ,
                "112"
              ],
              ,
              [
                ,
                ,
                "1(?:12|76)|911",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "176",
                ,
                ,
                ,
                "176"
              ],
              ,
              [
                ,
                ,
                "176",
                ,
                ,
                ,
                "176"
              ]
            ],
            BR: [
              ,
              [
                ,
                ,
                "[1-69]\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:00|12|28|8[015]|9[0-47-9])|4(?:57|82\\d)|911",
                ,
                ,
                ,
                "100",
                ,
                ,
                [3, 4]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "BR",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:12|28|9[023])|911",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0(?:[02]|3(?:1[2-579]|2[13-9]|3[124-9]|4[1-3578]|5[1-468]|6[139]|8[149]|9[168])|5[0-35-9]|6(?:0|1[0-35-8]?|2[0145]|3[0137]?|4[37-9]?|5[0-35]|6[016]?|7[137]?|8[5-8]|9[1359]))|1[25-8]|2[357-9]|3[024-68]|4[12568]|5\\d|6[0-8]|8[015]|9[0-47-9])|2(?:7(?:330|878)|85959?)|(?:32|91)1|4(?:0404?|57|828)|55555|6(?:0\\d{4}|10000)|(?:133|411)[12]",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                "102|273\\d\\d|321",
                ,
                ,
                ,
                "102",
                ,
                ,
                [3, 5]
              ],
              [
                ,
                ,
                "151|(?:278|555)\\d\\d|4(?:04\\d\\d?|11\\d|57)",
                ,
                ,
                ,
                "151",
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              [
                ,
                ,
                "285\\d{2,3}|321|40404|(?:27[38]\\d|482)\\d|6(?:0\\d|10)\\d{3}",
                ,
                ,
                ,
                "321"
              ]
            ],
            BS: [
              ,
              [
                ,
                ,
                "9\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:1[19]|88)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "BS",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "91[19]",
                ,
                ,
                ,
                "911"
              ],
              ,
              [
                ,
                ,
                "9(?:1[19]|88)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BT: [
              ,
              [
                ,
                ,
                "[14]\\d\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5]
              ],
              ,
              ,
              [
                ,
                ,
                "11[023]",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "BT",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[023]",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "11[0-6]|40404",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ]
            ],
            BW: [
              ,
              [
                ,
                ,
                "[19]\\d\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:11|9[7-9])",
                ,
                ,
                ,
                "911",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "BW",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "9(?:11|9[7-9])",
                ,
                ,
                ,
                "911",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1[26]|3123)|9(?:1[14]|9[1-57-9])",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "131\\d\\d",
                ,
                ,
                ,
                "13100",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "131\\d\\d",
                ,
                ,
                ,
                "13100",
                ,
                ,
                [5]
              ]
            ],
            BY: [
              ,
              [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:0[1-3]|12)",
                ,
                ,
                ,
                "101"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "BY",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:0[1-3]|12)",
                ,
                ,
                ,
                "101"
              ],
              ,
              [
                ,
                ,
                "1(?:0[1-79]|1[246]|35|5[1-35]|6[89]|7[5-7]|8[58]|9[1-7])",
                ,
                ,
                ,
                "101"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            BZ: [
              ,
              [
                ,
                ,
                "9\\d\\d?",
                ,
                ,
                ,
                ,
                ,
                ,
                [2, 3]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:0|11|22|66|77|9[09])",
                ,
                ,
                ,
                "90"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "BZ",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "9(?:0|11|90)",
                ,
                ,
                ,
                "90"
              ],
              ,
              [
                ,
                ,
                "9(?:0|11|22|66|77|9[09])",
                ,
                ,
                ,
                "90"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CA: [
              ,
              [
                ,
                ,
                "[1-9]\\d\\d(?:\\d{2,3})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "112|988|[29]11",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "CA",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112|911",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "[1-35-9]\\d{4,5}|112|[2-8]11|9(?:11|88)",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "[235-7]11",
                ,
                ,
                ,
                "211",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "[1-35-9]\\d{4,5}",
                ,
                ,
                ,
                "10000",
                ,
                ,
                [5, 6]
              ]
            ],
            CC: [
              ,
              [
                ,
                ,
                "[01]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "000|112",
                ,
                ,
                ,
                "000"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "CC",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "000|112",
                ,
                ,
                ,
                "000"
              ],
              ,
              [
                ,
                ,
                "000|112",
                ,
                ,
                ,
                "000"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CD: [
              ,
              [
                ,
                ,
                "[14]\\d\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1[348]|77|88)",
                ,
                ,
                ,
                "113",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "CD",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:1[348]|77|88)",
                ,
                ,
                ,
                "113",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1[348]|23|77|88)|40404",
                ,
                ,
                ,
                "113"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ]
            ],
            CF: [
              ,
              [
                ,
                ,
                "1\\d{2,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1[78]|22\\d)",
                ,
                ,
                ,
                "117"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "CF",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:1[78]|220)",
                ,
                ,
                ,
                "117"
              ],
              ,
              [
                ,
                ,
                "1(?:1[478]|220)",
                ,
                ,
                ,
                "114"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CG: [
              ,
              [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "11[178]",
                ,
                ,
                ,
                "111"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "CG",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[78]",
                ,
                ,
                ,
                "117"
              ],
              ,
              [
                ,
                ,
                "11[126-8]",
                ,
                ,
                ,
                "111"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CH: [
              ,
              [
                ,
                ,
                "[1-9]\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1(?:[278]|6\\d{3})|4[47])|5200",
                ,
                ,
                ,
                "112",
                ,
                ,
                [
                  3,
                  4,
                  6
                ]
              ],
              [
                ,
                ,
                "1(?:14|8[0-2589])\\d|543|83111",
                ,
                ,
                ,
                "543",
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              ,
              ,
              "CH",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:1[278]|44)",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0[78]\\d\\d|1(?:[278]|45|6(?:000|111))|4(?:[03-57]|1[0145])|6(?:00|[1-46])|8(?:02|1[189]|[25]0|7|8[08]|99))|[2-9]\\d{2,4}",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                "1(?:4[035]|6[1-46])|1(?:41|60)\\d",
                ,
                ,
                ,
                "140",
                ,
                ,
                [3, 4]
              ],
              [
                ,
                ,
                "5(?:200|35)",
                ,
                ,
                ,
                "535",
                ,
                ,
                [3, 4]
              ],
              ,
              [
                ,
                ,
                "[2-9]\\d{2,4}",
                ,
                ,
                ,
                "200",
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ]
            ],
            CI: [
              ,
              [
                ,
                ,
                "[14]\\d{2,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1[01]|[78]0)",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "CI",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:1[01]|[78]0)",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1[01]|[78]0)|4443",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "444\\d",
                ,
                ,
                ,
                "4440",
                ,
                ,
                [4]
              ],
              ,
              [
                ,
                ,
                "444\\d",
                ,
                ,
                ,
                "4440",
                ,
                ,
                [4]
              ]
            ],
            CK: [
              ,
              [
                ,
                ,
                "9\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "99[689]",
                ,
                ,
                ,
                "996"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "CK",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "99[689]",
                ,
                ,
                ,
                "996"
              ],
              ,
              [
                ,
                ,
                "99[689]",
                ,
                ,
                ,
                "996"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CL: [
              ,
              [
                ,
                ,
                "[1-9]\\d{2,4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:213|3[1-3])|434\\d|911",
                ,
                ,
                ,
                "131",
                ,
                ,
                [3, 4]
              ],
              [
                ,
                ,
                "1(?:211|3(?:13|[348]0|5[01]))|(?:1(?:[05]6|[48]1|9[18])|2(?:01\\d|[23]2|77|88)|3(?:0[59]|13|3[279]|66)|4(?:[12]4|36\\d|4[017]|55)|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d",
                ,
                ,
                ,
                "1060",
                ,
                ,
                [4, 5]
              ],
              ,
              ,
              ,
              "CL",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "13[1-3]|911",
                ,
                ,
                ,
                "131",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:00|21[13]|3(?:13|[348]0|5[01])|4(?:0[02-6]|17|[379])|818|919)|2(?:0(?:01|122)|22[47]|323|777|882)|3(?:0(?:51|99)|132|3(?:29|[37]7)|665)|43656|5(?:(?:00|415)4|5(?:66|77)|995)|6(?:131|222|366|699)|7878|8(?:011|11[28]|482|889)|9(?:01|1)1|13\\d|4(?:[13]42|243|4(?:02|15|77)|554)|(?:1(?:[05]6|98)|339|6(?:07|[35])0|9(?:[12]0|33))0",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                "(?:200|333)\\d",
                ,
                ,
                ,
                "2000",
                ,
                ,
                [4]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                "13(?:13|[348]0|5[01])|(?:1(?:[05]6|[28]1|4[01]|9[18])|2(?:0(?:0|1\\d)|[23]2|77|88)|3(?:0[59]|13|3[2379]|66)|436\\d|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d|4(?:[1-3]4|4[017]|55)\\d",
                ,
                ,
                ,
                "1060",
                ,
                ,
                [4, 5]
              ]
            ],
            CM: [
              ,
              [
                ,
                ,
                "[18]\\d{1,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  2,
                  3,
                  4
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1[37]|[37])",
                ,
                ,
                ,
                "13",
                ,
                ,
                [2, 3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "CM",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:1[37]|[37])",
                ,
                ,
                ,
                "13",
                ,
                ,
                [2, 3]
              ],
              ,
              [
                ,
                ,
                "1(?:1[37]|[37])|8711",
                ,
                ,
                ,
                "13"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "871\\d",
                ,
                ,
                ,
                "8710",
                ,
                ,
                [4]
              ],
              ,
              [
                ,
                ,
                "871\\d",
                ,
                ,
                ,
                "8710",
                ,
                ,
                [4]
              ]
            ],
            CN: [
              ,
              [
                ,
                ,
                "[19]\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1[09]|2(?:[02]|1\\d\\d|395))",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3, 5]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "CN",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:1[09]|20)",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:00|1[0249]|2395|6[08])|9[56]\\d{3,4}|12[023]|1(?:0(?:[0-26]\\d|8)|21\\d)\\d",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                "1(?:0(?:[0-26]\\d|8)\\d|1[24]|23|6[08])|9[56]\\d{3,4}|100",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                "12110",
                ,
                ,
                ,
                "12110",
                ,
                ,
                [5]
              ]
            ],
            CO: [
              ,
              [
                ,
                ,
                "[1-589]\\d\\d(?:\\d{2,3})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1[29]|23|32|56)",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "CO",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:1[29]|23|32|56)",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:06|1[2-9]|2[35-7]|3[27]|4[467]|5[36]|6[4-7]|95)|(?:29002|39003)9|40404|5930\\d\\d|85432|(?:[2359][57]|8(?:7|9\\d))\\d{3}",
                ,
                ,
                ,
                "106"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:40|85)4\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "(?:40|85)4\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ]
            ],
            CR: [
              ,
              [
                ,
                ,
                "[1359]\\d{2,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "112|911",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "CR",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112|911",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0(?:00|15|2[2-4679])|1(?:1[0-35-9]|2|37|[46]6|7[57]|8[79]|9[0-379])|2(?:00|[12]2|34|55)|3(?:21|33)|4(?:0[06]|1[4-6])|5(?:15|5[15])|693|7(?:00|1[7-9]|2[02]|[67]7)|975)|3855|5(?:0(?:30|49)|510)|911",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                "(?:385|5(?:0[34]|51))\\d",
                ,
                ,
                ,
                "3850",
                ,
                ,
                [4]
              ]
            ],
            CU: [
              ,
              [
                ,
                ,
                "[12]\\d\\d(?:\\d{3,4})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  6,
                  7
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "10[4-7]|(?:116|204\\d)\\d{3}",
                ,
                ,
                ,
                "104"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "CU",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "10[4-6]",
                ,
                ,
                ,
                "104",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0[4-7]|1(?:6111|8)|40)|2045252",
                ,
                ,
                ,
                "104"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CV: [
              ,
              [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "13[0-2]",
                ,
                ,
                ,
                "130"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "CV",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "13[0-2]",
                ,
                ,
                ,
                "130"
              ],
              ,
              [
                ,
                ,
                "13[0-2]",
                ,
                ,
                ,
                "130"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CW: [
              ,
              [
                ,
                ,
                "[19]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "112|911",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "CW",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112|911",
                ,
                ,
                ,
                "112"
              ],
              ,
              [
                ,
                ,
                "1(?:12|76)|911",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "176",
                ,
                ,
                ,
                "176"
              ],
              ,
              [
                ,
                ,
                "176",
                ,
                ,
                ,
                "176"
              ]
            ],
            CX: [
              ,
              [
                ,
                ,
                "[01]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "000|112",
                ,
                ,
                ,
                "000"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "CX",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "000|112",
                ,
                ,
                ,
                "000"
              ],
              ,
              [
                ,
                ,
                "000|112",
                ,
                ,
                ,
                "000"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CY: [
              ,
              [
                ,
                ,
                "1\\d\\d(?:\\d{3})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 6]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1(?:2|6\\d{3})|99)",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "CY",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:12|99)",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1(?:2|6(?:000|111))|99)",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            CZ: [
              ,
              [
                ,
                ,
                "1\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1(?:2|6(?:00[06]|1(?:11|23)))|5\\d)",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3, 6]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "CZ",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:12|5\\d)",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1(?:2|8\\d)|(?:2|3\\d)\\d{2,3}|5\\d|99)|1(?:16|4)\\d{3}",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            DE: [
              ,
              [
                ,
                ,
                "[1-478]\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "11(?:[02]|6\\d{3})",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3, 6]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "DE",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[02]",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "11(?:[025]|6(?:00[06]|1(?:1[167]|23))|800\\d)|22(?:044|5(?:43|80)|7700|922)|33(?:11|3[34])|44844|7(?:0\\d{3}|464)|80808|118\\d\\d",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:33[13]|746)\\d|(?:22(?:[059]|7\\d)|(?:44|80)8|70\\d)\\d\\d",
                ,
                ,
                ,
                "3310",
                ,
                ,
                [
                  4,
                  5,
                  6
                ]
              ],
              ,
              [
                ,
                ,
                "(?:333|746)\\d|(?:22(?:[059]|7\\d)|(?:44|80)8|70\\d)\\d\\d",
                ,
                ,
                ,
                "3330",
                ,
                ,
                [
                  4,
                  5,
                  6
                ]
              ]
            ],
            DJ: [
              ,
              [
                ,
                ,
                "1\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [2]
              ],
              ,
              ,
              [
                ,
                ,
                "1[78]",
                ,
                ,
                ,
                "17"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "DJ",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1[78]",
                ,
                ,
                ,
                "17"
              ],
              ,
              [
                ,
                ,
                "1[78]",
                ,
                ,
                ,
                "17"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            DK: [
              ,
              [
                ,
                ,
                "1\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "11(?:[24]|6\\d{3})",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3, 6]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "DK",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[24]",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1(?:[248]|6(?:00[06]|111))|619[0-2]|8(?:01|1[0238]|28|30|5[13]|8[18]))",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            DM: [
              ,
              [
                ,
                ,
                "[39]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "333|9(?:11|88|99)",
                ,
                ,
                ,
                "333"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "DM",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "333|9(?:11|99)",
                ,
                ,
                ,
                "333"
              ],
              ,
              [
                ,
                ,
                "333|9(?:11|88|99)",
                ,
                ,
                ,
                "333"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            DO: [
              ,
              [
                ,
                ,
                "[19]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "112|9(?:11|88)",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "DO",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112|911",
                ,
                ,
                ,
                "112"
              ],
              ,
              [
                ,
                ,
                "112|9(?:11|88)",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            DZ: [
              ,
              [
                ,
                ,
                "[17]\\d{1,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  2,
                  3,
                  4
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:12|[47]|54\\d)",
                ,
                ,
                ,
                "14"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "DZ",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:12|[47])",
                ,
                ,
                ,
                "14",
                ,
                ,
                [2, 3]
              ],
              ,
              [
                ,
                ,
                "1(?:055|12|[47]|548)|730",
                ,
                ,
                ,
                "14"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "730",
                ,
                ,
                ,
                "730",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "730",
                ,
                ,
                ,
                "730",
                ,
                ,
                [3]
              ]
            ],
            EC: [
              ,
              [
                ,
                ,
                "[19]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:0[12]|12)|911",
                ,
                ,
                ,
                "101"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "EC",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:0[12]|12)|911",
                ,
                ,
                ,
                "101"
              ],
              ,
              [
                ,
                ,
                "1(?:0[12]|12)|911",
                ,
                ,
                ,
                "101"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            EE: [
              ,
              [
                ,
                ,
                "1\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1(?:[02]|6\\d{3})|2(?:05|28)|3(?:014|3(?:21|5\\d?)|660)|492|5(?:1[03]|410|501)|6(?:112|333|644)|7(?:012|127|89)|8(?:10|8[57])|9(?:0[134]|14))",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                "1(?:18(?:00|[12458]\\d?)|2(?:0(?:[02-46-8]\\d?|1[0-36])|1(?:[0-4]\\d?|6[06])|2(?:[0-4]\\d?|5[25])|[367]|4(?:0[04]|[12]\\d?|4[24]|54)|55[12457])|3(?:0(?:[02]\\d?|1[13578]|3[356])|1[1347]|2[02-5]|3(?:[01347]\\d?|2[023]|88)|4(?:[35]\\d?|4[34])|5(?:3[134]|5[035])|666)|4(?:2(?:00|4\\d?)|4(?:0[01358]|1[024]|50|7\\d?)|900)|5(?:0[0-35]|1(?:[1267]\\d?|5[0-7]|82)|2(?:[014-6]\\d?|22)|330|4(?:[35]\\d?|44)|5(?:00|[1-69]\\d?)|9(?:[159]\\d?|[38]0|77))|6(?:1(?:00|1[19]|[35-9]\\d?)|2(?:2[26]|[68]\\d?)|3(?:22|36|6[36])|5|6(?:[0-359]\\d?|6[0-26])|7(?:00|55|7\\d?|8[89])|9(?:00|1\\d?|69))|7(?:0(?:[023]\\d?|1[0578])|1(?:00|2[034]|[4-9]\\d?)|2(?:[07]\\d?|20|44)|7(?:[0-57]\\d?|9[79])|8(?:0[08]|2\\d?|8[0178])|9(?:00|97))|8(?:1[127]|8[1268]|9[269])|9(?:0(?:[02]\\d?|69|9[0269])|1[1-3689]|21))",
                ,
                ,
                ,
                "123",
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              ,
              ,
              "EE",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[02]",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1(?:[02-579]|6(?:000|111)|8(?:[09]\\d|[1-8]))|2[36-9]|3[7-9]|4[05-7]|5[6-8]|6[05]|7[3-6]|8[02-7]|9[3-9])|1(?:2[0-245]|3[0-6]|4[1-489]|5[0-59]|6[1-46-9]|7[0-27-9]|8[189]|9[0-2])\\d\\d?",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                "1(?:18[1258]|2(?:0(?:1[036]|[46]\\d?)|166|21|4(?:0[04]|1\\d?|5[47])|[67])|3(?:0(?:1[13-578]|2\\d?|3[56])|1[15]|2[045]|3(?:[13]\\d?|2[13])|43|5(?:00|3[34]|53))|44(?:0[0135]|14|50|7\\d?)|5(?:05|1(?:[12]\\d?|5[1246]|8[12])|2(?:[01]\\d?|22)|3(?:00|3[03])|4(?:15|5\\d?)|500|9(?:5\\d?|77|80))|6(?:1[35-8]|226|3(?:22|3[36]|66)|644|7(?:00|7\\d?|89)|9(?:00|69))|7(?:01[258]|1(?:00|[15]\\d?)|2(?:44|7\\d?)|8(?:00|87|9\\d?))|8(?:1[128]|8[56]|9(?:[26]\\d?|77))|90(?:2\\d?|69|92))",
                ,
                ,
                ,
                "126",
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ]
            ],
            EG: [
              ,
              [
                ,
                ,
                "[13]\\d\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:2[23]|80)",
                ,
                ,
                ,
                "122",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "EG",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:2[23]|80)",
                ,
                ,
                ,
                "122",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:2[23]|[679]\\d{3}|80)|34400",
                ,
                ,
                ,
                "122"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "344\\d\\d",
                ,
                ,
                ,
                "34400",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "344\\d\\d",
                ,
                ,
                ,
                "34400",
                ,
                ,
                [5]
              ]
            ],
            EH: [
              ,
              [
                ,
                ,
                "1\\d\\d?",
                ,
                ,
                ,
                ,
                ,
                ,
                [2, 3]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:[59]|77)",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "EH",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:[59]|77)",
                ,
                ,
                ,
                "15"
              ],
              ,
              [
                ,
                ,
                "1(?:[59]|77)",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            ER: [
              ,
              [
                ,
                ,
                "[12]\\d\\d(?:\\d{3})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 6]
              ],
              ,
              ,
              [
                ,
                ,
                "11[2-46]|(?:12[47]|20[12])\\d{3}",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "ER",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:1[2-46]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99",
                ,
                ,
                ,
                "112"
              ],
              ,
              [
                ,
                ,
                "1(?:1[2-6]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            ES: [
              ,
              [
                ,
                ,
                "[0-379]\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "0(?:16|6[57]|8[58])|1(?:006|12|[3-7]\\d\\d)|(?:116|20\\d)\\d{3}",
                ,
                ,
                ,
                "016",
                ,
                ,
                [
                  3,
                  4,
                  6
                ]
              ],
              [
                ,
                ,
                "[12]2\\d{1,4}|90(?:5\\d|7)|(?:118|2(?:[357]\\d|80)|3[357]\\d)\\d\\d|[79]9[57]\\d{3}",
                ,
                ,
                ,
                "120"
              ],
              ,
              ,
              ,
              "ES",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "08[58]|112",
                ,
                ,
                ,
                "085",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "0(?:1[0-26]|6[0-257]|8[058]|9[12])|1(?:0[03-57]\\d{1,3}|1(?:2|6(?:000|111)|8\\d\\d)|2\\d{1,4}|[3-9]\\d\\d)|2(?:2\\d{1,4}|80\\d\\d)|90(?:5[124578]|7)|1(?:3[34]|77)|(?:2[01]\\d|[79]9[57])\\d{3}|[23][357]\\d{3}",
                ,
                ,
                ,
                "010"
              ],
              [
                ,
                ,
                "0(?:[16][0-2]|80|9[12])|21\\d{4}",
                ,
                ,
                ,
                "010",
                ,
                ,
                [3, 6]
              ],
              [
                ,
                ,
                "1(?:3[34]|77)|[12]2\\d{1,4}",
                ,
                ,
                ,
                "120"
              ],
              ,
              [
                ,
                ,
                "(?:2[0-2]\\d|3[357]|[79]9[57])\\d{3}|2(?:[2357]\\d|80)\\d\\d",
                ,
                ,
                ,
                "22000",
                ,
                ,
                [5, 6]
              ]
            ],
            ET: [
              ,
              [
                ,
                ,
                "9\\d\\d?",
                ,
                ,
                ,
                ,
                ,
                ,
                [2, 3]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:07|11?|2|39?|9[17])",
                ,
                ,
                ,
                "91"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "ET",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "9(?:11?|2|39?|9[17])",
                ,
                ,
                ,
                "91"
              ],
              ,
              [
                ,
                ,
                "9(?:07|11?|2|39?|45|9[17])",
                ,
                ,
                ,
                "91"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            FI: [
              ,
              [
                ,
                ,
                "[17]\\d\\d(?:\\d{2,3})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "11(?:2|6\\d{3})",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3, 6]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "FI",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "11(?:2|6(?:00[06]|1(?:1[17]|23)))|(?:1[2-8]\\d|75[12])\\d\\d",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                "1[2-8]\\d{3}",
                ,
                ,
                ,
                "12000",
                ,
                ,
                [5]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            FJ: [
              ,
              [
                ,
                ,
                "[0-579]\\d(?:\\d(?:\\d{2})?)?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  2,
                  3,
                  5
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "91[17]",
                ,
                ,
                ,
                "911",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "FJ",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "91[17]",
                ,
                ,
                ,
                "911",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "0(?:1[34]|8[1-4])|1(?:0[1-3]|[25]9)|2[289]|30|40404|91[137]|[45]4|75",
                ,
                ,
                ,
                "22"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ]
            ],
            FK: [
              ,
              [
                ,
                ,
                "[19]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "999",
                ,
                ,
                ,
                "999"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "FK",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "999",
                ,
                ,
                ,
                "999"
              ],
              ,
              [
                ,
                ,
                "1\\d\\d|999",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            FM: [
              ,
              [
                ,
                ,
                "[39]\\d\\d(?:\\d{3})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 6]
              ],
              ,
              ,
              [
                ,
                ,
                "320\\d{3}|911",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "FM",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "(?:32022|91)1",
                ,
                ,
                ,
                "911"
              ],
              ,
              [
                ,
                ,
                "(?:32022|91)1",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            FO: [
              ,
              [
                ,
                ,
                "1\\d{2,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1[24]|81\\d)",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "FO",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[24]",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1[248]|819)|1(?:4[124]|71|8[7-9])\\d",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            FR: [
              ,
              [
                ,
                ,
                "[1-8]\\d{1,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  2,
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1[02459]|[578]|9[167])|224|(?:3370|74)0|(?:116\\d|3[01])\\d\\d",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                "(?:1(?:0|18\\d)|366|[4-8]\\d\\d)\\d\\d|3[2-9]\\d\\d",
                ,
                ,
                ,
                "1000",
                ,
                ,
                [
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              ,
              "FR",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:12|[578])",
                ,
                ,
                ,
                "15",
                ,
                ,
                [2, 3]
              ],
              ,
              [
                ,
                ,
                "1(?:0\\d\\d|1(?:[02459]|6(?:000|111)|8\\d{3})|[578]|9[167])|2(?:0(?:00|2)0|24)|[3-8]\\d{4}|3\\d{3}|6(?:1[14]|34)|7(?:0[06]|22|40)",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                "202\\d|6(?:1[14]|34)|70[06]",
                ,
                ,
                ,
                "611",
                ,
                ,
                [3, 4]
              ],
              [
                ,
                ,
                "118777|224|6(?:1[14]|34)|7(?:0[06]|22|40)|20(?:0\\d|2)\\d",
                ,
                ,
                ,
                "224",
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              [
                ,
                ,
                "114|[3-8]\\d{4}",
                ,
                ,
                ,
                "114",
                ,
                ,
                [3, 5]
              ]
            ],
            GA: [
              ,
              [
                ,
                ,
                "1\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [2, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "18|1(?:3\\d|73)\\d",
                ,
                ,
                ,
                "18"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "GA",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:3\\d\\d|730|8)",
                ,
                ,
                ,
                "18"
              ],
              ,
              [
                ,
                ,
                "1(?:3\\d\\d|730|8)",
                ,
                ,
                ,
                "18"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GB: [
              ,
              [
                ,
                ,
                "[1-46-9]\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:05|1(?:[29]|6\\d{3})|7[56]\\d|8000)|2(?:20\\d|48)|4444|999",
                ,
                ,
                ,
                "105"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "GB",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112|999",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0[015]|1(?:[129]|6(?:000|1(?:11|23))|8\\d{3})|2(?:[1-3]|50)|33|4(?:1|7\\d)|571|7(?:0\\d|[56]0)|800\\d|9[15])|2(?:0202|1300|2(?:02|11)|3(?:02|336|45)|4(?:25|8))|3[13]3|4(?:0[02]|35[01]|44[45]|5\\d)|(?:[68]\\d|7[089])\\d{3}|15\\d|2[02]2|650|789|9(?:01|99)",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "1(?:(?:25|7[56])\\d|571)|2(?:02(?:\\d{2})?|[13]3\\d\\d|48)|4444|901",
                ,
                ,
                ,
                "202",
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              [
                ,
                ,
                "(?:125|2(?:020|13\\d)|(?:7[089]|8[01])\\d\\d)\\d",
                ,
                ,
                ,
                "1250",
                ,
                ,
                [4, 5]
              ]
            ],
            GD: [
              ,
              [
                ,
                ,
                "[19]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:11|88)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "GD",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "911",
                ,
                ,
                ,
                "911"
              ],
              ,
              [
                ,
                ,
                "176|9(?:11|88)",
                ,
                ,
                ,
                "176"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "176",
                ,
                ,
                ,
                "176"
              ],
              ,
              [
                ,
                ,
                "176",
                ,
                ,
                ,
                "176"
              ]
            ],
            GE: [
              ,
              [
                ,
                ,
                "[014]\\d\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5]
              ],
              ,
              ,
              [
                ,
                ,
                "0(?:11|33)|11[1-3]|[01]22",
                ,
                ,
                ,
                "011",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "GE",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "0(?:11|33)|11[1-3]|[01]22",
                ,
                ,
                ,
                "011",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "0(?:11|33)|11[1-3]|40404|[01]22",
                ,
                ,
                ,
                "011"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ]
            ],
            GF: [
              ,
              [
                ,
                ,
                "1\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [2]
              ],
              ,
              ,
              [
                ,
                ,
                "1[578]",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "GF",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1[578]",
                ,
                ,
                ,
                "15"
              ],
              ,
              [
                ,
                ,
                "1[578]",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GG: [
              ,
              [
                ,
                ,
                "[19]\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "112|999",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "GG",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112|999",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0[01]|1[12]|23|41|55|9[05])|999|1(?:1[68]\\d\\d|47|800)\\d",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GH: [
              ,
              [
                ,
                ,
                "[14589]\\d{2,4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "19[1-3]|999",
                ,
                ,
                ,
                "191",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "GH",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "19[1-3]|999",
                ,
                ,
                ,
                "191",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "19[1-3]|40404|(?:54|83)00|999",
                ,
                ,
                ,
                "191"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "404\\d\\d|(?:54|83)0\\d",
                ,
                ,
                ,
                "5400",
                ,
                ,
                [4, 5]
              ],
              ,
              [
                ,
                ,
                "404\\d\\d|(?:54|83)0\\d",
                ,
                ,
                ,
                "5400",
                ,
                ,
                [4, 5]
              ]
            ],
            GI: [
              ,
              [
                ,
                ,
                "[158]\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:00|1[25]|23|4(?:1|7\\d)|5[15]|9[02-49])|555|(?:116\\d|80)\\d\\d",
                ,
                ,
                ,
                "100",
                ,
                ,
                [
                  3,
                  4,
                  6
                ]
              ],
              [
                ,
                ,
                "8[1-69]\\d\\d",
                ,
                ,
                ,
                "8100",
                ,
                ,
                [4]
              ],
              ,
              ,
              ,
              "GI",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:12|9[09])",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:00|1(?:[25]|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|23|4(?:1|7[014])|5[015]|9[02-49])|555|8[0-79]\\d\\d|8(?:00|4[0-2]|8[0-589])",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                "150|87\\d\\d",
                ,
                ,
                ,
                "150",
                ,
                ,
                [3, 4]
              ],
              [
                ,
                ,
                "1(?:00|1(?:5|8\\d\\d)|23|51|9[2-4])|555|8(?:00|4[0-2]|8[0-589])",
                ,
                ,
                ,
                "100",
                ,
                ,
                [3, 5]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GL: [
              ,
              [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "112",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "GL",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112",
                ,
                ,
                ,
                "112"
              ],
              ,
              [
                ,
                ,
                "1[1-8]\\d",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GM: [
              ,
              [
                ,
                ,
                "1\\d\\d?",
                ,
                ,
                ,
                ,
                ,
                ,
                [2, 3]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1[6-8]|[6-8])",
                ,
                ,
                ,
                "16"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "GM",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:1[6-8]|[6-8])",
                ,
                ,
                ,
                "16"
              ],
              ,
              [
                ,
                ,
                "1(?:1[6-8]|[6-8])",
                ,
                ,
                ,
                "16"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GN: [
              ,
              [
                ,
                ,
                "[14]\\d\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5]
              ],
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "GN",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                "12\\d|40404",
                ,
                ,
                ,
                "120"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ]
            ],
            GP: [
              ,
              [
                ,
                ,
                "1\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [2]
              ],
              ,
              ,
              [
                ,
                ,
                "1[578]",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "GP",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1[578]",
                ,
                ,
                ,
                "15"
              ],
              ,
              [
                ,
                ,
                "1[578]",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GR: [
              ,
              [
                ,
                ,
                "1\\d\\d(?:\\d{2,3})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:0[089]|1(?:2|6\\d{3})|66|99)",
                ,
                ,
                ,
                "100",
                ,
                ,
                [3, 6]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "GR",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:00|12|66|99)",
                ,
                ,
                ,
                "100",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0[089]|1(?:2|320|6(?:000|1(?:1[17]|23)))|(?:389|9)9|66)",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                "113\\d\\d",
                ,
                ,
                ,
                "11300",
                ,
                ,
                [5]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GT: [
              ,
              [
                ,
                ,
                "[14]\\d{2,4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:10|2[03])",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "GT",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:10|2[03])",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "110|40404|1(?:2|[57]\\d)\\d",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ]
            ],
            GU: [
              ,
              [
                ,
                ,
                "9\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:11|88)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "GU",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "911",
                ,
                ,
                ,
                "911"
              ],
              ,
              [
                ,
                ,
                "9(?:11|88)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GW: [
              ,
              [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "11[378]",
                ,
                ,
                ,
                "113"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "GW",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[378]",
                ,
                ,
                ,
                "113"
              ],
              ,
              [
                ,
                ,
                "11[378]",
                ,
                ,
                ,
                "113"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            GY: [
              ,
              [
                ,
                ,
                "[019]\\d{2,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "91[1-3]",
                ,
                ,
                ,
                "911",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "GY",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "91[1-3]",
                ,
                ,
                ,
                "911",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "0(?:02|(?:17|80)1|444|7(?:[67]7|9)|9(?:0[78]|[2-47]))|1(?:443|5[568])|91[1-3]",
                ,
                ,
                ,
                "002"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "144\\d",
                ,
                ,
                ,
                "1440",
                ,
                ,
                [4]
              ],
              ,
              [
                ,
                ,
                "144\\d",
                ,
                ,
                ,
                "1440",
                ,
                ,
                [4]
              ]
            ],
            HK: [
              ,
              [
                ,
                ,
                "[19]\\d{2,6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6,
                  7
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "112|99[29]",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "HK",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112|99[29]",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0(?:(?:[0136]\\d|2[14])\\d{0,3}|8[138])|12|2(?:[0-3]\\d{0,4}|(?:58|8[13])\\d{0,3})|7(?:[135-9]\\d{0,4}|219\\d{0,2})|8(?:0(?:(?:[13]|60\\d)\\d|8)|1(?:0\\d|[2-8])|2(?:0[5-9]|(?:18|2)2|3|8[128])|(?:(?:3[0-689]\\d|7(?:2[1-389]|8[0235-9]|93))\\d|8)\\d|50[138]|6(?:1(?:11|86)|8)))|99[29]|10[0139]",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "109|1(?:08|85\\d)\\d",
                ,
                ,
                ,
                "109",
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              [
                ,
                ,
                "992",
                ,
                ,
                ,
                "992",
                ,
                ,
                [3]
              ]
            ],
            HN: [
              ,
              [
                ,
                ,
                "[14]\\d\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5]
              ],
              ,
              ,
              [
                ,
                ,
                "199",
                ,
                ,
                ,
                "199",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "HN",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "199",
                ,
                ,
                ,
                "199",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "199|40404",
                ,
                ,
                ,
                "199"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ]
            ],
            HR: [
              ,
              [
                ,
                ,
                "[016-9]\\d{1,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  2,
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:12|9[2-4])|9[34]|1(?:16\\d|39)\\d\\d",
                ,
                ,
                ,
                "93",
                ,
                ,
                [
                  2,
                  3,
                  5,
                  6
                ]
              ],
              [
                ,
                ,
                "06\\d|(?:118|[6-8]\\d{3})\\d\\d",
                ,
                ,
                ,
                "060",
                ,
                ,
                [
                  3,
                  5,
                  6
                ]
              ],
              ,
              ,
              ,
              "HR",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:12|9[2-4])|9[34]",
                ,
                ,
                ,
                "93",
                ,
                ,
                [2, 3]
              ],
              ,
              [
                ,
                ,
                "(?:06|[6-8]\\d{4})\\d|1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|3977|9(?:[2-5]|87))|9[34]",
                ,
                ,
                ,
                "93"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "139\\d\\d",
                ,
                ,
                ,
                "13900",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "139\\d\\d",
                ,
                ,
                ,
                "13900",
                ,
                ,
                [5]
              ]
            ],
            HT: [
              ,
              [
                ,
                ,
                "[14]\\d\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5]
              ],
              ,
              ,
              [
                ,
                ,
                "11[48]",
                ,
                ,
                ,
                "114",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "HT",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[48]",
                ,
                ,
                ,
                "114",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "11[48]|40404",
                ,
                ,
                ,
                "114"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ]
            ],
            HU: [
              ,
              [
                ,
                ,
                "1\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:0[457]|12|4[0-4]\\d)|1(?:16\\d|37|45)\\d\\d",
                ,
                ,
                ,
                "104"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "HU",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:0[457]|12)",
                ,
                ,
                ,
                "104",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0[457]|1(?:2|6(?:000|1(?:11|23))|800)|2(?:0[0-4]|1[013489]|2[0-5]|3[0-46]|4[0-24-68]|5[0-2568]|6[06]|7[0-25-7]|8[028]|9[08])|37(?:00|37|7[07])|4(?:0[0-5]|1[013-8]|2[034]|3[23]|4[02-9]|5(?:00|41|67))|777|8(?:1[27-9]|2[04]|40|[589]))",
                ,
                ,
                ,
                "104"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "1(?:4[0-4]|77)\\d|1(?:18|2|45)\\d\\d",
                ,
                ,
                ,
                "1200",
                ,
                ,
                [4, 5]
              ],
              ,
              [
                ,
                ,
                "184\\d",
                ,
                ,
                ,
                "1840",
                ,
                ,
                [4]
              ]
            ],
            ID: [
              ,
              [
                ,
                ,
                "[178]\\d\\d(?:\\d{2,3})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "11[02389]",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "ID",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[02389]",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1[02389]|40\\d\\d|50264)|71400|89887",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:714|898)\\d\\d",
                ,
                ,
                ,
                "71400",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "714\\d\\d",
                ,
                ,
                ,
                "71400",
                ,
                ,
                [5]
              ]
            ],
            IE: [
              ,
              [
                ,
                ,
                "[159]\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "11(?:2|6\\d{3})|999",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3, 6]
              ],
              [
                ,
                ,
                "5[37]\\d{3}",
                ,
                ,
                ,
                "53000",
                ,
                ,
                [5]
              ],
              ,
              ,
              ,
              "IE",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112|999",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "11(?:2|6(?:00[06]|1(?:1[17]|23)))|999|(?:1(?:18|9)|5[0137]\\d)\\d\\d",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                "51\\d{3}",
                ,
                ,
                ,
                "51000",
                ,
                ,
                [5]
              ],
              [
                ,
                ,
                "51210",
                ,
                ,
                ,
                "51210",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "51210|(?:118|5[037]\\d)\\d\\d",
                ,
                ,
                ,
                "11800",
                ,
                ,
                [5]
              ]
            ],
            IL: [
              ,
              [
                ,
                ,
                "[12]\\d{2,4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:0[0-2]|12)",
                ,
                ,
                ,
                "100",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "IL",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:0[0-2]|12)",
                ,
                ,
                ,
                "100",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0[0-2]|1(?:[013-9]\\d|2)|[2-9]\\d\\d)|2407|(?:104|27)00",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "104\\d\\d",
                ,
                ,
                ,
                "10400",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "104\\d\\d",
                ,
                ,
                ,
                "10400",
                ,
                ,
                [5]
              ]
            ],
            IM: [
              ,
              [
                ,
                ,
                "[189]\\d\\d(?:\\d{2,3})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "999",
                ,
                ,
                ,
                "999",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "IM",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "999",
                ,
                ,
                ,
                "999",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1\\d\\d(?:\\d{3})?|8(?:6444|9887)|999",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                "8(?:64|98)\\d\\d",
                ,
                ,
                ,
                "86400",
                ,
                ,
                [5]
              ]
            ],
            IN: [
              ,
              [
                ,
                ,
                "[12578]\\d{2,8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6,
                  7,
                  8,
                  9
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:0[0-248]|1[289]|21|[39][89]|4[01]|6(?:1|6\\d?)|8[12])|777|800|1[05]5\\d|1(?:07|51|94)\\d\\d?|(?:1(?:[05]5\\d|70)\\d|261)\\d|1(?:0[369]|10|29|3[126]|9[0-256])\\d",
                ,
                ,
                ,
                "100",
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              [
                ,
                ,
                "11[67]\\d{4}|56161561",
                ,
                ,
                ,
                "1160000",
                ,
                ,
                [7, 8]
              ],
              ,
              ,
              ,
              "IN",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:0[0-28]|12|298)|2611",
                ,
                ,
                ,
                "100",
                ,
                ,
                [3, 4]
              ],
              ,
              [
                ,
                ,
                "1(?:0(?:[0-248]|3[39]|5(?:010|6)|6[3468]|7(?:[01357]|[28]0?|4[01])|9[0135-9])|1(?:00|[289])|2(?:1|98)|3(?:11|2[0-2]|63|[89])|4[01]|5(?:1(?:0[0-36]|[127])|54)|6(?:1|6[01]?)|7000|8[12]|9(?:0[013-59]|12|25|4[4-9]\\d?|50|6[1347]|[89]))|2611|5(?:0(?:0(?:0\\d|1|20?)|325|5[2-79]\\d{3,5})|1(?:234|555|717|818|96[49])|2(?:0(?:0[01]|[14]0)|151|555|666|888|9(?:06|99\\d?))|3(?:0[01]0|131|553|(?:66|77)6)|(?:464|55[05])\\d{1,3}|6(?:070|3[68]|43)|717\\d)|777|800|5(?:05(?:0|1\\d)|221|3(?:03|3[23]))\\d{1,4}|5(?:(?:04|88)0|2(?:2[0267]|3[16])|4(?:1[04]|20|3[02])|5(?:3[16]|67)|6(?:06|[67]\\d)|787|9(?:64|90))\\d\\d?|(?:1(?:05[79]|(?:1[67][0-2]|802)\\d|55[23])\\d|5(?:(?:00(?:0\\d|1)|(?:304|616)\\d\\d)\\d|1(?:0[12]|4[2-4])|2(?:2[3589]|3(?:1\\d{3}|2)|4[04]|7[78])|4(?:[02]4|32\\d{4}|4[04]|99)|5(?:1[25]|[36]5|4[45]|93)|7(?:(?:17\\d|57)\\d\\d|[27]7|88)|8(?:3[4-69]|4[01]|5[58]|88(?:8\\d\\d|9)|99)|9(?:0(?:0|2\\d{3})|55|6[67]|77|88)))\\d",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                "5(?:14(?:2[5-9]|[34]\\d)|757555)",
                ,
                ,
                ,
                "51425",
                ,
                ,
                [5, 7]
              ],
              [
                ,
                ,
                "1(?:(?:1[67]\\d\\d|70)\\d\\d|55330|909)|5(?:300\\d|6161(?:17[89]|561))|1(?:[19][89]|21|4[01])",
                ,
                ,
                ,
                "118",
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6,
                  7,
                  8
                ]
              ],
              ,
              [
                ,
                ,
                "1(?:39|90[019])|5(?:14(?:2[5-9]|[34]\\d)|6161(?:17[89]|561)|757555)",
                ,
                ,
                ,
                "139",
                ,
                ,
                [
                  3,
                  4,
                  5,
                  7,
                  8
                ]
              ]
            ],
            IQ: [
              ,
              [
                ,
                ,
                "[1479]\\d{2,4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:0[04]|15|22)",
                ,
                ,
                ,
                "100",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "IQ",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:0[04]|15|22)",
                ,
                ,
                ,
                "100",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0[04]|15|22)|4432|71117|9988",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:443|711\\d|998)\\d",
                ,
                ,
                ,
                "4430",
                ,
                ,
                [4, 5]
              ],
              ,
              [
                ,
                ,
                "(?:443|711\\d|998)\\d",
                ,
                ,
                ,
                "4430",
                ,
                ,
                [4, 5]
              ]
            ],
            IR: [
              ,
              [
                ,
                ,
                "[129]\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1[0-68]|2[0-59]|9[0-579])|911",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "IR",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:1[025]|25)|911",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1[0-68]|2[0-59]|3[346-8]|4(?:[0147]|[289]0)|5(?:0[14]|1[02479]|2[0-3]|39|[49]0|65)|6(?:[16]6|[27]|90)|8(?:03|1[18]|22|3[37]|4[28]|88|99)|9[0-579])|20(?:[09]0|1(?:[038]|1[079]|26|9[69])|2[01])|9(?:11|9(?:0009|90))",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                "1(?:5[0-469]|8[0-489])\\d",
                ,
                ,
                ,
                "1500",
                ,
                ,
                [4]
              ],
              [
                ,
                ,
                "(?:1(?:5[0-469]|8[0-489])|99(?:0\\d\\d|9))\\d",
                ,
                ,
                ,
                "1500",
                ,
                ,
                [4, 6]
              ],
              ,
              [
                ,
                ,
                "990\\d{3}",
                ,
                ,
                ,
                "990000",
                ,
                ,
                [6]
              ]
            ],
            IS: [
              ,
              [
                ,
                ,
                "1\\d\\d(?:\\d(?:\\d{2})?)?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:12|71\\d)",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3, 4]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "IS",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1(?:[28]|61(?:16|23))|4(?:00|1[145]|4[0146])|55|7(?:00|17|7[07-9])|8(?:[02]0|1[16-9]|88)|900)",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "14(?:0\\d|41)",
                ,
                ,
                ,
                "1400",
                ,
                ,
                [4]
              ],
              ,
              [
                ,
                ,
                "1(?:415|90\\d)",
                ,
                ,
                ,
                "1415",
                ,
                ,
                [4]
              ]
            ],
            IT: [
              ,
              [
                ,
                ,
                "[14]\\d{2,6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6,
                  7
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1(?:[2358]|6\\d{3})|87)",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3, 6]
              ],
              [
                ,
                ,
                "(?:12|4(?:[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d",
                ,
                ,
                ,
                "1200",
                ,
                ,
                [
                  4,
                  5,
                  7
                ]
              ],
              ,
              ,
              ,
              "IT",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[2358]",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0\\d{2,3}|1(?:[2-57-9]|6(?:000|111))|3[39]|4(?:82|9\\d{1,3})|5(?:00|1[58]|2[25]|3[03]|44|[59])|60|8[67]|9(?:[01]|2[2-9]|4\\d|696))|4(?:2323|5045)|(?:1(?:2|92[01])|4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                "4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|5[05])\\d\\d",
                ,
                ,
                ,
                "43000",
                ,
                ,
                [5, 7]
              ]
            ],
            JE: [
              ,
              [
                ,
                ,
                "[129]\\d\\d(?:\\d(?:\\d{2})?)?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "112|999",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "JE",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112|999",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:00|1(?:2|8\\d{3})|23|4(?:[14]|28|7\\d)|5\\d|7(?:0[12]|[128]|35?)|808|9[0135])|23[2-4]|999",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            JM: [
              ,
              [
                ,
                ,
                "[19]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "11[029]|9(?:11|88)",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "JM",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[029]|911",
                ,
                ,
                ,
                "110"
              ],
              ,
              [
                ,
                ,
                "1(?:1[029]|76)|9(?:11|88)",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "176",
                ,
                ,
                ,
                "176"
              ],
              ,
              [
                ,
                ,
                "176",
                ,
                ,
                ,
                "176"
              ]
            ],
            JO: [
              ,
              [
                ,
                ,
                "[19]\\d\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:0[235]|1[2-6]|9[127])|911",
                ,
                ,
                ,
                "102",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                "9[0-4689]\\d{3}",
                ,
                ,
                ,
                "90000",
                ,
                ,
                [5]
              ],
              ,
              ,
              ,
              "JO",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:12|9[127])|911",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0[2359]|1[0-68]|9[0-24-79])|9[0-4689]\\d{3}|911",
                ,
                ,
                ,
                "102"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "9[0-4689]\\d{3}",
                ,
                ,
                ,
                "90000",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "9[0-4689]\\d{3}",
                ,
                ,
                ,
                "90000",
                ,
                ,
                [5]
              ]
            ],
            JP: [
              ,
              [
                ,
                ,
                "[01]\\d\\d(?:\\d{5,7})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  8,
                  9,
                  10
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "11[089]",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "JP",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[09]",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "000[2569]\\d{4,6}|1(?:0[24]|1[089]|44|89)",
                ,
                ,
                ,
                "102"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                "000[2569]\\d{4,6}",
                ,
                ,
                ,
                "00020000",
                ,
                ,
                [
                  8,
                  9,
                  10
                ]
              ]
            ],
            KE: [
              ,
              [
                ,
                ,
                "[1-9]\\d{2,4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1(?:[246]|9\\d)|5(?:01|2[127]|6[26]\\d))|999",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                "909\\d\\d",
                ,
                ,
                ,
                "90900",
                ,
                ,
                [5]
              ],
              ,
              ,
              ,
              "KE",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[24]|999",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0(?:[07-9]|1[0-25]|400)|1(?:[024-6]|9[0-579])|2[1-3]|3[01]|4[14]|5(?:[01][01]|2[0-24-79]|33|4[05]|5[59]|6(?:00|29|6[67]))|(?:6[035]\\d|[78])\\d|9(?:[02-9]\\d\\d|19))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99))\\d\\d|9(?:09\\d\\d|99)|8988",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "1(?:(?:04|6[35])\\d\\d|3[01]|4[14]|5(?:1\\d|2[25]))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99)|909)\\d\\d|898\\d",
                ,
                ,
                ,
                "130"
              ],
              ,
              [
                ,
                ,
                "1(?:(?:04|6[035])\\d\\d|4[14]|5(?:01|55|6[26]\\d))|40404|8988|909\\d\\d",
                ,
                ,
                ,
                "141"
              ]
            ],
            KG: [
              ,
              [
                ,
                ,
                "[14]\\d{2,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "10[1-3]",
                ,
                ,
                ,
                "101",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "KG",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "10[1-3]",
                ,
                ,
                ,
                "101",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "10[1-3]|4040",
                ,
                ,
                ,
                "101"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "404\\d",
                ,
                ,
                ,
                "4040",
                ,
                ,
                [4]
              ],
              ,
              [
                ,
                ,
                "404\\d",
                ,
                ,
                ,
                "4040",
                ,
                ,
                [4]
              ]
            ],
            KH: [
              ,
              [
                ,
                ,
                "[146]\\d\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5]
              ],
              ,
              ,
              [
                ,
                ,
                "11[7-9]|666",
                ,
                ,
                ,
                "117",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "KH",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[7-9]|666",
                ,
                ,
                ,
                "117",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "11[7-9]|40404|666",
                ,
                ,
                ,
                "117"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ]
            ],
            KI: [
              ,
              [
                ,
                ,
                "[179]\\d{2,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "19[2-5]|99[2-4]",
                ,
                ,
                ,
                "192",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "KI",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "19[2-5]|99[2-4]",
                ,
                ,
                ,
                "192",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:05[0-259]|88|9[2-5])|777|99[2-4]|10[0-8]",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                "103",
                ,
                ,
                ,
                "103",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            KM: [
              ,
              [
                ,
                ,
                "1\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [2]
              ],
              ,
              ,
              [
                ,
                ,
                "1[78]",
                ,
                ,
                ,
                "17"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "KM",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1[78]",
                ,
                ,
                ,
                "17"
              ],
              ,
              [
                ,
                ,
                "1[78]",
                ,
                ,
                ,
                "17"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            KN: [
              ,
              [
                ,
                ,
                "[39]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "333|9(?:11|88|99)",
                ,
                ,
                ,
                "333"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "KN",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "333|9(?:11|99)",
                ,
                ,
                ,
                "333"
              ],
              ,
              [
                ,
                ,
                "333|9(?:11|88|99)",
                ,
                ,
                ,
                "333"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            KP: [
              ,
              [
                ,
                ,
                "[18]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "11[29]|819",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "KP",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[29]|819",
                ,
                ,
                ,
                "112"
              ],
              ,
              [
                ,
                ,
                "11[29]|819",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            KR: [
              ,
              [
                ,
                ,
                "1\\d{2,4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1[27-9]|28|330|82)",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3, 4]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "KR",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[29]",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:[016-9]114|3(?:0[01]|2|3[0-35-9]|45?|5[057]|6[569]|7[79]|8[2589]|9[0189]))|1(?:0[015]|1\\d|2[01357-9]|41|8[28])",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "1(?:0[01]|1[4-6]|41)|1(?:[06-9]1\\d|111)\\d",
                ,
                ,
                ,
                "100",
                ,
                ,
                [3, 5]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            KW: [
              ,
              [
                ,
                ,
                "[18]\\d\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5]
              ],
              ,
              ,
              [
                ,
                ,
                "112",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "KW",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1[0-7]\\d|89887",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "898\\d\\d",
                ,
                ,
                ,
                "89800",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            KY: [
              ,
              [
                ,
                ,
                "9\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:11|88)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "KY",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "911",
                ,
                ,
                ,
                "911"
              ],
              ,
              [
                ,
                ,
                "9(?:11|88)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            KZ: [
              ,
              [
                ,
                ,
                "[1-4]\\d{2,4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:0[1-3]|12)|212\\d",
                ,
                ,
                ,
                "101",
                ,
                ,
                [3, 4]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "KZ",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:0[1-3]|12)",
                ,
                ,
                ,
                "101",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0[1-4]|12)|2121|(?:3040|404)0",
                ,
                ,
                ,
                "101"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:304\\d|404)\\d",
                ,
                ,
                ,
                "4040",
                ,
                ,
                [4, 5]
              ],
              ,
              [
                ,
                ,
                "(?:304\\d|404)\\d",
                ,
                ,
                ,
                "4040",
                ,
                ,
                [4, 5]
              ]
            ],
            LA: [
              ,
              [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "19[015]",
                ,
                ,
                ,
                "190"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "LA",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "19[015]",
                ,
                ,
                ,
                "190"
              ],
              ,
              [
                ,
                ,
                "19[015]",
                ,
                ,
                ,
                "190"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            LB: [
              ,
              [
                ,
                ,
                "[19]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:12|40|75)|999",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "LB",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:12|40|75)|999",
                ,
                ,
                ,
                "112"
              ],
              ,
              [
                ,
                ,
                "1(?:12|40|75)|999",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            LC: [
              ,
              [
                ,
                ,
                "9\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:11|88|99)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "LC",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "9(?:11|99)",
                ,
                ,
                ,
                "911"
              ],
              ,
              [
                ,
                ,
                "9(?:11|88|99)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            LI: [
              ,
              [
                ,
                ,
                "1\\d{2,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1[278]|44)",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "LI",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:1[278]|44)",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1(?:[278]|45)|4[3-57]|50|75|81[18])",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            LK: [
              ,
              [
                ,
                ,
                "1\\d{2,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "11[02689]",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "LK",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[02689]",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1[024-9]|3(?:00|1[2-49]|2[23]|3[1-3]|44|5[07]|[67]9|88|9[039])|9(?:0[0-2589]|1[0-357-9]|2[0-25689]|3[0389]|4[0489]|5[014-69]|6[0-2689]|7[03579]|8[02457-9]|9[0-2569]))",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            LR: [
              ,
              [
                ,
                ,
                "[3489]\\d{2,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "355|911",
                ,
                ,
                ,
                "355",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "LR",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "355|911",
                ,
                ,
                ,
                "355",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "355|4040|8(?:400|933)|911",
                ,
                ,
                ,
                "355"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:404|8(?:40|93))\\d",
                ,
                ,
                ,
                "4040",
                ,
                ,
                [4]
              ],
              ,
              [
                ,
                ,
                "(?:404|8(?:40|93))\\d",
                ,
                ,
                ,
                "4040",
                ,
                ,
                [4]
              ]
            ],
            LS: [
              ,
              [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "11[257]",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "LS",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[257]",
                ,
                ,
                ,
                "112"
              ],
              ,
              [
                ,
                ,
                "11[257]",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            LT: [
              ,
              [
                ,
                ,
                "[01]\\d(?:\\d(?:\\d{3})?)?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  2,
                  3,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "0(?:11?|22?|33?)|1(?:0[1-3]|1(?:2|6111))|116(?:0\\d|12)\\d",
                ,
                ,
                ,
                "01"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "LT",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "0(?:11?|22?|33?)|1(?:0[1-3]|12)",
                ,
                ,
                ,
                "01",
                ,
                ,
                [2, 3]
              ],
              ,
              [
                ,
                ,
                "0(?:11?|22?|33?)|1(?:0[1-3]|1(?:[27-9]|6(?:000|1(?:1[17]|23))))",
                ,
                ,
                ,
                "01"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            LU: [
              ,
              [
                ,
                ,
                "1\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "11(?:[23]|6\\d{3})",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3, 6]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "LU",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[23]",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "11(?:[23]|6(?:000|111))|1(?:18|[25]\\d|3)\\d\\d",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            LV: [
              ,
              [
                ,
                ,
                "[018]\\d{1,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  2,
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "0[1-3]|11(?:[023]|6\\d{3})",
                ,
                ,
                ,
                "01",
                ,
                ,
                [
                  2,
                  3,
                  6
                ]
              ],
              [
                ,
                ,
                "1180|821\\d\\d",
                ,
                ,
                ,
                "1180",
                ,
                ,
                [4, 5]
              ],
              ,
              ,
              ,
              "LV",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "0[1-3]|11[023]",
                ,
                ,
                ,
                "01",
                ,
                ,
                [2, 3]
              ],
              ,
              [
                ,
                ,
                "0[1-4]|1(?:1(?:[02-4]|6(?:000|111)|8[0189])|(?:5|65)5|77)|821[57]4",
                ,
                ,
                ,
                "01"
              ],
              [
                ,
                ,
                "1181",
                ,
                ,
                ,
                "1181",
                ,
                ,
                [4]
              ],
              [
                ,
                ,
                "165\\d",
                ,
                ,
                ,
                "1650",
                ,
                ,
                [4]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            LY: [
              ,
              [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "19[013]",
                ,
                ,
                ,
                "190"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "LY",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "19[013]",
                ,
                ,
                ,
                "190"
              ],
              ,
              [
                ,
                ,
                "19[013]",
                ,
                ,
                ,
                "190"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MA: [
              ,
              [
                ,
                ,
                "1\\d\\d?",
                ,
                ,
                ,
                ,
                ,
                ,
                [2, 3]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:[59]|77)",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "MA",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:[59]|77)",
                ,
                ,
                ,
                "15"
              ],
              ,
              [
                ,
                ,
                "1(?:[59]|77)",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MC: [
              ,
              [
                ,
                ,
                "1\\d\\d?",
                ,
                ,
                ,
                ,
                ,
                ,
                [2, 3]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:12|[578])",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "MC",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:12|[578])",
                ,
                ,
                ,
                "15"
              ],
              ,
              [
                ,
                ,
                "1(?:12|41|[578])",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MD: [
              ,
              [
                ,
                ,
                "[19]\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "11(?:2|6(?:000|1(?:11|2\\d)))|90[1-3]",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3, 6]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "MD",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112|90[1-3]",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d?|99)|90[04-9])|90[1-3]|1(?:4\\d\\d|6[0-389]|9[1-4])\\d",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            ME: [
              ,
              [
                ,
                ,
                "1\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:12|2[2-4])",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "ME",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:12|2[2-4])",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1(?:(?:[013-57-9]|6\\d\\d)\\d|2)|[249]\\d{3}|5999|8(?:0[089]|1[0-8]|888))|1(?:[02-5]\\d\\d|60[06]|700)|12\\d",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MF: [
              ,
              [
                ,
                ,
                "1\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [2]
              ],
              ,
              ,
              [
                ,
                ,
                "1[578]",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "MF",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1[578]",
                ,
                ,
                ,
                "15"
              ],
              ,
              [
                ,
                ,
                "1[578]",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MG: [
              ,
              [
                ,
                ,
                "1\\d\\d?",
                ,
                ,
                ,
                ,
                ,
                ,
                [2, 3]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1[78]|[78])",
                ,
                ,
                ,
                "17"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "MG",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:1[78]|[78])",
                ,
                ,
                ,
                "17"
              ],
              ,
              [
                ,
                ,
                "1(?:1[78]|[78])",
                ,
                ,
                ,
                "17"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MH: [
              ,
              [
                ,
                ,
                "9\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "911",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "MH",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "911",
                ,
                ,
                ,
                "911"
              ],
              ,
              [
                ,
                ,
                "911",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MK: [
              ,
              [
                ,
                ,
                "1\\d\\d(?:\\d(?:\\d{2})?)?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1(?:2|6\\d{3})|9[2-4])",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3, 6]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "MK",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:12|9[2-4])",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1(?:2|8\\d)|3\\d|9[2-4])|1(?:16|2\\d)\\d{3}",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            ML: [
              ,
              [
                ,
                ,
                "[136-8]\\d{1,4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  2,
                  3,
                  4,
                  5
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1[578]|(?:352|67)00|7402|(?:677|744|8000)\\d",
                ,
                ,
                ,
                "15",
                ,
                ,
                [
                  2,
                  4,
                  5
                ]
              ],
              [
                ,
                ,
                "(?:12|800)2\\d|3(?:52(?:11|2[02]|3[04-6]|99)|7574)",
                ,
                ,
                ,
                "1220",
                ,
                ,
                [4, 5]
              ],
              ,
              ,
              ,
              "ML",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1[578]",
                ,
                ,
                ,
                "15",
                ,
                ,
                [2]
              ],
              ,
              [
                ,
                ,
                "1(?:1(?:[013-9]\\d|2)|2(?:1[02-469]|2[13])|[578])|350(?:35|57)|67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)|800[0-2][12]|3(?:52|[67]\\d)\\d\\d",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                "37(?:433|575)|7400|8001\\d",
                ,
                ,
                ,
                "7400",
                ,
                ,
                [4, 5]
              ],
              [
                ,
                ,
                "3503\\d|(?:3[67]\\d|800)\\d\\d",
                ,
                ,
                ,
                "35030",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "374(?:0[24-9]|[1-9]\\d)|7400|3(?:6\\d|75)\\d\\d",
                ,
                ,
                ,
                "7400",
                ,
                ,
                [4, 5]
              ]
            ],
            MM: [
              ,
              [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "199",
                ,
                ,
                ,
                "199"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "MM",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "199",
                ,
                ,
                ,
                "199"
              ],
              ,
              [
                ,
                ,
                "199",
                ,
                ,
                ,
                "199"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MN: [
              ,
              [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "10[0-35]",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "MN",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "10[0-35]",
                ,
                ,
                ,
                "100"
              ],
              ,
              [
                ,
                ,
                "10[0-35]",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MO: [
              ,
              [
                ,
                ,
                "9\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "999",
                ,
                ,
                ,
                "999"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "MO",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "999",
                ,
                ,
                ,
                "999"
              ],
              ,
              [
                ,
                ,
                "999",
                ,
                ,
                ,
                "999"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MP: [
              ,
              [
                ,
                ,
                "9\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:11|88)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "MP",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "911",
                ,
                ,
                ,
                "911"
              ],
              ,
              [
                ,
                ,
                "9(?:11|88)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MQ: [
              ,
              [
                ,
                ,
                "[13]\\d(?:\\d(?:\\d(?:\\d{2})?)?)?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  2,
                  3,
                  4,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:12|[578])|3[01]\\d\\d",
                ,
                ,
                ,
                "15",
                ,
                ,
                [
                  2,
                  3,
                  4
                ]
              ],
              [
                ,
                ,
                "3[2469]\\d\\d",
                ,
                ,
                ,
                "3200",
                ,
                ,
                [4]
              ],
              ,
              ,
              ,
              "MQ",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:12|[578])",
                ,
                ,
                ,
                "15",
                ,
                ,
                [2, 3]
              ],
              ,
              [
                ,
                ,
                "1(?:12|[578])|(?:118[02-9]|3[0-2469])\\d\\d",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                "118\\d{3}",
                ,
                ,
                ,
                "118000",
                ,
                ,
                [6]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MR: [
              ,
              [
                ,
                ,
                "1\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [2]
              ],
              ,
              ,
              [
                ,
                ,
                "1[78]",
                ,
                ,
                ,
                "17"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "MR",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1[78]",
                ,
                ,
                ,
                "17"
              ],
              ,
              [
                ,
                ,
                "1[78]",
                ,
                ,
                ,
                "17"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MS: [
              ,
              [
                ,
                ,
                "[29]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:11|88|99)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "MS",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "9(?:11|99)",
                ,
                ,
                ,
                "911"
              ],
              ,
              [
                ,
                ,
                "211|9(?:11|88|99)",
                ,
                ,
                ,
                "211"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MT: [
              ,
              [
                ,
                ,
                "1\\d\\d(?:\\d{3})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 6]
              ],
              ,
              ,
              [
                ,
                ,
                "11(?:2|6\\d{3})",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "MT",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "11(?:2|6(?:000|1(?:11|23)))",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MU: [
              ,
              [
                ,
                ,
                "[189]\\d{2,4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "11[45]|99[59]",
                ,
                ,
                ,
                "114",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "MU",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[45]|99[59]",
                ,
                ,
                ,
                "114",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1\\d{2,4}|(?:8\\d\\d|99)\\d",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MV: [
              ,
              [
                ,
                ,
                "[14]\\d{2,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:02|1[89])",
                ,
                ,
                ,
                "102",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "MV",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:02|1[89])",
                ,
                ,
                ,
                "102",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:[0-37-9]|[4-6]\\d)\\d|4040|1[45]1",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "1[45]1",
                ,
                ,
                ,
                "141",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MW: [
              ,
              [
                ,
                ,
                "[189]\\d\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5]
              ],
              ,
              ,
              [
                ,
                ,
                "199|99[7-9]",
                ,
                ,
                ,
                "199",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "MW",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "199|99[7-9]",
                ,
                ,
                ,
                "199",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "199|80400|99[7-9]",
                ,
                ,
                ,
                "199"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "804\\d\\d",
                ,
                ,
                ,
                "80400",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "804\\d\\d",
                ,
                ,
                ,
                "80400",
                ,
                ,
                [5]
              ]
            ],
            MX: [
              ,
              [
                ,
                ,
                "[0579]\\d{2,4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "0(?:6[0568]|80)|911",
                ,
                ,
                ,
                "060",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                "(?:530\\d|776)\\d",
                ,
                ,
                ,
                "7760",
                ,
                ,
                [4, 5]
              ],
              ,
              ,
              ,
              "MX",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "0(?:6[0568]|80)|911",
                ,
                ,
                ,
                "060",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "0[1-9]\\d|53053|7766|911",
                ,
                ,
                ,
                "010"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "0(?:[249]0|[35][01])",
                ,
                ,
                ,
                "020",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            MY: [
              ,
              [
                ,
                ,
                "[1369]\\d{2,4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "112|999",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "MY",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112|999",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0[01348]|1(?:[02]|1[128]|311)|2(?:0[125]|[13-6]|2\\d{0,2})|(?:3[1-35-79]|7[45])\\d\\d?|5(?:454|5\\d\\d?|77|888|999?)|8(?:18?|2|8[18])|9(?:[124]\\d?|68|71|9[0679]))|66628|99[1-469]|13[5-7]|(?:1(?:0[569]|309|5[12]|7[136-9]|9[03])|3[23679]\\d\\d)\\d",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                "666\\d\\d",
                ,
                ,
                ,
                "66600",
                ,
                ,
                [5]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                "(?:3[23679]\\d|666)\\d\\d",
                ,
                ,
                ,
                "32000",
                ,
                ,
                [5]
              ]
            ],
            MZ: [
              ,
              [
                ,
                ,
                "1\\d{2,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1[79]|9[78])",
                ,
                ,
                ,
                "117",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "MZ",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:1[79]|9[78])",
                ,
                ,
                ,
                "117",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:[02-5]\\d\\d|1[79]|9[78])",
                ,
                ,
                ,
                "117"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            NA: [
              ,
              [
                ,
                ,
                "[19]\\d{2,4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "10111",
                ,
                ,
                ,
                "10111",
                ,
                ,
                [5]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "NA",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "10111",
                ,
                ,
                ,
                "10111",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "(?:10|93)111|(?:1\\d|9)\\d\\d",
                ,
                ,
                ,
                "900"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            NC: [
              ,
              [
                ,
                ,
                "[135]\\d{1,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  2,
                  3,
                  4
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:0(?:00|1[23]|3[0-2]|8\\d)|[5-8])|363\\d|577",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "NC",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1[5-8]",
                ,
                ,
                ,
                "15",
                ,
                ,
                [2]
              ],
              ,
              [
                ,
                ,
                "1(?:0(?:0[06]|1[02-46]|20|3[0-25]|42|5[058]|77|88)|[5-8])|3631|5[6-8]\\d",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                "5(?:67|88)",
                ,
                ,
                ,
                "567",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            NE: [
              ,
              [
                ,
                ,
                "[1-3578]\\d(?:\\d(?:\\d{3})?)?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  2,
                  3,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:18|[578])|723\\d{3}",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "NE",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:18|[578])|723141",
                ,
                ,
                ,
                "15"
              ],
              ,
              [
                ,
                ,
                "1(?:0[01]|1[128]|2[034]|3[013]|[46]0|55?|[78])|222|333|555|723141|888",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "1(?:0[01]|1[12]|2[034]|3[013]|[46]0|55)|222|333|555|888",
                ,
                ,
                ,
                "100",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            NF: [
              ,
              [
                ,
                ,
                "9\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:11|55|77)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "NF",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "9(?:11|55|77)",
                ,
                ,
                ,
                "911"
              ],
              ,
              [
                ,
                ,
                "9(?:11|55|77)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            NG: [
              ,
              [
                ,
                ,
                "[14]\\d\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5]
              ],
              ,
              ,
              [
                ,
                ,
                "199",
                ,
                ,
                ,
                "199",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "NG",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "199",
                ,
                ,
                ,
                "199",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "199|40700",
                ,
                ,
                ,
                "199"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "407\\d\\d",
                ,
                ,
                ,
                "40700",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "407\\d\\d",
                ,
                ,
                ,
                "40700",
                ,
                ,
                [5]
              ]
            ],
            NI: [
              ,
              [
                ,
                ,
                "[12467]\\d{2,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1[58]|2[08])|737\\d",
                ,
                ,
                ,
                "115"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "NI",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:1[58]|2[08])",
                ,
                ,
                ,
                "115",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1[58]|200)|4878|7(?:010|373)|12[0158]|(?:19|[267]1)00",
                ,
                ,
                ,
                "115"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            NL: [
              ,
              [
                ,
                ,
                "[1349]\\d\\d(?:\\d(?:\\d{2})?)?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "11(?:2|6\\d{3})|911",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3, 6]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "NL",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112|911",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1(?:2|6(?:00[06]|1(?:11|23)))|2(?:0[0-4]|3[34]|44)|3[03-9]\\d|400|8(?:[02-9]\\d|1[0-79]))|[34]000|911",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "120\\d",
                ,
                ,
                ,
                "1200",
                ,
                ,
                [4]
              ],
              ,
              [
                ,
                ,
                "[34]00\\d",
                ,
                ,
                ,
                "3000",
                ,
                ,
                [4]
              ]
            ],
            NO: [
              ,
              [
                ,
                ,
                "[01]\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "11(?:[023]|6\\d{3})",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3, 6]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "NO",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[023]",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "04\\d{3}|1(?:1(?:[0239]|61(?:1[17]|23))|2[048]|4(?:12|[59])|7[57]|8\\d\\d|90)",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                "04\\d{3}",
                ,
                ,
                ,
                "04000",
                ,
                ,
                [5]
              ]
            ],
            NP: [
              ,
              [
                ,
                ,
                "1\\d{2,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:0[0-36]|12)|1(?:09|11)\\d",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "NP",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:0[0-3]|12)",
                ,
                ,
                ,
                "100",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0(?:[0-36]|98)|1(?:1[1-4]|2))",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            NR: [
              ,
              [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "11[0-2]",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "NR",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[0-2]",
                ,
                ,
                ,
                "110"
              ],
              ,
              [
                ,
                ,
                "1(?:1[0-2]|23|92)",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            NU: [
              ,
              [
                ,
                ,
                "[019]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "999",
                ,
                ,
                ,
                "999"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "NU",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "999",
                ,
                ,
                ,
                "999"
              ],
              ,
              [
                ,
                ,
                "01[05]|101|999",
                ,
                ,
                ,
                "010"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "010",
                ,
                ,
                ,
                "010"
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            NZ: [
              ,
              [
                ,
                ,
                "\\d{3,4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "111",
                ,
                ,
                ,
                "111",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                "018",
                ,
                ,
                ,
                "018",
                ,
                ,
                [3]
              ],
              ,
              ,
              ,
              "NZ",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "111",
                ,
                ,
                ,
                "111",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "018|1(?:(?:1|37)1|(?:23|94)4|7[03]7)|[2-57-9]\\d{2,3}|6(?:161|26[0-3]|742)",
                ,
                ,
                ,
                "018"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                "018|(?:1(?:23|37|7[03]|94)|6(?:[12]6|74))\\d|[2-57-9]\\d{2,3}",
                ,
                ,
                ,
                "018"
              ]
            ],
            OM: [
              ,
              [
                ,
                ,
                "[19]\\d{3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [4]
              ],
              ,
              ,
              [
                ,
                ,
                "1444|999\\d",
                ,
                ,
                ,
                "1444"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "OM",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1444|9999",
                ,
                ,
                ,
                "1444"
              ],
              ,
              [
                ,
                ,
                "1(?:111|222|4(?:4[0-5]|50|66|7[7-9])|51[0-8])|9999|1(?:2[3-5]|3[0-2]|50)\\d",
                ,
                ,
                ,
                "1111"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            PA: [
              ,
              [
                ,
                ,
                "[19]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "911",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "PA",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "911",
                ,
                ,
                ,
                "911"
              ],
              ,
              [
                ,
                ,
                "10[2-4]|911",
                ,
                ,
                ,
                "102"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            PE: [
              ,
              [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:05|1[67])",
                ,
                ,
                ,
                "105"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "PE",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:05|1[67])",
                ,
                ,
                ,
                "105"
              ],
              ,
              [
                ,
                ,
                "1(?:05|1[67])",
                ,
                ,
                ,
                "105"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            PF: [
              ,
              [
                ,
                ,
                "1\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [2]
              ],
              ,
              ,
              [
                ,
                ,
                "1[578]",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "PF",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1[578]",
                ,
                ,
                ,
                "15"
              ],
              ,
              [
                ,
                ,
                "1[578]",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            PG: [
              ,
              [
                ,
                ,
                "[01]\\d{2,6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6,
                  7
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "000|11[01]",
                ,
                ,
                ,
                "000",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "PG",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "000|11[01]",
                ,
                ,
                ,
                "000",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "000|1(?:1[01]|5\\d\\d|6\\d{2,5})",
                ,
                ,
                ,
                "000"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                "16\\d{2,5}",
                ,
                ,
                ,
                "1600",
                ,
                ,
                [
                  4,
                  5,
                  6,
                  7
                ]
              ]
            ],
            PH: [
              ,
              [
                ,
                ,
                "[19]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "11[27]|911",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "PH",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[27]|911",
                ,
                ,
                ,
                "112"
              ],
              ,
              [
                ,
                ,
                "11[27]|911",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            PK: [
              ,
              [
                ,
                ,
                "1\\d{1,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  2,
                  3,
                  4
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1(?:2\\d?|5)|[56])",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "PK",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:1(?:22?|5)|[56])",
                ,
                ,
                ,
                "15"
              ],
              ,
              [
                ,
                ,
                "1(?:122|3[014]|[56])|11[2457-9]",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            PL: [
              ,
              [
                ,
                ,
                "[19]\\d\\d(?:\\d{2,3})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "11(?:2|6\\d{3})|99[7-9]",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3, 6]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "PL",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112|99[7-9]",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1(?:2|61(?:11|23)|891[23])|9\\d{3})|9(?:8[4-7]|9[1-9])|11[68]000",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            PM: [
              ,
              [
                ,
                ,
                "[13]\\d(?:\\d\\d(?:\\d{2})?)?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  2,
                  4,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1[578]|3(?:0\\d|1[689])\\d",
                ,
                ,
                ,
                "15",
                ,
                ,
                [2, 4]
              ],
              [
                ,
                ,
                "3[2469]\\d\\d",
                ,
                ,
                ,
                "3200",
                ,
                ,
                [4]
              ],
              ,
              ,
              ,
              "PM",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1[578]",
                ,
                ,
                ,
                "15",
                ,
                ,
                [2]
              ],
              ,
              [
                ,
                ,
                "1[578]|31(?:03|[689]\\d)|(?:118[02-9]|3[02469])\\d\\d",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                "118\\d{3}",
                ,
                ,
                ,
                "118000",
                ,
                ,
                [6]
              ],
              [
                ,
                ,
                "310\\d",
                ,
                ,
                ,
                "3100",
                ,
                ,
                [4]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            PR: [
              ,
              [
                ,
                ,
                "9\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:11|88)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "PR",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "911",
                ,
                ,
                ,
                "911"
              ],
              ,
              [
                ,
                ,
                "9(?:11|88)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            PS: [
              ,
              [
                ,
                ,
                "1\\d{2,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:0[0-2]|66)",
                ,
                ,
                ,
                "100",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "PS",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "10[0-2]",
                ,
                ,
                ,
                "100",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0[0-2]|122|44|66|99)",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "112\\d",
                ,
                ,
                ,
                "1120",
                ,
                ,
                [4]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            PT: [
              ,
              [
                ,
                ,
                "1\\d\\d(?:\\d(?:\\d{2})?)?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "11[257]|1(?:16\\d\\d|5[1589]|8[279])\\d",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "PT",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[25]",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0(?:45|5[01])|1(?:[2578]|600[06])|4(?:1[45]|4)|583|6(?:1[0236]|3[02]|9[169]))|1(?:1611|59)1|1[068]78|1[08]9[16]|1(?:0[1-38]|40|5[15]|6[258]|82)0",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            PW: [
              ,
              [
                ,
                ,
                "9\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "911",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "PW",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "911",
                ,
                ,
                ,
                "911"
              ],
              ,
              [
                ,
                ,
                "911",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            PY: [
              ,
              [
                ,
                ,
                "[19]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "128|911",
                ,
                ,
                ,
                "128"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "PY",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "128|911",
                ,
                ,
                ,
                "128"
              ],
              ,
              [
                ,
                ,
                "1[1-9]\\d|911",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            QA: [
              ,
              [
                ,
                ,
                "[129]\\d{2,4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "99\\d",
                ,
                ,
                ,
                "990",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                "900",
                ,
                ,
                ,
                "900",
                ,
                ,
                [3]
              ],
              ,
              ,
              ,
              "QA",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "999",
                ,
                ,
                ,
                "999",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "9(?:00|[19]\\d)|(?:1|20|9[27]\\d)\\d\\d",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            RE: [
              ,
              [
                ,
                ,
                "1\\d\\d?",
                ,
                ,
                ,
                ,
                ,
                ,
                [2, 3]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:12|[578])",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "RE",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:12|[578])",
                ,
                ,
                ,
                "15"
              ],
              ,
              [
                ,
                ,
                "1(?:12|[578])",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            RO: [
              ,
              [
                ,
                ,
                "[18]\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "11(?:2|6\\d{3})",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3, 6]
              ],
              [
                ,
                ,
                "(?:1(?:18[39]|[24])|8[48])\\d\\d",
                ,
                ,
                ,
                "1200",
                ,
                ,
                [4, 6]
              ],
              ,
              ,
              ,
              "RO",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1(?:2|6(?:000|1(?:11|23))|8(?:(?:01|8[18])1|119|[23]00|932))|[24]\\d\\d|9(?:0(?:00|19)|1[19]|21|3[02]|5[178]))|8[48]\\d\\d",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                "(?:1[24]|8[48])\\d\\d",
                ,
                ,
                ,
                "1200",
                ,
                ,
                [4]
              ]
            ],
            RS: [
              ,
              [
                ,
                ,
                "[19]\\d{1,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  2,
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "112|9[2-4]",
                ,
                ,
                ,
                "92",
                ,
                ,
                [2, 3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "RS",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112|9[2-4]",
                ,
                ,
                ,
                "92",
                ,
                ,
                [2, 3]
              ],
              ,
              [
                ,
                ,
                "1[189]\\d{1,4}|9[2-4]",
                ,
                ,
                ,
                "92"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            RU: [
              ,
              [
                ,
                ,
                "[01]\\d\\d?",
                ,
                ,
                ,
                ,
                ,
                ,
                [2, 3]
              ],
              ,
              ,
              [
                ,
                ,
                "112|(?:0|10)[1-3]",
                ,
                ,
                ,
                "01"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "RU",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112|(?:0|10)[1-3]",
                ,
                ,
                ,
                "01"
              ],
              ,
              [
                ,
                ,
                "112|(?:0|10)[1-4]",
                ,
                ,
                ,
                "01"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            RW: [
              ,
              [
                ,
                ,
                "[14]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "11[1245]",
                ,
                ,
                ,
                "111"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "RW",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[12]",
                ,
                ,
                ,
                "111"
              ],
              ,
              [
                ,
                ,
                "1(?:0[0-2]|1[0-24-6]|2[13]|70|99)|456",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SA: [
              ,
              [
                ,
                ,
                "[19]\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "11(?:2|6\\d{3})|9(?:11|37|9[7-9])",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3, 6]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "SA",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112|9(?:11|9[79])",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1(?:00|2|6111)|410|9(?:00|1[89]|9(?:099|22|9[0-3])))|9(?:0[24-79]|11|3[379]|40|66|8[5-9]|9[02-9])",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                "141\\d",
                ,
                ,
                ,
                "1410",
                ,
                ,
                [4]
              ],
              [
                ,
                ,
                "1(?:10|41)\\d|90[24679]",
                ,
                ,
                ,
                "902",
                ,
                ,
                [3, 4]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SB: [
              ,
              [
                ,
                ,
                "[127-9]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "999",
                ,
                ,
                ,
                "999"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "SB",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "999",
                ,
                ,
                ,
                "999"
              ],
              ,
              [
                ,
                ,
                "1(?:[02]\\d|1[12]|[35][01]|[49][1-9]|6[2-9]|7[7-9]|8[0-8])|269|777|835|9(?:[01]1|22|33|55|77|88|99)",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SC: [
              ,
              [
                ,
                ,
                "[19]\\d{2,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1[1468]|60)|999",
                ,
                ,
                ,
                "111",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "SC",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "999",
                ,
                ,
                ,
                "999",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:[06]\\d|1[0-246-8]|2[0-8]|3[13]|4[0-2]|5[15]|7[124-6]|8[158]|9[015])|9(?:6\\d\\d|99)",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SD: [
              ,
              [
                ,
                ,
                "9\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "999",
                ,
                ,
                ,
                "999"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "SD",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "999",
                ,
                ,
                ,
                "999"
              ],
              ,
              [
                ,
                ,
                "999",
                ,
                ,
                ,
                "999"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SE: [
              ,
              [
                ,
                ,
                "[1-37-9]\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "11(?:2|(?:3|6\\d)\\d\\d|414|77)|900\\d\\d",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                "11811[89]|72\\d{3}",
                ,
                ,
                ,
                "72000",
                ,
                ,
                [5, 6]
              ],
              ,
              ,
              ,
              "SE",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112|90000",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3, 5]
              ],
              ,
              [
                ,
                ,
                "11(?:[25]|313|6(?:00[06]|1(?:1[17]|23))|7[0-8])|2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|9(?:0(?:00|51)0|12)|(?:11(?:4|8[02-46-9])|7\\d\\d|90[2-4])\\d\\d|(?:118|90)1(?:[02-9]\\d|1[013-9])",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|912",
                ,
                ,
                ,
                "220",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "7\\d{4}",
                ,
                ,
                ,
                "70000",
                ,
                ,
                [5]
              ]
            ],
            SG: [
              ,
              [
                ,
                ,
                "[179]\\d{2,4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "99[359]",
                ,
                ,
                ,
                "993",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "SG",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "99[359]",
                ,
                ,
                ,
                "993",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:(?:[01368]\\d|44)\\d|[57]\\d{2,3}|9(?:0[1-9]|[1-9]\\d))|77222|99[02-9]|100",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                "772\\d\\d",
                ,
                ,
                ,
                "77200",
                ,
                ,
                [5]
              ]
            ],
            SH: [
              ,
              [
                ,
                ,
                "[129]\\d{2,4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:11|99)",
                ,
                ,
                ,
                "911",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "SH",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "9(?:11|99)",
                ,
                ,
                ,
                "911",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1\\d{2,3}|26[01]\\d\\d|9(?:11|99)",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SI: [
              ,
              [
                ,
                ,
                "1\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "11(?:(?:0|6\\d)\\d\\d|[23]|8\\d\\d?)",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "SI",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[23]",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1(?:00[146]|[23]|6(?:000|1(?:11|23))|8(?:[08]|99))|9(?:059|1(?:0[12]|16)|5|70|87|9(?:00|[149])))|19(?:08|81)[09]",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SJ: [
              ,
              [
                ,
                ,
                "[01]\\d\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5]
              ],
              ,
              ,
              [
                ,
                ,
                "11[023]",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "SJ",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[023]",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "04\\d{3}|11[023]",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                "04\\d{3}",
                ,
                ,
                ,
                "04000",
                ,
                ,
                [5]
              ]
            ],
            SK: [
              ,
              [
                ,
                ,
                "1\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1(?:2|6\\d{3})|5[058])",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3, 6]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "SK",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:12|5[058])",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1(?:2|6(?:000|111)|8[0-8])|[248]\\d{3}|5[0589])",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SL: [
              ,
              [
                ,
                ,
                "[069]\\d\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5]
              ],
              ,
              ,
              [
                ,
                ,
                "(?:01|99)9",
                ,
                ,
                ,
                "019",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "SL",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "(?:01|99)9",
                ,
                ,
                ,
                "019",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "(?:01|99)9|60400",
                ,
                ,
                ,
                "019"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "604\\d\\d",
                ,
                ,
                ,
                "60400",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "604\\d\\d",
                ,
                ,
                ,
                "60400",
                ,
                ,
                [5]
              ]
            ],
            SM: [
              ,
              [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "11[358]",
                ,
                ,
                ,
                "113"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "SM",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[358]",
                ,
                ,
                ,
                "113"
              ],
              ,
              [
                ,
                ,
                "11[358]",
                ,
                ,
                ,
                "113"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SN: [
              ,
              [
                ,
                ,
                "[12]\\d{1,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  2,
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:515|[78])|2(?:00|1)\\d{3}",
                ,
                ,
                ,
                "17",
                ,
                ,
                [
                  2,
                  4,
                  5,
                  6
                ]
              ],
              [
                ,
                ,
                "2(?:0[246]|[468])\\d{3}",
                ,
                ,
                ,
                "24000",
                ,
                ,
                [5, 6]
              ],
              ,
              ,
              ,
              "SN",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1[78]",
                ,
                ,
                ,
                "17",
                ,
                ,
                [2]
              ],
              ,
              [
                ,
                ,
                "1(?:1[69]|(?:[246]\\d|51)\\d)|2(?:0[0-246]|[12468])\\d{3}|1[278]",
                ,
                ,
                ,
                "12"
              ],
              [
                ,
                ,
                "2(?:01|2)\\d{3}",
                ,
                ,
                ,
                "22000",
                ,
                ,
                [5, 6]
              ],
              [
                ,
                ,
                "1[46]\\d\\d",
                ,
                ,
                ,
                "1400",
                ,
                ,
                [4]
              ],
              ,
              [
                ,
                ,
                "2[468]\\d{3}",
                ,
                ,
                ,
                "24000",
                ,
                ,
                [5]
              ]
            ],
            SO: [
              ,
              [
                ,
                ,
                "[57-9]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "555|888|999",
                ,
                ,
                ,
                "555"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "SO",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "555|888|999",
                ,
                ,
                ,
                "555"
              ],
              ,
              [
                ,
                ,
                "555|777|888|999",
                ,
                ,
                ,
                "555"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SR: [
              ,
              [
                ,
                ,
                "1\\d{2,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "115",
                ,
                ,
                ,
                "115",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "SR",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "115",
                ,
                ,
                ,
                "115",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1\\d{2,3}",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SS: [
              ,
              [
                ,
                ,
                "9\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "999",
                ,
                ,
                ,
                "999"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "SS",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "999",
                ,
                ,
                ,
                "999"
              ],
              ,
              [
                ,
                ,
                "999",
                ,
                ,
                ,
                "999"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            ST: [
              ,
              [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "112",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "ST",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112",
                ,
                ,
                ,
                "112"
              ],
              ,
              [
                ,
                ,
                "112",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SV: [
              ,
              [
                ,
                ,
                "[149]\\d\\d(?:\\d{2,3})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "116\\d{3}|911",
                ,
                ,
                ,
                "911",
                ,
                ,
                [3, 6]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "SV",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "91[13]",
                ,
                ,
                ,
                "911",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1(?:2|6111)|2[136-8]|3[0-6]|9[05])|40404|9(?:1\\d|29)",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ]
            ],
            SX: [
              ,
              [
                ,
                ,
                "9\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:19|88)",
                ,
                ,
                ,
                "919"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "SX",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "919",
                ,
                ,
                ,
                "919"
              ],
              ,
              [
                ,
                ,
                "9(?:19|88)",
                ,
                ,
                ,
                "919"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SY: [
              ,
              [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "11[023]",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "SY",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[023]",
                ,
                ,
                ,
                "110"
              ],
              ,
              [
                ,
                ,
                "11[023]",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            SZ: [
              ,
              [
                ,
                ,
                "9\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "999",
                ,
                ,
                ,
                "999"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "SZ",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "999",
                ,
                ,
                ,
                "999"
              ],
              ,
              [
                ,
                ,
                "999",
                ,
                ,
                ,
                "999"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TC: [
              ,
              [
                ,
                ,
                "9\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:11|88|99)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "TC",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "9(?:11|99)",
                ,
                ,
                ,
                "911"
              ],
              ,
              [
                ,
                ,
                "9(?:11|88|99)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TD: [
              ,
              [
                ,
                ,
                "1\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [2]
              ],
              ,
              ,
              [
                ,
                ,
                "1[78]",
                ,
                ,
                ,
                "17"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "TD",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1[78]",
                ,
                ,
                ,
                "17"
              ],
              ,
              [
                ,
                ,
                "1[78]",
                ,
                ,
                ,
                "17"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TG: [
              ,
              [
                ,
                ,
                "1\\d{2,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1[78]|7[127])",
                ,
                ,
                ,
                "117",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "TG",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:1[78]|7[127])",
                ,
                ,
                ,
                "117",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:011|1[078]|7[127])",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TH: [
              ,
              [
                ,
                ,
                "1\\d{2,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1(?:00|2[03]|3[3479]|7[67]|9[0246])|578|6(?:44|6[79]|88|9[16])|88\\d|9[19])|1[15]55",
                ,
                ,
                ,
                "191"
              ],
              [
                ,
                ,
                "1(?:113|2[23]\\d|5(?:09|56))",
                ,
                ,
                ,
                "1113",
                ,
                ,
                [4]
              ],
              ,
              ,
              ,
              "TH",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:669|9[19])",
                ,
                ,
                ,
                "191"
              ],
              ,
              [
                ,
                ,
                "1(?:0[0-2]|1(?:0[03]|1[1-35]|2[0358]|3[03-79]|4[02-489]|5[04-9]|6[04-79]|7[03-9]|8[027-9]|9[02-9])|2(?:22|3[89]|66)|3(?:18|2[23]|3[013]|5[56]|6[45]|73)|477|5(?:0\\d|4[0-37-9]|5[1-8]|6[01679]|7[12568]|8[0-24589]|9[013589])|6(?:0[0-29]|2[03]|4[3-6]|6[1-9]|7[0257-9]|8[0158]|9[014-9])|7(?:[14]9|7[27]|90)|888|9[19])",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                "1(?:1(?:03|1[15]|2[58]|3[056]|4[02-49]|5[046-9]|7[03-589]|9[57-9])|5(?:0[0-8]|4[0-378]|5[1-478]|7[156])|6(?:20|4[356]|6[1-68]|7[057-9]|8[015]|9[0457-9]))|1(?:1[68]|26|3[1-35]|5[689]|60|7[17])\\d",
                ,
                ,
                ,
                "1103",
                ,
                ,
                [4]
              ],
              [
                ,
                ,
                "114[89]",
                ,
                ,
                ,
                "1148",
                ,
                ,
                [4]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TJ: [
              ,
              [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:0[1-3]|12)",
                ,
                ,
                ,
                "101"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "TJ",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:0[1-3]|12)",
                ,
                ,
                ,
                "101"
              ],
              ,
              [
                ,
                ,
                "1(?:0[1-3]|12)",
                ,
                ,
                ,
                "101"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TL: [
              ,
              [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "11[25]",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "TL",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[25]",
                ,
                ,
                ,
                "112"
              ],
              ,
              [
                ,
                ,
                "1(?:0[02]|1[25]|2[0138]|72|9[07])",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TM: [
              ,
              [
                ,
                ,
                "0\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [2]
              ],
              ,
              ,
              [
                ,
                ,
                "0[1-49]",
                ,
                ,
                ,
                "01"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "TM",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "0[1-3]",
                ,
                ,
                ,
                "01"
              ],
              ,
              [
                ,
                ,
                "0[1-49]",
                ,
                ,
                ,
                "01"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TN: [
              ,
              [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "19[078]",
                ,
                ,
                ,
                "190"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "TN",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "19[078]",
                ,
                ,
                ,
                "190"
              ],
              ,
              [
                ,
                ,
                "19[078]",
                ,
                ,
                ,
                "190"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TO: [
              ,
              [
                ,
                ,
                "9\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:11|22|33|99)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "TO",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "9(?:11|22|33|99)",
                ,
                ,
                ,
                "911"
              ],
              ,
              [
                ,
                ,
                "9(?:11|22|33|99)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TR: [
              ,
              [
                ,
                ,
                "[1-9]\\d{2,4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1[02]|22|3[126]|4[04]|5[15-9]|6[18]|77|83)",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "TR",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:1[02]|55)",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1(?:[02-79]|8(?:1[018]|2[0245]|3[2-4]|42|5[058]|6[06]|7[07]|8[01389]|9[089]))|3(?:37|[58]6|65)|471|5(?:07|78)|6(?:[02]6|99)|8(?:63|95))|2(?:077|268|4(?:17|23)|5(?:7[26]|82)|6[14]4|8\\d\\d|9(?:30|89))|3(?:0(?:05|72)|353|4(?:06|30|64)|502|674|747|851|9(?:1[29]|60))|4(?:0(?:25|3[12]|[47]2)|3(?:3[13]|[89]1)|439|5(?:43|55)|717|832)|5(?:145|290|[4-6]\\d\\d|772|833|9(?:[06]1|92))|6(?:236|6(?:12|39|8[59])|769)|7890|8(?:688|7(?:28|65)|85[06])|9(?:159|290)|1[2-9]\\d",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                "(?:285|542)0",
                ,
                ,
                ,
                "2850",
                ,
                ,
                [4]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                "1(?:3(?:37|[58]6|65)|4(?:4|71)|5(?:07|78)|6(?:[02]6|99)|8(?:3|63|95))|(?:2(?:07|26|4[12]|5[78]|6[14]|8\\d|9[38])|3(?:0[07]|[38]5|4[036]|50|67|74|9[16])|4(?:0[2-47]|3[389]|[48]3|5[45]|71)|5(?:14|29|[4-6]\\d|77|83|9[069])|6(?:23|6[138]|76)|789|8(?:68|7[26]|85)|9(?:15|29))\\d",
                ,
                ,
                ,
                "144",
                ,
                ,
                [3, 4]
              ]
            ],
            TT: [
              ,
              [
                ,
                ,
                "9\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:88|9[09])",
                ,
                ,
                ,
                "988"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "TT",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "99[09]",
                ,
                ,
                ,
                "990"
              ],
              ,
              [
                ,
                ,
                "9(?:88|9[09])",
                ,
                ,
                ,
                "988"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TV: [
              ,
              [
                ,
                ,
                "[19]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "911",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "TV",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "911",
                ,
                ,
                ,
                "911"
              ],
              ,
              [
                ,
                ,
                "1\\d\\d|911",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TW: [
              ,
              [
                ,
                ,
                "1\\d{2,3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4]
              ],
              ,
              ,
              [
                ,
                ,
                "11[0289]|1(?:81|92)\\d",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                "10[56]",
                ,
                ,
                ,
                "105",
                ,
                ,
                [3]
              ],
              ,
              ,
              ,
              "TW",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[029]",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0[04-6]|1[0237-9]|3[389]|6[05-8]|7[07]|8(?:0|11)|9(?:19|22|5[057]|68|8[05]|9[15689]))",
                ,
                ,
                ,
                "100"
              ],
              [
                ,
                ,
                "1(?:65|9(?:1\\d|50|85|98))",
                ,
                ,
                ,
                "165"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            TZ: [
              ,
              [
                ,
                ,
                "[149]\\d\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:1[0-79]|9[09])|999",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "TZ",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[0-245]|999",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:1\\d|9[09])|46400|999",
                ,
                ,
                ,
                "110"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "464\\d\\d",
                ,
                ,
                ,
                "46400",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "464\\d\\d",
                ,
                ,
                ,
                "46400",
                ,
                ,
                [5]
              ]
            ],
            UA: [
              ,
              [
                ,
                ,
                "[189]\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:0[1-3]|1(?:2|6\\d{3}))",
                ,
                ,
                ,
                "101",
                ,
                ,
                [3, 6]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "UA",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:0[1-3]|12)",
                ,
                ,
                ,
                "101",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0[1-49]|1(?:2|6(?:000|1(?:11|23))|8\\d\\d?)|(?:[278]|5\\d)\\d)|[89]00\\d\\d?|151|1(?:06|4\\d|6)\\d\\d",
                ,
                ,
                ,
                "101"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "(?:118|[89]00)\\d\\d?",
                ,
                ,
                ,
                "1180",
                ,
                ,
                [4, 5]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            UG: [
              ,
              [
                ,
                ,
                "9\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "999",
                ,
                ,
                ,
                "999"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "UG",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "999",
                ,
                ,
                ,
                "999"
              ],
              ,
              [
                ,
                ,
                "999",
                ,
                ,
                ,
                "999"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            US: [
              ,
              [
                ,
                ,
                "[1-9]\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5,
                  6
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "112|611|9(?:11|33|88)",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                "24280|(?:381|968)35|4(?:3355|7553|8221)|5(?:(?:489|934)2|5928)|72078|(?:323|960)40|(?:276|414)63|(?:2(?:520|744)|7390|9968)9|(?:693|732|976)88|(?:3(?:556|825)|5294|8623|9729)4|(?:3378|4136|7642|8961|9979)6|(?:4(?:6(?:15|32)|827)|(?:591|720)8|9529)7",
                ,
                ,
                ,
                "24280",
                ,
                ,
                [5]
              ],
              ,
              ,
              ,
              "US",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112|911",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "11(?:2|5[1-47]|[68]\\d|7[0-57]|98)|[2-9]\\d{3,5}|[2-8]11|9(?:11|33|88)",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                "2(?:3333|(?:4224|7562|900)2|56447|6688)|3(?:1010|2665|7404)|40404|560560|6(?:0060|22639|5246|7622)|7(?:0701|3822|4666)|8(?:(?:3825|7226)5|4816)|99099",
                ,
                ,
                ,
                "23333",
                ,
                ,
                [5, 6]
              ],
              [
                ,
                ,
                "336\\d\\d|[2-9]\\d{3}|[2356]11",
                ,
                ,
                ,
                "211",
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              [
                ,
                ,
                "[2-9]\\d{4,5}",
                ,
                ,
                ,
                "20000",
                ,
                ,
                [5, 6]
              ]
            ],
            UY: [
              ,
              [
                ,
                ,
                "[19]\\d{2,4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "128|911",
                ,
                ,
                ,
                "128",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "UY",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "128|911",
                ,
                ,
                ,
                "128",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "1(?:0[4-9]|1[2368]|2[0-3568]|787|997\\d?)|911",
                ,
                ,
                ,
                "104"
              ],
              [
                ,
                ,
                "178\\d",
                ,
                ,
                ,
                "1780",
                ,
                ,
                [4]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            UZ: [
              ,
              [
                ,
                ,
                "[04]\\d(?:\\d(?:\\d{2})?)?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  2,
                  3,
                  5
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "0(?:0[1-3]|[1-3]|50)",
                ,
                ,
                ,
                "01",
                ,
                ,
                [2, 3]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "UZ",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "0(?:0[1-3]|[1-3]|50)",
                ,
                ,
                ,
                "01",
                ,
                ,
                [2, 3]
              ],
              ,
              [
                ,
                ,
                "0(?:0[1-3]|[1-3]|50)|45400",
                ,
                ,
                ,
                "01"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "454\\d\\d",
                ,
                ,
                ,
                "45400",
                ,
                ,
                [5]
              ],
              ,
              [
                ,
                ,
                "454\\d\\d",
                ,
                ,
                ,
                "45400",
                ,
                ,
                [5]
              ]
            ],
            VA: [
              ,
              [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "11[2358]",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "VA",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[2358]",
                ,
                ,
                ,
                "112"
              ],
              ,
              [
                ,
                ,
                "11[2358]",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            VC: [
              ,
              [
                ,
                ,
                "9\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:11|88|99)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "VC",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "9(?:11|99)",
                ,
                ,
                ,
                "911"
              ],
              ,
              [
                ,
                ,
                "9(?:11|88|99)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            VE: [
              ,
              [
                ,
                ,
                "[19]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:12|71)|911",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "VE",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:12|71)|911",
                ,
                ,
                ,
                "112"
              ],
              ,
              [
                ,
                ,
                "1(?:12|71)|911",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            VG: [
              ,
              [
                ,
                ,
                "9\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:11|88|99)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "VG",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "9(?:11|99)",
                ,
                ,
                ,
                "911"
              ],
              ,
              [
                ,
                ,
                "9(?:11|88|99)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            VI: [
              ,
              [
                ,
                ,
                "9\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:11|88)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "VI",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "911",
                ,
                ,
                ,
                "911"
              ],
              ,
              [
                ,
                ,
                "9(?:11|88)",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            VN: [
              ,
              [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "11[3-5]",
                ,
                ,
                ,
                "113"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "VN",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "11[3-5]",
                ,
                ,
                ,
                "113"
              ],
              ,
              [
                ,
                ,
                "11[3-5]",
                ,
                ,
                ,
                "113"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            VU: [
              ,
              [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "112",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "VU",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112",
                ,
                ,
                ,
                "112"
              ],
              ,
              [
                ,
                ,
                "112",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            WF: [
              ,
              [
                ,
                ,
                "1\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [2]
              ],
              ,
              ,
              [
                ,
                ,
                "1[578]",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "WF",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1[578]",
                ,
                ,
                ,
                "15"
              ],
              ,
              [
                ,
                ,
                "1[578]",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            WS: [
              ,
              [
                ,
                ,
                "[19]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "9(?:11|9[4-69])",
                ,
                ,
                ,
                "911"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "WS",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "9(?:11|9[4-69])",
                ,
                ,
                ,
                "911"
              ],
              ,
              [
                ,
                ,
                "1(?:1[12]|2[0-6]|[39]0)|9(?:11|9[4-79])",
                ,
                ,
                ,
                "111"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "12[0-6]",
                ,
                ,
                ,
                "120"
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            XK: [
              ,
              [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:12|9[2-4])",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "XK",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:12|9[2-4])",
                ,
                ,
                ,
                "112"
              ],
              ,
              [
                ,
                ,
                "1(?:12|9[2-4])",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            YE: [
              ,
              [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "19[1459]",
                ,
                ,
                ,
                "191"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "YE",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "19[1459]",
                ,
                ,
                ,
                "191"
              ],
              ,
              [
                ,
                ,
                "19[1459]",
                ,
                ,
                ,
                "191"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            YT: [
              ,
              [
                ,
                ,
                "1\\d\\d?",
                ,
                ,
                ,
                ,
                ,
                ,
                [2, 3]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:12|5)",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "YT",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:12|5)",
                ,
                ,
                ,
                "15"
              ],
              ,
              [
                ,
                ,
                "1(?:12|5)",
                ,
                ,
                ,
                "15"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            ZA: [
              ,
              [
                ,
                ,
                "[134]\\d{2,4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                  3,
                  4,
                  5
                ]
              ],
              ,
              ,
              [
                ,
                ,
                "1(?:01\\d\\d|12)",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3, 5]
              ],
              [
                ,
                ,
                "41(?:348|851)",
                ,
                ,
                ,
                "41348",
                ,
                ,
                [5]
              ],
              ,
              ,
              ,
              "ZA",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "1(?:01(?:11|77)|12)",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3, 5]
              ],
              ,
              [
                ,
                ,
                "1(?:0(?:1(?:11|77)|20|7)|1[12]|77(?:3[237]|[45]7|6[279]|9[26]))|[34]\\d{4}",
                ,
                ,
                ,
                "107"
              ],
              [
                ,
                ,
                "3(?:078[23]|7(?:064|567)|8126)|4(?:394[16]|7751|8837)|4[23]699",
                ,
                ,
                ,
                "30782",
                ,
                ,
                [5]
              ],
              [
                ,
                ,
                "111",
                ,
                ,
                ,
                "111",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "[34]\\d{4}",
                ,
                ,
                ,
                "30000",
                ,
                ,
                [5]
              ]
            ],
            ZM: [
              ,
              [
                ,
                ,
                "[19]\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ],
              ,
              ,
              [
                ,
                ,
                "112|99[139]",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              ,
              ,
              "ZM",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112|99[139]",
                ,
                ,
                ,
                "112"
              ],
              ,
              [
                ,
                ,
                "112|99[139]",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ],
            ZW: [
              ,
              [
                ,
                ,
                "[139]\\d\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5]
              ],
              ,
              ,
              [
                ,
                ,
                "112|9(?:5[023]|61|9[3-59])",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              [
                ,
                ,
                "3[013-57-9]\\d{3}",
                ,
                ,
                ,
                "30000",
                ,
                ,
                [5]
              ],
              ,
              ,
              ,
              "ZW",
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              ,
              [
                ,
                ,
                "112|99[3-59]",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                "11[2469]|3[013-57-9]\\d{3}|9(?:5[023]|6[0-25]|9[3-59])",
                ,
                ,
                ,
                "112"
              ],
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ],
              [
                ,
                ,
                "114|9(?:5[023]|6[0-25])",
                ,
                ,
                ,
                "114",
                ,
                ,
                [3]
              ],
              ,
              [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]
            ]
          }, i18n.phonenumbers.ShortNumberInfo = function() {
            this.regionToMetadataMap = {};
          }, goog.addSingletonGetter(i18n.phonenumbers.ShortNumberInfo), i18n.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_ = [
            "BR",
            "CL",
            "NI"
          ], i18n.phonenumbers.ShortNumberInfo.ShortNumberCost = {
            TOLL_FREE: 0,
            STANDARD_RATE: 1,
            PREMIUM_RATE: 2,
            UNKNOWN_COST: 3
          }, i18n.phonenumbers.ShortNumberInfo.prototype.getRegionCodesForCountryCode_ = function(a2) {
            return (a2 = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a2]) ? a2 : [];
          }, i18n.phonenumbers.ShortNumberInfo.prototype.regionDialingFromMatchesNumber_ = function(a2, b2) {
            return a2 = this.getRegionCodesForCountryCode_(a2.getCountryCodeOrDefault()), b2 != null && a2.includes(b2);
          }, i18n.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumberForRegion = function(a2, b2) {
            return !this.regionDialingFromMatchesNumber_(a2, b2) || (b2 = this.getMetadataForRegion_(b2), !b2) ? false : (a2 = this.getNationalSignificantNumber_(a2).length, b2.getGeneralDesc().possibleLengthArray().includes(a2));
          }, i18n.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumber = function(a2) {
            var b2 = this.getRegionCodesForCountryCode_(a2.getCountryCodeOrDefault());
            a2 = this.getNationalSignificantNumber_(a2).length;
            for (var c$12 = 0; c$12 < b2.length; c$12++) {
              var d2 = this.getMetadataForRegion_(b2[c$12]);
              if (d2 && d2.getGeneralDesc().possibleLengthArray().includes(a2)) return true;
            }
            return false;
          }, i18n.phonenumbers.ShortNumberInfo.prototype.isValidShortNumberForRegion = function(a2, b2) {
            if (!this.regionDialingFromMatchesNumber_(a2, b2) || (b2 = this.getMetadataForRegion_(b2), !b2)) return false;
            a2 = this.getNationalSignificantNumber_(a2);
            var c$12 = b2.getGeneralDesc();
            return this.matchesPossibleNumberAndNationalNumber_(a2, c$12) ? (b2 = b2.getShortCode(), this.matchesPossibleNumberAndNationalNumber_(a2, b2)) : false;
          }, i18n.phonenumbers.ShortNumberInfo.prototype.isValidShortNumber = function(a2) {
            var b2 = this.getRegionCodesForCountryCode_(a2.getCountryCodeOrDefault()), c$12 = this.getRegionCodeForShortNumberFromRegionList_(a2, b2);
            return 1 < b2.length && c$12 != null ? true : this.isValidShortNumberForRegion(a2, c$12);
          }, i18n.phonenumbers.ShortNumberInfo.prototype.getExpectedCostForRegion = function(a2, b2) {
            var c$12 = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost;
            if (!this.regionDialingFromMatchesNumber_(a2, b2)) return c$12.UNKNOWN_COST;
            var d2 = this.getMetadataForRegion_(b2);
            return d2 ? (a2 = this.getNationalSignificantNumber_(a2), d2.getGeneralDesc().possibleLengthArray().includes(a2.length) ? this.matchesPossibleNumberAndNationalNumber_(a2, d2.getPremiumRate()) ? c$12.PREMIUM_RATE : this.matchesPossibleNumberAndNationalNumber_(a2, d2.getStandardRate()) ? c$12.STANDARD_RATE : this.matchesPossibleNumberAndNationalNumber_(a2, d2.getTollFree()) || this.isEmergencyNumber(a2, b2) ? c$12.TOLL_FREE : c$12.UNKNOWN_COST : c$12.UNKNOWN_COST) : c$12.UNKNOWN_COST;
          }, i18n.phonenumbers.ShortNumberInfo.prototype.getExpectedCost = function(a2) {
            var b2 = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost, c$12 = this.getRegionCodesForCountryCode_(a2.getCountryCodeOrDefault());
            if (c$12.length === 0) return b2.UNKNOWN_COST;
            if (c$12.length === 1) return this.getExpectedCostForRegion(a2, c$12[0]);
            for (var d2 = b2.TOLL_FREE, e2 = 0; e2 < c$12.length; e2++) {
              var f2 = this.getExpectedCostForRegion(a2, c$12[e2]);
              switch (f2) {
                case b2.PREMIUM_RATE:
                  return b2.PREMIUM_RATE;
                case b2.UNKNOWN_COST:
                  d2 = b2.UNKNOWN_COST;
                  break;
                case b2.STANDARD_RATE:
                  d2 !== b2.UNKNOWN_COST && (d2 = b2.STANDARD_RATE);
                  break;
                case b2.TOLL_FREE:
                  break;
                default:
                  throw Error("Unrecognized cost for region: " + f2);
              }
            }
            return d2;
          }, i18n.phonenumbers.ShortNumberInfo.prototype.getRegionCodeForShortNumberFromRegionList_ = function(a2, b2) {
            if (b2.length === 0) return null;
            if (b2.length === 1) return b2[0];
            a2 = this.getNationalSignificantNumber_(a2);
            for (var c$12 = 0; c$12 < b2.length; c$12++) {
              var d2 = b2[c$12], e2 = this.getMetadataForRegion_(d2);
              if (e2 && this.matchesPossibleNumberAndNationalNumber_(a2, e2.getShortCode())) return d2;
            }
            return null;
          }, i18n.phonenumbers.ShortNumberInfo.prototype.getSupportedRegions = function() {
            return Object.keys(i18n.phonenumbers.shortnumbermetadata.countryToMetadata).filter(function(a2) {
              return isNaN(a2);
            });
          }, i18n.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumber = function(a2) {
            return a2 = this.getMetadataForRegion_(a2), a2 ? (a2 = a2.getShortCode(), a2.hasExampleNumber() && a2.getExampleNumber() || "") : "";
          }, i18n.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumberForCost = function(a2, b2) {
            if (a2 = this.getMetadataForRegion_(a2), !a2) return "";
            var c$12 = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost, d2 = null;
            switch (b2) {
              case c$12.TOLL_FREE:
                d2 = a2.getTollFree();
                break;
              case c$12.STANDARD_RATE:
                d2 = a2.getStandardRate();
                break;
              case c$12.PREMIUM_RATE:
                d2 = a2.getPremiumRate();
            }
            return d2 && d2.hasExampleNumber() && d2.getExampleNumber() || "";
          }, i18n.phonenumbers.ShortNumberInfo.prototype.connectsToEmergencyNumber = function(a2, b2) {
            return this.matchesEmergencyNumberHelper_(a2, b2, true);
          }, i18n.phonenumbers.ShortNumberInfo.prototype.isEmergencyNumber = function(a2, b2) {
            return this.matchesEmergencyNumberHelper_(a2, b2, false);
          }, i18n.phonenumbers.ShortNumberInfo.prototype.getMetadataForRegion_ = function(a2) {
            if (!a2) return null;
            a2 = a2.toUpperCase();
            var b2 = this.regionToMetadataMap[a2];
            if (b2 == null) {
              b2 = new goog.proto2.PbLiteSerializer();
              var c$12 = i18n.phonenumbers.shortnumbermetadata.countryToMetadata[a2];
              if (c$12 == null) return null;
              b2 = b2.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(), c$12), this.regionToMetadataMap[a2] = b2;
            }
            return b2;
          }, i18n.phonenumbers.ShortNumberInfo.prototype.matchesEmergencyNumberHelper_ = function(a2, b2, c$12) {
            var d2 = i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(a2);
            return i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(d2) || (a2 = this.getMetadataForRegion_(b2), a2 == null || !a2.hasEmergency()) ? false : (d2 = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d2), b2 = c$12 && !i18n.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_.includes(b2), c$12 = a2.getEmergency().getNationalNumberPatternOrDefault(), i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(c$12, d2) || b2 && i18n.phonenumbers.PhoneNumberUtil.matchesPrefix(c$12, d2));
          }, i18n.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecific = function(a2) {
            var b2 = this.getRegionCodesForCountryCode_(a2.getCountryCodeOrDefault());
            return b2 = this.getRegionCodeForShortNumberFromRegionList_(a2, b2), a2 = this.getNationalSignificantNumber_(a2), b2 = this.getMetadataForRegion_(b2), !!b2 && this.matchesPossibleNumberAndNationalNumber_(a2, b2.getCarrierSpecific());
          }, i18n.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecificForRegion = function(a2, b2) {
            return this.regionDialingFromMatchesNumber_(a2, b2) ? (a2 = this.getNationalSignificantNumber_(a2), b2 = this.getMetadataForRegion_(b2), !!b2 && this.matchesPossibleNumberAndNationalNumber_(a2, b2.getCarrierSpecific())) : false;
          }, i18n.phonenumbers.ShortNumberInfo.prototype.isSmsServiceForRegion = function(a2, b2) {
            return this.regionDialingFromMatchesNumber_(a2, b2) ? (b2 = this.getMetadataForRegion_(b2), a2 = this.getNationalSignificantNumber_(a2), !!b2 && this.matchesPossibleNumberAndNationalNumber_(a2, b2.getSmsServices())) : false;
          }, i18n.phonenumbers.ShortNumberInfo.prototype.getNationalSignificantNumber_ = function(a2) {
            if (!a2.hasNationalNumber()) return "";
            var b2 = "" + a2.getNationalNumber();
            return a2.hasItalianLeadingZero() && a2.getItalianLeadingZero() && 0 < a2.getNumberOfLeadingZerosOrDefault() ? Array(a2.getNumberOfLeadingZerosOrDefault() + 1).join("0") + b2 : b2;
          }, i18n.phonenumbers.ShortNumberInfo.prototype.matchesPossibleNumberAndNationalNumber_ = function(a2, b2) {
            return 0 < b2.possibleLengthArray().length && !b2.possibleLengthArray().includes(a2.length) ? false : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(b2.getNationalNumberPatternOrDefault(), a2.toString());
          }, i18n.phonenumbers.AsYouTypeFormatter = function(a2) {
            this.DIGIT_PLACEHOLDER_ = " ", this.DIGIT_PATTERN_ = new RegExp(this.DIGIT_PLACEHOLDER_), this.currentOutput_ = "", this.formattingTemplate_ = new goog.string.StringBuffer(), this.currentFormattingPattern_ = "", this.accruedInput_ = new goog.string.StringBuffer(), this.accruedInputWithoutFormatting_ = new goog.string.StringBuffer(), this.ableToFormat_ = true, this.isExpectingCountryCallingCode_ = this.isCompleteNumber_ = this.inputHasFormatting_ = false, this.phoneUtil_ = i18n.phonenumbers.PhoneNumberUtil.getInstance(), this.positionToRemember_ = this.originalPosition_ = this.lastMatchPosition_ = 0, this.prefixBeforeNationalNumber_ = new goog.string.StringBuffer(), this.shouldAddSpaceAfterNationalPrefix_ = false, this.extractedNationalPrefix_ = "", this.nationalNumber_ = new goog.string.StringBuffer(), this.possibleFormats_ = [], this.defaultCountry_ = a2, this.defaultMetadata_ = this.currentMetadata_ = this.getMetadataForRegion_(this.defaultCountry_);
          }, i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ = " ", i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_ = new i18n.phonenumbers.PhoneMetadata(), i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_.setInternationalPrefix("NA"), i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_ = /* @__PURE__ */ RegExp("^[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*\\$1[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*(\\$\\d[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*)*$"), i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_ = /[- ]/, i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_ = 3, i18n.phonenumbers.AsYouTypeFormatter.prototype.getMetadataForRegion_ = function(a2) {
            return a2 = this.phoneUtil_.getCountryCodeForRegion(a2), a2 = this.phoneUtil_.getRegionCodeForCountryCode(a2), a2 = this.phoneUtil_.getMetadataForRegion(a2), a2 ?? i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_;
          }, i18n.phonenumbers.AsYouTypeFormatter.prototype.maybeCreateNewTemplate_ = function() {
            for (var a2 = this.possibleFormats_.length, b2 = 0; b2 < a2; ++b2) {
              var c$12 = this.possibleFormats_[b2], d2 = c$12.getPatternOrDefault();
              if (this.currentFormattingPattern_ == d2) return false;
              if (this.createFormattingTemplate_(c$12)) return this.currentFormattingPattern_ = d2, this.shouldAddSpaceAfterNationalPrefix_ = i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(c$12.getNationalPrefixFormattingRule()), this.lastMatchPosition_ = 0, true;
            }
            return this.ableToFormat_ = false;
          }, i18n.phonenumbers.AsYouTypeFormatter.prototype.getAvailableFormats_ = function(a2) {
            for (var b2 = this.isCompleteNumber_ && this.extractedNationalPrefix_.length == 0 && 0 < this.currentMetadata_.intlNumberFormatCount() ? this.currentMetadata_.intlNumberFormatArray() : this.currentMetadata_.numberFormatArray(), c$12 = b2.length, d2 = 0; d2 < c$12; ++d2) {
              var e2 = b2[d2];
              0 < this.extractedNationalPrefix_.length && this.phoneUtil_.formattingRuleHasFirstGroupOnly(e2.getNationalPrefixFormattingRuleOrDefault()) && !e2.getNationalPrefixOptionalWhenFormatting() && !e2.hasDomesticCarrierCodeFormattingRule() || (this.extractedNationalPrefix_.length != 0 || this.isCompleteNumber_ || this.phoneUtil_.formattingRuleHasFirstGroupOnly(e2.getNationalPrefixFormattingRuleOrDefault()) || e2.getNationalPrefixOptionalWhenFormatting()) && i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_.test(e2.getFormatOrDefault()) && this.possibleFormats_.push(e2);
            }
            this.narrowDownPossibleFormats_(a2);
          }, i18n.phonenumbers.AsYouTypeFormatter.prototype.narrowDownPossibleFormats_ = function(a2) {
            for (var b2 = [], c$12 = a2.length - i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_, d2 = this.possibleFormats_.length, e2 = 0; e2 < d2; ++e2) {
              var f2 = this.possibleFormats_[e2];
              if (f2.leadingDigitsPatternCount() == 0) b2.push(this.possibleFormats_[e2]);
              else {
                var g2 = Math.min(c$12, f2.leadingDigitsPatternCount() - 1);
                f2 = f2.getLeadingDigitsPattern(g2), a2.search(f2) == 0 && b2.push(this.possibleFormats_[e2]);
              }
            }
            this.possibleFormats_ = b2;
          }, i18n.phonenumbers.AsYouTypeFormatter.prototype.createFormattingTemplate_ = function(a2) {
            var b2 = a2.getPatternOrDefault();
            return this.formattingTemplate_.clear(), a2 = this.getFormattingTemplate_(b2, a2.getFormatOrDefault()), 0 < a2.length ? (this.formattingTemplate_.append(a2), true) : false;
          }, i18n.phonenumbers.AsYouTypeFormatter.prototype.getFormattingTemplate_ = function(a2, b2) {
            var c$12 = "999999999999999".match(a2)[0];
            return c$12.length < this.nationalNumber_.getLength() ? "" : (a2 = c$12.replace(new RegExp(a2, "g"), b2), a2 = a2.replace(/9/g, this.DIGIT_PLACEHOLDER_));
          }, i18n.phonenumbers.AsYouTypeFormatter.prototype.clear = function() {
            this.currentOutput_ = "", this.accruedInput_.clear(), this.accruedInputWithoutFormatting_.clear(), this.formattingTemplate_.clear(), this.lastMatchPosition_ = 0, this.currentFormattingPattern_ = "", this.prefixBeforeNationalNumber_.clear(), this.extractedNationalPrefix_ = "", this.nationalNumber_.clear(), this.ableToFormat_ = true, this.inputHasFormatting_ = false, this.originalPosition_ = this.positionToRemember_ = 0, this.isExpectingCountryCallingCode_ = this.isCompleteNumber_ = false, this.possibleFormats_ = [], this.shouldAddSpaceAfterNationalPrefix_ = false, this.currentMetadata_ != this.defaultMetadata_ && (this.currentMetadata_ = this.getMetadataForRegion_(this.defaultCountry_));
          }, i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigit = function(a2) {
            return this.currentOutput_ = this.inputDigitWithOptionToRememberPosition_(a2, false);
          }, i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitAndRememberPosition = function(a2) {
            return this.currentOutput_ = this.inputDigitWithOptionToRememberPosition_(a2, true);
          }, i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitWithOptionToRememberPosition_ = function(a2, b2) {
            if (this.accruedInput_.append(a2), b2 && (this.originalPosition_ = this.accruedInput_.getLength()), this.isDigitOrLeadingPlusSign_(a2) ? a2 = this.normalizeAndAccrueDigitsAndPlusSign_(a2, b2) : (this.ableToFormat_ = false, this.inputHasFormatting_ = true), !this.ableToFormat_) {
              if (!this.inputHasFormatting_) {
                if (this.attemptToExtractIdd_()) {
                  if (this.attemptToExtractCountryCallingCode_()) return this.attemptToChoosePatternWithPrefixExtracted_();
                } else if (this.ableToExtractLongerNdd_()) return this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.attemptToChoosePatternWithPrefixExtracted_();
              }
              return this.accruedInput_.toString();
            }
            switch (this.accruedInputWithoutFormatting_.getLength()) {
              case 0:
              case 1:
              case 2:
                return this.accruedInput_.toString();
              case 3:
                if (this.attemptToExtractIdd_()) this.isExpectingCountryCallingCode_ = true;
                else return this.extractedNationalPrefix_ = this.removeNationalPrefixFromNationalNumber_(), this.attemptToChooseFormattingPattern_();
              default:
                return this.isExpectingCountryCallingCode_ ? (this.attemptToExtractCountryCallingCode_() && (this.isExpectingCountryCallingCode_ = false), this.prefixBeforeNationalNumber_.toString() + this.nationalNumber_.toString()) : 0 < this.possibleFormats_.length ? (a2 = this.inputDigitHelper_(a2), b2 = this.attemptToFormatAccruedDigits_(), 0 < b2.length ? b2 : (this.narrowDownPossibleFormats_(this.nationalNumber_.toString()), this.maybeCreateNewTemplate_() ? this.inputAccruedNationalNumber_() : this.ableToFormat_ ? this.appendNationalNumber_(a2) : this.accruedInput_.toString())) : this.attemptToChooseFormattingPattern_();
            }
          }, i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChoosePatternWithPrefixExtracted_ = function() {
            return this.ableToFormat_ = true, this.isExpectingCountryCallingCode_ = false, this.possibleFormats_ = [], this.lastMatchPosition_ = 0, this.formattingTemplate_.clear(), this.currentFormattingPattern_ = "", this.attemptToChooseFormattingPattern_();
          }, i18n.phonenumbers.AsYouTypeFormatter.prototype.getExtractedNationalPrefix_ = function() {
            return this.extractedNationalPrefix_;
          }, i18n.phonenumbers.AsYouTypeFormatter.prototype.ableToExtractLongerNdd_ = function() {
            if (0 < this.extractedNationalPrefix_.length) {
              var a2 = this.nationalNumber_.toString();
              this.nationalNumber_.clear(), this.nationalNumber_.append(this.extractedNationalPrefix_), this.nationalNumber_.append(a2), a2 = this.prefixBeforeNationalNumber_.toString();
              var b2 = a2.lastIndexOf(this.extractedNationalPrefix_);
              this.prefixBeforeNationalNumber_.clear(), this.prefixBeforeNationalNumber_.append(a2.substring(0, b2));
            }
            return this.extractedNationalPrefix_ != this.removeNationalPrefixFromNationalNumber_();
          }, i18n.phonenumbers.AsYouTypeFormatter.prototype.isDigitOrLeadingPlusSign_ = function(a2) {
            return i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN.test(a2) || this.accruedInput_.getLength() == 1 && i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN.test(a2);
          }, i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToFormatAccruedDigits_ = function() {
            for (var a2 = this.nationalNumber_.toString(), b2 = this.possibleFormats_.length, c$12 = 0; c$12 < b2; ++c$12) {
              var d2 = this.possibleFormats_[c$12], e2 = d2.getPatternOrDefault();
              if ((/* @__PURE__ */ RegExp("^(?:" + e2 + ")$")).test(a2) && (this.shouldAddSpaceAfterNationalPrefix_ = i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(d2.getNationalPrefixFormattingRule()), d2 = a2.replace(new RegExp(e2, "g"), d2.getFormat()), d2 = this.appendNationalNumber_(d2), i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(d2) == this.accruedInputWithoutFormatting_)) return d2;
            }
            return "";
          }, i18n.phonenumbers.AsYouTypeFormatter.prototype.appendNationalNumber_ = function(a2) {
            var b2 = this.prefixBeforeNationalNumber_.getLength();
            return this.shouldAddSpaceAfterNationalPrefix_ && 0 < b2 && this.prefixBeforeNationalNumber_.toString().charAt(b2 - 1) != i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ ? this.prefixBeforeNationalNumber_ + i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ + a2 : this.prefixBeforeNationalNumber_ + a2;
          }, i18n.phonenumbers.AsYouTypeFormatter.prototype.getRememberedPosition = function() {
            if (!this.ableToFormat_) return this.originalPosition_;
            for (var a2 = 0, b2 = 0, c$12 = this.accruedInputWithoutFormatting_.toString(), d2 = this.currentOutput_.toString(); a2 < this.positionToRemember_ && b2 < d2.length; ) c$12.charAt(a2) == d2.charAt(b2) && a2++, b2++;
            return b2;
          }, i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChooseFormattingPattern_ = function() {
            var a2 = this.nationalNumber_.toString();
            return a2.length >= i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_ ? (this.getAvailableFormats_(a2), a2 = this.attemptToFormatAccruedDigits_(), 0 < a2.length ? a2 : this.maybeCreateNewTemplate_() ? this.inputAccruedNationalNumber_() : this.accruedInput_.toString()) : this.appendNationalNumber_(a2);
          }, i18n.phonenumbers.AsYouTypeFormatter.prototype.inputAccruedNationalNumber_ = function() {
            var a2 = this.nationalNumber_.toString(), b2 = a2.length;
            if (0 < b2) {
              for (var c$12 = "", d2 = 0; d2 < b2; d2++) c$12 = this.inputDigitHelper_(a2.charAt(d2));
              return this.ableToFormat_ ? this.appendNationalNumber_(c$12) : this.accruedInput_.toString();
            }
            return this.prefixBeforeNationalNumber_.toString();
          }, i18n.phonenumbers.AsYouTypeFormatter.prototype.isNanpaNumberWithNationalPrefix_ = function() {
            if (this.currentMetadata_.getCountryCode() != 1) return false;
            var a2 = this.nationalNumber_.toString();
            return a2.charAt(0) == "1" && a2.charAt(1) != "0" && a2.charAt(1) != "1";
          }, i18n.phonenumbers.AsYouTypeFormatter.prototype.removeNationalPrefixFromNationalNumber_ = function() {
            var a2 = this.nationalNumber_.toString(), b2 = 0;
            if (this.isNanpaNumberWithNationalPrefix_()) b2 = 1, this.prefixBeforeNationalNumber_.append("1").append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.isCompleteNumber_ = true;
            else if (this.currentMetadata_.hasNationalPrefixForParsing()) {
              var c$12 = /* @__PURE__ */ RegExp("^(?:" + this.currentMetadata_.getNationalPrefixForParsing() + ")");
              c$12 = a2.match(c$12), c$12 != null && c$12[0] != null && 0 < c$12[0].length && (this.isCompleteNumber_ = true, b2 = c$12[0].length, this.prefixBeforeNationalNumber_.append(a2.substring(0, b2)));
            }
            return this.nationalNumber_.clear(), this.nationalNumber_.append(a2.substring(b2)), a2.substring(0, b2);
          }, i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractIdd_ = function() {
            var a2 = this.accruedInputWithoutFormatting_.toString(), b2 = /* @__PURE__ */ RegExp("^(?:\\" + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + "|" + this.currentMetadata_.getInternationalPrefix() + ")");
            return b2 = a2.match(b2), b2 != null && b2[0] != null && 0 < b2[0].length ? (this.isCompleteNumber_ = true, b2 = b2[0].length, this.nationalNumber_.clear(), this.nationalNumber_.append(a2.substring(b2)), this.prefixBeforeNationalNumber_.clear(), this.prefixBeforeNationalNumber_.append(a2.substring(0, b2)), a2.charAt(0) != i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN && this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), true) : false;
          }, i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractCountryCallingCode_ = function() {
            if (this.nationalNumber_.getLength() == 0) return false;
            var a2 = new goog.string.StringBuffer(), b2 = this.phoneUtil_.extractCountryCode(this.nationalNumber_, a2);
            return b2 == 0 ? false : (this.nationalNumber_.clear(), this.nationalNumber_.append(a2.toString()), a2 = this.phoneUtil_.getRegionCodeForCountryCode(b2), i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY == a2 ? this.currentMetadata_ = this.phoneUtil_.getMetadataForNonGeographicalRegion(b2) : a2 != this.defaultCountry_ && (this.currentMetadata_ = this.getMetadataForRegion_(a2)), this.prefixBeforeNationalNumber_.append("" + b2).append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.extractedNationalPrefix_ = "", true);
          }, i18n.phonenumbers.AsYouTypeFormatter.prototype.normalizeAndAccrueDigitsAndPlusSign_ = function(a2, b2) {
            if (a2 == i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) {
              var c$12 = a2;
              this.accruedInputWithoutFormatting_.append(a2);
            } else c$12 = i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS[a2], this.accruedInputWithoutFormatting_.append(c$12), this.nationalNumber_.append(c$12);
            return b2 && (this.positionToRemember_ = this.accruedInputWithoutFormatting_.getLength()), c$12;
          }, i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitHelper_ = function(a2) {
            var b2 = this.formattingTemplate_.toString();
            if (0 <= b2.substring(this.lastMatchPosition_).search(this.DIGIT_PATTERN_)) {
              var c$12 = b2.search(this.DIGIT_PATTERN_);
              return a2 = b2.replace(this.DIGIT_PATTERN_, a2), this.formattingTemplate_.clear(), this.formattingTemplate_.append(a2), this.lastMatchPosition_ = c$12, a2.substring(0, this.lastMatchPosition_ + 1);
            }
            return this.possibleFormats_.length == 1 && (this.ableToFormat_ = false), this.currentFormattingPattern_ = "", this.accruedInput_.toString();
          }, Object.defineProperty(exports$2, "__esModule", { value: true }), exports$2.default = i18n.phonenumbers, module$2.exports = exports$2.default;
        }).call(this);
      }).call(this, typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}] }, {}, [1])(1);
  });
})), import_country_telephone_data = require_country_telephone_data(), import_libphonenumber = require_libphonenumber(), Phone = class Phone2 {
  constructor(phone2, country) {
    let localPhone = String(phone2).replace(/\D/g, ""), countryTest = typeof country == "string" ? country.trim().toUpperCase() : "XX", localCountry = isos.has(countryTest) ? countryTest : "XX", localUtil = import_libphonenumber.PhoneNumberUtil.getInstance();
    localCountry === "XX" && (localCountry = this.#e(localPhone));
    let localParsed, localValid = false, localType = "INVALID";
    try {
      localParsed = localUtil.parseAndKeepRawInput(localPhone, localCountry === "XX" ? void 0 : localCountry);
    } catch {
    }
    if (localParsed) try {
      localValid = localUtil.isValidNumber(localParsed), localType = this.#r(localUtil, localParsed);
    } catch {
    }
    let isMobile = localType === "MOBILE" || localType === "FIXED_LINE_OR_MOBILE", raw = localParsed ? localUtil.format(localParsed, import_libphonenumber.PhoneNumberFormat.E164).replace(/\D/g, "") : localPhone.toString(), national = localParsed ? localUtil.format(localParsed, import_libphonenumber.PhoneNumberFormat.NATIONAL) : localPhone.toString(), international = localParsed ? localUtil.format(localParsed, import_libphonenumber.PhoneNumberFormat.INTERNATIONAL) : localPhone.toString(), e164 = localParsed ? localUtil.format(localParsed, import_libphonenumber.PhoneNumberFormat.E164) : localPhone.toString();
    Object.defineProperties(this, {
      phone: {
        value: localValid ? raw : localPhone,
        enumerable: true,
        writable: false
      },
      valid: {
        value: localValid,
        enumerable: true,
        writable: false
      },
      type: {
        value: localType,
        enumerable: true,
        writable: false
      },
      mobile: {
        value: isMobile,
        enumerable: true,
        writable: false
      },
      raw: {
        value: raw,
        enumerable: true,
        writable: false
      },
      national: {
        value: national,
        enumerable: true,
        writable: false
      },
      international: {
        value: international,
        enumerable: true,
        writable: false
      },
      e164: {
        value: e164,
        enumerable: true,
        writable: false
      }
    }), true === localValid && nanpaCountries.includes(localCountry) && (localCountry = this.#i());
    let timezone = "UTC";
    localCountry !== "XX" && timezones.has(localCountry) && (timezone = timezones.get(localCountry)), Object.defineProperties(this, {
      country: {
        value: localCountry,
        enumerable: true,
        writable: false
      },
      timezone: {
        value: timezone,
        enumerable: true,
        writable: false
      }
    });
  }
  #e(phone2) {
    let potentials = import_country_telephone_data.allCountries.map((c$12) => ({
      iso: c$12.iso2.toUpperCase(),
      prefix: String(c$12.dialCode).trim().replace(/\D/g, "")
    })).filter((c$12) => phone2.substring(0, c$12.prefix.length) === c$12.prefix).sort(this.#n).filter((c$12) => {
      let t = this.constructor;
      return new t(phone2, c$12.iso).valid;
    });
    return potentials.length >= 1 ? potentials[0].iso : this.#t(phone2);
  }
  #t(phone2) {
    let potentials = import_country_telephone_data.allCountries.map((c$12) => ({
      iso: c$12.iso2.toUpperCase(),
      prefix: String(c$12.dialCode).trim().replace(/\D/g, "")
    })).sort(this.#n).filter((c$12) => {
      let t = this.constructor;
      return new t(phone2, c$12.iso).valid;
    });
    return potentials.length >= 1 ? potentials[0].iso : "XX";
  }
  #n(a2, b2) {
    if (a2.prefix.length === b2.prefix.length) {
      let intA = Number.parseInt(a2.prefix), intB = Number.parseInt(b2.prefix);
      return intA === intB ? a2.iso.localeCompare(b2.iso) : intA > intB ? 1 : -1;
    }
    return a2.prefix.length > b2.prefix.length ? 1 : -1;
  }
  #r(util, parsed) {
    if (!parsed) return "INVALID";
    let type = util.getNumberType(parsed), typeValues = Object.values(import_libphonenumber.PhoneNumberType);
    return Object.keys(import_libphonenumber.PhoneNumberType)[typeValues.indexOf(type)] || "INVALID";
  }
  #i() {
    let ak = this.raw.substring(1, 4);
    return areaCodeMap[ak] && typeof areaCodeMap[ak] == "string" ? areaCodeMap[ak] : "XX";
  }
  toObject() {
    return {
      phone: this.phone,
      country: this.country,
      valid: this.valid,
      type: this.type,
      mobile: this.mobile,
      raw: this.raw,
      national: this.national,
      international: this.international,
      e164: this.e164,
      timezone: this.timezone
    };
  }
  toJSON() {
    return this.toObject();
  }
  toString() {
    return this.e164;
  }
  inspect() {
    return `Phone {
      phone: ${this.phone},
      country: ${this.country},
      valid: ${this.valid === true ? "true" : "false"},
      type: ${this.type},
      mobile: ${this.mobile === true ? "true" : "false"},
      raw: ${this.raw},
      national: ${this.national},
      international: ${this.international},
      e164: ${this.e164},
      timezone: ${this.timezone},
    }`;
  }
  serialize() {
    let encoder = new TextEncoder(), hashData = JSON.stringify({
      phone: this.raw,
      country: this.country
    }), hash = btoa(String.fromCharCode(...encoder.encode(hashData))), serializedData = JSON.stringify({
      phone: this.raw,
      country: this.country,
      hash
    });
    return btoa(String.fromCharCode(...encoder.encode(serializedData)));
  }
  static deserialize(serialized) {
    let asJsonString;
    try {
      let decoded = atob(serialized), bytes = new Uint8Array(decoded.length);
      for (let i$12 = 0; i$12 < decoded.length; i$12++) bytes[i$12] = decoded.charCodeAt(i$12);
      asJsonString = new TextDecoder().decode(bytes);
    } catch {
      throw Error("Not a valid serialized phone object");
    }
    let asJson;
    try {
      asJson = JSON.parse(asJsonString);
    } catch {
      throw Error("Not a valid serialized phone object");
    }
    if (!asJson.phone || !asJson.country || !asJson.hash) throw Error("Not a valid serialized phone object");
    let encoder = new TextEncoder(), hashData = JSON.stringify({
      phone: asJson.phone,
      country: asJson.country
    });
    if (btoa(String.fromCharCode(...encoder.encode(hashData))) !== asJson.hash) throw Error("Not a valid serialized phone object");
    return new Phone2(asJson.phone, asJson.country === "XX" ? void 0 : asJson.country);
  }
};
const PhoneTypes = [
  "FIXED_LINE",
  "MOBILE",
  "FIXED_LINE_OR_MOBILE",
  "TOLL_FREE",
  "PREMIUM_RATE",
  "SHARED_COST",
  "VOIP",
  "PERSONAL_NUMBER",
  "PAGER",
  "UAN",
  "VOICEMAIL",
  "UNKNOWN",
  "INVALID"
];
const stringSchema = validator.string().allow("").required();
const numberSchema = validator.alternatives(
  validator.number(),
  validator.object().instance(Number),
  validator.function().instance(Number),
  validator.valid(
    Number.MAX_SAFE_INTEGER,
    Number.MIN_SAFE_INTEGER,
    Number.MAX_VALUE,
    Number.MIN_VALUE
  )
).required();
const booleanSchema = validator.boolean().required();
const bigintSchema = validator.any().custom((value, helpers) => {
  if (typeof value === "bigint") {
    return value;
  }
  return helpers.error("any.invalid");
}).required();
const nullSchema = validator.any().valid(null).required();
const undefinedSchema = validator.any().custom((value, helpers) => {
  if (typeof value === "undefined") {
    return value;
  }
  return helpers.error("any.invalid");
});
const primitiveSchema = validator.alternatives().try(stringSchema, numberSchema, booleanSchema, nullSchema, undefinedSchema);
const int8ArraySchema = validator.any().custom((value, helpers) => {
  if (value instanceof Int8Array) {
    return value;
  }
  return helpers.error("any.invalid");
});
const uint8ArraySchema = validator.any().custom((value, helpers) => {
  if (value instanceof Uint8Array) {
    return value;
  }
  return helpers.error("any.invalid");
});
const uint8ClampedArraySchema = validator.any().custom((value, helpers) => {
  if (value instanceof Uint8ClampedArray) {
    return value;
  }
  return helpers.error("any.invalid");
});
const int16ArraySchema = validator.any().custom((value, helpers) => {
  if (value instanceof Int16Array) {
    return value;
  }
  return helpers.error("any.invalid");
});
const uint16ArraySchema = validator.any().custom((value, helpers) => {
  if (value instanceof Uint16Array) {
    return value;
  }
  return helpers.error("any.invalid");
});
const int32ArraySchema = validator.any().custom((value, helpers) => {
  if (value instanceof Int32Array) {
    return value;
  }
  return helpers.error("any.invalid");
});
const uint32ArraySchema = validator.any().custom((value, helpers) => {
  if (value instanceof Uint32Array) {
    return value;
  }
  return helpers.error("any.invalid");
});
const float32ArraySchema = validator.any().custom((value, helpers) => {
  if (value instanceof Float32Array) {
    return value;
  }
  return helpers.error("any.invalid");
});
const float64ArraySchema = validator.any().custom((value, helpers) => {
  if (value instanceof Float64Array) {
    return value;
  }
  return helpers.error("any.invalid");
});
const bigInt64ArraySchema = validator.any().custom((value, helpers) => {
  if (value instanceof BigInt64Array) {
    return value;
  }
  if (Object.prototype.toString.call(value) === "[object BigInt64Array]") {
    return value;
  }
  return helpers.error("any.invalid");
});
const bigUint64ArraySchema = validator.any().custom((value, helpers) => {
  if (value instanceof BigUint64Array) {
    return value;
  }
  if (Object.prototype.toString.call(value) === "[object BigUint64Array]") {
    return value;
  }
  return helpers.error("any.invalid");
});
const typedArraySchema = validator.alternatives().try(
  int8ArraySchema,
  uint8ArraySchema,
  uint8ClampedArraySchema,
  int16ArraySchema,
  uint16ArraySchema,
  int32ArraySchema,
  uint32ArraySchema,
  float32ArraySchema,
  float64ArraySchema
);
const bigIntTypedArraySchema = validator.alternatives().try(bigInt64ArraySchema, bigUint64ArraySchema);
const dateSchema = validator.any().custom((value, helpers) => {
  if (value instanceof Date) {
    return value;
  }
  return helpers.error("any.invalid");
});
const regExpSchema = validator.any().custom((value, helpers) => {
  if (value instanceof RegExp) {
    return value;
  }
  return helpers.error("any.invalid");
});
const arrayBufferSchema = validator.any().custom((value, helpers) => {
  if (value instanceof ArrayBuffer) {
    return value;
  }
  return helpers.error("any.invalid");
});
const dataViewSchema = validator.any().custom((value, helpers) => {
  if (value instanceof DataView) {
    return value;
  }
  return helpers.error("any.invalid");
});
const errorSchema = validator.any().custom((value, helpers) => {
  if (isInstanceOf(value, "Error", Error)) {
    return value;
  }
  return helpers.error("any.invalid");
});
const uniterableObjectSchema = validator.alternatives().try(dateSchema, regExpSchema, arrayBufferSchema, dataViewSchema, errorSchema);
const phoneObjectSchema = validator.alternatives(
  validator.custom((value, helpers) => {
    if (isInstanceOf(value, "Phone", Phone)) {
      return value;
    }
    return helpers.error("any.invalid");
  }).required(),
  validator.object({
    country: validator.string().required().valid(...[...Array.from(isos), "XX"]),
    international: validator.string().allow("").required(),
    mobile: validator.boolean().required(),
    national: validator.string().allow("").required(),
    raw: validator.string().allow("").required(),
    e164: validator.string().allow("").required(),
    timezone: validator.string().required(),
    type: validator.string().valid(...Array.from(PhoneTypes)).required(),
    valid: validator.boolean().required()
  }).unknown(true).required()
).required();
const isObject$1 = (value) => {
  return typeof value === "object" && value !== null && !Array.isArray(value);
};
const isArray = (value) => {
  return Array.isArray(value);
};
const isLuxonDateTime = (value) => {
  if (value instanceof DateTime$1) return true;
  if ("object" !== typeof value || null === value) return false;
  if (!("isLuxonDateTime" in value)) return false;
  return value.isLuxonDateTime === true;
};
const isLuxonDuration = (value) => {
  if (value instanceof Duration$1) return true;
  if ("object" !== typeof value || null === value) return false;
  if (!("isLuxonDuration" in value)) return false;
  return value.isLuxonDuration === true;
};
const isLuxonInterval = (value) => {
  if (value instanceof Interval$1) return true;
  if ("object" !== typeof value || null === value) return false;
  if (!("isLuxonInterval" in value)) return false;
  return value.isLuxonInterval === true;
};
const isLucidBinaryValue = (value) => {
  if (value instanceof Uint8Array) return true;
  if (typeof Buffer !== "undefined" && Buffer.isBuffer(value)) return true;
  return false;
};
const isInstanceOf = (value, type, ctor) => {
  if ("undefined" !== typeof ctor && value instanceof ctor) return true;
  if ("undefined" !== typeof ctor && typeof ctor[Symbol.hasInstance] === "function" && ctor[Symbol.hasInstance](value))
    return true;
  if ("object" === typeof value && null !== value) {
    const valueWithConstructor = value;
    const constructorName = valueWithConstructor.constructor?.name;
    return constructorName === type;
  }
  return false;
};
const isMap = (value) => {
  return isInstanceOf(value, "Map", Map);
};
const isSet = (value) => {
  return isInstanceOf(value, "Set", Set);
};
const isNumber = (value) => {
  return matchesSchema(value, numberSchema);
};
const isNegativeZero = (value) => {
  if (!isNumber(value)) return false;
  return 1 / value < 0 && Math.abs(value) === 0;
};
const isPositiveInfinity = (value) => {
  return typeof value === "number" && !Number.isNaN(value) && !Number.isFinite(value) && value > 0;
};
const isNegativeInfinity = (value) => {
  return typeof value === "number" && !Number.isNaN(value) && !Number.isFinite(value) && value < 0;
};
const isUnsafeInteger = (value) => {
  return Number.isInteger(value) && !Number.isSafeInteger(value);
};
const matchesSchema = (value, schema) => {
  const { error } = schema.validate(value, {
    abortEarly: true
  });
  return !error;
};
const isError = (value) => {
  return matchesSchema(value, errorSchema);
};
const isTypedArray = (value) => {
  return matchesSchema(value, typedArraySchema);
};
const isBigIntTypedArray = (value) => {
  return matchesSchema(value, bigIntTypedArraySchema);
};
const isUniterableObject = (value) => {
  return matchesSchema(value, uniterableObjectSchema);
};
const isPrimitive = (value) => {
  return matchesSchema(value, primitiveSchema);
};
const isPhoneObject = (value) => {
  return matchesSchema(value, phoneObjectSchema);
};
const isLuxonSystemZone = (value) => {
  return isInstanceOf(value, "SystemZone", SystemZone$1);
};
const isBigInt = (value) => {
  return matchesSchema(value, bigintSchema);
};
const isCustomEncodable = (value) => {
  if (typeof value !== "object" || value === null) return false;
  if (!(ENCODE_METHOD in value) || typeof value[ENCODE_METHOD] !== "function") return false;
  const ctor = value.constructor;
  if (typeof ctor !== "function" || typeof ctor.name !== "string" || ctor.name === "") return false;
  return DECODE_METHOD in ctor && typeof ctor[DECODE_METHOD] === "function";
};
export {
  DateTime$1 as D,
  ENCODE_METHOD as E,
  Interval$1 as I,
  Phone as P,
  isCustomEncodable as a,
  isArray as b,
  isSet as c,
  isMap as d,
  isLuxonSystemZone as e,
  isLuxonInterval as f,
  isLuxonDuration as g,
  Duration$1 as h,
  isObject$1 as i,
  isLuxonDateTime as j,
  isPhoneObject as k,
  isTypedArray as l,
  isBigIntTypedArray as m,
  isPrimitive as n,
  isUniterableObject as o,
  isError as p,
  isBigInt as q,
  isUnsafeInteger as r,
  isNegativeInfinity as s,
  isPositiveInfinity as t,
  isNegativeZero as u,
  DECODE_METHOD as v,
  Info$1 as w,
  isLucidBinaryValue as x,
  isInstanceOf as y,
  isNumber as z
};
//# sourceMappingURL=type_guards-DMqlMT2e.mjs.map
